angular.module('angularResizable', [])
    .directive('resizable', function() {
        var toCall;
        function throttle(fun) {
            if (toCall === undefined) {
                toCall = fun;
                setTimeout(function() {
                    toCall();
                    toCall = undefined;
                }, 100);
            } else {
                toCall = fun;
            }
        }
        return {
            restrict: 'AE',
            scope: {
                rDirections: '=',
                rCenteredX: '=',
                rCenteredY: '=',
                rWidth: '=',
                rHeight: '=',
                rFlex: '=',
                rGrabber: '@',
                rDisabled: '@',
                rNoThrottle: '=',
                resizable: '@',
            },
            link: function(scope, element, attr) {
                if (scope.resizable === 'false') return;

                var flexBasis = 'flexBasis' in document.documentElement.style ? 'flexBasis' :
                    'webkitFlexBasis' in document.documentElement.style ? 'webkitFlexBasis' :
                    'msFlexPreferredSize' in document.documentElement.style ? 'msFlexPreferredSize' : 'flexBasis';

                // register watchers on width and height attributes if they are set
                scope.$watch('rWidth', function(value){
                    element[0].style[scope.rFlex ? flexBasis : 'width'] = scope.rWidth + 'px';
                });
                scope.$watch('rHeight', function(value){
                    element[0].style[scope.rFlex ? flexBasis : 'height'] = scope.rHeight + 'px';
                });

                element.addClass('resizable');

                var style = window.getComputedStyle(element[0], null),
                    w,
                    h,
                    dir = scope.rDirections || ['right'],
                    vx = scope.rCenteredX ? 2 : 1, // if centered double velocity
                    vy = scope.rCenteredY ? 2 : 1, // if centered double velocity
                    inner = scope.rGrabber ? scope.rGrabber : '<span></span>',
                    start,
                    dragDir,
                    axis,
                    info = {};

                var updateInfo = function(e) {
                    info.width = false; info.height = false;
                    if(axis === 'x')
                        info.width = parseInt(element[0].style[scope.rFlex ? flexBasis : 'width']);
                    else
                        info.height = parseInt(element[0].style[scope.rFlex ? flexBasis : 'height']);
                    info.id = element[0].id;
                    info.evt = e;
                };

                var getClientX = function(e) {
                    return e.touches ? e.touches[0].clientX : e.clientX;
                };

                var getClientY = function(e) {
                    return e.touches ? e.touches[0].clientY : e.clientY;
                };

                var dragging = function(e) {
                    var prop, offset = axis === 'x' ? start - getClientX(e) : start - getClientY(e);
                    switch(dragDir) {
                        case 'top':
                            prop = scope.rFlex ? flexBasis : 'height';
                            element[0].style[prop] = h + (offset * vy) + 'px';
                            break;
                        case 'bottom':
                            prop = scope.rFlex ? flexBasis : 'height';
                            element[0].style[prop] = h - (offset * vy) + 'px';
                            break;
                        case 'right':
                            prop = scope.rFlex ? flexBasis : 'width';
                            element[0].style[prop] = w - (offset * vx) + 'px';
                            break;
                        case 'left':
                            prop = scope.rFlex ? flexBasis : 'width';
                            element[0].style[prop] = w + (offset * vx) + 'px';
                            break;
                    }
                    updateInfo(e);
                    function resizingEmit(){
                        scope.$emit('angular-resizable.resizing', info);
                    }
                    if (scope.rNoThrottle) {
                        resizingEmit();
                    } else {
                        throttle(resizingEmit);
                    }
                };
                var dragEnd = function(e) {
                    updateInfo();
                    scope.$emit('angular-resizable.resizeEnd', info);
                    scope.$apply();
                    document.removeEventListener('mouseup', dragEnd, false);
                    document.removeEventListener('mousemove', dragging, false);
                    document.removeEventListener('touchend', dragEnd, false);
                    document.removeEventListener('touchmove', dragging, false);
                    element.removeClass('no-transition');
                };
                var dragStart = function(e, direction) {
                    dragDir = direction;
                    axis = dragDir === 'left' || dragDir === 'right' ? 'x' : 'y';
                    start = axis === 'x' ? getClientX(e) : getClientY(e);
                    w = parseInt(style.getPropertyValue('width'));
                    h = parseInt(style.getPropertyValue('height'));

                    //prevent transition while dragging
                    element.addClass('no-transition');

                    document.addEventListener('mouseup', dragEnd, false);
                    document.addEventListener('mousemove', dragging, false);
                    document.addEventListener('touchend', dragEnd, false);
                    document.addEventListener('touchmove', dragging, false);

                    // Disable highlighting while dragging
                    if(e.stopPropagation) e.stopPropagation();
                    if(e.preventDefault) e.preventDefault();
                    e.cancelBubble = true;
                    e.returnValue = false;

                    updateInfo(e);
                    scope.$emit('angular-resizable.resizeStart', info);
                    scope.$apply();
                };

                dir.forEach(function (direction) {
                    var grabber = document.createElement('div');

                    // add class for styling purposes
                    grabber.setAttribute('class', 'rg-' + direction);
                    grabber.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(inner) : inner;
                    element[0].appendChild(grabber);
                    grabber.ondragstart = function() { return false; };

                    var down = function(e) {
                        var disabled = (scope.rDisabled === 'true');
                        if (!disabled && (e.which === 1 || e.touches)) {
                            // left mouse click or touch screen
                            dragStart(e, direction);
                        }
                    };
                    grabber.addEventListener('mousedown', down, false);
                    grabber.addEventListener('touchstart', down, false);
                });
            }
        };
    });

/**
 * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating
 * @author Alex_Crack
 * @version v0.3.6
 * @link https://github.com/alexcrack/angular-ui-notification
 * @license MIT
 */
angular.module("ui-notification",[]),angular.module("ui-notification").provider("Notification",function(){this.options={delay:5e3,startTop:10,startRight:10,verticalSpacing:10,horizontalSpacing:10,positionX:"right",positionY:"top",replaceMessage:!1,templateUrl:"angular-ui-notification.html",onClose:void 0,onClick:void 0,closeOnClick:!0,maxCount:0,container:"body",priority:10},this.setOptions=function(t){if(!angular.isObject(t))throw new Error("Options should be an object!");this.options=angular.extend({},this.options,t)},this.$get=["$timeout","$http","$compile","$templateCache","$rootScope","$injector","$sce","$q","$window",function(t,i,n,e,o,s,a,r,l){var c=this.options,p=c.startTop,u=c.startRight,d=c.verticalSpacing,f=c.horizontalSpacing,m=c.delay,g=[],h=!1,y=function(s,y){function C(i){function e(t){["-webkit-transition","-o-transition","transition"].forEach(function(i){C.css(i,t)})}var o=s.scope.$new();o.message=a.trustAsHtml(s.message),o.title=a.trustAsHtml(s.title),o.t=s.type.substr(0,1),o.delay=s.delay,o.onClose=s.onClose,o.onClick=s.onClick;var r=function(t,i){return t._priority-i._priority},m=function(t,i){return i._priority-t._priority},y=function(){var t=0,i=0,n=p,e=u,o=[];"top"===s.positionY?g.sort(r):"bottom"===s.positionY&&g.sort(m);for(var a=g.length-1;a>=0;a--){var l=g[a];if(s.replaceMessage&&a<g.length-1)l.addClass("killed");else{var h=parseInt(l[0].offsetHeight),y=parseInt(l[0].offsetWidth),C=o[l._positionY+l._positionX];k+h>window.innerHeight&&(C=p,i++,t=0);var k=n=C?0===t?C:C+d:p,v=e+i*(f+y);l.css(l._positionY,k+"px"),"center"===l._positionX?l.css("left",parseInt(window.innerWidth/2-y/2)+"px"):l.css(l._positionX,v+"px"),o[l._positionY+l._positionX]=k+h,c.maxCount>0&&g.length>c.maxCount&&0===a&&l.scope().kill(!0),t++}}},C=n(i)(o);C._positionY=s.positionY,C._positionX=s.positionX,C._priority=s.priority,C.addClass(s.type);var v=function(t){t=t.originalEvent||t,("click"===t.type||"opacity"===t.propertyName&&t.elapsedTime>=1)&&(o.onClose&&o.$apply(o.onClose(C)),"click"===t.type&&o.onClick&&o.$apply(o.onClick(C)),C.remove(),g.splice(g.indexOf(C),1),o.$destroy(),y())};s.closeOnClick&&(C.addClass("clickable"),C.bind("click",v)),C.bind("webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd",v),angular.isNumber(s.delay)&&t(function(){C.addClass("killed")},s.delay),e("none"),angular.element(document.querySelector(s.container)).append(C);var _=-(parseInt(C[0].offsetHeight)+50);if(C.css(C._positionY,_+"px"),g.push(C),"center"==s.positionX){var w=parseInt(C[0].offsetWidth);C.css("left",parseInt(window.innerWidth/2-w/2)+"px")}t(function(){e("")}),o._templateElement=C,o.kill=function(i){i?(o.onClose&&o.$apply(o.onClose(o._templateElement)),g.splice(g.indexOf(o._templateElement),1),o._templateElement.remove(),o.$destroy(),t(y)):o._templateElement.addClass("killed")},t(y),h||(angular.element(l).bind("resize",function(i){t(y)}),h=!0),k.resolve(o)}var k=r.defer();"object"==typeof s&&null!==s||(s={message:s}),s.scope=s.scope?s.scope:o,s.template=s.templateUrl?s.templateUrl:c.templateUrl,s.delay=angular.isUndefined(s.delay)?m:s.delay,s.type=y||s.type||c.type||"",s.positionY=s.positionY?s.positionY:c.positionY,s.positionX=s.positionX?s.positionX:c.positionX,s.replaceMessage=s.replaceMessage?s.replaceMessage:c.replaceMessage,s.onClose=s.onClose?s.onClose:c.onClose,s.onClick=s.onClick?s.onClick:c.onClick,s.closeOnClick=null!==s.closeOnClick&&void 0!==s.closeOnClick?s.closeOnClick:c.closeOnClick,s.container=s.container?s.container:c.container,s.priority=s.priority?s.priority:c.priority;var v=e.get(s.template);return v?C(v):i.get(s.template,{cache:!0}).then(function(t){C(t.data)})["catch"](function(t){throw new Error("Template ("+s.template+") could not be loaded. "+t)}),k.promise};return y.primary=function(t){return this(t,"primary")},y.error=function(t){return this(t,"error")},y.success=function(t){return this(t,"success")},y.info=function(t){return this(t,"info")},y.warning=function(t){return this(t,"warning")},y.clearAll=function(){angular.forEach(g,function(t){t.addClass("killed")})},y}]}),angular.module("ui-notification").run(["$templateCache",function(t){t.put("angular-ui-notification.html",'<div class="ui-notification"><h3 ng-show="title" ng-bind-html="title"></h3><div class="message" ng-bind-html="message"></div></div>')}]);
(function($, angular) {

  // eslint-disable-next-line angular/file-name, angular/no-service-method
  angular.module('ui.bootstrap.contextMenu', [])
    .service('CustomService', function () {
      'use strict';

      return {
        initialize: function (item) {
          console.log('got here', item);
        }
      };

    })
    .constant('ContextMenuEvents', {
      // Triggers when all the context menus have been closed
      ContextMenuAllClosed: 'context-menu-all-closed',
      // Triggers when any single conext menu is called.
      // Closing all context menus triggers this for each level open
      ContextMenuClosed: 'context-menu-closed',
      // Triggers right before the very first context menu is opened
      ContextMenuOpening: 'context-menu-opening',
      // Triggers right after any context menu is opened
      ContextMenuOpened: 'context-menu-opened'
    })
    .directive('contextMenu', ['$rootScope', 'ContextMenuEvents', '$parse', '$q', 'CustomService', '$sce', '$document', '$window', '$compile',
      function ($rootScope, ContextMenuEvents, $parse, $q, custom, $sce, $document, $window, $compile) {

        var _contextMenus = [];
        // Contains the element that was clicked to show the context menu
        var _clickedElement = null;
        var DEFAULT_ITEM_TEXT = '"New Item';
        var _emptyText = 'empty';

        function createAndAddOptionText(params) {
          // Destructuring:
          var $scope = params.$scope;
          var item = params.item;
          var event = params.event;
          var modelValue = params.modelValue;
          var $promises = params.$promises;
          var nestedMenu = params.nestedMenu;
          var $li = params.$li;
          var leftOriented = String(params.orientation).toLowerCase() === 'left';

          var optionText = null;

          if (item.html) {
            if (angular.isFunction(item.html)) {
              // runs the function that expects a jQuery/jqLite element
              optionText = item.html($scope);
            } else {
              // Incase we want to compile html string to initialize their custom directive in html string
              if (item.compile) {
                optionText = $compile(item.html)($scope);
              } else {
                // Assumes that the developer already placed a valid jQuery/jqLite element
                optionText = item.html;
              }
            }
          } else {

            var $a = $('<a>');
            var $anchorStyle = {};

            if (leftOriented) {
              $anchorStyle.textAlign = 'right';
              $anchorStyle.paddingLeft = '8px';
            } else {
              $anchorStyle.textAlign = 'left';
              $anchorStyle.paddingRight = '8px';
            }

            $a.css($anchorStyle);
            $a.addClass('dropdown-item');
            $a.attr({ tabindex: '-1', href: '#' });

            var textParam = item.text || item[0];
            var text = DEFAULT_ITEM_TEXT;

            if (typeof textParam === 'string') {
              text = textParam;
            } else if (typeof textParam === 'function') {
              text = textParam.call($scope, $scope, event, modelValue);
            }

            var $promise = $q.when(text);
            $promises.push($promise);
            $promise.then(function (pText) {
              if (nestedMenu) {
                var $arrow;
                var $boldStyle = {
                  fontFamily: 'monospace',
                  fontWeight: 'bold'
                };

                if (leftOriented) {
                  $arrow = '&lt;';
                  $boldStyle.float = 'left';
                } else {
                  $arrow = '&gt;';
                  $boldStyle.float = 'right';
                }

                var $bold = $('<strong style="font-family:monospace;font-weight:bold;float:right;">' + $arrow + '</strong>');
                $bold.css($boldStyle);
                $a.css('cursor', 'default');
                $a.append($bold);
              }
              $a.append(pText);
            });

            optionText = $a;
          }

          $li.append(optionText);

          return optionText;
        };

        /**
         * Process each individual item
         *
         * Properties of params:
         * - $scope
         * - event
         * - modelValue
         * - level
         * - item
         * - $ul
         * - $li
         * - $promises
         */
        function processItem(params) {
          var nestedMenu = extractNestedMenu(params);

          // if html property is not defined, fallback to text, otherwise use default text
          // if first item in the item array is a function then invoke .call()
          // if first item is a string, then text should be the string.

          var text = DEFAULT_ITEM_TEXT;
          var currItemParam = angular.extend({}, params);
          var item = params.item;
          var enabled = item.enabled === undefined ? item[2] : item.enabled;

          currItemParam.nestedMenu = nestedMenu;
          currItemParam.enabled = resolveBoolOrFunc(enabled, params);
          currItemParam.text = createAndAddOptionText(currItemParam);

          registerCurrentItemEvents(currItemParam);

        };

        /*
         * Registers the appropriate mouse events for options if the item is enabled.
         * Otherwise, it ensures that clicks to the item do not propagate.
         */
        function registerCurrentItemEvents (params) {
          // Destructuring:
          var item = params.item;
          var $ul = params.$ul;
          var $li = params.$li;
          var $scope = params.$scope;
          var modelValue = params.modelValue;
          var level = params.level;
          var event = params.event;
          var text = params.text;
          var nestedMenu = params.nestedMenu;
          var enabled = params.enabled;
          var orientation = String(params.orientation).toLowerCase();
          var customClass = params.customClass;

          if (enabled) {
            var openNestedMenu = function ($event) {
              removeContextMenus(level + 1);
              /*
               * The object here needs to be constructed and filled with data
               * on an "as needed" basis. Copying the data from event directly
               * or cloning the event results in unpredictable behavior.
               */
              /// adding the original event in the object to use the attributes of the mouse over event in the promises
              var ev = {
                pageX: orientation === 'left' ? event.pageX - $ul[0].offsetWidth + 1 : event.pageX + $ul[0].offsetWidth - 1,
                pageY: $ul[0].offsetTop + $li[0].offsetTop - 3,
                // eslint-disable-next-line angular/window-service
                view: event.view || window,
                target: event.target,
                event: $event
              };

              /*
               * At this point, nestedMenu can only either be an Array or a promise.
               * Regardless, passing them to `when` makes the implementation singular.
               */
              $q.when(nestedMenu).then(function(promisedNestedMenu) {
                if (angular.isFunction(promisedNestedMenu)) {
                  //  support for dynamic subitems
                  promisedNestedMenu = promisedNestedMenu.call($scope, $scope, event, modelValue, text, $li);
                }
                var nestedParam = {
                  $scope : $scope,
                  event : ev,
                  options : promisedNestedMenu,
                  modelValue : modelValue,
                  level : level + 1,
                  orientation: orientation,
                  customClass: customClass
                };
                renderContextMenu(nestedParam);
              });
            };

            $li.on('click', function ($event) {
              if($event.which == 1) {
                $event.preventDefault();
                $scope.$apply(function () {

                  var cleanupFunction = function () {
                    $(event.currentTarget).removeClass('context');
                    removeAllContextMenus();
                  };
                  var clickFunction = angular.isFunction(item.click)
                    ? item.click
                    : (angular.isFunction(item[1])
                      ? item[1]
                      : null);

                  if (clickFunction) {
                    var res = clickFunction.call($scope, $scope, event, modelValue, text, $li);
                    if(res === undefined || res) {
                      cleanupFunction();
                    }
                  } else {
                    cleanupFunction();
                  }
                });
              }
            });

            $li.on('mouseover', function ($event) {
              $scope.$apply(function () {
                if (nestedMenu) {
                  openNestedMenu($event);
                } else {
                  removeContextMenus(level + 1);
                }
              });
            });
          } else {
            setElementDisabled($li);
          }
        };

        /**
         * @param params - an object containing the `item` parameter
         * @returns an Array or a Promise containing the children,
         *          or null if the option has no submenu
         */
        function extractNestedMenu(params) {
          // Destructuring:
          var item = params.item;

          // New implementation:
          if (item.children) {
            if (angular.isFunction(item.children)) {
              // Expects a function that returns a Promise or an Array
              return item.children();
            } else if (angular.isFunction(item.children.then) || angular.isArray(item.children)) {
              // Returns the promise
              // OR, returns the actual array
              return item.children;
            }

            return null;

          } else {
            // nestedMenu is either an Array or a Promise that will return that array.
            // NOTE: This might be changed soon as it's a hangover from an old implementation

            return angular.isArray(item[1]) ||
                (item[1] && angular.isFunction(item[1].then)) ? item[1] : angular.isArray(item[2]) ||
                (item[2] && angular.isFunction(item[2].then)) ? item[2] : angular.isArray(item[3]) ||
                (item[3] && angular.isFunction(item[3].then)) ? item[3] : null;
          }
        }

        /**
         * Responsible for the actual rendering of the context menu.
         *
         * The parameters in params are:
         * - $scope = the scope of this context menu
         * - event = the event that triggered this context menu
         * - options = the options for this context menu
         * - modelValue = the value of the model attached to this context menu
         * - level = the current context menu level (defauts to 0)
         * - customClass = the custom class to be used for the context menu
         */
        function renderContextMenu (params) {
          /// <summary>Render context menu recursively.</summary>

          // Destructuring:
          var $scope = params.$scope;
          var event = params.event;
          var options = params.options;
          var modelValue = params.modelValue;
          var level = params.level;
          var customClass = params.customClass;

          // Initialize the container. This will be passed around
          var $ul = initContextMenuContainer(params);
          params.$ul = $ul;

          // Register this level of the context menu
          _contextMenus.push($ul);

          /*
           * This object will contain any promises that we have
           * to wait for before trying to adjust the context menu.
           */
          var $promises = [];
          params.$promises = $promises;

          angular.forEach(options, function (item) {

            if (item === null) {
              appendDivider($ul);
            } else {
              // If displayed is anything other than a function or a boolean
              var displayed = resolveBoolOrFunc(item.displayed, params);

              // Only add the <li> if the item is displayed
              if (displayed) {
                var $li = $('<li>');
                var itemParams = angular.extend({}, params);
                itemParams.item = item;
                itemParams.$li = $li;

                if (typeof item[0] === 'object') {
                  custom.initialize($li, item);
                } else {
                  processItem(itemParams);
                }
                if (resolveBoolOrFunc(item.hasTopDivider, itemParams, false)) {
                  appendDivider($ul);
                }
                $ul.append($li);
                if (resolveBoolOrFunc(item.hasBottomDivider, itemParams, false)) {
                  appendDivider($ul);
                }
              }
            }
          });

          if ($ul.children().length === 0) {
            var $emptyLi = angular.element('<li>');
            setElementDisabled($emptyLi);
            $emptyLi.html('<a>' + _emptyText + '</a>');
            $ul.append($emptyLi);
          }

          $document.find('body').append($ul);

          doAfterAllPromises(params);

          $rootScope.$broadcast(ContextMenuEvents.ContextMenuOpened, {
            context: _clickedElement,
            contextMenu: $ul,
            params: params
          });
        };

        /**
         * calculate if drop down menu would go out of screen at left or bottom
         * calculation need to be done after element has been added (and all texts are set; thus the promises)
         * to the DOM the get the actual height
         */
        function doAfterAllPromises (params) {

          // Desctructuring:
          var $ul = params.$ul;
          var $promises = params.$promises;
          var level = params.level;
          var event = params.event;
          var leftOriented = String(params.orientation).toLowerCase() === 'left';

          $q.all($promises).then(function () {
            var topCoordinate  = event.pageY;
            var menuHeight = angular.element($ul[0]).prop('offsetHeight');
            var winHeight = $window.pageYOffset + event.view.innerHeight;

            /// the 20 pixels in second condition are considering the browser status bar that sometimes overrides the element
            if (topCoordinate > menuHeight && winHeight - topCoordinate < menuHeight + 20) {
              topCoordinate = event.pageY - menuHeight;
              /// If the element is a nested menu, adds the height of the parent li to the topCoordinate to align with the parent
              if(level && level > 0) {
                topCoordinate += event.event.currentTarget.offsetHeight;
              }
            } else if(winHeight <= menuHeight) {
              // If it really can't fit, reset the height of the menu to one that will fit
              angular.element($ul[0]).css({ 'height': winHeight - 5, 'overflow-y': 'scroll' });
              // ...then set the topCoordinate height to 0 so the menu starts from the top
              topCoordinate = 0;
            } else if(winHeight - topCoordinate < menuHeight) {
              var reduceThresholdY = 5;
              if(topCoordinate < reduceThresholdY) {
                reduceThresholdY = topCoordinate;
              }
              topCoordinate = winHeight - menuHeight - reduceThresholdY;
            }

            var leftCoordinate = event.pageX;
            var menuWidth = angular.element($ul[0]).prop('offsetWidth');
            var winWidth = event.view.innerWidth + window.pageXOffset;
            var padding = 5;

            if (leftOriented) {
              if (winWidth - leftCoordinate > menuWidth && leftCoordinate < menuWidth + padding) {
                leftCoordinate = padding;
              } else if (leftCoordinate < menuWidth) {
                var reduceThresholdX = 5;
                if (winWidth - leftCoordinate < reduceThresholdX + padding) {
                  reduceThresholdX = winWidth - leftCoordinate + padding;
                }
                leftCoordinate = menuWidth + reduceThresholdX + padding;
              } else {
                leftCoordinate = leftCoordinate - menuWidth;
              }
            } else {
              if (leftCoordinate > menuWidth && winWidth - leftCoordinate - padding < menuWidth) {
                leftCoordinate = winWidth - menuWidth - padding;
              } else if(winWidth - leftCoordinate < menuWidth) {
                var reduceThresholdX = 5;
                if(leftCoordinate < reduceThresholdX + padding) {
                  reduceThresholdX = leftCoordinate + padding;
                }
                leftCoordinate = winWidth - menuWidth - reduceThresholdX - padding;
              }
            }

            $ul.css({
              display: 'block',
              position: 'absolute',
              left: leftCoordinate + 'px',
              top: topCoordinate + 'px'
            });
          });

        };

        /**
         * Creates the container of the context menu (a <ul> element),
         * applies the appropriate styles and then returns that container
         *
         * @return a <ul> jqLite/jQuery element
         */
        function initContextMenuContainer(params) {
          // Destructuring
          var customClass = params.customClass;

          var $ul = $('<ul>');
          $ul.addClass('dropdown-menu');
          $ul.attr({ 'role': 'menu' });
          $ul.css({
            display: 'block',
            position: 'absolute',
            left: params.event.pageX + 'px',
            top: params.event.pageY + 'px',
            'z-index': 10000
          });

          if(customClass) { $ul.addClass(customClass); }

          return $ul;
        }

        function isTouchDevice() {
          return 'ontouchstart' in window  || navigator.maxTouchPoints; // works on most browsers | works on IE10/11 and Surface
        }

        /**
         * Removes the context menus with level greater than or equal
         * to the value passed. If undefined, null or 0, all context menus
         * are removed.
         */
        function removeContextMenus (level) {
          while (_contextMenus.length && (!level || _contextMenus.length > level)) {
            var cm = _contextMenus.pop();
            $rootScope.$broadcast(ContextMenuEvents.ContextMenuClosed, { context: _clickedElement, contextMenu: cm });
            cm.remove();
          }
          if(!level) {
            $rootScope.$broadcast(ContextMenuEvents.ContextMenuAllClosed, { context: _clickedElement });
          }
        }

        function removeOnScrollEvent(e) {
          removeAllContextMenus(e);
        }

        function removeOnOutsideClickEvent(e) {

          var $curr = $(e.target);
          var shouldRemove = true;

          while($curr.length) {
            if ($curr.hasClass('dropdown-menu')) {
              shouldRemove = false;
              break;
            } else {
              $curr = $curr.parent();
            }
          }
          if (shouldRemove) {
            removeAllContextMenus(e);
          }
        }

        function removeAllContextMenus(e) {
          $document.find('body').off('mousedown touchstart', removeOnOutsideClickEvent);
          $document.off('scroll', removeOnScrollEvent);
          $(_clickedElement).removeClass('context');
          removeContextMenus();
          $rootScope.$broadcast('');
        }

        function isBoolean(a) {
          return a === false || a === true;
        }

        /** Resolves a boolean or a function that returns a boolean
         * Returns true by default if the param is null or undefined
         * @param a - the parameter to be checked
         * @param params - the object for the item's parameters
         * @param defaultValue - the default boolean value to use if the parameter is
         *  neither a boolean nor function. True by default.
         */
        function resolveBoolOrFunc(a, params, defaultValue) {
          var item = params.item;
          var $scope = params.$scope;
          var event = params.event;
          var modelValue = params.modelValue;

          defaultValue = isBoolean(defaultValue) ? defaultValue : true;

          if (isBoolean(a)) {
            return a;
          } else if (angular.isFunction(a)) {
            return a.call($scope, $scope, event, modelValue);
          } else {
            return defaultValue;
          }
        }

        function appendDivider($ul) {
          var $li = angular.element('<li>');
          $li.addClass('divider');
          $ul.append($li);
        }

        function setElementDisabled($li) {
          $li.on('click', function ($event) {
            $event.preventDefault();
          });
          $li.addClass('disabled');
        }

        return function ($scope, element, attrs) {
          var openMenuEvents = ['contextmenu'];
          _emptyText = $scope.$eval(attrs.contextMenuEmptyText) || 'empty';

          if(attrs.contextMenuOn && typeof(attrs.contextMenuOn) === 'string'){
            openMenuEvents = attrs.contextMenuOn.split(',');
          }

          angular.forEach(openMenuEvents, function (openMenuEvent) {
            element.on(openMenuEvent.trim(), function (event) {
              // Cleanup any leftover contextmenus(there are cases with longpress on touch where we
              // still see multiple contextmenus)
              removeAllContextMenus();

              if(!attrs.allowEventPropagation) {
                event.stopPropagation();
                event.preventDefault();
              }

              // Don't show context menu if on touch device and element is draggable
              if(isTouchDevice() && element.attr('draggable') === 'true') {
                return false;
              }

              // Remove if the user clicks outside
              $document.find('body').on('mousedown touchstart', removeOnOutsideClickEvent);
              // Remove the menu when the scroll moves
              $document.on('scroll', removeOnScrollEvent);

              _clickedElement = event.currentTarget;
              $(_clickedElement).addClass('context');

              $scope.$apply(function () {
                var options = $scope.$eval(attrs.contextMenu);
                var customClass = attrs.contextMenuClass;
                var modelValue = $scope.$eval(attrs.model);
                var orientation = attrs.contextMenuOrientation;

                $q.when(options).then(function(promisedMenu) {
                  if (angular.isFunction(promisedMenu)) {
                    //  support for dynamic items
                    promisedMenu = promisedMenu.call($scope, $scope, event, modelValue);
                  }
                  var params = {
                    '$scope' : $scope,
                    'event' : event,
                    'options' : promisedMenu,
                    'modelValue' : modelValue,
                    'level' : 0,
                    'customClass' : customClass,
                    'orientation': orientation
                  };
                  $rootScope.$broadcast(ContextMenuEvents.ContextMenuOpening, { context: _clickedElement });
                  renderContextMenu(params);
                });
              });

              // Remove all context menus if the scope is destroyed
              $scope.$on('$destroy', function () {
                removeAllContextMenus();
              });
            });
          });

          if (attrs.closeMenuOn) {
            $scope.$on(attrs.closeMenuOn, function () {
              removeAllContextMenus();
            });
          }
        };
      }]);
// eslint-disable-next-line angular/window-service
})(window.angular.element, window.angular);

//close menu container on click outside
$(document).ready(function () {
    if ($(window).width() < 1440) {
        $(document).on("click", ".al-sidebar-list-item.with-sub-menu .al-sidebar-list-link", function (event) {
            event.stopPropagation();
        });
        $(document).click(function () {
            $(".navbar-collapse").collapse('hide');
        });      
    }
    //js for menu panel for half screen
    $(window).resize(function () {
        $(document).click(function () {
            if ($(window).width() > 768 && $(window).width() < 1440) {
                $(".navbar-collapse").collapse('hide');
            }
        });
    });
});
/**
 * @fileoverview dragscroll - scroll area by dragging
 * @version 0.0.8
 * 
 * @license MIT, see http://github.com/asvd/dragscroll
 * @copyright 2015 asvd <heliosframework@gmail.com> 
 */


(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['exports'], factory);
    } else if (typeof exports !== 'undefined') {
        factory(exports);
    } else {
        factory((root.dragscroll = {}));
    }
}(this, function (exports) {
    var _window = window;
    var _document = document;
    var mousemove = 'mousemove';
    var mouseup = 'mouseup';
    var mousedown = 'mousedown';
    var EventListener = 'EventListener';
    var addEventListener = 'add'+EventListener;
    var removeEventListener = 'remove'+EventListener;
    var newScrollX, newScrollY;

    var dragged = [];
    var reset = function(i, el) {
        for (i = 0; i < dragged.length;) {
            el = dragged[i++];
            el = el.container || el;
            el[removeEventListener](mousedown, el.md, 0);
            _window[removeEventListener](mouseup, el.mu, 0);
            _window[removeEventListener](mousemove, el.mm, 0);
        }

        // cloning into array since HTMLCollection is updated dynamically
        dragged = [].slice.call(_document.getElementsByClassName('dragscroll'));
        for (i = 0; i < dragged.length;) {
            (function(el, lastClientX, lastClientY, pushed, scroller, cont){
                (cont = el.container || el)[addEventListener](
                    mousedown,
                    cont.md = function(e) {
                        if (!el.hasAttribute('nochilddrag') ||
                            _document.elementFromPoint(
                                e.pageX, e.pageY
                            ) == cont
                        ) {
                            pushed = 1;
                            lastClientX = e.clientX;
                            lastClientY = e.clientY;

                            e.preventDefault();
                        }
                    }, 0
                );

                _window[addEventListener](
                    mouseup, cont.mu = function() {pushed = 0;}, 0
                );

                _window[addEventListener](
                    mousemove,
                    cont.mm = function(e) {
                        if (pushed) {
                            (scroller = el.scroller||el).scrollLeft -=
                                newScrollX = (- lastClientX + (lastClientX=e.clientX));
                            scroller.scrollTop -=
                                newScrollY = (- lastClientY + (lastClientY=e.clientY));
                            if (el == _document.body) {
                                (scroller = _document.documentElement).scrollLeft -= newScrollX;
                                scroller.scrollTop -= newScrollY;
                            }
                        }
                    }, 0
                );
             })(dragged[i++]);
        }
    }

      
    if (_document.readyState == 'complete') {
        reset();
    } else {
        _window[addEventListener]('load', reset, 0);
    }

    exports.reset = reset;
}));


(function (window) {
    window.__env = window.__env || {};
    window.__env = {
        openSynapseonLoad: false,
        openPowerScribeonLoad: true,
        showLoaderonPSNViewerLoad: true,
        candelisURL: 'igplatform://viewer/?request=openstudybyaccession&AccessionNumber=',
        agfaURL: 'AgfaHC://impax-client-epr?domain=Agfa Healthcare&patientid=',
        agfaDefaultURL: 'AgfaHC://impax-client-epr?domain=Agfa Healthcare&patientid=&accession=',
        CheckDicomViewerCredentials: "GECUV",
        _ASSIGN_MSG_: "Wants to consult with you on a study",
        _CLOSE_MSG_: "The study you are consulting is closed now.",
        _ANS_MSG_: "You have reply on your study.",
        _NOTIFY_MSG_: "You have reply on your comment.",
        _ASSIGN_STUDY_: "You have new study",
        _MHSRichardsonXmlPath_: "C:\\Nuance\\Agfa\\study.xml",
        _MHSRichardsonXmlFile_: "<?xml version='1.0' encoding='UTF-8' standalone='yes'?><ChunkData><Fields><Field6>@Accession</Field6></Fields></ChunkData>",
        _SignalRreconnectInterval: 5000,
        _SignalRreconnectAttempts: 10,
        TechWorklistRefreshDuration: 180000,
        DefaultAutoRefreshDuration: 60000,
        appLogSetting: { isEnabled: false }, //true will add console log and false will add DB logs
        AnalyticsPopoutUrl: '?CallFrom=RadFlow&Token=@TOKEN&UserId=@USERID&RefreshToken=@REFRESHTOKEN&UserRoles=@USERROLES&NavigateTo=userAnalytics',
        OcpApimSubscriptionKey: '',
        // Task 172903 R3: Google reCAPTCHA v2 SITE key (the public one) for the login form. After the
        // first failed sign-in attempt loginController renders a checkbox widget with this key and posts
        // the resulting token as RecaptchaResponse to /Token, where the auth API verifies it with Google.
        //
        // This static default is a fallback only - loginController.js overwrites it at login-page init
        // via api/common/GetLoginRecaptchaSiteKey (reads Recaptch_SiteKey from PS.OrdersWeb's Web.config),
        // the same anonymous, pre-login pattern GetLoginBanners uses. Leave this blank; set the real
        // value in that Web.config, not here.
        //
        // INTENTIONALLY EMPTY - NOT AN OVERSIGHT. No site key has ever existed in this repo; only the
        // matching SECRET is present, server-side (Recaptch_SecreteKey in the auth API Web.config). A
        // site key cannot be derived from a secret, so it has to be read off the Google reCAPTCHA admin
        // console for that same key pair. While this is blank the widget is never rendered and login
        // behaves exactly as before.
        //
        // To turn the feature on: set Recaptch_SiteKey in PS.OrdersWeb's Web.config (client 1 then picks
        // it up automatically), wire up the four OTHER clients that still hardcode the 'Disabled'
        // sentinel (RadFlowVRUI, civr-lite, the Flutter mobile bundle and radico - all listed in the
        // LoginCaptchaEnabled comment in the auth API's Web.config), and only then set
        // LoginCaptchaEnabled=true. Do NOT enable the server flag first: it would start rejecting every
        // post-failure login attempt that has no verifiable token, and since a failed captcha does not
        // decay, one typo would lock a user out of the application until IT intervened.
        recaptchaSiteKey: '',
        CViewer: '/CView.html?TOKENURL=@TOKENURL',
        MedDreamCViewer: '/MedDreamViewer.html?key=@KEY',
        MedDreamUseCommunicationAPI: false,
        MedDreamUseHangingProtocol: false,
        EnableRadPodNewsletter: false,
        PassowordPatternMessage: "Password must be 12 characters and include a lowercase, uppercase, number, and one of special character.",
        PasswordRequirements: {
            rules: [
                "At least 12 characters",
                "At least 1 number",
                "At least 1 lowercase letter",
                "At least 1 uppercase letter",
                "At least 1 special character (e.g., !, @, #, $, &, %, ^, *)"
            ]
        }
        //CViewer: '/CView.html?ACCESSION=@ACCESSION&USERID=@USERID&USERNAME=@USERNAME&MONITORINDEX=@MONITORINDEX',
    };

    var _environments = {
        local: {
            host: 'http://localhost:3002',
            config: {
                apiResourceServiceBaseUri: 'https://radflow-core-api-dev.ci-dev-int-ase01.appserviceenvironment.net/api/',
                apiAuthServiceBaseUri: 'https://ci-ps-radflow-auth-api-dev.ci-dev-int-ase01.appserviceenvironment.net',
                signalrURL: 'https://radflow-core-api-dev.ci-dev-int-ase01.appserviceenvironment.net',
                domain: 'https://test2.radamatic.com/',
                synapse: 'https://pacs.texasradiology.com',
                idletimeout: 900,
                dicomviewerrncodeurl: 'https://test2.radamatic.com/dicomviewer/index.html?input=',
                dicomviewerViewurl: 'https://test2.radamatic.com/dicomviewer/index.html?URLID=',
                radiCoAPI: 'http://localhost:35360/',
                konicaURL: 'RadFlowChrome:https://testradflowfileshare.z21.web.core.windows.net/konicaviewer.html?v=1.0.0.5?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                konicaBaseURL: '/konicaviewer.html?v=1.0.0.5?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                GECentricityURL: 'https://bswntxraduvprod.bswhealth.org/loadStudy.jsp',
                VRViewurl: 'https://ci-ps-civr-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/',
                CIVRSmartWorklistURL: 'https://dev-civr-ui.civie.com/#/smartworklist',
                ciDICOMViewerAPI: 'https://cidicomviewerapi.azurewebsites.net',
                ciDICOMViewer: 'RadFlowChrome:https://testradflowfileshare.z21.web.core.windows.net/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION?USERID=@USERID',
                ciDICOMViewerChrome: 'https://testradflowfileshare.z21.web.core.windows.net/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION&USERID=@USERID&MONITORINDEX=@MONITORINDEX',
                attachmentViewerIFrameSRC: 'https://view.officeapps.live.com/op/embed.aspx?src=',
                MobileWebViewURL: window.location.origin + "/mobile/",
                //MobileWebViewURL: "https://testradflowfileshare.z21.web.core.windows.net/mobile/",
                rcServiceHelp: window.location.origin + "/rchelp.html",
                orderRefreshDuration: 180000,
            }
        },
        AzureTest: {
            host: 'https://ci-ps-radflow-ui-dev.ci-dev-ase01.p.azurewebsites.net',
            config: {
                //api: 'https://ps360ordersapi.ci-private-ase.p.azurewebsites.net/api/',
                apiResourceServiceBaseUri: 'https://ci-ps-radflow-api-dev.ci-dev-ase01.p.azurewebsites.net/api/',
                apiAuthServiceBaseUri: 'https://ci-ps-radflow-auth-api-dev.ci-dev-ase01.p.azurewebsites.net',
                //oAuthBase: 'https://radflowauthapi.azurewebsites.net',
                domain: 'https://ci-ps-radflow-ui-dev.ci-dev-ase01.p.azurewebsites.net/',
                //synapse: 'https://pacs.texasradiology.com',
                synapse: 'http://thrpacs',
                signalrURL: 'https://ci-ps-radflow-api-dev.ci-dev-ase01.p.azurewebsites.net',
                idletimeout: 900,
                dicomviewerrncodeurl: 'https://ci-ps-radflow-ui-dev.ci-dev-ase01.p.azurewebsites.net/dicomviewer/index.html?input=',
                dicomviewerViewurl: 'https://ci-ps-radflow-ui-dev.ci-dev-ase01.p.azurewebsites.net/dicomviewer/index.html?URLID=',
                oldDesignAppURL: 'https://testradflowfileshare.z21.web.core.windows.net/v1/',
                radiCoAPI: 'https://devradicoapi.ci-private-ase.p.azurewebsites.net/',
                //rcServiceHelp: 'https://radflow.collaborativeimaging.com/rchelp.html'
                konicaURL: 'RadFlowChrome:https://testradflowfileshare.z21.web.core.windows.net/konicaviewer.html?v=1.0.0.5?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                konicaBaseURL: '/konicaviewer.html?v=1.0.0.5?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                GECentricityURL: 'https://bswntxraduvprod.bswhealth.org/loadStudy.jsp',
                VRViewurl: 'https://ci-ps-civir-ui-dev.ci-dev-ase01.p.azurewebsites.net/?civr=v',
                CIVRSmartWorklistURL: 'https://dev-civr-ui.civie.com/#/smartworklist',
                ciDICOMViewerAPI: 'https://cidicomviewerapi.azurewebsites.net',
                ciDICOMViewer: 'RadFlowChrome:https://testradflowfileshare.z21.web.core.windows.net/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION?USERID=@USERID',
                ciDICOMViewerChrome: 'https://testradflowfileshare.z21.web.core.windows.net/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION&USERID=@USERID&MONITORINDEX=@MONITORINDEX',
                attachmentViewerIFrameSRC: 'https://view.officeapps.live.com/op/embed.aspx?src=',
                //MobileWebViewURL: "https://testradflowfileshare.z21.web.core.windows.net/mobile/",
                MobileWebViewURL: window.location.origin + "/mobile/",
                rcServiceHelp: window.location.origin + "/rchelp.html",
                orderRefreshDuration: 180000,
            }
        },
        QA: {
            host: 'https://ci-ps-radflow-ui-dev.ci-dev-int-ase01.appserviceenvironment.net',
            config: {
                //api: 'https://ps360ordersapi.ci-private-ase.p.azurewebsites.net/api/',
                apiResourceServiceBaseUri: 'https://radflow-core-api-dev.ci-dev-int-ase01.appserviceenvironment.net/api/',
                apiAuthServiceBaseUri: 'https://ci-ps-radflow-auth-api-dev.ci-dev-int-ase01.appserviceenvironment.net',
                signalrURL: 'https://radflow-core-api-dev.ci-dev-int-ase01.appserviceenvironment.net',
                //oAuthBase: 'https://radflowauthapi.azurewebsites.net',
                domain: 'https://ci-ps-radflow-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/',
                //synapse: 'https://pacs.texasradiology.com',
                synapse: 'http://thrpacs',
                idletimeout: 900,
                dicomviewerrncodeurl: 'https://ci-ps-radflow-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/dicomviewer/index.html?input=',
                dicomviewerViewurl: 'https://ci-ps-radflow-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/dicomviewer/index.html?URLID=',
                oldDesignAppURL: 'https://testradflowfileshare.z21.web.core.windows.net/v1/',
                radiCoAPI: 'https://devradicoapi.ci-private-ase.p.azurewebsites.net/',
                //rcServiceHelp: 'https://radflow.collaborativeimaging.com/rchelp.html'
                konicaURL: 'RadFlowChrome:https://testradflowfileshare.z21.web.core.windows.net/konicaviewer.html?v=1.0.0.5?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                konicaBaseURL: '/konicaviewer.html?v=1.0.0.5?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                GECentricityURL: 'https://bswntxraduvprod.bswhealth.org/loadStudy.jsp',
                VRViewurl: 'https://ci-ps-civr-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/',
                CIVRSmartWorklistURL: 'https://dev-civr-ui.civie.com/#/smartworklist',
                ciDICOMViewerAPI: 'https://cidicomviewerapi.azurewebsites.net',
                ciDICOMViewer: 'RadFlowChrome:https://testradflowfileshare.z21.web.core.windows.net/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION?USERID=@USERID',
                ciDICOMViewerChrome: 'https://testradflowfileshare.z21.web.core.windows.net/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION&USERID=@USERID&MONITORINDEX=@MONITORINDEX',
                attachmentViewerIFrameSRC: 'https://view.officeapps.live.com/op/embed.aspx?src=',
                //MobileWebViewURL: "https://testradflowfileshare.z21.web.core.windows.net/mobile/",
                MobileWebViewURL: window.location.origin + "/mobile/",
                rcServiceHelp: window.location.origin + "/rchelp.html",
                orderRefreshDuration: 180000,
            }
        },
        QASandBox: {
            host: 'https://ci-ps-radflow-sandbox-ui-dev.ci-dev-int-ase01.appserviceenvironment.net',
            config: {
                //api: 'https://ps360ordersapi.ci-private-ase.p.azurewebsites.net/api/',
                apiResourceServiceBaseUri: 'https://radflow-core-api-dev.ci-dev-int-ase01.appserviceenvironment.net/api/',
                apiAuthServiceBaseUri: 'https://ci-ps-radflow-sandbox-auth-api-dev.ci-dev-int-ase01.appserviceenvironment.net',
                //oAuthBase: 'https://radflowauthapi.azurewebsites.net',
                domain: 'https://ci-ps-radflow-sandbox-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/',
                //synapse: 'https://pacs.texasradiology.com',
                synapse: 'http://thrpacs',
                signalrURL: 'https://radflow-core-api-dev.ci-dev-int-ase01.appserviceenvironment.net',
                idletimeout: 900,
                dicomviewerrncodeurl: 'https://ci-ps-radflow-sandbox-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/dicomviewer/index.html?input=',
                dicomviewerViewurl: 'https://ci-ps-radflow-sandbox-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/dicomviewer/index.html?URLID=',
                oldDesignAppURL: 'https://testradflowfileshare.z21.web.core.windows.net/v1/',
                radiCoAPI: 'https://devradicoapi.ci-private-ase.p.azurewebsites.net/',
                //rcServiceHelp: 'https://radflow.collaborativeimaging.com/rchelp.html'
                konicaURL: 'RadFlowChrome:https://ci-ps-radflow-sandbox-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/konicaviewer.html?v=1.0.0.5?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                konicaBaseURL: '/konicaviewer.html?v=1.0.0.5?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                GECentricityURL: 'https://bswntxraduvprod.bswhealth.org/loadStudy.jsp',
                VRViewurl: 'https://ci-ps-civr-ui-dev.ci-dev-int-ase01.appserviceenvironment.net/',
                CIVRSmartWorklistURL: 'https://dev-civr-ui.civie.com/#/smartworklist',
                ciDICOMViewerAPI: 'https://cidicomviewerapi.azurewebsites.net',
                ciDICOMViewer: 'RadFlowChrome:https://testradflowfileshare.z21.web.core.windows.net/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION?USERID=@USERID',
                ciDICOMViewerChrome: 'https://testradflowfileshare.z21.web.core.windows.net/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION&USERID=@USERID&MONITORINDEX=@MONITORINDEX',
                attachmentViewerIFrameSRC: 'https://view.officeapps.live.com/op/embed.aspx?src=',
                //MobileWebViewURL: "https://testradflowfileshare.z21.web.core.windows.net/mobile/",
                MobileWebViewURL: window.location.origin + "/mobile/",
                rcServiceHelp: window.location.origin + "/rchelp.html",
                orderRefreshDuration: 180000,
            }
        },
        azureprodCIRadFlow: {
            host: 'https://radflow.collaborativeimaging.com',
            config: {
                apiResourceServiceBaseUri: 'https://api.collaborativeimaging.com/ci-radflow-api/api/',
                apiAuthServiceBaseUri: 'https://api.collaborativeimaging.com/ci-radflow-auth-api',
                // APIM (ci-prod-apimgmt01) requires this on every call to ci-radflow-api/ci-radflow-auth-api, same as
                // azureCIPRODMain below. Injected at build time by the UI-Prod pipeline; keep empty in source.
                OcpApimSubscriptionKey: '20654a42064f4225bfd50d248d874e66',
                domain: 'https://radflow.collaborativeimaging.com/',
                synapse: 'http://tra-pacs',
                signalrURL: 'https://api.collaborativeimaging.com/ci-radflow-api',
                idletimeout: 3540,
                dicomviewerrncodeurl: 'https://radflow.collaborativeimaging.com/dicomviewerprod/index.html?input=',
                dicomviewerViewurl: 'https://radflow.collaborativeimaging.com/dicomviewerprod/index.html?URLID=',
                oldDesignAppURL: 'https://radflow.collaborativeimaging.com/v1/',
                konicaURL: 'RadFlowChrome:https://radflow.collaborativeimaging.com/konicaviewer.html?v=1.0.0.7?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                konicaBaseURL: 'https://radflow.collaborativeimaging.com/konicaviewer.html?v=1.0.0.7?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                GECentricityURL: 'https://bswntxraduvprod.bswhealth.org/loadStudy.jsp',
                VRViewurl: 'https://civr.collaborativeimaging.com?civr=v',
                CIVRSmartWorklistURL: 'https://asr.civie.com/#/smartworklist',
                ciDICOMViewerAPI: 'https://cidicomviewerapi.azurewebsites.net',
                ciDICOMViewer: 'RadFlowChrome:https://radflow.collaborativeimaging.com/CIDICOMViewer.html?v=1.0.0.3?ACCESSION=@ACCESSION?USERID=@USERID',
                ciDICOMViewerChrome: 'https://radflow.collaborativeimaging.com/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION&USERID=@USERID&MONITORINDEX=@MONITORINDEX',
                radiCoAPI: 'https://ci-radicoapi-prod.ci-prod-ase.p.azurewebsites.net/',
                attachmentViewerIFrameSRC: 'https://view.officeapps.live.com/op/embed.aspx?src=',
                //MobileWebViewURL: "https://radflow.collaborativeimaging.com/mobile/",
                MobileWebViewURL: window.location.origin + "/mobile/",
                rcServiceHelp: window.location.origin + "/rchelp.html",
                orderRefreshDuration: 120000,
            }
        },
        azureTestProdCIRadFlow: {
            host: 'https://testradflow.collaborativeimaging.com',
            config: {
                apiResourceServiceBaseUri: 'https://api.collaborativeimaging.com/ci-radflow-api/api/',
                apiAuthServiceBaseUri: 'https://api.collaborativeimaging.com/ci-radflow-auth-api',
                // APIM (ci-prod-apimgmt01) requires this on every call to ci-radflow-api/ci-radflow-auth-api, same as
                // azureCIPRODMain below. Injected at build time by the UI-Prod pipeline; keep empty in source.
                OcpApimSubscriptionKey: '20654a42064f4225bfd50d248d874e66',
                domain: 'https://testradflow.collaborativeimaging.com/',
                synapse: 'http://tra-pacs',
                signalrURL: 'https://api.collaborativeimaging.com/ci-radflow-api',
                idletimeout: 3540,
                dicomviewerrncodeurl: 'https://testradflow.collaborativeimaging.com/dicomviewerprod/index.html?input=',
                dicomviewerViewurl: 'https://testradflow.collaborativeimaging.com/dicomviewerprod/index.html?URLID=',
                oldDesignAppURL: 'https://testradflow.collaborativeimaging.com/v1/',
                konicaURL: 'RadFlowChrome:https://testradflow.collaborativeimaging.com/konicaviewer.html?v=1.0.0.7?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                konicaBaseURL: 'https://testradflow.collaborativeimaging.com/konicaviewer.html?v=1.0.0.7?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                GECentricityURL: 'https://bswntxraduvprod.bswhealth.org/loadStudy.jsp',
                VRViewurl: 'https://civr.collaborativeimaging.com?civr=v',
                CIVRSmartWorklistURL: 'https://asr.civie.com/#/smartworklist',
                ciDICOMViewerAPI: 'https://cidicomviewerapi.azurewebsites.net',
                ciDICOMViewer: 'RadFlowChrome:https://testradflow.collaborativeimaging.com/CIDICOMViewer.html?v=1.0.0.3?ACCESSION=@ACCESSION?USERID=@USERID',
                ciDICOMViewerChrome: 'https://testradflow.collaborativeimaging.com/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION&USERID=@USERID&MONITORINDEX=@MONITORINDEX',
                radiCoAPI: 'https://ci-radicoapi-prod.ci-prod-ase.p.azurewebsites.net/',
                attachmentViewerIFrameSRC: 'https://view.officeapps.live.com/op/embed.aspx?src=',
                //MobileWebViewURL: "https://testradflow.collaborativeimaging.com/mobile/",
                MobileWebViewURL: window.location.origin + "/mobile/",
                rcServiceHelp: window.location.origin + "/rchelp.html",
                orderRefreshDuration: 120000,
            }
        },
        azureCIPRODMain: {
            host: 'https://ci-radflow-ui.ci-prod-int-ase01.appserviceenvironment.net',
            config: {
                apiResourceServiceBaseUri: 'https://api.collaborativeimaging.com/ci-radflow-api/api/',
                apiAuthServiceBaseUri: 'https://api.collaborativeimaging.com/ci-radflow-auth-api',
                // APIM (ci-prod-apimgmt01) rejects every call to ci-radflow-api and ci-radflow-auth-api that lacks
                // Ocp-Apim-Subscription-Key. KEEP THIS EMPTY IN SOURCE: the UI-Prod pipeline writes the key into this
                // slot at build time (PS.OrdersUI/pipelines/set-apim-subscription-key.js, value from the
                // radflow-ui-secrets-prod variable group) and fails the build when the variable is missing.
                // applyEnvironmentOverrides() below copies it onto __env.OcpApimSubscriptionKey, which the $http
                // interceptor, index.html's isLatestUI() and the SignalR negotiate all send. Hosts that call the APIs
                // directly leave it empty.
                OcpApimSubscriptionKey: '20654a42064f4225bfd50d248d874e66',
                domain: 'https://ci-radflow-ui.ci-prod-int-ase01.appserviceenvironment.net/',
                synapse: 'http://tra-pacs',
                signalrURL: 'https://api.collaborativeimaging.com/ci-radflow-api',
                idletimeout: 3540,
                // Same convention as konicaURL/ciDICOMViewer below: these legacy paths are only ever served off
                // the public domain, regardless of which hostname serves the SPA shell itself. Without these,
                // indexController.js's SwitchView() does window.open(undefined, '_self') on this host.
                dicomviewerrncodeurl: 'https://radflow.collaborativeimaging.com/dicomviewerprod/index.html?input=',
                dicomviewerViewurl: 'https://radflow.collaborativeimaging.com/dicomviewerprod/index.html?URLID=',
                oldDesignAppURL: 'https://radflow.collaborativeimaging.com/v1/',
                konicaURL: 'RadFlowChrome:https://radflow.collaborativeimaging.com/konicaviewer.html?v=1.0.0.7?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                konicaBaseURL: 'https://radflow.collaborativeimaging.com/konicaviewer.html?v=1.0.0.7?ACCESSION=@ACCESSION|MRN=@MRN|VIEWER=@VIEWER',
                GECentricityURL: 'https://bswntxraduvprod.bswhealth.org/loadStudy.jsp',
                VRViewurl: 'https://civr.collaborativeimaging.com?civr=v',
                CIVRSmartWorklistURL: 'https://asr.civie.com/#/smartworklist',
                ciDICOMViewerAPI: 'https://cidicomviewerapi.azurewebsites.net',
                ciDICOMViewer: 'RadFlowChrome:https://radflow.collaborativeimaging.com/CIDICOMViewer.html?v=1.0.0.3?ACCESSION=@ACCESSION?USERID=@USERID',
                ciDICOMViewerChrome: 'https://radflow.collaborativeimaging.com/CIDICOMViewer.html?v=1.0.0.4?ACCESSION=@ACCESSION&USERID=@USERID&MONITORINDEX=@MONITORINDEX',
                radiCoAPI: 'https://ci-radicoapi-prod.ci-prod-ase.p.azurewebsites.net/',
                attachmentViewerIFrameSRC: 'https://view.officeapps.live.com/op/embed.aspx?src=',
                //MobileWebViewURL: "https://radflow.collaborativeimaging.com/mobile/",
                MobileWebViewURL: window.location.origin + "/mobile/",
                rcServiceHelp: window.location.origin + "/rchelp.html",
                orderRefreshDuration: 120000,
            }
        },
    }

    function getEnvironment() {
        //console.log(window.location);
        //var host = window.location.host;
        var host = window.location.origin;
        if (window.__env._environment) {
            return window.__env._environment;
        }

        for (var environment in _environments) {
            if (typeof _environments[environment].host && _environments[environment].host == host) {
                window.__env._environment = environment;
                return window.__env._environment;
            }
        }

        alert("Application will not run properly. Please add Config settings for host :-" + host);
        return null;
    }
    window.__env._environment = _environments[getEnvironment()];

    // The APIM subscription key is per environment: only hosts routed through api.collaborativeimaging.com
    // (azureCIPRODMain) need one. A non-empty value on the selected environment's config replaces the global
    // default declared at the top of this file, which every consumer reads as __env.OcpApimSubscriptionKey.
    window.__env.applyEnvironmentOverrides = function () {
        var cfg = window.__env._environment && window.__env._environment.config;
        if (cfg && cfg.OcpApimSubscriptionKey) {
            window.__env.OcpApimSubscriptionKey = cfg.OcpApimSubscriptionKey;
        }
    };
    window.__env.applyEnvironmentOverrides();

}(this));


/*! Copyright (c) 2013 Brandon Aaron (http://brandonaaron.net)
                                 * Licensed under the MIT License (LICENSE.txt).
                                 *
                                 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
                                 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
                                 * Thanks to: Seamus Leahy for adding deltaX and deltaY
                                 *
                                 * Version: 3.1.1
                                 *
                                 * Requires: 1.2.2+
                                 */
var loadFirstTime = true;
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var toFix = ['wheel', 'mousewheel', 'DOMMouseScroll'];
    var toBind = 'onwheel' in document || document.documentMode >= 9 ? ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'];
    var lowestDelta, lowestDeltaXY;

    if ($.event.fixHooks) {
        for (var i = toFix.length; i;) {
            $.event.fixHooks[toFix[--i]] = $.event.mouseHooks;
        }
    }

    $.event.special.mousewheel = {
        setup: function () {
            if (this.addEventListener) {
                for (var i = toBind.length; i;) {
                    this.addEventListener(toBind[--i], handler, false);
                }
            } else {
                this.onmousewheel = handler;
            }
        },

        teardown: function () {
            if (this.removeEventListener) {
                for (var i = toBind.length; i;) {
                    this.removeEventListener(toBind[--i], handler, false);
                }
            } else {
                this.onmousewheel = null;
            }
        }
    };

    $.fn.extend({
        mousewheel: function (fn) {
            return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
        },

        unmousewheel: function (fn) {
            return this.unbind("mousewheel", fn);
        }
    });


    function handler(event) {
        var orgEvent = event || window.event, args = [].slice.call(arguments, 1), delta = 0, deltaX = 0, deltaY = 0, absDelta = 0, absDeltaXY = 0, fn;
        event = $.event.fix(orgEvent);
        event.type = "mousewheel";

        // Old school scrollwheel delta
        if (orgEvent.wheelDelta) { delta = orgEvent.wheelDelta; }
        if (orgEvent.detail) { delta = orgEvent.detail * -1; }

        // New school wheel delta (wheel event)
        if (orgEvent.deltaY) {
            deltaY = orgEvent.deltaY * -1;
            delta = deltaY;
        }
        if (orgEvent.deltaX) {
            deltaX = orgEvent.deltaX;
            delta = deltaX * -1;
        }

        // Webkit
        if (orgEvent.wheelDeltaY !== undefined) { deltaY = orgEvent.wheelDeltaY; }
        if (orgEvent.wheelDeltaX !== undefined) { deltaX = orgEvent.wheelDeltaX * -1; }

        // Look for lowest delta to normalize the delta values
        absDelta = Math.abs(delta);
        if (!lowestDelta || absDelta < lowestDelta) { lowestDelta = absDelta; }
        absDeltaXY = Math.max(Math.abs(deltaY), Math.abs(deltaX));
        if (!lowestDeltaXY || absDeltaXY < lowestDeltaXY) { lowestDeltaXY = absDeltaXY; }

        // Get a whole value for the deltas
        fn = delta > 0 ? 'floor' : 'ceil';
        delta = Math[fn](delta / lowestDelta);
        deltaX = Math[fn](deltaX / lowestDeltaXY);
        deltaY = Math[fn](deltaY / lowestDeltaXY);

        // Add event and delta to the front of the arguments
        args.unshift(event, delta, deltaX, deltaY);

        return ($.event.dispatch || $.event.handle).apply(this, args);
    }

}));

/*
 * iviewer Widget for jQuery UI
 * https://github.com/can3p/iviewer
 *
 * Copyright (c) 2009 - 2013 Dmitry Petrov
 * Dual licensed under the MIT license.
 *  - http://www.opensource.org/licenses/mit-license.php
 *
 * Author: Dmitry Petrov
 * Version: 0.7.11
 */

(function ($, undefined) {

    //this code was taken from the https://github.com/furf/jquery-ui-touch-punch
    var mouseEvents = {
        touchstart: 'mousedown',
        touchmove: 'mousemove',
        touchend: 'mouseup'
    },
        gesturesSupport = 'ongesturestart' in document.createElement('div');


    /**
     * Convert a touch event to a mouse-like
     */
    function makeMouseEvent(event) {
        var touch = event.originalEvent.changedTouches[0];

        return $.extend(event, {
            type: mouseEvents[event.type],
            which: 1,
            pageX: touch.pageX,
            pageY: touch.pageY,
            screenX: touch.screenX,
            screenY: touch.screenY,
            clientX: touch.clientX,
            clientY: touch.clientY,
            isTouchEvent: true
        });
    }

    var mouseProto = $.ui.mouse.prototype,
        _mouseInit = $.ui.mouse.prototype._mouseInit;

    mouseProto._mouseInit = function () {
        var self = this;
        self._touchActive = false;

        this.element.bind('touchstart.' + this.widgetName, function (event) {
            if (gesturesSupport && event.originalEvent.touches.length > 1) { return; }
            self._touchActive = true;
            return self._mouseDown(makeMouseEvent(event));
        });

        // these delegates are required to keep context
        this._mouseMoveDelegate = function (event) {
            if (gesturesSupport && event.originalEvent.touches && event.originalEvent.touches.length > 1) { return; }
            if (self._touchActive) {
                return self._mouseMove(makeMouseEvent(event));
            }
        };
        this._mouseUpDelegate = function (event) {
            if (self._touchActive) {
                self._touchActive = false;
                return self._mouseUp(makeMouseEvent(event));
            }
        };

        $(document)
            .bind('touchmove.' + this.widgetName, this._mouseMoveDelegate)
            .bind('touchend.' + this.widgetName, this._mouseUpDelegate);

        _mouseInit.apply(this);
    };

    /**
     * Simple implementation of jQuery like getters/setters
     * var val = something();
     * something(val);
     */
    var setter = function (setter, getter) {
        return function (val) {
            if (arguments.length === 0) {
                return getter.apply(this);
            } else {
                setter.apply(this, arguments);
            }
        }
    };

    /**
     * Internet explorer rotates image relative left top corner, so we should
     * shift image when it's rotated.
     */
    var ieTransforms = {
        '0': {
            marginLeft: 0,
            marginTop: 0,
            filter: 'progid:DXImageTransform.Microsoft.Matrix(M11=1, M12=0, M21=0, M22=1, SizingMethod="auto expand")'
        },

        '90': {
            marginLeft: -1,
            marginTop: 1,
            filter: 'progid:DXImageTransform.Microsoft.Matrix(M11=0, M12=-1, M21=1, M22=0, SizingMethod="auto expand")'
        },

        '180': {
            marginLeft: 0,
            marginTop: 0,
            filter: 'progid:DXImageTransform.Microsoft.Matrix(M11=-1, M12=0, M21=0, M22=-1, SizingMethod="auto expand")'
        },

        '270': {
            marginLeft: -1,
            marginTop: 1,
            filter: 'progid:DXImageTransform.Microsoft.Matrix(M11=0, M12=1, M21=-1, M22=0, SizingMethod="auto expand")'
        }
    },
        // this test is the inversion of the css filters test from the modernizr project
        useIeTransforms = function () {
            var modElem = document.createElement('modernizr'),
                mStyle = modElem.style,
                omPrefixes = 'Webkit Moz O ms',
                domPrefixes = omPrefixes.toLowerCase().split(' '),
                props = ("transform" + ' ' + domPrefixes.join("Transform ") + "Transform").split(' ');
            /*using 'for' loop instead of 'for in' to avoid issues in IE8*/
            for (var i = 0; i < props.length; i++) {
                var prop = props[i];
                if (prop.indexOf("-") == -1 && mStyle[prop] !== undefined) {
                    return false;
                }
            }
            return true;
        }();

    $.widget("ui.iviewer", $.ui.mouse, {
        widgetEventPrefix: "iviewer",
        options: {
            /**
            * start zoom value for image, not used now
            * may be equal to "fit" to fit image into container or scale in %
            **/
            zoom: "fit",
            /**
            * base value to scale image
            **/
            zoom_base: 100,
            /**
            * maximum zoom
            **/
            zoom_max: 1000,
            /**
            * minimum zoom
            **/
            zoom_min: 20,
            /**
            * base of rate multiplier.
            * zoom is calculated by formula: zoom_base * zoom_delta^rate
            **/
            zoom_delta: 1.4,
            /**
            * whether the zoom should be animated.
            */
            zoom_animation: true,
            /**
            * if true plugin doesn't add its own controls
            **/
            ui_disabled: false,
            /**
             * If false mousewheel will be disabled
             */
            mousewheel: true,
            /**
            * if false, plugin doesn't bind resize event on window and this must
            * be handled manually
            **/
            update_on_resize: true,
            /**
            * whether to provide zoom on doubleclick functionality
            */
            zoom_on_dblclick: true,
            /**
            * if true the image will fill the container and the image will be distorted
            */
            fill_container: false,
            /**
            * event is triggered when zoom value is changed
            * @param int new zoom value
            * @return boolean if false zoom action is aborted
            **/
            onZoom: jQuery.noop,
            /**
            * event is triggered when zoom value is changed after image is set to the new dimensions
            * @param int new zoom value
            * @return boolean if false zoom action is aborted
            **/
            onAfterZoom: jQuery.noop,
            /**
            * event is fired on drag begin
            * @param object coords mouse coordinates on the image
            * @return boolean if false is returned, drag action is aborted
            **/
            onStartDrag: jQuery.noop,
            /**
            * event is fired on drag action
            * @param object coords mouse coordinates on the image
            **/
            onDrag: jQuery.noop,
            /**
            * event is fired on drag stop
            * @param object coords mouse coordinates on the image
            **/
            onStopDrag: jQuery.noop,
            /**
            * event is fired when mouse moves over image
            * @param object coords mouse coordinates on the image
            **/
            onMouseMove: jQuery.noop,
            /**
            * mouse click event
            * @param object coords mouse coordinates on the image
            **/
            onClick: jQuery.noop,
            /**
            * mouse double click event. If used will delay each click event.
            * If double click event was fired, clicks will not.
            *
            * @param object coords mouse coordinates on the image
            **/
            onDblClick: null,
            /**
            * event is fired when image starts to load
            */
            onStartLoad: null,
            /**
            * event is fired, when image is loaded and initially positioned
            */
            onFinishLoad: null,
            /**
            * event is fired when image load error occurs
            */
            onErrorLoad: null
        },

        _create: function () {
            var me = this;

            //drag variables
            this.dx = 0;
            this.dy = 0;

            /* object containing actual information about image
            *   @img_object.object - jquery img object
            *   @img_object.orig_{width|height} - original dimensions
            *   @img_object.display_{width|height} - actual dimensions
            */
            this.img_object = {};

            this.zoom_object = {}; //object to show zoom status

            this._angle = 0;

            this.current_zoom = this.options.zoom;

            if (this.options.src === null) {
                return;
            }

            this.container = this.element;

            this._updateContainerInfo();

            //init container
            this.container.css("overflow", "hidden");

            if (this.options.update_on_resize == true) {
                $(window).resize(function () {
                    me.update();
                });
            }

            this.img_object = new $.ui.iviewer.ImageObject(this.options.zoom_animation);

            if (this.options.mousewheel) {
                this.activateMouseWheel(this.options.mousewheel);
            }

            //bind doubleclick only if callback is not falsy
            var useDblClick = !!this.options.onDblClick || this.options.zoom_on_dblclick,
                dblClickTimer = null,
                clicksNumber = 0;

            //init object
            this.img_object.object()
                .prependTo(this.container);

            //all these tricks are needed to fire either click
            //or doubleclick events at the same time
            if (useDblClick) {
                this.img_object.object()
                    //bind mouse events
                    .click(function (e) {
                        clicksNumber++;
                        clearTimeout(dblClickTimer);

                        dblClickTimer = setTimeout(function () {
                            clicksNumber = 0;
                            me._click(e);
                        }, 300);
                    })
                    .dblclick(function (e) {
                        if (clicksNumber !== 2) return;

                        clearTimeout(dblClickTimer);
                        clicksNumber = 0;
                        me._dblclick(e);
                    });
            } else {
                this.img_object.object()
                    .click(function (e) { me._click(e); });
            }

            this.container.bind('mousemove.iviewer', function (ev) { me._handleMouseMove(ev); });

            this.loadImage(this.options.src);

            if (!this.options.ui_disabled) {
                this.createui();
            }
            this.controls = this.container.find('.iviewer_common') || {};
            this._mouseInit();
        },

        destroy: function () {
            $.Widget.prototype.destroy.call(this);
            this._mouseDestroy();
            this.img_object.object().remove();
            /*removing the controls on destroy*/
            this.controls.remove();
            this.container.off('.iviewer');
            this.container.css('overflow', ''); //cleanup styles on destroy
        },

        _updateContainerInfo: function () {
            this.options.height = this.container.height();
            this.options.width = this.container.width();
        },

        /**
         * Add or remove the mousewheel effect on the viewer
         * @param {boolean} isActive
         * Sample : $('#viewer').iviewer('activateMouseWheel', true);
         */
        activateMouseWheel: function (isActive) {
            // Remove all the previous event bind on the mousewheel
            this.container.unbind('mousewheel.iviewer');
            if (gesturesSupport) {
                this.img_object.object().unbind('touchstart').unbind('gesturechange.iviewer').unbind('gestureend.iviewer');
            }

            if (isActive) {
                var me = this;

                this.container.bind('mousewheel.iviewer', function (ev, delta) {
                    //this event is there instead of containing div, because
                    //at opera it triggers many times on div
                    var zoom = (delta > 0) ? 1 : -1,
                        container_offset = me.container.offset(),
                        mouse_pos = {
                            //jquery.mousewheel 3.1.0 uses strange MozMousePixelScroll event
                            //which is not being fixed by jQuery.Event
                            x: (ev.pageX || ev.originalEvent.pageX) - container_offset.left,
                            y: (ev.pageY || ev.originalEvent.pageX) - container_offset.top
                        };
                    me.zoom_by(zoom, mouse_pos);
                    return false;
                });

                if (gesturesSupport) {
                    var gestureThrottle = +new Date();
                    var originalScale, originalCenter;
                    this.img_object.object()
                        .bind('touchstart', function (ev) {
                            originalScale = me.current_zoom;
                            var touches = ev.originalEvent.touches,
                                container_offset;
                            if (touches.length == 2) {
                                container_offset = me.container.offset();
                                originalCenter = {
                                    x: (touches[0].pageX + touches[1].pageX) / 2 - container_offset.left,
                                    y: (touches[0].pageY + touches[1].pageY) / 2 - container_offset.top
                                };
                            } else {
                                originalCenter = null;
                            }
                        }).bind('gesturechange.iviewer', function (ev) {
                            //do not want to import throttle function from underscore
                            var d = +new Date();
                            if ((d - gestureThrottle) < 50) { return; }
                            gestureThrottle = d;
                            var zoom = originalScale * ev.originalEvent.scale;
                            me.set_zoom(zoom, originalCenter);
                            ev.preventDefault();
                        }).bind('gestureend.iviewer', function (ev) {
                            originalCenter = null;
                        });
                }
            }
        },

        update: function () {
            this._updateContainerInfo();
            this.setCoords(this.img_object.x(), this.img_object.y());
        },

        loadImage: function (src) {
            //debugger;
            this.current_zoom = this.options.zoom;
            var me = this;

            this._trigger('onStartLoad', 0, src);

            this.container.addClass("iviewer_loading");
            this.img_object.load(src, function () {
                me._fill_orig_dimensions = { width: me.img_object.orig_width(), height: me.img_object.orig_height() };
                me._imageLoaded(src);
            }, function () {
                alert('error');
                me._trigger("onErrorLoad", 0, src);
            });
        },

        _imageLoaded: function (src) {
            this.container.removeClass("iviewer_loading");
            this.container.addClass("iviewer_cursor");

            if (this.options.zoom == "fit") {
                this.fit(true);
            }
            else {
                this.set_zoom(this.options.zoom, true);
            }

            this._trigger('onFinishLoad', 0, src);

            if (this.options.fill_container) {
                this.fill_container(true);
            }
        },

        /**
        * fits image in the container
        *
        * @param {boolean} skip_animation
        **/
        fit: function (skip_animation) {
            var aspect_ratio = this.img_object.orig_width() / this.img_object.orig_height();
            var window_ratio = this.options.width / this.options.height;
            var choose_left = (aspect_ratio > window_ratio);
            var new_zoom = 0;

            if (choose_left) {
                new_zoom = this.options.width / this.img_object.orig_width() * 100;
            }
            else {
                new_zoom = this.options.height / this.img_object.orig_height() * 100;
            }
            loadFirstTime = true;
            this.set_zoom(new_zoom, skip_animation);
        },

        /**
        * center image in container
        **/
        center: function () {
            this.setCoords(-Math.round((this.img_object.display_width() - this.options.width) / 2),
                -Math.round((this.img_object.display_height() - this.options.height) / 2));
        },

        /**
        *   move a point in container to the center of display area
        *   @param x a point in container
        *   @param y a point in container
        **/
        moveTo: function (x, y) {
            var dx = x - Math.round(this.options.width / 2);
            var dy = y - Math.round(this.options.height / 2);

            var new_x = this.img_object.x() - dx;
            var new_y = this.img_object.y() - dy;

            this.setCoords(new_x, new_y);
        },

        /**
         * Get container offset object.
         */
        getContainerOffset: function () {
            return jQuery.extend({}, this.container.offset());
        },

        /**
        * set coordinates of upper left corner of image object
        **/
        setCoords: function (x, y) {
            //do nothing while image is being loaded
            if (!this.img_object.loaded()) { return; }

            var coords = this._correctCoords(x, y);
            this.img_object.x(coords.x);
            this.img_object.y(coords.y);
        },

        _correctCoords: function (x, y) {
            x = parseInt(x, 10);
            y = parseInt(y, 10);

            //check new coordinates to be correct (to be in rect)
            if (y > 0) {
                y = 0;
            }
            if (x > 0) {
                x = 0;
            }
            if (y + this.img_object.display_height() < this.options.height) {
                y = this.options.height - this.img_object.display_height();
            }
            if (x + this.img_object.display_width() < this.options.width) {
                x = this.options.width - this.img_object.display_width();
            }
            if (this.img_object.display_width() <= this.options.width) {
                x = -(this.img_object.display_width() - this.options.width) / 2;
            }
            if (this.img_object.display_height() <= this.options.height) {
                y = -(this.img_object.display_height() - this.options.height) / 2;
            }

            return { x: x, y: y };
        },


        /**
        * convert coordinates on the container to the coordinates on the image (in original size)
        *
        * @return object with fields x,y according to coordinates or false
        * if initial coords are not inside image
        **/
        containerToImage: function (x, y) {
            var coords = {
                x: x - this.img_object.x(),
                y: y - this.img_object.y()
            };

            coords = this.img_object.toOriginalCoords(coords);

            return {
                x: util.descaleValue(coords.x, this.current_zoom),
                y: util.descaleValue(coords.y, this.current_zoom)
            };
        },

        /**
        * convert coordinates on the image (in original size, and zero angle) to the coordinates on the container
        *
        * @return object with fields x,y according to coordinates
        **/
        imageToContainer: function (x, y) {
            var coords = {
                x: util.scaleValue(x, this.current_zoom),
                y: util.scaleValue(y, this.current_zoom)
            };

            return this.img_object.toRealCoords(coords);
        },

        /**
        * get mouse coordinates on the image
        * @param e - object containing pageX and pageY fields, e.g. mouse event object
        *
        * @return object with fields x,y according to coordinates or false
        * if initial coords are not inside image
        **/
        _getMouseCoords: function (e) {
            var containerOffset = this.container.offset(),
                coords = this.containerToImage(e.pageX - containerOffset.left, e.pageY - containerOffset.top);

            return coords;
        },

        /**
        * fills container entirely by distorting image
        *
        * @param {boolean} fill wether to fill the container entirely or not.
        **/
        fill_container: function (fill) {
            this.options.fill_container = fill;
            if (fill) {
                var ratio = this.options.width / this.options.height;
                if (ratio > 1)
                    this.img_object.orig_width(this.img_object.orig_height() * ratio);
                else
                    this.img_object.orig_height(this.img_object.orig_width() * ratio);
            }
            else {
                this.img_object.orig_width(this._fill_orig_dimensions.width);
                this.img_object.orig_height(this._fill_orig_dimensions.height);
            }
            this.set_zoom(this.current_zoom);
        },

        /**
        * set image scale to the new_zoom
        *
        * @param {number} new_zoom image scale in %
        * @param {boolean} skip_animation
        * @param {x: number, y: number} Coordinates of point the should not be moved on zoom. The default is the center of image.
        **/
        set_zoom: function (new_zoom, skip_animation, zoom_center) {
            if (this._trigger('onZoom', 0, new_zoom) == false) {
                return;
            }

            //do nothing while image is being loaded
            if (!this.img_object.loaded()) { return; }

            zoom_center = zoom_center || {
                x: Math.round(this.options.width / 2),
                y: Math.round(this.options.height / 2)
            };

            if (new_zoom < this.options.zoom_min) {
                new_zoom = this.options.zoom_min;
            }
            else if (new_zoom > this.options.zoom_max) {
                new_zoom = this.options.zoom_max;
            }

            /* we fake these values to make fit zoom properly work */
            var old_x, old_y;
            if (this.current_zoom == "fit") {
                old_x = zoom_center.x + Math.round(this.img_object.orig_width() / 2);
                old_y = zoom_center.y + Math.round(this.img_object.orig_height() / 2);
                this.current_zoom = 100;
            }
            else {
                old_x = -this.img_object.x() + zoom_center.x;
                old_y = -this.img_object.y() + zoom_center.y;
            }

            var new_width = util.scaleValue(this.img_object.orig_width(), new_zoom);
            var new_height = util.scaleValue(this.img_object.orig_height(), new_zoom);
            var new_x = util.scaleValue(util.descaleValue(old_x, this.current_zoom), new_zoom);
            var new_y = util.scaleValue(util.descaleValue(old_y, this.current_zoom), new_zoom);

            new_x = zoom_center.x - new_x;
            new_y = zoom_center.y - new_y;

            new_width = Math.floor(new_width);
            new_height = Math.floor(new_height);
            new_x = Math.floor(new_x);
            new_y = Math.floor(new_y);
            if (new_y < 0 && loadFirstTime) {
                new_y = 0;
            }
            loadFirstTime = false;
            this.img_object.display_width(new_width);
            this.img_object.display_height(new_height);

            var coords = this._correctCoords(new_x, new_y),
                self = this;

            this.img_object.setImageProps(new_width, new_height, coords.x, coords.y,
                skip_animation, function () {
                    self._trigger('onAfterZoom', 0, new_zoom);
                });
            this.current_zoom = new_zoom;

            this.update_status();
        },
        /**
         * shows or hides the controls
         * controls are shown/hidden based on user input
         * @param Boolean flag that specifies whether to show or hide the controls
         **/
        showControls: function (flag) {
            if (flag) {
                this.controls.fadeIn();
            } else {
                this.controls.fadeOut();
            }
        },
        /**
        * changes zoom scale by delta
        * zoom is calculated by formula: zoom_base * zoom_delta^rate
        * @param Integer delta number to add to the current multiplier rate number
        * @param {x: number, y: number=} Coordinates of point the should not be moved on zoom.
        **/
        zoom_by: function (delta, zoom_center) {
            var closest_rate = this.find_closest_zoom_rate(this.current_zoom);

            var next_rate = closest_rate + delta;
            var next_zoom = this.options.zoom_base * Math.pow(this.options.zoom_delta, next_rate);
            if (delta > 0 && next_zoom < this.current_zoom) {
                next_zoom *= this.options.zoom_delta;
            }

            if (delta < 0 && next_zoom > this.current_zoom) {
                next_zoom /= this.options.zoom_delta;
            }

            this.set_zoom(next_zoom, undefined, zoom_center);
        },

        /**
        * Rotate image
        * @param {num} deg Degrees amount to rotate. Positive values rotate image clockwise.
        *     Currently 0, 90, 180, 270 and -90, -180, -270 values are supported
        *
        * @param {boolean} abs If the flag is true if, the deg parameter will be considered as
        *     a absolute value and relative otherwise.
        * @return {num|null} Method will return current image angle if called without any arguments.
        **/
        angle: function (deg, abs) {
            if (arguments.length === 0) { return this.img_object.angle(); }

            if (deg < -270 || deg > 270 || deg % 90 !== 0) { return; }
            if (!abs) { deg += this.img_object.angle(); }
            if (deg < 0) { deg += 360; }
            if (deg >= 360) { deg -= 360; }

            if (deg === this.img_object.angle()) { return; }

            this.img_object.angle(deg);
            //the rotate behavior is different in all editors. For now we  just center the
            //image. However, it will be better to try to keep the position.
            this.center();
            this._trigger('angle', 0, { angle: this.img_object.angle() });
        },

        /**
        * finds closest multiplier rate for value
        * basing on zoom_base and zoom_delta values from settings
        * @param Number value zoom value to examine
        **/
        find_closest_zoom_rate: function (value) {
            if (value == this.options.zoom_base) {
                return 0;
            }

            function div(val1, val2) { return val1 / val2; };
            function mul(val1, val2) { return val1 * val2; };

            var func = (value > this.options.zoom_base) ? mul : div;
            var sgn = (value > this.options.zoom_base) ? 1 : -1;

            var mltplr = this.options.zoom_delta;
            var rate = 1;

            while (Math.abs(func(this.options.zoom_base, Math.pow(mltplr, rate)) - value) >
                Math.abs(func(this.options.zoom_base, Math.pow(mltplr, rate + 1)) - value)) {
                rate++;
            }

            return sgn * rate;
        },

        /* update scale info in the container */
        update_status: function () {
            //if (!this.options.ui_disabled) {
            var percent = Math.round(100 * this.img_object.display_height() / this.img_object.orig_height());
            if (percent) {
                this.zoom_object.html(percent + "%");
            }
            //}
        },

        /**
         * Get some information about the image.
         *     Currently orig_(width|height), display_(width|height), angle, zoom and src params are supported.
         *
         *  @param {string} parameter to check
         *  @param {boolean} withoutRotation if param is orig_width or orig_height and this flag is set to true,
         *      method will return original image width without considering rotation.
         *
         */
        info: function (param, withoutRotation) {
            if (!param) { return; }

            switch (param) {
                case 'orig_width':
                case 'orig_height':
                    if (withoutRotation) {
                        return (this.img_object.angle() % 180 === 0 ? this.img_object[param]() :
                            param === 'orig_width' ? this.img_object.orig_height() :
                                this.img_object.orig_width());
                    } else {
                        return this.img_object[param]();
                    }
                case 'display_width':
                case 'display_height':
                case 'angle':
                    return this.img_object[param]();
                case 'zoom':
                    return this.current_zoom;
                case 'options':
                    return this.options;
                case 'src':
                    return this.img_object.object().attr('src');
                case 'coords':
                    return {
                        x: this.img_object.x(),
                        y: this.img_object.y()
                    };
            }
        },

        /**
        *   callback for handling mousdown event to start dragging image
        **/
        _mouseStart: function (e) {
            $.ui.mouse.prototype._mouseStart.call(this, e);
            if (this._trigger('onStartDrag', 0, this._getMouseCoords(e)) === false) {
                return false;
            }

            /* start drag event*/
            this.container.addClass("iviewer_drag_cursor");

            //#10: fix movement quirks for ipad
            this._dragInitialized = !(e.originalEvent.changedTouches && e.originalEvent.changedTouches.length == 1);

            this.dx = e.pageX - this.img_object.x();
            this.dy = e.pageY - this.img_object.y();
            return true;
        },

        _mouseCapture: function (e) {
            return true;
        },

        /**
         * Handle mouse move if needed. User can avoid using this callback, because
         *    he can get the same information through public methods.
         *  @param {jQuery.Event} e
         */
        _handleMouseMove: function (e) {
            this._trigger('onMouseMove', e, this._getMouseCoords(e));
        },

        /**
        *   callback for handling mousemove event to drag image
        **/
        _mouseDrag: function (e) {
            $.ui.mouse.prototype._mouseDrag.call(this, e);

            //#10: imitate mouseStart, because we can get here without it on iPad for some reason
            if (!this._dragInitialized) {
                this.dx = e.pageX - this.img_object.x();
                this.dy = e.pageY - this.img_object.y();
                this._dragInitialized = true;
            }

            var ltop = e.pageY - this.dy;
            var lleft = e.pageX - this.dx;

            this.setCoords(lleft, ltop);
            this._trigger('onDrag', e, this._getMouseCoords(e));
            return false;
        },

        /**
        *   callback for handling stop drag
        **/
        _mouseStop: function (e) {
            $.ui.mouse.prototype._mouseStop.call(this, e);
            this.container.removeClass("iviewer_drag_cursor");
            this._trigger('onStopDrag', 0, this._getMouseCoords(e));
        },

        _click: function (e) {
            this._trigger('onClick', 0, this._getMouseCoords(e));
        },

        _dblclick: function (ev) {
            if (this.options.onDblClick) {
                this._trigger('onDblClick', 0, this._getMouseCoords(ev));
            }

            if (this.options.zoom_on_dblclick) {
                var container_offset = this.container.offset()
                    , mouse_pos = {
                        x: ev.pageX - container_offset.left,
                        y: ev.pageY - container_offset.top
                    };

                this.zoom_by(1, mouse_pos);
            }
        },

        /**
        *   create zoom buttons info box
        **/
        createui: function () {
            var me = this;

            $("<div>", { 'class': "iviewer_zoom_in iviewer_common iviewer_button", 'title': "Zoom In" })
                .bind('mousedown touchstart', function () { me.zoom_by(1); return false; })
                .appendTo(this.container);

            $("<div>", { 'class': "iviewer_zoom_out iviewer_common iviewer_button", 'title': "Zoom Out" })
                .bind('mousedown touchstart', function () { me.zoom_by(- 1); return false; })
                .appendTo(this.container);

            //$("<div>", { 'class': "iviewer_zoom_zero iviewer_common iviewer_button", 'title':"Reset"})
            //    .bind('mousedown touchstart', function () { me.set_zoom(100); return false; })
            //    .appendTo(this.container);

            $("<div>", { 'class': "iviewer_zoom_fit iviewer_common iviewer_button", 'title': "Reset" })
                .bind('mousedown touchstart', function () { me.fit(this); return false; })
                .appendTo(this.container);

            this.zoom_object = $("<div>").addClass("iviewer_zoom_status iviewer_common")
                .appendTo(this.container);

            $("<div>", { 'class': "iviewer_rotate_left iviewer_common iviewer_button", 'title': "Rotate Left" })
                .bind('mousedown touchstart', function () { me.angle(-90); return false; })
                .appendTo(this.container);

            $("<div>", { 'class': "iviewer_rotate_right iviewer_common iviewer_button", 'title': "Rotate Right" })
                .bind('mousedown touchstart', function () { me.angle(90); return false; })
                .appendTo(this.container);

            this.update_status(); //initial status update
        }

    });

    /**
     * @class $.ui.iviewer.ImageObject Class represents image and provides public api without
     *     extending image prototype.
     * @constructor
     * @param {boolean} do_anim Do we want to animate image on dimension changes?
     */
    $.ui.iviewer.ImageObject = function (do_anim) {
        this._img = $("<img>")
            //this is needed, because chromium sets them auto otherwise
            .css({ position: "absolute", top: "0px", left: "0px" });

        this._loaded = false;
        this._swapDimensions = false;
        this._do_anim = do_anim || false;
        this.x(0, true);
        this.y(0, true);
        this.angle(0);
    };


    /** @lends $.ui.iviewer.ImageObject.prototype */
    (function () {
        /**
         * Restore initial object state.
         *
         * @param {number} w Image width.
         * @param {number} h Image height.
         */
        this._reset = function (w, h) {
            this._angle = 0;
            this._swapDimensions = false;
            this.x(0);
            this.y(0);

            this.orig_width(w);
            this.orig_height(h);
            this.display_width(w);
            this.display_height(h);
        };

        /**
         * Check if image is loaded.
         *
         * @return {boolean}
         */
        this.loaded = function () { return this._loaded; };

        /**
         * Load image.
         *
         * @param {string} src Image url.
         * @param {Function=} loaded Function will be called on image load.
         */
        this.load = function (src, loaded, error) {
            var self = this;
            loaded = loaded || jQuery.noop;
            this._loaded = false;

            // #67: don't use image object for loading in case naturalWidth is supported
            // because later assigning to self._img[0] may result in additional image requesrts.
            var supportsNaturalWidth = 'naturalWidth' in new Image();
            var img = supportsNaturalWidth ? self._img[0] : new Image();

            img.onload = function () {
                self._loaded = true;
                if (supportsNaturalWidth) {
                    self._reset(this.naturalWidth, this.naturalHeight);
                } else {
                    self._reset(this.width, this.height);
                }

                self._img
                    .removeAttr("width")
                    .removeAttr("height")
                    .removeAttr("style")
                    //max-width is reset, because plugin breaks in the twitter bootstrap otherwise
                    .css({ position: "absolute", top: "0px", left: "0px", maxWidth: "none" });

                if (!supportsNaturalWidth) {
                    self._img[0].src = src;
                }

                loaded();
            };
            img.onerror = error;

            //we need this because sometimes internet explorer 8 fires onload event
            //right after assignment (synchronously)
            setTimeout(function () {
                img.src = src;
            }, 50);
            this.angle(0);
        };
        this._dimension = function (prefix, name) {
            var horiz = '_' + prefix + '_' + name,
                vert = '_' + prefix + '_' + (name === 'height' ? 'width' : 'height');
            return setter(function (val) {
                this[this._swapDimensions ? horiz : vert] = val;
            },
                function () {
                    return this[this._swapDimensions ? horiz : vert];
                });
        };

        /**
         * Getters and setter for common image dimensions.
         *    display_ means real image tag dimensions
         *    orig_ means physical image dimensions.
         *  Note, that dimensions are swapped if image is rotated. It necessary,
         *  because as little as possible code should know about rotation.
         */
        this.display_width = this._dimension('display', 'width'),
            this.display_height = this._dimension('display', 'height'),
            this.display_diff = function () { return Math.floor(this.display_width() - this.display_height()); };
        this.orig_width = this._dimension('orig', 'width'),
            this.orig_height = this._dimension('orig', 'height'),

            /**
             * Setter for  X coordinate. If image is rotated we need to additionaly shift an
             *     image to map image coordinate to the visual position.
             *
             * @param {number} val Coordinate value.
             * @param {boolean} skipCss If true, we only set the value and do not touch the dom.
             */
            this.x = setter(function (val, skipCss) {
                this._x = val;
                if (!skipCss) {
                    this._finishAnimation();
                    this._img.css("left", this._x + (this._swapDimensions ? this.display_diff() / 2 : 0) + "px");
                }
            },
                function () {
                    return this._x;
                });

        /**
         * Setter for  Y coordinate. If image is rotated we need to additionaly shift an
         *     image to map image coordinate to the visual position.
         *
         * @param {number} val Coordinate value.
         * @param {boolean} skipCss If true, we only set the value and do not touch the dom.
         */
        this.y = setter(function (val, skipCss) {
            this._y = val;
            if (!skipCss) {
                this._finishAnimation();
                this._img.css("top", this._y - (this._swapDimensions ? this.display_diff() / 2 : 0) + "px");
            }
        },
            function () {
                return this._y;
            });

        /**
         * Perform image rotation.
         *
         * @param {number} deg Absolute image angle. The method will work with values 0, 90, 180, 270 degrees.
         */
        this.angle = setter(function (deg) {
            var prevSwap = this._swapDimensions;

            this._angle = deg;
            this._swapDimensions = deg % 180 !== 0;

            if (prevSwap !== this._swapDimensions) {
                var verticalMod = this._swapDimensions ? -1 : 1;
                this.x(this.x() - verticalMod * this.display_diff() / 2, true);
                this.y(this.y() + verticalMod * this.display_diff() / 2, true);
            };

            var cssVal = 'rotate(' + deg + 'deg)',
                img = this._img;

            jQuery.each(['', '-webkit-', '-moz-', '-o-', '-ms-'], function (i, prefix) {
                img.css(prefix + 'transform', cssVal);
            });

            if (useIeTransforms) {
                jQuery.each(['-ms-', ''], function (i, prefix) {
                    img.css(prefix + 'filter', ieTransforms[deg].filter);
                });

                img.css({
                    marginLeft: ieTransforms[deg].marginLeft * this.display_diff() / 2,
                    marginTop: ieTransforms[deg].marginTop * this.display_diff() / 2
                });
            }
        },
            function () { return this._angle; });

        /**
         * Map point in the container coordinates to the point in image coordinates.
         *     You will get coordinates of point on image with respect to rotation,
         *     but will be set as if image was not rotated.
         *     So, if image was rotated 90 degrees, it's (0,0) point will be on the
         *     top right corner.
         *
         * @param {{x: number, y: number}} point Point in container coordinates.
         * @return  {{x: number, y: number}}
         */
        this.toOriginalCoords = function (point) {
            switch (this.angle()) {
                case 0: return { x: point.x, y: point.y };
                case 90: return { x: point.y, y: this.display_width() - point.x };
                case 180: return { x: this.display_width() - point.x, y: this.display_height() - point.y };
                case 270: return { x: this.display_height() - point.y, y: point.x };
            }
        };

        /**
         * Map point in the image coordinates to the point in container coordinates.
         *     You will get coordinates of point on container with respect to rotation.
         *     Note, if image was rotated 90 degrees, it's (0,0) point will be on the
         *     top right corner.
         *
         * @param {{x: number, y: number}} point Point in container coordinates.
         * @return  {{x: number, y: number}}
         */
        this.toRealCoords = function (point) {
            switch (this.angle()) {
                case 0: return { x: this.x() + point.x, y: this.y() + point.y };
                case 90: return { x: this.x() + this.display_width() - point.y, y: this.y() + point.x };
                case 180: return { x: this.x() + this.display_width() - point.x, y: this.y() + this.display_height() - point.y };
                case 270: return { x: this.x() + point.y, y: this.y() + this.display_height() - point.x };
            }
        };

        /**
         * @return {jQuery} Return image node. this is needed to add event handlers.
         */
        this.object = setter(jQuery.noop,
            function () { return this._img; });

        /**
         * Change image properties.
         *
         * @param {number} disp_w Display width;
         * @param {number} disp_h Display height;
         * @param {number} x
         * @param {number} y
         * @param {boolean} skip_animation If true, the animation will be skiped despite the
         *     value set in constructor.
         * @param {Function=} complete Call back will be fired when zoom will be complete.
         */
        this.setImageProps = function (disp_w, disp_h, x, y, skip_animation, complete) {
            complete = complete || jQuery.noop;

            this.display_width(disp_w);
            this.display_height(disp_h);
            this.x(x, true);
            this.y(y, true);

            var w = this._swapDimensions ? disp_h : disp_w;
            var h = this._swapDimensions ? disp_w : disp_h;

            var params = {
                width: w,
                height: h,
                top: y - (this._swapDimensions ? this.display_diff() / 2 : 0) + "px",
                left: x + (this._swapDimensions ? this.display_diff() / 2 : 0) + "px"
            };

            if (useIeTransforms) {
                jQuery.extend(params, {
                    marginLeft: ieTransforms[this.angle()].marginLeft * this.display_diff() / 2,
                    marginTop: ieTransforms[this.angle()].marginTop * this.display_diff() / 2
                });
            }

            var swapDims = this._swapDimensions,
                img = this._img;

            //here we come: another IE oddness. If image is rotated 90 degrees with a filter, than
            //width and height getters return real width and height of rotated image. The bad news
            //is that to set height you need to set a width and vice versa. Fuck IE.
            //So, in this case we have to animate width and height manually.
            if (useIeTransforms && swapDims) {
                var ieh = this._img.width(),
                    iew = this._img.height(),
                    iedh = params.height - ieh;
                iedw = params.width - iew;

                delete params.width;
                delete params.height;
            }

            if (this._do_anim && !skip_animation) {
                this._img.stop(true)
                    .animate(params, {
                        duration: 200,
                        complete: complete,
                        step: function (now, fx) {
                            if (useIeTransforms && swapDims && (fx.prop === 'top')) {
                                var percent = (now - fx.start) / (fx.end - fx.start);

                                img.height(ieh + iedh * percent);
                                img.width(iew + iedw * percent);
                                img.css('top', now);
                            }
                        }
                    });
            } else {
                this._img.css(params);
                setTimeout(complete, 0); //both if branches should behave equally.
            }
        };

        //if we set image coordinates we need to be sure that no animation is active atm
        this._finishAnimation = function () {
            this._img.stop(true, true);
        };

    }).apply($.ui.iviewer.ImageObject.prototype);



    var util = {
        scaleValue: function (value, toZoom) {
            return value * toZoom / 100;
        },

        descaleValue: function (value, fromZoom) {
            return value * 100 / fromZoom;
        }
    };

})(jQuery, undefined);

var $ = jQuery;
(function (ng) {
    'use strict';
    var module = ng.module('lrDragNDrop', []);
    module.service('lrDragStore', ['$document', function (document) {
        var store = {};
        this.hold = function hold(key, item, collectionFrom, safe) {
            store[key] = {
                item: item,
                collection: collectionFrom,
                safe: safe === true
            }
        };
        this.get = function (namespace) {
            var modelItem = store[namespace],
                itemIndex;
            if (modelItem) {
                itemIndex = modelItem.collection.indexOf(modelItem.item);
                return modelItem.safe === true ? modelItem.item : modelItem.collection.splice(itemIndex, 1)[0];
            } else {
                return null;
            }
        };
        this.clean = function clean() {
            store = {};
        };
        this.isHolding = function (namespace) {
            return store[namespace] !== undefined;
        };
        document.bind('dragend', this.clean);
    }]);

    function parseRepeater(scope, attr) {
        var repeatExpression = attr.ngRepeat, match;
        if (!repeatExpression) {
            throw Error('this directive must be used with ngRepeat directive');
        }
        match = repeatExpression.match(/^(.*\sin).(\S*)/);
        if (!match) {
            throw Error("Expected ngRepeat in form of '_item_ in _collection_' but got '" + repeatExpression + "'.");
        }
        return scope.$eval(match[2]);
    }

    function lrDragSrcDirective(store, safe) {
        return function compileFunc(el, iattr) {
            iattr.$set('draggable', true);
            return function linkFunc(scope, element, attr) {
                var collection,
                    key = (safe === true ? attr.lrDragSrcSafe : attr.lrDragSrc) || 'temp';
                collection = parseRepeater(scope, attr);
                element.bind('dragstart', function (evt) {
                    store.hold(key, collection[scope.$index], collection, safe);
                });
            }
        }
    }

    module.directive('lrDragSrc', ['lrDragStore', function (store) {
        return {
            compile: lrDragSrcDirective(store)
        };
    }]);

    module.directive('lrDragSrcSafe', ['lrDragStore', function (store) {
        return {
            compile: lrDragSrcDirective(store, true)
        };
    }]);

    module.directive('lrDropTarget', ['lrDragStore', '$parse', function (store, $parse) {
        return {
            link: function (scope, element, attr) {
                var collection,
                    key = attr.lrDropTarget || 'temp',
                    classCache = null;
                function isAfter(x, y) {
                    //check if below or over the diagonal of the box element
                    return (element[0].offsetHeight - x * element[0].offsetHeight / element[0].offsetWidth) < y;
                }
                function resetStyle() {
                    if (classCache !== null) {
                        element.removeClass(classCache);
                        classCache = null;
                    }
                }
                collection = parseRepeater(scope, attr);
                element.bind('drop', function (evt) {
                    var collectionCopy = ng.copy(collection),
                        item = store.get(key),
                        dropIndex, i, l;
                    if (item !== null) {
                        dropIndex = scope.$index;
                        dropIndex = isAfter(evt.offsetX, evt.offsetY) ? dropIndex + 1 : dropIndex;
                        //srcCollection=targetCollection => we may need to apply a correction
                        if (collectionCopy.length > collection.length) {
                            for (i = 0, l = Math.min(dropIndex, collection.length - 1); i <= l; i++) {
                                if (!ng.equals(collectionCopy[i], collection[i])) {
                                    dropIndex = dropIndex - 1;
                                    break;
                                }
                            }
                        }
                        scope.$apply(function () {
                            collection.splice(dropIndex, 0, item);
                            var fn = $parse(attr.lrDropSuccess) || ng.noop;
                            fn(scope, { e: evt, item: item, collection: collection });
                        });
                        evt.preventDefault();
                        resetStyle();
                        store.clean();
                    }
                });
                element.bind('dragleave', resetStyle);
                element.bind('dragover', function (evt) {
                    var className;
                    if (store.isHolding(key)) {
                        className = isAfter(evt.offsetX, evt.offsetY) ? 'lr-drop-target-after' : 'lr-drop-target-before';
                        if (classCache !== className && classCache !== null) {
                            element.removeClass(classCache);
                        }
                        if (classCache !== className) {
                            element.addClass(className);
                        }
                        classCache = className;
                    }
                    evt.preventDefault();
                });
            }
        };
    }]);
})(angular);
angular.module('smart-table')
    .directive('stPaginationScroll', ['$timeout', function (timeout) {
        return{
            require: 'stTable',
            link: function (scope, element, attr, ctrl) {
                var itemByPage = 20;
                var pagination = ctrl.tableState().pagination;
                var lengthThreshold = 50;
                var timeThreshold = 400;
                var handler = function () {
                    //call next page
                    ctrl.slice(pagination.start + itemByPage, itemByPage);
                };
                var promise = null;
                var lastRemaining = 9999;
                var container = angular.element(element.parent());

                container.bind('scroll', function () {
                    var remaining = container[0].scrollHeight - (container[0].clientHeight + container[0].scrollTop);

                    //if we have reached the threshold and we scroll down
                    if (remaining < lengthThreshold && (remaining - lastRemaining) < 0) {

                        //if there is already a timer running which has no expired yet we have to cancel it and restart the timer
                        if (promise !== null) {
                            timeout.cancel(promise);
                        }
                        promise = timeout(function () {
                            handler();

                            //scroll a bit up
                            container[0].scrollTop -= 500;

                            promise = null;
                        }, timeThreshold);
                    }
                    lastRemaining = remaining;
                });
            }

        };
    }]);

/* ng-infinite-scroll - v1.0.0 - 2013-02-23 */
var mod;

mod = angular.module('infinite-scroll', []);

mod.directive('infiniteScroll', [
  '$rootScope', '$window', '$timeout', function($rootScope, $window, $timeout) {
    return {
      link: function(scope, elem, attrs) {
        var checkWhenEnabled, handler, scrollDistance, scrollEnabled;
        $window = angular.element($window);
        scrollDistance = 0;
        if (attrs.infiniteScrollDistance != null) {
          scope.$watch(attrs.infiniteScrollDistance, function(value) {
            return scrollDistance = parseInt(value, 10);
          });
        }
        scrollEnabled = true;
        checkWhenEnabled = false;
        if (attrs.infiniteScrollDisabled != null) {
          scope.$watch(attrs.infiniteScrollDisabled, function(value) {
            scrollEnabled = !value;
            if (scrollEnabled && checkWhenEnabled) {
              checkWhenEnabled = false;
              return handler();
            }
          });
        }
        handler = function() {
          var elementBottom, remaining, shouldScroll, windowBottom;
          windowBottom = $window.height() + $window.scrollTop();
          elementBottom = elem.offset().top + elem.height();
          remaining = elementBottom - windowBottom;
          shouldScroll = remaining <= $window.height() * scrollDistance;
          if (shouldScroll && scrollEnabled) {
            if ($rootScope.$$phase) {
              return scope.$eval(attrs.infiniteScroll);
            } else {
              return scope.$apply(attrs.infiniteScroll);
            }
          } else if (shouldScroll) {
            return checkWhenEnabled = true;
          }
        };
        $window.on('scroll', handler);
        scope.$on('$destroy', function() {
          return $window.off('scroll', handler);
        });
        return $timeout((function() {
          if (attrs.infiniteScrollImmediateCheck) {
            if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
              return handler();
            }
          } else {
            return handler();
          }
        }), 0);
      }
    };
  }
]);
/*! ngTable v1.0.0 by Vitalii Savchuk(esvit666@gmail.com) - https://github.com/esvit/ng-table - New BSD License */

!function(a,b){"use strict";return"function"==typeof define&&define.amd?void define(["angular"],function(a){return b(a)}):b(a)}(window.angular||null,function(a){"use strict";return function(){a.module("ngTable",[])}(),function(){a.module("ngTable").value("ngTableDefaults",{params:{},settings:{}})}(),function(){function b(b){function c(b,c){var f=b.charAt(0).toUpperCase()+b.substring(1),g={};return g["on"+f]=d(b),g["publish"+f]=e(b),a.extend(c,g)}function d(c){return function(d){var e=a.identity,g=b;if(2===arguments.length?a.isFunction(arguments[1].$new)?g=arguments[1]:e=arguments[1]:arguments.length>2&&(g=arguments[1],e=arguments[2]),a.isObject(e)){var h=e;e=function(a){return a===h}}return g.$on("ngTable:"+c,function(a,b){if(!b.isNullInstance){var c=f(arguments,2),g=[b].concat(c);e.apply(this,g)&&d.apply(this,g)}})}}function e(a){return function(){var c=["ngTable:"+a].concat(Array.prototype.slice.call(arguments));b.$broadcast.apply(b,c)}}function f(a,b){return Array.prototype.slice.call(a,null==b?1:b)}var g={};return g=c("afterCreated",g),g=c("afterReloadData",g),g=c("datasetChanged",g),g=c("pagesChanged",g)}a.module("ngTable").factory("ngTableEventsChannel",b),b.$inject=["$rootScope"]}(),function(){function b(){function b(){c()}function c(){f=g}function d(b){var c=a.extend({},f,b);c.aliasUrls=a.extend({},f.aliasUrls,b.aliasUrls),f=c}function e(){function b(b,c){return a.isObject(b)&&(b=b.id),-1!==b.indexOf("/")?b:e.getUrlForAlias(b,c)}function c(a){return f.aliasUrls[a]||f.defaultBaseUrl+a+f.defaultExt}var d,e={config:d,getTemplateUrl:b,getUrlForAlias:c};return Object.defineProperty(e,"config",{get:function(){return d=d||a.copy(f)},enumerable:!0}),e}var f,g={defaultBaseUrl:"ng-table/filters/",defaultExt:".html",aliasUrls:{}};this.$get=e,this.resetConfigs=c,this.setConfig=d,b(),e.$inject=[]}a.module("ngTable").provider("ngTableFilterConfig",b),b.$inject=[]}(),function(){function b(){function b(b){function d(d){var e=d.settings().filterOptions;return a.isFunction(e.filterFn)?e.filterFn:b(e.filterFilterName||c.filterFilterName)}function e(){return b(c.sortingFilterName)}function f(a,b){if(!b.hasFilter())return a;var c=b.filter(!0),e=Object.keys(c),f=e.reduce(function(a,b){return a=j(a,c[b],b)},{}),g=d(b);return g.call(b,a,f,b.settings().filterOptions.filterComparator)}function g(a,b){var c=a.slice((b.page()-1)*b.count(),b.page()*b.count());return b.total(a.length),c}function h(a,b){var c=b.orderBy(),d=e(b);return c.length?d(a,c):a}function i(b,c){if(null==b)return[];var d=a.extend({},k,c.settings().dataOptions),e=d.applyFilter?f(b,c):b,i=d.applySort?h(e,c):e;return d.applyPaging?g(i,c):i}function j(a,b,c){var d=c.split("."),e=a,f=d[d.length-1],g=e,h=d.slice(0,d.length-1);return h.forEach(function(a){g.hasOwnProperty(a)||(g[a]={}),g=g[a]}),g[f]=b,e}var k={applyFilter:!0,applySort:!0,applyPaging:!0};return i.applyPaging=g,i.getFilterFn=d,i.getOrderByFn=e,i}var c=this;c.$get=b,c.filterFilterName="filter",c.sortingFilterName="orderBy",b.$inject=["$filter"]}a.module("ngTable").provider("ngTableDefaultGetData",b),b.$inject=[]}(),function(){a.module("ngTable").factory("ngTableColumn",[function(){function b(b,d,f){var g=Object.create(b),h=c();for(var i in h)void 0===g[i]&&(g[i]=h[i]),a.isFunction(g[i])||!function(a){var c=function d(){return 1!==arguments.length||e(arguments[0])?b[a]:void d.assign(null,arguments[0])};c.assign=function(c,d){b[a]=d},g[a]=c}(i),function(c){var h=g[c];g[c]=function(){if(1!==arguments.length||e(arguments[0])){var c=arguments[0]||d,i=Object.create(c);return a.extend(i,{$column:g,$columns:f}),h.call(b,i)}h.assign(null,arguments[0])},h.assign&&(g[c].assign=h.assign)}(i);return g}function c(){return{"class":d(""),filter:d(!1),groupable:d(!1),filterData:a.noop,headerTemplateURL:d(!1),headerTitle:d(""),sortable:d(!1),show:d(!0),title:d(""),titleAlt:d("")}}function d(a){var b=a,c=function d(){return 1!==arguments.length||e(arguments[0])?b:void d.assign(null,arguments[0])};return c.assign=function(a,c){b=c},c}function e(b){return null!=b&&a.isFunction(b.$new)}return{buildColumn:b}}])}(),function(){a.module("ngTable").factory("NgTableParams",["$q","$log","$filter","ngTableDefaults","ngTableDefaultGetData","ngTableEventsChannel",function(b,c,d,e,f,g){var h=function(a){return!isNaN(parseFloat(a))&&isFinite(a)},i=function(d,i){function j(b){var c=A.groupOptions&&A.groupOptions.defaultSort;if(a.isFunction(b))return null==b.sortDirection&&(b.sortDirection=c),b;if(a.isString(b)){var d={};return d[b]=c,d}if(a.isObject(b)){for(var e in b)null==b[e]&&(b[e]=c);return b}return b}function k(a){var b=[];for(var c in a)b.push(("asc"===a[c]?"+":"-")+c);return b}function l(){var b={params:z};return a.isFunction(z.group)&&(b.groupSortDirection=z.group.sortDirection),b}function m(){var b=z.filter&&z.filter.$,c=q&&q.params.filter&&q.params.filter.$;return!a.equals(b,c)}function n(){A.filterOptions.filterDelay===w.filterDelay&&A.total<=A.filterOptions.filterDelayThreshold&&A.getData===y.getData&&(A.filterOptions.filterDelay=0)}function o(a){var c=A.interceptors||[];return c.reduce(function(a,c){var d=c.response&&c.response.bind(c)||b.when,e=c.responseError&&c.responseError.bind(c)||b.reject;return a.then(function(a){return d(a,s)},function(a){return e(a,s)})},a)}function p(){function c(a){return f(a.settings().dataset,a)}function d(c){var d,g=c.group(),h=void 0;if(a.isFunction(g))d=g,h=g.sortDirection;else{var i=Object.keys(g)[0];h=g[i],d=function(a){return e(a,i)}}var j=c.settings(),l=j.dataOptions;j.dataOptions={applyPaging:!1};var m=b.when(j.getData(c));return m.then(function(b){var e={};a.forEach(b,function(a){var b=d(a);e[b]=e[b]||{data:[],$hideRows:!j.groupOptions.isExpanded,value:b},e[b].data.push(a)});var g=[];for(var i in e)g.push(e[i]);if(h){var l=f.getOrderByFn(),m=k({value:h});g=l(g,m)}return f.applyPaging(g,c)})["finally"](function(){j.dataOptions=l})}function e(a,b){return"string"==typeof b&&(b=b.split(".")),void 0===a?void 0:0===b.length?a:null===a?void 0:e(a[b[0]],b.slice(1))}return{getData:c,getGroups:d}}"boolean"==typeof d&&(this.isNullInstance=!0);var q,r,s=this,t=!1,u=[],v=function(){A.debugMode&&c.debug&&c.debug.apply(c,arguments)},w={filterComparator:void 0,filterDelay:500,filterDelayThreshold:1e4,filterFilterName:void 0,filterFn:void 0,filterLayout:"stack"},x={defaultSort:"asc",isExpanded:!0},y=p();this.data=[],this.parameters=function(b,c){if(c=c||!1,a.isDefined(b)){for(var d in b){var e=b[d];if(c&&d.indexOf("[")>=0){for(var f=d.split(/\[(.*)\]/).reverse(),g="",i=0,k=f.length;k>i;i++){var l=f[i];if(""!==l){var m=e;e={},e[g=l]=h(m)?parseFloat(m):m}}"sorting"===g&&(z[g]={}),z[g]=a.extend(z[g]||{},e[g])}else z[d]="group"===d?j(b[d]):h(b[d])?parseFloat(b[d]):b[d]}return v("ngTable: set parameters",z),this}return z},this.settings=function(b){if(a.isDefined(b)){b.filterOptions&&(b.filterOptions=a.extend({},A.filterOptions,b.filterOptions)),b.groupOptions&&(b.groupOptions=a.extend({},A.groupOptions,b.groupOptions)),a.isArray(b.dataset)&&(b.total=b.dataset.length);var c=A.dataset;A=a.extend(A,b),a.isArray(b.dataset)&&n();var d=b.hasOwnProperty("dataset")&&b.dataset!=c;if(d){t&&this.page(1),t=!1;var e=function(){g.publishDatasetChanged(s,b.dataset,c)};u?u.push(e):e()}return v("ngTable: set settings",A),this}return A},this.page=function(b){return a.isDefined(b)?this.parameters({page:b}):z.page},this.total=function(b){return a.isDefined(b)?this.settings({total:b}):A.total},this.count=function(b){return a.isDefined(b)?this.parameters({count:b,page:1}):z.count},this.filter=function(b){if(a.isDefined(b)&&a.isObject(b))return this.parameters({filter:b,page:1});if(b===!0){for(var c=Object.keys(z.filter),d={},e=0;e<c.length;e++){var f=z.filter[c[e]];null!=f&&""!==f&&(d[c[e]]=f)}return d}return z.filter},this.group=function(b,c){if(!a.isDefined(b))return z.group;var d={page:1};if(a.isFunction(b)&&a.isDefined(c))b.sortDirection=c,d.group=b;else if(a.isDefined(b)&&a.isDefined(c)){var e={};e[b]=c,d.group=e}else d.group=b;return this.parameters(d),this},this.sorting=function(b){if(2==arguments.length){var c={};return c[b]=arguments[1],this.parameters({sorting:c}),this}return a.isDefined(b)?this.parameters({sorting:b}):z.sorting},this.isSortBy=function(b,c){return void 0!==c?a.isDefined(z.sorting[b])&&z.sorting[b]==c:a.isDefined(z.sorting[b])},this.orderBy=function(){return k(z.sorting)},this.generatePagesArray=function(a,b,c,d){arguments.length||(a=this.page(),b=this.total(),c=this.count());var e,f,g,h,i;if(d=d&&6>d?6:d,i=[],h=Math.ceil(b/c),h>1){i.push({type:"prev",number:Math.max(1,a-1),active:a>1}),i.push({type:"first",number:1,active:a>1,current:1===a}),f=Math.round((A.paginationMaxBlocks-A.paginationMinBlocks)/2),g=Math.max(2,a-f),e=Math.min(h-1,a+2*f-(a-g)),g=Math.max(2,g-(2*f-(e-g)));for(var j=g;e>=j;)i.push(j===g&&2!==j||j===e&&j!==h-1?{type:"more",active:!1}:{type:"page",number:j,active:a!==j,current:a===j}),j++;i.push({type:"last",number:h,active:a!==h,current:a===h}),i.push({type:"next",number:Math.min(h,a+1),active:h>a})}return i},this.isDataReloadRequired=function(){return!t||!a.equals(l(),q)||m()},this.hasFilter=function(){return Object.keys(this.filter(!0)).length>0},this.hasGroup=function(b,c){return null==b?a.isFunction(z.group)||Object.keys(z.group).length>0:a.isFunction(b)?null==c?z.group===b:z.group===b&&b.sortDirection===c:null==c?-1!==Object.keys(z.group).indexOf(b):z.group[b]===c},this.hasFilterChanges=function(){var b=q&&q.params.filter;return!a.equals(z.filter,b)||m()},this.url=function(b){function c(a,c){b?e.push(c+"="+encodeURIComponent(a)):e[c]=encodeURIComponent(a)}function d(b,c){return"group"===c?!0:a.isDefined(b)&&""!==b}b=b||!1;var e=b?[]:{};for(var f in z)if(z.hasOwnProperty(f)){var g=z[f],h=encodeURIComponent(f);if("object"==typeof g){for(var i in g)if(d(g[i],f)){var j=h+"["+encodeURIComponent(i)+"]";c(g[i],j)}}else!a.isFunction(g)&&d(g,f)&&c(g,h)}return e},this.reload=function(){var c=this,d=null;A.$loading=!0,q=a.copy(l()),t=!0,d=o(c.hasGroup()?b.when(A.getGroups(c)):b.when(A.getData(c))),v("ngTable: reload data");var e=c.data;return d.then(function(a){return A.$loading=!1,r=null,c.data=a,g.publishAfterReloadData(c,a,e),c.reloadPages(),a})["catch"](function(a){return r=q,b.reject(a)})},this.hasErrorState=function(){return!(!r||!a.equals(r,l()))},this.reloadPages=function(){var b;return function(){var c=b,d=s.generatePagesArray(s.page(),s.total(),s.count());a.equals(c,d)||(b=d,g.publishPagesChanged(this,d,c))}}();var z={page:1,count:10,filter:{},sorting:{},group:{}};a.extend(z,e.params);var A={$loading:!1,dataset:null,total:0,defaultSort:"desc",filterOptions:a.copy(w),groupOptions:a.copy(x),counts:[10,25,50,100],interceptors:[],paginationMaxBlocks:11,paginationMinBlocks:5,sortingIndicator:"span"};return this.settings(y),this.settings(e.settings),this.settings(i),this.parameters(d,!0),g.publishAfterCreated(this),a.forEach(u,function(a){a()}),u=null,this};return i}])}(),function(){a.module("ngTable").controller("ngTableController",["$scope","NgTableParams","$timeout","$parse","$compile","$attrs","$element","ngTableColumn","ngTableEventsChannel",function(b,c,d,e,f,g,h,i,j){function k(a){if(a&&!b.params.hasErrorState()){b.params.settings().$scope=b;var c=b.params,d=c.settings().filterOptions;if(c.hasFilterChanges()){var e=function(){c.page(1),c.reload()};d.filterDelay?r(e,d.filterDelay):e()}else c.reload()}}function l(){g.showFilter?b.$parent.$watch(g.showFilter,function(a){b.show_filter=a}):b.$watch(o,function(a){b.show_filter=a}),g.disableFilter&&b.$parent.$watch(g.disableFilter,function(a){b.$filterRow.disabled=a})}function m(){if(b.$groupRow={},g.showGroup){var a=e(g.showGroup);b.$parent.$watch(a,function(a){b.$groupRow.show=a}),a.assign&&b.$watch("$groupRow.show",function(c){a.assign(b.$parent,c)})}else b.$watch("params.hasGroup()",function(a){b.$groupRow.show=a})}function n(){return(b.$columns||[]).filter(function(a){return a.show(b)})}function o(){return b.$columns?p(b.$columns,function(a){return a.show(b)&&a.filter(b)}):!1}function p(a,b){for(var c=!1,d=0;d<a.length;d++){var e=a[d];if(b(e)){c=!0;break}}return c}function q(){function a(a,c){var d=n();a.hasGroup()?(b.$groups=c||[],b.$groups.visibleColumnCount=d.length):(b.$data=c||[],b.$data.visibleColumnCount=d.length)}function c(a,c){b.pages=c}function d(a){return b.params===a}j.onAfterReloadData(a,b,d),j.onPagesChanged(c,b,d)}b.$filterRow={},b.$loading=!1,b.hasOwnProperty("params")||(b.params=new c(!0)),b.params.settings().$scope=b;var r=function(){var a=0;return function(b,c){d.cancel(a),a=d(b,c)}}();b.$watch("params",function(a,b){a!==b&&a&&a.reload()},!1),b.$watch("params.isDataReloadRequired()",k),this.compileDirectiveTemplates=function(){if(!h.hasClass("ng-table")){b.templates={header:g.templateHeader?g.templateHeader:"ng-table/header.html",pagination:g.templatePagination?g.templatePagination:"ng-table/pager.html"},h.addClass("ng-table");var c=null,d=!1;a.forEach(h.children(),function(a){"THEAD"===a.tagName&&(d=!0)}),d||(c=a.element(document.createElement("thead")).attr("ng-include","templates.header"),h.prepend(c));var e=a.element(document.createElement("div")).attr({"ng-table-pagination":"params","template-url":"templates.pagination"});h.after(e),c&&f(c)(b),f(e)(b)}},this.loadFilterData=function(c){a.forEach(c,function(c){var d;if(d=c.filterData(b),!d)return void delete c.filterData;if(a.isObject(d)&&(a.isObject(d.promise)||a.isFunction(d.then))){var e=a.isFunction(d.then)?d:d.promise;return delete c.filterData,e.then(function(b){a.isArray(b)||a.isFunction(b)||a.isObject(b)||(b=[]),c.data=b})}return c.data=d})},this.buildColumns=function(a){var c=[];return(a||[]).forEach(function(a){c.push(i.buildColumn(a,b,c))}),c},this.parseNgTableDynamicExpr=function(a){if(!a||a.indexOf(" with ")>-1){var b=a.split(/\s+with\s+/);return{tableParams:b[0],columns:b[1]}}throw new Error("Parse error (expected example: ng-table-dynamic='tableParams with cols')")},this.setupBindingsToInternalScope=function(c){var d=e(c);b.$watch(d,function(c){a.isUndefined(c)||(b.paramsModel=d,b.params=c)},!1),l(),m()},q()}])}(),function(){a.module("ngTable").directive("ngTable",["$q","$parse",function(b,c){return{restrict:"A",priority:1001,scope:!0,controller:"ngTableController",compile:function(b){var d,e,f=[],g=0,h=[];return a.forEach(b.find("tr"),function(b){h.push(a.element(b))}),d=h.filter(function(a){return!a.hasClass("ng-table-group")})[0],e=h.filter(function(a){return a.hasClass("ng-table-group")})[0],d?(a.forEach(d.find("td"),function(b){var d=a.element(b);if(!d.attr("ignore-cell")||"true"!==d.attr("ignore-cell")){var h=function(a){return d.attr("x-data-"+a)||d.attr("data-"+a)||d.attr(a)},i=function(a,b){d.attr("x-data-"+a)?d.attr("x-data-"+a,b):d.attr("data"+a)?d.attr("data"+a,b):d.attr(a,b)},j=function(a){var b=h(a);if(!b)return void 0;var d,e=function(a){return void 0!==d?d:c(b)(a)};return e.assign=function(a,e){var f=c(b);f.assign?f.assign(a.$parent,e):d=e},e},k=h("title-alt")||h("title");k&&d.attr("data-title-text","{{"+k+"}}"),f.push({id:g++,title:j("title"),titleAlt:j("title-alt"),headerTitle:j("header-title"),sortable:j("sortable"),"class":j("header-class"),filter:j("filter"),groupable:j("groupable"),headerTemplateURL:j("header"),filterData:j("filter-data"),show:d.attr("ng-if")?j("ng-if"):void 0}),(e||d.attr("ng-if"))&&i("ng-if","$columns["+(f.length-1)+"].show(this)")}}),function(a,b,c,d){a.$columns=f=d.buildColumns(f),d.setupBindingsToInternalScope(c.ngTable),d.loadFilterData(f),d.compileDirectiveTemplates()}):void 0}}}])}(),function(){a.module("ngTable").directive("ngTableDynamic",[function(){return{restrict:"A",priority:1001,scope:!0,controller:"ngTableController",compile:function(b){var c;return a.forEach(b.find("tr"),function(b){b=a.element(b),b.hasClass("ng-table-group")||c||(c=b)}),c?(a.forEach(c.find("td"),function(b){var c=a.element(b),d=function(a){return c.attr("x-data-"+a)||c.attr("data-"+a)||c.attr(a)},e=d("title");e||c.attr("data-title-text","{{$columns[$index].titleAlt(this) || $columns[$index].title(this)}}");var f=c.attr("ng-if");f||c.attr("ng-if","$columns[$index].show(this)")}),function(a,b,c,d){var e=d.parseNgTableDynamicExpr(c.ngTableDynamic);d.setupBindingsToInternalScope(e.tableParams),d.compileDirectiveTemplates(),a.$watchCollection(e.columns,function(b){a.$columns=d.buildColumns(b),d.loadFilterData(a.$columns)})}):void 0}}}])}(),function(){function b(a){function b(b,c,d){var e=a(d.ngTableColumnsBinding).assign;e&&b.$watch("$columns",function(a){var c=(a||[]).slice(0);e(b,c)})}var c={restrict:"A",require:"ngTable",link:b};return c}a.module("ngTable").directive("ngTableColumnsBinding",b),b.$inject=["$parse"]}(),function(){a.module("ngTable").directive("ngTablePagination",["$compile","ngTableEventsChannel",function(b,c){return{restrict:"A",scope:{params:"=ngTablePagination",templateUrl:"="},replace:!1,link:function(d,e){c.onAfterReloadData(function(a){d.pages=a.generatePagesArray()},d,function(a){return a===d.params}),d.$watch("templateUrl",function(c){if(!a.isUndefined(c)){var f=a.element(document.createElement("div"));f.attr({"ng-include":"templateUrl"}),e.append(f),b(f)(d)}})}}}])}(),function(){function b(b,c){b.config=c,b.getFilterCellCss=function(a,b){if("horizontal"!==b)return"s12";var c=Object.keys(a).length,d=parseInt(12/c,10);return"s"+d},b.getFilterPlaceholderValue=function(b){return a.isObject(b)?b.placeholder:""}}a.module("ngTable").controller("ngTableFilterRowController",b),b.$inject=["$scope","ngTableFilterConfig"]}(),function(){function b(){var a={restrict:"E",replace:!0,templateUrl:"ng-table/filterRow.html",scope:!0,controller:"ngTableFilterRowController"};return a}a.module("ngTable").directive("ngTableFilterRow",b),b.$inject=[]}(),function(){function b(b){function c(){b.getGroupables=g,b.getGroupTitle=f,b.getVisibleColumns=h,b.groupBy=i,b.isSelectedGroup=j,b.toggleDetail=l,b.$watch("params.group()",k,!0)}function d(){var a;a=b.params.hasGroup(b.$selGroup,"asc")?"desc":b.params.hasGroup(b.$selGroup,"desc")?"":"asc",b.params.group(b.$selGroup,a)}function e(a){return b.$columns.filter(function(c){return c.groupable(b)===a})[0]}function f(c){return a.isFunction(c)?c.title:c.title(b)}function g(){var a=b.$columns.filter(function(a){return a.groupable(b)});return m.concat(a)}function h(){return b.$columns.filter(function(a){return a.show(b)})}function i(a){j(a)?d():b.params.group(a.groupable?a.groupable(b):a)}function j(a){return a.groupable?a.groupable(b)===b.$selGroup:a===b.$selGroup}function k(c){var d=e(b.$selGroup);if(d&&d.show.assign&&d.show.assign(b,!0),a.isFunction(c))m=[c],b.$selGroup=c,b.$selGroupTitle=c.title;else{var f=Object.keys(c||{})[0],g=e(f);g&&(b.$selGroupTitle=g.title(b),b.$selGroup=f,g.show.assign&&g.show.assign(b,!1))}}function l(){return b.params.settings().groupOptions.isExpanded=!b.params.settings().groupOptions.isExpanded,b.params.reload()}var m=[];c()}a.module("ngTable").controller("ngTableGroupRowController",b),b.$inject=["$scope"]}(),function(){function b(){var a={restrict:"E",replace:!0,templateUrl:"ng-table/groupRow.html",scope:!0,controller:"ngTableGroupRowController",controllerAs:"dctrl"};return a}a.module("ngTable").directive("ngTableGroupRow",b),b.$inject=[]}(),function(){function b(a){function b(b,c){var d=b.sortable&&b.sortable();if(d){var e=a.params.settings().defaultSort,f="asc"===e?"desc":"asc",g=a.params.sorting()&&a.params.sorting()[d]&&a.params.sorting()[d]===e,h=c.ctrlKey||c.metaKey?a.params.sorting():{};h[d]=g?f:e,a.params.parameters({sorting:h})}}a.sortBy=b}a.module("ngTable").controller("ngTableSorterRowController",b),b.$inject=["$scope"]}(),function(){function b(){var a={restrict:"E",replace:!0,templateUrl:"ng-table/sorterRow.html",scope:!0,controller:"ngTableSorterRowController"};return a}a.module("ngTable").directive("ngTableSorterRow",b),b.$inject=[]}(),function(){function b(){var a={restrict:"A",controller:c};return a}function c(b,c,d,e){function f(){j=c(d.ngTableSelectFilterDs)(b),b.$watch(function(){return j.data},g)}function g(){i(j).then(function(a){a&&!h(a)&&a.unshift({id:"",title:""}),a=a||[],b.$selectData=a})}function h(a){for(var b,c=0;c<a.length;c++){var d=a[c];if(d&&""===d.id){b=!0;break}}return b}function i(b){var c=a.isFunction(b.data)?b.data():b.data;return e.when(c)}var j={};f()}a.module("ngTable").directive("ngTableSelectFilterDs",b),b.$inject=[],c.$inject=["$scope","$parse","$attrs","$q"]}(),a.module("ngTable").run(["$templateCache",function(a){a.put("ng-table/filterRow.html",'<tr ng-show="show_filter" class="ng-table-filters"> <th data-title-text="{{$column.titleAlt(this) || $column.title(this)}}" ng-repeat="$column in $columns" ng-if="$column.show(this)" class="filter {{$column.class(this)}}" ng-class="params.settings().filterOptions.filterLayout===\'horizontal\' ? \'filter-horizontal\' : \'\'"> <div ng-repeat="(name, filter) in $column.filter(this)" ng-include="config.getTemplateUrl(filter)" class="filter-cell" ng-class="[getFilterCellCss($column.filter(this), params.settings().filterOptions.filterLayout), $last ? \'last\' : \'\']"> </div> </th> </tr> '),a.put("ng-table/filters/number.html",'<input type="number" name="{{name}}" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" class="input-filter form-control" placeholder="{{getFilterPlaceholderValue(filter, name)}}"/> '),a.put("ng-table/filters/select-multiple.html",'<select ng-options="data.id as data.title for data in $column.data" ng-disabled="$filterRow.disabled" multiple ng-multiple="true" ng-model="params.filter()[name]" class="filter filter-select-multiple form-control" name="{{name}}"> </select> '),a.put("ng-table/filters/select.html",'<select ng-options="data.id as data.title for data in $selectData" ng-table-select-filter-ds="$column" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" class="filter filter-select form-control" name="{{name}}"> <option style="display:none" value=""></option> </select> '),a.put("ng-table/filters/text.html",'<input type="text" name="{{name}}" ng-disabled="$filterRow.disabled" ng-model="params.filter()[name]" class="input-filter form-control" placeholder="{{getFilterPlaceholderValue(filter, name)}}"/> '),a.put("ng-table/groupRow.html",'<tr ng-if="params.hasGroup()" ng-show="$groupRow.show" class="ng-table-group-header"> <th colspan="{{getVisibleColumns().length}}" class="sortable" ng-class="{ \'sort-asc\': params.hasGroup($selGroup, \'asc\'), \'sort-desc\':params.hasGroup($selGroup, \'desc\') }"> <a href="" ng-click="isSelectorOpen=!isSelectorOpen" class="ng-table-group-selector"> <strong class="sort-indicator">{{$selGroupTitle}}</strong> <button class="btn btn-default btn-xs ng-table-group-close" ng-click="$groupRow.show=false; $event.preventDefault(); $event.stopPropagation();"> <span class="glyphicon glyphicon-remove"></span> </button> <button class="btn btn-default btn-xs ng-table-group-toggle" ng-click="toggleDetail(); $event.preventDefault(); $event.stopPropagation();"> <span class="glyphicon" ng-class="{ \'glyphicon-resize-small\': params.settings().groupOptions.isExpanded, \'glyphicon-resize-full\': !params.settings().groupOptions.isExpanded }"></span> </button> </a> <div class="list-group" ng-if="isSelectorOpen"> <a href="" class="list-group-item" ng-repeat="group in getGroupables()" ng-click="groupBy(group)"> <strong>{{ getGroupTitle(group)}}</strong> <strong ng-class="isSelectedGroup(group) && \'sort-indicator\'"></strong> </a> </div> </th> </tr> '),a.put("ng-table/header.html","<ng-table-group-row></ng-table-group-row> <ng-table-sorter-row></ng-table-sorter-row> <ng-table-filter-row></ng-table-filter-row> "),a.put("ng-table/pager.html",'<div class="ng-cloak ng-table-pager" ng-if="params.data.length"> <div ng-if="params.settings().counts.length" class="ng-table-counts btn-group pull-right"> <button ng-repeat="count in params.settings().counts" type="button" ng-class="{\'active\':params.count()==count}" ng-click="params.count(count)" class="btn btn-default"> <span ng-bind="count"></span> </button> </div> <ul ng-if="pages.length" class="pagination ng-table-pagination"> <li ng-class="{\'disabled\': !page.active && !page.current, \'active\': page.current}" ng-repeat="page in pages" ng-switch="page.type"> <a ng-switch-when="prev" ng-click="params.page(page.number)" href="">&laquo;</a> <a ng-switch-when="first" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="page" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="more" ng-click="params.page(page.number)" href="">&#8230;</a> <a ng-switch-when="last" ng-click="params.page(page.number)" href=""><span ng-bind="page.number"></span></a> <a ng-switch-when="next" ng-click="params.page(page.number)" href="">&raquo;</a> </li> </ul> </div> '),a.put("ng-table/sorterRow.html",'<tr class="ng-table-sort-header"> <th title="{{$column.headerTitle(this)}}" ng-repeat="$column in $columns" ng-class="{ \'sortable\': $column.sortable(this), \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\', \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\' }" ng-click="sortBy($column, $event)" ng-if="$column.show(this)" ng-init="template=$column.headerTemplateURL(this)" class="header {{$column.class(this)}}"> <div ng-if="!template" class="ng-table-header" ng-class="{\'sort-indicator\': params.settings().sortingIndicator==\'div\'}"> <span ng-bind="$column.title(this)" ng-class="{\'sort-indicator\': params.settings().sortingIndicator==\'span\'}"></span> </div> <div ng-if="template" ng-include="template"></div> </th> </tr> ')}]),a.module("ngTable")});

/*
 *
 * https://github.com/fatlinesofcode/ngDraggable
 */
angular.module("ngDraggable", [])
        .service('ngDraggable', [function() {


            var scope = this;
            scope.inputEvent = function(event) {
                if (angular.isDefined(event.touches)) {
                    return event.touches[0];
                }
                //Checking both is not redundent. If only check if touches isDefined, angularjs isDefnied will return error and stop the remaining scripty if event.originalEvent is not defined.
                else if (angular.isDefined(event.originalEvent) && angular.isDefined(event.originalEvent.touches)) {
                    return event.originalEvent.touches[0];
                }
                return event;
            };

        }])
        .directive('ngDrag', ['$rootScope', '$parse', '$document', '$window', 'ngDraggable', function ($rootScope, $parse, $document, $window, ngDraggable) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    scope.value = attrs.ngDrag;
                    var offset,_centerAnchor=false,_mx,_my,_tx,_ty,_mrx,_mry;
                    var _hasTouch = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
                    var _pressEvents = 'touchstart mousedown';
                    var _moveEvents = 'touchmove mousemove';
                    var _releaseEvents = 'touchend mouseup';
                    var _dragHandle;

                    // to identify the element in order to prevent getting superflous events when a single element has both drag and drop directives on it.
                    var _myid = scope.$id;
                    var _data = null;

                    var _dragOffset = null;

                    var _dragEnabled = false;

                    var _pressTimer = null;

                    var onDragSuccessCallback = $parse(attrs.ngDragSuccess) || null;
                    var allowTransform = angular.isDefined(attrs.allowTransform) ? scope.$eval(attrs.allowTransform) : true;

                    var getDragData = $parse(attrs.ngDragData);

                    // deregistration function for mouse move events in $rootScope triggered by jqLite trigger handler
                    var _deregisterRootMoveListener = angular.noop;

                    var initialize = function () {
                        element.attr('draggable', 'false'); // prevent native drag
                        // check to see if drag handle(s) was specified
                        // if querySelectorAll is available, we use this instead of find
                        // as JQLite find is limited to tagnames
                        if (element[0].querySelectorAll) {
                            var dragHandles = angular.element(element[0].querySelectorAll('[ng-drag-handle]'));
                        } else {
                            var dragHandles = element.find('[ng-drag-handle]');
                        }
                        if (dragHandles.length) {
                            _dragHandle = dragHandles;
                        }
                        toggleListeners(true);
                    };

                    var toggleListeners = function (enable) {
                        if (!enable)return;
                        // add listeners.

                        scope.$on('$destroy', onDestroy);
                        scope.$watch(attrs.ngDrag, onEnableChange);
                        scope.$watch(attrs.ngCenterAnchor, onCenterAnchor);
                        // wire up touch events
                        if (_dragHandle) {
                            // handle(s) specified, use those to initiate drag
                            _dragHandle.on(_pressEvents, onpress);
                        } else {
                            // no handle(s) specified, use the element as the handle
                            element.on(_pressEvents, onpress);
                        }
                        if(! _hasTouch && element[0].nodeName.toLowerCase() == "img"){
                            element.on('mousedown', function(){ return false;}); // prevent native drag for images
                        }
                    };
                    var onDestroy = function (enable) {
                        toggleListeners(false);
                    };
                    var onEnableChange = function (newVal, oldVal) {
                        _dragEnabled = (newVal);
                    };
                    var onCenterAnchor = function (newVal, oldVal) {
                        if(angular.isDefined(newVal))
                        _centerAnchor = (newVal || 'true');
                    };

                    var isClickableElement = function (evt) {
                        return (
                                angular.isDefined(angular.element(evt.target).attr("ng-cancel-drag"))
                                );
                    };
                    /*
                     * When the element is clicked start the drag behaviour
                     * On touch devices as a small delay so as not to prevent native window scrolling
                     */
                    var onpress = function(evt) {
                        if(! _dragEnabled)return;

                        if (isClickableElement(evt)) {
                            return;
                        }

                        if (evt.type == "mousedown" && evt.button != 0) {
                            // Do not start dragging on right-click
                            return;
                        }

                        if(_hasTouch){
                            cancelPress();
                            _pressTimer = setTimeout(function(){
                                cancelPress();
                                onlongpress(evt);
                            },100);
                            $document.on(_moveEvents, cancelPress);
                            $document.on(_releaseEvents, cancelPress);
                        }else{
                            onlongpress(evt);
                        }

                    };

                    var cancelPress = function() {
                        clearTimeout(_pressTimer);
                        $document.off(_moveEvents, cancelPress);
                        $document.off(_releaseEvents, cancelPress);
                    };

                    var onlongpress = function(evt) {
                        if(! _dragEnabled)return;
                        evt.preventDefault();

                        offset = element[0].getBoundingClientRect();
                        if(allowTransform)
                        _dragOffset = offset;
                        else{
                            _dragOffset = {left:document.body.scrollLeft, top:document.body.scrollTop};
                        }


                        element.centerX = element[0].offsetWidth / 2;
                        element.centerY = element[0].offsetHeight / 2;

                        _mx = ngDraggable.inputEvent(evt).pageX;//ngDraggable.getEventProp(evt, 'pageX');
                        _my = ngDraggable.inputEvent(evt).pageY;//ngDraggable.getEventProp(evt, 'pageY');
                        _mrx = _mx - offset.left;
                        _mry = _my - offset.top;
                         if (_centerAnchor) {
                             _tx = _mx - element.centerX - $window.pageXOffset;
                             _ty = _my - element.centerY - $window.pageYOffset;
                        } else {
                             _tx = _mx - _mrx - $window.pageXOffset;
                             _ty = _my - _mry - $window.pageYOffset;
                        }

                        $document.on(_moveEvents, onmove);
                        $document.on(_releaseEvents, onrelease);
                        // This event is used to receive manually triggered mouse move events
                        // jqLite unfortunately only supports triggerHandler(...)
                        // See http://api.jquery.com/triggerHandler/
                        // _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', onmove);
                        _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', function(event, origEvent) {
                            onmove(origEvent);
                        });
                    };

                    var onmove = function (evt) {
                        if (!_dragEnabled)return;
                        evt.preventDefault();

                        if (!element.hasClass('dragging')) {
                            _data = getDragData(scope);
                            element.addClass('dragging');
                            $rootScope.$broadcast('draggable:start', {x:_mx, y:_my, tx:_tx, ty:_ty, event:evt, element:element, data:_data});
                        }

                        _mx = ngDraggable.inputEvent(evt).pageX;//ngDraggable.getEventProp(evt, 'pageX');
                        _my = ngDraggable.inputEvent(evt).pageY;//ngDraggable.getEventProp(evt, 'pageY');

                        if (_centerAnchor) {
                            _tx = _mx - element.centerX - _dragOffset.left;
                            _ty = _my - element.centerY - _dragOffset.top;
                        } else {
                            _tx = _mx - _mrx - _dragOffset.left;
                            _ty = _my - _mry - _dragOffset.top;
                        }

                        moveElement(_tx, _ty);

                        $rootScope.$broadcast('draggable:move', { x: _mx, y: _my, tx: _tx, ty: _ty, event: evt, element: element, data: _data, uid: _myid });
                    };

                    var onrelease = function(evt) {
                        if (!_dragEnabled)
                            return;
                        evt.preventDefault();
                        $rootScope.$broadcast('draggable:end', {x:_mx, y:_my, tx:_tx, ty:_ty, event:evt, element:element, data:_data, callback:onDragComplete, uid: _myid});
                        element.removeClass('dragging');
                        element.parent().find('.drag-enter').removeClass('drag-enter');
                        reset();
                        $document.off(_moveEvents, onmove);
                        $document.off(_releaseEvents, onrelease);
                        _deregisterRootMoveListener();
                    };

                    var onDragComplete = function(evt) {
                        if (!onDragSuccessCallback )return;

                        scope.$apply(function () {
                            onDragSuccessCallback(scope, {$data: _data, $event: evt});
                        });
                    };

                    var reset = function() {
                        if(allowTransform)
                        element.css({transform:'', 'z-index':'', '-webkit-transform':'', '-ms-transform':''});
                        else
                        element.css({'position':'',top:'',left:''});
                    };

                    var moveElement = function (x, y) {
                        if(allowTransform) {
                            element.css({
                                transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
                                'z-index': 99999,
                                '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
                                '-ms-transform': 'matrix(1, 0, 0, 1, ' + x + ', ' + y + ')'
                            });
                        }else{
                            element.css({'left':x+'px','top':y+'px', 'position':'fixed'});
                        }
                    };
                    initialize();
                }
            };
        }])

        .directive('ngDrop', ['$parse', '$timeout', '$window', '$document', 'ngDraggable', function ($parse, $timeout, $window, $document, ngDraggable) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    scope.value = attrs.ngDrop;
                    scope.isTouching = false;

                    var _lastDropTouch=null;

                    var _myid = scope.$id;

                    var _dropEnabled=false;

                    var onDropCallback = $parse(attrs.ngDropSuccess);// || function(){};

                    var onDragStartCallback = $parse(attrs.ngDragStart);
                    var onDragStopCallback = $parse(attrs.ngDragStop);
                    var onDragMoveCallback = $parse(attrs.ngDragMove);

                    var initialize = function () {
                        toggleListeners(true);
                    };

                    var toggleListeners = function (enable) {
                        // remove listeners

                        if (!enable)return;
                        // add listeners.
                        scope.$watch(attrs.ngDrop, onEnableChange);
                        scope.$on('$destroy', onDestroy);
                        scope.$on('draggable:start', onDragStart);
                        scope.$on('draggable:move', onDragMove);
                        scope.$on('draggable:end', onDragEnd);
                    };

                    var onDestroy = function (enable) {
                        toggleListeners(false);
                    };
                    var onEnableChange = function (newVal, oldVal) {
                        _dropEnabled=newVal;
                    };
                    var onDragStart = function(evt, obj) {
                        if(! _dropEnabled)return;
                        isTouching(obj.x,obj.y,obj.element);

                        if (attrs.ngDragStart) {
                            $timeout(function(){
                                onDragStartCallback(scope, {$data: obj.data, $event: obj});
                            });
                        }
                    };
                    var onDragMove = function(evt, obj) {
                        if(! _dropEnabled)return;
                        isTouching(obj.x,obj.y,obj.element);

                        if (attrs.ngDragMove) {
                            $timeout(function(){
                                onDragMoveCallback(scope, {$data: obj.data, $event: obj});
                            });
                        }
                    };

                    var onDragEnd = function (evt, obj) {

                        // don't listen to drop events if this is the element being dragged
                        // only update the styles and return
                        if (!_dropEnabled || _myid === obj.uid) {
                            updateDragStyles(false, obj.element);
                            return;
                        }
                        if (isTouching(obj.x, obj.y, obj.element)) {
                            // call the ngDraggable ngDragSuccess element callback
                           if(obj.callback){
                                obj.callback(obj);
                            }

                            if (attrs.ngDropSuccess) {
                                $timeout(function(){
                                    onDropCallback(scope, {$data: obj.data, $event: obj, $target: scope.$eval(scope.value)});
                                });
                            }
                        }

                        if (attrs.ngDragStop) {
                            $timeout(function(){
                                onDragStopCallback(scope, {$data: obj.data, $event: obj});
                            });
                        }

                        updateDragStyles(false, obj.element);
                    };

                    var isTouching = function(mouseX, mouseY, dragElement) {
                        var touching= hitTest(mouseX, mouseY);
                        scope.isTouching = touching;
                        if(touching){
                            _lastDropTouch = element;
                        }
                        updateDragStyles(touching, dragElement);
                        return touching;
                    };

                    var updateDragStyles = function(touching, dragElement) {
                        if(touching){
                            element.addClass('drag-enter');
                            dragElement.addClass('drag-over');
                        }else if(_lastDropTouch == element){
                            _lastDropTouch=null;
                            element.removeClass('drag-enter');
                            dragElement.removeClass('drag-over');
                        }
                    };

                    var hitTest = function(x, y) {
                        var bounds = element[0].getBoundingClientRect();// ngDraggable.getPrivOffset(element);
                        x -= $document[0].body.scrollLeft + $document[0].documentElement.scrollLeft;
                        y -= $document[0].body.scrollTop + $document[0].documentElement.scrollTop;
                        return  x >= bounds.left
                                && x <= bounds.right
                                && y <= bounds.bottom
                                && y >= bounds.top;
                    };

                    initialize();
                }
            };
        }])
        .directive('ngDragClone', ['$parse', '$timeout', 'ngDraggable', function ($parse, $timeout, ngDraggable) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var img, _allowClone=true;
                    var _dragOffset = null;
                    scope.clonedData = {};
                    var initialize = function () {

                        img = element.find('img');
                        element.attr('draggable', 'false');
                        img.attr('draggable', 'false');
                        reset();
                        toggleListeners(true);
                    };


                    var toggleListeners = function (enable) {
                        // remove listeners

                        if (!enable)return;
                        // add listeners.
                        scope.$on('draggable:start', onDragStart);
                        scope.$on('draggable:move', onDragMove);
                        scope.$on('draggable:end', onDragEnd);
                        preventContextMenu();

                    };
                    var preventContextMenu = function() {
                      //  element.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                        img.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                      //  element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                        img.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                    };
                    var onDragStart = function(evt, obj, elm) {
                        _allowClone=true;
                        if(angular.isDefined(obj.data.allowClone)){
                            _allowClone=obj.data.allowClone;
                        }
                        if(_allowClone) {
                            scope.$apply(function () {
                                scope.clonedData = obj.data;
                            });
                            element.css('width', obj.element[0].offsetWidth);
                            element.css('height', obj.element[0].offsetHeight);

                            moveElement(obj.tx, obj.ty);
                        }

                        _dragOffset = element[0].getBoundingClientRect();//ngDraggable.getPrivOffset(element);
                    };
                    var onDragMove = function(evt, obj) {
                        if(_allowClone) {

                            _tx = obj.tx + _dragOffset.left;
                            _ty = obj.ty + _dragOffset.top;

                            moveElement(_tx, _ty);
                        }
                    };
                    var onDragEnd = function(evt, obj) {
                        //moveElement(obj.tx,obj.ty);
                        if(_allowClone) {
                            reset();
                        }
                    };

                    var reset = function() {
                        element.css({left:0,top:0, position:'fixed', 'z-index':-1, visibility:'hidden'});
                    };
                    var moveElement = function(x,y) {
                        element.css({
                            transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, '+x+', '+y+', 0, 1)', 'z-index': 99999, 'visibility': 'visible',
                            '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, '+x+', '+y+', 0, 1)',
                            '-ms-transform': 'matrix(1, 0, 0, 1, '+x+', '+y+')'
                            //,margin: '0'  don't monkey with the margin,
                        });
                    };

                    var absorbEvent_ = function (event) {
                        var e = event;//.originalEvent;
                        e.preventDefault && e.preventDefault();
                        e.stopPropagation && e.stopPropagation();
                        e.cancelBubble = true;
                        e.returnValue = false;
                        return false;
                    };

                    initialize();
                }
            };
        }])
    .directive('ngPreventDrag', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var initialize = function () {

                    element.attr('draggable', 'false');
                    toggleListeners(true);
                };


                var toggleListeners = function (enable) {
                    // remove listeners

                    if (!enable)return;
                    // add listeners.
                    element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                };


                var absorbEvent_ = function (event) {
                    var e = event.originalEvent;
                    e.preventDefault && e.preventDefault();
                    e.stopPropagation && e.stopPropagation();
                    e.cancelBubble = true;
                    e.returnValue = false;
                    return false;
                };

                initialize();
            }
        };
    }])
    .directive('ngCancelDrag', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.find('*').attr('ng-cancel-drag', 'ng-cancel-drag');
            }
        };
    }])
    .directive('ngDragScroll', ['$window', '$interval', '$timeout', '$document', '$rootScope', function($window, $interval, $timeout, $document, $rootScope) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var intervalPromise = null;
                var lastMouseEvent = null;

                var config = {
                    verticalScroll: attrs.verticalScroll || true,
                    horizontalScroll: attrs.horizontalScroll || true,
                    activationDistance: attrs.activationDistance || 75,
                    scrollDistance: attrs.scrollDistance || 15
                };


                var reqAnimFrame = (function() {
                    return window.requestAnimationFrame ||
                        window.webkitRequestAnimationFrame ||
                        window.mozRequestAnimationFrame ||
                        window.oRequestAnimationFrame ||
                        window.msRequestAnimationFrame ||
                        function( /* function FrameRequestCallback */ callback, /* DOMElement Element */ element ) {
                            window.setTimeout(callback, 1000 / 60);
                        };
                })();

                var animationIsOn = false;
                var createInterval = function() {
                    animationIsOn = true;

                    function nextFrame(callback) {
                        var args = Array.prototype.slice.call(arguments);
                        if(animationIsOn) {
                            reqAnimFrame(function () {
                              $rootScope.$apply(function () {
                                callback.apply(null, args);
                                nextFrame(callback);
                              });
                            })
                        }
                    }

                    nextFrame(function() {
                        if (!lastMouseEvent) return;

                        var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                        var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

                        var scrollX = 0;
                        var scrollY = 0;

                        if (config.horizontalScroll) {
                            // If horizontal scrolling is active.
                            if (lastMouseEvent.clientX < config.activationDistance) {
                                // If the mouse is on the left of the viewport within the activation distance.
                                scrollX = -config.scrollDistance;
                            }
                            else if (lastMouseEvent.clientX > viewportWidth - config.activationDistance) {
                                // If the mouse is on the right of the viewport within the activation distance.
                                scrollX = config.scrollDistance;
                            }
                        }

                        if (config.verticalScroll) {
                            // If vertical scrolling is active.
                            if (lastMouseEvent.clientY < config.activationDistance) {
                                // If the mouse is on the top of the viewport within the activation distance.
                                scrollY = -config.scrollDistance;
                            }
                            else if (lastMouseEvent.clientY > viewportHeight - config.activationDistance) {
                                // If the mouse is on the bottom of the viewport within the activation distance.
                                scrollY = config.scrollDistance;
                            }
                        }



                        if (scrollX !== 0 || scrollY !== 0) {
                            // Record the current scroll position.
                            var currentScrollLeft = ($window.pageXOffset || $document[0].documentElement.scrollLeft);
                            var currentScrollTop = ($window.pageYOffset || $document[0].documentElement.scrollTop);

                            // Remove the transformation from the element, scroll the window by the scroll distance
                            // record how far we scrolled, then reapply the element transformation.
                            var elementTransform = element.css('transform');
                            element.css('transform', 'initial');

                            $window.scrollBy(scrollX, scrollY);

                            var horizontalScrollAmount = ($window.pageXOffset || $document[0].documentElement.scrollLeft) - currentScrollLeft;
                            var verticalScrollAmount =  ($window.pageYOffset || $document[0].documentElement.scrollTop) - currentScrollTop;

                            element.css('transform', elementTransform);

                            lastMouseEvent.pageX += horizontalScrollAmount;
                            lastMouseEvent.pageY += verticalScrollAmount;

                            $rootScope.$emit('draggable:_triggerHandlerMove', lastMouseEvent);
                        }

                    });
                };

                var clearInterval = function() {
                    animationIsOn = false;
                };

                scope.$on('draggable:start', function(event, obj) {
                    // Ignore this event if it's not for this element.
                    if (obj.element[0] !== element[0]) return;

                    if (!animationIsOn) createInterval();
                });

                scope.$on('draggable:end', function(event, obj) {
                    // Ignore this event if it's not for this element.
                    if (obj.element[0] !== element[0]) return;

                    if (animationIsOn) clearInterval();
                });

                scope.$on('draggable:move', function(event, obj) {
                    // Ignore this event if it's not for this element.
                    if (obj.element[0] !== element[0]) return;

                    lastMouseEvent = obj.event;
                });
            }
        };
    }]);

angular.module('mc.resizer', []).directive('resizer', function($document) {

	return function($scope, $element, $attrs) {

		$element.on('mousedown', function(event) {
			event.preventDefault();

			$document.on('mousemove', mousemove);
			$document.on('mouseup', mouseup);
		});

		function mousemove(event) {

			if ($attrs.resizer == 'vertical') {
				// Handle vertical resizer
				var x = event.pageX;

				if ($attrs.resizerMax && x > $attrs.resizerMax) {
					x = parseInt($attrs.resizerMax);
				}
				if ($attrs.resizerMin && x <= $attrs.resizerMin) {
					x = parseInt($attrs.resizerMin) - 30;
				}
				$element.css({
					left: x + 30 + 'px'
				});

				$($attrs.resizerLeft).css({
					width: x + 'px'
				});
				$($attrs.resizerRight).css({
					left: (x + parseInt($attrs.resizerWidth)) + 30 +  'px'
				});

			} else {
				// Handle horizontal resizer
				var y = window.innerHeight - event.pageY;

				$element.css({
					bottom: y + 'px'
				});

				$($attrs.resizerTop).css({
					bottom: (y + parseInt($attrs.resizerHeight)) + 'px'
				});
				$($attrs.resizerBottom).css({
					height: y + 'px'
				});
			}
		}

		function mouseup() {
			$document.unbind('mousemove', mousemove);
			$document.unbind('mouseup', mouseup);
		}
	};
});
(function (ng) {
    'use strict';
    ng.module('smart-table',[]);
})(angular);

(function (ng, undefined) {
    'use strict';
    ng.module('smart-table')
        .controller('stTableController', ['$scope', '$parse', '$filter', '$attrs', function StTableController($scope, $parse, $filter, $attrs) {
            var propertyName = $attrs.stTable;
            var displayGetter = $parse(propertyName);
            var displaySetter = displayGetter.assign;
            var safeGetter;
            var orderBy = $filter('orderBy');
            var filter = $filter('filter');
            var safeCopy = copyRefs(displayGetter($scope));
            var tableState = {
                sort: {},
                search: {},
                pagination: {
                    start: 0
                }
            };
            var pipeAfterSafeCopy = true;
            var ctrl = this;

            function copyRefs(src) {
                return [].concat(src);
            }

            function updateSafeCopy() {
                safeCopy = copyRefs(safeGetter($scope));
                if (pipeAfterSafeCopy === true) {
                    ctrl.pipe();
                }
            }

            if ($attrs.stSafeSrc) {
                safeGetter = $parse($attrs.stSafeSrc);
                $scope.$watch(function () {
                    var safeSrc = safeGetter($scope);
                    return safeSrc ? safeSrc.length : 0;

                }, function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        updateSafeCopy()
                    }
                });
                $scope.$watch(function () {
                    return safeGetter($scope);
                }, function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        updateSafeCopy();
                    }
                });
            }

            /**
             * sort the rows
             * @param predicate function or string which will be used as predicate for the sorting
             * @param [optional] reverse if you want to reverse the order
             */
            this.sortBy = function sortBy(predicate, reverse) {
                tableState.sort.predicate = predicate;
                tableState.sort.reverse = reverse === true;
                tableState.pagination.start = 0;
                this.pipe();
            };

            /**
             * search matching rows
             * @param input the input string
             * @param predicate [optional] the property name against you want to check the match, otherwise it will search on all properties
             */
            this.search = function search(input, predicate) {
                var predicateObject = tableState.search.predicateObject || {};
                var prop = predicate ? predicate : '$';
                predicateObject[prop] = input;
                tableState.search.predicateObject = predicateObject;
                tableState.pagination.start = 0;
                this.pipe();
            };

            /**
             * this will chain the operations of sorting and filtering based on the current table state (sort options, filtering, ect)
             */
            this.pipe = function pipe() {
                var filtered = tableState.search.predicateObject ? filter(safeCopy, tableState.search.predicateObject) : safeCopy;
                filtered = orderBy(filtered, tableState.sort.predicate, tableState.sort.reverse);
                if (tableState.pagination.number !== undefined) {
                    tableState.pagination.numberOfPages = filtered.length > 0 ? Math.ceil(filtered.length / tableState.pagination.number) : 1;
                    filtered = filtered.slice(tableState.pagination.start, tableState.pagination.start + tableState.pagination.number);
                }
                displaySetter($scope, filtered);
            };

            /**
             * select a dataRow (it will add the attribute isSelected to the row object)
             * @param row the row to select
             * @param mode "single" or "multiple"
             */
            this.select = function select(row, mode) {
                var rows = displayGetter($scope);
                var index = rows.indexOf(row);
                if (index !== -1) {
                    if (mode === 'single') {
                        ng.forEach(displayGetter($scope), function (value, key) {
                            value.isSelected = key === index ? !value.isSelected : false;
                        });
                    } else {
                        rows[index].isSelected = !rows[index].isSelected;
                    }
                }
            };

            /**
             * take a slice of the current sorted/filtered collection (pagination)
             *
             * @param start index of the slice
             * @param number the number of item in the slice
             */
            this.slice = function splice(start, number) {
                tableState.pagination.start = start;
                tableState.pagination.number = number;
                this.pipe();
            };

            /**
             * return the current state of the table
             * @returns {{sort: {}, search: {}, pagination: {start: number}}}
             */
            this.tableState = function getTableState() {
                return tableState;
            };

            /**
             * Use a different filter function than the angular FilterFilter
             * @param filterName the name under which the custom filter is registered
             */
            this.setFilterFunction = function setFilterFunction(filterName) {
                filter = $filter(filterName);
            };

            /**
             *User a different function than the angular orderBy
             * @param sortFunctionName the name under which the custom order function is registered
             */
            this.setSortFunction = function setSortFunction(sortFunctionName) {
                orderBy = $filter(sortFunctionName);
            };

            /**
             * Usually when the safe copy is updated the pipe function is called.
             * Calling this method will prevent it, which is something required when using a custom pipe function
             */
            this.preventPipeOnWatch = function preventPipe() {
                pipeAfterSafeCopy = false;
            };
        }])
        .directive('stTable', function () {
            return {
                restrict: 'A',
                controller: 'stTableController',
                link: function (scope, element, attr, ctrl) {
                }
            };
        });
})(angular);

(function (ng) {
    'use strict';
    ng.module('smart-table')
        .directive('stSearch', ['$timeout', function ($timeout) {
            return {
                replace: true,
                require: '^stTable',
                scope: {
                    predicate: '=?stSearch'
                },
                link: function (scope, element, attr, ctrl) {
                    var tableCtrl = ctrl;
                    var promise = null;
                    var throttle = attr.stDelay || 400;

                    scope.$watch('predicate', function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            ctrl.tableState().search = {};
                            tableCtrl.search(element[0].value || '', newValue);
                        }
                    });

                    element.bind('input', function (evt) {
                        evt = evt.originalEvent || evt;
                        if (promise !== null) {
                            $timeout.cancel(promise);
                        }
                        promise = $timeout(function () {
                            tableCtrl.search(evt.target.value, scope.predicate || '');
                            promise = null;
                        }, throttle);
                    });
                }
            }
        }])
})(angular);

(function (ng) {
    'use strict';
    ng.module('smart-table')
        .directive('stSelectRow', function () {
            return {
                restrict: 'A',
                require: '^stTable',
                scope: {
                    row: '=stSelectRow'
                },
                link: function (scope, element, attr, ctrl) {
                    var mode = attr.stSelectMode || 'single';
                    element.bind('click', function () {
                        scope.$apply(function () {
                            ctrl.select(scope.row, mode);
                        });
                    });

                    scope.$watch('row.isSelected', function (newValue, oldValue) {
                        if (newValue === true) {
                            element.addClass('st-selected');
                        } else {
                            element.removeClass('st-selected');
                        }
                    });
                }
            }
        });
})(angular);

(function (ng) {
    'use strict';
    ng.module('smart-table')
        .directive('stSort', ['$parse', function ($parse) {
            return {
                restrict: 'A',
                require: '^stTable',
                link: function (scope, element, attr, ctrl) {

                    var predicate = attr.stSort;
                    var getter = $parse(predicate);
                    var index = 0;
                    var states = ['descent', 'ascent', 'natural'];

                    function reset() {
                        index = 0;
                        element
                            .removeClass('st-sort-ascent')
                            .removeClass('st-sort-descent');
                    }

                    if (ng.isFunction(getter(scope))) {
                        predicate = getter(scope);
                    }

                    element.bind('click', function sortClick() {
                        if (predicate) {
                            scope.$apply(function () {
                                index++;
                                var stateIndex = index % 2;
                                if (index % 3 === 0) {
                                    //manual reset
                                    ctrl.tableState().sort = {};
                                    ctrl.tableState().pagination.start = 0;
                                } else {
                                    ctrl.sortBy(predicate, stateIndex === 0);
                                    element
                                        .removeClass('st-sort-' + states[(stateIndex + 1) % 2])
                                        .addClass('st-sort-' + states[stateIndex]);
                                }
                            });
                        }
                    });

                    scope.$watch(function () {
                        return ctrl.tableState().sort;
                    }, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            if (newValue.predicate !== predicate) {
                                reset();
                            }
                        }
                    }, true);

                }
            };
        }])
})(angular);

(function (ng) {
    'use strict';
    ng.module('smart-table')
        .directive('stPagination', function () {
            return {
                restrict: 'EA',
                require: '^stTable',
                scope: {},
                template: '<div class="pagination"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li></ul></div>',
                replace: true,
                link: function (scope, element, attrs, ctrl) {

                    function isNotNan(value) {
                        return !(typeof value === 'number' && isNaN(value));
                    }

                    var itemsByPage = isNotNan(parseInt(attrs.stItemsByPage, 10)) == true ? parseInt(attrs.stItemsByPage, 10) : 10;
                    var displayedPages = isNotNan(parseInt(attrs.stDisplayedPages, 10)) == true ? parseInt(attrs.stDisplayedPages, 10) : 5;

                    scope.currentPage = 1;
                    scope.pages = [];


                    scope.$watch(function () {
                            return ctrl.tableState().pagination;
                        },
                        function () {
                            var paginationState = ctrl.tableState().pagination;
                            var start = 1;
                            var end;
                            var i;
                            scope.currentPage = Math.floor(paginationState.start / paginationState.number) + 1;

                            start = Math.max(start, scope.currentPage - Math.abs(Math.floor(displayedPages / 2)));
                            end = start + displayedPages;

                            if (end > paginationState.numberOfPages) {
                                end = paginationState.numberOfPages + 1;
                                start = Math.max(1, end - displayedPages);
                            }

                            scope.pages = [];
                            scope.numPages = paginationState.numberOfPages;

                            for (i = start; i < end; i++) {
                                scope.pages.push(i);
                            }


                        }, true);

                    scope.selectPage = function (page) {
                        if (page > 0 && page <= scope.numPages) {
                            ctrl.slice((page - 1) * itemsByPage, itemsByPage);
                        }
                    };

                    //select the first page
                    ctrl.slice(0, itemsByPage);
                }
            };
        });
})(angular);

(function (ng) {
    'use strict';
    ng.module('smart-table')
        .directive('stPipe', function () {
            return {
                require: 'stTable',
                scope: {
                    stPipe: '='
                },
                link: function (scope, element, attrs, ctrl) {

                    if (ng.isFunction(scope.stPipe)) {
                        ctrl.preventPipeOnWatch();
                        ctrl.pipe = scope.stPipe.bind(ctrl, ctrl.tableState());
                    }
                }
            };
        });
})(angular);
(function () {
    'use strict';

    angular.module('BlurAdmin.pages', [
        'ui.router',
        'Radico.services',


        //Orders
        //'radico.pages.psorders',
        //'radico.pages.psorders.search',  

        //Old WorkList
        /*'radico.pages.worklist',*/

        //New WorkList
        'radico.pages.worklistLite',

        'radico.pages.techno',
        'radico.pages.physician-worklist',
        //acount
        'radico.pages.account',
        'radico.pages.account.list',

        //Settings
        'radico.pages.settings',
        'radico.pages.settings.managelocation',
        /*'radico.pages.settings.userpreference',*/
        'radico.pages.settings.oncall',
        'radico.pages.settings.mapping',
        'radico.pages.settings.rule',
        'radico.pages.settings.lookup',
        'radico.pages.settings.timerticker',
        //'radico.pages.settings.techform',
        'radico.pages.settings.paymentcontract',
        'radico.pages.settings.tatnotification',
        'radico.pages.settings.updateviewer',

        //Schedule
        'radico.pages.schedule',
        'radico.pages.schedule.shiftClassification',
        'radico.pages.schedule.shiftConfiguration',
        'radico.pages.schedule.schedulSetting',
        'radico.pages.schedule.addEditSchedule',
        //'radico.pages.schedule.userSchedule',

        //Profile
        'radico.pages.profile',
        'radico.pages.questionnaire',


        //Schedule
        //'radico.pages.physician_schedule',

        //CAP
        //'radico.pages.cap',

        //Address Book
        /*'radico.pages.addressbook',*/
        'radico.pages.addressbook.list',

        //Analytics
        //'radico.pages.analytics',
        
        'radico.pages.iewarning',
        'radico.pages.payment-dashboard',

        'radico.pages.userAnalytics',

        'radico.pages.revieworder',

        'radico.pages.paymentinvoice',

        'radico.pages.prtg',

        'radico.pages.paymentinvoice-history',

        'radico.pages.campaign',

        'radico.pages.newsletter'

    ])
        .config(routeConfig);



    ///** @ngInject */
    function routeConfig($urlRouterProvider, $stateProvider) {
        $stateProvider.state('Login', {
            templateUrl: 'app/pages/auth/login.html'
        });
        $stateProvider.state('Home', {
            templateUrl: 'app/pages/home/home.html'
        });
        $stateProvider.state('PrivacyPolicy', {
            templateUrl: 'app/pages/policy/privacypolicy.html'
        });
        $stateProvider.state('TermsOfUse', {
            templateUrl: 'app/pages/policy/termsofuse.html'
        });


        

        // ui-router 0.3.x: otherwise(function) is invoked as rule($injector, $location) —
        // not ($match, $state, $location). For password-reset links, activate Login while
        // leaving the hash query intact so loginController can read resetpwdparams.
        $urlRouterProvider.otherwise(function ($injector, $location) {
            if (/[?&]resetpwdparams=/.test(window.location.href)) {
                $injector.get('$state').go('Login');
                return;
            }
            $location.url('/home');
        });
    }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.account', ['ui.grid'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('account', {
                url: '/account',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
                abstract: true,
                title: 'Account',
                params: { roles: ['SuperAdmin', 'Admin'] },
                sidebarMeta: {
                    icon: 'ion-ios-folder-outline',
                    order: 100,
                },
                resolve: {
                    //...
                }
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.addressbook', ['ui.grid'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('addressbook', {
                url: '/addressbook',
                templateUrl: 'app/pages/addressbook/addressbook.html',
                title: 'Address Book',
                controller: "appAddressBookController",
                controllerAs: "appCtrl",
                params: { roles: ['SuperAdmin', 'Admin', 'UTMBManager', 'User'], OD: null },
                sidebarMeta: {
                    icon: 'ion-clipboard',
                    order: 104,
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('radico.pages.analytics', ['ui.grid']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('analytics', {
            url: '/analytics',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/analytics/analytics.html',
            //abstract: true,
            controller: "AnalyticsController",
            controllerAs: "AnalyticsCtrl",
            params: { roles: ['SuperAdmin', 'Admin'] }, 
            //params: { roles: ['Technologist'] }, 
            title: 'Analytics',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 106,
            }
        })
    }
    //$urlRouterProvider.when('/worklist', '/worklist/worklist');
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.cap', ['ui.grid'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('cap', {
                url: '/cap',
                templateUrl: 'app/pages/cap/cap.html',
                title: 'CAP',
                controller: "CAPController",
                controllerAs: "capctrl",
                params: { roles: ['SuperAdmin', 'Admin', 'UTMBManager', 'User'], OD: null },
                sidebarMeta: {
                    icon: 'ion-clipboard',
                    order: 104,
                }
            })
            //.state('cap-worklist', {
            //    url: '/cap-worklist',
            //    //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            //    templateUrl: 'app/pages/cap/worklist/cap-worklist.html',
            //    //abstract: true,
            //    controller: "CAPWorklistController",
            //    controllerAs: "ctrl",
            //    params: { roles: ['SuperAdmin', 'Admin', 'UTMBManager', 'CAPUser', 'CAPAdmin'], pageData: null },
            //    title: 'CAP Worklist',
            //    sidebarMeta: {
            //        icon: 'ion-clipboard',
            //        order: 100,
            //    }
            //})
            .state('cap-details', {
                url: '/cap-details',
                //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
                templateUrl: 'app/pages/cap/details/cap-details.html',
                //abstract: true,
                controller: "CAPDetailsController",
                controllerAs: "ctrl",
                params: { roles: ['SuperAdmin', 'Admin', 'UTMBManager', 'User'], pageData: null, capObj: null },
                title: 'CAP Details',
                //sidebarMeta: {
                //    icon: 'ion-clipboard',
                //    order: 100,
                //}
            });
    }

})();

(function () {
    'use strict';

    angular.module('radico.pages.iewarning', ['ui.grid']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('iewarning', {
            url: '/iewarning',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/iewarning/iewarning.html',
            //abstract: true,
            controller: "iewarningController",
            controllerAs: "iewarningCtrl",
            params: { },
            title: 'iewarning',
            //sidebarMeta: {
            //    icon: 'ion-clipboard',
            //    order: 100,
            //}
        });
    }
    //$urlRouterProvider.when('/iewarning', '/iewarning/iewarning');
})();
(function () {
    'use strict';

    angular.module('radico.pages.payment-dashboard', ['ui.grid'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('payment-dashboard', {
                url: '/payment-dashboard',
                templateUrl: 'app/pages/payment-dashboard/payment-dashboard.html',
                title: 'PaymentDashboard',
                controller: "PaymentDashboardController",
                controllerAs: "PaymentDashboardCtrl",
            });

    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.paymentinvoice', ['ui.grid'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('paymentinvoice', {
                url: '/paymentinvoice',
                templateUrl: 'app/pages/paymentinvoice/paymentinvoice.html',
                title: 'Payment Invoices',
                controller: "PaymentInvoiceController",
                controllerAs: "accListCtrl",
                sidebarMeta: {
                    icon: 'ion-ios-folder-outline',
                    order: 100,
                },
                params: { roles: ['Financier'] },
            });

    }

})();
(function () {
    'use strict';

    angular.module('radico.pages.paymentinvoice-history', ['ui.grid']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('paymentinvoice-history', {
            url: '/payment-invoice-history',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/paymentinvoice-history/paymentinvoice-history.html',
            //abstract: true,
            controller: "PaymentInvoiceHistoryController",
            controllerAs: "PaymentInvoiceHistoryCtrl",
            //params: { roles: ['SuperAdmin', 'Admin', 'UTMBManager', 'User'] }, 
            params: { roles: ['User'], TourFlag: false },
            title: 'Payment Invoice History',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 100,
            }
        });
    }
    //$urlRouterProvider.when('/worklist', '/worklist/worklist');
})();
(function () {
    'use strict';

    angular.module('radico.pages.physician-worklist', ['ui.grid']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('physician-worklist', {
            url: '/physician-worklist',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/physician-worklist/physician-worklist.html',
            //abstract: true,
            controller: "PhysicianWorklistController",
            controllerAs: "PhysicianCtrl",
            //params: { roles: ['SuperAdmin', 'Admin', 'UTMBManager', 'User'] }, 
            params: { roles: ['Physician'], TourFlag: false },
            title: 'Physician Worklist',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 100,
            }
        });
    }
    //$urlRouterProvider.when('/worklist', '/worklist/worklist');
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.physician_schedule', ['ui.grid'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('schedule', {
                url: '/schedule',
                templateUrl: 'app/pages/physician_schedule/schedule.html',
                title: 'Schedule',
                controller: "ScheduleController",
                controllerAs: "accListCtrl",
                sidebarMeta: {
                    icon: 'ion-ios-folder-outline',
                    order: 100,
                },
                params: { roles: [] },
            });

    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.profile', ['ui.grid'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('profile', {
                url: '/profile',
                templateUrl: 'app/pages/profile/userprofile.html',
                title: 'User Profile',
                params: { PageName: null },
                controller: "AccountManagerListController",
                controllerAs: "accListCtrl"
            });

    }

})();

(function () {
    'use strict';

    angular.module('radico.pages.prtg', ['ui.grid']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('prtg', {
            url: '/prtg',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/prtg/prtg.html',
            //abstract: true,
            controller: "PRTGController",
            controllerAs: "PRTGCtrl",
            params: { roles: ['SuperAdmin', 'Admin'] },
            //params: { roles: ['Technologist'] }, 
            title: 'PRTG',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 106,
            }
        })
    }
    //$urlRouterProvider.when('/worklist', '/worklist/worklist');
})();
(function () {
    'use strict';

    angular.module('radico.pages.psorders', ['ui.grid']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('psorders', {
            url: '/psorders',
            template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            abstract: true,
            title: 'PSOrders',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 100,
            }
        });
    }

})();
(function () {
    'use strict';

    angular.module('radico.pages.questionnaire', ['ui.grid'
        ,'radico.pages.questionnaire.shared'
    ]).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('questionnaire', {
            url: '/questionnaire',
            template: '<order-questionnaire-form order-id="2167549"></order-questionnaire-form>',
            //abstract: true,
            title: 'questionnaire',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 100,
            }
        });
    }

})();
(function () {
    'use strict';

    angular.module('radico.pages.revieworder', ['ui.grid']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('revieworder', {
            url: '/revieworder',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/revieworder/revieworder.html',
            //abstract: true,
            controller: "ReviewOrderController",
            controllerAs: "ReviewOrderCtrl",
            params: { roles: ['User'], TourFlag: false },
            title: 'Peer Review',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 105,
            }
        });
    }
    //$urlRouterProvider.when('/worklist', '/worklist/worklist');
})();
(function () {
    'use strict';

    angular.module('radico.pages.schedule', []).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('schedule', {
            url: '/schedule',
            template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            abstract: true,
            title: 'Schedule',
            //params: { roles: ['SelfPayUser', 'DellUser', 'MBMS'] }, 
            params: {
                roles: ['Scheduler','User']
            },
            sidebarMeta: {
                icon: 'ion-settings',
                order: 100,
            }
        });
    }

})();
(function () {
    'use strict';

    angular.module('radico.pages.settings', ['ui.grid']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('settings', {
            url: '/settings',
            template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            abstract: true,
            title: 'Settings',
            //params: { roles: ['SelfPayUser', 'DellUser', 'MBMS'] }, 
            params: {
                roles: ['SuperAdmin', 'Admin', 'UTMBManager'] }, 
            sidebarMeta: {
                icon: 'ion-settings',
                order: 100,
            }
        });
    }

})();
(function () {
    'use strict';

    angular.module('radico.pages.techno', ['ui.grid'
        , 'radico.pages.questionnaire'
    ]).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('techno', {
            url: '/techno',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/techno/techno.html',
            //abstract: true,
            controller: "TechnoController",
            controllerAs: "TechnoCtrl",
            //params: { roles: ['SuperAdmin', 'Admin', 'UTMBManager', 'User'] }, 
            params: { roles: ['Technologist'], TourFlag: false },
            title: 'Technologist Worklist',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 100,
            }
        });
    }
    //$urlRouterProvider.when('/worklist', '/worklist/worklist');
})();
(function () {
    'use strict';

    angular.module('radico.pages.userAnalytics', ['ui.grid']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('userAnalytics', {
            url: '/user-Analytics',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/user-analytics/user-analytics.html',
            //abstract: true,
            controller: "UserAnalyticsController",
            controllerAs: "UserAnalyticsCtrl",
            params: { roles: ['Analytics'] },
            title: 'Analytics',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 100,
            }
        });
    }
    //$urlRouterProvider.when('/worklist', '/worklist/worklist');
})();
(function () {
    'use strict';

    angular.module('radico.pages.worklist', ['ui.grid', 'radico.pages.shared.services']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('worklist', {
            url: '/worklist',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/worklist/worklist.html',
            //abstract: true,
            controller: "WorklistController",
            controllerAs: "WorklistCtrl",
            params: { roles: [], OD: null },
            title: 'Worklist (Single View)',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 100,
            }
        });
    }
    //$urlRouterProvider.when('/worklist', '/worklist/worklist');
})();
(function () {
    'use strict';

    angular.module('radico.pages.worklistLite', ['ui.grid', 'radico.pages.shared.services']).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('worklist-lite', {
            url: '/worklist-lite',
            //templateUrl: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            templateUrl: 'app/pages/worklist-async/worklist-async.html',
            //abstract: true,
            controller: "WorklistAsyncController",
            controllerAs: "WorklistAsyncCtrl",
            params: { roles: ['User'], OD: null, TourFlag: false },
            title: 'Worklist',
            sidebarMeta: {
                icon: 'ion-clipboard',
                order: 100,
            }
        });
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components',[]);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.account.list', ['ui.grid'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('account.list', {
                url: '/list',
                title: 'Manager',
                templateUrl: 'app/pages/account/list/list.html',
                controller: "AccountManagerListController",
                controllerAs: "accListCtrl",
                sidebarMeta: {
                    icon: 'ion-share',
                    order: 0,
                },
                params: { roles: ['SuperAdmin', 'Admin'] },
            });

        $urlRouterProvider.when('/account/list', '/account/list');

    }

})();

(function () {
    'use strict';

    angular.module('radico.pages.addressbook.list', ['ui.grid'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('addressbooklist', {
                url: '/addressbooklist',
                templateUrl: 'app/pages/addressbook/list/addressbook_list.html',
                title: 'Address Book',
                controller: "AddressBookListController",
                controllerAs: "AddressCtrl",
                params: { roles: ['SuperAdmin', 'Admin','User'], OD: null },
                sidebarMeta: {
                    icon: 'ion-clipboard',
                    order: 104,
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('radico.pages.psorders.search', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('psorders.search', {
            url: '/search',
            templateUrl: 'app/pages/psorders/search/search.html',
            abstract: true,
            controller: 'PSOrdersSearchController',
            title: 'Search',
            controllerAs: 'tabCtrl',
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        }).state('psorders.search.list', {
            url: '/list',
            templateUrl: 'app/pages/psorders/search/list/list.html',
            title: 'Patient List',
            controller: "PSOrdersSearchListController",
            controllerAs: "listCtrl"
        }).state('psorders.search.detail', {
            url: '/detail',
            templateUrl: 'app/pages/psorders/search/detail/detail.html',
            title: 'Orders Detail',
            params: { 'Id': null },
            controller: "PSOrderslistDetailController",
            controllerAs: "detailCtrl"
        });

        $urlRouterProvider.when('/psorders/search', '/psorders/search/list');
    }
})();
(function () {
    'use strict';

    angular.module('radico.pages.schedule.addEditSchedule', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('schedule.addEditSchedule', {
            url: '/add-edit-schedule',
            templateUrl: 'app/pages/schedule/add-edit-schedule/addEditSchedule.html',
            controller: 'addEditScheduleCtrl',
            title: 'Schedule',
            controllerAs: 'addEditScheduleCtrl',
            params: { roles: ['Scheduler', 'User'] },
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });

        $urlRouterProvider.when('/settings/add-edit-schedule', '/settings/add-edit-schedule');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.schedule.schedulSetting', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('schedule.schedulSetting', {
            url: '/schedule-setting',
            templateUrl: 'app/pages/schedule/schedule-setting/schedule-setting.html',
            controller: 'schedulSettingCtrl',
            title: 'Schedule Setting',
            controllerAs: 'schedulSettingCtrl',
            params: { roles: ['Scheduler'] },
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });

        $urlRouterProvider.when('/settings/schedule-setting', '/settings/schedule-setting');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.schedule.shiftClassification', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('schedule.shiftClassification', {
            url: '/shift-classification',
            templateUrl: 'app/pages/schedule/shift-classification/shiftClassification.html',
            controller: 'shiftClassificationCtrl',
            title: 'Shift Classification',
            controllerAs: 'shiftClassificationCtrl',
            params: { roles: ['Scheduler'] },
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });

        $urlRouterProvider.when('/settings/shift-classification', '/settings/shift-classification');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.schedule.shiftConfiguration', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('schedule.shiftConfiguration', {
            url: '/shift-configuration',
            templateUrl: 'app/pages/schedule/shift-configuration/shiftConfiguration.html',
            controller: 'shiftConfigurationCtrl',
            title: 'Shift Configuration',
            controllerAs: 'shiftConfigurationCtrl',
            params: { roles: ['Scheduler'] },
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });

        $urlRouterProvider.when('/settings/shift-configuration', '/settings/shift-configuration');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.schedule.userSchedule', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('schedule.userSchedule', {
            url: '/user-schedule',
            templateUrl: 'app/pages/schedule/user-schedule/user-schedule.html',
            controller: 'userScheduleCtrl',
            title: 'Schedule',
            controllerAs: 'userScheduleCtrl',
            params: { roles: [] }, 
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });

        $urlRouterProvider.when('/settings/user-schedule', '/settings/user-schedule');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.settings.lookup', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.lookup', {
            url: '/lookup',
            templateUrl: 'app/pages/settings/lookup/lookup.html',
            controller: 'LookupController',
            title: 'Lookup',
            controllerAs: 'tabCtrl',
            params: { roles: ['SuperAdmin', 'Admin'] }, 
            sidebarMeta: {
                icon: 'ion-share',
                order: 2
            }
        });

        $urlRouterProvider.when('/settings/lookup', '/settings/lookup');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.settings.managelocation', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.managelocation', {
            url: '/managelocation',
            templateUrl: 'app/pages/settings/managelocation/managelocation.html',            
            controller: 'ManageLocationController',
            title: 'Manage Location',
            controllerAs: 'tabCtrl',
            params: { roles: ['SuperAdmin', 'Admin'] }, 
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });

        $urlRouterProvider.when('/settings/managelocation', '/settings/managelocation');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.settings.mapping', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.mapping', {
            url: '/mapping',
            templateUrl: 'app/pages/settings/mapping/mapping.html',
            controller: 'MappingController',
            title: 'Mapping',
            params: { roles: ['SuperAdmin', 'Admin'] },
            controllerAs: 'tabCtrl',
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });

        $urlRouterProvider.when('/settings/mapping', '/settings/mapping');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.settings.oncall', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.oncall', {
            url: '/oncall',
            templateUrl: 'app/pages/settings/oncall/oncallschedule.html',
            controller: 'OnCallScheduleController',
            title: 'On Call',
            controllerAs: 'tabCtrl',
            params: { roles: ['SuperAdmin', 'Admin'] }, 
            sidebarMeta: {
                icon: 'ion-share',
                order: 2
            }
        });

        $urlRouterProvider.when('/settings/oncall', '/settings/oncall');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.settings.paymentcontract', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.paymentcontract', {
            url: '/paymentcontract',
            templateUrl: 'app/pages/settings/paymentcontract/paymentcontract.html',
            controller: 'PaymentContractController',
            title: 'Payment Contract',
            controllerAs: 'PaymentContractCtrl',
            params: { roles: ['SuperAdmin', 'Admin'] },
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });

        $urlRouterProvider.when('/settings/paymentcontract', '/settings/paymentcontract');
    }
})();
(function () {
    'use strict';

    angular.module('radico.pages.settings.rule', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.rule', {
            url: '/rule',
            templateUrl: 'app/pages/settings/rule/rule.html',
            controller: 'RuleController',
            title: 'Rule(s)',
            controllerAs: 'tabCtrl',
            params: { roles: ['SuperAdmin', 'Admin'] }, 
            sidebarMeta: {
                icon: 'ion-share',
                order: 2
            }
        });

        $urlRouterProvider.when('/settings/rule', '/settings/rule');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.settings.tatnotification', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.tatnotification', {
            url: '/tat-notification',
            templateUrl: 'app/pages/settings/tat-notification/tat-notification.html',
            controller: 'tatNotifationCtrl',
            title: 'TAT Notification',
            controllerAs: 'tatNotifationCtrl',
            params: { roles: ['SuperAdmin', 'Admin'] },
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });

        $urlRouterProvider.when('/settings/notification', '/settings/notification');
    }
})();
(function () {
    'use strict';

    angular.module('radico.pages.settings.techform', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.techform', {
            url: '/techform',
            templateUrl: 'app/pages/settings/techform/techform.html',
            controller: 'TechFormController',
            abstract: true,
            title: 'Tech Form',
            controllerAs: 'tabCtrl',
            params: { roles: [] }, 
            sidebarMeta: {
                icon: 'ion-share',
                order: 2
            }
        }).state('settings.techformlist', {
            url: '/techformlist',
            templateUrl: 'app/pages/settings/techform/techformlist/techformlist.html',
            controller: 'TechFormListController',
            title: 'Tech Form',
            controllerAs: 'tabCtrl',
            params: { 'filterData': null,roles: [] }
        }).state('settings.techformdetails', {
            url: '/techformdetails',
            templateUrl: 'app/pages/settings/techform/techformdetails/techformdetails.html',
            controller: 'TechFormDetailsController',
            title: 'Tech Form',
            controllerAs: 'tabCtrl',
            params: { 'Template': null,'filterData':null, roles: [] }
        });

        $urlRouterProvider.when('/settings/techform', '/settings/techformlist');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.settings.timerticker', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.timerticker', {
            url: '/timer-ticker',
            templateUrl: 'app/pages/settings/timer-ticker/timer-ticker.html',
            controller: 'TimerTickerController',
            title: 'Timer Ticker',
            controllerAs: 'tabCtrl',
            params: { roles: ['SuperAdmin', 'Admin'] },
            sidebarMeta: {
                icon: 'ion-clock',
                order: 10
            }
        });

        $urlRouterProvider.when('/settings/timer-ticker', '/settings/timer-ticker');
    }
})();



(function () {
    'use strict';

    angular
        .module('radico.pages.settings.updateviewer', [])
        .config(routeConfig);

    routeConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider.state('settings.updateviewer', {
            url: '/updateviewer',
            templateUrl: 'app/pages/settings/update-viewer/update-viewer.html',
            controller: 'UpdateViewerController',
            title: 'Update Viewer',
            controllerAs: 'vm',
            params: { roles: ['SuperAdmin'] },
            sidebarMeta: {
                icon: 'ion-eye',
                order: 0
            }
        });

        $urlRouterProvider.when('/settings/updateviewer', '/settings/updateviewer');
    }
})();

(function () {
    'use strict';

    angular.module('radico.pages.settings.userpreference', []).config(routeConfig);


    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('settings.userpreference', {
            url: '/userpreference',
            templateUrl: 'app/pages/settings/userpreference/userpreference.html',            
            controller: 'UserPreferenceController',
            title: 'User Preference',
            params: {
                roles: ['SuperAdmin', 'Admin', 'UTMBManager', 'User'] }, 
            controllerAs: 'tabCtrl',
            sidebarMeta: {
                icon: 'ion-share',
                order: 0,
            }
        });  
        $urlRouterProvider.when('/settings/userpreference', '/settings/userpreference');
    }
})();   
(function () {
    'use strict';

    angular.module('radico.pages.shared.services', []);
}());
(function () {
    'use strict';

    angular.module('radico.pages.questionnaire.shared', []);


})();
 'use strict';
agGrid.LicenseManager.setLicenseKey('Using_this_AG_Grid_Enterprise_key_( AG-045656 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Collaborative Imaging )_is_granted_a_( Single Application )_Developer_License_for_the_application_( Collaborative Imaging )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( Collaborative Imaging )_need_to_be_licensed___( Collaborative Imaging )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 25 July 2024 )____[v2]_MTcyMTg2MjAwMDAwMA==9c66307a785c71ab80881987a09b9adf');
agCharts.LicenseManager.setLicenseKey('Using_this_{AG_Charts}_Enterprise_key_{AG-060441}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Collaborative_Imaging}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Radflow}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Radflow}_need_to_be_licensed___{Radflow}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts}_Enterprise_versions_released_before_{21_May_2025}____[v3]_[02]_MTc0Nzc4MjAwMDAwMA==743fd2a6c0720fe994f03d8f45ea8255');
var env = {};

// Import variables if present (from env.js)
if (window) {
    Object.assign(env, window.__env);
}
var app = angular.module('BlurAdmin', [
    'mc.resizer',
    'ngAnimate',
    'ui.bootstrap',
    'ui.bootstrap.contextMenu',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'ngStorage',
    'toastr',
    'smart-table',
    'ngTable',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'restangular',
    'angular-progress-button-styles',
    'auth.controllers',
    'BlurAdmin.theme',
    'BlurAdmin.pages',
    'dataGrid',
    'pagination',
    'threeStateCheckbox',
    'pdf',
    'ngSanitize',
    'ui.select',
    'oitozero.ngSweetAlert',
    'kendo.directives',
    'services.hub',
    'ngIdle',
    'daterangepicker',
    'lrDragNDrop',
    'ang-drag-drop',
    'ui-notification',
    'infinite-scroll',
    'ui.grid',
    'ui.grid.infiniteScroll',
    'ui.grid.selection',
    'ui.grid.moveColumns',
    'ui.grid.autoResize',
    'ui.grid.expandable',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ngDraggable',
    'ui.grid.treeView',
    'angularResizable',
    'toaster',
    'ngTagsInput',
]);

// Configure the application
app.config(function (RestangularProvider, $httpProvider, IdleProvider, KeepaliveProvider, toastrConfig) {
    RestangularProvider.setBaseUrl(__env._environment.config.apiResourceServiceBaseUri);
    $httpProvider.defaults.headers.put['Content-Type'] = 'application/json';
    $httpProvider.defaults.headers.post['Content-Type'] = 'application/json';
    $httpProvider.interceptors.push('authHttpResponseInterceptor');
    IdleProvider.idle(__env._environment.config.idletimeout);
    IdleProvider.timeout(60);
    KeepaliveProvider.interval(10);
    angular.extend(toastrConfig, {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": false,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
        "allowHtml": true,
        "preventOpenDuplicates": true
    });
    
    //#region --app logger enable/disable code 
    try {
        if (__env.appLogSetting) {
            __env.appLogSetting.sysConsole = window.console;
            __env.appLogSetting.appConsole = {
                debug: function () { },
                trace: function () { },
                log: function () { },
                info: function () { },
                warn: function () { },
                error: __env.appLogSetting.sysConsole.error
            };
            __env.appLogSetting.enableConsole = function (isEnable) {
                if (isEnable) {
                    window.console = __env.appLogSetting.sysConsole;
                } else {
                    window.console = __env.appLogSetting.appConsole;
                }
            }
            __env.appLogSetting.enableConsole(__env.appLogSetting.isEnabled);
        }
    } catch (e) {
        console.error("appLogSetting is not defined in config.js")
    }
    //#endregion --app logger enable/disable code 
});
app.constant('__env', env);
app.constant('APP_CONSTANTS', {
    radflowUIVersion: radflowUIVersion,
    clientId: 'RadicoApp',
});
app.filter('propsFilter', function () {
    return function (items, props) {
        var out = [];

        if (angular.isArray(items)) {
            var keys = Object.keys(props);

            items.forEach(function (item) {
                var itemMatches = false;

                for (var i = 0; i < keys.length; i++) {
                    var prop = keys[i];
                    var text = props[prop].toLowerCase();
                    if (item[prop] && item[prop].toString().toLowerCase().indexOf(text) === 0) {
                        itemMatches = true;
                        break;
                    }
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // Let the output be the input untouched
            out = items;
        }

        return out;
    };
});
app.filter('propsFilterStartWith', function () {
    return function (items, props) {
        var out = [];

        if (angular.isArray(items)) {
            var keys = Object.keys(props);

            items.forEach(function (item) {
                var itemMatches = false;

                for (var i = 0; i < keys.length; i++) {
                    var prop = keys[i];
                    var text = props[prop].toLowerCase();
                    if (item[prop].toString().toLowerCase().indexOf(text) === 0) {
                        itemMatches = true;
                        break;
                    }
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // Let the output be the input untouched
            out = items;
        }

        return out;
    };
});
app.filter('titleCase', function () {
    return function (input) {
        input = input || '';
        return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };
});
app.filter('UpperCase', function () {
    return function (input) {
        input = input || '';
        return input.replace(/\w\S*/g, function (txt) { return txt.toUpperCase(); });
    };
});
app.constant("keyCodes", {
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    NUMPAD_0: 96,
    NUMPAD_1: 97,
    NUMPAD_2: 98,
    NUMPAD_3: 99,
    NUMPAD_4: 100,
    NUMPAD_5: 101,
    NUMPAD_6: 102,
    NUMPAD_7: 103,
    NUMPAD_8: 104,
    NUMPAD_9: 105,
    NUMPAD_MULTIPLY: 106,
    NUMPAD_ADD: 107,
    NUMPAD_ENTER: 108,
    NUMPAD_SUBTRACT: 109,
    NUMPAD_DECIMAL: 110,
    NUMPAD_DIVIDE: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    F13: 124,
    F14: 125,
    F15: 126,
    COLON: 186,
    EQUALS: 187,
    UNDERSCORE: 189,
    QUESTION_MARK: 191,
    TILDE: 192,
    OPEN_BRACKET: 219,
    BACKWARD_SLASH: 220,
    CLOSED_BRACKET: 221,
    QUOTES: 222,
    BACKSPACE: 8,
    TAB: 9,
    CLEAR: 12,
    ENTER: 13,
    SHIFT: 16,
    CONTROL: 17,
    ALT: 18,
    CAPS_LOCK: 20,
    ESC: 27,
    SPACEBAR: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    INSERT: 45,
    DELETE: 46,
    HELP: 47,
    NUM_LOCK: 144
});
app.directive("keyboard", function keyboard($document, keyCodes) {
    return {
        link: function (scope, element, attrs) {
            var keysToHandle = scope.$eval(attrs.keyboard);
            var keyHandlers = {};
            // Registers key handlers
            angular.forEach(keysToHandle, function (callback, keyName) {
                var keyCode = keyCodes[keyName];
                keyHandlers[keyCode] = { callback: callback, name: keyName };
            });
            // Bind to document keydown event
            $document.on("keydown", function (event) {
                var keyDown = keyHandlers[event.keyCode];
                // Handler is registered
                if (keyDown) {
                    event.preventDefault();
                    // Invoke the handler and digest
                    scope.$apply(function () {
                        keyDown.callback(keyDown.name, event.keyCode);
                    })
                }
            });
        }
    };
});
app.directive('ngRightClick', function ($parse) {
    return function (scope, element, attrs) {
        var fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function (event) {
            scope.$apply(function () {
                event.preventDefault();
                fn(scope, { $event: event });
            });
        });
    };
});
app.run(function ($window, $rootScope) {
    $rootScope.IsConnectionOnline = navigator.onLine;
    $window.addEventListener("offline", function () {
        $rootScope.$apply(function () {
            $rootScope.IsConnectionOnline = false;
        });
    }, false);
    $window.addEventListener("online", function () {
        $rootScope.$apply(function () {
            $rootScope.IsConnectionOnline = true;
        });
    }, false);
});
app.filter('tel', function () {
    return function (tel) {
        if (!tel) { return ''; }

        var value = tel.toString().trim().replace(/^\+/, '');
        value = value.replace(' ', '');
        if (value.match(/[^0-9]/)) {
            return tel;
        }

        var country, city, number;
        switch (value.length) {
            case 10: // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                number = value.slice(3);
                break;

            case 11: // +CPPP####### -> CCC (PP) ###-####
                country = value[0];
                city = value.slice(1, 4);
                number = value.slice(4);
                break;

            case 12: // +CCCPP####### -> CCC (PP) ###-####
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                number = value.slice(5);
                break;

            default:
                return tel;
        }

        if (country == 1) {
            country = "";
        }
        number = number.slice(0, 3) + '-' + number.slice(3);
        if (country == "") {
            return (country + "(" + city + ") " + number).trim();
        }
        else {
            return (country + "" + city + "-" + number).trim();
        }

    };
});
app.value('uiMaskConfig', {
    'maskDefinitions': {
        '9': /\d/,
        'A': /[a-zA-Z]/,
        '*': /[a-zA-Z0-9]/
    }
});
app.directive('uiMask', ['uiMaskConfig', function (maskConfig) {
    return {
        priority: 100,
        require: 'ngModel',
        restrict: 'A',
        compile: function uiMaskCompilingFunction() {
            var options = maskConfig;

            return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
                var maskProcessed = false, eventsBound = false,
                    maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
                    // Minimum required length of the value to be considered valid
                    minRequiredLength,
                    value, valueMasked, isValid,
                    // Vars for initializing/uninitializing
                    originalPlaceholder = iAttrs.placeholder,
                    originalMaxlength = iAttrs.maxlength,
                    // Vars used exclusively in eventHandler()
                    oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength;

                function initialize(maskAttr) {
                    if (!angular.isDefined(maskAttr)) {
                        return uninitialize();
                    }
                    processRawMask(maskAttr);
                    if (!maskProcessed) {
                        return uninitialize();
                    }
                    initializeElement();
                    bindEventListeners();
                    return true;
                }

                function initPlaceholder(placeholderAttr) {
                    if (!angular.isDefined(placeholderAttr)) {
                        return;
                    }

                    maskPlaceholder = placeholderAttr;

                    // If the mask is processed, then we need to update the value
                    if (maskProcessed) {
                        eventHandler();
                    }
                }

                function formatter(fromModelValue) {
                    if (!maskProcessed) {
                        return fromModelValue;
                    }
                    value = unmaskValue(fromModelValue || '');
                    isValid = validateValue(value);
                    controller.$setValidity('mask', isValid);
                    return isValid && value.length ? maskValue(value) : undefined;
                }

                function parser(fromViewValue) {
                    if (!maskProcessed) {
                        return fromViewValue;
                    }
                    value = unmaskValue(fromViewValue || '');
                    isValid = validateValue(value);
                    // We have to set viewValue manually as the reformatting of the input
                    // value performed by eventHandler() doesn't happen until after
                    // this parser is called, which causes what the user sees in the input
                    // to be out-of-sync with what the controller's $viewValue is set to.
                    controller.$viewValue = value.length ? maskValue(value) : '';
                    controller.$setValidity('mask', isValid);
                    if (value === '' && controller.$error.required !== undefined) {
                        controller.$setValidity('required', false);
                    }
                    return isValid ? value : undefined;
                }

                var linkOptions = {};

                if (iAttrs.uiOptions) {
                    linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
                    if (angular.isObject(linkOptions[0])) {
                        // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
                        linkOptions = (function (original, current) {
                            for (var i in original) {
                                if (Object.prototype.hasOwnProperty.call(original, i)) {
                                    if (!current[i]) {
                                        current[i] = angular.copy(original[i]);
                                    } else {
                                        angular.extend(current[i], original[i]);
                                    }
                                }
                            }
                            return current;
                        })(options, linkOptions[0]);
                    }
                } else {
                    linkOptions = options;
                }

                iAttrs.$observe('uiMask', initialize);
                iAttrs.$observe('placeholder', initPlaceholder);
                controller.$formatters.push(formatter);
                controller.$parsers.push(parser);

                function uninitialize() {
                    maskProcessed = false;
                    unbindEventListeners();

                    if (angular.isDefined(originalPlaceholder)) {
                        iElement.attr('placeholder', originalPlaceholder);
                    } else {
                        iElement.removeAttr('placeholder');
                    }

                    if (angular.isDefined(originalMaxlength)) {
                        iElement.attr('maxlength', originalMaxlength);
                    } else {
                        iElement.removeAttr('maxlength');
                    }

                    iElement.val(controller.$modelValue);
                    controller.$viewValue = controller.$modelValue;
                    return false;
                }

                function initializeElement() {
                    value = oldValueUnmasked = unmaskValue(controller.$modelValue || '');
                    valueMasked = oldValue = maskValue(value);
                    isValid = validateValue(value);
                    var viewValue = isValid && value.length ? valueMasked : '';
                    if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
                        iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
                    }
                    iElement.attr('placeholder', maskPlaceholder);
                    iElement.val(viewValue);
                    controller.$viewValue = viewValue;
                    // Not using $setViewValue so we don't clobber the model value and dirty the form
                    // without any kind of user interaction.
                }

                function bindEventListeners() {
                    if (eventsBound) {
                        return;
                    }
                    //iElement.bind('blur', blurHandler);
                    iElement.bind('mousedown mouseup', mouseDownUpHandler);
                    iElement.bind('input keyup click', eventHandler);
                    eventsBound = true;
                }

                function unbindEventListeners() {
                    if (!eventsBound) {
                        return;
                    }
                    //iElement.unbind('blur', blurHandler);
                    iElement.unbind('mousedown', mouseDownUpHandler);
                    iElement.unbind('mouseup', mouseDownUpHandler);
                    iElement.unbind('input', eventHandler);
                    iElement.unbind('keyup', eventHandler);
                    iElement.unbind('click', eventHandler);
                    eventsBound = false;
                }

                function validateValue(value) {
                    // Zero-length value validity is ngRequired's determination
                    return value.length ? value.length >= minRequiredLength : true;
                }

                function unmaskValue(value) {
                    var valueUnmasked = '',
                        maskPatternsCopy = maskPatterns.slice();
                    // Preprocess by stripping mask components from value
                    value = value.toString();
                    angular.forEach(maskComponents, function (component) {
                        value = value.replace(component, '');
                    });
                    angular.forEach(value.split(''), function (chr) {
                        if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
                            valueUnmasked += chr;
                            maskPatternsCopy.shift();
                        }
                    });
                    return valueUnmasked;
                }

                function maskValue(unmaskedValue) {
                    var valueMasked = '',
                        maskCaretMapCopy = maskCaretMap.slice();

                    angular.forEach(maskPlaceholder.split(''), function (chr, i) {
                        if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
                            valueMasked += unmaskedValue.charAt(0) || '_';
                            unmaskedValue = unmaskedValue.substr(1);
                            maskCaretMapCopy.shift();
                        }
                        else {
                            valueMasked += chr;
                        }
                    });
                    return valueMasked;
                }

                function getPlaceholderChar(i) {
                    var placeholder = iAttrs.placeholder;

                    if (typeof placeholder !== "undefined" && placeholder[i]) {
                        return placeholder[i];
                    } else {
                        return "_";
                    }
                }

                // Generate array of mask components that will be stripped from a masked value
                // before processing to prevent mask components from being added to the unmasked value.
                // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
                // If a maskable char is followed by a mask char and has a mask
                // char behind it, we'll split it into it's own component so if
                // a user is aggressively deleting in the input and a char ahead
                // of the maskable char gets deleted, we'll still be able to strip
                // it in the unmaskValue() preprocessing.
                function getMaskComponents() {
                    return maskPlaceholder.replace(/[_]+/g, '_').replace(/([^_]+)([a-zA-Z0-9])([^_])/g, '$1$2_$3').split('_');
                }

                function processRawMask(mask) {
                    var characterCount = 0;

                    maskCaretMap = [];
                    maskPatterns = [];
                    maskPlaceholder = '';

                    if (typeof mask === 'string') {
                        minRequiredLength = 0;

                        var isOptional = false,
                            splitMask = mask.split("");

                        angular.forEach(splitMask, function (chr, i) {
                            if (linkOptions.maskDefinitions[chr]) {

                                maskCaretMap.push(characterCount);

                                maskPlaceholder += getPlaceholderChar(i);
                                maskPatterns.push(linkOptions.maskDefinitions[chr]);

                                characterCount++;
                                if (!isOptional) {
                                    minRequiredLength++;
                                }
                            }
                            else if (chr === "?") {
                                isOptional = true;
                            }
                            else {
                                maskPlaceholder += chr;
                                characterCount++;
                            }
                        });
                    }
                    // Caret position immediately following last position is valid.
                    maskCaretMap.push(maskCaretMap.slice().pop() + 1);

                    maskComponents = getMaskComponents();
                    maskProcessed = maskCaretMap.length > 1 ? true : false;
                }

                //*************************************************************
                //joe h - this will clear the contents if the input doesn't match the mask
                function blurHandler() {
                    oldCaretPosition = 0;
                    oldSelectionLength = 0;
                    if (!isValid || value.length === 0) {
                        valueMasked = '';
                        iElement.val('');
                        scope.$apply(function () {
                            controller.$setViewValue('');
                        });
                    }
                }

                function mouseDownUpHandler(e) {
                    if (e.type === 'mousedown') {
                        iElement.bind('mouseout', mouseoutHandler);
                    } else {
                        iElement.unbind('mouseout', mouseoutHandler);
                    }
                }

                iElement.bind('mousedown mouseup', mouseDownUpHandler);

                function mouseoutHandler() {
                    oldSelectionLength = getSelectionLength(this);
                    iElement.unbind('mouseout', mouseoutHandler);
                }

                function eventHandler(e) {
                    e = e || {};
                    // Allows more efficient minification
                    var eventWhich = e.which,
                        eventType = e.type;

                    // Prevent shift and ctrl from mucking with old values
                    if (eventWhich === 16 || eventWhich === 91) { return; }

                    var val = iElement.val(),
                        valOld = oldValue,
                        valMasked,
                        valUnmasked = unmaskValue(val),
                        valUnmaskedOld = oldValueUnmasked,
                        valAltered = false,

                        caretPos = getCaretPosition(this) || 0,
                        caretPosOld = oldCaretPosition || 0,
                        caretPosDelta = caretPos - caretPosOld,
                        caretPosMin = maskCaretMap[0],
                        caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),

                        selectionLenOld = oldSelectionLength || 0,
                        isSelected = getSelectionLength(this) > 0,
                        wasSelected = selectionLenOld > 0,

                        // Case: Typing a character to overwrite a selection
                        isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
                        // Case: Delete and backspace behave identically on a selection
                        isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
                        isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes

                        isKeyLeftArrow = eventWhich === 37,
                        // Necessary due to "input" event not providing a key code
                        isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
                        isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0) && !wasSelected),

                        // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
                        // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
                        // non-mask character. Also applied to click since users are (arguably) more likely to backspace
                        // a character when clicking within a filled input.
                        caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;

                    oldSelectionLength = getSelectionLength(this);

                    // These events don't require any action
                    if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup'))) {
                        return;
                    }

                    // Value Handling
                    // ==============

                    // User attempted to delete but raw value was unaffected--correct this grievous offense
                    if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
                        while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
                            caretPos--;
                        }
                        while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
                            caretPos++;
                        }
                        var charIndex = maskCaretMap.indexOf(caretPos);
                        // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
                        valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
                        valAltered = true;
                    }

                    // Update values
                    valMasked = maskValue(valUnmasked);

                    oldValue = valMasked;
                    oldValueUnmasked = valUnmasked;
                    iElement.val(valMasked);
                    if (valAltered) {
                        // We've altered the raw value after it's been $digest'ed, we need to $apply the new value.
                        scope.$apply(function () {
                            controller.$setViewValue(valUnmasked);
                        });
                    }

                    // Caret Repositioning
                    // ===================

                    // Ensure that typing always places caret ahead of typed character in cases where the first char of
                    // the input is a mask char and the caret is placed at the 0 position.
                    if (isAddition && (caretPos <= caretPosMin)) {
                        caretPos = caretPosMin + 1;
                    }

                    if (caretBumpBack) {
                        caretPos--;
                    }

                    // Make sure caret is within min and max position limits
                    caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;

                    // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
                    while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
                        caretPos += caretBumpBack ? -1 : 1;
                    }

                    if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
                        caretPos++;
                    }
                    oldCaretPosition = caretPos;
                    setCaretPosition(this, caretPos);
                }

                function isValidCaretPosition(pos) { return maskCaretMap.indexOf(pos) > -1; }

                function getCaretPosition(input) {
                    if (input.selectionStart !== undefined) {
                        return input.selectionStart;
                    } else if (document.selection) {
                        // Curse you IE
                        input.focus();
                        var selection = document.selection.createRange();
                        selection.moveStart('character', -input.value.length);
                        return selection.text.length;
                    }
                    return 0;
                }

                function setCaretPosition(input, pos) {
                    if (input.offsetWidth === 0 || input.offsetHeight === 0) {
                        return; // Input's hidden
                    }
                    if (input.setSelectionRange) {
                        input.focus();
                        input.setSelectionRange(pos, pos);
                    }
                    else if (input.createTextRange) {
                        // Curse you IE
                        var range = input.createTextRange();
                        range.collapse(true);
                        range.moveEnd('character', pos);
                        range.moveStart('character', pos);
                        range.select();
                    }
                }

                function getSelectionLength(input) {
                    if (input.selectionStart !== undefined) {
                        return (input.selectionEnd - input.selectionStart);
                    }
                    if (document.selection) {
                        return (document.selection.createRange().text.length);
                    }
                    return 0;
                }

                // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
                if (!Array.prototype.indexOf) {
                    Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
                        "use strict";
                        if (this === null) {
                            throw new TypeError();
                        }
                        var t = Object(this);
                        var len = t.length >>> 0;
                        if (len === 0) {
                            return -1;
                        }
                        var n = 0;
                        if (arguments.length > 1) {
                            n = Number(arguments[1]);
                            if (n !== n) { // shortcut for verifying if it's NaN
                                n = 0;
                            } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
                                n = (n > 0 || -1) * Math.floor(Math.abs(n));
                            }
                        }
                        if (n >= len) {
                            return -1;
                        }
                        var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
                        for (; k < len; k++) {
                            if (k in t && t[k] === searchElement) {
                                return k;
                            }
                        }
                        return -1;
                    };
                }

            };
        }
    };
}]);
app.directive('scrollToBottom', function ($timeout, $window) {
    return {
        scope: {
            scrollToBottom: "="
        },
        restrict: 'A',
        link: function (scope, element, attr) {
            scope.$watchCollection('scrollToBottom', function (newVal) {
                if (newVal) {
                    $timeout(function () {
                        element[0].scrollTop = element[0].scrollHeight;
                    }, 0);
                }

            });
        }
    };
});
app.directive('bindHtmlCompile', ['$compile', '$sce', function ($compile, $sce) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch(function () {
                return scope.$eval(attrs.bindHtmlCompile);
            }, function (value) {
                // In case value is a TrustedValueHolderType, sometimes it
                // needs to be explicitly called into a string in order to
                // get the HTML string.

                element.html(value && value.toString());//
                // If scope is provided use it, otherwise use parent scope
                var compileScope = scope;
                //if (attrs.bindHtmlScope) {
                //    compileScope = scope.$eval(attrs.bindHtmlScope);
                //}
                $compile(element.contents())(compileScope);
            });

        }
    };
}]);
app.directive('whenScrollEnds', function ($window) {
    return {
        restrict: "A",
        link: function (scope, elm, attr) {
            //console.log("whenScrollEnds");
            var raw = elm[0];
            //console.log("whenScrollEnds > raw: ", raw);
            raw.addEventListener('scroll', function () {
                //console.log("whenScrollEnds > scroll");
                //console.log("whenScrollEnds > scroll > top: ", raw.scrollTop);
                //console.log("whenScrollEnds > scroll > client height: ", raw.clientHeight);
                //console.log("whenScrollEnds > scroll > scroll height: ", raw.scrollHeight);
                if (raw.scrollTop == 0) {
                    scope.$apply(attr.whenScrollTop);
                } else if ((raw.scrollTop + raw.clientHeight) >= (raw.scrollHeight - 10)) {
                    //console.log("whenScrollEnds > scroll > true");
                    scope.$apply(attr.whenScrollEnds);
                }
            });
        }
    };
});

app.filter('localDate', function () {
    return function (input, text, currentDate, seconds) {
        /**
         * Converts a US Central wall-clock time string (as returned by the database) to a proper
         * UTC Date object.  Uses the browser's built-in Intl / ECMA-402 timezone support so DST
         * transitions (spring-forward and fall-back) are handled automatically without manual
         * boundary calculations.
         *
         * Algorithm:
         *  1. Extract year/month/day/hour/min/sec from the string via a temporary local parse.
         *  2. Make an initial UTC guess at CST offset (UTC-6).
         *  3. Ask the Intl API what US/Chicago Central time that UTC instant maps to.
         *  4. Correct the guess by the difference — one iteration is exact because the CST/CDT
         *     offset only differs by 1 hour, well within the initial guess range.
         *
         * @param {string} centralTimeStr  e.g. "2024-11-03 01:30:00" stored as US Central time
         * @returns {Date}  A Date with the correct UTC millisecond value
         */
        function parseCentralTimeToUTC(centralTimeStr) {
            if (!centralTimeStr) return new Date(NaN);
            var temp = new Date(centralTimeStr.replace(' ', 'T'));
            if (isNaN(temp.getTime())) return new Date(NaN);
            var y = temp.getFullYear(), mo = temp.getMonth(), d = temp.getDate(),
                h = temp.getHours(), min = temp.getMinutes(), s = temp.getSeconds();
            // Initial UTC guess using CST offset (UTC-6)
            var utcGuess = new Date(Date.UTC(y, mo, d, h + 6, min, s));
            // Ask the browser what Central time the guessed UTC instant maps to
            var centralRepr = new Date(utcGuess.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
            // Correct for the true offset (handles CDT automatically)
            var target = new Date(y, mo, d, h, min, s);
            return new Date(utcGuess.getTime() + (target.getTime() - centralRepr.getTime()));
        }
        function getOrderRecievedSince(cstDateTime, currentDate) {
            var fDate = parseCentralTimeToUTC(cstDateTime);
            var tDate = currentDate;

            var delta = Math.abs(fDate - tDate) / 1000;

            var days = Math.floor(delta / 86400);
            delta -= days * 86400;

            var hours = Math.floor(delta / 3600) % 24;
            delta -= hours * 3600;

            var minutes = Math.floor(delta / 60) % 60;
            delta -= minutes * 60;

            var seconds = delta % 60;
            var dDays = days;
            var dHours = hours;
            var dMinutes = minutes;
            var pendingSince = "";
            if (dDays > 0)
                pendingSince += dDays + " DAY";
            if (dHours > 0)
                pendingSince += ", " + dHours + " HR";
            if (dMinutes > 0)
                pendingSince += ", " + dMinutes + " MIN";
            if (pendingSince.startsWith(","))
                pendingSince = pendingSince.substring(2, pendingSince.length);
            return pendingSince;
        }
        /** Coerce API/Dapper values (locale strings, ISO, Date, epoch) before parseCentralTimeToUTC. */
        function normalizeInputToCentralWallString(val) {
            if (val == null || val === '') {
                return '';
            }
            if (angular.isDate(val)) {
                return isNaN(val.getTime()) ? '' : moment(val).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof val === 'number' && isFinite(val)) {
                return moment(val).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof val === 'string') {
                var t = val.trim();
                if (!t) {
                    return '';
                }
                var m = moment(t);
                return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : '';
            }
            return '';
        }

        var normalized = normalizeInputToCentralWallString(input);
        if (!normalized) {
            return '';
        }

        if (!text) {
            var createdDate = parseCentralTimeToUTC(normalized);
            if (isNaN(createdDate.getTime())) {
                return '';
            }
            if (seconds) {
                return (createdDate.getMonth() + 1) + "/" + createdDate.getDate() + "/" + createdDate.getFullYear() + " " + (createdDate.getHours() < 10 ? "0" + createdDate.getHours() : createdDate.getHours()) + ":" + (createdDate.getMinutes() < 10 ? "0" + createdDate.getMinutes() : createdDate.getMinutes()) + ":" + (createdDate.getSeconds() < 10 ? "0" + createdDate.getSeconds() : createdDate.getSeconds());
            }
            return (createdDate.getMonth() + 1) + "/" + createdDate.getDate() + "/" + createdDate.getFullYear() + " " + (createdDate.getHours() < 10 ? "0" + createdDate.getHours() : createdDate.getHours()) + ":" + (createdDate.getMinutes() < 10 ? "0" + createdDate.getMinutes() : createdDate.getMinutes());

        }
        return getOrderRecievedSince(normalized, currentDate);

    };
});
app.directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                //return undefined;    
                return '';
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});
app.config(function ($logProvider, $provide) {

    $logProvider.debugEnabled(false);

    $provide.decorator('$log', function ($delegate) {
        //Original methods
        var origInfo = $delegate.info;
        var origLog = $delegate.log;

        //Override the default behavior
        $delegate.info = function () {

            if ($logProvider.debugEnabled())
                origInfo.apply(null, arguments)
        };

        //Override the default behavior    
        $delegate.log = function () {

            if ($logProvider.debugEnabled())
                origLog.apply(null, arguments)
        };

        return $delegate;
    });
});
app.directive('firstCharNoSpace', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            //if (event.which === 13) {
            if (this.value.trim().length === 0 && event.which === 32) {
                scope.$apply(function () {
                    scope.$eval(attrs.firstCharNoSpace);
                });

                event.preventDefault();
            }
        });
        element.bind("keyup", function (event) {
            //if (event.which === 13) {
            if (this.value.trim().length === 0 && event.which === 32) {
                this.value = '';
            }
        });
    };
});

app.filter('minuteToHours', function () {
    return function (input) {

        return input / 60;
    };
});
app.filter('ChatSearch', function () {
    return function (list, query, fields) {

        if (!query) {
            return list;
        }

        query = query.toLowerCase().split(' ');

        if (!angular.isArray(fields)) {
            fields = [fields.toString()];
        }

        return list.filter(function (item) {
            return query.every(function (needle) {
                return fields.some(function (field) {
                    var content = item[field] != null ? item[field] : '';

                    if (!angular.isString(content)) {
                        content = '' + content;
                    }
                    return content.toLowerCase().indexOf(needle) > -1;
                });
            });
        });
    };
});
app.directive('infinitescroll', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind('scroll', function () {

                if ((element[0].scrollTop + element[0].offsetHeight) == element[0].scrollHeight) {

                    scope.$apply(attrs.infinitescroll);

                }
            })
        }
    }
});
app.directive('whenScrolledTop', ['$timeout', function ($timeout) {
    return function (scope, elm, attr) {
        var raw = elm[0];
        $timeout(function () {
            raw.scrollTop = raw.scrollHeight;
        });
        elm.bind('scroll', function () {
            if (raw.scrollTop === 0) { // load more items before you hit the top
                var sh = raw.scrollHeight
                scope.$apply(attr.whenScrolledTop);
                raw.scrollTop = raw.scrollHeight - sh;
            }
        });
    };
}]);
app.directive('ngScrollBottom', ['$timeout', function ($timeout) {
    return {
        scope: {
            scrollbottom: "=",
            scrollltobottom: "=",
            deletemessagescrollposition: "="
        },
        link: function ($scope, $element) {
            $scope.$watchCollection('scrollbottom', function (newValue) {
                var scrollltobottom = $scope.scrollltobottom;
                var deletemessagescrollposition = $scope.deletemessagescrollposition;

                if (newValue && !scrollltobottom && !deletemessagescrollposition) {
                    var sh = $element[0].scrollHeight;
                    $timeout(function () {
                        $element.scrollTop($element[0].scrollHeight - sh);
                    }, 0);
                }
                else if (newValue && scrollltobottom && !deletemessagescrollposition) {
                    $timeout(function () {
                        $element.scrollTop($element[0].scrollHeight);
                    }, 0);
                }
                else {
                    $timeout(function () {
                        $element.scrollTop($element[0].scrollTop);
                    }, 0);
                }

            });
        }
    }
}]);
app.directive('onlySingleClick', ['$timeout', function ($timeout) {
    var delay = 500;   // min milliseconds between clicks

    return {
        restrict: 'A',
        priority: -1,   // cause out postLink function to execute before native `ngClick`'s
        // ensuring that we can stop the propagation of the 'click' event
        // before it reaches `ngClick`'s listener
        link: function (scope, elem) {
            var disabled = false;

            function onClick(evt) {
                if (disabled) {
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                } else {
                    disabled = true;
                    $timeout(function () { disabled = false; }, delay, false);
                }
            }

            scope.$on('$destroy', function () { elem.off('click', onClick); });
            elem.on('click', onClick);
        }
    };
}]);
app.factory('uuidv4', [
    function () {

        return {
            newuuid: function () {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
                    .replace(/[xy]/g, function (c) {
                        var r = Math.random() * 16 | 0,
                            v = c == 'x' ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                    });
            },
        }

    }]);

app.filter('formatPhoneNumber', function () {
    return function (phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return phoneNumberString;
    };
});

app.filter('CSTDateTime', function () {
    return function (input) {
        function getCSTTime() {
            var localDate = new Date(input);
            var cstDate = new Date(localDate.toLocaleString('en-US', { timeZone: 'US/Central' }));
            var dateValue = moment(cstDate).format("YYYY-MM-DD HH:mm:ss");
            //2024	Sunday, March 10, 2:00 am	Sunday, November 3, 2:00 am
            if (!moment(localDate).isDST() && moment(cstDate).isDST()) {
                dateValue = moment(localDate).utc().utcOffset("-06:00").format("YYYY-MM-DD HH:mm:ss");
            } else if (moment(localDate).isDST() && !moment(cstDate).isDST()) {
                dateValue = moment(localDate).utc().utcOffset("-05:00").format("YYYY-MM-DD HH:mm:ss");
            }

            //if (moment(localDate).isDST() && moment(cstDate).isDST()) {
            //    dateValue = moment(cstDate).format("YYYY-MM-DD HH:mm:ss");
            //}
            
            //if (!moment(localDate).isDST() && !moment(cstDate).isDST()) {
            //    dateValue = moment(cstDate).format("YYYY-MM-DD HH:mm:ss");
            //}
            return dateValue;
            //var cst = new Date(new Date(input).toLocaleString('en-US', { timeZone: 'US/Central' }));
            //var date = cst.getFullYear() + '-' + (cst.getMonth() + 1) + '-' + (cst.getDate());
            //var time = String(cst.getHours()).padStart(2, '0') + ':' + String(cst.getMinutes()).padStart(2, '0') + ':' + String(cst.getSeconds()).padStart(2, '0');
            //// return time as a string
            //return date.concat(' ', time);
        }
        return getCSTTime();

    }
});
app.filter('camelCaseToSpace', function () {
    return function (input) {
        if (!input) return input;
        return input.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before uppercase letters
    };
});



/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function (angular) {
    'use strict';

    angular.module('radico.pages.addressbook')
        .controller('appAddressBookController', appAddressBookController);

    function appAddressBookController(AddressBookService, $document, $scope, $rootScope, $sce, $localStorage, $sessionStorage, NgTableParams) {
        var self = this;
        self.loading = false;
        self.searchText = "";
        self.SelectedAddressbookinfo = '';
        self.UserId = "";
        self.filteredCount = 0;
        self.totalRecords = 0;
        self.pageSize = 25;
        self.currentPage = 1;
        self.oldPage = 0;
        self.selectedUserInfo = "";
        self.selectedName = [];
        self.isImport = false;
        self.userRole = $sessionStorage.currentUserData.roles;
        self.isLoading = false;
        self.Permission = ($sessionStorage.currentUserData.roles == 'Admin' || $sessionStorage.currentUserData.roles == 'SuperAdmin') ? true : false;
        //------------------------
        // Destroy events to avoid memory leak and stop digest cycle

        if ($scope) {
            $scope.$on('$destroy', function () {
                
            });
        }
        initPage();
        function initPage() {
            clearData();
            self.UserId = $sessionStorage.currentUserData.userId;
            if ($sessionStorage.currentUserData) {
                $scope.userRole = $sessionStorage.currentUserData.roles;
            }
            getAllFirstName();
            getAllLastName();
            getAllLocation();
            getUserContactList();
        }

        function showLoader(val) {
            self.isLoading = val;
        }

        function getUserContactList() {
            showLoader(true);
            self.oldPage = self.currentPage;
            var serviceCall = AddressBookService.getUserContactList(self.location, self.firstName, self.lastName, (self.currentPage - 1), self.pageSize);
            serviceCall.then(function (obj) {
                if (obj.data.AddressBookContacts) {
                    self.AddressBookContactList = obj.data.AddressBookContacts;
                    self.currentPage = obj.data.CurrentPage;
                    self.pageSize = obj.data.PageSize;
                    self.totalRecords = obj.data.TotalRecords;
                    self.filteredCount = obj.data.AddressBookContacts.length;
                    self.tableParams = new NgTableParams({ page: 1, count: self.pageSize }, { counts: [], dataset: self.AddressBookContactList });
                }
                else {
                    self.AddressBookContactList = null;
                    self.currentPage = obj.data.CurrentPage;
                    self.pageSize = obj.data.PageSize;
                    self.totalRecords = 0;
                    self.filteredCount = 0;
                    self.tableParams = new NgTableParams({ page: 1, count: self.pageSize }, { counts: [], dataset: self.AddressBookContactList });
                }
                showLoader(false);
            }, function (error) {
                showLoader(false);
                swal('Error ' + error.message);
            });
        }
        self.SaveContact = function (valid) {
            if (!valid) {
                swal('Please fill all required field(s)');
                return;
            }
            showLoader(true);
            var serviceCall;
            if (self.SelectedAddressbookinfo.Id > 0) {
                serviceCall = AddressBookService.updateAddressBookContact(self.SelectedAddressbookinfo);
            } else {
                serviceCall = AddressBookService.createAddressBookContact(self.SelectedAddressbookinfo);
            }
            serviceCall.then(function (obj) {
                showLoader(false);
                angular.element('#ContactModal').modal('hide');
                swal(obj.data);
                getUserContactList();
                self.oldPage = 0;
            }, function (error) {
                showLoader(false);
                angular.element('#ContactModal').modal('hide');
                swal('Error ' + error.message);
            });
        }
        self.DeleteContact = function (Id) {
            swal({
                title: "Are you sure you want to delete this contact?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Ok",
                cancelButtonText: "Cancel",
                closeOnConfirm: true,
                closeOnCancel: true
            },
                function (isConfirm) {
                    if (isConfirm) {
                        showLoader(true);
                        var serviceCall = AddressBookService.DeleteContact(Id);
                        serviceCall.then(function (obj) {
                            showLoader(false);
                            swal("Contact Deleted successfully");
                            self.oldPage = 0;
                            getUserContactList();
                        }, function (error) {
                            showLoader(false);
                            swal('Error ' + error.message);
                        });
                    }
                });
        }
        self.EditContact = function (Id) {
            showLoader(true);
            var serviceCall = AddressBookService.GetAddressBookContactsById(Id);
            serviceCall.then(function (obj) {
                showLoader(false);
                self.SelectedAddressbookinfo = obj.data;
                if (self.SelectedAddressbookinfo && self.SelectedAddressbookinfo.Phones) {
                    _.each(self.SelectedAddressbookinfo.Phones, function (data) {
                        if (data && data.Phone != null && data.Phone !== '') {
                            data.Phone = data.Phone.replace('+1', '');
                        }
                    });
                }
                angular.element('#ContactModal').modal('show');
            }, function (error) {
                showLoader(false);
                swal('Error ' + error.message);
            });
        }
        self.OpenContactModal = function () {
            clearData();
        }
        self.changePageSize = function () {
            self.currentPage = 1;
            self.oldPage = 0;
            getUserContactList();
        }
        self.pageChanged = function () {
            if (self.currentPage == self.oldPage)
                return;
            getUserContactList();
        }
        self.search = function () {
            self.oldPage = 0;
            self.currentPage = 1;
            getUserContactList();
        }
        self.clearFilter = function () {
            self.oldPage = 0;
            self.currentPage = 1;
            self.firstName = '';
            self.lastName = '';
            self.location = '';
            getUserContactList();
        }
        self.RemoveExtraSpace = function () {
            self.SelectedAddressbookinfo.FirstName = self.SelectedAddressbookinfo.FirstName.replace(/\s\s+/g, ' ');
            self.SelectedAddressbookinfo.LastName = self.SelectedAddressbookinfo.LastName.replace(/\s\s+/g, ' ');
            self.SelectedAddressbookinfo.PrimaryLocation = self.SelectedAddressbookinfo.PrimaryLocation.replace(/\s\s+/g, ' ');
        }
        self.showUserContactInfo = function (Userinfo) {
            self.selectedUserInfo = Userinfo
            angular.element('#UserInfoModal').modal('show');
        }

        function getAllFirstName() {
            var serviceCall = AddressBookService.getFirstName('');
            serviceCall.then(function (obj) {
                $("#firstName").autocomplete({
                    source: function (request, response) {
                        var matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex(request.term), "i");
                        response($.grep(obj.data, function (item) {
                            return matcher.test(item);
                        }));
                    }
                });

            }, function (error) {
            });
        }
        function getAllLastName() {
            var serviceCall = AddressBookService.getLastName('');
            serviceCall.then(function (obj) {
                $("#lastName").autocomplete({
                    //source: obj.data
                    source: function (request, response) {
                        var matcher = new RegExp("^" + $.ui.autocomplete.escapeRegex(request.term), "i");
                        response($.grep(obj.data, function (item) {
                            return matcher.test(item);
                        }));
                    }
                });
            }, function (error) {
            });
        }

        function getAllLocation() {
            var serviceCall = AddressBookService.getAllLocation('');
            serviceCall.then(function (obj) {
                $("#location").autocomplete({
                    source: obj.data
                });
            }, function (error) {
            });
        }

        //---Start init variables-----------
        function clearData() {
            self.SelectedAddressbookinfo = {
                id: 0,
                FirstName: '',
                LastName: '',
                PrimaryLocation: '',
                IsPrivate: true,
                IsDeleted: false,
                Phones: [
                    {
                        Phone: '',
                        PhoneTypeId: 1,
                        PhoneType: {
                            id: 1,
                            Value: 'Office'
                        }
                    },
                    {
                        Phone: '',
                        PhoneTypeId: 2,
                        PhoneType: {
                            id: 2,
                            Value: 'Mobile'
                        }
                    }
                ],
                Emails: [
                    {
                        id: 0,
                        EmailId: '',
                        EmailType: {
                            id: 1,
                            Value: 'Email'
                        }
                    }
                ]
            }
        }
        //---End init variables-----------

        $scope.invite = function (list) {
            swal({
                title: "Are you sure you want to invite this user?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Ok",
                cancelButtonText: "Cancel",
                closeOnConfirm: true,
                closeOnCancel: true
            },
                function (isConfirm) {
                    if (isConfirm) {
                        var InviteUser = [{
                            Id: list.Id,
                            NPI: '',
                            FirstName: list.FirstName,
                            LastName: list.LastName,
                            MiddleName: '',
                            BusinessAddress: '',
                            City: list.PrimaryLocation,
                            State: '',
                            Zip: '',
                            BusinessTelephoneNumber: list.Phones[1].Phone,
                            Email: list.Emails[0].EmailId,
                            IsWorkGroupUser: false,
                            IsAdminUser: false,
                            CategoryId: 0,
                            ProviderType: '',
                            UserRole: 'U',
                            AppicationAccess: 'RadFlow,RadFlow',
                            UserAccess: null
                        }];
                        showLoader(true);
                        var getProviderData = AddressBookService.Invite(InviteUser);
                        showLoader(false);
                    }
                });
        };

        self.OpenFileUploader = function () {
            self.isImport = true;
        }
        function cancelFileUpload() {
            angular.element("input[type='file']").val(null);
            $scope.file = null;
            $scope.filePath = null;
            self.isImport = false;
        }
        self.hideFileUploader = function () {
            cancelFileUpload();
        }
        $scope.getFileDetails = function (e) {
            $scope.file = null;
            $scope.$apply(function () {
                if (e.files.length > 0) {
                    if (e.files[0].type.match('vnd.ms-excel')) {
                        $scope.file = e.files[0];
                    }
                    else {
                        swal('Please upload csv file!');
                        angular.element("input[type='file']").val(null);
                    }
                }

            });
        };
        self.Import = function () {
            if ($scope.file) {
                var data = new FormData();
                data.append("uploadedFile", $scope.file);
                showLoader(true);
                var serviceCall = AddressBookService.importAddressBookData(data);
                serviceCall.then(function (obj) {
                    showLoader(false);
                    if (obj.data.match('success')) {
                        swal(obj.data);
                        cancelFileUpload();
                        getUserContactList();
                        getAllFirstName();
                        getAllLastName();
                        getAllLocation();
                    }
                    else {
                        swal('Please check file format or contact support team!');
                        angular.element("input[type='file']").val(null);
                    }
                }, function (error) {
                    showLoader(false);
                    swal('Please check file format or contact support team!');
                    angular.element("input[type='file']").val(null);
                });
            }
            else {
                swal('Please upload file!');
            }
        }
        self.spiltPhoneNumber = function (phone) {
            if (phone) {
                return phone.split(',');
            }
            else {
                return null;
            }
        }
        // JS for table row active
        angular.element(document).ready(function () {
            setTimeout(function () {
                angular.element(".common-tbl table tr").click(function () {
                    if (angular.element(this).data('clicked', true)) {
                        angular.element(".common-tbl table tr").removeClass('tr-active');
                        angular.element(this).addClass('tr-active');
                    }
                });
            }, 500);
        });
    }
    
})(window.angular);

(function () {
    "use strict";

    AddressBookService.$inject = ['$http', '$rootScope', '$sessionStorage', 'APP_CONSTANTS', '__env'];

    function AddressBookService($http, $rootScope, $sessionStorage, APP_CONSTANTS, __env) {

        var radiCoAPI = __env._environment.config.radiCoAPI;
        var token = "Bearer " + $sessionStorage.currentUserData.accessToken;
        var header = {
            'Authorization': token,
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }

        function urlBase() {
            return radiCoAPI + ($sessionStorage.currentUserData.TenantName == 'TRAMBMS' ? 'TRA' : $sessionStorage.currentUserData.TenantName) +'/api/AddressBook';
        }

        var dataFactory = {};

        dataFactory.createAddressBookContact = function (addressBookVM) {
            return $http({
                method: 'post',
                data: addressBookVM,
                url: urlBase() + '/CreateAddressBookContact',
                headers: header
            });
        };
        dataFactory.updateAddressBookContact = function (addressBookVM) {
            return $http({
                method: 'post',
                data: addressBookVM,
                url: urlBase() + '/UpdateAddressBookContact',
                headers: header
            });
        };
        dataFactory.DeleteContact = function (Id) {
            return $http({
                method: 'get',
                params: { Id: Id },
                url: urlBase() + '/DeleteContact',
                headers: header
            });
        };
        dataFactory.GetAddressBookContactsById = function (Id) {
            return $http({
                method: 'get',
                params: { Id: Id },
                url: urlBase() + '/GetAddressBookContactsById',
                headers: header
            });
        };
        dataFactory.getFirstName = function (firstName) {
            return $http({
                method: 'get',
                params: {
                    firstName: firstName
                },
                url: urlBase() + '/getFirstName',
                headers: header
            });
        };
        dataFactory.getLastName = function (lastName) {
            return $http({
                method: 'get',
                params: {
                    lastName: lastName
                },
                url: urlBase() + '/getLastName',
                headers: header
            });
        };
        dataFactory.getAllLocation = function (location) {
            return $http({
                method: 'get',
                params: {
                    location: location
                },
                url: urlBase() + '/getAllLocation',
                headers: header
            });
        };
        dataFactory.getUserContactList = function (searchText, firstName, lastName, currentPage, pageSize) {
            return $http({
                method: 'get',
                params: {
                    searchText: searchText,
                    firstName: firstName,
                    lastName: lastName,
                    currentPage: currentPage,
                    pageSize: pageSize
                },
                url: urlBase() + '/GetUserContactList',
                headers: header
            });
        };
        dataFactory.importAddressBookData = function (formData) {
            return $http.post(urlBase() + "/importAddressBookData", formData, {
                headers: {
                    'Content-Type': undefined,
                    'Authorization': token,
                    'Access-Control-Allow-Origin': '*'
                },
                transformRequest: angular.identity
            });
        };
        dataFactory.Invite = function (strProviderJson) {
            return $http({
                method: 'post',
                url: radiCoAPI + ($sessionStorage.currentUserData.TenantName == 'TRAMBMS' ? 'TRA' : $sessionStorage.currentUserData.TenantName) + '/api/SendMessage/SendMsg/',
                data: JSON.stringify(strProviderJson),
                headers: header
            });
        }
        return dataFactory;
    }

    app.factory('AddressBookService', AddressBookService);
})();
(function () {
    'use strict';

    angular.module('radico.pages.analytics')
        .controller('AnalyticsController', AnalyticsController);
    function AnalyticsController($scope, AnalyticsService, $sce) { 

        $scope.InIt = function () {
            AnalyticsService.GetTablueReportInfo().then(function (result) {
                $scope.html = "";
                //var viz = document.getElementById('tableauVizDiv');
                // $scope.html ="<tableau-viz id='tableauViz' src='"+ReportUrl+"' toolbar='hidden' token='"+ReportToken+"' hide-tabs> <viz-filter  field='["+Tenantkey+"]' value='"+TenantValue+"'> </viz-filter>  </tableau-viz>";            debugger;

                $scope.ReportHtml = $sce.trustAsHtml(result.ReportHtml);
            });
            
        }
        $scope.InIt();
        
        

    }
})();


angular.module('radico.pages.analytics')
    .service('AnalyticsService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS, __env) {
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }
        this.GetTablueReportInfo = function () {
            return Restangular.one('reports').one("TablueReport/GetTablueReportInfo").get();
        };

    }]);
(function () {
    'use strict';

    angular
        .module('radico.pages.campaign', [])
        .controller('CampaignModalController', CampaignModalController);

    CampaignModalController.$inject = ['$uibModalInstance', 'campaignData', '$window', '__env'];

    function CampaignModalController($uibModalInstance, campaignData, $window, __env) {
        var vm = this;

        // CampaignStatsResponse from api/Campaign/GetCampaignStats
        vm.data = campaignData || {};

        // Between the announce date and the start date the API answers IsLive = false: the
        // announcement is shown, the Live tab is not offered and no standings are fetched.
        vm.isLive = !!vm.data.IsLive;

        // Holiday name and dates come from Web.config (CampaignName / CampaignStartDate /
        // CampaignEndDate via GetUserPreferences), so a new holiday needs no UI change.
        // Must be the injected __env: indexController writes these onto app.js's copy of
        // window.__env, so the global never sees them.
        var _env = __env || {};
        var _name = (_env.CampaignName || '').trim() || 'Holiday';

        // Shows the instant in US Central time ("2026-10-10T00:00:00-05:00" -> "12:00 AM CST,
        // Saturday October 10") whatever offset the value arrives with: DEV served these as UTC,
        // which moment.parseZone printed as 5:00 AM. Unparseable values are shown raw.
        function formatCampaignDate(raw) {
            var d = raw ? new Date(raw) : null;
            if (!d || isNaN(d.getTime())) { return raw || ''; }
            var tz = 'America/Chicago';
            // Newer Chrome puts a narrow no-break space before AM/PM; normalise to a plain space.
            var time = d.toLocaleTimeString('en-US', { timeZone: tz, hour: 'numeric', minute: '2-digit' }).replace(/\s+/g, ' ');
            var date = d.toLocaleDateString('en-US', { timeZone: tz, weekday: 'long', month: 'long', day: 'numeric' }).replace(',', '');
            return time + ' CST, ' + date;
        }

        vm.campaign = {
            name:       _name,
            title:      _name + ' Reading Rally',
            tagline:    'Read Smart. Read On Time. Read Right.',
            theme:      'Great reads. Right on time. Every patient.',
            start:      formatCampaignDate(_env.CampaignStartDate),
            deadline:   formatCampaignDate(_env.CampaignEndDate),
            cashReward: '$2,500'
        };

        // key  = property on CampaignStatsResponse (RS3..RS6 of the proc)
        // name = fallback only. The displayed name is the proc's AwardTitle whenever the API
        //        returned one (vm.awardName), so the DB team's naming wins on both tabs.
        // Order here is the display order on both tabs.
        vm.awards = [
            { key: 'SpeedWithPrecision', name: 'Speed With Precision', icon: '⚡',       desc: 'Fast reads while maintaining quality',        detail: 'Lowest median turnaround time across eligible studies, gated on quality: zero addendum requests and zero peer-review discrepancies. Minimum 10 eligible reads.' },
            { key: 'SLAGuardian',        name: 'SLA Champion',         icon: '⏱️', desc: 'Consistently meeting turnaround targets',     detail: 'Highest percentage of studies finalized within their SLA target — STAT ER 30 min, STAT IP 90 min, Routine IP 8 h, Routine OP 24 h. Minimum 10 studies with an SLA target.' },
            { key: 'FlawlessRecord',     name: 'Right the First Time', icon: '🎯', desc: 'Zero addendums or peer-review discrepancies', detail: 'Highest eligible read volume with zero addendum requests and every completed peer review rated concur. Minimum 10 eligible reads.' },
            { key: 'ModalityMaestro',    name: 'Multimodality MVP',    icon: '🌈', desc: 'Balanced reading across modalities',          detail: 'Widest spread of reads across the major modalities (CT, MR, US, XR), ranked first on modalities covered and then on how evenly the mix is distributed. Minimum 10 eligible reads.' }
        ];

        // Award name as the database currently states it. The proc may append a subtitle after an
        // en dash ("Queue Hero – Helping where..."); only the name before it is shown.
        vm.awardName = function (award) {
            var a = vm.data[award.key];
            var title = a && a.AwardTitle ? String(a.AwardTitle).split(' – ')[0].trim() : '';
            return title || award.name;
        };

        var _LAST_TAB_KEY = 'campaign_last_tab';
        var _storedTab = $window.localStorage.getItem(_LAST_TAB_KEY);
        // A remembered Live tab is only honoured once the campaign is actually live.
        vm.activeTab = (_storedTab === 'live' && vm.isLive) ? 'live' : 'campaign';

        vm.setTab = function (tab) {
            if (tab === 'live' && !vm.isLive) { tab = 'campaign'; }
            vm.activeTab = tab;
            $window.localStorage.setItem(_LAST_TAB_KEY, tab);
        };

        vm.leader = function (award) {
            return vm.data[award.key] || null;
        };

        vm.hasWinner = function (award) {
            var a = vm.leader(award);
            return !!(a && a.HasWinner && a.DisplayName);
        };

        vm.leaderName = function (award) {
            return vm.hasWinner(award) ? vm.leader(award).DisplayName : 'No winner yet';
        };

        vm.leaderMetric = function (award) {
            if (!vm.hasWinner(award)) { return ''; }
            var a = vm.leader(award);
            return (vm.formatMetric(a.MetricValue) + ' ' + (a.MetricLabel || '')).trim();
        };

        vm.leaderDetail = function (award) {
            var a = vm.leader(award);
            return (a && a.MetricDetail) || '';
        };

        // MetricValue is a count for some awards and a rate for others: whole numbers stay whole,
        // anything fractional gets one decimal.
        vm.formatMetric = function (n) {
            if (n === null || n === undefined || n === '') { return '--'; }
            var num = Number(n);
            if (isNaN(num)) { return '--'; }
            return num % 1 === 0 ? num.toLocaleString() : num.toFixed(1);
        };

        vm.close = function () {
            $uibModalInstance.dismiss('close');
        };
    }
})();

(function () {
    'use strict';

    angular.module('radico.pages.cap')
        .controller('CAPController', CAPController);

    function CAPController($scope, $q, $sce, $state, $sessionStorage, RFIService, chatService, $interval, $localStorage, APP_CONSTANTS, $rootScope, AppHubService, NgTableParams, $stateParams, $timeout, uuid2, filterFilter, $http, __env) {

        // #region Variables
        var AppHub;
        var self = this;
        self.Report = "";
        self.minDate = new Date();
        self.ModifiedDisplayReport = "";
        self.DisplayReport = "";
        self.options = [];
        self.Reason = "";
        self.DicomImages = [];
        self.selectedRFIData = null;
        self.gotoNextPage = false;
        self.RFIReportIndex = 0;
        self.RFIdata = [];
        self.showall = 0;
        self.RFIUsers = [];
        self.message = "";
        self.disabledComm = false;
        self.coderUserId = "7C75D9C8-246B-4FBA-ADD5-EA02A1AD4FAE";
        var fileFormatList = [{ CategoryId: 1, Format: '.doc' },
        { CategoryId: 1, Format: '.docx' },
        { CategoryId: 1, Format: '.pdf' },
        { CategoryId: 1, Format: '.txt' },
        { CategoryId: 2, Format: '.mp4' },
        { CategoryId: 2, Format: '.ogg' },
        { CategoryId: 2, Format: '.webm' },
        { CategoryId: 2, Format: '.mp3' },
        { CategoryId: 2, Format: '.avi' },
        { CategoryId: 3, Format: '.ppt' },
        { CategoryId: 3, Format: '.pptx' },
        { CategoryId: 3, Format: '.pptm' },
        { CategoryId: 5, Format: '.xls' },
        { CategoryId: 5, Format: '.xlsx' },
        { CategoryId: 6, Format: '.jpg' },
        { CategoryId: 6, Format: '.jpeg' },
        { CategoryId: 6, Format: '.png' },
        { CategoryId: 6, Format: '.gif' },
        { CategoryId: 6, Format: '.tif' },
        { CategoryId: 6, Format: '.bmp' }];
        self.DisplayNameOfCoder = "Leslie Jones";
        self.PendingRFIReport = [];
        self.providerInitials = "";
        self.selectedRFI = '';
        self.DOS = "";
        self.ResultColor = "",
            self.IsResultMessage = false,
            self.ResultMessage = ""
        self.LoggedInUserNPI = $sessionStorage.LoggedInUserNPI;
        self.rows = [];
        self.facilityNames = [];
        self.readingLocations = [];
        self.SelectedNormalUsers = '';
        self.savechangeOfReadinglocations = false;
        self.alertMessage = "";
        self.currentDate = moment(new Date()).format("MM-DD-YYYY");
        self.currUser = $sessionStorage.currentUserData.userId;
        self.searchData = {};
        self.Status = "Pending";
        self.SearchReason = '';
        self.SearchLocation = '';
        self.SearchPatientName = '';
        self.SearchProcedure = '';
        self.SearchReadingProvider = '';
        self.currentPage = 1;
        self.itemsPerPage = 15;
        self.maxSize = 15;
        self.totalItems = 15;
        self.SelectedDay = 1;
        self.ShowOnlyCoder = 0;
        self.ShowOnlyCoderValue = 0;
        self.QuestionView = 0;
        self.PendingRFI = 0;
        self.TotalRFI = 0;
        self.RFIReasons = [];
        self.RFIFacility = [];
        self.SortByName = '';
        self.SortASC = 1;
        self.showLoader = true;
        self.RFIListsfilter = {
            PageSize: self.itemsPerPage,
            PageNo: self.currentPage
        };
        var parser = new UAParser();
        $scope.browser = parser.getBrowser().name;
        //#endregion

        function showLoader(val) {
            self.isLoading = val;
            //$rootScope.$emit("showRequestLoader", val);
        }
        //self.isVisible = ($sessionStorage.currentUserData.userId == '0d45b769-6295-4e52-a7ce-1a54fc432c30' || $sessionStorage.currentUserData.userId == '7E314067-882D-466B-9712-402546897202') ? true : false; /*Temp variable for testing*/
        ////self.isVisible = true;   
        var oldcomment = '';
        self.isPopupOpen = true;
        self.isBlink = false;
        showLoader(true);
        RFIService.GetAllReasonsRFIUnique().then(function (obj) {
            self.RFIReasons = obj.data;
        }, function (error) {
            //  hideLoading();
        });

        RFIService.GetOnlyFacilities().then(function (obj) {
            self.RFIFacility = obj.data;

            // self.RFIFacilityDoctors = self.output;
        }, function (error) {
        });
        RFIService.getReadingProviderInfo().then(function (result) {
            self.RFIReadingProvider = result.data;

        });
        RFIService.getCheckCoder().then(function (result) {
            self.IsCoder = result.data;
        });
        self.Statuses = [
            { id: '', title: 'All' },
            { id: 'Addendum', title: 'Addendum' },
            { id: 'Pending', title: 'Pending' },
            { id: 'Expired', title: 'Expired' },
            { id: 'Disable', title: 'Disable' }
        ];
        $scope.showExpirycalender = function (row, $event) {
            $event.stopPropagation();
            self.temp = true;
            if (row.ChangeExpiry == true)
                row.ChangeExpiry = false;
            else
                row.ChangeExpiry = true;

        }
        function validateFile(file) {
            var isValid = true;
            var filename = file.name;
            var index = filename.lastIndexOf(".");
            var fileformate = filename.substring(index, filename.length);
            fileformate = angular.lowercase(fileformate);
            var index1 = _.findIndex(fileFormatList, function (obj) { return obj.Format == fileformate });
            if (index1 == -1) {
                $("input[type='file']").val(null);
                swal("This file is not supported!");
                return;
            }
            else {
                return fileformate;
            }


        }

        $scope.sortBy = function ($column, $event) {
            var test = test;
        };
        $scope.EditExpiry = function (row) {
            RFIService.UpdateExpirationDateTime(row.RFI_Id, row.ExpirationTime, 0).then(function (obj) {
                row.DateDiffMin = obj.data;
                $scope.cols = [
                    { field: "color", title: "", show: false },
                    { field: "ReasonCode", title: " Reason      ", show: false, sortable: "'ReasonCode'" },
                    { field: "LocationGroup", title: "LocationGroup", show: false, sortable: "'LocationGroup'" },
                    { field: "PatientName", title: "PatientName", sortable: "'PatientName'", show: false },
                    { field: "ProcedureDescription", title: "ProcedureDescription", show: false, sortable: "'ProcedureDescription'" },
                    { field: "DateDiffMin", title: "Days To Expire     ", show: false, sortable: "'DateDiffMin'" },
                    { field: "RFIDays", title: "Days in CAP", show: false, sortable: "'RFIDays'" },
                    { field: "Status", title: "Status    ", show: false, sortable: "'Status'" },
                    { field: "ReadingProviderName", title: "Reading Provider Name", show: false }, { field: "AssgnRFIToDoctor", title: " ", show: false }, { field: "Extension", title: " ", show: false }
                ];
                row.ChangeExpiry = false;
            });
        }
        $scope.GetCount = function () {
            RFIService.GetRFIDataCount(self.showall, self.itemsPerPage, self.currentPage, self.Status, self.SearchReason, self.SearchLocation, self.SearchPatientName, self.SearchProcedure, self.SearchReadingProvider, self.ShowOnlyCoderValue).then(function (result) {
                self.PendingRFI = result.data;
                self.Status = "ALL";

                RFIService.GetRFIDataCount(self.showall, self.itemsPerPage, self.currentPage, self.Status, self.SearchReason, self.SearchLocation, self.SearchPatientName, self.SearchProcedure, self.SearchReadingProvider, self.ShowOnlyCoderValue).then(function (result) {

                    self.TotalRFI = result.data;
                    self.Status = "Pending";
                });
            });
        }
        $scope.ShowCodersRFIData = function (ShowOnlyCoder) {
            if (ShowOnlyCoder) {
                self.ShowOnlyCoderValue = 1;
                self.Statuses = [
                    { id: '', title: 'All' },
                    { id: 'Addendum', title: 'Addendum' },
                    { id: 'Pending', title: 'Pending' },
                    { id: 'Expired', title: 'Expired' },
                    { id: 'Disable', title: 'Disable' }
                ];
            }
            else {
                self.ShowOnlyCoderValue = 0;

                self.Statuses = [
                    { id: 'Pending', title: 'Pending' }
                ];
            }
            $scope.GetCount();
            self.Status = "Pending";
            self.SearchReason = '';
            self.SearchLocation = '';
            self.SearchPatientName = '';
            self.SearchProcedure = '';
            self.SearchReadingProvider = '';

            $scope.getRFIData(self.showall);

        };
        $scope.GetCount();
        $scope.pageChanged = function () {
            $scope.getRFIData(self.showall);
        }
        $scope.changestatus = function (changestatus) {

            $scope.getRFIData(self.showall);
        }
        $scope.GetRFIDataCount = function (i) {

            RFIService.GetRFIDataCount(i, self.itemsPerPage, self.currentPage, self.Status, self.SearchReason, self.SearchLocation, self.SearchPatientName, self.SearchProcedure, self.SearchReadingProvider, self.ShowOnlyCoderValue).then(function (result) {
                if (result.data % 15 == 0)
                    self.totalItems = result.data;
                else {
                    self.totalItems = result.data + (15 - result.data % 15);
                    var item = Math.ceil(self.totalItems / 15);
                }
                // showLoader(false);
            });
        };
        $scope.getRFIData = function (i) {
            showLoader(true);
            $scope.GetRFIDataCount(i);
            RFIService.GetRFIData(i, self.itemsPerPage, self.currentPage, self.Status, self.SearchReason, self.SearchLocation, self.SearchPatientName, self.SearchProcedure, self.SearchReadingProvider, self.ShowOnlyCoderValue, self.SortByName, self.SortASC).then(function (result) {

                showLoader(false);

                if (result.data && result.data.length > 0) {
                    //$scope.IsCoder = result.data[0].IsCoder;
                    self.NoRecords = false;
                }
                else {
                    self.NoRecords = true;

                }
                if (self.IsCoder && !self.ShowOnlyCoderValue) {
                    self.RFIdata = _.filter(result.data, function (obj) { return obj.IsReplied !== true; });
                } else {
                    self.RFIdata = result.data;
                    self.ShowOnlyCoderValue = 1;
                }
                $scope.cols = [
                    { field: "color", title: "", show: false },
                    { field: "ReasonCode", title: " Reason      ", show: false, sortable: "'ReasonCode'" },
                    { field: "LocationGroup", title: "LocationGroup", show: false, sortable: "'LocationGroup'" },
                    { field: "PatientName", title: "PatientName", sortable: "'PatientName'", show: false },
                    { field: "ProcedureDescription", title: "ProcedureDescription", show: false, sortable: "'ProcedureDescription'" },
                    { field: "DateDiffMin", title: "Days To Expire     ", show: false, sortable: "'DateDiffMin'" },
                    { field: "RFIDays", title: "Days in CAP", show: false, sortable: "'RFIDays'" },
                    { field: "Status", title: "Status    ", show: false, sortable: "'Status'" },
                    { field: "ReadingProviderName", title: "Reading Provider Name", show: false }, { field: "AssgnRFIToDoctor", title: " ", show: false }, { field: "Extension", title: " ", show: false }
                ];
                if (self.IsCoder == 1 && self.ShowOnlyCoderValue == 0) {
                    self.QuestionView = 1;
                    self.Statuses = [
                        { id: 'Pending', title: 'Pending' }
                    ];
                }
                else
                    self.QuestionView = 0;

                $scope.tableParams = new NgTableParams(
                    {
                        page: 1,
                        count: self.itemsPerPage,
                        filter: { ReasonCode: "" }
                    },

                    { dataset: self.RFIdata, counts: [] }


                );


                //self.tableParams.count = 16;
                var PatientName = ($stateParams.PatientName) ? $stateParams.PatientName.trim() : '';
                var AccesionNumber = ($stateParams.AccesionNumber) ? $stateParams.AccesionNumber.trim() : '';
                var MRN = ($stateParams.MRN) ? $stateParams.MRN.trim() : '';
                if (PatientName && AccesionNumber && MRN) {
                    var selectedRfI = _.find(self.RFIdata, function (obj) {
                        return (obj.PatientName == PatientName && obj.Accession_Number == AccesionNumber && obj.MRN == MRN);
                    });
                    $scope.GoToRFIReport(selectedRfI,'');
                }

            });
        };
        $scope.clickSortByName = function (sortBy) {
            if (self.SortByName == sortBy) {
                if (self.SortASC == 1)
                    self.SortASC = 0;
                else
                    self.SortASC = 1;
            } else
                self.SortASC = 1;
            self.SortByName = sortBy;
            $scope.getRFIData(self.showall);

            //self.SortByName, self.SortASC
        };
        $scope.clearSearch = function () {
            self.Status = "Pending";
            self.SearchReason = '';
            self.SearchLocation = '';
            self.SearchPatientName = '';
            self.SearchProcedure = '';
            self.SearchReadingProvider = '';
            $scope.getRFIData(self.showall);

        };
        $scope.Search = function () {
            $scope.GetRFIDataCount(self.showall);
            showLoader(true);
            RFIService.GetRFIData(self.showall, self.itemsPerPage, self.currentPage, self.Status, self.SearchReason, self.SearchLocation, self.SearchPatientName, self.SearchProcedure, self.SearchReadingProvider, self.ShowOnlyCoderValue, self.SortByName, self.SortASC).then(function (result) {
                showLoader(false);
                if (result.data.length > 0) {
                    //$scope.IsCoder = result.data[0].IsCoder;
                    self.NoRecords = false;
                }
                else {
                    self.NoRecords = true;

                }
                if (self.IsCoder && !self.ShowOnlyCoderValue) {
                    self.RFIdata = _.filter(result.data, function (obj) { return obj.IsReplied !== true; });
                } else {
                    self.RFIdata = result.data;
                    self.ShowOnlyCoderValue = 1;
                }
                $scope.cols = [
                    { field: "color", title: "", show: false },
                    { field: "ReasonCode", title: " Reason      ", show: false, sortable: "'ReasonCode'" },
                    { field: "LocationGroup", title: "LocationGroup", show: false, sortable: "'LocationGroup'" },
                    { field: "PatientName", title: "PatientName", sortable: "'PatientName'", show: false },
                    { field: "ProcedureDescription", title: "ProcedureDescription", show: false, sortable: "'ProcedureDescription'" },
                    { field: "DateDiffMin", title: "Days To Expire     ", show: false, sortable: "'DateDiffMin'" },
                    { field: "RFIDays", title: "Days in CAP", show: false, sortable: "'RFIDays'" },
                    { field: "Status", title: "Status    ", show: false, sortable: "'Status'" },
                    { field: "ReadingProviderName", title: "Reading Provider Name", show: false }, { field: "AssgnRFIToDoctor", title: " ", show: false }, { field: "Extension", title: " ", show: false }
                ];
                if (self.IsCoder == 1 && self.ShowOnlyCoderValue == 0) {
                    self.QuestionView = 1;
                    self.Statuses = [
                        { id: 'Pending', title: 'Pending' }
                    ];

                    RFIService.GetRFIDataCount(self.showall, self.itemsPerPage, self.currentPage, self.Status, self.SearchReason, self.SearchLocation, self.SearchPatientName, self.SearchProcedure, self.SearchReadingProvider, self.ShowOnlyCoderValue).then(function (result) {

                        self.TotalRFI = result.data;

                    });
                }
                else
                    self.QuestionView = 0;

                $scope.tableParams = new NgTableParams(
                    {
                        page: 1,
                        count: self.itemsPerPage,
                        filter: { ReasonCode: "" }
                    },

                    { dataset: self.RFIdata, counts: [] }


                );


                //self.tableParams.count = 16;
                var PatientName = ($stateParams.PatientName) ? $stateParams.PatientName.trim() : '';
                var AccesionNumber = ($stateParams.AccesionNumber) ? $stateParams.AccesionNumber.trim() : '';
                var MRN = ($stateParams.MRN) ? $stateParams.MRN.trim() : '';
                if (PatientName && AccesionNumber && MRN) {
                    var selectedRfI = _.find(self.RFIdata, function (obj) {
                        return (obj.PatientName == PatientName && obj.Accession_Number == AccesionNumber && obj.MRN == MRN);
                    });
                    $scope.GoToRFIReport(selectedRfI,'');
                }

            });
        };
        initPage();
        self.showall = 0;
        $scope.ShowMedicalDirectorData = function (showAll) {
            //showLoader(true);
            var i = 0;
            if (showAll)
                self.showall = 1;
            else
                self.showall = 0;
            self.Status = "Pending";
            self.SearchReason = '';
            self.SearchLocation = '';
            self.SearchPatientName = '';
            self.SearchProcedure = '';
            self.SearchReadingProvider = '';
            $scope.getRFIData(self.showall);
            $scope.GetCount();
        };


        function initPage() {
            $scope.getRFIData(0);
            getFacilityNames();
            GetAllUsers();
            AppHub = AppHubService.getAppHub();
            if ($sessionStorage.currentUserData.roles == 'SuperAdmin')
                self.IsSuperAdminRole = true;
            else
                self.IsSuperAdminRole = false;

            if ($sessionStorage.currentUserData.roles == 'Admin' || $sessionStorage.currentUserData.roles == 'SuperAdmin')
                self.IsAdminRole = true;
            else
                self.IsAdminRole = false
        }
        if ($scope) {
            $scope.$on('$destroy', function () {
                AppHub.off('addRFIComment_ClientTo');
                AppHub.off('removeRFIComment_ClientTo');
            });
        }

        AppHub.on('addRFIComment_ClientTo', function (commnetId, RFIId, objComment, displayName, ProfilePic, IsFile) {
            setComment(commnetId, RFIId, objComment, displayName, ProfilePic, IsFile);
        });
        AppHub.on('removeRFIComment_ClientTo', function (commentId) {
            removeComment(commentId);
        });


        function getFacilityNames() {
            var result = RFIService.GetFacilityNames();
            result.then(function (obj) {
                self.facilityNames = obj.data;
            });
        }
        function GetAllUsers() {
            chatService.GetUserList(self.currUser).then(function (result) {
                self.userList = angular.copy(result);
            });
        };

        $scope.GoToPreviousPage = function () {
            RFIService.GetRFIData(self.showall, self.itemsPerPage, self.currentPage, self.Status, self.SearchReason, self.SearchLocation, self.SearchPatientName, self.SearchProcedure, self.SearchReadingProvider, self.ShowOnlyCoderValue, self.SortByName, self.SortASC).then(function (result) {


                if (result.data.length > 0) {
                    self.NoRecords = false;
                }
                else {
                    self.NoRecords = true;

                }
                if (self.IsCoder && !self.ShowOnlyCoderValue) {
                    self.RFIdata = _.filter(result.data, function (obj) { return obj.IsReplied !== true; });
                } else {
                    self.RFIdata = result.data;
                    self.ShowOnlyCoderValue = 1;
                }
                $scope.cols = [
                    { field: "color", title: "", show: false },
                    { field: "ReasonCode", title: " Reason      ", show: false, sortable: "'ReasonCode'" },
                    { field: "LocationGroup", title: "LocationGroup", show: false, sortable: "'LocationGroup'" },
                    { field: "PatientName", title: "PatientName", sortable: "'PatientName'", show: false },
                    { field: "ProcedureDescription", title: "ProcedureDescription", show: false, sortable: "'ProcedureDescription'" },
                    { field: "DateDiffMin", title: "Days To Expire     ", show: false, sortable: "'DateDiffMin'" },
                    { field: "RFIDays", title: "Days in CAP", show: false, sortable: "'RFIDays'" },
                    { field: "Status", title: "Status    ", show: false, sortable: "'Status'" },
                    { field: "ReadingProviderName", title: "Reading Provider Name", show: false }, { field: "AssgnRFIToDoctor", title: " ", show: false }, { field: "Extension", title: " ", show: false }
                ];
                if (self.IsCoder == 1 && self.ShowOnlyCoderValue == 0) {
                    self.QuestionView = 1;
                    self.Statuses = [
                        { id: 'Pending', title: 'Pending' }
                    ];
                }
                else
                    self.QuestionView = 0;
                //self.tableParams.reload();
                self.gotoNextPage = false;
                $scope.tableParams = new NgTableParams(
                    {
                        page: 1,
                        count: self.itemsPerPage
                    },

                    { dataset: self.RFIdata, counts: [] }


                );

            });
        }


        $scope.NoChange = function () {
            $scope.UpdateReport("nochange");
        }
        $scope.DisableReport = function () {
            swal({
                title: "Are you sure you want to disable this report?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Ok",
                closeOnConfirm: true
            },
                function () {
                    $scope.UpdateReport("Disable");
                });

        };
        $scope.OpenQuestionModal = function () {
            self.alertMessage = "";
            self.message = "";
            $("#AskQuestionModal").modal('show');
        }
        $scope.Show = function () {
            //GetDoctorsInfo()
            var i = 0;
            self.Report = self.originalReport;
            self.Report = self.ModifiedDisplayReport;
            if ($sessionStorage.currentUserData.roles == 'User' || $sessionStorage.currentUserData.roles == 'Admin') {
                RFIService.GetDoctorsInfo().then(function (result) {
                    self.UserData = result.data;
                    if (self.UserData != null) {
                        self.selectedRFIData.ProviderName = self.UserData.DoctorName;
                        self.selectedRFIData.ProviderNPI = self.UserData.Reading_Doctor_NPI;
                        if (!self.selectedRFIData.ProviderName) {
                            self.selectedRFIData.ProviderName = self.selectedRFIData.ReadingProviderName;
                        }
                        if (self.selectedRFIData.ProviderName) {
                            var splitArray = "";
                            if (self.selectedRFIData.ProviderName.includes(",")) {
                                splitArray = self.selectedRFIData.ProviderName.split(",");
                            }
                            else {
                                splitArray = self.selectedRFIData.ProviderName.split(" ");
                            }
                            self.providerInitials = splitArray.length == 2 ? splitArray[0].substring(0, 1) + '. ' + splitArray[1].substring(0, 1) + '.' : (splitArray.length == 1 ? splitArray[0].substring(0, 1) : splitArray[0].substring(0, 1) + '. ' + splitArray[2].substring(0, 1) + '.');
                        }
                    }
                    debugger;
                    if (self.Report.includes('%txtbox%') || self.Report.includes("<input type='text'") || self.Report.includes('<input type="text"')) {
                        var i = 0;
                        angular.forEach(self.rows, function (row, key) {
                            UpdateValueOfOrignalReport(row, true, i, key);
                            UpdateValueOfDisplayReport(row, true, i, key);
                            i++;
                        });
                        self.Report = htmlToPlaintext(self.Report);
                        self.DisplayReport = htmlToPlaintext(self.Report);
                    }
                    else {

                        UpdateValueOfOrignalReport(null, false, i, 0);
                        UpdateValueOfDisplayReport(null, false, i, 0);
                        self.Report = htmlToPlaintext(self.Report);
                        self.DisplayReport = htmlToPlaintext(self.Report);
                    }

                    $("#SignatureModal").modal('show');
                });
            }
            else {
                if (self.Report.includes('%txtbox%') || self.Report.includes("<input type='text'") || self.Report.includes('<input type="text"')) {
                    var i = 0;
                    angular.forEach(self.rows, function (row, key) {
                        UpdateValueOfOrignalReport(row, true, i, key);
                        UpdateValueOfDisplayReport(row, true, i, key);
                        i++;
                    });
                    self.Report = htmlToPlaintext(self.Report);
                    self.DisplayReport = htmlToPlaintext(self.Report);
                }
                else {

                    UpdateValueOfOrignalReport(null, false, i, 0);
                    UpdateValueOfDisplayReport(null, false, i, 0);
                    self.Report = htmlToPlaintext(self.Report);
                    self.DisplayReport = htmlToPlaintext(self.Report);
                }

                $("#SignatureModal").modal('show');
            }

        }
        function htmlToPlaintext(text) {


            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        }

        function UpdateValueOfOrignalReport(row, flag, i, key) {
            if (flag) {
                if (row.ValueOfField && row.ValueOfField != '') {
                    self.Report = self.Report.replace("%txtbox%", row.ValueOfField);
                    self.Report = self.Report.replace("ng-model='capctrl.rows[" + key + "].ValueOfField", "/>" + row.ValueOfField + "<div ");
                    self.Report = self.Report.replace('ng-model="capctrl.rows[' + key + '].ValueOfField', '/>' + row.ValueOfField + '<div ');
                }
                else {
                    var val = $('#rows' + key).val();
                    row.ValueOfField = val;
                    self.Report = self.Report.replace("%txtbox%", val);
                    self.Report = self.Report.replace("ng-model='capctrl.rows[" + key + "].ValueOfField", "/>" + val + "<div ");
                    self.Report = self.Report.replace('ng-model="capctrl.rows[' + key + '].ValueOfField', '/>' + val + '<div ');
                }
            }

        }

        function UpdateValueOfDisplayReport(row, flag, i, key) {
            if (flag) {
                self.DisplayReport = self.Report;
                if (row.ValueOfField && row.ValueOfField != '') {
                    self.DisplayReport = self.DisplayReport.replace("%txtbox%", row.ValueOfField);
                    self.DisplayReport = self.DisplayReport.replace("ng-model='capctrl.rows[" + key + "].ValueOfField", "/>" + row.ValueOfField + "<div ");
                    self.DisplayReport = self.DisplayReport.replace('ng-model="capctrl.rows[' + key + '].ValueOfField', '/>' + row.ValueOfField + '<div ');
                }
                else {
                    var row = $('#rows' + key).val();
                    row.ValueOfField = val;
                    self.Report = self.DisplayReport.replace("%txtbox%", val);
                    self.Report = self.DisplayReport.replace("ng-model='capctrl.rows[" + key + "].ValueOfField", "/>" + val + "<div ");
                    self.Report = self.DisplayReport.replace('ng-model="capctrl.rows[' + key + '].ValueOfField', '/>' + val + '<div ');
                }
            }
        }
        function seearchdivSpan() {
            var count = 0;
            if (self.Report.indexOf('<div>') != -1) {
                self.Report = self.Report.replace('<div>', '');
                count = 1;
            }
            if (self.Report.indexOf("</div") != -1) {
                self.Report = self.Report.replace('</div>', '');
                count = 1;
            }
            if (self.Report.indexOf('<span class=\"ng-scope">') != -1) {
                self.Report = self.Report.replace('<span class=\"ng-scope">', '');
                count = 1;
            }
            if (self.Report.indexOf('<span>') != -1) {
                self.Report = self.Report.replace('<span>', '');
                count = 1;
            }
            if (self.Report.indexOf('</span>') != -1) {
                self.Report = self.Report.replace('</span>', '');
                count = 1;
            }
            if (self.Report.indexOf('<div class=\"ng-scope">') != -1) {
                self.Report = self.Report.replace('<div class=\"ng-scope">', '');
                count = 1;
            }
            if (self.Report.indexOf("\n<span class='txt-clr-5 mt-15px'>") != -1) {
                self.Report = self.Report.replace("\n<span class='txt-clr-5 mt-15px'>", '');
                count = 1;
            }
            if (self.Report.indexOf("<span class='txt-clr-5'>") != -1) {
                self.Report = self.Report.replace("<span class='txt-clr-5'>", '');
                count = 1;
            }
            if (self.Report.indexOf("<div class='mt-15px' contenteditable='false'>") != -1) {
                self.Report = self.Report.replace("<div class='mt-15px' contenteditable='false'>", '');
                count = 1;
            }
            if (self.Report.indexOf(" <input type='text'") != -1) {
                if (self.Report.indexOf("class='form-border p-5px-all w-30 mb-10px' required/>") != -1) {
                    //<input type='text' ng-model='rows[1].ValueOfField'   class='form-border p-5px-all w-30 mb-10px' required/>
                    self.Report = self.Report.replace("class='form-border p-5px-all w-30 mb-10px' required/>", "");
                    self.Report = self.Report.replace("<input type='text'", "");
                    count = 1;
                }
                count = 1;
            }

            if (self.Report.indexOf("<span class=\'ng-scope'>") != -1) {
                self.Report = self.Report.replace("<span class=\'ng-scope'>", '');
                count = 1;
            }

            if (self.Report.indexOf("<div class=\'ng-scope'>") != -1) {
                self.Report = self.Report.replace("<div class=\'ng-scope'>", '');
                count = 1;
            }
            if (self.Report.indexOf('\n<span class="txt-clr-5 mt-15px">') != -1) {
                self.Report = self.Report.replace('\n<span class="txt-clr-5 mt-15px">', '');
                count = 1;
            }
            if (self.Report.indexOf('<span class="txt-clr-5">') != -1) {
                self.Report = self.Report.replace('<span class="txt-clr-5">', '');
                count = 1;
            }
            if (self.Report.indexOf('<div class="mt-15px" contenteditable="false">') != -1) {
                self.Report = self.Report.replace('<div class="mt-15px" contenteditable="false">', '');
                count = 1;
            }
            if (self.Report.indexOf('<input type="text"') != -1) {
                if (self.Report.indexOf('class="form-border p-5px-all w-30 mb-10px" required/>') != -1) {
                    //<input type='text' ng-model='rows[1].ValueOfField'   class='form-border p-5px-all w-30 mb-10px' required/>
                    self.Report = self.Report.replace('class="form-border p-5px-all w-30 mb-10px" required/>', "");
                    self.Report = self.Report.replace('<input type="text"', "");
                    count = 1;
                }
                count = 1;
            }

            if (self.Report.indexOf('<div class="mt-15px ng-scope" contenteditable="false">') != -1) {
                self.Report = self.Report.replace('<div class="mt-15px ng-scope" contenteditable="false">', '');
                count = 1;
            }
            if (self.Report.indexOf("<div class='mt-15px ng-scope' contenteditable='false'>") != -1) {
                self.Report = self.Report.replace("<div class='mt-15px ng-scope' contenteditable='false'>", '');
                count = 1;
            }


            if (self.Report.indexOf("%drag%") != -1) {
                self.Report = self.Report.replace("%drag%", "");
                count = 1;
            }

            if (count == 1) {
                seearchdivSpan();
            }
        };
        $scope.UpdateReport = function (flag) {
            var status = 'Addendum';
            if (!flag) {
                self.Report = self.Report.concat("\nAddendum Created and Electronically signed by " + self.selectedRFIData.ProviderName + " on " + "@DateTimeForAddendum");
                self.ModifiedDisplayReport = self.Report;
                self.DisplayReport = self.DisplayReport.concat("\nAddendum Created and Electronically signed by " + self.selectedRFIData.ProviderName + " on " + "@DateTimeForAddendum");
                status = 'Addendum';
            }
            else if (flag == 'Disable') {
                // self.Report = self.Report.concat("\n No change in report");
                self.Report = self.noChangeReport;
                self.Report = self.Report.concat("\n Report is Disabled");
                self.ModifiedDisplayReport = self.Report;
                //self.ModifiedDisplayReport = self.ModifiedDisplayReport.concat("\n Report is Disabled");
                self.DisplayReport = self.DisplayReport.concat("\n Report is Disabled");
                status = 'Disable';

            }
            else {
                self.Report = self.noChangeReport;
                self.ModifiedDisplayReport = self.Report;
                self.ModifiedDisplayReport = self.ModifiedDisplayReport.concat("\n No change in report");
                self.Report = self.ModifiedDisplayReport;
                self.DisplayReport = self.DisplayReport.concat("\n No change in report");
                status = 'Addendum';

            }
            var result = RFIService.UpdateReport(self.selectedRFIData.RFI_Id, self.Report, status, self.selectedRFIData.ProviderNPI);
            result.then(function (obj) {
                var data = JSON.parse(obj.data);
                var result = data.Message;;
                var index = _.findIndex(self.PendingRFIReport, function (obj) { return obj.ID == self.selectedRFIData.ID; })

                if (flag == 'Disable') {
                    self.DisplayReport = self.DisplayReport.replace("@DateTimeForAddendum", data.Date);
                    self.Report = self.Report.replace("@DateTimeForAddendum", data.Date);
                    self.ModifiedDisplayReport = self.ModifiedDisplayReport.replace("@DateTimeForAddendum", data.Date);
                    self.PendingRFIReport[index].Status = "Disable";
                    self.PendingRFIReport[index].DictationValue = self.Report;
                    if (result > 0) {
                        if ($sessionStorage.currentUserData.roles != 'SuperAdmin') {
                            var idx = _.findIndex(self.RFIdata, function (obj) { return obj.RFI_Id == self.selectedRFIData.RFI_Id; });
                            if (idx >= 0) {
                                self.RFIdata.splice(idx, 1);
                            }

                        }
                        swal("Report is Disabled Successfully");
                        self.CommentList = [];
                        self.isPopupOpen = false;
                        self.isBlink = false;
                        $("#SignatureModal").modal('hide');
                        if (self.RFIReportIndex == self.PendingRFIReport.length) {
                            //return;
                            $scope.GoToPreviousPage();
                        }
                        else {
                            if (!flag)
                                $scope.Next();
                        }
                        self.disabledComm = true;
                        self.isPopupOpen = false;
                    }
                    else {
                        swal("Some error is coming while updating report");
                        $("#SignatureModal").modal('hide');
                        $scope.skip();
                        self.disabledComm = false;
                    }
                }
                else {
                    self.DisplayReport = self.DisplayReport.replace("@DateTimeForAddendum", data.Date);
                    self.Report = self.Report.replace("@DateTimeForAddendum", data.Date);
                    self.ModifiedDisplayReport = self.ModifiedDisplayReport.replace("@DateTimeForAddendum", data.Date);
                    self.PendingRFIReport[index].Status = "Addendum";
                    self.PendingRFIReport[index].DictationValue = self.Report;
                    if (result > 0) {
                        if ($sessionStorage.currentUserData.roles != 'SuperAdmin') {
                            var idx = _.findIndex(self.RFIdata, function (obj) { return obj.RFI_Id == self.selectedRFIData.RFI_Id; });
                            if (idx >= 0) {
                                self.RFIdata.splice(idx, 1);
                            }
                        }
                        swal("Addendum Electronically Signed Successfully");
                        self.CommentList = [];
                        self.isPopupOpen = false;
                        self.isBlink = false;
                        $("#SignatureModal").modal('hide');
                        if (self.RFIReportIndex == self.PendingRFIReport.length) {
                            //return;
                            $scope.GoToPreviousPage();
                        }
                        else {
                            if (!flag)
                                $scope.Next();
                        }
                    }
                    else {
                        swal("Some error is coming while updating report");
                        $("#SignatureModal").modal('hide');
                        $scope.skip();
                    }
                }
                // $scope.diagnosticItem = obj.data[0];
                //   hideLoading();
            }, function (error) {
                //  hideLoading();
            });
        }
        function updateReportForMissingLocations() {
            var result = RFIService.UpdateReport(self.selectedRFIData.RFI_Id, "", "Addendum", self.selectedRFIData.ProviderNPI);
            result.then(function (obj) {
                var data = JSON.parse(obj.data);
                var result = data.Message;;

            }, function (error) {
                //  hideLoading();
            });
        }

        $scope.ShowReadingLocations = function () {
            var userId = $sessionStorage.currentUserData.userId;
            var result = RFIService.GetReadingLocations(userId);
            result.then(function (obj) {
                self.readingLocations = obj.data;
            });
        }
        $scope.GoToRFIReport = function (selectedRFIData, col) {
            if (col == "DateDiffMin")
                return;
            self.selectedRFIData = selectedRFIData;
            getCommentbyRFIId(selectedRFIData.RFI_Id);
            OpenCIDicomViewer();
            RFIService.GetDoctorsInfo().then(function (result) {
                self.UserData = result.data;

                if (self.UserData != null) {
                    self.selectedRFIData.ProviderName = self.UserData.DoctorName;
                    self.selectedRFIData.ProviderNPI = self.UserData.Reading_Doctor_NPI;

                }
                //});
                if (selectedRFIData.Status == "Addendum" || selectedRFIData.Status == "Expired" || selectedRFIData.Status == "Disable") {
                    $("#ReportModal").modal('show');
                    if (self.selectedRFIData.ReasonCode == 'MISSING READING LOCATIONS') {
                        var userId = $sessionStorage.currentUserData.userId;
                        var result = RFIService.GetReadingLocations(userId);
                        result.then(function (obj) {
                            self.readingLocations = obj.data;
                            self.Reason = self.selectedRFIData.ReasonCode;
                        });
                    }
                    else {
                        if (selectedRFIData.Status == "Expired") {
                            self.Report = self.selectedRFIData.DictationValue;
                            self.ModifiedDisplayReport = self.selectedRFIData.DictationValue;
                            self.DisplayReport = self.selectedRFIData.DictationValue;
                        }
                        else {
                            self.Report = self.selectedRFIData.SignedDictationValue;
                            self.ModifiedDisplayReport = self.selectedRFIData.SignedDictationValue;
                            self.DisplayReport = self.selectedRFIData.SignedDictationValue;
                        }

                        self.Reason = self.selectedRFIData.ReasonCode;

                    }
                    self.noChangeReport = angular.copy(self.Report);
                }

                else {

                    if (self.selectedRFIData.ReasonCode == 'MISSING READING LOCATIONS') {
                        var userId = $sessionStorage.currentUserData.userId;
                        var result = RFIService.GetReadingLocations(userId);
                        result.then(function (obj) {
                            self.readingLocations = obj.data;
                            self.Reason = self.selectedRFIData.ReasonCode;
                        });


                    } else {
                        self.Report = self.selectedRFIData.DictationValue;
                        self.ModifiedDisplayReport = self.selectedRFIData.DictationValue + " </span>";
                        //self.ModifiedDisplayReport = self.selectedRFIData.DictationValue;
                        self.DisplayReport = self.selectedRFIData.DictationValue;
                        self.rows = [];
                        //  $state.go("report_RFIReports");
                        if (!self.selectedRFIData.ProviderName) {
                            self.selectedRFIData.ProviderName = self.selectedRFIData.ReadingProviderName;
                        }
                        if (self.selectedRFIData.ProviderName) {
                            var splitArray = "";
                            if (self.selectedRFIData.ProviderName.includes(",")) {
                                splitArray = self.selectedRFIData.ProviderName.split(",");
                            }
                            else {
                                splitArray = self.selectedRFIData.ProviderName.split(" ");
                            }
                            self.providerInitials = splitArray.length == 2 ? splitArray[0].substring(0, 1) + '. ' + splitArray[1].substring(0, 1) + '.' : (splitArray.length == 1 ? splitArray[0].substring(0, 1) : splitArray[0].substring(0, 1) + '. ' + splitArray[2].substring(0, 1) + '.');
                        }
                        self.DOS = moment(new Date(self.selectedRFIData.DOS)).format("MM-DD-YYYY");
                        //   GetDicomImagesByAccession(self.selectedRFIData.Accession_Number);//self.selectedRFIData.AccessionID
                        GetOptionsOfReason(self.selectedRFIData.ReasonCode);
                    }
                    self.gotoNextPage = true;
                    self.PendingRFIReport = _.filter(self.RFIdata, function (obj) { return obj.Status == "Pending"; });
                    var index = _.findIndex(self.PendingRFIReport, function (obj) { return obj.ID == self.selectedRFIData.ID; });
                    self.RFIReportIndex = index + 1;
                    self.noChangeReport = angular.copy(self.Report);
                }

            });

        }
        $scope.dropSuccessHandler = function ($event, index, array) {  //$event, index, array
            //swal('hi');
            //  array.splice(index, 1);
        };
        $scope.ChangeQuestion = function () {
            if (self.alertMessage)
                self.alertMessage = "";
        }
        $scope.AskQuestion = function () {
            self.message = "Patient Name: " + self.selectedRFIData.PatientName + "\n" + "Accession Number: " + self.selectedRFIData.Accession_Number + "\n" + "MRN: " + self.selectedRFIData.MRN + "\n" + self.message;

            var curVM = getMessageViewModel({
                message: self.message.replace('/\n+/', '\n'),
            });

            appService.SendMessage(true, { "curVm": curVM, "MsgExpTime": "7200000", "MsgTimeZone": moment().format('Z'), "FromDisplayName": $sessionStorage.currentUserData.displayName, "GroupName": "", "SelectedUsers": null });
            self.alertMessage = "Your Question is submitted Successfully to Coder ";
            self.message = "";
            // $("#AskQuestionModal").modal('hide');
        }
        function getMessageViewModel(xiMessageVM) {
            return {
                fromUserID: $sessionStorage.currentUserData.userId,
                message: xiMessageVM.message,
                messageType: 4,
                messageKey: uuid2.newuuid(),
                //toUserName: xiMessageVM.toUserName,
                toUserID: self.coderUserId,//"0d45b769-6295-4e52-a7ce-1a54fc432c30",//
                toGroupID: null,
                isPrivateChat: true,
                isMessageRead: false,
                isHighPriority: true,
                //messageReadTime: msgTime,
                FileSystemModels: null
                //highlight: re.test(message.Content) ? 'highlight' : '',
                //status: getMessageUserStatus(message.User).toLowerCase()
            };
        }
        $scope.Previous = function () {
            self.rows = [];
            self.RFIReportIndex = self.RFIReportIndex - 1;
            self.selectedRFIData = self.PendingRFIReport[self.RFIReportIndex - 1];
            self.Report = self.selectedRFIData.DictationValue;
            self.ModifiedDisplayReport = self.selectedRFIData.DictationValue + " </span>";
            //self.ModifiedDisplayReport = self.selectedRFIData.DictationValue;
            self.DisplayReport = self.selectedRFIData.DictationValue;
            self.noChangeReport = angular.copy(self.Report);
            OpenCIDicomViewer();
            GetOptionsOfReason(self.selectedRFIData.ReasonCode);
            if (!self.savechangeOfReadinglocations)
                angular.forEach(self.readingLocations, function (obj) {
                    obj.ReadingLocationName = null;
                });
            getCommentbyRFIId(self.selectedRFIData.RFI_Id);
            if (!self.selectedRFIData.ProviderName) {
                self.selectedRFIData.ProviderName = self.selectedRFIData.ReadingProviderName;
            }
            if (self.selectedRFIData.ProviderName) {
                var splitArray = "";
                if (self.selectedRFIData.ProviderName.includes(",")) {
                    splitArray = self.selectedRFIData.ProviderName.split(",");
                }
                else {
                    splitArray = self.selectedRFIData.ProviderName.split(" ");
                }
                self.providerInitials = splitArray.length == 2 ? splitArray[0].substring(0, 1) + '. ' + splitArray[1].substring(0, 1) + '.' : (splitArray.length == 1 ? splitArray[0].substring(0, 1) : splitArray[0].substring(0, 1) + '. ' + splitArray[2].substring(0, 1) + '.');
            }

            self.DOS = moment(new Date(self.selectedRFIData.DOS)).format("MM-DD-YYYY");
        }
        $scope.Next = function () {
            self.selectedRFIData = self.PendingRFIReport[self.RFIReportIndex];
            self.RFIReportIndex = self.RFIReportIndex + 1;
            self.Report = self.selectedRFIData.DictationValue;
            self.ModifiedDisplayReport = self.selectedRFIData.DictationValue + " </span>";
            OpenCIDicomViewer();
            //self.ModifiedDisplayReport = self.selectedRFIData.DictationValue;
            self.DisplayReport = self.selectedRFIData.DictationValue;
            self.noChangeReport = angular.copy(self.Report);
            GetOptionsOfReason(self.selectedRFIData.ReasonCode);
            getCommentbyRFIId(self.selectedRFIData.RFI_Id);
            if (!self.selectedRFIData.ProviderName) {
                self.selectedRFIData.ProviderName = self.selectedRFIData.ReadingProviderName;
            }
            if (self.selectedRFIData.ProviderName) {
                var splitArray = "";
                if (self.selectedRFIData.ProviderName.includes(",")) {
                    splitArray = self.selectedRFIData.ProviderName.split(",");
                }
                else {
                    splitArray = self.selectedRFIData.ProviderName.split(" ");
                }
                self.providerInitials = splitArray.length == 2 ? splitArray[0].substring(0, 1) + '. ' + splitArray[1].substring(0, 1) + '.' : (splitArray.length == 1 ? splitArray[0].substring(0, 1) : splitArray[0].substring(0, 1) + '. ' + splitArray[2].substring(0, 1) + '.');
            }

            self.DOS = moment(new Date(self.selectedRFIData.DOS)).format("MM-DD-YYYY");
        }
        $scope.skip = function () {
            var i = self.ModifiedDisplayReport;
            self.ModifiedDisplayReport.indexOf('</span>')
            self.rows = [];
            self.selectedRFIData = self.PendingRFIReport[self.RFIReportIndex];
            OpenCIDicomViewer();
            self.RFIReportIndex = self.RFIReportIndex + 1;
            self.Report = self.selectedRFIData.DictationValue;
            self.ModifiedDisplayReport = self.selectedRFIData.DictationValue + " </span>";
            //self.ModifiedDisplayReport = self.selectedRFIData.DictationValue;
            self.DisplayReport = self.selectedRFIData.DictationValue;
            self.noChangeReport = angular.copy(self.Report);
            if (!self.savechangeOfReadinglocations)
                angular.forEach(self.readingLocations, function (obj) {
                    obj.ReadingLocationName = null;
                });
            GetOptionsOfReason(self.selectedRFIData.ReasonCode);
            getCommentbyRFIId(self.selectedRFIData.RFI_Id);
            if (!self.selectedRFIData.ProviderName) {
                self.selectedRFIData.ProviderName = self.selectedRFIData.ReadingProviderName;
            }
            if (self.selectedRFIData.ProviderName) {
                var splitArray = "";
                if (self.selectedRFIData.ProviderName.includes(",")) {
                    splitArray = self.selectedRFIData.ProviderName.split(",");
                }
                else {
                    splitArray = self.selectedRFIData.ProviderName.split(" ");
                }
                self.providerInitials = splitArray.length == 2 ? splitArray[0].substring(0, 1) + '. ' + splitArray[1].substring(0, 1) + '.' : (splitArray.length == 1 ? splitArray[0].substring(0, 1) : splitArray[0].substring(0, 1) + '. ' + splitArray[2].substring(0, 1) + '.');
            }

            self.DOS = moment(new Date(self.selectedRFIData.DOS)).format("MM-DD-YYYY");
        }
        $scope.dropFailureHandler = function ($event, index, array) {
            swal(array[index] + ' could be dropped into left list!');

        };
        $scope.dropValidateHandler1 = function ($drop, $event, $data) {
            return true;
        };
        $scope.onDrop1 = function ($event, $data, index) {
            if (index != -1)
                self.readingLocations[index].ReadingLocationName = $data.Name;
        };
        $scope.dropValidateHandler = function ($drop, $event, $data) {
            //$(".draggable").draggable({
            //    revert: true,
            //    helper: 'clone',
            //    start: function (event, ui) {
            //        $(this).fadeTo('fast', 0.5);
            //    },
            //    stop: function (event, ui) {
            //        $(this).fadeTo(0, 1);
            //    }
            //});
            //if ($scope.ModifiedDisplayReport.includes($data))
            //    return false;
            //else
            return true;
        };
        $scope.onDrop = function ($event, $data, index) {

            self.Report = getNewDragedName(self.Report, $data);
            self.ModifiedDisplayReport = getNewModifiedDisplayReport(self.ModifiedDisplayReport, $data);
            self.DisplayReport = getNewDragedNameForDisplayReport(self.DisplayReport, $data);
            self.originalReport = self.Report;
        };
        $scope.SaveChangesOfReadingLocations = function () {
            var data = _.find(self.readingLocations, function (obj) {
                return obj.ReadingLocationName == null;
            });
            if (data) {
                swal('Please enter all missing reading locations');
            } else {
                var result = RFIService.UpdaeReadingLocations(self.readingLocations);
                result.then(function (obj) {
                    var result = obj.data;
                    self.savechangeOfReadinglocations = true;
                    //   hideLoading();
                    swal("Reading Locations are updated successfully");
                    $scope.Next();
                }, function (error) {
                    //  hideLoading();
                });
                updateReportForMissingLocations();
            }
        }
        var getNewDragedName = function (report, selectedOptionName) {
            var tempreport = "";
            if (!report.includes("%drag%")) {
                tempreport = report + "\n" + "%drag%" + selectedOptionName;
            }
            else {
                tempreport = report + "\n" + selectedOptionName;
            }
            return tempreport;

        };
        var getNewDragedNameForDisplayReport = function (report, selectedOptionName) {
            var tempreport = "";
            tempreport = report + "\n" + "<span class='txt-clr-5 mt-15px'>" + selectedOptionName + "</span>";
            return tempreport;

        };
        var getNewModifiedDisplayReport = function (report, selectedOptionName) {
            var tempreport = "";
            var count = (selectedOptionName.match(/%txtbox%/g) || []).length;
            if (count > 0) {
                if (!report.includes('<div class="mt-15px" contenteditable="false">')) {
                //if (!report.includes("contenteditable='false'>")) {
                    var res = selectedOptionName;
                    for (var i = 0; i < count; i++) {
                        self.rows.push({
                            ValueOfField: ""
                        });
                        var index = self.rows.length - 1;
                        res = res.replace("%txtbox%", "<input type='text' id='rows" + index+"' ng-model='capctrl.rows[" + index + "].ValueOfField'   class='form-border p-5px-all w-80 mb-10px capblkinput b-1-s outline-none' required/>");
                    }
                    tempreport = report + "\n" + "<div class='mt-15px' contenteditable='false'> <span class='txt-clr-5'>" + res + "</span></div>";
                    //bug 36472 - Remove span tag from above line to remove border on IE browser
                }
                else {
                    var res = "";
                    for (var i = 0; i < count; i++) {
                        var res = selectedOptionName;
                        self.rows.push({
                            ValueOfField: ""
                        });
                        var index = self.rows.length - 1;
                        res = selectedOptionName.replace("%txtbox%", "<input type='text' id='rows" + index +"' ng-model='capctrl.rows[" + index + "].ValueOfField'   class='form-border p-5px-all w-30 mb-10px' required/>");
                    }
                    var index = report.indexOf("</div>");
                    var str1 = report.slice(0, index);
                    var str2 = report.slice(index);
                    tempreport = str1 + "\n" + "<span class='txt-clr-5'>" + res + "</span>" + str2;
                }
            }
            else {
                if (!report.includes("<div class='mt-15px' contenteditable='false'>")) {
                    tempreport = report + "\n" + "<div class='mt-15px cursor-pointer-events-none' contenteditable='false'> <span class='txt-clr-5'>" + selectedOptionName + "</span></div>";
                }
                else {
                    var index = report.indexOf("</div>");
                    var str1 = report.slice(0, index);
                    var str2 = report.slice(index);
                    tempreport = str1 + "\n" + "<span class='txt-clr-5'>" + selectedOptionName + "</span>" + str2;
                }
            }

            return tempreport;

        };
        function GetDicomImagesByAccession(accessionNumber) {
            var result = RFIService.GetDicomImagesByAccession(accessionNumber);
            result.then(function (obj) {
                var result = obj.data;

                self.DicomImages = result.DicomImages;
                //   hideLoading();
            }, function (error) {
                //  hideLoading();
            });
        }
        function GetOptionsOfReason(reason) {
            var result = RFIService.GetOptionsOfReason(reason);
            result.then(function (obj) {
                var result = obj.data;
                if (result == null) {
                    self.options = [];
                    self.Reason = reason;
                    self.RFIFileData = null;
                }
                else {
                    self.options = result.Options;
                    self.Reason = result.Reason;
                    self.RFIFileData = result.RFIFileData;

                }
                // self.diagnosticItem = obj.data[0];
                //   hideLoading();
            }, function (error) {
                //  hideLoading();
            });
        }
        $scope.showPreview = function () {
            self.fileurl = null;
            if (self.RFIFileData) {
                $http({
                    method: 'POST',
                    url: __env._environment.config.radiCoAPI + ($sessionStorage.currentUserData.TenantName == 'TRAMBMS' ? 'TRA' : $sessionStorage.currentUserData.TenantName) + '/api/RFI' + '/GetFileData',
                    data: JSON.stringify({ fileKey: self.RFIFileData.FileKey }),
                    //data: { filePath: selectedFiles },
                    responseType: 'arraybuffer',
                    headers: {
                        'Authorization': 'Bearer ' + $sessionStorage.currentUserData.accessToken,
                        'content-type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    }
                }).success(function (data, status, headers) {
                    headers = headers();
                    var contentType = headers['content-type'];

                    try {

                        $("#previewModal1").modal('show');
                        var blob = new Blob([data], { type: contentType });
                        var blob_url = window.URL.createObjectURL(blob);
                        self.fileurl = blob_url;
                        self.FileContent = data;
                        // alert(blob_url);
                        //$("#myiFrame2").attr("src", blob_url);

                    } catch (ex) {
                        swal("Some error has occured");
                        console.log(ex);
                    }
                }).error(function (data) {
                    swal("Some error has occured");
                    console.log(data);
                });

            }
        }
        self.shoRFIPopup = false;
        RFIService.GetRFIUsers().then(function (result) {
            self.RFIUsers = result.data;
            $scope.tableParamUser = new NgTableParams({ page: 1, count: 13 }, { counts: [], dataset: self.RFIUsers });
        });

        $scope.addUser = function (user) {
            if (!user.Selected) {
                var i;
                for (i = 0; i < self.RFIUsers.length; i++) {
                    self.RFIUsers[i].Selected = false;
                }
                user.Selected = true;
                self.SelectedNormalUsers = user;
            }
            else {
                var i;
                for (i = 0; i < self.RFIUsers.length; i++) {
                    self.RFIUsers[i].Selected = false;
                }
                self.SelectedNormalUsers = '';
                self.IsResultMessage = false;
            }
        }
        $scope.Clear = function () {
            var i;
            for (i = 0; i < self.RFIUsers.length; i++) {
                self.RFIUsers[i].Selected = false;
            }
            self.SelectedNormalUsers = '';
            self.IsResultMessage = false;
        }
        self.selectedIndex = 0;
        $scope.SelectedRFIforExtension = function (row) {
            self.selectedRFI = row;

            $("#ExtentionOfExpiy").modal('show');
        }
        $scope.PluckSelectedRFI = function (row) {
            self.selectedRFI = row;
            self.searchUser = '';
            //self.selectedIndex = row_index;
            var i;
            for (i = 0; i < self.RFIUsers.length; i++) {
                self.RFIUsers[i].Selected = false;
            }
            self.SelectedNormalUsers = '';
            self.IsResultMessage = false;
            $("#assignFRIModel").modal('show');
        }
        $scope.AssignRFIToUser = function () {

            showLoader(true);
            if (self.selectedRFI.RFI_Id) {
                RFIService.AssignRFIToUser(self.SelectedNormalUsers, self.selectedRFI.RFI_Id).then(function (result) {
                    if (result.data != "Your NPI number is not found.") {
                        self.selectedRFI.AssignedToName = self.SelectedNormalUsers.DisplayName;
                        self.ResultColor = 'green';
                        self.IsResultMessage = true;
                        self.ResultMessage = 'Successfully Assigned to Dr. ' + self.SelectedNormalUsers.DisplayName;
                        if ($sessionStorage.currentUserData.roles != 'SuperAdmin') {
                            var idx = _.findIndex(self.RFIdata, function (obj) { return obj.RFI_Id == self.selectedRFIData.RFI_Id; });
                            if (idx >= 0) {
                                self.RFIdata.splice(idx, 1);
                            }
                            //self.RFIdata.splice(self.RFIdata.findIndex(x => x.RFI_Id === self.selectedRFI.RFI_Id), 1)
                            $scope.tableParams = new NgTableParams(
                                {
                                    page: 1,
                                    count: self.itemsPerPage,
                                    filter: { ReasonCode: "" }
                                },

                                { dataset: self.RFIdata, counts: [] }


                            );
                        }
                        showLoader(false);
                        $("#assignFRIModel").modal('hide');
                        self.selectedRFI.AssignedToName = self.SelectedNormalUsers.DisplayName;
                        self.ResultColor = 'green';
                        self.IsResultMessage = false;
                        self.ResultMessage = '';
                    }
                    else {
                        showLoader(false);
                        swal(result.data);
                    }
                });

            } else {
                showLoader(false);
                self.ResultColor = 'red';
                self.IsResultMessage = true;
                self.ResultMessage = 'Some Error Occured !!';
                $("#assignFRIModel").modal('hide');
            }
        }
        function addComment(Id, RFI_Id, Comment, RepliedToCommentId) {
            if (self.IsCoder == 1 && RepliedToCommentId == 0)
                RepliedToCommentId = -1;
            var result = RFIService.submitComment(Id, RFI_Id, Comment, RepliedToCommentId);
            result.then(function (obj) {
                var data = obj.data;
                //data.DisplayName = $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName;
                //data.ProfilePic = $sessionStorage.currentUserData.ProfilePic;
                if (RepliedToCommentId > 0) {
                    self.disabledReply = false;
                    self.RepliedToCommentId = 0;
                //    fnloadReplies(obj.data.Id);
                }
                else {
                //    self.CommentList.push(data);
                    self.disabledComment = false;
                }
                //self.AllComments.push(data);
                self.Comment = '';
            }, function (error) {
                //  hideLoading();
            });
        }

        $scope.onFolderNumberKeyPress = function ($event, type) {
            var keyPressEvt = window.event ? $event.keyCode : $event.which;
            if (type == 'reply') {
                if (self.Reply) {
                    if (keyPressEvt == 13) {
                        self.disabledReply = true;
                        addComment(0, self.selectedRFIData.RFI_Id, self.Reply, self.RepliedToCommentId);
                        self.Reply = '';
                        $event.preventDefault();
                    }
                    return;
                }
            }
            else {
                if (self.Comment) {
                    if (keyPressEvt == 13) {
                        addComment(0, self.selectedRFIData.RFI_Id, self.Comment, 0);
                        self.Comment = '';
                        $event.preventDefault();
                    }
                    return;
                }
            }
        };

        $scope.togglePopup = function () {
            if (self.isPopupOpen) {
                self.isPopupOpen = false;
                self.isBlink = false;
            }
            else {
                self.isBlink = false;
                self.isPopupOpen = true;
            }
            $(".pb-chat-dropdown").slideToggle(400);
        }

        $scope.sendMessage = function (type) {
            if (type == 'reply') {
                if (self.Reply && self.Reply.trim().length > 0) {
                    self.disabledReply = true;
                    addComment(0, self.selectedRFIData.RFI_Id, self.Reply, self.RepliedToCommentId);
                    self.Reply = '';

                }
            }
            else {
                if (self.Comment && self.Comment.trim().length > 0) {
                    addComment(0, self.selectedRFIData.RFI_Id, self.Comment, 0);
                    self.Comment = '';

                }
            }
        };

        function getFileViewModel(file) {
            return {
                FileKey: uuid2.newuuid(),
                Id: 0,
                RFICommentId: self.selectedRFIData.RFI_Id,
                FileName: file.name,
                RepliedToCommentId: self.RepliedToCommentId
            };
        };
        $scope.uploadFile = function (input, isComment) {
            if (isComment == 'comment') {
                self.RepliedToCommentId = 0;
            }
            var formdata = new FormData();
            if (input.files.length > 0) {
                if (input.files[0].size / 1024 / 1024 <= 2) {
                    var fileformate = validateFile(input.files[0]);
                    if (fileformate != undefined) {
                        formdata.append("file" + '0', input.files[0]);
                        //  $rootScope.$emit("OnFileNameChanged", self.FileName);
                        var uplodedFile = getFileViewModel(input.files[0]);
                        formdata.append("RFIFileSystemModel", JSON.stringify(uplodedFile));
                        var fileUploaded = RFIService.RFIUploadChatFiles(formdata);
                        fileUploaded.then(function (obj) {
                            var data = obj.data;
                            data.DisplayName = $sessionStorage.currentUserData.displayName;
                            data.ProfilePic = $sessionStorage.currentUserData.ProfilePic;
                            if (data.RepliedToCommentId > 0) {
                                self.disabledReply = false;
                                //self.RepliedToCommentId = 0;
                                fnloadReplies(obj.data.Id);
                            }
                            else {
                                self.CommentList.push(data);
                                self.disabledComment = false;
                            }
                            self.AllComments.push(data);
                            self.Comment = '';

                            // self.roomListVM = obj.data;
                        }, function (error) {
                            self.FileName = "";
                            $('#selectedFileRFI').val('');
                            self.Reasons[index].RFIFileSystemViewModel = null;
                            swal("Some error has occured");
                        });

                        $('#selectedFileRFI').val('');


                    }
                }
                else {
                    swal("File size should not be greater than 2 MB");
                }
            }
        };
        $scope.DownloadFile = function (input) {
            var i = input;

            RFIService.GetRFIDownloadChatFiles(input.Id).then(function (data, status, headers) {
                headers = data.headers();

                var filename = input.Comment;
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([data.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);

                    if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                        window.navigator.msSaveBlob(blob, filename);
                    }
                    else {
                        linkElement.setAttribute('href', url);
                        linkElement.setAttribute("download", filename);

                        var clickEvent = new MouseEvent("click", {
                            "view": window,
                            "bubbles": true,
                            "cancelable": true
                        });
                        linkElement.dispatchEvent(clickEvent);
                    }
                    
                    $("input[type='file']").val(null);

                    //self.isMarked = false;
                    showLoader(false);
                } catch (ex) {
                    console.log(ex);
                }
            });
            //else
            // swal("Attach Pdf only");
        };

        function setComment(commnetId, RFIId, objComment, displayName, ProfilePic, IsFile) {

            if (self.selectedRFIData && self.selectedRFIData.RFI_Id == RFIId) {
                if (commnetId > 0) {
                    var index = _.findIndex(self.AllComments, function (obj) { return obj.Id == commnetId });
                    if (index >= 0) {
                        self.AllComments[index].Comment = objComment.Comment;
                    }
                    else {
                        self.AllComments.push(objComment);
                    }
                    index = _.findIndex(self.CommentList, function (obj) { return obj.Id == commnetId });
                    if (index >= 0) {
                        self.CommentList[index].Comment = objComment.Comment;
                    }
                    else {
                        if (objComment.RepliedToCommentId > 0) {
                            fnloadReplies(objComment.Id);
                        }
                        else {
                            self.CommentList.push(objComment);
                        }
                    }
                    if (!self.isPopupOpen) {
                        self.isBlink = true;
                    }
                    else
                        self.isBlink = false;
                }
                else {
                    //objComment.DisplayName = displayName;
                    objComment.ProfilePic = ProfilePic;
                    if (objComment.RepliedToCommentId > 0) {
                        fnloadReplies(objComment.Id);
                    }
                    else {
                        self.CommentList.push(objComment);
                    }
                    self.AllComments.push(objComment);
                    if (!self.isPopupOpen) {
                        self.isBlink = true;
                    }
                    else
                        self.isBlink = false;
                }

            }

        }
        function removeComment(commentId) {
            var comment = _.filter(self.AllComments, function (obj) {
                return obj.Id == commentId;
            });
            var index = _.findIndex(self.AllComments, function (users) {
                return users.Id == commentId;
            });
            comment.IsDeleted = true;
            if (index >= 0) {
                self.AllComments.splice(index, 1);
                index = _.findIndex(self.CommentList, function (users) {
                    return users.Id == commentId;
                });
                if (index >= 0) {
                    self.CommentList.splice(index, 1);
                }
                if (comment.RepliedToCommentId > 0)
                    fnloadReplies(comment.RepliedToCommentId);
            }
        }
        function getCommentbyRFIId(Id) {

            self.CommentList = [];
            var Comments = RFIService.getCommentbyId(Id);
            Comments.then(function (obj) {

                self.AllComments = obj.data;

                $timeout(function () {
                    var update = RFIService.updateIsReadCommentStatus(Id);
                }, 5000);
                var parentComments = self.AllComments.filter(function (object) {
                    return object.RepliedToCommentId !== 0 ? false : true;
                });
                self.CommentList = parentComments;


            });
        }
        $scope.LoadReplies = function (commentId) {
            return fnloadReplies(commentId);
        }
        function fnloadReplies(commentId) {
            var childComments = filterFilter(self.AllComments, {
                RepliedToCommentId: commentId,
                IsDeleted: '!' + true
            });
            return childComments;
        }
        $scope.reply = function (commentId) {
            self.RepliedToCommentId = commentId;
            $('#reply').focus();
        }

        $scope.deleteComment = function (comment) {
            swal({
                title: "Are you sure you want to delete this comment?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Ok",
                closeOnConfirm: true
            },
                function () {
                    var deleteCmt = RFIService.deleteComment(comment.Id);
                    deleteCmt.then(function (obj) {
                        comment.IsDeleted = true;
                        removeComment(comment.Id);

                    });
                });
        }
        $scope.editComment = function (comment) {
            if (comment.Comment) {
                oldcomment = comment.Comment;
                comment.IsEdit = true;
            }
        }
        $scope.cancelComment = function (comment) {
            comment.Comment = oldcomment;
            comment.IsEdit = false
        }
        $scope.updateComment = function (comment) {
            if (comment.Comment) {
                comment.IsEdit = false;
                var updateCmt = RFIService.submitComment(comment.Id, self.selectedRFIData.RFI_Id, comment.Comment, comment.RepliedToCommentId);
                updateCmt.then(function (obj) {
                    if (obj.data) {
                        comment.CommentDate = obj.data.CommentDate;
                        comment.Comment = obj.data.Comment;
                        var index = _.findIndex(self.AllComments, function (obj) { return obj.Id == comment.UserId });
                        if (index >= 0) {
                            self.AllComments[index].Comment = comment.Comment;
                        }
                        index = _.findIndex(self.CommentList, function (obj) { return obj.Id == comment.UserId });
                        if (index >= 0) {
                            self.CommentList[index].Comment = comment.Comment;
                        }
                    }
                });
            }
        }

        $scope.GetCheckMedicalDirector = function () {
            RFIService.GetCheckMedicalDirector().then(function (result) {

                self.IsMediclDirector = result.data;
            })
        }

        $scope.GetCheckMedicalDirector();
        $scope.RequestExtentionExpiry = function (Day) {
            $("#ExtentionOfExpiy").modal('hide');
            showLoader(true);
            self.newDate = new Date(self.selectedRFI.ExpirationTime).getDate(self.selectedRFI.ExpirationTime);
            self.selectedRFI.ExpirationTime = new Date(self.selectedRFI.ExpirationTime);
            self.selectedRFI.ExpirationTime.setDate(self.newDate + Day);
            RFIService.UpdateExpirationDateTime(self.selectedRFI.RFI_Id, self.selectedRFI.ExpirationTime, 1).then(function (obj) {


                $scope.cols = [
                    { field: "color", title: "", show: false },
                    { field: "ReasonCode", title: " Reason      ", show: false, sortable: "'ReasonCode'" },
                    { field: "LocationGroup", title: "LocationGroup", show: false, sortable: "'LocationGroup'" },
                    { field: "PatientName", title: "PatientName", sortable: "'PatientName'", show: false },
                    { field: "ProcedureDescription", title: "ProcedureDescription", show: false, sortable: "'ProcedureDescription'" },
                    { field: "DateDiffMin", title: "Days To Expire     ", show: false, sortable: "'DateDiffMin'" },
                    { field: "RFIDays", title: "Days in CAP", show: false, sortable: "'RFIDays'" },
                    { field: "Status", title: "Status    ", show: false, sortable: "'Status'" },
                    { field: "ReadingProviderName", title: "Reading Provider Name", show: false }, { field: "AssgnRFIToDoctor", title: " ", show: false }, { field: "Extension", title: " ", show: false }
                ];
                self.selectedRFI.IsExpiryDateExtendedByUser = true;
                self.selectedRFI.ChangeExpiry = false;
                self.selectedRFI.DateDiffMin = obj.data;
                //self.RFIdata[self.selectedIndex].ChangeExpiry = false;
                //self.RFIdata[self.selectedIndex].DateDiffMin = obj.data;
                showLoader(false);
                self.SelectedDay = 1;
            });

            $scope.tableParams = new NgTableParams(
                {
                    page: 1,
                    count: self.itemsPerPage,
                    filter: { ReasonCode: "" }
                },

                { dataset: self.RFIdata, counts: [] }


            );
        }

        self.Days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        $scope.getMessageDate = function (message) {
            var idx = $scope.MessageList.indexOf(message);
            var isShowDate = true;
            if (idx > 0) {
                var previousMessage = $scope.MessageList[idx - 1];
                var previousDate = moment.utc(previousMessage.MessageTime).local().format('YYYYMMDD');
                var currentDate = moment.utc(message.MessageTime).local().format('YYYYMMDD');
                if (previousDate === currentDate) {
                    isShowDate = false;
                }
            }
            var dateDisplay = '';
            if (isShowDate) {
                var messageTime = moment.utc(message.MessageTime).local();
                var diff = moment().diff(moment(messageTime, 'YYYY-MM-DD').startOf('day'), 'days', false);
                if (diff == 0) {
                    dateDisplay = 'Today';
                } else if (diff == 1) {

                    dateDisplay = 'Yesterday';
                } else {
                    dateDisplay = moment.utc(message.MessageTime).local().format('M/D/YYYY');
                }
            }

            return dateDisplay
        }
        $scope.showDisplayname = function (UserId, displayname) {
            var name = displayname.substring(0, 1);
            if (self.userList) {
                var index = _.findIndex(self.userList, function (obj) { return obj.Id == UserId });
                if (index >= 0) {
                    displayname = self.userList[index].LastName + ' ' + self.userList[index].FirstName;
                }
            }
            var n = displayname.split(' ');
            if (n.length > 1) {
                name = n[0].substring(0, 1) + n[1].substring(0, 1);
            }
            return name;
        }
        $scope.setUsername = function (comment) {
            var name = comment.DisplayName;
            if (self.userList) {
                var index = _.findIndex(self.userList, function (obj) { return obj.Id == comment.UserId });
                if (index >= 0) {
                    name = self.userList[index].LastName + ', ' + self.userList[index].FirstName;
                }
            }
            return name;
        }
        function OpenCIDicomViewer() {
            self.dicomUrl = null;
            //var accession = 'PDI-1612643';
            var accession = self.selectedRFIData.Accession_Number;
            //if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
            //    self.dicomUrl = APP_CONSTANTS.ciDICOMViewer.replace("@ACCESSION", accession);
            //}
            //else {
            self.dicomUrl = __env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession);
            //}
            
        }
    }

}) ()
app.filter('myDateFilter', ['$filter',
    function ($filter) {
        return function (input) {

            // set minutes to seconds
            var seconds = input * 60

            // calculate (and subtract) whole days
            var days = Math.floor(seconds / 86400);
            seconds -= days * 86400;

            // calculate (and subtract) whole hours
            var hours = Math.floor(seconds / 3600) % 24;
            seconds -= hours * 3600;

            // calculate (and subtract) whole minutes
            var minutes = Math.floor(seconds / 60) % 60;

            if (days < 0) {
                if (days >= -1 && days < 0)
                    return hours + 'hrs ' + minutes + 'mins ago';
                else
                    return (days + (-days * 2)) + 'days ago';
            } else {
                if (days < 1 && days >= 0)
                    return hours + 'hrs ' + minutes + 'mins left';
                else
                    return days + ' days left';
            }
        }
    }
]);
contenteditable.$inject = ['$sce'];
function contenteditable($sce) {
    return {
        restrict: 'A', // only activate on element attribute
        require: '?ngModel', // get a hold of NgModelController
        link: function (scope, element, attrs, ngModel) {
            if (!ngModel) return; // do nothing if no ng-model

            // Specify how UI should be updated
            ngModel.$render = function () {
                element.html(ngModel.$viewValue || "");
                // element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
            };

            // Listen for change events to enable binding
            element.on('blur', function () {
                scope.$evalAsync(read);
            });
            //read(); // initialize

            // Write data to the model
            function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                    html = '';
                }
                ngModel.$setViewValue(html);
            }
        }
    };
    //return {
    //    restrict: "A",
    //    require: "ngModel",
    //    link: function (scope, element, attrs, ngModel) {
    //        // read is the main handler, invoked here by the blur event
    //        function read() {
    //            // Keep the newline value for substitutin
    //            // when cleaning the <br>
    //            //var newLine = String.fromCharCode(10);
    //            //// Firefox adds a <br> for each new line, we replace it back
    //            //// to a regular '\n'
    //            //var formattedValue = element.html().replace(/<br>/ig, newLine).replace(/\r/ig, '');
    //            var formattedValue = element.html();
    //            // update the model
    //            ngModel.$setViewValue(formattedValue);
    //            // Set the formated (cleaned) value back into
    //            // the element's html.

    //            element.text(formattedValue);
    //        }

    //        ngModel.$render = function () {
    //            element.html(ngModel.$viewValue || "");
    //        };

    //        element.bind("blur", function () {
    //            // update the model when
    //            // we loose focus
    //            scope.$apply(read);
    //        });
    //        element.bind("paste", function (e) {
    //            // This is a tricky one
    //            // when copying values while
    //            // editing, the value might be
    //            // copied with formatting, for example
    //            // <span style="line-height: 20px">copied text</span>
    //            // to overcome this, we replace
    //            // the default behavior and
    //            // insert only the plain text
    //            // that's in the clipboard
    //            e.preventDefault();
    //            document.execCommand('inserttext', false, e.originalEvent.clipboardData.getData('text/plain'));
    //        });
    //    }
    //};
};
app.directive('contenteditable', contenteditable);
myCompile.$inject = ['$compile', '$sce'];
function myCompile($compile, $sce) {
    var directive = {
        restrict: 'A',
        link: postLink
    };
    return directive;

    function postLink(scope, element, attrs) {
        scope.$watch(attrs.myCompile, function (value) {
            element.html(value);
            $compile(element.contents())(scope);
        });
    }
}
app.filter('myCompile', myCompile);
unsafe.$inject = ['$sce'];
function unsafe($sce) {
    return $sce.trustAsHtml;
}
app.filter('unsafe', unsafe);
app.factory('uuid2', [
    function () {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return {

            newuuid: function () {
                // http://www.ietf.org/rfc/rfc4122.txt
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";
                return s.join("");
            },
            newguid: function () {
                return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
            }
        }

    }]);



(function () {

    RFIService.$inject = ['$http', '$rootScope', '$sessionStorage', 'APP_CONSTANTS', '__env'];

    function RFIService($http, $rootScope, $sessionStorage, APP_CONSTANTS, __env) {
        var radiCoAPI = __env._environment.config.radiCoAPI;
        var token = "Bearer " + $sessionStorage.currentUserData.accessToken;
        var header = {
            'Authorization': token,
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }
        function urlBase() {
            return radiCoAPI + ($sessionStorage.currentUserData.TenantName == 'TRAMBMS' ? 'TRA' : $sessionStorage.currentUserData.TenantName) + '/api/RFI';
        }


        var dataFactory = {};

        dataFactory.GetRFIData = function (IsMedicalDirector, ItemsPerPage, CurrentPage, Status, SearchReason, SearchLocation, SearchPatientName, SearchProcedure, SearchReadingProvider, ShowOnlyCoder, SortByName, SortASC) {
            return $http({
                method: 'get',
                params: {
                    IsMedicalDirector: IsMedicalDirector,
                    ItemsPerPage: ItemsPerPage,
                    CurrentPage: CurrentPage,
                    Status: Status,
                    SearchReason: SearchReason,
                    SearchLocation: SearchLocation,
                    SearchPatientName: SearchPatientName,
                    SearchProcedure: SearchProcedure,
                    SearchReadingProvider: SearchReadingProvider,
                    ShowOnlyCoder: ShowOnlyCoder,
                    SortByName: SortByName,
                    SortASC: SortASC
                },
                url: urlBase() + '/GetRFIData',
                headers: header
            });
        };

        dataFactory.GetRFIDataCount = function (IsMedicalDirector, ItemsPerPage, CurrentPage, Status, SearchReason, SearchLocation, SearchPatientName, SearchProcedure, SearchReadingProvider, ShowOnlyCoder) {
            return $http({
                method: 'get',
                params: {
                    IsMedicalDirector: IsMedicalDirector,
                    ItemsPerPage: ItemsPerPage,
                    CurrentPage: CurrentPage,
                    Status: Status,
                    SearchReason: SearchReason,
                    SearchLocation: SearchLocation,
                    SearchPatientName: SearchPatientName,
                    SearchProcedure: SearchProcedure,
                    SearchReadingProvider: SearchReadingProvider,
                    ShowOnlyCoder: ShowOnlyCoder
                },
                url: urlBase() + '/GetRFIDataCount',
                headers: header
            });
        };



        dataFactory.GetDicomImagesByAccession = function (accessionNumber) {
            var data1 = {
                AccessionNumber: accessionNumber
            };
            return $http({
                method: 'post',
                data: data1,
                url: GENERAL_CONFIG.APP_DICOMserviceURL + '/api/Dashboard/GetDicomImagesByAccession',
                headers: header
            });
        }

        dataFactory.GetRFIGroups = function () {
            return $http({
                method: 'get',
                params: {

                },
                url: urlBase() + '/GetRFIGroups',
                headers: header
            });
        }
        dataFactory.GetNPIList = function () {
            return $http({
                method: 'get',
                params: {

                },
                url: urlBase() + '/GetNPIList',
                headers: header
            });
        }
        dataFactory.UpdateExpirationDateTime = function (RFIId, dateTime, IsExpiryDateExtendedByUser) {
            return $http({
                method: 'get',
                params: {
                    RFIId: RFIId,
                    dateTime: dateTime,
                    IsExpiryDateExtendedByUser: IsExpiryDateExtendedByUser
                },
                url: urlBase() + '/GetUpdateExpirationDateTime',
                headers: header
            });
        }

        dataFactory.GetOption = function (Reason) {
            return $http({
                method: 'get',
                params: {
                    reason: Reason
                },
                url: urlBase() + '/GetOption',
                headers: header
            });
        }

        dataFactory.GetOptionsOfReason = function (Reason) {
            return $http({
                method: 'get',
                params: {
                    xiReason: Reason
                },
                url: urlBase() + '/GetOptionsOfReason',
                headers: header
            });
        }
        dataFactory.GetRFIUsers = function () {
            return $http({
                method: 'get',
                url: urlBase() + '/GetRFIUsers',
                headers: header
            });
        };
        dataFactory.GetFacilityNames = function () {
            return $http({
                method: 'get',
                url: urlBase() + '/GetFacilityNames',
                headers: header
            });
        };
        dataFactory.GetReadingLocations = function (userid) {
            return $http({
                method: 'get',
                params: { xiUserId: userid },
                url: urlBase() + '/GetReadingLocation',
                headers: header
            });
        };
        dataFactory.UpdaeReadingLocations = function (data) {
            var data1 = {
                listOfReadingLocations: data,
            }
            return $http({
                method: 'post',
                data: JSON.stringify(data1),
                url: urlBase() + '/UpdaeReadingLocations',
                headers: header
            });
        };
        dataFactory.GetAllReasons = function (data) {

            return $http({
                method: 'get',
                url: urlBase() + '/GetAllReasons',
                headers: header
            });
        };
        dataFactory.updateStatus = function (Id, status, AssignedToNPI) {
            return $http({
                method: 'get',
                params: {

                    Id: Id,
                    status: status,
                    AssignedToNPI: AssignedToNPI
                },
                url: urlBase() + '/GetUpdateStatus',
                headers: header
            });
        };
        dataFactory.UpdateReport = function (RFI_Id, Report, Status, proidernpi) {
            var data = {
                xiRFI_Id: RFI_Id,
                xiReport: Report,
                xiStatus: Status,
                xiProviderNPI: proidernpi,
            };
            return $http({
                method: 'post',
                data: data,
                url: urlBase() + '/UpdateReport',
                headers: header
            });
        };
        dataFactory.AssignRFIToUser = function (selectedUserObject, selectedRFI_Id) {
            var data = {
                RFI_Id: selectedRFI_Id,
                NPI: selectedUserObject.NPI
            }
            return $http({
                method: 'post',
                data: data,
                url: urlBase() + '/AssignRFIToUser',
                headers: header
            });
        }
        dataFactory.submitComment = function (Id, RFI_Id, Comment, RepliedToCommentId) {
            return $http({
                method: 'post',
                data: JSON.stringify({ xiCommentId: Id, xiRFI_Id: RFI_Id, xiComment: Comment, xiRepliedToCommentId: RepliedToCommentId }),
                url: urlBase() + '/submitComment',
                headers: header
            });
        };
        dataFactory.getCommentbyId = function (Id) {
            return $http({
                method: 'get',
                params: { xiRFIId: Id },
                url: urlBase() + '/GetCommentbyId',
                headers: header
            });
        };
        dataFactory.deleteComment = function (commentId) {
            return $http({
                method: 'get',
                params: { xiCommentId: commentId },
                url: urlBase() + '/deleteComment',
                headers: header
            });
        };

        dataFactory.saveOption = function (option) {
            return $http({
                method: 'post',
                data: JSON.stringify({ Option: option }),
                url: urlBase() + '/SaveOption',
                headers: header
            });
        };
        dataFactory.saveReason = function (reason) {
            return $http({
                method: 'post',
                data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/SaveReason',
                headers: header
            });
        };
        dataFactory.saveReasonandOption = function (reason, option) {
            return $http({
                method: 'post',
                data: JSON.stringify({ Reason: reason, Option: option }),
                url: urlBase() + '/SaveReasonandOption',
                headers: header
            });
        };
        dataFactory.saveNewOption = function (reasonId, option) {
            return $http({
                method: 'post',
                data: JSON.stringify({ ReasonId: reasonId, Option: option }),
                url: urlBase() + '/SaveNewOption',
                headers: header
            });
        };
        dataFactory.deleteReason = function (reasonId) {
            return $http({
                method: 'get',
                params: { reasonId: reasonId },
                url: urlBase() + '/DeleteReason',
                headers: header
            });
        };
        dataFactory.deleteOption = function (optionId) {
            return $http({
                method: 'get',
                params: { optionId: optionId },
                url: urlBase() + '/DeleteOption',
                headers: header
            });
        };

        dataFactory.DeleteFile = function (fileKey) {
            return $http({
                method: 'get',
                params: { fileKey: fileKey },
                url: urlBase() + '/DeleteFile',
                headers: header
            });
        };
        dataFactory.getFileData = function (fileKeyxi) {
            return $http({
                method: 'get',
                params: { fileKey: fileKeyxi },
                url: urlBase() + '/GetFileData',
                headers: header
            });
        };
        dataFactory.GetRFIDownloadChatFiles = function (Id) {
            return $http({
                method: 'get',
                params: {
                    Id: Id
                },
                url: urlBase() + '/GetRFIDownloadChatFiles',
                responseType: 'arraybuffer',
                headers: header
            });
        };
        dataFactory.RFIUploadFiles = function (formdata) {
            return $http.post(radiCoAPI + ($sessionStorage.currentUserData.TenantName == 'TRAMBMS' ? 'TRA' : $sessionStorage.currentUserData.TenantName) + '/api/FileUpload' + '/RFIUploadFiles', formdata, {
                //headers: { 'Content-Type': undefined },
                headers: {
                    'Authorization': token,
                    'content-type': undefined,
                    'Access-Control-Allow-Origin': '*'
                },
                transformRequest: angular.identity
            });

        };
        dataFactory.RFIUploadChatFiles = function (formdata) {
            return $http.post(urlBase() + '/RFIUploadChatFiles', formdata, {
                headers: {
                    'Authorization': token,
                    'content-type': undefined,
                    'Access-Control-Allow-Origin': '*'
                },
                //headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            });

        };

        dataFactory.getRFIRulesList = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetRFIRulesList',
                headers: header
            });
        };

        dataFactory.getRFIRules = function (rFIRuleId) {
            return $http({
                method: 'get',
                params: { RFIRuleId: rFIRuleId },
                url: urlBase() + '/GetRFIRules',
                headers: header
            });
        };
        dataFactory.getRFIRuleDetails = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetRFIRuleDetails',
                headers: header
            });
        };

        dataFactory.GetAllReasonsRFIUnique = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetAllReasonsRFIUnique',
                headers: header
            });
        };
        dataFactory.GetDoctorsInfo = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetDoctorsInfo',
                headers: header
            });
        };

        dataFactory.GetOnlyFacilities = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetOnlyFacilities',
                headers: header
            });
        };

        dataFactory.GetOnlyDoctors = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetOnlyDoctors',
                headers: header
            });
        };


        dataFactory.getFacilityDoctors = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetFacilityDoctors',
                headers: header
            });
        };

        dataFactory.GetAllReasonsRFI = function (data) {

            return $http({
                method: 'get',
                url: urlBase() + '/GetAllReasonsRFI',
                headers: header
            });
        };

        dataFactory.SaveRFIRuleDetails = function (RFIRulesVM) {
            return $http({
                method: 'post',
                data: JSON.stringify({ RFIRulesVM: RFIRulesVM }),
                url: urlBase() + '/SaveRFIRuleDetails',
                headers: header
            });
        };

        dataFactory.deleteRule = function (RuleId) {
            return $http({
                method: 'get',
                params: { RuleId: RuleId },
                url: urlBase() + '/GetdeleteRule',
                headers: header
            });
        };

        dataFactory.InsertRFIRuleDetails = function (RFIRulesVM) {
            return $http({
                method: 'post',
                data: JSON.stringify({ RFIRulesVM: RFIRulesVM }),
                url: urlBase() + '/InsertRFIRuleDetails',
                headers: header
            });
        };

        dataFactory.SaveFacilityDoctors = function (nPIProvidersLocation) {
            return $http({
                method: 'post',
                data: JSON.stringify({ NPIProvidersLocation: nPIProvidersLocation }),
                url: urlBase() + '/SaveFacilityDoctors',
                headers: header
            });
        };


        dataFactory.getCheckCoder = function () {
            return $http({
                method: 'get',
                url: urlBase() + '/getCheckCoder',
                headers: header

            });
        };


        dataFactory.GetCheckMedicalDirector = function () {
            return $http({
                method: 'get',
                url: urlBase() + '/getCheckMedicalDirector',
                headers: header

            });
        };


        dataFactory.GetSaveApplyRFIRule = function (RFIRuleId, ApplyExisting, ApplyUpcoming) {
            return $http({
                method: 'get',
                params: { RFIRuleId: RFIRuleId, ApplyExisting: ApplyExisting, ApplyUpcoming: ApplyUpcoming },
                url: urlBase() + '/GetSaveApplyRFIRule',
                headers: header

            });
        };

        dataFactory.GetAffectedRFICountbyRule = function (RFIRuleId) {
            return $http({
                method: 'get',
                params: { RFIRuleId: RFIRuleId },
                url: urlBase() + '/GetAffectedRFICountbyRule',
                headers: header

            });
        };

        dataFactory.GetFacilityDoctorsRFI = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetFacilityDoctorsRFI',
                headers: header

            });
        };
        dataFactory.getRFILogic = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetRFILogic',
                headers: header
            });
        };

        dataFactory.getRFIHeaders = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/GetRFIHeaders',
                headers: header
            });
        };

        dataFactory.updateIsReadCommentStatus = function (RFIId) {
            return $http({
                method: 'post',
                data: JSON.stringify({ xiRFIId: RFIId }),
                url: urlBase() + '/UpdateIsReadCommentStatus',
                headers: header
            });
        };
        dataFactory.getReadingProviderInfo = function () {
            return $http({
                method: 'get',
                //data: JSON.stringify({ Reason: reason }),
                url: urlBase() + '/getReadingProviderInfo',
                headers: header
            });
        };

        return dataFactory;
    }

    app.factory('RFIService', RFIService);
})();
(function () {
    'use strict';

    angular.module('radico.pages.iewarning')
        .controller('iewarningController', iewarningController);

    function iewarningController($scope, $sessionStorage) {
        $scope.browser = $sessionStorage.browser;
    }

    
})();


angular.module('radico.pages.iewarning')
    .service('iewarningService', ['Restangular', '$http', 'APP_CONSTANTS', function (Restangular, $http, APP_CONSTANTS) {        

    }]);
(function () {
    'use strict';

    angular
        .module('radico.pages.newsletter', [])
        .controller('NewsletterModalController', NewsletterModalController);

    NewsletterModalController.$inject = ['$uibModalInstance', 'newsletterData', '$sce'];

    // Task 174662: shows the RadPod Newsletter PDF (published from CIVIR) in an iframe.
    // newsletterData = { info: WeeklyDocumentInfo, url: blob object URL, blob: raw Blob, lastSeen: existing preference row or undefined }
    function NewsletterModalController($uibModalInstance, newsletterData, $sce) {
        var vm = this;
        var data = newsletterData || {};

        vm.title = (data.info && data.info.Title) || 'RadPod Newsletter';
        // #toolbar=0 is a PDF open parameter Chrome's viewer honors: it hides the viewer's own
        // toolbar, whose download/save icon names the file by the blob URL's GUID (a blob: URL has
        // no Content-Disposition). Fragments are ignored when the blob is resolved, and the URL is
        // still revoked by its fragment-less data.url in indexController.
        vm.pdfUrl = data.url ? $sce.trustAsResourceUrl(data.url + '#toolbar=0') : null;
        vm.fileName = (data.info && data.info.FileName) || 'RadPod-Newsletter.pdf';

        // A blob: URL carries no Content-Disposition. Reusing data.url (already shown in the
        // iframe, so Chrome treats it as "claimed" by the PDF viewer) for a download link still
        // falls back to the blob's random object-URL id as the file name -- a fresh object URL,
        // created only for this click and never displayed, is what reliably keeps the name.
        vm.download = function () {
            if (!data.blob) {
                return;
            }
            var downloadUrl = URL.createObjectURL(data.blob);
            var link = document.createElement('a');
            link.href = downloadUrl;
            link.download = vm.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Some browsers read the blob asynchronously after the click; revoking immediately
            // can cancel the download before it starts.
            setTimeout(function () {
                URL.revokeObjectURL(downloadUrl);
            }, 1000);
        };

        // 'close' is the only dismiss reason that records the acknowledgement (see indexController).
        vm.close = function () {
            $uibModalInstance.dismiss('close');
        };
    }
})();

(function () {
    'use strict';

    angular.module('radico.pages.payment-dashboard')
        .controller('PaymentDashboardController', PaymentDashboardController).filter('titleCase', function () {
            return function (input) {
                input = input || '';
                return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            };
        });

    /** @ngInject **/
    function PaymentDashboardController($scope, CommonService, toaster, PaymentDashboardService) {
        //local variables
        var gridDiv;
        var PageSize = 50;
        var PaymentSummaryList = [];
        var PaymentSchedule = 0;
        var rowPaymentScheduleData = [];
        //global variables
        $scope.ActiveTab = 'Dashboard';
        $scope.CheckoutOptions = [];
        $scope.PaymentScheduleType = { Obj: null };
        $scope.PaymentScheduleOption = { Obj: null };
        $scope.dospopup = {
            opened: false
        };
        $scope.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            minDate: new Date(),
        };
        $scope.dateSearchOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
        };
        $scope.PaymentBalance = 100;
        $scope.PaymentSummery = { TotalPrice: 0 };

        function PageInit() {
            CommonService.startNotifyTATStudy();
            $scope.onTabChange($scope.ActiveTab);
        }

        $scope.onTabChange = function (tab) {
            switch (tab) {
                case 'Payment Schedule':
                    $scope.columnPaymentScheduleDefs = [{ field: "PaymentSchedule" }, { field: "PaymentScheduleType" }, { field: "Percentage" }, { field: "Price" }, { field: "DueDate" }];
                    $scope.rowPaymentScheduleData = [];
                    $scope.PaymentScheduleTypes = ['Percentage', 'Price'];
                    $scope.PaymentScheduleOptions = ['Daily', 'Weekly', 'Every 15 Days', 'Monthly', 'Quaterly'];
                    $scope.PaymentScheduleOption.Obj = 'Daily';
                    break;
                case 'Invoice':
                case 'Dashboard':
                    $scope.columnDefs = [
                        { field: "PaymentInvoice" },
                        { field: "Amount" },
                        { field: "Date", sort: 'desc' },
                        { field: "Status" },
                    ];
                    $scope.rowData = [{ PaymentInvoice: '#01', Amount: '$10', Date: new Date(), Status: 'Completed' },
                    { PaymentInvoice: '#02', Amount: '$10', Date: new Date(), Status: 'Active' },
                    { PaymentInvoice: '#03', Amount: '$10', Date: new Date('08/15/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#04', Amount: '$10', Date: new Date('10/02/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#05', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#06', Amount: '$10', Date: new Date('10/07/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#07', Amount: '$10', Date: new Date('10/02/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#08', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#09', Amount: '$10', Date: new Date('10/05/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#10', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#11', Amount: '$10', Date: new Date('10/02/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#12', Amount: '$10', Date: new Date('10/05/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#13', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#14', Amount: '$10', Date: new Date('08/15/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#15', Amount: '$10', Date: new Date('10/09/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#16', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#17', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#18', Amount: '$10', Date: new Date('08/15/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#19', Amount: '$10', Date: new Date('09/20/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#20', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#21', Amount: '$10', Date: new Date('09/20/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#22', Amount: '$10', Date: new Date('09/20/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#23', Amount: '$10', Date: new Date('09/20/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#24', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#25', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#26', Amount: '$10', Date: new Date('08/15/2023 00:00:00'), Status: 'Rejected' },
                    { PaymentInvoice: '#27', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    { PaymentInvoice: '#28', Amount: '$10', Date: new Date(), Status: 'Rejected' },
                    ];
                    break;
                case 'Account':
                    $scope.CheckoutOptions = ['Daily', 'Weekly', 'Every 15 Days', 'Monthly', 'Quaterly'];
                    $scope.PaymentScheduleOption = 'Daily';
                    break;
            }
        }




        $scope.EditPersonalDetails = function () {
            alert('Personal Details from function');
        }

        $scope.EditBankAccountDetails = function () {
            alert('Bank Account Details from function');
        }

        $scope.EditCheckoutDetails = function () {
            alert('Checkout Details from function');
        }


        $scope.AddEditPaymentSchedule = function (type) {
            if (type == 'Add') {
                $('#ModalAddEditPaymentSchedule').modal('show');
                $scope.PaymentScheduleType.Obj = 'Percentage';
            }
        }

        $scope.SavePaymentSchedule = function () {
            if ($scope.CheckBalance()) {
                var paymentSchedule = [];
                paymentSchedule.PaymentSchedule = PaymentSchedule++;
                paymentSchedule.PaymentScheduleType = $scope.PaymentScheduleType.Obj;
                if ($scope.PercentageValue) { paymentSchedule.Percentage = $scope.PercentageValue; paymentSchedule.Price = '-'; }
                else { paymentSchedule.Price = $scope.Price; paymentSchedule.Percentage = '-'; }
                paymentSchedule.DueDate = moment($scope.DueDate).format('MM/DD/YYYY');
                rowPaymentScheduleData.push(paymentSchedule);
                $scope.rowPaymentScheduleData = rowPaymentScheduleData;
                clearPaymentScheduleData()
                $('#ModalAddEditPaymentSchedule').modal('hide');
            }
        }

        $scope.clearPaymentScheduleData = function () {
            $scope.PaymentScheduleType = { Obj: null };
            $scope.PercentageValue = null;
            $scope.Price = null;
            $scope.DueDate = null;
            $scope.PaymentBalance = 100;
        }

        $scope.ChangePaymentScheduleOption = function (option) {
            switch ($scope.PaymentScheduleOption.Obj) {
                case 'Daily':
                    $scope.DueDate = new Date();
                    break;
                case 'Weekly':
                    $scope.DueDate = (new Date).setDate((new Date()).getDate() + 7);
                    break;
                case 'Every 15 Days':
                    $scope.DueDate = (new Date).setDate((new Date()).getDate() + 15);
                    break;
                case 'Monthly':
                    $scope.DueDate = (new Date).setDate((new Date()).getDate() + 30);
                    break;
                case 'Quaterly':
                    $scope.DueDate = (new Date).setDate((new Date()).getDate() + 30 * 3);
                    break;
            }
        }
        $scope.CheckBalance = function () {
            if ($scope.Price) {
                var bal = $scope.PaymentBalance - parseInt($scope.Price);
                //$scope.PaymentBalance = bal;
                if (bal > $scope.PaymentBalance) return true;
                else return false;
            }
            else if ($scope.PercentageValue) {
                var amt = ($scope.PaymentBalance * parseInt($scope.PercentageValue)) / 100  ;
                var bal = $scope.PaymentBalance - (amt);
                //$scope.PaymentBalance = bal;
                if (bal > $scope.PaymentBalance) return true;
                else return false;
            }
            else {
                return true;
            }
        }

        $scope.onGetPaymentSummary = function () {
        }
        PageInit();

        $scope.$on('$destroy', function () {
            CommonService.stopNotifyTATStudy();
        });
    }

})();
angular.module('radico.pages.payment-dashboard')
    .service('PaymentDashboardService', ['Restangular', '$http', 'APP_CONSTANTS', function (Restangular, $http, APP_CONSTANTS) {

    }]);
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.paymentinvoice')
        .controller('PaymentInvoiceController', PaymentInvoiceController);

    /** @ngInject **/
    function PaymentInvoiceController($scope, CommonService, toaster, $q, SharedService) {

        var vm = this;
        $scope.PaymentInvoiceFlag = false;

        function InitPage() {
            $scope.PaymentInvoiceFlag = true;
            CommonService.startNotifyTATStudy();
        }

        InitPage();
        $scope.$on('$destroy', function () {
            CommonService.stopNotifyTATStudy();
        });

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }

    }

})();

angular.module('radico.pages.paymentinvoice')
    .service('PaymentInvoiceService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS, __env) {

    }]);
(function () {
    'use strict';

    angular.module('radico.pages.paymentinvoice-history')
        .controller('PaymentInvoiceHistoryController', PaymentInvoiceHistoryController);
    function PaymentInvoiceHistoryController($scope, PaymentContractService, SharedService) {

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }

    }
})();


angular.module('radico.pages.techno')
    .service('TechnoService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS, __env) {
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }
        this.GetAllSites = function () {
            return Restangular.one('psorders').one("GetAllSites").get();
        };
        this.GetOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetOrdersList").customPOST(orderListFilter);
        };
        this.GetDICOMOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetDICOMOrdersList").customPOST(orderListFilter);
        };
        //this.GetSitesAndLocations = function () {
        //    return Restangular.one('psorders').one("GetSitesAndLocations").get();
        //};
        this.GetSitesAndLocationsByUserID = function (userID) {
            return Restangular.one('psorders').one("GetSitesAndLocationsByUserID", userID).get();
        };
        this.GetPatientClass = function () {
            return Restangular.one('psorders').one("GetPatientClass").get();
        };
        this.CheckPSUserBySite = function (psuser) {
            return Restangular.one('psorders').one("CheckPSUserBySite").customPOST(psuser);
        };
        this.InsertPSUsersBySIte = function (psuser) {
            return Restangular.one('psorders').one("InsertPSUsersBySIte").customPOST(psuser);
        };
        this.SaveReport = function (reportView) {
            return Restangular.one('psorders').one("SaveReport").customPOST(reportView);
        };
        this.InsertOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("InsertOpenOrder").customPOST(openOrders);
        };
        this.DeleteOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("DeleteOpenOrder").customPOST(openOrders);
        };
        this.GetOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("GetOpenOrder").customPOST(openOrders);
        };
        this.RemoveFromComparison = function (comparisonOrder) {
            return Restangular.one('psorders').one("RemoveFromComparison").customPOST(comparisonOrder);
        };
        this.ShowHideOrder = function (orders) {
            return Restangular.one('psorders').one("ShowHideOrder").customPOST(orders);
        };
        this.GetCurrentDateTime = function () {
            return Restangular.one('psorders').one("GetCurrentDateTime").get();
        };
        this.SetDiscussion = function (data) {
            return Restangular.one('psorders').one("SetDiscussion").customPOST(data);
        };
        this.GetDiscussions = function (data) {
            return Restangular.one('psorders').one("GetDiscussions").customPOST(data);
        };
        this.GetDiscussionsByIds = function (data) {
            return Restangular.one('psorders').one("GetDiscussionsByIds").customPOST(data);
        };
        this.SetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("SetOrderDiscussion").customPOST(data);
        };
        this.UpdateDicomOrderSTAT = function (data) {
            return Restangular.one('psorders').one("UpdateDicomOrderSTAT").customPOST(data);
        };
        this.ResendReport = function (data) {
            return Restangular.one('psorders').one("ResendReport").customPOST(data);
        };
        this.GetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("GetOrderDiscussion").customPOST(data);
        };
        this.NotifyToUser = function (data) {
            return Restangular.one('psorders').one("NotifyToUser").customPOST(data);
        };
        this.GetAllUsers = function () {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/RadFlowGetUsers ',
                headers: { 'content-type': 'application/json' }
            });
        };
        this.SaveGridSetting = function (param) {
            return Restangular.one('psorders').one("SaveGridSetting").customPOST(param);
        };
        this.GetGridSetting = function (param) {
            return Restangular.one('psorders').one("GetGridSetting").customPOST(param);
        };
        this.GetModality = function () {
            return Restangular.one('psorders').one("GetModality").customPOST();
        };

        this.GetDicomFileByAccession = function (accession) {
            return Restangular.one('psorders').one("GetDicomFileByAccession", accession).get();
        };
        this.GetDicomFileByURI = function (FileRUI) {
            return Restangular.one('psorders').one("GetDicomFileByURI", FileRUI).get();
        };
        this.SavePatientInfo = function (order) {
            return Restangular.one('psorders').one("SavePatientInfo").customPOST(order);
        };
        this.SavePatientContactInfo = function (order) {
            return Restangular.one('psorders').one("SavePatientContactInfo").customPOST(order);
        };
        this.uploadFile = function (formData) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri + "psorders/uploadFile", formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            });
        };
        this.getFileList = function (DicomOrderId) {
            return Restangular.one('psorders').one("getFileList", DicomOrderId).get();
        };
        this.showFile = function (formData) {
            return Restangular.one('psorders').one("ShowFile").customPOST(formData);
        };
        //this.deleteFile = function (Id, DiacomOrderId) {
        //    return Restangular.one('psorders').one("DeleteFile", Id).customGET(DiacomOrderId);
        //};
        this.deleteFile = function (formData) {
            return Restangular.one('psorders').one("DeleteFile").customPOST(formData);
        };
        this.getImagePendingCount = function (userId) {
            return Restangular.one('psorders').one("getImagePendingCount", userId).get();
        };
        this.getOrderDetail = function (order) {
            return Restangular.one('psorders').one("GetOrderDetail").customPOST(order);
        };
        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };
        this.GetTechniqueByLocationID = function (locationId) {
            return Restangular.one('psorders').one("GetTechniqueByLocationID", locationId).get();
        };
        this.SubmitTechnique = function (formData) {
            return Restangular.one('psorders').one("AddTechnique").customPOST(formData);
        };
        this.SetOrderDiscussionAssignment = function (data) {
            return Restangular.one('psorders').one("SetOrderDiscussionAssignment").customPOST(data);
        };
        this.GetOrderDiscussionAssignment = function (data) {
            return Restangular.one('psorders').one("GetOrderDiscussionAssignment").customPOST(data);
        };
        this.SetPatientDiscussionORM = function (data) {
            return Restangular.one('psorders').one("SetPatientDiscussionORM").customPOST(data);
        };
        this.GetPatientORMDiscussion = function (data) {
            return Restangular.one('psorders').one("GetPatientORMDiscussion").customPOST(data);
        };
        this.GetDicomOrderByID = function (DicomOrderID) {
            return Restangular.one('psorders').one("GetDicomOrderByID", DicomOrderID).get();
        };
        this.SendInvite = function (obj) {
            return Restangular.one('psorders').one("SendInvite").customPOST(obj);
        };
        this.GetOrdersTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "GetOrdersTechForm").customPOST(data);
        };
        this.SetOrdersTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "SetOrdersTechForm").customPOST(data);
        };
        this.GetTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "GetTechForm").customPOST(data);
        };
        this.SetTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "SetTechForm").customPOST(data);
        };
        this.UpdateAddendumRequestReportStatus = function (params) {
            return Restangular.one('psorders').one("UpdateAddendumRequestReportStatus").customPOST(params);
        };
        this.UpdateStrokeSTAT = function (params) {
            return Restangular.one('psorders').one("UpdateStrokeSTAT").customPOST(params);
        };
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.physician-worklist')
        .controller('PhysicianWorklistController', PhysicianWorklistController);
    function PhysicianWorklistController($scope, PhysicianWorklistService, WorklistService, $state, $sessionStorage, UserPreferenceService, APP_CONSTANTS, AppHubService, $timeout, $filter, $q, NgTableParams, $interval, windowHandler, uiGridConstants, $sce, $log, toaster, UserLayoutPrefService, __env, ReviewOrderService, ManageLocationService, CommonService, $stateParams, $rootScope, SharedService, MappingService, RuleSharedService) {    //Bug 21548: Unable to see the selected Modalities on tooltip of worklist & tech worklist page
        //getPatientsList
        var ReportList = [];
        var AppHub;
        var DicomOrderList = [];
        var LastOpenOrder = null;
        var specialityAssignments = [];
        var showUserGuidePhysician = undefined;
        var ColumnsToHide = [];
        var phyGrid = null;
        var statusBarComponent = null;
        var tippyJsinstance = [];
        var worklistSavedState = [];
        var defaultSortingString = "O.OrderDate desc";
        var sortingString = defaultSortingString;

        var sortingApplied = false;

        var PageSize = "50";
        var PageNo = 1;
        var TotalRows = "";
        var UserLayoutOption = {};
        var orderListFilter = {};
        var ShowReleaseGuide = undefined;
        var halfScale = $(window).width() < 1199;
        $scope.IsAddendumRequestVisible = $sessionStorage.IsAddendumRequestVisible;
        $scope.Status = "RP";
        $scope.orderByField = "DOS";
        $scope.reverseSort = true;
        $scope.SelectedList = {};
        $scope.SingReport = {};
        $scope.SingReport.Index = 0;
        $scope.LastOpenedOrderID;
        $scope.ChooseNextStudy = false;
        $scope.showAttachment = false;
        $scope.modalitytooltip = 'Select Modalities';
        $scope.isfilterCollapse = false;
        $scope.hstep = 1;
        $scope.mstep = 5;
        //$scope.technoMenuExists = false;       
        $scope.AddendumRequest = {
            AssignedUser: null,
            isHighPriorityAddendum: false,
            AddendumComment: null,
            AssignedUserTooltip: "Select Radiologist"
        }
        $scope.PeerReview = {
            AssignedUser: null,
            Comment: null,
            AssignedUserTooltip: "Select Radiologist"
        }
        //$scope.winPatientInfoPhyWidth = "65%";
        if ($(window).width() < 1199) {
            $scope.winPatientInfoPhyWidth = "96%";
        } else {
            $scope.winPatientInfoPhyWidth = "80%";
        }
        //$scope.winViewReportPhyWidth = "70%";
        if ($(window).width() < 1199) {
            $scope.winPeerReviewWidth = "96%";
        } else {
            $scope.winPeerReviewWidth = "70%";
        }
        $scope.win_HelpOrderWidth = "90%";
        $scope.win_DCMViewerWidth = "80%";
        $scope.win_ViewTechniqueWidth = "850";
        $scope.win_ViewTechniqueHeight = "600";
        //$scope.isCollapsed = true;
        //$scope.RefreshTimmer = "00:00";

        $scope.CloseFrom = ""; //"RADFLOW" , "PS360"
        //$sessionStorage.PSEvent = false;
        $scope.addTechnique = false;
        $scope.halfScale = false;
        $scope.toolTipOrderDate = 'DOS';
        $scope.currentDate = new Date();
        var refreshDOSMidnight = null;
        $scope.Radiologists = [];
        var siteRadiologistsUnfiltered = [];
        $scope.IsPatientAgeShow = true;

        //$scope.defaultWindowHeight = "72.60%";
        $scope.defaultWindowHeight = "85%";
        $scope.IsLocationShow = false;
        $scope.IsDOSShow = false;
        $scope.IsPatientNameShow = false;
        $scope.IsPatientAgeShow = false;
        $scope.IsTypeNameShow = false;
        $scope.IsModalityShow = false;
        $scope.IsProcedureShow = false;
        $scope.IsOrderingPhysicianShow = false;
        $scope.IsAccessionShow = false;
        $scope.IsMRNShow = false;
        $scope.IsSTATShow = false;
        $scope.IsImageInstanceShow = false;
        var columnVersion = 9.4;
        var previouslySelectedFilter = {};
        $scope.uiGridState = {};
        var refreshDOSInterval = 1000;
        $scope.SendInvite = false;

        if ($(window).width() < 1199) {
            $scope.halfScale = true;
        }

        var parser = new UAParser();
        $scope.browser = parser.getBrowser().name;

        $scope.dateDOSOptions = {
            enableTime: 'true'
        };
        $scope.HiddenType = { obj: null };
        //Custom date range settings
        $scope.OrderDate = {
            //startDate: moment().subtract(1, "days"),
            //endDate: moment()
            startDate: moment().subtract(6, 'days'),
            endDate: moment()
        };

        $scope.SelectedLocations = {
            Ids: '',
            locations: [],
            divId: "PhysicianWorklistPage"
        };

        $scope.opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            //cancelButtonClasses: 'dr-btn-none',
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.OrderDate = {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                }

            },
            ranges: {
                'Today': [moment(), moment()],
                //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                //'Last 15 Days': [moment().subtract(14, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                //'This Month': [moment().startOf('month'), moment().endOf('month')],
                //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                'Last Year': [moment().subtract(1, 'year'), moment()],
                //'All DOS': [],

            }

        };

        $scope.htmlPopover = $sce.trustAsHtml('<div class="single4 v-a-m"></div>');
        $scope.popoverOpened1 = false;
        $scope.popoverDicomOrderID = '';

        var currentHeight = 0;
        var previousHeight = 0;

        $scope.AutoRefresh = false;
        $scope.SaveDiscussionFlag = false;

        $scope.PatientDOB = {};
        var openWindows = [];
        $scope.DataObject = {
            IsStudyRatingWindowVisible: false,
            StudyReReadReason: null,
            AddendumRequestedReasonList: [],
            StudyRating: {},
            onQueryRetrive: false,
            isLoadingQueryRetrieve: false,
            defaultWindowWidth: halfScale ? "96%" : "70%",
            QueryRetriveObj: {},
            QueryRetrieve: {
                Accession: '',
                PatientMRN: '',
                FirstName: '',
                LastName: '',
                toolTipOrderDate: 'DOS',
                OrderDateType: 'Last 3 Years',
                OrderDate: {
                    startDate: moment().subtract(3, 'year'),
                    endDate: moment()
                },
                IsRetrieveBtnDisabled: true,
                IsExpanded: false,
                IsAllStudySelected: false,
                IsSearchingData: false,
            },
            ModalityDropdownDataFilter: {
                divId: "PhysicianWorklistModalityFilter",
                keys: ['Code'],
                uniqKey: 'Code',
                placeHolder: "Select Modalities",
                SelectedValue: { list: [] },
            },
            ReportListFilter: { DateRange: 'Any', Modality: 'All' },
            ReportList: WorklistService.GetReportListModalityNDateRange(),
            ShowReportModal: false,
            ReportSortingPropName: 'OrderDate',
            ReportSortingRevOrder: true,
            SearchText: '',
            ReportSortingOptions: ['DOS (newest first)', 'DOS (oldest first)', 'Rendering Physician (A to Z)', 'Rendering Physician (Z to A)', 'Procedure (A to Z)', 'Procedure (Z to A)'],
            SelectedSortingOption: 'DOS (newest first)',
            winComparisonOrderReportsWidth: $scope.halfScale ? "96%" : "70%",
            ActionMenu: {
                ActionTaken: "",
                WorklistName: "Physician",
                MenuItems: [{
                    name: 'Consult with Physician',
                }, {
                    name: 'Open Discussion (F11)',
                }],
            },
            DiscussionWindowTabList: [
                {
                    TabName: 'Discussion',
                },
                {
                    TabName: 'Attachment',
                }
            ],
            DiscussionWindowActiveTab: 'Discussion',
            ShowDiscussionTab: false,
            Reference: {},
            RemoveRenderingPhysicianReport: $sessionStorage.currentUserData.RemoveRenderingPhysician,
            EnableRowsForSelectedTenants: $sessionStorage.EnableRowsForSelectedTenants.split(','),
            OrderingPhysician: {
                SelectedData: null,
            },
            MasterData: {
            },
        };
        $scope.DataObject.QueryRetrieve.opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",

                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.DataObject.QueryRetrieve.OrderDate = {
                    startDate: moment().subtract(5, 'year'),
                    endDate: moment()
                }
            },
            ranges: {
                'Last 6 Months': [moment().subtract(6, 'month'), moment()],
                'Last 1 Year': [moment().subtract(1, 'year'), moment()],
                'Last 3 Years': [moment().subtract(3, 'year'), moment()],
                'Last 5 Years': [moment().subtract(5, 'year'), moment()],
                'Last 10 Years': [moment().subtract(10, 'year'), moment()],
            }
        };

        var positionChanged = false;
        $scope.ImagePendingStatus = '';
        var OrderRefreshInterval = null;
        var OrderRefreshDuration = __env.TechWorklistRefreshDuration;
        var DefaultAutoRefreshDuration = __env.DefaultAutoRefreshDuration;
        $scope.LoggedInUserID = $sessionStorage.currentUserData.userId;
        $scope.ShowLockStudy = true;
        $scope.locationIDs = '';
        $scope.modalityIDs = '';
        $scope.locations = '';
        $scope.modalities = '';
        var OrderAutoRefresh = true;
        var PeerReviewToasterMessage = "Added to peer review successfully!";
        var TourFlag = $stateParams.TourFlag;
        var ProvidersFullList = [];
        kendo.ui.Window.fn._keydown = function (originalFn) {
            var KEY_ESC = 27;
            return function (e) {
                if (e.which !== KEY_ESC) {
                    originalFn.call(this, e);
                }
            };
        }(kendo.ui.Window.fn._keydown);

        $scope.resetDateRange = function () {
            $scope.opts.ranges = {
                'Today': [moment(), moment()],
                //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                //'Last 15 Days': [moment().subtract(14, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                //'This Month': [moment().startOf('month'), moment().endOf('month')],
                //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                'Last Year': [moment().subtract(1, 'year'), moment()],
                //'All DOS': [],
            };
            angular.element(document).ready(function () {
                angular.element('.drp-buttons .cancelBtn').click(function () {
                    angular.element('#daterange3').val('');
                    $scope.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                });
            });
            $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            if ($scope.OrderDate.startDate && $scope.OrderDate.endDate) {
                if ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom'))
                    $scope.OrderDateType = ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                        moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType;

            }
            else
                $scope.OrderDateType = 'Clear';
            setOrderDate($scope.OrderDateType);

        }
        angular.element(document).ready(function () {
            angular.element('.drp-buttons .cancelBtn').click(function () {
                angular.element('#daterange3').val('');
                $scope.OrderDate = {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                };
            });

        });
        angular.element(document).ready(function () {
            angular.element('.ranges ul li[data-range-key="Today"]').removeClass('active');
            angular.element('.ranges ul li[data-range-key="Last 7 Days"]').addClass('active');
            //angular.element('.ranges ul li[data-range-key="Last 3 Days"]').click();
            //angular.element('#daterange3').val(moment().subtract(2, 'days') + ' - ' + moment());
            $scope.OrderDate = {
                startDate: moment().subtract(6, 'days'),
                endDate: moment()
            };
            $scope.OrderDateType = 'Last 7 Days';
            $scope.toolTipOrderDate = 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY');
            //for mobile devices
            if (angular.element(window).width() < 768) {
                //angular.element('.techno-dscsn').addClass('tecnho-dscsn-wrpr');
                $scope.isfilterCollapse = true;
                angular.element("#collapseWorklist").removeClass("in");
                angular.element('.discsn-popup').parent().addClass('wrapper-search-contact');
            }
        });
        $scope.setTooltip = function (val, defaultval) {
            if (val) {
                return val.replace(/,/g, '\n');
            }
            else {
                return defaultval;
            }
        }
        $scope.formatted_date = function (date) {
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' === (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };

        function setOrderDate(val) {
            var type = null, startDate = null, endDate = null;
            //alert('setOrderDate' + val);
            if (val && val.match('Custom')) {
                type = 'Custom';
                startDate = val.split('#')[1];
                endDate = val.split('#')[2];
            }
            else {
                type = val;
            }
            $scope.OrderDateType = type;
            switch (type) {
                case 'Today':
                    $scope.OrderDate = {
                        startDate: moment(moment().format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                //case 'Yesterday':
                //    $scope.OrderDate = {
                //        startDate: moment().subtract(1, 'days'),
                //        endDate: moment().subtract(1, 'days')
                //    };
                //    break;
                case 'Last 3 Days':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(2, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 7 Days':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                //case 'Last 15 Days':
                //    $scope.OrderDate = {
                //        startDate: moment().subtract(14, 'days'),
                //        endDate: moment()
                //    };
                //    break;
                case 'Last 30 Days':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(29, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Custom':
                    $scope.OrderDate = {
                        startDate: moment(moment(startDate).format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment(endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    $scope.OrderDateType = 'Custom range';
                    break;
                case 'Last Year':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(1, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'All DOS':
                    $scope.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                case 'Clear':
                    $scope.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                default:
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    $scope.OrderDateType = 'Last 7 Days';
                    break;
            }
            var timeout = $timeout(function () {
                $scope.toolTipOrderDate = $scope.OrderDate.startDate && $scope.OrderDate.endDate ? 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                $timeout.cancel(timeout);
                timeout = null;
            }, 0)
        }

        $scope.clearFilterAndRefesh = function () {
            //$log.log("clearFilterAndRefesh: " + new Date());
            $scope.clearFilter();
            //$scope.getData();
            //$timeout(function () { $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'height:76vh !important; transition: height 1s;'); }, 1);
            var dollarTimeout = $timeout(function () {
                $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;');
                $timeout.cancel(dollarTimeout);
                dollarTimeout = null;
            }, 1);
            $(".anui").removeClass("set-modality-height");
            $(".anui").removeClass("set-location-height");
            $scope.FilterDICOMOrders();
        };

        $scope.closePatientInfo = function () {
            //$log.log("closePatientInfo");
            $scope.files = [];
            angular.element("input[type='file']").val(null);
            $scope.win_PatientInfo.center().close();
        };
        $scope.clearFilter = function () {
            //$log.log("clearFilter; " + new Date());
            PageNo = 1;
            updatePageSize();
            $scope.Status = "RP";
            $scope.SelectedList.Site = null;
            $scope.SelectedList.Location = null;
            $scope.modalitytooltip = 'Select Modalities';
            $scope.Accession = "";
            $scope.OrderDate = {
                startDate: moment().subtract(6, 'days'),
                endDate: moment()
            };
            $scope.OrderDateType = 'Last 7 Days';
            $scope.toolTipOrderDate = 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY');
            $scope.SelectedList.Modality = [];
            $scope.DataObject.ModalityDropdownDataFilter.SelectedValue = {
                list: [],
            };
            $scope.PatientName = "";
            $scope.PatientMRN = "";
            $scope.DOB = "";
            $scope.SelectedList.PatientClass = null;
            $scope.OrderingPhysician = "";
            //$scope.refresh();
            $scope.locationIDs = '';
            $scope.modalityIDs = '';
            $scope.locations = '';
            $scope.modalities = '';
            $scope.SelectedLocations = {
                Ids: '',
                locations: [],
                divId: "PhysicianWorklistPage"
            };
        };

        function GetSitesAndLocationsByUserID() {
            //$log.log("GetSitesAndLocationsByUserID: " + new Date());
            var d = $q.defer();
            PhysicianWorklistService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                //$log.log("GetSitesAndLocationsByUserID response: " + new Date());
                $scope.Locations = result;
                $scope.DataObject.MasterData.Sites = _.uniqBy(_.filter(result, function (obj) { return obj.SiteID != 0; }), 'SiteID');
                $scope.DataObject.MasterData.Sites = _.map($scope.DataObject.MasterData.Sites, function (item) {
                    return _.assign(item, {
                        SiteTenant: item.Site + " (" + item.TenantName + ")"
                    });
                });

                d.resolve();
            });
            return d.promise;
        };


        function openContextMenuOptions(params) {
            var contextMenus = [];
            if (params && params.node && params.node.data) {
                params.node.setSelected(true);
                var Order = params.node.data;
                $scope.setSelected(Order.OrderID, Order);

                contextMenus.push({
                    name: 'Consult with Physician',
                    action: function () {
                        $scope.CallInConsult(Order);
                    }
                });

                switch (Order.Status) {
                    case 'C':
                        if ($sessionStorage.IsAddendumRequestVisible) {
                            contextMenus.push('separator');
                            contextMenus.push(
                                {
                                    name: 'Addendum Request',
                                    action: function () {
                                        $scope.SelectedOrder = Order;
                                        $scope.GetAllUsers($scope.SelectedOrder.SiteID).then(function () {
                                            $scope.AddendumRequest.AssignedUser = _.find($scope.Radiologists, { Id: $scope.SelectedOrder.SignBy });
                                            $scope.onAddendumUserSelect();
                                            $scope.currentWindow = 'win_addendum_request';
                                            OpenWindow($scope.win_addendum_request, 'win_addendum_request');
                                            $scope.win_addendum_request.wrapper.prev(".k-overlay").addClass("custom-overlay");
                                        });
                                    }
                                }
                            );
                        }
                        break;
                };

                /*switch (Order.Status) {
                    case 'RP':
                        if (!Order.IsLock) {
                            contextMenus.push('separator');
                            contextMenus.push({
                                name: 'Not to be Read',
                                action: function () {
                                    $scope.HideOption = 'NotRead';
                                    $scope.HideStudy();
                                }
                            });
                        }
                        break;
                    case 'H':
                        contextMenus.push('separator');
                        contextMenus.push({
                            name: 'Unhide Study',
                            action: function () {
                                HideUnhideOrder();
                            }
                        });
                        break;
                    case 'C':
                        if ($sessionStorage.IsAddendumRequestVisible) {
                            contextMenus.push('separator');
                            contextMenus.push(
                                {
                                    name: 'Request Addendum',
                                    action: function () {
                                        $scope.SelectedOrder = Order;
                                        $scope.GetAllUsers($scope.SelectedOrder.SiteID).then(function () {
                                            $scope.AddendumRequest.AssignedUser = _.find($scope.Radiologists, { Id: $scope.SelectedOrder.SignBy });
                                            $scope.onAddendumUserSelect();
                                            $scope.currentWindow = 'win_addendum_request';
                                            OpenWindow($scope.win_addendum_request, 'win_addendum_request');
                                            $scope.win_addendum_request.wrapper.prev(".k-overlay").addClass("custom-overlay");
                                        });
                                    }
                                }
                            );
                        }
                        if (($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles && ($sessionStorage.currentUserData.userRoles.includes("Admin") || $sessionStorage.currentUserData.userRoles.includes("Technologist"))) && !Order.IsReviewAssigned) {
                            contextMenus.push('separator');
                            contextMenus.push({
                                name: 'Add to Peer Review',
                                subMenu: [
                                    {
                                        name: 'Auto Assign',
                                        action: function () {
                                            AddToPeerReview('Auto Assign', Order);
                                        }
                                    },
                                    'separator',
                                    {
                                        name: 'Assign to Specific User',
                                        action: function () {
                                            AddToPeerReview('Assign to Specific User', Order);
                                        }
                                    }
                                ],
                            });
                        }
                        break;
                }
                if ($sessionStorage.IsQueryRetrieveVisible && Order.Status != 'C' && Order.IsQREnable) {
                    contextMenus.push('separator');
                    contextMenus.push({
                        name: 'Query Retrieve',
                        action: function () {
                            $scope.QueryRetrieve(Order);
                        }
                    });
                }
                if (Order.Status != 'PA') {
                    contextMenus.push('separator');
                    contextMenus.push(
                        {
                            name: 'Open Discussion (F11)',
                            action: function () {
                                $scope.LoadDiscussion(Order.DicomOrderID, Order.FileCount);
                            }
                        });
                }*/

                //#region Copy Data 
                contextMenus.push('separator');
                var copySubmenu = [];
                copySubmenu.push({
                    name: 'Copy Cell Value',
                    action: function () {
                        if (params.value) {
                            navigator.clipboard.writeText(params.value);
                        }
                    },
                    icon: "<i class='ag-icon ag-icon-copy'></i>",
                });
                copySubmenu.push('separator');
                copySubmenu.push('copy');
                copySubmenu.push('separator');
                copySubmenu.push('copyWithHeaders');
                contextMenus.push({
                    name: 'Copy',
                    subMenu: copySubmenu
                });
                //#endregion Copy Data 

            }
            return contextMenus;
        }
        $scope.HideStudy = function (hideHours, Comments) {
            //////$log.log("HideStudy");
            var type = 0;
            $scope.Comments = Comments;
            $scope.hideHours = hideHours;

            if ($scope.HideOption === 'NotRead') {
                type = 1;
            }

            //Check Study should not be today.
            WorklistService.GetCurrentDateTime().then(function (result) {
                HideUnhideOrder(type);
            });
        };

        function HideUnhideOrder(type) {
            //////$log.log("HideUnhideOrder");
            //$scope.isLoading = true;
            var order = {
                OrderID: $scope.SelectedOrderID,
                IsHide: $scope.SelectedOrder.Status == 'H' ? false : true,
                Type: type,
                Min: ($scope.HideOption === 'Hide') ? parseInt($scope.hideHours) * 60 : 0,
                UserId: $sessionStorage.currentUserData.userId,
                PhysicianName: $sessionStorage.currentUserData.displayName,
                order: $scope.SelectedOrder,
                Comments: $scope.Comments
            };
            switch (type) {
                case 1:
                    order.EventType = 'HNR';
                    break;
                case 2:
                    order.EventType = 'HHR';
                    break;
                case 3:
                    order.EventType = 'HNC';
                    break;
                case 4:
                    order.EventType = 'HNI';
                    break;
            }
            WorklistService.ShowHideOrder(order).then(function (result) {
                var selectedNode;
                if (gridOptions && gridOptions.api) {
                    selectedNode = _.find(gridOptions.api.getRenderedNodes(), function (node) {
                        if (node && node.data) {
                            return node.data.DicomOrderID == $scope.SelectedOrder.DicomOrderID;
                        }
                    });
                    if (selectedNode) {
                        selectedNode.data.RowColorCode = getRowTemplateColorCode(selectedNode.data);
                        gridOptions.api.redrawRows({ rowNodes: [selectedNode] });
                        removeRowFromGrid(selectedNode);
                    }
                }
                //$scope.isLoading = false;
                if (type == 1) {
                    var HiddenType = _.find($scope.HiddenTypeList, { Value: type.toString() });
                    if (HiddenType) {
                        var Comments = HiddenType.Key + ($scope.Comments && $scope.Comments.length > 0 ? ' - ' + $scope.Comments : '');
                        $scope.Discussion = {
                            ReferenceID: $scope.SelectedOrder.DicomOrderID,
                            Type: 1,
                            Comment: Comments,
                            Record_Created_By: $sessionStorage.currentUserData.userId
                        };
                        $scope.SaveDiscussion();
                        Comments = null;
                    }
                }

                $scope.SelectedOrderID = "";
                //$scope.win_HideStudy.close();
                //$scope.refresh();
                if (type == 4) {
                    WorklistService.sendTextNotification(order);
                }

            });
        }
        $scope.CallInConsult = function (order) {
            //$scope.isChatMenuActive = true;
            // $rootScope.$broadcast('activeChatMenuBarformWorkList', $scope.isChatMenuActive,order);
            $scope.setSelected(order.OrderID, order);
            $scope.currentWindow = 'win_consultExamsWindow';
            OpenWindow($scope.win_consultExamsWindow, 'win_consultExamsWindow');
            $scope.win_consultExamsWindow.wrapper.prev(".k-overlay").addClass("custom-overlay");
        }
        $scope.clearSelectedChildRows = function () {
            if (_subGridAPI) {
                _subGridAPI.selection.clearSelectedRows();
            }
        }

        //Close onClick of send message button from shareExamchat.js
        $scope.onCloseConsultExamWindowHandler = function (newCheck) {
            $scope.isConsultExamsWindow = newCheck;
            if ($scope.isConsultExamsWindow == true) {
                $scope.win_consultExamsWindow.close();
            }
        };
        function OpenWindow(win, key) {
            if (win) {
                win.open();
                var dollarTimeout = $timeout(function () {
                    win.center();
                    $timeout.cancel(dollarTimeout);
                    dollarTimeout = null;
                }, 100);
            } else {
                var dialog = $("div[kendo-window='" + key + "']").data("kendoWindow");
                if (dialog) {
                    dialog.open();
                    var dollarTimeout = $timeout(function () {
                        dialog.center();
                        $timeout.cancel(dollarTimeout);
                        dollarTimeout = null;
                    }, 100);
                }
            }

        }
        /**
         * Modified By: Tejas Parikh
         * Task 22822: All sites should be listed in alphabetical manner in location filter list
         * @param {any} a
         * @param {any} b
         */
        function compare(a, b) {
            //$log.log("compare: " + new Date());
            // Use toUpperCase() to ignore character casing
            var bandA = a.text.toUpperCase();
            var bandB = b.text.toUpperCase();

            var comparison = 0;
            if (bandA > bandB) {
                comparison = 1;
            } else if (bandA < bandB) {
                comparison = -1;
            }
            return comparison;
        }

        function checkedNodeValues(nodes, checkedNodes) {
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && !nodes[i].hasChildren) {
                    if (checkedNodes.indexOf(nodes[i].value) < 0) {
                        checkedNodes.push(nodes[i].value);
                    }

                }
                if (nodes[i].hasChildren) {
                    checkedNodeValues(nodes[i].children.view(), checkedNodes);
                }
            }
            return checkedNodes;
        }

        $scope.bindLocationFilter = function () {
            WorklistService.GetSitesAndLocationsForWorkList($sessionStorage.currentUserData.userId).then(function (result) {
                var Locations = result;
                Locations = $filter('orderBy')(Locations, 'title');
                $scope.LocInstance = $('#Locations').comboTree({
                    source: Locations,
                    isMultiple: true,
                    cascadeSelect: true,
                    collapse: true,
                    onlyChild: true
                });
            });
        };
        function GetModality() {
            //$log.log("GetModality: " + new Date());
            var d = $q.defer();
            PhysicianWorklistService.GetModality().then(function (result) {
                //$log.log("GetModality response: " + new Date());
                $scope.Modalities = result;
                d.resolve();
            });
            return d.promise;
        };
        function GetUserPreferences() {
            var d = $q.defer();
            //$log.log("GetUserPreferences: " + new Date());
            //$scope.isLoading = true;
            var userPreference = {
                UserID: $sessionStorage.currentUserData.userId,
                PreferenceType: "Choose Next Study,DisplaySetting,ShowUserGuidePhysician",
            };
            UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
                //$log.log("GetUserPreferences response: " + new Date());
                result = result.UserPreferences;
                if (result !== null && result.length > 0) {
                    if ($scope.browser !== null && $scope.browser.toUpperCase() === "IE") {
                        $scope.ChooseNextStudy = result[0].PreferenceValue === "1" ? true : false;
                    }
                }
                var pref1 = _.filter(result, function (obj) { return obj.PreferenceType == "DisplaySetting"; })[0];
                if (pref1) {
                    pref1 = _.filter(JSON.parse(pref1.PreferenceValue), function (obj) { return obj.HostFingerPrintHash == $sessionStorage.currentUserData.HostFingerPrintHash })[0];
                    if (pref1) {
                        windowHandler.LoadPrefenece(pref1.DisplaySetting);
                    }
                }
                var pref1 = _.filter(result, function (obj) { return obj.PreferenceType == "DisplaySetting"; })[0];
                if (pref1) {
                    pref1 = _.filter(JSON.parse(pref1.PreferenceValue), function (obj) { return obj.HostFingerPrintHash == $sessionStorage.currentUserData.HostFingerPrintHash })[0];
                    if (pref1) {
                        windowHandler.LoadPrefenece(pref1.DisplaySetting);
                    }
                }
                showUserGuidePhysician = _.find(result, { PreferenceType: "ShowUserGuidePhysician" });
                ShowReleaseGuide = _.find(result, {
                    PreferenceType: "ShowReleaseGuide"
                });
                d.resolve();
            });
            return d.promise;
        };

        function UpdateDicomOrderSTAT(order) {
            order.UserId = $sessionStorage.currentUserData.userId;
            PhysicianWorklistService.UpdateDicomOrderSTAT(order).then(function (result) {
            });
        };
        $scope.ResendReport = function (order) {
            //$scope.isorderlistLoading = true;
            var obj = {
                OrderID: order.OrderID,
                UserID: $sessionStorage.currentUserData.userId,
                MessageType: "ORU"
            };
            PhysicianWorklistService.ResendReport(obj).then(function (result) {
                //$scope.isorderlistLoading = false;
                toaster.success({ body: "Report send successfully!" });
            }).catch(function (noCantDo) {
                //$scope.isorderlistLoading = false;
                toaster.error({ body: "Report not send! Please try again!" });
            });
        };
        function PageInIt() {
            //$log.log("PageInIt: " + new Date());
            //const gridDiv = document.querySelector('#myGrid');
            //new agGrid.Grid(gridDiv, gridOptions);
            intiAppHub();
            updatePageSize();
            setHeight();
            previousHeight = currentHeight;
            $q.all([
                getLookUpByType(),
                GetUserPreferences(),
                GetSitesAndLocationsByUserID(),
                GetModality(),
                getPhysicianPageSetting(),
                GetUserLayoutPreferences()
            ]).then(function (data) {
                //checkImagePendingRequest().then(function () {
                updateRefreshDOSInterval();
                refreshDOSMidnight = $interval(refreshDOS, refreshDOSInterval);
                OrderRefresh();
                getOrderStatus();

                var urlParams = new URLSearchParams(window.location.search);
                var Accession = urlParams.get('Accession');
                if (Accession && $scope.userRoles.includes("Physician")) {
                    $scope.Accession = Accession;
                    $scope.Status = "AL";
                    $scope.OrderDate = {
                        endDate: null,
                        startDate: null
                    }
                }

                var timeout = $timeout(function () {
                    initGrid();
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 100);
                //});
            });
        }
        function checkImagePendingRequest() {
            //$log.log("checkImagePendingRequest: " + new Date());
            var d = $q.defer();
            PhysicianWorklistService.getImagePendingCount($sessionStorage.currentUserData.userId).then(function (result) {
                //$log.log("checkImagePendingRequest response: " + new Date());
                //$scope.ImagePengindCount = result;
                if (result && result.length > 0) {
                    var name = '';
                    var cnt = 0;
                    if (result.length > 1) {
                        angular.forEach(result, function (obj) {
                            if (cnt === 0) {
                                name = '<div> - ' + obj.UserName + '</div>';
                            }
                            else {
                                name = name + '<div> - ' + obj.UserName + '</div>';
                            }
                            cnt++;
                        });

                        swal({
                            title: "",
                            text: "<div class='rf-alert-text'><div>Below physicians has requested for additional images.</div> \n" + name + "</div>",
                            html: true
                        });
                    }
                    else {

                        swal({
                            title: "",
                            text: "<div class='rf-alert-text'>" + result[0].UserName + " has requested for additional images.</div>",
                            html: true
                        });
                    }

                    $scope.Status = "H";
                    $scope.HiddenType.obj = _.filter($scope.HiddenTypeList, { Value: "4" })[0];
                }
                d.resolve();
            }, function (error) {
                d.reject();
            });
            return d.promise;
        }

        $scope.HelpOrder = function () {
            $scope.Ishelper = false;
            $scope.OrderDiscussion = null;
            //$('#ModalHelpOrder').modal('show');
            $scope.currentWindow = "win_HelpOrder";
            $scope.win_HelpOrder.open();
            $scope.win_HelpOrder.wrapper.prev(".k-overlay").addClass("custom-overlay");
            var timeout = setTimeout(function () {
                $scope.win_HelpOrder.center();
                clearTimeout(timeout);
                timeout = null;
            }, 1000);
            $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID);
            LoadOrderDiscussionForUser();
        }

        $scope.LoadReport = function () {
            $scope.selecteReportId = null;
            var timeout = setTimeout(function () {
                $scope.selecteReportId = $scope.SelectedOrder.OrderID;
                if ($scope.selecteReportId) {
                    //angular.element('#ModalViewReport').modal('show');
                    $scope.currentWindow = "win_ViewReport";
                    $scope.win_ViewReport.open();
                    $scope.win_ViewReport.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    $scope.win_ViewReport.wrapper.addClass("report-top-mdl");
                    var timeout1 = setTimeout(function () {
                        $scope.win_ViewReport.center();
                        clearTimeout(timeout1);
                        timeout1 = null;
                    }, 1000);
                }
                clearTimeout(timeout);
                timeout = null;
            }, 100);
        }

        function LoadOrderDiscussionForUser() {
            //$log.log("LoadOrderDiscussionForUser");
            $scope.orderDiscussionTooltip = '';
            $scope.OrderDiscussion = {
                SelectedUser: null,
                SelectedUsers: []
            };
            var data = {
                OrderID: $scope.SelectedOrder.OrderID,
                FromUserID: $sessionStorage.currentUserData.userId
            }

            //$scope.isDiscussionLoading = true;
            PhysicianWorklistService.GetOrderDiscussionAssignment(data).then(function (response) {
                $scope.isDiscussionLoading = false;
                if (response) {
                    $scope.OrderDiscussion = response;
                    $q.all([
                        $scope.GetAllUsers($scope.SelectedOrder.SiteID)
                    ]).then(function (data) {
                        if (!$scope.OrderDiscussion.SelectedUsers && !$scope.OrderDiscussion.SelectedRadioLogistsGroup) {
                            $scope.OrderDiscussion.SelectedUsers = [];
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                            var SelectedRadioLogistsGroup = [];
                            _.each($scope.OrderDiscussion.OrderAssignments, function (orderAssignment) {
                                if (orderAssignment.ProviderSpecialityId > 0) {
                                    var radiologistGroup = _.find($scope.RadiologistsGroups, { Id: orderAssignment.ProviderSpecialityId.toString() });
                                    if (radiologistGroup) {
                                        SelectedRadioLogistsGroup.push(radiologistGroup);
                                    }
                                } else {
                                    var radiologistGroup = _.find($scope.RadiologistsGroups, { Id: orderAssignment.ProviderID });
                                    if (radiologistGroup) {
                                        SelectedRadioLogistsGroup.push(radiologistGroup);
                                    }
                                }
                            });
                            var uniqueSelectedRadioLogistsGroup = _.uniqBy(SelectedRadioLogistsGroup, 'Id');
                            var orderedSelectedRadioLogistsGroup = _.concat(_.orderBy(_.filter(uniqueSelectedRadioLogistsGroup, function (srlg) { return srlg.Group && srlg.Group == 'YES'; }), ['UserName'], ['asc']), _.orderBy(_.filter(uniqueSelectedRadioLogistsGroup, function (srlg) { return !srlg.Group; }), ['UserName'], ['asc']));
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup = orderedSelectedRadioLogistsGroup;

                            $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();
                            var timeout = setTimeout(function () {
                                setOrderDiscussionUserGroup().then(function (data) {
                                    setOrderDiscussionTooltip();
                                    setSelectedUserAssignment(data);
                                });
                                $scope.AssignStudyVisible = false;
                                if ($scope.OrderDiscussion.SelectedUsers && $scope.OrderDiscussion.SelectedUsers.length > 0) {
                                    $scope.AssignStudyVisible = true;
                                }

                                clearTimeout(timeout);
                                timeout = null;
                            }, 100);
                        }

                    });
                } else {
                    $scope.GetAllUsers($scope.SelectedOrder.SiteID)
                }
            }, _respError);
        }
        $scope.LoadDiscussion = function (referenceID, FileCount) {
            //$log.log("LoadDiscussion");
            $scope.hidePopover(referenceID);
            $scope.showAttachment = false;
            $scope.FileList = [];
            $scope.isDiscussionLoading = true;
            angular.element("input[type='file']").val(null);
            $scope.Discussion = {
                ReferenceID: referenceID,
                Type: 1,
                Comment: '',
                Record_Created_By: $sessionStorage.currentUserData.userId
            };
            $scope.Discussions = null;
            LoadDiscussion($scope.Discussion).then(function () {
                if ($scope.Discussions && $scope.Discussions.length == 0 && $scope.SelectedOrder.FileCount > 0) {
                    $scope.onDiscussionWindowTabChange('Attachment');
                    $scope.showFileList();
                    $scope.DataObject.ShowDiscussionTab = false;
                }
                else {
                    $scope.DataObject.ShowDiscussionTab = true;
                    $scope.onDiscussionWindowTabChange('Discussion');
                }
            });
            var dollarTimeout = $timeout(function () {
                LoadOrderDiscussionForUser();
                $timeout.cancel(dollarTimeout);
                dollarTimeout = null;
            }, 500);
            $scope.currentWindow = "win_Discussion";
            $scope.win_Discussion.open();
            $scope.win_Discussion.wrapper.prev(".k-overlay").addClass("custom-overlay");
            $scope.win_Discussion.wrapper.addClass("report-top-mdl");
            var timeout = setTimeout(function () {
                $scope.win_Discussion.center();
                clearTimeout(timeout);
                timeout = null;
            }, 1000);
        }
        function LoadDiscussion(discussion) {
            //$log.log("LoadDiscussion: " + new Date());
            var d = $q.defer();
            PhysicianWorklistService.GetDiscussions(discussion).then(function (response) {
                $scope.AllDiscussions = _.cloneDeep(response);
                $scope.Discussions = _.filter(response, function (item) { return item.Type == 1; });
                angular.forEach($scope.Discussions, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
                d.resolve();
            }, _respError);
            return d.promise;
        }
        function LoadChildDiscussion(ObjDiscussion) {
            //$log.log("LoadChildDiscussion: " + new Date());
            var response = _.filter($scope.AllDiscussions, function (item) { return item.ReferenceID == ObjDiscussion.ID; });
            if (response && (response.length > 0)) {
                if (!ObjDiscussion.Childs || ObjDiscussion.Childs.length != response.length) {
                    ObjDiscussion.Childs = response;
                }
                angular.forEach(ObjDiscussion.Childs, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            }
        }
        function bindChildDiscussion(ObjDiscussion) {
            angular.forEach($scope.Discussions, function (obj, idx) {
                LoadChildDiscussion(obj);
            });
        }
        $scope.SaveOrderDiscussion = function () {
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];

                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_MSG_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });


                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'O'
                };
                $scope.isDiscussionLoading = true;
                PhysicianWorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                    $scope.SaveDiscussion();
                    LoadOrderDiscussionForUser();
                }, _respError);
            }
        }
        $scope.AssignStudy = function () {
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];
                $scope.SelectedOrder.listOrderListAssignment = [];
                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_STUDY_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var userOfGroup = _.filter($scope.OrderDiscussion.SelectedUsers, function (item) { return item.SpecialityId == obj.SpecialityId; });

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode,
                        TotalUsersOfGroup: userOfGroup.length
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });
                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'I',
                    Order: $scope.SelectedOrder,
                    EventType: 'TC',
                };
                //$scope.isLoading = true;

                PhysicianWorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                    LoadOrderDiscussionForUser();
                    $scope.SaveDiscussionFlag = false;
                }, _respError);
            }
        };
        $scope.CloseOrderDiscussion = function () {
            var orderDiscussionUserGroup = [];
            _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                var userGroup = {
                    ToUserID: obj.Id,
                    ToUser: obj.LastName + ', ' + obj.FirstName,
                    ProviderSpecialityId: obj.SpecialityId,
                    IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                }
                orderDiscussionUserGroup.push(userGroup);
            });
            NotifyToUser(__env._ANS_MSG_, $scope.SelectedOrder.OrderID, $scope.OrderDiscussion.FromUserID, null);
            $scope.OrderDiscussion.OrderDiscussionUserGroup = orderDiscussionUserGroup;
            PhysicianWorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                //$('#ModalHelpOrder').modal('hide');
                $scope.win_HelpOrder.close();
            }, _respError);
        }
        $scope.SaveDiscussion = function () {
            $scope.isDiscussionLoading = true;
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedUsers) {
                $scope.SaveDiscussionFlag = true;
                $scope.AssignStudy();
            }
            if ($scope.Discussion.Comment) {
                $scope.SaveDiscussionFlag = true;
                $scope.Discussion.EventType = 'TC';
                PhysicianWorklistService.SetDiscussion($scope.Discussion).then(function (response) {
                    var idx = _.findIndex(DicomOrderList, function (obj) { return obj.DicomOrderID == response.ReferenceID; });
                    if (idx != -1) {
                        DicomOrderList[idx].IsDiscussion = true;

                        var rowToUpdate = gridOptions.api.getRowNode((DicomOrderList[idx].orderRowID).toString());
                        if (rowToUpdate && rowToUpdate.data) {
                            rowToUpdate.data.IsDiscussion = true;
                            gridOptions.api.refreshCells({
                                force: true,
                                suppressFlash: true,
                                rowNodes: [rowToUpdate]
                            });
                        }
                    }
                    //updateOrders();
                    LoadDiscussion($scope.Discussion);
                    $scope.Discussion.Comment = null;
                    $scope.SaveDiscussionFlag = false;
                }, _respError);
            }
            $scope.isDiscussionLoading = false;
        }
        $scope.SaveChildDiscussion = function (discussion) {
            if (discussion.ChildComment) {
                var Objdiscussion = {
                    ReferenceID: discussion.ID,
                    Type: 0,
                    Comment: discussion.ChildComment,
                    Record_Created_By: $sessionStorage.currentUserData.userId
                };
                if (discussion.Record_Created_By !== $sessionStorage.currentUserData.userId) {
                    NotifyToUser(__env._NOTIFY_MSG_, $scope.SelectedOrder.OrderID, discussion.Record_Created_By, "N");
                }
                $scope.isDiscussionLoading = true;
                PhysicianWorklistService.SetDiscussion(Objdiscussion).then(function (response) {
                    $scope.isDiscussionLoading = false;
                    discussion.IsChild = false;
                    discussion.ChildComment = '';
                    $scope.AllDiscussions.push(response);
                    bindChildDiscussion(response);
                }, _respError);
            }

        }

        function _respError(error) {
            $scope.isDiscussionLoading = false;
        }

        $scope.GetAllUsers = function (SiteID) {
            var d = $q.defer();
            var filter = {
                SiteID: SiteID
            };
            WorklistService.GetRadiologistsBySite(filter).then(function (result) {
                siteRadiologistsUnfiltered = result.radiologistsLists || [];
                $scope.Radiologists = _.filter(siteRadiologistsUnfiltered, function (r) {
                    return _isSelf(r.Id || r.UserID) || !_hasPrelimRad(r.UserRoles || r.Roles);
                });
                specialityAssignments = result.specialityAssignments;

                $scope.RadiologistsGroups = [];
                var mRadiologistsGroups = [];

                var uniqueSpeciality = _.uniqBy(specialityAssignments, 'SpecialityId');
                _.each(uniqueSpeciality, function (obj) {

                    var RadiologistsGroup = {};
                    RadiologistsGroup['Id'] = obj.SpecialityId;
                    RadiologistsGroup['UserName'] = obj.SpecialityCode;
                    RadiologistsGroup['Group'] = "YES";
                    mRadiologistsGroups.push(RadiologistsGroup);


                });
                _.each(specialityAssignments, function (speciality) {
                    var user = _.find($scope.Radiologists, { 'Id': speciality.UserId });
                    if (user) {
                        if (!user.Specialities) {
                            user.Specialities = [];
                        }
                        var spclty = _.find(user.Specialities, { SpecialityId: speciality.SpecialityId });
                        if (!spclty) {
                            user.Specialities.push(speciality);
                        }
                    }
                });

                mRadiologistsGroups.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                $scope.Radiologists.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                mRadiologistsGroups = mRadiologistsGroups.concat($scope.Radiologists);

                $scope.RadiologistsGroups = mRadiologistsGroups;
                getOrderDiscussionOptions();

                d.resolve();

            });
            return d.promise;
        };

        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function isVisibleRad(r) {
            if (!r) return false;
            if (_isSelf(r.Id || r.UserID)) return true;
            return !_hasPrelimRad(r.UserRoles || r.Roles);
        }
        $scope.isVisibleRad = isVisibleRad;
        $scope.radDisplay = function (r) {
            if (!r) return '';
            if (!_isSelf(r.Id || r.UserID) && _hasPrelimRad(r.UserRoles || r.Roles)) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
        $scope.signByDisplay = function (r) {
            if (!r) return '';
            if ($sessionStorage.currentUserData
                && $sessionStorage.currentUserData.RemoveRenderingPhysician
                && $scope.DataObject.EnableRowsForSelectedTenants
                && $scope.SelectedOrder
                && $scope.DataObject.EnableRowsForSelectedTenants.includes($scope.SelectedOrder.TenantName)) {
                return '';
            }
            var signBy = r.SignBy || (r.OrderReport && r.OrderReport.SignBy);
            var signByName = r.SignByName || (r.OrderReport && r.OrderReport.SignByName) || '';
            return signBy ? _assignmentName(signBy, signByName) : signByName;
        };
        $scope.disName = function (dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        };
        function _findRadByUserId(userId) {
            if (!userId) return null;
            var id = userId.toLowerCase();
            var rad = _.find(siteRadiologistsUnfiltered || [], function (r) {
                return (r.Id || r.UserID || '').toLowerCase() === id;
            });
            if (rad) return rad;
            rad = _.find(RuleSharedService.GetCachedRadiologists(), function (r) {
                return (r.Id || r.UserID || '').toLowerCase() === id;
            });
            if (!rad) {
                RuleSharedService.RequestTenantRadiologistsIfNeeded();
            }
            return rad || null;
        }
        function _isPrelimRadAssignment(userId) {
            if (!userId || _isSelf(userId)) return false;
            var rad = _findRadByUserId(userId);
            return rad ? _hasPrelimRad(rad.UserRoles || rad.Roles) : false;
        }
        function _assignmentName(userId, name) {
            return _isPrelimRadAssignment(userId) ? '' : name;
        }
        function _discussionDisplayName(dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        }

        function OpenDiscussionOrder() {
            $scope.OrderDiscussion = null;
            if ($state.params["OD"]) {
                $scope.OrderDiscussion = $state.params["OD"];
                $scope.setSelected($scope.OrderDiscussion.Order.OrderID, $scope.OrderDiscussion.Order);
                $scope.currentWindow = "win_HelpOrder";
                $scope.win_HelpOrder.open();
                $scope.win_HelpOrder.wrapper.prev(".k-overlay").addClass("custom-overlay");
                var timeout = setTimeout(function () {
                    $scope.win_HelpOrder.center();
                    clearTimeout(timeout);
                    timeout = null;
                }, 1000);
                $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID);
                if ($scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId) {
                    if ($scope.OrderDiscussion.Status == 'A') {
                        $scope.OrderDiscussion.Status = 'C';
                        PhysicianWorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                            LoadOrderDiscussionForUser();
                        }, _respError);
                    } else {
                        LoadOrderDiscussionForUser();
                    }
                } else {
                    if ($scope.OrderDiscussion.Status == 'N') {
                        $scope.OrderDiscussion.Status = 'D';
                        PhysicianWorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                            LoadOrderDiscussionForUser();
                        }, _respError);
                        return;
                    }
                    var list = _.filter($scope.Radiologists, function (obj) { return $scope.OrderDiscussion.ToUserID == obj.Id; });
                    if (list && list.length > 0) {
                        $scope.OrderDiscussion.SelectedUser = list[0];
                    }
                    $scope.OrderDiscussion.Status = 'A';
                    $scope.Ishelper = true;
                }
            }
        }
        OpenDiscussionOrder();

        function NotifyToUser(msg, orderID, toUserID, status) {
            var data = {
                OrderID: orderID,
                FromUserID: $sessionStorage.currentUserData.userId,
                FromUser: $sessionStorage.currentUserData.displayName,
                ToUserID: toUserID,
                Status: status,
                Message: msg
            }
            PhysicianWorklistService.NotifyToUser(data).then(function (response) {
            }, _respError);
        }

        $scope.OpenDiscussion = function (referenceID) {
            $scope.ODType = 'Discussion';
            $scope.LoadDiscussion(referenceID, 'Discussion');
        };

        $scope.openDiscussion = function () {
            if ($scope.SelectedOrder && $scope.SelectedOrder.FileCount > 0) {
                selectPriorReportTab("#tabDiscussion");
                $scope.DataObject.Reference.ID = null;
                var timeout = setTimeout(function () {
                    $scope.showAttachment = true;
                    $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
                    clearTimeout(timeout);
                    timeout = null;
                }, 50);
            }
        }

        function selectPriorReportTab(tabName) {
            $("#tabReport").removeClass('active');
            $("#tabDiscussion").removeClass('active');
            $("#Discussion").removeClass('active');
            $("#Report").removeClass('active');
            $(tabName).addClass('active');
            $(tabName.replace('tab', '')).addClass('active');
            var tabStrip = $("#tabstrip").kendoTabStrip().data("kendoTabStrip");
            tabStrip.select(tabName);
        }

        function intiAppHub() {
            AppHub = AppHubService.getAppHub();
            var justCreated = false;
            if (!AppHub && $sessionStorage.currentUserData) {
                AppHubService.Initialize();
                AppHub = AppHubService.getAppHub();
                justCreated = true;
            }
            if (AppHub) {
                AppHubMethod();
                if (justCreated) AppHubService.startConnection();
            }
        }

        function AppHubMethod() {
            AppHub.on('RadFlowAppHubEvent', function (obj) {
                switch (obj.EventType) {
                    case 'techworklistupdatehandler':
                        OrderAutoRefresh = false;
                        //isOrderOnServer = true;
                        //if (!($scope.isDiscussionVisible ||
                        //    $scope.isPatientInfoVisible ||
                        //    $scope.isHelpOrderVisible ||
                        //    $scope.isViewReportVisible)) {
                        //    $scope.getData();
                        //}
                        break;
                    case 'notifyopenorder':
                        var OrderID = obj.EventArgs.OrderID;
                        var isOpen = obj.EventArgs.Open;
                        var ProviderID = obj.EventArgs.ProviderID;
                        var ProviderName = obj.EventArgs.ProviderName;

                        $log.log('NotifyOpenOrder is call');
                        OrderAutoRefresh = false;
                        //$scope.isorderlistLoading = false;
                        if ($sessionStorage.currentUserData.userId != ProviderID) {
                            var rowToUpdate;
                            var objOrder = _.filter(DicomOrderList, function (obj) { return obj.OrderID == OrderID; });
                            if (objOrder && objOrder.length > 0) {
                                rowToUpdate = gridOptions.api.getRowNode((objOrder[0].orderRowID).toString());
                                if ($scope.ShowLockStudy) {
                                    if (isOpen) {
                                        objOrder[0].IsLock = true;
                                        objOrder[0].LockBy = ProviderName;

                                        if (rowToUpdate && rowToUpdate.data) {
                                            rowToUpdate.data.IsLock = true;
                                            rowToUpdate.data.LockBy = ProviderName;
                                        }
                                    }
                                    else {
                                        objOrder[0].IsLock = false;
                                        if (rowToUpdate && rowToUpdate.data) {
                                            rowToUpdate.data.IsLock = false;
                                        }
                                    }
                                }
                                else {
                                    isOrderOnServer = true;
                                }

                                if (rowToUpdate && gridOptions && gridOptions.api) {
                                    gridOptions.api.refreshCells({
                                        force: true,
                                        suppressFlash: true,
                                        rowNodes: [rowToUpdate]
                                    });
                                }
                            }
                        }
                        break;
                    case 'notifyoruupdate':
                        OrderAutoRefresh = false;
                        removeOrderAccession(obj.EventArgs.Accession);
                        //$scope.getData();
                        break;
                    case 'notifyshowhidedicomorder':
                        var HideStudy = obj.EventArgs.HideStudy;
                        OrderAutoRefresh = false;
                        var orderIndex = OrderExists(HideStudy.order.OrderID);
                        if (orderIndex != -1) {
                            if (!HideStudy.IsHide) {
                                DicomOrderList[orderIndex].IPComment = '';

                            } else {
                                DicomOrderList[orderIndex].IPComment = HideStudy.Comments;
                            }
                            DicomOrderList[orderIndex].Status = HideStudy.IsHide ? "H" : "RP";
                            if ($scope.Status != "AL") {
                                removeOrderFromList(HideStudy.order.OrderID);
                            }
                            else {
                                var rowToUpdate = gridOptions.api.getRowNode((DicomOrderList[orderIndex].orderRowID).toString());
                                if (rowToUpdate && rowToUpdate.data) {
                                    rowToUpdate.data.FileCount = $scope.SelectedOrder.FileCount;
                                    gridOptions.api.refreshCells({
                                        force: true,
                                        suppressFlash: true,
                                        rowNodes: [rowToUpdate]
                                    });
                                }
                            }
                        }
                        /*if (HideStudy.Type == 4) {
                            var toast;
                            toast = toaster.pop({
                                type: 'info', title: 'Physician has requested for additional images!', body: 'Click here to view!', bodyOutputType: 'trustedHtml', tapToDismiss: true,
                                clickHandler: function (Toaster, closeFlag) {
                                    if (!closeFlag) {
                                        $scope.Status = "H";
                                        $scope.HiddenType.obj = _.filter($scope.HiddenTypeList, { Value: "4" })[0];
                                        $scope.FilterDICOMOrders();
                                        switch (true) {
                                            case ($scope.isHelpOrderVisible):
                                                $scope.win_HelpOrder.close();
                                                break;
                                            case ($scope.isViewReportVisible):
                                                $scope.win_ViewReport.close();
                                                break;
                                            case ($scope.isDiscussionVisible):
                                                $scope.win_Discussion.close();
                                                break;
                                            case ($scope.isViewTechniqueVisible):
                                                $scope.win_ViewTechnique.close();
                                                break;
                                            case ($scope.isAddTechniqueVisible):
                                                $scope.win_AddTechnique.close();
                                                break;
                                            case ($scope.isTechFormVisible):
                                                $scope.win_TechForm.close();
                                                break;
                                            case ($scope.isPatientInfoVisible):
                                                $scope.win_PatientInfo.close();
                                                break;
                                        }
                                    }
                                    toaster.clear(toast);
                                }
                            });
                        }*/
                        break;
                    case 'notifytechorderlistsavereport':
                        OrderAutoRefresh = false;
                        if (obj.EventArgs.ReportView && obj.EventArgs.ReportView.Accession) {
                            removeOrderAccession(obj.EventArgs.ReportView.Accession);
                        }
                        //$scope.getData();
                        break;
                    case 'notifyupdateorderdetail':
                        var index = _.findIndex(DicomOrderList, { 'OrderID': obj.EventArgs.OrderID });
                        if (index != -1) {
                            if (obj.EventArgs.isPeerReview != null) {
                                DicomOrderList[index].IsReviewAssigned = true;

                                var rowToUpdate = gridOptions.api.getRowNode((DicomOrderList[index].orderRowID).toString());
                                if (rowToUpdate && rowToUpdate.data && gridOptions && gridOptions.api) {
                                    rowToUpdate.data.IsReviewAssigned = true;
                                    gridOptions.api.redrawRows({ rowNodes: [rowToUpdate] });
                                }
                            }
                        }
                        break;
                    case 'notifyassignstudy':
                        NotifyAssignStudy(obj.EventArgs);
                        break;

                    case 'notifypostorderormqueuemsg':
                        CommonService.notifypostorderormqueuemsg(obj);
                        break;
                }
            });
        }


        function refreshDOS() {
            //$log.log("refreshDOS: " + new Date());
            if (refreshDOSMidnight)
                $interval.cancel(refreshDOSMidnight);
            refreshDOSMidnight = $interval(function () {
                //$log.log("refreshDOS interval: " + new Date());
                var now = new Date();
                var days = now.getDate() - $scope.currentDate.getDate();
                ////$log.log("refreshDOS > days: ", days);
                if (days > 0) {
                    $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
                    if ($scope.OrderDate.startDate && $scope.OrderDate.endDate) {
                        if ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom'))
                            $scope.OrderDateType = ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                                moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType;

                    }
                    else
                        $scope.OrderDateType = 'Clear';
                    setOrderDate($scope.OrderDateType);
                    $scope.currentDate = now;
                    //$scope.getData();-- for ag grid
                    refreshWorklistAggrid();
                }
            }, 1000);
        }


        $scope.setSelected = function (SelectedOrderID, SelectedOrder) {
            $scope.SelectedOrderID = SelectedOrderID;
            $scope.SelectedOrder = _.clone(SelectedOrder);
            $scope.SelectedOrder.DontShowReportData = true;
            $scope.SelectedOrder.OrderDate = ($filter('localDate')($scope.SelectedOrder.OrderDate, false, new Date()));
            if ($scope.SelectedOrder && $scope.SelectedOrder.PatientDOB) {
                $scope.SelectedOrder.PatientDOB = changeDateFormat($scope.SelectedOrder.PatientDOB);
            }
            if ($scope.SelectedOrder && $scope.SelectedOrder.Status) {
                $scope.SelectedOrder.OrderStatus = _.find($scope.DataObject.OrderStatus, { 'key': $scope.SelectedOrder.Status }).value;
            }
            $scope.SelectedComPatisomOrderID = "";
            //swal(SelectedComPatisomOrderID); 
            //js for discussion pop wondow to show message box when keypad comes up
            if (angular.element(window).width() < 768) {
                var timeout = setTimeout(function () {
                    angular.element('.discus-comment .txt-area').focusin(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').addClass('mobscreen-scroll');
                            var timeout1 = setTimeout(function () {
                                angular.element('.denial-window.mobscreen-scroll').animate({ scrollTop: $(document).height() }, "fast");
                                clearTimeout(timeout1);
                                timeout1 = null;
                            }, 100);
                        }
                    });
                    angular.element('.discus-comment .txt-area').focusout(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').removeClass('mobscreen-scroll');
                        }
                    });
                    clearTimeout(timeout);
                    timeout = null;
                }, 500);
            }
        };
        $scope.setSelectedComparison = function (SelectedOrderID, SelectedComPatisomOrderID) {
            $scope.SelectedComPatisomOrderID = SelectedComPatisomOrderID;
            $scope.SelectedOrderID = SelectedOrderID;
            //swal(SelectedComPatisomOrderID);
        };


        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };

        //#region Instance the physician tour
        var tourPhysician = new Tour({
            steps: [],
            backdrop: true,
            onShown: function (tour) {
                if (tour && tour._options) {
                    var step = tour._options.steps[tour._current];
                    $(step.element).addClass('tour-section-disbl');
                }
            },
            onHidden: function (tour) {
                if (tour && tour._options) {
                    var step = tour._options.steps[tour._current];
                    $(step.element).removeClass('tour-section-disbl');
                }
            },
            onEnd: function (tour) {
                $('.tour-section-disbl').removeClass('tour-section-disbl');
                updateuserguidephysicianpreference();
                GetUserPreferences().then(function () {
                    if (!ShowReleaseGuide || ShowReleaseGuide.PreferenceValue != APP_CONSTANTS.radflowUIVersion) {
                        $rootScope.$broadcast('startReleaseTour', true);
                    };
                });
            },
        });

        tourPhysician.init();

        function startUserGuidePhysicianTour() {
            if (!showUserGuidePhysician || showUserGuidePhysician.PreferenceValue != "0") {
                tourPhysician.init();
                tourPhysician.setCurrentStep(0);
                tourPhysician.start(true);

            }
            else {
                if (!ShowReleaseGuide || ShowReleaseGuide.PreferenceValue != APP_CONSTANTS.radflowUIVersion) {
                    $rootScope.$broadcast('startReleaseTour', true);
                }
            }
        }

        $scope.$on("PhysicianWorklist_Tour", function (evt, data) {
            if (data) {
                TourFlag = true;
                HelpPhysicianTour();
            }
        });
        //#endregion Instance the physician tour

        PageInIt();

        $scope.$on('$destroy', function () {
            AppHub.off("RadFlowAppHubEvent");

            //$interval.cancel(orderRefreshInterval);
            $interval.cancel(refreshDOSMidnight);
            $interval.cancel(OrderRefreshInterval);

            $('.popover.tour').css("display", "none");
            $('.tour-backdrop.top').css("display", "none");
            $('.tour-backdrop.bottom').css("display", "none");
            $('.tour-backdrop.left').css("display", "none");
            $('.tour-backdrop.right').css("display", "none");
            tourPhysician = null;
            if (gridOptions & gridOptions.api) {
                gridOptions.api.destroy()
            }
            CloseAllWindow(true);
        });
        //$scope.$on('$destroy', function () {
        //    //$interval.cancel(orderRefreshInterval);
        //});

        /* Update Patient Information*/
        $scope.LoadPatientData = function (order) {
            $scope.DicomOrderID = null;
            $scope.PatientInfo = null;
            PhysicianWorklistService.GetDicomOrderByID(order.DicomOrderID).then(function (result) {
                if (result && result.length > 0) {
                    result[0].OrderID = order.OrderID;
                    $scope.PatientInfo = angular.copy(result[0]);
                    $scope.DataObject.OrderingPhysician.Provider = null;
                    $scope.PatientInfo.OrderingPhysicianSite = null;
                    $scope.CPT = false;
                    if ($scope.PatientInfo.CPT_Code || $scope.PatientInfo.CPT_Description) {
                        $scope.CPT = true;
                    }
                    $scope.PatientInfo.CPTProcedures = $scope.CPT ? $scope.PatientInfo.CPT_Code : $scope.PatientInfo.Procedures;
                    $scope.PatientInfo.CPTProcedureDesc = $scope.CPT ? $scope.PatientInfo.CPT_Description : $scope.PatientInfo.ProcedureDesc;
                    loadPatientData(result[0]);
                }
            }, function (err) {
                $log.log(err);
            });

        };
        $scope.SavePatientInfo = function (saveDataFlag, EventType) {
            if (!$scope.PatientInfo.DOSTime) {
                toaster.warning({ body: "Invalid DOS time!" });
                return;
            }
            else {
                var dos = new Date($scope.PatientInfo.DOS.getFullYear(), $scope.PatientInfo.DOS.getMonth(), $scope.PatientInfo.DOS.getDate(), $scope.PatientInfo.DOSTime.getHours(), $scope.PatientInfo.DOSTime.getMinutes(), 0).toLocaleString('en-US', { timeZone: 'US/Central' });
                if ($scope.PatientInfo.PatientFirstName && $scope.PatientInfo.PatientFirstName.length > 0 && $scope.PatientInfo.PatientLastName && $scope.PatientInfo.PatientLastName.length > 0) {
                    $scope.PatientInfo.PatientDOB = $scope.formatted_date($scope.PatientDOB.DOB);
                    var patientInfo = angular.copy($scope.PatientInfo);
                    patientInfo.Modality = ($scope.PatientInfo.Modality ? $scope.PatientInfo.Modality.Code : null);
                    patientInfo.LocationID = $scope.PatientInfo.SelectedLocation.LocationID;
                    patientInfo.OrderDate = moment(dos).format("MM-DD-YYYY HH:mm");
                    patientInfo.UserId = $sessionStorage.currentUserData.userId;

                    if ($scope.CPT) {
                        patientInfo.CPT_Code = patientInfo.CPTProcedures;
                        patientInfo.CPT_Description = patientInfo.CPTProcedureDesc;
                    } else {
                        patientInfo.Procedures = patientInfo.CPTProcedures;
                        patientInfo.ProcedureDesc = patientInfo.CPTProcedureDesc;
                    }
                    if ($scope.PatientInfo.ContrastType) {
                        patientInfo.ContrastType = $scope.PatientInfo.ContrastType.Value;
                    }
                    patientInfo.PatientClass = $scope.PatientInfo.SelectedPatientClass ? $scope.PatientInfo.SelectedPatientClass.Value : null;
                    PhysicianWorklistService.SavePatientInfo(patientInfo).then(function (result) {
                        if ($scope.PatientInfo.Comment) {
                            if ($scope.PatientDiscussion) {
                                $scope.PatientDiscussion.Comment = $scope.PatientInfo.Comment;
                            }
                            else {
                                $scope.PatientDiscussion = {
                                    ID: 0,
                                    ReferenceID: $scope.PatientInfo.DicomOrderID,
                                    Comment: $scope.PatientInfo.Comment,
                                    Type: 1,
                                    Record_Created_By: $sessionStorage.currentUserData.userId
                                };
                            }
                            $scope.PatientDiscussion.EventType = EventType;
                            PhysicianWorklistService.SetPatientDiscussionORM($scope.PatientDiscussion).then(function (response) {
                                refreshWorklistAggrid();
                                //$scope.getData();-- for ag grid
                            }, function (error) {
                                refreshWorklistAggrid();
                                //$scope.getData();-- for ag grid
                            });
                        }
                        if (saveDataFlag) {
                            toaster.success({ body: result });
                            $scope.win_PatientInfo.center().close();
                            //$scope.getData();-- for ag grid
                            refreshWorklistAggrid();
                        }
                    });
                }
                else {
                    toaster.warning({ body: "Please enter mandatory fields!" });
                }
            }
        };
        $scope.BtnOrderComplete = function (isFormValid) {
            if (isFormValid) {
                $scope.PatientInfo.OrderStatus = 'C';
                $scope.PatientInfo.EventType = 'TOC';
                if ($scope.PatientDiscussion) {
                    $scope.PatientDiscussion.EventType = 'TOC';
                }
                $scope.SavePatientInfo(isFormValid, 'TOC');
            }
        }
        $scope.BtnSaveOrder = function (isFormValid) {
            if (isFormValid) {
                $scope.PatientInfo.EventType = 'TEO';
                $scope.SavePatientInfo(isFormValid, 'TEO');
            }
        }
        /* Update Patient Information end */

        /* File upload*/
        $scope.getFileDetails = function (e) {

            $scope.files = [];
            $scope.$apply(function () {
                // STORE THE FILE OBJECT IN AN ARRAY.
                for (var i = 0; i < e.files.length; i++) {
                    //alert(e.files[i].type);
                    $scope.files.push(e.files[i]);
                }
                //JS for browse file or files
                angular.element('#file').value = '';
                angular.element('#file').prev('label').text('');
                if (e.files.length == 1) {
                    angular.element('#file').prev('label').append(e.files[0].name);
                }
                else if (e.files.length > 1) {
                    angular.element('#file').prev('label').append(e.files.length + " " + "files");
                }
            });
        };
        // NOW UPLOAD THE FILES.
        $scope.uploadFiles = function () {
            if ($scope.files && $scope.files.length > 0) {
                $scope.isPatientInfoLoading = true;
                //FILL FormData WITH FILE DETAILS.
                var data = new FormData();
                var refId = $scope.SelectedOrder.DicomOrderID;
                data.append("DiacomOrderId", refId);
                data.append("userId", $sessionStorage.currentUserData.userId);
                var cnt = 0;
                for (var i in $scope.files) {
                    if ($scope.files[i].type.match('jpeg')
                        || $scope.files[i].type.match('jpg')
                        || $scope.files[i].type.match('png')
                        || $scope.files[i].type.match('pdf')
                        || $scope.files[i].name.match('doc')
                        || $scope.files[i].name.match('docx')
                        || $scope.files[i].name.match('csv')
                        || $scope.files[i].name.match('xls')
                        || $scope.files[i].name.match('xlsx')
                        || $scope.files[i].name.match('ppt')
                        || $scope.files[i].name.match('pptx')) {
                        data.append("uploadedFile", $scope.files[i]);
                        cnt++;
                    }
                }
                if (cnt === 0) {
                    toaster.warning({ body: "Only pdf, doc, excel, ppt and jpg files are allowed!" });
                    $scope.files = null;
                    angular.element("input[type='file']").val(null);
                    $scope.isPatientInfoLoading = false;
                }
                else {
                    PhysicianWorklistService.uploadFile(data).then(function (result) {
                        toaster.success({ body: result.data });
                        $scope.files = null;
                        angular.element("input[type='file']").val(null);
                        $scope.isPatientInfoLoading = false;
                        if (result.data.match('success')) {
                            //$scope.refresh();
                            $scope.SelectedOrder.FileCount = ($scope.SelectedOrder.FileCount) ? $scope.SelectedOrder.FileCount : 0;
                            $scope.SelectedOrder.FileCount = $scope.SelectedOrder.FileCount + cnt;
                            var idx = _.findIndex(DicomOrderList, function (obj) { return obj.DicomOrderID == $scope.SelectedOrder.DicomOrderID; });
                            if (idx != -1) {
                                DicomOrderList[idx].FileCount = $scope.SelectedOrder.FileCount;

                                var rowToUpdate = gridOptions.api.getRowNode((DicomOrderList[idx].orderRowID).toString());
                                if (rowToUpdate && rowToUpdate.data) {
                                    rowToUpdate.data.FileCount = $scope.SelectedOrder.FileCount;
                                    gridOptions.api.refreshCells({
                                        force: true,
                                        suppressFlash: true,
                                        rowNodes: [rowToUpdate]
                                    });
                                }
                            }
                            //updateOrders();
                        }
                    }, _respError);
                }
                // remove text from file upload input field
                var uploadFileVal = document.getElementById("file");
                var prevFileUploadSiblings = uploadFileVal.previousElementSibling;
                prevFileUploadSiblings.innerHTML = '';
            }
        }
        $scope.cancelPatientInfo = function () {
            $scope.files = [];
            angular.element("input[type='file']").val(null);
            $scope.isPatientInfoVisible = false;
        };
        $scope.$on("deleteFile", function (evt, count) {
            if (count == 0) {
                $scope.showAttachment = false;
                setOrderDiscussionUserGroup().then(function (data) {
                    setOrderDiscussionTooltip();
                    setSelectedUserAssignment(data);
                });
            }
            //$scope.getData();-- for ag grid
            //refreshWorklistAggrid();
            $scope.SelectedOrder.FileCount = count;
            var rowToUpdate = gridOptions.api.getRowNode(($scope.SelectedOrder.orderRowID).toString());
            if (rowToUpdate && rowToUpdate.data) {
                rowToUpdate.data.FileCount = count;
                gridOptions.api.refreshCells({
                    force: true,
                    suppressFlash: true,
                    rowNodes: [rowToUpdate]
                });
            }
        });
        $scope.showFileList = function () {
            $scope.showAttachment = true;
            $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
        }
        $scope.hideFileList = function () {
            $scope.showAttachment = false;
            setOrderDiscussionUserGroup().then(function (data) {
                setOrderDiscussionTooltip();
                setSelectedUserAssignment(data);
            });
        }
        $scope.onSelected = function () {
            //$log.log("onSelected: " + new Date());
        }
        function setModalitytooltipPhysician() {   //Bug 21548: Unable to see the selected Modalities on tooltip of worklist & tech worklist page
            $scope.modalities = '';
            if ($scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) {
                var dollarTimeout = $timeout(function () {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;');
                    $timeout.cancel(dollarTimeout);
                    dollarTimeout = null;
                }, 1);
                $('.anui').addClass("set-modality-height");
                $scope.modalitytooltip = '';
                //var locations = '';
                var objModality = $filter('orderBy')($scope.SelectedList.Modality, 'Code');
                _.each(objModality, function (data) {
                    if ($scope.modalitytooltip.length > 0) {
                        $scope.modalitytooltip = $scope.modalitytooltip + "\n" + data.Code;
                    }
                    else if ($scope.modalitytooltip.length == 0) {
                        $scope.modalitytooltip = data.Code;
                    }
                    if ($scope.modalities.length > 0) { $scope.modalities = $scope.modalities + "," + data.Code; }
                    else { $scope.modalities = data.Code; }
                });
                //$('#Location').attr('title', locations);
            }
            else {
                $('.anui').removeClass("set-modality-height");
                var dollarTimeout = $timeout(function () {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;');
                    $timeout.cancel(dollarTimeout);
                    dollarTimeout = null;
                }, 1);
                $scope.modalitytooltip = 'Select Modalities';
                //$('#Location').attr('title', locations);
            }
        }
        $scope.clearSelModaValue = function () {
            $scope.SelectedList.Modality = [];
            $scope.DataObject.ModalityDropdownDataFilter.SelectedValue = {
                list: [],
            };
            $scope.modalitytooltip = 'Select Modalities';
            $('.anui').removeClass("set-modality-height");
            //$('.anui').removeClass("set-location-height");
        }
        /**
         * Added By:    Tejas Parikh
         * Task:        Bug 21548: Unable to see the selected Modalities on tooltip of worklist & tech worklist page
         * */
        $scope.onSelectedModalityPhysician = function (selectedData) {
            $scope.SelectedList.Modality = selectedData;
            setModalitytooltipPhysician();
        }
        $scope.OpenSignReport = function (Order) {
            //selectRow();
            if (LastOpenOrder) {
                windowHandler.CloseWindow(["CI-VIEWER-1-" + LastOpenOrder.Accession.toUpperCase().trim(),
                "CI-VIEWER-2-" + LastOpenOrder.Accession.toUpperCase().trim(),
                'KONICA-' + LastOpenOrder.Accession.toUpperCase().trim(),
                'KONICATEST-' + LastOpenOrder.Accession.toUpperCase().trim(),
                'MedDreamViewer-' + LastOpenOrder.Accession.toUpperCase().trim(),
                'NORTHSTARKONICA-' + LastOpenOrder.Accession.toUpperCase().trim()]);
            }
            if (Order.IsImageViewableForTech) {
                LastOpenOrder = Order;
                if ($scope.browser != null && $scope.browser.toUpperCase() != "IE") {
                    //$scope.OpenVR(OrderList[index]);
                    $scope.openKonica(Order);
                    return;
                } else {
                    $scope.OpenSynapseStudy(Order, "KONICATEST", false);
                }
            }
        };

        $scope.openKonica = function (order) {
            $scope.konica_RadFlow = windowHandler.openByPreference(__env._environment.config.konicaBaseURL.replace("@MRN", order.PatientMRN).replace("@ACCESSION", order.Accession).replace("@SITE", order.Site), "KONICATEST", 100, "KONICATEST-" + order.Accession, "noreferrer");
        }
        $scope.OpenSynapseStudy = function (Order, OptionalDV, isOpenPS) {
            //$log.log("OpenSynapseStudy");

            $scope.GetDicomViewerCredentialsCallFrom = "OPENSYNAPSESTUDY";
            $scope.OpenSynapseStudyOrder = Order;
            $scope.OpenSynapseStudyOptionalDV = OptionalDV;
            $scope.OpenSynapseStudyisOpenPS = isOpenPS;
            $q.all([
                GetDicomViewerCredentials(Order.SiteID, OptionalDV)
            ]).then(function (data) {

                if (data != null && data[0] != null) {
                    if (data[0].ShowModal) { return; }
                    //else if (data[0].RequiredCredentials) {
                    else {
                        Order.DicomViewerCredentials = data[0].Credentials;
                        if (__env.showLoaderonPSNViewerLoad) {
                            $scope.isLoadingSynapse = true;
                        }
                        var timeout = setTimeout(function () {
                            OpenSynapseStudy(Order.Site, Order.Accession, Order.PatientMRN, OptionalDV, isOpenPS, Order.DicomViewerCredentials, Order.PSSiteName);
                            $scope.isLoadingSynapse = false;
                            clearTimeout(timeout);
                            timeout = null;
                        }, 500);
                    }
                }
            });
        };
        function OpenSynapseStudy(SiteName, Accession, PatientMRN, Viewer, isOpenPS, ViewerCrendetials, PSSiteName) {
            //$log.log("OpenSynapseStudy");
            if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                // Change Default Dicom Viewer to Agfa is it is inatalled.  
                if ($sessionStorage.AgfaSetup == true && SiteName.toUpperCase().replace(" ", "") == "MHSRICHARDSON") {
                    Viewer = "AGFA";
                }

                if (Viewer == null || Viewer.length == 0 || Viewer == "SYNAPSE") {
                    try {
                        var oSynapseAPI = new ActiveXObject("Synapse.SynapseAPI");
                        var sStudyPath = oSynapseAPI.MakePath(1, Accession);
                        //oSynapseAPI.OpenSynapseExplorer("Synapse", "https://pacs.texasradiology.com", sStudyPath);
                        oSynapseAPI.OpenSynapseExplorer("Synapse", __env._environment.config.synapse, sStudyPath);

                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Synapse." });
                    }
                }
                else if (Viewer == "CANDELIS") {
                    try {
                        //window.open("igplatform://viewer/?request=openstudybyaccession&AccessionNumber=" + Accession, "_self");
                        window.open(__env.candelisURL + encodeURIComponent(Accession), "_self");
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Candelis." });
                    }
                }
                else if (Viewer == "AGFA") {
                    try {
                        //window.open("AgfaHC://impax-client-epr?user=davieric&password=Davieric&domain=Agfa Healthcare&patientid=" + PatientMRN + "&accession=" + Accession, "_self");
                        window.open(__env.agfaURL + encodeURIComponent(PatientMRN.toUpperCase().replace("MHS", "")) + "&accession=" + encodeURIComponent(Accession.toUpperCase().replace("MHS", "")), "_self");
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Agfa." });
                    }
                }
                else if (Viewer == "KONICA" || Viewer == "KONICATEST" || replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                    try {

                        window.open(__env._environment.config.konicaURL.replace("@MRN", encodeURIComponent(PatientMRN)).replace("@ACCESSION", encodeURIComponent(Accession)).replace("@VIEWER", encodeURIComponent(Viewer)), "_self");
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Konica." });
                    }
                }
                else if (Viewer == "GECUV") {
                    try {
                        OpenGECentricity(Accession, ViewerCrendetials);
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Centricity Universal Viewer." });
                    }
                }
                else if (Viewer == "CI-VIEWER") {
                    try {
                        openRequestedPopup(Accession);
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in CI-Viewer." });
                    }
                } else if (Viewer == "MedDream") {
                    openMedDream(Accession);
                }

                //Open Report in PS
                var timeout = setTimeout(function () {
                    if (isOpenPS) {
                        try {
                            //Synchronize accession with PowerScribe 360 By Creating XML File
                            if ($sessionStorage.AgfaSetup == true && SiteName.toUpperCase().replace(" ", "") == "MHSRICHARDSON") //(Viewer == "AGFA") {
                            {
                                var accession = Accession.toUpperCase().replace("MHS", "");
                                CreateMHSPS360File(accession);
                                return;
                            }

                            RadWhereCtrl.Start();
                            try {
                                if (RadWhereCtrl.accessionNumbers) {
                                    $scope.CloseFrom = "RADFLOW"; //"RADFLOW" , "PS360"
                                    var r = RadWhereCtrl.CloseReport(false, false);
                                    while (!r) {
                                        r = RadWhereCtrl.CloseReport(false, false);
                                    }
                                }
                            }
                            catch (e) {
                                //swal("Unable to find the order in PS360.");
                                $log.log(e);
                            }
                            //Synchronize accession with PowerScribe 360
                            RadWhereCtrl.OpenReport(PSSiteName, Accession);
                            //RadWhereCtrl.PreviewOrders('', value);

                        } catch (e) {
                            toaster.warning({ body: "Unable to find the order in PS360." });
                            $log.log(e);
                        }
                    }

                    clearTimeout(timeout);
                    timeout = null;
                }, 500);
            }
            else {
                if (Viewer == "CI-VIEWER") {
                    try {
                        openRequestedPopup(Accession);
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Centricity Universal Viewer." });
                    }
                } else if (Viewer == "MedDream") {
                    openMedDream(Accession);
                } else {
                    var param = 'SiteName=' + encodeURIComponent(SiteName) + '%26Accession=' + encodeURIComponent(Accession);
                    window.open("RadFlowIE:" + __env._environment.config.domain + "OpenSynapse.html#?" + param, "_self");
                }


            }
        }
        function GetDicomViewerCredentials(SiteID, ViewerName) {
            //$log.log("GetDicomViewerCredentials");
            $scope.DVCred = {};
            var d = $q.defer();
            var out = {};
            var objFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: SiteID,
                ViewerName: ViewerName
            };
            if (__env.CheckDicomViewerCredentials.split(',').indexOf(ViewerName) !== -1) {
                out.RequiredCredentials = true;
                WorklistService.GetDicomViewerCredentials(objFilter).then(function (result) {
                    if (result != null && result.length > 0) {
                        out.RequiredCredentials = true;
                        out.ShowModal = false;
                        out.Credentials = {};
                        out.Credentials.UserName = result[0].UserName;
                        out.Credentials.Password = result[0].Password;
                        d.resolve(out);
                    }
                    else {
                        out.ShowModal = true;
                        $scope.DVCred.SiteID = SiteID;
                        $scope.DVCred.ViewerName = ViewerName;
                        $('#ModalDicomViewerCredentials').modal('show');
                        d.resolve(out);
                    }
                });
            }
            else {
                out.RequiredCredentials = false;
                out.ShowModal = false;
                d.resolve(out);
            }
            return d.promise;
        }
        $scope.CollapsePhysicianFilter = function () {
            $scope.isDisabled = true;
            var timeout = setTimeout(function () {
                $scope.isDisabled = false;
                clearTimeout(timeout);
                timeout = null;
            }, 200);
            //$('#collapseWorklist').slideToggle();
            $('#collapsePhysicianWorklist').toggleClass("in");
            $scope.isfilterCollapse = !$scope.isfilterCollapse;
            if ($scope.isfilterCollapse) {
                if ($scope.SelectedList.Location && $scope.SelectedList.Location.length > 0) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height .5s !important;');
                    $(".anui").addClass("update-vw-height");
                    $('.anui').removeClass("set-location-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height .5s !important;');
                    $(".anui").addClass("update-vw-height");
                }
                //$scope.mainGridOptions.height = $window.innerHeight - 190;
                if ($scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 0.5s !important;');
                    $(".anui").addClass("update-vw-height");
                    $('.anui').removeClass("set-modality-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 0.5s !important;');
                    $(".anui").addClass("update-vw-height");
                }

            } else {
                if ($scope.SelectedList.Location && $scope.SelectedList.Location.length > 0) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                    $('.anui').addClass("set-location-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                }
                if ($scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                    $('.anui').addClass("set-modality-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                }
                //$scope.mainGridOptions.height = $window.innerHeight - 101;
            }

        }

        //Window resizing
        $(window).resize(function () {
            if ($state.current.url != "/physician-worklist") {
                return;
            }
            adjustPhysicianSize();
            adjustWindow();
            setHalfScale();
            setHeight();

            if (previousHeight != currentHeight) {
                updatePageSize();
                refreshWorklistAggrid();
                //$scope.getData();-- for ag grid

                previousHeight = currentHeight;
            }

            updateWindowHeight();

        });
        function setHalfScale() {
            $scope.halfScale = false;
            if ($(window).width() < 1199) {
                $scope.halfScale = true;
            }
        }

        //adjusting pop up on half scale
        function adjustPhysicianSize() {
            if ($scope.currentWindow == 'win_Discussion') {
                $scope.win_Discussion.center();
            } else if ($scope.currentWindow == "win_PatientInfo") {
                $scope.win_PatientInfo.center();
            } else if ($scope.currentWindow == "win_ViewReport") {

                $scope.win_ViewReport.center();
            } else if ($scope.currentWindow == "win_DCMViewer") {
                $scope.win_DCMViewer.center();
            }
            else if ($scope.currentWindow == "win_consultExamsWindow") {
                $scope.win_consultExamsWindow.center();
            }
            else if ($scope.currentWindow == "win_addendum_request") {
                $scope.win_addendum_request.center();
            }
            else if ($scope.currentWindow == "win_ComparisonOrderReports") {
                $scope.win_ComparisonOrderReports.center();
            }
            return true;
        }

        function adjustWindow() {
            if ($scope.currentWindow == "win_PatientInfo") {
                if ($(window).width() < 1199) {
                    $scope.winPatientInfoPhyWidth = "96%";
                } else {
                    $scope.winPatientInfoPhyWidth = "80%";
                }
                $scope.win_PatientInfo.setOptions({ width: $scope.winPatientInfoPhyWidth });
                $scope.win_PatientInfo.center();
            } else if ($scope.currentWindow == "win_ViewReport") {
                $scope.DataObject.defaultWindowWidth = halfScale ? "96%" : "70%";
                $scope.win_ViewReport.setOptions({ width: $scope.DataObject.defaultWindowWidth });
                $scope.win_ViewReport.center();

            }
            else if ($scope.currentWindow === 'win_consultExamsWindow') {
                $scope.DataObject.defaultWindowWidth = halfScale ? "96%" : "70%";
                $scope.win_consultExamsWindow.setOptions({ width: $scope.DataObject.defaultWindowWidth });
                $scope.win_consultExamsWindow.center();
            }
            else if ($scope.currentWindow === 'win_addendum_request') {
                $scope.DataObject.defaultWindowWidth = halfScale ? "96%" : "70%";
                $scope.win_addendum_request.setOptions({ width: $scope.DataObject.defaultWindowWidth });
                $scope.win_addendum_request.center();
            }
            else if ($scope.currentWindow === 'win_peer_review') {
                $scope.DataObject.defaultWindowWidth = halfScale ? "96%" : "70%";
                $scope.win_peer_review.setOptions({ width: $scope.DataObject.defaultWindowWidth });
                $scope.win_peer_review.center();
            } else if ($scope.currentWindow === 'win_query_retrive') {
                if ($(window).width() < 1199) {
                    $scope.winPeerReviewWidth = "80%";
                } else {
                    $scope.winPeerReviewWidth = "60%";
                }
                $scope.win_query_retrive.setOptions({ width: $scope.winPeerReviewWidth });
                $scope.win_query_retrive.center();
            }

            return true;
        }

        $scope.SaveGridSetting = function () {
            //$log.log("SaveGridSetting");
            $scope.columns = [];
            var obj = {};
            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorkList', ColumnName: 'Location', Value: $scope.IsLocationShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'FormattedOrderDate', Value: $scope.IsDOSShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'PatientName', Value: $scope.IsPatientNameShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'PatientAge', Value: $scope.IsPatientAgeShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'PatientClass', Value: $scope.IsTypeNameShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'Modality', Value: $scope.IsModalityShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'ProcedureDesc', Value: $scope.IsProcedureShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'OrderingPhysician', Value: $scope.IsOrderingPhysicianShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'Accession', Value: $scope.IsAccessionShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'PatientMRN', Value: $scope.IsMRNShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'IsSTAT', Value: $scope.IsSTATShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'ImageInstance', Value: $scope.IsImageInstanceShow };
            $scope.columns.push(obj);

            if ($scope.columns.length > 0) {
                PhysicianWorklistService.SaveGridSetting($scope.columns).then(function (result) {
                });
            }
            else {
                toaster.warning({ body: "Please select atleast one column." });
            }

        };

        $scope.winOpen = function (e) {
            adjustPhysicianSize();
        }

        //Repot pop up resize
        $scope.winDragend = function (e) {
            adjustPhysicianSize();
        }
        $scope.winResize = function (e) {
            adjustPhysicianSize();
        }

        $scope.winDiscussionPhyResize = function () {
            adjustPhysicianSize();
        }
        $scope.winDiscussionPhyDragend = function () {
            adjustPhysicianSize();
        }
        $scope.winPatientInfoPhyResize = function () {
            adjustPhysicianSize();
        }
        $scope.winPatientInfoPhyDragand = function () {
            adjustPhysicianSize();
        }
        $scope.winViewReportPhyResize = function () {
            adjustPhysicianSize();
        }
        $scope.winViewReportPhyDragand = function () {
            adjustPhysicianSize();
        }

        //resetting the column width on resizing o half scale

        $scope.selectTechnique = function () {
            $scope.CancelTechnique();
            $scope.win_ViewTechnique.center().open();
            $scope.currentWindow = 'win_ViewTechnique';
            $scope.win_ViewTechnique.wrapper.prev(".k-overlay").addClass("custom-overlay");
            bindTechnique();
            $scope.addTechnique = false;
        }

        function bindTechnique() {
            $scope.TechniqueList = [];
            //$scope.SelectedOrder.LocationID;
            PhysicianWorklistService.GetTechniqueByLocationID($scope.SelectedOrder.LocationID).then(function (result) {
                $scope.TechniqueList = result;
                $scope.tableParams = new NgTableParams({ page: 1, count: 10 }, { counts: [], dataset: $scope.TechniqueList });
            });
        }
        $scope.AddTechnique = function () {
            $scope.TechniqueKey = '';
            $scope.TechniqueValue = '';
            $scope.addTechnique = true;
            $scope.win_AddTechnique.center().open();
            $scope.win_ViewTechnique.close();
        }
        $scope.addNewTechnique = function () {
            $scope.TechniqueKey = '';
            $scope.TechniqueValue = $scope.PatientInfo.TechniqueValue;
            $scope.addTechnique = true;
            $scope.win_AddTechnique.center().open();
            //$scope.win_ViewTechnique.center();
        }
        $scope.SubmitTechnique = function (evt, TechniqueKey, TechniqueValue) {
            $scope.TechniqueKey = TechniqueKey;
            $scope.TechniqueValue = TechniqueValue;
            var formData = {
                LocationId: $scope.SelectedOrder.LocationID,
                TechniqueKey: $scope.TechniqueKey,
                TechniqueValue: $scope.TechniqueValue,
                UserId: $sessionStorage.currentUserData.userId
            }
            PhysicianWorklistService.SubmitTechnique(formData).then(function (result) {
                $scope.CancelTechnique();
                $scope.PatientInfo.TechniqueValue = TechniqueValue;
                $scope.win_ViewTechnique.close();
                $scope.win_AddTechnique.close();
            });
        }
        $scope.CancelTechnique = function () {
            $scope.addTechnique = false;
            $scope.win_AddTechnique.close();
        }
        $scope.SelectTechniqueValue = function (val) {
            $scope.PatientInfo.TechniqueValue = val;
            $scope.win_ViewTechnique.close();
        }
        function getOrderDiscussionOptions() {
            $scope.OrderDiscussionOptions = {
                template: kendo.template($("#dropdowntree-orderdiscussion-template").html()),
                placeholder: 'Select User / Group',
                checkboxes: {
                    checkChildren: true
                },
                autoClose: false,
                dataSource: $scope.RadiologistsGroups,
                dataTextField: "UserName",
                dataValueField: "Id",
                height: "auto",
                loadOnDemand: false,
                headerTemplate: '<span class="k-list-filter"><input class="k-textbox" role="listbox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-disabled="false" id="ddstOrderDiscussion" autocomplete="off"/><span class="k-icon k-i-zoom"></span></span>',
                filtering: function (e) {
                    //get filter descriptor
                    var filter = e.filter;
                    // handle the event
                },
                open: function (e) {
                    $("#ddstOrderDiscussion").change(refreshTreeOrderDiscussion).keyup(refreshTreeOrderDiscussion);
                    var timeout = setTimeout(function () {
                        $("#ddstOrderDiscussion").focus();
                        clearTimeout(timeout);
                        timeout = null;
                    }, 1500);

                    $("#ddstOrderDiscussion").val('');
                    var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
                    if (drtr) {
                        var tree = drtr.treeview;
                        var dataSource = drtr.dataSource;
                        dataSource.filter({});
                        var timeout = setTimeout(function () {
                            tree.collapse(".k-item");
                            clearTimeout(timeout);
                            timeout = null;
                        }, 1000);
                    }


                },
                change: function (e) {
                    $scope.AssignStudyVisible = false;
                    var nodes = e.sender.dataSource.view();

                    var checkedNodes = e.sender.value();
                    var values = checkedNodeValues(nodes, checkedNodes);
                    var rValues = _.omitBy(values, _.isNil);
                    var selectedUsers = [];
                    $scope.OrderDiscussion.SelectedUsers = [];

                    /*
                    --IsUserWithSpecialityGroup = 0 / 1 / 2
                    --0: User does not exists in the group(selected only group) when study assigned
                    --1: User exists in the group and also selected individual users when study assigned
                    --2: selected individual users when study assigned
                    --3: selected user to be exists into multiple speciality
                    */
                    $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                    _.each(rValues, function (obj) {
                        var selectedRadiologistGroups = _.find($scope.RadiologistsGroups, function (dobj) { return dobj.Id == obj });
                        if (selectedRadiologistGroups) {
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup.push(selectedRadiologistGroups);
                        }

                    });

                    $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();


                    //$log.log($scope.OrderDiscussion.SelectedUsers);
                    setOrderDiscussionTooltip();
                    if ($scope.OrderDiscussion.SelectedUsers && $scope.OrderDiscussion.SelectedUsers.length > 0) {
                        $scope.AssignStudyVisible = true;
                    }



                },
            };
        }

        function refreshTreeOrderDiscussion() {
            var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            var tree = drtr.treeview;
            var dataSource = drtr.dataSource;
            var value = $("#ddstOrderDiscussion").val();
            if (value !== "") {
                dataSource.filter({
                    field: "UserName", //if I would use "ChildrenText" here nothing be displayed at all if filtertext is set
                    operator: "contains",
                    value: $("#ddstOrderDiscussion").val()
                });

                //filtering child node
                if (dataSource.view().length > 0) {
                    for (var i = 0; i < dataSource.view().length; i++) {
                        if (dataSource.view()[i].hasChildren) {
                            dataSource.view()[i].children.filter({
                                field: "UserName",
                                operator: "neq",
                                value: true
                            })
                        }
                    }
                }

                var timeout = setTimeout(function () {
                    tree.expand(".k-item");
                    clearTimeout(timeout);
                    timeout = null;
                }, 200);
            } else {
                dataSource.filter({});

                var timeout = setTimeout(function () {
                    tree.collapse(".k-item");
                    clearTimeout(timeout);
                    timeout = null;
                }, 200);
            }
            angular.element(document).ready(function () {
                angular.element('.k-item').mouseenter(function () {
                    if (tree) {
                        tree.focus();
                    }
                });

            });
        }

        function setOrderDiscussionUserGroup() {
            //$log.log("setOrderDiscussionUserGroup");
            var d = $q.defer();
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedRadioLogistsGroup) {
                var usergroups = _.map($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (radiologistGroup) {
                    return radiologistGroup.Id;
                });


                d.resolve(usergroups);
            } else {
                d.resolve();
            }
            return d.promise;
        }

        function setOrderDiscussionTooltip() {
            //$log.log("setOrderDiscussionTooltip");
            $scope.orderDiscussionTooltip = '';
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedRadioLogistsGroup && $scope.OrderDiscussion.SelectedRadioLogistsGroup.length > 0) {


                _.each($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (obj) {
                    if (obj && obj.Group && obj.Group == "YES") {
                        $scope.orderDiscussionTooltip += obj.UserName + "\n";
                    } else {
                        var selectedUserIndex = _.findIndex($scope.OrderDiscussion.SelectedUsers, { 'Id': obj.Id });
                        if (selectedUserIndex != -1) {
                            if ($scope.OrderDiscussion.SelectedUsers[selectedUserIndex].IsUserWithSpecialityGroup == 2) {
                                var assignmentLabel = _assignmentName(obj.Id, obj.UserName);
                                if (assignmentLabel) {
                                    $scope.orderDiscussionTooltip += assignmentLabel + "\n";
                                }
                            }
                        }
                    }
                });
            }
            angular.element(document).ready(function () {
                angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "hidden");
                if ($scope.orderDiscussionTooltip.length > 0) {
                    angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "visible");
                }

            });
        }

        $scope.OrdersTechForm = {};
        $scope.LoadTechForm = function (order) {
            $scope.OrdersTechForm = {
                TechFormID: order.TechFormID,
                OrdersTechFormID: order.OrdersTechFormID,
                OrderID: order.OrderID,
                CreatedBy: $sessionStorage.currentUserData.userId,
                Type: 'HTML'
            }
            //$scope.OrdersTechForm.TechFormID = 3;
            $scope.win_TechForm.open();
            var timeout = setTimeout(function () {
                $scope.win_TechForm.center();
                clearTimeout(timeout);
                timeout = null;
            }, 1000);
            if ($scope.OrdersTechForm.OrdersTechFormID > 0) {
                PhysicianWorklistService.GetOrdersTechForm($scope.OrdersTechForm).then(function (result) {
                    $scope.OrdersTechForm.FormText = result.FormText;
                    $scope.OrdersTechForm.FormData = result.FormData;
                    openTechForm($scope.OrdersTechForm.FormText);
                    write(document.getElementById('divTechForm'), JSON.parse($scope.OrdersTechForm.FormData));
                });
            } else {
                $scope.ReloadTechForm();
            }


        }
        function openTechForm(JsonValue) {
            var iframe = document.getElementById('tempid');
            iframe.contentDocument.documentElement.innerHTML = DOMPurify.sanitize(JsonValue);
            document.getElementById('divTechForm').innerHTML = DOMPurify.sanitize(iframe.contentDocument.documentElement.getElementsByTagName('body')[0].innerHTML);
        }

        $scope.SetOrdersTechForm = function () {
            $scope.OrdersTechForm.FormText = document.getElementById('divTechForm').innerHTML;
            $scope.OrdersTechForm.FormData = JSON.stringify(read(document.getElementById('divTechForm')));
            PhysicianWorklistService.SetOrdersTechForm($scope.OrdersTechForm).then(function (result) {
                $scope.CloseTechForm();
                //$scope.getData();-- for ag grid
            }, function (err) {
            });
        }
        $scope.CloseTechForm = function () {
            $scope.win_TechForm.close();
        }
        $scope.ReloadTechForm = function () {
            PhysicianWorklistService.GetTechForm({ TechFormID: $scope.OrdersTechForm.TechFormID }).then(function (result) {
                $scope.OrdersTechForm.FormText = result[0].JsonValue;
                openTechForm($scope.OrdersTechForm.FormText);

            }, function (err) {
            });
        }
        function read(node) {
            var jObj = {};
            _.each(node.getElementsByTagName('*'), function (n) {
                //$log.log(n);
                switch (n.nodeName) {
                    case 'SELECT':
                    case 'TEXTAREA':
                        jObj[n.name] = n.value;
                        break;
                    case 'INPUT':
                        if (n.type == 'text') {
                            jObj[n.name] = n.value;
                        }
                        if (n.type == 'checkbox' || n.type == 'radio') {
                            if (n.checked) {
                                jObj[n.name] = 'true';
                            } else {
                                jObj[n.name] = 'false';
                            }
                        }
                        break;
                }
            });
            return jObj;
        }
        function write(node, jObj) {
            _.each(node.getElementsByTagName('*'), function (n) {
                //$log.log(n);
                if (jObj[n.name]) {
                    switch (n.nodeName) {
                        case 'SELECT':
                        case 'TEXTAREA':
                            n.value = jObj[n.name];
                            break;
                        case 'INPUT':
                            if (n.type == 'text') {
                                n.value = jObj[n.name];
                            }
                            if (n.type == 'checkbox' || n.type == 'radio') {
                                if (jObj[n.name] == 'true') {
                                    n.checked = true;
                                } else {
                                    n.checked = false;
                                }
                            }
                            break;
                    }
                }
            });
        }


        function GetUserLayoutPreferences() {
            var d = $q.defer();
            UserLayoutPrefService.GetUserLayoutPreferences({
                UserID: $sessionStorage.currentUserData.userId,
                PageId: $state.current.name + "." + $state.current.controller,
                ControlId: "Tech_WorkList_ListGrid"
            }).then(function (res) {
                if (res && res.LayoutOptions) {
                    var savedLayout = JSON.parse(res.LayoutOptions);
                    if (savedLayout.savedState) {
                        UserLayoutOption = savedLayout;
                        worklistSavedState = UserLayoutOption.savedState;
                    } else {
                        UserLayoutOption.savedState = savedLayout
                        worklistSavedState = savedLayout;
                    }
                }
                d.resolve();
            });
            return d.promise;
        }

        function updateUserLayoutPreference() {
            //coldefs.AutoRefresh = $scope.AutoRefresh;

            var d = $q.defer();

            var currentState = gridOptions.columnApi.getColumnState();
            var equalObject = _.isEqual(worklistSavedState, currentState);

            if (gridOptions && gridOptions.api && currentState) {
                gridOptions.api.forEachDetailGridInfo(function (detailGridApi) {
                    detailGridApi.columnApi.applyColumnState({ state: currentState, applyOrder: true });
                });
            }

            if (!equalObject) {
                worklistSavedState = currentState;
                UserLayoutOption.savedState = worklistSavedState;

                UserLayoutPrefService.SetUserLayoutPreferences({
                    UserID: $sessionStorage.currentUserData.userId,
                    PageId: $state.current.name + "." + $state.current.controller,
                    ControlId: 'Tech_WorkList_ListGrid',
                    LayoutOptions: JSON.stringify(UserLayoutOption),
                    Username: $sessionStorage.currentUserData.userName
                }).then(function () {
                    d.resolve();
                }, function (err) { d.reject(); });
            }
            else {
                d.resolve();
            }
            return d.promise;
        }
        function updateuserguidephysicianpreference() {
            //$log.log("updateUserPreference > on: ", new Date());

            UserPreferenceService.AddEditUserPreferences([{
                UserPreferenceID: (showUserGuidePhysician && showUserGuidePhysician.UserPreferenceID) ? showUserGuidePhysician.UserPreferenceID : "-1",
                PreferenceType: "ShowUserGuidePhysician",
                UserID: $sessionStorage.currentUserData.userId,
                PreferenceValue: "0",
            }]);
        }


        function getDicomOrders(flag) {
            var d = $q.defer();

            hideShowColCoditionWise();
            //previouslySelectedFilter = {};
            $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            if ($scope.OrderDateType && $scope.OrderDateType.match('All')) {
                $scope.OrderDate = {
                    startDate: null,
                    endDate: null
                };
            }


            //if (previouslySelectedFilter &&
            //    ((previouslySelectedFilter.LocationID != $scope.orderListFilter.LocationID)
            //        || (previouslySelectedFilter.Accession != $scope.orderListFilter.Accession)
            //        || (previouslySelectedFilter.Modality != $scope.orderListFilter.Modality)
            //        || (previouslySelectedFilter.OrderDateStartDate != $scope.orderListFilter.OrderDateStartDate)
            //        || (previouslySelectedFilter.OrderDateEndDate != $scope.orderListFilter.OrderDateEndDate)
            //        || (previouslySelectedFilter.PatientName != $scope.orderListFilter.PatientName)
            //        || (previouslySelectedFilter.PatientMRN != $scope.orderListFilter.PatientMRN)
            //        || (previouslySelectedFilter.PatientDOB != $scope.orderListFilter.PatientDOB)
            //        || (previouslySelectedFilter.PatientClass != $scope.orderListFilter.PatientClass)
            //        || (previouslySelectedFilter.OrderingPhysician != $scope.orderListFilter.OrderingPhysician)
            //        || (previouslySelectedFilter.Status != $scope.orderListFilter.Status)
            //        || (previouslySelectedFilter.ImagePendingStatus != $scope.orderListFilter.ImagePendingStatus))) {
            //    $scope.orderListFilter.PageNum = 1;
            //    mOrderList = [];
            //    $scope.orderList = [];
            //    $scope.PageNo = 1;
            //}

            //previouslySelectedFilter = $scope.orderListFilter;

            orderListFilter.SortingByMultiColumn = sortingString;
            orderListFilter.PageNum = Math.ceil(PageNo);
            orderListFilter.PageSize = Math.ceil(PageSize);
            if (orderListFilter.PageNum === 0) { orderListFilter.PageNum = 1; }

            $scope.isorderlistLoading = true;
            PhysicianWorklistService.GetDICOMOrdersList(orderListFilter).then(function (result) {
                updateOrders(result);
                $scope.isorderlistLoading = false;
                if (result != null && result.length > 0) {
                    TotalRows = result[0].TotalRows;
                }
                else {
                    TotalRows = "0";
                }
                if (orderListFilter.PageNum == 1) {
                    DicomOrderList = [];
                }
                _.pullAllBy(DicomOrderList, result, 'DicomOrderID');
                DicomOrderList = _.concat(DicomOrderList, result);
                DicomOrderList = _.uniqBy(DicomOrderList, "DicomOrderID");
                d.resolve(result);
            }, function (err) { d.reject(); });
            return d.promise;
        }
        function resetColumns() {
            delete UserLayoutOption.ReportColVisible;
            delete UserLayoutOption.ResendReportColVisible;
            if (gridOptions && gridOptions.api) {
                var isReportColVisible = ($scope.Status == 'C' || $scope.Status == 'D' || $scope.Status == 'AL' || $scope.Status == 'PA');
                var isResendReportColVisible = ($scope.Status == 'C' || $scope.Status == 'AL');

                _.each(AgGridColumnDefs, function (col) {
                    if (col.field == "Report") {
                        col.hide = !isReportColVisible;
                    }
                    else if (col.field == "ResendReport") {
                        col.hide = !isResendReportColVisible;
                    }
                });

                gridOptions.api.setColumnDefs(AgGridColumnDefs);
                gridOptions.columnApi.resetColumnState();
            }
        }
        function hideShowColCoditionWise() {
            if (gridOptions && gridOptions.api) {
                var isReportColVisible = ($scope.Status == 'C' || $scope.Status == 'D' || $scope.Status == 'AL' || $scope.Status == 'PA');
                var isResendReportColVisible = ($scope.Status == 'C' || $scope.Status == 'AL');

                isReportColVisible = (UserLayoutOption.hasOwnProperty("ReportColVisible")) ? UserLayoutOption.ReportColVisible : isReportColVisible;
                isResendReportColVisible = (UserLayoutOption.hasOwnProperty("ResendReportColVisible")) ? UserLayoutOption.ResendReportColVisible : isResendReportColVisible;

                var currentState = gridOptions.columnApi.getColumnState();
                var idx = _.findIndex(currentState, { colId: 'Report' });
                if (idx != -1) {
                    currentState[idx].hide = !isReportColVisible;
                }
                idx = _.findIndex(currentState, { colId: 'ResendReport' });
                if (idx != -1) {
                    currentState[idx].hide = !isResendReportColVisible;
                }
                gridOptions.columnApi.applyColumnState({ state: currentState, applyOrder: true });
                updateUserLayoutPreference();
            }
        }

        $scope.showPopover = function (dicomOrderID, IsDiscussion) {
            var d = $q.defer();
            $scope.popoverOpened1 = true;
            $scope.popoverDicomOrderID = dicomOrderID;
            if (IsDiscussion) {
                $scope.Discussion = {
                    ReferenceID: dicomOrderID,
                    Type: 1,
                    Comment: '',
                    Record_Created_By: $sessionStorage.currentUserData.userId
                };
                $scope.Discussions = [];
                $q.all([
                    LoadDiscussion($scope.Discussion)
                ]).then(function (data) {
                    if ($scope.Discussions) {
                        var htmlpop = '<div class="popchatui">';
                        _.each($scope.Discussions, function (discussion) {
                            //htmlpop = htmlpop + '<li>' + discussion.Comment + '</li>';
                            htmlpop = htmlpop + '<div>';
                            var displayName = _discussionDisplayName(discussion);
                            if (discussion.Record_Created_By &&
                                discussion.Record_Created_By == $sessionStorage.currentUserData.userId) {
                                htmlpop = htmlpop + '<div class="sendersection">' +
                                    '<div class="sendercomment pos-rel senderborder">' +
                                    (displayName ? '<div class="sendername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline">' + discussion.Comment + '</div>' +
                                    '<div class="senderdate">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, true);
                                htmlpop = htmlpop + '</div></div>';
                            } else {
                                htmlpop = htmlpop + '<div class="receiversection">' +
                                    '<div class="receivercomment pos-rel receiverborder">' +
                                    (displayName ? '<div class="receivername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline word-break-word">' + discussion.Comment + '</div>' +
                                    '<div class="receiverdate">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, false);
                                htmlpop = htmlpop + '</div></div>';
                            }

                            htmlpop = htmlpop + '</div>';
                        });
                        htmlpop = htmlpop + '</div>';
                        d.resolve(htmlpop);
                    }
                });
            }
            return d.promise;
        }

        $scope.hidePopover = function () {
            $scope.popoverOpened1 = false;
            $scope.popoverDicomOrderID = null;
            $scope.Discussions = [];
        }

        function prepareChildDiscussionHTML(discussion, sender) {
            var htmlpop = '';
            if (discussion.Childs && discussion.Childs.length > 0) {
                _.each(discussion.Childs, function (childdiscussion) {
                    var childName = _discussionDisplayName(childdiscussion);
                    if (sender) {
                        htmlpop = htmlpop + '<div class="replaysection mr-15px w-80 pull-left">' +
                            '<div style="background-color: #2F4858 !important;" ' +
                            'class="comment pos-rel border text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    } else {
                        htmlpop = htmlpop + '<div class="replayreceiver mr-15px w-80 pull-right">' +
                            '<div style="background-color: #6c6868 !important;" ' +
                            'class="comment receiverborder pos-rel text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    }
                    htmlpop = htmlpop + prepareChildDiscussionHTML(childdiscussion, sender);
                });
            }
            return htmlpop;
        }

        function openRequestedPopup(accession) {
            if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
            }
            else {
                $scope.CIDICOMViewerWindow = windowHandler.openByPreference(__env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "CI-VIEWER", 1000, "CI-VIEWER", "");
            }

        }

        $scope.keepPopover = function (dicomOrderID) {
            $scope.popoverOpened1 = true;
            $scope.popoverDicomOrderID = dicomOrderID;
        }

        function OrderRefresh() {
            if (OrderRefreshInterval) {
                $interval.cancel(OrderRefreshInterval);
            }
            OrderRefreshInterval = $interval(function () {
                if (!$scope.isTechFormVisible
                    && !$scope.isAddTechniqueVisible
                    && !$scope.isViewTechniqueVisible
                    && !$scope.isViewReportVisible
                    && !$scope.isDiscussionVisible
                    && !$scope.isPatientInfoVisible
                    && !$scope.isHelpOrderVisible) {
                    //getData();-- for ag grid
                    refreshWorklistAggrid();
                }
            }, DefaultAutoRefreshDuration);
        }

        $scope.SaveFilters = function () {
            angular.element('#ModalPhysicianWorkList').modal('show');
        };
        $scope.saveFilterOnly = function () {
            SaveFilterValues();
            angular.element('#ModalPhysicianWorkList').modal('hide');
        }
        function SaveFilterValues() {
            $scope.worklistSaved = true;
            $scope.columns = [];
            var obj = {};

            if ($scope.locations != ',' && $scope.locations != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'LocationID', Value: $scope.locations };
                $scope.columns.push(obj);
            }
            if ($scope.Accession) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'Accession', Value: $scope.Accession };
                $scope.columns.push(obj);
            }
            if ($scope.OrderDate.startDate) {
                $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'OrderDate', Value: ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' + moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType };
                $scope.columns.push(obj);
            }
            if ($scope.modalities != ',' && $scope.modalities != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'ModalityID', Value: $scope.modalities };
                $scope.columns.push(obj);
            }
            if ($scope.PatientName) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'PatientName', Value: $scope.PatientName };
                $scope.columns.push(obj);
            }
            if ($scope.PatientMRN) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'PatientMRN', Value: $scope.PatientMRN };
                $scope.columns.push(obj);
            }
            if ($scope.DOB) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'PatientDOB', Value: $scope.DOB };
                $scope.columns.push(obj);
            }
            if ($scope.SelectedList.PatientClass) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'PatientClass', Value: $scope.SelectedList.PatientClass.Value };
                $scope.columns.push(obj);
            }
            if ($scope.OrderingPhysician) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'OrderingPhysician', Value: $scope.OrderingPhysician };
                $scope.columns.push(obj);
            }
            if ($scope.Status) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'Status', Value: $scope.Status };
                $scope.columns.push(obj);
            }
            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWorklist', ColumnName: 'STATFilter', Value: $scope.STATFilter ? "1" : "0" };
            $scope.columns.push(obj);
            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'PhysicianWork ListColSort', ColumnName: $scope.orderByField, Value: $scope.reverseSort ? "1" : "0" };
            $scope.columns.push(obj);

            if ($scope.columns.length > 0) {
                WorklistService.SaveFilterSetting($scope.columns).then(function (result) {
                    toaster.success({ body: "Filter saved successfully." });
                    //$scope.getData();-- for ag grid
                    $scope.FilterDICOMOrders();
                });
            }
        }
        function getPhysicianPageSetting() {
            var d = $q.defer();
            var Filter = {
                UserId: $sessionStorage.currentUserData.userId,
                PageName: 'PhysicianWorkList'
            };
            WorklistService.GetPageSetting(Filter).then(function (result) {

                var urlParams = new URLSearchParams(window.location.search);
                var Accession = urlParams.get('Accession');
                if (result && !Accession) {
                    //var ColSort = _.find(result, function (item) { return item.PageName == "TechWork ListColSort"; });
                    //if (ColSort != null) {
                    //    $scope.orderByField = ColSort.ColumnName;
                    //    $scope.reverseSort = (ColSort.Value == "1") ? true : false;
                    //    var idx = _.findIndex(result, function (obj) { return obj.PageName == "TechWork ListColSort"; });
                    //    if (idx != -1) {
                    //        result.splice(idx, 1);
                    //    }
                    //}
                    _.each(result, function (data) {
                        switch (data.ColumnName) {
                            case 'LocationID':
                                var locations = [];
                                if (data.Value) {
                                    _.each(data.Value.split(','), function (data) {
                                        if (data) {
                                            var filter = _.find($scope.Locations, function (item) { return item.LocationID == data && item.SiteID != 0; });
                                            if (filter != null) {
                                                locations.push(filter);
                                            }
                                        }
                                    });
                                }
                                $scope.SelectedList.Location = locations;
                                $scope.locations = data.Value; //User Story 19673: Improve Location Filter

                                $scope.SelectedLocations = {
                                    Ids: data.Value,
                                    locations: locations,
                                    divId: "PhysicianWorklistPage"
                                };
                                break;
                            case 'Accession':
                                $scope.Accession = data.Value;
                                break;
                            case 'OrderDate':
                                setOrderDate(data.Value);
                                break;
                            case 'ModalityID':
                                var modalities = [];
                                if (data.Value) {
                                    _.each(data.Value.split(','), function (data) {
                                        if (data) {
                                            var filter = _.find($scope.Modalities, function (item) { return item.Code == data; });
                                            if (filter != null) {
                                                modalities.push(filter);
                                            }
                                        }
                                    });
                                }
                                $scope.SelectedList.Modality = modalities;
                                $scope.DataObject.ModalityDropdownDataFilter.SelectedValue = {
                                    list: modalities,
                                };
                                setModalitytooltipPhysician();
                                break;
                            case 'PatientName':
                                $scope.PatientName = data.Value;
                                break;
                            case 'PatientMRN':
                                $scope.PatientMRN = data.Value;
                                break;
                            case 'PatientDOB':
                                $scope.DOB = new Date(data.Value);
                                break;
                            case 'PatientClass':
                                $scope.SelectedList.PatientClass = _.find($scope.PatientClass, function (item) { return item.Value == data.Value; });
                                break;
                            case 'OrderingPhysician':
                                $scope.OrderingPhysician = data.Value;
                                break;
                            case 'Status':
                                $scope.Status = data.Value;
                                break;
                            case 'STATFilter':
                                $scope.STATFilter = (data.Value == "1") ? true : false;
                                break;
                        }
                    });
                }
                d.resolve();

            }, function (error) {
                d.reject();
            });
            return d.promise;
        }

        function OrderExists(OrderID) {
            var OrderIndex = _.findIndex(DicomOrderList, function (obj) { return obj.OrderID == OrderID });
            return OrderIndex;
        }

        function removeOrderFromList(OrderId) {
            var idx = _.findIndex(DicomOrderList, function (obj) { return obj.OrderID == OrderId; });
            if (idx != -1) {
                removeOrder(idx);
            }
        }

        function removeOrderAccession(Accession) {
            var idx = _.findIndex(DicomOrderList, function (obj) { return obj.Accession == Accession; });
            if (idx != -1) {
                removeOrder(idx);
            }
        }

        function removeOrder(idx) {
            var selectedNode;
            if (gridOptions && gridOptions.api) {
                gridOptions.api.forEachNode(function (node) {
                    if (node.data.OrderID == DicomOrderList[idx].OrderID) {
                        selectedNode = node;
                    }
                })
                removeRowFromGrid(selectedNode);
            }
        }

        function loadPatientData(order) {
            $scope.PatientDOB = {};
            $scope.DicomOrderID = order.DicomOrderID;
            if (order.PatientDOB)
                $scope.PatientDOB.DOB = new Date(order.PatientDOB);
            if ($scope.PatientInfo.PatientGender.length == 1)
                $scope.PatientInfo.PatientGender = $scope.PatientInfo.PatientGender.toUpperCase();
            else
                $scope.PatientInfo.PatientGender = $scope.PatientInfo.PatientGender.substring(0, 1).toUpperCase();

            $scope.PatientInfo.Modality = _.filter($scope.Modalities, function (obj) { return obj.Code === order.Modality; })[0];
            if (order.OrderDate) {
                var OrderDate = ($filter('localDate')(order.OrderDate, false, new Date()));
                $scope.PatientInfo.DOS = new Date(OrderDate);
                $scope.PatientInfo.DOSTime = new Date(OrderDate);
            }
            $scope.LocationBySite = _.filter($scope.Locations, function (obj) { return obj.SiteID === order.SiteID; });
            $scope.PatientInfo.SelectedLocation = _.filter($scope.LocationBySite, function (obj) { return obj.LocationID === order.LocationID; })[0];
            $scope.PatientInfo.OrderingPhysicianSite = _.find($scope.DataObject.MasterData.Sites, { 'SiteID': $scope.PatientInfo.SiteID });
            $scope.GetProvidersList();
            var refIds = [];
            refIds.push(order.DicomOrderID);
            var Discussion = {
                ReferenceID: order.DicomOrderID,
                Type: 1
            };
            PhysicianWorklistService.GetPatientORMDiscussion(Discussion).then(function (response) {
                $scope.PatientDiscussion = null;
                if (response.length > 0) {
                    $scope.PatientInfo.Comment = response[0].Comment;
                    $scope.PatientDiscussion = response[0];
                }
            }, _respError);
            $scope.SiteContrastList = [];
            PhysicianWorklistService.getOrderDetail(order).then(function (response) {
                if (response.OrderContrastValue) {
                    $scope.PatientInfo.ContrastType = response.OrderContrastValue.ContrastType ? _.find($scope.ContrastTypeList, { Value: response.OrderContrastValue.ContrastType }) : null;
                    $scope.PatientInfo.ContrastAmount = response.OrderContrastValue.ContrastAmount ? response.OrderContrastValue.ContrastAmount : null;
                }
                _.each(response.SiteContrastList, function (l) {
                    var t = _.filter($scope.ContrastTypeList, function (cl) { return cl.Key == l.ContrastType })[0];
                    $scope.SiteContrastList.push(t);
                });
                var d = _.filter($scope.SiteContrastList, function (obj) { return obj.Key === ($scope.PatientInfo.ContrastType ? $scope.PatientInfo.ContrastType.Value : $scope.PatientInfo.ContrastType); });
                if (d.length == 0) {
                    var t = _.filter($scope.ContrastTypeList, function (cl) { return cl.Key == ($scope.PatientInfo.ContrastType ? $scope.PatientInfo.ContrastType.Value : $scope.PatientInfo.ContrastType) })[0];
                    $scope.SiteContrastList.push(t);
                }
            }, _respError);

            $scope.PatientInfo.SelectedPatientClass = _.find($scope.PatientClass, function (item) { return item.Value == order.PatientClass; });
            $scope.currentWindow = "win_PatientInfo";
            $scope.win_PatientInfo.open();
            $scope.win_PatientInfo.wrapper.prev(".k-overlay").addClass("custom-overlay");
            var timeout = setTimeout(function () {
                $scope.win_PatientInfo.center();
                clearTimeout(timeout);
                timeout = null;
            }, 1000);
        }

        function getLookUpByType() {
            var d = $q.defer();
            PhysicianWorklistService.GetLookupByType('ContrastType,HiddenTypes,PatientClass,AddendumRequestedReason,StudyPriority,ContactPreferenceType').then(function (result) {
                //$scope.ContrastTypeList = result;
                $scope.ContrastTypeList = _.filter(result, { 'Type': 'ContrastType' });
                $scope.HiddenTypeList = _.sortBy(_.filter(result, { 'Type': 'HiddenTypes' }), ['Key']);
                $scope.HiddenType.obj = $scope.HiddenTypeList[0];
                $scope.PatientClass = _.filter(result, { Type: 'PatientClass' });
                $scope.DataObject.AddendumRequestedReasonList = _.filter(result, { Type: 'AddendumRequestedReason' });
                $scope.DataObject.StudyPriorities = SharedService.mapPriorityToCollection(_.filter(result, { Type: 'StudyPriority' }), false);
                $scope.DataObject.MasterData.ContactPreferenceType = _.filter(result, { Type: 'ContactPreferenceType' });
                d.resolve();
            }, function (err) {
                d.reject();
                console.error(err);
            });
            return d.promise;
        }
        function updatePageSize() {
            var height = $(window).height();
            PageSize = 50;

            if (height < 1000) {
                PageSize = 50;
            } else if (height > 1000) {
                PageSize = 100;
            }
            if (gridOptions && gridOptions.api) {
                gridOptions.api.setCacheBlockSize(PageSize);
            }
        }

        function setHeight() {
            var height = $(window).height();
            currentHeight = height;
        }

        function updateWindowHeight() {
            $scope.defaultWindowHeight = "72.60%";
            var dollarTimeout = $timeout(function () {
                if ($scope.win_Discussion) {
                    $scope.win_Discussion.setOptions({ height: $scope.defaultWindowHeight });
                }
                if ($scope.win_ViewReport) {
                    $scope.win_ViewReport.setOptions({ height: $scope.defaultWindowHeight });
                }
                $timeout.cancel(dollarTimeout);
                dollarTimeout = null;
            }, 100);
        }

        function updateRefreshDOSInterval() {
            var now = new Date();
            $scope.currentDate.setDate(now.getDate() + 1);
            $scope.currentDate.setHours(0, 0, 0, 0);
            refreshDOSInterval = $scope.currentDate.getTime() - now.getTime();
        }

        $scope.openPatientInfo = function () {
            $scope.files = [];
            angular.element("input[type='file']").val(null);
            $scope.isPatientInfoVisible = true;
        };

        $scope.sendInvite = function (emailFlag, phoneFlag) {
            if ((!emailFlag && !phoneFlag) && $scope.PatientInfo) {
                var patientInfo = angular.copy($scope.PatientInfo);

                if (!patientInfo.PatientEmailID) {
                    toaster.warning({ body: "Please enter valid email!" });
                    return;
                }
                if (!patientInfo.PatientPhone) {
                    toaster.warning({ body: "Please enter valid phone number!" });
                    return;
                }
                $scope.SendInvite = true;
                var filter =
                {
                    "dob": patientInfo.PatientDOB,
                    "accessionNumber": patientInfo.Accession,
                    "dos": patientInfo.DOS,
                    "patientFirstname": patientInfo.PatientFirstName,
                    "patientLastname": patientInfo.PatientLastName,
                    "patientEmail": patientInfo.PatientEmailID,
                    "patientPhone": patientInfo.PatientPhone,
                    "location": patientInfo.SelectedLocation.Location,
                }
                var updatedPatientInfo =
                {
                    "DicomOrderId": patientInfo.DicomOrderID,
                    "UserId": $sessionStorage.currentUserData.userId,
                    "PatientPhone": patientInfo.PatientPhone,
                    "PatientEmailID": patientInfo.PatientEmailID
                }
                PhysicianWorklistService.SavePatientContactInfo(updatedPatientInfo).then(function (result) {
                    //$scope.getData();
                    if (result) {
                        PhysicianWorklistService.SendInvite(filter).then(function (result) {
                            if (result) {
                                toaster.success({ body: "Invitation sent!" });
                                $scope.SendInvite = false;
                            }
                        }).catch(function (noCantDo) {
                            toaster.error({ body: "Something went wrong, Please try again later!" });
                            $scope.SendInvite = false;
                        });
                    }
                });
            }
        };

        function getRowTemplateColorCode(order) {
            var colorCode = '';
            switch ($scope.Status) {
                case 'RP':
                    switch (order.Status) {
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : $scope.DelayStatColorCode ? $scope.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasImage && !order.HasORM) {
                                colorCode = '#b2b266';
                            }
                            break;
                    }
                    break;
                case 'AL':
                    switch (order.Status) {
                        case 'X':
                            colorCode = '#BFDED6';
                            break;
                        case 'CO':
                            colorCode = '#B9ADCF';
                            break;
                        case 'C':
                            colorCode = '#75E284';
                            break;
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'H':
                            colorCode = '#FFC99A';
                            break;
                        case 'RC':
                            colorCode = '#79b384';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : $scope.DelayStatColorCode ? $scope.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasORM && order.HasImage) {
                                colorCode = '#FFE69A';
                            } else if (colorCode.length == 0 && !order.HasORM && order.HasImage) {
                                colorCode = '#b2b266';
                            } else if (colorCode.length == 0 && order.HasORM && !order.HasImage) {
                                colorCode = '#f4ba4b';
                            }
                            break;
                        case 'PA':
                            colorCode = '#ffe6ee';
                            break;
                    }
                    if (colorCode.length == 0 && !order.HasORM) {
                        colorCode = '#ff873a';
                    } else if (colorCode.length == 0 && !order.HasImage) {
                        colorCode = '#f4ba4b';
                    }
                    break;
            }
            return colorCode.length > 0 ? colorCode : '#ffffff';
        }

        function openMedDream(Accession) {
            var order = $scope.OpenSynapseStudyOrder;
            var medDreamOrder = {
                OrderID:       order ? order.OrderID : 0,
                PatientMRN:    order ? order.PatientMRN : '',
                SiteID:        order ? order.SiteID : 0,
                Accession:     Accession,
                Modality:      order ? (order.Modality || '') : '',
                ProcedureDesc: order ? (order.ProcedureDesc || '') : ''
            };
            SharedService.openMedDreamCommunicationAPI(medDreamOrder, '');
        }

        $scope.updateSelectedLocation = function () {
            $scope.locations = $scope.SelectedLocations.Ids;
            $scope.SelectedList.Location = $scope.SelectedLocations.locations;
            if ($scope.SelectedList.Location && $scope.SelectedList.Location.length > 0) {
                $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                $(".anui").removeClass("update-vw-height");
                $('.anui').addClass("set-location-height");
            }
            else {
                $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                $(".anui").removeClass("update-vw-height");
                $('.anui').removeClass("set-location-height");
            }
        }

        function setSelectedUserAssignment(usergroups) {
            ////$log.log("setSelectedWorklistFilterSettings: " + new Date());
            var ddt = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            if (ddt) {
                ddt.value(usergroups);
            } else {
                var timeout = $timeout(function () {
                    setSelectedUserAssignment(usergroups);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 100);
            }
        }
        $scope.UpdateAddendumRequestReportStatus = function () {
            var comment = ($scope.DataObject.StudyReReadReason) ? "Re-Read Reason: " + $scope.DataObject.StudyReReadReason.Value + "\n" : "";
            comment = ($scope.AddendumRequest.AddendumComment) ? comment + $scope.AddendumRequest.AddendumComment : comment;
            PhysicianWorklistService.UpdateAddendumRequestReportStatus({
                Order: $scope.SelectedOrder,
                OrderID: $scope.SelectedOrder.OrderID,
                AddendumRequestedBy: $sessionStorage.currentUserData.userId,
                IsHighPriority: $scope.AddendumRequest.isHighPriorityAddendum,
                DicomOrderID: $scope.SelectedOrder.DicomOrderID,
                Comment: comment,
                ReportID: $scope.SelectedOrder.ReportID,
                ToUserID: $scope.AddendumRequest.AssignedUser.Id,
                FromUser: $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName,
                AddendumRequestedFrom: 'Radflow',
                ToUserPhoneNumber: $scope.AddendumRequest.AssignedUser.PhoneNumber,
                AddendumRequestedReason: ($scope.DataObject.StudyReReadReason) ? $scope.DataObject.StudyReReadReason.Value : null
            }).then(function (res) {
                $scope.DataObject.StudyReReadReason = null;
                if ($scope.Status == 'C') {
                    removeOrderFromList($scope.SelectedOrder.OrderID);
                }
                else {
                    //getData();-- for ag grid
                    refreshWorklistAggrid();
                }
                $scope.win_addendum_request.close();
                $scope.onAddendumReqClose();
                $scope.win_ComparisonOrderReports.close();
            }, function (err) {
                $scope.win_addendum_request.close();
                $scope.onAddendumReqClose();
                $scope.win_ComparisonOrderReports.close();
            });
        }
        $scope.onAddendumReqClose = function () {
            $scope.showAddendumReq = false;
            $scope.AddendumRequest.isHighPriorityAddendum = false;
            $scope.AddendumRequest.AddendumComment = null;
            $scope.AddendumRequest.AssignedUser = null;
            $scope.AddendumRequest.AssignedUserTooltip = "Select Radiologist";
        }


        $scope.onAddendumUserSelect = function () {
            if ($scope.AddendumRequest.AssignedUser) {
                $scope.AddendumRequest.AssignedUserTooltip = $scope.radDisplay($scope.AddendumRequest.AssignedUser);
            } else {
                $scope.AddendumRequest.AssignedUserTooltip = "Select Radiologist";
            }
        }

        function prepareOrderDiscussionUsers() {
            var selectedUsers = [];
            _.each($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (selectedRadiologistGroup) {
                if (selectedRadiologistGroup && selectedRadiologistGroup.Group && selectedRadiologistGroup.Group == "YES") {

                    var specialities = _.filter(specialityAssignments, { SpecialityId: selectedRadiologistGroup.Id });
                    _.each(specialities, function (speciality) {
                        var user = _.find($scope.Radiologists, { Id: speciality.UserId });
                        if (user) {
                            user.IsUserWithSpecialityGroup = 0;
                            user.SpecialityCode = speciality.SpecialityCode;
                            user.SpecialityCodeDesc = speciality.SpecialityCodeDesc;
                            user.SpecialityGroup = speciality.SpecialityGroup;
                            user.SpecialityId = speciality.SpecialityId;
                            var selectedUserIndex = _.findIndex(selectedUsers, function (auser) {
                                return auser.Id == user.Id
                                    && auser.IsUserWithSpecialityGroup == 0;
                            });
                            var selectedUserBySpecialityIndex = _.findIndex(selectedUsers, function (auser) {
                                return auser.Id == user.Id
                                    //&& auser.SpecialityId > 0
                                    //    && user.SpecialityId > 0
                                    && auser.SpecialityId != user.SpecialityId;
                            });

                            if (selectedUserIndex != -1 && selectedUserBySpecialityIndex == -1) {
                                selectedUsers[selectedUserIndex].IsUserWithSpecialityGroup = 1;
                                user.IsUserWithSpecialityGroup = 1;
                            } else if (selectedUserBySpecialityIndex != -1) {
                                selectedUsers[selectedUserBySpecialityIndex].IsUserWithSpecialityGroup = 3;
                                user.IsUserWithSpecialityGroup = 3;
                            }
                            selectedUsers.push(_.clone(user));
                        }

                    });

                } else {
                    var user = _.find($scope.Radiologists, function (user) { return user.Id == selectedRadiologistGroup.Id; });
                    if (user) {
                        user.IsUserWithSpecialityGroup = 2;
                        var selectedUserIndex = _.findIndex(selectedUsers, function (auser) {
                            return auser.Id == user.Id
                                && auser.IsUserWithSpecialityGroup == 0;
                        });
                        var selectedUserBySpecialityIndex = _.findIndex(selectedUsers, function (auser) {
                            return auser.Id == user.Id
                                //&& auser.SpecialityId > 0
                                //&& user.SpecialityId > 0
                                && auser.SpecialityId != user.SpecialityId;
                        });
                        if (selectedUserIndex != -1 && selectedUserBySpecialityIndex == -1) {
                            selectedUsers[selectedUserIndex].IsUserWithSpecialityGroup = 1;
                            user.IsUserWithSpecialityGroup = 1;
                        } else if (selectedUserBySpecialityIndex != -1) {
                            selectedUsers[selectedUserBySpecialityIndex].IsUserWithSpecialityGroup = 3;
                            user.IsUserWithSpecialityGroup = 3;
                        }
                        selectedUsers.push(_.clone(user));
                    }

                }
            });
            return selectedUsers;
        }

        $scope.onPeerReviewClose = function () {
            $scope.showPeerReview = false;
            $scope.SelectedOrder = {};
            $scope.PeerReview.Comment = null;
            $scope.PeerReview.AssignedUser = null;
            $scope.PeerReview.AssignedUserTooltip = "Select Radiologist";
        }

        $scope.onPeerReviewUserSelect = function () {
            if ($scope.PeerReview.AssignedUser) {
                $scope.PeerReview.AssignedUserTooltip = $scope.radDisplay($scope.PeerReview.AssignedUser);
            } else {
                $scope.PeerReview.AssignedUserTooltip = "Select Radiologist";
            }
        }

        $scope.AddOrderToSpecificPeer = function () {
            var obj = {
                OrderID: $scope.SelectedOrder.OrderID,
                isPeerReview: '1',
                PeerReviewUserID: $scope.PeerReview.AssignedUser.Id,
                UserID: $sessionStorage.currentUserData.userId,
                DicomOrderID: $scope.SelectedOrder.DicomOrderID,
                Comment: $scope.PeerReview.Comment ? $scope.PeerReview.Comment : null,
            }
            UpdateOrderDetail(obj, PeerReviewToasterMessage);
        }

        function UpdateOrderDetail(obj, message) {
            WorklistService.UpdateOrderDetail(obj).then(function () {
                toaster.success({ body: message });
                $scope.win_peer_review.close();
                $scope.onPeerReviewClose();
            });
        }

        function AddToPeerReview(type, Order) {
            switch (type) {
                case 'Auto Assign':
                    var obj = {
                        OrderID: Order.OrderID,
                        isPeerReview: '1',
                        PeerReviewUserID: 'Auto',
                        UserID: $sessionStorage.currentUserData.userId,
                        DicomOrderID: Order.DicomOrderID,
                    }
                    UpdateOrderDetail(obj, PeerReviewToasterMessage);
                    break;
                case 'Assign to Specific User':
                    $scope.setSelected(Order.OrderID, Order);
                    WorklistService.GetPeerReviewerListByUserID({ UserID: $sessionStorage.currentUserData.userId, isReviewer: true, Modality: Order.Modality, SiteID: Order.SiteID }).then(function (result) {
                        $scope.PeerReviewRadiologists = result;
                        $scope.PeerReviewRadiologists = _.sortBy($scope.PeerReviewRadiologists, ['UserName']);
                        $scope.onPeerReviewUserSelect();
                        $scope.currentWindow = 'win_peer_review';
                        OpenWindow($scope.win_peer_review, 'win_peer_review');
                        $scope.win_peer_review.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    });
                    break;
            }
        }

        //#region Query Retrieve
        $scope.QueryRetrieve = function (Order) {
            var d = $q.defer();
            $scope.ClearQueryRetrieve();
            //open modal
            $scope.setSelected(Order.OrderID, Order);
            $scope.SelectedOrderID = $scope.SelectedOrder.OrderID;
            ManageLocationService.GetSiteApplicationEntity({ SiteID: Order.SiteID }).then(function (result) {
                if (result && result.length > 0) {
                    _.each(result, function (item) {
                        if (!$scope.DataObject.QueryRetrieve[item.AEType]) {
                            $scope.DataObject.QueryRetrieve[item.AEType] = {
                                HostName: item.Host,
                                Port: item.Port,
                                TlsEnabled: item.TLS,
                                AeTitle: item.AETitle
                            };
                        }
                    });
                }
                else {
                    toaster.warning({ body: "Query retrieval is not configured for this site. Please reach out to the site administrator for assistance." });
                    return;
                }

                ManageLocationService.GetSitePrefixSuffix({ SiteID: Order.SiteID }).then(function (res) {
                    var result = null;
                    if (res && res.length > 0) {
                        var result = res[0];
                        $scope.DataObject.QueryRetrieve.PatientMRN = Order.PatientMRN.replace(result.Prefix, "").replace(result.Suffix, "");
                    }
                    else {
                        $scope.DataObject.QueryRetrieve.PatientMRN = Order.PatienstMRN;
                    }
                    $scope.currentWindow = 'win_query_retrive';
                    OpenWindow($scope.win_query_retrive, 'win_query_retrive');
                    $scope.win_query_retrive.wrapper.prev(".k-overlay").addClass("custom-overlay");

                    var Timeout = $timeout(function () {
                        var gridDiv = document.getElementById("myQueryGrid");
                        if (gridDiv && gridDiv != null) {
                            new agGrid.Grid(gridDiv, queryGridOptions);
                        }

                        $scope.QueryRetrieveFilter();
                        $timeout.cancel(Timeout);
                        Timeout = null;
                    }, 100);
                });
            });
            return d.promise;
        }
        $scope.QueryRetrieveFilter = function (SearchFlag) {
            //var d = $q.defer();
            if (queryGridOptions && queryGridOptions.api) {
                queryGridOptions.api.setRowData([]);
            }
            $scope.DataObject.QueryRetrieve.IsExpanded = false;
            $scope.DataObject.QueryRetrieve.IsAllStudySelected = false;
            if (SearchFlag && !(($scope.DataObject.QueryRetrieve.FirstName && $scope.DataObject.QueryRetrieve.FirstName != '') || ($scope.DataObject.QueryRetrieve.LastName && $scope.DataObject.QueryRetrieve.LastName != '') || ($scope.DataObject.QueryRetrieve.PatientMRN && $scope.DataObject.QueryRetrieve.PatientMRN != '') || ($scope.DataObject.QueryRetrieve.Accession && $scope.DataObject.QueryRetrieve.Accession != ''))) {
                toaster.warning({ body: "Please enter atleast one detail to filter" });
                return;
            }
            $scope.DataObject.isLoadingQueryRetrieve = true;
            $scope.DataObject.QueryRetrieve.IsSearchingData = true;

            DCMQRDoFind().then(function (result) {
                if (result && result.patients) {
                    $scope.DataObject.isLoadingQueryRetrieve = false;
                    $scope.DataObject.QueryRetrieve.IsSearchingData = false;
                    if (queryGridOptions && queryGridOptions.api) {
                        queryGridOptions.api.setRowData(result.patients);
                    }
                }
            });
        }
        function DCMQRDoFind() {
            var d = $q.defer();
            var obj = {
                "PatientFirstName": $scope.DataObject.QueryRetrieve.FirstName,
                "PatientLastName": $scope.DataObject.QueryRetrieve.LastName,
                "PatientId": $scope.DataObject.QueryRetrieve.PatientMRN,
                "DOSStartDate": $scope.DataObject.QueryRetrieve.OrderDate ? $scope.DataObject.QueryRetrieve.OrderDate.startDate.format('YYYYMMDD') : "20001001",
                "DOSEndtDate": $scope.DataObject.QueryRetrieve.OrderDate ? $scope.DataObject.QueryRetrieve.OrderDate.endDate.format('YYYYMMDD') : "20241001",
                "Accession": $scope.DataObject.QueryRetrieve.Accession,
                "CalledAE": $scope.DataObject.QueryRetrieve.CalledAE,
                "CallingAE": $scope.DataObject.QueryRetrieve.CallingAE,
                "DestinationAE": $scope.DataObject.QueryRetrieve.DestinationAE,
            };
            WorklistService.DCMQRDoFind(obj).then(function (result) {
                result = result.QRPatientList;
                if (result && result.patients) {
                    _.each(result.patients, function (patient) {
                        var SeriesCount = null, InstanceCount = null;
                        patient.StudyCount = patient.studies.length;
                        _.each(patient.studies, function (study) {
                            if (SeriesCount == null) {
                                SeriesCount = study.series.length;
                            }
                            else {
                                SeriesCount += study.series.length;
                            }
                            study.checkboxDisabled = false;
                            study.SeriesCount = study.series.length;
                            _.each(study.series, function (instance) {
                                if (InstanceCount == null) {
                                    InstanceCount = _.toInteger(instance.Instances);
                                }
                                else {
                                    InstanceCount += _.toInteger(instance.Instances);
                                }
                            });
                        });
                        if (SeriesCount != null) {
                            patient.SeriesCount = SeriesCount;
                        }
                        if (InstanceCount != null) {
                            patient.InstanceCount = InstanceCount;
                        }
                    });
                    $scope.DataObject.isLoadingQueryRetrieve = false;
                    $scope.DataObject.QueryRetrieve.IsSearchingData = false;
                    $scope.DataObject.QueryRetriveObj = result;
                    if (queryGridOptions && queryGridOptions.api) {
                        queryGridOptions.api.setRowData(result.patients);
                    }
                    d.resolve(result);
                }
            }).catch(function (ExceptionData) {
                var error = ExceptionData.data;
                $scope.DataObject.isLoadingQueryRetrieve = false;
                $scope.DataObject.QueryRetrieve.IsSearchingData = false;
                if (error.Message && error.Message != "") {
                    toaster.error({ body: error.Message });
                }
                else {
                    toaster.error({ body: "Something went wrong" });
                }

                d.reject();
            });
            return d.promise;
        }
        var queryGridOptions = {
            columnDefs: [
                {
                    field: 'PatientID', headerName: 'MRN', cellRenderer: 'agGroupCellRenderer', headerClass: 'px-5',
                },
                { field: 'FamilyName', headerName: 'Last Name' },
                { field: 'GivenName', headerName: 'First Name' },
                { field: 'MiddleName' },
                {
                    field: 'DOB', headerName: 'Date of Birth', cellRenderer: function (params) {
                        if (params.data.DOB) {
                            return moment(params.data.DOB).format('MM-DD-YYYY');
                        }
                    }
                },
                {
                    field: 'Gender', cellRenderer: function (params) {
                        return { 'M': 'Male', 'F': 'Female', 'O': 'Other' }[params.data.Gender] || params.data.Gender;
                    }
                },
                { field: 'StudyCount', headerName: 'Study Count' },
                { field: 'SeriesCount', headerName: 'Series Count' },
                { field: 'InstanceCount', headerName: 'Instance Count' },
            ],
            defaultColDef: {
                flex: 1,
            },
            groupDefaultExpanded: 0,
            masterDetail: true,
            detailRowAutoHeight: true,
            detailCellRendererParams: {
                detailGridOptions: {
                    columnDefs: [
                        { field: '', minWidth: 40, maxWidth: 40, checkboxSelection: true, },
                        { field: 'AccessionNumber', headerName: 'Accession', cellRenderer: 'agGroupCellRenderer', headerClass: 'queryAccessionHeaderTxt', },
                        { field: 'StudyDateTime', headerName: 'Date of Service', cellRenderer: function (params) { return $filter('localDate')(params.data.StudyDateTime, false, new Date()) }, },
                        { field: 'StudyDescription' },
                        { field: 'SeriesCount', headerName: 'Series Count' },
                    ],
                    defaultColDef: {
                        flex: 1,
                    },
                    rowClass: 'agrow-bg',
                    rowSelection: 'multiple',
                    onRowSelected: onRowSelected,
                    groupDefaultExpanded: 0,
                    masterDetail: true,
                    //detailRowHeight: 240,
                    detailRowAutoHeight: true,
                    detailCellRendererParams: {
                        detailGridOptions: {
                            columnDefs: [
                                { field: 'SeriesDescription', cellRenderer: 'agGroupCellRenderer', headerClass: 'querySeriesHeaderTxt' },
                                { field: 'SeriesNumber' },
                                { field: 'Modality' },
                                { field: 'Instances' },
                            ],
                            defaultColDef: {
                                flex: 1,
                            },
                            detailRowAutoHeight: true,
                        },
                        getDetailRowData: function (params) {
                            params.successCallback(params.data.series);
                        },
                    },
                    getRowId: function (params) {
                        return params.data.StudyInstanceUid;
                    },
                    getRowStyle: function (params) {
                        return params.node.data.checkboxDisabled ? { 'pointer-events': 'none !important', 'opacity': '0.5 !important' } : null;
                    }
                },
                getDetailRowData: function (params) {
                    params.successCallback(params.data.studies);
                },

            },
            getRowId: function (params) {
                return params.data.PatientID;
            },
        };

        $scope.MoveInstance = function () {
            var MoveStudies = [];
            if ($scope.DataObject.QueryRetrieve.SelectedStudies && $scope.DataObject.QueryRetrieve.SelectedStudies.length > 0) {
                _.each($scope.DataObject.QueryRetrieve.SelectedStudies, function (study) {
                    var obj = {
                        "StudyInstanceUid": study.StudyInstanceUid,
                        "CalledAE": $scope.DataObject.QueryRetrieve.CalledAE,
                        "CallingAE": $scope.DataObject.QueryRetrieve.CallingAE,
                        "DestinationAE": $scope.DataObject.QueryRetrieve.DestinationAE,
                    };
                    MoveStudies.push(obj);
                    if (queryGridOptions && queryGridOptions.api) {
                        queryGridOptions.api.forEachNode(function (node) {
                            var timeout = $timeout(function () {
                                node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                                if (node.detailGridOptions) {
                                    node.detailGridOptions.api.forEachNode(function (childNode) {
                                        if (childNode.data.StudyInstanceUid == study.StudyInstanceUid) {
                                            childNode.setSelected(false);
                                            childNode.data.checkboxDisabled = true;
                                        }
                                    });
                                    node.detailGridOptions.api.redrawRows();
                                    $timeout.cancel(timeout);
                                    timeout = null;
                                }
                            }, 100);
                        });
                    }
                });
                WorklistService.DCMQRDoMove(MoveStudies).then(function (result) {

                });
                toaster.success({ body: "Prior retrieval is in process." });
            }
        }

        function onRowSelected(event) {
            $scope.DataObject.QueryRetrieve.IsRetrieveBtnDisabled = true;
            var selectedRows = [];
            queryGridOptions.api.forEachNode(function (node) {
                if (node.master) {
                    node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                    if (node.detailGridOptions) {
                        var getSelectedRows = node.detailGridOptions.api.getSelectedRows();
                        _.each(getSelectedRows, function (row) {
                            var index = _.findIndex(selectedRows, { 'Accession': row.Accession });
                            if (index == -1) {
                                selectedRows.push(row);
                            }
                        });
                    }
                    if (selectedRows && selectedRows.length > 0) {
                        $scope.DataObject.QueryRetrieve.SelectedStudies = selectedRows;
                        $scope.DataObject.QueryRetrieve.IsRetrieveBtnDisabled = false;
                    }
                }
            });
        }

        $scope.ClearQueryRetrieve = function () {
            $scope.DataObject.QueryRetrieve.Accession = '';
            $scope.DataObject.QueryRetrieve.PatientMRN = '';
            $scope.DataObject.QueryRetrieve.FirstName = '';
            $scope.DataObject.QueryRetrieve.LastName = '';
            $scope.DataObject.QueryRetrieve.OrderDateType = 'Last 3 Years';
            $scope.DataObject.QueryRetrieve.OrderDate = {
                startDate: moment().subtract(3, 'year'),
                endDate: moment()
            };
            if (queryGridOptions && queryGridOptions.api) {
                queryGridOptions.api.setRowData([]);
            }
            $scope.DataObject.QueryRetrieve.IsExpanded = false;
            $scope.DataObject.QueryRetrieve.IsAllStudySelected = false;
        }
        $scope.resetQueryRetrieveDateRange = function () {
            $scope.DataObject.QueryRetrieve.opts.ranges = {
                'Last 6 Months': [moment().subtract(6, 'month'), moment()],
                'Last 1 Year': [moment().subtract(1, 'year'), moment()],
                'Last 3 Years': [moment().subtract(3, 'year'), moment()],
                'Last 5 Years': [moment().subtract(5, 'year'), moment()],
                'Last 10 Years': [moment().subtract(10, 'year'), moment()],
            };
            angular.element(document).ready(function () {
                angular.element('.drp-buttons .cancelBtn').click(function () {
                    angular.element('#daterange3').val('');
                    $scope.DataObject.QueryRetrieve.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                });
            });
            angular.element(document).ready(function () {
                $scope.DataObject.QueryRetrieve.OrderDateType = ($scope.DataObject.QueryRetrieve && $scope.DataObject.QueryRetrieve.OrderDate && $scope.DataObject.QueryRetrieve.OrderDate.label) ? $scope.DataObject.QueryRetrieve.OrderDate.label : $scope.DataObject.QueryRetrieve.OrderDateType;
                if ($scope.DataObject.QueryRetrieve.OrderDate.startDate && $scope.DataObject.QueryRetrieve.OrderDate.endDate) {
                    if ($scope.DataObject.QueryRetrieve.OrderDateType != null && $scope.DataObject.QueryRetrieve.OrderDateType.match('Custom'))
                        $scope.DataObject.QueryRetrieve.OrderDateType = ($scope.DataObject.QueryRetrieve.OrderDateType != null && $scope.DataObject.QueryRetrieve.OrderDateType.match('Custom')) ? ($scope.DataObject.QueryRetrieve.OrderDateType + '#' + moment(new Date($scope.DataObject.QueryRetrieve.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                            moment(new Date($scope.DataObject.QueryRetrieve.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.DataObject.QueryRetrieve.OrderDateType;

                }
                else {
                    $scope.DataObject.QueryRetrieve.OrderDateType = 'Clear';
                }
                setQueryRetrieveOrderDate($scope.DataObject.QueryRetrieve.OrderDateType, $scope.DataObject.QueryRetrieve);
            });
        }

        function setQueryRetrieveOrderDate(val, data) {
            var type = null, startDate = null, endDate = null;
            if (val && val.match('Custom')) {
                type = 'Custom';
                startDate = val.split('#')[1];
                endDate = val.split('#')[2];
            }
            else {
                type = val;
            }
            data.OrderDateType = type;
            switch (type) {
                case 'Last 6 Months':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(6, 'month').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 1 Year':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(1, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 3 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(3, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 5 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(5, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 10 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(10, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Custom':
                    //data.OrderDate = {
                    //    startDate: moment(startDate),
                    //    endDate: moment(endDate)
                    //};
                    data.OrderDate = {
                        startDate: moment(moment(startDate).format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment(endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    data.OrderDateType = 'Custom range';
                    break;
                case 'Clear':
                    data.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                default:
                    data.OrderDate = {
                        startDate: moment(moment().subtract(3, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    data.OrderDateType = 'Last 3 Days';
                    break;
            }

            var timeout = $timeout(function () {
                data.toolTipOrderDate = data.OrderDate.startDate && data.OrderDate.endDate ? 'DOS: ' + data.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + data.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                $timeout.cancel(timeout);
                timeout = null;
            }, 0);
        }

        $scope.ExpandCollapseData = function (expand, allStudies) {
            onRowSelected();
            if (queryGridOptions && queryGridOptions.api) {
                queryGridOptions.api.forEachNode(function (node) {
                    if (node.master && expand) {
                        node.setExpanded(expand);
                        var timeout = $timeout(function () {
                            node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                            if (node.detailGridOptions) {
                                if (!allStudies) {
                                    node.detailGridOptions.api.forEachNode(function (childNode) {
                                        childNode.setExpanded(expand);
                                    });
                                }
                                else {
                                    node.detailGridOptions.api.selectAll();
                                }
                            }
                            $timeout.cancel(timeout);
                            timeout = null;
                        }, 100);
                    }
                    else {
                        if (node.id) {
                            node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                            if (node.detailGridOptions) {
                                node.detailGridOptions.api.forEachNode(function (childNode) {
                                    if (childNode.expanded) {
                                        childNode.setExpanded(expand);
                                    }
                                    if (node.expanded) {
                                        node.setExpanded(expand);
                                    }
                                });
                            }
                        }
                    }
                });
            }
        }
        //#endregion Query Retrieve
        //#region Get Tour Steps
        function GetPhysicianTourSteps() {
            var d = $q.defer();
            CommonService.GetTourSteps('Physician').then(function (result) {
                if (tourPhysician && tourPhysician._options) {
                    tourPhysician._options.steps = result.Steps;
                    d.resolve();
                }
            });
            return d.promise;
        }

        function PhysicianInitTour() {
            GetPhysicianTourSteps().then(function () {
                startUserGuidePhysicianTour();
                HelpPhysicianTour();
            });
        }

        function HelpPhysicianTour() {
            if (TourFlag) {
                tourPhysician.init();
                //var timeout = $timeout(function () {
                tourPhysician.setCurrentStep(0);
                tourPhysician.start(true);
                /*$timeout.cancel(timeout);
                timeout = null;*/
                //}, 2000);
            }
        }
        //#endregion Get Tour Steps

        //#region Ag-Grid
        //#region cell-template
        function userLockIconCellRenderer(params) {
            var template = "";
            if (params.data) {
                var iconCase = setUserIconCase(params.data);
                switch (iconCase) {
                    case 'Lock':
                        template = '<i class="fa fa fa-lock fs-15px txt-clr-14 pt-8px" style="padding-left:6px;" title="' + params.data.LockBy + '"></i>';
                        break;
                    case "Assignment":
                        template = template + '<span title="' + getOrderListTooltip(params.data) + '" class="fa fa-user fs-15px v-a-t d-block py-5px cursor-pointer pt-5px text-center" ' +
                            'tooltip-class="uibtooltipDenial" ';

                        if (params.data.listOrderListAssignment && params.data.listOrderListAssignment.length > 0) {
                            var idx = _.findIndex(params.data.listOrderListAssignment, { OrderAssingedUserID: $sessionStorage.currentUserData.userId });
                            template = (idx != -1) ? template + " style='color:green' " : template + " style='color:gray' ";
                        }
                        else {
                            template = (params.data.OrderAssingedUserID && _.lowerCase(vm.selectedData.LoggedInUserID) == _.lowerCase(params.data.OrderAssingedUserID)) ? template + " style='color:green' " : template + " style='color:gray' ";
                        }
                        template = template + ' ></span>';
                        break;
                }
            }
            return template;
        }
        function setUserIconCase(row) {
            var iconCase = '';
            if (row.IsLock && ($sessionStorage.currentUserData.userId != row.LockByProviderID)) {
                iconCase = 'Lock';
            } else if (row.OrderAssingedUsers > 0) {
                iconCase = 'Assignment';
            } else {
                iconCase = 'empty';
            }
            return iconCase;
        }

        function DOSCellRenderer(params) {
            var OrderDate = ($filter('localDate')(params.data.OrderDate, false, new Date()));
            var color = params.data.RowColorCode;
            var template = "";
            template = '<span style="color:' + color + '" title="' + OrderDate + '">' + OrderDate + '</span>'
            return template;
        }

        function diacomImageCellRenderer(params) {
            var template = '<i class= "fa fa-eye fs-14px pt-4px px-5px cursor-pointer" title="View Images" ></i >';
            return template;
        }

        function viewOrderCellRenderer(params) {
            var template = "";
            if (!params.data.isComparisionOrder) {
                template = '<i class="fa fa-external-link txt-clr-14 fs-14px cursor-pointer pt-4px px-5px" title="View Order"></i>';
            }
            return template;
        }
        function reportCellRenderer(params) {
            var template = "";
            if (params.data.ReportStatus == '1' || params.data.ReportStatus == '5') {
                template = '<i class="btn fa fa-file-text-o txt-clr-14 fs-14px no-shadow py-0 px-0" title="Report"></i>';
            }
            return template;
        }
        function resendReportCellRenderer(params) {
            var template = "";
            if (params.data.Status == "C" && !params.data.isComparisionOrder) {
                template = '<img class="cursor-pointer" src="assets/images/resend_border_icon.svg"  title="Resend Report" ' +
                    'style="padding: 0px 0 0px!important; box-shadow: none!important;"></img>';
            }
            return template;
        }
        function RatingCellRenderer(params) {
            var template = "";
            if (params.data && params.data.Status == "C" && (params.data.Rating)) {
                var title = (params.data.Comments) ? (params.data.Comments) : params.data.Rating + " Star";
                for (var i = 1; i <= 5; i++) {
                    var icon = (i <= _.toInteger(params.data.Rating)) ? "fa fa-star txt-clr-14" : "fa fa-star-o txt-clr-2";
                    template = template + '<i class="' + icon + '" aria-hidden="true"></i>';

                }
            }
            return '<span title="' + title + '"' + template + "</span>";
        }

        function discussionCellRenderer(params) {
            var eGui = document.createElement('div');
            if (!params.data.isComparisionOrder) {
                var discussion = discussionHTML(params);
                if (discussion) {
                    eGui.appendChild(discussion);
                }
            }
            return eGui;
        }
        function IPCommentCellRenderer(params) {
            var template = "";
            if (params.data.IPComment && !params.data.isComparisionOrder) {
                template = '<div class="w-100 float-left text-center"><i class="btn fa fa-info txt-clr-14 p-0 fs-14px no-shadow" title="' + params.data.IPComment + '"></i></div >';
            }
            return template;
        }
        function discussionHTML(params) {
            if (params.data && !params.data.isComparisionOrder && (params.data.IsDiscussion || params.data.FileCount > 0)) {
                var className = (params.data.IsDiscussion) ? 'green' : 'gray';
                var wrapper = document.createElement('div');
                wrapper.className = 'pt-0 pb-0';
                var container = document.createElement('div');
                container.className = 'icon-container w-100 float-left text-center pos-rel';
                container.setAttribute('data-toggle', 'modal');
                container.setAttribute('title', '');
                container.setAttribute('data-target', '#ModalDiscussion');
                wrapper.appendChild(container);

                if (params.data.FileCount > 0) {
                    var paperclip = document.createElement('span');
                    paperclip.className = 'glyphicon glyphicon-paperclip icon-paperclip cursor-pointer z-i-1 fs-14px pos-abs txt-clr-1';
                    paperclip.title = 'Discussion';
                    paperclip.style.cssText = 'top:2px; left:0; right:0';
                    paperclip.setAttribute('aria-hidden', 'true');
                    container.appendChild(paperclip);
                }
                if (params.data.IsDiscussion && params.data.DicomOrderID) {
                    container.appendChild(discussionIcon('fa fa-comments cursor-pointer fs-14px pt-5px ' + className));
                }
                else if (params.data.IsDiscussion && params.data.DicomOrderID != $scope.popoverDicomOrderID) {
                    container.appendChild(discussionIcon('fa fa-comments cursor-pointer fs-14px pt-5px ' + className));
                }
                if (!params.data.IsDiscussion) {
                    container.appendChild(discussionIcon('fa fa-comment-o cursor-pointer fs-14px txt-clr-14 pt-5px ' + className));
                }
                return wrapper;
            }
            else {
                return null;
            }
        }
        function discussionIcon(className) {
            var icon = document.createElement('span');
            icon.className = className;
            icon.title = 'Discussion';
            icon.setAttribute('aria-hidden', 'true');
            return icon;
        }
        //#region Discussion Tippy popover
        function createDiscussionPopOver(instance, params) {
            var template = instance[0].eGui;
            hideAllTippyPopUp()
            var tippyInstance = tippy(template);
            tippyInstance.disable();
            configureTippyInstance(tippyInstance);
            if (params.data.IsDiscussion) {
                tippyJsinstance.push({ tippyInstance: tippyInstance, cellInstance: instance, rowNode: params.node });
            }
            var popOver = createDiscussionComponent(params);
            tippyInstance.setContent(popOver);
        }
        function configureTippyInstance(tippyInstance) {
            tippyInstance.enable();
            tippyInstance.show();
            document.getElementById("PhysicianWorklistAgGrid").addEventListener("mouseenter", discsnPopHide);
            function discsnPopHide() {
                tippyInstance.hide();
            }
            tippyInstance.setProps({
                trigger: 'mouseenter',
                placement: 'right',
                interactive: false,
                onMount: function (tippyInstance) {
                    tippyInstance.setProps({ interactive: true });
                },
                appendTo: document.body,
                hideOnClick: false,
                arrow: true,
                zIndex: 99999,
                followCursor: false,
                sticky: true,
                duration: 0,
                offset: [0, 8],
                flip: false
            });
        }
        function createDiscussionComponent(params) {
            var popOver = document.createElement('div');
            popOver.innerHTML = "<img src= \'https://i.gifer.com/ZKZx.gif\' style=\'height:20px;width:20px\'></img>"
            if (params.data.IsDiscussion) {
                $scope.showPopover(params.data.DicomOrderID, params.data.IsDiscussion).then(function (res) {
                    popOver.innerHTML = DOMPurify.sanitize("<div style='display:block; background-color: #323232;'>" + res + "</div>");
                });
            } else {
                popOver.innerHTML = "";
            }
            return popOver;
        }

        function hideAllTippyPopUp() {
            _.each(tippyJsinstance, function (instance) {
                if (instance.tippyInstance) {
                    instance.tippyInstance.hide();
                }
            });
            tippyJsinstance = [{ tippyInstance: null, cellInstance: null, rowNode: null }];
        }
        //#endregion Discussion Tippy popover
        //#endregion cell-template
        var AgGridColumnDefs = [
            {
                field: 'HasComparison',
                headerName: '',
                cellClass: 'pl-7px',
                cellRenderer: 'agGroupCellRenderer',
                lockPosition: 'left',
                lockVisible: true,
                maxWidth: 28,
                minWidth: 28,
                pinned: 'left',
                resizable: false,
                sortable: false,
                suppressMenu: false,
                suppressMovable: true,
                valueFormatter: function () { return ""; },
                icons: {
                    menu: '<i class="fa fa-gear"></i>',
                }
            },
            /*{
                field: 'User',
                headerName: "",
                headerClass: 'settcol-techno',
                cellRenderer: userLockIconCellRenderer,
                initialWidth: 40,
                pinned: 'left',
                lockPosition: 'left',
                lockVisible: true,
                resizable: false,
                suppressMovable: true,
                sortable: false,
            },*/
            {
                field: 'Location',
                tooltipField: 'Location',
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'Accession',
                tooltipField: 'Accession',
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'OrderDate',
                headerName: 'DOS',
                cellRenderer: DOSCellRenderer,
                flex: 1,
                minWidth: 70,
                sort: 'desc'
            },
            {
                field: 'PatientMRN',
                tooltipField: 'PatientMRN',
                headerName: 'MRN',
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'PatientName',
                tooltipField: 'PatientName',
                headerName: "Patient Name",
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'PatientPhone',
                tooltipField: 'PatientPhone',
                headerName: "Phone",
                flex: 1,
                minWidth: 70,
            },
            {
                field: 'FormattedPatientDOB',
                tooltipField: 'FormattedPatientDOB',
                headerName: "DOB",
                initialWidth: 65,
            },
            {
                field: 'PatientGender',
                tooltipField: 'PatientGender',
                headerName: "Gender",
                initialWidth: 60,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'PatientAge',
                tooltipField: 'PatientAge',
                headerName: "Age",
                initialWidth: 60,
            },
            {
                field: 'PatientClass',
                tooltipField: 'PatientClass',
                headerName: "Type",
                initialWidth: 50,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'Modality',
                tooltipField: 'Modality',
                initialWidth: 50,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'ProcedureDesc',
                tooltipField: 'ProcedureDesc',
                headerName: "Procedure",
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'OrderingPhysician',
                tooltipField: 'OrderingPhysician',
                headerName: "Ordering Physician",
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'ImageInstance',
                headerName: "Image Count",
                initialWidth: 60,
                sortable: false,
            },
            /*{
                field: 'IsSTAT',
                sortable: false,
                resizable: false,
                initialWidth: 80,
                editable: function (params) {
                    return !(params && params.data && params.data.isComparisionOrder)
                },
                valueGetter: function (params) {
                    if (params && params.data) {
                        return (params.data.isComparisionOrder) ? params.data.IsStat : params.data.IsSTAT
                    }
                },
                cellEditor: "agCheckboxCellEditor",
                cellRenderer: "agCheckboxCellRenderer",
            },
            {
                field: 'IsSTATStroke',
                sortable: false,
                resizable: false,
                initialWidth: 100,
                editable: function (params) {
                    return !(params && params.data && params.data.isComparisionOrder)
                },
                cellEditor: "agCheckboxCellEditor",
                cellRenderer: "agCheckboxCellRenderer",
            },*/
            {
                field: "Priority",
                initialWidth: 90,
                sortable: false,
                tooltipField: "Priority",
            },
            {
                field: 'DicomViewer',
                headerName: "Dicom Viewer",
                sortable: false,
                headerClass: "hideHeaderTxt",
                initialWidth: 30,
                cellRenderer: diacomImageCellRenderer,
            },
            {
                field: 'ViewOrder',
                headerName: "View Order",
                sortable: false,
                initialWidth: 30,
                resizable: false,
                headerClass: "hideHeaderTxt",
                cellRenderer: viewOrderCellRenderer,
            },
            {
                field: 'Report',
                headerName: "Report",
                sortable: false,
                initialWidth: 30,
                resizable: false,
                headerClass: "hideHeaderTxt",
                cellRenderer: reportCellRenderer,
            },
            /*{
                field: 'ResendReport',
                headerName: "Resend Report",
                sortable: false,
                initialWidth: 35,
                resizable: false,
                headerClass: "hideHeaderTxt",
                cellRenderer: resendReportCellRenderer,
            },*/
            {
                field: 'FileCount',
                headerName: "Discussion",
                sortable: false,
                initialWidth: 30,
                headerClass: "hideHeaderTxt",
                resizable: false,
                cellRenderer: discussionCellRenderer
            },
            {
                field: 'IC',
                headerName: "Comments",
                sortable: false,
                initialWidth: 30,
                resizable: false,
                headerClass: "hideHeaderTxt",
                cellRenderer: IPCommentCellRenderer
            },
            {
                field: 'Ratings',
                headerName: "Ratings",
                sortable: false,
                cellRenderer: RatingCellRenderer,
                resizable: false,
                initialWidth: 80,
            }
        ]
        function detailCellRendererParams(masterGridParams) {
            return {
                detailGridOptions: {
                    columnDefs: AgGridColumnDefs,
                    enableBrowserTooltips: true,
                    popupParent: document.body,
                    defaultColDef: {
                        suppressMenu: true,
                        resizable: true,
                        sortable: false,
                        lockVisible: false,
                    },
                    suppressMenuHide: true,
                    getContextMenuItems: function () { return []; },
                    headerHeight: 0,

                    context: {
                        masterGrid: {
                            node: masterGridParams.node.parent,
                            data: masterGridParams.data
                        }
                    },

                    getRowStyle: function (params) {
                        var obj = {}
                        if (params.node.data.RowColorCode) {
                            obj.color = params.node.data.RowColorCode;
                        } else {
                            obj.color = '#B9ADCF';
                        }
                        return obj;
                    },
                    onGridReady: function (params) {
                        var savedState = gridOptions.columnApi.getColumnState();
                        params.columnApi.applyColumnState({ state: savedState, applyOrder: true });
                    },
                    onFirstDataRendered: function (params) {
                        var savedState = gridOptions.columnApi.getColumnState();
                        params.columnApi.applyColumnState({ state: savedState, applyOrder: true });
                    },
                    onRowClicked: function (params) {
                        if (params.context && params.context.masterGrid && params.context.masterGrid.node) {
                            params.context.masterGrid.node.setSelected(true)
                        }
                    },
                    onCellClicked: function (params) {
                        if (params.node.data) {
                            var order = params.node.data;
                            switch (params.column.colId) {
                                case 'DicomViewer':
                                    $scope.OpenSynapseStudy(order, "MedDream", false);
                                    break;
                            }
                        }
                    }
                },
                getDetailRowData: function (params) {
                    var savedState = gridOptions.columnApi.getColumnState();
                    GetOrdersComparisonList(params.data.OrderID).then(function (ComparisionOrder) {
                        params.data.ComparisonOrder = _.filter(ComparisionOrder, function (item) { return _.toString(item.ReportStatus) != '2' });
                        _.each(ComparisionOrder, function (order) {
                            order.isComparisionOrder = 1;
                        });
                        params.successCallback(ComparisionOrder);
                        var timeout = $timeout(function () {
                            gridOptions.api.forEachDetailGridInfo(function (detailGridApi) {
                                detailGridApi.columnApi.applyColumnState({ state: savedState, applyOrder: true });
                            });
                            $timeout.cancel(timeout);
                            timeout = null;
                        }, 100);
                    });
                },
            }

        }
        var gridOptions = {
            masterDetail: true,
            detailRowAutoHeight: true,
            columnDefs: AgGridColumnDefs,
            enableBrowserTooltips: true,
            defaultColDef: {
                resizable: true,
                sortable: true,
                suppressMenu: true,
                columnsMenuParams: {
                    columnLayout: ColumnsToHide
                },
            },
            isRowMaster: function (order) {
                return _.toInteger(order.HasComparison);
            },
            detailCellRendererParams: detailCellRendererParams,
            suppressMenuHide: true,
            getMainMenuItems: function (params) {
                var items = ["autoSizeAll", "separator"];
                items.push({
                    name: 'Reset Columns',
                    action: function (params) {
                        console.log("Reset Columns > ", params);
                        resetColumns();
                    }
                })
                return items;
            },
            getContextMenuItems: openContextMenuOptions,
            sortingOrder: ['desc', 'asc'],
            rowSelection: 'single',
            rowModelType: 'serverSide',
            cacheBlockSize: PageSize,
            maxBlocksInCache: 1,
            maxConcurrentDatasourceRequests: 1,
            getRowId: function (params) {
                return params.data.orderRowID;
            },
            getRowStyle: function (params) {
                if (params.node.data) {
                    var obj = { color: params.node.data.RowColorCode };
                    return obj;
                }
            },
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            popupParent: document.body,
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },
            onGridReady: function () {
                var savedState = [];
                var currentState = gridOptions.columnApi.getColumnState();
                if (worklistSavedState && worklistSavedState.columnDefs) {
                    _.each(worklistSavedState.columnDefs, function (col) {
                        if (col.name != "CreatedDate" || col.name != "TF") {
                            var obj = {
                                colId: col.name,
                            }
                            var Idx = _.findIndex(gridOptions.columnApi.getColumnState(), { colId: col.name });
                            if (Idx != -1) {
                                obj.flex = currentState[Idx].flex;
                            }

                            if (col.hasOwnProperty("width") && col.width != "*") {
                                obj.flex = null;
                                obj.width = col.width;
                            }
                            if (col.hasOwnProperty("visible")) {
                                obj.hide = !col.visible;
                            }
                            savedState.push(obj);
                        }
                    });
                }
                worklistSavedState = (savedState && savedState.length > 0) ? savedState : ((worklistSavedState && worklistSavedState.length > 0) ? worklistSavedState : currentState);

                var HasComparisonSavedState = _.find(worklistSavedState, { colId: "HasComparison" });
                if (!HasComparisonSavedState) {
                    var HasComparisonCurrentState = _.find(currentState, { colId: "HasComparison" });
                    if (HasComparisonCurrentState) {
                        worklistSavedState.splice(0, 0, HasComparisonCurrentState);
                    }
                }

                var differenceStates = _.differenceBy(currentState, worklistSavedState, 'colId');
                if (differenceStates.length > 0) {
                    _.each(currentState, function (col, index) {
                        var idx = _.findIndex(worklistSavedState, { 'colId': col.colId });
                        if (idx == -1) {
                            var previousCol = currentState[index - 1];
                            if (previousCol) {
                                var previousColSavedStateIndex = _.findIndex(worklistSavedState, { 'colId': previousCol.colId });
                                if (previousColSavedStateIndex != -1) {
                                    worklistSavedState.splice(previousColSavedStateIndex + 1, 0, col);
                                }
                            }
                        }
                    });
                }

                gridOptions.columnApi.applyColumnState({ state: worklistSavedState, applyOrder: true });
                statusBarComponent = gridOptions.api.getStatusPanel('GridFooter');
                gridOptions.api.setCacheBlockSize(PageSize);

                setColumnHideMenu();
                setFilter();
                //#region bind data to html
                var fakeServer = createFakeServer();
                var datasource = createServerSideDatasource(fakeServer);
                gridOptions.api.setServerSideDatasource(datasource);
                //#endregion bind data to html

                //Calling Tour After Data binding
                PhysicianInitTour();
            },
            onCellMouseOver: function (params) {
                switch (params.column.colId) {
                    case 'FileCount':
                        hideAllTippyPopUp();
                        if (params.data.IsDiscussion) {
                            var cellRendererInstances = params.api.getCellRendererInstances({
                                rowNodes: [params.node],
                                columns: [params.column],
                            });
                            createDiscussionPopOver(cellRendererInstances, params)
                        }
                        break;
                }
            },
            onCellClicked: function (params) {
                if (params.node.data) {
                    var order = params.node.data;
                    switch (params.column.colId) {
                        case 'DicomViewer':
                            $scope.OpenSynapseStudy(order, "MedDream", false);
                            break;
                        case "ViewOrder":
                            $scope.LoadPatientData(order);
                            break;
                        case "Report":
                            if (params && params.data && _.toString(params.data.ReportStatus) != '2') {
                                $scope.DataObject.StudyReReadReason = null;
                                $scope.DataObject.StudyRating = null;

                                ViewOrderReport(params.data, params.data.Accession);
                            }
                            //if (order.ReportStatus == '1' || order.ReportStatus == '2' || order.ReportStatus == '5') {
                            //    $scope.SelectedOrder = _.clone(order);
                            //    $scope.LoadReport();
                            //}
                            break;
                        case "ResendReport":
                            $scope.ResendReport(order);
                            break;
                        case "FileCount":
                            if (order.IsDiscussion || order.FileCount > 0) {
                                $scope.setSelected(order.OrderID, order);
                                $scope.LoadDiscussion(order.DicomOrderID, order.FileCount);
                            }
                            break;
                    }
                }
            },
            onRowSelected: function (params) {
                var selectedRow = gridOptions.api.getSelectedRows()[0];
                if (selectedRow) { $scope.setSelected(selectedRow.OrderID, selectedRow); }
            },
            onCellEditingStopped: function (params) {
                if (params.node.data) {
                    var order = params.node.data;
                    switch (params.column.colId) {
                        case "IsSTAT":
                            UpdateDicomOrderSTAT(order);
                            break;
                        case "IsSTATStroke":
                            UpdateDicomOrderSTAT(order);
                            break;
                    }
                }
            },
            onRowDoubleClicked: function (params) {
                $scope.OpenSignReport(params.data);
            },
            onColumnMoved: function (params) {
                if (params.finished) {
                    updateUserLayoutPreference()
                }
            },
            onSortChanged: function (params) {
                updateUserLayoutPreference();
                PageNo = 1;
                DicomOrderList = [];
                sortingApplied = true;
                refreshWorklistAggrid(true);
                gridOptions.api.ensureIndexVisible(0);
            },
            onColumnResized: function (params) {
                if (params && params.source == "autosizeColumns") {
                    updateUserLayoutPreference();
                }
            },
            onColumnVisible: function (params) {
                console.log("onColumnVisible > ", params);
                if (params.source != "api") {
                    if (params.column && params.column.colId == "Report") {
                        UserLayoutOption.ReportColVisible = params.column.visible;
                    }
                    if (params.column && params.column.colId == "ResendReport") {
                        UserLayoutOption.ResendReportColVisible = params.column.visible;
                    }
                }
                updateUserLayoutPreference();
            },
            onDragStopped: function (params) {
                updateUserLayoutPreference();
            },
            onColumnPinned: function (params) {
                updateUserLayoutPreference();
            },
            icons: {
                groupExpanded:
                    '<div class=\'fa fa-minus fs-15px txt-clr-14 ng-scope\' title=\'Collapse\'></div>',
                groupContracted:
                    '<div class=\'fa fa-plus fs-15px txt-clr-14 ng-scope\' title=\'Expand\'></div>',
            },
        }
        function initGrid() {
            phyGrid = document.getElementById("PhysicianWorklistAgGrid");
            new agGrid.Grid(phyGrid, gridOptions);
        }

        function setColumnHideMenu() {
            _.each(AgGridColumnDefs, function (col) {
                if (!col.lockVisible) {
                    var obj = {};

                    obj.field = col.field;
                    ColumnsToHide.push(obj);
                }
            });
        }

        function createFakeServer() {
            return {
                getData: function (request) {
                    var d = $q.defer();

                    var page = _.toInteger(request.endRow / PageSize);
                    if (page <= 0) { page = 1; }

                    if (sortingApplied) {
                        PageNo = page;
                        sortingApplied = false;
                    } else if (page > PageNo) {
                        PageNo = page;
                    } else if (page < PageNo) {
                        PageNo = page;
                    }

                    createSortingString(request.sortModel);

                    getDicomOrders().then(function (response) {

                        statusBarComponent.eGui.hidden = true;
                        if (DicomOrderList.length > 0) {
                            statusBarComponent.eGui.hidden = false;
                            statusBarComponent.eGui.style.padding = '5px';
                            statusBarComponent.eGui.style.margin = '5px';
                            statusBarComponent.eGui.textContent = 'Showing ' + DicomOrderList.length + ' of ' + TotalRows + ' Total Records';
                            statusBarComponent.eGui.style.color = 'white';
                        }

                        if (DicomOrderList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            gridOptions.api.hideOverlay();
                        }

                        d.resolve({
                            success: true,
                            rows: response
                        });
                    }, function (error) {
                        $scope.isorderlistLoading = false;
                        toaster.error("Failure to retrieve the data.");
                        var rows = [];
                        statusBarComponent.eGui.hidden = true;
                        if (DicomOrderList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            rows = DicomOrderList.slice(request.startRow, request.endRow);
                            statusBarComponent.eGui.hidden = false;
                            statusBarComponent.eGui.style.padding = '5px';
                            statusBarComponent.eGui.style.margin = '5px';
                            statusBarComponent.eGui.textContent = 'Showing ' + DicomOrderList.length + ' of ' + TotalRows + ' Total Records';
                            statusBarComponent.eGui.style.color = 'white';

                            gridOptions.api.hideOverlay();
                        }
                        d.resolve({
                            success: true,
                            rows: rows
                        });
                    });
                    return d.promise;
                },
            };
        }

        function createServerSideDatasource(server) {
            return {
                getRows: function (params) {
                    server.getData(params.request).then(function (response) {
                        params.success({
                            rowData: response.rows,
                            rowCount: response.lastRow,
                        });

                        var selectedRows = gridOptions.api.getSelectedRows();
                        if (selectedRows.length > 0) {
                            gridOptions.api.deselectAll();
                            _.each(selectedRows, function (row) {
                                var order = _.find(DicomOrderList, { 'OrderID': row.OrderID });
                                if (order != null) {
                                    var node = gridOptions.api.getRowNode((order.orderRowID).toString());
                                    if (node) {
                                        node.setSelected(true);
                                    }
                                }
                            });
                        }

                    }, function (reason) {
                        params.fail();
                        var timeout = $timeout(function () {
                            gridOptions.api.retryServerSideLoads();
                            $timeout.cancel(timeout);
                            timeout = null;
                        }, 100);
                    });
                },
            };
        }

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }


        $scope.FilterDICOMOrders = function (flag) {
            PageNo = 1;
            DicomOrderList = [];
            if (flag) { if ($scope.Status == 'H') { $scope.HiddenType.obj = $scope.HiddenTypeList[0]; } }
            refreshWorklistAggrid(true);
        }
        function setFilter() {
            orderListFilter = {
                //SiteID: $scope.SelectedList.Site ? $scope.SelectedList.Site.SiteID : null,
                LocationID: $scope.locations.length > 0 ? $scope.locations : null,
                Accession: $scope.Accession,
                Modality: $scope.modalities.length > 0 ? $scope.modalities : null,
                OrderDateStartDate: ($scope.OrderDate.startDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.OrderDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00")) : null,
                OrderDateEndDate: ($scope.OrderDate.endDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.OrderDate.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")) : null,
                PatientName: $scope.PatientName,
                PatientMRN: $scope.PatientMRN,
                PatientDOB: $scope.formatted_date($scope.DOB),
                PatientClass: $scope.SelectedList.PatientClass ? $scope.SelectedList.PatientClass.Value : null,
                Status: $scope.Status,
                UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : null,
                OrderingPhysician: $scope.OrderingPhysician
            };
            if ($scope.Status == 'H' && $scope.HiddenType.obj && $scope.HiddenType.obj.Value) {
                orderListFilter.ImagePendingStatus = $scope.HiddenType.obj.Value;
            }
        }
        function createSortingString(sortModel) {
            sortingString = "";
            _.each(sortModel, function (obj) {
                var sortColumn = "";
                switch (obj.colId) {
                    case "Location":
                        sortColumn = "L.Location " + obj.sort;
                        break;
                    case "Accession":
                        sortColumn = "O.Accession " + obj.sort;
                        break;
                    case "OrderDate":
                        sortColumn = "O.OrderDate " + obj.sort;
                        break;
                    case "PatientMRN":
                        sortColumn = "O.PatientMRN " + obj.sort;
                        break;
                    case "PatientName":
                        sortColumn = "O.PatientLastName " + obj.sort + ",O.PatientFirstName " + obj.sort;
                        break;
                    case "FormattedPatientDOB":
                        sortColumn = "O.PatientDOB " + obj.sort;
                        break;
                    case "PatientGender":
                        sortColumn = "O.PatientGender " + obj.sort;
                        break;
                    case "PatientAge":
                        sortColumn = "O.PatientDOB " + obj.sort;
                        break;
                    case "PatientClass":
                        sortColumn = "O.PatientClass " + obj.sort;
                        break;
                    case "Modality":
                        sortColumn = "O.Modality " + obj.sort;
                        break;
                    case "ProcedureDesc":
                        sortColumn = "O.ProcedureDesc " + obj.sort;
                        break;
                    case "OrderingPhysician":
                        sortColumn = "P.Name " + obj.sort;
                        break;
                }
                if (sortingString == "") {
                    sortingString = sortColumn;
                } else {
                    sortingString = sortingString + "," + sortColumn;
                }
            });
            if (sortingString == "") {
                sortingString = defaultSortingString;
            }
            console.log("sortingString > ", sortingString)
        }
        function removeRowFromGrid(selectedNode) {
            if (gridOptions && gridOptions.api && selectedNode && selectedNode.data && selectedNode.data.orderRowID && $scope.Status != 'AL') {
                gridOptions.api.applyServerSideTransaction({
                    remove: [{ orderRowID: (selectedNode.data.orderRowID).toString() }]
                });
                _.remove(DicomOrderList, { OrderID: selectedNode.data.OrderID });
                TotalRows = TotalRows - 1;
                statusBarComponent.eGui.textContent = 'Showing ' + DicomOrderList.length + ' of ' + TotalRows + ' Total Records';
                statusBarComponent.eGui.style.color = 'white';
                if (DicomOrderList.length == 0) {
                    statusBarComponent.eGui.hidden = true;
                    gridOptions.api.showNoRowsOverlay();
                } else {
                    statusBarComponent.eGui.hidden = false;
                    gridOptions.api.hideOverlay();
                }
            }
        }
        function refreshWorklistAggrid(purge) {
            if (gridOptions && gridOptions.api) {
                if (purge) {
                    setFilter();
                    gridOptions.api.refreshServerSide({ purge: true });
                }
                else {
                    gridOptions.api.refreshServerSide();
                }
            }
        }
        function updateOrders(Orders) {
            _.each(Orders, function (order) {
                order.orderRowID = new Date().getTime() + Math.random().toString(16).slice(2);
                updateOrderAssign(order);
            });

            return Orders;
        }
        function updateOrderAssign(order) {
            var d = $q.defer();
            if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) {
                var orderAssignmentIndex = _.findIndex(order.listOrderListAssignment, function (assignment) { return assignment.OrderAssingedUserID == $sessionStorage.currentUserData.userId; });

                order.OrderAssingedUserID = (order.listOrderListAssignment && order.listOrderListAssignment.length > 0 ? order.listOrderListAssignment[0].OrderAssingedUserID : null);
                //order.OrderAssingedUserName = $scope.getOrderListTooltip(order);
                order.OrderAssingedUsers = (order.listOrderListAssignment ? order.listOrderListAssignment.length : 0);

                order.OrderAssingedUser = (orderAssignmentIndex != -1 ? $sessionStorage.currentUserData.userId : null);
            }
            d.resolve(order);
            return d.promise;
        }
        function getOrderListTooltip(Order) {
            var orderDiscussionTooltip = '';
            var groupName = '';
            var userName = '';
            var allSpeciality = _.uniqBy(_.map(Order.listOrderListAssignment, function (row) {
                return {
                    ProviderSpecialityId: row.ProviderSpecialityId,
                    IsUserWithSpecialityGroup: row.IsUserWithSpecialityGroup,
                    SpecialityCode: row.SpecialityCode
                }
            }), 'ProviderSpecialityId');
            var allUsers = _.map(Order.listOrderListAssignment, function (row) {
                return {
                    OrderAssingedUserID: row.OrderAssingedUserID,
                    OrderAssingedUserName: row.OrderAssingedUserName,
                }
            });
            var specialities = [];
            var users = []
            _.each(Order.listOrderListAssignment, function (orderAssignment) {
                if (orderAssignment.ProviderSpecialityId > 0) {
                    var speciality = _.find(allSpeciality, { ProviderSpecialityId: orderAssignment.ProviderSpecialityId });
                    if (speciality) {
                        specialities.push(speciality);
                    }
                } else {
                    var specialityUser = _.find(allUsers, { OrderAssingedUserID: orderAssignment.OrderAssingedUserID });
                    if (specialityUser) {
                        users.push(specialityUser);
                    }
                }
            });

            var uniquespecialities = _.uniqBy(specialities, 'ProviderSpecialityId');

            var rawUsers = _.uniqBy(users, 'OrderAssingedUserID');
            var uniquespecialityusers = _.filter(rawUsers, function (_u) { return !_isPrelimRadAssignment(_u.OrderAssingedUserID); });


            groupName = _.join(_.map(uniquespecialities, function (speciality) { return speciality.SpecialityCode; }), ',');

            userName = _.join(_.map(uniquespecialityusers, function (_user) {
                return _assignmentName(_user.OrderAssingedUserID, _user.OrderAssingedUserName);
            }), ',');

            if (uniquespecialities.length == 0 && uniquespecialityusers.length == 0) {
                if (rawUsers.length > 0) { return ''; }
                orderDiscussionTooltip = '';
                if (Order.isCollapsed) {
                    orderDiscussionTooltip = 'Hide Comparison';
                } else {
                    orderDiscussionTooltip = 'Show Comparison';
                }
                return orderDiscussionTooltip;
            } else {
                var message = '';
                var groupMessage = '';
                var userMessage = '';
                groupMessage += uniquespecialities.length > 1 ? uniquespecialities.length + ' Groups' : uniquespecialities.length == 1 ? groupName : '';
                userMessage += uniquespecialityusers.length > 1 ? uniquespecialityusers.length + ' Others' : uniquespecialityusers.length == 1 ? userName : '';
                if (groupMessage.length > 0 && userMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage + ' and ' + userMessage;
                } else if (groupMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage;
                } else if (userMessage.length > 0) {
                    message = 'Assigned to ' + userMessage;
                }
                return message;
            }
        }
        function NotifyAssignStudy(data) {
            if (data && (data.FromUserID != $sessionStorage.currentUserData.userId)) {
                var orderIndex = _.findIndex(DicomOrderList, { 'OrderID': _.toString(data.OrderID) });
                var userOfGroupLength = data.Order.listOrderListAssignment.length;
                var userIndex = _.findIndex(data.Order.listOrderListAssignment, { 'OrderAssingedUserID': $sessionStorage.currentUserData.userId });
                var userName = '';
                if (orderIndex != -1) {
                    DicomOrderList[orderIndex].listOrderListAssignment = data.Order.listOrderListAssignment;
                    userName = getOrderListTooltip(DicomOrderList[orderIndex]);
                }
                if (data.Order.listOrderListAssignment.length > 0) {
                    _.each(data.Order.listOrderListAssignment, function (data) {
                        if (orderIndex != -1) {
                            DicomOrderList[orderIndex].OrderAssingedUserID = data.OrderAssingedUserID;
                            DicomOrderList[orderIndex].OrderAssingedUserName = userName;
                            DicomOrderList[orderIndex].OrderAssingedUsers = userOfGroupLength;
                            DicomOrderList[orderIndex].OrderAssingedUser = userIndex != -1 ? $sessionStorage.currentUserData.userId : null;
                        }


                    });
                } else {
                    if (orderIndex != -1) {
                        DicomOrderList[orderIndex].OrderAssingedUserID = null;
                        DicomOrderList[orderIndex].OrderAssingedUserName = null;
                        DicomOrderList[orderIndex].OrderAssingedUsers = 0;
                        DicomOrderList[orderIndex].OrderAssingedUser = null;
                    }
                }

            } else if (data && (data.FromUserID == $sessionStorage.currentUserData.userId)) {
                var index = _.findIndex(DicomOrderList, { 'OrderID': data.Order.OrderID });
                if (index != -1) {
                    updateOrderAssign(data.Order);
                    DicomOrderList[index].OrderAssingedUserID = data.Order.OrderAssingedUserID;
                    DicomOrderList[index].OrderAssingedUserName = data.Order.OrderAssingedUserName;
                    DicomOrderList[index].OrderAssingedUsers = data.Order.OrderAssingedUsers;
                    DicomOrderList[index].OrderAssingedUser = data.Order.OrderAssingedUser;

                    if (data.Order && data.Order.listOrderListAssignment) {
                        DicomOrderList[index].listOrderListAssignment = data.Order.listOrderListAssignment;
                    }
                }
            }
            updateOrderAssign(data.Order).then(function (res) {
                UpdateGridData(res.OrderID);
            });
        }

        function UpdateGridData(OrderID) {

            var rowToUpdate;
            var order = _.find(DicomOrderList, { 'OrderID': OrderID });
            if (order) {
                rowToUpdate = gridOptions.api.getRowNode(order.orderRowID);
            }

            if (rowToUpdate) {
                rowToUpdate.data = _.filter(DicomOrderList, { OrderID: OrderID })[0];
                if (rowToUpdate.data) {
                    if (rowToUpdate.data && rowToUpdate.data.HasComparison == "0" && rowToUpdate.detailNode) {
                        rowToUpdate.setExpanded(false);
                        rowToUpdate.detailNode.parent.master = 0;
                    }
                    var params = {
                        force: true,
                        suppressFlash: true,
                        rowNodes: [rowToUpdate]

                    };
                    gridOptions.api.refreshCells(params);
                }

            }
        }
        //#endregion Ag-grid
        $scope.onKendoWindowClose = function () {
            OrderRefresh();
            refreshWorklistAggrid();
        }
        $scope.onKendoWindowOpen = function () {
            if (OrderRefreshInterval) {
                $interval.cancel(OrderRefreshInterval);
            }
        }

        $scope.keys = {
            F11: function (name, code) {
                var selectedRows = gridOptions.api.getSelectedRows();
                if (selectedRows.length > 0 && (selectedRows[0].IsDiscussion || selectedRows[0].FileCount > 0)) {
                    $scope.setSelected(selectedRows[0].OrderID, selectedRows[0]);
                    $scope.LoadDiscussion(selectedRows[0].DicomOrderID, selectedRows[0].FileCount);
                }
            },
        };

        $scope.$on("OpenDiscussionOrder", function (evt, OD) {
            $scope.OrderDiscussion = OD;
            $scope.setSelected($scope.OrderDiscussion.Order.OrderID, $scope.OrderDiscussion.Order);
            $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID);
        });

        function GetOrdersComparisonList(OrderID) {
            var d = $q.defer();
            var orderComparisonListFilter = {
                UserID: $sessionStorage.currentUserData.userId,
                OrderID: OrderID
            };
            WorklistService.GetOrdersComparisonList(orderComparisonListFilter).then(function (result) {
                if (result.length > 0) {
                    d.resolve(_.filter(result, function (item) { return _.toString(item.ReportStatus) != '2' }));
                }
            });
            return d.promise;
        }
        function ViewOrderReport(SelectedOrder, SelectedOrderAccession) {
            $scope.ReportSelectedOrder = _.clone(SelectedOrder);
            $scope.showDiscuss = false;
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;

            var ComparisionOrderList = [];

            if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length == 0) {
                $scope.orderComparisonListFilter = {
                    UserID: vm.selectedData.LoggedInUserID,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = _.filter(result, function (item) { return _.toString(item.ReportStatus) != '2' });
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });

                    setPriorReport(SelectedOrder, ComparisionOrderList);
                }).catch(function (noCantDo) {
                    //$scope.isLoading = false;
                });
            } else if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                setPriorReport(SelectedOrder, ComparisionOrderList);
            } else {
                setPriorReport(SelectedOrder, ComparisionOrderList);
            }
        }
        function setPriorReport(SelectedOrder, ComparisionOrderList) {
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN, SelectedOrder.SiteID)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];

                if (data != null && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        SelectedOrder.FormattedOrderDate = new Date($filter('localDate')(SelectedOrder.OrderDate, false, new Date()));
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            rptObject[0].FormattedOrderDate = new Date($filter('localDate')(rptObject[0].OrderDate, false, new Date()));
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            ComparisonOrderReport.FormattedOrderDate = new Date($filter('localDate')(ComparisonOrderReport.OrderDate, false, new Date()));
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });
                }
                $scope.OrderReport = SelectedOrder;
                $scope.reportList = _.filter(_.uniqBy($scope.reportList, 'OrderID'), function (item) { return _.toString(item.ReportStatus) != '2' });
                $scope.DataObject.ReportList.Modalities = _.concat($scope.DataObject.ReportList.Modalities, _.uniq(_.map($scope.reportList, 'Modality')));
                var objSelectedReport = _.filter($scope.reportList, function (obj) { return obj.Accession == $scope.SelectedOrderAccession; });
                LoadReport(objSelectedReport[0].OrderID);
                if (Hasreport) {
                    $scope.currentWindow = "win_ComparisonOrderReports";
                    $scope.win_ComparisonOrderReports.open();
                    $scope.win_ComparisonOrderReports.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    $scope.win_ComparisonOrderReports.wrapper.addClass("report-top-mdl");
                    var timeout = $timeout(function () {
                        $scope.win_ComparisonOrderReports.center();
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 100);
                }
                else {
                    toaster.info({ body: "No report found." });
                }
                ReportList = $scope.reportList;
                if (ReportList.length > 1) {
                    $scope.DataObject.ShowReportModal = true;
                }
            });
        }
        function GetPriorReportsByPatientMRN(OrderID, PatientMRN, SiteID) {
            var d = $q.defer();
            var jObject = {
                OrderID: OrderID,
                PatientMRN: PatientMRN,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: SiteID
            }

            WorklistService.GetPriorReportsByPatientMRN(jObject).then(function (results) {
                d.resolve(_.filter(results, function (item) { return _.toString(item.ReportStatus) != '2' }));
            });
            return d.promise;
        }
        function LoadReport(OrderId) {
            if ($scope.orderReportList && $scope.orderReportList.length > 0) {
                var data = _.filter($scope.orderReportList, function (obj) { return obj.OrderID == OrderId; });
                if (data && data.length > 0) {
                    $scope.report = data[0];
                    $scope.ReviewOrder = {};
                    angular.copy($scope.report, $scope.ReviewOrder);
                    AssignValuesReportToSelectedOrder();
                    //$scope.isLoading = false;
                }
                else {
                    $scope.ReviewOrder = {};
                    getReportData(OrderId);
                }
            }
            else {
                $scope.ReviewOrder = {};
                getReportData(OrderId);
            }

        }
        function getReportData(OrderId) {
            $scope.report = null;
            var UserId = $sessionStorage.currentUserData.userId;
            WorklistService.GetDictationValueReport(OrderId, UserId).then(function (response) {
                if (response) {
                    $scope.report = response;
                    if ($sessionStorage.currentUserData
                        && $sessionStorage.currentUserData.RemoveRenderingPhysician
                        && ($scope.DataObject.EnableRowsForSelectedTenants
                            && $scope.DataObject.EnableRowsForSelectedTenants.includes($scope.SelectedOrder.TenantName))) {
                        $scope.report.DictationValue = _.toString($scope.report.DictationValue).length > 0 ? $scope.report.DictationValue.replace(/Electronically signed by.*?(?:\n|\r|$)/gi, '').replace(/Workstation:.*?(?:\n|\r|$)/gi, '').replace(/Electronically drafted by.*?(?:\n|\r|$)/gi, '') : '';
                    }
                    $scope.ReviewOrder = response;

                    $scope.orderReportList.push(response);

                    if ($scope.report && $scope.report.DOS) {
                        $scope.report.DOS = ($filter('localDate')($scope.report.DOS, false, new Date()));
                    }
                    if ($scope.report && $scope.report.SingDate) {
                        $scope.report.SingDate = moment(
                            ($filter('localDate')($scope.report.SingDate, false, new Date()))
                        ).format("MM/DD/YYYY");
                    }
                    if ($scope.report && $scope.report.Patient_DOB) {
                        $scope.report.Patient_DOB = changeDateFormat($scope.report.Patient_DOB);
                    }
                    if ($scope.OrderReport) {
                        $scope.report.Location = $scope.OrderReport.Location;
                        $scope.report.LocationID = $scope.OrderReport.LocationID;
                    }
                    AssignValuesReportToSelectedOrder();
                }

                //$scope.isLoading = false;
            }, function (error) {
                //$scope.isLoading = false;
            });
        }
        function changeDateFormat(date) {
            if (date) {
                return moment(new Date(date)).format("MM/DD/YYYY");
            }
        }
        $scope.onReportSortingClicked = function (sortingOption) {
            $scope.DataObject.SelectedSortingOption = sortingOption;
            var ReportListElement = document.getElementsByClassName('repoHeiFtrWrklst ftlrbtns-height');
            if (ReportListElement && ReportListElement[0] && ReportListElement[0].scrollTop > 0) {
                ReportListElement[0].scrollTop = 0;
            }
            switch (sortingOption) {
                case 'DOS (newest first)':
                    $scope.DataObject.ReportSortingPropName = 'OrderDate';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
                case 'DOS (oldest first)':
                    $scope.DataObject.ReportSortingPropName = 'OrderDate';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Rendering Physician (A to Z)':
                    $scope.DataObject.ReportSortingPropName = 'SignByName';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Rendering Physician (Z to A)':
                    $scope.DataObject.ReportSortingPropName = 'SignByName';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
                case 'Procedure (A to Z)':
                    $scope.DataObject.ReportSortingPropName = 'ProcedureDesc';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Procedure (Z to A)':
                    $scope.DataObject.ReportSortingPropName = 'ProcedureDesc';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
            }
        }

        $scope.FilterReportList = function (FilterFlag) {
            var FilteredList = ReportList;
            var startDate, endDate = null;
            if ($scope.DataObject.ReportListFilter.DateRange != 'Any') {
                switch ($scope.DataObject.ReportListFilter.DateRange) {
                    case '6m':
                        startDate = new Date(moment().subtract(6, 'month'));
                        endDate = new Date(moment());
                        break;
                    case '1y':
                        startDate = new Date(moment().subtract(1, 'year').add(1, 'days'));
                        endDate = new Date(moment());
                        break;
                    case '2y':
                        startDate = new Date(moment().subtract(2, 'year'));
                        endDate = new Date(moment());
                        break;
                    case '5y':
                        startDate = new Date(moment().subtract(5, 'year'));
                        endDate = new Date(moment());
                        break;
                }
                FilteredList = _.filter(FilteredList, function (report) {
                    var itemDate = new Date(report.OrderDate);
                    return itemDate >= startDate && itemDate <= endDate;
                });
            }
            if ($scope.DataObject.ReportListFilter.Modality != 'All') {
                FilteredList = _.filter(FilteredList, { 'Modality': $scope.DataObject.ReportListFilter.Modality });
            }
            if ($scope.DataObject.SearchText != '') {
                var result = null;
                result = _.filter(FilteredList, function (item) {
                    return _.some(['OrderDate', 'ProcedureDesc', 'SignByName'], function (key) {
                        if (key == 'OrderDate') {
                            return moment(_.get(item, key, '')).format('MM/DD/YYYY').toString().toLowerCase().includes($scope.DataObject.SearchText.toLowerCase());
                        }
                        else {
                            var value = _.get(item, key, '');
                            if (value) {
                                return value.toString().toLowerCase().includes($scope.DataObject.SearchText.toLowerCase());
                            }
                        }
                        return false;
                    });
                });
                if (result) { FilteredList = result; }
            }
            $scope.reportList = _.filter(FilteredList, function (item) { return _.toString(item.ReportStatus) != '2' });
            if (FilterFlag && $scope.reportList && $scope.reportList.length > 0) {
                var objSelectedReport = $scope.reportList[$scope.reportList.length - 1];
                if (objSelectedReport) {
                    $scope.SelectedOrderAccession = objSelectedReport.Accession;
                    LoadReport(objSelectedReport.OrderID);
                }
            }
        }
        $scope.onClearFilterReportList = function (ClearFlag) {
            $scope.DataObject.SelectedSortingOption = 'DOS (newest first)';
            $scope.DataObject.ReportListFilter.Modality = 'All';
            $scope.DataObject.ReportListFilter.DateRange = 'Any';
            $scope.DataObject.ReportSortingPropName = 'OrderDate';
            $scope.DataObject.ReportSortingRevOrder = true;
            if (ClearFlag) {
                $scope.DataObject.ReportList.Modalities = ['All'];
                $scope.DataObject.ShowReportModal = false;
            }
            $scope.DataObject.SearchText = '';
        }
        $scope.showReport = function (SelectedOrder) {
            $scope.OrderReport = SelectedOrder;
            $scope.SelectedOrderAccession = SelectedOrder.Accession;
            LoadReport(SelectedOrder.OrderID);
        }

        function AssignValuesReportToSelectedOrder() {
            $scope.ReportSelectedOrder.OrderDate = $scope.report.DOS;
            $scope.ReportSelectedOrder.ReportSignDate = $scope.report.SingDate;
            $scope.ReportSelectedOrder.ReportStatus = $scope.report.Status;
            $scope.ReportSelectedOrder.PatientDOB = $scope.report.Patient_DOB;
            if ($scope.ReportSelectedOrder && $scope.ReportSelectedOrder.Status) {
                $scope.ReportSelectedOrder.OrderStatus = _.find($scope.DataObject.OrderStatus, { 'key': $scope.ReportSelectedOrder.Status }).value;
            }
        }

        $scope.ActionItemClicked = function (ActionMenu, Order) {
            switch (ActionMenu.ActionTaken) {
                case 'Open Discussion (F11)':
                    $scope.setSelected(Order.OrderID, Order);
                    $scope.LoadDiscussion(Order.DicomOrderID, Order.FileCount);
                    break;
                case 'Consult with Physician':
                    $scope.CallInConsult(Order);
                    break;
            }

            var Timeout = $timeout(function () {
                _.each(openWindows.slice(1, -1), function (w) {
                    CloseAllWindow(false, w);
                });
                $timeout.cancel(Timeout);
                Timeout = null;
            }, 1000);
        }
        function CloseAllWindow(AllWindow, Window) {
            if ($scope.isHelpOrderVisible && AllWindow) {
                $scope.win_HelpOrder.close();
            }
            if ($scope.isViewReportVisible && AllWindow) {
                $scope.win_ViewReport.close();
            }
            if ($scope.isDiscussionVisible && (AllWindow ? AllWindow : Window == 'Discussion')) {
                $scope.win_Discussion.close();
            }
            if ($scope.isViewTechniqueVisible && AllWindow) {
                $scope.win_ViewTechnique.close();
            }
            if ($scope.isAddTechniqueVisible && AllWindow) {
                $scope.win_AddTechnique.close();
            }
            if ($scope.isTechFormVisible && AllWindow) {
                $scope.win_TechForm.close();
            }
            if ($scope.isPatientInfoVisible && AllWindow) {
                $scope.win_PatientInfo.close();
            }
            if ($scope.isConsultExamsWindow && (AllWindow ? AllWindow : Window == 'Consult Exams')) {
                $scope.win_consultExamsWindow.close();
            }
            if ($scope.isComparisonOrderReportsVisible && (AllWindow ? AllWindow : Window == 'Report')) {
                $scope.win_ComparisonOrderReports.close();
            }
        }

        function getOrderStatus() {
            $scope.DataObject.OrderStatus = WorklistService.GetOrderStatus();
        }

        $scope.windowOpened = function (windowInstance) {
            var WindowTitle = windowInstance && windowInstance.options ? windowInstance.options.title : '';
            if (WindowTitle != '' && openWindows.indexOf(WindowTitle) === -1) {
                openWindows.push(WindowTitle);
            }
        };

        $scope.windowClosed = function (windowInstance) {
            if (windowInstance) {
                var WindowTitle = windowInstance && windowInstance.options ? windowInstance.options.title : '';
                var index = openWindows.indexOf(WindowTitle);
                if (index > -1) {
                    openWindows.splice(index, 1);
                }
            }
        };

        //#region View Attachment
        $scope.onDiscussionWindowTabChange = function (TabName) {
            $scope.DataObject.DiscussionWindowActiveTab = TabName;
            switch (TabName) {
                case 'Attachment':
                    $scope.showFileList();
                    break;
                case 'Discussion':
                    setOrderDiscussionUserGroup().then(function (data) {
                        setOrderDiscussionTooltip();
                        setSelectedUserAssignment(data);
                    });
                    break;
            }
        }
        //#endregion

        $scope.CloseDiscussionWindow = function () {
            $scope.isDiscussionVisible = false;
            $scope.onKendoWindowClose();
            $scope.windowClosed($scope.win_Discussion);
            $scope.DataObject.DiscussionWindowActiveTab = 'Discussion';

        }

        $scope.ReReadStudy = function () {
            angular.element("#ConfirmRatingModel").modal('hide');
            $scope.setSelected($scope.SelectedOrder.OrderID, $scope.SelectedOrder);
            $scope.GetAllUsers($scope.SelectedOrder.SiteID).then(function () {
                $scope.AddendumRequest.AssignedUser = _.find($scope.Radiologists, { Id: $scope.SelectedOrder.SignBy });
                $scope.onAddendumUserSelect();
                $scope.DataObject.StudyReReadReason = null;
                $scope.currentWindow = 'win_addendum_request';
                OpenWindow($scope.win_addendum_request, 'win_addendum_request');
                $scope.win_addendum_request.wrapper.prev(".k-overlay").addClass("custom-overlay");
            });
        }
        $scope.AddStudyRatings = function () {
            angular.element("#ConfirmRatingModel").modal('show');
        }

        $scope.RateReport = function () {
            angular.element("#ConfirmRatingModel").modal('hide');
            if ($scope.DataObject.StudyRating.Ratings > 0) {
                var timeout = $timeout(function () {
                    $scope.SelectedOrder.Rating = _.clone($scope.DataObject.StudyRating);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
                var PhysicianName = $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName;
                PhysicianWorklistService.SetStudyRating({
                    OrderID: $scope.SelectedOrder.OrderID,
                    Accession: $scope.SelectedOrder.Accession,
                    ProcedureDesc: $scope.SelectedOrder.ProcedureDesc,
                    Rating: $scope.DataObject.StudyRating.Ratings,
                    Comments: $scope.DataObject.StudyRating.Comment,
                    CreatedBy: $sessionStorage.currentUserData.userId,
                    RenderingPhysicianEmail: $scope.SelectedOrder.RenderingPhysicianEmail,
                    Modality: $scope.SelectedOrder.Modality,
                    OrderDate: $scope.SelectedOrder.OrderDate,
                    PatientName: $scope.SelectedOrder.PatientName,
                    PatientMRN: $scope.SelectedOrder.PatientMRN,
                    PhysicianName: PhysicianName,
                    ReferringPhysicianName: PhysicianName,
                    SignByName: $scope.SelectedOrder.SignByName,
                }).then(function () {
                    toaster.success("Study Rating Saved Successfully!");
                    refreshWorklistAggrid();
                }, function (err) {
                });

            }
        }
        $scope.HideConfirmRatingModel = function () {
            angular.element("#ConfirmRatingModel").modal('hide');
        }
        $scope.HideShowRateReportAction = function () {
            $scope.DataObject.IsStudyRatingWindowVisible = !$scope.DataObject.IsStudyRatingWindowVisible;
        }

        $scope.GetProvidersList = function (SearchText) {
            var siteIds = $scope.PatientInfo.OrderingPhysicianSite ? $scope.PatientInfo.OrderingPhysicianSite.SiteID : null;
            var obj = {
                SiteID: siteIds,
                Search: SearchText != '' ? SearchText : null,
                UserID: $sessionStorage.currentUserData.userId,
            }
            GetProviders(obj).then(function (result) {
                if (result && result.length > 0) {
                    ProvidersFullList = _.concat(ProvidersFullList, result);
                    $scope.DataObject.MasterData.ProvidersList = _.uniqBy(ProvidersFullList, 'ProviderID');

                    if ($scope.PatientInfo && $scope.PatientInfo.ProviderID && !$scope.DataObject.OrderingPhysician.Provider) {
                        var obj = _.find($scope.DataObject.MasterData.ProvidersList, { 'ProviderID': $scope.PatientInfo.ProviderID });
                        if (!obj) {
                            $scope.GetProvidersList($scope.PatientInfo.OrderingPhysicianLastName + ', ' + $scope.PatientInfo.OrderingPhysicianFirstName);
                        }
                        else {
                            $scope.DataObject.OrderingPhysician.Provider = obj;
                        }
                    }
                }
            });
        }

        function GetProviders(GetProviderObject) {
            var d = $q.defer();
            MappingService.GetProviders(GetProviderObject).then(function (result) {
                d.resolve(result);
            });
            return d.promise;
        }

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();


angular.module('radico.pages.techno')
    .service('PhysicianWorklistService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS,__env) {
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }
        this.GetAllSites = function () {
            return Restangular.one('psorders').one("GetAllSites").get();
        };
        this.GetOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetOrdersList").customPOST(orderListFilter);
        };
        this.GetDICOMOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetDICOMOrdersList").customPOST(orderListFilter);
        };
        //this.GetSitesAndLocations = function () {
        //    return Restangular.one('psorders').one("GetSitesAndLocations").get();
        //};
        this.GetSitesAndLocationsByUserID = function (userID) {
            return Restangular.one('psorders').one("GetSitesAndLocationsByUserID", userID).get();
        };
        this.GetPatientClass = function () {
            return Restangular.one('psorders').one("GetPatientClass").get();
        };
        this.CheckPSUserBySite = function (psuser) {
            return Restangular.one('psorders').one("CheckPSUserBySite").customPOST(psuser);
        };
        this.InsertPSUsersBySIte = function (psuser) {
            return Restangular.one('psorders').one("InsertPSUsersBySIte").customPOST(psuser);
        };
        this.SaveReport = function (reportView) {
            return Restangular.one('psorders').one("SaveReport").customPOST(reportView);
        };
        this.InsertOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("InsertOpenOrder").customPOST(openOrders);
        };
        this.DeleteOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("DeleteOpenOrder").customPOST(openOrders);
        };
        this.GetOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("GetOpenOrder").customPOST(openOrders);
        };
        this.RemoveFromComparison = function (comparisonOrder) {
            return Restangular.one('psorders').one("RemoveFromComparison").customPOST(comparisonOrder);
        };
        this.ShowHideOrder = function (orders) {
            return Restangular.one('psorders').one("ShowHideOrder").customPOST(orders);
        };
        this.GetCurrentDateTime = function () {
            return Restangular.one('psorders').one("GetCurrentDateTime").get();
        };
        this.SetDiscussion = function (data) {
            return Restangular.one('psorders').one("SetDiscussion").customPOST(data);
        };
        this.GetDiscussions = function (data) {
            return Restangular.one('psorders').one("GetDiscussions").customPOST(data);
        };      
        this.GetDiscussionsByIds = function (data) {
            return Restangular.one('psorders').one("GetDiscussionsByIds").customPOST(data);
        };
        this.SetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("SetOrderDiscussion").customPOST(data);
        };
        this.UpdateDicomOrderSTAT = function (data) {
            return Restangular.one('psorders').one("UpdateDicomOrderSTAT").customPOST(data);
        };
        this.ResendReport = function (data) {
            return Restangular.one('psorders').one("ResendReport").customPOST(data);
        };
        this.GetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("GetOrderDiscussion").customPOST(data);
        };
        this.NotifyToUser = function (data) {
            return Restangular.one('psorders').one("NotifyToUser").customPOST(data);
        };
        this.GetAllUsers = function () {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/RadFlowGetUsers ',
                headers: { 'content-type': 'application/json' }
            });
        };
        this.SaveGridSetting = function (param) {
            return Restangular.one('psorders').one("SaveGridSetting").customPOST(param);
        };
        this.GetGridSetting = function (param) {
            return Restangular.one('psorders').one("GetGridSetting").customPOST(param);
        };
        this.GetModality = function () {
            return Restangular.one('psorders').one("GetModality").customPOST();
        };

        this.GetDicomFileByAccession = function (accession) {
            return Restangular.one('psorders').one("GetDicomFileByAccession", accession).get();
        };
        this.GetDicomFileByURI = function (FileRUI) {
            return Restangular.one('psorders').one("GetDicomFileByURI", FileRUI).get();
        };
        this.SavePatientInfo = function (order) {
            return Restangular.one('psorders').one("SavePatientInfo").customPOST(order);
        };
        this.SavePatientContactInfo = function (order) {
            return Restangular.one('psorders').one("SavePatientContactInfo").customPOST(order);
        };
        this.uploadFile = function (formData) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri+ "psorders/uploadFile", formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            });
        };
        this.getFileList = function (DicomOrderId) {
            // Cache-bust: the gateway in front of this API caches GET responses by URL, which was
            // serving a stale file list after new uploads. Appending a changing param keeps this
            // request off that cache until the gateway policy itself is fixed.
            return Restangular.one('psorders').one("getFileList", DicomOrderId).get({ _: new Date().getTime() });
        };
        this.showFile = function (formData) {
            return Restangular.one('psorders').one("ShowFile").customPOST(formData);
        };
        //this.deleteFile = function (Id, DiacomOrderId) {
        //    return Restangular.one('psorders').one("DeleteFile", Id).customGET(DiacomOrderId);
        //};
        this.deleteFile = function (formData) {
            return Restangular.one('psorders').one("DeleteFile").customPOST(formData);
        };
        this.getImagePendingCount = function (userId) {
            return Restangular.one('psorders').one("getImagePendingCount", userId).get();
        };
        this.getOrderDetail = function (order) {
            return Restangular.one('psorders').one("GetOrderDetail").customPOST(order);
        };
        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };
        this.GetTechniqueByLocationID = function (locationId) {
            return Restangular.one('psorders').one("GetTechniqueByLocationID", locationId).get();
        };
        this.SubmitTechnique = function (formData) {
            return Restangular.one('psorders').one("AddTechnique").customPOST(formData);
        };
        this.SetOrderDiscussionAssignment = function (data) {
            return Restangular.one('psorders').one("SetOrderDiscussionAssignment").customPOST(data);
        };
        this.GetOrderDiscussionAssignment = function (data) {
            return Restangular.one('psorders').one("GetOrderDiscussionAssignment").customPOST(data);
        };
        this.SetPatientDiscussionORM = function (data) {
            return Restangular.one('psorders').one("SetPatientDiscussionORM").customPOST(data);
        };
        this.GetPatientORMDiscussion = function (data) {
            return Restangular.one('psorders').one("GetPatientORMDiscussion").customPOST(data);
        };
        this.GetDicomOrderByID = function (DicomOrderID) {
            return Restangular.one('psorders').one("GetDicomOrderByID", DicomOrderID).get();
        };
        this.SendInvite = function (obj) {
            return Restangular.one('psorders').one("SendInvite").customPOST(obj);
        };
        this.GetOrdersTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "GetOrdersTechForm").customPOST(data);
        };
        this.SetOrdersTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "SetOrdersTechForm").customPOST(data);
        };
        this.GetTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "GetTechForm").customPOST(data);
        };
        this.SetTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "SetTechForm").customPOST(data);
        };
        this.UpdateAddendumRequestReportStatus = function (params) {
            return Restangular.one('psorders').one("UpdateAddendumRequestReportStatus").customPOST(params);
        };
        this.UpdateStrokeSTAT = function (params) {
            return Restangular.one('psorders').one("UpdateStrokeSTAT").customPOST(params);
        };
        this.SetStudyRating = function (params) {
            return Restangular.one('psorders').one("SetStudyRating").customPOST(params);
        };
        this.SetOrderPeerReview = function (params) {
            return Restangular.one('psorders').one('SetOrderPeerReview').customPOST(params);
        };
    }]);
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.physician_schedule')
        .controller('ScheduleController', ScheduleController).filter('titleCase', function () {
            return function (input) {
                input = input || '';
                return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            };
        });

    /** @ngInject **/
    function ScheduleController($scope, ScheduleService, $sessionStorage, OnCallScheduleService, ManageLocationService, TechnoService,toastr,toaster,$q) {

        var vm = this;
        $scope.PageSize = 25;
        $scope.CurrentPage = 1;
        $scope.TotalCount = "0";
        $scope.FilterCount = "0";
        $scope.Id = 0;
        $scope.LocationId = '';
        $scope.sProviderId = { Obj: null };
        $scope.sLocationId = { Obj: null };

        $scope.SelectedProvider = { Obj: null };
        $scope.SelectedLocation = { Obj: null };
        initPage();

        function initPage() {
            getSchedule();
            getAllUsers();
            getAllLocation();
        }
        var formatted_date = function (date) {
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' == (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        function getSchedule() {
            $scope.isLoading = true;

            var param = {
                PageNum: $scope.CurrentPage,
                PageSize: $scope.PageSize,
                ProviderId: ($scope.sProviderId.Obj) ? $scope.sProviderId.Obj.Id: null,
                LocationId: ($scope.sLocationId.Obj) ? $scope.sLocationId.Obj.LocationID: null,               
                UserId: $sessionStorage.currentUserData.userId,
            };
            var data = ScheduleService.GetSchedule(param);
            data.then(function (resp) {
                if (resp.length > 0) {
                    $scope.ScheduleList = resp;
                    $scope.TotalCount = resp[0].TotalRec;
                    $scope.FilterCount = $scope.ScheduleList.length;
                }
                else {
                    $scope.ScheduleList = null;
                    $scope.TotalCount = 0;
                    $scope.FilterCount = 0;
                }
                $scope.isLoading = false;
            }, function (err) {
                $scope.isLoading = false;
            });
        }
        function getAllUsers() {
            OnCallScheduleService.GetAllUserByTenant({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
                _.each(result, function (data) {
                    data.FirstName = data.LastName + ", " + data.FirstName;
                });
                $scope.ProviderList = result;
            });
        }
        function getAllLocation() {
            ManageLocationService.GetAllLocations({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.LocationList = result;
            });
        }
        $scope.bindLocationByUserId = function (userId, LocationId) {
            var d = $q.defer();
            if (userId) {
                $scope.UserLocation = [];
                $scope.isLoading = true;
                TechnoService.GetSitesAndLocationsByUserID(userId).then(function (result) {
                    $scope.UserLocation = result;
                    if (LocationId > 0) {
                        $scope.LocationId = LocationId.toString();
                    }
                    $scope.isLoading = false;
                    d.resolve();
                }, function (err) {
                    $scope.isLoading = false;
                    d.reject();
                });
            }
            else {
                d.resolve();
            }
            return d.promise;
        }
        $scope.getSchedule = function () {
            getSchedule();
        }
        $scope.pageChanged = function () {
            getSchedule();
        };
        $scope.changePageSize = function () {
            $scope.CurrentPage = 1;
            getSchedule();
        };
        $scope.DeleteSchedule = function (Id) {

            var cnf = confirm("Are you sure, you want to delete this schedule?");
            if (cnf == true) {
                var param = {
                    Id: Id,
                };
                var data = ScheduleService.DeleteSchedule(param);
                data.then(function (resp) {
                    if (resp.match('success')) {
                        getSchedule();
                        //swal(resp);
                        toaster.success({ body: resp });
                    }
                    $scope.isLoading = false;
                }, function (err) {
                    $scope.isLoading = false;
                });
            }
        };
        
        $scope.AddSchedule = function () {   
            clearControl();
            angular.element('#ScheduleModal').modal('show');
        };
        $scope.EditSchedule = function (data) {
            $scope.Id = data.Id;
            $scope.bindLocationByUserId(data.ProviderId, data.LocationId).then(function (res) {
                $scope.SelectedLocation.Obj = _.find($scope.LocationList, { LocationID: data.LocationId.toString() });
                $scope.SelectedProvider.Obj = _.find($scope.ProviderList, { Id: data.ProviderId})
            });
            $scope.AppointmentDate = new Date(data.AppointmentDate);
            angular.element('#ScheduleModal').modal('show');
        };
        $scope.AddEditSchedule = function () {
            if ($scope.AppointmentDate < new Date()) {
                //swal('Please select future date!');
                toaster.warning({ body: "Please select future date!" });
            }
            else {
                $scope.isLoading = true;
                var param = {
                    Id: $scope.Id,
                    LocationId: $scope.SelectedLocation.Obj.LocationID,
                    ProviderId: $scope.SelectedProvider.Obj.Id,
                    AppointmentDate: formatted_date($scope.AppointmentDate),
                    AddedBy: $sessionStorage.currentUserData.userId
                };
                var data = ScheduleService.addEditSchedule(param);
                data.then(function (resp) {
                    if (resp.match('success')) {
                        clearControl();
                        getSchedule();
                        //swal(resp);
                        toaster.success({ body: resp });
                        angular.element('#ScheduleModal').modal('hide');
                    }
                    $scope.isLoading = false;
                }, function (err) {
                    $scope.isLoading = false;
                });
            }
        };

        function clearControl() {
            $scope.Id = 0;
            $scope.LocationId = '';
            $scope.ProviderId = '';
            $scope.AppointmentDate = '';
            $scope.UserLocation = [];
            $scope.SelectedProvider = { Obj: null };
            $scope.SelectedLocation = { Obj: null };
        }
        // JS for table row active
        angular.element(document).ready(function () {
            setTimeout(function () {
                angular.element(".common-tbl table tr").click(function () {
                    if (angular.element(this).data('clicked', true)) {
                        angular.element(".common-tbl table tr").removeClass('tr-active');
                        angular.element(this).addClass('tr-active');
                    }
                });
            }, 500);
        });
    }

})();

angular.module('radico.pages.physician_schedule')
    .service('ScheduleService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS, __env) {

        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }

        this.GetSchedule = function (data) {
            return Restangular.one('Schedule').one("GetList").customPOST(data);
        };

        this.addEditSchedule = function (data) {
            return Restangular.one('Schedule').one("addEditSchedule").customPOST(data);
        };

        this.DeleteSchedule = function (data) {
            return Restangular.one('Schedule').one("deleteSchedule").customPOST(data);
        };
    }]);




//(function () {
//    "use strict";

//    ScheduleService.$inject = ['$http', '$q', '$window', '$rootScope', '$sessionStorage', 'APP_CONSTANTS'];

//    function ScheduleService($http, $q, $window, $rootScope, $sessionStorage, APP_CONSTANTS) {

//        function urlCore() {
//            return APP_CONSTANTS.apiAuthServiceBaseUri;
//        }

//        function urlBase() {
//            return APP_CONSTANTS.apiResourceServiceBaseUri;
//        }

//        var dataFactory = {};
//        var isEnter = false;
//        var number = 0;

//        var objUsersList;

//        dataFactory.GetSchedule = function (ProviderId, LocationId, CurrentPage, PageSize) {

//            return $http({
//                method: 'get',
//                url: urlBase() + 'Schedule/GetList',
//                params: { xiProviderId: ProviderId, xiLocationId: LocationId, xiCurrentPage: CurrentPage, xiPageSize: PageSize },
//                headers: { 'content-type': 'application/json' }
//            });
//        };
//        dataFactory.UpdatePassword = function (strProviderJson) {
//            return $http({
//                method: 'post',
//                url: urlCore() + '/api/Account/RadFlow_ChangePassword',
//                data: JSON.stringify(strProviderJson),
//                headers: { 'content-type': 'application/json' }
//            });
//        };
//        dataFactory.UpdateUser = function (strProviderJson) {
//            return $http({
//                method: 'post',
//                url: urlCore() + '/api/Account/RadFlow_UpdateUser',
//                data: JSON.stringify(strProviderJson),
//                headers: { 'content-type': 'application/json' }
//            });
//        };


//        return dataFactory;
//    }

//    // Register the service to the 'app' module.
//    angular.module('radico.pages.physician_schedule').factory('ScheduleService', ScheduleService);
//})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('radico.pages.profile')
        .controller('ProfileController', ProfileController)
        .directive('numbersOnly', numbersOnly);
    //.directive('isNumber', function () {
    //    return {
    //        require: 'ngModel',
    //        link: function (scope) {
    //            scope.$watch('wks.number', function (newValue, oldValue) {
    //                var arr = String(newValue).split("");
    //                if (arr.length === 0) return;
    //                if (arr.length === 1 && (arr[0] == '-' || arr[0] === '.')) return;
    //                if (arr.length === 2 && newValue === '-.') return;
    //                if (isNaN(newValue)) {
    //                    scope.wks.number = oldValue;
    //                }
    //            });
    //        }
    //    };
    //});
    function numbersOnly() {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text.replace(/[^0-9]/g, '');

                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    //return undefined;    
                    return '';
                }
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }
    /** @ngInject **/
    function ProfileController($scope, ProfileService, authService, $sessionStorage, ManageLocationService, UserPreferenceService, toaster, $state, $stateParams, $q, $rootScope, TechnoService, CommonService, __env, SharedService, $injector) {

        var vm = this;
        var OriginalUserSettings = null; // Store original user settings for comparison
        vm.Email = "";
        vm.FirstName = "";
        vm.LastName = "";
        vm.Phone = "";
        vm.Password = "";
        vm.ConfirmPassword = "";
        vm.IsReviwer = false;
        vm.TargetRVU = 0;
        vm.Address = {
            AddressLine1: "",
            AddressLine2: "",
            City: "",
            State: "",
            PostalCode: "",
            CountryCode: "",
        };
        //vm.IsAdminUser = false;
        $scope.LocSelected = {};
        $scope.SelectedTenant = {};
        $scope.PaymentContract = { Obj: null };
        $scope.PaymentContractHelperShift = { Obj: null };
        $scope.PaymentCurrencyList = [{ Key: 'USD($)', Value: 'USD' }];
        $scope.AccountTypeList = [];
        $scope.BankAccountDetails = { AccountName: null, AccountNumber: null, PaymentCurrency: $scope.PaymentCurrencyList[0], AccountType: {}, UserID: $sessionStorage.currentUserData.userId };
        $scope.UserRole = false;
        $scope.UserPreferenceFlag = false;
        $scope.PaymentDashBoardFlag = false;
        $scope.PaymentInvoiceFlag = false;
        $scope.PageName = $stateParams.PageName;
        $scope.OpenCIVRSetting = function () {
            $rootScope.$emit("OpenCIVRSetting");
            $rootScope.$broadcast("OpenCIVRSetting");
        }
        $scope.ModalitiesFullList = [];
        $scope.SelectedModality = { Obj: null };
        var SharedVariable = CommonService.getSharedVariables();
        if (SharedVariable && SharedVariable.IsPaymentContractEnabled != null) {
            vm.IsPaymentContractEnabled = SharedVariable.IsPaymentContractEnabled;
            SharedVariable = null;
        }
        $scope.DataObject = {
            PasswordRequirements: __env && __env.PasswordRequirements ? __env.PasswordRequirements.rules : [],
        }
        $scope.TabChange = function (TabName) {
            $scope.PageName = TabName;
            switch (TabName) {
                case 'ProfileMenu':
                    initPage();
                    $scope.UserPreferenceFlag = false;
                    $scope.PaymentDashBoardFlag = false;
                    break;
                case 'UserPreferenceMenu':
                    $scope.UserPreferenceFlag = true;
                    $scope.PaymentDashBoardFlag = false;
                    break;
                case 'PaymentDashBoardMenu':
                    $scope.UserPreferenceFlag = false;
                    $scope.PaymentDashBoardFlag = true;
                    break;
            }
            angular.element(".right-dashboard").animate({ scrollTop: 0 }, "fast");
        }
        var $collapse12El = angular.element('#collapse12');
        $collapse12El.on('hidden.bs.collapse', function () {
            vm.Password = '';
            vm.CurrentPassword = '';
            vm.ConfirmPassword = '';
            $scope.frmChangePassword._pwdFocused = false;
        });
        $scope.Speciality = { Obj: [] };
        $scope.TabChange($scope.PageName);
        $scope.SpecialityDropdownProfile = {
            divId: "SpecialityDropdownProfile",
            keys: ['SpecialityCode'],
            uniqKey: 'SpecialityId',
            placeHolder: "Select Speciality",
            SelectedValue: { list: [] },
        }
        $scope.SpecialityList = [];
        $scope.isPCAvailable = false;
        function initPage() {
            $scope.CountryCodes = CommonService.GetCountryCode();
            CommonService.startNotifyTATStudy();
            if ($sessionStorage.currentUserData) {
                if ($sessionStorage.currentUserData.userRoles.length > 0) {
                    var allowedUser = false;
                    if ($sessionStorage.currentUserData.userRoles.includes('User')) {
                        allowedUser = true;
                        $scope.UserRole = true;
                    }
                    vm.IsTechUser = !allowedUser;
                }
                $q.all([
                    getUserPreference(),
                    getUserData($sessionStorage.currentUserData.userId),
                    getSpeciality(),
                    GetTenantsByUserID(),
                    GetModality(),
                    getAccountType(),
                    GetUserAccountDetails()
                ]).then(function () {
                    GetUserSpecialityMapping();
                    getUserSettingData($sessionStorage.currentUserData.userId);
                }, function (err) { });


            }
        }
        function GetTenantsByUserID() {
            var d = $q.defer();
            ManageLocationService.GetTenantsByUserID({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.TenantByUserID = result;
                $scope.SelectedTenant.Obj = $scope.TenantByUserID;
                d.resolve();
            }, function (err) { d.reject(); });
            return d.promise;
        }

        function getUserData(userId) {
            var d = $q.defer();
            ProfileService.GetDataById(userId).then(function (data) {
                if (data) {
                    var resp = data;
                    vm.UserName = resp.data.UserName;
                    vm.Email = resp.data.Email;
                    vm.FirstName = resp.data.FirstName;
                    vm.LastName = resp.data.LastName;
                    vm.DisplayName = resp.data.DisplayName;
                    vm.Phone = resp.data.PhoneNumber;
                    vm.Passcode = resp.data.Passcode;
                    vm.NPI = resp.data.NPI;
                    vm.UserRoles = resp.data.UserRoles;
                }

                var Address = $sessionStorage.currentUserData.Address;
                if (Address) {
                    vm.AddressLine1 = Address.AddressLine1;
                    vm.AddressLine2 = Address.AddressLine2;
                    vm.City = Address.City;
                    vm.State = Address.State;
                    vm.PostalCode = Address.PostalCode;
                    vm.CountryCode = _.find($scope.CountryCodes, { key: Address.CountryCode });
                    vm.VendorID = Address.VendorID;
                }

                d.resolve();

            });
            return d.promise;
        }
        function getSpeciality() {
            var d = $q.defer();
            var data = ProfileService.GetSpeciality();
            data.then(function (result) {
                $scope.SpecialityList = result.data;
                d.resolve();
            });
            return d.promise;
        }
        function GetModality() {
            var d = $q.defer();
            TechnoService.GetModality().then(function (result) {
                $scope.ModalitiesFullList = result;
                d.resolve();
            });
            return d.promise;

        }
        function getUserSettingData(userId) {
            var data = ProfileService.getUserSettingData(userId);
            data.then(function (resp) {
                if (resp.data) {
                    vm.IsReviwer = resp.data.IsReviewer;
                    vm.TargetRVU = resp.data.TargetRVU;
                    if (resp.data.Modality) {
                        $scope.SelectedModality.Obj = [];
                        _.each((resp.data.Modality).split(","), function (modality) {
                            var selectedModality = _.find($scope.ModalitiesFullList, { Code: modality });
                            if (selectedModality) { $scope.SelectedModality.Obj.push(selectedModality); }
                        });
                    } else {
                        $scope.SelectedModality.Obj = null;
                    }
                    // Store original settings after data is loaded
                    storeOriginalSettings();
                }
            }, function (err) { });
        }
        function GetUserSpecialityMapping() {
            ProfileService.GetUserSpecialityMapping({ UserId: $sessionStorage.currentUserData.userId }).then(function (result) {
                var selectedSpeciality = [];
                _.each(result, function (obj) {
                    var specialty = _.find($scope.SpecialityList, function (specialty) { return specialty.SpecialityId == obj.SpecialityId });
                    if (specialty) { selectedSpeciality.push(specialty); }
                });
                $scope.Speciality.Obj = selectedSpeciality;
                $scope.SpecialityDropdownProfile.SelectedValue = {
                    list: selectedSpeciality
                };
                // Store original settings after specialty mapping is loaded
                storeOriginalSettings();
            }, function (err) { });
        }
        function storeOriginalSettings() {
            // Store original settings for comparison (only if not already stored)
            if (!OriginalUserSettings) {
                OriginalUserSettings = {
                    TargetRVU: angular.copy(vm.TargetRVU),
                    SpecialityIds: angular.copy($scope.Speciality.Obj ? _.map($scope.Speciality.Obj, function (s) { return s.SpecialityId; }) : [])
                };
            }
        }
        function checkPwd(str) {
            var regularExpression = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{12,64}$/;
            return regularExpression.test(str);
        }

        function getSitesByUserId() {
            ProfileService.GetSitesByUserId($sessionStorage.currentUserData.userId).then(function (result) {
                //$scope.LocSelected.Sites = result.data;
                $scope.LocSelected.Sites = [];
                angular.forEach(result.data, function (site) {
                    //var idx = $scope.AllSites.indexOf(site);
                    //var idx = $scope.AllSites.findIndex(record => record.SiteID === site.SiteID);
                    //if (idx != -1) {
                    //    $scope.AllSites.splice(idx, 1);
                    //}
                    //var idx = _.findIndex($scope.AllSites, function (obj) { return obj.SiteID == site.SiteID; });
                    ////var idx = $scope.Radiologists.indexOf(obj[0]);
                    //if (idx != -1) {
                    //    $scope.AllSites.splice(idx, 1);
                    //}
                    var filter = _.find($scope.AllSites, function (item) { return item.SiteID == site.SiteID; });
                    if (filter != null) {
                        $scope.LocSelected.Sites.push(filter);
                    }
                });
            });
        }

        vm.UpdateUser = function () {
            var phonenumber = vm.Phone.toString();
            if (phonenumber.substr(0, 1) !== '+') {
                toaster.warning({ body: "Please enter country with phone number! eg. +1xxxxxxxxxx'" });
            }
            else {
                var User = {
                    UserId: $sessionStorage.currentUserData.userId,
                    UserName: vm.UserName.trim(),
                    Email: vm.Email.trim(),
                    FirstName: vm.FirstName.trim(),
                    LastName: vm.LastName.trim(),
                    PhoneNumber: vm.Phone,
                    DisplayName: vm.DisplayName.trim(),
                    Passcode: vm.Passcode,
                    Address: {
                        AddressLine1: vm.AddressLine1,
                        AddressLine2: vm.AddressLine2,
                        City: vm.City,
                        State: vm.State,
                        PostalCode: vm.PostalCode,
                        CountryCode: vm.CountryCode ? vm.CountryCode.key : '',
                        UserId: $sessionStorage.currentUserData.userId,
                        VendorID: vm.VendorID,
                        CreatedBy: $sessionStorage.currentUserData.userId,
                        ModifiedBy: $sessionStorage.currentUserData.userId,
                    }
                };
                var promiseResponse = ProfileService.UpdateUser(User);
                promiseResponse.then(function (resp) {
                    if (resp.data.toLowerCase().match('error')) {
                        toaster.error({ body: resp.data });
                    }
                    else {
                        $sessionStorage.currentUserData.Address = User.Address;
                        toaster.success({ body: resp.data });
                        logUserEvent("UPDATE PROFILE USER DETAILS");
                    }
                });
            }

        }
        vm.UpdateUserSetting = function () {
            
            var Modalities = _.join(_.map($scope.SelectedModality.Obj, function (modality) { return modality.Code; }), ',');
            var speciality = ProfileService.UpdateUserSetting($sessionStorage.currentUserData.userId, 0, vm.IsReviwer, vm.TargetRVU, Modalities);
            speciality.then(function (resp) {
                toaster.success({ body: "User setting updated successfully." });
            });

            var params = { SpecialityIds: [] };
            if ($scope.Speciality.Obj) {
                _.each($scope.Speciality.Obj, function (obj) {
                    params.SpecialityIds.push({
                        UserID: $sessionStorage.currentUserData.userId,
                        SpecialityId: obj.SpecialityId
                    });
                });
            }
            if (params.SpecialityIds.length == 0) {
                params.SpecialityIds.push({
                    UserID: $sessionStorage.currentUserData.userId,
                    SpecialityId: null
                });
            }
            ProfileService.SetUserSpecialityMapping(params).then(function (res) {
                toaster.success({ body: "User setting updated successfully." });
                
                // Build current settings object for comparison
                var currentSettings = {
                    TargetRVU: vm.TargetRVU,
                    SpecialityIds: $scope.Speciality.Obj ? _.map($scope.Speciality.Obj, function (s) { return s.SpecialityId; }) : []
                };

                // Log user event changes using SharedService
                // Note: fromUserID and toUserID are the same since user is updating their own profile
                var userId = $sessionStorage.currentUserData.userId;
                
                SharedService.logUserEventChanges(
                    OriginalUserSettings,
                    currentSettings,
                    null, // No DICOM object in profile settings
                    userId,
                    userId,
                    "UPDATE PROFILE"
                );
                
                // Update original settings after successful update
                OriginalUserSettings = angular.copy(currentSettings);
            }, function (err) { toaster.error({ body: "Something went wrong!" }); });
        }
        vm.ResetPassword = function () {
            if (vm.Password.trim() == vm.CurrentPassword.trim()) {
                toaster.warning({ body: "Current password and new password should not be same!" });
                return;
            }
            if (vm.Password.trim() != vm.ConfirmPassword.trim()) {
                toaster.warning({ body: "New & confirm password must be same!" });
                return;
            }
            if (!checkPwd(vm.Password.trim())) {
                toaster.warning({ body: __env.PassowordPatternMessage });
                return;
            }
            var User = {
                UserId: $sessionStorage.currentUserData.userId,
                UserName: vm.UserName.trim(),
                OldPassword: vm.CurrentPassword.trim(),
                NewPassword: vm.Password.trim(),
            };
            var promiseResponse = ProfileService.UpdatePassword(User);
            promiseResponse.then(function (resp) {
                toaster.success({ body: resp.data });
                if (resp.data.match('has been')) {
                    vm.Password = '';
                    vm.CurrentPassword = '';
                    vm.ConfirmPassword = '';
                    logUserEvent("UPDATE PROFILE CHANGE PASSWORD");
                }
            }).catch(function (error) {
                if (error && error.data && error.data.Message) {
                    toaster.error({ body: error.data.Message });
                }
            });
        }

        vm.ResetPasscode = function () {

            if (vm.NewPasscode.length < 4) {
                toaster.warning({ body: "Pin must be atleast 4 digit!" });

            }
            else if (vm.NewPasscode != vm.ConfirmPasscode) {
                toaster.warning({ body: "New pin and confirm pin  must be same!" });

            }
            else if (vm.NewPasscode == vm.CurrentPasscode) {
                toaster.warning({ body: "New pin and current pin must be different!" });

            }
            else if (vm.Passcode === vm.CurrentPasscode) {
                var promiseResponse = authService.forgotPasscode(vm.UserName.trim(), vm.NewPasscode.trim());
                promiseResponse.then(function (resp) {
                    if (resp.data.toLowerCase().match('error') || resp.data.toLowerCase().match('incorrect')) {
                        toaster.error({ body: resp.data });
                    } else {
                        toaster.success({ body: resp.data });
                    }
                    if (resp.data.match('has been')) {
                        vm.Passcode = vm.NewPasscode;
                        vm.NewPasscode = '';
                        vm.CurrentPasscode = '';
                        vm.ConfirmPasscode = '';
                        logUserEvent("UPDATE PROFILE CHANGE PASSCODE");
                    }
                });
            }
            else {
                toaster.error({ body: "Invalid current pin!" });

            }
        }

        vm.GetAllSites = function () {
            ProfileService.GetAllSites($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.AllSites = result;
                getSitesByUserId();
            });
        };
        vm.MapSites = function () {
            //if ($scope.LocSelected.Sites.length > 0) {
            var ids = "";
            _.each($scope.LocSelected.Sites, function (data) {
                ids = ids + "," + data.SiteID;
            });

            var promiseResponse = ProfileService.MapUserSites(ids, $sessionStorage.currentUserData.userId);
            promiseResponse.then(function (resp) {
                toaster.info({ body: "Selected sites mapped with users." });

            });
            //}
            //else {
            //    swal('Please select at least one Site!');
            //}
        };
        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };

        //document.body.style.overflowY = 'auto';

        function getUserPreference() {
            var d = $q.defer();

            var userPreference = {
                UserID: $sessionStorage.currentUserData.userId,
            };
            UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
                if (result != null) {
                    if (result.UserAccountDetails.IsPaymentContractEnabled) {
                        $scope.isPCAvailable = true;
                    }
                }
                d.resolve();
            }, function (err) { d.reject(); });

            return d.promise;
        }

        $scope.SaveUserAccountDetails = function () {
            var filter = _.clone($scope.BankAccountDetails);
            if ($scope.BankAccountDetails && $scope.BankAccountDetails.AccountType) {
                filter.AccountTypeID = $scope.BankAccountDetails.AccountType.AccountTypeID;
                filter.PaymentCurrency = $scope.BankAccountDetails.PaymentCurrency.Value;
                filter.Email = vm.Email;
                filter.Phone = vm.Phone;
                SetUserAccountDetails(filter).then(function () {
                    toaster.success({ body: 'Your account details updated successfully' });
                    GetUserAccountDetails();
                });
            }
        }

        $scope.checkout = function () {
            $state.go('payment-dashboard');
        }
        $scope.clearSelectedModality = function () {
            $scope.SelectedModality = { Obj: null };
        }
        $scope.onSpecialitySelected = function (selectedData) {
            $scope.Speciality.Obj = selectedData;
        }
        function SetUserAccountDetails(filter) {
            var d = $q.defer();
            ProfileService.SetUserAccountDetails(filter).then(function () {
                d.resolve();
            });
            return d.promise;
        }
        function GetUserAccountDetails() {
            var d = $q.defer();
            var obj = {
                PageNum: 1,
                PageSize: 50,
                OrderByField: 'AccountName',
                OrderBy: 'desc',
                UserIDs: $sessionStorage.currentUserData.userId,
            };
            ProfileService.GetUserAccountDetails(obj).then(function (result) {
                if (result && result.length > 0) {
                    getUserAccountDetails(result[0]);
                }
                else {
                    $scope.BankAccountDetails.AccountType = _.find($scope.AccountTypeList, { AccountTypeID: '1' });
                }
                d.resolve();
            });
            return d.promise;
        }


        function getAccountType() {
            var d = $q.defer();
            ProfileService.GetAccountType().then(function (result) {
                if (result && result.length > 0) {
                    $scope.AccountTypeList = result;
                }
                d.resolve();
            });
            return d.promise;
        }

        function getUserAccountDetails(UserAccountDetail) {
            $scope.BankAccountDetails = UserAccountDetail;
            if (UserAccountDetail.PaymentCurrency) {
                $scope.BankAccountDetails.PaymentCurrency = _.find($scope.PaymentCurrencyList, { Value: UserAccountDetail.PaymentCurrency });
            }
            if (UserAccountDetail.AccountTypeID) {
                $scope.BankAccountDetails.AccountType = _.find($scope.AccountTypeList, { AccountTypeID: UserAccountDetail.AccountTypeID });
            }
        }

        function logUserEvent(eventName) {
            var userId = $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '';
            if (userId) {
                var AccountManagerService = $injector.get('AccountManagerService');
                var UserEventLog = [{
                    FromUserID: userId,
                    ToUserID: userId,
                    EventName: eventName
                }];
                AccountManagerService.AddUserEvent(UserEventLog);
            }
        }

        $scope.$on('$destroy', function () {
            CommonService.stopNotifyTATStudy();
        });

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }

})();

(function () {
    "use strict";

    ProfileService.$inject = ['$http', 'APP_CONSTANTS', 'Restangular', '__env'];

    function ProfileService($http, APP_CONSTANTS, Restangular, __env) {

        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }

        //function urlBase() {
        //    return '/api/ChatGroup';
        //}

        var dataFactory = {};
        //var isEnter = false;
        //var number = 0;

        //var objUsersList;

        dataFactory.GetDataById = function (userId) {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/GetUserDataById',
                params: { Id: userId },
                headers: { 'content-type': 'application/json' }
            });
        };
        dataFactory.UpdatePassword = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/RadFlow_ChangePassword',
                data: JSON.stringify(strProviderJson),
                headers: { 'content-type': 'application/json' }
            });
        };
        dataFactory.UpdateUser = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/RadFlow_UpdateUser',
                data: JSON.stringify(strProviderJson),
                headers: { 'content-type': 'application/json' }
            });
        };

        dataFactory.getUserSettingData = function (UserId) {
            return $http({
                method: 'post',
                url: __env._environment.config.apiResourceServiceBaseUri + 'User/GetUserSettingData',
                data: JSON.stringify({ UserId: UserId }),
                headers: { 'content-type': 'application/json' }
            });
        };
        dataFactory.GetSpeciality = function () {
            return $http({
                method: 'get',
                url: __env._environment.config.apiResourceServiceBaseUri + 'Settings/GetAllSpeciality',
                headers: { 'content-type': 'application/json' }
            });
        };
        dataFactory.UpdateUserSetting = function (UserId, SpecialityId, IsReviwer, TargetRVU, Modality) {
            return $http({
                method: 'post',
                url: __env._environment.config.apiResourceServiceBaseUri + 'User/UpdateUserSetting',
                data: JSON.stringify({ UserId: UserId, SpecialityId: SpecialityId, IsReviwer: IsReviwer, TargetRVU: TargetRVU, Modality: Modality }),
                headers: { 'content-type': 'application/json' }
            });
        };

        dataFactory.GetAllSites = function () {
            return $http({
                method: 'get',
                url: __env._environment.config.apiResourceServiceBaseUri + 'Settings/GetAllSites',
                headers: { 'content-type': 'application/json' }
            });
        };
        dataFactory.GetAllSites = function (UserID) {
            return Restangular.one('Settings').one("GetAllSites", UserID).get();
        };
        dataFactory.MapUserSites = function (SiteIds, userId) {
            return $http({
                method: 'post',
                url: __env._environment.config.apiResourceServiceBaseUri + 'User/MapUserSites',
                data: JSON.stringify({ SiteIds: SiteIds, userId: userId }),
                headers: { 'content-type': 'application/json' }
            });
        };
        dataFactory.GetSitesByUserId = function (userId) {
            return $http({
                method: 'get',
                url: __env._environment.config.apiResourceServiceBaseUri + 'User/GetSitesByUserId',
                params: { userId: userId },
                headers: { 'content-type': 'application/json' }
            });
        };
        dataFactory.getUserRole = function (userId) {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/RadFlow_GetUserRoleById',
                params: { UserId: userId },
                headers: { 'content-type': 'application/json' }
            });
        };
        dataFactory.SetDeviceToken = function (data) {
            return Restangular.one('User').one("SetDeviceToken").customPOST(data);
        };
        dataFactory.SetUserAccountDetails = function (data) {
            return Restangular.one('User').one("SetUserAccountDetails").customPOST(data);
        };
        dataFactory.GetUserAccountDetails = function (data) {
            return Restangular.one('User').one("GetUserAccountDetails").customPOST(data);
        };
        dataFactory.SetUserSpecialityMapping = function (params) {
            return Restangular.one('User').one("SetUserSpecialityMapping").customPOST(params);
        };
        dataFactory.GetUserSpecialityMapping = function (params) {
            return Restangular.one('User').one("GetUserSpecialityMapping").customPOST(params);
        };
        dataFactory.SetUserExcludedSpecialityMapping = function (params) {
            return Restangular.one('User').one("SetUserExcludedSpecialityMapping").customPOST(params);
        };
        dataFactory.GetUserExcludedSpecialityMapping = function (UserId) {
            return Restangular.one('User').one("GetUserExcludedSpecialityMapping", UserId).get();
        };
        dataFactory.GetAccountType = function () {
            return Restangular.one('User').one("GetAccountType").customPOST();
        };
        dataFactory.GetSiteMarqueeSetting = function (UserID) {
            return Restangular.one('User').one("GetSiteMarqueeSetting", UserID).get();
        };
        dataFactory.GetUserVendorDetails = function (UserID) {
            return Restangular.one('User').one("GetUserVendorDetails", UserID).get();
        };
        return dataFactory;
    }

    // Register the service to the 'app' module.
    angular.module('radico.pages.account.list').factory('ProfileService', ProfileService);
})();
angular.module('radico.pages.profile')
    .service('UserPreferenceService', ['Restangular', function (Restangular) {

        this.AddEditUserPreferences = function (userPreference) {
            return Restangular.one('Settings').one("AddEditUserPreferences").customPOST(userPreference);
        };
        this.GetUserPreferences = function (userPreference) {
            return Restangular.one('Settings').one("GetUserPreferences").customPOST(userPreference);
        };
        this.GetUserWorkList = function (userPreference) {
            return Restangular.one('Settings').one("GetUserWorkList").customPOST(userPreference);
        };

        this.GetRadflowUIVersion = function () {
            return Restangular.one('Settings').one("GetRadflowUIVersion").get();
        };

        this.SetUserSiteViewer = function (params) {
            return Restangular.one('Settings').one("SetUserSiteViewer").customPOST(params);
        };
        this.GetDicomViewerByUserId = function (UserID) {
            return Restangular.one('Settings').one("GetDicomViewerByUserId", UserID).get();
        };
        this.GetRadPodDoctorDetailByUserID = function (UserID) {
            return Restangular.one('Settings').one("GetRadPodDoctorDetailByUserID", UserID).get();
        };
        this.IsAddendumRequestVisible = function (UserID) {
            return Restangular.one('psorders').one("IsAddendumRequestVisible").customPOST();
        };
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.prtg')
        .controller('PRTGController', PRTGController);
    function PRTGController($scope, PRTGService, $interval, $sessionStorage, $q, SharedService) {
        var prtgInterval = null;
        var canceller = $q.defer();

        $scope.DataObject = {
            selectedInterval: { optionValue: "30 Second", value: 30000 },
            prtgData: [],
            isLoading: {
                pageInit: false,
                value: false
            },
            SiteList: [],
        }

        $scope.DataObject.IntervalTime = [
            { optionValue: "30 Second", value: 30000 },
            { optionValue: "60 Second", value: 60000 },
            { optionValue: "90 Second", value: 90000 },
        ];

        function pageInIt() {
            GetAllPRTGSites().then(function () {
                GetPrtgData();
                $scope.changeInterval();
            });
        }

        function GetPrtgData() {
            _.each($scope.DataObject.SiteList, function (site) {
                site.isLoading = true;
                GetPrtgDataBySite(site).then(function (result) {
                    site.SensorData = result.SensorData;
                    site.isLoading = false;
                }, function (err) { site.isLoading = false; });
            });
        }
        function GetPrtgDataBySite(site) {
            var d = $q.defer();
            PRTGService.GetPrtgDataBySite(site, canceller.promise).then(function (result) {
                d.resolve(result);
            }, function () { d.resolve([]); })
            return d.promise;
        }

        $scope.changeInterval = function () {
            if (prtgInterval) {
                $interval.cancel(prtgInterval);
                prtgInterval = undefined;
            }
            if ($scope.DataObject.selectedInterval && $scope.DataObject.selectedInterval.value) {
                prtgInterval = $interval(function () {
                    GetPrtgData();
                }, $scope.DataObject.selectedInterval.value);
            }
        };

        function GetAllPRTGSites() {
            var d = $q.defer();
            PRTGService.GetAllPRTGSites($sessionStorage.currentUserData.userId, canceller.promise).then(function (result) {
                $scope.DataObject.SiteList = result;
                d.resolve(result);
            }, function (err) { d.resolve([]); });
            return d.promise;
        }

        if ($scope) {
            $scope.$on('$destroy', function () {
                canceller.resolve('navigated away');
                $interval.cancel(prtgInterval);
                prtgInterval = undefined;
            });
        }

        pageInIt();

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();


angular.module('radico.pages.prtg')
    .service('PRTGService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS, __env) {
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }
        this.GetPrtgDataBySite = function (site, canceller) {
            var config = canceller ? { timeout: canceller } : {};
            return Restangular.one('PRTG').one("GetPrtgDataBySite").withHttpConfig(config).customPOST(site);
        };
        this.GetAllPRTGSites = function (UserID, canceller) {
            var config = canceller ? { timeout: canceller } : {};
            return Restangular.one('PRTG').one("GetAllPRTGSites", UserID).withHttpConfig(config).get();
        };
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.revieworder')
        .controller('ReviewOrderController', ReviewOrderController);
    function ReviewOrderController($scope, ReviewOrderService, WorklistService, $state, $sessionStorage, TechnoService, APP_CONSTANTS, AppHubService, $window, $q, toaster, UserLayoutPrefService, $timeout, $filter, windowHandler, UserPreferenceService, $compile, RCService, RuleService, $rootScope, __env, CommonService, $stateParams, SharedService) {
        if ($sessionStorage.ShowModalIESettings) {
            $state.go('iewarning');
            return;
        }
        var AppHub;
        var parser = new UAParser();
        $scope.halfScale = $(window).width() < 1199;
        var HTMLHeadContent = '';
        var HTMLBodyContent = '';
        var HTMLContent = '';
        var PeerReviewReportDetails = [];
        var TimeoutList = [];
        var showUserGuidePeer = undefined;
        var TourFlag = $stateParams.TourFlag;
        $scope.DataObject = {
            GridSettingList: [],
            ReviewStatus: "Pending",
            SelectedList: {},
            SingReport: {
                Index: 0,
            },
            LastOpenedOrderID: "",
            ChooseNextStudy: false,
            reviewMenuExists: false,
            win_ReviewWidth: $scope.halfScale ? "90%" : "80%",
            win_ReviewHeight: $scope.halfScale ? "835" : "750",
            win_DicomViewerCredentialsWidth: "30%",
            CloseFrom: "",
            browser: parser.getBrowser().name,
            SelectedLocations: {
                Ids: '',
                locations: [],
                divId: "PeerReview"
            },
            SendMailEmailIDs: [],
            DefaultDicomViewer: "",
            SelectedOrder: {},
            ScoreOption: {},
            isPrevBtnDisable: false,
            isNextBtnDisable: false,
            ReportType: 0,
            ReportData: {
                ReportDate: new Date(),
                ShowExportAndMail: true,
                PhysicianName: null,
                TenantName: null
            },
            DisableReportFilter: true,
            ReportTypes: [{ Key: "0", Value: 'Tenant Overall Report' }, { Key: "1", Value: 'Individual Physician Report' }, { Key: "2", Value: 'Physician Reviewed Record Summary' }],
            OrderDateTooltip: "DOS",
            isDataLoading: false,
            LastOrder: {},
            ReportSiteDropdown: {
                divId: "ReportSiteDropdown",
                keys: ['Site'],
                uniqKey: 'SiteID',
                placeHolder: "Select Sites",
                SelectedValue: { list: [] },
            },
        };

        $(window).resize(function () {
            adjustSize();
        });

        function adjustSize() {
            // For small screens, maximize the window when it is shown.
            // You can also make the check again in $(window).resize if you want to
            // but you will have to change the way to reference the widget and then
            // to use $("#theWindow").data("kendoWindow").
            // Alternatively, you may want to .center() the window.
            //alert($(window).width());

            if ($scope.currentWindow == "win_Review") {
                $scope.DataObject.win_ReviewWidth = $scope.halfScale ? "90%" : "80%";
                $scope.DataObject.win_ReviewHeight = $scope.halfScale ? "835" : "750";
                $scope.win_Review.center();
            } else if ($scope.currentWindow == "win_DicomViewerCredentials") {
                $scope.win_DicomViewerCredentials.center();
            }
            return true;
        }
        //Repot pop up resize
        $scope.winDragend = function (e) {
            adjustSize();
        }
        $scope.winResize = function (e) {
            adjustSize();
        }

        //Custom date range settings
        $scope.OrderDate = {
            //startDate: moment().subtract(1, "days"),
            //endDate: moment()
            startDate: null,
            endDate: null
        };
        $scope.ReportOrderDate = {
            //startDate: moment().subtract(1, "days"),
            //endDate: moment()
            startDate: null,
            endDate: null
        };
        $scope.opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.OrderDate = {
                    startDate: null,
                    endDate: null
                }
            },
            ranges: {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
            },
            eventHandlers: {
                'apply.daterangepicker': function (event, picker) {
                    $scope.DataObject.OrderDateTooltip = $scope.OrderDate.startDate && $scope.OrderDate.endDate ? 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                }
            }
        };

        $scope.reportOpts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.ReportOrderDate = {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                }
            },
            ranges: {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
            },
            eventHandlers: {
                'apply.daterangepicker': function (event, picker) {
                    //$scope.ReportClearFilter();
                }
            }
        };
        angular.element(document).ready(function () {
            angular.element('.drp-buttons .cancelBtn').click(function () {
                angular.element('#daterange3').val('');
                $scope.OrderDate = {
                    startDate: null,
                    endDate: null
                };
            });

        });
        //Custom date range settings end


        $scope.formatted_date = function (date) {
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' === (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        $scope.refresh = function () {
            if (!gridOptions || !gridOptions.api) return;
            if ($scope.DataObject.ReviewStatus == 'Complete') {
                gridOptions.api.setColumnDefs(reviewedColumnDefs);
            }
            else {
                gridOptions.api.setColumnDefs(columnDefs);
            }
            resetGrid();
            //$scope.orderListFilter = {
            //    SiteID: $scope.SelectedList.Site ? $scope.SelectedList.Site.SiteID : null,
            //    LocationID: $scope.SelectedList.locationIDs,
            //    Accession: $scope.Accession,
            //    OrderDateStartDate: ($scope.OrderDate.startDate) ? moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") : null,
            //    OrderDateEndDate: ($scope.OrderDate.endDate) ? moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY") : null,
            //    PatientName: $scope.PatientName,
            //    PatientMRN: $scope.PatientMRN,
            //    PatientDOB: $scope.formatted_date($scope.DOB),
            //    PatientClass: $scope.SelectedList.PatientClass ? $scope.SelectedList.PatientClass.PatClass : null,
            //    OrderingPhysician: $scope.OrderingPhysician,
            //    //39.After applying the status pending & completed status to peer review records are displayed
            //    //Status: $scope.Status,
            //    Reviewby: $sessionStorage.currentUserData.userId,
            //    ReviewStatus: $scope.ReviewStatus
            //};
            //if ($scope.WorkList_GridOptions) {
            //    $scope.WorkList_GridOptions.dataSource.page(1);
            //}
        };

        $scope.clearFilter = function () {
            $scope.PageNo = 1;
            $scope.PageSize = "25";
            //$scope.Status = "RP";
            $scope.DataObject.SelectedList.Site = [];
            $scope.DataObject.ReportSiteDropdown.SelectedValue = {
                list: []
            };
            $scope.DataObject.SelectedList.Location = null;
            $scope.DataObject.SelectedList.locationIDs = null;
            $scope.Accession = "";
            $scope.OrderDate = {
                startDate: null,
                endDate: null
            };
            $scope.PatientName = "";
            $scope.PatientMRN = "";
            $scope.DOB = "";
            $scope.DataObject.SelectedList.PatientClass = null;
            $scope.OrderingPhysician = "";
            //39.After applying the status pending & completed status to peer review records are displayed
            $scope.DataObject.ReviewStatus = "Pending";
            $scope.DataObject.SelectedLocations = {
                Ids: '',
                locations: [],
                divId: "PeerReview"
            }
            $scope.refresh();
        };
        $scope.GetAllSitesAndLocations = function () {
            //ReviewOrderService.GetAllSitesAndLocations().then(function (result) {
            TechnoService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.Locations = result;
                $scope.DataObject.Tenants = _.uniqBy(_.map(_.sortBy($scope.Locations, 'TenantName'), function (loc) { return { 'TenantName': loc.TenantName, 'TenantID': loc.TenantID } }), 'TenantID');
            });
        };

        /**
         * Modified By: Tejas Parikh
         * Task 22822: All sites should be listed in alphabetical manner in location filter list
         * @param {any} a
         * @param {any} b
         */
        function compare(a, b) {
            // Use toUpperCase() to ignore character casing
            var bandA = a.text.toUpperCase();
            var bandB = b.text.toUpperCase();

            var comparison = 0;
            if (bandA > bandB) {
                comparison = 1;
            } else if (bandA < bandB) {
                comparison = -1;
            }
            return comparison;
        }



        function PageInIt() {
            GetUserPreferences();
            $scope.GetAllSitesAndLocations();
            getUserLayoutPrefrence().then(function (res) {
                initGrid();
            });
            //$scope.refresh();
            intiAppHub();
            getLookUpByType();
            $scope.DataObject.ScoreOption = [
                { Key: '1', Value: 'Concur with Interpretation', htmlTemplate: '<div class="txt-clr-1"> Self Explanatory </div>' },
                {
                    Key: '2',
                    Value: 'Discrepancy in Interpretation/not ordinarily expected to be made(understandable miss)',
                    SubValue: [
                        { Key: '2a', Value: 'Unlikely to be signficant', htmlTemplate: '<div><ul class= "pl-15px txt-clr-1"><li>Small knee collateral ligament tear (i.e., subtle or difficult to appreciate finding)</li><li>Osteopoikilosis that is not clinically significant (i.e., esoteric finding)</li><li>﻿﻿7mm mesenteric lymph node on CT abdomen</li> <li>Small (5mm) apical pneumothorax on overpenetrated portable chest radiograph following subelavian line placement</li><li>﻿﻿Minimally calcified < 3cm abdominal aortic aneurysm on KUB</li><li>Old, healed long bone fracture (i.e., apparent on single view)</li><li>﻿﻿Subtle mass (probable benign lymph node) on mammography</li></ul></div>' },
                        { Key: '2b', Value: 'Likely to be signficant', htmlTemplate: '<div><ul class="pl-15px txt-clr-1"><li>Subtle or early lung cancer seen on chest CT in retrospect (i.e., difficult to diagnose prospectively)</li><li>Subtle meningeal enhancement on CT or MRI brain</li><li>﻿﻿Small subdural hematoma around cerebellar tentorium</li> <li>Subtle scapholunate separation</li><li>﻿﻿Small minimally radiopaque soft tissue glass foreign body in hand radiograph</li><li>Subtle 1.5cm pancreatic tail mass</li><li>﻿﻿Early vascular calcifications on screening mammography, recalled for additional imaging (overcall)</li></ul></div>' }],

                },
                {
                    Key: '3',
                    Value: 'Discrepancy in Interpretation/Should be made most of time',
                    SubValue: [
                        { Key: '3a', Value: 'Unlikely to be signficant', htmlTemplate: '<div><ul class= "pl-15px txt-clr-1"><li>2cm bone cyst noted on MRI knee</li><li>Pneumoperitoneum on abdominal film of patient 1 day after abdominal surgery</li><li>﻿﻿Vertebral body hemangioma on MRI spine</li> <li>3cm thyroid mass on CT chest</li><li>﻿﻿5mm calcified renal calculus without associated hydronephrosis on CT urogram</li></ul></div>' },
                        { Key: '3b', Value: 'Likely to be signficant', htmlTemplate: '<div><ul class= "pl-15px txt-clr-1"><li>Small subdural hematoma on CT brain</li><li>Skin fold interpreted as pneumothorax in newborn with subsequent placement of chest tube</li><li>﻿﻿Assymmetric 2cm breast mass on CT chest</li> <li>2cm para-aortic or pelvic lymph node</li><li>﻿﻿Peri-appendiceal or peri-colic fat stranding</li><li>1.5cm adrenal mass in patient with lung mass</li><li>﻿﻿Cluster of pleomoplne microcalcifications on inammography</li><li>Pericardial effusion on CT chest</li><li>﻿﻿Short single segment Crohn\'s disease on small bowel follow-through exam</li><li>﻿﻿Lateral meniscus tear on knee MRI</li></ul></div>' }
                    ]
                },
                {
                    Key: '4',
                    Value: 'Discrepancy in Interpretation/Should be made almost every time - misinterpretation of findings',
                    SubValue: [
                        { Key: '4a', Value: 'Unlikely to be signficant', htmlTemplate: '' },
                        { Key: '4b', Value: 'Likely to be signficant', htmlTemplate: '' }
                    ]
                },
            ];
        }

        $scope.SelectedSiteChanged = function (SelectedSite) {
            $scope.Locations = null;
            $scope.DataObject.SelectedList.Location = null;
            //$scope.SelectedSite = SelectedSite;
            var lookup = {};
            var result = [];
            if (SelectedSite) {
                var items = SelectedSite.Locations;
                items.forEach(function (item) {
                    var name = item.Location;

                    if (!(name in lookup)) {
                        lookup[name] = 1;
                        result.push(item);
                    }
                });
            }
            $scope.Locations = result;
        };
        $scope.SaveReviewOrder = function (SaveFlag) {
            switch (SaveFlag) {
                case 'PREV':
                    DisablePrevAndNext($scope.ReviewOrder);
                    OnPrevBtnClick();
                    break;
                case 'NEXT':
                    DisablePrevAndNext($scope.ReviewOrder);
                    OnNextBtnClick();
                    break;
                case 'S':
                    DisablePrevAndNext($scope.ReviewOrder);
                    OnReviewSave();
                    break;
                case 'D':
                    DisablePrevAndNext($scope.ReviewOrder);
                    $scope.ReassignPeerReview($scope.ReviewOrder);
                    break;
            }

        }
        function OnPrevBtnClick() {
            if (OrderList && OrderList.length > 0) {
                var currentOrderIdx = _.findIndex(OrderList, { OrderID: $scope.DataObject.SelectedOrder.OrderID });
                if (currentOrderIdx != -1 && currentOrderIdx < OrderList.length) {
                    $scope.DataObject.SelectedOrder = OrderList[currentOrderIdx - 1];
                    $scope.LoadReviewOrder($scope.DataObject.SelectedOrder);
                }
            }
            else {
                $scope.win_Review.close();
                $scope.refresh();
            }
        }

        function OnNextBtnClick() {
            if (OrderList && OrderList.length > 0) {
                var currentOrderIdx = _.findIndex(OrderList, { OrderID: $scope.DataObject.SelectedOrder.OrderID });
                if (currentOrderIdx != -1 && currentOrderIdx < OrderList.length - 1) {
                    $scope.DataObject.SelectedOrder = OrderList[currentOrderIdx + 1];
                    $scope.LoadReviewOrder($scope.DataObject.SelectedOrder);
                }
                else {
                    $scope.win_Review.close();
                    $scope.refresh();
                }
            }
        }

        function OnReviewSave() {
            $scope.isLoading = true;
            ReviewOrderService.UpdateReviewOrder($scope.ReviewOrder).then(function (result) {
                $scope.DataObject.SelectedOrder.Rating = $scope.ReviewOrder.Rating;
                $scope.DataObject.SelectedOrder.Comments = $scope.ReviewOrder.Comments;
                $scope.DataObject.SelectedOrder.IsInterestingCase = $scope.ReviewOrder.IsInterestingCase;
                $scope.DataObject.SelectedOrder.Keywords = $scope.ReviewOrder.Keywords;
                var idx = _.findIndex(OrderList, { OrderID: $scope.ReviewOrder.OrderID });
                if (idx != -1) {
                    OrderList[idx].ReviewStatus = 'COMPLETE';
                }
                toaster.success('Review Saved Successfully!');
                $timeout(function () {
                    OnNextBtnClick();
                    $scope.isLoading = false;
                }, 2000);
                //$scope.refresh();
                GetPeerReviewPendingCount();
            });
        }

        $scope.ReassignPeerReview = function (Order) {
            if (Order.OrderID && ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId)) {
                $scope.isLoading = true;
                SetReassignPeerReview(Order.OrderID).then(function (data) {
                    $timeout(function () {
                        OnNextBtnClick();
                        $scope.isLoading = false;
                        var idx = _.findIndex(OrderList, { OrderID: Order.OrderID });
                        if (idx != -1) {
                            OrderList[idx].isReassignPeerReview = true;
                        }
                    }, 2000);
                    GetPeerReviewPendingCount();
                });
            }
        }
        $scope.LoadReviewOrder = function (order) {
            if (($scope.DataObject.LastOrder && $scope.DataObject.LastOrder.OrderID) && order.OrderID != $scope.DataObject.LastOrder.OrderID) {
                var accession = $scope.DataObject.LastOrder.Accession;
                windowHandler.CloseWindow(["CI-VIEWER-1-" + accession.toUpperCase().trim(),
                "CI-VIEWER-2-" + accession.toUpperCase().trim(),
                'KONICATEST-' + accession.toUpperCase().trim(),
                "MedDreamViewer-" + accession.toUpperCase().trim(),
                "NORTHSTARKONICA-" + accession.toUpperCase().trim()]);
            }
            $scope.DataObject.LastOrder = order;
            if ($scope.DataObject.DefaultDicomViewer && $scope.DataObject.DefaultDicomViewer.length > 0) {
                order.DicomViewer = $scope.DataObject.DefaultDicomViewer;
            }
            $scope.OpenSynapseStudy(order, order.DicomViewer, false);
            DisablePrevAndNext(order);
            $scope.ReviewOrder = _.clone(order);
            var idx = _.findIndex(OrderList, { OrderID: order.OrderID });
            $scope.DataObject.SelectedOrder.OrderDate = $filter('localDate')($scope.DataObject.SelectedOrder.OrderDate, false, new Date());
            $scope.DataObject.SelectedOrder.CurrentOrderIndex = idx + 1;
            $scope.DataObject.SelectedOrder.TotalRows = OrderList[0].TotalRows;
            if ($scope.DataObject.SelectedOrder.ReportText) {
                var rpt = $scope.DataObject.SelectedOrder.ReportText;
                var firstIndex = rpt.indexOf("ELECTRONICALLY SIGN");
                if (firstIndex != -1) {
                    var secondIndex = rpt.indexOf("\n", firstIndex);
                    var subString = rpt.substring(firstIndex, secondIndex);
                    $scope.DataObject.SelectedOrder.ReportText = rpt.replace(subString, "");
                }
            }
            $scope.currentWindow = "win_Review";
            $scope.win_Review.open();
            $scope.win_Review.wrapper.prev(".k-overlay").addClass("custom-overlay");
            var timeout = $timeout(function () {
                $scope.win_Review.center();
                $timeout.cancel(timeout);
                timeout = null;
            }, 100);
        };

        $scope.setSelected = function (SelectedOrderID, SelectedOrder) {
            $scope.DataObject.SelectedOrderID = SelectedOrderID;
            $scope.DataObject.SelectedOrder = SelectedOrder;
            $scope.SelectedComPatisomOrderID = "";
        };
        $scope.InsertDicomViewerCredentials = function () {
            $scope.isLoading = true;
            var objdata = {
                ID: -1,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: $scope.DVCred.SiteID,
                ViewerName: $scope.DVCred.ViewerName,
                UserName: $scope.DVCred.Username,
                Password: $scope.DVCred.Password,
                Modifyby: $sessionStorage.currentUserData.userId
            };
            ReviewOrderService.InsertDicomViewerCredentials(objdata).then(function (result) {
                //$('#ModalDicomViewerCredentials').modal('hide');
                $scope.win_DicomViewerCredentials.center().close();
                $scope.OpenSynapseStudy($scope.DataObject.SelectedOrder, $scope.SelectedOptionalDV, false);
                $scope.isLoading = false;
            });
        };
        function GetDicomViewerCredentials(SiteID, ViewerName) {
            $scope.DVCred = {};
            var d = $q.defer();
            var out = {};
            var objFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: SiteID,
                ViewerName: ViewerName
            };
            if (__env.CheckDicomViewerCredentials.split(',').indexOf(ViewerName) !== -1) {
                out.RequiredCredentials = true;
                ReviewOrderService.GetDicomViewerCredentials(objFilter).then(function (result) {
                    if (result != null && result.length > 0) {
                        out.RequiredCredentials = true;
                        out.ShowModal = false;
                        out.Credentials = {};
                        out.Credentials.UserName = result[0].UserName;
                        out.Credentials.Password = result[0].Password;
                        d.resolve(out);
                    }
                    else {
                        out.ShowModal = true;
                        $scope.DVCred.SiteID = SiteID;
                        $scope.DVCred.ViewerName = ViewerName;
                        //$('#ModalDicomViewerCredentials').modal('show');
                        $scope.currentWindow = "win_DicomViewerCredentials";
                        $scope.win_DicomViewerCredentials.open();
                        $scope.win_DicomViewerCredentials.wrapper.prev(".k-overlay").addClass("custom-overlay");
                        setTimeout(function () {
                            $scope.win_DicomViewerCredentials.center();
                        }, 1000);
                        d.resolve(out);
                    }
                });
            }
            else {
                out.RequiredCredentials = false;
                out.ShowModal = false;
                d.resolve(out);
            }
            return d.promise;
        }
        $scope.OpenSynapseStudy = function (Order, OptionalDV, isOpenPS) {
            $scope.SelectedOptionalDV = OptionalDV;
            $q.all([
                GetDicomViewerCredentials(Order.SiteID, OptionalDV)
            ]).then(function (data) {
                if (data != null && data[0] != null) {
                    if (data[0].ShowModal) { return; }
                    //else if (data[0].RequiredCredentials) {
                    else {
                        Order.DicomViewerCredentials = data[0].Credentials;
                        if (__env.showLoaderonPSNViewerLoad) {
                            $scope.isLoadingSynapse = true;
                        }
                        OpenSynapseStudy(Order, OptionalDV, isOpenPS);
                    }
                }
            });
        };
        function OpenSynapseStudy(Order, Viewer, isOpenPS) {
            if ($scope.DataObject.browser !== null && $scope.DataObject.browser.toUpperCase() === "IE") {
                if (Viewer === null || Viewer.length === 0 || Viewer === "SYNAPSE") {
                    try {
                        var accession = Order.Accession;
                        if (Order.Site.toUpperCase() == 'DECATUR') {
                            accession = accession.toUpperCase().replace('WHS', '');
                        }
                        var oSynapseAPI = new ActiveXObject("Synapse.SynapseAPI");
                        var sStudyPath = oSynapseAPI.MakePath(1, accession);
                        //oSynapseAPI.OpenSynapseExplorer("Synapse", "https://pacs.texasradiology.com", sStudyPath);
                        oSynapseAPI.OpenSynapseExplorer("Synapse", Order.DicomViewerURL, sStudyPath);

                    } catch (e) {
                        console.log(e);
                        toaster.warning({ body: "Unable to find the image in Synapse." });
                    }
                }
                else if (Viewer === "CANDELIS") {
                    try {
                        //window.open("igplatform://viewer/?request=openstudybyaccession&AccessionNumber=" + Order.Accession, "_self");
                        window.open(__env.candelisURL + encodeURIComponent(Order.Accession), "_self");
                    } catch (e) {
                        console.log(e);
                        toaster.warning({ body: "Unable to find the image in Candelis." });
                    }
                }
                else if (Viewer === "AGFA") {
                    try {
                        //window.open("AgfaHC://impax-client-epr?user=davieric&password=Davieric&domain=Agfa Healthcare&patientid=" + Order.PatientMRN + "&accession=" + Order.Accession, "_self");
                        window.open(__env.agfaURL + encodeURIComponent(Order.PatientMRN.toUpperCase().replace("MHS", "")) + "&accession=" + encodeURIComponent(Order.Accession.toUpperCase().replace("MHS", "")), "_self");
                    } catch (e) {
                        console.log(e);
                        toaster.warning({ body: "Unable to find the image in Agfa." });
                    }
                }
                else if (Viewer === "KONICA" || Viewer == "KONICATEST" || Viewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                    try {
                        /*--- FOR IE -----
                        if ($sessionStorage.KonicaWindow) {
                            $sessionStorage.KonicaWindow.close();
                        }
                        //KonicaWindow = window.open("https://pacs.collaborativeimaging.com/viewer?m_i=0&l=1&def_session=demo_session#viewer2/accession/", "KonicaWindow", "width=1000,height=900,resizable=yes");                                        
                        //$sessionStorage.KonicaWindow = window.open(APP_CONSTANTS.konicaURL + Order.Accession + "/", "_blank", "toolbar=no,menubar=no,scrollbars=no,location=yes,status=no,resizable=yes");
                        $sessionStorage.KonicaWindow = window.open(APP_CONSTANTS.konicaURL + Order.Accession + "/", "_self");
                        //KonicaWindow.location = APP_CONSTANTS.konicaURL + Order.Accession + "/";
                        //KonicaWindow.focus();
                        //-  FOR IE -----------
                        */
                        //window.open(APP_CONSTANTS.konicaURL + Order.Accession + "/", "_self");
                        window.open(__env._environment.config.konicaURL.replace("@MRN", encodeURIComponent(Order.PatientMRN)).replace("@ACCESSION", encodeURIComponent(Order.Accession)).replace("@VIEWER", encodeURIComponent(Viewer)), "_self");
                    } catch (e) {
                        console.log(e);
                        toaster.warning({ body: "Unable to find the image in Konica." });

                    }
                }
                //else if (Viewer == "KONICATEST") {
                //    try {
                //        window.open(APP_CONSTANTS.konicaTestURL.replace("@MRN", Order.PatientMRN).replace("@ACCESSION", Order.Accession).replace("@SITE", Order.Site), "_self");
                //    } catch (e) {
                //        console.log(e);
                //        swal("Unable to find the image in Konica.");
                //    }
                //}
                else if (Viewer === "GECUV") {
                    try {
                        OpenGECentricity(Order.Accession, Order.DicomViewerCredentials);
                    } catch (e) {
                        console.log(e);
                        toaster.warning({ body: "Unable to find the image in Centricity Universal Viewer." });

                    }
                }
                else if (Viewer == "CI-VIEWER") {
                    try {
                        OpenCIDicomViewer(Order.Accession);
                    } catch (e) {
                        console.log(e);
                        toaster.warning({ body: "Unable to find the image in CI-Viewer." });
                    }
                } else if (Viewer == "MedDream") {
                    openMedDream(Order);
                }
                //Open Report in PS
                setTimeout(function () {
                    if (isOpenPS) {
                        try {
                            RadWhereCtrl.Start();
                            //RadWhereCtrl.StopListening();
                            //RadWhereCtrl.StartListening();                
                            //if (!RadWhereCtrl.LoggedIn) {
                            //    var r = RadWhereCtrl.Login('spatel', 'RAD(pass17)');
                            //}
                            //console.log($sessionStorage.PSEvent);
                            //if (!$sessionStorage.PSEvent) {
                            //    console.log("insite");
                            //    RadWhereCtrl.Start();
                            //    $sessionStorage.PSEvent = true;
                            //    RadWhereCtrl.StartListening();
                            //    //setTimeout(function () { RadWhereCtrl.Login('spatel', 'RAD(pass17)'); }, 5000);                    
                            //    if (!RadWhereCtrl.LoggedIn) {
                            //        var r = RadWhereCtrl.Login('spatel', 'RAD(pass17)');
                            //    }
                            //} 
                            //RadWhereCtrl.Login('spatel', 'RAD(pass17)');
                            try {
                                if (RadWhereCtrl.accessionNumbers) {
                                    $scope.DataObject.CloseFrom = "RADFLOW"; //"RADFLOW" , "PS360"
                                    var r = RadWhereCtrl.CloseReport(false, false);
                                    while (!r) {
                                        r = RadWhereCtrl.CloseReport(false, false);
                                    }
                                }
                            }
                            catch (e) {
                                //swal("Unable to find the order in PS360.");
                                console.log(e);
                            }
                            //Synchronize accession with PowerScribe 360
                            RadWhereCtrl.OpenReport(Order.Site, Order.Accession);
                            //RadWhereCtrl.PreviewOrders('', value);

                        } catch (e) {
                            toaster.warning({ body: "Unable to find the order in PS360." });
                            console.log(e);
                        }
                    }
                }, 500);

            }
            else {
                //var param = 'SiteName=' + Order.Site + '%26Accession=' + Order.Accession;
                ////window.open("alert:http://localhost:55180/app/src/OpenSynapse.html#?" + param, "_self");
                ////window.open("alert:http://test1.radamatic.com/OpenSynapse.html#?" + param, "_self");
                ////window.open("alert:https://test2.radamatic.com/OpenSynapse.html#?" + param, "_self");
                ////window.open("alert:" + APP_CONSTANTS.domain + "OpenSynapse.html#?" + param, "_self");
                //window.open("RadFlowIE:" + APP_CONSTANTS.domain + "OpenSynapse.html#?" + param, "_self");

                if (Viewer == "CI-VIEWER") {
                    OpenCIDicomViewer(Order.Accession);
                }
                else if (Viewer == "KONICA" || Viewer == "KONICATEST" || Viewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                    $scope.openKonica(Order, Viewer);
                }
                else if (Viewer == "SYNAPSE") {
                    var accession = Order.Accession;
                    if (Order.Site.toUpperCase() == 'DECATUR') {
                        accession = accession.toUpperCase().replace('WHS', '');
                    }
                    openSynapseImage(Order.DicomViewerURL, accession);
                } else if (Viewer == "MedDream") {
                    openMedDream(Order);
                }

            }
        }
        function OpenGECentricity(Accession, ViewerCrendetials) {
            var map = window.open("", "Map", "status=0,title=0,width=700,height=600,left=500,top=300,scrollbars=1");
            if (map) {
                var form = map.document.createElement('form');
                form.method = 'POST';
                form.action = __env._environment.config.GECentricityURL;

                var userInput = map.document.createElement('input');
                userInput.type = 'hidden';
                userInput.name = 'user_name';
                userInput.value = ViewerCrendetials.UserName;
                form.appendChild(userInput);

                var passInput = map.document.createElement('input');
                passInput.type = 'hidden';
                passInput.name = 'password';
                passInput.value = ViewerCrendetials.Password;
                form.appendChild(passInput);

                var accInput = map.document.createElement('input');
                accInput.type = 'hidden';
                accInput.name = 'accession_number';
                accInput.value = Accession;
                form.appendChild(accInput);

                map.document.body.appendChild(form);
                form.submit();
            } else {
                swal("You must allow pop-ups for this to work.");
            }
        }
        function OpenCIDicomViewer(accession) {
            //accession = 'OAMRISAC-404963';
            //WorklistService.GetDicomImageByAccessionNumber(accession).then(function (result) {
            //    if (result.data != "Dicom file path not found.") {
            //        openRequestedPopup(accession);
            //    }
            //    else {
            //        swal('No image found.');
            //        //Swal.fire("No image found.", "", "info");
            //    }
            //});
            if ($scope.DataObject.browser != null && $scope.DataObject.browser.toUpperCase() == "IE") {
                window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
            }
            else {
                windowHandler.openByPreference(__env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 1), "CI-VIEWER-1", 1000, "CI-VIEWER-1-" + accession.toUpperCase().trim(), "", false);
                //windowHandler.openByPreference(APP_CONSTANTS.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 2), "CI-VIEWER-2", 1000, "", false, isSingleView ? "CI-VIEWER-2-" + accession : null);
            }
        }
        function openRequestedPopup(accession) {
            //console.log(APP_CONSTANTS.ciDICOMViewer + APP_CONSTANTS.ciDICOMViewerAPI + "/app-file/" + accession + ".json");
            //accession = 'OAMRISAC-404963';
            window.open(__env._environment.config.ciDICOMViewer + __env._environment.config.ciDICOMViewerAPI + "/app-file/" + accession + ".json", "_self");

        }
        function openSynapseImage(pacsURL, accessionNumber) {
            RCService.OpenImage({ requestEvent: "openimage", imageRequestDetails: { pacsURL: pacsURL, accessionNumber: accessionNumber } })
        }
        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };
        function intiAppHub() {
            AppHub = AppHubService.getAppHub();
            var justCreated = false;
            if (!AppHub && $sessionStorage.currentUserData) {
                AppHubService.Initialize();
                AppHub = AppHubService.getAppHub();
                justCreated = true;
            }
            if (AppHub) {
                AppHubMethod();
                if (justCreated) AppHubService.startConnection();
            }
        }
        function AppHubMethod() {
            AppHub.on('RadFlowAppHubEvent', function (obj) {
                switch (obj.EventType) {
                    case 'reviewlistupdatehandler':
                        $scope.refresh();
                        break;
                    case 'notifypostorderormqueuemsg':
                        CommonService.notifypostorderormqueuemsg(obj);
                        break;
                }
            });
        }

        //#region Instance peer-review tour
        var tourPeerReview = new Tour({
            steps: [],
            backdrop: true,
            onShown: function (tourPeerReview) {
                if (tourPeerReview && tourPeerReview._options) {
                    var step = tourPeerReview._options.steps[tourPeerReview._current];
                    $(step.element).addClass('tour-section-disbl');
                }
            },
            onHidden: function (tourPeerReview) {
                if (tourPeerReview && tourPeerReview._options) {
                    var step = tourPeerReview._options.steps[tourPeerReview._current];
                    $(step.element).removeClass('tour-section-disbl');
                }
            },
            onEnd: function (tourPeerReview) {
                $('.tour-section-disbl').removeClass('tour-section-disbl');
                updateuserguidepeerpreference()
            },
        });

        tourPeerReview.init();

        function startUserGuidePeerTour() {
            if (!showUserGuidePeer || showUserGuidePeer.PreferenceValue != "0") {
                tourPeerReview.init();
                var timeout = $timeout(function () {
                    $scope.DataObject.ReviewStatus = 'Complete';
                    $scope.refresh();
                    tourPeerReview.setCurrentStep(0);
                    tourPeerReview.start(true);
                }, 2000);
                TimeoutList.push(timeout);

            }
        }
        $scope.$on("PeerReview_Tour", function (evt, data) {
            if (data) {
                TourFlag = true;
                HelpPeerReviewTour();
            }
        });
        //#endregion Instance peer-review tour
        PageInIt();

        $scope.$on('$destroy', function () {
            //$interval.cancel(orderRefreshInterval);
            AppHub.off("RadFlowAppHubEvent");
            windowHandler.DoNotCloseWindow(['Analytics', 'CIVR']);
            $('.popover.tour').css("display", "none");
            $('.tour-backdrop.top').css("display", "none");
            $('.tour-backdrop.bottom').css("display", "none");
            $('.tour-backdrop.left').css("display", "none");
            $('.tour-backdrop.right').css("display", "none");
            tourPeerReview = null;
        });

        //Window resizing
        $(window).resize(function () {
            //resetColumnWidth();
            //abbriateColumneset();
        });

        //resetting the column width on resizing to half scale
        function resetColumnWidth() {
            var grid = $("#WorkList_ListGrid").getKendoGrid();

            var gridTableWidth = grid.table.width();
            if (gridTableWidth < 1000) {
                var halfCalWidth = ['8%', '8%', '6%', '6%', '8%', '6%', '2%', '2%', '5%', '8%', '8%', '3%'];
                for (var i = 0; i < halfCalWidth.length; i++) {
                    $("#WorkList_ListGrid .k-grid-header-wrap").find("colgroup col").eq(i).css({ width: halfCalWidth[i] }); //header
                    $("#WorkList_ListGrid .k-grid-content").find("colgroup col").eq(i).css({ width: halfCalWidth[i] });    //content     


                }
            }
            else {
                var fullCalWidth = ['8%', '8%', '6%', '6%', '8%', '4%', '2%', '2%', '3%', '8%', '8%', '3%'];
                for (var i = 0; i < fullCalWidth.length; i++) {
                    $("#WorkList_ListGrid .k-grid-header-wrap").find("colgroup col").eq(i).css({ width: fullCalWidth[i] }); //header
                    $("#WorkList_ListGrid .k-grid-content").find("colgroup col").eq(i).css({ width: fullCalWidth[i] });    //content

                }
            }
        }

        //make abbraviation of grid header on resizing to half scale
        function abbriateColumneset() {
            var grid = $("#WorkList_ListGrid").getKendoGrid();
            var gridTableWidth = grid.table.width();

            if (gridTableWidth < 1000) {
                $("#WorkList_ListGrid thead [data-field=LOCATION] .k-link").html("LOC");
                $("#WorkList_ListGrid thead [data-field=ACCESSION] .k-link").html("ACC");
                $("#WorkList_ListGrid thead [data-field=PATIENTNAME] .k-link").html("PAT");
                $("#WorkList_ListGrid thead [data-field=SEX] .k-link").html("S");
                $("#WorkList_ListGrid thead [data-field=TYPE] .k-link").html("T");
                $("#WorkList_ListGrid thead [data-field=MODALITY] .k-link").html("MOD");
                $("#WorkList_ListGrid thead [data-field=PROCEDURE] .k-link").html("PRO");
                $("#WorkList_ListGrid thead [data-field=ORDERINGPHYSICIAN] .k-link").html("OPH");

            }
            else {
                $("#WorkList_ListGrid thead [data-field=LOCATION] .k-link").html("Location");
                $("#WorkList_ListGrid thead [data-field=ACCESSION] .k-link").html("Accession");
                $("#WorkList_ListGrid thead [data-field=PATIENTNAME] .k-link").html("Patient Name");
                $("#WorkList_ListGrid thead [data-field=SEX] .k-link").html("Sex");
                $("#WorkList_ListGrid thead [data-field=TYPE] .k-link").html("Type");
                $("#WorkList_ListGrid thead [data-field=MODALITY] .k-link").html("Modality");
                $("#WorkList_ListGrid thead [data-field=PROCEDURE] .k-link").html("Procedure");
                $("#WorkList_ListGrid thead [data-field=ORDERINGPHYSICIAN] .k-link").html("Ordering Physician");

            }
        }
        /**
         * Modified By: Tejas Parikh
         * Task 20956: (Task) There should be reset column grid option present for the worklist, tech worklist, peer review page
         * @param {any} e
         */
        function onSelect(e) {

            //reference checkbox
            var checkbox = $(e.item).find("input");

            //reference the Grid
            var grid = $("#WorkList_ListGrid").getKendoGrid();

            //hold the number of columns
            var numOfColumns = grid.columns.length;

            //loop through to find how many columns are hidden
            for (var i = 0; i < grid.columns.length; i++) {
                if (grid.columns[i].hidden == true) {
                    numOfColumns--;
                }
            }

            //if the field matches the selected item, check if it is hidden or not.
            for (var i = 0; i < grid.columns.length; i++) {
                if (grid.columns[i].title == e.item.innerText) {

                    //Show the hidden column
                    if (grid.columns[i].hidden == true) {
                        grid.showColumn(grid.columns[i].field);

                        //check box
                        $(checkbox).prop("checked", true);

                        //it will hide as long as there is more than one column in the Grid
                    } else if (numOfColumns != 1) {
                        grid.hideColumn(grid.columns[i].field);

                        //uncheck box
                        $(checkbox).prop("checked", false);
                    } else {

                        //check box if it's the last item
                        $(checkbox).prop("checked", true);
                    }
                }
            }

            if (e.item.innerText == "Reset") {
                resetColumns(grid);
                resetColumnWidth();
            }
        }

        function resetColumns(grid) {
            for (var i = 0; i < grid.options.columns.length; i++) {
                var field = grid.options.columns[i].field;
                for (var j = 0; j < grid.columns.length; j++) {
                    if ((field.length > 0) && (grid.columns[j].field.length > 0)) {
                        if (grid.columns[j].field == field) {
                            grid.reorderColumn(i, grid.columns[j]);
                        }
                    }
                }
            }
        }

        function loadGrid() {
            var WorkList_GridOptions = {
                dataSource: new kendo.data.DataSource({
                    transport: {
                        read: function (options) {
                            if (!$scope.orderListFilter) {
                                var data = {
                                    Items: [],
                                    Total: 1,
                                    PageNumber: 50,
                                    Pages: 1
                                };
                                options.success(data);
                                return;
                            }
                            $scope.orderListFilter.PageSize = options.data.pageSize;
                            $scope.orderListFilter.PageNum = options.data.page;
                            $scope.orderListFilter.OrderByField = "";
                            $scope.orderListFilter.OrderBy = false;
                            if (options.data.sort && options.data.sort.length > 0) {
                                $scope.orderListFilter.OrderByField = options.data.sort[0].field;
                                $scope.orderListFilter.OrderBy = options.data.sort[0].dir == 'desc' ? true : false;
                            }
                            ReviewOrderService.GetReviewOrderList($scope.orderListFilter).then(function (result) {
                                $scope.orderList = result;
                                var data = {
                                    Items: $scope.orderList.length === 0 ? [] : $scope.orderList,
                                    Total: $scope.orderList.length > 0 ? $scope.orderList[0].TotalRows : 0,
                                    PageNumber: $scope.orderListFilter.PageSize,
                                    Pages: $scope.orderListFilter.PageSize,
                                }
                                options.success(data);
                            }).catch(function (noCantDo) {
                                var data = {
                                    Items: [],
                                    Total: 1,
                                    PageNumber: 50,
                                    Pages: 1
                                };
                                options.error(data);
                            });
                        }
                    },
                    schema: {
                        data: "Items",
                        total: "Total",
                        errors: "Errors"
                    },
                    pageSize: 50,
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    serverGrouping: true,
                    serverAggregates: true,
                    sort: { field: "DOS", dir: "desc" },
                }),
                dataBound: function (e) {

                    //resizing column
                    resetColumnWidth();
                    //abbriateColumneset();

                    //Fixing First and last columns for buttons only
                    var grid = e.sender;
                    var columns = grid.columns;

                    $scope.lastColumn = columns[columns.length - 1];
                    grid.bind("columnReorder", function (e) {
                        setTimeout(function (e) {

                            grid.reorderColumn(columns.length - 1, $scope.lastColumn);

                        }, 1)
                    });

                    /**
                     * Modified By: Tejas Parikh
                     * Task 20956: (Task) There should be reset column grid option present for the worklist, tech worklist, peer review page
                     * @param {any} id
                     * @param {any} dataSource
                     * @param {any} owner
                     */
                    var createKendoColumnMenu = function (id, dataSource, owner) {
                        var kendoColumnMenu = $(id).kendoColumnMenu({
                            dataSource: dataSource,
                            filterable: false,
                            sortable: false,
                            columns: true,
                            owner: owner
                        });
                    };

                    createKendoColumnMenu('#column-menu-button', grid.dataSource, grid);

                    //reference columns
                    var columnValues = grid.columns;

                    //Create array
                    var checkedValues = [];

                    //for each column, add checked if hidden is undefined
                    $(columnValues).each(function (index) {

                        if (this.hidden == true) {
                            checkedValues.push(" ");
                        } else {
                            checkedValues.push("checked");
                        }
                    });

                    var menuItems = [];
                    var menu = {};
                    menu["text"] = "Columns";
                    var subMenuItems = [];
                    $(columnValues).each(function (index) {
                        if (grid.columns[index].field.length > 0) {
                            var submenu = {};
                            submenu["text"] = "<input type='checkbox' class='cmn-checkbx-input' " + checkedValues[index] + " id='" + grid.columns[index].field + "' />" + grid.columns[index].title;
                            submenu["encoded"] = false;
                            subMenuItems.push(submenu);
                        }
                    });
                    menu["items"] = subMenuItems;
                    menuItems.push(menu);

                    var menu1 = {};
                    menu1["text"] = "Reset";
                    menuItems.push(menu1);

                    $("#context-menu-review").kendoContextMenu({
                        target: "#WorkList_ListGrid",
                        filter: "#menuTargetReview",
                        alignToAnchor: true,
                        copyAnchorStyles: false,
                        showOn: "click",
                        dataSource: menuItems,
                        select: onSelect,
                        closeOnClick: false,
                    });





                    //var menu = $("#columnMenu").data("kendoMenu");
                    //console.log("Menu: " + menu);
                    //menu.append({
                    //    text: "Reset"//Grid columns
                    //});

                    var $gridColumnMenuButton = $(".grid-column-menu").kendoColumnMenu({
                        filterable: false,
                        sortable: false,
                        dataSource: grid.dataSource,
                        columns: true,
                        owner: grid,
                    });

                    $gridColumnMenuButton.on("click", function (e) {
                        //$(this).find(".k-header-column-menu").click();

                        //return false;
                    });
                    //End: Task 20956: (Task) There should be reset column grid option present for the worklist, tech worklist, peer review page
                },
                pageable: {
                    refresh: true,
                    pageSize: 50,
                    pageSizes: [25, 50, 100, 200],
                    buttonCount: 5
                },
                sortable: {
                    allowUnsort: false
                },
                reorderable: true,
                resizable: false,
                columnMenu: false,
                scrollable: true,
                selectable: true,
                height: $window.innerHeight - 242,
                columns: [
                    {
                        field: "LOCATION", title: "Location", width: "8%",
                        template: function (dataItem) {
                            return '<span tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="{{dataItem.Location | UpperCase}}">{{dataItem.Location | UpperCase}}</span>';
                        }
                    },
                    {
                        field: "ACCESSION", title: "Accession", width: "8%",
                        template: function (dataItem) {
                            return '<span tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="{{dataItem.Accession | UpperCase}}">{{dataItem.Accession | UpperCase}}</span>';
                        }
                    },
                    {
                        field: "DOS", title: "DOS", width: "6%",
                        template: function (dataItem) {
                            return "{{dataItem.OrderDate | date:'M/d/yy HH:mm'}}";
                        }
                    },
                    {
                        field: "MRN", title: "MRN", width: "6%",
                        template: function (dataItem) {
                            return '<span tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="{{dataItem.PatientMRN | UpperCase}}">{{dataItem.PatientMRN | UpperCase}}</span>';
                        }
                    },
                    {
                        field: "PATIENTNAME", title: "Patient Name", width: "8%",
                        template: function (dataItem) {
                            return '<span tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="{{dataItem.PatientName | UpperCase}}">{{dataItem.PatientName | UpperCase}}</span>';
                        }
                    },
                    {
                        field: "DOB", title: "DOB", width: "4%",
                        template: function (dataItem) {
                            return "{{dataItem.PatientDOB | date:'M/d/yy'}}";
                        }
                    },
                    {
                        field: "SEX", title: "Sex", width: "2%",
                        template: function (dataItem) {
                            return "{{dataItem.PatientGender | UpperCase}}";
                        }
                    },
                    {
                        field: "TYPE", title: "Type", width: "2%",
                        template: function (dataItem) {
                            return "{{dataItem.PatientClass | UpperCase}}";
                        }
                    },
                    {
                        field: "MODALITY", title: "Modality", width: "3%",
                        template: function (dataItem) {
                            return '<span tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="{{dataItem.Modality | UpperCase}}">{{dataItem.Modality | UpperCase}}</span>';
                        }
                    },
                    {
                        field: "PROCEDURE", title: "Procedure", width: "8%",
                        template: function (dataItem) {
                            return '<span tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="{{dataItem.ProcedureDesc | UpperCase}}">{{dataItem.ProcedureDesc | UpperCase}}</span>';
                        }
                    },
                    {
                        field: "ORDERINGPHYSICIAN", title: "Ordering Physician", width: "8%",
                        template: function (dataItem) {
                            return '<span tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="{{dataItem.OrderingPhysician | UpperCase}}">{{dataItem.OrderingPhysician | UpperCase}}</span>';
                        }
                    },
                    {
                        field: "", title: "", width: "3%",
                        attributes: { class: "text-center p-0" },
                        template: function (dataItem) {
                            return ' <a class="cursor-pointer txt-clr-14" ng-click="LoadReviewOrder(dataItem)"><i class="glyphicon glyphicon-star fs-12px"></i></a>';
                        },
                        headerTemplate: "<span id='menuTargetReview' class='k-icon k-i-more-vertical'></span><ul id='context-menu-review' class='resetsec'></ul>"
                    },
                ],
                change: function (e) {
                    var _item = e.sender.dataItem(e.sender.select());
                    $scope.setSelected(_item.OrderID, _item);
                }
            };


        }
        //loadGrid();
        $scope.OpenViewReport = function () {
            $scope.win_ViewReport.center().open();
        };
        angular.element(document).ready(function () {
            setTimeout(function () {
                var kndFtrDrp = $(".k-grid-pager");
                kndFtrDrp.find(".k-pager-sizes").insertBefore(".k-pager-first");
                // Removes default text near page size.
                angular.element('.k-pager-sizes')
                    .contents()
                    .filter(function () {
                        return this.nodeType === 3;
                    }).remove();
            }, 100)
        });
        function openMedDream(order) {
            SharedService.openMedDreamCommunicationAPI(order, '');
        }

        $scope.updateSelectedLocation = function () {
            $scope.DataObject.SelectedList.locationIDs = $scope.DataObject.SelectedLocations.Ids;
            $scope.DataObject.SelectedList.Location = $scope.DataObject.SelectedLocations.locations;
            angular.element(document).ready(function () {
                if (angular.element('.location-tags-input #PeerReviewtagsId .host .tags .tag-list .tag-item').length > 0) {
                    angular.element('#PeerReviewAGGrid').addClass('setheight-peerrvw');
                } else {
                    angular.element('#PeerReviewAGGrid').removeClass('setheight-peerrvw');
                }
            });
        }
        $scope.updateReportSelectedLocation = function () {
            $scope.DataObject.Report.SelectedList.locationIDs = $scope.DataObject.Report.SelectedLocations.Ids;
            $scope.DataObject.Report.SelectedList.Location = $scope.DataObject.Report.SelectedLocations.locations;
            /*angular.element(document).ready(function () {
                if (angular.element('.location-tags-input #selectedDataTagsInput .host .tags .tag-list .tag-item').length > 0) {
                    angular.element('#PeerReviewAGGrid').addClass('setheight-peerrvw');
                } else {
                    angular.element('#PeerReviewAGGrid').removeClass('setheight-peerrvw');
                }
            });*/
        }
        $scope.SetDicomViewerText = function (DV) {
            var viewer = _.filter($scope.DicomViewers, { "Value": DV });
            if (viewer != null && viewer.length > 0) {
                return viewer[0].Key
            }
        }
        function getLookUpByType() {
            TechnoService.GetLookupByType('DicomViewer,PatientClass').then(function (result) {
                //$scope.ContrastTypeList = result;
                $scope.DicomViewers = _.filter(result, { 'Type': 'DicomViewer' });
                $scope.PatientClass = _.filter(result, { 'Type': 'PatientClass' });
            });
        }
        $scope.openKonica = function (order, Viewer) {
            $scope.konica_RadFlow = windowHandler.openByPreference(__env._environment.config.konicaBaseURL.replace("@MRN", order.PatientMRN).replace("@ACCESSION", order.Accession).replace("@VIEWER", Viewer), Viewer, 100, Viewer.replace(/\s/g, "").toUpperCase() + "-" + order.Accession.toUpperCase().trim(), "noreferrer");
        }

        //#region Ag-Grid
        var OrderList = [];
        var PageSize = 50;
        var TotalRows = 0;
        var UserLayoutOptions = {};
        var sortingString = "";

        var columnDefs = [
            {
                field: "Location",
                tooltipField: "Location",
                /*flex: 1,*/
                initialWidth: 300,
            },
            {
                field: "OrderDate",
                headerName: "DOS",
                cellRenderer: function (params) {
                    var template = "";
                    if (params.node.data) {
                        var val = ($filter('localDate')(params.value, false, new Date()));
                        template = "<span title='" + val + "'>" + val + "</span>";
                    }
                    return template;
                },
                sort: 'desc',
                /*flex: 1,*/
                initialWidth: 200,
            },
            {
                field: "PatientClass",
                headerName: "Type",
                initialWidth: 100
            },
            {
                field: "Modality",
                initialWidth: 100
            },
            {
                field: "ProcedureDesc",
                headerName: "Procedure Description",
                tooltipField: "ProcedureDesc",
                flex: 1,
                minWidth: 100
            },
            {
                field: "Action",
                headerClass: 'hideHeaderTxt arrowcursor',
                cellRenderer: function (params) {
                    return '<button type="button" class="btn btn-primary mb-3px py-0 px-5px" title="Review Pending"><i class="fa fa-star-half-o pr-5px"></i>Review Pending</button>';
                },
                sortable: false,
                resizable: false,
                initialWidth: 170
            },
            {
                field: "Decline",
                headerClass: 'hideHeaderTxt arrowcursor',
                cellRenderer: function (params) {
                    return '<button type="button" class="btn btn-primary mb-3px py-0 px-5px" title="Decline"><i class="fa fa-ban pr-5px"></i>Decline</button>';
                },
                sortable: false,
                resizable: false,
                initialWidth: 170
            },
        ];
        var reviewedColumnDefs = [
            {
                field: "Location",
                tooltipField: "Location",
                /*flex: 1,*/
                initialWidth: 300,
            },
            {
                field: "OrderDate",
                headerName: "DOS",
                cellRenderer: function (params) {
                    var template = "";
                    if (params.node.data) {
                        var val = ($filter('localDate')(params.value, false, new Date()));
                        template = "<span title='" + val + "'>" + val + "</span>";
                    }
                    return template;
                },
                sort: 'desc',
                /*flex: 1,*/
                initialWidth: 200,
            },
            {
                field: "PatientClass",
                headerName: "Type",
                initialWidth: 100
            },
            {
                field: "Modality",
                initialWidth: 100
            },
            {
                field: "ProcedureDesc",
                headerName: "Procedure Description",
                tooltipField: "ProcedureDesc",
                flex: 1,
                minWidth: 100
            },
            {
                field: "Rating",
                headerName: "Rating",
                initialWidth: 300,
                cellRenderer: RatingCellRenderer(),
                cellClass: 'comment-td'
            },
            {
                field: "Keywords",
                headerName: "Keywords",
                initialWidth: 300,
                tooltipField: "Keywords",
            },
            {
                field: "Comments",
                headerName: "Comments",
                initialWidth: 300,
                tooltipField: "Comments",
            },
            {
                field: "Action",
                headerClass: 'hideHeaderTxt arrowcursor',
                cellRenderer: function (params) {
                    return '<button type="button" class="btn btn-primary mb-3px py-0 px-5px" title="Review Complete"><i class="fa fa-star pr-5px"></i>View</button>';
                },
                cellClass: 'justify-content-center d-flex',
                sortable: false,
                resizable: false,
                initialWidth: 100
            }
        ];

        var gridOptions = {
            columnDefs: columnDefs,
            enableBrowserTooltips: true,
            defaultColDef: {
                sortable: true,
                resizable: true,
            },
            rowSelection: 'single',
            rowModelType: 'serverSide',
            cacheBlockSize: PageSize,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            sortingOrder: ['desc', 'asc'],
            popupParent: document.body,
            getContextMenuItems: getContextMenuItems,
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },
            onGridReady: function () {
                var savedState = gridOptions.columnApi.getColumnState();
                if (UserLayoutOptions && UserLayoutOptions.savedState) {
                    gridOptions.columnApi.applyColumnState({ state: UserLayoutOptions.savedState, applyOrder: true });
                } else {
                    UserLayoutOptions.savedState = savedState;
                    gridOptions.columnApi.applyColumnState({ state: UserLayoutOptions.savedState, applyOrder: true });
                }
                var fakeServer = createFakeServer();

                // create datasource with a reference to the fake server
                var datasource = createServerSideDatasource(fakeServer);

                // register the datasource with the grid

                gridOptions.api.setServerSideDatasource(datasource);
                PeerInitTour();
            },
            onCellClicked: onCellClicked,
            onSortChanged: function (params) {
                if (!$scope.DataObject.isDataLoading) {
                    resetGrid();
                    updatedGridUserLayoutPref();
                }
                else {
                    return;
                }
            },
            onColumnMoved: function (params) {
                if (params.finished) {
                    updatedGridUserLayoutPref();
                }
            },
            onColumnVisible: function (params) {
                updatedGridUserLayoutPref();
            },
            onDragStopped: function (params) {
                updatedGridUserLayoutPref();
            },
            onRowDoubleClicked: function (params) {
                $scope.DataObject.SelectedOrder = params.data;
                $scope.LoadReviewOrder(params.data);
            },
            onColumnResized: function (params) {
                updatedGridUserLayoutPref();
            },
        }
        function createServerSideDatasource(server) {
            return {
                getRows: function (params) {
                    server.getData(params.request).then(function (response) {
                        if (response.success) {
                            params.success({
                                rowData: response.rows,
                                rowCount: response.lastRow,
                            });
                        } else {
                            params.fail();
                        }
                    });
                },
            };
        }
        function createFakeServer() {
            return {
                getData: function (request) {
                    var d = $q.defer();
                    gridOptions.api.showLoadingOverlay();
                    createMultipleSortString(request.sortModel);
                    $scope.DataObject.OrderDateTooltip = $scope.OrderDate.startDate && $scope.OrderDate.endDate ? 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                    var orderListFilter = {
                        SiteID: $scope.DataObject.SelectedList.Site ? $scope.DataObject.SelectedList.Site.SiteID : null,
                        LocationID: $scope.DataObject.SelectedList.locationIDs,
                        Accession: $scope.Accession,
                        OrderDateStartDate: ($scope.OrderDate.startDate) ? moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") : null,
                        OrderDateEndDate: ($scope.OrderDate.endDate) ? moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY") : null,
                        PatientName: $scope.PatientName,
                        PatientMRN: $scope.PatientMRN,
                        PatientDOB: $scope.formatted_date($scope.DOB),
                        PatientClass: $scope.DataObject.SelectedList.PatientClass ? $scope.DataObject.SelectedList.PatientClass.Value : null,
                        OrderingPhysician: $scope.OrderingPhysician,
                        //39.After applying the status pending & completed status to peer review records are displayed
                        //Status: $scope.Status,
                        Reviewby: $sessionStorage.currentUserData.userId,
                        ReviewStatus: $scope.DataObject.ReviewStatus,
                        PageNum: Math.ceil(request.endRow / PageSize),
                        PageSize: PageSize,
                        SortingByMultiColumn: sortingString,
                        UserID: $sessionStorage.currentUserData.userId,
                    };

                    ReviewOrderService.GetReviewOrderList(orderListFilter).then(function (result) {
                        OrderList = _.concat(OrderList, result);
                        if (OrderList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            TotalRows = OrderList[0].TotalRows;
                        }
                        showHideStatusbar();
                        $scope.DataObject.isDataLoading = false;
                        gridOptions.api.hideOverlay();
                        if (OrderList && OrderList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        }
                        d.resolve({
                            success: true,
                            rows: result,
                        });
                    }, function (error) {
                        d.reject({ Message: error });
                    });
                    return d.promise;
                },
            };
        }
        function initGrid() {
            var timeout = $timeout(function () {
                var gridDiv = document.getElementById("PeerReviewAGGrid");
                if (gridDiv) { new agGrid.Grid(gridDiv, gridOptions); }

                var gridDiv = document.getElementById("ExportAGGrid");
                if (gridDiv) { new agGrid.Grid(gridDiv, exportGridOptions); }

                var gridDiv = document.getElementById("ReportAGGrid");
                if (gridDiv) { new agGrid.Grid(gridDiv, ReportGridOptions); }

                /*var gridDiv = document.getElementById("ExportAGGrid");
                if (gridDiv) { new agGrid.Grid(gridDiv, exportGridOptions); }*/
                $timeout.cancel(timeout);
                timeout = null;
            }, 200);
        }

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }
        function showHideStatusbar() {
            var statusBarComponent = gridOptions.api.getStatusPanel('GridFooter');
            if (OrderList.length == 0) {
                statusBarComponent.eGui.hidden = true;
                gridOptions.api.showNoRowsOverlay();
            } else {
                gridOptions.api.hideOverlay();
                statusBarComponent.eGui.hidden = false;
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
                statusBarComponent.eGui.textContent = 'Showing ' + OrderList.length + ' of ' + TotalRows + ' Total Records';
                statusBarComponent.eGui.style.color = 'white';
            }
        }

        function onCellClicked(params) {
            if (params.column.colId == "Action") {
                $scope.DataObject.SelectedOrder = params.data;
                $scope.LoadReviewOrder(params.data);
            }
            if (params.column.colId == "Decline") {
                SetReassignPeerReview(params.data.OrderID).then(function () {
                    $scope.refresh();
                    GetPeerReviewPendingCount();
                });
            }
        }
        function resetGrid() {
            $scope.DataObject.isDataLoading = true;
            OrderList = [];
            gridOptions.api.refreshServerSide({ purge: true });
        }
        function getContextMenuItems(params) {
            var contextMenu = [];
            if (OrderList.length != 0) {
                contextMenu.push('copy');
                contextMenu.push('copyWithHeaders');

                return contextMenu;
            }
        }
        //#endregion Ag-Grid
        function getUserLayoutPrefrence() {
            var d = $q.defer();
            UserLayoutPrefService.GetUserLayoutPreferences({
                UserID: $sessionStorage.currentUserData.userId,
                PageId: $state.current.name + "." + $state.current.controller,
                ControlId: 'ReviewOrder_ListGrid',
            }).then(function (response) {
                if (response && response.LayoutOptions) {
                    UserLayoutOptions = JSON.parse(response.LayoutOptions)
                }
                d.resolve();
            });
            return d.promise;
        }
        function updateUserLayoutPreference() {
            var d = $q.defer();
            if (UserLayoutOptions) {
                UserLayoutPrefService.SetUserLayoutPreferences({
                    UserID: $sessionStorage.currentUserData.userId,
                    PageId: $state.current.name + "." + $state.current.controller,
                    ControlId: 'ReviewOrder_ListGrid',
                    LayoutOptions: JSON.stringify(UserLayoutOptions),
                    Username: $sessionStorage.currentUserData.userName
                }).then(function (response) {
                    d.resolve();
                });
            } else {
                d.resolve();
            }
            return d.promise;
        }
        function updateuserguidepeerpreference() {

            UserPreferenceService.AddEditUserPreferences([{
                UserPreferenceID: (showUserGuidePeer && showUserGuidePeer.UserPreferenceID) ? showUserGuidePeer.UserPreferenceID : "-1",
                PreferenceType: "ShowUserGuidePeer",
                UserID: $sessionStorage.currentUserData.userId,
                PreferenceValue: "0",
            }]);
        }
        function updatedGridUserLayoutPref() {
            var savedState = gridOptions.columnApi.getColumnState();
            var equalObject = _.isEqual(UserLayoutOptions.savedState, savedState);
            if (!equalObject) {
                UserLayoutOptions.savedState = savedState;
                updateUserLayoutPreference();
            }
        }
        function createMultipleSortString(sortModel) {
            sortingString = "";
            _.each(sortModel, function (obj) {
                if (sortingString == "") {
                    sortingString = obj.colId + " " + obj.sort;
                } else {
                    sortingString = sortingString + "," + obj.colId + " " + obj.sort;
                }
            });
        }

        function GetUserPreferences() {
            //$log.log("GetUserPreferences: " + new Date());
            //$scope.isLoading = true;
            var d = $q.defer();
            var userPreference = {
                UserID: $sessionStorage.currentUserData.userId,
                PreferenceType: "DefaultDicomViewer,ShowUserGuidePeer",
            };
            UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
                //$log.log("GetUserPreferences response: " + new Date());
                var preference = result.UserPreferences;
                var pref4 = _.filter(preference, function (obj) { return obj.PreferenceType == "DefaultDicomViewer"; });
                if (pref4 != null && pref4.length > 0 && pref4[0].PreferenceValue) {
                    $scope.DataObject.DefaultDicomViewer = pref4[0].PreferenceValue;
                }
                pref4 = null;
                showUserGuidePeer = _.find(preference, { PreferenceType: "ShowUserGuidePeer" });
                d.resolve();
            });
            return d.promise;
        };
        $scope.SendMail = function () {
            var element = _.clone($("#dvPeerReviewReport"));
            kendo.drawing.drawDOM(element).then(function (group) {
                return kendo.drawing.exportPDF(group);
            }).then(function (data) {
                var emailIds = _.join(_.map($scope.DataObject.SendMailEmailIDs, function (email) { return email.text; }), ';');
                var obj = {
                    EmailID: emailIds,
                    TenantName: $scope.DataObject.SelectedList.Tenant.TenantName,
                    ReportType: _.find($scope.DataObject.ReportTypes, { Key: $scope.DataObject.ReportType.toString() }).Value,
                    Base64: data.replace('data:application/pdf;base64,', ''),
                }
                ReviewOrderService.SendEmailReviewOrder(obj).then(function (result) {
                    toaster.success({ body: "Email Sent" });
                    $('#ModalAddEmailIDs').modal('hide');
                    $scope.DataObject.SendMailEmailIDs = [];
                }, function (err) {
                    console.error("SendEmailReviewOrder error:", err);
                    toaster.error({ body: "Send mail failed. Please try again." });
                });
            }, function (err) {
                console.error("SendMail PDF generation error:", err);
                toaster.error({ body: "Send mail failed. Please try again." });
            });
        }
        $scope.ExportPDF = function () {
            var element = _.clone($("#dvPeerReviewReport"));
            kendo.drawing.drawDOM(element).then(function (group) {
                return kendo.drawing.exportPDF(group);
            }).then(function (data) {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var byteCharacters = atob(data.replace('data:application/pdf;base64,', ''));
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                var fileURL = URL.createObjectURL(file);
                a.href = fileURL;
                a.download = _.find($scope.DataObject.ReportTypes, { Key: $scope.DataObject.ReportType.toString() }).Value.replaceAll(" ", "-") + "-" + new Date().getTime();
                a.click();
                window.URL.revokeObjectURL(fileURL);
            });
        };
        $scope.Mail = function () {
            $('#ModalAddEmailIDs').modal('show');
            if ($sessionStorage.currentUserData.EmailId) {
                $scope.DataObject.SendMailEmailIDs.push({ text: $sessionStorage.currentUserData.EmailId });
            }
        }
        var exportColumnDefs = [
            {
                field: "SignMonthYear",
                headerName: "Sign Month Year",
                tooltipField: "SignMonthYear",
                flex: 1,
                minWidth: 90,
            },
            {
                field: "TotalFinalStudies",
                headerName: "Total Final Studies",
                tooltipField: "TotalFinalStudies",
                flex: 1,
                minWidth: 90,
            },
            {
                field: "TotalInternalReviewsFinals",
                headerName: "Total Internal Reviews Finals",
                flex: 1,
                minWidth: 150,
            },
            {
                field: "InternalReviewPercentage",
                headerName: "Internal Review Percentage",
                tooltipField: "InternalReviewPercentage",
                flex: 1,
                minWidth: 150,
            },
            {
                field: "NoDiscrepancyFound",
                headerName: "No Discrepancy Found",
                tooltipField: "No Discrepancy Found",
                flex: 1,
                minWidth: 150,
            },
            {
                field: "Radpeer2Count",
                headerName: "Radpeer 2 Count",
                tooltipField: "Radpeer 2 Count",
                initialWidth: 150
            },
            {
                field: "Radpeer2Percentage",
                headerName: "Radpeer 2 Percentage",
                tooltipField: "Radpeer 2 Percentage",
                initialWidth: 150
            },
            {
                field: "Radpeer3Count",
                headerName: "Radpeer 3 Count",
                tooltipField: "Radpeer 3 Count",
                initialWidth: 150
            },
            {
                field: "Radpeer3Percentage",
                headerName: "Radpeer 3 Percentage",
                tooltipField: "Radpeer 3 Percentage",
                initialWidth: 150
            },
            {
                field: "Radpeer4Count",
                headerName: "Radpeer 4 Count",
                tooltipField: "Radpeer 4 Count",
                flex: 1,
                minWidth: 100
            },
            {
                field: "Radpeer4Percentage",
                headerName: "Radpeer 4 Percentage",
                tooltipField: "Radpeer 4 Percentage",
                flex: 1,
                minWidth: 150
            }
        ];
        var exportGridOptions = {
            columnDefs: exportColumnDefs,
        }

        function DisablePrevAndNext(Order) {
            var idx = _.findIndex(OrderList, { OrderID: Order.OrderID });
            if (idx == 0) {
                $scope.DataObject.isPrevBtnDisable = true;
            }
            else {
                $scope.DataObject.isPrevBtnDisable = false;
            }

            if (idx == OrderList.length - 1) {
                $scope.DataObject.isNextBtnDisable = true;
            }
            else {
                $scope.DataObject.isNextBtnDisable = false;
            }
        };

        var ReportColDefs = [];

        var ReportGridOptions = {
            columnDefs: ReportColDefs,
            suppressContextMenu: true,
            enableBrowserTooltips: true,
            defaultColDef: {
                suppressMenu: true,
                autoHeaderHeight: true,
                wrapHeaderText: true,
            },
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
        }
        $scope.FilterReport = function () {
            $scope.DataObject.ReportData.ReportFromDate = moment($scope.ReportOrderDate.startDate).format("MM/DD/YYYY");
            $scope.DataObject.ReportData.ReportToDate = moment($scope.ReportOrderDate.endDate).format("MM/DD/YYYY");
            $scope.DataObject.ReportData.PhysicianName = $scope.DataObject.SelectedList.Provider ? $scope.DataObject.SelectedList.Provider.FirstName : null;
            $scope.DataObject.ReportData.TenantName = $scope.DataObject.SelectedList.Tenant.TenantName;
            var obj = {
                OrderDateStartDate: ($scope.ReportOrderDate.startDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.ReportOrderDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00")) : null,
                OrderDateEndDate: ($scope.ReportOrderDate.endDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.ReportOrderDate.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")) : null
            };
            if ($scope.DataObject.SelectedList.Site && $scope.DataObject.SelectedList.Site.length > 0) {
                $scope.DataObject.ReportData.Site = $scope.DataObject.SelectedList.Site;
                obj.TenantSiteIDs = [];
                _.each($scope.DataObject.SelectedList.Site, function (site) {
                    obj.TenantSiteIDs.push({ TenantID: site.TenantID, SiteID: site.SiteID });
                });
            } else {
                obj.TenantName = $scope.DataObject.SelectedList.Tenant.TenantName;
                $scope.DataObject.ReportData.Site = null;
            }
            switch (_.toInteger($scope.DataObject.ReportType)) {
                case 0:
                    GetPeerReviewReportByModalities(obj);
                    break;
                case 1:
                    obj.UserID = $scope.DataObject.SelectedList.Provider ? $scope.DataObject.SelectedList.Provider.Id : null
                    GetPeerReviewReportByModalities(obj);
                    break;
                case 2:
                    GetPeerReviewReportSummary(obj);
                    break;
            }
        }
        $scope.dynamicPopover = {
            content: '',
            templateUrl: 'myPopoverTemplate.html',
        };
        $scope.getHtmlContent = function (key) {
            var HTMLTemplate = '';
            _.each($scope.DataObject.ScoreOption, function (option) {
                if (key == option.Key) {
                    HTMLTemplate = option.htmlTemplate;
                }
                else if (option.SubValue) {
                    var template = _.find(option.SubValue, { Key: key });
                    if (template) { HTMLTemplate = template.htmlTemplate; }
                }
            });
            $scope.dynamicPopover.content = HTMLTemplate;
        }
        function RatingCellRenderer() {
            function CustomRenderer() {
            }
            CustomRenderer.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                var value = '';
                if (params.value != '') {
                    var Option = _.find($scope.DataObject.ScoreOption, { Key: params.value.charAt(0) });
                    if (Option) {
                        if (Option.SubValue) {
                            var subValue = _.find(Option.SubValue, { Key: params.value });
                            if (subValue) { value = subValue.Value; }
                        }
                        else {
                            value = Option.Value;
                        }
                        var ratingSpan = document.createElement('span');
                        ratingSpan.textContent = params.value + '. ' + value;
                        this.eGui.appendChild(ratingSpan);
                    }
                }
                this.$scope1 = $scope.$new();
                $compile(this.eGui)(this.$scope1);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                setTimeout(this.$scope1.$apply.bind(this.$scope1), 0);
            };
            CustomRenderer.prototype.getGui = function () {
                return this.eGui;
            };
            CustomRenderer.prototype.destroy = function () {
            };
            return CustomRenderer;
        }
        $scope.ReportClearFilter = function (CloseFlag) {
            ClearReportData();
            $scope.ClearGridData();
            $scope.DataObject.DisableReportFilter = disableFilter();
            if (CloseFlag) { $('#ReviewExportModal').modal('hide'); }
            $scope.DataObject.Sites = [];
            $scope.DataObject.SelectedList.Site = [];
            $scope.DataObject.ReportSiteDropdown.SelectedValue = {
                list: []
            };
        };

        function GetPeerReviewReportByModalities(obj) {
            $scope.isLoadingReport = true;
            ReviewOrderService.GetPeerReviewReportByModalities(obj).then(function (response) {
                PeerReviewReportDetails = response.PeerReviewDetails;
                if (response) {
                    if (response && response.PeerReviewDetails) {
                        PeerReviewReportDetails = response.PeerReviewDetails;
                    }
                    if (response.PeerReviewReportByModalities && response.PeerReviewReportByModalities.length > 0) {
                        var Keys = Object.keys(response.PeerReviewReportByModalities[0]);
                        if (response.PeerReviewReportByModalities[0].CountOfRadiologist) {
                            $scope.DataObject.ReportData.TotalPhysicians = response.PeerReviewReportByModalities[0].CountOfRadiologist;
                        }
                        if (response.PeerReviewReportByModalities[0].AllStudiesCount) {
                            $scope.DataObject.ReportData.AllStudiesCount = response.PeerReviewReportByModalities[0].AllStudiesCount;
                        }
                        if (response.PeerReviewReportByModalities[0].AllStudiesCountForTenant) {
                            $scope.DataObject.ReportData.AllStudiesCountForTenant = response.PeerReviewReportByModalities[0].AllStudiesCountForTenant;
                        }
                        if (response.PeerReviewReportByModalities[0][Keys[0]] != 'Total') {
                            var columnkeys = [];
                            _.each(Keys, function (key, index) {
                                var headerName = key;
                                if (key != "CountOfRadiologist" && key != "AllStudiesCount" && key != "AllStudiesCountForTenant") {
                                    if (key == 'NoDiscrepancyFound') {
                                        headerName = '1';
                                    }
                                    else if (key == 'Radpeer2a') {
                                        headerName = '2a';
                                    }
                                    else if (key == 'Radpeer2b') {
                                        headerName = '2b';
                                    }
                                    else if (key == 'Radpeer3a') {
                                        headerName = '3a';
                                    }
                                    else if (key == 'Radpeer3b') {
                                        headerName = '3b';
                                    }
                                    else if (key == 'Radpeer4a') {
                                        headerName = '4a';
                                    }
                                    else if (key == 'Radpeer4b') {
                                        headerName = '4b';
                                    }
                                    else if (key == "ClinicallySignficant") {
                                        headerName = 'Clinically Signficant';
                                    }
                                    var obj = {
                                        field: key,
                                        headerName: headerName,
                                        tooltipField: key,
                                        flex: 1,
                                        minWidth: 50,
                                        suppressMovable: true,
                                    }
                                    columnkeys.push(obj);
                                }
                            });
                            ReportColDefs = columnkeys;
                            ReportGridOptions.api.hideOverlay();
                            ReportGridOptions.api.setColumnDefs(ReportColDefs);
                            ReportGridOptions.api.setRowData(response.PeerReviewReportByModalities);
                            $scope.DataObject.ShowExportAndMail = true;
                        }
                        else {
                            $scope.ClearGridData();
                            $scope.DataObject.ShowExportAndMail = false;
                        }
                    }
                }
                else {
                    $scope.ClearGridData();
                    $scope.DataObject.ShowExportAndMail = false;
                }
                $scope.isLoadingReport = false;

            }, function (error) {
                $scope.isLoadingReport = false;
            });
        }

        function GetPeerReviewReportSummary(obj) {
            $scope.isLoadingReport = true;
            ReviewOrderService.GetPeerReviewReportSummary(obj).then(function (response) {
                if (response) {
                    if (response && response.PeerReviewDetails) {
                        PeerReviewReportDetails = response.PeerReviewDetails;
                    }
                    if (response.PeerReviewReportSummary && response.PeerReviewReportSummary.length > 0) {
                        var Keys = Object.keys(response.PeerReviewReportSummary[0]);
                        if (response.PeerReviewReportSummary[0].CountOfRadiologist) {
                            $scope.DataObject.ReportData.TotalPhysicians = response.PeerReviewReportSummary[0].CountOfRadiologist;
                        }
                        if (response.PeerReviewReportSummary[0][Keys[0]] != 'All') {
                            var columnkeys = [];
                            _.each(Keys, function (key, index) {
                                if (key != "CountOfRadiologist" && key != "Sorting") {
                                    var obj = {
                                        field: key,
                                        headerName: key,
                                        tooltipField: key,
                                        flex: 1,
                                        suppressMovable: true,
                                        sort: null,
                                    }
                                    if (key == 'Radiologist') {
                                        obj.flex = null;
                                        obj.maxWidth = null;
                                        obj.initialWidth = 180;
                                    }
                                    columnkeys.push(obj);
                                }
                            });
                            ReportColDefs = columnkeys;
                            ReportGridOptions.api.setColumnDefs(ReportColDefs);
                            ReportGridOptions.api.setRowData(response.PeerReviewReportSummary);
                            $scope.DataObject.ShowExportAndMail = true;
                            var hideTimeout = $timeout(function () {
                                $('.ag-filter-icon').remove();
                                $('.ag-sort-indicator-container').remove();
                                $('.ag-header-cell-text').css("padding", "5px");

                                $timeout.cancel(hideTimeout);
                                hideTimeout = null;
                            }, 100);
                        }
                        else {
                            $scope.ClearGridData();
                            $scope.DataObject.ShowExportAndMail = false;
                        }
                    }
                }
                else {
                    $scope.ClearGridData();
                    $scope.DataObject.ShowExportAndMail = false;
                }
                $scope.isLoadingReport = false;
            }, function (error) {
                $scope.isLoadingReport = false;
            });
        }
        $scope.ClearGridData = function () {
            ReportGridOptions.api.showNoRowsOverlay();
            ReportGridOptions.api.setColumnDefs([]);
            ReportGridOptions.api.setRowData([]);
            $scope.DataObject.ShowExportAndMail = false;
        }
        function ClearReportData() {
            $scope.ReportOrderDate = {
                startDate: moment().subtract(6, 'days'),
                endDate: moment()
            }
            $scope.DataObject.ReportData = {
                ReportDate: new Date(),
                ShowExportAndMail: true,
            };
            $scope.DataObject.SelectedList.Tenant = null;
            $scope.DataObject.SelectedList.Provider = null;
        }

        function disableFilter() {
            var response = true;
            if ($scope.DataObject.ReportType == '0' || $scope.DataObject.ReportType == '2') {
                if ($scope.DataObject.SelectedList
                    && $scope.DataObject.SelectedList.Tenant
                    && $scope.ReportOrderDate
                    && $scope.ReportOrderDate.startDate != null
                    && $scope.ReportOrderDate.endDate != null) {
                    response = false;
                }
            } else if ($scope.DataObject.ReportType == '1') {
                if ($scope.DataObject.SelectedList
                    && $scope.DataObject.SelectedList.Tenant
                    && $scope.DataObject.SelectedList.Provider
                    && $scope.ReportOrderDate
                    && $scope.ReportOrderDate.startDate != null
                    && $scope.ReportOrderDate.endDate != null) {
                    response = false;
                }
            }
            return response;
        }
        $scope.OnChangeTenant = function () {
            $scope.DataObject.SelectedList.Provider = null;
            $scope.DataObject.SelectedList.Site = [];
            $scope.DataObject.ReportSiteDropdown.SelectedValue = {
                list: []
            };
            $scope.DataObject.DisableReportFilter = disableFilter();
            if ($scope.DataObject.ReportType == 1) {
                getAllUserByTenant($scope.DataObject.SelectedList.Tenant.TenantID);
            }
            if ($scope.DataObject.SelectedList.Tenant && $scope.DataObject.SelectedList.Tenant.TenantID) {
                $scope.DataObject.Sites = $filter('orderBy')(_.uniqBy(_.filter($scope.Locations, { TenantID: $scope.DataObject.SelectedList.Tenant.TenantID }), 'SiteID'), ['Site']);
            }
        }
        $scope.OnChangeProvider = function () {
            $scope.DataObject.DisableReportFilter = disableFilter();
        }
        function getAllUserByTenant(TenantID) {
            RuleService.GetAllUserByTenant({ "UserID": $sessionStorage.currentUserData.userId, 'TenantID': TenantID }).then(function (result) {
                _.each(result, function (data) {
                    data.FirstName = data.LastName + ", " + data.FirstName;
                });
                $scope.DataObject.ProviderList = _.uniqBy(result, 'Id');
            });
        }
        $scope.OnChangeReportType = function () {
            $scope.DataObject.SelectedList.Provider = null;
            $scope.DataObject.DisableReportFilter = disableFilter();
        }
        $scope.ClearPhysician = function () {
            $scope.DataObject.SelectedList.Provider = null;
            $scope.DataObject.DisableReportFilter = disableFilter();
            $scope.DataObject.ReportData = {
                ReportDate: new Date(),
                ShowExportAndMail: true,
            };
            $scope.ClearGridData();
        }

        $scope.CloseAllWindows = function () {
            windowHandler.DoNotCloseWindow(['Analytics', 'CIVR']);
        }
        $scope.ValidateReviewOrder = function () {
            if ($scope.ReviewOrder.IsInterestingCase) {
                if (($scope.ReviewOrder.Rating && $scope.ReviewOrder.Rating != '') && $scope.ReviewOrder.Keywords && $scope.ReviewOrder.Comments) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else if ($scope.ReviewOrder.ReviewStatus == 'COMPLETE') {
                return true;
            }
            else {
                if ($scope.ReviewOrder.Rating && $scope.ReviewOrder.Rating != '') {
                    return false;
                }
                else {
                    return true;
                }
            }
        }

        $scope.OnReviewStatusChanged = function () {
            if ($scope.DataObject.ReviewStatus == 'Pending') {
                $scope.OrderDate = {
                    startDate: null,
                    endDate: null
                };
            } else {
                $scope.OrderDate = {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                };
            }
            $scope.refresh();
        }

        $scope.OnFilterDisabled = function () {
            if ($scope.DataObject.ReviewStatus == 'Pending') {
                return $scope.DataObject.isDataLoading;
            } else {
                return (!$scope.OrderDate.startDate && !$scope.OrderDate.endDate) || $scope.DataObject.isDataLoading;
            }

        }
        function GetPeerReviewPendingCount() {
            ReviewOrderService.GetPeerReviewPendingCount({ UserID: $sessionStorage.currentUserData.userId }).then(function (result) {
                $rootScope.$broadcast("PeerReviewPendingCount", result);
            });
        }

        function SetReassignPeerReview(OrderID) {
            var d = $q.defer();
            ReviewOrderService.SetReassignPeerReview({ UserID: $sessionStorage.currentUserData.userId, OrderID: OrderID }).then(function (result) {
                d.resolve();
            });
            return d.promise;
        }
        $scope.ExportExcel = function () {
            if (!PeerReviewReportDetails || PeerReviewReportDetails.length === 0) {
                toaster.warning({ body: "No data available to export." });
                return;
            }
            ReviewOrderService.ExportPeerReviewReport({
                PeerReviewDetails: PeerReviewReportDetails,
                StartDate: $scope.OrderDate.startDate,
                EndDate: $scope.OrderDate.endDate
            }).then(function (fileStorage) {
                if (!fileStorage || !fileStorage.FileContent) {
                    toaster.error({ body: "Export failed: no file content returned." });
                    return;
                }
                var byteCharacters = atob(fileStorage.FileContent);
                var byteNumbers = new Uint8Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var blob = new Blob([byteNumbers], { type: fileStorage.ContentType });
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                var filename = "Peer Review Report";
                if ($scope.ReportOrderDate && $scope.ReportOrderDate.startDate && $scope.ReportOrderDate.endDate) {
                    filename = filename + " " + $scope.ReportOrderDate.startDate.format("MM-DD-YYYY") + " to " + $scope.ReportOrderDate.endDate.format("MM-DD-YYYY");
                }
                a.download = filename + ".xlsx";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }, function (err) {
                console.error("ExportPeerReviewReport error:", err);
                toaster.error({ body: "Export failed. Please try again." });
            });
        }

        function GetPeerTourSteps() {
            var d = $q.defer();
            CommonService.GetTourSteps('Peer').then(function (result) {
                if (tourPeerReview && tourPeerReview._options) {
                    tourPeerReview._options.steps = result.Steps;
                    d.resolve();
                }
            });
            return d.promise;
        }

        function PeerInitTour() {
            GetPeerTourSteps().then(function () {
                startUserGuidePeerTour();
                HelpPeerReviewTour();
            });
        }

        function HelpPeerReviewTour() {
            if (TourFlag) {
                tourPeerReview.init();
                $scope.DataObject.ReviewStatus = 'Complete';
                $scope.refresh();
                tourPeerReview.setCurrentStep(0);
                tourPeerReview.start(true);
            }
        }
        $scope.onSelectedSiteChange = function (selectedData) {
            $scope.DataObject.SelectedList.Site = selectedData;
        }

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }

})();


angular.module('radico.pages.revieworder')
    .service('ReviewOrderService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS, __env) {
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }
        this.GetAllSites = function () {
            return Restangular.one('psorders').one("GetAllSites").get();
        };
        this.GetReviewOrderList = function (data) {
            return Restangular.one('psorders').one("GetReviewOrderList").customPOST(data);
        };
        this.UpdateReviewOrder = function (data) {
            return Restangular.one('psorders').one("UpdateReviewOrder").customPOST(data);
        };
        this.GetOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetOrdersList").customPOST(orderListFilter);
        };
        this.GetDICOMOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetDICOMOrdersList").customPOST(orderListFilter);
        };
        //this.GetSitesAndLocations = function () {
        //    return Restangular.one('psorders').one("GetSitesAndLocations").get();
        //};
        this.GetAllSitesAndLocations = function () {
            return Restangular.one('psorders').one("GetAllSitesAndLocations").get();
        };
        this.GetPatientClass = function () {
            return Restangular.one('psorders').one("GetPatientClass").get();
        };
        this.CheckPSUserBySite = function (psuser) {
            return Restangular.one('psorders').one("CheckPSUserBySite").customPOST(psuser);
        };
        this.InsertPSUsersBySIte = function (psuser) {
            return Restangular.one('psorders').one("InsertPSUsersBySIte").customPOST(psuser);
        };
        this.SaveReport = function (reportView) {
            return Restangular.one('psorders').one("SaveReport").customPOST(reportView);
        };
        this.InsertOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("InsertOpenOrder").customPOST(openOrders);
        };
        this.DeleteOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("DeleteOpenOrder").customPOST(openOrders);
        };
        this.GetOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("GetOpenOrder").customPOST(openOrders);
        };
        this.RemoveFromComparison = function (comparisonOrder) {
            return Restangular.one('psorders').one("RemoveFromComparison").customPOST(comparisonOrder);
        };
        this.ShowHideOrder = function (orders) {
            return Restangular.one('psorders').one("ShowHideOrder").customPOST(orders);
        };
        this.GetCurrentDateTime = function () {
            return Restangular.one('psorders').one("GetCurrentDateTime").get();
        };
        this.SetDiscussion = function (data) {
            return Restangular.one('psorders').one("SetDiscussion").customPOST(data);
        };
        this.GetDiscussions = function (data) {
            return Restangular.one('psorders').one("GetDiscussions").customPOST(data);
        };     
        this.GetDiscussionsByIds = function (data) {
            return Restangular.one('psorders').one("GetDiscussionsByIds").customPOST(data);
        };
        this.SetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("SetOrderDiscussion").customPOST(data);
        };
        this.GetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("GetOrderDiscussion").customPOST(data);
        };
        this.GetDicomViewerCredentials = function (obj) {
            return Restangular.one('psorders').one("GetDicomViewerCredentials").customPOST(obj);
        };
        this.InsertDicomViewerCredentials = function (obj) {
            return Restangular.one('psorders').one("InsertDicomViewerCredentials").customPOST(obj);
        };
        this.GetAllUsers = function () {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/RadFlowGetUsers ',
                headers: { 'content-type': 'application/json' }
            });
        };
        this.SendEmailReviewOrder = function (obj) {
            return Restangular.one('psorders').one("SendEmailReviewOrder").customPOST(obj);
        };
        this.GetPeerReviewReport = function (obj) {
            return Restangular.one('psorders').one("GetPeerReviewReport").customPOST(obj);
        };

        this.GetPeerReviewReportSummary = function (obj) {
            return Restangular.one('psorders').one("GetPeerReviewReportSummary").customPOST(obj);
        };

        this.GetPeerReviewReportByModalities = function (obj) {
            return Restangular.one('psorders').one("GetPeerReviewReportByModalities").customPOST(obj);
        };

        this.GetPeerReviewPendingCount = function (obj) {
            return Restangular.one('psorders').one("GetPeerReviewPendingCount").customPOST(obj);
        };
        this.SetReassignPeerReview = function (obj) {
            return Restangular.one('psorders').one("SetReassignPeerReview").customPOST(obj);
        };
        this.ExportPeerReviewReport = function (params) {
            return Restangular.one('psorders').one("ExportPeerReviewReport").customPOST(params);
        };
    }]);
angular.module('radico.pages.worklistLite')
    .service('ScheduleService', ['Restangular', '$http', '__env', function (Restangular, __env) {

        this.SetShiftClassification = function (params) {
            return Restangular.one('ShiftSchedule').one("SetShiftClassification").customPOST(params);
        };
        this.GetShiftClassification = function (params) {
            return Restangular.one('ShiftSchedule').one("GetShiftClassification").get(params || {});
        };
        this.GetWeekDays = function () {
            return Restangular.one('ShiftSchedule').one("GetWeekDays").get();
        };
        this.SetShiftConfig = function (params) {
            return Restangular.one('ShiftSchedule').one("SetShiftConfig").customPOST(params);
        };
        this.DeleteShiftConfig = function (params) {
            return Restangular.one('ShiftSchedule').one("DeleteShiftConfig").customPOST(params);
        };
        this.GetShiftConfig = function (params) {
            return Restangular.one('ShiftSchedule').one("GetShiftConfig").customPOST(params);
        };
        this.SetShiftSchedule = function (params) {
            return Restangular.one('ShiftSchedule').one("SetShiftSchedule").customPOST(params);
        };
        this.GetShiftSchedule = function (params) {
            return Restangular.one('ShiftSchedule').one("GetShiftSchedule").customPOST(params);
        };
        this.GetShiftScheduleCalendar = function (params) {
            return Restangular.one('ShiftSchedule').one("GetShiftScheduleCalendar").customPOST(params);
        };
        this.DeleteShiftSchedule = function (params) {
            return Restangular.one('ShiftSchedule').one("DeleteShiftSchedule").customPOST(params);
        };
        this.GetShiftScheduleCalendarExport = function (params) {
            return Restangular.one('ShiftSchedule').one("GetShiftScheduleCalendarExport")
                .withHttpConfig({ responseType: 'arraybuffer' }).customPOST(params);
        };

        this.formatTime = function (date) {
            if (date != null) {
                var h = ("0" + (date.getHours())).slice(-2); // in javascript month start from 0.
                var m = ("0" + date.getMinutes()).slice(-2); // add leading zero             
                return h + ':' + m;
            }
            else {
                return null;
            }
        }

        this.assignRowID = function (list) {
            _.each(list, function (obj) {
                obj.RowID = new Date().getTime() + Math.random().toString(16).slice(2);
            });
            return list;
        }
    }]);

(function () {
    'use strict';

    angular.module('radico.pages.techno')
        .controller('TechnoController', TechnoController);
    function TechnoController($scope, TechnoService, WorklistService, $state, $sessionStorage, UserPreferenceService, APP_CONSTANTS, AppHubService, $timeout, $filter, $q, NgTableParams, $interval, windowHandler, uiGridConstants, $sce, $log, toaster, UserLayoutPrefService, __env, ReviewOrderService, ManageLocationService, CommonService, $stateParams, $rootScope, SharedService, MappingService, RuleSharedService) {    //Bug 21548: Unable to see the selected Modalities on tooltip of worklist & tech worklist page
        //getPatientsList
        var ReportList = [];
        var AppHub;
        var DicomOrderList = [];
        var LastOpenOrder = null;
        var specialityAssignments = [];
        var showUserGuideTech = undefined;
        var ColumnsToHide = [];
        var techGrid = null;
        var statusBarComponent = null;
        var tippyJsinstance = [];
        var worklistSavedState = [];
        var defaultSortingString = "O.OrderDate desc";
        var sortingString = defaultSortingString;

        var sortingApplied = false;

        var PageSize = "50";
        var PageNo = 1;
        var TotalRows = "";
        var UserLayoutOption = {};
        var orderListFilter = {};
        var ShowReleaseGuideTech = undefined;
        var halfScale = $(window).width() < 1199;
        $scope.IsAddendumRequestVisible = $sessionStorage.IsAddendumRequestVisible;
        $scope.Status = "RP";
        $scope.orderByField = "DOS";
        $scope.reverseSort = true;
        $scope.SelectedList = {};
        $scope.SingReport = {};
        $scope.SingReport.Index = 0;
        $scope.LastOpenedOrderID;
        $scope.ChooseNextStudy = false;
        $scope.showAttachment = false;
        $scope.modalitytechnotooltip = 'Select Modalities';
        $scope.isfilterCollapse = false;
        $scope.hstep = 1;
        $scope.mstep = 5;
        $scope.technoMenuExists = false;

        $scope.AddendumRequest = {
            AssignedUser: null,
            isHighPriorityAddendum: false,
            AddendumComment: null,
            AssignedUserTooltip: "Select Radiologist"
        }
        $scope.PeerReview = {
            AssignedUser: null,
            Comment: null,
            AssignedUserTooltip: "Select Radiologist"
        }
        //$scope.winPatientInfoTechWidth = "65%";
        if ($(window).width() < 1199) {
            $scope.winPatientInfoTechWidth = "96%";
        } else {
            $scope.winPatientInfoTechWidth = "80%";
        }
        //$scope.winViewReportTechWidth = "70%";
        if ($(window).width() < 1199) {
            $scope.winPeerReviewWidth = "96%";
        } else {
            $scope.winPeerReviewWidth = "70%";
        }
        $scope.win_HelpOrderWidth = "90%";
        $scope.win_DCMViewerWidth = "80%";
        $scope.win_ViewTechniqueWidth = "850";
        $scope.win_ViewTechniqueHeight = "600";
        //$scope.isCollapsed = true;
        //$scope.RefreshTimmer = "00:00";

        $scope.CloseFrom = ""; //"RADFLOW" , "PS360"
        //$sessionStorage.PSEvent = false;
        $scope.addTechnique = false;
        $scope.halfScale = false;
        $scope.toolTipOrderDate = 'DOS';
        $scope.currentDate = new Date();
        var refreshDOSMidnight = null;
        $scope.Radiologists = [];
        var siteRadiologistsUnfiltered = [];
        $scope.IsPatientAgeShow = true;

        //$scope.defaultWindowHeight = "72.60%";
        $scope.defaultWindowHeight = "86%";
        $scope.IsLocationShow = false;
        $scope.IsDOSShow = false;
        $scope.IsPatientNameShow = false;
        $scope.IsPatientAgeShow = false;
        $scope.IsTypeNameShow = false;
        $scope.IsModalityShow = false;
        $scope.IsProcedureShow = false;
        $scope.IsOrderingPhysicianShow = false;
        $scope.IsAccessionShow = false;
        $scope.IsMRNShow = false;
        $scope.IsSTATShow = false;
        $scope.IsImageInstanceShow = false;
        var columnVersion = 9.4;
        var previouslySelectedFilter = {};
        $scope.uiGridState = {};
        var refreshDOSInterval = 1000;
        $scope.SendInvite = false;

        if ($(window).width() < 1199) {
            $scope.halfScale = true;
        }

        var parser = new UAParser();
        $scope.browser = parser.getBrowser().name;

        $scope.dateDOSOptions = {
            enableTime: 'true'
        };
        $scope.HiddenType = { obj: null };
        //Custom date range settings
        $scope.OrderDate = {
            //startDate: moment().subtract(1, "days"),
            //endDate: moment()
            startDate: moment().subtract(6, 'days'),
            endDate: moment()
        };

        $scope.SelectedLocations = {
            Ids: '',
            locations: [],
            divId: "TechnoWorklistPage"
        };

        $scope.opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            //cancelButtonClasses: 'dr-btn-none',
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.OrderDate = {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                }

            },
            ranges: {
                'Today': [moment(), moment()],
                //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                //'Last 15 Days': [moment().subtract(14, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                //'This Month': [moment().startOf('month'), moment().endOf('month')],
                //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                'Last Year': [moment().subtract(1, 'year'), moment()],
                'Last 5 Years': [moment().subtract(5, 'years'), moment()],
                //'All DOS': [],

            }

        };

        $scope.htmlPopover = $sce.trustAsHtml('<div class="single4 v-a-m"></div>');
        $scope.popoverOpened1 = false;
        $scope.popoverDicomOrderID = '';

        var currentHeight = 0;
        var previousHeight = 0;

        $scope.AutoRefresh = false;
        $scope.SaveDiscussionFlag = false;

        $scope.PatientDOB = {};
        $scope.winShareExamWindowWidth = window.innerWidth < 768 ? "80%" : "60%";
        var openWindows = [];
        $scope.DataObject = {
            isAutoAssignPeerReviewWin: false,
            FaxFile: {},
            onQueryRetrive: false,
            isLoadingQueryRetrieve: false,
            defaultWindowWidth: halfScale ? "96%" : "70%",
            QueryRetriveObj: {},
            QueryRetrieve: {
                Accession: '',
                PatientMRN: '',
                FirstName: '',
                LastName: '',
                toolTipOrderDate: 'DOS',
                OrderDateType: 'Last 3 Years',
                OrderDate: {
                    startDate: moment().subtract(3, 'year'),
                    endDate: moment()
                },
                IsRetrieveBtnDisabled: true,
                IsExpanded: false,
                IsAllStudySelected: false,
                IsSearchingData: false,
            },
            ModalityDropdownDataFilter: {
                divId: "TechWorklistModalityFilter",
                keys: ['Code'],
                uniqKey: 'Code',
                placeHolder: "Select Modalities",
                SelectedValue: { list: [] },
            },
            ReportListFilter: { DateRange: 'Any', Modality: 'All' },
            ReportList: WorklistService.GetReportListModalityNDateRange(),
            ShowReportModal: false,
            ReportSortingPropName: 'OrderDate',
            ReportSortingRevOrder: true,
            SearchText: '',
            ReportSortingOptions: ['DOS (newest first)', 'DOS (oldest first)', 'Rendering Physician (A to Z)', 'Rendering Physician (Z to A)', 'Procedure (A to Z)', 'Procedure (Z to A)'],
            SelectedSortingOption: 'DOS (newest first)',
            winComparisonOrderReportsWidth: $scope.halfScale ? "96%" : "70%",
            ActionMenu: {
                ActionTaken: "",
                WorklistName: "Technologist",
                MenuItems: [{
                    name: 'Consult with Physician',
                }, {
                    name: 'Share Exam',
                }, {
                    name: 'Open Discussion (F11)',
                }, {
                    name: 'Not to be Read',
                }, {
                    name: 'Unhide Study',
                }, {
                    name: 'Query Retrieve',
                }, {
                    name: 'Upload Attachment',
                },],
            },
            DiscussionWindowTabList: [
                {
                    TabName: 'Discussion',
                },
                {
                    TabName: 'Attachment',
                }
            ],
            DiscussionWindowActiveTab: 'Discussion',
            Reference: {},
            FaxDetails: {
                FaxNumTooltip: null,
                disableSendFaxBtn: false,
                FaxNumberList: [],
                FaxNumber: null,
                FaxNumberDropdown: {
                    divId: "FaxNumberDropdown",
                    keys: ['FaxName', 'DisplayFaxNumber'],
                    uniqKey: 'uniqID',
                    placeHolder: "Select Fax Number",
                    SelectedValue: { list: [] },
                    separator: "<br>",
                    onFaxNumbChanged: function (selectedData) {
                        var tooltip = null;
                        _.each(selectedData, function (obj) {
                            if (tooltip) {
                                tooltip = tooltip + "\n" + obj.FaxName + "-" + obj.FaxNumber;
                            }
                            else {
                                tooltip = obj.FaxName + "-" + obj.FaxNumber;
                            }
                        });
                        $scope.DataObject.FaxDetails.FaxNumTooltip = tooltip;
                    }
                }
            },
            ModalPatientInfoTabs: [
                {
                    title: 'Order Information',
                    templateUrl: 'order_info_tab.html',
                },
                {
                    title: 'Forms',
                    templateUrl: 'order_forms_tab.html',
                }
            ],
            ModalPatientInfoActiveIndex: 0,
            StatusList: WorklistService.GetOrderStatus(),
            RemoveRenderingPhysicianReport: $sessionStorage.currentUserData.RemoveRenderingPhysician,
            EnableRowsForSelectedTenants: $sessionStorage.EnableRowsForSelectedTenants.split(','),
            StudyPriorities: [],
            OrderingPhysician: {
                SelectedData: null,
            },
            MasterData: {
                SiteTenant: {
                    divId: "OrderingPhySite",
                    keys: ['SiteTenant'],
                    uniqKey: 'SiteID',
                    placeHolder: "Select Site(s)",
                    SelectedValue: { list: [] },
                    tooltip: "Select Site(s)",
                    OnChange: function (selectedData) {
                        var toolip = createSiteTooltip(selectedData);
                        $scope.DataObject.MasterData.SiteTenant.tooltip = toolip ? toolip : "Select Site(s)";
                    }
                },
            },
            ShowOrderingPhysicianModal: false,
        };
        $scope.DataObject.QueryRetrieve.opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",

                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.DataObject.QueryRetrieve.OrderDate = {
                    startDate: moment().subtract(5, 'year'),
                    endDate: moment()
                }
            },
            ranges: {
                'Last 6 Months': [moment().subtract(6, 'month'), moment()],
                'Last 1 Year': [moment().subtract(1, 'year'), moment()],
                'Last 3 Years': [moment().subtract(3, 'year'), moment()],
                'Last 5 Years': [moment().subtract(5, 'year'), moment()],
                'Last 10 Years': [moment().subtract(10, 'year'), moment()],
            }
        };

        var positionChanged = false;
        $scope.ImagePendingStatus = '';
        var OrderRefreshInterval = null;
        var OrderRefreshDuration = __env.TechWorklistRefreshDuration;
        var DefaultAutoRefreshDuration = __env.DefaultAutoRefreshDuration;
        $scope.LoggedInUserID = $sessionStorage.currentUserData.userId;
        $scope.ShowLockStudy = true;
        $scope.locationIDs = '';
        $scope.modalityIDs = '';
        $scope.locations = '';
        $scope.modalities = '';
        var OrderAutoRefresh = true;
        var PeerReviewToasterMessage = "Added to peer review successfully!";
        var TourFlag = $stateParams.TourFlag;
        var ProvidersFullList = [];
        var LoadPatientDataFlag = false;
        kendo.ui.Window.fn._keydown = function (originalFn) {
            var KEY_ESC = 27;
            return function (e) {
                if (e.which !== KEY_ESC) {
                    originalFn.call(this, e);
                }
            };
        }(kendo.ui.Window.fn._keydown);

        $scope.resetDateRange = function () {
            $scope.opts.ranges = {
                'Today': [moment(), moment()],
                //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                //'Last 15 Days': [moment().subtract(14, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                //'This Month': [moment().startOf('month'), moment().endOf('month')],
                //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                'Last Year': [moment().subtract(1, 'year'), moment()],
                'Last 5 Years': [moment().subtract(5, 'years'), moment()],
                //'All DOS': [],
            };
            angular.element(document).ready(function () {
                angular.element('.drp-buttons .cancelBtn').click(function () {
                    angular.element('#daterange3').val('');
                    $scope.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                });
            });
            $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            if ($scope.OrderDate.startDate && $scope.OrderDate.endDate) {
                if ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom'))
                    $scope.OrderDateType = ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                        moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType;

            }
            else
                $scope.OrderDateType = 'Clear';
            setOrderDate($scope.OrderDateType);

        }
        angular.element(document).ready(function () {
            angular.element('.drp-buttons .cancelBtn').click(function () {
                angular.element('#daterange3').val('');
                $scope.OrderDate = {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                };
            });

        });
        angular.element(document).ready(function () {
            angular.element('.ranges ul li[data-range-key="Today"]').removeClass('active');
            angular.element('.ranges ul li[data-range-key="Last 7 Days"]').addClass('active');
            //angular.element('.ranges ul li[data-range-key="Last 3 Days"]').click();
            //angular.element('#daterange3').val(moment().subtract(2, 'days') + ' - ' + moment());
            $scope.OrderDate = {
                startDate: moment().subtract(6, 'days'),
                endDate: moment()
            };
            $scope.OrderDateType = 'Last 7 Days';
            $scope.toolTipOrderDate = 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY');
            //for mobile devices
            if (angular.element(window).width() < 768) {
                //angular.element('.techno-dscsn').addClass('tecnho-dscsn-wrpr');
                $scope.isfilterCollapse = true;
                angular.element("#collapseWorklist").removeClass("in");
                angular.element('.discsn-popup').parent().addClass('wrapper-search-contact');
            }
        });
        $scope.setTooltip = function (val, defaultval) {
            if (val) {
                return val.replace(/,/g, '\n');
            }
            else {
                return defaultval;
            }
        }
        $scope.formatted_date = function (date) {
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' === (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };

        function setOrderDate(val) {
            var type = null, startDate = null, endDate = null;
            //alert('setOrderDate' + val);
            if (val && val.match('Custom')) {
                type = 'Custom';
                startDate = val.split('#')[1];
                endDate = val.split('#')[2];
            }
            else {
                type = val;
            }
            $scope.OrderDateType = type;
            switch (type) {
                case 'Today':
                    $scope.OrderDate = {
                        startDate: moment(moment().format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                //case 'Yesterday':
                //    $scope.OrderDate = {
                //        startDate: moment().subtract(1, 'days'),
                //        endDate: moment().subtract(1, 'days')
                //    };
                //    break;
                case 'Last 3 Days':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(2, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 7 Days':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                //case 'Last 15 Days':
                //    $scope.OrderDate = {
                //        startDate: moment().subtract(14, 'days'),
                //        endDate: moment()
                //    };
                //    break;
                case 'Last 30 Days':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(29, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Custom':
                    $scope.OrderDate = {
                        startDate: moment(moment(startDate).format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment(endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    $scope.OrderDateType = 'Custom range';
                    break;
                case 'Last Year':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(1, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 5 Years':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(5, 'years').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'All DOS':
                    $scope.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                case 'Clear':
                    $scope.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                default:
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    $scope.OrderDateType = 'Last 7 Days';
                    break;
            }
            var timeout = $timeout(function () {
                $scope.toolTipOrderDate = $scope.OrderDate.startDate && $scope.OrderDate.endDate ? 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                $timeout.cancel(timeout);
                timeout = null;
            }, 0)
        }

        function syncOrderDateBeforeFilter() {
            if (!$scope.OrderDate || !$scope.OrderDate.startDate || !$scope.OrderDate.endDate) {
                return;
            }
            var label = $scope.OrderDate.label;
            if (!label) {
                return;
            }
            var namedPresets = ['Today', 'Last 3 Days', 'Last 7 Days', 'Last 30 Days', 'Last Year', 'Last 5 Years'];
            if (namedPresets.indexOf(label) !== -1) {
                setOrderDate(label);
            }
        }

        $scope.clearFilterAndRefesh = function () {
            //$log.log("clearFilterAndRefesh: " + new Date());
            $scope.clearFilter();
            //$scope.getData();
            //$timeout(function () { $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'height:76vh !important; transition: height 1s;'); }, 1);
            var dollarTimeout = $timeout(function () {
                $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;');
                $timeout.cancel(dollarTimeout);
                dollarTimeout = null;
            }, 1);
            $(".anui").removeClass("set-modality-height");
            $(".anui").removeClass("set-location-height");
            $scope.FilterDICOMOrders();
        };

        $scope.closePatientInfo = function () {
            //$log.log("closePatientInfo");
            $scope.files = [];
            angular.element("input[type='file']").val(null);
            $scope.win_PatientInfo.center().close();
        };
        $scope.clearFilter = function () {
            //$log.log("clearFilter; " + new Date());
            PageNo = 1;
            updatePageSize();
            $scope.Status = "RP";
            $scope.SelectedList.Site = null;
            $scope.SelectedList.Location = null;
            $scope.modalitytechnotooltip = 'Select Modalities';
            $scope.Accession = "";
            $scope.OrderDate = {
                startDate: moment().subtract(6, 'days'),
                endDate: moment()
            };
            $scope.OrderDateType = 'Last 7 Days';
            $scope.toolTipOrderDate = 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY');
            $scope.SelectedList.Modality = [];
            $scope.DataObject.ModalityDropdownDataFilter.SelectedValue = {
                list: [],
            };
            $scope.PatientName = "";
            $scope.PatientMRN = "";
            $scope.DOB = "";
            $scope.SelectedList.PatientClass = null;
            $scope.OrderingPhysician = "";
            //$scope.refresh();
            $scope.locationIDs = '';
            $scope.modalityIDs = '';
            $scope.locations = '';
            $scope.modalities = '';
            $scope.SelectedLocations = {
                Ids: '',
                locations: [],
                divId: "TechnoWorklistPage"
            };
        };

        function GetSitesAndLocationsByUserID() {
            //$log.log("GetSitesAndLocationsByUserID: " + new Date());
            var d = $q.defer();
            TechnoService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                //$log.log("GetSitesAndLocationsByUserID response: " + new Date());
                $scope.Locations = result;
                $scope.DataObject.MasterData.Sites = _.uniqBy(_.filter(result, function (obj) { return obj.SiteID != 0; }), 'SiteID');
                $scope.DataObject.MasterData.Sites = _.map($scope.DataObject.MasterData.Sites, function (item) {
                    return _.assign(item, {
                        SiteTenant: item.Site + " (" + item.TenantName + ")"
                    });
                });
                d.resolve();
            });
            return d.promise;
        };


        function openContextMenuOptions(params) {
            var contextMenus = [];
            if (params && params.node && params.node.data) {
                params.node.setSelected(true);
                var Order = params.node.data;
                $scope.setSelected(Order.OrderID, Order);

                contextMenus.push({
                    name: 'Consult with Physician',
                    action: function () {
                        $scope.CallInConsult(Order);
                    }
                });
                switch (Order.Status) {
                    case 'RP':
                        if (!Order.IsLock) {
                            contextMenus.push('separator');
                            contextMenus.push({
                                name: 'Not to be Read',
                                action: function () {
                                    $scope.HideOption = 'NotRead';
                                    $scope.HideStudy();
                                }
                            });
                        }
                        break;
                    case 'H':
                        contextMenus.push('separator');
                        contextMenus.push({
                            name: 'Unhide Study',
                            action: function () {
                                HideUnhideOrder();
                            }
                        });
                        break;
                    case 'C':
                        if ($sessionStorage.IsAddendumRequestVisible) {
                            contextMenus.push('separator');
                            contextMenus.push(
                                {
                                    name: 'Addendum Request',
                                    action: function () {
                                        $scope.setSelected(Order.OrderID, Order);
                                        $scope.GetAllUsers($scope.SelectedOrder.SiteID).then(function () {
                                            $scope.AddendumRequest.AssignedUser = _.find($scope.Radiologists, { Id: $scope.SelectedOrder.SignBy });
                                            $scope.onAddendumUserSelect();
                                            $scope.currentWindow = 'win_addendum_request';
                                            OpenWindow($scope.win_addendum_request, 'win_addendum_request');
                                            $scope.win_addendum_request.wrapper.prev(".k-overlay").addClass("custom-overlay");
                                        });
                                    }
                                }
                            );
                        }
                        if (($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles && ($sessionStorage.currentUserData.userRoles.includes("Admin") || $sessionStorage.currentUserData.userRoles.includes("Technologist"))) && !Order.IsReviewAssigned) {
                            contextMenus.push('separator');
                            contextMenus.push({
                                name: 'Add to Peer Review',
                                subMenu: [
                                    {
                                        name: 'Auto Assign',
                                        action: function () {
                                            AddToPeerReview('Auto Assign', Order);
                                        }
                                    },
                                    'separator',
                                    {
                                        name: 'Assign to Specific User',
                                        action: function () {
                                            AddToPeerReview('Assign to Specific User', Order);
                                        }
                                    }
                                ],
                            });
                        }
                        break;
                }
                if ($sessionStorage.IsQueryRetrieveVisible && Order.Status != 'C' && Order.IsQREnable) {
                    contextMenus.push('separator');
                    contextMenus.push({
                        name: 'Query Retrieve',
                        action: function () {
                            $scope.QueryRetrieve(Order);
                        }
                    });
                }
                contextMenus.push('separator');
                contextMenus.push(
                    {
                        name: 'Open Discussion (F11)',
                        action: function () {
                            $scope.LoadDiscussion(Order.DicomOrderID, Order.FileCount);
                        }
                    });

                if (Order.DicomViewer &&
                    $sessionStorage.currentUserData &&
                    $sessionStorage.currentUserData.userRoles &&
                    ($sessionStorage.currentUserData.userRoles.includes("Admin") ||
                     $sessionStorage.currentUserData.userRoles.includes("Technologist"))) {
                    contextMenus.push('separator');
                    contextMenus.push({
                        name: 'Share Exam',
                        action: function () {
                            openShareExamWindow(Order);
                        }
                    });
                }

                //#region Copy Data
                contextMenus.push('separator');
                var copySubmenu = [];
                copySubmenu.push({
                    name: 'Copy Cell Value',
                    action: function () {
                        if (params.value) {
                            navigator.clipboard.writeText(params.value);
                        }
                    },
                    icon: "<i class='ag-icon ag-icon-copy'></i>",
                });
                copySubmenu.push('separator');
                copySubmenu.push('copy');
                copySubmenu.push('separator');
                copySubmenu.push('copyWithHeaders');
                contextMenus.push({
                    name: 'Copy',
                    subMenu: copySubmenu
                });
                //#endregion Copy Data 

            }
            return contextMenus;
        }
        $scope.HideStudy = function (hideHours, Comments) {
            //////$log.log("HideStudy");
            var type = 0;
            $scope.Comments = Comments;
            $scope.hideHours = hideHours;

            if ($scope.HideOption === 'NotRead') {
                type = 1;
            }

            //Check Study should not be today.
            WorklistService.GetCurrentDateTime().then(function (result) {
                HideUnhideOrder(type);
            });
        };

        function HideUnhideOrder(type) {
            //////$log.log("HideUnhideOrder");
            //$scope.isLoading = true;
            var order = {
                OrderID: $scope.SelectedOrderID,
                IsHide: $scope.SelectedOrder.Status == 'H' ? false : true,
                Type: type,
                Min: ($scope.HideOption === 'Hide') ? parseInt($scope.hideHours) * 60 : 0,
                UserId: $sessionStorage.currentUserData.userId,
                PhysicianName: $sessionStorage.currentUserData.displayName,
                order: $scope.SelectedOrder,
                Comments: $scope.Comments
            };
            switch (type) {
                case 1:
                    order.EventType = 'HNR';
                    break;
                case 2:
                    order.EventType = 'HHR';
                    break;
                case 3:
                    order.EventType = 'HNC';
                    break;
                case 4:
                    order.EventType = 'HNI';
                    break;
            }
            WorklistService.ShowHideOrder(order).then(function (result) {
                var selectedNode;
                if (gridOptions && gridOptions.api) {
                    selectedNode = _.find(gridOptions.api.getRenderedNodes(), function (node) {
                        if (node && node.data) {
                            return node.data.DicomOrderID == $scope.SelectedOrder.DicomOrderID;
                        }
                    });
                    if (selectedNode) {
                        selectedNode.data.RowColorCode = getRowTemplateColorCode(selectedNode.data);
                        gridOptions.api.redrawRows({ rowNodes: [selectedNode] });
                        removeRowFromGrid(selectedNode);
                    }
                }
                //$scope.isLoading = false;
                if (type == 1) {
                    var HiddenType = _.find($scope.HiddenTypeList, { Value: type.toString() });
                    if (HiddenType) {
                        var Comments = HiddenType.Key + ($scope.Comments && $scope.Comments.length > 0 ? ' - ' + $scope.Comments : '');
                        $scope.Discussion = {
                            ReferenceID: $scope.SelectedOrder.DicomOrderID,
                            Type: 1,
                            Comment: Comments,
                            Record_Created_By: $sessionStorage.currentUserData.userId
                        };
                        $scope.SaveDiscussion();
                        Comments = null;
                    }
                }

                $scope.SelectedOrderID = "";
                //$scope.win_HideStudy.close();
                //$scope.refresh();
                if (type == 4) {
                    WorklistService.sendTextNotification(order);
                }

            });
        }
        $scope.CallInConsult = function (order) {
            //$scope.isChatMenuActive = true;
            // $rootScope.$broadcast('activeChatMenuBarformWorkList', $scope.isChatMenuActive,order);
            $scope.setSelected(order.OrderID, order);
            $scope.currentWindow = 'win_consultExamsWindow';
            OpenWindow($scope.win_consultExamsWindow, 'win_consultExamsWindow');
            $scope.win_consultExamsWindow.wrapper.prev(".k-overlay").addClass("custom-overlay");
        }
        $scope.clearSelectedChildRows = function () {
            if (_subGridAPI) {
                _subGridAPI.selection.clearSelectedRows();
            }
        }

        //Close onClick of send message button from shareExamchat.js
        $scope.onCloseConsultExamWindowHandler = function (newCheck) {
            $scope.isConsultExamsWindow = newCheck;
            if ($scope.isConsultExamsWindow == true) {
                $scope.win_consultExamsWindow.close();
            }
        };
        function openShareExamWindow(SelectedOrder) {
            if ($scope.currentWindow && $scope[$scope.currentWindow] && $scope[$scope.currentWindow] !== $scope.win_shareExamsWindow) {
                $scope[$scope.currentWindow].close();
            }
            $scope.setSelected(SelectedOrder.OrderID, SelectedOrder);
            $scope.currentWindow = 'win_shareExamsWindow';
            OpenWindow($scope.win_shareExamsWindow, 'win_shareExamsWindow');
            $scope.win_shareExamsWindow.wrapper.prev(".k-overlay").addClass("custom-overlay");
        }

        $scope.onCloseShareExamWindowHandler = function (newCheck) {
            $scope.isShareExamWindowVisible = newCheck;
            if ($scope.isShareExamWindowVisible == true) {
                $scope.win_shareExamsWindow.close();
            }
        };
        function OpenWindow(win, key) {
            if (win) {
                win.open();
                var dollarTimeout = $timeout(function () {
                    win.center();
                    $timeout.cancel(dollarTimeout);
                    dollarTimeout = null;
                }, 100);
            } else {
                var dialog = $("div[kendo-window='" + key + "']").data("kendoWindow");
                if (dialog) {
                    dialog.open();
                    var dollarTimeout = $timeout(function () {
                        dialog.center();
                        $timeout.cancel(dollarTimeout);
                        dollarTimeout = null;
                    }, 100);
                }
            }

        }
        /**
         * Modified By: Tejas Parikh
         * Task 22822: All sites should be listed in alphabetical manner in location filter list
         * @param {any} a
         * @param {any} b
         */
        function compare(a, b) {
            //$log.log("compare: " + new Date());
            // Use toUpperCase() to ignore character casing
            var bandA = a.text.toUpperCase();
            var bandB = b.text.toUpperCase();

            var comparison = 0;
            if (bandA > bandB) {
                comparison = 1;
            } else if (bandA < bandB) {
                comparison = -1;
            }
            return comparison;
        }

        function checkedNodeValues(nodes, checkedNodes) {
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && !nodes[i].hasChildren) {
                    if (checkedNodes.indexOf(nodes[i].value) < 0) {
                        checkedNodes.push(nodes[i].value);
                    }

                }
                if (nodes[i].hasChildren) {
                    checkedNodeValues(nodes[i].children.view(), checkedNodes);
                }
            }
            return checkedNodes;
        }

        $scope.bindLocationFilter = function () {
            WorklistService.GetSitesAndLocationsForWorkList($sessionStorage.currentUserData.userId).then(function (result) {
                var Locations = result;
                Locations = $filter('orderBy')(Locations, 'title');
                $scope.LocInstance = $('#Locations').comboTree({
                    source: Locations,
                    isMultiple: true,
                    cascadeSelect: true,
                    collapse: true,
                    onlyChild: true
                });
            });
        };
        function GetModality() {
            //$log.log("GetModality: " + new Date());
            var d = $q.defer();
            TechnoService.GetModality().then(function (result) {
                //$log.log("GetModality response: " + new Date());
                $scope.Modalities = result;
                d.resolve();
            });
            return d.promise;
        };
        function GetUserPreferences() {
            var d = $q.defer();
            //$log.log("GetUserPreferences: " + new Date());
            //$scope.isLoading = true;
            var userPreference = {
                UserID: $sessionStorage.currentUserData.userId,
                PreferenceType: "Choose Next Study,DisplaySetting,ShowUserGuideTech,ShowReleaseGuideTech",
            };
            UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
                //$log.log("GetUserPreferences response: " + new Date());
                result = result.UserPreferences;
                if (result !== null && result.length > 0) {
                    if ($scope.browser !== null && $scope.browser.toUpperCase() === "IE") {
                        $scope.ChooseNextStudy = result[0].PreferenceValue === "1" ? true : false;
                    }
                }
                var pref1 = _.filter(result, function (obj) { return obj.PreferenceType == "DisplaySetting"; })[0];
                if (pref1) {
                    pref1 = _.filter(JSON.parse(pref1.PreferenceValue), function (obj) { return obj.HostFingerPrintHash == $sessionStorage.currentUserData.HostFingerPrintHash })[0];
                    if (pref1) {
                        windowHandler.LoadPrefenece(pref1.DisplaySetting);
                    }
                }
                var pref1 = _.filter(result, function (obj) { return obj.PreferenceType == "DisplaySetting"; })[0];
                if (pref1) {
                    pref1 = _.filter(JSON.parse(pref1.PreferenceValue), function (obj) { return obj.HostFingerPrintHash == $sessionStorage.currentUserData.HostFingerPrintHash })[0];
                    if (pref1) {
                        windowHandler.LoadPrefenece(pref1.DisplaySetting);
                    }
                }
                showUserGuideTech = _.find(result, { PreferenceType: "ShowUserGuideTech" });
                ShowReleaseGuideTech = _.find(result, {
                    PreferenceType: "ShowReleaseGuideTech"
                });
                d.resolve();
            });
            return d.promise;
        };

        function UpdateDicomOrderSTAT(order) {
            order.UserId = $sessionStorage.currentUserData.userId;
            TechnoService.UpdateDicomOrderSTAT(order).then(function (result) {
            });
        };
        function UpdateStrokeSTAT(order) {
            order.UserId = $sessionStorage.currentUserData.userId;
            TechnoService.UpdateStrokeSTAT(order);
        };
        $scope.ResendReport = function (order) {
            //$scope.isorderlistLoading = true;
            var obj = {
                OrderID: order.OrderID,
                UserID: $sessionStorage.currentUserData.userId,
                MessageType: "ORU"
            };
            TechnoService.ResendReport(obj).then(function (result) {
                //$scope.isorderlistLoading = false;
                toaster.success({ body: "Report send successfully!" });
            }).catch(function (noCantDo) {
                //$scope.isorderlistLoading = false;
                toaster.error({ body: "Report not send! Please try again!" });
            });
        };
        function PageInIt() {
            //$log.log("PageInIt: " + new Date());
            //const gridDiv = document.querySelector('#myGrid');
            //new agGrid.Grid(gridDiv, gridOptions);
            intiAppHub();
            updatePageSize();
            setHeight();
            previousHeight = currentHeight;
            $q.all([
                getLookUpByType(),
                GetUserPreferences(),
                GetSitesAndLocationsByUserID(),
                GetModality(),
                getTechnoPageSetting(),
                GetUserLayoutPreferences()
            ]).then(function (data) {
                checkImagePendingRequest().then(function () {
                    updateRefreshDOSInterval();
                    refreshDOSMidnight = $interval(refreshDOS, refreshDOSInterval);
                    OrderRefresh();
                    getOrderStatus();
                    var timeout = $timeout(function () {
                        initGrid();
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 100);
                });
            });
        }
        function checkImagePendingRequest() {
            //$log.log("checkImagePendingRequest: " + new Date());
            var d = $q.defer();
            TechnoService.getImagePendingCount($sessionStorage.currentUserData.userId).then(function (result) {
                //$log.log("checkImagePendingRequest response: " + new Date());
                //$scope.ImagePengindCount = result;
                if (result && result.length > 0) {
                    var name = '';
                    var cnt = 0;
                    if (result.length > 1) {
                        angular.forEach(result, function (obj) {
                            if (cnt === 0) {
                                name = '<div> - ' + obj.UserName + '</div>';
                            }
                            else {
                                name = name + '<div> - ' + obj.UserName + '</div>';
                            }
                            cnt++;
                        });

                        swal({
                            title: "",
                            text: "<div class='rf-alert-text'><div>Below physicians has requested for additional images.</div> \n" + name + "</div>",
                            html: true
                        });
                    }
                    else {

                        swal({
                            title: "",
                            text: "<div class='rf-alert-text'>" + result[0].UserName + " has requested for additional images.</div>",
                            html: true
                        });
                    }

                    $scope.Status = "H";
                    $scope.HiddenType.obj = _.filter($scope.HiddenTypeList, { Value: "4" })[0];
                }
                d.resolve();
            }, function (error) {
                d.reject();
            });
            return d.promise;
        }

        $scope.HelpOrder = function () {
            $scope.Ishelper = false;
            $scope.OrderDiscussion = null;
            //$('#ModalHelpOrder').modal('show');
            $scope.currentWindow = "win_HelpOrder";
            $scope.win_HelpOrder.open();
            $scope.win_HelpOrder.wrapper.prev(".k-overlay").addClass("custom-overlay");
            var timeout = setTimeout(function () {
                $scope.win_HelpOrder.center();
                clearTimeout(timeout);
                timeout = null;
            }, 1000);
            $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID);
            LoadOrderDiscussionForUser();
        }

        $scope.LoadReport = function () {
            $scope.selecteReportId = null;
            var timeout = setTimeout(function () {
                $scope.selecteReportId = $scope.SelectedOrder.OrderID;
                if ($scope.selecteReportId) {
                    //angular.element('#ModalViewReport').modal('show');
                    $scope.currentWindow = "win_ViewReport";
                    $scope.win_ViewReport.open();
                    $scope.win_ViewReport.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    $scope.win_ViewReport.wrapper.addClass("report-top-mdl");
                    var timeout1 = setTimeout(function () {
                        $scope.win_ViewReport.center();
                        clearTimeout(timeout1);
                        timeout1 = null;
                    }, 1000);
                }
                clearTimeout(timeout);
                timeout = null;
            }, 100);
        }

        function LoadOrderDiscussionForUser() {
            //$log.log("LoadOrderDiscussionForUser");
            $scope.orderDiscussionTooltip = '';
            $scope.OrderDiscussion = {
                SelectedUser: null,
                SelectedUsers: []
            };
            var data = {
                OrderID: $scope.SelectedOrder.OrderID,
                FromUserID: $sessionStorage.currentUserData.userId
            }

            //$scope.isDiscussionLoading = true;
            TechnoService.GetOrderDiscussionAssignment(data).then(function (response) {
                $scope.isDiscussionLoading = false;
                if (response) {
                    $scope.OrderDiscussion = response;
                    $q.all([
                        $scope.GetAllUsers($scope.SelectedOrder.SiteID)
                    ]).then(function (data) {
                        if (!$scope.OrderDiscussion.SelectedUsers && !$scope.OrderDiscussion.SelectedRadioLogistsGroup) {
                            $scope.OrderDiscussion.SelectedUsers = [];
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                            var SelectedRadioLogistsGroup = [];
                            _.each($scope.OrderDiscussion.OrderAssignments, function (orderAssignment) {
                                if (orderAssignment.ProviderSpecialityId > 0) {
                                    var radiologistGroup = _.find($scope.RadiologistsGroups, { Id: orderAssignment.ProviderSpecialityId.toString() });
                                    if (radiologistGroup) {
                                        SelectedRadioLogistsGroup.push(radiologistGroup);
                                    }
                                } else {
                                    var radiologistGroup = _.find($scope.RadiologistsGroups, { Id: orderAssignment.ProviderID });
                                    if (radiologistGroup) {
                                        SelectedRadioLogistsGroup.push(radiologistGroup);
                                    }
                                }
                            });
                            var uniqueSelectedRadioLogistsGroup = _.uniqBy(SelectedRadioLogistsGroup, 'Id');
                            var orderedSelectedRadioLogistsGroup = _.concat(_.orderBy(_.filter(uniqueSelectedRadioLogistsGroup, function (srlg) { return srlg.Group && srlg.Group == 'YES'; }), ['UserName'], ['asc']), _.orderBy(_.filter(uniqueSelectedRadioLogistsGroup, function (srlg) { return !srlg.Group; }), ['UserName'], ['asc']));
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup = orderedSelectedRadioLogistsGroup;

                            $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();
                            var timeout = setTimeout(function () {
                                setOrderDiscussionUserGroup().then(function (data) {
                                    setOrderDiscussionTooltip();
                                    setSelectedUserAssignment(data);
                                });
                                $scope.AssignStudyVisible = false;
                                if ($scope.OrderDiscussion.SelectedUsers && $scope.OrderDiscussion.SelectedUsers.length > 0) {
                                    $scope.AssignStudyVisible = true;
                                }
                                $scope.OrderDiscussion.isDirty = false;

                                clearTimeout(timeout);
                                timeout = null;
                            }, 100);
                        }

                    });
                } else {
                    $scope.GetAllUsers($scope.SelectedOrder.SiteID)
                }
            }, _respError);
        }
        $scope.LoadDiscussion = function (referenceID, FileCount) {
            //$log.log("LoadDiscussion");
            $scope.onDiscussionWindowTabChange('Discussion');
            $scope.hidePopover(referenceID);
            $scope.showAttachment = false;
            $scope.FileList = [];
            $scope.isDiscussionLoading = true;
            angular.element("input[type='file']").val(null);
            $scope.Discussion = {
                ReferenceID: referenceID,
                Type: 1,
                Comment: '',
                Record_Created_By: $sessionStorage.currentUserData.userId
            };
            $scope.Discussions = null;
            LoadDiscussion($scope.Discussion);
            var dollarTimeout = $timeout(function () {
                LoadOrderDiscussionForUser();
                $timeout.cancel(dollarTimeout);
                dollarTimeout = null;
            }, 500);
            $scope.currentWindow = "win_Discussion";
            $scope.win_Discussion.open();
            $scope.win_Discussion.wrapper.prev(".k-overlay").addClass("custom-overlay");
            $scope.win_Discussion.wrapper.addClass("report-top-mdl");
            var timeout = setTimeout(function () {
                $scope.win_Discussion.center();
                clearTimeout(timeout);
                timeout = null;
            }, 1000);
        }
        function LoadDiscussion(discussion) {
            //$log.log("LoadDiscussion: " + new Date());
            var d = $q.defer();
            TechnoService.GetDiscussions(discussion).then(function (response) {
                $scope.AllDiscussions = _.cloneDeep(response);
                $scope.Discussions = _.filter(response, function (item) { return item.Type == 1; });
                angular.forEach($scope.Discussions, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
                d.resolve();
            }, _respError);
            return d.promise;
        }
        function LoadChildDiscussion(ObjDiscussion) {
            //$log.log("LoadChildDiscussion: " + new Date());
            var response = _.filter($scope.AllDiscussions, function (item) { return item.ReferenceID == ObjDiscussion.ID; });
            if (response && (response.length > 0)) {
                if (!ObjDiscussion.Childs || ObjDiscussion.Childs.length != response.length) {
                    ObjDiscussion.Childs = response;
                }
                angular.forEach(ObjDiscussion.Childs, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            }
        }
        function bindChildDiscussion(ObjDiscussion) {
            angular.forEach($scope.Discussions, function (obj, idx) {
                LoadChildDiscussion(obj);
            });
        }
        $scope.SaveOrderDiscussion = function () {
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];

                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_MSG_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });


                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'O'
                };
                $scope.isDiscussionLoading = true;
                TechnoService.SetOrderDiscussionAssignment(data).then(function (response) {
                    $scope.SaveDiscussion();
                    LoadOrderDiscussionForUser();
                }, _respError);
            }
        }
        $scope.AssignStudy = function () {
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];
                $scope.SelectedOrder.listOrderListAssignment = [];
                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_STUDY_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var userOfGroup = _.filter($scope.OrderDiscussion.SelectedUsers, function (item) { return item.SpecialityId == obj.SpecialityId; });

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode,
                        TotalUsersOfGroup: userOfGroup.length
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });
                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'I',
                    Order: $scope.SelectedOrder,
                    EventType: 'TC',
                };
                //$scope.isLoading = true;

                TechnoService.SetOrderDiscussionAssignment(data).then(function (response) {
                    LoadOrderDiscussionForUser();
                    $scope.SaveDiscussionFlag = false;
                }, _respError);
            }
        };
        $scope.CloseOrderDiscussion = function () {
            var orderDiscussionUserGroup = [];
            _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                var userGroup = {
                    ToUserID: obj.Id,
                    ToUser: obj.LastName + ', ' + obj.FirstName,
                    ProviderSpecialityId: obj.SpecialityId,
                    IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                }
                orderDiscussionUserGroup.push(userGroup);
            });
            NotifyToUser(__env._ANS_MSG_, $scope.SelectedOrder.OrderID, $scope.OrderDiscussion.FromUserID, null);
            $scope.OrderDiscussion.OrderDiscussionUserGroup = orderDiscussionUserGroup;
            TechnoService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                //$('#ModalHelpOrder').modal('hide');
                $scope.win_HelpOrder.close();
            }, _respError);
        }
        $scope.SaveDiscussion = function () {
            $scope.isDiscussionLoading = true;
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedUsers) {
                $scope.SaveDiscussionFlag = true;
                $scope.AssignStudy();
            }
            if ($scope.Discussion.Comment) {
                $scope.SaveDiscussionFlag = true;
                $scope.Discussion.EventType = 'TC';
                TechnoService.SetDiscussion($scope.Discussion).then(function (response) {
                    var idx = _.findIndex(DicomOrderList, function (obj) { return obj.DicomOrderID == response.ReferenceID; });
                    if (idx != -1) {
                        DicomOrderList[idx].IsDiscussion = true;

                        var rowToUpdate = gridOptions.api.getRowNode((DicomOrderList[idx].orderRowID).toString());
                        if (rowToUpdate && rowToUpdate.data) {
                            rowToUpdate.data.IsDiscussion = true;
                            gridOptions.api.refreshCells({
                                force: true,
                                suppressFlash: true,
                                rowNodes: [rowToUpdate]
                            });
                        }
                    }
                    //updateOrders();
                    LoadDiscussion($scope.Discussion);
                    $scope.Discussion.Comment = null;
                    $scope.SaveDiscussionFlag = false;
                }, _respError);
            }
            $scope.isDiscussionLoading = false;
        }
        $scope.SaveChildDiscussion = function (discussion) {
            if (discussion.ChildComment) {
                var Objdiscussion = {
                    ReferenceID: discussion.ID,
                    Type: 0,
                    Comment: discussion.ChildComment,
                    Record_Created_By: $sessionStorage.currentUserData.userId
                };
                if (discussion.Record_Created_By !== $sessionStorage.currentUserData.userId) {
                    NotifyToUser(__env._NOTIFY_MSG_, $scope.SelectedOrder.OrderID, discussion.Record_Created_By, "N");
                }
                $scope.isDiscussionLoading = true;
                TechnoService.SetDiscussion(Objdiscussion).then(function (response) {
                    $scope.isDiscussionLoading = false;
                    discussion.IsChild = false;
                    discussion.ChildComment = '';
                    $scope.AllDiscussions.push(response);
                    bindChildDiscussion(response);
                }, _respError);
            }

        }

        function _respError(error) {
            $scope.isDiscussionLoading = false;
        }

        $scope.GetAllUsers = function (SiteID) {
            var d = $q.defer();
            var filter = {
                SiteID: SiteID
            };
            WorklistService.GetRadiologistsBySite(filter).then(function (result) {
                siteRadiologistsUnfiltered = result.radiologistsLists || [];
                $scope.Radiologists = _.filter(siteRadiologistsUnfiltered, function (r) {
                    return _isSelf(r.Id || r.UserID) || !_hasPrelimRad(r.UserRoles || r.Roles);
                });
                specialityAssignments = result.specialityAssignments;

                $scope.RadiologistsGroups = [];
                var mRadiologistsGroups = [];

                var uniqueSpeciality = _.uniqBy(specialityAssignments, 'SpecialityId');
                _.each(uniqueSpeciality, function (obj) {

                    var RadiologistsGroup = {};
                    RadiologistsGroup['Id'] = obj.SpecialityId;
                    RadiologistsGroup['UserName'] = obj.SpecialityCode;
                    RadiologistsGroup['Group'] = "YES";
                    mRadiologistsGroups.push(RadiologistsGroup);


                });
                _.each(specialityAssignments, function (speciality) {
                    var user = _.find($scope.Radiologists, { 'Id': speciality.UserId });
                    if (user) {
                        if (!user.Specialities) {
                            user.Specialities = [];
                        }
                        var spclty = _.find(user.Specialities, { SpecialityId: speciality.SpecialityId });
                        if (!spclty) {
                            user.Specialities.push(speciality);
                        }
                    }
                });

                mRadiologistsGroups.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                $scope.Radiologists.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                mRadiologistsGroups = mRadiologistsGroups.concat($scope.Radiologists);

                $scope.RadiologistsGroups = mRadiologistsGroups;
                getOrderDiscussionOptions();

                d.resolve();

            });
            return d.promise;
        };
        function OpenDiscussionOrder() {
            $scope.OrderDiscussion = null;
            if ($state.params["OD"]) {
                $scope.OrderDiscussion = $state.params["OD"];
                $scope.setSelected($scope.OrderDiscussion.Order.OrderID, $scope.OrderDiscussion.Order);
                $scope.currentWindow = "win_HelpOrder";
                $scope.win_HelpOrder.open();
                $scope.win_HelpOrder.wrapper.prev(".k-overlay").addClass("custom-overlay");
                var timeout = setTimeout(function () {
                    $scope.win_HelpOrder.center();
                    clearTimeout(timeout);
                    timeout = null;
                }, 1000);
                $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID);
                if ($scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId) {
                    if ($scope.OrderDiscussion.Status == 'A') {
                        $scope.OrderDiscussion.Status = 'C';
                        TechnoService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                            LoadOrderDiscussionForUser();
                        }, _respError);
                    } else {
                        LoadOrderDiscussionForUser();
                    }
                } else {
                    if ($scope.OrderDiscussion.Status == 'N') {
                        $scope.OrderDiscussion.Status = 'D';
                        TechnoService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                            LoadOrderDiscussionForUser();
                        }, _respError);
                        return;
                    }
                    var list = _.filter($scope.Radiologists, function (obj) { return $scope.OrderDiscussion.ToUserID == obj.Id; });
                    if (list && list.length > 0) {
                        $scope.OrderDiscussion.SelectedUser = list[0];
                    }
                    $scope.OrderDiscussion.Status = 'A';
                    $scope.Ishelper = true;
                }
            }
        }
        OpenDiscussionOrder();

        function NotifyToUser(msg, orderID, toUserID, status) {
            var data = {
                OrderID: orderID,
                FromUserID: $sessionStorage.currentUserData.userId,
                FromUser: $sessionStorage.currentUserData.displayName,
                ToUserID: toUserID,
                Status: status,
                Message: msg
            }
            TechnoService.NotifyToUser(data).then(function (response) {
            }, _respError);
        }

        $scope.OpenDiscussion = function (referenceID) {
            $scope.ODType = 'Discussion';
            $scope.LoadDiscussion(referenceID, 'Discussion');
        };

        $scope.openDiscussion = function () {
            if ($scope.SelectedOrder && $scope.SelectedOrder.FileCount > 0) {
                selectPriorReportTab("#tabDiscussion");
                $scope.DataObject.Reference.ID = null;
                if ($scope.Discussion && $scope.Discussion.ReferenceID) {
                    var timeout = setTimeout(function () {
                        $scope.showAttachment = true;
                        $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
                        clearTimeout(timeout);
                        timeout = null;
                    }, 50);
                }
            }
        }

        function selectPriorReportTab(tabName) {
            $("#tabReport").removeClass('active');
            $("#tabDiscussion").removeClass('active');
            $("#Discussion").removeClass('active');
            $("#Report").removeClass('active');
            $(tabName).addClass('active');
            $(tabName.replace('tab', '')).addClass('active');
            var tabStrip = $("#tabstrip").kendoTabStrip().data("kendoTabStrip");
            tabStrip.select(tabName);
        }

        function intiAppHub() {
            AppHub = AppHubService.getAppHub();
            var justCreated = false;
            if (!AppHub && $sessionStorage.currentUserData) {
                AppHubService.Initialize();
                AppHub = AppHubService.getAppHub();
                justCreated = true;
            }
            if (AppHub) {
                AppHubMethod();
                if (justCreated) AppHubService.startConnection();
            }
        }

        function AppHubMethod() {
            AppHub.on('RadFlowAppHubEvent', function (obj) {
                switch (obj.EventType) {
                    case 'techworklistupdatehandler':
                        OrderAutoRefresh = false;
                        //isOrderOnServer = true;
                        //if (!($scope.isDiscussionVisible ||
                        //    $scope.isPatientInfoVisible ||
                        //    $scope.isHelpOrderVisible ||
                        //    $scope.isViewReportVisible)) {
                        //    $scope.getData();
                        //}
                        break;
                    case 'notifyopenorder':
                        var OrderID = obj.EventArgs.OrderID;
                        var isOpen = obj.EventArgs.Open;
                        var ProviderID = obj.EventArgs.ProviderID;
                        var ProviderName = obj.EventArgs.ProviderName;

                        $log.log('NotifyOpenOrder is call');
                        OrderAutoRefresh = false;
                        //$scope.isorderlistLoading = false;
                        if ($sessionStorage.currentUserData.userId != ProviderID) {
                            var rowToUpdate;
                            var objOrder = _.filter(DicomOrderList, function (obj) { return obj.OrderID == OrderID; });
                            if (objOrder && objOrder.length > 0) {
                                rowToUpdate = gridOptions.api.getRowNode((objOrder[0].orderRowID).toString());
                                if ($scope.ShowLockStudy) {
                                    if (isOpen) {
                                        objOrder[0].IsLock = true;
                                        objOrder[0].LockBy = ProviderName;

                                        if (rowToUpdate && rowToUpdate.data) {
                                            rowToUpdate.data.IsLock = true;
                                            rowToUpdate.data.LockBy = ProviderName;
                                        }
                                    }
                                    else {
                                        objOrder[0].IsLock = false;
                                        if (rowToUpdate && rowToUpdate.data) {
                                            rowToUpdate.data.IsLock = false;
                                        }
                                    }
                                }
                                else {
                                    isOrderOnServer = true;
                                }

                                if (rowToUpdate && gridOptions && gridOptions.api) {
                                    gridOptions.api.refreshCells({
                                        force: true,
                                        suppressFlash: true,
                                        rowNodes: [rowToUpdate]
                                    });
                                }
                            }
                        }
                        break;
                    case 'notifyoruupdate':
                        OrderAutoRefresh = false;
                        removeOrderAccession(obj.EventArgs.Accession);
                        //$scope.getData();
                        break;
                    case 'notifyshowhidedicomorder':
                        var HideStudy = obj.EventArgs.HideStudy;
                        OrderAutoRefresh = false;
                        var orderIndex = OrderExists(HideStudy.order.OrderID);
                        if (orderIndex != -1) {
                            if (!HideStudy.IsHide) {
                                DicomOrderList[orderIndex].IPComment = '';

                            } else {
                                DicomOrderList[orderIndex].IPComment = HideStudy.Comments;
                            }
                            DicomOrderList[orderIndex].Status = HideStudy.IsHide ? "H" : "RP";
                            if ($scope.Status != "AL") {
                                removeOrderFromList(HideStudy.order.OrderID);
                            }
                            else {
                                var rowToUpdate = gridOptions.api.getRowNode((DicomOrderList[orderIndex].orderRowID).toString());
                                if (rowToUpdate && rowToUpdate.data) {
                                    rowToUpdate.data.FileCount = $scope.SelectedOrder.FileCount;
                                    gridOptions.api.refreshCells({
                                        force: true,
                                        suppressFlash: true,
                                        rowNodes: [rowToUpdate]
                                    });
                                }
                            }
                        }
                        if (HideStudy.Type == 4) {
                            if (_.find($scope.Locations, function (obj) { return obj.SiteID == HideStudy.order.SiteID })) {
                                var toast;
                                toast = toaster.pop({
                                    type: 'info', title: 'Physician has requested for additional images!', body: 'Click here to view!', bodyOutputType: 'trustedHtml', tapToDismiss: true,
                                    clickHandler: function (Toaster, closeFlag) {
                                        if (!closeFlag) {
                                            $scope.Status = "H";
                                            $scope.HiddenType.obj = _.filter($scope.HiddenTypeList, { Value: "4" })[0];
                                            $scope.FilterDICOMOrders();
                                            switch (true) {
                                                case ($scope.isHelpOrderVisible):
                                                    $scope.win_HelpOrder.close();
                                                    break;
                                                case ($scope.isViewReportVisible):
                                                    $scope.win_ViewReport.close();
                                                    break;
                                                case ($scope.isDiscussionVisible):
                                                    $scope.win_Discussion.close();
                                                    break;
                                                case ($scope.isViewTechniqueVisible):
                                                    $scope.win_ViewTechnique.close();
                                                    break;
                                                case ($scope.isAddTechniqueVisible):
                                                    $scope.win_AddTechnique.close();
                                                    break;
                                                case ($scope.isTechFormVisible):
                                                    $scope.win_TechForm.close();
                                                    break;
                                                case ($scope.isPatientInfoVisible):
                                                    $scope.win_PatientInfo.close();
                                                    break;
                                            }
                                        }
                                        toaster.clear(toast);
                                    }
                                });
                            }
                        }
                        break;
                    case 'notifytechorderlistsavereport':
                        OrderAutoRefresh = false;
                        if (obj.EventArgs.ReportView && obj.EventArgs.ReportView.Accession) {
                            removeOrderAccession(obj.EventArgs.ReportView.Accession);
                        }
                        //$scope.getData();
                        break;
                    case 'notifyupdateorderdetail':
                        var index = _.findIndex(DicomOrderList, { 'OrderID': obj.EventArgs.OrderID });
                        if (index != -1) {
                            if (obj.EventArgs.isPeerReview != null) {
                                DicomOrderList[index].IsReviewAssigned = true;

                                var rowToUpdate = gridOptions.api.getRowNode((DicomOrderList[index].orderRowID).toString());
                                if (rowToUpdate && rowToUpdate.data && gridOptions && gridOptions.api) {
                                    rowToUpdate.data.IsReviewAssigned = true;
                                    gridOptions.api.redrawRows({ rowNodes: [rowToUpdate] });
                                }
                            }
                        }
                        break;
                    case 'notifyassignstudy':
                        NotifyAssignStudy(obj.EventArgs);
                        break;

                    case 'notifypostorderormqueuemsg':
                        CommonService.notifypostorderormqueuemsg(obj);
                        break;
                }
            });
        }


        function refreshDOS() {
            //$log.log("refreshDOS: " + new Date());
            if (refreshDOSMidnight)
                $interval.cancel(refreshDOSMidnight);
            refreshDOSMidnight = $interval(function () {
                //$log.log("refreshDOS interval: " + new Date());
                var now = new Date();
                var days = now.getDate() - $scope.currentDate.getDate();
                ////$log.log("refreshDOS > days: ", days);
                if (days > 0) {
                    $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
                    if ($scope.OrderDate.startDate && $scope.OrderDate.endDate) {
                        if ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom'))
                            $scope.OrderDateType = ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                                moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType;

                    }
                    else
                        $scope.OrderDateType = 'Clear';
                    setOrderDate($scope.OrderDateType);
                    $scope.currentDate = now;
                    //$scope.getData();-- for ag grid
                    refreshWorklistAggrid();
                }
            }, 1000);
        }


        $scope.setSelected = function (SelectedOrderID, SelectedOrder) {
            $scope.SelectedOrderID = SelectedOrderID;
            $scope.SelectedOrder = _.clone(SelectedOrder);
            $scope.SelectedOrder.DontShowReportData = true;
            $scope.SelectedOrder.OrderDate = ($filter('localDate')($scope.SelectedOrder.OrderDate, false, new Date()));
            if ($scope.SelectedOrder && $scope.SelectedOrder.PatientDOB) {
                $scope.SelectedOrder.PatientDOB = changeDateFormat($scope.SelectedOrder.PatientDOB);
            }
            if ($scope.SelectedOrder && $scope.SelectedOrder.Status) {
                $scope.SelectedOrder.OrderStatus = _.find($scope.DataObject.OrderStatus, { 'key': $scope.SelectedOrder.Status }).value;
            }
            $scope.SelectedComPatisomOrderID = "";
            //swal(SelectedComPatisomOrderID); 
            //js for discussion pop wondow to show message box when keypad comes up
            if (angular.element(window).width() < 768) {
                var timeout = setTimeout(function () {
                    angular.element('.discus-comment .txt-area').focusin(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').addClass('mobscreen-scroll');
                            var timeout1 = setTimeout(function () {
                                angular.element('.denial-window.mobscreen-scroll').animate({ scrollTop: $(document).height() }, "fast");
                                clearTimeout(timeout1);
                                timeout1 = null;
                            }, 100);
                        }
                    });
                    angular.element('.discus-comment .txt-area').focusout(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').removeClass('mobscreen-scroll');
                        }
                    });
                    clearTimeout(timeout);
                    timeout = null;
                }, 500);
            }
        };
        $scope.setSelectedComparison = function (SelectedOrderID, SelectedComPatisomOrderID) {
            $scope.SelectedComPatisomOrderID = SelectedComPatisomOrderID;
            $scope.SelectedOrderID = SelectedOrderID;
            //swal(SelectedComPatisomOrderID);
        };


        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };

        //#region Instance the tech tour
        var tourTechno = new Tour({
            steps: [],
            backdrop: true,
            onShown: function (tour) {
                if (tour && tour._options) {
                    var step = tour._options.steps[tour._current];
                    $(step.element).addClass('tour-section-disbl');
                }
            },
            onHidden: function (tour) {
                if (tour && tour._options) {
                    var step = tour._options.steps[tour._current];
                    $(step.element).removeClass('tour-section-disbl');
                }
            },
            onEnd: function (tour) {
                $('.tour-section-disbl').removeClass('tour-section-disbl');
                updateuserguidetechpreference();
                GetUserPreferences().then(function () {
                    if (!ShowReleaseGuideTech || ShowReleaseGuideTech.PreferenceValue != APP_CONSTANTS.radflowUIVersion) {
                        $rootScope.$broadcast('ShowReleaseGuideTech', true);
                    };
                });
            },
        });

        tourTechno.init();

        function startUserGuideTechTour() {
            if (!showUserGuideTech || showUserGuideTech.PreferenceValue != "0") {
                tourTechno.init();
                tourTechno.setCurrentStep(0);
                tourTechno.start(true);
            }
            else {
                if (!ShowReleaseGuideTech || ShowReleaseGuideTech.PreferenceValue != APP_CONSTANTS.radflowUIVersion) {
                    $rootScope.$broadcast('ShowReleaseGuideTech', true);
                }
            }
        }

        $scope.$on("Techno_Tour", function (evt, data) {
            if (data) {
                TourFlag = true;
                HelpTechnoTour();
            }
        });
        //#endregion Instance the tech tour

        PageInIt();

        $scope.$on('$destroy', function () {
            AppHub.off("RadFlowAppHubEvent");

            //$interval.cancel(orderRefreshInterval);
            $interval.cancel(refreshDOSMidnight);
            $interval.cancel(OrderRefreshInterval);

            $('.popover.tour').css("display", "none");
            $('.tour-backdrop.top').css("display", "none");
            $('.tour-backdrop.bottom').css("display", "none");
            $('.tour-backdrop.left').css("display", "none");
            $('.tour-backdrop.right').css("display", "none");
            tourTechno = null;
            if (gridOptions & gridOptions.api) {
                gridOptions.api.destroy()
            }
            CloseAllWindow(true);
        });
        //$scope.$on('$destroy', function () {
        //    //$interval.cancel(orderRefreshInterval);
        //});

        /* Update Patient Information*/
        $scope.LoadPatientData = function (order) {
            LoadPatientDataFlag = true;
            $scope.DicomOrderID = null;
            $scope.PatientInfo = null;
            ProvidersFullList = [];
            TechnoService.GetDicomOrderByID(order.DicomOrderID).then(function (result) {
                if (result && result.length > 0) {
                    result[0].OrderID = order.OrderID;
                    $scope.PatientInfo = angular.copy(result[0]);
                    $scope.CPT = false;
                    if ($scope.PatientInfo.CPT_Code || $scope.PatientInfo.CPT_Description) {
                        $scope.CPT = true;
                    }
                    $scope.PatientInfo.CPTProcedures = $scope.CPT ? $scope.PatientInfo.CPT_Code : $scope.PatientInfo.Procedures;
                    $scope.PatientInfo.CPTProcedureDesc = $scope.CPT ? $scope.PatientInfo.CPT_Description : $scope.PatientInfo.ProcedureDesc;
                    $scope.PatientInfo.Status = order.Status;
                    loadPatientData(result[0]);
                    var dollarTimeout = $timeout(function () {
                        LoadOrderDiscussionForUser();
                        $timeout.cancel(dollarTimeout);
                        dollarTimeout = null;
                    }, 500);

                }
            }, function (err) {
                $log.log(err);
            });

        };
        $scope.SavePatientInfo = function (saveDataFlag, EventType) {
            if (!$scope.PatientInfo.DOSTime) {
                toaster.warning({ body: "Invalid DOS time!" });
                return;
            }
            else {
                var dos = new Date($scope.PatientInfo.DOS.getFullYear(), $scope.PatientInfo.DOS.getMonth(), $scope.PatientInfo.DOS.getDate(), $scope.PatientInfo.DOSTime.getHours(), $scope.PatientInfo.DOSTime.getMinutes(), 0).toLocaleString('en-US', { timeZone: 'US/Central' });
                if ($scope.PatientInfo.PatientFirstName && $scope.PatientInfo.PatientFirstName.length > 0 && $scope.PatientInfo.PatientLastName && $scope.PatientInfo.PatientLastName.length > 0) {
                    $scope.PatientInfo.PatientDOB = $scope.formatted_date($scope.PatientDOB.DOB);
                    var patientInfo = angular.copy($scope.PatientInfo);
                    patientInfo.Modality = ($scope.PatientInfo.Modality ? $scope.PatientInfo.Modality.Code : null);
                    patientInfo.LocationID = $scope.PatientInfo.SelectedLocation.LocationID;
                    patientInfo.OrderDate = moment(dos).format("MM-DD-YYYY HH:mm");
                    patientInfo.UserId = $sessionStorage.currentUserData.userId;

                    if ($scope.CPT) {
                        patientInfo.CPT_Code = patientInfo.CPTProcedures;
                        patientInfo.CPT_Description = patientInfo.CPTProcedureDesc;
                    } else {
                        patientInfo.Procedures = patientInfo.CPTProcedures;
                        patientInfo.ProcedureDesc = patientInfo.CPTProcedureDesc;
                    }
                    if ($scope.PatientInfo.ContrastType) {
                        patientInfo.ContrastType = $scope.PatientInfo.ContrastType.Value;
                    }
                    patientInfo.PatientClass = $scope.PatientInfo.SelectedPatientClass ? $scope.PatientInfo.SelectedPatientClass.Value : null;
                    switch (patientInfo.DelayedSTAT) {
                        case '0':
                        case '3':
                            patientInfo.IsSTAT = false;
                            break;
                        case '2':
                            patientInfo.IsSTAT = true;
                            break;
                    }
                    patientInfo.ProviderID = $scope.DataObject.OrderingPhysician.Provider.ProviderID;
                    TechnoService.SavePatientInfo(patientInfo).then(function (result) {
                        if ($scope.OrderDiscussion && $scope.OrderDiscussion.isDirty) {
                            $scope.AssignStudy();
                        }
                        if ($scope.PatientInfo.Comment) {
                            if ($scope.PatientDiscussion) {
                                $scope.PatientDiscussion.Comment = $scope.PatientInfo.Comment;
                            }
                            else {
                                $scope.PatientDiscussion = {
                                    ID: 0,
                                    ReferenceID: $scope.PatientInfo.DicomOrderID,
                                    Comment: $scope.PatientInfo.Comment,
                                    Type: 1,
                                    Record_Created_By: $sessionStorage.currentUserData.userId
                                };
                            }
                            $scope.PatientDiscussion.EventType = EventType;
                            TechnoService.SetPatientDiscussionORM($scope.PatientDiscussion).then(function (response) {
                                refreshWorklistAggrid();
                                //$scope.getData();-- for ag grid
                            }, function (error) {
                                refreshWorklistAggrid();
                                //$scope.getData();-- for ag grid
                            });
                        }
                        if (saveDataFlag) {
                            toaster.success({ body: result });
                            $scope.win_PatientInfo.center().close();
                            //$scope.getData();-- for ag grid
                            refreshWorklistAggrid();
                        }
                    });
                }
                else {
                    toaster.warning({ body: "Please enter mandatory fields!" });
                }
            }
        };
        $scope.BtnOrderComplete = function (isFormValid) {
            if (isFormValid) {
                $scope.PatientInfo.OrderStatus = 'C';
                $scope.PatientInfo.EventType = 'TOC';
                if ($scope.PatientDiscussion) {
                    $scope.PatientDiscussion.EventType = 'TOC';
                }
                $scope.SavePatientInfo(isFormValid, 'TOC');
            }
        }
        $scope.BtnSaveOrder = function (isFormValid) {
            if (isFormValid) {
                $scope.PatientInfo.EventType = 'TEO';
                $scope.SavePatientInfo(isFormValid, 'TEO');
            }
        }
        /* Update Patient Information end */

        /* File upload*/
        $scope.getFileDetails = function (e, DirectUploadFile) {

            $scope.files = [];
            $scope.$apply(function () {
                // STORE THE FILE OBJECT IN AN ARRAY.
                for (var i = 0; i < e.files.length; i++) {
                    //alert(e.files[i].type);
                    $scope.files.push(e.files[i]);
                }
                if (DirectUploadFile) {
                    $scope.uploadFiles(DirectUploadFile);
                }
                //JS for browse file or files
                angular.element('#file').value = '';
                angular.element('#file').prev('label').text('');
                if (e.files.length == 1) {
                    angular.element('#file').prev('label').append(e.files[0].name);
                }
                else if (e.files.length > 1) {
                    angular.element('#file').prev('label').append(e.files.length + " " + "files");
                }
            });
        };
        // NOW UPLOAD THE FILES.
        $scope.uploadFiles = function (DirectUploadFile) {
            if ($scope.files && $scope.files.length > 0) {
                $scope.isPatientInfoLoading = true;
                //FILL FormData WITH FILE DETAILS.
                var data = new FormData();
                var refId = $scope.SelectedOrder.DicomOrderID;
                data.append("DiacomOrderId", refId);
                data.append("userId", $sessionStorage.currentUserData.userId);
                var cnt = 0;
                for (var i in $scope.files) {
                    if ($scope.files[i].type.match('jpeg')
                        || $scope.files[i].type.match('jpg')
                        || $scope.files[i].type.match('png')
                        || $scope.files[i].type.match('pdf')
                        || $scope.files[i].name.match('doc')
                        || $scope.files[i].name.match('docx')
                        || $scope.files[i].name.match('csv')
                        || $scope.files[i].name.match('xls')
                        || $scope.files[i].name.match('xlsx')
                        || $scope.files[i].name.match('ppt')
                        || $scope.files[i].name.match('pptx')) {
                        data.append("uploadedFile", $scope.files[i]);
                        cnt++;
                    }
                }
                if (cnt === 0) {
                    toaster.warning({ body: "Only pdf, doc, excel, ppt and jpg files are allowed!" });
                    $scope.files = null;
                    angular.element("input[type='file']").val(null);
                    $scope.isPatientInfoLoading = false;
                }
                else {
                    TechnoService.uploadFile(data).then(function (result) {
                        toaster.success({ body: result.data });
                        $scope.files = null;
                        angular.element("input[type='file']").val(null);
                        $scope.isPatientInfoLoading = false;
                        if (result.data.match('success')) {
                            //$scope.refresh();
                            $scope.SelectedOrder.FileCount = ($scope.SelectedOrder.FileCount) ? $scope.SelectedOrder.FileCount : 0;
                            $scope.SelectedOrder.FileCount = $scope.SelectedOrder.FileCount + cnt;
                            var idx = _.findIndex(DicomOrderList, function (obj) { return obj.DicomOrderID == $scope.SelectedOrder.DicomOrderID; });
                            if (idx != -1) {
                                DicomOrderList[idx].FileCount = $scope.SelectedOrder.FileCount;

                                var rowToUpdate = gridOptions.api.getRowNode((DicomOrderList[idx].orderRowID).toString());
                                if (rowToUpdate && rowToUpdate.data) {
                                    rowToUpdate.data.FileCount = $scope.SelectedOrder.FileCount;
                                    gridOptions.api.refreshCells({
                                        force: true,
                                        suppressFlash: true,
                                        rowNodes: [rowToUpdate]
                                    });
                                }
                            }
                            if (DirectUploadFile) {
                                $scope.DataObject.Reference.ID = null;
                                if ($scope.Discussion && $scope.Discussion.ReferenceID) {
                                    if ($scope.DataObject.DiscussionWindowActiveTab == 'Discussion') {
                                        $scope.DataObject.DiscussionWindowActiveTab = 'Attachment';
                                    }
                                    // Use Angular's $timeout (not the global setTimeout) so the restored
                                    // Reference.ID triggers a digest - otherwise ng-if never re-evaluates
                                    // and attachment-viewer doesn't remount/re-fetch until something else
                                    // happens to trigger a digest, making the new file appear "missing".
                                    var timeout = $timeout(function () {
                                        $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
                                        $scope.DataObject.Reference.ShowLastFile = true;
                                        $timeout.cancel(timeout);
                                        timeout = null;
                                    }, 50);
                                }
                            }
                            // Non-direct uploads (e.g. the Patient Info panel's Upload button) skipped the
                            // refresh above, so a file uploaded while the Attachment panel is already open
                            // never showed up there (attachment-viewer has no $onChanges and only re-fetches
                            // when ng-if remounts it). Force the same remount here if it's currently open.
                            else if ($scope.DataObject.Reference && $scope.DataObject.Reference.ID) {
                                var currentReferenceId = $scope.DataObject.Reference.ID;
                                $scope.DataObject.Reference.ID = null;
                                var refreshTimeout = $timeout(function () {
                                    $scope.DataObject.Reference.ID = currentReferenceId;
                                    $scope.DataObject.Reference.ShowLastFile = true;
                                    $timeout.cancel(refreshTimeout);
                                    refreshTimeout = null;
                                }, 50);
                            }
                            //updateOrders();
                        }
                    }, _respError);
                }
                // remove text from file upload input field
                var uploadFileVal = document.getElementById("file");
                var prevFileUploadSiblings = uploadFileVal.previousElementSibling;
                if (prevFileUploadSiblings) {
                    prevFileUploadSiblings.innerHTML = '';
                }
            }
        }
        $scope.cancelPatientInfo = function () {
            $scope.files = [];
            angular.element("input[type='file']").val(null);
            $scope.isPatientInfoVisible = false;
        };
        $scope.$on("deleteFile", function (evt, count) {
            if (count == 0) {
                $scope.showAttachment = false;
                if ($scope.isDiscussionVisible) {
                    $scope.DataObject.DiscussionWindowActiveTab = 'Discussion';
                }
                setOrderDiscussionUserGroup().then(function (data) {
                    setOrderDiscussionTooltip();
                    setSelectedUserAssignment(data);
                });
            }
            //$scope.getData();-- for ag grid
            //refreshWorklistAggrid();
            $scope.SelectedOrder.FileCount = count;
            var rowToUpdate = gridOptions.api.getRowNode(($scope.SelectedOrder.orderRowID).toString());
            if (rowToUpdate && rowToUpdate.data) {
                rowToUpdate.data.FileCount = count;
                gridOptions.api.refreshCells({
                    force: true,
                    suppressFlash: true,
                    rowNodes: [rowToUpdate]
                });
            }
        });
        $scope.showFileList = function () {
            $scope.showAttachment = true;
            $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
        }
        $scope.hideFileList = function () {
            $scope.showAttachment = false;
            setOrderDiscussionUserGroup().then(function (data) {
                setOrderDiscussionTooltip();
                setSelectedUserAssignment(data);
            });
        }
        $scope.onSelected = function () {
            //$log.log("onSelected: " + new Date());
        }
        function setModalitytooltipTechno() {   //Bug 21548: Unable to see the selected Modalities on tooltip of worklist & tech worklist page
            $scope.modalities = '';
            if ($scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) {
                var dollarTimeout = $timeout(function () {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;');
                    $timeout.cancel(dollarTimeout);
                    dollarTimeout = null;
                }, 1);
                $('.anui').addClass("set-modality-height");
                $scope.modalitytechnotooltip = '';
                //var locations = '';
                var objModality = $filter('orderBy')($scope.SelectedList.Modality, 'Code');
                _.each(objModality, function (data) {
                    if ($scope.modalitytechnotooltip.length > 0) {
                        $scope.modalitytechnotooltip = $scope.modalitytechnotooltip + "\n" + data.Code;
                    }
                    else if ($scope.modalitytechnotooltip.length == 0) {
                        $scope.modalitytechnotooltip = data.Code;
                    }
                    if ($scope.modalities.length > 0) { $scope.modalities = $scope.modalities + "," + data.Code; }
                    else { $scope.modalities = data.Code; }
                });
                //$('#Location').attr('title', locations);
            }
            else {
                $('.anui').removeClass("set-modality-height");
                var dollarTimeout = $timeout(function () {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;');
                    $timeout.cancel(dollarTimeout);
                    dollarTimeout = null;
                }, 1);
                $scope.modalitytechnotooltip = 'Select Modalities';
                //$('#Location').attr('title', locations);
            }
        }
        $scope.clearSelModaValue = function () {
            $scope.SelectedList.Modality = [];
            $scope.DataObject.ModalityDropdownDataFilter.SelectedValue = {
                list: [],
            };
            $scope.modalitytechnotooltip = 'Select Modalities';
            $('.anui').removeClass("set-modality-height");
            //$('.anui').removeClass("set-location-height");
        }
        /**
         * Added By:    Tejas Parikh
         * Task:        Bug 21548: Unable to see the selected Modalities on tooltip of worklist & tech worklist page
         * */
        $scope.onSelectedModalityTechno = function (selectedData) {
            $scope.SelectedList.Modality = selectedData;
            setModalitytooltipTechno();
        }
        $scope.OpenSignReport = function (Order) {
            //selectRow();
            if (LastOpenOrder) {
                windowHandler.CloseWindow(["CI-VIEWER-1-" + LastOpenOrder.Accession.toUpperCase().trim(),
                "CI-VIEWER-2-" + LastOpenOrder.Accession.toUpperCase().trim(),
                'KONICA-' + LastOpenOrder.Accession.toUpperCase().trim(),
                'KONICATEST-' + LastOpenOrder.Accession.toUpperCase().trim(),
                'MedDreamViewer-' + LastOpenOrder.Accession.toUpperCase().trim(),
                'NORTHSTARKONICA-' + LastOpenOrder.Accession.toUpperCase().trim()]);
            }
            if (Order.IsImageViewableForTech) {
                LastOpenOrder = Order;
                if ($scope.browser != null && $scope.browser.toUpperCase() != "IE") {
                    //$scope.OpenVR(OrderList[index]);
                    $scope.openKonica(Order);
                    return;
                } else {
                    $scope.OpenSynapseStudy(Order, "KONICATEST", false);
                }
            }
        };

        $scope.openKonica = function (order) {
            $scope.konica_RadFlow = windowHandler.openByPreference(__env._environment.config.konicaBaseURL.replace("@MRN", order.PatientMRN).replace("@ACCESSION", order.Accession).replace("@SITE", order.Site), "KONICATEST", 100, "KONICATEST-" + order.Accession, "noreferrer");
        }
        $scope.OpenSynapseStudy = function (Order, OptionalDV, isOpenPS) {
            //$log.log("OpenSynapseStudy");

            $scope.GetDicomViewerCredentialsCallFrom = "OPENSYNAPSESTUDY";
            $scope.OpenSynapseStudyOrder = Order;
            $scope.OpenSynapseStudyOptionalDV = OptionalDV;
            $scope.OpenSynapseStudyisOpenPS = isOpenPS;
            $q.all([
                GetDicomViewerCredentials(Order.SiteID, OptionalDV)
            ]).then(function (data) {

                if (data != null && data[0] != null) {
                    if (data[0].ShowModal) { return; }
                    //else if (data[0].RequiredCredentials) {
                    else {
                        Order.DicomViewerCredentials = data[0].Credentials;
                        if (__env.showLoaderonPSNViewerLoad) {
                            $scope.isLoadingSynapse = true;
                        }
                        var timeout = setTimeout(function () {
                            OpenSynapseStudy(Order.Site, Order.Accession, Order.PatientMRN, OptionalDV, isOpenPS, Order.DicomViewerCredentials, Order.PSSiteName);
                            $scope.isLoadingSynapse = false;
                            clearTimeout(timeout);
                            timeout = null;
                        }, 500);
                    }
                }
            });
        };
        function OpenSynapseStudy(SiteName, Accession, PatientMRN, Viewer, isOpenPS, ViewerCrendetials, PSSiteName) {
            //$log.log("OpenSynapseStudy");
            if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                // Change Default Dicom Viewer to Agfa is it is inatalled.  
                if ($sessionStorage.AgfaSetup == true && SiteName.toUpperCase().replace(" ", "") == "MHSRICHARDSON") {
                    Viewer = "AGFA";
                }

                if (Viewer == null || Viewer.length == 0 || Viewer == "SYNAPSE") {
                    try {
                        var oSynapseAPI = new ActiveXObject("Synapse.SynapseAPI");
                        var sStudyPath = oSynapseAPI.MakePath(1, Accession);
                        //oSynapseAPI.OpenSynapseExplorer("Synapse", "https://pacs.texasradiology.com", sStudyPath);
                        oSynapseAPI.OpenSynapseExplorer("Synapse", __env._environment.config.synapse, sStudyPath);

                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Synapse." });
                    }
                }
                else if (Viewer == "CANDELIS") {
                    try {
                        //window.open("igplatform://viewer/?request=openstudybyaccession&AccessionNumber=" + Accession, "_self");
                        window.open(__env.candelisURL + encodeURIComponent(Accession), "_self");
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Candelis." });
                    }
                }
                else if (Viewer == "AGFA") {
                    try {
                        //window.open("AgfaHC://impax-client-epr?user=davieric&password=Davieric&domain=Agfa Healthcare&patientid=" + PatientMRN + "&accession=" + Accession, "_self");
                        window.open(__env.agfaURL + encodeURIComponent(PatientMRN.toUpperCase().replace("MHS", "")) + "&accession=" + encodeURIComponent(Accession.toUpperCase().replace("MHS", "")), "_self");
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Agfa." });
                    }
                }
                else if (Viewer == "KONICA" || Viewer == "KONICATEST" || replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                    try {

                        window.open(__env._environment.config.konicaURL.replace("@MRN", encodeURIComponent(PatientMRN)).replace("@ACCESSION", encodeURIComponent(Accession)).replace("@VIEWER", encodeURIComponent(Viewer)), "_self");
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Konica." });
                    }
                }
                else if (Viewer == "GECUV") {
                    try {
                        OpenGECentricity(Accession, ViewerCrendetials);
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Centricity Universal Viewer." });
                    }
                }
                else if (Viewer == "CI-VIEWER") {
                    try {
                        openRequestedPopup(Accession);
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in CI-Viewer." });
                    }
                } else if (Viewer == "MedDream") {
                    openMedDream(Accession);
                }

                //Open Report in PS
                var timeout = setTimeout(function () {
                    if (isOpenPS) {
                        try {
                            //Synchronize accession with PowerScribe 360 By Creating XML File
                            if ($sessionStorage.AgfaSetup == true && SiteName.toUpperCase().replace(" ", "") == "MHSRICHARDSON") //(Viewer == "AGFA") {
                            {
                                var accession = Accession.toUpperCase().replace("MHS", "");
                                CreateMHSPS360File(accession);
                                return;
                            }

                            RadWhereCtrl.Start();
                            try {
                                if (RadWhereCtrl.accessionNumbers) {
                                    $scope.CloseFrom = "RADFLOW"; //"RADFLOW" , "PS360"
                                    var r = RadWhereCtrl.CloseReport(false, false);
                                    while (!r) {
                                        r = RadWhereCtrl.CloseReport(false, false);
                                    }
                                }
                            }
                            catch (e) {
                                //swal("Unable to find the order in PS360.");
                                $log.log(e);
                            }
                            //Synchronize accession with PowerScribe 360
                            RadWhereCtrl.OpenReport(PSSiteName, Accession);
                            //RadWhereCtrl.PreviewOrders('', value);

                        } catch (e) {
                            toaster.warning({ body: "Unable to find the order in PS360." });
                            $log.log(e);
                        }
                    }

                    clearTimeout(timeout);
                    timeout = null;
                }, 500);
            }
            else {
                if (Viewer == "CI-VIEWER") {
                    try {
                        openRequestedPopup(Accession);
                    } catch (e) {
                        $log.log(e);
                        toaster.warning({ body: "Unable to find the image in Centricity Universal Viewer." });
                    }
                } else if (Viewer == "MedDream") {
                    openMedDream(Accession);
                } else {
                    var param = 'SiteName=' + encodeURIComponent(SiteName) + '%26Accession=' + encodeURIComponent(Accession);
                    window.open("RadFlowIE:" + __env._environment.config.domain + "OpenSynapse.html#?" + param, "_self");
                }


            }
        }
        function GetDicomViewerCredentials(SiteID, ViewerName) {
            //$log.log("GetDicomViewerCredentials");
            $scope.DVCred = {};
            var d = $q.defer();
            var out = {};
            var objFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: SiteID,
                ViewerName: ViewerName
            };
            if (__env.CheckDicomViewerCredentials.split(',').indexOf(ViewerName) !== -1) {
                out.RequiredCredentials = true;
                WorklistService.GetDicomViewerCredentials(objFilter).then(function (result) {
                    if (result != null && result.length > 0) {
                        out.RequiredCredentials = true;
                        out.ShowModal = false;
                        out.Credentials = {};
                        out.Credentials.UserName = result[0].UserName;
                        out.Credentials.Password = result[0].Password;
                        d.resolve(out);
                    }
                    else {
                        out.ShowModal = true;
                        $scope.DVCred.SiteID = SiteID;
                        $scope.DVCred.ViewerName = ViewerName;
                        $('#ModalDicomViewerCredentials').modal('show');
                        d.resolve(out);
                    }
                });
            }
            else {
                out.RequiredCredentials = false;
                out.ShowModal = false;
                d.resolve(out);
            }
            return d.promise;
        }
        $scope.CollapseTechnoFilter = function () {
            $scope.isDisabled = true;
            var timeout = setTimeout(function () {
                $scope.isDisabled = false;
                clearTimeout(timeout);
                timeout = null;
            }, 200);
            //$('#collapseWorklist').slideToggle();
            $('#collapseWorklist').toggleClass("in");
            $scope.isfilterCollapse = !$scope.isfilterCollapse;
            if ($scope.isfilterCollapse) {
                if ($scope.SelectedList.Location && $scope.SelectedList.Location.length > 0) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height .5s !important;');
                    $(".anui").addClass("update-vw-height");
                    $('.anui').removeClass("set-location-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height .5s !important;');
                    $(".anui").addClass("update-vw-height");
                }
                //$scope.mainGridOptions.height = $window.innerHeight - 190;
                if ($scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 0.5s !important;');
                    $(".anui").addClass("update-vw-height");
                    $('.anui').removeClass("set-modality-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 0.5s !important;');
                    $(".anui").addClass("update-vw-height");
                }

            } else {
                if ($scope.SelectedList.Location && $scope.SelectedList.Location.length > 0) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                    $('.anui').addClass("set-location-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                }
                if ($scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                    $('.anui').addClass("set-modality-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                }
                //$scope.mainGridOptions.height = $window.innerHeight - 101;
            }

        }

        //Window resizing
        $(window).resize(function () {
            if ($state.current.url != "/techno") {
                return;
            }
            adjustTechSize();
            adjustWindow();
            setHalfScale();
            setHeight();

            if (previousHeight != currentHeight) {
                updatePageSize();
                refreshWorklistAggrid();
                //$scope.getData();-- for ag grid

                previousHeight = currentHeight;
            }

            updateWindowHeight();

        });
        function setHalfScale() {
            $scope.halfScale = false;
            if ($(window).width() < 1199) {
                $scope.halfScale = true;
            }
        }

        //adjusting pop up on half scale
        function adjustTechSize() {
            if ($scope.currentWindow == 'win_Discussion') {
                $scope.win_Discussion.center();
            } else if ($scope.currentWindow == "win_PatientInfo") {
                $scope.win_PatientInfo.center();
            } else if ($scope.currentWindow == "win_ViewReport") {

                $scope.win_ViewReport.center();
            } else if ($scope.currentWindow == "win_DCMViewer") {
                $scope.win_DCMViewer.center();
            }
            else if ($scope.currentWindow == "win_consultExamsWindow") {
                $scope.win_consultExamsWindow.center();
            }
            else if ($scope.currentWindow == "win_addendum_request") {
                $scope.win_addendum_request.center();
            }
            else if ($scope.currentWindow == "win_ComparisonOrderReports") {
                $scope.win_ComparisonOrderReports.center();
            }
            return true;
        }

        function adjustWindow() {
            if ($scope.currentWindow == "win_PatientInfo") {
                if ($(window).width() < 1199) {
                    $scope.winPatientInfoTechWidth = "96%";
                } else {
                    $scope.winPatientInfoTechWidth = "80%";
                }
                $scope.win_PatientInfo.setOptions({ width: $scope.winPatientInfoTechWidth });
                $scope.win_PatientInfo.center();
            } else if ($scope.currentWindow == "win_ViewReport") {
                $scope.DataObject.defaultWindowWidth = halfScale ? "96%" : "70%";
                $scope.win_ViewReport.setOptions({ width: $scope.winViewReportTechWidth });
                $scope.win_ViewReport.center();

            }
            else if ($scope.currentWindow === 'win_consultExamsWindow') {
                $scope.DataObject.defaultWindowWidth = halfScale ? "96%" : "70%";
                $scope.win_consultExamsWindow.setOptions({ width: $scope.DataObject.defaultWindowWidth });
                $scope.win_consultExamsWindow.center();
            }
            else if ($scope.currentWindow === 'win_addendum_request') {
                $scope.DataObject.defaultWindowWidth = halfScale ? "96%" : "70%";

                $scope.win_addendum_request.setOptions({ width: $scope.DataObject.defaultWindowWidth });
                $scope.win_addendum_request.center();
            }
            else if ($scope.currentWindow === 'win_peer_review') {
                $scope.DataObject.defaultWindowWidth = halfScale ? "96%" : "70%";
                $scope.win_peer_review.setOptions({ width: $scope.DataObject.defaultWindowWidth });
                $scope.win_peer_review.center();
            } else if ($scope.currentWindow === 'win_query_retrive') {
                if ($(window).width() < 1199) {
                    $scope.winPeerReviewWidth = "80%";
                } else {
                    $scope.winPeerReviewWidth = "60%";
                }
                $scope.win_query_retrive.setOptions({ width: $scope.winPeerReviewWidth });
                $scope.win_query_retrive.center();
            }

            return true;
        }

        $scope.SaveGridSetting = function () {
            //$log.log("SaveGridSetting");
            $scope.columns = [];
            var obj = {};
            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'Location', Value: $scope.IsLocationShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'FormattedOrderDate', Value: $scope.IsDOSShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'PatientName', Value: $scope.IsPatientNameShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'PatientAge', Value: $scope.IsPatientAgeShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'PatientClass', Value: $scope.IsTypeNameShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'Modality', Value: $scope.IsModalityShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'ProcedureDesc', Value: $scope.IsProcedureShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'OrderingPhysician', Value: $scope.IsOrderingPhysicianShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'Accession', Value: $scope.IsAccessionShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'PatientMRN', Value: $scope.IsMRNShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'IsSTAT', Value: $scope.IsSTATShow };
            $scope.columns.push(obj);

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'ImageInstance', Value: $scope.IsImageInstanceShow };
            $scope.columns.push(obj);

            if ($scope.columns.length > 0) {
                TechnoService.SaveGridSetting($scope.columns).then(function (result) {
                });
            }
            else {
                toaster.warning({ body: "Please select atleast one column." });
            }

        };

        $scope.winOpen = function (e) {
            adjustTechSize();
        }

        //Repot pop up resize
        $scope.winDragend = function (e) {
            adjustTechSize();
        }
        $scope.winResize = function (e) {
            adjustTechSize();
        }

        $scope.winDiscussionTechResize = function () {
            adjustTechSize();
        }
        $scope.winDiscussionTechDragend = function () {
            adjustTechSize();
        }
        $scope.winPatientInfoTechResize = function () {
            adjustTechSize();
        }
        $scope.winPatientInfoTechDragand = function () {
            adjustTechSize();
        }
        $scope.winViewReportTechResize = function () {
            adjustTechSize();
        }
        $scope.winViewReportTechDragand = function () {
            adjustTechSize();
        }

        //resetting the column width on resizing o half scale

        $scope.selectTechnique = function () {
            $scope.CancelTechnique();
            $scope.win_ViewTechnique.center().open();
            $scope.currentWindow = 'win_ViewTechnique';
            $scope.win_ViewTechnique.wrapper.prev(".k-overlay").addClass("custom-overlay");
            bindTechnique();
            $scope.addTechnique = false;
        }

        function bindTechnique() {
            $scope.TechniqueList = [];
            //$scope.SelectedOrder.LocationID;
            TechnoService.GetTechniqueByLocationID($scope.SelectedOrder.LocationID).then(function (result) {
                $scope.TechniqueList = result;
                $scope.tableParams = new NgTableParams({ page: 1, count: 10 }, { counts: [], dataset: $scope.TechniqueList });
            });
        }
        $scope.AddTechnique = function () {
            $scope.TechniqueKey = '';
            $scope.TechniqueValue = '';
            $scope.addTechnique = true;
            $scope.win_AddTechnique.center().open();
            $scope.win_ViewTechnique.close();
        }
        $scope.addNewTechnique = function () {
            $scope.TechniqueKey = '';
            $scope.TechniqueValue = $scope.PatientInfo.TechniqueValue;
            $scope.addTechnique = true;
            $scope.win_AddTechnique.center().open();
            //$scope.win_ViewTechnique.center();
        }
        $scope.SubmitTechnique = function (evt, TechniqueKey, TechniqueValue) {
            $scope.TechniqueKey = TechniqueKey;
            $scope.TechniqueValue = TechniqueValue;
            var formData = {
                LocationId: $scope.SelectedOrder.LocationID,
                TechniqueKey: $scope.TechniqueKey,
                TechniqueValue: $scope.TechniqueValue,
                UserId: $sessionStorage.currentUserData.userId
            }
            TechnoService.SubmitTechnique(formData).then(function (result) {
                $scope.CancelTechnique();
                $scope.PatientInfo.TechniqueValue = TechniqueValue;
                $scope.win_ViewTechnique.close();
                $scope.win_AddTechnique.close();
            });
        }
        $scope.CancelTechnique = function () {
            $scope.addTechnique = false;
            $scope.win_AddTechnique.close();
        }
        $scope.SelectTechniqueValue = function (val) {
            $scope.PatientInfo.TechniqueValue = val;
            $scope.win_ViewTechnique.close();
        }
        function getOrderDiscussionOptions() {
            $scope.OrderDiscussionOptions = {
                template: kendo.template($("#dropdowntree-orderdiscussion-template").html()),
                placeholder: 'Select User / Group',
                checkboxes: {
                    checkChildren: true
                },
                autoClose: false,
                dataSource: $scope.RadiologistsGroups,
                dataTextField: "UserName",
                dataValueField: "Id",
                height: 200,
                loadOnDemand: false,
                popup: { origin: "bottom left", position: "top left" },
                headerTemplate: '<span class="k-list-filter"><input class="k-textbox" role="listbox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-disabled="false" id="ddstOrderDiscussion" autocomplete="off"/><span class="k-icon k-i-zoom"></span></span>',
                filtering: function (e) {
                    //get filter descriptor
                    var filter = e.filter;
                    // handle the event
                },
                open: function (e) {
                    $("#ddstOrderDiscussion").change(refreshTreeOrderDiscussion).keyup(refreshTreeOrderDiscussion);
                    var timeout = setTimeout(function () {
                        $("#ddstOrderDiscussion").focus();
                        clearTimeout(timeout);
                        timeout = null;
                    }, 1500);

                    $("#ddstOrderDiscussion").val('');
                    var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
                    if (drtr) {
                        var tree = drtr.treeview;
                        var dataSource = drtr.dataSource;
                        dataSource.filter({});
                        var timeout = setTimeout(function () {
                            tree.collapse(".k-item");
                            clearTimeout(timeout);
                            timeout = null;
                        }, 1000);
                    }

                },
                change: function (e) {
                    $scope.AssignStudyVisible = false;
                    $scope.OrderDiscussion.isDirty = true;
                    var nodes = e.sender.dataSource.view();

                    var checkedNodes = e.sender.value();
                    var values = checkedNodeValues(nodes, checkedNodes);
                    var rValues = _.omitBy(values, _.isNil);
                    var selectedUsers = [];
                    $scope.OrderDiscussion.SelectedUsers = [];

                    /*
                    --IsUserWithSpecialityGroup = 0 / 1 / 2
                    --0: User does not exists in the group(selected only group) when study assigned
                    --1: User exists in the group and also selected individual users when study assigned
                    --2: selected individual users when study assigned
                    --3: selected user to be exists into multiple speciality
                    */
                    $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                    _.each(rValues, function (obj) {
                        var selectedRadiologistGroups = _.find($scope.RadiologistsGroups, function (dobj) { return dobj.Id == obj });
                        if (selectedRadiologistGroups) {
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup.push(selectedRadiologistGroups);
                        }

                    });

                    $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();


                    //$log.log($scope.OrderDiscussion.SelectedUsers);
                    setOrderDiscussionTooltip();
                    if ($scope.OrderDiscussion.SelectedUsers && $scope.OrderDiscussion.SelectedUsers.length > 0) {
                        $scope.AssignStudyVisible = true;
                    }



                },
            };
        }

        function refreshTreeOrderDiscussion() {
            var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            var tree = drtr.treeview;
            var dataSource = drtr.dataSource;
            var value = $("#ddstOrderDiscussion").val();
            if (value !== "") {
                dataSource.filter({
                    field: "UserName", //if I would use "ChildrenText" here nothing be displayed at all if filtertext is set
                    operator: "contains",
                    value: $("#ddstOrderDiscussion").val()
                });

                //filtering child node
                if (dataSource.view().length > 0) {
                    for (var i = 0; i < dataSource.view().length; i++) {
                        if (dataSource.view()[i].hasChildren) {
                            dataSource.view()[i].children.filter({
                                field: "UserName",
                                operator: "neq",
                                value: true
                            })
                        }
                    }
                }

                var timeout = setTimeout(function () {
                    tree.expand(".k-item");
                    clearTimeout(timeout);
                    timeout = null;
                }, 200);
            } else {
                dataSource.filter({});

                var timeout = setTimeout(function () {
                    tree.collapse(".k-item");
                    clearTimeout(timeout);
                    timeout = null;
                }, 200);
            }
            angular.element(document).ready(function () {
                angular.element('.k-item').mouseenter(function () {
                    if (tree) {
                        tree.focus();
                    }
                });

            });
        }

        function setOrderDiscussionUserGroup() {
            //$log.log("setOrderDiscussionUserGroup");
            var d = $q.defer();
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedRadioLogistsGroup) {
                var usergroups = _.map($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (radiologistGroup) {
                    return radiologistGroup.Id;
                });


                d.resolve(usergroups);
            } else {
                d.resolve();
            }
            return d.promise;
        }

        function setOrderDiscussionTooltip() {
            //$log.log("setOrderDiscussionTooltip");
            $scope.orderDiscussionTooltip = '';
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedRadioLogistsGroup && $scope.OrderDiscussion.SelectedRadioLogistsGroup.length > 0) {


                _.each($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (obj) {
                    if (obj && obj.Group && obj.Group == "YES") {
                        $scope.orderDiscussionTooltip += obj.UserName + "\n";
                    } else {
                        var selectedUserIndex = _.findIndex($scope.OrderDiscussion.SelectedUsers, { 'Id': obj.Id });
                        if (selectedUserIndex != -1) {
                            if ($scope.OrderDiscussion.SelectedUsers[selectedUserIndex].IsUserWithSpecialityGroup == 2) {
                                var assignmentLabel = _assignmentName(obj.Id, obj.UserName);
                                if (assignmentLabel) {
                                    $scope.orderDiscussionTooltip += assignmentLabel + "\n";
                                }
                            }
                        }
                    }
                });
            }
            angular.element(document).ready(function () {
                angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "hidden");
                if ($scope.orderDiscussionTooltip.length > 0) {
                    angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "visible");
                }

            });
        }

        $scope.OrdersTechForm = {};
        $scope.LoadTechForm = function (order) {
            $scope.OrdersTechForm = {
                TechFormID: order.TechFormID,
                OrdersTechFormID: order.OrdersTechFormID,
                OrderID: order.OrderID,
                CreatedBy: $sessionStorage.currentUserData.userId,
                Type: 'HTML'
            }
            //$scope.OrdersTechForm.TechFormID = 3;
            $scope.win_TechForm.open();
            var timeout = setTimeout(function () {
                $scope.win_TechForm.center();
                clearTimeout(timeout);
                timeout = null;
            }, 1000);
            if ($scope.OrdersTechForm.OrdersTechFormID > 0) {
                TechnoService.GetOrdersTechForm($scope.OrdersTechForm).then(function (result) {
                    $scope.OrdersTechForm.FormText = result.FormText;
                    $scope.OrdersTechForm.FormData = result.FormData;
                    openTechForm($scope.OrdersTechForm.FormText);
                    write(document.getElementById('divTechForm'), JSON.parse($scope.OrdersTechForm.FormData));
                });
            } else {
                $scope.ReloadTechForm();
            }


        }
        function openTechForm(JsonValue) {
            var iframe = document.getElementById('tempid');
            iframe.contentDocument.documentElement.innerHTML = DOMPurify.sanitize(JsonValue);
            document.getElementById('divTechForm').innerHTML = DOMPurify.sanitize(iframe.contentDocument.documentElement.getElementsByTagName('body')[0].innerHTML);
        }

        $scope.SetOrdersTechForm = function () {
            $scope.OrdersTechForm.FormText = document.getElementById('divTechForm').innerHTML;
            $scope.OrdersTechForm.FormData = JSON.stringify(read(document.getElementById('divTechForm')));
            TechnoService.SetOrdersTechForm($scope.OrdersTechForm).then(function (result) {
                $scope.CloseTechForm();
                //$scope.getData();-- for ag grid
            }, function (err) {
            });
        }
        $scope.CloseTechForm = function () {
            $scope.win_TechForm.close();
        }
        $scope.ReloadTechForm = function () {
            TechnoService.GetTechForm({ TechFormID: $scope.OrdersTechForm.TechFormID }).then(function (result) {
                $scope.OrdersTechForm.FormText = result[0].JsonValue;
                openTechForm($scope.OrdersTechForm.FormText);

            }, function (err) {
            });
        }
        function read(node) {
            var jObj = {};
            _.each(node.getElementsByTagName('*'), function (n) {
                //$log.log(n);
                switch (n.nodeName) {
                    case 'SELECT':
                    case 'TEXTAREA':
                        jObj[n.name] = n.value;
                        break;
                    case 'INPUT':
                        if (n.type == 'text') {
                            jObj[n.name] = n.value;
                        }
                        if (n.type == 'checkbox' || n.type == 'radio') {
                            if (n.checked) {
                                jObj[n.name] = 'true';
                            } else {
                                jObj[n.name] = 'false';
                            }
                        }
                        break;
                }
            });
            return jObj;
        }
        function write(node, jObj) {
            _.each(node.getElementsByTagName('*'), function (n) {
                //$log.log(n);
                if (jObj[n.name]) {
                    switch (n.nodeName) {
                        case 'SELECT':
                        case 'TEXTAREA':
                            n.value = jObj[n.name];
                            break;
                        case 'INPUT':
                            if (n.type == 'text') {
                                n.value = jObj[n.name];
                            }
                            if (n.type == 'checkbox' || n.type == 'radio') {
                                if (jObj[n.name] == 'true') {
                                    n.checked = true;
                                } else {
                                    n.checked = false;
                                }
                            }
                            break;
                    }
                }
            });
        }


        function GetUserLayoutPreferences() {
            var d = $q.defer();
            UserLayoutPrefService.GetUserLayoutPreferences({
                UserID: $sessionStorage.currentUserData.userId,
                PageId: $state.current.name + "." + $state.current.controller,
                ControlId: "Tech_WorkList_ListGrid"
            }).then(function (res) {
                if (res && res.LayoutOptions) {
                    var savedLayout = JSON.parse(res.LayoutOptions);
                    if (savedLayout.savedState) {
                        UserLayoutOption = savedLayout;
                        worklistSavedState = UserLayoutOption.savedState;
                    } else {
                        UserLayoutOption.savedState = savedLayout
                        worklistSavedState = savedLayout;
                    }
                }
                d.resolve();
            });
            return d.promise;
        }

        function updateUserLayoutPreference() {
            //coldefs.AutoRefresh = $scope.AutoRefresh;

            var d = $q.defer();

            var currentState = gridOptions.columnApi.getColumnState();
            var equalObject = _.isEqual(worklistSavedState, currentState);

            if (gridOptions && gridOptions.api && currentState) {
                gridOptions.api.forEachDetailGridInfo(function (detailGridApi) {
                    detailGridApi.columnApi.applyColumnState({ state: currentState, applyOrder: true });
                });
            }

            if (!equalObject) {
                worklistSavedState = currentState;
                UserLayoutOption.savedState = worklistSavedState;

                UserLayoutPrefService.SetUserLayoutPreferences({
                    UserID: $sessionStorage.currentUserData.userId,
                    PageId: $state.current.name + "." + $state.current.controller,
                    ControlId: 'Tech_WorkList_ListGrid',
                    LayoutOptions: JSON.stringify(UserLayoutOption),
                    Username: $sessionStorage.currentUserData.userName
                }).then(function () {
                    d.resolve();
                }, function (err) { d.reject(); });
            }
            else {
                d.resolve();
            }
            return d.promise;
        }
        function updateuserguidetechpreference() {
            //$log.log("updateUserPreference > on: ", new Date());

            UserPreferenceService.AddEditUserPreferences([{
                UserPreferenceID: (showUserGuideTech && showUserGuideTech.UserPreferenceID) ? showUserGuideTech.UserPreferenceID : "-1",
                PreferenceType: "ShowUserGuideTech",
                UserID: $sessionStorage.currentUserData.userId,
                PreferenceValue: "0",
            }]);
        }


        function getDicomOrders(flag) {
            var d = $q.defer();

            hideShowColCoditionWise();
            //previouslySelectedFilter = {};
            $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            if ($scope.OrderDateType && $scope.OrderDateType.match('All')) {
                $scope.OrderDate = {
                    startDate: null,
                    endDate: null
                };
            }


            //if (previouslySelectedFilter &&
            //    ((previouslySelectedFilter.LocationID != $scope.orderListFilter.LocationID)
            //        || (previouslySelectedFilter.Accession != $scope.orderListFilter.Accession)
            //        || (previouslySelectedFilter.Modality != $scope.orderListFilter.Modality)
            //        || (previouslySelectedFilter.OrderDateStartDate != $scope.orderListFilter.OrderDateStartDate)
            //        || (previouslySelectedFilter.OrderDateEndDate != $scope.orderListFilter.OrderDateEndDate)
            //        || (previouslySelectedFilter.PatientName != $scope.orderListFilter.PatientName)
            //        || (previouslySelectedFilter.PatientMRN != $scope.orderListFilter.PatientMRN)
            //        || (previouslySelectedFilter.PatientDOB != $scope.orderListFilter.PatientDOB)
            //        || (previouslySelectedFilter.PatientClass != $scope.orderListFilter.PatientClass)
            //        || (previouslySelectedFilter.OrderingPhysician != $scope.orderListFilter.OrderingPhysician)
            //        || (previouslySelectedFilter.Status != $scope.orderListFilter.Status)
            //        || (previouslySelectedFilter.ImagePendingStatus != $scope.orderListFilter.ImagePendingStatus))) {
            //    $scope.orderListFilter.PageNum = 1;
            //    mOrderList = [];
            //    $scope.orderList = [];
            //    $scope.PageNo = 1;
            //}

            //previouslySelectedFilter = $scope.orderListFilter;

            orderListFilter.SortingByMultiColumn = sortingString;
            orderListFilter.PageNum = Math.ceil(PageNo);
            orderListFilter.PageSize = Math.ceil(PageSize);
            if (orderListFilter.PageNum === 0) { orderListFilter.PageNum = 1; }

            $scope.isorderlistLoading = true;
            TechnoService.GetDICOMOrdersList(orderListFilter).then(function (result) {
                updateOrders(result);
                $scope.isorderlistLoading = false;
                if (result != null && result.length > 0) {
                    TotalRows = result[0].TotalRows;
                }
                else {
                    TotalRows = "0";
                }
                if (orderListFilter.PageNum == 1) {
                    DicomOrderList = [];
                }
                _.pullAllBy(DicomOrderList, result, 'DicomOrderID');
                DicomOrderList = _.concat(DicomOrderList, result);
                DicomOrderList = _.uniqBy(DicomOrderList, "DicomOrderID");
                d.resolve(result);
            }, function (err) { d.reject(); });
            return d.promise;
        }
        function resetColumns() {
            delete UserLayoutOption.ReportColVisible;
            delete UserLayoutOption.ResendReportColVisible;
            if (gridOptions && gridOptions.api) {
                var isReportColVisible = ($scope.Status == 'C' || $scope.Status == 'D' || $scope.Status == 'AL' || $scope.Status == 'PA');
                var isResendReportColVisible = ($scope.Status == 'C' || $scope.Status == 'AL');

                _.each(AgGridColumnDefs, function (col) {
                    if (col.field == "Report") {
                        col.hide = !isReportColVisible;
                    }
                    else if (col.field == "ResendReport") {
                        col.hide = !isResendReportColVisible;
                    }
                });

                gridOptions.api.setColumnDefs(AgGridColumnDefs);
                gridOptions.columnApi.resetColumnState();
            }
        }
        function hideShowColCoditionWise() {
            if (gridOptions && gridOptions.api) {
                var isReportColVisible = ($scope.Status == 'C' || $scope.Status == 'D' || $scope.Status == 'AL' || $scope.Status == 'PA');
                var isResendReportColVisible = ($scope.Status == 'C' || $scope.Status == 'AL');

                isReportColVisible = (UserLayoutOption.hasOwnProperty("ReportColVisible")) ? UserLayoutOption.ReportColVisible : isReportColVisible;
                isResendReportColVisible = (UserLayoutOption.hasOwnProperty("ResendReportColVisible")) ? UserLayoutOption.ResendReportColVisible : isResendReportColVisible;

                var currentState = gridOptions.columnApi.getColumnState();
                var idx = _.findIndex(currentState, { colId: 'Report' });
                if (idx != -1) {
                    currentState[idx].hide = !isReportColVisible;
                }
                idx = _.findIndex(currentState, { colId: 'ResendReport' });
                if (idx != -1) {
                    currentState[idx].hide = !isResendReportColVisible;
                }
                gridOptions.columnApi.applyColumnState({ state: currentState, applyOrder: true });
                updateUserLayoutPreference();
            }
        }

        $scope.showPopover = function (dicomOrderID, IsDiscussion) {
            var d = $q.defer();
            $scope.popoverOpened1 = true;
            $scope.popoverDicomOrderID = dicomOrderID;
            if (IsDiscussion) {
                $scope.Discussion = {
                    ReferenceID: dicomOrderID,
                    Type: 1,
                    Comment: '',
                    Record_Created_By: $sessionStorage.currentUserData.userId
                };
                $scope.Discussions = [];
                $q.all([
                    LoadDiscussion($scope.Discussion)
                ]).then(function (data) {
                    if ($scope.Discussions) {
                        var htmlpop = '<div class="popchatui">';
                        _.each($scope.Discussions, function (discussion) {
                            //htmlpop = htmlpop + '<li>' + discussion.Comment + '</li>';
                            htmlpop = htmlpop + '<div>';
                            var displayName = _discussionDisplayName(discussion);
                            if (discussion.Record_Created_By &&
                                discussion.Record_Created_By == $sessionStorage.currentUserData.userId) {
                                htmlpop = htmlpop + '<div class="sendersection">' +
                                    '<div class="sendercomment pos-rel senderborder">' +
                                    (displayName ? '<div class="sendername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline">' + discussion.Comment + '</div>' +
                                    '<div class="senderdate">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, true);
                                htmlpop = htmlpop + '</div></div>';
                            } else {
                                htmlpop = htmlpop + '<div class="receiversection">' +
                                    '<div class="receivercomment pos-rel receiverborder">' +
                                    (displayName ? '<div class="receivername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline word-break-word">' + discussion.Comment + '</div>' +
                                    '<div class="receiverdate">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, false);
                                htmlpop = htmlpop + '</div></div>';
                            }

                            htmlpop = htmlpop + '</div>';
                        });
                        htmlpop = htmlpop + '</div>';
                        d.resolve(htmlpop);
                    }
                });
            }
            return d.promise;
        }

        $scope.hidePopover = function () {
            $scope.popoverOpened1 = false;
            $scope.popoverDicomOrderID = null;
            $scope.Discussions = [];
        }

        function prepareChildDiscussionHTML(discussion, sender) {
            var htmlpop = '';
            if (discussion.Childs && discussion.Childs.length > 0) {
                _.each(discussion.Childs, function (childdiscussion) {
                    var childName = _discussionDisplayName(childdiscussion);
                    if (sender) {
                        htmlpop = htmlpop + '<div class="replaysection mr-15px w-80 pull-left">' +
                            '<div style="background-color: #2F4858 !important;" ' +
                            'class="comment pos-rel border text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    } else {
                        htmlpop = htmlpop + '<div class="replayreceiver mr-15px w-80 pull-right">' +
                            '<div style="background-color: #6c6868 !important;" ' +
                            'class="comment receiverborder pos-rel text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    }
                    htmlpop = htmlpop + prepareChildDiscussionHTML(childdiscussion, sender);
                });
            }
            return htmlpop;
        }

        function openRequestedPopup(accession) {
            if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
            }
            else {
                $scope.CIDICOMViewerWindow = windowHandler.openByPreference(__env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "CI-VIEWER", 1000, "CI-VIEWER", "");
            }

        }

        $scope.keepPopover = function (dicomOrderID) {
            $scope.popoverOpened1 = true;
            $scope.popoverDicomOrderID = dicomOrderID;
        }

        function OrderRefresh() {
            if (OrderRefreshInterval) {
                $interval.cancel(OrderRefreshInterval);
            }
            OrderRefreshInterval = $interval(function () {
                if (!$scope.isTechFormVisible
                    && !$scope.isAddTechniqueVisible
                    && !$scope.isViewTechniqueVisible
                    && !$scope.isViewReportVisible
                    && !$scope.isDiscussionVisible
                    && !$scope.isPatientInfoVisible
                    && !$scope.isHelpOrderVisible) {
                    //getData();-- for ag grid
                    refreshWorklistAggrid();
                }
            }, DefaultAutoRefreshDuration);
        }

        $scope.SaveFilters = function () {
            SaveFilterValues();
        };
        $scope.saveFilterOnly = function () {
            SaveFilterValues();
            angular.element('#ModalTechnoWorkList').modal('hide');
        }
        function SaveFilterValues() {
            var dosLabel = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            var hasLoc = ($scope.SelectedLocations && $scope.SelectedLocations.locations && $scope.SelectedLocations.locations.length > 0) || ($scope.locations && $scope.locations !== '' && $scope.locations !== ',');
            if (dosLabel == 'Last 5 Years' && !hasLoc) {
                toaster.warning({ body: "Please select a Site/Location to use 'Last 5 Years' DOS filter." });
                return;
            }
            syncOrderDateBeforeFilter();
            $scope.worklistSaved = true;
            $scope.columns = [];
            var obj = {};

            if ($scope.locations != ',' && $scope.locations != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'LocationID', Value: $scope.locations };
                $scope.columns.push(obj);
            }
            if ($scope.Accession) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'Accession', Value: $scope.Accession };
                $scope.columns.push(obj);
            }
            if ($scope.OrderDate.startDate) {
                $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'OrderDate', Value: ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' + moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType };
                $scope.columns.push(obj);
            }
            if ($scope.modalities != ',' && $scope.modalities != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'ModalityID', Value: $scope.modalities };
                $scope.columns.push(obj);
            }
            if ($scope.PatientName) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'PatientName', Value: $scope.PatientName };
                $scope.columns.push(obj);
            }
            if ($scope.PatientMRN) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'PatientMRN', Value: $scope.PatientMRN };
                $scope.columns.push(obj);
            }
            if ($scope.DOB) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'PatientDOB', Value: $scope.DOB };
                $scope.columns.push(obj);
            }
            if ($scope.SelectedList.PatientClass) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'PatientClass', Value: $scope.SelectedList.PatientClass.Value };
                $scope.columns.push(obj);
            }
            if ($scope.OrderingPhysician) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'OrderingPhysician', Value: $scope.OrderingPhysician };
                $scope.columns.push(obj);
            }
            if ($scope.Status) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'Status', Value: $scope.Status };
                $scope.columns.push(obj);
            }
            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWorkList', ColumnName: 'STATFilter', Value: $scope.STATFilter ? "1" : "0" };
            $scope.columns.push(obj);
            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'TechWork ListColSort', ColumnName: $scope.orderByField, Value: $scope.reverseSort ? "1" : "0" };
            $scope.columns.push(obj);

            if ($scope.columns.length > 0) {
                WorklistService.SaveFilterSetting($scope.columns).then(function (result) {
                    toaster.success({ body: "Filter saved successfully." });
                    //$scope.getData();-- for ag grid
                    $scope.FilterDICOMOrders();
                });
            }
        }
        function getTechnoPageSetting() {
            var d = $q.defer();
            var Filter = {
                UserId: $sessionStorage.currentUserData.userId,
                PageName: 'TechWorkList'
            };
            WorklistService.GetPageSetting(Filter).then(function (result) {
                if (result) {
                    //var ColSort = _.find(result, function (item) { return item.PageName == "TechWork ListColSort"; });
                    //if (ColSort != null) {
                    //    $scope.orderByField = ColSort.ColumnName;
                    //    $scope.reverseSort = (ColSort.Value == "1") ? true : false;
                    //    var idx = _.findIndex(result, function (obj) { return obj.PageName == "TechWork ListColSort"; });
                    //    if (idx != -1) {
                    //        result.splice(idx, 1);
                    //    }
                    //}
                    _.each(result, function (data) {
                        switch (data.ColumnName) {
                            case 'LocationID':
                                var locations = [];
                                if (data.Value) {
                                    _.each(data.Value.split(','), function (data) {
                                        if (data) {
                                            var filter = _.find($scope.Locations, function (item) { return item.LocationID == data && item.SiteID != 0; });
                                            if (filter != null) {
                                                locations.push(filter);
                                            }
                                        }
                                    });
                                }
                                $scope.SelectedList.Location = locations;
                                $scope.locations = data.Value; //User Story 19673: Improve Location Filter

                                $scope.SelectedLocations = {
                                    Ids: data.Value,
                                    locations: locations,
                                    divId: "TechnoWorklistPage"
                                };
                                break;
                            case 'Accession':
                                $scope.Accession = data.Value;
                                break;
                            case 'OrderDate':
                                setOrderDate(data.Value);
                                break;
                            case 'ModalityID':
                                var modalities = [];
                                if (data.Value) {
                                    _.each(data.Value.split(','), function (data) {
                                        if (data) {
                                            var filter = _.find($scope.Modalities, function (item) { return item.Code == data; });
                                            if (filter != null) {
                                                modalities.push(filter);
                                            }
                                        }
                                    });
                                }
                                $scope.SelectedList.Modality = modalities;
                                $scope.DataObject.ModalityDropdownDataFilter.SelectedValue = {
                                    list: modalities,
                                };
                                setModalitytooltipTechno();
                                break;
                            case 'PatientName':
                                $scope.PatientName = data.Value;
                                break;
                            case 'PatientMRN':
                                $scope.PatientMRN = data.Value;
                                break;
                            case 'PatientDOB':
                                $scope.DOB = new Date(data.Value);
                                break;
                            case 'PatientClass':
                                $scope.SelectedList.PatientClass = _.find($scope.PatientClass, function (item) { return item.Value == data.Value; });
                                break;
                            case 'OrderingPhysician':
                                $scope.OrderingPhysician = data.Value;
                                break;
                            case 'Status':
                                $scope.Status = data.Value;
                                break;
                            case 'STATFilter':
                                $scope.STATFilter = (data.Value == "1") ? true : false;
                                break;
                        }
                    });
                }
                d.resolve();

            }, function (error) {
                d.reject();
            });
            return d.promise;
        }

        function OrderExists(OrderID) {
            var OrderIndex = _.findIndex(DicomOrderList, function (obj) { return obj.OrderID == OrderID });
            return OrderIndex;
        }

        function removeOrderFromList(OrderId) {
            var idx = _.findIndex(DicomOrderList, function (obj) { return obj.OrderID == OrderId; });
            if (idx != -1) {
                removeOrder(idx);
            }
        }

        function removeOrderAccession(Accession) {
            var idx = _.findIndex(DicomOrderList, function (obj) { return obj.Accession == Accession; });
            if (idx != -1) {
                removeOrder(idx);
            }
        }

        function removeOrder(idx) {
            var selectedNode;
            if (gridOptions && gridOptions.api) {
                gridOptions.api.forEachNode(function (node) {
                    if (node.data.OrderID == DicomOrderList[idx].OrderID) {
                        selectedNode = node;
                    }
                })
                removeRowFromGrid(selectedNode);
            }
        }

        function loadPatientData(order) {
            $scope.PatientDOB = {};
            $scope.DicomOrderID = order.DicomOrderID;
            if (order.PatientDOB)
                $scope.PatientDOB.DOB = new Date(order.PatientDOB);
            if ($scope.PatientInfo.PatientGender.length == 1)
                $scope.PatientInfo.PatientGender = $scope.PatientInfo.PatientGender.toUpperCase();
            else
                $scope.PatientInfo.PatientGender = $scope.PatientInfo.PatientGender.substring(0, 1).toUpperCase();

            $scope.PatientInfo.Modality = _.filter($scope.Modalities, function (obj) { return obj.Code === order.Modality; })[0];
            if (order.OrderDate) {
                var OrderDate = ($filter('localDate')(order.OrderDate, false, new Date()));
                $scope.PatientInfo.DOS = new Date(OrderDate);
                $scope.PatientInfo.DOSTime = new Date(OrderDate);
            }
            $scope.LocationBySite = _.filter($scope.Locations, function (obj) { return obj.SiteID === order.SiteID; });
            $scope.PatientInfo.SelectedLocation = _.filter($scope.LocationBySite, function (obj) { return obj.LocationID === order.LocationID; })[0];
            $scope.PatientInfo.OrderingPhysicianSite = _.find($scope.DataObject.MasterData.Sites, { 'SiteID': $scope.PatientInfo.SiteID });
            $scope.GetProvidersList();
            var refIds = [];
            refIds.push(order.DicomOrderID);
            var Discussion = {
                ReferenceID: order.DicomOrderID,
                Type: 1
            };
            TechnoService.GetPatientORMDiscussion(Discussion).then(function (response) {
                $scope.PatientDiscussion = null;
                if (response.length > 0) {
                    $scope.PatientInfo.Comment = response[0].Comment;
                    $scope.PatientDiscussion = response[0];
                }
            }, _respError);
            $scope.SiteContrastList = [];
            TechnoService.getOrderDetail(order).then(function (response) {
                if (response.OrderContrastValue) {
                    $scope.PatientInfo.ContrastType = response.OrderContrastValue.ContrastType ? _.find($scope.ContrastTypeList, { Value: response.OrderContrastValue.ContrastType }) : null;
                    $scope.PatientInfo.ContrastAmount = response.OrderContrastValue.ContrastAmount ? response.OrderContrastValue.ContrastAmount : null;
                }
                _.each(response.SiteContrastList, function (l) {
                    var t = _.filter($scope.ContrastTypeList, function (cl) { return cl.Key == l.ContrastType })[0];
                    $scope.SiteContrastList.push(t);
                });
                var d = _.filter($scope.SiteContrastList, function (obj) { return obj.Key === ($scope.PatientInfo.ContrastType ? $scope.PatientInfo.ContrastType.Value : $scope.PatientInfo.ContrastType); });
                if (d.length == 0) {
                    var t = _.filter($scope.ContrastTypeList, function (cl) { return cl.Key == ($scope.PatientInfo.ContrastType ? $scope.PatientInfo.ContrastType.Value : $scope.PatientInfo.ContrastType) })[0];
                    $scope.SiteContrastList.push(t);
                }
            }, _respError);

            $scope.PatientInfo.SelectedPatientClass = _.find($scope.PatientClass, function (item) { return item.Value == order.PatientClass; });
            $scope.currentWindow = "win_PatientInfo";
            $scope.win_PatientInfo.open();
            $scope.win_PatientInfo.wrapper.prev(".k-overlay").addClass("custom-overlay");
            var timeout = setTimeout(function () {
                $scope.win_PatientInfo.center();
                LoadPatientDataFlag = false;
                clearTimeout(timeout);
                timeout = null;
            }, 1000);
        }

        function getLookUpByType() {
            var d = $q.defer();
            TechnoService.GetLookupByType('ContrastType,HiddenTypes,PatientClass,StudyPriority,ContactPreferenceType').then(function (result) {
                //$scope.ContrastTypeList = result;
                $scope.ContrastTypeList = _.filter(result, { 'Type': 'ContrastType' });
                $scope.HiddenTypeList = _.sortBy(_.filter(result, { 'Type': 'HiddenTypes' }), ['Key']);
                $scope.HiddenType.obj = $scope.HiddenTypeList[0];
                $scope.PatientClass = _.filter(result, { Type: 'PatientClass' });
                $scope.DataObject.StudyPriorities = SharedService.mapPriorityToCollection(_.filter(result, { Type: 'StudyPriority' }), false);
                $scope.DataObject.MasterData.ContactPreferenceType = _.filter(result, { Type: 'ContactPreferenceType' });
                d.resolve();
            });
            return d.promise;
        }
        function updatePageSize() {
            var height = $(window).height();
            PageSize = 50;

            if (height < 1000) {
                PageSize = 50;
            } else if (height > 1000) {
                PageSize = 100;
            }
            if (gridOptions && gridOptions.api) {
                gridOptions.api.setCacheBlockSize(PageSize);
            }
        }

        function setHeight() {
            var height = $(window).height();
            currentHeight = height;
        }

        function updateWindowHeight() {
            $scope.defaultWindowHeight = "72.60%";
            var dollarTimeout = $timeout(function () {
                if ($scope.win_Discussion) {
                    $scope.win_Discussion.setOptions({ height: $scope.defaultWindowHeight });
                }
                if ($scope.win_ViewReport) {
                    $scope.win_ViewReport.setOptions({ height: $scope.defaultWindowHeight });
                }
                $timeout.cancel(dollarTimeout);
                dollarTimeout = null;
            }, 100);
        }

        function updateRefreshDOSInterval() {
            var now = new Date();
            $scope.currentDate.setDate(now.getDate() + 1);
            $scope.currentDate.setHours(0, 0, 0, 0);
            refreshDOSInterval = $scope.currentDate.getTime() - now.getTime();
        }

        $scope.openPatientInfo = function () {
            $scope.DataObject.ModalPatientInfoActiveIndex = 0;
            $scope.files = [];
            angular.element("input[type='file']").val(null);
            $scope.isPatientInfoVisible = true;
            angular.element('.technoform-edorder').parent().addClass('kndo-PatientInfo');
        };

        $scope.sendInvite = function (emailFlag, phoneFlag) {
            if ((!emailFlag && !phoneFlag) && $scope.PatientInfo) {
                var patientInfo = angular.copy($scope.PatientInfo);

                if (!patientInfo.PatientEmailID) {
                    toaster.warning({ body: "Please enter valid email!" });
                    return;
                }
                if (!patientInfo.PatientPhone) {
                    toaster.warning({ body: "Please enter valid phone number!" });
                    return;
                }
                $scope.SendInvite = true;
                var filter =
                {
                    "dob": patientInfo.PatientDOB,
                    "accessionNumber": patientInfo.Accession,
                    "dos": patientInfo.DOS,
                    "patientFirstname": patientInfo.PatientFirstName,
                    "patientLastname": patientInfo.PatientLastName,
                    "patientEmail": patientInfo.PatientEmailID,
                    "patientPhone": patientInfo.PatientPhone,
                    "location": patientInfo.SelectedLocation.Location,
                }
                var updatedPatientInfo =
                {
                    "DicomOrderId": patientInfo.DicomOrderID,
                    "UserId": $sessionStorage.currentUserData.userId,
                    "PatientPhone": patientInfo.PatientPhone,
                    "PatientEmailID": patientInfo.PatientEmailID
                }
                TechnoService.SavePatientContactInfo(updatedPatientInfo).then(function (result) {
                    //$scope.getData();
                    if (result) {
                        TechnoService.SendInvite(filter).then(function (result) {
                            if (result) {
                                toaster.success({ body: "Invitation sent!" });
                                $scope.SendInvite = false;
                            }
                        }).catch(function (noCantDo) {
                            toaster.error({ body: "Something went wrong, Please try again later!" });
                            $scope.SendInvite = false;
                        });
                    }
                });
            }
        };

        function getRowTemplateColorCode(order) {
            var colorCode = '';
            switch ($scope.Status) {
                case 'RP':
                    switch (order.Status) {
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : $scope.DelayStatColorCode ? $scope.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasImage && !order.HasORM) {
                                colorCode = '#b2b266';
                            }
                            break;
                    }
                    break;
                case 'AL':
                    switch (order.Status) {
                        case 'X':
                            colorCode = '#BFDED6';
                            break;
                        case 'CO':
                            colorCode = '#B9ADCF';
                            break;
                        case 'C':
                            colorCode = '#75E284';
                            break;
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'H':
                            colorCode = '#FFC99A';
                            break;
                        case 'RC':
                            colorCode = '#79b384';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : $scope.DelayStatColorCode ? $scope.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasORM && order.HasImage) {
                                colorCode = '#FFE69A';
                            } else if (colorCode.length == 0 && !order.HasORM && order.HasImage) {
                                colorCode = '#b2b266';
                            } else if (colorCode.length == 0 && order.HasORM && !order.HasImage) {
                                colorCode = '#f4ba4b';
                            }
                            break;
                        case 'PA':
                            colorCode = '#ffe6ee';
                            break;
                    }
                    if (colorCode.length == 0 && !order.HasORM) {
                        colorCode = '#ff873a';
                    } else if (colorCode.length == 0 && !order.HasImage) {
                        colorCode = '#f4ba4b';
                    }
                    break;
            }
            return colorCode.length > 0 ? colorCode : '#ffffff';
        }

        function openMedDream(Accession) {
            var order = $scope.OpenSynapseStudyOrder;
            var medDreamOrder = {
                OrderID:       order ? order.OrderID : 0,
                PatientMRN:    order ? order.PatientMRN : '',
                SiteID:        order ? order.SiteID : 0,
                Accession:     Accession,
                Modality:      order ? (order.Modality || '') : '',
                ProcedureDesc: order ? (order.ProcedureDesc || '') : ''
            };
            SharedService.openMedDreamCommunicationAPI(medDreamOrder, '');
        }

        $scope.updateSelectedLocation = function () {
            $scope.locations = $scope.SelectedLocations.Ids;
            $scope.SelectedList.Location = $scope.SelectedLocations.locations;
            if ($scope.SelectedList.Location && $scope.SelectedList.Location.length > 0) {
                $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                $(".anui").removeClass("update-vw-height");
                $('.anui').addClass("set-location-height");
            }
            else {
                $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                $(".anui").removeClass("update-vw-height");
                $('.anui').removeClass("set-location-height");
            }
        }

        function setSelectedUserAssignment(usergroups) {
            ////$log.log("setSelectedWorklistFilterSettings: " + new Date());
            var ddt = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            if (ddt) {
                ddt.value(usergroups);
            } else {
                var timeout = $timeout(function () {
                    setSelectedUserAssignment(usergroups);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 100);
            }
        }
        $scope.UpdateAddendumRequestReportStatus = function () {
            TechnoService.UpdateAddendumRequestReportStatus({
                Order: $scope.SelectedOrder,
                OrderID: $scope.SelectedOrder.OrderID,
                AddendumRequestedBy: $sessionStorage.currentUserData.userId,
                IsHighPriority: $scope.AddendumRequest.isHighPriorityAddendum,
                DicomOrderID: $scope.SelectedOrder.DicomOrderID,
                Comment: $scope.AddendumRequest.AddendumComment,
                ReportID: $scope.SelectedOrder.ReportID,
                ToUserID: $scope.AddendumRequest.AssignedUser.Id,
                FromUser: $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName,
                AddendumRequestedFrom: 'Radflow',
                ToUserPhoneNumber: $scope.AddendumRequest.AssignedUser.PhoneNumber
            }).then(function (res) {
                if ($scope.Status == 'C') {
                    removeOrderFromList($scope.SelectedOrder.OrderID);
                }
                else {
                    //getData();-- for ag grid
                    refreshWorklistAggrid();
                }
                $scope.win_addendum_request.close();
                $scope.onAddendumReqClose();
            });
        }
        $scope.onAddendumReqClose = function () {
            $scope.showAddendumReq = false;
            $scope.SelectedOrder = {};
            $scope.AddendumRequest.isHighPriorityAddendum = false;
            $scope.AddendumRequest.AddendumComment = null;
            $scope.AddendumRequest.AssignedUser = null;
            $scope.AddendumRequest.AssignedUserTooltip = "Select Radiologist";
        }


        $scope.onAddendumUserSelect = function () {
            if ($scope.AddendumRequest.AssignedUser) {
                $scope.AddendumRequest.AssignedUserTooltip = $scope.radDisplay($scope.AddendumRequest.AssignedUser);
            } else {
                $scope.AddendumRequest.AssignedUserTooltip = "Select Radiologist";
            }
        }

        function prepareOrderDiscussionUsers() {
            var selectedUsers = [];
            _.each($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (selectedRadiologistGroup) {
                if (selectedRadiologistGroup && selectedRadiologistGroup.Group && selectedRadiologistGroup.Group == "YES") {

                    var specialities = _.filter(specialityAssignments, { SpecialityId: selectedRadiologistGroup.Id });
                    _.each(specialities, function (speciality) {
                        var user = _.find($scope.Radiologists, { Id: speciality.UserId });
                        if (user) {
                            user.IsUserWithSpecialityGroup = 0;
                            user.SpecialityCode = speciality.SpecialityCode;
                            user.SpecialityCodeDesc = speciality.SpecialityCodeDesc;
                            user.SpecialityGroup = speciality.SpecialityGroup;
                            user.SpecialityId = speciality.SpecialityId;
                            var selectedUserIndex = _.findIndex(selectedUsers, function (auser) {
                                return auser.Id == user.Id
                                    && auser.IsUserWithSpecialityGroup == 0;
                            });
                            var selectedUserBySpecialityIndex = _.findIndex(selectedUsers, function (auser) {
                                return auser.Id == user.Id
                                    //&& auser.SpecialityId > 0
                                    //    && user.SpecialityId > 0
                                    && auser.SpecialityId != user.SpecialityId;
                            });

                            if (selectedUserIndex != -1 && selectedUserBySpecialityIndex == -1) {
                                selectedUsers[selectedUserIndex].IsUserWithSpecialityGroup = 1;
                                user.IsUserWithSpecialityGroup = 1;
                            } else if (selectedUserBySpecialityIndex != -1) {
                                selectedUsers[selectedUserBySpecialityIndex].IsUserWithSpecialityGroup = 3;
                                user.IsUserWithSpecialityGroup = 3;
                            }
                            selectedUsers.push(_.clone(user));
                        }

                    });

                } else {
                    var user = _.find($scope.Radiologists, function (user) { return user.Id == selectedRadiologistGroup.Id; });
                    if (user) {
                        user.IsUserWithSpecialityGroup = 2;
                        var selectedUserIndex = _.findIndex(selectedUsers, function (auser) {
                            return auser.Id == user.Id
                                && auser.IsUserWithSpecialityGroup == 0;
                        });
                        var selectedUserBySpecialityIndex = _.findIndex(selectedUsers, function (auser) {
                            return auser.Id == user.Id
                                //&& auser.SpecialityId > 0
                                //&& user.SpecialityId > 0
                                && auser.SpecialityId != user.SpecialityId;
                        });
                        if (selectedUserIndex != -1 && selectedUserBySpecialityIndex == -1) {
                            selectedUsers[selectedUserIndex].IsUserWithSpecialityGroup = 1;
                            user.IsUserWithSpecialityGroup = 1;
                        } else if (selectedUserBySpecialityIndex != -1) {
                            selectedUsers[selectedUserBySpecialityIndex].IsUserWithSpecialityGroup = 3;
                            user.IsUserWithSpecialityGroup = 3;
                        }
                        selectedUsers.push(_.clone(user));
                    }

                }
            });
            return selectedUsers;
        }

        $scope.onPeerReviewClose = function () {
            $scope.showPeerReview = false;
            $scope.SelectedOrder = {};
            $scope.PeerReview.Comment = null;
            $scope.PeerReview.AssignedUser = null;
            $scope.PeerReview.AssignedUserTooltip = "Select Radiologist";
            $scope.DataObject.isAutoAssignPeerReviewWin = false;
        }

        $scope.onPeerReviewUserSelect = function () {
            if ($scope.PeerReview.AssignedUser) {
                $scope.PeerReview.AssignedUserTooltip = $scope.radDisplay($scope.PeerReview.AssignedUser);
            } else {
                $scope.PeerReview.AssignedUserTooltip = "Select Radiologist";
            }
        }

        $scope.AddOrderToSpecificPeer = function () {
            var obj = {
                OrderID: $scope.SelectedOrder.OrderID,
                isPeerReview: '1',
                PeerReviewUserID: $scope.PeerReview.AssignedUser.Id,
                UserID: $sessionStorage.currentUserData.userId,
                DicomOrderID: $scope.SelectedOrder.DicomOrderID,
                Comment: $scope.PeerReview.Comment ? $scope.PeerReview.Comment : null,
            }
            UpdateOrderDetail(obj, PeerReviewToasterMessage);
        }

        function UpdateOrderDetail(obj, message) {
            WorklistService.UpdateOrderDetail(obj).then(function () {
                toaster.success({ body: message });
                $scope.win_peer_review.close();
                $scope.onPeerReviewClose();
                $scope.DataObject.isAutoAssignPeerReviewWin = false;
            });
        }

        function AddToPeerReview(type, Order) {
            switch (type) {
                case 'Auto Assign':
                    $scope.DataObject.isAutoAssignPeerReviewWin = true;
                    $scope.currentWindow = 'win_peer_review';
                    OpenWindow($scope.win_peer_review, 'win_peer_review');
                    $scope.win_peer_review.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    break;
                case 'Assign to Specific User':
                    $scope.setSelected(Order.OrderID, Order);
                    WorklistService.GetPeerReviewerListByUserID({ UserID: $sessionStorage.currentUserData.userId, isReviewer: true, Modality: Order.Modality, SiteID: Order.SiteID }).then(function (result) {
                        $scope.PeerReviewRadiologists = result;
                        $scope.PeerReviewRadiologists = _.sortBy($scope.PeerReviewRadiologists, ['UserName']);
                        $scope.onPeerReviewUserSelect();
                        $scope.currentWindow = 'win_peer_review';
                        OpenWindow($scope.win_peer_review, 'win_peer_review');
                        $scope.win_peer_review.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    });
                    break;
            }
        }
        $scope.AutoAssignPeerReview = function () {
            var obj = {
                OrderID: $scope.SelectedOrder.OrderID,
                isPeerReview: '1',
                PeerReviewUserID: 'Auto',
                UserID: $sessionStorage.currentUserData.userId,
                DicomOrderID: $scope.SelectedOrder.DicomOrderID,
                Comment: $scope.PeerReview.Comment ? $scope.PeerReview.Comment : null,
            }
            UpdateOrderDetail(obj, PeerReviewToasterMessage);
        }
        //#region Query Retrieve
        $scope.QueryRetrieve = function (Order) {
            var d = $q.defer();
            $scope.ClearQueryRetrieve();
            //open modal
            $scope.setSelected(Order.OrderID, Order);
            $scope.SelectedOrderID = $scope.SelectedOrder.OrderID;
            ManageLocationService.GetSiteApplicationEntity({ SiteID: Order.SiteID }).then(function (result) {
                if (result && result.length > 0) {
                    _.each(result, function (item) {
                        if (!$scope.DataObject.QueryRetrieve[item.AEType]) {
                            $scope.DataObject.QueryRetrieve[item.AEType] = {
                                HostName: item.Host,
                                Port: item.Port,
                                TlsEnabled: item.TLS,
                                AeTitle: item.AETitle
                            };
                        }
                    });
                }
                else {
                    toaster.warning({ body: "Query retrieval is not configured for this site. Please reach out to the site administrator for assistance." });
                    return;
                }

                ManageLocationService.GetSitePrefixSuffix({ SiteID: Order.SiteID }).then(function (res) {
                    var result = null;
                    if (res && res.length > 0) {
                        var result = res[0];
                        $scope.DataObject.QueryRetrieve.PatientMRN = Order.PatientMRN.replace(result.Prefix, "").replace(result.Suffix, "");
                    }
                    else {
                        $scope.DataObject.QueryRetrieve.PatientMRN = Order.PatienstMRN;
                    }
                    $scope.currentWindow = 'win_query_retrive';
                    OpenWindow($scope.win_query_retrive, 'win_query_retrive');
                    $scope.win_query_retrive.wrapper.prev(".k-overlay").addClass("custom-overlay");

                    var Timeout = $timeout(function () {
                        var gridDiv = document.getElementById("myQueryGrid");
                        if (gridDiv && gridDiv != null) {
                            new agGrid.Grid(gridDiv, queryGridOptions);
                        }

                        $scope.QueryRetrieveFilter();
                        $timeout.cancel(Timeout);
                        Timeout = null;
                    }, 100);
                });
            });
            return d.promise;
        }
        $scope.QueryRetrieveFilter = function (SearchFlag) {
            //var d = $q.defer();
            if (queryGridOptions && queryGridOptions.api) {
                queryGridOptions.api.setRowData([]);
            }
            $scope.DataObject.QueryRetrieve.IsExpanded = false;
            $scope.DataObject.QueryRetrieve.IsAllStudySelected = false;
            if (SearchFlag && !(($scope.DataObject.QueryRetrieve.FirstName && $scope.DataObject.QueryRetrieve.FirstName != '') || ($scope.DataObject.QueryRetrieve.LastName && $scope.DataObject.QueryRetrieve.LastName != '') || ($scope.DataObject.QueryRetrieve.PatientMRN && $scope.DataObject.QueryRetrieve.PatientMRN != '') || ($scope.DataObject.QueryRetrieve.Accession && $scope.DataObject.QueryRetrieve.Accession != ''))) {
                toaster.warning({ body: "Please enter atleast one detail to filter" });
                return;
            }
            $scope.DataObject.isLoadingQueryRetrieve = true;
            $scope.DataObject.QueryRetrieve.IsSearchingData = true;

            DCMQRDoFind().then(function (result) {
                if (result && result.patients) {
                    $scope.DataObject.isLoadingQueryRetrieve = false;
                    $scope.DataObject.QueryRetrieve.IsSearchingData = false;
                    if (queryGridOptions && queryGridOptions.api) {
                        queryGridOptions.api.setRowData(result.patients);
                    }
                }
            });
        }
        function DCMQRDoFind() {
            var d = $q.defer();
            var obj = {
                "PatientFirstName": $scope.DataObject.QueryRetrieve.FirstName,
                "PatientLastName": $scope.DataObject.QueryRetrieve.LastName,
                "PatientId": $scope.DataObject.QueryRetrieve.PatientMRN,
                "DOSStartDate": $scope.DataObject.QueryRetrieve.OrderDate ? $scope.DataObject.QueryRetrieve.OrderDate.startDate.format('YYYYMMDD') : "20001001",
                "DOSEndtDate": $scope.DataObject.QueryRetrieve.OrderDate ? $scope.DataObject.QueryRetrieve.OrderDate.endDate.format('YYYYMMDD') : "20241001",
                "Accession": $scope.DataObject.QueryRetrieve.Accession,
                "CalledAE": $scope.DataObject.QueryRetrieve.CalledAE,
                "CallingAE": $scope.DataObject.QueryRetrieve.CallingAE,
                "DestinationAE": $scope.DataObject.QueryRetrieve.DestinationAE,
            };
            WorklistService.DCMQRDoFind(obj).then(function (result) {
                result = result.QRPatientList;
                if (result && result.patients) {
                    _.each(result.patients, function (patient) {
                        var SeriesCount = null, InstanceCount = null;
                        patient.StudyCount = patient.studies.length;
                        _.each(patient.studies, function (study) {
                            if (SeriesCount == null) {
                                SeriesCount = study.series.length;
                            }
                            else {
                                SeriesCount += study.series.length;
                            }
                            study.checkboxDisabled = false;
                            study.SeriesCount = study.series.length;
                            _.each(study.series, function (instance) {
                                if (InstanceCount == null) {
                                    InstanceCount = _.toInteger(instance.Instances);
                                }
                                else {
                                    InstanceCount += _.toInteger(instance.Instances);
                                }
                            });
                        });
                        if (SeriesCount != null) {
                            patient.SeriesCount = SeriesCount;
                        }
                        if (InstanceCount != null) {
                            patient.InstanceCount = InstanceCount;
                        }
                    });
                    $scope.DataObject.isLoadingQueryRetrieve = false;
                    $scope.DataObject.QueryRetrieve.IsSearchingData = false;
                    $scope.DataObject.QueryRetriveObj = result;
                    if (queryGridOptions && queryGridOptions.api) {
                        queryGridOptions.api.setRowData(result.patients);
                    }
                    d.resolve(result);
                }
            }).catch(function (ExceptionData) {
                var error = ExceptionData.data;
                $scope.DataObject.isLoadingQueryRetrieve = false;
                $scope.DataObject.QueryRetrieve.IsSearchingData = false;
                if (error.Message && error.Message != "") {
                    toaster.error({ body: error.Message });
                }
                else {
                    toaster.error({ body: "Something went wrong" });
                }

                d.reject();
            });
            return d.promise;
        }
        var queryGridOptions = {
            columnDefs: [
                {
                    field: 'PatientID', headerName: 'MRN', cellRenderer: 'agGroupCellRenderer', headerClass: 'px-5',
                },
                { field: 'FamilyName', headerName: 'Last Name' },
                { field: 'GivenName', headerName: 'First Name' },
                { field: 'MiddleName' },
                {
                    field: 'DOB', headerName: 'Date of Birth', cellRenderer: function (params) {
                        if (params.data.DOB) {
                            return moment(params.data.DOB).format('MM-DD-YYYY');
                        }
                    }
                },
                {
                    field: 'Gender', cellRenderer: function (params) {
                        return { 'M': 'Male', 'F': 'Female', 'O': 'Other' }[params.data.Gender] || params.data.Gender;
                    }
                },
                { field: 'StudyCount', headerName: 'Study Count' },
                { field: 'SeriesCount', headerName: 'Series Count' },
                { field: 'InstanceCount', headerName: 'Instance Count' },
            ],
            defaultColDef: {
                flex: 1,
            },
            groupDefaultExpanded: 0,
            masterDetail: true,
            detailRowAutoHeight: true,
            detailCellRendererParams: {
                detailGridOptions: {
                    columnDefs: [
                        { field: '', minWidth: 40, maxWidth: 40, checkboxSelection: true, },
                        { field: 'AccessionNumber', headerName: 'Accession', cellRenderer: 'agGroupCellRenderer', headerClass: 'queryAccessionHeaderTxt', },
                        { field: 'StudyDateTime', headerName: 'Date of Service', cellRenderer: function (params) { return $filter('localDate')(params.data.StudyDateTime, false, new Date()) }, },
                        { field: 'StudyDescription' },
                        { field: 'SeriesCount', headerName: 'Series Count' },
                    ],
                    defaultColDef: {
                        flex: 1,
                    },
                    rowClass: 'agrow-bg',
                    rowSelection: 'multiple',
                    onRowSelected: onRowSelected,
                    groupDefaultExpanded: 0,
                    masterDetail: true,
                    //detailRowHeight: 240,
                    detailRowAutoHeight: true,
                    detailCellRendererParams: {
                        detailGridOptions: {
                            columnDefs: [
                                { field: 'SeriesDescription', cellRenderer: 'agGroupCellRenderer', headerClass: 'querySeriesHeaderTxt' },
                                { field: 'SeriesNumber' },
                                { field: 'Modality' },
                                { field: 'Instances' },
                            ],
                            defaultColDef: {
                                flex: 1,
                            },
                            detailRowAutoHeight: true,
                        },
                        getDetailRowData: function (params) {
                            params.successCallback(params.data.series);
                        },
                    },
                    getRowId: function (params) {
                        return params.data.StudyInstanceUid;
                    },
                    getRowStyle: function (params) {
                        return params.node.data.checkboxDisabled ? { 'pointer-events': 'none !important', 'opacity': '0.5 !important' } : null;
                    }
                },
                getDetailRowData: function (params) {
                    params.successCallback(params.data.studies);
                },

            },
            getRowId: function (params) {
                return params.data.PatientID;
            },
        };

        $scope.MoveInstance = function () {
            var MoveStudies = [];
            if ($scope.DataObject.QueryRetrieve.SelectedStudies && $scope.DataObject.QueryRetrieve.SelectedStudies.length > 0) {
                _.each($scope.DataObject.QueryRetrieve.SelectedStudies, function (study) {
                    var obj = {
                        "StudyInstanceUid": study.StudyInstanceUid,
                        "CalledAE": $scope.DataObject.QueryRetrieve.CalledAE,
                        "CallingAE": $scope.DataObject.QueryRetrieve.CallingAE,
                        "DestinationAE": $scope.DataObject.QueryRetrieve.DestinationAE,
                    };
                    MoveStudies.push(obj);
                    if (queryGridOptions && queryGridOptions.api) {
                        queryGridOptions.api.forEachNode(function (node) {
                            var timeout = $timeout(function () {
                                node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                                if (node.detailGridOptions) {
                                    node.detailGridOptions.api.forEachNode(function (childNode) {
                                        if (childNode.data.StudyInstanceUid == study.StudyInstanceUid) {
                                            childNode.setSelected(false);
                                            childNode.data.checkboxDisabled = true;
                                        }
                                    });
                                    node.detailGridOptions.api.redrawRows();
                                    $timeout.cancel(timeout);
                                    timeout = null;
                                }
                            }, 100);
                        });
                    }
                });
                WorklistService.DCMQRDoMove(MoveStudies).then(function (result) {

                });
                toaster.success({ body: "Prior retrieval is in process." });
            }
        }

        function onRowSelected(event) {
            $scope.DataObject.QueryRetrieve.IsRetrieveBtnDisabled = true;
            var selectedRows = [];
            queryGridOptions.api.forEachNode(function (node) {
                if (node.master) {
                    node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                    if (node.detailGridOptions) {
                        var getSelectedRows = node.detailGridOptions.api.getSelectedRows();
                        _.each(getSelectedRows, function (row) {
                            var index = _.findIndex(selectedRows, { 'Accession': row.Accession });
                            if (index == -1) {
                                selectedRows.push(row);
                            }
                        });
                    }
                    if (selectedRows && selectedRows.length > 0) {
                        $scope.DataObject.QueryRetrieve.SelectedStudies = selectedRows;
                        $scope.DataObject.QueryRetrieve.IsRetrieveBtnDisabled = false;
                    }
                }
            });
        }

        $scope.ClearQueryRetrieve = function () {
            $scope.DataObject.QueryRetrieve.Accession = '';
            $scope.DataObject.QueryRetrieve.PatientMRN = '';
            $scope.DataObject.QueryRetrieve.FirstName = '';
            $scope.DataObject.QueryRetrieve.LastName = '';
            $scope.DataObject.QueryRetrieve.OrderDateType = 'Last 3 Years';
            $scope.DataObject.QueryRetrieve.OrderDate = {
                startDate: moment().subtract(3, 'year'),
                endDate: moment()
            };
            if (queryGridOptions && queryGridOptions.api) {
                queryGridOptions.api.setRowData([]);
            }
            $scope.DataObject.QueryRetrieve.IsExpanded = false;
            $scope.DataObject.QueryRetrieve.IsAllStudySelected = false;
        }
        $scope.resetQueryRetrieveDateRange = function () {
            $scope.DataObject.QueryRetrieve.opts.ranges = {
                'Last 6 Months': [moment().subtract(6, 'month'), moment()],
                'Last 1 Year': [moment().subtract(1, 'year'), moment()],
                'Last 3 Years': [moment().subtract(3, 'year'), moment()],
                'Last 5 Years': [moment().subtract(5, 'year'), moment()],
                'Last 10 Years': [moment().subtract(10, 'year'), moment()],
            };
            angular.element(document).ready(function () {
                angular.element('.drp-buttons .cancelBtn').click(function () {
                    angular.element('#daterange3').val('');
                    $scope.DataObject.QueryRetrieve.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                });
            });
            angular.element(document).ready(function () {
                $scope.DataObject.QueryRetrieve.OrderDateType = ($scope.DataObject.QueryRetrieve && $scope.DataObject.QueryRetrieve.OrderDate && $scope.DataObject.QueryRetrieve.OrderDate.label) ? $scope.DataObject.QueryRetrieve.OrderDate.label : $scope.DataObject.QueryRetrieve.OrderDateType;
                if ($scope.DataObject.QueryRetrieve.OrderDate.startDate && $scope.DataObject.QueryRetrieve.OrderDate.endDate) {
                    if ($scope.DataObject.QueryRetrieve.OrderDateType != null && $scope.DataObject.QueryRetrieve.OrderDateType.match('Custom'))
                        $scope.DataObject.QueryRetrieve.OrderDateType = ($scope.DataObject.QueryRetrieve.OrderDateType != null && $scope.DataObject.QueryRetrieve.OrderDateType.match('Custom')) ? ($scope.DataObject.QueryRetrieve.OrderDateType + '#' + moment(new Date($scope.DataObject.QueryRetrieve.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                            moment(new Date($scope.DataObject.QueryRetrieve.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.DataObject.QueryRetrieve.OrderDateType;

                }
                else {
                    $scope.DataObject.QueryRetrieve.OrderDateType = 'Clear';
                }
                setQueryRetrieveOrderDate($scope.DataObject.QueryRetrieve.OrderDateType, $scope.DataObject.QueryRetrieve);
            });
        }

        function setQueryRetrieveOrderDate(val, data) {
            var type = null, startDate = null, endDate = null;
            if (val && val.match('Custom')) {
                type = 'Custom';
                startDate = val.split('#')[1];
                endDate = val.split('#')[2];
            }
            else {
                type = val;
            }
            data.OrderDateType = type;
            switch (type) {
                case 'Last 6 Months':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(6, 'month').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 1 Year':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(1, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 3 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(3, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 5 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(5, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 10 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(10, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Custom':
                    //data.OrderDate = {
                    //    startDate: moment(startDate),
                    //    endDate: moment(endDate)
                    //};
                    data.OrderDate = {
                        startDate: moment(moment(startDate).format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment(endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    data.OrderDateType = 'Custom range';
                    break;
                case 'Clear':
                    data.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                default:
                    data.OrderDate = {
                        startDate: moment(moment().subtract(3, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    data.OrderDateType = 'Last 3 Days';
                    break;
            }

            var timeout = $timeout(function () {
                data.toolTipOrderDate = data.OrderDate.startDate && data.OrderDate.endDate ? 'DOS: ' + data.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + data.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                $timeout.cancel(timeout);
                timeout = null;
            }, 0);
        }

        $scope.ExpandCollapseData = function (expand, allStudies) {
            onRowSelected();
            if (queryGridOptions && queryGridOptions.api) {
                queryGridOptions.api.forEachNode(function (node) {
                    if (node.master && expand) {
                        node.setExpanded(expand);
                        var timeout = $timeout(function () {
                            node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                            if (node.detailGridOptions) {
                                if (!allStudies) {
                                    node.detailGridOptions.api.forEachNode(function (childNode) {
                                        childNode.setExpanded(expand);
                                    });
                                }
                                else {
                                    node.detailGridOptions.api.selectAll();
                                }
                            }
                            $timeout.cancel(timeout);
                            timeout = null;
                        }, 100);
                    }
                    else {
                        if (node.id) {
                            node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                            if (node.detailGridOptions) {
                                node.detailGridOptions.api.forEachNode(function (childNode) {
                                    if (childNode.expanded) {
                                        childNode.setExpanded(expand);
                                    }
                                    if (node.expanded) {
                                        node.setExpanded(expand);
                                    }
                                });
                            }
                        }
                    }
                });
            }
        }
        //#endregion Query Retrieve
        //#region Get Tour Steps
        function GetTechnoTourSteps() {
            var d = $q.defer();
            CommonService.GetTourSteps('Techno').then(function (result) {
                if (tourTechno && tourTechno._options) {
                    tourTechno._options.steps = result.Steps;
                    d.resolve();
                }
            });
            return d.promise;
        }

        function TechnoInitTour() {
            GetTechnoTourSteps().then(function () {
                startUserGuideTechTour();
                HelpTechnoTour();
            });
        }

        function HelpTechnoTour() {
            if (TourFlag) {
                tourTechno.init();
                //var timeout = $timeout(function () {
                tourTechno.setCurrentStep(0);
                tourTechno.start(true);
                /*$timeout.cancel(timeout);
                timeout = null;*/
                //}, 2000);
            }
        }
        //#endregion Get Tour Steps

        //#region Ag-Grid
        //#region cell-template
        function userLockIconCellRenderer(params) {
            var template = "";
            if (params.data) {
                var iconCase = setUserIconCase(params.data);
                switch (iconCase) {
                    case 'Lock':
                        template = '<i class="fa fa fa-lock fs-15px txt-clr-14 pt-8px" style="padding-left:6px;" title="' + params.data.LockBy + '"></i>';
                        break;
                    case "Assignment":
                        template = template + '<span title="' + getOrderListTooltip(params.data) + '" class="fa fa-user fs-15px v-a-t d-block py-5px cursor-pointer pt-5px text-center" ' +
                            'tooltip-class="uibtooltipDenial" ';

                        if (params.data.listOrderListAssignment && params.data.listOrderListAssignment.length > 0) {
                            var idx = _.findIndex(params.data.listOrderListAssignment, { OrderAssingedUserID: $sessionStorage.currentUserData.userId });
                            template = (idx != -1) ? template + " style='color:green' " : template + " style='color:gray' ";
                        }
                        else {
                            template = (params.data.OrderAssingedUserID && _.lowerCase(vm.selectedData.LoggedInUserID) == _.lowerCase(params.data.OrderAssingedUserID)) ? template + " style='color:green' " : template + " style='color:gray' ";
                        }
                        template = template + ' ></span>';
                        break;
                }
            }
            return template;
        }
        function setUserIconCase(row) {
            var iconCase = '';
            if (row.IsLock && ($sessionStorage.currentUserData.userId != row.LockByProviderID)) {
                iconCase = 'Lock';
            } else if (row.OrderAssingedUsers > 0) {
                iconCase = 'Assignment';
            } else {
                iconCase = 'empty';
            }
            return iconCase;
        }

        function DOSCellRenderer(params) {
            var OrderDate = ($filter('localDate')(params.data.OrderDate, false, new Date()));
            var color = params.data.RowColorCode;
            var template = "";
            template = '<span style="color:' + color + '" title="' + OrderDate + '">' + OrderDate + '</span>'
            return template;
        }

        function diacomImageCellRenderer(params) {
            var template = '<i class= "fa fa-eye fs-14px pt-4px px-5px cursor-pointer" title="View Images" ></i >';
            return template;
        }

        function editOrderCellRenderer(params) {
            var template = "";
            if (!params.data.isComparisionOrder) {
                template = '<i class="fa fa-edit fs-14px cursor-pointer txt-clr-1 pt-5px px-5px" title="Edit Order"></i>';
            }
            return template;
        }
        function reportCellRenderer(params) {
            var template = "";
            if (params.data.ReportStatus == '1' || params.data.ReportStatus == '5') {
                template = '<i class="btn fa fa-file-text-o txt-clr-14 fs-14px no-shadow py-0 px-0" title="Report"></i>';
            }
            return template;
        }
        function resendReportCellRenderer(params) {
            var template = "";
            if (params.data.Status == "C" && !params.data.isComparisionOrder) {
                template = '<img class="cursor-pointer" src="assets/images/resend_border_icon.svg"  title="Resend Report" ' +
                    'style="padding: 0px 0 0px!important; box-shadow: none!important;"></img>';
            }
            return template;
        }

        function discussionCellRenderer(params) {
            var eGui = document.createElement('div');
            if (!params.data.isComparisionOrder) {
                var discussion = discussionHTML(params);
                if (discussion) {
                    eGui.appendChild(discussion);
                }
            }
            return eGui;
        }
        function IPCommentCellRenderer(params) {
            var template = "";
            if (params.data.IPComment && !params.data.isComparisionOrder) {
                template = '<div class="w-100 float-left text-center"><i class="btn fa fa-info txt-clr-14 p-0 fs-14px no-shadow" title="' + params.data.IPComment + '"></i></div >';
            }
            return template;
        }
        function discussionHTML(params) {
            if (params.data && !params.data.isComparisionOrder) {
                var className = (params.data.IsDiscussion) ? 'green' : 'gray';
                var wrapper = document.createElement('div');
                wrapper.className = 'pt-0 pb-0';
                var container = document.createElement('div');
                container.className = 'icon-container w-100 float-left text-center pos-rel';
                container.setAttribute('data-toggle', 'modal');
                container.setAttribute('title', '');
                container.setAttribute('data-target', '#ModalDiscussion');
                wrapper.appendChild(container);

                if (params.data.FileCount > 0) {
                    var paperclip = document.createElement('span');
                    paperclip.className = 'glyphicon glyphicon-paperclip icon-paperclip cursor-pointer z-i-1 fs-14px pos-abs txt-clr-1';
                    paperclip.title = 'Discussion';
                    paperclip.style.cssText = 'top:2px; left:0; right:0';
                    paperclip.setAttribute('aria-hidden', 'true');
                    container.appendChild(paperclip);
                }
                if (params.data.IsDiscussion && params.data.DicomOrderID) {
                    container.appendChild(discussionIcon('fa fa-comments cursor-pointer fs-14px pt-5px ' + className));
                }
                else if (params.data.IsDiscussion && params.data.DicomOrderID != $scope.popoverDicomOrderID) {
                    container.appendChild(discussionIcon('fa fa-comments cursor-pointer fs-14px pt-5px ' + className));
                }
                if (!params.data.IsDiscussion) {
                    container.appendChild(discussionIcon('fa fa-comment-o cursor-pointer fs-14px txt-clr-14 pt-5px ' + className));
                }
                return wrapper;
            }
            else {
                return null;
            }
        }
        function discussionIcon(className) {
            var icon = document.createElement('span');
            icon.className = className;
            icon.title = 'Discussion';
            icon.setAttribute('aria-hidden', 'true');
            return icon;
        }
        //#region Discussion Tippy popover
        function createDiscussionPopOver(instance, params) {
            var template = instance[0].eGui;
            hideAllTippyPopUp()
            var tippyInstance = tippy(template);
            tippyInstance.disable();
            configureTippyInstance(tippyInstance);
            if (params.data.IsDiscussion) {
                tippyJsinstance.push({ tippyInstance: tippyInstance, cellInstance: instance, rowNode: params.node });
            }
            var popOver = createDiscussionComponent(params);
            tippyInstance.setContent(popOver);
        }
        function configureTippyInstance(tippyInstance) {
            tippyInstance.enable();
            tippyInstance.show();
            document.getElementById("TechWorklistAgGrid").addEventListener("mouseenter", discsnPopHide);
            function discsnPopHide() {
                tippyInstance.hide();
            }
            tippyInstance.setProps({
                trigger: 'mouseenter',
                placement: 'right',
                interactive: false,
                onMount: function (tippyInstance) {
                    tippyInstance.setProps({ interactive: true });
                },
                appendTo: document.body,
                hideOnClick: false,
                arrow: true,
                zIndex: 99999,
                followCursor: false,
                sticky: true,
                duration: 0,
                offset: [0, 8],
                flip: false
            });
        }
        function createDiscussionComponent(params) {
            var popOver = document.createElement('div');
            popOver.innerHTML = "<img src= \'https://i.gifer.com/ZKZx.gif\' style=\'height:20px;width:20px\'></img>"
            if (params.data.IsDiscussion) {
                $scope.showPopover(params.data.DicomOrderID, params.data.IsDiscussion).then(function (res) {
                    popOver.innerHTML = DOMPurify.sanitize("<div style='display:block; background-color: #323232;'>" + res + "</div>");
                });
            } else {
                popOver.innerHTML = "";
            }
            return popOver;
        }

        function hideAllTippyPopUp() {
            _.each(tippyJsinstance, function (instance) {
                if (instance.tippyInstance) {
                    instance.tippyInstance.hide();
                }
            });
            tippyJsinstance = [{ tippyInstance: null, cellInstance: null, rowNode: null }];
        }
        //#endregion Discussion Tippy popover
        //#endregion cell-template
        var AgGridColumnDefs = [
            {
                field: 'HasComparison',
                headerName: '',
                cellClass: 'pl-7px',
                cellRenderer: 'agGroupCellRenderer',
                lockPosition: 'left',
                lockVisible: true,
                maxWidth: 28,
                minWidth: 28,
                pinned: 'left',
                resizable: false,
                sortable: false,
                suppressMenu: false,
                suppressMovable: true,
                valueFormatter: function () { return ""; },
                icons: {
                    menu: '<i class="fa fa-gear"></i>',
                }
            },
            {
                field: 'User',
                headerName: "",
                headerClass: 'settcol-techno',
                cellRenderer: userLockIconCellRenderer,
                initialWidth: 40,
                pinned: 'left',
                lockPosition: 'left',
                lockVisible: true,
                resizable: false,
                suppressMovable: true,
                sortable: false,
            },
            {
                field: 'Location',
                tooltipField: 'Location',
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'Accession',
                tooltipField: 'Accession',
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'OrderDate',
                headerName: 'DOS',
                cellRenderer: DOSCellRenderer,
                flex: 1,
                minWidth: 70,
                sort: 'desc'
            },
            {
                field: 'PatientMRN',
                tooltipField: 'PatientMRN',
                headerName: 'MRN',
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'PatientName',
                tooltipField: 'PatientName',
                headerName: "Patient Name",
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'PatientPhone',
                tooltipField: 'PatientPhone',
                headerName: "Phone",
                flex: 1,
                minWidth: 70,
            },
            {
                field: 'FormattedPatientDOB',
                tooltipField: 'FormattedPatientDOB',
                headerName: "DOB",
                initialWidth: 65,
            },
            {
                field: 'PatientGender',
                tooltipField: 'PatientGender',
                headerName: "Gender",
                initialWidth: 60,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'PatientAge',
                tooltipField: 'PatientAge',
                headerName: "Age",
                initialWidth: 60,
            },
            {
                field: 'PatientClass',
                tooltipField: 'PatientClass',
                headerName: "Type",
                initialWidth: 50,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'Modality',
                tooltipField: 'Modality',
                initialWidth: 50,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'ProcedureDesc',
                tooltipField: 'ProcedureDesc',
                headerName: "Procedure",
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'OrderingPhysician',
                tooltipField: 'OrderingPhysician',
                headerName: "Ordering Physician",
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: 'ExamStatus',
                tooltipField: 'Exam Status',
                headerName: "Exam Status",
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params && params.value) {
                        var status = params.value.toUpperCase();
                        var statusObject = _.find($scope.DataObject.StatusList, { key: status });
                        var statusValue = statusObject ? statusObject.value : status;
                        return statusValue;
                    }
                }
            },
            {
                field: 'ImageInstance',
                headerName: "Image Count",
                initialWidth: 60,
                sortable: false,
            },
            {
                field: "Priority",
                initialWidth: 90,
                sortable: false,
                tooltipField: "Priority",
            },
            {
                field: 'DicomViewer',
                headerName: "Dicom Viewer",
                sortable: false,
                headerClass: "hideHeaderTxt",
                initialWidth: 30,
                cellRenderer: diacomImageCellRenderer,
            },
            {
                field: 'EditOrder',
                headerName: "Edit Order",
                sortable: false,
                initialWidth: 30,
                resizable: false,
                headerClass: "hideHeaderTxt",
                cellRenderer: editOrderCellRenderer,
            },
            {
                field: 'Report',
                headerName: "Report",
                sortable: false,
                initialWidth: 30,
                resizable: false,
                headerClass: "hideHeaderTxt",
                cellRenderer: reportCellRenderer,
            },
            {
                field: 'ResendReport',
                headerName: "Resend Report",
                sortable: false,
                initialWidth: 35,
                resizable: false,
                headerClass: "hideHeaderTxt",
                cellRenderer: resendReportCellRenderer,
            },
            {
                field: 'FileCount',
                headerName: "Discussion",
                sortable: false,
                initialWidth: 30,
                headerClass: "hideHeaderTxt",
                resizable: false,
                cellRenderer: discussionCellRenderer
            },
            {
                field: 'IC',
                headerName: "Comments",
                sortable: false,
                initialWidth: 30,
                resizable: false,
                headerClass: "hideHeaderTxt",
                cellRenderer: IPCommentCellRenderer
            }
        ]
        function detailCellRendererParams(masterGridParams) {
            return {
                detailGridOptions: {
                    columnDefs: AgGridColumnDefs,
                    enableBrowserTooltips: true,
                    popupParent: document.body,
                    defaultColDef: {
                        suppressMenu: true,
                        resizable: true,
                        sortable: false,
                        lockVisible: false,
                    },
                    suppressMenuHide: true,
                    getContextMenuItems: function () { return []; },
                    headerHeight: 0,

                    context: {
                        masterGrid: {
                            node: masterGridParams.node.parent,
                            data: masterGridParams.data
                        }
                    },

                    getRowStyle: function (params) {
                        var obj = {}
                        if (params.node.data.RowColorCode) {
                            obj.color = params.node.data.RowColorCode;
                        } else {
                            obj.color = '#B9ADCF';
                        }
                        return obj;
                    },
                    onGridReady: function (params) {
                        var savedState = gridOptions.columnApi.getColumnState();
                        params.columnApi.applyColumnState({ state: savedState, applyOrder: true });
                    },
                    onFirstDataRendered: function (params) {
                        var savedState = gridOptions.columnApi.getColumnState();
                        params.columnApi.applyColumnState({ state: savedState, applyOrder: true });
                    },
                    onRowClicked: function (params) {
                        if (params.context && params.context.masterGrid && params.context.masterGrid.node) {
                            params.context.masterGrid.node.setSelected(true)
                        }
                    },
                    onCellClicked: function (params) {
                        if (params.node.data) {
                            var order = params.node.data;
                            switch (params.column.colId) {
                                case 'DicomViewer':
                                    $scope.OpenSynapseStudy(order, "MedDream", false);
                                    break;
                            }
                        }
                    }
                },
                getDetailRowData: function (params) {
                    var savedState = gridOptions.columnApi.getColumnState();
                    GetOrdersComparisonList(params.data.OrderID).then(function (ComparisionOrder) {
                        params.data.ComparisonOrder = _.filter(ComparisionOrder, function (item) { return _.toString(item.ReportStatus) != '2' });;
                        _.each(ComparisionOrder, function (order) {
                            order.isComparisionOrder = 1;
                        });
                        params.successCallback(ComparisionOrder);
                        var timeout = $timeout(function () {
                            gridOptions.api.forEachDetailGridInfo(function (detailGridApi) {
                                detailGridApi.columnApi.applyColumnState({ state: savedState, applyOrder: true });
                            });
                            $timeout.cancel(timeout);
                            timeout = null;
                        }, 100);
                    });
                },
            }

        }
        var gridOptions = {
            masterDetail: true,
            detailRowAutoHeight: true,
            columnDefs: AgGridColumnDefs,
            enableBrowserTooltips: true,
            defaultColDef: {
                resizable: true,
                sortable: true,
                suppressMenu: true,
                columnsMenuParams: {
                    columnLayout: ColumnsToHide
                },
            },
            isRowMaster: function (order) {
                return _.toInteger(order.HasComparison);
            },
            detailCellRendererParams: detailCellRendererParams,
            suppressMenuHide: true,
            getMainMenuItems: function (params) {
                var items = ["autoSizeAll", "separator"];
                items.push({
                    name: 'Reset Columns',
                    action: function (params) {
                        console.log("Reset Columns > ", params);
                        resetColumns();
                    }
                })
                return items;
            },
            getContextMenuItems: openContextMenuOptions,
            sortingOrder: ['desc', 'asc'],
            rowSelection: 'single',
            rowModelType: 'serverSide',
            cacheBlockSize: PageSize,
            maxBlocksInCache: 1,
            maxConcurrentDatasourceRequests: 1,
            getRowId: function (params) {
                return params.data.orderRowID;
            },
            getRowStyle: function (params) {
                if (params.node.data) {
                    var obj = { color: params.node.data.RowColorCode };
                    return obj;
                }
            },
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            popupParent: document.body,
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },
            onGridReady: function () {
                var savedState = [];
                var currentState = gridOptions.columnApi.getColumnState();
                if (worklistSavedState && worklistSavedState.columnDefs) {
                    _.each(worklistSavedState.columnDefs, function (col) {
                        if (col.name != "CreatedDate" || col.name != "TF") {
                            var obj = {
                                colId: col.name,
                            }
                            var Idx = _.findIndex(gridOptions.columnApi.getColumnState(), { colId: col.name });
                            if (Idx != -1) {
                                obj.flex = currentState[Idx].flex;
                            }

                            if (col.hasOwnProperty("width") && col.width != "*") {
                                obj.flex = null;
                                obj.width = col.width;
                            }
                            if (col.hasOwnProperty("visible")) {
                                obj.hide = !col.visible;
                            }
                            savedState.push(obj);
                        }
                    });
                }
                worklistSavedState = (savedState && savedState.length > 0) ? savedState : ((worklistSavedState && worklistSavedState.length > 0) ? worklistSavedState : currentState);

                var HasComparisonSavedState = _.find(worklistSavedState, { colId: "HasComparison" });
                if (!HasComparisonSavedState) {
                    var HasComparisonCurrentState = _.find(currentState, { colId: "HasComparison" });
                    if (HasComparisonCurrentState) {
                        worklistSavedState.splice(0, 0, HasComparisonCurrentState);
                    }
                }

                var differenceStates = _.differenceBy(currentState, worklistSavedState, 'colId');
                if (differenceStates.length > 0) {
                    _.each(currentState, function (col, index) {
                        var idx = _.findIndex(worklistSavedState, { 'colId': col.colId });
                        if (idx == -1) {
                            var previousCol = currentState[index - 1];
                            if (previousCol) {
                                var previousColSavedStateIndex = _.findIndex(worklistSavedState, { 'colId': previousCol.colId });
                                if (previousColSavedStateIndex != -1) {
                                    worklistSavedState.splice(previousColSavedStateIndex + 1, 0, col);
                                }
                            }
                        }
                    });
                }
                gridOptions.columnApi.applyColumnState({ state: worklistSavedState, applyOrder: true });
                statusBarComponent = gridOptions.api.getStatusPanel('GridFooter');
                gridOptions.api.setCacheBlockSize(PageSize);

                setColumnHideMenu();
                setFilter();
                //#region bind data to html
                var fakeServer = createFakeServer();
                var datasource = createServerSideDatasource(fakeServer);
                gridOptions.api.setServerSideDatasource(datasource);
                //#endregion bind data to html

                //Calling Tour After Data binding
                TechnoInitTour();
            },
            onCellMouseOver: function (params) {
                switch (params.column.colId) {
                    case 'FileCount':
                        hideAllTippyPopUp();
                        if (params.data.IsDiscussion) {
                            var cellRendererInstances = params.api.getCellRendererInstances({
                                rowNodes: [params.node],
                                columns: [params.column],
                            });
                            createDiscussionPopOver(cellRendererInstances, params)
                        }
                        break;
                }
            },
            onCellClicked: function (params) {
                if (params.node.data) {
                    var order = params.node.data;
                    $scope.SelectedOrder = _.clone(order);
                    console.log({ SelectedOrder: $scope.SelectedOrder })

                    switch (params.column.colId) {
                        case 'DicomViewer':
                            $scope.OpenSynapseStudy(order, "MedDream", false);
                            break;
                        case "EditOrder":
                            if (!LoadPatientDataFlag) {
                                $scope.LoadPatientData(order);
                            }
                            break;
                        case "Report":
                            if (params && params.data && _.toString(params.data.ReportStatus) != '2') {

                                ViewOrderReport(params.data, params.data.Accession);
                            }
                            //if (order.ReportStatus == '1' || order.ReportStatus == '2' || order.ReportStatus == '5') {
                            //    $scope.SelectedOrder = _.clone(order);
                            //    $scope.LoadReport();
                            //}
                            break;
                        case "ResendReport":
                            $scope.ResendReport(order);
                            break;
                        case "FileCount":
                            $scope.setSelected(order.OrderID, order);
                            $scope.LoadDiscussion(order.DicomOrderID, order.FileCount);
                            break;
                    }
                }
            },
            onRowSelected: function (params) {
                var selectedRow = gridOptions.api.getSelectedRows()[0];
                if (selectedRow) { $scope.setSelected(selectedRow.OrderID, selectedRow); }
            },
            onCellEditingStopped: function (params) {
                if (params.node.data) {
                    var order = params.node.data;
                    switch (params.column.colId) {
                        case "IsSTAT":
                            if (!params.newValue) {
                                order.IsSTATStroke = false;
                                order.IsSTATTrauma = false;
                                UpdateStrokeSTAT(order);
                            }
                            UpdateDicomOrderSTAT(order);
                            break;
                    }
                }
            },
            onRowDoubleClicked: function (params) {
                $scope.OpenSignReport(params.data);
            },
            onColumnMoved: function (params) {
                if (params.finished) {
                    updateUserLayoutPreference()
                }
            },
            onSortChanged: function (params) {
                updateUserLayoutPreference();
                PageNo = 1;
                DicomOrderList = [];
                sortingApplied = true;
                refreshWorklistAggrid(true);
                gridOptions.api.ensureIndexVisible(0);
            },
            onColumnResized: function (params) {
                if (params && params.source == "autosizeColumns") {
                    updateUserLayoutPreference();
                }
            },
            onColumnVisible: function (params) {
                console.log("onColumnVisible > ", params);
                if (params.source != "api") {
                    if (params.column && params.column.colId == "Report") {
                        UserLayoutOption.ReportColVisible = params.column.visible;
                    }
                    if (params.column && params.column.colId == "ResendReport") {
                        UserLayoutOption.ResendReportColVisible = params.column.visible;
                    }
                }
                updateUserLayoutPreference();
            },
            onDragStopped: function (params) {
                updateUserLayoutPreference();
            },
            onColumnPinned: function (params) {
                updateUserLayoutPreference();
            },
            icons: {
                groupExpanded:
                    '<div class=\'fa fa-minus fs-15px txt-clr-14 ng-scope\' title=\'Collapse\'></div>',
                groupContracted:
                    '<div class=\'fa fa-plus fs-15px txt-clr-14 ng-scope\' title=\'Expand\'></div>',
            },
        }
        function initGrid() {
            techGrid = document.getElementById("TechWorklistAgGrid");
            new agGrid.Grid(techGrid, gridOptions);
        }

        function setColumnHideMenu() {
            _.each(AgGridColumnDefs, function (col) {
                if (!col.lockVisible) {
                    var obj = {};

                    obj.field = col.field;
                    ColumnsToHide.push(obj);
                }
            });
        }

        function createFakeServer() {
            return {
                getData: function (request) {
                    var d = $q.defer();

                    var page = _.toInteger(request.endRow / PageSize);
                    if (page <= 0) { page = 1; }

                    if (sortingApplied) {
                        PageNo = page;
                        sortingApplied = false;
                    } else if (page > PageNo) {
                        PageNo = page;
                    } else if (page < PageNo) {
                        PageNo = page;
                    }

                    createSortingString(request.sortModel);

                    getDicomOrders().then(function (response) {

                        statusBarComponent.eGui.hidden = true;
                        if (DicomOrderList.length > 0) {
                            statusBarComponent.eGui.hidden = false;
                            statusBarComponent.eGui.style.padding = '5px';
                            statusBarComponent.eGui.style.margin = '5px';
                            statusBarComponent.eGui.textContent = 'Showing ' + DicomOrderList.length + ' of ' + TotalRows + ' Total Records';
                            statusBarComponent.eGui.style.color = 'white';
                        }

                        if (DicomOrderList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            gridOptions.api.hideOverlay();
                        }

                        d.resolve({
                            success: true,
                            rows: response
                        });
                    }, function (error) {
                        $scope.isorderlistLoading = false;
                        toaster.error("Failure to retrieve the data.");
                        var rows = [];
                        statusBarComponent.eGui.hidden = true;
                        if (DicomOrderList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            rows = DicomOrderList.slice(request.startRow, request.endRow);
                            statusBarComponent.eGui.hidden = false;
                            statusBarComponent.eGui.style.padding = '5px';
                            statusBarComponent.eGui.style.margin = '5px';
                            statusBarComponent.eGui.textContent = 'Showing ' + DicomOrderList.length + ' of ' + TotalRows + ' Total Records';
                            statusBarComponent.eGui.style.color = 'white';

                            gridOptions.api.hideOverlay();
                        }
                        d.resolve({
                            success: true,
                            rows: rows
                        });
                    });
                    return d.promise;
                },
            };
        }

        function createServerSideDatasource(server) {
            return {
                getRows: function (params) {
                    server.getData(params.request).then(function (response) {
                        params.success({
                            rowData: response.rows,
                            rowCount: response.lastRow,
                        });

                        var selectedRows = gridOptions.api.getSelectedRows();
                        if (selectedRows.length > 0) {
                            gridOptions.api.deselectAll();
                            _.each(selectedRows, function (row) {
                                var order = _.find(DicomOrderList, { 'OrderID': row.OrderID });
                                if (order != null) {
                                    var node = gridOptions.api.getRowNode((order.orderRowID).toString());
                                    if (node) {
                                        node.setSelected(true);
                                    }
                                }
                            });
                        }

                    }, function (reason) {
                        params.fail();
                        var timeout = $timeout(function () {
                            gridOptions.api.retryServerSideLoads();
                            $timeout.cancel(timeout);
                            timeout = null;
                        }, 100);
                    });
                },
            };
        }

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }


        $scope.FilterDICOMOrders = function (flag) {
            var dosLabel = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            var hasLoc = ($scope.SelectedLocations && $scope.SelectedLocations.locations && $scope.SelectedLocations.locations.length > 0) || ($scope.locations && $scope.locations !== '' && $scope.locations !== ',');
            if (dosLabel == 'Last 5 Years' && !hasLoc) {
                toaster.warning({ body: "Please select a Site/Location to use 'Last 5 Years' DOS filter." });
                return;
            }
            PageNo = 1;
            DicomOrderList = [];
            if (flag) { if ($scope.Status == 'H') { $scope.HiddenType.obj = $scope.HiddenTypeList[0]; } }
            refreshWorklistAggrid(true);
        }
        function setFilter() {
            syncOrderDateBeforeFilter();
            orderListFilter = {
                //SiteID: $scope.SelectedList.Site ? $scope.SelectedList.Site.SiteID : null,
                LocationID: $scope.locations.length > 0 ? $scope.locations : null,
                Accession: $scope.Accession,
                Modality: $scope.modalities.length > 0 ? $scope.modalities : null,
                OrderDateStartDate: ($scope.OrderDate.startDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.OrderDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00")) : null,
                OrderDateEndDate: ($scope.OrderDate.endDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.OrderDate.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")) : null,
                PatientName: $scope.PatientName,
                PatientMRN: $scope.PatientMRN,
                PatientDOB: $scope.formatted_date($scope.DOB),
                PatientClass: $scope.SelectedList.PatientClass ? $scope.SelectedList.PatientClass.Value : null,
                Status: $scope.Status,
                UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : null,
                OrderingPhysician: $scope.OrderingPhysician
            };
            if ($scope.Status == 'H' && $scope.HiddenType.obj && $scope.HiddenType.obj.Value) {
                orderListFilter.ImagePendingStatus = $scope.HiddenType.obj.Value;
            }
        }
        function createSortingString(sortModel) {
            sortingString = "";
            _.each(sortModel, function (obj) {
                var sortColumn = "";
                switch (obj.colId) {
                    case "Location":
                        sortColumn = "L.Location " + obj.sort;
                        break;
                    case "Accession":
                        sortColumn = "O.Accession " + obj.sort;
                        break;
                    case "OrderDate":
                        sortColumn = "O.OrderDate " + obj.sort;
                        break;
                    case "PatientMRN":
                        sortColumn = "O.PatientMRN " + obj.sort;
                        break;
                    case "PatientName":
                        sortColumn = "O.PatientLastName " + obj.sort + ",O.PatientFirstName " + obj.sort;
                        break;
                    case "FormattedPatientDOB":
                        sortColumn = "O.PatientDOB " + obj.sort;
                        break;
                    case "PatientGender":
                        sortColumn = "O.PatientGender " + obj.sort;
                        break;
                    case "PatientAge":
                        sortColumn = "O.PatientDOB " + obj.sort;
                        break;
                    case "PatientClass":
                        sortColumn = "O.PatientClass " + obj.sort;
                        break;
                    case "Modality":
                        sortColumn = "O.Modality " + obj.sort;
                        break;
                    case "ProcedureDesc":
                        sortColumn = "O.ProcedureDesc " + obj.sort;
                        break;
                    case "OrderingPhysician":
                        sortColumn = "P.Name " + obj.sort;
                        break;
                    case "Status":
                        sortColumn = "O.OrderStatus " + obj.sort;
                        break;
                    case "ExamStatus":
                        sortColumn = "O.ExamStatus " + obj.sort;
                        break;
                }
                if (sortingString == "") {
                    sortingString = sortColumn;
                } else {
                    sortingString = sortingString + "," + sortColumn;
                }
            });
            if (sortingString == "") {
                sortingString = defaultSortingString;
            }
            //console.log("sortingString > ", sortingString)
        }
        function removeRowFromGrid(selectedNode) {
            if (gridOptions && gridOptions.api && selectedNode && selectedNode.data && selectedNode.data.orderRowID && $scope.Status != 'AL') {
                gridOptions.api.applyServerSideTransaction({
                    remove: [{ orderRowID: (selectedNode.data.orderRowID).toString() }]
                });
                _.remove(DicomOrderList, { OrderID: selectedNode.data.OrderID });
                TotalRows = TotalRows - 1;
                statusBarComponent.eGui.textContent = 'Showing ' + DicomOrderList.length + ' of ' + TotalRows + ' Total Records';
                statusBarComponent.eGui.style.color = 'white';
                if (DicomOrderList.length == 0) {
                    statusBarComponent.eGui.hidden = true;
                    gridOptions.api.showNoRowsOverlay();
                } else {
                    statusBarComponent.eGui.hidden = false;
                    gridOptions.api.hideOverlay();
                }
            }
        }
        function refreshWorklistAggrid(purge) {
            if (gridOptions && gridOptions.api) {
                if (purge) {
                    setFilter();
                    gridOptions.api.refreshServerSide({ purge: true });
                }
                else {
                    gridOptions.api.refreshServerSide();
                }
            }
        }
        function updateOrders(Orders) {
            _.each(Orders, function (order) {
                order.orderRowID = new Date().getTime() + Math.random().toString(16).slice(2);
                updateOrderAssign(order);
            });

            return Orders;
        }
        function updateOrderAssign(order) {
            var d = $q.defer();
            if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) {
                var orderAssignmentIndex = _.findIndex(order.listOrderListAssignment, function (assignment) { return assignment.OrderAssingedUserID == $sessionStorage.currentUserData.userId; });

                order.OrderAssingedUserID = (order.listOrderListAssignment && order.listOrderListAssignment.length > 0 ? order.listOrderListAssignment[0].OrderAssingedUserID : null);
                //order.OrderAssingedUserName = $scope.getOrderListTooltip(order);
                order.OrderAssingedUsers = (order.listOrderListAssignment ? order.listOrderListAssignment.length : 0);

                order.OrderAssingedUser = (orderAssignmentIndex != -1 ? $sessionStorage.currentUserData.userId : null);
            }
            d.resolve(order);
            return d.promise;
        }
        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function isVisibleRad(r) {
            if (!r) return false;
            if (_isSelf(r.Id || r.UserID)) return true;
            return !_hasPrelimRad(r.UserRoles || r.Roles);
        }
        $scope.isVisibleRad = isVisibleRad;
        $scope.radDisplay = function (r) {
            if (!r) return '';
            if (!_isSelf(r.Id || r.UserID) && _hasPrelimRad(r.UserRoles || r.Roles)) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
        $scope.signByDisplay = function (r) {
            if (!r) return '';
            if ($sessionStorage.currentUserData
                && $sessionStorage.currentUserData.RemoveRenderingPhysician
                && $scope.DataObject.EnableRowsForSelectedTenants
                && $scope.SelectedOrder
                && $scope.DataObject.EnableRowsForSelectedTenants.includes($scope.SelectedOrder.TenantName)) {
                return '';
            }
            var signBy = r.SignBy || (r.OrderReport && r.OrderReport.SignBy);
            var signByName = r.SignByName || (r.OrderReport && r.OrderReport.SignByName) || '';
            return signBy ? _assignmentName(signBy, signByName) : signByName;
        };
        function _findRadByUserId(userId) {
            if (!userId) return null;
            var id = userId.toLowerCase();
            var rad = _.find(siteRadiologistsUnfiltered || [], function (r) {
                return (r.Id || r.UserID || '').toLowerCase() === id;
            });
            if (rad) return rad;
            rad = _.find(RuleSharedService.GetCachedRadiologists(), function (r) {
                return (r.Id || r.UserID || '').toLowerCase() === id;
            });
            if (!rad) {
                RuleSharedService.RequestTenantRadiologistsIfNeeded();
            }
            return rad || null;
        }
        function _isPrelimRadAssignment(userId) {
            if (!userId || _isSelf(userId)) return false;
            var rad = _findRadByUserId(userId);
            return rad ? _hasPrelimRad(rad.UserRoles || rad.Roles) : false;
        }
        function _assignmentName(userId, name) {
            return _isPrelimRadAssignment(userId) ? '' : name;
        }
        function _discussionDisplayName(dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        }
        $scope.disName = function (dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        };
        function getOrderListTooltip(Order) {
            var orderDiscussionTooltip = '';
            var groupName = '';
            var userName = '';
            var allSpeciality = _.uniqBy(_.map(Order.listOrderListAssignment, function (row) {
                return {
                    ProviderSpecialityId: row.ProviderSpecialityId,
                    IsUserWithSpecialityGroup: row.IsUserWithSpecialityGroup,
                    SpecialityCode: row.SpecialityCode
                }
            }), 'ProviderSpecialityId');
            var allUsers = _.map(Order.listOrderListAssignment, function (row) {
                return {
                    OrderAssingedUserID: row.OrderAssingedUserID,
                    OrderAssingedUserName: row.OrderAssingedUserName,
                }
            });
            var specialities = [];
            var users = []
            _.each(Order.listOrderListAssignment, function (orderAssignment) {
                if (orderAssignment.ProviderSpecialityId > 0) {
                    var speciality = _.find(allSpeciality, { ProviderSpecialityId: orderAssignment.ProviderSpecialityId });
                    if (speciality) {
                        specialities.push(speciality);
                    }
                } else {
                    var specialityUser = _.find(allUsers, { OrderAssingedUserID: orderAssignment.OrderAssingedUserID });
                    if (specialityUser) {
                        users.push(specialityUser);
                    }
                }
            });

            var uniquespecialities = _.uniqBy(specialities, 'ProviderSpecialityId');

            var rawUsers = _.uniqBy(users, 'OrderAssingedUserID');
            var uniquespecialityusers = _.filter(rawUsers, function (_u) { return !_isPrelimRadAssignment(_u.OrderAssingedUserID); });


            groupName = _.join(_.map(uniquespecialities, function (speciality) { return speciality.SpecialityCode; }), ',');

            userName = _.join(_.map(uniquespecialityusers, function (_user) {
                return _assignmentName(_user.OrderAssingedUserID, _user.OrderAssingedUserName);
            }), ',');

            if (uniquespecialities.length == 0 && uniquespecialityusers.length == 0) {
                if (rawUsers.length > 0) { return ''; }
                orderDiscussionTooltip = '';
                if (Order.isCollapsed) {
                    orderDiscussionTooltip = 'Hide Comparison';
                } else {
                    orderDiscussionTooltip = 'Show Comparison';
                }
                return orderDiscussionTooltip;
            } else {
                var message = '';
                var groupMessage = '';
                var userMessage = '';
                groupMessage += uniquespecialities.length > 1 ? uniquespecialities.length + ' Groups' : uniquespecialities.length == 1 ? groupName : '';
                userMessage += uniquespecialityusers.length > 1 ? uniquespecialityusers.length + ' Others' : uniquespecialityusers.length == 1 ? userName : '';
                if (groupMessage.length > 0 && userMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage + ' and ' + userMessage;
                } else if (groupMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage;
                } else if (userMessage.length > 0) {
                    message = 'Assigned to ' + userMessage;
                }
                return message;
            }
        }
        function NotifyAssignStudy(data) {
            if (data && (data.FromUserID != $sessionStorage.currentUserData.userId)) {
                var orderIndex = _.findIndex(DicomOrderList, { 'OrderID': _.toString(data.OrderID) });
                var userOfGroupLength = data.Order.listOrderListAssignment.length;
                var userIndex = _.findIndex(data.Order.listOrderListAssignment, { 'OrderAssingedUserID': $sessionStorage.currentUserData.userId });
                var userName = '';
                if (orderIndex != -1) {
                    DicomOrderList[orderIndex].listOrderListAssignment = data.Order.listOrderListAssignment;
                    userName = getOrderListTooltip(DicomOrderList[orderIndex]);
                }
                if (data.Order.listOrderListAssignment.length > 0) {
                    _.each(data.Order.listOrderListAssignment, function (data) {
                        if (orderIndex != -1) {
                            DicomOrderList[orderIndex].OrderAssingedUserID = data.OrderAssingedUserID;
                            DicomOrderList[orderIndex].OrderAssingedUserName = userName;
                            DicomOrderList[orderIndex].OrderAssingedUsers = userOfGroupLength;
                            DicomOrderList[orderIndex].OrderAssingedUser = userIndex != -1 ? $sessionStorage.currentUserData.userId : null;
                        }


                    });
                } else {
                    if (orderIndex != -1) {
                        DicomOrderList[orderIndex].OrderAssingedUserID = null;
                        DicomOrderList[orderIndex].OrderAssingedUserName = null;
                        DicomOrderList[orderIndex].OrderAssingedUsers = 0;
                        DicomOrderList[orderIndex].OrderAssingedUser = null;
                    }
                }

            } else if (data && (data.FromUserID == $sessionStorage.currentUserData.userId)) {
                var index = _.findIndex(DicomOrderList, { 'OrderID': data.Order.OrderID });
                if (index != -1) {
                    updateOrderAssign(data.Order);
                    DicomOrderList[index].OrderAssingedUserID = data.Order.OrderAssingedUserID;
                    DicomOrderList[index].OrderAssingedUserName = data.Order.OrderAssingedUserName;
                    DicomOrderList[index].OrderAssingedUsers = data.Order.OrderAssingedUsers;
                    DicomOrderList[index].OrderAssingedUser = data.Order.OrderAssingedUser;

                    if (data.Order && data.Order.listOrderListAssignment) {
                        DicomOrderList[index].listOrderListAssignment = data.Order.listOrderListAssignment;
                    }
                }
            }
            updateOrderAssign(data.Order).then(function (res) {
                UpdateGridData(res.OrderID);
            });
        }

        function UpdateGridData(OrderID) {

            var rowToUpdate;
            var order = _.find(DicomOrderList, { 'OrderID': OrderID });
            if (order) {
                rowToUpdate = gridOptions.api.getRowNode(order.orderRowID);
            }

            if (rowToUpdate) {
                rowToUpdate.data = _.filter(DicomOrderList, { OrderID: OrderID })[0];
                if (rowToUpdate.data) {
                    if (rowToUpdate.data && rowToUpdate.data.HasComparison == "0" && rowToUpdate.detailNode) {
                        rowToUpdate.setExpanded(false);
                        rowToUpdate.detailNode.parent.master = 0;
                    }
                    var params = {
                        force: true,
                        suppressFlash: true,
                        rowNodes: [rowToUpdate]

                    };
                    gridOptions.api.refreshCells(params);
                }

            }
        }
        //#endregion Ag-grid
        $scope.onKendoWindowClose = function () {
            OrderRefresh();
            refreshWorklistAggrid();
        }
        $scope.onKendoWindowOpen = function () {
            if (OrderRefreshInterval) {
                $interval.cancel(OrderRefreshInterval);
            }
        }

        $scope.keys = {
            F11: function (name, code) {
                var selectedRows = gridOptions.api.getSelectedRows();
                if (selectedRows.length == 1) {
                    $scope.LoadDiscussion(selectedRows[0].DicomOrderID, selectedRows[0].FileCount);
                }
            },
        };

        $scope.$on("OpenDiscussionOrder", function (evt, OD) {
            $scope.OrderDiscussion = OD;
            $scope.setSelected($scope.OrderDiscussion.Order.OrderID, $scope.OrderDiscussion.Order);
            $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID);
        });

        function GetOrdersComparisonList(OrderID) {
            var d = $q.defer();
            var orderComparisonListFilter = {
                UserID: $sessionStorage.currentUserData.userId,
                OrderID: OrderID
            };
            WorklistService.GetOrdersComparisonList(orderComparisonListFilter).then(function (result) {
                if (result.length > 0) {
                    d.resolve(_.filter(result, function (item) { return _.toString(item.ReportStatus) != '2' }));
                }
            });
            return d.promise;
        }
        function ViewOrderReport(SelectedOrder, SelectedOrderAccession) {
            $scope.ReportSelectedOrder = _.clone(SelectedOrder);
            $scope.showDiscuss = false;
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;

            var ComparisionOrderList = [];

            if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length == 0) {
                $scope.orderComparisonListFilter = {
                    UserID: vm.selectedData.LoggedInUserID,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = _.filter(result, function (item) { return _.toString(item.ReportStatus) != '2' });
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });

                    setPriorReport(SelectedOrder, ComparisionOrderList);
                }).catch(function (noCantDo) {
                    //$scope.isLoading = false;
                });
            } else if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                setPriorReport(SelectedOrder, ComparisionOrderList);
            } else {
                setPriorReport(SelectedOrder, ComparisionOrderList);
            }
        }
        function setPriorReport(SelectedOrder, ComparisionOrderList) {
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN, SelectedOrder.SiteID)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];

                if (data != null && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        SelectedOrder.FormattedOrderDate = new Date($filter('localDate')(SelectedOrder.OrderDate, false, new Date()));
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            rptObject[0].FormattedOrderDate = new Date($filter('localDate')(rptObject[0].OrderDate, false, new Date()));
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            ComparisonOrderReport.FormattedOrderDate = new Date($filter('localDate')(ComparisonOrderReport.OrderDate, false, new Date()));
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });
                }
                $scope.OrderReport = SelectedOrder;
                $scope.reportList = _.filter(_.uniqBy($scope.reportList, 'OrderID'), function (item) { return _.toString(item.ReportStatus) != '2' });
                $scope.DataObject.ReportList.Modalities = _.concat($scope.DataObject.ReportList.Modalities, _.uniq(_.map($scope.reportList, 'Modality')));
                var objSelectedReport = _.filter($scope.reportList, function (obj) { return obj.Accession == $scope.SelectedOrderAccession; });
                LoadReport(objSelectedReport[0].OrderID);
                if (Hasreport) {
                    $scope.currentWindow = "win_ComparisonOrderReports";
                    $scope.win_ComparisonOrderReports.open();
                    $scope.win_ComparisonOrderReports.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    $scope.win_ComparisonOrderReports.wrapper.addClass("report-top-mdl");
                    var timeout = $timeout(function () {
                        $scope.win_ComparisonOrderReports.center();
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 100);
                }
                else {
                    toaster.info({ body: "No report found." });
                }
                ReportList = $scope.reportList;
                if (ReportList.length > 1) {
                    $scope.DataObject.ShowReportModal = true;
                }
            });
        }
        function GetPriorReportsByPatientMRN(OrderID, PatientMRN, SiteID) {
            var d = $q.defer();
            var jObject = {
                OrderID: OrderID,
                PatientMRN: PatientMRN,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: SiteID
            }

            WorklistService.GetPriorReportsByPatientMRN(jObject).then(function (results) {
                d.resolve(_.filter(results, function (item) { return _.toString(item.ReportStatus) != '2' }));
            });
            return d.promise;
        }
        function LoadReport(OrderId) {
            if ($scope.orderReportList && $scope.orderReportList.length > 0) {
                var data = _.filter($scope.orderReportList, function (obj) { return obj.OrderID == OrderId; });
                if (data && data.length > 0) {
                    $scope.report = data[0];
                    $scope.ReviewOrder = {};
                    angular.copy($scope.report, $scope.ReviewOrder);

                    AssignValuesReportToSelectedOrder();
                    //$scope.isLoading = false;
                }
                else {
                    $scope.ReviewOrder = {};
                    getReportData(OrderId);
                }
            }
            else {
                $scope.ReviewOrder = {};
                getReportData(OrderId);
            }

        }
        function getReportData(OrderId) {
            $scope.report = null;
            var UserId = $sessionStorage.currentUserData.userId;
            WorklistService.GetDictationValueReport(OrderId, UserId).then(function (response) {
                if (response) {
                    $scope.report = response;
                    if ($sessionStorage.currentUserData
                        && $sessionStorage.currentUserData.RemoveRenderingPhysician
                        && ($scope.DataObject.EnableRowsForSelectedTenants
                            && $scope.DataObject.EnableRowsForSelectedTenants.includes($scope.SelectedOrder.TenantName))) {
                        $scope.report.DictationValue = _.toString($scope.report.DictationValue).length > 0 ? $scope.report.DictationValue.replace(/Electronically signed by.*?(?:\n|\r|$)/gi, '').replace(/Workstation:.*?(?:\n|\r|$)/gi, '').replace(/Electronically drafted by.*?(?:\n|\r|$)/gi, '') : '';
                    }
                    $scope.ReviewOrder = response;

                    $scope.orderReportList.push(response);

                    if ($scope.report && $scope.report.DOS) {
                        $scope.report.DOS = ($filter('localDate')($scope.report.DOS, false, new Date()));
                    }
                    if ($scope.report && $scope.report.SingDate) {
                        $scope.report.SingDate = moment(
                            ($filter('localDate')($scope.report.SingDate, false, new Date()))
                        ).format("MM/DD/YYYY");
                    }
                    if ($scope.report && $scope.report.Patient_DOB) {
                        $scope.report.Patient_DOB = changeDateFormat($scope.report.Patient_DOB);
                    }
                    if ($scope.OrderReport) {
                        $scope.report.Location = $scope.OrderReport.Location;
                        $scope.report.LocationID = $scope.OrderReport.LocationID;
                    }
                    AssignValuesReportToSelectedOrder();
                }

                //$scope.isLoading = false;
            }, function (error) {
                //$scope.isLoading = false;
            });
        }
        function changeDateFormat(date) {
            if (date) {
                return moment(new Date(date)).format("MM/DD/YYYY");
            }
        }
        $scope.onReportSortingClicked = function (sortingOption) {
            $scope.DataObject.SelectedSortingOption = sortingOption;
            var ReportListElement = document.getElementsByClassName('repoHeiFtrWrklst ftlrbtns-height');
            if (ReportListElement && ReportListElement[0] && ReportListElement[0].scrollTop > 0) {
                ReportListElement[0].scrollTop = 0;
            }
            switch (sortingOption) {
                case 'DOS (newest first)':
                    $scope.DataObject.ReportSortingPropName = 'OrderDate';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
                case 'DOS (oldest first)':
                    $scope.DataObject.ReportSortingPropName = 'OrderDate';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Rendering Physician (A to Z)':
                    $scope.DataObject.ReportSortingPropName = 'SignByName';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Rendering Physician (Z to A)':
                    $scope.DataObject.ReportSortingPropName = 'SignByName';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
                case 'Procedure (A to Z)':
                    $scope.DataObject.ReportSortingPropName = 'ProcedureDesc';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Procedure (Z to A)':
                    $scope.DataObject.ReportSortingPropName = 'ProcedureDesc';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
            }
        }

        $scope.FilterReportList = function (FilterFlag) {
            var FilteredList = ReportList;
            var startDate, endDate = null;
            if ($scope.DataObject.ReportListFilter.DateRange != 'Any') {
                switch ($scope.DataObject.ReportListFilter.DateRange) {
                    case '6m':
                        startDate = new Date(moment().subtract(6, 'month'));
                        endDate = new Date(moment());
                        break;
                    case '1y':
                        startDate = new Date(moment().subtract(1, 'year').add(1, 'days'));
                        endDate = new Date(moment());
                        break;
                    case '2y':
                        startDate = new Date(moment().subtract(2, 'year'));
                        endDate = new Date(moment());
                        break;
                    case '5y':
                        startDate = new Date(moment().subtract(5, 'year'));
                        endDate = new Date(moment());
                        break;
                }
                FilteredList = _.filter(FilteredList, function (report) {
                    var itemDate = new Date(report.OrderDate);
                    return itemDate >= startDate && itemDate <= endDate;
                });
            }
            if ($scope.DataObject.ReportListFilter.Modality != 'All') {
                FilteredList = _.filter(FilteredList, { 'Modality': $scope.DataObject.ReportListFilter.Modality });
            }
            if ($scope.DataObject.SearchText != '') {
                var result = null;
                result = _.filter(FilteredList, function (item) {
                    return _.some(['OrderDate', 'ProcedureDesc', 'SignByName'], function (key) {
                        if (key == 'OrderDate') {
                            return moment(_.get(item, key, '')).format('MM/DD/YYYY').toString().toLowerCase().includes($scope.DataObject.SearchText.toLowerCase());
                        }
                        else {
                            var value = _.get(item, key, '');
                            if (value) {
                                return value.toString().toLowerCase().includes($scope.DataObject.SearchText.toLowerCase());
                            }
                        }
                        return false;
                    });
                });
                if (result) { FilteredList = result; }
            }
            $scope.reportList = _.filter(FilteredList, function (item) { return _.toString(item.ReportStatus) != '2' });
            if (FilterFlag && $scope.reportList && $scope.reportList.length > 0) {
                var objSelectedReport = $scope.reportList[$scope.reportList.length - 1];
                if (objSelectedReport) {
                    $scope.SelectedOrderAccession = objSelectedReport.Accession;
                    LoadReport(objSelectedReport.OrderID);
                }
            }
        }
        $scope.onClearFilterReportList = function (ClearFlag) {
            $scope.DataObject.SelectedSortingOption = 'DOS (newest first)';
            $scope.DataObject.ReportListFilter.Modality = 'All';
            $scope.DataObject.ReportListFilter.DateRange = 'Any';
            $scope.DataObject.ReportSortingPropName = 'OrderDate';
            $scope.DataObject.ReportSortingRevOrder = true;
            if (ClearFlag) {
                $scope.DataObject.ReportList.Modalities = ['All'];
                $scope.DataObject.ShowReportModal = false;
            }
            $scope.DataObject.SearchText = '';
        }
        $scope.showReport = function (SelectedOrder) {
            $scope.OrderReport = SelectedOrder;
            $scope.SelectedOrderAccession = SelectedOrder.Accession;
            LoadReport(SelectedOrder.OrderID);
        }

        function AssignValuesReportToSelectedOrder() {
            $scope.ReportSelectedOrder.OrderDate = $scope.report.DOS;
            $scope.ReportSelectedOrder.ReportSignDate = $scope.report.SingDate;
            $scope.ReportSelectedOrder.ReportStatus = $scope.report.Status;
            $scope.ReportSelectedOrder.PatientDOB = $scope.report.Patient_DOB;
            if ($scope.ReportSelectedOrder && $scope.ReportSelectedOrder.Status) {
                $scope.ReportSelectedOrder.OrderStatus = _.find($scope.DataObject.OrderStatus, { 'key': $scope.ReportSelectedOrder.Status }).value;
            }
        }

        $scope.ActionItemClicked = function (ActionMenu, Order) {
            switch (ActionMenu.ActionTaken) {
                case 'Unhide Study':
                    HideUnhideOrder();
                    CloseAllWindow(true);
                    break;
                case 'Open Discussion (F11)':
                    $scope.setSelected(Order.OrderID, Order);
                    $scope.LoadDiscussion(Order.DicomOrderID, Order.FileCount);
                    break;
                case 'Consult with Physician':
                    $scope.CallInConsult(Order);
                    break;
                case 'Share Exam':
                    if (Order.DicomViewer) {
                        openShareExamWindow(Order);
                    }
                    break;
                case 'Query Retrieve':
                    $scope.QueryRetrieve(Order, true);
                    break;
                case 'Not to be Read':
                    $scope.HideOption = 'NotRead';
                    $scope.HideStudy();
                    CloseAllWindow(true);
                    break;
                case 'getFileDetails':
                    $scope.getFileDetails(ActionMenu.FileObject, true);
                    break;
            }

            var Timeout = $timeout(function () {
                _.each(openWindows.slice(1, -1), function (w) {
                    CloseAllWindow(false, w);
                });
                $timeout.cancel(Timeout);
                Timeout = null;
            }, 1000);
        }

        function CloseAllWindow(AllWindow, Window) {
            if ($scope.isHelpOrderVisible && AllWindow) {
                $scope.win_HelpOrder.close();
            }
            if ($scope.isViewReportVisible && AllWindow) {
                $scope.win_ViewReport.close();
            }
            if ($scope.isDiscussionVisible && (AllWindow ? AllWindow : Window == 'Discussion')) {
                $scope.win_Discussion.close();
            }
            if ($scope.isViewTechniqueVisible && AllWindow) {
                $scope.win_ViewTechnique.close();
            }
            if ($scope.isAddTechniqueVisible && AllWindow) {
                $scope.win_AddTechnique.close();
            }
            if ($scope.isTechFormVisible && AllWindow) {
                $scope.win_TechForm.close();
            }
            if ($scope.isPatientInfoVisible && AllWindow) {
                $scope.win_PatientInfo.close();
            }
            if ($scope.isConsultExamsWindow && (AllWindow ? AllWindow : Window == 'Consult Exams')) {
                $scope.win_consultExamsWindow.close();
            }
            if ($scope.isComparisonOrderReportsVisible && (AllWindow ? AllWindow : Window == 'Report')) {
                $scope.win_ComparisonOrderReports.close();
            }
        }

        function getOrderStatus() {
            $scope.DataObject.OrderStatus = WorklistService.GetOrderStatus();
        }

        $scope.windowOpened = function (windowInstance) {
            var WindowTitle = windowInstance && windowInstance.options ? windowInstance.options.title : '';
            if (WindowTitle != '' && openWindows.indexOf(WindowTitle) === -1) {
                openWindows.push(WindowTitle);
            }
        };

        $scope.windowClosed = function (windowInstance) {
            if (windowInstance) {
                var WindowTitle = windowInstance && windowInstance.options ? windowInstance.options.title : '';
                var index = openWindows.indexOf(WindowTitle);
                if (index > -1) {
                    openWindows.splice(index, 1);
                }
            }
        };

        //#region View Attachment
        $scope.onDiscussionWindowTabChange = function (TabName) {
            $scope.DataObject.DiscussionWindowActiveTab = TabName;
            switch (TabName) {
                case 'Attachment':
                    $scope.showFileList();
                    break;
                case 'Discussion':
                    setOrderDiscussionUserGroup().then(function (data) {
                        setOrderDiscussionTooltip();
                        setSelectedUserAssignment(data);
                    });
                    break;
            }
        }
        //#endregion

        $scope.PriorityChanged = function () {
            $scope.PatientInfo.IsSTATStroke = false;
            $scope.PatientInfo.IsSTATTrauma = false;
        }

        $scope.SendFax = function () {
            $scope.DataObject.FaxNumber = null;
            if ($scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list.length > 0 ||
                $scope.DataObject.FaxDetails.FaxNumber) {
                var textFaxNumber = $scope.DataObject.FaxDetails.FaxNumber;
                var dropdownFaxNum = _.join(_.map($scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list, function (obj) { return obj.FaxNumber; }), ',');

                var FaxNumber = textFaxNumber && dropdownFaxNum ? textFaxNumber + "," + dropdownFaxNum : textFaxNumber || dropdownFaxNum || null;
                var params = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    UserID: $sessionStorage.currentUserData.userId,
                    LocationID: $scope.SelectedOrder.LocationID,
                    FaxNumber: FaxNumber,
                    FaxContent: $scope.DataObject.FaxFile.FileContent,
                    FileName: $scope.DataObject.FaxFile.FileName,
                    ReportID: $scope.SelectedOrder.ReportID
                }

                $scope.DataObject.FaxDetails.disableSendFaxBtn = true;
                WorklistService.SendFax(params).then(function (res) {
                    $scope.DataObject.FaxDetails.disableSendFaxBtn = false
                    toaster.success("Fax sent successfully");
                    $("#SendFaxModal").modal("hide");
                }, function (err) {
                    $scope.DataObject.FaxDetails.disableSendFaxBtn = false
                    toaster.error("Some error occurred while sending Fax!");
                    $("#SendFaxModal").modal("hide");
                });

            }
        }
        $scope.openFaxModal = function (faxFile) {
            $scope.DataObject.FaxFile = faxFile;
            $scope.DataObject.FaxDetails.FaxNumber = null;
            $scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue = { list: [] };
            $scope.DataObject.FaxDetails.disableSendFaxBtn = false;
            ManageLocationService.GetLocationFaxMapping({ LocationID: $scope.SelectedOrder.LocationID }).then(function (res) {
                _.each(res, function (item, index) {
                    item.uniqID = index;
                    item.DisplayFaxNumber = (!item.PatientClass) ? item.FaxNumber : item.FaxNumber + " (" + item.PatientClass + ")";
                });
                $scope.DataObject.FaxDetails.FaxNumberList = res;
                $("#SendFaxModal").modal("show");
            }, function (err) {
            });
        }
        $scope.validateFaxNumText = function () {
            var disableBtn = false;
            if (!$scope.DataObject.FaxDetails.disableSendFaxBtn) {

                var faxNumTextInput = document.getElementById("FaxNumText");
                if (faxNumTextInput) {
                    var faxNumVal = _.cloneDeep(faxNumTextInput.value);
                    faxNumVal = faxNumVal.replaceAll('_', '').replaceAll('-', '').replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '');
                }

                if ($scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list.length > 0) {
                    if (faxNumVal.length > 0 && faxNumVal.length < 10) {
                        disableBtn = true;
                    }
                }
                else if (faxNumVal.length >= 0 && faxNumVal.length < 10) {
                    disableBtn = true;
                }
            }
            else {
                disableBtn = true;
            }
            return disableBtn;

        }

        $scope.OpenOrderingPhysicianModal = function () {
            $scope.DataObject.OrderingPhysician.SelectedData = { ContactPreferenceType: '0', StatusFlag: 'N' };
            $scope.DataObject.OrderingPhysician.AddEditText = "Add";
            $scope.DataObject.OrderingPhysician.SelectedData.SelectedSite = $scope.PatientInfo.OrderingPhysicianSite;
            $scope.DataObject.ShowOrderingPhysicianModal = true;
            $('#addOrderingPhysician').modal('show');
        }

        $scope.EditOrderingPhysicianModal = function () {
            if (!$scope.DataObject.OrderingPhysician.Provider) {
                toaster.pop('warning', 'Warning', 'Please select an Ordering Physician to edit.');
                return;
            }

            if (!$scope.PatientInfo.OrderingPhysicianSite) {
                toaster.pop('warning', 'Warning', 'Please select an Ordering Physician Site first.');
                return;
            }

            $scope.DataObject.OrderingPhysician.SelectedData = _.clone($scope.DataObject.OrderingPhysician.Provider);
            $scope.DataObject.OrderingPhysician.SelectedData.StatusFlag = 'M';
            $scope.DataObject.OrderingPhysician.SelectedData.SelectedSite = $scope.PatientInfo.OrderingPhysicianSite;

            if (!$scope.DataObject.OrderingPhysician.SelectedData.ContactPreferenceType) {
                $scope.DataObject.OrderingPhysician.SelectedData.ContactPreferenceType = '0';
            }

            $scope.DataObject.OrderingPhysician.AddEditText = "Edit";
            $scope.DataObject.ShowOrderingPhysicianModal = true;
            $('#addOrderingPhysician').modal('show');
        }

        $scope.GetProvidersList = function (SearchText) {
            var d = $q.defer();
            var siteIds = $scope.PatientInfo.OrderingPhysicianSite ? $scope.PatientInfo.OrderingPhysicianSite.SiteID : null;
            var obj = {
                SiteID: siteIds,
                Search: SearchText != '' && SearchText != null ? SearchText : null,
                UserID: $sessionStorage.currentUserData.userId,
            }
            GetProviders(obj).then(function (result) {
                if (result && result.length > 0) {
                    ProvidersFullList = _.concat(ProvidersFullList, result);
                    $scope.DataObject.MasterData.ProvidersList = _.uniqBy(ProvidersFullList, 'ProviderID');

                    if ($scope.PatientInfo && $scope.PatientInfo.ProviderID && !$scope.DataObject.OrderingPhysician.Provider) {
                        var providerObj = _.find($scope.DataObject.MasterData.ProvidersList, { 'ProviderID': $scope.PatientInfo.ProviderID });
                        if (providerObj) {
                            $scope.DataObject.OrderingPhysician.Provider = providerObj;
                            $scope.OnProviderSelected(providerObj);
                        } else {
                            var searchName = $scope.PatientInfo.OrderingPhysicianLastName + ', ' + $scope.PatientInfo.OrderingPhysicianFirstName;
                            if (searchName && searchName !== ', ') {
                                $scope.GetProvidersList(searchName);
                            }
                        }
                    }
                    d.resolve();
                }
            });
            return d.promise;
        }

        function GetProviders(GetProviderObject) {
            var d = $q.defer();
            MappingService.GetProviders(GetProviderObject).then(function (result) {
                d.resolve(result);
            });
            return d.promise;
        }

        function createSiteTooltip(selectedData) {
            var tooltip = null;
            _.each(selectedData, function (obj) {
                if (tooltip) {
                    tooltip = tooltip + "\n" + (obj.SiteTenant);
                }
                else {
                    tooltip = obj.SiteTenant;
                }
            });

            return tooltip;
        }

        $scope.clearModalData = function (frmOrderingPhysician) {
            if (frmOrderingPhysician) {
                frmOrderingPhysician.$setUntouched();
            }
            $scope.DataObject.OrderingPhysician.SelectedData = null;
            $scope.DataObject.ShowOrderingPhysicianModal = false;
            $scope.DataObject.MasterData.SiteTenant.SelectedValue = { list: [] };
            if ($scope.DataObject.MasterData.SiteTenant && $scope.DataObject.MasterData.SiteTenant.OnChange) {
                $scope.DataObject.MasterData.SiteTenant.OnChange($scope.DataObject.MasterData.SiteTenant.SelectedValue.list);
            }
            $('#addOrderingPhysician').modal('hide');
        }

        $scope.OnProviderSelected = function (Provider) {
            $scope.PatientInfo.OrderingPhysicianLastName = Provider ? Provider.LastName : null;
            $scope.PatientInfo.OrderingPhysicianFirstName = Provider ? Provider.FirstName : null;
            $scope.PatientInfo.OrderingPhysicianMiddleName = Provider ? Provider.MiddleName : null;
            $scope.PatientInfo.OrderingPhysicianNPI = Provider ? Provider.NPI : null;
            $scope.PatientInfo.OrderingPhysicianPhone = Provider ? Provider.Phone : null;
            $scope.PatientInfo.OrderingPhysicianCellPhone = Provider ? Provider.CellPhone : null;
        }

        function findProviderByNameAndNPI(providerList, lastName, firstName, npi) {
            var fullName = (lastName || '') + ', ' + (firstName || '');
            return _.find(providerList, function (p) {
                return (p.Name === fullName || (p.LastName === lastName && p.FirstName === firstName)) &&
                    (!npi || !p.NPI || p.NPI === npi);
            });
        }

        function refreshAndSelectProvider(providerData) {
            var searchName = (providerData.LastName || '') + ', ' + (providerData.FirstName || '');
            $scope.GetProvidersList(searchName).then(function () {
                var provider = findProviderByNameAndNPI(
                    $scope.DataObject.MasterData.ProvidersList,
                    providerData.LastName,
                    providerData.FirstName,
                    providerData.NPI
                );
                if (provider) {
                    $scope.DataObject.OrderingPhysician.Provider = provider;
                    $scope.OnProviderSelected(provider);
                }
            });
        }

        $scope.onSaveSuccess = function (result, providerData) {

            if (!result || !result.success) return;
            if (result.shouldClearModal) $scope.clearModalData();

            if (providerData.StatusFlag === 'M' && providerData.ProviderID) {
                var existingProviderIndex = _.findIndex(ProvidersFullList, { 'ProviderID': providerData.ProviderID });
                if (existingProviderIndex !== -1) {
                    var existingProvider = ProvidersFullList[existingProviderIndex];

                    var updatedProvider = _.extend({}, existingProvider, {
                        FirstName: providerData.FirstName,
                        LastName: providerData.LastName,
                        MiddleName: providerData.MiddleName,
                        Name: (providerData.LastName || '') + ', ' + (providerData.FirstName || '') + ' ' + (providerData.MiddleName || ''),
                        NPI: providerData.NPI,
                        Phone: providerData.Phone,
                        CellPhone: providerData.CellPhone,
                        Email: providerData.Email,
                        ContactPreferenceType: providerData.ContactPreferenceType,
                        SiteID: providerData.SelectedSite ? providerData.SelectedSite.SiteID : (providerData.SiteID || existingProvider.SiteID),
                        Site: providerData.SelectedSite ? providerData.SelectedSite.Site : (providerData.Site || existingProvider.Site),
                        TenantName: providerData.SelectedSite ? providerData.SelectedSite.TenantName : (providerData.TenantName || existingProvider.TenantName)
                    });

                    ProvidersFullList[existingProviderIndex] = updatedProvider;

                    $scope.DataObject.MasterData.ProvidersList = _.uniqBy(ProvidersFullList, 'ProviderID');

                    $scope.DataObject.OrderingPhysician.Provider = updatedProvider;

                    $scope.OnProviderSelected(updatedProvider);
                } else {
                    refreshAndSelectProvider(providerData);
                }
            } else {
                refreshAndSelectProvider(providerData);
            }
        }

        $scope.clearPatientInfoData = function () {
            $scope.isPatientInfoVisible = false;
            $scope.DataObject.OrderingPhysician.Provider = null;
            $scope.PatientInfo.OrderingPhysicianSite = null;
        }

        $scope.isAssignAllowed = function (status) {
            var hiddenAssignStatuses = ['C', 'X', 'CO', 'RC'];
            return hiddenAssignStatuses.indexOf(status) === -1;
        };

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();


angular.module('radico.pages.techno')
    .service('TechnoService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS, __env) {
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }
        this.GetAllSites = function () {
            return Restangular.one('psorders').one("GetAllSites").get();
        };
        this.GetOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetOrdersList").customPOST(orderListFilter);
        };
        this.GetDICOMOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetDICOMOrdersList").customPOST(orderListFilter);
        };
        //this.GetSitesAndLocations = function () {
        //    return Restangular.one('psorders').one("GetSitesAndLocations").get();
        //};
        this.GetSitesAndLocationsByUserID = function (userID) {
            return Restangular.one('psorders').one("GetSitesAndLocationsByUserID", userID).get();
        };
        this.GetPatientClass = function () {
            return Restangular.one('psorders').one("GetPatientClass").get();
        };
        this.CheckPSUserBySite = function (psuser) {
            return Restangular.one('psorders').one("CheckPSUserBySite").customPOST(psuser);
        };
        this.InsertPSUsersBySIte = function (psuser) {
            return Restangular.one('psorders').one("InsertPSUsersBySIte").customPOST(psuser);
        };
        this.SaveReport = function (reportView) {
            return Restangular.one('psorders').one("SaveReport").customPOST(reportView);
        };
        this.InsertOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("InsertOpenOrder").customPOST(openOrders);
        };
        this.DeleteOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("DeleteOpenOrder").customPOST(openOrders);
        };
        this.GetOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("GetOpenOrder").customPOST(openOrders);
        };
        this.RemoveFromComparison = function (comparisonOrder) {
            return Restangular.one('psorders').one("RemoveFromComparison").customPOST(comparisonOrder);
        };
        this.ShowHideOrder = function (orders) {
            return Restangular.one('psorders').one("ShowHideOrder").customPOST(orders);
        };
        this.GetCurrentDateTime = function () {
            return Restangular.one('psorders').one("GetCurrentDateTime").get();
        };
        this.SetDiscussion = function (data) {
            return Restangular.one('psorders').one("SetDiscussion").customPOST(data);
        };
        this.GetDiscussions = function (data) {
            return Restangular.one('psorders').one("GetDiscussions").customPOST(data);
        };
        this.GetDiscussionsByIds = function (data) {
            return Restangular.one('psorders').one("GetDiscussionsByIds").customPOST(data);
        };
        this.SetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("SetOrderDiscussion").customPOST(data);
        };
        this.UpdateDicomOrderSTAT = function (data) {
            return Restangular.one('psorders').one("UpdateDicomOrderSTAT").customPOST(data);
        };
        this.ResendReport = function (data) {
            return Restangular.one('psorders').one("ResendReport").customPOST(data);
        };
        this.GetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("GetOrderDiscussion").customPOST(data);
        };
        this.NotifyToUser = function (data) {
            return Restangular.one('psorders').one("NotifyToUser").customPOST(data);
        };
        this.GetAllUsers = function () {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/RadFlowGetUsers ',
                headers: { 'content-type': 'application/json' }
            });
        };
        this.SaveGridSetting = function (param) {
            return Restangular.one('psorders').one("SaveGridSetting").customPOST(param);
        };
        this.GetGridSetting = function (param) {
            return Restangular.one('psorders').one("GetGridSetting").customPOST(param);
        };
        this.GetModality = function () {
            return Restangular.one('psorders').one("GetModality").customPOST();
        };

        this.GetDicomFileByAccession = function (accession) {
            return Restangular.one('psorders').one("GetDicomFileByAccession", accession).get();
        };
        this.GetDicomFileByURI = function (FileRUI) {
            return Restangular.one('psorders').one("GetDicomFileByURI", FileRUI).get();
        };
        this.SavePatientInfo = function (order) {
            return Restangular.one('psorders').one("SavePatientInfo").customPOST(order);
        };
        this.SavePatientContactInfo = function (order) {
            return Restangular.one('psorders').one("SavePatientContactInfo").customPOST(order);
        };
        this.uploadFile = function (formData) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri + "psorders/uploadFile", formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            });
        };
        this.getFileList = function (DicomOrderId) {
            // Cache-bust: the gateway in front of this API caches GET responses by URL, which was
            // serving a stale file list after new uploads. Appending a changing param keeps this
            // request off that cache until the gateway policy itself is fixed.
            return Restangular.one('psorders').one("getFileList", DicomOrderId).get({ _: new Date().getTime() });
        };
        this.showFile = function (formData) {
            return Restangular.one('psorders').one("ShowFile").customPOST(formData);
        };
        //this.deleteFile = function (Id, DiacomOrderId) {
        //    return Restangular.one('psorders').one("DeleteFile", Id).customGET(DiacomOrderId);
        //};
        this.deleteFile = function (formData) {
            return Restangular.one('psorders').one("DeleteFile").customPOST(formData);
        };
        this.getImagePendingCount = function (userId) {
            return Restangular.one('psorders').one("getImagePendingCount", userId).get();
        };
        this.getOrderDetail = function (order) {
            return Restangular.one('psorders').one("GetOrderDetail").customPOST(order);
        };
        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };
        this.GetTechniqueByLocationID = function (locationId) {
            return Restangular.one('psorders').one("GetTechniqueByLocationID", locationId).get();
        };
        this.SubmitTechnique = function (formData) {
            return Restangular.one('psorders').one("AddTechnique").customPOST(formData);
        };
        this.SetOrderDiscussionAssignment = function (data) {
            return Restangular.one('psorders').one("SetOrderDiscussionAssignment").customPOST(data);
        };
        this.GetOrderDiscussionAssignment = function (data) {
            return Restangular.one('psorders').one("GetOrderDiscussionAssignment").customPOST(data);
        };
        this.SetPatientDiscussionORM = function (data) {
            return Restangular.one('psorders').one("SetPatientDiscussionORM").customPOST(data);
        };
        this.GetPatientORMDiscussion = function (data) {
            return Restangular.one('psorders').one("GetPatientORMDiscussion").customPOST(data);
        };
        this.GetDicomOrderByID = function (DicomOrderID) {
            return Restangular.one('psorders').one("GetDicomOrderByID", DicomOrderID).get();
        };
        this.SendInvite = function (obj) {
            return Restangular.one('psorders').one("SendInvite").customPOST(obj);
        };
        this.GetOrdersTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "GetOrdersTechForm").customPOST(data);
        };
        this.SetOrdersTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "SetOrdersTechForm").customPOST(data);
        };
        this.GetTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "GetTechForm").customPOST(data);
        };
        this.SetTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "SetTechForm").customPOST(data);
        };
        this.UpdateAddendumRequestReportStatus = function (params) {
            return Restangular.one('psorders').one("UpdateAddendumRequestReportStatus").customPOST(params);
        };
        this.UpdateStrokeSTAT = function (params) {
            return Restangular.one('psorders').one("UpdateStrokeSTAT").customPOST(params);
        };
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.userAnalytics').controller('UserAnalyticsController', UserAnalyticsController);


    function UserAnalyticsController($scope, $q, UserAnalyticsService, $filter, $timeout, $sessionStorage, PaymentContractService, $state, UserLayoutPrefService, SharedService) {

        //#region Local Variable Declarations

        var modalities = ["AR", "BD", "BMD", "CR", "CT", "DEXA", "DX", "KO", "MG", "MR", "NM", "PT", "RF", "US", "XA", "Other"];

        var PatientClassList = ["Emergency", "Inpatient", "Outpatient", "Other", "Unknown"];

        var chartList = {};

        var totalRowColor = '#1c1c1c';

        var layoutPref = {
            ActiveSection: "LocationTAT",
            isMenuVisible: true,
            NavigatorToggle: false,
            filter: {},
            Tabs: {},
            isDOSorSignedDate: "DOS",
            isCreatedOrCompletedDate: 'CreatedDate',
        };
        //#endregion Local Variable declaration

        //#region Variable Declaration

        $scope.DataObject = {
            isLoading: false,
            SelectedLocation: null,
            SelectedRadiologist: null,
            datePicker: setFilterDate("Last 30 Days"),
            ActiveSection: "LocationTAT",
            MasterData: { Locations: null, Sites: null },
            SelectedSiteValues: { SelectedItems: null },
            SelectedData: { Sites: null, TenantIDs: null },
            NavigatorToggle: false,
            isMenuVisible: true,
            DateFilterTooltip: "Select Date",
            Locations: [],
            SelectedLocations: {
                Ids: '',
                locations: [],
                divId: "AnalyticsPageFilter"
            },
            Tabs: setChartTabAsDefault(),
            IsAddendumRequestVisible: $sessionStorage.IsAddendumRequestVisible,
            isDOSorSignedDate: "DOS",
            isCreatedOrCompletedDate: 'CreatedDate'
        };
        function setChartTabAsDefault() {
            var tabs = {};

            tabs.TATByLocationTab = 'Chart';
            tabs.TATByRadiologistTab = 'Chart';

            tabs.TATByModalityTab = 'Chart';
            tabs.TATByPatientClassTab = 'Chart';
            tabs.TATByPatientClassModalityTab = 'Chart';

            tabs.VolumeByLocTab = 'Chart';
            tabs.ModalityByLocTab = 'Chart';
            tabs.PatientClassByLocTab = 'Chart';

            tabs.VolumesByRadTab = 'Chart';
            tabs.ModalityByRadTab = 'Chart';
            tabs.PatientClassByRadTab = 'Chart';

            tabs.MonthsGroupByLocVolTab = 'Chart';
            tabs.MonthsGroupByRadVolTab = 'Chart';
            tabs.ModalityGroupByMonthTab = 'Chart';
            tabs.RadVolumeByModalityGroup = 'Chart';

            tabs.LocModalityVolByMonthTab = 'Chart';

            tabs.RadModalityVolByMonthTab = 'Chart';

            tabs.LocPatientClassVolByMonthTab = 'Chart';
            tabs.RadPatientClassVolByMonthTab = 'Chart';
            tabs.SubChartLocVolByModalityTab = 'Chart';
            tabs.SubChartRadVolByModalityTab = 'Chart';
            tabs.SubChartLocVolByPCTab = 'Chart';
            tabs.SubChartRadVolByPCTab = 'Chart';

            tabs.HiddenVolByLocTab = 'Chart';
            tabs.LocHiddenVolByMonthTab = 'Chart';
            tabs.TATCountDOSLocTab = 'Chart';
            tabs.TATCountByDOSTab = 'Chart';
            tabs.TATCountByHourTab = 'Chart';

            tabs.TATCountByDOSAndLocTab = 'Chart';

            tabs.PeerReviewLocationTab = 'Chart';
            tabs.PeerReviewRadiologistTab = 'Chart';
            tabs.PeerReviewPendingSinceByLocTab = 'Chart';
            tabs.PeerReviewPendingSinceByRadTab = 'Chart';

            tabs.AddendumListByLocTab = 'Chart';
            tabs.AddendumListByRadTab = 'Chart';
            tabs.AddendumListToRadTab = 'Chart';

            tabs.RadiologistVolByLocTab = "Chart";
            tabs.RadiologistVolByLocModalityTab = "Chart";
            tabs.RadiologistVolByLocMonthsTab = "Chart";

            return tabs;
        }
        //#endregion Variable Declarations

        //#region Datepicker
        $scope.DOSopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                customRangeLabel: 'Custom range',
            },
            ranges: {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last 90 Days': [moment().subtract(89, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],

            },
            eventHandlers: {
                'apply.daterangepicker': function (event, picker) {
                    $scope.DataObject.DateFilterTooltip = moment($scope.DataObject.datePicker.startDate).format('MM/DD/YYYY') + " - " + moment($scope.DataObject.datePicker.endDate).format('MM/DD/YYYY');

                    if ($scope.DataObject.ActiveSection == "TATStudyCountByHourLocation") {
                        $scope.DataObject.SelectedLocation = null;
                        $scope.DataObject.SelectedRadiologist = null;
                    }
                    ApplyActiveSecion($scope.DataObject.ActiveSection);
                }
            }
        };


        function setFilterDate(label) {
            var dateObj = {
                label: label,
            };
            switch (label) {
                case "Today":
                    dateObj.startDate = moment(moment().format("YYYY-MM-DD") + ' ' + "00:00");
                    dateObj.endDate = moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59");
                    break;
                case "Last 3 Days":
                    dateObj.startDate = moment(moment().subtract(2, 'days').format("YYYY-MM-DD") + ' ' + "00:00");
                    dateObj.endDate = moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59");
                    break;
                case "Last 7 Days":
                    dateObj.startDate = moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00");
                    dateObj.endDate = moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59");
                    break;
                case "Last 30 Days":
                    dateObj.startDate = moment(moment().subtract(29, 'days').format("YYYY-MM-DD") + ' ' + "00:00");
                    dateObj.endDate = moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59");
                    break;
                case "Last 90 Days":
                    dateObj.startDate = moment(moment().subtract(89, 'days').format("YYYY-MM-DD") + ' ' + "00:00");
                    dateObj.endDate = moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59");
                    break;
                case "Last Year":
                    dateObj.startDate = moment((moment().subtract(1, 'year').add(1, 'days')).format("YYYY-MM-DD") + ' ' + "00:00");
                    dateObj.endDate = moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59");
                    break;
            }
            return dateObj;
        }
        //#endregion Datepicker

        //#region ColumnDefs and Gridoptions declarations
        function getGridoptions(key, type, catagoryField) {
            var gridoptions = {
                columnDefs: getColumnDefs(key, type, catagoryField),
                defaultColDef: {
                    flex: 1,
                    minWidth: 120,
                    resizable: true,
                    sortable: true,
                    lockVisible: true,
                    menuTabs: ["filterMenuTab", "generalMenuTab"]
                },
                sortingOrder: ['desc', 'asc'],
                enableRangeSelection: true,
                enableCharts: true,
                //rowSelection: 'single',
                //suppressContextMenu: true,
                overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
                getRowStyle: function (params) {
                    if (params && params.data && params.data.totalRowColor) {
                        return { background: params.data.totalRowColor };
                    }
                },
                onModelUpdated: function (params) {
                    if ($scope.DataObject.ActiveSection != "LocationTAT" && $scope.DataObject.ActiveSection != "RadiologistTAT" && $scope.DataObject.ActiveSection != "PeerReviewPendingSince") {
                        onFilterUpdatePinnedRow(params);
                    }
                    else {
                        params.api.setPinnedBottomRowData([]);
                    }
                },
            };
            return gridoptions;
        }
        function getColumnDefs(key, type, catagoryField) {
            var columnDefs = [];

            if (type == "TAT") {
                columnDefs = [
                    { field: catagoryField, chartDataType: "category", sort: "asc", filter: "agTextColumnFilter" },
                    {
                        field: "Routine", headerName: "ROUTINE TAT (Minutes)",
                        valueFormatter: function (params) {
                            if (params.data.Routine != "0") {
                                return params.data.Routine;
                            } else {
                                return "NA";
                            }
                        },
                        chartDataType: "series",
                        filter: 'agNumberColumnFilter',
                    },
                    {
                        field: "STAT", headerName: "STAT TAT (Minutes)",
                        valueFormatter: function (params) {
                            if (params.data.STAT != "0") {
                                return params.data.STAT;
                            } else {
                                return "NA";
                            }
                        },
                        chartDataType: "series",
                        filter: 'agNumberColumnFilter',
                    },
                    {
                        field: "TAT", headerName: "AVERAGE TAT (Minutes)",
                        valueFormatter: function (params) {
                            if (params.data.TAT != "0") {
                                return params.data.TAT;
                            } else {
                                return "NA";
                            }
                        },
                        chartDataType: "series",
                        filter: 'agNumberColumnFilter',
                    }
                ]
            }
            else if (type == "Volume") {
                switch (key) {
                    case "LocationOrRadiologist":
                        columnDefs = [
                            { field: catagoryField, chartDataType: "category", sort: "asc", filter: "agTextColumnFilter" },
                            { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                            {
                                field: "Routine", headerName: "Routine (Count)",
                                valueFormatter: function (params) {
                                    if (params.data.Routine != "0") {
                                        return params.data.Routine;
                                    } else {
                                        return "NA";
                                    }
                                },
                                chartDataType: "series",
                                filter: 'agNumberColumnFilter',
                            },
                            {
                                field: "STAT", headerName: "STAT (Count)",
                                valueFormatter: function (params) {
                                    if (params.data.STAT != "0") {
                                        return params.data.STAT;
                                    } else {
                                        return "NA";
                                    }
                                },
                                chartDataType: "series",
                                filter: 'agNumberColumnFilter',
                            }
                        ];
                        break;
                    case "Modality":
                        columnDefs = [
                            { field: catagoryField, chartDataType: "category", sort: "asc", filter: "agTextColumnFilter", pinned: "left", lockPinned: true },
                            { field: "SumOfModality", chartDataType: "series", filter: "agNumberColumnFilter", pinned: "left", lockPinned: true, initialWidth: 130 },
                            { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter", pinned: "left", lockPinned: true, initialWidth: 100 },
                        ]
                        _.each(modalities, function (data) {
                            columnDefs.push({
                                field: data, chartDataType: "series",
                                filter: 'agNumberColumnFilter',
                            });
                        });

                        break;
                    case "PatientClass":
                        columnDefs = [
                            { field: catagoryField, chartDataType: "category", sort: "asc", filter: "agTextColumnFilter", pinned: "left", lockPinned: true },
                            { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter", pinned: "left", lockPinned: true, initialWidth: 100 },
                        ]

                        _.each(PatientClassList, function (data) {
                            columnDefs.push({
                                field: data, chartDataType: "series",
                                filter: 'agNumberColumnFilter',
                            });
                        });
                        break;
                    case "ModalityCount":
                        columnDefs = [
                            { field: catagoryField, chartDataType: "category", sort: "asc", filter: "agTextColumnFilter" },
                            { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                            { field: "ModalityCount", chartDataType: "series", filter: "agNumberColumnFilter" },
                        ]
                        break;
                    case "ModalityCountByMonth":
                        columnDefs = [
                            { field: "MonthsName", chartDataType: "category", filter: "agTextColumnFilter" },
                            { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                            { field: "ModalityCount", chartDataType: "series", filter: "agNumberColumnFilter" },
                        ]
                        break;
                    case "PatientClassCountByMonth":
                        columnDefs = [
                            { field: "MonthsName", chartDataType: "category", filter: "agTextColumnFilter" },
                            { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                            { field: "PatientClassCount", chartDataType: "series", filter: "agNumberColumnFilter" },
                        ]
                        break;
                    case "PatientClassCount":
                        columnDefs = [
                            { field: catagoryField, chartDataType: "category", sort: "asc", filter: "agTextColumnFilter" },
                            { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                            { field: "PatientClassCount", chartDataType: "series", filter: "agNumberColumnFilter" },
                        ]
                        break;
                    case "HideStudyCount":
                        columnDefs = [
                            { field: catagoryField, chartDataType: "category", sort: "asc", filter: "agTextColumnFilter" },
                            { field: "HideStudyCount", chartDataType: "series", filter: "agNumberColumnFilter" },
                        ]
                        break;
                    case "HiddenStudyCountByDay":
                        columnDefs = [
                            { field: "Location", chartDataType: "category", filter: "agTextColumnFilter" },
                            { field: "DOS", chartDataType: "category", sort: "asc", filter: "agTextColumnFilter" },
                            { field: "HideStudyCount", chartDataType: "series", filter: "agNumberColumnFilter" }
                        ]
                        break;
                    case "PeerReviewLocationRadiologist":
                        columnDefs = [
                            { field: catagoryField, chartDataType: "category", filter: "agTextColumnFilter", sort: "asc" },
                            { field: "PendingCount", chartDataType: "series", filter: "agNumberColumnFilter" },
                            { field: "CompleteCount", chartDataType: "series", filter: "agNumberColumnFilter" },
                            { field: "TotalCount", chartDataType: "series", filter: "agNumberColumnFilter" }
                        ]
                        if (catagoryField == "AddendumRequestedBy") {
                            columnDefs[0].headerName = "Requested By";
                        }
                        else if (catagoryField == "AddendumRequestedTo") {
                            columnDefs[0].headerName = "Requested To";
                        }
                        break;
                    case "PeerReviewPendingSince":
                        columnDefs = [
                            { field: catagoryField, chartDataType: "category", filter: "agTextColumnFilter", sort: "asc" },
                            { field: "AddedDate", headerName: "Peer Review Created Date", chartDataType: "category", filter: "agTextColumnFilter" },
                            { field: "PendingCount", chartDataType: "series", filter: "agNumberColumnFilter" },
                            { field: "PendingSince", headerName: "Pending Since (Day/s)", chartDataType: "series", filter: "agNumberColumnFilter" }
                        ]
                        break;
                }
            }
            return columnDefs;
        }

        var gridOptionsByLoc = getGridoptions("Location", "TAT", "Location");
        var gridOptionsByRadiologist = getGridoptions("Radiologist", "TAT", "Radiologist");

        var gridOptionsByModality = getGridoptions("Modality", "TAT", "Modality");
        var gridOptionsByPatientClass = getGridoptions("PatientClass", "TAT", "PatientClass");
        var gridOptionsByPatientClassModality = getGridoptions("PatientClassModality", "TAT", "PatientClassModality");

        var VolumeByLocGridOptions = getGridoptions("LocationOrRadiologist", "Volume", "Location");
        var ModalityByLocGridOptions = getGridoptions("Modality", "Volume", "Location");
        var PatientClassByLocGridOptions = getGridoptions("PatientClass", "Volume", "Location");

        var VolumeByRadiologistGridOptions = getGridoptions("LocationOrRadiologist", "Volume", "Radiologist");
        var ModalityByRadiologistGridOptions = getGridoptions("Modality", "Volume", "Radiologist");
        var PatientClassByRadiologistGridOptions = getGridoptions("PatientClass", "Volume", "Radiologist");

        var MonthsGroupByLocVolGridOptions = getGridoptions("LocationOrRadiologist", "Volume", "MonthsName");

        var MonthsGroupByRadVolGridOptions = getGridoptions("LocationOrRadiologist", "Volume", "MonthsName");

        var ModalityGroupByMonthGridOptions = getGridoptions("ModalityCount", "Volume", "Modality");

        var RadVolumeByModalityGroupGridOptions = getGridoptions("ModalityCount", "Volume", "Modality");

        var LocModalityVolByMonthGridOption = getGridoptions("ModalityCountByMonth", "Volume");

        var RadModalityVolByMonthGridOption = getGridoptions("ModalityCountByMonth", "Volume");

        var LocPatientClassVolByMonthGridOption = getGridoptions("PatientClassCountByMonth", "Volume");

        var RadPatientClassVolByMonthGridOption = getGridoptions("PatientClassCountByMonth", "Volume");

        var SubChartLocVolByModalityGridOption = getGridoptions("LocationOrRadiologist", "Volume", "Location");;

        var SubChartRadVolByModalityGridOption = getGridoptions("LocationOrRadiologist", "Volume", "Radiologist");

        var SubChartLocVolByPCGridOption = getGridoptions("PatientClassCount", "Volume", "PatientClass");

        var SubChartRadVolByPCGridOption = getGridoptions("PatientClassCount", "Volume", "PatientClass");

        var HiddenVolByLocGridOption = getGridoptions("HideStudyCount", "Volume", "Location");

        var LocHiddenVolByMonthGridOption = getGridoptions("HiddenStudyCountByDay", "Volume", "DOS");

        var AddendumListByLocGridOption = getGridoptions("PeerReviewLocationRadiologist", "Volume", "Location");
        var AddendumListByRadGridOption = getGridoptions("PeerReviewLocationRadiologist", "Volume", "AddendumRequestedBy");
        var AddendumListToRadGridOption = getGridoptions("PeerReviewLocationRadiologist", "Volume", "AddendumRequestedTo");

        var TATCountDOSLocGridOption = {
            columnDefs: [
                { field: "Location", chartDataType: "category", filter: "agTextColumnFilter" },
                { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "AvgTAT", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "StudyCount", chartDataType: "series", filter: "agNumberColumnFilter" },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: ["filterMenuTab", "generalMenuTab"]
            },
            sortingOrder: ['desc', 'asc'],
            enableRangeSelection: true,
            enableCharts: true,
            //rowSelection: 'single',
            //suppressContextMenu: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getRowStyle: function (params) {
                if (params && params.data && params.data.totalRowColor) {
                    return { background: params.data.totalRowColor };
                }
            },
            onModelUpdated: function (params) {
                onFilterUpdatePinnedRow(params);
            }
        }

        var TATCountByDOSGridOption = {
            columnDefs: [
                { field: "DOS", chartDataType: "category", filter: "agTextColumnFilter" },
                { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "AvgTAT", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "StudyCount", chartDataType: "series", filter: "agNumberColumnFilter" },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: ["filterMenuTab", "generalMenuTab"]
            },
            sortingOrder: ['desc', 'asc'],
            enableRangeSelection: true,
            enableCharts: true,
            //rowSelection: 'single',
            //suppressContextMenu: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getRowStyle: function (params) {
                if (params && params.data && params.data.totalRowColor) {
                    return { background: params.data.totalRowColor };
                }
            },
            onModelUpdated: function (params) {
                onFilterUpdatePinnedRow(params);
            }
        }
        var TATCountByHourGridOption = {
            columnDefs: [
                { field: "DOSHour", chartDataType: "category", filter: "agTextColumnFilter" },
                { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "AvgTAT", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "StudyCount", chartDataType: "series", filter: "agNumberColumnFilter" },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: ["filterMenuTab", "generalMenuTab"]
            },
            sortingOrder: ['desc', 'asc'],
            enableRangeSelection: true,
            enableCharts: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getRowStyle: function (params) {
                if (params && params.data && params.data.totalRowColor) {
                    return { background: params.data.totalRowColor };
                }
            },
            onModelUpdated: function (params) {
                onFilterUpdatePinnedRow(params);
            }
        }
        var TATCountByDOSAndLocGridOption = {
            columnDefs: [
                { field: "DOS", chartDataType: "category", filter: "agTextColumnFilter" },
                { field: "Location", chartDataType: "category", filter: "agTextColumnFilter" },
                { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "AvgTAT", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "StudyCount", chartDataType: "series", filter: "agNumberColumnFilter" },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: ["filterMenuTab", "generalMenuTab"]
            },
            sortingOrder: ['desc', 'asc'],
            enableRangeSelection: true,
            enableCharts: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getRowStyle: function (params) {
                if (params && params.data && params.data.totalRowColor) {
                    return { background: params.data.totalRowColor };
                }
            },
            onModelUpdated: function (params) {
                onFilterUpdatePinnedRow(params);
            }
        }

        var PeerReviewLocationGridOption = getGridoptions("PeerReviewLocationRadiologist", "Volume", "Location");

        var PeerReviewRadiologistGridOption = getGridoptions("PeerReviewLocationRadiologist", "Volume", "Radiologist");
        var PeerReviewPendingSinceByLocGridOption = getGridoptions("PeerReviewPendingSince", "Volume", "Location");
        var PeerReviewPendingSinceByRadGridOption = getGridoptions("PeerReviewPendingSince", "Volume", "Radiologist");

        var RadiologistVolByLocGridOption = {
            columnDefs: [
                { field: "Radiologist", chartDataType: "category", filter: "agTextColumnFilter" },
                { field: "Location", chartDataType: "series", filter: "agTextColumnFilter" },
                { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "StudyCount", chartDataType: "series", filter: "agNumberColumnFilter" },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: ["filterMenuTab", "generalMenuTab"]
            },
            sortingOrder: ['desc', 'asc'],
            enableRangeSelection: true,
            enableCharts: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getRowStyle: function (params) {
                if (params && params.data && params.data.totalRowColor) {
                    return { background: params.data.totalRowColor };
                }
            },
            onModelUpdated: function (params) {
                onFilterUpdatePinnedRow(params);
            }
        }
        var RadiologistVolByLocMonthsGridOption = {
            columnDefs: [
                { field: "MonthsName", chartDataType: "category", filter: "agTextColumnFilter" },
                { field: "Location", chartDataType: "series", filter: "agTextColumnFilter" },
                { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "StudyCount", chartDataType: "series", filter: "agNumberColumnFilter" },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: ["filterMenuTab", "generalMenuTab"]
            },
            sortingOrder: ['desc', 'asc'],
            enableRangeSelection: true,
            enableCharts: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getRowStyle: function (params) {
                if (params && params.data && params.data.totalRowColor) {
                    return { background: params.data.totalRowColor };
                }
            },
            onModelUpdated: function (params) {
                onFilterUpdatePinnedRow(params);
            }
        }
        var RadiologistVolByLocModalityGridOption = {
            columnDefs: [
                { field: "Modality", chartDataType: "category", filter: "agTextColumnFilter" },
                { field: "Location", chartDataType: "series", filter: "agTextColumnFilter" },
                { field: "SumOfRVU", chartDataType: "series", filter: "agNumberColumnFilter" },
                { field: "ModalityCount", chartDataType: "series", filter: "agNumberColumnFilter" },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: ["filterMenuTab", "generalMenuTab"]
            },
            sortingOrder: ['desc', 'asc'],
            enableRangeSelection: true,
            enableCharts: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getRowStyle: function (params) {
                if (params && params.data && params.data.totalRowColor) {
                    return { background: params.data.totalRowColor };
                }
            },
            onModelUpdated: function (params) {
                onFilterUpdatePinnedRow(params);
            }
        }
        //#endregion ColumnDefs and Gridoptions declarations

        //#region Chartoptions declarations
        function createChartOptions(xKey, type, seriesField) {
            var chartoptions = {
                params: {
                    xKey: xKey,
                    type: type,
                    seriesField: seriesField
                },
                theme: getChartOptionTheme(type, seriesField),
                padding: {
                    left: 50,
                    right: 50
                },
                background: {
                    fill: "#2d3436",
                },
                data: [],
                axes: getChartOptionAxes(type, seriesField),
                overlays: getChartOptionOverlays(),
                zoom: {
                    enabled: true,
                    axes: "xy",
                    anchorPointX: "pointer",
                    anchorPointY: "pointer",
                },
                navigator: {
                    enabled: false,
                },
                legend: {
                    item: {
                        marker: {
                            shape: "circle",
                        },
                    },
                },
            };

            return chartoptions;
        }

        function getChartOptionTheme(type, seriesField) {
            var theme = {};
            theme = {
                baseTheme: 'ag-default-dark',
                palette: {
                    fills: ['#00ddff', '#ff0000', '#05c1a4', '#ffb5b5', '#0091ff', '#ff875c', '#b7b100', '#b8075a', '#fff83b', '#c8feb1', '#2c7a54', '#004cff', '#37b700', '#002d97', '#7b00ff', '#c48cff', '#ff00d4', '#ffa1ef', '#ffa803', '#c6c6c6'],
                },
            };
            if (theme.palette) {
                theme.palette.strokes = theme.palette.fills;
            }
            return theme;
        }

        function getChartOptionSeries(xKey, type, seriesField) {
            var graphType = (type == "TAT") ? 'line' : 'bar';

            var series = [];

            if (type == "TAT") {
                series = [
                    {
                        type: graphType,
                        xKey: xKey,
                        yKey: 'Routine',
                        yName: 'ROUTINE TAT',
                        stacked: true,
                        listeners: { nodeClick: nodeClick },
                        marker: {
                            size: 13,
                        },
                        tooltip: createTooltip(type),
                    },
                    {
                        type: graphType,
                        xKey: xKey,
                        yKey: 'STAT',
                        yName: 'STAT TAT',
                        stacked: true,
                        listeners: { nodeClick: nodeClick },
                        marker: {
                            size: 13,
                        },
                        tooltip: createTooltip(type),
                    },
                    {
                        type: graphType,
                        xKey: xKey,
                        yKey: 'TAT',
                        yName: 'AVERAGE TAT',
                        stacked: true,
                        listeners: { nodeClick: nodeClick },
                        marker: {
                            size: 13,
                        },
                        tooltip: createTooltip(type),
                    }
                ];
            }
            else if (type == "Volume") {
                switch (seriesField) {
                    case "TATCounts":
                        series = [
                            {
                                type: graphType,
                                xKey: xKey,
                                yKey: 'Routine',
                                yName: 'ROUTINE',
                                stacked: true,
                                listeners: { nodeClick: nodeClick },
                                tooltip: createTooltip(type),
                            },
                            {
                                type: graphType,
                                xKey: xKey,
                                yKey: 'STAT',
                                yName: 'STAT',
                                stacked: true,
                                listeners: { nodeClick: nodeClick },
                                tooltip: createTooltip(type),
                            },
                        ];
                        break;
                    case "Modality":
                        series = [];
                        _.each(modalities, function (data) {
                            series.push({
                                type: "bar",
                                xKey: xKey,
                                yKey: data,
                                yName: data.toUpperCase(),
                                stacked: true,
                                listeners: { nodeClick: nodeClick },
                                tooltip: createTooltip(type),
                            });
                        });
                        break;
                    case "PatientClass":
                        series = [];
                        _.each(PatientClassList, function (data) {
                            series.push({
                                type: "bar",
                                xKey: xKey,
                                yKey: data,
                                yName: data,
                                stacked: true,
                                listeners: { nodeClick: nodeClick },
                                tooltip: createTooltip(type)
                            });
                        });
                        break;
                    case "ModalityCount":
                        series = [
                            {
                                type: graphType,
                                xKey: xKey,
                                yKey: 'ModalityCount',
                                yName: 'Modality Count',
                                stacked: true,
                                tooltip: createTooltip(type)
                            },
                        ];
                        break;
                    case "PatientClassCount":
                        series = [
                            {
                                type: graphType,
                                xKey: xKey,
                                yKey: 'PatientClassCount',
                                yName: 'Patient Class Count',
                                stacked: true,
                                tooltip: createTooltip(type),
                            }
                        ];
                        break;
                    case "HideStudyCount":
                        series = [
                            {
                                type: 'line',
                                xKey: xKey,
                                yKey: 'HideStudyCount',
                                yName: 'Hide Study Count',
                                listeners: { nodeClick: nodeClick },
                                stacked: true,
                                tooltip: createTooltip(type),
                                marker: { size: 13, },
                            }
                        ];
                        break;
                    case "PeerReviewLocationRadiologist":
                        series = [
                            {
                                type: "bar",
                                xKey: xKey,
                                yKey: "CompleteCount",
                                yName: "Complete Count",
                                stacked: true,
                                tooltip: createTooltip(type),
                                listeners: { nodeClick: nodeClick },
                            },
                            {
                                type: "bar",
                                xKey: xKey,
                                yKey: "PendingCount",
                                yName: "Pending Count",
                                stacked: true,
                                tooltip: createTooltip(type),
                                listeners: { nodeClick: nodeClick },
                            },
                        ];
                        break;
                }
                if (seriesField == "Modality") {
                    series.push({
                        type: "line",
                        xKey: xKey,
                        yKey: 'SumOfModality',
                        yName: 'Sum Of Modality',
                        listeners: { nodeClick: nodeClick },
                        tooltip: createTooltip(type),
                        marker: { size: 13, },
                    });
                }
                if (seriesField != "HideStudyCount" && seriesField != "PeerReviewLocationRadiologist") {
                    series.push({
                        type: "line",
                        xKey: xKey,
                        yKey: 'SumOfRVU',
                        yName: 'Sum Of RVU',
                        listeners: { nodeClick: nodeClick },
                        tooltip: createTooltip(type),
                        marker: { size: 13, },
                    });
                }

            }
            return series;
        }

        function createTooltip(type) {
            return {
                renderer: function (params) {
                    var content = 0;
                    if (type == "TAT") {
                        switch (params.yKey) {
                            case "Routine":
                                var hours = Math.floor(params.datum.Routine / 60);
                                var minutes = params.datum.Routine % 60;
                                content = hours + "HR " + minutes + "MIN";
                                break;
                            case "STAT":
                                var hours = Math.floor(params.datum.STAT / 60);
                                var minutes = params.datum.STAT % 60;
                                content = hours + "HR " + minutes + "MIN";
                                break;
                            case "TAT":
                                var hours = Math.floor(params.datum.TAT / 60);
                                var minutes = params.datum.TAT % 60;
                                content = hours + "HR " + minutes + "MIN";
                                break;
                            default:
                                content = params.datum[params.xKey] + ": " + params.datum[params.yKey];
                        }
                    } else {
                        content = params.datum[params.xKey] + ": " + params.datum[params.yKey];
                    }
                    return {
                        title: params.yName,
                        data: [
                            {
                                value: content,
                            },
                        ],
                    };
                }
            }
        }
        function nodeClick(params) {
            if (params.datum.RadiologistLocation) {
                var timeout = $timeout(function () {
                    $scope.DataObject.SelectedRadiologist = params.datum.Radiologist;
                    if ($scope.DataObject.ActiveSection == "RadiologistVolByLoc") {
                        GetRadiologistVolByLocation("Modality");
                        GetRadiologistVolByLocation("MonthsName");
                    }
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            else if (params.datum.Location) {
                var timeout = $timeout(function () {

                    $scope.DataObject.SelectedLocation = params.datum.Location;

                    if ($scope.DataObject.ActiveSection == "LocationVolume") {
                        GetVolPriorityGroupByMonth();
                        GetVolumeByModalityGroup();
                    }
                    else if ($scope.DataObject.ActiveSection == "ModalityByLocationVolume") {
                        ModalityVolByLoc("MonthsName");
                        GetSubChartVolByPatientClass();
                    }
                    else if ($scope.DataObject.ActiveSection == "PatientClassByLocationVolume") {
                        PatientClassVolByLoc("MonthsName");
                        GetSubChartVolByModality();
                    }
                    else if ($scope.DataObject.ActiveSection == "HiddenVolumeByLocation") {
                        GetHiddenVolumeByLocation("day")
                    }
                    else if ($scope.DataObject.ActiveSection == "TATStudyCountByHourLocation") {
                        GetTATStudyCountByHourLocation(($scope.DataObject.isDOSorSignedDate == 'DOS') ? 'DOS' : 'SignDate');
                        GetTATStudyCountByHourLocation(($scope.DataObject.isDOSorSignedDate == 'DOS') ? 'DOSHour' : 'SignDateHour');
                    }
                    else if ($scope.DataObject.ActiveSection == "AddendumListVolume") {
                        GetAddedumRequestedList("AddendumRequestedBy");
                        GetAddedumRequestedList("AddendumRequestedTo");
                    }
                    else if ($scope.DataObject.ActiveSection == "LocationTAT" || $scope.DataObject.ActiveSection == "RadiologistTAT") {
                        GetAvgTATByModality();
                        GetAvgTATByPatientClass();
                        GetAvgTATByPatientClassModality();
                    }

                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            else if (params.datum.Radiologist) {
                var timeout = $timeout(function () {

                    $scope.DataObject.SelectedRadiologist = params.datum.Radiologist;

                    if ($scope.DataObject.ActiveSection == "RadiologistVolume") {
                        GetVolPriorityGroupByMonth();
                        GetVolumeByModalityGroup();
                    }
                    else if ($scope.DataObject.ActiveSection == "ModalityByRadiologistVolume") {
                        GetModalityVolByRadiologist("MonthsName");
                        GetSubChartVolByPatientClass();
                    }
                    else if ($scope.DataObject.ActiveSection == "PatientClassByRadiologistVolume") {
                        GetPatientClassVolByRadiologist("MonthsName");
                        GetSubChartVolByModality();
                    }
                    else if ($scope.DataObject.ActiveSection == "LocationTAT" || $scope.DataObject.ActiveSection == "RadiologistTAT") {
                        GetAvgTATByModality();
                        GetAvgTATByPatientClass();
                        GetAvgTATByPatientClassModality();
                    }
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
        }

        function getChartOptionAxes(type, seriesField) {
            var axes = [];
            if (type == 'TAT') {
                axes = [
                    {
                        type: "category",
                        position: "bottom",
                        crosshair: {
                            enabled: true,
                            label: {
                                renderer: function (params) {
                                    return {
                                        text: params.value,
                                        backgroundColor: '#059780',
                                    }
                                },
                            }
                        }
                    },
                    {
                        type: "number",
                        position: "left",
                        title: {
                            text: (type == "Volume") ? "Count" : "Time",
                        },
                        label: {
                            formatter: function (params) {
                                if (type == "TAT" && params.value > 0) {
                                    var hours = Math.floor(params.value / 60);
                                    var minutes = params.value % 60;

                                    return hours + "HR " + minutes + "MIN";
                                } else {
                                    return params.value;
                                }
                            },
                        },
                        nice: true,
                        crosshair: createCrosshair(type),
                    },
                ];
            }
            else {
                axes = [
                    {
                        type: (seriesField == "HiddenStudyCountByDay") ? "time" : "category",
                        position: "bottom",
                        crosshair: createCrosshair()
                    },
                    {
                        type: "number",
                        position: "left",
                        title: {
                            text: "Count"
                        },
                        crosshair: createCrosshair()
                    },

                ];

                if (seriesField == "HiddenStudyCountByDay") {
                    axes[0].tick = {
                        minSpacing: 10,
                        maxSpacing: 200,
                    };
                }
            }
            return axes;
        }

        function getChartOptionOverlays() {
            return {
                noData: {
                    renderer: function () { return '<span style="align-items: center; box-sizing: border-box; display: flex; justify-content: center; margin: 8px; height: 100%; font: 18px Verdana, sans-serif; color:white;">No data available.</span>'; },
                },
            };
        }
        function createCrosshair(type) {
            return {
                enabled: true,
                label: {
                    renderer: function (params) {
                        var textValue = "";
                        if (type == "TAT" && params.value > 0) {
                            var hours = Math.floor(params.value / 60);
                            var minutes = params.value % 60;

                            textValue = hours + "HR " + minutes + "MIN";
                        } else {
                            textValue = params.value;
                        }
                        return {
                            text: textValue,
                            backgroundColor: '#059780',
                        }
                    },
                }
            }
        }
        var chartOptionsList = {
            //Location TAT
            UserAnalyticsChartOptionsByLoc: createChartOptions("Location", "TAT", "AvgTAT"),
            //Radiologist TAT
            UserAnalyticsChartOptionsByRadiologist: createChartOptions("Radiologist", "TAT", "AvgTAT"),
            //Average TAT By Modalities
            UserAnalyticsChartOptionsByModality: createChartOptions("Modality", "TAT", "AvgTAT"),
            //Average TAT By Patient Class
            UserAnalyticsChartOptionsByPatientClass: createChartOptions("PatientClass", "TAT", "AvgTAT"),
            //Average TAT By PatientClass & Modality
            UserAnalyticsChartOptionsByPatientClassModality: createChartOptions("PatientClassModality", "TAT", "AvgTAT"),
            //Location Volume By Priority
            VolumeByLocChartOption: createChartOptions("Location", "Volume", "TATCounts"),
            //Location Volume By Modality
            ModalityByLocChartOption: createChartOptions("Location", "Volume", "Modality"),
            //Location Volume By Patient Class
            PatientClassByLocChartOption: createChartOptions("Location", "Volume", "PatientClass"),
            //Radiologist Volume By Priority
            VolumeByRadiologistChartOption: createChartOptions("Radiologist", "Volume", "TATCounts"),
            //Radiologist Volume By Modality
            ModalityByRadiologistChartOption: createChartOptions("Radiologist", "Volume", "Modality"),
            //Radiologist Volume By Patient Class
            PatientClassByRadiologistChartOption: createChartOptions("Radiologist", "Volume", "PatientClass"),
            //Months Group By Volume Priority
            MonthsGroupByLocVolChartOption: createChartOptions("MonthsName", "Volume", "TATCounts"),
            //Months Group By Volume Priority Radiologist
            MonthsGroupByRadVolChartOption: createChartOptions("MonthsName", "Volume", "TATCounts"),
            //Months Group By Volume Modality Radiologist
            ModalityGroupByMonthChartOption: createChartOptions("Modality", "Volume", "ModalityCount"),
            //Radiologist Volume By Modality Group
            RadVolumeByModalityGroupChartOption: createChartOptions("Modality", "Volume", "ModalityCount"),
            //Location Modality Volume By Month
            LocModalityVolByMonthChartOption: createChartOptions("MonthsName", "Volume", "ModalityCount"),
            //Radiologist Modality Volume By Month
            RadModalityVolByMonthChartOption: createChartOptions("MonthsName", "Volume", "ModalityCount"),
            //Location Patient Class Volume By Month
            LocPatientClassVolByMonthChartOption: createChartOptions("MonthsName", "Volume", "PatientClassCount"),
            //Radiologist Patient Class Volume By Month
            RadPatientClassVolByMonthChartOption: createChartOptions("MonthsName", "Volume", "PatientClassCount"),
            //Sub Chart Location Volume By Modality
            SubChartLocVolByModalityChartOption: createChartOptions("Location", "Volume", "TATCounts"),
            //Sub Chart Radiologist Volume By Modality
            SubChartRadVolByModalityChartOption: createChartOptions("Radiologist", "Volume", "TATCounts"),
            //Sub Chart Location Volume By Patient Class
            SubChartLocVolByPCChartOption: createChartOptions("PatientClass", "Volume", "PatientClassCount"),
            //Sub Chart Radiologist Volume By Patient Class
            SubChartRadVolByPCChartOption: createChartOptions("PatientClass", "Volume", "PatientClassCount"),
            //Hidden Volume By Location
            HiddenVolByLocChartOption: createChartOptions("Location", "Volume", "HideStudyCount"),
            //Location Hidden Volume By Months
            LocHiddenVolByMonthChartOption: createChartOptions("", "Volume", "HiddenStudyCountByDay"),

            PeerReviewLocationChartOption: createChartOptions("Location", "Volume", "PeerReviewLocationRadiologist"),
            PeerReviewRadiologistChartOption: createChartOptions("Radiologist", "Volume", "PeerReviewLocationRadiologist"),

            AddendumListByLocChartOption: createChartOptions("Location", "Volume", "PeerReviewLocationRadiologist"),
            AddendumListByRadChartOption: createChartOptions("AddendumRequestedBy", "Volume", "PeerReviewLocationRadiologist"),
            AddendumListToRadChartOption: createChartOptions("AddendumRequestedTo", "Volume", "PeerReviewLocationRadiologist"),


            TATCountDOSLocChartOption: {
                theme: getChartOptionTheme("Volume", "TATCountDOSLoc"),
                background: {
                    fill: "#2d3436",
                },
                data: [],
                axes: [
                    {
                        type: "category",
                        position: "bottom",
                        crosshair: createCrosshair()
                    },
                    {
                        type: "number",
                        position: "left",
                        title: {
                            text: "Count"
                        },
                        crosshair: createCrosshair()
                    },

                ],
                overlays: getChartOptionOverlays(),
                zoom: {
                    enabled: true,
                    axes: "xy",
                    anchorPointX: "pointer",
                    anchorPointY: "pointer",
                },
                navigator: {
                    enabled: false,
                },
                legend: {
                    item: {
                        marker: {
                            shape: "circle",
                        },
                    },
                },
            },
            TATCountByDOSChartOption: {
                theme: getChartOptionTheme("Volume", "TATCountDOSLoc"),
                background: {
                    fill: "#2d3436",
                },
                data: [],
                axes: [
                    {
                        type: "time",
                        position: "bottom",
                        crosshair: createCrosshair(),
                        tick: {
                            minSpacing: 10,
                            maxSpacing: 200,
                        }
                    },
                    {
                        type: "number",
                        position: "left",
                        title: {
                            text: "Count"
                        },
                        crosshair: createCrosshair()
                    },

                ],
                overlays: getChartOptionOverlays(),
                zoom: {
                    enabled: true,
                    axes: "xy",
                    anchorPointX: "pointer",
                    anchorPointY: "pointer",
                    rangeX: {
                        start: $filter('CSTDateTime')($scope.DataObject.datePicker.startDate),
                        end: $filter('CSTDateTime')($scope.DataObject.datePicker.endDate),
                    },
                },
                navigator: {
                    enabled: false,
                },
                legend: {
                    item: {
                        marker: {
                            shape: "circle",
                        },
                    },
                },
            },
            TATCountByHourChartOption: {
                theme: getChartOptionTheme("Volume", "TATCountDOSLoc"),
                background: {
                    fill: "#2d3436",
                },
                data: [],
                axes: [
                    {
                        type: "category",
                        position: "bottom",
                        title: {
                            text: "Hour"
                        },
                        crosshair: createCrosshair(),
                        label: {
                            formatter: function (params) {
                                if (params.value > 12) {
                                    return (params.value - 12) + ":00 PM";
                                } else {
                                    return params.value + ":00 AM";
                                }
                            },
                        },
                    },
                    {
                        type: "number",
                        position: "left",
                        title: {
                            text: "Count"
                        },
                        crosshair: createCrosshair()
                    },

                ],
                overlays: getChartOptionOverlays(),
                zoom: {
                    enabled: true,
                    axes: "xy",
                    anchorPointX: "pointer",
                    anchorPointY: "pointer",
                },
                navigator: {
                    enabled: false,
                },
                legend: {
                    item: {
                        marker: {
                            shape: "circle",
                        },
                    },
                },
            },
            TATCountByDOSAndLocChartOption: {
                theme: getChartOptionTheme("Volume", "TATCountDOSLoc"),
                background: {
                    fill: "#2d3436",
                },
                data: [],
                axes: [
                    {
                        type: "time",
                        position: "bottom",
                        crosshair: createCrosshair(),
                        tick: {
                            minSpacing: 10,
                            maxSpacing: 200,
                        }
                    },
                    {
                        type: "number",
                        position: "left",
                        title: {
                            text: "Count"
                        },
                        crosshair: createCrosshair()
                    },

                ],
                overlays: getChartOptionOverlays(),
                zoom: {
                    enabled: true,
                    axes: "xy",
                    anchorPointX: "pointer",
                    anchorPointY: "pointer",
                    rangeX: {
                        start: $filter('CSTDateTime')($scope.DataObject.datePicker.startDate),
                        end: $filter('CSTDateTime')($scope.DataObject.datePicker.endDate),
                    },
                },
                navigator: {
                    enabled: false,
                },
                legend: {
                    item: {
                        marker: {
                            shape: "circle",
                        },
                    },
                },
            },
            PeerReviewPendingSinceByLocChartOption: {
                theme: getChartOptionTheme("Volume", "TATCountDOSLoc"),
                background: {
                    fill: "#2d3436",
                },
                data: [],
                axes: [
                    {
                        type: "time",
                        position: "bottom",
                        crosshair: createCrosshair(),
                        title: {
                            text: "Peer Review Created Date"
                        },
                        tick: {
                            minSpacing: 10,
                            maxSpacing: 200,
                        }
                    },
                    {
                        type: "number",
                        position: "left",
                        title: {
                            text: "Count"
                        },
                        crosshair: createCrosshair()
                    },

                ],
                overlays: getChartOptionOverlays(),
                zoom: {
                    enabled: true,
                    anchorPointX: "pointer",
                    anchorPointY: "pointer",
                    autoScaling: {
                        enabled: true,
                    },
                },
                navigator: {
                    enabled: false,
                },
                legend: {
                    item: {
                        marker: {
                            shape: "circle",
                        },
                    },
                },
            },
            PeerReviewPendingSinceByRadChartOption: {
                theme: getChartOptionTheme("Volume", "TATCountDOSLoc"),
                background: {
                    fill: "#2d3436",
                },
                data: [],
                axes: [
                    {
                        type: "time",
                        position: "bottom",
                        crosshair: createCrosshair(),
                        title: {
                            text: "Peer Review Created Date"
                        },
                        tick: {
                            minSpacing: 10,
                            maxSpacing: 200,
                        }
                    },
                    {
                        type: "number",
                        position: "left",
                        title: {
                            text: "Count"
                        },
                        crosshair: createCrosshair()
                    },

                ],
                overlays: getChartOptionOverlays(),
                zoom: {
                    enabled: true,
                    anchorPointX: "pointer",
                    anchorPointY: "pointer",
                    autoScaling: {
                        enabled: true,
                    },
                },
                navigator: {
                    enabled: false,
                },
                legend: {
                    item: {
                        marker: {
                            shape: "circle",
                        },
                    },
                },
            },
            RadiologistVolByLocChartOptions: {
                theme: {
                    baseTheme: 'ag-default-dark',
                },
                background: {
                    fill: "#2d3436",
                },
                navigator: {
                    enabled: false,
                },
                data: [],
                series: [
                    {
                        type: 'bar',
                        xKey: 'RadiologistLocation',
                        yKey: 'SumOfRVU',
                        yName: 'Sum of wRVU',
                        stacked: true,
                        listeners: { nodeClick: nodeClick }
                    },
                    {
                        type: 'bar',
                        xKey: 'RadiologistLocation',
                        yKey: 'StudyCount',
                        yName: 'Study Count',
                        stacked: true,
                        listeners: { nodeClick: nodeClick }
                    },

                ],
                axes: [
                    {
                        type: "grouped-category",
                        position: "bottom",
                        label: { rotation: 0 },
                        depthOptions: [{}, { label: { fontWeight: "bold" } }],
                    },
                    { type: "number", position: "left" },
                ],
            },
            RadiologistVolByLocModalityChartOptions: {
                theme: {
                    baseTheme: 'ag-default-dark',
                },
                background: {
                    fill: "#2d3436",
                },
                navigator: {
                    enabled: false,
                },
                data: [],
                series: [
                    {
                        type: 'bar',
                        xKey: 'ModalityLocation',
                        yKey: 'SumOfRVU',
                        yName: 'Sum of wRVU',
                        stacked: true,
                    },
                    {
                        type: 'bar',
                        xKey: 'ModalityLocation',
                        yKey: 'ModalityCount',
                        yName: 'Modality Count',
                        stacked: true,
                    },

                ],
                axes: [
                    {
                        type: "grouped-category",
                        position: "bottom",
                        label: { rotation: 0 },
                        depthOptions: [{}, { label: { fontWeight: "bold" } }],
                    },
                    { type: "number", position: "left" },
                ],
            },
            RadiologistVolByLocMonthChartOptions: {
                theme: {
                    baseTheme: 'ag-default-dark',
                },
                background: {
                    fill: "#2d3436",
                },
                navigator: {
                    enabled: false,
                },
                data: [],
                series: [
                    {
                        type: 'bar',
                        xKey: 'MonthsLocation',
                        yKey: 'SumOfRVU',
                        yName: 'Sum of wRVU',
                        stacked: true,
                    },
                    {
                        type: 'bar',
                        xKey: 'MonthsLocation',
                        yKey: 'StudyCount',
                        yName: 'Study Count',
                        stacked: true,
                    },

                ],
                axes: [
                    {
                        type: "grouped-category",
                        position: "bottom",
                        label: { rotation: 0 },
                        depthOptions: [{}, { label: { fontWeight: "bold" } }],
                    },
                    { type: "number", position: "left" },
                ],
            }
        }

        //#endregion Chartoptions declarations
        function pageInit() {
            $scope.DataObject.DateFilterTooltip = moment($scope.DataObject.datePicker.startDate).format('MM/DD/YYYY') + " - " + moment($scope.DataObject.datePicker.endDate).format('MM/DD/YYYY');
            $q.all([
                GetSitesAndLocation(),
                initModalityAndPatientClassGridAndChart(),
                GetUserLayoutPreferences()
            ]).then(function () {
                $scope.ChangeActiveSection(layoutPref.ActiveSection);
            });
        }
        $scope.ChangeActiveSection = function (section) {
            if (section != $scope.DataObject.ActiveSection) {
                $scope.DataObject.Tabs = setChartTabAsDefault();
            }
            resetChartOption();
            $scope.DataObject.ActiveSection = section;
            $scope.DataObject.SelectedRadiologist = null;
            $scope.DataObject.SelectedLocation = null;

            initializeUserAnalyticsChartAndGrid(section).then(function () {
                $scope.hideShowChartNavigator();
                ApplyActiveSecion(section);
            });

        }
        function ApplyActiveSecion(section) {

            switch (section) {
                case "LocationTAT":
                    GetAvgTATByLocation();
                    GetAvgTATByModality();
                    GetAvgTATByPatientClass();
                    GetAvgTATByPatientClassModality();
                    break;
                case "RadiologistTAT":
                    GetAvgTATByRadiologist();
                    GetAvgTATByModality();
                    GetAvgTATByPatientClass();
                    GetAvgTATByPatientClassModality();
                    break;
                case "LocationVolume":
                    GetVolumeByLocation();
                    GetVolPriorityGroupByMonth();
                    GetVolumeByModalityGroup();
                    break;
                case "ModalityByLocationVolume":
                    ModalityVolByLoc();
                    ModalityVolByLoc("MonthsName");
                    GetSubChartVolByPatientClass();
                    break;
                case "PatientClassByLocationVolume":
                    PatientClassVolByLoc();
                    PatientClassVolByLoc("MonthsName");
                    GetSubChartVolByModality();
                    break;
                case "RadiologistVolume":
                    GetVolumeByRadiologist();
                    GetVolPriorityGroupByMonth();
                    GetVolumeByModalityGroup();
                    break;
                case "ModalityByRadiologistVolume":
                    GetModalityVolByRadiologist();
                    GetModalityVolByRadiologist("MonthsName");
                    GetSubChartVolByPatientClass();
                    break;
                case "PatientClassByRadiologistVolume":
                    GetPatientClassVolByRadiologist();
                    GetPatientClassVolByRadiologist("MonthsName");
                    GetSubChartVolByModality();
                    break;
                case "HiddenVolumeByLocation":
                    GetHiddenVolumeByLocation();
                    GetHiddenVolumeByLocation("day");
                    break;
                case "TATStudyCountByHourLocation":
                    GetTATStudyCountByHourLocation("Location");
                    GetTATStudyCountByHourLocation(($scope.DataObject.isDOSorSignedDate == 'DOS') ? 'DOS' : 'SignDate', "Location");
                    break;

                case "PeerReviewLocation":
                    GetPeerReviewByLocationRadiologist("Location");
                    GetPeerReviewByLocationRadiologist("Radiologist");
                    break;
                case "PeerReviewPendingSince":
                    GetPeerReviewByDayLocationRadiologist("Location");
                    GetPeerReviewByDayLocationRadiologist("Radiologist");
                    break;
                case "AddendumListVolume":
                    GetAddedumRequestedList("Location");
                    GetAddedumRequestedList("AddendumRequestedBy");
                    GetAddedumRequestedList("AddendumRequestedTo");
                    break;
                case "RadiologistVolByLoc":
                    GetRadiologistVolByLocation();
                    GetRadiologistVolByLocation("Modality");
                    GetRadiologistVolByLocation("MonthsName");
                    break;
            }

            var updatePref = false;
            if (layoutPref.ActiveSection != $scope.DataObject.ActiveSection) {
                layoutPref.ActiveSection = $scope.DataObject.ActiveSection;
                updatePref = true;
            }
            if (!(_.isEqual(layoutPref.Tabs, $scope.DataObject.Tabs))) {
                var keyList = Object.keys(layoutPref.Tabs);
                if (keyList.length > 0) {
                    _.each(keyList, function (key) {
                        layoutPref.Tabs[key] = $scope.DataObject.Tabs[key];
                    });
                    updatePref = true;
                }
            }
            if (!layoutPref.filter.datePicker || (layoutPref.filter.datePicker != $scope.DataObject.datePicker)) {
                if ($scope.DataObject.datePicker.label == "Custom range") {
                    layoutPref.filter.datePicker = $scope.DataObject.datePicker;
                } else {
                    layoutPref.filter.datePicker = { label: $scope.DataObject.datePicker.label };
                }
                updatePref = true;
            }

            if (!layoutPref.filter.SelectedLocations || (!(_.isEqual(layoutPref.filter.SelectedLocations, $scope.DataObject.SelectedLocations)))) {
                layoutPref.filter.SelectedLocations = _.cloneDeep($scope.DataObject.SelectedLocations);
                updatePref = true;
            }
            if (updatePref) {
                updateUserLayoutPreference();
            }
        }
        //#region Grid and Chart initilization
        function initModalityAndPatientClassGridAndChart() {
            var d = $q.defer();

            var timeout = $timeout(function () {

                var gridDiv = document.querySelector('#UserAnalyticsGridByModality');
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, gridOptionsByModality);
                }
                gridDiv = document.querySelector('#UserAnalyticsGridByPatientClass');
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, gridOptionsByPatientClass);
                }

                gridDiv = document.querySelector('#UserAnalyticsGridByPatientClassModality');
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, gridOptionsByPatientClassModality);
                }

                chartOptionsList.UserAnalyticsChartOptionsByModality.container = document.getElementById('UserAnalyticsChartByModality');
                chartList.UserAnalyticsChartByModality = agCharts.AgCharts.create(chartOptionsList.UserAnalyticsChartOptionsByModality);

                chartOptionsList.UserAnalyticsChartOptionsByPatientClass.container = document.getElementById('UserAnalyticsChartByPatientClass');
                chartList.UserAnalyticsChartByPatientClass = agCharts.AgCharts.create(chartOptionsList.UserAnalyticsChartOptionsByPatientClass);

                chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.container = document.getElementById('UserAnalyticsChartByPatientClassModality');
                chartList.UserAnalyticsChartByPatientClassModality = agCharts.AgCharts.create(chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality);

                $timeout.cancel(timeout);
                timeout = null;
                d.resolve();
            });
            return d.promise;
        }

        function initializeUserAnalyticsChartAndGrid(section) {
            var d = $q.defer();
            switch (section) {
                case "LocationTAT":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#UserAnalyticsGridByLoc');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, gridOptionsByLoc);
                        }

                        chartOptionsList.UserAnalyticsChartOptionsByLoc.container = document.getElementById('UserAnalyticsChartByLoc');
                        chartList.UserAnalyticsChartByLoc = agCharts.AgCharts.create(chartOptionsList.UserAnalyticsChartOptionsByLoc);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    }, 100);
                    break;

                case "RadiologistTAT":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#UserAnalyticsGridByRadiologist');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, gridOptionsByRadiologist);
                        }

                        chartOptionsList.UserAnalyticsChartOptionsByRadiologist.container = document.getElementById('UserAnalyticsChartByRadiologist');
                        chartList.UserAnalyticsChartByRadiologist = agCharts.AgCharts.create(chartOptionsList.UserAnalyticsChartOptionsByRadiologist);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    }, 100);
                    break;

                case "LocationVolume":
                    var timeout = $timeout(function () {


                        var gridDiv = document.querySelector('#VolumeByLocGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, VolumeByLocGridOptions);
                        }

                        gridDiv = document.querySelector('#MonthsGroupByLocVolGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, MonthsGroupByLocVolGridOptions);
                        }

                        gridDiv = document.querySelector('#ModalityGroupByMonthGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, ModalityGroupByMonthGridOptions);
                        }

                        chartOptionsList.VolumeByLocChartOption.container = document.getElementById('VolumeByLocChart');
                        chartList.VolumeByLocChart = agCharts.AgCharts.create(chartOptionsList.VolumeByLocChartOption);

                        chartOptionsList.MonthsGroupByLocVolChartOption.container = document.getElementById('MonthsGroupByLocVolChart');
                        chartList.MonthsGroupByLocVolChart = agCharts.AgCharts.create(chartOptionsList.MonthsGroupByLocVolChartOption);

                        chartOptionsList.ModalityGroupByMonthChartOption.container = document.getElementById('ModalityGroupByMonthChart');
                        chartList.ModalityGroupByMonthChart = agCharts.AgCharts.create(chartOptionsList.ModalityGroupByMonthChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    }, 100);
                    break;

                case "ModalityByLocationVolume":
                    var timeout = $timeout(function () {
                        var gridDiv = document.querySelector('#ModalityByLocGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, ModalityByLocGridOptions);
                        }

                        gridDiv = document.querySelector('#LocModalityVolByMonthGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, LocModalityVolByMonthGridOption);
                        }

                        gridDiv = document.querySelector('#SubChartLocVolByPCGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, SubChartLocVolByPCGridOption);
                        }

                        chartOptionsList.ModalityByLocChartOption.container = document.getElementById('ModalityByLocChart');
                        chartList.ModalityByLocChart = agCharts.AgCharts.create(chartOptionsList.ModalityByLocChartOption);

                        chartOptionsList.LocModalityVolByMonthChartOption.container = document.getElementById('LocModalityVolByMonthChart');
                        chartList.LocModalityVolByMonthChart = agCharts.AgCharts.create(chartOptionsList.LocModalityVolByMonthChartOption);

                        chartOptionsList.SubChartLocVolByPCChartOption.container = document.getElementById('SubChartLocVolByPCChart');
                        chartList.SubChartLocVolByPCChart = agCharts.AgCharts.create(chartOptionsList.SubChartLocVolByPCChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    }, 100);

                    break;

                case "PatientClassByLocationVolume":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#PatientClassByLocGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, PatientClassByLocGridOptions);
                        }

                        gridDiv = document.querySelector('#LocPatientClassVolByMonthGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, LocPatientClassVolByMonthGridOption);
                        }

                        gridDiv = document.querySelector('#SubChartLocVolByModalityGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, SubChartLocVolByModalityGridOption);
                        }

                        chartOptionsList.PatientClassByLocChartOption.container = document.getElementById('PatientClassByLocChart');
                        chartList.PatientClassByLocChart = agCharts.AgCharts.create(chartOptionsList.PatientClassByLocChartOption);

                        chartOptionsList.LocPatientClassVolByMonthChartOption.container = document.getElementById('LocPatientClassVolByMonthChart');
                        chartList.LocPatientClassVolByMonthChart = agCharts.AgCharts.create(chartOptionsList.LocPatientClassVolByMonthChartOption);

                        chartOptionsList.SubChartLocVolByModalityChartOption.container = document.getElementById('SubChartLocVolByModalityChart');
                        chartList.SubChartLocVolByModalityChart = agCharts.AgCharts.create(chartOptionsList.SubChartLocVolByModalityChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    }, 100);
                    break;

                case "RadiologistVolume":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#VolumeByRadGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, VolumeByRadiologistGridOptions);
                        }

                        gridDiv = document.querySelector('#MonthsGroupByRadVolGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, MonthsGroupByRadVolGridOptions);
                        }

                        gridDiv = document.querySelector('#RadVolumeByModalityGroupGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, RadVolumeByModalityGroupGridOptions);
                        }

                        chartOptionsList.VolumeByRadiologistChartOption.container = document.getElementById('VolumeByRadChart');
                        chartList.VolumeByRadiologistChart = agCharts.AgCharts.create(chartOptionsList.VolumeByRadiologistChartOption);


                        chartOptionsList.MonthsGroupByRadVolChartOption.container = document.getElementById('MonthsGroupByRadVolChart');
                        chartList.MonthsGroupByRadVolChart = agCharts.AgCharts.create(chartOptionsList.MonthsGroupByRadVolChartOption);

                        chartOptionsList.RadVolumeByModalityGroupChartOption.container = document.getElementById('RadVolumeByModalityGroupChart');
                        chartList.RadVolumeByModalityGroupChart = agCharts.AgCharts.create(chartOptionsList.RadVolumeByModalityGroupChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    }, 100);
                    break;

                case "ModalityByRadiologistVolume":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#ModalityByRadGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, ModalityByRadiologistGridOptions);
                        }
                        gridDiv = document.querySelector('#RadModalityVolByMonthGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, RadModalityVolByMonthGridOption);
                        }
                        gridDiv = document.querySelector('#SubChartRadVolByPCGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, SubChartRadVolByPCGridOption);
                        }

                        chartOptionsList.ModalityByRadiologistChartOption.container = document.getElementById('ModalityByRadChart');
                        chartList.ModalityByRadiologistChart = agCharts.AgCharts.create(chartOptionsList.ModalityByRadiologistChartOption);

                        chartOptionsList.RadModalityVolByMonthChartOption.container = document.getElementById('RadModalityVolByMonthChart');
                        chartList.RadModalityVolByMonthChart = agCharts.AgCharts.create(chartOptionsList.RadModalityVolByMonthChartOption);

                        chartOptionsList.SubChartRadVolByPCChartOption.container = document.getElementById('SubChartRadVolByPCChart');
                        chartList.SubChartRadVolByPCChart = agCharts.AgCharts.create(chartOptionsList.SubChartRadVolByPCChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    }, 100);
                    break;

                case "PatientClassByRadiologistVolume":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#PatientClassByRadGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, PatientClassByRadiologistGridOptions);
                        }

                        gridDiv = document.querySelector('#RadPatientClassVolByMonthGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, RadPatientClassVolByMonthGridOption);
                        }
                        gridDiv = document.querySelector('#SubChartRadVolByModalityGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, SubChartRadVolByModalityGridOption);
                        }

                        chartOptionsList.PatientClassByRadiologistChartOption.container = document.getElementById('PatientClassByRadChart');
                        chartList.PatientClassByRadiologistChart = agCharts.AgCharts.create(chartOptionsList.PatientClassByRadiologistChartOption);

                        chartOptionsList.RadPatientClassVolByMonthChartOption.container = document.getElementById('RadPatientClassVolByMonthChart');
                        chartList.RadPatientClassVolByMonthChart = agCharts.AgCharts.create(chartOptionsList.RadPatientClassVolByMonthChartOption);

                        chartOptionsList.SubChartRadVolByModalityChartOption.container = document.getElementById('SubChartRadVolByModalityChart');
                        chartList.SubChartRadVolByModalityChart = agCharts.AgCharts.create(chartOptionsList.SubChartRadVolByModalityChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    }, 100);
                    break;
                case "HiddenVolumeByLocation":
                    var timeout = $timeout(function () {


                        var gridDiv = document.querySelector('#HiddenVolByLocGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, HiddenVolByLocGridOption);
                        }
                        gridDiv = document.querySelector('#LocHiddenVolByMonthGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, LocHiddenVolByMonthGridOption);
                        }
                        chartOptionsList.HiddenVolByLocChartOption.container = document.getElementById('HiddenVolByLocChart');
                        chartList.HiddenVolByLocChart = agCharts.AgCharts.create(chartOptionsList.HiddenVolByLocChartOption);

                        chartOptionsList.LocHiddenVolByMonthChartOption.container = document.getElementById('LocHiddenVolByMonthChart');
                        chartList.LocHiddenVolByMonthChart = agCharts.AgCharts.create(chartOptionsList.LocHiddenVolByMonthChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    });
                    break;

                case "TATStudyCountByHourLocation":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#TATCountDOSLocGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, TATCountDOSLocGridOption);
                        }
                        gridDiv = document.querySelector('#TATCountByDOSGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, TATCountByDOSGridOption);
                        }

                        gridDiv = document.querySelector('#TATCountByHourGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, TATCountByHourGridOption);
                        }
                        gridDiv = document.querySelector('#TATCountByDOSAndLocGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, TATCountByDOSAndLocGridOption);
                        }

                        chartOptionsList.TATCountDOSLocChartOption.container = document.getElementById('TATCountDOSLocChart');
                        chartList.TATCountDOSLocChart = agCharts.AgCharts.create(chartOptionsList.TATCountDOSLocChartOption);

                        chartOptionsList.TATCountByDOSChartOption.container = document.getElementById('TATCountByDOSChart');
                        chartList.TATCountByDOSChart = agCharts.AgCharts.create(chartOptionsList.TATCountByDOSChartOption);

                        chartOptionsList.TATCountByHourChartOption.container = document.getElementById('TATCountByHourChart');
                        chartList.TATCountByHourChart = agCharts.AgCharts.create(chartOptionsList.TATCountByHourChartOption);


                        chartOptionsList.TATCountByDOSAndLocChartOption.container = document.getElementById('TATCountByDOSAndLocChart');
                        chartList.TATCountByDOSAndLocChart = agCharts.AgCharts.create(chartOptionsList.TATCountByDOSAndLocChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    });
                    break;

                case "PeerReviewLocation":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#PeerReviewLocationGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, PeerReviewLocationGridOption);
                        }
                        gridDiv = document.querySelector('#PeerReviewRadiologistGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, PeerReviewRadiologistGridOption);
                        }

                        chartOptionsList.PeerReviewLocationChartOption.container = document.getElementById('PeerReviewLocationChart');
                        chartList.PeerReviewLocationChart = agCharts.AgCharts.create(chartOptionsList.PeerReviewLocationChartOption);

                        chartOptionsList.PeerReviewRadiologistChartOption.container = document.getElementById('PeerReviewRadiologistChart');
                        chartList.PeerReviewRadiologistChart = agCharts.AgCharts.create(chartOptionsList.PeerReviewRadiologistChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    });
                    break;
                case "PeerReviewPendingSince":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#PeerReviewPendingSinceByLocGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, PeerReviewPendingSinceByLocGridOption);
                        }
                        gridDiv = document.querySelector('#PeerReviewPendingSinceByRadGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, PeerReviewPendingSinceByRadGridOption);
                        }

                        chartOptionsList.PeerReviewPendingSinceByLocChartOption.container = document.getElementById('PeerReviewPendingSinceByLocChart');
                        chartList.PeerReviewPendingSinceByLocChart = agCharts.AgCharts.create(chartOptionsList.PeerReviewPendingSinceByLocChartOption);
                        chartOptionsList.PeerReviewPendingSinceByRadChartOption.container = document.getElementById('PeerReviewPendingSinceByRadChart');
                        chartList.PeerReviewPendingSinceByRadChart = agCharts.AgCharts.create(chartOptionsList.PeerReviewPendingSinceByRadChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    });
                    break;
                case "AddendumListVolume":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#AddendumListByLocGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, AddendumListByLocGridOption);
                        }
                        gridDiv = document.querySelector('#AddendumListByRadGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, AddendumListByRadGridOption);
                        }
                        gridDiv = document.querySelector('#AddendumListToRadGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, AddendumListToRadGridOption);
                        }

                        chartOptionsList.AddendumListByLocChartOption.container = document.getElementById('AddendumListByLocChart');
                        chartList.AddendumListByLocChart = agCharts.AgCharts.create(chartOptionsList.AddendumListByLocChartOption);
                        chartOptionsList.AddendumListByRadChartOption.container = document.getElementById('AddendumListByRadChart');
                        chartList.AddendumListByRadChart = agCharts.AgCharts.create(chartOptionsList.AddendumListByRadChartOption);
                        chartOptionsList.AddendumListToRadChartOption.container = document.getElementById('AddendumListToRadChart');
                        chartList.AddendumListToRadChart = agCharts.AgCharts.create(chartOptionsList.AddendumListToRadChartOption);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    });
                    break;

                case "RadiologistVolByLoc":
                    var timeout = $timeout(function () {

                        var gridDiv = document.querySelector('#RadiologistVolByLocGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, RadiologistVolByLocGridOption);
                        }
                        gridDiv = document.querySelector('#RadiologistVolByLocModalityGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, RadiologistVolByLocModalityGridOption);
                        }
                        gridDiv = document.querySelector('#RadiologistVolByLocMonthsGrid');
                        if (gridDiv) {
                            new agGrid.Grid(gridDiv, RadiologistVolByLocMonthsGridOption);
                        }

                        chartOptionsList.RadiologistVolByLocChartOptions.container = document.getElementById('RadiologistVolByLocChart');
                        chartList.RadiologistVolByLocChart = agCharts.AgCharts.create(chartOptionsList.RadiologistVolByLocChartOptions);

                        chartOptionsList.RadiologistVolByLocModalityChartOptions.container = document.getElementById('RadiologistVolByLocModalityChart');
                        chartList.RadiologistVolByLocModalityChart = agCharts.AgCharts.create(chartOptionsList.RadiologistVolByLocModalityChartOptions);

                        chartOptionsList.RadiologistVolByLocMonthChartOptions.container = document.getElementById('RadiologistVolByLocMonthsChart');
                        chartList.RadiologistVolByLocMonthsChart = agCharts.AgCharts.create(chartOptionsList.RadiologistVolByLocMonthChartOptions);

                        $timeout.cancel(timeout);
                        timeout = null;
                        d.resolve();
                    });
                    break;

                default:
                    d.resolve();
            }
            return d.promise;
        }

        //#endregion Grid and Chart initilization

        //#region API calls for datatset for chart and Grid

        function GetAvgTATByLocation() {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;
            var params = {
                Group: "Location",
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };
            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            UserAnalyticsService.GetTATByLocationModalityPatientClassUser(params).then(function (result) {

                gridOptionsByLoc.api.setRowData(result);

                var max = 0;
                _.each(result, function (obj) {
                    obj.TAT = parseInt(obj.TAT);
                    obj.STAT = parseInt(obj.STAT);
                    obj.Routine = parseInt(obj.Routine);


                    var sum = obj.TAT + obj.STAT + obj.Routine;
                    if (sum > max) {
                        max = sum;
                    }
                });

                var interval = Math.round(max / 4);
                chartOptionsList.UserAnalyticsChartOptionsByLoc.axes[0].label = { rotation: -20 };
                chartOptionsList.UserAnalyticsChartOptionsByLoc.axes[1].tick = { interval: interval };

                chartOptionsList.UserAnalyticsChartOptionsByLoc.data = result;

                var params = chartOptionsList.UserAnalyticsChartOptionsByLoc.params;
                var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                _.each(seriesList, function (series) {
                    series.stacked = false;
                });
                chartOptionsList.UserAnalyticsChartOptionsByLoc.series = seriesList;

                chartList.UserAnalyticsChartByLoc.update(chartOptionsList.UserAnalyticsChartOptionsByLoc);

                $scope.DataObject.isLoading = false;


                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetAvgTATByRadiologist() {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;

            var params = {
                Group: "Radiologist",
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            }

            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            UserAnalyticsService.GetTATByLocationModalityPatientClassUser(params).then(function (result) {

                gridOptionsByRadiologist.api.setRowData(result);

                var max = 0;
                _.each(result, function (obj) {
                    obj.TAT = parseInt(obj.TAT);
                    obj.STAT = parseInt(obj.STAT);
                    obj.Routine = parseInt(obj.Routine);


                    var sum = obj.TAT + obj.STAT + obj.Routine;
                    if (sum > max) {
                        max = sum;
                    }
                });

                var interval = Math.round(max / 4);
                chartOptionsList.UserAnalyticsChartOptionsByRadiologist.axes[1].tick = { interval: interval };
                chartOptionsList.UserAnalyticsChartOptionsByRadiologist.axes[0].label = { rotation: -20 };

                chartOptionsList.UserAnalyticsChartOptionsByRadiologist.data = result;

                var params = chartOptionsList.UserAnalyticsChartOptionsByRadiologist.params;
                var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                _.each(seriesList, function (series) {
                    series.stacked = false;
                });
                chartOptionsList.UserAnalyticsChartOptionsByRadiologist.series = seriesList;

                chartList.UserAnalyticsChartByRadiologist.update(chartOptionsList.UserAnalyticsChartOptionsByRadiologist);

                $scope.DataObject.isLoading = false;

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetAvgTATByModality() {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;
            var params = {
                Group: "Modality",
                Location: $scope.DataObject.SelectedLocation,
                Radiologist: $scope.DataObject.SelectedRadiologist,
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };
            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            UserAnalyticsService.GetTATByLocationModalityPatientClassUser(params).then(function (result) {
                gridOptionsByModality.api.setRowData(result);

                var max = 0;
                _.each(result, function (obj) {
                    obj.TAT = parseInt(obj.TAT);
                    obj.STAT = parseInt(obj.STAT);
                    obj.Routine = parseInt(obj.Routine);


                    var sum = obj.TAT + obj.STAT + obj.Routine;
                    if (sum > max) {
                        max = sum;
                    }
                });

                var interval = Math.round(max / 4);
                chartOptionsList.UserAnalyticsChartOptionsByModality.axes[1].tick = { interval: interval };

                chartOptionsList.UserAnalyticsChartOptionsByModality.data = result;

                var params = chartOptionsList.UserAnalyticsChartOptionsByModality.params;
                var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                chartOptionsList.UserAnalyticsChartOptionsByModality.series = seriesList;

                chartList.UserAnalyticsChartByModality.update(chartOptionsList.UserAnalyticsChartOptionsByModality);


                $scope.DataObject.isLoading = false;

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetAvgTATByPatientClass() {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;

            var params = {
                Group: "PatientClass",
                Location: $scope.DataObject.SelectedLocation,
                Radiologist: $scope.DataObject.SelectedRadiologist,
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };
            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            UserAnalyticsService.GetTATByLocationModalityPatientClassUser(params).then(function (result) {
                gridOptionsByPatientClass.api.setRowData(result);

                var max = 0;
                _.each(result, function (obj) {
                    obj.TAT = parseInt(obj.TAT);
                    obj.STAT = parseInt(obj.STAT);
                    obj.Routine = parseInt(obj.Routine);


                    var sum = obj.TAT + obj.STAT + obj.Routine;
                    if (sum > max) {
                        max = sum;
                    }
                });

                var interval = Math.round(max / 4);
                chartOptionsList.UserAnalyticsChartOptionsByPatientClass.axes[1].tick = { interval: interval };
                chartOptionsList.UserAnalyticsChartOptionsByPatientClass.axes[0].label = { rotation: -20 };

                chartOptionsList.UserAnalyticsChartOptionsByPatientClass.data = result;

                var params = chartOptionsList.UserAnalyticsChartOptionsByPatientClass.params;
                var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                chartOptionsList.UserAnalyticsChartOptionsByPatientClass.series = seriesList;

                chartList.UserAnalyticsChartByPatientClass.update(chartOptionsList.UserAnalyticsChartOptionsByPatientClass);


                $scope.DataObject.isLoading = false;

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetAvgTATByPatientClassModality() {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;

            var params = {
                Group: "PatientClass",
                Location: $scope.DataObject.SelectedLocation,
                Radiologist: $scope.DataObject.SelectedRadiologist,
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
                Group1: "Modality",
            };
            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            UserAnalyticsService.GetTATByLocationModalityPatientClassUser(params).then(function (result) {
                _.each(result, function (res) {
                    res.PatientClassModality = (res.PatientClass != null ? res.PatientClass : "NA") + "-" + res.Modality;
                });
                gridOptionsByPatientClassModality.api.setRowData(result);

                var max = 0;
                _.each(result, function (obj) {
                    obj.TAT = parseInt(obj.TAT);
                    obj.STAT = parseInt(obj.STAT);
                    obj.Routine = parseInt(obj.Routine);


                    var sum = obj.TAT + obj.STAT + obj.Routine;
                    if (sum > max) {
                        max = sum;
                    }
                });

                var interval = Math.round(max / 4);

                _.each(result, function (res) {
                    res.PatientClassModality = [res.PatientClass != null ? res.PatientClass : "NA", res.Modality];
                });
                chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.axes[1].tick = { interval: interval };
                chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.axes[0].label = { rotation: -20 };
                chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.axes[0].type = "grouped-category";
                chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.axes[0].depthOptions = [{}, { label: { fontWeight: "bold" } }];

                chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.data = result;

                var params = chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.params;
                var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                _.each(seriesList, function (series) {
                    series.stacked = false;
                });
                chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.series = seriesList;

                chartList.UserAnalyticsChartByPatientClassModality.update(chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality);


                $scope.DataObject.isLoading = false;

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetVolumeByLocation() {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;

            var params = {
                SumOf: 'Priority',
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };

            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            UserAnalyticsService.GetVolumeByLocation(params).then(function (result) {
                VolumeByLocGridOptions.api.setRowData(result);

                var max = 0;
                var RoutineSum = 0;
                var STATSum = 0;
                var SumOfRVU = 0;

                _.each(result, function (obj) {
                    obj.STAT = parseInt(obj.STAT);
                    obj.Routine = parseInt(obj.Routine);

                    var sum = obj.STAT + obj.Routine;
                    if (sum > max) {
                        max = sum;
                    }

                    RoutineSum = (isNaN(obj.Routine)) ? RoutineSum : obj.Routine + RoutineSum;
                    STATSum = (isNaN(obj.STAT)) ? STATSum : obj.STAT + STATSum;
                    SumOfRVU = (isNaN(obj.SumOfRVU)) ? SumOfRVU : obj.SumOfRVU + SumOfRVU;
                });

                var interval = Math.round(max / 4);
                chartOptionsList.VolumeByLocChartOption.axes[1].tick = { interval: interval };


                chartOptionsList.VolumeByLocChartOption.data = result;

                var params = chartOptionsList.VolumeByLocChartOption.params;
                var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                chartOptionsList.VolumeByLocChartOption.series = seriesList;

                chartList.VolumeByLocChart.update(chartOptionsList.VolumeByLocChartOption);

                $scope.DataObject.isLoading = false;

                var row = {
                    "Location": null,
                    "Routine": RoutineSum,
                    "STAT": STATSum,
                    "SumOfRVU": parseFloat(SumOfRVU.toFixed(2)),
                    totalRowColor: totalRowColor,
                }
                VolumeByLocGridOptions.api.setPinnedBottomRowData([row]);

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function ModalityVolByLoc(Group) {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;

            var params = {
                SumOf: 'Modality',
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };

            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            if (Group == "MonthsName") {
                params.Group = Group;
                params.Location = $scope.DataObject.SelectedLocation;
            }
            UserAnalyticsService.GetVolumeByLocation(params).then(function (result) {
                if (Group == "MonthsName") {

                    var SumOfRVU = 0;
                    var TotalModalityCount = 0;

                    _.each(result, function (obj) {
                        SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                        TotalModalityCount = isNaN(obj.ModalityCount) ? TotalModalityCount : TotalModalityCount + obj.ModalityCount;
                    });

                    var row = {
                        MonthsName: null,
                        SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                        ModalityCount: TotalModalityCount,
                        totalRowColor: totalRowColor
                    }
                    LocModalityVolByMonthGridOption.api.setPinnedBottomRowData([row]);
                    LocModalityVolByMonthGridOption.api.setRowData(result);

                    chartOptionsList.LocModalityVolByMonthChartOption.data = result;

                    var params = chartOptionsList.LocModalityVolByMonthChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.LocModalityVolByMonthChartOption.series = seriesList;

                    chartList.LocModalityVolByMonthChart.update(chartOptionsList.LocModalityVolByMonthChartOption);
                }
                else {

                    var row = createPinnedFooterRowForModality(result);

                    ModalityByLocGridOptions.api.setPinnedBottomRowData([row]);

                    chartOptionsList.ModalityByLocChartOption.data = result;

                    var params = chartOptionsList.ModalityByLocChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.ModalityByLocChartOption.series = seriesList;

                    ModalityByLocGridOptions.api.setRowData(result);
                    chartList.ModalityByLocChart.update(chartOptionsList.ModalityByLocChartOption);
                }

                $scope.DataObject.isLoading = false;

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function PatientClassVolByLoc(Group) {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;
            var params = {
                SumOf: 'PatientClass',
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };

            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            if (Group == "MonthsName") {
                params.Group = Group;
                params.Location = $scope.DataObject.SelectedLocation;
            }

            UserAnalyticsService.GetVolumeByLocation(params).then(function (result) {
                if (Group == "MonthsName") {

                    var PatientClassCount = 0;
                    var SumOfRVU = 0;
                    _.each(result, function (obj) {
                        PatientClassCount = isNaN(obj.PatientClassCount) ? PatientClassCount : PatientClassCount + obj.PatientClassCount;
                        SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var row = {
                        MonthsName: null,
                        PatientClassCount: PatientClassCount,
                        SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor
                    }
                    LocPatientClassVolByMonthGridOption.api.setPinnedBottomRowData([row]);

                    LocPatientClassVolByMonthGridOption.api.setRowData(result);

                    var params = chartOptionsList.LocPatientClassVolByMonthChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.LocPatientClassVolByMonthChartOption.series = seriesList;

                    chartOptionsList.LocPatientClassVolByMonthChartOption.data = result;
                    chartList.LocPatientClassVolByMonthChart.update(chartOptionsList.LocPatientClassVolByMonthChartOption);
                }
                else {
                    var row = createPinnedFooterRowForPatientClass(result);
                    PatientClassByLocGridOptions.api.setPinnedBottomRowData([row]);

                    PatientClassByLocGridOptions.api.setRowData(result);

                    chartOptionsList.PatientClassByLocChartOption.data = result;

                    var params = chartOptionsList.PatientClassByLocChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.PatientClassByLocChartOption.series = seriesList;

                    chartList.PatientClassByLocChart.update(chartOptionsList.PatientClassByLocChartOption);
                }
                $scope.DataObject.isLoading = false;
                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetVolumeByRadiologist() {
            var d = $q.defer();
            $scope.DataObject.isLoading = true;

            var params = {
                SumOf: 'Priority',
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            }

            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            UserAnalyticsService.GetVolumeByRadiologist(params).then(function (result) {
                var max = 0;
                var TotalRoutine = 0;
                var TotalSTAT = 0;
                var SumOfRVU = 0;
                _.each(result, function (obj) {
                    obj.STAT = parseInt(obj.STAT);
                    obj.Routine = parseInt(obj.Routine);

                    var sum = obj.STAT + obj.Routine;
                    if (sum > max) {
                        max = sum;
                    }
                    TotalRoutine = (isNaN(obj.Routine)) ? TotalRoutine : TotalRoutine + obj.Routine;
                    TotalSTAT = (isNaN(obj.STAT)) ? TotalSTAT : TotalSTAT + obj.STAT;
                    SumOfRVU = (isNaN(obj.SumOfRVU)) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                });

                var row = {
                    Radiologist: null,
                    Routine: TotalRoutine,
                    STAT: TotalSTAT,
                    SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                    totalRowColor: totalRowColor
                }
                VolumeByRadiologistGridOptions.api.setPinnedBottomRowData([row]);
                VolumeByRadiologistGridOptions.api.setRowData(result);

                var interval = Math.round(max / 4);
                chartOptionsList.VolumeByRadiologistChartOption.axes[1].tick = { interval: interval };
                chartOptionsList.VolumeByRadiologistChartOption.axes[0].label = { rotation: -20 };

                chartOptionsList.VolumeByRadiologistChartOption.data = result;

                var params = chartOptionsList.VolumeByRadiologistChartOption.params;
                var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                chartOptionsList.VolumeByRadiologistChartOption.series = seriesList;

                chartList.VolumeByRadiologistChart.update(chartOptionsList.VolumeByRadiologistChartOption);

                $scope.DataObject.isLoading = false;

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetModalityVolByRadiologist(Group) {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;
            var params = {
                SumOf: 'Modality',
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            }

            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            if (Group == "MonthsName") {
                params.Group = Group;
                params.Radiologist = $scope.DataObject.SelectedRadiologist;
            }
            UserAnalyticsService.GetVolumeByRadiologist(params).then(function (result) {

                if (Group == "MonthsName") {
                    var ModalityCount = 0;
                    var SumOfRVU = 0;
                    _.each(result, function (obj) {
                        ModalityCount = isNaN(obj.ModalityCount) ? ModalityCount : ModalityCount + obj.ModalityCount;
                        SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var row = {
                        MonthsName: null,
                        ModalityCount: ModalityCount,
                        SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor
                    }
                    RadModalityVolByMonthGridOption.api.setPinnedBottomRowData([row]);
                    RadModalityVolByMonthGridOption.api.setRowData(result);

                    chartOptionsList.RadModalityVolByMonthChartOption.data = result;

                    var params = chartOptionsList.RadModalityVolByMonthChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.RadModalityVolByMonthChartOption.series = seriesList;

                    chartList.RadModalityVolByMonthChart.update(chartOptionsList.RadModalityVolByMonthChartOption);

                } else {
                    var row = createPinnedFooterRowForModality(result);
                    ModalityByRadiologistGridOptions.api.setPinnedBottomRowData([row]);
                    ModalityByRadiologistGridOptions.api.setRowData(result);

                    chartOptionsList.ModalityByRadiologistChartOption.data = result;

                    var params = chartOptionsList.ModalityByRadiologistChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.ModalityByRadiologistChartOption.series = seriesList;

                    chartList.ModalityByRadiologistChart.update(chartOptionsList.ModalityByRadiologistChartOption);
                }
                $scope.DataObject.isLoading = false;

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetPatientClassVolByRadiologist(Group) {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;

            var params = {
                SumOf: 'PatientClass',
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };
            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            if (Group == "MonthsName") {
                params.Group = Group;
                params.Radiologist = $scope.DataObject.SelectedRadiologist;
            }
            UserAnalyticsService.GetVolumeByRadiologist(params).then(function (result) {
                if (Group == "MonthsName") {

                    var PatientClassCount = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        PatientClassCount = isNaN(obj.PatientClassCount) ? PatientClassCount : PatientClassCount + obj.PatientClassCount;
                        SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var row = {
                        MonthsName: null,
                        PatientClassCount: PatientClassCount,
                        SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor
                    }
                    RadPatientClassVolByMonthGridOption.api.setPinnedBottomRowData([row]);
                    RadPatientClassVolByMonthGridOption.api.setRowData(result);

                    chartOptionsList.RadPatientClassVolByMonthChartOption.data = result;

                    var params = chartOptionsList.RadPatientClassVolByMonthChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.RadPatientClassVolByMonthChartOption.series = seriesList;

                    chartList.RadPatientClassVolByMonthChart.update(chartOptionsList.RadPatientClassVolByMonthChartOption);
                }
                else {
                    var row = createPinnedFooterRowForPatientClass(result);
                    PatientClassByRadiologistGridOptions.api.setPinnedBottomRowData([row]);

                    PatientClassByRadiologistGridOptions.api.setRowData(result);

                    chartOptionsList.PatientClassByRadiologistChartOption.data = result;

                    var params = chartOptionsList.PatientClassByRadiologistChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.PatientClassByRadiologistChartOption.series = seriesList;

                    chartList.PatientClassByRadiologistChart.update(chartOptionsList.PatientClassByRadiologistChartOption);
                }
                $scope.DataObject.isLoading = false;

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetVolPriorityGroupByMonth() {
            var d = $q.defer();

            $scope.DataObject.isLoading = true;
            var promise;
            var params = {
                SumOf: 'Priority',
                Group: 'MonthsName',
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };
            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            if ($scope.DataObject.ActiveSection.includes("LocationVolume")) {
                params.Location = $scope.DataObject.SelectedLocation;
                promise = UserAnalyticsService.GetVolumeByLocation(params);

            } else if ($scope.DataObject.ActiveSection.includes("RadiologistVolume")) {
                params.Radiologist = $scope.DataObject.SelectedRadiologist;
                promise = UserAnalyticsService.GetVolumeByRadiologist(params);
            }

            promise.then(function (result) {
                if ($scope.DataObject.ActiveSection.includes("LocationVolume")) {
                    chartOptionsList.MonthsGroupByLocVolChartOption.data = result;

                    var params = chartOptionsList.MonthsGroupByLocVolChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.MonthsGroupByLocVolChartOption.series = seriesList;

                    MonthsGroupByLocVolGridOptions.api.setRowData(result);

                    chartList.MonthsGroupByLocVolChart.update(chartOptionsList.MonthsGroupByLocVolChartOption);

                    var RoutineSum = 0;
                    var STATSum = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        RoutineSum = (isNaN(obj.Routine)) ? RoutineSum : obj.Routine + RoutineSum;
                        STATSum = (isNaN(obj.STAT)) ? STATSum : obj.STAT + STATSum;
                        SumOfRVU = (isNaN(obj.SumOfRVU)) ? SumOfRVU : obj.SumOfRVU + SumOfRVU;
                    });
                    var row = {
                        "Location": null,
                        "Routine": RoutineSum,
                        "STAT": STATSum,
                        "SumOfRVU": parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor,
                    }
                    MonthsGroupByLocVolGridOptions.api.setPinnedBottomRowData([row]);

                } else if ($scope.DataObject.ActiveSection.includes("RadiologistVolume")) {

                    var TotalRoutine = 0;
                    var TotalSTAT = 0;
                    var SumOfRVU = 0;
                    _.each(result, function (obj) {
                        SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                        TotalSTAT = isNaN(obj.STAT) ? TotalSTAT : TotalSTAT + obj.STAT;
                        TotalRoutine = isNaN(obj.Routine) ? TotalRoutine : TotalRoutine + obj.Routine;
                    });

                    row = {
                        MonthsName: null,
                        Routine: TotalRoutine,
                        STAT: TotalSTAT,
                        SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor
                    }
                    MonthsGroupByRadVolGridOptions.api.setPinnedBottomRowData([row]);
                    chartOptionsList.MonthsGroupByRadVolChartOption.data = result;

                    var params = chartOptionsList.MonthsGroupByRadVolChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.MonthsGroupByRadVolChartOption.series = seriesList;

                    MonthsGroupByRadVolGridOptions.api.setRowData(result);

                    chartList.MonthsGroupByRadVolChart.update(chartOptionsList.MonthsGroupByRadVolChartOption);
                }
                $scope.DataObject.isLoading = false;

                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetVolumeByModalityGroup() {

            var d = $q.defer();

            $scope.DataObject.isLoading = true;
            var promise;

            var params = {
                Group: 'Modality',
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };

            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            if ($scope.DataObject.ActiveSection.includes("LocationVolume")) {
                params.Location = $scope.DataObject.SelectedLocation;
                promise = UserAnalyticsService.GetVolumeByLocation(params);
            } else if ($scope.DataObject.ActiveSection.includes("RadiologistVolume")) {
                params.Radiologist = $scope.DataObject.SelectedRadiologist;
                promise = UserAnalyticsService.GetVolumeByRadiologist(params);
            }


            promise.then(function (result) {
                if ($scope.DataObject.ActiveSection.includes("LocationVolume")) {
                    var ModalityCount = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        ModalityCount = isNaN(obj.ModalityCount) ? ModalityCount : ModalityCount + obj.ModalityCount;
                        SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var row = {
                        Modality: null,
                        ModalityCount: ModalityCount,
                        SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor
                    }
                    ModalityGroupByMonthGridOptions.api.setPinnedBottomRowData([row]);

                    chartOptionsList.ModalityGroupByMonthChartOption.data = result;

                    var params = chartOptionsList.ModalityGroupByMonthChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.ModalityGroupByMonthChartOption.series = seriesList;

                    ModalityGroupByMonthGridOptions.api.setRowData(result);

                    chartList.ModalityGroupByMonthChart.update(chartOptionsList.ModalityGroupByMonthChartOption);

                } else if ($scope.DataObject.ActiveSection.includes("RadiologistVolume")) {

                    var ModalityCount = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        ModalityCount = isNaN(obj.ModalityCount) ? ModalityCount : ModalityCount + obj.ModalityCount;
                        SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var row = {
                        ModalityCount: ModalityCount,
                        SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor
                    }
                    RadVolumeByModalityGroupGridOptions.api.setPinnedBottomRowData([row]);
                    chartOptionsList.RadVolumeByModalityGroupChartOption.data = result;

                    var params = chartOptionsList.RadVolumeByModalityGroupChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.RadVolumeByModalityGroupChartOption.series = seriesList;

                    RadVolumeByModalityGroupGridOptions.api.setRowData(result);

                    chartList.RadVolumeByModalityGroupChart.update(chartOptionsList.RadVolumeByModalityGroupChartOption);
                }
                $scope.DataObject.isLoading = false;
                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;

        }
        function GetSubChartVolByModality() {
            var d = $q.defer();
            var promise;
            var params = {
                UserId: $sessionStorage.currentUserData.userId,
                SumOf: "Priority",
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };
            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            if ($scope.DataObject.ActiveSection.includes("LocationVolume")) {
                params.Location = $scope.DataObject.SelectedLocation;
                promise = UserAnalyticsService.GetVolumeByLocation(params);

            } else if ($scope.DataObject.ActiveSection.includes("RadiologistVolume")) {
                params.Radiologist = $scope.DataObject.SelectedRadiologist;
                promise = UserAnalyticsService.GetVolumeByRadiologist(params);
            }

            promise.then(function (result) {
                var Routine = 0;
                var STAT = 0;
                var SumOfRVU = 0;

                _.each(result, function (obj) {
                    SumOfRVU = isNaN(obj.Routine) ? Routine : Routine + obj.Routine;
                    SumOfRVU = isNaN(obj.STAT) ? STAT : STAT + obj.STAT;
                    SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                });

                var row = {
                    Routine: Routine,
                    STAT: STAT,
                    SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                    totalRowColor: totalRowColor
                }

                if ($scope.DataObject.ActiveSection.includes("LocationVolume")) {

                    SubChartLocVolByModalityGridOption.api.setPinnedBottomRowData([row]);
                    chartOptionsList.SubChartLocVolByModalityChartOption.data = result;

                    var params = chartOptionsList.SubChartLocVolByModalityChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.SubChartLocVolByModalityChartOption.series = seriesList;

                    SubChartLocVolByModalityGridOption.api.setRowData(result);
                    chartList.SubChartLocVolByModalityChart.update(chartOptionsList.SubChartLocVolByModalityChartOption);

                } else if ($scope.DataObject.ActiveSection.includes("RadiologistVolume")) {

                    SubChartRadVolByModalityGridOption.api.setPinnedBottomRowData([row]);

                    chartOptionsList.SubChartRadVolByModalityChartOption.data = result;

                    var params = chartOptionsList.SubChartRadVolByModalityChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.SubChartRadVolByModalityChartOption.series = seriesList;

                    SubChartRadVolByModalityGridOption.api.setRowData(result);
                    chartList.SubChartRadVolByModalityChart.update(chartOptionsList.SubChartRadVolByModalityChartOption);

                }
            }, function (err) { $scope.DataObject.isLoading = false; });

            return d.promise;
        }
        function GetSubChartVolByPatientClass() {
            var d = $q.defer();
            var promise;
            var params = {
                UserId: $sessionStorage.currentUserData.userId,
                Group: "PatientClass",
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };

            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            if ($scope.DataObject.ActiveSection.includes("LocationVolume")) {
                params.Location = $scope.DataObject.SelectedLocation;
                promise = UserAnalyticsService.GetVolumeByLocation(params);

            } else if ($scope.DataObject.ActiveSection.includes("RadiologistVolume")) {
                params.Radiologist = $scope.DataObject.SelectedRadiologist;
                promise = UserAnalyticsService.GetVolumeByRadiologist(params);
            }

            promise.then(function (result) {
                if ($scope.DataObject.ActiveSection.includes("LocationVolume")) {
                    var PatientClassCount = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        PatientClassCount = isNaN(obj.PatientClassCount) ? PatientClassCount : PatientClassCount + obj.PatientClassCount;
                        SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var row = {
                        PatientClass: null,
                        PatientClassCount: PatientClassCount,
                        SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor
                    }
                    SubChartLocVolByPCGridOption.api.setPinnedBottomRowData([row]);
                    chartOptionsList.SubChartLocVolByPCChartOption.data = result;

                    var params = chartOptionsList.SubChartLocVolByPCChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.SubChartLocVolByPCChartOption.series = seriesList;

                    SubChartLocVolByPCGridOption.api.setRowData(result);
                    chartList.SubChartLocVolByPCChart.update(chartOptionsList.SubChartLocVolByPCChartOption);

                } else if ($scope.DataObject.ActiveSection.includes("RadiologistVolume")) {
                    var PatientClassCount = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        PatientClassCount = isNaN(obj.PatientClassCount) ? PatientClassCount : PatientClassCount + obj.PatientClassCount;
                        SumOfRVU = isNaN(obj.SumOfRVU) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var row = {
                        PatientClass: null,
                        PatientClassCount: PatientClassCount,
                        SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor
                    }
                    SubChartRadVolByPCGridOption.api.setPinnedBottomRowData([row]);
                    chartOptionsList.SubChartRadVolByPCChartOption.data = result;

                    var params = chartOptionsList.SubChartRadVolByPCChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.SubChartRadVolByPCChartOption.series = seriesList;

                    SubChartRadVolByPCGridOption.api.setRowData(result);
                    chartList.SubChartRadVolByPCChart.update(chartOptionsList.SubChartRadVolByPCChartOption);

                }
            }, function (err) { $scope.DataObject.isLoading = false; });

            return d.promise;
        }

        function GetHiddenVolumeByLocation(Group) {
            var d = $q.defer();

            var params = {
                UserId: $sessionStorage.currentUserData.userId,
                FromDOS: $filter('CSTDateTime')($scope.DataObject.datePicker.startDate),
                ToDOS: $filter('CSTDateTime')($scope.DataObject.datePicker.endDate),
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };
            if (Group) {
                params.Group = Group;
                params.Location = $scope.DataObject.SelectedLocation;
            }

            UserAnalyticsService.GetHiddenVolumeByLocation(params).then(function (result) {
                if (!Group) {
                    var HideStudyCount = 0;
                    _.each(result, function (obj) {
                        HideStudyCount = isNaN(obj.HideStudyCount) ? HideStudyCount : HideStudyCount + obj.HideStudyCount;
                    });

                    var row = {
                        Location: null,
                        HideStudyCount: HideStudyCount,
                        totalRowColor: totalRowColor
                    }
                    HiddenVolByLocGridOption.api.setPinnedBottomRowData([row]);
                    HiddenVolByLocGridOption.api.setRowData(result);
                    chartOptionsList.HiddenVolByLocChartOption.data = result;

                    var params = chartOptionsList.HiddenVolByLocChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.HiddenVolByLocChartOption.series = seriesList;

                    chartList.HiddenVolByLocChart.update(chartOptionsList.HiddenVolByLocChartOption);
                }
                else if (Group == "day") {
                    var HideStudyCount = 0;

                    _.each(result, function (obj) {
                        obj.DOS = $filter('CSTDateTime')(obj.DOS);
                        obj.time = new Date(obj.DOS).getTime();
                        obj[obj.Location] = obj.HideStudyCount;
                        HideStudyCount = isNaN(obj.HideStudyCount) ? HideStudyCount : HideStudyCount + obj.HideStudyCount;
                    });

                    var uniqLocationList = _.uniqBy(result, "Location");

                    var seriesList = [];
                    _.each(uniqLocationList, function (obj) {
                        seriesList.push({
                            type: "line",
                            xKey: "time",
                            yKey: obj.Location,
                            yName: obj.Location,
                            tooltip: {
                                enabled: true,
                                renderer: function (params) {
                                    return {
                                        title: params.yName,
                                        data: [
                                            {
                                                label: "Hidden Study Count",
                                                value: params.datum[params.yKey],
                                            },
                                        ],
                                    };
                                },
                            },
                            marker: { size: 13, }
                        });
                    });

                    var row = {
                        Location: null,
                        DOS: null,
                        HideStudyCount: HideStudyCount,
                        totalRowColor: totalRowColor
                    }
                    LocHiddenVolByMonthGridOption.api.setPinnedBottomRowData([row]);
                    LocHiddenVolByMonthGridOption.api.setRowData(result);

                    chartOptionsList.LocHiddenVolByMonthChartOption.zoom = {
                        enabled: true,
                        axes: "xy",
                        anchorPointX: "pointer",
                        anchorPointY: "pointer",
                        rangeX: {
                            start: $filter('CSTDateTime')($scope.DataObject.datePicker.startDate),
                            end: $filter('CSTDateTime')($scope.DataObject.datePicker.endDate),
                        },
                    };
                    chartOptionsList.LocHiddenVolByMonthChartOption.series = seriesList;
                    chartOptionsList.LocHiddenVolByMonthChartOption.data = result;
                    chartList.LocHiddenVolByMonthChart.update(chartOptionsList.LocHiddenVolByMonthChartOption);
                }
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }
        function GetTATStudyCountByHourLocation(Group1, Group2, Group3) {
            var d = $q.defer();

            var params = {
                Group1: Group1,
                Group2: Group2,
                Group3: Group3,
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
            };

            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            if (!Group3 && !Group2 && (Group1 == "DOS" || Group1 == "DOSHour")) {
                params.Location = $scope.DataObject.SelectedLocation;
            }

            UserAnalyticsService.GetTATStudyCountByHourLocation(params).then(function (result) {
                if (!Group3 && !Group2 && (Group1 == "Location")) {
                    var seriesList = [];
                    seriesList.push({
                        type: "bar",
                        xKey: "Location",
                        yKey: "StudyCount",
                        yName: "Study Count",
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Study Count",
                                            value: params.datum[params.yKey],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, },
                        listeners: { nodeClick: nodeClick },
                    }, {
                        type: "line",
                        xKey: "Location",
                        yKey: "AvgTAT",
                        yName: "Avg TAT",
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Avg TAT",
                                            value: params.datum[params.yKey],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, },
                        listeners: { nodeClick: nodeClick },
                    }, {
                        type: "line",
                        xKey: "Location",
                        yKey: "SumOfRVU",
                        yName: "Sum Of RVU",
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Sum Of RVU",
                                            value: params.datum[params.yKey],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, },
                        listeners: { nodeClick: nodeClick },
                    });

                    var StudyCountSum = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        StudyCountSum = (isNaN(obj.StudyCount)) ? StudyCountSum : StudyCountSum + obj.StudyCount;
                        SumOfRVU = (isNaN(obj.SumOfRVU)) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var row = {
                        "Location": null,
                        "AvgTAT": null,
                        "StudyCount": StudyCountSum,
                        "SumOfRVU": parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor,
                    }
                    TATCountDOSLocGridOption.api.setPinnedBottomRowData([row]);

                    TATCountDOSLocGridOption.api.setRowData(result);
                    chartOptionsList.TATCountDOSLocChartOption.series = seriesList;
                    chartOptionsList.TATCountDOSLocChartOption.data = result;
                    chartList.TATCountDOSLocChart.update(chartOptionsList.TATCountDOSLocChartOption);


                }
                else if (!Group3 && !Group2 && (Group1 == "DOS" || Group1 == "SignDate")) {

                    var StudyCountSum = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        obj[Group1] = $filter('CSTDateTime')(obj[Group1]);
                        obj.time = new Date(obj[Group1]).getTime();

                        StudyCountSum = (isNaN(obj.StudyCount)) ? StudyCountSum : StudyCountSum + obj.StudyCount;
                        SumOfRVU = (isNaN(obj.SumOfRVU)) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var seriesList = [];
                    seriesList.push({
                        type: "bar",
                        xKey: "time",
                        yKey: "StudyCount",
                        yName: "Study Count",
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Study Count",
                                            value: params.datum[params.yKey],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, },
                        listeners: { nodeClick: nodeClick },
                    }, {
                        type: "line",
                        xKey: "time",
                        yKey: "AvgTAT",
                        yName: "Avg TAT",
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Avg TAT",
                                            value: params.datum[params.yKey],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, },
                        listeners: { nodeClick: nodeClick },
                    }, {
                        type: "line",
                        xKey: "time",
                        yKey: "SumOfRVU",
                        yName: "Sum Of RVU",
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Sum Of RVU",
                                            value: params.datum[params.yKey],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, },
                        listeners: { nodeClick: nodeClick },
                    });

                    var row = {
                        "AvgTAT": null,
                        "StudyCount": StudyCountSum,
                        "SumOfRVU": parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor,
                    }
                    row[Group1] = null;
                    var coldefs = TATCountByDOSGridOption.columnDefs;
                    coldefs[0].field = Group1;
                    TATCountByDOSGridOption.api.setColumnDefs(coldefs);
                    TATCountByDOSGridOption.api.setPinnedBottomRowData([row]);
                    TATCountByDOSGridOption.api.setRowData(result);
                    chartOptionsList.TATCountByDOSChartOption.series = seriesList;
                    chartOptionsList.TATCountByDOSChartOption.data = result;
                    chartList.TATCountByDOSChart.update(chartOptionsList.TATCountByDOSChartOption);
                }
                else if (!Group3 && !Group2 && (Group1 == "DOSHour" || Group1 == 'SignDateHour')) {
                    var seriesList = [];
                    seriesList.push({
                        type: "bar",
                        xKey: Group1,
                        yKey: "StudyCount",
                        yName: "Study Count",
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Study Count",
                                            value: params.datum[params.yKey],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, },
                        listeners: { nodeClick: nodeClick },
                    }, {
                        type: "line",
                        xKey: Group1,
                        yKey: "AvgTAT",
                        yName: "Avg TAT",
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Avg TAT",
                                            value: params.datum[params.yKey],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, },
                        listeners: { nodeClick: nodeClick },
                    }, {
                        type: "line",
                        xKey: Group1,
                        yKey: "SumOfRVU",
                        yName: "Sum Of RVU",
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Sum Of RVU",
                                            value: params.datum[params.yKey],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, },
                        listeners: { nodeClick: nodeClick },
                    });

                    var StudyCountSum = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        StudyCountSum = (isNaN(obj.StudyCount)) ? StudyCountSum : StudyCountSum + obj.StudyCount;
                        SumOfRVU = (isNaN(obj.SumOfRVU)) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
                    });

                    var row = {
                        "AvgTAT": null,
                        "StudyCount": StudyCountSum,
                        "SumOfRVU": parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor,
                    }
                    row[Group1] = null;
                    var coldefs = TATCountByHourGridOption.columnDefs;
                    coldefs[0].field = Group1;
                    TATCountByHourGridOption.api.setColumnDefs(coldefs);
                    TATCountByHourGridOption.api.setPinnedBottomRowData([row]);

                    TATCountByHourGridOption.api.setRowData(result);
                    chartOptionsList.TATCountByHourChartOption.series = seriesList;
                    chartOptionsList.TATCountByHourChartOption.data = result;
                    chartList.TATCountByHourChart.update(chartOptionsList.TATCountByHourChartOption);
                }
                else if (!Group3 && ((Group1 == "DOS" || Group1 == "SignDate") && Group2 == "Location")) {

                    var StudyCountSum = 0;
                    var SumOfRVU = 0;

                    _.each(result, function (obj) {
                        obj[Group1] = $filter('CSTDateTime')(obj[Group1]);
                        obj.time = new Date(obj[Group1]).getTime();

                        StudyCountSum = (isNaN(obj.StudyCount)) ? StudyCountSum : StudyCountSum + obj.StudyCount;
                        SumOfRVU = (isNaN(obj.SumOfRVU)) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;

                        obj[obj.Location] = (obj.StudyCount + obj.SumOfRVU + obj.AvgTAT);
                    });

                    var uniqLocationList = _.uniqBy(result, "Location");
                    var seriesList = [];
                    _.each(uniqLocationList, function (obj) {
                        seriesList.push({
                            type: "line",
                            xKey: "time",
                            yKey: obj.Location,
                            yName: obj.Location,
                            tooltip: {
                                enabled: true,
                                renderer: function (params) {
                                    return {
                                        title: params.yName,
                                        data: [
                                            {
                                                label: "Study Count",
                                                value: params.datum["StudyCount"],
                                            },
                                            {
                                                label: "Sum Of RVU",
                                                value: params.datum["SumOfRVU"],
                                            },
                                            {
                                                label: "Avg TAT",
                                                value: params.datum["AvgTAT"],
                                            },
                                        ],
                                    };
                                },
                            },
                            marker: { size: 13, }
                        });
                    });

                    var row = {
                        "Location": null,
                        "AvgTAT": null,
                        "StudyCount": StudyCountSum,
                        "SumOfRVU": parseFloat(SumOfRVU.toFixed(2)),
                        totalRowColor: totalRowColor,
                    }
                    row[Group1] = null;
                    var coldefs = TATCountByDOSAndLocGridOption.columnDefs;
                    coldefs[0].field = Group1;
                    TATCountByDOSAndLocGridOption.api.setColumnDefs(coldefs);
                    TATCountByDOSAndLocGridOption.api.setPinnedBottomRowData([row]);
                    TATCountByDOSAndLocGridOption.api.setRowData(result);

                    chartOptionsList.TATCountByDOSAndLocChartOption.series = seriesList;
                    chartOptionsList.TATCountByDOSAndLocChartOption.data = result;
                    chartList.TATCountByDOSAndLocChart.update(chartOptionsList.TATCountByDOSAndLocChartOption);
                }
                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });

            return d.promise;
        }

        function GetPeerReviewByLocationRadiologist(Group) {
            var d = $q.defer();
            $scope.DataObject.isLoading = true;
            var params = {
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
                Group: Group,
            }
            if ($scope.DataObject.isCreatedOrCompletedDate == 'CreatedDate') {
                params.FromCreatedDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToCreatedDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isCreatedOrCompletedDate == 'CompletedDate') {
                params.FromCompletedDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToCompletedDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            UserAnalyticsService.GetPeerReviewByLocationRadiologist(params).then(function (result) {
                if (Group == "Location") {
                    var PendingCount = 0;
                    var CompleteCount = 0;
                    var TotalCount = 0;

                    _.each(result, function (obj) {
                        PendingCount = isNaN(obj.PendingCount) ? PendingCount : PendingCount + obj.PendingCount;
                        CompleteCount = isNaN(obj.CompleteCount) ? CompleteCount : CompleteCount + obj.CompleteCount;
                        TotalCount = isNaN(obj.TotalCount) ? TotalCount : TotalCount + obj.TotalCount;
                    });

                    var row = {
                        Location: null,
                        PendingCount: PendingCount,
                        CompleteCount: CompleteCount,
                        TotalCount: TotalCount,
                        totalRowColor: totalRowColor,
                    }

                    PeerReviewLocationGridOption.api.setPinnedBottomRowData([row]);
                    chartOptionsList.PeerReviewLocationChartOption.data = result;

                    var params = chartOptionsList.PeerReviewLocationChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.PeerReviewLocationChartOption.series = seriesList;

                    PeerReviewLocationGridOption.api.setRowData(result);
                    chartList.PeerReviewLocationChart.update(chartOptionsList.PeerReviewLocationChartOption);
                }
                else if (Group == "Radiologist") {
                    var PendingCount = 0;
                    var CompleteCount = 0;
                    var TotalCount = 0;

                    _.each(result, function (obj) {
                        PendingCount = isNaN(obj.PendingCount) ? PendingCount : PendingCount + obj.PendingCount;
                        CompleteCount = isNaN(obj.CompleteCount) ? CompleteCount : CompleteCount + obj.CompleteCount;
                        TotalCount = isNaN(obj.TotalCount) ? TotalCount : TotalCount + obj.TotalCount;
                    });

                    var row = {
                        Radiologist: null,
                        PendingCount: PendingCount,
                        CompleteCount: CompleteCount,
                        TotalCount: TotalCount,
                        totalRowColor: totalRowColor,
                    }

                    PeerReviewRadiologistGridOption.api.setPinnedBottomRowData([row]);
                    chartOptionsList.PeerReviewRadiologistChartOption.data = result;

                    var params = chartOptionsList.PeerReviewRadiologistChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.PeerReviewRadiologistChartOption.series = seriesList;

                    PeerReviewRadiologistGridOption.api.setRowData(result);
                    chartList.PeerReviewRadiologistChart.update(chartOptionsList.PeerReviewRadiologistChartOption);
                }
                $scope.DataObject.isLoading = false;
                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }

        function GetPeerReviewByDayLocationRadiologist(Group) {
            var d = $q.defer();
            $scope.DataObject.isLoading = true;
            var params = {
                UserId: $sessionStorage.currentUserData.userId,
                FromSignDate: $filter('CSTDateTime')($scope.DataObject.datePicker.startDate),
                ToSignDate: $filter('CSTDateTime')($scope.DataObject.datePicker.endDate),
                LocationID: $scope.DataObject.SelectedLocations.Ids,
                Group: Group,
                Group1: "AddedDate",
            }
            UserAnalyticsService.GetPeerReviewByDayLocationRadiologist(params).then(function (result) {

                _.each(result, function (obj) {
                    obj.AddedDate = $filter('CSTDateTime')(obj.AddedDate);
                    obj.time = new Date(obj.AddedDate).getTime();
                    obj[obj[Group]] = (obj.PendingCount);
                });

                var uniqList = _.uniqBy(result, Group);

                var seriesList = [];
                _.each(uniqList, function (obj) {
                    seriesList.push({
                        type: "bar",
                        xKey: "time",
                        yKey: obj[Group],
                        yName: obj[Group],
                        tooltip: {
                            enabled: true,
                            renderer: function (params) {
                                return {
                                    title: params.yName,
                                    data: [
                                        {
                                            label: "Pending Count",
                                            value: params.datum["PendingCount"],
                                        },
                                        {
                                            label: "Pending Since",
                                            value: params.datum["PendingSince"],
                                        },
                                    ],
                                };
                            },
                        },
                        marker: { size: 13, }
                    });
                });

                if (Group == "Location") {
                    PeerReviewPendingSinceByLocGridOption.api.setRowData(result);

                    chartOptionsList.PeerReviewPendingSinceByLocChartOption.series = seriesList;
                    chartOptionsList.PeerReviewPendingSinceByLocChartOption.data = result;
                    chartList.PeerReviewPendingSinceByLocChart.update(chartOptionsList.PeerReviewPendingSinceByLocChartOption);
                }
                else {
                    PeerReviewPendingSinceByRadGridOption.api.setRowData(result);
                    chartOptionsList.PeerReviewPendingSinceByRadChartOption.series = seriesList;
                    chartOptionsList.PeerReviewPendingSinceByRadChartOption.data = result;
                    chartList.PeerReviewPendingSinceByRadChart.update(chartOptionsList.PeerReviewPendingSinceByRadChartOption);
                }

                $scope.DataObject.isLoading = false;
                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false; });
            return d.promise;
        }
        function GetAddedumRequestedList(Group) {
            var d = $q.defer();
            $scope.DataObject.isLoading = true;
            UserAnalyticsService.GetAddedumRequestedList({
                UserId: $sessionStorage.currentUserData.userId,
                FromDate: $filter('CSTDateTime')($scope.DataObject.datePicker.startDate),
                ToDate: $filter('CSTDateTime')($scope.DataObject.datePicker.endDate),
                LocationID: $scope.DataObject.SelectedLocations.Ids,
                Group: Group,
                Location: $scope.DataObject.SelectedLocation
            }).then(function (result) {
                if (Group == "Location") {

                    chartOptionsList.AddendumListByLocChartOption.data = result;
                    var params = chartOptionsList.AddendumListByLocChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.AddendumListByLocChartOption.series = seriesList;

                    AddendumListByLocGridOption.api.setRowData(result);
                    chartList.AddendumListByLocChart.update(chartOptionsList.AddendumListByLocChartOption);
                }
                else if (Group == "AddendumRequestedBy") {

                    chartOptionsList.AddendumListByRadChartOption.data = result;
                    var params = chartOptionsList.AddendumListByRadChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.AddendumListByRadChartOption.series = seriesList;

                    AddendumListByRadGridOption.api.setRowData(result);
                    chartList.AddendumListByRadChart.update(chartOptionsList.AddendumListByRadChartOption);
                }
                else if (Group == "AddendumRequestedTo") {

                    chartOptionsList.AddendumListToRadChartOption.data = result;
                    var params = chartOptionsList.AddendumListToRadChartOption.params;
                    var seriesList = getChartOptionSeries(params.xKey, params.type, params.seriesField);
                    chartOptionsList.AddendumListToRadChartOption.series = seriesList;

                    AddendumListToRadGridOption.api.setRowData(result);
                    chartList.AddendumListToRadChart.update(chartOptionsList.AddendumListToRadChartOption);
                }
                $scope.DataObject.isLoading = false;
                d.resolve();
            }, function (err) {
                $scope.DataObject.isLoading = false;
                d.reject();
            });
            return d.promise;
        }

        function GetRadiologistVolByLocation(group) {
            var d = $q.defer();
            var params = {
                Group1: 'Location',
                UserId: $sessionStorage.currentUserData.userId,
                LocationID: $scope.DataObject.SelectedLocations.Ids,
                Radiologist: $scope.DataObject.SelectedRadiologist,
            }
            if (group) {
                params.Group = group;
            }
            if ($scope.DataObject.isDOSorSignedDate == "DOS") {
                params.FromDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToDOS = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }
            else if ($scope.DataObject.isDOSorSignedDate == "SignedDate") {
                params.FromSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.startDate);
                params.ToSignDate = $filter('CSTDateTime')($scope.DataObject.datePicker.endDate);
            }

            UserAnalyticsService.GetVolumeByRadiologist(params).then(function (result) {
                console.log(result);
                _.each(result, function (obj) {
                    var groupData = [];
                    if (group == "Modality") {
                        if (obj.Modality) {
                            groupData.push(obj.Modality);
                        }
                        else {
                            groupData.push("");
                        }
                        groupData.push(obj.Location);
                        obj.ModalityLocation = groupData;
                    }
                    else if (group == "MonthsName") {
                        if (obj.MonthsName) {
                            groupData.push(obj.MonthsName);
                        }
                        else {
                            groupData.push("");
                        }
                        groupData.push(obj.Location);
                        obj.MonthsLocation = groupData;
                    }
                    else {
                        if (obj.Radiologist) {
                            groupData.push(obj.Radiologist);
                        }
                        else {
                            groupData.push("");
                        }
                        groupData.push(obj.Location);
                        obj.RadiologistLocation = groupData;
                    }
                });
                if (group == "Modality") {
                    if (RadiologistVolByLocModalityGridOption && RadiologistVolByLocModalityGridOption.api) {
                        RadiologistVolByLocModalityGridOption.api.setRowData(result);
                    }
                    if (chartOptionsList.RadiologistVolByLocModalityChartOptions && chartList.RadiologistVolByLocModalityChart) {
                        chartOptionsList.RadiologistVolByLocModalityChartOptions.zoom = {
                            enabled: true,
                            anchorPointX: "pointer",
                            anchorPointY: "pointer",
                            autoScaling: {
                                enabled: true,
                            },
                        };
                        chartOptionsList.RadiologistVolByLocModalityChartOptions.data = result;
                        chartList.RadiologistVolByLocModalityChart.update(chartOptionsList.RadiologistVolByLocModalityChartOptions);
                        $scope.convertChartType('RadiologistVolByLocModalityChart', 'RadiologistVolByLocModalityChartOptions', 'bar');

                    }
                }
                else if (group == "MonthsName") {
                    if (RadiologistVolByLocMonthsGridOption && RadiologistVolByLocMonthsGridOption.api) {
                        RadiologistVolByLocMonthsGridOption.api.setRowData(result);
                    }
                    if (chartOptionsList.RadiologistVolByLocMonthChartOptions && chartList.RadiologistVolByLocMonthsChart) {
                        chartOptionsList.RadiologistVolByLocMonthChartOptions.zoom = {
                            enabled: true,
                            anchorPointX: "pointer",
                            anchorPointY: "pointer",
                            autoScaling: {
                                enabled: true,
                            },
                        };
                        chartOptionsList.RadiologistVolByLocMonthChartOptions.data = result;
                        chartList.RadiologistVolByLocMonthsChart.update(chartOptionsList.RadiologistVolByLocMonthChartOptions);
                        $scope.convertChartType('RadiologistVolByLocMonthsChart', 'RadiologistVolByLocMonthChartOptions', 'bar');
                    }
                }
                else {
                    if (RadiologistVolByLocGridOption && RadiologistVolByLocGridOption.api) {
                        RadiologistVolByLocGridOption.api.setRowData(result);
                    }
                    if (chartOptionsList.RadiologistVolByLocChartOptions && chartList.RadiologistVolByLocChart) {
                        chartOptionsList.RadiologistVolByLocChartOptions.zoom = {
                            enabled: true,
                            anchorPointX: "pointer",
                            anchorPointY: "pointer",
                            autoScaling: {
                                enabled: true,
                            },
                        };
                        chartOptionsList.RadiologistVolByLocChartOptions.data = _.cloneDeep(result);
                        chartList.RadiologistVolByLocChart.update(chartOptionsList.RadiologistVolByLocChartOptions);
                        $scope.convertChartType('RadiologistVolByLocChart', 'RadiologistVolByLocChartOptions', 'bar');
                    }
                }
                d.resolve();
            }, function (err) {
                d.reject();
            });
            return d.promise;
        }
        //#endregion API calls for datatset for chart and Grid

        $scope.refreshCharts = function () {
            $scope.DataObject.SelectedLocation = null;
            $scope.DataObject.SelectedRadiologist = null;
            ApplyActiveSecion($scope.DataObject.ActiveSection);
        }

        //#region Site-location Dropdown
        function GetSitesAndLocation() {
            var d = $q.defer();
            PaymentContractService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.DataObject.Locations = _.filter(result, function (obj) { return obj.SiteID != 0; });
                d.resolve();
            })
            return d.promise;
        }
        $scope.clearFilter = function () {
            var cloneDataObj = _.cloneDeep($scope.DataObject);
            cloneDataObj.datePicker = {
                startDate: moment().subtract(29, 'days'),
                label: "Last 30 Days",
                endDate: moment(),
            };
            cloneDataObj.SelectedLocations = {
                Ids: '',
                locations: [],
                divId: "AnalyticsPageFilter"
            };
            $scope.DataObject = cloneDataObj;
            $scope.refreshCharts();
        }
        //#endregion Tenant Site Dropdown

        $scope.hideShowChartNavigator = function () {
            switch ($scope.DataObject.ActiveSection) {
                case "LocationTAT":
                    chartOptionsList.UserAnalyticsChartOptionsByLoc.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.UserAnalyticsChartByLoc.update(chartOptionsList.UserAnalyticsChartOptionsByLoc);

                    chartOptionsList.UserAnalyticsChartOptionsByModality.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.UserAnalyticsChartByModality.update(chartOptionsList.UserAnalyticsChartOptionsByModality);

                    chartOptionsList.UserAnalyticsChartOptionsByPatientClass.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.UserAnalyticsChartByPatientClass.update(chartOptionsList.UserAnalyticsChartOptionsByPatientClass);

                    chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.UserAnalyticsChartByPatientClassModality.update(chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality);
                    break;
                case "RadiologistTAT":
                    chartOptionsList.UserAnalyticsChartOptionsByRadiologist.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.UserAnalyticsChartByRadiologist.update(chartOptionsList.UserAnalyticsChartOptionsByRadiologist);

                    chartOptionsList.UserAnalyticsChartOptionsByModality.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.UserAnalyticsChartByModality.update(chartOptionsList.UserAnalyticsChartOptionsByModality);

                    chartOptionsList.UserAnalyticsChartOptionsByPatientClass.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.UserAnalyticsChartByPatientClass.update(chartOptionsList.UserAnalyticsChartOptionsByPatientClass);

                    chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.UserAnalyticsChartByPatientClassModality.update(chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality);
                    break;
                case "LocationVolume":
                    chartOptionsList.VolumeByLocChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.VolumeByLocChart.update(chartOptionsList.VolumeByLocChartOption);

                    chartOptionsList.MonthsGroupByLocVolChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.MonthsGroupByLocVolChart.update(chartOptionsList.MonthsGroupByLocVolChartOption);

                    chartOptionsList.ModalityGroupByMonthChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.ModalityGroupByMonthChart.update(chartOptionsList.ModalityGroupByMonthChartOption);
                    break;
                case "ModalityByLocationVolume":
                    chartOptionsList.ModalityByLocChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.ModalityByLocChart.update(chartOptionsList.ModalityByLocChartOption);

                    chartOptionsList.LocModalityVolByMonthChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.LocModalityVolByMonthChart.update(chartOptionsList.LocModalityVolByMonthChartOption);

                    chartOptionsList.SubChartLocVolByPCChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.SubChartLocVolByPCChart.update(chartOptionsList.SubChartLocVolByPCChartOption);
                    break;
                case "PatientClassByLocationVolume":
                    chartOptionsList.PatientClassByLocChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.PatientClassByLocChart.update(chartOptionsList.PatientClassByLocChartOption);

                    chartOptionsList.LocPatientClassVolByMonthChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.LocPatientClassVolByMonthChart.update(chartOptionsList.LocPatientClassVolByMonthChartOption);

                    chartOptionsList.SubChartLocVolByModalityChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.SubChartLocVolByModalityChart.update(chartOptionsList.SubChartLocVolByModalityChartOption);
                    break;
                case "RadiologistVolume":
                    chartOptionsList.VolumeByRadiologistChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.VolumeByRadiologistChart.update(chartOptionsList.VolumeByRadiologistChartOption);

                    chartOptionsList.MonthsGroupByRadVolChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.MonthsGroupByRadVolChart.update(chartOptionsList.MonthsGroupByRadVolChartOption);

                    chartOptionsList.RadVolumeByModalityGroupChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.RadVolumeByModalityGroupChart.update(chartOptionsList.RadVolumeByModalityGroupChartOption);
                    break;
                case "ModalityByRadiologistVolume":
                    chartOptionsList.ModalityByRadiologistChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.ModalityByRadiologistChart.update(chartOptionsList.ModalityByRadiologistChartOption);

                    chartOptionsList.RadModalityVolByMonthChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.RadModalityVolByMonthChart.update(chartOptionsList.RadModalityVolByMonthChartOption);

                    chartOptionsList.SubChartRadVolByPCChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.SubChartRadVolByPCChart.update(chartOptionsList.SubChartRadVolByPCChartOption);
                    break;
                case "PatientClassByRadiologistVolume":
                    chartOptionsList.PatientClassByRadiologistChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.PatientClassByRadiologistChart.update(chartOptionsList.PatientClassByRadiologistChartOption);

                    chartOptionsList.RadPatientClassVolByMonthChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.RadPatientClassVolByMonthChart.update(chartOptionsList.RadPatientClassVolByMonthChartOption);

                    chartOptionsList.SubChartRadVolByModalityChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.SubChartRadVolByModalityChart.update(chartOptionsList.SubChartRadVolByModalityChartOption);
                    break;
                case "HiddenVolumeByLocation":

                    chartOptionsList.HiddenVolByLocChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.HiddenVolByLocChart.update(chartOptionsList.HiddenVolByLocChartOption);

                    chartOptionsList.LocHiddenVolByMonthChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.LocHiddenVolByMonthChart.update(chartOptionsList.LocHiddenVolByMonthChartOption);
                    break;
                case "TATStudyCountByHourLocation":
                    chartOptionsList.TATCountDOSLocChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.TATCountDOSLocChart.update(chartOptionsList.TATCountDOSLocChartOption);

                    chartOptionsList.TATCountByDOSChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.TATCountByDOSChart.update(chartOptionsList.TATCountByDOSChartOption);

                    chartOptionsList.TATCountByHourChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.TATCountByHourChart.update(chartOptionsList.TATCountByHourChartOption);

                    chartOptionsList.TATCountByDOSAndLocChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.TATCountByDOSAndLocChart.update(chartOptionsList.TATCountByDOSAndLocChartOption);
                    break;

                case "PeerReviewLocation":

                    chartOptionsList.PeerReviewLocationChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.PeerReviewLocationChart.update(chartOptionsList.PeerReviewLocationChartOption);

                    chartOptionsList.PeerReviewRadiologistChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.PeerReviewRadiologistChart.update(chartOptionsList.PeerReviewRadiologistChartOption);
                    break;

                case "PeerReviewPendingSince":

                    chartOptionsList.PeerReviewPendingSinceByLocChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.PeerReviewPendingSinceByLocChart.update(chartOptionsList.PeerReviewPendingSinceByLocChartOption);

                    chartOptionsList.PeerReviewPendingSinceByRadChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.PeerReviewPendingSinceByRadChart.update(chartOptionsList.PeerReviewPendingSinceByRadChartOption);
                    break;

                case "AddendumListVolume":

                    chartOptionsList.AddendumListByLocChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.AddendumListByLocChart.update(chartOptionsList.AddendumListByLocChartOption);

                    chartOptionsList.AddendumListByRadChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.AddendumListByRadChart.update(chartOptionsList.AddendumListByRadChartOption);

                    chartOptionsList.AddendumListToRadChartOption.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.AddendumListToRadChart.update(chartOptionsList.AddendumListToRadChartOption);
                    break;
                case "RadiologistVolByLoc":
                    chartOptionsList.RadiologistVolByLocChartOptions.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.RadiologistVolByLocChart.update(chartOptionsList.RadiologistVolByLocChartOptions);

                    chartOptionsList.RadiologistVolByLocMonthChartOptions.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.RadiologistVolByLocMonthsChart.update(chartOptionsList.RadiologistVolByLocMonthChartOptions);

                    chartOptionsList.RadiologistVolByLocModalityChartOptions.navigator.enabled = $scope.DataObject.NavigatorToggle;
                    chartList.RadiologistVolByLocModalityChart.update(chartOptionsList.RadiologistVolByLocModalityChartOptions);
                    break;
            }

            if ($scope.DataObject.NavigatorToggle != layoutPref.NavigatorToggle) {
                layoutPref.NavigatorToggle = $scope.DataObject.NavigatorToggle;
                updateUserLayoutPreference();
            }
        }

        $scope.convertChartType = function (chart, chartOption, type) {
            if (chartOptionsList[chartOption]) {
                _.each(chartOptionsList[chartOption].series, function (obj) {
                    obj.type = type;
                    obj.marker = {
                        size: 13,
                    };
                })
                chartList[chart].update(chartOptionsList[chartOption]);
            }
        }

        function resetChartOption() {

            _.each(chartOptionsList.UserAnalyticsChartOptionsByModality.series, function (obj) {
                obj.type = 'line';
            });
            chartList.UserAnalyticsChartByModality.update(chartOptionsList.UserAnalyticsChartOptionsByModality);

            _.each(chartOptionsList.UserAnalyticsChartOptionsByPatientClass.series, function (obj) {
                obj.type = 'line';
            }); chartList.UserAnalyticsChartByPatientClass.update(chartOptionsList.UserAnalyticsChartOptionsByPatientClass);

            _.each(chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality.series, function (obj) {
                obj.type = 'line';
            }); chartList.UserAnalyticsChartByPatientClassModality.update(chartOptionsList.UserAnalyticsChartOptionsByPatientClassModality);

            switch ($scope.DataObject.ActiveSection) {
                case "LocationTAT":
                    chartOptionsList.UserAnalyticsChartOptionsByLoc = createChartOptions("Location", "TAT", "AvgTAT");
                    break;
                case "RadiologistTAT":
                    chartOptionsList.UserAnalyticsChartOptionsByRadiologist = createChartOptions("Radiologist", "TAT", "AvgTAT");

                    break;
                case "LocationVolume":
                    chartOptionsList.VolumeByLocChartOption = createChartOptions("Location", "Volume", "TATCounts");

                    chartOptionsList.MonthsGroupByLocVolChartOption = createChartOptions("MonthsName", "Volume", "TATCounts");

                    chartOptionsList.ModalityGroupByMonthChartOption = createChartOptions("Modality", "Volume", "ModalityCount");
                    break;
                case "ModalityByLocationVolume":
                    chartOptionsList.ModalityByLocChartOption = createChartOptions("Location", "Volume", "Modality");

                    chartOptionsList.LocModalityVolByMonthChartOption = createChartOptions("MonthsName", "Volume", "ModalityCount");

                    chartOptionsList.SubChartLocVolByPCChartOption = createChartOptions("PatientClass", "Volume", "PatientClassCount");
                    break;
                case "PatientClassByLocationVolume":
                    chartOptionsList.PatientClassByLocChartOption = createChartOptions("Location", "Volume", "PatientClass");

                    chartOptionsList.LocPatientClassVolByMonthChartOption = createChartOptions("MonthsName", "Volume", "PatientClassCount");

                    chartOptionsList.SubChartLocVolByModalityChartOption = createChartOptions("Location", "Volume", "TATCounts");
                    break;
                case "RadiologistVolume":
                    chartOptionsList.VolumeByRadiologistChartOption = createChartOptions("Radiologist", "Volume", "TATCounts");

                    chartOptionsList.MonthsGroupByRadVolChartOption = createChartOptions("MonthsName", "Volume", "TATCounts");

                    chartOptionsList.RadVolumeByModalityGroupChartOption = createChartOptions("Modality", "Volume", "ModalityCount");
                    break;
                case "ModalityByRadiologistVolume":
                    chartOptionsList.ModalityByRadiologistChartOption = createChartOptions("Radiologist", "Volume", "Modality");

                    chartOptionsList.RadModalityVolByMonthChartOption = createChartOptions("MonthsName", "Volume", "ModalityCount");

                    chartOptionsList.SubChartRadVolByPCChartOption = createChartOptions("PatientClass", "Volume", "PatientClassCount");
                    break;
                case "PatientClassByRadiologistVolume":
                    chartOptionsList.PatientClassByRadiologistChartOption = createChartOptions("Radiologist", "Volume", "PatientClass");

                    chartOptionsList.RadPatientClassVolByMonthChartOption = createChartOptions("MonthsName", "Volume", "PatientClassCount");

                    chartOptionsList.SubChartRadVolByModalityChartOption = createChartOptions("Radiologist", "Volume", "TATCounts");
                    break;
                case "HiddenVolumeByLocation":
                    chartOptionsList.HiddenVolByLocChartOption = createChartOptions("Location", "Volume", "HideStudyCount");
                    chartOptionsList.LocHiddenVolByMonthChartOption = createChartOptions("", "Volume", "HiddenStudyCountByDay");
                    break;
            }
        }

        function createPinnedFooterRowForModality(result) {
            var TotalOfModalities = {};
            var SumOfModality = 0;
            var SumOfRVU = 0;
            _.each(modalities, function (obj) { TotalOfModalities[obj] = 0; })

            _.each(result, function (obj) {
                _.each(modalities, function (modality) {
                    TotalOfModalities[modality] = (isNaN(obj[modality])) ? TotalOfModalities[modality] : TotalOfModalities[modality] + obj[modality];
                });
                SumOfModality = (isNaN(obj.SumOfModality)) ? SumOfModality : SumOfModality + obj.SumOfModality;
                SumOfRVU = (isNaN(obj.SumOfRVU)) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
            });

            var row = {
                SumOfModality: SumOfModality,
                SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                totalRowColor: totalRowColor,
            }
            _.each(modalities, function (modality) {
                row[modality] = TotalOfModalities[modality];
            });
            return row;
        }

        function createPinnedFooterRowForPatientClass(result) {
            var TotalOfPatientClass = {};
            var SumOfRVU = 0;
            _.each(PatientClassList, function (obj) { TotalOfPatientClass[obj] = 0; })

            _.each(result, function (obj) {
                _.each(PatientClassList, function (patientClass) {
                    TotalOfPatientClass[patientClass] = (isNaN(obj[patientClass])) ? TotalOfPatientClass[patientClass] : TotalOfPatientClass[patientClass] + obj[patientClass];
                });
                SumOfRVU = (isNaN(obj.SumOfRVU)) ? SumOfRVU : SumOfRVU + obj.SumOfRVU;
            });

            var row = {
                SumOfRVU: parseFloat(SumOfRVU.toFixed(2)),
                totalRowColor: totalRowColor,
            }
            _.each(PatientClassList, function (patientClass) {
                row[patientClass] = TotalOfPatientClass[patientClass];
            });
            return row;
        }

        //#region User Layout Preference 

        function updateUserLayoutPreference() {
            var d = $q.defer();

            UserLayoutPrefService.SetUserLayoutPreferences({
                UserID: $sessionStorage.currentUserData.userId,
                PageId: $state.current.name + "." + $state.current.controller,
                ControlId: $state.current.controller,
                LayoutOptions: JSON.stringify(layoutPref),
                Username: $sessionStorage.currentUserData.userName
            }).then(function () {
                d.resolve();
            });
            return d.promise;
        }
        function GetUserLayoutPreferences() {
            var d = $q.defer();
            UserLayoutPrefService.GetUserLayoutPreferences({
                UserID: $sessionStorage.currentUserData.userId,
                PageId: $state.current.name + "." + $state.current.controller,
                ControlId: $state.current.controller
            }).then(function (result) {
                if (result && result.LayoutOptions) {
                    layoutPref = JSON.parse(result.LayoutOptions);

                    if (layoutPref.hasOwnProperty("isMenuVisible")) {
                        $scope.DataObject.isMenuVisible = layoutPref.isMenuVisible;
                    } else {
                        layoutPref.isMenuVisible = false;
                    }

                    if (layoutPref.hasOwnProperty("ActiveSection")) {
                        $scope.DataObject.ActiveSection = layoutPref.ActiveSection;
                    }
                    if (layoutPref.hasOwnProperty("NavigatorToggle")) {
                        $scope.DataObject.NavigatorToggle = layoutPref.NavigatorToggle;
                    } else {
                        layoutPref.NavigatorToggle = false;
                    }

                    if (layoutPref.hasOwnProperty("filter")) {
                        if (layoutPref.filter.hasOwnProperty("datePicker")) {
                            if (layoutPref.filter.datePicker.label == "Custom range") {
                                $scope.DataObject.datePicker = {
                                    startDate: moment(layoutPref.filter.datePicker.startDate),
                                    endDate: moment(layoutPref.filter.datePicker.endDate),
                                    label: layoutPref.filter.datePicker.label
                                };
                            } else {
                                $scope.DataObject.datePicker = setFilterDate(layoutPref.filter.datePicker.label);
                            }
                            $scope.DataObject.DateFilterTooltip = moment($scope.DataObject.datePicker.startDate).format('MM/DD/YYYY') + " - " + moment($scope.DataObject.datePicker.endDate).format('MM/DD/YYYY');
                        }

                        if (layoutPref.filter.hasOwnProperty("SelectedLocations")) {
                            $scope.DataObject.SelectedLocations = layoutPref.filter.SelectedLocations;
                        }
                    } else {
                        layoutPref.filter = {};
                    }

                    if (layoutPref.hasOwnProperty("Tabs")) {
                        _.each(Object.keys(layoutPref.Tabs), function (key) {
                            $scope.DataObject.Tabs[key] = layoutPref.Tabs[key];
                        });
                    } else {
                        layoutPref.Tabs = {};
                    }
                    if (layoutPref.hasOwnProperty("isDOSorSignedDate")) {
                        $scope.DataObject.isDOSorSignedDate = layoutPref.isDOSorSignedDate;
                    }
                    if (layoutPref.hasOwnProperty("isCreatedOrCompletedDate")) {
                        $scope.DataObject.isCreatedOrCompletedDate = layoutPref.isCreatedOrCompletedDate;
                    }

                }
                d.resolve();
            });
            return d.promise;
        }
        //#endregion User Layout Preference 

        $scope.pinUnpinSidePanel = function () {
            $scope.DataObject.isMenuVisible = !$scope.DataObject.isMenuVisible;

            if (layoutPref.isMenuVisible != $scope.DataObject.isMenuVisible) {
                layoutPref.isMenuVisible = $scope.DataObject.isMenuVisible;
                updateUserLayoutPreference();
            }
        }
        $scope.changeChartDataTab = function (TabName, TabValue) {
            $scope.DataObject.Tabs[TabName] = TabValue;

            if (layoutPref.Tabs[TabName] != $scope.DataObject.Tabs[TabName]) {
                layoutPref.Tabs[TabName] = $scope.DataObject.Tabs[TabName];
                updateUserLayoutPreference();
            }
        }

        function onFilterUpdatePinnedRow(params) {
            var columnKeys = [];
            if (params.columnApi && params.columnApi.columnModel && params.columnApi.columnModel.columnDefs) {

                _.each(params.columnApi.columnModel.columnDefs, function (col) {
                    if (col.filter == "agNumberColumnFilter" && !((col.field.toUpperCase()).includes("AVG"))) {
                        columnKeys.push(col.field);
                    }
                });
            }
            var TotalCounts = {};

            _.each(columnKeys, function (key) { TotalCounts[key] = 0; });

            params.api.forEachNode(function (obj) {
                _.each(columnKeys, function (key) {
                    TotalCounts[key] = (isNaN(obj.data[key])) ? TotalCounts[key] : TotalCounts[key] + obj.data[key];
                });
            });

            var row = {
                totalRowColor: totalRowColor,
            }
            _.each(Object.keys(TotalCounts), function (key) {
                row[key] = isNaN(TotalCounts[key]) ? TotalCounts[key] : parseFloat(TotalCounts[key].toFixed(2));
            });
            params.api.setPinnedBottomRowData([row]);
        }

        $scope.onSignedDataDOSSelectionChange = function () {
            layoutPref.isDOSorSignedDate = $scope.DataObject.isDOSorSignedDate;
            $scope.refreshCharts();
        }

        $scope.onCreatedOrCompletedDateSelectionChange = function () {
            layoutPref.isCreatedOrCompletedDate = $scope.DataObject.isCreatedOrCompletedDate;
            $scope.refreshCharts();
        }
        pageInit();

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }

})();

angular.module('radico.pages.userAnalytics')
    .service('UserAnalyticsService', ['Restangular', '$http', 'APP_CONSTANTS', function (Restangular, $http, APP_CONSTANTS) {

        this.GetAvgTATByLocation = function (params) {
            return Restangular.one('UserAnalytics').one("GetAvgTATByLocation").customPOST(params);
        };
        this.GetAvgTATByPatientClass = function (params) {
            return Restangular.one('UserAnalytics').one("GetAvgTATByPatientClass").customPOST(params);
        };
        this.GetTATByLocationModalityPatientClassUser = function (params) {
            return Restangular.one('UserAnalytics').one("GetTATByLocationModalityPatientClassUser").customPOST(params);
        };
        this.GetVolumeByLocation = function (params) {
            return Restangular.one('UserAnalytics').one("GetVolumeByLocation").customPOST(params);
        };
        this.GetVolumeByRadiologist = function (params) {
            return Restangular.one('UserAnalytics').one("GetVolumeByRadiologist").customPOST(params);
        };
        this.GetTenantsAndSiteAndLocation = function (params) {
            return Restangular.one("GetTenantsAndSiteAndLocation").customPOST(params);
        }
        this.GetHiddenVolumeByLocation = function (params) {
            return Restangular.one('UserAnalytics').one("GetHiddenVolumeByLocation").customPOST(params);
        }
        this.GetTATStudyCountByHourLocation = function (params) {
            return Restangular.one('UserAnalytics').one("GetTATStudyCountByHourLocation").customPOST(params);
        }
        this.GetPeerReviewByLocationRadiologist  = function (params) {
            return Restangular.one('UserAnalytics').one("GetPeerReviewByLocationRadiologist ").customPOST(params);
        }
        this.GetPeerReviewByDayLocationRadiologist  = function (params) {
            return Restangular.one('UserAnalytics').one("GetPeerReviewByDayLocationRadiologist").customPOST(params);
        }
        this.GetAddedumRequestedList  = function (params) {
            return Restangular.one('UserAnalytics').one("GetAddedumRequestedList").customPOST(params);
        }
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.worklist').controller('WorklistController', WorklistController);


    function WorklistController($scope, $q, WorklistService, SharedService, $state, $sessionStorage, UserLayoutPrefService, $interval, $localStorage, APP_CONSTANTS, $rootScope, AppHubService, $filter, $timeout, Notification, windowHandler, $sce, uiGridConstants, $log, RCService, RuleSharedService, toaster, UserPreferenceService, __env, PaymentContractService) {
        ////$log.log("WorklistController ", new Date());
        $state.go('worklist-lite');
        if ($sessionStorage.ShowModalIESettings) {
            $state.go('iewarning');
            return;
        }

        // #region Variables
        windowHandler.inIt();
        var loadMoreWorklist = null;
        $scope.ReviewOrder = {};
        var AppHub;
        var orderRefreshInterval = null;
        var isOrderOnServer = false;
        $scope.ModalityDropdownDataFilter = {
            divId: "SWorklistModalityFilter",
            keys: ['Code'],
            uniqKey: 'Code',
            placeHolder: "Select Modalities",
            SelectedValue: { list: [] },
        }
        $scope.showDiscuss = false;
        $scope.Status = { key: 'RP' };
        $scope.OrderByField = "DOS";
        $scope.ReverseSort = true;
        $scope.SelectedList = {
            Worklist: null
        };
        $scope.SelectedWorkList = [];
        $scope.Location = null;
        $scope.ContactId = 0;
        $scope.SingReport = {};
        $scope.SingReport.Index = 0;
        $scope.SingReport.Order = {};
        $scope.LastOpenedOrderID;
        $scope.ChooseNextStudy = false;
        $scope.DeficientWarningOnWorklist = false;
        $scope.columns = [];
        $scope.UserRules = '';
        $scope.LoggedInUserID = $sessionStorage.currentUserData.userId;
        $scope.userRole = $sessionStorage.currentUserData.roles;
        $scope.userRoles = $sessionStorage.currentUserData.userRoles;
        $scope.ShowLockStudy = true;
        $scope.worklisttooltip = 'Select a Worklist';
        $scope.modalitytooltip = 'Select Modalities';
        $scope.WorklistPageHeaderParameter = {};
        $scope.WorklistPageHeaderParameter.isfilterCollapse = false;
        $scope.ContactSearch = [];
        $scope.curUserPRWFilters = {};
        $scope.curUserPSWFilters = {};
        $scope.HideOption = { Key: 'Not to be Read' };
        $scope.WorklistId = 0;
        $scope.editSelectedList = {};
        $scope.loc = { selectedItems: [] };
        $scope.Mobile = '';
        $scope.Office = '';
        $scope.Email = '';
        $scope.win_AddEditContactTitle = 'Add/Edit Contact';
        $scope.currentOffset = new Date().getTimezoneOffset();
        $scope.halfScale = false;
        $scope.toolTipOrderDate = 'DOS';
        $scope.currentDate = new Date();
        var refreshDOSMidnight = null;
        $scope.isRebindingLocation = false;
        $scope.isContextMenuVisible = false;
        $scope.contextmenuRowIndex = -1;
        $scope.isAssignedCurrentUser = false;
        $scope.Radiologists = [];
        var siteRadiologistsUnfiltered = [];
        var OrderList = [];
        $scope.orderList = [];
        var LoadPrevNext = "Next";
        var LoadExceededRecord = 50;
        $scope.showingRecords = 0;
        var loadIncrement = 1;
        var lastScrollHeight = 0;
        var loadMore = false;
        var newOrderRefreshInterval = null;
        var newOrderRefreshDuration = __env._environment.config.orderRefreshDuration;
        var DefaultAutoRefreshDuration = __env.DefaultAutoRefreshDuration;
        var filterChanged = false;
        $scope.IsPatientAgeShow = true;
        var OrderProcessed = false;
        var TimeoutList = [];
        $scope.assignMenuVisible = false;
        $scope.displaySortPopover = false;
        var specialityAssignments = [];

        $scope.SelectedLocations = {
            Ids: '',
            locations: [],
            divId: "OldWorklistFilter"
        };

        if ($(window).width() < 1199) {
            $scope.halfScale = true;
        }
        if ($(window).width() < 1199) {
            $scope.winComparisonOrderReportsWidth = "96%";
        } else {
            $scope.winComparisonOrderReportsWidth = "70%";
        }
        // Share Exam popup window width
        if ($(window).width() < 1199) {
            $scope.winShareExamWindowWidth = "80%";
        } else {
            $scope.winShareExamWindowWidth = "60%";
        }

        if ($(window).width() < 1199) {
            $scope.winConsultExamWindowWidth = "80%";
        } else {
            $scope.winConsultExamWindowWidth = "60%";
        }

        $scope.menuExists = false;
        $scope.winDiscussionWidth = "80%";
        if ($(window).width() < 1199) {
            $scope.win_ModalReportNDiscussWidth = "96%";
        } else {
            $scope.win_ModalReportNDiscussWidth = "70%";
        }
        $scope.win_ContactListWidth = "500";
        $scope.win_SingReportWidth = "50%";
        $scope.win_PSUserWidth = "60%";
        $scope.win_HideStudyWidth = "50%";
        if ($(window).width() < 1199) {
            $scope.win_HideStudyWidth = "56%";
        } else {
            $scope.win_HideStudyWidth = "50%";
        }
        $scope.win_ContactListWidth_new = "55%";
        $scope.win_ContactListWidth_new = $scope.halfScale ? "90%" : "55%";
        $scope.PageNo = 1;
        $scope.PageSize = "50";
        $scope.workListSaved = false;
        $scope.contextMenus = [];
        $scope.locationIDs = '';
        $scope.WorkList_Admin = '';
        $scope.WorkList_User = '';
        $scope.modalityIDs = '';

        $scope.htmlPopover = $sce.trustAsHtml('<div class="single4 v-a-m"></div>');
        $scope.popoverOpened1 = false;
        $scope.popoverDicomOrderID = '';

        $scope.Rule = {};
        $scope.RuleTable = [];
        $scope.SelectedRuleIndex = -1;
        $scope.ModalWorklistOpened = false;

        //Custom date range settings
        $scope.OrderDate = {
            startDate: moment().subtract(6, 'days'),
            endDate: moment()
        };
        $scope.OrderDateType = 'Last 7 Days';
        $scope.editOrderDateType = null;
        $scope.editOrderDate = {
            startDate: null,
            endDate: null
        };
        $scope.opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            //cancelButtonClasses: 'dr-btn-none',
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",

                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.OrderDate = {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                }
            },
            ranges: {
                'Today': [moment(), moment()],
                //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                //'Last 15 Days': [moment().subtract(14, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                //'This Month': [moment().startOf('month'), moment().endOf('month')],
                //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
                'Last 5 Years': [moment().subtract(5, 'years'), moment()],
                //'All DOS': [],

            }
        };

        var parser = new UAParser();
        $scope.browser = parser.getBrowser().name;

        var _gridAPI;
        var _subGridAPI;
        var columnVersion = 9.3;
        var previouslySelectedFilter = {};

        $scope.htmlPopover = $sce.trustAsHtml('<div class="single4 v-a-m"></div>');
        $scope.htmlViewerPopOver = $sce.trustAsHtml('<div class="single4 v-a-m"></div>');

        $scope.popoverOpened1 = false;
        $scope.popoverDicomOrderID = '';
        $scope.viewerPopOverOpened = false;
        $scope.viewerPopOverDicomOrderID = null;
        $scope.viewerPopOverOrder = null;
        $scope.selectedComparisonRow = {};
        $scope.RowHeight = 26;

        var positionChanged = false;
        var visiblePendingSince = false;

        var refreshDOSInterval = 1000;

        var currentHeight = 0;
        var previousHeight = 0;
        $scope.defaultWindowHeight = "80%";
        $scope.hideStudyWindowHeight = "35%";
        $scope.orderingPhysicianWindowHeight = "20%";
        // $scope.addEditContactWindowHeight = $scope.halfScale ? "55%" : "50%";

        $scope.DefaultDictationSystem = "";
        $scope.DictationReportState = "";

        $scope.AutoRefresh = false;
        var refreshOnClick = false;
        var SortColumns = [];
        var SortingByMultiColumn = '';
        var DefaultSortingColumn = 'O.ReceivedSinceDateTime';
        var DefaultSortingDirection = 'ASC';
        $scope.HideStudyPriority = false;

        $scope.DictationReportStatus = '';

        // $scope.win_ContactListHeight = $scope.halfScale ? "80%" : "80%";

        $scope.DictatedAccessionNumber = [];
        $scope.NativeMessageResponseReportStatus = -2;
        $scope.PendingSinceCurrentDate = new Date();
        $scope.OpenedAccessionNumber = '';

        $scope.SaveDiscussionFlag = false;

        $scope.WorklistPageHeaderParameter.Charges = 0;
        $scope.WorklistPageHeaderParameter.isPCAvailable = false;
        var HiddenTypesTooltip = [];
        $scope.AddressBookInfo = {};

        var ClipboardRule = {};
        var RuleTable = {};
        var ToasterMessage = 'Contact added successfully!';
        var OpenOrder = {};
        var ShowReleaseGuide = 0;
        var ReportList = [];
        $scope.PriorReportFilter = {
            Options: { DateRange: 'Any', Modality: 'All', SearchText: '' },
            List: WorklistService.GetReportListModalityNDateRange(),
            Modal: false,
            SortingPropName: 'OrderDate',
            SortingOrder: true,
            SortingOptions: ['DOS (newest first)', 'DOS (oldest first)', 'Rendering Physician (A to Z)', 'Rendering Physician (Z to A)', 'Procedure (A to Z)', 'Procedure (Z to A)'],
            SortingOption: 'DOS (newest first)',
        };
        $scope.ShowPracticeWorklist = true;
        $scope.WorklistDropdown = [{ Key: 'PSW', Value: 'Practice Worklist' }, { Key: 'PRW', Value: 'Personal Worklist' }];
        var patientNameCellTemplate = '<div class="pt-0 " title="TOOLTIP">' +
            '<div class="text-truncate">{{row.entity.PatientName}}</div><div class="float-left">{{row.entity.PatientDOB | date:"M/d/yy"}}</div><div class="mx-2px float-left">|</div>' +
            '<span ng-if=\"grid.appScope.halfScale\">{{row.entity.PatientGender}}</span>' +
            '<span ng-if=\"!grid.appScope.halfScale\">{{row.entity.PatientGender == "M" ? "Male" : "Female"}}</span>' +
            '</div>';

        var discussionCellTemplate = '<div class="ui-grid-cell-contents pt-4px pb-0">' +
            '<div class="icon-container w-100 float-left text-center pos-rel" ' +
            //'style="line-height:2.4em !important" ' +
            //'ng-init="grid.appScope.hidePopover()" ' +
            'ng-mouseenter="grid.appScope.showPopover(row.entity.DicomOrderID, row.entity.IsDiscussion)" ' +
            'ng-click="grid.appScope.LoadOnlyDiscussion(row.entity.DicomOrderID, \'Discussion\')" data-toggle="modal" title="" ' +
            'data-target="#ModalDiscussion" >' +
            '<span class="glyphicon glyphicon-paperclip icon-paperclip cursor-pointer z-i-1 fs-14px pos-abs txt-clr-1" title="Discussion" ' +
            'style="top:-2px;" aria-hidden="true" ng-if="row.entity.FileCount > 0"></span>' +
            '<span class="fa fa-comments cursor-pointer fs-14px" aria-hidden="true" title="Discussion" ' +
            'ng-show="row.entity.DicomOrderID" ng-class="row.entity.IsDiscussion ? \'green\' : \'gray\'" ' +
            'ng-if="row.entity.IsDiscussion && row.entity.DicomOrderID == grid.appScope.popoverDicomOrderID" ' +
            'uib-popover-html="grid.appScope.htmlPopover" popover-trigger="outsideClick" ' +
            'popover-placement="auto bottom" popover-is-open="grid.appScope.popoverOpened1" popover-class="popoverwl" ' +
            'popover-append-to-body="true"></span>' +
            '<span class="fa fa-comments cursor-pointer fs-14px" aria-hidden="true" title="Discussion" ' +
            'ng-show="row.entity.DicomOrderID" ng-class="row.entity.IsDiscussion ? \'green\' : \'gray\'" ' +
            'ng-if="row.entity.IsDiscussion && row.entity.DicomOrderID != grid.appScope.popoverDicomOrderID" ></span>' +
            '<span class="fa fa-comment-o cursor-pointer fs-14px txt-clr-14 pt-1px" aria-hidden="true" title="Discussion" ' +
            'ng-show="row.entity.DicomOrderID" ng-class="row.entity.IsDiscussion ? \'green\' : \'gray\'" ' +
            'ng-if="!row.entity.IsDiscussion"></span></div >' +
            '</div>' +
            '';

        var col1CellTemplate = '<div class="ui-grid-cell-contents overflow-visible pt-5px">' +
            '<a ng-click="grid.appScope.GetOrdersComparisonList(row)" ' +
            'class="cursor-pointer px-0 tooltip-w-130px d-block text-center" ' +
            'ng-if="row.entity.HasComparison == \'1\' && row.entity.Status != \'X\'" >' +
            '<span class="fa fa-plus fs-15px txt-clr-14" title="Expand"' +
            'ng-if="!row.entity.isCollapsed"> ' +
            '</span> ' +
            '<span class="fa fa-minus fs-15px txt-clr-14" title="Collapse"' +
            'ng-if="row.entity.isCollapsed"> ' +
            '</span> ' +
            '</a> ' +
            '</div>' +
            '';

        var userLockIconCellTemplate = '<div class="ui-grid-cell-contents overflow-visible pt-5px text-center">' +
            '<div ng-switch on="grid.appScope.setUserIconCase(row)">' +
            '<div ng-switch-when="Lock">' +
            '<i class="fa fa fa-lock fs-15px txt-clr-14" title="{{grid.appScope.LoggedInUserID != ' + 'row.entity.LockByProviderID ? row.entity.LockBy : \'\'}}"> ' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="Assignment">' +
            '<span title="{{grid.appScope.getOrderListTooltip(row.entity)}}" class="fa fa-user fs-15px v-a-t d-block py-5px cursor-pointer pt-0 text-center" ' +
            'ng-style="{\'color\' : (row.entity.OrderAssingedUser && ' +
            'grid.appScope.LoggedInUserID == row.entity.OrderAssingedUser) ? \'green\' : \'grey\'}" ' +
            ' ></span>' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="AssignmentMyClipboard" class="d-flex justify-content-center">' +
            '<span title="{{grid.appScope.getOrderListTooltip(row.entity)}}" class="fa fa-user fs-15px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'ng-style="{\'color\' : (row.entity.OrderAssingedUser && ' +
            'grid.appScope.LoggedInUserID == row.entity.OrderAssingedUser) ? \'green\' : \'grey\'}" ' +
            ' ></span>' +
            '<span  class="glyphicon glyphicon-copy fs-9px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'style="color:green" ' +
            ' ></span>' +
            '</div>' +
            '<div ng-switch-when="AssignmentOtherClipboard" class="d-flex justify-content-center">' +
            '<span title="{{grid.appScope.getOrderListTooltip(row.entity)}}" class="fa fa-user fs-15px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'ng-style="{\'color\' : (row.entity.OrderAssingedUser && ' +
            'grid.appScope.LoggedInUserID == row.entity.OrderAssingedUser) ? \'green\' : \'grey\'}" ' +
            ' ></span>' +
            '<span  class="glyphicon glyphicon-copy fs-9px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'style="color:grey" ' +
            ' ></span>' +
            '</div>' +
            '<div ng-switch-when="CopiedtoOtherClipboard">' +
            '<span title="Copied to Other Clipboard" class="glyphicon glyphicon-copy fs-15px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'style="color:grey" ' +
            ' ></span>' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="CopiedtoMyClipboard">' +
            '<span title="Copied to My Clipboard" class="glyphicon glyphicon-copy fs-15px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'style="color:green" ' +
            ' ></span>' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="NA">' +
            '<i class="fa fa fa-times fs-20px" style="color: red;" > ' +
            '<span class="tultiptext">Study not available!</span> ' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="empty">' +
            '<span ></span> ' +
            '</div>' +
            '</div>' +
            '</div>' +
            '';

        var orderPhysianTemplate = '<div class="ui-grid-cell-contents">' +
            '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body="true" ng-if="row.entity.OrderingPhysicianPhone">' +
            '<a href id="simple-dropdown" uib-dropdown-toggle class="op-nohover txt-clr-32" >' +
            '{{row.entity.OrderingPhysician | UpperCase }}' +
            '</a>' +
            '<ul class="dropdown-menu opdrop-1 p-0 border-0 min-w-200px" uib-dropdown-menu aria-labelledby="simple-dropdown">' +
            '<li class="no-list-bullet">' +
            '<div class="bg-clr-30 p-5px-all fs-13px cursor-pointer text-center">' +
            '{{row.entity.OrderingPhysician | UpperCase }}' +
            '</div>' +
            '<div class="bg-clr-30 text-truncate py-10px px-5px fs-13px cursor-pointer text-center">' +
            'Contact: {{row.entity.OrderingPhysicianPhone | tel }}' +
            '</div>' +
            '</li>' +
            '</ul>' +
            '</span>' +
            '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body="true" ng-if="!row.entity.OrderingPhysicianPhone">' +
            '<a href id="simple-dropdown" uib-dropdown-toggle class="op-nohover txt-clr-32" >' +
            '{{row.entity.OrderingPhysician | UpperCase }}' +
            '</a>' +
            '<ul class="dropdown-menu opdrop-2 border-0 rounded-0 fw-500 fs-13px" uib-dropdown-menu aria-labelledby="simple-dropdown" >' +
            '<li ng-click="grid.appScope.showContact(row.entity.OrderingPhysician, row.entity.LocationID,row.entity.Location)" class="no-list-bullet">' +
            '<span class="txt-clr-1 cursor-pointer">Search Contact <i class="fa fa-search fs-18px"></i></span> ' +
            '</li>' +
            '</ul>' +
            '</span>' +
            '</div>' +
            '';

        var orderddPhysianTemplate = '<div class="ui-grid-cell-contents">' +
            '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body="true" ng-if="row.entity.OrderingPhysicianPhone">' +
            '<a href id="simple-dropdown" uib-dropdown-toggle class="op-nohover" ng-style="{\'color\': row.entity.RowColorCode}">' +
            '{{row.entity.OrderingPhysician | UpperCase }}' +
            '</a>' +
            '<ul class="dropdown-menu opdrop-1 p-0 border-0 min-w-200px" uib-dropdown-menu aria-labelledby="simple-dropdown">' +
            '<li class="no-list-bullet">' +
            '<div class="bg-clr-30 p-5px-all fs-13px cursor-pointer text-center">' +
            '{{row.entity.OrderingPhysician | UpperCase }}' +
            '</div>' +
            '<div class="bg-clr-30 text-truncate py-10px px-5px fs-13px cursor-pointer text-center">' +
            'Contact: {{row.entity.OrderingPhysicianPhone | tel }}' +
            '</div>' +
            '</li>' +
            '</ul>' +
            '</span>' +
            '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body="true" ng-if="!row.entity.OrderingPhysicianPhone">' +
            '<a href id="simple-dropdown" uib-dropdown-toggle class="op-nohover" ng-style="{\'color\': row.entity.RowColorCode}">' +
            '{{row.entity.OrderingPhysician | UpperCase }}' +
            '</a>' +
            '<ul class="dropdown-menu opdrop-2 border-0 rounded-0 fw-500 fs-13px" uib-dropdown-menu aria-labelledby="simple-dropdown" >' +
            '<li ng-click="grid.appScope.showContact(row.entity.OrderingPhysician, row.entity.LocationID,row.entity.Location)" class="no-list-bullet">' +
            '<span tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ' +
            'uib-tooltip="Search By Address Book" class="txt-clr-1 cursor-pointer">Search Contact <i class="fa fa-search fs-18px"></i></span> ' +
            '</li>' +
            '</ul>' +
            '</span>' +
            '</div>' +
            '';

        var createdDateTemplate = '<div class="ui-grid-cell-contents py-0 d-flex align-item-center pos-rel rel-b-2-p">' +
            '<span>{{row.entity.CreatedDate | localDate:false}}</span>' +
            '</div>' +
            '';
        var DOSTemplate = '<div class="ui-grid-cell-contents py-0 d-flex align-item-center pos-rel rel-b-2-p">' +
            '<span>{{row.entity.OrderDate | localDate:false}}</span>' +
            '</div>' +
            '';
        var pendingSinceTemplate = '<div class="ui-grid-cell-contents py-0 d-flex align-item-center pos-rel rel-b-2-p">' +
            '<span>{{row.entity.CreatedDate | localDate:true:grid.appScope.PendingSinceCurrentDate}}</span>' +
            '</div>' +
            '';
        var viewerddCellTemplate = '<div class="ui-grid-cell-contents overflow-visible text-center">' +
            '<div class="viewer-section">' +
            '<a href id="viewer-dropdown" >' +
            '<i class="fa fa-picture-o fs-14px txt-clr-14"></i> ' +
            '</a>' +
            '<div class="dropdown-content dropdown-menu-right">' +
            '<ul >' +
            '<li ng-repeat="DV in row.entity.OptionalDicomViewer.split(\',\') | orderBy" ' +
            'ng-click="grid.appScope.OpenSynapseStudy(row.entity, DV, false, true)" >   ' +
            '<a>{{grid.appScope.SetDicomViewerText(DV)}}</a> ' +
            //'<a ng-show="DV == CANDELIS\'">CANDELIS</a> ' +
            //'<a ng-show="DV == \'KONICA\'">KONICA</a> ' +
            //'<a ng-show="DV == \'KONICATEST\'">KONICATEST</a> ' +
            //'<a ng-show="DV == \'SYNAPSE\'">SYNAPSE</a> ' +
            //'<a ng-show="DV == \'GECUV\'">GE Centricity</a> ' +
            //'<a ng-show="DV == \'CI-VIEWER\'">CI-VIEWER</a> ' +
            //'<a ng-show="DV == \'North Star Konica\'">North Star Konica</a> ' +
            '</li>' +
            '</ul>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '';

        var civrCellTemplate = '<div class="ui-grid-cell-contents text-center">' +
            '<div class="" > ' +
            '<a ' +
            'class="cursor-pointer no-bg" title="Open CIVR" ng-click="grid.appScope.OpenVR(row.entity,true)">' +
            '<img style="top:1px;" ' +
            'src="https://civr.collaborativeimaging.com/assets/img/favicon-16x16.png" title="Open CIVR" class="w-14px pos-rel mr-1px"/> ' +
            '</a> ' +
            '</div> ' +
            '</div>' +
            '';

        var reportParentCellTemplate = '<div class="ui-grid-cell-contents pt-5px text-center">' +
            '<a ng-click="grid.appScope.ViewOrderReport(row.entity, row.entity.Accession)" ' +
            'class="cursor-pointer tultip-right no-bg" ' +
            'ng-if="row.entity.ReportStatus == 1 || row.entity.ReportStatus == 2 || row.entity.ReportStatus == 5"> ' +
            '<i class="fa fa-exclamation-triangle fs-14px txt-clr-14" ng-if="row.entity.IsDeficient == true" ></i> ' +
            '<i class="fa fa-file-text-o fs-14px txt-clr-14" ng-if="row.entity.IsDeficient == false"></i> ' +
            //'<span class="tultiptext overflow-auto tt-white">View Report</span> ' +
            '</a> ' +
            '</div>' +
            '';

        var shareExamCellTemplate = '<div class="ui-grid-cell-contents text-center pt-1">' +
            '<div class="" > ' +
            '<a ' +
            'class="cursor-pointer no-bg" title="Share Exam" ng-click="grid.appScope.openShareExamWindow()">' +
            '<i class="fa fa-share txt-clr-14" aria-hidden="true"></i> ' +
            '</a> ' +
            '</div> ' +
            '</div>' +
            '';
        var reportSignedDate = '<div class="ui-grid-cell-contents py-0 d-flex align-item-center pos-rel rel-b-2-p">' +
            '<span>{{row.entity.ReportSignDate | localDate:false}}</span>' +
            '</div>' +
            '';

        var accessionCellTemplate = '<div class="ui-grid-cell-contents py-0 d-flex align-item-center pos-rel rel-b-2-p">' +
            '<span>{{row.entity.Accession | uppercase}}</span>' +
            '</div>' +
            '';

        var patientMRNCellTemplate = '<div class="ui-grid-cell-contents py-0 d-flex align-item-center pos-rel rel-b-2-p">' +
            '<span>{{row.entity.PatientMRN | uppercase}}</span>' +
            '</div>' +
            '';

        var cellClass = 'py-2px px-5px';
        var textPadding = 'pt-4px px-5px';
        var columnDefs = [
            { name: "Comparison", displayName: "", enableSorting: false, enableColumnMoving: false, enableHiding: false, width: 30, cellTemplate: col1CellTemplate, enableColumnResizing: false, },
            { name: "User", displayName: "", enableSorting: false, enableColumnMoving: false, enableHiding: false, width: 30, cellTemplate: userLockIconCellTemplate, enableColumnResizing: false, },
            { name: "Location", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "Accession", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*", cellTemplate: accessionCellTemplate },
            {
                name: "OrderDate", displayName: "DOS", type: "date", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, maxWidth: 120, width: "*", cellTemplate: DOSTemplate,
            },
            { name: "PatientMRN", displayName: "MRN", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*", cellTemplate: patientMRNCellTemplate },
            { name: "PatientName", displayName: "Patient Name", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "FormattedPatientDOB", displayName: "DOB", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, maxWidth: 70, width: "*" },
            {
                name: "PatientGender", displayName: "Gender", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, maxWidth: 80, width: "*"
            },
            { name: "PatientAge", displayName: "Age", cellTooltip: true, width: 60, cellClass: textPadding, headerCellClass: cellClass, },
            { name: "PatientClass", displayName: "Type", cellTooltip: false, maxWidth: 70, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "Modality", cellTooltip: true, maxWidth: 90, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "ProcedureDesc", displayName: "Procedure", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "OrderingPhysician", displayName: "Ordering Physician", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, cellTemplate: orderddPhysianTemplate, width: "*" },
            { name: "CreatedDate", displayName: "Created Date", cellTooltip: false, cellClass: textPadding, headerCellClass: cellClass, cellTemplate: createdDateTemplate, width: "*" },
            { name: "ReceivedSince", displayName: "Pending Since", cellTooltip: false, cellClass: textPadding, headerCellClass: cellClass, cellTemplate: pendingSinceTemplate, width: "*", visible: ($scope.Status.key == 'RP' || $scope.Status.key == 'D'), enableHiding: ($scope.Status.key == 'RP' || $scope.Status.key == 'D'), enableSorting: false, },
            { name: "SignByName", displayName: "Rendering Physician", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*", visible: false },
            { name: "ReportSignDate", displayName: "Signed Date", cellTooltip: false, cellClass: textPadding, headerCellClass: cellClass, cellTemplate: reportSignedDate, width: "*", visible: false },
            { name: "Reason", displayName: "Reason", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*", visible: false, },
            { name: "ImageInstance", displayName: "Images", enableColumnMoving: true, cellTooltip: true, maxWidth: 80, enableSorting: false, cellClass: textPadding, headerCellClass: 'cellClass arrowcursor py-2px pl-5px', width: "*" },
            { name: "Priority", displayName: "Priority", enableColumnMoving: true, cellTooltip: true, enableSorting: false, cellClass: textPadding, headerCellClass: 'cellClass arrowcursor py-2px pl-5px', width: "*" },
            { name: "WorkRVU", displayName: "Estimated wRVU", enableColumnMoving: true, cellTooltip: true, maxWidth: 150, enableSorting: false, cellClass: textPadding, headerCellClass: 'cellClass arrowcursor py-2px pl-5px', width: "*" },
            { name: "Optional Image viewer", displayName: "", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, cellTemplate: viewerddCellTemplate, enableColumnResizing: false, headerCellClass: 'arrowcursor', cellClass: textPadding },
            { name: "Open CIVR", displayName: "", cellClass: 'text-center textPadding', enableColumnMoving: true, enableSorting: false, enableHiding: true, width: 30, visible: $scope.browser.toUpperCase() != 'IE', cellTemplate: civrCellTemplate, cellTooltip: function (row, col) { return 'Open CIVR' }, enableColumnResizing: false, headerCellClass: 'arrowcursor', },
            { name: "View Report", displayName: "", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, cellTemplate: reportParentCellTemplate, enableColumnResizing: false, headerCellClass: 'arrowcursor' },
            { name: "Share Exam", displayName: "", cellClass: 'text-center textPadding', enableColumnMoving: true, enableSorting: false, enableHiding: true, width: 30, cellTemplate: shareExamCellTemplate, cellTooltip: function (row, col) { return 'Share Exam' }, enableColumnResizing: false, headerCellClass: 'arrowcursor', },
            { name: "Discussion", displayName: "", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, cellTemplate: discussionCellTemplate, cellClass: "overflow-visible", enableColumnResizing: false, headerCellClass: 'arrowcursor', },
        ];
        //, \'background-color\': grid.appScope.SelectedOrderID == row.entity.DicomOrderID ? \'#424242\' : \'\'
        //TODO: ROW TOOLTIP

        //var rowTemplate = '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
        //    'ng-if="grid.appScope.openContextMenuOptions(row.entity).length > 0"'+
        //    'ui-grid-cell context-menu="grid.appScope.openContextMenuOptions(row.entity)" ' +
        //    'ng-dblclick="grid.appScope.OpenSignReport(row.entity, grid.appScope.orderList)"' +
        //    'ng-click="grid.appScope.setSelected(row.entity.OrderID, row.entity); grid.appScope.clearSelectedChildRows();"' +
        //    'ng-style="{\'color\': row.entity.RowColorCode}" ' +
        //    'class="ui-grid-cell"  ui-grid-cell tooltip-class="uibtooltipDenial" tooltip-placement="auto top-left" uib-tooltip="{{((row.entity.Status == \'D\' && row.entity.SignByName.length > 0) ? ' + '\'Drafted by \' + row.entity.SignByName  : (row.entity.Status == \'C\' && row.entity.SignByName.length > 0) ' + '? \'Signed by \' + row.entity.SignByName : \'\')}}" ' +
        //    ' > ' +
        //    '</div>' +
        //    '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
        //    'ng-if="grid.appScope.openContextMenuOptions(row.entity).length == 0"' +
        //    'ui-grid-cell ' +
        //    'ng-dblclick="grid.appScope.OpenSignReport(row.entity, grid.appScope.orderList)"' +
        //    'ng-click="grid.appScope.setSelected(row.entity.OrderID, row.entity); grid.appScope.clearSelectedChildRows();"' +
        //    'ng-style="{\'color\': grid.appScope.getRowTemplateColorCode(row.entity)}" ' +
        //    'class="ui-grid-cell"  ui-grid-cell tooltip-class="uibtooltipDenial" tooltip-placement="auto top-left" uib-tooltip="{{((row.entity.Status == \'D\' && row.entity.SignByName.length > 0) ? ' + '\'Drafted by \' + row.entity.SignByName  : (row.entity.Status == \'C\' && row.entity.SignByName.length > 0) ' + '? \'Signed by \' + row.entity.SignByName : \'\')}}" ' +
        //    ' > ' +
        //    '</div>';
        var rowTemplate = '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
            'ng-if="grid.appScope.NoContextMenuOptions(row.entity)"' +
            'ui-grid-cell context-menu="grid.appScope.openContextMenuOptions(row.entity)" ' +
            'ng-dblclick="grid.appScope.OpenSignReport(row.entity, grid.appScope.orderList)"' +
            'ng-click="grid.appScope.setSelected(row.entity.OrderID, row.entity); grid.appScope.clearSelectedChildRows();"' +
            'ng-style="{\'color\': row.entity.RowColorCode}" ' +
            'class="ui-grid-cell"  ui-grid-cell tooltip-class="uibtooltipDenial" tooltip-placement="auto left" tooltip-append-to-body="true" uib-tooltip="{{((row.entity.Status == \'D\' && row.entity.SignByName.length > 0) ? ' + '\'Drafted by \' + row.entity.SignByName  : (row.entity.Status == \'C\' && row.entity.SignByName.length > 0) ' + '? \'Signed by \' + row.entity.SignByName : \'\')}}" ' +
            ' > ' +
            '</div>' +
            '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
            'ng-if="!grid.appScope.NoContextMenuOptions(row.entity)"' +
            'ui-grid-cell ' +
            'ng-dblclick="grid.appScope.OpenSignReport(row.entity, grid.appScope.orderList)"' +
            'ng-click="grid.appScope.setSelected(row.entity.OrderID, row.entity); grid.appScope.clearSelectedChildRows();"' +
            'ng-style="{\'color\': row.entity.RowColorCode}" ' +
            'class="ui-grid-cell"  ui-grid-cell tooltip-class="uibtooltipDenial" tooltip-placement="auto left" tooltip-append-to-body="true" uib-tooltip="{{((row.entity.Status == \'D\' && row.entity.SignByName.length > 0) ? ' + '\'Drafted by \' + row.entity.SignByName  : (row.entity.Status == \'C\' && row.entity.SignByName.length > 0) ' + '? \'Signed by \' + row.entity.SignByName : \'\')}}" ' +
            ' > ' +
            '</div>';

        var expandableRowTemplate = '<div class="anuichildsection" ui-grid="row.entity.subGridOptions" style="width:100%; " ' +
            'ng-style="{height: (((row.entity.ComparisonOrder.length * grid.appScope.RowHeight) + 1) + \'px\')}"' +
            'context-menu="grid.appScope.expandedOpenContextMenuOptions(row)" ' +
            'ng-click="grid.appScope.setSelectedComparison()" ' +
            'tooltip-class="uibtooltipDenial tt-black" tooltip-placement="auto left" tooltip-append-to-body="true" ' +
            'uib-tooltip="{{((row.entity.Status == \'D\' && row.entity.SignByName.length > 0) ? ' +
            '\'Drafted by \' + row.entity.SignByName  : (row.entity.Status == \'C\' && row.entity.SignByName.length > 0) ' +
            '? \'Signed by \' + row.entity.SignByName : \'\')}}" ui-grid-move-columns ui-grid-auto-resize ui-grid-pinning ui-grid-selection>' +
            '</div>' +
            '';


        var eCellClass = 'pt-4px px-5px txt-clr-32';

        $scope.expandableColumnDefs = [
            { name: "Comparison", enableSorting: false, enableColumnMoving: false, enableHiding: false, width: 30, enableColumnResizing: false, },
            { name: "User", enableSorting: false, enableColumnMoving: false, enableHiding: false, width: 30, enableColumnResizing: false, },
            { name: "Location", cellTooltip: true, cellClass: eCellClass, width: "*" },
            { name: "Accession", cellTooltip: true, cellClass: eCellClass, width: "*", cellTemplate: accessionCellTemplate },
            {
                name: "OrderDate", type: "date", cellTooltip: true, cellClass: eCellClass, maxWidth: 120, width: "*", cellTemplate: DOSTemplate,
            },
            { name: "PatientMRN", cellTooltip: true, cellClass: eCellClass, width: "*", cellTemplate: patientMRNCellTemplate },
            { name: "PatientName", cellTooltip: true, cellClass: eCellClass, width: "*" },
            { name: "FormattedPatientDOB", cellTooltip: true, cellClass: eCellClass, maxWidth: 70, width: "*" },
            {
                name: "PatientGender", cellTooltip: true, cellClass: eCellClass, maxWidth: 80, width: "*"
            },
            { name: "PatientAge", cellTooltip: true, width: 60, cellClass: eCellClass, },
            { name: "PatientClass", cellTooltip: false, maxWidth: 70, cellClass: eCellClass, width: "*" },
            { name: "Modality", cellTooltip: true, maxWidth: 90, cellClass: eCellClass, width: "*" },
            { name: "ProcedureDesc", cellTooltip: true, cellClass: eCellClass, width: "*" },
            { name: "OrderingPhysician", cellTooltip: true, cellClass: eCellClass, cellTemplate: orderPhysianTemplate, width: "*" },
            { name: "CreatedDate", cellTooltip: false, cellClass: eCellClass, cellTemplate: createdDateTemplate, width: "*" },
            { name: "ReceivedSince", cellTooltip: false, cellClass: eCellClass, width: "*", visible: ($scope.Status.key == 'RP' || $scope.Status.key == 'D') },
            { name: "SignByName", cellTooltip: true, cellClass: eCellClass, width: "*", visible: false },
            { name: "ReportSignDate", cellTooltip: false, cellClass: eCellClass, cellTemplate: reportSignedDate, width: "*", visible: false },
            { name: "Reason", cellTooltip: true, cellClass: eCellClass, width: "*", visible: false, },
            { name: "ImageInstance", enableColumnMoving: true, cellTooltip: true, maxWidth: 80, enableSorting: false, cellClass: eCellClass, width: "*" },
            { name: "Priority", displayName: "Priority", enableColumnMoving: true, cellTooltip: true, enableSorting: false, cellClass: eCellClass, width: "*" },
            { name: "WorkRVU", enableColumnMoving: true, cellTooltip: true, maxWidth: 150, enableSorting: false, cellClass: eCellClass, width: "*" },
            { name: "Optional Image viewer", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, enableColumnResizing: false, },
            { name: "Open CIVR", cellClass: 'text-center', enableColumnMoving: true, enableSorting: false, enableHiding: true, width: 30, visible: $scope.browser.toUpperCase() != 'IE', enableColumnResizing: false, },
            { name: "View Report", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, cellTemplate: reportParentCellTemplate, enableColumnResizing: false, },
            { name: "Share Exam", cellClass: 'text-center', enableColumnMoving: true, enableSorting: false, enableHiding: true, width: 30, enableColumnResizing: false, },
            { name: "Discussion", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, enableColumnResizing: false, },
        ];

        $scope.uiGridOptions = {
            columnDefs: columnDefs,
            appScopeProvider: $scope,
            enableColumnResizing: true,
            enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
            excessRows: 30,
            excessColumns: 19,
            virtualizationThreshold: 200,
            columnVirtualizationThreshold: 100,
            showExpandAllButton: false,
            enableOnDblClickExpand: false,
            enableExpandableRowHeader: false,
            expandableRowTemplate: expandableRowTemplate,
            //expandableRowHeight: 150,
            //subGridVariable will be available in subGrid scope
            //expandableRowScope: $scope.scopeVariable,
            expandableRowScope: {
                subGridVariable: 'subGridScopeVariable',
            },
            gridMenuCustomItems: [
                {
                    title: 'Reset',
                    action: function ($event) {
                        //////$log.log("reset");

                        var cols = onReset();
                        var colDefs = [];
                        _.each(cols, function (col) {
                            colDefs.push(col.colDef);
                        });
                        //$scope.uiGridOptions.columnDefs = columnDefs;

                        var userPref = { version: columnVersion, columnDefs: colDefs, SortColumns: SortColumns };
                        updateUserLayoutPreference(userPref);
                    },
                }
            ],
            multiSelect: false,
            useExternalSorting: true,
            //suppressMultiSort: true,
            showGridFooter: true,
            infiniteScrollRowsFromEnd: 10,
            infiniteScrollUp: true,
            infiniteScrollDown: true,
            enableColumnMenus: false,
            enableRowSelection: true,
            noUnselect: true,
            enableFullRowSelection: true,
            enableGridMenu: true,
            enableColumnMoving: true,
            rowHeight: $scope.RowHeight, //set row height
            enableRowHeaderSelection: false, //hide check mark
            enableHorizontalScrollbar: 2, //hide scroll dot
            rowTemplate: rowTemplate,
            gridFooterTemplate: '<div class="ui-grid-bottom-panel text-right bg-clr-31 txt-clr-1 fw-500 px-8px showingftxt w-100 h-35px f-f-quicksand footerfix d-flex align-item-center"><marquee style="font-size: 14px;font-weight: 600;margin-right: 30px;flex:1;">*** The Worklist (Single View) feature will be discontinued on 28-Feb-2025. Please transition to using the Worklist (Multi View) before this date. ***</marquee><span>Showing {{grid.appScope.orderList.length}} of {{grid.appScope.TotalRows}} Total Records</span></div>',
            data: 'orderList',
            onRegisterApi: function (gridApi) {
                ////$log.log("onRegisterApi");
                var pageTopheight = $(".page-top").height();
                var headerHeight = $(".radf-header").height();
                var topSectionHeight = $("#collapseWorklist").height();
                var height = $(window).height();
                angular.element(document.getElementsByClassName('grid')[0]).css('height', (height - topSectionHeight - headerHeight - pageTopheight - 0) + 'px');

                gridApi.infiniteScroll.on.needLoadMoreData($scope, getDataDown);
                gridApi.infiniteScroll.on.needLoadMoreDataTop($scope, getDataUp);

                gridApi.selection.on.rowSelectionChanged($scope, doSelection);

                gridApi.colMovable.on.columnPositionChanged($scope, columnPositionChanged);

                gridApi.core.on.columnVisibilityChanged($scope, columnVisibilityChanged);
                gridApi.core.on.sortChanged($scope, onSortChanged);

                gridApi.expandable.on.rowExpandedStateChanged($scope, function (row) {
                    row.expandedRowHeight = (row.entity.ComparisonOrder.length * $scope.RowHeight) + 1;
                    $scope.selectedComparisonRow = row;
                    $scope.subUIGridOptions.excessRows = row.entity.ComparisonOrder.length;

                    $timeout(function () {
                        $('.ui-grid .ui-grid-render-container-body .ui-grid-viewport').eq(1).css('cssText', 'overflow-y: hidden !important; overflow-x: hidden !important;');

                        $('.ui-grid-render-container-body .ui-grid-viewport').eq(1).css('cssText', 'height:' + $scope.selectedComparisonRow.expandedRowHeight + 'px !important;');
                        $('.ui-grid .ui-grid-render-container-body .ui-grid-viewport').eq(0).css('cssText', 'overflow-y: auto !important; overflow-x: auto !important;');

                        updateComparisonColumns();
                    }, 1000);
                });

                gridApi.core.on.rowsRendered($scope, function () {
                    if (!$scope.initialColumnOrder || $scope.initialColumnOrder.length == 0)
                        $scope.initialColumnOrder = gridApi.grid.columns.slice();

                    if ($scope.selectedComparisonRow && $scope.selectedComparisonRow.entity && $scope.selectedComparisonRow.entity.isCollapsed) {
                        $('.ui-grid .ui-grid-render-container-body .ui-grid-viewport').eq(0).css('cssText', 'overflow-y: auto !important; overflow-x: auto !important;');
                        $('.ui-grid .ui-grid-render-container-body .ui-grid-viewport').eq(1).css('cssText', 'overflow-y: hidden !important; overflow-x: hidden !important;');
                        $('.ui-grid-render-container-body .ui-grid-viewport').eq(1).css('cssText', 'height:' + $scope.selectedComparisonRow.expandedRowHeight + 'px !important;');
                    } else {
                        $('.ui-grid .ui-grid-render-container-body .ui-grid-viewport').css('cssText', 'overflow-y: auto !important; overflow-x: auto !important;');
                    }

                });

                gridApi.colResizable.on.columnSizeChanged($scope, onColumnResize);

                _gridAPI = gridApi;
            }
        };

        $scope.subUIGridOptions = {
            appScopeProvider: $scope,
            enableColumnResizing: true,
            enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
            noUnselect: true,
            multiSelect: false,
            enableRowHeaderSelection: false, //hide check mark
            enableRowSelection: true,
            //noUnselect: true,
            enableFullRowSelection: true,
            showHeader: false,
            enableColumnMenus: false,
            enableColumnMoving: true,
            columnDefs: $scope.expandableColumnDefs,
            data: [],
            //disableRowExpandable: order.HasComparison != '1',
            rowHeight: $scope.RowHeight,
            //expandableRowScope: $scope.scopeVariable,
            //externalScope: $scope.scopeVariable,
            onRegisterApi: function (gridApi) {

                _subGridAPI = gridApi;

            },
        };



        // #endregion



        kendo.ui.Window.fn._keydown = function (originalFn) {
            ////////$log.log("kendo.ui.Window.fn._keydown");
            var KEY_ESC = 27;
            return function (e) {
                if (e.which !== KEY_ESC) {
                    originalFn.call(this, e);
                }
            };
        }(kendo.ui.Window.fn._keydown);


        $scope.resetDateRange = function () {
            ////////$log.log("resetDateRange");
            $scope.opts.ranges = {
                'Today': [moment(), moment()],
                //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                //'Last 15 Days': [moment().subtract(14, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                //'This Month': [moment().startOf('month'), moment().endOf('month')],
                //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
                'Last 5 Years': [moment().subtract(5, 'years'), moment()],
                //'All DOS': [],
            };
            angular.element(document).ready(function () {
                angular.element('.drp-buttons .cancelBtn').click(function () {
                    angular.element('#daterange3').val('');
                    $scope.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                });
            });
            angular.element(document).ready(function () {
                $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
                if ($scope.OrderDate.startDate && $scope.OrderDate.endDate) {
                    if ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom'))
                        $scope.OrderDateType = ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                            moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType;

                }
                else
                    $scope.OrderDateType = 'Clear';
                setOrderDate($scope.OrderDateType);
            });
        }
        angular.element(document).ready(function () {
            ////////$log.log("ready");
            angular.element('.drp-buttons .cancelBtn').click(function () {

                angular.element('#daterange4').val('');
                $scope.editOrderDate = {
                    startDate: null,
                    endDate: null
                };
            });
        });
        angular.element(document).ready(function () {



            angular.element('#daterange4').val(moment().subtract(6, 'days') + ' - ' + moment());
            $scope.editOrderDate = {
                startDate: moment().subtract(6, 'days'),
                endDate: moment()
            };
            $scope.editOrderDateType = 'Last 7 Days';
            if (angular.element(window).width() < 1100) {
                angular.element('.modal-search-contact').parent().addClass('wrapper-search-contact');
            }
            //for mobile devices	
            if (angular.element(window).width() < 768) {
                $scope.WorklistPageHeaderParameter.isfilterCollapse = true;
                angular.element("#collapseWorklist").removeClass("in");
                angular.element('.modal-search-contact').parent().addClass('wrapper-search-contact');
                angular.element('.discsn-popup').parent().addClass('wrapper-search-contact');
            }
            angular.element('html, body').bind('touchmove', function (e) {
                document.webkitExitFullscreen(); /* Safari */
                document.exitFullscreen();
            });
        });
        //Custom date range settings end
        var DuplicateAccession = false;
        var NativeMessageResponse = function (NativeMessageResponse) {
            /*
             *  Discarded = -1, 
                Pending = 0, - Close
                WetRead = 1,
                Draft = 2, - Draft
                PendingCorrection = 3,
                Corrected = 4,
                CorrectionRejected = 5,
                PendingSignature = 6,
                SignRejected = 7,
                Final = 8 - Sign
             */
            //$scope.PDCDeviceID = deviceId;
            // PDCService.setEventMode($scope.PDCDeviceID, 0);
            //console.log(NativeMessageResponse);
            ///{"requestEvent":null,"responseEvent":"ReportResponseDetails","reportRequestDetails":null,"reportResponseDetails":{"responseStatus":true,"siteName":"HCA","accessionNumbers":"I0026035","reportStatus":2,"isAddendum":false,"plainText":"Historoy Exam: - CHEST 1 VIEW PORTABLE \r\nDate: 8/23/2020 11:05 PM \r\nOrdering provider: Mari Yasunaga, MD \r\nComparison: 7/25/2019. \r\nFindings: Cronic Frontal view of the chest is obtained. \r\nThere is mild bronchial wall thickening. The cardiothymic silhouette sfsd sfs\r\n. No evidence of pleural effusion or pneumothorax. \r\nImpression: \r\nMild bronchial wall thickening. This may reflect a viral process or \r\nreactive airways disease. \r\nNo evidence of focal pneumonia.","richText":null},"hostDetails":null}
            console.log("NativeMessageResponse > NativeMessageResponse: ", NativeMessageResponse);

            if (NativeMessageResponse.responseEvent != null
                && NativeMessageResponse.responseEvent == "ReportResponseDetails"
                && NativeMessageResponse.reportResponseDetails != null
                && NativeMessageResponse.reportResponseDetails.ReportResponseEvent == "ReportClosed") {

                // Skip intermediate ReportClosed events (status=0) fired by PS during draft save.
                // PS always fires a second event with the final status (2=Draft, 8=Signed, -1=Discarded).
                if (NativeMessageResponse.reportResponseDetails.reportStatus === 0) {
                    return;
                }

                $scope.DictationReportStatus = NativeMessageResponse.reportResponseDetails.reportStatus == 2 ? 'Draft' : NativeMessageResponse.reportResponseDetails.reportStatus == 8 ? 'Final' : '';
                $scope.NativeMessageResponseReportStatus = NativeMessageResponse.reportResponseDetails.reportStatus;

                var accessions = _.split(NativeMessageResponse.reportResponseDetails.accessionNumbers, ",");
                _.each(accessions, function (accession) {
                    windowHandler.CloseWindow(["CI-VIEWER-1-" + accession.toUpperCase().trim(),
                    "CI-VIEWER-2-" + accession.toUpperCase().trim(),
                    'KONICA-' + accession.toUpperCase().trim(),
                    'KONICATEST-' + accession.toUpperCase().trim(),
                    'MedDreamViewer-' + accession.toUpperCase().trim(),
                    'NORTHSTARKONICA-' + accession.toUpperCase().trim()]);

                    var SignedReportOrder = getOrderByAccessionNPSSiteName(accession, NativeMessageResponse.reportResponseDetails.siteName);
                    if (SignedReportOrder) {

                        // If a new openreport is in-flight for a DIFFERENT accession (user switched studies),
                        // skip auto-advance so we don't collide with that in-flight request.
                        if ($scope.isPSManualOpen) {
                            $scope.isPSManualOpen = false;
                            var isSwitching = $scope.pendingPSAccession &&
                                $scope.pendingPSAccession.toUpperCase().trim() !== accession.toUpperCase().trim();
                            if (isSwitching || $scope.ChooseNextStudy) {
                                $scope.SignReport("", SignedReportOrder);
                            } else {
                                $scope.SignReport("NEXT", SignedReportOrder);
                            }
                        }
                        else if ($scope.ChooseNextStudy) {
                            $scope.SignReport("", SignedReportOrder);
                        }
                        else {
                            $scope.SignReport("NEXT", SignedReportOrder);
                        }


                    }
                });


            }


            if (NativeMessageResponse.responseEvent != null
                && NativeMessageResponse.responseEvent == "ReportResponseDetails"
                && NativeMessageResponse.reportResponseDetails != null
                && NativeMessageResponse.reportResponseDetails.ReportResponseEvent == "ReportOpenFailed") {
                // PS failed to open the report (e.g. site not configured). Clear the manual-open
                // flag so subsequent opens and auto-advance are not permanently blocked.
                $scope.isPSManualOpen = false;
            }

            if (NativeMessageResponse.responseEvent != null && NativeMessageResponse.responseEvent == "ImageResponseDetails"
                && NativeMessageResponse.imageResponseDetails != null) {
                if (!NativeMessageResponse.imageResponseDetails.Status) {
                    toaster.warning({ body: "Unable to find the image in Synapse." });
                }
            }
        }
        var NativeMessageResponseWorklist = function (evt, nativeMessageResponse) {
            NativeMessageResponse(nativeMessageResponse);
        }
        $scope.$on('NativeMessageResponseWorklist', NativeMessageResponseWorklist);
        function StartRC() {
            ////$log.log("StartRC ", new Date());
            if (RCService) {
                //if (!RCService.rc) {
                //    RCService.Connect(NativeMessageResponse);
                //}
                var timeoutrc = $timeout(function () {
                    //if (RCService.rc && !RCService.rc.nativeHostVersion) {
                    //    RCService.StartNativehost();
                    //}
                    if ($scope.DefaultDictationSystem && $scope.DefaultDictationSystem == 'PS360') {
                        RCService.StartPS();
                    }

                    $timeout.cancel(timeoutrc);
                    timeoutrc = null;
                }, 1000);
            }
        }
        function StopRC() {
            //$log.log("StopRC > RCService: ", RCService);
            if (RCService) {
                //$log.log("StopRC > rc: ", RCService.rc);
                RCService.Disconnect();
                RCService.rc = null;
            }
        }

        //var KonicaWindow;
        function PageInIt() {
            //////$log.log("PageInIt: " + new Date());

            intiAppHub();
            getOrderStatus();
            setDefaultCounter();
            updatePageSize();
            setHeight();
            previousHeight = currentHeight;
            $q.all([
                getLoadMoreWorklistPreference(),
                getWorklistPrefrence(),
            ]).then(function (data) {
                $scope.filter();

                RuleTable = RuleSharedService.ReSetMasterData();
                updateRefreshDOSInterval();
                refreshDOSMidnight = $interval(refreshDOS, refreshDOSInterval);
                newOrderRefresh();
                StartRC();

                //showHideUserGuide();
                setLoadMoreWorklistPreference();
                $scope.GetRVU();
            });
        }

        $scope.CloseFrom = ""; //"RADFLOW" , "PS360"


        $scope.formatted_date = function (date) {
            ////////$log.log("formatted_date");
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' == (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };

        $scope.refresh = function () {
            ////$log.log("refresh: " + new Date());

            var d = $q.defer();

            $scope.NewOrders = 0;
            //$scope.showPopup();

            if (filterChanged) {
                $scope.PageNo = 1;
                loadIncrement = 1;
                $scope.TotalRows = 0;
                $scope.showingRecords = 0;
                filterChanged = false;
            }

            //resetTimer();     //Removed as reseting timer when Data Bound of the loading grid (Bug 21182: Refresh counter gets freeze, if user applies any filter & records are getting loaded)

            $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            if ($scope.OrderDateType && $scope.OrderDateType.match('All')) {
                $scope.OrderDate = {
                    startDate: null,
                    endDate: null
                };
            }
            var isStartUserGuideTour = false;
            $scope.orderListFilter = {
                PageNum: Math.ceil($scope.PageNo),
                PageSize: Math.ceil($scope.PageSize),
                SiteID: $scope.SelectedList.Site ? $scope.SelectedList.Site.SiteID : null,
                LocationID: $scope.locationIDs && $scope.locationIDs.length > 0 ? $scope.locationIDs : null,
                Accession: $scope.Accession,
                ModalityID: $scope.modalityIDs && $scope.modalityIDs.length > 0 ? $scope.modalityIDs : null,
                //OrderDateStartDate: ($scope.OrderDate.startDate) ? moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") : null,
                //OrderDateEndDate: ($scope.OrderDate.endDate) ? moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY") : null,
                OrderDateStartDate: ($scope.OrderDate.startDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.OrderDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00")) : null,
                OrderDateEndDate: ($scope.OrderDate.endDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.OrderDate.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")) : null,
                PatientName: $scope.PatientName,
                PatientMRN: $scope.PatientMRN,
                PatientDOB: $scope.formatted_date($scope.DOB),
                PatientClass: $scope.SelectedList.PatientClass ? $scope.SelectedList.PatientClass.Value : null,
                OrderingPhysician: $scope.OrderingPhysician,
                Status: $scope.Status.key,
                UserID: $sessionStorage.currentUserData.userId,
                OrderByField: $scope.OrderByField ? $scope.OrderByField : "",
                OrderBy: $scope.ReverseSort,
                WorklistFlag: $scope.SelectedList.Worklist.Key,
                AdminWorklistIds: $scope.worklistIds_Admin,
                UserWorklistIds: $scope.worklistIds_User,
                STATFilter: $scope.STATFilter ? "1" : "0",
                ShowLockStudy: $scope.ShowLockStudy,
                //FromSignDate: moment().format("MM-DD-YYYY"),
                //ToSignDate: moment().format("MM-DD-YYYY"),
                FromSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "00:00")),
                ToSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")),
                SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                Priority: $scope.SelectedList.StudyPriority ? $scope.SelectedList.StudyPriority.Key : 'All',
            };

            if (previouslySelectedFilter &&
                ((previouslySelectedFilter.SiteID != $scope.orderListFilter.SiteID)
                    || (previouslySelectedFilter.LocationID != $scope.orderListFilter.LocationID)
                    || (previouslySelectedFilter.Accession != $scope.orderListFilter.Accession)
                    || (previouslySelectedFilter.ModalityID != $scope.orderListFilter.ModalityID)
                    || (previouslySelectedFilter.OrderDateStartDate != $scope.orderListFilter.OrderDateStartDate)
                    || (previouslySelectedFilter.OrderDateEndDate != $scope.orderListFilter.OrderDateEndDate)
                    || (previouslySelectedFilter.PatientName != $scope.orderListFilter.PatientName)
                    || (previouslySelectedFilter.PatientMRN != $scope.orderListFilter.PatientMRN)
                    || (previouslySelectedFilter.PatientDOB != $scope.orderListFilter.PatientDOB)
                    || (previouslySelectedFilter.PatientClass != $scope.orderListFilter.PatientClass)
                    || (previouslySelectedFilter.OrderingPhysician != $scope.orderListFilter.OrderingPhysician)
                    || (previouslySelectedFilter.Status != $scope.orderListFilter.Status)
                    || (previouslySelectedFilter.AdminWorklistIds != $scope.orderListFilter.AdminWorklistIds)
                    || (previouslySelectedFilter.UserWorklistIds != $scope.orderListFilter.UserWorklistIds)
                    || (previouslySelectedFilter.Priority != $scope.orderListFilter.Priority))) {
                $scope.orderListFilter.PageNum = 1;
                OrderList = [];
                $scope.orderList = [];
                $scope.PageNo = 1;
            }

            previouslySelectedFilter = $scope.orderListFilter;

            $scope.isLoading = true;
            WorklistService.GetWorklistData($scope.orderListFilter).then(function (result) {
                ////$log.log("refresh response: " + new Date());
                $scope.isLoading = false;
                //OrderList = result.Orders;
                if (result.Orders && result.Orders.length > 0) {
                    $scope.TotalRows = result.Orders[0].TotalRows ? Number(result.Orders[0].TotalRows) : Number($scope.TotalRows);

                    ////////$log.log("refresh > orders length: ", $scope.orderList.length);


                } else {
                    $scope.TotalRows = 0;
                    $scope.orderList = [];
                    OrderList = [];
                    $scope.showingRecords = 0;
                }

                updateOrders(result.Orders)


                if (result != null && result.StatusCount != null) {
                    $scope.CancelCount = result.StatusCount.CancelCount;
                    $scope.ComparisonCount = result.StatusCount.ComparisonCount;
                    $scope.WorklistPageHeaderParameter.CompleteCount = result.StatusCount.CompleteCount;
                    $scope.WorklistPageHeaderParameter.DraftCount = result.StatusCount.DraftCount;
                    $scope.WorklistPageHeaderParameter.HiddenCount = result.StatusCount.HiddenCount;
                    $scope.ORMPendingCount = result.StatusCount.ORMPendingCount;
                    $scope.ImagePendingCount = result.StatusCount.ImagePendingCount;
                    $scope.RadFlowCompleteCount = result.StatusCount.RadFlowCompleteCount;
                    $scope.WorklistPageHeaderParameter.ResultPendingCount = result.StatusCount.ResultPendingCount;
                    $scope.WorklistPageHeaderParameter.StatCount = result.StatusCount.StatCount;
                    $scope.WorklistPageHeaderParameter.SignedToday = result.StatusCount.SignedToday;
                    GetUserPaymentHeader();
                }

                d.resolve(result.Orders);
            }).catch(function (noCantDo) {
                $scope.isLoading = false;
                d.reject(noCantDo);
            });

            if ($scope.SelectedList.Worklist.Key === 'PRW') {
                setPRWFilterSetting();
            }
            $scope.lastRowIndex = undefined;
            return d.promise;
        };


        $scope.GetOrdersListPendingCount = function () {
            ////////$log.log("GetOrdersListPendingCount");
            $rootScope.$broadcast('GetOrdersListPendingCount');
        };
        $scope.GetOrdersComparisonList = function (row) {
            ////$log.log("GetOrdersComparisonList");
            var d = $q.defer();
            if (!row.isExpanded) {

                $scope.isLoading = true;
                $scope.orderComparisonListFilter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    OrderID: row.entity.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    $scope.isLoading = false;
                    if (result && result.length > 0) {
                        _.each(result, function (obj) {
                            obj.scopeVariable = $scope.scopeVariable;

                        });
                        row.entity.ComparisonOrder = angular.copy(result);
                        row.entity.subGridOptions = $scope.subUIGridOptions;
                        row.entity.subGridOptions.data = result;

                        var rowentity = _gridAPI.expandable.getExpandedRows();
                        if (rowentity && rowentity.length > 0) {
                            rowentity[0].isCollapsed = !rowentity[0].isCollapsed;
                        }
                        _gridAPI.expandable.collapseAllRows();

                        _gridAPI.expandable.expandRow(row.entity);
                        row.entity.isCollapsed = !row.entity.isCollapsed;
                        d.resolve(result);
                    } else {
                        var idx = _.findIndex(OrderList, { 'OrderID': row.entity.OrderID });
                        if (idx != -1) {
                            OrderList[idx].HasComparison = "0";
                            $scope.orderList = OrderList;
                        }
                    }

                }).catch(function (noCantDo) {
                    $scope.isLoading = false;
                });
            } else {
                _gridAPI.expandable.collapseRow(row.entity);
                row.entity.isCollapsed = !row.entity.isCollapsed;
                d.resolve([]);
            }

            return d.promise;
        };
        $scope.GetRVU = function () {
            ////////$log.log("GetRVU");
            var data = {
                userid: $sessionStorage.currentUserData.userId,
                StartDateTime: $filter('CSTDateTime')(new Date(new Date().setDate(new Date().getDate() - 1))),
                EndDateTime: $filter('CSTDateTime')(new Date()),
                RadiologistsByTenant: $sessionStorage.RadiologistsByTenant && $sessionStorage.RadiologistsByTenant.length > 0 ? $sessionStorage.RadiologistsByTenant : "",
            };
            WorklistService.GetRVU(data).then(function (result) {
                if (result && result.length > 0) {
                    $scope.WorklistPageHeaderParameter.HospitalRVU = result[0].PracticeRVU;
                    $scope.WorklistPageHeaderParameter.TopUserRVU = result[0].HighRVU;
                    $scope.WorklistPageHeaderParameter.MyRVU = result[0].MyRVU;
                    $scope.WorklistPageHeaderParameter.LowRVU = result[0].LowRVU;
                    $scope.WorklistPageHeaderParameter.UnreadRVU = result[0].ResultPendingWorkRVUSum;
                }

            });
        };

        $scope.clearFilterAndRefesh = function () {
            ////$log.log("clearFilterAndRefesh");
            //Bug 28867: The previously selected study not shown selected if the user clears the filter

            $scope.clearFilter();


            $q.all([
                $scope.getData()
            ]).then(function (data) {
                var pages = Number($scope.TotalRows) / $scope.PageSize;
                _gridAPI.infiniteScroll.resetScroll($scope.PageNo > 1, $scope.PageNo < pages);
            });

            $timeout(function () { $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;'); }, 1);
            $('.anui').removeClass("set-modality-height");
            $('.anui').removeClass("set-location-height");
        };
        $scope.clearFilter = function () {
            ////$log.log("clearFilter: " + new Date());
            $scope.worklistSaved = false;
            $scope.PageNo = 1;
            updatePageSize();
            $scope.Status.key = "RP";
            $scope.OrderByField = "DOS";
            $scope.ReverseSort = true;
            $scope.SelectedList.Site = null;
            $scope.SelectedList.Location = null;
            $scope.SelectedWorkList = [];
            $scope.modalitytooltip = 'Select Modalities';
            $scope.worklisttooltip = 'Select a Worklist';
            $scope.SelectedList.Modality = [];
            $scope.ModalityDropdownDataFilter.SelectedValue = {
                list: [],
            };
            $scope.locationIDs = '';
            $scope.modalityIDs = '';
            $scope.worklistIds_Admin = '';
            $scope.worklistIds_User = '';
            $scope.Accession = "";
            $scope.OrderDate = {
                startDate: moment().subtract(6, 'days'),
                endDate: moment()
            };
            $scope.toolTipOrderDate = 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY');
            $scope.OrderDateType = 'Last 7 Days';
            $scope.PatientName = "";
            $scope.PatientMRN = "";
            $scope.DOB = "";
            $scope.SelectedList.PatientClass = null;
            $scope.OrderingPhysician = "";
            $scope.STATFilter = false;

            LoadPrevNext = "Next";
            loadIncrement = 1;
            OrderList = [];

            filterChanged = false;

            setSelectedWorklistFilterSettings();

            refreshOnClick = true;

            $scope.SelectedList.StudyPriority = null;
            $scope.SelectedLocations = {
                Ids: '',
                locations: [],
                divId: "OldWorklistFilter"
            };
        };
        /**
         * Modified By: Tejas Parikh
         * User Story 19673: Improve Location Filter
         * @param {any} localSites
         */
        $scope.loadWorklistDropdown = function () {
            ////$log.log("loadWorklistDropdown: " + new Date());
            $scope.worklistDropdownTreeOptions = {
                placeholder: $scope.worklisttooltip,
                checkboxes: true,
                autoClose: false,
                template: kendo.template($("#dropdowntree-template").html()),
                dataSource: $scope.WorkLists,
                dataTextField: "WorkListName",
                dataValueField: "RuleID",
                checkAll: true,
                height: "auto",
                loadOnDemand: false,
                headerTemplate: '<span class="k-list-filter"><input class="k-textbox" role="listbox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-disabled="false" id="tree-worklist-text-search" autocomplete="off"/><span class="k-icon k-i-zoom"></span></span>',
                filtering: function (e) {
                    //get filter descriptor
                    var filter = e.filter;
                    // handle the event
                },
                open: function (e) {
                    e.sender.popup.element.addClass('select-afilter');
                    $("#tree-worklist-text-search").change(refreshWorklistTree).keyup(refreshWorklistTree);
                    setTimeout(function () {
                        $("#tree-worklist-text-search").focus();
                        $('.select-afilter').parent().addClass('select-afilter-wraaper old-wedit');
                    }, 500);



                },
                change: function (e) {
                    if (!$scope.isRebindingLocation) {
                        var nodes = e.sender.dataSource.view();
                        var checkedNodes = e.sender.value();
                        var values = (checkedNodes && checkedNodes.length > 0) ? checkedNodes : checkedWorklist(nodes, checkedNodes);
                        if (values && values.length > 0) {
                            var locations = [];
                            ////$log.log("loadWorklistDropdown > change > values: ", values);
                            _.each(values, function (data) {
                                var filter = _.find($scope.WorkLists, function (item) { return item.RuleID == data; });
                                if (filter != null) {
                                    locations.push(filter);
                                }

                            });
                            ////$log.log("loadWorklistDropdown > change > locations: ", locations);

                            $scope.SelectedWorkList = locations;

                        } else {

                            $scope.SelectedWorkList = [];
                        }
                        setWorklisttooltip();

                        filterChanged = true;


                    }
                },
                close: function (e) {
                    clearWorklist();
                }
            };
        };


        /**
         * Modified By: Tejas Parikh
         * Task 22822: All sites should be listed in alphabetical manner in location filter list
         * @param {any} a
         * @param {any} b
         */
        function compare(a, b) {
            ////////$log.log("compare");
            // Use toUpperCase() to ignore character casing
            var bandA = a.text.toUpperCase();
            var bandB = b.text.toUpperCase();

            var comparison = 0;
            if (bandA > bandB) {
                comparison = 1;
            } else if (bandA < bandB) {
                comparison = -1;
            }
            return comparison;
        }

        /**
         * Modified By: Tejas Parikh
         * User Story 19673: Improve Location Filter
         * @param {any} nodes
         * @param {any} checkedNodes
         */
        function checkedNodeValues(nodes, checkedNodes) {
            ////////$log.log("checkedNodeValues");
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && !nodes[i].hasChildren) {
                    if (checkedNodes.indexOf(nodes[i].value) < 0) {
                        checkedNodes.push(nodes[i].value);
                    }
                }
                if (nodes[i].hasChildren) {
                    checkedNodeValues(nodes[i].children.view(), checkedNodes);
                }
            }
            return checkedNodes;
        }
        function checkedWorklist(nodes, checkedNodes) {
            ////$log.log("checkedWorklist");
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked) {
                    ////$log.log("checkedWorklist > nodes[i]: ", nodes[i]);
                    if (checkedNodes.indexOf(nodes[i].RuleID) > 0) {
                        checkedNodes.push(nodes[i].RuleID);
                        ////$log.log("checkedWorklist > checkedNodes: ", checkedNodes);
                    }
                }
            }
            return checkedNodes;
        }

        /**
         * Modified By: Tejas Parikh
         * User Story 19673: Improve Location Filter
         * */
        function refreshWorklistTree() {
            ////////$log.log("refreshWorklistTree");
            var drtr = $("#worklistDropdownTree").data("kendoDropDownTree");
            var tree = drtr.treeview;
            var dataSource = drtr.dataSource;
            var value = $("#tree-worklist-text-search").val();
            if (value !== "") {
                dataSource.filter({
                    field: "WorkListName", //if I would use "ChildrenText" here nothing be displayed at all if filtertext is set
                    operator: "contains",
                    value: $("#tree-worklist-text-search").val()
                });

            } else {
                dataSource.filter({});
            }
            angular.element(document).ready(function () {
                angular.element('.k-item').mouseenter(function () {
                    if (tree) {
                        tree.focus();
                    }
                });

            });
        }
        function setSelectedWorklistFilterSettings() {
            ////$log.log("setSelectedWorklistFilterSettings: " + new Date());
            var selectedWorkListIDs = [];
            if ($scope.SelectedWorkList) {
                for (var i = 0; i < $scope.SelectedWorkList.length; i++) {
                    selectedWorkListIDs.push($scope.SelectedWorkList[i].RuleID);
                }
            }
            var ddt = $("#worklistDropdownTree").data("kendoDropDownTree");
            if (ddt) {
                ddt.value(selectedWorkListIDs);
            } else {
                $timeout(function () {
                    setSelectedWorklistFilterSettings();
                }, 100);
            }
        }

        $scope.GetUserRuleText = function () {
            ////////$log.log("GetUserRuleText");
            var params = {
                UserID: $sessionStorage.currentUserData.userId
            };
            WorklistService.GetUserRuleText(params).then(function (result) {
                if (result != null && result.length > 1) {
                    $scope.UserRules = result;
                }
            });
        };

        $scope.SelectedSiteChanged = function (SelectedSite) {
            ////////$log.log("SelectedSiteChanged");
            $scope.Locations = null;
            $scope.SelectedList.Location = null;
            var lookup = {};
            var result = [];
            if (SelectedSite) {
                var items = SelectedSite.Locations;
                items.forEach(function (item) {
                    var name = item.Location;

                    if (!(name in lookup)) {
                        lookup[name] = 1;
                        result.push(item);
                    }
                });
            }
            $scope.Locations = result;
        };

        $scope.SortFilter = function (OrderByField) {
            ////$log.log("SortFilter");
            if (!validateDOS(true)) return;

            $scope.PageNo = 1;
            $scope.OrderByField = OrderByField.toUpperCase();
            $scope.ReverseSort = !$scope.ReverseSort;

            loadIncrement = 1;
            OrderList = [];

            refreshOnClick = true;

            $q.all([
                $scope.getData()
            ]).then(function (data) {
                var pages = Number($scope.TotalRows) / $scope.PageSize;
                _gridAPI.infiniteScroll.resetScroll($scope.PageNo > 1, $scope.PageNo < pages);
            });
        };

        function SetSignREportModal(Order, OrderList) {
            ////////$log.log("SetSignREportModal");
            $scope.SingReport.CurrentSite = Order.Site + (Order.Location ? "(" + Order.Location + ")" : "");
            $scope.SingReport.CurrentPatientMRN = Order.PatientMRN;
            $scope.SingReport.CurrentPatient = Order.PatientName;
            $scope.SingReport.CurrentAccession = Order.Accession;
            $scope.setSelected(Order.OrderID, Order);

            $scope.SingReport.PrevToolTip = "";
            $scope.SingReport.NextToolTip = "";
            var idx = _.findIndex(OrderList, function (a) { return a.OrderID == Order.OrderID });
            if (idx > 0) {
                $scope.SingReport.PrevToolTip = "Name: " + OrderList[idx - 1].PatientName + " " + "MRN: " + OrderList[idx - 1].PatientMRN + " " + "Accession: " + OrderList[idx - 1].Accession;
            }
            else if (idx <= 0) {
                $scope.SingReport.PrevToolTip = "No Order";
            }
            if (OrderList && OrderList.length > idx + 1) {
                $scope.SingReport.NextToolTip = "Name: " + OrderList[idx + 1].PatientName + " " + "MRN: " + OrderList[idx + 1].PatientMRN + " " + "Accession: " + OrderList[idx + 1].Accession;
            }
            else if (OrderList && OrderList.length <= idx + 1) {
                $scope.SingReport.NextToolTip = "No Order";
            }


            $q.all([
                showPriorReport(Order, Order.Accession)
            ]).then(function (data) {
                //------------------------------------Open PS and Viewer------------------------------------
                if (__env.showLoaderonPSNViewerLoad) {
                    $scope.isLoadingSynapse = true;
                }
                setTimeout(function () {
                    OpenSynapseStudy(Order, Order.DicomViewer, true);
                    $scope.isLoadingSynapse = false;
                }, 500);
                //-----------------------------------------------------------------------------------------
            });



        }

        function showPriorReport(SelectedOrder, SelectedOrderAccession) {
            ////////$log.log("showPriorReport");
            var d = $q.defer();
            var ComparisionOrderList = [];
            if (SelectedOrder.ComparisonOrder && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                $q.all([
                    viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                ]).then(function (data) {
                    d.resolve(data);
                });

            } else if (SelectedOrder.ComparisonOrder && SelectedOrder.ComparisonOrder.length == 0) {
                $scope.orderComparisonListFilter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = _.clone(result);
                    SelectedOrder.subGridOptions = _.clone($scope.subUIGridOptions);
                    SelectedOrder.subGridOptions.data = _.clone(result);
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });
                    $q.all([
                        viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                    ]).then(function (data) {
                        d.resolve(data);
                    });


                }).catch(function (noCantDo) {
                    $scope.isLoading = false;
                    d.resolve(false);
                });
            }
            else {
                $q.all([
                    viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                ]).then(function (data) {
                    d.resolve(data);
                });
            }
            return d.promise;
        }

        function viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList) {
            ////////$log.log("viewReport");
            var d = $q.defer();
            $scope.showDiscuss = true;
            $scope.isReportAvailable = false;
            var tabStrip = $("#tabstrip").kendoTabStrip().data("kendoTabStrip");
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN, SelectedOrder.SiteID)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];
                if (data != null && data.length > 0 && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report && report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        SelectedOrder.OrderDate = new Date($filter('localDate')(SelectedOrder.OrderDate, false, new Date()));
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {

                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            rptObject[0].OrderDate = new Date($filter('localDate')(rptObject[0].OrderDate, false, new Date()));
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            ComparisonOrderReport.OrderDate = new Date($filter('localDate')(ComparisonOrderReport.OrderDate, false, new Date()));
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });
                }
                $scope.OrderReport = SelectedOrder;
                $scope.reportList = _.uniqBy($scope.reportList, 'OrderID');
                $scope.PriorReportFilter.List.Modalities = _.concat($scope.PriorReportFilter.List.Modalities, _.uniq(_.map($scope.reportList, 'Modality')));
                if (report.length == 0) {
                    var reportList = _.orderBy($scope.reportList, ['OrderDate'], ['desc']);
                    $scope.reportList = reportList;
                }
                if ($scope.reportList && $scope.reportList.length > 0) {
                    var objSelectedReport = $scope.reportList[0];
                    if (objSelectedReport) {
                        $scope.SelectedOrderAccession = objSelectedReport.Accession;
                        LoadReport(objSelectedReport.OrderID);
                        if (Hasreport) {
                            $scope.isReportAvailable = true;
                        }
                        $scope.LoadDiscussion($scope.OrderReport.DicomOrderID, 'Discussion');
                    }
                }
                else {
                    $scope.LoadDiscussion($scope.OrderReport.DicomOrderID, 'Discussion');
                }
                ReportList = $scope.reportList;
                if (ReportList.length > 1) {
                    $scope.PriorReportFilter.Modal = true;
                }
                //$scope.isLoading = false;
                d.resolve(true);
            });
            return d.promise;
        }

        $scope.clearSelection = function () {
            ////////$log.log("clearSelection");
            try {
                if (document.selection && document.selection.empty) {
                    document.selection.empty();
                } else if (window.getSelection) {
                    var sel = window.getSelection();
                    sel.removeAllRanges();
                }
            } catch (error) {
                //////$log.log(error);
            }

        };
        $scope.OpenSignReport = function (Order, OrderList) {
            //$log.log("OpenSignReport");
            $scope.clearSelection();

            //$scope.SingReport.Index = index;
            $scope.SingReport.Order = Order;
            $scope.SingReport.OrderList = OrderList;



            var idx = _.findIndex($scope.SingReport.OrderList, { IsDeficient: true });
            if ($scope.SingReport.Order.IsDeficient) {
                idx = null;
            }

            $q.all([
                WarnDeficientCorrection(idx)
            ]).then(function (data) {
                if (data != null && data.length > 0 && data[0] == true) { $scope.SingReport.Order = $scope.SingReport.OrderList[idx]; }
                if ($scope.SingReport.Order.IsDeficient) {
                    WorklistService.GetDeficientErrorByOrderID($scope.SingReport.Order.OrderID).then(function (result) {
                        if (result != null && result.length > 0) {
                            var i = 1;
                            var errorstring = "";
                            result.forEach(function (error) {
                                if (errorstring && errorstring.length > 0) {
                                    errorstring += "<tr><td>" + i + ": " + error.DeficientErrorDesc + "</td></tr>";
                                    i++;
                                }
                                else {
                                    errorstring = "<table style='text-align: left;'><tr><td>" + i + ": " + error.DeficientErrorDesc + "</td></tr>";
                                    i++;
                                }
                            });
                            if (errorstring && errorstring.length > 0) errorstring += "</table>";
                            //$scope.isLoading = false;
                            setTimeout(function () {
                                swal({
                                    title: 'Please correct the below deficiency in the report.',
                                    text: errorstring,
                                    type: "warning",
                                    html: true,
                                    customClass: 'swal-wide',
                                    showCancelButton: true,
                                    confirmButtonColor: "#DD6B55", confirmButtonText: "Ok",
                                    cancelButtonText: "Ignore",
                                },
                                    function (isConfirm) {
                                        if (!isConfirm) {
                                            $scope.SingReport.Order.CheckDeficiency = 0;
                                        }
                                    });
                            }, 500);
                        }
                    });
                }
                $scope.GetDicomViewerCredentialsCallFrom = "OPENSINGREPORT";
                //if ($scope.DefaultDicomViewer != null && $scope.DefaultDicomViewer.toString().length > 0) {
                //    $scope.SingReport.Order.DicomViewer = $scope.DefaultDicomViewer;
                //}
                $q.all([
                    GetDicomViewerCredentials($scope.SingReport.Order.SiteID, $scope.SingReport.Order.DicomViewer)
                ]).then(function (data) {
                    OpenOrder = {};
                    if (data != null && data.length > 0 && data[0] != null) {
                        if (data[0].ShowModal) { return; }
                        else {
                            $scope.SingReport.Order.DicomViewerCredentials = data[0].Credentials;
                            if (Order.ProcessError) {
                                swal("Study not available.");
                                return;
                            }
                            $scope.RetrySignReport = false;
                            $q.all([
                                VerfiyReadStudy($scope.SingReport.Order.OrderID, $sessionStorage.currentUserData.userId, data),
                                GetClipboardDetailByOrderID($scope.SingReport.Order.OrderID)
                            ]).then(function () {
                                VerifyOpenOrder(OpenOrder);
                            });
                        }
                    }
                    else { return; }
                });
            });
        };

        function WarnDeficientCorrection(index) {
            ////////$log.log("WarnDeficientCorrection");
            var d = $q.defer();
            var out = false;
            if (index != null && index != -1 && $scope.DeficientWarningOnWorklist) {
                swal({
                    title: 'There are deficient reports in worklist.',
                    text: 'Are you sure you want to correct them?',
                    type: "warning",
                    html: true,
                    customClass: 'swal-wide',
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Ok",
                    cancelButtonText: "Skip",
                },
                    function (isConfirm) {
                        if (isConfirm) {
                            out = true;
                            d.resolve(out);
                        }
                        else {
                            out = false;
                            d.resolve(out);
                        }
                    });
            }
            else {
                d.resolve(out);
            }
            return d.promise;
        }

        $scope.Call_SetSignREportModal = function () {
            //$log.log("Call_SetSignREportModal");
            if ($scope.LastOpenedOrder) {
                windowHandler.CloseWindow(["CI-VIEWER-1-" + $scope.LastOpenedOrder.Accession.toUpperCase().trim(),
                "CI-VIEWER-2-" + $scope.LastOpenedOrder.Accession.toUpperCase().trim(),
                'KONICA-' + $scope.LastOpenedOrder.Accession.toUpperCase().trim(),
                'KONICATEST-' + $scope.LastOpenedOrder.Accession.toUpperCase().trim(),
                'MedDreamViewer-' + $scope.LastOpenedOrder.Accession.toUpperCase().trim(),
                'NORTHSTARKONICA-' + $scope.LastOpenedOrder.Accession.toUpperCase().trim()]);
            }
            if ($scope.LastOpenedOrderID != null && $scope.LastOpenedOrderID != $scope.SingReport.Order.OrderID) {
                removeOrderFromList($scope.LastOpenedOrderID);
                $scope.DeleteOpenOrder();
            }
            $scope.InsertOpenOrder();
            SetSignREportModal($scope.SingReport.Order, $scope.SingReport.OrderList);
            if (!$scope.ChooseNextStudy) {
                $scope.currentWindow = "win_SingReport";
                OpenWindow($scope.win_SingReport, 'win_SingReport');
                $scope.win_SingReport.wrapper.prev(".k-overlay").addClass("custom-overlay");
            }
        };
        $scope.PrevRec = function () {
            //$log.log("PrevRec");
            if ($scope.SingReport.Order) {
                var idx = _.findIndex($scope.SingReport.OrderList, function (a) { return a.OrderID == $scope.SingReport.Order.OrderID });
                if (idx != -1)
                    idx = idx - 1;
                var openOrders = {
                    OrderId: $scope.SingReport.OrderList[idx].OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId
                };
                WorklistService.GetOpenOrder(openOrders).then(function (result) {
                    if (result && result.length > 0) {
                        $scope.PrevRec();
                        return;
                    }
                    else {
                        if ($scope.LastOpenedOrderID != null) {
                            removeOrderFromList($scope.LastOpenedOrderID);
                            $scope.DeleteOpenOrder();
                        }
                        $scope.InsertOpenOrder();
                        SetSignREportModal($scope.SingReport.Order, $scope.SingReport.OrderList);
                    }
                });
            }
            else {
                $scope.win_SingReport.close();
            }
        };

        $scope.NextRec = function () {
            //$log.log("NextRec");
            var idx = _.findIndex($scope.SingReport.OrderList, function (a) { return a.OrderID == $scope.SingReport.Order.OrderID });
            if (idx < $scope.SingReport.OrderList.length - 1) {
                idx = idx + 1;
                var openOrders = {
                    OrderId: $scope.SingReport.OrderList[idx].OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId
                };
                WorklistService.GetOpenOrder(openOrders).then(function (result) {
                    if (result && result.length > 0) {
                        $scope.NextRec();
                        return;
                    }
                    else {
                        if ($scope.LastOpenedOrderID != null) {
                            removeOrderFromList($scope.LastOpenedOrderID);
                            $scope.DeleteOpenOrder();
                        }
                        $scope.InsertOpenOrder();
                        $scope.currentWindow = "win_SingReport";
                        OpenWindow($scope.win_SingReport, 'win_SingReport');
                        $scope.win_SingReport.wrapper.prev(".k-overlay").addClass("custom-overlay");
                        SetSignREportModal($scope.SingReport.Order, $scope.SingReport.OrderList);
                    }
                });
            }
            else {
                $scope.win_SingReport.close();
            }
        };
        $scope.SignAndNextRec = function () {
            ////////$log.log("SignAndNextRec");
            $scope.SignReport("NEXT", $scope.SingReport.Order);
        };
        $scope.SignAndPrevRec = function () {
            ////////$log.log("SignAndPrevRec");
            $scope.SignReport("PREV", $scope.SingReport.Order);

        };
        $scope.setSelected = function (SelectedOrderID, SelectedOrder) {
            //////////$log.log("setSelected");
            $scope.SelectedOrderID = SelectedOrderID;
            $scope.SelectedOrder = _.clone(SelectedOrder);
            $scope.SelectedOrder.OrderDate = $filter('localDate')(SelectedOrder.OrderDate, false, new Date());
            $scope.SelectedComPatisomOrderID = "";
            //js for discussion pop wondow to show message box when keypad comes up
            if (angular.element(window).width() < 768) {
                setTimeout(function () {
                    angular.element('.discus-comment .txt-area').focusin(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').addClass('mobscreen-scroll');
                            setTimeout(function () {
                                angular.element('.denial-window.mobscreen-scroll').animate({ scrollTop: $(document).height() }, "fast");
                            }, 100);
                        }
                    });
                    angular.element('.discus-comment .txt-area').focusout(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').removeClass('mobscreen-scroll');
                        }
                    });
                }, 500);
            }
        };
        $scope.setSelectedComparison = function () {
            //////$log.log("setSelectedComparison");
            if (_subGridAPI && _subGridAPI.selection.getSelectedRows() && _subGridAPI.selection.getSelectedRows().length > 0) {
                $scope.SelectedComPatisomOrderID = _subGridAPI.selection.getSelectedRows()[0].OrderID;
                $scope.SelectedOrderID = _subGridAPI.selection.getSelectedRows()[0].Orders;
                //swal(SelectedComPatisomOrderID);
                var order = _.find(OrderList, { 'OrderID': $scope.SelectedOrderID });
                if (order) {

                    $scope.setSelected($scope.SelectedOrderID, order);
                    selectRow();
                }
            }

        };
        $scope.clearSelectedChildRows = function () {
            if (_subGridAPI) {
                _subGridAPI.selection.clearSelectedRows();
            }
        }

        $scope.SignReport = function (navFlag, SignedReportOrder) {
            $scope.win_ModalReportNDiscuss.close();
            $scope.win_Discussion.close();
            //$scope.isLoading = true;

            $scope.navFlag = navFlag;

            ////$log.log("SignReport > $scope.NativeMessageResponseReportStatus: ", $scope.NativeMessageResponseReportStatus);
            ////$log.log("SignReport > $scope.LastOpenedOrderID: ", $scope.LastOpenedOrderID);
            var SignedOrDrafted = false;
            if ($scope.NativeMessageResponseReportStatus == 2
                || $scope.NativeMessageResponseReportStatus == 8) {
                SignedOrDrafted = true;
            }

            if ($scope.NativeMessageResponseReportStatus == 8) {
                OpenOrder = {};
                VerfiyReadStudy(SignedReportOrder.OrderID, $sessionStorage.currentUserData.userId, null).then(function (response) {
                    if (OpenOrder.ClipboardDetailResult && OpenOrder.ClipboardDetailResult.length > 0) {
                        var obj = { OrderID: SignedReportOrder.OrderID, UserID: $scope.LoggedInUserID, RuleID: OpenOrder.ClipboardDetailResult[0].RuleID };
                        RemoveFromClipboardRule(obj);
                        WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                    } else {
                        var clipboardRule = _.find($scope.GlobalRules, { WorklistType: 16 });
                        if (clipboardRule) {
                            var obj = { OrderID: SignedReportOrder.OrderID, UserID: $scope.LoggedInUserID, RuleID: clipboardRule.RuleID };
                            RemoveFromClipboardRule(obj);
                            WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                        }
                    }
                });

            }

            if (SignedOrDrafted) {
                removeOrderFromList(SignedReportOrder.OrderID);
                $scope.NativeMessageResponseReportStatus = -2;
            }

            $scope.DictationReportState = "DictateByPS360";
            $scope.SingbtnDisabled = true;
            var psuserFilter = {
                UserId: $scope.LoggedInUserID,
                SiteID: SignedReportOrder.SiteID,
                LocationID: SignedReportOrder.LocationID,
                InstitutionID: SignedReportOrder.InstitutionID
            };
            WorklistService.CheckPSUserBySite(psuserFilter).then(function (result) {
                $scope.PSUser = result;
                if ($scope.PSUser == null || $scope.PSUser.length <= 0 || ($scope.PSUser[0].CreateORU == true && $scope.PSUser[0].IsValid.toString().toUpperCase() == "FALSE")) {
                    $scope.PSUser.Username = $scope.PSUser != null && $scope.PSUser.length > 0 ? $scope.PSUser[0].UserName : "";
                    //$scope.isLoading = false;
                    $scope.currentWindow = "win_PSUser";
                    OpenWindow($scope.win_PSUser, 'win_PSUser');
                    $scope.win_PSUser.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    if ($scope.PSUser && $scope.PSUser.length > 0) { swal("Please update your password."); }
                    $scope.SingbtnDisabled = false;
                } else {
                    if (!$scope.ChooseNextStudy) {
                        if (navFlag == "NEXT") {
                            $scope.NextRec();
                        }
                        else if (navFlag == "PREV") {
                            $scope.PrevRec();
                        }
                        $scope.SingbtnDisabled = false;
                    }

                    $scope.DeleteOpenOrder(SignedReportOrder);
                    ////$log.log("SignReport > $scope.ChooseNextStudy: ", $scope.ChooseNextStudy);

                    GetStatusCount();
                    $scope.GetRVU();


                }
            });
        };
        function removeOrderFromList(OrderId) {
            ////$log.log("removeOrderFromList > OrderId: ", OrderId);
            var idx = _.findIndex(OrderList, function (obj) { return obj.OrderID == OrderId; });
            if (idx != -1) {
                removeOrder(idx);
            }
        }

        function removeOrderAccession(Accession) {
            ////$log.log("removeOrderAccession > Accession: ", Accession);
            var idx = _.findIndex(OrderList, function (obj) { return obj.Accession == Accession; });
            if (idx != -1) {
                removeOrder(idx);
            }
        }

        function removeOrder(idx) {
            //$log.log("removeOrder");
            //var orderID = OrderList[idx].OrderID;
            OrderList.splice(idx, 1);


            if ($scope.TotalRows && $scope.TotalRows > 0) {
                $scope.TotalRows = Number($scope.TotalRows) - 1;
            }

            $scope.orderList = OrderList;

            if (OrderList && OrderList.length < $scope.PageSize) {
                ////$log.log("removeOrder orderlist length is less than page size");
                isOrderOnServer = true;
            }

            $timeout(function () {
                if (selectedOrderExists()) {
                    $("tr[tabindex=" + $scope.SelectedOrder.OrderID + "]").focus();
                }
            }, 100);

            if ($scope.SingReport && $scope.SingReport.OrderList && $scope.SingReport.OrderList.length > 0) {
                $scope.SingReport.OrderList = _.clone(OrderList);
            }
        }

        $scope.InsertPSUsersBySIte = function () {
            ////////$log.log("InsertPSUsersBySIte");
            var psuserFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: $scope.SingReport.Order.SiteID,
                LocationID: $scope.SingReport.Order.LocationID,
                UserName: $scope.PSUser.Username,
                Password: $scope.PSUser.Password
            };
            WorklistService.InsertPSUsersBySIte(psuserFilter).then(function (result) {
                $scope.win_PSUser.close();
                $scope.SignReport($scope.navFlag, $scope.SingReport.Order);
            });
        };
        $scope.InsertDicomViewerCredentials = function () {
            ////////$log.log("InsertDicomViewerCredentials");
            //$scope.isLoading = true;
            var objdata = {
                ID: -1,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: $scope.DVCred.SiteID,
                ViewerName: $scope.DVCred.ViewerName,
                UserName: $scope.DVCred.Username,
                Password: $scope.DVCred.Password,
                Modifyby: $sessionStorage.currentUserData.userId
            };
            WorklistService.InsertDicomViewerCredentials(objdata).then(function (result) {
                $('#ModalDicomViewerCredentials').modal('hide');
                if ($scope.GetDicomViewerCredentialsCallFrom == "OPENSYNAPSESTUDY") {
                    $scope.OpenSynapseStudy($scope.OpenSynapseStudyOrder, $scope.OpenSynapseStudyOptionalDV, $scope.OpenSynapseStudyisOpenPS);
                }
                else if ($scope.GetDicomViewerCredentialsCallFrom == "OPENSINGREPORT") {
                    $scope.OpenSignReport($scope.SingReport.Order, $scope.SingReport.OrderList);
                }
                //$scope.isLoading = false;
            });
        };
        $scope.InsertOpenOrder = function () {
            //$log.log("InsertOpenOrder");
            var order = _.clone($scope.SingReport.Order);
            //$log.log("InsertOpenOrder > order: ", order);
            if (!order.IsLock) {
                $scope.LastOpenedOrder = order;
                $scope.LastOpenedOrderID = order.OrderID;
                var openOrders = {
                    OrderId: order.OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId,
                    ProviderName: $filter('titleCase')($sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName), //$sessionStorage.currentUserData.displayName,
                    OpenDateTime: new Date().toLocaleString('en-US', { timeZone: 'US/Central' })
                };
                //$log.log("InsertOpenOrder > openOrders: ", openOrders);
                $scope.OpenedAccessionNumber = order.Accession;
                $scope.DictatedAccessionNumber.push(order.Accession);
                WorklistService.InsertOpenOrder(openOrders).then(function (result) {

                });
            }

        };
        $scope.DeleteOpenOrder = function (Order) {
            var lastOrderID;
            var LastOpenedOrder;
            if (Order) {
                lastOrderID = Order.OrderID;
                LastOpenedOrder = Order;
            } else {
                lastOrderID = $scope.LastOpenedOrderID;
                LastOpenedOrder = $scope.LastOpenedOrder;
            }

            ////$log.log("DeleteOpenOrder > lastOrderID: ", lastOrderID);
            if (lastOrderID) {
                $scope.LastOpenedOrderID = null;
                $scope.LastOpenedOrder = null;
                var openOrders = {
                    OrderId: lastOrderID,
                    UserId: $scope.LoggedInUserID
                };
                //$log.log("DeleteOpenOrder > openOrders: ", openOrders);
                WorklistService.DeleteOpenOrder(openOrders).then(function (result) {
                    if ($scope.AutoRefresh) {
                        if ($scope.DictationReportStatus == 'Draft') {
                            LastOpenedOrder.Status = 'D';
                            LastOpenedOrder.ReportStatus = 2;

                            LastOpenedOrder.SignBy = $scope.LoggedInUserID;
                            LastOpenedOrder.RowColorCode = $scope.getRowTemplateColorCode(LastOpenedOrder);

                            $scope.orderList = OrderList;

                            var ProcessedOrders = {
                                UserID: $scope.LoggedInUserID,
                                Type: 'DraftedOrder',
                                OrderList: [LastOpenedOrder],
                            };
                            WorklistService.ProcessedOrdersUpdate(ProcessedOrders);
                        } else if ($scope.DictationReportStatus == 'Final' || $scope.DictationReportStatus == 'Correction') {
                            LastOpenedOrder.Status = 'C';
                            LastOpenedOrder.ReportStatus = 1;

                            LastOpenedOrder.SignBy = $scope.LoggedInUserID;
                            LastOpenedOrder.RowColorCode = $scope.getRowTemplateColorCode(LastOpenedOrder);

                            $scope.orderList = OrderList;

                            var ProcessedOrders = {
                                UserID: $scope.LoggedInUserID,
                                Type: 'SignedOrder',
                                OrderList: [LastOpenedOrder],
                            };
                            WorklistService.ProcessedOrdersUpdate(ProcessedOrders);
                        }
                    }

                    $scope.DictationReportStatus = '';
                    $scope.DictationReportState = '';
                    //$scope.LastOpenedOrder = null;
                    //$scope.OpenedAccessionNumber = '';
                    //$scope.DictatedAccessionNumber = '';
                });

                ////////$log.log("DeleteOpenOrder > LastOpenedOrder: ", LastOpenedOrder);
                //if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {


                ////$log.log("DeleteOpenOrder > LastOpenedOrder: ", LastOpenedOrder);
                if ((LastOpenedOrder)
                    && $scope.DictationReportState == "DictateByPS360"
                    && $scope.NativeMessageResponseReportStatus != -1) {

                    var applyRadflowComplete = false;
                    if ($scope.DefaultDictationSystem.length == 0
                        || $scope.DefaultDictationSystem == 'PS360') {
                        applyRadflowComplete = true;
                    } else if (LastOpenedOrder.DictationSystem.length == 0
                        || LastOpenedOrder.DictationSystem == 'PS360') {
                        applyRadflowComplete = true;
                    }

                    if (applyRadflowComplete) {
                        var reportView = {
                            Site: LastOpenedOrder.Site,
                            PSSiteName: LastOpenedOrder.PSSiteName,
                            OrderID: LastOpenedOrder.OrderID,
                            Accession: LastOpenedOrder.Accession,
                            SignBy: $sessionStorage.currentUserData.userId,
                            SignByName: $sessionStorage.currentUserData.displayName,
                            ProcedureDesc: LastOpenedOrder.ProcedureDesc,
                            CheckDeficiency: (LastOpenedOrder.CheckDeficiency == 0 ? 0 : 1),
                            SignDate: $filter('CSTDateTime')(moment().format("YYYY-MM-DD HH:mm:ss")),
                            SourceSignDate: moment().format("YYYY-MM-DDTHH:mm:ss")
                        };
                        WorklistService.SaveReport(reportView).then(function (result) {
                        });
                    }

                }
            }
        };
        $scope.GetOpenOrder = function () {
            ////////$log.log("GetOpenOrder");
            var openOrders = {
                OrderId: $scope.SingReport.Order.OrderID,
                UserId: $sessionStorage.currentUserData.userId,
                ProviderID: $sessionStorage.currentUserData.userId,
            };
            WorklistService.GetOpenOrder(openOrders).then(function (result) {
                $scope.OpenOrder = result;
                $scope.LastOpenedOrder = result;
                $scope.LastOpenedOrderID = result.OrderID;
                $scope.DictatedAccessionNumber = result.Accession;
            });
        };
        $scope.DeleteOpenOrderByUserID = function () {
            //////$log.log("DeleteOpenOrderByUserID");
            if ($sessionStorage.currentUserData) {
                WorklistService.DeleteOpenOrderByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                });
            }
        };


        $scope.RemoveFromComparison = function (ComparisonOrderID, OrderID) {
            ////////$log.log("RemoveFromComparison");
            if (confirm("Are you sure you want remove this study from comparison?")) {
                $scope.isLoading = true;
                var comparisonOrder = {
                    ComparisonOrderID: ComparisonOrderID,
                    OrderID: OrderID,
                    UserId: $sessionStorage.currentUserData.userId
                };

                WorklistService.RemoveFromComparison(comparisonOrder).then(function (result) {
                    $scope.isLoading = false;

                    var idx = _.findIndex($scope.orderList, function (obj) { return obj.OrderID == OrderID; });
                    if (idx != -1) {
                        var compidx = _.findIndex($scope.orderList[idx].ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderID; });
                        if (compidx != -1) {
                            $scope.orderList[idx].ComparisonOrder.splice(compidx, 1);
                            $scope.SelectedOrder.subGridOptions.data.splice(compidx, 1);
                            if (_gridAPI.selection.getSelectedGridRows() != null && _gridAPI.selection.getSelectedGridRows().length > 0) {
                                _gridAPI.selection.getSelectedGridRows()[0].expandedRowHeight = _gridAPI.selection.getSelectedRows()[0].ComparisonOrder.length * $scope.RowHeight;
                            }
                            if ($scope.orderList[idx].ComparisonOrder && $scope.orderList[idx].ComparisonOrder.length == 0) {
                                $scope.orderList[idx].HasComparison = '0';
                                $scope.SelectedOrder.HasComparison = '0';
                                _gridAPI.expandable.collapseRow($scope.selectedComparisonRow.entity);
                            }

                        }
                    }
                });
            }
        };

        $scope.ViewComparisionOrderReport = function (ComparisonOrderID, OrderID, SelectedOrderAccession) {
            ////////$log.log("ViewComparisionOrderReport");
            $scope.showDiscuss = false;
            //$scope.isLoading = true;
            var comparisionorderlist = [];
            var Hasreport = false;
            $scope.SelectedOrderAccession = SelectedOrderAccession;
            $scope.comparisonorders = _.filter($scope.orderList, function (obj) { return obj.OrderID == ComparisonOrderID; });
            if ($scope.comparisonorders && $scope.comparisonorders.length > 0) {
                $scope.comparisonorders.forEach(function (order) {
                    order.ComparisonOrder.forEach(function (report) {
                        var comporder = { OrderID: report.OrderID };
                        comparisionorderlist.push(comporder);
                    });
                });
                if (comparisionorderlist && comparisionorderlist.length > 0) {
                    var comparisionorderObj = {
                        OrderID: 0,
                        UserID: $sessionStorage.currentUserData.userId,
                        comparisionorderlist: comparisionorderlist
                    }
                    WorklistService.GetComparisonOrderReportByOrderID(comparisionorderObj).then(function (results) {
                        if (results && results.length > 0) {
                            results.forEach(function (report) {
                                var comparisonorderreport = _.filter($scope.comparisonorders[0].ComparisonOrder, function (obj) { return obj.OrderID == report.OrderID; });
                                if (comparisonorderreport && comparisonorderreport.length > 0) {
                                    comparisonorderreport[0].ComparisonOrderReport = report.ReportDecation;
                                    $scope.currentWindow = "win_ComparisonOrderReports";
                                    OpenWindow($scope.win_ComparisonOrderReports, 'win_ComparisonOrderReports');
                                    //$scope.isLoading = false;
                                    $scope.win_ComparisonOrderReports.wrapper.prev(".k-overlay").addClass("custom-overlay");
                                }
                            });
                        }
                        else {
                            toaster.info({ body: "No report found." });
                            //$scope.isLoading = false;
                        }
                    });
                }
                else {
                    //$scope.isLoading = false;
                }
            } else if ($scope.SelectedOrder) {
                $scope.SelectedOrder.ComparisonOrder.forEach(function (report) {
                    var comporder = { OrderID: report.OrderID };
                    comparisionorderlist.push(comporder);
                });
                $q.all([
                    //GetOrderReportByOrderID($scope.SelectedOrder.OrderID),
                    GetComparisonOrderReportByOrderID($scope.SelectedOrder.OrderID, comparisionorderlist)
                ]).then(function (data) {
                    $scope.reportList = [];
                    var report = [];
                    var comparisonReport = [];
                    //if (data != null && data[0] != null && data[0].route == "GetOrderReportByOrderID" && data[0].length > 0) {
                    if (data != null && data.length > 0 && data[0] != null && data[0].length > 0) {
                        report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                        comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                        if (report && report.length > 0) {
                            $scope.SelectedOrder.OrderReport = report[0];
                            Hasreport = true;
                            $scope.reportList.push($scope.SelectedOrder);
                        }

                    }
                    //if (data != null && data[1] != null && data[1].route == "GetComparisonOrderReportByOrderID" && data[1].length > 0) {
                    if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                        comparisonReport.forEach(function (ComparisonOrderReport) {
                            var rptObject = _.filter($scope.SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                            if (rptObject && rptObject.length > 0) {
                                rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                                Hasreport = true;
                                $scope.reportList.push(rptObject[0]);
                            }
                        });
                    }
                    $scope.OrderReport = $scope.SelectedOrder;
                    $scope.reportList = _.uniqBy($scope.reportList, 'OrderID');
                    $scope.PriorReportFilter.List.Modalities = _.concat($scope.PriorReportFilter.List.Modalities, _.uniq(_.map($scope.reportList, 'Modality')));
                    var objSelectedReport = _.filter($scope.reportList, function (obj) { return obj.Accession == SelectedOrderAccession; });
                    if (objSelectedReport && objSelectedReport.length > 0) {
                        LoadReport(objSelectedReport[0].OrderID);
                        if (Hasreport) {
                            $scope.currentWindow = "win_ComparisonOrderReports";
                            OpenWindow($scope.win_ComparisonOrderReports, 'win_ComparisonOrderReports');
                            $scope.win_ComparisonOrderReports.wrapper.prev(".k-overlay").addClass("custom-overlay");
                        }
                        else {
                            toaster.info({ body: "No report found." });
                        }
                    }
                    ReportList = $scope.reportList;
                    if (ReportList.length > 1) {
                        $scope.PriorReportFilter.Modal = true;
                    }
                    //$scope.isLoading = false;

                });
            } else {
                var orderComparisonListFilter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    OrderID: ComparisonOrderID
                };
                WorklistService.GetOrdersComparisonList(orderComparisonListFilter).then(function (result) {

                }).catch(function (noCantDo) {
                    //$scope.isLoading = false;
                });
            }
        };
        $scope.showReport = function (SelectedOrder) {
            ////////$log.log("showReport");
            //$scope.isLoading = true;
            $scope.OrderReport = SelectedOrder;
            $scope.SelectedOrderAccession = SelectedOrder.Accession;
            LoadReport(SelectedOrder.OrderID);
        }
        function getReportData(OrderId) {
            ////////$log.log("getReportData");
            $scope.report = null;
            var UserId = $sessionStorage.currentUserData.userId;
            WorklistService.GetDictationValueReport(OrderId, UserId).then(function (response) {
                $scope.report = response;
                $scope.ReviewOrder = response;

                $scope.orderReportList.push(response);

                if ($scope.report && $scope.report.DOS) {
                    $scope.report.DOS = moment(
                        ($filter('localDate')($scope.report.DOS, false, new Date()))
                    ).format("MM/DD/YYYY");
                }
                if ($scope.report && $scope.report.SingDate) {
                    $scope.report.SingDate = moment(
                        ($filter('localDate')($scope.report.SingDate, false, new Date()))
                    ).format("MM/DD/YYYY");
                }
                if ($scope.report && $scope.report.Patient_DOB) {
                    $scope.report.Patient_DOB = changeDateFormat($scope.report.Patient_DOB);
                }
                if ($scope.OrderReport) {
                    $scope.report.Location = $scope.OrderReport.Location;
                    $scope.report.LocationID = $scope.OrderReport.LocationID;
                }
                //$scope.isLoading = false;
            }, function (error) {
                //$scope.isLoading = false;
            });
        }
        function changeDateFormat(date) {
            ////////$log.log("changeDateFormat");
            if (date) {
                return moment(new Date(date)).format("MM/DD/YYYY");
            }
        }
        function LoadReport(OrderId) {
            ////////$log.log("LoadReport");


            if ($scope.orderReportList && $scope.orderReportList.length > 0) {
                var data = _.filter($scope.orderReportList, function (obj) { return obj.OrderID == OrderId; });
                if (data && data.length > 0) {
                    $scope.report = data[0];
                    $scope.ReviewOrder = {};
                    angular.copy($scope.report, $scope.ReviewOrder);
                    //$scope.isLoading = false;
                }
                else {
                    $scope.ReviewOrder = {};
                    getReportData(OrderId);
                }
            }
            else {
                $scope.ReviewOrder = {};
                getReportData(OrderId);
            }

        }
        $scope.SaveReviewOrder = function () {
            ////////$log.log("SaveReviewOrder");
            //$scope.isLoading = true;
            WorklistService.UpdateReviewOrder($scope.ReviewOrder).then(function (result) {
                ////$scope.isLoading = false;
                $scope.SelectedOrder.Rating = $scope.ReviewOrder.Rating;
                $scope.SelectedOrder.Comments = $scope.ReviewOrder.Comments;
                $scope.SelectedOrder.IsInterestingCase = $scope.ReviewOrder.IsInterestingCase;
                $scope.SelectedOrder.Keywords = $scope.ReviewOrder.Keywords;

                var index = _.findIndex($scope.orderReportList, function (obj) {
                    return obj.OrderID == $scope.ReviewOrder.OrderID;
                });
                if (index != -1)
                    $scope.orderReportList[index] = $scope.ReviewOrder;

                //$scope.refresh();
            });
        }

        $scope.ViewOrderReport = function (SelectedOrder, SelectedOrderAccession) {
            ////////$log.log("ViewOrderReport");
            $scope.showDiscuss = false;
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;

            var ComparisionOrderList = [];

            if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length == 0) {
                $scope.orderComparisonListFilter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = result;
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });

                    setPriorReport(SelectedOrder, ComparisionOrderList);
                }).catch(function (noCantDo) {
                    //$scope.isLoading = false;
                });
            } else if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                setPriorReport(SelectedOrder, ComparisionOrderList);
            } else {
                setPriorReport(SelectedOrder, ComparisionOrderList);
            }



            //var obj = GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList);
        };


        function GetComparisonOrderReportByOrderID(OrderID, ComparisionOrderList) {
            ////////$log.log("GetComparisonOrderReportByOrderID");
            var d = $q.defer();
            //if (ComparisionOrderList && ComparisionOrderList.length > 0) {
            var comparisionorderObj = {
                OrderID: OrderID,
                UserID: $sessionStorage.currentUserData.userId,
                comparisionorderlist: ComparisionOrderList
            }

            WorklistService.GetComparisonOrderReportByOrderID(comparisionorderObj).then(function (results) {
                d.resolve(results);
            });
            //}
            //else {
            //    return null;
            //}
            return d.promise;
        }
        function GetDicomViewerCredentials(SiteID, ViewerName) {
            ////////$log.log("GetDicomViewerCredentials");
            $scope.DVCred = {};
            var d = $q.defer();
            var out = {};
            var objFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: SiteID,
                ViewerName: ViewerName
            };
            if (__env.CheckDicomViewerCredentials.split(',').indexOf(ViewerName) !== -1) {
                out.RequiredCredentials = true;
                WorklistService.GetDicomViewerCredentials(objFilter).then(function (result) {
                    if (result != null && result.length > 0) {
                        out.RequiredCredentials = true;
                        out.ShowModal = false;
                        out.Credentials = {};
                        out.Credentials.UserName = result[0].UserName;
                        out.Credentials.Password = result[0].Password;
                        d.resolve(out);
                    }
                    else {
                        out.ShowModal = true;
                        $scope.DVCred.SiteID = SiteID;
                        $scope.DVCred.ViewerName = ViewerName;
                        $('#ModalDicomViewerCredentials').modal('show');
                        d.resolve(out);
                    }
                });
            }
            else {
                out.RequiredCredentials = false;
                out.ShowModal = false;
                d.resolve(out);
            }
            return d.promise;
        }
        function GetAllStatusCount() {
            $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            if ($scope.OrderDateType && $scope.OrderDateType.match('All')) {
                $scope.OrderDate = {
                    startDate: null,
                    endDate: null
                };
            }
            var orderListFilter = {
                UserID: $sessionStorage.currentUserData.userId,
                WorklistFlag: $scope.SelectedList.Worklist.Key,
                SiteID: $scope.SelectedList.Site ? $scope.SelectedList.Site.SiteID : null,
                LocationID: $scope.locationIDs && $scope.locationIDs.length > 0 ? $scope.locationIDs : null,
                AdminWorklistIds: $scope.worklistIds_Admin && $scope.worklistIds_Admin.length > 0 ? $scope.worklistIds_Admin : null,
                UserWorklistIds: $scope.worklistIds_User && $scope.worklistIds_User.length > 0 ? $scope.worklistIds_User : null,
                Accession: $scope.Accession,
                ModalityID: $scope.modalityIDs && $scope.modalityIDs.length > 0 ? $scope.modalityIDs : null,
                OrderDateStartDate: ($scope.OrderDate.startDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.OrderDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00")) : null,
                OrderDateEndDate: ($scope.OrderDate.endDate) ? $filter('CSTDateTime')(moment(moment(new Date($scope.OrderDate.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")) : null,
                PatientName: $scope.PatientName,
                PatientMRN: $scope.PatientMRN,
                PatientDOB: $scope.formatted_date($scope.DOB),
                PatientClass: $scope.SelectedList.PatientClass ? $scope.SelectedList.PatientClass.Value : null,
                OrderingPhysician: $scope.OrderingPhysician,
                Status: $scope.Status.key,
                ShowLockStudy: $scope.ShowLockStudy,
                FromSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "00:00")),
                ToSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59"))
            };
            WorklistService.GetAllStatusCount(orderListFilter).then(function (results) {
                setDefaultCounter();
                if (results != null) {
                    $scope.CancelCount = results.CancelCount;
                    $scope.ComparisonCount = results.ComparisonCount;
                    $scope.WorklistPageHeaderParameter.CompleteCount = results.CompleteCount;
                    $scope.WorklistPageHeaderParameter.DraftCount = results.DraftCount;
                    $scope.WorklistPageHeaderParameter.HiddenCount = results.HiddenCount;
                    $scope.ORMPendingCount = results.ORMPendingCount;
                    $scope.ImagePendingCount = results.ImagePendingCount;
                    $scope.RadFlowCompleteCount = results.RadFlowCompleteCount;
                    $scope.WorklistPageHeaderParameter.ResultPendingCount = results.ResultPendingCount;
                    $scope.WorklistPageHeaderParameter.StatCount = results.StatCount;
                    $scope.WorklistPageHeaderParameter.SignedToday = results.SignedToday;
                }

            });
        }
        function setDefaultCounter() {
            ////$log.log("setDefaultCounter: " + new Date());
            $scope.CancelCount = 0;
            $scope.ComparisonCount = 0;
            $scope.WorklistPageHeaderParameter.CompleteCount = 0;
            $scope.WorklistPageHeaderParameter.DraftCount = 0;
            $scope.WorklistPageHeaderParameter.HiddenCount = 0;
            $scope.ORMPendingCount = 0;
            $scope.ImagePendingCount = 0;
            $scope.RadFlowCompleteCount = 0;
            $scope.WorklistPageHeaderParameter.ResultPendingCount = 0;
            $scope.WorklistPageHeaderParameter.StatCount = 0;
            $scope.WorklistPageHeaderParameter.SignedToday = 0;
        }

        $scope.HideOrder = function () {
            ////////$log.log("HideOrder");
            if ($scope.SelectedOrderID != null && $scope.SelectedOrderID.length > 0 && $scope.SelectedOrder != null &&
                ($scope.SelectedOrder.Status == 'RP' || $scope.SelectedOrder.Status == 'H') && ($scope.SelectedOrder.IsLock == false || $sessionStorage.currentUserData.userId == $scope.SelectedOrder.LockByProviderID)) {
                if ($scope.SelectedOrder.Status != "H") {

                    $scope.HideOption.Key = _.clone($scope.HiddenTypeList[0].Key);
                    $scope.HideOption.Comments = '';
                    $scope.currentWindow = "win_HideStudy";
                    OpenWindow($scope.win_HideStudy, 'win_HideStudy');
                    $scope.win_HideStudy.wrapper.prev(".k-overlay").addClass("custom-overlay");
                }
                else {
                    HideUnhideOrder();
                }


            }
        };
        $scope.OpenSynapseStudy = function (Order, OptionalDV, isOpenPS, isSingleView) {
            ////////$log.log("OpenSynapseStudy");

            $scope.GetDicomViewerCredentialsCallFrom = "OPENSYNAPSESTUDY";
            $scope.OpenSynapseStudyOrder = Order;
            $scope.OpenSynapseStudyOptionalDV = OptionalDV;
            $scope.OpenSynapseStudyisOpenPS = isOpenPS;
            $q.all([
                GetDicomViewerCredentials(Order.SiteID, OptionalDV)
            ]).then(function (data) {
                if (data != null && data.length > 0 && data[0] != null) {
                    if (data[0].ShowModal) { return; }
                    else {
                        Order.DicomViewerCredentials = data[0].Credentials;
                        if (__env.showLoaderonPSNViewerLoad) {
                            $scope.isLoadingSynapse = true;
                        }
                        setTimeout(function () {
                            OpenSynapseStudy(Order, OptionalDV, isOpenPS, isSingleView);
                            $scope.isLoadingSynapse = false;
                        }, 500);
                    }
                }
            });
        };

        function HideUnhideOrder(type) {
            ////$log.log("HideUnhideOrder");
            $scope.isLoading = true;
            var order = {
                OrderID: $scope.SelectedOrderID,
                IsHide: $scope.SelectedOrder.Status == 'H' ? false : true,
                Type: type,
                Min: 0,
                UserId: $sessionStorage.currentUserData.userId,
                PhysicianName: $sessionStorage.currentUserData.displayName,
                order: $scope.SelectedOrder,
                Comments: $scope.HideOption.Comments,
                HideType: $scope.HideOption.Key,
            };
            switch (type) {
                case 1:
                    order.EventType = 'HNR';
                    break;
                case 2:
                    order.EventType = 'HHR';
                    break;
                case 3:
                    order.EventType = 'HNC';
                    break;
                case 4:
                    order.EventType = 'HNI';
                    break;
                case 5:
                    order.EventType = 'HMP';
                    break;
                case 6:
                    order.EventType = 'HMO';
                    break;
                case 7:
                    order.EventType = 'HMCT';
                    break;
                case 8:
                    order.EventType = 'HEM';
                    break;
            }
            WorklistService.ShowHideOrder(order).then(function (result) {
                $scope.isLoading = false;
                if ((type >= 3 && type <= 8) && $scope.HideOption && $scope.HideOption.Comments && $scope.HideOption.Comments.length > 0) {
                    $scope.Discussion = {
                        ReferenceID: $scope.SelectedOrder.DicomOrderID,
                        Type: 1,
                        Comment: $scope.HideOption.Key + ' - ' + $scope.HideOption.Comments,
                        Record_Created_By: $sessionStorage.currentUserData.userId
                    };
                    $scope.SaveDiscussion(order.EventType);
                }
                else if (type == 1) {
                    $scope.Discussion = {
                        ReferenceID: $scope.SelectedOrder.DicomOrderID,
                        Type: 1,
                        Comment: $scope.HideOption.Key,
                        Record_Created_By: $sessionStorage.currentUserData.userId
                    };
                    $scope.SaveDiscussion(order.EventType);
                }

                $scope.SelectedOrderID = "";
                $scope.win_HideStudy.close();
                //$scope.refresh();
                if (type >= 3 && type <= 8) {
                    WorklistService.sendTextNotification(order);
                }

            });
        }
        $scope.CancelHideStudy = function () {
            ////////$log.log("CancelHideStudy");
            $scope.win_HideStudy.close();
        };
        $scope.HideStudy = function (Comments) {
            ////$log.log("HideStudy");
            var hiddenType = _.find($scope.HiddenTypeList, { Key: $scope.HideOption.Key });
            var hiddenTypeValue = 0;
            if (hiddenType) {
                hiddenTypeValue = parseInt(hiddenType.Value);
            }
            $scope.HideOption.Comments = Comments;
            HideUnhideOrder(hiddenTypeValue);
            //$scope.isLoading = true;
        };
        $scope.HelpOrder = function () {
            ////////$log.log("HelpOrder");
            if ($scope.SelectedOrder && $scope.SelectedOrder.DicomOrderID) {
                $scope.ODType = 'Assigner';
                $scope.OrderDiscussion = null;
                $('#ModalDiscussion').modal('show');
                $scope.showDiscuss = false;
                $q.all([
                    $scope.GetAllUsers($scope.SelectedOrder.SiteID)
                ]).then(function (data) {
                    $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID, 'Assigner');
                    LoadOrderDiscussionForUser();
                });
            }
        };

        $scope.keys = {
            F12: function (name, code) { $scope.HideOrder(); },
            F11: function (name, code) { $scope.HelpOrder(); }
        };


        $scope.winSingReport_OnClose = function () {
            //$log.log("winSingReport_OnClose");
            if ($scope.LastOpenedOrderID != null) {
                $scope.DictationReportState = "DictateByPS360";
                removeOrderFromList($scope.LastOpenedOrderID);
                $scope.DeleteOpenOrder();
            }
            //$scope.refresh();
        }
        $scope.winComparisonOrderReports_OnClose = function () {
            ////////$log.log("winComparisonOrderReports_OnClose");
            var div = document.getElementById('OrderReport' + $scope.SelectedOrderAccession);
            if (div != null) {
                div.scrollIntoView();
            }
        }

        function OpenSynapseStudy(Order, Viewer, isOpenPS, isSingleView) {
            ////////$log.log("OpenSynapseStudy");
            if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                // Change Default Dicom Viewer to Agfa is it is inatalled.  
                if ($sessionStorage.AgfaSetup == true && Order.Site.toUpperCase().replace(" ", "") == "MHSRICHARDSON") {
                    Viewer = "AGFA";
                }

                if (Viewer == null || Viewer.length == 0 || Viewer == "SYNAPSE") {
                    try {
                        var accession = Order.Accession;
                        if (Order.Site.toUpperCase() == 'DECATUR') {
                            accession = accession.toUpperCase().replace('WHS', '');
                        }
                        var oSynapseAPI = new ActiveXObject("Synapse.SynapseAPI");
                        var sStudyPath = oSynapseAPI.MakePath(1, accession);

                        oSynapseAPI.OpenSynapseExplorer("Synapse", Order.DicomViewerURL, sStudyPath);

                    } catch (e) {
                        //////$log.log(e);
                        toaster.warning({ body: "Unable to find the image in Synapse." });
                    }
                }
                else if (Viewer == "CANDELIS") {
                    try {
                        window.open(__env.candelisURL + encodeURIComponent(Order.Accession), "_self");
                    } catch (e) {
                        //////$log.log(e);
                        toaster.warning({ body: "Unable to find the image in Candelis." });
                    }
                }
                else if (Viewer == "AGFA") {
                    try {
                        window.open(__env.agfaURL + encodeURIComponent(Order.PatientMRN.toUpperCase().replace("MHS", "")) + "&accession=" + encodeURIComponent(Order.Accession.toUpperCase().replace("MHS", "")), "_self");
                    } catch (e) {
                        //////$log.log(e);
                        toaster.warning({ body: "Unable to find the image in Agfa." });
                    }
                }
                else if (Viewer == "KONICA" || Viewer == "KONICATEST" || Viewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                    try {
                        window.open(__env._environment.config.konicaURL.replace("@MRN", encodeURIComponent(Order.PatientMRN)).replace("@ACCESSION", encodeURIComponent(Order.Accession)).replace("@VIEWER", encodeURIComponent(Viewer)), "_self");
                    } catch (e) {
                        //////$log.log(e);
                        toaster.warning({ body: "Unable to find the image in Konica." });

                    }
                }
                //else if (Viewer == "KONICATEST") {
                //    try {
                //        window.open(APP_CONSTANTS.konicaTestURL.replace("@MRN", Order.PatientMRN).replace("@ACCESSION", Order.Accession).replace("@SITE", Order.Site), "_self");
                //    } catch (e) {
                //        //////$log.log(e);
                //        swal("Unable to find the image in Konica.");
                //    }
                //}
                else if (Viewer == "GECUV") {
                    try {
                        OpenGECentricity(Order.Accession, Order.DicomViewerCredentials);
                    } catch (e) {
                        //////$log.log(e);
                        toaster.warning({ body: "Unable to find the image in Centricity Universal Viewer." });
                    }
                }
                else if (Viewer == "CI-VIEWER") {
                    try {
                        OpenCIDicomViewer(Order.Accession);
                    } catch (e) {
                        ////$log.log(e);
                        toaster.warning({ body: "Unable to find the image in CI-Viewer." });

                    }
                } else if (Viewer == "MedDream") {
                    openMedDream(Order);
                }

                //Open Report in PS
                setTimeout(function () {
                    if (isOpenPS) {
                        try {
                            //Synchronize accession with PowerScribe 360 By Creating XML File
                            if ($sessionStorage.AgfaSetup == true && Order.Site.toUpperCase().replace(" ", "") == "MHSRICHARDSON") //(Viewer == "AGFA") {
                            {
                                var accession = Order.Accession.toUpperCase().replace("MHS", "");
                                CreateMHSPS360File(accession);
                                return;
                            }

                            RadWhereCtrl.Start();
                            try {
                                if (RadWhereCtrl.accessionNumbers) {
                                    $scope.CloseFrom = "RADFLOW"; //"RADFLOW" , "PS360"
                                    var r = RadWhereCtrl.CloseReport(false, false);
                                    while (!r) {
                                        r = RadWhereCtrl.CloseReport(false, false);
                                    }
                                }
                            }
                            catch (e) {
                                //swal("Unable to find the order in PS360.");
                                //////$log.log(e);
                            }
                            //Synchronize accession with PowerScribe 360
                            RadWhereCtrl.OpenReport(Order.PSSiteName, Order.Accession);


                        } catch (e) {
                            toaster.warning({ body: "Unable to find the order in PS360." });
                            //////$log.log(e);
                        }
                    }
                }, 500);

            }
            else {

                if (isOpenPS) {
                    if ($scope.DefaultDictationSystem && $scope.DefaultDictationSystem == 'PS360') {
                        openPS360(Order);
                    } else if ($scope.DefaultDictationSystem && $scope.DefaultDictationSystem == 'CIVR') {
                        $scope.OpenVR(Order, false);
                    } else if (Order.DictationSystem && Order.DictationSystem == 'CIVR') {
                        $scope.OpenVR(Order, false);
                    } else if (Order.DictationSystem && Order.DictationSystem == 'PS360') {
                        openPS360(Order);
                    } else {
                        $scope.OpenVR(Order, false);
                    }

                }


                if (Viewer == "CI-VIEWER") {
                    OpenCIDicomViewer(Order.Accession, isSingleView);
                }
                else if (Viewer == "KONICA" || Viewer == "KONICATEST" || Viewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                    $scope.openKonica(Order, Viewer);
                }
                else if (Viewer == "SYNAPSE") {
                    var accession = Order.Accession;
                    if (Order.Site.toUpperCase() == 'DECATUR') {
                        accession = accession.toUpperCase().replace('WHS', '');
                    }
                    openSynapseImage(Order.DicomViewerURL, accession);
                } else if (Viewer == "MedDream") {
                    openMedDream(Order);
                }
                //else if (Viewer == "KONICATEST") {
                //    $scope.openKonicaTest(Order);
                //}

            }
        }
        function CreateMHSPS360File(accession) {
            ////////$log.log("CreateMHSPS360File");
            try {
                var fso, file, filepath, filecontent;
                filepath = __env._MHSRichardsonXmlPath_;
                filecontent = __env._MHSRichardsonXmlFile_.replace("@Accession", accession);
                fso = new ActiveXObject("Scripting.FileSystemObject");
                file = fso.CreateTextFile(filepath);
                file.WriteLine(filecontent);
                file.close();
            }
            catch (err) {
                alert(err.message);
            }
        }


        function OpenGECentricity(Accession, ViewerCrendetials) {
            ////////$log.log("OpenGECentricity");
            var map = window.open("", "Map", "status=0,title=0,width=700,height=600,left=500,top=300,scrollbars=1");
            if (map) {
                var form = map.document.createElement('form');
                form.method = 'POST';
                form.action = __env._environment.config.GECentricityURL;

                var userInput = map.document.createElement('input');
                userInput.type = 'hidden';
                userInput.name = 'user_name';
                userInput.value = ViewerCrendetials.UserName;
                form.appendChild(userInput);

                var passInput = map.document.createElement('input');
                passInput.type = 'hidden';
                passInput.name = 'password';
                passInput.value = ViewerCrendetials.Password;
                form.appendChild(passInput);

                var accInput = map.document.createElement('input');
                accInput.type = 'hidden';
                accInput.name = 'accession_number';
                accInput.value = Accession;
                form.appendChild(accInput);

                map.document.body.appendChild(form);
                form.submit();
            } else {
                swal("You must allow pop-ups for this to work.");
            }
        }
        function OpenCIDicomViewer(accession, isSingleView) {
            ////////$log.log("OpenCIDicomViewer");

            openRequestedPopup(accession, isSingleView);
        }
        function openRequestedPopup(accession, isSingleView) {

            if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
            }
            else {
                windowHandler.openByPreference(__env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 1), "CI-VIEWER-1", 1000, isSingleView ? "CI-VIEWER-1-" + accession.toUpperCase().trim() : null, "", false);
                //windowHandler.openByPreference(APP_CONSTANTS.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 2), "CI-VIEWER-2", 1000, "", false, isSingleView ? "CI-VIEWER-2-" + accession : null);
            }

        }

        function SaveFilterValues() {
            ////$log.log("SaveFilterValues");
            $scope.worklistSaved = true;
            $scope.columns = [];
            var obj = {};

            if ($scope.locationIDs != ',' && $scope.locationIDs != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'LocationID', Value: $scope.locationIDs };
                $scope.columns.push(obj);
            }
            if ($scope.worklistIds_Admin != ',' && $scope.worklistIds_Admin != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'WorklistIds_A', Value: $scope.worklistIds_Admin };
                $scope.columns.push(obj);
            }
            if ($scope.worklistIds_User != ',' && $scope.worklistIds_User != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'WorklistIds_U', Value: $scope.worklistIds_User };
                $scope.columns.push(obj);
            }
            if ($scope.Accession) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'Accession', Value: $scope.Accession };
                $scope.columns.push(obj);
            }
            if ($scope.OrderDate.startDate) {
                $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'OrderDate', Value: ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' + moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType };
                $scope.columns.push(obj);
            }
            if ($scope.modalityIDs != ',' && $scope.modalityIDs != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'ModalityID', Value: $scope.modalityIDs };
                $scope.columns.push(obj);
            }
            if ($scope.PatientName) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'PatientName', Value: $scope.PatientName };
                $scope.columns.push(obj);
            }
            if ($scope.PatientMRN) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'PatientMRN', Value: $scope.PatientMRN };
                $scope.columns.push(obj);
            }
            if ($scope.DOB) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'PatientDOB', Value: $scope.DOB };
                $scope.columns.push(obj);
            }
            if ($scope.SelectedList.PatientClass) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'PatientClass', Value: $scope.SelectedList.PatientClass.Value };
                $scope.columns.push(obj);
            }
            if ($scope.OrderingPhysician) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'OrderingPhysician', Value: $scope.OrderingPhysician };
                $scope.columns.push(obj);
            }
            if ($scope.Status) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'Status', Value: $scope.Status.key };
                $scope.columns.push(obj);
            }
            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'STATFilter', Value: $scope.STATFilter ? "1" : "0" };
            $scope.columns.push(obj);
            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: $scope.OrderByField, Value: $scope.ReverseSort ? "1" : "0" };
            $scope.columns.push(obj);
            if ($scope.SelectedList.StudyPriority) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'Priority', Value: $scope.SelectedList.StudyPriority.Key };
                $scope.columns.push(obj);
            }
            if ($scope.columns && $scope.columns.length > 0) {
                WorklistService.SaveFilterSetting($scope.columns).then(function (result) {
                    toaster.success({ body: "Filter saved successfully." });
                    $scope.getData();
                });
            }
        }

        function saveFilterAsWorkList() {
            ////////$log.log("saveFilterAsWorkList");
            swal({
                title: "Enter Worklist Name!",
                text: "",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: true,
                showLoaderOnConfirm: false,
                animation: "slide-from-top",
                inputPlaceholder: "Worklist Name"
            },
                function (inputValue) {
                    if (inputValue) {
                        inputValue = inputValue.trim();
                    }
                    if (inputValue === false)
                        return false;
                    if (inputValue === "") {
                        swal.showInputError("You need to write something!");
                        return false;
                    }
                    createWorkList(inputValue);
                });
        }
        function createWorkList(workListName) {
            ////////$log.log("createWorkList");

            var obj = {};
            var dt = new Date();

            //#region Create Object

            var RulesConditions = [];
            var RulesProviders = [{ ProviderID: $sessionStorage.currentUserData.userId }];
            $scope.RuleTable = RuleSharedService.ReSetMasterData();

            if ($scope.locationIDs != ',' && $scope.locationIDs != '') {
                var locationRuleTableIndex = _.findIndex($scope.RuleTable, { 'Key': 'Locations' });
                var locationRuleOperator = _.find($scope.RuleTable[locationRuleTableIndex].RuleOperator, { 'Value': 'IN' });
                var locationRuleTableValues = [];
                _.each($scope.Location, function (loc) {
                    locationRuleTableValues.push({
                        ID: loc.LocationID,
                        Value: loc.Location,
                        Description: loc.Site,
                    });
                });
                obj = {
                    TableName: 'Locations',
                    ColumnName: 'ORDERS.LocationID',
                    Operator: 'IN',
                    Value: _.join(_.map(_.split($scope.locationIDs, ','), function (num) { return "'" + num + "'"; }), ','),
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.RuleTable[locationRuleTableIndex],
                    RuleOperator: locationRuleOperator,
                    RuleTableValues: locationRuleTableValues,
                    AndOr: "AND",
                };
                RulesConditions.push(obj);

                _.remove($scope.RuleTable, function (n, index) {
                    return index == locationRuleTableIndex;
                });
            }
            //if ($scope.Accession) {
            //    obj = { TableName: 'Accession', ColumnName: 'ORDERS.Accession', Operator: '=', Value: "'" + $scope.Accession + "'", ModifyBy: $sessionStorage.currentUserData.userId };
            //    RulesConditions.push(obj);
            //}
            if ($scope.OrderDate.startDate) {
                var dosRuleTableIndex = _.findIndex($scope.RuleTable, { 'Key': 'DOS' });
                var dosRuleOperator = _.find($scope.RuleTable[dosRuleTableIndex].RuleOperator, { 'Value': '=' });
                $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
                if ($scope.OrderDateType.match('Custom')) {
                    obj = {
                        TableName: 'DOS',
                        ColumnName: 'ORDERS.OrderDate',
                        Operator: '=',
                        Value: $scope.OrderDateType + " '" + $scope.OrderDate.startDate.format("MM-DD-YYYY") + "' and '" + $scope.OrderDate.endDate.format("MM-DD-YYYY") + "'",
                        ModifyBy: $sessionStorage.currentUserData.userId,
                        RuleTable: $scope.RuleTable[dosRuleTableIndex],
                        RuleOperator: dosRuleOperator,
                        DateValue: {
                            startDate: $scope.OrderDate.startDate.format("MM-DD-YYYY"),
                            endDate: $scope.OrderDate.endDate.format("MM-DD-YYYY"),
                            label: $scope.OrderDateType,
                        },
                        AndOr: "AND",
                    };
                    RulesConditions.push(obj);
                }
                else {
                    obj = {
                        TableName: 'DOS',
                        ColumnName: 'ORDERS.OrderDate',
                        Operator: '=',
                        Value: $scope.OrderDateType,
                        ModifyBy: $sessionStorage.currentUserData.userId,
                        RuleTable: $scope.RuleTable[dosRuleTableIndex],
                        RuleOperator: dosRuleOperator,
                        DateValue: {
                            startDate: $scope.OrderDate.startDate.format("MM-DD-YYYY"),
                            endDate: $scope.OrderDate.endDate.format("MM-DD-YYYY"),
                            label: $scope.OrderDateType,
                        },
                        AndOr: "AND",
                    };
                    RulesConditions.push(obj);
                }
                _.remove($scope.RuleTable, function (n, index) {
                    return index == dosRuleTableIndex;
                });
            }
            if ($scope.modalityIDs != ',' && $scope.modalityIDs != '') {
                var modalityRuleTableIndex = _.findIndex($scope.RuleTable, { 'Key': 'Modality' });
                var modalityRuleOperator = _.find($scope.RuleTable[modalityRuleTableIndex].RuleOperator, { 'Value': 'IN' });
                var modalityRuleTableValues = [];
                _.each($scope.Modality, function (mod) {
                    modalityRuleTableValues.push({
                        ID: mod.Id,
                        Value: mod.Code,
                        Description: mod.Description,
                    });
                });
                obj = {
                    TableName: 'Modality',
                    ColumnName: 'ORDERS.ModalityID',
                    Operator: 'IN',
                    Value: _.join(_.map(_.split($scope.modalityIDs, ','), function (num) { return "'" + num + "'"; }), ','),
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.RuleTable[modalityRuleTableIndex],
                    RuleOperator: modalityRuleOperator,
                    RuleTableValues: modalityRuleTableValues,
                    AndOr: "AND",
                };
                RulesConditions.push(obj);

                _.remove($scope.RuleTable, function (n, index) {
                    return index == modalityRuleTableIndex;
                });
            }
            if ($scope.SelectedList.PatientClass) {
                var patientClassRuleTableIndex = _.findIndex($scope.RuleTable, { 'Key': 'Patient Class' });
                var patientClassRuleOperator = _.find($scope.RuleTable[patientClassRuleTableIndex].RuleOperator, { 'Value': '=' });
                var patientClassRuleTableValue = {
                    ID: $scope.SelectedList.PatientClass.Value,
                    Value: $scope.SelectedList.PatientClass.Value,
                    Description: "",
                };
                obj = {
                    TableName: 'dbo.Lookups',
                    ColumnName: 'ORDERS.PatientClass',
                    Operator: '=',
                    Value: "'" + $scope.SelectedList.PatientClass.Value + "'",
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.RuleTable[patientClassRuleTableIndex],
                    RuleOperator: patientClassRuleOperator,
                    RuleTableValue: patientClassRuleTableValue,
                    AndOr: "AND",
                };
                RulesConditions.push(obj);

                _.remove($scope.RuleTable, function (n, index) {
                    return index == patientClassRuleTableIndex;
                });
            }
            //if ($scope.OrderingPhysician) {
            //    obj = { TableName: 'Ordering Physician',ColumnName: 'ORDERS.ProviderID', Operator: '=', Value: "'" + $scope.OrderingPhysician + "'", ModifyBy: $sessionStorage.currentUserData.userId };
            //    RulesConditions.push(obj);
            //}
            //0: Routine, 1: Delayed STAT, 2: STAT
            if ($scope.SelectedList.StudyPriority && $scope.SelectedList.StudyPriority.Key != 'All') {
                var priorityRuleTableIndex = _.findIndex($scope.RuleTable, { 'Key': 'Exam Priority' });
                var priorityRuleOperator = _.find($scope.RuleTable[priorityRuleTableIndex].RuleOperator, { 'Value': '=' });

                var delayedSTAT = '';
                switch ($scope.SelectedList.StudyPriority.Key) {
                    case 'STAT':
                        delayedSTAT = '2';
                        break;
                    case 'DelayedSTAT':
                        delayedSTAT = '1';
                        break;
                    case 'Routine':
                        delayedSTAT = '0';
                        break;
                }
                obj = {
                    TableName: 'Exam Priority',
                    ColumnName: 'ORDERS.DelayedSTAT',
                    Operator: '=',
                    Value: delayedSTAT,
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.RuleTable[priorityRuleTableIndex],
                    RuleOperator: priorityRuleOperator,
                    RuleTableValue: {
                        Value: $scope.SelectedList.StudyPriority.Value,
                        ID: delayedSTAT
                    },
                    AndOr: "AND",
                };
                RulesConditions.push(obj);



                _.remove($scope.RuleTable, function (n, index) {
                    return index == priorityRuleTableIndex;
                });
            }

            if ($scope.Status.key != 'AL') {
                var statusRuleTableIndex = _.findIndex($scope.RuleTable, { 'Key': 'Exam Status' });
                var statusRuleOperator = _.find($scope.RuleTable[statusRuleTableIndex].RuleOperator, { 'Value': '=' });

                obj = {
                    TableName: 'Exam Status',
                    ColumnName: 'ORDERS.ExamStatus',
                    Operator: '=',
                    Value: $scope.Status.key == 'H' ? $scope.Status.key + ':0' : $scope.Status.key,
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.RuleTable[statusRuleTableIndex],
                    RuleOperator: statusRuleOperator,
                    RuleTableValue: {
                        Value: $scope.Status.value,
                        ID: $scope.Status.key,
                    },
                    AndOr: "AND",
                };
                RulesConditions.push(obj);

                _.remove($scope.RuleTable, function (n, index) {
                    return index == statusRuleTableIndex;
                });
            }

            $scope.Rule = {
                RuleName: workListName,
                RuleDescription: workListName,
                ModifyBy: $sessionStorage.currentUserData.userId,
                IsEnabled: true,
                WorkListName: workListName,
                IsWorkList: "1",
                Groups: [
                    {
                        GroupID: 0,
                        GroupOperator: 'And',
                        RulesConditions: RulesConditions,
                    }
                ],
                RulesProviders: RulesProviders,
                StatusFlag: 'N',
                Type: 'A'
            };
            //#endregion

            if (RulesConditions && RulesConditions.length > 0) {
                $q.all([
                    RuleSharedService.SetRule($scope.Rule)
                ]).then(function (data) {
                    var result = data[0];
                    if (result.RuleID === -1) {
                        toaster.warning({ body: "Worklist name already exists!" });

                    }
                    else {
                        $scope.Rule.RuleID = result.RuleID;
                        $scope.WorkLists.push(_.clone($scope.Rule))

                        $scope.WorkLists = _.orderBy($scope.WorkLists, ['WorkListName'], ['asc']);

                        for (var i = 0; i < $scope.WorkLists.length; i++) {
                            $scope.WorkLists[i].role = $scope.userRole;
                            $scope.WorkLists[i].index = i;
                        }

                        var CheckedWorklist = [];
                        if ($scope.SelectedWorkList.length > 0) {
                            CheckedWorklist = $scope.SelectedWorkList;
                        }
                        updateWorklistDropDown();
                        $scope.SelectedWorkList = CheckedWorklist;
                        setSelectedWorklistFilterSettings();

                        toaster.success({ body: "Worklist saved successfully!" });

                    }

                });
            }
            else {
                toaster.warning({ body: "Please select atleast one worklist!" });
            }
        }

        $scope.saveFilterOnly = function () {
            ////////$log.log("createWorkList");
            refreshOnClick = true;
            SaveFilterValues();
            angular.element('#ModalWorkList').modal('hide');
        }

        $scope.createWorkList = function () {
            refreshOnClick = true;
            saveFilterAsWorkList();
            angular.element('#ModalWorkList').modal('hide');
        }

        $scope.SaveFilters = function () {
            ////////$log.log("SaveFilters");
            if (!validateDOS(true)) return;
            angular.element('#ModalWorkList').modal('show');

        };

        function getPSWFilterSetting() {
            ////$log.log("getPSWFilterSetting");
            $scope.clearFilter();
            var Filter = {
                UserId: $sessionStorage.currentUserData.userId,
                PageName: 'Work List'
            };
            WorklistService.GetPageSetting(Filter).then(function (result) {
                if (result) {
                    var ColSort = _.find(result, function (item) { return item.PageName == "Work ListColSort"; });
                    if (ColSort != null) {
                        $scope.OrderByField = ColSort.ColumnName;
                        $scope.ReverseSort = (ColSort.Value == "1") ? true : false;
                        var idx = _.findIndex(result, function (obj) { return obj.PageName == "Work ListColSort"; });
                        if (idx != -1) {
                            result.splice(idx, 1);
                        }
                    }
                    _.each(result, function (data) {
                        switch (data.ColumnName) {
                            case 'LocationID':
                                var locations = [];
                                if (data.Value) {
                                    _.each(data.Value.split(','), function (data) {
                                        if (data) {
                                            var filter = _.find($scope.Locations, function (item) { return item.LocationID == data && item.SiteID != 0; });
                                            if (filter != null) {
                                                locations.push(filter);
                                            }
                                        }
                                    });
                                }
                                $scope.SelectedList.Location = locations;
                                $scope.locationIDs = data.Value;//User Story 19673: Improve Location Filter
                                $scope.SelectedLocations = {
                                    Ids: data.Value,
                                    locations: locations,
                                    divId: "OldWorklistFilter"
                                };
                                break;
                            case 'WorklistIds_A':
                                var locations = [];
                                if (data && data.Value) {
                                    _.each(data.Value.split(','), function (data) {
                                        if (data) {
                                            var filter = _.find($scope.WorkLists, function (item) { return item.RuleID == data; });
                                            if (filter != null) {
                                                locations.push(filter);
                                            }
                                        }
                                    });
                                }

                                if ($scope.SelectedWorkList != null) {
                                    _.each(locations, function (data) {
                                        $scope.SelectedWorkList.push(data);
                                    });
                                }
                                else {
                                    $scope.SelectedWorkList = locations;
                                }
                                setWorklisttooltip();
                                setSelectedWorklistFilterSettings();

                                break;
                            case 'WorklistIds_U':
                                var locations = [];
                                if (data.Value) {
                                    _.each(data.Value.split(','), function (data) {
                                        if (data) {
                                            var filter = _.find($scope.WorkLists, function (item) { return item.RuleID == data; });
                                            if (filter != null) {
                                                locations.push(filter);
                                            }
                                        }
                                    });
                                }
                                if ($scope.SelectedWorkList != null) {
                                    _.each(locations, function (data) {
                                        $scope.SelectedWorkList.push(data);
                                    });
                                }
                                else {
                                    $scope.SelectedWorkList = locations;
                                }
                                setWorklisttooltip();
                                setSelectedWorklistFilterSettings();
                                break;
                            case 'Accession':
                                $scope.Accession = data.Value;
                                break;
                            case 'OrderDate':
                                setOrderDate(data.Value);
                                break;
                            case 'ModalityID':
                                var modalities = [];
                                if (data.Value) {
                                    _.each(data.Value.split(','), function (data) {
                                        if (data) {
                                            var filter = _.find($scope.Modalities, function (item) { return item.Id == data; });
                                            if (filter != null) {
                                                modalities.push(filter);
                                            }
                                        }
                                    });
                                }
                                $scope.SelectedList.Modality = modalities;
                                $scope.ModalityDropdownDataFilter.SelectedValue = {
                                    list: modalities,
                                };
                                setModalitytooltip();
                                break;
                            case 'PatientName':
                                $scope.PatientName = data.Value;
                                break;
                            case 'PatientMRN':
                                $scope.PatientMRN = data.Value;
                                break;
                            case 'PatientDOB':
                                $scope.DOB = new Date(data.Value);
                                break;
                            case 'PatientClass':
                                $scope.SelectedList.PatientClass = _.find($scope.PatientClass, function (item) { return item.Value == data.Value; });
                                break;
                            case 'OrderingPhysician':
                                $scope.OrderingPhysician = data.Value;
                                break;
                            case 'Status':
                                $scope.Status.key = data.Value;
                                break;
                            case 'STATFilter':
                                $scope.STATFilter = (data.Value == "1") ? true : false;
                                break;
                        }
                    });

                    $scope.getData();
                }
                else {
                    $scope.getData();
                }
            }, function (error) {
                $scope.getData();
            });
        }
        function setOrderDate(val) {
            ////$log.log("setOrderDate: " + new Date());
            var type = null, startDate = null, endDate = null;
            if (val && val.match('Custom')) {
                type = 'Custom';
                startDate = val.split('#')[1];
                endDate = val.split('#')[2];
            }
            else {
                type = val;
            }
            $scope.OrderDateType = type;
            switch (type) {
                case 'Today':
                    $scope.OrderDate = {
                        startDate: moment(moment().format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;

                case 'Last 3 Days':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(2, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 7 Days':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 30 Days':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(29, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Custom':
                    //$scope.OrderDate = {
                    //    startDate: moment(startDate),
                    //    endDate: moment(endDate)
                    //};
                    $scope.OrderDate = {
                        startDate: moment(moment(startDate).format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment(endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    $scope.OrderDateType = 'Custom range';
                    break;
                case 'Last Year':
                    $scope.OrderDate = {
                        startDate: moment((moment().subtract(1, 'year').add(1, 'days')).format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 5 Years':
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(5, 'years').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'All DOS':
                    $scope.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                case 'Clear':
                    $scope.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                default:
                    $scope.OrderDate = {
                        startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    $scope.OrderDateType = 'Last 7 Days';
                    break;
            }
            var timeout = $timeout(function () {
                $scope.toolTipOrderDate = $scope.OrderDate.startDate && $scope.OrderDate.endDate ? 'DOS: ' + $scope.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                $timeout.cancel(timeout);
                timeout = null;
            }, 0);
        }
        function LoadOrderDiscussionForUser() {
            ////////$log.log("LoadOrderDiscussionForUser");
            $scope.orderDiscussionTooltip = '';
            var data = {
                OrderID: $scope.SelectedOrder.OrderID,
                FromUserID: $sessionStorage.currentUserData.userId
            };
            $scope.isLoading = true;
            $scope.isAssigner = true;
            $scope.OrderDiscussion = {};
            WorklistService.GetOrderDiscussionAssignment(data).then(function (response) {
                $scope.isLoading = false;
                if (response) {
                    $scope.OrderDiscussion = response;
                    $q.all([
                        $scope.GetAllUsers($scope.SelectedOrder.SiteID)
                    ]).then(function (data) {
                        if (!$scope.OrderDiscussion.SelectedUsers && !$scope.OrderDiscussion.SelectedRadioLogistsGroup) {
                            $scope.OrderDiscussion.SelectedUsers = [];
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                            var SelectedRadioLogistsGroup = [];
                            _.each($scope.OrderDiscussion.OrderAssignments, function (orderAssignment) {
                                if (orderAssignment.ProviderSpecialityId > 0) {
                                    var radiologistGroup = _.find($scope.RadiologistsGroups, { Id: orderAssignment.ProviderSpecialityId.toString() });
                                    if (radiologistGroup) {
                                        SelectedRadioLogistsGroup.push(radiologistGroup);
                                    }
                                } else {
                                    var radiologistGroup = _.find($scope.RadiologistsGroups, { Id: orderAssignment.ProviderID });
                                    if (radiologistGroup) {
                                        SelectedRadioLogistsGroup.push(radiologistGroup);
                                    }
                                }
                            });
                            var uniqueSelectedRadioLogistsGroup = _.uniqBy(SelectedRadioLogistsGroup, 'Id');
                            var orderedSelectedRadioLogistsGroup = _.concat(_.orderBy(_.filter(uniqueSelectedRadioLogistsGroup, function (srlg) { return srlg.Group && srlg.Group == 'YES'; }), ['UserName'], ['asc']), _.orderBy(_.filter(uniqueSelectedRadioLogistsGroup, function (srlg) { return !srlg.Group; }), ['UserName'], ['asc']));
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup = orderedSelectedRadioLogistsGroup;

                            $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();

                            var timeout = $timeout(function () {
                                $scope.isAssigner = false;
                                setOrderDiscussionUserGroup().then(function (data) {
                                    setOrderDiscussionTooltip();
                                    setSelectedUserAssignment(data);

                                    $timeout.cancel(timeout);
                                    timeout = null;
                                });
                            }, 100);
                        }
                    });
                    if ($scope.OrderDiscussion.ID
                        && $scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId
                        && $scope.OrderDiscussion.Status == 'A') {
                        $scope.OrderDiscussion.Status = 'C';
                        WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                        }, _respError);
                    }
                } else {
                    $scope.GetAllUsers($scope.SelectedOrder.SiteID)
                }
            }, _respError);
        }

        $scope.OpenDiscussion = function (referenceID) {
            ////////$log.log("OpenDiscussion");
            $scope.ODType = 'Discussion';
            $scope.LoadDiscussion(referenceID, 'Discussion');
        };

        $scope.LoadOnlyDiscussion = function (referenceID, ODType) {
            ////////$log.log("LoadOnlyDiscussion");
            $scope.showDiscuss = false;
            $scope.LoadDiscussion(referenceID, ODType);
        };

        $scope.LoadDiscussion = function (referenceID, ODType) {
            ////////$log.log("LoadDiscussion");
            $scope.hidePopover();
            $scope.showAttachment = false;
            $scope.ODType = ODType;
            $scope.Discussion = {
                ReferenceID: referenceID,
                Type: 1,
                Comment: '',
                Record_Created_By: $sessionStorage.currentUserData.userId
            };
            $scope.Discussions = [];
            LoadDiscussion($scope.Discussion);
            if ($scope.showDiscuss) {
                if (($scope.reportList && $scope.reportList.length > 0) || ($scope.Discussions && $scope.Discussions.length > 0)) {
                    $scope.currentWindow = 'win_ModalReportNDiscuss';
                    OpenWindow($scope.win_ModalReportNDiscuss, 'win_ModalReportNDiscuss');
                    $scope.win_ModalReportNDiscuss.wrapper.prev(".k-overlay").addClass("custom-overlay");
                }
            }
            else {
                $scope.currentWindow = 'win_Discussion';
                OpenWindow($scope.win_Discussion, 'win_Discussion');
                $scope.win_Discussion.wrapper.prev(".k-overlay").addClass("custom-overlay");
            }

        };

        $scope.openDiscussion = function () {
            ////////$log.log("openDiscussion");
            if ($scope.SelectedOrder && $scope.SelectedOrder.FileCount > 0) {
                selectPriorReportTab("#tabDiscussion");
                $scope.ReferenceID = null;
                setTimeout(function () {
                    $scope.showAttachment = true;
                    $scope.ReferenceID = $scope.Discussion.ReferenceID;
                }, 50);
            }
        }

        function selectPriorReportTab(tabName) {
            ////////$log.log("selectPriorReportTab");
            $("#tabReport").removeClass('active');
            $("#tabDiscussion").removeClass('active');
            $("#Discussion").removeClass('active');
            $("#Report").removeClass('active');
            $(tabName).addClass('active');
            $(tabName.replace('tab', '')).addClass('active');
            var tabStrip = $("#tabstrip").kendoTabStrip().data("kendoTabStrip");
            tabStrip.select(tabName);
        }

        //Window resizing
        $(window).resize(function () {
            ////////$log.log("resize");
            if (!validateDOS(false)) return;
            adjustSize();
            adjustWindow();
            setHalfScale();

            setHeight();

            if (previousHeight != currentHeight) {
                updatePageSize();

                $scope.getData();

                previousHeight = currentHeight;
            }
            updateWindowHeight();
        });



        function setHalfScale() {
            ////////$log.log("setHalfScale");
            $scope.halfScale = false;
            if ($(window).width() < 1199) {
                $scope.halfScale = true;
            }
        }
        function adjustSize() {
            ////////$log.log("adjustSize");
            // For small screens, maximize the window when it is shown.
            // You can also make the check again in $(window).resize if you want to
            // but you will have to change the way to reference the widget and then
            // to use $("#theWindow").data("kendoWindow").
            // Alternatively, you may want to .center() the window.
            //alert($(window).width());

            if ($scope.currentWindow == 'win_Discussion') {
                $scope.win_Discussion.center();
            } else if ($scope.currentWindow == 'win_ContactList') {
                $scope.win_ContactList.center();
            } else if ($scope.currentWindow == 'win_ComparisonOrderReports') {
                $scope.win_ComparisonOrderReports.center();
            } else if ($scope.currentWindow == 'win_ModalReportNDiscuss') {
                $scope.win_ModalReportNDiscuss.center();
            } else if ($scope.currentWindow == 'win_SingReport') {
                $scope.win_SingReport.center();
            } else if ($scope.currentWindow == 'win_PSUser') {
                $scope.win_PSUser.center();
            } else if ($scope.currentWindow == 'win_HideStudy') {
                $scope.win_HideStudy.center();
            }

            return true;
        }

        function adjustWindow() {
            ////////$log.log("adjustWindow");
            if ($scope.currentWindow == 'win_ComparisonOrderReports') {
                if ($(window).width() < 1199) {
                    $scope.winComparisonOrderReportsWidth = "96%";
                } else {
                    $scope.winComparisonOrderReportsWidth = "70%";
                }
                SetWindowOptions($scope.win_ComparisonOrderReports, 'win_ComparisonOrderReports', { width: $scope.winComparisonOrderReportsWidth });
                $scope.win_ComparisonOrderReports.center();
            } else if ($scope.currentWindow == 'win_ModalReportNDiscuss') {
                if ($(window).width() < 1199) {
                    $scope.win_ModalReportNDiscussWidth = "96%";
                } else {
                    $scope.win_ModalReportNDiscussWidth = "70%";
                }
                SetWindowOptions($scope.win_ModalReportNDiscuss, 'win_ModalReportNDiscuss', { width: $scope.win_ModalReportNDiscussWidth });
                $scope.win_ModalReportNDiscuss.center();
            } else if ($scope.currentWindow == 'AddEditContactWindow') {
                if ($scope.halfScale) {
                    $scope.addEditContactWindowHeight = "55%";
                } else {
                    $scope.addEditContactWindowHeight = "50%";
                }
                //SetWindowOptions($scope.win_AddEditContact, 'win_AddEditContact', { height: $scope.addEditContactWindowHeight });
                $scope.win_AddEditContact.center();
            } else if ($scope.currentWindow === 'win_ContactList') {
                updateContactWindow();
            } else if ($scope.currentWindow === 'win_shareExamsWindow') {
                if ($(window).width() < 1199) {
                    $scope.winShareExamWindowWidth = "80%";
                } else {
                    $scope.winShareExamWindowWidth = "60%";
                }
                SetWindowOptions($scope.win_shareExamsWindow, 'win_shareExamsWindow', { width: $scope.winShareExamWindowWidth });
                $scope.win_shareExamsWindow.center();
            }
            else if ($scope.currentWindow === 'win_consultExamsWindow') {
                if ($(window).width() < 1199) {
                    $scope.winConsultExamWindowWidth = "80%";
                } else {
                    $scope.winConsultExamWindowWidth = "60%";
                }
                SetWindowOptions($scope.win_consultExamsWindow, 'win_consultExamsWindow', { width: $scope.winConsultExamWindowWidth });
                $scope.win_consultExamsWindow.center();
            }
        }

        $scope.winOpen = function (e) {
            ////////$log.log("winOpen");
            adjustSize();
        }

        //Repot pop up resize
        $scope.winDragend = function (e) {
            ////////$log.log("winDragend");
            adjustSize();
        }
        $scope.winResize = function (e) {
            ////////$log.log("winResize");
            adjustSize();
        }

        //Report-Discussion pop up resize
        $scope.winModalReportNDiscussResize = function () {
            ////////$log.log("winModalReportNDiscussResize");
            adjustSize();
        }

        $scope.wwinModalReportNDiscussDragend = function () {
            ////////$log.log("wwinModalReportNDiscussDragend");
            adjustSize();
        }

        // Search Contact popup resize
        $scope.searchContactWidthResize = function () {
            ////////$log.log("searchContactWidthResize");
            adjustSize();
        }

        $scope.searchContactWidthDragend = function () {
            ////////$log.log("searchContactWidthDragend");
            adjustSize();
        }

        $scope.winModalReportNDiscussionOnOpen = function () {
            ////////$log.log("winModalReportNDiscussionOnOpen");
            var tabStrip = $("#tabstrip").kendoTabStrip().data("kendoTabStrip");
            if ($scope.reportList && $scope.reportList.length > 0) {
                tabStrip.select(0);
            } else {
                if ($scope.Discussions && $scope.Discussions.length > 0) {
                    tabStrip.select(1);
                } else {
                    $scope.win_ModalReportNDiscuss.close();
                }
            }
        }

        function refreshDOS() {
            ////$log.log("refreshDOS: ", new Date());
            if (refreshDOSMidnight) {
                $interval.cancel(refreshDOSMidnight);
                refreshDOSMidnight = $interval(refreshDOS, refreshDOSInterval);
            }
            updateRefreshDOSInterval();

            $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            if ($scope.OrderDate.startDate && $scope.OrderDate.endDate) {
                if ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom'))
                    $scope.OrderDateType = ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                        moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType;

            }
            setOrderDate($scope.OrderDateType);
        }

        function LoadDiscussion(discussion) {
            ////////$log.log("LoadDiscussion");
            WorklistService.GetDiscussions(discussion).then(function (response) {
                $scope.AllDiscussions = _.cloneDeep(response);
                $scope.Discussions = _.filter(response, function (item) { return item.Type == 1; });

                if ($scope.showDiscuss && ($scope.isReportAvailable || ($scope.Discussions && $scope.Discussions.length > 0) || $scope.OrderReport.FileCount > 0)) {
                    angular.element('#ModalReportNDiscuss').modal('show');
                    if ($scope.showDiscuss) {
                        $scope.currentWindow = "win_ModalReportNDiscuss";
                        OpenWindow($scope.win_ModalReportNDiscuss, 'win_ModalReportNDiscuss');
                        $scope.win_ModalReportNDiscuss.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    } else {
                        $scope.currentWindow = 'win_Discussion';
                        OpenWindow($scope.win_Discussion, 'win_Discussion');
                        $scope.win_Discussion.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    }

                    $log.log("LoadDiscussion > $scope.Discussions.length: ", $scope.Discussions.length);
                    if ($scope.Discussions.length > 0) {
                        selectPriorReportTab("#tabDiscussion");
                        if ($scope.OrderReport && $scope.OrderReport.FileCount > 0) {
                            $scope.ReferenceID = null;
                            setTimeout(function () {
                                $scope.showAttachment = true;
                                $scope.ReferenceID = $scope.Discussion.ReferenceID;
                            }, 100);
                        }
                    }
                    else if ($scope.isReportAvailable) {
                        selectPriorReportTab("#tabReport");
                    }


                }
                angular.forEach($scope.Discussions, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            }, _respError);
        }
        function LoadChildDiscussion(ObjDiscussion) {
            ////////$log.log("LoadChildDiscussion");
            var response = _.filter($scope.AllDiscussions, function (item) { return item.ReferenceID == ObjDiscussion.ID; });
            if (response && (response.length > 0)) {
                if (!ObjDiscussion.Childs || ObjDiscussion.Childs.length != response.length) {
                    ObjDiscussion.Childs = response;
                }
                angular.forEach(ObjDiscussion.Childs, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            }
        }
        function bindChildDiscussion(ObjDiscussion) {
            ////////$log.log("LoadChildDiscussion");
            angular.forEach($scope.Discussions, function (obj, idx) {
                LoadChildDiscussion(obj);
            });
        }
        $scope.SaveOrderDiscussion = function () {
            ////////$log.log("SaveOrderDiscussion");
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];
                $scope.SelectedOrder.listOrderListAssignment = [];

                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_MSG_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });


                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'O'
                };
                //$scope.isLoading = true;


                WorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                    $scope.SaveDiscussion();
                    LoadOrderDiscussionForUser();
                }, _respError);
            }
        };
        $scope.AssignStudy = function (EventType) {
            ////////$log.log("AssignStudy");
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];
                $scope.SelectedOrder.listOrderListAssignment = [];

                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_STUDY_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var userOfGroup = _.filter($scope.OrderDiscussion.SelectedUsers, function (item) { return item.SpecialityId == obj.SpecialityId; });

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode,
                        TotalUsersOfGroup: userOfGroup.length
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });


                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'I',
                    Order: $scope.SelectedOrder,
                    EventType: EventType ? EventType : 'WC',
                };
                //$scope.isLoading = true;


                WorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                    LoadOrderDiscussionForUser();
                    $scope.SaveDiscussionFlag = false;
                }, _respError);
            }
        };
        $scope.CloseOrderDiscussion = function () {
            ////////$log.log("CloseOrderDiscussion");
            if ($scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId) {
                $scope.OrderDiscussion.Status = 'C';
                _.each($scope.OrderDiscussion.OrderDiscussionUserGroup, function (obj) {
                    NotifyToUser(__env._CLOSE_MSG_, $scope.SelectedOrder.OrderID, obj.ToUserID, null);
                });

            } else {
                NotifyToUser(__env._ANS_MSG_, $scope.SelectedOrder.OrderID, $scope.OrderDiscussion.FromUserID, null);
            }
            WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                /*
                 * Modified By: Tejas Parikh
                 * Task:        Bug 21731: Close discussion button is not working
                 */
                if ($scope.showDiscuss) {
                    $scope.win_ModalReportNDiscuss.close();
                }
                else {
                    $scope.win_Discussion.close();
                }
            }, _respError);
        };
        $scope.SaveDiscussion = function (EventType) {
            ////////$log.log("SaveDiscussion");
            $scope.isLoading = true;
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedUsers) {
                $scope.SaveDiscussionFlag = true;
                $scope.AssignStudy(EventType);
            }
            if ($scope.Discussion.Comment) {
                $scope.SaveDiscussionFlag = true;
                $scope.Discussion.EventType = EventType ? EventType : 'WC';
                WorklistService.SetDiscussion($scope.Discussion).then(function (response) {
                    $scope.SelectedOrder.IsDiscussion = true;
                    $scope.showDiscuss = false;
                    LoadDiscussion(response);
                    $scope.Discussion.Comment = null;
                    $scope.SaveDiscussionFlag = false;
                    var idx = _.findIndex(OrderList, { OrderID: $scope.SelectedOrder.OrderID });
                    if (idx != -1) {
                        OrderList[idx].IsDiscussion = true;
                    }
                    $scope.orderList = OrderList;
                }, _respError);
            }
            $scope.isLoading = false;
        };
        $scope.SaveChildDiscussion = function (discussion) {
            ////////$log.log("SaveChildDiscussion");
            if (discussion.ChildComment) {
                var Objdiscussion = {
                    ReferenceID: discussion.ID,
                    Type: 0,
                    Comment: discussion.ChildComment,
                    Record_Created_By: $sessionStorage.currentUserData.userId
                };
                if (discussion.Record_Created_By != $sessionStorage.currentUserData.userId) {
                    NotifyToUser(__env._NOTIFY_MSG_, $scope.SelectedOrder.OrderID, discussion.Record_Created_By, "N");
                }
                $scope.isLoading = true;
                WorklistService.SetDiscussion(Objdiscussion).then(function (response) {
                    $scope.isLoading = false;
                    discussion.IsChild = false;
                    discussion.ChildComment = '';
                    $scope.AllDiscussions.push(response);
                    bindChildDiscussion(response);
                }, _respError);
            }
        };
        $scope.closeReportNDiscuss = function () {
            ////////$log.log("closeReportNDiscuss");
            $scope.showDiscuss = false;
        }
        function LoadOrderDiscussion(orderIds) {
            ////////$log.log("LoadOrderDiscussion");
            if ($scope.isDiscussionVisible) {
                LoadDiscussion($scope.Discussion);
            }
            var Discussion = {
                ReferenceIDs: orderIds,
                Type: 1
            };
            WorklistService.GetDiscussionsByIds(Discussion).then(function (response) {
                var DiscussionList = response;
                angular.forEach(DiscussionList, function (Dis, idx) {
                    var objOrderList = _.filter($scope.orderList, function (obj) { return Dis.ReferenceID == obj.DicomOrderID; });
                    if (objOrderList && objOrderList.length > 0) {
                        objOrderList[0].IsDiscussion = true;
                    }
                });
            }, _respError);
        }
        function _respError(error) {
            ////////$log.log("_respError");
            $scope.isLoading = false;
        }
        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function isVisibleRad(r) {
            if (!r) return false;
            if (_isSelf(r.Id || r.UserID)) return true;
            return !_hasPrelimRad(r.UserRoles || r.Roles);
        }
        $scope.isVisibleRad = isVisibleRad;
        $scope.radDisplay = function (r) {
            if (!r) return '';
            if (!_isSelf(r.Id || r.UserID) && _hasPrelimRad(r.UserRoles || r.Roles)) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
        $scope.disName = function (dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        };
        function _findRadByUserId(userId) {
            if (!userId) return null;
            var id = userId.toLowerCase();
            var rad = _.find(siteRadiologistsUnfiltered || [], function (r) {
                return (r.Id || r.UserID || '').toLowerCase() === id;
            });
            if (rad) return rad;
            rad = _.find(RuleSharedService.GetCachedRadiologists(), function (r) {
                return (r.Id || r.UserID || '').toLowerCase() === id;
            });
            if (!rad) {
                RuleSharedService.RequestTenantRadiologistsIfNeeded();
            }
            return rad || null;
        }
        function _isPrelimRadAssignment(userId) {
            if (!userId || _isSelf(userId)) return false;
            var rad = _findRadByUserId(userId);
            return rad ? _hasPrelimRad(rad.UserRoles || rad.Roles) : false;
        }
        function _assignmentName(userId, name) {
            return _isPrelimRadAssignment(userId) ? '' : name;
        }
        function _discussionDisplayName(dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        }
        $scope.signByDisplay = function (r) {
            if (!r) return '';
            var signBy = r.SignBy || (r.OrderReport && r.OrderReport.SignBy);
            var signByName = r.SignByName || (r.OrderReport && r.OrderReport.SignByName) || '';
            return signBy ? _assignmentName(signBy, signByName) : signByName;
        };
        $scope.GetAllUsers = function (SiteID) {
            ////////$log.log("GetAllUsers");
            var d = $q.defer();
            var filter = {
                SiteID: SiteID
            };
            WorklistService.GetRadiologistsBySite(filter).then(function (result) {
                siteRadiologistsUnfiltered = result.radiologistsLists || [];
                $scope.Radiologists = _.filter(siteRadiologistsUnfiltered, function (r) {
                    return _isSelf(r.Id || r.UserID) || !_hasPrelimRad(r.UserRoles || r.Roles);
                });
                specialityAssignments = result.specialityAssignments;

                $scope.RadiologistsGroups = [];
                var mRadiologistsGroups = [];

                var uniqueSpeciality = _.uniqBy(specialityAssignments, 'SpecialityId');
                _.each(uniqueSpeciality, function (obj) {

                    var RadiologistsGroup = {};
                    RadiologistsGroup['Id'] = obj.SpecialityId;
                    RadiologistsGroup['UserName'] = obj.SpecialityCode;
                    RadiologistsGroup['Group'] = "YES";
                    mRadiologistsGroups.push(RadiologistsGroup);


                });

                _.each(specialityAssignments, function (speciality) {
                    var user = _.find($scope.Radiologists, { 'Id': speciality.UserId });
                    if (user) {
                        if (!user.Specialities) {
                            user.Specialities = [];
                        }
                        var spclty = _.find(user.Specialities, { SpecialityId: speciality.SpecialityId });
                        if (!spclty) {
                            user.Specialities.push(speciality);
                        }
                    }
                });

                mRadiologistsGroups.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                $scope.Radiologists.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                mRadiologistsGroups = mRadiologistsGroups.concat($scope.Radiologists);

                $scope.RadiologistsGroups = mRadiologistsGroups;

                d.resolve();
            });
            return d.promise;


        };

        function OpenDiscussionOrder() {
            ////////$log.log("OpenDiscussionOrder");
            $scope.OrderDiscussion = null;
            if ($state.params["OD"]) {
                $scope.OrderDiscussion = $state.params["OD"];
                _OpenDiscussionOrder();

                $timeout(function () {
                    $state.params = [];
                }, 1000)

            }
        }
        function _OpenDiscussionOrder() {
            ////////$log.log("_OpenDiscussionOrder");
            $scope.ODType = "Helper";
            $scope.SelectedOrder = $scope.OrderDiscussion.Order ? $scope.OrderDiscussion.Order : $scope.OrderDiscussion;
            $scope.SelectedOrderID = $scope.SelectedOrder.OrderID;
            if ($scope.SelectedOrder && !$scope.SelectedOrder.DicomOrderID) {
                $scope.SelectedOrder.DicomOrderID = $scope.SelectedOrderID;
            }
            $('#ModalDiscussion').modal('show');
            $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID, 'Helper');
            if ($scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId) {
                if ($scope.OrderDiscussion.Status == 'A') {
                    $scope.OrderDiscussion.Status = 'C';
                    WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                        LoadOrderDiscussionForUser();
                    }, _respError);
                } else {
                    LoadOrderDiscussionForUser();
                }
            } else {
                if ($scope.OrderDiscussion.Status == 'N' || $scope.OrderDiscussion.Status == 'I') {
                    $scope.ODType = "Discussion";
                    $scope.OrderDiscussion.Status = 'D';
                    WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                        LoadOrderDiscussionForUser();
                    }, _respError);
                    return;
                }
                $q.all([
                    $scope.GetAllUsers($scope.SelectedOrder.SiteID)
                ]).then(function (data) {
                    if ($scope.OrderDiscussion) {
                        $scope.OrderDiscussion.SelectedUsers = [];
                        $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                        _.each($scope.OrderDiscussion.OrderAssignments, function (orderAssignment) {
                            if (orderAssignment.IsUserWithSpecialityGroup == 0) {
                                var radiologistGroup = _.find($scope.DataObject.masterData.RadiologistsGroups, { Id: orderAssignment.ProviderSpecialityId.toString() });
                                if (radiologistGroup) {
                                    $scope.OrderDiscussion.SelectedRadioLogistsGroup.push(radiologistGroup);
                                }
                            } else if (orderAssignment.IsUserWithSpecialityGroup == 2) {
                                var radiologistGroup = _.find($scope.DataObject.masterData.RadiologistsGroups, { Id: orderAssignment.ProviderID });
                                if (radiologistGroup) {
                                    $scope.OrderDiscussion.SelectedRadioLogistsGroup.push(radiologistGroup);
                                }
                            }
                        });
                        $scope.OrderDiscussion.SelectedRadioLogistsGroup = _.uniqBy($scope.OrderDiscussion.SelectedRadioLogistsGroup, 'Id');

                        $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();


                        setTimeout(function () {
                            $scope.isAssigner = false;
                            setOrderDiscussionUserGroup().then(function (data) {
                                setOrderDiscussionTooltip();
                            });
                        }, 100);
                    }

                });
                $scope.OrderDiscussion.Status = 'A';
            }
        }

        $scope.$on("OpenDiscussionOrder", function (evt, OD) {
            ////////$log.log("OpenDiscussionOrder");
            $scope.OrderDiscussion = OD;
            if ($scope.OrderDiscussion.RequestType == "Addendum Request") {
                $scope.OpenSignReport($scope.OrderDiscussion.Order, $scope.orderList);
            } else {
                _OpenDiscussionOrder();
            }
        });

        $scope.$on("ReLoadDiscussion", function (evt, OD) {
            ////$log.log("ReLoadDiscussion");
            if (OD.Status == 'I') {
                var objOrder = _.filter($scope.orderList, function (obj) { return obj.OrderID == OD.OrderID; });
                if (objOrder && objOrder.length > 0) {
                    if (!objOrder[0].IsLock && $scope.SelectedList.Worklist.Key === 'PSW') {
                        var ToUserID;
                        var ToUserName;
                        var assignedCurrentUser;
                        if (objOrder[0].listOrderListAssignment) {
                            if (objOrder[0].listOrderListAssignment.length > 0) {
                                ToUserName = $scope.getOrderListTooltip(objOrder[0]);
                                ToUserID = objOrder[0].listOrderListAssignment[0].OrderAssingedUserID;
                            }
                        }

                        if (OD.OrderDiscussionUserGroup) {

                            var userGroup = _.find(OD.OrderDiscussionUserGroup, function (obj) {
                                return obj.ToUserID == $scope.UserId;
                            });
                            if (userGroup) {
                                assignedCurrentUser = userGroup.ToUserID;
                            }
                        }
                        objOrder[0].OrderAssingedUserID = ToUserID;
                        objOrder[0].OrderAssingedUserName = ToUserName;
                        objOrder[0].OrderAssingedUsers = OD.OrderDiscussionUserGroup.length;
                        objOrder[0].OrderAssingedUser = assignedCurrentUser;
                        objOrder[0].listOrderListAssignment = OD.Order.listOrderListAssignment;
                    }
                    if (!objOrder[0].IsLock && $scope.SelectedList.Worklist.Key === 'PRW') {
                        removeOrderFromList(OD.OrderID);
                    }
                }
            } else {
                if ($scope.SelectedOrder && ($scope.SelectedOrder.OrderID == OD.Order.OrderID)) {
                    LoadDiscussion($scope.Discussion);
                    if (OD.Status == 'N') {
                        OD.Status = 'D';
                        WorklistService.SetOrderDiscussionAssignment(OD).then(function (response) {
                        }, _respError);
                    }
                }
            }
        });

        $scope.$on("UnAssignStudy", function (evt, OD) {
            ////$log.log("UnAssignStudy");
            if (OD.Status == 'D' && OD.FromUserID == $scope.LoggedInUserID) {
                var objOrder = _.filter($scope.orderList, function (obj) { return obj.OrderID == OD.OrderID; });
                if (objOrder && objOrder.length > 0) {
                    if (!objOrder[0].IsLock && $scope.SelectedList.Worklist.Key === 'PSW') {

                        var assignedUserID;
                        var findObj = _.find(OD.OrderDiscussionUserGroup, function (obj) {
                            return obj.ToUserID == $scope.LoggedInUserID;
                        });
                        if (findObj) {
                            assignedUserID = OD.OrderDiscussionUserGroup.ToUserID;
                        }
                        var OrderAssingedUsers;
                        var findIndex = _.findIndex(OD.OrderDiscussionUserGroup, function (obj) {
                            return obj.ToUserID == $scope.LoggedInUserID;
                        });
                        if (findIndex != -1) {
                            OD.OrderDiscussionUserGroup.splice(findIndex, 1);
                            OrderAssingedUsers = OD.OrderDiscussionUserGroup.length;
                        } else {
                            OrderAssingedUsers = OD.OrderDiscussionUserGroup.length - 1;
                        }
                        var OrderAssingedUserID;
                        if (OrderAssingedUsers > 0) {
                            OrderAssingedUserID = OD.OrderDiscussionUserGroup[0].ToUserID;
                        }
                        var OrderAssingedUserName;
                        if (OrderAssingedUserID) {
                            var findObj = _.find(objOrder[0].listOrderListAssignment, function (obj) { return obj.OrderAssingedUserID = OrderAssingedUserID });
                            if (findObj) {
                                OrderAssingedUserName = $scope.getOrderListTooltip(objOrder[0]);
                            }
                        }
                        objOrder[0].OrderAssingedUserID = OrderAssingedUserID;
                        objOrder[0].OrderAssingedUserName = OrderAssingedUserName;
                        objOrder[0].OrderAssingedUsers = OrderAssingedUsers;
                        objOrder[0].OrderAssingedUser = assignedUserID ? null : assignedUserID;
                        objOrder[0].listOrderListAssignment = OD.Order.listOrderListAssignment;
                    }
                    if (!objOrder[0].IsLock && $scope.SelectedList.Worklist.Key === 'PRW') {
                        removeOrderFromList(OD.OrderID);
                    }
                }
            }
        });
        $scope.$on('event.Rule.Save', function (evt, data) {
            if (data && data.Rule && data.Rule.WorkListName) {
                var worklistIndex = _.findIndex($scope.WorkLists, { 'RuleID': data.Rule.RuleID });
                if (worklistIndex == -1) {
                    $scope.WorkLists.push(data.Rule);
                    $scope.WorkLists = _.orderBy(rWorklist, ['WorkListName'], ['asc']);
                } else {
                    $scope.WorkLists[worklistIndex] = data.Rule;
                }
                var CheckedWorklist = [];
                if ($scope.SelectedWorkList.length > 0) {
                    CheckedWorklist = $scope.SelectedWorkList;
                }
                updateWorklistDropDown();
                $scope.SelectedWorkList = CheckedWorklist;
                setSelectedWorklistFilterSettings();
                setWorklisttooltip();
            }

            if (data.HideWindow) {
                $scope.ModalWorklistOpened = false;
                angular.element('#ModalEditWorkList').modal('hide');
            }
        });
        $scope.$on('event.Rule.Close', function (evt, data) {

            if (data.HideWindow) {
                $scope.ModalWorklistOpened = false;
                angular.element('#ModalEditWorkList').modal('hide');
            }
        });

        $scope.$on("deleteFile", function (evt, count) {
            if (count == 0) {
                $scope.showAttachment = false;
                setOrderDiscussionUserGroup().then(function (data) {
                    setOrderDiscussionTooltip();
                    setSelectedUserAssignment(data);
                });
            }
            $scope.getData();
            $scope.SelectedOrder.FileCount = count;
        });

        function updateWorklistDropDown() {
            var dropdowntree = $("#worklistDropdownTree").data("kendoDropDownTree");
            if (dropdowntree) {
                var dataSource = new kendo.data.HierarchicalDataSource({
                    data: $scope.WorkLists
                });
                dropdowntree.setDataSource(dataSource);
            }
        }
        $scope.changeWorklist = function () {
            ////$log.log("changeWorklist");
            if (!validateDOS(true)) return;
            filterChanged = true;
            if ($scope.SelectedList.Worklist.Key === 'PSW') {
                getPSWFilterSetting();
            }
            else if ($scope.SelectedList.Worklist.Key === 'PRW') {
                $scope.workListSaved = true;
                getPRWFilterSetting();
            }
            else {
                $scope.workListSaved = false;
                $scope.clearFilter();
                $scope.getData();
            }
        };

        /**
         * Added By: Tejas Parikh
         * Bug 21051: Image pending alert is not populating if the user hides any study by selecting Need additional images option from worklist
         * @param {any} value
         */
        $scope.changeHideStudyOption = function (value) {
            ////////$log.log("changeHideStudyOption");
            $scope.HideOption = value;
            $scope.hideStudyWindowHeight = "35%";
            if (value == "NeedMoreImages") {
                $scope.hideStudyWindowHeight = "45%";
            }
            SetWindowOptions($scope.win_HideStudy, 'win_HideStudy', { height: $scope.hideStudyWindowHeight });
        };

        function NotifyToUser(msg, orderID, toUserID, status) {
            ////////$log.log("NotifyToUser");
            var data = {
                OrderID: orderID,
                FromUserID: $sessionStorage.currentUserData.userId,
                FromUser: $sessionStorage.currentUserData.displayName,
                ToUserID: toUserID,
                Status: status,
                Message: msg
            }
            WorklistService.NotifyToUser(data).then(function (response) {
            }, _respError);
        }
        function getPRWFilterSetting() {
            ////$log.log("getPRWFilterSetting: " + new Date());
            $scope.clearFilter();
            if ($localStorage.PRWFilters != null && $localStorage.PRWFilters.length > 0) {
                var curUserPRWFilters = _.filter($localStorage.PRWFilters, function (obj) { return obj.UserID == $sessionStorage.currentUserData.userId });
                if (curUserPRWFilters != null && curUserPRWFilters.length > 0) {
                    var locations = [];

                    if (curUserPRWFilters[0].LocationID != null) {
                        _.each(curUserPRWFilters[0].LocationID.split(','), function (data) {
                            if (data) {
                                var filter = _.find($scope.Locations, function (item) { return item.LocationID == data && item.SiteID != 0; });
                                if (filter != null) {
                                    locations.push(filter);
                                }
                            }
                        });
                    }
                    $scope.SelectedList.Location = locations;
                    $scope.locationIDs = curUserPRWFilters[0].LocationID;
                    $scope.SelectedLocations = {
                        Ids: curUserPRWFilters[0].LocationID,
                        locations: locations,
                        divId: "OldWorklistFilter"
                    };
                    var workList_Admin = [];
                    if (curUserPRWFilters && curUserPRWFilters.length > 0 && curUserPRWFilters[0].WorklistIds_A != null) {
                        _.each(curUserPRWFilters[0].WorklistIds_A.split(','), function (data) {
                            if (data) {
                                var filter = _.find($scope.WorkLists, function (item) { return item.RuleID; });
                                if (filter != null) {
                                    workList_Admin.push(filter);
                                }
                            }
                        });
                    }
                    if ($scope.SelectedWorkList != null) {
                        _.each(workList_Admin, function (data) {
                            $scope.SelectedWorkList.push(data);
                        });
                    }
                    else {
                        $scope.SelectedWorkList = workList_Admin;
                    }

                    var workList_User = [];
                    if (curUserPRWFilters[0].WorklistIds_U != null) {
                        _.each(curUserPRWFilters[0].WorklistIds_U.split(','), function (data) {
                            if (data) {
                                var filter = _.find($scope.WorkLists, function (item) { return item.RuleID == data; });
                                if (filter != null) {
                                    workList_User.push(filter);
                                }
                            }
                        });
                    }
                    if ($scope.SelectedWorkList != null) {
                        _.each(workList_User, function (data) {
                            $scope.SelectedWorkList.push(data);
                        });
                    }
                    else {
                        $scope.SelectedWorkList = workList_User;
                    }

                    setWorklisttooltip();
                    setSelectedWorklistFilterSettings();
                    $scope.Accession = curUserPRWFilters[0].Accession;
                    var modalities = [];
                    if (curUserPRWFilters[0].ModalityID) {
                        _.each(curUserPRWFilters[0].ModalityID.split(','), function (data) {
                            if (data) {
                                var filter = _.find($scope.Modalities, function (item) { return item.Id == data; });
                                if (filter != null) {
                                    modalities.push(filter);
                                }
                            }
                        });
                    }
                    $scope.SelectedList.Modality = modalities;
                    $scope.ModalityDropdownDataFilter.SelectedValue = {
                        list: modalities,
                    };
                    setModalitytooltip();
                    if (curUserPRWFilters[0].OrderDate != null && curUserPRWFilters[0].OrderDate.length > 0) {
                        setOrderDate(curUserPRWFilters[0].OrderDate);
                    }
                    $scope.PatientName = curUserPRWFilters[0].PatientName;
                    $scope.PatientMRN = curUserPRWFilters[0].PatientMRN;
                    if (curUserPRWFilters[0].PatientDOB != null && curUserPRWFilters[0].PatientDOB.length > 0) {
                        $scope.PatientDOB = new Date(curUserPRWFilters[0].PatientDOB);
                    }
                    $scope.SelectedList.PatientClass = _.find($scope.PatientClass, function (item) { return item.Value == curUserPRWFilters[0].PatientClass; });
                    $scope.OrderingPhysician = curUserPRWFilters[0].OrderingPhysician;
                    $scope.Status.key = curUserPRWFilters[0].Status;
                    $scope.OrderByField = curUserPRWFilters[0].OrderByField;
                    $scope.ReverseSort = curUserPRWFilters[0].ReverseSort;
                    $scope.STATFilter = curUserPRWFilters[0].STATFilter == "1" ? true : false;
                }
            }
            $scope.getData();
        }
        function setPRWFilterSetting() {
            ////$log.log("setPRWFilterSetting; " + new Date());
            if ($localStorage.PRWFilters != null && $localStorage.PRWFilters.length > 0) {
                var idx = _.findIndex($localStorage.PRWFilters, function (obj) { return obj.UserID == $sessionStorage.currentUserData.userId; });
                if (idx != -1) {
                    $localStorage.PRWFilters.splice(idx, 1);
                }
                $localStorage.PRWFilters.push(setlocalStoragePRWFilters());
            }
            else {
                $localStorage.PRWFilters = [];
                $localStorage.PRWFilters.push(setlocalStoragePRWFilters());
            }
        }
        function setlocalStoragePRWFilters() {
            ////////$log.log("setlocalStoragePRWFilters");
            var orderDate = null;
            if ($scope.OrderDate.startDate == null)
                $scope.OrderDateType = null;
            else {
                $scope.OrderDateType = ($scope.OrderDate && $scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
                orderDate = ($scope.OrderDate ? ($scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' + moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType : null);
            }

            return {
                SiteID: $scope.SelectedList.Site ? $scope.SelectedList.Site.SiteID : null,
                LocationID: $scope.locationIDs,
                WorklistIds_A: $scope.worklistIds_Admin,
                WorklistIds_U: $scope.worklistIds_User,
                Accession: $scope.Accession,
                ModalityID: $scope.modalityIDs,
                OrderDate: orderDate,
                PatientName: $scope.PatientName,
                PatientMRN: $scope.PatientMRN,
                PatientDOB: $scope.formatted_date($scope.DOB),
                PatientClass: $scope.SelectedList.PatientClass ? $scope.SelectedList.PatientClass.Value : null,
                OrderingPhysician: $scope.OrderingPhysician,
                Status: $scope.Status.key,
                UserID: $sessionStorage.currentUserData.userId,
                OrderByField: $scope.OrderByField,
                ReverseSort: $scope.ReverseSort,
                STATFilter: $scope.STATFilter ? "1" : "0",
            };
        }
        $scope.onOpenClose = function (isOpen, $select) {
            ////////$log.log("onOpenClose");
            $select.search = "";
        };

        $scope.showFileList = function () {
            ////////$log.log("showFileList");
            $scope.showAttachment = true;
            $scope.ReferenceID = $scope.Discussion.ReferenceID;
        }
        $scope.hideFileList = function () {
            ////////$log.log("hideFileList");
            $scope.showAttachment = false;
            setOrderDiscussionUserGroup().then(function (data) {
                setOrderDiscussionTooltip();
                setSelectedUserAssignment(data);
            });
        }
        function setWorklisttooltip() {
            //$log.log("setWorklisttooltip: " + new Date());
            //$log.log("setWorklisttooltip > $scope.SelectedWorkList: " + $scope.SelectedWorkList);
            var SelectedWorkList = _.clone($scope.SelectedWorkList); //[...new Set()];
            $scope.worklistIds_Admin = '';
            $scope.worklistIds_User = '';
            if (SelectedWorkList && SelectedWorkList.length > 0) {
                $scope.worklisttooltip = '';
                SelectedWorkList = $filter('orderBy')(SelectedWorkList, 'WorkListName');
                //$log.log("setWorklisttooltip > SelectedWorkList: " + SelectedWorkList);
                _.each(SelectedWorkList, function (data) {
                    if ($scope.worklisttooltip.length > 0) {
                        $scope.worklisttooltip = $scope.worklisttooltip + "\n" + data.WorkListName;
                    }
                    else if ($scope.worklisttooltip.length == 0) {
                        $scope.worklisttooltip = data.WorkListName;
                    }
                    if ($scope.worklistIds_Admin) {
                        $scope.worklistIds_Admin = $scope.worklistIds_Admin + "," + data.RuleID;
                    }
                    else {
                        $scope.worklistIds_Admin = data.RuleID;
                    }

                });
            }
            else {
                $scope.worklisttooltip = 'Select a Worklist';
            }
        }

        $scope.onSelected = function () {
            //////////$log.log("onSelected");
        }
        function setModalitytooltip() {
            ////$log.log("setModalitytooltip: " + new Date());
            $scope.modalityIDs = '';
            if ($scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) {
                $timeout(function () { $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;'); }, 1);
                $('.anui').addClass("set-modality-height");
                $scope.modalitytooltip = '';
                var objModality = $filter('orderBy')($scope.SelectedList.Modality, 'Code');
                _.each(objModality, function (data) {
                    if ($scope.modalitytooltip.length > 0) {
                        $scope.modalitytooltip = $scope.modalitytooltip + " \n" + data.Code;    //Bug 21548: Unable to see the selected Modalities on tooltip of worklist & tech worklist page
                    }
                    else if ($scope.modalitytooltip.length == 0) {
                        $scope.modalitytooltip = data.Code;
                    }
                    if ($scope.modalityIDs.length > 0) { $scope.modalityIDs = $scope.modalityIDs + "," + data.Id; }
                    else { $scope.modalityIDs = data.Id; }
                });
            }
            else {
                $('.anui').removeClass("set-modality-height");
                $timeout(function () { $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;'); }, 1);
                $scope.modalitytooltip = 'Select Modalities';
            }
        }
        $scope.onSelectedModality = function (selectedData) {
            $scope.SelectedList.Modality = selectedData;
            ////////$log.log("onSelectedModality");
            filterChanged = true;
            setModalitytooltip();
        }
        //$scope.clearSelModaValue = function () {
        //    $scope.SelectedList.Modality = [];
        //    $scope.SelectedList.Modality = null;
        //    $scope.modalitytooltip = 'Select Modalities';
        //    $('.anui').removeClass("set-modality-height");
        //}
        $scope.setStatus = function () {
            ////////$log.log("setStatus");
            //$scope.SelectedList.StudyPriority = null;
            var status = $scope.WorklistPageHeaderParameter.Status;
            if (status == 'Stat') {
                $scope.STATFilter = !$scope.STATFilter;
                $scope.SelectedList.StudyPriority = _.find($scope.StudyPriorities, { Key: 'STAT' });
            }
            else if (status == 'ST') {
                $scope.STATFilter = false;
                $scope.Status.key = status;
            }
            else {
                $scope.STATFilter = false;
                $scope.Status.key = status;
            }
            $scope.filter();
        }
        $scope.CollapseFiler = function () {
            ////////$log.log("CollapseFiler");
            $scope.isDisabled = true;
            setTimeout(function () { $scope.isDisabled = false; }, 200);
            //$('#collapseWorklist').slideToggle();
            $('#collapseWorklist').toggleClass('in');
            $scope.WorklistPageHeaderParameter.isfilterCollapse = !$scope.WorklistPageHeaderParameter.isfilterCollapse;
            if ($scope.WorklistPageHeaderParameter.isfilterCollapse) {
                if (($scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) || ($scope.SelectedList.Location && $scope.SelectedList.Location.length > 0)) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 0.5s !important;');
                    $(".anui").addClass("update-vw-height");
                    $('.anui').removeClass("set-modality-height")
                    $('.anui').removeClass("set-location-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 0.5s !important;');
                    $(".anui").addClass("update-vw-height");
                }

            } else {
                if (($scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) || ($scope.SelectedList.Location && $scope.SelectedList.Location.length > 0)) {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', ' transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                    $('.anui').addClass("set-location-height");
                }
                else {
                    $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s !important;');
                    $(".anui").removeClass("update-vw-height");
                }
            }
        }
        $scope.showContact = function (OrderingPhysician, LocationID, LocationName) {
            ////////$log.log("showContact");
            $scope.currentWindow = 'win_ContactList';
            $scope.getContact(OrderingPhysician, LocationID, LocationName);
            /*var names = OrderingPhysician.split(' ');
            if (names && names.length > 0) {
                $scope.OrderingPhysicianLName = names[0].replace(',', '');
                $scope.OrderingPhysicianFName = (names.length > 1 ? names[1].replace(',', '') : '');
                setTimeout(function () { $scope.ContactSearch.Location = _.filter($scope.Locations, function (obj) { return obj.Location === Location; })[0]; $scope.getContact($scope.OrderingPhysicianFName, $scope.OrderingPhysicianLName); }, 200);
            }*/


        }
        $scope.getContact = function (OrderingPhysician, LocationID, LocationName) {
            ////////$log.log("getContact");
            $scope.FilterAddressBook = {
                Name: OrderingPhysician,
                LocationIDs: LocationID,
                Location: null,
                LocationName: LocationName,
            };
            $scope.win_ContactList.open();
            $scope.win_ContactList.wrapper.prev(".k-overlay").addClass("custom-overlay");
        };

        $scope.addContact = function (locationID) {
            ////////$log.log("addContact");
            // $scope.addEditContactWindowHeight = $scope.halfScale ? "68%" : "62%";
            $scope.currentWindow = "AddEditContactWindow";
            $scope.win_AddEditContactTitle = "Add Contact";
            SetWindowOptions($scope.win_AddEditContact, 'win_AddEditContact', { height: $scope.addEditContactWindowHeight });
            OpenWindow($scope.win_AddEditContact, 'win_AddEditContact');
            $scope.win_AddEditContact.wrapper.prev(".k-overlay").addClass("custom-overlay");
            clearContact();
            var names = $scope.FilterAddressBook.Name.split(' ');
            $scope.AddressBookInfo.SelectedData.LastName = names[0].replace(',', '');
            $scope.AddressBookInfo.SelectedData.FirstName = (names.length > 1 ? names[1].replace(',', '') : '');
            $scope.AddressBookInfo.sites = $scope.sites;
            $scope.AddressBookInfo.Locations = $scope.Locations;
            $scope.AddressBookInfo.Modality = $scope.Modalities;
            $scope.AddressBookInfo.SelectedData.Locations = _.find($scope.Locations, { 'LocationID': locationID }).Location;
            $scope.AddressBookInfo.SelectedData.LocationIDs = locationID;
        };
        $scope.editContact = function (obj) {
            ////////$log.log("editContact");
            // $scope.addEditContactWindowHeight = $scope.halfScale ? "68%" : "62%";
            $scope.currentWindow = "AddEditContactWindow";
            $scope.win_AddEditContactTitle = "Edit Contact";
            //SetWindowOptions($scope.win_AddEditContact, 'win_AddEditContact', { height: $scope.addEditContactWindowHeight });
            OpenWindow($scope.win_AddEditContact, 'win_AddEditContact');
            $scope.win_AddEditContact.wrapper.prev(".k-overlay").addClass("custom-overlay");
            clearContact();
            $scope.ContactId = obj.Id;
            $scope.FirstName = obj.FirstName;
            $scope.LastName = obj.LastName;
            $scope.loc.selectedItems = _.find($scope.Locations, function (item) { return item.Location == obj.PrimaryLocation; });

            var mobile = $scope.spiltPhoneNumber(obj.Mobile);
            var office = $scope.spiltPhoneNumber(obj.Office);
            if (mobile && mobile.length > 0) {
                $scope.Mobile = (mobile != null) ? mobile[0] : '';
            }
            if (office && office.length > 0) {
                $scope.Office = (office != null) ? office[0] : '';
            }
            $scope.Email = (obj.EmailId) ? obj.EmailId.trim() : '';

        };
        $scope.saveContact = function (Flag) {
            ////////$log.log("saveContact");
            toaster.success({ body: "Contact added successfully!" });
            $scope.getContact($scope.FilterAddressBook.Name, $scope.FilterAddressBook.LocationIDs, $scope.FilterAddressBook.LocationName);
            $scope.win_AddEditContact.close();
        }
        function clearContact() {
            ////////$log.log("clearContact");
            //$scope.frmContact.$setUntouched();
            $scope.SelectedAddressBookLocationValues = { SelectedItems: [] };
            $scope.AddressBookInfo.SelectedData = {
                StatsFlag: 'N',
                CreatedBy: $sessionStorage.currentUserData.userId,
            };
        }
        $scope.spiltPhoneNumber = function (phone) {
            ////////$log.log("spiltPhoneNumber");
            if (phone) {
                return phone.split(',');
            }
            else {
                return null;
            }
        }
        function intiAppHub() {
            ////$log.log("intiAppHub: " + new Date());
            AppHub = AppHubService.getAppHub();
            var justCreated = false;
            if (!AppHub && $sessionStorage.currentUserData) {
                AppHubService.Initialize();
                AppHub = AppHubService.getAppHub();
                justCreated = true;
            }
            if (AppHub) {
                AppHubMethod();
                if (justCreated) AppHubService.startConnection();
            }
        }

        function AppHubMethod() {
            // Ensure chat events (e.g. bindmessage) are received and broadcast when not on index
            var myUserId = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) ? String($sessionStorage.currentUserData.userId) : '(none)';
            console.log('SignalR [bindmessage]: worklist registering. My user ID (as recipient, server must send to this group):', myUserId, 'lowercase:', myUserId.toLowerCase());
            AppHub.on('RadFlowChatAppHubEvent', function (obj) {
                if (obj) {
                    var eventType = (obj.EventType || obj.eventType || '').toLowerCase();
                    var eventArgs = obj.EventArgs || obj.eventArgs || {};
                    var toUserId = String(eventArgs.ToUserId || eventArgs.toUserId || '').toLowerCase();
                    var myId = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) ? String($sessionStorage.currentUserData.userId).toLowerCase() : '';
                    var amIRecipient = !!(toUserId && myId && toUserId === myId);
                    console.log('SignalR [bindmessage]: worklist received EventType=' + (obj.EventType || obj.eventType || '(none)') + ' ToUserId=' + (toUserId || '(none)') + ' myUserId=' + (myId || '(none)') + ' amIRecipient=' + amIRecipient);
                    $rootScope.$broadcast('SignalR:RadFlowChatAppHubEvent', obj);
                    if (eventType === 'bindmessage' && amIRecipient) {
                        var fromName = eventArgs.FromUserDisplayName || eventArgs.fromUserDisplayName || 'Someone';
                        toaster.pop('info', 'New chat message', fromName + ' sent you a message.');
                    }
                }
            });
            AppHub.on('RadFlowAppHubEvent', function (obj) {
                switch (obj.EventType) {
                    case 'orderdiscussionhandler':
                        var discussion = obj.EventArgs;
                        var orderID = obj.EventArgs.orderID;
                        if (discussion.Type == 1) {
                            var objOrderList = _.filter($scope.orderList, function (obj) { return discussion.ReferenceID == obj.DicomOrderID; });
                            if (objOrderList && objOrderList.length > 0) {
                                objOrderList[0].IsDiscussion = true;
                            }
                        } else if (discussion.Type == 0 && orderID) {
                            var objOrderList = _.filter($scope.orderList, function (obj) { return orderID == obj.OrderID; });
                            if (objOrderList && objOrderList.length > 0) {
                                objOrderList[0].IsDiscussion = true;
                            }
                        }
                        if ($scope.isDiscussionVisible) {
                            LoadDiscussion($scope.Discussion);
                        }
                        break;

                    case 'notifyassignstudy':

                        var OrderDiscussion = obj.EventArgs;
                        if (OrderDiscussion.FromUserID != $sessionStorage.currentUserData.userId) {
                            var orderIndex = _.findIndex(OrderList, function (data) { return data.OrderID == OrderDiscussion.OrderID; });
                            var sorderIndex = _.findIndex($scope.orderList, function (data) { return data.OrderID == OrderDiscussion.OrderID; });
                            var userOfGroupLength = OrderDiscussion.Order.listOrderListAssignment.length;
                            var userIndex = _.findIndex(OrderDiscussion.Order.listOrderListAssignment, function (data) { return data.OrderAssingedUserID == $sessionStorage.currentUserData.userId; });
                            var userName = '';
                            if (orderIndex != -1) {
                                OrderList[orderIndex].listOrderListAssignment = OrderDiscussion.Order.listOrderListAssignment;
                                userName = $scope.getOrderListTooltip(OrderList[orderIndex]);
                            }
                            if (sorderIndex != -1) {
                                $scope.orderList[sorderIndex].listOrderListAssignment = OrderDiscussion.Order.listOrderListAssignment;
                                userName = $scope.getOrderListTooltip($scope.orderList[sorderIndex]);
                            }
                            if (OrderDiscussion.Order.listOrderListAssignment.length > 0) {
                                _.each(OrderDiscussion.Order.listOrderListAssignment, function (data) {
                                    if (orderIndex != -1) {
                                        OrderList[orderIndex].OrderAssingedUserID = data.OrderAssingedUserID;
                                        OrderList[orderIndex].OrderAssingedUserName = userName;
                                        OrderList[orderIndex].OrderAssingedUsers = userOfGroupLength;
                                        OrderList[orderIndex].OrderAssingedUser = userIndex != -1 ? $sessionStorage.currentUserData.userId : null;
                                    }

                                    if (sorderIndex != -1) {
                                        $scope.orderList[sorderIndex].OrderAssingedUserID = data.OrderAssingedUserID;
                                        $scope.orderList[sorderIndex].OrderAssingedUserName = userName;
                                        $scope.orderList[sorderIndex].OrderAssingedUsers = userOfGroupLength;
                                        $scope.orderList[sorderIndex].OrderAssingedUser = userIndex != -1 ? $sessionStorage.currentUserData.userId : null;
                                    }


                                });
                            } else {
                                if (orderIndex != -1) {
                                    OrderList[orderIndex].OrderAssingedUserID = null;
                                    OrderList[orderIndex].OrderAssingedUserName = null;
                                    OrderList[orderIndex].OrderAssingedUsers = 0;
                                    OrderList[orderIndex].OrderAssingedUser = null;
                                }

                                if (sorderIndex != -1) {
                                    $scope.orderList[sorderIndex].OrderAssingedUserID = null;
                                    $scope.orderList[sorderIndex].OrderAssingedUserName = null;
                                    $scope.orderList[sorderIndex].OrderAssingedUsers = 0;
                                    $scope.orderList[sorderIndex].OrderAssingedUser = null;
                                }
                            }

                        }
                        else if (OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId) {

                            if (OrderDiscussion.order && OrderDiscussion.order.listOrderListAssignment && OrderDiscussion.order.listOrderListAssignment.length > 0) {

                                var orderIndex = _.findIndex(OrderList, function (data) { return data.OrderID == OrderDiscussion.OrderID; });
                                var sorderIndex = _.findIndex($scope.orderList, function (data) { return data.OrderID == OrderDiscussion.OrderID; });

                                var idx = _.findIndex(OrderDiscussion.order.listOrderListAssignment, { OrderAssingedUserID: $sessionStorage.currentUserData.userId });
                                var OrderAssignedUserID = (idx != -1) ? $sessionStorage.currentUserData.userId : OrderDiscussion.order.listOrderListAssignment[0].OrderAssingedUserID;

                                if (orderIndex != -1) {
                                    OrderList[orderIndex].OrderAssingedUserID = OrderAssignedUserID;
                                }
                                if (sorderIndex != -1) {
                                    $scope.orderList[sorderIndex].OrderAssingedUserID = OrderAssignedUserID;
                                }
                            }
                        }
                        break;

                    case 'notifyorderlistupdatereportfromscrapper':
                        var OrderID = obj.EventArgs.OrderID;
                        isOrderOnServer = true;
                        if (!$scope.isSingReportVisible) {
                            var objOrderList = _.filter($scope.orderList, function (obj) { return obj.OrderID == OrderID; });
                            if (objOrderList && objOrderList.length > 0) {
                            }
                        }
                        $scope.GetRVU();
                        break;

                    case 'orderslistattachmentupdatehandler':

                        var DiacomOrderId = obj.EventArgs.DiacomOrderId;
                        var count = obj.EventArgs.Count;
                        var objOrderList = _.filter($scope.orderList, function (obj) { return obj.DicomOrderID == DiacomOrderId; });
                        if (objOrderList && objOrderList.length > 0) {
                            objOrderList[0].FileCount = count;
                        }
                        break;
                    case 'orderlistupdatehandlerpsw':
                        isOrderOnServer = true;
                        break;
                    case 'processedordersupdate':
                        var obj = obj.EventArgs;
                        switch (obj.Type) {
                            case 'ShowHideOrder':
                                _.each(obj.OrderList, function (order) {
                                    if (($scope.Status.key == 'H' || $scope.Status.key == 'AL') && order.Status == 'RP') {
                                        var OrderIndex = OrderExists(order.OrderID);
                                        if (OrderIndex != -1) {
                                            order.Status = 'H';
                                            order.RowColorCode = $scope.getRowTemplateColorCode(order);

                                            OrderList[OrderIndex] = order;

                                            $scope.orderList = OrderList;
                                        } else {
                                            order.Status = 'H';
                                            if (checkOrderFilters(order)
                                                && validateSite(order.SiteID)) {
                                                order.RowColorCode = $scope.getRowTemplateColorCode(order);
                                                OrderList.push(order);
                                                $scope.WorklistPageHeaderParameter.HiddenCount++;
                                                $scope.WorklistPageHeaderParameter.ResultPendingCount--;
                                                updateOrderList(order);
                                            }
                                        }
                                    } else if (($scope.Status.key == 'AL' || $scope.Status.key == 'RP') && order.Status == 'H') {

                                        var OrderIndex = OrderExists(order.OrderID);
                                        if (OrderIndex != -1) {
                                            order.Status = 'RP';
                                            order.RowColorCode = $scope.getRowTemplateColorCode(order);

                                            OrderList[OrderIndex] = order;

                                            $scope.orderList = OrderList;
                                        } else {
                                            order.Status = 'RP';
                                            if (checkOrderFilters(order)
                                                && validateSite(order.SiteID)) {
                                                order.RowColorCode = $scope.getRowTemplateColorCode(order);
                                                OrderList.push(order);
                                                $scope.WorklistPageHeaderParameter.HiddenCount--;
                                                $scope.WorklistPageHeaderParameter.ResultPendingCount++;
                                                updateOrderList(order);
                                            }
                                        }

                                    }
                                });

                                break;
                            case 'DraftedOrder':
                                if (obj.UserID != $sessionStorage.currentUserData.userId) {
                                    _.each(obj.OrderList, function (order) {
                                        if ($scope.Status.key == 'RP') {
                                            removeOrderFromList(order.OrderID);
                                        } else if ($scope.Status.key == 'AL') {
                                            var OrderIndex = OrderExists(order.OrderID);
                                            if (OrderIndex == -1) {
                                                if (checkOrderFilters(order)
                                                    && validateSite(order.SiteID)) {
                                                    order.Status = 'D';
                                                    order.ReportStatus = 2;
                                                    order.RowColorCode = $scope.getRowTemplateColorCode(order);
                                                    OrderList.push(order);
                                                    updateOrderList(order);

                                                }
                                            } else {
                                                order.Status = 'D';
                                                order.ReportStatus = 2;
                                                order.RowColorCode = $scope.getRowTemplateColorCode(order);
                                                OrderList[OrderIndex] = order;
                                                $scope.orderList = OrderList;
                                            }
                                            $timeout(function () {
                                                selectRow();
                                            }, 100);

                                        }
                                    });

                                }

                                break;
                            case 'SignedOrder':
                                if (obj.UserID != $sessionStorage.currentUserData.userId) {
                                    _.each(obj.OrderList, function (order) {
                                        if ($scope.Status.key == 'RP' || $scope.Status.key == 'D') {
                                            removeOrderFromList(order.OrderID);
                                        } else if ($scope.Status.key == 'AL') {
                                            var OrderIndex = OrderExists(order.OrderID);
                                            if (OrderIndex == -1) {
                                                if (checkOrderFilters(order)
                                                    && validateSite(order.SiteID)) {
                                                    order.Status = 'C';
                                                    order.ReportStatus = 1;
                                                    order.RowColorCode = $scope.getRowTemplateColorCode(order);
                                                    OrderList.push(order);
                                                    updateOrderList(order);
                                                }
                                            } else {
                                                order.Status = 'C';
                                                order.ReportStatus = 1;
                                                order.RowColorCode = $scope.getRowTemplateColorCode(order);
                                                OrderList[OrderIndex] = order;
                                                $scope.orderList = OrderList;
                                            }
                                            $timeout(function () {
                                                selectRow();
                                            }, 100);
                                        }
                                    });

                                }


                                break;
                            default:
                                if ($scope.AutoRefresh) {
                                    if ($scope.SelectedWorkList && $scope.SelectedWorkList.length > 0) {
                                        var OrderIDs = _.map(obj.OrderList, function (order) { return { 'OrderID': order.OrderID, 'QueueSource': '', 'ParentOrderIDs': '' }; });
                                        var orderListFilter = {
                                            PageNum: 1,
                                            PageSize: $scope.PageSize,
                                            AdminWorklistIds: $scope.worklistIds_Admin,
                                            UserWorklistIds: $scope.worklistIds_User,
                                            jsonOrderIDs: OrderIDs,
                                            SiteID: $scope.SelectedList.Site ? $scope.SelectedList.Site.SiteID : null,
                                            LocationID: $scope.locationIDs && $scope.locationIDs.length > 0 ? $scope.locationIDs : null,
                                            Accession: $scope.Accession,
                                            ModalityID: $scope.modalityIDs && $scope.modalityIDs.length > 0 ? $scope.modalityIDs : null,
                                            OrderDateStartDate: ($scope.OrderDate.startDate) ? moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") : null,
                                            OrderDateEndDate: ($scope.OrderDate.endDate) ? moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY") : null,
                                            PatientName: $scope.PatientName,
                                            PatientMRN: $scope.PatientMRN,
                                            PatientDOB: $scope.formatted_date($scope.DOB),
                                            PatientClass: $scope.SelectedList.PatientClass ? $scope.SelectedList.PatientClass.Value : null,
                                            OrderingPhysician: $scope.OrderingPhysician,
                                            Status: $scope.Status.key,
                                            UserID: $sessionStorage.currentUserData.userId,
                                        };
                                        WorklistService.ValidateOrdersList(orderListFilter).then(function (result) {
                                            validateOrders(result);
                                        });
                                    } else {
                                        validateOrders(obj.OrderList);
                                    }
                                } else {
                                    isOrderOnServer = true;
                                }
                                break;
                        }
                        break;
                    case 'notifyopenorder':
                        var OrderID = obj.EventArgs.OrderID;
                        var isOpen = obj.EventArgs.Open;
                        var ProviderID = obj.EventArgs.ProviderID;
                        var ProviderName = obj.EventArgs.ProviderName;
                        if ($sessionStorage.currentUserData.userId != ProviderID) {
                            var objOrder = _.filter($scope.orderList, function (obj) { return obj.OrderID == OrderID; });
                            if (objOrder && objOrder.length > 0) {
                                if ($scope.ShowLockStudy) {
                                    if (isOpen) {
                                        objOrder[0].IsLock = true;
                                        objOrder[0].LockBy = ProviderName;
                                    }
                                    else {
                                        objOrder[0].IsLock = false;
                                    }
                                }
                                else {
                                    isOrderOnServer = true;
                                }
                            }
                        }
                        break;
                    case 'notifyshowhideorder':
                        var OrderID = obj.EventArgs.OrderID;
                        var IsHide = obj.EventArgs.Hide;
                        var objOrder = _.filter($scope.orderList, function (obj) { return obj.OrderID == OrderID; });
                        if (objOrder && objOrder.length > 0) {
                            switch ($scope.Status.key) {
                                case 'H':
                                    if (!IsHide) {
                                        isOrderOnServer = true;
                                        removeOrderFromList(OrderID);
                                        $scope.WorklistPageHeaderParameter.HiddenCount--;
                                        $scope.WorklistPageHeaderParameter.ResultPendingCount++;
                                    }
                                    break;
                                case 'AL':
                                    objOrder[0].Status = IsHide ? "H" : "RP";

                                    break;
                                case 'RP':
                                    if (IsHide) {
                                        isOrderOnServer = true;
                                        removeOrderFromList(OrderID);
                                        $scope.WorklistPageHeaderParameter.HiddenCount++;
                                        $scope.WorklistPageHeaderParameter.ResultPendingCount--;
                                    }
                                    break;

                            }
                        }
                        break;
                    case 'notifyoruupdate':
                        if (!validateDOS(false)) return;
                        removeOrderAccession(obj.EventArgs.Accession);
                        isOrderOnServer = true;
                        break;
                    case 'notifyorderlistupdatereport':
                        var userID = obj.EventArgs.userID;
                        var OrderID = obj.EventArgs.OrderID;
                        isOrderOnServer = true;
                        if (!$scope.isSingReportVisible) {
                            var objOrderList = _.filter($scope.orderList, function (obj) { return obj.OrderID == OrderID; });
                            if (objOrderList && objOrderList.length > 0) {
                                //$scope.refresh();
                            }
                        }
                        $scope.GetRVU();
                        break;
                    case 'notifyorderlistupdatereportfromradflow':
                        var userID = obj.EventArgs.userID;
                        var OrderID = obj.EventArgs.OrderID
                        if ($scope.NativeMessageResponseReportStatus != -1) {
                            removeOrderFromList(OrderID);
                            $scope.NativeMessageResponseReportStatus = -2;
                        }

                        $scope.GetRVU();
                        GetAllStatusCount();
                        break;
                    case 'notifyorderlistsavereport':
                        var OrderID = (obj.EventArgs.OrderID) ? obj.EventArgs.OrderID : obj.EventArgs.OrderId;
                        if ($scope.Status.key != 'AL') {
                            if ($scope.DictationReportStatus != '') {
                                removeOrderFromList(OrderID);
                            }
                        }
                        break;
                    case 'userstatushandler':
                        var userID = obj.EventArgs.userID;
                        var status = obj.EventArgs.status;
                        var user = _.filter($scope.Radiologists, function (user) { return user.Id == userID; });
                        if (user && user.length > 0) {
                            user[0].IsOnline = status;
                        }
                        break;
                    case 'notifyremoveorderidfromclipboard':
                        var orderIndex = _.findIndex(OrderList, { OrderID: obj.EventArgs.OrderID });
                        if (orderIndex != -1) {
                            OrderList[orderIndex].IsInClipboard = 0;
                        }
                        $scope.orderList = OrderList;
                        break;
                    case 'notifyupdateorderdetail':
                        var orderIndex = _.findIndex(OrderList, { OrderID: obj.EventArgs.OrderID });
                        if (orderIndex != -1) {
                            if (obj.EventArgs.isPeerReview != null) { OrderList[orderIndex].IsReviewAssigned = true; }
                        }
                        $scope.orderList = OrderList;
                        break;
                }
            });
        }

        PageInIt();

        $scope.$on('$destroy', function () {
            //$log.log("$destroy");
            $('#divOrderList').hide();
            if ($scope.LastOpenedOrderID != null) {
                closePS360($scope.LastOpenedOrder);
                removeOrderFromList($scope.LastOpenedOrderID);
                $scope.DeleteOpenOrder();
            }
            $scope.DeleteOpenOrderByUserID();
            oldWorklistTour.end();
            $('.popover.tour').css("display", "none");
            //StopRC();

            AppHub.off("RadFlowAppHubEvent");
            //AppHub = null;

            windowHandler.DoNotCloseWindow(['Analytics']);

            $interval.cancel(refreshDOSMidnight);
            $interval.cancel(orderRefreshInterval);
            $interval.cancel(newOrderRefreshInterval);

            hideContextMenu();
            hideNotification();

        });


        $scope.OpenVR = function (order, isSingleView) {
            var paramObj = {
                cmd: 'civrObject',
                data: {
                    currentUserData: $sessionStorage.currentUserData,
                    SelectedOrder: cleanCIVRparamObj(order)
                },
                callbackStatus: "VRStatus",
                isSingleView: isSingleView,
            }
            if (isSingleView) {
                var openOrders = {
                    OrderId: order.OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId
                };
                WorklistService.VerfiyReadStudy(openOrders).then(function (result) {
                    if (result.openOrders && result.openOrders.length > 0) {
                        confirm("This order is presently being dictated by user " + result.openOrders[0].ProviderName + ".\nCaution: Proceeding will create another report.");
                        return;
                    }
                    else {
                        windowHandler.openCIVR(paramObj)
                    }
                });
            }
            else {
                windowHandler.openCIVR(paramObj)
            }
        };
        function cleanCIVRparamObj(order) {
            var obj = _.clone(order)
            if (obj.hasOwnProperty('listOrderListAssignment')) {
                delete obj.listOrderListAssignment
            }
            if (obj.hasOwnProperty('subGridOptions')) {
                delete obj.subGridOptions
            }
            if (obj.hasOwnProperty('OrderReport')) {
                delete obj.OrderReport
            }
            if (obj.hasOwnProperty('listOrderListAssignment')) {
                delete obj.listOrderListAssignment
            }
            return obj;
        }

        $scope.openKonica = function (order, Viewer) {
            $scope.konica_RadFlow = windowHandler.openByPreference(__env._environment.config.konicaBaseURL.replace("@MRN", order.PatientMRN).replace("@ACCESSION", order.Accession).replace("@VIEWER", Viewer), Viewer, 100, Viewer.replace(/\s/g, "").toUpperCase() + "-" + order.Accession.toUpperCase().trim(), "noreferrer");
        }
        //$scope.openKonicaTest = function (order) {
        //    $scope.konicaTest_RadFlow = windowHandler.openByPreference(APP_CONSTANTS.konicaTestBaseURL.replace("@MRN", order.PatientMRN).replace("@ACCESSION", order.Accession).replace("@SITE", order.Site), "KONICATEST", 100, "noreferrer");
        //}

        window.onmessage = function (event) {
            //$log.log("onmessage");
            // Do we trust the sender of this message?  (might be
            // different from what we originally opened, for example).
            //////$log.log(event);
            var d = event.data;
            if (d.cmd === 'redirectClose') {
                if ($scope.konica_Redirect) {
                    $scope.konica_Redirect.close()
                }
            }
            //if (event.origin !== APP_CONSTANTS.VRViewurl) {
            //    return;
            //}
            //$log.log("onmessage > d.cmd: ", d.cmd);
            if (d.cmd === 'radflowObject') {
                if (d.data.SelectedOrder) {
                    $scope.win_ModalReportNDiscuss.close();
                    $scope.win_Discussion.close();
                    if ($scope.SingReport.Order.Accession == d.data.SelectedOrder.Accession) {
                        windowHandler.CloseWindow(["CI-VIEWER-1-" + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        "CI-VIEWER-2-" + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        'KONICA-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        'KONICATEST-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        'MedDreamViewer-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        'NORTHSTARKONICA-' + d.data.SelectedOrder.Accession.toUpperCase().trim()]);
                    }
                    //$scope.DeleteOpenOrder();
                    //$scope.refresh();
                    if (!$scope.ChooseNextStudy) {
                        $scope.NextRec();
                        $scope.SingbtnDisabled = false;
                    }
                    else {
                        $scope.DictationReportState = "DictateByCIVR";
                        $scope.DictationReportStatus = d.data.SelectedOrder._ReportStatus;

                        if (d.data.SelectedOrder._ReportStatus == 'Final' || d.data.SelectedOrder._ReportStatus == 'Correction') {
                            OpenOrder = {};
                            VerfiyReadStudy(d.data.SelectedOrder.OrderID, $sessionStorage.currentUserData.userId, null).then(function (response) {
                                if (OpenOrder.ClipboardDetailResult && OpenOrder.ClipboardDetailResult.length > 0) {
                                    var obj = { OrderID: d.data.SelectedOrder.OrderID, UserID: $scope.LoggedInUserID, RuleID: OpenOrder.ClipboardDetailResult[0].RuleID };
                                    RemoveFromClipboardRule(obj);
                                    WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                                } else {
                                    var clipboardRule = _.find($scope.GlobalRules, { WorklistType: 16 });
                                    if (clipboardRule) {
                                        var obj = { OrderID: d.data.SelectedOrder.OrderID, UserID: $scope.LoggedInUserID, RuleID: clipboardRule.RuleID };
                                        RemoveFromClipboardRule(obj);
                                        WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                                    }
                                }
                            });
                        }

                        if (($scope.Status.key == 'RP' || $scope.Status.key == 'D') && (d.data.SelectedOrder._ReportStatus == 'Final' || d.data.SelectedOrder._ReportStatus == 'Correction')) {
                            removeOrderFromList($scope.LastOpenedOrderID);
                            if (d.data.SelectedOrder._PatientOrdersMapped) {
                                _.each(d.data.SelectedOrder._PatientOrdersMapped, function (mappedOrder) {
                                    removeOrderFromList(mappedOrder.OrderID);
                                });
                            }

                        }

                        $scope.DeleteOpenOrder();
                    }

                    GetStatusCount();
                    $scope.GetRVU();


                }
            }
        }

        window.onbeforeunload = function (event) {
            ////////$log.log("onbeforeunload");
            //if ($scope.CIDICOMViewerWindow && !$scope.CIDICOMViewerWindow.closed) {
            //    $scope.CIDICOMViewerWindow.close();
            //}
            if ($scope.konica_RadFlow && !$scope.konica_RadFlow.closed) {
                $scope.konica_RadFlow.close();
            }
            //if ($scope.konicaTest_RadFlow && !$scope.konicaTest_RadFlow.closed) {
            //    $scope.konicaTest_RadFlow.close();
            //}
            windowHandler.DoNotCloseWindow(['Analytics']);
            event.preventdefault(true);
            return true;
        };

        function rebindLocation() {
            //////$log.log("rebindLocation");
            $scope.isRebindingLocation = true;
            var drtr = $("#worklistDropdownTree").data("kendoDropDownTree");
            if ($scope.SelectedWorkList && $scope.SelectedWorkList.length > 0) {
                for (var i = 0; i < $scope.SelectedWorkList.length; i++) {
                    var idx = _.findIndex($scope.WorkLists, function (item) { return item.RuleID == $scope.SelectedWorkList[i].RuleID; });
                    if (idx > -1) {
                        $scope.WorkLists[idx].checked = true;
                    }
                }
            }
            if (drtr) {
                var dataSource = new kendo.data.HierarchicalDataSource({
                    data: $scope.WorkLists
                });
                drtr.setDataSource(dataSource);
            }
            setWorklisttooltip();
            $scope.isRebindingLocation = false;
        }

        var hideContextMenu = function () {
            //////$log.log("hideContextMenu");
            $scope.isContextMenuVisible = false;
            if (!$rootScope.$$phase) {
                $rootScope.$apply();
            }
        };

        $scope.assignToMe = function () {
            //////$log.log("assignToMe");
            var index = $scope.contextmenuRowIndex;
            var Order = $scope.orderList[index];

            var SpecialityId = 0;
            var SpecialityCode = '';
            var filter = _.find($scope.Radiologists, function (dobj) { return dobj.Id == $sessionStorage.currentUserData.userId });
            if (filter) {
                SpecialityId = filter.SpecialityId;
                SpecialityCode = filter.SpecialityCode;
            }

            var orderDiscussionUserGroup = [];
            var userGroup = {
                ToUserID: $sessionStorage.currentUserData.userId,
                ToUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                ProviderSpecialityId: SpecialityId,
                IsUserWithSpecialityGroup: 2
            }
            orderDiscussionUserGroup.push(userGroup);
            var userOfGroup = _.filter($scope.Radiologists, function (item) { return item.SpecialityId == SpecialityId; });
            var OrderListAssignment = {
                OrderID: $scope.SelectedOrder.OrderID,
                OrderAssingedUserID: $sessionStorage.currentUserData.userId,
                OrderAssingedUserName: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                ProviderSpecialityId: SpecialityId,
                IsUserWithSpecialityGroup: 2,
                SpecialityCode: SpecialityCode,
                TotalUsersOfGroup: userOfGroup.length
            }
            Order.listOrderListAssignment.push(OrderListAssignment);


            var data = {
                OrderID: $scope.SelectedOrder.OrderID,
                FromUserID: $sessionStorage.currentUserData.userId,
                FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                OrderDiscussionUserGroup: orderDiscussionUserGroup,
                Status: 'I',
                Order: $scope.SelectedOrder
            };
            $scope.isLoading = true;

            WorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                $scope.isLoading = false;
            }, _respError);

            $scope.isContextMenuVisible = false;
            $scope.isAssignedCurrentUser = true;
        };

        $scope.unAssignToMe = function () {
            //////$log.log("unAssignToMe");
            var index = $scope.contextmenuRowIndex;
            var Order = $scope.orderList[index];

            var orderDiscussionUserGroup = [];
            if (Order.listOrderListAssignment.length > 0) {

                _.each(Order.listOrderListAssignment, function (obj) {
                    var userGroup = {
                        ToUserID: obj.OrderAssingedUserID,
                        ToUser: obj.OrderAssingedUserName,
                        ProviderSpecialityId: obj.ProviderSpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);
                });
                if (!(_.filter(Order.listOrderListAssignment, function (obj) { return obj.OrderAssingedUserID === $sessionStorage.currentUserData.userId }).length > 0)) {
                    Order.listOrderListAssignment = [];
                }
                else {
                    var idx = _.findIndex(Order.listOrderListAssignment, function (order_obj) { return order_obj.OrderAssingedUserID == $sessionStorage.currentUserData.userId });
                    if (idx != -1) {
                        Order.listOrderListAssignment.splice(idx, 1);
                    }
                }
            } else {
                var SpecialityId = 0;
                var filter = _.find($scope.Radiologists, function (dobj) { return dobj.Id == $sessionStorage.currentUserData.userId });
                if (filter) {
                    SpecialityId = filter.SpecialityId;
                }

                var userGroup = {
                    ToUserID: $sessionStorage.currentUserData.userId,
                    ToUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    ProviderSpecialityId: SpecialityId
                }
                orderDiscussionUserGroup.push(userGroup);
            }
            var userId, userName, data = null;
            if (orderDiscussionUserGroup.length > 0 && !(_.filter(orderDiscussionUserGroup, function (obj) { return obj.ToUserID === $sessionStorage.currentUserData.userId }).length > 0)) {
                _.each(orderDiscussionUserGroup, function (obj) {
                    if (userId) { userId += ',' + obj.ToUserID; } else { userId = obj.ToUserID; }
                    if (userName) { userName += ';' + obj.ToUser; } else { userName = obj.ToUser; }
                });
                data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: userId,
                    FromUser: userName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'D',
                    Order: Order
                };
            }
            else {
                data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'D',
                    Order: Order
                };
            }
            $scope.isLoading = true;

            WorklistService.UnassignStudy(data).then(function (response) {
                $scope.isLoading = false;
                $scope.getData();
            }, _respError);

            $scope.isContextMenuVisible = false;
            $scope.isAssignedCurrentUser = false;
        };

        angular.element(document).bind('click', function ($evt) {
            ////////$log.log("bind");
            hideContextMenu();
        });

        $scope.getOrderDiscussionOptions = function () {
            //////$log.log("getOrderDiscussionOptions");
            var options = {
                template: kendo.template($("#dropdowntree-orderdiscussion-template").html()),
                placeholder: 'Select User / Group',
                checkboxes: {
                    checkChildren: true
                },
                autoClose: false,
                dataSource: $scope.RadiologistsGroups,
                dataTextField: "UserName",
                dataValueField: "Id",
                height: "auto",
                loadOnDemand: false,
                headerTemplate: '<span class="k-list-filter"><input class="k-textbox" role="listbox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-disabled="false" id="ddstOrderDiscussion" autocomplete="off"/><span class="k-icon k-i-zoom"></span></span>',
                filtering: function (e) {
                    //get filter descriptor
                    var filter = e.filter;
                    // handle the event
                },
                open: function (e) {
                    $("#ddstOrderDiscussion").change(refreshTreeOrderDiscussion).keyup(refreshTreeOrderDiscussion);
                    setTimeout(function () {
                        $("#ddstOrderDiscussion").focus();
                    }, 1500);

                    $("#ddstOrderDiscussion").val('');
                    var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
                    if (drtr) {
                        var tree = drtr.treeview;
                        var dataSource = drtr.dataSource;
                        dataSource.filter({});
                        setTimeout(function () {
                            tree.collapse(".k-item");
                        }, 1000);
                    }


                },
                change: function (e) {
                    var nodes = e.sender.dataSource.view();

                    var checkedNodes = e.sender.value();

                    var values = checkedNodeValues(nodes, checkedNodes);
                    var rValues = _.omitBy(values, _.isNil);
                    var selectedUsers = [];
                    $scope.OrderDiscussion.SelectedUsers = [];
                    $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                    _.each(rValues, function (obj) {
                        var selectedRadiologistGroups = _.find($scope.RadiologistsGroups, function (dobj) { return dobj.Id == obj });
                        if (selectedRadiologistGroups) {
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup.push(selectedRadiologistGroups);
                        }

                    });
                    $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();


                    setOrderDiscussionTooltip();

                },
            };
            return options;
        }

        function refreshTreeOrderDiscussion() {
            //////$log.log("refreshTreeOrderDiscussion");
            var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            var tree = drtr.treeview;
            var dataSource = drtr.dataSource;
            var value = $("#ddstOrderDiscussion").val();
            if (value !== "") {
                dataSource.filter({
                    field: "UserName", //if I would use "ChildrenText" here nothing be displayed at all if filtertext is set
                    operator: "contains",
                    value: $("#ddstOrderDiscussion").val()
                });

                //filtering child node
                if (dataSource.view().length > 0) {
                    for (var i = 0; i < dataSource.view().length; i++) {
                        if (dataSource.view()[i].hasChildren) {
                            dataSource.view()[i].children.filter({
                                field: "UserName",
                                operator: "neq",
                                value: true
                            })
                        }
                    }
                }

                setTimeout(function () {
                    tree.expand(".k-item");
                }, 200);
            } else {
                dataSource.filter({});

                setTimeout(function () {
                    tree.collapse(".k-item");
                }, 200);
            }
            angular.element(document).ready(function () {
                angular.element('.k-item').mouseenter(function () {
                    if (tree) {
                        tree.focus();
                    }
                });

            });
        }

        function setOrderDiscussionUserGroup() {
            var d = $q.defer();
            //////$log.log("setOrderDiscussionUserGroup");
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedUsers) {
                var allSpecialityArr = _.map($scope.OrderDiscussion.SelectedUsers, function (row) {
                    return row.SpecialityId;
                });
                var uniqueSpeciality = _.filter(allSpecialityArr, function (item, index, arry) { return (arry.indexOf(item) === index) });

                var usergroups = [];

                _.each(uniqueSpeciality, function (obj) {
                    if (obj > 0) {
                        var findSelectedSpeciality = _.filter($scope.OrderDiscussion.SelectedUsers, function (sUser) { return sUser.SpecialityId == obj });
                        var findAllSpeciality = _.filter($scope.Radiologists, function (aUser) { return aUser.SpecialityId == obj });
                        var findExistsInGroup = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 1 });
                        var findUserOnly = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 2 });
                        if (findUserOnly.length == 0 && findSelectedSpeciality && findAllSpeciality && findSelectedSpeciality.length > 0 && findAllSpeciality.length > 0 && findSelectedSpeciality.length == findAllSpeciality.length) {
                            usergroups.push(obj);
                            if (findExistsInGroup && findExistsInGroup.length > 0) {
                                _.each(findExistsInGroup, function (user) {
                                    usergroups.push(user.Id);
                                });
                            }
                        } else {
                            if (findUserOnly.length > 0 || findExistsInGroup.length > 0) {
                                if (findUserOnly && findUserOnly.length > 0) {
                                    _.each(findUserOnly, function (user) {
                                        usergroups.push(user.Id);
                                    });
                                }
                                if (findExistsInGroup && findExistsInGroup.length > 0) {
                                    _.each(findExistsInGroup, function (user) {
                                        usergroups.push(user.Id);
                                    });
                                }
                            } else {
                                if (findSelectedSpeciality && findSelectedSpeciality.length > 0) {
                                    _.each(findSelectedSpeciality, function (speciality) {
                                        usergroups.push(speciality.Id);
                                    });
                                }
                            }


                        }
                    }
                });

                var filterUsers = _.filter($scope.OrderDiscussion.SelectedUsers, function (obj) { return obj.SpecialityId == 0 });
                if (filterUsers && filterUsers.length > 0) {
                    _.each(filterUsers, function (obj) {
                        usergroups.push(obj.Id);
                    });
                }
                d.resolve(usergroups);
            } else {
                d.resolve();
            }
            return d.promise;
        }

        $scope.OrderDiscussionAssigned = function (count) {
            ////////$log.log("OrderDiscussionAssigned");
            return count > 0;
        }

        function setOrderDiscussionTooltip() {
            //////$log.log("setOrderDiscussionTooltip");
            $scope.orderDiscussionTooltip = '';
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedRadioLogistsGroup && $scope.OrderDiscussion.SelectedRadioLogistsGroup.length > 0) {
                _.each($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (obj) {
                    if (obj && obj.Group && obj.Group == "YES") {
                        $scope.orderDiscussionTooltip += obj.UserName + "\n";
                    } else {
                        var selectedUserIndex = _.findIndex($scope.OrderDiscussion.SelectedUsers, { 'Id': obj.Id });
                        if (selectedUserIndex != -1) {
                            if ($scope.OrderDiscussion.SelectedUsers[selectedUserIndex].IsUserWithSpecialityGroup == 2) {
                                $scope.orderDiscussionTooltip += obj.UserName + "\n";
                            }
                        }
                    }
                });

            }
            angular.element(document).ready(function () {
                angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "hidden");
                if ($scope.orderDiscussionTooltip.length > 0) {
                    angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "visible");
                }

            });
        }

        $scope.getOrderListTooltip = function (Order) {
            ////////$log.log("getOrderListTooltip");
            var orderDiscussionTooltip = '';
            var groupName = '';
            var userName = '';
            var allSpeciality = _.uniqBy(_.map(Order.listOrderListAssignment, function (row) {
                return {
                    ProviderSpecialityId: row.ProviderSpecialityId,
                    IsUserWithSpecialityGroup: row.IsUserWithSpecialityGroup,
                    SpecialityCode: row.SpecialityCode
                }
            }), 'ProviderSpecialityId');
            var allUsers = _.map(Order.listOrderListAssignment, function (row) {
                return {
                    OrderAssingedUserID: row.OrderAssingedUserID,
                    OrderAssingedUserName: row.OrderAssingedUserName,
                }
            });
            var specialities = [];
            var users = []
            _.each(Order.listOrderListAssignment, function (orderAssignment) {
                if (orderAssignment.ProviderSpecialityId > 0) {
                    var speciality = _.find(allSpeciality, { ProviderSpecialityId: orderAssignment.ProviderSpecialityId });
                    if (speciality) {
                        specialities.push(speciality);
                    }
                } else {
                    var specialityUser = _.find(allUsers, { OrderAssingedUserID: orderAssignment.OrderAssingedUserID });
                    if (specialityUser) {
                        users.push(specialityUser);
                    }
                }
            });
            var uniquespecialities = _.uniqBy(specialities, 'ProviderSpecialityId');
            var rawUsers = _.uniqBy(users, 'OrderAssingedUserID');
            var uniquespecialityusers = _.filter(rawUsers, function (_u) { return !_isPrelimRadAssignment(_u.OrderAssingedUserID); });

            groupName = _.join(_.map(uniquespecialities, function (speciality) { return speciality.SpecialityCode; }), ',');
            userName = _.join(_.map(uniquespecialityusers, function (_user) {
                return _assignmentName(_user.OrderAssingedUserID, _user.OrderAssingedUserName);
            }), ',');


            if (uniquespecialities.length == 0 && uniquespecialityusers.length == 0) {
                if (rawUsers.length > 0) { return ''; }
                orderDiscussionTooltip = '';
                if (Order.isCollapsed) {
                    orderDiscussionTooltip = 'Hide Comparison';
                } else {
                    orderDiscussionTooltip = 'Show Comparison';
                }
                return orderDiscussionTooltip;
            } else {
                var message = '';
                var groupMessage = '';
                var userMessage = '';
                groupMessage += uniquespecialities.length > 1 ? uniquespecialities.length + ' Groups' : uniquespecialities.length == 1 ? groupName : '';
                userMessage += uniquespecialityusers.length > 1 ? uniquespecialityusers.length + ' Others' : uniquespecialityusers.length == 1 ? userName : '';
                if (groupMessage.length > 0 && userMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage + ' and ' + userMessage;
                } else if (groupMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage;
                } else if (userMessage.length > 0) {
                    message = 'Assigned to ' + userMessage;
                }
                return message;
            }


        }


        function getWorklistPrefrence() {
            ////$log.log("getWorklistPrefrence: " + new Date());
            var d = $q.defer();
            var data = {
                UserID: $sessionStorage.currentUserData.userId,


                UserLayoutPreferenceDto: {
                    PageId: $state.current.name + "." + $state.current.controller,
                    ControlId: 'WorkList_Old'
                }
            };
            WorklistService.GetWorklistPrefrences(data).then(function (result) {
                ////$log.log("getWorklistPrefrence response: " + new Date());
                var WorklistPrefrence = result;
                //User Rule Text
                if (WorklistPrefrence != null && WorklistPrefrence.UserRuleText && WorklistPrefrence.UserRuleText.length > 1) {
                    $scope.UserRules = WorklistPrefrence.UserRuleText;
                }

                //RVUs removed from Worklist Preferences

                //Modalities
                getPrefModalities(WorklistPrefrence);

                //Site and Locations
                getPrefSiteAndLocations(WorklistPrefrence);

                //UserPreferences
                getPrefUserPreferences(WorklistPrefrence);

                //Lookups
                getPrefLookups(WorklistPrefrence);

                //Rules
                getPrefRules(WorklistPrefrence);

                //PRW - PSW
                if ($scope.SelectedList.Worklist.Key == "PRW") {
                    getPRWFilterSetting();
                } else if ($scope.SelectedList.Worklist.Key == "PSW") {
                    getPrefPSW(WorklistPrefrence);
                }

                RenderWorklistLayout(WorklistPrefrence)

                d.resolve();
            });
            return d.promise;
        }

        function OrderExists(OrderID) {
            //////$log.log("OrderExists");
            var OrderIndex = _.findIndex(OrderList, function (obj) { return obj.OrderID == OrderID });
            return OrderIndex;
        }
        function checkOrderFilters(order) {
            //////$log.log("checkOrderFilters");
            var flag = true;
            if ($scope.SelectedList && $scope.SelectedList.Location && $scope.SelectedList.Location.length > 0) {
                var idx = _.findIndex($scope.SelectedList.Location, function (obj) { return obj.LocationID == order.LocationID; });
                if (idx == -1) {
                    return false;
                }
            }
            if ($scope.Accession) {
                if (order.Accession != $scope.Accession) {
                    return false;
                }
            }
            if ($scope.OrderDate && $scope.OrderDate.startDate && $scope.OrderDate.endDate) {
                var orderStartDate = moment(new Date(order.OrderDate)).format("MM-DD-YYYY");
                var startDate = moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY");
                var endDate = moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY");
                if (moment(orderStartDate) >= moment(startDate) && moment(orderStartDate) <= moment(endDate)) {
                    flag = true
                }
                else {
                    return false;
                }
            }
            if ($scope.SelectedList && $scope.SelectedList.Modality && $scope.SelectedList.Modality.length > 0) {
                var idx = _.findIndex($scope.SelectedList.Modality, function (obj) { return obj.Code == order.Modality; });
                if (idx == -1) {
                    return false;
                }
            }
            if ($scope.OrderingPhysician) {
                if (order.OrderingPhysician.toUpperCase().includes($scope.OrderingPhysician.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            }
            if ($scope.PatientMRN) {
                if (order.PatientMRN != $scope.PatientMRN) {
                    return false;
                }
            }
            if ($scope.PatientName) {
                if (order.PatientName.toUpperCase().includes($scope.PatientName.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            }
            if ($scope.DOB) {
                if (moment(new Date(order.PatientDOB)).format("MM-DD-YYYY") != moment(new Date($scope.DOB)).format("MM-DD-YYYY")) {
                    return false;
                }
            }
            if ($scope.SelectedList.PatientClass) {
                if (order.PatientClass != $scope.SelectedList.PatientClass) {
                    return false;
                }
            }
            if ($scope.Status && $scope.Status.key != 'AL') {
                if ($scope.Status.key == 'OP' && order.Status == 'RP') {
                    flag = true;
                } else if (order.Status != $scope.Status.key) {
                    flag = false;
                }
            }
            if ($scope.SelectedList.StudyPriority && $scope.SelectedList.StudyPriority.Key != 'All') {
                if (order.Priority.toUpperCase() != $scope.SelectedList.StudyPriority.Value.toUpperCase()) {
                    return false;
                }
            }
            return flag;
        }

        $scope.showPopup = function () {
            //////$log.log("showPopup");
            //Reference: https://github.com/alexcrack/angular-ui-notification
            if ($state.current.url == "/worklist-lite") {

                Notification({
                    templateUrl: 'custom_template.html',
                    delay: 5000,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'center',
                    positionY: 'top',
                    closeOnClick: true,
                    //onClose: function (element) {
                    //    $scope.refreshAndHideNotification();
                    //},
                    replaceMessage: true,
                    scope: $scope
                }, 'warning');
            }
        }





        function hideNotification() {

            Notification.clearAll();
        }

        function sortByField() {
            ////$log.log("sortByField: " + new Date());
            var sortingFields = [];
            var sortingDirections = [];
            if ($scope.Status.key == "RP") {
                sortingFields = ['IsDeficient', 'DelayedSTAT'];
                sortingDirections = ['desc', 'desc'];
                //if ($scope.SelectedList.StudyPriority) {
                //    sortingFields = ['IsDeficient', 'DelayedSTAT'];
                //    sortingDirections = ['desc', 'desc'];
                //} else {
                //    sortingFields = ['IsDeficient', function (e) { return e.IsStat || e.IsHighPriority; }];
                //    sortingDirections = ['desc', 'desc'];
                //}

            }


            _.each(SortColumns, function (sColumn, index) {
                switch (sColumn.field) {
                    case 'OrderDate':
                        sortingFields.push(function (e) { return e.OrderDate ? new Date(e.OrderDate).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    case 'FormattedPatientDOB':
                        sortingFields.push(function (e) { return e.PatientDOB ? new Date(e.PatientDOB).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    case 'CreatedDate':
                        sortingFields.push(function (e) { return e.CreatedDate ? new Date(e.CreatedDate).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    default:
                        sortingFields.push(sColumn.field);
                        break;
                }

                sortingDirections.push(sColumn.sort.direction);

                //if (sColumn.field != 'CreatedDate') {
                //    sortingFields.push('CreatedDate');
                //    sortingDirections.push('desc');
                //}
            });

            OrderList = _.orderBy(OrderList, sortingFields, sortingDirections);

            ////$log.log("sortByField sorted: " + new Date());

        }

        $scope.refreshAndHideNotification = function () {
            ////$log.log("refreshAndHideNotification");
            if (!validateDOS(true)) return;
            $scope.getData();
            hideNotification();
        }

        $scope.filter = function () {
            ////$log.log("filter: " + new Date());
            if (!validateDOS(true)) return;


            filterChanged = false;
            $scope.PageNo = 1;
            LoadPrevNext = "Next";
            loadIncrement = 1;
            OrderList = [];
            refreshOnClick = true;

            visiblePriorityDD();


            previouslySelectedFilter = {};

            $q.all([
                $scope.getData()
            ]).then(function (data) {
                var pages = Number($scope.TotalRows) / $scope.PageSize;
                _gridAPI.infiniteScroll.resetScroll($scope.PageNo > 1, $scope.PageNo < pages);
            });
        }

        function getPrefModalities(WorklistPrefrence) {
            ////$log.log("getPrefModalities: " + new Date());
            var d = $q.defer();
            if (WorklistPrefrence != null && WorklistPrefrence.Modalities && WorklistPrefrence.Modalities.length > 0) {
                $scope.Modalities = WorklistPrefrence.Modalities;
                d.resolve();
            }
            return d.promise;
        }

        function getPrefSiteAndLocations(WorklistPrefrence) {
            ////$log.log("getPrefSiteAndLocations: " + new Date());
            var d = $q.defer();
            if (WorklistPrefrence != null && WorklistPrefrence.SiteandLocations && WorklistPrefrence.SiteandLocations.length > 0) {
                $scope.Locations = _.filter(WorklistPrefrence.SiteandLocations, function (obj) { return obj.SiteID != 0; });
                var siteIDs = [];

                $.each($scope.Locations, function (index, value) {
                    if ($.inArray(value.SiteID, siteIDs) == -1) {
                        siteIDs.push(value.SiteID);
                    }
                });

                var localSites = [];
                for (var parent = 0; parent < siteIDs.length; parent++) {
                    var child = 0;
                    var itemSite = {};
                    var localLocations = [];
                    for (var j = 0; j < $scope.Locations.length; j++) {
                        if (siteIDs[parent] == $scope.Locations[j].SiteID) {

                            itemSite["text"] = ($scope.Locations[j].SiteID > 0) ? $scope.Locations[j].Site + " (" + $scope.Locations[j].TenantName + ")" : 'WorkList';
                            itemSite["parent"] = parent;

                            var itemLocation = {}
                            itemLocation["text"] = $scope.Locations[j].Location;
                            itemLocation["value"] = $scope.Locations[j].LocationID;

                            itemLocation["type"] = ($scope.Locations[j].SiteID == 0 ? $scope.Locations[j].Site == 'A' ? 'Admin' : 'User' : '');
                            itemLocation["role"] = $scope.userRole;
                            itemLocation["parent"] = parent;
                            localLocations.push(itemLocation);

                            itemSite["items"] = localLocations
                        }
                    }
                    localSites.push(itemSite);
                }
                $scope.sites = localSites.sort(compare);
                d.resolve();
            }
            return d.promise;
        }

        function getPrefUserPreferences(WorklistPrefrence) {
            ////$log.log("getPrefUserPreferences: " + new Date());
            var d = $q.defer();
            if (WorklistPrefrence != null && WorklistPrefrence.UserPreferences && WorklistPrefrence.UserPreferences.length > 0) {

                var ShowPracticeWorklist = _.find(WorklistPrefrence.UserPreferences, { PreferenceType: "ShowPracticeWorklist" });
                if (ShowPracticeWorklist && ShowPracticeWorklist.PreferenceValue) {
                    $scope.ShowPracticeWorklist = ShowPracticeWorklist.PreferenceValue == '1' ? true : false;
                    if ($scope.ShowPracticeWorklist == false) {
                        $scope.WorklistDropdown = _.filter($scope.WorklistDropdown, { Key: 'PRW' });
                    }
                }
                ShowPracticeWorklist = null;

                var pref1 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "Choose Next Study"; });
                $scope.ChooseNextStudy = (pref1 != null && pref1.length > 0 && pref1[0].PreferenceValue == "1") ? true : false;

                var pref2 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "DefaultWorklist"; });
                if (!$scope.ShowPracticeWorklist || pref2 != null && pref2.length > 0 && pref2[0].PreferenceValue == "PRW") {
                    $scope.SelectedList.Worklist = { Key: 'PRW', Value: 'Personal Worklist' };
                }
                else if ($scope.ShowPracticeWorklist || pref2 != null && pref2.length > 0 && pref2[0].PreferenceValue == "PSW") {
                    $scope.SelectedList.Worklist = { Key: 'PSW', Value: 'Practice Worklist' };
                }
                var pref3 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "ShowLockStudy"; });
                if (pref3 != null && pref3.length > 0) {
                    $scope.ShowLockStudy = (pref3 != null && pref3.length > 0 && pref3[0].PreferenceValue == "1") ? true : false;
                }
                var pref4 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "DefaultDicomViewer"; });
                if (pref4 != null && pref4.length > 0 && pref4[0].PreferenceValue) {
                    $scope.DefaultDicomViewer = pref4[0].PreferenceValue;
                }
                var pref5 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "DeficientWarningOnWorklist"; });
                $scope.DeficientWarningOnWorklist = (pref5 != null && pref5.length > 0 && pref5[0].PreferenceValue == "1") ? true : false;

                var pref6 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "DisplaySetting"; });
                if (pref6 && pref6.length > 0) {
                    var childPref6 = _.filter(JSON.parse(pref6[0].PreferenceValue), function (obj) { return obj.HostFingerPrintHash == $sessionStorage.currentUserData.HostFingerPrintHash });
                    if (childPref6 && childPref6.length > 0) {
                        windowHandler.LoadPrefenece(childPref6[0].DisplaySetting);
                    }

                }
                var pref7 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "DefaultDictationSystem"; });
                $scope.DefaultDictationSystem = "";
                if (pref7 != null && pref7.length > 0 && pref7[0].PreferenceValue) {
                    $scope.DefaultDictationSystem = pref7[0].PreferenceValue;
                }

                var StudyPrirority = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "StudyPriority"; });
                $scope.StudyPrirorities = [];
                if (StudyPrirority && StudyPrirority.length > 0) {
                    $scope.StudyPrirorities = StudyPrirority;
                }

                ShowReleaseGuide = _.find(WorklistPrefrence.UserPreferences, {
                    PreferenceType: "ShowReleaseGuide"
                });

                $sessionStorage.DicomViewerCredentials = [];
                var dicomViewerCredentials = _.find(WorklistPrefrence.UserPreferences, { PreferenceType: "DicomViewerCred" });
                if (dicomViewerCredentials && dicomViewerCredentials.PreferenceValue) {
                    $sessionStorage.DicomViewerCredentials = JSON.parse(dicomViewerCredentials.PreferenceValue);
                }
                dicomViewerCredentials = null;
                d.resolve();
            }
            return d.promise;
        }

        function getPrefPSW(WorklistPrefrence) {
            ////$log.log("getPrefPSW ", new Date());
            if (WorklistPrefrence != null && WorklistPrefrence.PageSettings && WorklistPrefrence.PageSettings.length > 0) {
                var ColSort = _.find(WorklistPrefrence.PageSettings, function (item) { return item.PageName == "Work ListColSort"; });
                if (ColSort != null) {
                    $scope.OrderByField = ColSort.ColumnName;
                    $scope.ReverseSort = (ColSort.Value == "1") ? true : false;
                    var idx = _.findIndex(WorklistPrefrence.PageSettings, function (obj) { return obj.PageName == "Work ListColSort"; });
                    if (idx != -1) {
                        WorklistPrefrence.PageSettings.splice(idx, 1);
                    }
                }
                _.each(_.filter(WorklistPrefrence.PageSettings, { PageName: 'Work List' }), function (data) {
                    switch (data.ColumnName) {
                        case 'LocationID':
                            var locations = [];
                            if (data.Value) {
                                _.each(data.Value.split(','), function (data) {
                                    if (data) {
                                        var filter = _.find($scope.Locations, function (item) { return item.LocationID == data && item.SiteID != 0; });
                                        if (filter != null) {
                                            locations.push(filter);
                                        }
                                    }
                                });
                            }

                            $scope.SelectedList.Location = locations;
                            $scope.locationIDs = data.Value;

                            $scope.SelectedLocations = {
                                Ids: data.Value,
                                locations: locations,
                                divId: "OldWorklistFilter"
                            };
                            break;
                        case 'WorklistIds_A':
                            var locations = [];
                            if (data.Value) {
                                _.each(data.Value.split(','), function (data) {
                                    if (data) {
                                        var filter = _.find($scope.WorkLists, function (item) { return item.RuleID == data; });
                                        if (filter != null) {
                                            locations.push(filter);
                                        }
                                    }
                                });
                            }

                            if ($scope.SelectedWorkList != null) {
                                _.each(locations, function (data) {
                                    $scope.SelectedWorkList.push(data);
                                });
                            }
                            else {
                                $scope.SelectedWorkList = locations;
                            }
                            setWorklisttooltip();
                            setSelectedWorklistFilterSettings();

                            break;
                        case 'WorklistIds_U':
                            var locations = [];
                            if (data.Value) {
                                _.each(data.Value.split(','), function (data) {
                                    if (data) {
                                        var filter = _.find($scope.WorkLists, function (item) { return item.RuleID == data; });
                                        if (filter != null) {
                                            locations.push(filter);
                                        }
                                    }
                                });
                            }

                            if ($scope.SelectedWorkList != null) {
                                _.each(locations, function (data) {
                                    $scope.SelectedWorkList.push(data);
                                });
                            }
                            else {
                                $scope.SelectedWorkList = locations;
                            }
                            setWorklisttooltip();
                            setSelectedWorklistFilterSettings();
                            break;
                        case 'Accession':
                            $scope.Accession = data.Value;
                            break;
                        case 'OrderDate':
                            setOrderDate(data.Value);
                            break;
                        case 'ModalityID':
                            var modalities = [];
                            if (data.Value) {
                                _.each(data.Value.split(','), function (data) {
                                    if (data) {
                                        var filter = _.find($scope.Modalities, function (item) { return item.Id == data; });
                                        if (filter != null) {
                                            modalities.push(filter);
                                        }
                                    }
                                });
                            }

                            $scope.SelectedList.Modality = modalities;
                            $scope.ModalityDropdownDataFilter.SelectedValue = {
                                list: modalities,
                            };
                            setModalitytooltip();
                            break;
                        case 'PatientName':
                            $scope.PatientName = data.Value;
                            break;
                        case 'PatientMRN':
                            $scope.PatientMRN = data.Value;
                            break;
                        case 'PatientDOB':
                            $scope.DOB = new Date(data.Value);
                            break;
                        case 'PatientClass':
                            $scope.SelectedList.PatientClass = _.find($scope.PatientClass, function (item) { return item.Value == data.Value; });
                            break;
                        case 'OrderingPhysician':
                            $scope.OrderingPhysician = data.Value;
                            break;
                        case 'Status':
                            $scope.Status.key = data.Value;
                            visiblePriorityDD();
                            break;
                        case 'STATFilter':
                            $scope.STATFilter = (data.Value == "1") ? true : false;
                            break;
                        case 'Priority':
                            $scope.SelectedList.StudyPriority = _.find($scope.StudyPriorities, { Key: data.Value });
                            break;
                    }
                });

            }
        }

        function newOrderRefresh() {
            ////$log.log("newOrderRefresh: ", new Date());
            if (newOrderRefreshInterval) {
                $interval.cancel(newOrderRefreshInterval);
            }
            newOrderRefreshInterval = $interval(function () {
                //$log.log("newOrderRefresh > interval: ", new Date());
                $scope.PendingSinceCurrentDate = new Date();

                if (!validateDOS(false)) return;

                var refresh = false;
                if (!$scope.isSingReportVisible ||
                    !$scope.isPSUserVisible ||
                    !$scope.isComparisonOrderReportsVisible ||
                    !$scope.isDiscussionVisible ||
                    !$scope.isHideStudyVisible) {
                    if ($scope.AutoRefresh) {
                        if (isOrderOnServer) {
                            isOrderOnServer = false;
                            refresh = true;
                        }
                        if (!OrderProcessed) {
                            OrderProcessed = true;
                            refresh = true;
                        } else {
                            OrderProcessed = false;
                        }
                        if (refresh) {
                            refresh = false;
                            $scope.getData();
                            GetStatusCount();
                            $scope.GetRVU();
                        }
                    } else {
                        $scope.getData();
                    }

                }

            }, $scope.AutoRefresh ? newOrderRefreshDuration : DefaultAutoRefreshDuration);
        }

        function validateSite(SiteID) {
            //////$log.log("validateSite");
            var siteIdx = _.findIndex($scope.Locations, function (lObj) { return lObj.SiteID == SiteID });
            if (siteIdx != -1) {
                return true;
            }
            return false;
        }

        function updateOrderList(Order) {
            OrderList = _.uniqBy(OrderList, 'OrderID');

            if ($scope.TotalRows) {
                $scope.TotalRows = Number($scope.TotalRows) + 1;
            }


            sortByField();

            var pages = Number($scope.TotalRows) / $scope.PageSize;
            _gridAPI.infiniteScroll.saveScrollPercentage();
            $scope.orderList = OrderList;
            _gridAPI.infiniteScroll.dataLoaded($scope.PageNo > 1, $scope.PageNo < pages);

        }

        $scope.OnChangeFilter = function () {
            //////$log.log("OnChangeFilter");
            filterChanged = true;
        }

        $scope.OnSelectFilter = function (selectedItem) {
            //////$log.log("OnSelectFilter");
            filterChanged = true;
        }

        $scope.openEventLog = function () {
            $scope.currentWindow = 'win_OrderEventLog';
            OpenWindow($scope.win_OrderEventLog, 'win_OrderEventLog');
            $scope.win_OrderEventLog.wrapper.prev(".k-overlay").addClass("custom-overlay");
        };

        $scope.removeComparedStudy = function (ComparisonOrderID) {
            ////$log.log('removeComparedStudy');
            if (confirm("Are you sure you want to remove this study from comparison?")) {
                $scope.isLoading = true;
                var comparisonOrder = {
                    ComparisonOrderID: ComparisonOrderID,
                    UserId: $sessionStorage.currentUserData.userId
                };

                WorklistService.RemoveComparedStudy(comparisonOrder).then(function (result) {
                    $scope.isLoading = false;

                    removeOrderFromList(ComparisonOrderID);
                });
            }
        }

        $scope.menuItemClicked = function (menuItem) {
            switch (menuItem) {
                case 'Assign to Me':
                    $scope.assignToMe();
                    break;
                case 'Unassign':
                    $scope.unAssignToMe();
                    break;
                case 'View Event':
                    $scope.openEventLog();
                    break;
                case 'Share Exam':
                    $scope.openShareExamWindow();
                    break;
                default:
                    break;
            }
        }

        function selectedOrderExists() {
            if (!$scope.SelectedOrder) {
                return false;
            }
            var idx = _.findIndex($scope.orderList, function (obj) { return obj.OrderID == $scope.SelectedOrder.OrderID; });
            if (idx != -1) {
                return true;
            }
            return false;
        }

        $scope.showPopover = function (dicomOrderID, IsDiscussion) {
            ////$log.log("showPopover");
            $scope.popoverOpened1 = true;
            $scope.popoverDicomOrderID = dicomOrderID;
            if (IsDiscussion) {
                $scope.Discussion = {
                    ReferenceID: dicomOrderID,
                    Type: 1,
                    Comment: '',
                    Record_Created_By: $sessionStorage.currentUserData.userId
                };
                $scope.Discussions = [];
                $q.all([
                    LoadPopOverDiscussion($scope.Discussion)
                ]).then(function (data) {
                    if ($scope.Discussions) {
                        var htmlpop = '<div class="popchatui">';
                        _.each($scope.Discussions, function (discussion) {
                            // htmlpop = htmlpop + '<div>' + discussion.Comment + '</div>';
                            htmlpop = htmlpop + '<div>';
                            var displayName = _discussionDisplayName(discussion);
                            if (discussion.Record_Created_By &&
                                discussion.Record_Created_By == $sessionStorage.currentUserData.userId) {
                                htmlpop = htmlpop + '<div class="sendersection">' +
                                    '<div class="sendercomment pos-rel senderborder">' +
                                    (displayName ? '<div class="sendername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline">' + discussion.Comment + '</div>' +
                                    '<div class="senderdate text-preline">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, true);
                                htmlpop = htmlpop + '</div></div>';
                            } else {
                                htmlpop = htmlpop + '<div class="receiversection">' +
                                    '<div class="receivercomment pos-rel receiverborder">' +
                                    (displayName ? '<div class="receivername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline word-break-word">' + discussion.Comment + '</div>' +
                                    '<div class="receiverdate">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, false);
                                htmlpop = htmlpop + '</div></div>';
                            }

                            htmlpop = htmlpop + '</div>';
                        });
                        htmlpop = htmlpop + '</div>';
                        $scope.htmlPopover = $sce.trustAsHtml(DOMPurify.sanitize(htmlpop));
                    }
                });
            }

        }

        $scope.hidePopover = function () {
            ////$log.log("hidePopover");
            $scope.popoverOpened1 = false;
            $scope.popoverDicomOrderID = null;
            $scope.Discussions = [];
        }

        function LoadPopOverDiscussion(discussion) {
            ////$log.log("LoadPopOverDiscussion");
            var d = $q.defer();
            WorklistService.GetDiscussions(discussion).then(function (response) {
                $scope.AllDiscussions = _.cloneDeep(response);
                $scope.Discussions = _.filter(response, function (item) { return item.Type == 1; });

                angular.forEach($scope.Discussions, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
                d.resolve();
            }, _respError);
            return d.promise;
        }

        function prepareChildDiscussionHTML(discussion, sender) {
            var htmlpop = '';
            if (discussion.Childs && discussion.Childs.length > 0) {
                _.each(discussion.Childs, function (childdiscussion) {
                    var childName = _discussionDisplayName(childdiscussion);
                    if (sender) {
                        htmlpop = htmlpop + '<div class="replaysection mr-15px w-80 pull-left">' +
                            '<div style="background-color: #2F4858 !important;" ' +
                            'class="comment pos-rel border text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    } else {
                        htmlpop = htmlpop + '<div class="replayreceiver mr-15px w-80 pull-right">' +
                            '<div style="background-color: #6c6868 !important;" ' +
                            'class="comment receiverborder pos-rel text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    }

                    htmlpop = htmlpop + prepareChildDiscussionHTML(childdiscussion, sender);
                });
            }
            return htmlpop;
        }

        function getDataDown() {
            if (!validateDOS(false)) { return _gridAPI.infiniteScroll.dataLoaded(); }
            $scope.hidePopover();
            $scope.PageNo++;
            $q.all([
                $scope.refresh()
            ]).then(function (data) {
                //$scope.uiGridOptions.infiniteScrollRowsFromEnd = ($scope.PageNo * 3);
                var pages = Number($scope.TotalRows) / $scope.PageSize;

                _gridAPI.infiniteScroll.saveScrollPercentage();
                OrderList = _.concat(OrderList, data[0]);
                sortByField();

                var uniqueOrderList = _.uniqBy(OrderList, 'OrderID');
                $scope.orderList = _.slice(uniqueOrderList, 0, ($scope.PageNo * $scope.PageSize));
                return _gridAPI.infiniteScroll.dataLoaded($scope.PageNo > 1, $scope.PageNo < pages).then(function () { checkDataLength('up'); });
            }).catch(function () {
                _gridAPI.infiniteScroll.dataLoaded();
            });
        };

        function getDataUp() {
            if (!validateDOS(false)) { return _gridAPI.infiniteScroll.dataLoaded(); }
            $scope.hidePopover();
            var pages = Number($scope.TotalRows) / $scope.PageSize;

            $scope.PageNo--;
            //$scope.uiGridOptions.infiniteScrollRowsFromEnd = ($scope.PageNo * 3);
            _gridAPI.infiniteScroll.saveScrollPercentage();
            OrderList = _.uniqBy(OrderList, 'OrderID');
            OrderList.splice(($scope.PageNo * $scope.PageSize), $scope.PageSize);
            sortByField();
            $scope.orderList = _.slice(OrderList, 0);
            return _gridAPI.infiniteScroll.dataLoaded($scope.PageNo > 1, $scope.PageNo < pages).then(function () { checkDataLength('down'); });
        };

        $scope.getData = function () {
            ////$log.log("getData: " + new Date());
            var d = $q.defer();
            var receivedSinceCol = _.find($scope.uiGridOptions.columnDefs, { 'name': 'ReceivedSince' });
            if (receivedSinceCol) {
                receivedSinceCol.visible = visiblePendingSince ? $scope.Status.key == 'RP' || $scope.Status.key == 'D' : visiblePendingSince;
                receivedSinceCol.enableHiding = $scope.Status.key == 'RP' || $scope.Status.key == 'D';
            }


            $q.all([
                $scope.refresh()
            ]).then(function (data) {
                ////$log.log("getData received: " + new Date());
                if ($scope.PageNo == 1) {
                    OrderList = [];
                }
                OrderList = _.concat(OrderList, data[0]);
                OrderList = _.uniqBy(OrderList, 'OrderID');
                sortByField();
                $scope.orderList = OrderList;



                selectRow();
                d.resolve();
            }).catch(function (err) {
                d.reject(err);
            });

            return d.promise;
        }

        function checkDataLength(discardDirection) {
            ////$log.log("checkDataLength");
            var pages = Number($scope.TotalRows) / $scope.PageSize;
            // work out whether we need to discard a page, if so discard from the direction passed in
            // we want to remove a page
            _gridAPI.infiniteScroll.saveScrollPercentage();

            if (discardDirection === 'up') {
                //$scope.orderList = $scope.orderList.slice(50);
                //gridFirstPage++;
                $timeout(function () {
                    // wait for grid to ingest data changes
                    _gridAPI.infiniteScroll.dataRemovedTop($scope.PageNo > 1, $scope.PageNo < pages);
                });
            } else {
                //$scope.orderList = $scope.orderList.slice(0, (pages * 50));
                //gridLastPage--;
                $timeout(function () {
                    // wait for grid to ingest data changes
                    _gridAPI.infiniteScroll.dataRemovedBottom($scope.PageNo > 1, $scope.PageNo < pages);
                });
            }
        }

        function getPage(data, page) {
            var res = [];
            for (var i = (page * 100); i < (page + 1) * 100 && i < data.length; ++i) {
                res.push(data[i]);
            }
            return res;
        }

        function doSelection(row) {
            ////$log.log("doSelection");
            $scope.setSelected(row.entity.OrderID, row.entity);
        }

        function columnVisibilityChanged(changedColumn) {
            ////$log.log("columnVisibilityChanged");
            var parentGridColums = positionChanged ? _gridAPI.grid.moveColumns.orderCache : _gridAPI.grid.columns;
            var cols = [];
            _.each(parentGridColums, function (col) {
                cols.push(col.colDef);
            });

            var receivedSinceCol = _.find($scope.uiGridOptions.columnDefs, { 'name': 'ReceivedSince' });
            if (receivedSinceCol) {
                visiblePendingSince = receivedSinceCol.visible;
            }


            updateComparisonColumns();

            //vm.columnChanged = { name: changedColumn.colDef.name, visible: changedColumn.colDef.visible };
            var userPref = { version: columnVersion, columnDefs: cols, SortColumns: SortColumns };
            updateUserLayoutPreference(userPref);

        }

        function columnPositionChanged(colDef, originalPosition, newPosition) {
            ////$log.log("columnPositionChanged");
            if (newPosition > 1) {
                var colDefs = $scope.uiGridOptions.columnDefs;
                _.remove(colDefs, function (obj) {
                    return obj.name == colDef.name;
                });
                colDefs.splice(newPosition, 0, colDef);

                $scope.uiGridOptions.columnDefs = colDefs;

                updateComparisonColumns();

                var userPref = { version: columnVersion, columnDefs: $scope.uiGridOptions.columnDefs, SortColumns: SortColumns };
                updateUserLayoutPreference(userPref);
            } else {
                var gridColumns = _gridAPI.grid.moveColumns.orderCache;
                var removedGridCol = _.remove(gridColumns, function (obj) {
                    return obj.field == colDef.name;
                });
                gridColumns.splice(originalPosition, 0, removedGridCol[0]);
                _gridAPI.grid.moveColumns.orderCache = gridColumns;
                _gridAPI.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
            }


            positionChanged = true;
        }

        function RenderWorklistLayout(WorklistPref) {
            if (WorklistPref && WorklistPref.LayoutOptions) {
                var mainGridOptions = JSON.parse(WorklistPref.LayoutOptions);

                if (mainGridOptions != null && mainGridOptions.version != null && mainGridOptions.version == columnVersion) {

                    var civrCell = _.find(mainGridOptions.columnDefs, { 'name': 'CIVR' });
                    if (civrCell) {
                        civrCell.visible = $scope.browser.toUpperCase() != 'IE';
                    }
                    var workRVUCol = _.find(mainGridOptions.columnDefs, { 'name': 'WorkRVU' });
                    if (workRVUCol) {
                        workRVUCol.displayName = "Estimated wRVU";
                        workRVUCol.maxWidth = 150;
                    }


                    var receivedSinceCol = _.find(mainGridOptions.columnDefs, { 'name': 'ReceivedSince' });
                    if (receivedSinceCol) {
                        visiblePendingSince = receivedSinceCol.visible;
                        receivedSinceCol.visible = visiblePendingSince ? $scope.Status.key == 'RP' || $scope.Status.key == 'D' : visiblePendingSince;
                        receivedSinceCol.enableHiding = $scope.Status.key == 'RP' || $scope.Status.key == 'D';
                    }


                    $scope.uiGridOptions.columnDefs = mainGridOptions.columnDefs;
                    //$scope.AutoRefresh = mainGridOptions.AutoRefresh;
                    sorting(mainGridOptions.SortColumns);

                    _gridAPI.grid.refresh();
                } else if (mainGridOptions != null && mainGridOptions.version != null && mainGridOptions.version < columnVersion) {
                    var index = 0;
                    var notExistsColumns = [];
                    _.each(angular.copy(columnDefs), function (colDef) {
                        var colDefIndex = _.findIndex(mainGridOptions.columnDefs, { 'name': colDef.name });
                        if (colDefIndex != -1) {
                            mainGridOptions.columnDefs[colDefIndex].displayName = colDef.displayName;
                            mainGridOptions.columnDefs[colDefIndex].cellTooltip = colDef.cellTooltip;
                            mainGridOptions.columnDefs[colDefIndex].enableSorting = colDef.enableSorting;
                            mainGridOptions.columnDefs[colDefIndex].enableColumnMoving = colDef.enableColumnMoving;
                            mainGridOptions.columnDefs[colDefIndex].enableHiding = colDef.enableHiding;
                            mainGridOptions.columnDefs[colDefIndex].cellTemplate = colDef.cellTemplate;
                            mainGridOptions.columnDefs[colDefIndex].allowFloatWidth = colDef.allowFloatWidth;
                            mainGridOptions.columnDefs[colDefIndex].cellClass = colDef.cellClass;
                            mainGridOptions.columnDefs[colDefIndex].headerCellClass = colDef.headerCellClass;
                            mainGridOptions.columnDefs[colDefIndex].hidePinLeft = colDef.hidePinLeft;
                            mainGridOptions.columnDefs[colDefIndex].enableColumnResizing = colDef.enableColumnResizing;
                            mainGridOptions.columnDefs[colDefIndex].hidePinRight = colDef.hidePinRight;
                            mainGridOptions.columnDefs[colDefIndex].minWidth = colDef.minWidth;
                            mainGridOptions.columnDefs[colDefIndex].maxWidth = colDef.maxWidth;
                            mainGridOptions.columnDefs[colDefIndex].width = colDef.width;
                        } else {
                            mainGridOptions.columnDefs.splice(index, 0, colDef);
                        }

                        index++;
                    });

                    _.each(mainGridOptions.columnDefs, function (col) {
                        var exists = _.some(angular.copy(columnDefs), { 'name': col.name });
                        if (!exists) {
                            notExistsColumns.push(col);
                        }
                    });

                    _.each(notExistsColumns, function (col) {
                        _.remove(mainGridOptions.columnDefs, { 'name': col.name });
                    });

                    var receivedSinceCol = _.find(mainGridOptions.columnDefs, { 'name': 'ReceivedSince' });
                    if (receivedSinceCol) {
                        visiblePendingSince = receivedSinceCol.visible;
                        receivedSinceCol.visible = visiblePendingSince ? $scope.Status.key == 'RP' || $scope.Status.key == 'D' : visiblePendingSince;
                        receivedSinceCol.enableHiding = $scope.Status.key == 'RP' || $scope.Status.key == 'D';
                    }


                    $scope.uiGridOptions.columnDefs = mainGridOptions.columnDefs;
                    //$scope.AutoRefresh = mainGridOptions.AutoRefresh;
                    sorting(mainGridOptions.SortColumns);

                    var userPref = { version: columnVersion, columnDefs: $scope.uiGridOptions.columnDefs, SortColumns: SortColumns };
                    updateUserLayoutPreference(userPref);
                }
            }
            else {

                $scope.uiGridOptions.columnDefs = angular.copy(columnDefs);
                sorting(columnDefs.SortColumns);
            }
        }

        function updateUserLayoutPreference(coldefs) {

            var d = $q.defer();

            coldefs.AutoRefresh = $scope.AutoRefresh;

            var receivedSinceCol = _.find(coldefs, { 'name': 'ReceivedSince' });
            if (receivedSinceCol) { receivedSinceCol.visible = visiblePendingSince; }

            UserLayoutPrefService.SetUserLayoutPreferences({
                UserID: $sessionStorage.currentUserData.userId,
                PageId: $state.current.name + "." + $state.current.controller,
                ControlId: 'WorkList_Old',
                LayoutOptions: JSON.stringify(coldefs),
                Username: $sessionStorage.currentUserData.userName
            }).then(function () {
                d.resolve();
            });
            return d.promise;
        }

        function onSortChanged(grid, sortColumns) {
            ////$log.log("onSortChanged");
            $scope.clearSelection();
            if (sortColumns.length > 0) {
                OrderList = [];

                sorting(sortColumns);
            } else {
                SortColumns[0].sort.direction = SortColumns[0].sort.direction == 'desc' ? 'asc' : 'desc';

                var index = _.findIndex(grid.columns, { 'field': SortColumns[0].field });
                _gridAPI.grid.sortColumn(grid.columns[index], SortColumns[0].sort.direction);
            }
            $scope.SortFilter(SortingByMultiColumn);

            var userPref = { version: columnVersion, columnDefs: $scope.uiGridOptions.columnDefs, SortColumns: SortColumns };
            updateUserLayoutPreference(userPref);
        }

        function onReset() {
            var cols = [];
            if (positionChanged) {
                positionChanged = false;
                var gridColumns = _gridAPI.grid.moveColumns.orderCache;
                _.each(angular.copy(columnDefs), function (col) {
                    var gridCol = _.find(gridColumns, { 'field': col.name });
                    gridCol.width = col.width;
                    gridCol.colDef.width = col.width;

                    gridCol.visible = col.visible;
                    gridCol.colDef.visible = col.visible;
                    cols.push(gridCol);
                });
                gridColumns.length = 0;
                gridColumns.push.apply(gridColumns, cols);
                _gridAPI.grid.moveColumns.orderCache = gridColumns;
            } else {
                var gridColumns = _gridAPI.grid.columns;
                _.each(angular.copy(columnDefs), function (col) {
                    var gridCol = _.find(gridColumns, { 'field': col.name });
                    gridCol.width = col.width;
                    gridCol.colDef.width = col.width;

                    gridCol.visible = col.visible;
                    gridCol.colDef.visible = col.visible;
                    cols.push(gridCol);
                });
                gridColumns.length = 0;
                gridColumns.push.apply(gridColumns, cols);
                _gridAPI.grid.columns = gridColumns;
            }
            _gridAPI.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);

            if (_subGridAPI) {
                resetComparisonGrid();
            }

            return cols;
        }

        function selectRow() {
            ////$log.log("selectRow: ", new Date());
            ////$log.log($scope.SelectedOrder);
            if ($scope.SelectedOrder) {
                var idx = _.findIndex($scope.orderList, { 'OrderID': $scope.SelectedOrder.OrderID });
                _gridAPI.grid.modifyRows($scope.orderList);
                _gridAPI.selection.selectRow($scope.orderList[idx]);
            }
        }

        function updateOrders(Orders) {
            ////$log.log("updateOrders: " + new Date());

            _.each(Orders, function (order) {

                order.subGridOptions = $scope.subUIGridOptions;
                //order.ComparisonOrder = [];

                order.$$treeLevel = 0;

                var orderAssignmentIndex = _.findIndex(order.listOrderListAssignment, function (assignment) { return assignment.OrderAssingedUserID == $sessionStorage.currentUserData.userId; });

                order.OrderAssingedUserID = (order.listOrderListAssignment && order.listOrderListAssignment.length > 0 ? order.listOrderListAssignment[0].OrderAssingedUserID : null);
                //order.OrderAssingedUserName = $scope.getOrderListTooltip(order);
                order.OrderAssingedUsers = (order.listOrderListAssignment ? order.listOrderListAssignment.length : 0);

                order.OrderAssingedUser = (orderAssignmentIndex != -1 ? $sessionStorage.currentUserData.userId : null);
                //order.row = row + 1;

                //row++;

            });
        }

        $scope.openContextMenuOptions = function (Order) {
            $scope.contextMenus = [];

            var index = _.findIndex(OrderList, function (lOrder) { return lOrder.OrderID == Order.OrderID; });
            $scope.contextmenuRowIndex = index;


            $scope.isAssignedCurrentUser = false;
            if (Order.OrderAssingedUser == $scope.LoggedInUserID) {
                $scope.isAssignedCurrentUser = true;
            }

            if (Order.Status == 'C' || Order.Status == 'D' || Order.Status == 'OP' || Order.IsLock || (Order.OrderAssingedUsers > 0 && !Order.OrderAssingedUser)) {
                $scope.assignMenuVisible = false;
            } else {
                if ($scope.isAssignedCurrentUser) {
                    $scope.contextMenus.push({
                        text: 'Unassign',
                        click: function ($itemScope, $event, modelValue, text, $li) {
                            $scope.unAssignToMe();
                        }
                    });
                } else {
                    $scope.contextMenus.push({
                        text: 'Assign to Me', click: function ($itemScope, $event, modelValue, text, $li) {
                            $scope.assignToMe();
                        }
                    });
                }
                //$scope.contextMenus.push($scope.isAssignedCurrentUser ? 'Unassign' : 'Assign to Me');
            }
            if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles && ($sessionStorage.currentUserData.userRoles.includes("SuperAdmin") || $sessionStorage.currentUserData.userRoles.includes("Admin"))) {
                if (!(Order.SignByName) && (!Order.OrderAssingedUser && !(_.filter($scope.contextMenus, function (obj) { return obj.text === 'Assign to Me' }).length > 0))) {
                    $scope.contextMenus.push({
                        text: 'Unassign User(s)', click: function ($itemScope, $event, modelValue, text, $li) {
                            $scope.unAssignToMe();
                        }
                    });
                }
            }
            switch (Order.Status) {
                case 'CO':
                    $scope.contextMenus.push({
                        text: 'Remove from Comparison', click: function ($itemScope, $event, modelValue, text, $li) {
                            $scope.removeComparedStudy(Order.OrderID);
                        }
                    });
                    break;
                case 'H':
                    $scope.contextMenus.push({
                        text: 'Unhide Study', click: function () {
                            $scope.HideOrder();
                        }
                    });
                    break;
                case 'C':
                    if (!Order.IsReviewAssigned) {
                        $scope.contextMenus.push({
                            text: 'Add To Peer Review', click: function ($itemScope, $event, modelValue, text, $li) {
                                var obj = {
                                    OrderID: Order.OrderID,
                                    isPeerReview: '1',
                                    PeerReviewUserID: $sessionStorage.currentUserData.userId,
                                    UserID: $sessionStorage.currentUserData.userId,
                                }
                                UpdateOrderDetail(obj, "Added To Peer Review Successfully!");
                            }
                        });
                    }
                    break;
            }

            $scope.contextMenus.push({
                text: 'View Event', click: function ($itemScope, $event, modelValue, text, $li) {
                    $scope.openEventLog();
                }
            });

            if (Order.IsLock) {
                $scope.contextMenus.push({
                    text: 'Unlock Study', click: function ($itemScope, $event, modelValue, text, $li) {
                        swal({
                            title: 'Do you want to Unlock the Study?',
                            type: "warning",
                            html: true,
                            customClass: 'swal-wide',
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes",
                            cancelButtonText: "No",
                        },
                            function (isConfirm) {
                                if (isConfirm) {
                                    $scope.DeleteOpenOrder(Order);
                                }
                            });
                    }
                });
            }
            $scope.contextMenus.push({
                text: 'Consult with Physician', click: function ($itemScope, $event, modelValue, text, $li) {
                    $scope.CallInConsult(Order);
                }
            });

            if (Order.DicomViewer) {
                $scope.contextMenus.push({
                    text: 'Share Exam', click: function ($itemScope, $event, modelValue, text, $li) {
                        $scope.openShareExamWindow();
                    }
                });
            }
            if ($scope.contextMenus.length > 0) {
                $scope.isContextMenuVisible = true;
            }

            $scope.setSelected(Order.OrderID, Order);
            $scope.clearSelectedChildRows();
            selectRow();
            $scope.contextMenus = _.sortBy($scope.contextMenus, ['text']);
            $scope.assignMenuVisible = true;
            return $scope.contextMenus;
        }
        // New Code
        $scope.CallInConsult = function (order) {
            //$scope.isChatMenuActive = true;
            // $rootScope.$broadcast('activeChatMenuBarformWorkList', $scope.isChatMenuActive,order);
            $scope.SelectedOrder = order;
            $scope.currentWindow = 'win_consultExamsWindow';
            OpenWindow($scope.win_consultExamsWindow, 'win_consultExamsWindow');
            $scope.win_consultExamsWindow.wrapper.prev(".k-overlay").addClass("custom-overlay");
        }
        // Old Code
        // $scope.CallInConsult = function(order){
        //     $scope.isChatMenuActive = true;
        //    $rootScope.$broadcast('activeChatMenuBarformWorkList', $scope.isChatMenuActive,order);
        // }

        // $scope.openConsultExamWindow = function () {
        //     $scope.currentWindow = 'win_consultExamsWindow';
        //     OpenWindow($scope.win_consultExamsWindow, 'win_consultExamsWindow');
        // };
        //Close onClick of send message button from shareExamchat.js
        $scope.onCloseConsultExamWindowHandler = function (newCheck) {
            $scope.isConsultExamsWindow = newCheck;
            if ($scope.isConsultExamsWindow == true) {
                $scope.win_consultExamsWindow.close();
            }
        };

        $scope.rowExpandCollapse = function (row) {
            if (row.isExpanded) {
                _gridAPI.expandable.collapseRow(row.entity);
            } else {
                _gridAPI.expandable.expandRow(row.entity);
            }
            row.entity.isCollapsed = !row.entity.isCollapsed;
        }

        function updateComparisonColumns() {
            if (_subGridAPI) {
                var parentGridColums = positionChanged ? _gridAPI.grid.moveColumns.orderCache : _gridAPI.grid.columns;
                var cols = [];
                var gridColumns = _subGridAPI.grid.columns;
                _.each(parentGridColums, function (col) {
                    var gridCol = _.find(gridColumns, { 'field': col.field });
                    if (gridCol) {
                        gridCol.visible = col.visible;
                        gridCol.colDef.visible = col.visible;

                        gridCol.width = col.width;
                        gridCol.colDef.width = col.width;


                        cols.push(gridCol);
                    }

                });
                gridColumns.length = 0;
                gridColumns.push.apply(gridColumns, cols);
                _subGridAPI.grid.columns = gridColumns;

                _subGridAPI.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
            }

        }

        $scope.getRowTemplateColorCode = function (order) {
            var colorCode = '';
            switch ($scope.Status.key) {
                case 'RP':
                    switch (order.Status) {
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : $scope.DelayStatColorCode ? $scope.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasImage && !order.HasORM) {
                                colorCode = '#b2b266';
                            }
                            break;
                    }
                    break;
                case 'AL':
                    switch (order.Status) {
                        case 'X':
                            colorCode = '#BFDED6';
                            break;
                        case 'CO':
                            colorCode = '#B9ADCF';
                            break;
                        case 'C':
                            colorCode = '#75E284';
                            break;
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'H':
                            colorCode = '#FFC99A';
                            break;
                        case 'RC':
                            colorCode = '#79b384';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : $scope.DelayStatColorCode ? $scope.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasORM && order.HasImage) {
                                colorCode = '#FFE69A';
                            } else if (colorCode.length == 0 && !order.HasORM && order.HasImage) {
                                colorCode = '#b2b266';
                            } else if (colorCode.length == 0 && order.HasORM && !order.HasImage) {
                                colorCode = '#f4ba4b';
                            }
                            break;
                        case 'PA':
                            colorCode = '#ffe6ee';
                            break;
                    }
                    if (colorCode.length == 0 && !order.HasORM) {
                        colorCode = '#ff873a';
                    } else if (colorCode.length == 0 && !order.HasImage) {
                        colorCode = '#f4ba4b';
                    }
                    break;
            }
            return colorCode.length > 0 ? colorCode : '#ffffff';
        }

        $scope.expandedOpenContextMenuOptions = function (row) {
            $scope.contextMenus = [];
            $scope.contextMenus.push({
                text: "Remove from Comparison",
                click: function ($itemScope, $event, modelValue, text, $li) {
                    if (_subGridAPI.selection.getSelectedRows() != null && _subGridAPI.selection.getSelectedRows().length > 0) {
                        $scope.RemoveFromComparison(_subGridAPI.selection.getSelectedRows()[0].OrderID, _subGridAPI.selection.getSelectedRows()[0].Orders);
                    }
                }
            });
            return $scope.contextMenus;
        }

        $scope.setUserIcon = function (row) {
            var html = '';//'<div class="ui-grid-cell-contents overflow-visible" title="TOOLTIP">';

            if (row.entity.IsLock && ($scope.LoggedInUserID != row.entity.LockByProviderID)) {
                html = '<i class="fa fa fa-lock fs-20px txt-clr-14"> ' +
                    '<span class="tultiptext overflow-auto tt-white ml-20px">{{grid.appScope.LoggedInUserID != ' +
                    'row.entity.LockByProviderID ? row.entity.LockBy : \'\'}}</span> ' +
                    '</i> ';
            } else if (row.entity.OrderAssingedUsers > 0) {
                html = '<span class="fa fa-user fs-15px v-a-t d-block py-5px cursor-pointer" ' +
                    'tooltip-class="uibtooltipDenial" ' +
                    'ng-style="{\'color\' : (row.entity.OrderAssingedUser && ' +
                    'grid.appScope.LoggedInUserID == row.entity.OrderAssingedUser) ? \'green\' !important : \'grey\' !important}" ' +
                    'tooltip-placement="auto right" ' +
                    'uib-tooltip="{{grid.appScope.getOrderListTooltip(row.entity)}}" ></span>';
            } else if (row.entity.ProcessError) {
                html = '<i class="fa fa fa-times fs-20px" style="color: red;" > ' +
                    '<span class="tultiptext">Study not available!</span> ' +
                    '</i> ';
            } else {
                html = '';
            }
            //html += '</div>';
            return html;
        }

        $scope.setUserIconCase = function (row) {
            var iconCase = '';
            if (row.entity.IsLock && ($scope.LoggedInUserID != row.entity.LockByProviderID)) {
                iconCase = 'Lock';
            } else if (row.entity.OrderAssingedUsers > 0) {
                iconCase = 'Assignment';
                if (row.entity.IsInClipboard == 2) {
                    iconCase = 'AssignmentMyClipboard';
                } else if (row.entity.IsInClipboard == 1) {
                    iconCase = 'AssignmentOtherClipboard';
                }

            } else if (row.entity.IsInClipboard == 1) {
                iconCase = 'CopiedtoOtherClipboard';

            } else if (row.entity.IsInClipboard == 2) {
                iconCase = 'CopiedtoMyClipboard';
            }
            else if (row.entity.ProcessError) {
                iconCase = 'NA';

            } else {
                iconCase = 'empty';
            }
            return iconCase;
        }

        function setPriorReport(SelectedOrder, ComparisionOrderList) {
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN, SelectedOrder.SiteID)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];

                if (data != null && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        SelectedOrder.OrderDate = new Date($filter('localDate')(SelectedOrder.OrderDate, false, new Date()));
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            rptObject[0].OrderDate = new Date($filter('localDate')(rptObject[0].OrderDate, false, new Date()));
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            ComparisonOrderReport.OrderDate = new Date($filter('localDate')(ComparisonOrderReport.OrderDate, false, new Date()));
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });
                }
                $scope.OrderReport = SelectedOrder;
                $scope.reportList = _.uniqBy($scope.reportList, 'OrderID');
                $scope.PriorReportFilter.List.Modalities = _.concat($scope.PriorReportFilter.List.Modalities, _.uniq(_.map($scope.reportList, 'Modality')));
                var objSelectedReport = _.filter($scope.reportList, function (obj) { return obj.Accession == $scope.SelectedOrderAccession; });
                LoadReport(objSelectedReport[0].OrderID);
                if (Hasreport) {
                    $scope.currentWindow = "win_ComparisonOrderReports";
                    OpenWindow($scope.win_ComparisonOrderReports, 'win_ComparisonOrderReports');
                    $scope.win_ComparisonOrderReports.wrapper.prev(".k-overlay").addClass("custom-overlay");
                }
                else {
                    toaster.info({ body: "No report found." });
                }
                ReportList = $scope.reportList;
                if (ReportList.length > 1) {
                    $scope.PriorReportFilter.Modal = true;
                }
            });
        }

        function resetComparisonGrid() {
            var cols = [];
            var gridColumns = _subGridAPI.grid.columns;
            _.each(angular.copy(columnDefs), function (col) {
                var gridCol = _.find(gridColumns, { 'field': col.name });
                gridCol.width = col.width;
                gridCol.colDef.width = col.width;
                cols.push(gridCol);
            });
            gridColumns.length = 0;
            gridColumns.push.apply(gridColumns, cols);
            _subGridAPI.grid.columns = gridColumns;
            _subGridAPI.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        }

        function onColumnResize(colDef, deltaChange) {
            ////$log.log("onColumnResize");
            var parentGridColums = _gridAPI.grid.columns;
            var cols = [];
            var gridColumns = _gridAPI.grid.columns;
            _.each(parentGridColums, function (col) {
                var gridCol = _.find(gridColumns, { 'field': col.field });

                gridCol.width = col.width;
                gridCol.colDef.width = col.width;

                cols.push(gridCol.colDef);
            });

            updateComparisonColumns();

            var userPref = { version: columnVersion, columnDefs: cols, SortColumns: SortColumns };
            updateUserLayoutPreference(userPref);

        }

        function clearWorklist() {
            $("#tree-worklist-text-search").val('');
            var drtr = $("#worklistDropdownTree").data("kendoDropDownTree");
            if (drtr) {
                var tree = drtr.treeview;
                var dataSource = drtr.dataSource;
                setTimeout(function () {
                    dataSource.filter({});
                    tree.collapse(".k-item");
                }, 1000);
            }
        }

        function isComparisonOrder(Order) {
            var compOrderIndex = -1;
            if (Order.ParentOrderIDs && Order.ParentOrderIDs.length > 0) {
                if (Order.ParentOrderIDs.indexOf(',') > 0) {
                    var parentOrderIDs = Order.ParentOrderIDs.split(',');
                    _.each(parentOrderIDs, function (IDs) {
                        compOrderIndex = _.findIndex(OrderList, { 'OrderID': IDs });

                        if (compOrderIndex != -1) {
                            OrderList[compOrderIndex].HasComparison = OrderList[compOrderIndex].HasComparison == "0" ? "1" : OrderList[compOrderIndex].HasComparison;
                            if (OrderList[compOrderIndex].ComparisonOrder && OrderList[compOrderIndex].ComparisonOrder.length > 0) {
                                OrderList[compOrderIndex].ComparisonOrder.push(Order);
                            } else {
                                var comparisonOrder = [];
                                comparisonOrder.push(Order);
                                OrderList[compOrderIndex].ComparisonOrder = comparisonOrder;
                            }
                        }
                    });

                } else {
                    compOrderIndex = _.findIndex(OrderList, { 'OrderID': Order.ParentOrderIDs });

                    if (compOrderIndex != -1) {
                        OrderList[compOrderIndex].HasComparison = OrderList[compOrderIndex].HasComparison == "0" ? "1" : OrderList[compOrderIndex].HasComparison;
                        if (OrderList[compOrderIndex].ComparisonOrder && OrderList[compOrderIndex].ComparisonOrder.length > 0) {
                            OrderList[compOrderIndex].ComparisonOrder.push(Order);
                        } else {
                            var comparisonOrder = [];
                            comparisonOrder.push(Order);
                            OrderList[compOrderIndex].ComparisonOrder = comparisonOrder;
                        }
                    }
                }

                return true;
            }

            return false;
        }

        function updateRefreshDOSInterval() {
            ////$log.log("updateRefreshDOSInterval ", new Date());
            var now = new Date();
            $scope.currentDate.setDate(now.getDate() + 1);
            $scope.currentDate.setHours(0, 0, 0, 0);
            //$scope.currentDate = new Date(now.getTime() + 3 * 60000);
            refreshDOSInterval = $scope.currentDate.getTime() - now.getTime();
        }

        function openSynapseImage(pacsURL, accessionNumber) {
            RCService.OpenImage({ requestEvent: "openimage", imageRequestDetails: { pacsURL: pacsURL, accessionNumber: accessionNumber } })
        }
        function openPS360(Order) {
            $scope.isPSManualOpen = true;
            $scope.pendingPSAccession = Order.Accession;
            RCService.OpenReport({ requestEvent: "openreport", reportRequestDetails: { siteName: Order.PSSiteName, accessionNumber: Order.Accession } })
        }
        function closePS360(Order) {
            RCService.CloseReport({ requestEvent: "closereport", reportRequestDetails: { siteName: Order.PSSiteName, accessionNumber: Order.Accession } })
        }

        function updatePageSize() {
            ////$log.log("updatePageSize ", new Date());
            var height = $(window).height();
            $scope.PageSize = 50;

            if (height < 1000) {
                $scope.PageSize = 50;
            } else if (height > 1000) {
                $scope.PageSize = 100;
            }

        }

        function setHeight() {
            ////$log.log("setHeight ", new Date());
            var height = $(window).height();
            currentHeight = height;
        }

        function validateOrders(Orders) {
            ////$log.log('validateOrders');
            _.each(Orders, function (order) {
                var OrderIndex = OrderExists(order.OrderID);
                if (OrderIndex == -1
                    && validateSite(order.SiteID)
                    && checkOrderFilters(order)
                    && validatePendingOrder(order)
                    && !order.isComparisonOrder
                    && !isComparisonOrder(order)) {
                    //////////$log.log("ProcessedOrdersUpdate > OrderList: ", OrderList);
                    order.FormattedOrderDate = $filter('date')(order.OrderDate, "M/d/yy HH:mm");
                    order.FormattedPatientDOB = $filter('date')(order.PatientDOB, "M/d/yy");
                    order.RowColorCode = $scope.getRowTemplateColorCode(order);
                    OrderList.push(order);
                    updateOrderList(order);

                } if (OrderIndex != -1
                    && !order.isComparisonOrder) {
                    if (checkOrderFilters(order)
                        && validatePendingOrder(order)) {

                        order.FormattedOrderDate = $filter('date')(order.OrderDate, "M/d/yy HH:mm");
                        order.FormattedPatientDOB = $filter('date')(order.PatientDOB, "M/d/yy");
                        order.RowColorCode = $scope.getRowTemplateColorCode(order);

                        OrderList[OrderIndex] = order;

                        sortByField();

                        $scope.orderList = OrderList;
                    } else {
                        removeOrderFromList(order.OrderID);
                    }
                } else {
                    isComparisonOrder(order)
                }
            });
            OrderProcessed = true;
        }

        function updateWindowHeight() {
            $scope.defaultWindowHeight = "80%";
            $timeout(function () {
                if ($scope.win_Discussion) {
                    SetWindowOptions($scope.win_Discussion, 'win_Discussion', { height: $scope.defaultWindowHeight });
                }
                if ($scope.win_ModalReportNDiscuss) {
                    SetWindowOptions($scope.win_ModalReportNDiscuss, 'win_ModalReportNDiscuss', { height: $scope.defaultWindowHeight });
                }
                if ($scope.win_ComparisonOrderReports) {
                    SetWindowOptions($scope.win_ComparisonOrderReports, 'win_ComparisonOrderReports', { height: $scope.defaultWindowHeight });
                }
            }, 100);


        }

        function updateContactWindow() {
            $timeout(function () {
                if ($scope.contactList.length > 0) {
                    if ($(window).width() < 1199) {
                        $scope.orderingPhysicianWindowHeight = "70%";
                    } else {
                        $scope.orderingPhysicianWindowHeight = "80%";
                    }

                } else {
                    if ($(window).width() < 1199) {
                        $scope.orderingPhysicianWindowHeight = "25%";
                    } else {
                        $scope.orderingPhysicianWindowHeight = "20%";
                    }
                }
                //SetWindowOptions($scope.win_ContactList, 'win_ContactList', { height: $scope.orderingPhysicianWindowHeight });
                $scope.win_ContactList.center();
            }, 100);
        }

        $scope.onChangeAutoRefresh = function () {
            var userPref = { version: columnVersion, columnDefs: $scope.uiGridOptions.columnDefs, AutoRefresh: $scope.AutoRefresh, SortColumns: SortColumns };
            updateUserLayoutPreference(userPref);
        }

        function getSortingString(sColumnField, direction) {
            ////$log.log("getSortingString ", new Date());
            var orderByField = '';
            switch (sColumnField) {
                case "Location":
                    orderByField = "L.Location";
                    break;
                case "Accession":
                    orderByField = "O.Accession";
                    break;
                case "OrderDate":
                    orderByField = "O.OrderDate";
                    break;
                case "PatientMRN":
                    orderByField = "O.PatientMRN";
                    break;
                case "PatientName":
                    orderByField = "O.PatientLastName|O.PatientFirstName";
                    break;
                case "FormattedPatientDOB":
                    orderByField = "O.PatientDOB";
                    break;
                case "PatientGender":
                    orderByField = "O.PatientGender";
                    break;
                case "PatientAge":
                    orderByField = "O.PatientDOB";
                    break;
                case "PatientClass":
                    orderByField = "O.PatientClass";
                    break;
                case "Modality":
                    orderByField = "O.Modality";
                    break;
                case "ProcedureDesc":
                    orderByField = "O.ProcedureDesc";
                    break;
                case "OrderingPhysician":
                    orderByField = "P.Name";
                    break;
                case "CreatedDate":
                    orderByField = DefaultSortingColumn;
                    break;
                case "Reason":
                    orderByField = 'O.Reason';
                    break;
                case "ReportSignDate":
                    orderByField = 'R1.SignDate';
                    break;
                default:
                    orderByField = sColumnField;
                    break;
            }

            if (orderByField.indexOf('|') > 0) {
                var fields = orderByField.split('|');
                _.each(fields, function (field) {
                    SortingByMultiColumn += field + ' ' + direction + ', ';
                });
            } else {
                SortingByMultiColumn += orderByField + ' ' + direction + ', ';
            }
        }

        function sorting(sortColumns) {
            ////$log.log("sorting ", new Date());
            SortColumns = [];
            SortingByMultiColumn = '';
            if (sortColumns) {
                _.each($scope.uiGridOptions.columnDefs, function (sColumn, index) {


                    var columnDefIndex = _.findIndex(sortColumns, { 'field': sColumn.name });
                    if (columnDefIndex >= 0) {
                        $scope.uiGridOptions.columnDefs[index].sort = sortColumns[columnDefIndex].sort;
                        var SortColumn = {
                            field: sortColumns[columnDefIndex].field, sort: sortColumns[columnDefIndex].sort
                        };
                        SortColumns.push(SortColumn);

                        getSortingString(sortColumns[columnDefIndex].field, sortColumns[columnDefIndex].sort.direction);
                    } else {
                        $scope.uiGridOptions.columnDefs[index].sort = {};
                    }


                });
                SortingByMultiColumn = SortingByMultiColumn.substring(0, SortingByMultiColumn.lastIndexOf(','));
            } else {
                _.each($scope.uiGridOptions.columnDefs, function (sColumn, index) {


                    if (sColumn.name == 'CreatedDate') {
                        $scope.uiGridOptions.columnDefs[index].sort = { direction: uiGridConstants.ASC, priority: 0 };

                        var SortColumn = {
                            field: $scope.uiGridOptions.columnDefs[index].name, sort: $scope.uiGridOptions.columnDefs[index].sort
                        };
                        SortColumns.push(SortColumn);

                        getSortingString($scope.uiGridOptions.columnDefs[index].name, $scope.uiGridOptions.columnDefs[index].sort.direction);

                        SortingByMultiColumn = SortingByMultiColumn.substring(0, SortingByMultiColumn.lastIndexOf(','));

                    } else {
                        $scope.uiGridOptions.columnDefs[index].sort = {};
                    }


                });

                var userPref = { version: columnVersion, columnDefs: $scope.uiGridOptions.columnDefs, SortColumns: SortColumns };
                updateUserLayoutPreference(userPref);
            }

        }

        $scope.NoContextMenuOptions = function (Order) {
            var hasMenu = false;

            if (Order.Status == 'C' || Order.Status == 'D' || Order.Status == 'OP' || Order.IsLock || (Order.OrderAssingedUsers > 0 && !Order.OrderAssingedUser)) {
                hasMenu = true;
            }
            // commented : this code for show Consult with Physician context menu for all the status
            else {
                hasMenu = true;
            }
            if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles && ($sessionStorage.currentUserData.userRoles.includes("SuperAdmin") || $sessionStorage.currentUserData.userRoles.includes("Admin"))) {
                hasMenu = true;
            }
            if (Order.Status == 'CO' || Order.Status == 'H') {
                hasMenu = true;
            }
            if (Order.IsLock) {
                hasMenu = true;
            }
            if (Order.DicomViewer) { hasMenu = true };


            return hasMenu;
        }

        function validateDOS(Alert) {
            if ($scope.Status.key == 'AL') {
                if (!$scope.OrderDate.startDate && !$scope.OrderDate.endDate) {
                    if (Alert) toaster.warning({ body: "Please select the DOS." });
                    return false;
                }

                var DaysDifferent = moment(($scope.OrderDate.endDate)).diff(moment($scope.OrderDate.startDate), 'days');
                if (DaysDifferent > 366) {
                    if (Alert) toaster.warning({ body: "Please select the DOS that is max one year." });
                    return false;
                }
            }
            return true;
        }

        function getPrefLookups(WorklistPrefrence) {
            var d = $q.defer();
            if (WorklistPrefrence != null && WorklistPrefrence.Lookups && WorklistPrefrence.Lookups.length > 0) {
                $scope.StudyPriorities = _.filter(WorklistPrefrence.Lookups, { Type: 'StudyPriority' });
                $scope.StudyPriorities = _.orderBy($scope.StudyPriorities, ['Value'], ['ASC']);
                $scope.DelayStatColorCode = _.find(WorklistPrefrence.Lookups, { Type: 'DelayedStatColorCode' });
                $scope.DicomViewers = _.filter(WorklistPrefrence.Lookups, { Type: 'DicomViewer' });
                HiddenTypesTooltip = _.filter(WorklistPrefrence.Lookups, { Type: 'HiddenTypesTooltip' });
                $scope.HiddenTypeList = _.sortBy(_.filter(WorklistPrefrence.Lookups, function (type) {
                    if (type.Type == 'HiddenTypes' && type.Value != '0') {
                        type.tooltip = _.find(HiddenTypesTooltip, { Key: type.Key }).Value;
                    }
                    return type.Type == 'HiddenTypes' && type.Value != '0';
                }), ['Value']);
                $scope.HideOption.Key = $scope.HiddenTypeList[0].Key;
                $scope.PatientClass = _.filter(WorklistPrefrence.Lookups, { Type: 'PatientClass' });
                d.resolve();
            }
            return d.promise;
        }

        function visiblePriorityDD() {
            $scope.HideStudyPriority = true;
            if ($scope.Status.key == 'RP') {
                $scope.HideStudyPriority = false;
            }
        }

        function validatePendingOrder(order) {
            var validated = false;
            if ($scope.Status.key == 'OP') {
                if (order.HasImage && !order.HasORM) {
                    validated = true;
                } else if (order.HasImage && order.HasORM) {
                    validated = false;
                }
            } else {
                validated = true;
            }

            return validated;
        }

        function getPrefRules(WorklistPrefrence) {
            var d = $q.defer();
            if (WorklistPrefrence != null && WorklistPrefrence.Rules && WorklistPrefrence.Rules.length > 0) {
                ClipboardRule = _.find(WorklistPrefrence.Rules, { WorklistType: 16 });
                _.each(WorklistPrefrence.Rules, function (worklistItem) { worklistItem.Type = 'A'; worklistItem.isAdmin = ($sessionStorage.currentUserData.userRoles.includes('SuperAdmin') || $sessionStorage.currentUserData.userRoles.includes('Admin')) ? true : false; });
                $scope.GlobalRules = _.filter(WorklistPrefrence.Rules, function (grule) { return grule.WorklistType == 21 || grule.WorklistType == 16 });
                WorklistPrefrence.Rules = _.filter(WorklistPrefrence.Rules, function (rule) {
                    if (!rule.WorkListName) {
                        rule.WorkListName = rule.RuleName;
                    }
                    return rule.WorklistType == 0 && rule.IsEnabled;
                });
                $scope.WorkLists = WorklistPrefrence.Rules;

                for (var i = 0; i < $scope.WorkLists.length; i++) {
                    $scope.WorkLists[i].role = $scope.userRole;
                    $scope.WorkLists[i].index = i;
                    $scope.WorkLists[i].LoggedInUserID = $sessionStorage.currentUserData.userId;
                }

                $scope.loadWorklistDropdown();

                d.resolve();
            } else {
                $scope.WorkLists = [];
                $scope.loadWorklistDropdown();
                d.resolve();
            }
            return d.promise;
        }

        $scope.onEditWorklist = function (ruleid) {
            //$log.log("onEditWorklist");
            var worklistIndex = _.findIndex($scope.WorkLists, { RuleID: ruleid });
            var objWorklist = _.omit($scope.WorkLists[worklistIndex], ['RulesConditions', 'Groups'
            ]);
            $scope.Rule = objWorklist;
            //$log.log("onEditWorklist > $scope.Rule: ", $scope.Rule);
            $scope.SelectedRuleIndex = worklistIndex;
            $scope.RuleTable = RuleSharedService.ReSetMasterData();
            $scope.ModalWorklistOpened = true;
            angular.element('#ModalEditWorkList').modal('show');
        }

        $scope.onDeleteWorklist = function (ruleid) {
            //////$log.log("onDeleteWorklist");
            var worklistIndex = _.findIndex($scope.WorkLists, { RuleID: ruleid });
            var rule = $scope.WorkLists[worklistIndex];
            swal({
                title: "Are you sure you want to delete this worklist?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#6A9944",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: false,
                showCloseButton: true
            },
                function (isConfirm) {
                    if (isConfirm) {
                        swal.close();
                        $q.all([
                            RuleSharedService.DeleteRule(rule)
                        ]).then(function (data) {
                            _.remove($scope.WorkLists, function (n) {
                                return n.RuleID == rule.RuleID;
                            });
                            _.remove($scope.SelectedWorkList, function (n) {
                                return n.RuleID == rule.RuleID;
                            });
                            setWorklisttooltip();
                            setSelectedWorklistFilterSettings();

                            var dropdowntree = $("#worklistDropdownTree").data("kendoDropDownTree");
                            if (dropdowntree) {
                                var dataSource = new kendo.data.HierarchicalDataSource({
                                    data: $scope.WorkLists
                                });
                                dropdowntree.setDataSource(dataSource);
                            }

                        });
                    }
                }
            );
        }

        function getOrderStatus() {
            $scope.OrderStatus = WorklistService.GetOrderStatus();
        }

        function OpenWindow(win, key) {
            if (win) {
                win.open();
                $timeout(function () {
                    win.center();
                }, 100);
            } else {
                var dialog = $("div[kendo-window='" + key + "']").data("kendoWindow");
                if (dialog) {
                    dialog.open();
                    $timeout(function () {
                        dialog.center();
                    }, 100);
                }
            }

        }

        function SetWindowOptions(win, key, options) {
            if (win) {
                win.setOptions(options);
            } else {
                var dialog = $("div[kendo-window='" + key + "']").data("kendoWindow");
                if (dialog) dialog.setOptions(options);
            }
        }

        //Function to Open Share Exam popup kendo window(onClick of context menu-share Exams)
        $scope.openShareExamWindow = function () {
            $scope.currentWindow = 'win_shareExamsWindow';
            OpenWindow($scope.win_shareExamsWindow, 'win_shareExamsWindow');
            $scope.win_shareExamsWindow.wrapper.prev(".k-overlay").addClass("custom-overlay");
        };
        //Close onClick of send message button from shareExamchat.js
        $scope.onCloseShareExamWindowHandler = function (newCheck) {
            $scope.isShareExamWindowVisible = newCheck;
            if ($scope.isShareExamWindowVisible == true) {
                $scope.win_shareExamsWindow.close();
            }
        };

        function GetPriorReportsByPatientMRN(OrderID, PatientMRN, SiteID) {
            var d = $q.defer();
            var jObject = {
                OrderID: OrderID,
                PatientMRN: PatientMRN,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: SiteID
            }

            WorklistService.GetPriorReportsByPatientMRN(jObject).then(function (results) {
                d.resolve(results);
            });
            //}
            //else {
            //    return null;
            //}
            return d.promise;
        }

        $scope.CloseWorklistModal = function () {
            $scope.ModalWorklistOpened = false;
        }
        $scope.SetDicomViewerText = function (DV) {
            var viewer = _.filter($scope.DicomViewers, { "Value": DV });
            if (viewer != null && viewer.length > 0) {
                return viewer[0].Key
            }
        }
        $scope.getUserPayments = function () {
            $state.go('payment-dashboard');
        }
        // Removed dead invoice-printing code that wrote raw HTML into a popup window (Aikido XSS finding) -
        // it was unreachable since getUserPayments returns before ever calling it, and it was
        // itself entirely commented out already.
        function GetStatusCount() {
            var data = {
                userid: $sessionStorage.currentUserData.userId,
                StartDateTime: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "00:00")),
                EndDateTime: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")),
            };
            WorklistService.GetStatusCount(data).then(function (response) { $scope.WorklistPageHeaderParameter.SignedToday = response.SignedToday; $scope.WorklistPageHeaderParameter.Charges = response.UserPayment; });
        }

        function openMedDream(order) {
            SharedService.openMedDreamCommunicationAPI(order, '');
        }

        //Old-worklist tour
        var oldWorklistTour = new Tour({
            steps: [
                {
                    element: "#worklistToggle",
                    content: "Explore the updated worklist by clicking here",
                    backdropPadding: 1,
                    title: "Try New Worklist",
                    placement: 'left',
                    delay: 300,
                    template: "<div class='popover dt-WorklistPan tour hca-tooltip--left-nav w-340px'><div class='arrow'></div><div class='row p-2 step-header m-0'><div class='col-sm-11 pl-2 pr-0'><p class='popover-title p-0'></p></div><div class='col-sm-1 pr-0'><div data-role='end' class='close'><i class='glyphicon glyphicon-remove tour-close'></i></div></div></div><div class='row m-0'><div class='col-sm-12 px-0'><p class='popover-content'></p></div></div><div class='row m-0'><div class='col-md-12 px-0'><button class='btn m-1 tour-nxt-btns btn-primary px-2 py-0 float-right' data-role='end'>Done <i class='fa fa-check fs-12px pl-1'></i></button></div></div></div>"
                }
            ],
            backdrop: true,
            onShown: function (oldWorklistTour) {
                var step = oldWorklistTour._options.steps[oldWorklistTour._current];
                $(step.element).addClass('tour-section-disbl');
            },
            onHidden: function (oldWorklistTour) {
                var step = oldWorklistTour._options.steps[oldWorklistTour._current];
                $(step.element).removeClass('tour-section-disbl');
            },
        });



        function showHideUserGuide() {
            if (!$localStorage.oldWorklistTourSeen) {
                // Initialize the tour
                oldWorklistTour.init();

                $timeout(function () {
                    oldWorklistTour.setCurrentStep(0);
                    oldWorklistTour.start(true);
                    $localStorage.oldWorklistTourSeen = true;
                }, 500)
            }
        }
        $scope.clearCommentBox = function () {
            $scope.HideOption.Comments = '';
        }


        $scope.updateAddressBookLocationData = function () {
            //$log.log("updateLocationData > on: ", new Date());
            if ($scope.SelectedAddressBookLocationValues.SelectedItems && $scope.SelectedAddressBookLocationValues.SelectedItems.length > 0) {
                var locations = [];
                var locationIds = [];
                _.each($scope.SelectedAddressBookLocationValues.SelectedItems, function (data) {
                    var filter = _.find($scope.Locations, function (item) { return item.LocationID == data.value; });
                    if (filter != null) {
                        locations.push(filter);
                        locationIds.push(filter.LocationID);
                    }
                });
                $scope.AddressBookInfo.SelectedData.Location = locations;
                $scope.AddressBookInfo.SelectedData.LocationIDs = _.join(locationIds, ',');
            } else {
                $scope.AddressBookInfo.SelectedData.Location = [];
                $scope.AddressBookInfo.SelectedData.LocationIDs = '';
            }
        }

        $scope.updateSelectedLocation = function () {
            $scope.SelectedList.Location = $scope.SelectedLocations.locations;
            $scope.locationIDs = $scope.SelectedLocations.Ids;
            if ($scope.SelectedList.Location && $scope.SelectedList.Location.length > 0) {
                $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', ' transition: height 0.5s !important;');
                $('.anui').addClass("set-location-height");
            }
            else {
                $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 0.5s !important;');
                $('.anui').removeClass("set-location-height");
            }
        }

        function getOrderByAccessionNPSSiteName(Accession, PSSiteName) {
            return _.find(OrderList, function (obj) {
                return obj.Accession.toLowerCase().trim() == Accession.toLowerCase().trim() && obj.PSSiteName.toLowerCase().trim() == PSSiteName.toLowerCase().trim();
            });
        }

        function getLoadMoreWorklistPreference() {
            var d = $q.defer();
            if ($state.current.name == "worklist") {
                UserPreferenceService.GetUserPreferences({
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceType: 'LoadMoreWorklist',
                }).then(function (result) {
                    if (result != null && result.UserPreferences != null) {
                        loadMoreWorklist = _.find(result.UserPreferences, { PreferenceType: "LoadMoreWorklist" });
                        if (result.UserAccountDetails.IsPaymentContractEnabled) {
                            $scope.WorklistPageHeaderParameter.isPCAvailable = true;
                        }
                    }
                    d.resolve();
                });
            } else {
                d.resolve();
            }
            return d.promise;
        }

        function setLoadMoreWorklistPreference() {
            var d = $q.defer();
            if ($state.current.name == "worklist" && loadMoreWorklist != null && loadMoreWorklist.PreferenceValue && loadMoreWorklist.PreferenceValue != "0") {
                loadMoreWorklist.PreferenceValue = "0";
                UserPreferenceService.AddEditUserPreferences([{
                    UserPreferenceID: loadMoreWorklist.UserPreferenceID ? loadMoreWorklist.UserPreferenceID : "-1",
                    PreferenceType: "LoadMoreWorklist",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: loadMoreWorklist.PreferenceValue,
                }]).then(function (result) {
                    $localStorage.LoadMoreWorklist = loadMoreWorklist.PreferenceValue;
                    d.resolve();
                });
            } else {
                d.resolve();
            }
            return d.promise;
        }

        function VerifyOpenOrder(OpenOrder) {
            if (OpenOrder.ClipboardDetailResult && OpenOrder.ClipboardDetailResult.length > 0) {
                if (!confirm('This study is already assigned to the "' + OpenOrder.ClipboardDetailResult[0].UserName + '\'s" clipboard. \nDo you still wish to continue reading the study?')) {
                    return;
                }
                else {
                    var obj = { OrderID: $scope.SingReport.Order.OrderID, UserID: $scope.LoggedInUserID, RuleID: OpenOrder.ClipboardDetailResult[0].RuleID };
                    RemoveFromClipboardRule(obj);
                    WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                }
            }
            if ($scope.SingReport.Order.OrderAssingedUsers > 0 && (!$scope.SingReport.Order.OrderAssingedUser || $scope.SingReport.Order.OrderAssingedUser != null)) {
                var UserName = $scope.getOrderListTooltip($scope.SingReport.Order);
                if (UserName && UserName != null && !confirm('This study is already ' + UserName.replace("Assigned to", "assigned to") + ', \nDo you still wish to continue reading the study?')) {
                    return;
                }
            }
            if (OpenOrder.VerifyReadStudyResult.openOrders && OpenOrder.VerifyReadStudyResult.openOrders.length > 0) {
                if ($scope.ChooseNextStudy) {
                    //if (!confirm("This order is locked by " + result.openOrders[0].ProviderName + ".\nAre you sure do you want to proceed any way?")) {
                    //if (!confirm("This order is presently being dictated by user " + result.openOrders[0].ProviderName + ".\nCaution: Proceeding will create another report.")) {
                    //    return;
                    //}
                    //else {
                    //    //$scope.Call_SetSignREportModal();
                    //    return;
                    //}
                    confirm("This order is presently being dictated by user " + OpenOrder.VerifyReadStudyResult.openOrders[0].ProviderName + ".\nCaution: Proceeding will create another report.");
                    return;

                }
                else {
                    //var cnf = confirm("This order is locked by " + result.openOrders[0].ProviderName + ".\nAre you sure you want to skip?");
                    var cnf = confirm("This order is presently being dictated by user " + OpenOrder.VerifyReadStudyResult.openOrders[0].ProviderName + ".\nAre you sure you want to skip?");
                    if (cnf == true) {
                        $scope.NextRec();
                    } else {
                        return;
                    }
                }
            }
            if (OpenOrder.VerifyReadStudyResult.reportView && OpenOrder.VerifyReadStudyResult.reportView.ReportStatus == 2 && OpenOrder.VerifyReadStudyResult.reportView.SignBy != $scope.LoggedInUserID) {
                if (!confirm('This order has been drafted by user ' + OpenOrder.VerifyReadStudyResult.reportView.SignByName + '.\nAre you sure you want to proceed?')) {
                    return;
                }
            }
            $scope.Call_SetSignREportModal();
        }

        function VerfiyReadStudy(OrderID, ProviderID, data) {
            var d = $q.defer();
            var openOrders = {
                OrderId: OrderID,
                ProviderID: ProviderID
            };
            WorklistService.VerfiyReadStudy(openOrders).then(function (result) {
                OpenOrder.VerifyReadStudyResult = result;
                d.resolve();
            });
            return d.promise;
        }

        function GetClipboardDetailByOrderID(OrderID) {
            var d = $q.defer();
            if ($scope.SingReport.Order.IsInClipboard && $scope.SingReport.Order.IsInClipboard == 1) {
                WorklistService.GetClipboardDetailByOrderID(OrderID).then(function (result) {
                    OpenOrder.ClipboardDetailResult = result;
                    d.resolve();
                });
            }
            else {
                d.resolve();
            }
            return d.promise;
        }

        function RemoveOrderIDFromClipboard(Rule, OrderID) {
            var RuleConditionOrderID = {};
            if (Rule.Groups && Rule.Groups.length > 0) {
                _.each(Rule.Groups, function (grp) {
                    RuleConditionOrderID = _.find(grp.RulesConditions, { ColumnName: "ORDERS.OrderID" });
                });
                if (RuleConditionOrderID && RuleConditionOrderID.Value) {
                    var OrderIDs = RuleConditionOrderID.Value.split(',');
                    var removedOrderIDs = _.remove(OrderIDs, function (orderid) { return orderid == OrderID });
                    if (removedOrderIDs.length > 0) {
                        if (OrderIDs.length > 0) {
                            RuleConditionOrderID.Value = _.join(OrderIDs, ',');
                            RuleConditionOrderID.StatusFlag = 'M';
                        }
                        else {
                            RuleConditionOrderID.Value = "";
                            RuleConditionOrderID.StatusFlag = 'D';
                        }
                        _.each(Rule.Groups, function (grp) {
                            _.each(grp.RulesConditions, function (condition) {
                                if (condition.ColumnName == "ORDERS.OrderID") {
                                    condition = RuleConditionOrderID;
                                }
                                else {
                                    condition.StatusFlag = RuleConditionOrderID.StatusFlag;
                                    if (condition.StatusFlag == 'D' && condition.ColumnName == "ORDERS.OrderDate") {
                                        condition.OrderDate = {
                                            startDate: null,
                                            endDate: null
                                        };
                                        condition.Value = "";
                                    }
                                }
                            });
                            grp.GroupOperator = "AND";
                        });
                        RuleSharedService.SetRule(Rule).then(function (result) {
                            removeOrderFromList(OrderID);
                            RuleSharedService.RemoveOrderIDFromRuleTable(RuleTable);
                        });
                    }

                }
            }

        }

        function UpdateOrderDetail(obj, message) {
            WorklistService.UpdateOrderDetail(obj).then(function () {
                toaster.success({ body: message });
            });
        }

        function RemoveFromClipboardRule(data) {
            var Rule = { RuleID: data.RuleID };

            RuleSharedService.UpdateRuleTable(RuleTable);
            RuleSharedService.GetRuleDetails(Rule, "Clipboard").then(function (result) {
                if (result.Rule) {
                    RuleSharedService.SetData(RuleTable);
                    Rule = result.Rule;
                    RemoveOrderIDFromClipboard(Rule, data.OrderID);
                }

            });
        }

        function setSelectedUserAssignment(usergroups) {
            ////$log.log("setSelectedWorklistFilterSettings: " + new Date());
            var ddt = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            if (ddt) {
                ddt.value(usergroups);
            } else {
                $timeout(function () {
                    setSelectedUserAssignment(usergroups);
                }, 100);
            }
        }

        $scope.FilterReportList = function () {
            var FilteredList = ReportList;
            var startDate, endDate = null;
            if ($scope.PriorReportFilter.Options.DateRange != 'Any') {
                switch ($scope.PriorReportFilter.Options.DateRange) {
                    case '6m':
                        startDate = new Date(moment().subtract(6, 'month'));
                        endDate = new Date(moment());
                        break;
                    case '1y':
                        startDate = new Date(moment().subtract(1, 'year').add(1, 'days'));
                        endDate = new Date(moment());
                        break;
                    case '2y':
                        startDate = new Date(moment().subtract(2, 'year'));
                        endDate = new Date(moment());
                        break;
                    case '5y':
                        startDate = new Date(moment().subtract(5, 'year'));
                        endDate = new Date(moment());
                        break;
                }
                FilteredList = _.filter(FilteredList, function (report) {
                    var itemDate = new Date(report.OrderDate);
                    return itemDate >= startDate && itemDate <= endDate;
                });
            }
            if ($scope.PriorReportFilter.Options.Modality != 'All') {
                FilteredList = _.filter(FilteredList, { 'Modality': $scope.PriorReportFilter.Options.Modality });
            }
            if ($scope.PriorReportFilter.Options.SearchText != '') {
                var result = _.filter(FilteredList, function (item) {
                    return _.some(['OrderDate', 'ProcedureDesc', 'SignByName'], function (key) {
                        if (key == 'OrderDate') {
                            return moment(_.get(item, key, '')).format('MM/DD/YYYY').toString().toLowerCase().includes($scope.PriorReportFilter.Options.SearchText.toLowerCase());
                        }
                        else {
                            var value = _.get(item, key, '');
                            if (value) {
                                return value.toString().toLowerCase().includes($scope.PriorReportFilter.Options.SearchText.toLowerCase());
                            }
                        }
                        return false;
                    });
                });
                if (result) { FilteredList = result; }
            }
            $scope.reportList = FilteredList;
            if ($scope.reportList && $scope.reportList.length > 0) {
                var objSelectedReport = $scope.reportList[$scope.reportList.length - 1];
                if (objSelectedReport) {
                    $scope.SelectedOrderAccession = objSelectedReport.Accession;
                    LoadReport(objSelectedReport.OrderID);
                }
            }
        }
        $scope.onClearFilterReportList = function (ClearFlag) {
            $scope.PriorReportFilter.SortingOption = 'DOS (newest first)';
            $scope.PriorReportFilter.SortingPropName = 'OrderDate';
            $scope.PriorReportFilter.SortingOrder = true;
            if (ClearFlag) {
                $scope.PriorReportFilter.List.Modalities = ['All'];
                $scope.PriorReportFilter.Modal = false;
            }
            $scope.PriorReportFilter.Options = { DateRange: 'Any', Modality: 'All', SearchText: '' };
        }
        $scope.onReportSortingClicked = function (sortingOption) {
            $scope.PriorReportFilter.SortingOption = sortingOption;
            var ReportListElement = document.getElementsByClassName('repoHeiFtrWrklst ftlrbtns-height');
            if (ReportListElement && ReportListElement[0] && ReportListElement[0].scrollTop > 0) {
                ReportListElement[0].scrollTop = 0;
            }
            switch (sortingOption) {
                case 'DOS (newest first)':
                    $scope.PriorReportFilter.SortingPropName = 'OrderDate';
                    $scope.PriorReportFilter.SortingOrder = true;
                    break;
                case 'DOS (oldest first)':
                    $scope.PriorReportFilter.SortingPropName = 'OrderDate';
                    $scope.PriorReportFilter.SortingOrder = false;
                    break;
                case 'Rendering Physician (A to Z)':
                    $scope.PriorReportFilter.SortingPropName = 'SignByName';
                    $scope.PriorReportFilter.SortingOrder = false;
                    break;
                case 'Rendering Physician (Z to A)':
                    $scope.PriorReportFilter.SortingPropName = 'SignByName';
                    $scope.PriorReportFilter.SortingOrder = true;
                    break;
                case 'Procedure (A to Z)':
                    $scope.PriorReportFilter.SortingPropName = 'ProcedureDesc';
                    $scope.PriorReportFilter.SortingOrder = false;
                    break;
                case 'Procedure (Z to A)':
                    $scope.PriorReportFilter.SortingPropName = 'ProcedureDesc';
                    $scope.PriorReportFilter.SortingOrder = true;
                    break;
            }
        }

        function prepareOrderDiscussionUsers() {
            var selectedUsers = [];
            _.each($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (selectedRadiologistGroup) {
                if (selectedRadiologistGroup && selectedRadiologistGroup.Group && selectedRadiologistGroup.Group == "YES") {

                    var specialities = _.filter(specialityAssignments, { SpecialityId: selectedRadiologistGroup.Id });
                    _.each(specialities, function (speciality) {
                        var user = _.find($scope.Radiologists, { Id: speciality.UserId });
                        if (user) {
                            user.IsUserWithSpecialityGroup = 0;
                            user.SpecialityCode = speciality.SpecialityCode;
                            user.SpecialityCodeDesc = speciality.SpecialityCodeDesc;
                            user.SpecialityGroup = speciality.SpecialityGroup;
                            user.SpecialityId = speciality.SpecialityId;
                            var selectedUserIndex = _.findIndex(selectedUsers, function (auser) {
                                return auser.Id == user.Id
                                    && auser.IsUserWithSpecialityGroup == 0;
                            });
                            var selectedUserBySpecialityIndex = _.findIndex(selectedUsers, function (auser) {
                                return auser.Id == user.Id
                                    //&& auser.SpecialityId > 0
                                    //    && user.SpecialityId > 0
                                    && auser.SpecialityId != user.SpecialityId;
                            });

                            if (selectedUserIndex != -1 && selectedUserBySpecialityIndex == -1) {
                                selectedUsers[selectedUserIndex].IsUserWithSpecialityGroup = 1;
                                user.IsUserWithSpecialityGroup = 1;
                            } else if (selectedUserBySpecialityIndex != -1) {
                                selectedUsers[selectedUserBySpecialityIndex].IsUserWithSpecialityGroup = 3;
                                user.IsUserWithSpecialityGroup = 3;
                            }
                            selectedUsers.push(_.clone(user));
                        }

                    });

                } else {
                    var user = _.find($scope.Radiologists, function (user) { return user.Id == selectedRadiologistGroup.Id; });
                    if (user) {
                        user.IsUserWithSpecialityGroup = 2;
                        var selectedUserIndex = _.findIndex(selectedUsers, function (auser) {
                            return auser.Id == user.Id
                                && auser.IsUserWithSpecialityGroup == 0;
                        });
                        var selectedUserBySpecialityIndex = _.findIndex(selectedUsers, function (auser) {
                            return auser.Id == user.Id
                                //&& auser.SpecialityId > 0
                                //&& user.SpecialityId > 0
                                && auser.SpecialityId != user.SpecialityId;
                        });
                        if (selectedUserIndex != -1 && selectedUserBySpecialityIndex == -1) {
                            selectedUsers[selectedUserIndex].IsUserWithSpecialityGroup = 1;
                            user.IsUserWithSpecialityGroup = 1;
                        } else if (selectedUserBySpecialityIndex != -1) {
                            selectedUsers[selectedUserBySpecialityIndex].IsUserWithSpecialityGroup = 3;
                            user.IsUserWithSpecialityGroup = 3;
                        }
                        selectedUsers.push(_.clone(user));
                    }

                }
            });
            return selectedUsers;
        }

        function GetUserPaymentHeader() {
            var startDate = moment(moment().format("YYYY-MM-DD") + ' ' + "00:00");
            var endDate = moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59");
            PaymentContractService.GetUserPaymentHeader({
                UserID: $sessionStorage.currentUserData.userId,
                StartDate: $filter('CSTDateTime')(startDate),
                EndDate: $filter('CSTDateTime')(endDate),
            }).then(function (result) {
                $scope.WorklistPageHeaderParameter.Charges = 0;
                if (result) {
                    $scope.WorklistPageHeaderParameter.Charges = result.TotalEarnings;
                }
            });
        }

    }


})();




(function () {
    'use strict';

    angular.module('radico.pages.worklistLite').controller('WorklistAsyncController', WorklistAsyncController);

    function WorklistAsyncController($scope, $q, WorklistService, $state, $sessionStorage, $interval, $localStorage, APP_CONSTANTS, AppHubService, $filter, $timeout, Notification, windowHandler, $log, RCService, uuidv4, RuleSharedService, toaster, $compile, UserPreferenceService, UserLayoutPrefService, $rootScope, __env, PaymentContractService, CommonService, $stateParams, SharedService, ManageLocationService) {

        if ($sessionStorage.ShowModalIESettings) {
            $state.go('iewarning');
            return;
        }
        windowHandler.inIt();
        var AppHub;
        var isOrderOnServer = false;
        var OrderByField = "DOS";
        var ReverseSort = true;
        var SelectedWorkList = [];
        var currentDate = new Date();
        var refreshDOSMidnight = null;
        var newOrderRefreshInterval = null;
        var DefaultAutoRefreshDuration = __env.DefaultAutoRefreshDuration;
        var OrderProcessed = false;
        var modalityIDs = '';
        var OnLoadRefreshDuration = 1;
        var parser = new UAParser();
        var browser = parser.getBrowser().name;
        var refreshDOSInterval = 1000;
        var currentHeight = 0;
        var previousHeight = 0;
        var SortColumns = [];
        var AllRadiologists = [];
        var pageTopheight = 0;
        var headerHeight = 0;
        var height = 0;
        var userLayoutPreference = {};
        var TimeoutList = [];
        var halfScale = false;
        var UserPrefTourSteps = [];
        var CurrentIndexToRefresh = 0;
        var showUserGuide = undefined;
        var loadMoreWorklist = null;
        var ClipboardRule = {};
        var ShowReleaseGuide = 0;
        var MasterDefaultWorklistData = [];
        var LayoutPreferenceID = '-1';
        var PendingAddendumWorklist = null;
        var OverdueReadsWorklist = null;
        var _hiddenOverdueDefaultWorklist = null;
        var TourFlag = $stateParams.TourFlag;
        var searchTabStep = {};
        var quickSearchTabStep = {};
        var worklistTabStep = {};
        var searchTabTopStep = {
            "title": "Search Tab",
            "template": "<div class='popover dt-WorklistPan tour hca-tooltip--left-nav w-500px' style='max-width: 450px;'><div class='arrow'></div><div class='row p-2 step-header m-0'><div class='col-sm-11 pl-2 pr-0'><p class='popover-title p-0'></p></div><div class='col-sm-1 pr-0'><div data-role='end' class='close'><i class='glyphicon glyphicon-remove tour-close'></i></div></div></div><div class='row m-0'><div class='col-sm-12 pt-10px d-flex' style='align-items: flex-start; justify-content: center;'><img width='350' src='assets/images/search-popup.png'/></div></div><div class='row m-0'><div class='col-sm-12 px-0'><p class='popover-content'></p></div></div><div class='row m-0'><div class='progress h-5px mb-2'><div class='progress-bar bg-clr-35' role='progressbar' style='width:5%' aria-valuenow='5' aria-valuemin='0' aria-valuemax='100'></div></div></div><div class='row m-0'><div class='col-md-6'><p class='m-0 txt-clr-2'>1/19</p></div><div class='col-md-6 px-0'><button class='btn m-1 tour-nxt-btns btn-primary px-2 py-0 float-right' data-role='next'>Next <i class='fa fa-arrow-right fs-12px pl-1'></i></button></div></div></div>"
        };
        var searchTabNotTopStep = {
            "title": "Search and Worklist Tab",
            "template": "<div class='popover dt-WorklistPan tour hca-tooltip--left-nav w-300px'><div class='arrow'></div><div class='row p-2 step-header m-0'><div class='col-sm-11 pl-2 pr-0'><p class='popover-title p-0'></p></div><div class='col-sm-1 pr-0'><div data-role='end' class='close'><i class='glyphicon glyphicon-remove tour-close'></i></div></div></div><div class='row m-0'><div class='col-sm-12 px-0'><p class='popover-content'></p></div></div><div class='row m-0'><div class='progress h-5px mb-2'><div class='progress-bar bg-clr-35' role='progressbar' style='width:5%' aria-valuenow='5' aria-valuemin='0' aria-valuemax='100'></div></div></div><div class='row m-0'><div class='col-md-6'><p class='m-0 txt-clr-2'>1/19</p></div><div class='col-md-6 px-0'><button class='btn m-1 tour-nxt-btns btn-primary px-2 py-0 float-right' data-role='next'>Next <i class='fa fa-arrow-right fs-12px pl-1'></i></button></div></div></div>"
        };
        var worklistTabTopStep = {
            "title": "Worklist Tab",
            "content": "Simplified worklist creation, to streamline the task organization.",
            "template": "<div class='popover tour hca-tooltip--left-nav w-500px' style='max-width: 470px;'><div class='arrow'></div><div class='row p-2 step-header m-0'><div class='col-sm-11 d-flex align-item-center pl-2 pr-0'><p class='popover-title p-0'></p></div><div class='col-sm-1 pr-0'><div data-role='end' class='close'><i class='glyphicon glyphicon-remove tour-close'></i></div></div></div><div class='row m-0'><div class='col-sm-12 pt-10px d-flex' style='align-items: flex-start;justify-content: center;'><img style='width:100%' src='assets/images/worklist-popup.png'/></div></div><div class='row m-0'><div class='col-sm-12 px-0'><p class='px-3 pb-1 pt-2 text-white m-0'><i class='glyphicon glyphicon-plus icon-hover txt-clr-14 pr-1'></i> Simplified worklist creation, to streamline the task organization.</p><p class='px-3 py-1 text-white m-0'><i class='fa fa-check-square-o icon-hover txt-clr-14 pr-1'></i> Streamline the worklist selection and deselection by utilizing the provided checkboxes for efficient management. </p><p class='px-3 py-1 text-white m-0'>Utilize the provided ' <i class='glyphicon glyphicon-pencil icon-hover txt-clr-14 pr-1'></i> ' edit and ' <i class='fa fa-trash-o icon-hover txt-clr-14 pr-1'></i> ' delete icons for effortless worklist editing and removal. </p> <p style='padding: 5px 14px;color:white;'>Double click any item or Click ' <i class='fa fa-external-link pt-1px txt-clr-14 fs-13px icon-hover'></i> ' for pop out worklist window</p></div></div><div class='row m-0'><div class='progress h-5px mb-2'><div class='progress-bar bg-clr-35' role='progressbar' style='width:33.33%' aria-valuenow='33' aria-valuemin='0' aria-valuemax='100'></div></div></div><div class='row m-0'><div class='col-md-6'><p class='m-0 txt-clr-2'>7/19</p></div><div class='col-md-6 px-0'><button class='btn m-1 tour-nxt-btns btn-primary px-2 py-0 float-right' type='button' data-role='next' autofocus>Next <i class='fa fa-arrow-right fs-12px pl-1'></i></button><button class='btn tour-back-btns btn-default m-1 px-2 py-1 float-right' data-role='prev'><i class='fa fa-arrow-left fs-12px pr-1'></i> Back</button></div></div></div>"
        };
        var worklistTabNotTopStep = {
            "title": "Search and Worklist Tab",
            "content": "Simplified worklist creation, to streamline the task organization.",
            "template": "<div class='popover tour hca-tooltip--left-nav w-300px'><div class='arrow'></div><div class='row p-2 step-header m-0'><div class='col-sm-11 d-flex align-item-center pl-2 pr-0'><i class='glyphicon glyphicon-plus icon-hover txt-clr-14 pr-2'></i><p class='popover-title p-0'></p></div><div class='col-sm-1 pr-0'><div data-role='end' class='close'><i class='glyphicon glyphicon-remove tour-close'></i></div></div></div><div class='row m-0'><div class='col-sm-12 px-0'><p class='popover-content'></p></div></div><div class='row m-0'><div class='progress h-5px mb-2'><div class='progress-bar bg-clr-35' role='progressbar' style='width:33.33%' aria-valuenow='33' aria-valuemin='0' aria-valuemax='100'></div></div></div><div class='row m-0'><div class='col-md-6'><p class='m-0 txt-clr-2'>7/19</p></div><div class='col-md-6 px-0'><button class='btn m-1 tour-nxt-btns btn-primary px-2 py-0 float-right' type='button' data-role='next' autofocus>Next <i class='fa fa-arrow-right fs-12px pl-1'></i></button><button class='btn tour-back-btns btn-default m-1 px-2 py-1 float-right' data-role='prev'><i class='fa fa-arrow-left fs-12px pr-1'></i> Back</button></div></div></div>"
        };
        var quickSearchTabTopStep = "<div class='popover dt-QuickSearch tour hca-tooltip--left-nav w-500px' style='max-width: 450px;'><div class='arrow'></div><div class='row p-2 step-header m-0'><div class='col-sm-11 pl-2 pr-0'><p class='popover-title p-0'></p></div><div class='col-sm-1 pr-0'><div data-role='end' class='close'><i class='glyphicon glyphicon-remove tour-close'></i></div></div></div><div class='row m-0'><div class='col-sm-12 pt-10px d-flex' style='align-items: flex-start; justify-content: center;'><img width='350' src='assets/images/quick-search-popup.png'/></div></div><div class='row m-0'><div class='col-sm-12 px-0'><p class='popover-content'></p></div></div><div class='row m-0'><div class='progress h-5px mb-2'><div class='progress-bar bg-clr-35' role='progressbar' style='width:8%' aria-valuenow='8' aria-valuemin='0' aria-valuemax='100'></div></div></div><div class='row m-0'><div class='col-md-6'><p class='m-0 txt-clr-2'>2/19</p></div><div class='col-md-6 px-0'><button class='btn m-1 tour-nxt-btns btn-primary px-2 py-0 float-right' data-role='next'>Next <i class='fa fa-arrow-right fs-12px pl-1'></i></button><button class='btn tour-back-btns btn-default m-1 px-2 py-1 float-right' data-role='prev'><i class='fa fa-arrow-left fs-12px pr-1'></i> Back</button></div></div></div>";
        var quickSearchTabNotTopStep = "<div class='popover dt-QuickSearch tour hca-tooltip--left-nav w-300px'><div class='arrow'></div><div class='row p-2 step-header m-0'><div class='col-sm-11 pl-2 pr-0'><p class='popover-title p-0'></p></div><div class='col-sm-1 pr-0'><div data-role='end' class='close'><i class='glyphicon glyphicon-remove tour-close'></i></div></div></div><div class='row m-0'><div class='col-sm-12 px-0'><p class='popover-content'></p></div></div><div class='row m-0'><div class='progress h-5px mb-2'><div class='progress-bar bg-clr-35' role='progressbar' style='width:8%' aria-valuenow='8' aria-valuemin='0' aria-valuemax='100'></div></div></div><div class='row m-0'><div class='col-md-6'><p class='m-0 txt-clr-2'>2/19</p></div><div class='col-md-6 px-0'><button class='btn m-1 tour-nxt-btns btn-primary px-2 py-0 float-right' data-role='next'>Next <i class='fa fa-arrow-right fs-12px pl-1'></i></button><button class='btn tour-back-btns btn-default m-1 px-2 py-1 float-right' data-role='prev'><i class='fa fa-arrow-left fs-12px pr-1'></i> Back</button></div></div></div>";
        var UpdatedMasterWorklists = [];
        var bodyElement = angular.element(document).find('body');

        $scope.DataObject = {
            WorkLists: [],
            SearchedWorklist: {},
            iswlTabAutoHide: false,
            wlTabName: 'Search',
            winFilterWorklist: "84%",
            Rule: {},
            ModalWorklistOpened: false,
            AddEditWorklistTitle: "Edit Worklist",
            AccordianShow: false,
            showQuickFilter: false,
            OpenQuickFilter: false,
            GlobalRules: [],
            WorklistPopupTitle: 'Worklist',
            defaultWindowHeight: "80%",
            RuleTable: [],
            SelectQuickFilter: { obj: false },
            DefaultWorklists: [],
            RadLocationValues: { SelectedItems: [] },
            MasterData: {
                Radiologists: [], RuleTable: [],
            },
            SelectedData: {
                Status: { key: 'RP' },
                Worklist: "PSW",
                ChooseNextStudy: false,
                ShowLockStudy: true,
                modalitytooltip: 'Select Modalities',
                toolTipOrderDate: 'DOS',
                locationIDs: '',
                OrderDateType: 'Last 7 Days',
                OrderDate: {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                },
                DefaultDictationSystem: "",
                QuickSearch: {
                    Status: { key: 'AL' },
                    OrderDate: {
                        startDate: null,
                        endDate: null
                    },
                    OrderDateType: 'Today',
                },
                DeficientWarningOnWorklist: false,
                LoggedInUserID: $sessionStorage.currentUserData.userId,
                userRole: $sessionStorage.currentUserData.roles,
                userRoles: $sessionStorage.currentUserData.userRoles,
                WorklistFontSize: null,
                WorklistColorCode: {},
                SelectedLocations: {
                    Ids: '',
                    locations: [],
                    divId: "NewWorklistFilter"
                },
                OrderIDRemovedFromClipboard: false,
                Modality: [],
                CloseWindow: false,
                OpenFromWorklist: false,
            },
            OrderStatus: {},
            StudyPrirorities: [],
            InputDropdownList: {
                Options: [
                    {
                        Key: 'contains',
                        Value: 'Contains'
                    },
                    {
                        Key: 'equals',
                        Value: 'Equals'
                    },
                    {
                        Key: 'startswith',
                        Value: 'Starts with'
                    },
                    {
                        Key: 'endswith',
                        Value: 'Ends with'
                    }
                ],
            },
            PendingAddendumCount: 0,
            OverdueReadsCount: 0,
            IsAddendumRequestVisible: $sessionStorage.IsAddendumRequestVisible,
            ShowPracticeWorklist: true,
            ModalityDropdownDataFilter: {
                divId: "MWorklistModalityFilter",
                keys: ['Code'],
                uniqKey: 'Code',
                placeHolder: "Select Modalities",
                SelectedValue: { list: [] },
            },
            ModalityDropdownDataQC: {
                divId: "MWorklistModalityQC",
                keys: ['Code'],
                uniqKey: 'Code',
                placeHolder: "Select Modalities",
                SelectedValue: { list: [] },
            },
            isWorklistLoading: true,
            DockerPosition: null,
            PaymentAddedSound: null,
            SelectedModaliesFilter: [],
        };
        $scope.WorklistPageHeaderParameter = {
            isfilterCollapse: false,
            isPCAvailable: false,
            Charges: 0,
            HospitalRVU: 0,
            TopUserRVU: 0,
            MyRVU: 0,
            LowRVU: 0,
            SignedToday: 0,
            UnreadRVU: 0,
            BonusDetails: null,
            isSOSVisible: false,
            XRayDetails: null,
        };
        $scope.opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",

                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.DataObject.SelectedData.OrderDate = {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                }
            },
            ranges: {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
                'Last 5 Years': [moment().subtract(5, 'years'), moment()],
            }
        };


        if ($(window).width() < 1199) {
            halfScale = true;
        }

        $scope.QuickSearchopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",

                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.DataObject.SelectedData.QuickSearch.OrderDate = {
                    startDate: null,
                    endDate: null
                }
            },
            drops: 'up',
            ranges: {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
                'Last 5 Years': [moment().subtract(5, 'years'), moment()],
            }
        };
        $scope.QuickSearchField = [

            {
                key: 'Location', checked: true, type: 'text', SelectedOption: {
                    FilterOption: {
                        Key: 'contains',
                        Value: 'Contains'
                    },
                    text: ''
                }
            },
            {
                key: 'Accession', checked: true, type: 'text', SelectedOption: {
                    FilterOption: {
                        Key: 'equals',
                        Value: 'Equals'
                    },
                    text: ''
                }
            },
            {
                key: 'Patient Name', checked: true, type: 'text', SelectedOption: {
                    FilterOption: {
                        Key: 'contains',
                        Value: 'Contains'
                    },
                    text: ''
                }
            },
            {
                key: 'MRN', checked: true, type: 'text', SelectedOption: {
                    FilterOption: {
                        Key: 'equals',
                        Value: 'Equals'
                    },
                    text: ''
                }
            },
            { key: 'DOB', checked: false, type: 'date' },
            { key: 'DOS', checked: false, value: { toolTipOrderDate: 'DOS' }, type: 'date-range' },
            { key: 'Select Modalities', checked: false, modalitytooltip: 'Select modalities', type: 'multi-select' },
            { key: 'Select Type', checked: false, type: 'single-select' },
            { key: 'Select Priority', checked: false, type: 'single-select' },
            { key: 'Status', checked: false, value: 'AL', type: 'single-select-bgcolor' },
            {
                key: 'Ordering Physician', checked: false, type: 'text', SelectedOption: {
                    FilterOption: {
                        Key: 'contains',
                        Value: 'Contains'
                    },
                    text: ''
                }
            },
        ];
        // #endregion

        kendo.ui.Window.fn._keydown = function (originalFn) {
            var KEY_ESC = 27;
            return function (e) {
                if (e.which !== KEY_ESC) {
                    originalFn.call(this, e);
                }
            };
        }(kendo.ui.Window.fn._keydown);

        $scope.resetDateRange = function () {
            $scope.opts.ranges = {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
                'Last 5 Years': [moment().subtract(5, 'years'), moment()],
            };
            angular.element(document).ready(function () {
                angular.element('.drp-buttons .cancelBtn').click(function () {
                    angular.element('#daterange3').val('');
                    $scope.DataObject.SelectedData.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                });
            });
            angular.element(document).ready(function () {
                $scope.DataObject.SelectedData.OrderDateType = ($scope.DataObject.SelectedData && $scope.DataObject.SelectedData.OrderDate && $scope.DataObject.SelectedData.OrderDate.label) ? $scope.DataObject.SelectedData.OrderDate.label : $scope.DataObject.SelectedData.OrderDateType;
                if ($scope.DataObject.SelectedData.OrderDate.startDate && $scope.DataObject.SelectedData.OrderDate.endDate) {
                    if ($scope.DataObject.SelectedData.OrderDateType != null && $scope.DataObject.SelectedData.OrderDateType.match('Custom'))
                        $scope.DataObject.SelectedData.OrderDateType = ($scope.DataObject.SelectedData.OrderDateType != null && $scope.DataObject.SelectedData.OrderDateType.match('Custom')) ? ($scope.DataObject.SelectedData.OrderDateType + '#' + moment(new Date($scope.DataObject.SelectedData.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                            moment(new Date($scope.DataObject.SelectedData.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.DataObject.SelectedData.OrderDateType;

                }
                else {
                    $scope.DataObject.SelectedData.OrderDateType = 'Clear';
                }
                setOrderDate($scope.DataObject.SelectedData.OrderDateType, $scope.DataObject.SelectedData);
            });
        }

        /*
        *  Discarded = -1,
            Pending = 0, - Close
            WetRead = 1,
            Draft = 2, - Draft
            PendingCorrection = 3,
            Corrected = 4,
            CorrectionRejected = 5,
            PendingSignature = 6,
            SignRejected = 7,
            Final = 8 - Sign
        */
        var NativeMessageResponse = function (NativeMessageResponse) {
            //console.log("NativeMessageResponse > NativeMessageResponse: ", NativeMessageResponse);
            if (NativeMessageResponse.responseEvent != null
                && NativeMessageResponse.responseEvent == "ReportResponseDetails"
                && NativeMessageResponse.reportResponseDetails != null
                && NativeMessageResponse.reportResponseDetails.ReportResponseEvent == "ReportClosed") {

                // Skip intermediate ReportClosed events (status=0) fired by PS during draft save.
                // PS always fires a second event with the final status (2=Draft, 8=Signed, -1=Discarded).
                if (NativeMessageResponse.reportResponseDetails.reportStatus === 0) {
                    return;
                }

                $scope.isPS360ReportOpen = false;

                $scope.DataObject.SelectedData.CloseWindow = false;

                if (!$scope.DataObject.SelectedData.ChooseNextStudy || ($localStorage.OpenClipboardNextStudy != undefined && !$localStorage.OpenClipboardNextStudy)) {
                    $scope.DataObject.SelectedData.CloseWindow = ((!$scope.DataObject.SelectedData.ChooseNextStudy || ($localStorage.OpenClipboardNextStudy != undefined && !$localStorage.OpenClipboardNextStudy)));
                }

                // If a RadFlow openreport is in-flight, the ReportClosed we receive is PS360
                // auto-closing the previous report as a side-effect of switching — not a
                // user-initiated close. Always skip auto-advance here; the user's actual close
                // of the newly-opened study will trigger auto-advance when isPSManualOpen is false.
                if ($scope.isPSManualOpen) {
                    $scope.isPSManualOpen = false;
                    SignReport("", NativeMessageResponse);
                }
                else if (!$scope.DataObject.SelectedData.ChooseNextStudy
                    || ($localStorage.OpenClipboardNextStudy != undefined && !$localStorage.OpenClipboardNextStudy)) {
                    SignReport("NEXT", NativeMessageResponse);
                }
                else {
                    SignReport("", NativeMessageResponse);
                }

            }
            if (NativeMessageResponse.responseEvent != null
                && NativeMessageResponse.responseEvent == "ReportResponseDetails"
                && NativeMessageResponse.reportResponseDetails != null
                && NativeMessageResponse.reportResponseDetails.ReportResponseEvent == "ReportOpenFailed") {
                // PS failed to open the report (e.g. site not configured). Clear the manual-open
                // flag so subsequent opens and auto-advance are not permanently blocked.
                $scope.isPSManualOpen = false;
            }

            if (NativeMessageResponse.responseEvent != null && NativeMessageResponse.responseEvent == "ImageResponseDetails"
                && NativeMessageResponse.imageResponseDetails != null) {
                if (!NativeMessageResponse.imageResponseDetails.Status) {
                    toaster.warning({ body: "Unable to find the image in Synapse." });
                }
            }
        }
        var NativeMessageResponseWorklist = function (evt, nativeMessageResponse) {
            NativeMessageResponse(nativeMessageResponse);
        }
        $scope.$on('NativeMessageResponseWorklist', NativeMessageResponseWorklist);

        function StartRC() {
            if (RCService) {
                //if (!RCService.rc) {
                //    RCService.Connect(NativeMessageResponse);
                //}
                var timeout = $timeout(function () {
                    //if (RCService.rc && !RCService.rc.nativeHostVersion) {
                    //    RCService.StartNativehost();
                    //}
                    if ($scope.DataObject.SelectedData.DefaultDictationSystem && $scope.DataObject.SelectedData.DefaultDictationSystem == 'PS360') {
                        RCService.StartPS();
                    }

                    $timeout.cancel(timeout);
                    timeout = null;
                }, 1000);
            }
        }

        function StopRC() {
            if (RCService) {
                RCService.Disconnect();
                RCService.rc = null;
            }
        }

        function PageInIt() {
            $scope.DataObject.AccordianShow = true;

            intiAppHub();

            getOrderStatus();

            setHeight();
            previousHeight = currentHeight;

            AddWorklist();

            loadWorklistListAgGrid();

            $q.all([
                GetWorklistTourSteps(),
                getLoadMoreWorklistPreference(),
                getWorklistPrefrence(),
                GetTenantsByUserID()
            ]).then(function (data) {
                pageTopheight = $(".page-top").height();
                headerHeight = $(".radf-header").height();
                height = $(window).height();

                var defaultWorklists = prepareDefaultWorklist($scope.DataObject.DefaultWorklists);
                $scope.DataObject.DefaultWorklists = _.filter(defaultWorklists, { 'IsEnabled': true, 'deleted': false });
                //console.log("PageInIt: ", $scope.DataObject.DefaultWorklists);
                CalculateHeight();
                if ($sessionStorage.HasSOLAccess) {
                    GetXRayCountByUser();
                }
                GetUserPaymentHeader();
                UpdateTimeToLoad();

                updateRefreshDOSInterval();
                refreshDOSMidnight = $interval(refreshDOS, refreshDOSInterval);
                newOrderRefresh();
                StartRC();

                setLoadMoreWorklistPreference();
                GetSignSummary();
                GetWorklistStatusCount();
                GetOverdueReadsCount();
                WorklistInitTour().then(function () {
                    _.each($scope.DataObject.DefaultWorklists, function (worklist) {
                        if (WorklistListsGridoptions && WorklistListsGridoptions.api) {
                            var node = WorklistListsGridoptions.api.getRowNode(worklist.RuleID);
                            if (node) {
                                node.setSelected(true);
                            }
                        }
                    });

                });
                var TenantAccess = _.filter($scope.DataObject.MasterData.UserTenants, function (tenant) {
                    return $sessionStorage.EnableRowsForSelectedTenants.split(',').includes(tenant.Name);
                });
                if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician
                    && (TenantAccess && TenantAccess.length > 0)) {
                    $scope.DataObject.OrderStatus = _.filter($scope.DataObject.OrderStatus, function (status) { return status.key != 'IP' });
                    $scope.DataObject.MasterData.OrderStatus = $scope.DataObject.OrderStatus;
                }

                var SOSAccess = _.filter($scope.DataObject.MasterData.UserTenants, function (tenant) {
                    return $sessionStorage.EnableSOSTenants.split(',').includes(tenant.Name);
                });
                $scope.WorklistPageHeaderParameter.isSOSVisible = $sessionStorage.isSOSVisible && (SOSAccess && SOSAccess.length > 0);
                $scope.DataObject.isWorklistLoading = false;
            });

            $scope.DataObject.RuleTable = RuleSharedService.ReSetMasterData();
            $scope.DataObject.MasterData.RuleTable = RuleSharedService.ReSetMasterData();
            $q.all([
                RuleSharedService.GetAllRadiologists()
            ]).then(function (data) {
                AllRadiologists = data[0];
                $scope.DataObject.MasterData.Radiologists = AllRadiologists;
            });

            /**/
        }

        $scope.CloseFrom = ""; //"RADFLOW" , "PS360"


        function prepareDefaultWorklist(DefaultWorklists) {
            _.each(DefaultWorklists, function (dWorklist) {
                dWorklist.deleted = false;
                dWorklist.popUpWorklist = false;
                var worklistIndex = _.findIndex($scope.DataObject.WorkLists, function (obj) { return obj.RuleID == dWorklist.RuleID; });
                if (worklistIndex != -1) {
                    $scope.DataObject.WorkLists[worklistIndex].checked = true;
                    dWorklist.IsEnabled = $scope.DataObject.WorkLists[worklistIndex].IsEnabled;
                    dWorklist.IsSmartWorklist = $scope.DataObject.WorkLists[worklistIndex].IsSmartWorklist;
                    dWorklist.WorklistPageSize = $scope.DataObject.WorkLists[worklistIndex].WorklistPageSize;
                } else {
                    dWorklist.deleted = true;
                }

                dWorklist.ResultPendingCount = 0;
                dWorklist.UnreadRVU = 0;
                dWorklist.STATCount = 0;
                dWorklist.loading = false;
                dWorklist.TimeToLoad = moment();
                dWorklist.PageSize = _.toInteger(getPageSize(dWorklist.height));
                if (dWorklist.open == null) {
                    dWorklist.open = true;
                }
                if (dWorklist.WorklistType != 16) { dWorklist.OpenClipboardNextStudy = true; }
                if (dWorklist.WorklistType == 16) {
                    dWorklist.Type = "A";
                    $localStorage.OpenClipboardNextStudy = dWorklist.OpenClipboardNextStudy;
                }
                dWorklist.gridId = uuidv4.newuuid();
                dWorklist.UpdateID = 1;
                dWorklist.purge = false;
                dWorklist.ResetFilter = false;
                dWorklist.SaveLayout = false;
                if (dWorklist.WorklistType != 16) {
                    dWorklist.ChooseNextStudy = (dWorklist && dWorklist.hasOwnProperty("ChooseNextStudy")) ? dWorklist.ChooseNextStudy : true;
                }
            });
            return _.uniqBy(DefaultWorklists, 'RuleID');
        }

        function formatted_date(date) {
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' == (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };

        function GetRVU() {
            var data = {
                userid: $sessionStorage.currentUserData.userId,
                StartDateTime: $filter('CSTDateTime')(new Date(new Date().setDate(new Date().getDate() - 1))),
                EndDateTime: $filter('CSTDateTime')(new Date()),
                RadiologistsByTenant: $sessionStorage.RadiologistsByTenant && $sessionStorage.RadiologistsByTenant.length > 0 ? $sessionStorage.RadiologistsByTenant : "",
            };
            WorklistService.GetRVU(data).then(function (result) {
                if (result && result.length > 0) {
                    $scope.WorklistPageHeaderParameter.HospitalRVU = result[0].PracticeRVU;
                    $scope.WorklistPageHeaderParameter.TopUserRVU = result[0].HighRVU;
                    $scope.WorklistPageHeaderParameter.MyRVU = result[0].MyRVU;
                    $scope.WorklistPageHeaderParameter.LowRVU = result[0].LowRVU;
                    $scope.WorklistPageHeaderParameter.UnreadRVU = result[0].ResultPendingWorkRVUSum && result[0].ResultPendingWorkRVUSum != null ? result[0].ResultPendingWorkRVUSum : "0.00";
                }

            });
        };

        function GetSignSummary() {
            var data = {
                userid: $sessionStorage.currentUserData.userId,
                // RVU window: rolling 24h, matches legacy GetRVU exactly.
                StartDateTime: $filter('CSTDateTime')(new Date(new Date().setDate(new Date().getDate() - 1))),
                EndDateTime: $filter('CSTDateTime')(new Date()),
                RadiologistsByTenant: $sessionStorage.RadiologistsByTenant && $sessionStorage.RadiologistsByTenant.length > 0 ? $sessionStorage.RadiologistsByTenant : "",
                // SignedToday window: current calendar day, matches legacy GetStatusCount exactly
                // (GetRVU's rolling 24h window must NOT be reused here, see Task 171659 review).
                SignedTodayStartDateTime: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "00:00")),
                SignedTodayEndDateTime: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")),
            };
            return WorklistService.GetSignSummary(data).then(function (result) {
                if (result) {
                    $scope.WorklistPageHeaderParameter.HospitalRVU = result.PracticeRVU;
                    $scope.WorklistPageHeaderParameter.TopUserRVU = result.HighRVU;
                    $scope.WorklistPageHeaderParameter.MyRVU = result.MyRVU;
                    $scope.WorklistPageHeaderParameter.LowRVU = result.LowRVU;
                    $scope.WorklistPageHeaderParameter.UnreadRVU = result.ResultPendingWorkRVUSum && result.ResultPendingWorkRVUSum != null ? result.ResultPendingWorkRVUSum : "0.00";
                    $scope.WorklistPageHeaderParameter.SignedToday = result.SignedToday;
                }
            });
        };

        // Task 172082: manual replacement for the removed GetSignSummary fallback interval / SignalR listener.
        $scope.IsRefreshingSignSummary = false;
        $scope.RefreshSignSummary = function () {
            if ($scope.IsRefreshingSignSummary) {
                return;
            }
            $scope.IsRefreshingSignSummary = true;
            var promises = [GetSignSummary()];
            if ($sessionStorage.HasSOLAccess) {
                promises.push(GetXRayCountByUser());
            }
            $q.all(promises).finally(function () {
                $scope.IsRefreshingSignSummary = false;
            });
        };

        $scope.clearFilterAndRefesh = function () {
            //Bug 28867: The previously selected study not shown selected if the user clears the filter
            clearFilter();
            var timeout = $timeout(function () { $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;'); }, 1);
            TimeoutList.push(timeout)
            $('.anui').removeClass("set-modality-height");
        };

        function clearFilter() {
            $scope.DataObject.SelectedData.Status.key = "RP";
            OrderByField = "DOS";
            ReverseSort = true;
            $scope.DataObject.SelectedData.Site = null;
            $scope.DataObject.SelectedData.Location = null;
            SelectedWorkList = [];
            $scope.DataObject.SelectedData.modalitytooltip = 'Select Modalities';
            $scope.DataObject.SelectedData.Modality = [];
            $scope.DataObject.ModalityDropdownDataFilter.SelectedValue = {
                list: [],
            };
            $scope.DataObject.SelectedData.locationIDs = '';
            modalityIDs = '';
            $scope.worklistIds_Admin = '';
            $scope.worklistIds_User = '';
            $scope.DataObject.SelectedData.Accession = "";
            $scope.DataObject.SelectedData.OrderDate = {
                startDate: moment().subtract(6, 'days'),
                endDate: moment()
            };
            $scope.DataObject.SelectedData.toolTipOrderDate = 'DOS: ' + $scope.DataObject.SelectedData.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.DataObject.SelectedData.OrderDate.endDate.format('MM/DD/YYYY');
            $scope.DataObject.SelectedData.OrderDateType = 'Last 7 Days';
            $scope.DataObject.SelectedData.PatientName = "";
            $scope.DataObject.SelectedData.PatientMRN = "";
            $scope.DataObject.SelectedData.DOB = "";
            $scope.DataObject.SelectedData.PatientClass = null;
            $scope.DataObject.SelectedData.OrderingPhysician = "";
            $scope.DataObject.SelectedData.STATFilter = false;
            $scope.DataObject.SelectedData.StudyPriority = null;
            $scope.DataObject.SelectedData.SelectedLocations = {
                Ids: '',
                locations: [],
                divId: "NewWorklistFilter"
            };
        };

        /**
         * Modified By: Tejas Parikh
         * Task 22822: All sites should be listed in alphabetical manner in location filter list
         * @param {any} a
         * @param {any} b
         */
        function compare(a, b) {
            // Use toUpperCase() to ignore character casing
            var bandA = a.text.toUpperCase();
            var bandB = b.text.toUpperCase();

            var comparison = 0;
            if (bandA > bandB) {
                comparison = 1;
            } else if (bandA < bandB) {
                comparison = -1;
            }
            return comparison;
        }

        function SignReport(navFlag, NativeMessageResponse) {
            //console.log("SignReport > NativeMessageResponse: ", NativeMessageResponse);
            var accessions = _.split(NativeMessageResponse.reportResponseDetails.accessionNumbers, ",");
            _.each(accessions, function (accession) {
                windowHandler.CloseWindow(["CI-VIEWER-1-" + accession.toUpperCase().trim(),
                "CI-VIEWER-2-" + accession.toUpperCase().trim(),
                'KONICA-' + accession.toUpperCase().trim(),
                'KONICATEST-' + accession.toUpperCase().trim(),
                'MedDreamViewer-' + accession.toUpperCase().trim(),
                'NORTHSTARKONICA-' + accession.toUpperCase().trim()]);
            });
            if ($sessionStorage.MedDreamViewerKeepOpen) {
                SharedService.clearMedDreamViewer();
            } else {
                SharedService.closeMedDreamViewer();
            }
            var clipboardRule = _.find($scope.DataObject.GlobalRules, { WorklistType: 16 });
            if ($scope.DataObject.SelectedData.OpenFromWorklist) {
                $scope.$broadcast('event.worklist', {
                    EventType: 'SignReport',
                    navFlag: navFlag,
                    MessageResponse: NativeMessageResponse,
                    RuleID: $scope.DataObject.SelectedData.RuleID,
                    ClipboardRuleID: clipboardRule ? clipboardRule.RuleID : 0
                });
                GetSignSummary();
                if ($sessionStorage.HasSOLAccess) {
                    GetXRayCountByUser();
                }
                GetUserPaymentHeader();
                GetWorklistStatusCount();
                GetOverdueReadsCount();
            }
        };

        function OpenSynapseStudy(Order, Viewer, isOpenPS, isSingleView, correlationId) {
            SharedService.OpenSynapseStudy(Order, Viewer, isOpenPS, isSingleView, $scope, TimeoutList, browser, correlationId);
        }

        function CreateMHSPS360File(accession) {
            try {
                var fso, file, filepath, filecontent;
                filepath = __env._MHSRichardsonXmlPath_;
                filecontent = __env._MHSRichardsonXmlFile_.replace("@Accession", accession);
                fso = new ActiveXObject("Scripting.FileSystemObject");
                file = fso.CreateTextFile(filepath);
                file.WriteLine(filecontent);
                file.close();
            }
            catch (err) {
                alert(err.message);
            }
        }

        function OpenGECentricity(Accession, ViewerCrendetials) {
            var map = window.open("", "Map", "status=0,title=0,width=700,height=600,left=500,top=300,scrollbars=1");
            if (map) {
                var form = map.document.createElement('form');
                form.method = 'POST';
                form.action = __env._environment.config.GECentricityURL;

                var userInput = map.document.createElement('input');
                userInput.type = 'hidden';
                userInput.name = 'user_name';
                userInput.value = ViewerCrendetials.UserName;
                form.appendChild(userInput);

                var passInput = map.document.createElement('input');
                passInput.type = 'hidden';
                passInput.name = 'password';
                passInput.value = ViewerCrendetials.Password;
                form.appendChild(passInput);

                var accInput = map.document.createElement('input');
                accInput.type = 'hidden';
                accInput.name = 'accession_number';
                accInput.value = Accession;
                form.appendChild(accInput);

                map.document.body.appendChild(form);
                form.submit();
            } else {
                swal("You must allow pop-ups for this to work.");
            }
        }

        function OpenCIDicomViewer(accession, isSingleView) {
            openRequestedPopup(accession, isSingleView);
        }

        function openRequestedPopup(accession, isSingleView) {

            if (browser != null && browser.toUpperCase() == "IE") {
                window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
            }
            else {
                windowHandler.openByPreference(__env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 1), "CI-VIEWER-1", 1000, isSingleView ? "CI-VIEWER-1-" + accession.toUpperCase().trim() : null, "", false);
            }

        }

        function SaveFilterValues() {
            var columns = [];
            var obj = {};
            if ($scope.DataObject.SelectedData.locationIDs != ',' && $scope.DataObject.SelectedData.locationIDs != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'LocationID', Value: $scope.DataObject.SelectedData.locationIDs };
                columns.push(obj);
            }
            if ($scope.worklistIds_Admin != ',' && $scope.worklistIds_Admin != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'WorklistIds_A', Value: $scope.worklistIds_Admin };
                columns.push(obj);
            }
            if ($scope.worklistIds_User != ',' && $scope.worklistIds_User != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'WorklistIds_U', Value: $scope.worklistIds_User };
                columns.push(obj);
            }
            if ($scope.DataObject.SelectedData.Accession) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'Accession', Value: $scope.DataObject.SelectedData.Accession };
                columns.push(obj);
            }
            if ($scope.DataObject.SelectedData.OrderDate.startDate) {
                $scope.DataObject.SelectedData.OrderDateType = ($scope.DataObject.SelectedData && $scope.DataObject.SelectedData.OrderDate && $scope.DataObject.SelectedData.OrderDate.label) ? $scope.DataObject.SelectedData.OrderDate.label : $scope.DataObject.SelectedData.OrderDateType;
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'OrderDate', Value: ($scope.DataObject.SelectedData.OrderDateType != null && $scope.DataObject.SelectedData.OrderDateType.match('Custom')) ? ($scope.DataObject.SelectedData.OrderDateType + '#' + moment(new Date($scope.DataObject.SelectedData.OrderDate.startDate)).format("MM-DD-YYYY") + '#' + moment(new Date($scope.DataObject.SelectedData.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.DataObject.SelectedData.OrderDateType };
                columns.push(obj);
            }
            if (modalityIDs != ',' && modalityIDs != '') {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'ModalityID', Value: modalityIDs };
                columns.push(obj);
            }
            if ($scope.DataObject.SelectedData.PatientName) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'PatientName', Value: $scope.DataObject.SelectedData.PatientName };
                columns.push(obj);
            }
            if ($scope.DataObject.SelectedData.PatientMRN) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'PatientMRN', Value: $scope.DataObject.SelectedData.PatientMRN };
                columns.push(obj);
            }
            if ($scope.DataObject.SelectedData.DOB) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'PatientDOB', Value: $scope.DataObject.SelectedData.DOB };
                columns.push(obj);
            }
            if ($scope.DataObject.SelectedData.PatientClass) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'PatientClass', Value: $scope.DataObject.SelectedData.PatientClass.Value };
                columns.push(obj);
            }
            if ($scope.DataObject.SelectedData.OrderingPhysician) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'OrderingPhysician', Value: $scope.DataObject.SelectedData.OrderingPhysician };
                columns.push(obj);
            }
            if ($scope.DataObject.SelectedData.Status.key) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'Status', Value: $scope.DataObject.SelectedData.Status.key };
                columns.push(obj);
            }

            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'STATFilter', Value: $scope.DataObject.SelectedData.STATFilter ? "1" : "0" };
            columns.push(obj);

            if ($scope.DataObject.SelectedData.StudyPriority) {
                obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List', ColumnName: 'Priority', Value: $scope.DataObject.SelectedData.StudyPriority.Key };
                columns.push(obj);
            }
            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work ListColSort', ColumnName: OrderByField, Value: ReverseSort ? "1" : "0" };
            columns.push(obj);

            if (columns && columns.length > 0) {
                WorklistService.SaveFilterSetting(columns).then(function (result) {
                    toaster.success({ body: "Filter saved successfully." });
                });
            }
        }

        function saveFilterAsWorkList() {
            swal({
                title: "Enter Worklist Name!",
                text: "",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: true,
                showLoaderOnConfirm: false,
                //animation: "slide-from-top",
                inputPlaceholder: "Worklist Name"
            },
                function (inputValue) {
                    if (inputValue) {
                        inputValue = inputValue.trim();
                    }
                    if (inputValue === false)
                        return false;
                    if (inputValue === "") {
                        swal.showInputError("You need to write something!");
                        return false;
                    }
                    createWorkList(inputValue);
                });
        }

        function createWorkList(workListName) {
            var obj = {};

            //#region Create Object

            var RulesConditions = [];
            var RulesProviders = [{ ProviderID: $sessionStorage.currentUserData.userId }];


            if ($scope.DataObject.SelectedData.locationIDs != ',' && $scope.DataObject.SelectedData.locationIDs != '') {
                var locationRuleTableIndex = _.findIndex($scope.DataObject.RuleTable, { 'Key': 'Locations' });
                var locationRuleOperator = _.find($scope.DataObject.RuleTable[locationRuleTableIndex].RuleOperator, { 'Value': 'IN' });
                var locationRuleTableValues = [];
                _.each($scope.DataObject.SelectedData.Location, function (loc) {
                    locationRuleTableValues.push({
                        ID: loc.LocationID,
                        Value: loc.Location,
                        Description: loc.Site,
                    });
                });
                obj = {
                    TableName: 'Locations',
                    ColumnName: 'ORDERS.LocationID',
                    Operator: 'IN',
                    Value: _.join(_.map(_.split($scope.DataObject.SelectedData.locationIDs, ','), function (num) { return "'" + num + "'"; }), ','),
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.DataObject.RuleTable[locationRuleTableIndex],
                    RuleOperator: locationRuleOperator,
                    RuleTableValues: locationRuleTableValues,
                    AndOr: "AND",
                };
                RulesConditions.push(obj);

                //_.remove($scope.DataObject.RuleTable, function (n, index) {
                //    return index == locationRuleTableIndex;
                //});
            }
            if ($scope.DataObject.SelectedData.OrderDate.startDate) {
                var dosRuleTableIndex = _.findIndex($scope.DataObject.RuleTable, { 'Key': 'DOS' });
                var dosRuleOperator = _.find($scope.DataObject.RuleTable[dosRuleTableIndex].RuleOperator, { 'Value': '=' });

                $scope.DataObject.SelectedData.OrderDateType = ($scope.DataObject.SelectedData && $scope.DataObject.SelectedData.OrderDate && $scope.DataObject.SelectedData.OrderDate.label) ? $scope.DataObject.SelectedData.OrderDate.label : $scope.DataObject.SelectedData.OrderDateType;
                if ($scope.DataObject.SelectedData.OrderDateType.match('Custom')) {
                    obj = {
                        TableName: 'DOS',
                        ColumnName: 'ORDERS.OrderDate',
                        Operator: '=',
                        Value: $scope.DataObject.SelectedData.OrderDateType + " '" + $scope.DataObject.SelectedData.OrderDate.startDate.format("MM-DD-YYYY") + "' and '" + $scope.DataObject.SelectedData.OrderDate.endDate.format("MM-DD-YYYY") + "'",
                        ModifyBy: $sessionStorage.currentUserData.userId,
                        RuleTable: $scope.DataObject.RuleTable[dosRuleTableIndex],
                        RuleOperator: dosRuleOperator,
                        DateValue: {
                            startDate: $scope.DataObject.SelectedData.OrderDate.startDate.format("MM-DD-YYYY"),
                            endDate: $scope.DataObject.SelectedData.OrderDate.endDate.format("MM-DD-YYYY"),
                            label: $scope.DataObject.SelectedData.OrderDateType,
                        },
                        AndOr: "AND",
                    };
                    RulesConditions.push(obj);
                }
                else {
                    obj = {
                        TableName: 'DOS',
                        ColumnName: 'ORDERS.OrderDate',
                        Operator: '=',
                        Value: $scope.DataObject.SelectedData.OrderDateType,
                        ModifyBy: $sessionStorage.currentUserData.userId,
                        RuleTable: $scope.DataObject.RuleTable[dosRuleTableIndex],
                        RuleOperator: dosRuleOperator,
                        DateValue: {
                            startDate: $scope.DataObject.SelectedData.OrderDate.startDate.format("MM-DD-YYYY"),
                            endDate: $scope.DataObject.SelectedData.OrderDate.endDate.format("MM-DD-YYYY"),
                            label: $scope.DataObject.SelectedData.OrderDateType,
                        },
                        AndOr: "AND",
                    };
                    RulesConditions.push(obj);
                }
                //_.remove($scope.DataObject.RuleTable, function (n, index) {
                //    return index == dosRuleTableIndex;
                //});
            }
            if (modalityIDs != ',' && modalityIDs != '') {
                var modalityRuleTableIndex = _.findIndex($scope.DataObject.RuleTable, { 'Key': 'Modality' });
                var modalityRuleOperator = _.find($scope.DataObject.RuleTable[modalityRuleTableIndex].RuleOperator, { 'Value': 'IN' });
                var modalityRuleTableValues = [];
                _.each($scope.DataObject.SelectedData.Modality, function (mod) {
                    modalityRuleTableValues.push({
                        ID: mod.Id,
                        Value: mod.Code,
                        Description: mod.Description,
                    });
                });
                obj = {
                    TableName: 'Modality',
                    ColumnName: 'ORDERS.ModalityID',
                    Operator: 'IN',
                    Value: _.join(_.map(_.split(modalityIDs, ','), function (num) { return "'" + num + "'"; }), ','),
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.DataObject.RuleTable[modalityRuleTableIndex],
                    RuleOperator: modalityRuleOperator,
                    RuleTableValues: modalityRuleTableValues,
                    AndOr: "AND",
                };
                RulesConditions.push(obj);

                //_.remove($scope.DataObject.RuleTable, function (n, index) {
                //    return index == modalityRuleTableIndex;
                //});
            }
            if ($scope.DataObject.SelectedData.PatientClass) {
                var patientClassRuleTableIndex = _.findIndex($scope.DataObject.RuleTable, { 'Key': 'Patient Class' });
                var patientClassRuleOperator = _.find($scope.DataObject.RuleTable[patientClassRuleTableIndex].RuleOperator, { 'Value': '=' });
                var patientClassRuleTableValue = {
                    ID: $scope.DataObject.SelectedData.PatientClass.Value,
                    Value: $scope.DataObject.SelectedData.PatientClass.Value,
                    Description: "",
                };
                obj = {
                    TableName: 'dbo.Lookups',
                    ColumnName: 'ORDERS.PatientClass',
                    Operator: '=',
                    Value: "'" + $scope.DataObject.SelectedData.PatientClass.Value + "'",
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.DataObject.RuleTable[patientClassRuleTableIndex],
                    RuleOperator: patientClassRuleOperator,
                    RuleTableValue: patientClassRuleTableValue,
                    AndOr: "AND",
                };
                RulesConditions.push(obj);

                //_.remove($scope.DataObject.RuleTable, function (n, index) {
                //    return index == patientClassRuleTableIndex;
                //});
            }
            //0: Routine, 1: Delayed STAT, 2: STAT
            if ($scope.DataObject.SelectedData.StudyPriority && $scope.DataObject.SelectedData.StudyPriority.Key != 'All') {
                var priorityRuleTableIndex = _.findIndex($scope.DataObject.RuleTable, { 'Key': 'Exam Priority' });
                var priorityRuleOperator = _.find($scope.DataObject.RuleTable[priorityRuleTableIndex].RuleOperator, { 'Value': '=' });

                var delayedSTAT = '';
                switch ($scope.DataObject.SelectedData.StudyPriority.Key) {
                    case 'STAT':
                        delayedSTAT = '2';
                        break;
                    case 'DelayedSTAT':
                        delayedSTAT = '1';
                        break;
                    case 'Routine':
                        delayedSTAT = '0';
                        break;
                    case 'URGENT':
                        delayedSTAT = '3';
                        break;
                }
                obj = {
                    TableName: 'Exam Priority',
                    ColumnName: 'ORDERS.DelayedSTAT',
                    Operator: '=',
                    Value: delayedSTAT,
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.DataObject.RuleTable[priorityRuleTableIndex],
                    RuleOperator: priorityRuleOperator,
                    RuleTableValue: {
                        Value: $scope.DataObject.SelectedData.StudyPriority.Value,
                        ID: delayedSTAT
                    },
                    AndOr: "AND",
                };
                RulesConditions.push(obj);



                //_.remove($scope.DataObject.RuleTable, function (n, index) {
                //    return index == priorityRuleTableIndex;
                //});
            }

            if ($scope.DataObject.SelectedData.Status.key != 'AL') {
                var statusRuleTableIndex = _.findIndex($scope.DataObject.RuleTable, { 'Key': 'Exam Status' });
                var statusRuleOperator = _.find($scope.DataObject.RuleTable[statusRuleTableIndex].RuleOperator, { 'Value': '=' });

                obj = {
                    TableName: 'Exam Status',
                    ColumnName: 'ORDERS.ExamStatus',
                    Operator: '=',
                    Value: $scope.DataObject.SelectedData.Status.key == 'H' ? $scope.DataObject.SelectedData.Status.key + ':0' : $scope.DataObject.SelectedData.Status.key,
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.DataObject.RuleTable[statusRuleTableIndex],
                    RuleOperator: statusRuleOperator,
                    RuleTableValue: {
                        Value: _.find($scope.DataObject.OrderStatus, { 'key': $scope.DataObject.SelectedData.Status.key }).value,
                        ID: $scope.DataObject.SelectedData.Status.key,
                    },
                    AndOr: "AND",
                };
                RulesConditions.push(obj);

                //_.remove($scope.DataObject.RuleTable, function (n, index) {
                //    return index == statusRuleTableIndex;
                //});
            }

            $scope.DataObject.Rule = {
                RuleName: workListName,
                RuleDescription: workListName,
                ModifyBy: $sessionStorage.currentUserData.userId,
                IsEnabled: true,
                WorkListName: workListName,
                IsWorkList: "1",
                Groups: [
                    {
                        GroupID: 0,
                        GroupOperator: 'And',
                        RulesConditions: RulesConditions,
                    }
                ],
                RulesProviders: RulesProviders,
                StatusFlag: 'N',
                Type: 'A',
                CreatedBy: $sessionStorage.currentUserData.userId
            };
            //#endregion


            if (RulesConditions && RulesConditions.length > 0) {
                $q.all([
                    RuleSharedService.SetRule($scope.DataObject.Rule)
                ]).then(function (data) {
                    var result = data[0];
                    if (result.RuleID === -1) {
                        toaster.warning({ body: "Worklist name already exists!" });
                    }
                    else {
                        $scope.DataObject.Rule.RuleID = result.RuleID;
                        $scope.DataObject.WorkLists.push(_.cloneDeep($scope.DataObject.Rule));

                        SortWorklistInOrder();

                        for (var i = 0; i < $scope.DataObject.WorkLists.length; i++) {
                            $scope.DataObject.WorkLists[i].role = $scope.DataObject.SelectedData.userRole;
                            $scope.DataObject.WorkLists[i].index = i;
                        }

                        $scope.viewGlobalRuleWorklist($scope.DataObject.Rule);

                        //Add into right side pane
                        var worklistIndex = _.findIndex($scope.DataObject.WorkLists, function (obj) { return obj.RuleID == $scope.DataObject.Rule.RuleID });
                        if (worklistIndex != -1) {
                            $scope.DataObject.WorkLists[worklistIndex].checked = true;
                            $scope.DataObject.WorkLists[worklistIndex].popUpWorklist = false;
                            AddDefaultWorklist($scope.DataObject.WorkLists[worklistIndex]);
                        }

                        if (WorklistListsGridoptions && WorklistListsGridoptions.api) {
                            WorklistListsGridoptions.api.setRowData($scope.DataObject.WorkLists);
                        }
                        toaster.success({ title: "Worklist saved successfully!" });
                    }

                });
            }
            else {
                toaster.info({ title: "Please select atleast one worklist!" });
            }
        }

        function getDosLabel() {
            return ($scope.DataObject.SelectedData.OrderDate && $scope.DataObject.SelectedData.OrderDate.label)
                ? $scope.DataObject.SelectedData.OrderDate.label
                : $scope.DataObject.SelectedData.OrderDateType;
        }

        function hasLocationSelected() {
            var locations = $scope.DataObject.SelectedData.SelectedLocations;
            if (locations && locations.locations && locations.locations.length > 0) return true;
            var ids = $scope.DataObject.SelectedData.locationIDs;
            return !!(ids && ids !== '' && ids !== ',');
        }

        function validateLast5Years() {
            if (getDosLabel() == 'Last 5 Years' && !hasLocationSelected()) {
                toaster.warning({ body: "Please select a Site/Location to use 'Last 5 Years' DOS filter." });
                return false;
            }
            return true;
        }

        $scope.saveFilterOnly = function () {
            if (!validateLast5Years()) return;
            SaveFilterValues();
            angular.element('#ModalWorkList').modal('hide');
        }

        $scope.createWorkList = function () {
            if (getDosLabel() == 'Last 5 Years') {
                toaster.warning({ body: "'Last 5 Years' DOS filter cannot be used to create a Worklist." });
                return;
            }
            saveFilterAsWorkList();
            angular.element('#ModalWorkList').modal('hide');
        }

        $scope.SaveFilters = function () {
            if (!validateLast5Years()) return;
            if (!validateDOS(true)) return;
            angular.element('#ModalWorkList').modal('show');
        };

        function setOrderDate(val, data) {
            var type = null, startDate = null, endDate = null;
            if (val && val.match('Custom')) {
                type = 'Custom';
                startDate = val.split('#')[1];
                endDate = val.split('#')[2];
            }
            else {
                type = val;
            }
            data.OrderDateType = type;
            switch (type) {
                case 'Today':
                    data.OrderDate = {
                        startDate: moment(moment().format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;

                case 'Last 3 Days':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(2, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 7 Days':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 30 Days':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(29, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Custom':
                    //data.OrderDate = {
                    //    startDate: moment(startDate),
                    //    endDate: moment(endDate)
                    //};
                    data.OrderDate = {
                        startDate: moment(moment(startDate).format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment(endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    data.OrderDateType = 'Custom range';
                    break;
                case 'Last Year':
                    data.OrderDate = {
                        startDate: moment((moment().subtract(1, 'year').add(1, 'days')).format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 5 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(5, 'years').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'All DOS':
                    data.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                case 'Clear':
                    data.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                default:
                    data.OrderDate = {
                        startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    data.OrderDateType = 'Last 7 Days';
                    break;
            }

            var timeout = $timeout(function () {
                data.toolTipOrderDate = data.OrderDate.startDate && data.OrderDate.endDate ? 'DOS: ' + data.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + data.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                $timeout.cancel(timeout);
                timeout = null;
            }, 0);
        }

        //Window resizing
        $(window).resize(function () {
            if ($state.current.url != "/worklist-lite") {
                return;
            }
            if (!validateDOS(false)) return;
            setHalfScale();

            setHeight();

            if (previousHeight != currentHeight) {
                previousHeight = currentHeight;
            }
        });

        function setHalfScale() {
            halfScale = false;
            if ($(window).width() < 1199) {
                halfScale = true;
            }
        }

        function refreshDOS() {
            if (refreshDOSMidnight) {
                $interval.cancel(refreshDOSMidnight);
                refreshDOSMidnight = $interval(refreshDOS, refreshDOSInterval);
            }
            updateRefreshDOSInterval();

            $scope.DataObject.SelectedData.OrderDateType = ($scope.DataObject.SelectedData && $scope.DataObject.SelectedData.OrderDate && $scope.DataObject.SelectedData.OrderDate.label) ? $scope.DataObject.SelectedData.OrderDate.label : $scope.DataObject.SelectedData.OrderDateType;
            if ($scope.DataObject.SelectedData.OrderDate.startDate && $scope.DataObject.SelectedData.OrderDate.endDate) {
                if ($scope.DataObject.SelectedData.OrderDateType != null && $scope.DataObject.SelectedData.OrderDateType.match('Custom'))
                    $scope.DataObject.SelectedData.OrderDateType = ($scope.DataObject.SelectedData.OrderDateType != null && $scope.DataObject.SelectedData.OrderDateType.match('Custom')) ? ($scope.DataObject.SelectedData.OrderDateType + '#' + moment(new Date($scope.DataObject.SelectedData.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                        moment(new Date($scope.DataObject.SelectedData.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.DataObject.SelectedData.OrderDateType;

            }
            setOrderDate($scope.DataObject.SelectedData.OrderDateType, $scope.DataObject.SelectedData);
        }

        $scope.$on("OpenDiscussionOrder", function (evt, OD) {
            $scope.DataObject.SelectedData.OpenDiscussion = false;
            $scope.$broadcast('event.worklist', { EventType: 'OpenDiscussionOrder', OD: OD })
        });

        $scope.$on("ReLoadDiscussion", function (evt, OD) {
            $scope.$broadcast('event.worklist', { EventType: 'ReLoadDiscussion', OD: OD });

        });

        $scope.$on("UnAssignStudy", function (evt, OD) {
            $scope.$broadcast('event.worklist', { EventType: 'UnAssignStudy', OD: OD });

        });

        $scope.$on('event.OpenSynapse', function (evt, data) {
            CommonService.LogApplicationInfo({ LogDetails: '[' + data.correlationId + '] Step2-EventHandler: event.OpenSynapse received, calling SharedService viewer=' + data.OptionalDV, Application: 'PACS-Viewer', UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '' });
            OpenSynapseStudy(data.Order, data.OptionalDV, data.isOpenPS, data.isSingleView, data.correlationId);
        });
        $scope.$on('event.CloseReport', function (evt, data) {
            closePS360(data.Order);
            //closeVR();
        });

        $scope.$on('event.OpenVR', function (evt, data) {
            CommonService.LogApplicationInfo({ LogDetails: '[' + data.correlationId + '] Step2-EventHandler-CIVR: event.OpenVR received', Application: 'PACS-Viewer', UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '' });
            $scope.OpenVR(data.order, data.isSingleView, data.correlationId);
        });
        $scope.$on('angular-resizable.resizeEnd', function (evt, data) {
            var id = data.id;
            try {
                id = _.toInteger(data.id);
            } catch (e) {
                $log.log("angular-resizable.resizeEnd > e: ", e);
            } finally {
                id = id == 0 ? data.id : id;
            }
            var index = _.findIndex($scope.DataObject.DefaultWorklists, function (obj) { return obj.RuleID == id });
            //$log.log("angular-resizable.resizeEnd > index: ", index);
            if (index != -1) {
                var PageSize = getPageSize(data.height);
                //$log.log("angular-resizable.resizeEnd > PageSize: ", PageSize);
                $scope.DataObject.DefaultWorklists[index].PageSize = _.toInteger(PageSize);
                $scope.DataObject.DefaultWorklists[index].height = data.height;
                $scope.DataObject.DefaultWorklists[index].heightChangedManually = true;

                var mWorklistIndex = _.findIndex(MasterDefaultWorklistData, function (item) { return _.toString(item.RuleID) == _.toString($scope.DataObject.DefaultWorklists[index].RuleID); });
                if (mWorklistIndex != -1) {
                    MasterDefaultWorklistData[mWorklistIndex].LayoutOptions = JSON.stringify($scope.DataObject.DefaultWorklists[index]);
                    MasterDefaultWorklistData[mWorklistIndex].Type = 'M';

                    UpdatedMasterWorklists.push(MasterDefaultWorklistData[mWorklistIndex]);
                }
                MasterDefaultWorklistData = _.sortBy(_.uniqBy(MasterDefaultWorklistData, 'RuleID'), 'WorkistOrder');
                SetWorklistLayoutPreference('M');
                //$scope.$broadcast('event.worklist', { EventType: 'resizePanel', resizeData: data, PageSize: PageSize });
            }

            CalculateHeight();

            var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);
            _.each(defaultWorklist, function (worklist) {
                worklist.purge = true;
                worklist.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
            });
            $scope.DataObject.DefaultWorklists = _.uniqBy(defaultWorklist, 'RuleID');
            //console.log("angular-resizable.resizeEnd: ", $scope.DataObject.DefaultWorklists);

        });
        $scope.$on('event.Rule.Save', function (evt, data) {
            if (data && data.Rule && data.Rule.WorkListName) {
                data.Rule.popUpWorklist = false
                var Groups = _.filter(data.Rule.Groups, function (group) { return group.GroupID != -1; });
                data.Rule.Groups = Groups;
                data.Rule.TimeToLoad = moment();
                var worklistIndex = _.findIndex($scope.DataObject.WorkLists, function (obj) { return obj.RuleID == data.Rule.RuleID });
                if (worklistIndex == -1) {
                    $scope.DataObject.WorkLists.push(_.cloneDeep(data.Rule));
                } else {
                    $scope.DataObject.WorkLists[worklistIndex] = _.cloneDeep(data.Rule);
                }
                SortWorklistInOrder();
                var masterDefaultWorklistIndex = _.findIndex(MasterDefaultWorklistData, function (obj) { return _.toString(obj.RuleID) == _.toString(data.Rule.RuleID); });
                if (data.HideWindow) {
                    var defaultWorklistIndex = _.findIndex($scope.DataObject.DefaultWorklists, function (obj) { return obj.RuleID == data.Rule.RuleID });
                    if (defaultWorklistIndex == -1) {
                        if (data.HideWindow && masterDefaultWorklistIndex == -1) {
                            //Open Window
                            data.Rule.checked = true;
                            data.Rule.popUpWorklist = false;
                            $scope.viewGlobalRuleWorklist(data.Rule);

                            //Add into right side pane
                            //AddDefaultWorklist(data.Rule);
                        }
                    } else {
                        data.Rule.purge = true;
                        data.Rule.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
                        data.Rule.OpenClipboardNextStudy = _.isEmpty($localStorage.OpenClipboardNextStudy) ? true : $localStorage.OpenClipboardNextStudy;
                        $scope.DataObject.DefaultWorklists[defaultWorklistIndex] = _.cloneDeep(data.Rule);
                        //console.log("event.Rule.Save: ", $scope.DataObject.DefaultWorklists);
                        CalculateHeight();
                    }
                }

                if (WorklistListsGridoptions && WorklistListsGridoptions.api) {
                    WorklistListsGridoptions.api.setRowData($scope.DataObject.WorkLists);
                    WorklistListsGridoptions.api.redrawRows();
                    if (data.HideWindow && masterDefaultWorklistIndex == -1) {
                        var node = WorklistListsGridoptions.api.getRowNode(data.Rule.RuleID);
                        if (node) {
                            node.setSelected(true);
                        }
                    }
                }
            }

            if (data.HideWindow) {
                $scope.DataObject.ModalWorklistOpened = false;

                angular.element('#ModalEditWorkList').modal('hide');
            }
            //$scope.$broadcast('event.worklist', { EventType: 'Reload', WorklistID: data.Rule.RuleID, });
        });

        $scope.$on('event.Rule.Close', function (evt, data) {

            if (data.HideWindow) {
                $scope.DataObject.ModalWorklistOpened = false;

                angular.element('#ModalEditWorkList').modal('hide');
            }
            //$scope.$broadcast('event.worklist', { EventType: 'Reload', WorklistID: data.Rule.RuleID, });
        });

        $scope.$on("deleteFile", function (evt, count) {

            $scope.$broadcast('event.worklist', { EventType: 'deleteFile', FileCount: count });
        });


        $scope.$on("event.worklist.clipboard", function (evt, data) {
            CopyToClipboard(data.ClipboardConditionData);
        });

        $scope.$on("event.NotifyRemoveFromClipboard", function (evt, data) {
            SharedService.handleRemoveFromClipboard(data, $scope.DataObject.RuleTable);
        });
        var _unbindOverdueAccess = $rootScope.$on('overdueAccessGranted', function () {
            GetOverdueReadsCount(true);
        });
        $scope.$on('event.closeDicomViewer', function (evt, data) {
            windowHandler.CloseWindow(["CI-VIEWER-1-" + data.Accession.toUpperCase().trim(),
            "CI-VIEWER-2-" + data.Accession.toUpperCase().trim(),
            'KONICA-' + data.Accession.toUpperCase().trim(),
            'KONICATEST-' + data.Accession.toUpperCase().trim(),
            'MedDreamViewer-' + data.Accession.toUpperCase().trim(),
            'NORTHSTARKONICA-' + data.Accession.toUpperCase().trim()]);
            if ($sessionStorage.MedDreamViewerKeepOpen) {
                SharedService.clearMedDreamViewer();
            } else {
                SharedService.closeMedDreamViewer();
            }
        });
        function CopyToClipboard(ClipboardConditionData) {
            var ClipboardConditionData = ClipboardConditionData;
            var ruleObjIndex = _.findIndex($scope.DataObject.GlobalRules, function (obj) { return obj.WorklistType == 16; });

            if ($scope.DataObject.GlobalRules[ruleObjIndex] && $scope.DataObject.GlobalRules[ruleObjIndex].RuleID) {
                RuleSharedService.UpdateRuleTable($scope.DataObject.RuleTable);
                getClipoardRuleDetail({ RuleID: $scope.DataObject.GlobalRules[ruleObjIndex].RuleID }).then(function (response) {
                    $scope.DataObject.GlobalRules[ruleObjIndex] = _.clone(response);

                    if ($scope.DataObject.GlobalRules[ruleObjIndex].Groups.length > 0) {
                        $scope.DataObject.GlobalRules[ruleObjIndex].Groups[0].GroupOperator = "AND";
                        $scope.DataObject.GlobalRules[ruleObjIndex].Groups[0].deleted = false;
                        updateClipboardData(ClipboardConditionData, $scope.DataObject.GlobalRules[ruleObjIndex].Groups[0].RulesConditions);
                        if (ClipboardConditionData.ActionType == 'Reset') {
                            $scope.DataObject.GlobalRules[ruleObjIndex].Groups[0].deleted = true;
                        }
                    } else {
                        createClipboardWorklist($scope.DataObject.GlobalRules[ruleObjIndex], ClipboardConditionData);
                    }
                    $scope.DataObject.GlobalRules[ruleObjIndex].StatusFlag = "M";
                    $scope.DataObject.GlobalRules[ruleObjIndex].TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
                    setClipboardRule($scope.DataObject.GlobalRules[ruleObjIndex], ClipboardConditionData);

                });




            }
            else {
                RuleSharedService.UpdateRuleTable($scope.DataObject.RuleTable);
                RuleSharedService.SetData($scope.DataObject.RuleTable, AllRadiologists);

                var Rule = { Groups: [], RulesProviders: [], IsEnabled: true, IsWorkList: true, Type: "A" };

                createClipboardWorklist(Rule, ClipboardConditionData);
                updateClipboardRule(Rule);
                setClipboardRule(Rule, ClipboardConditionData);
            }
        }

        function setModalitytooltip(params) {
            modalityIDs = '';
            if (params.Modality && params.Modality.length > 0) {
                var timeout = $timeout(function () { $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;'); }, 1);
                TimeoutList.push(timeout)
                $('.anui').addClass("set-modality-height");
                params.modalitytooltip = '';
                var objModality = $filter('orderBy')(params.Modality, 'Code');
                _.each(objModality, function (data) {
                    if (params.modalitytooltip.length > 0) {
                        params.modalitytooltip = params.modalitytooltip + " \n" + data.Code;    //Bug 21548: Unable to see the selected Modalities on tooltip of worklist & tech worklist page
                    }
                    else if (params.modalitytooltip.length == 0) {
                        params.modalitytooltip = data.Code;
                    }
                    if (modalityIDs.length > 0) { modalityIDs = modalityIDs + "," + data.Id; }
                    else { modalityIDs = data.Id; }
                });
            }
            else {
                $('.anui').removeClass("set-modality-height");
                var timeout = $timeout(function () { $('.ui-grid-render-container-body .ui-grid-viewport').attr('style', 'transition: height 1s;'); }, 1);
                TimeoutList.push(timeout)
                params.modalitytooltip = 'Select Modalities';
            }
        }

        $scope.onSelectedModalityQS = function (selectedData, field) {
            //field.Modality = field.value ? field.value : selectedData;
            field.Modality = selectedData;
            setModalitytooltip(field);
        }

        $scope.clearSelModaValue = function (data) {
            data.Modality = data.value ? data.value : data.Modality;
            data.Modality = null;
            data.value = null;
            data.modalitytooltip = 'Select Modalities';
            $('.anui').removeClass("set-modality-height");
        }

        $scope.setStatus = function () {
            var status = $scope.WorklistPageHeaderParameter.Status;
            if (status == 'Stat') {
                $scope.DataObject.SelectedData.STATFilter = !$scope.DataObject.SelectedData.STATFilter;
                $scope.DataObject.SelectedData.StudyPriority = _.find($scope.DataObject.MasterData.StudyPriorities, { Key: 'STAT' });
            }
            else if (status == 'ST') {
                $scope.DataObject.SelectedData.STATFilter = false;
                $scope.DataObject.SelectedData.Status.key = status;
            }
            else {
                $scope.DataObject.SelectedData.STATFilter = false;
                $scope.DataObject.SelectedData.Status.key = status;
            }
            $scope.filter();

        }

        function intiAppHub() {
            AppHub = AppHubService.getAppHub();
            var justCreated = false;
            if (!AppHub && $sessionStorage.currentUserData) {
                AppHubService.Initialize();
                AppHub = AppHubService.getAppHub();
                justCreated = true;
            }
            if (AppHub) {
                AppHubMethod();
                if (justCreated) AppHubService.startConnection();
            }
        }

        function AppHubMethod() {
            AppHub.on('RadFlowAppHubEvent', function (obj) {
                switch (obj.EventType) {
                    case 'orderdiscussionhandler':
                        var discussion = obj.EventArgs;
                        var orderID = obj.EventArgs.orderID;
                        isOrderOnServer = true;
                        $scope.$broadcast('event.worklist', { EventType: 'OrderDiscussionHandler', discussion: discussion, orderID: orderID });
                        break;
                    case 'notifyassignstudy':
                        var OrderDiscussion = obj.EventArgs;
                        $scope.$broadcast('event.worklist', { EventType: 'NotifyAssignStudy', OrderDiscussion: OrderDiscussion });
                        isOrderOnServer = true;
                        break;
                    case 'notifyorderlistupdatereportfromscrapper':
                        $log.log('NotifyOrderListUpdateReportFromScrapper is call');
                        isOrderOnServer = true;
                        break;
                    case 'orderslistattachmentupdatehandler':
                        var DiacomOrderId = obj.EventArgs.DicomOrderID;
                        var count = obj.EventArgs.Count;
                        isOrderOnServer = true;
                        $timeout(function () {
                            $rootScope.$broadcast('event.worklist', { EventType: 'OrdersListAttachmentUpdateHandler', DiacomOrderId: DiacomOrderId, count: count });
                        });
                        break;
                    case 'orderlistupdatehandlerprw':
                        isOrderOnServer = true;
                        break;
                    case 'orderlistupdatehandlerpsw':
                        isOrderOnServer = true;
                        break;
                    case 'processedordersupdate':
                        var ProcessedOrder = obj.EventArgs;
                        isOrderOnServer = true;
                        $scope.$broadcast('event.worklist', { EventType: 'ProcessedOrdersUpdate', ProcessedOrder: ProcessedOrder });
                        OrderProcessed = true;
                        break;
                    case 'notifyopenorder':
                        var OrderID = obj.EventArgs.OrderID;
                        var isOpen = obj.EventArgs.Open;
                        var ProviderID = obj.EventArgs.ProviderID;
                        var ProviderName = obj.EventArgs.ProviderName;
                        isOrderOnServer = true;
                        $scope.$broadcast('event.worklist', { EventType: 'NotifyOpenOrder', OrderID: OrderID, isOpen: isOpen, ProviderID: ProviderID, ProviderName: ProviderName });

                        break;
                    case 'notifyshowhideorder':
                        var OrderID = obj.EventArgs.OrderID;
                        var IsHide = obj.EventArgs.Hide;
                        console.log('[NotifyShowHideOrder] SignalR event received - OrderID:', OrderID, 'IsHide:', IsHide);
                        isOrderOnServer = true;
                        $scope.$broadcast('event.worklist', { EventType: 'NotifyShowHideOrder', OrderID: OrderID, IsHide: IsHide });
                        console.log('[NotifyShowHideOrder] event.worklist broadcast sent - OrderID:', OrderID);
                        break;
                    case 'notifyoruupdate':
                        var clipboardRule = _.find($scope.DataObject.GlobalRules, { WorklistType: 16 });
                        $scope.$broadcast('event.worklist', { EventType: 'NotifyORUUpdate', Accession: obj.EventArgs.Accession, ClipboardRuleID: clipboardRule ? clipboardRule.RuleID : 0 });
                        isOrderOnServer = true;
                        break;
                    case 'notifyorderlistupdatereport':
                        var userID = obj.EventArgs.userID;
                        var OrderID = obj.EventArgs.OrderID;
                        isOrderOnServer = true;
                        break;
                    case 'notifyorderlistupdatereportfromradflow':
                        var userID = obj.EventArgs.userID;
                        var OrderID = obj.EventArgs.OrderID;
                        isOrderOnServer = true;
                        $scope.$broadcast('event.worklist', {
                            EventType: 'NotifyOrderListUpdateReportFromRadFLow', OrderID: OrderID
                        });
                        if ($sessionStorage.HasSOLAccess) {
                            GetXRayCountByUser();
                        }
                        GetUserPaymentHeader();
                        break;
                    case 'notifyorderlistsavereport':
                        isOrderOnServer = true;
                        $scope.$broadcast('event.worklist', { EventType: 'NotifyOrderListSaveReport', OrderID: obj.EventArgs.OrderId });
                        break;
                    case 'userstatushandler':
                        var userID = obj.EventArgs.userID;
                        var status = obj.EventArgs.status;
                        var user = _.filter($scope.DataObject.MasterData.Radiologists, function (user) { return user.Id == userID; });
                        if (user && user.length > 0) {
                            user[0].IsOnline = status;
                        }
                        break;
                    case 'notifyclipboard':
                        var worklistIndex = _.findIndex($scope.DataObject.DefaultWorklists, function (wl) { return wl.WorklistType == 16 });
                        if (worklistIndex != -1) {
                            $scope.$broadcast('event.worklist', { EventType: 'Reload', WorklistID: $scope.DataObject.DefaultWorklists[worklistIndex].RuleID, ClipboardConditionData: JSON.parse(obj.EventArgs) });
                        }
                        else if ($scope.DataObject.WorklistPopupTitle == 'My ClipBoard') {
                            var globalworklistIndex = _.findIndex($scope.DataObject.GlobalRules, { WorklistType: 16 });
                            $scope.$broadcast('event.worklist', { EventType: 'Reload', WorklistID: $scope.DataObject.GlobalRules[globalworklistIndex].RuleID, ClipboardConditionData: JSON.parse(obj.EventArgs) });
                        }
                        else {
                            $scope.$broadcast('event.worklist', { EventType: 'Reload', ClipboardConditionData: JSON.parse(obj.EventArgs) });
                            UpdateTimeToLoad();
                        }

                        break;

                    case 'notifyremoveorderidfromclipboard':
                        $scope.$broadcast('event.worklist', { EventType: 'notifyremoveclipboardicon', OrderID: obj.EventArgs.OrderID });
                        break;
                    case 'notifyupdateorderdetail':
                        $scope.$broadcast('event.worklist', { EventType: 'notifyupdateorderdetail', OrderDetail: obj.EventArgs });
                        break;
                    case 'notifypostorderormqueuemsg':
                        CommonService.notifypostorderormqueuemsg(obj);
                        break;
                    case 'removeMultipleOrderFromClipboard':
                        $scope.$broadcast('event.worklist', { EventType: 'removeMultipleOrderFromClipboard', OrderIDs: obj.EventArgs });
                        break;
                }
            });
        }

        //#region Instance Worklist Tour
        var tour = new Tour({
            steps: [],
            backdrop: true,
            onShown: function (tour) {
                if (tour && tour._options) {
                    var step = tour._options.steps[tour._current];
                    $(step.element).addClass('tour-section-disbl');
                }
            },
            onHidden: function (tour) {
                if (tour && tour._options) {
                    var step = tour._options.steps[tour._current];
                    $(step.element).removeClass('tour-section-disbl');
                }
            },
            onNext: function (tour) {
                if (tour && tour._options) {
                    var step = tour._options.steps[tour._current];
                    switch (step.element) {
                        case ".stepWorklistPan":
                            tour._options.steps[2].template = quickSearchTabStep;
                            break;
                        case ".stepQuickFilter":
                            if ($scope.DataObject.wlTabName != 'Worklist' && $scope.DataObject.DockerPosition != 'Top') {
                                var timeout = $timeout(function () {
                                    $scope.setWorklistTab('Worklist', true);
                                }, 500);
                                TimeoutList.push(timeout)
                            }
                            break;
                        case ".stepCherryPan":
                            if ($scope.DataObject.wlTabName != 'Worklist' && $scope.DataObject.DockerPosition != 'Top') {
                                var timeout = $timeout(function () {
                                    $scope.setWorklistTab('Worklist', true);
                                }, 100);
                                TimeoutList.push(timeout)
                            }
                            break;
                        case ".stepMissedPan":
                            if ($scope.DataObject.wlTabName != 'Worklist' && $scope.DataObject.DockerPosition != 'Top') {
                                var timeout = $timeout(function () {
                                    $scope.setWorklistTab('Worklist', true);
                                }, 100);
                                TimeoutList.push(timeout)
                            }
                            break;
                        case ".stepClipboardPan":
                            if ($scope.DataObject.wlTabName != 'Worklist' && $scope.DataObject.DockerPosition != 'Top') {
                                var timeout = $timeout(function () {
                                    $scope.setWorklistTab('Worklist', true);
                                }, 100);
                                TimeoutList.push(timeout)
                            }
                            tour._options.steps[7].title = worklistTabStep.title;
                            tour._options.steps[7].content = worklistTabStep.content;
                            tour._options.steps[7].template = worklistTabStep.template;
                            break;
                        case ".rf-accordion .panel-group worklist-accordion:first-child .ag-root-wrapper .ag-header .ag-pinned-left-header .ag-header-cell .ag-cell-label-container .ag-header-icon.ag-header-cell-menu-button":
                            var ele = $(".rf-accordion .panel-group worklist-accordion:first-child .ag-root-wrapper .ag-body .ag-center-cols-clipper .ag-row-position-absolute.ag-row-first")
                            if (!ele || ele.length == 0) {
                                tour.end();
                            }
                            break;
                    }
                }
            },
            onPrev: function (tour) {
                if (tour && tour._options) {
                    var step = tour._options.steps[tour._current];
                    switch (step.element) {
                        case ".stepCherryPan":
                            if ($scope.DataObject.wlTabName != 'Search' && $scope.DataObject.DockerPosition != 'Top') {
                                var timeout = $timeout(function () {
                                    $scope.setWorklistTab('Search', true);
                                }, 300);
                                TimeoutList.push(timeout)
                            }
                            break;
                        case ".stepMissedPan":
                            if ($scope.DataObject.wlTabName != 'Search' && $scope.DataObject.DockerPosition != 'Top') {
                                var timeout = $timeout(function () {
                                    $scope.setWorklistTab('Search', true);
                                }, 200);
                                TimeoutList.push(timeout)
                            }
                            break;
                        case ".stepClipboardPan":
                            if ($scope.DataObject.wlTabName != 'Search' && $scope.DataObject.DockerPosition != 'Top') {
                                var timeout = $timeout(function () {
                                    $scope.setWorklistTab('Search', true);
                                }, 100);
                                TimeoutList.push(timeout)
                            }
                            break;
                        case ".stepNewWorklist":
                            if ($scope.DataObject.wlTabName != 'Search' && $scope.DataObject.DockerPosition != 'Top') {
                                var timeout = $timeout(function () {
                                    $scope.setWorklistTab('Search', true);
                                    $timeout.cancel(timeout);
                                    timeout = null;
                                }, 200);
                            }
                            break;
                    }
                }
            },
            onEnd: function (tour) {
                $('.tour-section-disbl').removeClass('tour-section-disbl');
                updateuserguidepreference();
                var releasetourtimeout = $timeout(function () {
                    if (!ShowReleaseGuide || ShowReleaseGuide.PreferenceValue != APP_CONSTANTS.radflowUIVersion) {
                        $rootScope.$broadcast('startReleaseTour', true);
                    }

                    $timeout.cancel(releasetourtimeout);
                    releasetourtimeout = null;
                }, 100);
            },
        });

        function startUserGuideTour() {
            var d = $q.defer();
            if (!userLayoutPreference || (userLayoutPreference && !userLayoutPreference.DockPanelPref) || (userLayoutPreference && userLayoutPreference.DockPanelPref && !userLayoutPreference.DockPanelPref.DockerPosition)) {
                angular.element('#wrklstFilterWraaper').css('display', 'block');
            }
            if (!showUserGuide || showUserGuide.PreferenceValue != "0") {
                $sessionStorage.isStartUserGuideTour = true;
                tour.init();
                if ($scope.DataObject.wlTabName != 'Search') {
                    $scope.setWorklistTab('Search')
                }
                initialiseSidePanel().then(function () {
                    searchTabStep = searchTabNotTopStep;
                    quickSearchTabStep = quickSearchTabNotTopStep;
                    worklistTabStep = worklistTabNotTopStep;
                    tour.setCurrentStep(0);
                    tour.start(true);
                    if (tour._inited) {
                        $scope.DataObject.iswlTabAutoHide = false;
                    }
                    d.resolve();
                });
            }
            else {
                initialiseSidePanel().then(function () { d.resolve(); });
            }
            return d.promise;
        }
        //#endregion Instance Worklist Tour

        PageInIt();

        $scope.$on('$destroy', function () {
            $("#mainDiv").hide();
            //DeleteOpenOrderByUserID();
            if ($scope.DataObject.AccordianShow && angular.element('#uibDefaultWorklistsaccordion').length > 0) {
                document.getElementById("uibDefaultWorklistsaccordion").remove();
            }
            $scope.DataObject.AccordianShow = false;
            AppHub.off("RadFlowAppHubEvent");
            AppHub = null;

            //windowHandler.DoNotCloseWindow(['Analytics']);
            if (refreshDOSMidnight) {
                $interval.cancel(refreshDOSMidnight);
                refreshDOSMidnight = undefined;
            }
            if (newOrderRefreshInterval) {
                $interval.cancel(newOrderRefreshInterval);
                newOrderRefreshInterval = undefined;
            }
            $('.popover.tour').css("display", "none");
            $('.tour-backdrop.top').css("display", "none");
            $('.tour-backdrop.bottom').css("display", "none");
            $('.tour-backdrop.left').css("display", "none");
            $('.tour-backdrop.right').css("display", "none");
            tour = null;
            StopRC();
            _.each(TimeoutList, function (timeout) { $timeout.cancel(timeout); })

        });

        $scope.OpenVR = function (order, isSingleView, correlationId) {
            SharedService.OpenVR(order, isSingleView, correlationId);
        };

        function cleanCIVRparamObj(order) {
            var obj = _.cloneDeep(order)
            if (obj.hasOwnProperty('listOrderListAssignment')) {
                delete obj.listOrderListAssignment
            }
            if (obj.hasOwnProperty('subGridOptions')) {
                delete obj.subGridOptions
            }
            if (obj.hasOwnProperty('OrderReport')) {
                delete obj.OrderReport
            }
            if (obj.hasOwnProperty('listOrderListAssignment')) {
                delete obj.listOrderListAssignment
            }
            return obj;
        }

        function openKonica(order, Viewer) {
            $scope.konica_RadFlow = windowHandler.openByPreference(__env._environment.config.konicaBaseURL.replace("@MRN", order.PatientMRN).replace("@ACCESSION", order.Accession).replace("@VIEWER", Viewer), Viewer, 100, Viewer.replace(/\s/g, "").toUpperCase() + "-" + order.Accession.toUpperCase().trim(), "noreferrer");
        }

        window.onmessage = function (event) {
            //$log.log("onmessage");
            var d = event.data;
            if (d.cmd === 'redirectClose') {
                if ($scope.konica_Redirect) {
                    $scope.konica_Redirect.close()
                }
            }
            if (d.cmd === 'radflowObject') {
                if (d.data.SelectedOrder) {

                    windowHandler.CloseWindow(["CI-VIEWER-1-" + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    "CI-VIEWER-2-" + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    'KONICA-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    'KONICATEST-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    'MedDreamViewer-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    'NORTHSTARKONICA-' + d.data.SelectedOrder.Accession.toUpperCase().trim()]);
                    if ($sessionStorage.MedDreamViewerKeepOpen) {
                        SharedService.clearMedDreamViewer();
                    } else {
                        SharedService.closeMedDreamViewer();
                    }

                    var clipboardRule = _.find($scope.DataObject.GlobalRules, { WorklistType: 16 });

                    if ($scope.DataObject.SelectedData.OpenFromWorklist) {
                        $scope.$broadcast('event.worklist', {
                            EventType: 'Dictation',
                            DictationReportState: 'DictateByCIVR',
                            SelectedOrder: d.data.SelectedOrder,
                            RuleID: $scope.DataObject.SelectedData.RuleID,
                            ClipboardRuleID: clipboardRule ? clipboardRule.RuleID : 0
                        });
                        GetSignSummary();
                        if ($sessionStorage.HasSOLAccess) {
                            GetXRayCountByUser();
                        }
                        GetUserPaymentHeader();
                        GetWorklistStatusCount();
                GetOverdueReadsCount();
                        $scope.DataObject.SelectedData.OpenFromWorklist = false;
                    }
                    else {
                        $rootScope.$broadcast("DictationChatList", {
                            EventType: 'Dictation',
                            DictationReportState: 'DictateByCIVR',
                            SelectedOrder: d.data.SelectedOrder,
                        });
                    }
                }
            }
        }

        window.onbeforeunload = function (event) {
            if ($scope.konica_RadFlow && !$scope.konica_RadFlow.closed) {
                $scope.konica_RadFlow.close();
            }
            windowHandler.DoNotCloseWindow(['Analytics']);
            event.preventdefault(true);
            return true;
        };

        $scope.deleteWorklist = function (_rule) {
            swal({
                title: "Are you sure you want to delete this worklist?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#6A9944",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: false,
                showCloseButton: true
            },
                function (isConfirm) {
                    if (isConfirm) {


                        addLoadingCursor();
                        var timeoutSwalclose = $timeout(function () {

                            swal.close();

                            var rule = _.cloneDeep(_rule);

                            _.remove($scope.DataObject.WorkLists, function (n) {
                                return n.RuleID == rule.RuleID;
                            });

                            if (WorklistListsGridoptions && WorklistListsGridoptions.api) {
                                WorklistListsGridoptions.api.applyTransaction({
                                    remove: [{ RuleID: rule.RuleID }]
                                });
                            }

                            _.remove($scope.DataObject.DefaultWorklists, function (n) {
                                return n.RuleID == rule.RuleID;
                            });

                            var removedMasterWorklistData = _.remove(MasterDefaultWorklistData, function (masterObj) {
                                return masterObj.RuleID == rule.RuleID;
                            });



                            var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);
                            _.each(defaultWorklist, function (worklist) {
                                worklist.purge = true;
                                worklist.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
                            });
                            $scope.DataObject.DefaultWorklists = _.uniqBy(defaultWorklist, 'RuleID');
                            //console.log("deleteWorklist: ", $scope.DataObject.DefaultWorklists);
                            CalculateHeight();

                            if (removedMasterWorklistData.length > 0) {
                                removedMasterWorklistData[0].Type = 'D';
                                UpdatedMasterWorklists.push(removedMasterWorklistData[0]);
                                MasterDefaultWorklistData = _.sortBy(_.uniqBy(MasterDefaultWorklistData, 'RuleID'), 'WorkistOrder');
                                SetWorklistLayoutPreference('D');

                            }
                            RuleSharedService.DeleteRule(rule);

                            removeLoadingCursor();

                            $timeout.cancel(timeoutSwalclose);
                            timeoutSwalclose = null;
                        }, 500);



                    }
                }
            );
        }

        $scope.editAdminWorklist = function (workListId) {
            $sessionStorage.workListId = workListId;
            $state.go('settings.rule');
        }

        function getWorklistPrefrence() {
            var d = $q.defer();
            var data = {
                UserID: $sessionStorage.currentUserData.userId,

                UserLayoutPreferenceDto: {
                    PageId: $state.current.name + "." + $state.current.controller,
                    ControlId: 'WorkList_ListGrid'
                }
            };
            WorklistService.GetWorklistPrefrences(data).then(function (WorklistPrefrence) {

                //RVUs removed from Worklist Preferences

                //Modalities
                getPrefModalities(WorklistPrefrence);

                //Site and Locations
                getPrefSiteAndLocations(WorklistPrefrence);

                //UserPreferences
                getPrefUserPreferences(WorklistPrefrence);

                //Lookups
                getPrefLookups(WorklistPrefrence);

                //Rules
                getPrefRules(WorklistPrefrence);
                getPrefPSW(WorklistPrefrence);
                RenderWorklistLayout(WorklistPrefrence)

                d.resolve();

            });
            return d.promise;
        }

        function hideNotification() {
            Notification.clearAll();
        }

        $scope.refreshAndHideNotification = function () {
            if (!validateDOS(true)) return;
            hideNotification();
        }

        $scope.filter = function () {
            if (!validateLast5Years()) return;
            if (!validateDOS(true)) return;
            openSearchedWorklist('S');
        }


        function getPrefModalities(WorklistPrefrence) {
            var d = $q.defer();
            if (WorklistPrefrence != null && WorklistPrefrence.Modalities && WorklistPrefrence.Modalities.length > 0) {
                $scope.DataObject.MasterData.Modalities = WorklistPrefrence.Modalities;
                d.resolve();
            }
            return d.promise;
        }

        function getPrefSiteAndLocations(WorklistPrefrence) {
            var d = $q.defer();
            if (WorklistPrefrence != null && WorklistPrefrence.SiteandLocations && WorklistPrefrence.SiteandLocations.length > 0) {
                $scope.DataObject.MasterData.Locations = _.filter(WorklistPrefrence.SiteandLocations, function (obj) { return obj.SiteID != 0; });
                d.resolve();
            }
            return d.promise;
        }

        function getPrefUserPreferences(WorklistPrefrence) {
            var d = $q.defer();
            if (WorklistPrefrence != null && WorklistPrefrence.UserPreferences && WorklistPrefrence.UserPreferences.length > 0) {

                var pref1 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "Choose Next Study"; });
                $scope.DataObject.SelectedData.ChooseNextStudy = (pref1 != null && pref1.length > 0 && pref1[0].PreferenceValue == "1") ? true : false;
                pref1 = null;

                var pref3 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "ShowLockStudy"; });
                if (pref3 != null && pref3.length > 0) {
                    $scope.DataObject.SelectedData.ShowLockStudy = (pref3 != null && pref3.length > 0 && pref3[0].PreferenceValue == "1") ? true : false;
                }
                pref3 = null;

                var pref4 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "DefaultDicomViewer"; });
                if (pref4 != null && pref4.length > 0 && pref4[0].PreferenceValue) {
                    $scope.DataObject.SelectedData.DefaultDicomViewer = pref4[0].PreferenceValue;
                }
                pref4 = null;

                var pref5 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "DeficientWarningOnWorklist"; });
                $scope.DataObject.SelectedData.DeficientWarningOnWorklist = (pref5 != null && pref5.length > 0 && pref5[0].PreferenceValue == "1") ? true : false;
                pref5 = null;

                var pref6 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "DisplaySetting"; });
                if (pref6 && pref6.length > 0) {
                    var childPref6 = _.filter(JSON.parse(pref6[0].PreferenceValue), function (obj) { return obj.HostFingerPrintHash == $sessionStorage.currentUserData.HostFingerPrintHash });
                    if (childPref6 && childPref6.length > 0) {
                        windowHandler.LoadPrefenece(childPref6[0].DisplaySetting);
                    }

                }
                pref6 = null;

                var pref7 = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "DefaultDictationSystem"; });
                $scope.DataObject.SelectedData.DefaultDictationSystem = "";
                if (pref7 != null && pref7.length > 0 && pref7[0].PreferenceValue) {
                    $scope.DataObject.SelectedData.DefaultDictationSystem = pref7[0].PreferenceValue;
                    $sessionStorage.DefaultDictationSystem = pref7[0].PreferenceValue;
                }
                pref7 = null;

                var StudyPrirority = _.filter(WorklistPrefrence.UserPreferences, function (obj) { return obj.PreferenceType == "StudyPriority"; });
                if (StudyPrirority && StudyPrirority.length > 0) {
                    $scope.DataObject.StudyPrirorities = StudyPrirority;
                }
                StudyPrirority = null;

                var WorklistFontSize = _.find(WorklistPrefrence.UserPreferences, { PreferenceType: "WorklistFontSize" });
                $scope.DataObject.SelectedData.WorklistFontSize = WorklistFontSize ? WorklistFontSize : {};
                WorklistFontSize = null;

                var WorklistColorCode = _.find(WorklistPrefrence.UserPreferences, { PreferenceType: "WorklistColorCode" });
                if (WorklistColorCode) {
                    WorklistColorCode.PreferenceValue = JSON.parse(WorklistColorCode.PreferenceValue);
                }
                else {
                    WorklistColorCode = {};
                }
                $scope.DataObject.SelectedData.WorklistColorCode = WorklistColorCode;
                WorklistColorCode = null;

                showUserGuide = _.find(WorklistPrefrence.UserPreferences, { PreferenceType: "ShowUserGuide" });

                ShowReleaseGuide = _.find(WorklistPrefrence.UserPreferences, {
                    PreferenceType: "ShowReleaseGuide"
                });

                var ShowPracticeWorklist = _.find(WorklistPrefrence.UserPreferences, { PreferenceType: "ShowPracticeWorklist" });
                if (ShowPracticeWorklist && ShowPracticeWorklist.PreferenceValue) {
                    $scope.DataObject.ShowPracticeWorklist = ShowPracticeWorklist.PreferenceValue == '1' ? true : false;
                }
                ShowPracticeWorklist = null;

                $sessionStorage.DicomViewerCredentials = [];
                var dicomViewerCredentials = _.find(WorklistPrefrence.UserPreferences, { PreferenceType: "DicomViewerCred" });
                if (dicomViewerCredentials && dicomViewerCredentials.PreferenceValue) {
                    $sessionStorage.DicomViewerCredentials = JSON.parse(dicomViewerCredentials.PreferenceValue);
                }
                dicomViewerCredentials = null;

                var PaymentAddedSound = _.find(WorklistPrefrence.UserPreferences, { PreferenceType: "PaymentAddedSound" });
                if (PaymentAddedSound && PaymentAddedSound.PreferenceValue) {
                    $scope.DataObject.PaymentAddedSound = PaymentAddedSound.PreferenceValue;
                }
                PaymentAddedSound = null;
                d.resolve();
            }
            return d.promise;
        }

        function getPrefPSW(WorklistPrefrence) {
            if (WorklistPrefrence != null && WorklistPrefrence.PageSettings && WorklistPrefrence.PageSettings.length > 0) {
                var ColSort = _.find(WorklistPrefrence.PageSettings, function (item) { return item.PageName == "Work ListColSort"; });
                if (ColSort != null) {
                    OrderByField = ColSort.ColumnName;
                    ReverseSort = (ColSort.Value == "1") ? true : false;
                    var idx = _.findIndex(WorklistPrefrence.PageSettings, function (obj) { return obj.PageName == "Work ListColSort"; });
                    if (idx != -1) {
                        WorklistPrefrence.PageSettings.splice(idx, 1);
                    }
                }
                var WorklistSearch = _.filter(WorklistPrefrence.PageSettings, { PageName: 'Work List' });
                _.each(WorklistSearch, function (data) {
                    switch (data.ColumnName) {
                        case 'LocationID':
                            var locations = [];
                            if (data.Value) {
                                _.each(data.Value.split(','), function (locationID) {
                                    if (locationID) {
                                        var filter = _.find($scope.DataObject.MasterData.Locations, function (item) { return item.LocationID == locationID && item.SiteID != 0; });
                                        if (filter != null) {
                                            locations.push(filter);
                                        }
                                    }
                                });
                            }

                            $scope.DataObject.SelectedData.Location = locations;
                            $scope.DataObject.SelectedData.locationIDs = data.Value;
                            $scope.DataObject.SelectedData.SelectedLocations = {
                                Ids: data.Value,
                                locations: locations,
                                divId: "NewWorklistFilter"
                            };
                            break;
                        case 'WorklistIds_A':
                            var locations = [];
                            if (data && data.Value) {
                                _.each(data.Value.split(','), function (data) {
                                    if (data) {
                                        var filter = _.find($scope.DataObject.WorkLists, function (item) { return item.RuleID == data; });
                                        if (filter != null) {
                                            locations.push(filter);
                                        }
                                    }
                                });
                            }

                            if (SelectedWorkList != null) {
                                _.each(locations, function (data) {
                                    SelectedWorkList.push(data);
                                });
                            }
                            else {
                                SelectedWorkList = locations;
                            }

                            break;
                        case 'WorklistIds_U':
                            var locations = [];
                            if (data.Value) {
                                _.each(data.Value.split(','), function (data) {
                                    if (data) {
                                        var filter = _.find($scope.DataObject.WorkLists, function (item) { return item.RuleID == data; });
                                        if (filter != null) {
                                            locations.push(filter);
                                        }
                                    }
                                });
                            }

                            if (SelectedWorkList != null) {
                                _.each(locations, function (data) {
                                    SelectedWorkList.push(data);
                                });
                            }
                            else {
                                SelectedWorkList = locations;
                            }
                            break;
                        case 'Accession':
                            $scope.DataObject.SelectedData.Accession = data.Value;
                            break;
                        case 'OrderDate':
                            setOrderDate(data.Value, data);
                            $scope.DataObject.SelectedData.OrderDate = data.OrderDate;
                            $scope.DataObject.SelectedData.OrderDateType = data.OrderDateType;
                            break;
                        case 'ModalityID':
                            var modalities = [];
                            if (data.Value) {
                                _.each(data.Value.split(','), function (data) {
                                    if (data) {
                                        var filter = _.find($scope.DataObject.MasterData.Modalities, function (item) { return item.Id == data; });
                                        if (filter != null) {
                                            modalities.push(filter);
                                        }
                                    }
                                });
                            }

                            $scope.DataObject.SelectedData.Modality = modalities;
                            $scope.DataObject.ModalityDropdownDataFilter.SelectedValue = {
                                list: modalities,
                            };
                            setModalitytooltip($scope.DataObject.SelectedData);
                            break;
                        case 'PatientName':
                            $scope.DataObject.SelectedData.PatientName = data.Value;
                            break;
                        case 'PatientMRN':
                            $scope.DataObject.SelectedData.PatientMRN = data.Value;
                            break;
                        case 'PatientDOB':
                            $scope.DataObject.SelectedData.DOB = new Date(data.Value);
                            break;
                        case 'PatientClass':
                            $scope.DataObject.SelectedData.PatientClass = _.find($scope.DataObject.MasterData.PatientClass, function (item) { return item.Value == data.Value; });
                            break;
                        case 'OrderingPhysician':
                            $scope.DataObject.SelectedData.OrderingPhysician = data.Value;
                            break;
                        case 'Status':
                            $scope.DataObject.SelectedData.Status.key = data.Value;
                            break;
                        case 'STATFilter':
                            $scope.DataObject.SelectedData.STATFilter = (data.Value == "1") ? true : false;
                            break;
                        case 'Priority':
                            $scope.DataObject.SelectedData.StudyPriority = _.find($scope.DataObject.MasterData.StudyPriorities, { Key: data.Value });
                            break;
                    }
                });
                var WorklistQuickSearch = _.filter(WorklistPrefrence.PageSettings, { PageName: 'Work List Quick Search' });
                GetQuickSearchFilterValues(WorklistQuickSearch);
            }
        }

        function newOrderRefresh() {
            if (newOrderRefreshInterval) {
                $interval.cancel(newOrderRefreshInterval);
            }
            newOrderRefreshInterval = $interval(onRefreshInterval, DefaultAutoRefreshDuration);
        }

        function RenderWorklistLayout(WorklistPrefrence) {
            var dWorklist = { RuleID: 'PSW', WorkListName: 'Practice', Type: 'D', SortColumns: userLayoutPreference.SortColumns, IsEnabled: true, open: true, checked: true };
            userLayoutPreference = JSON.parse(WorklistPrefrence.LayoutOptions);
            LayoutPreferenceID = WorklistPrefrence.LayoutPreferenceID;
            if (LayoutPreferenceID) {
                PrepareWorklist(WorklistPrefrence, dWorklist);
            } else {
                updateUserLayoutPreference().then(function () {
                    PrepareWorklist(WorklistPrefrence, dWorklist);
                });
            }
        }

        function PrepareWorklist(WorklistPrefrence, dWorklist) {
            if (WorklistPrefrence.IsMigrated) {

                var worklistPrefLayout = _.uniqBy(_.sortBy(WorklistPrefrence.WorklistLayout, ['WorkistOrder']), 'RuleID');
                //MasterDefaultWorklistData = _.uniqBy(_.sortBy(WorklistPrefrence.WorklistLayout, ['WorkistOrder']), 'RuleID');

                var defaultWorklist = [];
                _.each(worklistPrefLayout, function (WorklistLayout) {
                    var worklistIndex = _.findIndex($scope.DataObject.WorkLists, function (item) { return _.toString(item.RuleID) == _.toString(WorklistLayout.RuleID) && item.IsEnabled; });
                    if (worklistIndex != -1) {
                        if (WorklistLayout.RuleID === 'PRW' && WorklistLayout.LayoutOptions) {
                            var opts = JSON.parse(WorklistLayout.LayoutOptions);
                            if (opts.WorkListName === 'Priority') {
                                opts.WorkListName = 'Personal';
                                WorklistLayout.LayoutOptions = JSON.stringify(opts);
                            }
                        }
                        MasterDefaultWorklistData.push(WorklistLayout);

                        if (!WorklistLayout.IsDeleted && (WorklistLayout.RuleID == 'PSW' ? $scope.DataObject.ShowPracticeWorklist : true)) {
                            defaultWorklist.push(JSON.parse(WorklistLayout.LayoutOptions));
                        }
                    }

                });
                $scope.DataObject.DefaultWorklists = defaultWorklist;
                //console.log("PrepareWorklist: ", $scope.DataObject.DefaultWorklists);
                //if ($scope.DataObject.DefaultWorklists.length == 0) {
                //    if ($scope.DataObject.ShowPracticeWorklist) {
                //        AddDefaultWorklist(dWorklist);
                //    }
                //}
            } else {
                if (userLayoutPreference && userLayoutPreference.Worklist) {
                    $scope.DataObject.DefaultWorklists = userLayoutPreference.Worklist;
                }
                else {
                    if ($scope.DataObject.ShowPracticeWorklist) {
                        AddDefaultWorklist(dWorklist)
                            .then(function () {
                                var witemIndex = _.findIndex($scope.DataObject.WorkLists, { RuleID: dWorklist.RuleID });
                                if (witemIndex != -1) {
                                    $scope.DataObject.WorkLists[witemIndex].checked = true;
                                }
                            });
                    }
                }
            }
            if (userLayoutPreference && (userLayoutPreference.DockerPosition || $scope.DataObject.SelectedData.userRole || ($scope.DataObject.SelectedData.userRoles.includes('SuperAdmin') || $scope.DataObject.SelectedData.userRoles.includes('Admin')))) {

                if (userLayoutPreference.DockerPosition) {
                    if (_.isArray(userLayoutPreference.DockerPosition)) {
                        userLayoutPreference.DockerPosition = userLayoutPreference.DockerPosition[0];
                    }
                    if (userLayoutPreference.DockPanelPref) {
                        userLayoutPreference.DockPanelPref.DockerPosition = userLayoutPreference.DockerPosition;
                    } else {
                        userLayoutPreference.DockPanelPref = { DockerPosition: userLayoutPreference.DockerPosition };
                    }
                    delete userLayoutPreference.DockerPosition;
                }

            }
            if (userLayoutPreference && userLayoutPreference.TabName) {
                if (userLayoutPreference.DockPanelPref) {
                    userLayoutPreference.DockPanelPref.currentTab = userLayoutPreference.TabName;
                } else {
                    userLayoutPreference.DockPanelPref = { currentTab: userLayoutPreference.TabName };
                }
                delete userLayoutPreference.TabName;
            }
            if (userLayoutPreference && userLayoutPreference.hasOwnProperty("TabAutoHide")) {
                if (userLayoutPreference.TabAutoHide) {
                    userLayoutPreference.DockPanelPref.isPinned = "UnPinned";
                } else {
                    userLayoutPreference.DockPanelPref.isPinned = "Pinned";
                }
                delete userLayoutPreference.TabAutoHide;
            }
            if (userLayoutPreference && userLayoutPreference.hasOwnProperty("DockPanelPref")) {
                if (userLayoutPreference.DockPanelPref.hasOwnProperty("currentTab")) {
                    if (userLayoutPreference.DockPanelPref.DockerPosition && userLayoutPreference.DockPanelPref.DockerPosition != 'Top' && userLayoutPreference.DockPanelPref.currentTab == 'Quick Search') {
                        $scope.DataObject.wlTabName = 'Search';
                    }
                    else {
                        $scope.DataObject.wlTabName = userLayoutPreference.DockPanelPref.currentTab;
                    }
                };
                if (userLayoutPreference.DockPanelPref.isPinned) {
                    if (userLayoutPreference.DockPanelPref.isPinned == "Pinned") {
                        $scope.DataObject.iswlTabAutoHide = false;
                    } else {
                        $scope.DataObject.wlTabName = "";
                        $scope.DataObject.iswlTabAutoHide = true;
                    }
                }
                if (userLayoutPreference.DockPanelPref.hasOwnProperty("DockerPosition")) {
                    if (_.isArray(userLayoutPreference.DockPanelPref.DockerPosition)) {
                        userLayoutPreference.DockPanelPref.DockerPosition = userLayoutPreference.DockPanelPref.DockerPosition[0];
                    }
                    $scope.DataObject.DockerPosition = userLayoutPreference.DockPanelPref.DockerPosition;
                    setDockerPosition();
                }
            }
            if (!userLayoutPreference || ((userLayoutPreference && !userLayoutPreference.DockPanelPref) || (userLayoutPreference.DockPanelPref && !userLayoutPreference.DockPanelPref.DockerPosition))) {
                angular.element('#wrklstFilterWraaper').css('display', 'block');
            }
            if (!$scope.DataObject.DockerPosition) {
                $scope.DataObject.DockerPosition = "Left";
                setDockerPosition();
            }
        }

        function updateUserLayoutPreference() {

            var d = $q.defer();
            userLayoutPreference = _.pick(userLayoutPreference, ['DockerPosition', 'TabName', 'DockPanelPref']);
            UserLayoutPrefService.SetUserLayoutPreferences({
                UserID: $sessionStorage.currentUserData.userId,
                PageId: $state.current.name + "." + $state.current.controller,
                ControlId: 'WorkList_ListGrid',
                LayoutOptions: JSON.stringify(userLayoutPreference),
                Username: $sessionStorage.currentUserData.userName,
                IsMigrated: true,
            }).then(function (response) {
                LayoutPreferenceID = response.LayoutPreferenceID;
                if (response.LayoutOptions) {
                    userLayoutPreference = JSON.parse(response.LayoutOptions)
                }
                d.resolve();
            });
            return d.promise;
        }

        function updateuserguidepreference() {
            //$log.log("updateUserPreference > on: ", new Date());

            UserPreferenceService.AddEditUserPreferences([{
                UserPreferenceID: (showUserGuide && showUserGuide.UserPreferenceID) ? showUserGuide.UserPreferenceID : "-1",
                PreferenceType: "ShowUserGuide",
                UserID: $sessionStorage.currentUserData.userId,
                PreferenceValue: "0",
            }]);
        }

        function updateRefreshDOSInterval() {
            var now = new Date();
            currentDate.setDate(now.getDate() + 1);
            currentDate.setHours(0, 0, 0, 0);
            refreshDOSInterval = currentDate.getTime() - now.getTime();
        }

        function openSynapseImage(pacsURL, accessionNumber) {
            RCService.OpenImage({ requestEvent: "openimage", imageRequestDetails: { pacsURL: pacsURL, accessionNumber: accessionNumber } })
        }

        function openPS360(Order) {
            $scope.isPSManualOpen = true;
            $scope.pendingPSAccession = Order.Accession;
            RCService.OpenReport({ requestEvent: "openreport", reportRequestDetails: { siteName: Order.PSSiteName, accessionNumber: Order.Accession } })
        }

        function closePS360(Order) {
            if (RCService && RCService.rc) {
                RCService.CloseReport({ requestEvent: "closereport", reportRequestDetails: { siteName: Order.PSSiteName, accessionNumber: Order.Accession } })
            }
        }

        function setHeight() {
            currentHeight = $(window).height();
        }

        function validateDOS(Alert) {
            if ($scope.DataObject.SelectedData.Status.key == 'AL') {
                if (!$scope.DataObject.SelectedData.OrderDate.startDate && !$scope.DataObject.SelectedData.OrderDate.endDate) {
                    if (Alert) toaster.warning({ body: "Please select the DOS." });
                    return false;
                }

                if (getDosLabel() == 'Last 5 Years' && hasLocationSelected()) {
                    return true;
                }

                var DaysDifferent = moment(($scope.DataObject.SelectedData.OrderDate.endDate)).diff(moment($scope.DataObject.SelectedData.OrderDate.startDate), 'days');
                if (DaysDifferent > 366) {
                    if (Alert) toaster.warning({ body: "Please select the DOS that is max one year." });
                    return false;
                }
            }
            return true;
        }

        function getPrefLookups(WorklistPrefrence) {
            var d = $q.defer();
            if (WorklistPrefrence != null && WorklistPrefrence.Lookups && WorklistPrefrence.Lookups.length > 0) {
                $scope.DataObject.MasterData.StudyPriorities = _.filter(WorklistPrefrence.Lookups, { Type: 'StudyPriority' });
                $scope.DataObject.MasterData.StudyPriorities = _.orderBy($scope.DataObject.MasterData.StudyPriorities, ['Value'], ['ASC']);
                $scope.DataObject.MasterData.DelayStatColorCode = _.find(WorklistPrefrence.Lookups, { Type: 'DelayedStatColorCode' });
                $scope.DataObject.MasterData.DicomViewers = _.filter(WorklistPrefrence.Lookups, { Type: 'DicomViewer' });
                $scope.DataObject.MasterData.ExamTags = _.filter(WorklistPrefrence.Lookups, { Type: 'ExamTags' });
                $scope.DataObject.MasterData.HiddenTypes = _.filter(WorklistPrefrence.Lookups, { Type: 'HiddenTypes' });
                $scope.DataObject.MasterData.PatientClass = _.filter(WorklistPrefrence.Lookups, { Type: 'PatientClass' });
                $scope.DataObject.MasterData.HiddenTypesTooltip = _.filter(WorklistPrefrence.Lookups, { Type: 'HiddenTypesTooltip' });
                $scope.DataObject.MasterData.RadExamTag = _.filter(WorklistPrefrence.Lookups, { Type: 'RadExamTag' });

                var quickPatientClassIndex = _.findIndex($scope.QuickSearchField, { key: 'Select Type' });
                if (quickPatientClassIndex != -1) {
                    $scope.QuickSearchField[quickPatientClassIndex].list = $scope.DataObject.MasterData.PatientClass;
                }
                var quickStudyPriorityIndex = _.findIndex($scope.QuickSearchField, { key: 'Select Priority' });
                if (quickStudyPriorityIndex != -1) {
                    $scope.QuickSearchField[quickStudyPriorityIndex].list = $scope.DataObject.MasterData.StudyPriorities;
                }

                //ROUTINE STUDIES REASON
                $scope.DataObject.MasterData.RoutineStudiesReasons = _.filter(WorklistPrefrence.Lookups, { Type: 'UserComments' });

                d.resolve();
            }
            return d.promise;
        }

        $scope.leftSideSec = '';

        $scope.setWorklistTab = function (tab, istour) {
            //$scope.leftSideSec = document.getElementById('leftSidebarSection').parentElement.parentElement;
            $scope.leftSideSec = $("#leftSidebarSection").parent().parent();
            //document.getElementById('dropToTop').classList.remove('searcHideHeight');
            $("#dropToTop").removeClass("searcHideHeight");
            if (tab == $scope.DataObject.wlTabName) {
                $scope.DataObject.wlTabName = (istour) ? tab : "";
                //$scope.leftSideSec.classList.add('atTopsetHght');
                $scope.leftSideSec.addClass("atTopsetHght");
            } else {
                $scope.DataObject.wlTabName = tab;
                //$scope.leftSideSec.classList.remove('atTopsetHght');
                $scope.leftSideSec.removeClass("atTopsetHght");

                if ($scope.DataObject.wlTabName == 'Worklist') {
                    var timeout = $timeout(function () {
                        loadWorklistListAgGrid();
                    }, 200);
                    TimeoutList.push(timeout)
                }
            }
            if (!$scope.DataObject.iswlTabAutoHide || ($scope.DataObject.wlTabName == "")) {
                saveSidePanelPreference();
            }
        }
        $scope.setwlTabAutiHide = function (boolHide) {
            if (!boolHide) {
                $scope.DataObject.iswlTabAutoHide = !$scope.DataObject.iswlTabAutoHide
            }
            if ($scope.DataObject.iswlTabAutoHide || boolHide) {
                $scope.DataObject.wlTabName = "";
            }
            if (angular.element('#dropToTop').hasClass('inActive') || angular.element('#dropToTop').hasClass('outActive')) {
                angular.element('#dropToTop').addClass('atTopsetHght')
            }

            saveSidePanelPreference();
        }

        function saveSidePanelPreference() {

            if (userLayoutPreference.DockPanelPref) {
                userLayoutPreference.DockPanelPref.currentTab = $scope.DataObject.wlTabName;
                userLayoutPreference.DockPanelPref.isPinned = ($scope.DataObject.iswlTabAutoHide) ? "UnPinned" : "Pinned"
            } else {
                userLayoutPreference.DockPanelPref = {
                    currentTab: $scope.DataObject.wlTabName,
                    isPinned: ($scope.DataObject.iswlTabAutoHide) ? "UnPinned" : "Pinned",
                };
            }
            updateUserLayoutPreference();
        }

        //below code will hide side panel if not pinned on click outside
        document.getElementById('mainDiv').onclick = function (e) {
            if ((!e.target.closest("#wrklstFilterWraaper")) && (!e.target.closest("#dropToRight"))) {
                if ($scope.DataObject.iswlTabAutoHide) {
                    var timeout = $timeout(function () { $scope.DataObject.wlTabName = ""; $timeout.cancel(timeout) }, 0);;
                }
            }
        }


        $scope.updateUserLayoutPref = function (data) {
            var index = _.findIndex($scope.DataObject.DefaultWorklists, function (obj) { return obj.RuleID == data.RuleID });
            if (index != -1) {

                $scope.DataObject.DefaultWorklists[index].SortColumns = data.SortColumns;
                $scope.DataObject.DefaultWorklists[index].OpenClipboardNextStudy = data.OpenClipboardNextStudy;
                if ($scope.DataObject.DefaultWorklists[index].WorklistType != 16) {
                    $scope.DataObject.DefaultWorklists[index].ChooseNextStudy = data.ChooseNextStudy;
                }
                $scope.DataObject.DefaultWorklists[index].IsDeleted = false;
                if (data.popUpWorklist) {
                    var worklist = _.cloneDeep($scope.DataObject.DefaultWorklists[index]);
                    worklist.savedState = data.savedState;
                    $scope.DataObject.DefaultWorklists[index] = worklist;
                    //console.log("updateUserLayoutPref: ", $scope.DataObject.DefaultWorklists);
                }
                $scope.DataObject.DefaultWorklists[index].SignedByPrefUpdated = data.SignedByPrefUpdated;
                $scope.DataObject.DefaultWorklists[index].SignedDatePrefUpdated = data.SignedDatePrefUpdated;
                $scope.DataObject.DefaultWorklists[index].open = data.open;

                var mWorklistIndex = _.findIndex(MasterDefaultWorklistData, function (item) { return _.toString(item.RuleID) == _.toString($scope.DataObject.DefaultWorklists[index].RuleID); });
                if (mWorklistIndex != -1) {
                    MasterDefaultWorklistData[mWorklistIndex].LayoutOptions = JSON.stringify($scope.DataObject.DefaultWorklists[index]);
                    MasterDefaultWorklistData[mWorklistIndex].Type = 'M';

                    UpdatedMasterWorklists.push(MasterDefaultWorklistData[mWorklistIndex]);
                }
                MasterDefaultWorklistData = _.sortBy(_.uniqBy(MasterDefaultWorklistData, 'RuleID'), 'WorkistOrder');
                SetWorklistLayoutPreference('M');
            }
            else {
                var mWorklistIndex = _.findIndex(MasterDefaultWorklistData, function (item) { return _.toString(item.RuleID) == _.toString(data.RuleID); });
                if (mWorklistIndex != -1) {
                    MasterDefaultWorklistData[mWorklistIndex].LayoutOptions = JSON.stringify(data);
                    MasterDefaultWorklistData[mWorklistIndex].IsDeleted = true;
                    MasterDefaultWorklistData[mWorklistIndex].Type = 'M';

                    UpdatedMasterWorklists.push(MasterDefaultWorklistData[mWorklistIndex]);
                }
                MasterDefaultWorklistData = _.sortBy(_.uniqBy(MasterDefaultWorklistData, 'RuleID'), 'WorkistOrder');
                SetWorklistLayoutPreference('M');
            }
        };

        $scope.onEditWorklist = function (Worklist) {
            $scope.DataObject.AddEditWorklistTitle = 'Edit Worklist';

            var EditRuleWorklist = _.find($scope.DataObject.WorkLists, function (obj) { return obj.RuleID == Worklist.RuleID });
            if (EditRuleWorklist) {
                RuleSharedService.RemoveOrderIDFromRuleTable($scope.DataObject.RuleTable);
                var objWorklist = _.omit(EditRuleWorklist, ['RulesConditions', 'Groups'
                ]);
                $scope.DataObject.Rule = _.cloneDeep(objWorklist);
                $scope.DataObject.ModalWorklistOpened = true;
                angular.element('#ModalEditWorkList').modal('show');
            }

        }

        $scope.RemoveDefaultWorklist = function (Worklist) {
            addLoadingCursor();
            var removetimeout = $timeout(function () {
                var worklistIndex = _.findIndex($scope.DataObject.WorkLists, function (obj) { return obj.RuleID == Worklist.RuleID });
                if (worklistIndex != -1) {
                    $scope.DataObject.WorkLists[worklistIndex].checked = false;
                }
                if (WorklistListsGridoptions && WorklistListsGridoptions.api) {
                    WorklistListsGridoptions.api.setRowData($scope.DataObject.WorkLists);
                    var node = WorklistListsGridoptions.api.getRowNode(Worklist.RuleID);
                    if (node) {
                        node.setSelected(false);
                    }
                }

                var mWorklistIndex = _.findIndex(MasterDefaultWorklistData, function (item) { return _.toString(item.RuleID) == _.toString(Worklist.RuleID); });
                if (mWorklistIndex != -1) {
                    Worklist.checked = false;
                    MasterDefaultWorklistData[mWorklistIndex].IsDeleted = true;
                    MasterDefaultWorklistData[mWorklistIndex].LayoutOptions = JSON.stringify(Worklist);
                    MasterDefaultWorklistData[mWorklistIndex].Type = 'M';

                    UpdatedMasterWorklists.push(MasterDefaultWorklistData[mWorklistIndex]);
                }
                MasterDefaultWorklistData = _.sortBy(_.uniqBy(MasterDefaultWorklistData, 'RuleID'), 'WorkistOrder');
                var defaultWorklist = [];
                _.each(MasterDefaultWorklistData, function (eWorklist) {
                    if (!eWorklist.IsDeleted) {
                        var layoutOption = JSON.parse(eWorklist.LayoutOptions);
                        defaultWorklist.push(setWorklistAttr(layoutOption));
                    }
                });
                $scope.DataObject.DefaultWorklists = defaultWorklist;
                //console.log("RemoveDefaultWorklist: ", $scope.DataObject.DefaultWorklists);
                CalculateHeight();
                UpdatePurgeTimeToLoad();

                SetWorklistLayoutPreference('M').then(function () {
                    removeLoadingCursor();
                });
                $timeout.cancel(removetimeout);
                removetimeout = null;
            }, 500);
        }

        $scope.onCheckChanged = function (data) {
            //$log.log("onCheckChanged > on: ", new Date());
            if (data.checked) {
                AddDefaultWorklist(data);
            } else {
                $scope.RemoveDefaultWorklist(data);
            }

        }

        function AddDefaultWorklist(Worklist) {
            //console.log("AddDefaultWorklist > Worklist: ", Worklist);
            var d = $q.defer();
            var defaultWorklistIndex = _.findIndex($scope.DataObject.DefaultWorklists, function (obj) { return obj.RuleID == Worklist.RuleID });
            if (defaultWorklistIndex != -1) {
                toaster.warning({ body: "Worklist already exists." });
            } else {
                addLoadingCursor();
                var addtimeout = $timeout(function () {


                    var Type = 'I';
                    var mWorklistIndex = _.findIndex(MasterDefaultWorklistData, function (item) { return _.toString(item.RuleID) == _.toString(Worklist.RuleID); });
                    if (mWorklistIndex != -1) {
                        Type = 'M';
                        MasterDefaultWorklistData[mWorklistIndex].IsDeleted = false;
                        MasterDefaultWorklistData[mWorklistIndex].Type = Type;
                        UpdatedMasterWorklists.push(MasterDefaultWorklistData[mWorklistIndex]);
                    } else {
                        var MasterWorklist = {
                            LayoutPreferenceID: LayoutPreferenceID,
                            RuleID: Worklist.RuleID,
                            LayoutOptions: JSON.stringify(Worklist),
                            IsDeleted: false,
                            Type: Type,
                            WorkistOrder: MasterDefaultWorklistData.length + 1,
                            WorkListName: Worklist.WorklistName,
                        };
                        MasterDefaultWorklistData.push(MasterWorklist);
                        UpdatedMasterWorklists.push(MasterWorklist);
                    }
                    MasterDefaultWorklistData = _.sortBy(_.uniqBy(MasterDefaultWorklistData, 'RuleID'), 'WorkistOrder');
                    var defaultWorklist = [];
                    _.each(MasterDefaultWorklistData, function (eWorklist) {
                        if (!eWorklist.IsDeleted) {
                            var layoutOption = JSON.parse(eWorklist.LayoutOptions);

                            if (layoutOption.RuleID == Worklist.RuleID) {
                                layoutOption.IsSmartWorklist = Worklist.IsSmartWorklist;
                                layoutOption.WorklistPageSize = Worklist.WorklistPageSize;
                            }
                            defaultWorklist.push(setWorklistAttr(layoutOption));
                        }

                    });
                    $scope.DataObject.DefaultWorklists = defaultWorklist;
                    //console.log("AddDefaultWorklist: ", $scope.DataObject.DefaultWorklists);
                    CalculateHeight();
                    UpdatePurgeTimeToLoad();

                    SetWorklistLayoutPreference(Type).then(function () {
                        removeLoadingCursor();

                        d.resolve();
                    });

                    $timeout.cancel(addtimeout);
                    addtimeout = null;
                }, 500);

            }
            return d.promise;
        }

        function setWorklistAttr(Worklist) {
            var defaultWorklist = _.find($scope.DataObject.DefaultWorklists, function (item) { return _.toString(item.RuleID) == _.toString(Worklist.RuleID); });
            if (defaultWorklist) {
                Worklist = defaultWorklist;
            } else {
                Worklist.loading = false;
                Worklist.ResultPendingCount = 0;
                Worklist.UnreadRVU = 0;
                Worklist.STATCount = 0;
                Worklist.IsEnabled = true;
                Worklist.TimeToLoad = moment();
                Worklist.PageSize = 0;
                Worklist.gridId = uuidv4.newuuid();
                Worklist.OpenClipboardNextStudy = true;
                Worklist.windowOpen = false;
                if (Worklist.WorklistType == 16) {
                    Worklist.OpenClipboardNextStudy = $localStorage.OpenClipboardNextStudy ? $localStorage.OpenClipboardNextStudy : false;
                }
                if (Worklist.WorklistType != 16) {
                    Worklist.ChooseNextStudy = (Worklist && Worklist.hasOwnProperty("ChooseNextStudy")) ? Worklist.ChooseNextStudy : true;
                }
            }
            return Worklist;
        }

        function AddWorklist() {
            $scope.DataObject.WorkLists.push({ RuleID: 'PSW', WorkListName: 'Practice', Type: 'D', IsEnabled: true, TimeToLoad: moment(), });
            $scope.DataObject.WorkLists.push({ RuleID: 'PRW', WorkListName: 'Personal', Type: 'D', IsEnabled: true, TimeToLoad: moment(), });
        }

        function openSearchedWorklist(Type) {
            var PageSize = 0;
            var height = $(window).height();
            if (height < 1000) {
                PageSize = 50;
            } else if (height > 1000) {
                PageSize = 100;
            }
            var type = Type

            $scope.DataObject.SearchedWorklist = { RuleID: -1, WorkListName: 'Worklist Search', Type: type, SortColumns: SortColumns, PageSize: PageSize, height: height, OpenClipboardNextStudy: true, ChooseNextStudy: true }
            $scope.DataObject.SearchedWorklist.purge = true;
            $scope.DataObject.SearchedWorklist.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
            $scope.DataObject.SearchedWorklist.gridId = uuidv4.newuuid();

            $scope.currentWindow = 'win_Worklist';

            $scope.win_Worklist.open();
            $scope.win_Worklist.wrapper.prevAll(".k-overlay").first().addClass("custom-overlay").css({ 'z-index': '10003', 'opacity': '0.5' });
            if (($scope.win_Worklist.wrapper.find("#WLPopupModalityFilter")).length > 0) {
                ($scope.win_Worklist.wrapper.find("#WLPopupModalityFilter")).remove();
            }
            var timeout = $timeout(function () {
                $scope.win_Worklist.center();
            }, 100);
            TimeoutList.push(timeout)
            $scope.DataObject.WorklistPopupTitle = 'Worklist';
            SetWindowOptions($scope.win_Worklist, 'win_Worklist', { title: $scope.DataObject.WorklistPopupTitle });
        }

        $scope.AddNewWorklist = function () {
            RuleSharedService.RemoveOrderIDFromRuleTable($scope.DataObject.RuleTable);
            $scope.DataObject.AddEditWorklistTitle = 'Add Worklist';
            $scope.DataObject.Rule = {
                StatusFlag: 'N',
                Type: 'A',
                IsEnabled: true,
                IsWorkList: '1',
                RulesProviders: [{ ProviderID: $sessionStorage.currentUserData.userId }],
                RulesConditions: [],
            };
            $scope.DataObject.ModalWorklistOpened = true;
            angular.element('#ModalEditWorkList').modal('show');
        }

        function GetStatusCount() {
            var data = {
                userid: $sessionStorage.currentUserData.userId,
                StartDateTime: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "00:00")),
                EndDateTime: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")),
            };
            WorklistService.GetStatusCount(data).then(function (response) {
                $scope.WorklistPageHeaderParameter.SignedToday = response;
            });
        }

        
        $scope.onDropWorklistOrder = function (index, worklist, evt) {
            if (!evt.data) {
                return;
            }
            if ($scope.DataObject.DefaultWorklists[index] && $scope.DataObject.DefaultWorklists[index].RuleID === worklist.RuleID) {
                return;
            }
            var fromMasterWorklistData = _.filter(MasterDefaultWorklistData, { 'IsDeleted': false });
            if (fromMasterWorklistData.length > 0) {
                var fromMasterWorklistDataIndex = _.findIndex(MasterDefaultWorklistData, function (item) { return _.toString(item.RuleID) == _.toString(fromMasterWorklistData[index].RuleID); });
                var toMasterWorklistData = _.remove(MasterDefaultWorklistData, function (n) {
                    return n.RuleID == worklist.RuleID;
                });
                if (toMasterWorklistData.length > 0) {
                    MasterDefaultWorklistData.splice(fromMasterWorklistDataIndex, 0, toMasterWorklistData[0]);

                    ReorderMasterDefaultWorklist();

                    CalculateHeight();
                }
            }


        }

        function CalculateHeight() {
            var accordianHeight = 26;
            var gridHeight = height - pageTopheight - headerHeight - 5;
            var heightChangedManually = 0;
            _.each($scope.DataObject.DefaultWorklists, function (wo) { if (wo.heightChangedManually) { heightChangedManually = heightChangedManually + wo.height; } });
            var individualHeight = (gridHeight / $scope.DataObject.DefaultWorklists.length);
            _.each($scope.DataObject.DefaultWorklists, function (dWorklist, index) {
                var individualGridHeight = individualHeight - accordianHeight;
                if (!dWorklist.heightChangedManually) { dWorklist.height = individualGridHeight; }


                var PageSize = getPageSize(dWorklist.height);
                dWorklist.PageSize = _.toInteger(PageSize);
            });
        }

        function getPrefRules(WorklistPrefrence) {
            var d = $q.defer();
            var height = $(window).height();

            var userRoles      = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles) ? $sessionStorage.currentUserData.userRoles : [];
            var userTenants    = ($sessionStorage.userTenantNames || '').split(',').map(function(s) { return s.trim().toLowerCase(); }).filter(function(s) { return s !== ''; });
            var allowedTenants = ($sessionStorage.OverdueReadsWorklistTenantNames || '').split(',').map(function(s) { return s.trim().toLowerCase(); }).filter(function(s) { return s !== ''; });
            var allowedRoles   = ($sessionStorage.OverdueReadsWorklistUserRoles   || '').split(',').map(function(s) { return s.trim().toLowerCase(); }).filter(function(s) { return s !== ''; });
            var isOverdueEligible = !!$sessionStorage.EnableOverduesWorklist
                && allowedTenants.length > 0 && allowedRoles.length > 0
                && userTenants.some(function(t) { return allowedTenants.indexOf(t) !== -1; })
                && userRoles.some(function(r) { return allowedRoles.indexOf(r.toLowerCase()) !== -1; });

            if (WorklistPrefrence != null && WorklistPrefrence.Rules && WorklistPrefrence.Rules.length > 0) {
                var Rules = _.uniqBy(WorklistPrefrence.Rules, 'RuleID');
                ClipboardRule = _.find(Rules, { WorklistType: 16 });
                _.each(Rules, function (worklistItem) {
                    worklistItem.Type = 'A';
                    if (!worklistItem.height) worklistItem.height = height;
                    worklistItem.gridId = uuidv4.newuuid();
                    worklistItem.TimeToLoad = moment();
                });

                $scope.DataObject.GlobalRules = _.sortBy(_.filter(Rules, function (grule) {
                    return grule.WorklistType == 21
                        || grule.WorklistType == 16
                        || grule.WorklistType == 31
                        || (grule.WorklistType == 51 && isOverdueEligible);
                }), ['RuleName']);

                PendingAddendumWorklist = _.find(Rules, function (rule) { return rule.WorklistType == 31; });
                $scope.DataObject.WorkLists = _.concat($scope.DataObject.WorkLists, Rules);

                SortWorklistInOrder();

                var ruleObjIndex = _.findIndex($scope.DataObject.GlobalRules, function (obj) { return obj.WorklistType == 16; });
                if (ruleObjIndex != -1) {
                    RuleSharedService.UpdateRuleTable($scope.DataObject.RuleTable);
                    RuleSharedService.SetData($scope.DataObject.RuleTable, AllRadiologists);
                    getClipoardRuleDetail($scope.DataObject.GlobalRules[ruleObjIndex]);
                    $scope.DataObject.GlobalRules[ruleObjIndex].Type = 'A';
                    $scope.DataObject.GlobalRules[ruleObjIndex].OpenClipboardNextStudy = $localStorage.OpenClipboardNextStudy;
                }
                else {
                    RuleSharedService.SetData($scope.DataObject.RuleTable, AllRadiologists);
                }
            }
            else {
                RuleSharedService.SetData($scope.DataObject.RuleTable, AllRadiologists);
            }

            if (isOverdueEligible) {
                OverdueReadsWorklist = _.find($scope.DataObject.GlobalRules, function(r) { return r.WorklistType == 51; });
            }

            d.resolve();
            return d.promise;
        }

        function UpdateTimeToLoad() {
            //$log.log('UpdateTimeToLoad > on: ', new Date());
            var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);
            _.each(defaultWorklist, function (dWorklist, index) {
                if (CurrentIndexToRefresh == index) {
                    dWorklist.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
                }
            });
            $scope.DataObject.DefaultWorklists = _.uniqBy(defaultWorklist, 'RuleID');
            //console.log("UpdateTimeToLoad: ", $scope.DataObject.DefaultWorklists);
        }

        function UpdatePurgeTimeToLoad() {
            //$log.log('UpdateTimeToLoad > on: ', new Date());
            var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);
            _.each(defaultWorklist, function (dWorklist, index) {
                if (CurrentIndexToRefresh == index) {
                    dWorklist.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
                    dWorklist.purge = true;
                }
            });
            $scope.DataObject.DefaultWorklists = _.uniqBy(defaultWorklist, 'RuleID');
            //console.log("UpdatePurgeTimeToLoad: ", $scope.DataObject.DefaultWorklists);
        }

        function getPageSize(height) {
            return ((height / 26) + 30);
        }

        function addLoadingCursor() {
            bodyElement.addClass('waiting');   // set cursor to hourglass
        }

        function removeLoadingCursor() {
            bodyElement.removeClass('waiting');  // set cursor to normal
        }

        function getOrderStatus() {
            $scope.DataObject.OrderStatus = WorklistService.GetOrderStatus();
            $scope.DataObject.MasterData.OrderStatus = $scope.DataObject.OrderStatus;
        }

        $scope.OnCloseAddEditWorklistWin = function (RuleID) {
            $scope.DataObject.ModalWorklistOpened = false;
            var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);
            var defaultWorklistIndex = _.findIndex(defaultWorklist, function (obj) { return _.toString(obj.RuleID) == _.toString(RuleID) });
            if (defaultWorklistIndex != -1) {
                defaultWorklist[defaultWorklistIndex].Groups = null;
                defaultWorklist[defaultWorklistIndex].purge = true;
                defaultWorklist[defaultWorklistIndex].TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
            }
            $scope.DataObject.DefaultWorklists = defaultWorklist;
            CalculateHeight();
        }

        function closeVR() {
            if (windowHandler)
                windowHandler.DoNotCloseWindow(['Analytics']);
        }

        function DeleteOpenOrderByUserID() {
            if ($sessionStorage.currentUserData) {
                WorklistService.DeleteOpenOrderByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                });
            }
        };

        $scope.viewGlobalRuleWorklist = function (obj) {
            //$log.log("viewGlobalRuleWorklist > on: ", new Date());
            obj.PageSize = 50;
            obj.SortColumns = SortColumns;
            obj.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
            obj.Type = "A";
            obj.windowOpen = true;
            $scope.popOutWorklist(obj);
            //$scope.DataObject.SearchedWorklist = _.cloneDeep(obj);
        }

        function SetWindowOptions(win, key, options) {
            if (win) {
                win.setOptions(options);
            } else {
                var dialog = $("div[kendo-window='" + key + "']").data("kendoWindow");
                if (dialog) dialog.setOptions(options);
            }
        }

        function createClipboardWorklist(Rule, ClipboardConditionData) {
            var obj = {};
            var RulesConditions = Rule && Rule.Groups && Rule.Groups.length > 0 ? Rule.Groups[0].RulesConditions : [];
            var RulesProviders = [{ ProviderID: $sessionStorage.currentUserData.userId }];

            if (ClipboardConditionData.OrderIDs) {
                var orderIDRuleTableIndex = _.findIndex($scope.DataObject.RuleTable, { 'Key': 'OrderID' });
                var orderIDRuleOperator = _.find($scope.DataObject.RuleTable[orderIDRuleTableIndex].RuleOperator, { 'Value': 'IN' });
                obj = {
                    TableName: 'Orders',
                    ColumnName: 'ORDERS.OrderID',
                    Operator: 'IN',
                    Value: ClipboardConditionData.OrderIDs,
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleOperator: orderIDRuleOperator,
                    RuleTable: $scope.DataObject.RuleTable[orderIDRuleTableIndex],
                    AndOr: "AND",
                    StatusFlag: "N",
                };
                RulesConditions.push(obj);
            }
            if (ClipboardConditionData.OrderDate && ClipboardConditionData.OrderDate.startDate) {
                var dosRuleTableIndex = _.findIndex($scope.DataObject.RuleTable, { 'Key': 'DOS' });
                var dosRuleOperator = _.find($scope.DataObject.RuleTable[dosRuleTableIndex].RuleOperator, { 'Value': '=' });

                obj = {
                    TableName: 'DOS',
                    ColumnName: 'ORDERS.OrderDate',
                    Operator: '=',
                    Value: ClipboardConditionData.OrderDateType + " '" + ClipboardConditionData.OrderDate.startDate.format("MM-DD-YYYY") + "' and '" + ClipboardConditionData.OrderDate.endDate.format("MM-DD-YYYY") + "'",
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.DataObject.RuleTable[dosRuleTableIndex],
                    RuleOperator: dosRuleOperator,
                    DateValue: {
                        startDate: ClipboardConditionData.OrderDate.startDate.format("MM-DD-YYYY"),
                        endDate: ClipboardConditionData.OrderDate.endDate.format("MM-DD-YYYY"),
                        label: ClipboardConditionData.OrderDateType,
                    },
                    AndOr: "AND",
                    StatusFlag: "N",
                };
                RulesConditions.push(obj);
            }

            if (RulesConditions.length > 0 && ClipboardConditionData.OrderIDs && ClipboardConditionData.OrderDate && ClipboardConditionData.OrderDate.startDate) {
                var statusRuleTableIndex = _.findIndex($scope.DataObject.RuleTable, { 'Key': 'Exam Status' });
                var statusRuleOperator = _.find($scope.DataObject.RuleTable[statusRuleTableIndex].RuleOperator, { 'Value': '=' });

                obj = {
                    TableName: 'Exam Status',
                    ColumnName: 'ORDERS.ExamStatus',
                    Operator: '=',
                    Value: "RP",
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    RuleTable: $scope.DataObject.RuleTable[statusRuleTableIndex],
                    RuleOperator: statusRuleOperator,
                    RuleTableValue: { Value: 'Result Pending', ID: 'RP' },
                    AndOr: "AND",
                    StatusFlag: "N",
                };
                RulesConditions.push(obj);
            }
            Rule.Groups = [
                {
                    GroupID: 0,
                    RulesConditions: RulesConditions,
                    deleted: false,
                    GroupOperator: "AND"
                },
            ];
            Rule.RulesProviders = RulesProviders;

        }

        function getClipoardRuleDetail(ruleObj) {
            //$log.log("getClipoardRuleDetail > on: ", new Date());
            var d = $q.defer();
            $q.all([
                RuleSharedService.GetRuleDetails(ruleObj, "Clipboard")
            ]).then(function (data) {
                if (data && data.length > 0) {
                    ruleObj = data[0].Rule;
                    d.resolve(ruleObj);
                }
            });
            return d.promise;
        }

        function updateClipboardRule(Rule) {

            Rule.loading = false;
            Rule.StatusFlag = "N";
            Rule.RuleName = "My ClipBoard";
            Rule.RuleDescription = "My ClipBoard";
            Rule.IsWorkList = "1";
            Rule.IsEnabled = true;
            Rule.WorkListName = "My ClipBoard";
            Rule.ModifyBy = $sessionStorage.currentUserData.userId;
            Rule.CreatedBy = $sessionStorage.currentUserData.userId;
            Rule.WorklistType = 16;
            Rule.Type = "A";
            Rule.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
        }

        function setClipboardRule(Rule, ClipboardConditionData) {
            Rule.RulesConditions = [];
            Rule.selectedRadiologists = [];
            Rule.RulesProviders = _.uniq(Rule.RulesProviders);
            //Clipboard related signal R changes starts
            ClipboardConditionData.CreatedBy = $sessionStorage.currentUserData.userId;
            if (ClipboardConditionData.ActionType == "Remove") {

                var OrderIdsToRemove = "";
                _.each(ClipboardConditionData.SelectedRowsClipboard, function (order) {
                    OrderIdsToRemove = OrderIdsToRemove + order.OrderID + ",";
                })

                var RemoveObj = {};
                RemoveObj.ActionType = ClipboardConditionData.ActionType;
                RemoveObj.CreatedBy = ClipboardConditionData.CreatedBy;
                RemoveObj.OrderIdsToRemove = OrderIdsToRemove;
                Rule.ClipboardConditionData = JSON.stringify(RemoveObj);

            }
            else if (ClipboardConditionData.ActionType == "Add" || ClipboardConditionData.ActionType == "Reset") {
                var Obj = {};
                Obj.CreatedBy = ClipboardConditionData.CreatedBy;
                if (ClipboardConditionData.ActionType == "Add") {
                    Obj.OrderIDs = ClipboardConditionData.OrderIDs;
                } else {
                    Obj.OrderIdsToRemove = ClipboardConditionData.OrderIdsToRemove;
                }
                Obj.ActionType = ClipboardConditionData.ActionType;
                Rule.ClipboardConditionData = JSON.stringify(Obj);
            }
            //Clipboard related signal R changes ends
            ClipboardConditionData.RequestInProgress = true;
            $q.all([
                RuleSharedService.SetRule(Rule)
            ]).then(function (data) {
                ClipboardConditionData.RequestInProgress = false;
                var result = data[0];
                if (result.RuleID === -1) {
                    toaster.warning({ body: "Worklist name already exists!" });
                }
                else {
                    result.Type = "A";
                    if (!Rule.RuleID) {
                        Rule.RuleID = result.RuleID;
                        Rule.checked = true;
                        $scope.DataObject.GlobalRules.push(_.cloneDeep(result));

                        result.TimeToLoad = moment();

                        $scope.DataObject.WorkLists.push(_.cloneDeep(result));

                        toaster.success({ body: "Clipboard has been created!" });

                        SortWorklistInOrder();

                        //Open window
                        $scope.viewGlobalRuleWorklist(result);

                        //Add into right side pane
                        //var checkedTimeout = $timeout(function () {
                        var worklistIndex = _.findIndex($scope.DataObject.WorkLists, function (obj) { return obj.RuleID == result.RuleID });
                        if (worklistIndex != -1) {
                            $scope.DataObject.WorkLists[worklistIndex].checked = true;
                            $scope.DataObject.WorkLists[worklistIndex].popUpWorklist = false;
                            if (WorklistListsGridoptions && WorklistListsGridoptions.api) {
                                WorklistListsGridoptions.api.setRowData($scope.DataObject.WorkLists);
                                var node = WorklistListsGridoptions.api.getRowNode(Rule.RuleID);
                                if (node) {
                                    node.setSelected(true);
                                }
                            }
                            else {
                                AddDefaultWorklist($scope.DataObject.WorkLists[worklistIndex]);
                            }
                        }

                        //$timeout.cancel(checkedTimeout);
                        //checkedTimeout = null;
                        //}, 200);

                    } else {

                        if (!ClipboardConditionData.OrderIDs) {
                            $scope.win_Worklist.close();
                            if (ClipboardConditionData.showClipboardToaster) { toaster.info({ title: "Your clipboard is empty!" }); }
                        }
                        if (ClipboardConditionData.IsInOtherClipboard && ClipboardConditionData.OrderIDs != null && ClipboardConditionData.showClipboardToaster) { toaster.info({ title: "Study(ies) have already been added to other user's clipboard." }); }
                        //if (ClipboardConditionData.ActionType != 'Reset' && ClipboardConditionData.OrderIDs != null) { toaster.success("Clipboard has been updated!"); }
                    }
                    $scope.$broadcast('event.worklist', { EventType: 'ClearClipboard', ClipboardConditionData: ClipboardConditionData });
                    if (ClipboardConditionData.showClipboardToaster) { onShowMessageByModalityNRVU(ClipboardConditionData); ClipboardConditionData.showClipboardToaster = true; }
                    var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);
                    var defaultWorklistObjIndex = _.findIndex(defaultWorklist, function (obj) { return obj.WorklistType == 16; });
                    if (defaultWorklistObjIndex != -1) {
                        defaultWorklist[defaultWorklistObjIndex].Groups = _.cloneDeep(result.Groups);
                    }
                    $scope.DataObject.DefaultWorklists = _.uniqBy(defaultWorklist, 'RuleID');
                    //console.log("updateClipboardRule: ", $scope.DataObject.DefaultWorklists);
                }
            });
            $scope.$broadcast('event.worklist', { EventType: 'ClipboardRequestInProgress', ClipboardConditionData: ClipboardConditionData });

        }

        function updateClipboardData(ClipboardConditionData, RuleConditions) {
            _.each(RuleConditions, function (condition) {
                if (condition.RuleTable.Key == "DOS") {
                    var clipboardDates = [];
                    if (ClipboardConditionData.OrderDate.startDate && ClipboardConditionData.OrderDate.endDate) {
                        clipboardDates.push(ClipboardConditionData.OrderDate.startDate);
                        clipboardDates.push(moment(condition.DateValue.startDate));
                        clipboardDates.push(ClipboardConditionData.OrderDate.endDate);
                        clipboardDates.push(moment(condition.DateValue.endDate));

                        ClipboardConditionData.OrderDate.startDate = _.min(clipboardDates, function (o) { return o; });
                        ClipboardConditionData.OrderDate.endDate = _.max(clipboardDates, function (o) { return o; });

                        condition.Value = ClipboardConditionData.OrderDateType + " '" + ClipboardConditionData.OrderDate.startDate.format("MM-DD-YYYY") + "' and '" + ClipboardConditionData.OrderDate.endDate.format("MM-DD-YYYY") + "'";
                        condition.DateValue.startDate = ClipboardConditionData.OrderDate.startDate.format("MM-DD-YYYY");
                        condition.DateValue.endDate = ClipboardConditionData.OrderDate.endDate.format("MM-DD-YYYY");
                        condition.DateValue.label = ClipboardConditionData.OrderDateType;
                        condition.StatusFlag = "M";
                    } else {
                        condition.Value = ""
                        condition.DateValue = {};
                        condition.StatusFlag = "D";
                    }

                } else if (condition.RuleTable.Key == "OrderID") {
                    if (!ClipboardConditionData.OrderIDs) {
                        condition.Value = "";
                        condition.StatusFlag = "D";
                    } else {
                        if (ClipboardConditionData.ActionType == 'Add') {
                            var OrderIDs = condition.Value && condition.Value.length > 0 ? condition.Value : "";
                            var arrOrderIDs = [];
                            var arrOrderIDs = _.compact(_.union(_.concat(_.split(OrderIDs), _.split(ClipboardConditionData.OrderIDs))));
                            ClipboardConditionData.OrderIDs = _.join(_.map(_.uniq(arrOrderIDs), function (item) { return item; }), ',');

                        }
                        condition.Value = ClipboardConditionData.OrderIDs;
                        condition.StatusFlag = "M";
                    }


                } else if (condition.RuleTable.Key == "Exam Status") {

                    if (ClipboardConditionData.OrderIDs) {
                        condition.StatusFlag = "M";
                    } else {
                        condition.StatusFlag = "D";
                    }

                }

            });


        }

        $scope.onResetClipboard = function (Rule) {
            var worklist = _.find($scope.DataObject.WorkLists, function (obj) { return obj.RuleID == Rule.RuleID });
            var ClipboardConditionData = {
                OrderDate: {
                    startDate: null,
                    endDate: null
                },
                OrderIDs: null,
                OrderDateType: "Custom range",
                ActionType: 'Reset',
                OrderIdsToRemove: '',
                showClipboardToaster: true,
            };
            if (worklist && worklist.Groups && worklist.Groups.length > 0) {
                _.each(worklist.Groups[0].RulesConditions, function (cond) {
                    if (cond.ColumnName == "ORDERS.OrderID") {
                        ClipboardConditionData.OrderIdsToRemove = ClipboardConditionData.OrderIdsToRemove + cond.Value;
                    }
                });
                CopyToClipboard(ClipboardConditionData);
            }
        };

        $scope.onChooseNextStudy = function (worklist) {
            var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);

            var defaultWorklistObjIndex = _.findIndex(defaultWorklist, function (obj) { return obj.RuleID == worklist.RuleID; });
            if (defaultWorklistObjIndex != -1) {
                if (worklist.WorklistType == 16) {
                    defaultWorklist[defaultWorklistObjIndex].OpenClipboardNextStudy = $localStorage.OpenClipboardNextStudy;
                }
                else {
                    defaultWorklist[defaultWorklistObjIndex].ChooseNextStudy = worklist.ChooseNextStudy;
                }
                $scope.updateUserLayoutPref(defaultWorklist[defaultWorklistObjIndex]);
            }
            $scope.DataObject.DefaultWorklists = _.uniqBy(defaultWorklist, 'RuleID');
            //console.log("OnClipboardNextStudyChange: ", $scope.DataObject.DefaultWorklists);
        }

        $scope.winResize = function (e) {
            ////$log.log("winResize");
            adjustSize();
        }
        function adjustSize() {
            if ($scope.currentWindow == 'win_Worklist') {
                $scope.win_Worklist.center();
            }
            return true;
        }

        function onShowMessageByModalityNRVU(ClipboardConditionData) {
            //$log.log("onShowMessageByModalityNRVU > on: ", new Date());
            switch (ClipboardConditionData.ActionType) {
                case "Add":
                    var countByModality = _.countBy(ClipboardConditionData.ClipboardData, "Modality");
                    var ModalityKeys = _.keys(countByModality);
                    var Modalities = "";
                    _.each(ModalityKeys, function (key, index) {
                        var modalitystr = key + "(" + _.get(countByModality, key, 0) + ")";
                        if (index < (ModalityKeys.length - 1)) {
                            Modalities += modalitystr + ", ";
                        } else {
                            Modalities += modalitystr;
                        }
                        //$log.log("onShowMessageByModalityNRVU > Modalities: ", Modalities);
                    });
                    var sumByRVU = _.sumBy(ClipboardConditionData.ClipboardData, function (obj) { return _.toNumber(obj.WorkRVU); });
                    toaster.pop({ type: 'success', body: "<p style=\"margin: 0;\">Modality: " + Modalities + "</p><p style=\"margin: 0;\">Total RVU: " + _.round(sumByRVU, 2) + "</p>", title: "Added to your clipboard!", bodyOutputType: 'trustedHtml' });
                    break;
                case "Remove":
                    var countByModality = _.countBy(ClipboardConditionData.SelectedRowsClipboard, "Modality");
                    var ModalityKeys = _.keys(countByModality);
                    var Modalities = "";
                    _.each(ModalityKeys, function (key, index) {
                        var modalitystr = key + "(" + _.get(countByModality, key, 0) + ")";
                        if (index < (ModalityKeys.length - 1)) {
                            Modalities += modalitystr + ", ";
                        } else {
                            Modalities += modalitystr;
                        }
                        //$log.log("onShowMessageByModalityNRVU > Modalities: ", Modalities);
                    });
                    var sumByRVU = _.sumBy(ClipboardConditionData.SelectedRowsClipboard, function (obj) { return _.toNumber(obj.WorkRVU); });
                    toaster.pop({ type: 'success', body: "<p style=\"margin: 0;\">Modality: " + Modalities + "</p><p style=\"margin: 0;\">Total RVU: " + _.round(sumByRVU, 2) + "</p>", title: "Removed from your clipboard!", bodyOutputType: 'trustedHtml' });
                    break;
            }

        }


        $scope.getUserPayments = function () {
            $state.go('payment-dashboard');
        }
        // Removed dead invoice-printing code that wrote raw HTML into a popup window (Aikido XSS finding) -
        // it was unreachable since getUserPayments returns before ever calling it, and it was
        // itself entirely commented out already.

        //Quick Search
        $scope.quickSearchTab = function () {
            $scope.DataObject.OpenQuickFilter = !$scope.DataObject.OpenQuickFilter;
        };

        $scope.onSubmitQuickFilter = function () {
            var dosField = _.find($scope.QuickSearchField, { key: 'DOS' });
            var locationField = _.find($scope.QuickSearchField, { key: 'Location' });
            if (dosField && dosField.value && dosField.value.label == 'Last 5 Years' && (!locationField || !locationField.SelectedOption || !locationField.SelectedOption.text)) {
                toaster.warning({ body: "Please select a Site/Location to use 'Last 5 Years' DOS filter." });
                return;
            }
            syncQuickSearchOrderDateBeforeSave();
            setQuickSearchSelectedData();
            openSearchedWorklist('QS');
        }

        function setQuickSearchSelectedData() {
            clearQuickSearchObj();
            _.each($scope.QuickSearchField, function (field) {
                if (field.type == 'text' && !field.SelectedOption.text) {
                    field.value = '';
                }
                if (field.type == 'text' && field.SelectedOption.text) {
                    field.value = getFilterString(field.SelectedOption.FilterOption.Key, field.SelectedOption.text);
                }
                if (($scope.DataObject.DockerPosition == 'Top' || field.checked) && field.type == "multi-select") {
                    if (field.key == "Select Modalities" && field.Modality && field.Modality != '') {
                        $scope.DataObject.SelectedData.QuickSearch.Modality = field.Modality;
                    }
                }
                if (($scope.DataObject.DockerPosition == 'Top' || field.checked) && field.value && field.value != '') {
                    switch (field.key) {
                        case 'Location':
                            $scope.DataObject.SelectedData.QuickSearch.LocationSearch = field.value;
                            break;
                        case 'Accession':
                            $scope.DataObject.SelectedData.QuickSearch.Accession = field.value;
                            break;
                        case 'Patient Name':
                            $scope.DataObject.SelectedData.QuickSearch.PatientSearch = field.value;
                            break;
                        case 'MRN':
                            $scope.DataObject.SelectedData.QuickSearch.PatientMRN = field.value;
                            break;
                        case 'DOB':
                            $scope.DataObject.SelectedData.QuickSearch.DOB = field.value;
                            break;
                        case 'DOS':
                            $scope.DataObject.SelectedData.QuickSearch.OrderDate = field.value;
                            break;
                        case 'Select Type':
                            $scope.DataObject.SelectedData.QuickSearch.PatientClass = field.value;
                            break;
                        case 'Select Priority':
                            $scope.DataObject.SelectedData.QuickSearch.StudyPriority = field.value;
                            break;
                        case 'Status':
                            $scope.DataObject.SelectedData.QuickSearch.Status.key = field.value;
                            break;
                        case 'Ordering Physician':
                            $scope.DataObject.SelectedData.QuickSearch.OrderingPhysician = field.value;
                            break;
                    }
                }
            });
        }

        $scope.validateQuichSearch = function () {
            setQuickSearchSelectedData();
            if (Object.keys($scope.DataObject.SelectedData.QuickSearch).length >= 2) {
                if (Object.keys($scope.DataObject.SelectedData.QuickSearch).length > 2 || $scope.QuickSearchField[9].value != 'AL' || $scope.QuickSearchField[5].value.startDate) {
                    return false;
                } else {
                    return true;
                }

            }
        }

        $scope.onChangeQuickFilter = function (index) {
            if (!index.checked) {
                ClearFieldValue(index);
                $scope.DataObject.SelectQuickFilter.obj = false;
            }
        }

        $scope.clearQuickFilter = function () {
            _.each($scope.QuickSearchField, function (field) {
                ClearFieldValue(field);
            });
            clearQuickSearchObj();
        }

        function clearQuickSearchObj() {
            $scope.DataObject.SelectedData.QuickSearch = {};
            $scope.DataObject.SelectedData.QuickSearch.Status = { key: 'AL' };
            $scope.DataObject.SelectedData.QuickSearch.OrderDate = {
                startDate: null,
                endDate: null
            };
        }

        $scope.resetDateRangeQuickSearch = function () {
            $scope.QuickSearchopts.ranges = {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
                'Last 5 Years': [moment().subtract(5, 'years'), moment()],
            };
            angular.element(document).ready(function () {
                angular.element('.drp-buttons .cancelBtn').click(function () {
                    angular.element('#daterange3').val('');
                    $scope.QuickSearchField[5].value = {
                        startDate: null,
                        endDate: null
                    };
                });
            });
            angular.element(document).ready(function () {
                $scope.QuickSearchField[5].value.OrderDateType = ($scope.QuickSearchField[5].value && $scope.QuickSearchField[5].value.label) ? $scope.QuickSearchField[5].value.label : $scope.QuickSearchField[5].value.OrderDateType;
                if ($scope.QuickSearchField[5].value.startDate && $scope.QuickSearchField[5].value.endDate) {
                    if ($scope.QuickSearchField[5].value.OrderDateType != null && $scope.QuickSearchField[5].value.OrderDateType.match('Custom'))
                        $scope.QuickSearchField[5].value.OrderDateType = ($scope.QuickSearchField[5].value.OrderDateType != null && $scope.QuickSearchField[5].value.OrderDateType.match('Custom')) ? ($scope.QuickSearchField[5].value.OrderDateType + '#' + moment(new Date($scope.QuickSearchField[5].value.startDate)).format("MM-DD-YYYY") + '#' +
                            moment(new Date($scope.QuickSearchField[5].value.endDate)).format("MM-DD-YYYY")) : $scope.QuickSearchField[5].value.OrderDateType;

                }
                else {
                    $scope.QuickSearchField[5].value.OrderDateType = 'Clear';
                }
                setOrderDate($scope.QuickSearchField[5].value.OrderDateType, $scope.QuickSearchField[5].value);
            });
        }

        $scope.SelectAllField = function () {
            for (var i = 0; i < $scope.QuickSearchField.length; i++) {
                $scope.QuickSearchField[i].checked = $scope.DataObject.SelectQuickFilter.obj;
            }
            if (!$scope.DataObject.SelectQuickFilter.obj) {
                $scope.clearQuickFilter();
            }
        }

        function openMedDream(order) {
            SharedService.openMedDreamCommunicationAPI(order, '');
        }

        function initialiseSidePanel() {
            var d = $q.defer();
            if ($scope.DataObject.wlTabName == 'Worklist') {
                var timeout = $timeout(function () {
                    loadWorklistListAgGrid();
                    $timeout.cancel(timeout);
                    d.resolve();
                }, 200);
            } else {
                d.resolve();
            }
            return d.promise;
        }

        $scope.restartTour = function () {
            searchTabStep = searchTabNotTopStep;
            quickSearchTabStep = quickSearchTabNotTopStep;
            worklistTabStep = worklistTabNotTopStep;
            if ($scope.DataObject.wlTabName != 'Search' && $scope.DataObject.DockerPosition != 'Top') {
                $scope.setWorklistTab('Search')
            }
            else if ($scope.DataObject.DockerPosition == 'Top') {
                $scope.DataObject.wlTabName = "";
                searchTabStep = searchTabTopStep;
                quickSearchTabStep = quickSearchTabTopStep;
                worklistTabStep = worklistTabTopStep;
            }
            $scope.DataObject.iswlTabAutoHide = false;
            var timeout = $timeout(function () {
                tour.setCurrentStep(1);
                tour._options.steps[tour._current].title = searchTabStep.title;
                tour._options.steps[tour._current].template = searchTabStep.template;
                tour.start(true);
            }, 500);
            TimeoutList.push(timeout)
        }
        //js for filter panel docking start
        $scope.wrklstFilterWraaper = angular.element('#wrklstFilterWraaper');
        $scope.dropToRight = angular.element('#dropToRight');
        $scope.dropToTop = angular.element('#dropToTop');
        $scope.leftSidebarSection = angular.element('#leftSidebarSection');
        angular.element('#sidebar-resizer').hide();
        $scope.eleDropped = angular.element('.eleDropped');
        var DockerPos = {
            Top: false,
            Right: false,
            Left: false,
        };

        window.allowDrop = function (ev) {
            ev.preventDefault();
        }

        window.drag = function (ev) {
            ev.dataTransfer.setData("text", ev.target.id);
            $scope.wrklstFilterWraaper.addClass('outActive');
            $scope.dropToRight.addClass('outActive');
            $scope.wrklstFilterWraaper.removeClass('inActive');
            $scope.dropToRight.removeClass('inActive');
            var timeout = $timeout(function () {
                $scope.dropToTop.addClass('outActive');
                $scope.dropToTop.removeClass('inActive');
                $scope.leftSidebarSection.removeClass('atTopsetHght');
            }, 5);
            TimeoutList.push(timeout)
            $scope.dropToTop.removeClass('searcHideHeight');
            $scope.dropToTop.removeClass('atTopsetHght');
            if ($scope.dropToRight.html() === "") {
                $scope.dropToRight.removeClass('docright-width');
            }
            if ($scope.dropToTop.html() === "") {
                $scope.dropToTop.removeClass('docrtop-height');
            }
            var cursorGrabb = angular.element($scope.eleDropped);
            cursorGrabb.css('cursor', 'grabbing');
        }

        window.dragEnd = function (event) {
            setDockerPosition();
            if ($scope.DataObject.DockerPosition != "Top" && $scope.DataObject.wlTabName == 'Quick Search') {
                $scope.DataObject.wlTabName = 'Search';
                saveSidePanelPreference();
            }
            if (!$scope.dropToRight.hasClass('inActive') && !$scope.dropToRight.html() === "") {
                $scope.dropToRight.removeClass('outActive');
            }
            if (!$scope.wrklstFilterWraaper.hasClass('inActive')) {
                $scope.wrklstFilterWraaper.removeClass('outActive');
            }
            if ($scope.dropToRight.hasClass('outActive') && $scope.dropToRight.html() === "") {
                $scope.dropToRight.removeClass('outActive');
            }
            if ($scope.dropToRight.html() !== "") {
                $scope.dropToRight.addClass('docright-width');
            }
            if (!$scope.dropToTop.hasClass('inActive') && !$scope.dropToTop.html() === "") {
                $scope.dropToTop.removeClass('outActive');
            }
            if ($scope.dropToTop.hasClass('outActive') && $scope.dropToTop.html() === "") {
                $scope.dropToTop.removeClass('outActive');
            }
            if ($scope.dropToTop.html() !== "") {
                $scope.dropToTop.addClass('docrtop-height');
            }
            var timeout = $timeout(function () {
                if ($scope.dropToTop.html() === "") {
                    $scope.dropToTop.removeClass('outActive');
                }
            }, 5);
            TimeoutList.push(timeout)
        }
        window.drop = function (ev) {
            //$log.log('ev', ev.target.id);
            if (ev.target.id == $scope.wrklstFilterWraaper[0].id || ev.target.id == $scope.dropToRight[0].id || ev.target.id == $scope.dropToTop[0].id) {
                DockerPos.Top = false;
                DockerPos.Right = false;
                DockerPos.Left = false;
                switch (ev.target.id) {
                    case 'dropToTop':
                        DockerPos.Top = true;
                        angular.element('#sidebar-resizer').hide();
                        break;
                    case 'dropToRight':
                        DockerPos.Right = true;
                        angular.element('#sidebar-resizer').hide();
                        break;
                    case 'wrklstFilterWraaper':
                        DockerPos.Left = true;
                        angular.element('#sidebar-resizer').show();
                        break;
                }

                _.each(Object.keys(DockerPos), function (key) {
                    if (DockerPos[key]) {
                        $scope.DataObject.DockerPosition = key;
                    }
                });
                if (userLayoutPreference.DockPanelPref) {
                    userLayoutPreference.DockPanelPref.DockerPosition = $scope.DataObject.DockerPosition;
                }
                else {
                    userLayoutPreference.DockPanelPref = { DockerPosition: $scope.DataObject.DockerPosition };
                }
                updateUserLayoutPreference();

                ev.preventDefault();
                var data = ev.dataTransfer.getData("text");
                ev.target.appendChild(document.getElementById(data));
                $scope.wrklstFilterWraaper.removeClass('outActive');
                $scope.dropToRight.removeClass('outActive');
                $scope.dropToTop.removeClass('outActive');
                ev.target.classList.remove('outActive');
                ev.target.classList.add('inActive');
                if ($scope.dropToTop.hasClass('inActive')) {
                    angular.element('body').addClass('DOSAtTop');
                    if ($scope.leftSidebarSection.hasClass('d-none')) {
                        $scope.dropToTop.addClass('searcHideHeight');
                    }
                } else {
                    angular.element('body').removeClass('DOSAtTop');
                }
                $scope.leftSidebarSection.removeClass('atTopsetHght');
            }
        }
        $scope.RmvDrg = angular.element('.drag-fltrpanel');

        window.rmvDragg = function () {
            $scope.RmvDrg.removeAttr('draggable');
        }
        window.addDragg = function () {
            $scope.RmvDrg.attr('draggable', 'true');
        }
        function setDockerPosition() {
            //var timeout = $timeout(function () {
            //$scope.side = sessionStorage.getItem("side");
            searchTabStep = searchTabNotTopStep;
            quickSearchTabStep = quickSearchTabNotTopStep;
            worklistTabStep = worklistTabNotTopStep;
            if ($scope.DataObject.DockerPosition == "Top") {
                $scope.dropToTop.addClass('inActive');
                angular.element('body').addClass('DOSAtTop');
                $scope.wrklstFilterWraaper.css('display', 'none');
                angular.element('.eleDraggable').appendTo($scope.eleDropped[0]);
                $scope.wrklstFilterWraaper.html("");
                searchTabStep = searchTabTopStep;
                quickSearchTabStep = quickSearchTabTopStep;
                worklistTabStep = worklistTabTopStep;
            }
            else if ($scope.DataObject.DockerPosition == "Right") {
                $scope.dropToRight.addClass('inActive');
                $scope.wrklstFilterWraaper.css('display', 'none');
                angular.element('body').removeClass('DOSAtTop');
                angular.element('.eleDraggable').appendTo($scope.eleDropped[2]);
                $scope.wrklstFilterWraaper.html("");
            }
            else {
                $scope.wrklstFilterWraaper.css('display', 'block');
                angular.element('#sidebar-resizer').show();
                angular.element('body').removeClass('DOSAtTop');
                angular.element('.eleDraggable').appendTo($scope.eleDropped[1]);
            }
            //}, 5);
            //TimeoutList.push(timeout)
        }
        //#region WorklistList Grid
        var WorklistListscolumnDefs = [
            {
                field: 'WorkListName',
                flex: 1,
                tooltipField: "WorkListName",
                cellRenderer: ActionButtonCellRenderer(),
                checkboxSelection: true,
                showDisabledCheckboxes: true,
            },
        ];

        //#region Available Radiologist Grid
        var WorklistListsGridoptions = {
            animateRows: false,
            domLayout: 'autoHeight',
            columnDefs: WorklistListscolumnDefs,
            defaultColDef: {
                suppressMenu: true,
                lockVisible: true,
                menuTabs: [],
            },
            getContextMenuItems: [],
            enableBrowserTooltips: true,
            rowSelection: 'multiple',
            rowStyle: { background: '#2d3436' },
            suppressRowClickSelection: true,
            headerHeight: 0,
            getRowId: function (params) {
                return params.data.RuleID;
            },
            onGridReady: function () {
                $scope.DataObject.WorkLists = _.filter($scope.DataObject.WorkLists, function (obj) {
                    if ((obj.RuleID == 'PSW') ? $scope.DataObject.ShowPracticeWorklist : true) {
                        if (obj.IsEnabled) {
                            if (!obj.WorkListName) {
                                obj.WorkListName = obj.RuleName;
                            }
                            return obj;
                        }
                    }
                });
                WorklistListsGridoptions.api.setRowData($scope.DataObject.WorkLists);
            },
            onFirstDataRendered: function (params) {
                var nodesToSelect = [];
                params.api.forEachNode(function (node) {
                    if (node.data && node.data.checked) {
                        nodesToSelect.push(node);
                    }
                });
                params.api.setNodesSelected({ nodes: nodesToSelect, newValue: true });
            },
            onRowSelected: function (params) {
                if (params.node) {
                    onCheckChanged(params.node)
                }
            },
            onRowDoubleClicked: function (params) {
                $scope.popOutWorklist(params.data);
            }
        }
        function worklistButton(title, className, ngClick, iconClass) {
            var button = document.createElement('button');
            button.title = title;
            button.className = className;
            button.style.backgroundColor = 'transparent';
            button.setAttribute('ng-click', ngClick);
            var icon = document.createElement('i');
            icon.className = iconClass;
            button.appendChild(icon);
            return button;
        }
        function ActionButtonCellRenderer() {
            function CustomRender() {
            }
            CustomRender.prototype.init = function (params) {
                var obj = _.cloneDeep(params.data);
                $scope[obj.RuleID] = obj;
                this.eGui = document.createElement('div');
                var wrapper = document.createElement('div');
                var nameSpan = document.createElement('span');
                nameSpan.className = 'worklist-hover worklist-list';
                nameSpan.textContent = obj.WorkListName;
                wrapper.appendChild(nameSpan);
                var iconSpan = document.createElement('span');
                iconSpan.className = 'd-flex edit-list-icon pt-4px';
                wrapper.appendChild(iconSpan);
                iconSpan.appendChild(worklistButton('Pop Out Window', 'btn px-2 border-0 py-1 front icon-hover pnlwrklist-icon', 'popOutWorklist(this["' + obj.RuleID + '"])', 'fa fa-external-link pt-1px txt-clr-14 fs-13px icon-hover'));
                if (($scope.DataObject.SelectedData.LoggedInUserID === obj.CreatedBy || $scope.DataObject.SelectedData.userRoles.includes('Admin') || $scope.DataObject.SelectedData.userRoles.includes('SuperAdmin'))
                    && !(obj.RuleID == 'PRW' || obj.RuleID == 'PSW') && !(obj.WorklistType == 16) && !(obj.WorklistType == 31) && !(obj.WorklistType == 51)) {
                    iconSpan.appendChild(worklistButton('Edit', 'btn px-2 border-0 py-1 front icon-hover pnlwrklist-icon', 'onEditWorklist(this[' + obj.RuleID + '])', 'glyphicon glyphicon-pencil txt-clr-14 fs-12px icon-hover'));
                }
                if (($scope.DataObject.SelectedData.LoggedInUserID === obj.CreatedBy || $scope.DataObject.SelectedData.userRoles.includes('Admin') || $scope.DataObject.SelectedData.userRoles.includes('SuperAdmin')) && !(obj.RuleID == 'PRW' || obj.RuleID == 'PSW') && !(obj.WorklistType == 21 || obj.WorklistType == 11 || obj.WorklistType == 16 || obj.WorklistType == 31 || obj.WorklistType == 51)) {
                    iconSpan.appendChild(worklistButton('Delete', 'btn px-2 ml-2px front border-0 py-1 icon-hover pnlwrklist-icon', 'deleteWorklist(this[' + obj.RuleID + '])', 'fa fa-trash-o fs-14px txt-clr-14 icon-hover'));
                }
                this.eGui.appendChild(wrapper);
                // create and compile AngularJS scope for this component
                this.$scope1 = $scope.$new();
                $compile(this.eGui)(this.$scope1);
                this.$scope1.params = params;
                //in case we are running outside of angular (ie in an ag-grid started VM turn)
                //we call $apply. we put in timeout in case we are inside apply already.
                var timeout = $timeout(this.$scope1.$apply.bind(this.$scope1), 0);
                TimeoutList.push(timeout)
            };
            CustomRender.prototype.getGui = function () {
                return this.eGui;
            };
            CustomRender.prototype.destroy = function () {
            };
            return CustomRender;
        }
        function loadWorklistListAgGrid() {
            var WorklistListGridDiv = document.getElementById('WorklistListsGrid');
            if (WorklistListGridDiv) {
                new agGrid.Grid(WorklistListGridDiv, WorklistListsGridoptions);
            }
        }
        function onCheckChanged(node) {
            var idx = _.findIndex($scope.DataObject.DefaultWorklists, function (obj) { return obj.RuleID == node.data.RuleID });
            if (node.selected) {
                node.data.checked = true;
                node.data.popUpWorklist = false;
                if (idx == -1) {
                    AddDefaultWorklist(node.data);
                }
            } else {
                if (idx != -1) {
                    node.data.ChooseNextStudy = $scope.DataObject.DefaultWorklists[idx].ChooseNextStudy;
                    $scope.RemoveDefaultWorklist(node.data);
                }
            }
        }

        //#endregion Available Radiologist Grid
        $scope.popOutWorklist = function (obj) {
            $scope.DataObject.SelectedModaliesFilter = [];
            var defaultWorklistIndex = _.findIndex(MasterDefaultWorklistData, function (worklist) { return _.toString(worklist.RuleID) == _.toString(obj.RuleID); });
            if (defaultWorklistIndex != -1) {
                var layoutOptions = _.cloneDeep(JSON.parse(MasterDefaultWorklistData[defaultWorklistIndex].LayoutOptions));
                layoutOptions.IsSmartWorklist = obj.IsSmartWorklist;
                layoutOptions.WorklistPageSize = obj.WorklistPageSize;
                obj = layoutOptions;
            }
            obj.gridId = uuidv4.newuuid();
            obj.popUpWorklist = true;
            obj.OpenClipboardNextStudy = true;
            $scope.currentWindow = 'win_Worklist';

            $scope.DataObject.WorklistPopupTitle = obj.RuleName ? obj.RuleName : obj.WorkListName;
            SetWindowOptions($scope.win_Worklist, 'win_Worklist', { title: $scope.DataObject.WorklistPopupTitle });

            //#region modality filter
            var modalityTemplate = '<div id="WLPopupModalityFilter" class="d-flex align-item-center modality-wrapper"><button type="submit" id="worklistPopupbtnAllFilterMod" class="active btn btn-primary btn-mod-all rf-btn-xs fs-10px fw-400 txt-clr-1 px-4px py-4px bor-rad-2px border-0 line-height-normal mr-5px">All</button>';
            var modalityDetailTemplate = '';
            _.each($scope.DataObject.MasterData.Modalities, function (modality) {
                if (modality.Code != 'DX') {
                    modalityDetailTemplate = '<div class="d-flex align-item-center mr-5px"><input type="checkbox" id="modalityPopUp' + modality.Code + '" class="custom-chckbox"><label for="modalityPopUp' + modality.Code + '" class="fs-10px fw-400 txt-clr-1 px-4px py-4px m-0 bor-rad-2px text-center cursor-pointer">' + modality.Code + '</label></div>';
                    if (modality.Code == 'CR') {
                        modalityDetailTemplate = '<div class="d-flex align-item-center mr-5px"><input type="checkbox" id="modalityPopUp' + modality.Code + '" class="custom-chckbox"><label for="modalityPopUp' + modality.Code + '" class="fs-10px fw-400 txt-clr-1 px-4px py-4px m-0 bor-rad-2px text-center cursor-pointer">' + modality.Code + '/DX</label></div>';
                        if (obj['CRDX']) {
                            modalityDetailTemplate = '<div class="d-flex align-item-center mr-5px"><input type="checkbox" id="modalityPopUp' + modality.Code + '" class="custom-chckbox"><label for="modalityPopUp' + modality.Code + '" class="fs-10px fw-400 txt-clr-1 px-4px py-4px m-0 bor-rad-2px text-center cursor-pointer">' + modality.Code + '/DX' + (obj['CRDX']) + '</label></div>';
                        }
                    } else {
                        if (obj[modality.Code]) {
                            modalityDetailTemplate = '<div class="d-flex align-item-center mr-5px"><input type="checkbox" id="modalityPopUp' + modality.Code + '" class="custom-chckbox"><label for="modalityPopUp' + modality.Code + '" class="fs-10px fw-400 txt-clr-1 px-4px py-4px m-0 bor-rad-2px text-center cursor-pointer">' + modality.Code(obj[modality.Code]) + '</label></div>';
                        }
                    }
                    modalityTemplate = modalityTemplate + modalityDetailTemplate;
                }


            });
            modalityTemplate = modalityTemplate + '</div>';
            if (($scope.win_Worklist.wrapper.find("#WLPopupModalityFilter")).length == 0) {
                $scope.win_Worklist.wrapper.find(".k-window-actions").before(modalityTemplate);
            }
            else {
                onResetSelectedModalitiesFilter(obj);
            }

            $("#worklistPopupbtnAllFilterMod").on("click", function () { onResetSelectedModalitiesFilter(obj); });

            _.each($scope.DataObject.MasterData.Modalities, function (modality) {
                $('#modalityPopUp' + modality.Code).on('change', function (event) {
                    onSelectModalityFilter(event, modality);
                });
            });
            //#endregion modality filter

            if ($scope.DataObject.WorklistPopupTitle == 'Cherry Pick') {
                $scope.win_Worklist.wrapper.find(".k-window-title").prepend("<div class='cherry-pick-icon'></div> &nbsp; ");
            }
            if ($scope.DataObject.WorklistPopupTitle == 'Missed SLA') {
                $scope.win_Worklist.wrapper.find(".k-window-title").prepend("<div class='msla-icon'></div> &nbsp; ");
            }
            if ($scope.DataObject.WorklistPopupTitle == 'My ClipBoard' && obj.WorklistType == 16) {
                obj.OpenClipboardNextStudy = $localStorage.OpenClipboardNextStudy;
                $scope.win_Worklist.wrapper.find(".k-window-actions").prepend("<label class='checkbox-switch ml-3px mb-0' title='Choose next study'> <input id='clipboardnextstudyswitch' type='checkbox' class='mr-2px' ><span class='checkbox-switch-slider round'></span></label> <a id='onresetclipboard' role='button' href='#' class='k-button k-bare k-button-icon'><img class='m-0 sm-refresh w-16px' src='assets/images/secondaryToolbarButton-rotateCcw.png' alt='Reset' title='Reset'/> </a>");
                $("#onresetclipboard").unbind('dblclick');
                $("#clipboardnextstudyswitch").on('change', function () {
                    var searchWorklist = _.cloneDeep($scope.DataObject.SearchedWorklist);
                    searchWorklist.OpenClipboardNextStudy = this.checked;
                    $scope.DataObject.SearchedWorklist = searchWorklist;

                    $localStorage.OpenClipboardNextStudy = this.checked;

                    var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);
                    var defaultWorklistObjIndex = _.findIndex(defaultWorklist, function (obj) { return obj.WorklistType == 16; });
                    if (defaultWorklistObjIndex != -1) {
                        defaultWorklist[defaultWorklistObjIndex].OpenClipboardNextStudy = this.checked;
                        $scope.updateUserLayoutPref(defaultWorklist[defaultWorklistObjIndex]);
                    }
                    $scope.DataObject.DefaultWorklists = _.uniqBy(defaultWorklist, 'RuleID');
                    //console.log("popOutWorklist: ", $scope.DataObject.DefaultWorklists);
                });
                $("#clipboardnextstudyswitch").prop('checked', $localStorage.OpenClipboardNextStudy);
                $("#onresetclipboard").on('click', function () { $scope.onResetClipboard(obj); });

                //SetWindowOptions($scope.win_Worklist, 'win_Worklist', { title: { text: "<b>WorklistPopupTitle</b>", encoded:false, } });
            }
            else {
                $scope.win_Worklist.wrapper.find(".k-window-actions").prepend("<label class='checkbox-switch ml-3px mb-0' title='Choose next study'> <input id='chooseNextStudySwitch' type='checkbox' class='mr-2px' ><span class='checkbox-switch-slider round'></span></label> ");

                $("#chooseNextStudySwitch").on('change', function () {
                    var searchWorklist = _.cloneDeep($scope.DataObject.SearchedWorklist);
                    searchWorklist.ChooseNextStudy = this.checked;
                    $scope.DataObject.SearchedWorklist = searchWorklist;
                    obj.ChooseNextStudy = this.checked;
                    obj.SaveLayout = true;
                    $scope.onUpdateProps(obj);
                });

                obj.ChooseNextStudy = (obj && obj.hasOwnProperty("ChooseNextStudy")) ? obj.ChooseNextStudy : true;
                var popedupworklistIdx = _.findIndex($scope.DataObject.WorkLists, function (wl) { return wl.RuleID == obj.RuleID });
                if (popedupworklistIdx != -1) {
                    $scope.DataObject.WorkLists[popedupworklistIdx].ChooseNextStudy = ($scope.DataObject.WorkLists[popedupworklistIdx] && $scope.DataObject.WorkLists[popedupworklistIdx].hasOwnProperty("ChooseNextStudy")) ? $scope.DataObject.WorkLists[popedupworklistIdx].ChooseNextStudy : true;

                    if (WorklistListsGridoptions && WorklistListsGridoptions.api) {
                        WorklistListsGridoptions.api.setRowData($scope.DataObject.WorkLists);
                    }
                }

                $("#chooseNextStudySwitch").prop('checked', obj.ChooseNextStudy);

            }
            obj.PageSize = 50;
            obj.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
            obj.purge = true;
            obj.windowOpen = true;
            $scope.DataObject.SearchedWorklist = _.cloneDeep(obj);
            $scope.win_Worklist.open();
            $scope.win_Worklist.wrapper.prevAll(".k-overlay").first().addClass("custom-overlay").css({ 'z-index': '10003', 'opacity': '0.5' });
            var timeout = $timeout(function () {
                $scope.win_Worklist.center();
            }, 100);
            TimeoutList.push(timeout);
        }

        function onResetSelectedModalitiesFilter(worklist) {
            $scope.DataObject.SelectedModaliesFilter = [];
            var masterData = _.cloneDeep($scope.DataObject.MasterData);
            masterData.selectedModalities = $scope.DataObject.SelectedModaliesFilter;
            $scope.DataObject.MasterData = masterData;

            _.each($scope.DataObject.MasterData.Modalities, function (modality) {
                var ele = document.getElementById('modalityPopUp' + modality.Code);
                if (ele) {
                    ele.checked = false;
                }
            });
            $("#worklistPopupbtnAllFilterMod").addClass('active');
        }

        function onSelectModalityFilter(event, modality) {
            if (event.target && event.target.checked) {
                $scope.DataObject.SelectedModaliesFilter.push(modality);
            }
            else {
                _.remove($scope.DataObject.SelectedModaliesFilter, { Code: modality.Code });
            }
            var masterData = _.cloneDeep($scope.DataObject.MasterData);
            masterData.selectedModalities = $scope.DataObject.SelectedModaliesFilter;
            $scope.DataObject.MasterData = masterData;

            if ($scope.DataObject.SelectedModaliesFilter.length > 0) {
                $("#worklistPopupbtnAllFilterMod").removeClass('active');
            }
            else {
                $("#worklistPopupbtnAllFilterMod").addClass('active');
            }
        }

        function updateMoadalityCount(worklist) {
            _.each($scope.DataObject.MasterData.Modalities, function (modality) {
                if (modality.Code != 'DX') {
                    var innerText = modality.Code;
                    if (modality.Code == 'CR') {
                        innerText = innerText + "/DX";
                        innerText = (worklist['CRDX']) ? innerText + "(" + worklist['CRDX'] + ")" : innerText;
                    } else {
                        innerText = (worklist[modality.Code]) ? innerText + "(" + worklist[modality.Code] + ")" : innerText;
                    }

                    var ele = document.getElementById('modalityPopUp' + modality.Code);
                    if (ele && ele.labels && ele.labels[0]) {
                        ele.labels[0].innerText = innerText;
                    }
                }

            });
        }

        function SortWorklistInOrder() {
            //This function will sort Worklist for worklistpanel in ascending order of their Rule Name
            var defaultWorklists = _.filter($scope.DataObject.WorkLists, function (obj) { return obj.Type == 'D' });
            var globalWorklists = _.filter($scope.DataObject.WorkLists, function (obj) { return obj.Type == 'A' && (obj.WorklistType && obj.WorklistType != '0') });
            var userWorklists = _.filter($scope.DataObject.WorkLists, function (obj) { return obj.Type == 'A' && (!obj.WorklistType || obj.WorklistType == '0') });

            defaultWorklists = $filter('orderBy')(defaultWorklists, ['RuleName']);
            globalWorklists = $filter('orderBy')(globalWorklists, ['RuleName']);
            userWorklists = $filter('orderBy')(userWorklists, ['RuleName']);

            $scope.DataObject.WorkLists = [];
            $scope.DataObject.WorkLists = _.concat($scope.DataObject.WorkLists, defaultWorklists);
            $scope.DataObject.WorkLists = _.concat($scope.DataObject.WorkLists, globalWorklists);
            $scope.DataObject.WorkLists = _.concat($scope.DataObject.WorkLists, userWorklists);
        }

        $scope.OnWorklistPopupClose = function () {
            addLoadingCursor();
            var onWorklistPopupCloseTimeout = $timeout(function () { $scope.DataObject.WorklistPopupTitle = 'Worklist'; removeLoadingCursor(); $timeout.cancel(onWorklistPopupCloseTimeout); }, 100);
        }

        var indexUpdateProps = false;
        $scope.onUpdateProps = function (obj) {
            //console.log("onUpdateProps > obj: ", obj);
            var index = _.findIndex(MasterDefaultWorklistData, function (worklist) {
                return _.toString(obj.RuleID) == _.toString(worklist.RuleID);
            });
            if (index != -1) {
                var worklist = (typeof (MasterDefaultWorklistData[index].LayoutOptions) == "object") ? MasterDefaultWorklistData[index].LayoutOptions : JSON.parse(MasterDefaultWorklistData[index].LayoutOptions);

                worklist.ResultPendingCount = obj.ResultPendingCount;
                worklist.UnreadRVU = obj.UnreadRVU;
                worklist.STATCount = obj.STATCount;
                worklist.purge = obj.popUpWorklist ? false : obj.purge;
                worklist.SortColumns = obj.SortColumns;
                worklist.savedState = obj.savedState;
                worklist.Groups = obj.Groups;
                worklist.ResetFilter = obj.ResetFilter;
                worklist.open = obj.open != null || obj.open != undefined ? obj.open : true;
                worklist.SignedByPrefUpdated = obj.SignedByPrefUpdated;
                worklist.SignedDatePrefUpdated = obj.SignedDatePrefUpdated;
                if (worklist.WorklistType != 16) {
                    worklist.ChooseNextStudy = obj.ChooseNextStudy;
                }
                if (obj.SaveLayout) {
                    MasterDefaultWorklistData[index].LayoutOptions = JSON.stringify(worklist);
                    MasterDefaultWorklistData[index].Type = 'M';
                    UpdatedMasterWorklists.push(MasterDefaultWorklistData[index]);
                    SetWorklistLayoutPreference('M');
                    worklist.SaveLayout = false;
                }
                //worklist.IsSmartWorklist = obj.IsSmartWorklist;
                //worklist.WorklistPageSize = obj.WorklistPageSize;

            }
            var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);
            var index = _.findIndex(defaultWorklist, function (worklist) { return worklist.RuleID == obj.RuleID });
            if (index != -1) {
                defaultWorklist[index].ResultPendingCount = obj.ResultPendingCount;
                defaultWorklist[index].UnreadRVU = obj.UnreadRVU;
                defaultWorklist[index].STATCount = obj.STATCount;
                defaultWorklist[index].purge = obj.popUpWorklist ? false : obj.purge;
                defaultWorklist[index].SortColumns = obj.SortColumns;
                defaultWorklist[index].savedState = obj.savedState;
                defaultWorklist[index].Groups = obj.Groups;
                defaultWorklist[index].ResetFilter = obj.ResetFilter;
                defaultWorklist[index].open = obj.open != null || obj.open != undefined ? obj.open : true;
                defaultWorklist[index].SignedByPrefUpdated = obj.SignedByPrefUpdated;
                defaultWorklist[index].SignedDatePrefUpdated = obj.SignedDatePrefUpdated;
                if (defaultWorklist[index].WorklistType != 16) {
                    defaultWorklist[index].ChooseNextStudy = obj.ChooseNextStudy;
                }
                //defaultWorklist[index].IsSmartWorklist = obj.IsSmartWorklist;
                //defaultWorklist[index].WorklistPageSize = obj.WorklistPageSize;
            }
            $scope.DataObject.DefaultWorklists = defaultWorklist;
            ////console.log("onUpdateProps: ", $scope.DataObject.DefaultWorklists);

            var worklistIndex = _.findIndex($scope.DataObject.WorkLists, function (worklist) { return worklist.RuleID == obj.RuleID });
            if (worklistIndex != -1) {
                $scope.DataObject.WorkLists[worklistIndex].ResultPendingCount = obj.ResultPendingCount;
                $scope.DataObject.WorkLists[worklistIndex].UnreadRVU = obj.UnreadRVU;
                $scope.DataObject.WorkLists[worklistIndex].STATCount = obj.STATCount;
                $scope.DataObject.WorkLists[worklistIndex].purge = obj.purge;
                $scope.DataObject.WorkLists[worklistIndex].SortColumns = obj.SortColumns;
                $scope.DataObject.WorkLists[worklistIndex].savedState = obj.savedState;
                $scope.DataObject.WorkLists[worklistIndex].Groups = obj.Groups;
                $scope.DataObject.WorkLists[worklistIndex].ResetFilter = obj.ResetFilter;
                $scope.DataObject.WorkLists[worklistIndex].open = obj.open != null || obj.open != undefined ? obj.open : true;
                $scope.DataObject.WorkLists[worklistIndex].SignedByPrefUpdated = obj.SignedByPrefUpdated;
                $scope.DataObject.WorkLists[worklistIndex].SignedDatePrefUpdated = obj.SignedDatePrefUpdated;
                $scope.DataObject.WorkLists[worklistIndex].SaveLayout = false;
                if ($scope.DataObject.WorkLists[worklistIndex].WorklistType != 16) {
                    $scope.DataObject.WorkLists[worklistIndex].ChooseNextStudy = obj.ChooseNextStudy;
                }
                if (WorklistListsGridoptions && WorklistListsGridoptions.api) {
                    WorklistListsGridoptions.api.setRowData($scope.DataObject.WorkLists);
                }
                //$scope.DataObject.WorkLists[worklistIndex].IsSmartWorklist = obj.IsSmartWorklist;
                //$scope.DataObject.WorkLists[worklistIndex].WorklistPageSize = obj.WorklistPageSize;
            }
            //#region Release Tour
            if (!indexUpdateProps && !$sessionStorage.isStartUserGuideTour) {
                var releasetourtimeout = $timeout(function () {
                    $rootScope.$broadcast('startReleaseTour', true);

                    $timeout.cancel(releasetourtimeout);
                    releasetourtimeout = null;
                }, 2000);
                indexUpdateProps = true;
                $sessionStorage.isStartUserGuideTour = true;
            }

            if (obj.popUpWorklist && $scope.DataObject.SearchedWorklist && $scope.DataObject.SearchedWorklist.RuleID == obj.RuleID) {
                updateMoadalityCount(obj);
            }
            //#endregion Release Tour
        }

        function onRefreshInterval() {
            if (!validateDOS(false)) return;

            UpdateTimeToLoad();
            if (CurrentIndexToRefresh == 0) {
                GetUserPaymentHeader();
                GetWorklistStatusCount();
                GetOverdueReadsCount();
            }
            $interval.cancel(newOrderRefreshInterval);
            if (CurrentIndexToRefresh >= ($scope.DataObject.DefaultWorklists.length - 1)) {
                DefaultAutoRefreshDuration = __env.DefaultAutoRefreshDuration;
                CurrentIndexToRefresh = 0;
            } else {
                DefaultAutoRefreshDuration = 3000;
                CurrentIndexToRefresh++;
            }
            newOrderRefreshInterval = $interval(onRefreshInterval, DefaultAutoRefreshDuration);
        }
        $scope.updateSelectedLocation = function () {
            $scope.DataObject.SelectedData.locationIDs = $scope.DataObject.SelectedData.SelectedLocations.Ids;
            $scope.DataObject.SelectedData.Location = $scope.DataObject.SelectedData.SelectedLocations.locations;
        }

        $scope.onOpenWinWorklist = function () {
            $scope.DataObject.ShowWorklistWindow = true;
            var visibleTimeout = $timeout(function () { $("#win_Worklist").show(); $("#win_Worklist").css("visibility", "visible"); $timeout.cancel(visibleTimeout); visibleTimeout = null; }, 500);
            // Hide Bootstrap Tour backdrop so it doesn't stack with the Kendo modal overlay
            if (tour && tour._inited && typeof tour._current !== 'undefined') {
                try { tour.hideStep(tour._current); } catch (e) { }
            }
            // Unbind Bootstrap Tour's global scroll listener while the Kendo window is open.
            // Opening the window triggers a scroll event, and the tour's debounced scroll
            // handler calls _showPopoverAndOverlay(tour._current) 100ms later; if _current is
            // stale relative to the currently-loaded steps array, that throws "Cannot read
            // properties of undefined (reading 'backdrop')".
            if (tour && tour._options) {
                $(window).off('scroll.tour-' + tour._options.name);
            }
            $('.tour-backdrop').hide();
            $('.popover.tour').hide();
        }

        $scope.onCloseWinWorklist = function () {
            $("#win_Worklist").css("visibility", "hidden");
            $scope.DataObject.WorklistPopupTitle = 'Worklist';
            var visibleTimeout = $timeout(function () { $scope.DataObject.ShowWorklistWindow = false; $timeout.cancel(visibleTimeout); visibleTimeout = null; }, 500);
            // Remove custom-overlay class and reset inline styles so the backdrop doesn't persist
            if ($scope.win_Worklist && $scope.win_Worklist.wrapper) {
                $scope.win_Worklist.wrapper.prevAll(".k-overlay").first()
                    .removeClass("custom-overlay")
                    .css({ 'z-index': '', 'opacity': '' });
            }
            // Restore Bootstrap Tour if still active
            if (tour && tour._inited && $sessionStorage.isStartUserGuideTour) {
                try { tour.showStep(tour._current); } catch (e) { }
                // Rebind the scroll listener we removed in onOpenWinWorklist, matching the
                // binding bootstrap-tour's own init() sets up internally.
                if (tour._options && typeof tour._showPopoverAndOverlay === 'function') {
                    tour._onScroll(function () { return tour._showPopoverAndOverlay(tour._current); });
                }
                $('.tour-backdrop').show();
                $('.popover.tour').show();
            }
        }

        function getLoadMoreWorklistPreference() {
            var d = $q.defer();
            if ($state.current.name == "worklist-lite") {
                UserPreferenceService.GetUserPreferences({
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceType: 'LoadMoreWorklist',
                }).then(function (result) {
                    if (result != null && result.UserPreferences != null) {
                        loadMoreWorklist = _.find(result.UserPreferences, { PreferenceType: "LoadMoreWorklist" });
                        if (result.UserAccountDetails.IsPaymentContractEnabled) {
                            $scope.WorklistPageHeaderParameter.isPCAvailable = true;
                        }
                    }
                    d.resolve();
                });
            } else {
                d.resolve();
            }
            return d.promise;
        }

        function setLoadMoreWorklistPreference() {
            var d = $q.defer();
            if ($state.current.name == "worklist-lite" && loadMoreWorklist != null && loadMoreWorklist.PreferenceValue && loadMoreWorklist.PreferenceValue != "1") {
                loadMoreWorklist.PreferenceValue = "1";
                UserPreferenceService.AddEditUserPreferences([{
                    UserPreferenceID: loadMoreWorklist.UserPreferenceID ? loadMoreWorklist.UserPreferenceID : "-1",
                    PreferenceType: "LoadMoreWorklist",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: loadMoreWorklist.PreferenceValue,
                }]).then(function (result) {
                    $localStorage.LoadMoreWorklist = loadMoreWorklist.PreferenceValue;
                    d.resolve();
                });
            } else {
                d.resolve();
            }
            return d.promise;
        }

        $scope.OnRefreshWorklist = function (obj) {
            var defaultWorklist = _.cloneDeep($scope.DataObject.DefaultWorklists);
            var index = _.findIndex(defaultWorklist, function (worklist) { return worklist.RuleID == obj.RuleID });
            if (index != -1) {
                defaultWorklist[index].purge = true;
                defaultWorklist[index].TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
                defaultWorklist[index].ResetFilter = true;
            }
            $scope.DataObject.DefaultWorklists = _.uniqBy(defaultWorklist, 'RuleID');
            //console.log("OnRefreshWorklist: ", $scope.DataObject.DefaultWorklists);
        }



        $scope.keys = {
            F12: function (name, code) {
                $scope.$broadcast('event.worklist', {
                    EventType: 'KeyBoardEvent',
                    Name: name,
                    Code: code
                });
            },
            F11: function (name, code) {

                $scope.$broadcast('event.worklist', {
                    EventType: 'KeyBoardEvent',
                    Name: name,
                    Code: code
                });
            },
        };
        angular.element(document).ready(function () {
            angular.element('.stepQuickFilter').hover(function () {
                if (angular.element("#frmFilter").find('.tag-list').children().length > 0) {
                    angular.element("#frmFilter").addClass('locanotempty');
                } else {
                    angular.element("#frmFilter").removeClass('locanotempty');
                }
            });
            angular.element('.wl-menu-right, .ag-body-viewport').scroll(function () {
                if (angular.element(this).scrollTop() > 50) {
                    angular.element('.ag-theme-balham-dark.ag-popup').css({
                        'display': 'none'
                    });
                }
            });
        });
        function getFilterString(type, filter) {
            var FilterString = "";
            switch (type) {
                case 'contains':
                    FilterString = "*" + filter + "*";
                    break;
                case 'equals':
                    FilterString = filter;
                    break;
                case 'endswith':
                    FilterString = "*" + filter;
                    break;
                case 'startswith':
                    FilterString = filter + "*";
                    break;
            }
            return FilterString;
        }

        $scope.onChangeClearInputDropDownText = function (field) {
            if (field.type == 'text' && !field.SelectedOption.text) {
                field.value = '';
            }
        }

        function SetWorklistLayoutPreference(Flag) {
            var d = $q.defer();
            if (UpdatedMasterWorklists.length > 0) {
                _.each(UpdatedMasterWorklists, function (item) {
                    item.LayoutOptions = JSON.stringify(omitWorklistMasterData(JSON.parse(item.LayoutOptions)));
                });
                var obj = {
                    Flag: Flag,
                    CreatedBy: $sessionStorage.currentUserData.userId,
                    UserLayoutOptions: UpdatedMasterWorklists,
                };
                UserLayoutPrefService.SetWorklistLayoutPreferences(obj).then(function (result) {
                    //MasterDefaultWorklistData = _.sortBy(_.uniqBy(result, 'RuleID'), 'WorkistOrder');
                    UpdatedMasterWorklists = [];
                    d.resolve();
                });
            }
            else {
                d.resolve();
            }
            return d.promise;
        }
        function omitWorklistMasterData(worklist) {
            var omitedWorklist = _.omit(worklist, ['popUpWorklist',
                'loading',
                'ResultPendingCount',
                'UnreadRVU',
                'STATCount',
                'PageSize',
                'gridId',
                'windowOpen',
                'UpdateID',
                'TimeToLoad',
                'ModifyBy',
                'IsHighpriority',
                'RuleDescription',
                'StatusFlag',
                'ModifyDate',
                'IsEnabled',
                'IsWorkList',
                'RulesProviders',
                'WhereClauseText',
                'Groups',
                'RulesConditions',
                'ClipboardConditionData',
                'TAT',
                'TATType',
                'SLABreachTime',
                'deleted',
                'isCollapsed',
                'selectedRadiologists',
                'purge',
                'AR',
                'BD',
                'BDUS',
                'BMD',
                'CR',
                'CT',
                'DEXA',
                'DX',
                'KO',
                'MG',
                'MR',
                'NM',
                'PT',
                'RF',
                'US',
                'XA',
                'IsSmartWorklist',
                'WorklistPageSize'
            ]);
            return omitedWorklist;
        }
        // Function to update master array
        function ReorderMasterDefaultWorklist() {
            _.each(MasterDefaultWorklistData, function (masterObj, index) {
                masterObj.WorkistOrder = index;
                masterObj.Type = 'M';
            });
            MasterDefaultWorklistData = _.sortBy(MasterDefaultWorklistData, 'WorkistOrder');

            UpdatedMasterWorklists = MasterDefaultWorklistData;

            var defaultWorklist = [];
            _.each(MasterDefaultWorklistData, function (eWorklist) {
                if (!eWorklist.IsDeleted) {
                    var layoutOption = JSON.parse(eWorklist.LayoutOptions);
                    defaultWorklist.push(setWorklistAttr(layoutOption));
                }
            });
            $scope.DataObject.DefaultWorklists = defaultWorklist;
            //console.log("ReorderMasterDefaultWorklist: ", $scope.DataObject.DefaultWorklists);

            SetWorklistLayoutPreference('M');
        };
        function GetWorklistStatusCount() {
            if (PendingAddendumWorklist) {
                if (!PendingAddendumWorklist.Groups) {
                    RuleSharedService.GetRuleDetails(PendingAddendumWorklist, "View").then(function (data) {
                        PendingAddendumWorklist.Groups = data.Rule.Groups;
                        $q.all([
                            GetOrderDate(PendingAddendumWorklist),
                            GetSignDate(PendingAddendumWorklist)
                        ]).then(function () {
                            WorklistService.GetWorklistStatusCount({
                                OrderDateStartDate: $filter('CSTDateTime')(moment(moment(new Date(PendingAddendumWorklist.OrderDateStartDate)).format("YYYY-MM-DD") + ' ' + "00:00")),
                                OrderDateEndDate: $filter('CSTDateTime')(moment(moment(new Date(PendingAddendumWorklist.OrderDateEndDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")),
                                UserID: $sessionStorage.currentUserData.userId,
                                FromSignDate: $filter('CSTDateTime')(moment(moment(new Date(PendingAddendumWorklist.FromSignDate)).format("YYYY-MM-DD") + ' ' + "00:00")),
                                ToSignDate: $filter('CSTDateTime')(moment(moment(new Date(PendingAddendumWorklist.ToSignDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")),
                                AdminWorklistIds: PendingAddendumWorklist.RuleID
                            }).then(function (result) {
                                $scope.DataObject.PendingAddendumCount = result;
                            });
                        })
                    });
                }
                else {
                    WorklistService.GetWorklistStatusCount({
                        OrderDateStartDate: $filter('CSTDateTime')(moment(moment(new Date(PendingAddendumWorklist.OrderDateStartDate)).format("YYYY-MM-DD") + ' ' + "00:00")),
                        OrderDateEndDate: $filter('CSTDateTime')(moment(moment(new Date(PendingAddendumWorklist.OrderDateEndDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")),
                        UserID: $sessionStorage.currentUserData.userId,
                        FromSignDate: $filter('CSTDateTime')(moment(moment(new Date(PendingAddendumWorklist.FromSignDate)).format("YYYY-MM-DD") + ' ' + "00:00")),
                        ToSignDate: $filter('CSTDateTime')(moment(moment(new Date(PendingAddendumWorklist.ToSignDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")),
                        AdminWorklistIds: PendingAddendumWorklist.RuleID
                    }).then(function (result) {
                        $scope.DataObject.PendingAddendumCount = result;
                    });
                }

            }
        }
        function GetOverdueReadsCount() {
            if (!OverdueReadsWorklist) return;
            var defaultStartStr = moment().subtract(12, 'months').format('YYYY-MM-DD') + ' 00:00';
            var defaultEndStr   = moment().format('YYYY-MM-DD') + ' 23:59:59';
            var startDate = $filter('CSTDateTime')(moment(OverdueReadsWorklist.OrderDateStartDate
                ? moment(new Date(OverdueReadsWorklist.OrderDateStartDate)).format('YYYY-MM-DD') + ' 00:00'
                : defaultStartStr));
            var endDate = $filter('CSTDateTime')(moment(OverdueReadsWorklist.OrderDateEndDate
                ? moment(new Date(OverdueReadsWorklist.OrderDateEndDate)).format('YYYY-MM-DD') + ' 23:59:59'
                : defaultEndStr));
            WorklistService.GetWorklistStatusCount({
                OrderDateStartDate: startDate,
                OrderDateEndDate: endDate,
                UserID: $sessionStorage.currentUserData.userId,
                AdminWorklistIds: OverdueReadsWorklist.RuleID,
                WorklistName: 'OverDues'
            }).then(function (count) {
                $scope.DataObject.OverdueReadsCount = count || 0;
                if ($scope.DataObject.OverdueReadsCount === 0) {
                    if ($scope.win_Worklist
                            && $scope.DataObject.SearchedWorklist
                            && $scope.DataObject.SearchedWorklist.WorklistType == 51) {
                        $scope.win_Worklist.close();
                    }
                    $scope.DataObject.GlobalRules = _.filter($scope.DataObject.GlobalRules, function(r) { return r.WorklistType !== 51; });
                    var overdueInPane = _.find($scope.DataObject.DefaultWorklists, function(r) { return r.WorklistType == 51; });
                    if (overdueInPane) {
                        _hiddenOverdueDefaultWorklist = overdueInPane;
                        $scope.DataObject.DefaultWorklists = _.filter($scope.DataObject.DefaultWorklists, function(r) { return r.WorklistType !== 51; });
                        CalculateHeight();
                    }
                } else {
                    if (!_.find($scope.DataObject.GlobalRules, function(r) { return r.WorklistType === 51; })) {
                        $scope.DataObject.GlobalRules = _.sortBy(
                            $scope.DataObject.GlobalRules.concat([OverdueReadsWorklist]),
                            ['RuleName']
                        );
                    }
                    if (_hiddenOverdueDefaultWorklist && !_.find($scope.DataObject.DefaultWorklists, function(r) { return r.WorklistType == 51; })) {
                        $scope.DataObject.DefaultWorklists = $scope.DataObject.DefaultWorklists.concat([_hiddenOverdueDefaultWorklist]);
                        _hiddenOverdueDefaultWorklist = null;
                        CalculateHeight();
                    }
                }
            });
        }
        function GetOrderDate(worklist) {
            var d = $q.defer();

            var RuleOrderDate = { Value: 'Last 7 Days', DateValue: { startDate: null, endDate: null } };
            var RuleOrderDateLabel = '';

            _.each(worklist.Groups, function (group) {
                var grpRuleConditions = _.filter(group.RulesConditions, function (cond) { return cond.StatusFlag != 'D' });
                RuleOrderDateLabel = _.find(grpRuleConditions, { ColumnName: 'ORDERS.OrderDate' });
            });

            if (RuleOrderDateLabel) {
                RuleOrderDate.Value = RuleOrderDateLabel.DateValue.label;
                if (RuleOrderDateLabel.DateValue && RuleOrderDateLabel.DateValue.label.includes('Custom range')) {
                    RuleOrderDate.Value += " " + moment(RuleOrderDateLabel.DateValue.startDate).format('MM/DD/YYYY') + " and " + moment(RuleOrderDateLabel.DateValue.endDate).format('MM/DD/YYYY') + "";
                    RuleOrderDate.DateValue.startDate = moment(RuleOrderDateLabel.DateValue.startDate).format('MM/DD/YYYY');
                    RuleOrderDate.DateValue.endDate = moment(RuleOrderDateLabel.DateValue.endDate).format('MM/DD/YYYY');
                }
            }
            RuleSharedService.setOrderDateByLabel(RuleOrderDate);
            worklist.OrderDateStartDate = RuleOrderDate.DateValue.startDate;
            worklist.OrderDateEndDate = RuleOrderDate.DateValue.endDate;
            d.resolve();
            return d.promise;
        }

        function GetSignDate(worklist) {
            var d = $q.defer();

            var RuleSignDate = { Value: 'Today', DateValue: { startDate: null, endDate: null } };
            var RuleSignDateLabel = '';

            _.each(worklist.Groups, function (group) {
                var grpRuleConditions = _.filter(group.RulesConditions, function (cond) { return cond.StatusFlag != 'D' });
                RuleSignDateLabel = _.find(grpRuleConditions, { ColumnName: 'Reports.SignDate' });
            });

            if (RuleSignDateLabel) {
                RuleSignDate.Value = RuleSignDateLabel.DateValue.label;
                if (RuleSignDateLabel.DateValue && RuleSignDateLabel.DateValue.label.includes('Custom range')) {
                    RuleSignDate.Value += " " + moment(RuleSignDateLabel.DateValue.startDate).format('MM/DD/YYYY') + " and " + moment(RuleSignDateLabel.DateValue.endDate).format('MM/DD/YYYY') + "";
                    RuleSignDate.DateValue.startDate = moment(RuleSignDateLabel.DateValue.startDate).format('MM/DD/YYYY');
                    RuleSignDate.DateValue.endDate = moment(RuleSignDateLabel.DateValue.endDate).format('MM/DD/YYYY');
                }
            }
            RuleSharedService.setOrderDateByLabel(RuleSignDate);

            worklist.FromSignDate = RuleSignDate.DateValue.startDate;
            worklist.ToSignDate = RuleSignDate.DateValue.endDate;

            d.resolve();
            return d.promise;
        }

        $scope.$on("NewWorklist_Tour", function (evt, data) {
            if (data) {
                TourFlag = true;
                HelpWorklistTour();
            }
        });

        function GetWorklistTourSteps() {
            var d = $q.defer();
            CommonService.GetTourSteps('Worklist').then(function (result) {
                if (tour && tour._options) {
                    tour._options.steps = result.Steps;
                    d.resolve();
                }
            });
            return d.promise;
        }

        function WorklistInitTour() {
            var d = $q.defer();
            startUserGuideTour().then(function () {
                HelpWorklistTour();
                d.resolve();
            });
            return d.promise;
        }

        function HelpWorklistTour() {
            if (TourFlag) {
                var timeout = $timeout(function () {
                    $scope.restartTour();
                }, 1000);
                TimeoutList.push(timeout);
            }
        }
        $scope.onSelectedModalityFilter = function (selectedData) {
            $scope.DataObject.SelectedData.Modality = selectedData;
            setModalitytooltip($scope.DataObject.SelectedData);
        }

        function SetQuickSearchFilterValues(columns) {
            var obj = {};
            _.each($scope.QuickSearchField, function (field) {
                if ($scope.DataObject.DockerPosition == 'Top' || field.checked && field.type == "multi-select") {
                    if (field.key == "Select Modalities") {
                        obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'ModalityID', Value: field.Modality != '' ? _.join(_.map(field.Modality, 'Id'), ',') : null };
                        columns.push(obj);
                    }
                }
                if ($scope.DataObject.DockerPosition == 'Top' || field.checked) {
                    switch (field.key) {
                        case 'Location':
                            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'LocationID', Value: field.value ? field.SelectedOption.text : null, Operator: field.SelectedOption.FilterOption.Value };
                            columns.push(obj);
                            break;
                        case 'Accession':
                            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'Accession', Value: field.value ? field.SelectedOption.text : null, Operator: field.SelectedOption.FilterOption.Value };
                            columns.push(obj);
                            break;
                        case 'Patient Name':
                            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'PatientName', Value: field.value ? field.SelectedOption.text : null, Operator: field.SelectedOption.FilterOption.Value };
                            columns.push(obj);
                            break;
                        case 'MRN':
                            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'PatientMRN', Value: field.value ? field.SelectedOption.text : null, Operator: field.SelectedOption.FilterOption.Value };
                            columns.push(obj);
                            break;
                        case 'DOB':
                            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'PatientDOB', Value: field.value ? moment(field.value).format("MM-DD-YYYY") : null };
                            columns.push(obj);
                            break;
                        case 'DOS':
                            var od = field.value;
                            if (!od || (!od.startDate && !(od.OrderDate && od.OrderDate.startDate))) {
                                break;
                            }
                            var odStart = od.startDate || (od.OrderDate && od.OrderDate.startDate);
                            var odEnd = od.endDate || (od.OrderDate && od.OrderDate.endDate);
                            var qsOrderType = od.label ? od.label : od.OrderDateType;
                            obj = {
                                Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'OrderDate',
                                Value: (qsOrderType != null && qsOrderType.match('Custom')) ? (qsOrderType + '#' + moment(new Date(odStart)).format("MM-DD-YYYY") + '#' + moment(new Date(odEnd)).format("MM-DD-YYYY")) : qsOrderType
                            };
                            columns.push(obj);
                            break;
                        case 'Select Type':
                            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'PatientClass', Value: field.value ? field.value.Value : null };
                            columns.push(obj);
                            break;
                        case 'Select Priority':
                            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'Priority', Value: field.value ? field.value.Value : null };
                            columns.push(obj);
                            break;
                        case 'Status':
                            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'Status', Value: field.value ? field.value : null };
                            columns.push(obj);
                            break;
                        case 'Ordering Physician':
                            obj = { Id: 0, UserId: $sessionStorage.currentUserData.userId, PageName: 'Work List Quick Search', ColumnName: 'OrderingPhysician', Value: field.value ? field.SelectedOption.text : null, Operator: field.SelectedOption.FilterOption.Value };
                            columns.push(obj);
                            break;
                    }
                }
            });
            return columns;
        }

        function GetQuickSearchFilterValues(WorklistQuickSearch) {
            if (WorklistQuickSearch && WorklistQuickSearch.length > 0) {
                _.each($scope.QuickSearchField, function (field) {
                    if (field.checked) {
                        field.checked = false;
                    }
                });
                _.each(WorklistQuickSearch, function (data) {
                    switch (data.ColumnName) {
                        case 'LocationID':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'Location' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    $scope.QuickSearchField[index].SelectedOption.FilterOption = _.find($scope.DataObject.InputDropdownList.Options, { Value: data.Operator });
                                    $scope.QuickSearchField[index].SelectedOption.text = data.Value;
                                }
                                $scope.QuickSearchField[index].checked = true;
                            }
                            break;
                        case 'Accession':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'Accession' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    $scope.QuickSearchField[index].SelectedOption.FilterOption = _.find($scope.DataObject.InputDropdownList.Options, { Value: data.Operator });
                                    $scope.QuickSearchField[index].SelectedOption.text = data.Value;
                                }
                                $scope.QuickSearchField[index].checked = true;
                            }
                            break;
                        case 'PatientName':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'Patient Name' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    $scope.QuickSearchField[index].SelectedOption.FilterOption = _.find($scope.DataObject.InputDropdownList.Options, { Value: data.Operator });
                                    $scope.QuickSearchField[index].SelectedOption.text = data.Value;
                                }
                                $scope.QuickSearchField[index].checked = true;
                            }
                            break;
                        case 'PatientMRN':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'MRN' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    $scope.QuickSearchField[index].SelectedOption.FilterOption = _.find($scope.DataObject.InputDropdownList.Options, { Value: data.Operator });
                                    $scope.QuickSearchField[index].SelectedOption.text = data.Value;
                                }
                                $scope.QuickSearchField[index].checked = true;
                            }
                            break;
                        case 'PatientDOB':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'DOB' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    $scope.QuickSearchField[index].value = new Date(data.Value);
                                }
                                $scope.QuickSearchField[index].checked = true;
                            }
                            break;
                        case 'OrderDate':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'DOS' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    setOrderDate(data.Value, data);
                                    $scope.QuickSearchField[index].value.OrderDate = data.OrderDate;
                                    $scope.QuickSearchField[index].value.OrderDateType = data.OrderDateType;
                                    $scope.QuickSearchField[index].value.startDate = data.OrderDate.startDate;
                                    $scope.QuickSearchField[index].value.endDate = data.OrderDate.endDate;
                                    $scope.QuickSearchField[index].value.label = data.OrderDateType;
                                    $scope.QuickSearchField[index].value.toolTipOrderDate = data.toolTipOrderDate;
                                }
                                $scope.QuickSearchField[index].checked = true;
                            }
                            break;
                        case 'ModalityID':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'Select Modalities' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    var modalities = [];
                                    if (data.Value) {
                                        _.each(data.Value.split(','), function (data) {
                                            if (data) {
                                                var filter = _.find($scope.DataObject.MasterData.Modalities, function (item) { return item.Id == data; });
                                                if (filter != null) {
                                                    modalities.push(filter);
                                                }
                                            }
                                        });
                                    }
                                    $scope.DataObject.ModalityDropdownDataQC.SelectedValue = {
                                        list: modalities,
                                    };
                                    $scope.QuickSearchField[index].Modality = modalities;
                                }
                                $scope.QuickSearchField[index].checked = true;
                                setModalitytooltip($scope.QuickSearchField[index]);
                            }
                            break;
                        case 'PatientClass':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'Select Type' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    $scope.QuickSearchField[index].value = _.find($scope.QuickSearchField[index].list, function (item) { return item.Value == data.Value; });
                                }
                                $scope.QuickSearchField[index].checked = true;
                            }
                            break;
                        case 'Priority':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'Select Priority' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    $scope.QuickSearchField[index].value = _.find($scope.QuickSearchField[index].list, function (item) { return item.Value == data.Value; });
                                }
                                $scope.QuickSearchField[index].checked = true;
                            }
                            break;
                        case 'Status':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'Status' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    $scope.QuickSearchField[index].value = data.Value;
                                }
                                $scope.QuickSearchField[index].checked = true;
                                break;
                            }
                        case 'OrderingPhysician':
                            var index = _.findIndex($scope.QuickSearchField, { key: 'Ordering Physician' });
                            if (index != -1) {
                                if (data.Value != null) {
                                    $scope.QuickSearchField[index].SelectedOption.FilterOption = _.find($scope.DataObject.InputDropdownList.Options, { Value: data.Operator });
                                    $scope.QuickSearchField[index].SelectedOption.text = data.Value;
                                }
                                $scope.QuickSearchField[index].checked = true;
                            }
                            break;
                    }
                });
            }
        }

        $scope.validateQuichSearchSaveFilter = function () {
            $scope.DataObject.SelectQuickFilter.obj = _.every($scope.QuickSearchField, ['checked', true]);
            return !($scope.DataObject.DockerPosition != 'Top' ? _.some($scope.QuickSearchField, ['checked', true]) : true);
        }

        function ClearFieldValue(field) {
            switch (field.key) {
                case 'DOS':
                    field.value = { toolTipOrderDate: 'DOS' };
                    break;
                case 'Select Modalities':
                    field.modalitytooltip = 'Select modalities';
                    field.value = [];
                    $scope.DataObject.ModalityDropdownDataQC.SelectedValue = { list: [] };
                    break;
                case 'Status':
                    field.value = 'AL';
                    break;
                case 'Location':
                    field.SelectedOption = {
                        FilterOption: {
                            Key: 'contains',
                            Value: 'Contains'
                        },
                        text: ''
                    };
                    field.value = '';
                    break;
                case 'Accession':
                    field.SelectedOption = {
                        FilterOption: {
                            Key: 'equals',
                            Value: 'Equals'
                        },
                        text: ''
                    };
                    field.value = '';
                    break;
                case 'Patient Name':
                    field.SelectedOption = {
                        FilterOption: {
                            Key: 'contains',
                            Value: 'Contains'
                        },
                        text: ''
                    };
                    field.value = '';
                    break;
                case 'MRN':
                    field.SelectedOption = {
                        FilterOption: {
                            Key: 'equals',
                            Value: 'Equals'
                        },
                        text: ''
                    };
                    field.value = '';
                    break;
                case 'Ordering Physician':
                    field.SelectedOption = {
                        FilterOption: {
                            Key: 'contains',
                            Value: 'Contains'
                        },
                        text: ''
                    };
                    field.value = '';
                    break;
                default:
                    field.value = '';
                    break;
            }
        }

        function syncQuickSearchOrderDateBeforeSave() {
            var dosField = _.find($scope.QuickSearchField, { key: 'DOS' });
            if (!dosField || !dosField.value) {
                return;
            }
            var v = dosField.value;
            if (!v.startDate && !(v.OrderDate && v.OrderDate.startDate)) {
                return;
            }
            var label = v.label;
            if (!label) {
                return;
            }
            var namedPresets = ['Today', 'Last 3 Days', 'Last 7 Days', 'Last 30 Days', 'Last Year', 'Last 5 Years'];
            if (namedPresets.indexOf(label) === -1) {
                return;
            }
            setOrderDate(label, v);
            if (v.OrderDate) {
                v.startDate = v.OrderDate.startDate;
                v.endDate = v.OrderDate.endDate;
            }
        }

        $scope.SaveFilterQuickSearch = function () {
            var dosField = _.find($scope.QuickSearchField, { key: 'DOS' });
            var locationField = _.find($scope.QuickSearchField, { key: 'Location' });
            if (dosField && dosField.value && dosField.value.label == 'Last 5 Years' && (!locationField || !locationField.SelectedOption || !locationField.SelectedOption.text)) {
                toaster.warning({ body: "Please select a Site/Location to use 'Last 5 Years' DOS filter." });
                return;
            }
            syncQuickSearchOrderDateBeforeSave();
            setQuickSearchSelectedData();
            var columns = [];
            columns = SetQuickSearchFilterValues(columns);
            if (columns && columns.length > 0) {
                WorklistService.SaveFilterSetting(columns).then(function (result) {
                    toaster.success({ body: "Filter saved successfully." });
                    if (result && result.length > 0) {
                        GetQuickSearchFilterValues(result);
                    }
                });
            }
            columns = null;
        }

        function GetUserPaymentHeader() {
            if ($scope.WorklistPageHeaderParameter.isPCAvailable) {
                var startDate = moment(moment().format("YYYY-MM-DD") + ' ' + "00:00");
                var endDate = moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59");
                PaymentContractService.GetUserPaymentHeader({
                    UserID: $sessionStorage.currentUserData.userId,
                    StartDate: $filter('CSTDateTime')(startDate),
                    EndDate: $filter('CSTDateTime')(endDate),
                }).then(function (result) {
                    if (result) {
                        if (result.userPaymentHeaders) {
                            var NewEarnings = $scope.WorklistPageHeaderParameter.TotalCollectionForDay ? !_.isEqual(result.userPaymentHeaders.TotalCollectionForDay, $scope.WorklistPageHeaderParameter.TotalCollectionForDay) : false;
                            $scope.WorklistPageHeaderParameter.TotalCollectionForDay = result.userPaymentHeaders.TotalCollectionForDay;
                            $scope.WorklistPageHeaderParameter.TotalRemainingBalance = result.userPaymentHeaders.TotalRemainingBalance;
                            $scope.WorklistPageHeaderParameter.TotalEarnings = result.userPaymentHeaders.TotalEarnings;
                            if (NewEarnings && $sessionStorage.PaymentIncomingAudio != '' && ($scope.DataObject.PaymentAddedSound != null && $scope.DataObject.PaymentAddedSound == "1")) {
                                PlayPaymentIncomingAudio();
                            }
                        }
                        if (result.bonusDetails) {
                            var startDate = moment(result.bonusDetails.StartDate, "YYYY-MM-DD HH:mm");
                            var endDate = moment(result.bonusDetails.EndDate, "YYYY-MM-DD HH:mm");
                            var now = moment();
                            $scope.WorklistPageHeaderParameter.BonusDetails = (now.isBetween(startDate, endDate, undefined, '[]')) ? result.bonusDetails : null;
                        }
                    }
                });
            }
        }

        function PlayPaymentIncomingAudio() {
            var audioUrl = __env._environment.config.apiResourceServiceBaseUri.replace('/api/', '/') + $sessionStorage.PaymentIncomingAudio;
            // An <audio> request cannot send headers, so behind APIM (PROD) the key goes in the query string
            if (__env.OcpApimSubscriptionKey) {
                audioUrl += (audioUrl.indexOf('?') === -1 ? '?' : '&') + 'subscription-key=' + encodeURIComponent(__env.OcpApimSubscriptionKey);
            }
            var audio = new Audio(audioUrl);
            audio.play();
        }

        function GetTenantsByUserID() {
            var d = $q.defer();
            ManageLocationService.GetTenantsByUserID({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.DataObject.MasterData.UserTenants = result;
                d.resolve();
            });
            return d.promise;
        }

        function GetXRayCountByUser() {
            var startDate = moment(moment().format("YYYY-MM-DD") + ' ' + "00:00");
            var endDate = moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59");
            var data = {
                UserID: $sessionStorage.currentUserData.userId,
                StartDate: $filter('CSTDateTime')(startDate),
                EndDate: $filter('CSTDateTime')(endDate),
            };
            return WorklistService.GetXRayCountByUser(data).then(function (response) {
                if (response && response.length > 0) {
                    $scope.WorklistPageHeaderParameter.XRayDetails = response[0];
                }
            });
        }
    }
})();
angular.module('radico.pages.worklistLite')
    .service('WorklistService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', '$sessionStorage', function (Restangular, $http, APP_CONSTANTS, __env, $sessionStorage) {
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }
        this.GetAllSites = function () {
            return Restangular.one('psorders').one("GetAllSites").get();
        };
        this.GetOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetOrdersList").customPOST(orderListFilter);
        };
        this.GetOrdersComparisonList = function (orderComparisonListFilter) {
            return Restangular.one('psorders').one("GetOrdersComparisonList").customPOST(orderComparisonListFilter);
        };
        //this.GetSitesAndLocations = function () {
        //    return Restangular.one('psorders').one("GetSitesAndLocations").get();
        //};
        this.GetAllSitesAndLocations = function () {
            return Restangular.one('psorders').one("GetAllSitesAndLocations").get();
        };
        this.GetLocationsAndWorkList = function (userID) {
            return Restangular.one('psorders').one("GetLocationsAndWorkList", userID).get();
        };
        this.GetSitesAndLocationsForWorkList = function (userid) {
            return Restangular.one('psorders').one("GetSitesAndLocationsForWorkList", userid).get();
        };
        this.GetPatientClass = function () {
            return Restangular.one('psorders').one("GetPatientClass").get();
        };
        this.CheckPSUserBySite = function (psuser) {
            return Restangular.one('psorders').one("CheckPSUserBySite").customPOST(psuser);
        };
        this.InsertPSUsersBySIte = function (psuser) {
            return Restangular.one('psorders').one("InsertPSUsersBySIte").customPOST(psuser);
        };
        this.SaveReport = function (reportView) {
            return Restangular.one('psorders').one("SaveReport").customPOST(reportView);
        };
        this.InsertOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("InsertOpenOrder").customPOST(openOrders);
        };
        this.DeleteOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("DeleteOpenOrder").customPOST(openOrders);
        };
        this.DeleteOpenOrderByUserID = function (userid) {
            return Restangular.one('psorders').one("DeleteOpenOrderByUserID", userid).get();
        };
        this.GetDeficientErrorByOrderID = function (orderid) {
            return Restangular.one('psorders').one("GetDeficientErrorByOrderID", orderid).get();
        };
        this.GetOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("GetOpenOrder").customPOST(openOrders);
        };
        this.RemoveFromComparison = function (comparisonOrder) {
            return Restangular.one('psorders').one("RemoveFromComparison").customPOST(comparisonOrder);
        };
        this.ShowHideOrder = function (orders) {
            return Restangular.one('psorders').one("ShowHideOrder").customPOST(orders);
        };
        this.sendTextNotification = function (orders) {
            return Restangular.one('psorders').one("sendTextNotification").customPOST(orders);
        };
        this.GetCurrentDateTime = function () {
            return Restangular.one('psorders').one("GetCurrentDateTime").get();
        };
        this.SaveGridSetting = function (param) {
            return Restangular.one('psorders').one("SaveGridSetting").customPOST(param);
        };
        this.GetGridSetting = function (param) {
            return Restangular.one('psorders').one("GetGridSetting").customPOST(param);
        };

        this.SaveFilterSetting = function (param) {
            return Restangular.one('psorders').one("SavePageSetting").customPOST(param);
        };
        this.SaveUserWorkList = function (param) {
            return Restangular.one('psorders').one("SaveUserWorkList").customPOST(param);
        };
        this.GetPageSetting = function (param) {
            return Restangular.one('psorders').one("GetPageSetting").customPOST(param);
        };

        this.GetRVU = function (data) {
            return Restangular.one('psorders').one("GetRVU").customPOST(data);
        };

        this.GetSignSummary = function (data) {
            return Restangular.one('psorders').one("GetSignSummary").customPOST(data);
        };

        this.GetComparisonOrderReportByOrderID = function (comparisionorderObj) {
            return Restangular.one('psorders').one("GetComparisonOrderReportByOrderID").customPOST(comparisionorderObj);
        };
        this.GetDictationReportPDF = function (orderID, TenantName) {
            return Restangular.one('psorders').one("GetDictationReportPDF", orderID)
                //.withHttpConfig({ responseType: 'arraybuffer' })
                .customGET(TenantName);
        };
        this.GetDictationValueReportPDF = function (orderID, TenantName) {
            return Restangular.one('psorders').one("GetDictationValueReportPDF", orderID)
                //.withHttpConfig({ responseType: 'arraybuffer' })
                .customGET(TenantName);
        };
        this.GetDictationReport = function (OrderId, UserId) {
            return Restangular.one('psorders').one("GetDictationReport").one(OrderId, UserId).get();
        };
        this.GetDictationValueReport = function (OrderId, UserId) {
            return Restangular.one('psorders').one("GetDictationValueReport").one(OrderId, UserId).get();
        };
        this.UpdateReviewOrder = function (data) {
            return Restangular.one('psorders').one("UpdateReviewOrder").customPOST(data);
        };
        this.GetOrderReportByOrderID = function (orderID) {
            return Restangular.one('psorders').one("GetOrderReportByOrderID", orderID).get();
        };
        this.SetDiscussion = function (data) {
            return Restangular.one('psorders').one("SetDiscussion").customPOST(data);
        }
        this.UnassignStudy = function (data) {
            return Restangular.one('psorders').one("UnassignStudy").customPOST(data);
        }
        this.GetDiscussions = function (data) {
            return Restangular.one('psorders').one("GetDiscussions").customPOST(data);
        };
        this.GetDiscussionsByIds = function (data) {
            return Restangular.one('psorders').one("GetDiscussionsByIds").customPOST(data);
        };
        this.SetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("SetOrderDiscussion").customPOST(data);
        };
        this.GetOrderDiscussion = function (data) {
            return Restangular.one('psorders').one("GetOrderDiscussion").customPOST(data);
        };
        this.NotifyToUser = function (data) {
            return Restangular.one('psorders').one("NotifyToUser").customPOST(data);
        };
        this.GetModality = function () {
            return Restangular.one('psorders').one("GetModality").customPOST();
        };
        this.getOnlineUsers = function () {
            return Restangular.one('User').one("GetOnlineUsers").get();
        };

        this.GetOrdersListPendingCount = function (userID) {
            return Restangular.one('psorders').one("GetOrdersListPendingCount", userID).get();
        };
        this.GetSTATPendingOrderCount = function (orderListFilter) {
            return Restangular.one('psorders').one("GetSTATPendingOrderCount").customPOST(orderListFilter);
        };
        this.GetAllStatusCount = function (orderListFilter) {
            return Restangular.one('psorders').one("getAllStatusCount").customPOST(orderListFilter);
        };

        this.GetDicomViewerCredentials = function (obj) {
            return Restangular.one('psorders').one("GetDicomViewerCredentials").customPOST(obj);
        };
        this.InsertDicomViewerCredentials = function (obj) {
            return Restangular.one('psorders').one("InsertDicomViewerCredentials").customPOST(obj);
        };


        this.OpenGECentricity = function (params) {
            var data = $.param(params);
            return $http({
                method: 'POST',
                url: __env._environment.config.GECentricityURL,
                data: data
            });
        };

        this.GetAllUsers = function () {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/RadFlowGetUsers ',
                headers: { 'content-type': 'application/json' }
            });
        };
        this.GetUserBySite = function (data) {
            return Restangular.one('user').one("GetUserBySite").customPOST(data);
        };
        this.GetUserRuleText = function (data) {
            return Restangular.one('psorders').one("GetUserRuleText").customPOST(data);
        };
        this.getContact = function (OrderingPhysicianName) {
            return Restangular.one('psorders').one("getContact", OrderingPhysicianName)
                .get();
        };
        this.saveContact = function (addrbook) {
            return Restangular.one('psorders').one("saveContact").customPOST(addrbook);
        };
        this.DeleteWorkList = function (workListId, type, userId) {
            var param = { Id: workListId, Type: type, UserId: userId };
            return Restangular.one('psorders').one("DeleteWorkList").customPOST(param);
        };
        this.getWorkList = function (workListId) {
            return Restangular.one('psorders').one("getWorkList", workListId)
                .get();
        };
        this.SetOrderDiscussionAssignment = function (data) {
            return Restangular.one('psorders').one("SetOrderDiscussionAssignment").customPOST(data);
        };
        this.GetOrderDiscussionAssignment = function (data) {
            return Restangular.one('psorders').one("GetOrderDiscussionAssignment").customPOST(data);
        };
        this.GetRadiologistsBySite = function (data) {
            return Restangular.one('user').one("GetRadiologistsBySite").customPOST(data);
        };
        this.GetDicomImageByAccessionNumber = function (accessionNumber) {
            return $http({
                method: 'get',
                url: __env._environment.config.ciDICOMViewerAPI + '/api/ohifdicomviewer/GetaccessionNumber/' + accessionNumber,
                headers: { 'content-type': 'application/json' }
            });
            //`${APP_CONSTANTS.ciDICOMViewerAPI}/api/ohifdicomviewer/GetAccessionJsonFileByPath/${accessionfileName}`
        };
        this.GetWorklistPrefrences = function (data) {
            return Restangular.one('psorders').one("GetWorklistPrefrences").customPOST(data);
        };
        this.GetWorklistData = function (data) {
            return Restangular.one('psorders').one("GetWorklistData").customPOST(data);
        };
        this.VerfiyReadStudy = function (openOrders) {
            return Restangular.one('psorders').one("VerifyReadStudy").customPOST(openOrders);
        };
        this.EnforceReadsEvaluate = function (request) {
            return Restangular.one('psorders').one("EnforceReadsEvaluate").customPOST(request);
        };
        this.GetReportsOrdersEventDatat = function (data) {
            return Restangular.one('psorders').one("GetReportsOrdersEventData").customPOST(data);
        };
        this.RemoveComparedStudy = function (comparisonOrder) {
            return Restangular.one('psorders').one("RemoveComparedStudy").customPOST(comparisonOrder);
        };
        this.ValidateOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("ValidateOrdersList").customPOST(orderListFilter);
        };
        this.ProcessedOrdersUpdate = function (ProcessedOrders) {
            return Restangular.one('psorders').one("ProcessedOrdersUpdate").customPOST(ProcessedOrders);
        };
        this.GetMultipleWorklistDetails = function (MultipleWorklistFilter) {
            return Restangular.one('psorders').one("GetMultipleWorklistDetails").customPOST(MultipleWorklistFilter);
        };
        this.GetStatusCount = function (data) {
            return Restangular.one('psorders').one("GetStatusCount").customPOST(data);
        };
        this.GetOrderDetails = function (orderListFilter) {
            return Restangular.one('psorders').one("GetOrderDetails").customPOST(orderListFilter);
        };
        this.GetOrderDetailsReadOnly = function (orderListFilter) {
            return Restangular.one('psorders').one("GetOrderDetailsReadOnly").customPOST(orderListFilter);
        };

        this.GetOrderStatus = function () {
            var OrderStatus = [
                {
                    value: "All",
                    key: "AL",
                    bgcolor: "{'background-color':'black'}",
                },
                {
                    value: "Cancelled",
                    key: "X",
                    bgcolor: "{'background-color':'#BFDED6'}",
                },
                {
                    value: "Comparison",
                    key: "CO",
                    bgcolor: "{'background-color':'#B9ADCF'}",
                },
                {
                    value: "Complete",
                    key: "C",
                    bgcolor: "{'background-color':'#75E284'}",
                },
                {
                    value: "Deficient",
                    key: "DE",
                    bgcolor: "{'background-color':'#a0c1c5'}",
                },
                {
                    value: "Draft",
                    key: "D",
                    bgcolor: "{'background-color':'#a0c1c5'}",
                },
                {
                    value: "Hidden",
                    key: "H",
                    bgcolor: "{'background-color':'#FFC99A'}",
                },
                {
                    value: "Image Pending",
                    key: "IP",
                    bgcolor: "{'background-color':'#f4ba4b'}",
                },
                {
                    value: "Pending Order",
                    key: "OP",
                    bgcolor: "{'background-color':'#b2b266'}",
                },
                {
                    value: "Pending Correction",
                    key: "PC",
                    bgcolor: "{'background-color':'#FBA46E'}",
                },
                {
                    value: "RadFlow Complete",
                    key: "RC",
                    bgcolor: "{'background-color':'#79b384'}",
                },
                {
                    value: "Result Pending",
                    key: "RP",
                    bgcolor: "{'background-color':'#FFE69A'}",
                },
                {
                    value: "Signed Today",
                    key: "ST",
                    bgcolor: "{'background-color':'#75E284'}",
                }
            ];
            if ($sessionStorage.IsAddendumRequestVisible) {
                OrderStatus.push({
                    value: "Pending Addendum",
                    key: "PA",
                    bgcolor: "{'background-color':'#ffe6ee'}",
                });
            }
            return _.sortBy(OrderStatus, ['value']);
        }

        this.GetPriorReportsByPatientMRN = function (jObject) {
            return Restangular.one('psorders').one("GetPriorReportsByPatientMRN").customPOST(jObject);
        };
        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };
        this.GetUserPayments = function (UserID) {
            return Restangular.one('psorders').one("GetUserPayments", UserID).get();
        };
        this.GetOrdersListQuickFilter = function (orderListFilter) {
            return Restangular.one('psorders').one("GetOrdersListQuickFilter").customPOST(orderListFilter);
        };
        this.GetMedDreamViewerToken = function (data) {
            return Restangular.one('psorders').one("GetMedDreamViewerToken").customPOST(data);
        };
        this.GetMedDreamCommunicationPayload = function (data) {
            return Restangular.one('psorders').one("GetMedDreamCommunicationPayload").customPOST(data);
        };
        this.GetClipboardDetailByOrderID = function (orderID) {
            return Restangular.one('psorders').one("GetClipboardDetailByOrderID", orderID).get();
        }

        this.NotifyRemoveOrderIDFromClipboard = function (data) {
            return Restangular.one('psorders').one("NotifyRemoveOrderIDFromClipboard").customPOST(data);
        }
        this.VerifyOrderProviderRuleTextByUserID = function (data) {
            return Restangular.one('psorders').one("VerifyOrderProviderRuleTextByUserID").customPOST(data);
        }
        this.UpdateOrderDetail = function (data) {
            return Restangular.one('psorders').one("UpdateOrderDetail").customPOST(data);
        }
        this.GetOrderByAccession = function (data) {
            return Restangular.one('psorders').one("GetOrderByAccession").customPOST(data);
        }
        this.GetReportListModalityNDateRange = function () {
            return { Modalities: ['All'], DateRange: ['Any', '6m', '1y', '2y', '5y'] };
        }
        this.GetWorklistStatusCount = function (params) {
            return Restangular.one('psorders').one("GetWorklistStatusCount").customPOST(params);
        }
        this.UpdateAddendumRequestReportStatus = function (params) {
            return Restangular.one('psorders').one("UpdateAddendumRequestReportStatus").customPOST(params);
        };
        this.GetPeerReviewerListByUserID = function (params) {
            return Restangular.one('user').one("GetPeerReviewerListByUserID").customPOST(params);
        };
        //#region QueryRetrive
        this.DCMQRDoFind = function (params) {
            return Restangular.one('DCMQR').one("DoFind").customPOST(params);
        };
        this.DCMQRDoMove = function (params) {
            return Restangular.one('DCMQR').one("DoMove").customPOST(params);
        };
        this.QueryRetrieveVisible = function () {
            return Restangular.one('DCMQR').one("QueryRetrieveVisible").customPOST();
        };
        //#endregion QueryRetrive
        this.GetOrdersListExport = function (params) {
            return Restangular.one('psorders').one("GetOrdersListExport").customPOST(params);
        };
        this.GetColumnFilterData = function (params) {
            return Restangular.one('psorders').one("GetColumnFilterData").customPOST(params);
        };
        this.InsertUserComments = function (params) {
            return Restangular.one('psorders').one("InsertUserComments").customPOST(params);
        };
        this.UpdateOrderReportStatus = function (params) {
            return Restangular.one('psorders').one("UpdateOrderReportStatus").customPOST(params);
        };
        this.SendFax = function (params) {
            return Restangular.one('psorders').one('WestFax').one("SendFAX").customPOST(params);
        };
        this.SetOrderPeerReview = function (params) {
            return Restangular.one('psorders').one('SetOrderPeerReview').customPOST(params);
        };
        this.SendSOSMessage = function (params) {
            return Restangular.one('psorders').one('SendSOSMessage').customPOST(params);
        };
        this.SetSOSHistory = function (params) {
            return Restangular.one('psorders').one('SetSOSHistory').customPOST(params);
        };
        this.GetXRayCountByUser = function (data) {
            return Restangular.one('psorders').one("GetXRayCountByUser").customPOST(data);
        };
        this.GetMedDreamViewerOverrideByStudy = function (model) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri + 'Settings/GetMedDreamViewerOverrideByStudy', model);
        };
    }]);
(function (angular) {
    'use strict';

    /**
	 * AppHub - SignalR connection. Uses API-first negotiate flow:
	 * 1. Negotiate with RadFlow API (signalrURL from env.js)
	 * 2. API redirects to Azure SignalR Service (always, in all environments where ConnectionString is set)
	 * 3. After connect, client calls RegisterConnectionForMessages(userId) to join the user's group
	 * @param {HubProxy}
	 * @return {HubProxy}
	 */
    AppHubService.$inject = ['HubProxy', '$sessionStorage','APP_CONSTANTS', '__env'];
    function AppHubService(Hub, $sessionStorage, APP_CONSTANTS, __env) {

        var dataFactory = {};
        var appHub;
        var APP_loggingEnabled = true;
        var APP_jsonpEnabled = false;
        dataFactory.Initialize = function () {
            var APP_signalrURL = (__env._environment && __env._environment.config) ? __env._environment.config.signalrURL : null;
            if (!APP_signalrURL) {
                console.error('SignalR: signalrURL is missing. Check env.js - host', window.location.origin, 'may not match any environment. Connection will NOT be established.');
                return;
            }
            var token = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.accessToken) ? $sessionStorage.currentUserData.accessToken : null;
            var tokenLen = token ? token.length : 0;
            var userId = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) ? $sessionStorage.currentUserData.userId : '';
            console.log('SignalR: Initialize - signalrURL=' + APP_signalrURL + ', tokenLength=' + tokenLen + ', userId=' + (userId || '(EMPTY)') + ', hasToken=' + !!token);
            if (!userId) {
                console.error('SignalR: userId is empty - RegisterConnectionForMessages will be SKIPPED and this client will NOT receive any group-targeted messages (chat, notifications). Ensure $sessionStorage.currentUserData.userId is set before calling Initialize().');
            } else {
                console.log('SignalR: userId="' + userId + '", will register for group="' + userId.toLowerCase() + '". Server must send Clients.Group("' + userId.toLowerCase() + '") for this client to receive targeted messages.');
            }
            // Create hub but do NOT start yet - caller must register handlers then call startConnection()
            appHub = new Hub('appHub', token, { connectionPath: APP_signalrURL, loggingEnabled: APP_loggingEnabled, HostName: $sessionStorage.hostName, userId: userId });
            console.log('SignalR: Hub instance created (not started). Call startConnection() after registering event handlers.');
        };

        /** Call after registering event handlers so the first server event (e.g. userstatushandler) is not missed. */
        dataFactory.startConnection = function () {
            if (appHub) {
                console.log('SignalR: startConnection() called - starting connection now.');
                appHub.start(APP_jsonpEnabled);
            } else {
                console.warn('SignalR: startConnection() called but appHub is null. Did Initialize() run and succeed?');
            }
        }

        //dataFactory.setAppHub = function (xiObjAppHub) {
        //    appHub = xiObjAppHub;
        //};
        dataFactory.getAppHub = function () {
            if (APP_loggingEnabled && !appHub) {
                console.warn('SignalR: getAppHub() returned null - hub not created. Call Initialize() first.');
            }
            return appHub;
        };

        dataFactory.stop = function () {
            //alert("stop 1");
            //$sessionStorage.IsSignalrConnectionDisconnectedManually = true;
            if (appHub) {
                appHub.stop();
                appHub = null;
            }
        };

        return dataFactory;
    }

    // Register the 'AppHub' to the 'app' module
    angular.module('BlurAdmin').factory('AppHubService', AppHubService);

})(window.angular);
(function ($, angular, document) {
    'use strict';

    HubFactory.$inject = ['$rootScope', '$q', 'HubConnectionEvents', '$sessionStorage', '$interval', 'APP_CONSTANTS', '__env'];
    function HubFactory($rootScope, $q, HubConnectionEvents, $sessionStorage, $interval, APP_CONSTANTS, __env) {

        var signalR = window.signalR;
        if (!signalR || !signalR.HubConnectionBuilder) {
            console.error('SignalR: @microsoft/signalr not loaded. index.html must include the self-hosted cdn/js/signalr.min.js (CSP script-src is self-only; third-party CDNs are blocked).');
        }

        /**
         * HttpClient that transforms Azure negotiate response (RedirectUrl/AccessToken/ProtocolVersion)
         * to client-expected format (url/accessToken). Ensures redirect URL is found for Azure flow.
         */
        function createAzureRedirectHttpClient(signalR, loggingEnabled) {
            function transformNegotiateResponse(content, requestUrl, loggingEnabled) {
                if (typeof content !== 'string') return content;
                try {
                    var obj = JSON.parse(content);
                    var redirectUrl = obj.RedirectUrl || obj.redirectUrl;
                    var accessTokenVal = obj.AccessToken || obj.accessToken;
                    var isFirstNegotiate = requestUrl && requestUrl.indexOf('negotiate') !== -1 && requestUrl.indexOf('signalr.net') === -1;
                    var isAzureSecondNegotiate = requestUrl && requestUrl.indexOf('signalr.net') !== -1 && (obj.ProtocolVersion || obj.ConnectionToken);

                    if (redirectUrl && accessTokenVal) {
                        if (loggingEnabled && isFirstNegotiate) {
                            console.log('SignalR: First negotiate REDIRECT - RedirectUrl: ' + redirectUrl + ' (will transform to url)');
                        }
                        obj.url = redirectUrl;
                        obj.accessToken = accessTokenVal;
                        delete obj.RedirectUrl;
                        delete obj.redirectUrl;
                        delete obj.AccessToken;
                        delete obj.ProtocolVersion;
                        return JSON.stringify(obj);
                    }

                    if (isAzureSecondNegotiate) {
                        var connToken = obj.ConnectionToken || obj.connectionToken;
                        var connId = obj.ConnectionId || obj.connectionId;
                        if (connToken && connId) {
                            if (loggingEnabled) {
                                console.log('SignalR: Second negotiate (Azure) - transforming to ASP.NET Core format. Next: WebSocket (WS) or LongPolling GET - no separate HTTP /start.');
                            }
                            var tryWs = (obj.TryWebSockets || '').toString().toLowerCase() === 'true';
                            var transports = [
                                { transport: 'WebSockets', transferFormats: ['Text', 'Binary'] },
                                { transport: 'ServerSentEvents', transferFormats: ['Text'] },
                                { transport: 'LongPolling', transferFormats: ['Text', 'Binary'] }
                            ];
                            var out = {
                                negotiateVersion: 1,
                                connectionId: connId,
                                connectionToken: connToken,
                                availableTransports: tryWs ? transports : transports.slice(1)
                            };
                            if (accessTokenVal) out.accessToken = accessTokenVal;
                            return JSON.stringify(out);
                        }
                    }

                    if (loggingEnabled && isFirstNegotiate && obj.connectionId && !redirectUrl) {
                        console.log('SignalR: First negotiate NO REDIRECT - API returned connectionId directly (local SignalR, not Azure).');
                    }
                } catch (e) { /* ignore */ }
                return content;
            }

            function doSend(request) {
                var init = {
                    method: request.method || 'GET',
                    headers: request.headers || {},
                    credentials: request.withCredentials ? 'include' : 'omit'
                };
                if (request.content) init.body = typeof request.content === 'string' ? request.content : request.content;
                if (request.abortSignal) init.signal = request.abortSignal;
                var timeout = request.timeout || 60000;
                var ctrl = new AbortController();
                init.signal = ctrl.signal;
                var t = setTimeout(function () { ctrl.abort(); }, timeout);
                return fetch(request.url, init).then(function (r) {
                    clearTimeout(t);
                    return r.text().then(function (text) {
                        var response = { statusCode: r.status, statusText: r.statusText, content: text };
                        var url = (request && request.url) || '';
                        if (url.indexOf('negotiate') !== -1 && loggingEnabled) {
                            var safeUrl = url.replace(/Bearer=[^&]+/, 'Bearer=***');
                            console.log('SignalR: negotiate request -> ' + safeUrl + ' -> status=' + r.status);
                            if (response.content && response.content.length < 500) {
                                console.log('SignalR: negotiate response (raw length ' + response.content.length + '):', response.content);
                            } else if (response.content) {
                                try {
                                    var o = JSON.parse(response.content);
                                    console.log('SignalR: negotiate response keys:', Object.keys(o).join(', '), '(length=' + response.content.length + ')');
                                } catch (e) {
                                    console.log('SignalR: negotiate response length:', response.content.length);
                                }
                            }
                        }
                        if (url.indexOf('negotiate') !== -1 && response.statusCode === 200 && response.content) {
                            var transformed = transformNegotiateResponse(response.content, request.url, loggingEnabled);
                            if (transformed !== response.content) {
                                response.content = transformed;
                            }
                        }
                        return response;
                    });
                });
            }

            var DefaultHttpClient = signalR.DefaultHttpClient;
            var inner = DefaultHttpClient ? new DefaultHttpClient({ log: function () {} }) : null;

            return {
                send: function (request) {
                    var p = inner ? inner.send(request) : doSend(request);
                    if (inner) {
                        return p.then(function (response) {
                            var url = (request && request.url) || '';
                            if (url.indexOf('negotiate') !== -1 && loggingEnabled) {
                                console.log('SignalR: negotiate (default client) -> status=' + response.statusCode + ', contentLength=' + (response.content ? response.content.length : 0));
                            }
                            if (url.indexOf('negotiate') !== -1 && response.statusCode === 200 && response.content) {
                                var transformed = transformNegotiateResponse(response.content, request.url, loggingEnabled);
                                if (transformed !== response.content) {
                                    return { statusCode: response.statusCode, statusText: response.statusText, content: transformed };
                                }
                            }
                            return response;
                        });
                    }
                    return p;
                },
                getCookieString: function (url) { return inner && inner.getCookieString ? inner.getCookieString(url) : ''; }
            };
        }

        /**
         * Hub class using ASP.NET Core SignalR client (@microsoft/signalr).
         * Replaces old jQuery SignalR 2.x for compatibility with RadFlow.Core.API.
         *
         * Negotiate flow (API-first, then Azure):
         * 1. Client sends negotiate to API (connectionPath = RadFlow API URL, e.g. radflow-core-api-dev)
         * 2. API negotiates with Azure SignalR server-side, returns { url, accessToken }
         * 3. Client automatically negotiates with Azure endpoint from step 2
         * connectionPath MUST be the API URL, never the Azure SignalR endpoint directly.
         *
         * @param {String} hubName - e.g. 'appHub'
         * @param {String} accessToken - JWT Bearer token (sent as Bearer in query for API negotiate)
         * @param {Object} options - connectionPath (API URL), loggingEnabled, HostName
         */
        function Hub(hubName, accessToken, options) {
            if (!hubName) {
                throw new Error('Hub name was not specified, be sure to pass it in when invoking the Hub class');
            }
            if (!signalR || !signalR.HubConnectionBuilder) {
                throw new Error('SignalR: @microsoft/signalr not loaded. index.html must include the self-hosted cdn/js/signalr.min.js (CSP script-src is self-only; third-party CDNs are blocked).');
            }

            var settings = angular.extend({
                loggingEnabled: false,
                connectionPath: '.',
                HostName: '',
                userId: ''
            }, options);

            var baseUrl = (settings.connectionPath || '.').replace(/\/$/, '');
            var hubUrl = baseUrl + (baseUrl.indexOf('/signalr') !== -1 ? '' : '/signalr');
            var tenantName = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.tenantName) ? $sessionStorage.currentUserData.tenantName : '';
            var qs = 'BrowserType=Web&TenantName=' + encodeURIComponent(tenantName) + '&HostName=' + encodeURIComponent(settings.HostName || '') + '&RadFlowUIVersion=' + encodeURIComponent(APP_CONSTANTS.radflowUIVersion || '');
            var urlWithQs = hubUrl + (hubUrl.indexOf('?') !== -1 ? '&' : '?') + qs;
            // RadFlow API expects token as Bearer in query (not access_token). Add it so negotiate matches expected curl format.
            if (accessToken) {
                urlWithQs += '&Bearer=' + encodeURIComponent(accessToken);
            }
            var safeUrlLog = (hubUrl || '(empty)') + (accessToken ? '?..Bearer=***' : '');
            if (settings.loggingEnabled) {
                var negotiateEndpoint = (hubUrl || '(empty)') + '/negotiate';
                console.log('SignalR: Hub constructor - baseUrl=' + safeUrlLog + ', loggingEnabled=true');
                console.log('SignalR: Step 1 - negotiate with API first: ' + negotiateEndpoint);
                // Step 2 (Azure) happens automatically when API returns redirect; only when API uses Azure (deployed, not Development)
                var isLocalApi = !hubUrl || hubUrl.indexOf('localhost') !== -1;
                if (isLocalApi) {
                    console.log('SignalR: Local API - no Step 2 Azure negotiate. Use deployed API (ASPNETCORE_ENVIRONMENT=QA) for API -> Azure flow.');
                } else {
                    console.log('SignalR: API will redirect to Azure SignalR after successful negotiate (Step 2).');
                }
            }

            this._handlers = {};
            this._loggingEnabled = !!settings.loggingEnabled;
            this._accessToken = accessToken || '';
            this._userId = settings.userId || '';
            this.reconnectedAttempt = 1;
            console.log('SignalR Hub: created. hubUrl=' + safeUrlLog + ', userId=' + (this._userId || '(EMPTY - RegisterConnectionForMessages will be skipped, group messages will not be received)') + ', hasToken=' + !!accessToken);
            this.connectionStatus = {
                disconnected: false,
                reconnecting: false,
                isConnected: function () { return !this.disconnected && !this.reconnecting; },
                isDisconnected: function () { return this.disconnected; },
                isReconnecting: function () { return this.reconnecting; },
                isDown: function () { return this.disconnected || this.reconnecting; },
                setConnection: function (reconnectVal, disconnectVal) {
                    var self = this;
                    $rootScope.$evalAsync(function () {
                        self.reconnecting = reconnectVal;
                        self.disconnected = disconnectVal;
                    });
                }
            };

            var self = this;
            var httpClientOptions = { accessTokenFactory: function () { return accessToken || ''; } };
            // The first negotiate goes to the RadFlow API, which in CI PROD sits behind APIM and needs the
            // subscription key. Headers apply to negotiate and to any non-WebSocket transport; the WebSocket
            // itself connects to the Azure SignalR endpoint returned by that negotiate, not through APIM.
            if (__env.OcpApimSubscriptionKey) {
                httpClientOptions.headers = { 'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey };
            }
            try {
                var customHttpClient = createAzureRedirectHttpClient(signalR, settings.loggingEnabled);
                if (customHttpClient) httpClientOptions.httpClient = customHttpClient;
            } catch (e) { /* use default */ }
            var builder = new signalR.HubConnectionBuilder()
                .withUrl(urlWithQs, httpClientOptions)
                .withAutomaticReconnect()
                .configureLogging(settings.loggingEnabled ? signalR.LogLevel.Debug : signalR.LogLevel.Warning);

            this.connection = builder.build();
            this.connection.serverTimeoutInMilliseconds = 60000;       // 60s - must be > 2x server KeepAliveInterval
            this.connection.keepAliveIntervalInMilliseconds = 10000;   // 10s - client pings server for health

            this.connection.on('subscribe_ClientFrom', function () {
                var xiConnid = (arguments.length > 0) ? arguments[0] : undefined;
                if (xiConnid == null || xiConnid === '') {
                    xiConnid = self.connection.connectionId || xiConnid;
                }
                var connIdStr = (xiConnid != null && xiConnid !== '') ? String(xiConnid) : '(empty - check server logs)';
                $rootScope.$emit('SignalrConnectionSetStartedMethod', true, xiConnid);
                console.log('SignalR: subscribe_ClientFrom received. connectionId=' + connIdStr + ', userId=' + (self._userId || '(none)') + ', state=' + (self.connection.state != null ? self.connection.state : '') + '. Next: RegisterConnectionForMessages will be called with this userId to join the group for targeted messages.');
            });

            bindConnectionEvents(this);
        }

        Hub.prototype = {
            start: function start(xiJsonpEnabled) {
                var self = this;
                var deferred = $.Deferred();
                console.log('SignalR: start() called, connection state=' + (self.connection.state != null ? self.connection.state : 'undefined'));
                this.connection.start()
                    .then(function () {
                        console.log('SignalR: connection.start() resolved, state=' + (self.connection.state != null ? self.connection.state : '') + ', invoking Subscribe_Hub');
                        return self.connection.invoke('Subscribe_Hub');
                    })
                    .then(function () {
                        console.log('SignalR: Subscribe_Hub completed. Connection ready. connectionId=' + (self.connection.connectionId != null ? self.connection.connectionId : 'undefined'));
                        var registerPromise = self._userId
                            ? (function () {
                                console.log('SignalR: invoking RegisterConnectionForMessages. userId="' + self._userId + '", group="' + self._userId.toLowerCase() + '". Server must show "added to group" in logs. Server will then route Clients.Group("' + self._userId.toLowerCase() + '") messages to this connection.');
                                return self.connection.invoke('RegisterConnectionForMessages', self._userId).then(function () {
                                    console.log('SignalR: RegisterConnectionForMessages SUCCESS. userId="' + self._userId + '", group="' + self._userId.toLowerCase() + '".');
                                }).catch(function (e) {
                                    console.error('SignalR: RegisterConnectionForMessages FAILED. Group NOT registered. Targeted messages (bindmessage, notificationhandler) will NOT be received by this user. Error:', (e && e.message) || e);
                                });
                            })()
                            : (function () { console.warn('SignalR: userId is empty - RegisterConnectionForMessages NOT called. $sessionStorage.currentUserData.userId must be set before hub Initialize() is called.'); return Promise.resolve(); })();
                        return registerPromise;
                    })
                    .then(function () {
                        deferred.resolve();
                    })
                    .catch(function (err) {
                        console.error('SignalR: Connection failed -', (err && err.message) || err);
                        if (err && err.message) console.error('SignalR: Full error:', err);
                        $rootScope.$emit('SignalrConnectionSetStartedMethod', false, '');
                        deferred.reject(err);
                    });
                return deferred.promise();
            },

            stop: function stop() {
                var deferred = $.Deferred();
                this.connection.stop().then(function () { deferred.resolve(); }).catch(function () { deferred.resolve(); });
                return deferred.promise();
            },

            on: function on(evt, fn) {
                var hub = this;
                var evtStr = (evt != null ? String(evt) : '');
                if (!evtStr) {
                    console.warn('SignalR: on() called with empty/undefined event name - ignoring. Handlers must use exact event names e.g. RadFlowAppHubEvent');
                    return this;
                }
                if (!this._handlers[evt]) {
                    this._handlers[evt] = [];
                    if (hub._loggingEnabled) {
                        console.log('SignalR: registering connection handler for event: [' + evtStr + ']');
                    }
                    this.connection.on(evt, function () {
                        var args = arguments;
                        var payload = args.length > 0 ? args[0] : null;
                        if (payload && typeof payload === 'object') {
                            if (payload.EventType === undefined && payload.eventType !== undefined) payload.EventType = payload.eventType;
                            if (payload.EventArgs === undefined && payload.eventArgs !== undefined) payload.EventArgs = payload.eventArgs;
                        }
                        var eventType = (payload && (payload.EventType || payload.eventType)) ? (payload.EventType || payload.eventType) : '(no EventType)';
                        if (hub._loggingEnabled) {
                            console.log('SignalR: raw callback invoked for [' + evtStr + '] args.length=' + args.length, args.length > 0 ? 'arg0 keys: ' + (typeof args[0] === 'object' && args[0] !== null ? Object.keys(args[0]).join(',') : typeof args[0]) : '');
                        }
                        if (evt === 'RadFlowChatAppHubEvent' && (eventType === 'bindmessage' || eventType === 'BindMessage')) {
                            var eventArgs = (payload && (payload.EventArgs || payload.eventArgs)) || {};
                            // If EventArgs is empty but payload has message fields at root (e.g. serialization shape), copy from root into eventArgs
                            var fromRoot = (payload && (payload.FromUserId || payload.fromUserId || payload.ToUserId || payload.toUserId));
                            if (fromRoot && (!eventArgs || typeof eventArgs !== 'object')) eventArgs = {};
                            if (eventArgs && typeof eventArgs === 'object' && payload) {
                                if ((eventArgs.ToUserId === undefined && eventArgs.toUserId === undefined) && (payload.ToUserId !== undefined || payload.toUserId !== undefined)) { eventArgs.ToUserId = payload.ToUserId || payload.toUserId; eventArgs.toUserId = eventArgs.toUserId || eventArgs.ToUserId; }
                                if ((eventArgs.FromUserId === undefined && eventArgs.fromUserId === undefined) && (payload.FromUserId !== undefined || payload.fromUserId !== undefined)) { eventArgs.FromUserId = payload.FromUserId || payload.fromUserId; eventArgs.fromUserId = eventArgs.fromUserId || eventArgs.FromUserId; }
                                if ((eventArgs.Message === undefined && eventArgs.message === undefined) && (payload.Message !== undefined || payload.message !== undefined)) { eventArgs.Message = payload.Message || payload.message; eventArgs.message = eventArgs.message || eventArgs.Message; }
                                if ((eventArgs.MessageTime === undefined && eventArgs.messageTime === undefined) && (payload.MessageTime !== undefined || payload.messageTime !== undefined)) { eventArgs.MessageTime = payload.MessageTime || payload.messageTime; eventArgs.messageTime = eventArgs.messageTime || eventArgs.MessageTime; }
                                // So handlers see EventArgs: ensure payload points to the same object
                                if (payload.EventArgs !== eventArgs) { payload.EventArgs = eventArgs; payload.eventArgs = eventArgs; }
                            }
                            var toId = (eventArgs && (eventArgs.ToUserId || eventArgs.toUserId || '')).toString().toLowerCase();
                            var fromId = (eventArgs && (eventArgs.FromUserId || eventArgs.fromUserId || '')).toString().toLowerCase();
                            var payloadKeys = (payload && typeof payload === 'object') ? Object.keys(payload).join(',') : '';
                            var eventArgsKeys = (eventArgs && typeof eventArgs === 'object') ? Object.keys(eventArgs).join(',') : '';
                            console.log('SignalR [bindmessage]: RECEIVED. EventType=' + eventType + ', ToUserId=' + (toId || '(none)') + ', FromUserId=' + (fromId || '(none)') + ', payloadKeys=[' + payloadKeys + '], eventArgsKeys=[' + eventArgsKeys + '], handlerCount=' + (hub._handlers[evt] || []).length);
                        }
                        if (hub._loggingEnabled && (evt === 'RadFlowAppHubEvent' || evt === 'RadFlowChatAppHubEvent')) {
                            var handlerCount = (hub._handlers[evt] || []).length;
                            console.log('SignalR event received: [' + evtStr + '] EventType=' + eventType + ' handlerCount=' + handlerCount);
                        }
                        (hub._handlers[evt] || []).forEach(function (f) {
                            $rootScope.$evalAsync(function () { f.apply(null, args); });
                        });
                    });
                }
                this._handlers[evt].push(fn);
                if (hub._loggingEnabled) {
                    console.log('SignalR: handler added for event: [' + evtStr + '] total=' + this._handlers[evt].length);
                }
                return this;
            },

            off: function off(evt) {
                this._handlers[evt] = [];
                return this;
            },

            invoke: function invoke() {
                var args = Array.prototype.slice.call(arguments);
                var deferred = $q.defer();
                var self = this;
                var methodName = args[0];
                var methodArgs = args.slice(1);

                function doInvoke() {
                    self.connection.invoke.apply(self.connection, [methodName].concat(methodArgs)).then(deferred.resolve, deferred.reject);
                }

                if (this.connection.state === signalR.HubConnectionState.Connected) {
                    doInvoke();
                } else if (this.connection.state === signalR.HubConnectionState.Disconnected) {
                    this.start().done(doInvoke).fail(function (err) { deferred.reject(err); });
                } else {
                    deferred.reject(new Error('Connection not ready'));
                }
                return deferred.promise;
            },

            send: function send() {
                return this.invoke.apply(this, arguments);
            }
        };

        function bindConnectionEvents(hubInstance) {
            function broadcastConnectionEvent() {
                $rootScope.$broadcast.apply($rootScope, arguments);
            }

            function updateConnectionState(evt, state) {
                var reconnecting = state.newState === signalR.HubConnectionState.Reconnecting;
                var disconnected = state.newState === signalR.HubConnectionState.Disconnected;
                hubInstance.connectionStatus.setConnection(reconnecting, disconnected);
            }

            $rootScope.$on(HubConnectionEvents.change, updateConnectionState);

            hubInstance.connection.onreconnecting(function () {
                console.log('SignalR: reconnecting at ' + new Date() + ', state=', hubInstance.connection.state);
                broadcastConnectionEvent(HubConnectionEvents.reconnecting);
            });

            hubInstance.connection.onreconnected(function () {
                console.log('SignalR: reconnected. New connectionId=' + hubInstance.connection.connectionId + '. IMPORTANT: group membership is lost on reconnect - must re-register.');
                if (hubInstance._userId) {
                    console.log('SignalR: re-invoking RegisterConnectionForMessages after reconnect. userId="' + hubInstance._userId + '", group="' + hubInstance._userId.toLowerCase() + '"');
                    hubInstance.connection.invoke('RegisterConnectionForMessages', hubInstance._userId).then(function () {
                        console.log('SignalR: RegisterConnectionForMessages on reconnect SUCCESS. Group="' + hubInstance._userId.toLowerCase() + '" re-registered for new connectionId=' + hubInstance.connection.connectionId);
                    }).catch(function (e) {
                        console.error('SignalR: RegisterConnectionForMessages on reconnect FAILED. Group NOT re-registered. Targeted messages will NOT be received until next reconnect or page reload. Error:', (e && e.message) || e);
                    });
                } else {
                    console.warn('SignalR: on reconnect - userId is empty, RegisterConnectionForMessages not called. Group messages will not be received.');
                }
                broadcastConnectionEvent(HubConnectionEvents.reconnected);
            });

            hubInstance.connection.onclose(function (error) {
                console.log('SignalR: connection closed at ' + new Date());
                if (error) {
                    console.log('SignalR: onclose error:', error.message || error, 'code=', error.code, 'wasClean=', error.wasClean);
                }

                hubInstance.connectionStatus.setConnection(false, true);

                if ($sessionStorage.currentUserData && hubInstance.reconnectedAttempt <= __env._SignalRreconnectAttempts) {
                    setTimeout(function () {
                        if (hubInstance.connection.state === signalR.HubConnectionState.Connected) {
                            $rootScope.$emit('SignalrConnectionReconnected', '');
                            hubInstance.reconnectedAttempt = 1;
                            console.log('signalr - reconnected : ');
                        } else if (!$sessionStorage.IdleTimeout) {
                            console.log('signalr - reconnect after disconnected : ' + new Date());
                            hubInstance.start();
                            hubInstance.reconnectedAttempt++;
                            console.log('signalr - reconnection - fail : ' + hubInstance.reconnectedAttempt);
                        }
                    }, __env._SignalRreconnectInterval);
                } else {
                    var errorMessage = error ? (error.message || String(error)) : '';
                    $rootScope.$emit('SignalrConnectionDisconnected', errorMessage);
                }
            });

            hubInstance.connection.onreconnecting(function () {
                hubInstance.connectionStatus.setConnection(true, false);
                broadcastConnectionEvent(HubConnectionEvents.change, { newState: signalR.HubConnectionState.Reconnecting });
            });
            hubInstance.connection.onreconnected(function () {
                hubInstance.connectionStatus.setConnection(false, false);
                broadcastConnectionEvent(HubConnectionEvents.change, { newState: signalR.HubConnectionState.Connected });
            });
        }

        return Hub;
    }

    angular.module('services.hub', [])
        .value('HubConnectionEvents', {
            change: 'hub:connection:change',
            error: 'hub:connection:error',
            disconnected: 'hub:connection:disconnected',
            reconnected: 'hub:connection:reconnected',
            reconnecting: 'hub:connection:reconnecting'
        })
        .factory('HubProxy', HubFactory);
})(window.jQuery, window.angular, document);

angular.module('Radico.services', [])

angular.module('Radico.services').service('yesnoService', ['$uibModal',

    function ($modal) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            modalFade: true,
            template: '<div class="yesno-modal default-modal">' +
            '<div class="modal-header">' +
            '<h3>{{ modalOptions.headerText }}</h3>' +
            '</div>' +
            '<div class="modal-body">' +
            '<p>{{ modalOptions.bodyText }}</p>' +
            '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn"' +
            'data-ng-click="modalOptions.close()">{{ modalOptions.closeButtonText }}</button>' +
            '<button class="btn btn-primary"' +
            'data-ng-click="modalOptions.ok();">{{ modalOptions.actionButtonText }}</button>' +
            '</div>' +
            '</div>'
        };

        var modalOptions = {
            closeButtonText: 'Close',
            actionButtonText: 'OK',
            headerText: 'Proceed?',
            bodyText: 'Perform this action?'
        };

        this.showModal = function (customModalDefaults, customModalOptions) {
            if (!customModalDefaults) customModalDefaults = {};
            customModalDefaults.backdrop = 'static';
            return this.show(customModalDefaults, customModalOptions);
        };

        this.show = function (customModalDefaults, customModalOptions) {
            //Create temp objects to work with since we're in a singleton service
            var tempModalDefaults = {};
            var tempModalOptions = {};

            //Map angular-ui modal custom defaults to modal defaults defined in service
            angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

            //Map modal.html $scope custom properties to defaults defined in service
            angular.extend(tempModalOptions, modalOptions, customModalOptions);

            if (!tempModalDefaults.controller) {
                tempModalDefaults.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                    $scope.modalOptions = tempModalOptions;
                    $scope.modalOptions.ok = function (result) {
                        $uibModalInstance.close(result);
                    };
                    $scope.modalOptions.close = function (result) {
                        $uibModalInstance.dismiss('cancel');
                    };
                }];
            }

            return $modal.open(tempModalDefaults).result;
        };

    }]);
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Created by Shripad on 2015-Nov-17.
 */

angular.module('BlurAdmin.theme').directive('treeDropdown', treeDropdown);

treeDropdown.$inject = ['$compile'];

function treeDropdown($compile) {
    var template = "<div class='select' ng-click='openTree()'><p>{{selected.name}}</p></div>";
    template += "<div class='list' ng-show='isOpen'></div>";

    return {
        restrict: 'E',
        scope: {
            data: '=',
            selected: '='
        },

        template: template,
        controller: function ($scope, $element) {
            ctrl = $scope;
            ctrl.isOpen = false;

            ctrl.openTree = function () {
                ctrl.isOpen = ctrl.isOpen ? false : true;
            }

            ctrl.childClick = function (obj) {
                obj.selected = !obj.selected;
                //ctrl.isOpen = false;
                ctrl.$apply();
            }
        },
        link: function (scope, element, attrs, ngModel) {
            var list = angular.element(element[0].querySelector('.list'));

            scope.$watchGroup(['data', 'selected'], function (newValues, oldValues, scope) {
                list.html('');

                if (!scope.selected) {
                    setSelected(scope, null);
                }
                var options = getOptions(scope, scope.data, 0);
                list.append($compile(options)(scope));
            });

            // Close on click outside the dropdown...            
            angular.element(document).bind('click', function (event) {
                if (element !== event.target && !element[0].contains(event.target)) {
                    scope.$apply(function () {
                        scope.isOpen = false;
                    })
                }
            });
        }
    };

    function getOptions(scope, data, level) {

        var optionUL = angular.element("<ul></ul>");

        var optionLI = angular.element("<li ng-repeat='obj in data'><p ng-class='{selected:selected.id== obj.id}' class='level-1'><input type='checkbox' ng-model='obj.selected' /><span>{{obj.name }}</span></p><ul><li ng-repeat='child in obj.children'><p ng-class='{selected:selected.id==child.id}' class='level-2'><input type='checkbox' ng-model='child.selected' /><span>{{child.name}}</span></p></li></ul></li>");
        //var optionA = angular.element("<p ng-class='{selected:selected.id==" + obj.id + "}' class='level-" + level + "'><input type='checkbox' ng-model='obj.selected' />" + obj.name + "</p>");
        //optionLI.append(optionA);

        // Set selected option if selected id or object exist..
        //if (scope.selected == obj) {
        //    setSelected(scope, obj);
        //}

        //optionA.bind("click", function () {
        //    scope.childClick(obj);
       // })

        //if (obj.children) {
        //    optionLI.append(getOptions(scope, obj.children, level + 1));
        //}
        //optionUL.append(optionLI);


        //angular.forEach(data, function (obj) {
        //    var optionLI = angular.element("<li></li>");
        //    var optionA = angular.element("<p ng-class='{selected:selected.id==" + obj.id + "}' class='level-" + level + "'><input type='checkbox' ng-model='obj.selected' />" + obj.name + "</p>");
        //    optionLI.append(optionA);

        //    // Set selected option if selected id or object exist..
        //    if (scope.selected == obj) {
        //        setSelected(scope, obj);
        //    }

        //    optionA.bind("click", function () {
        //        scope.childClick(obj);
        //    })

        //    if (obj.children) {
        //        optionLI.append(getOptions(scope, obj.children, level + 1));
        //    }
        //    optionUL.append(optionLI);
        //})
        optionUL.append(optionLI);
        return optionUL;
    }

    function setSelected(scope, obj) {
        if (obj) {
            scope.selected = obj;
        } else {
            scope.selected = null;
        }
    }
}
angular.module('BlurAdmin.theme')
    //from bootstrap-ui typeahead parser
    .factory('optionParser', ['$parse', function ($parse) {

        //                      00000111000000000000022200000000000000003333333333333330000000000044000
        var TYPEAHEAD_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+(.*)$/;

        return {
            parse: function (input) {

                var match = input.match(TYPEAHEAD_REGEXP), modelMapper, viewMapper, source;
                if (!match) {
                    throw new Error(
                        "Expected typeahead specification in form of '_modelValue_ (as _label_)? for _item_ in _collection_'" +
                        " but got '" + input + "'.");
                }

                return {
                    itemName: match[3],
                    source: $parse(match[4]),
                    viewMapper: $parse(match[2] || match[1]),
                    modelMapper: $parse(match[1])
                };
            }
        };
    }])

    .directive('multiselect', ['$parse', '$document', '$compile', 'optionParser',

        function ($parse, $document, $compile, optionParser) {
            return {
                restrict: 'E',
                require: 'ngModel',
                link: function (originalScope, element, attrs, modelCtrl) {

                    var exp = attrs.options,
                        parsedResult = optionParser.parse(exp),
                        isMultiple = attrs.multiple ? true : false,
                        required = false,
                        scope = originalScope.$new(),
                        changeHandler = attrs.change || anguler.noop;

                    scope.items = [];
                    scope.header = 'Select';
                    scope.multiple = isMultiple;
                    scope.disabled = false;

                    originalScope.$on('$destroy', function () {
                        scope.$destroy();
                    });

                    var popUpEl = angular.element('<multiselect-popup></multiselect-popup>');

                    //required validator
                    if (attrs.required || attrs.ngRequired) {
                        required = true;
                    }
                    attrs.$observe('required', function (newVal) {
                        required = newVal;
                    });

                    //watch disabled state
                    scope.$watch(function () {
                        return $parse(attrs.disabled)(originalScope);
                    }, function (newVal) {
                        scope.disabled = newVal;
                    });

                    //watch single/multiple state for dynamically change single to multiple
                    scope.$watch(function () {
                        return $parse(attrs.multiple)(originalScope);
                    }, function (newVal) {
                        isMultiple = newVal || false;
                    });

                    //watch option changes for options that are populated dynamically
                    scope.$watch(function () {
                        return parsedResult.source(originalScope);
                    }, function (newVal) {
                        if (angular.isDefined(newVal))
                            parseModel();
                    });

                    //watch model change
                    scope.$watch(function () {
                        return modelCtrl.$modelValue;
                    }, function (newVal, oldVal) {
                        //when directive initialize, newVal usually undefined. Also, if model value already set in the controller
                        //for preselected list then we need to mark checked in our scope item. But we don't want to do this every time
                        //model changes. We need to do this only if it is done outside directive scope, from controller, for example.
                        if (angular.isDefined(newVal)) {
                            markChecked(newVal);
                            scope.$eval(changeHandler);
                        }
                        getHeaderText();
                        modelCtrl.$setValidity('required', scope.valid());
                    }, true);

                    function parseModel() {
                        scope.items.length = 0;
                        var model = parsedResult.source(originalScope);
                        for (var i = 0; i < model.length; i++) {
                            var local = {};
                            local[parsedResult.itemName] = model[i];
                            scope.items.push({
                                label: parsedResult.viewMapper(local),
                                model: model[i],
                                checked: false
                            });
                        }
                    }

                    parseModel();

                    element.append($compile(popUpEl)(scope));

                    function getHeaderText() {
                        if (!modelCtrl.$modelValue || !modelCtrl.$modelValue.length) return scope.header = 'Select';
                        if (isMultiple) {
                            scope.header = modelCtrl.$modelValue.length + ' ' + 'selected';
                        } else {
                            var local = {};
                            local[parsedResult.itemName] = modelCtrl.$modelValue;
                            scope.header = parsedResult.viewMapper(local);
                        }
                    }

                    scope.valid = function validModel() {
                        if (!required) return true;
                        var value = modelCtrl.$modelValue;
                        return (angular.isArray(value) && value.length > 0) || (!angular.isArray(value) && value != null);
                    };

                    function selectSingle(item) {
                        if (item.checked) {
                            scope.uncheckAll();
                        } else {
                            scope.uncheckAll();
                            item.checked = !item.checked;
                        }
                        setModelValue(false);
                    }

                    function selectMultiple(item) {
                        item.checked = !item.checked;
                        setModelValue(true);
                    }

                    function setModelValue(isMultiple) {
                        var value;

                        if (isMultiple) {
                            value = [];
                            angular.forEach(scope.items, function (item) {
                                if (item.checked) value.push(item.model);
                            })
                        } else {
                            angular.forEach(scope.items, function (item) {
                                if (item.checked) {
                                    value = item.model;
                                    return false;
                                }
                            })
                        }
                        modelCtrl.$setViewValue(value);
                    }

                    function markChecked(newVal) {
                        if (!angular.isArray(newVal)) {
                            angular.forEach(scope.items, function (item) {
                                if (angular.equals(item.model, newVal)) {
                                    item.checked = true;
                                    return false;
                                }
                            });
                        } else {
                            angular.forEach(newVal, function (i) {
                                angular.forEach(scope.items, function (item) {
                                    if (angular.equals(item.model, i)) {
                                        item.checked = true;
                                    }
                                });
                            });
                        }
                    }

                    scope.checkAll = function () {
                        if (!isMultiple) return;
                        angular.forEach(scope.items, function (item) {
                            item.checked = true;
                        });
                        setModelValue(true);
                    };

                    scope.uncheckAll = function () {
                        angular.forEach(scope.items, function (item) {
                            item.checked = false;
                        });
                        setModelValue(true);
                    };

                    scope.select = function (item) {
                        if (isMultiple === false) {
                            selectSingle(item);
                            scope.toggleSelect();
                        } else {
                            selectMultiple(item);
                        }
                    }
                }
            };
        }])

    .directive('multiselectPopup', ['$document', function ($document) {
        return {
            restrict: 'E',
            scope: false,
            replace: true,
            template: 
                '<div class="dropdown">' +
            '<button class="btn" ng-click="toggleSelect()" ng-disabled="disabled" ng-class="{\'error\': !valid()}">' +
                        '<span class="pull-left">{{ header }}</span>' +
                        '<span class="caret pull-right"></span>' +
                    '</button>' +
                    '<div class="dropdown-menu dropdown-menu-fake-panel">' +
                        '<div class="dropdown-header">' +
                           ' <input class="input-block-level" type="text" ng-model="searchText.label" autofocus="autofocus" placeholder="Filter" />' +
                        '</div>' +
                        '<div>' +
                         '   <button class="btn-link btn-small pull-left" style="margin-left: 15px;" ng-click="checkAll()"><i class="ion-checkmark"></i> Check all</button>' +
                          '  <button class="btn-link btn-small pull-left" style="margin-left: 15px;" ng-click="uncheckAll()"><i class="ion-close-round"></i> Uncheck all</button>' +
                        '</div>' +
                        '<ul class="dropdown-menu dropdown-menu-fake">' +
                          '  <li ng-repeat="i in items | filter:searchText">' +
                            '    <a ng-click="select(i); focus()">' +
                            '    <i ng-class="{\'ion-checkmark\': i.checked, \'icon-empty\': !i.checked}"></i>{{ i.label }}</a>' +
                           ' </li>' +
                        '</ul>' +
                   ' </div>' +
               ' </div>' +
            '',
            link: function (scope, element, attrs) {

                scope.isVisible = false;

                scope.toggleSelect = function () {
                    if (element.hasClass('open')) {
                        element.removeClass('open');
                        $document.unbind('click', clickHandler);
                    } else {
                        element.addClass('open');
                        scope.focus();
                        $document.bind('click', clickHandler);
                    }
                };

                function clickHandler(event) {
                    if (elementMatchesAnyInArray(event.target, element.find(event.target.tagName)))
                        return;
                    element.removeClass('open');
                    $document.unbind('click', clickHandler);
                    scope.$digest();
                }

                scope.focus = function focus() {
                    var searchBox = element.find('input')[0];
                    searchBox.focus();
                }

                var elementMatchesAnyInArray = function (element, elementArray) {
                    for (var i = 0; i < elementArray.length; i++)
                        if (element == elementArray[i])
                            return true;
                    return false;
                }
            }
        }
    }]);
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

angular.module('BlurAdmin.theme')
    .service('BillAPIService', ['Restangular', function (Restangular) {

        this.login = function (preference) {
            return Restangular.one('bill').one('login').customPOST(preference);
        };
    }]);
(function () {
    'use strict';

    angular
        .module('BlurAdmin.theme')
        .factory('campaignService', campaignService);

    campaignService.$inject = ['$http', '__env'];

    function campaignService($http, __env) {
        return {
            getStats: function (userId) {
                return $http.post(__env._environment.config.apiResourceServiceBaseUri + 'Campaign/GetCampaignStats', { UserID: userId });
            }
        };
    }
})();



angular.module('BlurAdmin.theme')
    .service('chatService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS,__env) {
        //this.GetUserList = function (userId) {
        //    return Restangular.one('chat').one("GetUserList", userId).get();
        //};
        this.GetUserList = function (param) {
            return Restangular.one('chat').one("GetUserList").customPOST(param);
        };
        this.GetMessage = function (curVM) {
            return Restangular.one('chat').one("GetMessage").customPOST(curVM);
        };
        this.SendMessage = function (curVM) {
            return Restangular.one('chat').one("SendMessage").customPOST(curVM);
        };
        this.DeleteMessage = function (curVM) {
            return Restangular.one('chat').one("DeleteMessage").customPOST(curVM);
        };
        this.uploadFile = function (formData) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri + "chat/uploadFile", formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            });
        };
        this.DownloadFile = function (curVM) {
            return Restangular.one('chat').one("DownloadFile").customPOST(curVM);
        };
        this.SetOnlineStatus = function (userId, IsOnline) {
            var param = { Id: userId, IsOnline: IsOnline };
            return Restangular.one('chat').one("SetOnlineStatus").customPOST(param);
        };
        this.ChangeReadStatus = function (param) {
            return Restangular.one('chat').one("ChangeReadStatus").customPOST(param);
        };
        this.GetUnreadMessageCount = function (userId) {
            return Restangular.one('chat').one("GetUnreadMessageCount").one(userId).get();
        };
        this.getAccessTwilioToken = function (displayname,roomName) {
            return Restangular.one('chat').one("GetAccessTwilioToken").one(displayname,roomName).get();            
        };
        this.saveVideoConferencingDatails = function (paramVideoObj) {
            return Restangular.one('chat').one("SaveVideoConferencingDatails").customPOST(paramVideoObj);            
        };
        this.LogVideoCallEndTime = function(videoConferencingID){
            return Restangular.one('chat').one("LogVideoCallEndTime", videoConferencingID).get();
        }
        this.getVideoConferencingIDToUser = function(messageId){
            return Restangular.one('chat').one("GetVideoConferencingIDToUser", messageId).get();
        }
        this.checkVideoCallLinkIsExpired = function(videoConferencingID){
            return Restangular.one('chat').one("CheckVideoCallLinkIsExpired", videoConferencingID).get();
        }
        this.expirePreviousScheduledVideoCall = function(oldRescheduledMsg){
            return Restangular.one('chat').one("ExpirePreviousScheduledVideoCall").customPOST(oldRescheduledMsg);
        }
        this.SetChatPinUsers = function(params){
            return Restangular.one('chat').one("SetChatPinUsers").customPOST(params);
        }
        this.SetChatGroup = function (params) {
            return Restangular.one('chat').one("SetChatGroup").customPOST(params);
        }
        this.GetChatGroup = function (params) {
            return Restangular.one('chat').one("GetChatGroup").customPOST(params);
        }
        this.AddMember = function (params) {
            return Restangular.one('chat').one("AddMember").customPOST(params);
        }
        this.GetMessageReadStatusByMessage = function (params) {
            return Restangular.one('chat').one("GetMessageReadStatusByMessage").customPOST(params);
        }
    }]);


angular.module('BlurAdmin.theme')
    .service('commonService', function () {
        var self = this;
        /****************************************************
            * 
            ****************************************************/
        self.clone = function (obj) {
            if (obj) {
                var newObj = {};
                $.each(obj, function (key, val) {
                    newObj[key] = val;
                });
                return newObj
            }
            return obj;
        }
        /****************************************************
        * 
        ****************************************************/
        self.deepClone = function (obj) {
            if (obj) {
                return JSON.parse(JSON.stringify(obj))
            }
            return obj;
        }
        /****************************************************
        * 
        ****************************************************/
        self.parseJson = function (jsonText, defaultValue) {
            try {
                return JSON.parse(jsonText);
            }
            catch (e) {

            }
            return defaultValue;
        }
        /****************************************************
        * 
        ****************************************************/
        self.formatDate = function (dateValue, formatString, defaultValue) {
            defaultValue = defaultValue || null;
            formatString = formatString || "MM/DD/YYYY";
            if (dateValue) {
                try {
                    if (!_.isDate(dateValue)) {
                        dateValue = new Date(dateValue);
                    }
                    return moment(dateValue).format(formatString);
                }
                catch (e) { }
            }
            return defaultValue;
        }
        /****************************************************
        * 
        ****************************************************/
        self.convertToDate = function (dateValue, defaultValue) {
            defaultValue = defaultValue || null;
            if (dateValue) {
                try {
                    if (_.isDate(dateValue)) {
                        return dateValue;
                    }
                    return new Date(dateValue);
                }
                catch (e) { }
            }
            return defaultValue;
        }
        /****************************************************
            * 
            ****************************************************/
        self.downloadFile = function (data, fileName, contentType) {
            try {
                var parser = new UAParser();
                var linkElement = document.createElement('a');

                var blob = b64toBlob(data, contentType);
                var url = URL.createObjectURL(blob);
                var b = parser.getBrowser().name;
                if (b != null && b.toUpperCase() == "IE") {
                    window.navigator.msSaveBlob(blob, fileName);
                }
                else {
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
                    var clickEvent = new MouseEvent("click", {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        }
        function b64toBlob(dataURI, fileType) {
            var byteString = atob(dataURI);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: fileType });
        }
        /****************************************************
            * 
            ****************************************************/
        self.changeFileExtension = function (fileName, newExt, suffix) {
            fileName = $.trim(fileName);
            suffix = suffix || '';
            var arrFile = fileName.split('.');
            arrFile.pop();

            var newFileName = arrFile.join('.') + suffix + '.' + newExt;
            return newFileName;
        }

        self.getFileName = function (filePath, altPath) {
            filePath = $.trim(filePath || altPath);
            filePath = filePath.replace(/\\/g, "/");

            var arrFile = filePath.split('/');
            var fileName = arrFile.pop();

            return fileName;
        }
        /****************************************************
        * 
        ****************************************************/
        self.getFileNameFromHeader = function (headers, defaultFileName) {
            var fileName = defaultFileName || "";
            if (headers['content-disposition']) {
                //Header something like this: content-disposition: "attachment; filename="PATIENT PAYMENT FORM.xlsx""
                var contentDisposition = headers['content-disposition'];
                var prefixText = "filename=";
                var startIndex = contentDisposition.indexOf(prefixText) + (prefixText.length + 1);
                var endIndex = contentDisposition.length - 1;
                fileName = contentDisposition.substring(startIndex, endIndex);
            }
            return fileName;
        }

        /****************************************************
        * 
        ****************************************************/
        self.buildUploadFormData = function (fileControlId, currentModel) {
            var formData = new FormData()
            angular.forEach(currentModel, function (value, key) {
                formData.append(key, value);
            });
            var file = angular.element('#' + fileControlId)[0];
            var hasFile = false;//Have to manual use hasFile indicator, because IE10 doesn't support FormData.get to know field exist
            if (file.files && file.files.length) {
                formData.append('file', file.files[0]);
                hasFile = true;
            }
            return {
                formData: formData,
                hasFile: hasFile
            };
        }
        /****************************************************
        * 
        ****************************************************/
        self.applyOrdering = function (sortRequest, sortBy, defaultSortDirection) {
            if (sortRequest.sortBy === sortBy) {
                sortRequest.sortDirection = sortRequest.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                sortRequest.sortBy = sortBy;
                sortRequest.sortDirection = defaultSortDirection || 'asc';
            }
            return sortRequest;
        };
        /****************************************************
        * 
        ****************************************************/
        self.getLayoutCssClass = function (showDetailLayout, listCss, detailCss) {
            var cssClass = {};
            if (showDetailLayout && detailCss) {
                cssClass[detailCss] = true;
            }
            if (!showDetailLayout && listCss) {
                cssClass[listCss] = true;
            }
            return cssClass;

        }
        /****************************************************
            * 
            ****************************************************/
        self.clearFileInput = function (selector) {
            $(selector).val('');
            $(selector).change();
        }
        /****************************************************
            * 
            ****************************************************/
        self.nameTrim = function (value) {
            value = value || '';
            value = value.replace(/\s+/g, ' ');
            value = value.replace(' ,', ',');
            value = $.trim(value);
            return value;
        }
        /****************************************************
        * 
        ****************************************************/
        self.groupData = function (data, groupFieldName) {
            var dataGrouped = {};
            $.each(data, function (iii, item) {
                var groupFieldValue = item[groupFieldName];
                dataGrouped[groupFieldValue] = dataGrouped[groupFieldValue] || [];
                dataGrouped[groupFieldValue].push(item);
            });
            return dataGrouped;
        }
        /***********************************************************************************
        * 
        ************************************************************************************/
        self.arrayToHash = function (data, filterFieldName) {
            var hashData = {};
            $.each(data, function (iii, item) {
                if (item) {
                    var key = item[filterFieldName];
                    hashData[key] = item;
                }
            });
            return hashData;
        }
        /***********************************************************************************
        * 
        ************************************************************************************/
        self.arrayToHashComplex = function (data, fields) {
            var hashData = {};
            $.each(data, function (iii, item) {
                if (item) {
                    var comboKeys = [];
                    fields.forEach(function (fieldName) {
                        comboKeys.push(item[fieldName]);
                    })
                    var key = JSON.stringify(comboKeys);
                    hashData[key] = item;
                }
            });
            return hashData;
        }
        /***********************************************************************************
       * 
       ************************************************************************************/
        self.searchArray = function (data, keyword, searchFields, limit, defaultValue) {
            var results = self.filterArray(data, keyword, searchFields, 'start', limit, defaultValue);
            if (results.length) {
                return results;
            }
            // Try anoher search approach
            results = self.filterArray(data, keyword, searchFields, 'contains', limit, defaultValue);
            return results;
        }
        /***********************************************************************************
        * 
        ************************************************************************************/
        self.arrayContains = function (data, keyword) {
            data = data || [];
            for (var i = 0; i < data.length; i++) {
                if (data[i] == keyword) { // Use == instead of === to ignore data type
                    return true;
                }
            }
            return false;
        }
        /***********************************************************************************
        * 
        ************************************************************************************/
        self.filterArray = function (data, keyword, searchFields, searchType, limit, defaultValue) {
            searchType = searchType || 'contains';
            limit = limit || Number.MAX_VALUE;
            defaultValue = defaultValue || [];
            keyword = _.trim(keyword).toLowerCase();
            if (!keyword) {
                return data;
            }
            if (data && data.length) {
                var filteredData = [];
                var dLen = data.length;
                var fLen = searchFields.length;
                var numInsert = 0;
                for (var i = 0; i < dLen; i++) {
                    var item = data[i];
                    for (var j = 0; j < fLen; j++) {
                        var fieldName = searchFields[j];
                        var fieldValue = _.trim(item[fieldName]).toLowerCase();
                        var isMatch = false;
                        if (searchType == 'start') {
                            isMatch = _.startsWith(fieldValue, keyword);
                        } else {
                            isMatch = fieldValue.indexOf(keyword) >= 0;
                        }
                        if (fieldValue && isMatch) {
                            filteredData.push(item);
                            numInsert++;
                            break;
                        }
                    }
                    if (numInsert > limit) {
                        break;
                    }
                }
                return filteredData;
            }
            return defaultValue;
        }
        /***********************************************************************************
        * 
        ************************************************************************************/
        self.hasDuplicateValue = function (obj, fields) {
            var existValues = [];
            var hasDuplicate = false;
            for (var i = 0; i < fields.length; i++) {
                var fieldName = fields[i];
                if (obj && obj[fieldName]) {
                    var mValue = _.trim(obj[fieldName]);
                    if (existValues.indexOf(mValue) >= 0) {
                        hasDuplicate = true;
                        break
                    }
                    existValues.push(mValue);
                }
            }
            return hasDuplicate;
        }
        /***********************************************************************************
        * 
        ************************************************************************************/

        self.getDuplicatedData = function (data, fields) {
            var groupedData = self.groupDataByFields(data, fields);
            var duplicatedData = [];
            _.forEach(groupedData, function (value, key) {
                if (value.length > 1) {
                    duplicatedData.push(value[0].item);
                }
            });
            return duplicatedData;
        }
        /***********************************************************************************
        * 
        ************************************************************************************/

        self.groupDataByFields = function (data, fields) {
            data = data || [];
            var hashedData = [];
            _.forEach(data, function (item) {
                var hashKeyObj = {};
                for (var i = 0; i < fields.length; i++) {
                    var fieldName = fields[i];
                    hashKeyObj[fieldName] = _.get(item, fieldName);
                }

                hashedData.push({
                    key: JSON.stringify(hashKeyObj),
                    item: item
                });
            });
            return self.groupData(hashedData, 'key');
        }
        /***********************************************************************************
        * 
        ************************************************************************************/
        self.getPropertyValues = function (obj, fields) {
            var values = [];
            if (obj) {
                _.forEach(fields, function (fieldName) {
                    var mValue = _.trim(obj[fieldName]);
                    if (mValue) {
                        values.push(mValue);
                    }
                });
            }
            return values;
        }
        /***********************************************************************************
        * 
        ************************************************************************************/
        self.getNextRow = function (rows, matchFunc, nextMatchFunc) {
            var foundIndex = -1;
            var nextIndex = -1;
            var foundRow = null;
            for (var i = 0; i < rows.length; i++) {
                if (matchFunc(rows[i])) {
                    foundIndex = i;
                    break;
                }
            }
            if (foundIndex >= 0) {
                if (nextMatchFunc) {
                    for (var i = (foundIndex + 1); i < rows.length; i++) {
                        if (nextMatchFunc(rows[i])) {
                            nextIndex = i;
                            break;
                        }
                    }
                } else {
                    nextIndex = foundIndex + 1;
                }
            }

            if (nextIndex >= 0 && nextIndex < rows.length) {
                foundRow = rows[nextIndex];
            }
            return foundRow;
        }
        /****************************************************************************************************************************
        * 
        ****************************************************/
        self.focusNextControl = function (currentFocusControl, listSelector) {
            var nextSelector = getNextFocusableSelector(currentFocusControl, listSelector);

            if (nextSelector) {
                self.focusControl(nextSelector);
            }
            return nextSelector;
        }
        function getNextFocusableSelector(currentFocusControl, listSelector) {
            for (var i = 0; i < listSelector.length; i++) {
                var nextSelector = getNextSelector(currentFocusControl, listSelector);
                if ($(nextSelector).is(':visible') && !$(nextSelector).is(':disabled')) {
                    return nextSelector;
                } else {
                    //console.log('nextSelector', currentFocusControl, nextSelector);
                    currentFocusControl = nextSelector;
                }
            }
            return '';
        }
        function getNextSelector(currentControl, listSelector) {
            var nextIndex = 0;
            var foundIndex = listSelector.indexOf(currentControl);
            if (foundIndex < (listSelector.length - 1)) {
                nextIndex = foundIndex + 1;
            }
            return listSelector[nextIndex];
        }
        /****************************************************************************************************************************
       * 
       ****************************************************/
        self.focusControl = function (selector) {
            var len = $(selector).length;
            if (len) {
                setTimeout(function () {
                    var focusser = $($(selector)[len - 1]).find('.ui-select-focusser');
                    if (focusser.length) {
                        focusser[0].focus();
                    } else {
                        $(selector)[len - 1].focus();
                    }
                }, 0);
            }
            return selector;
        }
        /****************************************************************************************************************************
        * 
        ****************************************************/
        self.getDefaultBatchNumber = function (fileName, defaultValue) {
            defaultValue = defaultValue || '';
            var batchNumber = defaultValue
            if (fileName) {
                var arrFileName = fileName.split('_');
                for (var i = 0; i < arrFileName.length; i++) {
                    var partialFileName = arrFileName[i];
                    if (partialFileName && !isNaN(partialFileName)) {
                        batchNumber = partialFileName;
                    }
                }
            }
            return batchNumber;
        }
        /****************************************************************************************************************************
       * 
       ****************************************************/
        self.getPrevNextRow = function (listItems, matchCond) {
            var prevNextData = {};
            var foundIndex = _.findIndex(listItems, matchCond);
            if (foundIndex >= 0) {
                var prevIndex = foundIndex - 1;
                var nextIndex = foundIndex + 1;
                if (prevIndex >= 0) {
                    prevNextData.prev = listItems[prevIndex];
                }
                if (nextIndex < listItems.length) {
                    prevNextData.next = listItems[nextIndex];
                }
            }
            return prevNextData;
        }
        /***********************************************************************************
       * 
       ************************************************************************************/
        self.uniqueArrayString = function (displayValue, separator) {
            separator = separator || ',';
            if (displayValue) {
                var arrValue = displayValue.toString().split(separator);
                var result = self.uniqueArray(arrValue);

                return result.join(separator);
            }
            return displayValue;
        }
        /***********************************************************************************
         * 
         ************************************************************************************/
        self.uniqueArray = function (arrValue) {
            var result = [];
            _.forEach(arrValue, function (item) {
                if (result.indexOf(item) < 0) {
                    result.push(item);
                }
            })
            return result;
        }
        /***********************************************************************************
         * 
         ************************************************************************************/
        self.matchAny = function (arrValue, fieldName, fieldValue) {
            arrValue = arrValue || [];
            var filterArr = _.filter(arrValue, function (item) {
                return item[fieldName] == fieldValue;
            });
            return filterArr.length > 0;
        }
        /***********************************************************************************
         * 
         ************************************************************************************/
        self.matchAll = function (arrValue, fieldName, fieldValue) {
            arrValue = arrValue || [];
            var filterArr = _.filter(arrValue, function (item) {
                return item[fieldName] == fieldValue;
            });
            return filterArr.length === arrValue.length;
        }
        /***********************************************************************************
        * This function check if object is empty, event if the property has empty array also empty
        ************************************************************************************/
        self.isEmptyObject = function (obj, ignoreFields) {
            var isEmpty = true;
            obj = obj || {};
            ignoreFields = ignoreFields || [];
            _.forEach(obj, function (value, key) {
                if (ignoreFields.indexOf(key) < 0) {
                    if (value && _.isArray(value)) {
                        if (value.length) {
                            isEmpty = false;
                        }
                    } else if (value) {
                        isEmpty = false;
                    }
                }

            });
            return isEmpty;
        }
        /***********************************************************************************
         * 
         ************************************************************************************/
        self.sliceAndInsert = function (items, count, selectItem, fieldName) {
            items = items || [];
            var sliceItems = items.slice(0, count);
            if (selectItem) {
                var fieldValue = selectItem[fieldName];
                if (items.length) {
                    // If we have data list use the one in the data list instead
                    selectItem = _.find(items, function (item) {
                        return item[fieldName] == fieldValue;
                    });
                }
                sliceItems = _.filter(sliceItems, function (item) {
                    return item[fieldName] != fieldValue;
                });
                if (selectItem) {
                    sliceItems.unshift(selectItem);
                }
            }
            return sliceItems;
        }
        /****************************************************
        * 
        ****************************************************/
        self.mappingKendoGridFilter = function (options, filter) {
            filter = filter || {};
            filter.PageSize = options.data.pageSize;
            filter.PageNo = options.data.page;
            if (options.data.sort && options.data.sort.length > 0) {
                filter.sortField = options.data.sort[0].field;
                filter.sortDir = options.data.sort[0].dir;
            }
            return filter;
        }
        /****************************************************
       * 
       ****************************************************/
        self.refreshKendoGrid = function (dataSource, currentPage) {
            if (dataSource.page() != currentPage) {
                dataSource.page(1);
            }
            dataSource.read();
        }
        /****************************************************************************************************************************
        * 
        ****************************************************/
        self.openSimpleDialog = function (options) {
            var defaultOptions = {
                title: '',
                message: '',
                ok: '',
                cancel: '',
            };
            options = $.extend({}, defaultOptions, options);
            return self.openComponentDialog(options);
        }
        /****************************************************************************************************************************
        * 
        ****************************************************/
        self.parseFullName = function (fullName) {
            var result = {};
            fullName = _.trim(fullName);
            fullName = fullName.replace(/\s\s+/g, ' ');
            //Because user might also enter middle name and we ignore it.
            if (fullName.indexOf(',') >= 0) {
                var arrName = fullName.split(',');
                result.lastName = _.trim(arrName[0]);
                result.firstName = _.trim(self.getFirstWord(arrName[1]));
            } else if (fullName.indexOf(' ') >= 0) {
                var arrName = fullName.split(' ');
                result.lastName = _.trim(self.getFirstWord(arrName[1]));
                result.firstName = _.trim(arrName[0]);
            } else {
                result.lastName = fullName;
            }
            return result;
        }
        /****************************************************************************************************************************
        * 
        ****************************************************/
        self.getFirstWord = function (word) {
            word = _.trim(word);
            var arrWord = word.split(' ');
            return arrWord[0];
        }
        /****************************************************************************************************************************
        * 
        ****************************************************/
        self.getApiAppUrl = function () {
            var appUrl = api.replace('/api/', '') + '/';
            return appUrl;
        }

        /****************************************************************************************************************************
            * 
            ****************************************************/
        self.openComponentDialog = function (options, okCallback, cancelCallback) {

            options = options || {};

            var defaultOptions = {
                controlId: 'ciComponentDialog',
                title: 'Confirm',
                message: 'Are you sure',
                width: 320,
                ok: 'OK',
                cancel: 'Cancel',
            };
            options = $.extend({}, defaultOptions, options);
            var controlId = options.controlId;
            var html = '';

            var styleAttribute = '';
            if (options.width) {
                styleAttribute = 'width:' + options.width + 'px';
            }

            html = html + '<div class="modal fade new-popup" id="' + controlId + '" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">\r\n';
            html = html + '	<div class="modal-dialog comment-width" style="' + styleAttribute + '"  role="document">\r\n';
            html = html + '		<div class="modal-content">\r\n';
            if (options.title) {
                html = html + '			<div class="modal-header p-0-625-all border-0">\r\n';
                html = html + '				<button type="button" class="close otln-0 fs-17px mt-2px mr-4px" style="color:#fff" aria-label="Close" data-dismiss="modal">\r\n';
                html = html + '					<i class="fa fa-times" aria-hidden="true"></i>\r\n';
                html = html + '				</button>\r\n';
                html = html + '				<h4 class="modal-title fs-0-8125 fw-700" style="color:#fff">' + options.title + '</h4>\r\n';
                html = html + '			</div>\r\n';
            }
            html = html + '			<div class="modal-body">\r\n';
            html = html + '				<div class="gc-content">\r\n';
            html = html + '					<div class="row mb-10px">\r\n';
            html = html + '						<div class="col-lg-12">\r\n';
            html = html + '							 ' + options.message + '\r\n';
            html = html + '						</div>\r\n';
            html = html + '					</div>\r\n';
            if (options.ok || options.cancel) {
                html = html + '					<div class="row py-10px">\r\n';
                html = html + '						<div class="col-lg-12 text-center">\r\n';
                if (options.ok) {
                    html = html + '							<button type="button"  class="ok-button btn btn-primary btn-sm fs-13px fw-500 ral-btn" style="border-bottom:2px solid #333 !important;">\r\n';
                    html = html + '' + options.ok + '\r\n';
                    html = html + '							</button>\r\n';
                }
                if (options.cancel) {
                    html = html + '							<button type="button"  class="cancel-button btn btn-primary btn-sm fs-13px fw-500 ral-btn" style="border-bottom:2px solid #333 !important;" >\r\n';
                    html = html + '' + options.cancel + '\r\n';
                    html = html + '							</button>\r\n';
                }


                html = html + '						</div>\r\n';
                html = html + '					</div>\r\n';
            }
            html = html + '				</div>\r\n';
            html = html + '			</div>\r\n';
            html = html + '		</div>\r\n';
            html = html + '	</div>\r\n';
            html = html + '</div>\r\n';

            if ($('#' + controlId).length) {
                $('#' + controlId).remove(); //Remove exist first
            }
            $('body').append(html);
            $('#' + controlId).modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#' + controlId).find('.ok-button').click(function () {
                if (okCallback && typeof (okCallback) === 'function') {
                    okCallback.call();
                }
                $('#' + options.controlId).modal('hide');
            });
            $('#' + controlId).find('.cancel-button').click(function () {
                if (cancelCallback && typeof (cancelCallback) === 'function') {
                    cancelCallback.call();
                }
                $('#' + options.controlId).modal('hide');
            });
            return $('#' + controlId);
        }

        self.downloadImage = function (fileType, ImageBase64, fileName) {
            var a = document.createElement("a"); //Create <a>
            a.href = "data:" + fileType + ";base64," + ImageBase64; //Image Base64 Goes here
            a.download = fileName; //File name Here
            a.click(); //Downloaded file
        }

        self.stringEqual = function (str1, str2) {
           return _.trim(str1).toLowerCase() == _.trim(str2).toLowerCase()
        }

    });


angular.module('BlurAdmin.theme')
    .service('fileHelperService', ['Restangular', function (Restangular) {
        var self = this;
        self.download = function (url) {
            url = url || '';
            var arrUrl = url.split('/');
            var downloadPromise = Restangular;
            for (var i = 0; i < arrUrl.length; i++) {
                downloadPromise = downloadPromise.one(arrUrl[i]);
            }
            return downloadPromise
                .withHttpConfig({ responseType: 'arraybuffer' })
                .get();
        }
        self.loadFileContent = function (fileUrl, fileName, successCallback, errorCallback) {
            self.download(fileUrl).then(function (response) {
                var fileType = self.getFileType(fileName);
                var mimeType = self.getMimeType(fileName);
                var blob = new Blob([response], { type: mimeType });
                var contentData = {
                    binary: response,
                    blob: blob,
                    mimeType: mimeType
                };
                if (fileType == 'pdf') {
                    contentData.fileContent = URL.createObjectURL(blob);
                    successCallback.call(null, contentData);
                }
                else if (fileType == 'image') {
                    self.blobToBase64(blob, function (base64Data) {
                        contentData.fileContent = base64Data;
                        successCallback.call(null, contentData);
                    });
                }
            }, function (err) {
                if (errorCallback) {
                    errorCallback.call(err);
                }
            });
        }
        self.blobToBase64 = function (blob, callback) {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
                var base64data = reader.result;
                callback.call(null, base64data);
            }
        }
        self.getBase64DataFromUrl = function (base64Url) {
            var base64Data = base64Url;
            if (base64Url && base64Url.length > 10 && base64Url.substring(0, 4) === 'data') {
                var commaIndex = base64Url.indexOf(',')
                if (commaIndex > 0) {
                    base64Data = base64Url.substring(commaIndex + 1);
                }
            }
            return base64Data;
        }
        self.getFileExtension = function (fileName) {
            fileName = (fileName || '').trim();
            var fileExt = (fileName.split('.').pop()).toLowerCase();
            return fileExt;
        }
        self.getFileNameOnly = function (fileName) {
            fileName = (fileName || '').trim();
            var fileNameOnly = fileName.split('.').slice(0, -1).join('.');
            return fileNameOnly;
        }
        self.getFileType = function (fileName) {
            var fileType = self.getFileExtension(fileName);
            var imagesFiles = ['png', 'jpg', 'jpeg', 'gif', 'gif', 'bmp'];
            if (imagesFiles.indexOf(fileType) >= 0) {
                fileType = 'image';
            }
            return fileType;
        }
        self.getMimeType = function (fileName) {
            var fileExtension = self.getFileExtension(fileName);
            var mappings = {
                "doc": "application/msword",
                "docx": "application/msword",
                "xls": "application/vnd.ms-excel",
                "xlsx": "application/vnd.ms-excel",
                "pps": "application/vnd.ms-powerpoint",
                "ppt": "application/vnd.ms-powerpoint",
                "pptx": "application/vnd.ms-powerpoint",
                "txt": "text/plain",
                "rtf": "application/rtf",
                "pdf": "application/pdf",
                "msg": "application/vnd.ms-outlook",
                "eml": "application/vnd.ms-outlook",
                "gif": "image/gif",
                "bmp": "image/bmp",
                "png": "image/png",
                "jpg": "image/jpeg",
                "jpe": "image/jpeg",
                "jpeg": "image/jpeg",
                "dwg": "application/acad",
                "zip": "application/x-zip-compressed",
                "rar": "application/x-rar-compressed",
                "edi": "text/plain",
            };
            return mappings[fileExtension] || "application/" + fileExtension;
        }
    }]);
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
(function () {
    'use strict';

    angular
        .module('BlurAdmin.theme')
        .factory('newsletterService', newsletterService);

    newsletterService.$inject = ['$http', '$q', '__env'];

    // Task 174662: RadPod Newsletter published from CIVIR, read through the RadFlow API.
    // $http carries the bearer token via authHttpResponseInterceptor, same as campaign.service.js.
    function newsletterService($http, $q, __env) {
        var baseUri = __env._environment.config.apiResourceServiceBaseUri;

        // Who the newsletter is for: RadPod radiologists, or internal staff. RadFlow has no "Radiologist"
        // role -- radiologists sign in under the User role, and holding the RadPod tenant is what makes
        // them RadPod radiologists. Internal staff qualify by the domain of their login email whatever
        // their role or tenant. Both lists come from the API (GetUserPreferences): RadPodNewsletterUserRoles
        // and RadPodNewsletterInternalEmailDomains, each falling back to the default below when absent or blank.
        var DEFAULT_RADIOLOGIST_ROLES = 'User';
        var RADPOD_TENANT = 'RadPod';
        var DEFAULT_INTERNAL_EMAIL_DOMAINS = 'collaborativeimaging.com,civie.com,radamatic.com';

        // userRoles arrives as an array (LoginSuccessData.userRoles) and tenant names as either the
        // comma-joined $sessionStorage.userTenantNames string or its split array; both may be null.
        function toList(value) {
            if (Array.isArray(value)) { return value; }
            return typeof value === 'string' ? value.split(',') : [];
        }

        // Comma-separated config value -> trimmed, lower-cased entries; blank or missing -> the fallback list.
        function parseList(configured, fallback) {
            var raw = (typeof configured === 'string' && configured.trim()) ? configured : fallback;
            return raw.split(',').map(function (entry) {
                return entry.trim().replace(/^@/, '').toLowerCase();
            }).filter(Boolean);
        }

        // configuredRoles: RadPodNewsletterUserRoles (comma-separated RadFlow role names, matched case-insensitively).
        function isRadPodRadiologist(userRoles, tenantNames, configuredRoles) {
            var roles = parseList(configuredRoles, DEFAULT_RADIOLOGIST_ROLES);
            var holdsRole = toList(userRoles).some(function (role) {
                return typeof role === 'string' && roles.indexOf(role.trim().toLowerCase()) !== -1;
            });
            return holdsRole && toList(tenantNames).indexOf(RADPOD_TENANT) !== -1;
        }

        // Exact, case-insensitive match on the part after the last '@' (so notcivie.com is external).
        function isInternalUser(email, configuredDomains) {
            if (typeof email !== 'string') { return false; }
            var address = email.trim();
            var at = address.lastIndexOf('@');
            if (at === -1 || at === address.length - 1) { return false; }
            return parseList(configuredDomains, DEFAULT_INTERNAL_EMAIL_DOMAINS).indexOf(address.slice(at + 1).toLowerCase()) !== -1;
        }

        // user: { userRoles, tenantNames, email }; prefs: the GetUserPreferences response (may be null).
        function audience(user, prefs) {
            var who = user || {};
            var radiologist = isRadPodRadiologist(who.userRoles, who.tenantNames, prefs && prefs.RadPodNewsletterUserRoles);
            var internal = isInternalUser(who.email, prefs && prefs.RadPodNewsletterInternalEmailDomains);
            return { radiologist: radiologist, internal: internal, eligible: radiologist || internal };
        }

        return {
            isRadPodRadiologist: isRadPodRadiologist,
            isInternalUser: isInternalUser,
            audience: audience,
            // Resolves { WeeklyDocumentID, Title, FileName, UploadedDate } or null when nothing is published.
            getInfo: function () {
                return $http.get(baseUri + 'reports/GetWeeklyDocument').then(function (resp) {
                    return resp && resp.data ? resp.data : null;
                });
            },
            // Resolves { blob, url }; url is a blob: object URL the caller must revoke when done.
            // Rejects on 404 (nothing to stream) or an empty body.
            getContent: function () {
                return $http.get(baseUri + 'reports/WeeklyDocument/download', { responseType: 'arraybuffer' }).then(function (resp) {
                    if (!resp || !resp.data || !resp.data.byteLength) {
                        return $q.reject('empty newsletter content');
                    }
                    var blob = new Blob([resp.data], { type: 'application/pdf' });
                    return { blob: blob, url: URL.createObjectURL(blob) };
                });
            },
            // Releases an object URL returned by getContent. Safe to call with null or undefined.
            revoke: function (url) {
                if (url) {
                    URL.revokeObjectURL(url);
                }
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('BlurAdmin.theme')
        .factory('newsletterPopupService', newsletterPopupService);

    newsletterPopupService.$inject = ['$state', '$timeout', '$uibModal', '$sessionStorage', 'newsletterService', 'UserPreferenceService'];

    // Task 174662: lifecycle of the RadPod Newsletter popup (published from CIVIR), kept out of
    // indexController. Shown once per publish to RadPod radiologists (User role + RadPod tenant) and
    // to internal staff (login email on a company domain, any role or tenant) -- newsletterService.audience
    // is the rule. Same lifecycle as the campaign modal: opened on the post-login landing page, tracked
    // so idle timeout and logout can dismiss it. The campaign modal always goes first when both are due;
    // indexController owns the campaign state and hands in a `campaignBusy` probe through init().
    function newsletterPopupService($state, $timeout, $uibModal, $sessionStorage, newsletterService, UserPreferenceService) {
        var PREFERENCE_TYPE = 'WeeklyDocumentLastSeen';
        // Post-login landing states (see indexController.redirectBasedOnUserRole): User -> worklist-lite,
        // Technologist -> techno, Admin/SuperAdmin -> account.list, Analytics -> userAnalytics,
        // Financier -> paymentinvoice, Physician -> physician-worklist. Internal staff can hold any of
        // these roles, so a queued newsletter must be able to open on each of them.
        var LANDING_STATES = ['worklist-lite', 'account.list', 'techno', 'userAnalytics', 'paymentinvoice', 'physician-worklist'];

        var modalInstance = null;
        // A fetched newsletter waiting for the landing page to show or the campaign modal to close.
        var pending = null;
        var campaignBusy = function () { return false; };

        function isLandingState(stateName) {
            return LANDING_STATES.indexOf(stateName) !== -1;
        }

        // opts.campaignBusy(): true while a campaign modal is opening, open or waiting for its landing page.
        function init(opts) {
            if (opts && typeof opts.campaignBusy === 'function') {
                campaignBusy = opts.campaignBusy;
            }
        }

        // prefs: the GetUserPreferences response; user: { userRoles, tenantNames, email } for newsletterService.audience.
        function maybeShow(prefs, user) {
            // LoginSuccess is re-broadcast after every token refresh; never fetch or stack a second newsletter.
            if (modalInstance || pending) {
                console.log('[Newsletter] already open or queued — skipping');
                return;
            }
            var enabled = !!(prefs && prefs.EnableRadPodNewsletter);
            var who = newsletterService.audience(user, prefs);
            console.log('[Newsletter] enabled:', enabled, '| isRadPodRadiologist:', who.radiologist, '| isInternalUser:', who.internal);
            if (!enabled || !who.eligible) {
                console.log('[Newsletter] gate failed — popup will not show');
                return;
            }
            newsletterService.getInfo().then(function (info) {
                if (!info || !info.UploadedDate) {
                    console.log('[Newsletter] nothing published');
                    return;
                }
                var lastSeen = _.find((prefs && prefs.UserPreferences) || [], { PreferenceType: PREFERENCE_TYPE });
                // Exact string compare of the API's UploadedDate against the stored ack: no date parsing,
                // works whether CIVIR re-inserts the row or updates it in place.
                var isNew = !lastSeen || lastSeen.PreferenceValue !== info.UploadedDate;
                console.log('[Newsletter] uploaded:', info.UploadedDate, '| lastSeen:', lastSeen && lastSeen.PreferenceValue, '| isNew:', isNew);
                if (!isNew) { return; }
                return newsletterService.getContent().then(function (content) {
                    queue({ info: info, url: content.url, blob: content.blob, lastSeen: lastSeen });
                });
            }).catch(function (err) {
                console.log('[Newsletter] skipped:', (err && err.status) || err);
            });
        }

        // Open now only when a landing page is up and no campaign modal is open or pending; otherwise
        // park the data for onStateChange() or the campaign modal's close (openPending()).
        function queue(data) {
            var onLanding = !!($state.current && isLandingState($state.current.name));
            if (onLanding && !campaignBusy()) {
                openModal(data);
            } else {
                console.log('[Newsletter] queued until the landing page is shown and the campaign modal is closed');
                pending = data;
            }
        }

        function openPending() {
            if (pending && !campaignBusy()) {
                var data = pending;
                pending = null;
                openModal(data);
            }
        }

        // Call from the $stateChangeSuccess listener with the destination state name.
        function onStateChange(stateName) {
            if (isLandingState(stateName)) {
                openPending();
            }
        }

        function openModal(data) {
            $timeout(function () {
                if (modalInstance) {
                    // Another instance opened during the 300 ms delay; release this copy instead of stacking.
                    console.log('[Newsletter] modal already open — discarding duplicate');
                    newsletterService.revoke(data.url);
                    return;
                }
                console.log('[Newsletter] opening modal');
                modalInstance = $uibModal.open({
                    templateUrl:  'app/pages/newsletter/newsletter-modal.html',
                    controller:   'NewsletterModalController',
                    controllerAs: 'vm',
                    size:         'lg',
                    backdrop:     'static',
                    keyboard:     false,
                    windowClass:  'newsletter-modal-window',
                    resolve: { newsletterData: function () { return data; } }
                });
                modalInstance.result
                    .then(null, function (reason) {
                        // Only the explicit close button acknowledges; idle timeout and logout leave it unread.
                        if (reason === 'close') { acknowledge(data); }
                    })
                    .finally(function () {
                        modalInstance = null;
                        newsletterService.revoke(data.url);
                    });
            }, 300);
        }

        function acknowledge(data) {
            var userId = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            if (!userId || !data.info) { return; }
            // Passing the existing UserPreferenceID makes dbo.AddEditUserPreferences UPDATE instead of INSERT,
            // so a user never accumulates duplicate WeeklyDocumentLastSeen rows. "-1" = insert (repo convention).
            UserPreferenceService.AddEditUserPreferences([{
                UserPreferenceID: (data.lastSeen && data.lastSeen.UserPreferenceID) ? data.lastSeen.UserPreferenceID : "-1",
                PreferenceType: PREFERENCE_TYPE,
                UserID: userId,
                PreferenceValue: data.info.UploadedDate
            }]).then(function () {
                if (data.lastSeen) { data.lastSeen.PreferenceValue = data.info.UploadedDate; }
                console.log('[Newsletter] acknowledged', data.info.UploadedDate);
            }, function (err) {
                console.log('[Newsletter] ack failed, will show again next login:', err && err.status);
            });
        }

        // reason: 'idle' | 'logout'. Neither acknowledges; both release the blob URL.
        function close(reason) {
            // A newsletter fetched but not yet opened still owns a blob URL; release it too.
            if (pending) {
                newsletterService.revoke(pending.url);
                pending = null;
            }
            if (modalInstance) {
                console.log('[Newsletter] closing modal:', reason);
                modalInstance.dismiss(reason);
                modalInstance = null;
            }
        }

        function isOpen() {
            return !!modalInstance;
        }

        return {
            init: init,
            maybeShow: maybeShow,
            openPending: openPending,
            onStateChange: onStateChange,
            close: close,
            isOpen: isOpen,
            isLandingState: isLandingState
        };
    }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('pdfJsLoader', pdfJsLoader);

    pdfJsLoader.$inject = ['$q'];

    function pdfJsLoader($q) {
        var PDF_JS_SRC = 'cdn/js/pdf.js';
        var PDF_WORKER_SRC = 'cdn/js/pdf.worker.js';
        var loadPromise = null;

        return {
            ensureLoaded: ensureLoaded
        };

        function ensureLoaded() {
            if (window.pdfjsLib) {
                window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;
                return $q.when(window.pdfjsLib);
            }

            if (loadPromise) {
                return loadPromise;
            }

            loadPromise = $q(function (resolve, reject) {
                $.getScript(PDF_JS_SRC).done(function () {
                    if (!window.pdfjsLib) {
                        loadPromise = null;
                        reject(new Error('pdf.js failed to initialize'));
                        return;
                    }
                    window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;
                    resolve(window.pdfjsLib);
                }).fail(function () {
                    loadPromise = null;
                    reject(new Error('pdf.js failed to load'));
                });
            });

            return loadPromise;
        }
    }
})();

/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
angular.module('BlurAdmin.theme')
    .service('UserLayoutPrefService', ['Restangular', function (Restangular) {

        this.SetUserLayoutPreferences = function (preference) {
            return Restangular.one('user-layout-preferences').one('SetUserLayoutPreferences').customPOST(preference);
        };

        this.GetUserLayoutPreferences = function (preference) {
            return Restangular.one('user-layout-preferences').one('GetUserLayoutPreferences').customPOST(preference);
        };

        this.SetWorklistLayoutPreferences = function (preference) {
            return Restangular.one('user-layout-preferences').one("SetWorklistLayoutPreferences").customPOST(preference);
        }
    }]);
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('SharedService', SharedService);

    function SharedService($sessionStorage, $timeout, toaster, __env, windowHandler, RCService, WorklistService, RuleSharedService, MappingService, $injector, $q) {
        var self = this;

        /**
         * Main function to open different study viewers
         * @param {Object} Order - Order object containing study information
         * @param {string} Viewer - Viewer type (SYNAPSE, CI-VIEWER, KONICA, etc.)
         * @param {boolean} isOpenPS - Whether to open PowerScribe
         * @param {boolean} isSingleView - Whether to open in single view mode
         * @param {Object} scope - Controller scope (needed for some functions)
         * @param {Array} TimeoutList - Array to track timeouts for cleanup
         * @param {Object} browser - Browser information
         */
        self.OpenSynapseStudy = function (Order, Viewer, isOpenPS, isSingleView, scope, TimeoutList, browser, correlationId) {
            try {
                var _CommonService = $injector.get('CommonService');
                _CommonService.LogApplicationInfo({ LogDetails: '[' + correlationId + '] Step3-SharedService: OpenSynapseStudy called viewer=' + Viewer, Application: 'PACS-Viewer', UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '' });
            } catch (e) { }
            if (browser != null && browser.toUpperCase() == "IE") {
                // Change Default Dicom Viewer to Agfa if it is installed.  
                if ($sessionStorage.AgfaSetup == true && Order.Site.toUpperCase().replace(" ", "") == "MHSRICHARDSON") {
                    Viewer = "AGFA";
                }

                if (Viewer == null || Viewer.length == 0 || Viewer == "SYNAPSE") {
                    try {
                        var accession = Order.Accession;
                        if (Order.Site.toUpperCase() == 'DECATUR') {
                            accession = accession.toUpperCase().replace('WHS', '');
                        }
                        var oSynapseAPI = new ActiveXObject("Synapse.SynapseAPI");
                        var sStudyPath = oSynapseAPI.MakePath(1, accession);

                        oSynapseAPI.OpenSynapseExplorer("Synapse", Order.DicomViewerURL, sStudyPath);

                    } catch (e) {
                        toaster.warning({ body: "Unable to find the image in Synapse." });
                    }
                }
                else if (Viewer == "CANDELIS") {
                    try {
                        window.open(__env.candelisURL + Order.Accession, "_self");
                    } catch (e) {
                        toaster.warning({ body: "Unable to find the image in Candelis." });
                    }
                }
                else if (Viewer == "AGFA") {
                    try {
                        window.open(__env.agfaURL + Order.PatientMRN.toUpperCase().replace("MHS", "") + "&accession=" + Order.Accession.toUpperCase().replace("MHS", ""), "_self");
                    } catch (e) {
                        toaster.warning({ body: "Unable to find the image in Agfa." });
                    }
                }
                else if (Viewer == "KONICA" || Viewer == "KONICATEST" || Viewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                    try {
                        window.open(__env._environment.config.konicaURL.replace("@MRN", Order.PatientMRN).replace("@ACCESSION", Order.Accession).replace("@VIEWER", Viewer), "_self");
                    } catch (e) {
                        toaster.warning({ body: "Unable to find the image in Konica." });
                    }
                }
                else if (Viewer == "GECUV") {
                    try {
                        self.OpenGECentricity(Order.Accession, Order.DicomViewerCredentials);
                    } catch (e) {
                        toaster.warning({ body: "Unable to find the image in Centricity Universal Viewer." });
                    }
                }
                else if (Viewer == "CI-VIEWER") {
                    try {
                        self.OpenCIDicomViewer(Order.Accession, false, browser);
                    } catch (e) {
                        toaster.warning({ body: "Unable to find the image in CI-Viewer." });
                    }
                } else if (Viewer == "MedDream") {
                    if (__env.MedDreamUseCommunicationAPI) {
                        self.openMedDreamCommunicationAPI(Order, correlationId);
                    } else {
                        self.openMedDream(Order, correlationId);
                    }
                }

                //Open Report in PS
                var timeout = $timeout(function () {
                    if (isOpenPS) {
                        try {
                            //Synchronize accession with PowerScribe 360 By Creating XML File
                            if ($sessionStorage.AgfaSetup == true && Order.Site.toUpperCase().replace(" ", "") == "MHSRICHARDSON") {
                                var accession = Order.Accession.toUpperCase().replace("MHS", "");
                                self.CreateMHSPS360File(accession);
                                return;
                            }

                            if (typeof RadWhereCtrl !== 'undefined') {
                                RadWhereCtrl.Start();
                                try {
                                    if (RadWhereCtrl.accessionNumbers) {
                                        scope.CloseFrom = "RADFLOW";
                                        var r = RadWhereCtrl.CloseReport(false, false);
                                        while (!r) {
                                            r = RadWhereCtrl.CloseReport(false, false);
                                        }
                                    }
                                }
                                catch (e) {
                                }
                                //Synchronize accession with PowerScribe 360
                                RadWhereCtrl.OpenReport(Order.PSSiteName, Order.Accession);
                            }

                        } catch (e) {
                            toaster.warning({ body: "Unable to find the order in PS360." });
                        }
                    }
                }, 500);

                if (TimeoutList) {
                    TimeoutList.push(timeout);
                }

            }
            else {
                if (isOpenPS) {
                    if (scope && scope.DataObject && scope.DataObject.SelectedData && scope.DataObject.SelectedData.DefaultDictationSystem && scope.DataObject.SelectedData.DefaultDictationSystem == 'PS360') {
                        self.openPS360(Order, scope);
                    } else if (scope && scope.DataObject && scope.DataObject.SelectedData && scope.DataObject.SelectedData.DefaultDictationSystem && scope.DataObject.SelectedData.DefaultDictationSystem == 'CIVR') {
                        self.OpenVR(Order, false);

                    } else if (Order.DictationSystem && Order.DictationSystem == 'CIVR') {

                        self.OpenVR(Order, false);

                    } else if (Order.DictationSystem && Order.DictationSystem == 'PS360') {
                        self.openPS360(Order, scope);
                    } else {
                        self.OpenVR(Order, false);
                    }
                }

                if (Viewer == "CI-VIEWER") {
                    self.OpenCIDicomViewer(Order.Accession, isSingleView, browser, correlationId);
                }
                else if (Viewer == "KONICA" || Viewer == "KONICATEST" || Viewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                    self.openKonica(Order, Viewer, correlationId);
                }
                else if (Viewer == "SYNAPSE") {
                    var accession = Order.Accession;
                    if (Order.Site.toUpperCase() == 'DECATUR') {
                        accession = accession.toUpperCase().replace('WHS', '');
                    }
                    self.openSynapseImage(Order.DicomViewerURL, accession);
                } else if (Viewer == "MedDream") {
                    if (__env.MedDreamUseCommunicationAPI) {
                        self.openMedDreamCommunicationAPI(Order, correlationId);
                    } else {
                        self.openMedDream(Order, correlationId);
                    }
                }
            }
        };

        /**
         * Helper function to open GE Centricity viewer
         */
        self.OpenGECentricity = function (Accession, ViewerCredentials) {
            var map = window.open("", "Map", "status=0,title=0,width=700,height=600,left=500,top=300,scrollbars=1");
            if (map) {
                var form = map.document.createElement('form');
                form.method = 'POST';
                form.action = __env._environment.config.GECentricityURL;

                var userInput = map.document.createElement('input');
                userInput.type = 'hidden';
                userInput.name = 'user_name';
                userInput.value = ViewerCredentials.UserName;
                form.appendChild(userInput);

                var passInput = map.document.createElement('input');
                passInput.type = 'hidden';
                passInput.name = 'password';
                passInput.value = ViewerCredentials.Password;
                form.appendChild(passInput);

                var accInput = map.document.createElement('input');
                accInput.type = 'hidden';
                accInput.name = 'accession_number';
                accInput.value = Accession;
                form.appendChild(accInput);

                map.document.body.appendChild(form);
                form.submit();
            } else {
                toaster.warning({ body: "You must allow pop-ups for this to work." });
            }
        };

        /**
         * Helper function to open CI DICOM viewer
         */
        self.OpenCIDicomViewer = function (accession, isSingleView, browser, correlationId) {
            if (browser != null && browser.toUpperCase() == "IE") {
                window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
            }
            else {
                windowHandler.openByPreference(
                    __env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 1),
                    "CI-VIEWER-1",
                    1000,
                    isSingleView ? "CI-VIEWER-1-" + accession.toUpperCase().trim() : null,
                    "",
                    false,
                    correlationId
                );
            }
        };

        /**
         * Helper function to open Konica viewer
         */
        self.openKonica = function (order, Viewer, correlationId) {
            return windowHandler.openByPreference(
                __env._environment.config.konicaBaseURL.replace("@MRN", order.PatientMRN).replace("@ACCESSION", order.Accession).replace("@VIEWER", Viewer),
                Viewer,
                100,
                Viewer.replace(/\s/g, "").toUpperCase() + "-" + order.Accession.toUpperCase().trim(),
                "noreferrer",
                false,
                correlationId
            );
        };

        /**
         * Helper function to open Synapse image
         */
        self.openSynapseImage = function (pacsURL, accessionNumber) {
            if (RCService) {
                RCService.OpenImage({
                    requestEvent: "openimage",
                    imageRequestDetails: {
                        pacsURL: pacsURL,
                        accessionNumber: accessionNumber
                    }
                });
            }
        };

        /**
         * Helper function to open PS360
         * @param {Object} scope - Worklist scope; when set, tracks PS360 report state so that
         *   isPSManualOpen is only set when replacing an already-open report (preventing a false
         *   auto-advance on the ReportClosed that PS360 fires for the displaced report).
         *   When PS360 is idle, isPSManualOpen stays false so the user's own close triggers auto-next.
         */
        self.openPS360 = function (Order, scope) {
            if (scope) {
                // Only suppress auto-advance when PS360 already has a report open and will fire
                // ReportClosed for it as a side-effect of this new open request.
                if (scope.isPS360ReportOpen) {
                    scope.isPSManualOpen = true;
                }
                scope.isPS360ReportOpen = true;
            }
            if (RCService) {
                RCService.OpenReport({
                    requestEvent: "openreport",
                    reportRequestDetails: {
                        siteName: Order.PSSiteName,
                        accessionNumber: Order.Accession
                    }
                });
            }
        };

        /**
         * Helper function to create MHS PS360 file
         */
        self.CreateMHSPS360File = function (accession) {
            try {
                var fso, file, filepath, filecontent;
                filepath = __env._MHSRichardsonXmlPath_;
                filecontent = __env._MHSRichardsonXmlFile_.replace("@Accession", accession);
                fso = new ActiveXObject("Scripting.FileSystemObject");
                file = fso.CreateTextFile(filepath);
                file.WriteLine(filecontent);
                file.close();
            }
            catch (err) {
                toaster.warning({ body: err.message });
            }
        };

        /**
         * Helper function to open MedDream viewer
         */
        self.openMedDream = function (order, correlationId) {
            var obj = {
                OrderID: order.OrderID,
                PatientMRN: order.PatientMRN,
                SiteID: order.SiteID,
                Accession: order.Accession,
                UserID: $sessionStorage.currentUserData.userId,
                UserName: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
            };

            var _tokenStart = Date.now();
            WorklistService.GetMedDreamViewerToken(obj).then(function (response) {
                try {
                    var _CommonService = $injector.get('CommonService');
                    _CommonService.LogApplicationInfo({ LogDetails: '[' + correlationId + '] Step3b-MedDream: GetMedDreamViewerToken=' + (Date.now() - _tokenStart) + 'ms', Application: 'PACS-Viewer', UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '' });
                } catch (e) { }
                _medDreamLegacyWinName = "MedDreamViewer-" + order.Accession.toUpperCase().trim();
                _medDreamLegacyWin = windowHandler.openByPreference(
                    __env.CViewer.replace("@TOKENURL", response),
                    "MedDream",
                    100,
                    _medDreamLegacyWinName,
                    "",
                    false,
                    correlationId
                );
                return _medDreamLegacyWin;
            }, function (reason) {
                toaster.warning({ body: "Unable to get MedDream viewer token." });
            });
        };

        // Persisted across opens — allows replaceStudies and preloadStudies without reopening the window.
        //
        // _medDreamWin is held from the moment the popup is opened, not from when the viewer
        // reports COMMUNICATION_SERVICE_READY. The popup navigates cross-site (RadFlow origin
        // to the viewer origin), after which the browser no longer resolves it by name, so a
        // window.open('MedDreamViewer') while it exists spawns a second popup instead of
        // reusing it. Every launch therefore decides from this reference whether a window
        // already exists, whatever the state of the message channel.
        var _medDreamComm              = null;   // ViewerCommunication once READY has been received
        var _medDreamWin               = null;   // the viewer popup, channel ready or not
        var _medDreamBaseOrigin        = null;
        var _medDreamPendingComm       = null;   // ViewerCommunication still waiting for READY
        var _medDreamReadyTimer        = null;
        var _medDreamLaunchSeq         = 0;      // bumped per launch; in-flight requests check it

        // payload.baseURL comes from the server's MedDreamCommunicationAPIBaseURL app setting
        // (OrdersService.GetMedDreamCommunicationPayload) — never from request input — and is
        // the same single host in every environment config in this repo. Checked against this
        // allowlist, not just http(s) scheme, so a misconfigured or tampered response can only
        // ever navigate the browser to a known MedDream host.
        var _medDreamAllowedHosts = ['dv.civie.com'];

        // Legacy (non-Communication-API) viewer window, opened per accession.
        var _medDreamLegacyWin     = null;
        var _medDreamLegacyWinName = null;

        function _medDreamWindowExists() {
            return !!(_medDreamWin && !_medDreamWin.closed);
        }

        function _medDreamViewerIsOpen() {
            return _medDreamWindowExists() && !!_medDreamComm;
        }

        // Drop the connection state but keep the window reference: the popup is still on
        // screen, and the next launch has to navigate it rather than open another one.
        function _medDreamDropConnection() {
            if (_medDreamReadyTimer) {
                clearTimeout(_medDreamReadyTimer);
                _medDreamReadyTimer = null;
            }
            // destroy() can throw (e.g. the vendor client manipulating a reference to a
            // window that's already closed/cross-origin-severed). closeMedDreamViewer()
            // runs this on every $stateChangeSuccess, and an uncaught throw here would skip
            // the null-outs below, leaving stale state for the next open attempt.
            if (_medDreamPendingComm) {
                try { _medDreamPendingComm.destroy(); } catch (e) { console.error('Failed to destroy MedDream communication:', e); }
            }
            _medDreamPendingComm = null;
            if (_medDreamComm) {
                try { _medDreamComm.destroy(); } catch (e) { console.error('Failed to destroy MedDream communication:', e); }
            }
            _medDreamComm       = null;
            _medDreamBaseOrigin = null;
        }

        function _medDreamReset() {
            _medDreamDropConnection();
            _medDreamWin = null;
        }

        self.clearMedDreamViewer = function () {
            if (_medDreamViewerIsOpen()) {
                // Post directly to the stored window reference to avoid the library's
                // findWindowReference() calling window.open('','MedDreamViewer'), which
                // creates a blank tab when the named window can't be found by the browser.
                _medDreamWin.postMessage({actionType: 'CLOSE_ALL_STUDIES', actionData: {}}, _medDreamBaseOrigin || '*');
                // Keep _medDreamComm/_medDreamWin alive so the next study launch uses
                // replaceStudies (no new popup window). openByPreference uses a features
                // string which always spawns a new popup even when 'MedDreamViewer' exists.
            }
        };

        /**
         * Close the MedDream viewer window and tear down its connection.
         *
         * A viewer left open outlives the session that opened it, which leaves patient
         * images on screen after the user has navigated away or been logged out, and
         * leaves a stale window reference for the next launch to trip over.
         *
         * Closes through windowHandler.CloseWindow so the embedded desktop shell gets its
         * postMessage as well, then closes the held references directly: windowHandler
         * only registers a window ~100ms after opening it (list.push runs inside a
         * $timeout), so a viewer closed right after launch would otherwise be missed.
         */
        self.closeMedDreamViewer = function () {
            // Always closes unconditionally - the MedDreamViewerKeepOpen preference
            // only governs study-to-study transitions (see the call sites that choose
            // between clearMedDreamViewer and this function), never page navigation.
            // This function is also wired directly to $stateChangeSuccess/IdleTimeout/
            // beforeunload below, which fire on ANY navigation away from the page.
            var names = ['MedDreamViewer'];
            if (_medDreamLegacyWinName) { names.push(_medDreamLegacyWinName); }
            try { windowHandler.CloseWindow(names); } catch (e) { }

            [_medDreamWin, _medDreamLegacyWin].forEach(function (win) {
                if (win && !win.closed) {
                    try { win.close(); } catch (e) { }
                }
            });

            _medDreamLegacyWin     = null;
            _medDreamLegacyWinName = null;
            _medDreamReset();
        };

        // A viewer window must not outlive the page or the session that opened it.
        (function registerMedDreamTeardown() {
            var $rootScope = $injector.get('$rootScope');
            // Any navigation, including the change to Login that logout performs.
            $rootScope.$on('$stateChangeSuccess', function () { self.closeMedDreamViewer(); });
            // Hooked separately from logout: Logout() closes windows inside
            // DeleteOpenOrderByUserID().then(...) with no error callback, so a failed
            // request there would otherwise leave the viewer open after an idle timeout.
            $rootScope.$on('IdleTimeout', function () { self.closeMedDreamViewer(); });
            // Refresh, tab close, browser close.
            window.addEventListener('beforeunload', function () { self.closeMedDreamViewer(); });
        })();

        /**
         * Open a study in the MedDream viewer through the Communication API.
         *
         * Exactly one viewer popup is kept. Which launch mode runs is decided from the held
         * window reference, and only after the token and payload requests come back, because
         * the viewer state can change while they are in flight:
         *   - channel ready (COMMUNICATION_SERVICE_READY received): REPLACE_STUDIES_WITH_TOKEN
         *     into the existing window;
         *   - window open but channel not ready (still loading, handshake timed out, or the
         *     connection was dropped): navigate that same window to the new token URL and
         *     start a fresh handshake, so no second popup appears;
         *   - no window: open one through windowHandler and start the handshake.
         * A launch superseded by a newer one while its requests were in flight is abandoned,
         * so the study requested last is the one that ends up on screen.
         */
        self.openMedDreamCommunicationAPI = function (order, correlationId) {
            var obj = {
                OrderID:       order.OrderID,
                PatientMRN:    order.PatientMRN,
                SiteID:        order.SiteID,
                Accession:     order.Accession,
                UserID:        $sessionStorage.currentUserData.userId,
                UserName:      $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                Modality:      order.Modality || '',
                ProcedureDesc: order.ProcedureDesc || ''
            };
            var seq = ++_medDreamLaunchSeq;

            $q.all([
                WorklistService.GetMedDreamViewerToken(obj),
                WorklistService.GetMedDreamCommunicationPayload(obj)
            ]).then(function (results) {
                // A newer launch started while these requests were in flight; it owns the viewer now.
                if (seq !== _medDreamLaunchSeq) { return; }

                var payload = results[1];
                var jwtToken;
                try {
                    jwtToken = new URL(results[0]).searchParams.get('token') || results[0];
                } catch (e) {
                    jwtToken = results[0];
                }
                var baseOrigin;
                try {
                    var parsedBaseURL = new URL(payload.baseURL);
                    if (parsedBaseURL.protocol !== 'https:' && parsedBaseURL.protocol !== 'http:') {
                        throw new Error('Unsupported protocol');
                    }
                    if (_medDreamAllowedHosts.indexOf(parsedBaseURL.hostname) === -1) {
                        throw new Error('Untrusted host');
                    }
                    baseOrigin = parsedBaseURL.origin;
                } catch (e) {
                    toaster.warning({ body: 'MedDream viewer URL is invalid.' });
                    return;
                }
                if (_medDreamViewerIsOpen()) {
                    // All postMessages go directly to _medDreamWin to avoid the library's
                    // findWindowReference() calling window.open('','MedDreamViewer'), which
                    // creates a blank tab when the named-window lookup fails in the browser.
                    _medDreamWin.postMessage({actionType: 'REPLACE_STUDIES_WITH_TOKEN', actionData: {token: jwtToken}}, baseOrigin);
                    _medDreamWin.focus();
                    return;
                }

                var viewerURL = parsedBaseURL.href + '?token=' + jwtToken;
                var mode      = _medDreamWindowExists() ? 'navigate-existing-window' : 'new-window';

                try {
                    var _CommonService = $injector.get('CommonService');
                    _CommonService.LogApplicationInfo({
                        LogDetails:  '[' + correlationId + '] MedDreamCommAPI: opening accession=' + order.Accession + ' mode=' + mode,
                        Application: 'PACS-Viewer',
                        UserID:      $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : ''
                    });
                } catch (e) { }

                var medDreamWindow = _medDreamWindowExists() ? _medDreamNavigateExisting(viewerURL) : null;
                if (!medDreamWindow) {
                    _medDreamReset();
                    medDreamWindow = windowHandler.openByPreference(
                        viewerURL, 'MedDream', 100,
                        'MedDreamViewer',
                        '', false, correlationId
                    );
                    if (!medDreamWindow) {
                        toaster.warning({ body: 'Unable to open MedDream viewer. Please allow popups for this site.' });
                        return;
                    }
                }
                // Hold the window from now on, not from READY: a launch that arrives before the
                // handshake completes must see it and navigate it instead of opening another.
                _medDreamWin = medDreamWindow;

                _medDreamStartHandshake(medDreamWindow, parsedBaseURL.href, baseOrigin);

            }, function (err) {
                if (seq !== _medDreamLaunchSeq) { return; }
                // The viewer window and its connection are left as they are: reopening would
                // repeat the same failed requests and, with the popup still open, add a second one.
                toaster.warning({ body: 'Unable to open MedDream viewer.' });
            });
        };

        /**
         * Point the existing viewer popup at a new token URL when the message channel is not
         * ready. Navigating a cross-origin window through a held reference is permitted (the
         * Location href setter is cross-origin accessible). The w_n/v_n parameters match what
         * windowHandler appends, so the RadFlow Connector extension keeps treating it as the
         * same viewer window. Returns the window, or null if it could not be navigated; it is
         * closed in that case so the caller can open a fresh one without leaving two behind.
         */
        function _medDreamNavigateExisting(viewerURL) {
            var win = _medDreamWin;
            _medDreamDropConnection();
            try {
                win.location.href = viewerURL + '&w_n=MedDreamViewer&v_n=MedDream&v=1';
            } catch (e) {
                try { win.close(); } catch (e2) { }
                return null;
            }
            try { win.focus(); } catch (e) { }
            return win;
        }

        /**
         * Start the COMMUNICATION_SERVICE_READY handshake for a freshly loaded viewer window.
         *
         * READY only means the message channel is up. If it never arrives the pending
         * connection is discarded but the window reference is kept: the popup is still open,
         * and the next launch navigates it rather than opening another.
         *
         * baseURL must already be the http(s)-validated, re-serialized `new URL(...).href` form
         * (see the parsedBaseURL check in openMedDreamCommunicationAPI): it is handed to the
         * vendor MedDream SDK, which uses it in window.open/iframe.src without validating it.
         */
        function _medDreamStartHandshake(win, baseURL, baseOrigin) {
            var viewerCommunication = new ViewerCommunication(baseURL, 'token', false);
            _medDreamPendingComm = viewerCommunication;

            _medDreamReadyTimer = setTimeout(function () {
                if (_medDreamPendingComm === viewerCommunication) {
                    _medDreamPendingComm = null;
                    _medDreamReadyTimer  = null;
                }
                viewerCommunication.destroy();
            }, 30000);

            viewerCommunication.subscribeCommunicationServiceReadyEvent(function () {
                viewerCommunication.unsubscribeCommunicationServiceReadyEvent();
                // A later launch has re-pointed or replaced this window; it owns the connection.
                if (_medDreamPendingComm !== viewerCommunication || _medDreamWin !== win) {
                    viewerCommunication.destroy();
                    return;
                }
                clearTimeout(_medDreamReadyTimer);
                _medDreamReadyTimer  = null;
                _medDreamPendingComm = null;
                // Store connection — enables replaceStudies and preloadStudies for subsequent opens.
                _medDreamComm       = viewerCommunication;
                _medDreamBaseOrigin = baseOrigin;
            });
        }

        /**
         * Preload a study into the already-open MedDream viewer without displaying it.
         * Call this after openMedDreamCommunicationAPI with the next worklist order
         * so it is cached before the radiologist navigates to it.
         */
        self.preloadMedDreamStudy = function (order) {
            if (!_medDreamViewerIsOpen()) {
                return;
            }
            var obj = {
                OrderID:       order.OrderID,
                PatientMRN:    order.PatientMRN,
                SiteID:        order.SiteID,
                Accession:     order.Accession,
                UserID:        $sessionStorage.currentUserData.userId,
                UserName:      $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                Modality:      order.Modality || '',
                ProcedureDesc: order.ProcedureDesc || ''
            };
            WorklistService.GetMedDreamViewerToken(obj).then(function (tokenUrl) {
                var jwtToken;
                try { jwtToken = new URL(tokenUrl).searchParams.get('token') || tokenUrl; } catch (e) { jwtToken = tokenUrl; }
                _medDreamComm.preloadStudies(jwtToken, false);
            }, function (err) {
            });
        };

        /**
         * Function to open VR (Voice Recognition) system
         * @param {Object} order - Order object containing study information
         * @param {boolean} isSingleView - Whether to open in single view mode
         */
        self.OpenVR = function (order, isSingleView, correlationId) {
            try {
                var _CommonService = $injector.get('CommonService');
                _CommonService.LogApplicationInfo({ LogDetails: '[' + correlationId + '] Step3-SharedService-CIVR: OpenVR called', Application: 'PACS-Viewer', UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '' });
            } catch (e) { }
            var paramObj = {
                cmd: 'civrObject',
                data: {
                    currentUserData: $sessionStorage.currentUserData,
                    SelectedOrder: self.cleanCIVRparamObj(order)
                },
                callbackStatus: "VRStatus",
                isSingleView: isSingleView,
                correlationId: correlationId,
            };

            if (windowHandler && windowHandler.openCIVR) {
                windowHandler.openCIVR(paramObj, null, function () {
                    toaster.warning({ body: "Unable to open CIVR. Please allow pop-ups for this site and try again." });
                });
            } else {
                toaster.warning({ body: "Unable to open VR system - windowHandler not available." });
            }
        };

        /**
         * Helper function to clean CIVR parameter object
         * @param {Object} order - Order object to clean
         * @returns {Object} - Cleaned order object
         */
        self.cleanCIVRparamObj = function (order) {
            var obj = _.cloneDeep(order);
            
            // Remove properties that shouldn't be passed to CIVR
            var propsToRemove = [
                'listOrderListAssignment',
                'subGridOptions', 
                'OrderReport'
            ];
            
            _.forEach(propsToRemove, function (prop) {
                if (obj.hasOwnProperty(prop)) {
                    delete obj[prop];
                }
            });
            
            return obj;
        };

        /**
         * Handle notification to remove order from clipboard
         * @param {Object} data - Event data containing RuleID and OrderID
         * @param {Object} RuleTable - Rule table data object
         * @returns {Promise} - Promise resolving when operation completes
         */
        self.handleRemoveFromClipboard = function (data, RuleTable) {
            var Rule = { RuleID: data.RuleID };
            RuleSharedService.UpdateRuleTable(RuleTable);
            
            return RuleSharedService.GetRuleDetails(Rule, "Clipboard").then(function (result) {
                if (result.Rule) {
                    Rule = result.Rule;
                    return self.removeOrderIDFromClipboard(Rule, data.OrderID, RuleTable);
                }
            });
        };

        /**
         * Generate tooltip text for order list based on assignments
         * @param {Object} Order - Order object containing assignment information
         * @returns {string} - Tooltip text for the order
         */
        self.getOrderListTooltip = function (Order) {
            var orderDiscussionTooltip = '';
            var groupName = '';
            var userName = '';
            var allSpeciality = _.uniqBy(_.map(Order.listOrderListAssignment, function (row) {
                return {
                    ProviderSpecialityId: row.ProviderSpecialityId,
                    IsUserWithSpecialityGroup: row.IsUserWithSpecialityGroup,
                    SpecialityCode: row.SpecialityCode
                }
            }), 'ProviderSpecialityId');
            var allUsers = _.map(Order.listOrderListAssignment, function (row) {
                return {
                    OrderAssingedUserID: row.OrderAssingedUserID,
                    OrderAssingedUserName: row.OrderAssingedUserName,
                }
            });
            var specialities = [];
            var users = []
            _.each(Order.listOrderListAssignment, function (orderAssignment) {
                if (orderAssignment.ProviderSpecialityId > 0) {
                    var speciality = _.find(allSpeciality, { ProviderSpecialityId: orderAssignment.ProviderSpecialityId });
                    if (speciality) {
                        specialities.push(speciality);
                    }
                } else {
                    var specialityUser = _.find(allUsers, { OrderAssingedUserID: orderAssignment.OrderAssingedUserID });
                    if (specialityUser) {
                        users.push(specialityUser);
                    }
                }
            });

            var uniquespecialities = _.uniqBy(specialities, 'ProviderSpecialityId');

            var uniquespecialityusers = _.uniqBy(users, 'OrderAssingedUserID');


            groupName = _.join(_.map(uniquespecialities, function (speciality) { return speciality.SpecialityCode; }), ',');

            userName = _.join(_.map(uniquespecialityusers, function (_user) { return _user.OrderAssingedUserName; }), ',');

            if (uniquespecialities.length == 0 && uniquespecialityusers.length == 0) {
                orderDiscussionTooltip = '';
                if (Order.isCollapsed) {
                    orderDiscussionTooltip = 'Hide Comparison';
                } else {
                    orderDiscussionTooltip = 'Show Comparison';
                }
                return orderDiscussionTooltip;
            } else {
                var message = '';
                var groupMessage = '';
                var userMessage = '';
                groupMessage += uniquespecialities.length > 1 ? uniquespecialities.length + ' Groups' : uniquespecialities.length == 1 ? groupName : '';
                userMessage += uniquespecialityusers.length > 1 ? uniquespecialityusers.length + ' Others' : uniquespecialityusers.length == 1 ? userName : '';
                if (groupMessage.length > 0 && userMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage + ' and ' + userMessage;
                } else if (groupMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage;
                } else if (userMessage.length > 0) {
                    message = 'Assigned to ' + userMessage;
                }
                return message;
            }
        };

        /**
         * Remove specific order ID from clipboard rule
         * @param {Object} Rule - Rule object containing clipboard data
         * @param {string} OrderID - Order ID to remove
         * @param {Object} RuleTable - Rule table data object
         * @returns {Promise} - Promise resolving when operation completes
         */
        self.removeOrderIDFromClipboard = function (Rule, OrderID, RuleTable) {
            var RuleConditionOrderID = {};
            
            if (Rule.Groups && Rule.Groups.length > 0) {
                _.each(Rule.Groups, function (grp) {
                    RuleConditionOrderID = _.find(grp.RulesConditions, { ColumnName: "ORDERS.OrderID" });
                });
                
                if (RuleConditionOrderID && RuleConditionOrderID.Value) {
                    var OrderIDs = RuleConditionOrderID.Value.split(',');
                    var removedOrderIDs = _.remove(OrderIDs, function (orderid) { return orderid == OrderID });
                    
                    if (removedOrderIDs.length > 0) {
                        if (OrderIDs.length > 0) {
                            RuleConditionOrderID.Value = _.join(OrderIDs, ',');
                            RuleConditionOrderID.StatusFlag = 'M';
                        }
                        else {
                            RuleConditionOrderID.Value = "";
                            RuleConditionOrderID.StatusFlag = 'D';
                        }
                        
                        _.each(Rule.Groups, function (grp) {
                            _.each(grp.RulesConditions, function (condition) {
                                if (condition.ColumnName == "ORDERS.OrderID") {
                                    condition = RuleConditionOrderID;
                                }
                                else {
                                    condition.StatusFlag = RuleConditionOrderID.StatusFlag;
                                    if (condition.StatusFlag == 'D' && condition.ColumnName == "ORDERS.OrderDate") {
                                        condition.OrderDate = {
                                            startDate: null,
                                            endDate: null
                                        };
                                        condition.Value = "";
                                    }
                                }
                            });
                            grp.GroupOperator = "AND";
                        });
                        
                        return RuleSharedService.SetRule(Rule).then(function (response) {
                            RuleSharedService.RemoveOrderIDFromRuleTable(RuleTable);
                            return response;
                        });
                    }
                }
            }
        };

        /**
         * Get DICOM viewer display text by value
         * @param {string} DV - DICOM viewer value
         * @param {Array} DicomViewers - Array of DICOM viewer objects with Key and Value properties
         * @returns {string} - Display text for the DICOM viewer
         */
        self.SetDicomViewerText = function (DV, DicomViewers) {
            var viewer = _.filter(DicomViewers, { "Value": DV });
            if (viewer != null && viewer.length > 0) {
                return viewer[0].Key;
            }
        };

        /**
         * Handle window message events for viewer operations
         * @param {Object} event - Window message event object
         * @param {Object} scope - Controller scope (for accessing scope variables like konica_Redirect)
         * @param {Object} windowHandler - Window handler service for closing windows
         */
        self.handleWindowMessage = function (event, scope) {
            var d = event.data;
            if (d.cmd === 'redirectClose') {
                if (scope && scope.konica_Redirect) {
                    scope.konica_Redirect.close();
                }
            }
            if (d.cmd === 'radflowObject') {
                if (d.data.SelectedOrder) {
                    var windowNames = [
                        "CI-VIEWER-1-" + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        "CI-VIEWER-2-" + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        'KONICA-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        'KONICATEST-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        'MedDreamViewer-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                        'NORTHSTARKONICA-' + d.data.SelectedOrder.Accession.toUpperCase().trim()
                    ];
                    windowHandler.CloseWindow(windowNames);
                    if ($sessionStorage.MedDreamViewerKeepOpen) {
                        // Preference is to keep the viewer open: clear the current study but
                        // leave the window/connection alive so the next study reuses it.
                        self.clearMedDreamViewer();
                    } else {
                        // Preference is to close after each study.
                        self.closeMedDreamViewer();
                    }
                    self.DeleteOpenOrder(d.data.SelectedOrder);
                }
            }
        };

        /**
         * Delete open order from the system
         * @param {Object} Order - Order object containing OrderID
         */
        self.DeleteOpenOrder = function (Order) {
            var lastOrder;

            if (Order) {
                lastOrder = Order;
            }
            if (lastOrder) {
                var openOrders = {
                    OrderId: Order.OrderID,
                    UserId: $sessionStorage.currentUserData.userId
                };
                WorklistService.DeleteOpenOrder(openOrders).then(function () {
                    // Order deleted successfully
                });
            }
        };

        self.mapPriorityToCollection= function(data, isRule) {
            return _.map(_.filter(data, function (priority) { return priority.Key != "All"; }), function (data) {
                var key = 0;
                switch (data.Key) {
                    case 'Routine':
                        key = 0;
                        break;
                    case 'DelayedSTAT':
                        key = 1;
                        break;
                    case 'STAT':
                        key = 2;
                        break;
                    case 'URGENT':
                        key = 3;
                        break;
                }
                if (isRule) {
                    return { Value: data.Value, ID: key };
                } else {
                    return { Priority: data.Value, Key: key };
                }
            });
        };

        /**
         * Save ordering physician
         * @param {Object} physicianData - Physician data object
         * @param {Array} siteTenantList - List of selected site tenant objects
         * @returns {Promise} - Promise resolving with result object containing success status and action needed
         */
        self.saveOrderingPhysician = function (physicianData, siteTenantList) {
            var providerObject = _.clone(physicianData);
            providerObject.CreatedBy = $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : null;
            if (physicianData.StatusFlag != 'D') {
                providerObject.SiteIDs = _.map(siteTenantList, function (item) {
                    return { ID: item.SiteID };
                });
                providerObject.SiteID = (providerObject.SelectedSite) ? providerObject.SelectedSite.SiteID : null;
            }
            return MappingService.SetProviders(providerObject).then(function (result) {
                var response = {
                    success: false,
                    shouldClearModal: false,
                    shouldRefreshList: false
                };

                if (result && result.length > 0) {
                    if (result[0].IsExists) {
                        toaster.warning("Ordering physician already exists.");
                        return response;
                    }
                }

                switch (providerObject.StatusFlag) {
                    case 'N':
                        toaster.success("Ordering physician added successfully.");
                        response.success = true;
                        response.shouldClearModal = true;
                        response.shouldRefreshList = true;
                        break;
                    case 'M':
                        toaster.success("Ordering physician updated successfully.");
                        response.success = true;
                        response.shouldClearModal = true;
                        response.shouldRefreshList = true;
                        break;
                    case 'D':
                        toaster.success("Ordering physician deleted successfully.");
                        response.success = true;
                        response.shouldRefreshList = true;
                        break;
                }

                return response;
            });
        };

        /**
         * Get changed fields by comparing original and current user settings and optionally log events
         * @param {Object} originalSettings - Original user settings object
         * @param {Object} currentSettings - Current user settings object
         * @param {Array} dicomObject - Current DICOM viewer credentials array
         * @param {string} fromUserID - (Optional) User ID who made the changes - if provided, events will be logged
         * @param {string} toUserID - (Optional) User ID whose settings were changed - if provided, events will be logged
         * @returns {Promise} - Promise resolving with array of changed field objects with field, oldValue, and newValue properties
         */
        self.getChangedFields = function (originalSettings, currentSettings, dicomObject, fromUserID, toUserID) {
            if (!originalSettings || !currentSettings) {
                return $q.when([]);
            }

            var changedFields = [];
            
            // Compare ShowPracticeWorklist
            if (originalSettings.ShowPracticeWorklist !== currentSettings.ShowPracticeWorklist) {
                changedFields.push({
                    field: 'Show Practice Worklist',
                    oldValue: originalSettings.ShowPracticeWorklist,
                    newValue: currentSettings.ShowPracticeWorklist
                });
            }

            // Compare DoNotSendPaymentSummary
            if (originalSettings.DoNotSendPaymentSummary !== currentSettings.DoNotSendPaymentSummary) {
                changedFields.push({
                    field: 'Do Not Send Payment Summary',
                    oldValue: originalSettings.DoNotSendPaymentSummary,
                    newValue: currentSettings.DoNotSendPaymentSummary
                });
            }

            // Compare EnableTwoFactorAuthentication
            if (originalSettings.EnableTwoFactorAuthentication !== currentSettings.EnableTwoFactorAuthentication) {
                changedFields.push({
                    field: 'Enable Two-Factor Authentication',
                    oldValue: originalSettings.EnableTwoFactorAuthentication,
                    newValue: currentSettings.EnableTwoFactorAuthentication
                });
            }

            // Compare DicomViewerCred
            var oldDicomCred = originalSettings.DicomViewerCred || [];
            if (!_.isEqual(oldDicomCred, dicomObject || [])) {
                changedFields.push({
                    field: 'Dicom Viewer Credentials',
                    oldValue: oldDicomCred,
                    newValue: dicomObject || []
                });
            }

            // Compare IsReviewer
            if (originalSettings.IsReviewer !== currentSettings.IsReviewer) {
                changedFields.push({
                    field: 'Is Reviewer',
                    oldValue: originalSettings.IsReviewer,
                    newValue: currentSettings.IsReviewer
                });
            }

            // Compare TargetRVU
            if (originalSettings.TargetRVU !== currentSettings.TargetRVU) {
                changedFields.push({
                    field: 'Target RVU',
                    oldValue: originalSettings.TargetRVU,
                    newValue: currentSettings.TargetRVU
                });
            }

            // Compare Modalities
            var originalModalities = originalSettings.Modalities || [];
            var currentModalities = currentSettings.Modalities || [];
            if (!_.isEqual(_.sortBy(originalModalities), _.sortBy(currentModalities))) {
                changedFields.push({
                    field: 'Modalities',
                    oldValue: originalModalities,
                    newValue: currentModalities
                });
            }

            // Compare SpecialityIds
            var originalSpecialityIds = originalSettings.SpecialityIds || [];
            var currentSpecialityIds = currentSettings.SpecialityIds || [];
            if (!_.isEqual(_.sortBy(originalSpecialityIds), _.sortBy(currentSpecialityIds))) {
                changedFields.push({
                    field: 'Speciality',
                    oldValue: originalSpecialityIds,
                    newValue: currentSpecialityIds
                });
            }

            // Compare ExcludedSpecialityIds
            var originalExcludedSpecialityIds = originalSettings.ExcludedSpecialityIds || [];
            var currentExcludedSpecialityIds = currentSettings.ExcludedSpecialityIds || [];
            if (!_.isEqual(_.sortBy(originalExcludedSpecialityIds), _.sortBy(currentExcludedSpecialityIds))) {
                changedFields.push({
                    field: 'Excluded Speciality',
                    oldValue: originalExcludedSpecialityIds,
                    newValue: currentExcludedSpecialityIds
                });
            }

            // Compare TenantIDs
            var originalTenantIDs = originalSettings.TenantIDs || [];
            var currentTenantIDs = currentSettings.TenantIDs || [];
            if (!_.isEqual(_.sortBy(originalTenantIDs), _.sortBy(currentTenantIDs))) {
                changedFields.push({
                    field: 'Tenant',
                    oldValue: originalTenantIDs,
                    newValue: currentTenantIDs
                });
            }

            // Compare SiteIDs
            var originalSiteIDs = originalSettings.SiteIDs || [];
            var currentSiteIDs = currentSettings.SiteIDs || [];
            if (!_.isEqual(_.sortBy(originalSiteIDs), _.sortBy(currentSiteIDs))) {
                changedFields.push({
                    field: 'Site',
                    oldValue: originalSiteIDs,
                    newValue: currentSiteIDs
                });
            }

            // Return changed fields as resolved promise
            return $q.when(changedFields);
        };

        /**
         * Log user event changes for updated fields by comparing original and current settings
         * @param {Object} originalSettings - Original user settings object
         * @param {Object} currentSettings - Current user settings object
         * @param {Array} dicomObject - Current DICOM viewer credentials array
         * @param {string} fromUserID - User ID who made the changes
         * @param {string} toUserID - User ID whose settings were changed
         * @param {Function} message - Event message
         * @returns {Promise} - Promise resolving with array of changed fields when event logging completes
         */
        self.logUserEventChanges = function (originalSettings, currentSettings, dicomObject, fromUserID, toUserID, message) {
            
            self.getChangedFields(originalSettings, currentSettings, dicomObject).then(function (changedFields) {
                if (!changedFields || changedFields.length === 0) {
                    return; 
                }

                var AccountManagerService = $injector.get('AccountManagerService');
                var UserEventLog = [];
                
                _.each(changedFields, function (change) {
                    UserEventLog.push({
                        FromUserID: fromUserID,
                        ToUserID: toUserID,
                        EventName: message + " " + change.field.toUpperCase(),
                    });
                });

                // Log the events and return changed fields
                AccountManagerService.AddUserEvent(UserEventLog);
            });
        };
    }
})();


angular.module('BlurAdmin.theme')
    .service('windowHandler', ['Restangular', '$localStorage', '$timeout', '$interval', 'APP_CONSTANTS', '$sessionStorage', 'CommonService', function (Restangular, $localStorage, $timeout, $interval, APP_CONSTANTS, $sessionStorage, CommonService) {
        var displayController = {
            getDisplayPropsV2: function (refresh, callback) {
                var displayProps = {},
                    defaultProps = {
                        DISPLAY1: {
                            0: "0",
                            1: "0",
                            2: window.screen.availWidth,
                            3: window.screen.availHeight,
                            left: "0",
                            top: "0",
                            width: window.screen.availWidth,
                            height: window.screen.availHeight,
                            originalWidth: window.screen.width,
                            originalHeight: window.screen.height,
                            count: 1
                        }
                    };
                if (refresh) {
                    monitorSdk.getMonitors(function (monitors, isChWithExtn) {
                        if (0 == monitors.length) displayProps = defaultProps;
                        else
                            for (var i = 0; i < monitors.length; i++) {
                                var originalWidth = monitors[i].width,
                                    originalHeight = monitors[i].height;
                                monitors[i].originalWeight && (originalWidth = monitors[i].originalWeight), monitors[i].originalHeight && (originalHeight = monitors[i].originalHeight), displayProps["DISPLAY" + (i + 1)] = {
                                    0: monitors[i].xpoint,
                                    1: monitors[i].ypoint,
                                    2: monitors[i].width,
                                    3: monitors[i].height,
                                    left: monitors[i].xpoint,
                                    top: monitors[i].ypoint,
                                    width: monitors[i].width,
                                    height: monitors[i].height,
                                    originalWidth: originalWidth,
                                    originalHeight: originalHeight,
                                    count: monitors.length
                                }
                            }
                        displayProps = monitorSdk.reorderDisplay(displayProps, true),
                            window.localStorage.setItem("EMD_PACS_DISPLAY", JSON.stringify(displayProps)), callback && callback(displayProps)
                    })
                } else {
                    displayProps = JSON.parse(window.localStorage.getItem("EMD_PACS_DISPLAY", defaultProps));
                    displayProps = monitorSdk.reorderDisplay(displayProps)
                }
            },
        },
            monitorSdk = {
                result: [],
                displays: [],
                displayDuration: 3e3,
                Monitor: {
                    Up: {},
                    Down: {},
                    Left: {},
                    Right: {}
                },
                isChromeBrowser: function () {
                    var isChromium = window.chrome,
                        vendorName = window.navigator.vendor;
                    return null !== isChromium && void 0 !== isChromium && "Google Inc." === vendorName
                },
                msgResHandler: function (callback, hasExtension) {
                    var funcHandler = function (event) {
                        if (event.data.type == "monitors") {
                            var data = event.data.data;
                            monitorSdk.result = [];
                            for (var d = 0; d < data.length; d++) monitorSdk.result.push({
                                xpoint: data[d].left,
                                ypoint: data[d].top,
                                width: data[d].width,
                                height: data[d].height,
                                originalWeight: data[d].owidth,
                                originalHeight: data[d].oheight
                            });
                            if (monitorSdk.result.length > 0) {
                                window.removeEventListener("message", funcHandler);
                                callback(monitorSdk.result, hasExtension);
                            }
                        }
                    };
                    return funcHandler
                },
                getMonitors: function (callback) {
                    if (monitorSdk.isChromeBrowser()) {
                        window.addEventListener("message", monitorSdk.msgResHandler(callback, true));
                        window.parent.postMessage({ type: "FROM_RADFLOW", action: "getdisplay" }, "*");
                    }
                    else {
                        var xpoint = window.screen.availLeft,
                            ypoint = window.screen.availTop,
                            width = window.screen.availWidth,
                            height = window.screen.availHeight;
                        monitorSdk.result = [];
                        var xpointLeft = xpoint,
                            ypointLeft = ypoint,
                            heightLeft = height,
                            widthLeft = width;
                        monitorSdk.displays.push({
                            xpoint: xpoint,
                            ypoint: ypoint,
                            width: width,
                            height: height
                        });
                        for (var leftWindowObj = monitorSdk.findLeftWindow(xpointLeft, ypointLeft, heightLeft, widthLeft); leftWindowObj.success;) {
                            monitorSdk.displays.push({
                                xpoint: leftWindowObj.windowDetails.xpoint,
                                ypoint: leftWindowObj.windowDetails.ypoint,
                                width: leftWindowObj.windowDetails.width,
                                height: leftWindowObj.windowDetails.height
                            }), xpointLeft = leftWindowObj.windowDetails.xpoint, ypointLeft = leftWindowObj.windowDetails.ypoint, heightLeft = leftWindowObj.windowDetails.height, widthLeft = leftWindowObj.windowDetails.width, leftWindowObj = monitorSdk.findLeftWindow(xpointLeft, ypointLeft, heightLeft, widthLeft);
                            for (var xpointUp = xpointLeft, ypointUp = ypointLeft, heightUp = heightLeft, widthUp = widthLeft, upWindowObj = monitorSdk.findUpWindow(xpointUp, ypointUp, heightUp, widthUp); upWindowObj.success;) monitorSdk.displays.push({
                                xpoint: upWindowObj.windowDetails.xpoint,
                                ypoint: upWindowObj.windowDetails.ypoint,
                                width: upWindowObj.windowDetails.width,
                                height: upWindowObj.windowDetails.height
                            }), xpointUp = upWindowObj.windowDetails.xpoint, ypointUp = upWindowObj.windowDetails.ypoint, heightUp = upWindowObj.windowDetails.height, widthUp = upWindowObj.windowDetails.width, upWindowObj = monitorSdk.findUpWindow(xpointUp, ypointUp, heightUp, widthUp);
                            for (var xpointDown = xpointLeft, ypointDown = ypointLeft, heightDown = heightLeft, widthDown = widthLeft, downWindowObj = monitorSdk.findDownWindow(xpointDown, ypointDown, heightDown, widthDown); downWindowObj.success;) monitorSdk.displays.push({
                                xpoint: downWindowObj.windowDetails.xpoint,
                                ypoint: downWindowObj.windowDetails.ypoint,
                                width: downWindowObj.windowDetails.width,
                                height: downWindowObj.windowDetails.height
                            }), xpointDown = downWindowObj.windowDetails.xpoint, ypointDown = downWindowObj.windowDetails.ypoint, heightDown = downWindowObj.windowDetails.height, widthDown = downWindowObj.windowDetails.width, downWindowObj = monitorSdk.findDownWindow(xpointDown, ypointDown, heightDown, widthDown)
                        }
                        for (var xpointRight = xpoint, ypointRight = ypoint, heightRight = height, widthRight = width, rightWindowObj = monitorSdk.findRightWindow(xpointRight, ypointRight, heightRight, widthRight); rightWindowObj.success;) {
                            for (monitorSdk.displays.push({
                                xpoint: rightWindowObj.windowDetails.xpoint,
                                ypoint: rightWindowObj.windowDetails.ypoint,
                                width: rightWindowObj.windowDetails.width,
                                height: rightWindowObj.windowDetails.height
                            }), xpointRight = rightWindowObj.windowDetails.xpoint, ypointRight = rightWindowObj.windowDetails.ypoint, heightRight = rightWindowObj.windowDetails.height, widthRight = rightWindowObj.windowDetails.width, rightWindowObj = monitorSdk.findRightWindow(xpointRight, ypointRight, heightRight, widthRight), xpointUp = xpointRight, ypointUp = ypointRight, heightUp = heightRight, widthUp = widthRight, upWindowObj = monitorSdk.findUpWindow(xpointUp, ypointUp, heightUp, widthUp); upWindowObj.success;) monitorSdk.displays.push({
                                xpoint: upWindowObj.windowDetails.xpoint,
                                ypoint: upWindowObj.windowDetails.ypoint,
                                width: upWindowObj.windowDetails.width,
                                height: upWindowObj.windowDetails.height
                            }), xpointUp = upWindowObj.windowDetails.xpoint, ypointUp = upWindowObj.windowDetails.ypoint, heightUp = upWindowObj.windowDetails.height, widthUp = upWindowObj.windowDetails.width, upWindowObj = monitorSdk.findUpWindow(xpointUp, ypointUp, heightUp, widthUp);
                            for (xpointDown = xpointRight, ypointDown = ypointRight, heightDown = heightRight, widthDown = widthRight, downWindowObj = monitorSdk.findDownWindow(xpointDown, ypointDown, heightDown, widthDown); downWindowObj.success;) monitorSdk.displays.push({
                                xpoint: downWindowObj.windowDetails.xpoint,
                                ypoint: downWindowObj.windowDetails.ypoint,
                                width: downWindowObj.windowDetails.width,
                                height: downWindowObj.windowDetails.height
                            }), xpointDown = downWindowObj.windowDetails.xpoint, ypointDown = downWindowObj.windowDetails.ypoint, heightDown = downWindowObj.windowDetails.height, widthDown = downWindowObj.windowDetails.width, downWindowObj = monitorSdk.findDownWindow(xpointDown, ypointDown, heightDown, widthDown)
                        }
                        for (xpointUp = xpoint, ypointUp = ypoint, heightUp = height, widthUp = width, upWindowObj = monitorSdk.findUpWindow(xpointUp, ypointUp, heightUp, widthUp); upWindowObj.success;) monitorSdk.displays.push({
                            xpoint: upWindowObj.windowDetails.xpoint,
                            ypoint: upWindowObj.windowDetails.ypoint,
                            width: upWindowObj.windowDetails.width,
                            height: upWindowObj.windowDetails.height
                        }), xpointUp = upWindowObj.windowDetails.xpoint, ypointUp = upWindowObj.windowDetails.ypoint, heightUp = upWindowObj.windowDetails.height, widthUp = upWindowObj.windowDetails.width, upWindowObj = monitorSdk.findUpWindow(xpointUp, ypointUp, heightUp, widthUp);
                        for (xpointDown = xpoint, ypointDown = ypoint, heightDown = height, widthDown = width, downWindowObj = monitorSdk.findDownWindow(xpointDown, ypointDown, heightDown, widthDown); downWindowObj.success;) monitorSdk.displays.push({
                            xpoint: downWindowObj.windowDetails.xpoint,
                            ypoint: downWindowObj.windowDetails.ypoint,
                            width: downWindowObj.windowDetails.width,
                            height: downWindowObj.windowDetails.height
                        }), xpointDown = downWindowObj.windowDetails.xpoint, ypointDown = downWindowObj.windowDetails.ypoint, heightDown = downWindowObj.windowDetails.height, widthDown = downWindowObj.windowDetails.width, downWindowObj = monitorSdk.findDownWindow(xpointDown, ypointDown, heightDown, widthDown);
                        if (0 != monitorSdk.displays.length) {
                            var downList = [],
                                upList = [];
                            for (i = 0; i < monitorSdk.displays.length; i++) monitorSdk.displays[i].ypoint >= 0 ? -1 == downList.indexOf(monitorSdk.displays[i].ypoint) && downList.push(monitorSdk.displays[i].ypoint) : -1 == upList.indexOf(monitorSdk.displays[i].ypoint) && upList.push(monitorSdk.displays[i].ypoint);
                            var resultOrdered = monitorSdk.orderList(downList, upList);
                            for (iteration = 0; iteration < resultOrdered.length; iteration++) {
                                var monitorList = [];
                                for (iteration2 = 0; iteration2 < monitorSdk.displays.length; iteration2++) monitorSdk.displays[iteration2].ypoint == resultOrdered[iteration] && monitorList.push(monitorSdk.displays[iteration2]);
                                for (monitorSdk.orderScreens(monitorList); monitorList.length > 0;) monitorList.pop()
                            }
                            for (; monitorSdk.displays.length > 0;) monitorSdk.displays.pop()
                        }
                        callback && callback(monitorSdk.result)
                    }
                },
                reorderDisplay: function (displayProps, setName) {
                    var monitorArr = [];
                    if (displayProps) {
                        for (var key in displayProps) monitorArr.push({
                            key: key,
                            displayProps: displayProps[key]
                        });
                        if (monitorArr = monitorArr.sort(function (a, b) {
                            return a.displayProps.left - b.displayProps.left
                        }), setName)
                            for (var i = 0; i < monitorArr.length; i++) monitorArr[i].displayProps.name = "DISPLAY" + (i + 1);
                        else {
                            displayProps = {};
                            for (var i = 0; i < monitorArr.length; i++) displayProps["DISPLAY" + (i + 1)] = monitorArr[i].displayProps
                        }
                    }
                    return displayProps
                }
            };
        var list = []

        var monitors = [];
        function loadDisplay() {
            displayController.getDisplayPropsV2(true, function (monitorsList) {
                monitors = [];
                for (i = 1; i <= monitorsList.DISPLAY1.count; i++) {
                    if (monitorsList['DISPLAY' + i]) {
                        monitors.push(monitorsList['DISPLAY' + i]);
                    }
                }
                //console.log(monitors);
                $localStorage.Monitors = monitors;
                _loadExtensonData()
            });
        }
        var callMessage = null;
        this.inIt = function () {
            list = [];
            monitors = [];
            try {
                var parser = new UAParser();
                var browser = parser.getBrowser().name;
                if (browser != null && browser.toUpperCase() != "IE") {
                    try {
                        loadDisplay();
                    } catch (ex) {
                        console.log(ex);
                    }
                }
            } catch (e) {
                console.log(ex);
            }
            if (!callMessage) {
                callMessage = function (event) {
                    var d = event.data;
                    if (d.cmd == 'CloseCIVR') {
                        if (d.data.SelectedOrder) {
                            var winObj = _.filter(list, function (o) { return o.winName == 'CIVR-' + d.data.SelectedOrder.Accession })[0];
                            if (winObj) {
                                if (winObj.win && !winObj.win.closed) {
                                    winObj.win.close();
                                } else {
                                    var args = { type: "FROM_RADFLOW", action: "close", winName: winName };
                                    window.parent.postMessage(args, "*");
                                }
                            }
                        }
                    }
                }
                window.addEventListener("message", callMessage);
            }
        }
        this.DisplayController = displayController;

        //var viewer = ["CI-VIEWER", "CIVR", "KONICA", "KONICATEST"]
        var displayPref = [
            {
                "viewer": "CI-VIEWER",
                "display": {
                    "0": 0,
                    "1": 0,
                    "2": 1920,
                    "3": 1040,
                    "left": 0,
                    "top": 0,
                    "width": 1920,
                    "height": 1040,
                    "originalWidth": 1920,
                    "originalHeight": 1080,
                    "count": 1,
                    "name": "DISPLAY1"
                },
                "top": 100,
                "left": 100,
                "width": 600,
                "height": 600
            },
        ]

        this.LoadPrefenece = function (pref) {
            displayPref = [];
            if (pref) {
                displayPref = pref;
            }
            _loadExtensonData()
        }

        this._openByPreference = function (url, viewer, timeout, features, preventReload, winName, pref, correlationId) {
            if (!winName) {
                winName = viewer;
            }
            
            var display = {
                left: parseInt(screen.width / 2),
                top: 0,
                width: parseInt(screen.width / 2),
                height: parseInt(screen.height),
            }
            if (pref) {
                display.left = parseInt(pref.left);
                display.top = parseInt(pref.top);
                display.width = parseInt(pref.width);
                display.height = parseInt(pref.height);
                display.isFullScreen = pref.isFullScreen;
                display.isFocused = pref.isFocused;
                pref.display = _.filter(monitors, function (o) { return o.name.toUpperCase().trim() == pref.displayName.toUpperCase().trim() })[0];
                if (pref.display) {
                    display.left = parseInt(pref.display.left + pref.left);
                    display.top = parseInt(pref.display.top + pref.top);
                }
            }

            var winObj = _.filter(list, function (o) { return o.winName.toUpperCase().trim() == winName.toUpperCase().trim() })[0];
            if (!winObj) {
                winObj = { viewer: viewer, winName: winName, w_n: winName, pref: pref, display: display }
                
            } else {
                if (winObj.win && winObj.win.closed == false) {
                    if (preventReload) {
                        return winObj.win;
                    }
                    display = undefined;
                }
            }
            if (url.indexOf('?') == -1) {
                url = url + '?';
            }
            url = url + "&w_n=" + winName + "&v_n=" + viewer + "&v=1"
            if (features.indexOf('noreferrer') != -1) {
                url = url + "&w_c=1&w_t=new";
            }
            if (display) {
                features = "menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=" + display.width + ",height=" + display.height + ",top=" + display.top + ",left=" + display.left + "," + features
            }
            else {
                features = "menubar=no,location=no,resizable=yes,scrollbars=yes,status=no," + features
            }
            // Block javascript:/vbscript: (and similar) URL schemes before opening a new window -
            // window.open() executes these in the new window's context if not filtered.
            if (/^\s*(javascript|vbscript):/i.test(url)) {
                console.error('windowHandler: refusing to open unsafe URL scheme');
                return null;
            }
            var _winOpenStart = Date.now();
            var radWindow = window.open(url, winName, features);
            var _winOpenElapsed = Date.now() - _winOpenStart;
            var _viewerWindowOpenTime = Date.now();
            var _step5Handler = function (e) {
                if (e.data && e.data.cmd === 'setPos' && e.data.accession) {
                    window.removeEventListener('message', _step5Handler);
                    try {
                        var userId = $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '';
                        CommonService.LogApplicationInfo({ LogDetails: '[' + correlationId + '] Step5-ViewerPageLoad: proxy-page-loaded=' + (Date.now() - _viewerWindowOpenTime) + 'ms redirect-delay=2000ms(fixed) viewer=' + viewer, Application: 'PACS-Viewer', UserID: userId });
                    } catch (e) { }
                }
            };
            window.addEventListener('message', _step5Handler);
            winObj.win = radWindow;
            if (display) {
                var args = {
                    type: "FROM_RADFLOW",
                    action: "setpos",
                    display: display,
                    winName: winObj.winName,
                };
                var _setposStart = Date.now();
                var postmessagetimeout = $timeout(function () {
                    try {
                        var userId = $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '';
                        CommonService.LogApplicationInfo({ LogDetails: '[' + correlationId + '] Step4-WindowHandler: window.open=' + _winOpenElapsed + 'ms setposTimeout=' + (Date.now() - _setposStart) + 'ms (configured=' + timeout + 'ms) viewer=' + viewer + ' winName=' + winName, Application: 'PACS-Viewer', UserID: userId });
                    } catch (e) { }
                    if (monitorSdk.isChromeBrowser()) {
                        window.parent.postMessage(args, "*");
                        postDicomViewerCredentials(viewer, winObj);
                    }

                    list.push(winObj);

                    $timeout.cancel(postmessagetimeout);
                    postmessagetimeout = null;
                }, timeout);
            }
            
            return winObj.win;
        }
        function postDicomViewerCredentials(viewer, winObj) {
            if ((viewer === 'KONICATEST'
                || viewer === 'NORTHSTARKONICA')) {
                var dvCredentials = {};
                var credentialsIndex = _.findIndex($sessionStorage.DicomViewerCredentials, { VWR: viewer });
                if (credentialsIndex != -1) {
                    dvCredentials = $sessionStorage.DicomViewerCredentials[credentialsIndex];
                }
                var args = {
                    type: "FROM_RADFLOW",
                    action: "getDicomViewerCredential",
                    DicomViewerCredentials: dvCredentials,
                    winName: winObj.winName,
                };
                window.parent.postMessage(args, "*");
            }
        }
        this.openByPreference = function (url, viewer, timeout, winName, features, preventReload, correlationId) {
            var pref = _.filter(displayPref, function (d) { return d.viewer.toUpperCase().trim() == viewer.toUpperCase().trim() })[0];
            return this._openByPreference(url, viewer, timeout, features, preventReload, winName, pref, correlationId);
        }
        this.CloseAllWindows = function () {
            var i = 0;
            for (i = 0; i <= list.length; i++) {
                var w = list[i];
                if (w && w.win && !w.win.closed) {
                    w.win.close();
                }
            }
            var args = { type: "FROM_RADFLOW", action: "closeall", };
            window.parent.postMessage(args, "*");
        }
        this.CloseWindow = function (arr) {
            _.each(arr, function (winName) {
                var winObj = _.find(list, function (o) { return o.winName == winName });
                if (winObj) {
                    if (winObj.win && !winObj.win.closed) {
                        winObj.win.close();
                    } else {
                        var args = { type: "FROM_RADFLOW", action: "close", winName: winName };
                        window.parent.postMessage(args, "*");
                    }
                }
            });
        }



        this.openCIVR = function (paramObj, onOpen, onError) {
            var _interval;
            var win = null;
            var reqCount = 0;
            function getResponse(event) {
                var d = event.data;
                if (d.cmd === paramObj.callbackStatus) {
                    if (d.data.Response) {
                        window.removeEventListener("message", getResponse);
                        $interval.cancel(_interval);
                        if (onOpen) {
                            onOpen(win);
                        }
                    }
                }
            }
            function VRWinIntervalCallBack() {
                reqCount++;
                if (win && !win.closed) {
                    win.postMessage(JSON.parse(JSON.stringify(paramObj)), "*");
                    return;
                }
                if (reqCount <= 10) {
                    return
                }
                $interval.cancel(_interval);
                window.removeEventListener("message", getResponse);
                if (onError) {
                    onError('unable to open!');
                }
            }
            window.addEventListener("message", getResponse);
            win = this.openByPreference(__env._environment.config.VRViewurl, "CIVR", 5000, paramObj.isSingleView ? 'CIVR-' + paramObj.data.SelectedOrder.Accession : null, "", true, paramObj.correlationId);
            _interval = $interval(VRWinIntervalCallBack, 1000);
        }

        function _loadExtensonData() {
            var dp = angular.copy(displayPref);
            var data = {};
            _.each(dp, function (pref) {
                var monitor = _.filter(monitors, function (o) { return o.name == pref.displayName })[0];
                if (monitor) {
                    pref.left = parseInt(monitor.left + pref.left);
                    pref.top = parseInt(monitor.top + pref.top);
                }
                data[pref.viewer] = pref;
            });
            if (data) {
                var args = {
                    type: "FROM_RADFLOW",
                    action: "setviewer",
                    displaySetting: data,
                };
                if (monitorSdk.isChromeBrowser()) {
                    window.parent.postMessage(args, "*");
                }
            }
        }
        this.DoNotCloseWindow = function (winList) {
            var i = 0;
            for (i = 0; i <= list.length; i++) {
                var w = list[i];
                var winindex = -1;
                if (w && w.winName) {
                    winindex = winList.indexOf(w.winName);
                }
                if (w && w.win && !w.win.closed && winindex == -1) {
                    w.win.close();
                }
            }
            var args = { type: "FROM_RADFLOW", action: "closeall", };
            window.parent.postMessage(args, "*");
        }
        this.inIt();
    }]);

(function () {
    'use strict';

    angular.module('radico.pages.account.list')
        .controller('AccountManagerListController', AccountManagerListController);


    function AccountManagerListController($q, $scope, $rootScope, AccountManagerService, ProfileService, NgTableParams, APP_CONSTANTS, $sessionStorage, ManageLocationService, UserPreferenceService, toaster, TechnoService, $compile, $timeout, $filter, CommonService, __env, SharedService, $state) {

        var vm = this;
        var data = [];
        var ShowPracticeWorklistPref = null;
        var DoNotSendPaymentSummaryPref = null;
        var EnableTwoFactorAuthenticationPref = null;
        var MedDreamViewerKeepOpenPref = null;
        var DicomViewerFullList = [];
        var DicomViewerCred = null;
        var OriginalUserSettings = null; // Store original user settings for comparison
        $scope.RolesList = [];
        vm.isLoading = false;
        $scope.LocSelected = { Sites: [] };
        $scope.SelectedTenant = { Obj: [] };
        $scope.isLoading = true;
        $scope.ShowHideHelperDropdownFlag = false;
        $scope.ModalitiesFullList = [];
        $scope.SelectedModality = { Obj: null };
        $scope.DataObject = {
            ShowPracticeWorklist: true,
            isPSWCheckboxDisableInviteUser: true,
            isPSWCheckboxDisableUserSettings: true,
            InstDicomViewerList: [],
            SelectedViewer: null,
            DVCredUsername: null,
            DVCredPassword: null,
            SaveUserSettingFlag: false,
            ShowPaymentContractDetail: false,
            isResetPwdMenuVisible: false,
            DoNotSendPaymentSummary: false,
            SaveNext: false,
            EnableTwoFactorAuthentication: false,
            MedDreamViewerKeepOpen: true,
            PasswordRequirements: __env && __env.PasswordRequirements ? __env.PasswordRequirements.rules : [],
        };
        $scope.NewUser = {};
        $scope.MultiSelectDropdowns = {
            editUserRole: {
                divId: "editUserRole",
                keys: ['Name'],
                uniqKey: 'Id',
                placeHolder: "Select Role",
                SelectedValue: { list: [] },
                onSelectedRole: function (selectedData) {
                    if ($scope.selectedRow) {
                        $scope.selectedRow.Roles = selectedData;
                        $scope.selectedRow.UserRoleExists = _.find($scope.selectedRow.Roles, { Name: 'User' }) ? true : false;
                    }
                }
            },
            SpecialtyUserSettings: {
                divId: "SpecialtyUserSettings",
                keys: ['SpecialityCode'],
                uniqKey: 'SpecialityId',
                placeHolder: "Select Specialty",
                SelectedValue: { list: [] },
                onSelectedSpecialty: function (selectedData) {
                    $scope.SpecialityId.Obj = selectedData;
                    recomputeSpecialityLists();
                }
            },
            ExcludedSpecialtyUserSettings: {
                divId: "ExcludedSpecialtyUserSettings",
                keys: ['SpecialityCode'],
                uniqKey: 'SpecialityId',
                placeHolder: "Select Excluded Specialty",
                SelectedValue: { list: [] },
                onSelectedExcludedSpecialty: function (selectedData) {
                    $scope.ExcludedSpecialityId.Obj = selectedData;
                    recomputeSpecialityLists();
                }
            },
            TenantUserSettings: {
                divId: "TenantUserSettings",
                keys: ['DisplayName'],
                uniqKey: 'TenantID',
                placeHolder: "Select Tenant",
                SelectedValue: { list: [] },
                onSelectedTenant: function (selectedData) {
                    $scope.SelectedTenant.Obj = selectedData;
                    if (selectedData.length == 0) {
                        $scope.LocSelected.Sites = [];
                        $scope.MultiSelectDropdowns.SiteUserSettings.SelectedValue = { list: [] };
                    }
                    $scope.TenantSiteListMap($scope.SelectedTenant.Obj);

                }
            },
            SiteUserSettings: {
                divId: "SiteUserSettings",
                keys: ['Site'],
                uniqKey: 'SiteID',
                placeHolder: "Select Site",
                SelectedValue: { list: [] },
                onSelectedSite: function (selectedData) {
                    $scope.LocSelected.Sites = selectedData;
                }
            },
            RoleInviteUser: {
                divId: "RoleInviteUser",
                keys: ['Name'],
                uniqKey: 'Id',
                placeHolder: "Select Role",
                SelectedValue: { list: [] },
                onSelectedRole: function (selectedData) {
                    if (selectedData) {
                        var idx = _.findIndex(selectedData, { Name: 'User' });
                        if (idx != -1) {
                            $scope.DataObject.isPSWCheckboxDisableInviteUser = false;
                        } else {
                            $scope.DataObject.isPSWCheckboxDisableInviteUser = true;
                        }
                    } else {
                        $scope.DataObject.isPSWCheckboxDisableInviteUser = true;
                    }
                    $scope.NewUser.RoleName = selectedData;
                }
            },
            TenantInviteUser: {
                divId: "TenantInviteUser",
                keys: ['DisplayName'],
                uniqKey: 'TenantID',
                placeHolder: "Select Tenant",
                SelectedValue: { list: [] },
                onSelectedTenant: function (selectedData) {
                    $scope.SelectedTenant.Obj = selectedData;
                    if (!selectedData || selectedData.length == 0) {
                        $scope.SitesByTenants = [];
                        $scope.NewUser.Sites = [];
                    }
                    $scope.TenantSiteList($scope.SelectedTenant.Obj);
                }
            },
            SiteInviteUser: {
                divId: "SiteInviteUser",
                keys: ['Site'],
                uniqKey: 'SiteID',
                placeHolder: "Select Site",
                SelectedValue: { list: [] },
                onSelectedSite: function (selectedData) {
                    $scope.NewUser.Sites = selectedData;
                    if (!selectedData || selectedData.length == 0) {
                        $scope.NewUser.Sites = [];
                    }
                }
            },
            TenantBulkInvite: {
                divId: "TenantBulkInvite",
                keys: ['DisplayName'],
                uniqKey: 'TenantID',
                placeHolder: "Select Tenant",
                SelectedValue: { list: [] },
                onSelectedTenant: function (selectedData) {
                    $scope.SelectedTenantBulk.Obj = selectedData;
                    $scope.TenantSiteList($scope.SelectedTenantBulk.Obj);
                }
            },
            SiteBulkInvite: {
                divId: "SiteBulkInvite",
                keys: ['Site'],
                uniqKey: 'SiteID',
                placeHolder: "Select Site",
                SelectedValue: { list: [] },
                onSelectedSite: function (selectedData) {
                    vm.Sites = selectedData
                }
            },
        }
        clear();
        var accountlistCtrlinit = function () {
            CommonService.startNotifyTATStudy();
            GetModality();
            GetAllRoles();
            // Profile route reuses this controller but does not need the tenant user grid.
            // GetTenantsUserList is Admin/SuperAdmin-only (PenTest); calling it breaks non-admin Profile.
            if ($state.current.name !== 'profile') {
                getUsers();
            } else {
                vm.isLoading = false;
                $scope.isLoading = false;
            }
            getSpeciality();
            $scope.CountryCodes = CommonService.GetCountryCode();
        }

        function checkPassword(str) {
            var regularExpression = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{12,64}$/;
            return regularExpression.test(str);
        }
        function getSpeciality() {
            var data = ProfileService.GetSpeciality();
            data.then(function (result) {
                //$rootScope.SpecialityList = result.data;
                $scope.SpecialityMasterList = result.data;
                recomputeSpecialityLists();
            });
        }
        // Keeps the Specialty and Excluded Specialty option lists mutually exclusive:
        // a specialty selected in one dropdown is removed from the other's available options.
        // New array references are assigned so the multi-select component's $onChanges re-renders.
        function recomputeSpecialityLists() {
            var masterList = $scope.SpecialityMasterList || [];
            var excludedIds = _.map(($scope.ExcludedSpecialityId && $scope.ExcludedSpecialityId.Obj) || [], 'SpecialityId');
            var specialtyIds = _.map(($scope.SpecialityId && $scope.SpecialityId.Obj) || [], 'SpecialityId');
            $scope.SpecialityList = _.filter(masterList, function (s) {
                return !_.includes(excludedIds, s.SpecialityId);
            });
            $scope.ExcludedSpecialityList = _.filter(masterList, function (s) {
                return !_.includes(specialtyIds, s.SpecialityId);
            });
        }
        function GetModality() {
            var d = $q.defer();
            TechnoService.GetModality().then(function (result) {
                $scope.ModalitiesFullList = result;
                d.resolve();
            });
            return d.promise;

        }
        vm.ResetPassword = function () {
            if (vm.Password.trim() != vm.ConfirmPassword.trim()) {
                return vm.Message = "New & confirm password must be same!";
            }
            if (!checkPassword(vm.Password.trim())) {
                return vm.Message = __env.PassowordPatternMessage;
            }
            var ResetData = {
                NewPassword: vm.Password.trim(),
                ConfirmPassword: vm.ConfirmPassword.trim(),
                UserId: $scope.selectedRow.Id.trim(),
            };
            vm.isLoading = true;
            var promiseResponse = AccountManagerService.ResetPassword(ResetData);
            promiseResponse.then(function (resp) {
                if (resp.data.toLowerCase().match('error') || resp.data.toLowerCase().match('reuse')) {
                    vm.Message = resp.data;
                } else {
                    $('#resetPasswordModal').modal('hide');
                    vm.Password = '';
                    vm.ConfirmPassword = '';
                    logUserEvent("CHANGE PASSWORD BY ADMIN", $scope.selectedRow.Id);
                    vm.Message = null;
                }
                vm.isLoading = false;
            }, function (error) {
                vm.isLoading = false;
                if (error && error.data && error.data.Message) {
                    vm.Message = error.data.Message;
                }
            });
        }
        vm.ResetUserPassword = function () {
            if (vm.Password.trim() != vm.ConfirmPassword.trim())
                return vm.Message = "The selected passwords doesn't match!";

            if (vm.Password.trim() == vm.OldPassword.trim())
                return vm.Message = "New password can't be same as the old password";
            if (!checkPassword(vm.Password.trim())) {
                return vm.Message = __env.PassowordPatternMessage;
            }
            var ResetData = {
                OldPassword: vm.OldPassword.trim(),
                NewPassword: vm.Password.trim(),
                ConfirmPassword: vm.ConfirmPassword.trim(),
                UserId: $scope.UserId.trim()
            };
            vm.isLoading = true;
            var promiseResponse = AccountManagerService.ResetUserPassword(ResetData);
            promiseResponse.then(function (resp) {
                if (resp.data.match('Error')) {
                    vm.Message = "Error : Some problem occured!";
                } else {
                    $('#resetUserPasswordModal').modal('hide');
                }
                vm.isLoading = false;
            }, function (error) {
                $scope.isLoading = false;
                vm.Message = "Error : Some problem occured!";
            });
        }

        vm.cancel = function (row, rowForm) {
            $('#editUserModal').modal('hide');
            row.IsEditing = false;
            var c = $scope.originalData;
            var originalRow = _.find($scope.originalData, function (a) { return a.Id === row.Id });
            /*if (typeof (row.Roles) == 'object') {
                originalRow.Roles = _.join(_.map(originalRow.Roles, function (role) { return role.Name; }), ',');
            }*/
            angular.extend(row, originalRow);
            SetOnlineUsers([originalRow]);
        }

        vm.selectedUser = function (row) {
            vm.Password = '';
            vm.ConfirmPassword = '';
            vm.Message = null;
            // Use a copy, not the grid row itself - onSelectedRole (below) writes back into
            // selectedRow.Roles, which previously corrupted the actual grid row's Roles field
            // (since selectedRow was the same object as row), leaving a subsequent "Edit User"
            // click on that row with blank roles.
            $scope.selectedRow = angular.copy(row);
            if (row.Roles) {
                var roles = [];
                _.each(row.Roles.split(","), function (obj) {
                    var role = _.find($scope.RolesList, { 'Name': obj });
                    roles.push(role);
                });
                $scope.selectedRow.Roles = roles;
                $scope.MultiSelectDropdowns.editUserRole.SelectedValue = {
                    list: roles
                };
            }
            setTimeout(function () { angular.element('.modal-backdrop').removeClass('modal-backdrop'); }, 100);

        }
        $scope.sendResetPasswordLink = function () {
            if ($scope.selectedRow) {
                var Timestamp = $filter('CSTDateTime')(moment());
                var resetpwdparams = btoa(JSON.stringify({
                    Username: $scope.selectedRow.UserName,
                    Email: $scope.selectedRow.Email,
                    Timestamp: Timestamp
                }));
                // Hash query must survive ui-router's otherwise() rewrite; loginController
                // reads resetpwdparams from window.location.href on init.
                var URL = window.location.origin + "/#/?resetpwdparams=" + resetpwdparams;
                AccountManagerService.SendResetPasswordLink({
                    Email: $scope.selectedRow.Email,
                    URL: URL
                }).then(function () {
                    toaster.success({ body: "A password reset link has been successfully sent to the user's email. They can now reset their password." });
                }, function (err) { toaster.error({ body: "Some error occured!" }) });
            }
        }
        $scope.showResetPasswordModel = function () {
            angular.element('#resetPasswordModal').modal('show');
        }
        $scope.showResetPwdContextMenu = function (event, row) {
            $scope.DataObject.isResetPwdMenuVisible = true;
            var contextMenuDiv = document.getElementById("contextMenuDiv");
            if (contextMenuDiv) {
                contextMenuDiv.style.left = (event.clientX - 170) + 'px';
                contextMenuDiv.style.top = (event.clientY - 30) + 'px';
            }
        }
        vm.del = function (row) {
            _.remove(self.tableParams.settings().dataset, function (item) {
                return row === item;
            });
            self.tableParams.reload().then(function (data) {
                if (data.length === 0 && self.tableParams.total() > 0) {
                    self.tableParams.page(self.tableParams.page() - 1);
                    self.tableParams.reload();
                }
            });
        }

        function resetRow(row, rowForm) {
            row.IsEditing = false;
            rowForm.$setPristine();
        }

        vm.save = function (row, rowForm) {
            var phonenumber = "";
            if ($scope.selectedRow.PhoneNumber) {
                phonenumber = $scope.selectedRow.PhoneNumber.toString();
            }
            if (phonenumber.substr(0, 1) !== '+') {
                toaster.warning({ body: "Please enter country code with phonenumber! eg. +1xxxxxxxxxx" });
            }
            if (!$scope.selectedRow.Roles || $scope.selectedRow.Roles.length == 0) {
                toaster.pop({
                    type: 'warning',
                    body: "The user must have at least one <b>role</b> assigned.",
                    bodyOutputType: 'trustedHtml'
                });
                return;
            }
            if ($scope.selectedRow.Passcode && $scope.selectedRow.Passcode.length > 3) {
                var EditUser = {};
                if ($scope.selectedRow.UserRoleExists) {
                    EditUser = {
                        UserName: $scope.selectedRow.UserName.trim(),
                        Email: $scope.selectedRow.Email.trim(),
                        FirstName: $scope.selectedRow.FirstName.trim(),
                        LastName: $scope.selectedRow.LastName.trim(),
                        PhoneNumber: $scope.selectedRow.PhoneNumber,
                        RoleName: _.join(_.map($scope.selectedRow.Roles, function (role) { return role.Name; }), ','),
                        UserId: $scope.selectedRow.Id,
                        Passcode: $scope.selectedRow.Passcode,
                        NPI: $scope.selectedRow.NPI,
                        Address: {
                            AddressLine1: $scope.selectedRow.AddressLine1,
                            AddressLine2: $scope.selectedRow.AddressLine2,
                            City: $scope.selectedRow.City,
                            State: $scope.selectedRow.State,
                            PostalCode: $scope.selectedRow.PostalCode,
                            CountryCode: $scope.selectedRow.CountryCode ? $scope.selectedRow.CountryCode.key : '',
                            UserId: $scope.selectedRow.Id,
                            VendorID: $scope.selectedRow.VendorID,
                            CreatedBy: $sessionStorage.currentUserData.userId,
                            ModifiedBy: $sessionStorage.currentUserData.userId,
                        }
                    };
                } else {
                    EditUser = {
                        UserName: $scope.selectedRow.UserName.trim(),
                        Email: $scope.selectedRow.Email.trim(),
                        FirstName: $scope.selectedRow.FirstName.trim(),
                        LastName: $scope.selectedRow.LastName.trim(),
                        PhoneNumber: $scope.selectedRow.PhoneNumber,
                        RoleName: _.join(_.map($scope.selectedRow.Roles, function (role) { return role.Name; }), ','),
                        UserId: $scope.selectedRow.Id,
                        Passcode: $scope.selectedRow.Passcode,
                        NPI: $scope.selectedRow.NPI
                    };
                }
                vm.isLoading = true;
                var promiseResponse = AccountManagerService.UpdateUser(EditUser);
                promiseResponse.then(function (resp) {
                    if (resp && resp.data && resp.data.length > 0 && resp.data.toLowerCase().match('error')) {
                        toaster.error({ body: resp.data });
                    } else {
                        if (resp.data.match('already')) {
                            toaster.success({ body: resp.data });
                        }
                        else {
                            toaster.success({ body: $scope.selectedRow.LastName + ", " + $scope.selectedRow.FirstName + "'s Details Updated Successfully." });
                            row = $scope.selectedRow;
                            row.Roles = _.join(_.map(row.Roles, function (role) { return role.Name; }), ',');
                            row.IsEditing = false;
                            $scope.originalData = _.map($scope.originalData, function (a) {
                                return a.Id === row.Id ? row : a;
                            });
                            logUserEvent("UPDATE USER DETAILS", $scope.selectedRow.Id);
                        }

                    }
                    vm.isLoading = false;
                    if ($scope.DataObject.SaveNext) {
                        var userListIndex = _.findIndex($scope.originalData, { Id: $scope.selectedRow.Id });
                        if (userListIndex != -1
                            && (userListIndex < ($scope.originalData.length - 1))) {
                            vm.setRoleOption($scope.originalData[userListIndex + 1]);
                        } else {
                            $scope.selectedRow = {};
                            $('#editUserModal').modal('hide');
                        }
                    } else {
                        $scope.selectedRow = {};
                        $('#editUserModal').modal('hide');
                    }
                    $scope.DataObject.SaveNext = false;
                }, function (error) {
                    $scope.selectedRow = {};
                    vm.isLoading = false;
                    $('#editUserModal').modal('hide');
                    toaster.error({ body: "Something went wrong!" });
                });
            }
            else {
                toaster.warning({ body: "Pin must be atleast 4 digit!" });
            }

        }
        vm.delete = function (row) {

            swal({
                title: row.LastName + ", " + row.FirstName + "'s account will be deleted.<br> Do you want to continue?",
                type: "warning",
                html: true,
                customClass: 'swal-wide',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55", confirmButtonText: "Continue",
                cancelButtonText: "Cancel",
            }, function (isConfirm) {
                if (isConfirm) {
                    var BlockUser = {
                        UserId: row.Id.trim(),
                        ClientId: APP_CONSTANTS.clientId
                    };

                    vm.isLoading = true;
                    var promiseResponse = AccountManagerService.BlockUser(BlockUser);
                    promiseResponse.then(function (resp) {
                        if (resp.data.toLowerCase().match('error')) {
                            toaster.error({ body: resp.data });
                        } else {
                            row.IsDeleted = true;
                            row.IsEditing = false;
                            $scope.originalData = _.map($scope.originalData, function (a) {
                                return a.Id === row.Id ? row : a;
                            });
                            logUserEvent("BLOCK USER", row.Id);
                        }
                        vm.isLoading = false;
                    }, function (error) {
                        vm.isLoading = false;
                        toaster.error({ body: "Something went wrong!" });
                    });
                }
            });
        }
        vm.setRoleOption = function (row) {
            /*if ($scope.selectedRow) {
                var lastSelectedRow = _.find($scope.originalData, { Id: $scope.selectedRow.Id });
                if (lastSelectedRow) {
                    vm.cancel(lastSelectedRow);
                }
            }*/
            if (row) {
                row.IsEditing = true;
                $scope.selectedRow = angular.copy(row);
                if (row.Roles) {
                    /*var roles = row.Roles.split(",");
                    row.Roles = [];
                    _.each(roles, function (obj) {
                        var role = _.find($scope.RolesList, { 'Name': obj });
                        row.Roles.push(role);
                    });*/

                    var roles = [];
                    _.each(row.Roles.split(","), function (obj) {
                        var role = _.find($scope.RolesList, { 'Name': obj });
                        roles.push(role);
                    });
                    $scope.selectedRow.Roles = roles;
                    $scope.MultiSelectDropdowns.editUserRole.SelectedValue = {
                        list: roles
                    };
                    $scope.selectedRow.UserRoleExists = _.find(roles, { Name: 'User' }) ? true : false;
                }

            }
        };


        vm.openUserSetting = function (row) {
            /*if (row.IsEditing) {
                vm.cancel(row);
            }*/
            $scope.DataObject.isPSWCheckboxDisableUserSettings = !((row.Roles) && (row.Roles.split(",")).includes('User'));
            $scope.isUserSettingModalLoading = true;
            $scope.userId = row.Id;
            $scope.FullName = row.LastName + ' ' + row.FirstName;
            $scope.SelectedModality.Obj = null;
            clearUserSetting();
            $scope.DataObject.ShowPaymentContractDetail = true;
            var gridDiv = document.querySelector('#DicomViewerGridSetting');
            if (gridDiv) {
                new agGrid.Grid(gridDiv, DicomViewerGridSettingOption);
            }
            var data = ProfileService.getUserSettingData($scope.userId);
            data.then(function (resp) {
                if (resp.data) {
                    $scope.IsReviwer = resp.data.IsReviewer;
                    $scope.TargetRVU = resp.data.TargetRVU;
                    if (resp.data.Modality) {
                        $scope.SelectedModality.Obj = [];
                        _.each((resp.data.Modality).split(","), function (modality) {
                            var selectedModality = _.find($scope.ModalitiesFullList, { Code: modality });
                            if (selectedModality) { $scope.SelectedModality.Obj.push(selectedModality); }
                        });
                    }
                }
            });

            ProfileService.GetUserSpecialityMapping({ UserId: $scope.userId }).then(function (result) {
                var selectedSpeciality = [];
                _.each(result, function (obj) {
                    var specialty = _.find($scope.SpecialityMasterList, function (specialty) { return specialty.SpecialityId == obj.SpecialityId });
                    if (specialty) { selectedSpeciality.push(specialty); }
                });
                $scope.SpecialityId.Obj = selectedSpeciality;
                $scope.MultiSelectDropdowns.SpecialtyUserSettings.SelectedValue = {
                    list: selectedSpeciality
                };
                recomputeSpecialityLists();
            }, function (err) {
                $scope.isUserSettingModalLoading = false;
                toaster.error({ body: "Something went wrong!" });
            });

            ProfileService.GetUserExcludedSpecialityMapping($scope.userId).then(function (result) {
                var selectedExcludedSpeciality = [];
                _.each(result, function (obj) {
                    var specialty = _.find($scope.SpecialityMasterList, function (specialty) { return specialty.SpecialityId == obj.SpecialityId });
                    if (specialty) { selectedExcludedSpeciality.push(specialty); }
                });
                $scope.ExcludedSpecialityId.Obj = selectedExcludedSpeciality;
                $scope.MultiSelectDropdowns.ExcludedSpecialtyUserSettings.SelectedValue = {
                    list: selectedExcludedSpeciality
                };
                recomputeSpecialityLists();
            }, function (err) {
                $scope.isUserSettingModalLoading = false;
                toaster.error({ body: "Something went wrong!" });
            });
            GetTenantByUser($scope.userId).then(function (resp) {
                GetAllSites($scope.userId).then(function (resp) {
                    $scope.TenantSiteListMap($scope.SelectedTenant.Obj).then(function (resp) {
                        ManageLocationService.GetLookupByType('PaymentContract,DicomViewer').then(function (result) {
                            $scope.PaymentContractList = _.filter(result, { Key: 'PaymentContract' });
                            $scope.PaymentContractList.HelperShiftList = _.filter($scope.PaymentContractList, function (obj) { return obj.Value != 'Payment Per Shift' });
                            //#region Get Dicom Viewer Value From Lookups
                            $scope.DataObject.InstDicomViewerList = _.filter(_.filter(result, { Type: 'DicomViewer' }), function (dicomviewer) {
                                return dicomviewer.Key == 'Azure Konica' || dicomviewer.Key == 'North Star Konica';
                            });
                            sortDicomViewer();
                            DicomViewerFullList = _.cloneDeep($scope.DataObject.InstDicomViewerList);
                            if (DicomViewerFullList.length == 0) {
                                document.getElementsByClassName('ag-row-pinned ag-row-level-0')[0].classList.add('disable-checkbox');
                            }
                            //#endregion
                            var userPreference = {
                                UserID: $scope.userId,
                            };
                            UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
                                result = result.UserPreferences;
                                if (result != null && result.length > 0) {
                                    ShowPracticeWorklistPref = _.find(result, { PreferenceType: 'ShowPracticeWorklist' });
                                    if (ShowPracticeWorklistPref && ShowPracticeWorklistPref.PreferenceValue) {
                                        $scope.DataObject.ShowPracticeWorklist = ShowPracticeWorklistPref.PreferenceValue == '1' ? true : false;
                                    }
                                    DoNotSendPaymentSummaryPref = _.find(result, { PreferenceType: 'DoNotSendPaymentSummary' });
                                    if (DoNotSendPaymentSummaryPref && DoNotSendPaymentSummaryPref.PreferenceValue) {
                                        $scope.DataObject.DoNotSendPaymentSummary = DoNotSendPaymentSummaryPref.PreferenceValue == '1' ? true : false;
                                    }
                                    EnableTwoFactorAuthenticationPref = _.find(result, { PreferenceType: 'EnableTwoFactorAuthentication' });
                                    if (EnableTwoFactorAuthenticationPref && EnableTwoFactorAuthenticationPref.PreferenceValue) {
                                        $scope.DataObject.EnableTwoFactorAuthentication = EnableTwoFactorAuthenticationPref.PreferenceValue == '1' ? true : false;
                                    }
                                    MedDreamViewerKeepOpenPref = _.find(result, { PreferenceType: 'MedDreamViewerKeepOpen' });
                                    if (MedDreamViewerKeepOpenPref && MedDreamViewerKeepOpenPref.PreferenceValue) {
                                        $scope.DataObject.MedDreamViewerKeepOpen = MedDreamViewerKeepOpenPref.PreferenceValue == '1' ? true : false;
                                    }
                                    /*#region Get Dicom Viewer Cred*/
                                    DicomViewerCred = _.find(result, { PreferenceType: 'DicomViewerCred' });
                                    var viewerMappingList = [];
                                    if (DicomViewerCred) {
                                        var SelectedViewers = JSON.parse(DicomViewerCred.PreferenceValue);
                                        _.each(SelectedViewers, function (viewer) {
                                            var Viewer = _.find(DicomViewerFullList, { Value: viewer.VWR });
                                            if (Viewer) {
                                                viewerMappingList.push({
                                                    DicomViewer: Viewer.Key,
                                                    Username: viewer.UNM,
                                                    Password: viewer.PWD,
                                                    selectedViewer: Viewer,
                                                });
                                            }
                                            Viewer = null;
                                        });
                                        SelectedViewers = null;
                                    }
                                    if (DicomViewerGridSettingOption && DicomViewerGridSettingOption.api) {
                                        DicomViewerGridSettingOption.api.setRowData(viewerMappingList);
                                        if (DicomViewerGridSettingOption.api.getRenderedNodes().length == 2) {
                                            document.getElementsByClassName('ag-row-pinned ag-row-level-0')[0].classList.add('disable-checkbox');
                                        }
                                        viewerMappingList = null;
                                    }
                                    /*#endregion Get Dicom Viewer Cred*/
                                }
                                // Store original user settings for comparison
                                OriginalUserSettings = {
                                    ShowPracticeWorklist: angular.copy($scope.DataObject.ShowPracticeWorklist),
                                    DoNotSendPaymentSummary: angular.copy($scope.DataObject.DoNotSendPaymentSummary),
                                    EnableTwoFactorAuthentication: angular.copy($scope.DataObject.EnableTwoFactorAuthentication),
                                    DicomViewerCred: DicomViewerCred ? angular.copy(JSON.parse(DicomViewerCred.PreferenceValue)) : [],
                                    IsReviewer: angular.copy($scope.IsReviwer),
                                    TargetRVU: angular.copy($scope.TargetRVU),
                                    Modalities: angular.copy($scope.SelectedModality.Obj ? _.map($scope.SelectedModality.Obj, function (m) { return m.Code; }) : []),
                                    SpecialityIds: angular.copy($scope.SpecialityId.Obj ? _.map($scope.SpecialityId.Obj, function (s) { return s.SpecialityId; }) : []),
                                    ExcludedSpecialityIds: angular.copy($scope.ExcludedSpecialityId.Obj ? _.map($scope.ExcludedSpecialityId.Obj, function (s) { return s.SpecialityId; }) : []),
                                    TenantIDs: angular.copy($scope.SelectedTenant.Obj ? _.map($scope.SelectedTenant.Obj, function (t) { return t.TenantID; }) : []),
                                    SiteIDs: angular.copy($scope.LocSelected.Sites ? _.map($scope.LocSelected.Sites, function (s) { return s.SiteID; }) : [])
                                };
                                $scope.isUserSettingModalLoading = false;
                            }, function () {
                                $scope.isUserSettingModalLoading = false;
                                toaster.error({ body: "Unable to load user preferences." });
                            });


                        });

                    });
                });
            });
            angular.element('#UserSettingModal').modal('show');
            angular.element('.modal-backdrop').removeClass('modal-backdrop');
        }

        vm.UpdateUserSetting = function () {
            // Updates the following fields:
            // 1. User Preferences: ShowPracticeWorklist, DoNotSendPaymentSummary, EnableTwoFactorAuthentication, DicomViewerCred
            // 2. User Tenant: TenantIDList
            // 3. User Sites: Sites mapped to user
            // 4. User Settings: IsReviewer, TargetRVU, Modalities
            // 5. User Specialty Mapping: SpecialityIds
            $scope.DataObject.SaveUserSettingFlag = true;
            DicomViewerGridSettingOption.api.stopEditing();
            var Timeout = $timeout(function () {

                var DicomObject = [];
                DicomViewerGridSettingOption.api.forEachNode(function (node) {
                    var Data = node.data;
                    var Viewer = _.find(DicomViewerFullList, { Key: Data.DicomViewer });
                    if (Viewer) {
                        DicomObject.push({
                            "VWR": Viewer.Value,
                            "UNM": Data.Username,
                            "PWD": Data.Password,
                        });
                    }
                });

                var IsEdited = false;
                var RenderedNodes = DicomViewerGridSettingOption.api.getRenderedNodes()
                _.each(RenderedNodes, function (node) {
                    if (!IsEdited) {
                        if (node && node.data) {
                            if (!node.data.Username || node.data.Username == '') {
                                DicomViewerGridSettingOption.api.startEditingCell({
                                    rowIndex: node.rowIndex,
                                    colKey: "Username"
                                })
                                IsEdited = true;
                            }
                            else if (!node.data.Password || node.data.Password == '') {
                                DicomViewerGridSettingOption.api.startEditingCell({
                                    rowIndex: node.rowIndex,
                                    colKey: "Password"
                                });
                                IsEdited = true;
                            }
                        }
                    }
                });
                if (RenderedNodes.length > 0 && IsEdited) {
                    toaster.warning({ body: "Please add all the necessary information in the DICOM Viewer Credentials." });
                    $scope.DataObject.SaveUserSettingFlag = false;
                    return;
                }
                $scope.NewUser = {};
                $scope.NewUser.UserId = $scope.userId;
                $scope.NewUser.TenantIDList = [];
                var userPreferences = [];
                _.each($scope.SelectedTenant.Obj, function (tenant) {
                    $scope.NewUser.TenantIDList.push(tenant.TenantID);
                });
                if (ShowPracticeWorklistPref) {
                    if (ShowPracticeWorklistPref.PreferenceValue != ($scope.DataObject.ShowPracticeWorklist ? '1' : '0')) {
                        ShowPracticeWorklistPref.PreferenceValue = $scope.DataObject.ShowPracticeWorklist ? '1' : '0';
                        userPreferences.push(ShowPracticeWorklistPref);
                    }
                }
                else {
                    userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "ShowPracticeWorklist", UserID: $scope.userId, PreferenceValue: $scope.DataObject.ShowPracticeWorklist ? '1' : '0' });
                }

                if (DoNotSendPaymentSummaryPref) {
                    if (DoNotSendPaymentSummaryPref.PreferenceValue != ($scope.DataObject.DoNotSendPaymentSummary ? '1' : '0')) {
                        DoNotSendPaymentSummaryPref.PreferenceValue = $scope.DataObject.DoNotSendPaymentSummary ? '1' : '0';
                        userPreferences.push(DoNotSendPaymentSummaryPref);
                    }
                }
                else {
                    userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "DoNotSendPaymentSummary", UserID: $scope.userId, PreferenceValue: $scope.DataObject.DoNotSendPaymentSummary ? '1' : '0' });
                }

                if (EnableTwoFactorAuthenticationPref) {
                    if (EnableTwoFactorAuthenticationPref.PreferenceValue != ($scope.DataObject.EnableTwoFactorAuthentication ? '1' : '0')) {
                        EnableTwoFactorAuthenticationPref.PreferenceValue = $scope.DataObject.EnableTwoFactorAuthentication ? '1' : '0';
                        userPreferences.push(EnableTwoFactorAuthenticationPref);
                    }
                }
                else {
                    userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "EnableTwoFactorAuthentication", UserID: $scope.userId, PreferenceValue: $scope.DataObject.EnableTwoFactorAuthentication ? '1' : '0' });
                }

                if (MedDreamViewerKeepOpenPref) {
                    if (MedDreamViewerKeepOpenPref.PreferenceValue != ($scope.DataObject.MedDreamViewerKeepOpen ? '1' : '0')) {
                        MedDreamViewerKeepOpenPref.PreferenceValue = $scope.DataObject.MedDreamViewerKeepOpen ? '1' : '0';
                        userPreferences.push(MedDreamViewerKeepOpenPref);
                    }
                }
                else {
                    userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "MedDreamViewerKeepOpen", UserID: $scope.userId, PreferenceValue: $scope.DataObject.MedDreamViewerKeepOpen ? '1' : '0' });
                }
                //#region Set Dicom Viewer Cred User Preference
                // DicomObject already created above for comparison
                if (DicomViewerCred) {
                    var HasEqual = _.isEqual(JSON.parse(DicomViewerCred.PreferenceValue), DicomObject);
                    if (!HasEqual) {
                        DicomViewerCred.PreferenceValue = JSON.stringify(DicomObject);
                        userPreferences.push(DicomViewerCred);
                    }
                }
                else {
                    if (DicomObject && DicomObject.length > 0) {
                        userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "DicomViewerCred", UserID: $scope.userId, PreferenceValue: JSON.stringify(DicomObject) });
                    }
                }
                
                //#endregion Set Dicom Viewer Cred User Preference
                // Shared failure handler for this chain - without it, a rejection at any step left
                // SaveUserSettingFlag stuck true forever (loader never disappears, bug 170907),
                // since none of these calls previously had an error callback.
                function onUpdateUserSettingError(err) {
                    toaster.error({ body: "Something went wrong!" });
                    $scope.DataObject.SaveUserSettingFlag = false;
                }
                if (userPreferences && userPreferences.length > 0) {
                    AddEditUserPreferences(userPreferences).then(function (result) {
                        userPreferences = [];
                    }, onUpdateUserSettingError);
                }
                AccountManagerService.UpdateUserTenant($scope.NewUser).then(function (resp) {
                    var sites = MapSites();
                    sites.then(function (resp) {
                        var Modalities = _.join(_.map($scope.SelectedModality.Obj, function (modality) { return modality.Code; }), ',');
                        var promiseResponse = ProfileService.UpdateUserSetting($scope.userId, 0, ($scope.IsReviwer) ? $scope.IsReviwer : null, $scope.TargetRVU, Modalities);
                        promiseResponse.then(function (resp) {
                            var params = { SpecialityIds: [] };
                            if ($scope.SpecialityId.Obj) {
                                _.each($scope.SpecialityId.Obj, function (obj) {
                                    params.SpecialityIds.push({
                                        UserID: $scope.userId,
                                        SpecialityId: obj.SpecialityId
                                    });
                                });
                            }
                            if (params.SpecialityIds.length == 0) {
                                params.SpecialityIds.push({
                                    UserID: $scope.userId,
                                    SpecialityId: null
                                });
                            }
                            var excludedParams = { SpecialityIds: [] };
                            if ($scope.ExcludedSpecialityId.Obj) {
                                _.each($scope.ExcludedSpecialityId.Obj, function (obj) {
                                    excludedParams.SpecialityIds.push({
                                        UserID: $scope.userId,
                                        SpecialityId: obj.SpecialityId
                                    });
                                });
                            }
                            if (excludedParams.SpecialityIds.length == 0) {
                                excludedParams.SpecialityIds.push({
                                    UserID: $scope.userId,
                                    SpecialityId: null
                                });
                            }
                            $q.all([
                                ProfileService.SetUserSpecialityMapping(params),
                                ProfileService.SetUserExcludedSpecialityMapping(excludedParams)
                            ]).then(function (results) {
                                angular.element('#UserSettingModal').modal('hide');
                                toaster.success({ body: "User settings are updated successfully!" });

                                var currentSettings = {
                                    ShowPracticeWorklist: $scope.DataObject.ShowPracticeWorklist,
                                    DoNotSendPaymentSummary: $scope.DataObject.DoNotSendPaymentSummary,
                                    EnableTwoFactorAuthentication: $scope.DataObject.EnableTwoFactorAuthentication,
                                    IsReviewer: $scope.IsReviwer,
                                    TargetRVU: $scope.TargetRVU,
                                    Modalities: $scope.SelectedModality.Obj ? _.map($scope.SelectedModality.Obj, function (m) { return m.Code; }) : [],
                                    SpecialityIds: $scope.SpecialityId.Obj ? _.map($scope.SpecialityId.Obj, function (s) { return s.SpecialityId; }) : [],
                                    ExcludedSpecialityIds: $scope.ExcludedSpecialityId.Obj ? _.map($scope.ExcludedSpecialityId.Obj, function (s) { return s.SpecialityId; }) : [],
                                    TenantIDs: $scope.SelectedTenant.Obj ? _.map($scope.SelectedTenant.Obj, function (t) { return t.TenantID; }) : [],
                                    SiteIDs: $scope.LocSelected.Sites ? _.map($scope.LocSelected.Sites, function (s) { return s.SiteID; }) : []
                                };

                                SharedService.logUserEventChanges(
                                    OriginalUserSettings,
                                    currentSettings,
                                    DicomObject,
                                    $sessionStorage.currentUserData.userId,
                                    $scope.userId,
                                    "UPDATE USER SETTINGS"
                                );
                                DicomObject = null;
                                $scope.PaymentContract = { Obj: null };
                                $scope.PaymentContractHelperShift = { Obj: null };
                                $scope.ShowHideHelperDropdownFlag = false;
                                $scope.DataObject.SaveUserSettingFlag = false;
                                OriginalUserSettings = null; // Clear original settings after update
                            }, onUpdateUserSettingError);
                        }, onUpdateUserSettingError);
                    }, onUpdateUserSettingError);
                }, onUpdateUserSettingError);
                $timeout.cancel(Timeout);
                Timeout = null;
            }, 100);
        }
        function clearUserSetting() {
            $scope.IsReviwer = false;
            $scope.SpecialityId = { Obj: null };
            $scope.ExcludedSpecialityId = { Obj: null };
            $scope.MultiSelectDropdowns.ExcludedSpecialtyUserSettings.SelectedValue = {
                list: []
            };
            $scope.TargetRVU = 0;
            $scope.LocSelected = { Sites: [] };
            $scope.MultiSelectDropdowns.SiteUserSettings.SelectedValue = {
                list: []
            };
            $scope.PaymentContract = { Obj: null };
            $scope.PaymentContractHelperShift = { Obj: null };
            $scope.ShowHideHelperDropdownFlag = false;
            $scope.DataObject.ShowPracticeWorklist = true;
            ShowPracticeWorklistPref = null;
            if (DicomViewerGridSettingOption && DicomViewerGridSettingOption.api) {
                DicomViewerGridSettingOption.api.destroy();
            }
            $scope.DataObject.SelectedViewer = null;
            $scope.DataObject.DVCredUsername = null;
            $scope.DataObject.DVCredPassword = null;
            $scope.DataObject.ShowPaymentContractDetail = false;
            $scope.DataObject.DoNotSendPaymentSummary = false;
            DoNotSendPaymentSummaryPref = null;
            $scope.DataObject.EnableTwoFactorAuthentication = false;
            EnableTwoFactorAuthenticationPref = null;
            $scope.DataObject.MedDreamViewerKeepOpen = true;
            MedDreamViewerKeepOpenPref = null;
            OriginalUserSettings = null; // Clear original settings when clearing
            recomputeSpecialityLists();
        }


        function GetAllSites(userId) {
            var d = $q.defer();
            ManageLocationService.GetSites({ "PageSize": "500", "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.AllSites = result;
                getSitesByUserId(userId).then(function (resp) {
                    d.resolve();
                });
            });
            return d.promise;
        };

        function getSitesByUserId(userId) {
            var d = $q.defer();
            ProfileService.GetSitesByUserId(userId).then(function (result) {
                $scope.LocSelected.Sites = [];
                angular.forEach(result.data, function (site) {
                    var filter = _.find($scope.AllSites, function (item) { return item.SiteID == site.SiteID; });
                    if (filter != null) {
                        $scope.LocSelected.Sites.push(filter);
                    }
                });
                $scope.MultiSelectDropdowns.SiteUserSettings.SelectedValue = {
                    list: $scope.LocSelected.Sites
                };
                d.resolve();
            });
            return d.promise;
        }
        function MapSites() {
            var d = $q.defer();
            //if ($scope.LocSelected.Sites.length > 0) {
            var ids = "";
            ids = _.join(_.map($scope.LocSelected.Sites, function (site) { return site.SiteID; }), ',');
            var promiseResponse = ProfileService.MapUserSites(ids, $scope.userId);
            promiseResponse.then(function (resp) {
                d.resolve();
            }, function (err) {
                d.reject(err);
            });
            return d.promise;
        };

        function SetOnlineUsers(userList) {
            AccountManagerService.getOnlineUsers().then(function (result) {
                var userIds = result.data;
                angular.forEach(userIds, function (id, idx) {
                    var user = _.filter(userList, function (user) { return user.Id == id; });
                    if (user && user.length > 0) {
                        user[0].IsOnline = true;
                    }
                });
            }, function (err) {
            });
        }
        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };
        $scope.pageChanged = function () {
            getUsers();
        };

        $scope.pageSizeChanged = function () {
            $scope.PageNo = 1;
            getUsers();
        };

        function getUsers() {
            if ($state.current.name === 'profile') {
                return;
            }
            if (!vm.isLoading) {
                vm.isLoading = true;
                $scope.SortDir = $scope.ReverseSort ? 'desc' : 'asc';
                var filter = {
                    PageNum: $scope.PageNum,
                    PageSize: $scope.PageSize,
                    SortDir: $scope.SortDir,
                    SortField: $scope.SortField,
                    UserName: $scope.UserName,
                    FirstName: $scope.FirstName,
                    LastName: $scope.LastName,
                    Email: $scope.Email,
                    PhoneNumber: $scope.PhoneNumber,
                    Roles: $scope.Roles,
                    IsRegisterUser: $scope.IsRegisterUser ? false : true,
                    UserID: $sessionStorage.currentUserData.userId,
                };
                AccountManagerService.GetTenantsUserListSummary(filter).then(function (result) {
                    var users = [];
                    users = _.map(result, function (item) {
                        item.CountryCode = _.find($scope.CountryCodes, { key: item.CountryCode });
                        return item;
                    });
                    $scope.originalData = users;
                    vm.originalData = users;
                    $scope.PageCounts = 0;
                    $scope.ShowingRedords = 0;
                    if ($scope.originalData.length > 0) {
                        $scope.PageCounts = $scope.originalData[0].PageCounts;
                        $scope.ShowingRedords = $scope.originalData.length;
                    }
                    vm.tableParams = new NgTableParams({ page: 1, count: 15 }, { counts: [], dataset: users });

                    vm.isLoading = false;

                    SetOnlineUsers(users);
                }, function (err) {
                    vm.isLoading = false;
                });
            }
        }

        $scope.SortFilter = function (OrderByField) {
            $scope.PageNum = 1;
            //$scope.PageSize = "25";
            $scope.SortField = OrderByField;
            $scope.ReverseSort = !$scope.ReverseSort;
            getUsers();
        };

        $scope.Filter = function () {
            getUsers();
        }

        $scope.clearFilterAndRefesh = function () {
            clear();
            getUsers();
        }

        function clear() {
            $scope.PageNum = 1;
            $scope.PageSize = 25;
            $scope.SortDir = 'asc';
            $scope.SortField = 'UserName';
            $scope.UserName = '';
            $scope.FirstName = '';
            $scope.LastName = '';
            $scope.Email = '';
            $scope.PhoneNumber = '';
            $scope.Roles = '';
            $scope.PageCounts = 0;
            $scope.ReverseSort = false;
            $scope.ShowingRedords = 0;
            $scope.SpecialityId = {
                Obj: null
            };
            $scope.ExcludedSpecialityId = {
                Obj: null
            };
            $scope.SelectedModality = { Obj: null };
        }
        vm.SendInvitation = function (user) {
            var promiseResponse = AccountManagerService.ReInviteUser(user.Id);
            promiseResponse.then(function (resp) {
                if (resp.data.toLowerCase().match('error')) {
                    toaster.error({ body: resp.data });
                } else {
                    toaster.success({ body: "Invitation sent successfully." });
                }
            }, function (error) {
                toaster.error({ body: "Something went wrong!" });
            });
        }
        $scope.$on("UpdateUserList", function (evt, data) {
            getUsers();
        });
        // JS for table row active
        angular.element(document).ready(function () {
            setTimeout(function () {
                angular.element(".common-tbl table tr").click(function () {
                    if (angular.element(this).data('clicked', true)) {
                        angular.element(".common-tbl table tr").removeClass('tr-active');
                        angular.element(this).addClass('tr-active');
                    }
                });
            }, 500);
        });

        function GetTenantByUser(userID) {
            var d = $q.defer();
            ManageLocationService.GetTenantsByUserID({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.TenantByUserID = result;
                ManageLocationService.GetTenantsByUserID({ "UserID": userID }).then(function (result) {
                    $scope.SelectedTenant.Obj = result;
                    $scope.MultiSelectDropdowns.TenantUserSettings.SelectedValue = {
                        list: result
                    };
                    d.resolve();
                });
            });
            return d.promise;
        }
        //$scope.clearSelectedTenant = function () {
        //    $scope.SelectedTenant.Obj = null;
        //    $scope.clearLocSelected();
        //}
        $scope.TenantSiteListMap = function (SelectedTenants) {
            var d = $q.defer();
            $scope.SitesByTenants = [];
            var seletedSiteByTenant = [];
            _.each(SelectedTenants, function (tenant) {
                var sites = _.filter($scope.AllSites, { "TenantName": tenant.DisplayName });
                _.each(sites, function (site) { $scope.SitesByTenants.push(site); });
                if ($scope.LocSelected) {
                    var selectedSites = _.filter($scope.LocSelected.Sites, { "TenantName": tenant.DisplayName });
                    _.each(selectedSites, function (site) { seletedSiteByTenant.push(site); });
                }
            });
            if ($scope.LocSelected) {
                $scope.LocSelected.Sites = seletedSiteByTenant;
                $scope.MultiSelectDropdowns.SiteUserSettings.SelectedValue = {
                    list: seletedSiteByTenant
                };
            }
            d.resolve();
            return d.promise;
        }
        $scope.closeUserSettings = function () {
            $scope.SelectedTenant.Obj = [];
            $scope.MultiSelectDropdowns.TenantUserSettings.SelectedValue = {
                list: [],
            };
            $scope.LocSelected.Sites = [];
            $scope.MultiSelectDropdowns.SiteUserSettings.SelectedValue = {
                list: []
            };
            $scope.isLoading = true;
            $scope.PaymentContract = { Obj: null };
            $scope.PaymentContractHelperShift = { Obj: null };
            $scope.ShowHideHelperDropdownFlag = false;
            $scope.DataObject.ShowPracticeWorklist = true;
            ShowPracticeWorklistPref = null;
            if (DicomViewerGridSettingOption && DicomViewerGridSettingOption.api) {
                DicomViewerGridSettingOption.api.destroy();
            }
            $scope.DataObject.ShowPaymentContractDetail = false;
            $scope.DataObject.DoNotSendPaymentSummary = false;
            DoNotSendPaymentSummaryPref = null;
            $scope.DataObject.EnableTwoFactorAuthentication = false;
            EnableTwoFactorAuthenticationPref = null;
        }
        //$scope.clearSelectedSpeciality = function () {
        //    $scope.SpecialityId = { Obj: null };
        //}
        $scope.clearSelectedModality = function () {
            $scope.SelectedModality = { Obj: null };
        }
        $scope.ShowHideHelperDropdown = function (obj) {
            if (obj) {
                if ($scope.PaymentContract)
                    $scope.PaymentContract.Obj = obj;
                else
                    $scope.PaymentContract = { Obj: obj };
            }
            if (obj && obj.Value == "Payment Per Shift") {
                $scope.ShowHideHelperDropdownFlag = true;
            }
            else {
                $scope.ShowHideHelperDropdownFlag = false;
            }
            $scope.PaymentContractHelperShift.Obj = null;
        }
        $scope.SelectedTenant = { Obj: [] };
        $scope.MultiSelectDropdowns.TenantUserSettings.SelectedValue = {
            list: []
        };
        $scope.SelectedTenantBulk = {};
        $scope.winBulkInviteWidth = "98%";
        var vm = this;
        ManageLocationService.GetSites({ "PageSize": "500", "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
            $scope.AllSites = result;
        });
        ManageLocationService.GetTenantsByUserID({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
            $scope.TenantByUserID = result;
        });

        function checkPwd(str) {
            var regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
            return regularExpression.test(str);
        }
        vm.OpenCreateUser = function () {
            $scope.NewUser = { ShowPracticeWorklist: true, DoNotSendPaymentSummary: false, EnableTwoFactorAuthentication: false };
            $scope.MultiSelectDropdowns.RoleInviteUser.SelectedValue = {
                list: []
            };
            $scope.SelectedTenant = { Obj: [] };
            $scope.MultiSelectDropdowns.TenantInviteUser.SelectedValue = {
                list: []
            };
            $scope.MultiSelectDropdowns.SiteInviteUser.SelectedValue = {
                list: []
            };
        }
        function _generatePassword(length, charset) {
            var retVal = "";
            for (var i = 0, n = charset.length; i < length; ++i) {
                retVal += charset.charAt(Math.floor(Math.random() * n));
            }
            return retVal;
        }
        function generatePassword() {
            return _generatePassword(3, "ABCDEFGHIJKLMNOPQRSTUVWXYZ")
                + _generatePassword(3, "abcdefghijklmnopqrstuvwxyz")
                + _generatePassword(1, "!@#$%^&*")
                + _generatePassword(3, "0123456789")
        }
        vm.CreateUser = function () {

            var newUser = _.clone($scope.NewUser)

            newUser.RoleName = _.join(_.map(newUser.RoleName, function (role) { return role.Name; }), ',');
            newUser.Password = generatePassword();
            newUser.ConfirmPassword = newUser.Password;
            //if ($scope.NewUser.Phone && $scope.NewUser.Phone.substr(0, 1) !== '+') {
            //    vm.Message = "'Please enter country code with phonenumber! eg. +1xxxxxxxxxx'";
            //    return;
            //}
            if (newUser.PhoneNumber != null && newUser.PhoneNumber.length == 10) {
                newUser.PhoneNumber = "+1" + newUser.PhoneNumber;
            }
            if (newUser.Password.trim() != newUser.ConfirmPassword.trim()) {
                toaster.error({ body: "New & confirm password must be same!" });
                return;
            }
            //if (!checkPwd(vm.Password.trim())) {
            //    return vm.Message = "Password must contains atleast 1 (special, numberic & upper case) character.";
            //} 
            newUser.UserName = newUser.Email;
            newUser.TenantIDList = [];
            _.each($scope.SelectedTenant.Obj, function (tenant) {
                newUser.TenantIDList.push(tenant.TenantID);
            })
            // The auth server bases the invitation link on this address when its host is trusted.
            newUser.AppUrl = window.location.origin;
            var promiseResponse = AccountManagerService.CreateUser(newUser);
            promiseResponse.then(function (resp) {
                if (resp && resp.data) {
                    $('#myModal').modal('hide');
                    MappingSites(resp.data, newUser)
                    logUserEvent("INVITE USER", resp.data);
                }
            }, function (error) {
                if (error && error.data && error.data.Message) {
                    toaster.error({ body: error.data.Message });
                }
            });
        }
        vm.OpenBulkInvite = function () {
            vm.Sites = [];
            $scope.MultiSelectDropdowns.SiteBulkInvite.SelectedValue = {
                list: []
            };
            vm.SelectedALL = false;
            vm.selectedAtOne = false;
            $scope.collection = [];
            $scope.column = [];
            $('#myModal').modal('hide');
            $scope.win_BulkInvite.open();
            $scope.win_BulkInvite.wrapper.prev(".k-overlay").addClass("custom-overlay");
            setTimeout(function () {
                $scope.win_BulkInvite.center();
            }, 100);
        }
        $scope.uploadFile = function (input) {
            if (input.files && input.files.length > 0) {
                angular.forEach(input.files, function (file) {
                    var reader = new FileReader();
                    reader.onload = function () {
                        $scope.$apply(function ($scope) {
                            //console.log(reader.result);
                            document.getElementById("fileInput").value = null;
                            vm.Sites = [];
                            $scope.MultiSelectDropdowns.SiteBulkInvite.SelectedValue = {
                                list: []
                            };
                            var list = reader.result.split(/\r?\n/);
                            if (list.length <= 2) {
                                toaster.pop({ type: 'error', body: "Invalid csv file." });
                                return;
                            }
                            var Collection = [];
                            var column = list[0].split(',');
                            var IsInvalideFile = false;
                            _.each(('FirstName,LastName,Email,PhoneNumber,RoleName').split(','), function (c) {
                                if (!_.filter(column, function (f) { return f == c })[0]) {
                                    IsInvalideFile = true;
                                }
                            });
                            if (!IsInvalideFile) {
                                var k = 0, c = ('FirstName,LastName,Email,PhoneNumber,RoleName').split(',');
                                _.each(column, function (col) {
                                    if (k < 5) {
                                        if (!(col == c[k])) {
                                            IsInvalideFile = true;
                                        }
                                        k++;
                                    }
                                });
                            }
                            if (IsInvalideFile) {
                                toaster.pop({ type: 'error', body: "Invalid csv file." });
                                $scope.collection = [];
                                $scope.column = [];
                                return
                            }
                            for (var i = 1; i < list.length; i++) {
                                var item = { Selected: true, ShowPracticeWorklist: true, DoNotSendPaymentSummary: false, EnableTwoFactorAuthentication: false }
                                var value = list[i].split("\"");

                                if (value.length == 1) {
                                    value = value[0].split(",");
                                }
                                else if (value.length == 3) {
                                    var tempVal = value[0].split(",");
                                    tempVal[4] = value[1].replaceAll(" ", "");
                                    value = tempVal;
                                }
                                if (value.length == column.length) {
                                    for (var j = 0; j < 5; j++) {
                                        item[column[j]] = value[j];
                                    }
                                    Collection.push(item);
                                }
                            }
                            $scope.column = column;
                            $scope.SelectedTenantBulk = { Obj: [] };
                            $scope.MultiSelectDropdowns.TenantBulkInvite.SelectedValue = {
                                list: []
                            };
                            $scope.collection = Collection
                            vm.selectedAtOne = true;
                            vm.SelectedALL = true;
                        });
                    };
                    //reader.readAsDataURL(file);
                    reader.readAsText(file, "UTF-8");
                });

            }
        };
        $scope.downloadSampleFile = function () {
            var text = 'FirstName,LastName,Email,PhoneNumber,RoleName\nUser1,User1,User1@test.com,+19876543210,"Role1"\nUser2,User2,User2@test.com,+19876543211,"Role1,Role2"'
            //var url = 'data:application/octet-stream;charset=utf-8;base64,' + btoa(text);
            //window.open(url,'Sample.csv');
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', 'Sample.csv');
            document.body.appendChild(element);
            element.click()
        }
        $scope.onSelectAll = function () {
            _.each($scope.collection, function (c) {
                c.Selected = vm.SelectedALL;
            });
            vm.selectedAtOne = vm.SelectedALL;
        }

        $scope.onSelect = function () {
            if (_.filter($scope.collection, function (c) { return c.Selected == false }).length > 0) {
                vm.SelectedALL = false;
            } else {
                vm.SelectedALL = true;
            }
            vm.selectedAtOne = false;
            if (_.filter($scope.collection, function (c) { return c.Selected == true }).length > 0) {
                vm.selectedAtOne = true;
            }
        }

        vm.OnSelectSite = function (item) {
            _.each($scope.collection, function (c) {
                if (c.Selected) {
                    if (!c.Site) {
                        c.Site = [];
                    }
                    var idx = -1;
                    if (c.Site.length != 0) {
                        idx = _.findIndex(c.Site, { 'Site': item.Site });
                    }
                    if (idx == -1) {
                        c.Site.push(item);
                    }
                }
            });
        }
        vm.OnRemovedSite = function (item) {
            _.each($scope.collection, function (c) {
                if (c.Selected) {
                    if (c.Site && c.Site.length > 0) {
                        var idx = _.findIndex(c.Site, function (s) { return s.SiteID == item.SiteID });
                        c.Site.splice(idx, 1);
                    }
                }
            });
        }
        function MappingSites(userId, newUser) {
            var ids = "", Sites = newUser.Sites ? newUser.Sites : newUser.Site, ShowPracticeWorklist = newUser.ShowPracticeWorklist, DoNotSendPaymentSummary = newUser.DoNotSendPaymentSummary, EnableTwoFactorAuthentication = newUser.EnableTwoFactorAuthentication;
            ids = _.join(_.map(Sites, function (site) { return site.SiteID; }), ',');
            var promiseResponse = ProfileService.MapUserSites(ids, userId);
            promiseResponse.then(function (resp) {
                //swal('Selected sites mapped with users.');
            });
            AddEditUserPreferences(setPreferance(userId, ShowPracticeWorklist, DoNotSendPaymentSummary, EnableTwoFactorAuthentication)).then(function (result) {
                $scope.isLoading = false;
            });
            $scope.$broadcast("UpdateUserList", null);
        };
        function setPreferance(userId, ShowPracticeWorklist, DoNotSendPaymentSummary, EnableTwoFactorAuthentication) {
            var userPreferences = [];
            //Choose Next Study
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "Choose Next Study", UserID: userId, PreferenceValue: "1", });
            //SendDefaultAlertforOncall    
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "SendDefaultAlertforOncall", UserID: userId, PreferenceValue: "1", });
            //DefaultWorklist
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "DefaultWorklist", UserID: userId, PreferenceValue: "PSW", });
            //ShowLockStudy
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "ShowLockStudy", UserID: userId, PreferenceValue: "1", });
            //Worklist Lite
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "LoadMoreWorklist", UserID: userId, PreferenceValue: "1", });
            //PushToTalk
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "PushToTalk", UserID: userId, PreferenceValue: "1", });
            //DoNotShowStudyAssignedToOtherUsers
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "DoNotShowStudyAssignedToOtherUsers", UserID: userId, PreferenceValue: "1", });
            //ShowPracticeWorklist
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "ShowPracticeWorklist", UserID: userId, PreferenceValue: ShowPracticeWorklist ? "1" : "0" });
            //DoNotSendPaymentSummary
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "DoNotSendPaymentSummary", UserID: userId, PreferenceValue: DoNotSendPaymentSummary ? "1" : "0" });
            //EnableTwoFactorAuthentication
            userPreferences.push({ UserPreferenceID: "-1", PreferenceType: "EnableTwoFactorAuthentication", UserID: userId, PreferenceValue: EnableTwoFactorAuthentication ? "1" : "0" });
            return userPreferences;
        };
        $scope.InviteAll = function () {
            _.each($scope.collection, function (newUser) {
                newUser.Message = "";
                newUser.Password = generatePassword();
                newUser.ConfirmPassword = newUser.Password;
                newUser.UserName = newUser.Email;
                if (!newUser.FirstName) {
                    newUser.Message = 'First name is required.';
                }
                if (!newUser.LastName) {
                    newUser.Message = 'Last name is required.';
                }
                if (!newUser.Email) {
                    newUser.Message = 'Email is required.';
                }
                if (!newUser.RoleName) {
                    newUser.Message = 'Role is required.';
                }
                if (newUser.PhoneNumber && newUser.PhoneNumber.substr(0, 1) !== '+') {
                    newUser.Message = 'Please enter country code with phonenumber! eg. +1xxxxxxxxxx';
                }
                if (newUser.Password != newUser.ConfirmPassword) {
                    newUser.Message = "New & confirm password must be same!";
                }
                if (newUser.SelectedTenant) {
                    newUser.TenantIDList = [];
                    _.each(newUser.SelectedTenant.Obj, function (tenant) {
                        newUser.TenantIDList.push(tenant.TenantID);
                    })
                }
                if (newUser.RoleName) {
                    var ValidRoleList = _.join(_.map($scope.RolesList, function (role) { return role.Name; }), ',');

                    var isValidRole = true;

                    _.each(newUser.RoleName.split(","), function (role) {
                        if (!ValidRoleList.includes(role)) {
                            isValidRole = false;
                        }
                    });

                    if (!isValidRole) {
                        newUser.Message = "User Role is not valid!";
                    }
                }
                if (!newUser.Message) {
                    // The auth server bases the invitation link on this address when its host is trusted.
                    newUser.AppUrl = window.location.origin;
                    var promiseResponse = AccountManagerService.CreateUser(newUser);
                    promiseResponse.then(function (resp) {
                        if (resp && resp.data) {
                            MappingSites(resp.data, newUser)
                            newUser.IsInvited = true;
                            logUserEvent("INVITE USER", resp.data);
                        }
                    }, function (error) {
                        if (error && error.data && error.data.Message) {
                            newUser.Message = error.data.Message;
                        }
                    });
                }
            });
        }
        $scope.TenantSiteList = function (SelectedTenants) {
            $scope.SitesByTenants = [];
            var seletedSiteByTenant = [];

            _.each(SelectedTenants, function (tenant) {
                var sites = _.filter($scope.AllSites, { "TenantName": tenant.DisplayName });
                _.each(sites, function (site) { $scope.SitesByTenants.push(site); });

                if ($scope.NewUser) {
                    var selectedSites = _.filter($scope.NewUser.Sites, { "TenantName": tenant.DisplayName });
                    _.each(selectedSites, function (site) { seletedSiteByTenant.push(site); });
                }
            });
            if ($scope.NewUser) {
                $scope.NewUser.Sites = seletedSiteByTenant;
                $scope.MultiSelectDropdowns.SiteInviteUser.SelectedValue = {
                    list: seletedSiteByTenant
                };
            }
        }
        $scope.CloseInviteUser = function () {
            $scope.SelectedTenant.Obj = [];
            $scope.MultiSelectDropdowns.TenantInviteUser.SelectedValue = {
                list: []
            };
            $scope.NewUser.Sites = [];
            vm.Message = null;
            $scope.SitesByTenants = null;
            $scope.NewUser.ShowPracticeWorklist = true;
            $scope.MultiSelectDropdowns.RoleInviteUser.SelectedValue = {
                list: []
            };
            $scope.MultiSelectDropdowns.SiteInviteUser.SelectedValue = {
                list: []
            };
            $scope.NewUser.DoNotSendPaymentSummary = true;
            $scope.NewUser.EnableTwoFactorAuthentication = false;
        }
        $scope.SiteSelect = function (SelectedTenants) {
            if (SelectedTenants && SelectedTenants.length != 0) {
                $scope.TenantSiteList(SelectedTenants);
            } else {
                $scope.SitesByTenants = [];
            }
        }
        $scope.OnSelectTenant = function (tenant) {
            _.each($scope.collection, function (c) {
                if (c.Selected) {
                    if (!c.SelectedTenant) {
                        c.SelectedTenant = {};
                        c.SelectedTenant.Obj = [];
                    }
                    if (!c.SelectedTenant.Obj) {
                        c.SelectedTenant.Obj = [];
                    }
                    var idx = -1;
                    if (c.SelectedTenant.Obj.length != 0) {
                        idx = _.findIndex(c.SelectedTenant.Obj, { 'DisplayName': tenant.DisplayName });
                    }
                    if (idx == -1) {
                        c.SelectedTenant.Obj.push(tenant);
                    }
                }
            });
        }
        $scope.OnRemovedTenant = function (item, index) {
            if (index == undefined) {
                _.each($scope.collection, function (c) {
                    if (c.Selected) {
                        if (c.SelectedTenant.Obj && c.SelectedTenant.Obj.length > 0) {
                            var idx = _.findIndex(c.SelectedTenant.Obj, function (s) { return s.TenantID == item.TenantID });
                            if (idx != -1) {
                                c.SelectedTenant.Obj.splice(idx, 1);
                            }
                        }
                        vm.Sites = _.filter(vm.Sites, function (site) {
                            return site.TenantName != item.DisplayName;
                        });
                        $scope.MultiSelectDropdowns.SiteBulkInvite.SelectedValue = {
                            list: vm.Sites
                        };
                        c.Site = _.filter(c.Site, function (site) {
                            return site.TenantName != item.DisplayName;
                        });
                    }
                });
            } else {
                $scope.collection[index].Site = _.filter($scope.collection[index].Site, function (site) {
                    return site.TenantName != item.DisplayName;
                });
            }
        }
        $scope.disableInvitation = function () {
            var disableBtn = true;
            var breakLoop = false;
            _.each($scope.collection, function (item) {
                if (!breakLoop && item.Selected) {
                    if ((item.SelectedTenant && item.SelectedTenant.Obj && item.SelectedTenant.Obj.length != 0) && (item.Site && item.Site.length != 0)) {
                        disableBtn = false;
                    } else {
                        disableBtn = true;
                        breakLoop = true;
                    }
                }

            })
            return disableBtn;
        }
        //For bulk invite button
        $scope.clearSelectedTenantObj = function (index) {
            $scope.collection[index].SelectedTenant.Obj = null;
            $scope.collection[index].Site = null;
            // $scope.clearSelectedSite();
        }
        $scope.clearSelectedSite = function (index) {
            $scope.collection[index].Site = null;
        }

        //For invite User button
        //$scope.clearTenant = function () {
        //    $scope.SelectedTenant.Obj = [];
        //    $scope.MultiSelectDropdowns.TenantUserSettings.SelectedTenant = [];
        //    $scope.clearSite(true);
        ////}
        //$scope.clearSite = function (ClearSitesFlag) {

        //    $scope.NewUser.Sites = null;
        //}
        //$scope.clearAllTenantBtn = function (selectedTenant) {
        //    if (!selectedTenant || selectedTenant.length == 0) {
        //        return false;
        //    }
        //    else {
        //        return true;
        //    }
        //}
        $scope.clearAllSiteBtn = function (site) {
            if (!site || site.length == 0) {
                return false;
            }
            else {
                return true;
            }
        }
        function GetAllRoles() {
            AccountManagerService.GetAllRoles().then(function (result) {
                if (result && result.data) {
                    $scope.RolesList = result.data;
                }
            });
        }
        function AddEditUserPreferences(userPreferences) {
            var d = $q.defer();
            UserPreferenceService.AddEditUserPreferences(userPreferences).then(function (result) {
                d.resolve();
            }, function (err) {
                d.reject(err);
            });
            return d.promise;
        }
        //#region Diacom Viewer Grid
        var editingRow = {};
        var addNewRowTxt = "Add New";
        var rowId = -1;
        var DicomViewerColDef = [
            {
                field: "DicomViewer",
                editable: function (params) {
                    return (params.data.DicomViewer != addNewRowTxt) ? true : false;
                },
                cellEditor: ViewerEditor(),
                cellEditorPopup: true,
                initialWidth: 200,
                cellRenderer: function (params) {
                    if (params.data.DicomViewer != addNewRowTxt) {
                        if ($scope.DataObject.SelectedViewer) {
                            params.data.selectedViewer = $scope.DataObject.SelectedViewer;
                            params.data.DicomViewer = $scope.DataObject.SelectedViewer.Key;
                        }
                        return params.data.DicomViewer;
                    } else {
                        return '<span class="fw-600"><i class="fa fa-plus"></i> ' + params.data.DicomViewer + '</span>';
                    }
                },
            },
            {
                field: "Username",
                editable: function (params) {
                    return (params.data.DicomViewer != addNewRowTxt) ? true : false;
                },
                cellEditor: UserNameEditor(),
                cellRenderer: function (params) {
                    var template = "<div>";
                    if (params.data && params.data.Username) {
                        template = template + "<span class='p-4px-all mlp-value-box mr-4px text-nowrap'>" + params.data.Username + "</span>";
                    }
                    template = template + "</div>";
                    return template;
                },
                cellEditorPopup: true,
                flex: 1,
                wrapText: true,
                autoHeight: true,
            }, {
                field: "Password",
                editable: function (params) {
                    return (params.data.DicomViewer != addNewRowTxt) ? true : false;
                },
                cellEditor: PasswordEditor(),
                cellRenderer: function (params) {
                    var template = "<div>";
                    if (params.data && params.data.Password) {
                        template = template + "<span class='p-4px-all mlp-value-box mr-4px text-nowrap'>" + '*'.repeat(params.data.Password.length) + "</span>";
                    }
                    template = template + "</div>";
                    return template;
                },
                cellEditorPopup: true,
                flex: 1,
                wrapText: true,
                autoHeight: true,
            },
            {
                field: "Action",
                cellRenderer: function (params) {
                    if (params.data.DicomViewer != addNewRowTxt) {
                        return '<i class="fa fa-trash-o txt-clr-31 cursor-pointer fs-16px" aria-hidden="true" title="Delete"></i>';
                    }
                },
                initialWidth: 100,
            }
        ];

        var DicomViewerGridSettingOption = {
            columnDefs: DicomViewerColDef,
            rowHeight: 36,
            defaultColDef: {
                sortable: false,
                lockVisible: true,
                suppressMovable: true,
                suppressMenu: true,
                resizable: false,
            },
            suppressClickEdit: true,
            onGridReady: function () {
                DicomViewerGridSettingOption.api.setPinnedBottomRowData([{
                    DicomViewer: addNewRowTxt,
                    Username: "",
                    Password: "",
                    rowColor: "#1c1c1c"
                }])
            },
            getRowStyle: function (params) {
                if (params && params.data && params.data.rowColor) {
                    return {
                        paddingTop: '4px',
                        background: params.data.rowColor
                    };
                }
            },
            getRowId: function (params) {
                rowId++;
                if (params && params.data && !params.data.hasOwnProperty('ID')) {
                    params.data.ID = rowId.toString();
                }
                if (params.data.hasOwnProperty('ID')) {
                    return params.data.ID;
                }
            },
            onCellClicked: function (params) {
                params.api.stopEditing();
                if (params.data.DicomViewer == addNewRowTxt) {
                    var renderedRows = DicomViewerGridSettingOption.api.getRenderedNodes();
                    if (renderedRows.length != DicomViewerFullList.length) {
                        AddViewerSiteMapping();
                    }
                }
                else {
                    switch (params.column.colId) {
                        case "Action":
                            DicomViewerGridSettingOption.api.applyTransaction({
                                remove: [{ ID: params.node.data.ID }]
                            });
                            if (DicomViewerGridSettingOption.api.getRenderedNodes().length < 2) {
                                document.getElementsByClassName('ag-row-pinned ag-row-level-0')[0].classList.remove('disable-checkbox');
                            }
                            $scope.DataObject.SelectedViewer = null;
                            $scope.DataObject.DVCredUsername = null;
                            $scope.DataObject.DVCredPassword = null;
                            break;
                        case "DicomViewer":
                            params.api.startEditingCell({
                                rowIndex: params.rowIndex,
                                colKey: params.column.colId
                            });
                            break;
                        case "Username":
                            if (params.data.selectedViewer) {
                                params.api.startEditingCell({
                                    rowIndex: params.rowIndex,
                                    colKey: params.column.colId
                                });
                                document.getElementById('DVCredUsername').focus();
                            }
                            else {
                                toaster.warning("Please Select Dicom Viewer!");
                                params.api.startEditingCell({
                                    rowIndex: params.rowIndex,
                                    colKey: "DicomViewer"
                                });
                            }
                            break;
                        case "Password":
                            if (params.data.selectedViewer) {
                                params.api.startEditingCell({
                                    rowIndex: params.rowIndex,
                                    colKey: params.column.colId
                                });
                                document.getElementById('DVCredPassword').focus();
                            }
                            else {
                                toaster.warning("Please Select Dicom Viewer!");
                                params.api.startEditingCell({
                                    rowIndex: params.rowIndex,
                                    colKey: "DicomViewer"
                                });
                            }
                            break;
                    }
                }
            },
            onCellEditingStarted: function (params) {
                editingRow = params.node.data;
                if (params.column.colId == "DicomViewer") {
                    var timeout = $timeout(function () {
                        $scope.DataObject.SelectedViewer = params.data.selectedViewer;
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 0);

                    $scope.DataObject.InstDicomViewerList = DicomViewerFullList;
                    DicomViewerGridSettingOption.api.forEachNode(function (node) {
                        if (node.data.selectedViewer) {
                            $scope.DataObject.InstDicomViewerList = _.filter($scope.DataObject.InstDicomViewerList, function (obj) {
                                return obj.Value != node.data.selectedViewer.Value;
                            });
                        }
                    });
                    if (params.data.selectedViewer) {
                        var viewer = _.find($scope.DataObject.InstDicomViewerList, { Value: params.data.selectedViewer.Value });
                        if (!viewer) {
                            var viewer = _.find(DicomViewerFullList, { Value: params.data.selectedViewer.Value });
                            if (viewer) {
                                $scope.DataObject.InstDicomViewerList.push(viewer);
                            }
                        }
                    }
                    sortDicomViewer();
                }
                else if (params.column.colId == "Username") {
                    var timeout = $timeout(function () {
                        $scope.DataObject.DVCredUsername = params.data.Username;
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 0);
                }
                else if (params.column.colId == "Password") {
                    var timeout = $timeout(function () {
                        $scope.DataObject.DVCredPassword = params.data.Password;
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 0);
                }
            },
            onCellEditingStopped: function (params) {
                editingRow = {};
                if (params.column.colId == "DicomViewer") {
                    $scope.DataObject.SelectedViewer = null;
                }
                else if (params.column.colId == "Username") {
                    $scope.DataObject.DVCredUsername = null;
                }
                else if (params.column.colId == "Password") {
                    $scope.DataObject.DVCredPassword = null;
                }
            },
            getContextMenuItems: function () { return [] },
            rowData: [],
        }

        function ViewerEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                $scope.DataObject.InstDicomViewerList = _.uniqBy($scope.DataObject.InstDicomViewerList, 'ID');
                this.eGui = document.createElement('div');
                //this.eGui.className = "dicom-viewer-dropdown";
                this.eGui.innerHTML =
                    '<ui-select class="viewer-editor mult-select provider-select seltype-drop mob-closekeypad" style ="width: 180px !important;" ng-model="DataObject.SelectedViewer" on-select="onSelectViewer();">' +
                    '<ui-select-match placeholder="Select Viewer" allow-clear="false">' +
                    '{{$select.selected.Key}}' +
                    '</ui-select-match>' +
                    '<ui-select-choices repeat="viewer in DataObject.InstDicomViewerList | filter: {Key: $select.search} track by $index"> ' +
                    '<div ng-bind-html="viewer.Key | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>';

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                var val = editingRow.DicomViewer;
                if ($scope.DataObject.SelectedViewer && $scope.DataObject.SelectedViewer.Value) {
                    val = $scope.DataObject.SelectedViewer.Key;
                }
                return val;
            }
            return CustomEditor;
        }

        function UserNameEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.innerHTML = '<input type="text" id="DVCredUsername" name="DVCredUsername" ng-model="DataObject.DVCredUsername" ng-required="true" class="blk-input form-control dicom-username" style="width: 125px;" autocomplete="off" placeholder="Username"/>';
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                var val = editingRow.Username;
                if ($scope.DataObject.DVCredUsername && $scope.DataObject.DVCredUsername) {
                    val = $scope.DataObject.DVCredUsername;
                }
                return val;
            }
            return CustomEditor;
        }

        function PasswordEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.innerHTML = '<input type="password" id="DVCredPassword" name="DVCredPassword" ng-model="DataObject.DVCredPassword" ng-required="true" class="blk-input form-control dicom-password" style="width: 125px;" autocomplete="new-password" placeholder="Password"/>';

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                var val = editingRow.Password;
                if ($scope.DataObject.DVCredPassword && $scope.DataObject.DVCredPassword) {
                    val = $scope.DataObject.DVCredPassword;
                }
                return val;
            }
            return CustomEditor;
        }

        function AddViewerSiteMapping() {
            if (DicomViewerGridSettingOption && DicomViewerGridSettingOption.api) {
                DicomViewerGridSettingOption.api.stopEditing();

                if (DicomViewerGridSettingOption.api.getRenderedNodes().length == 0) {
                    $scope.DataObject.SelectedViewer = _.find($scope.DataObject.InstDicomViewerList, { Key: 'Azure Konica' });
                }
                else {
                    var nodes = DicomViewerGridSettingOption.api.getRenderedNodes();
                    if (nodes && nodes.length > 0) {
                        $scope.DataObject.SelectedViewer = _.find($scope.DataObject.InstDicomViewerList, function (viewer) { return viewer.Key != nodes[0].data.DicomViewer });
                    }
                }

                DicomViewerGridSettingOption.api.applyTransaction({
                    add: [{
                        DicomViewer: $scope.DataObject.SelectedViewer.Key,
                        Username: "",
                        Password: "",
                        selectedViewer: $scope.DataObject.SelectedViewer,
                    }],
                });

                if (DicomViewerGridSettingOption.api.getRenderedNodes().length == 2) {
                    document.getElementsByClassName('ag-row-pinned ag-row-level-0')[0].classList.add('disable-checkbox');
                }
            }
        }

        $scope.onSelectViewer = function () {
            DicomViewerGridSettingOption.api.stopEditing();
        }

        function sortDicomViewer() {
            $scope.DataObject.InstDicomViewerList.sort(
                function (a, b) {
                    if (a.Key && b.Key && a.Key.toLowerCase() < b.Key.toLowerCase()) return -1;
                    if (a.Key && b.Key && a.Key.toLowerCase() > b.Key.toLowerCase()) return 1;
                    return 0;
                }
            );
        }
        // Initialize controller
        $(document).ready(function () {
            document.addEventListener('click', onDocumentClick);
            function onDocumentClick(event) {
                if (event && event.target && !event.target.closest("#resetPwdBtn")) {
                    $scope.DataObject.isResetPwdMenuVisible = false;
                }
            }
            var userListDiv = document.getElementById('user-list-div');
            if (userListDiv) {
                userListDiv.addEventListener('wheel', function () {
                    var timeout = $timeout(function () {
                        $scope.DataObject.isResetPwdMenuVisible = false;
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 0);
                });
            }
        });


        accountlistCtrlinit();

        function logUserEvent(eventName, toUserId) {
            var userId = $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '';
            if (userId) {
                var UserEventLog = [{
                    FromUserID: userId,
                    ToUserID: toUserId || userId,
                    EventName: eventName
                }];
                AccountManagerService.AddUserEvent(UserEventLog);
            }
        }

        $scope.$on('$destroy', function () {
            CommonService.stopNotifyTATStudy();
        });

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }

})();

(function () {
    "use strict";

    AccountManagerService.$inject = ['Restangular', '$http', '$q', '$window', '$rootScope', '$sessionStorage', 'APP_CONSTANTS', '__env'];

    function AccountManagerService(Restangular, $http, $q, $window, $rootScope, $sessionStorage, APP_CONSTANTS, __env) {
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }

        function urlAPI() {
            return __env._environment.config.apiResourceServiceBaseUri;
        }

        function urlBase() {
            return '/api/ChatGroup';
        }

        var dataFactory = {};
        var isEnter = false;
        var number = 0;

        var objUsersList;

        dataFactory.getAllUsers = function () {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/GetUsers',
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };

        dataFactory.getOnlineUsers = function () {
            return $http({
                method: 'get',
                url: urlAPI() + 'User/GetOnlineUsers',
                headers: { 'content-type': 'application/json' }
            });
        };

        dataFactory.CreateUser = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/InviteUser',
                data: JSON.stringify(strProviderJson),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };

        dataFactory.UpdateUserTenant = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/UpdateUserTenant',
                data: JSON.stringify(strProviderJson),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.BlockUser = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/BlockUser',
                data: JSON.stringify(strProviderJson),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.UpdateUser = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/UpdateUser',
                data: JSON.stringify(strProviderJson),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.UpdateUserContact = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/UpdateUserContact',
                data: JSON.stringify(strProviderJson),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.ResetPassword = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/ChangePasswordByAdmin',
                data: JSON.stringify(strProviderJson),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.ResetUserPassword = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/ChangePassword',
                data: JSON.stringify(strProviderJson),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.getAllUsers = function (userFilter) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/GetAllUsers',
                data: JSON.stringify(userFilter),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.ReInviteUser = function (UserId) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/ReInviteUser',
                // AppUrl: the auth server bases the invitation link on this address when its host is trusted.
                data: JSON.stringify({ UserId: UserId, AppUrl: $window.location.origin }),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.GetAllRoles = function (UserId) {
            return $http({
                method: 'get',
                url: urlCore() + '/api/roles',
                headers: {
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.UpdateUserVendorDetail = function (strProviderJson) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/UpdateUserVendorDetail',
                data: JSON.stringify(strProviderJson),
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.AddUserEvent = function (data) {
            return $http({
                method: 'post',
                url: urlCore() + '/api/Account/AddUserEvent',
                data: data,
                headers: {
                    'content-type': 'application/json',
                    'Ocp-Apim-Subscription-Key': __env.OcpApimSubscriptionKey,
                }
            });
        };
        dataFactory.GetTenantsUserList = function (filter) {
            return Restangular.one("Settings").one("GetTenantsUserList").customPOST(filter);
        }
        // New: returns only the fields the Account Manager grid uses (task 170878 follow-up).
        // GetTenantsUserList above is left untouched.
        dataFactory.GetTenantsUserListSummary = function (filter) {
            return Restangular.one("Settings").one("GetTenantsUserListSummary").customPOST(filter);
        }
        dataFactory.SendResetPasswordLink = function (filter) {
            return Restangular.one("User").one("SendResetPasswordLink").customPOST(filter);
        }
        return dataFactory;
    }

    // Register the service to the 'app' module.
    angular.module('radico.pages.account.list').factory('AccountManagerService', AccountManagerService);
})();
(function () {
    'use strict';

    angular.module('radico.pages.addressbook.list')
        .controller('AddressBookListController', AddressBookListController);
    function AddressBookListController($q, $scope, $sessionStorage, toaster, $timeout, AddressBookListService, $filter, CommonService, SharedService) {

        $scope.SelectedLocationValues = { SelectedItems: [] };
        var ContactCsvFile = [];
        $scope.MultiSelectDropdowns = {
            ModalityAddressBookFilter: {
                divId: "ModalityAddressBookFilter",
                keys: ['Code'],
                uniqKey: 'Code',
                placeHolder: "Select Modalities",
                SelectedValue: { list: [] },
            },
            DeptAddressBookFilter: {
                divId: "DeptAddressBookFilter",
                keys: ['Value'],
                uniqKey: 'ID',
                placeHolder: "Select Department",
                SelectedValue: { list: [] },
            },
        }
        $scope.FilterAddressBook = {
            Name: '',
            LocationIDs: null,
            Location: null,
            Modalities: null,
            Departments: null,
        };
        $scope.AddressBookInfo = {
            SelectedData: {},
            ContactPreferenceType: {},
        };
        $scope.ModalTitle = "Add New Contact";
        $scope.EditMode = false;
        $scope.SelectedValue = { Modality: null, Department: null };

        $scope.SelectedLocations = {
            Ids: '',
            locations: [],
            divId: "addressBookPage"
        }

        var MasterData = {};
        var ToasterMessage = "Contact saved successfully!";
        var TimeoutList = [];

        function PageInIt() {
            CommonService.startNotifyTATStudy();
            GetSitesAndLocation();
            getModality();
            getLookupByType();
        }
        $scope.OpenContactModal = function () {
            $scope.EditMode = true;
            $scope.AddressBookInfo.SelectedData = {};
            ToasterMessage = "Contact saved successfully!";
            $scope.ModalTitle = "Add New Contact";
        };
        function GetSitesAndLocation() {
            var d = $q.defer();
            AddressBookListService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                MasterData.Locations = _.filter(result, function (obj) { return obj.SiteID != 0; });
                $scope.AddressBookInfo.Locations = MasterData.Locations;

                d.resolve();
            })
            return d.promise;
        }
        $scope.SaveContact = function () {
            if (ToasterMessage != "") { toaster.success({ body: ToasterMessage }); }
            if ($scope.AddressBookInfo.Flag == 'S') { $scope.EditMode = false; $('#ContactModal').modal('hide'); }
            else { $scope.ModalTitle = "Add New Contact"; }
            $scope.search();
        }
        $scope.clearFilter = function () {
            $scope.FilterAddressBook = {
                Name: '',
                LocationIDs: null,
                Location: null,
                Modalities: null,
                Departments: null,
            };
            $scope.SelectedValue = { Modality: [], Department: null };
            $scope.MultiSelectDropdowns.ModalityAddressBookFilter.SelectedValue = {
                list: [],
            };
            $scope.MultiSelectDropdowns.DeptAddressBookFilter.SelectedValue = {
                list: [],
            };
            $scope.SelectedLocations = {
                Ids: '',
                locations: [],
                divId: "addressBookPage"
            }
        };

        $scope.EditContact = function () {
            $scope.EditMode = true;
            $scope.ModalTitle = "Edit Contact";
            ToasterMessage = "Contact updated successfully!";
            $('#ContactModal').modal('show');
        };

        $scope.DeleteContact = function () {
            ToasterMessage = "Contact deleted successfully!";
            $scope.SaveContact();
        };

        $scope.search = function () {
            var modalityid = '';
            var departmentkey = '';

            if ($scope.SelectedValue && $scope.SelectedValue.Modality) {
                _.each($scope.SelectedValue.Modality, function (code) {
                    if (modalityid) {
                        modalityid += "," + code.Id;
                    }
                    else {
                        modalityid = code.Id;
                    }
                })
            }
            if ($scope.SelectedValue && $scope.SelectedValue.Department) {
                _.each($scope.SelectedValue.Department, function (department) {
                    if (departmentkey) {
                        departmentkey += "," + department.Key;
                    }
                    else {
                        departmentkey = department.Key;
                    }
                })
            }
            $scope.FilterAddressBook = {
                Name: $scope.FilterAddressBook.Name,
                LocationIDs: $scope.FilterAddressBook.LocationIDs,
                Location: $scope.FilterAddressBook.Location,
                ModalityIDs: modalityid,
                Departments: departmentkey,
            };
        }

        function getModality() {
            AddressBookListService.GetModality().then(function (result) {
                $scope.AddressBookInfo.Modality = result;
            });
        }

        function getLookupByType() {
            AddressBookListService.GetLookupByType('ContactPreferenceType,ContactDepartmentType').then(function (result) {
                $scope.AddressBookInfo.ContactPreferenceType = _.filter(result, { Type: 'ContactPreferenceType' });
                $scope.AddressBookInfo.ContactDepartmentType = $filter('orderBy')(_.filter(result, { Type: 'ContactDepartmentType' }), 'Value');
            });
        }

        $scope.ExportCSVDemo = function () {
            var text = "Location,Modality,Department,FirstName,LastName,OfficePhone,MobilePhone,Email,ContactPreferenceType";
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', 'Sample.csv');
            document.body.appendChild(element);
            element.click()
        }
        $scope.uploadFile = function (input) {
            if (input.files && input.files.length > 0) {
                var toast = toaster.pop(
                    {
                        type: 'info',
                        body: "File is uploading...",
                        timeout: 0,
                    }
                );

                angular.forEach(input.files, function (file) {
                    var reader = new FileReader();
                    reader.onload = function () {
                        $scope.$apply(function ($scope) {
                            document.getElementById("fileInput").value = null;
                            var list = reader.result.split(/\r?\n/);
                            if (list.length <= 1) {
                                toaster.clear(toast);
                                toaster.pop({ type: 'error', body: "Invalid csv file." });
                                return;
                            }
                            var column = list[0].split(',');
                            var IsInvalideFile = false;
                            if (column.length != 9) {
                                //This if block will verify column length
                                IsInvalideFile = true;
                            }
                            if (!IsInvalideFile) {
                                //This if block verify if column exists
                                _.each(('Location,Modality,Department,FirstName,LastName,OfficePhone,MobilePhone,Email,ContactPreferenceType').split(','), function (c) {
                                    if (!_.filter(column, function (f) { return f == c })[0]) {
                                        IsInvalideFile = true;
                                    }
                                });
                            }
                            if (!IsInvalideFile) {
                                //This if block verify column order
                                var k = 0, c = ('Location,Modality,Department,FirstName,LastName,OfficePhone,MobilePhone,Email,ContactPreferenceType').split(',');
                                _.each(column, function (col) {
                                    if (k < 9) {
                                        if (!(col == c[k])) {
                                            IsInvalideFile = true;
                                        }
                                        k++;
                                    }
                                });
                            }
                            if (IsInvalideFile) {
                                toaster.clear(toast);
                                toaster.pop({ type: 'error', body: "Invalid csv file." });
                                return;
                            } else {
                                var doc = {};
                                doc.fileContentBase64 = reader.result;
                                doc.Base64 = btoa(reader.result);
                                doc.Filename = file.name;
                                doc.Filetype = file.type;
                                ContactCsvFile.push(doc);
                                $scope.CSVFileName = file.name;
                            }
                            if (ContactCsvFile != null && ContactCsvFile.length > 0) {
                                angular.forEach(ContactCsvFile, function (doc) {
                                    var objDoc = angular.copy(doc);
                                    delete objDoc.fileContentBase64;
                                    objDoc.UploadBy = $sessionStorage.currentUserData.userId;
                                    AddressBookListService.ImportContactDetail(objDoc).then(function (response) {
                                        $scope.CSVFileName = null;
                                        ContactCsvFile = [];
                                        toaster.clear(toast);
                                        toaster.success({ body: "File uploaded successfully." });
                                        $scope.search();
                                    }).catch(function (noCantDo) {
                                        toaster.clear(toast);
                                        toaster.error({ body: "Invalid CSV file." });
                                    });
                                });
                            }
                        });
                    };
                    //reader.readAsDataURL(file);
                    reader.readAsText(file, "UTF-8");
                });
            }
        };

        $scope.ResetFileInput = function () {
            document.getElementById("fileInput").value = null;
            $scope.CSVFileName = null;
            ContactCsvFile = [];
        }

        $scope.$on('$destroy', function () {
            _.each(TimeoutList, function (timeout) {
                $timeout.cancel(timeout);
            });
            CommonService.stopNotifyTATStudy();
        });

        $scope.updateSelectedLocation = function () {
            $scope.FilterAddressBook.LocationIDs = $scope.SelectedLocations.Ids;
            $scope.FilterAddressBook.Location = $scope.SelectedLocations.locations;
        }
        $scope.onSelectedModalityFilter = function (selectedData) {
            $scope.SelectedValue.Modality = selectedData;
        }
        $scope.onSelectedDeptFilter = function (selectedData) {
            $scope.SelectedValue.Department = selectedData;
        }
        PageInIt();
        
        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }

    }
})();
angular.module('radico.pages.addressbook.list')
    .service('AddressBookListService', ['Restangular', '$http', 'APP_CONSTANTS', function (Restangular, $http, APP_CONSTANTS) {
        this.GetSitesAndLocationsByUserID = function (userID) {
            return Restangular.one('psorders').one("GetSitesAndLocationsByUserID", userID).get();
        };

        this.SetContactDetail = function (data) {
            return Restangular.one('AddressBook').one("SetContactDetail").customPOST(data);
        };

        this.GetContactDetail = function (data) {
            return Restangular.one('AddressBook').one("GetContactDetail").customPOST(data);
        };

        this.GetModality = function () {
            return Restangular.one('psorders').one("GetModality").customPOST();
        };
        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };

        this.ImportContactDetail = function (Filter) {
            return Restangular.one('AddressBook').one("ImportContactDetail").customPOST(Filter);
        };
    }]);
angular.module('auth.controllers', []);

indexController.$inject = ['$scope', '$state', '$sessionStorage', '$localStorage', 'authService', '$rootScope', '$window', 'APP_CONSTANTS', 'WorklistService', '$interval', '$timeout', '$location', 'AppHubService', 'Idle', 'chatService', 'UserPreferenceService', 'windowHandler', 'RCService', 'toaster', 'RuleService', 'CommonService', 'ReviewOrderService', 'ErrorLoggerService', '__env', '$filter', '$q', 'ProfileService', 'Keepalive', 'BillAPIService', 'RuleSharedService', 'SharedService', 'ManageLocationService', 'campaignService', '$uibModal', 'resetPasswordLinkHelper', 'pdfJsLoader', 'newsletterPopupService'];
function indexController($scope, $state, $sessionStorage, $localStorage, authService, $rootScope, $window, APP_CONSTANTS, WorklistService, $interval, $timeout, $location, AppHubService, Idle, chatService, UserPreferenceService, windowHandler, RCService, toaster, RuleService, CommonService, ReviewOrderService, ErrorLoggerService, __env, $filter, $q, ProfileService, Keepalive, BillAPIService, RuleSharedService, SharedService, ManageLocationService, campaignService, $uibModal, resetPasswordLinkHelper, pdfJsLoader, newsletterPopupService) {
    //import { initializeApp } from 'firebase/app';
    //var firebase = require("firebase/app");
    var AppHub;
    $scope.isAuthenticate = false;
    $sessionStorage.currentUserData = "";
    $scope.isFullScreen = false;
    $scope.OpenOrderDiscussions = [];
    $scope.ActionOrderDiscussions = [];
    $scope.ReplyDiscussions = [];
    $scope.ChatMessageList = [];

    $scope.isChatMenuActive = false;
    $scope.isVideoCallConnected = false;

    $sessionStorage.ShowModalIESettings = false;
    $sessionStorage.AgfaSetup = false;
    $scope.isPasscode = false;
    $scope.RadiCoParam = null;
    var _UpdateNotification;
    $scope.PendingCount = {
        PriorityCount: '',
        PracticeCount: ''
    };
    $scope.OldPriorityCount = 0;
    $scope.OldPracticeCount = 0;
    $sessionStorage.IdleTimeout = false;
    var ShowReleaseGuide = undefined;
    var ShowReleaseGuideTech = undefined;
    var ShowReleaseGuideIndex = undefined;
    var tourNavigateToWoklistLite = false;
    $scope.IsTechUser = false;
    var parser = new UAParser();
    var tourUserPref = null;
    var tourUserPrefTech = null;
    var tourUserPrefIndex = null;
    $scope.halfScale = false;
    $sessionStorage.isStartUserGuideTour = false;
    $scope.AnalyticsPopupUrl = {};
    $scope.AnalyticsWindowPopout = true;
    $scope.helpMenuCliked = false;
    var showUserGuide = {};
    var steps = [
        // Add steps in worklist page as release feature 

    ];
    var stepsTech = [
        // Add steps in techpage as release feature 

    ];
    var stepsIndex = [
        // Add steps in for indexpage as release feature 

    ];
    $sessionStorage.isPCAvailable = false;
    var ChatCurrentUserObject = {};
    $scope.AnnouncementMarqueeLookupValue = '';
    var SiteMarqueeSetting = null;
    $scope.TermsOfUseVisible = false;
    $scope.TermsOfUseContent = null;
    var LogingSuccessResult = null;
    var LoginSuccessData = null;
    $scope.LoginSuccessfully = false;

    var COC_DOC_VERSION = '2026-v1';
    var pendingLoginData = null;
    var pendingCivrRedirect = false;
    var EnableCodeOfConductTenants = [];
    var EnableCodeOfConductUserRoles = [];
    var cocContent = null;
    var pendingTermsOfUseRange = null;
    $scope.isCodeOfConductVisible = false;
    $scope.coc = {
        step: 1,
        hasScrolled: false,
        hasAgreed: false,
        typedName: '',
        userName: '',
        signatureDate: '',
        hasDrawn: false,
        isSaving: false,
        processingLogin: false,
        docLoading: false,
        docError: false
    };
    $scope._cocCanvas = null;

    $scope.$on("toogleSceen", function (evt, data) {
        $scope.isFullScreen = data;
    });

    $scope.$on("LoginSuccess", function (evt, data) {
        $scope.LoginSuccessfully = false;
        LoginSuccessData = data;

        $scope.isPasscode = false;

        var userPreference = {
            UserID: $sessionStorage.currentUserData.userId,
            // dbo.GetUserPreferences takes this as NVARCHAR(250) and splits on commas (no spaces): 151 chars used, truncation is silent.
            PreferenceType: "LoadMoreWorklist,ShowReleaseGuide,ShowUserGuide,DicomViewerCred,ShowReleaseGuideTech,ShowReleaseGuideIndex,CodeOfConduct,ShowSOS,WeeklyDocumentLastSeen,MedDreamViewerKeepOpen"
        };
        RuleService.GetAllUserByTenant(userPreference).then(function (result) {
            $sessionStorage.RadiologistsByTenant = _.join(_.map(result, function (user) { return user.Id; }), ',');
            RuleSharedService.SetCachedRadiologists(result);
        });
        //#Start
        $sessionStorage.currentUserData.HostFingerPrintHash = GetHostFingerPrintHash();
        if ($localStorage.userInfo) {
            $localStorage.userInfo = $sessionStorage.currentUserData;
        }
        WorklistService.QueryRetrieveVisible().then(function (result) {
            $sessionStorage.IsQueryRetrieveVisible = result;
        });
        tourUserPref = prepareUserTour();
        tourUserPrefTech = prepareUserTourTech();
        tourUserPrefIndex = prepareUserTourIndex();
        $scope.AnnouncementMarqueeLookupValue = '';
        $scope.isLoad = true;
        CheckIESettings(indexCtrlinit);

        $scope.isAuthenticate = true;
        $scope.DisplayName = LoginSuccessData.displayName;
        $scope.FirstName = LoginSuccessData.FirstName;
        $scope.LastName = LoginSuccessData.LastName;
        $scope.TenantName = LoginSuccessData.TenantName;
        $scope.UserName = LoginSuccessData.userName;
        $scope.Role = LoginSuccessData.roles;
        $scope.AccessToken = LoginSuccessData.accessToken;
        $scope.RefreshToken = LoginSuccessData.refreshToken;
        $scope.TokenExpiry = LoginSuccessData.expire;
        $scope.UserId = LoginSuccessData.userId;
        intiAppHub();
        _NotificationService();

        $scope.GetOrdersListPendingCount();
        $scope.ChatMessageList = [];
        setOnlineStatus($scope.UserId, true);
        getUnreadmessages();

        if (LoginSuccessData.userRoles.length > 0) {
            var allowedUser = false;
            var allowedRoleForUserPreference = ['Admin', 'SuperAdmin', 'User'];
            _.each(allowedRoleForUserPreference, function (role) {
                if (LoginSuccessData.userRoles.includes(role)) {
                    allowedUser = true;
                }
            });
            $scope.IsTechUser = !allowedUser;
            $sessionStorage.currentUserData.IsTechUser = !allowedUser;
        }
        if ($(window).width() < 1199) {
            $scope.halfScale = true;
        }




        //#End
        $q.all([
            IsAddendumRequestVisible(),
            GetUserPreferences(userPreference),
            GetSiteMarqueeSetting(),
            ProfileService.GetUserVendorDetails($sessionStorage.currentUserData.userId),
            WorklistService.GetLookupByType('TermsOfUse,CodeOfConduct'),
            ManageLocationService.GetTenantsByUserID({ UserID: $sessionStorage.currentUserData.userId }),
        ]).then(function (dataObject) {
            $rootScope.$broadcast("LoginDataReady");
            LogingSuccessResult = dataObject;
            cocContent = _.find(LogingSuccessResult[4], { Type: 'CodeOfConduct' });
            if (LogingSuccessResult[1] && LogingSuccessResult[1].EnableCodeOfConductTenants) {
                EnableCodeOfConductTenants = LogingSuccessResult[1].EnableCodeOfConductTenants.split(',');
            }
            if (LogingSuccessResult[1] && LogingSuccessResult[1].EnableCodeOfConductUserRoles) {
                EnableCodeOfConductUserRoles = LogingSuccessResult[1].EnableCodeOfConductUserRoles.split(',');
            }
            if (LogingSuccessResult[1] && LogingSuccessResult[1].OverdueReadsWorklistTenantNames) {
                $sessionStorage.OverdueReadsWorklistTenantNames = LogingSuccessResult[1].OverdueReadsWorklistTenantNames;
            } else {
                delete $sessionStorage.OverdueReadsWorklistTenantNames;
            }
            if (LogingSuccessResult[1] && LogingSuccessResult[1].OverdueReadsWorklistUserRoles) {
                $sessionStorage.OverdueReadsWorklistUserRoles = LogingSuccessResult[1].OverdueReadsWorklistUserRoles;
            } else {
                delete $sessionStorage.OverdueReadsWorklistUserRoles;
            }
            $sessionStorage.EnableOverduesWorklist = !!(LogingSuccessResult[1] && LogingSuccessResult[1].EnableOverduesWorklist);
            $sessionStorage.HasSOLAccess = !!(LogingSuccessResult[1] && LogingSuccessResult[1].HasSOLAccess);
            if (LogingSuccessResult[1]) { __env.EnableEnforceReads = !!LogingSuccessResult[1].EnableEnforceReads; }
            if (LogingSuccessResult[1]) { __env.MedDreamUseCommunicationAPI = !!LogingSuccessResult[1].MedDreamUseCommunicationAPI; }
            if (LogingSuccessResult[1]) { __env.MedDreamUseHangingProtocol = !!LogingSuccessResult[1].MedDreamUseHangingProtocol; }
            if (LogingSuccessResult[1]) { __env.EnableRadPodNewsletter = !!LogingSuccessResult[1].EnableRadPodNewsletter; }
            if (LogingSuccessResult[1]) {
                __env.CampaignEnabled      = !!LogingSuccessResult[1].CampaignEnabled;
                __env.CampaignAnnounceDate = LogingSuccessResult[1].CampaignAnnounceDate || '';
                __env.CampaignStartDate    = LogingSuccessResult[1].CampaignStartDate    || '';
                __env.CampaignEndDate      = LogingSuccessResult[1].CampaignEndDate      || '';
                __env.CampaignName         = LogingSuccessResult[1].CampaignName         || '';
                __env.AllowedChatFileTypes = LogingSuccessResult[1].AllowedChatFileTypes || '';
            }
            if (Array.isArray(LogingSuccessResult[5]) && LogingSuccessResult[5].length > 0) {
                $sessionStorage.userTenantNames = LogingSuccessResult[5].map(function(t) { return t.Name; }).filter(Boolean).join(',');
            } else {
                delete $sessionStorage.userTenantNames;
            }
            var result = LogingSuccessResult[1];
            $scope.TermsOfUseContent = _.find(LogingSuccessResult[4], { Type: 'TermsOfUse' });
            pendingTermsOfUseRange = result.OnLoginTermsOfUse;

            checkAndProceedAfterLogin(LoginSuccessData);

            var _campaignEnabled = LogingSuccessResult[1] && LogingSuccessResult[1].CampaignEnabled;
            var _campaignStart   = LogingSuccessResult[1] && new Date(LogingSuccessResult[1].CampaignStartDate);
            var _campaignEnd     = LogingSuccessResult[1] && new Date(LogingSuccessResult[1].CampaignEndDate);
            var _now             = new Date();

            // The popup is offered from the announce date (when configured and earlier than the
            // start) until the end date. Whether standings are live is the API's call (IsLive):
            // before the start date the popup shows the announcement only.
            var _announceRaw     = LogingSuccessResult[1] && LogingSuccessResult[1].CampaignAnnounceDate;
            var _campaignAnnounce = _announceRaw ? new Date(_announceRaw) : null;
            var _windowStart     = (_campaignAnnounce && !isNaN(_campaignAnnounce.getTime()) && _campaignAnnounce <= _campaignStart)
                ? _campaignAnnounce : _campaignStart;

            var _tenantNames = ($sessionStorage.userTenantNames || '').split(',');
            var _isRadPodUser = _tenantNames.indexOf('RadPod') !== -1;
            var _userRoles = (LoginSuccessData && LoginSuccessData.userRoles) || [];
            var _hasAllowedRole = _userRoles.indexOf('User') !== -1 || _userRoles.indexOf('Admin') !== -1 || _userRoles.indexOf('SuperAdmin') !== -1;

            console.log('[Campaign] enabled:', _campaignEnabled, '| isRadPod:', _isRadPodUser, '| hasRole:', _hasAllowedRole, '| now:', _now, '| announce:', _campaignAnnounce, '| start:', _campaignStart, '| end:', _campaignEnd);

            if (_campaignEnabled && _isRadPodUser && _hasAllowedRole && _windowStart && _campaignEnd && _now >= _windowStart && _now <= _campaignEnd) {
                var _userId = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId)
                    || (LoginSuccessData && LoginSuccessData.userId);
                console.log('[Campaign] gate passed — calling API for userId:', _userId);
                if (!_userId) { console.log('[Campaign] no userId, skipping'); return; }
                campaignService.getStats(_userId)
                    .then(function (resp) {
                        console.log('[Campaign] API response:', resp && resp.data);
                        if (resp && resp.data && resp.data.IsActive) {
                            // The worklist state change usually fires before this response arrives
                            // (the login flow navigates while the preferences call is still in flight),
                            // so waiting for the next $stateChangeSuccess would wait forever. Open now if
                            // the user is already on the worklist; otherwise hand off to the state listener.
                            if ($state.current && $state.current.name === 'worklist-lite') {
                                console.log('[Campaign] already on worklist-lite, opening modal now');
                                openCampaignModal(resp.data);
                            } else {
                                $rootScope._pendingCampaignData = resp.data;
                                console.log('[Campaign] data stored, waiting for stateChangeSuccess to worklist-lite');
                            }
                        } else {
                            console.log('[Campaign] IsActive=false, modal will not show');
                        }
                    })
                    .catch(function (err) { console.log('[Campaign] API error:', err); });
            } else {
                console.log('[Campaign] gate failed — modal will not show');
            }

            // Task 174662: RadPod Newsletter for RadPod radiologists (User role + RadPod tenant) and internal staff
            // (company email domain); newsletterPopupService owns the rule and the popup lifecycle. Users about to
            // be redirected to CIVR (login/pin screens) never reach this point and read it there. EmailId comes from
            // the token (SimpleAuthorizationServerProvider); the passcode path stores it on currentUserData only.
            newsletterPopupService.maybeShow(LogingSuccessResult[1], {
                userRoles: _userRoles,
                tenantNames: _tenantNames,
                email: (LoginSuccessData && LoginSuccessData.EmailId)
                    || ($sessionStorage.currentUserData && $sessionStorage.currentUserData.EmailId) || ''
            });
        });
        $sessionStorage.IdleTimeout = false;
        delete $sessionStorage.overdueAutoOpened;
        //Index page release guide
        //var timeout = $timeout(function () {
        //    var allowedFeatureGuide = !(data.userRoles.includes("User") || data.userRoles.includes("Technologist") || data.userRoles.includes("Physician"));
        //    if (allowedFeatureGuide) {
        //        startCurrentFeatureTourIndex();
        //    }
        //    $timeout.cancel(timeout);
        //    timeout = null;
        //}, 500);

        //initFirebase();        
    });
    function setOnlineStatus(userId, IsOnline) {
        chatService.SetOnlineStatus(userId, IsOnline);
    }
    $scope.$on("closePasscodeWindow", function (evt, data) {
        $scope.isPasscode = false;
        $sessionStorage.isPasscode = false;
        $sessionStorage.currentState = null;
        Idle.watch();
        Keepalive.start();
        $scope.OldPriorityCount = 0;
        $scope.OldPracticeCount = 0;
        $scope.GetOrdersListPendingCount();
    });
    var windowElement = angular.element($window);
    windowElement.on('beforeunload', function (event) {
        //console.log('Browser refresh call');
        //if (!$localStorage.userInfo) {
        //    try {
        //        authService.removeRefreshToken();
        //    }
        //    catch (e) {
        //        console.log(e);
        //    }
        //}
        //$sessionStorage.currentUserData = null;
        //$sessionStorage.isPasscode = false;
    });



    $scope.SwitchView = function () {

        $localStorage.userInfo = $sessionStorage.currentUserData;
        $localStorage.isSwitchedView = true;
        $localStorage.isFromSwitchView = true;
        $timeout(function () {
            window.open(__env._environment.config.oldDesignAppURL, '_self');
        }, 1000)

        $localStorage.IsKDView = true;

    };






    function checkParam() {
        //var objdevice = parser.getDevice();
        //if (objdevice != null && objdevice.type == "mobile") {
        //    window.location.href = APP_CONSTANTS.MobileWebViewURL;
        //}
        // Password-reset links use ?resetpwdparams=... which contains the substring "param"
        // and must not be treated as a RadiCo handoff payload (that path JSON.parses the
        // value and crashes on base64: Unexpected token 'e', "eyJVc2Vybm"...).
        if ($location.$$url.match('resetpwdparams')) {
            return;
        }
        if ($location.$$url.match('param')) {
            var param = [], values;
            var dataString = decodeURIComponent($location.$$url.substring(1));

            if (!dataString.match('&')) {
                dataString = dataString.split('?')[1];
            }
            var decryptedString = dataString.split('&');
            for (var i = 0; i < decryptedString.length; i++) {
                values = decryptedString[i].split('=');
                param.push(values[0]);
                param[values[0]] = values[1];
            }
            $scope.RadiCoParam = jQuery.parseJSON(param[param]);
        }
        else if ($location.$$absUrl.match('CallFrom')) {
            var _AnalyticsPopupUrl = new URL($location.$$absUrl);
            $scope.AnalyticsPopupUrl.CallFrom = decodeURIComponent(_AnalyticsPopupUrl.searchParams.get('CallFrom'));
            $scope.AnalyticsPopupUrl.Token = decodeURIComponent(_AnalyticsPopupUrl.searchParams.get('Token'));
            $scope.AnalyticsPopupUrl.NavigateTo = decodeURIComponent(_AnalyticsPopupUrl.searchParams.get('NavigateTo'));
            $scope.AnalyticsPopupUrl.UserId = decodeURIComponent(_AnalyticsPopupUrl.searchParams.get('UserId'));
            $scope.AnalyticsPopupUrl.RefreshToken = decodeURIComponent(_AnalyticsPopupUrl.searchParams.get('RefreshToken'));
            $scope.AnalyticsPopupUrl.UserRoles = decodeURIComponent(_AnalyticsPopupUrl.searchParams.get('UserRoles'));
        }
        else if ($localStorage.userInfo) {
            $scope.RadiCoParam = $localStorage.userInfo;
        }
    }


    function CheckIESettings(indexCtrlinit) {
        //var parser = new UAParser();
        $scope.browser = parser.getBrowser().name;
        $sessionStorage.browser = $scope.browser.toUpperCase();
        //console.log("CheckIESettings > browser: ", $scope.browser);
        if ($scope.browser != null && $scope.browser.toUpperCase() != "IE") {
            //$('#ModalIESettings').modal('show');
            //$sessionStorage.ShowModalIESettings = true;            
        }
        else if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
            //alert($scope.browser);
            try {
                var regpath = "HKEY_CLASSES_ROOT\\RadFlowIE\\IsSettings";
                var oWSS = new ActiveXObject("WScript.Shell");
                if (oWSS != null) {
                    var value = oWSS.RegRead(regpath);
                    if (value != 1) {
                        //$('#ModalIESettings').modal('show');                        
                        $sessionStorage.ShowModalIESettings = true;
                    }
                }
                else {
                    //$('#ModalIESettings').modal('show');                    
                    $sessionStorage.ShowModalIESettings = true;
                }

            }
            catch (e) {
                //$('#ModalIESettings').modal('show');                
                $sessionStorage.ShowModalIESettings = true;
            }
            //Check Agfa Installed in this machine or not. 
            try {
                var Agfaregpath = "HKEY_CLASSES_ROOT\\AgfaHC\\URL Protocol";
                var AgfaoWSS = new ActiveXObject("WScript.Shell");
                if (AgfaoWSS != null) {
                    var Agfavalue = AgfaoWSS.RegRead(Agfaregpath);
                    if (Agfavalue != null) {
                        $sessionStorage.AgfaSetup = true;
                    }
                    else {
                        $sessionStorage.AgfaSetup = false;
                    }
                }
                else {
                    $sessionStorage.AgfaSetup = false;
                }
            }
            catch (e) {
                $sessionStorage.AgfaSetup = false;
            }
            //Launch Agfa defalut if installed on machine 
            if ($sessionStorage.AgfaSetup) {
                window.open(__env.agfaDefaultURL, "_self");
            }
        }
        //$sessionStorage.ShowModalIESettings = false;
        indexCtrlinit();

    }
    //CheckIESetting();
    $scope.keys = {
        //F1: function (name, code) { openUserManual(); }
    };
    function openUserManual() {
        window.open(__env._environment.config.domain + 'usermanual.pdf', "_blank");
    }
    function Logout() {
        closeCampaignModal('logout');
        newsletterPopupService.close('logout');
        if ($scope.activeChatMenuBar) {
            $scope.isChatMenuActive = false;
            $rootScope.$emit('activeChatMenuBar', $scope.isChatMenuActive);
        }
        if ($scope.disconnectVideoCall) {
            $scope.isVideoCallConnected = true;
            $rootScope.$emit('disconnectVideoCall', $scope.isVideoCallConnected);
        }
        setOnlineStatus($scope.UserId, false);
        DeleteOpenOrderByUserID().then(function () {
            function finishLogout() {
                clearData();
                try {
                    if ($sessionStorage.KonicaWindow) {
                        $sessionStorage.KonicaWindow.close();
                    }
                } catch (e) {
                    console.log(e);
                }
                $interval.cancel(_UpdateNotification);
                if (AppHub != null) {
                    AppHub.off('RadFlowAppHubEvent');
                    if (!$sessionStorage.IdleTimeout) { AppHub.invoke('SetLogoutReason', 'UserLogout'); }
                }
                AppHubService.stop();
                AppHub = null;
                Idle.unwatch();
                Keepalive.stop();
                if ($state.current.name != 'Login') {
                    $state.go('Login');
                }
                if (tourUserPref) {
                    tourUserPref.ended();
                    tourUserPref = null;
                }
                if (tourUserPrefTech) {
                    tourUserPrefTech.ended();
                    tourUserPrefTech = null;
                }
                if (tourUserPrefIndex) {
                    tourUserPrefIndex.ended();
                    tourUserPrefIndex = null;
                }
                $sessionStorage.isStartUserGuideTour = false;
                windowHandler.CloseAllWindows();
            }
            if (!$sessionStorage.isPasscode) {
                try {
                    // Logout revokes the access token and removes the refresh token in one call.
                    // Do not call removeRefreshToken afterward — the Bearer is already revoked and
                    // that second request returns 401 by design.
                    authService.revokeAccessToken()
                        .finally(function () {
                            $sessionStorage.currentUserData = null;
                            $sessionStorage.isPasscode = false;
                            $sessionStorage.$reset();
                            $localStorage.userInfo = null;
                            finishLogout();
                        });
                }
                catch (e) {
                    console.log(e);
                    $sessionStorage.currentUserData = null;
                    $sessionStorage.isPasscode = false;
                    $sessionStorage.$reset();
                    $localStorage.userInfo = null;
                    finishLogout();
                }
            } else {
                finishLogout();
            }
        });
    }
    function clearData() {
        if (!$sessionStorage.currentUserData) {
            $scope.isAuthenticate = false;
            document.title = "";
            $scope.tenantName = "";
            $scope.tenantDispalyName = "";
            $scope.IssueType = "";
            $scope.accesstoken = '';
            $scope.userName = '';
            $scope.userRole = '';
            $scope.displayName = '';
        }
        $scope.PendingCount.PriorityCount = '';
        $scope.PendingCount.PracticeCount = '';
        $scope.OldPriorityCount = 0;
        $scope.OldPracticeCount = 0;
    }

    // Opens the campaign popup once per login. Called either straight from the campaign API
    // response (user already on the worklist) or from the state listener below (response
    // arrived before the worklist loaded).
    // The instance is kept so idle timeout and logout can dismiss it: closeModals() only hides
    // the jQuery #idealAlertWarning dialog and knows nothing about $uibModal windows, which
    // otherwise stay open on top of the login screen.
    var campaignModalInstance = null;
    // True between openCampaignModal() and the $uibModal.open() call inside its $timeout, so the
    // newsletter (Task 174662) never opens on top of a campaign modal that is about to appear.
    var campaignModalOpening = false;

    function openCampaignModal(data) {
        campaignModalOpening = true;
        $timeout(function () {
            console.log('[Campaign] opening modal');
            campaignModalInstance = $uibModal.open({
                templateUrl: 'app/pages/campaign/campaign-modal.html',
                controller:  'CampaignModalController',
                controllerAs: 'vm',
                size:        'lg',
                backdrop:    'static',
                resolve: { campaignData: function () { return data; } }
            });
            campaignModalOpening = false;
            campaignModalInstance.result.finally(function () {
                campaignModalInstance = null;
                newsletterPopupService.openPending();
            });
        }, 300);
    }

    function closeCampaignModal(reason) {
        campaignModalOpening = false;
        if (campaignModalInstance) {
            console.log('[Campaign] closing modal:', reason);
            campaignModalInstance.dismiss(reason);
            campaignModalInstance = null;
        }
    }

    // ── Task 174662: RadPod Newsletter (published from CIVIR) ─────────────────────────────
    // The popup lifecycle (audience gate, publish check, queueing, modal, acknowledgement, dismissal)
    // lives in newsletterPopupService. This controller only lends it the campaign state, so the
    // newsletter never opens on top of a campaign modal that is opening, open or waiting to open.
    newsletterPopupService.init({
        campaignBusy: function () {
            return campaignModalOpening || !!campaignModalInstance || !!$rootScope._pendingCampaignData;
        }
    });

    $rootScope.$on('$stateChangeSuccess', function (ev, toState) {
        console.log('[Campaign] stateChangeSuccess — pendingData:', !!$rootScope._pendingCampaignData, '| state:', toState && toState.name);
        if ($rootScope._pendingCampaignData && toState && toState.name === 'worklist-lite') {
            var _data = $rootScope._pendingCampaignData;
            $rootScope._pendingCampaignData = null;
            openCampaignModal(_data);
        }
        // Task 174662: a queued newsletter opens on any post-login landing page unless a campaign modal is busy.
        if (toState) { newsletterPopupService.onStateChange(toState.name); }
    });

    $rootScope.$on('account:Login', function (event, args) {
        Logout();
    });

    $scope.logout = function () {
        //setOnlineStatus($scope.UserId, false);
        $sessionStorage.isPasscode = false;
        Logout();

    };
    // init controller
    function getParameterByName(name, url) {
        if (!url) {
            url = window.location.href
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    indexCtrlinit = function () {
        if ($scope.isLoad) {
            $scope.isLoad = false;
            return;
        }
        if (getParameterByName('resetpwdparams')) {
            var resetpwdparams = resetPasswordLinkHelper.parseEncodedParam(getParameterByName('resetpwdparams'));
            if (!resetpwdparams || !resetpwdparams.Timestamp || !resetpwdparams.Username) {
                swal("Invalid password reset link. Please request a new link from your administrator.");
                window.open(window.location.origin + "/#/", "_self");
                return;
            }

            // Timestamp in the link is already a CST wall-clock string from sendResetPasswordLink;
            // parse it literally — do not pass through moment() local TZ or CSTDateTime again.
            var urlTimeStamp = moment(resetpwdparams.Timestamp, "YYYY-MM-DD HH:mm:ss");
            var currentTime = moment($filter('CSTDateTime')(moment()), "YYYY-MM-DD HH:mm:ss");

            var timeDiff = currentTime.diff(urlTimeStamp, "minutes");

            if (timeDiff > 10) {
                swal("This password reset link has expired. Please request a new link from your administrator.");
                window.open(window.location.origin + "/#/", "_self");
                return;
            }
            $state.go('Login');
            return;
        }
        //console.log("IsKDView: " + $localStorage.IsKDView);
        checkParam();
        //$localStorage.userInfo = null;
        if ($localStorage.userInfo && !$scope.isPasscode && $scope.AnalyticsPopupUrl.CallFrom != 'RadFlow') {
            $sessionStorage.currentUserData = $localStorage.userInfo;
            if ($localStorage.isSwitchedView) {
                if ($localStorage.isFromSwitchView) {
                    $sessionStorage.isPasscode = true;
                    $localStorage.isFromSwitchView = false;
                } else {
                    $sessionStorage.isPasscode = false;
                }

            } else {
                //setOnlineStatus($scope.UserId, false);
                $sessionStorage.isPasscode = true;
            }

            $scope.isPasscode = true;
            Idle.unwatch();
            Keepalive.stop();
            //if ($localStorage.IsKDView) {
            //    window.open(APP_CONSTANTS.oldDesignAppURL, "_self");
            //} else {

            $state.go('Login');

            //}

        }
        else if ($scope.RadiCoParam) {
            var dt = new Date();
            var promiselogin = authService.getLoginDataByUserId($scope.RadiCoParam.userId);
            promiselogin.then(function (resp) {
                if (resp != null && resp.data != null) {
                    var data = {
                        userId: resp.data.userId,
                        connectionId: '',
                        userName: resp.data.userName,
                        roles: resp.data.roles,
                        accessToken: $scope.RadiCoParam.accessToken,
                        refreshToken: $scope.RadiCoParam.refreshToken,
                        ProfilePic: '',//Profile pic will be set later, other token problem occurs
                        displayName: resp.data.displayName,
                        browserType: 'Web',
                        TenantName: resp.data.TenantName,
                        expire: dt.setDate(dt.getDate() + 10),
                        FirstName: resp.data.FirstName,
                        LastName: resp.data.LastName,
                        Passcode: resp.data.Passcode,
                        EmailId: resp.data.EmailId,
                        userRoles: resp.data.userRoles ? resp.data.userRoles.split(',') : null
                    };
                    $scope.isLoading = false;
                    $sessionStorage.currentUserData = data;
                    if (!$sessionStorage.EnableTwoFactorAuthentication) {
                        $rootScope.$broadcast("LoginSuccess", data);
                    }


                }
                else {
                    $scope.isLoading = false;
                    //if ($localStorage.IsKDView) {
                    //    window.open(APP_CONSTANTS.oldDesignAppURL, "_self");
                    //} else {
                    $state.go('Login');
                    //}

                }
            }, function (err) {
                //$scope.isLoading = false;
                //if ($localStorage.IsKDView) {
                //    window.open(APP_CONSTANTS.oldDesignAppURL, "_self");
                //} else {
                $state.go('Login');
                //}

            });
        }
        else if ($scope.AnalyticsPopupUrl.CallFrom == 'RadFlow') {
            var dt = new Date();
            var promiselogin = authService.getLoginDataByUserId($scope.AnalyticsPopupUrl.UserId);
            promiselogin.then(function (resp) {
                if (resp != null && resp.data != null) {
                    var data = {
                        userId: resp.data.userId,
                        connectionId: '',
                        userName: resp.data.userName,
                        roles: resp.data.roles,
                        accessToken: $scope.AnalyticsPopupUrl.Token,
                        refreshToken: $scope.AnalyticsPopupUrl.RefreshToken,
                        ProfilePic: '',//Profile pic will be set later, other token problem occurs
                        displayName: resp.data.displayName,
                        browserType: 'Web',
                        TenantName: resp.data.TenantName,
                        expire: dt.setDate(dt.getDate() + 10),
                        FirstName: resp.data.FirstName,
                        LastName: resp.data.LastName,
                        Passcode: resp.data.Passcode,
                        EmailId: resp.data.EmailId,
                        userRoles: $scope.AnalyticsPopupUrl.UserRoles ? $scope.AnalyticsPopupUrl.UserRoles.split(',') : null,
                    };
                    $scope.isLoading = false;
                    $sessionStorage.currentUserData = data;

                    $rootScope.$broadcast("LoginSuccess", data);


                }
                else {
                    $scope.isLoading = false;
                    //if ($localStorage.IsKDView) {
                    //    window.open(APP_CONSTANTS.oldDesignAppURL, "_self");
                    //} else {
                    $state.go('Login');
                    //}

                }
            }, function (err) {
                //$scope.isLoading = false;
                //if ($localStorage.IsKDView) {
                //    window.open(APP_CONSTANTS.oldDesignAppURL, "_self");
                //} else {
                $state.go('Login');
                //}

            });
        }
        else if (!$scope.isPasscode) {
            //if ($localStorage.IsKDView) {
            //    window.open(APP_CONSTANTS.oldDesignAppURL, "_self");
            //} else {
            //setOnlineStatus($scope.UserId, false);
            $state.go('Login');
            //}

        }
    };
    //Page load start from here
    CheckIESettings(indexCtrlinit);
    function closeModals() {
        $('#idealAlertWarning').modal('hide');
    }

    $scope.activeChatMenuBar = function () {
        $scope.isChatMenuActive = !$scope.isChatMenuActive;
        $rootScope.$emit('activeChatMenuBar', $scope.isChatMenuActive);
    }

    $scope.$on('activeChatMenuBarformWorkList', function (evt, isChatMenuActive, workListOrderData) {
        $scope.isChatMenuActive = isChatMenuActive;
        $rootScope.$emit('activeChatMenuBarformWorkList', $scope.isChatMenuActive, workListOrderData);
        //$scope.activeChatMenuBar(evt,isChatMenuActive,workListOrderData);
    })

    $scope.disconnectVideoCall = function () {
        $scope.isVideoCallConnected = isVideoCallConnected;
        $rootScope.$emit('disconnectVideoCall', $scope.isVideoCallConnected);
        //$scope.activeChatMenuBar(evt,isChatMenuActive,workListOrderData);
    }

    $scope.$on('IdleStart', function () {
        closeModals();
        //console.log('IdleStart : ');        
        $('#idealAlertWarning').modal('show');
    });
    $scope.$on('IdleEnd', function () {
        closeModals();
    });
    $scope.$on('IdleTimeout', function () {
        swal.close();
        setOnlineStatus($scope.UserId, false);
        if ($scope.activeChatMenuBar) {
            $scope.isChatMenuActive = false;
            $rootScope.$emit('activeChatMenuBar', $scope.isChatMenuActive);
        }
        if ($scope.disconnectVideoCall) {
            $scope.isVideoCallConnected = false;
            $rootScope.$emit('disconnectVideoCall', $scope.isVideoCallConnected);
        }
        closeCampaignModal('idle');
        newsletterPopupService.close('idle');
        $(".modal-backdrop").remove();
        closeModals();
        $sessionStorage.isPasscode = true;
        $scope.isPasscode = true;
        $sessionStorage.currentState = $state.current.name;
        //$state.go('Login');
        $sessionStorage.IdleTimeout = true;
        if (AppHub != null) { AppHub.invoke('SetLogoutReason', 'IdleTimeout'); }
        Logout();
    });

    // init controller
    //indexCtrlinit();
    // Open synapse before login 
    if (__env.openSynapseonLoad == true) {
        try {
            var oSynapseAPI = new ActiveXObject("Synapse.SynapseAPI");
            var sStudyPath = oSynapseAPI.MakePath(5, "");
            //oSynapseAPI.OpenSynapseExplorer("Synapse", "https://pacs.texasradiology.com", sStudyPath);
            oSynapseAPI.OpenSynapseExplorer("Synapse", __env._environment.config.synapse, sStudyPath);

        } catch (e) {
            console.log(e);
        }
    }

    // PS Event Listener
    if (__env.openPowerScribeonLoad == true && ($scope.browser != null && $scope.browser.toUpperCase() == "IE")) {
        try {
            if (!$sessionStorage.PSEvent) {
                RadWhereCtrl.Start();
                $sessionStorage.PSEvent = true;
                RadWhereCtrl.StartListening();
                //setTimeout(function () { RadWhereCtrl.Login('spatel', 'RAD(pass17)'); }, 5000);
            }
        } catch (e) {
            //swal("Unable to find the order in PS360.");
            console.log(e);
        }
    }

    $scope.OpenOrderDiscussion = function (paramOD) {
        var OD = {};
        if (paramOD.OrderID) { _.remove($scope.OrderDiscussions, { OrderID: paramOD.OrderID }); }
        angular.copy(paramOD, OD);
        if ($state.current.url == "/worklist" || $state.current.url == "/worklist-lite" || $state.current.url == "/techno") {
            $scope.$broadcast("OpenDiscussionOrder", OD);
        }
        else if ($scope.userRoles.includes("User")) {
            if ($localStorage.LoadMoreWorklist) {
                $state.go('worklist-lite', { "OD": OD });
            } else {
                $state.go('worklist', { "OD": OD });
            }
        }
    }
    var _NotificationService = function () {
        $scope.OrderDiscussions = [];
        var data1 = {
            ToUserID: $scope.UserId,
            Status: 'O'
        };
        WorklistService.GetOrderDiscussion(data1).then(function (response) {
            if (response && response.length > 0) {
                $scope.OrderDiscussions = _.union($scope.OrderDiscussions, response);
            }

        });
        var data2 = {
            FromUserID: $scope.UserId,
            Status: 'A'
        };
        WorklistService.GetOrderDiscussion(data2).then(function (response) {
            if (response && response.length > 0) {
                $scope.OrderDiscussions = _.union($scope.OrderDiscussions, response);
            }
        });

        var data3 = {
            ToUserID: $scope.UserId,
            Status: 'N'
        };
        WorklistService.GetOrderDiscussion(data3).then(function (response) {
            if (response && response.length > 0) {
                $scope.OrderDiscussions = _.union($scope.OrderDiscussions, response);
            }
        });

        var data4 = {
            ToUserID: $scope.UserId,
            Status: 'I'
        };
        WorklistService.GetOrderDiscussion(data4).then(function (response) {
            if (response && response.length > 0) {
                $scope.OrderDiscussions = _.union($scope.OrderDiscussions, response);
            }
        });
    }

    $scope.GetOrdersListPendingCount = function () {
        if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) {
            WorklistService.GetOrdersListPendingCount($sessionStorage.currentUserData.userId).then(function (response) {
                //ShowPendingCount(response[0]);                                
                if (response != null && response.length > 0) {
                    $scope.PendingCount.PriorityCount = response[0].PriorityCount;
                    $scope.PendingCount.PracticeCount = response[0].PracticeCount;
                    //if (parseInt(response[0].PriorityCount) > parseInt($scope.OldPriorityCount)) {
                    //    angular.element(document.querySelector("#spanPriorityCount")).removeClass("bartopAnimate");
                    //    angular.element(document.querySelector("#spanPriorityCount")).removeClass("barbottomAnimate");
                    //    setTimeout(function () {
                    //        $scope.PendingCount.PriorityCount = response[0].PriorityCount;
                    //        angular.element(document.querySelector("#spanPriorityCount")).addClass("bartopAnimate");
                    //    }, 100);

                    //}
                    //else if (parseInt(response[0].PriorityCount) < parseInt($scope.OldPriorityCount)) {
                    //    angular.element(document.querySelector("#spanPriorityCount")).removeClass("bartopAnimate");
                    //    angular.element(document.querySelector("#spanPriorityCount")).removeClass("barbottomAnimate");
                    //    setTimeout(function () {
                    //        $scope.PendingCount.PriorityCount = response[0].PriorityCount;
                    //        angular.element(document.querySelector("#spanPriorityCount")).addClass("barbottomAnimate");
                    //    }, 100);

                    //}
                    //if (parseInt(response[0].PracticeCount) > parseInt($scope.OldPracticeCount)) {
                    //    angular.element(document.querySelector("#spanPracticeCount")).removeClass("bartopAnimate");
                    //    angular.element(document.querySelector("#spanPracticeCount")).removeClass("barbottomAnimate");
                    //    setTimeout(function () {
                    //        $scope.PendingCount.PracticeCount = response[0].PracticeCount;
                    //        angular.element(document.querySelector("#spanPracticeCount")).addClass("bartopAnimate");
                    //    }, 100);

                    //}
                    //else if (parseInt(response[0].PracticeCount) < parseInt($scope.OldPracticeCount)) {
                    //    angular.element(document.querySelector("#spanPracticeCount")).removeClass("bartopAnimate");
                    //    angular.element(document.querySelector("#spanPracticeCount")).removeClass("barbottomAnimate");
                    //    setTimeout(function () {
                    //        $scope.PendingCount.PracticeCount = response[0].PracticeCount;
                    //        angular.element(document.querySelector("#spanPracticeCount")).addClass("barbottomAnimate");
                    //    }, 100);

                    //}
                    $scope.OldPriorityCount = response[0].PriorityCount;
                    $scope.OldPracticeCount = response[0].PracticeCount;
                }
            });
        }
    };

    //function ShowPendingCount($event, PendingCount) {
    //    //        alert(TotalRows);
    //    $scope.PendingCount = PendingCount;
    //}    
    $scope.$on('GetOrdersListPendingCount', ShowPendingCount);

    function ShowPendingCount() {
        //        alert(TotalRows);
        //$scope.PendingCount = PendingCount;
        $scope.GetOrdersListPendingCount();
    }

    var _signalrRetrying = false;
    var _signalrRetryCount = 0;
    // Rate limiter allows 3 req/15s; use 20s delay to stay safely under the limit (max 10 attempts, matching __env._SignalRreconnectAttempts)
    var _signalrRetryDelay = (__env._SignalRreconnectInterval && __env._SignalRreconnectInterval >= 20000) ? __env._SignalRreconnectInterval : 20000;
    var _signalrMaxRetries = (__env._SignalRreconnectAttempts && __env._SignalRreconnectAttempts > 0) ? __env._SignalRreconnectAttempts : 10;

    function intiAppHub() {
        AppHubService.Initialize();
        AppHub = AppHubService.getAppHub();
        if (AppHub) {
            AppHubMethod();
            AppHubService.startConnection();
        }
    }

    function _scheduleSignalRRetry(label) {
        if (_signalrRetrying) return;
        if (_signalrRetryCount >= _signalrMaxRetries) {
            console.warn('SignalR: ' + label + ' - max retries (' + _signalrMaxRetries + ') reached. Stopping reconnect attempts.');
            return;
        }
        _signalrRetrying = true;
        _signalrRetryCount++;
        console.log('SignalR: ' + label + ' - scheduling retry ' + _signalrRetryCount + '/' + _signalrMaxRetries + ' in ' + _signalrRetryDelay + 'ms');
        setTimeout(function () {
            _signalrRetrying = false;
            if ($sessionStorage.currentUserData) {
                AppHubService.stop();
                intiAppHub();
            }
        }, _signalrRetryDelay);
    }

    // Register SignalR lifecycle listeners once (not inside intiAppHub, to prevent duplicate listener accumulation)
    $rootScope.$on("SignalrConnectionDisconnected", function (name, errorMessage) {
        //Logout();
        //swal("Server disconnected", "You have been disconnected from the server for inactivity. Please login again.", "info");
        console.log('Server disconnected : ' + errorMessage);
        console.log('Server disconnected : ' + name);
        AppHubService.stop();
        if ($sessionStorage.currentUserData) {
            _scheduleSignalRRetry('SignalrConnectionDisconnected');
        }
        /*
        toastr.warning('Server disconnected. Trying to reconnect!', 'Warning', {
            closeButton: true
        });
        */
    });
    $rootScope.$on("SignalrConnectionReconnected", function (name, errorMessage) {
        console.log('Server reconnected!');
        _signalrRetryCount = 0; // reset on successful reconnect
        //toastr.success('Server reconnected!', {
        //    closeButton: true
        //});
    });
    $rootScope.$on("SignalrConnectionSetStartedMethod", function (name, xiIsConnectionStarted, xiConnectionId) {
        if (xiIsConnectionStarted) {
            _signalrRetryCount = 0; // reset on successful connect
        } else {
            //Logout();
            //swal('Server connection failed!', 'Unable to login due to problem at server. Please contact administrator if the problem persists.', 'warning');
            console.log('Server connection failed! Unable to login due to problem at server. Please contact administrator if the problem persists.');
            _scheduleSignalRRetry('SignalrConnectionSetStartedMethod');
        }
    });

    function AppHubMethod() {
        // Always listen for chat events (e.g. bindmessage) so they are received even when chat UI is not open
        var myUserId = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) ? String($sessionStorage.currentUserData.userId) : '(none)';
        console.log('SignalR [bindmessage]: index registering. My user ID (as recipient, server must send to this group):', myUserId, 'lowercase:', myUserId.toLowerCase());
        AppHub.on('RadFlowChatAppHubEvent', function (obj) {
            if (obj) {
                var eventType = (obj.EventType || obj.eventType || '').toLowerCase();
                var eventArgs = obj.EventArgs || obj.eventArgs || {};
                var toUserId = String(eventArgs.ToUserId || eventArgs.toUserId || '').toLowerCase();
                var myId = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) ? String($sessionStorage.currentUserData.userId).toLowerCase() : '';
                var amIRecipient = !!(toUserId && myId && toUserId === myId);
                console.log('SignalR [bindmessage]: index received EventType=' + (obj.EventType || obj.eventType || '(none)') + ' ToUserId=' + (toUserId || '(none)') + ' myUserId=' + (myId || '(none)') + ' amIRecipient=' + amIRecipient);
                $rootScope.$broadcast('SignalR:RadFlowChatAppHubEvent', obj);
                if (eventType === 'bindmessage' && amIRecipient) {
                    var fromName = eventArgs.FromUserDisplayName || eventArgs.fromUserDisplayName || 'Someone';
                    toaster.pop('info', 'New chat message', fromName + ' sent you a message.');
                }
            }
        });
        AppHub.on('RadFlowAppHubEvent', function (obj) {
            switch (obj.EventType) {
                case 'sendunreadmessage':
                    var incomingMsg = obj.EventArgs;
                    var alreadyExists = incomingMsg && incomingMsg.Id && _.some($scope.ChatMessageList, function (m) { return m.Id == incomingMsg.Id; });
                    if (!alreadyExists && incomingMsg) {
                        $scope.ChatMessageList.push(incomingMsg);
                    }
                    if (ChatCurrentUserObject
                        && ((ChatCurrentUserObject.ChatGroupID
                            && ChatCurrentUserObject.ChatGroupID == obj.EventArgs.ChatGroupID)
                        || (ChatCurrentUserObject.Id
                            && ChatCurrentUserObject.Id == obj.EventArgs.FromUserId))) {
                        getChatRead(ChatCurrentUserObject);
                    }
                    showPendingReadChat();
                    break;
                case 'deleteunreadchat':
                    if (obj.EventArgs.Type == "Read") {
                        $scope.ChatMessageList = _.filter($scope.ChatMessageList, function (a) { return a.FromUserId != obj.EventArgs.ChatMessage.FromUserId; });
                    } else {
                        $scope.ChatMessageList = _.filter($scope.ChatMessageList, function (a) { return a.Id != obj.EventArgs.ChatMessage.Id; });
                    }
                    showPendingReadChat();
                    break;
                case 'notificationhandler':
                    var discussion = obj.EventArgs;
                    var isAdd = false;
                    var ToUserID;
                    if (discussion.ToUserID && discussion.ToUserID == $scope.UserId) {
                        ToUserID = discussion.ToUserID;
                    } else {

                        var userGroup = _.find(discussion.OrderDiscussionUserGroup, function (obj) {
                            return obj.ToUserID == $scope.UserId;
                        });
                        if (userGroup) {
                            ToUserID = userGroup.ToUserID;
                        }
                    }
                    if (ToUserID && discussion.Status == 'O') {
                        isAdd = true;
                    } else if (discussion.FromUserID == $scope.UserId && discussion.Status == 'A') {
                        isAdd = true;
                    } else if (ToUserID && discussion.Status == 'N') {
                        isAdd = true;
                    } else if (ToUserID == discussion.FromUserID && discussion.Status == 'I') {
                        isAdd = false;
                    } else if (ToUserID == discussion.FromUserID && discussion.Status == 'D') {
                        isAdd = false;
                    } else if (discussion.FromUserID != $scope.UserId && discussion.Status == 'I') {
                        isAdd = true;
                    } else if (ToUserID == $scope.UserId && discussion.RequestType == "Addendum Request") {
                        isAdd = true;
                    } else {
                        if (discussion.ID) {
                            var idx = _.findIndex($scope.OrderDiscussions, function (obj) { return obj.ID == discussion.ID; });
                            if (idx > -1) {
                                $scope.OrderDiscussions.splice(idx, 1);
                            }
                        } else {
                            var idx = _.findIndex($scope.OrderDiscussions, function (obj) { return obj.OrderID == discussion.OrderID; });
                            if (idx > -1) {
                                $scope.OrderDiscussions.splice(idx, 1);
                            }
                        }
                    }
                    if (discussion.Status == 'I') {
                        if ($state.current.url == "/worklist" || $state.current.url == "/worklist-lite") {
                            $scope.$broadcast("ReLoadDiscussion", discussion);
                        }
                    }
                    if (discussion.Status == 'D') {
                        if ($state.current.url == "/worklist" || $state.current.url == "/worklist-lite") {
                            $scope.$broadcast("UnAssignStudy", discussion);
                        }
                    }
                    if (isAdd) {
                        if ($scope.OrderDiscussions.length == 0) {
                            $scope.OrderDiscussions.push(discussion);
                        } else {
                            $scope.OrderDiscussions.splice(0, 0, discussion);
                        }
                        if ($state.current.url == "/worklist" || $state.current.url == "/worklist-lite") {
                            $scope.$broadcast("ReLoadDiscussion", discussion);
                        }
                    }
                    break;

                case 'orderslistpendingcountupdatehandler':
                    $scope.GetOrdersListPendingCount();
                    break;

                case 'unassignednotificationhandler':
                    var discussion = obj.EventArgs;
                    var ToUserID;
                    if (discussion.ToUserID && discussion.ToUserID == $scope.UserId) {
                        ToUserID = discussion.ToUserID;
                    } else {

                        var userGroup = _.find(discussion.OrderDiscussionUserGroup, function (obj) {
                            return obj.ToUserID == $scope.UserId;
                        });
                        if (userGroup) {
                            ToUserID = userGroup.ToUserID;
                        }
                    }

                    var notify = true;
                    if (discussion.FromUserID != $scope.UserId) {
                        notify = false;
                    }
                    if (ToUserID) {
                        notify = false;
                    }
                    if (notify) {
                        if (discussion.Status == 'D') {
                            if ($state.current.url == "/worklist" || $state.current.url == "/worklist-lite") {
                                $scope.$broadcast("UnAssignStudy", discussion);
                            }
                        } else {
                            if ($state.current.url == "/worklist" || $state.current.url == "/worklist-lite") {
                                $scope.$broadcast("ReLoadDiscussion", discussion);
                            }
                        }

                    }
                    break;
                case 'notifypeerreview':
                    GetPeerReviewPendingCount();
                    break;
                case 'overduenotification':
                    $rootScope.$broadcast('overdueNotification');
                    break;
            }

        });
    }

    $scope.$on('$destroy', function () {
        setOnlineStatus($scope.UserId, false);
        if ($scope.activeChatMenuBar) {
            $scope.isChatMenuActive = false;
            $rootScope.$emit('activeChatMenuBar', $scope.isChatMenuActive);
        }
        //console.log("111");
        if (!$localStorage.userInfo) {
            //console.log("222");
            try {
                authService.revokeAccessToken()
                    .finally(function () {
                        $sessionStorage.currentUserData = null;
                        $sessionStorage.isPasscode = false;
                    });
            }
            catch (e) {
                console.log(e);
                $sessionStorage.currentUserData = null;
                $sessionStorage.isPasscode = false;
            }
        } else {
            $sessionStorage.currentUserData = null;
            $sessionStorage.isPasscode = false;
        }
        AppHub.off('RadFlowAppHubEvent');
        //AppHubService.stop();
        //firebase.messaging().deleteToken();
        //console.log("444");
        if (tourUserPref) {
            tourUserPref.ended();
            tourUserPref = null;
        }
        if (tourUserPrefTech) {
            tourUserPrefTech.ended();
            tourUserPrefTech = null;
        }
        if (tourUserPrefIndex) {
            tourUserPrefIndex.ended();
            tourUserPrefIndex = null;
        }
        $sessionStorage.isStartUserGuideTour = false;
    });

    $scope.$on("ChatReadCount", function (evt, ChatRead, Type) {

        if (Type == "Read") {
            getChatRead(ChatRead);
        } else {
            $scope.ChatMessageList = _.filter($scope.ChatMessageList, function (a) { return a.Id != ChatRead.Id; });
        }

        showPendingReadChat();
    });

    $scope.$on("ChatCurrentUserObject", function (evt, _ChatCurrentUserObject) {
        ChatCurrentUserObject = _ChatCurrentUserObject;

    });

    function getChatRead(ChatRead) {
        $scope.ChatMessageList = _.filter($scope.ChatMessageList, function (a) {
            if (a.ChatGroupID) {
                return a.ChatGroupID != ChatRead.ChatGroupID;
            }
            return a.FromUserId != ChatRead.Id;
        });
    }

    function showPendingReadChat() {
        $scope.UnreadCount = _.filter($scope.ChatMessageList, function (msg) {
            return msg.FromUserId != $sessionStorage.currentUserData.userId;
        }).length;
        $rootScope.$broadcast('activeChatMenuBar:ChatMessageList', $scope.ChatMessageList);
    }
    function getUnreadmessages() {
        chatService.GetUnreadMessageCount($scope.UserId).then(function (result) {
            $scope.ChatMessageList = _.filter(result, function (msg) {
                return !msg.Message.includes('|NEWGROUP|');
            });
            showPendingReadChat();
        });
    }

    $scope.$on("OpenCIVRSetting", function (evt) {
        var paramObj = {
            cmd: 'civrSetting',
            data: {
                currentUserData: $sessionStorage.currentUserData,
                SelectedOrder: {}
            },
            callbackStatus: "VRStatus",
            isSingleView: false,
        }
        windowHandler.openCIVR(paramObj)
    });
    function GetHostFingerPrintHash(userid) {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // Create gradient
        var grd = ctx.createRadialGradient(95, 50, 0, 100, 50, 100);
        grd.addColorStop(0, "red");
        grd.addColorStop(1, "white");

        // Fill with gradient
        ctx.fillStyle = grd;
        ctx.fillRect(0, 0, 250, 100);

        // Draw Cross with gradient
        ctx.moveTo(0, 0);
        ctx.lineTo(200, 100);
        ctx.stroke();
        ctx.moveTo(0, 100);
        ctx.lineTo(200, 0);
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(100, 50, 50, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.font = "30px Arial";
        ctx.strokeText("RadFlow", 40, 60);
        var txt = '%r@dF!0W%(Xr$~!=;yme%V/,gGu/Nft?v3%%9nwN-6';
        ctx.textBaseline = "top";
        ctx.font = "13.13px 'Arial'";
        ctx.textBaseline = "alphabetic";
        ctx.rotate(.05);
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText(txt, 2, 15);
        ctx.fillText(userid, 2, 15);
        ctx.fillStyle = "rgba(102, 200, 0, 0.7)";
        ctx.fillText(txt, 4, 17);
        ctx.shadowBlur = 10;
        ctx.shadowColor = "blue";
        ctx.fillRect(-20, 10, 375, 5);
        var strng = canvas.toDataURL();

        //document.body.appendChild(canvas);

        var hash = 0;
        if (strng.length == 0) return 'nothing!';
        for (i = 0; i < strng.length; i++) {
            char = strng.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash;
        }
        return hash;
    }

    var fnNativeMessageResponse = function (NativeMessageResponse) {
        //console.log("fnNativeMessageResponse > NativeMessageResponse: ", NativeMessageResponse);
        if (NativeMessageResponse.responseEvent != null) {
            if (NativeMessageResponse.responseEvent == "ReportResponseDetails" || NativeMessageResponse.responseEvent == "ImageResponseDetails") {
                if (NativeMessageResponse.reportResponseDetails != null
                    && NativeMessageResponse.reportResponseDetails.ReportResponseEvent == "ReportClosed"
                    && (NativeMessageResponse.reportResponseDetails.reportStatus == 2
                        || NativeMessageResponse.reportResponseDetails.reportStatus == 8
                        || NativeMessageResponse.reportResponseDetails.reportStatus == -1)) {
                    $rootScope.$broadcast("NativeMessageResponseWorklist", NativeMessageResponse);
                }
            }
            else if (NativeMessageResponse.responseEvent == "NativeHostConnected") {
                toaster.pop({ type: 'success', body: "<p style=\"margin: 0;\">Connector Version: " + RCService.rc.sdkVersion + "</p>" + " Native Host Version: " + RCService.rc.nativeHostVersion + "</p>", title: "RadFlow Native Host connection succeeded!", bodyOutputType: 'trustedHtml' });
                CommonService.LogApplicationInfo({
                    LogDetails: "NativeHostConnected \n Hostname: " + RCService.rc.hostName + "\n Connector Version: " + RCService.rc.sdkVersion + "\n Native Host Version: " + RCService.rc.nativeHostVersion,
                    Application: $state.current.name,
                    UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '',
                });
            }
            else if (NativeMessageResponse.responseEvent == "NativeHostDisconnected") {
                var rcServiceDisconnectedTimeout = $timeout(function () {
                    StartRC("DISCONNECTED");
                    $timeout.cancel(rcServiceDisconnectedTimeout);
                    rcServiceDisconnectedTimeout = null;
                }, 1000);
                //toaster.error({ body: "RadFlow Native Host Disconnected!" });
                CommonService.LogApplicationInfo({
                    LogDetails: "RadFlow Native Host Disconnected!",
                    Application: $state.current.name,
                    UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '',
                });
            }
            CommonService.LogPSResponseMessage({
                Accession: (NativeMessageResponse.reportResponseDetails != null) ? NativeMessageResponse.reportResponseDetails.accessionNumbers : '',
                PSMessageResponse: JSON.stringify(NativeMessageResponse)
            });
        }
    }
    function StartRC(callFrom) {
        if (RCService) {
            if (!RCService.rc || ($rootScope.previousState == '' || (callFrom != null && callFrom == "DISCONNECTED"))) {
                try {
                    RCService.Connect(fnNativeMessageResponse);
                }
                catch (e) {
                    var currentState = ($state.current.name).toLowerCase();
                    if (currentState == "login" || currentState == "worklist-lite") {
                        var toast = toaster.pop({
                            type: 'warning',
                            body: '<span style="font-weight:600;text-decoration:underline;">Click here</span> to enable the RadFlow Connector extension and reload the page.', bodyOutputType: 'trustedHtml', tapToDismiss: true,
                            clickHandler: function (Toaster, closeFlag) {
                                toaster.clear(toast);
                                if (!closeFlag) {
                                    window.open(__env._environment.config.rcServiceHelp);
                                }
                            }
                        });
                    }
                }
            }
            if (RCService.rc && !RCService.rc.nativeHostVersion) {
                var rcServiceTimeout = $timeout(function () {
                    RCService.StartNativehost();
                    if ($rootScope.currentState == 'worklist-lite' || $rootScope.currentState == 'worklist') {
                        RCService.StartPS();
                    }
                    $timeout.cancel(rcServiceTimeout);
                    rcServiceTimeout = null;
                }, 1000);
            }
        }
    }
    $rootScope.$on('activeChatMenuBar:Chat', function (event, args) {
        $scope.isChatMenuActive = args;
    });
    $scope.$on('$viewContentLoaded', function () {
        if ($scope.browser != null && $scope.browser.toUpperCase() != "IE") {
            StartRC();
        }
    });
    $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
        //assign the "from" parameter to something
        $rootScope.currentState = to.name;
        $rootScope.previousState = from.name;
        var SharedVariable = CommonService.getSharedVariables();
        if (SharedVariable && SharedVariable.IsPaymentContractEnabled != null) {
            $scope.IsPaymentContractEnabled = SharedVariable.IsPaymentContractEnabled;
            SharedVariable = null;
        }
    });
    $scope.OpenCIVRSetting = function () {
        $rootScope.$emit("OpenCIVRSetting");
        $rootScope.$broadcast("OpenCIVRSetting");
    }
    $scope.OpenProfileUserPref = function (PageName) {
        $state.go('profile', { "PageName": PageName });
    }
    //#region ----- WebPushNotificationStart------------------
    /*
    var firebaseConfig = {
        apiKey: "AIzaSyC6s3cOyyoBEkWrAUDW9emZqyAz1vfyRYM",
        authDomain: "radflowapp.firebaseapp.com",
        projectId: "radflowapp",
        storageBucket: "radflowapp.appspot.com",
        messagingSenderId: "898866040669",
        appId: "1:898866040669:web:72de87f5d4c541664a62b4",
        measurementId: "G-HYNYMGYNTF"
    }
    function initFirebase() {
        var firebaseApp = firebase.initializeApp(firebaseConfig);
     
        var messaging = firebase.messaging();
        messaging.requestPermission().then(function (permission) {
            console.log("have permisssion");
            return messaging.getToken();
        }).then(function (token) {
            console.log(token);
            ProfileService.SetDeviceToken(
                {
                    "DeviceToken": token,
                    "DeviceType": "Web",
                    "UserID": $sessionStorage.currentUserData.userId
                }
            )
        }).catch(function (err) {
            console.log("Error ");
            console.log(err);
        });
        messaging.onMessage(function (payload) {
            console.log(payload);
            var notificationTitle = payload.notification.title;
            var notificationOptions = {
                body: payload.notification.body,
                icon: payload.notification.icon,
                image: payload.notification.image,
                //vibrate: [200, 100, 200, 100, 200, 100, 200],
                //tag: "vibration-sample",
                //renotify: true
            };
     
            if (!("Notification" in window)) {
                console.log("This browser does not support system notifications.");
            } else if (Notification.permission === "granted") {
                // If it's okay let's create a notification
                if (payload.data["gcm.notification.userid"] == $sessionStorage.currentUserData.userId) {
                    var notification = new Notification(notificationTitle, notificationOptions);
                    notification.onclick = function (event) {
                        event.preventDefault();
                        window.open(payload.notification.click_action, '_blank');
                        notification.close();
                    }
                }
                else if (payload.data["gcm.notification.isglobal"]) {
                    var notification = new Notification(notificationTitle, notificationOptions);
                    notification.onclick = function (event) {
                        event.preventDefault();
                        window.open(payload.notification.click_action, '_blank');
                        notification.close();
                    }
                }
            }
        });
    }
    */
    //----- WebPushNotificationEnd------------------
    //window.addEventListener('beforeunload', (event) => {
    //    event.preventDefault();
    //    event.returnValue = '';
    //});
    //#endregion -------------------------------------------

    //Initialize the current feature tour Start                   

    //#region ----- Release-worklist-Tour------------------
    function prepareUserTour() {
        return new Tour({
            backdrop: true,
            onShown: function (tourUserPref) {
                var step = tourUserPref._options.steps[tourUserPref._current];
                $(step.element).addClass('tour-section-disbl');
            },
            onHidden: function (tourUserPref) {
                var step = tourUserPref._options.steps[tourUserPref._current];
                $(step.element).removeClass('tour-section-disbl');
            },
            onEnd: function (tourUserPref) {
                $('.tour-section-disbl').removeClass('tour-section-disbl');
                $('.deskmenu .pagetop-nav.navbar-collapse.collapse').removeClass('in');
                $('.moremenu .pagetop-nav.navbar-collapse.collapse').removeClass('in');
                $rootScope.$broadcast('activeChatMenuBar:shareExamComponent', false);
                updateuserguidepreference();
            },
            storage: false,
            //container: "body",
            debug: false,
            delay: true,
        });
    }

    function startCurrentFeatureTour() {
        if (!ShowReleaseGuide || ShowReleaseGuide.PreferenceValue != '1.6.0.0') {
            var tourSteps = [];
            _.each(steps, function (step) {
                if ($sessionStorage.currentUserData.userRoles.includes(step.role)) {
                    tourSteps.push(step);
                }
            });
            if (tourSteps.length > 0 && tourUserPref && tourUserPref.addSteps) {

                tourUserPref.addSteps(tourSteps);

                tourUserPref.init();

                var timeout = $timeout(function () {

                    //if ($scope.halfScale) {
                    //    $('.deskmenu .pagetop-nav.navbar-collapse.collapse').addClass('in');
                    //    $('.moremenu .pagetop-nav.navbar-collapse.collapse').addClass('in');
                    //}
                    tourUserPref.start(true);

                    $timeout.cancel(timeout);
                    timeout = null;
                }, 400);
            }

        }

    }

    function updateuserguidepreference() {
        ShowReleaseGuide = {
            UserPreferenceID: (ShowReleaseGuide && ShowReleaseGuide.UserPreferenceID) ? ShowReleaseGuide.UserPreferenceID : "-1",
            PreferenceType: "ShowReleaseGuide",
            UserID: $sessionStorage.currentUserData.userId,
            PreferenceValue: APP_CONSTANTS.radflowUIVersion,
        };
        UserPreferenceService.AddEditUserPreferences([ShowReleaseGuide]);
    }
    //#endregion -------------------------------------------

    //#region ----- Release-Tech-Tour------------------


    function prepareUserTourTech() {
        return new Tour({
            backdrop: true,
            onShown: function (tourUserPrefTech) {
                var step = tourUserPrefTech._options.steps[tourUserPrefTech._current];
                $(step.element).addClass('tour-section-disbl');
            },
            onHidden: function (tourUserPrefTech) {
                var step = tourUserPrefTech._options.steps[tourUserPrefTech._current];
                $(step.element).removeClass('tour-section-disbl');
            },
            onEnd: function (tourUserPrefTech) {
                $('.tour-section-disbl').removeClass('tour-section-disbl');
                $('.deskmenu .pagetop-nav.navbar-collapse.collapse').removeClass('in');
                $('.moremenu .pagetop-nav.navbar-collapse.collapse').removeClass('in');
                $rootScope.$broadcast('activeChatMenuBar:shareExamComponent', false);
                updateuserguidepreferencetech();
            },
            storage: false,
            //container: "body",
            debug: false,
            delay: true,
        });
    }


    function startCurrentFeatureTourTech() {
        if (!ShowReleaseGuideTech || ShowReleaseGuideTech.PreferenceValue != '1.7.6.0') {
            var tourSteps = [];
            _.each(stepsTech, function (step) {
                if ($sessionStorage.currentUserData.userRoles.includes(step.role)) {
                    tourSteps.push(step);
                }
            });
            if (tourSteps.length > 0 && tourUserPrefTech && tourUserPrefTech.addSteps) {

                tourUserPrefTech.addSteps(tourSteps);

                tourUserPrefTech.init();

                var timeout = $timeout(function () {
                    tourUserPrefTech.start(true);

                    $timeout.cancel(timeout);
                    timeout = null;
                }, 400);
            }

        }

    }

    function updateuserguidepreferencetech() {
        UserPreferenceService.AddEditUserPreferences([{
            UserPreferenceID: (ShowReleaseGuideTech && ShowReleaseGuideTech.UserPreferenceID) ? ShowReleaseGuideTech.UserPreferenceID : "-1",
            PreferenceType: "ShowReleaseGuideTech",
            UserID: $sessionStorage.currentUserData.userId,
            PreferenceValue: '1.7.6.0',
        }
        ]);
    }

    //#endregion -------------------------------------------

    //#region ----- Release-IndexPage-Tour------------------


    function prepareUserTourIndex() {
        return new Tour({
            backdrop: true,
            onShown: function (tourUserPrefIndex) {
                var step = tourUserPrefIndex._options.steps[tourUserPrefIndex._current];
                $(step.element).addClass('tour-section-disbl');
            },
            onHidden: function (tourUserPrefIndex) {
                var step = tourUserPrefIndex._options.steps[tourUserPrefIndex._current];
                $(step.element).removeClass('tour-section-disbl');
            },
            onEnd: function (tourUserPrefIndex) {
                $('.tour-section-disbl').removeClass('tour-section-disbl');
                $('.deskmenu .pagetop-nav.navbar-collapse.collapse').removeClass('in');
                $('.moremenu .pagetop-nav.navbar-collapse.collapse').removeClass('in');
                updateuserguidepreferenceindex();
            },
            storage: false,
            //container: "body",
            debug: false,
            delay: true,
        });
    }


    function startCurrentFeatureTourIndex() {
        if (!ShowReleaseGuideIndex || ShowReleaseGuideIndex.PreferenceValue != '1.5.9.0') {
            var tourSteps = [];
            _.each(stepsIndex, function (step) {
                if ($sessionStorage.currentUserData.userRoles.includes(step.role) || step.role == 'All') {
                    tourSteps.push(step);
                }
            });
            if (tourSteps.length > 0 && tourUserPrefIndex && tourUserPrefIndex.addSteps) {

                tourUserPrefIndex.addSteps(tourSteps);

                tourUserPrefIndex.init();

                var timeout = $timeout(function () {
                    tourUserPrefIndex.start(true);

                    $timeout.cancel(timeout);
                    timeout = null;
                }, 400);
            }

        }

    }

    function updateuserguidepreferenceindex() {
        ShowReleaseGuideIndex = {
            UserPreferenceID: (ShowReleaseGuideIndex && ShowReleaseGuideIndex.UserPreferenceID) ? ShowReleaseGuideIndex.UserPreferenceID : "-1",
            PreferenceType: "ShowReleaseGuideIndex",
            UserID: $sessionStorage.currentUserData.userId,
            PreferenceValue: APP_CONSTANTS.radflowUIVersion,
        };
        UserPreferenceService.AddEditUserPreferences([ShowReleaseGuideIndex]);
    }

    //#endregion -------------------------------------------

    //Initialize the current feature tour End
    $scope.onMenuOptionClicked = function (menuItems, stateRef) {
        if (!(menuItems.length == 1 && menuItems[0].stateRef == 'userAnalytics')) {
            if (stateRef == "userAnalytics") {
                var analyticurl = window.location.origin + __env.AnalyticsPopoutUrl.replace('@TOKEN', encodeURIComponent($sessionStorage.currentUserData.accessToken)).replace('@USERID', encodeURIComponent($sessionStorage.currentUserData.userId)).replace('@REFRESHTOKEN', encodeURIComponent($sessionStorage.currentUserData.refreshToken)).replace('@USERROLES', encodeURIComponent($sessionStorage.currentUserData.userRoles));
                var popup = windowHandler.openByPreference(analyticurl, "Analytics", 1000, "Analytics", "", false);
                var timeout = $timeout(function () {
                    if (popup) {
                        popup.moveTo(0, 0);
                        popup.resizeTo(window.screen.width, window.screen.height);
                    }
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 10);
            }
        }
    }

    function GetPeerReviewPendingCount() {
        ReviewOrderService.GetPeerReviewPendingCount({ UserID: $sessionStorage.currentUserData.userId }).then(function (result) {
            $rootScope.$broadcast("PeerReviewPendingCount", result);
        });
    }

    $scope.$on("startReleaseTour", function (evt, data) {
        startCurrentFeatureTour();
        // startCurrentFeatureTourIndex();
    });
    $scope.$on("ShowReleaseGuideTech", function (evt, data) {
        //startCurrentFeatureTourTech();
        // startCurrentFeatureTourIndex();

    });


    $scope.$on("event.NotifyRemoveFromClipboard", function (evt, data) {
        SharedService.handleRemoveFromClipboard(data, RuleSharedService.ReSetMasterData());
    });
    $scope.HelpMenuAction = function (val, e) {
        if (val == true) {
            e = e || window.event;
            var target = e.target || e.srcElement,
                text = target.textContent || target.innerText;
            //if (text == "Worklist Single View (Start Tour)") {
            //    $state.go("worklist");
            //}
            if (text == "Technologist Worklist (Start Tour)") {
                if ($state.current.name != "techno") {
                    $state.go("techno", { "TourFlag": true });
                } else {
                    $rootScope.$broadcast("Techno_Tour", true);
                }
            }
            if (text == "Worklist (Start Tour)") {
                if ($state.current.name != "worklist-lite") {
                    $state.go("worklist-lite", { "TourFlag": true });
                }
                else {
                    $rootScope.$broadcast("NewWorklist_Tour", true);
                }
            }
            if (text == "Peer Review (Start Tour)") {
                if ($state.current.name != "revieworder") {
                    $state.go("revieworder", { "TourFlag": true });
                }
                else {
                    $rootScope.$broadcast("PeerReview_Tour", true);
                }
            }
            if (text == "Physician Worklist (Start Tour)") {
                if ($state.current.name != "physician-worklist") {
                    $state.go("physician-worklist", { "TourFlag": true });
                }
                else {
                    $rootScope.$broadcast("PhysicianWorklist_Tour", true);
                }
            }
            if (text == "FAQ") {
                window.open("faq.html");
            }
        }
        $scope.helpMenuCliked = val;
    }

    function IsAddendumRequestVisible() {
        var d = $q.defer();
        UserPreferenceService.IsAddendumRequestVisible().then(function (res) {
            d.resolve(res);
        });
        return d.promise;
    }

    function GetUserPreferences(userPreference) {
        var d = $q.defer();
        UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
            d.resolve(result);
        });
        return d.promise;
    }
    //#region Marquee Tag Interval
    $scope.$on('Keepalive', function () {
        checkMarqueeTime();
    })

    function checkMarqueeTime() {
        var currentDateTime = new Date();
        var UpdatedMarqueeSetting = _.filter(SiteMarqueeSetting, function (marquee) {
            return currentDateTime <= new Date($filter('localDate')(marquee.EndDate, false, new Date()));
        });
        if (UpdatedMarqueeSetting && UpdatedMarqueeSetting.length != SiteMarqueeSetting.length) {
            $scope.AnnouncementMarqueeLookupValue = _.join(_.map(UpdatedMarqueeSetting, function (marquee) { return marquee.MarqueeText }), ' | ');
        }
    };
    function GetSiteMarqueeSetting() {
        var d = $q.defer();
        ProfileService.GetSiteMarqueeSetting($sessionStorage.currentUserData.userId).then(function (result) {
            result.sort(function (a, b) {
                var dateA = new Date(a.EndDate);
                var dateB = new Date(b.EndDate);
                if (dateA < dateB) {
                    return -1;
                } else if (dateA > dateB) {
                    return 1;
                } else {
                    return 0;
                }
            });
            d.resolve(result);
        });
        return d.promise;
    }
    //#endregion
    $scope.CountryCodes = CommonService.GetCountryCode();

    function DeleteOpenOrderByUserID() {
        var d = $q.defer();
        if ($sessionStorage.currentUserData) {
            WorklistService.DeleteOpenOrderByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                d.resolve();
            });
        }
        return d.promise;
    };

    $scope.OnTermsOfUseSubmit = function () {
        $scope.TermsOfUseVisible = false;
        $scope.LoginSuccessfully = true;
        GetPeerReviewPendingCount();

        var VendorAddressDetail = LogingSuccessResult[3];
        $sessionStorage.currentUserData.Address = VendorAddressDetail;
        $sessionStorage.IsAddendumRequestVisible = LogingSuccessResult[0];

        $sessionStorage.BillAPIEnable = LogingSuccessResult[1].BillAPIEnable;
        SiteMarqueeSetting = LogingSuccessResult[2];


        $sessionStorage.EnableRowsForSelectedTenants = LogingSuccessResult[1].EnableRowsForSelectedTenants;
        $sessionStorage.currentUserData.RemoveRenderingPhysician = !($sessionStorage.currentUserData.userRoles.includes('Admin'));

        if (LoginSuccessData.userRoles
            && LoginSuccessData.userRoles.includes('User')) {
            $scope.IsPaymentContractEnabled = LogingSuccessResult[1].UserAccountDetails.IsPaymentContractEnabled;
            CommonService.setVariable('IsPaymentContractEnabled', $scope.IsPaymentContractEnabled);
            $rootScope.$broadcast("ShowPaymentInvoiceHistory", $scope.IsPaymentContractEnabled);
            $sessionStorage.PaymentIncomingAudio = LogingSuccessResult[1].PaymentIncomingAudio;
            $sessionStorage.ShowOnlyFiveStudyForSelectedTenants = LogingSuccessResult[1].ShowOnlyFiveStudyForSelectedTenants;
            $sessionStorage.FlashSTATHighPriorityStudyInterval = LogingSuccessResult[1].FlashSTATHighPriorityStudyInterval;
            $sessionStorage.STATHighPriorityStudyTooltip = LogingSuccessResult[1].STATHighPriorityStudyTooltip;
            //#TODO -- need to reivew with Sharvi and Sutirth.
            /*if (result.UserAccountDetails.IsPaymentContractEnabled) {
                if (!result.UserAccountDetails.IsUserAccountDetailVerified) {
                    var toast = toaster.error({
                        body: 'Your payment account details are pending',
                        tapToDismiss: true,
                        clickHandler: function (Toaster, closeFlag) {
                            if (!closeFlag) {
                                $state.go('profile');
                            }
                            toaster.clear(toast);
                        }
                    });
                }
            }*/
        }
        $scope.LoadMoreWorklist = _.find(LogingSuccessResult[1].UserPreferences, {
            PreferenceType: "LoadMoreWorklist"
        });
        if ($scope.LoadMoreWorklist != null) {
            $scope.LoadMoreWorklist.PreferenceValue = $scope.LoadMoreWorklist.PreferenceValue == "1" ? true : false;
            $localStorage.LoadMoreWorklist = $scope.LoadMoreWorklist.PreferenceValue;
        }

        $sessionStorage.DicomViewerCredentials = [];
        var DicomViewerCred = _.find(LogingSuccessResult[1].UserPreferences, {
            PreferenceType: "DicomViewerCred"
        });
        if (DicomViewerCred && DicomViewerCred.PreferenceValue) {
            $sessionStorage.DicomViewerCredentials = JSON.parse(DicomViewerCred.PreferenceValue);
        }
        DicomViewerCred = null;

        var DefaultDictationSystem = _.filter(LogingSuccessResult[1].UserPreferences, {
            PreferenceType: "DefaultDictationSystem"
        });
        $sessionStorage.DefaultDictationSystem = "";
        if (DefaultDictationSystem != null && DefaultDictationSystem.length > 0 && DefaultDictationSystem[0].PreferenceValue) {
            $sessionStorage.DefaultDictationSystem = DefaultDictationSystem[0].PreferenceValue;
        }
        DefaultDictationSystem = null;

        var MedDreamViewerKeepOpen = _.find(LogingSuccessResult[1].UserPreferences, {
            PreferenceType: "MedDreamViewerKeepOpen"
        });
        $sessionStorage.MedDreamViewerKeepOpen = true;
        if (MedDreamViewerKeepOpen && MedDreamViewerKeepOpen.PreferenceValue) {
            $sessionStorage.MedDreamViewerKeepOpen = MedDreamViewerKeepOpen.PreferenceValue == "1" ? true : false;
        }
        MedDreamViewerKeepOpen = null;

        $scope.userRoles = LoginSuccessData.userRoles;

        $scope.userRoles = $sessionStorage.currentUserData.userRoles;
        showUserGuide = _.find(LogingSuccessResult[1].UserPreferences, { PreferenceType: "ShowUserGuide" });
        ShowReleaseGuide = _.find(LogingSuccessResult[1].UserPreferences, {
            PreferenceType: "ShowReleaseGuide"
        });
        ShowReleaseGuideTech = _.find(LogingSuccessResult[1].UserPreferences, {
            PreferenceType: "ShowReleaseGuideTech"
        });
        ShowReleaseGuideIndex = _.find(LogingSuccessResult[1].UserPreferences, {
            PreferenceType: "ShowReleaseGuideIndex"
        });
        //var starttourtimeout = $timeout(function () {
        //    if (showUserGuide && showUserGuide.PreferenceValue == "0") {
        //        startCurrentFeatureTour();
        //    }
        //    //else if (!data.userRoles.includes("User") && data.userRoles.includes("Technologist")) {
        //    //    startCurrentFeatureTour();
        //    //}
        //    $timeout.cancel(starttourtimeout);
        //    starttourtimeout = null;
        //}, 100);
        if (LogingSuccessResult[1] && LogingSuccessResult[1].ClipboardToBeRemovedForTenants) {
            $sessionStorage.ClipboardToBeRemovedForTenants = LogingSuccessResult[1].ClipboardToBeRemovedForTenants.split(',');
        }
        if (LogingSuccessResult[1] && LogingSuccessResult[1].DontShowLockedByForTenants && LogingSuccessResult[1].DontShowLockedByForTenants != "") {
            $sessionStorage.DontShowLockedByForTenants = LogingSuccessResult[1].DontShowLockedByForTenants.split(',');
        }
        if (SiteMarqueeSetting && SiteMarqueeSetting.length > 0) {
            $scope.AnnouncementMarqueeLookupValue = _.join(_.map(SiteMarqueeSetting, function (marquee) { return marquee.MarqueeText }), ' | ');
        }
        if (LogingSuccessResult[1] && LogingSuccessResult[1].SpecialGroup) {
            $sessionStorage.SpecialGroup = LogingSuccessResult[1].SpecialGroup.split(',');
        }
        if (LogingSuccessResult[1] && LogingSuccessResult[1].SpecialGroupEmailIDs) {
            $sessionStorage.SpecialGroupEmailIDs = LogingSuccessResult[1].SpecialGroupEmailIDs.split(',');
        }
        if (LogingSuccessResult[1] && LogingSuccessResult[1].SpecialTenantUsersSTATStudiesSchedule) {
            $sessionStorage.SpecialTenantUsersSTATStudiesSchedule = LogingSuccessResult[1].SpecialTenantUsersSTATStudiesSchedule;
        }
        if (LogingSuccessResult[1] && LogingSuccessResult[1].SpecialTenants) {
            $sessionStorage.SpecialTenants = LogingSuccessResult[1].SpecialTenants.split(',');
        }

        $sessionStorage.currentUserData.OnlyUserAccess = $sessionStorage.currentUserData.userRoles.includes('User') && !($sessionStorage.currentUserData.userRoles.includes('Admin'));
        $sessionStorage.EnableSOSTenants = LogingSuccessResult[1].EnableSOSTenants;
        $sessionStorage.isSOSVisible = LogingSuccessResult[1].isSOSVisible;
        $sessionStorage.EnableInfoLogging = LogingSuccessResult[1].EnableInfoLogging;
        /*
             * "password": "Texas1989!civie",
                "username": "pstasiak@collaborativeimaging.com"
                "password": "vlHv#9*Vx#R7MM5m",
                "username": "spatel@civie.com"
             */
        $scope.TermsOfUseVisible = false;
        var currentState = $sessionStorage.currentState;

        var urlParams = new URLSearchParams(window.location.search);
        var Accession = urlParams.get('Accession');
        var pageName = urlParams.get('Page');

        if ($scope.AnalyticsPopupUrl.CallFrom == 'RadFlow') {
            $scope.AnalyticsWindowPopout = false;
            $state.go('userAnalytics');
        }
        else if ($scope.userRoles && $scope.userRoles.length > 0 && Accession && pageName) {
            if ($scope.userRoles.includes("Physician") && pageName.toLowerCase() == "phy") {
                $state.go('physician-worklist');
            } else {
                redirectBasedOnUserRole();
            }
        }
        else {
            Idle.watch();
            Keepalive.start();
            if (currentState && currentState != 'login') {
                if (currentState != 'profile') {
                    $state.go(currentState);
                }
                else {
                    $state.go(currentState, { "PageName": "ProfileMenu" });
                }

            }
            else {
                redirectBasedOnUserRole();
            }

            if ($scope.userRoles.length > 0) {
                var allowedUser = false;
                if ($scope.userRoles.includes('User')) {
                    allowedUser = true;
                }
                $scope.IsTechUser = !allowedUser;
            }
        }
    }

    function redirectBasedOnUserRole() {
        if ($scope.userRoles && $scope.userRoles.length > 0) {
            if ($scope.userRoles.includes("User")) {
                $state.go('worklist-lite');
            }
            else if ($scope.userRoles.includes("Technologist")) {
                $state.go('techno');
            }
            else if ($scope.userRoles.includes("Admin") || $scope.userRoles.includes("SuperAdmin")) {
                $state.go('account.list');
            }
            else if ($scope.userRoles.includes("Analytics")) {
                $state.go('userAnalytics');
            }
            else if ($scope.userRoles.includes("Financier")) {
                $state.go('paymentinvoice');
            }
            else if ($scope.userRoles.includes("Physician")) {
                $state.go('physician-worklist');
            }
        }
    }

    function ValidateTermsOfUseRange(termsOfUseRange) {
        if (termsOfUseRange && termsOfUseRange.indexOf('to') != -1) {
            var dateRange = termsOfUseRange.split('to');
            var startDate = moment(dateRange[0]);
            var endDate = moment(dateRange[1]);
            var localDate = moment(new Date().toLocaleDateString());
            if (localDate.diff(startDate) >= 0 && localDate.diff(endDate) <= 0) {
                $scope.TermsOfUseVisible = true;
            }
        } else if (termsOfUseRange && termsOfUseRange.indexOf('to') == -1) {
            var startDate = moment(termsOfUseRange);
            var localDate = moment(new Date().toLocaleDateString());
            if (localDate.diff(startDate) >= 0) {
                $scope.TermsOfUseVisible = true;
            }
        } else {
            $scope.TermsOfUseVisible = false;
        }

    }

    // RadPod doctors (login/pin screens) skip the RadFlow initialisation entirely: only the Code of Conduct
    // gate runs here, then CommonService hands them over to CIVR. indexController owns the CoC panel, which is
    // rendered inside the login view (inherits isCodeOfConductVisible), so the login view stays up until they sign.
    // Called by loginController through scope inheritance, the same way the login view calls cocSubmit().
    $scope.CheckCocAndRedirectToCIVR = function (data) {
        var userId = data.userId;
        var splitLower = function (value) {
            return value ? value.split(',').map(function (s) { return s.trim().toLowerCase(); }) : [];
        };
        $q.all([
            UserPreferenceService.GetUserPreferences({ UserID: userId, PreferenceType: 'CodeOfConduct' }),
            WorklistService.GetLookupByType('CodeOfConduct'),
            ManageLocationService.GetTenantsByUserID({ UserID: userId })
        ]).then(function (res) {
            var config = res[0] || {};
            var requiredRoles = splitLower(config.EnableCodeOfConductUserRoles);
            var cocTenants = splitLower(config.EnableCodeOfConductTenants);
            var userRoles = (data.userRoles || []).map(function (r) { return r.trim().toLowerCase(); });
            var hasRequiredRole = requiredRoles.length === 0 || _.some(requiredRoles, function (r) { return userRoles.indexOf(r) !== -1; });
            var hasCocTenant = _.some(res[2], function (t) { return t.Name && cocTenants.indexOf(t.Name.toLowerCase()) !== -1; });
            var cocPref = _.find(config.UserPreferences, { PreferenceType: 'CodeOfConduct' });
            if (config.ShowCodeOfConduct && hasRequiredRole && hasCocTenant && !(cocPref && cocPref.PreferenceValue)) {
                cocContent = _.find(res[1], { Type: 'CodeOfConduct' });
                pendingCivrRedirect = true;
                showCocPanel(data);
            } else {
                CommonService.RedirectToCIVRSmartWorklist(data);
            }
        }).catch(function () {
            // Any failure of the CoC check (API error or an error while evaluating the result) must not leave the
            // user on the login screen or send them to RadFlow: continue with the CIVR redirect.
            pendingCivrRedirect = false;
            CommonService.RedirectToCIVRSmartWorklist(data);
        });
    };

    function continueLogin() {
        if (!$scope.TermsOfUseVisible || !$sessionStorage.LoginByUserName) {
            $scope.OnTermsOfUseSubmit();
        } else {
            $timeout(function () {
                var termsOfUseDiv = document.getElementById('termsofuse');
                if (termsOfUseDiv && $scope.TermsOfUseContent) {
                    termsOfUseDiv.innerHTML = DOMPurify.sanitize($scope.TermsOfUseContent.Value);
                }
            }, 0);
        }
    }

    function checkAndProceedAfterLogin(data) {
        var showCoc = LogingSuccessResult && LogingSuccessResult[1] && LogingSuccessResult[1].ShowCodeOfConduct;
        if (!showCoc) { ValidateTermsOfUseRange(pendingTermsOfUseRange); continueLogin(); return; }
        var userId = (data && data.userId) || ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) || '';
        if (EnableCodeOfConductUserRoles.length > 0) {
            var userRoles = (($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles) || []).map(function (r) { return r.trim().toLowerCase(); });
            var hasRequiredRole = _.some(EnableCodeOfConductUserRoles, function (r) { return userRoles.indexOf(r.trim().toLowerCase()) !== -1; });
            if (!hasRequiredRole) { ValidateTermsOfUseRange(pendingTermsOfUseRange); continueLogin(); return; }
        }
        var cocTenants = (EnableCodeOfConductTenants || []).map(function (s) { return s.trim().toLowerCase(); });
        ManageLocationService.GetTenantsByUserID({ UserID: userId }).then(function (tenants) {
            var hasCocTenant = Array.isArray(tenants) && _.find(tenants, function (t) {
                return t.Name && cocTenants.indexOf(t.Name.toLowerCase()) !== -1;
            });
            if (!hasCocTenant) { ValidateTermsOfUseRange(pendingTermsOfUseRange); continueLogin(); return; }
            UserPreferenceService.GetUserPreferences({ UserID: userId, PreferenceType: 'CodeOfConduct' }).then(function (result) {
                var prefs = result && result.UserPreferences;
                var cocPref = prefs && _.find(prefs, { PreferenceType: 'CodeOfConduct' });
                if (cocPref && cocPref.PreferenceValue) {
                    ValidateTermsOfUseRange(pendingTermsOfUseRange);
                    continueLogin();
                } else {
                    showCocPanel(data); // COC takes priority — Terms of Use deferred to after COC
                }
            }, function () { showCocPanel(data); });
        }, function () {
            ValidateTermsOfUseRange(pendingTermsOfUseRange);
            continueLogin();
        });
    }

    function showCocPanel(data) {
        pendingLoginData = data;
        $scope.isCodeOfConductVisible = true;
        $scope.coc.step = 1;
        $scope.coc.hasScrolled = false;
        $scope.coc.hasAgreed = false;
        $scope.coc.signatureDate = moment().format('MM/DD/YYYY');
        var u = $sessionStorage.currentUserData || data || {};
        var _last = (u.LastName || '').trim();
        var _first = (u.FirstName || '').trim();
        $scope.coc.userName = _last && _first ? _last + ', ' + _first : (_last || _first);
        $scope.coc.documentUrl = __env._environment.config.apiResourceServiceBaseUri + 'common/GetCocDocument';
        $timeout(function () {
            var cocDiv = document.getElementById('codeofconduct');
            if (cocDiv && cocContent && cocContent.Value) {
                cocDiv.innerHTML = DOMPurify.sanitize(cocContent.Value);
            }
        }, 0);
    }

    function cocInitCanvas() {
        var canvas = document.getElementById('cocSignatureCanvas');
        if (!canvas) return;
        var rect = canvas.getBoundingClientRect();
        if (!rect.width || !rect.height) {
            $timeout(cocInitCanvas, 100);
            return;
        }
        canvas.width = Math.round(rect.width);
        canvas.height = Math.round(rect.height);
        var ctx = canvas.getContext('2d');
        ctx.strokeStyle = '#1a1aff';
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
        var drawing = false;

        function getPos(e) {
            var rect = canvas.getBoundingClientRect();
            if (e.touches) {
                return { x: e.touches[0].clientX - rect.left, y: e.touches[0].clientY - rect.top };
            }
            return { x: e.clientX - rect.left, y: e.clientY - rect.top };
        }

        canvas.onmousedown = function (e) { drawing = true; ctx.beginPath(); var p = getPos(e); ctx.moveTo(p.x, p.y); };
        canvas.onmousemove = function (e) {
            if (!drawing) return;
            var p = getPos(e);
            ctx.lineTo(p.x, p.y);
            ctx.stroke();
            if (!$scope.coc.hasDrawn) {
                $scope.$apply(function () { $scope.coc.hasDrawn = true; });
            }
        };
        canvas.onmouseup = function () { drawing = false; };
        canvas.onmouseleave = function () { drawing = false; };
        canvas.ontouchstart = function (e) { e.preventDefault(); drawing = true; ctx.beginPath(); var p = getPos(e); ctx.moveTo(p.x, p.y); };
        canvas.ontouchmove = function (e) {
            e.preventDefault();
            if (!drawing) return;
            var p = getPos(e);
            ctx.lineTo(p.x, p.y);
            ctx.stroke();
            if (!$scope.coc.hasDrawn) {
                $scope.$apply(function () { $scope.coc.hasDrawn = true; });
            }
        };
        canvas.ontouchend = function () { drawing = false; };
        $scope.coc.hasDrawn = false;
        $scope._cocCanvas = canvas;
    }

    $scope.cocOnScrollEnd = function () {
        $scope.coc.hasScrolled = true;
    };

    function cocLoadDocument() {
        $scope.coc.docLoading = true;
        $scope.coc.docError = false;

        var pdfUrl = $scope.coc.documentUrl || 'assets/docs/code-of-conduct-attestation.pdf';
        var container = document.getElementById('cocPdfContainer');
        var scrollContainer = document.getElementById('cocPdfScrollContainer');
        if (!container || !scrollContainer) return;

        var oldPages = container.querySelectorAll('canvas.coc-pdf-page');
        for (var i = 0; i < oldPages.length; i++) { container.removeChild(oldPages[i]); }
        var oldOverlays = container.querySelectorAll('.coc-text-overlay');
        for (var i = 0; i < oldOverlays.length; i++) { container.removeChild(oldOverlays[i]); }

        var containerWidth = scrollContainer.clientWidth || 800;

        pdfJsLoader.ensureLoaded().then(function () {
            var pdfLoadParams = { url: pdfUrl };
            var _token = $sessionStorage.currentUserData && $sessionStorage.currentUserData.accessToken;
            if (_token) { pdfLoadParams.httpHeaders = { 'Authorization': 'Bearer ' + _token }; }
            // pdf.js fetches outside $http, so the interceptor does not add the APIM key (PROD)
            if (__env.OcpApimSubscriptionKey) {
                pdfLoadParams.httpHeaders = pdfLoadParams.httpHeaders || {};
                pdfLoadParams.httpHeaders['Ocp-Apim-Subscription-Key'] = __env.OcpApimSubscriptionKey;
            }
            pdfjsLib.getDocument(pdfLoadParams).promise.then(function (pdf) {
                var numPages = pdf.numPages;
                var sigCanvas = document.getElementById('cocSignatureCanvas');
                var pageGap = 8;
                var sigFound = false;
                var sigTop = 0;
                var sigLeft = 0;
                var sigWidth = 0;
                var overlayFields = {
                    radiologistName: { found: false, top: 0, left: 0 },
                    printedName:     { found: false, top: 0, left: 0 },
                    date:            { found: false, top: 0, left: 0 }
                };

                function createTextOverlay(id, text, top, left) {
                    var el = document.createElement('span');
                    el.className = 'coc-text-overlay';
                    el.id = id;
                    el.style.cssText = 'position:absolute;pointer-events:none;font-size:11px;font-family:Arial,sans-serif;color:#111;white-space:nowrap;';
                    el.style.top  = top + 'px';
                    el.style.left = left + 'px';
                    el.textContent = text;
                    container.appendChild(el);
                }

                function renderPage(pageNum, yOffset) {
                    pdf.getPage(pageNum).then(function (page) {
                        var unscaled = page.getViewport({ scale: 1 });
                        var scale = containerWidth / unscaled.width;
                        var viewport = page.getViewport({ scale: scale });

                        var pageCanvas = document.createElement('canvas');
                        pageCanvas.className = 'coc-pdf-page';
                        pageCanvas.width = Math.round(viewport.width);
                        pageCanvas.height = Math.round(viewport.height);
                        pageCanvas.style.display = 'block';
                        pageCanvas.style.marginBottom = pageGap + 'px';
                        container.insertBefore(pageCanvas, sigCanvas);

                        page.render({ canvasContext: pageCanvas.getContext('2d'), viewport: viewport }).promise.then(function () {
                            return page.getTextContent();
                        }).then(function (textContent) {
                            var allFound = sigFound && overlayFields.radiologistName.found && overlayFields.printedName.found && overlayFields.date.found;
                            if (!allFound) {
                                for (var j = 0; j < textContent.items.length; j++) {
                                    var item = textContent.items[j];
                                    if (!item.str) continue;
                                    var itemStr = item.str.toLowerCase().trim();

                                    if (!sigFound && itemStr.indexOf('radiologist signature') !== -1) {
                                        var pt = viewport.convertToViewportPoint(item.transform[4], item.transform[5]);
                                        var ptEnd = viewport.convertToViewportPoint(item.transform[4] + item.width, item.transform[5]);
                                        sigLeft = Math.round(ptEnd[0]) + 2;
                                        sigTop = yOffset + Math.round(pt[1]) - 46;
                                        sigWidth = Math.max(120, Math.round(containerWidth * 0.65) - sigLeft);
                                        sigFound = true;
                                    }

                                    if (!overlayFields.radiologistName.found && itemStr.indexOf('radiologist name') !== -1) {
                                        var ptRN = viewport.convertToViewportPoint(item.transform[4], item.transform[5]);
                                        // item.str may include trailing underscores — estimate label-only width
                                        var rnRaw = item.str || '';
                                        var rnUnderscoreIdx = rnRaw.search(/_+\s*$/);
                                        var rnLabelProportion = rnUnderscoreIdx > 0 ? rnUnderscoreIdx / rnRaw.length : 1;
                                        var rnLabelEndX = item.transform[4] + item.width * rnLabelProportion;
                                        var ptRNEnd = viewport.convertToViewportPoint(rnLabelEndX, item.transform[5]);
                                        overlayFields.radiologistName = { found: true, top: yOffset + Math.round(ptRN[1]) - 13, left: Math.round(ptRNEnd[0]) + 4 };
                                    }

                                    if (!overlayFields.printedName.found && itemStr.indexOf('printed name') !== -1) {
                                        var ptPN = viewport.convertToViewportPoint(item.transform[4], item.transform[5]);
                                        var ptPNEnd = viewport.convertToViewportPoint(item.transform[4] + item.width, item.transform[5]);
                                        overlayFields.printedName = { found: true, top: yOffset + Math.round(ptPN[1]) - 13, left: Math.round(ptPNEnd[0]) + 4 };
                                    }

                                    if (!overlayFields.date.found && itemStr.startsWith('date:')) {
                                        var ptD = viewport.convertToViewportPoint(item.transform[4], item.transform[5]);
                                        var ptDEnd = viewport.convertToViewportPoint(item.transform[4] + item.width, item.transform[5]);
                                        overlayFields.date = { found: true, top: yOffset + Math.round(ptD[1]) - 13, left: Math.round(ptDEnd[0]) + 4 };
                                    }

                                    if (sigFound && overlayFields.radiologistName.found && overlayFields.printedName.found && overlayFields.date.found) break;
                                }
                            }

                            var nextY = yOffset + Math.round(viewport.height) + pageGap;
                            if (pageNum < numPages) {
                                renderPage(pageNum + 1, nextY);
                            } else {
                                $scope.$apply(function () { $scope.coc.docLoading = false; });

                                if (sigFound && sigCanvas) {
                                    sigCanvas.style.setProperty('position', 'absolute', 'important');
                                    sigCanvas.style.setProperty('top', sigTop + 'px', 'important');
                                    sigCanvas.style.setProperty('left', sigLeft + 'px', 'important');
                                    sigCanvas.style.setProperty('width', sigWidth + 'px', 'important');
                                    sigCanvas.style.setProperty('height', '50px', 'important');
                                    sigCanvas.style.setProperty('display', 'block', 'important');
                                    sigCanvas.style.setProperty('background', 'rgba(255,255,255,0.6)', 'important');
                                    sigCanvas.style.setProperty('border', '1.5px dashed #1a1aff', 'important');

                                    $scope.$apply(function () {
                                        $scope.coc.sigScrollTop = Math.max(0, sigTop - 150);
                                        $scope.coc.showSigHint = true;
                                    });

                                    scrollContainer.scrollTop = 0;

                                    // Hide hint once user scrolls within 200px of the signature line
                                    scrollContainer.addEventListener('scroll', function onCocScroll() {
                                        if (scrollContainer.scrollTop >= Math.max(0, sigTop - 200)) {
                                            $scope.$apply(function () { $scope.coc.showSigHint = false; });
                                            scrollContainer.removeEventListener('scroll', onCocScroll);
                                        }
                                    });

                                    $timeout(function () { cocInitCanvas(); }, 100);
                                }

                                var userName = $scope.coc.userName || '';
                                var signatureDate = $scope.coc.signatureDate || '';
                                if (overlayFields.radiologistName.found) {
                                    createTextOverlay('coc-overlay-radname', userName, overlayFields.radiologistName.top, overlayFields.radiologistName.left);
                                }
                                if (overlayFields.printedName.found) {
                                    createTextOverlay('coc-overlay-printedname', userName, overlayFields.printedName.top, overlayFields.printedName.left);
                                }
                                if (overlayFields.date.found) {
                                    createTextOverlay('coc-overlay-date', signatureDate, overlayFields.date.top, overlayFields.date.left);
                                }
                            }
                        });
                    });
                }

                renderPage(1, 0);
            }, function () {
                $timeout(function () { $scope.coc.docError = true; $scope.coc.docLoading = false; });
            });
        }, function () {
            $timeout(function () { $scope.coc.docError = true; $scope.coc.docLoading = false; });
        });
    }

    $scope.cocScrollToSignature = function () {
        var scrollCon = document.getElementById('cocPdfScrollContainer');
        if (scrollCon && $scope.coc.sigScrollTop != null) {
            scrollCon.scrollTop = $scope.coc.sigScrollTop;
        }
    };

    $scope.cocGoToStep2 = function () {
        if (!$scope.coc.hasAgreed) return;
        $scope.coc.docLoading = true;
        $scope.coc.docError = false;
        $scope.coc.step = 2;
        $scope.coc.typedName = '';
        $scope.coc.hasDrawn = false;
        $scope.coc.showSigHint = false;
        $scope.coc.sigScrollTop = null;
        $scope._cocCanvas = null;
        $timeout(function () { cocLoadDocument(); }, 50);
    };

    $scope.cocGoToStep1 = function () {
        $scope.coc.step = 1;
        $scope.coc.hasDrawn = false;
        $scope.coc.showSigHint = false;
        $scope._cocCanvas = null;
        var scrollCon = document.getElementById('cocPdfScrollContainer');
        if (scrollCon) { scrollCon.scrollTop = 0; }
        $timeout(function () {
            var cocDiv = document.getElementById('codeofconduct');
            if (cocDiv && cocContent && cocContent.Value) {
                cocDiv.innerHTML = DOMPurify.sanitize(cocContent.Value);
            }
        }, 0);
    };

    $scope.cocClearCanvas = function () {
        var canvas = $scope._cocCanvas;
        if (!canvas) return;
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
        $scope.coc.hasDrawn = false;
    };

    $scope.cocCanSubmit = function () {
        return $scope.coc.hasDrawn;
    };

    $scope.cocSubmit = function () {
        if (!$scope.cocCanSubmit() || $scope.coc.isSaving) return;
        $scope.coc.isSaving = true;
        var signatureData = $scope._cocCanvas ? $scope._cocCanvas.toDataURL('image/png') : '';
        var preferenceValue = JSON.stringify({
            radiologistName: $scope.coc.userName,
            signature: signatureData,
            signatureDate: $scope.coc.signatureDate,
            documentVersion: COC_DOC_VERSION
        });
        UserPreferenceService.AddEditUserPreferences([{
            UserPreferenceID: '-1',
            PreferenceType: 'CodeOfConduct',
            UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '',
            PreferenceValue: preferenceValue
        }]).then(function () {
            $scope.coc.isSaving = false;
            $scope.isCodeOfConductVisible = false;
            if (pendingCivrRedirect) {
                pendingCivrRedirect = false;
                CommonService.RedirectToCIVRSmartWorklist(pendingLoginData);
                return;
            }
            ValidateTermsOfUseRange(pendingTermsOfUseRange);
            continueLogin();
        }, function () {
            $scope.coc.isSaving = false;
            toaster.error({ body: 'Failed to Add UserPreferences. Please try again.' });
        });
    };
}
angular.module('auth.controllers').controller('indexController', indexController);
loginController.$inject = ['$rootScope', '$scope', 'authService', '$timeout', '$sessionStorage', '$localStorage', '$state', 'APP_CONSTANTS', '$interval', 'UserPreferenceService', '$filter', 'toaster', 'chatService', 'CommonService', '$q', '__env', '$injector', 'resetPasswordLinkHelper'];
function loginController($rootScope, $scope, authService, $timeout, $sessionStorage, $localStorage, $state, APP_CONSTANTS, $interval, UserPreferenceService, $filter, toaster, chatService, CommonService, $q, __env, $injector, resetPasswordLinkHelper) {
    $scope.radflowUIVersion = APP_CONSTANTS.radflowUIVersion;
    $scope.emailFormat = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
    //$scope.phoneFormat = /^(\+(\d{1}|\d{2}|\d{3})[- ]?)?\d{3}[- ]?\d{3}[- ]?\d{4}$/;
    $scope.phoneFormat = /^(\+(\d{1}|\d{2}|\d{3})?)?\d{3}\d{3}\d{4}$/;
    $scope.tenantName = "Radamatic/";
    $scope.isLoading = false;
    $scope.errorColor = "red";
    $scope.error = null;
    $scope.isVerifyUserName = false;
    $scope.isUsernameVerified = false;
    $scope.isResetPassword = false;
    $scope.isPasscode = false;
    $scope.isResetPasscode = false;
    $scope.title = 'Sign in to RadFlow';
    $scope.newUser = {};
    $scope.isRadFlowUpdate = false;
    $scope.isResendDisabled = false;
    $scope.OTPRetryTimer = 30;
    $scope.SelectedCountry = {};
    $scope.DataObject = {
        otpResendAttempts: 0,
        maxOtpResendAttempts: 3,
        isResendLimitReached: false,
        ComesFromLogin: true,
        PasswordRequirements: __env && __env.PasswordRequirements ? __env.PasswordRequirements.rules : [],
    };
    $scope.bannerImageUrl = null;
    $scope.scheduledBannerUrl = null; // Task 174409: time-limited banner above the pre-login forms
    /*$scope.otpResendAttempts = 0;
    $scope.maxOtpResendAttempts = 3;
    $scope.isResendLimitReached = false;*/
    var OTPRetryInterval;
    var TimeoutList = [];
    var EnableTFAPref = null;
    var passwordResetType = null;

    // ---------------------------------------------------------------------------------------------
    // Task 172903 (login hardening) - client state.
    //
    // The server is the authority for all of this: the 3-attempt budget, the permanent lockout, the
    // inter-attempt throttle and the captcha check are all enforced in the auth API's /Token path
    // (AuthRepository.FindUserForLogin), and the exact wording shown to the user comes back in the
    // OAuth error_description. Nothing here is a security control - a scripted attacker bypassing
    // this page entirely still hits every server-side control. This only makes the UI honest about
    // what just happened, and renders the captcha widget the server may ask for.
    // ---------------------------------------------------------------------------------------------
    $scope.showRecaptcha = false;              // widget visible (after the 1st failed attempt)
    var loginFailedAttempts = 0;
    var recaptchaWidgetId = null;              // grecaptcha widget handle, for reset() between attempts
    var recaptchaScriptRequested = false;

    // Empty unless a site key has been provisioned - see the comment on recaptchaSiteKey in
    // assets/js/env.js. Blank means "feature not configured": no widget, no behaviour change.
    function getRecaptchaSiteKey() {
        return (__env && __env.recaptchaSiteKey) ? __env.recaptchaSiteKey : '';
    }

    // Loads Google's widget script on demand rather than from index.html, so a login page for an
    // environment with no site key configured makes no third-party request at all.
    function loadRecaptchaScript() {
        if (recaptchaScriptRequested) {
            return;
        }
        recaptchaScriptRequested = true;

        var script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        script.onerror = function () {
            // Let the user retry rather than trapping them behind a widget that will never appear.
            recaptchaScriptRequested = false;
        };
        document.head.appendChild(script);
    }

    // Renders once and resets thereafter: grecaptcha.render() throws if called twice on the same
    // container, and a solved token is single-use so it must be cleared before the next attempt.
    //
    // Two things are legitimately not ready on the first call and are polled for, up to a bounded
    // number of tries so a permanently-missing dependency can never spin forever:
    //   1. Google's api.js, which was only just requested;
    //   2. the #loginRecaptcha container itself - it lives behind ng-if="showRecaptcha", so it does
    //      not exist in the DOM until the digest that follows showRecaptcha flipping to true.
    function renderOrResetRecaptcha(attemptsLeft) {
        if (!$scope.showRecaptcha || !getRecaptchaSiteKey()) {
            return;
        }

        var remaining = angular.isNumber(attemptsLeft) ? attemptsLeft : 40; // ~12s at 300ms

        function retry() {
            if (remaining <= 0) {
                return;
            }
            var waitForRecaptcha = $timeout(function () {
                $timeout.cancel(waitForRecaptcha);
                renderOrResetRecaptcha(remaining - 1);
            }, 300);
            TimeoutList.push(waitForRecaptcha);
        }

        if (typeof grecaptcha === 'undefined' || !grecaptcha.render) {
            retry();
            return;
        }

        try {
            if (recaptchaWidgetId === null) {
                var container = document.getElementById('loginRecaptcha');
                if (!container) {
                    retry();
                    return;
                }
                recaptchaWidgetId = grecaptcha.render(container, {
                    sitekey: getRecaptchaSiteKey(),
                    theme: 'dark'
                });
            } else {
                grecaptcha.reset(recaptchaWidgetId);
            }
        } catch (e) {
            // Never let a widget problem block the form; the server decides whether the attempt is
            // acceptable regardless of what happened here.
        }
    }

    function getRecaptchaResponse() {
        if (!$scope.showRecaptcha || !getRecaptchaSiteKey() || recaptchaWidgetId === null) {
            // Legacy sentinel the auth API has always received on this field. It is only honoured
            // while server-side enforcement (LoginCaptchaEnabled) is off.
            return 'Disabled';
        }

        try {
            return grecaptcha.getResponse(recaptchaWidgetId) || '';
        } catch (e) {
            return '';
        }
    }

    // Called after any rejected sign-in. The captcha appears from the 1st failure onwards, matching
    // the point at which the server starts requiring it for that username.
    function onLoginAttemptFailed() {
        loginFailedAttempts++;

        if (loginFailedAttempts >= 1 && getRecaptchaSiteKey()) {
            $scope.showRecaptcha = true;
            loadRecaptchaScript();
            renderOrResetRecaptcha();
        }
    }

    // Called on a successful sign-in and whenever the form is left/re-entered.
    function resetLoginAttemptState() {
        loginFailedAttempts = 0;
        $scope.showRecaptcha = false;
        recaptchaWidgetId = null;
    }

    //$sessionStorage.ShowModalIESettings = false;
    //$sessionStorage.AgfaSetup = false;
    // init controller
    function getParameterByName(name, url) {
        if (!url) {
            url = window.location.href
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    loginCtrlinit = function () {
        // Task 174409: one anonymous call returns both banners. The server decides whether the scheduled
        // banner is inside its window and sends "" otherwise, so the client clock never matters here.
        CommonService.GetLoginBanners().then(function (resp) {
            $scope.bannerImageUrl = (resp && resp.BannerImageUrl) ? resp.BannerImageUrl : null;
            $scope.scheduledBannerUrl = (resp && resp.ScheduledBannerImageUrl) ? resp.ScheduledBannerImageUrl : null;
        });
        // Task 172903 R3: fetched anonymously, same as GetLoginBanners above - the login page has no
        // token yet, so this cannot go through an authenticated preferences call. Assigning onto __env
        // (rather than $scope) is deliberate: getRecaptchaSiteKey() in this file is a plain closure, not
        // Angular-bound, and reads __env.recaptchaSiteKey directly. Leaves the property unset (falsy,
        // same as "not provisioned") if the call fails or the key isn't configured server-side.
        CommonService.GetLoginRecaptchaSiteKey().then(function (resp) {
            __env.recaptchaSiteKey = (resp && resp != "") ? resp : '';
        });
        $scope.CountryCodes = CommonService.GetCountryCode();
        $scope.DataObject.otpResendAttempts = 0;
        $scope.DataObject.isResendLimitReached = false;
        $scope.isRegisteringUser = false;
        passwordResetType = null;
        // Task 172903: a fresh login form starts with no captcha and a zeroed local attempt counter.
        // The authoritative counter lives server-side, so this cannot be used to win back attempts.
        resetLoginAttemptState();
        if (getParameterByName('resetpwdparams')) {
            if (!$localStorage.resetPasswordLinkParams || !($localStorage.resetPasswordLinkParams.includes(getParameterByName('resetpwdparams')))) {
                var resetpwdparams = resetPasswordLinkHelper.parseEncodedParam(getParameterByName('resetpwdparams'));
                if (!resetpwdparams || !resetpwdparams.Timestamp || !resetpwdparams.Username) {
                    swal("Invalid password reset link. Please request a new link from your administrator.");
                    window.open(window.location.origin + "/#/", "_self");
                    return;
                }

                // Timestamp in the link is already a CST wall-clock string from sendResetPasswordLink;
                // parse it literally — do not pass through moment() local TZ or CSTDateTime again.
                var urlTimeStamp = moment(resetpwdparams.Timestamp, "YYYY-MM-DD HH:mm:ss");
                var currentTime = moment($filter('CSTDateTime')(moment()), "YYYY-MM-DD HH:mm:ss");

                var timeDiff = currentTime.diff(urlTimeStamp, "minutes");

                if (timeDiff > 10) {
                    swal("This password reset link has expired. Please request a new link from your administrator.");
                    window.open(window.location.origin + "/#/", "_self");
                }
                else {
                    $scope.forgotPassword();
                    passwordResetType = null;
                    $scope.verify_username = resetpwdparams.Username;
                    if ($scope.verify_username) {
                        $scope.VerifyUserName($scope.verify_username);
                    }
                }
            }
            else {
                swal("This password reset link has already been used. Please request a new link from your administrator.");
                window.open(window.location.origin + "/#/", "_self");
            }
        }
        if (getParameterByName('uid') && getParameterByName('auk')) {
            $scope.isRegisteringUser = true;
            authService.GetInvitedUser(getParameterByName('uid'), getParameterByName('auk')).then(function (resp) {
                if (resp && resp.data) {
                    if (resp.data.Address && resp.data.Address.CountryCode) {
                        resp.data.Address.CountryCode = _.find($scope.CountryCodes, { key: resp.data.Address.CountryCode });
                    }
                    $scope.newUser = resp.data;

                    if ($scope.newUser.IsRegisterUser) {
                        swal("User already registered!");
                        $scope.onSignUpCancel();
                    }
                }
                else {
                    swal("Invalid link!");
                    $scope.onSignUpCancel();
                }
            }, function (err) {
                swal("Invalid link!");
                $scope.onSignUpCancel();
            });
        }
        //CheckIESettings();        
        //$sessionStorage.isPasscode = null;
        //console.log("Passcode in login page:  " + $sessionStorage.isPasscode)
        if ($localStorage.isFromResetPassword) {
            $localStorage.isFromResetPassword = false;
            $sessionStorage.isPasscode = false;
            $localStorage.userInfo = null;
        }
        if ($sessionStorage.isPasscode && $sessionStorage.currentUserData) {
            $scope.isPasscode = true;
            $scope.title = 'Pin';
            $scope.DataObject.ComesFromLogin = true;
            $scope.UserName = $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName;
        }
        else {
            $scope.isPasscode = false;
            $scope.title = 'Sign in to RadFlow';
            $scope.DataObject.ComesFromLogin = true;
        }
        if ($localStorage.userInfo) {
            if ($localStorage.isSwitchedView) {
                $scope.rememberMe = false;
            } else {
                $scope.rememberMe = true;
            }

        }
    };
    /* --Unsed ---
    function CheckIESettings() {
        var parser = new UAParser();
        $scope.browser = parser.getBrowser().name;
        $sessionStorage.browser = $scope.browser.toUpperCase();
        if ($scope.browser != null && $scope.browser.toUpperCase() != "IE") {
            //$('#ModalIESettings').modal('show');
            $sessionStorage.ShowModalIESettings = true;
        }
        else if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
            //alert($scope.browser);
            try {
                var regpath = "HKEY_CLASSES_ROOT\\RadFlowIE\\IsSettings";
                var oWSS = new ActiveXObject("WScript.Shell");
                if (oWSS != null) {
                    var value = oWSS.RegRead(regpath);
                    //alert(value);
                    if (value != 1) {
                        //$('#ModalIESettings').modal('show');                        
                        $sessionStorage.ShowModalIESettings = true;
                    }
                }
                else {
                    //$('#ModalIESettings').modal('show');                    
                    $sessionStorage.ShowModalIESettings = true;
                }

            }
            catch (e) {
                //$('#ModalIESettings').modal('show');                
                $sessionStorage.ShowModalIESettings = true;
            }
            //Check Agfa Installed in this machine or not. 
            try {
                var Agfaregpath = "HKEY_CLASSES_ROOT\\AgfaHC\\URL Protocol";
                var AgfaoWSS = new ActiveXObject("WScript.Shell");
                if (AgfaoWSS != null) {
                    var Agfavalue = AgfaoWSS.RegRead(Agfaregpath);
                    if (Agfavalue != null) {
                        $sessionStorage.AgfaSetup = true;
                    }
                    else {
                        $sessionStorage.AgfaSetup = false;
                    }
                }
                else {
                    $sessionStorage.AgfaSetup = false;
                }
            }
            catch (e) {
                $sessionStorage.AgfaSetup = false;
            }
        }
    }   
    */
    /*
    $("#ModalIESettings").on('hide.bs.modal', function () {
        //swal('The modal is about to be hidden.');
        //$scope.SignReport($scope.navFlag);
        //$state.go('Login');
        //init();
        window.open(APP_CONSTANTS.domain, "_self");
    });
    */
    /*$scope.forgotPassword = function () {
        if (!$scope.username) {
            $scope.errorColor = "red";
            $scope.error = "Please enter username !";
            return;
        } else {
            $scope.isLoading = true;
            var promiseResponse = authService.forgotPassword($scope.username);
            promiseResponse.then(function (resp) {
                if (resp.data.match('has been sent')) {
                    $scope.errorColor = "green";
                } else if (resp.data.match('Error')) {
                    $scope.errorColor = "red";
                }
                $scope.isLoading = false;
                $scope.error = resp.data;
            }, function (error) {
                $scope.isLoading = false;
                $scope.errorColor = "red";
                $scope.error = 'Error ' + error.message;
            });
        }
    };*/

    //Prevent Back on browser --------------------------------
    $scope.$on('$locationChangeStart', function (evnt, next, current) {
        evnt.preventDefault();
    });
    //--------------------------------

    $scope.CancelCerification = function () {
        $scope.isVerifyUserName = false;
        $scope.verify_username = "";
        $scope.error = '';
        $scope.DataObject.otpResendAttempts = 0;
        $scope.DataObject.isResendLimitReached = false;
        passwordResetType = null;
        $scope.OTP = "";
        if ($scope.isPasscode) {
            $scope.title = 'Pin';
            $scope.DataObject.ComesFromLogin = true;
            setTimeout(function () {
                var passcode = document.getElementById('passcode');
                if (passcode) {
                    passcode.focus();
                }
            }, 100);
        }
        else {
            $scope.title = 'Sign in to RadFlow';
            $scope.DataObject.ComesFromLogin = true;
            setTimeout(function () {
                var email = document.getElementById('inputEmail3');
                if (email) {
                    email.focus();
                }
            }, 100);
        }
        if (OTPRetryInterval) {
            $interval.cancel(OTPRetryInterval);
            OTPRetryInterval = null;
        }
        if (getParameterByName('resetpwdparams')) {
            window.open(window.location.origin, "_self");
        }
    }
    $scope.CancelforgotPasscode = function () {
        $scope.isResetPasscode = false;
        $scope.resetpasscodeerror = '';
        $scope.error = '';
        $scope.title = 'Pin';
        $scope.DataObject.ComesFromLogin = true;
    }
    $scope.CancelforgotPassword = function () {
        $scope.isResetPassword = false;
        $scope.title = 'Sign in to RadFlow';
        $scope.DataObject.ComesFromLogin = true;
        passwordResetType = null;
        $scope.error = '';
        $scope.resetpassworderror = '';
        if (getParameterByName('resetpwdparams')) {
            window.open(window.location.origin, "_self");
        }
    }

    $scope.forgotPassword = function () {
        $scope.isVerifyUserName = true;
        $scope.title = 'Forgot Password';
        $scope.DataObject.ComesFromLogin = false;
        passwordResetType = 'forgot';

        // Task 175013: clear the sign-in screen's error state (e.g. the account-locked message)
        // so it doesn't linger into the username-verification screen this navigates to.
        $scope.error = '';
        $scope.forgotPasswordUrl = null;
        $scope.errorBeforeLink = '';
        $scope.errorLinkText = '';
        $scope.errorAfterLink = '';

        setTimeout(function () {
            document.getElementById('verify_username').focus();
        }, 100);
    };
    $scope.VerifyUserName = function (verify_username) {
        $scope.error = '';
        $scope.verify_username = verify_username;
        if (!$scope.verify_username) {
            $scope.errorColor = "red";
            $scope.error = "Please enter username!";
            return;
        } else {
            if ($scope.DataObject.ComesFromLogin) {
                if ($scope.DataObject.otpResendAttempts >= $scope.DataObject.maxOtpResendAttempts) {
                    $scope.errorColor = "red";
                    $scope.error = "You have reached the maximum number of OTP resend attempts (3). Please try again later.";
                    $scope.DataObject.isResendLimitReached = true;
                    $scope.isResendDisabled = true;
                    $timeout(function () {
                        $scope.isPasscode = false;
                        $scope.CancelCerification();
                        angular.element('#OTPVerification').modal('hide');
                    }, 3000);
                    return;
                }
                $scope.DataObject.otpResendAttempts++;
            }
            $scope.isLoading = true;
            var promiseResponse = authService.generateOTP($scope.verify_username, $scope.isPasscode, $scope.DataObject.ComesFromLogin);
            promiseResponse.then(function (resp) {
                if (resp.data.match('has been sent')) {
                    $scope.errorColor = "green";
                    angular.element('#OTPVerification').modal('show');
                    $scope.otp_error = resp.data;
                    angular.element('#OTPVerification').on('shown.bs.modal', function () {
                        setTimeout(function () {
                            angular.element('#OTP').focus();
                        }, 100);
                    });
                    $scope.isResendDisabled = true;
                    OTPRetryInterval = $interval(function (time) {
                        if (time < 30) {
                            $scope.OTPRetryTimer = 30 - time;
                        } else {
                            $scope.OTPRetryTimer = 30;
                            $scope.isResendDisabled = false;
                            $interval.cancel(OTPRetryInterval);
                            OTPRetryInterval = null;
                        }
                    }, 1000);

                } else if (resp.data.match('Invalid')) {
                    $scope.errorColor = "red";
                }
                $scope.isLoading = false;
                $scope.error = resp.data;
            }, function (error) {
                $scope.isLoading = false;
                $scope.errorColor = "red";
                $scope.error = 'Error ' + error.message;
                if (error.status == "429") {
                    $scope.error = "You’ve reached the request limit. Please try again after 1 minute.";
                }
            });
        }
    };
    $scope.VerifyOTP = function () {
        $scope.otp_error = "";
        $scope.isLoading = true;

        var promiseResponse = authService.verifyOTP($scope.verify_username, $scope.OTP);
        promiseResponse.then(function (resp) {
            $scope.isLoading = false;
            if (resp && resp.data) {
                $scope.isVerifyUserName = false;
                // Reset OTP resend attempts on successful verification
                if ($scope.DataObject.ComesFromLogin) {
                    $scope.DataObject.otpResendAttempts = 0;
                    $scope.DataObject.isResendLimitReached = false;
                }
                if (EnableTFAPref && $sessionStorage.currentUserData && ($scope.DataObject.ComesFromLogin)) {
                    $sessionStorage.LoginByUserName = false;
                    finalizeLogin($sessionStorage.currentUserData, $scope.title === 'Pin');
                }
                else {
                    if ($scope.isPasscode) {
                        $scope.isResetPasscode = true;
                        $scope.title = 'Reset Pin';
                        $scope.DataObject.ComesFromLogin = false;
                    }
                    else {
                        $scope.isResetPassword = true;
                        $scope.title = 'Reset Password';
                        $scope.DataObject.ComesFromLogin = false;
                    }
                }
                ClearOTPVerificationValues();
                angular.element('#OTPVerification').modal('hide');
            }
            else {
                $scope.errorColor = "red";
                $scope.otp_error = "verification code not matched!";
            }
        }, function (error) {
            $scope.isLoading = false;
            $scope.errorColor = "red";
            $scope.otp_error = "verification code not matched!";
        });

    }
    $scope.ResetPassword = function (verify_username, password, confirmpassword) {

        if (!checkPwd(password)) {
            $scope.resetpassworderror = __env.PassowordPatternMessage;
        }
        else {
            $scope.resetpassworderror = "";
            $scope.username = verify_username;
            $scope.password = password;
            $scope.confirmpassword = confirmpassword;

            if ($scope.password != $scope.confirmpassword) {
                $scope.errorColor = "red";
                $scope.resetpassworderror = "New & confirm password must be same!";
                return;
            }
            else {
                $scope.isLoading = true;
                var eventName = passwordResetType == "forgot" ? "FORGOT PASSWORD" : (passwordResetType == "90days" ? "RESET PASSWORD AFTER 90 DAYS" : "RESET PASSWORD");
                var promiseResponse = authService.forgotPassword($scope.username, $scope.password, eventName);
                promiseResponse.then(function (resp) {
                    if (resp.data.match('has been')) {
                        if ((!$localStorage.resetPasswordLinkParams || $localStorage.resetPasswordLinkParams.length == 0)) {
                            $localStorage.resetPasswordLinkParams = [getParameterByName('resetpwdparams')]
                        }
                        else {
                            $localStorage.resetPasswordLinkParams.push(getParameterByName('resetpwdparams'));
                        }
                        $localStorage.isFromResetPassword = true;
                        window.open(window.location.origin, "_self");
                    } else if (resp.data.toLowerCase().match('error')) {
                        $scope.errorColor = "red";
                    }
                    $scope.isLoading = false;
                    $scope.resetpassworderror = resp.data;
                }, function (error) {
                    $scope.isLoading = false;
                    $scope.errorColor = "red";
                    if (error && error.data && error.data.Message) {
                        if (error.data.Message.toLowerCase().match('forgetting the password')) {
                            $scope.resetpassworderror = error.data.Message.replace('forgetting', 'resetting');
                        }
                        else {
                            $scope.resetpassworderror = error.data.Message;
                        }
                    }
                });
            }
        }
    }

    function checkPwd(str) {
        var regularExpression = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{12,64}$/;
        return regularExpression.test(str);
    }

    $scope.formSubmit = function (username, password, rememberMe) {
        if ($scope.isLoading)
            return;

        UserPreferenceService.GetRadflowUIVersion().then(function (version) {
            if (version != $scope.radflowUIVersion) {
                $scope.isRadFlowUpdate = true;
                var signintimeout = $timeout(function () {
                    window.location.reload();
                    $scope.isRadFlowUpdate = false;
                    $timeout.cancel(signintimeout);
                }, 3000);
                TimeoutList.push(signintimeout);
                return;
            }
            $scope.username = username;
            $scope.password = password;
            $scope.rememberMe = rememberMe;
            $scope.isLoading = true;
            $scope.error = null;

            var userLogin = {
                remember_me: true,
                username: $scope.username,
                password: $scope.password,
                // Task 172903 R3: the real widget token once a captcha is on screen, otherwise the
                // legacy 'Disabled' sentinel this field has always carried. authService.login forwards
                // it to /Token as the RecaptchaResponse form field.
                RecaptchaResponse: getRecaptchaResponse(),
                BrowserType: 'Web',
                GMTTime: moment().format('Z'),
                TenantName: ''
            };
            $localStorage.userInfo = null;
            $sessionStorage.currentUserData = null;
            var promiselogin = authService.login(userLogin);
            promiselogin.then(function (resp) {
                var data = {
                    //userName: resp.data.userName,
                    //token: resp.data.access_token
                    userId: resp.data.userId,
                    connectionId: '',
                    userName: resp.data.userName,
                    roles: resp.data.roles.replace('["', '').replace('"]', '').replace('[]', ''),
                    accessToken: resp.data.access_token,
                    refreshToken: resp.data.refresh_token,
                    ProfilePic: '',//Profile pic will be set later, other token problem occurs
                    displayName: resp.data.displayName,
                    browserType: 'Web',
                    TenantName: resp.data.TenantName,
                    expire: resp.data[".expires"],
                    FirstName: resp.data.FirstName,
                    LastName: resp.data.LastName,
                    Passcode: resp.data.Passcode,
                    NPI: resp.data.NPI,
                    EmailId: resp.data.EmailId,
                    userRoles: resp.data.userRoles ? resp.data.userRoles.split(',') : null
                };
                $scope.isLoading = false;
                // Task 172903: credentials accepted, so drop the attempt counter and take the captcha
                // back down (the server has likewise cleared AccessFailedCount for this account).
                resetLoginAttemptState();
                // Set session data first so GetUserPreferences (api/Settings/GetUserPreferences) is
                // authenticated - it also carries the Web.config-driven PasswordResetIntervalDays,
                // checked below before finalizing login.
                $sessionStorage.currentUserData = data;
                GetUserPreferences().then(function (result) {
                    var TodaysDate = moment();
                    var LastPasswordResetDate = moment(new Date($filter('localDate')(resp.data.LastPasswordResetDate, false, new Date())));
                    var passwordResetIntervalDays = (result && result.PasswordResetIntervalDays) || 90;

                    if (TodaysDate.diff(LastPasswordResetDate, 'days') >= passwordResetIntervalDays) {
                        $sessionStorage.currentUserData = null;
                        toaster.warning({ body: "It's been over " + passwordResetIntervalDays + " days since your last password change. Please reset your password now." });
                        $scope.isResetPassword = true;
                        $scope.title = 'Reset Password';
                        $scope.DataObject.ComesFromLogin = false;
                        passwordResetType = '90days';
                        $scope.verify_username = resp.data.userName;
                        $scope.password = null;
                        return;
                    }

                    if (result.UserPreferences) {
                        var EnableTwoFactorAuthentication = _.find(result.UserPreferences, {
                            PreferenceType: "EnableTwoFactorAuthentication"
                        });
                        EnableTFAPref = null;
                        if (EnableTwoFactorAuthentication && EnableTwoFactorAuthentication.PreferenceValue) {
                            EnableTFAPref = EnableTwoFactorAuthentication.PreferenceValue == '1' ? true : false;
                        }

                        if (!EnableTFAPref) {
                            $sessionStorage.LoginByUserName = true;
                            finalizeLogin(data, false);
                        }
                        else {
                            $scope.verify_username = data.userName;
                            if ($scope.verify_username) {
                                $scope.VerifyUserName($scope.verify_username, true);
                            }
                        }

                    }

                    if ($scope.rememberMe) {
                        $localStorage.userInfo = data;
                    }
                });
                //$state.go('Home');
                //this.router.navigate(['/pages/psorders/search'])

            }, function (err) {
                $scope.isLoading = false;
                $sessionStorage.isAuthenicate = false;
                $scope.errorColor = "red";

                // Task 172903: show the server's own message rather than a fixed string, so the user
                // sees the remaining-attempt count ("Incorrect username or password. 2 of 3 attempts
                // remaining."), the lockout notice ("Your account has been locked for security
                // measures, please reset your password..."), the throttle notice ("Please wait a moment before
                // trying again.") or the captcha prompt as appropriate. These arrive in the OAuth
                // error_description; the older fixed copy stays as the fallback for a transport-level
                // failure that carries no body at all.
                var errorMsg = (err && err.data && err.data.error_description)
                    ? err.data.error_description
                    : "Incorrect username/password !";

                // Task 174299: on lockout the auth API also sends a forgot-password URL, in the
                // OAuth-standard error_uri field (the earlier custom forgot_password_url field is kept
                // as a fallback for any auth API build that still emits it). Its presence is what
                // makes login.html turn "reset your password" into an inline link within the message.
                $scope.error = errorMsg;
                $scope.forgotPasswordUrl = (err && err.data && (err.data.error_uri || err.data.forgot_password_url)) || null;

                // Task 175013: AccountLockedMessage (AuthRepository.cs) is a fixed server string
                // containing "reset your password" - split it so that phrase renders as the clickable
                // link, in place of the old separate "Reset your password here" line below the message.
                if ($scope.forgotPasswordUrl) {
                    var linkPhrase = "reset your password";
                    var linkIndex = errorMsg.indexOf(linkPhrase);
                    if (linkIndex === -1) {
                        $scope.errorBeforeLink = errorMsg;
                        $scope.errorLinkText = "";
                        $scope.errorAfterLink = "";
                    } else {
                        $scope.errorBeforeLink = errorMsg.substring(0, linkIndex);
                        $scope.errorLinkText = errorMsg.substr(linkIndex, linkPhrase.length);
                        $scope.errorAfterLink = errorMsg.substring(linkIndex + linkPhrase.length);
                    }
                }

                onLoginAttemptFailed();
            });
        });
    };

    $scope.formSubmitPasscode = function (passcode) {
        if ($scope.isLoading)
            return;

        UserPreferenceService.GetRadflowUIVersion().then(function (version) {

            if (version != $scope.radflowUIVersion) {
                $scope.isRadFlowUpdate = true;
                var passcodetimeout = $timeout(function () {
                    window.location.reload();
                    $scope.isRadFlowUpdate = false;
                    $timeout.cancel(passcodetimeout);
                }, 3000);
                TimeoutList.push(passcodetimeout);
                return;
            }

            $scope.error = '';
            $scope.isLoading = true;
            var promiseResponse = authService.checkPasscode($sessionStorage.currentUserData.userId, passcode);
            promiseResponse.then(function (resp) {

                if (resp.data.match('success')) {
                    setTimeout(function () {
                        $scope.isLoading = false;
                    }, 500);
                    authService.refreshToken()
                        .then(function (data) {
                            if (data) {
                                $sessionStorage.currentUserData.EmailId = data.EmailId;
                                GetUserPreferences().then(function (result) {
                                    var TodaysDate = moment();
                                    var LastPasswordResetDate = moment(new Date($filter('localDate')(data.LastPasswordResetDate, false, new Date())));
                                    var passwordResetIntervalDays = (result && result.PasswordResetIntervalDays) || 90;

                                    if (TodaysDate.diff(LastPasswordResetDate, 'days') >= passwordResetIntervalDays) {
                                        toaster.warning({ body: "It's been over " + passwordResetIntervalDays + " days since your last password change. Please reset your password now." });
                                        $scope.isPasscode = false;
                                        $scope.isResetPassword = true;
                                        $scope.title = 'Reset Password';
                                        $scope.DataObject.ComesFromLogin = false;
                                        passwordResetType = '90days';
                                        $scope.verify_username = data.userName;
                                        return;
                                    }

                                    if (result.UserPreferences) {
                                        var EnableTwoFactorAuthentication = _.find(result.UserPreferences, {
                                            PreferenceType: "EnableTwoFactorAuthentication"
                                        });
                                        EnableTFAPref = null;
                                        if (EnableTwoFactorAuthentication && EnableTwoFactorAuthentication.PreferenceValue) {
                                            EnableTFAPref = EnableTwoFactorAuthentication.PreferenceValue == '1' ? true : false;
                                        }

                                        if (!EnableTFAPref) {
                                            $sessionStorage.LoginByUserName = false;
                                            finalizeLogin($sessionStorage.currentUserData, true);
                                        }
                                        else {
                                            $scope.verify_username = data.userName;
                                            if ($scope.verify_username) {
                                                $scope.VerifyUserName($scope.verify_username, true);
                                            }
                                        }
                                    }
                                });

                            }
                            else {
                                Logout();
                            }
                        }, function (err) {
                            Logout();
                        });

                } else {
                    $scope.errorColor = "red";
                    $scope.error = 'Invalid Pin!';
                    $scope.isLoading = false;
                }

            }, function (err) {
                Logout();
            });
        });
    }

    $scope.verifyuser = function () {
        $scope.isVerifyUserName = true;
        $scope.title = 'Forgot Pin';
        $scope.DataObject.ComesFromLogin = false;
        $scope.error = '';
        setTimeout(function () {
            document.getElementById('verify_username').focus();
        }, 100);
    }
    $scope.ResetPasscode = function (verify_username, passcode, confirmpasscode) {
        $scope.resetpasscodeerror = '';
        $scope.username = verify_username;
        $scope.passcode = passcode;

        if (passcode !== confirmpasscode) {
            $scope.errorColor = "red";
            $scope.resetpasscodeerror = "New & confirm pin must be same!";
            return;
        }
        else {
            $scope.isLoading = true;
            var promiseResponse = authService.forgotPasscode(verify_username, passcode);
            promiseResponse.then(function (resp) {
                if (resp.data.match('has been')) {
                    logUserEvent("FORGOT PASSCODE");
                    $sessionStorage.currentUserData.Passcode = passcode;
                    $scope.errorColor = "green";
                    $scope.isResetPasscode = false;
                    $scope.title = 'Pin';
                    $scope.DataObject.ComesFromLogin = true;
                    $scope.resetpasscodeerror = resp.data;
                    $scope.error = resp.data;
                } else if (resp.data.toLowerCase().match('error')) {
                    $scope.errorColor = "red";
                }
                $scope.isLoading = false;
                $scope.resetpasscodeerror = resp.data;
            }, function (error) {
                $scope.isLoading = false;
                $scope.errorColor = "red";
                $scope.resetpasscodeerror = 'Error ' + error.message;
            });
        }
    }

    function Logout() {
        function clearSession() {
            $sessionStorage.currentUserData = null;
            $localStorage.userInfo = null;
            $scope.isPasscode = false;
            $sessionStorage.isPasscode = false;
            $localStorage.isSwitchedView = false;
            $localStorage.isFromSwitchView = false;
            $scope.title = 'Sign in to RadFlow';
            $scope.DataObject.ComesFromLogin = true;
            $scope.isLoading = false;
            $sessionStorage.$reset();
            if ($state.current.name != 'Login') {
                $state.go('Login');
            }
        }
        try {
            // Logout revokes access + refresh tokens; skip removeRefreshToken (would 401 after revoke).
            authService.revokeAccessToken()
                .finally(clearSession);
        }
        catch (e) {
            console.log(e);
            clearSession();
        }
    }


    $scope.onSignUp = function () {
        $scope.newUser.error = "";
        var phonenumber = $scope.newUser.PhoneNumber.toString();
        //if (phonenumber.substr(0, 1) !== '+') {
        //    $scope.newUser.error = 'Please enter country code with phonenumber! eg. +1xxxxxxxxxx';
        //    return;
        //}        
        if ($scope.newUser.Password.trim() != $scope.newUser.ConfirmPassword.trim()) {
            $scope.newUser.error = "New & confirm password must be same!";
            return;
        }
        if (!checkPwd($scope.newUser.Password.trim())) {
            return $scope.newUser.error = __env.PassowordPatternMessage;
        }
        $scope.isLoading = true;
        var newUser = {
            FirstName: $scope.newUser.FirstName,
            LastName: $scope.newUser.LastName,
            Email: $scope.newUser.Email,
            PhoneNumber: $scope.newUser.PhoneNumber,
            NPI: $scope.newUser.NPI,
            Address: $scope.newUser.Address,
            UserName: $scope.newUser.UserName,
            Password: $scope.newUser.Password,
            ConfirmPassword: $scope.newUser.ConfirmPassword,
            Passcode: $scope.newUser.Passcode,
            UserId: $scope.newUser.UserId
        };
        if (newUser.Address) {
            newUser.Address.CountryCode = $scope.newUser.Address.CountryCode ? $scope.newUser.Address.CountryCode.key:'';
            newUser.Address.UserId = $scope.newUser.UserId;
            newUser.Address.CreatedBy = $scope.newUser.UserId;
            newUser.Address.ModifiedBy = $scope.newUser.UserId;
        }

        if (phonenumber.length == 10) {
            newUser.PhoneNumber = "+1" + phonenumber;
        }
        authService.RegisterInvitedUser(newUser).then(function (resp) {
            $scope.isLoading = false;
            if (resp && resp.data) {
                $scope.newUser.error = resp.data;
            }
            else {
                chatService.AddMember({ UserID: newUser.UserId, JoiningDate: moment().utc().format('MM/DD/YYYY HH:mm:ss') });
                swal("Registration completed successfully.");
                $scope.onSignUpCancel();
            }
        }, function (err) {
            $scope.isLoading = false;
            if (err && err.data && err.data.Message) {
                $scope.newUser.error = err.data.Message;
            }
        });
    }
    $scope.onSignUpCancel = function () {
        $scope.isRegisteringUser = false;
        $timeout(function () {
            window.location.href = window.location.href.split('?')[0];
        }, 2000);
    }
    $scope.SignOut = function () {
        Logout();
        $scope.rememberMe = false;
        setTimeout(function () {
            document.getElementById('inputEmail3').focus();
        }, 100);
    };
    $scope.ReloadRadFlow = function () {
        _.each(TimeoutList, function (timeout) {
            $timeout.cancel(timeout);
        });
        window.location.reload();
    }

    function GetUserPreferences() {
        var d = $q.defer();
        var userPreference = {
            UserID: $sessionStorage.currentUserData.userId,
            PreferenceType: "EnableTwoFactorAuthentication"
        };
        UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
            d.resolve(result);
        });
        return d.promise;
    }

    function ClearOTPVerificationValues() {
        $scope.OTP = "";
        if (OTPRetryInterval) {
            $interval.cancel(OTPRetryInterval);
            OTPRetryInterval = null;
        }
        var backdrop = angular.element('.modal-backdrop');
        if (backdrop) {
            backdrop.removeClass('modal-backdrop fade');
        }
    }

    function logUserEvent(eventName, toUserId) {
        var userId = $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '';
        if (userId || toUserId) {
            try {
                var AccountManagerService = $injector.get('AccountManagerService');
                var UserEventLog = [{
                    FromUserID: userId || toUserId,
                    ToUserID: toUserId || userId,
                    EventName: eventName
                }];
                AccountManagerService.AddUserEvent(UserEventLog);
            } catch (e) {
                // AccountManagerService might not be available in all contexts
            }
        }
    }

    // On the login and pin screens: RadPod doctors (proc returns records) never get LoginSuccess, so RadFlow is
    // not initialised for them. indexController runs the Code of Conduct gate, then CommonService redirects.
    // Everyone else logs in as usual.
    function finalizeLogin(data, broadcastClose) {
        UserPreferenceService.GetRadPodDoctorDetailByUserID(data.userId).then(function (result) {
            if (result && result.length > 0) {
                $scope.CheckCocAndRedirectToCIVR(data);
                return;
            }
            completeLogin(data, broadcastClose);
        }, function () {
            completeLogin(data, broadcastClose);
        });
    }

    function completeLogin(data, broadcastClose) {
        $rootScope.$broadcast("LoginSuccess", data);
        if (broadcastClose) {
            $scope.isPasscode = true;
            $rootScope.$broadcast("closePasscodeWindow");
        }
    }

    loginCtrlinit();
}
angular.module('auth.controllers').controller('loginController', loginController).filter('titleCase', function () {
    return function (input) {
        input = input || '';
        return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };
}).directive('numbersOnly', numbersOnly);
function numbersOnly() {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                //return undefined;    
                return '';
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
}
angular.module('auth.controllers').controller('loginController', loginController);


(function () {

    authHttpResponseInterceptor.$inject = ['APP_CONSTANTS', '$q', '$injector', '$sessionStorage', '$rootScope', '__env'];
    function authHttpResponseInterceptor(APP_CONSTANTS, $q, $injector, $sessionStorage, $rootScope, __env) {
        return {
            request: function (config) {
                config.headers = config.headers || {};
                // APIM (api.collaborativeimaging.com) rejects every call without this key, including the pre-login
                // ones (/Token, GetRadflowUIVersion, login banners), so it goes on all requests whenever the
                // environment configures a key. It is never sent empty.
                if (__env.OcpApimSubscriptionKey) {
                    config.headers['Ocp-Apim-Subscription-Key'] = __env.OcpApimSubscriptionKey;
                }

                if ($sessionStorage.currentUserData) {
                    // keep user logged in after page refresh                   
                    config.headers['UserName'] = $sessionStorage.currentUserData.userName;
                    config.headers['BrowserType'] = $sessionStorage.currentUserData.browserType;
                    config.headers['GMTTime'] = moment().format('Z');
                    config.headers['TenantName'] = $sessionStorage.currentUserData.TenantName; // For all normal requests after user logged in.
                    config.headers['RadFlowUIVersion'] = APP_CONSTANTS.radflowUIVersion;

                    var connId = $sessionStorage.currentUserData.connectionId;
                    if (connId) {
                        config.headers['ConnectionId'] = connId;
                    }
                    // if token expire
                    if ($sessionStorage.currentUserData.expire && moment($sessionStorage.currentUserData.expire).subtract(10, 'm').toDate() < moment()) {
                        // re-new token
                        var authService = $injector.get('authService');
                        //return authService.refreshToken(config);  
                        return authService.refreshToken()
                            .then(function (data) {
                                config.headers.Authorization = 'Bearer ' + $sessionStorage.currentUserData.accessToken;
                                $rootScope.$broadcast("LoginSuccess", data);
                                return config;
                            });
                    }
                    else {
                        if (!(config.url.toLowerCase().includes('api/common/logapplicationinfo')
                            || config.url.toLowerCase().includes('api/common/logpsresponsemessage'))) {
                            config.headers.Authorization = 'Bearer ' + $sessionStorage.currentUserData.accessToken;
                        }
                    }
                }
                return config || $q.when(config);
            },
            requestError: function (rejection) {
                return $q.reject(rejection);
            },
            response: function (response) {
                return response || $q.when(response);
            },
            responseError: function (rejection) {
                var errorNo = "";
                var exceptionMessage = "Rejection Status :- " + rejection.status;
                var userErrorMessage = "Please take screenshot of current page with this message.";

                if (rejection.data) {
                    exceptionMessage = exceptionMessage + " Rejection Message :- " + rejection.data.Message;
                    if (rejection.data.ErrorNo) {
                        errorNo = rejection.data.ErrorNo;
                        userErrorMessage = userErrorMessage + " Also please note down the 'ErrorNo' which will be provided to you on following page!";
                    }
                    if (rejection.data.ExceptionMessage)
                        exceptionMessage = exceptionMessage + "ExceptionMessage :- " + rejection.data.ExceptionMessage;
                }

                if (rejection.config && rejection.config.url &&
                    (rejection.config.url.toLowerCase().includes('logapplicationinfo') || rejection.config.url.toLowerCase().includes('logpsresponsemessage'))) {
                    return $q.reject(rejection);
                }

                switch (rejection.status) {
                    /*
                     * If not a 401 or 403, do nothing with this error.
                     * This is necessary to make a `responseError`
                     * interceptor a no-op.
                     */
                    case -1:

                    case 404:
                    case 500:
                        /*$injector.get('toastr').error('It looks like we\'re having some internal issue.');*/
                        try {
                            throw new Error("Failed to load resource:" + rejection.config.url);
                        } catch (e) {
                            var d = angular.copy(rejection);
                            delete d.headers;
                            delete d.config.headers;
                            console.error(e, d);
                        }
                        break;
                    case 401:
                        // Return a new promise for session\token expired
                        //$rootScope.$emit('account:Login');
                        //return $injector.get('$http')(rejection.config);
                        // Logged (not sent to the server): a 401 here can mean APIM rejected the call before it ever
                        // reached the app (e.g. missing/bad Ocp-Apim-Subscription-Key), in which case the server-side
                        // LogApplicationInfo call would 401 too. This is the only trace of that failure mode.
                        try {
                            throw new Error("Unauthorized (401): " + rejection.config.url);
                        } catch (e) {
                            var d401 = angular.copy(rejection);
                            delete d401.headers;
                            delete d401.config.headers;
                            console.error(e, d401);
                        }
                        break;
                    case 403:
                        // Return a new promise for session\token expired
                        $sessionStorage.currentUserData = "";
                        $rootScope.$emit('account:Login');
                        //return $injector.get('$http')(rejection.config);
                        break;
                    //case 404:
                    //    $rootScope.$emit('home:error404');
                    //    break;
                    default:
                        $sessionStorage.ErrorNo = errorNo;
                        $sessionStorage.ExceptionMessage = exceptionMessage;
                        $rootScope.$emit('home:error');
                }
                return $q.reject(rejection);
            }
        };
    };
    angular.module('BlurAdmin').factory('authHttpResponseInterceptor', authHttpResponseInterceptor);


})();

(function () {


    authService.$inject = ['$http', '$q', '$sessionStorage', 'APP_CONSTANTS', '__env'];

    function authService($http, $q, $sessionStorage, APP_CONSTANTS, __env) {

        var authDataFactory = {};

        var _login = function (userlogin) {
            // Task 172903 R3: RecaptchaResponse is no longer a dead field. loginController now supplies
            // either a real reCAPTCHA v2 token (once the widget is on screen after a failed attempt) or
            // the legacy 'Disabled' sentinel, and the auth API verifies it with Google on the /Token
            // path when LoginCaptchaEnabled is on. This service just forwards whatever it is given.
            var data = { grant_type: 'password', username: userlogin.username, password: userlogin.password, RecaptchaResponse: userlogin.RecaptchaResponse, BrowserType: userlogin.BrowserType, GMTTime: userlogin.GMTTime, client_id: APP_CONSTANTS.clientId, TenantName: userlogin.TenantName };
            return $http({
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                method: 'post',
                url: __env._environment.config.apiAuthServiceBaseUri + "/Token",
                data: $.param(data)
            });
        }
        var _getLoginDataByUserId = function (UserId) {
            var data = { UserId: UserId };
            return $http({
                headers: { 'content-type': 'application/json' },
                method: 'get',
                url: __env._environment.config.apiAuthServiceBaseUri + "/api/Account/RadFlow_GetLoginDataById",
                params: { UserId: UserId },
                data: $.param(data)
            });
        }

        var _refreshToken = function () {
            var deferred = $q.defer();

            var authData = $sessionStorage.currentUserData;

            if (authData) {
                var data = "grant_type=refresh_token&refresh_token=" + authData.refreshToken + "&client_id=" + APP_CONSTANTS.clientId;
                $sessionStorage.currentUserData = '';

                $http.post(__env._environment.config.apiAuthServiceBaseUri + '/token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (resp) {
                    $sessionStorage.currentUserData = {
                        userId: resp.data.userId,
                        connectionId: authData.connectionId,
                        userName: resp.data.userName,
                        roles: resp.data.roles.replace('["', '').replace('"]', '').replace('[]', ''),
                        PasswordResetDate: resp.data.PasswordResetDate,
                        LastPasswordResetDate: resp.data.LastPasswordResetDate,
                        accessToken: resp.data.access_token,
                        refreshToken: resp.data.refresh_token,
                        ProfilePic: authData.ProfilePic,//Profile pic will be set later, other token problem occurs
                        displayName: resp.data.displayName,
                        browserType: authData.browserType,
                        TenantName: resp.data.TenantName,
                        expire: resp.data[".expires"],
                        page: authData.page,
                        FirstName: resp.data.FirstName,
                        LastName: resp.data.LastName,
                        userRoles: resp.data.userRoles ? resp.data.userRoles.split(',') : null
                    };

                    $sessionStorage.tenantBaseURL = __env._environment.config.apiResourceServiceBaseUri;
                    deferred.resolve(resp.data);
                });
            }
            return deferred.promise;
        };
        // Revokes the current bearer access token server-side (in addition to removing the
        // refresh token) so a logged-out session's access token can no longer be used, even
        // within its remaining lifetime. Must be called before clearing $sessionStorage.currentUserData
        // since the auth interceptor needs it to attach the Authorization header.
        var _revokeAccessToken = function () {
            var authData = $sessionStorage.currentUserData;

            if (authData) {
                var data = { RefreshTokenId: authData.refreshToken };
                return $http({
                    headers: { 'content-type': 'application/json' },
                    method: 'post',
                    url: __env._environment.config.apiAuthServiceBaseUri + "/api/RefreshTokens/Logout",
                    data: data
                });
            }
            var deferred = $q.defer();
            deferred.resolve();
            return deferred.promise;
        };
        var _removeRefreshToken = function () {
            var deferred = $q.defer();

            var authData = $sessionStorage.currentUserData;

            if (authData) {
                var data = { refreshTokenId: authData.refreshToken };
                return $http({
                    headers: { 'content-type': 'application/json' },
                    method: 'get',
                    url: __env._environment.config.apiAuthServiceBaseUri + "/api/RefreshTokens/removeRefreshToken",
                    params: data,
                    data: $.param(data)
                });
            }
            return deferred.promise;
        };
        /*var _forgotPassword = function (xiUsername) {
            return $http({
                method: 'post',
                data: JSON.stringify({ xiUsername: xiUsername }),
                url: APP_CONSTANTS.apiAuthServiceBaseUri + '/api/Account/ForgotPassword',
                headers: { 'content-type': 'application/json' }
            });
        }*/
        var _forgotPassword = function (xiUsername, xiPassword, eventName) {
            return $http({
                method: 'post',
                data: JSON.stringify({ xiUsername: xiUsername, xiPassword: xiPassword, eventName: eventName }),
                url: __env._environment.config.apiAuthServiceBaseUri + '/api/Account/RadFlow_ForgotPassword',
                headers: { 'content-type': 'application/json' }
            });
        }
        var _forgotPasscode = function (xiUsername, xiPasscode) {
            return $http({
                method: 'post',
                data: JSON.stringify({ xiUsername: xiUsername, xiPasscode: xiPasscode }),
                url: __env._environment.config.apiAuthServiceBaseUri + '/api/Account/RadFlow_ForgotPasscode',
                headers: { 'content-type': 'application/json' }
            });
        }
        var _checkPasscode = function (xiUserId, xiPasscode) {
            return $http({
                method: 'get',
                params: { xiUserId: xiUserId, xiPasscode: xiPasscode },
                url: __env._environment.config.apiAuthServiceBaseUri + '/api/Account/RadFlow_checkPasscode',
                headers: { 'content-type': 'application/json' }
            });
        }

        var _generateOTP = function (xiUsername, isPasscode, isLogin) {
            var p = JSON.stringify({ xiUsername: xiUsername, xiisPasscode: isPasscode });
            return $http({
                method: 'post',
                data: JSON.stringify({ xiUsername: xiUsername, xiisPasscode: isPasscode, xiisLogin: isLogin}),
                url: __env._environment.config.apiAuthServiceBaseUri + '/api/Account/RadFlow_GenerateOTP',
                headers: { 'content-type': 'application/json' }
            });
        }

        var _verifyOTP = function (xiUsername, OTP) {
            var _data = JSON.stringify({ xiUsername: xiUsername, xiOTP: OTP });
            return $http({
                method: 'post',
                data: _data,
                url: __env._environment.config.apiAuthServiceBaseUri + '/api/Account/RadFlow_VerifyOTP',
                headers: { 'content-type': 'application/json' }
            });
        }

        var _isAuthenticated = function () {
            return $sessionStorage.currentUserData;
        }
        var _isAdmin = function () {
            return $sessionStorage.currentUserData;
        }
        var _isRoleDell = function () {
            return $sessionStorage.currentUserData;
        }


        var _user = function () {
            return $sessionStorage.currentUserData;
        }

        var _roles = function () {
            return _user().roles;
        }

        var _hasRole = function (role) {
            return _.includes([_roles()], role);
        }
        authDataFactory.GetInvitedUser = function (UserId, Authkey) {
            var data = {};
            return $http({
                headers: { 'content-type': 'application/json' },
                method: 'get',
                url: __env._environment.config.apiAuthServiceBaseUri + "/api/Account/GetInvitedUser",
                params: { UserId: UserId, Authkey: Authkey },
                data: $.param(data)
            });
        }
        authDataFactory.RegisterInvitedUser = function (data) {
            return $http({
                headers: { 'content-type': 'application/json' },
                method: 'post',
                url: __env._environment.config.apiAuthServiceBaseUri + "/api/Account/RegisterInvitedUser",
                params: {},
                data: JSON.stringify(data),
            });
        }

        authDataFactory.isAuthenticated = _isAuthenticated;
        authDataFactory.validateRoleDell = _isRoleDell;
        authDataFactory.validateRoleAdmin = _isAdmin;
        authDataFactory.login = _login;
        authDataFactory.getLoginDataByUserId = _getLoginDataByUserId;
        authDataFactory.User = _user;
        authDataFactory.HasRole = _hasRole;
        authDataFactory.Roles = _roles;
        authDataFactory.refreshToken = _refreshToken;
        authDataFactory.removeRefreshToken = _removeRefreshToken;
        authDataFactory.revokeAccessToken = _revokeAccessToken;
        authDataFactory.forgotPassword = _forgotPassword;
        authDataFactory.forgotPasscode = _forgotPasscode;
        authDataFactory.checkPasscode = _checkPasscode;
        authDataFactory.generateOTP = _generateOTP;
        authDataFactory.verifyOTP = _verifyOTP;
        return authDataFactory;
    }

    app.factory('authService', authService);



})();

(function () {
    'use strict';

    angular.module('BlurAdmin').factory('resetPasswordLinkHelper', resetPasswordLinkHelper);

    function resetPasswordLinkHelper() {
        return {
            parseEncodedParam: parseEncodedParam
        };

        function parseEncodedParam(encoded) {
            if (!encoded) {
                return null;
            }
            try {
                var value = encoded;
                if (value.indexOf('%') !== -1) {
                    value = decodeURIComponent(value.replace(/\+/g, ' '));
                }
                if (value.charAt(0) === '{') {
                    return JSON.parse(value);
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                while (value.length % 4) {
                    value += '=';
                }
                return JSON.parse(window.atob(value));
            } catch (e) {
                return null;
            }
        }
    }
})();

(function () {

    'use strict';

    angular.module('BlurAdmin')
        .run(runStateChange);

    function runStateChange($rootScope, $state, $timeout, authService, $sessionStorage, $location) {

        // enumerate routes that don't need authentication
        var routesThatDontRequireAuth = ['/login'];
        var routesThatForAdmins = ['/admin'];
        var routesThatForDell = ['/denialsworklist'];


        // check if current location matches route  
        var routeClean = function (route) {
            return _.find(routesThatDontRequireAuth,
                function (noAuthRoute) {
                    return _.startsWith(route, noAuthRoute);
                });
        };

        function hasResetPasswordParams() {
            return /[?&]resetpwdparams=/.test(window.location.href);
        }

        // check if route requires admin priviledge
        var routeAdmin = function (route) {
            return _.find(routesThatForAdmins,
                function (noAuthRoute) {
                    return _.startsWith(route, noAuthRoute);
                });
        }

        // check if current location matches route  
        var routeDell = function (route) {
            return _.find(routesThatForDell,
                function (noAuthRoute) {
                    return _.startsWith(route, noAuthRoute);
                });
        };



        $rootScope.$on('$stateChangeStart', function (ev, to, toParams, from, fromParams) {
            if (!authService.isAuthenticated()) {
                // Password-reset links land on / or /home with resetpwdparams in the hash;
                // let indexController/loginController handle them — do not rewrite the URL.
                if (!routeClean($location.url()) && !hasResetPasswordParams()) {
                    $location.path('/login');
                }
                return;
            }

            if (authService.validateRoleDell() && !routeDell($location.url())) {
                $location.path('/login');
            }
            else if (!authService.validateRoleAdmin()) {
                $location.path('/login');
            }
        });


    }



})();

(function () {
    'use strict';

    angular.module('radico.pages.psorders.search')
        .controller('PSOrdersSearchController', PSOrdersSearchController);
    function PSOrdersSearchController($scope, $stateParams) {


    }

})();

angular.module('radico.pages.psorders.search')
    .service('PSOrdersSearchService', ['Restangular', function (Restangular) {

        this.GetAllSites = function () {
            return Restangular.one('psorders').one("GetAllSites").get();
        };       
        this.GetOrdersList = function (orderListFilter) {
            return Restangular.one('psorders').one("GetOrdersList").customPOST(orderListFilter);
        };
        this.GetSitesAndLocations = function () {
            return Restangular.one('psorders').one("GetSitesAndLocations").get();
        };       
        this.GetPatientClass = function () {
            return Restangular.one('psorders').one("GetPatientClass").get();
        };
        this.CheckPSUserBySite = function (psuser) {
            return Restangular.one('psorders').one("CheckPSUserBySite").customPOST(psuser);
        };
        this.InsertPSUsersBySIte = function (psuser) {
            return Restangular.one('psorders').one("InsertPSUsersBySIte").customPOST(psuser);
        };
        this.SaveReport = function (reportView) {
            return Restangular.one('psorders').one("SaveReport").customPOST(reportView);
        };
        this.InsertOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("InsertOpenOrder").customPOST(openOrders);
        };
        this.DeleteOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("DeleteOpenOrder").customPOST(openOrders);
        };
        this.GetOpenOrder = function (openOrders) {
            return Restangular.one('psorders').one("GetOpenOrder").customPOST(openOrders);
        };
    }]);
(function () {
  "use strict";

  angular
    .module("radico.pages.questionnaire")
    .service("questionnaireCommonService", questionnaireCommonService);

  /** @ngInject */
  function questionnaireCommonService(Restangular, $sessionStorage, commonService) {
    var self = this;


    this.appendMissingQuestionsOptions = function (formCategories) {
      _.forEach(formCategories, function (category) {
        _.forEach(category.questions, function (question) {
          question.key = question.key || question.name;
          appendQuestionDefaultOptions(question)
          _.forEach(question.children, function (subQuestion) {
            subQuestion.key = subQuestion.key || question.name + ' - ' + subQuestion.name;
            appendQuestionDefaultOptions(subQuestion)
          })

        })

      })

    };

    function appendQuestionDefaultOptions(question) {
      appendControlDefaultOption(question);
      if (question.additionalQuestion) {
        appendControlDefaultOption(question.additionalQuestion);
      }
      return question;
    }

    function appendControlDefaultOption(question) {
      question.controlOptions = question.controlOptions || {};
      question.answer = question.answer || {};
      question.controlOptions.name = question.controlOptions.name || Math.random();
      if (commonService.stringEqual(question.controlType, "YesNo") && !(question.answerOptions || []).length) {
        question.answerOptions = getYesNoAnswerOptions();
      }


      question.controlOptions.wrapperCssClass = question.controlOptions.wrapperCssClass || 'col-sm-12 col-md-12';

      var questionCssClass = question.controlOptions.questionCssClass;
      var additionalQuestionCssClass = question.controlOptions.additionalQuestionCssClass;
      ;
      if (!questionCssClass && question.additionalQuestion) {
          questionCssClass = 'col-sm-8 col-md-8';
      }
      if (!additionalQuestionCssClass && question.additionalQuestion) {
          additionalQuestionCssClass = 'col-sm-4 col-md-4';
      }

      question.controlOptions.questionCssClass = questionCssClass || 'col-sm-12 col-md-12';
      question.controlOptions.additionalQuestionCssClass = additionalQuestionCssClass || 'col-sm-12 col-md-12';

      return question;
    }

    function getYesNoAnswerOptions() {
      return [
        {
          "optionValue": "Y",
          "optionText": "YES",
        },
        {
          "optionValue": "N",
          "optionText": "NO",
        },
      ];
    };


    this.getAllQuestions = function (formCategories) {
      var allQuestions = [];
      _.forEach(formCategories, function (category) {
        _.forEach(category.questions, function (question) {
          allQuestions = _.concat(allQuestions, question, question.children || [])
        });
      })
      return allQuestions;
    };

    this.buildModelAnswerValue = function (question) {
      if (question) {
        question.answer.answerValue = question.answer.answerValue || _.get(question, 'controlOptions.defaultValue');
        if (commonService.stringEqual(question.controlType, 'date') && question.answer.answerValue) {
          question.answer.answerValue = commonService.convertToDate(question.answer.answerValue);
        }
        else if (commonService.stringEqual(question.controlType, 'ListCheckbox') && question.answer.answerValue) {
          var answerValues = _.split(question.answer.answerValue, ',')
          _.forEach(question.answerOptions, function (ao) {
            if (_.includes(answerValues, ao.optionValue)) {
              ao.isSelected = true;
            }
          })
        }
        else if (commonService.stringEqual(question.controlType, 'Checkbox') && question.answer.answerValue) {

          if (question.controlOptions.trueValue && question.answer.answerValue === question.controlOptions.trueValue) {
            question.answer.answerValue = true;
          }
          if (question.controlOptions.falseValue && question.answer.answerValue === question.controlOptions.falseValue) {
            question.answer.answerValue = false;
          }
        }
      }

    };

    this.getAllAvaliableQuestions = function (formCategories) {
      var allQuestions = this.getAllQuestions(formCategories);
      allQuestions = _.filter(allQuestions, function (q) {
        return q.controlType && !commonService.stringEqual(q.controlType, 'Placeholder');
      })
      return allQuestions;
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("radico.pages.questionnaire")
    .service("questionnaireService", questionnaireService);

  /** @ngInject */
  function questionnaireService(Restangular, $http, $sessionStorage) {
    var self = this;

    this.getQuestionnaireForms = function () {
      return Restangular.one("questionnaire")
        .one("questionnaire-forms")
        .get();
    };

    this.getQuestionnaireFormContent = function (questionnaireFormId) {
      return Restangular.one("questionnaire")
        .one("forms-content", questionnaireFormId)
        .get();
    };

    this.getQuestionnaireAnswers = function (answerTarget) {
      return Restangular.one("questionnaire")
        .one("get-answsers")
        .customPOST(answerTarget);
    };
    

    this.saveFormAnswers = function (answerRequest) {
      return Restangular.one("questionnaire")
        .one("save-answsers")
        .customPOST(answerRequest);
    };

    
    // this.getOrderForms = function (fileName) {
    //   return $http.get('/assets/data/questionnaire-forms/' + fileName);
     
    // };


  }
})();

(function () {
    'use strict';

    angular.module('radico.pages.schedule.addEditSchedule')
        .controller('addEditScheduleCtrl', addEditScheduleCtrl);

    function addEditScheduleCtrl($scope, SharedService) {
        function pageInit() {
            console.log("shiftConfigurationCtrl");
        }
        pageInit();

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();
(function () {
    'use strict';

    angular.module('radico.pages.schedule.schedulSetting')
        .controller('schedulSettingCtrl', schedulSettingCtrl);

    function schedulSettingCtrl($scope, SharedService) {
        function pageInit() {
            console.log("schedulSettingCtrl");
        }
        pageInit();

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();
(function () {
    'use strict';

    angular.module('radico.pages.schedule.shiftClassification')
        .controller('shiftClassificationCtrl', shiftClassificationCtrl);

    function shiftClassificationCtrl($scope, SharedService) {
        function pageInit() {
            console.log("shiftClassificationCtrl");
        }
        pageInit();
        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }

    }
})();
(function () {
    'use strict';

    angular.module('radico.pages.schedule.shiftConfiguration')
        .controller('shiftConfigurationCtrl', shiftConfigurationCtrl);

    function shiftConfigurationCtrl($scope, SharedService) {
        function pageInit() {
            console.log("shiftConfigurationCtrl");
        }
        pageInit();

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();
(function () {
    'use strict';

    angular.module('radico.pages.schedule.userSchedule')
        .controller('userScheduleCtrl', userScheduleCtrl);

    function userScheduleCtrl($scope, SharedService) {
        function pageInit() {
            console.log("userSchedule");
        }
        pageInit();

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();
(function () {
    'use strict';

    angular.module('radico.pages.settings.lookup')
        .controller('LookupController', LookupController);
    function LookupController($scope, $sessionStorage, CommonService, filterFilter, LookupService, $uibModal, $timeout, toastr, toaster, SharedService) {


        $scope.Filter = {
            Type: [],
            Key: "",
            Value:"",
            PageSize: "25",
            PageNum: "1",
        };

        $scope.TotalCount = "0";
        $scope.PageSize = "25";
        $scope.PageNum = "1";
        $scope.isEdit = false;
        $scope.title = "Lookup";
        $scope.Init = function () {
            CommonService.startNotifyTATStudy();
            $timeout(function () {
                $scope.GetLookupTypes();
            }, 50);
            $scope.GetLookupData();
        };
        $scope.GetLookupTypes = function () {
            $scope.isLoading = true;
            LookupService.GetLookupTypes().then(function (result) {
                $scope.isLoading = false;
                $scope.LookupTypes = result;
            });
        };

        $scope.GetLookupData = function () {
            $scope.isLoading = true;
            $scope.Filter.PageNum = 1;
            $scope.Filter.PageSize = "25";
            $scope.PageSize = "25";
            $scope.PageNum = "1";
            LookupService.GetLookupData($scope.Filter).then(function (result) {
                $scope.isLoading = false;
                $scope.LookupData = result;
                $scope.TotalRows = parseInt(result[0].PageCounts);
            });
        };

        $scope.clearFilterAndRefesh = function () {
            $scope.Filter.PageNum = 1;
            $scope.Filter.PageSize = "25";
            $scope.Filter.Type = [];
            $scope.Filter.Key = "";
            $scope.Filter.Value = "";
            $scope.GetLookupData();
        }

        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };

        $scope.pageSizeChanged = function () {
            $scope.refresh();
        };

        $scope.PageNoChanged = function () {
            $scope.refresh();
        };

        $scope.refresh = function () {
            $scope.isLoading = true;
            $scope.Filter = {
                Type: [],
                Key: "",
                Value: "",
                PageSize: $scope.PageSize,
                PageNum: $scope.PageNum,
            };
            LookupService.GetLookupData($scope.Filter).then(function (result) {
                $scope.isLoading = false;
                $scope.LookupData = result;
                if (result != null && result.length > 0) {
                    $scope.TotalRows = result[0].PageCounts;
                }
                else {
                    $scope.TotalRows = "0";
                }
                $scope.isLoading = false;
            });
        };


        $scope.AddEditLookup = function (Lookup) {
            if (Lookup) {
                $scope.isEdit = true;
                var lookupObj = _.filter($scope.LookupData, {
                    ID: Lookup.ID
                })[0];
                $scope.LocAddLookup = angular.copy(lookupObj);

            }
            else {
                $scope.isEdit = false;
                $scope.LocAddLookup = {};
            }
            $('#ModalAddEditLookup').modal('show');
        };

        $scope.CloseLookupModal = function () {
            $scope.isEdit = false;
            $scope.LocAddLookup = {};
        };




        $scope.SaveLookup = function () {
            $scope.isLoading = true;

            if ($scope.isEdit) {
                var lookupObject = {
                    ID: $scope.LocAddLookup.ID,
                    Type: $scope.LocAddLookup.Type,
                    Key: $scope.LocAddLookup.Key,
                    Value: $scope.LocAddLookup.Value,
                    ModifyBy: $sessionStorage.currentUserData.userId
                };
            }
            else {
                var lookupObject = {
                    Type: $scope.LocAddLookup.Type,
                    Key: $scope.LocAddLookup.Key,
                    Value: $scope.LocAddLookup.Value,
                    CreatedBy: $sessionStorage.currentUserData.userId
                };
            }
            LookupService.SetLookupData(lookupObject).then(function (result) {
                if (result == 1) {
                    $scope.isLoading = false;
                    $('#ModalAddEditLookup').modal('hide');
                    if ($scope.isEdit)
                        toaster.success({ body: "Lookup updated successfully!" });
                    else
                        toaster.success({ body: "Lookup added successfully!" });
                    $scope.GetLookupData();
                }
                else {
                    $scope.isLoading = false;
                    $('#ModalAddEditLookup').modal('hide');
                    toaster.error({ body: "Something went wrong!" });
                }
            });
            
        };
        // JS for table row active
        angular.element(document).ready(function () {
            setTimeout(function () {
                angular.element(".common-tbl table tr").click(function () {
                    if (angular.element(this).data('clicked', true)) {
                        angular.element(".common-tbl table tr").removeClass('tr-active');
                        angular.element(this).addClass('tr-active');
                    }
                });
            }, 500);
        });
        $scope.$on('$destroy', function () {
            CommonService.stopNotifyTATStudy();
        });

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
   
    }

})();

angular.module('radico.pages.settings.lookup')
    .service('LookupService', ['Restangular', '$http', 'APP_CONSTANTS','__env', function (Restangular, $http, APP_CONSTANTS,__env) {

        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }

        this.GetLookupTypes = function (data) {
            return Restangular.one('Settings').one("Lookup", "GetLookupTypes").customPOST(data);
        };

        this.GetLookupData = function (data) {
            return Restangular.one('Settings').one("Lookup", "GetLookupData").customPOST(data);
        };

        this.SetLookupData = function (data) {
            return Restangular.one('Settings').one("Lookup", "SetLookupData").customPOST(data);
        };
        
        
    }]);

(function () {
    'use strict';

    angular.module('radico.pages.settings.managelocation')
        .controller('ManageLocationController', ManageLocationController).filter('titleCase', function () {
            return function (input) {
                input = input || '';
                return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            };
        });
    function ManageLocationController($q, $scope, $sessionStorage, ManageLocationService, $filter, RuleService, toaster, WorklistService, __env, $compile, $timeout, CommonService, SharedService) {
        //#region Site Tab
        ///------------------------------- Site Tab -----------------------------------------------------------------------
        $scope.multiSelectDropdowns = {
            defaultDicomViewer: {
                divId: "defaultDicomViewer",
                keys: ['Key'],
                uniqKey: 'ID',
                placeHolder: "Select Dicom Viewer",
                SelectedValue: { list: [] },
                onSelectedDefaultDV: function (selectedData) {
                    $scope.ObjSite.DicomViewer = selectedData
                }
            },
            OptionalDV: {
                divId: "OptionalDV",
                keys: ['Key'],
                uniqKey: 'ID',
                placeHolder: "Select optional Dicom Viewer",
                SelectedValue: { list: [] },
            },
            ContrastType: {
                divId: "ContrastType",
                keys: ['Value'],
                uniqKey: 'ID',
                placeHolder: "Select a Contrast Type",
                SelectedValue: { list: [] },
                onSelectedContrastType: function (selectedData) {
                    $scope.ObjSite.ContrastType = selectedData;
                }
            },
            PrtgDevice: {
                divId: "PrtgDevice",
                keys: ['device'],
                uniqKey: 'objid',
                placeHolder: "Select PRTG Device",
                SelectedValue: { list: [] },
                onSelectedPrtgDevice: function (selectedData) {
                    $scope.ObjSite.PrtgDeviceIds = selectedData
                }
            }
        }
        $scope.PageNo = 1;
        $scope.PageSize = "25";
        $scope.TotalRows = "";
        $scope.FlagEdit = false;
        $scope.TechniqueList = [];
        $scope.SelectedTechniques = [];
        $scope.AllTechniqueList = [];
        $scope.dicomViewers = ['Synapse'];
        $scope.diacomViewerURLVisible = false;

        $scope.AllowedUser = [];
        $scope.selectedclientsFullSet = [];
        $scope.RadiologistsFullSet = [];
        var MasterRadiologistsFullSet = [];
        $scope.selectedclients = [];
        $scope.Radiologists = [];
        $scope.search = '';
        $scope.searchclient = '';
        $scope.userstooltip = 'Select Users';
        $scope.selectedValues = { SelectedRadiologists: [] };
        $scope.SiteSaved = false;
        $scope.SelectedTenant = {};
        $scope.showAssignRadiologistCmp = { value: false };
        $scope.SelectedTenantId = null;

        $scope.SelectedTimeZone = { Obj: null };
        $scope.AllTimeZoneList = [];
        $scope.ShowAddressBookGrid = false;
        $scope.loadEmailidInput = false;
        var TimeoutList = [];
        $scope.disableSiteTimezone = false;
        $scope.checkInstitutionViewerMap = false;
        $scope.DataObject = {
            ReviewPercentage: null,
            PrefixInput: "",
            SuffixInput: "",
        }
        $scope.SiteApplication = { Data: [] };
        var SelectedSiteAssignedRadiologists = null;
        // JS for table row active
        $scope.activeTableTR = function () {
            angular.element(document).ready(function () {
                var timeout = setTimeout(function () {
                    angular.element(".common-tbl table tr").click(function () {
                        if (angular.element(this).data('clicked', true)) {
                            angular.element(".common-tbl table tr").removeClass('tr-active');
                            angular.element(this).addClass('tr-active');
                        }
                    });
                }, 500);
                TimeoutList.push(timeout);
            });
        }

        function pageInit() {
            CommonService.startNotifyTATStudy();
            $scope.GetLookupTypes();
            $scope.refresh();
            GetAllRadiologists();
            GetModality();
            initPrefixSuffixGrid();
            getAllDevice();
            initFaxDetailsGrid();
        }
        $scope.GetLookupTypes = function () {
            ManageLocationService.GetLookupByType('ContrastType,DictationSystem,OldOrdersComparisonTime,DelayedStatColorCode,DicomViewer,PatientClass').then(function (result) {
                //$scope.InstAllLocations = result;
                $scope.ContrastTypeList = _.filter(result, { Type: 'ContrastType' });
                $scope.DefaultDictationSystemList = _.filter(result, { Type: 'DictationSystem' });
                $scope.OldOrdersComparisonTime = _.filter(result, { Type: 'OldOrdersComparisonTime' });
                $scope.DelayedStatColorCode = _.filter(result, { Type: 'DelayedStatColorCode' });
                $scope.InstDicomViewerList = _.filter(result, { Type: 'DicomViewer' });
                $scope.DataObject.PatientClassList = _.filter(result, { Type: 'PatientClass' });
            });
        };
        ManageLocationService.GetTenantsByUserID({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
            $scope.TenantByUserID = result;
        });
        $scope.GetAllRadiologistsByTenat = function (SelectedTenant) {
            GetAllRadiologists(SelectedTenant.Obj.TenantID).then(function (resp) {
                var currentUser = _.filter($scope.RadiologistsFullSet, { 'Id': $sessionStorage.currentUserData.userId })
                var RadiologistsFullSet = _.clone($scope.RadiologistsFullSet);
                $scope.moveItemRadiologis(currentUser, RadiologistsFullSet, $scope.selectedclientsFullSet).then(function (resp) {
                    $scope.SaveRadiologists(false);
                });
            });
        }

        $scope.ObjSite = {};
        $scope.refresh = function () {
            GetLookupByType("DicomViewer");
            $scope.isLoading = true;
            var UsersList = _.filter($scope.Users, function (obj) { return obj.Id != 0; });
            var users = '';
            _.each(UsersList, function (data) {
                if (users.length > 0) {
                    users = users + "," + data.Id;
                }
                else if (users.length == 0) {
                    users = data.Id;
                }
            });
            $scope.siteFilter = {
                PageNum: $scope.PageNo,
                PageSize: $scope.PageSize,
                Site: $scope.Site ? $scope.Site : null,
                PSSiteName: $scope.PSSiteName ? $scope.PSSiteName : null,
                TenantName: $scope.SiteTenantName ? $scope.SiteTenantName : null,
                UserIDs: users.length > 0 ? users : null,
                UserID: $sessionStorage.currentUserData.userId,
            };
            ManageLocationService.GetSites($scope.siteFilter).then(function (result) {
                $scope.SiteList = result;
                if (result != null && result.length > 0) {
                    $scope.TotalRows = result[0].TotalRows;
                }
                else {
                    $scope.TotalRows = "0";
                }
                $scope.isLoading = false;
            });
            $scope.activeTableTR();  // table row active
            GetAllTimeZones();
        };
        $scope.pageSizeChanged = function () {
            $scope.refresh();
        };
        $scope.PageNoChanged = function () {
            $scope.refresh();
        };
        $scope.ClearFilter = function () {
            $scope.Site = "";
            $scope.PSSiteName = "";
            $scope.PageNo = 1;
            $scope.PageSize = "25";
            $scope.SiteTenantName = "";
            $scope.Users = [];
            $scope.userstooltip = 'Select Users';
            $("#tree-text-search").val('');
            var drtr = $("#usersDropdownTree").data("kendoDropDownTree");
            if (drtr) {
                var tree = drtr.treeview;
                var dataSource = drtr.dataSource;
                dataSource.filter({});
                var timeout = setTimeout(function () {
                    tree.collapse(".k-item");
                }, 1000);
                TimeoutList.push(timeout);
            };
            setSelectedUsersFilterSettings();
            $scope.refresh();
        };

        $scope.setSelected = function (SelectedSiteID) {
            $scope.SelectedSiteID = SelectedSiteID;
            //console.log(idSelectedVote);
        };

        $scope.EditSite = function (site) {
            if (PrefixSuffixGridOptions && PrefixSuffixGridOptions.api) {
                PrefixSuffixGridOptions.api.setRowData([]);
            }
            $scope.DataObject.ReviewPercentage = (site.ReviewPercentage) ? _.toInteger(site.ReviewPercentage) : null;
            $scope.disableSiteTimezone = true;
            if (site.TimeZone) {
                $scope.SelectedTimeZone.Obj = _.find($scope.AllTimeZoneList, { TimeZone: site.TimeZone });
            }
            else {
                $scope.SelectedTimeZone.Obj = _.find($scope.AllTimeZoneList, { TimeZone: 'Central Standard Time' });
            }
            var tenant = _.find($scope.TenantByUserID, { 'DisplayName': site.TenantName });
            if (tenant) {
                GetAllRadiologists(tenant.TenantID).then(function (resp) {
                    $scope.isSaveRadiologistOption = false;
                    $scope.search = '';
                    $scope.searchclient = '';
                    ManageLocationService.GetUserBySite(site).then(function (result) {
                        $scope.selectedclientsFullSet = result;
                        $scope.selectedValues.SelectedRadiologists = $scope.selectedclientsFullSet;
                        $scope.FlagEdit = true;
                        $scope.txtSite = site.Site;
                        $scope.txtPSSiteName = site.PSSiteName;
                        $scope.SelectedTenant.Obj = tenant;
                        //$scope.txtSiteTenantName = site.TenantName;
                        $scope.ObjSite.ContrastType = [];
                        $scope.ObjSite.IsFinalize = site.IsFinalize;
                        $scope.ObjSite.IsEnableFax = site.IsEnableFax;
                        $scope.ObjSite.IsImageViewableForTech = site.IsImageViewableForTech;
                        $scope.ObjSite.IsDicomizePDF = site.IsDicomizePDF;
                        $scope.ObjSite.CreateReportPDF = site.CreateReportPDF;
                        $scope.ObjSite.EnablePatientWallet = site.IsPatientWallet;
                        $scope.ObjSite.OldOrdersComparisonTime = site.OldOrdersComparisonTime ? calculateComparisonTimeInHours(site.OldOrdersComparisonTime) : getDefaultOldOrdersComparisonTime();

                        _.each(site.ContrastList, function (l) {
                            var t = _.find($scope.ContrastTypeList, function (cl) { return cl.Key == l });
                            if (t) {
                                $scope.ObjSite.ContrastType.push(t);
                            }
                        });
                        $scope.multiSelectDropdowns.ContrastType.SelectedValue = {
                            list: $scope.ObjSite.ContrastType
                        };
                        $scope.ObjSite.DicomViewer = [];
                        if (site.DicomViewer) {
                            _.each((site.DicomViewer).split(","), function (viewer) {
                                var obj = _.find($scope.InstDicomViewerList, { Key: viewer.trim() });
                                if (obj) {
                                    $scope.ObjSite.DicomViewer.push(obj);
                                }
                            });
                        }
                        $scope.multiSelectDropdowns.defaultDicomViewer.SelectedValue = {
                            list: $scope.ObjSite.DicomViewer
                        };

                        $scope.ObjSite.PrtgDeviceIds = [];
                        if (site.PrtgDeviceIds) {
                            _.each((site.PrtgDeviceIds).split(","), function (device) {
                                var obj = _.find($scope.PrtgDeviceList, { objid: _.toInteger(device) });
                                if (obj) {
                                    $scope.ObjSite.PrtgDeviceIds.push(obj);
                                }
                            });
                        }
                        $scope.multiSelectDropdowns.PrtgDevice.SelectedValue = {
                            list: $scope.ObjSite.PrtgDeviceIds
                        };

                        GetSiteApplicationEntity($scope.SelectedSiteID).then(function (result) {
                            $('#ModalAddEditSite').modal('show');
                            if (result && result.length > 0) {
                                siteConfigGridOptions.api.setRowData(CreateRowDataSet(result));// Convert Object to Row Data
                                $scope.SiteApplication.Data = result;
                            }
                            else {
                                siteConfigGridOptions.api.setRowData(CreateRowDataSet());// Convert Object to Row Data
                                $scope.SiteApplication.Data = [];
                            }
                        });
                    });
                });
            }
            ManageLocationService.GetSitePrefixSuffix({ SiteID: site.SiteID }).then(function (res) {
                PrefixSuffixGridOptions.api.setRowData(res);
            });
        };
        $scope.AddSite = function () {
            $scope.SiteApplication.Data = [];
            $scope.SelectedSiteID = null;
            if (PrefixSuffixGridOptions && PrefixSuffixGridOptions.api) {
                PrefixSuffixGridOptions.api.setRowData([]);
            }
            $scope.DataObject.ReviewPercentage = null;

            $scope.isSaveRadiologistOption = false;

            $scope.selectedclientsFullSet = [];
            $scope.selectedValues.SelectedRadiologists = [];

            $scope.FlagEdit = false;
            $scope.txtSite = "";
            $scope.txtPSSiteName = "";
            $scope.SelectedTenant.Obj = "";
            $scope.search = '';
            $scope.searchclient = '';
            $scope.ObjSite.IsFinalize = false;
            $scope.ObjSite.IsEnableFax = false;
            $scope.ObjSite.IsImageViewableForTech = false;
            $scope.ObjSite.IsDicomizePDF = false;
            $scope.ObjSite.ContrastType = [];
            $scope.multiSelectDropdowns.ContrastType.SelectedValue = {
                list: []
            };
            $scope.ObjSite.CreateReportPDF = false;
            $scope.ObjSite.EnablePatientWallet = false;

            $scope.ObjSite.OldOrdersComparisonTime = getDefaultOldOrdersComparisonTime();
            $scope.ObjSite.DicomViewer = [];
            $scope.multiSelectDropdowns.defaultDicomViewer.SelectedValue = {
                list: []
            };
            $scope.ObjSite.PrtgDeviceIds = [];
            $scope.multiSelectDropdowns.PrtgDevice.SelectedValue = {
                list: []
            };
            $scope.SelectedTimeZone.Obj = _.find($scope.AllTimeZoneList, { TimeZone: "Central Standard Time" });
            siteConfigGridOptions.api.setRowData(CreateRowDataSet());
            $('#ModalAddEditSite').modal('show');
        };
        $scope.DeleteSite = function (site) {
            ManageLocationService.CheckSiteMapping(site.SiteID).then(function (result) {
                if (result != null && result.length > 0) {
                    toaster.warning({ body: "You can not delete this site! </br> Location mapped with this site.", bodyOutputType: 'trustedHtml' });

                    return;
                }
                else {
                    SetSiteApplicationEntity(site.SiteID, 'D').then(function () {
                        var dsite = {
                            SiteID: $scope.SelectedSiteID,
                            ModifyBy: $sessionStorage.currentUserData.userId
                        };
                        ManageLocationService.DeleteSite(dsite).then(function (result) {
                            toaster.success({ body: "Site deleted successfully." });
                            $scope.refresh();
                        });
                    });
                }
            });
        };

        $scope.SaveSite = function () {
            $scope.SiteSaved = true;
            siteConfigGridOptions.api.stopEditing();
            var Timeout = $timeout(function () {
                var ContainDataAfterEditing = allRowsHaveData(siteConfigGridOptions);
                if (!ContainDataAfterEditing.allRowsEmpty && ContainDataAfterEditing.invalidData) {
                    toaster.warning({ body: "Please fill in all the columns in the Query Retrieve section." });
                    $scope.SiteSaved = false;
                    return;
                }
                else if (ContainDataAfterEditing.allRowsEmpty && $scope.SiteApplication.Data.length > 0) {
                    SetSiteApplicationEntity($scope.SelectedSiteID, 'D');
                }
                if ($scope.ObjSite.OldOrdersComparisonTime && $scope.ObjSite.OldOrdersComparisonTime <= 0) {
                    toaster.warning({ body: "The comparison time must be at least 1 in hours." });
                    $scope.SiteSaved = false;
                    return;
                }
                var site = {
                    SiteID: $scope.FlagEdit ? $scope.SelectedSiteID : "-1",
                    Site: $scope.txtSite,
                    PSSiteName: $scope.txtPSSiteName,
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    ContrastType: "",
                    IsFinalize: $scope.ObjSite.IsFinalize,
                    IsEnableFax: $scope.ObjSite.IsEnableFax,
                    IsImageViewableForTech: $scope.ObjSite.IsImageViewableForTech,
                    IsDicomizePDF: $scope.ObjSite.IsDicomizePDF,
                    TenantName: $scope.SelectedTenant.Obj.Name,
                    UserIds: "",
                    CreateReportPDF: $scope.ObjSite.CreateReportPDF == "1" ? true : false,
                    OldOrdersComparisonTime: convertHoursToMinute($scope.ObjSite.OldOrdersComparisonTime),
                    IsPatientWallet: $scope.ObjSite.EnablePatientWallet == "1" ? true : false,
                    TimeZone: ($scope.SelectedTimeZone.Obj && $scope.SelectedTimeZone.Obj.TimeZone) ? $scope.SelectedTimeZone.Obj.TimeZone : null,
                    ReviewPercentage: $scope.DataObject.ReviewPercentage,
                    PrtgDeviceIds: ""
                };

                _.each($scope.ObjSite.ContrastType, function (l) {
                    if (l && l.Key) {
                        if (site.ContrastType) {
                            site.ContrastType += "," + l.Key;
                        } else {
                            site.ContrastType = l.Key;
                        }
                    }
                });

                _.each($scope.ObjSite.PrtgDeviceIds, function (l) { //add comma seprated id's of devices
                    if (l && l.objid) {
                        if (site.PrtgDeviceIds) {
                            site.PrtgDeviceIds += "," + l.objid;
                        } else {
                            site.PrtgDeviceIds = l.objid;
                        }
                    }
                });
                _.each($scope.selectedValues.SelectedRadiologists, function (l) {
                    if (l && l.Id) {    
                        if (site.UserIds) {
                            site.UserIds += "," + l.Id;
                        } else {
                            site.UserIds = l.Id;
                        }
                    }
                });
                ManageLocationService.CheckSiteExists(site).then(function (result) {
                    if (result != null && result.length > 0) {
                        $scope.SiteSaved = false;
                        toaster.error({ body: "Site exists with the same name!" });
                        return;
                    }
                    else {
                        if ($scope.ObjSite.DicomViewer) {
                            var DicomViewer = "";
                            _.each($scope.ObjSite.DicomViewer, function (viewer) {
                                DicomViewer = (DicomViewer == "") ? viewer.Value : DicomViewer + "," + viewer.Value;
                            });
                            site.DicomViewer = DicomViewer;
                        }

                        ManageLocationService.AddEditSite(site).then(function (result) {
                            if (result && result.SiteID) {
                                if (!ContainDataAfterEditing.invalidData && !ContainDataAfterEditing.allRowsEmpty) {
                                    var Flag = 'I';
                                    if ($scope.SiteApplication.Data && $scope.SiteApplication.Data.length > 0 && $scope.SiteApplication.Data[0].SiteApplicationEntityID) {
                                        Flag = 'U';
                                    }
                                    SetSiteApplicationEntity(result.SiteID, Flag);
                                    Flag = null;
                                }
                                SetSitePrefixSuffix(result.SiteID).then(function () {
                                    $scope.SiteSaved = false;
                                    //$scope.SiteList = result;
                                    $('#ModalAddEditSite').modal('hide');
                                    toaster.success({ body: site.Site + " settings have been saved successfully!" })
                                });
                            }

                        });

                    }

                });
                $timeout.cancel(Timeout);
                Timeout = null;
            }, 1000);
        };
        $("#ModalAddEditSite").on('hide.bs.modal', function () {
            $scope.refresh();
            $scope.disableSiteTimezone = false;
        });

        $scope.AssignRadiologists = function () {
            $scope.search = '';
            $scope.searchclient = '';
            $scope.selectedValues.SelectedRadiologists = [];
            $scope.RadiologistsFullSet = angular.copy(MasterRadiologistsFullSet);
            if ($scope.selectedclientsFullSet != null && $scope.selectedclientsFullSet.length > 0) {
                angular.forEach($scope.selectedclientsFullSet, function (item) {

                    $scope.selectedValues.SelectedRadiologists.push(item);

                    var idx = _.findIndex($scope.RadiologistsFullSet, { Id: item.Id });
                    if (idx != -1) {
                        $scope.RadiologistsFullSet.splice(idx, 1);
                    }
                });
            }
            $scope.filterRadiologist();
            $scope.filterselectedclients();
            $('#AssignUsers').modal('show');
            $scope.modalTitle = 'Assign Users';
            $scope.SavebtnText = 'Ok';
        };

        $scope.LoadAssignRadiologists = function (site) {
            var tenant = _.find($scope.TenantByUserID, { 'DisplayName': site.TenantName });
            SelectedSiteAssignedRadiologists = _.cloneDeep(site);
            /*$scope.SelectedTenant = tenantID;*/
            if (tenant) {
                $q.all([
                    GetAllRadiologists(tenant.TenantID)
                ]).then(function () {
                    $scope.isSaveRadiologistOption = true;
                    ManageLocationService.GetUserBySite(site).then(function (result) {
                        $scope.selectedclientsFullSet = result;
                        $scope.FlagEdit = true;
                        $scope.txtSite = site.Site;
                        /*$scope.txtPSSiteName = site.PSSiteName;
                        $scope.SelectedTenant.Obj = tenant;
                        //$scope.txtSiteTenantName = site.TenantName;
                        $scope.ObjSite.ContrastType = [];
                        $scope.ObjSite.IsFinalize = site.IsFinalize;
                        $scope.ObjSite.IsEnableFax = site.IsEnableFax;
                        $scope.ObjSite.IsImageViewableForTech = site.IsImageViewableForTech;
                        $scope.ObjSite.IsDicomizePDF = site.IsDicomizePDF;
                        $scope.ObjSite.CreateReportPDF = site.CreateReportPDF;
                        $scope.ObjSite.EnablePatientWallet = site.IsPatientWallet;
                        $scope.ObjSite.OldOrdersComparisonTime = site.OldOrdersComparisonTime ? calculateComparisonTimeInHours(site.OldOrdersComparisonTime) : getDefaultOldOrdersComparisonTime();
                        _.each(site.ContrastList, function (l) {
                            var t = _.filter($scope.ContrastTypeList, function (cl) { return cl.Key == l })[0];
                            $scope.ObjSite.ContrastType.push(t);
                        });
                        $scope.multiSelectDropdowns.ContrastType.SelectedValue = {
                            list: $scope.ObjSite.ContrastType
                        };*/

                        $scope.search = '';
                        $scope.searchclient = '';
                        $scope.AssignRadiologists();
                        $scope.SavebtnText = 'Save';
                        $scope.showAssignRadiologistCmp.value = true;
                        $scope.DataObject.ReviewPercentage = (site.ReviewPercentage) ? _.toInteger(site.ReviewPercentage) : null;
                    });
                });

            }

        };
        $scope.moveItemRadiologis = function (items, from, to) {
            var d = $q.defer();
            //console.log('Move item   Item: ' + item + ' From:: ' + from + ' To:: ' + to);
            //Here from is returned as blank and to as undefined
            if (!items || items.length == 0) {
                $scope.available = null;
                $scope.selected = null;
            }
            angular.forEach(items, function (item) {
                var idx = from.indexOf(item);
                if (idx != -1) {
                    from.splice(idx, 1);
                }
                idx = _.findIndex(to, { 'Id': item.Id });
                if (idx == -1) {
                    to.push(item);
                }
            });
            $scope.filterRadiologist();
            $scope.filterselectedclients();
            d.resolve();
            return d.promise;
        };
        $scope.Close = function () {
            $scope.search = '';
            $scope.searchclient = '';
            $scope.selectedclientsFullSet = $scope.selectedValues.SelectedRadiologists;
        };
        $scope.SaveRadiologists = function (Flag) {
            if (Flag) {
                $scope.selectedValues.SelectedRadiologists = $scope.selectedValues.SelectedRadiologists;
                $scope.selectedclientsFullSet = $scope.selectedValues.SelectedRadiologists;
            }
            else {
                $scope.selectedValues.SelectedRadiologists = $scope.selectedclientsFullSet;
            }
            $('#AssignUsers').modal('hide');
        };
        $scope._SaveRadiologists = function () {
            $scope.SaveRadiologists(true);
            var site = angular.copy(SelectedSiteAssignedRadiologists);
            if ($scope.SavebtnText == 'Save') {
                //$scope.SaveSite()
                var siteObject = _.omit(site, ['ModifyDate', 'StatsFlag', 'PSSiteID', 'TotalRows', 'ContrastList', 'SiteDicomViewer']);
                _.each($scope.selectedValues.SelectedRadiologists, function (l) {
                    if (siteObject.UserIds) {
                        siteObject.UserIds += "," + l.Id;
                    } else {
                        siteObject.UserIds = l.Id;
                    }
                });
                var DicomViewer = "";
                if (siteObject.DicomViewer) {
                    _.each((siteObject.DicomViewer).split(","), function (viewer) {
                        var obj = _.find($scope.InstDicomViewerList, { Key: viewer.trim() });
                        if (obj) {
                            DicomViewer = (DicomViewer == "") ? obj.Value : DicomViewer + "," + obj.Value;
                        }
                    });
                    siteObject.DicomViewer = DicomViewer;
                }
                siteObject.ModifyBy = $sessionStorage.currentUserData.userId;
                ManageLocationService.AddEditSite(siteObject).then(function (result) {
                    if (result && result.SiteID) {
                        toaster.success({ body: siteObject.Site + " settings have been saved successfully!" });
                        $scope.refresh();
                    }
                });
            }
        };
        $scope.filterRadiologist = function () {
            $scope.Radiologists = _.filter($scope.RadiologistsFullSet, function (obj) {
                if ($scope.search) {
                    return (obj.FirstName + ' ' + obj.LastName).toLowerCase().includes($scope.search.toLowerCase());
                } else {
                    return true;
                }
            });
            $scope.Radiologists = _.sortBy($scope.Radiologists, function (obj) { return obj.FirstName + ' ' + obj.LastName; });
        }
        $scope.filterselectedclients = function () {
            $scope.selectedclients = _.filter($scope.selectedclientsFullSet, function (obj) {
                if ($scope.searchclient) {
                    return (obj.FirstName + ' ' + obj.LastName).toLowerCase().includes($scope.searchclient.toLowerCase());
                } else {
                    return true;
                }
            });
            $scope.selectedclients = _.sortBy($scope.selectedclients, function (obj) { return obj.FirstName + ' ' + obj.LastName; });
        }
        function GetAllRadiologists(TenantID) {
            var d = $q.defer();
            $scope.SelectedTenantId = TenantID;
            RuleService.GetAllUserByTenant({ 'UserID': $sessionStorage.currentUserData.userId, 'TenantID': TenantID }).then(function (resp) {
                $scope.RadiologistsFullSet = resp;
                MasterRadiologistsFullSet = $scope.RadiologistsFullSet;
                //$scope.selectedclientsFullSet = selectedRadiologists;   
                $scope.loadUsersDropdown();
                d.resolve();
            }, function (err) {
                $scope.RadiologistsFullSet = null;
                d.resolve();
            });
            return d.promise;
        }
        $scope.loadUsersDropdown = function () {
            $scope.usersDropdownTreeOptions = {
                placeholder: $scope.userstooltip,
                checkboxes: true,
                autoClose: false,
                dataSource: MasterRadiologistsFullSet,
                dataTextField: "DisplayName",
                dataValueField: "Id",
                height: "auto",
                loadOnDemand: false,
                headerTemplate: '<span class="k-list-filter"><input class="k-textbox" role="listbox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-disabled="false" id="tree-text-search" autocomplete="off"/><span class="k-icon k-i-zoom"></span></span>',
                filtering: function (e) {
                    //get filter descriptor
                    var filter = e.filter;
                    // handle the event
                },
                open: function (e) {
                    $("#tree-text-search").change(refreshTree).keyup(refreshTree);
                    var timeout = setTimeout(function () {
                        $("#tree-text-search").focus();
                    }, 1500);
                    TimeoutList.push(timeout);

                    $("#tree-text-search").val('');
                    var drtr = $("#usersDropdownTree").data("kendoDropDownTree");
                    if (drtr) {
                        var tree = drtr.treeview;
                        var dataSource = drtr.dataSource;
                        dataSource.filter({});
                        var timeout = setTimeout(function () {
                            tree.collapse(".k-item");
                        }, 1000);
                        TimeoutList.push(timeout);
                    }
                },
                change: function (e) {
                    var nodes = e.sender.dataSource.view();
                    var checkedNodes = e.sender.value();
                    var values = checkedNodeValues(nodes, checkedNodes);
                    if (values.length > 0) {
                        var users = [];
                        _.each(values, function (data) {
                            var filter = _.find(MasterRadiologistsFullSet, function (item) { return item.Id == data; });
                            if (filter != null) {
                                users.push(filter);
                            }
                        });
                        $scope.Users = users;
                        setUserstooltip();

                    } else {
                        $scope.Users = [];
                        $scope.userstooltip = 'Select Users';
                    }
                },
            };
        };

        function checkedNodeValues(nodes, checkedNodes) {
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && !nodes[i].hasChildren) {
                    if (checkedNodes.indexOf(nodes[i].value) < 0) {
                        checkedNodes.push(nodes[i].value);
                    }
                }
                if (nodes[i].hasChildren) {
                    checkedNodeValues(nodes[i].children.view(), checkedNodes);
                }
            }
            return checkedNodes;
        }
        function refreshTree() {
            var drtr = $("#usersDropdownTree").data("kendoDropDownTree");
            var tree = drtr.treeview;
            var dataSource = drtr.dataSource;
            var value = $("#tree-text-search").val();
            if (value !== "") {
                dataSource.filter({
                    field: "DisplayName", //if I would use "ChildrenText" here nothing be displayed at all if filtertext is set
                    operator: "contains",
                    value: $("#tree-text-search").val()
                });
                //filtering child node
                if (dataSource.view().length > 0) {
                    for (var i = 0; i < dataSource.view().length; i++) {
                        if (dataSource.view()[i].hasChildren) {
                            dataSource.view()[i].children.filter({
                                field: "DisplayName",
                                operator: "neq",
                                value: true
                            })
                        }
                    }
                }
                var timeout = setTimeout(function () {
                    tree.expand(".k-item");
                }, 200);
                TimeoutList.push(timeout);
            } else {
                dataSource.filter({});

                var timeout = setTimeout(function () {
                    tree.collapse(".k-item");
                }, 200);
                TimeoutList.push(timeout);
            }
        }
        function setUserstooltip() {
            if ($scope.Users && $scope.Users.length > 0) {
                $scope.userstooltip = '';
                var objUsers = $filter('orderBy')($scope.Users, 'DisplayName');
                _.each(objUsers, function (data) {
                    if ($scope.userstooltip.length > 0) {
                        $scope.userstooltip = $scope.userstooltip + "\n" + data.DisplayName;
                    }
                    else if ($scope.userstooltip.length == 0) {
                        $scope.userstooltip = data.DisplayName;
                    }
                });
            }
            else {
                $scope.userstooltip = 'Select Users';
            }
        }
        function selectedUsersIds() {
            var selectedUsersIds = [];
            if ($scope.Users) {
                var Users = $scope.Users;
                for (var i = 0; i < Users.length; i++) {
                    selectedUsersIds.push(Users[i].UsersID);
                }
            }
            return selectedUsersIds;
        }
        function setSelectedUsersFilterSettings() {
            var ddt = $("#usersDropdownTree").data("kendoDropDownTree");
            var selectedUsers = selectedUsersIds();
            if (ddt) {
                ddt.value(selectedUsers);
            }
        }

        $scope.removeDicomViewer = function (item) {
            if ($scope.SelectedSiteID && $scope.ObjSite.DicomViewer && $scope.ObjSite.DicomViewer.length > 0) {
                $scope.checkInstitutionViewerMap = true;
                ManageLocationService.CheckInstitutionMapping({
                    SiteID: $scope.SelectedSiteID,
                    DicomViewer: item.Value
                }).then(function (result) {
                    var existingMapping = [];
                    if (result) {
                        result = _.unionBy(result, 'InstitutionID')
                        _.each(result, function (obj) {
                            if (obj.DicomViewerExists || obj.OptionalDicomViewerExists) {
                                existingMapping.push(obj.InstitutionName);
                            }
                        });
                    }
                    if (existingMapping.length > 0) {
                        toaster.pop({
                            type: 'warning',
                            title: "Can not remove " + item.Key + "!",
                            body: item.Key + " is mapped with <b>" + _.join(_.map(existingMapping, function (val) { return val }), ", ") + "</b> Institution(s)",
                            bodyOutputType: 'trustedHtml'
                        });
                        if ((_.findIndex($scope.ObjSite.DicomViewer, { ID: item.ID })) == -1) {
                            $scope.ObjSite.DicomViewer.push(item);
                            $scope.multiSelectDropdowns.defaultDicomViewer.SelectedValue = {
                                list: $scope.ObjSite.DicomViewer
                            };
                        }
                    }
                    $scope.checkInstitutionViewerMap = false;
                });
            }
        }
        //#endregion Site Tab
        ///------------------------------- Tab Changed -----------------------------------------------------------------------

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            var target = $(e.target).attr("href"); // activated tab
            //swal(target);
            if (target.toUpperCase() == "#SITES") {
                $scope.refresh();
            }
            else if (target.toUpperCase() == "#LOCATIONS") {
                $scope.Locinit();
            }
            else if (target.toUpperCase() == "#INSTITUTIONS") {
                $scope.Instinit();
            }
        });

        //#region Location Tab
        ///------------------------------- Location Tab -----------------------------------------------------------------------
        var DicomViewerFullList = [];
        $scope.GetAllSites = function () {
            ManageLocationService.GetAllSites($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.AllSites = result;
            });
        };

        $scope.LocPageNo = 1;
        $scope.LocPageSize = "25";
        $scope.LocTotalRows = "";
        $scope.LocSelected = {};
        $scope.LocFlagEdit = false;
        $scope.LocAddLocation = {};
        $scope.LocationSaved = false;

        $scope.LocRefresh = function () {
            $scope.isLoading = true;
            $scope.locationFilter = {
                PageNum: $scope.LocPageNo,
                PageSize: $scope.LocPageSize,
                SiteID: $scope.LocSelected.Site ? $scope.LocSelected.Site.SiteID : null,
                Location: $scope.Location ? $scope.Location : null,
                UserID: $sessionStorage.currentUserData.userId,
            };
            ManageLocationService.GetLocations($scope.locationFilter).then(function (result) {
                $scope.LocationList = result;
                if (result != null && result.length > 0) {
                    $scope.LocTotalRows = result[0].TotalRows;
                }
                else {
                    $scope.LocTotalRows = "0";
                }
                $scope.isLoading = false;
            });
        };
        $scope.setLocSelected = function (SelectedLocationID) {
            $scope.SelectedLocationID = SelectedLocationID;
            //console.log(idSelectedVote);
        };
        $scope.LocPageSizeChanged = function () {
            $scope.LocRefresh();
        };
        $scope.LocPageNoChanged = function () {
            $scope.LocRefresh();
        };

        $scope.Locinit = function () {
            $scope.GetAllSites();
            $scope.LocRefresh();
            $scope.activeTableTR();  // table row active
        };
        $scope.LocClearFilter = function () {
            $scope.LocSelected.Site = null;
            $scope.Location = "";
            $scope.LocPageNo = 1;
            $scope.LocPageSize = "25";
            $scope.LocRefresh();
        };
        $scope.AddLocation = function () {
            $scope.LocFlagEdit = false;
            $scope.loadEmailidInput = true;
            $scope.LocAddLocation.Site = null;
            $scope.LocAddLocation.IsAutomateFax = false;
            $scope.LocAddLocation.txtLocation = "";
            $scope.LocAddLocation.HideStudyEmailId = [];
            $scope.ShowAddressBookGrid = false;
            if (FaxDetailsGridOptions && FaxDetailsGridOptions.api) {
                FaxDetailsGridOptions.api.setRowData([]);
            }
            $('#ModalAddEditLocation').modal('show');
        };
        $scope.MapTechnique = function (Location) {
            $scope.LocationName = Location.Location;
            $scope.SelectedLocationID = Location.LocationID;
            $scope.getTechniquesforMapping();
            $('#ModalMapTechnique').modal('show');
        };
        $scope.EditLocation = function (Location) {
            $scope.LocFlagEdit = true;
            $scope.loadEmailidInput = true;
            $scope.LocAddLocation.Site = _.filter($scope.AllSites, {
                SiteID: Location.SiteID
            })[0];
            $scope.LocAddLocation.txtLocation = Location.Location;
            $scope.LocAddLocation.IsAutomateFax = Location.IsAutomateFax;
            $scope.LocAddLocation.HideStudyEmailId = [];
            if (Location.HideStudyEmailId) {
                $scope.LocAddLocation.HideStudyEmailId = _.map(Location.HideStudyEmailId.split(';'), function (email) { return { text: email } });
            }
            $scope.ShowAddressBookGrid = true;
            $scope.FilterAddressBook = {
                LocationIDs: Location.LocationID
            };
            GetLocationFaxMapping(Location.LocationID);
            if (FaxDetailsGridOptions && FaxDetailsGridOptions.api) {
                FaxDetailsGridOptions.api.setRowData([]);
            }
            $('#ModalAddEditLocation').modal('show');
        };
        $scope.DeleteLocation = function (location) {
            ManageLocationService.CheckLocationMapping(location.LocationID).then(function (result) {
                if (result != null && result.length > 0) {
                    toaster.warning({ body: "You can not delete this location! </br> Institution mapped with this location.", bodyOutputType: 'trustedHtml' });
                    return;
                }
                else {
                    var dLocation = {
                        LocationID: location.LocationID,
                        ModifyBy: $sessionStorage.currentUserData.userId
                    };
                    ManageLocationService.DeleteLocation(dLocation).then(function (result) {
                        toaster.success({ body: "Location deleted successfully." });
                        $scope.LocRefresh();
                    });
                }
            });
        };
        $scope.SaveLocation = function () {
            //console.log($scope.LocAddLocation);
            //$scope.LocRefresh();
            $scope.LocationSaved = true;
            var location = {
                SiteID: $scope.LocAddLocation.Site.SiteID,
                LocationID: $scope.LocFlagEdit ? $scope.SelectedLocationID : "-1",
                Location: $scope.LocAddLocation.txtLocation,
                IsAutomateFax: $scope.LocAddLocation.IsAutomateFax,
                ModifyBy: $sessionStorage.currentUserData.userId
            };
            if ($scope.LocAddLocation.HideStudyEmailId) {
                location.HideStudyEmailId = "";
                location.HideStudyEmailId = _.join(_.map($scope.LocAddLocation.HideStudyEmailId, function (email) { return email.text }), ';');
            }
            ManageLocationService.CheckLocationExists(location).then(function (result) {
                $scope.LocationSaved = false;
                if (result != null && result.length > 0) {
                    toaster.error({ body: "Location exists with the same name!" });
                    return;
                }
                else {

                    ManageLocationService.AddEditLocation(location).then(function (result) {
                        $scope.LocationSaved = false;
                        if (result && result.LocationID) {
                            SetLocationFaxMapping(result.LocationID);
                        }
                        $('#ModalAddEditLocation').modal('hide');
                    });
                }
            });
        };
        $("#ModalAddEditLocation").on('hide.bs.modal', function () {
            //swal('The modal is about to be hidden.');            
            $scope.LocRefresh();
            $scope.loadEmailidInput = false;
        });

        //#endregion Location Tab

        //#region Institution Tab
        ///------------------------------- Institution Tab -----------------------------------------------------------------------

        $scope.GetAllLocationsBySite = function (SiteID) {
            var filter = {
                SiteID: SiteID,
                UserID: $sessionStorage.currentUserData.userId,
            }
            ManageLocationService.GetAllLocations(filter).then(function (result) {
                $scope.AllLocations = result;
            });
        };
        $scope.InstGetAllLocationsBySite = function (SiteID) {
            var filter = {
                SiteID: SiteID,
                UserID: $sessionStorage.currentUserData.userId,
            }
            ManageLocationService.GetAllLocations(filter).then(function (result) {
                $scope.InstAllLocations = result;
            });
        };
        function GetLookupByType(type) {
            ManageLocationService.GetLookupByType(type).then(function (result) {
                //$scope.InstAllLocations = result;
                DicomViewerFullList = result;
                $scope.InstDicomViewerList = result;
                sortDicomViewer();
            });
        };

        $scope.InstPageNo = 1;
        $scope.InstPageSize = "25";
        $scope.InstTotalRows = "";
        $scope.InstSelected = {};
        $scope.InstFlagEdit = false;
        $scope.InstAddInstitution = {};
        //$scope.InstDicomViewerList = [{ "Name": "Agfa (Impax)", "Value": "AGFA" }, { "Name": "Candelis", "Value": "CANDELIS" }, { "Name": "Synapse", "Value": "SYNAPSE" }];
        //$scope.InstDicomViewerList = [{ "Name": "Agfa (Impax)", "Value": "AGFA" }, { "Name": "Candelis", "Value": "CANDELIS" }, { "Name": "Synapse", "Value": "SYNAPSE" }, { "Name": "Konica", "Value": "KONICA" }];
        $scope.InstitutionSaved = false;

        $scope.InstRefresh = function () {
            $scope.isLoading = true;
            $scope.institutionFilter = {
                PageNum: $scope.InstPageNo,
                PageSize: $scope.InstPageSize,
                SiteID: $scope.InstSelected.Site ? $scope.InstSelected.Site.SiteID : null,
                LocationID: $scope.InstSelected.Location ? $scope.InstSelected.Location.LocationID : null,
                InstitutionName: $scope.InstitutionName ? $scope.InstitutionName : null,
                UserID: $sessionStorage.currentUserData.userId,
            };
            ManageLocationService.GetInstitution($scope.institutionFilter).then(function (result) {
                $scope.InstitutionList = result;
                if (result != null && result.length > 0) {
                    $scope.InstTotalRows = result[0].TotalRows;
                }
                else {
                    $scope.InstTotalRows = "0";
                }
                $scope.isLoading = false;
            });
        };
        $scope.setInstSelected = function (SelectedInstitutionID) {
            $scope.SelectedInstitutionID = SelectedInstitutionID;
        };
        $scope.InstPageSizeChanged = function () {
            $scope.InstRefresh();
        };
        $scope.InstPageNoChanged = function () {
            $scope.InstRefresh();
        };

        $scope.Instinit = function () {
            $scope.GetAllSites();
            $scope.InstRefresh();
            GetLookupByType("DicomViewer");
            $scope.activeTableTR();  // table row active
        };

        $scope.InstClearFilter = function () {
            $scope.InstSelected.Site = null;
            $scope.InstSelected.Location = null;
            $scope.AllLocations = null;
            $scope.InstitutionName = "";
            $scope.InstPageNo = 1;
            $scope.InstPageSize = "25";
            $scope.InstRefresh();
        };
        $scope.AddInstitution = function () {
            $scope.InstFlagEdit = false;
            $scope.InstAddInstitution.Site = null;
            $scope.InstAddInstitution.Location = null;
            $scope.InstAddInstitution.txtInstitutionName = "";
            $scope.InstAddInstitution.CreateORM = "1";
            $scope.InstAddInstitution.CreateORU = "0";
            $scope.InstDicomViewerList = DicomViewerFullList;
            $scope.InstAddInstitution.ddlDicomViewer = _.filter($scope.InstDicomViewerList, {
                Value: "SYNAPSE"
            })[0];
            $scope.InstAddInstitution.ODicomViewer = [];
            $scope.multiSelectDropdowns.OptionalDV.SelectedValue = {
                list: [],
            };
            $scope.InstAddInstitution.txtDicomViewerURL = __env._environment.config.synapse;
            $scope.InstAddInstitution.DictationSystem = '';
            $scope.InstAddInstitution.txtDelayedSTAT = 0;
            $scope.InstAddInstitution.txtDelayedSTATColor = $scope.DelayedStatColorCode[0].Value;
            $scope.InstAllLocations = [];
            $('#ModalAddEditInstitution').modal('show');
        };
        $scope.EditInstitution = function (Institution) {
            $scope.isLoading = true;
            $scope.InstFlagEdit = true;
            $scope.InstAddInstitution.Site = _.filter($scope.AllSites, {
                SiteID: Institution.SiteID
            })[0];
            var filter = {
                SiteID: $scope.InstAddInstitution.Site.SiteID,
                UserID: $sessionStorage.currentUserData.userId,
            }
            ManageLocationService.GetAllLocations(filter).then(function (result) {
                $scope.InstAllLocations = result;
                $scope.InstAddInstitution.Location = _.filter($scope.InstAllLocations, {
                    LocationID: Institution.LocationID
                })[0];
            });
            $scope.InstAddInstitution.txtInstitutionName = Institution.InstitutionName;
            $scope.InstAddInstitution.CreateORM = Institution.CreateORM == true ? "1" : "0";
            $scope.InstAddInstitution.CreateORU = Institution.CreateORU == true ? "1" : "0";
            //$scope.InstAddInstitution.ddlDicomViewer = Institution.DicomViewer;

            $scope.InstAddInstitution.ddlDicomViewer = _.filter(DicomViewerFullList, { Key: Institution.DicomViewer })[0];
            $scope.InstAddInstitution.ODicomViewer = [];
            if (Institution.OptionalDicomViewer) {

                var dcmsplit = Institution.OptionalDicomViewer.split(",");
                dcmsplit.forEach(function (dcm) {
                    var filterdcm = _.filter(DicomViewerFullList, {
                        //Value: dcm
                        Key: dcm.trim()
                    })[0];
                    if (filterdcm) {
                        $scope.InstAddInstitution.ODicomViewer.push(filterdcm);
                    }
                });
            }
            $scope.multiSelectDropdowns.OptionalDV.SelectedValue = {
                list: _.uniqBy($scope.InstAddInstitution.ODicomViewer, 'ID')
            };
            $scope.InstAddInstitution.txtDicomViewerURL = Institution.DicomViewerURL ? Institution.DicomViewerURL : "";
            $scope.InstAddInstitution.ddlDictationSystem = _.filter($scope.DefaultDictationSystemList, {
                Value: Institution.DictationSystem
            })[0];
            setDafaultDicomViewerURL('Synapse');
            $scope.InstAddInstitution.txtDelayedSTAT = Institution.DelayedStatMins ? Institution.DelayedStatMins : 0;
            $scope.InstAddInstitution.txtDelayedSTATColor = Institution.DelayedStatColorCode ? Institution.DelayedStatColorCode : $scope.DelayedStatColorCode[0].Value;
            $scope.isLoading = false;

            $scope.InstDicomViewerList = [];
            if (Institution.SiteDicomViewer) {
                _.each((Institution.SiteDicomViewer).split(","), function (val) {
                    var viewer = _.find(DicomViewerFullList, { Value: val });
                    if (viewer) {
                        $scope.InstDicomViewerList.push(viewer);
                    }
                });
            }
            else {
                var viewer = _.find(DicomViewerFullList, { Key: Institution.DicomViewer });
                if (viewer) {
                    $scope.InstDicomViewerList.push(viewer);
                }
            }
            $('#ModalAddEditInstitution').modal('show');
        };
        $scope.InstSiteChanged = function (Site) {
            $scope.InstSelected.Location = null;
            $scope.AllLocations = null;
            if (Site) {
                $scope.GetAllLocationsBySite(Site.SiteID);
            }
        };
        $scope.InstAddInstitutionSiteChanged = function (Site) {
            $scope.InstAddInstitution.Location = null;
            $scope.InstDicomViewerList = DicomViewerFullList;
            if (Site) {
                $scope.InstGetAllLocationsBySite(Site.SiteID);
                $scope.InstDicomViewerList = [];
                if (Site.SiteDicomViewer) {
                    _.each((Site.SiteDicomViewer).split(","), function (val) {
                        var viewer = _.find(DicomViewerFullList, { Value: val.trim() });
                        if (viewer) {
                            $scope.InstDicomViewerList.push(viewer);
                        }
                    });
                    $scope.InstAddInstitution.ddlDicomViewer = (_.filter($scope.InstDicomViewerList, { Value: "SYNAPSE" }).length > 0) ? _.filter($scope.InstDicomViewerList, { Value: "SYNAPSE" })[0] : $scope.InstDicomViewerList[0];
                }
            }
            else {
                $scope.InstAddInstitution.Site = null;
                $scope.InstAddInstitution.ddlDicomViewer = _.filter($scope.InstDicomViewerList, { Value: "SYNAPSE" })[0];
            }
            sortDicomViewer();
        };

        $scope.SaveInstitution = function () {
            //console.log($scope.LocAddLocation);
            //$scope.LocRefresh();
            $scope.InstitutionSaved = true;
            var OptionalDV = "";
            $scope.InstAddInstitution.ODicomViewer.forEach(function (viewer) {
                if (OptionalDV != "") {
                    OptionalDV += "," + viewer.Value;
                }
                else {
                    OptionalDV = viewer.Value;
                }
            });
            var institution = {
                SiteID: $scope.InstAddInstitution.Site.SiteID,
                LocationID: $scope.InstAddInstitution.Location.LocationID,
                InstitutionID: $scope.InstFlagEdit ? $scope.SelectedInstitutionID : "-1",
                InstitutionName: $scope.InstAddInstitution.txtInstitutionName,
                CreateORM: $scope.InstAddInstitution.CreateORM == "1" ? "true" : "false",
                CreateORU: $scope.InstAddInstitution.CreateORU == "1" ? "true" : "false",
                ModifyBy: $sessionStorage.currentUserData.userId,
                //DicomViewer: $scope.InstAddInstitution.ddlDicomViewer,
                DicomViewer: $scope.InstAddInstitution.ddlDicomViewer.Value,
                OptionalDicomViewer: OptionalDV,
                DicomViewerURL: $scope.InstAddInstitution.txtDicomViewerURL,
                DictationSystem: $scope.InstAddInstitution.ddlDictationSystem ? $scope.InstAddInstitution.ddlDictationSystem.Value : '',
                DelayedStatMins: $scope.InstAddInstitution.txtDelayedSTAT,
                DelayedStatColorCode: $scope.InstAddInstitution.txtDelayedSTATColor,
            };
            ManageLocationService.CheckInstitutionExists(institution).then(function (result) {
                $scope.InstitutionSaved = false;
                if (result != null && result.length > 0) {
                    toaster.error({ body: "Institution exists with the same name!" });
                    return;
                }
                else {
                    ManageLocationService.AddEditInstitutions(institution).then(function (result) {
                        $scope.InstitutionSaved = false;
                        //$scope.SiteList = result;
                        $('#ModalAddEditInstitution').modal('hide');
                    });
                }
            });
        };
        $("#ModalAddEditInstitution").on('hide.bs.modal', function () {
            //swal('The modal is about to be hidden.');            
            $scope.InstRefresh();
        });
        $scope.DeleteInstitution = function (Institution) {
            var dInstitution = {
                InstitutionID: Institution.InstitutionID,
                ModifyBy: $sessionStorage.currentUserData.userId
            };
            ManageLocationService.DeleteInstitution(dInstitution).then(function (result) {
                toaster.success({ body: "Institution deleted successfully." });
                $scope.InstRefresh();
            });
        };
        $scope.getTechniquesforMapping = function () {
            $scope.TechniqueList = [];
            $scope.SelectedTechniques = [];
            ManageLocationService.GetTechniquesforMapping($scope.SelectedLocationID).then(function (result) {
                $scope.AllTechniqueList = result;
                $scope.TechniqueList = _.filter($scope.AllTechniqueList, function (cl) { return cl.isMapped == false });
                $scope.SelectedTechniques = _.filter($scope.AllTechniqueList, function (cl) { return cl.isMapped == true });
            });
        };
        $scope.moveItem = function (items, type) {
            if (type == 'select') {
                angular.forEach(items, function (item) {
                    var idx = $scope.TechniqueList.indexOf(item);
                    if (idx != -1) {
                        $scope.TechniqueList.splice(idx, 1);
                        $scope.SelectedTechniques.push(item);
                    }
                });
            }
            else {
                angular.forEach(items, function (item) {
                    var idx = $scope.SelectedTechniques.indexOf(item);
                    if (idx != -1) {
                        $scope.SelectedTechniques.splice(idx, 1);
                        $scope.TechniqueList.push(item);
                    }
                });
            }
        };
        $scope.selectAllItem = function () {
            angular.forEach($scope.TechniqueList, function (item) {
                item.isMapped = !item.isMapped;
                $scope.SelectedTechniques.push(item);
                $scope.TechniqueList = [];
            });
        };
        $scope.visibleDicom = function (diacomViewer) {
            var ddlDicomViewerLen = $scope.InstAddInstitution.ddlDicomViewer ? $scope.InstAddInstitution.ddlDicomViewer.Key == diacomViewer : false;

            var ODicomViewerLen = false;
            if ($scope.InstAddInstitution.ODicomViewer) {
                ODicomViewerLen = _.filter($scope.InstAddInstitution.ODicomViewer, {
                    Key: diacomViewer
                }).length > 0;
            }
            return ddlDicomViewerLen || ODicomViewerLen;
        };
        $scope.clearInst = function ($event) {
            $event.stopPropagation();
            var dicomViewer = $scope.InstAddInstitution.ddlDicomViewer;
            $scope.InstAddInstitution.ddlDicomViewer = undefined;
            $scope.diacomViewerURLVisible = $scope.visibleDicom(dicomViewer);
        };
        $scope.onSelectedInst = function (selectedItem) {
            // do selectedItem.PropertyName like selectedItem.Name or selectedItem.Key 
            // whatever property your list has.

        };
        function setDafaultDicomViewerURL(diacomViewer) {
            var ddlDicomViewerLen = $scope.InstAddInstitution.ddlDicomViewer ? $scope.InstAddInstitution.ddlDicomViewer.Key == diacomViewer : false;

            var ODicomViewerLen = false;
            if ($scope.InstAddInstitution.ODicomViewer) {
                ODicomViewerLen = _.filter($scope.InstAddInstitution.ODicomViewer, {
                    Key: diacomViewer
                }).length > 0;
            }
            var visible = true;
            if (!ddlDicomViewerLen && !ODicomViewerLen)
                visible = false;

            if (!visible)
                $scope.InstAddInstitution.txtDicomViewerURL = __env._environment.config.synapse;
        }

        $scope.deselectAll = function () {
            angular.forEach($scope.SelectedTechniques, function (item) {
                item.isMapped = !item.isMapped;
                $scope.TechniqueList.push(item);
                $scope.SelectedTechniques = [];
            });
        };
        $scope.filterTechnique = function () {
            $scope.TechniqueList = _.filter($scope.AllTechniqueList, function (obj) {
                if ($scope.search) {
                    return ((obj.Key).toLowerCase().includes($scope.search.toLowerCase()) && obj.isMapped == false);
                } else {
                    return obj.isMapped == false;
                }
            });
        }

        $scope.filterselectedTechnique = function () {
            $scope.SelectedTechniques = _.filter($scope.AllTechniqueList, function (obj) {
                if ($scope.searchclient) {
                    return ((obj.Key).toLowerCase().includes($scope.searchclient.toLowerCase()) && obj.isMapped == true);
                } else {
                    return obj.isMapped == true;
                }
            });
        }
        $scope.SaveTechnique = function () {
            var formData = {
                LocationId: $scope.SelectedLocationID,
                UserId: $sessionStorage.currentUserData.userId,
                List: $scope.SelectedTechniques
            }
            ManageLocationService.SaveTechnique(formData).then(function (result) {
                toaster.success({ body: "Selected technique has been mapped with " + $scope.LocationName + " location." });
                $('#ModalMapTechnique').modal('hide');
            });
        }
        $scope.clearDictation = function ($event) {
            $event.stopPropagation();
            $scope.InstAddInstitution.ddlDictationSystem = undefined;
        };

        function getDefaultOldOrdersComparisonTime() {
            var OldOrdersComparisonTime = 0;
            if ($scope.OldOrdersComparisonTime && $scope.OldOrdersComparisonTime.length > 0) {
                OldOrdersComparisonTime = calculateComparisonTimeInHours($scope.OldOrdersComparisonTime[0].Value);
            }
            return OldOrdersComparisonTime;
        }

        function calculateComparisonTimeInHours(value) {
            return value / 60;
        }

        function convertHoursToMinute(value) {
            return value * 60;
        }

        $scope.InstResetDelayedSTATColor = function () {
            $scope.InstAddInstitution.txtDelayedSTATColor = $scope.DelayedStatColorCode[0].Value;
        }
        $scope.AssignUserCancel = function () {
            $scope.RadiologistsFullSet = angular.copy(MasterRadiologistsFullSet);
            if ($scope.SavebtnText == 'Save') {
                if ($scope.selectedclientsFullSet.length > 0) {
                    $scope.selectedValues.SelectedRadiologists = [];
                    _.each($scope.selectedclientsFullSet, function (provider) {
                        var obj = _.find($scope.RadiologistsFullSet, { Id: provider.Id });
                        if (obj) {
                            $scope.selectedValues.SelectedRadiologists.push(obj);
                        }
                    });
                }

                else {
                    $scope.selectedValues.SelectedRadiologists = [];
                }
            }
            else {
                if ($scope.selectedclientsFullSet.length > 0) {
                    $scope.selectedValues.SelectedRadiologists = [];
                    _.each($scope.selectedclientsFullSet, function (provider) {
                        var obj = _.find($scope.RadiologistsFullSet, { Id: provider.Id });
                        if (obj) {
                            $scope.selectedValues.SelectedRadiologists.push(obj);
                        }
                    });
                }
                else {
                    $scope.selectedValues.SelectedRadiologists = [];
                }
            }
        }

        function GetAllTimeZones() {
            var d = $q.defer();
            ManageLocationService.GetAllTimeZones().then(function (result) {
                $scope.AllTimeZoneList = result;
                d.resolve();
            }).catch(function () {
                d.reject();
            });
            return d.promise;
        }
        //#endregion Institution Tab

        function sortDicomViewer() {
            $scope.InstDicomViewerList.sort(
                function (a, b) {
                    if (a.Key.toLowerCase() < b.Key.toLowerCase()) return -1;
                    if (a.Key.toLowerCase() > b.Key.toLowerCase()) return 1;
                    return 0;
                }
            );
        }

        $scope.$on('$destroy', function () {
            _.each(TimeoutList, function (timeout) {
                clearTimeout(timeout);
            });
            window.removeEventListener("click", windowClicklistner);
            SiteConfigGridContainer.removeEventListener('focusout', focusOutClicklistner);
            CommonService.stopNotifyTATStudy();
        });

        //grid table
        // Grid API: Access to Grid API methods
        var gridDiv;
        // Grid Options: Contains all of the grid configurations
        var siteConfigGridOptions = {
            columnDefs: [
                {
                    field: "Headers", headerName: "", maxWidth: 100, flex: 1, pinned: 'left', resizable: false, editable: false,
                },
                {
                    field: "CalledAE", headerName: "Called AE", flex: 1,
                    cellRenderer: TLSCellRenderer(),
                    editable: function (params) {
                        return params.data.Headers !== 'TLS';
                    },
                },
                {
                    field: "CallingAE", headerName: "Calling AE", type: "TLSCallinAE", flex: 1,
                    cellRenderer: TLSCellRenderer(),
                    editable: function (params) {
                        return params.data.Headers !== 'TLS';
                    },
                },
                {
                    field: "DestinationAE", headerName: "Destination AE", flex: 1,
                    cellRenderer: TLSCellRenderer(),
                    editable: function (params) {
                        return params.data.Headers !== 'TLS';
                    },
                },
            ],
            suppressClipboardPaste: true,
            defaultColDef: {
                editable: true,
            },
            singleClickEdit: true,
            onCellValueChanged: function (params) {
                if (params.newValue) {
                    params.node.setDataValue(params.colDef.field, params.newValue.trim());
                }
            }
        };
        // Create Grid: Create new grid within the #mySiteConfigGrid div, using the Grid Options object
        function CreateMySiteConfigGrid() {
            gridDiv = document.getElementById("mySiteConfigGrid");
            new agGrid.Grid(gridDiv, siteConfigGridOptions);
        }
        function CreateRowDataSet(siteAppConfigData) {
            var rowData = [];

            var headers = ['Host', 'Port', 'AETitle', 'TLS'];
            return _.map(headers, function (header) {
                var rowObject = {
                    "Headers": header == 'AETitle' ? 'AE Title' : header,
                    "CalledAE": null,
                    "CallingAE": null,
                    "DestinationAE": null,
                };
                if (siteAppConfigData && siteAppConfigData.length > 0) {
                    _.each(siteAppConfigData, function (data) {
                        rowObject[data.AEType] = data[header];
                    });
                }
                else {
                    if (header == 'TLS') {
                        rowObject.CalledAE = false;
                        rowObject.CallingAE = false;
                        rowObject.DestinationAE = false;
                    }
                }
                return rowObject;
            });
        }


        function TLSCellRenderer() {
            function CustomRenderer() {
            }
            CustomRenderer.prototype.init = function (params) {
                var obj = _.cloneDeep(params.data);
                $scope[params.colDef.field] = params;
                this.eGui = document.createElement('div');
                if (params.data.Headers === "TLS") {
                    var tlsScopeKey = '__tlsVal_' + params.colDef.field;
                    this.$scope1 = $scope.$new();
                    this.$scope1[tlsScopeKey] = !!params.value;

                    this.eGui.className = 'd-flex align-item-center mt-3px';
                    var label = document.createElement('label');
                    label.className = 'checkbox-switch pref-checkbox mb-0';
                    var input = document.createElement('input');
                    input.type = 'checkbox';
                    input.className = 'mr-2px';
                    input.setAttribute('ng-click', "toggleTLS(this['" + params.colDef.field + "'])");
                    input.setAttribute('ng-checked', tlsScopeKey);
                    var slider = document.createElement('span');
                    slider.className = 'checkbox-switch-slider round';
                    label.appendChild(input);
                    label.appendChild(slider);
                    this.eGui.appendChild(label);
                }
                else {
                    this.eGui.textContent = params.value;
                }
                if (!this.$scope1) {
                    this.$scope1 = $scope.$new();
                }
                $compile(this.eGui)(this.$scope1);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                setTimeout(this.$scope1.$apply.bind(this.$scope1), 0);
            };
            CustomRenderer.prototype.getGui = function () {
                return this.eGui;
            };
            CustomRenderer.prototype.destroy = function () {
            };
            return CustomRenderer;
        }

        $scope.toggleTLS = function (params) {
            var rowNode = siteConfigGridOptions.api.getRowNode(3);
            var field = params.colDef.field;
            var data = rowNode.data;
            data[field] = !rowNode.data[field]
            rowNode.updateData(data);
        }

        function RowDataToObject() {
            var transformedObject = [];
            _.each(["CalledAE", "CallingAE", "DestinationAE"], function (aeType, index) {
                var SiteApp = _.find($scope.SiteApplication.Data, { AEType: aeType });
                var obj = { SiteApplicationEntityID: SiteApp ? SiteApp.SiteApplicationEntityID : null, AEType: aeType };

                siteConfigGridOptions.api.forEachNode(function (node) {
                    node.data.Headers = (node.data.Headers == 'AE Title') ? 'AETitle' : node.data.Headers;
                    obj[node.data.Headers] = node.data[aeType];
                });
                transformedObject.push(obj);
            });
            return transformedObject;
        }

        function allRowsHaveData(gridApi) {
            var invalidHeaders = [];
            var allRowsContainData = [];
            gridApi.api.forEachNode(function (item, index) {
                var data = item.data;
                if (data.Headers !== "TLS") {
                    var attributes = [data.CalledAE, data.CallingAE, data.DestinationAE];
                    var allEmpty = _.every(attributes, function (attr) {
                        return !attr;
                    });
                    var allPresent = _.every(attributes, function (attr) {
                        return attr != null && attr != "";
                    });

                    if ((allEmpty && !allPresent) || (!allEmpty && !allPresent)) {
                        invalidHeaders.push(data.Headers);
                    }
                    if (allEmpty) {
                        allRowsContainData.push([data.Headers]);
                    }
                }
            });

            return {
                allRowsEmpty: allRowsContainData.length == 3 ? true : false,
                invalidData: invalidHeaders.length > 0 ? true : false,
            };
        };
        //#region Get / Set Application Entity
        function GetSiteApplicationEntity(SiteID) {
            var d = $q.defer();
            ManageLocationService.GetSiteApplicationEntity({ SiteID: SiteID }).then(function (result) {
                d.resolve(result);
            });
            return d.promise;
        }

        function SetSiteApplicationEntity(SiteID, Flag) {
            var d = $q.defer();

            var siteAppObj = {
                SiteID: SiteID,
                UserID: $sessionStorage.currentUserData.userId,
                Flag: Flag,
                SiteApplicationEntity: RowDataToObject(),// Convert Row Data to Object
            };
            ManageLocationService.SetSiteApplicationEntity(siteAppObj).then(function () {
                d.resolve();
            });
            return d.promise;
        }
        //#endregion Get / Set Application Entity
        CreateMySiteConfigGrid();

        function GetModality() {
            var d = $q.defer();
            WorklistService.GetModality().then(function (result) {
                $scope.Modalities = result;
                d.resolve();
            });
            return d.promise;
        };


        //#region Prefix-Suffix mapping
        function initPrefixSuffixGrid() {
            var gridDiv = document.querySelector('#PrefixSuffixGrid');
            if (gridDiv && PrefixSuffixGridOptions && !(PrefixSuffixGridOptions.api)) {
                new agGrid.Grid(gridDiv, PrefixSuffixGridOptions);
            }
        }
        var addNewRowTxt = "Add New";
        var rowId = -1;
        var PrefixSuffixGridOptions = {
            columnDefs: [
                {
                    field: 'Prefix',
                    editable: function (params) {
                        return (params.data.Prefix != addNewRowTxt);
                    },
                    cellEditorPopup: true,
                    autoHeight: true,
                    cellEditor: prefixEditor(),
                    cellRenderer: function (params) {
                        if (params.data.Prefix != addNewRowTxt) {
                            return params.data.Prefix;
                        } else {
                            return '<span class="fw-600"><i class="fa fa-plus"></i> ' + params.data.Prefix + '</span>';
                        }

                    },
                    flex: 1,
                    autoWidth: true,

                },
                {
                    field: 'Suffix',
                    editable: function (params) {
                        return (params.data.Prefix != addNewRowTxt);
                    },
                    cellEditorPopup: true,
                    autoHeight: true,
                    cellEditor: suffixEditor(),
                    cellRenderer: function (params) {
                        return params.data.Suffix;
                    },
                    flex: 1,
                    autoWidth: true,
                },
                {
                    field: 'Action',
                    headerName: "",
                    width: 30,
                    cellRenderer: function (params) { return (params.data.Prefix != addNewRowTxt) ? '<i class="fa fa-trash-o txt-clr-31 cursor-pointer fs-16px" aria-hidden="true" title="Delete"></i>' : ''; }
                }
            ],
            //rowHeight: 25,
            defaultColDef: {
                sortable: false,
                lockVisible: true,
                suppressMovable: true,
                suppressMenu: true,
                resizable: false
            },
            suppressClickEdit: true,
            getContextMenuItems: function () { return [] },
            rowData: [],

            onGridReady: function (params) {
                params.api.setPinnedBottomRowData([{
                    Prefix: addNewRowTxt,
                    Suffix: "",
                    rowColor: "#1c1c1c"
                }]);
            },
            getRowStyle: function (params) {
                if (params && params.data && params.data.rowColor) {
                    return {
                        /*paddingTop: '4px',*/
                        background: params.data.rowColor
                    };
                }
            },
            getRowId: function (params) {
                rowId++;
                if (params && params.data && !params.data.hasOwnProperty('ID')) {
                    params.data.ID = rowId.toString();
                }
                if (params.data.hasOwnProperty('ID')) {
                    return params.data.ID;
                }
            },
            onCellClicked: function (params) {
                params.api.stopEditing();
                if (params.column.colId != 'Action') {
                    if (params.data.Prefix == addNewRowTxt) {
                        var renderedRows = params.api.getRenderedNodes();
                        if (renderedRows.length <= 5) {
                            AddNewGridRow();
                        } else {
                            toaster.warning("No Additional Rows Can Be Added!")
                        }
                    }
                    else {
                        params.api.startEditingCell({
                            rowIndex: params.rowIndex,
                            colKey: params.column.colId
                        });
                    }
                } else {
                    RemoveSitePrefixSuffix(params.data);
                }
            },
            onCellEditingStarted: function (params) {
                if (params.column.colId == "Prefix" && $(".prefix-editor")) {
                    $(".prefix-editor").focus();
                }
                else if (params.column.colId == "Suffix" && $(".suffix-editor")) {
                    $(".suffix-editor").focus();
                }
            }
        }

        function AddNewGridRow() {
            if (PrefixSuffixGridOptions && PrefixSuffixGridOptions.api) {
                PrefixSuffixGridOptions.api.stopEditing();
                PrefixSuffixGridOptions.api.applyTransaction({
                    add: [{
                        Prefix: "",
                        Suffix: ""
                    }],
                });
            }
        }
        function prefixEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                $scope.DataObject.PrefixInput = params.data.Prefix;
                this.eGui = document.createElement('div');
                this.eGui.className = ""
                this.eGui.innerHTML = '<input class="prefix-editor" placeholder="" style="color: #fff;" type="text" ng-model="DataObject.PrefixInput" />';

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                var PrefixInput = $scope.DataObject.PrefixInput;
                $scope.DataObject.PrefixInput = "";
                return PrefixInput;
            }
            return CustomEditor;
        }
        function suffixEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                $scope.DataObject.SuffixInput = params.data.Suffix;
                this.eGui = document.createElement('div');
                this.eGui.className = ""
                this.eGui.innerHTML = '<input class="suffix-editor" placeholder="" style="color: #fff;" type="text" ng-model="DataObject.SuffixInput" />';

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                var SuffixInput = $scope.DataObject.SuffixInput;
                $scope.DataObject.SuffixInput = "";
                return SuffixInput;
            }
            return CustomEditor;
        }

        window.addEventListener("click", windowClicklistner);
        function windowClicklistner(event) {
            if (event && event.target && event.target.classList) {
                var prefixEditor = event.target.closest(".prefix-editor");
                var suffixEditor = event.target.closest(".suffix-editor");
                if (!prefixEditor && !suffixEditor) {
                    if (PrefixSuffixGridOptions && PrefixSuffixGridOptions.api) {
                        PrefixSuffixGridOptions.api.stopEditing();
                    }
                }

                var patientClassEditor = event.target.closest(".fax-patientclass-editor");
                var faxNameEditor = event.target.closest(".fax-name-editor");
                var faxNumberEditor = event.target.closest(".fax-number-editor");
                if (!patientClassEditor && !faxNameEditor && !faxNumberEditor) {
                    if (FaxDetailsGridOptions && FaxDetailsGridOptions.api) {
                        FaxDetailsGridOptions.api.stopEditing();
                    }
                }
            }
        }
        var SiteConfigGridContainer = document.querySelector('#mySiteConfigGrid');
        SiteConfigGridContainer.addEventListener('focusout', focusOutClicklistner);
        function focusOutClicklistner(event) {
            if (!SiteConfigGridContainer.contains(event.relatedTarget)) {
                if (siteConfigGridOptions && siteConfigGridOptions.api) {
                    siteConfigGridOptions.api.stopEditing();
                }
            }
        }
        function SetSitePrefixSuffix(SiteID) {
            var d = $q.defer();
            var params = {
                Flag: 'I',
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: SiteID
            };
            var SitePrefixSuffix = [];

            PrefixSuffixGridOptions.api.forEachNode(function (node) {
                if (node.data) {
                    var obj = {};
                    obj.Prefix = (node.data.Prefix) ? node.data.Prefix : null;
                    obj.Suffix = (node.data.Suffix) ? node.data.Suffix : null;
                    if (node.data.SitePrefixSuffixID) {
                        params.Flag = 'U';
                        obj.SitePrefixSuffixID = node.data.SitePrefixSuffixID;
                    }
                    if (obj.Prefix || obj.Suffix) {
                        SitePrefixSuffix.push(obj);
                    }
                }
            });
            params.SitePrefixSuffix = SitePrefixSuffix;
            if (SitePrefixSuffix.length > 0) {
                ManageLocationService.SetSitePrefixSuffix(params).then(function (res) {
                    d.resolve();
                }, function () {
                    d.reject();
                });
            } else {
                d.resolve();
            }
            return d.promise;
        }

        function RemoveSitePrefixSuffix(data) {

            var d = $q.defer();
            var params = {
                Flag: 'D',
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: $scope.SelectedSiteID
            };
            params.SitePrefixSuffix = [];
            if (data.Prefix || data.Suffix) {
                params.SitePrefixSuffix.push(data);
            }
            if (params.SitePrefixSuffix.length > 0) {
                ManageLocationService.SetSitePrefixSuffix(params).then(function (res) {
                    PrefixSuffixGridOptions.api.applyTransaction({
                        remove: [{ ID: data.ID }]
                    });
                    d.resolve();
                }, function () {
                    d.reject();
                });
            } else {
                d.resolve();
            }
            return d.promise;
        }

        $scope.onSelectedOptionalDV = function (selectedData) {
            $scope.InstAddInstitution.ODicomViewer = selectedData;
        }

        function getAllDevice() {
            ManageLocationService.GetDeviceData().then(function (result) {
                if (result.devices.length > 0) {
                    $scope.PrtgDeviceList = result.devices;

                }
            });
        }

        //#endregion Prefix-Suffix mapping
        //#region Fax Details Grid
        var faxDetailsColDef = [
            {
                field: 'DefaultNum', headerName: 'Default',
                checkboxSelection: true,
                suppressMenu: true,
                minWidth: 60,
                maxWidth: 60,
                editable: false,
            },
            {
                field: 'FaxName', headerName: 'Fax Name',
                suppressMenu: true,
                cellRenderer: function (params) {
                    if (params && params.data && params.data.isAddNewRow) {
                        return '<span class="fw-600"><i class="fa fa-plus"></i> ' + params.data.FaxName + '</span>';
                    }
                    else {
                        return params.data.FaxName;
                    }
                },
                cellEditorParams: {
                    // Callback when editor is created
                    onEditorCreated: function (params) {
                        // Access the editor's DOM element and add a custom class
                        var editorElement = params.eGridCell.querySelector('input');
                        if (editorElement) {
                            editorElement.classList.add('fax-name-editor');
                        }
                    }
                }
            },
            {
                field: 'FaxNumber', headerName: 'Fax Number',
                cellRenderer: function (params) {
                    return params.data.FaxNumber;
                },
                cellEditor: faxNumberCellEditor(),
                cellEditorPopup: true,
            },
            {
                field: 'PatientClass', headerName: 'Patient Class',
                cellEditor: patientClassCellEditor(),
                cellEditorPopup: true,
                cellRenderer: function (params) {
                    return params.data.PatientClass;
                },
            },
            {
                field: 'Action', headerName: '',
                editable: false,
                maxWidth: 30,
                cellRenderer: function (params) {
                    if (params && params.data && !params.data.isAddNewRow) {
                        return '<i class="fa fa-trash-o txt-clr-31 cursor-pointer fs-16px" aria-hidden="true" title="Delete"></i>';
                    }
                }
            },
        ]
        var rowId = 0;
        var FaxDetailsGridOptions = {
            columnDefs: faxDetailsColDef,
            rowSelection: 'single',
            suppressRowClickSelection: true,
            rowHeight: 30,
            defaultColDef: {
                sortable: false,
                lockVisible: true,
                suppressMovable: true,
                suppressMenu: true,
                resizable: false,
                editable: function (params) {
                    return (params && params.data && !params.data.isAddNewRow)
                },
                flex: 1,
            },
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getContextMenuItems: function () { return [] },
            rowData: [],
            onGridReady: function (params) {
                params.api.setPinnedBottomRowData([{
                    FaxName: 'Add New Details',
                    FaxNumber: '',
                    PatientClass: '',
                    isAddNewRow: true,
                    rowColor: "#1c1c1c"
                }]);
            },
            getRowStyle: function (params) {
                if (params && params.data && params.data.isAddNewRow) {
                    return {
                        paddingTop: '0',
                        background: params.data.rowColor
                    };
                }
            },
            getRowId: function (params) {
                rowId++;
                if (params && params.data && !params.data.hasOwnProperty('ID')) {
                    params.data.ID = rowId.toString();
                }
                return params.data.ID;
            },
            onCellEditingStopped: function (params) {
                if (params.column.colId == "PatientClass") {
                    $scope.DataObject.SelectedFaxPatientClass = null;
                }
            },
            onCellClicked: function (params) {
                params.api.stopEditing();
                if (params.data.isAddNewRow) {
                    AddNewGridFaxDetail();
                }
                else {
                    if (params.column.colId == 'Action') {
                        RemoveFaxDetail(params.data);
                    }
                    else {
                        params.api.startEditingCell({
                            rowIndex: params.rowIndex,
                            colKey: params.column.colId
                        });
                    }
                }
            },
        }
        function patientClassCellEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                $scope.DataObject.SelectedFaxPatientClass = _.find($scope.DataObject.PatientClassList, { Key: params.data.PatientClass });
                this.eGui.className = "fax-patientclass-editor";
                this.eGui.innerHTML =
                    '<ui-select class="viewer-editor mult-select provider-select seltype-drop mob-closekeypad" ng-model="DataObject.SelectedFaxPatientClass" on-select="onSelectPatientClass();" append-to-body="true" allow-clear="true">' +
                    '<ui-select-match placeholder="Select Patient Class" class="fax-patientclass-editor">' +
                    '{{$select.selected.Key}}' +
                    '</ui-select-match>' +
                    '<ui-select-choices repeat="pc in DataObject.PatientClassList | filter: {Key: $select.search} track by $index"> ' +
                    '<div ng-bind-html="pc.Key | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>';

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                var val = "";
                if ($scope.DataObject.SelectedFaxPatientClass && $scope.DataObject.SelectedFaxPatientClass.Value) {
                    val = $scope.DataObject.SelectedFaxPatientClass.Key;
                }
                return val;
            }
            return CustomEditor;
        }
        function faxNumberCellEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                $scope.DataObject.FaxNumInput = params.data.FaxNumber;
                //$scope.DataObject.SelectedFaxPatientClass = _.find($scope.DataObject.PatientClassList, { Key: params.data.PatientClass });
                this.eGui.className = "fax-number-editor";
                this.eGui.innerHTML = '<input ng-model="DataObject.FaxNumInput" class="ag-input-field-input ag-text-field-input" ui-mask="(999) 999-9999" type="text" aria-label="Input Editor">';

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                return ($scope.DataObject.FaxNumInput) ? $scope.DataObject.FaxNumInput :"";
            }
            return CustomEditor;
        }

        $scope.onSelectPatientClass = function () {
            console.log("onSelectPatientClass > ", $scope.DataObject.SelectedFaxPatientClass);
        }
        function initFaxDetailsGrid() {
            var gridDiv = document.querySelector('#FaxDetailsGrid');
            if (gridDiv && FaxDetailsGridOptions && !(FaxDetailsGridOptions.api)) {
                new agGrid.Grid(gridDiv, FaxDetailsGridOptions);
            }
        }
        function AddNewGridFaxDetail() {
            if (FaxDetailsGridOptions && FaxDetailsGridOptions.api) {
                FaxDetailsGridOptions.api.applyTransaction({
                    add: [{
                        FaxName: '',
                        FaxNumber: '',
                        PatientClass: ''
                    }],
                });
            }
        }
        function RemoveFaxDetail(data) {
            if (FaxDetailsGridOptions && FaxDetailsGridOptions.api) {
                FaxDetailsGridOptions.api.applyTransaction({
                    remove: [{ ID: data.ID }]
                });
            }
        }
        function SetLocationFaxMapping(locationID) {
            var d = $q.defer();
            var params = {
                LocationID: locationID,
                CreatedBy: $sessionStorage.currentUserData.userId,
                faxDetails: []
            };
            var isFaxnumberAndDetailsAdded = true;
            if (FaxDetailsGridOptions && FaxDetailsGridOptions.api) {
                FaxDetailsGridOptions.api.stopEditing();
                FaxDetailsGridOptions.api.forEachNode(function (node) {
                    if (node.data) {
                        if ((node.data.FaxNumber && !node.data.FaxName) || (!node.data.FaxNumber && node.data.FaxName)) {
                            isFaxnumberAndDetailsAdded = false;
                        }
                        else if (node.data.FaxName && node.data.FaxNumber) {
                            params.faxDetails.push({
                                FaxName: node.data.FaxName,
                                FaxNumber: node.data.FaxNumber,
                                PatientClass: node.data.PatientClass,
                                IsDefault: node.selected
                            });
                        }
                    }
                });
                if (isFaxnumberAndDetailsAdded) {
                    ManageLocationService.SetLocationFaxMapping(params).then(function (res) {
                        d.resolve();
                    }, function () {
                        d.reject();
                    });
                }
                else {
                    toaster.warning("Please Add Fax Number And Fax Name");
                    d.reject();
                }
            }
            else {
                d.resolve();
            }
            return d.promise;
        }
        function GetLocationFaxMapping(LocationID) {
            var d = $q.defer();
            var params = {
                LocationID: LocationID
            };
            ManageLocationService.GetLocationFaxMapping(params).then(function (res) {
                if (res && res.length > 0) {
                    FaxDetailsGridOptions.api.setRowData(res);
                    FaxDetailsGridOptions.api.forEachNode(function (node) {
                        if (node.data && node.data.IsDefault) {
                            node.setSelected(true);
                        }
                    });
                }
                else {
                    FaxDetailsGridOptions.api.setRowData([]);
                }
                d.resolve();
            }, function () {
                d.reject();
            });
            return d.promise;
        }

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
        pageInit();
    }
})();

angular.module('radico.pages.settings.managelocation')
    .service('ManageLocationService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS, __env) {
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }

        this.GetSites = function (siteFilter) {
            return Restangular.one('Settings').one("GetSites").customPOST(siteFilter);
        };        
        this.GetAllSites = function (UserID) {
            return Restangular.one('Settings').one("GetAllSites", UserID).get();
        };       
        this.CheckSiteExists = function (sitelist) {
            return Restangular.one('Settings').one("CheckSiteExists").customPOST(sitelist);
        };
        this.CheckSiteMapping = function (siteID) {
            return Restangular.one('Settings').one("CheckSiteMapping", siteID).get();
        };        
        this.AddEditSite = function (sitelist) {
            return Restangular.one('Settings').one("AddEditSite").customPOST(sitelist);
        };
        this.DeleteSite = function (sitelist) {
            return Restangular.one('Settings').one("DeleteSite").customPOST(sitelist);
        };
        this.GetAllRadiologists = function () {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/RadFlowGetUsers ',
                headers: { 'content-type': 'application/json' }
            });
        };
        this.GetUserBySite = function (data) {
            return Restangular.one('user').one("GetUserBySite").customPOST(data);
        };

        
        this.GetLocations = function (locationFilter) {
            return Restangular.one('Settings').one("GetLocations").customPOST(locationFilter);
        };
        this.GetAllLocations = function (data) {
            return Restangular.one('Settings').one("GetAllLocations").customPOST(data);
        };       
        this.CheckLocationExists = function (locationlist) {
            return Restangular.one('Settings').one("CheckLocationExists").customPOST(locationlist);
        };
        this.CheckLocationMapping = function (locationID) {
            return Restangular.one('Settings').one("CheckLocationMapping", locationID).get();
        };
        this.AddEditLocation = function (locationlist) {
            return Restangular.one('Settings').one("AddEditLocation").customPOST(locationlist);
        };
        this.DeleteLocation = function (locationlist) {
            return Restangular.one('Settings').one("DeleteLocation").customPOST(locationlist);
        };


        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };
        this.GetInstitution = function (institutionFilter) {
            return Restangular.one('Settings').one("GetInstitution").customPOST(institutionFilter);
        };
        this.CheckInstitutionExists = function (institutionList) {
            return Restangular.one('Settings').one("CheckInstitutionExists").customPOST(institutionList);
        };        
        this.AddEditInstitutions = function (institutionList) {
            return Restangular.one('Settings').one("AddEditInstitutions").customPOST(institutionList);
        };
        this.DeleteInstitution = function (Institution) {
            return Restangular.one('Settings').one("DeleteInstitutions").customPOST(Institution);
        };
        this.GetAllDicomViewerCredentials = function (objFilter) {
            return Restangular.one('psorders').one("GetAllDicomViewerCredentials").customPOST(objFilter);
        };
        this.GetTechniquesforMapping = function (locationId) {
            return Restangular.one('Settings').one("GetTechniquesforMapping", locationId).get();
        };
        this.SaveTechnique = function (formData) {
            return Restangular.one('Settings').one("SaveTechnique").customPOST(formData);
        };
        this.GetTenantsByUserID = function (filter) {
            return Restangular.one('Settings').one("GetTenantsByUserID").customPOST(filter);
        };
        this.GetAllTimeZones = function () {
            return Restangular.one('Settings').one("GetAllTimeZones").customPOST();
        };
        this.CheckInstitutionMapping = function (params) {
            return Restangular.one('Settings').one("CheckInstitutionMapping").customPOST(params);
        };

        this.GetSiteApplicationEntity = function (params) {
            return Restangular.one('Settings').one("GetSiteApplicationEntity").customPOST(params);
        };
        this.SetSiteApplicationEntity = function (params) {
            return Restangular.one('Settings').one("SetSiteApplicationEntity").customPOST(params);
        };
        this.SetSitePrefixSuffix = function (params) {
            return Restangular.one('Settings').one("SetSitePrefixSuffix").customPOST(params);
        };
        this.GetSitePrefixSuffix = function (params) {
            return Restangular.one('Settings').one("GetSitePrefixSuffix").customPOST(params);
        };
        this.GetDeviceData = function () {
            return Restangular.one('Settings').one("GetDeviceData").get();
        };
        this.SetLocationFaxMapping = function (params) {
            return Restangular.one('Settings').one("SetLocationFaxMapping").customPOST(params);
        };
        this.GetLocationFaxMapping = function (params) {
            return Restangular.one('Settings').one("GetLocationFaxMapping").customPOST(params);
        };
        this.SetTenantDicomViewerSetting = function (params) {
            return Restangular.one('Settings').one("SetTenantDicomViewerSetting").customPOST(params);
        };
        this.GetTenantDicomViewerSetting = function (params) {
            return Restangular.one('Settings').one("GetTenantDicomViewerSetting").customPOST(params);
        };
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.settings.mapping')
        .controller('MappingController', MappingController);
    function MappingController($scope, MappingService, $q, toaster, $timeout, PaymentContractService, $sessionStorage, $filter, CommonService, SharedService) {
        $scope.DataObject = {
            SiteList: [],
            MappedCPTWRVUList: [],
            SiteMultiSelectFilter: {
                divId: "SiteMultiSelectFilter",
                keys: ['Site'],
                uniqKey: 'SiteID',
                placeHolder: "Select Site(s)",
                SelectedValue: { list: [] },

                SelectedCPT: null,
                SelectedProcedure: null,
                ShowEmptyCustomwRVU: false,
                tooltip: "Select Site(s)",
                onChange: function (selectedData) {
                    var tooltip = "";
                    _.each(selectedData, function (obj) {
                        if (obj.Site) {
                            tooltip = (tooltip == "") ? obj.Site : tooltip + "\n" + obj.Site;
                        }
                    });
                    $scope.DataObject.SiteMultiSelectFilter.tooltip = (tooltip == "") ? "Select Site(s)" : tooltip;
                }
            },
            SiteCPTCustomwRVUList: { list: [] },
            isCustomwRVUGridLoading: false,
        }
        $scope.currentTab = {
            ProcedureSpecialityMapping: false,
            CPTProcedureMapping: false,
            ReadingProviderMapping: false,
            customwRVUTab: true
        };
        $scope.changeTab = function (tab) {
            $scope.currentTab = {
                ProcedureSpecialityMapping: false,
                CPTProcedureMapping: false,
                ReadingProviderMapping: false,
                customwRVUTab: false,
                OrderingPhysician: false,
            };
            switch (tab) {
                case 'ProcedureSpecialityMapping':
                    getProcedure(null);
                    getSpeciality();
                    getProcedureSpeciality();
                    $scope.currentTab.ProcedureSpecialityMapping = true;
                    break;
                case 'CPTProcedureMapping':
                    $scope.currentTab.CPTProcedureMapping = true;
                    GetCPTData();
                    break;
                case 'ReadingProviderMapping':
                    $scope.currentTab.ReadingProviderMapping = true;
                    break;
                case 'CustomwRVU':
                    $scope.currentTab.customwRVUTab = true;
                    clearCustomwRVUTabData();
                    initCustomwRVUGrid();
                    break;
                case 'OrderingPhysician':
                    $scope.currentTab.OrderingPhysician = true;
                    break;
            }
        }

        var activeTableTRTimeout;
        var CPTGridTimeout;
        ///------------------------------- Site Tab -----------------------------------------------------------------------
        $scope.PageNo = 1;
        $scope.PageSize = "25";
        $scope.TotalRows = "";
        $scope.FlagEdit = false;
        $scope.sProcedure = {};
        $scope.sSpeciality = {};
        $scope.Procedure = {};
        $scope.Speciality = {};
        $scope.Modalmps = {};
        $scope.Id = 0;
        $scope.halfScale = $(window).width() < 1199;


        function initPage() {
            CommonService.startNotifyTATStudy();
            GetSitesAndLocation().then(function () {
                GetCPTData();
                $scope.changeTab("CustomwRVU");
            });
            activeTableTR();  // table row active
        }
        // JS for table row active
        function activeTableTR() {
            angular.element(document).ready(function () {
                activeTableTRTimeout = $timeout(function () {
                    angular.element(".common-tbl table tr").click(function () {
                        if (angular.element(this).data('clicked', true)) {
                            angular.element(".common-tbl table tr").removeClass('tr-active');
                            angular.element(this).addClass('tr-active');
                        }
                    });
                }, 500);
            });
        }

        //#region Procedure-Speciality Mapping
        function getProcedure(search) {
            var Filter = {
                Search: search
            };
            MappingService.GetProcedure(Filter).then(function (result) {
                $scope.ProcedureList = result;
            });
        }
        function getSpeciality() {
            $scope.isLoading = true;
            MappingService.GetSpeciality().then(function (result) {
                $scope.SpecialityList = result;
                $scope.isLoading = false;
            });
        }
        function getProcedureSpeciality() {
            $scope.isLoading = true;
            $scope.ProcedureSpecialityMapFilter = {
                PageNum: $scope.PageNo,
                PageSize: $scope.PageSize,
                ProcedureId: ($scope.sProcedure.Code) ? $scope.sProcedure.Code.ProcedureID : null,
                SpecialityId: ($scope.sSpeciality.Code) ? $scope.sSpeciality.Code.SpecialityId : null
            };
            MappingService.GetProcedureSpeciality($scope.ProcedureSpecialityMapFilter).then(function (result) {
                $scope.ProcedureSpecialityList = result;
                if (result != null && result.length > 0) {
                    $scope.TotalRows = result[0].TotalRec;
                }
                else {
                    $scope.TotalRows = "0";
                }
                $scope.isLoading = false;
            });
        }

        $scope.checkLoadProcedureList = function (val) {
            getProcedure(val);
        };
        $scope.refresh = function () {
            getProcedureSpeciality();
        };
        $scope.pageSizeChanged = function () {
            getProcedureSpeciality();
        };
        $scope.PageNoChanged = function () {
            getProcedureSpeciality();
        };
        $scope.ClearFilter = function () {
            $scope.sProcedure = {};
            $scope.sSpeciality = {};
            $scope.PageNo = 1;
            $scope.PageSize = "25";
            getProcedureSpeciality();
        };

        $scope.setSelected = function (SelectedSiteID) {
            $scope.SelectedSiteID = SelectedSiteID;
        };
        $scope.EditProcedureSpeciality = function (ps) {
            $scope.Id = ps.MapId;
            $scope.ProcedureID = ps.ProcedureId;
            $scope.SpecialityId = ps.SpecialityId;

            $scope.isLoading = true;
            $q.all([
                GetProcedureByProcedureID(ps.ProcedureId),
                GetSpecialityBySpecialityID(ps.SpecialityId)
            ]).then(function (data) {
                $scope.reportList = [];
                if (data != null && data[0] != null && data[0].route == "GetProcedureByProcedureID" && data[0].length > 0) {
                    $scope.Modalmps.Procedure = data[0][0];
                }
                if (data != null && data[1] != null && data[1].route == "GetSpecialityBySpecialityID" && data[1].length > 0) {
                    $scope.Modalmps.Speciality = data[1][0];
                }
                $scope.isLoading = false;
            });
            $('#ModalMapProcedureSpeciality').modal('show');
        };
        $scope.MapProcedureSpeciality = function () {
            clearControl();
            $('#ModalMapProcedureSpeciality').modal('show');
        };
        $scope.DeleteProcedureSpeciality = function (MapId) {
            swal({
                title: 'Are you sure, you want to delete this record?',
                //text: 'Are you sure you want delete this record?',
                type: "warning",
                html: true,
                customClass: 'swal-wide',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55", confirmButtonText: "Yes",
                cancelButtonText: "No",
            },
                function (isConfirm) {
                    if (isConfirm) {
                        var filter = {
                            MapId: MapId
                        };
                        MappingService.DeleteProcedureSpeciality(filter).then(function (result) {
                            toaster.success({ body: "Procedure and specialty mapping deleted successfully." });
                            getProcedureSpeciality();
                        });
                    }
                });
        };

        $scope.Save = function () {
            var filter = {
                MapId: $scope.Id,
                ProcedureId: $scope.Modalmps.Procedure.ProcedureID,
                SpecialityId: $scope.Modalmps.Speciality.SpecialityId
            };
            MappingService.AddEditMapping(filter).then(function (result) {
                toaster.success({ body: result });
                if (result.match('success')) {
                    $('#ModalMapProcedureSpeciality').modal('hide');
                    getProcedureSpeciality();
                    clearControl();
                }

            });
        };
        function clearControl() {
            $scope.Id = 0;
            $scope.Modalmps.Procedure = null;
            $scope.Modalmps.Speciality = null;
        }
        function GetProcedureByProcedureID(search) {
            var d = $q.defer();
            var Filter = {
                ProcedureID: search
            };
            MappingService.GetProcedureByProcedureID(Filter).then(function (result) {
                d.resolve(result);
            });
            return d.promise;
        };
        function GetSpecialityBySpecialityID(search) {
            var d = $q.defer();
            var Filter = {
                SpecialityID: search
            };
            MappingService.GetSpecialityBySpecialityID(Filter).then(function (result) {
                d.resolve(result);
            });
            return d.promise;
        };
        //#endregion Procedure-Speciality Mapping

        //#region Procedure CPT Mapping

        var cpmPageNo = 1;
        var cpmPageSize = 40;
        var cpmTotalRows = 0;
        var CPTProcedureList = [];
        var CPTRowID = 0;
        $scope.cpmProcedure = {};
        $scope.cpmCPT = {};
        $scope.CPTMapStatusOptions = [
            { value: "All", key: "All" },
            { value: "Mapped", key: "Mapped CPT" },
            { value: "Unmapped", key: "Unmapped CPT" },
        ]
        $scope.CPTMapStatus = { Obj: _.find($scope.CPTMapStatusOptions, function (item) { return item.value == "Unmapped" }) };
        $scope.MasterData = { Radiologists: null, Sites: null, Locations: null };
        $scope.ProcCPTMapCsvFile = [];
        $scope.CSVFileName = null;
        $scope.loadProcCPTMap = false;
        $scope.disableProcCPTFilter = false;
        $scope.ShowEmptyCustomwRVU = { Obj: null };
        $scope.SelectedLocations = {
            Ids: '',
            locations: [],
            divId: "MappingPage"
        }

        function GetCPTData() {
            clearCPTData();
            GetCPTList(null);
            activeTableTR();   // table row active
            CPTGridTimeout = $timeout(function () {
                var gridDiv = document.querySelector('#cptAgGrid');
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, CPTGridOptions);

                    var PageTopHeight = document.querySelector('.page-top').offsetHeight;
                    var MappingHeaderHeight = document.querySelector('#MappingHeader').offsetHeight;
                    var mappingNavHeight = document.querySelector('#mappingNav').offsetHeight;
                    var CPTFilterPanelHeight = document.querySelector('#CPTFilterPanel').offsetHeight;
                    $scope.CPTGridHeight = innerHeight - PageTopHeight - MappingHeaderHeight - mappingNavHeight - CPTFilterPanelHeight;
                }
            }, 200)

        };

        /** localDate expects "YYYY-MM-DD HH:mm:ss" style; API/Dapper often returns culture-specific datetime strings. */
        function normalizeDateStringForLocalDateFilter(raw) {
            if (raw == null || raw === '') {
                return '';
            }
            if (angular.isDate(raw)) {
                return isNaN(raw.getTime()) ? '' : moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'number' && isFinite(raw)) {
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'string') {
                var parsed = moment(raw.trim());
                return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : '';
            }
            return '';
        }

        function formatMappingLastModifiedCell(paramsValue) {
            var normalized = normalizeDateStringForLocalDateFilter(paramsValue);
            if (!normalized) {
                return '';
            }
            return $filter('localDate')(normalized, false, new Date()) || '';
        }

        //#region CPT AgGrid
        var cptColumnDefs = [
            { field: 'Site', headerName: 'Site', initialWidth: 200 },
            { field: 'ProcedureCode', headerName: 'Procedure Code', initialWidth: 200 },
            { field: 'ProcedureDesc', headerName: 'Procedure Description', flex: 1, },
            { field: 'CPT_Code', headerName: 'CPT Code', initialWidth: 150, },
            { field: 'CPT_Description', headerName: 'CPT Description', flex: 1, },
            { field: 'workrvu', headerName: 'wRVU', initialWidth: 150, },
            {
                field: 'CustomWorkRVU', headerName: 'Custom wRVU', initialWidth: 150, editable: true,
                valueFormatter: function (params) {
                    if (params.value) {
                        return parseFloat(params.value);
                    }
                },
                sortable: false,
            },
            {
                field: 'LastModified', headerName: 'Last Modified', initialWidth: 180,
                valueFormatter: function (params) {
                    return formatMappingLastModifiedCell(params.value);
                }
            },
            {
                field: 'Action', headerName: '', colId: 'Action',
                cellRenderer: function (params) {
                    if (!params.data.SiteCPTProcedureMapID) {
                        return "";
                    } else {
                        return "<button title='Delete' class='btn border-0' style='background-color: transparent;'> <i class='fa fa-trash-o fs-17px' style='color:#07e6c4 '></i></button>";
                    }
                },
                minWidth: 60, maxWidth: 60,
            },
        ];

        var CPTGridOptions = {
            columnDefs: cptColumnDefs,
            defaultColDef: {
                lockVisible: true,
                minWidth: 50,
                resizable: true,
                sortable: true,
            },
            sortingOrder: ['desc', 'asc'],
            rowModelType: 'serverSide',
            suppressExcelExport: true,
            cacheBlockSize: cpmPageSize,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getContextMenuItems: getContextMenuItems,

            undoRedoCellEditing: true,
            undoRedoCellEditingLimit: 5,

            getRowId: function (params) {
                return params.data.rowID;
            },

            onGridReady: function () {

                CPTGridOptions.columnApi.applyColumnState({ state: [{ colId: 'ProcedureDesc', sort: 'desc' }], });

                var fakeServer = createFakeServer();
                // create datasource with a reference to the fake server
                var datasource = createServerSideDatasource(fakeServer);
                // register the datasource with the grid
                CPTGridOptions.api.setServerSideDatasource(datasource);

            },
            onCellClicked: function (params) {
                if (params.column.colId == "Action" && (params.data.SiteCPTProcedureMapID)) {
                    params.node.setSelected(true);
                    DeleteCPTProcedureMaping(params);
                }
            },
            onSortChanged: function (params) {
                CPTGridOptions.api.showLoadingOverlay();
                resetCPTGrid();
            },
            onCellEditingStopped: function (params) {
                if (!isNaN(parseFloat(params.newValue)) && parseFloat(params.newValue) >= 0) {
                    UpdateCustomWorkRVU(params.data.SiteProcedureMappingID, parseFloat(params.newValue));
                } else {
                    toaster.error({ body: "Invalid Custom RVU." });
                    CPTGridOptions.api.undoCellEditing();
                }
            },
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },

        };
        function createFakeServer() {
            return {
                getData: function (request) {
                    var d = $q.defer();
                    cpmPageNo = _.toInteger(request.endRow / cpmPageSize);
                    var Filter = {
                        PageNum: cpmPageNo,
                        PageSize: cpmPageSize,
                        ProcedureID: ($scope.cpmProcedure.Code) ? $scope.cpmProcedure.Code.ProcedureID : null,
                        CPT_Code: ($scope.cpmCPT.Code) ? $scope.cpmCPT.Code.CPT_Code : null,
                        MappingStatus: $scope.CPTMapStatus.Obj.value,
                        OrderByField: (request.sortModel.length > 0) ? request.sortModel[0].colId : '',
                        OrderBy: (request.sortModel.length > 0) ? request.sortModel[0].sort : '',
                        IsEmptyCustomRVU: $scope.ShowEmptyCustomwRVU.Obj,
                    };
                    GetCPTProcedureList(Filter).then(function () {
                        showHideStatusbar(CPTProcedureList, CPTGridOptions)
                        var rowsForBlock = CPTProcedureList.slice(request.startRow, request.endRow);
                        d.resolve({
                            success: true,
                            rows: rowsForBlock,
                        });
                    });
                    return d.promise;
                }
            }
        }

        function createServerSideDatasource(server) {
            return {
                getRows: function (params) {
                    server.getData(params.request).then(function (response) {
                        if (response.success) {
                            params.success({
                                rowData: response.rows,
                                rowCount: response.lastRow,
                            });
                        } else {
                            params.fail();
                        }
                    });
                },
            };
        }
        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }
        function showHideStatusbar(list, gridOptions) {
            var statusBarComponent = gridOptions.api.getStatusPanel('GridFooter');
            if (list.length == 0) {
                statusBarComponent.eGui.hidden = true;
                gridOptions.api.showNoRowsOverlay();
            } else {
                gridOptions.api.hideOverlay();
                statusBarComponent.eGui.hidden = false;
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
                var totalRows = list.length == 0 ? 0 : list[0].TotalRows;
                statusBarComponent.eGui.textContent = 'Showing ' + list.length + ' of ' + totalRows + ' Total Records';
                statusBarComponent.eGui.style.color = 'white';
            }
        }
        function getContextMenuItems(params) {
            var menuItems = [];
            menuItems.push({
                name: 'Export CSV',
                action: function () {
                    var Filter = {
                        ProcedureID: ($scope.cpmProcedure.Code) ? $scope.cpmProcedure.Code.ProcedureID : null,
                        CPT_Code: ($scope.cpmCPT.Code) ? $scope.cpmCPT.Code.CPT_Code : null,
                        MappingStatus: $scope.CPTMapStatus.Obj.value,
                    };
                    Filter.LocationID = $scope.SelectedLocations.Ids;
                    MappingService.GetCPTProcedureListExport(Filter).then(function (res) {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        var blob = new Blob([res], { type: 'text/csv' });
                        var url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = "Export.csv";
                        a.click();
                        window.URL.revokeObjectURL(url);
                    });
                },
                icon: '<i class="ag-icon ag-icon-csv"></i>'
            });
            menuItems.push('separator');
            menuItems.push('autoSizeAll');
            menuItems.push('resetColumns');
            menuItems.push('separator');
            menuItems.push('copy');
            menuItems.push('copyWithHeaders');

            return menuItems;
        }

        //#endregion  CPT AgGrid
        function GetCPTList(search) {
            MappingService.GetCPTList({ Search: search }).then(function (result) {
                $scope.CPTList = result;
            });
        }
        function GetCPTProcedureList(Filter) {
            var d = $q.defer();
            Filter.LocationID = $scope.SelectedLocations.Ids;
            MappingService.GetCPTProcedureList(Filter).then(function (result) {
                $scope.disableProcCPTFilter = false;
                _.each(result, function (cpt) {
                    CPTRowID++;
                    cpt.rowID = CPTRowID;
                });
                CPTProcedureList = _.concat(CPTProcedureList, result);
                if (CPTProcedureList.length > 0 && !cpmTotalRows) {
                    cpmTotalRows = result[0].TotalRows;
                }
                d.resolve();
            }).catch(function () {
                d.reject();
            });
            return d.promise;
        }
        $scope.bindCPTProcedureList = function () {
            $scope.disableProcCPTFilter = true;
            $scope.loadProcCPTMap = false;
            resetCPTGrid();
        };
        $scope.ClearCPTProcedureFilter = function () {
            $scope.disableProcCPTFilter = true;
            clearCPTData();
            resetCPTGrid();
        };
        $scope.MapCPTProcedure = function () {
            $scope.cpmProcedures = {};
            $scope.cpmCPTs = {};
            $scope.loadProcCPTMap = true;
            $('#ModalMapCPTProcedure').modal('show');
        };

        function DeleteCPTProcedureMaping(params) {
            swal({
                title: 'Are you sure, you want to delete this record?',
                type: "warning",
                html: true,
                customClass: 'swal-wide',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55", confirmButtonText: "Yes",
                cancelButtonText: "No",
            },
                function (isConfirm) {
                    if (isConfirm) {
                        var filter = {
                            SiteCPTProcedureMapID: params.data.SiteCPTProcedureMapID,
                        };
                        MappingService.DeleteCPTProcedureMaping(filter).then(function (result) {
                            if ($scope.CPTMapStatus.Obj.value != 'All') {
                                var rowIdx = params.data.rowID;
                                CPTGridOptions.api.applyServerSideTransaction({ remove: [{ rowID: rowIdx.toString() }] });
                                var idx = _.findIndex(CPTProcedureList, { 'RowID': params.data.RowID });
                                CPTProcedureList.splice(idx, 1);
                                cpmTotalRows = cpmTotalRows - 1;
                                showHideStatusbar(CPTProcedureList, CPTGridOptions);

                            } else {
                                params.node.data.CPT_Code = null;
                                params.node.data.CPT_Description = null;
                                params.node.data.SiteCPTProcedureMapID = null;
                                params.node.data.workrvu = '0.00';

                                var refreshParams = {
                                    force: true,
                                    suppressFlash: true,
                                    rowNodes: [params.node]

                                };
                                CPTGridOptions.api.refreshCells(refreshParams);
                            }
                            toaster.success({ body: "CPT and procedure mapping deleted successfully." });
                        });
                    }
                });
        };
        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };
        $scope.checkLoadCPTList = function (val) {
            GetCPTList(val);
        };
        function clearCPTData() {
            cpmPageNo = 1;
            cpmPageSize = 40;
            cpmTotalRows = 0;
            CPTProcedureList = [];
            $scope.cpmProcedure = {};
            $scope.cpmCPT = {};
            $scope.CPTMapStatus = { Obj: _.find($scope.CPTMapStatusOptions, function (item) { return item.value == "Unmapped" }) }
            $scope.SelectedLocations = {
                Ids: '',
                locations: [],
                divId: "MappingPage"
            }
        }
        function resetCPTGrid() {
            CPTProcedureList = [];
            cpmTotalRows = 0;
            CPTGridOptions.api.refreshServerSide({ purge: true });
        }

        $scope.SelectCPTMapStatus = function () {
            resetCPTGrid();
        }

        function GetSitesAndLocation() {
            var d = $q.defer();
            PaymentContractService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.MasterData.Locations = _.filter(result, function (obj) { return obj.SiteID != 0; });
                $scope.DataObject.SiteList = _.uniqBy($scope.MasterData.Locations, 'SiteID');

                d.resolve();
            });
            return d.promise;
        }
        function compare(a, b) {
            // Use toUpperCase() to ignore character casing
            var bandA = a.text.toUpperCase();
            var bandB = b.text.toUpperCase();

            var comparison = 0;
            if (bandA > bandB) {
                comparison = 1;
            } else if (bandA < bandB) {
                comparison = -1;
            }
            return comparison;
        }
        $scope.selectLocForCPTProcMap = function () {
        }

        $scope.uploadFile = function (input) {
            if (input.files && input.files.length > 0) {
                var toast = toaster.pop(
                    {
                        type: 'info',
                        body: "File is uploading...",
                        timeout: 0,
                    }
                );

                angular.forEach(input.files, function (file) {
                    var reader = new FileReader();
                    reader.onload = function () {
                        $scope.$apply(function ($scope) {
                            document.getElementById("fileInput").value = null;
                            var list = reader.result.split(/\r?\n/);
                            if (list.length <= 2) {
                                toaster.clear(toast);
                                toaster.pop({ type: 'error', body: "Invalid csv file." });
                                return;
                            }
                            var column = list[0].split(',');
                            var IsInvalideFile = false;
                            if (column.length != 5) {
                                //This if block will verify column length
                                IsInvalideFile = true;
                            }
                            if (!IsInvalideFile) {
                                //This if block verify if column exists
                                _.each(('Site,Procedure Code,Procedure Description,CPT Code,Custom wRVU').split(','), function (c) {
                                    if (!_.filter(column, function (f) { return f == c })[0]) {
                                        IsInvalideFile = true;
                                    }
                                });
                            }
                            if (!IsInvalideFile) {
                                //This if block verify column order
                                var k = 0, c = ('Site,Procedure Code,Procedure Description,CPT Code,Custom wRVU').split(',');
                                _.each(column, function (col) {
                                    if (k < 5) {
                                        if (!(col == c[k])) {
                                            IsInvalideFile = true;
                                        }
                                        k++;
                                    }
                                });
                            }
                            if (IsInvalideFile) {
                                toaster.clear(toast);
                                toaster.pop({ type: 'error', body: "Invalid csv file." });
                                return;
                            } else {
                                var doc = {};
                                doc.fileContentBase64 = reader.result;
                                doc.Base64 = btoa(reader.result);
                                doc.Filename = file.name;
                                doc.Filetype = file.type;
                                $scope.ProcCPTMapCsvFile.push(doc);
                                $scope.CSVFileName = file.name;
                            }
                            if ($scope.ProcCPTMapCsvFile != null && $scope.ProcCPTMapCsvFile.length > 0) {
                                angular.forEach($scope.ProcCPTMapCsvFile, function (doc) {
                                    var objDoc = angular.copy(doc);
                                    delete objDoc.fileContentBase64;
                                    objDoc.UploadBy = $sessionStorage.currentUserData.userId;
                                    MappingService.ImportCPTProcedureMapping(objDoc).then(function (response) {
                                        $scope.CSVFileName = null;
                                        $scope.ProcCPTMapCsvFile = [];
                                        toaster.clear(toast);
                                        toaster.success({ body: "File uploaded successfully." });
                                    }).catch(function (noCantDo) {
                                        toaster.clear(toast);
                                        toaster.error({ body: "Invalid CSV file." });
                                    });
                                });
                            }
                        });
                    };
                    //reader.readAsDataURL(file);
                    reader.readAsText(file, "UTF-8");
                });
            }
        };

        $scope.ResetFileInput = function () {
            document.getElementById("fileInput").value = null;
            $scope.CSVFileName = null;
            $scope.ProcCPTMapCsvFile = [];
        }
        $scope.closeModalMapCPTProcedure = function () {
            $scope.loadProcCPTMap = false;
        }

        function UpdateCustomWorkRVU(SiteProcedureMappingID, CustomWorkRVU) {
            var d = $q.defer();
            var params = {
                SiteProcedureMappingID: SiteProcedureMappingID,
                CustomWorkRVU: CustomWorkRVU,
            }
            MappingService.UpdateCustomWorkRVU(params).then(function () { });
            return d.promise;
        }
        //#endregion Procedure CPT Mapping

        //#region Custom wRVU
        var customwRVUPageNo = 0;
        var customwRVUPageSize = 50;
        var customwRVUMappingList = [];

        var customwRVUColDefs = [
            {
                field: 'Site', headerName: 'Site', initialWidth: 200, cellRenderer: SiteCellTemplate,
                tooltipValueGetter: function (params) {
                    if (params.data.Site && params.data.TenantName) {
                        return params.data.Site + ' (' + params.data.TenantName + ')';
                    }
                }
            },
            { field: 'CPT_Code', headerName: 'CPT Code', initialWidth: 150, sort: 'asc' },
            { field: 'CPT_Description', headerName: 'CPT Description', flex: 1, },
            { field: 'WorkRVU', headerName: 'wRVU', initialWidth: 150, },
            {
                field: 'CustomWorkRVU', headerName: 'Custom wRVU', initialWidth: 150,
                editable: function (params) { return (params && params.data && params.data.SiteCPTCodeWorkRVUID); },
                valueFormatter: function (params) {
                    if (params.value) {
                        return parseFloat(params.value);
                    }
                },
                cellEditor: 'agNumberCellEditor',
                sortable: true,
                cellClass: "custom-rvu-grid-cell-render",
            },
            {
                field: 'LastModified', headerName: 'Last Modified', initialWidth: 180,
                valueFormatter: function (params) {
                    return formatMappingLastModifiedCell(params.value);
                },
            },
            {
                field: 'Action', headerName: '', colId: 'Action',
                cellRenderer: function (params) {
                    if (params && params.data && params.data.SiteCPTCodeWorkRVUID) {
                        return "<button title='Delete' class='btn border-0' style='background-color: transparent;'> <i class='fa fa-trash-o fs-17px' style='color:#07e6c4 '></i></button>";
                    }
                },
                minWidth: 60, maxWidth: 60,
            },
        ];

        var customwRVUGridOptions = {
            columnDefs: customwRVUColDefs,
            defaultColDef: {
                lockVisible: true,
                minWidth: 50,
                resizable: true,
                sortable: true,
            },
            singleClickEdit: true,
            suppressMultiSort: true,
            sortingOrder: ['desc', 'asc'],
            rowModelType: 'serverSide',
            suppressExcelExport: true,
            cacheBlockSize: customwRVUPageSize,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            suppressContextMenu: true,
            getRowId: function (params) {
                return params.data.RowID;
            },
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },
            onGridReady: function () {

                var fakeServer = createFakeServerForCustomwRVU();
                // create datasource with a reference to the fake server
                var datasource = createServerSideDatasource(fakeServer);
                // register the datasource with the grid
                customwRVUGridOptions.api.setServerSideDatasource(datasource);
            },
            onSortChanged: function (params) {
                customwRVUGridOptions.api.showLoadingOverlay();
                $scope.filterCustomwRVUList();
            },
            onCellClicked: function (params) {
                if (params && params.data) {
                    if (params.column.colId == "Action" && params.data.SiteCPTCodeWorkRVUID) {

                        if (params.data.RowID) {
                            customwRVUGridOptions.api.applyServerSideTransaction({ remove: [{ RowID: params.data.RowID }] });
                        }
                        customwRVUGridOptions.api.showLoadingOverlay();
                        UpdateSiteCPTWorkRVU(params.data, "D").then(function () {
                            customwRVUGridOptions.api.hideOverlay();
                        }, function (err) { customwRVUGridOptions.api.hideOverlay(); });
                    }
                }
            },
            onCellEditingStopped: function (params) {
                if (params && params.data) {
                    if (params.column.colId == "CustomWorkRVU" && params.data.SiteCPTCodeWorkRVUID && params.newValue) {
                        customwRVUGridOptions.api.showLoadingOverlay();
                        UpdateSiteCPTWorkRVU(params.data, "U").then(function () {
                            customwRVUGridOptions.api.hideOverlay();
                        }, function (err) { customwRVUGridOptions.api.hideOverlay(); });
                    }
                }
            }
        }

        function createFakeServerForCustomwRVU() {
            return {
                getData: function (request) {
                    var d = $q.defer();
                    $scope.DataObject.isCustomwRVUGridLoading = true;
                    customwRVUPageNo = _.toInteger(request.endRow / customwRVUPageSize);
                    var params = {
                        PageNum: customwRVUPageNo,
                        PageSize: customwRVUPageSize,
                        OrderByField: (request.sortModel.length > 0) ? request.sortModel[0].colId : '',
                        OrderBy: (request.sortModel.length > 0) ? request.sortModel[0].sort : '',
                        CPTCode: ($scope.DataObject.SiteMultiSelectFilter.SelectedCPT) ? $scope.DataObject.SiteMultiSelectFilter.SelectedCPT.CPT_Code : null,
                        ProcDesc: ($scope.DataObject.SiteMultiSelectFilter.SelectedProcedure) ? $scope.DataObject.SiteMultiSelectFilter.SelectedProcedure.ProcedureDesc : null,
                        IsEmptyCustomRVU: $scope.DataObject.SiteMultiSelectFilter.ShowEmptyCustomwRVU,
                        UserID: $sessionStorage.currentUserData.userId,
                    };
                    if ($scope.DataObject.SiteMultiSelectFilter && $scope.DataObject.SiteMultiSelectFilter.SelectedValue) {
                        params.SiteIDs = _.join(_.map($scope.DataObject.SiteMultiSelectFilter.SelectedValue.list, function (val) { return val.SiteID; }), ',');
                    }
                    GetSiteCPTWorkRVU(params).then(function () {
                        showHideStatusbar(customwRVUMappingList, customwRVUGridOptions);
                        var rowsForBlock = customwRVUMappingList.slice(request.startRow, request.endRow);

                        $scope.DataObject.isCustomwRVUGridLoading = false;
                        d.resolve({
                            success: true,
                            rows: rowsForBlock,
                        });
                    });
                    return d.promise;
                }
            }
        }

        function GetSiteCPTWorkRVU(params) {
            var d = $q.defer();

            MappingService.GetSiteCPTWorkRVU(params).then(function (result) {
                _.each(result, function (obj) {
                    obj.RowID = new Date().getTime() + Math.random().toString(16).slice(2);
                });
                customwRVUMappingList = _.concat(customwRVUMappingList, result);
                d.resolve(result);
            }, function () { d.reject(); });
            return d.promise;
        }
        function initCustomwRVUGrid() {
            var timeout = $timeout(function () {
                var gridDiv = document.querySelector('#customwRVUGrid');
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, customwRVUGridOptions);
                }
                $timeout.cancel(timeout);
                timeout = null;
            }, 100);
        }
        function clearCustomwRVUTabData() {
            customwRVUMappingList = [];
            $scope.DataObject.SiteMultiSelectFilter.SelectedValue = { list: [] };
            $scope.DataObject.SiteMultiSelectFilter.SelectedCPT = null;
            $scope.DataObject.SiteMultiSelectFilter.SelectedProcedure = null;
            $scope.DataObject.SiteMultiSelectFilter.ShowEmptyCustomwRVU = false;
        }
        $scope.filterCustomwRVUList = function () {
            customwRVUMappingList = [];
            customwRVUGridOptions.api.refreshServerSide({ purge: true });
        }
        $scope.clearCustomwRVUList = function () {
            clearCustomwRVUTabData();
            $scope.filterCustomwRVUList();
        }
        $scope.openShowAddCustomRVUModel = function (closePopup) {
            if (closePopup) {
                $('#addCustomRVUMapping').modal('hide');
                $scope.DataObject.SiteCPTCustomwRVUList = { list: [] };
            }
            else {
                $('#addCustomRVUMapping').modal('show');
            }
        }
        $scope.SetSiteCPTWorkRVU = function (gridData) {
            var d = $q.defer();
            if (gridData && gridData.length > 0) {
                var SiteCPTCodeWorkRVU = [];
                _.each(gridData, function (Obj) {
                    _.each(Obj.CPT, function (cptObj) {
                        if (Obj.Site && Obj.Site.SiteID && cptObj.CPT_Code && Obj.CustomwRVU) {
                            SiteCPTCodeWorkRVU.push({
                                SiteID: Obj.Site.SiteID,
                                CPTCode: cptObj.CPT_Code,
                                CustomWorkRVU: Obj.CustomwRVU
                            });
                        }
                    });
                });

                if (SiteCPTCodeWorkRVU.length > 0) {
                    MappingService.SetSiteCPTWorkRVU({
                        SiteCPTCodeWorkRVUs: SiteCPTCodeWorkRVU,
                        CreatedBy: $sessionStorage.currentUserData.userId
                    }).then(function (result) {
                        toaster.success({ body: "Data Saved Successfully!" });
                        $scope.openShowAddCustomRVUModel(true);
                        $scope.filterCustomwRVUList();
                        d.resolve();
                    }, function () {
                        toaster.error({ body: "Some Error Occured!" });
                        d.reject();
                    });
                }
            }
            else {
                d.resolve();
            }
            return d.promise;
        }

        function UpdateSiteCPTWorkRVU(customwRVUObj, Flag) {
            var d = $q.defer();
            if (customwRVUObj.SiteCPTCodeWorkRVUID && customwRVUObj.CustomWorkRVU) {
                MappingService.UpdateSiteCPTWorkRVU({
                    SiteCPTCodeWorkRVUID: customwRVUObj.SiteCPTCodeWorkRVUID,
                    CustomWorkRVU: customwRVUObj.CustomWorkRVU,
                    ModifiedBy: $sessionStorage.currentUserData.userId,
                    Flag: Flag
                }).then(function () {
                    if (Flag != 'D') {
                        toaster.success({ body: "Data Updated Successfully!" });
                    }
                    else {
                        toaster.success({ body: "Data Deleted Successfully!" });
                    }
                    $scope.filterCustomwRVUList();
                    d.resolve();
                }, function (err) {
                    d.reject();
                });
            }
            else {
                d.resolve();
            }
            return d.promise;
        }
        $scope.GetMappedCPTWRVUList = function (SearchKey) {
            var d = $q.defer();
            MappingService.GetMappedCPTWRVUList({ SearchKey: SearchKey }).then(function (result) {
                $scope.DataObject.MappedCPTWRVUList = _.uniqBy(_.concat($scope.DataObject.MappedCPTWRVUList, result), 'CPT_Code');
            });
            return d.promise;
        }


        initPage();
        $scope.$on('$destroy', function () {
            if (CPTGridOptions.api) { CPTGridOptions.api.destroy(); }
            $timeout.cancel(activeTableTRTimeout);
            $timeout.cancel(CPTGridTimeout);
            document.removeEventListener("click", ClickEventListner);
            CommonService.stopNotifyTATStudy();
        });

        function ClickEventListner(event) {
            var rvuRender = event.target.closest(".custom-rvu-grid-cell-render");

            if (!rvuRender && customwRVUGridOptions && customwRVUGridOptions.api) {
                customwRVUGridOptions.api.stopEditing();
            }
        }

        function SiteCellTemplate(params) {
            if (params.data && params.data.Site && params.data.TenantName) {
                var template = '<div class="sites-overflow">';
                template += "<span class='px-4px py-2px mlp-value-box bg-clr-36 mr-4px text-nowrap'>" + params.data.Site + " (" + params.data.TenantName + ")" + "</span>";
                '</div>';
                return template;
            }
            else {
                return "";
            }
        }

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
        document.addEventListener("click", ClickEventListner);
    }
})();

angular.module('radico.pages.settings.mapping')
    .service('MappingService', ['Restangular', function (Restangular) {

        this.GetProcedureSpeciality = function (siteFilter) {
            return Restangular.one('Settings').one("GetProcedureSpecialityList").customPOST(siteFilter);
        };
        this.GetProcedure = function (Filter) {
            return Restangular.one('Settings').one("GetAllProcedure").customPOST(Filter);
        };
        this.GetProcedureByProcedureID = function (Filter) {
            return Restangular.one('Settings').one("GetProcedureByProcedureID").customPOST(Filter);
        };
        this.GetSpeciality = function () {
            return Restangular.one('Settings').one("GetAllSpeciality").get();
        };
        this.GetSpecialityBySpecialityID = function (Filter) {
            return Restangular.one('Settings').one("GetSpecialityBySpecialityID").customPOST(Filter);
        };
        this.AddEditMapping = function (Filter) {
            return Restangular.one('Settings').one("AddEditMapping").customPOST(Filter);
        };
        this.DeleteProcedureSpeciality = function (Filter) {
            return Restangular.one('Settings').one("DeleteMapping").customPOST(Filter);
        };

        this.GetCPTList = function (Filter) {
            return Restangular.one('Settings').one("GetCPTList").customPOST(Filter);
        };
        this.GetCPTProcedureList = function (Filter) {
            return Restangular.one('Settings').one("GetCPTProcedureList").customPOST(Filter);
        };
        this.AddCPTProcedureMapping = function (param) {
            return Restangular.one('Settings').one("AddCPTProcedureMapping").customPOST(param);
        };
        this.DeleteCPTProcedureMaping = function (Filter) {
            return Restangular.one('Settings').one("DeleteCPTProcedureMaping").customPOST(Filter);
        };
        this.GetProviderNameUserMappingsList = function (filter) {
            return Restangular.one('Settings').one("GetProviderNameUserMappingsList").customPOST(filter);
        }
        this.EditProviderNameUserMappingsList = function (filter) {
            return Restangular.one('Settings').one("EditProviderNameUserMappingsList").customPOST(filter);
        }
        this.GetAllProviders = function (filter) {
            return Restangular.one('Settings').one("GetAllProviders").customPOST(filter);
        }
        this.GetCPTProcedureListExport = function (Filter) {
            return Restangular.one('Settings').one("GetCPTProcedureListExport").customPOST(Filter);
        };
        this.ImportCPTProcedureMapping = function (Filter) {
            return Restangular.one('Settings').one("ImportCPTProcedureMapping").customPOST(Filter);
        };
        this.UpdateCustomWorkRVU = function (Filter) {
            return Restangular.one('Settings').one("UpdateCustomWorkRVU").customPOST(Filter);
        };
        this.GetSiteCPTWorkRVU = function (params) {
            return Restangular.one('Settings').one("GetSiteCPTWorkRVU").customPOST(params);
        };
        this.SetSiteCPTWorkRVU = function (params) {
            return Restangular.one('Settings').one("SetSiteCPTWorkRVU").customPOST(params);
        };
        this.UpdateSiteCPTWorkRVU = function (params) {
            return Restangular.one('Settings').one("UpdateSiteCPTWorkRVU").customPOST(params);
        };
        this.GetMappedCPTWRVUList = function (params) {
            return Restangular.one('Settings').one("GetMappedCPTWRVUList").customPOST(params);
        };
        this.DownloadCustomwRVUMapppingSample = function () {
            return Restangular.one('Settings').one("DownloadCustomwRVUMapppingSample").customPOST();
        };

        this.SetProviders = function (params) {
            return Restangular.one('Settings').one("SetProviders").customPOST(params);
        };
        this.GetProviders = function (params) {
            return Restangular.one('Settings').one("GetProviders").customPOST(params);
        };
        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.settings.oncall')
        .controller('OnCallScheduleController', OnCallScheduleController).filter('titleCase', function () {
            return function (input) {
                input = input || '';
                return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            };
        });
    function OnCallScheduleController($scope, $sessionStorage, CommonService, filterFilter, OnCallScheduleService, AccountManagerService, $q, toastr, toaster, SharedService) {


        //var onCallCtrl = this;

        var parser = new UAParser();
        $scope.browser = parser.getBrowser().name;

        $scope.title = "On-Call Schedule";
        $scope.Flag = '';
        $scope.SelectedInstitution = {};
        $scope.SelectedRadiologist = {};
        $scope.SelectedRadiologistAlternative = {};

        $scope.ShowFilter = false;
        $scope.PageSize = "25";
        $scope.CurrentPage = "1";
        $scope.TotalCount = "0";
        $scope.FilterCount = "0";

        $scope.ShowFilter = false;
        $scope.ShowListView = true;
        $scope.selectedRow = null;  // initialize our variable to null   

        $scope.Search = {};
        $scope.AltSearch = {};
        $scope.InstSearch = {};

        $scope.FromSearch = {};
        $scope.ToSearch = {};

        $scope.FromSearchEdit = {};
        $scope.ToSearchEdit = {};

        $scope.hstep = 1;
        $scope.mstep = 5;

        $scope.ismeridian = true;

        $scope.isExporting = false;

        $scope.toggleMode = function () {
            $scope.ismeridian = !$scope.ismeridian;
        };


        $scope.date = {
            startDate: moment(),
            endDate: moment()
        };
        $scope.minDate = moment().local().format("MM/DD/YYYY");

        $scope.opts = {
            locale: {
                format: "MM/DD/YYYY"
            }
        };
        //Watch for date changes
        $scope.$watch('date', function (newDate) {
            //console.log('New date set: ', newDate);
        }, false);

        $scope.Load = function () {
            $scope.GetOnCallScheduleList();
            $scope.GetAllInstitutions();
            $scope.GetAllUsers();
        };

        $scope.GetAllInstitutions = function () {
            OnCallScheduleService.GetAllInstitutions($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.Institutions = result;
            });
        };
        $scope.GetAllUsers = function () {
            OnCallScheduleService.GetAllUserByTenant({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
                _.each(result, function (data) {
                    data.FirstName = data.LastName + ", " + data.FirstName;
                });
                $scope.Radiologists = result;
            });
        };
        $scope.ShowHideFilter = function () {
            $scope.ShowFilter = !$scope.ShowFilter;
            $scope.isfilterHeight = !$scope.isfilterHeight;
        };

        $scope.SearchInstitutionsSelectChange = function (SelectedInstitution) {
            if (SelectedInstitution) {
                $scope.GetAllRadiologistAsync(SelectedInstitution);
            }
            $scope.Search.SelectedRadiologist = '';
            $scope.Search.SelectedRadiologistAlternative = '';
        };

        $scope.SearchFilter = function () {
            $scope.PageSize = "25";
            $scope.CurrentPage = "1";
            $scope.orderByField = "";
            $scope.OrderBy = "";
            $scope.ShowOnCallScheduleList();
        };
        $scope.SortFilter = function () {
            $scope.PageSize = "25";
            $scope.CurrentPage = "1";
            $scope.ShowOnCallScheduleList();
        };

        $scope.dosFromDateOpen = function () {
            $scope.dosFDpopup.opened = true;
        };
        $scope.dosFDpopup = {
            opened: false
        };
        $scope.dosToDateOpen = function () {
            $scope.dosTDpopup.opened = true;
        };
        $scope.dosTDpopup = {
            opened: false
        };
        $scope.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            minDate: new Date(),
        };
        $scope.dateSearchOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
        };

        $scope.ClearFilter = function () {
            $scope.Search = {};
            $scope.AltSearch = {};
            $scope.InstSearch = {};
            $scope.PageSize = "25";
            $scope.CurrentPage = "1";
            $scope.showUnMapped = false;
            $scope.FromSearch = '';
            $scope.ToSearch = '';
            $scope.orderByField = "";
            $scope.OrderBy = "";
            $scope.ShowOnCallScheduleList();
        };

        $scope.Cancel = function () {
            $scope.ClearAddFields();
            $scope.ClearFilter();
        };

        $scope.ShowOnCallScheduleList = function () {
            $scope.ShowListView = true;
            $scope.Flag = '';
            $scope.GetOnCallScheduleList();
        };

        function searchFilterModel() {
            var obj = {
                ProviderID: $scope.Search.Obj ? $scope.Search.Obj.Id : null,
                AlternateProviderID: $scope.AltSearch.Obj ? $scope.AltSearch.Obj.Id : null,
                InstitutionId: $scope.InstSearch.Obj ? $scope.InstSearch.Obj.InstitutionId : null,
                OrderByField: $scope.orderByField ? $scope.orderByField : "",
                OrderBy: $scope.reverseSort
            };
            if ($scope.FromSearch.Obj && $scope.ToSearch.Obj) {
                obj.FromDate = formatted_date($scope.FromSearch.Obj);
                obj.ToDate = formatted_date($scope.ToSearch.Obj);
            }
            return obj;
        }
        $scope.changePageSize = function () {
            $scope.CurrentPage = "1";
            $scope.ShowOnCallScheduleList();
        };
        $scope.CreateOnCallSchedule = function () {
            $scope.ShowListView = false;
            $scope.Flag = 'ADD';
            $scope.ToTime = new Date(1970, 0, 1, '08', '00', '0');
            $scope.FromTime = new Date(1970, 0, 1, '00', '00', '0');
            //$scope.SelectedRadiologist = '';
            //$scope.SelectedRadiologistAlternative = '';
            //$scope.date = {
            //    startDate: moment(),
            //    endDate: moment()
            //};
            //$scope.ToTime = new Date(1970, 0, 1, 08, 00, 0);
            //$scope.FromTime = new Date(1970, 0, 1, 00, 00, 0);
            //$scope.OnCallScheduleID = '';
            //$scope.SelectedModalityTemp = '';
            //$scope.SelectedInstitution = '';
            //$scope.SelectedPatientClass = '';
        };
        $scope.GetOnCallScheduleList = function () {
            //var a = $scope.Search.Obj.Id;
            //var b = $scope.AltSearch.Obj.Id;
            //var c = $scope.InstSearch.Obj.InstitutionId;
            //var d = $scope.FromSearch.Obj;
            //var e = $scope.ToSearch.Obj;


            if ((!$scope.FromSearch.Obj && !$scope.ToSearch.Obj) || $scope.FromSearch.Obj && $scope.ToSearch.Obj) {
                if ($scope.FromSearch.Obj > $scope.ToSearch.Obj) {
                    swal("To Date should be greater than From Date.");
                    return;
                }
            } else {
                swal("Please select both From Date and To Date.");
                return;
            }
            //$scope.ShowMainLoader();
            $scope.isLoading = true;
            var SearchFilter = searchFilterModel();

            var data = {
                CurrentPage: $scope.CurrentPage,
                PageSize: $scope.PageSize,
                SearchFilter: SearchFilter,
                UserID: $sessionStorage.currentUserData.userId,
            };
            var serviceCall = OnCallScheduleService.GetOnCallSchedules(data);
            serviceCall.then(function (resp) {
                if (!resp) {
                    $scope.OnCallScheduleList = null;
                    $scope.TotalCount = 0;
                    $scope.FilterCount = 0;

                }
                else {
                    $scope.OnCallScheduleList = resp.OnCallScheduleList;
                    $scope.TotalCount = resp.TotalRecords;
                    $scope.FilterCount = $scope.OnCallScheduleList.length;
                }
                $scope.isLoading = false;
            }, function (err) {
                $scope.isLoading = false;
            });
        };
        $scope.pageChanged = function () {
            $scope.ShowOnCallScheduleList();
        };
        $scope.timeChange = function () {
            if ($scope.date.startDate.local().format("MM/DD/YYYY") == $scope.date.endDate.local().format("MM/DD/YYYY")) {
                $scope.isSameDate = true;
            } else {
                $scope.isSameDate = false;
            }
            $scope.ToDate = $scope.date.endDate.local().format("MM/DD/YYYY");
        };
        $scope.InstitutionsSelectChange = function (Site) {
            var d = $q.defer();
            $scope.UserList = [];
            if (Site) {
                $scope.isLoading = true;
                OnCallScheduleService.GetUsersByInstituteId(Site.InstitutionId).then(function (result) {
                    _.each(result, function (data) {
                        var user = _.find($scope.Radiologists, function (item) { return item.Id == data.UserID; });
                        if (user) {
                            $scope.UserList.push(user);
                        }
                    });
                    d.resolve();
                    $scope.isLoading = false;
                }, function (err) {
                    $scope.isLoading = false;
                });
            }
            return d.promise;
        };
        var formatted_date = function (date) {
            if (date != null) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero 
                var y = date.getFullYear();
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        var formatted_time = function (date) {
            if (date != null) {
                var h = ("0" + (date.getHours())).slice(-2); // in javascript month start from 0.
                var m = ("0" + date.getMinutes()).slice(-2); // add leading zero             
                return h + ':' + m;
            }
            else {
                return null;
            }
        };
        $scope.ClearAddFields = function () {
            $scope.SelectedRadiologist = {};
            $scope.SelectedInstitution = {};
            $scope.SelectedRadiologistAlternative = {};
            $scope.FromSearchEdit = {};
            $scope.ToSearchEdit = {};
            $scope.FromTime = '';
            $scope.ToTime = '';
            $scope.OnCallScheduleID = '';
        };
        $scope.EditOnCallSchedule = function (obj) {
            //$scope.isLoading = true;
            $scope.ShowListView = false;
            $scope.Flag = 'EDIT';
            $scope.SelectedInstitution.Obj = _.find($scope.Institutions, function (objInst) { return objInst.InstitutionId == obj.InstitutionId });
            $q.all([
                $scope.InstitutionsSelectChange($scope.SelectedInstitution.Obj)
            ]).then(function (data) {
                $scope.SelectedRadiologist.Obj = _.find($scope.UserList, function (objInst) { return objInst.Id == obj.ProviderID });
                $scope.SelectedRadiologistAlternative.Obj = _.find($scope.UserList, function (objInst) { return objInst.Id == obj.AlternateProviderID });

            });
            
            
            $scope.FromSearchEdit.Obj = new Date(obj.FromDate);
            $scope.ToSearchEdit.Obj = new Date(obj.ToDate);
            $scope.FromTime = new Date(1970, 0, 1, obj.FromTime.split(':')[0], obj.FromTime.split(':')[1], 0);
            $scope.ToTime = new Date(1970, 0, 1, obj.ToTime.split(':')[0], obj.ToTime.split(':')[1], 0);
            $scope.ScheduleFlag = obj.ScheduleFlag; //== "1" ? true : false;
            $scope.OnCallScheduleID = obj.OnCallScheduleID;
            //$scope.isLoading = false;
        };
        $scope.DeleteOnCallSchedule = function (objVM) {
            var r = confirm("Are you sure you want to delete ?");
            if (r == true) {
                $scope.isLoading = true;
                var servicecall = OnCallScheduleService.DeleteOnCallSchedule(objVM);
                servicecall.then(function (resp) {
                    //$scope.HideMainLoader();
                    if (resp.data) {
                        $scope.isLoading = false;
                        toaster.success({ body: resp.data });
                    } else {
                        $scope.ClearFilter();
                        $scope.ClearAddFields();
                        $scope.ShowOnCallScheduleList();
                    }
                }, function (err) {
                    $scope.isLoading = false;
                    //swal(err.data);
                });
            } //else { }
        };

        $scope.SaveOnCallSchedule = function (valid) {
            //if (!valid) return;        
            //if (!$scope.SelectedRadiologist.Obj) {
            //    swal("Please Select Radiologist");
            //    return;
            //}
            //if (!$scope.SelectedRadiologistAlternative.Obj) {
            //    swal("Please Select Alternative Radiologist");
            //    return;
            //}
            //if ($scope.SelectedRadiologist.Obj.Id == $scope.SelectedRadiologistAlternative.Obj.Id) {
            //    return;
            //}
            //$scope.timeChange();
            if (!$scope.SelectedInstitution.Obj || !$scope.SelectedRadiologist.Obj || !$scope.SelectedRadiologistAlternative.Obj || !$scope.FromSearchEdit.Obj || !$scope.ToSearchEdit.Obj) {
                return;
            }
            //var a = $scope.SelectedInstitution.Obj.InstitutionId;
            //var ab = $scope.SelectedRadiologist.Obj.Id;
            //var aaaaaa = $scope.SelectedRadiologistAlternative.Obj.Id;
            //var aaaaa = formatted_date($scope.FromSearchEdit.Obj);
            //var aaaa = formatted_date($scope.ToSearchEdit.Obj);
            //var aaa = formatted_time($scope.FromTime);
            //var aa = formatted_time($scope.ToTime);

            var fromdatetime = new Date($scope.FromSearchEdit.Obj.getFullYear(), $scope.FromSearchEdit.Obj.getMonth(), $scope.FromSearchEdit.Obj.getDate(), $scope.FromTime.getHours(), $scope.FromTime.getMinutes(), 0);
            var todatetime = new Date($scope.ToSearchEdit.Obj.getFullYear(), $scope.ToSearchEdit.Obj.getMonth(), $scope.ToSearchEdit.Obj.getDate(), $scope.ToTime.getHours(), $scope.ToTime.getMinutes(), 0);

            if (fromdatetime > todatetime) { swal("From date time can not be greater than to date time"); return; };


            $scope.isLoading = true;
            var objVM = {
                ProviderID: $scope.SelectedRadiologist.Obj.Id,
                AlternateProviderID: $scope.SelectedRadiologistAlternative.Obj.Id,
                InstitutionId: $scope.SelectedInstitution.Obj.InstitutionId,
                FromDate: formatted_date($scope.FromSearchEdit.Obj),
                ToDate: formatted_date($scope.ToSearchEdit.Obj),
                FromTime: formatted_time($scope.FromTime),
                ToTime: formatted_time($scope.ToTime),
                ScheduleFlag: $scope.ScheduleFlag,//? "1" : "0",
                OnCallScheduleID: $scope.OnCallScheduleID
            };
            //if (!objVM.FromDate) {
            //    swal("Invalid From Date");
            //    return;
            //}
            //if (!objVM.ToDate) {
            //    swal("Invalid To Date");
            //    return;
            //}
            ////$scope.ShowMainLoader();
            var servicecall = OnCallScheduleService.SaveOnCallSchedule(objVM);
            servicecall.then(function (resp) {
                //$scope.HideMainLoader();
                if (resp.data) {
                    $scope.isLoading = false;
                    toaster.success({ body: resp.data });
                } else {
                    $scope.ClearFilter();
                    $scope.ClearAddFields();
                    $scope.ShowOnCallScheduleList();
                }
            }, function (err) {
                //$scope.HideMainLoader();
                //swal(err.data);
                $scope.isLoading = false;
            });
            //$scope.HideMainLoader();
        };

        $scope.export = function () {
            if (!$scope.isExporting) {
                $scope.isExporting = true;

                var SearchFilter = searchFilterModel();

                var data = {
                    CurrentPage: $scope.CurrentPage,
                    PageSize: "-1", //10000, //$scope.PageSize, -1 for Export all filter data                    
                    SearchFilter: SearchFilter
                };

                OnCallScheduleService.export(data).then(function (data) {
                    var now = new Date();
                    //var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    //var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    //if (urlCreator) {
                    //    var blob = new Blob([data], { type: contentType });
                    //    var url = urlCreator.createObjectURL(blob);
                    //    var a = document.createElement("a");
                    //    document.body.appendChild(a);
                    //    a.style = "display: none";
                    //    a.href = url;
                    //    a.download = "OncallScheduleExport_" + now.getDate().toString() + now.getMonth().toString() + now.getFullYear().toString() + now.getHours().toString() + now.getMinutes().toString() + now.getSeconds().toString() + now.getMilliseconds().toString() + ".xlsx"; //you may assign this value from header as well 
                    //    a.click();
                    //    window.URL.revokeObjectURL(url);
                    //}
                    var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {

                        var IEblob = new Blob([data], { type: contentType });
                        window.navigator.msSaveBlob(IEblob, "OncallScheduleExport_" + now.getDate().toString() + now.getMonth().toString() + now.getFullYear().toString() + now.getHours().toString() + now.getMinutes().toString() + now.getSeconds().toString() + now.getMilliseconds().toString() + ".xlsx");
                    }
                    else {
                        var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                        if (urlCreator) {
                            var blob = new Blob([data], { type: contentType });
                            var url = urlCreator.createObjectURL(blob);
                            var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style = "display: none";
                            a.href = url;
                            a.download = "OncallScheduleExport_" + now.getDate().toString() + now.getMonth().toString() + now.getFullYear().toString() + now.getHours().toString() + now.getMinutes().toString() + now.getSeconds().toString() + now.getMilliseconds().toString() + ".xlsx"; //you may assign this value from header as well 
                            a.click();
                            window.URL.revokeObjectURL(url);
                        }
                    }


                    $scope.isExporting = false;
                }, function (err) {
                    $scope.isExporting = false;
                });
            }
            //var SearchFilter = searchFilterModel();

            //var data = {
            //    CurrentPage: $scope.CurrentPage,
            //    PageSize: $scope.PageSize,
            //    OrderBy: "",
            //    SearchFilter: SearchFilter
            //};   
            //var serviceCall = OnCallScheduleService.GetOnCallSchedulesExport(data);
            //serviceCall.then(function (resp) {
            //    if (!resp) {
            //        //$scope.OnCallScheduleList = null;
            //       // $scope.isLoading = false;
            //        return;
            //    }                
            //    //$scope.HideMainLoader(); 
            //    $scope.isLoading = false;
            //}, function (err) {
            //    $scope.isLoading = false;
            //    //$scope.HideMainLoader();
            //    //$scope.OnCallScheduleList = null;
            //});
        };

        $scope.SendTestNotification = function (type, user) {
            OnCallScheduleService.testnotification({ Type: type, PhoneNumber: user.PhoneNumber }).then(function (resp) {
                if (resp.data != 0) {
                    toaster.success({ body: "Notification sent successfully." });
                } else {
                    toaster.warning({ body: "Notification send fail." });
                }
            }, function (err) {
                console.log(err);
                toaster.error({ body: "Something went wrong!" });
            });
        }
        function validatePhone(phone) {
            var regex = /^\+(?:[0-9]●?){10,14}[0-9]$/;
            if (regex.test(phone)) {
                return true
            } else {
                return false
            }
        }
        function validateEmail(email) {
            var regex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;
            if (regex.test(email)) {
                return true
            } else {
                return false
            }
        }
        $scope.RadiologistChange = function (o) {
            o.isEdit = false;
            o.msg = "";
            o.PhoneNumber = "";
            o.Email = "";
            if (o.Obj) {
                if (!validatePhone(o.Obj.PhoneNumber)) {
                    //swal('Please edit country code with phonenumber! eg. +1xxxxxxxxxx');
                    o.msg = "Radiologist phonenumber not vaild.";
                } else if (!validateEmail(o.Obj.Email)) {
                    //swal('Please edit country code with phonenumber! eg. +1xxxxxxxxxx');
                    o.msg = "Radiologist email not vaild.";
                }
            }
        }
        $scope.EditUserInfo = function (o) {
            o.isEdit = true;
            o.Email = angular.copy(o.Obj.Email);
            o.PhoneNumber = angular.copy(o.Obj.PhoneNumber);
        }
        $scope.UpdateUserContact = function (o) {
            o.msg = "";
            if (!validatePhone(o.PhoneNumber)) {
                //swal('Please edit country code with phonenumber! eg. +1xxxxxxxxxx');
                o.msg = "Radiologist phonenumber not vaild.";
                return;
            } else if (!validateEmail(o.Email)) {
                //swal('Please edit country code with phonenumber! eg. +1xxxxxxxxxx');
                o.msg = "Radiologist email not vaild.";
                return;
            }
            var EditUser = {
                Email: o.Email.trim(),
                PhoneNumber: o.PhoneNumber,
                UserId: o.Obj.Id,
            };
            var promiseResponse = AccountManagerService.UpdateUserContact(EditUser);
            promiseResponse.then(function (resp) {
                //swal("Error : Some problem occured!");
                o.isEdit = false;
                o.msg = "";
                var user = _.find($scope.Radiologists, function (item) { return item.Id == o.Obj.Id; });
                if (user) {
                    user.Email = o.Email.trim();
                    user.PhoneNumber = o.PhoneNumber;
                }
            }, function (error) {
                vm.isLoading = false;
                toaster.error({ body: "Something went wrong!" });
            });

        }
        // JS for table row active
        angular.element(document).ready(function () {
            setTimeout(function () {
                angular.element(".common-tbl table tr").click(function () {
                    if (angular.element(this).data('clicked', true)) {
                        angular.element(".common-tbl table tr").removeClass('tr-active');
                        angular.element(this).addClass('tr-active');
                    }
                });
            }, 500);
        });
        CommonService.startNotifyTATStudy();
        $scope.$on('$destroy', function () {
            CommonService.stopNotifyTATStudy();
        });

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();

//angular.module('app.controllers').controller('OnCallScheduleController', OnCallScheduleController);

angular.module('radico.pages.settings.oncall')
    .service('OnCallScheduleService', ['Restangular', '$http', 'APP_CONSTANTS','__env', function (Restangular, $http, APP_CONSTANTS,__env) {

        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }
        
        this.GetAllInstitutions = function (UserID) {
            return Restangular.one('Settings').one("GetAllInstitutions", UserID).get();
        }; 
        
        this.GetOnCallSchedules = function (data) {
            return Restangular.one('Settings').one("GetOnCallSchedules").customPOST(data);
        }; 
        this.SaveOnCallSchedule = function (data) {
            return Restangular.one('Settings').one("SaveOnCallSchedule").customPOST(data);
        }; 
        this.DeleteOnCallSchedule = function (data) {
            return Restangular.one('Settings').one("DeleteOnCallSchedule").customPOST(data);
        }; 
        this.GetAllUsers = function () {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/RadFlowGetUsers ',
                headers: { 'content-type': 'application/json' }
            });
        }; 
        this.GetUsersByInstituteId = function (InstituteId) {
            return Restangular.one('Settings').one("GetUsersByInstituteId", InstituteId).get();
        };
        
        this.export = function (data) {
            return Restangular.one('Settings').one('GetOnCallSchedulesExport')
                .withHttpConfig({ responseType: 'arraybuffer' }).customPOST(data);
        };
        this.testnotification = function (data) {
            return Restangular.one('Settings').one("testnotification").customPOST(data);
            //return Restangular.one('twilio').one("smsresponse").customPOST({ "ToCountry": "US", "ToState": "TX", "SmsMessageSid": "SM885c45c762ae4633a4736ef9d9d8bbfa", "NumMedia": "0", "ToCity": "HOUSTON", "FromZip": "75159", "SmsSid": "SM885c45c762ae4633a4736ef9d9d8bbfa", "FromState": "TX", "SmsStatus": "received", "FromCity": "COMBINE", "Body": "Hi test response", "FromCountry": "US", "To": "+18329240526", "MessagingServiceSid": "MG7c241ddf043016f3bd233e891e433bb7", "ToZip": "77036", "NumSegments": "1", "ReferralNumMedia": "0", "MessageSid": "SM885c45c762ae4633a4736ef9d9d8bbfa", "AccountSid": "ACca0a12bd4c9cdd3b57a4e2ae3ffda2dc", "From": "+19724748140", "ApiVersion": "2010-04-01" });
        };
        this.GetAllUserByTenant = function (filter) {
            return Restangular.one("Settings").one("GetAllUserByTenant").customPOST(filter);
        };
        this.GetAllUsersBySite = function (filter) {
            return Restangular.one("Settings").one("GetAllUsersBySite").customPOST(filter);
        };
    }]);

/*(function () {
    "use strict";

    OnCallScheduleService.$inject = ['$http', 'GENERAL_CONFIG'];

    function OnCallScheduleService($http, GENERAL_CONFIG) {

        var urlServiceBase = GENERAL_CONFIG.APP_serviceURL + '/api/OnCallSchedule';
        var dataFactory = {};

        dataFactory.GetAllRadiologists = function (data) {
            return $http({
                method: 'POST',
                data: data,
                url: urlServiceBase + '/GetAllRadiologists',
                headers: { 'content-type': 'application/json' }
            });
        };

        dataFactory.GetPatientClass = function () {
            return $http({
                method: 'POST',               
                url: urlServiceBase + '/GetPatientClass',
                headers: { 'content-type': 'application/json' }
            });
        };

        dataFactory.SaveOnCallSchedule = function (data) {
            return $http({
                method: 'POST',
                data: data,
                url: urlServiceBase + '/SaveOnCallSchedule',
                headers: { 'content-type': 'application/json' }
            });
        };

        dataFactory.GetOnCallScheduleList = function (data) {
            return $http({
                method: 'POST',
                data: data,
                url: urlServiceBase + '/GetOnCallScheduleList',
                headers: { 'content-type': 'application/json' }
            });
        };

        dataFactory.DeleteOnCallSchedule = function (data) {
            return $http({
                method: 'POST',
                data: data,
                url: urlServiceBase + '/DeleteOnCallSchedule',
                headers: { 'content-type': 'application/json' }
            });
        };

        dataFactory.GetOnCallSchedule = function (data) {
            return $http({
                method: 'POST',
                data: data,
                url: urlServiceBase + '/GetOnCallSchedule',
                headers: { 'content-type': 'application/json' }
            });
        };
        return dataFactory;
    }
    angular.module('app').factory('OnCallScheduleService', OnCallScheduleService);
})();*/
(function () {
    'use strict';

    angular.module('radico.pages.settings.paymentcontract')
        .controller('PaymentContractController', PaymentContractController).filter('titleCase', function () {
            return function (input) {
                input = input || '';
                return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            };
        });
    function PaymentContractController($q, $scope, $sessionStorage, $filter, toaster, PaymentContractService, WorklistService, MappingService, $log, RuleService, CommonService, AccountManagerService, SharedService, $timeout) {

        var gridDiv = "";
        var PageSize = 50;
        var EditedRow = {};
        var PageNum = 0;
        var OrderByField = "Location";
        var OrderBy = "Asc";
        var PageNum = 0;
        var TotalPageRows = 0;
        $scope.DataObject = {
            isSaveEditBtnDisable: false
        }
        $scope.MultiSelectDropdown = {
            RadiologistFilterPC: {
                divId: "RadiologistFilterPC",
                keys: ['LastName', 'FirstName'],
                uniqKey: 'Id',
                placeHolder: "Select Radiologist",
                SelectedValue: { list: [] },
                onChange: function (selectedData) {
                    $scope.SelectedProvider.obj = selectedData;
                },
                UserList: []
            }
        }
        $scope.RadiologistsFullSet = [];
        $scope.MasterRadiologistsFullSet = [];
        $scope.PaymentContractList = [];
        $scope.PriceType = [{ Value: '%' }, { Value: '$' }];
        $scope.PriceType.Obj = { Value: '%' };
        $scope.Procedure = {};
        $scope.MasterData = { Radiologists: [] };
        $scope.PaymentContract = [];
        $scope.SelectedData = {};
        $scope.SelectedData.Sites;
        $scope.PaymentContract = { Obj: null };
        $scope.SelectedData = { locationIDs: null, Location: null };
        $scope.DisablePaymentContract = false;
        $scope.LocationHideShowText = "Add Location";
        $scope.showPercentage = false;
        $scope.showPrice = false;
        $scope.isLocationVisible = false;
        $scope.isCPTVisible = false;
        $scope.CPTHideShow = 'Add CPT';
        $scope.SelectedModality = { Obj: null };
        $scope.SelectedCPT = { Obj: null };
        $scope.CPTList = [];
        $scope.SelectedProvider = { Obj: null };
        $scope.SelectedDataFilter = {};
        $scope.AssignUserText = "Add Radiologists";
        $scope.isAssignUserVisible = false;
        $scope.RadiologistFilterTooltip = "Select Radiologist";
        $scope.PaymentContractTypes = null;
        $scope.CptCodeTooltip = 'Choose a CPT'
        $scope.PaymentContractHelperShift = { Obj: null };
        $scope.PaymentContractHelperTypes = null;
        //$scope.TabList = ['PayPerRVU', 'PayPerProcedure', 'PayPerShift', 'HelperShift'];
        $scope.TabList = [{ Label: 'Pay Per RVU', Value: 'PayPerRVU' }, { Label: 'Pay Per Procedure', Value: 'PayPerProcedure' }, { Label: 'Pay Per Shift', Value: 'PayPerShift' }, { Label: 'Helper Shift', Value: 'HelperShift' }];

        $scope.SelectedLocationFilterValues = { SelectedItems: [] };
        //#region variable initialization for Pay Per shift
        $scope.FromDate = setDateTime('date', moment(new Date()).format('MM/DD/YYYY'));
        $scope.ToDate = setDateTime('date', moment(new Date()).format('MM/DD/YYYY'));
        $scope.dosFromDatePopup = {
            opened: false
        };
        $scope.dosToDatePopup = {
            opened: false
        };
        $scope.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            minDate: new Date(),
        };
        $scope.dateSearchOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
        };
        $scope.hourStep = 1;
        $scope.minuteStep = 5;
        $scope.DoNotRepeat = false;
        $scope.htSelRadio = "";
        $scope.SelectedValues = { SelectedRadiologists: [] };
        $scope.showAssignRadiologistCmp = { value: false };

        $scope.SelectedLocations = {
            AddEdit: {
                Ids: '',
                locations: [],
                divId: "PaymentContractAddEdit"
            },
            Filter: {
                Ids: '',
                locations: [],
                divId: "PaymentContractFilter"
            }
        }
        $scope.DataObject = {
            SelectedPaymentContractDetail: {
                PaymentAccount: {}
            },
            PaymentAccountTypes: []
        };
        //#endregion

        //Page Init
        function PageInIt() {
            CommonService.startNotifyTATStudy();
            $scope.isLoading = false;
            $scope.PaymentContractSelection = "PayPerRVU";
            GetSitesAndLocation();
            GetLookupTypes();
            $scope.GetCPTList();
            GetModality();
            $scope.GetPaymentContractUsers();
            GetPaymentContractUsersFullList();
            initPaymentContractGrid();
        }

        function initPaymentContractGrid() {
            gridDiv = document.querySelector('#myGrid');
            new agGrid.Grid(gridDiv, gridOptions);
            selColumnVisibility("PayPerRVU");
            gridOptions.columnApi.applyColumnState({ state: [{ colId: 'LastModifiedDate', sort: 'desc' }], });

            //calculate ag-grid height accordingly to screen size
            var pageTopheight = $(".page-top").height();
            var headerDivheight = $("#headerDiv").height();
            $scope.gridHeight = $(window).height() - pageTopheight - headerDivheight;
        }

        function editCellTemplate(params) {
            return "<div title='Edit'class='glyphicon glyphicon-pencil' style='color:#07e6c4 '><div>"
        }

        /** localDate filter expects "YYYY-MM-DD HH:mm:ss"-style strings; API/Dapper often sends culture-specific datetime text. */
        function normalizeDateStringForLocalDateFilter(raw) {
            if (raw == null || raw === '') {
                return '';
            }
            if (angular.isDate(raw)) {
                return isNaN(raw.getTime()) ? '' : moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'number' && isFinite(raw)) {
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'string') {
                var parsed = moment(raw.trim());
                return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : '';
            }
            return '';
        }

        var ColumnDefs = [
            { field: "PaymentContractName", headerName: 'Payment Contract Name' },
            { field: "Modality", maxWidth: 100, },
            {
                field: "Price", valueFormatter: function (params) {
                    return "$" + params.value;
                }
            },
            {
                field: "FromDate", headerName: 'From Date',
                valueFormatter: function (params) {
                    return moment(new Date(params.value)).format("MM/DD/YY");
                },
            },
            { field: "FromTime", headerName: 'From Time', },
            {
                field: "ToDate", headerName: 'To Date',
                valueFormatter: function (params) {
                    return moment(new Date(params.value)).format("MM/DD/YY");
                },
            },
            { field: "ToTime", headerName: 'To Time', },
            {
                field: "PaymentSubContract", headerName: 'Payment Sub Contract',
                cellRenderer: function (params) {
                    if (params.value && params.value != "") {
                        return $filter('camelCaseToSpace')(params.value);
                    }
                }
            },
            {
                field: "LastModifiedByName", headerName: 'Modified By',
            },
            {
                field: "LastModifiedDate", headerName: 'Modified Date',
                valueFormatter: function (params) {
                    var normalized = normalizeDateStringForLocalDateFilter(params.value);
                    if (!normalized) {
                        return '';
                    }
                    return $filter('localDate')(normalized, false, new Date());
                },
            },


            { field: "Edit", cellRenderer: editCellTemplate, minWidth: 40, maxWidth: 40, sortable: false, },
        ];
        var gridOptions = {
            masterDetail: true,
            detailRowAutoHeight: true,
            columnDefs: ColumnDefs,
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: []
            },
            rowModelType: 'serverSide',
            suppressAggFuncInHeader: true,
            cacheBlockSize: PageSize,
            suppressContextMenu: true,
            alwaysShowVerticalScroll: true,
            alwaysShowHorizontalScroll: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            localeText: { loadingError: 'Some error has occurred!' },
            getRowId: function (params) {
                return Math.random().toString();
            },
            //Grid Events
            onCellClicked: function (params) {
                if (params.column.colId == "Edit") {
                    var filter = {};
                    var type = params.data.PaymentContract;
                    switch (type) {
                        case 'PayPerRVU':
                            filter.RVUChargeID = params.data.RVUChargeID;
                            break;
                        case 'PayPerProcedure':
                            filter.ModalityCPTChargeID = params.data.ModalityCPTChargeID;
                            break;
                        case 'PayPerShift':
                            if (params.data.PaymentSubContract == 'PayPerRVU') {
                                filter.RVUChargeID = params.data.RVUChargeID;
                            }
                            else if (params.data.PaymentSubContract == 'PayPerProcedure') {
                                filter.ModalityCPTChargeID = params.data.ModalityCPTChargeID;
                            }
                            else {
                                filter.ShiftChargesID = params.data.ShiftChargesID;
                            }
                            break;
                    }
                    PaymentContractService.GetPaymentContractDetail(filter).then(function (result) {
                        $scope.AddEditPaymentContract(result);
                    });
                }
            },
            onGridReady: function () {
                var datasource = createServerSideDatasource();
                gridOptions.api.setServerSideDatasource(datasource);
            },
            onSortChanged: function (params) {
                resetGrid();
            },
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },
        };

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }

        function createServerSideDatasource() {
            return {
                getRows: function (params) {

                    if (params.request.sortModel.length > 0) {
                        OrderByField = params.request.sortModel[0].colId;
                        OrderBy = params.request.sortModel[0].sort;
                    }
                    PageNum = params.request.endRow / PageSize;
                    $scope.loading = true;
                    var promise = GetPaymentContractList();
                    promise.then(function (data) {
                        if ($scope.PaymentContractList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            gridOptions.api.hideOverlay();
                        }
                        var rowsForBlock = $scope.PaymentContractList.slice(params.request.startRow, params.request.endRow);
                        params.success({
                            rowData: rowsForBlock,
                            rowCount: undefined,
                        });
                        $scope.loading = false;
                    }, function (err) {
                        console.log("Error > ", err);
                        params.fail();
                        $scope.loading = false;
                    });
                    /*server.getData(params.request).then(function (response) {
                        if (response.success) {
                            params.success({
                                rowData: response.rows,
                                rowCount: response.lastRow,
                            });
                        } else {
                            params.fail();
                        }
                    });*/
                },
            };
        }
        $scope.OnTabChanged = function (PaymentContractSelection) {
            $scope.paymentContractList = [];
            $scope.MasterRadiologistsFullSet = [];
            $scope.PaymentContractSelection = PaymentContractSelection;
            gridOptions.columnApi.resetColumnState();
            gridOptions.columnApi.applyColumnState({ state: [{ colId: 'LastModifiedDate', sort: 'desc' }], });
            selColumnVisibility(PaymentContractSelection);
            resetGrid();
            $scope.MultiSelectDropdown.RadiologistFilterPC.UserList = [];
            $scope.GetPaymentContractUsers();
            GetPaymentContractUsersFullList();
        }

        $scope.AddEditPaymentContract = function (data) {
            $scope.clearData();
            if (!data) {
                $('#ModalAddEditPaymentContract').modal('show');
            }
            else if (data.contract) {
                $('#ModalAddEditPaymentContract').modal('show');
                EditedRow = data.contract;// assigning data into other variable
                $scope.DisablePaymentContract = true;

                $scope.PaymentContractName = data.contract.PaymentContractName;
                $scope.Price = data.contract.Price;

                if ($scope.PaymentContractSelection == "HelperShift") {
                    $scope.PaymentContractHelperShift.Obj = _.find($scope.PaymentContractHelperTypes, { Key: data.contract.PaymentSubContract });
                }

                if ($scope.PaymentContractSelection == "PayPerShift") {
                    $scope.FromDate = setDateTime('date', data.contract.FromDate);
                    $scope.ToDate = setDateTime('date', data.contract.ToDate);
                    $scope.FromTime = setDateTime('time', data.contract.FromTime);
                    $scope.ToTime = setDateTime('time', data.contract.ToTime);
                    $scope.DoNotRepeat = data.contract.DoNotRepeat;
                }

                if ($scope.PaymentContractSelection == 'PayPerProcedure' ||
                    ($scope.PaymentContractHelperShift.Obj && $scope.PaymentContractHelperShift.Obj.Key == 'PayPerProcedure')) {

                    $scope.SelectedModality.Obj = _.find($scope.Modalities, { Code: data.contract.Modality });

                    if (data.contract.CPTCodes) {
                        $scope.SelectedCPT.Obj = [];
                        $scope.CptCodeTooltip = '';
                        $scope.isCPTVisible = true;
                        var cptCodes = data.contract.CPTCodes.split(",");
                        _.each(cptCodes, function (cptCode) {
                            var cpt = _.find($scope.CPTList, { 'CPT_Code': cptCode });
                            if (cpt) {
                                $scope.CptCodeTooltip += CptTooltip(cpt);
                                $scope.SelectedCPT.Obj.push(cpt);
                            }
                            else {
                                $scope.GetCPTList(cptCode).then(function (data) {
                                    cpt = _.find($scope.CPTList, { 'CPT_Code': cptCode });
                                    $scope.SelectedCPT.Obj.push(cpt);
                                    $scope.CptCodeTooltip += CptTooltip(cpt);
                                });
                            }
                        });
                    }
                }

                if (data.contract.LocationIDs) {
                    $scope.SelectedData.Location = [];
                    $scope.isLocationVisible = true;
                    var locationIds = data.contract.LocationIDs.split(",");
                    _.each(locationIds, function (locID) {
                        var loc = _.find($scope.MasterData.Locations, { 'LocationID': locID });
                        if (loc) {
                            $scope.SelectedData.Location.push(loc);
                        }
                    });
                }
                $scope.SelectedData.locationIDs = data.contract.LocationIDs;
                $scope.SelectedLocations.AddEdit.Location = $scope.SelectedData.Location;
                $scope.SelectedLocations.AddEdit.Ids = $scope.SelectedData.locationIDs;
                $scope.DataObject.SelectedPaymentContractDetail.PaymentAccountType = _.find($scope.DataObject.PaymentAccountTypes, { Value: EditedRow.PaymentAccountType });

                $scope.SelectedValues.SelectedRadiologists = data.assignedTo;
            }
        };

        $scope.GetCPTList = function (search) {
            var d = $q.defer();
            MappingService.GetMappedCPTWRVUList({
                SearchKey: search
            }).then(function (result) {
                $scope.CPTList = result;
                d.resolve(result);
            });
            return d.promise;
        }

        function GetLookupTypes() {
            PaymentContractService.GetLookupByType('PaymentContract,PaymentAcountType').then(function (result) {
                $scope.PaymentContractTypes = _.filter(result, { Type: 'PaymentContract' });
                $scope.DataObject.PaymentAccountTypes = _.filter(result, { Type: 'PaymentAcountType' });
                $scope.PaymentContractHelperTypes = _.filter($scope.PaymentContractTypes, function (value) { return value.Value != 'Payment Per Shift' });
            });
        };
        function GetModality() {
            WorklistService.GetModality().then(function (result) {
                $scope.Modalities = result;
            });
        }

        $scope.SaveOrEdit = function () {
            /*if ($sessionStorage.BillAPIEnable) {
                var emptyAddressOfUsers = _.filter($scope.SelectedValues.SelectedRadiologists, function (item) { return _.isEmpty(item.VendorID); });
                if (emptyAddressOfUsers && emptyAddressOfUsers.length > 0) {
                    var message = "<span class='fw-600'>The selected users must create vendors on Bill.com to establish a payment contract.</span>";
                    message += "<ul>";
                    _.each(emptyAddressOfUsers, function (item) {
                        message += "<li>" + item.LastName + ", " + item.FirstName + " (" + item.Email + ")</li>";
                    });
                    message += "</ul>";
                    toaster.error({
                        type: 'error',
                        body: message,
                        bodyOutputType: 'trustedHtml'
                    });
                    return;
                }
            }*/

            $scope.DataObject.isSaveEditBtnDisable = true;
            var PaymentContract = {};
            var locationMapping = [];
            var UserIDs = [];
            //this will make array object of selected CPT's [dataTable]
            if ($scope.SelectedCPT && $scope.SelectedCPT.Obj && $scope.SelectedCPT.Obj.length > 0) {
                var cptCodes = [];
                _.each($scope.SelectedCPT.Obj, function (item) {
                    cptCodes.push({ "CPTCode": item.CPT_Code });
                });
                $scope.SelectedCPT.Values = cptCodes;
            }
            //this will make array object of selected Location's [dataTable]
            if ($scope.SelectedData && $scope.SelectedData.Location && $scope.SelectedData.Location.length > 0) {
                _.each($scope.SelectedData.Location, function (location) {
                    if (location) {
                        var obj = {};
                        obj["TenantID"] = null;
                        obj["SiteID"] = location.SiteID;
                        obj["LocationID"] = location.LocationID;
                        locationMapping.push(obj);
                    }
                });
            }
            //this will make array object of selected Radiologist's [dataTable]
            if ($scope.SelectedValues.SelectedRadiologists && $scope.SelectedValues.SelectedRadiologists.length > 0) {
                _.each($scope.SelectedValues.SelectedRadiologists, function (user) {
                    if (user) {
                        var obj = {};
                        obj["UserID"] = user.Id;
                        UserIDs.push(obj);
                    }
                });
            }
            //this will check whether in PayPerShift From Date will not be greater than To Date
            /*if ($scope.PaymentContract.Obj.Key == 'PayPerShift' && !$scope.PaymentContractHelperShift) {
                var fromdatetime = setDateTime('time', $scope.FromTime.getHours());
                var todatetime = setDateTime('time', $scope.ToTime.getHours());

                if (fromdatetime > todatetime) { swal("From date time can not be greater than to date time"); return; };
            }*/
            //initializing setPaymentContract object 
            PaymentContract = {
                PaymentContractName: $scope.PaymentContractName,
                PaymentContract: $scope.PaymentContractSelection,
                Modality: $scope.SelectedModality.Obj ? $scope.SelectedModality.Obj.Code : $scope.SelectedModality.Obj,
                CPTCode: $scope.SelectedCPT.Values,
                LocationMapping: locationMapping,
                CreatedBy: $sessionStorage.currentUserData.userId,
                StatusFlag: (EditedRow) ? 'M' : 'N',
                PercentageValue: $scope.PercentageValue,
                Price: $scope.Price,
                UserIDs: UserIDs,
            };
            //this add other values in PaymentContract object related to PayPerShift
            if ($scope.PaymentContractSelection == 'PayPerShift' && !$scope.PaymentContractHelperShift.Obj) {
                PaymentContract.FromDate = $scope.FromDate ? formatted_date($scope.FromDate) : $scope.FromDate;
                PaymentContract.ToDate = $scope.ToDate ? formatted_date($scope.ToDate) : $scope.ToDate;
                PaymentContract.FromTime = $scope.FromTime ? formatted_time($scope.FromTime) : $scope.FromTime;
                PaymentContract.ToTime = $scope.ToTime ? formatted_time($scope.ToTime) : $scope.ToTime;
                PaymentContract.DoNotRepeat = $scope.DoNotRepeat ? '1' : '0';
            }
            if ($scope.PaymentContractSelection == 'PayPerShift' && $scope.PaymentContractHelperShift.Obj) {
                PaymentContract.PaymentSubContract = ($scope.PaymentContractHelperShift.Obj && $scope.PaymentContractHelperShift.Obj.Key) ? $scope.PaymentContractHelperShift.Obj.Key : $scope.PaymentContractHelperShift.Obj;
            }

            //this will add id's regarding edited record
            if (EditedRow) {
                PaymentContract.ModalityCPTChargeID = EditedRow.ModalityCPTChargeID;
                PaymentContract.RVUChargeID = EditedRow.RVUChargeID;
                PaymentContract.ShiftChargesID = EditedRow.ShiftChargesID;
            }
            PaymentContract.BillAPIVendorSession = {
                Users: $scope.SelectedValues.SelectedRadiologists
            }
            PaymentContract.PaymentAccountType = $scope.DataObject.SelectedPaymentContractDetail.PaymentAccountType.Value;
            PaymentContractService.SetPaymentContractList(PaymentContract).then(function (result) {
                var resultPaymentContract = _.head(result);
                /*if ($sessionStorage.BillAPIEnable) {

                    //Update Vendor ID
                    var addresses = [];

                    if (resultPaymentContract.BillAPICreateVendorResponse && resultPaymentContract.BillAPICreateVendorResponse.HasError) {
                        toaster.error("Please update the address properly for the selected users to update a payment contract.");
                    }
                    if (resultPaymentContract.BillAPIVendorSession && resultPaymentContract.BillAPIVendorSession.Users) {
                        _.each(resultPaymentContract.BillAPIVendorSession.Users, function (item) {
                            var address = {
                                AddressLine1: item.AddressLine1,
                                AddressLine2: item.AddressLine2,
                                City: item.City,
                                State: item.State,
                                PostalCode: item.PostalCode,
                                CountryCode: item.CountryCode,
                                UserId: item.Id,
                                VendorID: item.VendorID,
                                CreatedBy: $sessionStorage.currentUserData.userId,
                                ModifiedBy: $sessionStorage.currentUserData.userId,
                            }
                            addresses.push(address);
                        });
                        if (addresses.length > 0) {
                            AccountManagerService.UpdateUserVendorDetail(addresses);
                        }
                    }
                }*/


                $scope.FilterPaymentContractList();
                if (resultPaymentContract.IsExists) {
                    toaster.error("Payment contract with same location already exists.");
                }
                else {
                    toaster.success("Payment contract saved successfully.");
                    $('#ModalAddEditPaymentContract').modal('hide');
                }
                $scope.clearData();
                $scope.DataObject.isSaveEditBtnDisable = false;

            }, function (error) {
                toaster.error("Error saving payment contract.");
                $('#ModalAddEditPaymentContract').modal('hide');
                $scope.clearData();
                $scope.DataObject.isSaveEditBtnDisable = false;
            });
        };

        $scope.onModalityCPTChange = function (obj) {
            if (obj && obj.Code) { $scope.SelectedModality.Obj = obj; }
            else { $scope.SelectedCPT.Obj = obj; }
        }

        function GetSitesAndLocation() {

            PaymentContractService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.MasterData.Locations = _.filter(result, function (obj) { return obj.SiteID != 0; });
            })
        }

        function GetPaymentContractList() {
            var d = $q.defer();
            var filter = {
                PaymentContractName: $scope.PaymentContractNameFilter,
                PaymentContract: $scope.PaymentContractSelection,
                PageNum: PageNum,
                PageSize: PageSize,
                LocationID: $scope.SelectedDataFilter.locationIDs,
                OrderByField: OrderByField,
                OrderBy: OrderBy,
                UserIDs: _.join(_.map($scope.SelectedProvider.obj, function (provider) { return provider.Id; }), ','),
            }
            PaymentContractService.GetPaymentContract(filter).then(function (result) {
                $scope.PaymentContractList = _.concat($scope.PaymentContractList, result.paymentContractList);
                _.each($scope.PaymentContractList, function (contract) {
                    if (contract.UserIDs) {
                        contract.AssignRadiologists = [];
                        _.each(contract.UserIDs.split(','), function (id) {
                            var obj = _.find($scope.RadiologistsFullSet, { Id: id });
                            if (obj) {
                                contract.AssignRadiologists.push(obj);
                            }
                        });
                    }
                });
                TotalPageRows = result.count.PageCounts;
                showHideStatusBar();
                d.resolve(result.paymentContractList);
            }).catch(function (ex) {
                showHideStatusBar();
                d.reject(ex);
            });
            return d.promise;
        }

        $scope.clearFilter = function () {
            $scope.PaymentContractNameFilter = null;
            $scope.SelectedDataFilter = { locationIDs: null, Location: null };
            $scope.FilterPaymentContractList();
            $scope.clearProviders();
            $scope.SelectedLocationFilterValues = { SelectedItems: [] };
            $scope.SelectedLocations.Filter = {
                Ids: '',
                locations: [],
                divId: "PaymentContractFilter"
            };
        }

        $scope.FilterPaymentContractList = function () {
            resetGrid();
        };

        function resetGrid() {
            $scope.PaymentContractList = [];
            PageNum = 0;
            if (gridOptions.api) gridOptions.api.refreshServerSide({ purge: true });
        }


        //#endregion
        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };
        $scope.AddUsers = function () {
            $('#RadiologistComponentPaymentContract').modal('show');
            $scope.SavebtnText = 'OK';
            $scope.modalTitle = 'Add Radiologists';
        };
        $scope.GetPaymentContractUsers = function (searchKey) {
            var d = $q.defer();
            var filter = {
                UserId: $sessionStorage.currentUserData.userId,
                PaymentContract: $scope.PaymentContractSelection,
                PaymentSubContract: ($scope.PaymentContractHelperShift.Obj && $scope.PaymentContractHelperShift.Obj.Key) ? $scope.PaymentContractHelperShift.Obj.Key : $scope.PaymentContractHelperShift.Obj,
            };
            filter.Search = (searchKey) ? searchKey : null;
            if (searchKey || ($scope.MultiSelectDropdown.RadiologistFilterPC.UserList.length == 0)) {
                PaymentContractService.GetPaymentContractUsers(filter).then(function (result) {
                    $scope.MultiSelectDropdown.RadiologistFilterPC.UserList = _.uniqBy(_.concat($scope.MultiSelectDropdown.RadiologistFilterPC.UserList, result), 'Id');
                    d.resolve();
                });
            }
            return d.promise;
        }

        $scope.onRadiologistFilterSelect = function () {
            if ($scope.SelectedProvider.obj && $scope.SelectedProvider.obj.length > 0) {
                $scope.RadiologistFilterTooltip = _.join(_.map($scope.SelectedProvider.obj, function (provider) { return provider.LastName + ', ' + provider.FirstName; }), '\n')
                $scope.htSelRadio = angular.element('.htSelRadio').height();
            } else {
                $scope.clearProviders();
            }
        }
        $scope.clearProviders = function () {
            $scope.SelectedProvider.obj = null;
            $scope.MultiSelectDropdown.RadiologistFilterPC.SelectedValue = {
                list: []
            }
            $scope.RadiologistFilterTooltip = "Select Radiologist";
            setTimeout(function () {
                if (angular.element('.htSelRadio').children().length > 0) {
                    $scope.htSelRadio = angular.element('.htSelRadio').height() - 25;
                } else {
                    $scope.htSelRadio = angular.element('.htSelRadio').height();
                }
            }, 0);
        }
        $scope.clearData = function () {
            $scope.PaymentContractName = null;
            $scope.isLocationVisible = false;
            $scope.Price = null;
            $scope.PercentageValue = null;
            $scope.DisablePaymentContract = false;
            $scope.isCPTVisible = false;
            $scope.SelectedModality.Obj = null;
            $scope.SelectedCPT = { Obj: null };
            $scope.formPaymentContract.$setUntouched();
            $scope.SelectedValues = { SelectedRadiologists: [] }
            $scope.CptCodeTooltip = 'Choose a CPT';
            var SelectedData = { locationIDs: null, Location: null };
            $scope.SelectedData = SelectedData;
            $scope.FromDate = setDateTime('date', moment(new Date()).format('MM/DD/YYYY'));
            $scope.ToDate = setDateTime('date', moment(new Date()).format('MM/DD/YYYY'));
            $scope.ToTime = setDateTime('time', '08:00');
            $scope.FromTime = setDateTime('time', '00:00');
            $scope.DoNotRepeat = false;
            EditedRow = null;
            $scope.PaymentContractHelperShift.Obj = null;
            $scope.SelectedLocations.AddEdit = {
                Ids: '',
                locations: [],
                divId: "PaymentContractAddEdit"
            };
            $scope.DataObject.isSaveEditBtnDisable = false;
            $scope.DataObject.SelectedPaymentContractDetail.PaymentAccountType = null;
        }
        $scope.onCptSelect = function () {
            if ($scope.SelectedCPT.Obj && $scope.SelectedCPT.Obj.length > 0) {
                $scope.CptCodeTooltip = _.join(_.map($scope.SelectedCPT.Obj, function (cpt) { return CptTooltip(cpt); }), '')
            }
            else {
                $scope.CptCodeTooltip = 'Choose a CPT';
            }
        }

        function CptTooltip(cpt) {
            return cpt.CPT_Code + '\n';
        }

        $scope.AssignUserCancel = function () {
            if (EditedRow) {
                if (EditedRow.UserIDs) {
                    $scope.SelectedValues.SelectedRadiologists = [];
                    _.each(EditedRow.UserIDs.split(','), function (id) {
                        var obj = _.find($scope.RadiologistsFullSet, { Id: id });
                        if (obj) {
                            $scope.SelectedValues.SelectedRadiologists.push(obj);
                        }
                    });
                }
            }
            else {
                $scope.SelectedValues.SelectedRadiologists = [];
            }
        }
        $scope.SaveAddUsers = function () {
            $('#RadiologistComponentPaymentContract').modal('hide');
        };

        //#region Start/End Date and Time
        $scope.dosFromDateOpen = function () {
            $scope.dosFromDatePopup.opened = true;
        };
        $scope.dosToDateOpen = function () {
            $scope.dosToDatePopup.opened = true;
        };
        var formatted_date = function (date) {
            if (date != null) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero 
                var y = date.getFullYear();
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        var formatted_time = function (date) {
            if (date != null) {
                var h = ("0" + (date.getHours())).slice(-2); // in javascript month start from 0.
                var m = ("0" + date.getMinutes()).slice(-2); // add leading zero             
                return h + ':' + m;
            }
            else {
                return null;
            }
        };
        //#endregion

        //selColumnVisibility() function will hide and show the columns as per payment contract . User won't be able to hide any columns
        function selColumnVisibility(tabName) {
            switch (tabName) {
                case "PayPerRVU":
                    gridOptions.columnApi.setColumnsVisible(['Modality', 'FromDate', 'FromTime', 'ToDate', 'ToTime', 'PaymentSubContract'], false);
                    break;
                case "PayPerProcedure":
                    gridOptions.columnApi.setColumnsVisible(['FromDate', 'FromTime', 'ToDate', 'ToTime', 'PaymentSubContract'], false);
                    gridOptions.columnApi.setColumnsVisible(['Modality'], true);
                    break;
                case "PayPerShift":
                    gridOptions.columnApi.setColumnsVisible(['Modality', 'PaymentSubContract'], false);
                    gridOptions.columnApi.setColumnsVisible(['FromDate', 'FromTime', 'ToDate', 'ToTime'], true);
                    break;
                case "HelperShift":
                    gridOptions.columnApi.setColumnsVisible(['FromDate', 'FromTime', 'ToDate', 'ToTime'], false);
                    gridOptions.columnApi.setColumnsVisible(['Modality', 'PaymentSubContract'], true);
                    break;
            }
        }
        function showHideStatusBar() {
            var statusBarComponent = gridOptions.api.getStatusPanel('GridFooter');
            if ($scope.PaymentContractList.length == 0) {
                statusBarComponent.eGui.hidden = true;
            } else {
                statusBarComponent.eGui.hidden = false;
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
                statusBarComponent.eGui.textContent = 'Showing ' + $scope.PaymentContractList.length + ' of ' + TotalPageRows + ' Total Records';
                statusBarComponent.eGui.style.color = 'white';
            }
        }
        $scope.clearAllCPT = function () {
            $scope.SelectedCPT = { Obj: null };
            $scope.CptCodeTooltip = 'Choose a CPT';
        };

        function setDateTime(type, value) {
            var date_time = new Date();
            if (type == 'time') {
                date_time.setHours(value.split(':')[0]);
                date_time.setMinutes(value.split(':')[1]);
            }
            if (type == 'date') {
                value = value.includes(' ') ? value.split(' ')[0] : value;
                date_time.setDate(value.split('/')[1]);
                date_time.setMonth(parseInt(value.split('/')[0]) - 1);
                date_time.setFullYear(value.split('/')[2]);
            }
            return date_time;
        }

        $scope.updateLocationFilterData = function () {
            $scope.SelectedDataFilter.Location = $scope.SelectedLocations.Filter.locations;
            $scope.SelectedDataFilter.locationIDs = $scope.SelectedLocations.Filter.Ids;
        }
        $scope.updateLocationData = function () {
            $scope.SelectedData.Location = $scope.SelectedLocations.AddEdit.locations;
            $scope.SelectedData.locationIDs = $scope.SelectedLocations.AddEdit.Ids;
        }

        function GetPaymentContractUsersFullList() {
            var d = $q.defer();
            if ($scope.MasterRadiologistsFullSet.length == 0) {
                var filter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    PaymentContract: $scope.PaymentContractSelection,
                    PaymentSubContract: ($scope.PaymentContractHelperShift.Obj && $scope.PaymentContractHelperShift.Obj.Key) ? $scope.PaymentContractHelperShift.Obj.Key : $scope.PaymentContractHelperShift.Obj,

                };
                RuleService.GetAllUserByTenant(filter).then(function (result) {
                    result = _.filter(result, function (user) {
                        if (user && user.UserRoles && user.UserRoles.split(',').length > 0) {
                            return user.UserRoles.split(',').includes('User');
                        }
                    });
                    $scope.RadiologistsFullSet = _.uniqBy(result, 'Id');
                    $scope.MasterRadiologistsFullSet = _.uniqBy(result, 'Id');
                    $scope.MasterData.Radiologists = _.uniqBy(result, 'Id');
                    d.resolve();
                });
            }
            else {
                d.resolve();
            }
            return d.promise;
        };
        PageInIt();

        $scope.$on('$destroy', function () {
            CommonService.stopNotifyTATStudy();
        });

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();
angular.module('radico.pages.settings.paymentcontract')
    .service('PaymentContractService', ['Restangular', '$http', 'APP_CONSTANTS', function (Restangular, $http, APP_CONSTANTS) {
        this.GetPaymentContract = function (paymentContractList) {
            return Restangular.one("GetPaymentContract").customPOST(paymentContractList);
        };
        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };
        this.SetPaymentContractList = function (setPaymentContract) {
            return Restangular.one("SetPaymentContractList").customPOST(setPaymentContract);
        };
        this.GetSitesAndLocationsByUserID = function (userID) {
            return Restangular.one('psorders').one("GetSitesAndLocationsByUserID", userID).get();
        };
        this.GetUserPaymentSummary = function (summeryFilter) {
            return Restangular.one("GetUserPaymentSummary").customPOST(summeryFilter);
        }
        this.GetTenantsAndSiteAndLocation = function (filter) {
            return Restangular.one("GetTenantsAndSiteAndLocation").customPOST(filter);
        };
        this.GetPaymentContractDetail = function (paymentContractList) {
            return Restangular.one("GetPaymentContractDetail").customPOST(paymentContractList);
        };
        this.GetMappedCPTWRVUList = function (params) {
            return Restangular.one('Settings').one("GetMappedCPTWRVUList").customPOST(params);
        };
        this.GetUserPayments = function (params) {
            return Restangular.one("GetUserPayments").customPOST(params);
        };
        this.GetUserPaymentHeader = function (params) {
            return Restangular.one("GetUserPaymentHeader").customPOST(params);
        };

        this.SetInvoice = function (params) {
            return Restangular.one("SetInvoice").customPOST(params);
        };
        this.GetInvoiceDetail = function (params) {
            return Restangular.one("GetInvoiceDetail").customPOST(params);
        };
        this.GetPaymentMethod = function () {
            return Restangular.one("GetPaymentMethod").customPOST();
        };
        this.GetInvoiceStatus = function () {
            return Restangular.one("GetInvoiceStatus").customPOST();
        };
        this.GetInvoicePaymentDetail = function (params) {
            return Restangular.one("GetInvoicePaymentDetail").customPOST(params);
        };
        this.SetInvoicePayment = function (params) {
            return Restangular.one("SetInvoicePayment").customPOST(params);
        };

        this.UpdateInvoice = function (params) {
            return Restangular.one("UpdateInvoice").customPOST(params);
        };
        this.GetInvoiceByInvoiceID = function (params) {
            return Restangular.one("GetInvoiceByInvoiceID").customPOST(params);
        };
        this.GetPaymentContractByUserByID = function (params) {
            return Restangular.one("GetPaymentContractByUserByID").customPOST(params);
        };
        this.GetInvoiceNotesByInvoiceID = function (params) {
            return Restangular.one("GetInvoiceNotesByInvoiceID").customPOST(params);
        };
        this.GetRemainingPaymentSummary = function (params) {
            return Restangular.one("GetRemainingPaymentSummary").customPOST(params);
        };
        this.SendInvoice = function (params) {
            return Restangular.one("SendInvoice").customPOST(params);
        };
        this.GetUserPaymentDetailExport = function (params) {
            return Restangular.one("GetUserPaymentDetailExport").customPOST(params);
        };
        //Payment Invoice History 
        this.GetUserInvoice = function (params) {
            return Restangular.one("GetUserInvoice").customPOST(params);
        };
        this.GetUserInvoiceDetail = function (params) {
            return Restangular.one("GetUserInvoiceDetail").customPOST(params);
        };
        this.DownloadUserInvoicePDF = function (params) {
            return Restangular.one("DownloadUserInvoicePDF").customPOST(params);
        };
        this.GenerateUserInvoicePDF = function (params) {
            return Restangular.one("GenerateUserInvoicePDF").customPOST(params);
        };
        this.GetAllUserInvoicePDFs = function (params) {
            return Restangular.one("GetAllUserInvoicePDFs").customPOST(params);
        };
        this.GetVendors = function (params) {
            return Restangular.one("GetVendors").customPOST(params);
        };
        this.GetPaymentContractUsers = function (params) {
            return Restangular.one("GetPaymentContractUsers").customPOST(params);
        };
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.settings.rule')
        .controller('RuleController', RuleController);
    function RuleController($scope, $sessionStorage, RuleService, $timeout, RuleSharedService, $q, uuidv4, $compile, TATNotificationService, toaster, CommonService, SharedService, ManageLocationService) {

        var TimeoutList = [];
        //var onCallCtrl = this;
        $scope.title = "Rule(s)";
        /*$scope.PageSize = "25";*/

        //$scope.CurrentPage = "1";
        $scope.TotalCount = "0";
        $scope.FilterCount = "0";

        $scope.Filter = {

            PageSize: "25",
            PageNum: "1",
            RuleName: "",
            Priority: "AL",
            Status: "E",
            OrderByField: "",
            OrderBy: "",
            IsWorkList: "1",
            TenantID: null   // TAT Rules tab only: exact-match tenant filter; null = All Tenants
        };

        $scope.PriorityList = [{
            key: 'AL',
            value: 'All'
        },
        {
            key: 'HP',
            value: 'High Priority'
        },
        {
            key: 'NP',
            value: 'Normal Priority'
        },];

        $scope.StatusList = [{
            key: 'AL',
            value: 'All'
        },
        {
            key: 'D',
            value: 'Disabled'
        },
        {
            key: 'E',
            value: 'Enabled'
        },
        ];

        $scope.selectedPriority = {
            Obj: {
                key: 'AL',
                value: 'All'
            }
        };
        $scope.selectedStatus = {
            Obj: {
                key: 'E',
                value: 'Enabled'
            }
        };

        $scope.opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            //cancelButtonClasses: 'dr-btn-none',
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                customRangeLabel: 'Custom range',
                //cancelLabel: 'Clear',
                //clearLabel: $scope.DateValue = {
                //    startDate: null,
                //    endDate: null
                //}
            },
            ranges: {
                'Today': [moment(), moment()],
                //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                //'Last 15 Days': [moment().subtract(14, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                //'This Month': [moment().startOf('month'), moment().endOf('month')],
                //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
                //'All DOS': [],

            }
        };
        $scope.ShowListView = true;
        $scope.ShowFilter = true;
        $scope.selectedRadiologists = [];
        $scope.Rule = { Groups: [], RulesProviders: [] };
        $scope.RadiologistsFullSet = [];
        $scope.MasterRadiologistsFullSet = [];
        // Radiologist filter dropdown: users mapped to the caller's accessible sites (UserAndSiteMap).
        // Kept separate from MasterRadiologistsFullSet, which the shared cache uses to resolve a
        // rule's assigned providers in the detail panel.
        $scope.FilterRadiologists = [];
        // TAT Rules tab tenant filter: the signed-in user's tenants in GetTenantsByUserID order (default
        // tenant first). The first one is selected whenever that tab is entered or cleared; there is no
        // "All Tenants" choice, so the TAT list is always one tenant's rules.
        $scope.TenantList = [];
        $scope.selectedTenant = { Obj: null };
        var tenantsPromise = null;
        $scope.DataObject = {
            isRuleDetailsVisible: false,
            RuleDetail: {},
            activeRow: null,
            isFilterLoading: false,
            UserFilterMultiSelect: {
                divId: "UserFilterMultiSelect",
                keys: ['LastName', 'FirstName'],
                uniqKey: 'Id',
                SelectedValue: { list: [] },
                onSelectUser: function (selectedData) {
                    $scope.Filter.Provider = selectedData;
                }
            },
        };
        $scope.DeleteRule = function (rule) {
            if (rule.IsWorkList == "2") {
                GetTATSchedules({ UserID: $sessionStorage.currentUserData.userId, RuleID: rule.RuleID }).then(function (result) {
                    if (result && result.TATSchedulesList && result.TATSchedulesList.length > 0) {
                        toaster.pop({ type: 'warning', body: rule.RuleName + " is mapped with " + result.TATSchedulesList[0].ScheduleName + " TAT Notification Schedule." });
                    }
                    else {
                        deleteSelectedRule(rule);
                    }
                });
            }
            else {
                deleteSelectedRule(rule);
            }
        };
        function deleteSelectedRule(rule) {
            swal({
                title: "Are you sure you want to delete rule?",
                //text: "Want to delete rule!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55", confirmButtonText: "Yes",
                cancelButtonText: "No",
            }, function (isConfirm) {
                if (isConfirm) {
                    $scope.DataObject.isFilterLoading = true;
                    $q.all([
                        RuleSharedService.DeleteRule(rule)
                    ]).then(function (data) {
                        $scope.DataObject.isFilterLoading = false;
                        $scope.GetRuleList();
                    });
                }
            });
        }

        function GetTATSchedules(params) {
            var d = $q.defer();
            TATNotificationService.GetTATSchedules(params).then(function (result) {
                d.resolve(result);
            }, function (err) { d.resolve([]); });
            return d.promise;
        }
        $scope.Init = function () {
            CommonService.startNotifyTATStudy();
            $scope.Rule.gridId = uuidv4.newuuid();;
            ReSetMasterData();
            $q.all([
                GetAllRadiologists()
            ]).then(function (data) {
                $scope.GetRuleList();
                createRuleMenu();
            });
            GetTenantsByUserID();
            GetFilterRadiologistsByAccessibleSites(null);
        };
        function createRuleMenu() {
            tippy('#addRuleBtn', {
                content: getRuleMenuContent(),
                arrow: false,
                interactive: true,
                theme: 'material',
                trigger: 'mouseenter click'
            });

        }
        function getRuleMenuContent() {
            var ruleOptionMenu = document.createElement('div');
            ruleOptionMenu.innerHTML = '<div class="form-controller d-flex align-item-center mb-1" id="menulist">' +
                '<ul class="p-0 add-rule-menu mb-0" style="list-style:none">' +
                '<li class="cursor-pointer px-10px" ng-click="AddRule(\'1\')">Create Worklist</li>' +
                '<li class="cursor-pointer px-10px" ng-click="AddRule(\'2\')">Create TAT Rule</li>' +
                '<li class="cursor-pointer px-10px" ng-click="AddRule(\'0\')">Create Rule</li>' +
                '</ul>' +
                '</div > '
            var newScope = $scope.$new();
            $compile(ruleOptionMenu)(newScope);
            var timeout = $timeout(newScope.$apply.bind(newScope), 0);
            TimeoutList.push(timeout);
            return ruleOptionMenu;
        }
        //#region Tab Change
        $scope.currentTab = {
            Worklists: true,
            TATRules: false,
            Rules: false,
        };
        $scope.changeTab = function (tab) {
            $scope.currentTab = {
                Worklists: false,
                TATRules: false,
                Rules: false,
            };
            switch (tab) {
                case 'Worklists':
                    $scope.currentTab.Worklists = true;
                    $scope.Filter.IsWorkList = '1';
                    break;
                case 'TATRules':
                    $scope.currentTab.TATRules = true;
                    $scope.Filter.IsWorkList = '2';
                    break;
                case 'Rules':
                    $scope.currentTab.Rules = true;
                    $scope.Filter.IsWorkList = '0';
                    break;
            }
            // TAT tab: first tenant selected, no radiologist filter. Other tabs: no tenant filter
            // (worklists/rules have no TenantID) and radiologists of every accessible site.
            syncTenantFilterForTab().then(function () {
                $scope.GetRuleList();
            });
        }
        //#endregion Change Tab

        $scope.changePageSize = function () {
            $scope.Filter.PageNum = "1";
            $scope.GetRuleList();
        };

        $scope.pageChanged = function () {
            $scope.GetRuleList();
        };
        $scope.SortFilter = function (OrderByField) {
            $scope.Filter.PageNum = 1;
            $scope.Filter.PageSize = "25";
            $scope.Filter.OrderByField = OrderByField;
            $scope.ReverseSort = !$scope.ReverseSort;
            $scope.Filter.OrderBy = $scope.ReverseSort;
            $scope.GetRuleList();
        };


        $scope.clearFilterAndRefesh = function () {
            $scope.Filter.PageNum = 1;
            $scope.Filter.PageSize = "25";
            $scope.Filter.OrderByField = "";
            $scope.Filter.OrderBy = "";
            $scope.Filter.RuleName = "";
            $scope.Filter.Priority = "AL";
            $scope.Filter.Status = "E";
            $scope.selectedPriority = {
                Obj: {
                    key: 'AL',
                    value: 'All'
                }
            };
            $scope.selectedStatus = {
                Obj: {
                    key: 'E',
                    value: 'Enabled'
                }
            };
            // $scope.Filter.Provider = [];
            $scope.clearProvider();
            syncTenantFilterForTab().then(function () {
                $scope.GetRuleList();
            });
        }

        $scope.GetRuleList = function () {
            $scope.DataObject.isFilterLoading = true;
            $scope.DataObject.isRuleDetailsVisible = false;
            $scope.DataObject.activeRow = null;
            $scope.Filter.UserID = $sessionStorage.currentUserData.userId;
            RuleService.GetRuleList($scope.Filter).then(function (result) {
                $scope.RulesList = result.Rules;
                $scope.UserRole = $sessionStorage.currentUserData.roles;
                $scope.UserRoles = $sessionStorage.currentUserData.userRoles;
                $scope.TotalCount = result.TotalCount;
                $scope.FilterCount = result.Rules.length;
                if ($sessionStorage.workListId) {
                    editRule();
                }
                $scope.DataObject.isFilterLoading = false;
            });
        };


        $scope.OpenRule = function (objRule) {
            ReSetMasterData();

            $scope.Rule = objRule;
            $scope.ShowListView = false;
        };
        var formatted_date = function (date) {
            if (date != null) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero 
                var y = date.getFullYear();
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        var formatted_time = function (date) {
            if (date != null) {
                var h = ("0" + (date.getHours())).slice(-2); // in javascript month start from 0.
                var m = ("0" + date.getMinutes()).slice(-2); // add leading zero             
                return h + ':' + m;
            }
            else {
                return null;
            }
        };
        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };

        function editRule() {
            $scope.requestFromWorklist = true;
            var rule = _.filter($scope.RulesList, function (obj) { return obj.RuleID == $sessionStorage.workListId; });

            if (rule && rule.length > 0) {
                $scope.OpenRule(rule[0]);
            }
            $sessionStorage.workListId = null;
        }

        $scope.GetRuleDetails = function (ruleObj, Flag) {
            if ($scope.DataObject.activeRow == ruleObj.RuleID && $scope.DataObject.isRuleDetailsVisible) {
                $scope.DataObject.isRuleDetailsVisible = false;
                $scope.DataObject.activeRow = null;
                return;
            }
            $scope.DataObject.activeRow = ruleObj.RuleID;
            RuleSharedService.SetData($scope.RuleTable, $scope.RadiologistsFullSet);
            $q.all([
                RuleSharedService.GetRuleDetails(ruleObj, Flag)
            ]).then(function (data) {
                if (data && data.length > 0) {
                    //ruleObj = data[0].Rule;
                    ruleObj.Groups = data[0].Rule.Groups;
                    ruleObj.selectedRadiologists = data[0].selectedRadiologists;
                    $scope.AllowedUser = data[0].AllowedUser;
                    $scope.DataObject.RuleDetail = ruleObj;
                    $scope.DataObject.isRuleDetailsVisible = true;
                    if (ruleObj.IsWorkList == "2") {
                        ruleObj.TATValue = RuleSharedService.converMinToSelectedType(ruleObj.TATType, ruleObj.TAT);
                        ruleObj.SLABreachType = (ruleObj.SLABreachType) ? ruleObj.SLABreachType : "Minutes";
                        ruleObj.SLABreachValue = RuleSharedService.converMinToSelectedType(ruleObj.SLABreachType, ruleObj.SLABreachTime);
                    }
                }
            });
        };

        function ReSetMasterData() {
            $scope.selectedRadiologists = [];
            $scope.AllowedUser = [];
            $scope.RadiologistsFullSet = $scope.MasterRadiologistsFullSet;
            $scope.RuleTable = RuleSharedService.ReSetMasterData();
        }

        var GetAllRadiologists = function () {
            var d = $q.defer();
            $q.all([
                RuleSharedService.GetAllRadiologists()
            ]).then(function (data) {
                $scope.RadiologistsFullSet = data[0];
                $scope.MasterRadiologistsFullSet = data[0];

                d.resolve();
            });
            return d.promise;
        }
        // JS for table row active
        angular.element(document).ready(function () {
            var timeout = $timeout(function () {
                angular.element(".common-tbl table tr").click(function () {
                    if (angular.element(this).data('clicked', true)) {
                        angular.element(".common-tbl table tr").removeClass('tr-active');
                        angular.element(this).addClass('tr-active');
                    }
                });
            }, 500);
            TimeoutList.push(timeout);
        });

        $scope.CloseRule = function () {

            $scope.ShowListView = true;
            ReSetMasterData();

        };

        $scope.AddRule = function (isWorklist) {
            $scope.Rule = { Groups: [], RulesProviders: [], IsWorkList: isWorklist };
            $scope.Rule.Groups = { RulesConditions: [] };

            $scope.OpenRule($scope.Rule);
        };

        $scope.$on('event.Rule.Close', function (evt, data) {
            if (data.HideWindow) {
                $scope.CloseRule();
                $scope.GetRuleList();
            }
        });
        $scope.$on('event.Rule.Save', function (evt, data) {
            if (data.HideWindow) {
                $scope.CloseRule();
                $scope.GetRuleList();
            }
        });

        $scope.clearProvider = function () {
            $scope.Filter.Provider = null;
            $scope.DataObject.UserFilterMultiSelect.SelectedValue = { list: [] };
        }
        $scope.changePriorityFilter = function () {
            $scope.Filter.Priority = $scope.selectedPriority.Obj.key;
            $scope.GetRuleList();
        }
        $scope.changeStatusFilter = function () {
            $scope.Filter.Status = $scope.selectedStatus.Obj.key;
            $scope.GetRuleList();
        }

        //#region Tenant filter (TAT Rules tab)
        $scope.changeTenantFilter = function () {
            var tenant = $scope.selectedTenant.Obj;
            $scope.Filter.TenantID = tenant ? tenant.TenantID : null;
            $scope.Filter.PageNum = "1";
            $scope.GetRuleList();
        }
        // Tenants in GetTenantsByUserID order (default tenant first). Loaded once per page visit.
        function GetTenantsByUserID() {
            if (!tenantsPromise) {
                tenantsPromise = ManageLocationService.GetTenantsByUserID({ UserID: $sessionStorage.currentUserData.userId }).then(function (result) {
                    $scope.TenantList = result || [];
                    return $scope.TenantList;
                }, function () {
                    tenantsPromise = null;
                    $scope.TenantList = [];
                    return $scope.TenantList;
                });
            }
            return tenantsPromise;
        }
        // Puts the tenant filter in the right state for the current tab (TAT tab: first tenant;
        // other tabs: none). The TAT tab has no radiologist filter (TAT rules apply to every
        // radiologist), so a pick carried over from another tab is cleared. Resolves once
        // Filter.TenantID is final, so callers can chain GetRuleList.
        function syncTenantFilterForTab() {
            if (!$scope.currentTab.TATRules) {
                $scope.selectedTenant = { Obj: null };
                $scope.Filter.TenantID = null;
                GetFilterRadiologistsByAccessibleSites(null);
                return $q.when();
            }
            $scope.clearProvider();
            return GetTenantsByUserID().then(function (tenants) {
                var first = tenants[0] || null;
                $scope.selectedTenant = { Obj: first };
                $scope.Filter.TenantID = first ? first.TenantID : null;
            });
        }
        // Display name for a rule's TenantID (legacy rules created before tenants have none).
        $scope.tenantName = function (tenantID) {
            if (tenantID === null || tenantID === undefined) {
                return 'Not set';
            }
            var tenant = _.find($scope.TenantList, function (t) { return t.TenantID == tenantID; });
            return tenant ? tenant.DisplayName : 'Tenant #' + tenantID;
        }
        //#endregion Tenant filter

        // Radiologist filter values: users mapped to the caller's accessible sites (shared, cached
        // lookup also used by the rule editor).
        function GetFilterRadiologistsByAccessibleSites(tenantID) {
            return RuleSharedService.GetRadiologistsByAccessibleSites(tenantID).then(function (users) {
                $scope.FilterRadiologists = users || [];
            });
        }
        $scope.$on('$destroy', function () {
            _.each(TimeoutList, function (timeout) {
                $timeout.cancel(timeout);
            });
            CommonService.stopNotifyTATStudy();
        });

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();

//angular.module('app.controllers').controller('OnCallScheduleController', OnCallScheduleController);

angular.module('radico.pages.settings.rule')
    .service('RuleService', ['Restangular', '$http', 'APP_CONSTANTS','__env', function (Restangular, $http, APP_CONSTANTS,__env) {

        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }

        this.GetRuleList = function (data) {
            return Restangular.one('Settings').one("Rule", "GetRuleList").customPOST(data);
        };
        this.GetRuleDetails = function (data) {
            return Restangular.one('Settings').one("Rule", "GetRuleDetails").customPOST(data);
        };

        this.GetRuleCollections = function (data) {
            return Restangular.one('Settings').one("Rule", "GetRuleCollections").customPOST(data);
        };

        this.SetRule = function (data) {
            return Restangular.one('Settings').one("Rule", "SetRule").customPOST(data);
        };
        this.SetRuleCondition = function (data) {
            return Restangular.one('Settings').one("Rule", "SetRuleCondition").customPOST(data);
        };

        this.GetSpecialityUserByProcedure = function (data) {
            return Restangular.one('Settings').one("Rule", "GetSpecialityUserByProcedure").customPOST(data);
        };
        this.SetRulesProvider = function (data) {
            return Restangular.one('Settings').one("Rule", "SetRulesProvider").customPOST(data);
        };


      
        this.GetAllRadiologists = function () {
            return $http({
                method: 'get',
                url: urlCore() + '/api/Account/RadFlowGetUsers ',
                headers: { 'content-type': 'application/json' }
            });
        };

        this.GetAllRadiologists = function (filter) {
            return Restangular.one("Settings").one("GetTenantsUserList").customPOST(filter);
        };
        this.GetAllUserByTenant = function (filter) {
            return Restangular.one("Settings").one("GetAllUserByTenant").customPOST(filter);
        };

        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };
        this.GetAllSpeciality = function () {
            return Restangular.one('Settings').one("GetAllSpeciality").get();
        };
        this.GetAllRadSubspecialty = function (UserID) {
            return Restangular.one('Settings').one("GetAllRadSubspecialty", UserID).get();
        };
        this.RemoveFromClipboard = function (params) {
            return Restangular.one('Settings').one("Rule").one("RemoveFromClipboard").customPOST(params);
        };
        this.GetMaxTATValueMinutes = function () {
            return Restangular.one('common').one("GetMaxTATValueMinutes").get();
        };
    }]);

angular.module('radico.pages.settings.rule')
    .service('RuleSharedService', ['$sessionStorage', 'RuleService', '$q', '$injector',
        function ($sessionStorage, RuleService, $q, $injector) {

            var lRuleTable = [];
            var lRadiologistsFullSet = [];
            var tenantRadiologistsLoadPromise = null;
            var lselectedRadiologists = [];
            var lRuleData = {};
            var lHiddenTypeList = [];
            var orderIDRuleTableObject = {
                Key: 'OrderID',
                ID: 'ORDERS.OrderID',
                ID_ColumnName: 'OrderID',
                Table_Name: 'Orders',
                RuleOperator: [
                    { Key: 'Contains', Value: 'IN' },
                ]
            };

            this.SetData = function (RuleTable, RadiologistsFullSet) {
                //$log.log('SetData');
                //$log.log("SetData > on: ", new Date());
                lRuleTable = RuleTable;
                lRadiologistsFullSet = RadiologistsFullSet ? RadiologistsFullSet : lRadiologistsFullSet;
            }

            this.GetRuleDetails = function (ruleObj, Flag) {
                lselectedRadiologists = [];
                lRuleData = {};
                var d = $q.defer();

                //ruleObj.isCollapsed = !ruleObj.isCollapsed;
                if (!ruleObj.Groups || ruleObj.Groups.length == 0) {
                    RuleService.GetRuleDetails(ruleObj).then(function (result) {
                        if (Flag == 'Clipboard') {
                            ruleObj = result;
                        }
                        ruleObj.RuleColorCode = result.RuleColorCode;
                        ruleObj.WorklistPageSize = result.WorklistPageSize;
                        ruleObj.IsSmartWorklist = result.IsSmartWorklist;
                        ruleObj.RulesProviders = result.RulesProviders;
                        ruleObj.Groups = result.Groups;
                        ruleObj = GetRuleConditionDetails(ruleObj, false);
                        lRuleData.selectedRadiologists = ruleObj.selectedRadiologists;
                        d.resolve(lRuleData);
                    });
                } else {
                    //GetRuleConditionDetails(ruleObj, false);
                    lRuleData.Rule = ruleObj;

                    lRuleData.selectedRadiologists = ruleObj.selectedRadiologists;
                    lRuleData.AllowedUser = lRuleData.AllowedUser ? lRuleData.AllowedUser : [];
                    d.resolve(lRuleData);
                }
                return d.promise;
            };

            function LoadUserByProcedure(ids, IsShow) {
                var AllowedUser = [];
                RuleService.GetSpecialityUserByProcedure(ids).then(function (resp) {
                    var userIds = resp;
                    angular.forEach(userIds, function (item) {
                        var obj = filterFilter(lRadiologistsFullSet, {
                            Id: item
                        })[0];
                        if (IsShow) {
                            AllowedUser.push(obj);
                        } else {
                            var idx = lRadiologistsFullSet.indexOf(obj);
                            if (idx != -1) {
                                lRadiologistsFullSet.splice(idx, 1);
                            }
                        }
                    });
                    lRuleData.AllowedUser = AllowedUser;
                }, function (err) {
                    lRadiologistsFullSet = [];
                });
            }

            this.GetCachedRadiologists = function () {
                return lRadiologistsFullSet || [];
            };

            //#region Radiologists by accessible sites
            // The signed-in user's accessible sites (dbo.UserAndSiteMap, via GetTenantsAndSiteAndLocation)
            // shaped as the {TenantID, SiteID} rows Proc_Get_AllUsers takes in @TenantSiteIDs. Cached per session.
            var accessibleTenantSiteIDsPromise = null;
            this.GetAccessibleTenantSiteIDs = function () {
                if (!accessibleTenantSiteIDsPromise) {
                    var PaymentContractService = $injector.get('PaymentContractService');
                    accessibleTenantSiteIDsPromise = PaymentContractService.GetTenantsAndSiteAndLocation({ UserID: $sessionStorage.currentUserData.userId })
                        .then(function (tenants) {
                            var ids = [];
                            _.each(tenants || [], function (tenant) {
                                _.each(tenant.Sites || [], function (site) {
                                    if (site.SiteID && site.SiteID != 0) {
                                        ids.push({ TenantID: tenant.TenantID, SiteID: site.SiteID });
                                    }
                                });
                            });
                            return _.uniqBy(ids, function (s) { return s.TenantID + '-' + s.SiteID; });
                        }, function () {
                            accessibleTenantSiteIDsPromise = null;
                            return [];
                        });
                }
                return accessibleTenantSiteIDsPromise;
            };

            // The accessible sites that belong to one tenant. Null/undefined tenant = all of them.
            this.GetAccessibleTenantSiteIDsForTenant = function (tenantID) {
                return this.GetAccessibleTenantSiteIDs().then(function (ids) {
                    if (tenantID === null || tenantID === undefined) { return ids; }
                    return _.filter(ids, function (s) { return s.TenantID == tenantID; });
                });
            };

            // Radiologists mapped to at least one of the caller's accessible sites, optionally limited to
            // one tenant's sites. Fallbacks: no accessible site in that tenant -> the tenant's own user
            // list (@TenantID); no tenant and no sites, or an error -> the tenant-wide cache. So a picker
            // is never empty by accident. Cached per tenant key per session.
            var siteRadiologistsPromises = {};
            this.GetRadiologistsByAccessibleSites = function (tenantID) {
                var self = this;
                var key = (tenantID === null || tenantID === undefined) ? 'all' : String(tenantID);
                if (!siteRadiologistsPromises[key]) {
                    siteRadiologistsPromises[key] = self.GetAccessibleTenantSiteIDsForTenant(tenantID).then(function (tenantSiteIDs) {
                        var filter = { UserID: $sessionStorage.currentUserData.userId };
                        if (tenantSiteIDs && tenantSiteIDs.length > 0) {
                            filter.TenantSiteIDs = tenantSiteIDs;
                        } else if (key !== 'all') {
                            filter.TenantID = tenantID;
                        } else {
                            return self.GetAllRadiologists();
                        }
                        return RuleService.GetAllUserByTenant(filter).then(function (users) {
                            return _.sortBy(users || [], ['LastName', 'FirstName']);
                        });
                    }).then(null, function () {
                        delete siteRadiologistsPromises[key];
                        return self.GetAllRadiologists();
                    });
                }
                return siteRadiologistsPromises[key];
            };
            //#endregion Radiologists by accessible sites

            this.SetCachedRadiologists = function (radiologists) {
                lRadiologistsFullSet = radiologists || [];
                if (lRadiologistsFullSet.length > 0) {
                    tenantRadiologistsLoadPromise = $q.when(lRadiologistsFullSet);
                }
            };

            this.RequestTenantRadiologistsIfNeeded = function () {
                if (lRadiologistsFullSet && lRadiologistsFullSet.length > 0) {
                    return tenantRadiologistsLoadPromise || $q.when(lRadiologistsFullSet);
                }
                if (!tenantRadiologistsLoadPromise) {
                    tenantRadiologistsLoadPromise = this.GetAllRadiologists();
                }
                return tenantRadiologistsLoadPromise;
            };

            this.GetAllRadiologists = function () {
                //$log.log('GetAllRadiologists');
                //$log.log("GetAllRadiologists > on: ", new Date());
                var d = $q.defer();
                if (lRadiologistsFullSet && lRadiologistsFullSet.length == 0) {
                    var Radiologists = RuleService.GetAllUserByTenant({ "UserID": $sessionStorage.currentUserData.userId });
                    Radiologists.then(function (resp) {
                        lRadiologistsFullSet = resp;
                        d.resolve(resp);
                    }, function (err) {
                        lRadiologistsFullSet = [];

                    });
                } else {
                    d.resolve(lRadiologistsFullSet);
                }

                return d.promise;
            }

            this.ReSetMasterData = function () {
                //$log.log("ReSetMasterData > on: ", new Date());
                return GetRuleTable();
            }

            this.DeleteRule = function (rule) {
                var d = $q.defer();
                rule.StatusFlag = "D";
                rule.RulesConditions = [];
                rule.rulesProviders = [];
                RuleService.SetRule(rule).then(function (result) {
                    d.resolve();
                });
                return d.promise;
            };

            this.SetRule = function (Rule) {
                //$log.log("SetRule > on: ", new Date());
                var d = $q.defer();
                var RuleObject = _.clone(Rule);
                RuleObject = _.omit(RuleObject, ['RulesConditions', 'Type', 'height', 'checked', 'SortColumns', 'isCollapsed', 'savedState', 'popUpWorklist', 'ResultPendingCount', 'STATCount', 'UnreadRVU', 'loading', 'TimeToLoad', 'PageSize', 'open', 'OpenClipboardNextStudy', 'gridId', 'UpdateID']);
                RuleService.SetRule(RuleObject).then(function (result) {
                    d.resolve(result);
                }, function (error) {
                    d.reject(error);
                });
                return d.promise;
            }

            function setOrderDate(cond) {
                var val = cond.Value;
                var type = null, startDate = null, endDate = null;
                if (val && val.includes('Custom')) {
                    val = val.replace("Custom range ", "").replace("and", "");
                    var values = val.split(" ");
                    startDate = values[0];
                    endDate = values[2];
                    type = 'Custom range';

                }
                else {
                    type = val;
                }
                switch (type) {
                    case 'Today':
                        cond.DateValue = {
                            startDate: moment(moment().format("YYYY-MM-DD") + ' ' + "00:00"),
                            endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                        };
                        break;

                    case 'Last 3 Days':
                        cond.DateValue = {
                            startDate: moment(moment().subtract(2, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                            endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                        };
                        break;
                    case 'Last 7 Days':
                        cond.DateValue = {
                            startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                            endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                        };
                        break;
                    case 'Last 30 Days':
                        cond.DateValue = {
                            startDate: moment(moment().subtract(29, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                            endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                        };
                        break;
                    case 'Custom range':
                        cond.DateValue = {
                            startDate: moment(moment(startDate).format("YYYY-MM-DD") + ' ' + "00:00"),
                            endDate: moment(moment(endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")
                        };
                        break;
                    case 'Last Year':
                        cond.DateValue = {
                            startDate: moment((moment().subtract(1, 'year').add(1, 'days')).format("YYYY-MM-DD") + ' ' + "00:00"),
                            endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                        };
                        break;
                    default:
                        cond.DateValue = {
                            startDate: moment(moment().subtract(6, 'days').format("YYYY-MM-DD") + ' ' + "00:00"),
                            endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                        };
                        break;
                }
                cond.DateValue.label = type;

            }


            function GetRuleConditionDetails(ruleObj, visualize) {
                if (visualize) lRuleTable = GetRuleTable();
                _.each(ruleObj.Groups, function (grp) {
                    if (grp.deleted) { return; }
                    grp.RulesConditions = _.orderBy(grp.RulesConditions, ['RuleCondtionID'], ['asc']);
                    angular.forEach(grp.RulesConditions, function (cond) {
                        if (!cond.AndOr) {
                            cond.AndOr = "AND";
                        }
                        cond.GroupID = grp.GroupID;

                        if (cond.StatusFlag == 'D') {
                            return;
                        }
                        if (cond.ColumnName == "ORDERS.OrderID") {
                            lRuleTable.push(orderIDRuleTableObject);
                        }
                        if (cond.ColumnName.includes("ORDERS.OrderDate,")) {
                            cond.ColumnName = cond.ColumnName.replace('ORDERS.OrderDate', 'ORDERS.DOS')
                        }
                        if (cond.ColumnName == 'ORDERS.ProcedureDesc' || cond.ColumnName == 'PROVIDERS.Name' || cond.ColumnName == 'ORDERS.Reason') {
                            var tables = _.filter(lRuleTable, function (obj) {
                                return obj.Contains_ColumnName == cond.ColumnName;
                            });
                        }
                        else {
                            var tables = _.filter(lRuleTable, function (obj) {
                                return obj.ID == cond.ColumnName;
                            });
                        }

                        var table = {};
                        angular.copy(tables[0], table);

                        table.Ids = cond.Value;
                        table.SearchKey = null;
                        cond.RuleTable = table;
                        if (cond.RuleTable.Key == 'Exam Status' && cond.Value.includes(':')) {
                            cond.HiddenType = _.filter(lHiddenTypeList, { 'Value': cond.Value.split(':')[1] })[0];
                        }
                        if (cond.RuleTable.Key == 'Image Count' || cond.RuleTable.Key == 'Patient Age') {
                            if (cond.Operator == '>') {
                                cond.Operator = 'gt';
                            }
                            if (cond.Operator == '<') {
                                cond.Operator = 'lt';
                            }
                        }
                        //create rule operator for rulecondition
                        var RuleOperator = {};
                        if (cond.OperatorText) {
                            RuleOperator = _.find(cond.RuleTable.RuleOperator, function (obj) {
                                return obj.Key == cond.OperatorText;
                            });
                        } else {
                            RuleOperator = _.find(cond.RuleTable.RuleOperator, function (obj) {
                                return obj.Value == cond.Operator;
                            });
                        }
                        if (RuleOperator) {
                            cond.RuleOperator = RuleOperator;
                        }
                        if (cond.RuleOperator) {
                            cond.Operator = cond.RuleOperator.Value;
                        }
                        //below if block is added to prevent getRuleCollection API for date input
                        if (cond.RuleTable.IsDate) {
                            setOrderDate(cond);
                            return;
                        }
                        if (table.IsText || table.IsNum) {
                            var value = cond.Value;
                            if (cond.Value.indexOf("'") != -1) {
                                value = value.replaceAll("'", "");
                            }
                            cond.TextValue = value;
                            return;
                        };
                        if (cond.RuleOperator && cond.RuleOperator.IsText) {
                            cond.TextValue = cond.Value;
                            return;
                        };
                        if (table.List) {
                            if (cond.Operator == '=' || cond.Operator == '<>') {
                                var value = cond.Value;
                                //below if block is used for 'Patient Class' and 'Tenants'
                                if (cond.Value.indexOf("'") != -1) {
                                    value = value.replaceAll("'", "");
                                }
                                cond.RuleTableValue = _.find(table.List, function (obj) {
                                    return obj.ID == (value.includes(':') ? value.split(':')[0] : value);
                                });
                            } else {
                                if (cond.Value.indexOf(",") != -1) {
                                    var values = cond.Value.split(",");
                                    var RuleTableValues = [];
                                    _.each(values, function (value) {
                                        var RuleTableValue = _.find(table.List, function (obj) {
                                            return obj.ID == value.replaceAll("'", "");
                                        });
                                        if (RuleTableValue) {
                                            RuleTableValues.push(RuleTableValue);
                                        }
                                    });
                                    cond.RuleTableValues = RuleTableValues;
                                } else {
                                    cond.RuleTableValues = _.filter(table.List, function (obj) {
                                        return obj.ID == cond.Value.replaceAll("'", "");
                                    });
                                }

                            }
                            return;
                        }
                        else {
                            table.CreatedBy = $sessionStorage.currentUserData.userId;
                            var promise;
                            if (table.Key == "Exam Tags (RadAssist)" || table.Key == "Exam Tags (RadFlow)" || table.Key == "Exam Priority") {
                                promise = RuleService.GetLookupByType(table.Key == "Exam Tags (RadAssist)" ? "ExamTags" : (table.Key == "Exam Tags (RadFlow)") ? "RadExamTag" : "StudyPriority")
                            }
                            else if (table.Key == "Specialty") {
                                promise = RuleService.GetAllSpeciality()
                            }
                            else if (table.Key == "Rad Subspecialty") {
                                promise = RuleService.GetAllRadSubspecialty($sessionStorage.currentUserData.userId)
                            }
                            else {
                                promise = RuleService.GetRuleCollections(table)
                            }
                            promise.then(function (result) {
                                if (cond.Operator == '=' || cond.Operator == '<>') {
                                    var value = cond.Value;
                                    //below if block is used for 'Patient Class' and 'Tenants'
                                    if (cond.Value.indexOf("'") != -1) {
                                        value = value.replaceAll("'", "");
                                    }
                                    if (cond.RuleTable.Key == "Exam Tags (RadAssist)" || cond.RuleTable.Key == "Exam Tags (RadFlow)") {
                                        cond.RuleTableValue = _.find(result, { 'Value': value });
                                    }
                                    else if (cond.RuleTable.Key == "Exam Priority") {
                                        var SharedService = $injector.get('SharedService');
                                        result = SharedService.mapPriorityToCollection(result, true);
                                        cond.RuleTableValue = _.find(result, { 'ID': _.toInteger(value) });
                                    }
                                    else if (cond.RuleTable.Key == "Specialty") {
                                        cond.RuleTableValue = _.find(result, function (speciality) { return speciality.SpecialityId == value; });
                                    }
                                    else if (cond.RuleTable.Key == "Rad Subspecialty") {
                                        cond.RuleTableValue = _.find(result, function (subspec) { return subspec.RadSubspecialtyID == value; });
                                    }
                                    else {
                                        cond.RuleTableValue = _.find(result, function (obj) {
                                            return obj.ID == value;
                                        });
                                    }
                                }
                                else if (cond.RuleTable.Key == "Exam Tags (RadAssist)" || cond.RuleTable.Key == "Exam Tags (RadFlow)") {
                                    var value;
                                    if (cond.Value.indexOf("'") != -1) {
                                        value = cond.Value.replaceAll("'", "");
                                        value = value.split(",");
                                    }
                                    cond.RuleTableValues = [];
                                    _.each(value, function (val) {
                                        var ruleTableValue = _.find(result, { 'Value': val });
                                        cond.RuleTableValues.push(ruleTableValue);
                                    });
                                }
                                else if (cond.RuleTable.Key == "Specialty") {
                                    var value;
                                    if (cond.Value.indexOf("'") != -1) {
                                        value = cond.Value.replaceAll("'", "");
                                        value = value.split(",");
                                    }
                                    cond.RuleTableValues = [];
                                    _.each(value, function (val) {
                                        cond.RuleTableValues.push(_.find(result, function (speciality) { return speciality.SpecialityId == val; }));
                                    });
                                }
                                else if (cond.RuleTable.Key == "Rad Subspecialty") {
                                    var value;
                                    if (cond.Value.indexOf("'") != -1) {
                                        value = cond.Value.replaceAll("'", "");
                                        value = value.split(",");
                                    }
                                    cond.RuleTableValues = [];
                                    _.each(value, function (val) {
                                        cond.RuleTableValues.push(_.find(result, function (subspec) { return subspec.RadSubspecialtyID == val; }));
                                    });
                                }
                                else {
                                    cond.RuleTableValues = result;
                                }
                            });

                        }

                        if (cond.RuleTable.Key == 'Procedure Description') {
                            LoadUserByProcedure(cond.Value, (cond.Operator == '<>' ? false : true));
                        }
                    });
                })

                if (!visualize) {
                    angular.forEach(ruleObj.RulesProviders, function (prov) {
                        var providers = _.filter(lRadiologistsFullSet, function (obj) {
                            return obj.Id == prov.ProviderID
                        });
                        if (providers && providers.length > 0) {
                            lselectedRadiologists.push(providers[0]);
                        }
                    });
                    ruleObj.selectedRadiologists = lselectedRadiologists;
                }


                lRuleData.Rule = ruleObj;
                lRuleData.selectedRadiologists = lselectedRadiologists;
                lRuleData.AllowedUser = lRuleData.AllowedUser ? lRuleData.AllowedUser : [];

                return ruleObj;
            }

            this.VisualizeData = function (rule) {
                return GetRuleConditionDetails(rule, true);
            }
            function GetRuleTable() {
                //$log.log('GetRuleTable');
                //$log.log("GetRuleTable > on: ", new Date());
                var RuleTable = [
                    {
                        Key: 'Institution', ID: 'ORDERS.InstitutionID', ID_ColumnName: 'InstitutionID', Table_Name: 'Institutions', Name_ColumnName: 'InstitutionName',
                        Description_ColumnName: [{ ID_ColumnName: 'siteid', Table_Name: 'Sites', Name_ColumnName: '[site]', LinkID_ColumnName: 'siteid' },
                        { ID_ColumnName: 'LocationID', Table_Name: 'Locations', Name_ColumnName: '[Location]', LinkID_ColumnName: 'LocationID' }]
                        , IsCollection: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },

                        ]
                    },
                    {
                        Key: 'Locations', ID: 'ORDERS.LocationID', ID_ColumnName: 'LocationID', Table_Name: 'Locations', Name_ColumnName: 'Location',
                        Description_ColumnName: [{ ID_ColumnName: 'siteid', Table_Name: 'Sites', Name_ColumnName: '[site]', LinkID_ColumnName: 'siteid' }]
                        , IsCollection: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                        ]
                    },
                    {
                        Key: 'Sites', ID: 'ORDERS.SiteID', ID_ColumnName: 'SiteID', Table_Name: 'Sites', Name_ColumnName: 'Site', IsCollection: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                        ]
                    },
                    {
                        Key: 'Tenants', ID: 'Sites.TenantID', ID_ColumnName: 'ID', Table_Name: 'Tenants', Name_ColumnName: 'Name', IsCollection: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                        ]
                    },

                    {
                        Key: 'Modality', ID: 'ORDERS.ModalityID', ID_ColumnName: 'ID', Table_Name: 'Modalities', Name_ColumnName: 'Code', IsCollection: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                        ]
                    },
                    {
                        Key: 'Procedure Description', ID: 'ORDERS.ProcedureId', ID_ColumnName: 'ProcedureID', Table_Name: 'Procedures', Name_ColumnName: 'ProcedureDesc',
                        Description_ColumnName: [{ ID_ColumnName: 'ProcedureCode' }], Contains_ColumnName: 'ORDERS.ProcedureDesc', Contains_codeName: 'ORDERS.ProcedureCode', IsCollection: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                            { Key: 'Contains Words', Value: 'LIKE', IsText: true },
                            { Key: 'Not Contains Words', Value: 'NOT LIKE', IsText: true },

                        ]
                    },
                    {
                        Key: 'Ordering Physician', ID: 'ORDERS.ProviderID', ID_ColumnName: 'ID', Table_Name: 'Providers', Name_ColumnName: 'Name', Contains_ColumnName: 'PROVIDERS.Name', IsCollection: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                            { Key: 'Contains Words', Value: 'LIKE', IsText: true },
                        ]
                    },
                    //{
                    //    Key: 'Insurance Carrier', ID_ColumnName: 'CarrierID', Table_Name: 'Institutions', Name_ColumnName: 'InstitutionName',
                    //    RuleOperator: [
                    //    { Key: 'Equals', Value: '=' },
                    //    { Key: 'Not Equals', Value: '<>' },
                    //    { Key: 'Contains', Value: 'IN' },
                    //    ]
                    //},
                    {
                        Key: 'Accession', ID: 'ORDERS.Accession', IsText: true, RuleOperator: [
                            { Key: 'Start With', Value: 'LIKE%' },
                            { Key: 'End With', Value: '%LIKE' },
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                        ]
                    },
                    {
                        Key: 'Image Count', ID: 'ORDERS.ImageInstance', IsNum: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Greater Than', Value: 'gt' },
                            { Key: 'Less Than', Value: 'lt' },
                            { Key: 'Greater Than Equals', Value: '>=' },
                            { Key: 'Less Than Equals', Value: '<=' },
                        ]
                    },
                    {
                        Key: 'Patient Age', ID: '([dbo].[GetPatientAgeInYear](ORDERS.PatientDOB))', IsNum: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Greater Than', Value: 'gt' },
                            { Key: 'Less Than', Value: 'lt' },
                            { Key: 'Greater Than Equals', Value: '>=' },
                            { Key: 'Less Than Equals', Value: '<=' },
                        ]
                    },

                    {
                        Key: 'DOS', ID: 'ORDERS.OrderDate', IsDate: true, RuleOperator: [
                            { Key: 'Is', Value: '=' }
                        ]
                    },
                    {
                        Key: 'Patient Class', ID: 'ORDERS.PatientClass', ID_ColumnName: '[Key]', Table_Name: 'dbo.Lookups', Name_ColumnName: 'Value', RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                        ]
                    },
                    {
                        Key: 'Exam Priority', ID: 'ORDERS.DelayedSTAT', RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            //{ Key: 'Contains', Value: 'IN' },
                        ]
                    },
                    {
                        Key: 'Exam Status', ID: 'ORDERS.ExamStatus',
                        List: [
                            { Value: 'Cancelled', ID: 'X' },
                            { Value: 'Comparison', ID: 'CO' },
                            { Value: 'Complete', ID: 'C' },
                            { Value: 'Deficient', ID: 'DE' },
                            { Value: 'Draft', ID: 'D' },
                            { Value: 'Hidden', ID: 'H' },
                            { Value: 'Image Pending', ID: 'IP' },
                            { Value: 'Pending Order', ID: 'OP' },
                            { Value: 'Pending Correction', ID: 'PC' },
                            { Value: 'RadFlow Complete', ID: 'RC' },
                            { Value: 'Result Pending', ID: 'RP' },
                            { Value: 'Signed Today', ID: 'ST' }
                        ],
                        RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            /*{ Key: 'Not Equals', Value: '<>' },*/
                            { Key: 'Contains', Value: 'IN' },
                        ]
                    },
                    {
                        Key: 'Reason', ID: 'ORDERS.ReasonID', ID_ColumnName: 'ID', Table_Name: 'Reasons', Name_ColumnName: 'Resons', Contains_ColumnName: 'ORDERS.Reason', IsCollection: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                            { Key: 'Contains Words', Value: 'LIKE', IsText: true },

                        ]
                    },
                    {
                        Key: 'Study has been unread', ID: '(datediff(mi,ISNULL(ORDERS.ReceivedSinceDateTime,[dbo].[getUSCentralDate]()), [dbo].[getUSCentralDate]()))', IsNum: true, RuleOperator: [
                            { Key: 'Before Time', Value: '<' },
                            { Key: 'After Time', Value: '>' }
                        ]
                    },
                    {
                        Key: 'Carriers', ID: 'ORDERS.CarrierID', ID_ColumnName: 'ID', Table_Name: 'Carriers', Name_ColumnName: 'Carrier', IsCollection: true, RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                        ]
                    },
                    {
                        Key: 'Signed Date', ID: 'Reports.SignDate', IsDate: true, RuleOperator: [
                            { Key: 'Is', Value: '=' }
                        ]
                    },
                    {
                        Key: 'Exam Tags (RadAssist)', ID: 'OrderDetail.ExamTag', RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                        ]
                    },
                    {
                        Key: 'Exam Tags (RadFlow)', ID: 'OrderDetail.RadExamTag', RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                        ]
                    },
                    {
                        Key: 'Specialty', ID: 'OrderDetail.ProviderSpecialityId', IsCollection: true,
                        RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                        ]
                    },
                    {
                        Key: 'Rad Subspecialty', ID: 'OrderDetail.RadSubspecialtyID', IsCollection: true,
                        RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                            { Key: 'Contains', Value: 'IN' },
                            { Key: 'Not Contains', Value: 'NOT IN' },
                        ]
                    },
                    {
                        Key: 'Gender', ID: 'PatientGender',
                        List: [
                            { Value: 'Male', ID: 'Male' },
                            { Value: 'Female', ID: 'Female' },
                        ],
                        RuleOperator: [
                            { Key: 'Is', Value: '=' },
                            { Key: 'Is Not', Value: '<>' },
                        ]
                    },
                    {
                        Key: 'Hospital ORM', ID: 'ORDERS.IsHospitalORM',
                        List: [
                            { Value: 'Yes', ID: '1' },
                            { Value: 'No', ID: '0' },
                        ],
                        RuleOperator: [
                            { Key: 'Is', Value: '=' },
                        ]
                    }
                ];

                var orderstatus = _.find(RuleTable, { ID: "ORDERS.ExamStatus" });
                if (orderstatus) {
                    if ($sessionStorage.IsAddendumRequestVisible) {
                        orderstatus.List.push({ Value: 'Pending Addendum', ID: 'PA' });
                    }
                }
                return RuleTable;
            }

            this.UpdateRuleTable = function (RuleTable) {
                //$log.log('UpdateRuleTable');
                //$log.log("UpdateRuleTable > on: ", new Date());
                RuleTable.push(orderIDRuleTableObject);
            }

            this.getHiddenTypes = function () {
                RuleService.GetLookupByType('HiddenTypes').then(function (result) {
                    lHiddenTypeList = _.sortBy(_.filter(result, { 'Type': 'HiddenTypes' }), ['Key']);
                });
            }

            this.getLocalHiddenTypes = function () {
                return lHiddenTypeList ? lHiddenTypeList : [];
            }

            this.setOrderDateByLabel = function (cond) {
                setOrderDate(cond);
            }

            this.RemoveOrderIDFromRuleTable = function (RuleTable) {
                //$log.log('UpdateRuleTable');
                //$log.log("UpdateRuleTable > on: ", new Date());
                _.remove(RuleTable, { Key: 'OrderID' });
            }
            this.converMinToSelectedType = function (type, value) {
                switch (type) {
                    case 'Day':
                        return (value / 1440);
                        break;
                    case 'Hour':
                        return (value / 60);
                        break;
                    case 'Minutes':
                        return value
                        break;
                }
            }
        }]);

(function () {
    'use strict';

    angular.module('radico.pages.settings.tatnotification')
        .controller('tatNotifationCtrl', tatNotifationCtrl);


    function tatNotifationCtrl($scope, $q, RuleService, $sessionStorage, RuleSharedService, $compile, TATNotificationService, $filter, $timeout, toaster, CommonService, SharedService) {

        var vm = this;
        var PageSize = 50;
        var gridAPI = null;
        var TATSchedulesList = [];
        var TATSchedulesProvidersList = [];
        var TATSchedulesAltProvidersList = [];
        var statusBarComponent = null;
        $scope.DataObject = {
            selectedRow: null,
            isRowDetailsVisible: false,
            gridRows: {},
            TATRuleList: [],
            MasterRadiologistsList: [],
            RadiologistsList: [],
            AlternateRadiologistsList: [],
            dateSearchOptions: {
                formatYear: 'yyyy',
                startingDay: 1,
            },

            FromDateOpenFilter: false,
            ToDateOpenFilter: false,

            FromDateOpen: false,
            ToDateOpen: false,
            addScheduleObj: {
                ScheduleName: null,
                selectedRule: null,
                Radiologist: {
                    divId: "addScheduleRadiologist",
                    keys: ['LastName', 'FirstName'],
                    uniqKey: 'Id',
                    placeHolder: "Select Providers",
                    SelectedValue: { list: [] },
                    tooltip: "Select Providers"
                },
                AlternateRadiologist: {
                    divId: "addScheduleAlternateRadiologist",
                    keys: ['LastName', 'FirstName'],
                    uniqKey: 'Id',
                    placeHolder: "Select Alternate Providers",
                    SelectedValue: { list: [] },
                    tooltip: "Select Alternate Providers"
                },
                FromDate: null,
                ToDate: null,
            },
            filter: {
                ScheduleName: null,
                selectedRule: null,
                Radiologist: {
                    divId: "filterScheduleRadiologist",
                    keys: ['LastName', 'FirstName'],
                    uniqKey: 'Id',
                    placeHolder: "Select Providers",
                    SelectedValue: { list: [] },
                    tooltip: "Select Providers",
                    OnChange: function (selectedData) {
                        var toolip = createProviderTooltip(selectedData);
                        $scope.DataObject.filter.Radiologist.tooltip = toolip ? toolip : "Select Providers";
                    }
                },
                FromDate: null,
                ToDate: null,
            }
        }

        function pageInit() {
            CommonService.startNotifyTATStudy();
            GetRuleList();
            GetAllUserByTenant();
            initGrid();
        }

        function GetAllUserByTenant() {
            var d = $q.defer();
            RuleService.GetAllUserByTenant({
                UserID: $sessionStorage.currentUserData.userId
            }).then(function (result) {
                $scope.DataObject.MasterRadiologistsList = result;
                $scope.DataObject.RadiologistsList = result;
                $scope.DataObject.AlternateRadiologistsList = result;
                d.resolve(result);
            }, function () { d.resolve(); });
            return d.promise;
        }
        function GetRuleList() {
            var d = $q.defer();
            RuleService.GetRuleList({
                PageSize: "500",
                PageNum: "1",
                Priority: "AL",
                Status: "E",
                IsWorkList: "2",
                UserID: $sessionStorage.currentUserData.userId
            }).then(function (result) {
                if (result && result.Rules) {
                    $scope.DataObject.TATRuleList = result.Rules;
                }
                d.resolve(result);
            }, function (err) { d.resolve(); });
            return d.promise;
        }

        /** localDate expects "YYYY-MM-DD HH:mm:ss"-style strings; API/Dapper often returns culture-specific datetime text. */
        function normalizeDateStringForLocalDateFilter(raw) {
            if (raw == null || raw === '') {
                return '';
            }
            if (angular.isDate(raw)) {
                return isNaN(raw.getTime()) ? '' : moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'number' && isFinite(raw)) {
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'string') {
                var parsed = moment(raw.trim());
                return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : '';
            }
            return '';
        }

        function momentFromLocalDateOutput(localized) {
            if (!localized) {
                return null;
            }
            var m = moment(localized, ['M/D/YYYY HH:mm', 'MM/DD/YYYY HH:mm', 'M/D/YYYY H:mm'], true);
            if (!m.isValid()) {
                m = moment(localized);
            }
            return m.isValid() ? m : null;
        }

        function formatTatGridDateOnly(raw) {
            var normalized = normalizeDateStringForLocalDateFilter(raw);
            if (!normalized) {
                return '';
            }
            var localized = $filter('localDate')(normalized, false, new Date());
            var m = momentFromLocalDateOutput(localized);
            return m ? m.format('MM/DD/YYYY') : '';
        }

        function formatTatGridDateTime(raw) {
            var normalized = normalizeDateStringForLocalDateFilter(raw);
            if (!normalized) {
                return '';
            }
            return $filter('localDate')(normalized, false, new Date()) || '';
        }

        //#region Ag-grid
        var columnDefs = [
            { field: "ScheduleName", flex: 1, },
            {
                field: "RuleName", flex: 1,
                headerName: "TAT Rule Name"
            },
            {
                field: "FromDate", flex: 1, headerName: "Start Effective Date",
                cellRenderer: function (params) {
                    if (!params.data || !params.data.FromDate) {
                        return '';
                    }
                    return formatTatGridDateOnly(params.data.FromDate);
                }
            },
            {
                field: "ToDate", flex: 1, headerName: "End Effective Date",
                cellRenderer: function (params) {
                    if (!params.data || !params.data.ToDate) {
                        return '';
                    }
                    return formatTatGridDateOnly(params.data.ToDate);
                }
            },
            {
                field: "LastModifiedDate", flex: 1,
                cellRenderer: function (params) {
                    if (!params.data || !params.data.LastModifiedDate) {
                        return '';
                    }
                    return formatTatGridDateTime(params.value);
                },
                sort: 'desc'
            },
            {
                field: "Action",
                resizable: false,
                width: 40,
                cellRenderer: ActionCellRenderer()
            },
        ];
        function actionButton(className, title, ngClick, iconClass) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = className;
            button.title = title;
            button.setAttribute('ng-click', ngClick);
            var icon = document.createElement('i');
            icon.className = iconClass;
            button.appendChild(icon);
            return button;
        }
        function ActionCellRenderer() {
            function customRenderer() {
            }
            customRenderer.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.className = "d-flex"
                $scope.DataObject.gridRows[params.data.TATScheduleID] = params.data;
                var rowExpr = "this.DataObject.gridRows['" + params.data.TATScheduleID + "']";
                this.eGui.appendChild(actionButton('btn btn-default txt-clr-14 px-1 border-0 mx-1 my-0 py-0', 'Edit Schedule', 'DataObject.EditSchedule(' + rowExpr + ')', 'fa fa-pencil'));
                this.eGui.appendChild(actionButton('btn btn-default txt-clr-14 px-1 border-0 mx-1 my-0 py-0', 'Delete Schedule', 'DataObject.DeleteSchedule(' + rowExpr + ')', 'fa fa-trash'));
                this.eGui.appendChild(actionButton('btn btn-default txt-clr-14 px-1 border-0 mx-1 mt-1 mb-0 py-0', 'View Schedule', 'DataObject.viewRuleDetails(' + rowExpr + ')', 'glyphicon glyphicon-eye-open'));
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);

            }
            customRenderer.prototype.getGui = function () {
                return this.eGui;
            };
            customRenderer.prototype.destroy = function () {
            };
            return customRenderer;
        }
        var gridOptions = {
            sortingOrder: ['desc', 'asc'],
            suppressMultiSort: true,
            columnDefs: columnDefs,
            defaultColDef: {
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: []
            },
            rowModelType: 'serverSide',
            cacheBlockSize: PageSize,
            suppressContextMenu: true,
            alwaysShowVerticalScroll: true,
            alwaysShowHorizontalScroll: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            localeText: { loadingError: 'Some error has occurred!' },
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },

            getRowId: function (params) {
                return params.data.TATScheduleID;
            },
            onGridReady: function () {
                statusBarComponent = gridOptions.api.getStatusPanel('GridFooter');
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
                var datasource = createServerSideDatasource();
                gridAPI.setServerSideDatasource(datasource);
            },
            onSortChanged: function (params) {
                $scope.DataObject.FilterTATScheduleList();
            },
        };

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }

        function createServerSideDatasource() {
            return {
                getRows: function (params) {

                    var filter = setFilter(params);
                    GetTATSchedules(filter).then(function (data) {
                        if (TATSchedulesList.length == 0) {
                            statusBarComponent.eGui.hidden = true;
                            gridAPI.showNoRowsOverlay();
                        } else {
                            statusBarComponent.eGui.hidden = false;
                            statusBarComponent.eGui.textContent = 'Showing ' + TATSchedulesList.length + ' of ' + TATSchedulesList[0].TotalRows + ' Total Records';
                            statusBarComponent.eGui.style.color = 'white';
                            gridAPI.hideOverlay();
                        }
                        var rowsForBlock = TATSchedulesList.slice(params.request.startRow, params.request.endRow);
                        params.success({
                            rowData: rowsForBlock,
                            rowCount: undefined,
                        });
                    }, function (err) {
                        params.fail();
                    });
                },
            };
        }

        function setFilter(params) {
            var filter = {
                PageNum: params.request.endRow / PageSize,
                PageSize: PageSize,
                UserID: $sessionStorage.currentUserData.userId,
                ScheduleName: $scope.DataObject.filter.ScheduleName
            }
            if (params.request.sortModel.length > 0) {
                filter.OrderByField = params.request.sortModel[0].colId;
                filter.OrderBy = params.request.sortModel[0].sort;
            }
            if ($scope.DataObject.filter.selectedRule) {
                filter.RuleID = $scope.DataObject.filter.selectedRule.RuleID;
            }
            if ($scope.DataObject.filter.FromDate && $scope.DataObject.filter.ToDate) {
                filter.FromDate = $filter('CSTDateTime')(moment($scope.DataObject.filter.FromDate));
                filter.ToDate = $filter('CSTDateTime')(moment($scope.DataObject.filter.ToDate));
            }

            if ($scope.DataObject.filter.Radiologist.SelectedValue &&
                $scope.DataObject.filter.Radiologist.SelectedValue.list &&
                $scope.DataObject.filter.Radiologist.SelectedValue.list.length > 0) {
                var Radiologist = "";
                _.each($scope.DataObject.filter.Radiologist.SelectedValue.list, function (obj) {
                    if (Radiologist == "") {
                        Radiologist = obj.Id;
                    }
                    else {
                        Radiologist = Radiologist + "," + obj.Id;
                    }
                });
                filter.Radiologist = Radiologist;
            }
            return filter;
        }
        function initGrid() {
            var gridDiv = document.querySelector('#tatNotificationGrid');
            new agGrid.Grid(gridDiv, gridOptions);
            gridAPI = gridOptions.api;
        }
        //#endregion Ag-grid

        function GetTATSchedules(params) {
            var d = $q.defer();
            TATNotificationService.GetTATSchedules(params).then(function (result) {
                if (result) {
                    if (result.TATSchedulesList) {
                        TATSchedulesList = _.uniqBy((_.concat(TATSchedulesList, result.TATSchedulesList)), 'TATScheduleID');
                    }
                    if (result.ProvidersList) {
                        TATSchedulesProvidersList = _.concat(TATSchedulesProvidersList, result.ProvidersList);
                    }
                    if (result.AlternateProvidersList) {
                        TATSchedulesAltProvidersList = _.concat(TATSchedulesAltProvidersList, result.AlternateProvidersList);
                    }
                }
                d.resolve(TATSchedulesList);
            }, function (err) { d.resolve(); });
            return d.promise;
        }
        function createProviderTooltip(selectedData) {
            var tooltip = null;
            _.each(selectedData, function (obj) {
                if (tooltip) {
                    tooltip = tooltip + "\n" + (obj.LastName + "," + obj.FirstName);
                }
                else {
                    tooltip = obj.LastName + "," + obj.FirstName;
                }
            });
            return tooltip;
        }
        function createAddScheduleObj(selectedRule, scheduleData) {
            $scope.DataObject.addScheduleObj.ScheduleName = scheduleData.ScheduleName;

            $scope.DataObject.addScheduleObj.selectedRule = selectedRule;
            $scope.DataObject.onRuleSelected();

            var fromNorm = normalizeDateStringForLocalDateFilter(scheduleData.FromDate);
            var toNorm = normalizeDateStringForLocalDateFilter(scheduleData.ToDate);
            var fromLocalized = fromNorm ? $filter('localDate')(fromNorm, false, new Date()) : '';
            var toLocalized = toNorm ? $filter('localDate')(toNorm, false, new Date()) : '';
            var fromM = momentFromLocalDateOutput(fromLocalized);
            var toM = momentFromLocalDateOutput(toLocalized);
            $scope.DataObject.addScheduleObj.FromDate = fromM ? fromM.toDate() : null;
            $scope.DataObject.addScheduleObj.ToDate = toM ? toM.toDate() : null;

            var providersList = _.filter(TATSchedulesProvidersList, { TATScheduleID: scheduleData.TATScheduleID });
            var selectedProvidersList = [];
            _.each(providersList, function (obj) {
                var providerObj = _.find($scope.DataObject.MasterRadiologistsList, { Id: obj.ProviderID });
                if (providerObj) {
                    selectedProvidersList.push(providerObj);
                }
            });
            selectedProvidersList = _.uniqBy(selectedProvidersList, 'Id');
            $scope.DataObject.addScheduleObj.Radiologist.SelectedValue = { list: selectedProvidersList }

            var altprovidersList = _.filter(TATSchedulesAltProvidersList, { TATScheduleID: scheduleData.TATScheduleID });
            var selectedAltProvidersList = [];
            _.each(altprovidersList, function (obj) {
                var providerObj = _.find($scope.DataObject.MasterRadiologistsList, { Id: obj.AlternateProviderID });
                if (providerObj) {
                    selectedAltProvidersList.push(providerObj);
                }
            });
            selectedAltProvidersList = _.uniqBy(selectedAltProvidersList, 'Id');
            $scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue = { list: selectedAltProvidersList }
        }

        $scope.clearAddScheduleData = function () {
            $scope.DataObject.addScheduleObj = {
                selectedRule: null,
                Radiologist: {
                    divId: "addScheduleRadiologist",
                    keys: ['LastName', 'FirstName'],
                    uniqKey: 'Id',
                    placeHolder: "Select Radiologist",
                    SelectedValue: { list: [] },
                    tooltip: "Select Providers"
                },
                AlternateRadiologist: {
                    divId: "addScheduleAlternateRadiologist",
                    keys: ['LastName', 'FirstName'],
                    uniqKey: 'Id',
                    placeHolder: "Select Alternate Radiologist",
                    SelectedValue: { list: [] },
                    tooltip: "Select Alternate Providers"
                },
                FromDate: null,
                ToDate: null
            }
            $scope.DataObject.RadiologistsList = $scope.DataObject.MasterRadiologistsList;
            $scope.DataObject.AlternateRadiologistsList = $scope.DataObject.MasterRadiologistsList;
            $scope.DataObject.selectedRow = null;

            $scope.DataObject.isRowDetailsVisible = false;
        }
        //#region Scope Functions
        $scope.DataObject.openAddScheduleModal = function () {
            $scope.clearAddScheduleData();
            $("#addScheduleModal").modal('show');
        }
        $scope.DataObject.onRuleSelected = function () {
            var d = $q.defer();
            $scope.DataObject.addScheduleObj.selectedRule.TATValue = RuleSharedService.converMinToSelectedType($scope.DataObject.addScheduleObj.selectedRule.TATType, $scope.DataObject.addScheduleObj.selectedRule.TAT);
            $scope.DataObject.addScheduleObj.selectedRule.SLABreachValue = RuleSharedService.converMinToSelectedType($scope.DataObject.addScheduleObj.selectedRule.SLABreachType, $scope.DataObject.addScheduleObj.selectedRule.SLABreachTime);
            RuleSharedService.GetRuleDetails($scope.DataObject.addScheduleObj.selectedRule, "VIEW").then(function (result) {
                if (result && result.Rule) {
                    $scope.DataObject.addScheduleObj.selectedRule.Groups = result.Rule.Groups;
                }
                d.resolve(result);
            }, function (err) { d.resolve(); });
            return d.promise;
        }
        $scope.DataObject.onRadiologistSelected = function (tag) {
            if (tag) {
                var AlternateRadiologistsList = _.cloneDeep($scope.DataObject.AlternateRadiologistsList);
                _.remove(AlternateRadiologistsList, { Id: tag.Id });
                $scope.DataObject.AlternateRadiologistsList = _.cloneDeep(AlternateRadiologistsList);
            }

            var toolip = createProviderTooltip($scope.DataObject.addScheduleObj.Radiologist.SelectedValue.list);
            $scope.DataObject.addScheduleObj.Radiologist.tooltip = toolip ? toolip : "Select Providers";
        }
        $scope.DataObject.onAltRadiologistSelected = function (tag) {
            if (tag) {
                var RadiologistsList = _.cloneDeep($scope.DataObject.RadiologistsList);
                _.remove(RadiologistsList, { Id: tag.Id });
                $scope.DataObject.RadiologistsList = _.cloneDeep(RadiologistsList);
            }
            var toolip = createProviderTooltip($scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue.list);
            $scope.DataObject.addScheduleObj.AlternateRadiologist.tooltip = toolip ? toolip : "Select Alternate Providers";
        }
        $scope.DataObject.onRadiologistRemoved = function (tag) {
            if (tag) {
                var AlternateRadiologistsList = _.cloneDeep($scope.DataObject.AlternateRadiologistsList);
                var alternateRadiologistIdx = _.findIndex(AlternateRadiologistsList, { Id: tag.Id });
                if (alternateRadiologistIdx == -1) {
                    AlternateRadiologistsList.push(tag);
                }
                $scope.DataObject.AlternateRadiologistsList = _.cloneDeep(AlternateRadiologistsList);
            }
            var toolip = createProviderTooltip($scope.DataObject.addScheduleObj.Radiologist.SelectedValue.list);
            $scope.DataObject.addScheduleObj.Radiologist.tooltip = toolip ? toolip : "Select Providers";
        }
        $scope.DataObject.onAltRadiologistRemoved = function (tag) {
            if (tag) {
                var RadiologistsList = _.cloneDeep($scope.DataObject.RadiologistsList);
                var radiologistIdx = _.findIndex(RadiologistsList, { Id: tag.Id });
                if (radiologistIdx == -1) {
                    RadiologistsList.push(tag);
                }
                $scope.DataObject.RadiologistsList = _.cloneDeep(RadiologistsList);
            }
            var toolip = createProviderTooltip($scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue.list);
            $scope.DataObject.addScheduleObj.AlternateRadiologist.tooltip = toolip ? toolip : "Select Alternate Providers";
        }
        $scope.DataObject.openFromDate = function () {
            $scope.DataObject.FromDateOpen = true;
        }
        $scope.DataObject.openToDate = function () {
            $scope.DataObject.ToDateOpen = true;
        }
        $scope.DataObject.SaveOnCallSchedule = function () {
            var d = $q.defer();
            if ($scope.DataObject.addScheduleObj.selectedRule) {
                var fromDate = moment($scope.DataObject.addScheduleObj.FromDate);
                var toDate = moment($scope.DataObject.addScheduleObj.ToDate);
                if (fromDate.isAfter(toDate)) {
                    toaster.pop({ type: 'warning', body: "The from date cannot be greater than the to date." });
                    return;
                }
                var params = {
                    FromDate: $filter('CSTDateTime')(moment($scope.DataObject.addScheduleObj.FromDate)),
                    ToDate: $filter('CSTDateTime')(moment($scope.DataObject.addScheduleObj.ToDate)),
                    RuleID: $scope.DataObject.addScheduleObj.selectedRule.RuleID,
                    CreatedBy: $sessionStorage.currentUserData.userId,
                    StatusFlag: 'N',
                    ScheduleName: $scope.DataObject.addScheduleObj.ScheduleName,
                };
                if ($scope.DataObject.selectedRow && $scope.DataObject.selectedRow.TATScheduleID) {
                    params.TATScheduleID = $scope.DataObject.selectedRow.TATScheduleID;
                    params.StatusFlag = "M";
                }
                var ProviderIDs = "";
                if ($scope.DataObject.addScheduleObj.Radiologist.SelectedValue &&
                    $scope.DataObject.addScheduleObj.Radiologist.SelectedValue.list &&
                    $scope.DataObject.addScheduleObj.Radiologist.SelectedValue.list.length > 0) {
                    _.each($scope.DataObject.addScheduleObj.Radiologist.SelectedValue.list, function (obj) {
                        if (ProviderIDs == "") {
                            ProviderIDs = obj.Id;
                        }
                        else {
                            ProviderIDs = ProviderIDs + "," + obj.Id;
                        }
                    });
                }
                params.ProviderIDs = ProviderIDs;

                var AlternateProviderIDs = "";
                if ($scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue &&
                    $scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue.list &&
                    $scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue.list.length > 0) {
                    _.each($scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue.list, function (obj) {
                        if (AlternateProviderIDs == "") {
                            AlternateProviderIDs = obj.Id;
                        }
                        else {
                            AlternateProviderIDs = AlternateProviderIDs + "," + obj.Id;
                        }
                    });
                }
                params.AlternateProviderIDs = AlternateProviderIDs;

                TATNotificationService.SetTATSchedules(params).then(function () {
                    var toasterMsg = "Notification Schedule " + (($scope.DataObject.selectedRow && $scope.DataObject.selectedRow.TATScheduleID) ? "Updated" : "Created") + " Successfully.";
                    toaster.pop({ type: 'success', body: toasterMsg });
                    $("#addScheduleModal").modal('hide');
                    $scope.clearAddScheduleData();
                    $scope.DataObject.FilterTATScheduleList();
                    d.resolve();
                }, function (err) {
                    toaster.pop({ type: 'error', body: "Some Error Occurred!" });
                    d.resolve();
                });
            } else {
                d.resolve();
            }
            return d.promise;
        }

        $scope.DataObject.EditSchedule = function (scheduleData) {
            if (scheduleData) {
                $scope.DataObject.selectedRow = scheduleData;
                var selectedRule = _.find($scope.DataObject.TATRuleList, function (obj) {
                    return obj.RuleID == scheduleData.RuleID;
                });
                if (selectedRule) {
                    createAddScheduleObj(selectedRule, scheduleData);
                    $("#addScheduleModal").modal('show');
                }
            }
        }
        $scope.DataObject.DeleteSchedule = function (scheduleData) {
            if (scheduleData) {
                swal({
                    title: scheduleData.ScheduleName + " schedule will be deleted.<br> Do you want to continue?",
                    type: "warning",
                    html: true,
                    customClass: 'swal-wide',
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                }, function (isConfirm) {
                    if (isConfirm) {
                        TATNotificationService.DeleteTATSchedules({
                            TATScheduleID: scheduleData.TATScheduleID,
                            ModifyBy: $sessionStorage.currentUserData.userId,
                            StatusFlag: 'D',
                        }).then(function () {
                            toaster.pop({ type: 'success', body: "Notification Schedule Deleted Successfully." });
                            $scope.DataObject.FilterTATScheduleList();
                        }, function (err) { toaster.pop({ type: 'error', body: "Some Error Occurred!" }); });
                    }
                });
            }
        }
        $scope.DataObject.viewRuleDetails = function (scheduleData) {
            if (!$scope.DataObject.isRowDetailsVisible || $scope.DataObject.addScheduleObj.selectedRule.RuleID != scheduleData.RuleID) {
                if (scheduleData) {
                    $scope.DataObject.selectedRow = scheduleData;
                    var selectedRule = _.find($scope.DataObject.TATRuleList, function (obj) {
                        return obj.RuleID == scheduleData.RuleID;
                    });
                    if (selectedRule) {
                        createAddScheduleObj(selectedRule, scheduleData);
                        $scope.DataObject.isRowDetailsVisible = true;
                    }
                }
            } else {
                $scope.clearAddScheduleData();
            }
        }
        $scope.DataObject.FilterTATScheduleList = function () {
            TATSchedulesList = [];
            TATSchedulesProvidersList = [];
            TATSchedulesAltProvidersList = [];
            if (gridAPI) gridAPI.refreshServerSide({ purge: true });
        }
        $scope.DataObject.ClearTATScheduleListFilter = function () {
            $scope.DataObject.filter = {
                ScheduleName: null,
                selectedRule: null,
                Radiologist: {
                    divId: "filterScheduleRadiologist",
                    keys: ['LastName', 'FirstName'],
                    uniqKey: 'Id',
                    placeHolder: "Select Radiologist",
                    SelectedValue: { list: [] }
                },
                FromDate: null,
                ToDate: null
            }
            $scope.DataObject.FilterTATScheduleList();
        }

        $scope.DataObject.isAddScheduleDisabled = function () {
            if ($scope.DataObject.addScheduleObj) {
                return !($scope.DataObject.addScheduleObj.ScheduleName && $scope.DataObject.addScheduleObj.ScheduleName != "" &&
                    $scope.DataObject.addScheduleObj.selectedRule &&
                    $scope.DataObject.addScheduleObj.Radiologist.SelectedValue && $scope.DataObject.addScheduleObj.Radiologist.SelectedValue.list &&
                    $scope.DataObject.addScheduleObj.Radiologist.SelectedValue.list.length > 0 &&
                    $scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue && $scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue.list &&
                    $scope.DataObject.addScheduleObj.AlternateRadiologist.SelectedValue.list.length > 0 &&
                    $scope.DataObject.addScheduleObj.FromDate &&
                    $scope.DataObject.addScheduleObj.ToDate)
            }
            return true;
        }
        //#endregion Scope Functions
        //----------------------------------------------------------------------------------------------
        pageInit();

        $scope.$on('$destroy', function () {
            CommonService.stopNotifyTATStudy();
        });

        window.onmessage = function (event) {
            //$log.log("onmessage");
            SharedService.handleWindowMessage(event, $scope);
        }
    }
})();
angular.module('radico.pages.settings.tatnotification')
    .service('TATNotificationService', ['Restangular', '$http', 'APP_CONSTANTS', function (Restangular, $http, APP_CONSTANTS) {

        this.SetTATSchedules = function (params) {
            return Restangular.one("TATNotification").one("SetTATSchedules").customPOST(params);
        };
        this.GetTATSchedules = function (params) {
            return Restangular.one("TATNotification").one("GetTATSchedules").customPOST(params);
        };
        this.DeleteTATSchedules = function (params) {
            return Restangular.one("TATNotification").one("DeleteTATSchedules").customPOST(params);
        };
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.settings.techform')
        .controller('TechFormController', TechFormController);
    function TechFormController($scope, $window, $sessionStorage, toastr) {
       
    }
})();


angular.module('radico.pages.settings.techform')
    .service('TechFormService', ['Restangular', '$http', 'APP_CONSTANTS', '__env', function (Restangular, $http, APP_CONSTANTS, __env) {
        var _userID, _Locations, _Procedure;
        function urlCore() {
            return __env._environment.config.apiAuthServiceBaseUri;
        }
        this.SetVRTemplate = function (data) {
            return Restangular.one('Settings').one("CIVR","SetVRTemplate").customPOST(data);
        };
        this.GetDefaultTemplate = function () {
            return Restangular.one('Settings').one("GetDefaultTemplate").get();
        };
        this.GetVRTemplate = function (data) {
            return Restangular.one('Settings').one("CIVR", "GetVRTemplate").customPOST(data);
        };
        this.GetVRTemplateList = function (data) {
            return Restangular.one('Settings').one("CIVR", "GetVRTemplateList").customPOST(data);
        };
        this.GetLookupByType = function (type) {
            return Restangular.one('psorders').one("GetLookupByType", type).get();
        };
        this.GetSitesAndLocationsByUserID = function (userID) {
            if (_userID !== userID || !_Locations) {
                _Locations = Restangular.one('psorders').one("GetSitesAndLocationsByUserID", userID).get();
            }
            return _Locations;
        };
        this.GetGetProcedure = function (search) {
            if (search) {
                return Restangular.one('Settings','CIVR').one("GetGetProcedure", search).customPOST();
            } else {
                if (!_Procedure) {
                    _Procedure = Restangular.one('Settings', 'CIVR').one("GetGetProcedure").customPOST();
                } return _Procedure;
            }
        };
        this.DeleteTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "DeleteTechForm").customPOST(data);
        };

        this.GetTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "GetTechForm").customPOST(data);
        };
        this.SetTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "SetTechForm").customPOST(data);
        };

        this.SetOrdersTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "SetOrdersTechForm").customPOST(data);
        };
        this.GetOrdersTechForm = function (data) {
            return Restangular.one('reports').one("tech-form", "GetOrdersTechForm").customPOST(data);
        };
    }]);
(function () {
    'use strict';

    angular.module('radico.pages.settings.timerticker')
        .controller('TimerTickerController', TimerTickerController);

    /**
     * Timer Ticker Controller
     * Manages site marquee settings including creation, editing, and deletion
     */
    function TimerTickerController($scope, $sessionStorage, ProfileService, $log, $q, TimerTickerService, $compile, $timeout, $filter,toaster) {
        var vm = this;

        // Constants
        var MODAL_ID = '#addTimerTickerModal';
        var GRID_ID = '#timerTickerGrid';
        var STATUS_KEYS = {
            ALL: 'AL',
            DISABLED: 'D',
            ENABLED: 'E'
        };
        var ACTION_FLAGS = {
            INSERT: 'I',
            UPDATE: 'U',
            DELETE: 'D'
        };

        // Grid API references
        var gridapi = null;
        var columnapi = null;

        $scope.DataObject = {
            TenantsList: [],
            SitesList: [],
            StatusList: [
                {
                    key: STATUS_KEYS.ALL,
                    value: 'All'
                },
                {
                    key: STATUS_KEYS.DISABLED,
                    value: 'Disabled'
                },
                {
                    key: STATUS_KEYS.ENABLED,
                    value: 'Enabled'
                }
            ],
            Filter: {
                selectedStatus: {
                    key: STATUS_KEYS.ENABLED,
                    value: 'Enabled'
                },
                SelectedTenant: null,
                SelectedFilterDateRange: {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment(),
                    label: "Last 7 Days",
                },
                SelectedFilterDateRangeTooltip:"Select Date Range"
            },
            multiSelectDropdown: {
                SiteDropdown: {
                    divId: 'SiteDropdownAddTimerTicker',
                    keys: ['TenantSite'],
                    uniqKey: 'SiteID',
                    placeHolder: 'Select Site(s)'
                }
            },
            SelectedSites: { list: [] },
            SelectedDateRange: null,
            IsTickerEnabled: true,
            TickerValue: null,
            SiteMarqueeSettingID: null
        };

        // Date range picker options
        $scope.DOSopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: 'Apply',
                fromLabel: 'From',
                format: 'MM/DD/YYYY',
                toLabel: 'To',
                customRangeLabel: 'Custom range'
            }
        };
        $scope.FilterDOSopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                customRangeLabel: 'Custom range',
            },
            ranges: {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            },
            eventHandlers: {
                'apply.daterangepicker': function (event, picker) {
                    $scope.DataObject.Filter.SelectedFilterDateRangeTooltip = createDOSFilterTooltip();
                    $scope.FilterTimerTickerList();
                }
            }
        };

        /**
         * Component initialization
         */
        vm.$onInit = function () {
            initGrid();
            GetSitesByUserId();
            $scope.FilterTimerTickerList();
            $scope.DataObject.Filter.SelectedFilterDateRangeTooltip = createDOSFilterTooltip();
        };

        // Grid column definitions
        var columndefs = [
            {
                field: 'Site',initialWidth: 200,
                sortable: true
            },
            {
                field: 'MarqueeText',
                headerName: 'Footer Ticker Message',initialWidth: 500,
                tooltipField: 'MarqueeText',
                flex: 1
            },
            {
                field: 'StartDate',
                headerName: 'Start Date',
                valueFormatter: function (params) {
                    if (params.value) {
                        return moment($filter('localDate')(params.value, false, new Date())).format("MM/DD/YYYY");
                    }
                    return '';
                },initialWidth: 200,
                sortable: true
            },
            {
                field: 'EndDate',
                headerName: 'End Date',
                valueFormatter: function (params) {
                    if (params.value) {
                        return moment($filter('localDate')(params.value, false, new Date())).format("MM/DD/YYYY");
                    }
                    return '';
                },
                initialWidth: 200,
                sortable: true
            },
            {
                field: 'IsEnable',
                cellEditor: 'agCheckboxCellEditor',
                cellRenderer: 'agCheckboxCellRenderer',
                editable: true,
                initialWidth: 150
            },
            {
                field: 'Action',
                cellRenderer: ActionItemCellRenderer(),
                initialWidth: 150,
            }
        ];

        // Grid options configuration
        var gridoptions = {
            columnDefs: columndefs,
            enableBrowserTooltips: true,
            defaultColDef: {
                lockVisible: true,
                suppressMovable: true,
                suppressMenu: true,
                resizable: true,
                sortable: false,
            },
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getContextMenuItems: function () {
                return [];
            },
            rowData: [],
            getRowId: function (params) {
                return params.data.SiteMarqueeSettingID;
            },
        onCellEditingStopped: function(params) {
            // Ensure we have correct field and value
            if (params.column && params.column.colId === 'IsEnable') {
                var data = params.data;
                if (data && data.SiteMarqueeSettingID !== undefined) {
                    // Prepare payload to update just IsEnable value
                    var payload = {
                        SiteMarqueeSettingID: data.SiteMarqueeSettingID,
                        IsEnable: params.newValue,
                        Flag: ACTION_FLAGS.UPDATE,
                        StartDate: $filter('CSTDateTime')(data.StartDate),
                        EndDate: $filter('CSTDateTime')(data.EndDate),
                        CreatedBy: $sessionStorage.currentUserData.userId,
                        SiteIDs: data.SiteID,
                        MarqueeText: data.MarqueeText,
                    };
                TimerTickerService.SetSiteMarqueeSetting(payload)
                    .then(function (response) {
                        toaster.pop({type: 'success', body: 'Timer Ticker is '+(params.newValue?'Enabled':'Disabled')+' successfully'});
                        $scope.FilterTimerTickerList();
                    })
                    .catch(function (error) {
                        $log.error('Error updating IsEnable value:', error);
                    });
                }
            }
        },
        };

        function actionButton(title, ngClick, iconClass, style) {
            var button = document.createElement('button');
            button.className = 'btn btn-default txt-clr-14 px-5px mx-5px border-0 my-0 py-0 ml-0';
            button.title = title;
            button.setAttribute('ng-click', ngClick);
            if (style) {
                button.style.cssText = style;
            }
            var icon = document.createElement('span');
            icon.className = iconClass;
            button.appendChild(icon);
            return button;
        }
        /**
         * Custom cell renderer for action buttons (Edit/Delete)
         * @returns {Function} CustomRenderer constructor
         */
        function ActionItemCellRenderer() {
            function CustomRenderer() {}

            CustomRenderer.prototype.init = function (params) {
                var obj = _.cloneDeep(params.data);
                obj.isEditing = false;
                var uniqueId = 'marquee_' + obj.SiteMarqueeSettingID;
                $scope[uniqueId] = obj;
                this.eGui = document.createElement('div');

                var wrapper = document.createElement('div');
                wrapper.appendChild(actionButton('Edit', 'EditTimerTicker(this.' + uniqueId + ')', 'glyphicon glyphicon-pencil', null));
                wrapper.appendChild(actionButton('Delete', 'DeleteTimerTicker(this.' + uniqueId + ')', 'fa fa-trash-o fs-15px', 'padding-bottom: 2px !important;'));
                this.eGui.appendChild(wrapper);
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);

                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                }, 0);
            };

            CustomRenderer.prototype.getGui = function () {
                return this.eGui;
            };

            CustomRenderer.prototype.destroy = function () {
                // Cleanup if needed
            };

            return CustomRenderer;
        }

        /**
         * Initialize ag-Grid instance
         */
        function initGrid() {
            var gridDiv = document.querySelector(GRID_ID);
            if (gridDiv && gridoptions && !gridapi) {
                new agGrid.Grid(gridDiv, gridoptions);
                gridapi = gridoptions.api;
                columnapi = gridoptions.columnApi;
            }
        }

        /**
         * Open add timer ticker modal and reset form
         */
        $scope.AddTimerTicker = function () {
            resetFormData();
            $(MODAL_ID).modal('show');
        };

        /**
         * Reset form data to initial state
         */
        function resetFormData() {
            $scope.DataObject.SiteMarqueeSettingID = null;
            $scope.DataObject.TickerValue = null;
            $scope.DataObject.IsTickerEnabled = true;
            $scope.DataObject.SelectedSites = { list: [] };
            $scope.DataObject.SelectedDateRange = null;
        }

        /**
         * Fetch sites associated with the current user
         */
        function GetSitesByUserId() {
            if (!$sessionStorage.currentUserData || !$sessionStorage.currentUserData.userId) {
                $log.error('User session data not available');
                return;
            }

            ProfileService.GetSitesByUserId($sessionStorage.currentUserData.userId)
                .then(function (result) {
                    if (result && result.data) {
                        _.each(result.data, function (obj) {
                            obj.TenantSite = obj.Site + ' (' + obj.TenantName + ')';
                        });
                        $scope.DataObject.SitesList = result.data;
                        $scope.DataObject.TenantsList = _.uniqBy(result.data, 'TenantID');
                    }
                })
                .catch(function (error) {
                    $log.error('Error fetching sites by user ID:', error);
                });
        }

        /**
         * Filter timer ticker list based on selected criteria
         */
        $scope.FilterTimerTickerList = function () {
            var params = {
                TenantID: $scope.DataObject.Filter.SelectedTenant ? $scope.DataObject.Filter.SelectedTenant.TenantID : null,
                UserID: $sessionStorage.currentUserData.userId,
                IsEnable: $scope.DataObject.Filter.selectedStatus ? $scope.DataObject.Filter.selectedStatus.key : null,
                StartDate: $filter('CSTDateTime')($scope.DataObject.Filter.SelectedFilterDateRange.startDate),
                EndDate: $filter('CSTDateTime')($scope.DataObject.Filter.SelectedFilterDateRange.endDate),
            };

            TimerTickerService.GetSiteMarqueeList(params)
                .then(function (result) {
                    gridapi.setRowData(result || []);
                })
                .catch(function (error) {
                    $log.error('Error fetching Site Marquee Settings:', error);
                    gridapi.setRowData([]);
                });
        };

        /**
         * Clear all filters and reset to default values
         */
        $scope.ClearFilter = function () {
            $scope.DataObject.Filter = {
                selectedStatus: {
                    key: STATUS_KEYS.ENABLED,
                    value: 'Enabled'
                },
                SelectedTenant: null,
                SelectedFilterDateRange: {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment(),
                    label: "Last 7 Days",
                },
                SelectedFilterDateRangeTooltip:createDOSFilterTooltip(),
            };
            $scope.FilterTimerTickerList();
        };

        $scope.SaveTimerTicker = function () {
            var selectedSites = $scope.DataObject.SelectedSites && $scope.DataObject.SelectedSites.list;
            var siteIDs = '';

            var selectedSites = $scope.DataObject.SelectedSites.list;
            var siteIDs = selectedSites.map(function (siteObj) {
                return siteObj.SiteID;
            }).join(',');

            var payload = {
                SiteIDs: siteIDs,
                CreatedBy: $sessionStorage.currentUserData.userId,
                IsEnable: $scope.DataObject.IsTickerEnabled,
                MarqueeText: $scope.DataObject.TickerValue,
                StartDate: $filter('CSTDateTime')($scope.DataObject.SelectedDateRange.startDate),
                EndDate: $filter('CSTDateTime')($scope.DataObject.SelectedDateRange.endDate),
                Flag: $scope.DataObject.SiteMarqueeSettingID ? ACTION_FLAGS.UPDATE : ACTION_FLAGS.INSERT,
                SiteMarqueeSettingID: $scope.DataObject.SiteMarqueeSettingID || undefined
            };

            TimerTickerService.SetSiteMarqueeSetting(payload)
                .then(function (response) {
                    toaster.pop({type: 'success', body: 'Timer Ticker is '+( $scope.DataObject.SiteMarqueeSettingID?'Updated':'Created')+' successfully.'});
                    $(MODAL_ID).modal('hide');
                    resetFormData();
                    $scope.FilterTimerTickerList();
                })
                .catch(function (error) {
                    $log.error('Error saving Timer Ticker:', error);
                });
        };

        /**
         * Edit existing timer ticker entry
         * @param {Object} data - The timer ticker data to edit
         */
        $scope.EditTimerTicker = function (data) {
            if (!data) {
                $log.error('No data provided for editing');
                return;
            }

            // Pre-fill form with existing data
            $scope.DataObject.SiteMarqueeSettingID = data.SiteMarqueeSettingID;
            $scope.DataObject.TickerValue = data.MarqueeText;
            $scope.DataObject.IsTickerEnabled = data.IsEnable;

            // Map selected sites from comma-separated SiteIDs
            if (data.SiteID) {
                $scope.DataObject.SelectedSites = {
                    list: $scope.DataObject.SitesList.filter(function (site) {
                        return site.SiteID === data.SiteID;
                    })
                };
            } else {
                $scope.DataObject.SelectedSites = { list: [] };
            }

            // Convert and set date range
            if (data.StartDate && data.EndDate) {
                $scope.DataObject.SelectedDateRange = {
                    startDate: $filter('date')(moment(data.StartDate), 'yyyy-MM-ddTHH:mm:ss'),
                    endDate: $filter('date')(moment(data.EndDate), 'yyyy-MM-ddTHH:mm:ss')
                };
            }

            $(MODAL_ID).modal('show');
        };

        /**
         * Delete timer ticker entry
         * @param {Object} rowData - The row data containing SiteMarqueeSettingID
         */
        $scope.DeleteTimerTicker = function (rowData) {
            if (!rowData || !rowData.SiteMarqueeSettingID) {
                $log.error('Invalid row data: SiteMarqueeSettingID required');
                return;
            }

            // Optional: Add confirmation dialog here
            // if (!confirm('Are you sure you want to delete this timer ticker?')) {
            //     return;
            // }

            var payload = {
                Flag: ACTION_FLAGS.DELETE,
                SiteMarqueeSettingID: rowData.SiteMarqueeSettingID,
                CreatedBy: $sessionStorage.currentUserData.userId,
                SiteIDs: rowData.SiteID,
                MarqueeText: rowData.MarqueeText,
                StartDate: $filter('CSTDateTime')(rowData.StartDate),
                EndDate: $filter('CSTDateTime')(rowData.EndDate),
            };

            TimerTickerService.SetSiteMarqueeSetting(payload)
                .then(function (response) {
                    $scope.FilterTimerTickerList();
                    toaster.pop({type: 'success', body: 'Timer Ticker is deleted successfully.'});
                })
                .catch(function (error) {
                    $log.error('Error deleting Timer Ticker:', error);
                });
        };
        function createDOSFilterTooltip(){
            return ($scope.DataObject.Filter.SelectedFilterDateRange.startDate && $scope.DataObject.Filter.SelectedFilterDateRange.endDate) ?
            $scope.DataObject.Filter.SelectedFilterDateRange.startDate.format("MM/DD/YYYY") + " - " + $scope.DataObject.Filter.SelectedFilterDateRange.endDate.format("MM/DD/YYYY") :
            "Select Date Range";
        }
    }
})();

angular.module('radico.pages.settings.timerticker')
    .service('TimerTickerService', ['Restangular', '$http', 'APP_CONSTANTS', function (Restangular, $http, APP_CONSTANTS) {

        this.SetSiteMarqueeSetting = function (params) {
            return Restangular.one("Settings").one("SetSiteMarqueeSetting").customPOST(params);
        };

        this.GetSiteMarqueeSetting = function (params) {
            return Restangular.one("Settings").one("GetSiteMarqueeSetting").customPOST(params);
        };

        this.GetSiteMarqueeList = function (params) {
            return Restangular.one("Settings").one("GetSiteMarqueeList").customPOST(params);
        };

    }]);

(function () {
    'use strict';

    angular
        .module('radico.pages.settings.updateviewer')
        .controller('UpdateViewerController', UpdateViewerController);

    UpdateViewerController.$inject = [
        '$scope', '$q', '$compile', '$timeout', '$sessionStorage',
        'UpdateViewerService', 'ManageLocationService', 'RuleService', 'ProfileService',
        'toaster', 'CommonService', 'SharedService'
    ];

    function UpdateViewerController(
        $scope, $q, $compile, $timeout, $sessionStorage,
        UpdateViewerService, ManageLocationService, RuleService, ProfileService,
        toaster, CommonService, SharedService
    ) {
        var vm = this;
        var gridAPI = null;

        // ── Viewer options (loaded from lookup, same source as Site settings) ──
        vm.viewerOptions = [];
        vm.viewerLookup = {}; // Value → Key, used for grid display

        // ── Reference data ──────────────────────────────────────────────────────
        vm.sitesList = [];
        vm.radiologists = [];

        // ── multi-Select configs (unique divId per instance) ────────────────────
        vm.filterSiteConfig = {
            divId: 'SiteDropdownFilterUpdateViewer',
            keys: ['TenantSite'],
            uniqKey: 'SiteID',
            placeHolder: 'Select Site(s)'
        };
        vm.modalSiteConfig = {
            divId: 'SiteDropdownModalUpdateViewer',
            keys: ['TenantSite'],
            uniqKey: 'SiteID',
            placeHolder: 'Select Site(s)'
        };

        // ── Date range picker options ───────────────────────────────────────────
        vm.FilterDOSopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: 'Apply',
                fromLabel: 'From',
                format: 'MM/DD/YYYY',
                toLabel: 'To',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today':        [moment(), moment()],
                'Next 3 Days':  [moment(), moment().add(2, 'days')],
                'Next 7 Days':  [moment(), moment().add(6, 'days')],
                'Next 30 Days': [moment(), moment().add(29, 'days')]
            },
            eventHandlers: {
                'apply.daterangepicker': function () {
                    vm.search();
                }
            }
        };

        vm.DOSopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: 'Apply',
                fromLabel: 'From',
                format: 'MM/DD/YYYY',
                toLabel: 'To',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Today':        [moment(), moment()],
                'Next 3 Days':  [moment(), moment().add(2, 'days')],
                'Next 7 Days':  [moment(), moment().add(6, 'days')],
                'Next 30 Days': [moment(), moment().add(29, 'days')]
            }
        };

        // ── Site tooltip helper ─────────────────────────────────────────────────
        vm.getSiteTooltip = function (siteModel) {
            var sites = siteModel && siteModel.list || [];
            if (sites.length === 0) return 'Select Site(s)';
            var TOOLTIP_LIMIT = 10;
            var names = _.map(sites, 'TenantSite');
            if (names.length <= TOOLTIP_LIMIT) return names.join('\n');
            return names.slice(0, TOOLTIP_LIMIT).join('\n') + '\n... ' + (names.length - TOOLTIP_LIMIT) + ' more';
        };

        vm.getRadiologistTooltip = function (rads) {
            var list = rads || [];
            if (list.length === 0) return 'Select Radiologist';
            var TOOLTIP_LIMIT = 10;
            var names = _.map(list, function (r) { return r.LastName + ', ' + r.FirstName; });
            if (names.length <= TOOLTIP_LIMIT) return names.join('\n');
            return names.slice(0, TOOLTIP_LIMIT).join('\n') + '\n... ' + (names.length - TOOLTIP_LIMIT) + ' more';
        };

        vm.getDateRangeTooltip = function (range) {
            if (!range || !range.startDate) { return 'Select Date Range'; }
            return moment(range.startDate).format('MM/DD/YYYY') + ' — ' + moment(range.endDate).format('MM/DD/YYYY');
        };

        // ── Radiologist search (load on type, like payment contract) ────────────
        vm.filterRadiologistMatches = [];
        vm.modalRadiologistMatches  = [];

        vm.searchRadiologists = function (search, target) {
            var all = target === 'modal' ? _modalRadiologists : _filterRadiologists;
            var matches = (search && search.trim().length > 0)
                ? _.filter(all, function (r) {
                    var term = search.toLowerCase();
                    return (r.FirstName || '').toLowerCase().indexOf(term) >= 0
                        || (r.LastName  || '').toLowerCase().indexOf(term) >= 0
                        || (r.Email     || '').toLowerCase().indexOf(term) >= 0
                        || (r.PhoneNumber || '').toLowerCase().indexOf(term) >= 0;
                })
                : all;
            if (target === 'modal') {
                var selectedIds = {};
                _.each(vm.modal && vm.modal.selectedRadiologists || [], function (r) { selectedIds[r.Id] = true; });
                vm.modalRadiologistMatches = _.filter(matches, function (r) { return !selectedIds[r.Id]; });
            } else {
                vm.filterRadiologistMatches = matches;
            }
        };

        // ── Pagination ──────────────────────────────────────────────────────────
        vm.totalRows = 0;
        vm.currentPage = 1;
        vm.pageSize = 25;

        // ── Modal state ─────────────────────────────────────────────────────────
        vm.modalTitle = '';

        vm.modal = {};
        vm.modalRadiologists = [];

        // ── Filter state ────────────────────────────────────────────────────────
        vm.filter = {};

        // ── Radiologist pools (full list or site-filtered) ──────────────────────
        var _filterRadiologists  = [];
        var _modalRadiologists   = [];
        var _modalInitialLoad    = false;

        // ── ag-grid rows keyed by OverrideID for cellRenderer closures ──────────
        var gridRowsMap = {};

        // ════════════════════════════════════════════════════════════════════════
        // Initialization
        // ════════════════════════════════════════════════════════════════════════
        function pageInit() {
            CommonService.startNotifyTATStudy();
            resetFilter();
            $q.all([
                loadSites(),
                loadRadiologists(),
                loadViewerOptions()
            ]).then(function () {
                initGrid();
                vm.search();
                setupSiteWatchers();
            });
        }

        function setupSiteWatchers() {
            $scope.$watchCollection(function () {
                return vm.filter.SelectedSites && vm.filter.SelectedSites.list;
            }, function (newVal, oldVal) {
                if (newVal === oldVal) { return; }
                loadRadiologistsBySite(newVal || [], 'filter');
            });

            $scope.$watchCollection(function () {
                return vm.modal.SelectedSites && vm.modal.SelectedSites.list;
            }, function (newVal, oldVal) {
                if (newVal === oldVal) { return; }
                loadRadiologistsBySite(newVal || [], 'modal');
            });
        }

        function loadViewerOptions() {
            var d = $q.defer();
            ManageLocationService.GetLookupByType('DicomViewer').then(function (result) {
                vm.viewerOptions = _.sortBy(result || [], 'Key');
                vm.viewerLookup = {};
                _.each(vm.viewerOptions, function (item) { vm.viewerLookup[item.Value] = item.Key; });
                d.resolve();
            }, function () {
                vm.viewerOptions = [];
                vm.viewerLookup = {};
                d.resolve();
            });
            return d.promise;
        }

        function resetFilter() {
            vm.filter = {
                SelectedSites: { list: [] },
                selectedRadiologists: [],
                SelectedFilterDateRange: null,
                dicomViewer: ''
            };
        }

        function loadSites() {
            var d = $q.defer();
            ProfileService.GetSitesByUserId($sessionStorage.currentUserData.userId)
                .then(function (result) {
                    if (result && result.data) {
                        _.each(result.data, function (obj) {
                            obj.TenantSite = obj.Site + ' (' + obj.TenantName + ')';
                        });
                        vm.sitesList = result.data;
                    }
                    d.resolve();
                })
                .catch(function () {
                    vm.sitesList = [];
                    d.resolve();
                });
            return d.promise;
        }

        function loadRadiologists() {
            var d = $q.defer();
            RuleService.GetAllUserByTenant({ UserID: $sessionStorage.currentUserData.userId }).then(function (result) {
                vm.radiologists = _.filter(result || [], function (r) {
                    var first = (r.FirstName || '').trim();
                    var last  = (r.LastName  || '').trim();
                    return first.length > 0 || last.length > 0;
                });
                _filterRadiologists = vm.radiologists;
                _modalRadiologists  = vm.radiologists;
                vm.modalRadiologists = vm.radiologists;
                d.resolve();
            }, function () {
                vm.radiologists = [];
                _filterRadiologists = [];
                _modalRadiologists  = [];
                vm.modalRadiologists = [];
                d.resolve();
            });
            return d.promise;
        }

        function loadRadiologistsBySite(sites, target) {
            if (!sites || sites.length === 0) {
                if (target === 'modal') {
                    _modalRadiologists = vm.radiologists;
                    vm.modalRadiologistMatches = _modalRadiologists;
                    vm.modal.selectedRadiologists = [];
                } else {
                    _filterRadiologists = vm.radiologists;
                    vm.filterRadiologistMatches = _filterRadiologists;
                    vm.filter.selectedRadiologists = [];
                }
                return;
            }
            var siteIDs = _.map(sites, 'SiteID').join(',');
            UpdateViewerService.getRadiologistBySite(siteIDs).then(function (resp) {
                var list = (resp.data && resp.data.radiologistsLists) || [];
                if (target === 'modal') {
                    _modalRadiologists = list;
                    var selectedIds = {};
                    _.each(vm.modal && vm.modal.selectedRadiologists || [], function (r) { selectedIds[r.Id] = true; });
                    vm.modalRadiologistMatches = _.filter(list, function (r) { return !selectedIds[r.Id]; });
                    if (!_modalInitialLoad) {
                        vm.modal.selectedRadiologists = _.uniqBy(_.filter(vm.modal.selectedRadiologists || [], function (r) {
                            return _.find(list, { Id: r.Id });
                        }), 'Id');
                    }
                    _modalInitialLoad = false;
                } else {
                    _filterRadiologists = list;
                    vm.filterRadiologistMatches = list;
                    vm.filter.selectedRadiologists = _.filter(vm.filter.selectedRadiologists || [], function (r) {
                        return _.find(list, { Id: r.Id });
                    });
                }
            }, function () {
                if (target === 'modal') {
                    _modalRadiologists = [];
                    vm.modalRadiologistMatches = [];
                } else {
                    _filterRadiologists = [];
                    vm.filterRadiologistMatches = [];
                }
            });
        }

        // ════════════════════════════════════════════════════════════════════════
        // Search / Reset
        // ════════════════════════════════════════════════════════════════════════
        vm.search = function () {
            if (!gridAPI) { return; }
            gridRowsMap = {};
            gridAPI.refreshServerSide({ purge: true });
        };

        vm.reset = function () {
            resetFilter();
            vm.search();
        };

        vm.pageChanged = function () {
            vm.search();
        };

        // ── Build the filter payload ─────────────────────────────────────────────
        function buildSearchPayload() {
            var sites = vm.filter.SelectedSites && vm.filter.SelectedSites.list || [];
            // SP takes single INT — only filter by the first selected site
            var firstSite = sites.length ? sites[0] : null;

            var startDate = vm.filter.SelectedFilterDateRange && vm.filter.SelectedFilterDateRange.startDate
                ? moment(vm.filter.SelectedFilterDateRange.startDate).format('YYYY-MM-DD') : null;
            var endDate = vm.filter.SelectedFilterDateRange && vm.filter.SelectedFilterDateRange.endDate
                ? moment(vm.filter.SelectedFilterDateRange.endDate).format('YYYY-MM-DD') : null;

            return {
                TenantID: firstSite ? firstSite.TenantID : null,
                SiteID:   firstSite ? firstSite.SiteID   : null,
                StartDate: startDate,
                EndDate: endDate,
                DicomViewer: vm.filter.dicomViewer || null,
                PageNum: vm.currentPage,
                PageSize: vm.pageSize,
                UserID: $sessionStorage.currentUserData.userId
            };
        }

        // ════════════════════════════════════════════════════════════════════════
        // ag-grid
        // ════════════════════════════════════════════════════════════════════════
        function actionButton(title, ngClick, iconClass) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'btn btn-default txt-clr-14 px-1 border-0 mx-1 my-0 py-0';
            button.title = title;
            button.setAttribute('ng-click', ngClick);
            var icon = document.createElement('i');
            icon.className = iconClass;
            button.appendChild(icon);
            return button;
        }
        function ActionCellRenderer() {
            function CustomRenderer() { }

            CustomRenderer.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.className = 'd-flex';

                if (params.data && params.data.OverrideID != null) {
                    gridRowsMap[params.data.OverrideID] = params.data;
                }

                var overrideID = params.data ? params.data.OverrideID : null;
                this.eGui.appendChild(actionButton('Update Override', 'vm.openModal(vm._gridRowsMap[' + overrideID + '])', 'fa fa-pencil'));
                this.eGui.appendChild(actionButton('Delete Override', 'vm.deleteOverride(' + overrideID + ')', 'fa fa-trash'));
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
            };

            CustomRenderer.prototype.getGui = function () { return this.eGui; };
            CustomRenderer.prototype.destroy = function () { };
            return CustomRenderer;
        }

        vm.gridOptions = {
            columnDefs: [
                { field: 'TenantName', headerName: 'Tenant', flex: 1, minWidth: 120, resizable: true, sortable: true },
                { field: 'SiteName', headerName: 'Site', flex: 1, minWidth: 120, resizable: true, sortable: true },
                {
                    field: 'RadiologistName', headerName: 'Radiologist(s)', flex: 1, minWidth: 150, resizable: true,
                    cellRenderer: function (params) {
                        if (!params.value) { return '<span class="txt-clr-4">All</span>'; }
                        return params.value;
                    }
                },
                {
                    field: 'StartDate', headerName: 'Start Date', flex: 1, minWidth: 110, resizable: true, sortable: true,
                    cellRenderer: function (params) {
                        if (!params.value) { return ''; }
                        return params.value.toString().split('T')[0];
                    }
                },
                {
                    field: 'EndDate', headerName: 'End Date', flex: 1, minWidth: 110, resizable: true, sortable: true,
                    cellRenderer: function (params) {
                        if (!params.value) { return ''; }
                        return params.value.toString().split('T')[0];
                    }
                },
                {
                    field: 'DicomViewer', headerName: 'DICOM Viewer', flex: 1, minWidth: 130, resizable: true, sortable: true,
                    cellRenderer: function (params) {
                        return vm.viewerLookup[params.value] || params.value || '';
                    }
                },
                {
                    field: 'Action',
                    headerName: 'Action',
                    width: 90,
                    resizable: false,
                    sortable: false,
                    cellRenderer: ActionCellRenderer()
                }
            ],
            defaultColDef: {
                lockVisible: true,
                suppressMovable: true,
                menuTabs: []
            },
            rowModelType: 'serverSide',
            cacheBlockSize: 25,
            suppressContextMenu: true,
            alwaysShowVerticalScroll: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size:16px;border:0px">No data available.</span>',
            onGridReady: function (params) {
                gridAPI = params.api;
                gridAPI.setServerSideDatasource(createServerSideDatasource());
            }
        };

        function createServerSideDatasource() {
            return {
                getRows: function (params) {
                    var payload = buildSearchPayload();
                    payload.PageNum = Math.floor(params.request.startRow / vm.pageSize) + 1;

                    UpdateViewerService.getMedDreamViewerOverride(payload).then(function (resp) {
                        var rows = Array.isArray(resp.data) ? resp.data : [];
                        vm.totalRows = rows.length > 0 ? (rows[0].TotalRows || rows.length) : 0;

                        gridRowsMap = {};
                        _.each(rows, function (row) {
                            if (row.OverrideID != null) {
                                gridRowsMap[row.OverrideID] = row;
                            }
                        });
                        vm._gridRowsMap = gridRowsMap;

                        if (rows.length === 0) {
                            gridAPI.showNoRowsOverlay();
                        } else {
                            gridAPI.hideOverlay();
                        }

                        params.success({ rowData: rows, rowCount: vm.totalRows });
                    }, function () {
                        params.fail();
                    });
                }
            };
        }

        function initGrid() {
            var gridDiv = document.querySelector('#updateViewerGrid');
            if (gridDiv) {
                new agGrid.Grid(gridDiv, vm.gridOptions);
            }
        }

        // ════════════════════════════════════════════════════════════════════════
        // Modal
        // ════════════════════════════════════════════════════════════════════════
        vm.openModal = function (row) {
            if (!row) {
                vm.modalTitle = 'Add Override';
                vm.modal = {
                    SelectedSites: { list: [] },
                    selectedRadiologists: [],
                    SelectedDateRange: null,
                    dicomViewer: null,
                    overrideID: null
                };
            } else {
                vm.modalTitle = 'Update Override';
                _modalInitialLoad = true;

                var matchSite = _.find(vm.sitesList, function (s) { return s.SiteID == row.SiteID; });
                var preSelectedRads = [];
                if (row.RadiologistUserID) {
                    _.each(row.RadiologistUserID.toString().split(','), function (id) {
                        var rad = _.find(vm.radiologists, { Id: id });
                        if (rad) { preSelectedRads.push(rad); }
                    });
                }

                var startStr = row.StartDate ? row.StartDate.toString().split('T')[0] : null;
                var endStr   = row.EndDate   ? row.EndDate.toString().split('T')[0]   : null;

                vm.modal = {
                    SelectedSites: { list: matchSite ? [matchSite] : [] },
                    selectedRadiologists: _.uniqBy(preSelectedRads, 'Id'),
                    SelectedDateRange: (startStr && endStr) ? { startDate: moment(startStr), endDate: moment(endStr) } : null,
                    dicomViewer: _.find(vm.viewerOptions, { Value: row.DicomViewer }) || null,
                    overrideID: row.OverrideID
                };
            }

            vm.modalRadiologists = vm.radiologists;
            $timeout(function () {
                $('#updateViewerModal').modal('show');
            }, 0);
        };

        vm.saveOverride = function () {
            var selectedSites = vm.modal.SelectedSites && vm.modal.SelectedSites.list || [];
            if (selectedSites.length === 0) {
                toaster.pop({ type: 'warning', body: 'Please select at least one Site.' });
                return;
            }
            if (!vm.modal.dicomViewer) {
                toaster.pop({ type: 'warning', body: 'Please select a DICOM Viewer.' });
                return;
            }
            if (!vm.modal.SelectedDateRange || !vm.modal.SelectedDateRange.startDate) {
                toaster.pop({ type: 'warning', body: 'Please select a date range.' });
                return;
            }

            var overrides = [];
            _.each(selectedSites, function (site) {
                if (vm.modal.selectedRadiologists && vm.modal.selectedRadiologists.length > 0) {
                    _.each(vm.modal.selectedRadiologists, function (rad) {
                        overrides.push({ TenantID: site.TenantID, SiteID: site.SiteID, RadiologistUserID: rad.Id });
                    });
                } else {
                    overrides.push({ TenantID: site.TenantID, SiteID: site.SiteID, RadiologistUserID: null });
                }
            });

            var payload = {
                OverrideID: vm.modal.overrideID || null,
                Overrides: overrides,
                DicomViewer: vm.modal.dicomViewer ? vm.modal.dicomViewer.Value : null,
                StartDate: moment(vm.modal.SelectedDateRange.startDate).format('YYYY-MM-DD'),
                EndDate:   moment(vm.modal.SelectedDateRange.endDate).format('YYYY-MM-DD'),
                StatusFlag: vm.modal.overrideID ? 'M' : 'N',
                UserID: $sessionStorage.currentUserData.userId
            };

            UpdateViewerService.setMedDreamViewerOverride(payload).then(function (resp) {
                var data = resp.data || {};
                if (data.Success === false) {
                    toaster.pop({ type: 'warning', body: data.Message || 'An override already exists for this Tenant/Site/Radiologist within the selected date range. Please delete it first.' });
                    return;
                }
                $('#updateViewerModal').modal('hide');
                toaster.pop({ type: 'success', body: 'Override saved successfully.' });
                vm.search();
            }, function () {
                toaster.pop({ type: 'error', body: 'An error occurred while saving the override.' });
            });
        };

        // ════════════════════════════════════════════════════════════════════════
        // Delete
        // ════════════════════════════════════════════════════════════════════════
        vm.deleteOverride = function (overrideID) {
            if (!overrideID) { return; }
            if (!confirm('Are you sure you want to delete this override?')) { return; }

            UpdateViewerService.deleteMedDreamViewerOverride({
                OverrideID: overrideID,
                UserID: $sessionStorage.currentUserData.userId
            }).then(function () {
                toaster.pop({ type: 'success', body: 'Override deleted successfully.' });
                vm.search();
            }, function () {
                toaster.pop({ type: 'error', body: 'An error occurred while deleting the override.' });
            });
        };

        // ════════════════════════════════════════════════════════════════════════
        // Lifecycle
        // ════════════════════════════════════════════════════════════════════════
        $scope.$on('$destroy', function () {
            CommonService.stopNotifyTATStudy();
        });

        window.onmessage = function (event) {
            SharedService.handleWindowMessage(event, $scope);
        };

        pageInit();
    }
})();

(function () {
    'use strict';

    angular
        .module('radico.pages.settings.updateviewer')
        .service('UpdateViewerService', UpdateViewerService);

    UpdateViewerService.$inject = ['$http', '__env'];

    function UpdateViewerService($http, __env) {
        var service = this;

        service.getMedDreamViewerOverride = function (filter) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri + 'Settings/GetMedDreamViewerOverride', filter);
        };

        service.setMedDreamViewerOverride = function (params) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri + 'Settings/SetMedDreamViewerOverride', params);
        };

        service.deleteMedDreamViewerOverride = function (model) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri + 'Settings/DeleteMedDreamViewerOverride', model);
        };

        service.getMedDreamViewerOverrideByStudy = function (model) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri + 'Settings/GetMedDreamViewerOverrideByStudy', model);
        };

        service.getRadiologistBySite = function (siteIDs) {
            return $http.post(__env._environment.config.apiResourceServiceBaseUri + 'User/GetRadiologistsBySite', { SiteID: siteIDs });
        };
    }
})();

(function () {
    'use strict';

    angular.module('radico.pages.settings.userpreference')
        .controller('UserPreferenceController', UserPreferenceController);
    function UserPreferenceController($scope, $sessionStorage, $stateParams, UserPreferenceService, ManageLocationService, ProfileService, WorklistService, filterFilter, windowHandler, $localStorage, $timeout, toastr, toaster) {
        $scope.IsDisPref = true;
        var parser = new UAParser();
        var browser = parser.getBrowser().name;
        if (browser && browser.toUpperCase() == "IE") {
            $scope.IsDisPref = false;
        }
        $scope.InstSelected = {};
        $scope.InstAddInstitution = {};
        $scope.SelectedDefaultDicomViewer = {};
        $scope.SelectedSite = {};
        $scope.SelectedViewer = {};
        $scope.PageNo = "1";
        $scope.PageSize = "25";
        $scope.OrderByField = "SITE";
        $scope.ReverseSort = true;
        $scope.AddDVCredentials = false;
        $scope.Id = -1;
        $scope.ChooseNextStudy = null;
        $scope.DeficientWarningOnWorklist = null;
        $scope.NumberofComparisonInReport = null;
        $scope.validNumberpattern = /^[0-9]\d*(\.\d+)?$/;
        $scope.isInvalidNumberofComparison = false;
        $scope.SelectedDefaultDictationSystem = {};
        $scope.DoNotShowStudyAssignedToOtherUsers = {};
        // JS for table row active
        $scope.activeTableTR = function () {
            angular.element(document).ready(function () {
                setTimeout(function () {
                    angular.element(".common-tbl table tr").click(function () {
                        if (angular.element(this).data('clicked', true)) {
                            angular.element(".common-tbl table tr").removeClass('tr-active');
                            angular.element(this).addClass('tr-active');
                        }
                    });
                }, 500);
            });
        }
        $scope.GetUserWorkList = function () {
            $scope.isLoading = true;
            var userPreference = {
                UserID: $sessionStorage.currentUserData.userId
            };
            UserPreferenceService.GetUserWorkList(userPreference).then(function (result) {
                $scope.isLoading = false;
                $scope.workList = result;
                $scope.GetUserPreferences();
            });
        };
        $scope.GetUserPreferences = function () {
            $scope.isLoading = true;
            var userPreference = {
                UserID: $sessionStorage.currentUserData.userId
            };
            UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
                $scope.userPreferences = result.UserPreferences;
                $scope.ChooseNextStudy = filterFilter($scope.userPreferences, {
                    PreferenceType: "Choose Next Study"
                })[0];
                if ($scope.ChooseNextStudy != null) {
                    $scope.ChooseNextStudy.PreferenceValue = $scope.ChooseNextStudy.PreferenceValue == "1" ? true : false;
                }
                $scope.SendDefaultAlertforOncall = filterFilter($scope.userPreferences, {
                    PreferenceType: "SendDefaultAlertforOncall"
                })[0];
                if ($scope.SendDefaultAlertforOncall == null) {
                    $scope.SendDefaultAlertforOncall = {
                        PreferenceType: "SendDefaultAlertforOncall",
                        PreferenceValue: "0"
                    };
                    //$scope.SendDefaultAlertforOncall.PreferenceValue = "1";
                    //$scope.SendDefaultAlertforOncall.PreferenceValue = $scope.SendDefaultAlertforOncall.PreferenceValue == "1" ? true : false;
                }
                $scope.DefaultWorklist = filterFilter($scope.userPreferences, {
                    PreferenceType: "DefaultWorklist"
                })[0];
                if ($scope.DefaultWorklist == null) {
                    $scope.DefaultWorklist = {
                        PreferenceType: "DefaultWorklist",
                        PreferenceValue: "PRW"
                    };
                }
                $scope.ShowLockStudy = filterFilter($scope.userPreferences, {
                    PreferenceType: "ShowLockStudy"
                })[0];
                if ($scope.ShowLockStudy == null) {
                    $scope.ShowLockStudy = {
                        PreferenceType: "ShowLockStudy",
                        PreferenceValue: "1"
                    };
                }
                $scope.DefaultDicomViewer = filterFilter($scope.userPreferences, {
                    PreferenceType: "DefaultDicomViewer"
                })[0];
                if ($scope.DefaultDicomViewer) {
                    $scope.SelectedDefaultDicomViewer.PreferenceValue = _.filter($scope.InstDicomViewerList, function (obj) { return obj.Value == $scope.DefaultDicomViewer.PreferenceValue; })[0];
                }
                else {
                    $scope.DefaultDicomViewer = {
                        PreferenceType: "DefaultDicomViewer",
                    };
                }
                $scope.NumberofComparisonInReport = filterFilter($scope.userPreferences, {
                    PreferenceType: "NumberofComparisonInReport"
                })[0];
                if ($scope.NumberofComparisonInReport != null) {
                    $scope.NumberofComparisonInReport.PreferenceValue = $scope.NumberofComparisonInReport.PreferenceValue != null ? $scope.NumberofComparisonInReport.PreferenceValue : "";
                } else {
                    $scope.NumberofComparisonInReport = {
                        PreferenceType: "NumberofComparisonInReport",
                        PreferenceValue: "5"
                    };
                }
                $scope.PushToTalk = filterFilter($scope.userPreferences, {
                    PreferenceType: "PushToTalk"
                })[0];
                if ($scope.PushToTalk != null) {
                    $scope.PushToTalk.PreferenceValue = $scope.PushToTalk.PreferenceValue == "1" ? true : false;
                }
                $scope.DeficientWarningOnWorklist = filterFilter($scope.userPreferences, {
                    PreferenceType: "DeficientWarningOnWorklist"
                })[0];
                if ($scope.DeficientWarningOnWorklist != null) {
                    $scope.DeficientWarningOnWorklist.PreferenceValue = $scope.DeficientWarningOnWorklist.PreferenceValue == "1" ? true : false;
                }

                $scope.ShowTemplateWarning = filterFilter($scope.userPreferences, {
                    PreferenceType: "ShowTemplateWarning"
                })[0];
                if ($scope.ShowTemplateWarning) {
                    $scope.ShowTemplateWarning.PreferenceValue = $scope.ShowTemplateWarning.PreferenceValue == "1" ? true : false;
                } else {
                    $scope.ShowTemplateWarning = { PreferenceValue: true }
                }

                if ($scope.IsDisPref) {
                    $scope.DisplaySetting = filterFilter($scope.userPreferences, {
                        PreferenceType: "DisplaySetting"
                    })[0];
                    var viewer = ["CI-VIEWER-1", "CI-VIEWER-2", "CIVR", "KONICA", "KONICATEST", "MedDream"]
                    if ($scope.DisplaySetting != null) {
                        var hostdisplaysetting = _.filter(JSON.parse($scope.DisplaySetting.PreferenceValue), function (obj) { return obj.HostFingerPrintHash == $sessionStorage.currentUserData.HostFingerPrintHash })[0];
                        $scope.otherhostdisplaysetting = _.filter(JSON.parse($scope.DisplaySetting.PreferenceValue), function (obj) { return obj.HostFingerPrintHash != $sessionStorage.currentUserData.HostFingerPrintHash });
                        $scope.DisplaySetting.PreferenceValue = hostdisplaysetting ? hostdisplaysetting.DisplaySetting : [];
                        $scope.LoadDisplay();
                    } else {
                        $scope.DisplaySetting = { PreferenceValue: [] };
                    }
                    _.each(viewer, function (v) {
                        if (!_.filter($scope.DisplaySetting.PreferenceValue, function (f) { return f.viewer == v })[0]) {
                            if (v == "CI-VIEWER-1") {
                                var d = _.filter($scope.DisplaySetting.PreferenceValue, function (f) { return f.viewer == "CI-VIEWER" })[0]
                                if (d) {
                                    d = angular.copy(d);
                                    d.viewer = v;
                                    $scope.DisplaySetting.PreferenceValue.push(d);
                                } else {
                                    $scope.DisplaySetting.PreferenceValue.push({ viewer: v, top: 0, left: 0 })
                                }
                            } else {
                                $scope.DisplaySetting.PreferenceValue.push({ viewer: v, top: 0, left: 0 })
                            }
                        }
                    });
                    $scope.DisplaySetting.PreferenceValue = _.sortBy($scope.DisplaySetting.PreferenceValue, 'viewer');
                    $scope.DisplaySetting.PreferenceValue = _.filter($scope.DisplaySetting.PreferenceValue, function (f) { return viewer.includes(f.viewer) });
                }
                $scope.LoadMoreWorklist = _.find($scope.userPreferences, { PreferenceType: "LoadMoreWorklist" });
                $scope.DoNotShowStudyAssignedToOtherUsers = filterFilter($scope.userPreferences, {
                    PreferenceType: "DoNotShowStudyAssignedToOtherUsers"
                })[0];
                if ($scope.DoNotShowStudyAssignedToOtherUsers == null) {
                    $scope.DoNotShowStudyAssignedToOtherUsers = {
                        PreferenceType: "DoNotShowStudyAssignedToOtherUsers",
                        PreferenceValue: "1"
                    };
                }
                getDefaultDictationSystem();
                $scope.isLoading = false;

            });
        };

        //$scope.GetUserWorkList();
        function setPreferance() {
            var userPreferences = [];

            //Choose Next Study
            if ($scope.ChooseNextStudy != null) {
                var ChooseNextStudyObj = {
                    UserPreferenceID: $scope.ChooseNextStudy.UserPreferenceID ? $scope.ChooseNextStudy.UserPreferenceID : "-1",
                    PreferenceType: "Choose Next Study",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.ChooseNextStudy.PreferenceValue ? "1" : "0",
                };
                userPreferences.push(ChooseNextStudyObj);
            }

            //SendDefaultAlertforOncall    
            if ($scope.SendDefaultAlertforOncall != null) {
                var SendDefaultAlertforOncall = {
                    UserPreferenceID: $scope.SendDefaultAlertforOncall.UserPreferenceID ? $scope.SendDefaultAlertforOncall.UserPreferenceID : "-1",
                    PreferenceType: "SendDefaultAlertforOncall",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.SendDefaultAlertforOncall.PreferenceValue,
                };
                userPreferences.push(SendDefaultAlertforOncall);
            }
            //DefaultWorklist
            if ($scope.DefaultWorklist != null) {
                var DefaultWorklist = {
                    UserPreferenceID: $scope.DefaultWorklist.UserPreferenceID ? $scope.DefaultWorklist.UserPreferenceID : "-1",
                    PreferenceType: "DefaultWorklist",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.DefaultWorklist.PreferenceValue,
                };
                userPreferences.push(DefaultWorklist);
            }

            //ShowLockStudy
            if ($scope.ShowLockStudy != null) {
                var ShowLockStudy = {
                    UserPreferenceID: $scope.ShowLockStudy.UserPreferenceID ? $scope.ShowLockStudy.UserPreferenceID : "-1",
                    PreferenceType: "ShowLockStudy",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.ShowLockStudy.PreferenceValue,
                };
                userPreferences.push(ShowLockStudy);
            }
            //DefaultDicomViewer
            if ($scope.SelectedDefaultDicomViewer != null && $scope.DefaultDicomViewer != null) {
                var DefaultDicomViewer = {
                    UserPreferenceID: $scope.DefaultDicomViewer.UserPreferenceID ? $scope.DefaultDicomViewer.UserPreferenceID : "-1",
                    PreferenceType: "DefaultDicomViewer",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.SelectedDefaultDicomViewer.PreferenceValue ? $scope.SelectedDefaultDicomViewer.PreferenceValue.Value : "",
                };
                userPreferences.push(DefaultDicomViewer);
            }

            //NumberofComparisonInReport
            if ($scope.NumberofComparisonInReport != null) {
                var NumberofComparisonInReportObj = {
                    UserPreferenceID: $scope.NumberofComparisonInReport.UserPreferenceID ? $scope.NumberofComparisonInReport.UserPreferenceID : "-1",
                    PreferenceType: "NumberofComparisonInReport",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.NumberofComparisonInReport.PreferenceValue
                };
                userPreferences.push(NumberofComparisonInReportObj);
            }
            //PushToTalk
            if ($scope.PushToTalk != null) {
                var PushToTalkObj = {
                    UserPreferenceID: $scope.PushToTalk.UserPreferenceID ? $scope.PushToTalk.UserPreferenceID : "-1",
                    PreferenceType: "PushToTalk",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.PushToTalk.PreferenceValue ? "1" : "0",
                };
                userPreferences.push(PushToTalkObj);
            }
            //DeficientWarningOnWorklist
            if ($scope.DeficientWarningOnWorklist != null) {
                var DeficientWarningOnWorklistObj = {
                    UserPreferenceID: $scope.DeficientWarningOnWorklist.UserPreferenceID ? $scope.DeficientWarningOnWorklist.UserPreferenceID : "-1",
                    PreferenceType: "DeficientWarningOnWorklist",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.DeficientWarningOnWorklist.PreferenceValue ? "1" : "0",
                };
                userPreferences.push(DeficientWarningOnWorklistObj);
            }
            //ShowTemplateWarning
            if ($scope.ShowTemplateWarning != null) {
                var ShowTemplateWarningObj = {
                    UserPreferenceID: $scope.ShowTemplateWarning.UserPreferenceID ? $scope.ShowTemplateWarning.UserPreferenceID : "-1",
                    PreferenceType: "ShowTemplateWarning",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.ShowTemplateWarning.PreferenceValue ? "1" : "0",
                };
                userPreferences.push(ShowTemplateWarningObj);
            }
            if ($scope.IsDisPref) {
                //DisplaySetting
                if ($scope.DisplaySetting != null) {
                    var pref = angular.copy($scope.DisplaySetting.PreferenceValue);
                    _.each(pref, function (d) {
                        delete d.display;
                    });
                    if (!$scope.otherhostdisplaysetting) {
                        $scope.otherhostdisplaysetting = [];
                    }
                    $scope.otherhostdisplaysetting.push({ "HostFingerPrintHash": $sessionStorage.currentUserData.HostFingerPrintHash, "DisplaySetting": pref });
                    var DisplaySetting = {
                        UserPreferenceID: $scope.DisplaySetting.UserPreferenceID ? $scope.DisplaySetting.UserPreferenceID : "-1",
                        PreferenceType: "DisplaySetting",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: JSON.stringify($scope.otherhostdisplaysetting),
                    };
                    userPreferences.push(DisplaySetting);
                }
            }
            //Worklist Lite
            if ($scope.LoadMoreWorklist != null) {
                var LoadMoreWorklist = {
                    UserPreferenceID: $scope.LoadMoreWorklist.UserPreferenceID ? $scope.LoadMoreWorklist.UserPreferenceID : "-1",
                    PreferenceType: "LoadMoreWorklist",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.LoadMoreWorklist.PreferenceValue,
                };
                userPreferences.push(LoadMoreWorklist);
                $localStorage.LoadMoreWorklist = $scope.LoadMoreWorklist.PreferenceValue;
            }
            //DefaultDictationSystem
            if ($scope.SelectedDefaultDictationSystem != null) {
                var DefaultDictationSystem = {
                    UserPreferenceID: $scope.DefaultDictationSystem && $scope.DefaultDictationSystem.length > 0 && $scope.DefaultDictationSystem[0].UserPreferenceID ? $scope.DefaultDictationSystem[0].UserPreferenceID : "-1",
                    PreferenceType: "DefaultDictationSystem",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.SelectedDefaultDictationSystem.PreferenceValue ? $scope.SelectedDefaultDictationSystem.PreferenceValue.Value : "",
                };
                userPreferences.push(DefaultDictationSystem);
            }
            //ShowStudyAssignedToOtherUsers
            if ($scope.DoNotShowStudyAssignedToOtherUsers != null) {
                var DoNotShowStudyAssignedToOtherUsers = {
                    UserPreferenceID: $scope.DoNotShowStudyAssignedToOtherUsers.UserPreferenceID ? $scope.DoNotShowStudyAssignedToOtherUsers.UserPreferenceID : "-1",
                    PreferenceType: "DoNotShowStudyAssignedToOtherUsers",
                    UserID: $sessionStorage.currentUserData.userId,
                    PreferenceValue: $scope.DoNotShowStudyAssignedToOtherUsers.PreferenceValue,
                };
                userPreferences.push(DoNotShowStudyAssignedToOtherUsers);
            }

            return userPreferences;
        };
        $scope.SavePreference = function () {
            if (!$scope.NumberofComparisonInReport.PreferenceValue || $scope.NumberofComparisonInReport.PreferenceValue <= 0) {
                $scope.isInvalidNumberofComparison = true;
                return;
            }
            if ($scope.IsDisPref) {
                var count = _.filter($scope.DisplaySetting.PreferenceValue, function (d) { return !d.display });
                if (count.length > 0) {
                    toaster.warning({ body: "Please select display setting." });
                    return;
                }
            }

            $scope.isLoading = true;
            UserPreferenceService.AddEditUserPreferences(setPreferance()).then(function (result) {
                $scope.GetUserPreferences();
                $scope.isLoading = false;
                toaster.success({ body: "Preference saved successfully!" });
                $scope.isInvalidNumberofComparison = false;
            });
        };

        $scope.GetAllSites = function () {
            //ManageLocationService.GetAllSites().then(function (result) {
            ProfileService.GetSitesByUserId($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.AllSites = result.data;
            });
        };
        $scope.GetAllSites();
        $scope.GetLookupByType = function () {
            ManageLocationService.GetLookupByType('DicomViewer,DictationSystem').then(function (result) {
                //$scope.InstAllLocations = result;
                $scope.InstDicomViewerList = _.filter(result, { 'Type': 'DicomViewer' });
                $scope.DefaultDictationSystemList = _.filter(result, { 'Type': 'DictationSystem' });
                getDefaultDictationSystem();

                $scope.GetUserPreferences();
            });
        };
        $scope.GetLookupByType();


        $scope.InsertDicomViewerCredentials = function () {
            if (!$scope.InstSelected.Site) {
                toaster.warning({ body: "Please select site!" });
                return;
            }
            if (!$scope.InstAddInstitution.ddlDicomViewer) {
                toaster.warning({ body: "Please select viewer!" });
                return;
            }
            $scope.isLoading = true;
            var objdata = {
                ID: $scope.Id,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: $scope.InstSelected.Site.SiteID,
                ViewerName: $scope.InstAddInstitution.ddlDicomViewer.Value,
                UserName: $scope.DVCredUsername,
                Password: $scope.DVCredPassword,
                Modifyby: $sessionStorage.currentUserData.userId
            };
            WorklistService.InsertDicomViewerCredentials(objdata).then(function (result) {
                if (result != null && result.length > 0) {
                    toaster.error({ body: "Site and viewer already mapped!" });
                }
                else {
                    if ($scope.Id > 0) {
                        toaster.success({ body: "Data updated successfully." });
                    }
                    else {
                        toaster.success({ body: "Data updated successfully." });
                    }
                    $scope.clear();
                    $scope.GetAllDicomViewerCredentials();

                }

                $scope.isLoading = false;
            });
        };

        $scope.GetAllDicomViewerCredentials = function () {
            $scope.isLoading = true;

            var objFilter = {
                PageNum: $scope.PageNo,
                PageSize: $scope.PageSize,
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: ($scope.SelectedSite.Site) ? $scope.SelectedSite.Site.SiteID : null,
                ViewerName: ($scope.SelectedViewer.ddlDicomViewer) ? $scope.SelectedViewer.ddlDicomViewer.Value : null,
                OrderByField: $scope.OrderByField,
                OrderBy: $scope.ReverseSort
            };
            ManageLocationService.GetAllDicomViewerCredentials(objFilter).then(function (result) {
                if (result != null && result.length > 0) {
                    $scope.TotalRows = result[0].TotalCount;
                    $scope.DicomViewerList = result;
                }
                else {
                    $scope.TotalRows = "0";
                    $scope.DicomViewerList = [];
                }
                $scope.isLoading = false;
            }, function (error) {
                $scope.isLoading = false;
            });
            $scope.activeTableTR();  // table row active
        };
        $scope.pageChanged = function () {
            $scope.GetAllDicomViewerCredentials();
        };
        $scope.pageSizeChanged = function () {
            $scope.PageNo = 1;
            $scope.GetAllDicomViewerCredentials();
        };
        $scope.SortFilter = function (OrderByField) {
            $scope.PageNo = 1;
            $scope.PageSize = "25";
            $scope.OrderByField = OrderByField;
            $scope.ReverseSort = !$scope.ReverseSort;
            $scope.GetAllDicomViewerCredentials();
        };
        $scope.clear = function () {
            $scope.Id = -1;
            $scope.InstSelected.Site = null;
            $scope.InstAddInstitution.ddlDicomViewer = null;
            $scope.DVCredUsername = '';
            $scope.DVCredPassword = '';
            $scope.AddDVCredentials = false;
        }
        $scope.ClearFilter = function () {
            $scope.SelectedSite.Site = null;
            $scope.SelectedViewer.ddlDicomViewer = null;
            $scope.GetAllDicomViewerCredentials();
        };
        $scope.LoadData = function (data) {
            $scope.AddDVCredentials = true;
            $scope.Id = data.ID;
            $scope.InstSelected.Site = _.filter($scope.AllSites, function (obj) { return obj.SiteID == data.SiteID; })[0];
            //$scope.InstAddInstitution.ddlDicomViewer = _.filter($scope.InstDicomViewerList, function (obj) { return obj.Value == data.ViewerName; })[0];
            $scope.InstAddInstitution.ddlDicomViewer = _.filter($scope.InstDicomViewerList, function (obj) { return obj.Key == data.ViewerName; })[0];
            $scope.DVCredUsername = data.UserName;
            $scope.DVCredPassword = data.Password;
        };
        $scope.AddDicomViewerCredentials = function () {
            $scope.AddDVCredentials = true;
        }
        $scope.Display = [];
        $scope.LoadDisplay = function () {
            if ($scope.IsDisPref) {
                if (!$localStorage.Monitors) {
                    $localStorage.Monitors = [
                        {
                            0: "0",
                            1: "0",
                            2: window.screen.availWidth,
                            3: window.screen.availHeight,
                            left: "0",
                            top: "0",
                            width: window.screen.availWidth,
                            height: window.screen.availHeight,
                            originalWidth: window.screen.width,
                            originalHeight: window.screen.height,
                            count: 1,
                            name: "DISPLAY1"
                        }
                    ]
                }
                $scope.Display = $localStorage.Monitors;
                if ($scope.DisplaySetting && $scope.DisplaySetting.PreferenceValue) {
                    _.each($scope.DisplaySetting.PreferenceValue, function (d) {
                        d.display = _.filter($scope.Display, function (o) { return o.name == d.displayName })[0];
                        if (!d.display) {
                            d.display = { name: d.displayName };
                        }
                    });
                }
            }
        }
        $scope.LoadDisplay();
        $scope.setDisplayValue = function (o) {
            o.displayName; o.width = 0; o.height = 0; o.top = 0; o.left = 0; o.layout = '';
            if (o.display) {
                o.width = o.display.width; o.height = o.display.height; o.displayName = o.display.name;
            }
        }

        $scope.setDisplay = function (o, h, w, x, y, layout) {
            o.width = 0; o.height = 0; o.top = 0; o.left = 0;
            if (o.display) {
                o.height = parseInt(o.display.height * h);
                o.width = parseInt(o.display.width * w);
                o.top = parseInt(o.display.height * x);
                o.left = parseInt(o.display.width * y);
                o.layout = layout;
            }
        }
        $scope.DisplayPreview = function (o) {
            var win = windowHandler._openByPreference('displayLabel.html?display=' + o.displayName, o.viewer + "-" + o.layout, 1000, "", true, null, angular.copy(o));
            $timeout(function () {
                win.close();
            }, 10000);
        }

        function getDefaultDictationSystem() {
            $scope.DefaultDictationSystem = filterFilter($scope.userPreferences, {
                PreferenceType: "DefaultDictationSystem"
            });
            if ($scope.DefaultDictationSystem != null && $scope.DefaultDictationSystem.length > 0) {
                var PreferenceValue = _.filter($scope.DefaultDictationSystemList, function (obj) { return obj.Value == $scope.DefaultDictationSystem[0].PreferenceValue; });
                if (PreferenceValue && PreferenceValue.length > 0) {
                    $scope.SelectedDefaultDictationSystem.PreferenceValue = PreferenceValue[0];
                }
            }
            else {
                $scope.DefaultDictationSystem = {
                    PreferenceType: "DefaultDictationSystem",
                };
            }
        }

        $scope.setDefaultDisplay = function (o) {
            console.info(o);
            if (!o.display) {
                if ($scope.Display && $scope.Display.length > 0) {
                    o.display = $scope.Display[0];
                    $scope.setDisplayValue(o);
                    $scope.setDisplay(o, 1, 0.5, 0, 0.5, 'L1-2')
                }
            }
        }
        $scope.SetDicomViewerText = function (DV) {
            var viewer = _.filter($scope.InstDicomViewerList, { "Value": DV });
            if (viewer != null && viewer.length > 0) {
                return viewer[0].Key
            }
            else {
                return DV;
            }
        }
        /*
         * will implement this code when we refactor code for display settings
         * 
        $scope.setDefaultScreen = function (o) {
            var screen = o.layout.split("-")[0];
            var div = ''
            switch (screen) {
                case 'L1':
                    div = $('#cardscreen1').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L2':
                    div = $('#cardscreen2').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L3':
                    div = $('#cardscreen3').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L4':
                    div = $('#cardscreen4').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L5':
                    div = $('#cardscreen5').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L6':
                    div = $('#cardscreen6').prop('outerHTML');
                    console.log("div > ", div)
                    break;
            }
            o.selectedScreen = div;
        }
        */
    }
})();

angular.module('radico.pages.settings.userpreference')
    .service('UserPreferenceService', ['Restangular', function (Restangular) {

        this.AddEditUserPreferences = function (userPreference) {
            return Restangular.one('Settings').one("AddEditUserPreferences").customPOST(userPreference);
        };
        this.GetUserPreferences = function (userPreference) {
            return Restangular.one('Settings').one("GetUserPreferences").customPOST(userPreference);
        };
        this.GetUserWorkList = function (userPreference) {
            return Restangular.one('Settings').one("GetUserWorkList").customPOST(userPreference);
        };

        this.GetRadflowUIVersion = function () {
            return Restangular.one('Settings').one("GetRadflowUIVersion").get();
        };
    }]);
angular.module('radico.pages.shared.services')
    .service('CommonService', ['$http', 'APP_CONSTANTS', '__env', 'Restangular', '$sessionStorage', 'toaster', 'AppHubService', '$timeout', '$interval',
        function ($http, APP_CONSTANTS, __env, Restangular, $sessionStorage, toaster, AppHubService, $timeout, $interval) {
            'use strict';
            var AppHub;
            function urlCore() {
                return __env._environment.config.apiResourceServiceBaseUri;
            }
            this.LogApplicationInfo = function (data) {
                if ($sessionStorage.EnableInfoLogging === false) return;
                return $http({
                    method: 'post',
                    url: urlCore() + 'common/LogApplicationInfo',
                    headers: { 'content-type': 'application/json', 'authorization': 'Basic UmFkRmxvd0V4dFNlcnZpY2U6UkBEUzNDUkA3Mw==' },
                    data: JSON.stringify(data),
                });
            };
            this.LogPSResponseMessage = function (data) {
                return $http({
                    method: 'post',
                    url: urlCore() + 'common/LogPSResponseMessage',
                    headers: { 'content-type': 'application/json', 'authorization': 'Basic UmFkRmxvd0V4dFNlcnZpY2U6UkBEUzNDUkA3Mw==' },
                    data: JSON.stringify(data),
                });
            };
            this.GetTourSteps = function (tabName) {
                return Restangular.one('common').one("GetTourSteps", tabName).get();
            };
            // RadPod doctors are redirected to the CIVR Smart Worklist right after login/pin. Shows a short
            // countdown popup, then hands the logged-in user over to CIVR using the same auto-login contract
            // RadFlow already supports (see indexController.checkParam).
            this.RedirectToCIVRSmartWorklist = function (data) {
                var userData = data || $sessionStorage.currentUserData || {};
                // Technologist-only RadPod users (no 'User' role) land on the same ASR app, which shows its
                // Technologist Worklist for that role — only the popup copy needs to reflect that; the
                // destination URL is unchanged.
                var userRolesForRedirect = userData.userRoles || [];
                var isTechnologistWorklist = userRolesForRedirect.indexOf('User') === -1 && userRolesForRedirect.indexOf('Technologist') !== -1;
                var baseUrl = (__env && __env._environment && __env._environment.config && __env._environment.config.CIVRSmartWorklistURL) ? __env._environment.config.CIVRSmartWorklistURL : 'https://dev-civr-ui.civie.com/#/smartworklist';
                var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
                var redirectUrl = baseUrl + separator +
                    'CallFrom=RadFlowForRadPod' +
                    '&UserData=' + encodeURIComponent(JSON.stringify(userData));
                var hasRedirected = false;
                var countdownInterval;
                var secondsLeft = 5;
                function doRedirect() {
                    if (hasRedirected) {
                        return;
                    }
                    hasRedirected = true;
                    if (countdownInterval) {
                        $interval.cancel(countdownInterval);
                        countdownInterval = null;
                    }
                    window.open(redirectUrl, "_self");
                }
                var redirectTitle = isTechnologistWorklist ? "Technologist Worklist" : "Smart Worklist";
                var redirectText = isTechnologistWorklist
                    ? "The Technologist Worklist you used in RadFlow now lives in CIVR, with all the features you're used to."
                    : "You are being redirected to an AI-driven Smart Worklist, optimized for meeting SLAs and clinical care. Please read studies in the same order as presented.";
                var redirectMarkup =
                    "<div class='civr-redirect'>" +
                        "<div class='civr-redirect__badge'>" +
                            "<i class='fa fa-magic'></i>" +
                        "</div>" +
                        "<h3 class='civr-redirect__title'>" + redirectTitle + "</h3>" +
                        "<p class='civr-redirect__text'>" + redirectText + "</p>" +
                        "<div class='civr-redirect__timer'>" +
                            "<svg class='civr-redirect__ring' viewBox='0 0 64 64'>" +
                                "<circle class='civr-redirect__ring-track' cx='32' cy='32' r='28'></circle>" +
                                "<circle class='civr-redirect__ring-progress' cx='32' cy='32' r='28'></circle>" +
                            "</svg>" +
                            "<span class='civr-redirect__count' id='civrCountdown'>" + secondsLeft + "</span>" +
                        "</div>" +
                        "<div class='civr-redirect__hint'>Redirecting automatically&hellip;</div>" +
                    "</div>";
                swal({
                    title: "",
                    text: redirectMarkup,
                    html: true,
                    customClass: "civr-redirect-swal",
                    confirmButtonText: "Go now",
                    closeOnConfirm: false,
                    allowOutsideClick: false
                }, function () {
                    doRedirect();
                });
                // Live countdown; auto-redirect when it reaches 0 even if the user does not click OK.
                countdownInterval = $interval(function () {
                    secondsLeft--;
                    var countdownEl = document.getElementById('civrCountdown');
                    if (countdownEl) {
                        countdownEl.textContent = secondsLeft;
                    }
                    if (secondsLeft <= 0) {
                        doRedirect();
                    }
                }, 1000);
            };
            this.GetCountryCode = function () {
                var CountryCodes = [
                    { "key": "US", "value": "United States of America" }
                ];
                return _.sortBy(CountryCodes, ['value']);
            };

            this.startNotifyTATStudy = function () {
                intiAppHub();
            }
            this.stopNotifyTATStudy = function () {
                if (AppHub) {
                    AppHub.off("RadFlowAppHubEvent");
                }
            }
            function intiAppHub() {
                AppHub = AppHubService.getAppHub();
                var justCreated = false;
                if (!AppHub && $sessionStorage.currentUserData) {
                    AppHubService.Initialize();
                    AppHub = AppHubService.getAppHub();
                    justCreated = true;
                }
                if (AppHub) {
                    AppHubMethod();
                    if (justCreated) AppHubService.startConnection();
                }
            }
            function AppHubMethod() {
                AppHub.on('RadFlowAppHubEvent', function (obj) {
                    switch (obj.EventType) {
                        case 'notifypostorderormqueuemsg':
                            notifypostorderormqueuemsg(obj);
                            break;
                    }
                });
            }
            this.notifypostorderormqueuemsg = function (obj) {
                notifypostorderormqueuemsg(obj);
            }
            function notifypostorderormqueuemsg(obj) {
                var Order = obj.EventArgs;
                if (Order && Order.Message) {
                    if (Order.ProviderID == $sessionStorage.currentUserData.userId) {
                        toaster.pop({
                            type: 'info',
                            body: '<div id="' + Order.OrderID + '"><i class="fa fa-info-circle" style="top: 17px;position: absolute; left: 20px;font-size: 25px;"></i>' + Order.Message + '</div>',
                            bodyOutputType: 'trustedHtml',
                            timeout: Order.ToasterTimer,
                            onShowCallback: function () {
                                var timeout = $timeout(function () {
                                    var toasterEle = document.getElementById(Order.OrderID);
                                    if (toasterEle) {
                                        var parent = toasterEle.offsetParent;
                                        if (parent) {
                                            parent.style.background = "#178ee5";
                                            if (Order.IsSLABreach) {
                                                parent.style.background = "#ff0000";
                                            }
                                            parent.className = "toast"
                                        }
                                    }
                                    $timeout.cancel(timeout);
                                    timeout = null;
                                }, 200);
                            }
                        });
                    }
                }
            }
            this.createBlobUrl = function (dataURI, fileType) {
                var blob = b64toBlob(dataURI, fileType);
                return URL.createObjectURL(blob);
            }
            function b64toBlob(dataURI, fileType) {
                var byteString = atob(dataURI);
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ab], { type: fileType});
            }
            var self = this;
            //private shared variable
            var sharedVariables = {};
            self.getSharedVariables = getSharedVariables;
            self.setVariable = setVariable;

            //function declarations
            function getSharedVariables() {
                return sharedVariables;
            }
            function setVariable(paramName, value) {
                sharedVariables[paramName] = value;
            }
            // Task 174409: both login-page banners in one anonymous call ({ BannerImageUrl,
            // ScheduledBannerImageUrl }); each url is "" when that banner is not showing.
            this.GetLoginBanners = function () {
                return Restangular.one('common').one("GetLoginBanners").get();
            };
            this.GetLoginRecaptchaSiteKey = function () {
                return Restangular.one('common').one("GetLoginRecaptchaSiteKey").get();
            };
            this.GetAllProvidersByTenantID = function (TenantID) {
                return Restangular.one('common').one('GetAllProvidersByTenantID', TenantID).get();
            };
        }]);




angular.module('radico.pages.shared.services')
    .service('ErrorLoggerService', ['$sessionStorage', '$state', 'CommonService', function ($sessionStorage, $state, CommonService) {
        'use strict';
        var self = this;
        var errors = [];
        var isError = false;
        this.LogApplicationInfo = function (errorData) {
            CommonService.LogApplicationInfo({
                LogDetails: errorData,
                Application: $state.current.name,
                UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '',
            });
        };
        //this.Logger = {};
        function init() {
            if (__env.appLogSetting && !__env.appLogSetting.isEnabled) {
                window.console.log = function (errorMessage) {
                    __env.appLogSetting.sysConsole.log(errorMessage);
                    //errors.push({ message: JSON.stringify(errorMessage), source: '', lineno: '', colno: '', error: '', type:'log' });
                }
                window.console.info = function (errorMessage) {
                    //errors.push({ message: JSON.stringify(errorMessage), source: '', lineno: '', colno: '', error: '', type: 'log' });
                }
                window.console.error = function (errorMessage, log) {
                    var ErrorData = errorMessage.toString() + "\n" + errorMessage.stack ? errorMessage.stack : '';
                    __env.appLogSetting.sysConsole.error(errorMessage);
                    if (log) {
                        ErrorData += JSON.stringify(log);
                        __env.appLogSetting.sysConsole.log(log);
                    }
                    self.LogApplicationInfo(ErrorData);
                }
            }
        }
        init();
        this.forcelog = function (obj, type) {
            try {
                errors.push({ message: JSON.stringify(obj), source: '', lineno: '', colno: '', error: '', type: type ? type : 'error' });
                isError = true;
            } catch (e) {

            }
        }
        this.load = function () {
            errors = [];
            isError = false;
        }
    }]).
    factory('$exceptionHandler', [function () {
        return function myExceptionHandler(exception) {
            console.error(exception);
        };
    }]);
angular.module('radico.pages.shared.services')
    .service('RCService', [function () {
        'use strict';

        var self = this;
        self.Enabled = true;
               
        function createRCObject() {
            try {
                if (typeof RadFlowConnector == "undefined") {
                    self.Enabled = false;                    
                    throw 'Please enable RadFlowConnector extension and reload the page';
                }
                if (!self.rc) {
                    self.rc = new RadFlowConnector();
                    self.rc.onNativeMessagingHostDisconnected = function (errorMessage) {
                        self.rc.nativeHostVersion = null;
                        self.rc.sdkVersion = null;
                        self.rc.hostName = null;                                
                        if (self.onNativeMessageResponse) {
                            self.onNativeMessageResponse(
                                {
                                    "responseEvent": "NativeHostDisconnected"
                                });
                        }
                    }
                    self.rc.onNativeMessageResponse = function (message) {
                        if (self.onNativeMessageResponse) {
                            self.onNativeMessageResponse(message);
                        }                        
                    }
                }
            } catch (e) {
                console.log(e);
                throw e;
            }
        }
        function connect(NativeMessageResponse) {
            try {
                createRCObject();
                if (self.Enabled) {
                    self.rc.connect().then(function (connectResponse) {                                             
                        self.rc.nativeHostVersion = connectResponse.nativeHostVersion;
                        self.rc.sdkVersion = connectResponse.sdkVersion;
                        self.rc.hostName = connectResponse.hostName;
                        self.onNativeMessageResponse = NativeMessageResponse;
                        if (self.onNativeMessageResponse) {
                            self.onNativeMessageResponse(
                                {
                                    "responseEvent": "NativeHostConnected"
                                });
                        }                        
                    }, function (error) {
                        log("Connection error: " + error.errorMessage + " errorCode: " + error.errorCode);
                    })
                }
                //self.onNativeMessageResponse = NativeMessageResponse;

            } catch (e) {
                console.log(e);
                throw e;
            }
        }

        function disconnect() {
            try {
                if (self.Enabled) {
                    //self.rc.disconnect();
                    self.rc.sendMessageToNativehost({ requestEvent: "disconnect" })
                }
            } catch (e) {
                console.log(e);
            }
        }
        function startnativehost() {
            try {
                //self.rc.startnativehost();
                if (self.Enabled) {
                    self.rc.sendMessageToNativehost({ requestEvent: "startnativehost" })
                }
            } catch (e) {
                console.log(e);
            }
        }
        function hostdetails() {
            try {
                //self.rc.hostdetails();
                if (self.Enabled) {
                    self.rc.sendMessageToNativehost({ requestEvent: "hostdetails" })
                }
            } catch (e) {
                console.log(e);
            }
        }
        function startps() {
            try {
                //self.rc.startps();
                if (self.Enabled) {
                    self.rc.sendMessageToNativehost({ requestEvent: "startps" })
                }
            } catch (e) {
                console.log(e);
            }
        }
        function openreport(obj) {
            try {
                //self.rc.openreport(obj);
                if (self.Enabled) {
                    self.rc.sendMessageToNativehost(obj)
                }
            } catch (e) {
                console.log(e);
            }
        }

        function closereport(obj) {
            try {
                if (self.Enabled && self.rc) {
                    self.rc.sendMessageToNativehost(obj)
                }
            } catch (e) {
                console.log(e);
            }
        }
        function openimage(obj) {
            try {
                //self.rc.openreport(obj);
                if (self.Enabled) {
                    self.rc.sendMessageToNativehost(obj)
                }
            } catch (e) {
                console.log(e);
            }
        }

        function log(msg) {
            console.log(msg);
        }

        this.Connect = connect;
        this.Disconnect = disconnect;
        this.StartNativehost = startnativehost;
        this.Hostdetails = hostdetails;
        this.StartPS = startps;
        this.OpenReport = openreport;
        this.CloseReport = closereport;
        this.OpenImage = openimage;        
    }]);

(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('addressBookGrid', {
            templateUrl: 'app/theme/components/address-book-grid/address-book-grid.html',
            bindings: {
                contactList: '<',
                addressBookInfo: '<',
                contactPreferenceType: '<',
                filterAddressBook: '<',
                viewMode: '<',
                editContact: '&',
                deleteContact: '&',
                exportCsvDemo: '&',
                id: '@',
                gridHeight: '@',
            },
            controller: addressBookGridCtrl
        });

    /** @ngInject */
    function addressBookGridCtrl($scope, $sessionStorage, $timeout, $filter, $q, toaster, $compile, AddressBookListService) {

        var vm = this;
        $scope.isLoadingAddressBook = false;
        $scope.halfScale = false;
        $scope.viewModeGridHeight = '200px';
        var AddressBookGridDiv = null;
        var TimeoutList = []
        var ContactPreferenceType = [];

        var ContactDetailsList = [];
        var PageNum = 0;
        var PageSize = 50;
        var TotalRows = 0;

        var AddressBookGridOptions = null;
        var ColumnDefs = [
            {
                field: "Locations",
                headerName: 'Locations',
                initialWidth: 280
            },
            {
                field: 'Site', headerName: 'Site', initialWidth: 280, cellRenderer: SiteCellTemplate,
                tooltipValueGetter: function (params) {
                    if (params.data.Site && params.data.TenantName) {
                        return params.data.Site + ' (' + params.data.TenantName + ')';
                    }
                }
            },
            {
                field: "Modality",
                headerName: 'Modality',
                initialWidth: 100
            },
            {
                field: "Department",
                headerName: 'Department',
                initialWidth: 200
            },
            {
                field: "Name",
                headerName: 'Name',
                initialWidth: 200,
            },
            {
                field: "OfficePhone",
                headerName: 'Office',
                valueFormatter: function (params) {
                    return $filter('formatPhoneNumber')(params.data.OfficePhone);
                },
                initialWidth: 150,
            },
            {
                field: "MobilePhone",
                headerName: 'Mobile',
                valueFormatter: function (params) {
                    return $filter('formatPhoneNumber')(params.data.MobilePhone);
                },
                initialWidth: 150,
            },
            {
                field: "Email",
                headerName: 'Email',
                initialWidth: 320,
            },
            {
                field: "ContactPreferenceType",
                headerName: 'Contact Preference',
                initialWidth: 150,
                valueFormatter: function (params) {
                    if (params.data.ContactPreferenceType) {
                        var obj = _.find(ContactPreferenceType, { Key: params.data.ContactPreferenceType });
                        if (obj && obj.Value) {
                            return obj.Value;
                        }
                    }
                },
            },
            {
                field: "Action",
                cellRenderer: getActionItems(),
                sortable: false,
                initialWidth: 80
            },
        ];

        var ViewModeColumnDefs = [
            {
                field: "Modality",
                headerName: 'Modality',
                initialWidth: 100,
                sortable: true,
                suppressMovable: true,
                menuTabs: [],
            },
            {
                field: "Department",
                headerName: 'Department',
                initialWidth: 200,
                sortable: true,
                suppressMovable: true,
                menuTabs: [],
            },
            {
                field: "Name",
                headerName: 'Name',
                sortable: true,
                suppressMovable: true,
                menuTabs: [],
                flex: 1,
                tooltipField: "Name",
            },
            {
                field: "Email",
                headerName: 'Email',
                sortable: true,
                suppressMovable: true,
                menuTabs: [],
                flex: 1,
                tooltipField: "Email",
            },
            {
                field: "MobilePhone",
                headerName: 'Mobile',
                sortable: true,
                valueFormatter: function (params) {
                    return $filter('formatPhoneNumber')(params.data.MobilePhone);
                },
                suppressMovable: true,
                menuTabs: [],
                flex: 1,
                tooltipField: "MobilePhone",
            },
            {
                field: "OfficePhone",
                headerName: 'Office',
                sortable: true,
                valueFormatter: function (params) {
                    return $filter('formatPhoneNumber')(params.data.OfficePhone);
                },
                suppressMovable: true,
                menuTabs: [],
                flex: 1,
                tooltipField: "OfficePhone",
            },
        ];

        vm.$onInit = function () {
            createGridOptions();
            initGrid();
        }
        vm.$onChanges = function (changes) {
            if (changes.contactList) {
                vm.contactList = changes.contactList.currentValue;
            }
            if (changes.addressBookInfo) {
                vm.addressBookInfo = changes.addressBookInfo.currentValue;
            }
            if (changes.filterAddressBook) {
                vm.filterAddressBook = changes.filterAddressBook.currentValue;
                resetGrid();
            }
            if (changes.contactPreferenceType && changes.contactPreferenceType.currentValue && changes.contactPreferenceType.currentValue.length > 0) {
                ContactPreferenceType = changes.contactPreferenceType.currentValue;
                if (AddressBookGridDiv && AddressBookGridOptions.api) {
                    AddressBookGridOptions.api.refreshServerSide();
                }
            }
            if (changes.gridHeight && changes.gridHeight.currentValue && changes.gridHeight.currentValue != "") {
                $scope.viewModeGridHeight = changes.gridHeight.currentValue;
            }
        }
        vm.$onDestroy = function () {
            AddressBookGridOptions.api.destroy();
            _.each(TimeoutList, function (timeout) {
                $timeout.cancel(timeout);
            });
        }
        function initGrid() {
            var timeout = $timeout(function () {

                AddressBookGridDiv = document.querySelector('#AddressBookGrid');
                new agGrid.Grid(AddressBookGridDiv, AddressBookGridOptions);
                if (vm.viewMode) {
                    AddressBookGridOptions.api.setColumnDefs(ViewModeColumnDefs);
                } else {
                    AddressBookGridOptions.api.setColumnDefs(ColumnDefs);
                }

            }, 100);
            TimeoutList.push(timeout);
        }
        function createGridOptions() {
            AddressBookGridOptions = {
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    lockVisible: true,
                    menuTabs: ['generalMenuTab'],
                },
                rowHeight: 33,
                enableBrowserTooltips: true,
                rowSelection: 'single',
                rowModelType: 'serverSide',
                cacheBlockSize: PageSize,
                //Column Menu
                getMainMenuItems: getMainMenuItems,

                //Context Menu
                getContextMenuItems: function () { return []; },

                sortingOrder: ['desc', 'asc'],
                alwaysShowVerticalScroll: true,
                alwaysShowHorizontalScroll: true,
                overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
                onSortChanged: function (params) {
                    resetGrid();
                },
                onGridReady: function () {
                    var fakeServer = createFakeServer();

                    // create datasource with a reference to the fake server
                    var datasource = createServerSideDatasource(fakeServer);

                    // register the datasource with the grid

                    AddressBookGridOptions.api.setServerSideDatasource(datasource);
                    AddressBookGridOptions.columnApi.applyColumnState({ state: [{ colId: 'Name', sort: 'desc' }], });
                },
                statusBar: {
                    statusPanels: [
                        {
                            statusPanel: getStatusPanel(),
                            key: 'GridFooter',
                        },
                    ],
                },
            };
        }


        function createServerSideDatasource(server) {
            return {
                getRows: function (params) {
                    server.getData(params.request).then(function (response) {
                        if (response.success) {
                            params.success({
                                rowData: response.rows,
                                rowCount: response.lastRow,
                            });
                        } else {
                            params.fail();
                        }
                    });
                },
            };
        }
        function createFakeServer() {
            return {
                getData: function (request) {
                    var d = $q.defer();
                    $scope.isLoadingAddressBook = true;
                    PageNum = _.toInteger(request.endRow / PageSize);
                    var filter = {
                        PageNum: PageNum,
                        PageSize: PageSize,
                        Name: vm.filterAddressBook ? vm.filterAddressBook.Name : '',
                        LocationIDs: vm.filterAddressBook ? vm.filterAddressBook.LocationIDs : '',
                        OrderByField: 'Name',
                        OrderBy: 'desc',
                        ModalityIDs: vm.filterAddressBook ? vm.filterAddressBook.ModalityIDs : '',
                        Departments: vm.filterAddressBook ? vm.filterAddressBook.Departments : '',
                        UserID: $sessionStorage.currentUserData.userId,
                    };
                    if (request.sortModel.length > 0) {
                        filter.OrderByField = request.sortModel[0].colId;
                        filter.OrderBy = request.sortModel[0].sort;
                    }
                    GetContactDetail(filter).then(function (result) {
                        ContactDetailsList = _.uniqBy(_.concat(ContactDetailsList, result),'ContactDetailID');
                        if (ContactDetailsList.length == 0) {
                            AddressBookGridOptions.api.showNoRowsOverlay();
                        } else {
                            AddressBookGridOptions.api.hideOverlay();
                        }
                        if (ContactDetailsList.length > 0) {
                            TotalRows = ContactDetailsList[0].PageCounts;
                        }
                        if (!vm.viewMode) {
                            showHideStatusbar();
                        }
                        var rowsForBlock = ContactDetailsList.slice(request.startRow, request.endRow);
                        $scope.isLoadingAddressBook = false;
                        d.resolve({
                            success: true,
                            rows: rowsForBlock,
                        });

                    }).then(function (error) {
                        $scope.isLoadingAddressBook = false;
                        d.reject();
                    });

                    return d.promise;

                }
            }
        }
        function resetGrid() {
            ContactDetailsList = [];
            PageNum = 0;
            if (AddressBookGridOptions && AddressBookGridOptions.api) { AddressBookGridOptions.api.refreshServerSide({ purge: true }); }
        }

        function getActionItems() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                $scope[params.rowIndex] = params;
                this.eGui = document.createElement('div');
                this.eGui.className = "d-flex"
                var rowExpr = 'this[' + params.rowIndex + ']';
                var editIcon = document.createElement('i');
                editIcon.className = 'cursor-pointer glyphicon glyphicon-pencil p-4px-all';
                editIcon.title = 'Edit';
                editIcon.style.color = '#07e6c4';
                editIcon.setAttribute('ng-click', 'EditContact(' + rowExpr + ')');
                var deleteButton = document.createElement('button');
                deleteButton.className = 'btn btn-transparent border-0 px-0 pt-2px mx-2 my-0 pb-0';
                deleteButton.title = 'Delete';
                deleteButton.style.color = '#07e6c4';
                deleteButton.setAttribute('ng-click', 'DeleteContact(' + rowExpr + ')');
                var deleteIcon = document.createElement('i');
                deleteIcon.className = 'fa fa-trash-o fs-17px';
                deleteButton.appendChild(deleteIcon);
                this.eGui.appendChild(editIcon);
                this.eGui.appendChild(deleteButton);
                // create and compile AngularJS scope for this component
                this.$scope1 = $scope.$new();
                $compile(this.eGui)(this.$scope1);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                var timeout = $timeout(this.$scope1.$apply.bind(this.$scope1), 0);
                TimeoutList.push(timeout);

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }

        function getMainMenuItems(params) {
            var athleteMenuItems = ["autoSizeThis", "autoSizeAll", "separator", "resetColumns"];
            return athleteMenuItems;
        }

        function showHideStatusbar() {
            var statusBarComponent = AddressBookGridOptions.api.getStatusPanel('GridFooter');
            if (ContactDetailsList.length == 0) {
                statusBarComponent.eGui.hidden = true;
                AddressBookGridOptions.api.showNoRowsOverlay();
            } else {
                AddressBookGridOptions.api.hideOverlay();
                statusBarComponent.eGui.hidden = false;
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
                statusBarComponent.eGui.textContent = 'Showing ' + ContactDetailsList.length + ' of ' + TotalRows + ' Total Records';
                statusBarComponent.eGui.style.color = 'white';
            }
        }

        function GetContactDetail(filter) {
            var d = $q.defer();
            AddressBookListService.GetContactDetail(filter).then(function (result) {
                d.resolve(result);
            })
            return d.promise;
        }

        $scope.EditContact = function (params) {
            params.data.StatsFlag = 'M';
            vm.addressBookInfo.SelectedData = _.clone(params.data);
            vm.editContact();
        };

        $scope.DeleteContact = function (params) {
            params.data.StatsFlag = 'D';
            AddressBookListService.SetContactDetail(params.data);
            resetGrid();
        };

        if ($(window).width() < 1199) {
            $scope.halfScale = true;
        }

        function SiteCellTemplate(params) {
            if (params.data && params.data.Site && params.data.TenantName) {
                var template = '<div class="sites-overflow">';
                template += "<span class='px-4px py-2px mlp-value-box bg-clr-36 mr-4px text-nowrap'>" + params.data.Site + " (" + params.data.TenantName + ")" + "</span>";
                '</div>';
                return template;
            }
            else {
                return "";
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('addressBookContactForm', {
            templateUrl: 'app/theme/components/address-book-info/address-book-info.html',
            bindings: {
                addressBookInfo: '<',
                saveOtherBtn: '<',
                onSaveContact: '&',
            },
            controller: addressBookInfoCtrl
        });

    /** @ngInject */
    function addressBookInfoCtrl($scope, $sessionStorage, $timeout, $filter, $q, toaster, $compile, AddressBookListService) {

        var vm = this;
        var TimeoutList = [];

        $scope.currentTab = {
            Department: true,
            Person: false,
        };
        $scope.SelectedValue = { Location: null, Modality: null, Department: null };

        vm.$onInit = function () {
        }
        vm.$onChanges = function (changes) {
            if (changes.addressBookInfo) {
                vm.addressBookInfo = changes.addressBookInfo.currentValue;
                setSelectedValues();
            }
        }
        vm.$onDestroy = function () {
            _.each(TimeoutList, function (timeout) {
                $timeout.cancel(timeout);
            });
        }

        $scope.SaveContact = function (Flag) {
            var obj = vm.addressBookInfo.SelectedData;
            obj.CreatedBy = $sessionStorage.currentUserData.userId;
            obj.StatsFlag = obj.ContactDetailID ? 'M' : 'N';
            obj.LocationID = $scope.SelectedValue.Location.LocationID;
            obj.ModalityID = $scope.SelectedValue && $scope.SelectedValue.Modality ? $scope.SelectedValue.Modality.Id : '';
            obj.Department = $scope.SelectedValue && $scope.SelectedValue.Department ? $scope.SelectedValue.Department.Key : '';
            AddressBookListService.SetContactDetail(obj).then(function () {
                clearData();
                vm.addressBookInfo.Flag = Flag;
                vm.onSaveContact();
            });
        }

        $scope.updateLocationData = function () {
            var timeout = $timeout(function () {
                if ($scope.SelectedLocationValues.SelectedItems && $scope.SelectedLocationValues.SelectedItems.length > 0) {
                    var locations = [];
                    var locationIds = [];
                    _.each($scope.SelectedLocationValues.SelectedItems, function (data) {
                        var filter = _.find(vm.addressBookInfo.Locations, function (item) { return item.LocationID == data.value; });
                        if (filter != null) {
                            locations.push(filter);
                            locationIds.push(filter.LocationID);
                        }
                    });
                    vm.addressBookInfo.SelectedData.Location = locations;
                    vm.addressBookInfo.SelectedData.LocationIDs = _.join(locationIds, ',');
                } else {
                    vm.addressBookInfo.SelectedData.Location = [];
                    vm.addressBookInfo.SelectedData.LocationIDs = '';
                }
                $("#AddressBookLocation").val(vm.addressBookInfo.SelectedData.LocationIDs);
            }, 100);
            TimeoutList.push(timeout);
        }

        function setRadLocationComponentValues() {
            $scope.SelectedLocationValues = { SelectedItems: [] };
            var selectedItems = [];
            _.each(vm.addressBookInfo.sites, function (site) {
                _.each(vm.addressBookInfo.SelectedData.Location, function (location) {
                    var value = _.find(site.items, { 'value': location.LocationID });
                    if (value) {
                        selectedItems.push(value);
                    }
                });
            });
            $scope.SelectedLocationValues.SelectedItems = selectedItems;
        }

        function clearData() {
            $scope.frmContact.$setUntouched();
            $scope.SelectedLocationValues = { SelectedItems: [] };
            vm.addressBookInfo.SelectedData = { ContactPreferenceType : '0'};
            $scope.SelectedValue = { Location: null, Modality: null, Department: null };
        }

        $scope.changeTab = function (tab) {
            $scope.currentTab = {
                Department: false,
                Person: false,
            };
            switch (tab) {
                case 'Department':
                    $scope.currentTab.Department = true;
                    clearData();
                    break;
                case 'Person':
                    $scope.currentTab.Person = true;
                    break;
            }
        }

        function setSelectedValues() {
            if (vm.addressBookInfo.SelectedData) {
                if (vm.addressBookInfo.SelectedData.Locations) {
                    $scope.SelectedValue.Location = _.find(vm.addressBookInfo.Locations, { Location: vm.addressBookInfo.SelectedData.Locations });
                }
                if (vm.addressBookInfo.SelectedData.ModalityID) {
                    $scope.SelectedValue.Modality = _.find(vm.addressBookInfo.Modality, { Id: vm.addressBookInfo.SelectedData.ModalityID });
                }
                if (vm.addressBookInfo.SelectedData.Department) {
                    $scope.SelectedValue.Department = _.find(vm.addressBookInfo.ContactDepartmentType, { Key: vm.addressBookInfo.SelectedData.Department });
                }
                if (!vm.addressBookInfo.SelectedData.ContactPreferenceType) {
                    vm.addressBookInfo.SelectedData.ContactPreferenceType = '0';
                }
            }
        }
    }
})();
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('agGrid', {
            templateUrl: 'app/theme/components/ag-grid/ag-grid.html',
            bindings: {
                worklist: '<',
                masterData: '<',
                selectedData: '<',
                index: '<',
                viewMode: '<',
                updateUserLayoutPref: '&',
                updateProps: '&',
            },
            controller: WorklistGridController
        });

    /** @ngInject */
    function WorklistGridController($scope, $rootScope, $sessionStorage, $q, WorklistService, $timeout, $filter, APP_CONSTANTS, toaster, RuleSharedService, $compile, ReviewOrderService, ManageLocationService, AddressBookListService, $interval, $sce, SharedService, RuleService, ProfileService, CommonService) {

        var vm = this;
        var IsSmartWorklist = false;
        var SmartWorklistPageSize = false;
        var showOnlyFiveStudies = false;
        var showOnlyFiveStudiesForTenant = "";
        var selectedRow = [];
        var OrderListFilter = {};
        var OrderList = [];
        var SortingByMultiColumn = '';
        var DefaultSortingColumn = 'O.ReceivedSinceDateTime';
        var DefaultSortingDirection = 'ASC';
        var ClipboardConditionData = { ClipboardData: [], SelectedRowsClipboard: [], showClipboardToaster: true };
        var halfScale = $(window).width() < 1199;
        var LastOpenedOrderID = null;
        var DictatedAccessionNumber = [];
        var DictationReportState = '';
        var contextMenus = [];
        var tippyJsinstance = [{ tippyInstance: null, cellInstance: null, rowNode: null }];
        var ColumnsToHide = [];
        var gridDiv;
        var autoRefreshing = false;
        var sortingApplied = false;
        var localModalityCounts = {};
        var TimeoutList = [];
        var PageNo = 1;
        var currentDate = null;
        var statusBarComponent;
        var OpenOrder = {};
        var dvCredentialsCache = {};
        var _verifyReadStudyCache = {};
        var _nextOrderLockCache = {};
        var _isOpeningStudy = false;
        var FilterByLocationIDs = '';
        var FilterByModality = '';
        var FilterByType = '';
        var FilterByPriority = '';
        var FilterByAccession = "";
        var FilterByPatientMRN = "";
        var FilterByPatientName = "";
        var FilterByProcedureDesc = "";
        var FilterByOrderingPhysician = "";
        var FilterByRenderingPhysician = "";
        var MainMenuIcon = '<i class="fa fa-gear"></i>';
        var FilterMenuIcon = '<i class="fa fa-filter"></i>';
        var FilterParamsButtons = ["apply", "reset"];
        var FilterParamsOptions = ['contains', 'startsWith', 'endsWith', 'equals'];
        var ReportList = [];
        var specialityAssignments = [];
        var PeerReviewToasterMessage = "Added to peer review successfully!";
        var FilterByDOSDateRange = { StartDate: '', EndDate: '' };
        var RuleOrderDate = { Value: 'Last 7 Days', DateValue: { startDate: null, endDate: null } };
        var RuleOrderDateLabel = '';
        var NumberFilterParamsOptions = ['inRange', 'equals', 'lessThanOrEqual'];
        var FilterByCreatedDateRange = { StartDate: '', EndDate: '' };
        var FilterByImageInstance = { StartValue: null, EndValue: null };
        var FilterByWorkRVU = { StartValue: null, EndValue: null };
        var FilterBySLA = { StartValue: null, EndValue: null };
        var ClipboardRequestInProgress = false;
        var columnFilterData = [];
        var RuleSignDate = { Value: 'Today', DateValue: { startDate: null, endDate: null } };
        var RuleSignDateLabel;
        var RuleNoDataTemplate = '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>';
        var WorklistNoDataTemplate = '<span class="ag-overlay-loading-center" style="font-size: 16px; border: 0px">There are no pending studies to be read at the moment. As soon as we receive new studies, they will be made available on the worklist. Don\'t go too far from your workstation, as these lulls don\'t usually last long!</span>';
        var RowsToFlashInterval = null;
        var openWindows = [];
        var EnableRowsForSelectedTenants = false;
        var DefaultWorklistLoadTimeThreshold = 59;
        var DifferenceWorklistTime = DefaultWorklistLoadTimeThreshold;
        var FilterByRenderingPhysicianFlag = false;
        var WorklistTenantID = null;
        var CurrentDictationOrder = [];
        var HideAssignmentForStatus = ['C', 'X', 'CO', 'RC'];


        $scope.DataObject = {
            LoggedInUserDetails: {},
            IsStudyReviewSectionVisible: false,
            isAutoAssignPeerReviewWin: false,
            FaxFile: {},
            addressBookGridHeight: "",
            SingReport: {},
            defaultWindowHeight: "85%",
            defaultWindowWidth: halfScale ? "97%" : "70%",
            win_ContactListWidth_new: halfScale ? "90%" : "55%",
            win_ContactListWidth: "500",
            win_PSUserWidth: "60%",
            win_HideStudyWidth: halfScale ? "56%" : "50%",
            hideStudyWindowHeight: "35%",
            LocationContactWindowWidth: halfScale ? "90%" : "55%",
            STATStudiesFirstWindowWidth: halfScale ? "55%" : "28%",
            HideOption: { Key: 'Not to be Read' },
            win_AddEditContactTitle: "Add Contact",
            ModalReportNDiscussionTabs: [
                {
                    title: 'Report',
                    templateUrl: 'modal_report_tab.html',
                    disabled: false,
                },
                {
                    title: 'Discussion',
                    templateUrl: 'modal_discussion_tab.html',
                    disabled: false,
                },
                {
                    title: 'Attachment',
                    templateUrl: 'modal_attachment_tab.html',
                    disabled: false,
                }
            ],
            ModalReportNDiscussActiveIndex: 0,
            Loading: true,
            NoPrevOrder: false,
            NoNextOrder: false,
            FilterAddressBook: {
                Name: '',
                LocationIDs: null,
                Location: null,
            },
            FilterLocationAddressBook: {
                LocationIDs: null,
                Location: null,
            },
            index: 0,
            worklist: {},
            masterData: {},
            HiddenTypeList: [],
            AddressBookInfo: {},
            ReportListFilter: { DateRange: 'Any', Modality: 'All' },
            ReportList: WorklistService.GetReportListModalityNDateRange(),
            ShowReportModal: false,
            ReportSortingPropName: 'OrderDate',
            ReportSortingRevOrder: true,
            SearchText: '',
            ReportSortingOptions: ['DOS (newest first)', 'DOS (oldest first)', 'Rendering Physician (A to Z)', 'Rendering Physician (Z to A)', 'Procedure (A to Z)', 'Procedure (Z to A)'],
            SelectedSortingOption: 'DOS (newest first)',
            displaySortPopover: false,
            AddendumRequest: {
                AssignedUser: null,
                isHighPriorityAddendum: false,
                AddendumComment: null,
                showAddendumReq: false,
                AssignedUserTooltip: "Select Radiologist"
            },
            winAddendumReqWidth: halfScale ? "96%" : "75%",
            onQueryRetrive: false,
            isLoadingQueryRetrieve: false,
            QueryRetriveObj: {},
            QueryRetrieve: {
                Accession: '',
                PatientMRN: '',
                FirstName: '',
                LastName: '',
                toolTipOrderDate: 'DOS',
                OrderDateType: 'Last 3 Years',
                OrderDate: {
                    startDate: moment().subtract(3, 'year'),
                    endDate: moment()
                },
                IsRetrieveBtnDisabled: true,
                IsExpanded: false,
                IsAllStudySelected: false,
                SelectedStudies: [],
                IsSearchingData: false,
            },
            PeerReview: {
                AssignedUser: null,
                Comment: null,
                showPeerReview: false,
                AssignedUserTooltip: "Select Radiologist"
            },
            SelectedLocationContact: {},
            ActionMenu: {
                ActionTaken: "",
                WorklistName: "Worklist",
                MenuItems: [{
                    name: 'Share Exam',
                }, {
                    name: 'Consult with Physician',
                }, {
                    name: 'Open Discussion (F11)',
                }, {
                    name: 'Hide Study (F12)',
                    subMenu: [{
                        name: 'Exam is Mislabeled',
                    }, {
                        name: 'Missing Contrast Type/Dosage',
                    }, {
                        name: 'Missing Order/Cancelled Order',
                    }, {
                        name: 'Missing Paperwork',
                    }, {
                        name: 'Need Additional Images',
                    }, {
                        name: 'Need Comparison',
                    }, {
                        name: 'Not to be Read',
                    },]
                }, {
                    name: 'Unhide Study',
                }, {
                    name: 'Query Retrieve',
                },],
            },
            DiscussionWindowTabList: [
                {
                    TabName: 'Discussion',
                },
                {
                    TabName: 'Attachment',
                }
            ],
            DiscussionWindowActiveTab: 'Discussion',
            Reference: {},
            ShowPrevNextBtn: false,
            ShowAttachmentTab: false,
            FaxDetails: {
                FaxNumTooltip: null,
                disableSendFaxBtn: false,
                FaxNumberList: [],
                FaxNumber: null,
                FaxNumberDropdown: {
                    divId: "FaxNumberDropdown",
                    keys: ['FaxName', 'DisplayFaxNumber'],
                    uniqKey: 'uniqID',
                    placeHolder: "Select Fax Number",
                    SelectedValue: { list: [] },
                    separator: "<br>",
                    onFaxNumbChanged: function (selectedData) {
                        var tooltip = null;
                        _.each(selectedData, function (obj) {
                            if (tooltip) {
                                tooltip = tooltip + "\n" + obj.FaxName + "-" + obj.FaxNumber;
                            }
                            else {
                                tooltip = obj.FaxName + "-" + obj.FaxNumber;
                            }
                        });
                        $scope.DataObject.FaxDetails.FaxNumTooltip = tooltip;
                    }
                }
            },
            RemoveRenderingPhysician: false,
            RemoveRenderingPhysicianReport: $sessionStorage.currentUserData.RemoveRenderingPhysician,
            EnableRowsForSelectedTenants: $sessionStorage.EnableRowsForSelectedTenants.split(',')
        };
        $scope.DataObject.QueryRetrieve.opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",

                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.DataObject.QueryRetrieve.OrderDate = {
                    startDate: moment().subtract(5, 'year'),
                    endDate: moment()
                }
            },
            ranges: {
                'Last 6 Months': [moment().subtract(6, 'month'), moment()],
                'Last 1 Year': [moment().subtract(1, 'year'), moment()],
                'Last 3 Years': [moment().subtract(3, 'year'), moment()],
                'Last 5 Years': [moment().subtract(5, 'year'), moment()],
                'Last 10 Years': [moment().subtract(10, 'year'), moment()],
            }
        };
        vm.$onChanges = function (changes) {
            if (changes.worklist) {
                var prevWorklistId = $scope.DataObject.worklist && $scope.DataObject.worklist.WorklistID;
                $scope.DataObject.worklist = _.clone(changes.worklist.currentValue);
                if ($scope.DataObject.worklist.WorklistID !== prevWorklistId) {
                    localModalityCounts = {};
                }
                if (vm.viewMode) {
                    DifferenceWorklistTime = 60;
                } else {
                    if (!currentDate) {
                        var timeToLoad = $scope.DataObject.worklist.TimeToLoad ? _.cloneDeep($scope.DataObject.worklist.TimeToLoad) : moment();
                        currentDate = _.cloneDeep(timeToLoad.subtract(60, 'seconds'));
                    }
                    DifferenceWorklistTime = $scope.DataObject.worklist.TimeToLoad.diff(currentDate, 'seconds');
                }

                if (DifferenceWorklistTime >= DefaultWorklistLoadTimeThreshold || $scope.DataObject.worklist.purge) {
                    if ($scope.DataObject.worklist.RuleID) {
                        var hasRuleDetails = $scope.DataObject.worklist.Type == 'D'
                            || $scope.DataObject.worklist.Type == 'S'
                            || $scope.DataObject.worklist.Type == 'QS';
                        if (!hasRuleDetails) {
                            RuleSharedService.GetRuleDetails($scope.DataObject.worklist, "View").then(function (data) {
                                $scope.DataObject.worklist.Groups = data.Rule.Groups;
                                $scope.DataObject.worklist.LoadRuleDetails = false;
                                $q.all([
                                    GetOrderDate(),
                                    GetSignDate(),
                                    isshowOnlyFiveStudiesEnabled(),
                                    GetTenantName()
                                ]).then(function () {
                                    if (gridDiv && gridOptions && gridOptions.api) {
                                        var onChangesTimeout = $timeout(function () {
                                            if ($scope.DataObject.worklist.savedState) {
                                                var savedstate = gridOptions.columnApi.getColumnState();
                                                if (!(_.isEqual($scope.DataObject.worklist.savedState, savedstate))) {
                                                    gridOptions.columnApi.applyColumnState({ state: $scope.DataObject.worklist.savedState, applyOrder: true });
                                                }
                                            }
                                            onAgGridLoad();
                                            $timeout.cancel(onChangesTimeout);
                                            onChangesTimeout = null;
                                        }, 200);
                                    } else {
                                        var onInitTimeout = $timeout(function () { initGrid(); $timeout.cancel(onInitTimeout); onInitTimeout = null; }, 100);
                                    }
                                })
                            });
                        } else {
                            if (gridDiv && gridOptions && gridOptions.api) {
                                var onChangesTimeout = $timeout(function () {
                                    if ($scope.DataObject.worklist.savedState) {
                                        var savedstate = gridOptions.columnApi.getColumnState();
                                        if (!(_.isEqual($scope.DataObject.worklist.savedState, savedstate))) {
                                            gridOptions.columnApi.applyColumnState({ state: $scope.DataObject.worklist.savedState, applyOrder: true });
                                        }
                                    }
                                    onAgGridLoad();
                                    $timeout.cancel(onChangesTimeout);
                                    onChangesTimeout = null;
                                }, 200);
                            } else {
                                var onInitTimeout = $timeout(function () { initGrid(); $timeout.cancel(onInitTimeout); onInitTimeout = null; }, 100);
                            }
                        }
                    } else {
                        if (gridDiv && gridOptions && gridOptions.api) {
                            var onChangesTimeout = $timeout(function () { onAgGridLoad(); $timeout.cancel(onChangesTimeout); onChangesTimeout = null; }, 200);
                        } else {
                            var onInitTimeout = $timeout(function () { initGrid(); $timeout.cancel(onInitTimeout); onInitTimeout = null; }, 100);
                        }
                    }
                }
                currentDate = $scope.DataObject.worklist.TimeToLoad;
            }
            if (changes.masterData) {
                $scope.DataObject.masterData = changes.masterData.currentValue;
                if (gridOptions && gridOptions.api) {
                    OrderList = [];
                    _verifyReadStudyCache = {};
                    _nextOrderLockCache = {};
                    gridOptions.api.refreshServerSide({ purge: true });
                }
            }

        };
        vm.$onDestroy = function () {
            if (LastOpenedOrderID != null) {
                $rootScope.$broadcast('event.CloseReport', { 'Order': $scope.LastOpenedOrder });
                removeOrderFromList(LastOpenedOrderID);
                var DeleteOrderFlag = false;
                if (vm.selectedData.DefaultDictationSystem == 'PS360') {
                    DeleteOrderFlag = true;
                }
                else if ($scope.LastOpenedOrder.DefaultDictationSystem == 'PS360') {
                    DeleteOrderFlag = true;
                }

                if (DeleteOrderFlag) {
                    DeleteOpenOrder();
                }
            }
            _.each(TimeoutList, function (timeout) {
                $timeout.cancel(timeout);
            });
            if (RowsToFlashInterval) {
                $interval.cancel(RowsToFlashInterval);
                RowsToFlashInterval = null;
            }
            CloseAllWindow(true);
        }
        vm.$onInit = function () {
            getLoggedInUserDetails()
            $scope.DataObject.index = vm.index;
            $scope.DataObject.worklist = _.clone(vm.worklist);
            $scope.DataObject.masterData = vm.masterData;
            if (!vm.viewMode) {
                GetLookupTypes();
            }
        }
        function onAgGridLoad() {
            if ($scope.DataObject.worklist.purge) {
                if ($scope.DataObject.worklist.ResetFilter) {
                    gridOptions.api.setFilterModel(null);
                    resetPracticeWorklistFilter();

                    vm.worklist.ResetFilter = false;
                    vm.updateProps();
                }
                resetParameter();
                var columnStates = gridOptions.columnApi.getColumnState();
                showhideSignedByAndDateCol(columnStates);
                gridOptions.columnApi.applyColumnState({ state: columnStates, applyOrder: true });
                $scope.DataObject.worklist.savedState = columnStates;
                vm.worklist.savedState = columnStates;

                gridOptions.api.refreshServerSide({ purge: true });

                vm.worklist.purge = false;
                vm.updateProps();
            } else {
                gridOptions.api.refreshServerSide();
            }
            //showhideSignedByAndDateCol();
        }

        function setOrderDateColumnFilterparams(params) {
            params.column.colDef.filterParams.minValidDate = RuleOrderDate.DateValue.startDate ? moment(RuleOrderDate.DateValue.startDate).format("YYYY-MM-DD") : moment().subtract(29, 'days').format("YYYY-MM-DD");
            params.column.colDef.filterParams.maxValidDate = RuleOrderDate.DateValue.endDate ? moment(RuleOrderDate.DateValue.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        }

        function showhideSignedByAndDateCol(columnStates) {
            if ($scope.DataObject.worklist.SignedByPrefUpdated != 1) {
                var SinedByidx = _.findIndex(columnStates, { 'colId': "SignByName" });
                if (SinedByidx != -1) {
                    columnStates[SinedByidx].hide = RuleSignDateLabel ? false : true;
                }
            }

            if ($scope.DataObject.worklist.SignedDatePrefUpdated != 1) {
                var RenderingPhyIdx = _.findIndex(columnStates, { 'colId': "ReportSignDate" });
                if (RenderingPhyIdx != -1) {
                    columnStates[RenderingPhyIdx].hide = RuleSignDateLabel ? false : true;
                }
            }
        }

        function resetPracticeWorklistFilter() {
            FilterByLocationIDs = '';
            FilterByAccession = '';
            FilterByModality = '';
            FilterByOrderingPhysician = '';
            FilterByPatientMRN = '';
            FilterByPatientName = '';
            FilterByPriority = '';
            FilterByProcedureDesc = '';
            FilterByRenderingPhysician = '';
            FilterByType = '';
            FilterByDOSDateRange = { StartDate: '', EndDate: '' };
            FilterByImageInstance = { StartValue: null, EndValue: null };
            FilterByWorkRVU = { StartValue: null, EndValue: null };
            FilterBySLA = { StartValue: null, EndValue: null };
            FilterByCreatedDateRange = { StartDate: '', EndDate: '' };
        }

        //Cell Templates Start

        function userLockIconCellTemplate(params) {
            if (params.data && !params.data.isComparisionOrder) {
                var iconCase = setUserIconCase(params);
                var template = '<div class="overflow-visible text-center">';
                switch (iconCase) {
                    case "IsSTATStroke":
                    case "IsSTATTrauma":
                        var toolTipText = "";
                        if (params.data.IsSTATStroke) {
                            toolTipText = "Stroke";
                        }
                        if (params.data.IsSTATTrauma) {
                            toolTipText = "Trauma";
                        }
                        if (params.data.IsSTATStroke && params.data.IsSTATTrauma) {
                            toolTipText = "Stroke And Trauma";
                        }
                        template = template + '<i class="fa fa fa-exclamation fs-15px text-danger" title="' + toolTipText + '"></i>';
                        break;
                    case 'Lock':
                        var showTooltip = false;
                        if (vm.selectedData.LoggedInUserID != params.data.LockByProviderID) {
                            if ($sessionStorage.currentUserData.userRoles.includes("Admin") || $sessionStorage.currentUserData.userRoles.includes("SuperAdmin")) {
                                showTooltip = true;
                            }
                            else if (!$sessionStorage.DontShowLockedByForTenants || (!$sessionStorage.DontShowLockedByForTenants.includes(params.data.TenantName))) {
                                showTooltip = true;
                            }
                        }
                        var tooltiptext = showTooltip ? params.data.LockBy : '';
                        template = template + '<i class="fa fa fa-lock fs-15px txt-clr-14" title="' + tooltiptext
                            + '">' +
                            //'<span class="tultiptext overflow-auto tt-white ml-20px"></span> ' +
                            '</i>';
                        break;
                    case 'Assignment':
                        template = template + '<span title="' + getOrderListTooltip(params.data) + '" class="fa fa-user fs-15px v-a-t d-block py-5px cursor-pointer pt-5px text-center" ' +
                            'tooltip-class="uibtooltipDenial" ';

                        if (params.data.listOrderListAssignment && params.data.listOrderListAssignment.length > 0) {
                            var idx = _.findIndex(params.data.listOrderListAssignment, { OrderAssingedUserID: $sessionStorage.currentUserData.userId });
                            template = (idx != -1) ? template + " style='color:green' " : template + " style='color:gray' ";
                        }
                        else {
                            template = (params.data.OrderAssingedUserID && _.lowerCase(vm.selectedData.LoggedInUserID) == _.lowerCase(params.data.OrderAssingedUserID)) ? template + " style='color:green' " : template + " style='color:gray' ";
                        }
                        template = template + ' ></span>';
                        break;
                    case 'AssignmentMyClipboard':
                        template = template +
                            '<div class="d-flex pt-5px"><span title="' + getOrderListTooltip(params.data) + '"  class="fa fa-user fs-15px v-a-t d-block cursor-pointer text-center" ';
                        template = (params.data.OrderAssingedUser && vm.selectedData.LoggedInUserID == params.data.OrderAssingedUser) ? template + " style='color:green' " : template + " style='color:gray' ";
                        template = template + ' ></span>' +
                            '<span  class="glyphicon glyphicon-copy fs-9px v-a-t d-block cursor-pointer pt-0 text-center" ' +
                            'style="color:green" ' +
                            ' ></span></div>';
                        break;
                    case 'AssignmentOtherClipboard':
                        template = template +
                            '<div class="d-flex pt-5px"><span title="' + getOrderListTooltip(params.data) + '"  class="fa fa-user fs-15px v-a-t d-block cursor-pointer text-center" ';
                        template = (params.data.OrderAssingedUser && vm.selectedData.LoggedInUserID == params.data.OrderAssingedUser) ? template + " style='color:green' " : template + " style='color:gray' ";
                        template = template + ' ></span>' +
                            '<span  class="glyphicon glyphicon-copy fs-9px v-a-t d-block cursor-pointer pt-0 text-center" ' +
                            'style="color:grey" ' +
                            ' ></span></div>';
                        break;
                    case 'CopiedtoOtherClipboard':
                        template = template + '<span title="Copied to Other Clipboard" class="glyphicon glyphicon-copy fs-15px v-a-t d-block cursor-pointer pt-5px text-center" ' +
                            'style="color:grey" ' +
                            ' ></span>';
                        break;
                    case 'CopiedtoMyClipboard':
                        template = template + '<span title="Copied to My Clipboard" class="glyphicon glyphicon-copy fs-15px v-a-t d-block cursor-pointer pt-5px text-center" ' +
                            'style="color:green" ' +
                            ' ></span>';
                        break;
                    case 'NA':
                        template = template + '<i class="fa fa fa-times fs-20px" style="color: red;" > ' +
                            '<span class="tultiptext">Study not available!</span> ' +
                            '</i> ';
                        break;
                    case 'empty':
                        template = template + '<span ></span> ';
                        break;
                }
                template = template + '</div>';
                return template;
            }
            else {
                return "";
            }
        }

        function viewerddCellTemplate(params) {
            if (params.data && !params.data.isComparisionOrder) {
                return '<div class="ng-scope ng-binding overflow-visible text-center">' +
                    '<div class="viewer-section">' +
                    '<a href id="viewer-dropdown" >' +
                    '<i class="fa fa-picture-o fs-14px txt-clr-14"></i> ' +
                    '</a></div></div>';
            }
            else {
                return "";
            }
        }
        function civrCellTemplate(params) {
            if (params.data && !params.data.isComparisionOrder) {
                return '<div class="text-center">' +
                    '<div class="smw-3 overflow-visible" > ' +
                    '<a  id=\'CivrBtn\'' +
                    'class="cursor-pointer no-bg" title="Open CIVR">' +
                    '<img style="top:-3px;" ' +
                    'src="/assets/img/civricon-16x16.png" class="w-14px pos-rel mr-1px"/> ' +
                    '</a> ' +
                    '</div> ' +
                    '</div>' +
                    '';
            }
            else {
                return "";
            }
        }
        function reportParentCellTemplate(params) {
            if (params.data && !params.data.isComparisionOrder) {
                var tooltip = params.data.Status == 'C' ? "View Report" : "Prior Report";
                if (params.data.SignByName && !($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && ($scope.DataObject.EnableRowsForSelectedTenants && $scope.DataObject.EnableRowsForSelectedTenants.includes(params.data.TenantName)))) {
                    tooltip = (params.data.Status == 'D' && params.data.SignByName.length > 0) ? 'Drafted by ' + params.data.SignByName : ((params.data.Status == 'C' || params.data.Status == 'PA') && params.data.SignByName.length > 0) ? 'Signed by ' + params.data.SignByName : '';
                }
                var template = '<div class="text-center" title="' + tooltip + '">' +
                    '<a id=\'reportBtn\' class="cursor-pointer tultip-right no-bg" >';

                if (params.data.ReportStatus == 1 || params.data.ReportStatus == 2 || params.data.ReportStatus == 5) {
                    template = (params.data.IsDeficient) ? template + '<i class="fa fa-exclamation-triangle fs-14px"></i>' : template + '<i class="fa fa-file-text-o fs-14px txt-clr-14"></i>';
                }
                else if (params.data.Status == 'RP' && params.data.IsPriorOrder) {
                    template += '<i class="fa fa-files-o fs-14px txt-clr-14"></i>';
                }
                template = template + '</a></div>';
                return template;
            }
            else {
                return "";
            }
        }
        function shareExamCellTemplate(params) {
            if (params.data && !params.data.isComparisionOrder) {
                return '<div class="text-center">' +
                    '<div class="smw-3 overflow-visible" > ' +
                    '<a id=\'shareExamBtn\'' +
                    'class="cursor-pointer no-bg ng-scope">' +
                    '<i class="fa fa-share txt-clr-14" style=\'font-size:15px\' aria-hidden="true" title=\'Share Exam\'></i> ' +
                    '</a> ' +
                    '</div> ' +
                    '</div>' +
                    '';
            } else {
                return "";
            }
        }

        /**
         * below two function 'discussionCellTemplate' and 'discussionHTML' is used for discussion icon
         * --do not add any line of code unless it's necessary.
         * --Chirag Jadav
         * @param {any} params
         */
        function discussionCellTemplate(params) {
            var eGui = document.createElement('div');
            var discussion = discussionHTML(params);
            if (discussion) {
                eGui.appendChild(discussion);
            }
            return eGui;
        }

        function discussionHTML(params) {
            if (params.data && !params.data.isComparisionOrder) {
                var className = (params.data.IsDiscussion) ? 'green' : 'gray';
                var wrapper = document.createElement('div');
                wrapper.className = 'pt-0 pb-0';
                var container = document.createElement('div');
                container.className = 'icon-container w-100 float-left text-center pos-rel';
                container.setAttribute('data-toggle', 'modal');
                container.setAttribute('title', '');
                container.setAttribute('data-target', '#ModalDiscussion');
                wrapper.appendChild(container);

                if (params.data.FileCount > 0) {
                    var paperclip = document.createElement('span');
                    paperclip.className = 'glyphicon glyphicon-paperclip icon-paperclip cursor-pointer z-i-1 fs-14px pos-abs txt-clr-1';
                    paperclip.title = 'Discussion';
                    paperclip.style.cssText = 'top:2px; left:0; right:0';
                    paperclip.setAttribute('aria-hidden', 'true');
                    container.appendChild(paperclip);
                }
                if (params.data.IsDiscussion && params.data.DicomOrderID) {
                    container.appendChild(discussionIcon('fa fa-comments cursor-pointer fs-14px pt-5px ' + className));
                }
                else if (params.data.IsDiscussion && params.data.DicomOrderID != $scope.popoverDicomOrderID) {
                    container.appendChild(discussionIcon('fa fa-comments cursor-pointer fs-14px pt-5px ' + className));
                }
                if (!params.data.IsDiscussion) {
                    container.appendChild(discussionIcon('fa fa-comment-o cursor-pointer fs-14px txt-clr-14 pt-5px ' + className));
                }
                return wrapper;
            }
            else {
                return null;
            }
        }
        function discussionIcon(className) {
            var icon = document.createElement('span');
            icon.className = className;
            icon.title = 'Discussion';
            icon.setAttribute('aria-hidden', 'true');
            return icon;
        }
        function DOSCellTemplate(params) {
            var data = ($filter('localDate')(params.data.OrderDate, false, new Date()))
            var color = (params.data.RuleColorCode) ? params.data.RuleColorCode : params.data.RowColorCode;
            if (vm.selectedData.WorklistColorCode) {
                var worklistcolor = _.find(vm.selectedData.WorklistColorCode.PreferenceValue, { "Key": params.data.PatientClassPriority });
                if (worklistcolor && !worklistcolor.Deleted) {
                    color = worklistcolor.Value;
                }
            }
            var template = "";
            template = '<span title="' + data + '" style="color:' + color + '" class="' + 'row-type-' + params.node.data.PatientClassPriority + '">' + data + '</span>';
            return template;
        }
        //dicussion icon code ends here.

        /**
         * Below code is for Discussion PopOver
         * --Chirag Jadav
         * @param {any} template
         */
        function createDiscussionPopOver(instance, params) {
            var template = instance[0].eGui;
            hideAllTippyPopUp()
            var tippyInstance = tippy(template);
            tippyInstance.disable();
            configureTippyInstance(tippyInstance);
            if (params.data.IsDiscussion) {
                tippyJsinstance.push({ tippyInstance: tippyInstance, cellInstance: instance, rowNode: params.node });
            }
            var popOver = createDiscussionComponent(params);
            tippyInstance.setContent(popOver);
        }
        function configureTippyInstance(tippyInstance) {
            tippyInstance.enable();
            tippyInstance.show();
            document.getElementById("rightContentSection").addEventListener("mouseenter", discsnPopHide);
            function discsnPopHide() {
                tippyInstance.hide();
            }
            tippyInstance.setProps({
                trigger: 'mouseenter',
                placement: 'right',
                interactive: false,
                onMount: function (tippyInstance) {
                    tippyInstance.setProps({ interactive: true });
                },
                appendTo: document.body,
                hideOnClick: false,
                arrow: true,
                zIndex: 99999,
                followCursor: false,
                sticky: true,
                duration: 0,
                offset: [0, 8],
                flip: false
            });
        }
        function createDiscussionComponent(params) {
            var popOver = document.createElement('div');
            popOver.innerHTML = "<img src= \'https://i.gifer.com/ZKZx.gif\' style=\'height:20px;width:20px\'></img>"
            if (params.data.IsDiscussion) {
                showPopover(params.data.DicomOrderID, params.data.IsDiscussion).then(function (res) {
                    popOver.innerHTML = DOMPurify.sanitize("<div style='display:block; background-color: #323232;'>" + res + "</div>");
                });
            } else {
                popOver.innerHTML = "";
            }
            return popOver;
        }
        //discussion PopOver code ends.

        function TATCellTemplate(params) {
            var template = "";
            if (params.data.TAT) {
                if (params.data.TAT > 0) {
                    template = '<div title="' + params.data.TAT + ' MIN">' + params.data.TAT + ' MIN</div>';
                } else {
                    template = '<div title="0 MIN">0 MIN</div>';
                }
            }
            return template;
        }

        function examTagChip(label, width, ngClick) {
            var chip = document.createElement('span');
            chip.className = 'examtag-btnwrapper';
            chip.style.cssText = 'padding: 1px 5px; border-radius: 15px; font-weight: 500; background-color: #00605d; border: 1px solid #05c1a4; color: white;';
            if (width !== null) {
                chip.style.display = 'inline';
                chip.style.setProperty('width', width + 'px', 'important');
            }
            chip.title = label;
            chip.appendChild(document.createTextNode(label));
            var removeButton = document.createElement('button');
            removeButton.className = 'btn exam-tag px-1 border-0 py-0 mb-4px';
            removeButton.style.backgroundColor = 'transparent';
            removeButton.setAttribute('ng-click', ngClick);
            var icon = document.createElement('i');
            icon.className = 'glyphicon glyphicon-remove';
            removeButton.appendChild(icon);
            chip.appendChild(removeButton);
            return chip;
        }
        function ExamTagCellRenderer() {
            function CustomRender() {
            }
            CustomRender.prototype.init = function (params) {
                var obj = _.cloneDeep(params.data);
                $scope[params.rowIndex] = obj;
                this.eGui = document.createElement('div');
                var ExamTag = _.find($scope.DataObject.masterData.ExamTags, { 'Value': params.data.ExamTag });
                var RadExamTags = [];
                var SplitExamTags = (params.data.RadExamTag && params.data.RadExamTag.includes(',') ? params.data.RadExamTag.split(',') : params.data.RadExamTag);
                _.each(SplitExamTags, function (ExamTag) {
                    var obj = _.find($scope.DataObject.masterData.RadExamTag, { Value: ExamTag });

                    if (obj) {
                        RadExamTags.push(obj);
                    }
                });
                var tagWidth = _.toInteger((params.column.actualWidth) / 2);
                if (ExamTag) {
                    this.eGui.appendChild(examTagChip(ExamTag.Key, tagWidth, 'RemoveTag(this[' + params.rowIndex + '], true)'));
                }
                if (RadExamTags && RadExamTags.length > 0) {
                    var eGui = this.eGui;
                    _.each(RadExamTags, function (RadExamTag) {
                        eGui.appendChild(examTagChip(RadExamTag.Key, ExamTag ? tagWidth : null, 'RemoveTag(this[' + params.rowIndex + '], false, ' + RadExamTag.Value + ')'));
                    });
                }
                // create and compile AngularJS scope for this component
                var scope1 = $scope.$new();
                $compile(this.eGui)(scope1);
                //in case we are running outside of angular (ie in an ag-grid started VM turn)
                //we call $apply. we put in timeout in case we are inside apply already.
                var timeout = $timeout(function () { scope1.$apply.bind(scope1); $timeout.cancel(timeout); timeout = null; }, 0);
            };
            CustomRender.prototype.getGui = function () {
                return this.eGui;
            };
            CustomRender.prototype.destroy = function () {
            };
            return CustomRender;
        }

        function PriorityCellTemplate(params) {
            var template = "";
            if (params.data.Priority) {
                if ($sessionStorage.STATHighPriorityStudyTooltip && params.data.Priority.trim().toUpperCase().includes('(HIGH)')) {
                    template = '<div title="' + $sessionStorage.STATHighPriorityStudyTooltip + '">' + params.data.Priority + '</div>';
                }
                else if (params.data.Priority) {
                    template = '<div title="' + params.data.Priority + '">' + params.data.Priority + '</div>';
                }
            }
            return template;
        }
        //#region Column Definitions
        var ColumnDefs = [
            {
                field: 'HasComparison',
                headerName: '',
                cellClass: 'pl-7px',
                cellRenderer: 'agGroupCellRenderer',
                lockPosition: 'left',
                lockVisible: true,
                maxWidth: 28,
                minWidth: 28,
                pinned: 'left',
                resizable: false,
                sortable: false,
                suppressMenu: false,
                suppressMovable: true,
                valueFormatter: function () { return ""; },
                icons: {
                    menu: MainMenuIcon,
                },
            },
            {
                field: "User",
                headerName: "",
                cellClass: 'px-4px',
                cellRenderer: userLockIconCellTemplate,
                lockPosition: 'left',
                lockVisible: true,
                maxWidth: 28,
                minWidth: 28,
                pinned: 'left',
                resizable: false,
                sortable: false,
                suppressMovable: true,//Disable Column move
            },
            {
                field: "Location",
                flex: 1,
                minWidth: 70,
                tooltipField: 'Location',
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        FilterByRenderingPhysicianFlag = false;
                        getColumnFilterData().then(function () {
                            var LocationFilterLookupData = _.uniqBy(_.map(columnFilterData, function (data) { return { LocationID: data.LocationID, Location: data.Location }; }), 'LocationID');
                            params.success(LocationFilterLookupData);
                        });
                    },
                    valueFormatter: function (params) {
                        return params.value.Location;
                    },
                    keyCreator: function (params) {
                        return params.value.LocationID;
                    },
                    refreshValuesOnOpen: true,
                    defaultToNothingSelected: true,
                    showTooltips: true,
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "Accession",
                flex: 1,
                minWidth: 70,
                tooltipField: 'Accession',
                filter: 'agTextColumnFilter',
                filterParams: {
                    buttons: FilterParamsButtons,
                    closeOnApply: true,
                    filterPlaceholder: "Filter By Accession",
                    maxNumConditions: 1,
                    filterOptions: FilterParamsOptions,
                    defaultOption: 'equals',
                    trimInput: true,
                },
                icons: {
                    menu: FilterMenuIcon,
                },
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: "OrderDate",
                headerName: "DOS",
                cellRenderer: DOSCellTemplate,
                flex: 1,
                minWidth: 70,
                filter: 'agDateColumnFilter',
                filterParams: {
                    buttons: ["reset"],
                    filterPlaceholder: "Filter By DOS",
                    minValidDate: RuleOrderDate.DateValue.startDate ? RuleOrderDate.DateValue.startDate : moment().subtract(29, 'days').format("YYYY-MM-DD"),
                    maxValidDate: RuleOrderDate.DateValue.endDate ? RuleOrderDate.DateValue.endDate : moment().format("YYYY-MM-DD"),
                    filterOptions: ['inRange'],
                    maxNumConditions: 1,
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "PatientMRN",
                headerName: "MRN",
                flex: 1,
                minWidth: 70,
                tooltipField: "PatientMRN",
                filter: 'agTextColumnFilter',
                filterParams: {
                    buttons: FilterParamsButtons,
                    closeOnApply: true,
                    filterPlaceholder: "Filter By Patient MRN",
                    maxNumConditions: 1,
                    filterOptions: FilterParamsOptions,
                    defaultOption: 'equals',
                    trimInput: true,
                },
                icons: {
                    menu: FilterMenuIcon,
                },
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: "PatientName",
                headerName: "Patient Name",
                flex: 1,
                minWidth: 70,
                tooltipField: "PatientName",
                filter: 'agTextColumnFilter',
                filterParams: {
                    buttons: FilterParamsButtons,
                    closeOnApply: true,
                    filterPlaceholder: "Filter By Patient Name",
                    maxNumConditions: 1,
                    filterOptions: FilterParamsOptions,
                    trimInput: true,
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "FormattedPatientDOB",
                headerName: "DOB",
                initialWidth: 65,
                tooltipField: "FormattedPatientDOB",
            },
            {
                field: "PatientGender",
                headerName: "Gender",
                initialWidth: 60,
                tooltipField: "PatientGender",
            },
            {
                field: "PatientAge",
                headerName: "Age",
                initialWidth: 60,
                tooltipField: "PatientAge",
            },
            {
                field: "PatientClass",
                headerName: "Type",
                initialWidth: 50,
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        var timeoutValues = $timeout(function () {
                            var TypeFilterLookupData = [];
                            TypeFilterLookupData = _.map(vm.masterData.PatientClass, function (data) { return data.Value; });
                            params.success(TypeFilterLookupData);

                            $timeout.cancel(timeoutValues);
                            timeoutValues = null;
                        }, 1000);
                    },
                    valueFormatter: function (params) {
                        return params.value;
                    },
                    keyCreator: function (params) {
                        return params.value;
                    },
                    refreshValuesOnOpen: true,
                    defaultToNothingSelected: true,
                    showTooltips: true,
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "Modality",
                initialWidth: 50,
                tooltipField: "Modality",
            },
            {
                field: "ProcedureDesc",
                flex: 1,
                minWidth: 70,
                tooltipField: "ProcedureDesc",
                filter: 'agTextColumnFilter',
                filterParams: {
                    buttons: FilterParamsButtons,
                    closeOnApply: true,
                    filterPlaceholder: "Filter By Procedure Description",
                    maxNumConditions: 1,
                    filterOptions: FilterParamsOptions,
                    trimInput: true,
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "OrderingPhysician",
                headerName: "Ordering Physician",
                flex: 1,
                minWidth: 70,
                filter: 'agTextColumnFilter',
                filterParams: {
                    buttons: FilterParamsButtons,
                    closeOnApply: true,
                    filterPlaceholder: "Filter By Ordering Physician",
                    maxNumConditions: 1,
                    filterOptions: FilterParamsOptions,
                    trimInput: true,
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "CreatedDate",
                headerName: "Created Date",
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params.value) {
                        return ($filter('localDate')(params.value, false, new Date()));
                    }
                },
                filter: 'agDateColumnFilter',
                filterParams: {
                    buttons: ["reset"],
                    filterPlaceholder: "Filter By Created Date",
                    /*minValidDate: RuleOrderDate.DateValue.startDate ? RuleOrderDate.DateValue.startDate : moment().subtract(29, 'days').format("YYYY-MM-DD"),
                    maxValidDate: RuleOrderDate.DateValue.endDate ? RuleOrderDate.DateValue.endDate : moment().format("YYYY-MM-DD"),*/
                    filterOptions: ['inRange'],
                    maxNumConditions: 1,
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "ReceivedSince",
                headerName: "Pending Since",
                flex: 1,
                minWidth: 70,
                sortable: true,
                valueFormatter: function (params) {
                    return ($filter('localDate')(params.data.CreatedDate, true, new Date()));
                },
            },
            {
                field: "SignByName",
                headerName: "Rendering Physician",
                hide: true,
                flex: 1,
                minWidth: 70,
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        FilterByRenderingPhysicianFlag = true;
                        getColumnFilterData().then(function () {
                            var RenderingPhyFilterLookupData = _.uniqBy(_.map(_.filter(columnFilterData, function (data) { return data.SignBy != null && data.SignByName != null }), function (data) { return { SignBy: data.SignBy, SignByName: data.SignByName }; }), 'SignBy');
                            params.success(RenderingPhyFilterLookupData);

                            if (RenderingPhyFilterLookupData.length == 0) {
                                $('.ag-text-field').hide();
                                $('.ag-filter-virtual-list-container').hide();
                                if ($('.ag-filter-no-matches.fs-12px').length == 0) {
                                    $('.ag-set-filter').append('<p class="ag-filter-no-matches fs-12px">No matches.</p>');
                                }
                                else {
                                    $('.ag-filter-no-matches.fs-12px').show();
                                }
                            }
                            else {
                                $('.ag-filter-no-matches.fs-12px').hide();
                                $('.ag-text-field').show();
                                $('.ag-filter-virtual-list-container').show();
                            }
                        });
                    },
                    valueFormatter: function (params) {
                        return params.value.SignByName;
                    },
                    keyCreator: function (params) {
                        return params.value.SignBy;
                    },
                    refreshValuesOnOpen: true,
                    defaultToNothingSelected: true,
                    showTooltips: true,
                },
                valueFormatter: function (params) {
                    if (params.value) {
                        return ($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && ($sessionStorage.EnableRowsForSelectedTenants &&
                            $sessionStorage.EnableRowsForSelectedTenants.split(',').includes(params.data.TenantName))) ? "NA" : params.value;
                    }
                },
                tooltipValueGetter: function (params) {
                    if (params.value) {
                        return ($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && ($sessionStorage.EnableRowsForSelectedTenants &&
                            $sessionStorage.EnableRowsForSelectedTenants.split(',').includes(params.data.TenantName))) ? "NA" : params.value;
                    }
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "ReportSignDate",
                headerName: "Signed Date",
                hide: true,
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params.value) {
                        return ($filter('localDate')(params.value, false, new Date()));
                    }
                }
            },
            {
                field: "Reason",
                headerName: "Reason",
                hide: true,
                flex: 1,
                minWidth: 100,
                tooltipField: "Reason",
            },
            {
                field: "SLA",
                initialWidth: 80,
                cellRenderer: TATCellTemplate,
                filter: "agNumberColumnFilter",
                filterParams: {
                    buttons: FilterParamsButtons,
                    closeOnApply: true,
                    filterPlaceholder: "Filter By SLA (in minutes)",
                    maxNumConditions: 1,
                    filterOptions: NumberFilterParamsOptions,
                    trimInput: true,
                    allowedCharPattern: '\\d',
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "ImageInstance",
                headerName: "Image Count",
                initialWidth: 60,
                sortable: false,
                tooltipField: "ImageInstance",
                filter: "agNumberColumnFilter",
                filterParams: {
                    buttons: FilterParamsButtons,
                    closeOnApply: true,
                    filterPlaceholder: "Filter By Image Count",
                    maxNumConditions: 1,
                    filterOptions: NumberFilterParamsOptions,
                    trimInput: true,
                    allowedCharPattern: '\\d',
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "Priority",
                initialWidth: 90,
                sortable: false,
                tooltipField: "Priority",
                cellRenderer: PriorityCellTemplate,
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: function (params) {
                        var timeoutValues = $timeout(function () {
                            var PriorityFilterLookupData = [];
                            PriorityFilterLookupData = SharedService.mapPriorityToCollection(vm.masterData.StudyPriorities, false);
                            params.success(PriorityFilterLookupData);

                            $timeout.cancel(timeoutValues);
                            timeoutValues = null;
                        }, 1000);
                    },
                    valueFormatter: function (params) {
                        return params.value.Priority;
                    },
                    keyCreator: function (params) {
                        return params.value.Key;
                    },
                    refreshValuesOnOpen: true,
                    defaultToNothingSelected: true,
                    showTooltips: true,
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "WorkRVU",
                headerName: "Estimated wRVU",
                initialWidth: 50,
                sortable: false,
                tooltipField: "WorkRVU",
                filter: "agNumberColumnFilter",
                filterParams: {
                    buttons: FilterParamsButtons,
                    closeOnApply: true,
                    filterPlaceholder: "Filter By wRVU",
                    maxNumConditions: 1,
                    filterOptions: NumberFilterParamsOptions,
                    trimInput: true,
                },
                icons: {
                    menu: FilterMenuIcon,
                }
            },
            {
                field: "ExamTag",
                headerName: "Exam Tag",
                initialWidth: 170,
                sortable: false,
                hide: true,
                cellRenderer: ExamTagCellRenderer(),
            },
            {
                field: "Optional Image viewer",
                cellClass: 'px-5px',
                cellRenderer: viewerddCellTemplate,
                headerClass: 'hideHeaderTxt arrowcursor',
                maxWidth: 30,
                minWidth: 30,
                resizable: false,
                sortable: false,
            },
            {
                field: "Open CIVR",
                headerName: "Open CIVR",
                cellClass: 'px-5px',
                cellRenderer: civrCellTemplate,
                headerClass: 'hideHeaderTxt arrowcursor',
                maxWidth: 30,
                minWidth: 30,
                sortable: false,
                tooltipField: "Open CIVR",
            },
            {
                field: "View Report",
                headerName: "View Report",
                cellClass: 'px-5px',
                cellRenderer: reportParentCellTemplate,
                headerClass: 'hideHeaderTxt arrowcursor',
                maxWidth: 30,
                minWidth: 30,
                resizable: false,
                sortable: false,
            },
            {
                field: "Share Exam",
                headerName: "Share Exam",
                cellClass: 'px-5px',
                cellRenderer: shareExamCellTemplate,
                headerClass: "hideHeaderTxt",
                maxWidth: 30,
                minWidth: 30,
                resizable: false,
                sortable: false,
                tooltipField: "Share Exam",
            },
            {
                field: "IsDiscussion",
                headerName: "Discussion",
                headerClass: "hideHeaderTxt",
                cellClass: "overflow-visible px-5px",
                cellRenderer: discussionCellTemplate,
                maxWidth: 30,
                minWidth: 30,
                resizable: false,
                sortable: false,
            },

        ];
        var ViewModeColumnDefs = [
            {
                field: "Location",
                flex: 1,
                lockVisible: true,
                menuTabs: [],
                minWidth: 70,
                sortable: false,
                suppressMovable: true,
                tooltipField: 'Location',
            },
            {
                field: "Accession",
                flex: 1,
                lockVisible: true,
                menuTabs: [],
                minWidth: 70,
                sortable: false,
                suppressMovable: true,
                tooltipField: 'Accession',
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: "OrderDate",
                headerName: "DOS",
                cellRenderer: DOSCellTemplate,
                flex: 1,
                lockVisible: true,
                menuTabs: [],
                minWidth: 70,
                sortable: false,
                suppressMovable: true,
            },
            {
                field: "PatientMRN",
                headerName: "MRN",
                flex: 1,
                lockVisible: true,
                menuTabs: [],
                sortable: false,
                suppressMovable: true,
                tooltipField: "PatientMRN",
                valueFormatter: function (params) {
                    if (params && params.value) {
                        return params.value.toUpperCase();
                    }
                }
            },
            {
                field: "PatientName",
                headerName: "Patient Name",
                flex: 1,
                lockVisible: true,
                menuTabs: [],
                minWidth: 70,
                sortable: false,
                suppressMovable: true,
                tooltipField: "PatientName",
            },
            {
                field: "FormattedPatientDOB",
                headerName: "DOB",
                initialWidth: 65,
                lockVisible: true,
                menuTabs: [],
                sortable: false,
                suppressMovable: true,
                tooltipField: "FormattedPatientDOB",
            },
            {
                field: "PatientGender",
                headerName: "Gender",
                initialWidth: 60,
                lockVisible: true,
                menuTabs: [],
                sortable: false,
                suppressMovable: true,
                tooltipField: "PatientGender",
            },
            {
                field: "PatientAge",
                headerName: "Age",
                initialWidth: 60,
                lockVisible: true,
                menuTabs: [],
                sortable: false,
                suppressMovable: true,
                tooltipField: "PatientAge",
            },
            {
                field: "PatientClass",
                headerName: "Type",
                initialWidth: 50,
                lockVisible: true,
                menuTabs: [],
                sortable: false,
                suppressMovable: true,
            },
            {
                field: "Modality",
                initialWidth: 50,
                lockVisible: true,
                menuTabs: [],
                sortable: false,
                suppressMovable: true,
                tooltipField: "Modality",
            },
            {
                field: "ProcedureDesc",
                flex: 1,
                lockVisible: true,
                menuTabs: [],
                minWidth: 70,
                sortable: false,
                suppressMovable: true,
                tooltipField: "ProcedureDesc",
            },
            {
                field: "OrderingPhysician",
                headerName: "Ordering Physician",
                flex: 1,
                lockVisible: true,
                menuTabs: [],
                minWidth: 70,
                sortable: false,
                suppressMovable: true,
            },
            {
                field: "CreatedDate",
                headerName: "Created Date",
                flex: 1,
                lockVisible: true,
                menuTabs: [],
                minWidth: 70,
                sortable: false,
                suppressMovable: true,
                valueFormatter: function (params) {
                    return ($filter('localDate')(params.data.CreatedDate, false));
                },
            },
            {
                field: "ReceivedSince",
                headerName: "Pending Since",
                flex: 1,
                menuTabs: [],
                minWidth: 70,
                sortable: true,
                suppressMovable: true,
                valueFormatter: function (params) {
                    return ($filter('localDate')(params.data.CreatedDate, true, new Date()));
                },
            },

            {
                field: "SignByName",
                headerName: "Rendering Physician",
                hide: true,
                flex: 1,
                minWidth: 70,
                lockVisible: true,
                sortable: false,
                suppressMovable: true,
                suppressMenu: true,
                valueFormatter: function (params) {
                    if (params.value) {
                        return ($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && ($sessionStorage.EnableRowsForSelectedTenants &&
                            $sessionStorage.EnableRowsForSelectedTenants.split(',').includes(params.data.TenantName))) ? "NA" : params.value;
                    }
                },
                tooltipValueGetter: function (params) {
                    if (params.value) {
                        return ($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && ($sessionStorage.EnableRowsForSelectedTenants &&
                            $sessionStorage.EnableRowsForSelectedTenants.split(',').includes(params.data.TenantName))) ? "NA" : params.value;
                    }
                },
            },
            {
                field: "ReportSignDate",
                headerName: "Signed Date",
                hide: true,
                flex: 1,
                minWidth: 70,
                valueFormatter: function (params) {
                    if (params.value) {
                        return ($filter('localDate')(params.value, false, new Date()));
                    }
                },
                lockVisible: true,
                sortable: false,
                suppressMovable: true,
                suppressMenu: true,
            },
            {
                field: "SLA",
                initialWidth: 120,
                cellRenderer: TATCellTemplate,
                sortable: false,
            },
            {
                field: "ImageInstance",
                headerName: "Image Count",
                initialWidth: 60,
                lockVisible: true,
                menuTabs: [],
                sortable: false,
                suppressMovable: true,
                tooltipField: "ImageInstance",
            },
            {
                field: "Priority",
                headerName: "Priority",
                initialWidth: 90,
                lockVisible: true,
                menuTabs: [],
                sortable: false,
                suppressMovable: true,
                tooltipField: "Priority",
            },
            {
                field: "WorkRVU",
                headerName: "Estimated wRVU",
                initialWidth: 50,
                lockVisible: true,
                menuTabs: [],
                sortable: false,
                suppressMovable: true,
                tooltipField: "WorkRVU",
            },
        ];
        //#endregion

        //#region AG Grid

        //expend detail grid
        function detailCellRendererParams(masterGridParams) {
            return {
                detailGridOptions: {
                    columnDefs: ColumnDefs,
                    enableBrowserTooltips: true,
                    popupParent: document.body,
                    defaultColDef: {
                        suppressMenu: true,
                        resizable: true,
                        sortable: false,
                        lockVisible: false,
                    },
                    suppressMenuHide: true,
                    getContextMenuItems: expandedOpenContextMenuOptions,
                    headerHeight: 0,

                    context: {
                        masterGrid: {
                            node: masterGridParams.node.parent,
                            data: masterGridParams.data
                        }
                    },

                    getRowStyle: function (params) {
                        var obj = {}
                        if (vm.selectedData.WorklistFontSize && vm.selectedData.WorklistFontSize.PreferenceValue) {
                            obj.fontSize = vm.selectedData.WorklistFontSize.PreferenceValue + 'px';
                        }
                        if (vm.selectedData.WorklistColorCode) {
                            var worklistcolor = _.find(vm.selectedData.WorklistColorCode.PreferenceValue, { "Key": params.node.data.PatientClassPriority });
                            if (worklistcolor && !worklistcolor.Deleted) {
                                obj.color = worklistcolor.Value;
                            }
                        }
                        else if (params.node.data.RuleColorCode) {
                            obj.color = params.node.data.RuleColorCode;
                        }
                        else if (params.node.data.RowColorCode) {
                            obj.color = params.node.data.RowColorCode;
                        } else {
                            obj.color = '#B9ADCF';
                        }

                        return obj;
                    },
                    onGridReady: function (params) {
                        params.columnApi.applyColumnState({ state: $scope.DataObject.worklist.savedState, applyOrder: true });
                    },
                    onFirstDataRendered: function (params) {
                        params.columnApi.applyColumnState({ state: $scope.DataObject.worklist.savedState, applyOrder: true });
                    },
                    onRowClicked: function (params) {
                        if (params.context && params.context.masterGrid && params.context.masterGrid.node) {
                            params.context.masterGrid.node.setSelected(true)
                        }
                    }
                },
                getDetailRowData: function (params) {
                    var savedState = gridOptions.columnApi.getColumnState();

                    GetOrdersComparisonList(params.data.OrderID).then(function (ComparisionOrder) {
                        params.data.ComparisonOrder = ComparisionOrder;
                        _.each(ComparisionOrder, function (order) {
                            order.isComparisionOrder = 1;
                            order.TenantName = params.data.TenantName;
                        });
                        params.successCallback(ComparisionOrder);
                        var timeout = $timeout(function () {
                            gridOptions.api.forEachDetailGridInfo(function (detailGridApi) {
                                detailGridApi.columnApi.applyColumnState({ state: savedState, applyOrder: true });
                            });
                        }, 100);
                        TimeoutList.push(timeout);
                    });
                },
            }

        }

        var gridOptions = {
            columnMenu: 'new',
            columnDefs: vm.viewMode ? ViewModeColumnDefs : ColumnDefs,
            masterDetail: true,
            detailRowAutoHeight: true,
            enableBrowserTooltips: true,
            defaultColDef: {
                suppressMenu: true,
                resizable: true,
                sortable: true,
                lockVisible: false,//prevent column hiding if true
                columnsMenuParams: {
                    columnLayout: ColumnsToHide
                },
                tooltipValueGetter: function (params) {
                    if (params.node.data) {
                        var rowToolTip = '';
                        if (EnableRowsForSelectedTenants && !$scope.DataObject.worklist.IsSmartWorklist
                            && ($sessionStorage.currentUserData
                                && !$sessionStorage.currentUserData.AllowEnableRowsForSelectedTenants)
                            && ($sessionStorage.EnableRowsForSelectedTenants
                                && $sessionStorage.EnableRowsForSelectedTenants.split(',').includes(params.node.data.TenantName))
                            && (params.node.data.Priority.toUpperCase().trim().includes('ROUTINE')
                                || params.node.data.Priority.toUpperCase().trim().includes('DELAYED'))) {
                            rowToolTip = 'STAT STUDIES FIRST! Please prioritize these before Routine exams.';
                        }
                        return rowToolTip;
                    }
                }
            },
            tooltipShowDelay: 500,
            suppressMenuHide: false,
            getMainMenuItems: getMainMenuItems,
            sortingOrder: ['desc', 'asc'],
            rowSelection: 'multiple',
            isRowMaster: function (order) {
                return _.toInteger(order.HasComparison);
            },
            // use the server-side row model
            rowModelType: 'serverSide',
            getRowId: function (params) {
                return params.data.ID;
            },
            //getRowNodeId: function (params) {
            //    return params.data.ID;
            //},
            // fetch 10 rows at a time (default is 100)
            cacheBlockSize: $scope.DataObject.worklist.PageSize,
            maxBlocksInCache: 1,
            //maxConcurrentDatasourceRequests: 1,
            detailCellRendererParams: detailCellRendererParams,
            getContextMenuItems: openContextMenuOptions,
            //components: {
            //    agDateInput: CustomDateRangePickerComponent,
            //},
            getRowStyle: function (params) {
                if (params.node.data) {
                    var obj = { color: (params.node.data.RuleColorCode) ? params.node.data.RuleColorCode : params.node.data.RowColorCode }
                    if (vm.selectedData.WorklistFontSize && vm.selectedData.WorklistFontSize.PreferenceValue) {
                        obj.fontSize = vm.selectedData.WorklistFontSize.PreferenceValue + 'px';
                    }
                    if (vm.selectedData.WorklistColorCode) {
                        var worklistcolor = _.find(vm.selectedData.WorklistColorCode.PreferenceValue, { "Key": params.node.data.PatientClassPriority });
                        if (worklistcolor && !worklistcolor.Deleted) {
                            obj.color = worklistcolor.Value;
                        }
                    }
                    return obj;
                }
            },

            getRowClass: function (params) {
                if (params.node.data) {
                    var rowClass = '';
                    rowClass = 'row-type-' + params.node.data.PatientClassPriority;
                    if (EnableRowsForSelectedTenants && !$scope.DataObject.worklist.IsSmartWorklist
                        && ($sessionStorage.currentUserData
                            && !$sessionStorage.currentUserData.AllowEnableRowsForSelectedTenants)
                        && ($sessionStorage.EnableRowsForSelectedTenants
                            && $sessionStorage.EnableRowsForSelectedTenants.split(',').includes(params.node.data.TenantName))
                        && (params.node.data.Priority.toUpperCase().trim().includes('ROUTINE')
                            || params.node.data.Priority.toUpperCase().trim().includes('DELAYED'))) {
                        rowClass += ' row-disbl-splash'; // Gray out the row
                    }
                    return rowClass;
                }
            },

            overlayNoRowsTemplate: RuleNoDataTemplate,
            popupParent: document.body,
            //embedFullWidthRows: true,
            /* Grid Events Starts */
            //Bind data from serever to grid
            onColumnEverythingChanged: function (params) {
                if (params && (params.source == "contextMenu")) {
                    vm.worklist.SignedByPrefUpdated = 2;
                    vm.worklist.SignedDatePrefUpdated = 2;
                    $scope.DataObject.worklist.SignedByPrefUpdated = 2;
                    $scope.DataObject.worklist.SignedDatePrefUpdated = 2;

                    var columnStates = gridOptions.columnApi.getColumnState();
                    showhideSignedByAndDateCol(columnStates);
                    defaultState(columnStates);
                    vm.worklist.SaveLayout = true;
                    vm.updateProps();
                }
            },
            onGridReady: function () {
                //$("div[col-id='HasComparison']").addClass(function (index) {
                //    return "ag-header-active";
                //});                
                angular.element('.fltr-mdl-worklit').parent().addClass('fltr-mdl-worklit-wrapper');
                var columnStates = gridOptions.columnApi.getColumnState();
                PendingSinceColChanges(columnStates);
                showhideSignedByAndDateCol(columnStates);
                if (!vm.viewMode) {
                    if (!$scope.DataObject.worklist.savedState) {
                        defaultState(columnStates);
                    } else {
                        var savedStates = $scope.DataObject.worklist.savedState;
                        var differenceStates = _.differenceBy(columnStates, savedStates, 'colId');
                        if (differenceStates.length > 0) {
                            _.each(columnStates, function (col, index) {
                                var idx = _.findIndex(savedStates, { 'colId': col.colId });
                                if (idx == -1) {
                                    var previousCol = columnStates[index - 1];
                                    if (previousCol) {
                                        var previousColSavedStateIndex = _.findIndex(savedStates, { 'colId': previousCol.colId });
                                        if (previousColSavedStateIndex != -1) {
                                            savedStates.splice(previousColSavedStateIndex + 1, 0, col);
                                        }
                                    }
                                }
                            });
                            $scope.DataObject.worklist.savedState = savedStates;
                            vm.updateProps();
                        }
                        gridOptions.columnApi.applyColumnState({ state: savedStates, applyOrder: true });
                        sorting($scope.DataObject.worklist.SortColumns);
                    }
                } else {
                    defaultState(columnStates);
                }

                setColumnHideMenu();




                gridOptions.api.setCacheBlockSize($scope.DataObject.worklist.PageSize);
                // setup the fake server with entire dataset
                var fakeServer = createFakeServer();

                // create datasource with a reference to the fake server
                var datasource = createServerSideDatasource(fakeServer);

                // register the datasource with the grid

                gridOptions.api.setServerSideDatasource(datasource);

            },

            onSortChanged: function (params) {
                //Sorting model
                if (params.source == "uiColumnSorted") {
                    var savedState = gridOptions.columnApi.getColumnState();

                    var sortObject = _.filter(savedState, function (so) { return so.sort == "asc" || so.sort == "desc"; });
                    var createdDateSort = _.find(sortObject, function (s) { return s.colId === 'CreatedDate'; });
                    var receivedSinceSort = _.find(sortObject, function (s) { return s.colId === 'ReceivedSince'; });
                    if (createdDateSort && receivedSinceSort) {
                        var removeColId = createdDateSort.sortIndex > receivedSinceSort.sortIndex ? 'ReceivedSince' : 'CreatedDate';
                        sortObject = _.filter(sortObject, function (s) { return s.colId !== removeColId; });
                        gridOptions.columnApi.applyColumnState({ state: [{ colId: removeColId, sort: null }] });
                    }
                    if (sortObject.length > 0) {
                        $scope.DataObject.worklist.SortColumns = [];
                        _.each(sortObject, function (sortedObj) {
                            var obj = { 'field': sortedObj.colId, sort: { 'direction': sortedObj.sort, 'priority': sortedObj.sortIndex } };
                            $scope.DataObject.worklist.SortColumns.push(obj);
                        });
                        vm.worklist.SortColumns = $scope.DataObject.worklist.SortColumns;
                        vm.worklist.SaveLayout = true;
                        vm.updateProps();

                        var equalObject = _.isEqual($scope.DataObject.worklist.savedState, savedState);
                        if (!equalObject && !vm.viewMode) {
                            $scope.DataObject.worklist.savedState = savedState;
                            vm.worklist.savedState = savedState;
                            vm.worklist.SaveLayout = true;
                            vm.updateProps();
                            //vm.updateUserLayoutPref();
                        }

                    } else {
                        gridOptions.columnApi.applyColumnState({ state: [{ colId: 'CreatedDate', sort: 'asc' }], });
                        $scope.DataObject.worklist.SortColumns = [{ "field": "CreatedDate", "sort": { "direction": "asc", "priority": 0 } }];
                    }
                    sorting($scope.DataObject.worklist.SortColumns);
                    PageNo = 1;
                    sortingApplied = true;
                    gridOptions.api.refreshServerSide({ purge: true });
                    gridOptions.api.ensureIndexVisible(0);
                }
            },

            onColumnResized: function (params) {
                var savedState = gridOptions.columnApi.getColumnState();
                gridOptions.api.forEachDetailGridInfo(function (detailGridApi) {
                    detailGridApi.columnApi.applyColumnState({ state: savedState, applyOrder: true });
                });
                if (params && params.source == "autosizeColumns") {
                    var equalObject = _.isEqual($scope.DataObject.worklist.savedState, savedState);
                    if (!equalObject && !vm.viewMode) {
                        $scope.DataObject.worklist.savedState = savedState;
                        vm.worklist.savedState = savedState;
                        vm.worklist.SaveLayout = true;
                        vm.updateProps();
                        //vm.updateUserLayoutPref();
                    }
                }
            },
            onColumnMoved: function (params) {
                if (params.finished) {
                    var savedState = gridOptions.columnApi.getColumnState();

                    gridOptions.api.forEachDetailGridInfo(function (detailGridApi) {
                        detailGridApi.columnApi.applyColumnState({ state: savedState, applyOrder: true, });
                    });
                    var equalObject = _.isEqual($scope.DataObject.worklist.savedState, savedState);
                    if (!equalObject && !vm.viewMode) {
                        $scope.DataObject.worklist.savedState = savedState;
                        vm.worklist.savedState = savedState;
                        vm.worklist.SaveLayout = true;
                        vm.updateProps();
                        //vm.updateUserLayoutPref();
                    }
                }


            },
            onSelectionChanged: function (params) {
                selectedRow = gridOptions.api.getSelectedRows()[0];
                if (selectedRow && $sessionStorage.currentUserData) {
                    setSelected(selectedRow.OrderID, selectedRow);
                    var prefetchFilter = { OrderId: selectedRow.OrderID, ProviderID: $sessionStorage.currentUserData.userId };
                    _verifyReadStudyCache = {};
                    _verifyReadStudyCache[selectedRow.OrderID] = WorklistService.VerfiyReadStudy(prefetchFilter);
                }
            },
            onRowDoubleClicked: function (params) {
                $scope.SelectedOrder = params.data;
                if (!vm.viewMode) {
                    $scope.OpenSignReport(params.data, OrderList);
                }

            },
            onCellClicked: function (params) {
                switch (params.column.colId) {
                    case "Open CIVR":
                        OpenVR(params.data, true);
                        break;
                    case "IsDiscussion":
                        $scope.DataObject.ShowAttachmentTab = false;
                        if (params.data && params.data.FileCount > 0) {
                            $scope.onDiscussionWindowTabChange('Attachment');
                            $scope.DataObject.ShowAttachmentTab = true;
                        }
                        LoadOnlyDiscussion(params.data.DicomOrderID, 'Discussion');
                        break;
                    case "Share Exam":
                        openShareExamWindow(params.data);
                        break;
                    case "View Report":
                        switch (params.data.Status) {
                            case 'RP':
                                if (params.data.IsPriorOrder) {
                                    showPriorReport(params.data, params.data.Accession);
                                }
                                break;
                            case 'C':
                            case 'PA':
                            case 'D':
                                ViewOrderReport(params.data, params.data.Accession);
                                break;
                        }
                        break;
                    case "Optional Image viewer":
                        params.node.data.eventType = params.type;
                        params.node.showSecondMenu = true;
                        params.api.contextMenuFactory.showMenu(params.node, params.column, params.value, params.event);
                        break;
                    case "OrderingPhysician":
                        params.node.data.eventType = params.type;
                        params.node.showSecondMenu = true;
                        params.api.contextMenuFactory.showMenu(params.node, params.column, params.value, params.event);
                        break;
                    case "PatientClass":
                        if (!vm.viewMode) {
                            GetTypeContactMessage(params.node.data).then(function (typeContactMessage) {
                                params.node.data.TypeContactMessage = typeContactMessage;
                            });;
                            params.node.data.eventType = params.type;
                            params.node.showSecondMenu = true;
                            params.api.contextMenuFactory.showMenu(params.node, params.column, params.value, params.event);
                        }


                        break;

                    case "Location":
                        params.node.data.eventType = params.type;
                        params.node.showSecondMenu = true;
                        params.api.contextMenuFactory.showMenu(params.node, params.column, params.value, params.event);
                        break;
                    case "PatientName":
                        params.node.data.eventType = params.type;
                        params.node.showSecondMenu = true;
                        params.api.contextMenuFactory.showMenu(params.node, params.column, params.value, params.event);
                        break;
                }
            },
            onCellMouseOver: function (params) {
                switch (params.column.colId) {
                    case 'IsDiscussion':
                        if (params.data.IsDiscussion) {
                            var cellRendererInstances = params.api.getCellRendererInstances({
                                rowNodes: [params.node],
                                columns: [params.column],
                            });
                            createDiscussionPopOver(cellRendererInstances, params)
                        } else {
                            hideAllTippyPopUp();
                        }
                        break;
                    case "Optional Image viewer":
                        break;//!!Do not remove this line untill it's making an issue. --Chirag Jadav
                    case "OrderingPhysician":
                        break;//!This case is added so that context menu stays visible. -- Chirag Jadav
                    case "PatientClass":
                        break;//!This case is added so that context menu stays visible. -- Chirag Jadav
                    case "Location":
                        break;//!This case is added so that context menu stays visible. -- Chirag Jadav
                    default:
                        var Idx = _.findIndex(contextMenus, { 'name': 'Share Exam' });
                        if (Idx == -1) { gridOptions.api.hidePopupMenu(); }

                }
            },
            onColumnVisible: function (params) {
                if (params.source != "api") {
                    var savedState = gridOptions.columnApi.getColumnState();
                    gridOptions.api.forEachDetailGridInfo(function (detailGridApi) {
                        detailGridApi.columnApi.applyColumnState({ state: savedState, applyOrder: true });
                    });
                    var equalObject = _.isEqual($scope.DataObject.worklist.savedState, savedState);
                    if (!equalObject && !vm.viewMode) {
                        $scope.DataObject.worklist.savedState = savedState;
                        vm.worklist.savedState = savedState;
                        if (params.column && params.column.colId == "SignByName") {
                            vm.worklist.SignedByPrefUpdated = 1;
                            $scope.DataObject.worklist.SignedByPrefUpdated = 1;
                        }
                        if (params.column && params.column.colId == "ReportSignDate") {
                            vm.worklist.SignedDatePrefUpdated = 1;
                            $scope.DataObject.worklist.SignedDatePrefUpdated = 1;
                        }
                        vm.worklist.SaveLayout = true;
                        vm.updateProps();
                        //vm.updateUserLayoutPref();
                    }
                }
            },
            onBodyScroll: function (params) {
                var gridHeight = params.top + gridDiv.offsetHeight;
                _.each(tippyJsinstance, function (instance) {
                    if (instance.rowNode && ((instance.rowNode.rowTop < params.top) || (instance.rowNode.rowTop > gridHeight))) {
                        instance.tippyInstance.hide();
                    }
                });
            },
            onDragStopped: function (params) {
                var savedState = gridOptions.columnApi.getColumnState();
                var equalObject = _.isEqual($scope.DataObject.worklist.savedState, savedState);
                if (!equalObject && !vm.viewMode) {
                    $scope.DataObject.worklist.savedState = savedState;
                    vm.worklist.savedState = savedState;
                    vm.worklist.SaveLayout = true;
                    vm.updateProps();
                    //vm.updateUserLayoutPref();
                }
            },
            /* Grid Events Ends */
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooterCenter',
                        align: 'left'
                    },
                ],
            },
            icons: {
                groupExpanded:
                    '<div class=\'fa fa-minus fs-15px txt-clr-14 ng-scope\' title=\'Collapse\'></div>',
                groupContracted:
                    '<div class=\'fa fa-plus fs-15px txt-clr-14 ng-scope\' title=\'Expand\'></div>',
            },
            defaultExcelExportParams: {
                processCellCallback: function (params) {
                    return DefaultExportParams(params);
                }
            },
            defaultCsvExportParams: {
                processCellCallback: function (params) {
                    return DefaultExportParams(params);
                }
            },
            onFilterOpened: function (params) {
                angular.element('input[type="text"][ref="eInput"]').attr('autocomplete', 'off');
                switch (params.column.colId) {
                    case 'OrderDate':
                        setOrderDateColumnFilterparams(params);
                        break;
                    case 'WorkRVU':
                    case 'ImageInstance':
                    case 'SLA':
                        ChangeInRangeFilterPlaceHolder(params.column.colId);
                        break;
                }
            },
            onFilterChanged: function (params) {
                resetParameter();
                resetPracticeWorklistFilter();
                if (params.api.getFilterModel().Location) {
                    FilterByLocationIDs = _.join(params.api.getFilterModel().Location.values, ",");
                }
                if (params.api.getFilterModel().Modality) {
                    FilterByModality = _.join(params.api.getFilterModel().Modality.values, ",");
                }
                if (params.api.getFilterModel().PatientClass) {
                    FilterByType = _.join(params.api.getFilterModel().PatientClass.values, ",");
                }
                if (params.api.getFilterModel().Priority) {
                    FilterByPriority = _.join(params.api.getFilterModel().Priority.values, ",");
                }
                if (params.api.getFilterModel().Accession) {
                    FilterByAccession = "";
                    if (params.api.getFilterModel().Accession.conditions) {
                        var operator = params.api.getFilterModel().Accession.operator;
                        _.each(params.api.getFilterModel().Accession.conditions, function (condition) {
                            FilterByAccession += getFilterString(condition.type, condition.filter) + " " + operator + " ";
                            operator = "";
                        });
                    } else {
                        var type = params.api.getFilterModel().Accession.type;
                        var filter = params.api.getFilterModel().Accession.filter;
                        FilterByAccession = getFilterString(type, filter);
                    }
                }
                if (params.api.getFilterModel().PatientMRN) {
                    FilterByPatientMRN = "";
                    if (params.api.getFilterModel().PatientMRN.conditions) {
                        var operator = params.api.getFilterModel().PatientMRN.operator;
                        _.each(params.api.getFilterModel().PatientMRN.conditions, function (condition) {
                            FilterByPatientMRN += getFilterString(condition.type, condition.filter) + " " + operator + " ";
                            operator = "";
                        });
                    } else {
                        var type = params.api.getFilterModel().PatientMRN.type;
                        var filter = params.api.getFilterModel().PatientMRN.filter;
                        FilterByPatientMRN = getFilterString(type, filter);
                    }
                }
                if (params.api.getFilterModel().PatientName) {
                    FilterByPatientName = "";
                    if (params.api.getFilterModel().PatientName.conditions) {
                        var operator = params.api.getFilterModel().PatientName.operator;
                        _.each(params.api.getFilterModel().PatientName.conditions, function (condition) {
                            FilterByPatientName += getFilterString(condition.type, condition.filter) + " " + operator + " ";
                            operator = "";
                        });
                    } else {
                        var type = params.api.getFilterModel().PatientName.type;
                        var filter = params.api.getFilterModel().PatientName.filter;
                        FilterByPatientName = getFilterString(type, filter);
                    }
                }
                if (params.api.getFilterModel().ProcedureDesc) {
                    FilterByProcedureDesc = "";
                    if (params.api.getFilterModel().ProcedureDesc.conditions) {
                        var operator = params.api.getFilterModel().ProcedureDesc.operator;
                        _.each(params.api.getFilterModel().ProcedureDesc.conditions, function (condition) {
                            FilterByProcedureDesc += getFilterString(condition.type, condition.filter) + " " + operator + " ";
                            operator = "";
                        });
                    } else {
                        var type = params.api.getFilterModel().ProcedureDesc.type;
                        var filter = params.api.getFilterModel().ProcedureDesc.filter;
                        FilterByProcedureDesc = getFilterString(type, filter);
                    }
                }
                if (params.api.getFilterModel().OrderingPhysician) {
                    FilterByOrderingPhysician = "";
                    if (params.api.getFilterModel().OrderingPhysician.conditions) {
                        var operator = params.api.getFilterModel().OrderingPhysician.operator;
                        _.each(params.api.getFilterModel().OrderingPhysician.conditions, function (condition) {
                            FilterByOrderingPhysician += getFilterString(condition.type, condition.filter) + " " + operator + " ";
                            operator = "";
                        });
                    } else {
                        var type = params.api.getFilterModel().OrderingPhysician.type;
                        var filter = params.api.getFilterModel().OrderingPhysician.filter;
                        FilterByOrderingPhysician = getFilterString(type, filter);
                    }
                }
                if (params.api.getFilterModel().SignByName) {
                    FilterByRenderingPhysician = _.join(params.api.getFilterModel().SignByName.values, ",");
                }
                if (params.api.getFilterModel().OrderDate) {
                    FilterByDOSDateRange.StartDate = params.api.getFilterModel().OrderDate.dateFrom;
                    FilterByDOSDateRange.EndDate = params.api.getFilterModel().OrderDate.dateTo;
                }
                if (params.api.getFilterModel().ImageInstance) {
                    var type = params.api.getFilterModel().ImageInstance.type;
                    var filter = params.api.getFilterModel().ImageInstance.filter;
                    var filterTo = params.api.getFilterModel().ImageInstance.filterTo;
                    FilterByImageInstance = getNumberFilterString(type, filter, filterTo);
                }
                if (params.api.getFilterModel().WorkRVU) {
                    var type = params.api.getFilterModel().WorkRVU.type;
                    var filter = params.api.getFilterModel().WorkRVU.filter;
                    var filterTo = params.api.getFilterModel().WorkRVU.filterTo;
                    FilterByWorkRVU = getNumberFilterString(type, filter, filterTo);
                }
                if (params.api.getFilterModel().SLA) {
                    var type = params.api.getFilterModel().SLA.type;
                    var filter = params.api.getFilterModel().SLA.filter;
                    var filterTo = params.api.getFilterModel().SLA.filterTo;
                    FilterBySLA = getNumberFilterString(type, filter, filterTo);
                }
                if (params.api.getFilterModel().CreatedDate) {
                    FilterByCreatedDateRange.StartDate = params.api.getFilterModel().CreatedDate.dateFrom;
                    FilterByCreatedDateRange.EndDate = params.api.getFilterModel().CreatedDate.dateTo;
                }
            },
            onFilterModified: function (params) {
                switch (params.column.colId) {
                    case 'WorkRVU':
                    case 'ImageInstance':
                    case 'SLA':
                        ChangeInRangeFilterPlaceHolder(params.column.colId);
                        break;
                }
            }
        };

        function defaultState(columnStates) {
            var idx = _.findIndex(columnStates, { 'colId': 'CreatedDate' });
            if (idx != -1) {
                columnStates[idx].sort = 'asc';
            }

            gridOptions.columnApi.applyColumnState({ state: columnStates, applyOrder: true });
            $scope.DataObject.worklist.savedState = columnStates;
            vm.worklist.savedState = columnStates;
        }

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
                //this.eGui.innerHTML = 'Thid is temp div';
                //// create and compile AngularJS scope for this component
                //this.$scope1 = $scope.$new();
                //$compile(this.eGui)(this.$scope1);
                //this.$scope1.params = params;
                // //in case we are running outside of angular (ie in an ag-grid started VM turn)
                // //we call $apply. we put in timeout in case we are inside apply already.
                //setTimeout(this.$scope1.$apply.bind(this.$scope1), 0);
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }

        function getMainMenuItems(params) {
            var athleteMenuItems = ["autoSizeAll", "separator", "resetColumns"];
            return athleteMenuItems;
        }
        //#region - Ag-Grid Functions
        function createServerSideDatasource(server) {
            return {
                getRows: function (params) {
                    // get data for request from our fake server

                    server.getData(params.request).then(function (response) {
                        params.success({
                            rowData: response.rows,
                            rowCount: response.lastRow,
                        });

                        var selectedRows = gridOptions.api.getSelectedRows();
                        if (selectedRows.length > 0) {
                            gridOptions.api.deselectAll();
                            _.each(selectedRows, function (row) {
                                selectAgGridRow(row.OrderID);
                            });
                        }




                    }, function (reason) {
                        params.fail();
                    });



                },
            };
        }

        function createFakeServer() {
            return {
                getData: function (request) {
                    var d = $q.defer();

                    var page = request.startRow > 0 ?
                        _.toInteger(request.endRow / $scope.DataObject.worklist.PageSize) :
                        1;
                    if (page <= 0) { page = 1; }

                    if (sortingApplied) {
                        PageNo = page;
                        sortingApplied = false;
                    } else if (autoRefreshing) {
                        PageNo = page;
                        autoRefreshing = false;
                    } else if (page > PageNo) {
                        PageNo = page;
                    } else if (page < PageNo) {
                        PageNo = page;
                    }

                    $scope.DataObject.worklist.loading = true;
                    vm.worklist.loading = $scope.DataObject.worklist.loading;

                    statusBarComponent = (showOnlyFiveStudies) ?
                        gridOptions.api.getStatusPanel('GridFooterCenter') :
                        gridOptions.api.getStatusPanel('GridFooter');
                    statusBarComponent.eGui.style.padding = '2px';
                    statusBarComponent.eGui.style.margin = '2px';


                    getOrderList(request).then(function (response) {
                        var rowsLoded = OrderList.length;
                        statusBarComponent.eGui.hidden = true;
                        if ($scope.DataObject.worklist.RuleID == -1
                            || ($scope.DataObject.worklist.WorklistType == 16 && $scope.DataObject.worklist.windowOpen)
                            || ($scope.DataObject.worklist.WorklistType == 21 && $scope.DataObject.worklist.windowOpen)
                            || $scope.DataObject.worklist.IsGlobal
                            || vm.viewMode
                            || $scope.DataObject.worklist.popUpWorklist) {
                            if (OrderList.length > 0) {
                                statusBarComponent.eGui.hidden = false;
                                statusBarComponent.eGui.textContent = 'Showing ' + rowsLoded + ' of ' + $scope.TotalRows + ' Total Records';
                                statusBarComponent.eGui.style.color = 'white';
                            }
                        }
                        if (showOnlyFiveStudies && OrderList.length > 0) {
                            statusBarComponent.eGui.hidden = false;
                            statusBarComponent.eGui.innerHTML = '<div style="color:#efefef;font-size:15px"><b>Message for PACS Status/Notification: STAT Priority Mode Active</b><br>Due to the high volume of STAT studies, outpatient/routine exams are temporarily hidden. Only STAT and urgent studies are displayed for immediate interpretation.</div>';
                        }
                        if (OrderList.length == 0) {
                            //$scope.DataObject.worklist.open = false;
                            var Status = GetStatus();
                            gridOptions.overlayNoRowsTemplate = vm.viewMode ? RuleNoDataTemplate : Status == 'RP' ? WorklistNoDataTemplate : RuleNoDataTemplate;
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            gridOptions.api.hideOverlay();
                        }


                        $scope.DataObject.worklist.loading = false;
                        vm.worklist.loading = $scope.DataObject.worklist.loading;

                        var anyRowsToExclude = _.filter(OrderList, function (order) { return order.exclude; });

                        var lastRow = OrderList.length === 0 ? 0 : (_.toInteger($scope.TotalRows) <= request.endRow ? _.toInteger($scope.TotalRows) : -1);
                        if (OrderList.length > 0 && $scope.DataObject.worklist.IsSmartWorklist) {
                            if ($scope.DataObject.masterData.selectedModalities && $scope.DataObject.masterData.selectedModalities.length > 0) {
                                lastRow = _.toInteger($scope.TotalRows);
                            } else {
                                lastRow = OrderList.length;
                            }
                        }
                        if (anyRowsToExclude.length) {
                            _.remove(OrderList, function (order) { return !order.exclude; });
                            _.remove(response, function (order) { return !order.exclude; });
                            //var excludeRows = _.remove(OrderList, function (order) { return !order.exclude; });
                            //_.each(excludeRows, function (erow) { removeFromAGGrid(erow); });
                            lastRow = _.toInteger(anyRowsToExclude.length) <= request.endRow ? _.toInteger(anyRowsToExclude.length) : -1;
                        }
                        if ($scope.DataObject
                            && $scope.DataObject.SingReport
                            && $scope.DataObject.SingReport.OrderList
                            && CurrentDictationOrder.length > 0) {
                            $scope.DataObject.SingReport.OrderList = _.clone(OrderList);
                        }
                        d.resolve({
                            success: true,
                            rows: response,
                            lastRow: lastRow,
                        });

                    }, function (error) {
                        toaster.error("Error fetching data for the " + vm.worklist.WorkListName + " Worklist!");
                        $scope.DataObject.worklist.loading = false;
                        vm.worklist.loading = $scope.DataObject.worklist.loading;
                        var rows = [];
                        if (OrderList.length == 0) {
                            $scope.DataObject.worklist.ResultPendingCount = 0;
                            $scope.DataObject.worklist.UnreadRVU = 0;
                            $scope.DataObject.worklist.STATCount = 0;
                            vm.worklist.ResultPendingCount = $scope.DataObject.worklist.ResultPendingCount;
                            vm.worklist.UnreadRVU = $scope.DataObject.worklist.UnreadRVU;
                            vm.worklist.STATCount = $scope.DataObject.worklist.STATCount;
                            $scope.TotalRows = 0;
                            var Status = GetStatus();
                            gridOptions.overlayNoRowsTemplate = vm.viewMode ? RuleNoDataTemplate : Status == 'RP' ? WorklistNoDataTemplate : RuleNoDataTemplate;
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            rows = OrderList.slice(request.startRow, request.endRow);
                            gridOptions.api.hideOverlay();
                        }
                        d.resolve({
                            success: true,
                            rows: rows,
                            lastRow: $scope.TotalRows,
                        });
                    }).catch(function (unexpectedError) {
                        // Safety net: if any unhandled exception occurs in then/error callbacks,
                        // ensure d always resolves so the AG Grid datasource doesn't hang indefinitely
                        $scope.DataObject.worklist.loading = false;
                        vm.worklist.loading = false;
                        d.resolve({ success: true, rows: [], lastRow: 0 });
                    });
                    return d.promise;
                },
            };
        }

        //#endregion (ag-grid function)

        //#endregion

        function getOrderList(request) {
            var d = $q.defer();


            $q.all([
                refresh()
            ]).then(function (data) {
                if (data && data.length > 0 && data[0]) {
                    if (data[0].length > 0) {
                        if (OrderListFilter.PageNum == 1) {
                            OrderList = _.uniqBy(data[0], 'OrderID');
                        } else {
                            _.pullAllBy(OrderList, data[0], 'OrderID');
                            var concatedOrderList = _.concat(OrderList, data[0]);

                            var uniqueOrderList = _.uniqBy(concatedOrderList, 'OrderID');
                            OrderList = uniqueOrderList;
                        }


                        EnableRowsForSelectedTenants = false;
                        var Status = GetStatus();
                        if (!vm.viewMode && Status == 'RP') {
                            if ($sessionStorage.EnableRowsForSelectedTenants
                                && $sessionStorage.EnableRowsForSelectedTenants.length > 0) {
                                var findStudyByPriorityNTenant = _.filter(OrderList, function (OrderItem) {
                                    var priority = (OrderItem.Priority || '').toUpperCase().trim();
                                    return (!(priority.includes('ROUTINE')
                                        || priority.includes('DELAYED'))
                                        && $sessionStorage.EnableRowsForSelectedTenants.split(',').includes(OrderItem.TenantName));
                                });
                                if (findStudyByPriorityNTenant.length > 0) {
                                    EnableRowsForSelectedTenants = true;
                                }
                            }
                        }


                        var Orders = _.uniqBy(data[0], 'OrderID');
                        d.resolve(Orders);
                    }
                    else {
                        OrderList = data[0];
                        d.resolve(data[0]);
                    }
                } else {
                    d.resolve([]);
                }

            }, function (err) {
                d.reject(err);
            });
            return d.promise;
        }
        function refresh() {
            var d = $q.defer();

            setFilter();
            clearColumnFilterList();

            if ($scope.DataObject.worklist.IsSmartWorklist
                && $scope.DataObject.masterData.selectedModalities
                && $scope.DataObject.masterData.selectedModalities.length > 0 
                && OrderListFilter.WorklistPageSize) {
                if (OrderListFilter.WorklistPageSize === "0") {
                    $scope.TotalRows = 0;
                    $scope.DataObject.worklist.loading = false;
                    vm.worklist.loading = false;
                    d.resolve([]);
                    return d.promise;
                } else {
                    var worklistPageSize = _.toInteger(OrderListFilter.WorklistPageSize);
                    var configuredPageSize = _.toInteger($scope.DataObject.worklist.PageSize);
                    var isTypeALazyLoad = $scope.DataObject.worklist.Type === 'A'
                        && configuredPageSize > 0
                        && worklistPageSize > configuredPageSize;

                    OrderListFilter.PageNum = isTypeALazyLoad ? OrderListFilter.PageNum : 1;
                    OrderListFilter.PageSize = worklistPageSize > 0
                        ? (isTypeALazyLoad ? configuredPageSize : worklistPageSize)
                        : OrderListFilter.PageSize;
                }
            }

            var promise;
            if ($scope.DataObject.worklist.Type == 'QS') {
                promise = WorklistService.GetOrdersListQuickFilter(OrderListFilter);
            } else if ($scope.DataObject.worklist.Type == 'S') {
                promise = WorklistService.GetOrderDetailsReadOnly(OrderListFilter);
            }
            else {
                promise = WorklistService.GetOrderDetails(OrderListFilter);
            }

            if (showOnlyFiveStudies) {
                OrderListFilter.PageNum = 1;
                OrderListFilter.PageSize = 5;
            }

            promise.then(function (result) {
                // Always update STAT, ResultPendingCount, and wRVU on every call
                $scope.DataObject.worklist.ResultPendingCount = result.orderCount ? result.orderCount.ResultPendingCount : $scope.DataObject.worklist.ResultPendingCount;
                $scope.DataObject.worklist.UnreadRVU = result.orderCount && result.orderCount.ResultPendingWorkRVUSum && result.orderCount.ResultPendingWorkRVUSum != null ? result.orderCount.ResultPendingWorkRVUSum : "0.00";
                $scope.DataObject.worklist.STATCount = result.orderCount ? result.orderCount.STATCount : $scope.DataObject.worklist.STATCount;
                vm.worklist.ResultPendingCount = $scope.DataObject.worklist.ResultPendingCount;
                vm.worklist.UnreadRVU = $scope.DataObject.worklist.UnreadRVU;
                vm.worklist.STATCount = $scope.DataObject.worklist.STATCount;
                vm.worklist.Groups = $scope.DataObject.worklist.Groups;

                if (result.orderCount && (!$scope.DataObject.worklist.IsSmartWorklist || OrderListFilter.ModalityID == "" || OrderListFilter.ModalityID == null)) {
                    // For smart worklist: assign modality counts on first call only to preserve UI bindings on subsequent calls
                    // For non-smart worklist: always assign modality counts (original behavior)
                    vm.worklist.AR = result.orderCount.AR;
                    vm.worklist.BD = result.orderCount.BD;
                    vm.worklist.BDUS = result.orderCount.BDUS;
                    vm.worklist.BMD = result.orderCount.BMD;
                    vm.worklist.CRDX = result.orderCount.CRDX;
                    vm.worklist.CT = result.orderCount.CT;
                    vm.worklist.DEXA = result.orderCount.DEXA;
                    vm.worklist.KO = result.orderCount.KO;
                    vm.worklist.MG = result.orderCount.MG;
                    vm.worklist.MR = result.orderCount.MR;
                    vm.worklist.NM = result.orderCount.NM;
                    vm.worklist.PT = result.orderCount.PT;
                    vm.worklist.RF = result.orderCount.RF;
                    vm.worklist.US = result.orderCount.US;
                    vm.worklist.XA = result.orderCount.XA;

                    localModalityCounts = _.clone(result.orderCount);
                }
                //vm.worklist.IsSmartWorklist = $scope.DataObject.worklist.IsSmartWorklist;
                //vm.worklist.WorklistPageSize = $scope.DataObject.worklist.WorklistPageSize;

                vm.updateProps();

                var TotalRows = $scope.TotalRows;
                //OrderList = result.Orders;
                if (result.orderLists && result.orderLists.length > 0) {
                    TotalRows = result.orderLists[0].TotalRows ? _.toInteger(result.orderLists[0].TotalRows) : result.orderLists.length;
                } else {
                    TotalRows = 0;
                }
                $scope.TotalRows = (showOnlyFiveStudies) ? result.orderLists.length : (($scope.DataObject.worklist.IsSmartWorklist && OrderListFilter.WorklistPageSize != "0") ? _.toInteger(OrderListFilter.WorklistPageSize) : TotalRows);
                //if ($scope.TotalRows == 0) {
                //    $scope.DataObject.worklist.open = false;
                //}


                updateOrders(result.orderLists);

                var Status = GetStatus();
                var Orders = result.orderLists;
                var SpecialTenantUsersSTATStudiesSchedule = ValidateSpecialTenantUsersSTATStudiesSchedule();
                if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.OnlyUserAccess
                    && SpecialTenantUsersSTATStudiesSchedule
                    && (validateSpecialTenant()
                        || $scope.DataObject.worklist.RuleID == 'PSW')
                    && Status == 'RP') {
                    //var CurrentRows = result.orderLists.length;
                    //var OnlySTATOrders = filterBySpecialClass(result.orderLists);
                    //if (OnlySTATOrders.length > 0) {
                    //    Orders = OnlySTATOrders;
                    //    var SpecialRows = CurrentRows - Orders.length;
                    //    $scope.TotalRows = $scope.TotalRows - SpecialRows;
                    //}
                    filterBySpecialClass(result.orderLists);
                }


                d.resolve(Orders);


            }).catch(function (err) {
                $scope.DataObject.worklist.loading = false;
                d.reject(err);
            });

            return d.promise;
        };

        function updateOrders(Orders) {
            _.each(Orders, function (order) {
                order.ID = new Date().getTime() + Math.random().toString(16).slice(2);
                //order.subGridOptions = subUIGridOptions;
                //order.ComparisonOrder = [];

                //order.$$treeLevel = 1;

                updateOrderAssign(order);
                //order.row = row + 1;

                //row++;

            });

            return Orders;
        }
        function updateOrderAssign(order) {
            var d = $q.defer();
            if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) {
                var orderAssignmentIndex = _.findIndex(order.listOrderListAssignment, function (assignment) { return assignment.OrderAssingedUserID == $sessionStorage.currentUserData.userId; });

                order.OrderAssingedUserID = (order.listOrderListAssignment && order.listOrderListAssignment.length > 0 ? order.listOrderListAssignment[0].OrderAssingedUserID : null);
                //order.OrderAssingedUserName = $scope.getOrderListTooltip(order);
                order.OrderAssingedUsers = (order.listOrderListAssignment ? order.listOrderListAssignment.length : 0);

                order.OrderAssingedUser = (orderAssignmentIndex != -1 ? $sessionStorage.currentUserData.userId : null);
            }
            d.resolve(order);
            return d.promise;
        }
        function GetOrdersComparisonList(OrderID) {
            var d = $q.defer();
            var orderComparisonListFilter = {
                UserID: $sessionStorage.currentUserData.userId,
                OrderID: OrderID
            };
            WorklistService.GetOrdersComparisonList(orderComparisonListFilter).then(function (result) {
                if (result.length > 0) {
                    d.resolve(result);
                }
            });
            return d.promise;
        }
        function sorting(sortColumns) {
            SortingByMultiColumn = '';
            _.each(sortColumns, function (col) {
                if (!col.colId) {
                    col.colId = col.field;
                    col.sort = col.sort.direction;
                }
                getSortingString(col.colId, col.sort);
            });
            SortingByMultiColumn = SortingByMultiColumn.substring(0, SortingByMultiColumn.lastIndexOf(','));
        }
        function getSortingString(sColumnField, direction) {
            var orderByField = '';
            switch (sColumnField) {
                case "Location":
                    orderByField = "L.Location";
                    break;
                case "Accession":
                    orderByField = "O.Accession";
                    break;
                case "OrderDate":
                    orderByField = "O.OrderDate";
                    break;
                case "PatientMRN":
                    orderByField = "O.PatientMRN";
                    break;
                case "PatientName":
                    orderByField = "O.PatientLastName|O.PatientFirstName";
                    break;
                case "FormattedPatientDOB":
                    orderByField = "O.PatientDOB";
                    break;
                case "PatientGender":
                    orderByField = "O.PatientGender";
                    break;
                case "PatientAge":
                    orderByField = "O.PatientDOB";
                    break;
                case "PatientClass":
                    orderByField = "O.PatientClass";
                    break;
                case "Modality":
                    orderByField = "O.Modality";
                    break;
                case "ProcedureDesc":
                    orderByField = "O.ProcedureDesc";
                    break;
                case "OrderingPhysician":
                    orderByField = "P.Name";
                    break;
                case "CreatedDate":
                case "ReceivedSince":
                    orderByField = DefaultSortingColumn;
                    break;
                case "SLA":
                    orderByField = "TAT";
                    break;
                case "Reason":
                    orderByField = "O.Reason";
                    break;
                case "ReportSignDate":
                    orderByField = "R1.SignDate";
                    break;
                default:
                    orderByField = sColumnField;
                    break;
            }

            if (orderByField.indexOf('|') > 0) {
                var fields = orderByField.split('|');
                _.each(fields, function (field) {
                    SortingByMultiColumn += field + ' ' + direction + ', ';
                });
            } else {
                SortingByMultiColumn += orderByField + ' ' + direction + ', ';
            }
        }
        function openShareExamWindow(SelectedOrder) {
            setSelected(SelectedOrder.OrderID, SelectedOrder);
            $scope.SelectedOrderShareExam = _.clone($scope.SelectedOrder);
            $scope.currentWindow = 'win_shareExamsWindow';
            OpenWindow($scope.win_shareExamsWindow, 'win_shareExamsWindow');
            $scope.win_shareExamsWindow.wrapper.prev(".k-overlay").addClass("custom-overlay");
        }

        $scope.onCloseShareExamWindowHandler = function (newCheck) {
            $scope.isShareExamWindowVisible = newCheck;
            if ($scope.isShareExamWindowVisible == true) {
                $scope.win_shareExamsWindow.close();
            }
        };
        function OpenWindow(win, key) {
            if (win) {
                win.open();
                var timeout = $timeout(function () {
                    win.center();
                }, 100);
                TimeoutList.push(timeout);
            } else {
                var dialog = $("div[kendo-window='" + key + "']").data("kendoWindow");
                if (dialog) {
                    dialog.open();
                    var timeout = $timeout(function () {
                        dialog.center();
                    }, 100);
                    TimeoutList.push(timeout);
                }
            }

        }
        function setSelected(SelectedOrderID, SelectedOrder) {
            //console.log("setSelected > SelectedOrderID: ", SelectedOrderID);
            $rootScope.$broadcast('event.worklist', { EventType: 'Deselect', ID: $scope.DataObject.index });
            $scope.SelectedOrderID = SelectedOrderID;
            $scope.SelectedOrder = _.clone(SelectedOrder);
            $scope.SelectedOrder.ShowContactBtn = true;
            $scope.SelectedOrder.ExamTagKey = $scope.SelectedOrder.ExamTag && $scope.SelectedOrder.ExamTag != "0" ? _.find($scope.DataObject.masterData.ExamTags, { 'Value': $scope.SelectedOrder.ExamTag }).Key : $scope.SelectedOrder.ExamTagKey
            if ($scope.SelectedOrder.RadExamTag && $scope.SelectedOrder.RadExamTag != "0") {
                $scope.SelectedOrder.RadExamTagKeys = [];
                var SplitExamTags = ($scope.SelectedOrder.RadExamTag && $scope.SelectedOrder.RadExamTag.includes(',') ? $scope.SelectedOrder.RadExamTag.split(',') : $scope.SelectedOrder.RadExamTag);
                _.each(SplitExamTags, function (ExamTag) {
                    var obj = _.find($scope.DataObject.masterData.RadExamTag, { Value: ExamTag });

                    if (obj) {
                        $scope.SelectedOrder.RadExamTagKeys.push(obj.Key);
                    }
                });
            }
            else {
                $scope.SelectedOrder.RadExamTagKeys = $scope.SelectedOrder.RadExamTagKeys;
            }
            if ($scope.SelectedOrder && $scope.SelectedOrder.ReportSignDate) {
                $scope.SelectedOrder.ReportSignDate = moment(
                    ($filter('localDate')($scope.SelectedOrder.ReportSignDate, false, new Date()))
                ).format("MM/DD/YYYY");
            }
            if ($scope.SelectedOrder && $scope.SelectedOrder.PatientDOB) {
                $scope.SelectedOrder.PatientDOB = changeDateFormat($scope.SelectedOrder.PatientDOB);
            }
            if ($scope.SelectedOrder && $scope.SelectedOrder.Status) {
                $scope.SelectedOrder.OrderStatus = _.find($scope.DataObject.masterData.OrderStatus, { 'key': $scope.SelectedOrder.Status }).value;
            }
            $scope.SelectedOrder.OrderDate = $filter('localDate')(SelectedOrder.OrderDate, false, new Date());
            $scope.SelectedOrder.ReceivedSince = $filter('localDate')(SelectedOrder.CreatedDate, true, new Date());
            vm.selectedData.SelectedOrder = $scope.SelectedOrder;
            $scope.SelectedComPatisomOrderID = "";
            //js for discussion pop wondow to show message box when keypad comes up
            if (angular.element(window).width() < 768) {
                var timeout = $timeout(function () {
                    angular.element('.discus-comment .txt-area').focusin(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').addClass('mobscreen-scroll');
                            var timeout1 = $timeout(function () {
                                angular.element('.denial-window.mobscreen-scroll').animate({ scrollTop: $(document).height() }, "fast");
                            }, 100);
                            TimeoutList.push(timeout1);
                        }
                    });
                    angular.element('.discus-comment .txt-area').focusout(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').removeClass('mobscreen-scroll');
                        }
                    });
                }, 500);
                TimeoutList.push(timeout);
            }
        };

        //#region Context Menu
        function openContextMenuOptions(params) {
            contextMenus = [];
            if (params.node) {
                params.node.setSelected(true);
                var Order = (gridOptions.api.getSelectedRows())[0];
                var isContextMenuVisible = NoContextMenuOptions(Order);
                if ((isContextMenuVisible && params.column) || params.node.showSecondMenu) {
                    params.node.showSecondMenu = false;
                    if (params.column.colId == "Optional Image viewer" && params.node.data.eventType == "cellClicked") {
                        params.node.data.eventType = "";
                        imageViewerOptions(params.node.data, contextMenus);
                    }
                    else if (params.column.colId == "OrderingPhysician" && params.node.data.eventType == "cellClicked") {
                        params.node.data.eventType = "";
                        if (!vm.viewMode) {
                            if ((!params.node.data.OrderingPhysicianPhone || params.node.data.OrderingPhysicianPhone == "") && (!params.node.data.OrderingPhysicianCellPhone || params.node.data.OrderingPhysicianCellPhone == "")) {
                                contextMenus.push(
                                    {
                                        name: 'Search Contact',
                                        action: function () {
                                            $scope.showContact(params.node.data.OrderingPhysician, params.node.data.LocationID, params.node.data.Location);
                                        },
                                        icon: "<i class='fa fa-search fs-18px'></i>"
                                    });
                            }
                            else {
                                var contactDetail = params.node.data.OrderingPhysician + (params.node.data.OrderingPhysicianPhone ? ("<br>" + "Contact : " + params.node.data.OrderingPhysicianPhone) : "") + (params.node.data.OrderingPhysicianCellPhone ? ("<br>" + "Cell Phone : " + params.node.data.OrderingPhysicianCellPhone) : "");
                                contextMenus.push(
                                    {
                                        name: contactDetail,
                                        action: function () {
                                        }
                                    });
                            }
                        }
                    }
                    else if (params.column.colId == "PatientClass" && params.node.data.eventType == "cellClicked") {
                        params.node.data.eventType = "";
                        if (params.node.data.TypeContactMessage && params.node.data.TypeContactMessage.length > 0) {
                            contextMenus.push(
                                {
                                    name: params.node.data.TypeContactMessage,
                                    action: function () {
                                    }
                                });
                        }

                    }
                    else if (params.column.colId == "Location" && params.node.data.eventType == "cellClicked") {
                        params.node.data.eventType = "";
                        if (!vm.viewMode) {
                            contextMenus.push(
                                {
                                    name: 'View Contact',
                                    action: function () {
                                        $scope.showLocationContact(params.node.data.LocationID, params.node.data.Location);
                                    },
                                    icon: "<i class='fa fa-search fs-18px'></i>"
                                });
                        }
                    }
                    else if (params.column.colId == "PatientName" && params.node.data.eventType == "cellClicked") {
                        params.node.data.eventType = "";
                        if (!vm.viewMode) {
                            if (params.node.data.PatientPhone && params.node.data.PatientPhone != "") {

                                var patientContactDetail = params.node.data.PatientName + ("<br>" + "Phone : " + params.node.data.PatientPhone);
                                contextMenus.push(
                                    {
                                        name: patientContactDetail,
                                        action: function () {
                                        }
                                    });
                            }
                        }
                    }
                    else {
                        getContextMenuItems(params, contextMenus, Order);
                    }

                }
            }
            return contextMenus;
        }
        function imageViewerOptions(order, contextMenus) {
            if (order.OptionalDicomViewer && order.OptionalDicomViewer != '') {
                var DicomViewerList = order.OptionalDicomViewer.split(',');
                var DV = "";
                //DicomViewerList = DicomViewerList.sort();

                DicomViewerList.sort(
                    function (a, b) {
                        if (a.toLowerCase() < b.toLowerCase()) return -1;
                        if (a.toLowerCase() > b.toLowerCase()) return 1;
                        return 0;
                    }
                );

                _.each(DicomViewerList, function (viewer) {
                    //DV = (viewer == "GE Centricity") ? "GECUV" : viewer;                
                    contextMenus.push(
                        {
                            name: $scope.SetDicomViewerText(viewer),
                            action: function () {
                                $scope.OpenSynapseStudy(order, viewer, false)
                            }
                        });
                    contextMenus.push('separator');
                });
            }
            contextMenus.pop();
        }
        // Task 173042 - the 'Unassign'/'Reassign', 'Unassign User(s)' and 'Unlock Study' context menu
        // options are restricted to the Admin and SuperAdmin roles. Radiologists sign in under the
        // 'User' role, so gating on Admin/SuperAdmin is what removes these options for them, and for
        // Technologist and Physician. 'Assign to Me' is deliberately NOT gated - every role keeps it.
        // Those three options are HIDDEN for the roles that may not use them. The one exception is the
        // 'Assign to:' control in the Open Discussion window, which stays visible and usable for every
        // role and instead prompts on Save - see $scope.SaveDiscussion.
        // userRoles is an array built from resp.data.userRoles.split(',') at login and can be missing,
        // so both currentUserData and userRoles are null-guarded here.
        function isAdminOrSuperAdminUser() {
            return !!($sessionStorage.currentUserData
                && $sessionStorage.currentUserData.userRoles
                && ($sessionStorage.currentUserData.userRoles.includes("SuperAdmin")
                    || $sessionStorage.currentUserData.userRoles.includes("Admin")));
        }
        function getContextMenuItems(params, contextMenus, Order) {
            var cellValue;
            var focusedCell;
            var row;
            var subMenu = [];
            var SelectedRows = gridOptions.api.getSelectedRows();

            var index = _.findIndex(OrderList, function (lOrder) { return lOrder.OrderID == Order.OrderID; });
            $scope.contextmenuRowIndex = index;

            $scope.isAssignedCurrentUser = false;
            if (Order.OrderAssingedUser == vm.selectedData.LoggedInUserID) {
                $scope.isAssignedCurrentUser = true;
            }
            //#region get cell value logic starts
            focusedCell = gridOptions.api.getFocusedCell();
            row = gridOptions.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
            if (focusedCell) {
                cellValue = gridOptions.api.getValue(focusedCell.column, row);
            }
            //#endregion get cell value logic ends

            if (((!$scope.DataObject.worklist.WorklistType || $scope.DataObject.worklist.WorklistType == 21 || $scope.DataObject.worklist.WorklistType == 11 || $scope.DataObject.worklist.WorklistType == 31 || $scope.DataObject.worklist.WorklistType == 51) && gridOptions.api.getSelectedRows().length <= 1) || ($scope.DataObject.worklist.WorklistType
                && $scope.DataObject.worklist.WorklistType == 16 && gridOptions.api.getSelectedRows().length == 1)) {

                if (HideAssignmentForStatus.indexOf(Order.Status) !== -1 || Order.IsLock || (Order.OrderAssingedUsers > 0 && !Order.OrderAssingedUser)) {
                    $scope.assignMenuVisible = false;
                }
                else {
                    //#region Assignment Menu
                    // Task 173042 - 'Unassign'/'Reassign' is Admin/SuperAdmin only. The separator is
                    // pushed inside each branch instead of unconditionally afterwards: a user without
                    // the role who is holding their own assigned study matches neither branch, and an
                    // unconditional push would put a stray divider at the top of the menu.
                    if ($scope.isAssignedCurrentUser) {
                        if (isAdminOrSuperAdminUser()) {
                            contextMenus.push({
                                name: Order.Status === 'PA' ? 'Reassign' : 'Unassign',
                                action: function () {
                                    if (Order.Status === 'PA') {
                                        setSelected(Order.OrderID, Order);
                                        GetAllUsers($scope.SelectedOrder.SiteID).then(function () {
                                            $scope.DataObject.AddendumRequest.AssignedUser = _.find($scope.DataObject.masterData.Radiologists, { Id: $scope.SelectedOrder.SignBy });
                                            $scope.onAddendumUserSelect();
                                            $scope.currentWindow = 'win_addendum_request';
                                            OpenWindow($scope.win_addendum_request, 'win_addendum_request');
                                            $scope.win_addendum_request.wrapper.prev(".k-overlay").addClass("custom-overlay");
                                        });
                                    } else {
                                        unAssignToMe(Order);
                                    }
                                }
                            });
                            contextMenus.push('separator');
                        }
                    } else {
                        contextMenus.push({
                            name: 'Assign to Me',
                            action: function () {
                                assignToMe(Order);
                            }
                        });
                        contextMenus.push('separator');
                    }
                    //$scope.contextMenus.push($scope.isAssignedCurrentUser ? 'Unassign' : 'Assign to Me');
                }
                // Task 173042 - 'Unassign User(s)' keeps its original SuperAdmin-or-Admin audience; it is
                // routed through the shared helper so all of these options are gated in one place.
                if (isAdminOrSuperAdminUser()) {
                    if (!$scope.isAssignedCurrentUser && Order.listOrderListAssignment && Order.listOrderListAssignment.length > 0) {
                        contextMenus.push({
                            name: 'Unassign User(s)',
                            action: function () {
                                unAssignToMe(Order);
                            }
                        });
                        contextMenus.push('separator');
                    }
                }
                //#endregion Assignment Menu
                switch (Order.Status) {
                    //#region Remove from Comparison
                    case 'CO':
                        contextMenus.push({
                            name: 'Remove from Comparison',
                            action: function () {
                                $scope.removeComparedStudy(Order.OrderID);
                            }
                        });
                        contextMenus.push('separator');
                        break;
                    //#endregion Remove from Comparison

                    //#region Unhide Study
                    case 'H':
                        contextMenus.push({
                            name: 'Unhide Study',
                            action: function () {
                                HideOrder();
                            }
                        });
                        contextMenus.push('separator');
                        break;
                    //#endregion Unhide Study

                    case "PA":
                        if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles &&
                            ($sessionStorage.currentUserData.userRoles.includes("SuperAdmin") || $sessionStorage.currentUserData.userRoles.includes("Admin"))) {
                            contextMenus.push({
                                name: 'Mark as Completed',
                                action: function () {
                                    UpdateOrderReportStatus(Order, "1").then(function () {
                                        toaster.success("Order marked as completed");
                                        removeOrderFromList(Order.OrderID);
                                        if (!showOnlyFiveStudies) {
                                            statusBarComponent.eGui.textContent = 'Showing ' + OrderList.length + ' of ' + $scope.TotalRows + ' Total Records';
                                            statusBarComponent.eGui.style.color = 'white';
                                        }
                                    });
                                }
                            });
                            contextMenus.push('separator');
                        }
                        break;
                }

                if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles && ($sessionStorage.currentUserData.userRoles.includes("SuperAdmin") || $sessionStorage.currentUserData.userRoles.includes("Admin"))) {
                    if (Order.IsHighPriority && (!Order.IsSTATStroke && !Order.IsSTATTrauma)) {
                        contextMenus.push({
                            name: 'Remove From High Priority',
                            action: function () {
                                var obj = {
                                    OrderID: Order.OrderID,
                                    UserID: $sessionStorage.currentUserData.userId,
                                    DicomOrderID: Order.DicomOrderID,
                                    IsHighPriorityRemove: true
                                }
                                UpdateOrderDetail(obj, "Order removed from high priority");
                                Order.IsHighPriority = false;
                                Order.Priority = Order.Priority.replaceAll("(HIGH)", "");
                                updateAGGridOrder(Order);
                            }
                        });
                        contextMenus.push('separator');
                    }
                }

                if (($scope.DataObject.EnableRowsForSelectedTenants && $scope.DataObject.EnableRowsForSelectedTenants.includes(Order.TenantName))
                    ? $sessionStorage.currentUserData && !$sessionStorage.currentUserData.RemoveRenderingPhysician : true) {
                    contextMenus.push({
                        name: 'View Event',
                        action: function () {
                            openEventLog();
                        }
                    });
                    contextMenus.push('separator');
                }
                contextMenus.push({
                    name: 'View Contact Details',
                    action: function () {
                        $scope.showLocationContact(params.node.data.LocationID, params.node.data.Location);
                    }
                });
                contextMenus.push('separator');

                // Task 173042 - 'Unlock Study' force-clears another user's lock, Admin/SuperAdmin only.
                if (Order.IsLock && isAdminOrSuperAdminUser()) {
                    contextMenus.push({
                        name: 'Unlock Study',
                        action: function () {
                            swal({
                                title: 'Do you want to Unlock the Study?',
                                type: "warning",
                                html: true,
                                customClass: 'swal-wide',
                                showCancelButton: true,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "Yes",
                                cancelButtonText: "No",
                            },
                                function (isConfirm) {
                                    if (isConfirm) {
                                        DeleteOpenOrder(Order, true);
                                    }
                                });
                        }
                    });
                    contextMenus.push('separator');
                }
                if (Order.DicomViewer) {
                    contextMenus.push({
                        name: 'Share Exam',
                        action: function () {
                            openShareExamWindow(Order);
                        }
                    });
                }
                // Task 173042 - 'Unlock Study' above is now hidden for non-SuperAdmins and
                // 'Share Exam' is conditional on Order.DicomViewer, so on a locked row with no
                // DICOM viewer this would follow the separator pushed after 'View Contact Details'
                // and render two adjacent dividers. Only add one if the last entry is not already
                // a separator.
                if (contextMenus[contextMenus.length - 1] !== 'separator') {
                    contextMenus.push('separator');
                }
                contextMenus.push({
                    name: 'Consult with Physician',
                    action: function () {
                        $scope.CallInConsult(Order);
                    }
                });
                contextMenus.push('separator');
            }
            //#region Clipboard
            if (Order.Status != 'C') {
                var SelectedRowsForClipboard = [];
                if (SelectedRows && SelectedRows.length > 0 && $sessionStorage.ClipboardToBeRemovedForTenants) {
                    SelectedRowsForClipboard = _.filter(SelectedRows, function (row) {
                        return !$sessionStorage.ClipboardToBeRemovedForTenants.includes(row.TenantName);
                    });
                }
                if ($scope.DataObject.worklist.WorklistType != 16) {
                    var index = _.findIndex(SelectedRowsForClipboard, function (order) { return order.IsInClipboard == 0; });
                    if (SelectedRowsForClipboard && SelectedRowsForClipboard.length > 0) {
                        if (index != -1) {
                            if (!ClipboardRequestInProgress) {
                                contextMenus.push({
                                    name: 'Add to Clipboard',
                                    action: function () {
                                        setMultipleSelection(SelectedRowsForClipboard);
                                        onAddToClipboard("Add");
                                    }
                                });
                            } else {
                                contextMenus.push({
                                    name: 'Add to Clipboard',
                                    action: function () {
                                        setMultipleSelection(SelectedRowsForClipboard);
                                        onAddToClipboard("Add");
                                    },
                                    disabled: true,
                                    icon: '<img src= \'https://i.gifer.com/ZKZx.gif\' style=\'height:20px;width:20px\'></img>'
                                });
                            }
                            contextMenus.push('separator');
                        }
                        else if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles && ($sessionStorage.currentUserData.userRoles.includes("SuperAdmin") || $sessionStorage.currentUserData.userRoles.includes("Admin"))) {
                            contextMenus.push({
                                name: 'Remove From Clipboard',
                                action: function () {
                                    RemoveMultipleFromClipboard(SelectedRowsForClipboard);
                                }
                            });
                            contextMenus.push('separator');
                        }
                        
                    }

                }
                else {
                    contextMenus.push({
                        name: 'Remove From Clipboard',
                        action: function () {
                            setMultipleSelection(SelectedRowsForClipboard);
                            onRemoveFromClipboard();
                        }
                    });
                    contextMenus.push('separator');
                }
            }
            //#endregion Clipboard

            //#region Peer review
            if (SelectedRows && SelectedRows.length > 0) {
                var completedStudies = _.filter(SelectedRows, function (order) { return order.Status == "C" && !order.IsReviewAssigned });
                if (completedStudies && completedStudies.length == 1) {
                    var orderIds = [];
                    subMenu.push({
                        name: 'Assign to Me',
                        action: function () {
                            AddToPeerReview('Assign to Me', Order);
                        }
                    });
                    subMenu.push('separator');
                    subMenu.push({
                        name: 'Auto Assign',
                        action: function () {
                            AddToPeerReview('Auto Assign', Order);
                        }
                    });
                    subMenu.push('separator');
                    subMenu.push({
                        name: 'Assign to Specific User',
                        action: function () {
                            AddToPeerReview('Assign to Specific User', Order);
                        }
                    });

                    contextMenus.push({
                        name: 'Add to Peer Review',
                        subMenu: subMenu,
                    });
                    contextMenus.push('separator');
                    subMenu = [];
                }
            }
            //#endregion Peer review

            //#region Exam Tags
            if (SelectedRows && SelectedRows.length == 1) {
                if ((Order.RadExamTag != null && Order.RadExamTag != "0") || (Order.ExamTag != null && Order.ExamTag != "0")) {
                    contextMenus.push(
                        {
                            name: 'Remove All Tags',
                            action: function () {
                                var obj = {
                                    OrderID: Order.OrderID,
                                    RadExamTag: '0',
                                    ExamTag: '0',
                                    UserID: $sessionStorage.currentUserData.userId,
                                };
                                NotifyUpdateOrderDetail({ OrderDetail: obj });
                                UpdateOrderDetail(obj, "All tags removed successfully!");
                            },
                        });
                    contextMenus.push('separator');
                }
                var AllRadExamTags = $scope.DataObject.masterData.RadExamTag;
                if ((Order.RadExamTag != null && Order.RadExamTag != "0")) {
                    AllRadExamTags = _.filter($scope.DataObject.masterData.RadExamTag, function (RadExamTag) { return Order.RadExamTag && Order.RadExamTag.includes(',') ? !Order.RadExamTag.split(',').includes(RadExamTag.Value) : RadExamTag.Value != Order.RadExamTag });
                }
                _.each(AllRadExamTags, function (radExamTag, index) {
                    subMenu.push(
                        {
                            name: radExamTag.Key,
                            action: function () {
                                var obj = {
                                    OrderID: Order.OrderID,
                                    RadExamTag: (Order.RadExamTag != null && Order.RadExamTag != "0") ? Order.RadExamTag += "," + radExamTag.Value : radExamTag.Value,
                                    UserID: $sessionStorage.currentUserData.userId,
                                };
                                NotifyUpdateOrderDetail({ OrderDetail: obj });
                                UpdateOrderDetail(obj, "New tag added successfully!");
                            },
                        });
                    if ((AllRadExamTags.length - 1) != index) {
                        subMenu.push('separator');
                    }
                });

                if (subMenu.length > 0) {
                    contextMenus.push({
                        name: 'Add Tag',
                        subMenu: subMenu,
                    });
                    contextMenus.push('separator');
                }

                subMenu = [];
            }
            //#endregion Exam Tags

            //#region Export
            var columnsToExport = ['Location', 'Accession', 'OrderDate', 'PatientMRN', 'PatientName', 'FormattedPatientDOB', 'PatientGender', 'PatientAge', 'PatientClass', 'Modality', 'ProcedureDesc', 'OrderingPhysician', 'CreatedDate', 'ReceivedSince', 'SignByName', 'ReportSignDate', 'Reason', 'SLA', 'ImageInstance', 'Priority', 'WorkRVU', 'ExamTag'];


            var hideRederingPhy = _.find(SelectedRows, function (orderRow) {
                return (($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician &&
                    ($scope.DataObject.EnableRowsForSelectedTenants && $scope.DataObject.EnableRowsForSelectedTenants.includes(orderRow.TenantName))))
            });

            if (hideRederingPhy) {
                _.remove(columnsToExport, function (val) { return (val == "SignByName") });
            }
            subMenu.push({
                name: 'Export CSV',
                action: function () {
                    gridOptions.api.exportDataAsCsv({
                        allColumns: false,
                        columnKeys: columnsToExport,
                        onlySelected: true,
                    });
                },
                icon: '<i class="ag-icon ag-icon-csv"></i>'
            });
            subMenu.push('separator');
            subMenu.push({
                name: 'Export Excel',
                action: function () {
                    gridOptions.api.exportDataAsExcel({
                        allColumns: false,
                        columnKeys: columnsToExport,
                        onlySelected: true,
                    });
                },
                icon: '<i class="fa fa-file-excel-o fs-14px pl-2px"></i>'
            });
            subMenu.push('separator');
            subMenu.push({
                name: 'Export Worklist',
                action: function () {
                    ExportWorklistData(hideRederingPhy);
                },
                icon: '<i class="fa fa-download fs-14px pl-2px"></i>'
            });
            contextMenus.push(
                {
                    name: 'Export',
                    subMenu: subMenu
                });
            contextMenus.push('separator');
            //#endregion Export

            //#region F11 and F12 and Query Retrieve shortcut
            subMenu = [];
            if (SelectedRows && SelectedRows.length == 1) {
                if ($sessionStorage.IsQueryRetrieveVisible && Order.Status != 'C' && $sessionStorage.currentUserData && ($sessionStorage.currentUserData.userRoles && ($sessionStorage.currentUserData.userRoles.includes("Admin") || $sessionStorage.currentUserData.userRoles.includes("User"))) && Order.IsQREnable) {
                    contextMenus.push(
                        {
                            name: 'Query Retrieve',
                            action: function () {
                                $scope.QueryRetrieve(Order, true);
                            }
                        });
                    contextMenus.push('separator');
                }
                contextMenus.push(
                    {
                        name: 'Open Discussion (F11)',
                        action: function () {
                            HelpOrder();
                        }
                    });
                contextMenus.push('separator');
                if ((Order.Status == 'RP')) {
                    _.each(_.sortBy($scope.DataObject.HiddenTypeList, ['Key']), function (type, index) {
                        subMenu.push({
                            name: type.Key,
                            action: function () {
                                $scope.DataObject.HideOption.Key = type.Key;
                                $scope.HideStudy("");
                            },
                        });
                        if (($scope.DataObject.HiddenTypeList.length - 1) != index) {
                            subMenu.push('separator');
                        }
                    });
                    contextMenus.push(
                        {
                            name: 'Hide Study (F12)',
                            cssClasses: ["text-white", "cursor-pointer"],
                            action: function () {
                                HideOrder();
                            },
                            subMenu: subMenu,
                        });
                    contextMenus.push('separator');
                }
            }
            //#endregion F11 and F12 shortcut

            //#region Addendum Request
            if (SelectedRows.length == 1 && Order.Status == "C" && $sessionStorage.IsAddendumRequestVisible) {
                contextMenus.push({
                    name: 'Addendum Request',
                    action: function () {
                        setSelected(Order.OrderID, Order);
                        GetAllUsers($scope.SelectedOrder.SiteID).then(function () {
                            $scope.DataObject.AddendumRequest.AssignedUser = _.find($scope.DataObject.masterData.Radiologists, { Id: $scope.SelectedOrder.SignBy });
                            $scope.onAddendumUserSelect();
                            $scope.currentWindow = 'win_addendum_request';
                            OpenWindow($scope.win_addendum_request, 'win_addendum_request');
                            $scope.win_addendum_request.wrapper.prev(".k-overlay").addClass("custom-overlay");
                        });
                    }
                });
                contextMenus.push('separator');
            }
            //#endregion Addendum Request

            //#region Copy order data
            subMenu = [];
            subMenu.push(
                {
                    name: 'Copy Cell Value',
                    action: function () {
                        navigator.clipboard.writeText(cellValue);
                    },
                    icon: "<i class='ag-icon ag-icon-copy'></i>",
                });
            subMenu.push('separator');
            subMenu.push('copy');
            subMenu.push('separator');
            subMenu.push('copyWithHeaders');
            contextMenus.push({
                name: 'Copy',
                subMenu: subMenu
            });
            //#endregion Copy order data

            if (contextMenus.length > 0) {
                $scope.isContextMenuVisible = true;
            }
            //$scope.clearSelectedChildRows();

            $scope.assignMenuVisible = true;
        }
        function expandedOpenContextMenuOptions(params) {
            var contextMenus = [];
            var Order = params.node.data;
            var subMenu = [];
            contextMenus.push({
                name: 'Remove from Comparison',
                action: function () {
                    if (Order) {
                        RemoveFromComparison(Order.OrderID, Order.Orders);
                    }
                }
            });

            if (Order && Order.Status == "C" && !Order.IsReviewAssigned) {
                subMenu.push({
                    name: 'Assign to Me',
                    action: function () {
                        AddToPeerReview('Assign to Me', Order);
                    }
                });
                subMenu.push('separator');
                subMenu.push({
                    name: 'Auto Assign',
                    action: function () {
                        AddToPeerReview('Auto Assign', Order);
                    }
                });
                subMenu.push('separator');
                subMenu.push({
                    name: 'Assign to Specific User',
                    action: function () {
                        AddToPeerReview('Assign to Specific User', Order);
                    }
                });
                contextMenus.push('separator');
                contextMenus.push({
                    name: 'Add to Peer Review',
                    subMenu: subMenu,
                });

                subMenu = [];
            }
            return contextMenus;
        }
        //#endregion
        function setUserIconCase(row) {
            var iconCase = '';
            if (row.data.IsLock && (vm.selectedData.LoggedInUserID != row.data.LockByProviderID)) {
                iconCase = 'Lock';
            }
            else if (row.data.IsSTATStroke) {
                iconCase = 'IsSTATStroke';
            }
            else if (row.data.IsSTATTrauma) {
                iconCase = 'IsSTATTrauma';
            }
            else if (row.data.OrderAssingedUsers > 0) {
                iconCase = 'Assignment';
                if (row.data.IsInClipboard == 2) {
                    iconCase = 'AssignmentMyClipboard';
                } else if (row.data.IsInClipboard == 1) {
                    iconCase = 'AssignmentOtherClipboard';
                }
            }
            else if (row.data.IsInClipboard == 1) {
                iconCase = 'CopiedtoOtherClipboard';

            } else if (row.data.IsInClipboard == 2) {
                iconCase = 'CopiedtoMyClipboard';
            }
            else if (row.data.ProcessError) {
                iconCase = 'NA';
            }
            else {
                iconCase = 'empty';
            }
            return iconCase;
        }
        function openEventLog() {
            $scope.currentWindow = 'win_OrderEventLog';
            $scope.win_OrderEventLog.open();
            $scope.win_OrderEventLog.wrapper.prev(".k-overlay").addClass("custom-overlay");
            var timeout = $timeout(function () {
                $scope.win_OrderEventLog.center();

                $timeout.cancel(timeout);
                timeout = null;
            }, 100);
        };

        //Repot pop up resize
        $scope.winDragend = function (e) {
            adjustSize();
        }
        $scope.winResize = function (e) {
            adjustSize();
            if ($scope.currentWindow == 'win_LocationContact') {
                $scope.DataObject.addressBookGridHeight = ((e.height - 100) + "px");
            }
        }

        function adjustSize() {
            // For small screens, maximize the window when it is shown.
            // You can also make the check again in $(window).resize if you want to
            // but you will have to change the way to reference the widget and then
            // to use $("#theWindow").data("kendoWindow").
            // Alternatively, you may want to .center() the window.
            //alert($(window).width());

            if ($scope.currentWindow == 'win_Discussion') {
                $scope.win_Discussion.center();
            } else if ($scope.currentWindow == 'win_ContactList') {
                $scope.win_ContactList.center();
            } else if ($scope.currentWindow == 'win_ComparisonOrderReports') {
                $scope.win_ComparisonOrderReports.center();
            } else if ($scope.currentWindow == 'win_ModalReportNDiscuss') {
                $scope.win_ModalReportNDiscuss.center();
            }
            else if ($scope.currentWindow == 'win_PSUser') {
                $scope.win_PSUser.center();
            } else if ($scope.currentWindow == 'win_HideStudy') {
                $scope.win_HideStudy.center();
            } else if ($scope.currentWindow == 'win_addendum_request') {
                $scope.win_addendum_request.center();
            }

            return true;
        }
        function getOrderListTooltip(Order) {
            var orderDiscussionTooltip = '';
            var groupName = '';
            var userName = '';
            var allSpeciality = _.uniqBy(_.map(Order.listOrderListAssignment, function (row) {
                return {
                    ProviderSpecialityId: row.ProviderSpecialityId,
                    IsUserWithSpecialityGroup: row.IsUserWithSpecialityGroup,
                    SpecialityCode: row.SpecialityCode
                }
            }), 'ProviderSpecialityId');
            var allUsers = _.map(Order.listOrderListAssignment, function (row) {
                return {
                    OrderAssingedUserID: row.OrderAssingedUserID,
                    OrderAssingedUserName: row.OrderAssingedUserName,
                }
            });
            var specialities = [];
            var users = []
            _.each(Order.listOrderListAssignment, function (orderAssignment) {
                if (orderAssignment.ProviderSpecialityId > 0) {
                    var speciality = _.find(allSpeciality, { ProviderSpecialityId: orderAssignment.ProviderSpecialityId });
                    if (speciality) {
                        specialities.push(speciality);
                    }
                } else {
                    var specialityUser = _.find(allUsers, { OrderAssingedUserID: orderAssignment.OrderAssingedUserID });
                    if (specialityUser) {
                        users.push(specialityUser);
                    }
                }
            });

            var uniquespecialities = _.uniqBy(specialities, 'ProviderSpecialityId');

            var rawUsers = _.uniqBy(users, 'OrderAssingedUserID');
            var uniquespecialityusers = _.filter(rawUsers, function (_u) { return !_isPrelimRadAssignment(_u.OrderAssingedUserID); });


            groupName = _.join(_.map(uniquespecialities, function (speciality) { return speciality.SpecialityCode; }), ',');

            userName = _.join(_.map(uniquespecialityusers, function (_user) {
                return _assignmentName(_user.OrderAssingedUserID, _user.OrderAssingedUserName);
            }), ',');

            if (uniquespecialities.length == 0 && uniquespecialityusers.length == 0) {
                if (rawUsers.length > 0) { return ''; }
                orderDiscussionTooltip = '';
                if (Order.isCollapsed) {
                    orderDiscussionTooltip = 'Hide Comparison';
                } else {
                    orderDiscussionTooltip = 'Show Comparison';
                }
                return orderDiscussionTooltip;
            } else {
                var message = '';
                var groupMessage = '';
                var userMessage = '';
                groupMessage += uniquespecialities.length > 1 ? uniquespecialities.length + ' Groups' : uniquespecialities.length == 1 ? groupName : '';
                userMessage += uniquespecialityusers.length > 1 ? uniquespecialityusers.length + ' Others' : uniquespecialityusers.length == 1 ? userName : '';
                if (groupMessage.length > 0 && userMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage + ' and ' + userMessage;
                } else if (groupMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage;
                } else if (userMessage.length > 0) {
                    message = 'Assigned to ' + userMessage;
                }
                return message;
            }
        }
        function assignToMe(Order) {
            var index = $scope.contextmenuRowIndex;
            //var Order = $scope.orderList[index];

            var SpecialityId = 0;
            var SpecialityCode = '';
            var filter = _.find($scope.DataObject.masterData.Radiologists, function (dobj) { return dobj.Id == $sessionStorage.currentUserData.userId });
            if (filter) {
                SpecialityId = filter.SpecialityId;
                SpecialityCode = filter.SpecialityCode;
            }

            var orderDiscussionUserGroup = [];
            var userGroup = {
                ToUserID: $sessionStorage.currentUserData.userId,
                ToUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                ProviderSpecialityId: SpecialityId,
                IsUserWithSpecialityGroup: 2
            }
            orderDiscussionUserGroup.push(userGroup);
            var userOfGroup = _.filter($scope.DataObject.masterData.Radiologists, function (item) { return item.SpecialityId == SpecialityId; });
            var OrderListAssignment = {
                OrderID: $scope.SelectedOrder.OrderID,
                OrderAssingedUserID: $sessionStorage.currentUserData.userId,
                OrderAssingedUserName: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                ProviderSpecialityId: SpecialityId,
                IsUserWithSpecialityGroup: 2,
                SpecialityCode: SpecialityCode,
                TotalUsersOfGroup: userOfGroup.length
            }
            Order.listOrderListAssignment.push(OrderListAssignment);


            var data = {
                OrderID: $scope.SelectedOrder.OrderID,
                FromUserID: $sessionStorage.currentUserData.userId,
                FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                OrderDiscussionUserGroup: orderDiscussionUserGroup,
                Status: 'I',
                Order: $scope.SelectedOrder
            };
            $scope.DataObject.Loading = true;
            WorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                $scope.DataObject.Loading = false;
            });

            $scope.isContextMenuVisible = false;
            $scope.isAssignedCurrentUser = true;
        };

        function unAssignToMe(Order) {
            var orderDiscussionUserGroup = [];
            if (Order.listOrderListAssignment.length > 0) {

                _.each(Order.listOrderListAssignment, function (obj) {
                    var userGroup = {
                        ToUserID: obj.OrderAssingedUserID,
                        ToUser: obj.OrderAssingedUserName,
                        ProviderSpecialityId: obj.ProviderSpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);
                });
                if (!(_.filter(Order.listOrderListAssignment, function (obj) { return obj.OrderAssingedUserID === $sessionStorage.currentUserData.userId }).length > 0)) {
                    Order.listOrderListAssignment = [];
                }
                else {
                    var idx = _.findIndex(Order.listOrderListAssignment, function (order_obj) { return order_obj.OrderAssingedUserID == $sessionStorage.currentUserData.userId });
                    if (idx != -1) {
                        Order.listOrderListAssignment.splice(idx, 1);
                    }
                }
            } else {
                var SpecialityId = 0;
                var filter = _.find($scope.DataObject.masterData.Radiologists, function (dobj) { return dobj.Id == $sessionStorage.currentUserData.userId });
                if (filter) {
                    SpecialityId = filter.SpecialityId;
                }

                var userGroup = {
                    ToUserID: $sessionStorage.currentUserData.userId,
                    ToUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    ProviderSpecialityId: SpecialityId
                }
                orderDiscussionUserGroup.push(userGroup);
            }
            var userId, userName, data = null;
            if (orderDiscussionUserGroup.length > 0 && !(_.filter(orderDiscussionUserGroup, function (obj) { return obj.ToUserID === $sessionStorage.currentUserData.userId }).length > 0)) {
                _.each(orderDiscussionUserGroup, function (obj) {
                    if (userId) { userId += ',' + obj.ToUserID; } else { userId = obj.ToUserID; }
                    if (userName) { userName += ';' + obj.ToUser; } else { userName = obj.ToUser; }
                });
                data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: userId,
                    FromUser: userName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'D',
                    Order: Order,
                };
            }
            else {
                data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'D',
                    Order: Order
                };
            }
            $scope.DataObject.Loading = true;
            data.UnAssignUserID = $sessionStorage.currentUserData.userId;
            WorklistService.UnassignStudy(data).then(function (response) {
                $scope.DataObject.Loading = false;
                //getData().then(function (data) {
                gridOptions.api.refreshServerSide();
                //});
            });

            $scope.isContextMenuVisible = false;
            $scope.isAssignedCurrentUser = false;
        };

        //SignalR events
        $scope.$on('event.worklist', function (evt, data) {
            switch (data.EventType) {
                case 'SignReport':
                    if (data.RuleID == $scope.DataObject.worklist.RuleID) {
                        SignReport(data);
                    }
                    break;
                case 'OpenDiscussionOrder':
                    $scope.OrderDiscussion = data.OD;
                    if ($scope.OrderDiscussion.RequestType == "Addendum Request") {
                        $scope.OpenSignReport(data.OD.Order, OrderList);
                    } else {
                        if (!vm.selectedData.OpenDiscussion) {
                            _OpenDiscussionOrder();
                            vm.selectedData.OpenDiscussion = true;
                        }
                    }
                    break;
                case 'ReLoadDiscussion':
                    ReloadDiscussion(data.OD);
                    break;
                case 'UnAssignStudy':
                    UnAssignStudy(data.OD);
                    break;
                case 'NotifyOrderListUpdateReportFromRadFLow':
                    removeOrderFromList(data.OrderID);
                    break;
                case 'OrderDiscussionHandler':
                    OrderDiscussionHandler(data);
                    break;
                case 'OrdersListAttachmentUpdateHandler':
                    var objOrderList = _.filter(OrderList, function (obj) { return obj.DicomOrderID == data.DiacomOrderId; });
                    if (objOrderList && objOrderList.length > 0) {
                        objOrderList[0].FileCount = data.count;
                        if (data.count > 0) {
                            objOrderList[0].IsDiscussion = true;
                        }
                        updateAGGridOrder([objOrderList[0]]);
                    }
                    autoRefreshing = true;
                    //gridOptions.api.refreshServerSide();
                    break;
                case 'NotifyOpenOrder':
                    NotifyOpenOrder(data);
                    break;
                case 'NotifyShowHideOrder':
                    NotifyShowHideOrder(data);
                    break;
                case 'NotifyOrderListSaveReport':
                    var Status = GetStatus();
                    if (Status != 'AL') {
                        removeOrderFromList(data.OrderID);
                    }
                    break;
                case 'NotifyORUUpdate':
                    //OpenOrder = {};
                    //VerfiyReadStudy(data.OrderID, vm.selectedData.LoggedInUserID, null).then(function () {
                    //    if (OpenOrder.ClipboardDetailResult && OpenOrder.ClipboardDetailResult.length > 0) {
                    //        var obj = { OrderID: data.OrderID, UserID: vm.selectedData.LoggedInUserID, RuleID: OpenOrder.ClipboardDetailResult[0].RuleID };
                    //        $rootScope.$broadcast('event.NotifyRemoveFromClipboard', obj);
                    //        WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                    //    } else {
                    //        var obj = { OrderID: data.OrderID, UserID: vm.selectedData.LoggedInUserID, RuleID: data.ClipboardRuleID };
                    //        $rootScope.$broadcast('event.NotifyRemoveFromClipboard', obj);
                    //        WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                    //    }
                    //});
                    removeOrderAccession(data.Accession);
                    break;
                case 'NotifyAssignStudy':
                    NotifyAssignStudy(data);
                    break;
                case 'Dictation':
                    if (data.RuleID == $scope.DataObject.worklist.RuleID) {
                        Dictation(data);
                    }
                    break;
                case 'Reload':
                    if (data.ClipboardConditionData) {
                        ClipboardIconCase(data);
                    }
                    //Reload(data);
                    break;
                case 'Deselect':
                    if (data.ID != $scope.DataObject.index) {
                        $scope.SelectedOrderID = null;
                        $scope.SelectedOrder = null;
                        $scope.SelectedComPatisomOrderID = "";
                        if (gridOptions && gridOptions.api) {
                            gridOptions.api.deselectAll();
                        }
                        ClipboardConditionData = { ClipboardData: [], SelectedRowsClipboard: [], showClipboardToaster: true };
                    }
                    break;
                case 'deleteFile':
                    if ($scope.SelectedOrder) {
                        $scope.SelectedOrder.FileCount = data.FileCount;
                        if ($scope.SelectedOrder.FileCount == 0) {
                            $scope.showAttachment = false;
                            if ($scope.isDiscussionVisible) {
                                $scope.DataObject.DiscussionWindowActiveTab = 'Discussion';
                                $scope.DataObject.ShowAttachmentTab = false;
                            }
                            if ($scope.isModalReportNDiscussVisible) {
                                $scope.DataObject.ModalReportNDiscussActiveIndex = 1;
                            }
                            setOrderDiscussionUserGroup().then(function (data) {
                                setOrderDiscussionTooltip();
                                setSelectedUserAssignment(data);
                            });
                            UpdateGridData($scope.SelectedOrder.OrderID);
                        }
                        updateAGGridOrder([$scope.SelectedOrder]);
                    }
                    break;
                case 'ClearClipboard':
                    ClipboardRequestInProgress = data.ClipboardConditionData.RequestInProgress;
                    if (data.ClipboardConditionData.ActionType == "Reset" || (data.ClipboardConditionData.ActionType == "Remove" && data.ClipboardConditionData.ClipboardData.length == 0)) {
                        $scope.TotalRows = 0;
                        ResetClipboard();
                    }
                    $scope.SelectedOrderID = null;
                    $scope.SelectedOrder = null;
                    vm.selectedData.SelectedOrder = null;
                    if (gridOptions.api) {
                        gridOptions.api.deselectAll();
                        ClipboardConditionData = { ClipboardData: [], SelectedRowsClipboard: [], showClipboardToaster: true };
                        if ($scope.DataObject.worklist.WorklistType == 16) {
                            gridOptions.api.refreshServerSide({ purge: true });
                            autoRefreshing = true;
                            //gridOptions.api.setServerSideDatasource(datasource);
                        }
                    }
                    //var hasRuleDetails = $scope.DataObject.worklist.Type == 'D'
                    //    || $scope.DataObject.worklist.Type == 'S'
                    //    || $scope.DataObject.worklist.Type == 'QS';
                    //if (!hasRuleDetails) {
                    //    GetOrderDate();
                    //    GetSignDate();
                    //}
                    break;
                case 'FontSizeChanged':
                    if (data && data.WorklistFontSize) {
                        vm.selectedData.WorklistFontSize.PreferenceValue = data.WorklistFontSize;
                    }
                    if (data && data.WorklistColorCode) {
                        vm.selectedData.WorklistColorCode.PreferenceValue = data.WorklistColorCode;
                        var DeletedColorCode = _.filter(data.WorklistColorCode, { Deleted: true });
                        _.each(DeletedColorCode, function (obj) {
                            var Orders = _.filter(OrderList, { PatientClassPriority: obj.Key });
                            if (Orders.length > 0) updateAGGridOrder(Orders);
                        });
                    }
                    break;
                case 'notifyremoveorderidfromclipboard':
                    if (vm.worklist.WorklistType == 16) {
                        var order = _.find(OrderList, { OrderID: data.OrderID });
                        if (order) {
                            removeFromAGGrid(order);
                            ClipboardConditionData.showClipboardToaster = false;
                            setMultipleSelection([order]);
                            onRemoveFromClipboard();
                        }
                    }
                    break;
                case 'notifyremoveclipboardicon':
                    var orderIndex = _.findIndex(OrderList, { OrderID: data.OrderID });
                    if (orderIndex != -1) {
                        OrderList[orderIndex].IsInClipboard = 0;
                        updateAGGridOrder([OrderList[orderIndex]]);
                    }
                    break;
                case 'KeyBoardEvent':
                    switch (data.Name) {
                        case 'F12':
                            var selectedRows = gridOptions.api.getSelectedRows();
                            if (selectedRows.length == 1 && !vm.viewMode) {
                                HideOrder();
                            }
                            break;
                        case 'F11':
                            var selectedRows = gridOptions.api.getSelectedRows();
                            if (selectedRows.length == 1 && !vm.viewMode) {
                                HelpOrder();
                            }
                            break;
                    }
                    break;
                case 'notifyupdateorderdetail':
                    NotifyUpdateOrderDetail(data);
                    break;
                case 'ClipboardRequestInProgress':
                    ClipboardRequestInProgress = data.ClipboardConditionData.RequestInProgress;
                    break;
                case 'removeMultipleOrderFromClipboard':
                    var OrdersIDs = (data.OrderIDs).split(',');
                    _.each(OrdersIDs, function (OrderID) {
                        var orderIndex = _.findIndex(OrderList, { 'OrderID': OrderID });
                        if (orderIndex != -1) {
                            if ($scope.DataObject.worklist.WorklistType != 16) {
                                OrderList[orderIndex].IsInClipboard = 0;
                                updateAGGridOrder([OrderList[orderIndex]]);
                            } else {
                                removeOrderFromList(OrderID);
                                if (statusBarComponent && statusBarComponent.eGui && !showOnlyFiveStudies) {
                                    statusBarComponent.eGui.textContent = 'Showing ' + OrderList.length + ' of ' + $scope.TotalRows + ' Total Records';
                                    statusBarComponent.eGui.style.color = 'white';
                                }
                            }
                        }
                    });
                    break;
                case 'AssignLastOpenedOrder':
                    $scope.LastOpenedOrder = data.Order;
                    LastOpenedOrderID = data.Order.OrderID;
                    break;
                case 'NotifyOpenFromChatList':
                    if (vm.selectedData.OpenFromWorklist && data.Order && data.Order.OrderID) {
                        vm.selectedData.OpenFromWorklist = false;
                    }
                    break;
            }

        });
        function NotifyAssignStudy(data) {
            if (data.OrderDiscussion && (data.OrderDiscussion.FromUserID != $sessionStorage.currentUserData.userId)) {
                var orderIndex = _.findIndex(OrderList, { 'OrderID': _.toString(data.OrderDiscussion.OrderID) });
                var userOfGroupLength = data.OrderDiscussion.Order.listOrderListAssignment.length;
                var userIndex = _.findIndex(data.OrderDiscussion.Order.listOrderListAssignment, { 'OrderAssingedUserID': $sessionStorage.currentUserData.userId });
                var userName = '';
                if (orderIndex != -1) {
                    OrderList[orderIndex].listOrderListAssignment = data.OrderDiscussion.Order.listOrderListAssignment;
                    userName = getOrderListTooltip(OrderList[orderIndex]);
                }
                if (data.OrderDiscussion.Order.listOrderListAssignment.length > 0) {
                    _.each(data.OrderDiscussion.Order.listOrderListAssignment, function (data) {
                        if (orderIndex != -1) {
                            OrderList[orderIndex].OrderAssingedUserID = data.OrderAssingedUserID;
                            OrderList[orderIndex].OrderAssingedUserName = userName;
                            OrderList[orderIndex].OrderAssingedUsers = userOfGroupLength;
                            OrderList[orderIndex].OrderAssingedUser = userIndex != -1 ? $sessionStorage.currentUserData.userId : null;
                        }


                    });
                } else {
                    if (orderIndex != -1) {
                        OrderList[orderIndex].OrderAssingedUserID = null;
                        OrderList[orderIndex].OrderAssingedUserName = null;
                        OrderList[orderIndex].OrderAssingedUsers = 0;
                        OrderList[orderIndex].OrderAssingedUser = null;
                    }
                }

            } else if (data.OrderDiscussion && (data.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId)) {
                var index = _.findIndex(OrderList, { 'OrderID': data.OrderDiscussion.Order.OrderID });
                if (index != -1) {
                    updateOrderAssign(data.OrderDiscussion.Order);
                    OrderList[index].OrderAssingedUserID = data.OrderDiscussion.Order.OrderAssingedUserID;
                    OrderList[index].OrderAssingedUserName = data.OrderDiscussion.Order.OrderAssingedUserName;
                    OrderList[index].OrderAssingedUsers = data.OrderDiscussion.Order.OrderAssingedUsers;
                    OrderList[index].OrderAssingedUser = data.OrderDiscussion.Order.OrderAssingedUser;

                    if (data.OrderDiscussion.Order && data.OrderDiscussion.Order.listOrderListAssignment) {
                        OrderList[index].listOrderListAssignment = data.OrderDiscussion.Order.listOrderListAssignment;
                    }
                }
            }
            updateOrderAssign(data.OrderDiscussion.Order).then(function (res) {
                UpdateGridData(res.OrderID);
            });

        }
        function UnAssignStudy(OD) {
            if (OD.Status == 'D' && OD.FromUserID == vm.selectedData.LoggedInUserID) {
                var objOrder = _.filter(OrderList, function (obj) { return obj.OrderID == OD.OrderID; });
                if (objOrder && objOrder.length > 0) {
                    if (!objOrder[0].IsLock && $scope.DataObject.worklist === 'PSW') {

                        var assignedUserID;
                        var findObj = _.find(OD.OrderDiscussionUserGroup, function (obj) {
                            return obj.ToUserID == vm.selectedData.LoggedInUserID;
                        });
                        if (findObj) {
                            assignedUserID = OD.OrderDiscussionUserGroup.ToUserID;
                        }
                        var OrderAssingedUsers;
                        var findIndex = _.findIndex(OD.OrderDiscussionUserGroup, function (obj) {
                            return obj.ToUserID == vm.selectedData.LoggedInUserID;
                        });
                        if (findIndex != -1) {
                            OD.OrderDiscussionUserGroup.splice(findIndex, 1);
                            OrderAssingedUsers = OD.OrderDiscussionUserGroup.length;
                        } else {
                            OrderAssingedUsers = OD.OrderDiscussionUserGroup.length - 1;
                        }
                        var OrderAssingedUserID;
                        if (OrderAssingedUsers > 0) {
                            OrderAssingedUserID = OD.OrderDiscussionUserGroup[0].ToUserID;
                        }
                        var OrderAssingedUserName;
                        if (OrderAssingedUserID) {
                            var findObj = _.find(objOrder[0].listOrderListAssignment, function (obj) { return obj.OrderAssingedUserID = OrderAssingedUserID });
                            if (findObj) {
                                OrderAssingedUserName = getOrderListTooltip(objOrder[0]);
                            }
                        }
                        objOrder[0].OrderAssingedUserID = OrderAssingedUserID;
                        objOrder[0].OrderAssingedUserName = OrderAssingedUserName;
                        objOrder[0].OrderAssingedUsers = OrderAssingedUsers;
                        objOrder[0].OrderAssingedUser = assignedUserID ? null : assignedUserID;
                        objOrder[0].listOrderListAssignment = OD.Order.listOrderListAssignment;
                    }
                    if (!objOrder[0].IsLock && $scope.DataObject.worklist === 'PRW') {
                        removeOrderFromList(OD.OrderID);
                    }
                }
            }
        }
        function sortByField() {

            var sortingFields = [];
            var sortingDirections = [];

            var Status = GetStatus();

            if (Status == "RP") {
                sortingFields = ['IsDeficient', function (e) { return e.IsStat || e.IsHighPriority; }, 'DelayedSTAT'];
                sortingDirections = ['desc', 'desc', 'desc'];
            }


            _.each($scope.DataObject.worklist.SortColumns, function (sColumn, index) {
                switch (sColumn.field) {
                    case 'OrderDate':
                        sortingFields.push(function (e) { return e.OrderDate ? new Date(e.OrderDate).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    case 'FormattedPatientDOB':
                        sortingFields.push(function (e) { return e.PatientDOB ? new Date(e.PatientDOB).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    case 'CreatedDate':
                        sortingFields.push(function (e) { return e.CreatedDate ? new Date(e.CreatedDate).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    default:
                        sortingFields.push(sColumn.field);
                        break;
                }

                sortingDirections.push(sColumn.sort.direction);

                //if (sColumn.field != 'CreatedDate') {
                //    sortingFields.push('CreatedDate');
                //    sortingDirections.push('desc');
                //}
            });

            OrderList = _.orderBy(OrderList, sortingFields, sortingDirections);
        }
        function setFilter() {
            var PageNum = _.toInteger(PageNo);
            var PageSize = _.toInteger($scope.DataObject.worklist.PageSize);
            var isPersonalWorklist = $scope.DataObject.worklist.RuleID === 'PRW';
            if ($scope.DataObject.worklist.Type == 'D') {
                OrderListFilter = {
                    PageNum: PageNum > 0 ? PageNum : 1,
                    PageSize: PageSize > 0 ? PageSize : getPageSize($scope.DataObject.worklist.height),
                    //OrderDateStartDate: moment().subtract(6, 'days').format("MM-DD-YYYY"),
                    //OrderDateEndDate: moment().format("MM-DD-YYYY"),
                    OrderDateStartDate: isPersonalWorklist ? null : $filter('CSTDateTime')(moment(moment().subtract(29, 'days').format("YYYY-MM-DD") + ' ' + "00:00")),
                    OrderDateEndDate: isPersonalWorklist ? null : $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")),
                    Status: 'RP',
                    UserID: $sessionStorage.currentUserData.userId,
                    WorklistFlag: $scope.DataObject.worklist.RuleID,
                    STATFilter: vm.selectedData.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    //FromSignDate: moment().format("MM-DD-YYYY"),
                    //ToSignDate: moment().format("MM-DD-YYYY"),
                    FromSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "00:00")),
                    ToSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")),
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: 'All',
                    LocationID: FilterByLocationIDs,
                    PatientClassMultiple: FilterByType,
                    PriorityMultiple: FilterByPriority,
                    Accession: FilterByAccession,
                    PatientMRN: FilterByPatientMRN,
                    ProcedureDesc: FilterByProcedureDesc,
                    OrderingPhysicianSearch: FilterByOrderingPhysician,
                    RenderingPhysician: FilterByRenderingPhysician,
                };
                if ($scope.DataObject.masterData.selectedModalities) {
                    OrderListFilter.ModalityID = _.join(_.map($scope.DataObject.masterData.selectedModalities, function (modality) {
                        return modality.Id;
                    }), ',');
                }
                if (_.indexOf(FilterByPatientName, "*") != -1) {
                    OrderListFilter.PatientSearch = FilterByPatientName;
                } else {
                    OrderListFilter.PatientName = FilterByPatientName;
                }
                if (FilterByDOSDateRange.StartDate.length > 0 && FilterByDOSDateRange.EndDate.length > 0) {
                    OrderListFilter.OrderDateStartDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByDOSDateRange.StartDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                    OrderListFilter.OrderDateEndDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByDOSDateRange.EndDate)).format("YYYY-MM-DD") + ' ' + "23:59:59"));
                }
                if (FilterByCreatedDateRange.StartDate.length > 0 && FilterByCreatedDateRange.EndDate.length > 0) {
                    OrderListFilter.FromCreatedDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByCreatedDateRange.StartDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                    OrderListFilter.ToCreatedDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByCreatedDateRange.EndDate)).format("YYYY-MM-DD") + ' ' + "23:59:59"));
                }
                if (FilterByWorkRVU.StartValue != null && FilterByWorkRVU.EndValue != null) {
                    OrderListFilter.FromWorkRVU = FilterByWorkRVU.StartValue;
                    OrderListFilter.ToWorkRVU = FilterByWorkRVU.EndValue;
                }
                if (FilterByImageInstance.StartValue != null && FilterByImageInstance.EndValue != null) {
                    OrderListFilter.FromImages = FilterByImageInstance.StartValue;
                    OrderListFilter.ToImages = FilterByImageInstance.EndValue;
                }
                if (FilterBySLA.StartValue != null && FilterBySLA.EndValue != null) {
                    OrderListFilter.FromSLA = FilterBySLA.StartValue;
                    OrderListFilter.ToSLA = FilterBySLA.EndValue;
                }
                if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && FilterByRenderingPhysicianFlag) {
                    OrderListFilter.TenantName = $sessionStorage.EnableRowsForSelectedTenants;
                }
            } else if ($scope.DataObject.worklist.Type == 'S') {
                OrderListFilter = {
                    PageNum: PageNum > 0 ? PageNum : 1,
                    PageSize: PageSize > 0 ? PageSize : getPageSize($scope.DataObject.worklist.height),
                    SiteID: vm.selectedData.Site ? vm.selectedData.Site.SiteID : null,
                    LocationID: _.join(_.map(vm.selectedData.Location, 'LocationID'), ','),
                    Accession: vm.selectedData.Accession,
                    ModalityIDSearch: _.join(_.map(vm.selectedData.Modality, 'Id'), ','),
                    //OrderDateStartDate: (vm.selectedData.OrderDate.startDate) ? moment(new Date(vm.selectedData.OrderDate.startDate)).format("MM-DD-YYYY") : null,
                    //OrderDateEndDate: (vm.selectedData.OrderDate.endDate) ? moment(new Date(vm.selectedData.OrderDate.endDate)).format("MM-DD-YYYY") : null,
                    OrderDateStartDate: (!isPersonalWorklist && vm.selectedData.OrderDate.startDate) ? $filter('CSTDateTime')(moment(moment(new Date(vm.selectedData.OrderDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00")) : null,
                    OrderDateEndDate: (!isPersonalWorklist && vm.selectedData.OrderDate.endDate) ? $filter('CSTDateTime')(moment(moment(new Date(vm.selectedData.OrderDate.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")) : null,
                    PatientName: vm.selectedData.PatientName,
                    PatientMRN: vm.selectedData.PatientMRN,
                    PatientDOB: formatted_date(vm.selectedData.DOB),
                    PatientClass: vm.selectedData.PatientClass ? vm.selectedData.PatientClass.Value : '',
                    OrderingPhysician: vm.selectedData.OrderingPhysician,
                    Status: vm.selectedData.Status.key,
                    UserID: $sessionStorage.currentUserData.userId,
                    WorklistFlag: vm.selectedData.Worklist,
                    STATFilter: vm.selectedData.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    //FromSignDate: moment().format("MM-DD-YYYY"),
                    //ToSignDate: moment().format("MM-DD-YYYY"),
                    FromSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "00:00")),
                    ToSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")),
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: vm.selectedData.StudyPriority ? vm.selectedData.StudyPriority.Key : 'All',
                };
            } else if ($scope.DataObject.worklist.Type == 'A') {
                OrderListFilter = {
                    PageNum: PageNum > 0 ? PageNum : 1,
                    PageSize: PageSize > 0 ? PageSize : getPageSize($scope.DataObject.worklist.height),
                    Status: vm.selectedData.Status.key,
                    UserID: $sessionStorage.currentUserData.userId,
                    AdminWorklistIds: _.toString($scope.DataObject.worklist.RuleID),
                    STATFilter: vm.selectedData.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    //FromSignDate: moment().format("MM-DD-YYYY"),
                    //ToSignDate: moment().format("MM-DD-YYYY"),
                    FromSignDate: (RuleSignDate.DateValue.startDate) ? $filter('CSTDateTime')(moment(moment(new Date(RuleSignDate.DateValue.startDate)).format("YYYY-MM-DD") + ' ' + "00:00")) : null,
                    ToSignDate: (RuleSignDate.DateValue.endDate) ? $filter('CSTDateTime')(moment(moment(new Date(RuleSignDate.DateValue.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")) : null,
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: 'All',
                    OrderDateStartDate: (!isPersonalWorklist && RuleOrderDate.DateValue.startDate) ? $filter('CSTDateTime')(moment(moment(new Date(RuleOrderDate.DateValue.startDate)).format("YYYY-MM-DD") + ' ' + "00:00:00")) : null,
                    OrderDateEndDate: (!isPersonalWorklist && RuleOrderDate.DateValue.endDate) ? $filter('CSTDateTime')(moment(moment(new Date(RuleOrderDate.DateValue.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")) : null,
                    LocationID: FilterByLocationIDs,
                    PatientClassMultiple: FilterByType,
                    PriorityMultiple: FilterByPriority,
                    Accession: FilterByAccession,
                    PatientMRN: FilterByPatientMRN,
                    ProcedureDesc: FilterByProcedureDesc,
                    OrderingPhysicianSearch: FilterByOrderingPhysician,
                    RenderingPhysician: FilterByRenderingPhysician,
                };
                if ($scope.DataObject.masterData.selectedModalities) {
                    OrderListFilter.ModalityID = _.join(_.map($scope.DataObject.masterData.selectedModalities, function (modality) { return modality.Id; }), ',');
                }
                if (_.indexOf(FilterByPatientName, "*") != -1) {
                    OrderListFilter.PatientSearch = FilterByPatientName;
                } else {
                    OrderListFilter.PatientName = FilterByPatientName;
                }
                if (FilterByDOSDateRange.StartDate.length > 0 && FilterByDOSDateRange.EndDate.length > 0) {
                    OrderListFilter.OrderDateStartDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByDOSDateRange.StartDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                    OrderListFilter.OrderDateEndDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByDOSDateRange.EndDate)).format("YYYY-MM-DD") + ' ' + "23:59:59"));
                }
                if (FilterByCreatedDateRange.StartDate.length > 0 && FilterByCreatedDateRange.EndDate.length > 0) {
                    OrderListFilter.FromCreatedDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByCreatedDateRange.StartDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                    OrderListFilter.ToCreatedDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByCreatedDateRange.EndDate)).format("YYYY-MM-DD") + ' ' + "23:59:59"));
                }
                if (FilterByWorkRVU.StartValue != null && FilterByWorkRVU.EndValue != null) {
                    OrderListFilter.FromWorkRVU = FilterByWorkRVU.StartValue;
                    OrderListFilter.ToWorkRVU = FilterByWorkRVU.EndValue;
                }
                if (FilterByImageInstance.StartValue != null && FilterByImageInstance.EndValue != null) {
                    OrderListFilter.FromImages = FilterByImageInstance.StartValue;
                    OrderListFilter.ToImages = FilterByImageInstance.EndValue;
                }
                if (FilterBySLA.StartValue != null && FilterBySLA.EndValue != null) {
                    OrderListFilter.FromSLA = FilterBySLA.StartValue;
                    OrderListFilter.ToSLA = FilterBySLA.EndValue;
                }
                if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && FilterByRenderingPhysicianFlag) {
                    OrderListFilter.TenantName = $sessionStorage.EnableRowsForSelectedTenants;
                }
            }
            else if ($scope.DataObject.worklist.Type == 'QS') {
                OrderListFilter = {
                    PageNum: PageNum > 0 ? PageNum : 1,
                    PageSize: PageSize > 0 ? PageSize : getPageSize($scope.DataObject.worklist.height),
                    Accession: vm.selectedData.QuickSearch.Accession,
                    LocationSearch: vm.selectedData.QuickSearch.LocationSearch,
                    ModalityIDSearch: _.join(_.map(vm.selectedData.QuickSearch.Modality, 'Id'), ','),
                    //OrderDateStartDate: (vm.selectedData.QuickSearch.OrderDate.startDate) ? moment(new Date(vm.selectedData.QuickSearch.OrderDate.startDate)).format("MM-DD-YYYY") : null,
                    //OrderDateEndDate: (vm.selectedData.QuickSearch.OrderDate.endDate) ? moment(new Date(vm.selectedData.QuickSearch.OrderDate.endDate)).format("MM-DD-YYYY") : null,
                    OrderDateStartDate: (!isPersonalWorklist && vm.selectedData.QuickSearch.OrderDate.startDate) ? $filter('CSTDateTime')(moment(moment(new Date(vm.selectedData.QuickSearch.OrderDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00")) : null,
                    OrderDateEndDate: (!isPersonalWorklist && vm.selectedData.QuickSearch.OrderDate.endDate) ? $filter('CSTDateTime')(moment(moment(new Date(vm.selectedData.QuickSearch.OrderDate.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59")) : null,
                    PatientMRN: vm.selectedData.QuickSearch.PatientMRN,
                    PatientDOB: formatted_date(vm.selectedData.QuickSearch.DOB),
                    PatientClass: vm.selectedData.QuickSearch.PatientClass ? vm.selectedData.QuickSearch.PatientClass.Value : '',
                    OrderingPhysicianSearch: vm.selectedData.QuickSearch.OrderingPhysician,
                    Status: vm.selectedData.QuickSearch.Status.key,
                    UserID: $sessionStorage.currentUserData.userId,
                    STATFilter: vm.selectedData.QuickSearch.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: vm.selectedData.QuickSearch.StudyPriority ? vm.selectedData.QuickSearch.StudyPriority.Key : 'All',
                    //FromSignDate: moment().format("MM-DD-YYYY"),
                    //ToSignDate: moment().format("MM-DD-YYYY"),
                    FromSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "00:00")),
                    ToSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")),
                };
                if (_.indexOf(vm.selectedData.QuickSearch.PatientSearch, "*") != -1) {
                    OrderListFilter.PatientSearch = vm.selectedData.QuickSearch.PatientSearch;
                } else {
                    OrderListFilter.PatientName = vm.selectedData.QuickSearch.PatientSearch;
                }
                if (FilterByDOSDateRange.StartDate.length > 0 && FilterByDOSDateRange.EndDate.length > 0) {
                    OrderListFilter.OrderDateStartDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByDOSDateRange.StartDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                    OrderListFilter.OrderDateEndDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByDOSDateRange.EndDate)).format("YYYY-MM-DD") + ' ' + "23:59:59"));
                }
                if (FilterByCreatedDateRange.StartDate.length > 0 && FilterByCreatedDateRange.EndDate.length > 0) {
                    OrderListFilter.FromCreatedDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByCreatedDateRange.StartDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                    OrderListFilter.ToCreatedDate = $filter('CSTDateTime')(moment(moment(new Date(FilterByCreatedDateRange.EndDate)).format("YYYY-MM-DD") + ' ' + "23:59:59"));
                }
                if (FilterByWorkRVU.StartValue != null && FilterByWorkRVU.EndValue != null) {
                    OrderListFilter.FromWorkRVU = FilterByWorkRVU.StartValue;
                    OrderListFilter.ToWorkRVU = FilterByWorkRVU.EndValue;
                }
                if (FilterByImageInstance.StartValue != null && FilterByImageInstance.EndValue != null) {
                    OrderListFilter.FromImages = FilterByImageInstance.StartValue;
                    OrderListFilter.ToImages = FilterByImageInstance.EndValue;
                }
                if (FilterBySLA.StartValue != null && FilterBySLA.EndValue != null) {
                    OrderListFilter.FromSLA = FilterBySLA.StartValue;
                    OrderListFilter.ToSLA = FilterBySLA.EndValue;
                }
                if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && FilterByRenderingPhysicianFlag) {
                    OrderListFilter.TenantName = $sessionStorage.EnableRowsForSelectedTenants;
                }
            }
            if ($scope.DataObject.worklist.WorklistType == 51) {
                OrderListFilter.WorkListName = 'OverDues';
            } else if ($scope.DataObject.worklist.WorkListName) {
                OrderListFilter.WorkListName = $scope.DataObject.worklist.WorkListName;
            }
            if (OrderListFilter.ModalityID
                && OrderListFilter.ModalityID.length > 0
                && _.find($scope.DataObject.masterData.selectedModalities, { Code: 'CR' })) {
                var dxmodality = _.find(vm.masterData.Modalities, { Code: 'DX' });
                OrderListFilter.ModalityID = OrderListFilter.ModalityID + "," + dxmodality.Id;
            }
            OrderListFilter.IsSmartWorklist = $scope.DataObject.worklist.IsSmartWorklist;
            OrderListFilter.WorklistPageSize = $scope.DataObject.worklist.WorklistPageSize;
            if ($scope.DataObject.worklist.IsSmartWorklist
                && $scope.DataObject.masterData.selectedModalities
                && $scope.DataObject.masterData.selectedModalities.length > 0) {
                var modalityCountTotal = 0;
                _.each($scope.DataObject.masterData.selectedModalities, function (modality) {
                    var count = localModalityCounts[modality.Code] !== undefined
                        ? localModalityCounts[modality.Code]
                        : vm.worklist[modality.Code];
                    modalityCountTotal += (_.toInteger(count) || 0);
                });
                if (_.find($scope.DataObject.masterData.selectedModalities, { Code: 'CR' })) {
                    var crdxCount = localModalityCounts['CRDX'] !== undefined
                        ? localModalityCounts['CRDX']
                        : vm.worklist['CRDX'];
                    modalityCountTotal += (_.toInteger(crdxCount) || 0);
                }
                var worklistPageSize = _.toInteger(vm.worklist.WorklistPageSize);
                if (modalityCountTotal === 0) {
                    OrderListFilter.WorklistPageSize = "0";
                } else if (modalityCountTotal <= worklistPageSize) {
                    OrderListFilter.WorklistPageSize = modalityCountTotal.toString();
                }
            }
        }
        function GetStatus() {
            var RuleConditionStatus;
            var DefaultStatus = $scope.DataObject.worklist.Type == 'S' ? (vm.selectedData && vm.selectedData.Status ? vm.selectedData.Status.key : 'RP') : $scope.DataObject.worklist.Type == 'QS' ? (vm.selectedData && vm.selectedData.QuickSearch && vm.selectedData.QuickSearch.Status ? vm.selectedData.QuickSearch.Status.key : 'RP') : 'RP';
            var Status = DefaultStatus;
            _.each($scope.DataObject.worklist.Groups, function (group) {
                RuleConditionStatus = _.find(group.RulesConditions, { ColumnName: 'ORDERS.ExamStatus' });
            });

            if (RuleConditionStatus && RuleConditionStatus.RuleTableValues && RuleConditionStatus.RuleTableValues.length > 0) {
                Status = $scope.DataObject.worklist.Type == 'D' ? OrderListFilter.Status : $scope.DataObject.worklist.Type == 'A' ? RuleConditionStatus.RuleTableValues[0].ID : DefaultStatus;
            } else if (RuleConditionStatus && RuleConditionStatus.Value && RuleConditionStatus.Value.length > 0) {
                if (RuleConditionStatus.Value.indexOf(':') != -1) {
                    Status = $scope.DataObject.worklist.Type == 'D' ? OrderListFilter.Status : $scope.DataObject.worklist.Type == 'A' ? RuleConditionStatus.Value.split(":")[0] : DefaultStatus;
                } else {
                    Status = $scope.DataObject.worklist.Type == 'D' ? OrderListFilter.Status : $scope.DataObject.worklist.Type == 'A' ? RuleConditionStatus.Value : DefaultStatus;
                }

            } else {
                Status = $scope.DataObject.worklist.Type == 'D' ? OrderListFilter.Status : DefaultStatus;
            }
            if (!Status) {
                Status = 'RP';
            }
            return Status;
        }

        function NoContextMenuOptions(Order) {
            var hasMenu = false;

            if (((!$scope.DataObject.worklist.WorklistType || $scope.DataObject.worklist.WorklistType == 21 || $scope.DataObject.worklist.WorklistType == 11 || $scope.DataObject.worklist.WorklistType == 31 || $scope.DataObject.worklist.WorklistType == 51) && ClipboardConditionData.ClipboardData && ClipboardConditionData.ClipboardData.length <= 1) || ($scope.DataObject.worklist.WorklistType && $scope.DataObject.worklist.WorklistType == 16 && ClipboardConditionData.SelectedRowsClipboard.length == 1)) {

                if (Order.Status == 'C' || Order.Status == 'D' || Order.IsLock || (Order.OrderAssingedUsers > 0 && !Order.OrderAssingedUser)) {
                    hasMenu = false;
                } else {
                    hasMenu = true;
                }
                if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userRoles && ($sessionStorage.currentUserData.userRoles.includes("SuperAdmin") || $sessionStorage.currentUserData.userRoles.includes("Admin"))) {
                    hasMenu = true;
                }
                if (Order.Status == 'CO' || Order.Status == 'H') {
                    hasMenu = true;
                }
                if (Order.IsLock) {
                    hasMenu = true;
                }
                if (Order.DicomViewer) { hasMenu = true };
            }
            if ($scope.DataObject.worklist.WorklistType == 16) { hasMenu = true; } else {
                if (ClipboardConditionData.ClipboardData && ClipboardConditionData.ClipboardData.length > 0) { hasMenu = true; }
            }
            if (vm.viewMode) {
                hasMenu = false;
            }
            return hasMenu;
        }
        function OpenVR(order, isSingleView) {
            var _correlationId = Date.now();
            logPacsEvent('[' + _correlationId + '] Step1-WorklistGrid-CIVR: viewer=CIVR');
            if (isSingleView) {
                var openOrders = {
                    OrderId: order.OrderID,
                    ProviderID: vm.selectedData.LoggedInUserID
                };
                WorklistService.VerfiyReadStudy(openOrders).then(function (result) {
                    if (result.openOrders && result.openOrders.length > 0) {
                        confirm("This order is presently being dictated by user " + result.openOrders[0].ProviderName + ".\nCaution: Proceeding will create another report.");
                        return;
                    }
                    $rootScope.$broadcast('event.OpenVR', { order: order, isSingleView: isSingleView, correlationId: _correlationId });
                });
            }
            else {
                $rootScope.$broadcast('event.OpenVR', { order: order, isSingleView: isSingleView, correlationId: _correlationId });
            }
        }
        function ViewOrderReport(SelectedOrder, SelectedOrderAccession) {
            $scope.ReportSelectedOrder = _.clone(SelectedOrder);
            $scope.ReportSelectedOrder.ShowContactBtn = true;
            $scope.showDiscuss = false;
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;
            var ComparisionOrderList = [];

            if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length == 0) {
                $scope.orderComparisonListFilter = {
                    UserID: vm.selectedData.LoggedInUserID,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = result;
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });

                    setPriorReport(SelectedOrder, ComparisionOrderList);
                }).catch(function (noCantDo) {
                    //$scope.isLoading = false;
                });
            } else if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                setPriorReport(SelectedOrder, ComparisionOrderList);
            } else {
                setPriorReport(SelectedOrder, ComparisionOrderList);
            }
        }
        function setPriorReport(SelectedOrder, ComparisionOrderList) {
            //console.log("setPriorReport");
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN, SelectedOrder.SiteID)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];

                if (data != null && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        SelectedOrder.FormattedOrderDate = new Date($filter('localDate')(SelectedOrder.OrderDate, false, new Date()));
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            rptObject[0].FormattedOrderDate = new Date($filter('localDate')(rptObject[0].OrderDate, false, new Date()));
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            ComparisonOrderReport.FormattedOrderDate = new Date($filter('localDate')(ComparisonOrderReport.OrderDate, false, new Date()));
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });
                }
                if ($scope.reportList.length > 0) {
                    $scope.OrderReport = $scope.reportList[0];
                } else {
                    $scope.OrderReport = SelectedOrder;
                }
                $scope.reportList = _.uniqBy($scope.reportList, 'OrderID');
                $scope.DataObject.ReportList.Modalities = _.concat($scope.DataObject.ReportList.Modalities, _.uniq(_.map(_.filter($scope.reportList, function (report) { return report.Modality != ''; }), 'Modality')));
                var objSelectedReport = _.filter($scope.reportList, function (obj) { return obj.Accession == $scope.SelectedOrderAccession; });
                LoadReport(objSelectedReport[0].OrderID);
                if (Hasreport) {
                    $scope.currentWindow = "win_ComparisonOrderReports";
                    $scope.win_ComparisonOrderReports.open();
                    $scope.win_ComparisonOrderReports.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    $scope.win_ComparisonOrderReports.wrapper.addClass("report-top-mdl");
                    var timeout = $timeout(function () {
                        $scope.win_ComparisonOrderReports.center();
                    }, 100);
                    TimeoutList.push(timeout);
                }
                else {
                    toaster.info({ body: "No report found." });
                }
                ReportList = $scope.reportList;
                if (ReportList.length > 1) {
                    $scope.DataObject.ShowReportModal = true;
                }
            });
        }
        function GetPriorReportsByPatientMRN(OrderID, PatientMRN, SiteID) {
            var d = $q.defer();
            var jObject = {
                OrderID: OrderID,
                PatientMRN: PatientMRN,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: SiteID
            }

            WorklistService.GetPriorReportsByPatientMRN(jObject).then(function (results) {
                d.resolve(results);
            });
            return d.promise;
        }
        function LoadReport(OrderId) {
            if ($scope.orderReportList && $scope.orderReportList.length > 0) {
                var data = _.filter($scope.orderReportList, function (obj) { return obj.OrderID == OrderId; });
                if (data && data.length > 0) {
                    $scope.report = data[0];
                    $scope.ReviewOrder = {};
                    angular.copy($scope.report, $scope.ReviewOrder);
                    AssignValuesReportToSelectedOrder();
                    $scope.isReviewReportVisible();
                    //$scope.isLoading = false;
                }
                else {
                    $scope.ReviewOrder = {};
                    getReportData(OrderId);
                }
            }
            else {
                $scope.ReviewOrder = {};
                getReportData(OrderId);
            }
        }
        function getReportData(OrderId) {
            $scope.report = null;
            var UserId = $sessionStorage.currentUserData.userId;
            WorklistService.GetDictationValueReport(OrderId, UserId).then(function (response) {
                if (response) {
                    $scope.report = response;
                    if ($sessionStorage.currentUserData
                        && $sessionStorage.currentUserData.RemoveRenderingPhysician
                        && ($scope.DataObject.EnableRowsForSelectedTenants
                            && $scope.DataObject.EnableRowsForSelectedTenants.includes($scope.SelectedOrder.TenantName))) {
                        $scope.report.DictationValue = _.toString($scope.report.DictationValue).length > 0 ? $scope.report.DictationValue.replace(/Electronically signed by.*?(?:\n|\r|$)/gi, '').replace(/Workstation:.*?(?:\n|\r|$)/gi, '').replace(/Electronically drafted by.*?(?:\n|\r|$)/gi, '') : '';
                    }
                    $scope.ReviewOrder = response;




                    if ($scope.report && $scope.report.DOS) {
                        $scope.report.DOS = ($filter('localDate')($scope.report.DOS, false, new Date()));
                    }
                    if ($scope.report && $scope.report.SingDate) {
                        $scope.report.SingDate = moment(
                            ($filter('localDate')($scope.report.SingDate, false, new Date()))
                        ).format("MM/DD/YYYY");
                    }
                    if ($scope.report && $scope.report.Patient_DOB) {
                        $scope.report.Patient_DOB = changeDateFormat($scope.report.Patient_DOB);
                    }
                    if ($scope.OrderReport) {
                        $scope.report.Location = $scope.OrderReport.Location;
                        $scope.report.LocationID = $scope.OrderReport.LocationID;
                    }
                    AssignValuesReportToSelectedOrder();
                    $scope.isReviewReportVisible();
                    $scope.orderReportList.push(response);
                }

                //$scope.isLoading = false;
            }, function (error) {
                //$scope.isLoading = false;
            });
        }
        function changeDateFormat(date) {
            if (date) {
                return moment(new Date(date)).format("MM/DD/YYYY");
            }
        }
        function showPopover(dicomOrderID, IsDiscussion) {
            var d = $q.defer();
            $scope.popoverDicomOrderID = dicomOrderID;
            if (IsDiscussion) {
                $scope.Discussion = {
                    ReferenceID: dicomOrderID,
                    Type: 1,
                    Comment: '',
                    Record_Created_By: vm.selectedData.LoggedInUserID
                };
                $scope.Discussions = [];
                $q.all([
                    LoadPopOverDiscussion($scope.Discussion)
                ]).then(function (data) {
                    if ($scope.Discussions) {
                        var htmlpop = '<div class="popchatui dropdown-content dropdown-menu-right">';
                        _.each($scope.Discussions, function (discussion) {
                            // htmlpop = htmlpop + '<div>' + discussion.Comment + '</div>';
                            htmlpop = htmlpop + '<div>';
                            var displayName = _discussionDisplayName(discussion);
                            if (discussion.Record_Created_By &&
                                discussion.Record_Created_By == vm.selectedData.LoggedInUserID) {
                                htmlpop = htmlpop + '<div class="sendersection">' +
                                    '<div class="sendercomment pos-rel senderborder">' +
                                    (displayName ? '<div class="sendername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline">' + discussion.Comment + '</div>' +
                                    '<div class="senderdate text-preline">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, true);
                                htmlpop = htmlpop + '</div></div>';
                            } else {
                                htmlpop = htmlpop + '<div class="receiversection">' +
                                    '<div class="receivercomment pos-rel receiverborder">' +
                                    (displayName ? '<div class="receivername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline word-break-word">' + discussion.Comment + '</div>' +
                                    '<div class="receiverdate">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, false);
                                htmlpop = htmlpop + '</div></div>';
                            }

                            htmlpop = htmlpop + '</div>';
                        });
                        htmlpop = htmlpop + '</div>';
                        d.resolve(htmlpop);
                    }
                });
            }
            return d.promise;
        }
        function LoadOnlyDiscussion(referenceID, ODType) {
            $scope.showDiscuss = false;
            $scope.LoadDiscussion(referenceID, ODType);
        };
        $scope.LoadDiscussion = function (referenceID, ODType) {
            hidePopover();

            var selectedGridRows = gridOptions.api.getSelectedRows();
            var selectedGridOrder = _.find(selectedGridRows, { DicomOrderID: referenceID });
            var ReportID = null;
            if (selectedGridOrder) {
                ReportID = selectedGridOrder.ReportID;
            }

            var ClipboardFlag = !(($scope.DataObject.worklist.WorklistType != 16 && !$scope.DataObject.worklist.ChooseNextStudy) || ($scope.DataObject.worklist.WorklistType == 16 && !$scope.DataObject.worklist.OpenClipboardNextStudy));
            $scope.showAttachment = false;
            $scope.ODType = ODType;
            $scope.Discussion = {
                ReferenceID: referenceID,
                Type: 1,
                Comment: '',
                Record_Created_By: vm.selectedData.LoggedInUserID,
                ReportID: ReportID,
            };
            $scope.Discussions = [];
            LoadDiscussion($scope.Discussion);
            if ($scope.showDiscuss) {
                if ((ClipboardFlag ? ($scope.reportList && $scope.reportList.length > 0) || ($scope.Discussions && $scope.Discussions.length > 0) : true)) {
                    $scope.currentWindow = 'win_ModalReportNDiscuss';
                    $scope.win_ModalReportNDiscuss.open();
                    $scope.win_ModalReportNDiscuss.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    $scope.win_ModalReportNDiscuss.wrapper.addClass("report-top-mdl");
                    var timeout = $timeout(function () {
                        $scope.win_ModalReportNDiscuss.center();
                    }, 100);
                    TimeoutList.push(timeout);
                }
            }
            else {
                $scope.currentWindow = 'win_Discussion';
                $scope.win_Discussion.open();
                $scope.win_Discussion.wrapper.prev(".k-overlay").addClass("custom-overlay");
                $scope.win_Discussion.wrapper.addClass("report-top-mdl");
                var timeout = $timeout(function () {
                    $scope.win_Discussion.center();
                }, 100);
                TimeoutList.push(timeout);
            }
            if ($scope.showDiscuss) {
                if ($scope.isReportAvailable) {
                    //selectPriorReportTab("#tabReport");
                    $scope.DataObject.ModalReportNDiscussActiveIndex = 0;
                }
                else if ($scope.OrderReport && $scope.OrderReport.FileCount > 0) {
                    //selectPriorReportTab("#tabDiscussion");
                    $scope.DataObject.ModalReportNDiscussActiveIndex = 2;
                    $scope.DataObject.Reference.ID = null;
                    $scope.showAttachment = true;
                    $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
                }
                else {
                    //selectPriorReportTab("#tabDiscussion");
                    $scope.DataObject.ModalReportNDiscussActiveIndex = 1;
                }
            }
            $scope.DataObject.Loading = false;
        };
        function hidePopover() {
            $scope.popoverDicomOrderID = null;
            $scope.Discussions = [];
        }
        function LoadPopOverDiscussion(discussion) {
            var d = $q.defer();
            WorklistService.GetDiscussions(discussion).then(function (response) {
                $scope.AllDiscussions = _.clone(response);
                $scope.Discussions = _.filter(response, function (item) { return item.Type == 1; });

                angular.forEach($scope.Discussions, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
                d.resolve();
            }).catch(function (noCantDo) {
                d.resolve();
            });
            return d.promise;
        }
        function LoadChildDiscussion(ObjDiscussion) {
            var response = _.filter($scope.AllDiscussions, function (item) { return item.ReferenceID == ObjDiscussion.ID; });
            if (response && (response.length > 0)) {
                if (!ObjDiscussion.Childs || ObjDiscussion.Childs.length != response.length) {
                    ObjDiscussion.Childs = response;
                }
                angular.forEach(ObjDiscussion.Childs, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            }
        }
        function prepareChildDiscussionHTML(discussion, sender) {
            var htmlpop = '';
            if (discussion.Childs && discussion.Childs.length > 0) {
                _.each(discussion.Childs, function (childdiscussion) {
                    var childName = _discussionDisplayName(childdiscussion);
                    if (sender) {
                        htmlpop = htmlpop + '<div class="replaysection mr-15px w-80 pull-left">' +
                            '<div style="background-color: #2F4858 !important;" ' +
                            'class="comment pos-rel border text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    } else {
                        htmlpop = htmlpop + '<div class="replayreceiver mr-15px w-80 pull-right">' +
                            '<div style="background-color: #6c6868 !important;" ' +
                            'class="comment receiverborder pos-rel text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    }

                    htmlpop = htmlpop + prepareChildDiscussionHTML(childdiscussion, sender);
                });
            }
            return htmlpop;
        }
        function LoadDiscussion(discussion) {
            WorklistService.GetDiscussions(discussion).then(function (response) {
                $scope.AllDiscussions = _.clone(response);
                $scope.Discussions = _.filter(response, function (item) { return item.Type == 1; });
                var ClipboardFlag = !(($scope.DataObject.worklist.WorklistType != 16 && !$scope.DataObject.worklist.ChooseNextStudy) || ($scope.DataObject.worklist.WorklistType == 16 && !$scope.DataObject.worklist.OpenClipboardNextStudy));
                if ($scope.showDiscuss && (ClipboardFlag ? ($scope.isReportAvailable || ($scope.Discussions && $scope.Discussions.length > 0) || $scope.OrderReport.FileCount > 0) : true)) {
                    angular.element('#ModalReportNDiscuss').modal('show');
                    if ($scope.showDiscuss) {
                        $scope.currentWindow = "win_ModalReportNDiscuss";
                        $scope.win_ModalReportNDiscuss.open();
                        $scope.win_ModalReportNDiscuss.wrapper.prev(".k-overlay").addClass("custom-overlay");
                        var timeout = $timeout(function () {
                            $scope.win_ModalReportNDiscuss.center();
                        }, 100);
                        TimeoutList.push(timeout);
                    } else {
                        $scope.currentWindow = 'win_Discussion';
                        $scope.win_Discussion.open();
                        $scope.win_Discussion.wrapper.prev(".k-overlay").addClass("custom-overlay");
                        $scope.win_Discussion.wrapper.addClass("report-top-mdl")
                        var timeout = $timeout(function () {
                            $scope.win_Discussion.center();
                        }, 100);
                        TimeoutList.push(timeout);
                    }
                }
                $scope.DiscussionSelectedOrder = _.clone($scope.SelectedOrder);
                angular.forEach($scope.Discussions, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            });
        }
        function RemoveFromComparison(ComparisonOrderID, OrderID) {
            if (confirm("Are you sure you want remove this study from comparison?")) {
                $scope.DataObject.Loading = true;
                var comparisonOrder = {
                    ComparisonOrderID: ComparisonOrderID,
                    OrderID: OrderID,
                    UserId: $sessionStorage.currentUserData.userId
                };

                WorklistService.RemoveFromComparison(comparisonOrder).then(function (result) {
                    $scope.DataObject.Loading = false;

                    var idx = _.findIndex(OrderList, function (obj) { return obj.OrderID == OrderID; });
                    if (idx != -1) {
                        var compidx = _.findIndex(OrderList[idx].ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderID; });
                        if (compidx != -1) {
                            OrderList[idx].ComparisonOrder.splice(compidx, 1);
                            if (OrderList[idx].ComparisonOrder.length == 0) {
                                OrderList[idx].HasComparison = "0";
                                UpdateGridData(OrderList[idx].OrderID);
                            } else {
                                var detailNode = gridOptions.api.getDetailGridInfo("detail_" + OrderList[idx].ID);
                                detailNode.api.setRowData(OrderList[idx].ComparisonOrder);
                            }

                        }
                    }
                });
            }
        };
        function HideOrder() {
            if ($scope.SelectedOrderID != null && $scope.SelectedOrderID.length > 0 && $scope.SelectedOrder != null &&
                ($scope.SelectedOrder.Status == 'RP' || $scope.SelectedOrder.Status == 'H') && ($scope.SelectedOrder.IsLock == false || $sessionStorage.currentUserData.userId == $scope.SelectedOrder.LockByProviderID)) {
                if ($scope.SelectedOrder.Status != "H") {

                    $scope.DataObject.HideOption.Key = _.clone($scope.DataObject.HiddenTypeList[0].Key);
                    $scope.DataObject.HideOption.Comments = '';
                    $scope.currentWindow = "win_HideStudy";
                    $scope.isHideStudyVisible = true;
                    OpenWindow($scope.win_HideStudy, '#win_HideStudy');
                    $scope.win_HideStudy.wrapper.prev(".k-overlay").addClass("custom-overlay");
                }
                else {
                    HideUnhideOrder();
                }
            }
        };
        function HideUnhideOrder(type, FromQueryRetrieve) {
            $scope.DataObject.Loading = true;
            var order = {
                OrderID: $scope.SelectedOrderID,
                IsHide: $scope.SelectedOrder.Status == 'H' ? false : true,
                Type: type,
                Min: 0,
                UserId: $sessionStorage.currentUserData.userId,
                PhysicianName: $sessionStorage.currentUserData.displayName,
                order: $scope.SelectedOrder,
                Comments: $scope.DataObject.HideOption.Comments,
                HideType: $scope.DataObject.HideOption.Key,
            };
            switch (type) {
                case 1:
                    order.EventType = 'HNR';
                    break;
                case 2:
                    order.EventType = 'HHR';
                    break;
                case 3:
                    order.EventType = 'HNC';
                    break;
                case 4:
                    order.EventType = 'HNI';
                    break;
                case 5:
                    order.EventType = 'HMP';
                    break;
                case 6:
                    order.EventType = 'HMO';
                    break;
                case 7:
                    order.EventType = 'HMCT';
                    break;
                case 8:
                    order.EventType = 'HEM';
                    break;
            }
            WorklistService.ShowHideOrder(order).then(function (result) {
                $scope.DataObject.Loading = false;
                if ((type >= 3 && type <= 8) && $scope.DataObject.HideOption
                    && $scope.DataObject.HideOption.Comments
                    && $scope.DataObject.HideOption.Comments.length > 0) {
                    $scope.Discussion = {
                        ReferenceID: $scope.SelectedOrder.DicomOrderID,
                        Type: 1,
                        Comment: $scope.DataObject.HideOption.Key + ' - ' + $scope.DataObject.HideOption.Comments,
                        Record_Created_By: $sessionStorage.currentUserData.userId,
                    };
                    $scope.SaveDiscussion(order.EventType);
                }
                else if (type == 1) {
                    $scope.Discussion = {
                        ReferenceID: $scope.SelectedOrder.DicomOrderID,
                        Type: 1,
                        Comment: $scope.DataObject.HideOption.Key,
                        Record_Created_By: $sessionStorage.currentUserData.userId,
                    };
                    $scope.SaveDiscussion(order.EventType);
                }

                $scope.SelectedOrderID = "";
                $scope.win_HideStudy.close();
                //$scope.refresh();
                if (type >= 3 && type <= 8) {
                    WorklistService.sendTextNotification(order);
                }

            });
            //Auto Query Retrieve
            if ($sessionStorage.IsQueryRetrieveVisible && type == 4 && !FromQueryRetrieve) {
                $scope.QueryRetrieve($scope.SelectedOrder, false).then(function (result) {
                    if ($scope.DataObject.QueryRetriveObj && $scope.DataObject.QueryRetriveObj.patients) {
                        _.each($scope.DataObject.QueryRetriveObj.patients, function (patient) {
                            _.each(patient.studies, function (study) {
                                if (study.AccessionNumber == $scope.DataObject.QueryRetrieve.Accession) {
                                    if (_.toInteger($scope.SelectedOrder.ImageInstance) < _.toInteger(patient.InstanceCount)) {
                                        $scope.DataObject.QueryRetrieve.SelectedStudies.push(study);
                                        $scope.MoveInstance(true);
                                    }
                                }
                            });
                        });
                    }
                });
            }
        }
        // Task 173042 - baseline of the assigned user ids as last loaded from the server for the order
        // shown in the Open Discussion window. Taken from the same prepareOrderDiscussionUsers() output
        // that populates the 'Assign to:' tree, so the comparison cannot be thrown off by group
        // assignments being expanded into individual users - which is why the order's
        // listOrderListAssignment is deliberately NOT used as the baseline.
        var orderAssignmentBaselineIDs = null;
        function orderAssignmentSelectionIDs() {
            var selectedUsers = ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedUsers) ? $scope.OrderDiscussion.SelectedUsers : [];
            return _.map(selectedUsers, 'Id').sort();
        }
        function captureOrderAssignmentBaseline() {
            orderAssignmentBaselineIDs = orderAssignmentSelectionIDs();
        }
        // Sorted, so merely reordering the selection is not mistaken for an edit. Returns false when no
        // baseline has been captured, so an entry point that never loaded an assignment cannot block.
        function isOrderAssignmentChanged() {
            if (!orderAssignmentBaselineIDs) {
                return false;
            }
            return !_.isEqual(orderAssignmentBaselineIDs, orderAssignmentSelectionIDs());
        }
        $scope.SaveDiscussion = function (EventType) {
            // Task 173042 - changing the 'Assign to:' users in the Open Discussion window is restricted
            // to Admin and SuperAdmin. That control writes through SetOrderDiscussionAssignment, which
            // clears and rewrites the order's whole assignment, so it is a second route to unassigning
            // a study.
            // The check is made here, on Save, rather than on the dropdowntree 'change' event, so the
            // control stays fully usable and a user without the role can still open the window and
            // inspect who is assigned - they are only told when they try to commit the change. Nothing
            // is saved when it fires, and LoadOrderDiscussionForUser() puts the real assignment back
            // into the tree so the window is never left showing an edit that was not applied.
            // isOrderAssignmentChanged() keeps this off every other path: the Hide Study flows reuse
            // SaveDiscussion to write a comment without touching assignment, and must work for all roles.
            if (isOrderAssignmentChanged() && !isAdminOrSuperAdminUser()) {
                toaster.error('Only an Admin or SuperAdmin can change the assigned users. Please contact your administrator.');
                $scope.SaveDiscussionFlag = false;
                $scope.DataObject.Loading = false;
                LoadOrderDiscussionForUser();
                return;
            }
            $scope.DataObject.Loading = true;
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedUsers) {
                $scope.SaveDiscussionFlag = true;
                $scope.AssignStudy(EventType);
            }
            if ($scope.Discussion.Comment) {
                $scope.SaveDiscussionFlag = true;
                $scope.Discussion.EventType = EventType ? EventType : 'WC';
                WorklistService.SetDiscussion($scope.Discussion).then(function (response) {
                    $scope.SelectedOrder.IsDiscussion = true;
                    $scope.showDiscuss = false;
                    LoadDiscussion(response);
                    $scope.Discussion.Comment = null;
                    $scope.SaveDiscussionFlag = false;
                    var idx = _.findIndex(OrderList, { OrderID: $scope.SelectedOrder.OrderID });
                    if (idx != -1) {
                        OrderList[idx].IsDiscussion = true;
                    }
                    UpdateGridData($scope.SelectedOrder.OrderID);
                });
            }
            $scope.DataObject.Loading = false;
        };
        $scope.AssignStudy = function (EventType) {
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];
                $scope.SelectedOrder.listOrderListAssignment = [];

                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_STUDY_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var userOfGroup = _.filter($scope.OrderDiscussion.SelectedUsers, function (item) { return item.SpecialityId == obj.SpecialityId; });

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode,
                        TotalUsersOfGroup: userOfGroup.length
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });


                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'I',
                    Order: $scope.SelectedOrder,
                    EventType: EventType ? EventType : 'WC',
                };
                //$scope.isLoading = true;


                WorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                    LoadOrderDiscussionForUser();
                    $scope.SaveDiscussionFlag = false;
                });
            }
        };
        function NotifyToUser(msg, orderID, toUserID, status) {
            var data = {
                OrderID: orderID,
                FromUserID: $sessionStorage.currentUserData.userId,
                FromUser: $sessionStorage.currentUserData.displayName,
                ToUserID: toUserID,
                Status: status,
                Message: msg
            }
            WorklistService.NotifyToUser(data).then(function (response) {
            });
        }
        function HelpOrder() {
            if ($scope.SelectedOrder && $scope.SelectedOrder.DicomOrderID) {
                $scope.DataObject.ShowAttachmentTab = false;
                if ($scope.SelectedOrder && $scope.SelectedOrder.FileCount > 0) {
                    $scope.onDiscussionWindowTabChange('Attachment');
                    $scope.DataObject.ShowAttachmentTab = true;
                }
                $scope.ODType = 'Assigner';
                $scope.OrderDiscussion = null;
                $('#ModalDiscussion').modal('show');
                $scope.showDiscuss = false;
                $q.all([
                    GetAllUsers($scope.SelectedOrder.SiteID)
                ]).then(function (data) {
                    $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID, 'Assigner');
                    LoadOrderDiscussionForUser();
                    if ($scope.DataObject.ShowAttachmentTab && $scope.DataObject.DiscussionWindowActiveTab === 'Attachment' && $scope.Discussion) {
                        $scope.DataObject.Reference.ID = null;
                        $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
                    }
                });
            }
        }
        function GetAllUsers(SiteID) {
            var d = $q.defer();
            var filter = {
                SiteID: SiteID
            };
            WorklistService.GetRadiologistsBySite(filter).then(function (result) {
                $scope.DataObject.masterData.Radiologists = _.filter(result.radiologistsLists || [], function (r) {
                    return _isSelf(r.Id || r.UserID) || !_hasPrelimRad(r.UserRoles || r.Roles);
                });
                specialityAssignments = result.specialityAssignments;
                $scope.DataObject.masterData.RadiologistsGroups = [];
                var mRadiologistsGroups = [];

                var uniqueSpeciality = _.uniqBy(specialityAssignments, 'SpecialityId');
                _.each(uniqueSpeciality, function (obj) {

                    var RadiologistsGroup = {};
                    RadiologistsGroup['Id'] = obj.SpecialityId;
                    RadiologistsGroup['UserName'] = obj.SpecialityCode;
                    RadiologistsGroup['Group'] = "YES";
                    mRadiologistsGroups.push(RadiologistsGroup);


                });

                _.each(specialityAssignments, function (speciality) {
                    var user = _.find($scope.DataObject.masterData.Radiologists, { 'Id': speciality.UserId });
                    if (user) {
                        if (!user.Specialities) {
                            user.Specialities = [];
                        }
                        var spclty = _.find(user.Specialities, { SpecialityId: speciality.SpecialityId });
                        if (!spclty) {
                            user.Specialities.push(speciality);
                        }
                    }
                });

                mRadiologistsGroups.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                $scope.DataObject.masterData.Radiologists.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                mRadiologistsGroups = mRadiologistsGroups.concat($scope.DataObject.masterData.Radiologists);

                $scope.DataObject.masterData.RadiologistsGroups = mRadiologistsGroups;

                d.resolve();
            });
            return d.promise;


        };

        function isVisibleRad(r) {
            if (!r) return false;
            if (_isSelf(r.Id || r.UserID)) return true;
            return !_hasPrelimRad(r.UserRoles || r.Roles);
        }
        $scope.isVisibleRad = isVisibleRad;
        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        $scope.radDisplay = function (r) {
            if (!r) return '';
            if (!_isSelf(r.Id || r.UserID) && _hasPrelimRad(r.UserRoles || r.Roles)) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
        $scope.disName = function (dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        };
        function _findRadByUserId(userId, rads) {
            if (!userId || !rads || !rads.length) return null;
            return _.find(rads, function (r) {
                return (r.Id || r.UserID || '').toLowerCase() === userId.toLowerCase();
            });
        }
        function _isPrelimRadAssignment(userId) {
            if (!userId || _isSelf(userId)) return false;
            var rad = _findRadByUserId(userId, $scope.DataObject && $scope.DataObject.masterData && $scope.DataObject.masterData.Radiologists)
                || _findRadByUserId(userId, RuleSharedService.GetCachedRadiologists());
            if (!rad) {
                RuleSharedService.RequestTenantRadiologistsIfNeeded();
            }
            return rad ? _hasPrelimRad(rad.UserRoles || rad.Roles) : false;
        }
        function _assignmentName(userId, name) {
            return _isPrelimRadAssignment(userId) ? '' : name;
        }
        function _discussionDisplayName(dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        }

        function LoadOrderDiscussionForUser() {
            $scope.orderDiscussionTooltip = '';
            var data = {
                OrderID: $scope.SelectedOrder.OrderID,
                FromUserID: $sessionStorage.currentUserData.userId
            };
            $scope.DataObject.Loading = true;
            $scope.isAssigner = true;
            $scope.OrderDiscussion = {};
            WorklistService.GetOrderDiscussionAssignment(data).then(function (response) {
                $scope.DataObject.Loading = false;
                if (response) {
                    $scope.OrderDiscussion = response;
                    $q.all([
                        GetAllUsers($scope.SelectedOrder.SiteID)
                    ]).then(function (data) {
                        if (!$scope.OrderDiscussion.SelectedUsers && !$scope.OrderDiscussion.SelectedRadioLogistsGroup) {
                            $scope.OrderDiscussion.SelectedUsers = [];
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                            var SelectedRadioLogistsGroup = [];
                            _.each($scope.OrderDiscussion.OrderAssignments, function (orderAssignment) {
                                if (orderAssignment.ProviderSpecialityId > 0) {
                                    var radiologistGroup = _.find($scope.DataObject.masterData.RadiologistsGroups, { Id: orderAssignment.ProviderSpecialityId.toString() });
                                    if (radiologistGroup) {
                                        SelectedRadioLogistsGroup.push(radiologistGroup);
                                    }
                                } else {
                                    var radiologistGroup = _.find($scope.DataObject.masterData.RadiologistsGroups, { Id: orderAssignment.ProviderID });
                                    if (radiologistGroup) {
                                        SelectedRadioLogistsGroup.push(radiologistGroup);
                                    }
                                }
                            });
                            var uniqueSelectedRadioLogistsGroup = _.uniqBy(SelectedRadioLogistsGroup, 'Id');
                            var orderedSelectedRadioLogistsGroup = _.concat(_.orderBy(_.filter(uniqueSelectedRadioLogistsGroup, function (srlg) { return srlg.Group && srlg.Group == 'YES'; }), ['UserName'], ['asc']), _.orderBy(_.filter(uniqueSelectedRadioLogistsGroup, function (srlg) { return !srlg.Group; }), ['UserName'], ['asc']));
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup = orderedSelectedRadioLogistsGroup;

                            $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();
                            captureOrderAssignmentBaseline();

                            var timeout = $timeout(function () {
                                $scope.isAssigner = false;
                                setOrderDiscussionUserGroup().then(function (data) {
                                    setOrderDiscussionTooltip();
                                    setSelectedUserAssignment(data);

                                    $timeout.cancel(timeout);
                                    timeout = null;
                                });
                            }, 100);
                        }

                    });
                    if ($scope.OrderDiscussion.ID
                        && $scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId
                        && $scope.OrderDiscussion.Status == 'A') {
                        $scope.OrderDiscussion.Status = 'C';
                        WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                        });
                    }
                } else {
                    GetAllUsers($scope.SelectedOrder.SiteID)
                }
            });
        }
        function setOrderDiscussionUserGroup() {
            var d = $q.defer();
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedRadioLogistsGroup) {
                var usergroups = _.map($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (radiologistGroup) {
                    return radiologistGroup.Id;
                });


                d.resolve(usergroups);
            } else {
                d.resolve();
            }
            return d.promise;
        }

        function setOrderDiscussionTooltip() {
            $scope.orderDiscussionTooltip = '';
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedRadioLogistsGroup && $scope.OrderDiscussion.SelectedRadioLogistsGroup.length > 0) {


                _.each($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (obj) {
                    if (obj && obj.Group && obj.Group == "YES") {
                        if (!_isPrelimRadAssignment(obj.Id)) {
                            $scope.orderDiscussionTooltip += obj.UserName + "\n";
                        }
                    } else {
                        var selectedUserIndex = _.findIndex($scope.OrderDiscussion.SelectedUsers, { 'Id': obj.Id });
                        if (selectedUserIndex != -1) {
                            if ($scope.OrderDiscussion.SelectedUsers[selectedUserIndex].IsUserWithSpecialityGroup == 2) {
                                if (!_isPrelimRadAssignment(obj.Id)) {
                                    $scope.orderDiscussionTooltip += obj.UserName + "\n";
                                }
                            }
                        }
                    }
                });
            }
            angular.element(document).ready(function () {
                angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "hidden");
                if ($scope.orderDiscussionTooltip.length > 0) {
                    angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "visible");
                }

            });
        }
        $scope.CancelHideStudy = function () {
            $scope.win_HideStudy.close();
        };
        $scope.HideStudy = function (Comments) {
            var type = parseInt(_.find($scope.DataObject.HiddenTypeList, { Key: $scope.DataObject.HideOption.Key }).Value);
            $scope.DataObject.HideOption.Comments = Comments;
            HideUnhideOrder(type);
            //$scope.isLoading = true;
        };
        function formatted_date(date) {
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' == (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        $scope.showFileList = function () {
            $scope.showAttachment = true;
            if ($scope.Discussion) {
                $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
            }
        }
        $scope.hideFileList = function () {
            $scope.showAttachment = false;
            setOrderDiscussionUserGroup().then(function (data) {
                setOrderDiscussionTooltip();
                setSelectedUserAssignment(data);
            });
        }
        $scope.onCloseConsultExamWindowHandler = function (newCheck) {
            $scope.isConsultExamsWindow = newCheck;
            if ($scope.isConsultExamsWindow == true) {
                $scope.win_consultExamsWindow.close();
            }
        };
        $scope.OpenSignReport = function (Order, OrderList) {
            //console.log("OpenSignReport");
            //clearSelection();
            if (_isOpeningStudy) { return; }
            _isOpeningStudy = true;

            vm.selectedData.CloseWindow = true;
            //$scope.SingReport.Index = index;
            $scope.DataObject.SingReport.Order = _.clone(Order);
            $scope.DataObject.SingReport.OrderList = _.clone(OrderList);
            vm.selectedData.RuleID = $scope.DataObject.worklist.RuleID;
            vm.selectedData.ChooseNextStudy = $scope.DataObject.worklist.ChooseNextStudy;


            var idx = _.findIndex($scope.DataObject.SingReport.OrderList, { IsDeficient: true });
            if ($scope.DataObject.SingReport.Order.IsDeficient) {
                idx = null;
            }

            $q.all([
                WarnDeficientCorrection(idx)
            ]).then(function (data) {
                if (data != null && data.length > 0 && data[0] == true) {
                    $scope.DataObject.SingReport.Order = $scope.DataObject.SingReport.OrderList[idx];
                }
                //console.log("OpenSignReport > Order: ", $scope.DataObject.SingReport.Order);
                if ($scope.DataObject.SingReport.Order.IsDeficient) {
                    WorklistService.GetDeficientErrorByOrderID($scope.DataObject.SingReport.Order.OrderID).then(function (result) {
                        if (result != null && result.length > 0) {
                            var i = 1;
                            var errorstring = "";
                            result.forEach(function (error) {
                                if (errorstring && errorstring.length > 0) {
                                    errorstring += "<tr><td>" + i + ": " + error.DeficientErrorDesc + "</td></tr>";
                                    i++;
                                }
                                else {
                                    errorstring = "<table style='text-align: left;'><tr><td>" + i + ": " + error.DeficientErrorDesc + "</td></tr>";
                                    i++;
                                }
                            });
                            if (errorstring && errorstring.length > 0) errorstring += "</table>";
                            //$scope.isLoading = false;
                            var timeout = $timeout(function () {
                                swal({
                                    title: 'Please correct the below deficiency in the report.',
                                    text: errorstring,
                                    type: "warning",
                                    html: true,
                                    customClass: 'swal-wide',
                                    showCancelButton: true,
                                    confirmButtonColor: "#DD6B55", confirmButtonText: "Ok",
                                    cancelButtonText: "Ignore",
                                },
                                    function (isConfirm) {
                                        if (!isConfirm) {
                                            $scope.DataObject.SingReport.Order.CheckDeficiency = 0;
                                        }
                                    });
                            }, 500);
                            TimeoutList.push(timeout);
                        }
                    });
                }
                $scope.GetDicomViewerCredentialsCallFrom = "OPENSINGREPORT";
                //if (vm.selectedData.DefaultDicomViewer != null && vm.selectedData.DefaultDicomViewer.toString().length > 0) {
                //    $scope.DataObject.SingReport.Order.DicomViewer = vm.selectedData.DefaultDicomViewer;
                //}
                OpenOrder = {};
                var _priority = ($scope.DataObject.SingReport.Order.Priority || '').toUpperCase().trim();
                var _isStatStudy = $scope.DataObject.SingReport.Order.IsStat || _priority.includes('STAT');
                if (__env.EnableEnforceReads && GetStatus() === 'RP' && !_isStatStudy) {
                    GetEnforceReadsEvaluate($scope.DataObject.SingReport.Order).then(function () {
                        ShowEnforceReadsPromptIfNeeded(OpenOrder);
                    });
                }
                $q.all([
                    GetDicomViewerCredentials($scope.DataObject.SingReport.Order.SiteID, $scope.DataObject.SingReport.Order.DicomViewer),
                    VerfiyReadStudy($scope.DataObject.SingReport.Order.OrderID, vm.selectedData.LoggedInUserID),
                    GetClipboardDetailByOrderID($scope.DataObject.SingReport.Order.OrderID)
                ]).then(function (data) {
                    if (data != null && data.length > 0 && data[0] != null) {
                        if (data[0].ShowModal) { _isOpeningStudy = false; return; }
                        $scope.DataObject.SingReport.Order.DicomViewerCredentials = data[0].Credentials;
                        if (Order.ProcessError) {
                            _isOpeningStudy = false;
                            swal("Study not available.");
                            return;
                        }
                        $scope.RetrySignReport = false;
                        VerifyOpenOrder(OpenOrder);
                    }
                    else { _isOpeningStudy = false; return; }
                });
            });
        };
        function clearSelection() {
            try {
                if (document.selection && document.selection.empty) {
                    document.selection.empty();
                } else if (window.getSelection) {
                    var sel = window.getSelection();
                    sel.removeAllRanges();
                }
            } catch (error) {
            }

        };
        function WarnDeficientCorrection(index) {
            var d = $q.defer();
            var out = false;
            if (index != null && index != -1 && vm.selectedData.DeficientWarningOnWorklist) {
                swal({
                    title: 'There are deficient reports in worklist.',
                    text: 'Are you sure you want to correct them?',
                    type: "warning",
                    html: true,
                    customClass: 'swal-wide',
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Ok",
                    cancelButtonText: "Skip",
                },
                    function (isConfirm) {
                        if (isConfirm) {
                            out = true;
                        }
                        else {
                            out = false;
                        }
                        d.resolve(out);
                    });
            }
            else {
                d.resolve(out);
            }
            return d.promise;
        }
        function GetDicomViewerCredentials(SiteID, ViewerName) {
            $scope.DVCred = {};
            var d = $q.defer();
            var out = {};
            var objFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: SiteID,
                ViewerName: ViewerName
            };
            if (__env.CheckDicomViewerCredentials.split(',').indexOf(ViewerName) !== -1) {
                out.RequiredCredentials = true;
                var cacheKey = SiteID + '|' + ViewerName;
                if (dvCredentialsCache[cacheKey]) {
                    d.resolve(angular.copy(dvCredentialsCache[cacheKey]));
                    return d.promise;
                }
                WorklistService.GetDicomViewerCredentials(objFilter).then(function (result) {
                    if (result != null && result.length > 0) {
                        out.RequiredCredentials = true;
                        out.ShowModal = false;
                        out.Credentials = {};
                        out.Credentials.UserName = result[0].UserName;
                        out.Credentials.Password = result[0].Password;
                        dvCredentialsCache[cacheKey] = out;
                    }
                    else {
                        out.ShowModal = true;
                        $scope.DVCred.SiteID = SiteID;
                        $scope.DVCred.ViewerName = ViewerName;
                        $('#ModalDicomViewerCredentials').modal('show');
                    }
                    d.resolve(out);
                });
            }
            else {
                out.RequiredCredentials = false;
                out.ShowModal = false;
                d.resolve(out);
            }
            return d.promise;
        }
        // Shared helper used by NextRec when no valid next order exists on the current page.
        // Loads the next page if available, otherwise disables the Next button and shows a toaster.
        function tryLoadNextPageOrDisable() {
            if (!$scope.DataObject.worklist.OpenClipboardNextStudy) {
                var pages = $scope.TotalRows / $scope.DataObject.worklist.PageSize;
                if (PageNo < pages) {
                    $scope.DataObject.ShowPrevNextBtn = false;
                    PageNo++;
                    $q.all([
                        refresh()
                    ]).then(function (data) {
                        $scope.DataObject.SingReport.OrderList = _.concat($scope.DataObject.SingReport.OrderList, data[0]);
                        var uniqueOrderList = _.uniqBy($scope.DataObject.SingReport.OrderList, 'OrderID');
                        $scope.DataObject.SingReport.OrderList = uniqueOrderList;
                        _isOpeningStudy = false;
                        NextRec();
                    });
                } else {
                    _isOpeningStudy = false;
                    $scope.DataObject.ShowPrevNextBtn = true;
                    $scope.DataObject.NoNextOrder = true;
                    $scope.DataObject.SingReport.NextToolTip = $sce.trustAsHtml('<span class="prevnxttt-lblno fs-12px">No Order</span>');
                    toaster.pop('warning', 'Choose Next Study', 'No more available orders to read.');
                }
            } else {
                _isOpeningStudy = false;
                $scope.DataObject.ShowPrevNextBtn = true;
                $scope.DataObject.NoNextOrder = true;
                $scope.DataObject.SingReport.NextToolTip = $sce.trustAsHtml('<span class="prevnxttt-lblno fs-12px">No Order</span>');
                toaster.pop('warning', 'Choose Next Study', 'No more available orders to read.');
            }
        }

        // The manual open path (VerifyOpenOrder) swaps in the site/radiologist viewer override
        // before launching. Next/Prev have to do the same: otherwise the next study launches in
        // the order's default viewer while the current one sits in the override viewer, and a
        // second viewer window (e.g. MedDream) appears on auto-next. A failed lookup falls back
        // to the order's own viewer, as VerifyOpenOrder does.
        function applyMedDreamViewerOverride(order) {
            return WorklistService.GetMedDreamViewerOverrideByStudy({
                SiteID: order.SiteID,
                RadiologistUserID: vm.selectedData.LoggedInUserID
            }).then(function (response) {
                if (response && response.data && response.data.HasOverride === true) {
                    order.DicomViewer = response.data.DicomViewer;
                }
            }, function () { });
        }

        function NextRec(nextIdx) {
            vm.selectedData.CloseWindow = true;
            if (!$scope.DataObject.SingReport || !$scope.DataObject.SingReport.OrderList) {
                _isOpeningStudy = false;
                return;
            }

            // Re-entry guard — only block duplicate initial calls, not recursive skip calls
            if (nextIdx === undefined) {
                if (_isOpeningStudy) { return; }
                _isOpeningStudy = true;
                var currentIdx = _.findIndex($scope.DataObject.SingReport.OrderList, function (a) { return a.OrderID == $scope.DataObject.SingReport.Order.OrderID });
                nextIdx = currentIdx + 1;
            }

            // Skip statically restricted orders
            while (nextIdx < $scope.DataObject.SingReport.OrderList.length
                && isOrderRestrictedForCurrentUser($scope.DataObject.SingReport.OrderList[nextIdx])) {
                nextIdx++;
            }

            // No valid next order found — try loading next page or disable the button
            if (nextIdx >= $scope.DataObject.SingReport.OrderList.length) {
                tryLoadNextPageOrDisable();
                return;
            }

            var nextOrderID = $scope.DataObject.SingReport.OrderList[nextIdx].OrderID;
            var openOrders = { OrderId: nextOrderID, ProviderID: $sessionStorage.currentUserData.userId };
            var lockPromise = _nextOrderLockCache[nextOrderID] || WorklistService.GetOpenOrder(openOrders);
            delete _nextOrderLockCache[nextOrderID];
            lockPromise.then(function (result) {
                if (result && result.length > 0) {
                    // Order is locked — skip it without touching the scope or modal
                    NextRec(nextIdx + 1);
                }
                else {
                    // Order is free — apply the viewer override (as the manual open path does), then
                    // fetch credentials for the effective viewer (uses cache when available, fetches on miss)
                    var nextOrder = $scope.DataObject.SingReport.OrderList[nextIdx];
                    applyMedDreamViewerOverride(nextOrder).then(function () {
                        return GetDicomViewerCredentials(nextOrder.SiteID, nextOrder.DicomViewer);
                    }).then(function (credResult) {
                        if (credResult && !credResult.ShowModal && credResult.Credentials) {
                            nextOrder.DicomViewerCredentials = credResult.Credentials;
                        }
                        $scope.DataObject.SingReport.LastOrder = _.clone($scope.DataObject.SingReport.Order);
                        $scope.DataObject.SingReport.Order = nextOrder;
                        setSelected($scope.DataObject.SingReport.Order.OrderID, $scope.DataObject.SingReport.Order);
                        $scope.onClearFilterReportList(true);
                        if ($scope.DataObject.ModalReportNDiscussActiveIndex == 0) {
                            $scope.ReportSelectedOrder = _.clone($scope.SelectedOrder);
                        }
                        else if ($scope.DataObject.ModalReportNDiscussActiveIndex == 1 || $scope.DataObject.ModalReportNDiscussActiveIndex == 2) {
                            $scope.DiscussionSelectedOrder = _.clone($scope.SelectedOrder);
                        }
                        if (LastOpenedOrderID != null) {
                            DeleteOpenOrder();
                        }
                        InsertOpenOrder();
                        $scope.DataObject.ShowPrevNextBtn = true;
                        if ($scope.DataObject.SingReport.LastOrder) {
                            var OrderExistsIdx = _.findIndex($scope.DataObject.SingReport.OrderList, function (a) { return a.OrderID == $scope.DataObject.SingReport.LastOrder.OrderID });
                            if (OrderExistsIdx == -1) {
                                _.remove($scope.DataObject.SingReport.OrderList, { OrderID: $scope.DataObject.SingReport.LastOrder.OrderID });
                            }
                        }
                        SetSignREportModal($scope.DataObject.SingReport.Order, $scope.DataObject.SingReport.OrderList);
                    }).catch(function () { _isOpeningStudy = false; });
                }
            }).catch(function () { _isOpeningStudy = false; });
        };
        function Call_SetSignREportModal() {
            _isOpeningStudy = false;
            if ($scope.LastOpenedOrder) {
                $rootScope.$broadcast('event.closeDicomViewer', { 'Accession': $scope.LastOpenedOrder.Accession });
            }
            if (LastOpenedOrderID != null && LastOpenedOrderID != $scope.DataObject.SingReport.Order.OrderID) {
                removeOrderFromList(LastOpenedOrderID);
                DeleteOpenOrder();
            }
            InsertOpenOrder();
            SetSignREportModal($scope.DataObject.SingReport.Order, $scope.DataObject.SingReport.OrderList);
            if (($scope.DataObject.worklist.WorklistType != 16 && !$scope.DataObject.worklist.ChooseNextStudy) ||
                ($scope.DataObject.worklist.WorklistType == 16 && !$scope.DataObject.worklist.OpenClipboardNextStudy)) {
                $scope.DataObject.ShowPrevNextBtn = true;
            }
        };
        function DeleteOpenOrder(Order, IsUnlocked) {
            //console.log("DeleteOpenOrder > Order: ", Order);
            var lastOrderID;
            var LastOpenedOrder;
            if (Order) {
                lastOrderID = Order.OrderID;
                LastOpenedOrder = Order;
            } else {
                lastOrderID = LastOpenedOrderID;
                LastOpenedOrder = $scope.LastOpenedOrder;
            }

            if (lastOrderID) {
                LastOpenedOrderID = null;
                $scope.LastOpenedOrder = null;
                var openOrders = {
                    OrderId: lastOrderID,
                    UserId: $sessionStorage.currentUserData.userId,
                    IsUnlocked: IsUnlocked
                };
                WorklistService.DeleteOpenOrder(openOrders).then(function (result) {
                    if ((LastOpenedOrder)
                        && DictationReportState == "DictateByPS360"
                        && ($scope.NativeMessageResponseReportStatus == 2
                            || $scope.NativeMessageResponseReportStatus == 8)) {

                        var applyRadflowComplete = false;
                        if (vm.selectedData.DefaultDictationSystem.length == 0
                            || vm.selectedData.DefaultDictationSystem == 'PS360') {
                            applyRadflowComplete = true;
                        } else if ((LastOpenedOrder.DictationSystem
                            && LastOpenedOrder.DictationSystem.length == 0)
                            || LastOpenedOrder.DictationSystem == 'PS360') {
                            applyRadflowComplete = true;
                        }

                        //console.log("DeleteOpenOrder > applyRadflowComplete: ", applyRadflowComplete);
                        if (applyRadflowComplete) {
                            var reportView = {
                                Site: LastOpenedOrder.Site,
                                PSSiteName: LastOpenedOrder.PSSiteName,
                                OrderID: LastOpenedOrder.OrderID,
                                Accession: LastOpenedOrder.Accession,
                                SignBy: $sessionStorage.currentUserData.userId,
                                SignByName: $sessionStorage.currentUserData.displayName,
                                ProcedureDesc: LastOpenedOrder.ProcedureDesc,
                                CheckDeficiency: (LastOpenedOrder.CheckDeficiency == 0 ? 0 : 1),
                                SignDate: $filter('CSTDateTime')(moment().format("YYYY-MM-DD HH:mm:ss")),
                                SourceSignDate: moment().format("YYYY-MM-DDTHH:mm:ss")
                            };
                            //console.log("DeleteOpenOrder > reportView: ", reportView);
                            WorklistService.SaveReport(reportView);
                        }

                    }
                    DictationReportState = '';
                });

            }
        };
        function InsertOpenOrder() {
            //console.log("InsertOpenOrder");
            var order = $scope.DataObject.SingReport.Order;
            if (!order.IsLock) {
                $scope.LastOpenedOrder = order;
                LastOpenedOrderID = order.OrderID;
                $rootScope.$broadcast('ChatAssignLastOpenedOrder', { 'Order': order });
                var openOrders = {
                    OrderId: order.OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId,
                    ProviderName: $filter('titleCase')($sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName), //$sessionStorage.currentUserData.displayName,
                    OpenDateTime: new Date().toLocaleString('en-US', { timeZone: 'US/Central' })
                };
                WorklistService.InsertOpenOrder(openOrders).then(function (result) {

                });
            }

        };
        function SetSignREportModal(Order, OrderList) {
            //console.log("SetSignREportModal > Order: ", Order);
            //console.log("SetSignREportModal > OrderList: ", OrderList);
            _isOpeningStudy = false;
            CurrentDictationOrder.push(Order);
            $scope.DataObject.SingReport.CurrentSite = Order.Site + (Order.Location ? "(" + Order.Location + ")" : "");
            $scope.DataObject.SingReport.CurrentPatientMRN = Order.PatientMRN;
            $scope.DataObject.SingReport.CurrentPatient = Order.PatientName;
            $scope.DataObject.SingReport.CurrentAccession = Order.Accession;
            setSelected(Order.OrderID, Order);

            DictatedAccessionNumber.push(Order.Accession);

            //if (vm.selectedData.DefaultDicomViewer != null && vm.selectedData.DefaultDicomViewer.toString().length > 0) {
            //    $scope.DataObject.SingReport.Order.DicomViewer = vm.selectedData.DefaultDicomViewer;
            //}


            $scope.DataObject.SingReport.PrevToolTip = "";
            $scope.DataObject.SingReport.NextToolTip = "";
            var idx = _.findIndex(OrderList, function (a) { return a.OrderID == Order.OrderID });

            // Pre-fetch lock status for the next candidate while radiologist is viewing current study
            var prefetchIdx = idx + 1;
            while (prefetchIdx < OrderList.length && isOrderRestrictedForCurrentUser(OrderList[prefetchIdx])) { prefetchIdx++; }
            if (prefetchIdx < OrderList.length) {
                var prefetchOrderID = OrderList[prefetchIdx].OrderID;
                _nextOrderLockCache[prefetchOrderID] = WorklistService.GetOpenOrder({ OrderId: prefetchOrderID, ProviderID: $sessionStorage.currentUserData.userId });
            }
            if (idx > 0) {
                $scope.DataObject.SingReport.PrevToolTip = $sce.trustAsHtml('<div class="uibtt-cont-wrpr pb-5px"><span class="prevnxttt-lbl fs-12px fw-600 txt-clr-ccc">Name: </span><span class="prevnxttt-lblval fs-12px txt-clr-15">' + OrderList[idx - 1].PatientName + ' ' + '</span></div><div class="uibtt-cont-wrpr pb-5px"><span class="prevnxttt-lbl fs-12px fw-600 txt-clr-ccc">MRN: </span><span class="prevnxttt-lblval fs-12px txt-clr-15">' + OrderList[idx - 1].PatientMRN + ' ' + '</span></div><div class="uibtt-cont-wrpr"><span class="prevnxttt-lbl fs-12px fw-600 txt-clr-ccc">Accession: </span><span class="prevnxttt-lblval fs-12px txt-clr-15">' + OrderList[idx - 1].Accession + '</span></div>');
                $scope.DataObject.NoPrevOrder = false;
            }
            else if (idx <= 0) {
                $scope.DataObject.SingReport.PrevToolTip = $sce.trustAsHtml('<span class="prevnxttt-lblno fs-12px">No Order</span>');
                $scope.DataObject.NoPrevOrder = true;
            }
            if (OrderList && prefetchIdx < OrderList.length) {
                $scope.DataObject.SingReport.NextToolTip = $sce.trustAsHtml('<div class="uibtt-cont-wrpr pb-5px"><span class="prevnxttt-lbl fs-12px fw-600 txt-clr-ccc">Name: </span><span class="prevnxttt-lblval fs-12px txt-clr-15">' + OrderList[prefetchIdx].PatientName + ' ' + '</span></div><div class="uibtt-cont-wrpr pb-5px"><span class="prevnxttt-lbl fs-12px fw-600 txt-clr-ccc">MRN: </span><span class="prevnxttt-lblval fs-12px txt-clr-15">' + OrderList[prefetchIdx].PatientMRN + ' ' + '</span></div><div class="uibtt-cont-wrpr"><span class="prevnxttt-lbl fs-12px fw-600 txt-clr-ccc">Accession: </span><span class="prevnxttt-lblval fs-12px txt-clr-15">' + OrderList[prefetchIdx].Accession + '</span></div>');
                $scope.DataObject.NoNextOrder = false;
            }
            else if (OrderList && prefetchIdx >= OrderList.length) {
                $scope.DataObject.SingReport.NextToolTip = $sce.trustAsHtml('<span class="prevnxttt-lblno fs-12px">No Order</span>');
                $scope.DataObject.NoNextOrder = true;
            }


            $q.all([
                showPriorReport(Order, Order.Accession)
            ]).then(function (data) {
                //------------------------------------Open PS and Viewer------------------------------------
                if (__env.showLoaderonPSNViewerLoad) {
                    //$scope.isLoadingSynapse = true;
                }
                var _autoCorrelationId = Date.now();
                var timeout = $timeout(function () {
                    logPacsEvent('[' + _autoCorrelationId + '] Step1-WorklistGrid: viewer=' + Order.DicomViewer + ' auto-open setTimeout=500ms');
                    $rootScope.$broadcast('event.OpenSynapse', { 'Order': Order, 'OptionalDV': Order.DicomViewer, 'isOpenPS': true, 'correlationId': _autoCorrelationId });
                    vm.selectedData.OpenFromWorklist = true;
                    //$scope.isLoadingSynapse = false;
                }, 500);
                TimeoutList.push(timeout);
                //-----------------------------------------------------------------------------------------
            });
        }
        function showPriorReport(SelectedOrder, SelectedOrderAccession) {
            //console.log("showPriorReport > SelectedOrder: ", SelectedOrder);
            //console.log("showPriorReport > SelectedOrderAccession: ", SelectedOrderAccession);
            var d = $q.defer();
            $scope.ReportSelectedOrder = _.clone(SelectedOrder);
            $scope.ReportSelectedOrder.ShowContactBtn = true;
            var ComparisionOrderList = [];
            if (SelectedOrder.ComparisonOrder && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                $q.all([
                    viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                ]).then(function (data) {
                    d.resolve(data);
                });

            } else if (SelectedOrder.ComparisonOrder && SelectedOrder.ComparisonOrder.length == 0) {
                $scope.orderComparisonListFilter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = _.clone(result);
                    //SelectedOrder.subGridOptions = _.clone(subUIGridOptions);
                    //SelectedOrder.subGridOptions.data = _.clone(result);
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });
                    $q.all([
                        viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                    ]).then(function (data) {
                        d.resolve(data);
                    });


                }).catch(function (noCantDo) {
                    $scope.DataObject.worklist.loading = false;
                    d.resolve(false);
                });
            }
            else {
                $q.all([
                    viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                ]).then(function (data) {
                    d.resolve(data);
                });
            }
            return d.promise;
        }
        function viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList) {
            //console.log("viewReport");
            var d = $q.defer();
            $scope.showDiscuss = true;
            $scope.isReportAvailable = false;
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN, SelectedOrder.SiteID)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];
                if (data != null && data.length > 0 && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report && report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        SelectedOrder.FormattedOrderDate = new Date($filter('localDate')(SelectedOrder.OrderDate, false, new Date()));
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            rptObject[0].FormattedOrderDate = new Date($filter('localDate')(rptObject[0].OrderDate, false, new Date()));
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            ComparisonOrderReport.FormattedOrderDate = new Date($filter('localDate')(ComparisonOrderReport.OrderDate, false, new Date()));
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });

                }
                if ($scope.reportList.length > 0) {
                    $scope.OrderReport = $scope.reportList[0];
                } else {
                    $scope.OrderReport = SelectedOrder;
                }

                $scope.reportList = _.uniqBy($scope.reportList, 'OrderID');
                $scope.DataObject.ReportList.Modalities = _.concat($scope.DataObject.ReportList.Modalities, _.uniq(_.map(_.filter($scope.reportList, function (report) { return report.Modality != ''; }), 'Modality')));
                if (report.length == 0) {
                    var reportList = _.orderBy($scope.reportList, ['OrderDate'], ['desc']);
                    $scope.reportList = reportList;
                }
                if ($scope.reportList && $scope.reportList.length > 0) {
                    var objSelectedReport = $scope.reportList[0];
                    if (objSelectedReport) {
                        $scope.SelectedOrderAccession = objSelectedReport.Accession;
                        LoadReport(objSelectedReport.OrderID);
                        if (Hasreport) {
                            $scope.isReportAvailable = true;
                        }
                        $scope.LoadDiscussion(SelectedOrder.DicomOrderID, 'Discussion');
                    }
                }
                else {
                    $scope.LoadDiscussion(SelectedOrder.DicomOrderID, 'Discussion');
                }
                ReportList = $scope.reportList;
                if (ReportList.length > 1) {
                    $scope.DataObject.ShowReportModal = true;
                }
                //$scope.isLoading = false;
                d.resolve(true);
            });
            return d.promise;
        }
        function removeOrderFromList(OrderId) {
            //console.log("removeOrderFromList > OrderId: ", OrderId);
            var idx = _.findIndex(OrderList, function (obj) { return obj.OrderID == _.toInteger(OrderId); });
            if (idx != -1) {
                removeFromAGGrid(OrderList[idx]);

                removeOrder(idx);
            }
        }
        $scope.SaveChildDiscussion = function (discussion) {
            if (discussion.ChildComment) {
                var Objdiscussion = {
                    ReferenceID: discussion.ID,
                    Type: 0,
                    Comment: discussion.ChildComment,
                    Record_Created_By: $sessionStorage.currentUserData.userId,
                    Record_Created_By_Name: $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName,
                    Record_Modified_At: $filter('CSTDateTime')(moment()),
                    AddendumRequestedApplication: discussion.AddendumRequestedApplication,
                    CallBackURL: discussion.CallBackURL,
                    ReplyAddendumRequestDiscussion: {
                        Accession: $scope.SelectedOrder.Accession,
                        SiteName: $scope.SelectedOrder.Site,
                        AddendumRequestedBy: $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName,
                        Comment: discussion.ChildComment,
                    }
                };
                if (discussion.Record_Created_By != $sessionStorage.currentUserData.userId) {
                    NotifyToUser(__env._NOTIFY_MSG_, $scope.SelectedOrder.OrderID, discussion.Record_Created_By, "N");
                }
                $scope.DataObject.Loading = true;
                WorklistService.SetDiscussion(Objdiscussion).then(function (response) {
                    $scope.DataObject.Loading = false;
                    discussion.IsChild = false;
                    discussion.ChildComment = '';
                    $scope.AllDiscussions.push(response);
                    bindChildDiscussion(response);
                });
            }
        };

        function bindChildDiscussion(ObjDiscussion) {
            angular.forEach($scope.Discussions, function (obj, idx) {
                LoadChildDiscussion(obj);
            });
        }
        function logPacsEvent(eventName) {
            try {
                if (!__env.appLogSetting || !__env.appLogSetting.isEnabled) { return; }
                var userId = $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '';
                CommonService.LogApplicationInfo({ LogDetails: eventName, Application: 'PACS-Viewer', UserID: userId });
            } catch (e) { }
        }

        $scope.OpenSynapseStudy = function (Order, OptionalDV, isOpenPS, isSingleView) {

            $scope.GetDicomViewerCredentialsCallFrom = "OPENSYNAPSESTUDY";
            $scope.OpenSynapseStudyOrder = Order;
            $scope.OpenSynapseStudyOptionalDV = OptionalDV;
            $scope.OpenSynapseStudyisOpenPS = isOpenPS;
            var _correlationId = Date.now();
            var _pacsOpenStart = Date.now();
            var _credStart = Date.now();
            $q.all([
                GetDicomViewerCredentials(Order.SiteID, OptionalDV)
            ]).then(function (data) {
                var credElapsed = Date.now() - _credStart;
                if (data != null && data.length > 0 && data[0] != null) {
                    if (data[0].ShowModal) { return; }
                    else {
                        Order.DicomViewerCredentials = data[0].Credentials;
                        if (__env.showLoaderonPSNViewerLoad) {
                            //$scope.isLoadingSynapse = true;
                        }
                        var timeout = $timeout(function () {
                            var totalElapsed = Date.now() - _pacsOpenStart;
                            logPacsEvent('[' + _correlationId + '] Step1-WorklistGrid: viewer=' + OptionalDV + ' GetDicomViewerCredentials=' + credElapsed + 'ms (apiCall=' + (data[0].RequiredCredentials ? 'YES' : 'NO') + ') setTimeout=500ms total=' + totalElapsed + 'ms');
                            $rootScope.$broadcast('event.OpenSynapse', { 'Order': Order, 'OptionalDV': OptionalDV, 'isOpenPS': isOpenPS, 'isSingleView': isSingleView, 'correlationId': _correlationId });
                            //$scope.isLoadingSynapse = false;
                        }, 500);
                        TimeoutList.push(timeout);
                    }
                }
            });
        };
        $scope.showReport = function (SelectedOrder) {
            $scope.OrderReport = SelectedOrder;
            $scope.SelectedOrderAccession = SelectedOrder.Accession;
            LoadReport(SelectedOrder.OrderID);
        }
        function SignReport(data) {
            //console.log("SignReport > data: ", data);

            var accessions = _.split(data.MessageResponse.reportResponseDetails.accessionNumbers, ",");
            if (($scope.LastOpenedOrder && accessions.includes($scope.LastOpenedOrder.Accession))) {
                $scope.win_ModalReportNDiscuss.close();
                $scope.win_Discussion.close();
                CloseAllWindow(true);
            }
            else if (DictatedAccessionNumber.length == 1 && (_.intersection(DictatedAccessionNumber, accessions).length > 0) && !vm.selectedData.CloseWindow) {
                $scope.win_ModalReportNDiscuss.close();
                $scope.win_Discussion.close();
                CloseAllWindow(true);
            }
            _.pullAll(DictatedAccessionNumber, accessions);
            vm.selectedData.CloseWindow = false;
            $scope.NativeMessageResponseReportStatus = data.MessageResponse.reportResponseDetails.reportStatus;

            if ($scope.NativeMessageResponseReportStatus == 2
                || $scope.NativeMessageResponseReportStatus == 8) {


                _.each(accessions, function (accession) {
                    var SignedReportOrder = getOrderByAccessionNPSSiteName(accession, data.MessageResponse.reportResponseDetails.siteName);
                    if (SignedReportOrder) {

                        processSignReportResponse(data, SignedReportOrder);


                    }
                });
            }
            else if (DictatedAccessionNumber.length == 0) {
                _.each(accessions, function (item) {
                    var order = _.find(OrderList, { Accession: item });
                    if (order) {
                        var openOrders = {
                            OrderId: order.OrderID,
                            UserId: $sessionStorage.currentUserData.userId
                        };
                        WorklistService.DeleteOpenOrder(openOrders);
                    }
                });
            }

        };
        function _OpenDiscussionOrder() {
            $scope.ODType = "Helper";
            var SelectedOrder = $scope.OrderDiscussion.Order ? $scope.OrderDiscussion.Order : $scope.OrderDiscussion;
            setSelected(SelectedOrder.OrderID, SelectedOrder);
            if ($scope.SelectedOrder && !$scope.SelectedOrder.DicomOrderID) {
                $scope.SelectedOrder.DicomOrderID = $scope.SelectedOrderID;
            }
            $('#ModalDiscussion').modal('show');
            $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID, 'Helper');
            if ($scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId) {
                if ($scope.OrderDiscussion.Status == 'A') {
                    $scope.OrderDiscussion.Status = 'C';
                    WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                        LoadOrderDiscussionForUser();
                    }, _respError);
                } else {
                    LoadOrderDiscussionForUser();
                }
            } else {
                if ($scope.OrderDiscussion.Status == 'N' || $scope.OrderDiscussion.Status == 'I') {
                    $scope.ODType = "Discussion";
                    $scope.OrderDiscussion.Status = 'D';
                    WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                        LoadOrderDiscussionForUser();
                    }, _respError);
                    return;
                }
                $q.all([
                    GetAllUsers($scope.SelectedOrder.SiteID)
                ]).then(function (data) {
                    if ($scope.OrderDiscussion) {
                        $scope.OrderDiscussion.SelectedUsers = [];
                        $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                        _.each($scope.OrderDiscussion.OrderAssignments, function (orderAssignment) {
                            if (orderAssignment.IsUserWithSpecialityGroup == 0) {
                                var radiologistGroup = _.find($scope.DataObject.masterData.RadiologistsGroups, { Id: orderAssignment.ProviderSpecialityId.toString() });
                                if (radiologistGroup) {
                                    $scope.OrderDiscussion.SelectedRadioLogistsGroup.push(radiologistGroup);
                                }
                            } else if (orderAssignment.IsUserWithSpecialityGroup == 2) {
                                var radiologistGroup = _.find($scope.DataObject.masterData.RadiologistsGroups, { Id: orderAssignment.ProviderID });
                                if (radiologistGroup) {
                                    $scope.OrderDiscussion.SelectedRadioLogistsGroup.push(radiologistGroup);
                                }
                            }
                        });
                        $scope.OrderDiscussion.SelectedRadioLogistsGroup = _.uniqBy($scope.OrderDiscussion.SelectedRadioLogistsGroup, 'Id');

                        $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();
                        captureOrderAssignmentBaseline();

                        var timeout = $timeout(function () {
                            $scope.isAssigner = false;
                            setOrderDiscussionUserGroup().then(function (data) {
                                setOrderDiscussionTooltip();
                                setSelectedUserAssignment(data);

                                $timeout.cancel(timeout);
                                timeout = null;
                            });
                        }, 100);

                    }
                });
                $scope.OrderDiscussion.Status = 'A';
            }
        }
        function ReloadDiscussion(OD) {
            if (OD.Status == 'I') {
                var objOrder = _.filter(OrderList, function (obj) { return obj.OrderID == OD.OrderID; });
                if (objOrder && objOrder.length > 0) {
                    if (!objOrder[0].IsLock && vm.selectedData.Worklist === 'PSW') {
                        var ToUserID;
                        var ToUserName;
                        var assignedCurrentUser;
                        if (objOrder[0].listOrderListAssignment) {
                            if (objOrder[0].listOrderListAssignment.length > 0) {
                                ToUserName = getOrderListTooltip(objOrder[0]);
                                ToUserID = objOrder[0].listOrderListAssignment[0].OrderAssingedUserID;
                            }
                        }

                        if (OD.OrderDiscussionUserGroup) {

                            var userGroup = _.find(OD.OrderDiscussionUserGroup, function (obj) {
                                return obj.ToUserID == vm.selectedData.LoggedInUserID;
                            });
                            if (userGroup) {
                                assignedCurrentUser = userGroup.ToUserID;
                            }
                        }
                        objOrder[0].OrderAssingedUserID = ToUserID;
                        objOrder[0].OrderAssingedUserName = ToUserName;
                        objOrder[0].OrderAssingedUsers = OD.OrderDiscussionUserGroup.length;
                        objOrder[0].OrderAssingedUser = assignedCurrentUser;
                        objOrder[0].listOrderListAssignment = OD.Order.listOrderListAssignment;
                    }
                    if (!objOrder[0].IsLock && vm.selectedData.Worklist === 'PRW') {
                        removeOrderFromList(OD.OrderID);
                    }
                }
            } else {
                if (vm.selectedOrder && (vm.selectedOrder.OrderID == OD.Order.OrderID)) {
                    LoadDiscussion($scope.Discussion);
                    if (OD.Status == 'N') {
                        OD.Status = 'D';
                        WorklistService.SetOrderDiscussionAssignment(OD).then(function (response) {
                        });
                    }
                }
            }
        }
        function OrderDiscussionHandler(data) {
            if (data.discussion.Type == 1) {
                var objOrderList = _.filter(OrderList, function (obj) { return data.discussion.ReferenceID == obj.DicomOrderID; });
                if (objOrderList && objOrderList.length > 0) {
                    objOrderList[0].IsDiscussion = true;
                }
            } else if (data.discussion.Type == 0 && data.orderID) {
                var objOrderList = _.filter(OrderList, function (obj) { return data.orderID == obj.OrderID; });
                if (objOrderList && objOrderList.length > 0) {
                    objOrderList[0].IsDiscussion = true;
                }
            }
            if ($scope.isDiscussionVisible) {
                LoadDiscussion($scope.Discussion);
            }
            UpdateGridData(data.OrderID);
        }
        function NotifyOpenOrder(data) {
            if ($sessionStorage.currentUserData.userId != data.ProviderID) {
                var objOrder = _.filter(OrderList, function (obj) { return obj.OrderID == data.OrderID; });
                if (objOrder && objOrder.length > 0) {
                    if (vm.selectedData.ShowLockStudy) {
                        if (data.isOpen) {
                            objOrder[0].IsLock = true;
                            objOrder[0].LockBy = data.ProviderName;
                        }
                        else {
                            objOrder[0].IsLock = false;
                        }
                    }
                }
                UpdateGridData(data.OrderID);
            }
        }
        function NotifyShowHideOrder(data) {
            var Status = GetStatus();
            var objOrder = _.findIndex(OrderList, function (obj) { return obj.OrderID == data.OrderID; });
            console.log('[NotifyShowHideOrder] ag-grid handler - OrderID:', data.OrderID, 'IsHide:', data.IsHide, 'Status:', Status, 'orderFound:', objOrder != -1);
            if (objOrder != -1) {
                switch (Status) {
                    case 'H':
                        if (!data.IsHide) {
                            console.log('[NotifyShowHideOrder] Status=H, IsHide=false - removing order from list, OrderID:', data.OrderID);
                            removeOrderFromList(data.OrderID);
                        }
                        break;
                    case 'AL':
                        OrderList[objOrder].Status = data.IsHide ? "H" : "RP";
                        OrderList[objOrder].RowColorCode = getRowTemplateColorCode(OrderList[objOrder]);
                        console.log('[NotifyShowHideOrder] Status=AL - updating order, OrderID:', data.OrderID, 'newStatus:', OrderList[objOrder].Status);
                        updateAGGridOrder([OrderList[objOrder]]);
                        break;
                    case 'RP':
                        if (data.IsHide) {
                            console.log('[NotifyShowHideOrder] Status=RP, IsHide=true - removing order from list, OrderID:', data.OrderID);
                            removeOrderFromList(data.OrderID);
                        }
                        break;
                }
            } else {
                console.log('[NotifyShowHideOrder] order not found in local OrderList, OrderID:', data.OrderID);
            }
        }
        function removeOrderAccession(Accession) {
            var idx = _.findIndex(OrderList, function (obj) { return obj.Accession == Accession; });
            if (idx != -1) {
                removeFromAGGrid(OrderList[idx]);

                removeOrder(idx);
            }
        }
        function Dictation(data) {
            //console.log("Dictation > data: ", data);
            _.remove(CurrentDictationOrder, function (orderObj) { return orderObj.OrderID == data.SelectedOrder.OrderID; });
            var Status = GetStatus();
            DictationReportState = data.DictationReportState;


            $scope.win_ModalReportNDiscuss.close();
            $scope.win_Discussion.close();
            CloseAllWindow(true);

            if (data.SelectedOrder._ReportStatus == 'Final' || data.SelectedOrder._ReportStatus == 'Correction') {
                OpenOrder = {};
                VerfiyReadStudy(data.SelectedOrder.OrderID, vm.selectedData.LoggedInUserID, null).then(function () {
                    if (OpenOrder.ClipboardDetailResult && OpenOrder.ClipboardDetailResult.length > 0) {
                        var obj = { OrderID: data.SelectedOrder.OrderID, UserID: vm.selectedData.LoggedInUserID, RuleID: OpenOrder.ClipboardDetailResult[0].RuleID };
                        $rootScope.$broadcast('event.NotifyRemoveFromClipboard', obj);
                        WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                        $rootScope.$broadcast('event.worklist', { EventType: 'NotifyOrderListSaveReport', OrderID: data.SelectedOrder.OrderID });
                    } else {
                        if (data.ClipboardRuleID > 0) {
                            var obj = { OrderID: data.SelectedOrder.OrderID, UserID: vm.selectedData.LoggedInUserID, RuleID: data.ClipboardRuleID };
                            $rootScope.$broadcast('event.NotifyRemoveFromClipboard', obj);
                            WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                            $rootScope.$broadcast('event.worklist', { EventType: 'NotifyOrderListSaveReport', OrderID: data.SelectedOrder.OrderID });
                        }
                    }
                });
            }

            if ((Status == 'RP' || Status == 'D' || Status == 'PA')
                && (data.SelectedOrder._ReportStatus == 'Final' || data.SelectedOrder._ReportStatus == 'Correction' || data.SelectedOrder._ReportStatus == 'Draft')) {
                removeOrderFromList(data.SelectedOrder.OrderID);
                if (data.SelectedOrder._PatientOrdersMapped) {
                    _.each(data.SelectedOrder._PatientOrdersMapped, function (mappedOrder) {
                        removeOrderFromList(mappedOrder.OrderID);
                    });
                }
            }

            if (data.SelectedOrder._ReportStatus) {
                if (($scope.DataObject.worklist.WorklistType != 16 && !$scope.DataObject.worklist.ChooseNextStudy) ||
                    ($scope.DataObject.worklist.WorklistType == 16 && !$scope.DataObject.worklist.OpenClipboardNextStudy)) {
                    NextRec();
                    $scope.SingbtnDisabled = false;
                }
            }
            DeleteOpenOrder();
        }

        function Reload(data) {
            var hasRuleDetails = $scope.DataObject.worklist.Type == 'D'
                || $scope.DataObject.worklist.Type == 'S'
                || $scope.DataObject.worklist.Type == 'QS';
            if (!hasRuleDetails) {
                RuleSharedService.GetRuleDetails($scope.DataObject.worklist, "View");
            }
            if (data.WorklistID && data.WorklistID == $scope.DataObject.worklist.RuleID) {
                //getData().then(function (data) {
                $scope.TotalRows = 0;
                PageNo = 1;
                OrderList = [];
                autoRefreshing = true;
                gridOptions.api.refreshServerSide({ purge: true });
            }
        }

        function removeOrder(idx) {
            //console.log("removeOrder > idx: ", idx);
            OrderList.splice(idx, 1);

            if ($scope.TotalRows > 0) {
                $scope.TotalRows = $scope.TotalRows - 1;
            }

            /*if ($scope.DataObject.SingReport && $scope.DataObject.SingReport.OrderList && $scope.DataObject.SingReport.OrderList.length > 0) {
                $scope.DataObject.SingReport.OrderList = _.clone(OrderList);
            }*/

            var PageSize = _.toInteger($scope.DataObject.worklist.PageSize) - 1;
            if (OrderList.length < PageSize) {
                $scope.TotalRows = 0;
                PageNo = 1;
                OrderList = [];
                autoRefreshing = true;
                gridOptions.api.refreshServerSide({ purge: true });
            }
        }
        $scope.showContact = function (OrderingPhysician, LocationID, LocationName) {
            $scope.currentWindow = 'win_ContactList';
            $scope.getContact(OrderingPhysician, LocationID, LocationName);
        }
        $scope.showLocationContact = function (LocationID, LocationName) {
            $scope.getLocationContact(LocationID, LocationName);

            $scope.currentWindow = 'win_LocationContact';
            $scope.win_LocationContact.open();
            $scope.win_LocationContact.wrapper.prev(".k-overlay").addClass("custom-overlay");
        }

        $scope.getContact = function (OrderingPhysician, LocationID, LocationName) {
            $scope.DataObject.FilterAddressBook = {
                Name: OrderingPhysician,
                LocationIDs: LocationID,
                Location: null,
                LocationName: LocationName
            };
            $scope.win_ContactList.open();
            $scope.win_ContactList.wrapper.prev(".k-overlay").addClass("custom-overlay");
        };
        $scope.getTypeContact = function (LocationID) {
            var PageSize = 50;
            var PageNum = 1;
            var filter = {
                PageNum: PageNum,
                PageSize: PageSize,
                Name: '',
                LocationIDs: LocationID,
                OrderByField: 'Name',
                OrderBy: 'desc',
                ModalityIDs: '',
                Departments: '',
                UserID: $sessionStorage.currentUserData.userId,
            };
            var d = $q.defer();
            AddressBookListService.GetContactDetail(filter).then(function (result) {
                d.resolve(result);
            })
            return d.promise;
        };
        $scope.getLocationContact = function (LocationID, LocationName) {
            var locationIds = _.split(LocationID, ',');
            var locations = [];
            _.each(locationIds, function (item) {
                var location = _.find($scope.DataObject.masterData.Locations, { LocationID: item });
                if (location) {
                    locations.push(location);
                }
            });
            $scope.DataObject.FilterLocationAddressBook = {
                Ids: LocationID,
                LocationIDs: LocationID,
                locations: locations,
                divId: 'LocationContactWindowGrid'
            };


        };
        function hideAllTippyPopUp() {
            _.each(tippyJsinstance, function (instance) {
                if (instance.tippyInstance) {
                    instance.tippyInstance.hide();
                }
            });
            tippyJsinstance = [{ tippyInstance: null, cellInstance: null, rowNode: null }];
        }
        $scope.getOrderDiscussionOptions = function () {
            var options = {
                template: kendo.template($("#dropdowntree-orderdiscussion-template").html()),
                placeholder: 'Select User / Group',
                checkboxes: {
                    checkChildren: true
                },
                autoClose: false,
                dataSource: $scope.DataObject.masterData.RadiologistsGroups,
                dataTextField: "UserName",
                dataValueField: "Id",
                height: "auto",
                loadOnDemand: false,
                headerTemplate: '<span class="k-list-filter"><input class="k-textbox" role="listbox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-disabled="false" id="ddstOrderDiscussion" autocomplete="off"/><span class="k-icon k-i-zoom"></span></span>',
                filtering: function (e) {
                    //get filter descriptor
                    var filter = e.filter;
                    // handle the event
                },
                open: function (e) {
                    $("#ddstOrderDiscussion").change(refreshTreeOrderDiscussion).keyup(refreshTreeOrderDiscussion);
                    var timeout = $timeout(function () {
                        $("#ddstOrderDiscussion").focus();
                    }, 1500);
                    TimeoutList.push(timeout);

                    $("#ddstOrderDiscussion").val('');
                    var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
                    if (drtr) {
                        var tree = drtr.treeview;
                        var dataSource = drtr.dataSource;
                        dataSource.filter({});
                        var timeout = $timeout(function () {
                            tree.collapse(".k-item");
                        }, 1000);
                        TimeoutList.push(timeout);
                    }


                },
                change: function (e) {
                    ClearAll();
                    var nodes = e.sender.dataSource.view();

                    var checkedNodes = e.sender.value();

                    var values = checkedNodeValues(nodes, checkedNodes);
                    var rValues = _.omitBy(values, _.isNil);
                    $scope.OrderDiscussion.SelectedUsers = [];
                    $scope.OrderDiscussion.SelectedRadioLogistsGroup = [];
                    _.each(rValues, function (obj) {
                        var selectedRadiologistGroups = _.find($scope.DataObject.masterData.RadiologistsGroups, function (dobj) { return dobj.Id == obj });
                        if (selectedRadiologistGroups) {
                            $scope.OrderDiscussion.SelectedRadioLogistsGroup.push(selectedRadiologistGroups);
                        }

                    });

                    $scope.OrderDiscussion.SelectedUsers = prepareOrderDiscussionUsers();

                    setOrderDiscussionTooltip();

                },
            };
            return options;
        }
        $scope.CallInConsult = function (order) {
            //$scope.isChatMenuActive = true;
            // $rootScope.$broadcast('activeChatMenuBarformWorkList', $scope.isChatMenuActive,order);
            setSelected(order.OrderID, order);
            $scope.currentWindow = 'win_consultExamsWindow';
            OpenWindow($scope.win_consultExamsWindow, 'win_consultExamsWindow');
            $scope.win_consultExamsWindow.wrapper.prev(".k-overlay").addClass("custom-overlay");
        }

        function prepareOrderDiscussionUsers() {
            var selectedUsers = [];
            _.each($scope.OrderDiscussion.SelectedRadioLogistsGroup, function (selectedRadiologistGroup) {
                if (selectedRadiologistGroup && selectedRadiologistGroup.Group && selectedRadiologistGroup.Group == "YES") {

                    var specialities = _.filter(specialityAssignments, { SpecialityId: selectedRadiologistGroup.Id });
                    _.each(specialities, function (speciality) {
                        var user = _.find($scope.DataObject.masterData.Radiologists, { Id: speciality.UserId });
                        if (user) {
                            user.IsUserWithSpecialityGroup = 0;
                            user.SpecialityCode = speciality.SpecialityCode;
                            user.SpecialityCodeDesc = speciality.SpecialityCodeDesc;
                            user.SpecialityGroup = speciality.SpecialityGroup;
                            user.SpecialityId = speciality.SpecialityId;
                            var selectedUserIndex = _.findIndex(selectedUsers, function (auser) {
                                return auser.Id == user.Id
                                    && auser.IsUserWithSpecialityGroup == 0;
                            });
                            var selectedUserBySpecialityIndex = _.findIndex(selectedUsers, function (auser) {
                                return auser.Id == user.Id
                                    //&& auser.SpecialityId > 0
                                    //    && user.SpecialityId > 0
                                    && auser.SpecialityId != user.SpecialityId;
                            });

                            if (selectedUserIndex != -1 && selectedUserBySpecialityIndex == -1) {
                                selectedUsers[selectedUserIndex].IsUserWithSpecialityGroup = 1;
                                user.IsUserWithSpecialityGroup = 1;
                            } else if (selectedUserBySpecialityIndex != -1) {
                                selectedUsers[selectedUserBySpecialityIndex].IsUserWithSpecialityGroup = 3;
                                user.IsUserWithSpecialityGroup = 3;
                            }
                            selectedUsers.push(_.clone(user));
                        }

                    });

                } else {
                    var user = _.find($scope.DataObject.masterData.Radiologists, function (user) { return user.Id == selectedRadiologistGroup.Id; });
                    if (user) {
                        user.IsUserWithSpecialityGroup = 2;
                        var selectedUserIndex = _.findIndex(selectedUsers, function (auser) {
                            return auser.Id == user.Id
                                && auser.IsUserWithSpecialityGroup == 0;
                        });
                        var selectedUserBySpecialityIndex = _.findIndex(selectedUsers, function (auser) {
                            return auser.Id == user.Id
                                //&& auser.SpecialityId > 0
                                //&& user.SpecialityId > 0
                                && auser.SpecialityId != user.SpecialityId;
                        });
                        if (selectedUserIndex != -1 && selectedUserBySpecialityIndex == -1) {
                            selectedUsers[selectedUserIndex].IsUserWithSpecialityGroup = 1;
                            user.IsUserWithSpecialityGroup = 1;
                        } else if (selectedUserBySpecialityIndex != -1) {
                            selectedUsers[selectedUserBySpecialityIndex].IsUserWithSpecialityGroup = 3;
                            user.IsUserWithSpecialityGroup = 3;
                        }
                        selectedUsers.push(_.clone(user));
                    }

                }
            });
            return selectedUsers;
        }

        function setMultipleSelection(Orders) {
            if (Orders && Orders.length > 0) {
                ClipboardConditionData = { ClipboardData: [], SelectedRowsClipboard: [], showClipboardToaster: true };
                if ($scope.DataObject.worklist.WorklistType == 16) {
                    var OrderlistClipboard = [], SelectedRowsClipboard = [], RemainingRowsClipboard = [];
                    OrderlistClipboard = _.clone(OrderList);
                    _.each(Orders, function (order) {
                        if (order.IsInClipboard != 1) { SelectedRowsClipboard.push(order); }
                        if (order.IsInClipboard == 1) { ClipboardConditionData.IsInOtherClipboard = true; }
                    });
                    if (SelectedRowsClipboard.length > 0) {
                        ClipboardConditionData.SelectedRowsClipboard = _.concat(ClipboardConditionData.SelectedRowsClipboard, SelectedRowsClipboard);
                        RemainingRowsClipboard = _.differenceBy(OrderlistClipboard, ClipboardConditionData.SelectedRowsClipboard, 'OrderID');
                        OrderList = RemainingRowsClipboard;
                        ClipboardConditionData.ClipboardData = RemainingRowsClipboard;
                    }
                }
                else {
                    _.pullAllBy(Orders, ClipboardConditionData.ClipboardData, 'OrderID');
                    ClipboardConditionData.ClipboardData = _.filter(_.concat(ClipboardConditionData.ClipboardData, Orders), function (obj) {
                        if (obj.IsInClipboard == 1) { ClipboardConditionData.IsInOtherClipboard = true; }
                        return obj.IsInClipboard == 0;
                    });
                }
            }

        }

        function onAddToClipboard(Type) {
            var orderMinDate = _.minBy(ClipboardConditionData.ClipboardData, function (obj) {
                return obj.OrderDate;
            });
            var orderMaxDate = _.maxBy(ClipboardConditionData.ClipboardData, function (obj) {
                return obj.OrderDate;
            });
            var orderIDs = _.join(_.map(ClipboardConditionData.ClipboardData, function (item) { return item.OrderID; }), ',');
            if (ClipboardConditionData.ClipboardData.length > 0) {
                ClipboardConditionData.OrderDate = {
                    startDate: moment(orderMinDate.OrderDate),
                    endDate: moment(orderMaxDate.OrderDate)
                };
                ClipboardConditionData.OrderIDs = orderIDs;
                ClipboardConditionData.OrderDateType = "Custom range";
                ClipboardConditionData.ActionType = Type;
            } else {
                ClipboardConditionData.OrderDate = {
                    startDate: null,
                    endDate: null
                };
                ClipboardConditionData.OrderIDs = null;
                ClipboardConditionData.OrderDateType = "Custom range";
                ClipboardConditionData.ActionType = Type;
            }
            $rootScope.$broadcast('event.worklist.clipboard', { EventType: 'CreateClipboardConditions', ClipboardConditionData: ClipboardConditionData });
        }
        function onRemoveFromClipboard() {
            onAddToClipboard("Remove");
        }
        function ResetClipboard() {
            if (OrderList.length > 0) { $("#onresetclipboard").removeAttr('disabled'); $("#DisableResetClipboard").removeAttr('disabled'); }
            else { $("#onresetclipboard").attr('disabled', 'disabled'); $("#DisableResetClipboard").attr('disabled', 'disabled'); }
        }

        function UpdateGridData(OrderID) {

            var rowToUpdate;
            var order = _.find(OrderList, { 'OrderID': OrderID });
            if (order) {
                rowToUpdate = gridOptions.api.getRowNode(order.ID);
            }

            if (rowToUpdate) {

                rowToUpdate.data = _.find(OrderList, { OrderID: OrderID });
                if (rowToUpdate.data) {
                    if (rowToUpdate.data && rowToUpdate.data.HasComparison == "0" && rowToUpdate.detailNode) {
                        rowToUpdate.setExpanded(false);
                        rowToUpdate.detailNode.parent.master = 0;
                    }
                    var params = {
                        force: true,
                        suppressFlash: true,
                        rowNodes: [rowToUpdate]

                    };
                    gridOptions.api.refreshCells(params);
                }

            }

        }
        function refreshTreeOrderDiscussion() {
            var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            var tree = drtr.treeview;
            var dataSource = drtr.dataSource;
            var value = $("#ddstOrderDiscussion").val();
            if (value !== "") {
                dataSource.filter({
                    field: "UserName", //if I would use "ChildrenText" here nothing be displayed at all if filtertext is set
                    operator: "contains",
                    value: $("#ddstOrderDiscussion").val()
                });

                //filtering child node
                if (dataSource.view().length > 0) {
                    for (var i = 0; i < dataSource.view().length; i++) {
                        if (dataSource.view()[i].hasChildren) {
                            dataSource.view()[i].children.filter({
                                field: "UserName",
                                operator: "neq",
                                value: true
                            })
                        }
                    }
                }

                var timeout = $timeout(function () {
                    tree.expand(".k-item");
                }, 200);
                TimeoutList.push(timeout);
            } else {
                dataSource.filter({});

                var timeout = $timeout(function () {
                    tree.collapse(".k-item");
                }, 200);
                TimeoutList.push(timeout);
            }
            angular.element(document).ready(function () {
                angular.element('.k-item').mouseenter(function () {
                    if (tree) {
                        tree.focus();
                    }
                });

            });
        }
        function ClearAll() {
            $(".k-check-all").on("click", function () {

                if ($('.k-checkbox').is(':checked') == false) {

                    $scope.SelectedList.Site = null;
                    $scope.SelectedList.Location = null;
                    $scope.locationtooltip = 'Select a Location';

                    $('.k-multiselect-wrap li').remove();
                }
            })
        }
        function checkedNodeValues(nodes, checkedNodes) {
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && !nodes[i].hasChildren) {
                    if (checkedNodes.indexOf(nodes[i].value) < 0) {
                        checkedNodes.push(nodes[i].value);
                    }
                }
                if (nodes[i].hasChildren) {
                    checkedNodeValues(nodes[i].children.view(), checkedNodes);
                }
            }
            return checkedNodes;
        }

        function setColumnHideMenu() {
            _.each(ColumnDefs, function (col) {
                if (!col.lockVisible) {
                    var obj = {};

                    obj.field = col.field;
                    ColumnsToHide.push(obj);
                }
            });
        }
        $scope.addContact = function (locationID) {
            //$scope.addEditContactWindowHeight = halfScale ? "68%" : "62%";
            $scope.currentWindow = "AddEditContactWindow";
            $scope.DataObject.win_AddEditContactTitle = "Add Contact";
            SetWindowOptions($scope.win_AddEditContact, 'win_AddEditContact', { height: $scope.addEditContactWindowHeight });
            OpenWindow($scope.win_AddEditContact, 'win_AddEditContact');
            $scope.win_AddEditContact.wrapper.prev(".k-overlay").addClass("custom-overlay");
            clearContact();
            var names = $scope.DataObject.FilterAddressBook.Name.split(' ');
            $scope.DataObject.AddressBookInfo.SelectedData.LastName = names[0].replace(',', '');
            $scope.DataObject.AddressBookInfo.SelectedData.FirstName = (names.length > 1 ? names[1].replace(',', '') : '');
            $scope.DataObject.AddressBookInfo.sites = $scope.DataObject.masterData.sites;
            $scope.DataObject.AddressBookInfo.Locations = $scope.DataObject.masterData.Locations;
            $scope.DataObject.AddressBookInfo.Modality = $scope.DataObject.masterData.Modalities;
            $scope.DataObject.AddressBookInfo.SelectedData.Locations = _.find($scope.DataObject.masterData.Locations, { 'LocationID': locationID }).Location;
            $scope.DataObject.AddressBookInfo.SelectedData.LocationIDs = locationID;
            var timeout = $timeout(function () {
                $scope.win_AddEditContact.center();
            }, 100);
            TimeoutList.push(timeout);
        };
        $scope.editContact = function (obj) {
            //  $scope.addEditContactWindowHeight = halfScale ? "68%" : "62%";
            $scope.currentWindow = "AddEditContactWindow";
            $scope.DataObject.win_AddEditContactTitle = "Edit Contact";
            $scope.win_AddEditContact.setOptions({ height: $scope.addEditContactWindowHeight });
            $scope.win_AddEditContact.open();
            $scope.win_AddEditContact.wrapper.prev(".k-overlay").addClass("custom-overlay");
            var timeout = $timeout(function () {
                $scope.win_AddEditContact.center();
            }, 100);
            TimeoutList.push(timeout);
            clearContact();
            $scope.ContactId = obj.Id;
            $scope.FirstName = obj.FirstName;
            $scope.LastName = obj.LastName;
            $scope.loc.selectedItems = _.find($scope.DataObject.masterData.Locations, function (item) { return item.Location == obj.PrimaryLocation; });

            var mobile = $scope.spiltPhoneNumber(obj.Mobile);
            var office = $scope.spiltPhoneNumber(obj.Office);
            if (mobile && mobile.length > 0) {
                $scope.Mobile = (mobile != null) ? mobile[0] : '';
            }
            if (office && office.length > 0) {
                $scope.Office = (office != null) ? office[0] : '';
            }
            $scope.Email = (obj.EmailId) ? obj.EmailId.trim() : '';

        };
        $scope.saveContact = function (Flag) {
            toaster.success({ body: "Contact added successfully!" });
            $scope.getContact($scope.DataObject.FilterAddressBook.Name, $scope.DataObject.FilterAddressBook.LocationIDs, $scope.DataObject.FilterAddressBook.LocationName);
            $scope.win_AddEditContact.close();
        }
        function clearContact() {
            //$scope.frmContact.$setUntouched();
            $scope.SelectedLocationValues = { SelectedItems: [] };
            $scope.DataObject.AddressBookInfo.SelectedData = {
                StatsFlag: 'N',
                CreatedBy: $sessionStorage.currentUserData.userId,
            };
        }
        function ClipboardIconCase(data) {
            switch (data.ClipboardConditionData.ActionType) {
                case "Add":
                    if (data.ClipboardConditionData.OrderIDs) {
                        var OrderIDList = data
                            && data.ClipboardConditionData
                            && data.ClipboardConditionData.OrderIDs
                            && data.ClipboardConditionData.OrderIDs.indexOf(",") != -1
                            ? data.ClipboardConditionData.OrderIDs.split(',')
                            : [data.ClipboardConditionData.OrderIDs];
                        _.each(OrderIDList, function (orderId) {
                            var idx = _.findIndex(OrderList, function (order) { return order.OrderID == orderId });
                            if (idx != -1) {
                                if (vm.selectedData.LoggedInUserID == data.ClipboardConditionData.CreatedBy) {
                                    OrderList[idx].IsInClipboard = 2;
                                } else {
                                    OrderList[idx].IsInClipboard = 1;
                                }
                            }
                            UpdateGridData(orderId);
                        });
                    }
                    break;
                case "Remove":
                    var OrderIDList = data.ClipboardConditionData.OrderIdsToRemove.split(',');
                    _.each(OrderIDList, function (orderId) {
                        var idx = _.findIndex(OrderList, function (obj) { return obj.OrderID == orderId });
                        if (idx != -1) {
                            OrderList[idx].IsInClipboard = 0;
                        }
                        UpdateGridData(orderId);
                    });
                    break;
                case "Reset":
                    var OrderIDList = data.ClipboardConditionData.OrderIdsToRemove.split(',');
                    _.each(OrderIDList, function (orderId) {
                        var idx = _.findIndex(OrderList, function (obj) { return obj.OrderID == orderId });
                        if (idx != -1) {
                            OrderList[idx].IsInClipboard = 0;
                        }
                        UpdateGridData(orderId);
                    });
                    break;
            }
        }
        $scope.SignAndNextRec = function () {
            NextRec();
        };
        $scope.SignAndPrevRec = function () {
            PrevRec();
        };
        function PrevRec(idx) {
            vm.selectedData.CloseWindow = true;
            if (!$scope.DataObject.SingReport.Order) {
                $scope.DataObject.ShowPrevNextBtn = false;
                return;
            }

            // First call: idx is undefined — compute starting position from current order
            if (idx === undefined) {
                var currentIdx = _.findIndex($scope.DataObject.SingReport.OrderList, function (a) { return a.OrderID == $scope.DataObject.SingReport.Order.OrderID });
                idx = (currentIdx !== -1) ? currentIdx - 1 : -1;
            }

            // Skip statically restricted orders
            while (idx >= 0 && isOrderRestrictedForCurrentUser($scope.DataObject.SingReport.OrderList[idx])) {
                idx--;
            }

            if (idx < 0) {
                $scope.DataObject.NoPrevOrder = true;
                $scope.DataObject.SingReport.PrevToolTip = $sce.trustAsHtml('<span class="prevnxttt-lblno fs-12px">No Order</span>');
                toaster.pop('warning', 'Previous Order', 'No more available orders to go back to.');
                return;
            }

            var openOrders = {
                OrderId: $scope.DataObject.SingReport.OrderList[idx].OrderID,
                ProviderID: $sessionStorage.currentUserData.userId
            };
            WorklistService.GetOpenOrder(openOrders).then(function (result) {
                if (result && result.length > 0) {
                    // Order is locked — skip it without touching the scope or modal
                    PrevRec(idx - 1);
                }
                else {
                    // Order is free — apply the viewer override (as the manual open path does),
                    // then update the scope and open the modal
                    var prevOrder = $scope.DataObject.SingReport.OrderList[idx];
                    applyMedDreamViewerOverride(prevOrder).then(function () {
                        $scope.DataObject.SingReport.Order = prevOrder;
                        setSelected($scope.DataObject.SingReport.Order.OrderID, $scope.DataObject.SingReport.Order);
                        $scope.onClearFilterReportList(true);
                        if ($scope.DataObject.ModalReportNDiscussActiveIndex == 0) {
                            $scope.ReportSelectedOrder = _.clone($scope.SelectedOrder);
                        }
                        else if ($scope.DataObject.ModalReportNDiscussActiveIndex == 1 || $scope.DataObject.ModalReportNDiscussActiveIndex == 2) {
                            $scope.DiscussionSelectedOrder = _.clone($scope.SelectedOrder);
                        }
                        if (LastOpenedOrderID != null) {
                            DeleteOpenOrder();
                        }
                        InsertOpenOrder();
                        SetSignREportModal($scope.DataObject.SingReport.Order, $scope.DataObject.SingReport.OrderList);
                    });
                }
            });
        };

        $scope.changeHideStudyOption = function (value) {
            $scope.DataObject.HideOption = value;
            $scope.DataObject.hideStudyWindowHeight = "35%";
            if (value == "NeedMoreImages") {
                $scope.DataObject.hideStudyWindowHeight = "45%";
            }
            SetWindowOptions($scope.win_HideStudy, 'win_HideStudy', { height: $scope.DataObject.hideStudyWindowHeight });
        };
        function SetWindowOptions(win, key, options) {
            if (win) {
                win.setOptions(options);
            } else {
                var dialog = $("div[kendo-window='" + key + "']").data("kendoWindow");
                if (dialog) dialog.setOptions(options);
            }
        }
        $scope.CloseOrderDiscussion = function () {
            if ($scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId) {
                $scope.OrderDiscussion.Status = 'C';
                _.each($scope.OrderDiscussion.OrderDiscussionUserGroup, function (obj) {
                    NotifyToUser(__env._CLOSE_MSG_, $scope.SelectedOrder.OrderID, obj.ToUserID, null);
                });

            } else {
                NotifyToUser(__env._ANS_MSG_, $scope.SelectedOrder.OrderID, $scope.OrderDiscussion.FromUserID, null);
            }
            WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                /*
                 * Modified By: Tejas Parikh
                 * Task:        Bug 21731: Close discussion button is not working
                 */
                if ($scope.showDiscuss) {
                    $scope.win_ModalReportNDiscuss.close();
                }
                else {
                    $scope.win_Discussion.close();
                }
            });
        };
        $scope.SaveOrderDiscussion = function () {
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];
                $scope.SelectedOrder.listOrderListAssignment = [];

                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_MSG_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });


                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'O'
                };
                //$scope.isLoading = true;


                WorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                    $scope.SaveDiscussion();
                    LoadOrderDiscussionForUser();
                });
            }
        };
        $scope.SaveReviewOrder = function () {
            WorklistService.UpdateReviewOrder($scope.ReviewOrder).then(function (result) {
                $scope.SelectedOrder.Rating = $scope.ReviewOrder.Rating;
                $scope.SelectedOrder.Comments = $scope.ReviewOrder.Comments;
                $scope.SelectedOrder.IsInterestingCase = $scope.ReviewOrder.IsInterestingCase;
                $scope.SelectedOrder.Keywords = $scope.ReviewOrder.Keywords;

                var index = _.findIndex($scope.orderReportList, function (obj) {
                    return obj.OrderID == $scope.ReviewOrder.OrderID;
                });
                if (index != -1)
                    $scope.orderReportList[index] = $scope.ReviewOrder;
            });
        }
        $scope.InsertPSUsersBySIte = function () {
            var psuserFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: $scope.DataObject.SingReport.Order.SiteID,
                LocationID: $scope.DataObject.SingReport.Order.LocationID,
                UserName: $scope.PSUser.Username,
                Password: $scope.PSUser.Password
            };
            WorklistService.InsertPSUsersBySIte(psuserFilter).then(function (result) {
                $scope.win_PSUser.close();
                SignReport($scope.navFlag);
            });
        };
        $scope.InsertDicomViewerCredentials = function () {
            var objdata = {
                ID: -1,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: $scope.DVCred.SiteID,
                ViewerName: $scope.DVCred.ViewerName,
                UserName: $scope.DVCred.Username,
                Password: $scope.DVCred.Password,
                Modifyby: $sessionStorage.currentUserData.userId
            };
            WorklistService.InsertDicomViewerCredentials(objdata).then(function (result) {
                $('#ModalDicomViewerCredentials').modal('hide');
                if ($scope.GetDicomViewerCredentialsCallFrom == "OPENSYNAPSESTUDY") {
                    $scope.OpenSynapseStudy($scope.OpenSynapseStudyOrder, $scope.OpenSynapseStudyOptionalDV, $scope.OpenSynapseStudyisOpenPS);
                }
                else if ($scope.GetDicomViewerCredentialsCallFrom == "OPENSINGREPORT") {
                    $scope.OpenSignReport($scope.DataObject.SingReport.Order, $scope.DataObject.SingReport.OrderList);
                }
            });
        };
        $scope.spiltPhoneNumber = function (phone) {
            if (phone) {
                return phone.split(',');
            }
            else {
                return null;
            }
        }
        $scope.SetDicomViewerText = function (DV) {
            return SharedService.SetDicomViewerText(DV, $scope.DataObject.masterData.DicomViewers);
        }
        function GetLookupTypes() {
            var HiddenTypeList = _.filter($scope.DataObject.masterData.HiddenTypes, function (type) {
                if (type.Value != '0') {
                    type.tooltip = _.find($scope.DataObject.masterData.HiddenTypesTooltip, { Key: type.Key }).Value;
                }
                return type.Value != '0'
            });
            $scope.DataObject.HiddenTypeList = _.sortBy(HiddenTypeList, ['Value']);
            $scope.DataObject.HideOption.Key = $scope.DataObject.HiddenTypeList[0].Key;
        };
        $scope.clearCommentBox = function () {
            $scope.DataObject.HideOption.Comments = '';
        }

        //TODO: This functions will only work for new worklist
        function GetOrderDate() {
            var d = $q.defer();
            RuleOrderDate = { Value: 'Last 7 Days', DateValue: { startDate: null, endDate: null } };
            _.each($scope.DataObject.worklist.Groups, function (group) {
                var grpRuleConditions = _.filter(group.RulesConditions, function (cond) { return cond.StatusFlag != 'D' });
                RuleOrderDateLabel = _.find(grpRuleConditions, { ColumnName: 'ORDERS.OrderDate' });
            });

            if (RuleOrderDateLabel) {
                if (RuleOrderDateLabel.DateValue) {
                    RuleOrderDate.Value = RuleOrderDateLabel.DateValue.label;
                    if (RuleOrderDateLabel.DateValue && RuleOrderDateLabel.DateValue.label.includes('Custom range')) {
                        RuleOrderDate.Value += " " + moment(RuleOrderDateLabel.DateValue.startDate).format('MM/DD/YYYY') + " and " + moment(RuleOrderDateLabel.DateValue.endDate).format('MM/DD/YYYY') + "";
                        RuleOrderDate.DateValue.startDate = moment(RuleOrderDateLabel.DateValue.startDate).format('MM/DD/YYYY');
                        RuleOrderDate.DateValue.endDate = moment(RuleOrderDateLabel.DateValue.endDate).format('MM/DD/YYYY');
                    }
                } else if (RuleOrderDateLabel.Value) {
                    RuleOrderDate.Value = RuleOrderDateLabel.Value;
                    if (RuleOrderDateLabel.Value.toLowerCase().includes('custom')) {
                        var value = RuleOrderDateLabel.Value.substring(RuleOrderDateLabel.Value.indexOf('\''));
                        var datevalues = _.split(value, "and");
                        if (datevalues.length > 0) {
                            RuleOrderDate.DateValue.startDate = moment(datevalues[0].trim()).format('MM/DD/YYYY');
                            RuleOrderDate.DateValue.endDate = moment(datevalues[1].trim()).format('MM/DD/YYYY');
                        }
                    }
                }

            }
            RuleSharedService.setOrderDateByLabel(RuleOrderDate);

            d.resolve();
            return d.promise;
        }




        function GetSignDate() {
            var d = $q.defer();
            _.each($scope.DataObject.worklist.Groups, function (group) {
                var grpRuleConditions = _.filter(group.RulesConditions, function (cond) { return cond.StatusFlag != 'D' });
                RuleSignDateLabel = _.find(grpRuleConditions, { ColumnName: 'Reports.SignDate' });
            });

            if (RuleSignDateLabel) {
                RuleSignDate.Value = RuleSignDateLabel.DateValue.label;
                if (RuleSignDateLabel.DateValue && RuleSignDateLabel.DateValue.label.includes('Custom range')) {
                    RuleSignDate.Value += " " + moment(RuleSignDateLabel.DateValue.startDate).format('MM/DD/YYYY') + " and " + moment(RuleSignDateLabel.DateValue.endDate).format('MM/DD/YYYY') + "";
                    RuleSignDate.DateValue.startDate = moment(RuleSignDateLabel.DateValue.startDate).format('MM/DD/YYYY');
                    RuleSignDate.DateValue.endDate = moment(RuleSignDateLabel.DateValue.endDate).format('MM/DD/YYYY');
                }
            }
            RuleSharedService.setOrderDateByLabel(RuleSignDate);
            d.resolve();
            return d.promise;
        }

        function hideReceivedSince() {
            var hide = true;
            if (GetStatus() == 'RP' || GetStatus() == 'D') {
                hide = false;
            }
            return hide;
        }
        function initGrid() {
            if (($scope.DataObject.worklist.Type == 'D'
                || $scope.DataObject.worklist.Type == 'A')
                && !vm.viewMode
                && !$scope.DataObject.worklist.IsSmartWorklist) {
                _.each(gridOptions.columnDefs, function (columnDef) {
                    if (columnDef.field == 'Location'
                        || columnDef.field == 'Accession'
                        || columnDef.field == 'PatientMRN'
                        || columnDef.field == 'PatientName'
                        || columnDef.field == 'PatientClass'
                        || columnDef.field == 'ProcedureDesc'
                        || columnDef.field == 'OrderingPhysician'
                        || columnDef.field == 'SignByName'
                        || columnDef.field == 'Priority'
                        || columnDef.field == 'OrderDate'
                        || columnDef.field == 'ImageInstance'
                        || columnDef.field == 'WorkRVU'
                        || columnDef.field == 'SLA'
                        || columnDef.field == 'CreatedDate') {
                        columnDef.suppressMenu = false;
                        columnDef.menuTabs = ["filterMenuTab"];
                    }
                });
            }
            if ($scope.DataObject.worklist.IsSmartWorklist) {
                _.each(gridOptions.columnDefs, function (columnDef) {
                    columnDef.filter = false;
                    columnDef.suppressMenu = true;
                    columnDef.menuTabs = [];
                });
            }
            if (_.isNull(gridDiv) || _.isUndefined(gridDiv)) {
                gridDiv = document.getElementById($scope.DataObject.worklist.gridId);
                if (gridDiv && gridDiv != null) {
                    gridOptions.defaultColDef.sortable = $scope.DataObject.worklist.IsSmartWorklist ? false : true;
                    new agGrid.Grid(gridDiv, gridOptions);
                }
            }

        }
        function getOrderByAccessionNPSSiteName(Accession, PSSiteName) {
            return _.find(OrderList, function (obj) {
                return obj.Accession.toLowerCase().trim() == Accession.toLowerCase().trim() && obj.PSSiteName.toLowerCase().trim() == PSSiteName.toLowerCase().trim();
            });
        }

        function processSignReportResponse(data, SignedReportOrder) {
            //console.log("processSignReportResponse > data: ", data);
            //console.log("processSignReportResponse > SignedReportOrder: ", SignedReportOrder);
            //console.log("processSignReportResponse > Order: ", $scope.DataObject.SingReport.Order);
            _.remove(CurrentDictationOrder, function (orderObj) { return orderObj.OrderID == SignedReportOrder.OrderID; });

            var SignedOrDrafted = ($scope.NativeMessageResponseReportStatus == 2
                || $scope.NativeMessageResponseReportStatus == 8);
            $scope.navFlag = data.navFlag;

            if ($scope.NativeMessageResponseReportStatus == 8) {
                OpenOrder = {};
                VerfiyReadStudy(SignedReportOrder.OrderID, vm.selectedData.LoggedInUserID, null).then(function () {
                    if (OpenOrder.ClipboardDetailResult && OpenOrder.ClipboardDetailResult.length > 0) {
                        var obj = { OrderID: SignedReportOrder.OrderID, UserID: vm.selectedData.LoggedInUserID, RuleID: OpenOrder.ClipboardDetailResult[0].RuleID };
                        $rootScope.$broadcast('event.NotifyRemoveFromClipboard', obj);
                        WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                        $rootScope.$broadcast('event.worklist', { EventType: 'NotifyOrderListSaveReport', OrderID: SignedReportOrder.OrderID });
                    } else {
                        if (data.ClipboardRuleID > 0) {
                            var obj = { OrderID: SignedReportOrder.OrderID, UserID: vm.selectedData.LoggedInUserID, RuleID: data.ClipboardRuleID };
                            $rootScope.$broadcast('event.NotifyRemoveFromClipboard', obj);
                            WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                            $rootScope.$broadcast('event.worklist', { EventType: 'NotifyOrderListSaveReport', OrderID: SignedReportOrder.OrderID });
                        }
                    }
                });
            }
            if (SignedOrDrafted) {
                removeOrderFromList(SignedReportOrder.OrderID);
            }


            DictationReportState = "DictateByPS360";
            $scope.SingbtnDisabled = true;
            var psuserFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: SignedReportOrder.SiteID,
                LocationID: SignedReportOrder.LocationID,
                InstitutionID: SignedReportOrder.InstitutionID
            };
            WorklistService.CheckPSUserBySite(psuserFilter).then(function (result) {
                $scope.PSUser = result;
                $scope.SingbtnDisabled = false;
                if ($scope.PSUser == null || $scope.PSUser.length <= 0 || ($scope.PSUser[0].CreateORU == true && $scope.PSUser[0].IsValid.toString().toUpperCase() == "FALSE")) {
                    $scope.PSUser.Username = $scope.PSUser != null && $scope.PSUser.length > 0 ? $scope.PSUser[0].UserName : "";
                    //$scope.isLoading = false;
                    $scope.currentWindow = "win_PSUser";
                    $scope.win_PSUser.open();
                    $scope.win_PSUser.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    var timeout = $timeout(function () {
                        $scope.win_PSUser.center();

                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 100);
                    if ($scope.PSUser && $scope.PSUser.length > 0) { swal("Please update your password."); }
                } else {
                    if (SignedOrDrafted) {
                        if (($scope.DataObject.worklist.WorklistType != 16 && !$scope.DataObject.worklist.ChooseNextStudy) ||
                            ($scope.DataObject.worklist.WorklistType == 16 && !$scope.DataObject.worklist.OpenClipboardNextStudy)) {
                            if (data.navFlag == "NEXT") {
                                NextRec();
                            }
                            else if (data.navFlag == "PREV") {
                                PrevRec();
                            }

                        }

                    }
                    DeleteOpenOrder(SignedReportOrder);
                }

            });
        }

        function removeFromAGGrid(Order) {
            //console.log("removeFromAGGrid > Order: ", Order);
            gridOptions.api.applyServerSideTransaction({
                remove: [
                    Order
                ]
            });
        }

        function updateAGGridOrder(Object) {
            var updateTransaction = {
                update: Object,
            };
            gridOptions.api.applyServerSideTransaction(updateTransaction);
            gridOptions.api.redrawRows();
        }

        function updateAGGridDetailOrder(MasterOrder, DetailOrder) {
            if (!MasterOrder || !DetailOrder) {
                return;
            }

            if (MasterOrder && MasterOrder.ID) {
                // Get the detail grid for this master row
                var detailGridInfo = gridOptions.api.getDetailGridInfo("detail_" + MasterOrder.ID);
                if (detailGridInfo && detailGridInfo.api) {
                    var updateTransaction = {
                        update: DetailOrder,
                    };
                    detailGridInfo.api.applyServerSideTransaction(updateTransaction);
                    detailGridInfo.api.redrawRows();
                }
            }
        }

        function GetMasterOrder(Order) {
            if (!Order) {
                return {
                    masterOrder: null,
                    detailOrder: null
                };
            }

            var masterOrder = _.find(OrderList, function (master) {
                return master.ComparisonOrder && _.find(master.ComparisonOrder, { 'OrderID': Order.OrderID });
            });

            var detailOrder = null;
            if (masterOrder) {
                // Update the ComparisonOrder array in the master order
                var comparisonIndex = _.findIndex(masterOrder.ComparisonOrder, { 'OrderID': Order.OrderID });
                if (comparisonIndex !== -1) {
                    // Merge the updated order data
                    masterOrder.ComparisonOrder[comparisonIndex] = _.assign(masterOrder.ComparisonOrder[comparisonIndex], Order);
                    detailOrder = masterOrder.ComparisonOrder[comparisonIndex];
                }
            }

            return {
                masterOrder: masterOrder,
                detailOrder: detailOrder
            };
        }

        function getRowTemplateColorCode(order) {
            var Status = GetStatus();
            var colorCode = '';
            switch (Status) {
                case 'RP':
                    switch (order.Status) {
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : $scope.DataObject.masterData.DelayStatColorCode ? $scope.DataObject.masterData.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasImage && !order.HasORM) {
                                colorCode = '#b2b266';
                            }
                            break;
                    }
                    break;
                case 'AL':
                    switch (order.Status) {
                        case 'X':
                            colorCode = '#BFDED6';
                            break;
                        case 'CO':
                            colorCode = '#B9ADCF';
                            break;
                        case 'C':
                            colorCode = '#75E284';
                            break;
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'H':
                            colorCode = '#FFC99A';
                            break;
                        case 'RC':
                            colorCode = '#79b384';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : $scope.DataObject.masterData.DelayStatColorCode ? $scope.DataObject.masterData.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasORM && order.HasImage) {
                                colorCode = '#FFE69A';
                            } else if (colorCode.length == 0 && !order.HasORM && order.HasImage) {
                                colorCode = '#b2b266';
                            } else if (colorCode.length == 0 && order.HasORM && !order.HasImage) {
                                colorCode = '#f4ba4b';
                            }
                            break;
                        case 'PA':
                            colorCode = '#ffe6ee';
                            break;
                    }
                    if (colorCode.length == 0 && !order.HasORM) {
                        colorCode = '#ff873a';
                    } else if (colorCode.length == 0 && !order.HasImage) {
                        colorCode = '#f4ba4b';
                    }
                    break;
            }
            return colorCode.length > 0 ? colorCode : '#ffffff';
        }
        function selectAgGridRow(OrderID) {
            var order = _.find(OrderList, { 'OrderID': OrderID });
            if (order != null) {
                var node = gridOptions.api.getRowNode(order.ID)
                if (node) {
                    node.setSelected(true);
                }
            }
        }

        /**
         * Returns true if the given order should be blocked/skipped for the current user
         * because it is either in another user's clipboard (IsInClipboard === 1) or
         * assigned exclusively to another user (OrderAssingedUsers > 0 and not assigned to current user).
         *
         * Always returns false (never skip) when:
         *   - The order is assigned to the current user (OrderAssingedUser != null)
         *   - The order is in the current user's own clipboard (IsInClipboard === 2)
         *
         * Used by both NextRec (auto-skip) and VerifyOpenOrder (hard-block on double-click).
         */
        function isOrderRestrictedForCurrentUser(order) {
            // Never skip if the order is assigned to the current user
            if (order.OrderAssingedUser && order.OrderAssingedUser != null) {
                return false;
            }
            // Never skip if the order is in the current user's own clipboard
            if (order.IsInClipboard === 2) {
                return false;
            }
            // Skip if the order is in another user's clipboard
            if (order.IsInClipboard === 1) {
                return true;
            }
            // Skip if the order is assigned to another user (and not to the current user)
            if (order.OrderAssingedUsers > 0 && (!order.OrderAssingedUser || order.OrderAssingedUser == null)) {
                return true;
            }
            return false;
        }

        function VerifyOpenOrder(OpenOrder) {

            var showProviderName = (($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && ($scope.DataObject.EnableRowsForSelectedTenants && $scope.DataObject.EnableRowsForSelectedTenants.includes($scope.DataObject.SingReport.Order.TenantName))))

            if (OpenOrder.ClipboardDetailResult && OpenOrder.ClipboardDetailResult.length > 0) {
                if (!confirm('This study is already assigned to the "' + OpenOrder.ClipboardDetailResult[0].UserName + '\'s" clipboard. \nDo you still wish to continue reading the study?')) {
                    _isOpeningStudy = false;
                    return;
                }
                else {
                    var obj = { OrderID: $scope.DataObject.SingReport.Order.OrderID, UserID: vm.selectedData.LoggedInUserID, RuleID: OpenOrder.ClipboardDetailResult[0].RuleID };
                    $rootScope.$broadcast('event.NotifyRemoveFromClipboard', obj);
                    WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                    $rootScope.$broadcast('event.worklist', { EventType: 'NotifyOrderListSaveReport', OrderID: $scope.DataObject.SingReport.Order.OrderID });
                }
            }
            if ($scope.DataObject.SingReport.Order.OrderAssingedUsers > 0 && (!$scope.DataObject.SingReport.Order.OrderAssingedUser || $scope.DataObject.SingReport.Order.OrderAssingedUser == null)) {
                var UserName = getOrderListTooltip($scope.DataObject.SingReport.Order);
                if (UserName && UserName != null && !confirm('This study is already ' + UserName.replace("Assigned to", "assigned to") + ', \nDo you still wish to continue reading the study?')) {
                    _isOpeningStudy = false;
                    return;
                }
            }
            if (OpenOrder.VerifyReadStudyResult.openOrders && OpenOrder.VerifyReadStudyResult.openOrders.length > 0) {
                if (($scope.DataObject.worklist.WorklistType != 16 && $scope.DataObject.worklist.ChooseNextStudy) ||
                    ($scope.DataObject.worklist.WorklistType == 16 && $scope.DataObject.worklist.OpenClipboardNextStudy)) {
                    var msg = "This order is presently being dictated";
                    msg = (!showProviderName) ? msg + "  by user " + OpenOrder.VerifyReadStudyResult.openOrders[0].ProviderName : msg;
                    msg = msg + ".\nPlease select a different study to open.";
                    alert(msg);
                    _isOpeningStudy = false;
                    return;
                }
                else {
                    var msg = "This order is presently being dictated";
                    msg = (!showProviderName) ? msg + "  by user " + OpenOrder.VerifyReadStudyResult.openOrders[0].ProviderName : msg;
                    msg = msg + ".\nDo you want to launch the next study?";
                    if (!confirm(msg)) {
                        _isOpeningStudy = false;
                        return;
                    } else {
                        _isOpeningStudy = false;
                        NextRec();
                        return;
                    }

                }
            }
            if (OpenOrder.VerifyReadStudyResult.reportView && OpenOrder.VerifyReadStudyResult.reportView.ReportStatus == 2 && OpenOrder.VerifyReadStudyResult.reportView.SignBy != vm.selectedData.LoggedInUserID) {

                var msg = "This order has been drafted";
                msg = (!showProviderName) ? msg + " by user " + OpenOrder.VerifyReadStudyResult.reportView.SignByName : msg;
                msg = msg + '.\nAre you sure you want to proceed?';

                if (!confirm(msg)) {
                    _isOpeningStudy = false;
                    return;
                }
            }
            if (!allowRoutineStudy()) { _isOpeningStudy = false; return; }

            var order = $scope.DataObject.SingReport.Order;
            WorklistService.GetMedDreamViewerOverrideByStudy({
                SiteID: order.SiteID,
                RadiologistUserID: vm.selectedData.LoggedInUserID
            }).then(function (response) {
                if (response && response.data && response.data.HasOverride === true) {
                    order.DicomViewer = response.data.DicomViewer;
                }
                Call_SetSignREportModal();
            }, function () {
                Call_SetSignREportModal();
            });
        }

        function allowRoutineStudy() {
            //console.log("allowRoutineStudy");
            var Status = GetStatus();
            if (Status == 'RP') {
                //console.log("allowRoutineStudy > Order: ", $scope.DataObject.SingReport.Order);
                if (EnableRowsForSelectedTenants && !$scope.DataObject.worklist.IsSmartWorklist
                    && !$sessionStorage.currentUserData.AllowEnableRowsForSelectedTenants
                    && $sessionStorage.EnableRowsForSelectedTenants
                    && $sessionStorage.EnableRowsForSelectedTenants.length > 0
                    && ($scope.DataObject.SingReport.Order.Priority.toUpperCase().trim().includes('ROUTINE')
                        || $scope.DataObject.SingReport.Order.Priority.toUpperCase().trim().includes('DELAYED'))
                    && $sessionStorage.EnableRowsForSelectedTenants.split(',').includes($scope.DataObject.SingReport.Order.TenantName)) {
                    $scope.currentWindow = 'win_STATStudiesFirst';
                    $scope.win_STATStudiesFirst.open();
                    $scope.win_STATStudiesFirst.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
            return true;
        }

        function GetClipboardDetailByOrderID(OrderID) {
            var d = $q.defer();
            if ($scope.DataObject.SingReport.Order.IsInClipboard && $scope.DataObject.SingReport.Order.IsInClipboard == 1) {
                WorklistService.GetClipboardDetailByOrderID(OrderID).then(function (result) {
                    OpenOrder.ClipboardDetailResult = result;
                    d.resolve();
                });
            }
            else {
                d.resolve();
            }
            return d.promise;
        }

        function VerfiyReadStudy(OrderID, ProviderID, data) {
            //console.log("VerfiyReadStudy > OrderID: ", OrderID);
            var d = $q.defer();
            var openOrders = { OrderId: OrderID, ProviderID: ProviderID };
            var pending = _verifyReadStudyCache[OrderID] || WorklistService.VerfiyReadStudy(openOrders);
            delete _verifyReadStudyCache[OrderID];
            pending.then(function (result) {
                OpenOrder.VerifyReadStudyResult = result;
                d.resolve();
            }).catch(function () { d.reject(); });
            return d.promise;
        }

        function ShowEnforceReadsPromptIfNeeded(OpenOrder) {
            var ev = OpenOrder.EnforceReadsResult;
            if (!ev) { return; }
            var priorityUpper = $scope.DataObject.SingReport.Order.Priority ? $scope.DataObject.SingReport.Order.Priority.toUpperCase().trim() : '';
            var isStatStudy = $scope.DataObject.SingReport.Order.IsStat || priorityUpper.includes('STAT');
            var primaryModalityUpper = (ev.PrimaryModality || '').toUpperCase().trim();
            var configModalityUpper = (ev.ConfigModality || '').toUpperCase().trim();
            var isExemptModality = primaryModalityUpper.length > 0 && primaryModalityUpper === configModalityUpper;
            if (!ev.ShouldPrompt || isStatStudy || isExemptModality || GetStatus() !== 'RP') { return; }

            var modality = ev.ConfigModality;
            var threshold = ev.TriggerRVU;
            var pending = ev.PendingXRayCount;
            var targetRead = ev.TargetRead;
            var enforcedReadCount = ev.EnforcedReadCount;
            var remaining = (targetRead < pending) ? (targetRead - enforcedReadCount) : pending;
            var progressPct = targetRead > 0 ? Math.min(Math.round((enforcedReadCount / targetRead) * 100), 100) : 0;

            var intro = 'There are ' + modality + ' studies available to be read and you have read more than '
                + threshold + ' RVU worth of non-' + modality + ' studies already. ';
            var enforceMsg = intro + 'You are requested to read ' + remaining + ' '
                + modality + ' studies before moving to other modalities.';

            var progressHtml = '<div style="border-left:2px solid #ff0000;padding:10px 0 10px 12px;margin-bottom:14px;text-align:left;">'
                +   '<span style="color:#ffcccc;font-size:13px;line-height:1.6;">' + enforceMsg + '</span>'
                + '</div>'
                + '<div style="text-align:left;color:#e4e4e4;font-size:12px;margin-bottom:6px;">Read ' + targetRead + ' ' + modality + ' studies</div>'
                + '<div style="background:#1a1a1a;border-radius:3px;height:6px;overflow:hidden;">'
                +   '<div style="background:#209e91;height:6px;width:' + progressPct + '%;border-radius:3px;transition:width 0.3s ease;"></div>'
                + '</div>'
                + '<div style="text-align:right;font-size:12px;color:#e4e4e4;margin-top:4px;">' + enforcedReadCount + '/' + targetRead + '</div>';

            swal({ title: 'Enforce Reads', text: progressHtml, html: true, customClass: 'swal-wide', confirmButtonText: 'OK' });
        }

        function GetEnforceReadsEvaluate(order) {
            var d = $q.defer();
            // Derive today's date in CST first, then do all arithmetic in CST
            // (avoids local-timezone drift — e.g. IST is 10.5h ahead of CDT)
            var _cstDateStr = function (dt) {
                var s = dt.toLocaleDateString('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' });
                var p = s.split('/'); // MM/DD/YYYY
                return p[2] + '-' + p[0] + '-' + p[1];
            };
            var _todayCST = _cstDateStr(new Date()); // "YYYY-MM-DD" in CST
            var _tp = _todayCST.split('-');
            // Use noon to stay clear of DST boundaries when constructing Date objects
            var _startCST = new Date(parseInt(_tp[0]), parseInt(_tp[1]) - 1, parseInt(_tp[2]) - 2, 12, 0, 0);
            var request = {
                UserID: vm.selectedData.LoggedInUserID,
                TenantName: order.TenantName,
                Site: order.Site,
                OrderID: order.OrderID,
                EventType: 'Open',
                StudyModality: order.Modality,
                WorklistFlag: $scope.DataObject.worklist.RuleID,
                SiteID: order.SiteID,
                LocationID: $scope.DataObject.worklist.LocationID || null,
                STATFilter: $scope.DataObject.worklist.STATFilter || null,
                ShowLockStudy: true,
                OrderDateStartDate: _cstDateStr(_startCST) + 'T00:00:00',
                OrderDateEndDate: _todayCST + 'T23:59:59'
            };
            WorklistService.EnforceReadsEvaluate(request).then(function (result) {
                OpenOrder.EnforceReadsResult = result;
                d.resolve();
            }, function () {
                d.resolve();
            });
            return d.promise;
        }

        function UpdateOrderDetail(obj, message, Order) {
            WorklistService.UpdateOrderDetail(obj).then(function () {
                toaster.success({ body: message });
                if ($scope.currentWindow == 'win_peer_review') {
                    $scope.win_peer_review.close();
                    $scope.onPeerReviewClose();
                    $scope.DataObject.isAutoAssignPeerReviewWin = false;
                }
                if (Order && !Order.ComparisonOrder && Order.isComparisionOrder) {
                    Order.IsReviewAssigned = true;
                    var result = GetMasterOrder(Order);
                    if (result.masterOrder) {
                        updateAGGridDetailOrder(result.masterOrder, [result.detailOrder || Order]);
                    }
                }
            });
        }

        function NotifyUpdateOrderDetail(data) {
            var index = _.findIndex(OrderList, { 'OrderID': data.OrderDetail.OrderID });
            if (index != -1) {
                if (data.OrderDetail.ExamTag != null) { OrderList[index].ExamTag = data.OrderDetail.ExamTag; }
                if (data.OrderDetail.RadExamTag != null) { OrderList[index].RadExamTag = data.OrderDetail.RadExamTag; }
                if (data.OrderDetail.isPeerReview != null) { OrderList[index].IsReviewAssigned = true; }
                updateAGGridOrder([OrderList[index]]);
            }
            else {
                var result = GetMasterOrder(data.OrderDetail);
                if (result.masterOrder && result.detailOrder) {
                    result.detailOrder.IsReviewAssigned = true;
                    updateAGGridDetailOrder(result.masterOrder, [result.detailOrder]);
                }
            }
        }
        $scope.RemoveTag = function (params, ExamTag, RadExamTag) {
            var obj = {
                OrderID: params.OrderID,
                UserID: $sessionStorage.currentUserData.userId,
            };
            if (ExamTag) {
                obj.ExamTag = '0';
            }
            else {
                if (params.RadExamTag && params.RadExamTag.includes(',')) {
                    switch (RadExamTag) {
                        case 1:
                            obj.RadExamTag = '2';
                            break;
                        case 2:
                            obj.RadExamTag = '1';
                            break;
                    }
                }
                else {
                    obj.RadExamTag = '0';
                }
            }
            NotifyUpdateOrderDetail({ OrderDetail: obj });
            UpdateOrderDetail(obj, "Tag removed successfully!");
        }

        function getFilterString(type, filter) {
            var FilterString = "";
            switch (type) {
                case 'contains':
                    FilterString = "*" + filter + "*";
                    break;
                case 'equals':
                    FilterString = filter;
                    break;
                case 'endsWith':
                    FilterString = "*" + filter;
                    break;
                case 'startsWith':
                    FilterString = filter + "*";
                    break;
            }
            return FilterString;
        }

        function resetParameter() {
            PageNo = 1;
            OrderList = [];
            autoRefreshing = true;
            $scope.TotalRows = 0;
            gridOptions.api.setCacheBlockSize($scope.DataObject.worklist.PageSize);
            statusBarComponent.eGui.hidden = true;
        }

        $scope.removeComparedStudy = function (ComparisonOrderID) {
            ////$log.log('removeComparedStudy');
            if (confirm("Are you sure you want to remove this study from comparison?")) {
                $scope.isLoading = true;
                var comparisonOrder = {
                    ComparisonOrderID: ComparisonOrderID,
                    UserId: $sessionStorage.currentUserData.userId
                };

                WorklistService.RemoveComparedStudy(comparisonOrder).then(function (result) {
                    $scope.isLoading = false;

                    removeOrderFromList(ComparisonOrderID);
                });
            }
        }

        function setSelectedUserAssignment(usergroups) {
            ////$log.log("setSelectedWorklistFilterSettings: " + new Date());
            var ddt = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            if (ddt) {
                ddt.value(usergroups);
            } else {
                $timeout(function () {
                    setSelectedUserAssignment(usergroups);
                }, 100);
            }
        }
        $scope.FilterReportList = function (FilterFlag) {
            var FilteredList = ReportList;
            var startDate, endDate = null;
            if ($scope.DataObject.ReportListFilter.DateRange != 'Any') {
                switch ($scope.DataObject.ReportListFilter.DateRange) {
                    case '6m':
                        startDate = new Date(moment().subtract(6, 'month'));
                        endDate = new Date(moment());
                        break;
                    case '1y':
                        startDate = new Date(moment().subtract(1, 'year').add(1, 'days'));
                        endDate = new Date(moment());
                        break;
                    case '2y':
                        startDate = new Date(moment().subtract(2, 'year'));
                        endDate = new Date(moment());
                        break;
                    case '5y':
                        startDate = new Date(moment().subtract(5, 'year'));
                        endDate = new Date(moment());
                        break;
                }
                FilteredList = _.filter(FilteredList, function (report) {
                    var itemDate = new Date(report.OrderDate);
                    return itemDate >= startDate && itemDate <= endDate;
                });
            }
            if ($scope.DataObject.ReportListFilter.Modality != 'All') {
                FilteredList = _.filter(FilteredList, { 'Modality': $scope.DataObject.ReportListFilter.Modality });
            }
            if ($scope.DataObject.SearchText != '') {
                var result = null;
                result = _.filter(FilteredList, function (item) {
                    return _.some(['OrderDate', 'ProcedureDesc', 'SignByName'], function (key) {
                        if (key == 'OrderDate') {
                            return moment(_.get(item, key, '')).format('MM/DD/YYYY').toString().toLowerCase().includes($scope.DataObject.SearchText.toLowerCase());
                        }
                        else {
                            var value = _.get(item, key, '');
                            if (value) {
                                return value.toString().toLowerCase().includes($scope.DataObject.SearchText.toLowerCase());
                            }
                        }
                        return false;
                    });
                });
                if (result) { FilteredList = result; }
            }
            $scope.reportList = FilteredList;
            if (FilterFlag && $scope.reportList && $scope.reportList.length > 0) {
                var objSelectedReport = $scope.reportList[$scope.reportList.length - 1];
                if (objSelectedReport) {
                    $scope.SelectedOrderAccession = objSelectedReport.Accession;
                    LoadReport(objSelectedReport.OrderID);
                }
            }
        }
        $scope.onClearFilterReportList = function (ClearFlag) {
            $scope.DataObject.SelectedSortingOption = 'DOS (newest first)';
            $scope.DataObject.ReportListFilter.Modality = 'All';
            $scope.DataObject.ReportListFilter.DateRange = 'Any';
            $scope.DataObject.ReportSortingPropName = 'OrderDate';
            $scope.DataObject.ReportSortingRevOrder = true;
            if (ClearFlag) {
                $scope.DataObject.ReportList.Modalities = ['All'];
                $scope.DataObject.ShowReportModal = false;
            }
            $scope.DataObject.SearchText = '';
        }
        $scope.onModalReportNDiscussionTabsChange = function (TabName) {
            switch (TabName) {
                case 'Report':
                    $scope.onClearFilterReportList(false);
                    $scope.FilterReportList(false);
                    $scope.ReportSelectedOrder = _.clone($scope.SelectedOrder);
                    if ($scope.report) {
                        AssignValuesReportToSelectedOrder();
                    }
                    //$scope.ReportSelectedOrder.ReportStatus = $scope.report ? $scope.report.Status : $scope.ReportSelectedOrder.ReportStatus;
                    break;
                case 'Discussion':
                    $scope.DiscussionSelectedOrder = _.clone($scope.SelectedOrder);
                    break;
                case 'Attachment':
                    $scope.DataObject.Reference.ID = null;
                    var timeout = $timeout(function () {
                        $scope.showFileList();
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 50);
                    break;
            }
        }

        function clearColumnFilterList() {
            if (!FilterByLocationIDs &&
                !FilterByAccession &&
                !FilterByModality &&
                !FilterByOrderingPhysician &&
                !FilterByPatientMRN &&
                !FilterByPatientName &&
                !FilterByPriority &&
                !FilterByProcedureDesc &&
                !FilterByRenderingPhysician &&
                !FilterByType &&
                FilterByDOSDateRange.StartDate.length == 0 &&
                FilterByDOSDateRange.EndDate.length == 0) {
                columnFilterData = [];
            }
        }

        function DefaultExportParams(params) {
            if (params.column.colId == "ExamTag" && (params.value || params.node.data.RadExamTag)) {
                if (params.node.data && params.node.data.RadExamTag && params.node.data.RadExamTag != "0") {
                    var ExamTag = _.find($scope.DataObject.masterData.ExamTags, { 'Value': params.value });
                    var RadExamTags = [];
                    var SplitExamTags = (params.node.data.RadExamTag && params.node.data.RadExamTag.includes(',') ? params.node.data.RadExamTag.split(',') : params.node.data.RadExamTag);
                    _.each(SplitExamTags, function (ExamTag) {
                        var obj = _.find($scope.DataObject.masterData.RadExamTag, { Value: ExamTag });

                        if (obj) {
                            RadExamTags.push(obj.Key);
                        }
                    });
                    return ExamTag && RadExamTags ? ExamTag.Key + ' ,' + _.join(RadExamTags, ' ,') : (RadExamTags ? _.join(RadExamTags, ' ,') : null);
                }
                else {
                    return _.find($scope.DataObject.masterData.ExamTags, { 'Value': params.value }) ? _.find($scope.DataObject.masterData.ExamTags, { 'Value': params.value }).Key : null;
                }
            }
            if (params.column.colId == "OrderDate" || params.column.colId == "CreatedDate" || params.column.colId == "ReportSignDate") {
                return ($filter('localDate')(params.value, false, new Date()));
            }
            if (params.column.colId == 'SLA') {
                if (params.node.data && params.node.data.TAT) {
                    if (params.node.data.TAT > 0) {
                        return params.node.data.TAT + ' MIN';
                    } else {
                        return '0 MIN';
                    }
                }
            }
            return params.value;
        }

        $scope.onReportSortingClicked = function (sortingOption) {
            $scope.DataObject.SelectedSortingOption = sortingOption;
            var ReportListElement = document.getElementsByClassName('repoHeiFtrWrklst ftlrbtns-height');
            if (ReportListElement && ReportListElement[0] && ReportListElement[0].scrollTop > 0) {
                ReportListElement[0].scrollTop = 0;
            }
            switch (sortingOption) {
                case 'DOS (newest first)':
                    $scope.DataObject.ReportSortingPropName = 'OrderDate';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
                case 'DOS (oldest first)':
                    $scope.DataObject.ReportSortingPropName = 'OrderDate';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Rendering Physician (A to Z)':
                    $scope.DataObject.ReportSortingPropName = 'SignByName';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Rendering Physician (Z to A)':
                    $scope.DataObject.ReportSortingPropName = 'SignByName';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
                case 'Procedure (A to Z)':
                    $scope.DataObject.ReportSortingPropName = 'ProcedureDesc';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Procedure (Z to A)':
                    $scope.DataObject.ReportSortingPropName = 'ProcedureDesc';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
            }
        }

        function PendingSinceColChanges(columnStates) {
            var columnDefs = gridOptions.api.getColumnDefs();
            var receivedSinceColIndex = _.findIndex(columnStates, { 'colId': 'ReceivedSince' });
            var receivedSinceColDefIndex = _.findIndex(columnDefs, { 'field': 'ReceivedSince' });
            if (receivedSinceColIndex != -1) {
                var visiblePendingSince = columnStates[receivedSinceColIndex].hide;
                columnStates[receivedSinceColIndex].hide = visiblePendingSince ? visiblePendingSince : hideReceivedSince();
                columnStates[receivedSinceColIndex].lockVisible = hideReceivedSince();
            }
            if (receivedSinceColDefIndex != -1) {
                columnDefs[receivedSinceColDefIndex].hide = hideReceivedSince();
                columnDefs[receivedSinceColDefIndex].lockVisible = hideReceivedSince();
            }
            ColumnDefs = columnDefs;
        }
        function _respError(error) {
            ////////$log.log("_respError");
            $scope.isLoading = false;
        }
        function getPageSize(height) {
            return ((height / 26) + 30);
        }
        //#region Addendum Request

        $scope.UpdateAddendumRequestReportStatus = function () {
            WorklistService.UpdateAddendumRequestReportStatus({
                Order: $scope.SelectedOrder,
                OrderID: $scope.SelectedOrder.OrderID,
                AddendumRequestedBy: $sessionStorage.currentUserData.userId,
                IsHighPriority: $scope.DataObject.AddendumRequest.isHighPriorityAddendum,
                DicomOrderID: $scope.SelectedOrder.DicomOrderID,
                Comment: $scope.DataObject.AddendumRequest.AddendumComment,
                ReportID: $scope.SelectedOrder.ReportID,
                ToUserID: $scope.DataObject.AddendumRequest.AssignedUser.Id,
                FromUser: $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName,
                AddendumRequestedFrom: 'Radflow',
                ToUserPhoneNumber: $scope.DataObject.AddendumRequest.AssignedUser.PhoneNumber
            }).then(function (res) {
                removeOrderFromList($scope.SelectedOrder.OrderID);
                $scope.win_addendum_request.close();
                $scope.onAddendumReqClose();
            });
        }

        $scope.onAddendumReqClose = function () {
            $scope.DataObject.AddendumRequest.showAddendumReq = false;
            $scope.SelectedOrder = {};
            $scope.DataObject.AddendumRequest.isHighPriorityAddendum = false;
            $scope.DataObject.AddendumRequest.AddendumComment = null;
            $scope.DataObject.AddendumRequest.AssignedUser = null;
            $scope.DataObject.AddendumRequest.AssignedUserTooltip = "Select Radiologist";
        }
        $scope.onAddendumUserSelect = function () {
            if ($scope.DataObject.AddendumRequest.AssignedUser) {
                $scope.DataObject.AddendumRequest.AssignedUserTooltip = $scope.radDisplay($scope.DataObject.AddendumRequest.AssignedUser);
            } else {
                $scope.DataObject.AddendumRequest.AssignedUserTooltip = "Select Radiologist";
            }
        }
        //#endregion Addendum Request

        //#region Peer Review
        $scope.onPeerReviewClose = function () {
            $scope.DataObject.PeerReview.showPeerReview = false;
            $scope.SelectedOrder = {};
            $scope.DataObject.PeerReview.Comment = null;
            $scope.DataObject.PeerReview.AssignedUser = null;
            $scope.DataObject.PeerReview.AssignedUserTooltip = "Select Radiologist";
            $scope.DataObject.isAutoAssignPeerReviewWin = false;
        }

        $scope.onPeerReviewUserSelect = function () {
            if ($scope.DataObject.PeerReview.AssignedUser) {
                $scope.DataObject.PeerReview.AssignedUserTooltip = $scope.radDisplay($scope.DataObject.PeerReview.AssignedUser);
            } else {
                $scope.DataObject.PeerReview.AssignedUserTooltip = "Select Radiologist";
            }
        }

        $scope.AddOrderToSpecificPeer = function () {
            var obj = {
                OrderID: $scope.SelectedOrder.OrderID,
                isPeerReview: '1',
                PeerReviewUserID: $scope.DataObject.PeerReview.AssignedUser.Id,
                UserID: $sessionStorage.currentUserData.userId,
                DicomOrderID: $scope.SelectedOrder.DicomOrderID,
                Comment: $scope.DataObject.PeerReview.Comment ? $scope.DataObject.PeerReview.Comment : null,
            }
            UpdateOrderDetail(obj, PeerReviewToasterMessage, $scope.SelectedOrder);
        }

        function AddToPeerReview(type, Order) {
            switch (type) {
                case 'Assign to Me':
                    var obj = {
                        OrderID: Order.OrderID,
                        isPeerReview: '1',
                        PeerReviewUserID: $sessionStorage.currentUserData.userId,
                        UserID: $sessionStorage.currentUserData.userId,
                        DicomOrderID: Order.DicomOrderID,
                    }
                    UpdateOrderDetail(obj, PeerReviewToasterMessage, Order);
                    break;
                case 'Auto Assign':
                    $scope.DataObject.isAutoAssignPeerReviewWin = true;
                    setSelected(Order.OrderID, Order);
                    $scope.currentWindow = 'win_peer_review';
                    OpenWindow($scope.win_peer_review, 'win_peer_review');
                    $scope.win_peer_review.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    break;
                case 'Assign to Specific User':
                    setSelected(Order.OrderID, Order);
                    WorklistService.GetPeerReviewerListByUserID({ UserID: $sessionStorage.currentUserData.userId, isReviewer: true, Modality: Order.Modality, SiteID: Order.SiteID }).then(function (result) {
                        $scope.DataObject.masterData.PeerReviewRadiologists = result;
                        $scope.DataObject.masterData.PeerReviewRadiologists = _.sortBy($scope.DataObject.masterData.PeerReviewRadiologists, ['UserName']);
                        $scope.onPeerReviewUserSelect();
                        $scope.currentWindow = 'win_peer_review';
                        OpenWindow($scope.win_peer_review, 'win_peer_review');
                        $scope.win_peer_review.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    });
                    break;
            }
        }
        $scope.AutoAssignPeerReview = function () {
            var obj = {
                OrderID: $scope.SelectedOrder.OrderID,
                isPeerReview: '1',
                PeerReviewUserID: 'Auto',
                UserID: $sessionStorage.currentUserData.userId,
                DicomOrderID: $scope.SelectedOrder.DicomOrderID,
                Comment: $scope.DataObject.PeerReview.Comment ? $scope.DataObject.PeerReview.Comment : null,
            }
            UpdateOrderDetail(obj, PeerReviewToasterMessage, $scope.SelectedOrder);
        }
        //#endregion Peer Review

        //#region Query Retrieve
        $scope.QueryRetrieve = function (Order, FromContextMenu) {
            var d = $q.defer();
            $scope.ClearQueryRetrieve();
            //open modal
            setSelected(Order.OrderID, Order);
            ManageLocationService.GetSiteApplicationEntity({ SiteID: Order.SiteID }).then(function (result) {
                if (result && result.length > 0) {
                    _.each(result, function (item) {
                        if (!$scope.DataObject.QueryRetrieve[item.AEType]) {
                            $scope.DataObject.QueryRetrieve[item.AEType] = {
                                HostName: item.Host,
                                Port: item.Port,
                                TlsEnabled: item.TLS,
                                AeTitle: item.AETitle
                            };
                        }
                    });
                }
                else {
                    toaster.warning({ body: "Query retrieval is not configured for this site. Please reach out to the site administrator for assistance." });
                    return;
                }

                ManageLocationService.GetSitePrefixSuffix({ SiteID: Order.SiteID }).then(function (res) {
                    var result = null;
                    if (res && res.length > 0) {
                        var result = res[0];
                        $scope.DataObject.QueryRetrieve.PatientMRN = Order.PatientMRN.replace(result.Prefix, "").replace(result.Suffix, "");
                    }
                    else {
                        $scope.DataObject.QueryRetrieve.PatientMRN = Order.PatientMRN;
                    }
                    if (FromContextMenu) {
                        $scope.currentWindow = 'win_query_retrive';
                        OpenWindow($scope.win_query_retrive, 'win_query_retrive');
                        $scope.win_query_retrive.wrapper.prev(".k-overlay").addClass("custom-overlay");

                        var Timeout = $timeout(function () {
                            var gridDiv = document.getElementById("myQueryGrid");
                            if (gridDiv && gridDiv != null) {
                                new agGrid.Grid(gridDiv, queryGridOptions);
                            }

                            $scope.QueryRetrieveFilter();
                            d.resolve();
                            $timeout.cancel(Timeout);
                            Timeout = null;
                        }, 100);
                    }
                    else {
                        $scope.DataObject.QueryRetrieve.Accession = (result != null) ? Order.Accession.replace(result.Prefix, "").replace(result.Suffix, "") : Order.Accession;
                        DCMQRDoFind().then(function () {
                            d.resolve();
                        });
                    }
                });
            });
            return d.promise;
        }
        $scope.QueryRetrieveFilter = function (SearchFlag) {
            if (queryGridOptions && queryGridOptions.api) {
                queryGridOptions.api.setRowData([]);
            }
            $scope.DataObject.QueryRetrieve.IsExpanded = false;
            $scope.DataObject.QueryRetrieve.IsAllStudySelected = false;
            if (SearchFlag && !(($scope.DataObject.QueryRetrieve.FirstName && $scope.DataObject.QueryRetrieve.FirstName != '') || ($scope.DataObject.QueryRetrieve.LastName && $scope.DataObject.QueryRetrieve.LastName != '') || ($scope.DataObject.QueryRetrieve.PatientMRN && $scope.DataObject.QueryRetrieve.PatientMRN != '') || ($scope.DataObject.QueryRetrieve.Accession && $scope.DataObject.QueryRetrieve.Accession != ''))) {
                toaster.warning({ body: "Please enter atleast one detail to filter" });
                return;
            }
            $scope.DataObject.QueryRetrieve.IsSearchingData = true;
            $scope.DataObject.isLoadingQueryRetrieve = true;
            DCMQRDoFind().then(function (result) {
                if (result && result.patients) {
                    $scope.DataObject.isLoadingQueryRetrieve = false;
                    $scope.DataObject.QueryRetrieve.IsSearchingData = false;
                    if (queryGridOptions && queryGridOptions.api) {
                        queryGridOptions.api.setRowData(result.patients);
                    }
                }
            });
        }
        function DCMQRDoFind() {
            var d = $q.defer();
            var obj = {
                "PatientFirstName": $scope.DataObject.QueryRetrieve.FirstName,
                "PatientLastName": $scope.DataObject.QueryRetrieve.LastName,
                "PatientId": $scope.DataObject.QueryRetrieve.PatientMRN,
                "DOSStartDate": $scope.DataObject.QueryRetrieve.OrderDate ? $scope.DataObject.QueryRetrieve.OrderDate.startDate.format('YYYYMMDD') : "20001001",
                "DOSEndtDate": $scope.DataObject.QueryRetrieve.OrderDate ? $scope.DataObject.QueryRetrieve.OrderDate.endDate.format('YYYYMMDD') : "20241001",
                "Accession": $scope.DataObject.QueryRetrieve.Accession,
                "CalledAE": $scope.DataObject.QueryRetrieve.CalledAE,
                "CallingAE": $scope.DataObject.QueryRetrieve.CallingAE,
                "DestinationAE": $scope.DataObject.QueryRetrieve.DestinationAE,
            };
            WorklistService.DCMQRDoFind(obj).then(function (result) {
                result = result.QRPatientList;
                if (result && result.patients) {
                    _.each(result.patients, function (patient) {
                        var SeriesCount = null, InstanceCount = null;
                        patient.StudyCount = patient.studies.length;
                        _.each(patient.studies, function (study) {
                            if (SeriesCount == null) {
                                SeriesCount = study.series.length;
                            }
                            else {
                                SeriesCount += study.series.length;
                            }
                            study.checkboxDisabled = false;
                            study.SeriesCount = study.series.length;
                            _.each(study.series, function (instance) {
                                if (InstanceCount == null) {
                                    InstanceCount = _.toInteger(instance.Instances);
                                }
                                else {
                                    InstanceCount += _.toInteger(instance.Instances);
                                }
                            });
                        });
                        if (SeriesCount != null) {
                            patient.SeriesCount = SeriesCount;
                        }
                        if (InstanceCount != null) {
                            patient.InstanceCount = InstanceCount;
                        }
                    });
                    $scope.DataObject.QueryRetriveObj = result;
                    d.resolve(result);
                }
            }).catch(function (ExceptionData) {
                var error = ExceptionData.data;
                if ($scope.DataObject.isLoadingQueryRetrieve) {
                    $scope.DataObject.isLoadingQueryRetrieve = false;
                    $scope.DataObject.QueryRetrieve.IsSearchingData = false;
                }
                if (error.Message && error.Message != "") {
                    toaster.error({ body: error.Message });
                }
                else {
                    toaster.error({ body: "Something went wrong" });
                }
                d.reject();
            });
            return d.promise;
        }
        var queryGridOptions = {
            columnDefs: [
                {
                    field: 'PatientID', headerName: 'MRN', cellRenderer: 'agGroupCellRenderer', headerClass: 'px-5',
                },
                { field: 'FamilyName', headerName: 'Last Name' },
                { field: 'GivenName', headerName: 'First Name' },
                { field: 'MiddleName' },
                {
                    field: 'DOB', headerName: 'Date of Birth', cellRenderer: function (params) {
                        if (params.data.DOB) {
                            return moment(params.data.DOB).format('MM-DD-YYYY');
                        }
                    }
                },
                {
                    field: 'Gender', cellRenderer: function (params) {
                        return { 'M': 'Male', 'F': 'Female', 'O': 'Other' }[params.data.Gender] || params.data.Gender;
                    }
                },
                { field: 'StudyCount', headerName: 'Study Count' },
                { field: 'SeriesCount', headerName: 'Series Count' },
                { field: 'InstanceCount', headerName: 'Instance Count' },
            ],
            defaultColDef: {
                flex: 1,
            },
            groupDefaultExpanded: 0,
            masterDetail: true,
            detailRowAutoHeight: true,
            detailCellRendererParams: {
                detailGridOptions: {
                    columnDefs: [
                        { field: '', minWidth: 40, maxWidth: 40, checkboxSelection: true, },
                        { field: 'AccessionNumber', headerName: 'Accession', cellRenderer: 'agGroupCellRenderer', headerClass: 'queryAccessionHeaderTxt', },
                        { field: 'StudyDateTime', headerName: 'Date of Service', cellRenderer: function (params) { return $filter('localDate')(params.data.StudyDateTime, false, new Date()) }, },
                        { field: 'ModalitiesInStudy' },
                        { field: 'StudyDescription' },
                        { field: 'SeriesCount', headerName: 'Series Count' },
                    ],
                    defaultColDef: {
                        flex: 1,
                    },
                    rowClass: 'agrow-bg',
                    rowSelection: 'multiple',
                    onRowSelected: onRowSelected,
                    groupDefaultExpanded: 0,
                    masterDetail: true,
                    //detailRowHeight: 240,
                    detailRowAutoHeight: true,
                    detailCellRendererParams: {
                        detailGridOptions: {
                            columnDefs: [
                                { field: 'SeriesDescription', cellRenderer: 'agGroupCellRenderer', headerClass: 'querySeriesHeaderTxt' },
                                { field: 'SeriesNumber' },
                                { field: 'Modality' },
                                { field: 'Instances' },
                            ],
                            defaultColDef: {
                                flex: 1,
                            },
                            detailRowAutoHeight: true,
                        },
                        getDetailRowData: function (params) {
                            params.successCallback(params.data.series);
                        },
                    },
                    getRowId: function (params) {
                        return params.data.StudyInstanceUid;
                    },
                    getRowStyle: function (params) {
                        return params.node.data.checkboxDisabled ? { 'pointer-events': 'none !important', 'opacity': '0.5 !important' } : null;
                    }
                },
                getDetailRowData: function (params) {
                    params.successCallback(params.data.studies);
                },

            },
            getRowId: function (params) {
                return params.data.PatientID;
            },
        };

        $scope.MoveInstance = function (AutomaticQueryRetrieve) {
            var MoveStudies = [];
            if ($scope.DataObject.QueryRetrieve.SelectedStudies && $scope.DataObject.QueryRetrieve.SelectedStudies.length > 0) {
                _.each($scope.DataObject.QueryRetrieve.SelectedStudies, function (study) {
                    var obj = {
                        "StudyInstanceUid": study.StudyInstanceUid,
                        "CalledAE": $scope.DataObject.QueryRetrieve.CalledAE,
                        "CallingAE": $scope.DataObject.QueryRetrieve.CallingAE,
                        "DestinationAE": $scope.DataObject.QueryRetrieve.DestinationAE,
                    }
                    MoveStudies.push(obj);
                    if (queryGridOptions && queryGridOptions.api && !AutomaticQueryRetrieve) {
                        queryGridOptions.api.forEachNode(function (node) {
                            $timeout(function () {
                                node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                                if (node.detailGridOptions) {
                                    node.detailGridOptions.api.forEachNode(function (childNode) {
                                        if (childNode.data.StudyInstanceUid == study.StudyInstanceUid) {
                                            childNode.setSelected(false);
                                            childNode.data.checkboxDisabled = true;
                                        }
                                    });
                                    node.detailGridOptions.api.redrawRows();
                                }
                            }, 100);
                        });
                    }
                });
                if (!AutomaticQueryRetrieve) {
                    $scope.DataObject.HideOption.Key = _.find($scope.DataObject.HiddenTypeList, { Value: "4" }).Key;
                    $scope.DataObject.HideOption.Comments = "Prior retrieval is in process";
                    HideUnhideOrder(4, true);
                }
                WorklistService.DCMQRDoMove(MoveStudies).then(function (result) {

                });
                toaster.success({ body: "Prior retrieval is in process." });
            }
        }

        function onRowSelected(event) {
            $scope.DataObject.QueryRetrieve.IsRetrieveBtnDisabled = true;
            var selectedRows = [];
            queryGridOptions.api.forEachNode(function (node) {
                if (node.master) {
                    node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                    if (node.detailGridOptions) {
                        var getSelectedRows = node.detailGridOptions.api.getSelectedRows();
                        _.each(getSelectedRows, function (row) {
                            var index = _.findIndex(selectedRows, { 'Accession': row.Accession });
                            if (index == -1) {
                                selectedRows.push(row);
                            }
                        });
                    }
                    if (selectedRows && selectedRows.length > 0) {
                        $scope.DataObject.QueryRetrieve.SelectedStudies = selectedRows;
                        $scope.DataObject.QueryRetrieve.IsRetrieveBtnDisabled = false;
                    }
                }
            });
        }

        $scope.ClearQueryRetrieve = function () {
            $scope.DataObject.QueryRetrieve.Accession = '';
            $scope.DataObject.QueryRetrieve.PatientMRN = '';
            $scope.DataObject.QueryRetrieve.FirstName = '';
            $scope.DataObject.QueryRetrieve.LastName = '';
            $scope.DataObject.QueryRetrieve.OrderDateType = 'Last 3 Years';
            $scope.DataObject.QueryRetrieve.OrderDate = {
                startDate: moment().subtract(3, 'year'),
                endDate: moment()
            };
            if (queryGridOptions && queryGridOptions.api) {
                queryGridOptions.api.setRowData([]);
            }
            $scope.DataObject.QueryRetrieve.IsExpanded = false;
            $scope.DataObject.QueryRetrieve.IsAllStudySelected = false;
        }
        $scope.resetDateRange = function () {
            $scope.DataObject.QueryRetrieve.opts.ranges = {
                'Last 6 Months': [moment().subtract(6, 'month'), moment()],
                'Last 1 Year': [moment().subtract(1, 'year'), moment()],
                'Last 3 Years': [moment().subtract(3, 'year'), moment()],
                'Last 5 Years': [moment().subtract(5, 'year'), moment()],
                'Last 10 Years': [moment().subtract(10, 'year'), moment()],
            };
            angular.element(document).ready(function () {
                angular.element('.drp-buttons .cancelBtn').click(function () {
                    angular.element('#daterange3').val('');
                    $scope.DataObject.QueryRetrieve.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                });
            });
            angular.element(document).ready(function () {
                $scope.DataObject.QueryRetrieve.OrderDateType = ($scope.DataObject.QueryRetrieve && $scope.DataObject.QueryRetrieve.OrderDate && $scope.DataObject.QueryRetrieve.OrderDate.label) ? $scope.DataObject.QueryRetrieve.OrderDate.label : $scope.DataObject.QueryRetrieve.OrderDateType;
                if ($scope.DataObject.QueryRetrieve.OrderDate.startDate && $scope.DataObject.QueryRetrieve.OrderDate.endDate) {
                    if ($scope.DataObject.QueryRetrieve.OrderDateType != null && $scope.DataObject.QueryRetrieve.OrderDateType.match('Custom'))
                        $scope.DataObject.QueryRetrieve.OrderDateType = ($scope.DataObject.QueryRetrieve.OrderDateType != null && $scope.DataObject.QueryRetrieve.OrderDateType.match('Custom')) ? ($scope.DataObject.QueryRetrieve.OrderDateType + '#' + moment(new Date($scope.DataObject.QueryRetrieve.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
                            moment(new Date($scope.DataObject.QueryRetrieve.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.DataObject.QueryRetrieve.OrderDateType;

                }
                else {
                    $scope.DataObject.QueryRetrieve.OrderDateType = 'Clear';
                }
                setOrderDate($scope.DataObject.QueryRetrieve.OrderDateType, $scope.DataObject.QueryRetrieve);
            });
        }

        function setOrderDate(val, data) {
            var type = null, startDate = null, endDate = null;
            if (val && val.match('Custom')) {
                type = 'Custom';
                startDate = val.split('#')[1];
                endDate = val.split('#')[2];
            }
            else {
                type = val;
            }
            data.OrderDateType = type;
            switch (type) {
                case 'Last 6 Months':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(6, 'month').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 1 Year':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(1, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 3 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(3, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 5 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(5, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Last 10 Years':
                    data.OrderDate = {
                        startDate: moment(moment().subtract(10, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    break;
                case 'Custom':
                    //data.OrderDate = {
                    //    startDate: moment(startDate),
                    //    endDate: moment(endDate)
                    //};
                    data.OrderDate = {
                        startDate: moment(moment(startDate).format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment(endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    data.OrderDateType = 'Custom range';
                    break;
                case 'Clear':
                    data.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                    break;
                default:
                    data.OrderDate = {
                        startDate: moment(moment().subtract(3, 'year').format("YYYY-MM-DD") + ' ' + "00:00"),
                        endDate: moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")
                    };
                    data.OrderDateType = 'Last 3 Days';
                    break;
            }

            var timeout = $timeout(function () {
                data.toolTipOrderDate = data.OrderDate.startDate && data.OrderDate.endDate ? 'DOS: ' + data.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + data.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                $timeout.cancel(timeout);
                timeout = null;
            }, 0);
        }

        $scope.ExpandCollapseData = function (expand, allStudies) {
            onRowSelected();
            if (queryGridOptions && queryGridOptions.api) {
                queryGridOptions.api.forEachNode(function (node) {
                    if (node.master && expand) {
                        node.setExpanded(expand);
                        $timeout(function () {
                            node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                            if (node.detailGridOptions) {
                                if (!allStudies) {
                                    node.detailGridOptions.api.forEachNode(function (childNode) {
                                        childNode.setExpanded(expand);
                                    });
                                }
                                else {
                                    node.detailGridOptions.api.selectAll();
                                }
                            }
                        }, 100);
                    }
                    else {
                        if (node.id) {
                            node.detailGridOptions = queryGridOptions.api.getDetailGridInfo("detail_" + node.id);
                            if (node.detailGridOptions) {
                                node.detailGridOptions.api.forEachNode(function (childNode) {
                                    if (childNode.expanded) {
                                        childNode.setExpanded(expand);
                                    }
                                    if (node.expanded) {
                                        node.setExpanded(expand);
                                    }
                                });
                            }
                        }
                    }
                });
            }
            /*if (!$scope.DataObject.QueryRetrieve.IsExpanded && $scope.DataObject.QueryRetrieve.IsAllStudySelected && allStudies) {
                $scope.DataObject.QueryRetrieve.IsAllStudySelected = false;
            }
            if (!$scope.DataObject.QueryRetrieve.IsAllStudySelected && $scope.DataObject.QueryRetrieve.IsExpanded && !allStudies) {
                $scope.DataObject.QueryRetrieve.IsExpanded = false;
            }*/
        }
        //#endregion Query Retrieve
        function CustomDateRangePickerComponent(params) {

        }

        function getNumberFilterString(type, filter, filterTo) {
            var FilterString = { StartValue: null, EndValue: null };
            switch (type) {
                case 'equals':
                    FilterString.StartValue = filter;
                    FilterString.EndValue = filter;
                    break;
                case 'inRange':
                    FilterString.StartValue = filter;
                    FilterString.EndValue = filterTo;
                    break;
                case 'lessThanOrEqual':
                    FilterString.StartValue = 0;
                    FilterString.EndValue = filter;
                    break;
            }
            return FilterString;
        }

        function ChangeInRangeFilterPlaceHolder(colId) {
            var filterElements = document.querySelectorAll('.ag-filter-body input');
            var AnyHiddenElement = $('.ag-filter-body .ag-filter-filter.ag-hidden');

            switch (colId) {
                case 'WorkRVU':
                    if (AnyHiddenElement.length == 0 && filterElements.length > 1) {
                        filterElements[0].placeholder = 'Filter By Min wRVU';
                        filterElements[1].placeholder = 'Filter By Max wRVU';
                    }
                    break;
                case 'ImageInstance':
                    if (AnyHiddenElement.length == 0 && filterElements.length > 1) {
                        filterElements[0].placeholder = 'Filter By Min Image Count';
                        filterElements[1].placeholder = 'Filter By Max Image Count';
                    }
                    break;
                case 'SLA':
                    if (AnyHiddenElement.length == 0 && filterElements.length > 1) {
                        filterElements[0].placeholder = 'Filter By Min SLA (in minutes)';
                        filterElements[1].placeholder = 'Filter By Max SLA (in minutes)';
                    }
                    break;
            }
        }
        function ExportWorklistData(hideRederingPhy) {
            setFilter();
            OrderListFilter.TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            toaster.info("Your export is in progress. You will be notified once it is complete.");
            var exportWorklistFilter = _.cloneDeep(OrderListFilter);
            exportWorklistFilter.HideRenderingPhysician = (hideRederingPhy) ? true : false;
            WorklistService.GetOrdersListExport(exportWorklistFilter).then(function (fileStorage) {
                var byteCharacters = atob(fileStorage.FileContent);
                var byteNumbers = new Uint8Array(byteCharacters.length);

                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var blob = new Blob([byteNumbers], { type: fileStorage.ContentType });
                var url = URL.createObjectURL(blob);

                var a = document.createElement('a');
                a.href = url;

                a.download = fileStorage.FileName;
                document.body.appendChild(a);
                a.click();
                toaster.success("Your export is complete and has been downloaded.")
            });
        }
        function getColumnFilterData() {
            var d = $q.defer();
            if (gridOptions && gridOptions.api) {
                var filteredColumn = gridOptions.api.getFilterModel();
                var keys = Object.keys(filteredColumn);
                if (keys.includes("Location") || keys.includes("SignByName") || keys.includes("Modality")) {
                    d.resolve(columnFilterData);
                }
                else {
                    setFilter();
                    WorklistService.GetColumnFilterData(OrderListFilter).then(function (result) {
                        if (result && !(_.isEqual(result, columnFilterData))) {
                            columnFilterData = result;
                        }
                        d.resolve(columnFilterData)
                    }).catch(function (err) {
                        toaster.error("Error fetching data for the " + vm.worklist.WorkListName + " Worklist!");
                        d.reject(err);
                    });
                }
            } else {
                d.reject();
            }
            return d.promise;
        }

        $scope.updateSelectedLocationContact = function () {

        }

        function onFlashTwoRows() {
            var RowsToFlash = [];
            if (gridOptions && gridOptions.api) {
                gridOptions.api.forEachNode(function (rowNode, index) {
                    if (rowNode.data && rowNode.data.Status == 'RP' && rowNode.data.Priority.trim().toUpperCase() == 'STAT (HIGH)' && rowNode.data.IsHighPriority) {
                        RowsToFlash.push(rowNode);
                    }
                });
                gridOptions.api.flashCells({ rowNodes: RowsToFlash });
            }
        }

        RowsToFlashInterval = $interval(function (time) {
            if ($sessionStorage.FlashSTATHighPriorityStudyInterval == 0) {
                $interval.cancel(RowsToFlashInterval);
                RowsToFlashInterval = null;
            } else {
                if (!vm.viewMode) {
                    onFlashTwoRows();
                }
            }
        }, $sessionStorage.FlashSTATHighPriorityStudyInterval);


        $scope.ButtonClicked = function (SelectedOrder) {
            switch (SelectedOrder.ButtonClicked) {
                case 'showContact':
                    $scope.showContact($scope.SelectedOrder.OrderingPhysician, $scope.SelectedOrder.LocationID, $scope.SelectedOrder.Location);
                    break;
                case 'ViewContact':
                    $scope.showLocationContact(SelectedOrder.LocationID, SelectedOrder.Location);
                    break;
                case 'GetTypeContactMessage':
                    GetTypeContactMessage(SelectedOrder).then(function (typeContactMessage) {
                        SelectedOrder.TypeContactMessage = typeContactMessage;
                    });
                    break;
            }
        }

        function GetTypeContactMessage(SelectedOrder) {
            var d = $q.defer();
            if (SelectedOrder.TypeContactMessage == null) {
                var department = '';
                switch (_.toUpper(SelectedOrder.PatientClass)) {
                    case 'I':
                        department = 'Inpatient Department';
                        break;
                    case 'E':
                        department = 'Emergency Department';
                        break;
                    case 'U':
                        department = 'Unknown Department';
                        break;
                }
                if (!_.isEmpty(department)) {
                    $scope.getTypeContact(SelectedOrder.LocationID).then(function (result) {
                        var typeContacts = _.filter(result, { Department: department });
                        var typeContactMessage = '';
                        _.each(typeContacts, function (item) {
                            if (typeContactMessage.length > 0) {
                                typeContactMessage += '<br>' + item.LastName + ', ' + item.FirstName;
                            } else {
                                typeContactMessage = item.LastName + ', ' + item.FirstName;
                            }
                            if (item.OfficePhone) {
                                typeContactMessage += '<br>' + 'Office: ' + '<span class="txt-clr-15"> ' + item.OfficePhone + '</span> ';
                            }
                            if (item.MobilePhone) {
                                typeContactMessage += '<br>' + 'Mobile: ' + '<span class="txt-clr-15"> ' + item.MobilePhone + '</span> ';
                            }
                        });
                        d.resolve(typeContactMessage);
                    });
                }
            }
            return d.promise;
        }


        function AssignValuesReportToSelectedOrder() {
            $scope.ReportSelectedOrder.SignByName = $scope.report.RED_LastName;
            $scope.ReportSelectedOrder.OrderDate = $scope.report.DOS;
            $scope.ReportSelectedOrder.ReportSignDate = $scope.report.SingDate;
            $scope.ReportSelectedOrder.ReportStatus = $scope.report.Status;
            $scope.ReportSelectedOrder.PatientDOB = $scope.report.Patient_DOB;
            if ($scope.ReportSelectedOrder && $scope.ReportSelectedOrder.Status) {
                $scope.ReportSelectedOrder.OrderStatus = _.find($scope.DataObject.masterData.OrderStatus, { 'key': $scope.ReportSelectedOrder.Status }).value;
            }
            $scope.ReportSelectedOrder.ExamTagKey = $scope.ReportSelectedOrder.ExamTag && $scope.ReportSelectedOrder.ExamTag != "0" ? _.find($scope.DataObject.masterData.ExamTags, { 'Value': $scope.ReportSelectedOrder.ExamTag }).Key : $scope.ReportSelectedOrder.ExamTagKey;
            if ($scope.ReportSelectedOrder.RadExamTag && $scope.ReportSelectedOrder.RadExamTag != "0") {
                $scope.ReportSelectedOrder.RadExamTagKeys = [];
                var SplitExamTags = ($scope.ReportSelectedOrder.RadExamTag && $scope.ReportSelectedOrder.RadExamTag.includes(',') ? $scope.ReportSelectedOrder.RadExamTag.split(',') : $scope.ReportSelectedOrder.RadExamTag);
                _.each(SplitExamTags, function (ExamTag) {
                    var obj = _.find($scope.DataObject.masterData.RadExamTag, { Value: ExamTag });

                    if (obj) {
                        $scope.ReportSelectedOrder.RadExamTagKeys.push(obj.Key);
                    }
                });
            }
            else {
                $scope.ReportSelectedOrder.RadExamTagKeys = $scope.ReportSelectedOrder.RadExamTagKeys;
            }
            $scope.ReportSelectedOrder.RenderingPhysicianEmail = $scope.report.RenderingPhysicianEmail;
            $scope.ReportSelectedOrder.RenderingPhysicianPhone = $scope.report.RenderingPhysicianPhone;
        }

        $scope.ActionItemClicked = function (ActionMenu, Order) {
            switch (ActionMenu.ActionTaken) {
                case 'Unhide Study':
                case 'Hide Study (F12)':
                    //HideOrder();
                    HideOrder();
                    CloseAllWindow(true);
                    break;
                case 'Open Discussion (F11)':
                    HelpOrder();
                    break;
                case 'Share Exam':
                    openShareExamWindow(Order);
                    break;
                case 'Consult with Physician':
                    $scope.CallInConsult(Order);
                    break;
                case 'Query Retrieve':
                    $scope.QueryRetrieve(Order, true);
                    break;
                case 'Exam is Mislabeled':
                case 'Missing Contrast Type/Dosage':
                case 'Missing Order/Cancelled Order':
                case 'Missing Paperwork':
                case 'Need Additional Images':
                case 'Need Comparison':
                case 'Not to be Read':
                    $scope.DataObject.HideOption.Key = ActionMenu.ActionTaken;
                    $scope.HideStudy("");
                    CloseAllWindow(true);
                    break;
            }

            var Timeout = $timeout(function () {
                _.each(openWindows.slice(1, -1), function (w) {
                    CloseAllWindow(false, w);
                });
                $timeout.cancel(Timeout);
                Timeout = null;
            }, 1000);
        }

        function CloseAllWindow(AllWindow, Window) {
            if ($scope.isDiscussionVisible && (AllWindow ? AllWindow : Window == 'Discussion')) {
                $scope.win_Discussion.close();
            }
            if ($scope.isComparisonOrderReportsVisible && (AllWindow ? AllWindow : Window == 'Report')) {
                $scope.win_ComparisonOrderReports.close();
            }
            if ($scope.isShareExamWindowVisible && (AllWindow ? AllWindow : Window == 'Share Exams')) {
                $scope.win_shareExamsWindow.close();
            }
            if ($scope.isConsultExamsWindow && (AllWindow ? AllWindow : Window == 'Consult Exams')) {
                $scope.win_consultExamsWindow.close();
            }
            if ($scope.isOrderEventLogVisible && (AllWindow ? AllWindow : Window == 'Order Event Logs')) {
                $scope.win_OrderEventLog.close();
            }
            if ($scope.DataObject.AddendumRequest.showAddendumReq && (AllWindow ? AllWindow : Window == 'Addendum Request')) {
                $scope.win_addendum_request.close();
            }
            if ($scope.DataObject.PeerReview.showPeerReview && (AllWindow ? AllWindow : Window == 'Peer Review')) {
                $scope.win_peer_review.close();
            }
            if ($scope.isModalReportNDiscussVisible && (AllWindow ? AllWindow : Window == 'Report - Discussion')) {
                $scope.win_ModalReportNDiscuss.close();
            }
            if ($scope.DataObject.onQueryRetrive && (AllWindow ? AllWindow : Window == 'Query Retrieve')) {
                $scope.win_query_retrive.close();
            }
        }

        $scope.windowOpened = function (windowInstance) {
            var WindowTitle = windowInstance && windowInstance.options ? windowInstance.options.title : '';
            if (WindowTitle != '' && openWindows.indexOf(WindowTitle) === -1) {
                openWindows.push(WindowTitle);
            }
        };

        $scope.windowClosed = function (windowInstance) {
            if (windowInstance) {
                var WindowTitle = windowInstance && windowInstance.options ? windowInstance.options.title : '';
                var index = openWindows.indexOf(WindowTitle);
                if (index > -1) {
                    openWindows.splice(index, 1);
                }

                if (WindowTitle == 'Discussion' && $scope.DataObject.ModalReportNDiscussActiveIndex == 2) {
                    $scope.DataObject.Reference.ID = null;
                    var timeout = $timeout(function () {
                        $scope.showFileList();
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 50);
                }
            }
        };

        //#region View Attachment
        $scope.onDiscussionWindowTabChange = function (TabName) {
            $scope.DataObject.DiscussionWindowActiveTab = TabName;
            switch (TabName) {
                case 'Attachment':
                    $scope.DataObject.Reference.ID = null;
                    var timeout = $timeout(function () {
                        $scope.showFileList();
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 50);
                    break;
                case 'Discussion':
                    setOrderDiscussionUserGroup().then(function (data) {
                        setOrderDiscussionTooltip();
                        setSelectedUserAssignment(data);
                    });
                    break;
            }
        }
        //#endregion

        $scope.CloseDiscussionWindow = function () {
            $scope.isDiscussionVisible = false;
            $scope.ODType = 'Discussion';
            $scope.windowClosed($scope.win_Discussion);
            $scope.DataObject.DiscussionWindowActiveTab = 'Discussion'
        }

        $scope.CloseReportNDiscussionWindow = function () {
            $scope.isModalReportNDiscussVisible = false;
            $scope.onClearFilterReportList(true);
            $scope.windowClosed($scope.win_ModalReportNDiscuss);
            $scope.DataObject.ShowPrevNextBtn = false;
        }
        $scope.OnUpdateAllowRoutineStudies = function () {
            if ($scope.DataObject.SingReport.STATStudies == 'NO') {

                $sessionStorage.currentUserData.AllowEnableRowsForSelectedTenants = true;
                var comments = { Message: $scope.DataObject.SingReport.SelectedRoutineStudyReason, Accession: $scope.DataObject.SingReport.Order.Accession, Priority: $scope.DataObject.SingReport.Order.Priority };
                WorklistService.InsertUserComments({ UserID: $sessionStorage.currentUserData.userId, Comments: JSON.stringify(comments) });

                Call_SetSignREportModal();

            }

            $scope.DataObject.SingReport.STATStudies = '';
            $scope.DataObject.SingReport.SelectedRoutineStudyReason = '';
            $scope.win_STATStudiesFirst.close();
        }
        $scope.closeSTATStudiesFirstWin = function () {
            $scope.DataObject.SingReport.STATStudies = '';
            $scope.DataObject.SingReport.SelectedRoutineStudyReason = '';
            $scope.win_STATStudiesFirst.close();
        }

        function UpdateOrderReportStatus(order, newStatus) {
            var d = $q.defer();
            var params = {
                OrderID: order.OrderID,
                ReportStatus: newStatus,
                OldReportStatus: order.ReportStatus,
                UserID: $sessionStorage.currentUserData.userId
            };
            WorklistService.UpdateOrderReportStatus(params).then(function () {
                d.resolve();
            }).catch(function (err) {
                d.reject(err);
            });
            return d.promise;
        }
        function RemoveMultipleFromClipboard(SelectedRowsForClipboard) {
            // Filter out orders with IsInClipboard == 0
            var ordersToBeRemoved = _.filter(SelectedRowsForClipboard, function (order) {
                return order.IsInClipboard != 0;
            });
            var params = {
                OrderIDs: _.join(_.map(ordersToBeRemoved, function (order) { return order.OrderID; }), ','),
                UserID: $sessionStorage.currentUserData.userId
            }
            RuleService.RemoveFromClipboard(params).then(function () {
                toaster.success("Order removed from clipboard");
            }, function () {
                toaster.error("Failed to remove order from clipboard");
            });
        }
        $scope.SendFax = function () {
            if ($scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list.length > 0 ||
                $scope.DataObject.FaxDetails.FaxNumber) {
                var textFaxNumber = $scope.DataObject.FaxDetails.FaxNumber;
                var dropdownFaxNum = _.join(_.map($scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list, function (obj) { return obj.FaxNumber; }), ',');

                var FaxNumber = textFaxNumber && dropdownFaxNum ? textFaxNumber + "," + dropdownFaxNum : textFaxNumber || dropdownFaxNum || null;
                var params = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    UserID: $sessionStorage.currentUserData.userId,
                    LocationID: $scope.SelectedOrder.LocationID,
                    FaxNumber: FaxNumber,
                    FaxContent: $scope.DataObject.FaxFile.FileContent,
                    FileName: $scope.DataObject.FaxFile.FileName,
                    ReportID: $scope.SelectedOrder.ReportID
                }
                $scope.DataObject.FaxDetails.disableSendFaxBtn = true;
                WorklistService.SendFax(params).then(function (res) {
                    $scope.DataObject.FaxDetails.disableSendFaxBtn = false;
                    toaster.success("Fax sent successfully");
                    $("#SendFaxModal").modal("hide");
                }, function (err) {
                    $scope.DataObject.FaxDetails.disableSendFaxBtn = false;
                    toaster.error("Some error occurred while sending Fax!");
                    $("#SendFaxModal").modal("hide");
                });

            }
        }
        $scope.openFaxModal = function (faxFile) {
            $scope.DataObject.FaxFile = faxFile;
            $scope.DataObject.FaxDetails.FaxNumber = null;
            $scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue = { list: [] }
            $scope.DataObject.FaxDetails.disableSendFaxBtn = false;
            ManageLocationService.GetLocationFaxMapping({ LocationID: $scope.SelectedOrder.LocationID }).then(function (res) {
                _.each(res, function (item, index) {
                    item.uniqID = index;
                    item.DisplayFaxNumber = (!item.PatientClass) ? item.FaxNumber : item.FaxNumber + " (" + item.PatientClass + ")";
                });
                $scope.DataObject.FaxDetails.FaxNumberList = res;
                $("#SendFaxModal").modal("show");
            }, function (err) {
                console.error("err", err);
            });
        }
        $scope.validateFaxNumText = function () {
            var disableBtn = false;
            if (!$scope.DataObject.FaxDetails.disableSendFaxBtn) {

                var faxNumTextInput = document.getElementById("FaxNumText");
                if (faxNumTextInput) {
                    var faxNumVal = _.cloneDeep(faxNumTextInput.value);
                    faxNumVal = faxNumVal.replaceAll('_', '').replaceAll('-', '').replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '');
                }

                if ($scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list.length > 0) {
                    if (faxNumVal.length > 0 && faxNumVal.length < 10) {
                        disableBtn = true;
                    }
                }
                else if (faxNumVal.length >= 0 && faxNumVal.length < 10) {
                    disableBtn = true;
                }
            }
            else {
                disableBtn = true;
            }
            return disableBtn;

        }

        function isshowOnlyFiveStudiesEnabled() {
            //console.log("isshowOnlyFiveStudiesEnabled");
            var d = $q.defer();
            showOnlyFiveStudies = false;
            showOnlyFiveStudiesForTenant = "";
            if (!vm.viewMode) {
                var restrictedTenants = ($sessionStorage.ShowOnlyFiveStudyForSelectedTenants) ? ($sessionStorage.ShowOnlyFiveStudyForSelectedTenants).split(",") : [];
                _.each($scope.DataObject.worklist.Groups, function (grp) {
                    if (!grp.deleted) {
                        _.each(grp.RulesConditions, function (cond) {
                            if (cond.RuleTable && cond.RuleTable.Key == "Tenants" && cond.RuleOperator &&
                                ((cond.RuleOperator.Value).toLowerCase() == "=" || (cond.RuleOperator.Value).toLowerCase() == "in")) {
                                if (cond.RuleTableValue) {
                                    _.each(restrictedTenants, function (tenant) {
                                        if (tenant == cond.RuleTableValue.Value) {
                                            showOnlyFiveStudies = true;
                                            showOnlyFiveStudiesForTenant = (showOnlyFiveStudiesForTenant == "") ? tenant : showOnlyFiveStudiesForTenant + ", " + tenant;
                                        }
                                    });
                                }
                                else if (cond.RuleTableValues) {
                                    _.each(restrictedTenants, function (tenant) {
                                        _.each(cond.RuleTableValues, function (obj) {
                                            if (tenant == obj.Value) {
                                                showOnlyFiveStudies = true;
                                                showOnlyFiveStudiesForTenant = (showOnlyFiveStudiesForTenant == "") ? tenant : showOnlyFiveStudiesForTenant + ", " + tenant;
                                            }
                                        });
                                    });
                                }
                                else {
                                    var userAccessibleTenant = _.uniqBy(vm.masterData.Locations, 'TenantID');
                                    var values = (cond.Value).replaceAll("'", "");
                                    var ValueArray = (values) ? (values.split(",")) : [];
                                    _.each(ValueArray, function (id) {
                                        var tenant = _.find(userAccessibleTenant, { "TenantID": id });
                                        //console.log("isshowOnlyFiveStudiesEnabled > tenant: ", tenant);
                                        if (tenant) {
                                            if (restrictedTenants.includes(tenant.TenantName)) {
                                                showOnlyFiveStudies = true;
                                                showOnlyFiveStudiesForTenant = (showOnlyFiveStudiesForTenant == "") ? tenant : showOnlyFiveStudiesForTenant + ", " + tenant;
                                            }
                                        }
                                    })
                                }
                            }
                        });
                    }
                });
            }
            d.resolve();
            return d.promise;
        }

        $scope.HideShowReviewReportAction = function () {
            $scope.DataObject.IsStudyReviewSectionVisible = !$scope.DataObject.IsStudyReviewSectionVisible;
        }
        $scope.isReviewReportVisible = function () {
            $scope.ReviewOrder.Reviewable = false;
            if ($scope.ReviewOrder.IsPeerReviewEnable
                && $scope.DataObject.LoggedInUserDetails.IsReviewer) {
                if ($scope.ReviewOrder.ReviewStatus
                    && $scope.ReviewOrder.ReviewStatus.toString().toLowerCase() == 'complete') {
                    $scope.ReviewOrder.IsReportReviewEditable = false;
                    $scope.ReviewOrder.Reviewable = true;
                } else if ($scope.OrderReport
                    && ($scope.OrderReport.ReportStatus.toString() == "1"
                        || $scope.OrderReport.ReportStatus.toString() == "5")
                    && $scope.OrderReport.SignBy != vm.selectedData.LoggedInUserID) {
                    $scope.ReviewOrder.IsReportReviewEditable = true;
                    $scope.ReviewOrder.Reviewable = true;
                } else if ($scope.SelectedOrder.Accession == $scope.OrderReport.Accession) {
                    $scope.ReviewOrder.IsReportReviewEditable = ($scope.ReviewOrder.Rating) ? false : true;
                }
                else if ($scope.ReviewOrder.IsReviewable == 1) {
                    $scope.ReviewOrder.IsReportReviewEditable = $scope.ReviewOrder.ReviewStatus
                        && $scope.ReviewOrder.ReviewStatus.toString().toLowerCase() == "pending"
                        ? true
                        : false;
                    //$scope.DataObject.IsStudyReviewSectionVisible = !$scope.ReviewOrder.IsReportReviewEditable;
                    $scope.ReviewOrder.Reviewable = true;
                }
                if ($scope.ReviewOrder.Reviewable) {
                    if ($scope.ReviewOrder.IsReportReviewEditable) {
                        $scope.ReviewOrder.ReviewReportButtonText = "Review Report";
                        $scope.DataObject.IsStudyReviewSectionVisible = false;
                    } else {
                        $scope.ReviewOrder.ReviewReportButtonText = "View Report Review";
                        $scope.DataObject.IsStudyReviewSectionVisible = false;
                    }
                }

            }


        }
        $scope.SetOrderPeerReview = function () {
            $scope.ReviewOrder.PeerReviewUserID = $sessionStorage.currentUserData.userId;
            $scope.ReviewOrder.ReviewBy = $sessionStorage.currentUserData.userId;
            var promise = ($scope.ReviewOrder.OrderReviewID) ? WorklistService.UpdateReviewOrder($scope.ReviewOrder) : WorklistService.SetOrderPeerReview($scope.ReviewOrder);
            promise.then(function (result) {
                var orderReportIndex = _.findIndex($scope.orderReportList, { OrderID: $scope.ReviewOrder.OrderID });
                if (orderReportIndex != -1) {
                    $scope.orderReportList[orderReportIndex] = _.clone($scope.ReviewOrder);
                    $scope.orderReportList[orderReportIndex].ReviewStatus = 'Complete';
                    $scope.orderReportList[orderReportIndex].Reviewby = $sessionStorage.currentUserData.userId;
                    $scope.orderReportList[orderReportIndex].IsReviewable = 1;
                }
                var reportIndex = _.findIndex($scope.reportList, { OrderID: $scope.ReviewOrder.OrderID });
                if (reportIndex != -1) {
                    $scope.reportList[reportIndex].IsReviewable = 1;
                }
                $scope.ReviewOrder.IsReportReviewEditable = false;
                $scope.ReviewOrder.ReviewReportButtonText = "View Report Review";
                $scope.DataObject.IsStudyReviewSectionVisible = false;
                toaster.success('Review Saved Successfully!');
            });
        }
        $scope.disableReportReviewBtn = function () {
            if (!$scope.ReviewOrder.Rating) {
                return true;
            }
            if ($scope.ReviewOrder.IsInterestingCase) {
                return !$scope.ReviewOrder.Keywords || !($scope.ReviewOrder.Comments);
            }
        }
        function getLoggedInUserDetails() {
            ProfileService.getUserSettingData($sessionStorage.currentUserData.userId).then(function (resp) {
                if (resp.data) {
                    $scope.DataObject.LoggedInUserDetails = resp.data;
                }
            });
        }
        function ValidateSpecialTenantUsersSTATStudiesSchedule() {
            var accessAllowed = false;
            if ($sessionStorage.SpecialTenantUsersSTATStudiesSchedule
                && $sessionStorage.SpecialTenantUsersSTATStudiesSchedule.indexOf('to') != -1) {
                var timeRange = $sessionStorage.SpecialTenantUsersSTATStudiesSchedule.split('to');
                var startTime = moment(timeRange[0], 'HH:mm:ss');
                var endTime = moment(timeRange[1], 'HH:mm:ss');
                var currentTime = getLocalTime();
                if (currentTime.isBetween(startTime, endTime)) {
                    accessAllowed = true;
                } else if (currentTime.isAfter(startTime)) {
                    accessAllowed = true;
                } else if (currentTime.isBefore(endTime)) {
                    accessAllowed = true;
                } else {
                    accessAllowed = false;
                }
            } else if ($sessionStorage.SpecialTenantUsersSTATStudiesSchedule
                && $sessionStorage.SpecialTenantUsersSTATStudiesSchedule.indexOf('to') == -1) {
                var startTime = moment($sessionStorage.SpecialTenantUsersSTATStudiesSchedule, 'HH:mm:ss');
                var endTime = moment('23:59:59', 'HH:mm:ss');
                var currentTime = getLocalTime();
                if (currentTime.isBetween(startTime, endTime)) {
                    accessAllowed = true;
                } else {
                    accessAllowed = false;
                }
            } else {
                accessAllowed = false;
            }
            return accessAllowed;
        }
        function getLocalTime() {
            var date = moment.utc().format('YYYY-MM-DD HH:mm:ss');
            var stillUtc = moment.utc(date).toDate();
            return moment(stillUtc).local();
        }
        function GetTenantName() {
            var TenantID = null;
            var RuleConditionTenantName = null;
            _.each($scope.DataObject.worklist.Groups, function (group) {
                RuleConditionTenantName = _.find(group.RulesConditions, { ColumnName: 'Sites.TenantID' });
            });

            if (RuleConditionTenantName
                && RuleConditionTenantName.Value
                && RuleConditionTenantName.Operator
                && (RuleConditionTenantName.Operator == 'IN'
                    || RuleConditionTenantName.Operator == '=')) {
                TenantID = RuleConditionTenantName.Value.split(',');
            }
            WorklistTenantID = TenantID;
        }
        function getSpecialTenantIDs() {
            var SpecialTenants = [];
            _.each($sessionStorage.SpecialTenants, function (tenant) {
                var tenantObj = _.find($scope.DataObject.masterData.UserTenants, { Name: tenant });
                if (tenantObj) {
                    SpecialTenants.push(tenantObj);
                }
            });
            return _.map(SpecialTenants, function (t) { return "'" + t.TenantID + "'"; });
        }
        function validateSpecialTenant() {
            var isSpecialTenant = false;
            var SpecialTenantIDs = getSpecialTenantIDs();
            _.each(SpecialTenantIDs, function (id) {
                var idIndex = _.findIndex(WorklistTenantID, function (worklisttenantid) { return worklisttenantid.toString() == id.toString(); });
                if (idIndex != -1 && !isSpecialTenant) {
                    isSpecialTenant = true;
                }
            });
            return isSpecialTenant;
        }
        function filterBySpecialClass(Orders) {
            //console.log("filterBySpecialClass > Orders: ", Orders);
            var OPOrderList = _.filter(Orders, function (order) {
                return (((order.PatientClass == 'E'
                    || order.PatientClass == 'I')
                    && (order.TenantName
                        && order.TenantName.includes($sessionStorage.SpecialTenants))
                    && order.DelayedSTAT == 2)
                    || !(order.TenantName
                        && order.TenantName.includes($sessionStorage.SpecialTenants)));
            });
            //console.log("filterBySpecialClass > OPOrderList: ", OPOrderList);
            var STATOrderList = _.filter(Orders, function (order) {
                return (((order.TenantName
                    && order.TenantName.includes($sessionStorage.SpecialTenants))
                    && order.DelayedSTAT == 2)
                    || !(order.TenantName
                        && order.TenantName.includes($sessionStorage.SpecialTenants)));
            });
            //console.log("filterBySpecialClass > STATOrderList: ", STATOrderList);
            if (OPOrderList.length > 0) {
                Orders = _.filter(Orders, function (order) {
                    return ((order.PatientClass != 'O'
                        && (order.TenantName
                            && order.TenantName.includes($sessionStorage.SpecialTenants))
                        && order.DelayedSTAT == 2)
                        || !(order.TenantName
                            && order.TenantName.includes($sessionStorage.SpecialTenants)));
                });
                _.each(Orders, function (order) { order.exclude = true; });
            } else if (STATOrderList.length > 0) {
                Orders = _.filter(Orders, function (order) {
                    return (((order.TenantName
                        && order.TenantName.includes($sessionStorage.SpecialTenants))
                        && order.DelayedSTAT == 2)
                        || !(order.TenantName
                            && order.TenantName.includes($sessionStorage.SpecialTenants)));
                });
                _.each(Orders, function (order) { order.exclude = true; });
            }

            //return Orders;
        }

        $scope.isAssignAllowed = function (status) {
            return HideAssignmentForStatus.indexOf(status) === -1;
        };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('assignRadiologistGrid', {
            templateUrl: 'app/theme/components/assign-radiologist-grid/assign-radiologist-grid.html',
            bindings: {
                radiologists: '<',
                selectedValues: '<',
                onSelectRadiologist: '&',
                siteTitle: '<',
                modalTitle: '@',
                btnText: '<',
                onCancel: '&',
                paymentContract: '<',
                paymentSubContract: '<',
                radioLogistCmpTooltipId: '@',
                showAssignRadiologistCmp: '<',
                tenantId: '<',
                viewMode: '<',
                // Optional {TenantID, SiteID}[] the host wants applied when no site is picked in the
                // grid's own site dropdown (e.g. the rule editor's accessible sites). Omit for no default.
                defaultTenantSiteIds: '<'
            },
            controller: assignRadiologistGridCtrl
        });

    /** @ngInject */
    function assignRadiologistGridCtrl($scope, $sessionStorage, $timeout, $filter, RuleService, $q, PaymentContractService, toaster) {

        var vm = this;
        var GridInitTimeout;
        var GridApiInitTimeout;

        //#region Variable declaration
        $scope.radiologistSearchOperatorTooltip = 'Select a Site';
        $scope.MasterData = { Radiologists: null, Sites: null, Locations: null };
        $scope.SelectedData = { Location: null, locationIDs: null, TenantIDs: null, SiteIDs: null, Sites: null };
        $scope.SelectedSiteValues = {
            Ids: '',
            sites: [],
            divId: "AssignRadiologist"
        };


        var AvailableRadiologistsList = [];
        var PaymentContractType = null;
        var PaymentSubContractType = null;

        $scope.ShowAllUserSwitch = { Obj: false };
        function hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function isVisibleRad(r) {
            if (!r) return false;
            if (isSelf(r.Id || r.UserID)) return true;
            return !hasPrelimRad(r.UserRoles || r.Roles);
        }
        function filterVisibleRadiologists(list) {
            if (vm.radioLogistCmpTooltipId !== 'radioLogistGroupChatCmp') return list || [];
            return _.filter(list || [], function (r) { return isVisibleRad(r); });
        }
        function radiologistDisplayName(r) {
            if (!r) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        }

        //#endregion Variable declaration

        vm.$onInit = function () {
            PaymentContractType = vm.paymentContract;
            PaymentSubContractType = vm.paymentSubContract;

            GetSitesAndLocation();

            GridInitTimeout = $timeout(function () {
                var AvailableRadGridDiv = document.querySelector('#AvailableRadGridDiv');
                new agGrid.Grid(AvailableRadGridDiv, AvailableRadGridOptions);

                var SelectedRadGridDiv = document.querySelector('#SelectedRadGridDiv');
                new agGrid.Grid(SelectedRadGridDiv, SelectedRadGridOptions);

            }, 100);
        }
        vm.$onChanges = function (changes) {
            if (changes.radiologists) {
                AvailableRadiologistsList = filterVisibleRadiologists(changes.radiologists.currentValue);
            }
            if (changes.selectedValues) {
                vm.selectedValues = changes.selectedValues.currentValue;
            }
            if (vm.selectedValues) {
                _.each(vm.selectedValues.SelectedRadiologists, function (user) {
                    AvailableRadiologistsList = _.filter(AvailableRadiologistsList, function (data) {
                        return data.Id != user.Id;
                    });
                });
                AvailableRadiologistsList = _.uniqBy(AvailableRadiologistsList, 'Id');
            }
            if (changes.tenantId) {
                vm.tenantId = changes.tenantId.currentValue;
            }

            GridApiInitTimeout = $timeout(function () {
                
            }, 200);

            PaymentContractType = changes.paymentContract ? changes.paymentContract.currentValue : vm.paymentContract;
            PaymentSubContractType = changes.paymentSubContract ? changes.paymentSubContract.currentValue : vm.paymentSubContract;
        }
        vm.$onDestroy = function () {
            AvailableRadGridOptions.api.destroy();
            SelectedRadGridOptions.api.destroy();
            $timeout.cancel(GridInitTimeout);
            $timeout.cancel(GridApiInitTimeout);
        }
        var columnDefs = [
            { field: 'Select', headerName: '', checkboxSelection: true, minWidth: 40, maxWidth: 40, headerCheckboxSelection: true, headerTooltip: 'Select All', menuTabs: [] },
            {
                field: 'LastName', headerName: 'Name', valueFormatter: function (params) {
                    return radiologistDisplayName(params.data);
                }, flex: 1,
            },
            { field: 'Email', flex: 1, },
            { field: 'UserRoles', headerName: 'User Role', initialWidth: 100, },
        ];

        //#region Available Radiologist Grid
        var AvailableRadGridOptions = {
            columnDefs: columnDefs,
            defaultColDef: {
                sortable: true,
                lockVisible: true,
                resizable: true,
            },
            rowSelection: 'multiple',
            enableBrowserTooltips: true,
            suppressRowClickSelection: true,
            sortingOrder: ['desc', 'asc'],
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',

            getRowId: function (params) {
                return params.data.Id;
            },
            onGridReady: function () {
                AvailableRadGridOptions.columnApi.applyColumnState({ state: [{ colId: 'LastName', sort: 'asc' }], });
                AvailableRadiologistsList = _.uniqBy(AvailableRadiologistsList, 'Id');
                AvailableRadGridOptions.api.setRowData(AvailableRadiologistsList);
            },
            onSortChanged: function (params) {
                AvailableRadGridOptions.api.ensureIndexVisible(0);
            },
            onCellClicked: function (params) {
                params.node.setSelected(true);
            },
        }
        //#endregion Available Radiologist Grid

        //#region Selected Radiologist Grid
        var SelectedRadGridOptions = {
            columnDefs: columnDefs,
            defaultColDef: {
                sortable: true,
                lockVisible: true,
                resizable: true,
            },
            rowSelection: 'multiple',
            enableBrowserTooltips: true,
            suppressRowClickSelection: true,
            sortingOrder: ['desc', 'asc'],
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',

            onGridReady: function () {
                SelectedRadGridOptions.columnApi.applyColumnState({ state: [{ colId: 'LastName', sort: 'asc' }], });
                vm.selectedValues.SelectedRadiologists = _.uniqBy(vm.selectedValues.SelectedRadiologists, 'Id');
                SelectedRadGridOptions.api.setRowData(vm.selectedValues.SelectedRadiologists);
            },
            onSortChanged: function (params) {
                SelectedRadGridOptions.api.ensureIndexVisible(0);
            },
            onCellClicked: function (params) {
                params.node.setSelected(true);
            },
        }
        //#endregion Selected Radiologist Grid

        $scope.moveAvailableToSelected = function () {
            var SelectedRows = AvailableRadGridOptions.api.getSelectedRows();
            if (SelectedRows && SelectedRows.length > 0) {

                //Below code will add selected rows to SelectedRadiologistsList
                vm.selectedValues.SelectedRadiologists = _.concat(vm.selectedValues.SelectedRadiologists, SelectedRows);
                vm.selectedValues.SelectedRadiologists = _.uniqBy(vm.selectedValues.SelectedRadiologists, 'Id');
                vm.selectedValues.SelectedRadiologists = $filter('orderBy')(vm.selectedValues.SelectedRadiologists, ['LastName', 'FirstName']);
                SelectedRadGridOptions.api.setRowData(vm.selectedValues.SelectedRadiologists);

                //Below Code will remove selected rowsw from AvailableRadiologistsList
                AvailableRadiologistsList = _.difference(AvailableRadiologistsList, SelectedRows);
                AvailableRadGridOptions.api.setRowData(AvailableRadiologistsList);
            }
        };
        $scope.moveSelectedToAvailable = function () {
            var SelectedRows = SelectedRadGridOptions.api.getSelectedRows();
            if (SelectedRows && SelectedRows.length > 0) {
                //Below code will remove selected rows from SelectedRadiologistsList
                vm.selectedValues.SelectedRadiologists = _.difference(vm.selectedValues.SelectedRadiologists, SelectedRows);
                SelectedRadGridOptions.api.setRowData(vm.selectedValues.SelectedRadiologists);

                //Below code will add selected rows to AvailableRadiologistsList
                AvailableRadiologistsList = _.concat(AvailableRadiologistsList, SelectedRows);
                AvailableRadiologistsList = _.uniqBy(AvailableRadiologistsList, 'Id');
                AvailableRadiologistsList = $filter('orderBy')(AvailableRadiologistsList, ['LastName', 'FirstName']);
                AvailableRadGridOptions.api.setRowData(AvailableRadiologistsList);
            }
        };

        $scope.FilterRadiologist = function () {
            var d = $q.defer();
            var filter = {
                Search: $scope.search,
                UserID: $sessionStorage.currentUserData.userId,
                // Sites picked in the grid's dropdown win; otherwise the host's default scope; otherwise none.
                TenantSiteIDs: ($scope.SelectedSiteValues.sites && $scope.SelectedSiteValues.sites.length > 0)
                    ? $scope.SelectedSiteValues.sites
                    : ((vm.defaultTenantSiteIds && vm.defaultTenantSiteIds.length > 0) ? vm.defaultTenantSiteIds : null),
                PaymentContract: PaymentContractType ? PaymentContractType : null,
                PaymentSubContract: PaymentSubContractType ? PaymentSubContractType : null,
                ShowAllUsers: $scope.ShowAllUserSwitch.Obj
            };
            if (vm.tenantId) {
                filter.TenantID = vm.tenantId;
            }
            RuleService.GetAllUserByTenant(filter).then(function (result) {
                if(PaymentContractType ||PaymentSubContractType){
                    result = _.filter(result, function (user) {
                        if (user && user.UserRoles && user.UserRoles.split(',').length > 0) {
                            return user.UserRoles.split(',').includes('User');
                        }
                    });
                }
                AvailableRadiologistsList = filterVisibleRadiologists(result);
                _.each(vm.selectedValues.SelectedRadiologists, function (user) {
                    AvailableRadiologistsList = _.filter(AvailableRadiologistsList, function (data) {
                        return data.Id != user.Id;
                    });
                });
                AvailableRadiologistsList = _.uniqBy(AvailableRadiologistsList, 'Id');
                AvailableRadGridOptions.api.setRowData(AvailableRadiologistsList);
                AvailableRadGridOptions.api.ensureIndexVisible(0);
                d.resolve();
            });
            return d.promise;
        };

        $scope.Save = function () {
            if (vm.selectedValues.SelectedRadiologists.length > 0) {
                vm.showAssignRadiologistCmp.value = false;
                clearData();
                vm.onSelectRadiologist();
            } else {
                toaster.warning({ body: "Please select at least one user." });
            }
        };

        $scope.cancel = function () {
            clearData();
            vm.showAssignRadiologistCmp.value = false;
            vm.onCancel();
        };
        $scope.clearFilter = function () {
            clearData();
            $scope.FilterRadiologist();
        }
        function clearData() {
            $scope.search = '';
            $scope.SelectedData = { Location: null, locationIDs: null, TenantIDs: null, SiteIDs: null, Sites: null };
            $scope.SelectedSiteValues = {
                Ids: '',
                sites: [],
                divId: "AssignRadiologist"
            };
        }
        function GetSitesAndLocation() {
            var filter = {
                UserID: $sessionStorage.currentUserData.userId,
            }
            PaymentContractService.GetTenantsAndSiteAndLocation(filter).then(function (result) {
                $scope.MasterData.Locations = _.filter(result, function (obj) { return obj.SiteID != 0; });
                $scope.MasterData.Sites = _.flatMap($scope.MasterData.Locations, function (tenant) {
                    return _.map(tenant.Sites, function (site) {
                        return {
                            TenantName: tenant.TenantName,
                            TenantID: tenant.TenantID,
                            Site: site.Site,
                            SiteID: site.SiteID
                        };
                    });
                });
            })
        };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('cmpassignradiologists', {
            templateUrl: 'app/theme/components/assign-radiologists-cmp/assign-radiologists-cmp.html',
            bindings: {
                assignedRadiologist: '<',
                viewMode: '<',
                flag: '<',
                viewGroup: '<',
            },
            controller: cmpAssignRadiologistsController
        });
    function cmpAssignRadiologistsController($scope, $log, $sessionStorage) {
        var vm = this;

        $scope.assignedRadiologist = [];

        vm.$onChanges = function (changes) {
            $log.log("OnChnages > cmpassignradiologists");
            $scope.assignedRadiologist = changes.assignedRadiologist.currentValue;
        };
        vm.$onDestroy = function () {
            $log.log("onDestroy > cmpassignradiologists");
        }
        vm.$onInit = function () {
            $log.log("onInit > cmpassignradiologists");
            $scope.assignedRadiologist = vm.assignedRadiologist;
        }

        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        $scope.radDisplay = function (r) {
            if (!r) return '';
            if (vm.viewGroup && !_isSelf(r.Id || r.UserID) && _hasPrelimRad(r.UserRoles || r.Roles)) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
    }

    
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('attachmentViewer', {
            templateUrl: 'app/theme/components/attachment-viewer/attachment-viewer.html',
            bindings: {
                dicomorder: '<',
                sendFax: '&',
                selectedOrder: '<',
                showPdf: '<'
            },
            controller: AttachmentViewerController
        });

    /** @ngInject */
    function AttachmentViewerController($scope, $rootScope, TechnoService, $sce, $state, $sessionStorage, $window,toastr,toaster, CommonService) {
        var work = this;
        $scope.currState = $state.current.name;
        $scope.userId = $sessionStorage.currentUserData.userId;
        $scope.userRole = $sessionStorage.currentUserData.userRoles;
        function init() {
            if (work.dicomorder) {
                //$scope.DiacomOrderId = work.dicomorderId;
                getFile(work.dicomorder.ID, work.dicomorder.ShowLastFile);
            }
        }

        function getFile(DicomOrderId,ShowLastFile) {
            $scope.FileList = [];
            TechnoService.getFileList(DicomOrderId).then(function (result) {
                if (!work.showPdf && $sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && ($sessionStorage.EnableRowsForSelectedTenants && $sessionStorage.EnableRowsForSelectedTenants.split(',').includes(work.selectedOrder.TenantName))) {
                    result = _.filter(result, function (file) {
                        return !_.includes(_.toUpper(file.FileName), 'ORU');
                    });
                    $rootScope.$broadcast("deleteFile", result.length);
                }
                $scope.FileList = result;
                $scope.FileList.forEach(function (extension) {
                    extension.FileExtension = '.' + extension.FileName.split('.').pop();
                });
                if (result && result.length > 0 && !ShowLastFile) {
                    downloadFile(result[0].FilePath, result[0].FileType, result[0].Id, result[0].FileName);
                }
                else if (ShowLastFile) {
                    var idx = result.length - 1;
                    downloadFile(result[idx].FilePath, result[idx].FileType, result[idx].Id, result[idx].FileName);
                    work.dicomorder.ShowLastFile = false;
                }
                //$scope.isLoading = false;
            }, _respError);
        }
        $scope.showFile = function (uri, fileType, Id, fileName) {
            if ($scope.SelectedFileId == Id) { return; }
            else { $scope.SelectedFileId = Id }            
            downloadFile(uri, fileType, Id, fileName);
        }
        function downloadFile(uri, fileType, Id, fileName) {
            $scope.isLoading = true;
            var data = {
                FilePath: uri
            };
            $scope.filePath = uri;
            $scope.file = null;
            $scope.FileType = fileType;
            $scope.fileName = fileName;
            $scope.fileurl = null;

            if ($scope.fileName.includes(".pdf") && fileType.includes("octet-st")) {
                $scope.FileType = "application/pdf";
                fileType = "application/pdf";
            }

            TechnoService.showFile(data).then(function (result) {
                $scope.isLoading = false;
                $scope.file = result;
                    if ($scope.file && $scope.file.FileContent) {
                        $scope.fileurl = CommonService.createBlobUrl($scope.file.FileContent, fileType);
                }
                
                setTimeout(function () { activeInactiveClass(Id); }, 200);
            }, function (error){
                $scope.isLoading = false;
                console.log("downloadFile > Error: ", error);
            });
        }

        function b64toBlob(dataURI, fileType) {
            var byteString = atob(dataURI);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: fileType});
        }

        function activeInactiveClass(Id) {
            angular.element("div.activeFile").removeClass('activeFile');
            angular.element('.' + Id).addClass('activeFile');
        }
        function _respError(error) {
            $scope.isLoading = false;
        }
        $scope.deleteFile = function (obj) {
            swal({
                title: 'Are you sure you want to delete?',
                type: "warning",
                html: true,
                customClass: 'swal-wide',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55", confirmButtonText: "Yes",
                cancelButtonText: "No",
            },
                function (isConfirm) {
                    if (isConfirm) {
                        obj.UploadBy = $scope.userId;
                        deleteAttachedFile(obj);
                    }
                });
        }

        function deleteAttachedFile(obj) {
            $scope.isLoading = true;
            
            TechnoService.deleteFile(obj).then(function (result) {
                if (result != -1) {
                    toaster.success({ body: "File deleted successfully!"  })
                    $rootScope.$broadcast("deleteFile", result);
                    getFile(work.dicomorder.ID, work.dicomorder.ShowLastFile);
                }
               
                $scope.isLoading = false;
            }, _respError);
        }
        init();
    }
}());




//(function () {
//    'use strict';

//    angular.module('BlurAdmin.theme.components')
//        .component('attachmentViewer', {
//            templateUrl: 'app/theme/components/attachment-viewer/attachment-viewer.html',
//            bindings: {
//                dicomorderId: '<'
//            },
//            controller: AttachmentViewerController
//        });



//    /** @ngInject */
//    function AttachmentViewerController($scope, $attrs) {
//        var vm = this;
//        alert(vm.dicomorderId);
//        if (vm.dicomOrderId) {
//            $scope.DiacomOrderId = work.dicomOrderId;
//            //getFile(work.dicomOrderId);
//        }



//    }
//}());

(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    //baSidebarServiceProvider.$inject = ['authService'];

    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];

        this.addStaticItem = function () {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        /** @ngInject */
        this.$get = function ($state, layoutSizes, authService) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();

                this.getMenuItems = function (roles) {
                    var states = defineMenuItemStates();
                    var userRoles = _.clone(authService.User().userRoles);
                    var menuItems = [];
                    _.each(states, function (obj) {
                        if (obj.level == 0) {
                            var isAccessible = false;
                            _.each(userRoles, function (role) {
                                if (!isAccessible && obj.roles.includes(role)) {
                                    isAccessible = true;
                                }
                            });
                            if (isAccessible) {
                                menuItems.push(obj);
                            }
                        }
                    });

                    _.each(menuItems, function (item) {
                        var submenu = [];
                        _.each(states, function (obj) {
                            if (obj.level == 1 && (obj.name.includes(item.name))) {
                                var isAccessible = false;
                                _.each(userRoles, function (role) {
                                    if (!isAccessible && obj.roles.includes(role)) {
                                        isAccessible = true;
                                    }
                                });
                                if (isAccessible) {
                                    submenu.push(obj);
                                }
                            }
                        });
                        if (submenu && submenu.length > 0) {
                            item.subMenu = submenu;
                        }
                    });
                    return menuItems;
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function (isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function () {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function () {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function (item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates() {
                    return $state.get()
                        .filter(function (s) {
                            return s.sidebarMeta;
                        })
                        .map(function (s) {
                            var meta = s.sidebarMeta;
                            var params = s.params || {};
                            return {
                                name: s.name,
                                roles: params.roles || [],
                                title: s.title,
                                level: (s.name.match(/\./g) || []).length,
                                order: meta.order,
                                icon: meta.icon,
                                stateRef: s.name,
                            };
                        })
                        .sort(function (a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        };
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('BaSidebarCtrl', BaSidebarCtrl);

    /** @ngInject */
    function BaSidebarCtrl($scope, baSidebarService, authService, $rootScope, $state, CommonService) {

        $scope.$on('LoginSuccess', function (event, mass) {
            if (authService.User().roles) {
                $scope.menuItems = baSidebarService.getMenuItems(authService.User().roles);
                //$scope.defaultSidebarState = $scope.menuItems[0].stateRef;
                $scope.defaultSidebarState = $scope.menuItems && $scope.menuItems.length > 0 ? $scope.menuItems[0].stateRef : null;
            }
        });

        $scope.hoverItem = function ($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            var menuTopValue = 40;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };

        $scope.$on('$stateChangeSuccess', function () {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });
        $scope.OpenCIVRSetting = function () {
            $rootScope.$emit("OpenCIVRSetting");
            $rootScope.$broadcast("OpenCIVRSetting");
        }
        var init = function () {
            if (authService.User().roles) {
                var menuItems = baSidebarService.getMenuItems(authService.User().roles);
                if (window.location.href.match('CallFrom')) {
                    menuItems = _.filter(menuItems, { stateRef: 'userAnalytics' });
                    $scope.currentStateTitle = 'Analytics';
                    $scope.menuItems = menuItems;
                    //$scope.defaultSidebarState = $scope.menuItems[0].stateRef;
                    $scope.defaultSidebarState = $scope.menuItems && $scope.menuItems.length > 0 ? $scope.menuItems[0].stateRef : null;
                }
                else {
                    $scope.menuItems = menuItems;
                    //$scope.defaultSidebarState = $scope.menuItems[0].stateRef;
                    $scope.defaultSidebarState = $scope.menuItems && $scope.menuItems.length > 0 ? $scope.menuItems[0].stateRef : null;
                }
                if (menuItems.length >= 9) {
                    angular.element("#navtop").addClass("deskmenu");
                }
                else if (menuItems.length >= 5) {
                    angular.element("#navtop").addClass("moremenu");
                }
            }
        }
        init();
        $rootScope.$on('$stateChangeSuccess', function () {
            $scope.currentStateTitle = $state.current.title;
        });
        $scope.$on('PeerReviewPendingCount', function (evt, data) {
            $scope.PeerReviewPendingCount = data[0].PeerReviewPendingCount;
        });
        $scope.$on('ShowPaymentInvoiceHistory', function (evt, data) {
            $scope.ShowPaymentInvoiceHistory = data;
        });
    }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('chatBox', {
            templateUrl: 'app/theme/components/chat/chat.html',
            bindings: {

            },
            controller: ChatController
        });

    /** @ngInject */
    function ChatController($scope, $rootScope, chatService, AccountManagerService, $sce, $state, $sessionStorage, AppHubService, $q, $timeout, windowHandler, APP_CONSTANTS, RCService, $filter, toastr, toaster, __env) {
        //var TwilioVideo = Twilio.Video;
        // #region Variables
        var AppHub;
        var parser = new UAParser();

        $scope.browser = parser.getBrowser().name;
        $scope.currState = $state.current.name;
        $scope.currUserId = $sessionStorage.currentUserData.userId;
        $scope.currFirstName = $sessionStorage.currentUserData.FirstName;
        $scope.currLastName = $sessionStorage.currentUserData.LastName;
        $scope.isHighPriority = false;
        $scope.isShowChatWindow = false;
        $scope.selectedUserId = "0";
        var UserListPageNum = 1;
        var MessageListPageNum = 1;
        var PageSize = 25;
        $scope.userList = [];
        $scope.MessageList = [];
        $scope.scrolllToBottom = false;
        var ShareExamscrollPosition = false;
        $scope.DeleteMessageScrollPosition = false;
        $scope.readMoreTxt = "Read More";
        var numLimit = 160;
        $scope.isShareChatLink = false;
        $scope.EnterKeyFlag = false;
        // #endregion Variables

        // #region PrelimRad masking helpers
        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function _maskName(last, first, roles, id) {
            if (_isSelf(id)) return (last || '') + ', ' + (first || '');
            return _hasPrelimRad(roles) ? '' : (last || '') + ', ' + (first || '');
        }
        $scope.maskName = _maskName;
        $scope.maskInitials = function (last, first, roles, id) {
            if (_isSelf(id)) return (last || '').substring(0, 1) + (first || '').substring(0, 1);
            return _hasPrelimRad(roles) ? '' : (last || '').substring(0, 1) + (first || '').substring(0, 1);
        };
        // #endregion PrelimRad masking helpers

        // #region funcitons
        function init() {
            $scope.isChatMenuActive = true;
            intiAppHub();
            windowHandler.inIt();
        }
        function GetAllUsers() {
            var d = $q.defer();
            var filter = {
                PageSize: PageSize,
                PageNum: UserListPageNum,
                Id: $scope.currUserId,
                UserName: $scope.UserName,
                NewMessage: $scope.NewMessage,
            }
            $scope.showUsersLoader = true;
            chatService.GetUserList(filter).then(function (result) {

                if (result != null && result.length > 0) {
                    if ($scope.UserName && UserListPageNum == 1) {
                        $scope.userList = result;
                    }
                    else if ($scope.UserName && UserListPageNum > 1) {
                        $scope.userList = $scope.userList.concat(result);
                    }
                    else {
                        $scope.userList = $scope.userList.concat(result);
                    }
                    $scope.showUsersLoader = false;
                }
                else if ($scope.UserName && result.length <= 0 && UserListPageNum == 1) {
                    $scope.userList = [];
                    $scope.showUsersLoader = false;
                }
                else {
                    $scope.showUsersLoader = false;
                }
                //angular.copy(result);
                $scope.userList = _.uniqBy($scope.userList, 'Id');
                $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                var idx = _.findIndex($scope.userList, function (obj) { return obj.Id == $scope.currUserId; });
                if (idx > -1) {
                    $scope.userList.splice(idx, 1);
                }
                SetOnlineUsers();
                d.resolve();
            }, function (err) {
                $scope.showUsersLoader = false;
            });
            return d.promise;
        };
        $scope.UserListNextPage = function () {
            UserListPageNum += 1;
            GetAllUsers();
        };
        $scope.OnChangeFilter = function () {
            UserListPageNum = 1;
            GetAllUsers();
            scrollPositionSetMessageList();
        }
        function SetOnlineUsers() {
            AccountManagerService.getOnlineUsers().then(function (result) {
                var userIds = result.data;
                angular.forEach(userIds, function (id, idx) {
                    var user = _.filter($scope.userList, function (user) { return user.Id == id; });
                    if (user && user.length > 0) {
                        user[0].IsOnline = true;
                    }
                });
            }, function (err) {
            });
        }
        init();
        function GetMessage() {
            var d = $q.defer();
            //$scope.MessageList = [];
            var curVM = {
                FromUserId: $scope.currUserId,
                ToUserId: $scope.isPrivateUserChat == true ? $scope.selectedUserObject.Id : null,
                ToGroupId: $scope.isPrivateUserChat == true ? null : $scope.selectedUserObject.Id,
                PageSize: PageSize,
                PageNum: MessageListPageNum,
            };
            $scope.showChatLoader = true;
            chatService.GetMessage(curVM).then(function (result) {
                if (result != null && result.length > 0) {
                    //$scope.MessageList = [];
                    _.each(result, function (obj) {
                        obj.numLimit = numLimit;
                        if ((obj.Message.split('|SHAREEXAMOBJ|'))[0].length > numLimit) {
                            obj.isExpandable = true;
                            obj.readMoreTxt = "Read More";
                        }
                        else
                            obj.isExpandable = false;
                        if (obj.Message.includes('Call has been scheduled')) {
                            obj.Message = obj.Message.replace(obj.Message.slice(-16), moment.utc((obj.Message.slice(-16) + ':00').replace(/-/g, "/")).local().format("MM-DD-YYYY HH:mm"));
                            //re.Message = re.Message.replace(re.Message.slice(-16),moment.utc(re.Message.slice(-16)+':00').local().format("MM-DD-YYYY HH:mm"));    
                            // $scope.MessageList.push(obj);
                        }

                        $scope.MessageList.push(obj);
                    })
                }
                $scope.MessageList = $filter('orderBy')(_.uniqBy($scope.MessageList, 'Id'), ['MessageTime']);
                //$scope.MessageList = result;

                $scope.showChatLoader = false;
                d.resolve();
            }, function (err) {
                $scope.showChatLoader = false;
                d.resolve();
            });
            return d.promise;
        };

        $scope.GetMessageNextPage = function () {

            if ($scope.MessageList != null && $scope.MessageList.length > 0) {
                $scope.scrolllToBottom = false;
                $scope.DeleteMessageScrollPosition = false;
                MessageListPageNum += 1;
                GetMessage();
            }

            // ShareExamscrollPosition = false;
        }
        function SendPrivateOrGroupMessage(curVM) {
            if (!curVM)
                return;
            chatService.SendMessage(curVM).then(function (result) {
                $scope.EnterKeyFlag = false;
                $scope.messageId = result;
                if($scope.roomName != ""){
                    if(curVM.Message.includes('Call has been scheduled')){
                        curVM.Message = curVM.Message.replace(curVM.Message.slice(-16),moment.utc((curVM.Message.slice(-16)+':00').replace(/-/g,"/")).local().format("MM-DD-YYYY HH:mm")); 
                    }
                $scope.paramVideoObj = {
                    fromUserId: $scope.currUserId,//$sessionStorage.currentUserData.userId,
                    toUserName: $scope.selectedUserObject.FirstName +" "+$scope.selectedUserObject.LastName,//username,
                    toUserId:$scope.selectedUserObject.Id,
                    roomName: $scope.roomName,
                    startDateTime: $scope.dateTimeLocalUTCCallScheduled == undefined ? moment(new Date().toLocaleString('en-US', { timeZone: 'US/Central' })).format("MM-DD-YYYY HH:mm:ss") : moment(new Date($scope.dateTimeLocalUTCCallScheduled).toLocaleString('en-US', { timeZone: 'US/Central' })).format("MM-DD-YYYY HH:mm"),
                    endDateTime : moment(new Date()).format("MM-DD-YYYY HH:mm:ss"),
                    hasJoinCall : $scope.hasJoinCall,
                    messageId : $scope.messageId,
                    message:curVM.Message,
                    toUserPhoneNumber: $scope.selectedUserObject.PhoneNumber,
                    fromUserDisplayName: $scope.currLastName + ', ' + $scope.currFirstName,
                };
                if(curVM.Message.includes('Call has been scheduled') || curVM.Message.includes('wants to consult a study for the below procedure')){
                    videoCallConvertToJsonObject(curVM.Message);                    
                }
                if(curVM.Message.includes('Video Call Link') || curVM.Message.includes('Call has been scheduled') || curVM.Message.includes('wants to consult a study for the below procedure')){
                    chatService.saveVideoConferencingDatails($scope.paramVideoObj).then(function(result){
                        $scope.videoConferencingId = result;
                        //GetMessage();
                        
                        $scope.showVideoChatLoader = false;
                    });
                }                
                }
                //if(curVM.Message.includes('|SHAREEXAMOBJ|')){
                //  GetMessage();
                //}
                $scope.previousMessageVM = curVM;
                $scope.isHighPriority = false;
                $scope.message = '';
                var idx = _.findIndex($scope.userList, function (data) { return data.Id == curVM.ToUserId; });
                if (idx > -1) {
                    $scope.userList[idx].MessageDT = moment(curVM.MessageTime).format("YYYY-MM-DDTHH:mm:ss");
                    $scope.userList[idx].LastMessage = curVM.Message;
                    $scope.userList[idx].FileName = curVM.FileName;
                    //$scope.$apply();
                    $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                }
            });

            //$('#message').val('');
        };
        function intiAppHub() {
            AppHub = AppHubService.getAppHub();
            var justCreated = false;
            if (!AppHub) {
                AppHubService.Initialize();
                AppHub = AppHubService.getAppHub();
                justCreated = true;
            }
            if (AppHub) {
                AppHub.off('RadFlowChatAppHubEvent');
                AppHubMethod();
                if (justCreated) AppHubService.startConnection();
            } else {
                $timeout(function () {
                    AppHub = AppHubService.getAppHub();
                    if (AppHub) {
                        AppHub.off('RadFlowChatAppHubEvent');
                        AppHubMethod();
                    }
                }, 500);
            }
        }
        $rootScope.$on('SignalrConnectionSetStartedMethod', function (name, xiIsConnectionStarted, xiConnectionId) {
            if (xiIsConnectionStarted) {
                AppHub = AppHubService.getAppHub();
                if (AppHub) {
                    AppHub.off('RadFlowChatAppHubEvent');
                    AppHubMethod();
                }
            }
        });
        function OpenShareExamchat() {
            var d = $q.defer();
            $scope.isChatMenuActive = true;
            $scope.isShowChatWindow = true;
            if ($scope.UserName) {
                $scope.UserName = null;
                UserListPageNum = 1;
                $scope.userList = [];
            }
            if ($scope.userList && $scope.userList.length == 0) {
                $q.all([
                    GetAllUsers()
                ]).then(function (data) {
                    $scope.userList = _.uniqBy($scope.userList, 'Id');
                    $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                    $rootScope.$emit('activeChatMenuBar:Chat', $scope.isChatMenuActive);
                    d.resolve();
                });

            } else {
                $rootScope.$emit('activeChatMenuBar:Chat', $scope.isChatMenuActive);
                d.resolve();
            }
            return d.promise;
        }
        function AppHubMethod() {
            if (!AppHub) return;
            console.log('SignalR [bindmessage]: chat component registering RadFlowChatAppHubEvent listener');
            AppHub.on('RadFlowChatAppHubEvent', function (obj) {
                if (!obj) return;
                var eventType = obj.EventType || obj.eventType || '';
                var eventArgs = obj.EventArgs || obj.eventArgs;
                console.log('SignalR [bindmessage]: chat component received RadFlowChatAppHubEvent EventType=' + (eventType || '(none)'));
                switch ((eventType || '').toLowerCase()) {
                    case 'bindmessage':
                        console.log('SignalR [bindmessage]: chat component processing bindmessage');
                        var obj = eventArgs || obj.EventArgs || obj.eventArgs;
                        if (!obj) break;
                        var msgVal = obj.Message || obj.message;
                        obj.Message = (typeof msgVal === 'string') ? msgVal : (msgVal != null ? String(msgVal) : '');
                        if (obj.ToUserId === undefined && obj.toUserId !== undefined) obj.ToUserId = obj.toUserId;
                        if (obj.FromUserId === undefined && obj.fromUserId !== undefined) obj.FromUserId = obj.fromUserId;
                        if (obj.MessageTime === undefined && obj.messageTime !== undefined) obj.MessageTime = obj.messageTime;
                        obj.readMoreTxt = "Read More";
                        obj.numLimit = numLimit;
                        if ((obj.Message.split('|SHAREEXAMOBJ|'))[0].length > numLimit) {
                            obj.isExpandable = true;
                        }
                        else {
                            obj.isExpandable = false;
                        }
                        if (obj.Message.includes('Call has been scheduled')) {
                            obj.Message = obj.Message.replace(obj.Message.slice(-16), moment.utc((obj.Message.slice(-16) + ':00').replace(/-/g, "/")).local().format("MM-DD-YYYY HH:mm"));
                            //re.Message = re.Message.replace(re.Message.slice(-16),moment.utc(re.Message.slice(-16)+':00').local().format("MM-DD-YYYY HH:mm"));    
                            // $scope.MessageList.push(obj);
                        }
                        if (obj.ToUserId == $scope.currUserId) {
                            if ($scope.isShowChatWindow && $scope.selectedUserObject.Id == obj.FromUserId) {
                                $scope.MessageList.push(obj);
                                $scope.MessageList = $filter('orderBy')($scope.MessageList, ['MessageTime']);
                                ChangeReadStatus(obj.FromUserId, obj.ToUserId);
                                if ($scope.hideChatWindow && obj.Message.indexOf("|SHAREEXAMOBJ|") != -1) {
                                    scrollPositionSetMessageList();
                                    $scope.maxChatWindow();
                                }
                                if (obj.FromUserId == $scope.selectedUserObject.Id) {
                                    $scope.maxChatWindow();
                                }
                            }
                            else {
                                var idx = _.findIndex($scope.userList, function (data) {
                                    return data.Id == obj.FromUserId;
                                });
                                if (idx == -1 && $scope.userList.length > 0) {
                                    var filter = {
                                        PageNum: '1',
                                        PageSize: '25',
                                        Id: obj.FromUserId,
                                        NewMessage: true,
                                    }
                                    chatService.GetUserList(filter).then(function (result) {
                                        if (!$scope.UserName) {
                                            $scope.userList.unshift(result[0]);
                                            $scope.userList[0].UnreadMsgCount = $scope.userList[0].UnreadMsgCount + 1;
                                        }
                                        if (obj.Message.indexOf("|SHAREEXAMOBJ|") != -1 && obj.FromUserId != $scope.currUserId && !_hasPrelimRad(obj.FromUserRoles)) {
                                            $q.all([
                                                OpenShareExamchat()
                                            ]).then(function (data) {
                                                if (!$scope.UserName) {
                                                    $scope.selectedUserObject = _.find($scope.userList, { 'Id': obj.FromUserId });
                                                    $scope.userList[0].UnreadMsgCount = $scope.userList[0].UnreadMsgCount - 1;
                                                }
                                                else {
                                                    $scope.selectedUserObject = result[0];
                                                }
                                                getUserMessages($scope.selectedUserObject);

                                            });
                                            scrollPositionSetMessageList();
                                            $scope.maxChatWindow();
                                        }
                                    });

                                }
                                else {
                                    if (idx > -1) {
                                        $scope.userList[idx].UnreadMsgCount = $scope.userList[idx].UnreadMsgCount + 1;
                                    }
                                    if (obj.Message.indexOf("|SHAREEXAMOBJ|") != -1 && obj.FromUserId != $scope.currUserId && !_hasPrelimRad(obj.FromUserRoles)) {
                                        $q.all([
                                            OpenShareExamchat()
                                        ]).then(function (data) {
                                            $scope.selectedUserObject = _.find($scope.userList, { 'Id': obj.FromUserId });
                                            getUserMessages($scope.selectedUserObject);
                                        });
                                        $scope.maxChatWindow();
                                    }
                                    scrollPositionSetMessageList();
                                    if ($scope.selectedUserObject && $scope.userList[idx].Id == $scope.selectedUserObject.Id) {
                                        $scope.maxChatWindow();
                                    }
                                }
                            }
                            ////////Update UserList Data ----------------------
                            var idx = _.findIndex($scope.userList, function (data) { return data.Id == obj.FromUserId; });
                            if (idx > -1) {
                                $scope.userList[idx].MessageDT = moment(obj.MessageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                                $scope.userList[idx].LastMessage = obj.Message;
                                $scope.userList[idx].FileName = obj.FileName;
                                $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                            }
                            //---------------------------------------------------
                        }
                        else if (obj.FromUserId == $scope.currUserId) {
                            $scope.MessageList.push(obj);
                            $scope.MessageList = $filter('orderBy')($scope.MessageList, ['MessageTime']);
                            ////////Update UserList Data
                            var idx = _.findIndex($scope.userList, function (data) { return data.Id == obj.ToUserId; });
                            if (idx > -1) {
                                $scope.userList[idx].MessageDT = moment(obj.MessageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                                $scope.userList[idx].LastMessage = obj.Message;
                                $scope.userList[idx].FileName = obj.FileName;
                                $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                            }
                            //---------------------------------------------------
                        }
                        $scope.scrolllToBottom = true;
                        $scope.DeleteMessageScrollPosition = false;

                        //}
                        break;
                    case 'deletemessage':
                        var Id = obj.EventArgs.Id;
                        var ToUserId = obj.EventArgs.ToUserId;
                        var DeletedMessage = obj;
                        var idx = _.findIndex($scope.MessageList, function (data) { return data.Id == Id; });
                        if (idx > -1) {
                            $scope.MessageList.splice(idx, 1);
                        }
                        //$scope.MessageList = $filter('orderBy')($scope.MessageList, 'MessageTime', false);
                        $scope.MessageList = $filter('orderBy')($scope.MessageList, ['MessageTime']);
                            var idxtouser = _.findIndex($scope.userList, function (data) { return data.Id == DeletedMessage.EventArgs.FromUserId; });
                            var idxtoUnreadUser = _.findIndex($scope.ChatMessageList, function (data) { return data.Id == Id; });
                            if (idxtouser > -1 && $scope.userList[idxtouser].UnreadMsgCount > 0 && idxtoUnreadUser > -1) {
                                $scope.userList[idxtouser].UnreadMsgCount = $scope.userList[idxtouser].UnreadMsgCount - 1;
                            }
                            if (idxtouser > -1) {
                                if ($scope.MessageList != null && $scope.MessageList.length > 0) {
                                    //$scope.DeleteMessageObject = _.find($scope.MessageList, { 'Id': DeletedMessage.EventArgs.Id });
                                    //if ($scope.DeleteMessageObject) {
                                    //    $scope.userList[idxtouser].MessageDT = moment($scope.MessageList[$scope.MessageList.length - 1].MessageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                                    //    $scope.userList[idxtouser].LastMessage = $scope.MessageList[$scope.MessageList.length - 1].Message;
                                    //    $scope.userList[idxtouser].FileName = $scope.MessageList[$scope.MessageList.length - 1].FileName;
                                    //    $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                                    //}
                                    //else {
                                    if ($scope.userList[idxtouser].LastMessage == DeletedMessage.EventArgs.Message && $scope.userList[idxtouser].MessageDT == DeletedMessage.EventArgs.MessageTime) {
                                        $scope.userList[idxtouser].LastMessage = "This message has been deleted.";
                                        $scope.userList[idxtouser].MessageDT = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
                                        if (DeletedMessage.EventArgs.FileName) { $scope.userList[idxtouser].FileName = null;}
                                        $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                                    }
                                    //}
                                }
                                else if ($scope.userList[idxtouser].LastMessage == DeletedMessage.EventArgs.Message && $scope.userList[idxtouser].MessageDT == DeletedMessage.EventArgs.MessageTime) {
                                    $scope.userList[idxtouser].LastMessage = "This message has been deleted.";
                                    $scope.userList[idxtouser].MessageDT = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
                                    if (DeletedMessage.EventArgs.FileName) { $scope.userList[idxtouser].FileName = null; }
                                    $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                                }
                            }
                            var idxselecteduser = _.findIndex($scope.userList, function (data) { return data.Id == $scope.selectedUserId; });
                            if (idxselecteduser > -1) {
                                ////////Update UserList Data
                                if ($scope.MessageList != null && $scope.MessageList.length > 0) {
                                    $scope.userList[idxselecteduser].MessageDT = moment($scope.MessageList[$scope.MessageList.length - 1].MessageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                                    $scope.userList[idxselecteduser].LastMessage = $scope.MessageList[$scope.MessageList.length - 1].Message;
                                    $scope.userList[idxselecteduser].FileName = $scope.MessageList[$scope.MessageList.length - 1].FileName;
                                    $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                                }
                                else {
                                    $scope.userList[idxselecteduser].MessageDT = moment("1900-01-01").format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                                    $scope.userList[idxselecteduser].LastMessage = "";
                                    $scope.userList[idxselecteduser].FileName = "";
                                    $scope.userList = $filter('orderBy')($scope.userList, ['-MessageDT', 'LastName', 'FirstName']);
                                }
                                //---------------------------------------------------
                            }
                        break;
                    case 'setonlinestatus':
                        var userId = obj.EventArgs.Id;
                        var idx = _.findIndex($scope.userList, function (obj) { return obj.Id == userId; });
                        if (idx > -1) {
                            $scope.userList[idx].IsOnline = obj.EventArgs.IsOnline;
                        }
                        break;
                    case 'typingindicator':
                        if (obj.EventArgs && obj.EventArgs.Message) {
                            $scope.isTypingMessage = obj.EventArgs.Message;
                            $timeout(function () { $scope.isTypingMessage = ''; }, 3000);
                        }
                        break;
                }
            });
        }
        function deleteMessage(obj) {
            chatService.DeleteMessage(obj).then(function (result) {
            },
                function (err) {

                });
            ShareExamscrollPosition = true;
            $scope.DeleteMessageScrollPosition = true;
            $scope.scrolllToBottom = true;
        }
        function downloadFile(obj, blobData) {
            try {
                var linkElement = document.createElement('a');
                var contentType = obj.FileExtension;

                var blob = b64toBlob(blobData, contentType);
                var url = URL.createObjectURL(blob);
                var b = parser.getBrowser().name;
                if (b != null && b.toUpperCase() == "IE") {
                    window.navigator.msSaveBlob(blob, obj.FileName);
                }
                else {
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", obj.FileName);
                    var clickEvent = new MouseEvent("click", {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        }
        function b64toBlob(dataURI, fileType) {
            var byteString = atob(dataURI);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: fileType });
        }
        function ChangeReadStatus(FromUserId, ToUserId) {
            chatService.ChangeReadStatus(FromUserId, ToUserId);
            var idx = _.findIndex($scope.userList, function (obj) { return obj.Id == ToUserId; });
            if (idx > -1) {
                $scope.userList[idx].UnreadMsgCount = 0;
            }
        }
        // #endregion

        // #region Methods
        $scope.itemClicked = function (obj, isShareChatLink) {
            $scope.isShareChatLink = isShareChatLink;
            // if(multipleOrderWorkList){
            //     var consultUserName = obj.FirstName + " " + obj.LastName;
            //     swal({
            //         title: "Are you sure you want to do video call consult with "+ consultUserName + " ?",
            //         text: "",
            //         type: "warning",
            //         showCancelButton: true,
            //         confirmButtonColor: "#DD6B55",
            //         confirmButtonText: "Yes",
            //         cancelButtonText: "No",
            //         closeOnConfirm: false

            //     },
            //         function (isConfirm) {
            //             if(isConfirm){
            //                 getUserMessages(obj);
            //             // $rootScope.$broadcast("ChatReadCount", obj, "Read");
            //             // $scope.isShowChatWindow = true;
            //             // $scope.isPrivateUserChat = true;
            //             // $scope.selectedUserObject = obj;
            //             // $scope.selectedUserId = obj.Id;
            //             // GetMessage();
            //             // if (obj.UnreadMsgCount > 0) {
            //             //     ChangeReadStatus(obj.Id, $scope.currUserId);
            //             //     obj.UnreadMsgCount = 0;
            //             // }
            //             // $scope.isHighPriority = false;

            //             // //$scope.message = '';
            //             // //$scope.sendMessage();
            //             $scope.openVideoChat(consultUserName, false,'');
            //         }
            //         else{
            //             multipleOrderWorkList =null;
            //         }
            //         });

            // }else
            if (!$scope.isShareChatLink) {
                $scope.closeKendoScheduleLater();
                swal.close();
                multipleOrderWorkList = null;
                $timeout(function () { getUserMessages(obj); }, 300);
                //getUserMessages(obj).then(function (data) {
                //});
                //ShareExamscrollPosition = true;
                
                $scope.scrolllToBottom = true;
                $scope.DeleteMessageScrollPosition = false;
            }
            else {
                //alert();
                getUserMessages(obj);
                var leftDiv = document.createElement("div"); //Create left div
                leftDiv.id = "left"; //Assign div id
                leftDiv.setAttribute("style", "float:left; width:66.5%; line-height: 26px; text-align:left; font-size:12pt; padding-left:8px; height:26px;"); //Set div attributes
                leftDiv.style.background = "#FF0000";
                var a = document.createElement('a');
                a.href = 'google.com';
                a.textContent = $scope.roomName + " " + "Video Call Link"
                leftDiv.appendChild(a);
                $scope.isHighPriority = true;
                $scope.message = leftDiv.textContent;
                $scope.sendMessage($scope.message);
                $scope.message = '';
                $scope.isShareChatLink = false;
            }
        }
        // function loadChatHistory(obj){
        //     $rootScope.$broadcast("ChatReadCount", obj, "Read");
        //     $scope.isShowChatWindow = true;
        //     $scope.isPrivateUserChat = true;
        //     $scope.selectedUserObject = obj;
        //     $scope.selectedUserId = obj.Id;
        //     GetMessage();
        //     if (obj.UnreadMsgCount > 0) {
        //         ChangeReadStatus(obj.Id, $scope.currUserId);
        //         obj.UnreadMsgCount = 0;
        //     }
        //     $scope.isHighPriority = false;
        // }
        $scope.closeChatWindow = function () {
            $scope.isShowChatWindow = false;
            $scope.selectedUserId = "0";
            $scope.topFunction();
        }
        $scope.setUserChat = function (obj) {
            $scope.selectedUserObject = obj;
            $scope.maxChatWindow();
        }
        $scope.onFolderNumberKeyPress = function ($event, message) {

            var keyPressEvt = window.event ? $event.keyCode : $event.which;
            $scope.message = message;
            if (!$scope.message) {
                if (keyPressEvt == 13) {
                    $event.preventDefault();
                }
                return;
            }
            if (keyPressEvt == 13) {
                if ($(window).width() < 768 && keyPressEvt === 13) {
                    return;
                }
                if ($event.ctrlKey) {
                    $scope.message = $scope.message + '\n';
                    //$('#message').val($('#message').val() + '\n');
                }
                else {
                    //appService.setValue(true);
                    $scope.EnterKeyFlag = true;
                    $scope.sendMessage(message);
                    $event.preventDefault();
                    $scope.isTypingMessage = '';
                }
                $scope.scrolllToBottom = true;
                $scope.DeleteMessageScrollPosition = false;
            }
            else {
                if ($scope.selectedUserObject != null && $scope.isInstantGroupChat == false) {
                    if (!isTypingSentTimer) {
                        var typingTargetId = $scope.isPrivateUserChat ? $scope.selectedUserObject.Id : $scope.selectedUserObject.ChatGroupID;
                        AppHub.invoke('sendIsTypingDataGroupAndPrivate', typingTargetId, $scope.userObj.displayName + ' is typing...', $scope.isPrivateUserChat);
                        isTypingSentTimer = $timeout(function () {
                            $timeout.cancel(isTypingSentTimer);
                            isTypingSentTimer = null;
                        }, 1000);
                    }
                }
            }
        };
        $scope.sendMessage = function (message) {
            var curVM = null;
            if ($scope.message && $scope.message.trim(' ') != '') {
                $scope.message = message.replace('/\n+/', '\n');
                var curVM = {
                    FromUserId: $scope.currUserId,
                    Message: $scope.message,
                    ToUserId: $scope.isPrivateUserChat == true ? $scope.selectedUserObject.Id : null,
                    ToGroupId: $scope.isPrivateUserChat == true ? null : $scope.selectedUserObject.Id,
                    isPrivateChat: $scope.isPrivateUserChat,
                    isMessageRead: false,
                    isHighPriority: $scope.isHighPriority,
                    MessageTime: moment().utc().format('MM/DD/YYYY HH:mm:ss'),
                    ToUserPhoneNumber: $scope.selectedUserObject.PhoneNumber,
                    FromUserDisplayName: $scope.currLastName + ', ' + $scope.currFirstName,
                    FromUserRoles: $sessionStorage.currentUserData.roles,
                };
                SendPrivateOrGroupMessage(curVM)
            }
            return;
        };
        $scope.changePriority = function () {
            $scope.isHighPriority = !$scope.isHighPriority;
        }
        $scope.getMessageDate = function (message) {
            var idx = $scope.MessageList.indexOf(message);
            var isShowDate = true;
            if (idx > 0) {
                var previousMessage = $scope.MessageList[idx - 1];
                var previousDate = moment.utc(previousMessage.MessageTime).local().format('YYYYMMDD');
                var currentDate = moment.utc(message.MessageTime).local().format('YYYYMMDD');
                if (previousDate === currentDate) {
                    isShowDate = false;
                }
            }
            var dateDisplay = '';
            if (isShowDate) {
                var messageTime = moment.utc(message.MessageTime).local();
                var diff = moment().diff(moment(messageTime, 'YYYY-MM-DD').startOf('day'), 'days', false);
                if (diff == 0) {
                    dateDisplay = 'Today';
                } else if (diff == 1) {

                    dateDisplay = 'Yesterday';
                } else {
                    dateDisplay = moment.utc(message.MessageTime).local().format('M/D/YYYY');
                }
            }

            return dateDisplay
        }
        $scope.deleteMsg = function (obj) {
            swal({
                title: "Are you sure you want to delete it ?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
                function () {
                    deleteMessage(obj);
                });
        }
        $scope.uploadFile = function (e) {
            var allowedExtensions = ['pdf','doc','docx','xls','xlsx','csv','zip','jpg','jpeg','png','gif','bmp','tiff','tif','dcm','txt'];
            if (e.files.length > 0) {
                var data = new FormData();
                data.append("FromUserId", $scope.currUserId);
                data.append("ToUserId", $scope.selectedUserObject.Id);
                data.append("isHighPriority", $scope.isHighPriority);
                data.append("MessageTime", moment().utc().format('MM/DD/YYYY HH:mm:ss'));
                data.append("ToUserPhoneNumber", $scope.selectedUserObject.PhoneNumber);
                for (var i = 0; i < e.files.length; i++) {
                    var fileName = e.files[i].name;
                    var ext = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
                    if (!ext || allowedExtensions.indexOf(ext) === -1) {
                        toaster.warning({ body: "File type '." + ext + "' is not allowed. Permitted types: " + allowedExtensions.join(', ') });
                        angular.element("#file-input").val(null);
                        return;
                    }
                    var size = e.files[i].size / 1024 / 1024;
                    if (size > 5) {
                        toaster.warning({ body: "file size must be less than 5MB"  });
                        angular.element("#file-input").val(null);
                        return;
                    }
                    data.append("uploadedFile", e.files[i]);
                }
                chatService.uploadFile(data).then(function (result) {
                    angular.element("#file-input").val(null);
                }, function (error) {
                    var msg = (error && error.data && error.data.error) ? error.data.error : "File upload failed. File type may not be allowed.";
                    toaster.error({ body: msg });
                    angular.element("#file-input").val(null);
                });
                $scope.isHighPriority = false;
            }
        }
        $scope.downloadFile = function (obj) {
            chatService.DownloadFile(obj).then(function (result) {
                downloadFile(obj, result);
            }, function (err) {

            });

        }
        // #endregion

        ////#region Video-Chat
        $scope.window;
        $scope.schedulelaterDlgOptionWindow;
        $scope.roomName = "";
        $scope.showVideoChatLoader = false;
        $scope.isRescheduled = false;
        var connected = false;
        var room;
        var buttonJoin = document.getElementById('join_leave');
        var token = '';
        var localVideoTrack;
        var shareScreen = document.getElementById('share_screen');
        var screenTrack;
        var isshowViedoChatScreen = false;
        var connectedUseName = '';
        var muteUnmuteAudioButton = document.getElementById('mute-unmute-audio-button');
        var muteUnmuteVideoButton = document.getElementById('mute-unmute-video-button');
        var isAudioMuted = false;
        var isVideoMuted = false;

        var TrackType = {
            Audios: 'Audio',
            Videos: 'Video'
        }
        //$scope.ScheduleForTime = new Date();
        // $scope.ScheduleForDate = {};
        // //$scope.ScheduleForTime = new Date();
        // $scope.scheduleForDateOptions = {
        //     formatYear: 'yyyy',
        //     startingDay: 1,
        //     minDate: new Date()
        // };

        $scope.ScheduleForDateNew = {};
        $scope.scheduleForDateOptionsNew = {
            singleDatePicker: true,
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 5,
            autoUpdateInput: true,
            startDate: moment().startOf('hour'),
            minDate: new Date(),
            locale: {
                format: 'MM/DD/YYYY HH:mm'
            },
            ranges: {
                'Today': [moment().startOf('hour').startOf('minute')],
                'Tomorrow': [moment().add(1, 'days').startOf('hour').startOf('minute')]
            }
        };
        // $scope.scheduleForDateOptions = { minDate: new Date() }; 
        $scope.hstep = 1;
        $scope.mstep = 5;
        $scope.mindate = new Date();

        //full screen element
        //$scope.spanFullScreen = document.createElement('span');
        //$scope.spanFullScreen.setAttribute('class', 'fa fa-arrows-alt vidCallFullScrIcon');
        //$scope.spanFullScreen.setAttribute('title', 'Full screen');
        // connect to local video camera
        function addLocalVideo() {
            $q.all([
                Twilio.Video.createLocalVideoTrack()
            ]).then(function (track) {
                localVideoTrack = track[0];
                var video = document.getElementById('local').firstElementChild;
                if (video.childNodes.length >= 1) {
                    video.removeChild(video.childNodes[0]);
                }
                var trackElement = track[0].attach();
                trackElement.addEventListener('click', function () { zoomTrack(trackElement); });
                video.appendChild(trackElement);
                video.appendChild(trackElement);
                //video.appendChild($scope.spanFullScreen);
            });
        }
        $scope.openVideoChat = function (obj, hasJoinCall, currentMgs) {
            $scope.ScheduleForDateNew = {};

            if (isshowViedoChatScreen == true) {
                swal("Sorry!! you can not switch to another call, while on going call is active.");
                return;
            }
            // this is for SEND VIDEO CALL MESSAGE.
            if (!currentMgs) {
                swal({
                    //title: "Are you sure you want to consult right now or schedule meeting ?", 
                    //title : "Are you sure want to send a video call request to " + obj + " ?",

                    title: "Are you ready to be connected with " + obj + " for a video call request ?",
                    text: "",
                    //type: "error",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Meet now",
                    cancelButtonText: "Schedule meeting",
                    closeOnConfirm: true,
                    imageUrl: "assets/images/clock.svg"

                },
                    function (isConfirmed) {
                        if (isConfirmed) {
                            // THIS IS FOR INSTANT JOIN
                            //generateTwilioAcccessToken(obj, hasJoinCall,currentMgs)
                            // todo : time being commented for if join to user  disconnet the call then link can be expire
                            if (currentMgs != "") {
                                chatService.getVideoConferencingIDToUser(currentMgs.Id).then(function (result) {
                                    $scope.videoConferencingId = result;
                                    chatService.checkVideoCallLinkIsExpired($scope.videoConferencingId).then(function (result) {
                                        if (result) {
                                            // if($scope.videoConferencingId != 0){
                                            swal('This video call link is expired.')
                                            return;
                                            // }
                                            // else{
                                            //     generateTwilioAcccessToken(obj, hasJoinCall,currentMgs)
                                            // }
                                        }
                                        else
                                            generateTwilioAcccessToken(obj, hasJoinCall, currentMgs)
                                    })

                                })
                            }
                            else
                                generateTwilioAcccessToken(obj, hasJoinCall, currentMgs)
                        }
                        else {
                            // THIS IS FOR SCHEDULE THE VIDEO CALL
                            $scope.schedulelaterDlgOption = {
                                //width: "40%",
                                //height: "40%",
                                visible: false,
                                actions: [
                                    "Minimize",
                                    "Close"
                                ]
                            };

                            //$scope.ScheduleForTime=  new Date();
                            $scope.schedulelaterDlgOptionWindow.setOptions($scope.schedulelaterDlgOption);
                            //$scope.window.center();  // open dailog in center of screen
                            $scope.schedulelaterDlgOptionWindow.open();
                            angular.element('.svcall').parent().addClass('z-i-10007').removeClass('vcallheight');
                            $scope.schedulelaterDlgOptionWindow.title("RadFlow Secure V-Call Schedule Meeting")
                        }
                    });
            }
            else {
                // this is for JOIN NOW message 
                // todo : time being commented for if join to user  disconnet the call then link can be expire
                chatService.getVideoConferencingIDToUser(currentMgs.Id).then(function (result) {
                    $scope.videoConferencingId = result;
                    chatService.checkVideoCallLinkIsExpired($scope.videoConferencingId).then(function (result) {
                        if (result) {
                            // if($scope.videoConferencingId != 0){
                            swal('This video call link is expired.')
                            return;
                            // }
                            // else
                            //     generateTwilioAcccessToken(obj, hasJoinCall,currentMgs)
                        }
                        else {
                            var today = new Date();
                            var messageScheduleTime = currentMgs.Message.split(/\r?\n/);
                            var messageScheduled = messageScheduleTime.at(-1)
                            var dateTimeLocalUTCCallScheduled = new Date((messageScheduled + ':00').replace(/-/g, "/"));
                            var fromdatetime = new Date(dateTimeLocalUTCCallScheduled.getFullYear(), dateTimeLocalUTCCallScheduled.getMonth(), dateTimeLocalUTCCallScheduled.getDate(), dateTimeLocalUTCCallScheduled.getHours(), dateTimeLocalUTCCallScheduled.getMinutes(), 0);
                            var todayDatetime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), 0);



                            if (fromdatetime > todayDatetime) { swal("The scheduled v-call can't be started for the current date/time."); return; };
                            // if (todayDatetime > fromdatetime) {
                            //     console.log(`${todayDatetime} is less than ${fromdatetime}`);
                            //   } else if (todayDatetime > fromdatetime) {
                            //     console.log(`${todayDatetime} is greater than ${fromdatetime}`);
                            //   } else {
                            //     console.log(`Both dates are equal`);
                            //   }
                            if (currentMgs.Message == 'Video Call Link') {
                                generateTwilioAcccessToken(obj, true, currentMgs);
                            }
                            else if (messageScheduleTime.at(-3) != undefined) {
                                if (currentMgs.Message.includes('wants to consult a study for the below procedure'))
                                    generateTwilioAcccessToken(messageScheduleTime.at(-2).trim(), true, currentMgs);
                                else
                                    generateTwilioAcccessToken(messageScheduleTime.at(-3).trim(), true, currentMgs);
                            }
                            else
                                generateTwilioAcccessToken(messageScheduleTime.at(-1).trim(), true, currentMgs);
                        }
                    })

                })
                // generateTwilioAcccessToken(obj, hasJoinCall,currentMgs)
            }
        }

        function generateTwilioAcccessToken(obj, hasJoinCall, currentMgs) {

            //else{
            if (!currentMgs) {
                if (hasJoinCall) {
                    $scope.roomName = obj + " " + $scope.currFirstName.trim() + " " + $scope.currLastName.trim();
                }
                else {
                    $scope.roomName = $scope.currFirstName.trim() + " " + $scope.currLastName.trim() + " " + obj;
                }
            }
            else if (currentMgs.Message == 'Video Call Link') {
                $scope.roomName = obj + " " + $scope.currFirstName.trim() + " " + $scope.currLastName.trim();//
            }
            else if (currentMgs.Message.includes('Call has been scheduled')) {
                $scope.roomName = obj;//$scope.currFirstName.trim() +" "+ $scope.currLastName.trim() +" "+ obj;                    
            }
            else if (currentMgs.Message.includes('wants to consult a study for the below procedure')) {
                $scope.roomName = obj;
            }
            else {
                $scope.roomName = currentMgs.Message.replace(' Video Call Link', '');
            }
            if (hasJoinCall) {
                //chatService.
            }
            chatService.getAccessTwilioToken($scope.currFirstName + " " + $scope.currLastName, $scope.roomName).then(function (result) {
                //chatService.getAccessTwilioToken($scope.paramVideoObj).then(function(result){
                $scope.DlgOptions = {
                    //width: "40%",
                    //height: "40%",
                    visible: false,
                    actions: [
                        "Minimize",
                        "Maximize",
                        "Close"
                    ],
                    minimize: function () {
                        $('.kwindo-RadSceureVCall').addClass('modalSeVCall');
                        $('.modalSeVCall').addClass('sm-vidCallSection');
                        $('.modal-RadSceureVCall').show();
                        setTimeout(function () {
                            $('.kwindo-RadSceureVCall').find('[aria-label="window-restore"]').addClass('custom-krestore');
                            $('a.custom-krestore').click(function () {
                                $('.kwindo-RadSceureVCall').removeClass('modalSeVCall sm-vidCallSection modalSeVCallDragg').addClass('k-widget');
                            });
                        }, 500);
                    },
                    maximize: function () {
                        $('.kwindo-RadSceureVCall').removeClass('modalSeVCall sm-vidCallSection modalSeVCallDragg');
                    }
                };
                if (currentMgs) {
                    videoCallConvertToJsonObject(currentMgs.Message);
                }
                $scope.window.setOptions($scope.DlgOptions);
                //$scope.window.center();  // open dailog in center of screen
                $scope.window.open();
                angular.element('.svcall').parent().addClass('z-i-10007 vcallheight');
                $scope.window.title("RadFlow Secure V-Call");
                addLocalVideo();
                token = result;
                // $('#container').modal('hide');
                // $('#container').modal('show');
                connectedUseName = obj;
                connectButtonHandler(obj, hasJoinCall);
                isshowViedoChatScreen = true;
                $('.kwindo-RadSceureVCall').removeClass('modalSeVCall sm-vidCallSection modalSeVCallDragg').addClass('k-widget');
                // JS for move minimized video call window
                var $draggingVidEle = null;
                $(document.body).on("mousemove", function (e) {
                    if ($draggingVidEle) {
                        $(".kwindo-RadSceureVCall.k-window").removeClass('modalSeVCall k-widget').addClass('modalSeVCallDragg');
                        $(".kwindo-RadSceureVCall.k-window").offset({
                            top: e.pageY,
                            left: e.pageX
                        });
                    }
                });
                $(document.body).on("mousedown", ".k-widget.k-window.vcallheight.modalSeVCall", function (e) {
                    $draggingVidEle = $(e.target);
                });
                $(document.body).on("mouseup", function (e) {
                    $draggingVidEle = null;
                });

                //setTimeout(function () {
                //    $('.vidCallFullScrIcon').click(function () {
                //        $(this).parent().toggleClass('participantZoomed pos-rel');
                //        $(this).parent().find('video').toggleClass('participantZoomed');
                //    });
                //}, 100);
            })
            //}
        }

        //const connectButtonHandler = async (username) => {
        function connectButtonHandler(username, hasJoinCall) {
            //event.preventDefault();
            if (!connected) {
                buttonJoin.disabled = true;
                //buttonJoin.innerHTML = 'Connecting...';
                try {
                    connect(username, hasJoinCall);
                    //buttonJoin.innerHTML = 'Leave call';
                    angular.element('#join_leave').addClass('joincall-off');
                    buttonJoin.disabled = false;
                }
                catch (er) {
                    //swal('Connection failed. Is the backend running?');
                    toaster.error({ body: "Connection failed. Is the backend running?"  });
                    buttonJoin.innerHTML = 'Join call';
                    buttonJoin.disabled = false;
                }
            }
            else {
                disconnect();
                //buttonJoin.innerHTML = 'Join call';
                //shareScreen.innerHTML = 'Share screen';
                shareScreen.disabled = true;
                connected = false;
            }
        };

        // connect with participant
        function connect(username, hasJoinCall) {
            buttonJoin.disabled = true;
            //buttonJoin.innerHTML = 'Connecting...';
            $q.all([
                Twilio.Video.connect(token, { dominantSpeaker: true })
            ]).then(function (data) {

                room = data[0];
                $sessionStorage.room = room;
                room.participants.forEach(participantConnected);
                room.on('dominantSpeakerChanged', function (participant) {
                    handleSpeakerChange(participant);
                });
                room.on('participantConnected', participantConnected);
                room.on('participantDisconnected', participantDisconnected);

                connected = true;
                var leftDiv = document.createElement("div"); //Create left div
                leftDiv.id = "left"; //Assign div id
                leftDiv.setAttribute("style", "float:left; width:66.5%; line-height: 26px; text-align:left; font-size:12pt; padding-left:8px; height:26px;"); //Set div attributes
                leftDiv.style.background = "#FF0000";
                var a = document.createElement('a');
                a.href = 'google.com';
                //a.innerHTML = $scope.currFirstName.trim() +" "+ $scope.currLastName.trim() +' '+"Sent Video Call Link" 

                if (multipleOrderWorkList) {
                    $scope.showVideoChatLoader = true;
                    $scope.isHighPriority = true;
                    //$scope.roomName = $scope.currFirstName.trim() +" "+ $scope.currLastName.trim()+' '+ $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                    var dicomViewerURL = multipleOrderWorkList.DicomViewerURL != undefined ? multipleOrderWorkList.DicomViewerURL : '';
                    var dicomViewer = multipleOrderWorkList.DicomViewer != undefined ? multipleOrderWorkList.DicomViewer : '';
                    var site = multipleOrderWorkList.Site != null ? multipleOrderWorkList.Site : '';
                    a.textContent = "wants to consult a study for the below procedure. \n Location : " + multipleOrderWorkList.Location + "\n DOS : " + moment.utc(multipleOrderWorkList.OrderDate).format('MM-DD-YYYY HH:mm') + "\n Accession : " + multipleOrderWorkList.Accession + " \n MRN : " + multipleOrderWorkList.PatientMRN + " \n Patient Name : " + multipleOrderWorkList.PatientName + " \n Gender : " + multipleOrderWorkList.PatientGender + " \n DOB : " + moment.utc(multipleOrderWorkList.PatientDOB).format('MM-DD-YYYY') + " \n Modality : " + multipleOrderWorkList.Modality + " \n Type : " + multipleOrderWorkList.PatientClass + " \n Procedure Desc : " + multipleOrderWorkList.ProcedureDesc + " \n Ordering Physician : " + multipleOrderWorkList.OrderingPhysician + " \n Dicom Viewer URL : " + dicomViewerURL + " \n Dicom Viewer : " + dicomViewer + " \n Site : " + site + "\n in the video chat room \n " + $scope.roomName + "\n Please click Join now;";
                    $scope.message = a.textContent;
                    $scope.sendMessage($scope.message);
                    multipleOrderWorkList = null;
                }
                if (!hasJoinCall) {
                    $scope.showVideoChatLoader = true;
                    // setTimeout(function(){
                    a.textContent = "Video Call Link"
                    leftDiv.appendChild(a);
                    //document.body.appendChild(leftDiv);
                    //chatinner.appendChild(leftDiv);
                    $scope.isHighPriority = true;
                    $scope.message = leftDiv.textContent;
                    $scope.sendMessage($scope.message);

                    shareScreen.disabled = false;
                    muteUnmuteAudioButton.disabled = false;
                    muteUnmuteVideoButton.disabled = false;
                    //},200 )
                }
                else {
                    shareScreen.disabled = false;
                }
            });
            //room = await Twilio.Video.connect(token);

            //updateParticipantCount();

        };

        function handleSpeakerChange(participant) {
            removeDominantSpeaker();
            if (participant !== null)
                assignDominantSpeaker(participant);
        }
        var lastSpeakerSID = null; // add this at the top with the other variable declarations

        function setLabelColor(label, color) {
            if (label !== null) {
                label.style.backgroundColor = color;
            }
        }

        function removeDominantSpeaker() {
            var speakerNameLabel;
            speakerNameLabel = document.getElementById(lastSpeakerSID);
            setLabelColor(speakerNameLabel, "#717177"); // default color
            //setLabelColor(speakerNameLabel, "#ebebeb"); // default color
        }

        function assignDominantSpeaker(participant) {
            var domSpeakerNameLabel;
            lastSpeakerSID = "N_" + participant.sid;
            domSpeakerNameLabel = document.getElementById(lastSpeakerSID);
            setLabelColor(domSpeakerNameLabel, "#1f9b84"); // green color
            //setLabelColor(domSpeakerNameLabel, "#b5e7a0"); // green color
        }

        //const disconnect = () => {
        function disconnect() {
            if (room) {
                room.localParticipant.tracks.forEach(function (publication) {
                    var attachedElements = publication.track.detach();

                    attachedElements.forEach(function (element) { element.remove() });
                    publication.unpublish();
                    publication.track.stop();
                });
                room.disconnect();
            }
            if (localVideoTrack != null) {
                localVideoTrack.stop();
            }
            while (container.lastChild.id != 'local') {
                container.removeChild(container.lastChild);
            }

            $scope.roomName = "";
            //buttonJoin.innerHTML = 'Join call';
            isshowViedoChatScreen = false;
            //muteUnmuteAudioButton.innerHTML = 'Mute Audio';
            //muteUnmuteVideoButton.innerHTML = 'Mute Video';
            angular.element('#mute-unmute-audio-button').removeClass('mic-off');
            angular.element('#mute-unmute-audio-button').addClass('mic-on').attr("title", "Mute audio");
            angular.element('#mute-unmute-video-button').removeClass('video-off');
            angular.element('#mute-unmute-video-button').addClass('video-on').attr("title", "Mute video");
            angular.element('#share_screen').removeClass('sharescreen-off');
            angular.element('#share_screen').addClass('sharescreen-on');
            connected = false;

            setTimeout(function () {
                logVideoCallEndTime();
                $scope.window.close();
            }, 10);

            //$sessionStorage.room =null;
            //$('#container').modal('hide');
            // $scope.window.close();
            // buttonJoin.innerHTML = 'Join call';
            // isshowViedoChatScreen = false;
            // connected = false;
            // updateParticipantCount();
        };

        $scope.closeKendoVideoChat = function () {
            //
            disconnect();
        }
        $scope.closeKendoScheduleLater = function () {
            setTimeout(function () { $scope.schedulelaterDlgOptionWindow.close(); }, 100)
        }
        $scope.CancelScheduleLater = function () {
            $scope.closeKendoScheduleLater();
            $scope.ScheduleForDateNew = {};
            //$scope.ScheduleForTime = new Date();;
        }
        $scope.scheduleForDateOpen = function () {
            $scope.scheduleForDatepopup.opened = true;
        };
        $scope.scheduleForDatepopup = {
            opened: false
        };
        function logVideoCallEndTime() {
            if ($scope.videoConferencingId) {
                setTimeout(function () {
                    chatService.LogVideoCallEndTime($scope.videoConferencingId).then(function (result) {

                    })
                }, 100);

            }
        }
        
        function videoCallConvertToJsonObject(curVMMessage){
            $scope.selectedOrder =  angular.fromJson(curVMMessage.split(/\r?\n/).slice(1,15));
            if(curVMMessage.includes('Location')){
                $scope.selectedOrder ={
                    "Location":$scope.selectedOrder[0].substring($scope.selectedOrder[0].indexOf(':')+1).trim(),
                    "OrderDate" : $scope.selectedOrder[1].substring($scope.selectedOrder[1].indexOf(':')+1),//moment.utc($scope.selectedOrder[1].substring($scope.selectedOrder[1].indexOf(':')+1)).format('MM-DD-YYYY HH:mm'),
                    "Accession" : $scope.selectedOrder[2].substring($scope.selectedOrder[2].indexOf(':')+1).trim(),
                    "MRN" : $scope.selectedOrder[3].substring($scope.selectedOrder[3].indexOf(':')+1).trim(),
                    "PatientName" : $scope.selectedOrder[4].substring($scope.selectedOrder[4].indexOf(':')+1).trim(),
                    "PatientGender" : $scope.selectedOrder[5].substring($scope.selectedOrder[5].indexOf(':')+1).trim(),
                    "PatientDOB" : $scope.selectedOrder[6].substring($scope.selectedOrder[6].indexOf(':')+1),//moment.utc($scope.selectedOrder[6].substring($scope.selectedOrder[6].indexOf(':')+1)).format('MM-DD-YYYY'),
                    "Modality" : $scope.selectedOrder[7].substring($scope.selectedOrder[7].indexOf(':')+1).trim(),                    
                    "PatientClass" : $scope.selectedOrder[8].substring($scope.selectedOrder[8].indexOf(':')+1).trim(),                                                           
                    "ProcedureDesc" : $scope.selectedOrder[9].substring($scope.selectedOrder[9].indexOf(':')+1).trim(),    
                    "OrderingPhysician": $scope.selectedOrder[10].substring($scope.selectedOrder[10].indexOf(':')+1).trim() ,
                    "DicomViewerURL": $scope.selectedOrder[11].substring($scope.selectedOrder[11].indexOf(':')+1).trim(), 
                    "DicomViewer": $scope.selectedOrder[12].substring($scope.selectedOrder[12].indexOf(':')+1).trim(),
                    "Site": $scope.selectedOrder[13].substring($scope.selectedOrder[13].indexOf(':')+1).trim(),                
                }
            }
        }

        $scope.SaveOnCallScheduleLater = function (valid) {
            if(!$scope.isRescheduled){
            if(!valid)
                return;
            var today = new Date();
            var fromdatetime = new Date(moment($scope.ScheduleForDateNew.date).year(), moment($scope.ScheduleForDateNew.date).month(), moment($scope.ScheduleForDateNew.date).date(), moment($scope.ScheduleForDateNew.date).hour(), moment($scope.ScheduleForDateNew.date).minutes(), 0);
            var todatetime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), 0);

            if (todatetime > fromdatetime) { swal("The v-call can't be scheduled for the previous date/Time."); return; };

            var objVM = {
                FromDate: formatted_date(fromdatetime),
                FromTime: formatted_time(fromdatetime)
            }
            var leftDiv = document.createElement("div"); //Create left div
            leftDiv.id = "left"; //Assign div id
            leftDiv.setAttribute("style", "float:left; width:66.5%; line-height: 26px; text-align:left; font-size:12pt; padding-left:8px; height:26px;"); //Set div attributes
            leftDiv.style.background = "#FF0000";
            var a = document.createElement('a');
            a.href = 'google.com';

                    if(multipleOrderWorkList){                       
                            $scope.isHighPriority = true;
                            $scope.dateTimeLocalUTCCallScheduled = new Date((objVM.FromDate+' '+objVM.FromTime+':00').replace(/-/g,"/"));// moment.utc(objVM.FromDate+' '+objVM.FromTime).format('M/D/YYYY HH:mm')
                            $scope.dateTimeLocalUTCCallScheduled = moment.utc($scope.dateTimeLocalUTCCallScheduled).format("MM-DD-YYYY HH:mm");
                            $scope.roomName = $scope.currFirstName.trim() +" "+ $scope.currLastName.trim()+' '+ $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                            var dicomViewerURL = multipleOrderWorkList.DicomViewerURL != undefined ? multipleOrderWorkList.DicomViewerURL : '';
                            var dicomViewer = multipleOrderWorkList.DicomViewer != undefined ? multipleOrderWorkList.DicomViewer : '';
                            var site = multipleOrderWorkList.Site != null ? multipleOrderWorkList.Site :'';
                        a.textContent = "Call has been scheduled to consult a study for the below procedure. \n Location : " + multipleOrderWorkList.Location +
                            "\n DOS : " + moment.utc(multipleOrderWorkList.FormattedOrderDate).format("MM-DD-YYYY HH:mm") +
                            " \n Accession : " + multipleOrderWorkList.Accession +
                            " \n MRN : " + multipleOrderWorkList.PatientMRN +
                            " \n Patient Name : " + multipleOrderWorkList.PatientName +
                            " \n Gender : " + multipleOrderWorkList.PatientGender +
                            " \n DOB : " + moment.utc(multipleOrderWorkList.PatientDOB).format("MM-DD-YYYY") +
                            " \n Modality : " + multipleOrderWorkList.Modality +
                            " \n Type : " + multipleOrderWorkList.PatientClass +
                            " \n Procedure Desc : " + multipleOrderWorkList.ProcedureDesc +
                            " \n Ordering Physician : " + multipleOrderWorkList.OrderingPhysician +
                            " \n Dicom Viewer URL : " + dicomViewerURL +
                            " \n Dicom Viewer : " + dicomViewer +
                            " \n Site : " + site +
                            "\n in the video chat room \n " + $scope.roomName +
                            "\n Please join on this time. \n" + $scope.dateTimeLocalUTCCallScheduled;
                            $scope.message = a.textContent;
                            $scope.sendMessage($scope.message);
                            $scope.message = '';
                            multipleOrderWorkList=null;
                            $scope.closeKendoScheduleLater();
                            $scope.isHighPriority = false;                   
                    }
                    else
                    { //moment().utc().format('MM/DD/YYYY HH:mm:ss')
                        $scope.dateTimeLocalUTCCallScheduled = new Date((objVM.FromDate+' '+objVM.FromTime+':00').replace(/-/g,"/"));//moment.utc(Date((objVM.FromDate+' '+objVM.FromTime).replace(/ /g,'T'))) //moment.utc((objVM.FromDate+' '+objVM.FromTime).replace(/ /g,'T')).format('M/D/YYYY HH:mm')
                        $scope.dateTimeLocalUTCCallScheduled = moment.utc($scope.dateTimeLocalUTCCallScheduled).format("MM-DD-YYYY HH:mm")
                        $scope.roomName = $scope.currFirstName.trim() +" "+ $scope.currLastName.trim()+' '+ $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                        a.textContent = "Call has been scheduled \n in the video chat room \n " + $scope.roomName + "\n Please join on this time. \n" + $scope.dateTimeLocalUTCCallScheduled;
                        leftDiv.appendChild(a); 
                        $scope.isHighPriority = true;
                        $scope.message = leftDiv.textContent;
                        $scope.sendMessage($scope.message);
                        $scope.message = '';
                        $scope.closeKendoScheduleLater();
                        $scope.isHighPriority = false;
                    }
                }
                else{
                    reScheduledCallMessage();
                }
          }

        var formatted_date = function (date) {
            if (date != null) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero 
                var y = date.getFullYear();
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        var formatted_time = function (date) {

            if (date != null) {
                var h = ("0" + (date.getHours())).slice(-2); // in javascript month start from 0.
                var m = ("0" + date.getMinutes()).slice(-2); // add leading zero             
                return h + ':' + m;
            }
            else {
                return null;
            }
        };

        //const participantConnected = (participant) => {
        function participantConnected(participant) {
            var participantDiv = document.createElement('div');
            participantDiv.setAttribute('id', participant.sid);
            participantDiv.setAttribute('class', 'participant');

            var tracksDiv = document.createElement('div');
            tracksDiv.setAttribute('class', 'pos-rel');
            participantDiv.appendChild(tracksDiv);

            var labelDiv = document.createElement('div');
            labelDiv.textContent = participant.identity;
            labelDiv.setAttribute('class', 'nameLabel');
            // Add unique SID to the name tag
            labelDiv.setAttribute('id', 'N_' + participant.sid);
            //labelDiv.innerHTML = connectedUseName;
            participantDiv.appendChild(labelDiv);

            container.appendChild(participantDiv);

            //tracksDiv.appendChild($scope.spanFullScreen);
            // participant.tracks.forEach(publication => {
            //   if (publication.isSubscribed) {
            //     trackSubscribed(tracksDiv, publication.track);
            //   }
            // });
            participant.tracks.forEach(function (publication) {
                if (publication.isSubscribed) {
                    trackSubscribed(tracksDiv, publication.track);
                }
            });
            participant.on('trackSubscribed', function (track) { trackSubscribed(tracksDiv, track) });
            participant.on('trackUnsubscribed', trackUnsubscribed);
            //updateParticipantCount();
        };

        function participantDisconnected(participant) {
            document.getElementById(participant.sid).remove();
            //updateParticipantCount();
        };

        function trackSubscribed(div, track) {
            var trackElement = track.attach();
            trackElement.addEventListener('click', function () { zoomTrack(trackElement); });
            div.appendChild(trackElement);
        };

        function trackUnsubscribed(track) {
            track.detach().forEach(function (element) { element.remove() });
        };
        function zoomTrack(trackElement) {
            if (!trackElement.classList.contains('participantZoomed')) {
                // zoom in
                container.childNodes.forEach(function (participant) {
                    if (participant.className == 'participant') {
                        participant.childNodes[0].childNodes.forEach(function (track) {
                            if (track === trackElement) {
                                track.classList.add('participantZoomed');
                                track.parentNode.classList.add('participantZoomed');
                                track.parentNode.classList.remove('pos-rel');
                                //document.querySelector('.vidCallFullScrIcon').classList.remove('participantHidden');
                                //document.querySelector('.vidCallFullScrIcon').setAttribute('title', 'Exit full screen');
                                //if (track.parentNode.classList.contains('participantZoomed')) {
                                //    document.querySelector('.vidCallFullScrIcon').classList.add('icon-flscrn');
                                //}
                            }
                            else {
                                track.classList.add('participantHidden')
                            }
                        });
                        participant.childNodes[1].classList.add('participantHidden');
                    }
                });
            }
            else {
                // zoom out
                container.childNodes.forEach(function (participant) {
                    if (participant.className == 'participant') {
                        participant.childNodes[0].childNodes.forEach(function (track) {
                            if (track === trackElement) {
                                track.classList.remove('participantZoomed');
                                track.parentNode.classList.remove('participantZoomed');
                                track.parentNode.classList.add('pos-rel');
                                //document.querySelector('.vidCallFullScrIcon').setAttribute('title', 'Full screen')
                                //if (document.querySelector('.vidCallFullScrIcon').classList.contains('icon-flscrn')) {
                                //    document.querySelector('.vidCallFullScrIcon').classList.remove('icon-flscrn');
                                //}
                            }
                            else {
                                track.classList.remove('participantHidden');
                            }
                        });
                        participant.childNodes[1].classList.remove('participantHidden');
                    }
                });
            }
        };
        //screen share code.
        function shareScreenHandler() {
            //event.preventDefault();
            if (!screenTrack) {
                navigator.mediaDevices.getDisplayMedia().then(function (stream) {
                    $scope.window.minimize();
                    screenTrack = new Twilio.Video.LocalVideoTrack(stream.getTracks()[0]);
                    room.localParticipant.publishTrack(screenTrack);
                    //shareScreen.innerHTML = 'Stop sharing';
                    angular.element('#share_screen').removeClass('sharescreen-on');
                    angular.element('#share_screen').addClass('sharescreen-off').attr("title", "Stop share");
                    screenTrack.mediaStreamTrack.onended = function () { shareScreenHandler() };
                }).catch(function (er) {
                    //swal('Could not share the screen.');
                    toaster.error({ body: "Could not share the screen."  });
                });
            }
            else {
                $scope.window.restore();
                $('.kwindo-RadSceureVCall').removeClass('modalSeVCall sm-vidCallSection');
                room.localParticipant.unpublishTrack(screenTrack);
                screenTrack.stop();
                screenTrack = null;
                //shareScreen.innerHTML = 'Share screen';
                angular.element('#share_screen').addClass('sharescreen-on').attr("title", "Share screen");;
                angular.element('#share_screen').removeClass('sharescreen-off');
            }
        };


        function mute(opts) {
            if (!room || !room.localParticipant)
                throw new Error('You must be connected to a room to mute tracks.');

            if (opts.audio) {
                angular.element('#mute-unmute-audio-button').removeClass('mic-on').attr("title", "Mute audio");
                angular.element('#mute-unmute-audio-button').addClass('mic-off').attr("title", "Unmute audio");
                room.localParticipant.audioTracks.forEach(
                    function (publication) { publication.track.disable() }
                );
            }

            if (opts.video) {
                angular.element('#mute-unmute-video-button').removeClass('video-on').attr("title", "Mute video");
                angular.element('#mute-unmute-video-button').addClass('video-off').attr("title", "Unmute video");
                room.localParticipant.videoTracks.forEach(
                    function (publication) { publication.track.disable() }
                );
            }
        }
        function unmute(opts) {
            if (!room || !room.localParticipant)
                throw new Error('You must be connected to a room to unmute tracks.');

            if (opts.audio) {
                angular.element('#mute-unmute-audio-button').removeClass('mic-off').attr("title", "Unmute audio");
                angular.element('#mute-unmute-audio-button').addClass('mic-on').attr("title", "Mute audio");
                room.localParticipant.audioTracks.forEach(
                    function (publication) { publication.track.enable() }
                );
            }

            if (opts.video) {
                angular.element('#mute-unmute-video-button').removeClass('video-off').attr("title", "Unmute video");
                angular.element('#mute-unmute-video-button').addClass('video-on').attr("title", "Mute video");
                room.localParticipant.videoTracks.forEach(
                    function (publication) { publication.track.enable() }
                );
            }
        }

        function onMuteUnmuteClickAudios() {
            onMuteUnmuteClick(TrackType.Audios)
        }

        function onMuteUnmuteClickVideos() {
            onMuteUnmuteClick(TrackType.Videos)
        }

        function onMuteUnmuteClick(trackType) {
            if (trackType === TrackType.Audios) {
                var opts = { audio: true, video: false };

                isAudioMuted
                    ? unmute(opts)
                    : mute(opts);

                isAudioMuted = !isAudioMuted;

                //isAudioMuted
                //    ? muteUnmuteAudioButton.textContent = 'Unmute Audio'
                //    : muteUnmuteAudioButton.textContent = 'Mute Audio';
                isAudioMuted
                    ? angular.element('#mute-unmute-audio-button').addClass('mic-off').attr("title", "Unmute audio")
                    : angular.element('#mute-unmute-audio-button').addClass('mic-on').attr("title", "Mute audio");
            }

            if (trackType === TrackType.Videos) {
                var opts = { audio: false, video: true };

                isVideoMuted
                    ? unmute(opts)
                    : mute(opts);

                isVideoMuted = !isVideoMuted;

                //isVideoMuted
                //    ? muteUnmuteVideoButton.textContent = 'Unmute Video'
                //    : muteUnmuteVideoButton.textContent = 'Mute Video';
                isVideoMuted
                    ? angular.element('#mute-unmute-video-button').addClass('video-off').attr("title", "Unmute video")
                    : angular.element('#mute-unmute-video-button').addClass('video-on').attr("title", "Mute video");
            }
        }

        buttonJoin.addEventListener('click', connectButtonHandler);
        shareScreen.addEventListener('click', shareScreenHandler);
        muteUnmuteAudioButton.addEventListener('click', onMuteUnmuteClickAudios);
        muteUnmuteVideoButton.addEventListener('click', onMuteUnmuteClickVideos);

        $scope.shareVideoCallDetails = function () {
            swal({
                title: "Are you sure, you want to allow another user to join the Radflow Secure V-Call?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true

            },
                function (isConfirm) {
                    if (isConfirm) {
                        ShareRoomDetails();
                    }
                });
        }
        function ShareRoomDetails() {
            $scope.isChatMenuActive = true;
            $scope.isShowChatWindow = false;
            $scope.isShareChatLink = true;
            angular.element('.chatsec .control-sidebar').addClass('addUsrZin');
        }
        $scope.scheduledCallJoin = function (currentMgs) {
            chatService.getVideoConferencingIDToUser(currentMgs.Id).then(function (result) {
                $scope.videoConferencingId = result;
                chatService.checkVideoCallLinkIsExpired($scope.videoConferencingId).then(function (result) {
                    if (result) {
                        swal('This video call link is expired.')
                        return;
                    }
                    else {
                        var today = new Date();
                        var messageScheduleTime = currentMgs.Message.split(/\r?\n/);
                        var messageScheduled = messageScheduleTime.at(-1)
                        var dateTimeLocalUTCCallScheduled = new Date((messageScheduled + ':00').replace(/-/g, "/"));
                        var fromdatetime = new Date(dateTimeLocalUTCCallScheduled.getFullYear(), dateTimeLocalUTCCallScheduled.getMonth(), dateTimeLocalUTCCallScheduled.getDate(), dateTimeLocalUTCCallScheduled.getHours(), dateTimeLocalUTCCallScheduled.getMinutes(), 0);
                        var todayDatetime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), 0);

                        if (fromdatetime > todayDatetime) { swal("The scheduled v-call can't be started for the current date/Time."); return; };
                        // if (todayDatetime > fromdatetime) {
                        //     console.log(`${todayDatetime} is less than ${fromdatetime}`);
                        //   } else if (todayDatetime > fromdatetime) {
                        //     console.log(`${todayDatetime} is greater than ${fromdatetime}`);
                        //   } else {
                        //     console.log(`Both dates are equal`);
                        //   }
                        // if(messageScheduleTime.at(-3) != undefined)
                        //     generateTwilioAcccessToken(messageScheduleTime.at(-3).trim(), true,currentMgs);
                        // else
                        //     generateTwilioAcccessToken(messageScheduleTime.at(-1).trim(), true,currentMgs);

                        if (messageScheduleTime.at(-3) != undefined) {
                            if (currentMgs.Message.includes('wants to consult a study for the below procedure'))
                                generateTwilioAcccessToken(messageScheduleTime.at(-2).trim(), true, currentMgs);
                            else
                                generateTwilioAcccessToken(messageScheduleTime.at(-3).trim(), true, currentMgs);
                        }
                        else
                            generateTwilioAcccessToken(messageScheduleTime.at(-1).trim(), true,currentMgs);
                   }
               })
            })
        }

        $scope.reScheduledCall = function (currentMgs){
            $scope.oldRescheduledMsg = currentMgs;
            chatService.getVideoConferencingIDToUser(currentMgs.Id).then(function(result){
                $scope.videoConferencingId = result;
               chatService.checkVideoCallLinkIsExpired($scope.videoConferencingId).then(function(result){
                   if(result){
                       swal('This video call link is expired, so you can not reschedule the call.')
                       return;
                   }
                   else{
                    $scope.isRescheduled = true;
                    $scope.ScheduleForDateNew = {};
                    $scope.schedulelaterDlgOption = {
                        //width: "40%",
                        //height: "40%",
                        visible: false,
                        actions: [
                            "Minimize",                            
                            "Close"
                        ]
                    };                    
                    //$scope.ScheduleForTime=  new Date();
                    $scope.schedulelaterDlgOptionWindow.setOptions($scope.schedulelaterDlgOption);
                    //$scope.window.center();  // open dailog in center of screen
                    $scope.schedulelaterDlgOptionWindow.open();
                    angular.element('.svcall').parent().addClass('z-i-10007').removeClass('vcallheight');
                    $scope.schedulelaterDlgOptionWindow.title("Re-schedule RadFlow Secure V-Call Schedule Meeting");
                    }
               })
              
              })
        }	
        function reScheduledCallMessage(){
            //console.log($scope.videoConferencingId)
            expirePreviousScheduledVideoCall($scope.oldRescheduledMsg);
            var today = new Date();
            var fromdatetime = new Date(moment($scope.ScheduleForDateNew.date).year(), moment($scope.ScheduleForDateNew.date).month(), moment($scope.ScheduleForDateNew.date).date(), moment($scope.ScheduleForDateNew.date).hour(), moment($scope.ScheduleForDateNew.date).minutes(), 0);
            var todatetime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), 0);
            
            if (todatetime > fromdatetime) { swal("The v-call can't be scheduled for the previous date/Time."); return; };

            var objVM = { 
                    FromDate: formatted_date(fromdatetime),
                    FromTime: formatted_time(fromdatetime)
            }
                var leftDivreScheduled = document.createElement("div"); //Create left div
                leftDivreScheduled.id = "leftDivreScheduled"; //Assign div id
                leftDivreScheduled.setAttribute("style", "float:left; width:66.5%; line-height: 26px; text-align:left; font-size:12pt; padding-left:8px; height:26px;"); //Set div attributes
                leftDivreScheduled.style.background =  "#FF0000";
                    var areScheduled = document.createElement('areScheduled');
                    areScheduled.href =  'google.com'; 

                    if($scope.oldRescheduledMsg.Message.includes('Call has been scheduled to consult a study for the below procedure.')){  
                            videoCallConvertToJsonObject($scope.oldRescheduledMsg.Message);
                            
                            $scope.isHighPriority = true;
                            $scope.dateTimeLocalUTCCallScheduled = new Date((objVM.FromDate+' '+objVM.FromTime+':00').replace(/-/g,"/"));// moment.utc(objVM.FromDate+' '+objVM.FromTime).format('M/D/YYYY HH:mm')
                            $scope.dateTimeLocalUTCCallScheduled = moment.utc($scope.dateTimeLocalUTCCallScheduled).format("MM-DD-YYYY HH:mm");
                            $scope.roomName = $scope.currFirstName.trim() +" "+ $scope.currLastName.trim()+' '+ $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                            var dicomViewerURL = $scope.selectedOrder.DicomViewerURL != undefined ? $scope.selectedOrder.DicomViewerURL : '';
                            var dicomViewer = $scope.selectedOrder.DicomViewer != undefined ? $scope.selectedOrder.DicomViewer : '';
                            var site = $scope.selectedOrder.Site != null ? $scope.selectedOrder.Site :'';
                            areScheduled.textContent = "Rescheduled!! Call has been scheduled to consult a study for the below procedure. \n Location : " + $scope.selectedOrder.Location + " \n DOS : " + moment.utc($scope.selectedOrder.OrderDate).format("MM-DD-YYYY HH:mm") +" \n Accession : " + $scope.selectedOrder.Accession + " \n MRN : " + $scope.selectedOrder.MRN + " \n Patient Name : " + $scope.selectedOrder.PatientName +  " \n Gender : " + $scope.selectedOrder.PatientGender +" \n DOB : " + moment.utc($scope.selectedOrder.PatientDOB).format("MM-DD-YYYY") + " \n Modality : " + $scope.selectedOrder.Modality +" \n Type : " + $scope.selectedOrder.PatientClass + " \n Procedure Desc : " + $scope.selectedOrder.ProcedureDesc +" \n Ordering Physician : " + $scope.selectedOrder.OrderingPhysician +" \n Dicom Viewer URL : " + dicomViewerURL +" \n Dicom Viewer : " + dicomViewer +" \n Site : " + site + " \n in the video chat room \n " + $scope.roomName + "\n Please join on this time. \n" + $scope.dateTimeLocalUTCCallScheduled;
                            $scope.message = areScheduled.textContent;
                            $scope.sendMessage($scope.message);
                            $scope.message = '';
                            $scope.oldRescheduledMsg=null;
                            $scope.closeKendoScheduleLater();
                            $scope.isHighPriority = false; 
                            $scope.isRescheduled = false;                  
                    }
                    else
                    { //moment().utc().format('MM/DD/YYYY HH:mm:ss')
                        $scope.dateTimeLocalUTCCallScheduled = new Date((objVM.FromDate+' '+objVM.FromTime+':00').replace(/-/g,"/"));//moment.utc(Date((objVM.FromDate+' '+objVM.FromTime).replace(/ /g,'T'))) //moment.utc((objVM.FromDate+' '+objVM.FromTime).replace(/ /g,'T')).format('M/D/YYYY HH:mm')
                        $scope.dateTimeLocalUTCCallScheduled = moment.utc($scope.dateTimeLocalUTCCallScheduled).format("MM-DD-YYYY HH:mm")
                        $scope.roomName = $scope.currFirstName.trim() +" "+ $scope.currLastName.trim()+' '+ $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                        areScheduled.textContent = "Rescheduled!! Call has been scheduled \n in the video chat room \n " + $scope.roomName + " \n Please join on this time. \n" + $scope.dateTimeLocalUTCCallScheduled;
                        leftDivreScheduled.appendChild(areScheduled); 
                        $scope.isHighPriority = true;
                        $scope.message = leftDivreScheduled.textContent;
                        $scope.sendMessage($scope.message);
                        $scope.message = '';
                        $scope.closeKendoScheduleLater();
                        $scope.isHighPriority = false;
                        $scope.oldRescheduledMsg=null;
                        $scope.isRescheduled = false;
                    }
        }
        function expirePreviousScheduledVideoCall(obj){
            chatService.expirePreviousScheduledVideoCall(obj).then(function(result){
                
            })
        }

        $scope.OpenExamVideoConf = function (strJson) {
            videoCallConvertToJsonObject(strJson)
            //var patObj = JSON.parse(strJson);

            var accession = $scope.selectedOrder.Accession.trim();
            var patientMRN = $scope.selectedOrder.MRN.trim();
            var dicomViewer = $scope.selectedOrder.DicomViewer.trim();
            var DicomViewerURL = $scope.selectedOrder.DicomViewerURL.trim();
            var Site = $scope.selectedOrder.Site.trim();
            if (dicomViewer == '') {
                dicomViewer = "CI-VIEWER";
            }
            if (dicomViewer == "CI-VIEWER") {
                if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                    window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
                }
                else {
                    windowHandler.openByPreference(__env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 1), "CI-VIEWER-1", 1000, "CI-VIEWER-1", "", false);
                    //windowHandler.openByPreference(APP_CONSTANTS.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 2), "CI-VIEWER-2", 1000, "", false);
                }
            }
            else if (dicomViewer == "KONICA" || dicomViewer == "KONICATEST" || dicomViewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                $scope.konica_RadFlow = windowHandler.openByPreference(__env._environment.config.konicaBaseURL.replace("@MRN", patientMRN).replace("@ACCESSION", accession).replace("@VIEWER", dicomViewer), "KONICA", 100, "KONICA", "noreferrer");
            }
            else if (dicomViewer == "SYNAPSE") {

                if (Site.toUpperCase() == 'DECATUR') {
                    accession = accession.toUpperCase().replace('WHS', '');
                }
                RCService.OpenImage({ requestEvent: "openimage", imageRequestDetails: { pacsURL: DicomViewerURL, accessionNumber: accession } })
            }

        }
        //#endregionend

        var activeChatMenuBar = $rootScope.$on('activeChatMenuBar', function (name, isChatMenuActive) {
            angular.element('.svcall').parent().addClass('z-i-10007');
            $scope.isChatMenuActive = isChatMenuActive;
            if ($scope.isChatMenuActive && $scope.UserName) {
                $scope.UserName = null;
                $scope.isShowChatWindow = false;
                UserListPageNum = 1;
                GetAllUsers();
            }
            if ($scope.userList && $scope.userList.length == 0 && $scope.isChatMenuActive) {
                GetAllUsers();
            }
            if (!$scope.isChatMenuActive) {
                $scope.isShowChatWindow = false;
                $scope.selectedUserId = 0;
                scrollPositionSetMessageList();
            }
            else {
                scrollPositionSetMessageList();
            }

        });
        var multipleOrderWorkList;
        // New Code
        var activeChatMenuBarformWorkList = $rootScope.$on('activeChatMenuBarformWorkList', function (name, isChatMenuActive, worklistOrderData) {
            if ($scope.userList != null && $scope.userList.length > 0) {
                VideoCallConsultExamSendMessage(worklistOrderData);
            }
            else {
                $q.all([
                    GetAllUsers()
                ]).then(function (data) {
                    VideoCallConsultExamSendMessage(worklistOrderData);

                });
            }
        });

        // Old Code
        // var activeChatMenuBarformWorkList = $rootScope.$on('activeChatMenuBarformWorkList', function (name, isChatMenuActive,worklistOrderData) {
        //     $scope.isChatMenuActive = isChatMenuActive;
        //     $scope.isShowChatWindow = false;
        //     multipleOrderWorkList = worklistOrderData;
        //     if ($scope.userList && $scope.userList.length == 0) { GetAllUsers(); }
        // });

        function VideoCallConsultExamSendMessage(mssgWithPatientDetails) {
            multipleOrderWorkList = mssgWithPatientDetails.selectedOrder;
            $scope.isPrivateUserChat = true;
            $scope.isShowChatWindow = true;
            $scope.isHighPriority = mssgWithPatientDetails.isHighPriority;
            if ($scope.selectedUserObject == null || ($scope.selectedUserObject != null && $scope.selectedUserObject.Id != mssgWithPatientDetails.toUserId)) {
                $scope.selectedUserObject = _.find($scope.userList, { 'Id': mssgWithPatientDetails.toUserId });
                if (!$scope.selectedUserObject) {
                    var filter = {
                        PageNum: '1',
                        PageSize: '25',
                        Id: mssgWithPatientDetails.toUserId,
                        NewMessage: true,
                    }
                    chatService.GetUserList(filter).then(function (result) {
                        $scope.selectedUserObject = result[0];
                        if (!$scope.UserName)
                            $scope.userList.unshift(result[0]);
                        getUserMessages($scope.selectedUserObject);
                    });
                }
                else {
                    getUserMessages($scope.selectedUserObject);
                    $scope.selectedUserId = $scope.selectedUserObject.Id;
                }
            }
            else {
                $scope.openVideoChat($scope.selectedUserObject.FirstName + ' ' + $scope.selectedUserObject.LastName, true, '');
                $scope.selectedUserId = $scope.selectedUserObject.Id;
            }

            scrollPositionSetMessageList();
            $scope.maxChatWindow();
        }
        var activeChatMenuBarshareExamComponent = $rootScope.$on('activeChatMenuBar:shareExamComponent', function (name, isChatMenuActive) {
            $scope.isChatMenuActive = isChatMenuActive;
            if ($scope.isChatMenuActive && $scope.UserName) {
                $scope.UserName = null;
                $scope.isShowChatWindow = false;
                UserListPageNum = 1;
                GetAllUsers();
            }
            else {
                $scope.isShowChatWindow = false;
                if ($scope.userList && $scope.userList.length == 0) {
                    UserListPageNum = 1;
                    if ($scope.isChatMenuActive) {
                        GetAllUsers();
                    }
                }
                scrollPositionSetMessageList();
            }
            $rootScope.$emit('activeChatMenuBar:Chat', $scope.isChatMenuActive);
        });

        var activeChatMenuBarSendMessage = $rootScope.$on('activeChatMenuBar:SendMessage', function (name, isChatMenuActive, mssgWithPatientDetails) {
            /*var ToUserID;*/
            if ($scope.userList != null && $scope.userList.length > 0) {
                ShareExamSendMessage(mssgWithPatientDetails);
            }
            else {
                $q.all([
                    GetAllUsers()
                ]).then(function (data) {
                    //message come from shareExamComponent with required patientDetails
                    //var message = mssgWithPatientDetails.message + "|SHAREEXAMOBJ|" + JSON.stringify(mssgWithPatientDetails.patientDetails);
                    //ToUserID = mssgWithPatientDetails.toUserId;
                    //$scope.selectedUserObject = _.find($scope.userList, { 'Id': ToUserID });
                    //$scope.message = message;
                    //$scope.isPrivateUserChat = true;
                    //$scope.isHighPriority = mssgWithPatientDetails.isHighPriority;
                    //$scope.sendMessage(message);
                    ////getUserMessages($scope.selectedUserObject);
                    //ShareExamSendMessage(mssgWithPatientDetails); 
                    ShareExamSendMessage(mssgWithPatientDetails);
                });
            }
            $scope.scrolllToBottom = true;
            $scope.DeleteMessageScrollPosition = false;
        });
        var ChatMessageListCount = $rootScope.$on('activeChatMenuBar:ChatMessageList', function (Name, ChatMessageListChatCom) {
            $timeout(function () { $scope.ChatMessageList = ChatMessageListChatCom; }, 1000);
        });

        function ShareExamSendMessage(mssgWithPatientDetails) {
            var message = mssgWithPatientDetails.message + "|SHAREEXAMOBJ|" + JSON.stringify(mssgWithPatientDetails.patientDetails);
            //ToUserID = mssgWithPatientDetails.toUserId;
            $scope.message = message;
            $scope.isPrivateUserChat = true;
            $scope.isShowChatWindow = true;
            $scope.isHighPriority = mssgWithPatientDetails.isHighPriority;
            if ($scope.selectedUserObject == null || ($scope.selectedUserObject != null && $scope.selectedUserObject.Id != mssgWithPatientDetails.toUserId)) {
                $scope.selectedUserObject = _.find($scope.userList, { 'Id': mssgWithPatientDetails.toUserId });
                if (!$scope.selectedUserObject) {
                    var filter = {
                        PageNum: '1',
                        PageSize: '25',
                        Id: mssgWithPatientDetails.toUserId,
                        NewMessage: true,
                    }
                    chatService.GetUserList(filter).then(function (result) {
                        $scope.selectedUserObject = result[0];
                        if (!$scope.UserName)
                            $scope.userList.unshift(result[0]);
                        $scope.sendMessage(message);
                        getUserMessages($scope.selectedUserObject);
                    });
                }
                else {
                    $scope.sendMessage(message);
                    getUserMessages($scope.selectedUserObject);
                    $scope.selectedUserId = $scope.selectedUserObject.Id;
                }
            }
            else {
                $scope.sendMessage(message);
                $scope.selectedUserId = $scope.selectedUserObject.Id;
            }
            scrollPositionSetMessageList();
            $scope.maxChatWindow();
        }

        var disconnectVideoCall = $rootScope.$on('disconnectVideoCall', function (name, connected) {
            if (connected) {
                //logVideoCallEndTime();
                room = $sessionStorage.room;
                disconnect();
            }
        });
        $scope.$on('$destroy', function () {
            activeChatMenuBarformWorkList();
            activeChatMenuBar();
            activeChatMenuBarshareExamComponent();
            activeChatMenuBarSendMessage();
            AppHub.off('RadFlowChatAppHubEvent');
            disconnectVideoCall();
        });

        $scope.activeChatMenuBar = function () {
            $scope.isChatMenuActive = !$scope.isChatMenuActive;
            $scope.isShowChatWindow = false;
            $scope.selectedUserId = 0;
            if ($scope.UserName) {
                $scope.UserName = null;
                UserListPageNum = 1;
                $scope.userList = [];
                GetAllUsers();
            }
            scrollPositionSetMessageList();
            $rootScope.$emit('activeChatMenuBar:Chat', $scope.isChatMenuActive);
            angular.element('.chatsec .control-sidebar').removeClass('addUsrZin')
        }

        //chat's message box scroll to last last message when keypad comes up
        if (angular.element(window).width() < 768) {
            angular.element(document).ready(function () {
                angular.element('#message').focus(function () {
                    angular.element(this).parents(".chat-user-action-container").addClass('textAreaCliked');
                    angular.element(".textAreaCliked").siblings(".chat-history").find("#messageMe").addClass('scrollToLastDiv');
                    setTimeout(function () {
                        angular.element(".scrollToLastDiv").scrollTop(angular.element(".scrollToLastDiv").get(0).scrollHeight);
                    }, 200);
                });
            });
        }
        angular.element(document).ready(function () {
            angular.element('.modal-RadSceureVCall').parent().addClass('kwindo-RadSceureVCall');
        });
        $scope.minChatWindow = function () {
            $('.chat-inner').addClass("setchatsection");
            $('.chat-header').addClass("setchatheader");
            $scope.hideChatWindow = true;
        }

        $scope.maxChatWindow = function () {
            $('.chat-inner').removeClass("setchatsection");
            $('.chat-header').removeClass("setchatheader");
            $scope.hideChatWindow = false;
            if ($scope.scrolllToBottom) {
                var objDiv = document.getElementById("messageMe");
                objDiv.scrollTop = objDiv.scrollHeight;
                $scope.scrolllToBottom = false;
            }
        }

        function getUserMessages(obj) {
            var d = $q.defer();
            $rootScope.$broadcast("ChatReadCount", obj, "Read");
            $scope.isShowChatWindow = true;
            $scope.isPrivateUserChat = true;
            $scope.selectedUserObject = obj;
            $scope.selectedUserId = obj.Id;
            $scope.MessageList = [];
            MessageListPageNum = 1;
            $scope.isHighPriority = false;
            $scope.message = '';
            GetMessage().then(function (data) {
                if (obj.UnreadMsgCount > 0) {
                    ChangeReadStatus(obj.Id, $scope.currUserId);
                    obj.UnreadMsgCount = 0;
                }
                d.resolve();
            });
            return d.promise;
        }

        $scope.OpenExam = function (strJson) {
            var patObj = JSON.parse(strJson);
            var accession = patObj.Accession;
            var patientMRN = patObj.PatientMRN;
            var dicomViewer = patObj.DicomViewer;
            var DicomViewerURL = patObj.DicomViewerURL;
            var Site = patObj.Site;

            if (dicomViewer == "CI-VIEWER") {
                if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                    window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
                }
                else {
                    windowHandler.openByPreference(__env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 1), "CI-VIEWER-1", 1000, "CI-VIEWER-1", "", false);
                    //windowHandler.openByPreference(APP_CONSTANTS.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 2), "CI-VIEWER-2", 1000, "", false);
                }
            }
            else if (dicomViewer == "KONICA" || dicomViewer == "KONICATEST" || dicomViewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                $scope.konica_RadFlow = windowHandler.openByPreference(__env._environment.config.konicaBaseURL.replace("@MRN", patientMRN).replace("@ACCESSION", accession).replace("@VIEWER", dicomViewer), dicomViewer, 100, dicomViewer, "noreferrer");
            }
            else if (dicomViewer == "SYNAPSE") {

                if (Site.toUpperCase() == 'DECATUR') {
                    accession = accession.toUpperCase().replace('WHS', '');
                }
                RCService.OpenImage({ requestEvent: "openimage", imageRequestDetails: { pacsURL: DicomViewerURL, accessionNumber: accession } })
            }

        }


        $scope.ViewPatientDetails = function (strJson, propName) {
            var patObj = JSON.parse(strJson);
            if (propName == "NAME") {
                return patObj.PatientName;
            }
            else if (propName == "MRN") {
                return patObj.PatientMRN;
            }
            else if (propName == "ACCESSION") {
                return patObj.Accession;
            }
        }
        $scope.LastMessageTimeStamp = function (MessageDT) {
            var localDate = new moment();
            var msgdt = moment.utc(MessageDT).local();
            switch (localDate.diff(msgdt, 'days')) {
                case 0:
                    return msgdt.format("HH:mm");
                    break;
                case 1:
                    return "Yesterday";
                    break;
                case 2: case 3: case 4: case 5: case 6:
                    return msgdt.format('dddd')
                    break;
                default:
                    return msgdt.format('MM/DD')
            }

        }
        $scope.readMore = function (messageObj) {
            if (messageObj.readMoreTxt == 'Read More') {
                messageObj.numLimit = messageObj.Message.length;
                messageObj.readMoreTxt = 'Read Less';
            } else {
                messageObj.numLimit = numLimit;
                messageObj.readMoreTxt = 'Read More';
            }
        };
        // chat bottom button
        document.getElementById("chat-bottom-btn").style.display = "none";
        var mybutton = document.getElementById("chat-bottom-btn");
        angular.element(document.querySelector('.chat-history-inner')).bind('scroll', function () {
            $scope.scrollFunction();
        });
        $scope.scrollFunction = function () {
            if (Math.abs(document.getElementById('messageMe').scrollHeight - document.getElementById('messageMe').clientHeight - document.getElementById('messageMe').scrollTop) < 1) {
                mybutton.style.display = "none";
            } else {
                mybutton.style.display = "block";
            }
        }
        $scope.topFunction = function () {
            var objDiv = document.getElementById("messageMe");
            objDiv.scrollTop = objDiv.scrollHeight;
        }
        function scrollPositionSetMessageList() {
            var objDiv = document.getElementById("UserLsitID");
            objDiv.scrollTop = 0;
            ShareExamscrollPosition = true;
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('BlurAdmin.theme.components')
        .filter('utcToLocal', utcToLocal);


    function utcToLocal($filter) {
        return function (utcDateString, format) {
            if (!utcDateString) {
                return;
            }

            // append 'Z' to the date string to indicate UTC time if the timezone isn't already specified
            if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
                utcDateString += 'Z';
            }

            return $filter('date')(utcDateString, format);
        };
    }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('chatlistUpdate', {
            templateUrl: 'app/theme/components/chat-list-update/chatlistupdate.html',
            bindings: {

            },
            controller: ChatListUpdateController
        });

    /** @ngInject */
    function ChatListUpdateController($scope, $rootScope, $document, chatService, AccountManagerService, $state, $sessionStorage, AppHubService, $q, $timeout, windowHandler, APP_CONSTANTS, RCService, $filter, toaster, ProfileService, __env, RuleService, uuidv4, WorklistService, CommonService, SharedService) {
        //var TwilioVideo = Twilio.Video;
        // #region Variables
        var AppHub;
        var parser = new UAParser();

        $scope.browser = parser.getBrowser().name;
        $scope.currState = $state.current.name;
        $scope.currUserId = $sessionStorage.currentUserData.userId;
        $scope.currFirstName = $sessionStorage.currentUserData.FirstName;
        $scope.currLastName = $sessionStorage.currentUserData.LastName;
        $scope.isHighPriority = false;
        $scope.isShowChatWindow = false;
        $scope.selectedUserId = "0";
        var UserListPageNum = 1;
        var MessageListPageNum = 1;
        var PageSize = 25;
        $scope.userList = [];
        $scope.MessageList = [];
        $scope.scrolllToBottom = false;
        var ShareExamscrollPosition = false;
        $scope.DeleteMessageScrollPosition = false;
        $scope.readMoreTxt = "Read More";
        var numLimit = 160;
        $scope.isShareChatLink = false;
        $scope.EnterKeyFlag = false;
        $scope.UserRoleTab = "All";
        $scope.pinnedUserList = [];
        $scope.ContextMenuSelectedUser = {};
        var pinnedUsersCount = 0;
        $scope.isToUserDetailsVisible = false;
        $scope.isCursorOnPopover = false;
        var AllUsers = [];
        var EditedRow = {};
        var LastOpenedOrder = null;

        $scope.DataObject = {
            MasterData: {},
            SelectedValues: {},
            showAssignRadiologistCmp: { value: false },
            isAddMemberVisible: { value: false },
            isEditGroupTitleVisible: { value: false },
            AssignUserText: "Add Members",
            GroupDetails: { GroupName: null, SelectedRadiologists: [] },
            BtnText: 'Add',
            isSaveEditBtnDisable: false,
            CurrentUserRoles: $sessionStorage.currentUserData.userRoles,
            currentUser: { Id: $sessionStorage.currentUserData.userId },
            SelectedData: {},
            ShowReport: false,
            SpecialGroupIDs: [],
            CurrentUserEmail: $sessionStorage.currentUserData && $sessionStorage.currentUserData.EmailId ? $sessionStorage.currentUserData.EmailId.toLowerCase() : null,
            SpecialUserEmailIDs: $sessionStorage.SpecialGroupEmailIDs,
            EnableRowsForSelectedTenants: null,
        };
        var Order = null;
        var TimeoutList = [];
        var OpenStudyOrder = null;
        var OpenOrder = {};
        var halfScale = $(window).width() < 1199;
        // Initialize other required variables
        $scope.LastOpenedOrder = null;
        $scope.NativeMessageResponseReportStatus = null;
        $scope.selectedUserObject = null;
        // #endregion Variables

        // #region PrelimRad masking helpers
        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function _maskName(last, first, roles, id) {
            if (_isSelf(id)) return (last || '') + ', ' + (first || '');
            return _hasPrelimRad(roles) ? '' : (last || '') + ', ' + (first || '');
        }
        function _memberHasPrelimRad(user) {
            var roles = user.UserRoles || user.Roles;
            if (roles) return _hasPrelimRad(roles);
            var userId = (user.Id || user.UserID || '').toLowerCase();
            var rad = _.find($scope.RadiologistsFullSet, function (r) {
                return (r.Id || '').toLowerCase() === userId;
            });
            return rad ? _hasPrelimRad(rad.UserRoles || rad.Roles) : false;
        }
        function isVisibleMember(user) {
            if (!user || !user.Id) return false;
            if (_isSelf(user.Id || user.UserID)) return true;
            return !_memberHasPrelimRad(user);
        }
        $scope.isVisibleMember = isVisibleMember;
        $scope.visibleGroupMemberCount = function (radiologists, excludeSelf) {
            return _.filter(radiologists || [], function (user) {
                if (!user || !user.Id) return false;
                if (excludeSelf && user.Id === $scope.currUserId) return false;
                return isVisibleMember(user);
            }).length;
        };
        $scope.maskName = _maskName;
        $scope.maskInitials = function (last, first, roles, id) {
            if (_isSelf(id)) return (last || '').substring(0, 1).toUpperCase() + (first || '').substring(0, 1).toUpperCase();
            return _hasPrelimRad(roles) ? '' : (last || '').substring(0, 1).toUpperCase() + (first || '').substring(0, 1).toUpperCase();
        };
        // #endregion PrelimRad masking helpers

        // #region funcitons
        function init() {
            $scope.isChatMenuActive = true;
            intiAppHub();
            windowHandler.inIt();
            GetAllUserByTenant();
            GetLookupByType();
            $scope.DataObject.MasterData.OrderStatus = WorklistService.GetOrderStatus();
            $scope.DataObject.MasterData.defaultWindowHeight = "85%";
            $scope.DataObject.MasterData.defaultWindowWidth = halfScale ? "97%" : "70%";
            if ($sessionStorage && $sessionStorage.EnableRowsForSelectedTenants) {
                $scope.DataObject.EnableRowsForSelectedTenants = $sessionStorage.EnableRowsForSelectedTenants.split(',');
            }
        }


        function GetAllUsers(IsPinnedUsers) {
            var d = $q.defer();
            if ($scope.showUsersLoader) {
                return;
            }
            var filter = {
                PageSize: PageSize,
                PageNum: UserListPageNum,
                Id: $scope.currUserId,
                UserName: $scope.UserName,
                NewMessage: $scope.NewMessage,
            }

            if ($scope.UserRoleTab != "All") {
                filter.UserRoles = ($scope.UserRoleTab == "Admin") ? "Admin,Super Admin" : $scope.UserRoleTab;
            }

            $scope.showUsersLoader = true;
            $q.all([
                getUsersList(filter),
                GetChatGroup()
            ]).then(function (data) {
                var result = data[0];
                $scope.DataObject.GroupList = [];
                _.each(data[1], function (groupItem) {
                    var LeftRadiologists = _.filter(groupItem.SelectedRadiologists, function (item) { return item.LeavingDate; });
                    var SelectedRadiologists = _.filter(groupItem.SelectedRadiologists, function (item) { return !item.LeavingDate; });
                    _.remove(LeftRadiologists, function (leftRad) {
                        var commonRadioLogist = _.find(SelectedRadiologists, function (selectedRad) {
                            return ((selectedRad.UserID
                                && leftRad.UserID
                                && selectedRad.UserID == leftRad.UserID)
                                || (selectedRad.Id
                                    && leftRad.Id
                                    && selectedRad.Id == leftRad.Id));
                        });

                        if (commonRadioLogist) {
                            return true;
                        }
                        return false;
                    });
                    groupItem.LeftRadioLogist = _.clone(LeftRadiologists);
                    groupItem.SelectedRadiologists = _.clone(SelectedRadiologists);
                    _.each(groupItem.SelectedRadiologists, function (useritem) {
                        useritem.ChatGroupID = groupItem.ChatGroupID;
                        var selectedUser = _.find($scope.RadiologistsFullSet, { Id: useritem.UserID });
                        if (selectedUser) {
                            useritem = _.merge(useritem, selectedUser);
                        }
                    });
                    //groupItem.LastMessage = getLastMessage(groupItem);
                    var createdByUser = _.find($scope.RadiologistsFullSet, { Id: groupItem.CreatedBy });
                    if (createdByUser) { groupItem.CreatedName = createdByUser.DisplayName; }
                    var modifiedByUser = _.find($scope.RadiologistsFullSet, { Id: groupItem.ModifiedBy });
                    if (modifiedByUser) { groupItem.ModifiedName = modifiedByUser.DisplayName; }
                    groupItem.UserIDs = _.map(groupItem.SelectedRadiologists, function (item) {
                        return item.Id;
                    });
                    $scope.DataObject.GroupList.push(groupItem);
                });
                result = _.filter(result, function (user) { return user.Id != $scope.currUserId; });
                if (UserListPageNum == 1) {
                    if (($scope.UserRoleTab == 'All')
                        || ($scope.UserRoleTab != 'Group')) {
                        if (result && result.length > 0) {
                            $scope.userList = _.uniqBy(_.filter(result, { IsPinnedUser: false }), 'Id');
                            $scope.pinnedUserList = _.uniqBy(_.filter(result, { IsPinnedUser: true }), 'Id');
                        }
                    }
                    if (($scope.UserRoleTab == 'Group')
                        || ($scope.UserRoleTab == 'All')) {
                        if ($scope.DataObject.GroupList && $scope.DataObject.GroupList.length > 0) {
                            var groupList = _.uniqBy(_.filter($scope.DataObject.GroupList, { IsPinnedGroup: false }), 'ChatGroupID');
                            $scope.userList = _.concat($scope.userList, groupList);
                            var pinnedGroupList = _.uniqBy(_.filter($scope.DataObject.GroupList, { IsPinnedGroup: true }), 'ChatGroupID');
                            $scope.pinnedUserList = _.concat($scope.pinnedUserList, pinnedGroupList);
                        }
                    }
                } else {
                    if (($scope.UserRoleTab == 'All')
                        || ($scope.UserRoleTab != 'Group')) {
                        if (result && result.length > 0) {
                            _.each(_.filter(result, { IsPinnedUser: false }), function (userItem) {
                                var userIndex = _.findIndex($scope.userList, function (item) { return item.Id && item.Id == userItem.Id });
                                if (userIndex != -1) {
                                    $scope.userList[userIndex] = userItem;
                                } else {
                                    $scope.userList.push(userItem);
                                }
                            });
                            _.each(_.filter(result, { IsPinnedUser: true }), function (userItem) {
                                var pinnedUserIndex = _.findIndex($scope.pinnedUserList, function (item) { return item.Id && item.Id == userItem.Id });
                                if (pinnedUserIndex != -1) {
                                    $scope.pinnedUserList[pinnedUserIndex] = userItem;
                                } else {
                                    $scope.pinnedUserList.push(userItem);
                                }
                            });
                        }
                    }
                }
                $scope.userList = sortUserList($scope.userList);
                $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                $scope.showUsersLoader = false;
                d.resolve();
            });

            return d.promise;
        };

        function getUsersList(filter) {

            var d = $q.defer();
            if ($scope.UserRoleTab != "Group") {
                chatService.GetUserList(filter).then(function (result) {
                    var usersList = _.uniqBy(result, 'Id');
                    d.resolve(usersList);
                }, function (err) { d.reject(); });
            }
            else {
                d.resolve([]);
            }
            return d.promise;

        }
        $scope.UserListNextPage = function () {
            if ($scope.UserRoleTab == 'Group') { return; }
            UserListPageNum += 1;
            GetAllUsers();
        };
        $scope.OnChangeFilter = function () {
            UserListPageNum = 1;

            $scope.userList = [];
            $scope.pinnedUserList = [];

            $scope.isShowChatWindow = false;

            GetAllUsers();
            //getPinnedUsers();
            scrollPositionSetMessageList();
        }
        init();
        function GetMessage() {
            var d = $q.defer();
            //$scope.MessageList = [];
            var curVM = {
                FromUserId: $scope.currUserId,
                ToUserId: $scope.isPrivateUserChat == true ? $scope.selectedUserObject.Id : null,
                ToGroupId: $scope.isPrivateUserChat == true ? null : $scope.selectedUserObject.Id,
                PageSize: PageSize,
                PageNum: MessageListPageNum,
                ChatGroupID: $scope.selectedUserObject.ChatGroupID,
            };
            $scope.showChatLoader = true;
            chatService.GetMessage(curVM).then(function (result) {
                if (result != null && result.length > 0) {
                    //$scope.MessageList = [];
                    _.each(result, function (obj) {
                        obj.GroupChatMessageReadUsers = _.map($scope.selectedUserObject.SelectedRadiologists, function (item) { return { ChatGroupID: $scope.selectedUserObject.ChatGroupID, UserID: item.UserID ? item.UserID : item.Id, IsRead: false }; });

                        obj.numLimit = numLimit;
                        if ((obj.Message.split('|SHAREEXAMOBJ|'))[0].length > numLimit) {
                            obj.isExpandable = true;
                            obj.readMoreTxt = "Read More";
                        }
                        else {
                            obj.isExpandable = false;
                        }
                        if (obj.Message.includes('Call has been scheduled')) {
                            obj.Message = obj.Message.replace(obj.Message.slice(-16), moment.utc((obj.Message.slice(-16) + ':00').replace(/-/g, "/")).local().format("MM-DD-YYYY HH:mm"));
                            //re.Message = re.Message.replace(re.Message.slice(-16),moment.utc(re.Message.slice(-16)+':00').local().format("MM-DD-YYYY HH:mm"));    
                            // $scope.MessageList.push(obj);
                        }

                        var user = _.find($scope.RadiologistsFullSet, { Id: obj.FromUserId });
                        if (user) {
                            obj.FromUserDisplayName = user.LastName + ', ' + user.FirstName;
                            obj.FromInitials = user.LastName.substring(0, 1).toUpperCase() + user.FirstName.substring(0, 1).toUpperCase();
                        }

                        obj = prepareGroupChatMessage(obj);
                        if (obj.Type != 'NEWGROUP' || !obj.Type) {
                            $scope.MessageList.push(obj);
                        }
                    });
                }
                $scope.MessageList = _.orderBy(_.uniqBy($scope.MessageList, 'Id'), ['MessageTime'], ['asc']);
                if ($scope.selectedUserObject
                    && $scope.selectedUserObject.LeftRadioLogist) {
                    var user = _.find($scope.selectedUserObject.LeftRadioLogist, { UserID: $scope.currUserId });
                    if (!user) { user = _.find($scope.selectedUserObject.LeftRadioLogist, { Id: $scope.currUserId }); }
                    if (user) {
                        $scope.MessageList = _.filter($scope.MessageList, function (item) {
                            var messageTime = new Date(item.MessageTime);
                            var leavingDate = new Date(user.LeavingDate);
                            return messageTime < leavingDate;
                        });
                    }
                }
                //$scope.MessageList = result;

                $scope.showChatLoader = false;
                updateReadMessage();
                d.resolve();
            }, function (err) {
                $scope.showChatLoader = false;
                d.resolve();
            });
            return d.promise;
        };

        $scope.GetMessageNextPage = function () {

            if ($scope.MessageList != null && $scope.MessageList.length > 0) {
                $scope.scrolllToBottom = false;
                $scope.DeleteMessageScrollPosition = false;
                MessageListPageNum += 1;
                GetMessage();
            }

            // ShareExamscrollPosition = false;
        }
        function updateReadMessage() {
            var messages = _.filter($scope.MessageList, { ReadMessage: true });
            if (messages) {
                _.each(messages, function (item) { item.ReadMessage = false; });
                var messageIndex = _.findLastIndex($scope.MessageList, { FromUserId: $scope.currUserId });
                if (messageIndex != -1) {
                    $scope.MessageList[messageIndex].ReadMessage = true;
                }
            }

        }

        function prepareGroupChatMessage(obj) {
            if (obj.Message.includes('|ADDUSER|')) {
                obj.Type = 'ADDUSER';
                obj.Message = obj.Message.split('|ADDUSER|')[1];
            }
            if (obj.Message.includes('|REMOVEUSER|')) {
                obj.Type = 'REMOVEUSER';
                obj.Message = obj.Message.split('|REMOVEUSER|')[1];
            }
            if (obj.Message.includes('|NEWGROUP|')) {
                obj.Type = 'NEWGROUP';
                obj.Message = obj.Message.split('|NEWGROUP|')[1];
            }
            return obj;
        }

        function SendPrivateOrGroupMessage(curVM) {
            chatService.SendMessage(curVM).then(function (result) {
                $scope.EnterKeyFlag = false;
                $scope.messageId = result;
                if (result != null && result !== undefined && !curVM.Id) {
                    curVM.Id = result;
                    if (curVM.id === undefined) curVM.id = result;
                }

                if ($scope.roomName != "") {
                    if (curVM.Message.includes('Call has been scheduled')) {
                        curVM.Message = curVM.Message.replace(curVM.Message.slice(-16), moment.utc((curVM.Message.slice(-16) + ':00').replace(/-/g, "/")).local().format("MM-DD-YYYY HH:mm"));
                    }
                    $scope.paramVideoObj = {
                        fromUserId: $scope.currUserId,//$sessionStorage.currentUserData.userId,
                        toUserName: $scope.selectedUserObject.FirstName + " " + $scope.selectedUserObject.LastName,//username,
                        toUserId: $scope.selectedUserObject.Id,
                        roomName: $scope.roomName,
                        startDateTime: $scope.dateTimeLocalUTCCallScheduled == undefined ? moment(new Date().toLocaleString('en-US', { timeZone: 'US/Central' })).format("MM-DD-YYYY HH:mm:ss") : moment(new Date($scope.dateTimeLocalUTCCallScheduled).toLocaleString('en-US', { timeZone: 'US/Central' })).format("MM-DD-YYYY HH:mm"),
                        endDateTime: moment(new Date()).format("MM-DD-YYYY HH:mm:ss"),
                        hasJoinCall: $scope.hasJoinCall,
                        messageId: $scope.messageId,
                        message: curVM.Message,
                        toUserPhoneNumber: $scope.selectedUserObject.PhoneNumber,
                        fromUserDisplayName: $scope.currLastName + ', ' + $scope.currFirstName,
                    };
                    if (curVM.Message.includes('Call has been scheduled') || curVM.Message.includes('wants to consult a study for the below procedure')) {
                        videoCallConvertToJsonObject(curVM.Message);
                    }
                    if (curVM.Message.includes('Video Call Link') || curVM.Message.includes('Call has been scheduled') || curVM.Message.includes('wants to consult a study for the below procedure')) {
                        chatService.saveVideoConferencingDatails($scope.paramVideoObj).then(function (result) {
                            $scope.videoConferencingId = result;
                            //GetMessage();

                            $scope.showVideoChatLoader = false;
                        });
                    }
                }
                //if(curVM.Message.includes('|SHAREEXAMOBJ|')){
                //  GetMessage();
                //}
                $scope.previousMessageVM = curVM;
                $scope.isHighPriority = false;
                $scope.message = '';
                var idx = _.findIndex($scope.userList, function (data) { return curVM.ToUserId && data.Id == curVM.ToUserId; });
                if (idx > -1) {
                    $scope.userList[idx].MessageDT = moment(curVM.MessageTime).format("YYYY-MM-DDTHH:mm:ss");
                    $scope.userList[idx].LastMessage = curVM.Message;
                    $scope.userList[idx].FileName = curVM.FileName;
                    $scope.userList[idx].LastMessageUserId = $scope.currUserId;
                    $scope.userList = sortUserList($scope.userList);
                }
                else {
                    var idx = _.findIndex($scope.userList, function (data) { return curVM.ChatGroupID && data.ChatGroupID == curVM.ChatGroupID; });
                    if (idx > -1) {
                        $scope.userList[idx].MessageDT = moment(curVM.MessageTime).format("YYYY-MM-DDTHH:mm:ss");
                        $scope.userList[idx].LastMessage = curVM.Message;
                        $scope.userList[idx].FileName = curVM.FileName;
                        $scope.userList[idx].LastMessageUserId = $scope.currUserId;
                        $scope.userList = sortUserList($scope.userList);
                    }
                }
                var idx = _.findIndex($scope.pinnedUserList, function (data) { return curVM.ToUserId && data.Id == curVM.ToUserId; });
                if (idx > -1) {
                    $scope.pinnedUserList[idx].MessageDT = moment(curVM.MessageTime).format("YYYY-MM-DDTHH:mm:ss");
                    $scope.pinnedUserList[idx].LastMessage = curVM.Message;
                    $scope.pinnedUserList[idx].FileName = curVM.FileName;
                    $scope.pinnedUserList[idx].LastMessageUserId = $scope.currUserId;
                    $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                }
                else {
                    var idx = _.findIndex($scope.pinnedUserList, function (data) { return curVM.ChatGroupID && data.ChatGroupID == curVM.ChatGroupID; });
                    if (idx > -1) {
                        $scope.pinnedUserList[idx].MessageDT = moment(curVM.MessageTime).format("YYYY-MM-DDTHH:mm:ss");
                        $scope.pinnedUserList[idx].LastMessage = curVM.Message;
                        $scope.pinnedUserList[idx].FileName = curVM.FileName;
                        $scope.pinnedUserList[idx].LastMessageUserId = $scope.currUserId;
                        $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                    }
                }
                updateReadMessage();
            });

            //$('#message').val('');
        };
        function intiAppHub() {
            AppHub = AppHubService.getAppHub();
            var justCreated = false;
            if (!AppHub) {
                AppHubService.Initialize();
                AppHub = AppHubService.getAppHub();
                justCreated = true;
            }
            if (AppHub) {
                AppHub.off('RadFlowChatAppHubEvent');
                AppHubMethod();
                if (justCreated) AppHubService.startConnection();
            } else {
                $timeout(function () {
                    AppHub = AppHubService.getAppHub();
                    if (AppHub) {
                        AppHub.off('RadFlowChatAppHubEvent');
                        AppHubMethod();
                    }
                }, 500);
            }
        }
        $rootScope.$on('SignalrConnectionSetStartedMethod', function (name, xiIsConnectionStarted, xiConnectionId) {
            if (xiIsConnectionStarted) {
                AppHub = AppHubService.getAppHub();
                if (AppHub) {
                    AppHub.off('RadFlowChatAppHubEvent');
                    AppHubMethod();
                }
            }
        });
        function OpenShareExamchat() {
            var d = $q.defer();
            $scope.isChatMenuActive = true;
            $scope.isShowChatWindow = true;
            if ($scope.UserName) {
                $scope.UserName = null;
                UserListPageNum = 1;
                $scope.userList = [];
            }
            if (($scope.userList && $scope.userList.length == 0) || ($scope.pinnedUserList && $scope.pinnedUserList.length == 0)) {

                $q.all([
                    GetAllUsers(),
                    //getPinnedUsers()
                ]).then(function (data) {

                    $scope.userList = sortUserList($scope.userList);

                    $scope.pinnedUserList = sortUserList($scope.pinnedUserList);

                    $rootScope.$emit('activeChatMenuBar:Chat', $scope.isChatMenuActive);
                    d.resolve();

                });

            } else {
                $rootScope.$emit('activeChatMenuBar:Chat', $scope.isChatMenuActive);
                d.resolve();
            }
            return d.promise;
        }
        function AppHubMethod() {
            if (!AppHub) return;
            var myUserId = ($scope.currUserId != null && $scope.currUserId !== undefined) ? String($scope.currUserId) : '(none)';
            console.log('SignalR [bindmessage]: chatlistupdate registering. My user ID (as recipient, server must send to this group):', myUserId, 'lowercase:', myUserId.toLowerCase());
            AppHub.on('RadFlowChatAppHubEvent', function (obj) {
                if (!obj) return;
                var eventType = obj.EventType || obj.eventType || '';
                var eventArgs = obj.EventArgs || obj.eventArgs;
                var toIdLog = (eventArgs && (eventArgs.ToUserId || eventArgs.toUserId || '').toString().toLowerCase()) || '(none)';
                var currIdLog = ($scope.currUserId != null ? String($scope.currUserId).toLowerCase() : '(none)');
                var amIRec = !!(toIdLog !== '(none)' && currIdLog !== '(none)' && toIdLog === currIdLog);
                console.log('SignalR [bindmessage]: chatlistupdate received EventType=' + (eventType || '(none)') + ' ToUserId=' + toIdLog + ' currUserId=' + currIdLog + ' amIRecipient=' + amIRec);
                switch ((eventType || '').toLowerCase()) {
                    case 'bindmessage':
                        console.log('SignalR [bindmessage]: chatlistupdate processing bindmessage (recipient=' + amIRec + ')');
                        var message = eventArgs || obj.EventArgs || obj.eventArgs;
                        message.IsRead = true;
                        var serverMessageId = message.Id != null ? message.Id : message.id;
                        var messageUniqueId = message.MessageUniqueId || message.messageUniqueId;
                        var fromUserId = message.FromUserId || message.fromUserId;
                        if ($scope.currUserId == fromUserId && serverMessageId != null) {
                            var messageIndex = -1;
                            if (messageUniqueId) {
                                messageIndex = _.findIndex($scope.MessageList, function (m) { return (m.MessageUniqueId || m.messageUniqueId) === messageUniqueId; });
                            }
                            if (messageIndex === -1) {
                                for (var i = $scope.MessageList.length - 1; i >= 0; i--) {
                                    var m = $scope.MessageList[i];
                                    var noId = !m.Id && (m.id == null || m.id === undefined);
                                    var fromMe = (m.FromUserId || m.fromUserId) === $scope.currUserId;
                                    var sameTarget = (message.ToUserId || message.toUserId) ? ((m.ToUserId || m.toUserId) === (message.ToUserId || message.toUserId)) : true;
                                    var sameGroup = (message.ChatGroupID || message.chatGroupID) ? ((m.ChatGroupID || m.chatGroupID) === (message.ChatGroupID || message.chatGroupID)) : true;
                                    if (noId && fromMe && sameTarget && sameGroup) { messageIndex = i; break; }
                                }
                            }
                            if (messageIndex !== -1) {
                                $scope.MessageList[messageIndex].Id = serverMessageId;
                                if ($scope.MessageList[messageIndex].id === undefined) $scope.MessageList[messageIndex].id = serverMessageId;
                                ChangeReadStatus($scope.currUserId, null, $scope.MessageList[messageIndex].ChatGroupID || $scope.MessageList[messageIndex].chatGroupID, serverMessageId);
                            } else {
                                bindMessage(message);
                            }
                            if (message.ChatGroupID || message.chatGroupID) {
                                var gid = message.ChatGroupID || message.chatGroupID;
                                var chatMessage = _.last(_.filter($scope.MessageList, function (m) { return (m.FromUserId || m.fromUserId) === $scope.currUserId && (m.ChatGroupID || m.chatGroupID) === gid; }));
                                if (chatMessage && !chatMessage.GroupChatMessageReadUsers) { chatMessage.GroupChatMessageReadUsers = _.map($scope.selectedUserObject.SelectedRadiologists, function (item) { return { ChatGroupID: $scope.selectedUserObject.ChatGroupID, UserID: item.UserID ? item.UserID : item.Id, IsRead: false }; }); }
                                if (chatMessage) UpdateOnSeenGroupChatMessages(chatMessage);
                            }
                        } else if ($scope.currUserId != fromUserId) {
                            bindMessage(message);
                        }

                        //}
                        break;
                    case 'deletemessage':
                        var DeletedMessage = obj.EventArgs;

                        funcDeleteMessage(DeletedMessage);


                        break;
                    case 'typingindicator':
                        if (obj.EventArgs && obj.EventArgs.Message) {
                            $scope.isTypingMessage = obj.EventArgs.Message;
                            $timeout(function () { $scope.isTypingMessage = ''; }, 3000);
                        }
                        break;
                    case 'setonlinestatus':
                        if ($scope.isChatMenuActive && $scope.UserRoleTab != "Group") {
                            var userId = obj.EventArgs.Id;
                            if ($scope.userList && $scope.userList.length > 0) {
                                var idx = _.findIndex($scope.userList, function (obj) { return obj.Id == userId; });
                                if (idx > -1) {
                                    $scope.userList[idx].IsOnline = obj.EventArgs.IsOnline;
                                    $scope.userList = sortUserList($scope.userList);
                                }
                                if (idx == -1) {
                                    idx = _.findIndex($scope.pinnedUserList, function (obj) { return obj.Id == userId; });
                                    if (idx > -1) {
                                        $scope.pinnedUserList[idx].IsOnline = obj.EventArgs.IsOnline;
                                        $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                                    }
                                }
                                if (idx == -1 && $sessionStorage.currentUserData.userId != userId && $scope.UserRoleTab != "All") {
                                    var filter = {
                                        PageNum: '1',
                                        PageSize: '25',
                                        Id: $scope.currUserId,
                                        UserName: $scope.UserName,
                                        OnlineUserIds: obj.EventArgs.Id,
                                    }
                                    if ($scope.UserRoleTab != "All") {
                                        filter.UserRoles = ($scope.UserRoleTab == "Admin") ? "Admin,Super Admin" : $scope.UserRoleTab;
                                    }
                                    chatService.GetUserList(filter).then(function (result) {
                                        var UserDetails = _.find($scope.userList, { 'Id': userId });
                                        if (!UserDetails && (result && result.length > 0)) {
                                            result[0].IsOnline = obj.EventArgs.IsOnline;
                                            if (!result[0].IsPinnedUser) {
                                                $scope.userList.push(result[0]);
                                                $scope.userList = sortUserList($scope.userList);
                                            }
                                        }
                                    });
                                }

                            }
                            var idx = _.findIndex($scope.pinnedUserList, function (obj) { return obj.Id == userId; });
                            if (idx > -1) {
                                $scope.pinnedUserList[idx].IsOnline = obj.EventArgs.IsOnline;
                                $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                            }
                        }
                        break;
                    case 'creategroup':

                        var groupObject = obj.EventArgs;
                        if (groupObject.StatusFlag == 'D') {
                            var pinnedUserIndex = _.findIndex($scope.pinnedUserList, function (item) { return item.ChatGroupID == groupObject.ChatGroupID; });
                            if (pinnedUserIndex != -1) {
                                $scope.pinnedUserList.splice(pinnedUserIndex, 1);
                            } else {
                                var userIndex = _.findIndex($scope.userList, function (item) { return item.ChatGroupID == groupObject.ChatGroupID; });
                                if (userIndex != -1) {
                                    $scope.userList.splice(userIndex, 1);
                                }
                            }
                            var removeChatWindowTimeout = $timeout(function () {
                                if (($scope.selectedUserObject)
                                    && ($scope.selectedUserObject.ChatGroupID == groupObject.ChatGroupID)) {
                                    $scope.isShowChatWindow = false;
                                    $scope.ClearModalData();
                                }

                                $timeout.cancel(removeChatWindowTimeout);
                                removeChatWindowTimeout = null;
                            }, 100);

                        } else {
                            var LeftRadiologists = _.filter(groupObject.SelectedRadiologists, function (item) { return item.LeavingDate; });
                            var SelectedRadiologists = _.filter(groupObject.SelectedRadiologists, function (item) { return !item.LeavingDate; });
                            _.remove(LeftRadiologists, function (leftRad) {
                                var commonRadioLogist = _.find(SelectedRadiologists, function (selectedRad) {
                                    return ((selectedRad.UserID
                                        && leftRad.UserID
                                        && selectedRad.UserID == leftRad.UserID)
                                        || (selectedRad.Id
                                            && leftRad.Id
                                            && selectedRad.Id == leftRad.Id));
                                });

                                if (commonRadioLogist) {
                                    return true;
                                }
                                return false;
                            });
                            groupObject.LeftRadioLogist = LeftRadiologists;
                            groupObject.SelectedRadiologists = _.clone(SelectedRadiologists);
                            _.each(groupObject.SelectedRadiologists, function (useritem) {
                                useritem.ChatGroupID = groupObject.ChatGroupID;
                                var selectedUser = _.find($scope.RadiologistsFullSet, { Id: useritem.UserID });
                                if (selectedUser) {
                                    useritem = _.merge(useritem, selectedUser);
                                }
                            });
                            //groupItem.LastMessage = getLastMessage(groupItem);
                            var createdByUser = _.find($scope.RadiologistsFullSet, { Id: groupObject.CreatedBy });
                            if (createdByUser) { groupObject.CreatedName = createdByUser.DisplayName; }
                            var modifiedByUser = _.find($scope.RadiologistsFullSet, { Id: groupObject.ModifiedBy });
                            if (modifiedByUser) { groupObject.ModifiedName = modifiedByUser.DisplayName; }
                            groupObject.UserIDs = _.map(groupObject.SelectedRadiologists, function (item) {
                                return item.Id;
                            });
                            _.each(groupObject.Messages, function (message) {
                                var messageItem = prepareGroupChatMessage(message);
                                if (messageItem.Type != 'NEWGROUP') {
                                    BindChatGroupMessage(messageItem);
                                }
                            });
                            var groupIndex = _.findIndex($scope.pinnedUserList, { ChatGroupID: groupObject.ChatGroupID });
                            if (groupIndex != -1) {
                                groupObject.IsPinnedGroup = true;
                                $scope.pinnedUserList[groupIndex] = groupObject;
                                $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                            } else {
                                groupIndex = _.findIndex($scope.userList, { ChatGroupID: groupObject.ChatGroupID });
                                if (groupIndex != -1) {
                                    $scope.userList[groupIndex] = groupObject;
                                } else {
                                    $scope.userList.push(groupObject);
                                }
                                $scope.userList = sortUserList($scope.userList);
                            }


                            if ($scope.selectedUserObject && $scope.selectedUserObject.ChatGroupID == groupObject.ChatGroupID) {
                                $scope.itemClicked(groupObject, false);
                            }
                        }
                        break;
                    case 'seenchatmessage':
                        var chatMessage = obj.EventArgs.ChatMessage;
                        if (!chatMessage.ChatGroupID) {
                            UpdateOnSenChatMessages(chatMessage);
                        } else {
                            UpdateOnSeenGroupChatMessages(chatMessage);

                        }
                        break;
                }
            });
        }
        function UpdateOnSenChatMessages(chatMessage) {
            var chatMessages = _.filter($scope.MessageList, function (item) { return chatMessage.Id || chatMessage.Id > 0 ? item.Id == chatMessage.Id && item.FromUserId == $scope.currUserId && item.IsRead : item.FromUserId == $scope.currUserId && item.IsRead; });
            if (chatMessages) {
                _.each(chatMessages, function (item) { item.IsRead = false; });
                updateReadMessage();
            }
        }

        function UpdateOnSeenGroupChatMessages(chatMessage) {
            var chatMessages = _.filter($scope.MessageList, { FromUserId: $scope.currUserId, IsReadByAllUser: true });
            _.each(chatMessages, function (item) { item.IsReadByAllUser = false; });
            var objChatMessage = _.last(_.filter($scope.MessageList, function (item) { return chatMessage.Id || chatMessage.Id > 0 ? item.Id == chatMessage.Id && item.ChatGroupID == chatMessage.ChatGroupID && item.FromUserId == $scope.currUserId && !item.IsReadByAllUser : item.ChatGroupID == chatMessage.ChatGroupID && item.FromUserId == $scope.currUserId && !item.IsReadByAllUser; }));
            if (objChatMessage) {
                if (objChatMessage.GroupChatMessageReadUsers) {
                    var userIndex = _.findIndex(objChatMessage.GroupChatMessageReadUsers, { UserID: chatMessage.FromUserId });
                    if (userIndex != -1) {
                        objChatMessage.GroupChatMessageReadUsers[userIndex].IsRead = true;

                    }
                    var readUsers = _.filter(objChatMessage.GroupChatMessageReadUsers, { IsRead: false });
                    if (readUsers.length == 0) {
                        objChatMessage.IsReadByAllUser = true;
                    }
                }
            }
        }

        function funcDeleteMessage(DeletedMessage) {
            var Id = DeletedMessage.Id;
            var DeleteUserId = (DeletedMessage.ChatGroupID != null) ? DeletedMessage.ChatGroupID : ((DeletedMessage.FromUserId == $scope.currUserId) ? DeletedMessage.ToUserId : DeletedMessage.FromUserId);

            var idx = _.findIndex($scope.MessageList, function (data) { return data.Id == Id; });


            //$scope.MessageList = $filter('orderBy')($scope.MessageList, 'MessageTime', false);
            var userIdx = _.findIndex($scope.userList, function (data) { return data.Id == DeleteUserId || data.ChatGroupID == DeleteUserId; });
            var pinnedUserIdx = _.findIndex($scope.pinnedUserList, function (data) { return data.Id == DeleteUserId || data.ChatGroupID == DeleteUserId; });
            var idxtoUnreadUser = _.findIndex($scope.ChatMessageList, function (data) { return data.Id == Id; });
            if (userIdx > -1 && $scope.userList[userIdx].UnreadMsgCount > 0 && idxtoUnreadUser > -1) {
                $scope.userList[userIdx].UnreadMsgCount = $scope.userList[userIdx].UnreadMsgCount - 1;
            }
            if (pinnedUserIdx > -1 && $scope.pinnedUserList[pinnedUserIdx].UnreadMsgCount > 0 && idxtoUnreadUser > -1) {
                $scope.pinnedUserList[pinnedUserIdx].UnreadMsgCount = $scope.pinnedUserList[pinnedUserIdx].UnreadMsgCount - 1;
            }
            if ($scope.MessageList != null && $scope.MessageList.length > 0 && $scope.isShowChatWindow) {
                var LastMessage = $scope.MessageList[$scope.MessageList.length - 1];
                if (((idx == 0) && ($scope.MessageList.length == 1))
                    || ((idx > 0) && (idx == ($scope.MessageList.length - 1)))) {
                    if (pinnedUserIdx != -1) {
                        $scope.pinnedUserList[pinnedUserIdx].LastMessage = "This message has been deleted.";
                        $scope.pinnedUserList[pinnedUserIdx].MessageDT = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
                        $scope.pinnedUserList[pinnedUserIdx].LastMessageUserId = DeletedMessage.FromUserId;
                        if (DeletedMessage.FileName) {
                            $scope.pinnedUserList[pinnedUserIdx].FileName = null;
                        }
                    } else {
                        if (userIdx != -1) {
                            $scope.userList[userIdx].LastMessage = "This message has been deleted.";
                            $scope.userList[userIdx].MessageDT = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
                            $scope.userList[userIdx].LastMessageUserId = DeletedMessage.FromUserId;
                            if (DeletedMessage.FileName) { $scope.userList[userIdx].FileName = null; }
                        }
                    }
                } else {
                    if (pinnedUserIdx != -1) {
                        $scope.pinnedUserList[pinnedUserIdx].LastMessage = LastMessage.Message;
                        $scope.pinnedUserList[pinnedUserIdx].MessageDT = LastMessage.MessageTime;
                        $scope.pinnedUserList[pinnedUserIdx].LastMessageUserId = LastMessage.FromUserId;
                        if (LastMessage.FileName) {
                            $scope.pinnedUserList[pinnedUserIdx].FileName = LastMessage.FileName;
                        }
                    } else {
                        if (userIdx != -1) {
                            $scope.userList[userIdx].LastMessage = LastMessage.Message;
                            $scope.userList[userIdx].MessageDT = LastMessage.MessageTime;
                            $scope.userList[userIdx].LastMessageUserId = LastMessage.FromUserId;
                            if (LastMessage.FileName) {
                                $scope.userList[userIdx].FileName = LastMessage.FileName;
                            }
                        }
                    }
                }

            } else {
                if (pinnedUserIdx != -1) {
                    $scope.pinnedUserList[pinnedUserIdx].LastMessage = "This message has been deleted.";
                    $scope.pinnedUserList[pinnedUserIdx].MessageDT = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
                    $scope.pinnedUserList[pinnedUserIdx].LastMessageUserId = DeletedMessage.FromUserId;
                    if (DeletedMessage.FileName) {
                        $scope.pinnedUserList[pinnedUserIdx].FileName = null;
                    }
                } else {
                    if (userIdx != -1) {
                        $scope.userList[userIdx].LastMessage = "This message has been deleted.";
                        $scope.userList[userIdx].MessageDT = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
                        $scope.userList[userIdx].LastMessageUserId = DeletedMessage.FromUserId;
                        if (DeletedMessage.FileName) { $scope.userList[userIdx].FileName = null; }
                    }
                }
            }

            if (idx != -1) {
                $scope.MessageList.splice(idx, 1);
            }
            $scope.MessageList = $filter('orderBy')(_.uniqBy($scope.MessageList, 'Id'), ['MessageTime']);

            $scope.userList = sortUserList($scope.userList);
            $scope.pinnedUserList = sortUserList($scope.pinnedUserList);

        }

        function bindMessage(obj) {
            if (!obj) return;
            var msg = obj.Message || obj.message;
            obj.Message = (typeof msg === 'string') ? msg : (msg != null ? String(msg) : '');
            if (obj.ToUserId === undefined && obj.toUserId !== undefined) obj.ToUserId = obj.toUserId;
            if (obj.FromUserId === undefined && obj.fromUserId !== undefined) obj.FromUserId = obj.fromUserId;
            if (obj.MessageTime === undefined && obj.messageTime !== undefined) obj.MessageTime = obj.messageTime;
            if (obj.FromUserRoles === undefined && obj.fromUserRoles !== undefined) obj.FromUserRoles = obj.fromUserRoles;
            if (obj.FromUserRoles === undefined) obj.FromUserRoles = [];
            obj.readMoreTxt = "Read More";
            obj.numLimit = numLimit;
            if ((obj.Message.split('|SHAREEXAMOBJ|'))[0].length > numLimit) {
                obj.isExpandable = true;
            }
            else {
                obj.isExpandable = false;
            }
            if (obj.Message.includes('Call has been scheduled')) {
                obj.Message = obj.Message.replace(obj.Message.slice(-16), moment.utc((obj.Message.slice(-16) + ':00').replace(/-/g, "/")).local().format("MM-DD-YYYY HH:mm"));
                //re.Message = re.Message.replace(re.Message.slice(-16),moment.utc(re.Message.slice(-16)+':00').local().format("MM-DD-YYYY HH:mm"));    
                // $scope.MessageList.push(obj);
            }
            var toUserId = (obj.ToUserId || obj.toUserId || '').toString().toLowerCase();
            var currUserIdLower = ($scope.currUserId || '').toString().toLowerCase();
            var fromUserIdVal = obj.FromUserId || obj.fromUserId;
            var fromLower = String(fromUserIdVal || '').toLowerCase();
            if (toUserId === currUserIdLower) {
                if ($scope.isShowChatWindow && $scope.selectedUserObject && (( $scope.selectedUserObject.Id || $scope.selectedUserObject.id) == fromUserIdVal || String($scope.selectedUserObject.Id || $scope.selectedUserObject.id).toLowerCase() === String(fromUserIdVal || '').toLowerCase())) {
                    $scope.MessageList.push(obj);
                    $scope.MessageList = $filter('orderBy')(_.uniqBy($scope.MessageList, 'Id'), ['MessageTime']);
                    ChangeReadStatus(obj.FromUserId, obj.ToUserId, null, obj.Id);
                    if ($scope.hideChatWindow && obj.Message.indexOf("|SHAREEXAMOBJ|") != -1) {
                        scrollPositionSetMessageList();
                        $scope.maxChatWindow();
                    }
                    if (( $scope.selectedUserObject.Id || $scope.selectedUserObject.id) == fromUserIdVal) {
                        $scope.maxChatWindow();
                    }
                }
                else if ($scope.UserRoleTab == 'All' || !(obj.ChatGroupID || obj.chatGroupID) || (obj.FromUserRoles && obj.FromUserRoles.length && obj.FromUserRoles.includes($scope.UserRoleTab))) {
                    var pinnedUserIdx = -1;
                    var idx = _.findIndex($scope.userList, function (data) {
                        var id = (data.Id || data.id || '').toString().toLowerCase();
                        return id === fromLower;
                    });
                    if (idx == -1) {
                        pinnedUserIdx = _.findIndex($scope.pinnedUserList, function (data) {
                            var id = (data.Id || data.id || '').toString().toLowerCase();
                            return id === fromLower;
                        });
                    }
                    if (idx == -1 && pinnedUserIdx == -1 && $scope.userList.length > 0) {
                        var filter = {
                            PageNum: '1',
                            PageSize: '25',
                            Id: obj.FromUserId,
                            NewMessage: true,
                        };
                        chatService.GetUserList(filter).then(function (result) {
                            if (!$scope.UserName) {
                                $scope.userList.unshift(result[0]);
                                $scope.userList[0].UnreadMsgCount = $scope.userList[0].UnreadMsgCount + 1;
                            }
                            var senderIsPrelimRad = _hasPrelimRad(obj.FromUserRoles);
                            if (obj.Message.indexOf("|SHAREEXAMOBJ|") != -1 && obj.FromUserId != $scope.currUserId && !senderIsPrelimRad) {
                                $q.all([
                                    OpenShareExamchat()
                                ]).then(function (data) {

                                    var pinnedIndex = _.findIndex($scope.pinnedUserList, function (data) {
                                        return data.Id == obj.FromUserId;
                                    });

                                    if (!$scope.UserName) {
                                        if (pinnedIndex != -1) {
                                            $scope.selectedUserObject = _.find($scope.pinnedUserList, { 'Id': obj.FromUserId });
                                            $scope.pinnedUserList[0].UnreadMsgCount = $scope.pinnedUserList[0].UnreadMsgCount - 1;
                                        }
                                        else {
                                            $scope.selectedUserObject = _.find($scope.userList, { 'Id': obj.FromUserId });
                                            $scope.userList[0].UnreadMsgCount = $scope.userList[0].UnreadMsgCount - 1;
                                        }
                                    }
                                    else {
                                        $scope.selectedUserObject = result[0];
                                    }
                                    getUserMessages($scope.selectedUserObject);

                                });
                                scrollPositionSetMessageList();
                                $scope.maxChatWindow();
                            }
                        });

                    }
                    else {
                        if (idx > -1) {
                            $scope.userList[idx].UnreadMsgCount = $scope.userList[idx].UnreadMsgCount + 1;
                        } else if (pinnedUserIdx != -1) {
                            $scope.pinnedUserList[pinnedUserIdx].UnreadMsgCount = $scope.pinnedUserList[pinnedUserIdx].UnreadMsgCount + 1;
                        }
                        var senderIsPrelimRad = _hasPrelimRad(obj.FromUserRoles);
                        if (obj.Message.indexOf("|SHAREEXAMOBJ|") != -1 && obj.FromUserId != $scope.currUserId && !senderIsPrelimRad) {
                            $q.all([
                                OpenShareExamchat()
                            ]).then(function (data) {

                                pinnedUserIdx = _.findIndex($scope.pinnedUserList, function (data) {
                                    return data.Id == obj.FromUserId;
                                });

                                if (pinnedUserIdx != -1) {
                                    $scope.selectedUserObject = _.find($scope.pinnedUserList, { 'Id': obj.FromUserId });
                                } else {
                                    $scope.selectedUserObject = _.find($scope.userList, { 'Id': obj.FromUserId });
                                }
                                getUserMessages($scope.selectedUserObject);
                            });
                            $scope.maxChatWindow();
                        }
                        scrollPositionSetMessageList();
                        if ($scope.selectedUserObject &&
                            ((idx != -1 && ($scope.userList[idx].Id == $scope.selectedUserObject.Id)) ||
                                (pinnedUserIdx != -1 && ($scope.pinnedUserList[pinnedUserIdx].Id == $scope.selectedUserObject.Id)))) {
                            $scope.maxChatWindow();
                        }
                        $scope.topFunction();
                    }
                }
                ////////Update UserList Data ----------------------
                var idx = _.findIndex($scope.userList, function (data) { var id = (data.Id || data.id || '').toString().toLowerCase(); return id === fromLower; });
                if (idx > -1) {
                    $scope.userList[idx].MessageDT = moment(obj.MessageTime || obj.messageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                    $scope.userList[idx].LastMessage = obj.Message;
                    $scope.userList[idx].FileName = obj.FileName || obj.fileName;
                    $scope.userList[idx].LastMessageUserId = fromUserIdVal;
                    $scope.userList = sortUserList($scope.userList);
                }
                var idx = _.findIndex($scope.pinnedUserList, function (data) { var id = (data.Id || data.id || '').toString().toLowerCase(); return id === fromLower; });
                if (idx > -1) {
                    $scope.pinnedUserList[idx].MessageDT = moment(obj.MessageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                    $scope.pinnedUserList[idx].LastMessage = obj.Message;
                    $scope.pinnedUserList[idx].FileName = obj.FileName;
                    $scope.pinnedUserList[idx].LastMessageUserId = obj.FromUserId;
                    $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                }
                //---------------------------------------------------
            }
            else if (obj.FromUserId == $scope.currUserId && obj.ChatGroupID == null) {
                $scope.MessageList.push(obj);
                $scope.MessageList = $filter('orderBy')(_.uniqBy($scope.MessageList, 'Id'), ['MessageTime']);
                ////////Update UserList Data
                var idx = _.findIndex($scope.userList, function (data) { return data.Id == obj.ToUserId; });
                if (idx > -1) {
                    $scope.userList[idx].MessageDT = moment(obj.MessageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                    $scope.userList[idx].LastMessage = obj.Message;
                    $scope.userList[idx].FileName = obj.FileName;
                    $scope.userList[idx].LastMessageUserId = obj.FromUserId;
                    $scope.userList = sortUserList($scope.userList);
                }
                var idx = _.findIndex($scope.pinnedUserList, function (data) { return data.Id == obj.ToUserId; });
                if (idx > -1) {
                    $scope.pinnedUserList[idx].MessageDT = moment(obj.MessageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                    $scope.pinnedUserList[idx].LastMessage = obj.Message;
                    $scope.pinnedUserList[idx].FileName = obj.FileName;
                    $scope.pinnedUserList[idx].LastMessageUserId = obj.FromUserId;
                    $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                }
                //---------------------------------------------------
            }

            if (obj.ChatGroupID != null) {
                BindChatGroupMessage(obj);
            }
            $scope.scrolllToBottom = true;
            $scope.DeleteMessageScrollPosition = false;
        }

        function deleteMessage(obj, index) {
            obj.UserIDs = $scope.selectedUserObject.ChatGroupID ? _.join($scope.selectedUserObject.UserIDs, ',') : '';
            funcDeleteMessage(obj)
            chatService.DeleteMessage(obj).then(function (result) {
                if (obj.ChatGroupID) {
                    UpdateGroupChatReadMessageUsers(obj);
                } else {
                    UpdateOnSenChatMessages({});
                }
            }, function (err) {

            });
            ShareExamscrollPosition = true;
            $scope.DeleteMessageScrollPosition = true;
            $scope.scrolllToBottom = true;
        }
        function downloadFile(obj, blobData) {
            try {
                //console.log('blobData', blobData);
                var linkElement = document.createElement('a');
                var contentType = obj.FileExtension;

                var blob = b64toBlob(blobData, contentType);
                var url = URL.createObjectURL(blob);
                //console.log('downloadFile', url);
                var b = parser.getBrowser().name;
                if (b != null && b.toUpperCase() == "IE") {
                    window.navigator.msSaveBlob(blob, obj.FileName);
                }
                else {
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", obj.FileName);
                    //console.log('clickEvent', linkElement, contentType);
                    var clickEvent = new MouseEvent("click", {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        }
        function b64toBlob(dataURI, fileType) {
            var byteString = atob(dataURI);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: fileType });
        }
        function ChangeReadStatus(FromUserId, ToUserId, ChatGroupID, MessageID) {
            var param = { FromUserId: FromUserId, ToUserId: ToUserId, ChatGroupID: ChatGroupID, Id: MessageID };
            if (ChatGroupID && !MessageID) {
                var messages = _.filter($scope.MessageList, function (item) { return item.FromUserId != $scope.currUserId; });
                if (messages) {
                    var userIDs = _.join(_.map(messages, function (item) { return item.FromUserId }), ',');
                    param.UserIDs = userIDs;
                }
            } else if (ChatGroupID && MessageID) {
                var messages = _.filter($scope.MessageList, function (item) { return item.Id != MessageID; });
                if (messages) {
                    var userIDs = _.join(_.map(messages, function (item) { return item.FromUserId }), ',');
                    param.UserIDs = userIDs;
                }
            }
            chatService.ChangeReadStatus(param);
            var userListIndex = -1;
            var pinnedUserListIndex = -1;
            if (ToUserId) {
                pinnedUserListIndex = _.findIndex($scope.pinnedUserList, function (obj) { return obj.Id == ToUserId; });
                userListIndex = _.findIndex($scope.userList, function (obj) { return obj.Id == ToUserId; });
            } else if (ChatGroupID) {
                pinnedUserListIndex = _.findIndex($scope.pinnedUserList, function (obj) { return obj.ChatGroupID == ChatGroupID; });
                userListIndex = _.findIndex($scope.userList, function (obj) { return obj.ChatGroupID == ChatGroupID; });
            }
            if (pinnedUserListIndex != -1) {
                $scope.pinnedUserList[pinnedUserListIndex].UnreadMsgCount = 0;
            }
            else if (userListIndex != -1) {
                $scope.userList[userListIndex].UnreadMsgCount = 0;
            }
        }
        // #endregion

        // #region Methods
        $scope.itemClicked = function (obj, isShareChatLink) {
            $scope.DataObject.SpecialUserEmailIDs = $sessionStorage.SpecialGroupEmailIDs;
            $scope.MessageList = [];
            $scope.isShareChatLink = isShareChatLink;

            if (!$scope.isShareChatLink) {
                $scope.closeKendoScheduleLater();
                swal.close();
                multipleOrderWorkList = null;
                $timeout(function () { getUserMessages(obj); }, 300);
                //getUserMessages(obj).then(function (data) {
                //});
                //ShareExamscrollPosition = true;

                $scope.scrolllToBottom = true;
                $scope.DeleteMessageScrollPosition = false;
            }
            else {
                //alert();
                getUserMessages(obj);
                var leftDiv = document.createElement("div"); //Create left div
                leftDiv.id = "left"; //Assign div id
                leftDiv.setAttribute("style", "float:left; width:66.5%; line-height: 26px; text-align:left; font-size:12pt; padding-left:8px; height:26px;"); //Set div attributes
                leftDiv.style.background = "#FF0000";
                var a = document.createElement('a');
                a.href = 'google.com';
                a.textContent = $scope.roomName + " " + "Video Call Link"
                leftDiv.appendChild(a);
                $scope.isHighPriority = true;
                $scope.message = leftDiv.textContent;
                $scope.sendMessage($scope.message);
                $scope.message = '';
                $scope.isShareChatLink = false;
            }
        }
        // function loadChatHistory(obj){
        //     $rootScope.$broadcast("ChatReadCount", obj, "Read");
        //     $scope.isShowChatWindow = true;
        //     $scope.isPrivateUserChat = true;
        //     $scope.selectedUserObject = obj;
        //     $scope.selectedUserId = obj.Id;
        //     GetMessage();
        //     if (obj.UnreadMsgCount > 0) {
        //         ChangeReadStatus(obj.Id, $scope.currUserId);
        //         obj.UnreadMsgCount = 0;
        //     }
        //     $scope.isHighPriority = false;
        // }
        $scope.closeChatWindow = function () {
            $rootScope.$broadcast("ChatCurrentUserObject", {});
            $scope.isShowChatWindow = false;
            $scope.selectedUserId = "0";
            $scope.topFunction();
        }
        $scope.setUserChat = function (obj) {
            $scope.selectedUserObject = obj;
            $scope.maxChatWindow();
        }
        $scope.onFolderNumberKeyPress = function ($event, message) {

            var keyPressEvt = window.event ? $event.keyCode : $event.which;
            $scope.message = message;
            if (!$scope.message) {
                if (keyPressEvt == 13) {
                    $event.preventDefault();
                }
                return;
            }
            if (keyPressEvt == 13) {
                if ($(window).width() < 768 && keyPressEvt === 13) {
                    return;
                }
                if ($event.ctrlKey) {
                    $scope.message = $scope.message + '\n';
                    //$('#message').val($('#message').val() + '\n');
                }
                else {
                    //appService.setValue(true);
                    $scope.EnterKeyFlag = true;
                    $scope.sendMessage(message);
                    $event.preventDefault();
                    $scope.isTypingMessage = '';
                }
                $scope.scrolllToBottom = true;
                $scope.DeleteMessageScrollPosition = false;
            }
            else {
                if ($scope.selectedUserObject != null && $scope.isInstantGroupChat == false) {
                    if (!isTypingSentTimer) {
                        var typingTargetId = $scope.isPrivateUserChat ? $scope.selectedUserObject.Id : $scope.selectedUserObject.ChatGroupID;
                        AppHub.invoke('sendIsTypingDataGroupAndPrivate', typingTargetId, $scope.userObj.displayName + ' is typing...', $scope.isPrivateUserChat);
                        isTypingSentTimer = $timeout(function () {
                            $timeout.cancel(isTypingSentTimer);
                            isTypingSentTimer = null;
                        }, 1000);
                    }
                }
            }
        };
        $scope.sendMessage = function (message) {
            var curVM = {};
            $scope.message = _.replace(_.trim(message), '/\n+/', '\n');
            if ($scope.message.length > 0) {
                curVM = {
                    FromUserId: $scope.currUserId,
                    Message: $scope.message,
                    ToUserId: $scope.isPrivateUserChat == true ? $scope.selectedUserObject.Id : null,
                    ToGroupId: $scope.isPrivateUserChat == true ? null : $scope.selectedUserObject.Id,
                    isPrivateChat: $scope.isPrivateUserChat,
                    isMessageRead: false,
                    isHighPriority: $scope.isHighPriority,
                    MessageTime: moment().utc().format('YYYY-MM-DDTHH:mm:ss'),
                    ToUserPhoneNumber: $scope.selectedUserObject.PhoneNumber,
                    FromUserDisplayName: $scope.currLastName + ', ' + $scope.currFirstName,
                    FromUserRoles: _.join(_.map($sessionStorage.currentUserData.userRoles, function (role) { return role; }), ','),
                    ChatGroupID: $scope.selectedUserObject.ChatGroupID ? $scope.selectedUserObject.ChatGroupID : null,
                    GroupName: $scope.selectedUserObject.ChatGroupID ? $scope.selectedUserObject.GroupName : null,
                    UserIDs: $scope.selectedUserObject.ChatGroupID ?
                        _.join($scope.selectedUserObject.UserIDs, ',') : '',
                    UsersPhoneNumber: $scope.selectedUserObject.SelectedRadiologists ?
                        _.join(_.map(_.filter($scope.selectedUserObject.SelectedRadiologists, function (item) {
                            return item.UserID != $scope.currUserId;
                        }), function (user) {
                            return user.PhoneNumber;
                        }), ',') : '',
                    MessageUniqueId: _.uniqueId(),
                    IsRead: true,
                    IsReadByAllUser: false,
                    GroupChatMessageReadUsers: _.map($scope.selectedUserObject.SelectedRadiologists, function (item) { return { ChatGroupID: $scope.selectedUserObject.ChatGroupID, UserID: item.UserID ? item.UserID : item.Id, IsRead: false }; })
                };
                SendPrivateOrGroupMessage(curVM);
                bindMessage(curVM);
                $scope.message = '';
            }
            return;
        };
        $scope.changePriority = function () {
            $scope.isHighPriority = !$scope.isHighPriority;
        }
        $scope.getMessageDate = function (message) {
            var idx = $scope.MessageList.indexOf(message);
            var isShowDate = true;
            if (idx > 0) {
                var previousMessage = $scope.MessageList[idx - 1];
                var previousDate = moment.utc(previousMessage.MessageTime).local().format('YYYYMMDD');
                var currentDate = moment.utc(message.MessageTime).local().format('YYYYMMDD');
                if (previousDate === currentDate) {
                    isShowDate = false;
                }
            }
            var dateDisplay = '';
            if (isShowDate) {
                var messageTime = moment.utc(message.MessageTime).local();
                var diff = moment().diff(moment(messageTime, 'YYYY-MM-DD').startOf('day'), 'days', false);
                if (diff == 0) {
                    dateDisplay = 'Today';
                } else if (diff == 1) {

                    dateDisplay = 'Yesterday';
                } else {
                    dateDisplay = moment.utc(message.MessageTime).local().format('M/D/YYYY');
                }
            }

            return dateDisplay
        }
        $scope.deleteMsg = function (obj, index) {
            swal({
                title: "Are you sure you want to delete it ?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
                function () {
                    deleteMessage(obj, index);
                });
        }
        $scope.uploadFile = function (e) {
            console.log('[uploadFile] called, files:', e && e.files ? e.files.length : 'none');
            var allowedExtensions = (__env.AllowedChatFileTypes || 'pdf,doc,docx,xls,xlsx,csv,zip,jpg,jpeg,png,gif,bmp,tiff,tif,dcm,txt').split(',');
            if (e.files.length > 0) {
                var data = new FormData();
                data.append("FromUserId", $scope.currUserId);
                data.append("ToUserId", $scope.selectedUserObject.Id);
                data.append("isHighPriority", $scope.isHighPriority);
                data.append("MessageTime", moment().utc().format('MM/DD/YYYY HH:mm:ss'));
                data.append("ToUserPhoneNumber", $scope.selectedUserObject.PhoneNumber);
                data.append("IsRead", true);
                if ($scope.selectedUserObject.ChatGroupID) {
                    data.append("ChatGroupID", $scope.selectedUserObject.ChatGroupID ? $scope.selectedUserObject.ChatGroupID : null);
                    data.append("UserIDs", $scope.selectedUserObject.ChatGroupID ? _.join($scope.selectedUserObject.UserIDs, ',') : '');
                    data.append("UsersPhoneNumber", $scope.selectedUserObject.ChatGroupID && $scope.selectedUserObject.SelectedRadiologists ? _.join(_.map(_.filter($scope.selectedUserObject.SelectedRadiologists, function (item) { return item.UserID != $scope.currUserId; }), function (user) { return user.PhoneNumber; }), ',') : '');
                }

                for (var i = 0; i < e.files.length; i++) {
                    var fileName = e.files[i].name;
                    var ext = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
                    console.log('[uploadFile] file:', fileName, '| ext:', ext, '| allowed:', allowedExtensions.indexOf(ext) !== -1);
                    if (!ext || allowedExtensions.indexOf(ext) === -1) {
                        console.log('[uploadFile] blocked ext:', ext);
                        $timeout(function() { toaster.warning({ body: "File type '." + ext + "' is not allowed. Permitted types: " + allowedExtensions.join(', ') }); });
                        angular.element("#file-input").val(null);
                        return;
                    }
                    var size = e.files[i].size / 1024 / 1024;
                    if (size > 5) {
                        $timeout(function() { toaster.warning({ body: "file size must be less than 5MB" }); });
                        angular.element("#file-input").val(null);
                        return;
                    }
                    data.append("uploadedFile", e.files[i]);
                }
                chatService.uploadFile(data).then(function (result) {
                    angular.element("#file-input").val(null);
                    updateReadMessage();
                    if ($scope.selectedUserObject.ChatGroupID) {
                        var chatMessage = _.last(_.filter($scope.MessageList, { FromUserId: $scope.currUserId, ChatGroupID: $scope.selectedUserObject.ChatGroupID }));
                        if (!chatMessage.GroupChatMessageReadUsers) { chatMessage.GroupChatMessageReadUsers = _.map($scope.selectedUserObject.SelectedRadiologists, function (item) { return { ChatGroupID: $scope.selectedUserObject.ChatGroupID, UserID: item.UserID ? item.UserID : item.Id, IsRead: false }; }); }
                        UpdateOnSeenGroupChatMessages(chatMessage);
                    }
                }, function (error) {
                    var msg = (error && error.data && error.data.error) ? error.data.error : "File upload failed. File type may not be allowed.";
                    toaster.error({ body: msg });
                    angular.element("#file-input").val(null);
                });
                $scope.isHighPriority = false;
            }
        }
        $scope.downloadFile = function (obj) {
            chatService.DownloadFile(obj).then(function (result) {
                downloadFile(obj, result);
            }, function (err) {

            });

        }
        // #endregion

        ////#region Video-Chat
        $scope.window;
        $scope.schedulelaterDlgOptionWindow;
        $scope.roomName = "";
        $scope.showVideoChatLoader = false;
        $scope.isRescheduled = false;
        var connected = false;
        var room;
        var buttonJoin = document.getElementById('join_leave');
        var token = '';
        var localVideoTrack;
        var shareScreen = document.getElementById('share_screen');
        var screenTrack;
        var isshowViedoChatScreen = false;
        var connectedUseName = '';
        var muteUnmuteAudioButton = document.getElementById('mute-unmute-audio-button');
        var muteUnmuteVideoButton = document.getElementById('mute-unmute-video-button');
        var isAudioMuted = false;
        var isVideoMuted = false;

        var TrackType = {
            Audios: 'Audio',
            Videos: 'Video'
        }
        //$scope.ScheduleForTime = new Date();
        // $scope.ScheduleForDate = {};
        // //$scope.ScheduleForTime = new Date();
        // $scope.scheduleForDateOptions = {
        //     formatYear: 'yyyy',
        //     startingDay: 1,
        //     minDate: new Date()
        // };

        $scope.ScheduleForDateNew = {};
        $scope.scheduleForDateOptionsNew = {
            singleDatePicker: true,
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 5,
            autoUpdateInput: true,
            startDate: moment().startOf('hour'),
            minDate: new Date(),
            locale: {
                format: 'MM/DD/YYYY HH:mm'
            },
            ranges: {
                'Today': [moment().startOf('hour').startOf('minute')],
                'Tomorrow': [moment().add(1, 'days').startOf('hour').startOf('minute')]
            }
        };
        // $scope.scheduleForDateOptions = { minDate: new Date() }; 
        $scope.hstep = 1;
        $scope.mstep = 5;
        $scope.mindate = new Date();

        //full screen element
        //$scope.spanFullScreen = document.createElement('span');
        //$scope.spanFullScreen.setAttribute('class', 'fa fa-arrows-alt vidCallFullScrIcon');
        //$scope.spanFullScreen.setAttribute('title', 'Full screen');
        // connect to local video camera
        function addLocalVideo() {
            $q.all([
                Twilio.Video.createLocalVideoTrack()
            ]).then(function (track) {
                localVideoTrack = track[0];
                var video = document.getElementById('local').firstElementChild;
                if (video.childNodes.length >= 1) {
                    video.removeChild(video.childNodes[0]);
                }
                var trackElement = track[0].attach();
                //console.log('trackElement :' + trackElement);
                trackElement.addEventListener('click', function () { zoomTrack(trackElement); });
                video.appendChild(trackElement);
                video.appendChild(trackElement);
                //video.appendChild($scope.spanFullScreen);
                //console.log(track[0]);
            });
        }
        $scope.openVideoChat = function (obj, hasJoinCall, currentMgs) {
            $scope.ScheduleForDateNew = {};

            if (isshowViedoChatScreen == true) {
                swal("Sorry!! you can not switch to another call, while on going call is active.");
                return;
            }
            // this is for SEND VIDEO CALL MESSAGE.
            if (!currentMgs) {
                swal({
                    //title: "Are you sure you want to consult right now or schedule meeting ?", 
                    //title : "Are you sure want to send a video call request to " + obj + " ?",

                    title: "Are you ready to be connected with " + obj + " for a video call request ?",
                    text: "",
                    //type: "error",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Meet now",
                    cancelButtonText: "Schedule meeting",
                    closeOnConfirm: true,
                    imageUrl: "assets/images/clock.svg"

                },
                    function (isConfirmed) {
                        if (isConfirmed) {
                            // THIS IS FOR INSTANT JOIN
                            //generateTwilioAcccessToken(obj, hasJoinCall,currentMgs)
                            // todo : time being commented for if join to user  disconnet the call then link can be expire
                            if (currentMgs != "") {
                                chatService.getVideoConferencingIDToUser(currentMgs.Id).then(function (result) {
                                    $scope.videoConferencingId = result;
                                    chatService.checkVideoCallLinkIsExpired($scope.videoConferencingId).then(function (result) {
                                        if (result) {
                                            // if($scope.videoConferencingId != 0){
                                            swal('This video call link is expired.')
                                            return;
                                            // }
                                            // else{
                                            //     generateTwilioAcccessToken(obj, hasJoinCall,currentMgs)
                                            // }
                                        }
                                        else
                                            generateTwilioAcccessToken(obj, hasJoinCall, currentMgs)
                                    })

                                })
                            }
                            else
                                generateTwilioAcccessToken(obj, hasJoinCall, currentMgs)
                        }
                        else {
                            // THIS IS FOR SCHEDULE THE VIDEO CALL
                            $scope.schedulelaterDlgOption = {
                                //width: "40%",
                                //height: "40%",
                                visible: false,
                                actions: [
                                    "Minimize",
                                    "Close"
                                ]
                            };

                            //$scope.ScheduleForTime=  new Date();
                            $scope.schedulelaterDlgOptionWindow.setOptions($scope.schedulelaterDlgOption);
                            //$scope.window.center();  // open dailog in center of screen
                            $scope.schedulelaterDlgOptionWindow.open();
                            angular.element('.svcall').parent().addClass('z-i-10007').removeClass('vcallheight');
                            $scope.schedulelaterDlgOptionWindow.title("RadFlow Secure V-Call Schedule Meeting")
                        }
                    });
            }
            else {
                // this is for JOIN NOW message 
                // todo : time being commented for if join to user  disconnet the call then link can be expire
                chatService.getVideoConferencingIDToUser(currentMgs.Id).then(function (result) {
                    $scope.videoConferencingId = result;
                    chatService.checkVideoCallLinkIsExpired($scope.videoConferencingId).then(function (result) {
                        if (result) {
                            // if($scope.videoConferencingId != 0){
                            swal('This video call link is expired.')
                            return;
                            // }
                            // else
                            //     generateTwilioAcccessToken(obj, hasJoinCall,currentMgs)
                        }
                        else {
                            var today = new Date();
                            var messageScheduleTime = currentMgs.Message.split(/\r?\n/);
                            var messageScheduled = messageScheduleTime.at(-1)
                            var dateTimeLocalUTCCallScheduled = new Date((messageScheduled + ':00').replace(/-/g, "/"));
                            var fromdatetime = new Date(dateTimeLocalUTCCallScheduled.getFullYear(), dateTimeLocalUTCCallScheduled.getMonth(), dateTimeLocalUTCCallScheduled.getDate(), dateTimeLocalUTCCallScheduled.getHours(), dateTimeLocalUTCCallScheduled.getMinutes(), 0);
                            var todayDatetime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), 0);



                            if (fromdatetime > todayDatetime) { swal("The scheduled v-call can't be started for the current date/time."); return; };
                            // if (todayDatetime > fromdatetime) {
                            //     console.log(`${todayDatetime} is less than ${fromdatetime}`);
                            //   } else if (todayDatetime > fromdatetime) {
                            //     console.log(`${todayDatetime} is greater than ${fromdatetime}`);
                            //   } else {
                            //     console.log(`Both dates are equal`);
                            //   }
                            if (currentMgs.Message == 'Video Call Link') {
                                generateTwilioAcccessToken(obj, true, currentMgs);
                            }
                            else if (messageScheduleTime.at(-3) != undefined) {
                                if (currentMgs.Message.includes('wants to consult a study for the below procedure'))
                                    generateTwilioAcccessToken(messageScheduleTime.at(-2).trim(), true, currentMgs);
                                else
                                    generateTwilioAcccessToken(messageScheduleTime.at(-3).trim(), true, currentMgs);
                            }
                            else
                                generateTwilioAcccessToken(messageScheduleTime.at(-1).trim(), true, currentMgs);
                        }
                    })

                })
                // generateTwilioAcccessToken(obj, hasJoinCall,currentMgs)
            }
        }

        function generateTwilioAcccessToken(obj, hasJoinCall, currentMgs) {

            //else{
            if (!currentMgs) {
                if (hasJoinCall) {
                    $scope.roomName = obj + " " + $scope.currFirstName.trim() + " " + $scope.currLastName.trim();
                }
                else {
                    $scope.roomName = $scope.currFirstName.trim() + " " + $scope.currLastName.trim() + " " + obj;
                }
            }
            else if (currentMgs.Message == 'Video Call Link') {
                $scope.roomName = obj + " " + $scope.currFirstName.trim() + " " + $scope.currLastName.trim();//
            }
            else if (currentMgs.Message.includes('Call has been scheduled')) {
                $scope.roomName = obj;//$scope.currFirstName.trim() +" "+ $scope.currLastName.trim() +" "+ obj;                    
            }
            else if (currentMgs.Message.includes('wants to consult a study for the below procedure')) {
                $scope.roomName = obj;
            }
            else {
                $scope.roomName = currentMgs.Message.replace(' Video Call Link', '');
            }
            if (hasJoinCall) {
                //chatService.
            }
            chatService.getAccessTwilioToken($scope.currFirstName + " " + $scope.currLastName, $scope.roomName).then(function (result) {
                //chatService.getAccessTwilioToken($scope.paramVideoObj).then(function(result){
                $scope.DlgOptions = {
                    //width: "40%",
                    //height: "40%",
                    visible: false,
                    actions: [
                        "Minimize",
                        "Maximize",
                        "Close"
                    ],
                    minimize: function () {
                        $('.kwindo-RadSceureVCall').addClass('modalSeVCall');
                        $('.modalSeVCall').addClass('sm-vidCallSection');
                        $('.modal-RadSceureVCall').show();
                        setTimeout(function () {
                            $('.kwindo-RadSceureVCall').find('[aria-label="window-restore"]').addClass('custom-krestore');
                            $('a.custom-krestore').click(function () {
                                $('.kwindo-RadSceureVCall').removeClass('modalSeVCall sm-vidCallSection modalSeVCallDragg').addClass('k-widget');
                            });
                        }, 500);
                    },
                    maximize: function () {
                        $('.kwindo-RadSceureVCall').removeClass('modalSeVCall sm-vidCallSection modalSeVCallDragg');
                    }
                };
                if (currentMgs) {
                    videoCallConvertToJsonObject(currentMgs.Message);
                }
                $scope.window.setOptions($scope.DlgOptions);
                //$scope.window.center();  // open dailog in center of screen
                $scope.window.open();
                angular.element('.svcall').parent().addClass('z-i-10007 vcallheight');
                $scope.window.title("RadFlow Secure V-Call");
                addLocalVideo();
                token = result;
                // $('#container').modal('hide');
                // $('#container').modal('show');
                connectedUseName = obj;
                connectButtonHandler(obj, hasJoinCall);
                isshowViedoChatScreen = true;
                $('.kwindo-RadSceureVCall').removeClass('modalSeVCall sm-vidCallSection modalSeVCallDragg').addClass('k-widget');
                // JS for move minimized video call window
                var $draggingVidEle = null;
                $(document.body).on("mousemove", function (e) {
                    if ($draggingVidEle) {
                        $(".kwindo-RadSceureVCall.k-window").removeClass('modalSeVCall k-widget').addClass('modalSeVCallDragg');
                        $(".kwindo-RadSceureVCall.k-window").offset({
                            top: e.pageY,
                            left: e.pageX
                        });
                    }
                });
                $(document.body).on("mousedown", ".k-widget.k-window.vcallheight.modalSeVCall", function (e) {
                    $draggingVidEle = $(e.target);
                });
                $(document.body).on("mouseup", function (e) {
                    $draggingVidEle = null;
                });

                //setTimeout(function () {
                //    $('.vidCallFullScrIcon').click(function () {
                //        $(this).parent().toggleClass('participantZoomed pos-rel');
                //        $(this).parent().find('video').toggleClass('participantZoomed');
                //    });
                //}, 100);
            })
            //}
        }

        //const connectButtonHandler = async (username) => {
        function connectButtonHandler(username, hasJoinCall) {
            //event.preventDefault();
            if (!connected) {
                buttonJoin.disabled = true;
                //buttonJoin.innerHTML = 'Connecting...';
                try {
                    connect(username, hasJoinCall);
                    //buttonJoin.innerHTML = 'Leave call';
                    angular.element('#join_leave').addClass('joincall-off');
                    buttonJoin.disabled = false;
                }
                catch (er) {
                    //swal('Connection failed. Is the backend running?');
                    toaster.error({ body: "Connection failed. Is the backend running?" });
                    buttonJoin.innerHTML = 'Join call';
                    buttonJoin.disabled = false;
                }
            }
            else {
                disconnect();
                //buttonJoin.innerHTML = 'Join call';
                //shareScreen.innerHTML = 'Share screen';
                shareScreen.disabled = true;
                connected = false;
            }
        };

        // connect with participant
        function connect(username, hasJoinCall) {
            buttonJoin.disabled = true;
            //buttonJoin.innerHTML = 'Connecting...';
            $q.all([
                Twilio.Video.connect(token, { dominantSpeaker: true })
            ]).then(function (data) {

                room = data[0];
                $sessionStorage.room = room;
                room.participants.forEach(participantConnected);
                room.on('dominantSpeakerChanged', function (participant) {
                    handleSpeakerChange(participant);
                });
                room.on('participantConnected', participantConnected);
                room.on('participantDisconnected', participantDisconnected);

                connected = true;
                var leftDiv = document.createElement("div"); //Create left div
                leftDiv.id = "left"; //Assign div id
                leftDiv.setAttribute("style", "float:left; width:66.5%; line-height: 26px; text-align:left; font-size:12pt; padding-left:8px; height:26px;"); //Set div attributes
                leftDiv.style.background = "#FF0000";
                var a = document.createElement('a');
                a.href = 'google.com';
                //a.innerHTML = $scope.currFirstName.trim() +" "+ $scope.currLastName.trim() +' '+"Sent Video Call Link" 

                if (multipleOrderWorkList) {
                    $scope.showVideoChatLoader = true;
                    $scope.isHighPriority = true;
                    //$scope.roomName = $scope.currFirstName.trim() +" "+ $scope.currLastName.trim()+' '+ $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                    var dicomViewerURL = multipleOrderWorkList.DicomViewerURL != undefined ? multipleOrderWorkList.DicomViewerURL : '';
                    var dicomViewer = multipleOrderWorkList.DicomViewer != undefined ? multipleOrderWorkList.DicomViewer : '';
                    var site = multipleOrderWorkList.Site != null ? multipleOrderWorkList.Site : '';
                    a.textContent = "wants to consult a study for the below procedure. \n Location : " + multipleOrderWorkList.Location + "\n DOS : " + moment.utc(multipleOrderWorkList.OrderDate).format('MM-DD-YYYY HH:mm') + "\n Accession : " + multipleOrderWorkList.Accession + " \n MRN : " + multipleOrderWorkList.PatientMRN + " \n Patient Name : " + multipleOrderWorkList.PatientName + " \n Gender : " + multipleOrderWorkList.PatientGender + " \n DOB : " + moment.utc(multipleOrderWorkList.PatientDOB).format('MM-DD-YYYY') + " \n Modality : " + multipleOrderWorkList.Modality + " \n Type : " + multipleOrderWorkList.PatientClass + " \n Procedure Desc : " + multipleOrderWorkList.ProcedureDesc + " \n Ordering Physician : " + multipleOrderWorkList.OrderingPhysician + " \n Dicom Viewer URL : " + dicomViewerURL + " \n Dicom Viewer : " + dicomViewer + " \n Site : " + site + "\n in the video chat room \n " + $scope.roomName + "\n Please click Join now;";
                    $scope.message = a.textContent;
                    $scope.sendMessage($scope.message);
                    multipleOrderWorkList = null;
                }
                if (!hasJoinCall) {
                    $scope.showVideoChatLoader = true;
                    // setTimeout(function(){
                    a.textContent = "Video Call Link"
                    leftDiv.appendChild(a);
                    //document.body.appendChild(leftDiv);
                    //chatinner.appendChild(leftDiv);
                    $scope.isHighPriority = true;
                    $scope.message = leftDiv.textContent;
                    $scope.sendMessage($scope.message);

                    shareScreen.disabled = false;
                    muteUnmuteAudioButton.disabled = false;
                    muteUnmuteVideoButton.disabled = false;
                    //console.log(room);
                    //},200 )
                }
                else {
                    shareScreen.disabled = false;
                    //console.log(room);
                }
            });
            //room = await Twilio.Video.connect(token);

            //updateParticipantCount();

        };

        function handleSpeakerChange(participant) {
            removeDominantSpeaker();
            if (participant !== null)
                assignDominantSpeaker(participant);
        }
        var lastSpeakerSID = null; // add this at the top with the other variable declarations

        function setLabelColor(label, color) {
            if (label !== null) {
                label.style.backgroundColor = color;
            }
        }

        function removeDominantSpeaker() {
            var speakerNameLabel;
            speakerNameLabel = document.getElementById(lastSpeakerSID);
            setLabelColor(speakerNameLabel, "#717177"); // default color
            //setLabelColor(speakerNameLabel, "#ebebeb"); // default color
        }

        function assignDominantSpeaker(participant) {
            var domSpeakerNameLabel;
            lastSpeakerSID = "N_" + participant.sid;
            domSpeakerNameLabel = document.getElementById(lastSpeakerSID);
            setLabelColor(domSpeakerNameLabel, "#1f9b84"); // green color
            //setLabelColor(domSpeakerNameLabel, "#b5e7a0"); // green color
        }

        //const disconnect = () => {
        function disconnect() {
            if (room) {
                room.localParticipant.tracks.forEach(function (publication) {
                    var attachedElements = publication.track.detach();

                    attachedElements.forEach(function (element) { element.remove() });
                    publication.unpublish();
                    publication.track.stop();
                });
                room.disconnect();
            }
            if (localVideoTrack != null) {
                localVideoTrack.stop();
            }
            while (container.lastChild.id != 'local') {
                container.removeChild(container.lastChild);
            }

            $scope.roomName = "";
            $scope.selectedOrder = null;
            //buttonJoin.innerHTML = 'Join call';
            isshowViedoChatScreen = false;
            //muteUnmuteAudioButton.innerHTML = 'Mute Audio';
            //muteUnmuteVideoButton.innerHTML = 'Mute Video';
            angular.element('#mute-unmute-audio-button').removeClass('mic-off');
            angular.element('#mute-unmute-audio-button').addClass('mic-on').attr("title", "Mute audio");
            angular.element('#mute-unmute-video-button').removeClass('video-off');
            angular.element('#mute-unmute-video-button').addClass('video-on').attr("title", "Mute video");
            angular.element('#share_screen').removeClass('sharescreen-off');
            angular.element('#share_screen').addClass('sharescreen-on');
            connected = false;

            setTimeout(function () {
                logVideoCallEndTime();
                $scope.window.close();
            }, 10);

            //$sessionStorage.room =null;
            //$('#container').modal('hide');
            // $scope.window.close();
            // buttonJoin.innerHTML = 'Join call';
            // isshowViedoChatScreen = false;
            // connected = false;
            // updateParticipantCount();
        };

        $scope.closeKendoVideoChat = function () {
            //
            disconnect();
        }
        $scope.closeKendoScheduleLater = function () {
            setTimeout(function () { $scope.schedulelaterDlgOptionWindow.close(); }, 100)
        }
        $scope.CancelScheduleLater = function () {
            $scope.closeKendoScheduleLater();
            $scope.ScheduleForDateNew = {};
            //$scope.ScheduleForTime = new Date();;
        }
        $scope.scheduleForDateOpen = function () {
            $scope.scheduleForDatepopup.opened = true;
        };
        $scope.scheduleForDatepopup = {
            opened: false
        };
        function logVideoCallEndTime() {
            if ($scope.videoConferencingId) {
                setTimeout(function () {
                    chatService.LogVideoCallEndTime($scope.videoConferencingId).then(function (result) {

                    })
                }, 100);

            }
        }

        function videoCallConvertToJsonObject(curVMMessage) {
            $scope.selectedOrder = angular.fromJson(curVMMessage.split(/\r?\n/).slice(1, 15));
            if (curVMMessage.includes('Location')) {
                $scope.selectedOrder = {
                    "Location": $scope.selectedOrder[0].substring($scope.selectedOrder[0].indexOf(':') + 1).trim(),
                    "OrderDate": $scope.selectedOrder[1].substring($scope.selectedOrder[1].indexOf(':') + 1),//moment.utc($scope.selectedOrder[1].substring($scope.selectedOrder[1].indexOf(':')+1)).format('MM-DD-YYYY HH:mm'),
                    "Accession": $scope.selectedOrder[2].substring($scope.selectedOrder[2].indexOf(':') + 1).trim(),
                    "PatientMRN": $scope.selectedOrder[3].substring($scope.selectedOrder[3].indexOf(':') + 1).trim(),
                    "PatientName": $scope.selectedOrder[4].substring($scope.selectedOrder[4].indexOf(':') + 1).trim(),
                    "PatientGender": $scope.selectedOrder[5].substring($scope.selectedOrder[5].indexOf(':') + 1).trim(),
                    "PatientDOB": $scope.selectedOrder[6].substring($scope.selectedOrder[6].indexOf(':') + 1),//moment.utc($scope.selectedOrder[6].substring($scope.selectedOrder[6].indexOf(':')+1)).format('MM-DD-YYYY'),
                    "Modality": $scope.selectedOrder[7].substring($scope.selectedOrder[7].indexOf(':') + 1).trim(),
                    "PatientClass": $scope.selectedOrder[8].substring($scope.selectedOrder[8].indexOf(':') + 1).trim(),
                    "ProcedureDesc": $scope.selectedOrder[9].substring($scope.selectedOrder[9].indexOf(':') + 1).trim(),
                    "OrderingPhysician": $scope.selectedOrder[10].substring($scope.selectedOrder[10].indexOf(':') + 1).trim(),
                    "DicomViewerURL": $scope.selectedOrder[11].substring($scope.selectedOrder[11].indexOf(':') + 1).trim(),
                    "DicomViewer": $scope.selectedOrder[12].substring($scope.selectedOrder[12].indexOf(':') + 1).trim(),
                    "Site": $scope.selectedOrder[13].substring($scope.selectedOrder[13].indexOf(':') + 1).trim(),
                }
            }
        }

        $scope.SaveOnCallScheduleLater = function (valid) {
            if (!$scope.isRescheduled) {
                if (!valid)
                    return;
                var today = new Date();
                var fromdatetime = new Date(moment($scope.ScheduleForDateNew.date).year(), moment($scope.ScheduleForDateNew.date).month(), moment($scope.ScheduleForDateNew.date).date(), moment($scope.ScheduleForDateNew.date).hour(), moment($scope.ScheduleForDateNew.date).minutes(), 0);
                var todatetime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), 0);

                if (todatetime > fromdatetime) { swal("The v-call can't be scheduled for the previous date/Time."); return; };

                var objVM = {
                    FromDate: formatted_date(fromdatetime),
                    FromTime: formatted_time(fromdatetime)
                }
                var leftDiv = document.createElement("div"); //Create left div
                leftDiv.id = "left"; //Assign div id
                leftDiv.setAttribute("style", "float:left; width:66.5%; line-height: 26px; text-align:left; font-size:12pt; padding-left:8px; height:26px;"); //Set div attributes
                leftDiv.style.background = "#FF0000";
                var a = document.createElement('a');
                a.href = 'google.com';

                if (multipleOrderWorkList) {
                    $scope.isHighPriority = true;
                    $scope.dateTimeLocalUTCCallScheduled = new Date((objVM.FromDate + ' ' + objVM.FromTime + ':00').replace(/-/g, "/"));// moment.utc(objVM.FromDate+' '+objVM.FromTime).format('M/D/YYYY HH:mm')
                    $scope.dateTimeLocalUTCCallScheduled = moment.utc($scope.dateTimeLocalUTCCallScheduled).format("MM-DD-YYYY HH:mm");
                    $scope.roomName = $scope.currFirstName.trim() + " " + $scope.currLastName.trim() + ' ' + $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                    var dicomViewerURL = multipleOrderWorkList.DicomViewerURL != undefined ? multipleOrderWorkList.DicomViewerURL : '';
                    var dicomViewer = multipleOrderWorkList.DicomViewer != undefined ? multipleOrderWorkList.DicomViewer : '';
                    var site = multipleOrderWorkList.Site != null ? multipleOrderWorkList.Site : '';
                    a.textContent = "Call has been scheduled to consult a study for the below procedure. \n Location : " + multipleOrderWorkList.Location +
                        "\n DOS : " + moment.utc(multipleOrderWorkList.FormattedOrderDate).format("MM-DD-YYYY HH:mm") +
                        " \n Accession : " + multipleOrderWorkList.Accession +
                        " \n MRN : " + multipleOrderWorkList.PatientMRN +
                        " \n Patient Name : " + multipleOrderWorkList.PatientName +
                        " \n Gender : " + multipleOrderWorkList.PatientGender +
                        " \n DOB : " + moment.utc(multipleOrderWorkList.PatientDOB).format("MM-DD-YYYY") +
                        " \n Modality : " + multipleOrderWorkList.Modality +
                        " \n Type : " + multipleOrderWorkList.PatientClass +
                        " \n Procedure Desc : " + multipleOrderWorkList.ProcedureDesc +
                        " \n Ordering Physician : " + multipleOrderWorkList.OrderingPhysician +
                        " \n Dicom Viewer URL : " + dicomViewerURL +
                        " \n Dicom Viewer : " + dicomViewer +
                        " \n Site : " + site +
                        "\n in the video chat room \n " + $scope.roomName +
                        "\n Please join on this time. \n" + $scope.dateTimeLocalUTCCallScheduled;
                    $scope.message = a.textContent;
                    $scope.sendMessage($scope.message);
                    $scope.message = '';
                    multipleOrderWorkList = null;
                    $scope.closeKendoScheduleLater();
                    $scope.isHighPriority = false;
                }
                else { //moment().utc().format('MM/DD/YYYY HH:mm:ss')
                    $scope.dateTimeLocalUTCCallScheduled = new Date((objVM.FromDate + ' ' + objVM.FromTime + ':00').replace(/-/g, "/"));//moment.utc(Date((objVM.FromDate+' '+objVM.FromTime).replace(/ /g,'T'))) //moment.utc((objVM.FromDate+' '+objVM.FromTime).replace(/ /g,'T')).format('M/D/YYYY HH:mm')
                    $scope.dateTimeLocalUTCCallScheduled = moment.utc($scope.dateTimeLocalUTCCallScheduled).format("MM-DD-YYYY HH:mm")
                    $scope.roomName = $scope.currFirstName.trim() + " " + $scope.currLastName.trim() + ' ' + $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                    a.textContent = "Call has been scheduled \n in the video chat room \n " + $scope.roomName + "\n Please join on this time. \n" + $scope.dateTimeLocalUTCCallScheduled;
                    leftDiv.appendChild(a);
                    $scope.isHighPriority = true;
                    $scope.message = leftDiv.textContent;
                    $scope.sendMessage($scope.message);
                    $scope.message = '';
                    $scope.closeKendoScheduleLater();
                    $scope.isHighPriority = false;
                }
            }
            else {
                reScheduledCallMessage();
            }
        }

        var formatted_date = function (date) {
            if (date != null) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero 
                var y = date.getFullYear();
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        var formatted_time = function (date) {

            if (date != null) {
                var h = ("0" + (date.getHours())).slice(-2); // in javascript month start from 0.
                var m = ("0" + date.getMinutes()).slice(-2); // add leading zero             
                return h + ':' + m;
            }
            else {
                return null;
            }
        };

        //const participantConnected = (participant) => {
        function participantConnected(participant) {
            var participantDiv = document.createElement('div');
            participantDiv.setAttribute('id', participant.sid);
            participantDiv.setAttribute('class', 'participant');

            var tracksDiv = document.createElement('div');
            tracksDiv.setAttribute('class', 'pos-rel');
            participantDiv.appendChild(tracksDiv);

            var labelDiv = document.createElement('div');
            labelDiv.textContent = participant.identity;
            labelDiv.setAttribute('class', 'nameLabel');
            // Add unique SID to the name tag
            labelDiv.setAttribute('id', 'N_' + participant.sid);
            //labelDiv.innerHTML = connectedUseName;
            participantDiv.appendChild(labelDiv);

            container.appendChild(participantDiv);

            //tracksDiv.appendChild($scope.spanFullScreen);
            // participant.tracks.forEach(publication => {
            //   if (publication.isSubscribed) {
            //     trackSubscribed(tracksDiv, publication.track);
            //   }
            // });
            participant.tracks.forEach(function (publication) {
                if (publication.isSubscribed) {
                    trackSubscribed(tracksDiv, publication.track);
                }
            });
            participant.on('trackSubscribed', function (track) { trackSubscribed(tracksDiv, track) });
            participant.on('trackUnsubscribed', trackUnsubscribed);
            //updateParticipantCount();
        };

        function participantDisconnected(participant) {
            document.getElementById(participant.sid).remove();
            //updateParticipantCount();
        };

        function trackSubscribed(div, track) {
            var trackElement = track.attach();
            trackElement.addEventListener('click', function () { zoomTrack(trackElement); });
            div.appendChild(trackElement);
        };

        function trackUnsubscribed(track) {
            track.detach().forEach(function (element) { element.remove() });
        };
        function zoomTrack(trackElement) {
            //console.log('function zoomTrack(trackElement) {');
            if (!trackElement.classList.contains('participantZoomed')) {
                // zoom in
                container.childNodes.forEach(function (participant) {
                    if (participant.className == 'participant') {
                        participant.childNodes[0].childNodes.forEach(function (track) {
                            if (track === trackElement) {
                                track.classList.add('participantZoomed');
                                track.parentNode.classList.add('participantZoomed');
                                track.parentNode.classList.remove('pos-rel');
                                //document.querySelector('.vidCallFullScrIcon').classList.remove('participantHidden');
                                //document.querySelector('.vidCallFullScrIcon').setAttribute('title', 'Exit full screen');
                                //if (track.parentNode.classList.contains('participantZoomed')) {
                                //    document.querySelector('.vidCallFullScrIcon').classList.add('icon-flscrn');
                                //}
                            }
                            else {
                                track.classList.add('participantHidden')
                            }
                        });
                        participant.childNodes[1].classList.add('participantHidden');
                    }
                });
            }
            else {
                // zoom out
                container.childNodes.forEach(function (participant) {
                    if (participant.className == 'participant') {
                        participant.childNodes[0].childNodes.forEach(function (track) {
                            if (track === trackElement) {
                                track.classList.remove('participantZoomed');
                                track.parentNode.classList.remove('participantZoomed');
                                track.parentNode.classList.add('pos-rel');
                                //document.querySelector('.vidCallFullScrIcon').setAttribute('title', 'Full screen')
                                //if (document.querySelector('.vidCallFullScrIcon').classList.contains('icon-flscrn')) {
                                //    document.querySelector('.vidCallFullScrIcon').classList.remove('icon-flscrn');
                                //}
                            }
                            else {
                                track.classList.remove('participantHidden');
                            }
                        });
                        participant.childNodes[1].classList.remove('participantHidden');
                    }
                });
            }
        };
        //screen share code.
        function shareScreenHandler() {
            //event.preventDefault();
            if (!screenTrack) {
                navigator.mediaDevices.getDisplayMedia().then(function (stream) {
                    $scope.window.minimize();
                    screenTrack = new Twilio.Video.LocalVideoTrack(stream.getTracks()[0]);
                    room.localParticipant.publishTrack(screenTrack);
                    //shareScreen.innerHTML = 'Stop sharing';
                    angular.element('#share_screen').removeClass('sharescreen-on');
                    angular.element('#share_screen').addClass('sharescreen-off').attr("title", "Stop share");
                    screenTrack.mediaStreamTrack.onended = function () { shareScreenHandler() };
                }).catch(function (er) {
                    //swal('Could not share the screen.');
                    toaster.error({ body: "Could not share the screen." });
                });
            }
            else {
                $scope.window.restore();
                $('.kwindo-RadSceureVCall').removeClass('modalSeVCall sm-vidCallSection');
                room.localParticipant.unpublishTrack(screenTrack);
                screenTrack.stop();
                screenTrack = null;
                //shareScreen.innerHTML = 'Share screen';
                angular.element('#share_screen').addClass('sharescreen-on').attr("title", "Share screen");;
                angular.element('#share_screen').removeClass('sharescreen-off');
            }
        };


        function mute(opts) {
            if (!room || !room.localParticipant)
                throw new Error('You must be connected to a room to mute tracks.');

            if (opts.audio) {
                angular.element('#mute-unmute-audio-button').removeClass('mic-on').attr("title", "Mute audio");
                angular.element('#mute-unmute-audio-button').addClass('mic-off').attr("title", "Unmute audio");
                room.localParticipant.audioTracks.forEach(
                    function (publication) { publication.track.disable() }
                );
            }

            if (opts.video) {
                angular.element('#mute-unmute-video-button').removeClass('video-on').attr("title", "Mute video");
                angular.element('#mute-unmute-video-button').addClass('video-off').attr("title", "Unmute video");
                room.localParticipant.videoTracks.forEach(
                    function (publication) { publication.track.disable() }
                );
            }
        }
        function unmute(opts) {
            if (!room || !room.localParticipant)
                throw new Error('You must be connected to a room to unmute tracks.');

            if (opts.audio) {
                angular.element('#mute-unmute-audio-button').removeClass('mic-off').attr("title", "Unmute audio");
                angular.element('#mute-unmute-audio-button').addClass('mic-on').attr("title", "Mute audio");
                room.localParticipant.audioTracks.forEach(
                    function (publication) { publication.track.enable() }
                );
            }

            if (opts.video) {
                angular.element('#mute-unmute-video-button').removeClass('video-off').attr("title", "Unmute video");
                angular.element('#mute-unmute-video-button').addClass('video-on').attr("title", "Mute video");
                room.localParticipant.videoTracks.forEach(
                    function (publication) { publication.track.enable() }
                );
            }
        }

        function onMuteUnmuteClickAudios() {
            onMuteUnmuteClick(TrackType.Audios)
        }

        function onMuteUnmuteClickVideos() {
            onMuteUnmuteClick(TrackType.Videos)
        }

        function onMuteUnmuteClick(trackType) {
            if (trackType === TrackType.Audios) {
                var opts = { audio: true, video: false };

                isAudioMuted
                    ? unmute(opts)
                    : mute(opts);

                isAudioMuted = !isAudioMuted;

                //isAudioMuted
                //    ? muteUnmuteAudioButton.textContent = 'Unmute Audio'
                //    : muteUnmuteAudioButton.textContent = 'Mute Audio';
                isAudioMuted
                    ? angular.element('#mute-unmute-audio-button').addClass('mic-off').attr("title", "Unmute audio")
                    : angular.element('#mute-unmute-audio-button').addClass('mic-on').attr("title", "Mute audio");
            }

            if (trackType === TrackType.Videos) {
                var opts = { audio: false, video: true };

                isVideoMuted
                    ? unmute(opts)
                    : mute(opts);

                isVideoMuted = !isVideoMuted;

                //isVideoMuted
                //    ? muteUnmuteVideoButton.textContent = 'Unmute Video'
                //    : muteUnmuteVideoButton.textContent = 'Mute Video';
                isVideoMuted
                    ? angular.element('#mute-unmute-video-button').addClass('video-off').attr("title", "Unmute video")
                    : angular.element('#mute-unmute-video-button').addClass('video-on').attr("title", "Mute video");
            }
        }

        buttonJoin.addEventListener('click', connectButtonHandler);
        shareScreen.addEventListener('click', shareScreenHandler);
        muteUnmuteAudioButton.addEventListener('click', onMuteUnmuteClickAudios);
        muteUnmuteVideoButton.addEventListener('click', onMuteUnmuteClickVideos);

        $scope.shareVideoCallDetails = function () {
            swal({
                title: "Are you sure, you want to allow another user to join the Radflow Secure V-Call?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true

            },
                function (isConfirm) {
                    if (isConfirm) {
                        ShareRoomDetails();
                    }
                });
        }
        function ShareRoomDetails() {
            $scope.isChatMenuActive = true;
            $scope.isShowChatWindow = false;
            $scope.isShareChatLink = true;
            angular.element('.chatsec .control-sidebar').addClass('addUsrZin');
        }
        $scope.scheduledCallJoin = function (currentMgs) {
            chatService.getVideoConferencingIDToUser(currentMgs.Id).then(function (result) {
                $scope.videoConferencingId = result;
                chatService.checkVideoCallLinkIsExpired($scope.videoConferencingId).then(function (result) {
                    if (result) {
                        swal('This video call link is expired.')
                        return;
                    }
                    else {
                        var today = new Date();
                        var messageScheduleTime = currentMgs.Message.split(/\r?\n/);
                        var messageScheduled = messageScheduleTime.at(-1)
                        var dateTimeLocalUTCCallScheduled = new Date((messageScheduled + ':00').replace(/-/g, "/"));
                        var fromdatetime = new Date(dateTimeLocalUTCCallScheduled.getFullYear(), dateTimeLocalUTCCallScheduled.getMonth(), dateTimeLocalUTCCallScheduled.getDate(), dateTimeLocalUTCCallScheduled.getHours(), dateTimeLocalUTCCallScheduled.getMinutes(), 0);
                        var todayDatetime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), 0);

                        if (fromdatetime > todayDatetime) { swal("The scheduled v-call can't be started for the current date/Time."); return; };
                        // if (todayDatetime > fromdatetime) {
                        //     console.log(`${todayDatetime} is less than ${fromdatetime}`);
                        //   } else if (todayDatetime > fromdatetime) {
                        //     console.log(`${todayDatetime} is greater than ${fromdatetime}`);
                        //   } else {
                        //     console.log(`Both dates are equal`);
                        //   }
                        // if(messageScheduleTime.at(-3) != undefined)
                        //     generateTwilioAcccessToken(messageScheduleTime.at(-3).trim(), true,currentMgs);
                        // else
                        //     generateTwilioAcccessToken(messageScheduleTime.at(-1).trim(), true,currentMgs);

                        if (messageScheduleTime.at(-3) != undefined) {
                            if (currentMgs.Message.includes('wants to consult a study for the below procedure'))
                                generateTwilioAcccessToken(messageScheduleTime.at(-2).trim(), true, currentMgs);
                            else
                                generateTwilioAcccessToken(messageScheduleTime.at(-3).trim(), true, currentMgs);
                        }
                        else
                            generateTwilioAcccessToken(messageScheduleTime.at(-1).trim(), true, currentMgs);
                    }
                })
            })
        }

        $scope.reScheduledCall = function (currentMgs) {
            $scope.oldRescheduledMsg = currentMgs;
            chatService.getVideoConferencingIDToUser(currentMgs.Id).then(function (result) {
                $scope.videoConferencingId = result;
                chatService.checkVideoCallLinkIsExpired($scope.videoConferencingId).then(function (result) {
                    if (result) {
                        swal('This video call link is expired, so you can not reschedule the call.')
                        return;
                    }
                    else {
                        $scope.isRescheduled = true;
                        $scope.ScheduleForDateNew = {};
                        $scope.schedulelaterDlgOption = {
                            //width: "40%",
                            //height: "40%",
                            visible: false,
                            actions: [
                                "Minimize",
                                "Close"
                            ]
                        };
                        //$scope.ScheduleForTime=  new Date();
                        $scope.schedulelaterDlgOptionWindow.setOptions($scope.schedulelaterDlgOption);
                        //$scope.window.center();  // open dailog in center of screen
                        $scope.schedulelaterDlgOptionWindow.open();
                        angular.element('.svcall').parent().addClass('z-i-10007').removeClass('vcallheight');
                        $scope.schedulelaterDlgOptionWindow.title("Re-schedule RadFlow Secure V-Call Schedule Meeting");
                    }
                })

            })
        }
        function reScheduledCallMessage() {
            //console.log($scope.videoConferencingId)
            expirePreviousScheduledVideoCall($scope.oldRescheduledMsg);
            var today = new Date();
            var fromdatetime = new Date(moment($scope.ScheduleForDateNew.date).year(), moment($scope.ScheduleForDateNew.date).month(), moment($scope.ScheduleForDateNew.date).date(), moment($scope.ScheduleForDateNew.date).hour(), moment($scope.ScheduleForDateNew.date).minutes(), 0);
            var todatetime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), today.getMinutes(), 0);

            if (todatetime > fromdatetime) { swal("The v-call can't be scheduled for the previous date/Time."); return; };

            var objVM = {
                FromDate: formatted_date(fromdatetime),
                FromTime: formatted_time(fromdatetime)
            }
            var leftDivreScheduled = document.createElement("div"); //Create left div
            leftDivreScheduled.id = "leftDivreScheduled"; //Assign div id
            leftDivreScheduled.setAttribute("style", "float:left; width:66.5%; line-height: 26px; text-align:left; font-size:12pt; padding-left:8px; height:26px;"); //Set div attributes
            leftDivreScheduled.style.background = "#FF0000";
            var areScheduled = document.createElement('areScheduled');
            areScheduled.href = 'google.com';

            if ($scope.oldRescheduledMsg.Message.includes('Call has been scheduled to consult a study for the below procedure.')) {
                videoCallConvertToJsonObject($scope.oldRescheduledMsg.Message);

                $scope.isHighPriority = true;
                $scope.dateTimeLocalUTCCallScheduled = new Date((objVM.FromDate + ' ' + objVM.FromTime + ':00').replace(/-/g, "/"));// moment.utc(objVM.FromDate+' '+objVM.FromTime).format('M/D/YYYY HH:mm')
                $scope.dateTimeLocalUTCCallScheduled = moment.utc($scope.dateTimeLocalUTCCallScheduled).format("MM-DD-YYYY HH:mm");
                $scope.roomName = $scope.currFirstName.trim() + " " + $scope.currLastName.trim() + ' ' + $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                var dicomViewerURL = $scope.selectedOrder.DicomViewerURL != undefined ? $scope.selectedOrder.DicomViewerURL : '';
                var dicomViewer = $scope.selectedOrder.DicomViewer != undefined ? $scope.selectedOrder.DicomViewer : '';
                var site = $scope.selectedOrder.Site != null ? $scope.selectedOrder.Site : '';
                areScheduled.textContent = "Rescheduled!! Call has been scheduled to consult a study for the below procedure. \n Location : " + $scope.selectedOrder.Location + " \n DOS : " + moment.utc($scope.selectedOrder.OrderDate).format("MM-DD-YYYY HH:mm") + " \n Accession : " + $scope.selectedOrder.Accession + " \n MRN : " + $scope.selectedOrder.MRN + " \n Patient Name : " + $scope.selectedOrder.PatientName + " \n Gender : " + $scope.selectedOrder.PatientGender + " \n DOB : " + moment.utc($scope.selectedOrder.PatientDOB).format("MM-DD-YYYY") + " \n Modality : " + $scope.selectedOrder.Modality + " \n Type : " + $scope.selectedOrder.PatientClass + " \n Procedure Desc : " + $scope.selectedOrder.ProcedureDesc + " \n Ordering Physician : " + $scope.selectedOrder.OrderingPhysician + " \n Dicom Viewer URL : " + dicomViewerURL + " \n Dicom Viewer : " + dicomViewer + " \n Site : " + site + " \n in the video chat room \n " + $scope.roomName + "\n Please join on this time. \n" + $scope.dateTimeLocalUTCCallScheduled;
                $scope.message = areScheduled.textContent;
                $scope.sendMessage($scope.message);
                $scope.message = '';
                $scope.oldRescheduledMsg = null;
                $scope.closeKendoScheduleLater();
                $scope.isHighPriority = false;
                $scope.isRescheduled = false;
            }
            else { //moment().utc().format('MM/DD/YYYY HH:mm:ss')
                $scope.dateTimeLocalUTCCallScheduled = new Date((objVM.FromDate + ' ' + objVM.FromTime + ':00').replace(/-/g, "/"));//moment.utc(Date((objVM.FromDate+' '+objVM.FromTime).replace(/ /g,'T'))) //moment.utc((objVM.FromDate+' '+objVM.FromTime).replace(/ /g,'T')).format('M/D/YYYY HH:mm')
                $scope.dateTimeLocalUTCCallScheduled = moment.utc($scope.dateTimeLocalUTCCallScheduled).format("MM-DD-YYYY HH:mm")
                $scope.roomName = $scope.currFirstName.trim() + " " + $scope.currLastName.trim() + ' ' + $scope.selectedUserObject.FirstName.trim() + ' ' + $scope.selectedUserObject.LastName.trim();
                areScheduled.textContent = "Rescheduled!! Call has been scheduled \n in the video chat room \n " + $scope.roomName + " \n Please join on this time. \n" + $scope.dateTimeLocalUTCCallScheduled;
                leftDivreScheduled.appendChild(areScheduled);
                $scope.isHighPriority = true;
                $scope.message = leftDivreScheduled.textContent;
                $scope.sendMessage($scope.message);
                $scope.message = '';
                $scope.closeKendoScheduleLater();
                $scope.isHighPriority = false;
                $scope.oldRescheduledMsg = null;
                $scope.isRescheduled = false;
            }
        }
        function expirePreviousScheduledVideoCall(obj) {
            chatService.expirePreviousScheduledVideoCall(obj).then(function (result) {

            })
        }

        $scope.OpenExamVideoConf = function (strJson) {
            videoCallConvertToJsonObject(strJson)
            //var patObj = JSON.parse(strJson);

            var accession = $scope.selectedOrder.Accession.trim();
            var patientMRN = $scope.selectedOrder.MRN.trim();
            var dicomViewer = $scope.selectedOrder.DicomViewer.trim();
            var DicomViewerURL = $scope.selectedOrder.DicomViewerURL.trim();
            var Site = $scope.selectedOrder.Site.trim();
            if (dicomViewer == '') {
                dicomViewer = "CI-VIEWER";
            }
            if (dicomViewer == "CI-VIEWER") {
                if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                    window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
                }
                else {
                    windowHandler.openByPreference(__env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 1), "CI-VIEWER-1", 1000, "CI-VIEWER-1-" + accession.toUpperCase().trim(), "", false);
                    //windowHandler.openByPreference(APP_CONSTANTS.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 2), "CI-VIEWER-2", 1000, "", false);
                }
            }
            else if (dicomViewer == "KONICA" || dicomViewer == "KONICATEST" || dicomViewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                $scope.konica_RadFlow = windowHandler.openByPreference(__env._environment.config.konicaBaseURL.replace("@MRN", patientMRN).replace("@ACCESSION", accession).replace("@VIEWER", dicomViewer), dicomViewer, 100, dicomViewer.replace(/\s/g, "").toUpperCase() + "-" + + accession.toUpperCase().trim(), "noreferrer");
            }
            else if (dicomViewer == "SYNAPSE") {

                if (Site.toUpperCase() == 'DECATUR') {
                    accession = accession.toUpperCase().replace('WHS', '');
                }
                RCService.OpenImage({ requestEvent: "openimage", imageRequestDetails: { pacsURL: DicomViewerURL, accessionNumber: accession } })
            }

        }
        //#endregionend

        var activeChatMenuBar = $rootScope.$on('activeChatMenuBar', function (name, isChatMenuActive) {
            //console.log('chat activeChatMenuBar')
            angular.element('.svcall').parent().addClass('z-i-10007');
            $scope.isChatMenuActive = isChatMenuActive;
            $scope.DataObject.SpecialGroupIDs = $sessionStorage.SpecialGroup;
            if ($scope.isChatMenuActive) {
                if ($scope.UserName) {
                    $scope.UserName = null;
                    $scope.isShowChatWindow = false;
                    UserListPageNum = 1;
                    //GetAllUsers();
                }

                $scope.onChatTabChange('All');
                angular.element('.chattabmenu li').removeClass('active');
                angular.element('.chattabmenu li:first-child').addClass('active');
                //scrollPositionSetMessageList();



                //if ($scope.userList && $scope.userList.length == 0) {
                //GetAllUsers();
                //getPinnedUsers();
                //}
            }
            else if (!$scope.isChatMenuActive) {
                $scope.isShowChatWindow = false;
                $scope.selectedUserId = 0;
                scrollPositionSetMessageList();
            }

        });
        var multipleOrderWorkList;

        function dismissChatPanelCompletely() {
            if (!$scope.isChatMenuActive && !$scope.isShowChatWindow) {
                return;
            }
            $rootScope.$broadcast("ChatCurrentUserObject", {});
            $rootScope.$emit('activeChatMenuBar', false);
            $rootScope.$emit('activeChatMenuBar:Chat', false);
            angular.element('.chatsec .control-sidebar').removeClass('addUsrZin');
        }

        function shouldIgnoreOutsideChatClick(target) {
            if (!target || !target.closest) {
                return true;
            }
            if (target.closest('#controllerId')) {
                return true;
            }
            if (target.closest('.chat-step')) {
                return true;
            }
            if (target.closest('.modal')) {
                return true;
            }
            if (target.closest('.modal-backdrop')) {
                return true;
            }
            if (target.closest('.swal2-container')) {
                return true;
            }
            if (target.closest('.sweet-overlay')) {
                return true;
            }
            if (target.closest('.sweet-alert')) {
                return true;
            }
            if (target.closest('.daterangepicker')) {
                return true;
            }
            if (target.closest('.k-animation-container')) {
                return true;
            }
            if (target.closest('.k-list-container')) {
                return true;
            }
            if (target.closest('.k-window')) {
                return true;
            }
            if (target.closest('.uib-datepicker-popup')) {
                return true;
            }
            if (target.closest('.ag-popup')) {
                return true;
            }
            if (target.closest('.ag-menu')) {
                return true;
            }
            if (target.closest('.context-menu')) {
                return true;
            }
            return false;
        }

        function onDocumentClickDismissChatCapture(event) {
            if (!$scope.isChatMenuActive && !$scope.isShowChatWindow) {
                return;
            }
            if (shouldIgnoreOutsideChatClick(event.target)) {
                return;
            }
            $scope.$applyAsync(function () {
                dismissChatPanelCompletely();
            });
        }

        $document[0].addEventListener('click', onDocumentClickDismissChatCapture, true);
        $document[0].addEventListener('contextmenu', onDocumentClickDismissChatCapture, true);

        var closeChatFromWorklist = $rootScope.$on('closeChatFromWorklist', dismissChatPanelCompletely);
        // New Code
        var activeChatMenuBarformWorkList = $rootScope.$on('activeChatMenuBarformWorkList', function (name, isChatMenuActive, worklistOrderData) {
            if ($scope.userList != null && $scope.userList.length > 0) {
                VideoCallConsultExamSendMessage(worklistOrderData);
            }
            else {
                $q.all([
                    GetAllUsers()
                ]).then(function (data) {
                    VideoCallConsultExamSendMessage(worklistOrderData);

                });
            }
        });

        // Old Code
        // var activeChatMenuBarformWorkList = $rootScope.$on('activeChatMenuBarformWorkList', function (name, isChatMenuActive,worklistOrderData) {
        //     $scope.isChatMenuActive = isChatMenuActive;
        //     $scope.isShowChatWindow = false;
        //     multipleOrderWorkList = worklistOrderData;
        //     if ($scope.userList && $scope.userList.length == 0) { GetAllUsers(); }
        // });

        function VideoCallConsultExamSendMessage(mssgWithPatientDetails) {
            multipleOrderWorkList = mssgWithPatientDetails.selectedOrder;
            $scope.isPrivateUserChat = true;
            $scope.isShowChatWindow = true;
            $scope.isHighPriority = mssgWithPatientDetails.isHighPriority;
            if ($scope.selectedUserObject == null || ($scope.selectedUserObject != null && $scope.selectedUserObject.Id != mssgWithPatientDetails.toUserId)) {
                var AllUsersConcat = _.concat($scope.userList, $scope.pinnedUserList);
                $scope.selectedUserObject = _.find(AllUsersConcat, { 'Id': mssgWithPatientDetails.toUserId });
                if (!$scope.selectedUserObject) {
                    var filter = {
                        PageNum: '1',
                        PageSize: '25',
                        Id: mssgWithPatientDetails.toUserId,
                        NewMessage: true,
                    }
                    chatService.GetUserList(filter).then(function (result) {
                        $scope.selectedUserObject = result[0];
                        if (!$scope.UserName)
                            $scope.userList.unshift(result[0]);
                        getUserMessages($scope.selectedUserObject);
                    });
                }
                else {
                    getUserMessages($scope.selectedUserObject);
                    $scope.selectedUserId = $scope.selectedUserObject.Id;
                }
            }
            else {
                $scope.openVideoChat($scope.selectedUserObject.FirstName + ' ' + $scope.selectedUserObject.LastName, true, '');
                $scope.selectedUserId = $scope.selectedUserObject.Id;
            }

            scrollPositionSetMessageList();
            $scope.maxChatWindow();
        }
        var activeChatMenuBarshareExamComponent = $rootScope.$on('activeChatMenuBar:shareExamComponent', function (name, isChatMenuActive) {
            $scope.isChatMenuActive = isChatMenuActive;
            if ($scope.isChatMenuActive && $scope.UserName) {
                $scope.UserName = null;
                $scope.isShowChatWindow = false;
                UserListPageNum = 1;
                GetAllUsers();
            }
            else {
                $scope.isShowChatWindow = false;
                if ($scope.userList && $scope.userList.length == 0) {
                    UserListPageNum = 1;
                    if ($scope.isChatMenuActive) {
                        GetAllUsers();
                    }
                }
                scrollPositionSetMessageList();
            }
            $rootScope.$emit('activeChatMenuBar:Chat', $scope.isChatMenuActive);
        });

        var activeChatMenuBarSendMessage = $rootScope.$on('activeChatMenuBar:SendMessage', function (name, isChatMenuActive, mssgWithPatientDetails) {
            /*var ToUserID;*/
            if ($scope.userList != null && $scope.userList.length > 0) {
                ShareExamSendMessage(mssgWithPatientDetails);
            }
            else {
                $q.all([
                    GetAllUsers()
                ]).then(function (data) {
                    //message come from shareExamComponent with required patientDetails
                    //var message = mssgWithPatientDetails.message + "|SHAREEXAMOBJ|" + JSON.stringify(mssgWithPatientDetails.patientDetails);
                    //ToUserID = mssgWithPatientDetails.toUserId;
                    //$scope.selectedUserObject = _.find($scope.userList, { 'Id': ToUserID });
                    //$scope.message = message;
                    //$scope.isPrivateUserChat = true;
                    //$scope.isHighPriority = mssgWithPatientDetails.isHighPriority;
                    //$scope.sendMessage(message);
                    ////getUserMessages($scope.selectedUserObject);
                    //ShareExamSendMessage(mssgWithPatientDetails); 
                    ShareExamSendMessage(mssgWithPatientDetails);
                });
            }
            $scope.scrolllToBottom = true;
            $scope.DeleteMessageScrollPosition = false;
        });
        var ChatMessageListCount = $rootScope.$on('activeChatMenuBar:ChatMessageList', function (Name, ChatMessageListChatCom) {
            $timeout(function () {
                $scope.ChatMessageList = ChatMessageListChatCom;
            }, 1000);
        });

        function ShareExamSendMessage(mssgWithPatientDetails) {
            var message = mssgWithPatientDetails.message + "|SHAREEXAMOBJ|" + JSON.stringify(mssgWithPatientDetails.patientDetails);
            //ToUserID = mssgWithPatientDetails.toUserId;
            $scope.message = message;
            $scope.isPrivateUserChat = true;
            $scope.isShowChatWindow = true;
            $scope.isHighPriority = mssgWithPatientDetails.isHighPriority;
            if ($scope.selectedUserObject == null || ($scope.selectedUserObject != null && $scope.selectedUserObject.Id != mssgWithPatientDetails.toUserId)) {
                var AllUsersConcat = _.concat($scope.userList, $scope.pinnedUserList);
                $scope.selectedUserObject = _.find(AllUsersConcat, { 'Id': mssgWithPatientDetails.toUserId });
                if (!$scope.selectedUserObject) {
                    var filter = {
                        PageNum: '1',
                        PageSize: '25',
                        Id: mssgWithPatientDetails.toUserId,
                        NewMessage: true,
                    }
                    chatService.GetUserList(filter).then(function (result) {
                        $scope.selectedUserObject = result[0];
                        if (!$scope.UserName)
                            $scope.userList.unshift(result[0]);
                        $scope.sendMessage(message);
                        getUserMessages($scope.selectedUserObject);
                    });
                }
                else {
                    $scope.sendMessage(message);
                    getUserMessages($scope.selectedUserObject);
                    $scope.selectedUserId = $scope.selectedUserObject.Id;
                }
            }
            else {
                $scope.sendMessage(message);
                $scope.selectedUserId = $scope.selectedUserObject.Id;
            }
            scrollPositionSetMessageList();
            $scope.maxChatWindow();
        }

        var disconnectVideoCall = $rootScope.$on('disconnectVideoCall', function (name, connected) {
            if (connected) {
                //logVideoCallEndTime();
                room = $sessionStorage.room;
                disconnect();
            }
        });
        $scope.$on('$destroy', function () {
            $document[0].removeEventListener('click', onDocumentClickDismissChatCapture, true);
            $document[0].removeEventListener('contextmenu', onDocumentClickDismissChatCapture, true);
            closeChatFromWorklist();
            activeChatMenuBarformWorkList();
            activeChatMenuBar();
            activeChatMenuBarshareExamComponent();
            activeChatMenuBarSendMessage();
            AppHub.off('RadFlowChatAppHubEvent');
            disconnectVideoCall();
            _.each(TimeoutList, function (timeout) {
                $timeout.cancel(timeout);
            });
        });

        $scope.activeChatMenuBar = function () {
            $scope.isChatMenuActive = !$scope.isChatMenuActive;
            $scope.isShowChatWindow = false;
            $scope.selectedUserId = 0;
            if ($scope.UserName) {
                $scope.UserName = null;
                UserListPageNum = 1;
                $scope.userList = [];
                GetAllUsers();
            }
            scrollPositionSetMessageList();
            $rootScope.$emit('activeChatMenuBar:Chat', $scope.isChatMenuActive);
            angular.element('.chatsec .control-sidebar').removeClass('addUsrZin')
        }

        //chat's message box scroll to last last message when keypad comes up
        if (angular.element(window).width() < 768) {
            angular.element(document).ready(function () {
                angular.element('#message').focus(function () {
                    angular.element(this).parents(".chat-user-action-container").addClass('textAreaCliked');
                    angular.element(".textAreaCliked").siblings(".chat-history").find("#messageMe").addClass('scrollToLastDiv');
                    setTimeout(function () {
                        angular.element(".scrollToLastDiv").scrollTop(angular.element(".scrollToLastDiv").get(0).scrollHeight);
                    }, 200);
                });
            });
        }
        angular.element(document).ready(function () {
            angular.element('.modal-RadSceureVCall').parent().addClass('kwindo-RadSceureVCall');
        });
        $scope.minChatWindow = function () {
            $('.chat-inner').addClass("setchatsection");
            $('.chat-header').addClass("setchatheader");
            $scope.hideChatWindow = true;
        }

        $scope.maxChatWindow = function () {
            $('.chat-inner').removeClass("setchatsection");
            $('.chat-header').removeClass("setchatheader");
            $scope.hideChatWindow = false;
            if ($scope.scrolllToBottom) {
                var objDiv = document.getElementById("messageMe");
                objDiv.scrollTop = objDiv.scrollHeight;
                $scope.scrolllToBottom = false;
            }
        }

        function getUserMessages(obj) {
            var d = $q.defer();
            $rootScope.$broadcast("ChatReadCount", obj, "Read");
            $rootScope.$broadcast("ChatCurrentUserObject", obj);
            $scope.isShowChatWindow = true;
            $scope.isPrivateUserChat = true;

            obj.SelectedRadiologists = _.clone(_.filter(obj.SelectedRadiologists, function (item) { return item.StatusFlag != 'D'; }));

            $scope.selectedUserObject = _.clone(obj);
            $scope.selectedUserId = _.clone(obj.Id);
            $scope.selectedChatGroupId = _.clone(obj.ChatGroupID);

            $scope.MessageList = [];
            MessageListPageNum = 1;
            $scope.isHighPriority = false;
            $scope.message = '';
            $q.all([
                GetMessage()
            ]).then(function (data) {
                if (obj.UnreadMsgCount > 0 && !obj.ChatGroupID) {
                    ChangeReadStatus(obj.Id, $scope.currUserId, null);
                    obj.UnreadMsgCount = 0;
                }
                else if (obj.UnreadMsgCount > 0 && obj.ChatGroupID) {
                    ChangeReadStatus($scope.currUserId, null, obj.ChatGroupID);
                    obj.UnreadMsgCount = 0;
                }

                UpdateGroupChatReadMessageUsers(obj);

                d.resolve();

            });
            return d.promise;
        }

        $scope.OpenExam = function (strJson) {
            var patObj = JSON.parse(strJson);
            var accession = patObj.Accession;
            var patientMRN = patObj.PatientMRN;
            var dicomViewer = patObj.DicomViewer;
            var DicomViewerURL = patObj.DicomViewerURL;
            var Site = patObj.Site;

            if (dicomViewer == "CI-VIEWER") {
                if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                    window.open(__env._environment.config.ciDICOMViewer.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId), "_self");
                }
                else {
                    windowHandler.openByPreference(__env._environment.config.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 1), "CI-VIEWER-1", 1000, "CI-VIEWER-1-" + accession.toUpperCase().trim(), "", false);
                    //windowHandler.openByPreference(APP_CONSTANTS.ciDICOMViewerChrome.replace("@ACCESSION", accession).replace("@USERID", $sessionStorage.currentUserData.userId).replace("@MONITORINDEX", 2), "CI-VIEWER-2", 1000, "", false);
                }
            }
            else if (dicomViewer == "KONICA" || dicomViewer == "KONICATEST" || dicomViewer.replace(/\s/g, "").toUpperCase() == "NORTHSTARKONICA") {
                $scope.konica_RadFlow = windowHandler.openByPreference(__env._environment.config.konicaBaseURL.replace("@MRN", patientMRN).replace("@ACCESSION", accession).replace("@VIEWER", dicomViewer), dicomViewer, 100, dicomViewer.replace(/\s/g, "").toUpperCase() + "-" + + accession.toUpperCase().trim(), "noreferrer");
            }
            else if (dicomViewer == "SYNAPSE") {

                if (Site.toUpperCase() == 'DECATUR') {
                    accession = accession.toUpperCase().replace('WHS', '');
                }
                RCService.OpenImage({ requestEvent: "openimage", imageRequestDetails: { pacsURL: DicomViewerURL, accessionNumber: accession } })
            }

        }


        $scope.ViewPatientDetails = function (strJson, propName) {
            var patObj = JSON.parse(strJson);
            if (propName == "NAME") {
                return patObj.PatientName;
            }
            else if (propName == "MRN") {
                return patObj.PatientMRN;
            }
            else if (propName == "ACCESSION") {
                return patObj.Accession;
            }
        }
        $scope.LastMessageTimeStamp = function (MessageDT) {
            var localDate = new moment();
            var msgdt = moment.utc(MessageDT).local();
            switch (localDate.diff(msgdt, 'days')) {
                case 0:
                    return msgdt.format("HH:mm");
                    break;
                case 1:
                    return "Yesterday";
                    break;
                case 2: case 3: case 4: case 5: case 6:
                    return msgdt.format('dddd')
                    break;
                default:
                    return msgdt.format('MM/DD')
            }

        }
        $scope.readMore = function (messageObj) {
            if (messageObj.readMoreTxt == 'Read More') {
                messageObj.numLimit = messageObj.Message.length;
                messageObj.readMoreTxt = 'Read Less';
            } else {
                messageObj.numLimit = numLimit;
                messageObj.readMoreTxt = 'Read More';
            }
        };
        // chat bottom button
        document.getElementById("chat-bottom-btn").style.display = "none";
        var mybutton = document.getElementById("chat-bottom-btn");
        angular.element(document.querySelector('.chat-history-inner')).bind('scroll', function () {
            $scope.scrollFunction();
        });
        $scope.scrollFunction = function () {
            if (Math.abs(document.getElementById('messageMe').scrollHeight - document.getElementById('messageMe').clientHeight - document.getElementById('messageMe').scrollTop) < 1) {
                mybutton.style.display = "none";
            } else {
                mybutton.style.display = "block";
            }
        }
        $scope.topFunction = function () {
            var objDiv = document.getElementById("messageMe");
            objDiv.scrollTop = objDiv.scrollHeight;
        }
        function UpdateGroupChatReadMessageUsers(obj) {
            if (obj.ChatGroupID) {
                var messageIndex = _.findLastIndex($scope.MessageList, { FromUserId: $scope.currUserId });
                if (messageIndex != -1) {
                    var messageObject = {
                        Id: $scope.MessageList[messageIndex].Id,
                        ChatGroupID: $scope.MessageList[messageIndex].ChatGroupID
                    };
                    GetMessageReadStatusByMessage(messageObject);
                }
            }
        }

        function scrollPositionSetMessageList() {
            var objDiv = document.getElementById("UserListID");
            objDiv.scrollTop = 0;
            ShareExamscrollPosition = true;
        }

        $scope.onChatTabChange = function (userRole) {
            //if (userRole != $scope.UserRoleTab) {
            if ($scope.showUsersLoader) {
                var timeoutActiveClass = $timeout(function () {
                    $('#chat' + userRole.toLowerCase()).removeClass('active');
                    $('#chat' + $scope.UserRoleTab.toLowerCase()).addClass('active');

                    $timeout.cancel(timeoutActiveClass);
                    timeoutActiveClass = null;
                }, 100);

                toaster.warning('Allow the request to finish loading the records.');
                return;
            }
            $scope.isShowChatWindow = false;
            $scope.UserRoleTab = userRole;

            PageSize = '25';
            UserListPageNum = 1;

            $scope.userList = [];
            $scope.pinnedUserList = [];

            $scope.selectedUserId = 0;
            scrollPositionSetMessageList();

            GetAllUsers();
            //getPinnedUsers();
            //}
        }
        $scope.pinUnpinUser = function () {
            var d = $q.defer();
            if (pinnedUsersCount >= 10 && $scope.ContextMenuSelectedUser && (($scope.ContextMenuSelectedUser.ChatGroupID && !$scope.ContextMenuSelectedUser.IsPinnedGroup) || (!$scope.ContextMenuSelectedUser.ChatGroupID && !$scope.ContextMenuSelectedUser.IsPinnedUser))) {
                toaster.warning("There's only space for 10 pinned chats. Unpin one and try again!");
            }
            else {
                chatService.SetChatPinUsers({
                    FromUserID: $sessionStorage.currentUserData.userId,
                    ToUserID: $scope.ContextMenuSelectedUser.ChatGroupID ? null : $scope.ContextMenuSelectedUser.Id,
                    Flag: $scope.ContextMenuSelectedUser.ChatGroupID ? $scope.ContextMenuSelectedUser.IsPinnedGroup ? 'D' : 'N' : $scope.ContextMenuSelectedUser.IsPinnedUser ? 'D' : 'N',
                    ChatGroupID: $scope.ContextMenuSelectedUser.ChatGroupID,
                }).then(function (res) {
                    if (!$scope.ContextMenuSelectedUser.ChatGroupID) {
                        $scope.ContextMenuSelectedUser.IsPinnedUser = !$scope.ContextMenuSelectedUser.IsPinnedUser;
                        if ($scope.ContextMenuSelectedUser.IsPinnedUser) {
                            $scope.userList = _.filter($scope.userList, function (obj) { return obj.Id != $scope.ContextMenuSelectedUser.Id });
                            $scope.pinnedUserList.push($scope.ContextMenuSelectedUser);

                            $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                        }
                        else if (!$scope.ContextMenuSelectedUser.IsPinnedUser) {
                            $scope.pinnedUserList = _.filter($scope.pinnedUserList, function (obj) { return obj.Id != $scope.ContextMenuSelectedUser.Id });
                            $scope.userList.push($scope.ContextMenuSelectedUser);

                            $scope.userList = sortUserList($scope.userList);
                        }
                    }
                    else {
                        $scope.ContextMenuSelectedUser.IsPinnedGroup = !$scope.ContextMenuSelectedUser.IsPinnedGroup;
                        if ($scope.ContextMenuSelectedUser.IsPinnedGroup) {
                            _.remove($scope.userList, { ChatGroupID: $scope.ContextMenuSelectedUser.ChatGroupID });
                            $scope.pinnedUserList.push($scope.ContextMenuSelectedUser);

                            $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                        }
                        else if (!$scope.ContextMenuSelectedUser.IsPinnedGroup) {
                            _.remove($scope.pinnedUserList, { ChatGroupID: $scope.ContextMenuSelectedUser.ChatGroupID });
                            $scope.userList.push($scope.ContextMenuSelectedUser);

                            $scope.userList = sortUserList($scope.userList);
                        }
                    }
                    pinnedUsersCount = $scope.pinnedUserList.length;
                    d.resolve();
                });
            }
            return d.promise;
        }
        $scope.isMenuVisible = false;
        $scope.contextMenuStyle = {};

        $scope.showContextMenu = function (event, currentUserObj) {
            if (event.button == 2) { // Right-click
                event.preventDefault(); // Prevent the default context menu            
                $scope.ContextMenuSelectedUser = {};
                $scope.isMenuVisible = false;

                $scope.ContextMenuSelectedUser = _.clone(currentUserObj);
                $scope.isMenuVisible = true;

                if ($scope.isMenuVisible) {
                    var contectMenuDiv = document.getElementById("contectMenuDiv");
                    if (contectMenuDiv) {
                        contectMenuDiv.style.left = event.clientX + 'px';
                        contectMenuDiv.style.top = event.clientY - 30 + 'px';
                    }
                }
            }
        };
        $scope.clearChatFilter = function () {
            $scope.UserName = null;
            $scope.OnChangeFilter();
        }
        // Hide the context menu when clicking anywhere else
        document.addEventListener('click',
            function () {
                var timeout = $timeout(function () {
                    $scope.isMenuVisible = false;
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            });

        // Prevent the default context menu from opening

        document.addEventListener('contextmenu', function (event) {
            if (event && event.target.id == "contectMenuDiv") {
                event.preventDefault();
            }
        });
        document.getElementById('ChatUserListDiv').addEventListener('wheel', function () {
            var timeout = $timeout(function () {
                $scope.isMenuVisible = false;
                $timeout.cancel(timeout);
                timeout = null;
            }, 0);
        })
        $scope.showToUserDetails = function (toUser) {
            if ($scope.toUserDetails) {
                $scope.toUserDetails.ispopOverOpen = false;
            }
            $scope.toUserDetails = toUser;
            if (!toUser.ChatGroupID) {
                $scope.getToUserSites(toUser.Id).then(function (result) {
                    $scope.toUserSiteAccessList = result;
                    $scope.toUserDetails.ispopOverOpen = true;
                });
            }
            else {
                $scope.toUserDetails.ispopOverOpen = true;
            }
        }
        $scope.showGroupToUserDetails = function (toUser) {
            if ($scope.toGroupUserDetails) {
                $scope.toGroupUserDetails.isgrouppopOverOpen = false;
            }
            $scope.toGroupUserDetails = toUser;

            $scope.getToUserSites(toUser.Id).then(function (result) {
                $scope.toGroupUserSiteAccessList = result;
                $scope.toGroupUserDetails.isgrouppopOverOpen = true;
            });

        }
        $scope.hideToUserDetails = function () {
            var timeout = $timeout(function () {
                if ($scope.toUserDetails && !$scope.isCursorOnPopover) {
                    if (!($scope.toGroupUserDetails && $scope.isGroupCursorOnPopover)) {
                        $scope.isCursorOnPopover = false;
                        $scope.toUserDetails.ispopOverOpen = false;
                        $timeout.cancel(timeout);
                        timeout = null;
                    }
                }
            }, 200);
        }
        $scope.hideGroupToUserDetails = function () {
            var timeout = $timeout(function () {
                if ($scope.toGroupUserDetails && !$scope.isGroupCursorOnPopover) {
                    $scope.isGroupCursorOnPopover = false;
                    $scope.toGroupUserDetails.isgrouppopOverOpen = false;
                    if ($scope.toUserDetails && !$scope.isCursorOnPopover) {
                        $scope.isCursorOnPopover = false;
                        $scope.toUserDetails.ispopOverOpen = false;
                    }
                    $timeout.cancel(timeout);
                    timeout = null;
                }
            }, 200);
        }
        $scope.mouseEnterOutPopUp = function (flag, isGroup) {
            if (!isGroup) {
                $scope.isCursorOnPopover = flag;
                if (!flag) {
                    $scope.hideToUserDetails();
                }
            }
            else {
                $scope.isGroupCursorOnPopover = flag;
                if (!flag) {
                    $scope.hideGroupToUserDetails();
                }
            }
        }
        $scope.getToUserSites = function (toUserId) {
            var d = $q.defer();
            $scope.toUserSiteAccessList = [];
            ProfileService.GetSitesByUserId(toUserId).then(function (result) {
                d.resolve(result.data);
            });
            return d.promise;
        }

        function sortUserList(userList) {
            userList = _.uniq(userList);
            var HasMsgDateValue = _.filter(userList, function (user) { return user.MessageDT != null && user.MessageDT.length > 0; });
            var HasNoMsgDateValue = _.filter(userList, function (user) { return user.MessageDT == null; });
            HasMsgDateValue = _.orderBy(HasMsgDateValue, ['MessageDT', function (e) { if (!e.GroupName) { return e.LastName + ' , ' + e.FirstName; } else { return e.GroupName } }, function (e) { if (!e.GroupName) { return e.IsOnline ? 1 : 0; } }], ['desc', 'asc', 'desc']);
            HasNoMsgDateValue = _.orderBy(HasNoMsgDateValue, ['MessageDT', function (e) { if (!e.GroupName) { return e.LastName + ' , ' + e.FirstName; } else { return e.GroupName } }, function (e) { if (!e.GroupName) { return e.IsOnline ? 1 : 0; } }], ['desc', 'asc', 'desc']);
            var FinalUserList = _.concat(HasMsgDateValue, HasNoMsgDateValue);
            return FinalUserList;
        }
        function GetAllUserByTenant() {
            var d = $q.defer();
            var filter = {
                UserID: $sessionStorage.currentUserData.userId,
            };
            $q.all([
                RuleService.GetAllUserByTenant(filter)
            ]).then(function (data) {
                $scope.RadiologistsFullSet = data[0];
                $scope.MasterRadiologistsFullSet = data[0];
                $scope.DataObject.MasterData.Radiologists = _.uniqBy(data[0], 'Id');
                d.resolve();
            });
            return d.promise;
        }
        $scope.AssignUserCancel = function () {
            if (!$scope.DataObject.GroupDetails) {
                $scope.DataObject.GroupDetails.SelectedRadiologists = [];
            }
        }
        $scope.SaveAddUsers = function () {
            $('#RadiologistComponentGroupChat').modal('hide');
            if ($scope.DataObject.BtnText == 'Update') {
                if ($scope.DataObject.GroupDetails.SelectedRadiologists.length <= 2) {
                    toaster.warning({ body: "At least 3 members to be required in the group." });
                    return;
                }
                $scope.AddUpdateGroup('Update');
            }
        };
        $scope.AddUsers = function () {
            //$scope.DataObject.GroupDetails = _.clone($scope.toUserDetails);
            //$scope.DataObject.GroupDetails.Radiologists = _.clone($scope.toUserDetails.SelectedRadiologists);
            $('#RadiologistComponentGroupChat').modal('show');
            //$scope.modalTitle = 'Add Members';
        };
        $scope.ClearModalData = function () {
            $('#AddEditGroupModal').modal('hide');
            $scope.DataObject.showAssignRadiologistCmp = { value: false };
            $scope.DataObject.GroupDetails = { GroupName: null, SelectedRadiologists: [] };
            $scope.DataObject.BtnText = 'Create';
        };
        $scope.OpenGroupModal = function (Action) {
            $scope.ClearModalData();
            $scope.DataObject.isSaveEditBtnDisable = false;
            $scope.DataObject.GroupChatText = Action;
            $scope.DataObject.BtnText = Action;
            $scope.DataObject.GroupDetails = (Action == 'Create') ? $scope.DataObject.GroupDetails : $scope.selectedUserObject;
            $scope.DataObject.GroupDetails.Radiologists = _.clone($scope.DataObject.GroupDetails.SelectedRadiologists);
            if (Action == 'Create') {
                var selectedUser = _.find($scope.RadiologistsFullSet, { Id: $sessionStorage.currentUserData.userId });
                if (!selectedUser) {
                    // RadiologistsFullSet may not yet contain the creator's own record
                    // (e.g. GetAllUserByTenant() in init() hasn't resolved yet). Build a
                    // minimal fallback from session data so the creator is still added to
                    // the group instead of this lookup throwing and silently dropping them
                    // from SelectedRadiologists/UserIDs (which hides the rename and
                    // view/add-member icons downstream).
                    selectedUser = {
                        Id: $sessionStorage.currentUserData.userId,
                        FirstName: $sessionStorage.currentUserData.FirstName,
                        LastName: $sessionStorage.currentUserData.LastName
                    };
                }
                selectedUser.JoiningDate = moment().utc().format('MM/DD/YYYY HH:mm:ss');
                $scope.DataObject.GroupDetails.SelectedRadiologists.push(selectedUser);
            }
            $scope.DataObject.GroupDetails.Flag = (Action == 'Create') ? 'N' : 'M';
            $('#AddEditGroupModal').modal('show');
        }

        function SetChatGroup(object) {
            var d = $q.defer();
            chatService.SetChatGroup(object).then(function (result) {
                d.resolve(result);
            });
            return d.promise;
        }
        function GetChatGroup() {
            var d = $q.defer();
            if ($scope.UserRoleTab == "All" || $scope.UserRoleTab == "Group") {
                var filter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    GroupName: $scope.UserName,
                };
                chatService.GetChatGroup(filter).then(function (result) {
                    var groupsList = _.uniqBy(result, 'ChatGroupID');
                    d.resolve(groupsList);
                });
            }
            else {
                d.resolve([]);
            }
            return d.promise;
        }
        $scope.GetUserName = function (userId) {
            var user = _.find($scope.RadiologistsFullSet, { Id: userId });
            if (user) {
                return user.FirstName.substring(0, 1) + '' + user.LastName.substring(0, 1);
            }
        }

        $scope.DeleteOrLeaveGroup = function (action, obj, user) {
            var title = user && user.DisplayName ? "Are you sure you want to remove '" + user.LastName + ', ' + user.FirstName + "' from this group '" + obj.GroupName + "' ?" : "Are you sure you want to " + action.toLowerCase() + " this group '" + obj.GroupName + "' ?"
            swal({
                title: title,
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
                function () {
                    //$scope.SaveGroupChat(action, obj, user);

                    $scope.DataObject.GroupDetails = obj;
                    $scope.DataObject.GroupDetails.Radiologists = _.clone(obj.SelectedRadiologists);

                    if (action == 'Leave') {
                        _.remove($scope.DataObject.GroupDetails.SelectedRadiologists, { Id: user.Id });
                    }
                    action = action == 'Leave' ? 'Update' : 'Delete';
                    $scope.AddUpdateGroup(action);
                });
        }

        $scope.AddUpdateGroup = function (action) {
            var Users = [];
            _.each($scope.DataObject.GroupDetails.SelectedRadiologists, function (user) {
                var RadiologistExists = _.find($scope.DataObject.GroupDetails.Radiologists, { Id: user.Id });
                if (RadiologistExists) {
                    user.StatusFlag = 'M';
                } else {
                    user.StatusFlag = 'N';
                    user.JoiningDate = moment().utc().format('MM/DD/YYYY HH:mm:ss');
                }
                Users.push(user);
            });
            _.each($scope.DataObject.GroupDetails.Radiologists, function (user) {
                var RadiologistExists = _.find($scope.DataObject.GroupDetails.SelectedRadiologists, { Id: user.Id });
                if (!RadiologistExists) {
                    user.StatusFlag = 'D';
                    user.LeavingDate = moment().utc().add(1, 'seconds').format('MM/DD/YYYY HH:mm:ss');
                    Users.push(user);
                }
            });
            var Groupobject = {
                ChatGroupID: action == "Create" ? null : $scope.DataObject.GroupDetails.ChatGroupID,
                GroupName: $scope.DataObject.GroupDetails.GroupName,
                StatusFlag: action == "Create" ? "N" : (action == "Update") ? "M" : "D",
                IsOnline: true,
                IsDistributed: $scope.DataObject.GroupDetails.IsDistributed,
                CreatedBy: action == "Create" ? $sessionStorage.currentUserData.userId : $scope.DataObject.GroupDetails.CreatedBy,
                CreatedName: action == "Create" ? $sessionStorage.currentUserData.displayName : $scope.DataObject.GroupDetails.CreatedName,
                CreatedDate: action == "Create" ? moment().utc().format('MM/DD/YYYY HH:mm:ss') : $scope.DataObject.GroupDetails.CreatedDate,
                ModifiedBy: action != "Create" ? $sessionStorage.currentUserData.userId : null,
                ModifiedName: action != "Create" ? $sessionStorage.currentUserData.displayName : null,
                ModifiedDate: action != "Create" ? moment().utc().format('MM/DD/YYYY HH:mm:ss') : null,
                SelectedRadiologists: Users,
                UserID: $sessionStorage.currentUserData.userId
            };
            if (action == 'Update') {
                if ($scope.MessageList.length > 0) {
                    Groupobject.MessageDT = $scope.MessageList[$scope.MessageList.length - 1].MessageTime;
                    Groupobject.LastMessage = $scope.MessageList[$scope.MessageList.length - 1].Message;
                    Groupobject.FileName = $scope.MessageList[$scope.MessageList.length - 1].FileName;
                    Groupobject.LastMessageUserId = $scope.MessageList[$scope.MessageList.length - 1].FromUserId;
                    Groupobject.UnreadMsgCount = 0;
                } else {
                    Groupobject.MessageDT = $scope.DataObject.GroupDetails.MessageDT;
                    Groupobject.LastMessage = $scope.DataObject.GroupDetails.LastMessage;
                    Groupobject.LastMessageUserId = $scope.DataObject.GroupDetails.LastMessageUserId;
                    Groupobject.UnreadMsgCount = $scope.DataObject.GroupDetails.UnreadMsgCount;
                }

            }

            SetChatGroup(Groupobject).then(function (GroupDetail) {
                if (GroupDetail && GroupDetail.Exists) {
                    toaster.pop({ type: "warning", body: "Group exists with same name." });
                    $scope.DataObject.isSaveEditBtnDisable = false;
                    return;
                }
                if (GroupDetail.StatusFlag == 'D') {
                    var pinnedUserIndex = _.findIndex($scope.pinnedUserList, function (item) { return item.ChatGroupID == GroupDetail.ChatGroupID; });
                    if (pinnedUserIndex != -1) {
                        $scope.pinnedUserList.splice(pinnedUserIndex, 1);
                    } else {
                        var userIndex = _.findIndex($scope.userList, function (item) { return item.ChatGroupID == GroupDetail.ChatGroupID; });
                        if (userIndex != -1) {
                            $scope.userList.splice(userIndex, 1);
                        }
                    }
                    var removeChatWindowTimeout = $timeout(function () {
                        if (($scope.selectedUserObject)
                            && ($scope.selectedUserObject.ChatGroupID == GroupDetail.ChatGroupID)) {
                            $scope.isShowChatWindow = false;
                            $scope.ClearModalData();
                        }

                        $timeout.cancel(removeChatWindowTimeout);
                        removeChatWindowTimeout = null;
                    }, 100);
                } else {
                    var LeftRadiologists = _.filter(GroupDetail.SelectedRadiologists, function (item) { return item.LeavingDate; });
                    var SelectedRadiologists = _.filter(GroupDetail.SelectedRadiologists, function (item) { return !item.LeavingDate; });
                    _.remove(LeftRadiologists, function (leftRad) {
                        var commonRadioLogist = _.find(SelectedRadiologists, function (selectedRad) {
                            return ((selectedRad.UserID
                                && leftRad.UserID
                                && selectedRad.UserID == leftRad.UserID)
                                || (selectedRad.Id
                                    && leftRad.Id
                                    && selectedRad.Id == leftRad.Id));
                        });

                        if (commonRadioLogist) {
                            return true;
                        }
                        return false;
                    });
                    GroupDetail.LeftRadioLogist = _.clone(LeftRadiologists);
                    GroupDetail.SelectedRadiologists = _.clone(SelectedRadiologists);
                    _.each(GroupDetail.SelectedRadiologists, function (useritem) {
                        useritem.ChatGroupID = GroupDetail.ChatGroupID;
                        // A freshly created/echoed member (Create path, and newly-added
                        // members picked from RadiologistsFullSet in the Update path) only
                        // carries .Id, not .UserID (SetChatGroup echoes the posted object,
                        // it doesn't re-query the DB and remap fields). Fall back to .Id so
                        // these members still get profile-enriched immediately instead of
                        // waiting for the next full list refresh.
                        var selectedUser = _.find($scope.RadiologistsFullSet, { Id: useritem.UserID || useritem.Id });
                        if (selectedUser) {
                            useritem = _.merge(useritem, selectedUser);
                        }
                    });
                    //groupItem.LastMessage = getLastMessage(groupItem);
                    var createdByUser = _.find($scope.RadiologistsFullSet, { Id: GroupDetail.CreatedBy });
                    if (createdByUser) { GroupDetail.CreatedName = createdByUser.DisplayName; }
                    var modifiedByUser = _.find($scope.RadiologistsFullSet, { Id: GroupDetail.ModifiedBy });
                    if (modifiedByUser) { GroupDetail.ModifiedName = modifiedByUser.DisplayName; }
                    GroupDetail.UserIDs = _.map(GroupDetail.SelectedRadiologists, function (item) {
                        return item.Id;
                    });
                    var groupIndex = _.findIndex($scope.pinnedUserList, { ChatGroupID: GroupDetail.ChatGroupID });
                    if (groupIndex != -1) {
                        GroupDetail.IsPinnedGroup = true;
                        $scope.pinnedUserList[groupIndex] = GroupDetail;
                        $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
                    } else {
                        groupIndex = _.findIndex($scope.userList, { ChatGroupID: GroupDetail.ChatGroupID });
                        if (groupIndex != -1) {
                            $scope.userList[groupIndex] = GroupDetail;
                        } else {
                            $scope.userList.push(GroupDetail);
                        }
                        $scope.userList = sortUserList($scope.userList);
                    }
                    $scope.itemClicked(GroupDetail, false);

                    $scope.DataObject.isEditGroupTitleVisible.value = false;
                    $scope.ClearModalData();
                    $scope.DataObject.isSaveEditBtnDisable = false;
                    $scope.DataObject.isAddMemberVisible.value = false;
                }

                scrollPositionSetMessageList();
            });
        }
        $scope.UpdateGroupName = function () {
            if ($scope.DataObject.isEditGroupTitleVisible.value) {
                $scope.DataObject.isEditGroupTitleVisible.value = false;
            } else {
                $scope.DataObject.GroupDetails = _.clone($scope.selectedUserObject);
                $scope.DataObject.GroupDetails.Radiologists = _.clone($scope.selectedUserObject.SelectedRadiologists);
                $scope.DataObject.isEditGroupTitleVisible.value = true;
            }
        }

        function BindChatGroupMessage(MessageObject) {
            if ($scope.isShowChatWindow && $scope.selectedUserObject.ChatGroupID == MessageObject.ChatGroupID) {
                var user = _.find($scope.RadiologistsFullSet, { Id: MessageObject.FromUserId });
                if (user) {
                    MessageObject.FromInitials = user.LastName.substring(0, 1).toUpperCase() + user.FirstName.substring(0, 1).toUpperCase();
                }
                $scope.MessageList.push(MessageObject);
                $scope.MessageList = $filter('orderBy')(_.uniqBy($scope.MessageList, 'Id'), ['MessageTime']);
                ChangeReadStatus($scope.currUserId, null, MessageObject.ChatGroupID, MessageObject.Id);
                if (MessageObject.ChatGroupID == $scope.selectedUserObject.ChatGroupID) {
                    $rootScope.$broadcast("ChatReadCount", MessageObject, "Read");
                    $scope.maxChatWindow();
                }
            }
            else if ($scope.UserRoleTab == 'All' || $scope.UserRoleTab == 'Group' || (MessageObject.FromUserRoles.includes($scope.UserRoleTab))) {
                var pinnedUserIdx = -1;
                var idx = _.findIndex($scope.userList, function (data) {
                    return data.ChatGroupID == MessageObject.ChatGroupID;
                });
                if (idx == -1) {
                    pinnedUserIdx = _.findIndex($scope.pinnedUserList, function (data) {
                        return data.ChatGroupID == MessageObject.ChatGroupID;
                    });
                }
                if (idx > -1) {
                    $scope.userList[idx].UnreadMsgCount = $scope.userList[idx].UnreadMsgCount + 1;
                } else if (pinnedUserIdx != -1) {
                    $scope.pinnedUserList[pinnedUserIdx].UnreadMsgCount = $scope.pinnedUserList[pinnedUserIdx].UnreadMsgCount + 1;
                }
                scrollPositionSetMessageList();

                if ($scope.selectedUserObject &&
                    ((idx != -1 && ($scope.userList[idx].Id == $scope.selectedUserObject.Id)) ||
                        (pinnedUserIdx != -1 && ($scope.pinnedUserList[pinnedUserIdx].Id == $scope.selectedUserObject.Id)))) {
                    $scope.maxChatWindow();
                }

                $scope.topFunction();
            }

            ////////Update UserList Data
            var idx = _.findIndex($scope.userList, function (data) { return data.ChatGroupID == MessageObject.ChatGroupID; });
            if (idx > -1) {
                $scope.userList[idx].MessageDT = moment(MessageObject.MessageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                $scope.userList[idx].LastMessage = MessageObject.Message;
                $scope.userList[idx].FileName = MessageObject.FileName;
                $scope.userList[idx].LastMessageUserId = MessageObject.FromUserId;
                $scope.userList = sortUserList($scope.userList);
            }
            var idx = _.findIndex($scope.pinnedUserList, function (data) { return data.ChatGroupID == MessageObject.ChatGroupID; });
            if (idx > -1) {
                $scope.pinnedUserList[idx].MessageDT = moment(MessageObject.MessageTime).format("YYYY-MM-DDTHH:mm:ss"); //new Date(obj.MessageTime);
                $scope.pinnedUserList[idx].LastMessage = MessageObject.Message;
                $scope.pinnedUserList[idx].FileName = MessageObject.FileName;
                $scope.pinnedUserList[idx].LastMessageUserId = MessageObject.FromUserId;
                $scope.pinnedUserList = sortUserList($scope.pinnedUserList);
            }

            //-------------------------------------------
        }

        $scope.UpdateMembers = function () {
            if ($scope.DataObject.isAddMemberVisible.value) {
                $scope.DataObject.isAddMemberVisible.value = false;
            } else {
                $scope.DataObject.BtnText = 'Update';
                $scope.DataObject.GroupDetails = _.clone($scope.selectedUserObject);
                $scope.DataObject.GroupDetails.Radiologists = _.clone($scope.selectedUserObject.SelectedRadiologists);
                $scope.DataObject.isAddMemberVisible.value = true;
            }
        }

        $scope.retryMessage = function (messageObj, index) {
            if (!messageObj.Id) {
                SendPrivateOrGroupMessage(messageObj);
            }
        }

        document.addEventListener('click', onDocumentClick);
        function onDocumentClick(e) {
            if ((!e.target.closest("#groupTitleEdit")) && (!e.target.closest("#editGroupBtn"))) {
                $scope.DataObject.isEditGroupTitleVisible.value = false;
            }
            if ((!e.target.closest("#groupMemberEdit")) && (!e.target.closest("#editGroupMember"))) {
                $scope.DataObject.isAddMemberVisible.value = false;
            }
        }

        function GetMessageReadStatusByMessage(messageObject) {
            var d = $q.defer();
            chatService.GetMessageReadStatusByMessage(messageObject).then(function (response) {
                var groupChatMessageReadUserList = response;
                if (groupChatMessageReadUserList && groupChatMessageReadUserList.length > 0) {
                    var messageIndex = _.findIndex($scope.MessageList, { Id: messageObject.Id });
                    if (messageIndex != -1) {
                        $scope.MessageList[messageIndex].GroupChatMessageReadUserList = groupChatMessageReadUserList;
                        var readUsers = _.filter(groupChatMessageReadUserList, { IsRead: false });
                        if (readUsers.length == 0) {
                            $scope.MessageList[messageIndex].IsReadByAllUser = true;
                        }
                    }
                }
                d.resolve(response);
            });
            return d.promise;
        }


        // Initialize the component
        init();

        function proceedToOpenStudy(SelectedOrder, isSingleView) {
            OpenOrder = {};
            $q.all([
                VerfiyReadStudy(SelectedOrder.OrderID, $sessionStorage.currentUserData.userId, isSingleView),
                GetClipboardDetailByOrderID(SelectedOrder.OrderID)
            ]).then(function () {
                VerifyOpenOrder(OpenOrder, SelectedOrder, isSingleView);
            });

        }

        function VerfiyReadStudy(OrderID, ProviderID, isSingleView) {
            var d = $q.defer();
            if (isSingleView) {
                var openOrders = {
                    OrderId: OrderID,
                    ProviderID: ProviderID
                };
                WorklistService.VerfiyReadStudy(openOrders).then(function (result) {
                    OpenOrder.VerifyReadStudyResult = result;
                    d.resolve();
                });
            }
            else {
                d.resolve();
            }
            return d.promise;
        }

        function GetClipboardDetailByOrderID(OrderID) {
            var d = $q.defer();
            if (Order.IsInClipboard && Order.IsInClipboard == 1) {
                WorklistService.GetClipboardDetailByOrderID(OrderID).then(function (result) {
                    OpenOrder.ClipboardDetailResult = result;
                    d.resolve();
                });
            }
            else {
                d.resolve();
            }
            return d.promise;
        }

        function VerifyOpenOrder(OpenOrder, SelectedOrder, isSingleView) {

            var showProviderName = (($sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && ($scope.DataObject.EnableRowsForSelectedTenants && $scope.DataObject.EnableRowsForSelectedTenants.includes(SelectedOrder.TenantName))))

            OpenStudyOrder = null;
            if (OpenOrder.ClipboardDetailResult && OpenOrder.ClipboardDetailResult.length > 0) {
                if (!confirm('This study is already assigned to the "' + OpenOrder.ClipboardDetailResult[0].UserName + '\'s" clipboard. \nDo you still wish to continue reading the study?')) {
                    return;
                }
                else {
                    var obj = { OrderID: SelectedOrder.OrderID, UserID: $sessionStorage.currentUserData.userId, RuleID: OpenOrder.ClipboardDetailResult[0].RuleID };
                    $rootScope.$broadcast('event.NotifyRemoveFromClipboard', obj);
                    WorklistService.NotifyRemoveOrderIDFromClipboard(obj);
                    $rootScope.$broadcast('event.worklist', { EventType: 'NotifyOrderListSaveReport', OrderID: SelectedOrder.OrderID });
                }
            }
            if (SelectedOrder.OrderAssingedUsers > 0 && (!SelectedOrder.OrderAssingedUser || SelectedOrder.OrderAssingedUser == null)) {
                var UserName = SharedService.getOrderListTooltip(SelectedOrder);
                if (UserName && UserName != null && !confirm('This study is already ' + UserName.replace("Assigned to", "assigned to") + ', \nDo you still wish to continue reading the study?')) {
                    return;
                }
            }
            var isStudyLocked = !!(OpenOrder.VerifyReadStudyResult.openOrders && OpenOrder.VerifyReadStudyResult.openOrders.length > 0);
            if (!isStudyLocked) {
                if (OpenOrder.VerifyReadStudyResult.reportView && OpenOrder.VerifyReadStudyResult.reportView.ReportStatus == 2 && OpenOrder.VerifyReadStudyResult.reportView.SignBy != $sessionStorage.currentUserData.userId) {
                    var msg = "This order has been drafted";
                    msg = (!showProviderName) ? msg + " by user " + OpenOrder.VerifyReadStudyResult.reportView.SignByName : msg;
                    msg = msg + '.\nAre you sure you want to proceed?';

                    if (!confirm(msg)) {
                        return;
                    }
                }

                $scope.DataObject.ShowReport = true;
                $scope.DataObject.ReportSelectedOrder = _.clone(SelectedOrder);
                $scope.DataObject.FormattedSelectedOrder = FormatOrder(SelectedOrder);
                $scope.DataObject.ReportSelectedOrder.OpenPriorReport = true;
            }
            SelectedOrder.DictationSystem = $sessionStorage.DefaultDictationSystem;

            function launchViewer(order) {
                SharedService.OpenSynapseStudy(order, order.DicomViewer, !isStudyLocked, isSingleView, $scope, TimeoutList, $scope.browser);
                $rootScope.$broadcast('event.worklist', { EventType: 'NotifyOpenFromChatList', Order: order });
                OpenStudyOrder = order;
                if (LastOpenedOrder != null && LastOpenedOrder.OrderID != order.OrderID) {
                    DeleteOpenOrder(LastOpenedOrder);
                }
                InsertOpenOrder(order);
            }

            WorklistService.GetMedDreamViewerOverrideByStudy({
                SiteID: SelectedOrder.SiteID,
                RadiologistUserID: $sessionStorage.currentUserData.userId
            }).then(function (response) {
                if (response && response.data && response.data.HasOverride === true) {
                    SelectedOrder.DicomViewer = response.data.DicomViewer;
                }
                launchViewer(SelectedOrder);
            }, function () {
                launchViewer(SelectedOrder);
            });
        }

        $scope.OpenStudy = function (_order, isSingleView) {
            var order = null;

            if (_order.includes('Location')) {
                videoCallConvertToJsonObject(_order);
                order = $scope.selectedOrder;
            }
            else {
                order = JSON.parse(_order);
            }
            if (!Order || (Order && Order.Accession != order.Accession)) {
                GetOrderData(order).then(function (response) {
                    if (response && response.length > 0 && response[0].OrderID) {
                        order = response[0];
                        Order = order;
                        proceedToOpenStudy(order, isSingleView);
                    } else {

                        toaster.error({ body: "No report found." });
                    }
                }, function () {
                    toaster.error({ body: "No report found." });
                });

            } else {
                proceedToOpenStudy(Order, isSingleView);
            }
        }

        $scope.OpenVR = function (order, isSingleView) {
            SharedService.OpenVR(order, isSingleView);
        }

        // DeleteOpenOrder function
        function DeleteOpenOrder(Order, FromPS) {
            var lastOrder;

            if (Order) {
                lastOrder = Order;
            }
            else {
                lastOrder = LastOpenedOrder;
            }
            if (lastOrder) {
                LastOpenedOrder = null;
                var openOrders = {
                    OrderId: Order.OrderID,
                    UserId: $sessionStorage.currentUserData.userId
                };
                WorklistService.DeleteOpenOrder(openOrders).then(function () {
                    if (FromPS) {
                        if ((lastOrder)
                            && ($scope.NativeMessageResponseReportStatus == 2
                                || $scope.NativeMessageResponseReportStatus == 8)) {

                            var applyRadflowComplete = false;
                            if ((lastOrder.DictationSystem
                                && lastOrder.DictationSystem.length == 0)
                                || lastOrder.DictationSystem == 'PS360') {
                                applyRadflowComplete = true;
                            }
                            //console.log("DeleteOpenOrder > applyRadflowComplete: ", applyRadflowComplete);
                            if (applyRadflowComplete) {
                                var reportView = {
                                    Site: lastOrder.Site,
                                    PSSiteName: lastOrder.PSSiteName,
                                    OrderID: lastOrder.OrderID,
                                    Accession: lastOrder.Accession,
                                    SignBy: $sessionStorage.currentUserData.userId,
                                    SignByName: $sessionStorage.currentUserData.displayName,
                                    ProcedureDesc: lastOrder.ProcedureDesc,
                                    CheckDeficiency: (lastOrder.CheckDeficiency == 0 ? 0 : 1),
                                    SignDate: $filter('CSTDateTime')(moment().format("YYYY-MM-DD HH:mm:ss")),
                                    SourceSignDate: moment().format("YYYY-MM-DDTHH:mm:ss")
                                };
                                //console.log("DeleteOpenOrder > reportView: ", reportView);
                                WorklistService.SaveReport(reportView);
                            }

                        }

                    }
                });
            }
        }

        window.onmessage = function (event) {
            //$log.log("onmessage");
            var d = event.data;
            if (d.cmd === 'redirectClose') {
                if ($scope.konica_Redirect) {
                    $scope.konica_Redirect.close()
                }
            }
            if (d.cmd === 'radflowObject') {
                if (d.data.SelectedOrder) {

                    windowHandler.CloseWindow(["CI-VIEWER-1-" + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    "CI-VIEWER-2-" + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    'KONICA-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    'KONICATEST-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    'MedDreamViewer-' + d.data.SelectedOrder.Accession.toUpperCase().trim(),
                    'NORTHSTARKONICA-' + d.data.SelectedOrder.Accession.toUpperCase().trim()]);
                    if ($sessionStorage.MedDreamViewerKeepOpen) {
                        SharedService.clearMedDreamViewer();
                    } else {
                        SharedService.closeMedDreamViewer();
                    }
                    DeleteOpenOrder(d.data.SelectedOrder);
                    $scope.DataObject.ShowReport = false;
                }
            }
        }

        var NativeMessageResponse = function (NativeMessageResponse) {
            //console.log("NativeMessageResponse> Chat > NativeMessageResponse: ", NativeMessageResponse);
            if (NativeMessageResponse.responseEvent != null
                && NativeMessageResponse.responseEvent == "ReportResponseDetails"
                && NativeMessageResponse.reportResponseDetails != null
                && NativeMessageResponse.reportResponseDetails.ReportResponseEvent == "ReportClosed") {

                var accessions = _.split(NativeMessageResponse.reportResponseDetails.accessionNumbers, ",");
                _.each(accessions, function (accession) {
                    windowHandler.CloseWindow(["CI-VIEWER-1-" + accession.toUpperCase().trim(),
                    "CI-VIEWER-2-" + accession.toUpperCase().trim(),
                    'KONICA-' + accession.toUpperCase().trim(),
                    'KONICATEST-' + accession.toUpperCase().trim(),
                    'MedDreamViewer-' + accession.toUpperCase().trim(),
                    'NORTHSTARKONICA-' + accession.toUpperCase().trim()]);
                    if ($sessionStorage.MedDreamViewerKeepOpen) {
                        SharedService.clearMedDreamViewer();
                    } else {
                        SharedService.closeMedDreamViewer();
                    }
                });
                $scope.NativeMessageResponseReportStatus = NativeMessageResponse.reportResponseDetails.reportStatus;
                if (OpenStudyOrder && accessions.includes(OpenStudyOrder.Accession) && LastOpenedOrder.OrderID == OpenStudyOrder.OrderID) {
                    DeleteOpenOrder(OpenStudyOrder, true);
                    $scope.DataObject.ShowReport = false;
                }

            }
            if (NativeMessageResponse.responseEvent != null && NativeMessageResponse.responseEvent == "ImageResponseDetails"
                && NativeMessageResponse.imageResponseDetails != null) {
                if (!NativeMessageResponse.imageResponseDetails.Status) {
                    toaster.warning({ body: "Unable to find the image in Synapse." });
                }
            }
        }
        var NativeMessageResponseWorklist = function (evt, nativeMessageResponse) {
            NativeMessageResponse(nativeMessageResponse);
        }
        $scope.$on('NativeMessageResponseWorklist', NativeMessageResponseWorklist);

        $scope.$on("DictationChatList", function (evt, data) {
            if (data) {
                DeleteOpenOrder(data.SelectedOrder);
                $scope.DataObject.ShowReport = false;
            }
        });

        $scope.$on("ChatAssignLastOpenedOrder", function (evt, data) {
            if (data) {
                LastOpenedOrder = data.Order;
            }
        });
        function InsertOpenOrder(order) {
            if (order) {
                LastOpenedOrder = order;


                var openOrders = {
                    OrderId: order.OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId,
                    ProviderName: $filter('titleCase')($sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName), //$sessionStorage.currentUserData.displayName,
                    OpenDateTime: new Date().toLocaleString('en-US', { timeZone: 'US/Central' })
                };
                WorklistService.InsertOpenOrder(openOrders);
            }

        };
        $scope.imageViewerOptions = function (_order) {
            var messageOrder = null;
            if (_order.includes('Location')) {
                videoCallConvertToJsonObject(_order);
                messageOrder = $scope.selectedOrder;
            }
            else {
                messageOrder = JSON.parse(_order);
            }
            if (!Order || (Order && Order.Accession != messageOrder.Accession)) {
                $scope.DicomViewerList = null;
                Order = null;
                GetOrderData(messageOrder).then(function (result) {
                    if (result && result.length > 0) {
                        var order = result[0];
                        if (order.Accession == messageOrder.Accession) {
                            if (order.OptionalDicomViewer && order.OptionalDicomViewer != '') {
                                $scope.DicomViewerList = order.OptionalDicomViewer.split(',');
                                var DV = "";
                                //DicomViewerList = DicomViewerList.sort();

                                $scope.DicomViewerList.sort(
                                    function (a, b) {
                                        if (a.toLowerCase() < b.toLowerCase()) return -1;
                                        if (a.toLowerCase() > b.toLowerCase()) return 1;
                                        return 0;
                                    }
                                );
                                Order = order;
                                $timeout(function () {
                                    var objDiv = document.getElementById("messageMe");
                                    if (objDiv) {
                                        objDiv.scrollTop = objDiv.scrollHeight;
                                    }
                                });
                            }
                        }
                    }
                });
            }
        }

        $scope.SetDicomViewerText = function (DV) {
            return SharedService.SetDicomViewerText(DV, $scope.DataObject.MasterData.DicomViewers);
        };
        $scope.onViewerDropdownToggle = function (open, curMessageObj, toggleId) {
            if (!open) {
                return;
            }
            $timeout(function () {
                var toggleEl = document.getElementById(toggleId);
                var containerEl = document.getElementById('messageMe');
                if (!toggleEl || !containerEl) {
                    return;
                }
                var toggleRect = toggleEl.getBoundingClientRect();
                var containerRect = containerEl.getBoundingClientRect();
                var itemCount = ($scope.DicomViewerList && $scope.DicomViewerList.length) || 3;
                var estimatedMenuHeight = itemCount * 30 + 16;
                var spaceBelow = containerRect.bottom - toggleRect.bottom;
                curMessageObj.viewerDropUp = spaceBelow < estimatedMenuHeight;
            });
        };

        $scope.ViewReport = function (_order) {
            var messageOrder = null;
            if (_order.includes('Location')) {
                videoCallConvertToJsonObject(_order);
                messageOrder = $scope.selectedOrder;
            }
            else {
                messageOrder = JSON.parse(_order);
            }
            GetOrderData(messageOrder).then(function (result) {
                if (result && result.length > 0) {
                    Order = result[0];
                    if ((Order.ReportStatus == 1 || Order.ReportStatus == 2 || Order.ReportStatus == 5) || (Order.Status == 'RP' && Order.IsPriorOrder)) {
                        if (result[0].Accession == messageOrder.Accession) {
                            $scope.DataObject.ShowReport = true;
                            $scope.DataObject.ReportSelectedOrder = _.clone(result[0]);
                            $scope.DataObject.FormattedSelectedOrder = FormatOrder(result[0]);
                            $scope.DataObject.ReportSelectedOrder.OpenPriorReport = false;
                        }
                    }
                    else {
                        toaster.error({ body: "No report found." });
                    }
                }
                else {
                    toaster.error({ body: "No report found." });
                }
            }, function () {
                toaster.error({ body: "No report found." });
            });
        }

        function GetLookupByType() {
            WorklistService.GetLookupByType('ExamTags,RadExamTag,DicomViewer').then(function (result) {
                $scope.DataObject.MasterData.ExamTags = _.filter(result, { Type: 'ExamTags' });
                $scope.DataObject.MasterData.RadExamTag = _.filter(result, { Type: 'RadExamTag' });
                $scope.DataObject.MasterData.DicomViewers = _.filter(result, { Type: 'DicomViewer' });
            });
        }
        $scope.OpenSynapseStudy = function (_order, OptionalDV, isOpenPS, isSingleView) {
            isOpenPS = false;
            var messageOrder = null;
            if (_order.includes('Location')) {
                videoCallConvertToJsonObject(_order);
                messageOrder = $scope.selectedOrder;
            }
            else {
                messageOrder = JSON.parse(_order);
            }
            if (Order.Accession == messageOrder.Accession) {
                $scope.GetDicomViewerCredentialsCallFrom = "OPENSYNAPSESTUDY";
                $scope.OpenSynapseStudyOrder = Order;
                $scope.OpenSynapseStudyOptionalDV = OptionalDV;
                $scope.OpenSynapseStudyisOpenPS = isOpenPS;
                $q.all([
                    GetDicomViewerCredentials(Order.SiteID, OptionalDV)
                ]).then(function (data) {
                    if (data != null && data.length > 0 && data[0] != null) {
                        if (data[0].ShowModal) { return; }
                        else {
                            Order.DicomViewerCredentials = data[0].Credentials;
                            if (__env.showLoaderonPSNViewerLoad) {
                                //$scope.isLoadingSynapse = true;
                            }
                            var timeout = $timeout(function () {
                                //OpenSynapseStudy(Order, OptionalDV, isOpenPS, isSingleView);
                                SharedService.OpenSynapseStudy(Order, OptionalDV, isOpenPS, isSingleView, $scope, TimeoutList, $scope.browser);
                                //$scope.isLoadingSynapse = false;
                            }, 500);
                            TimeoutList.push(timeout);
                        }
                    }
                });
            };
        }

        function GetDicomViewerCredentials(SiteID, ViewerName) {
            $scope.DVCred = {};
            var d = $q.defer();
            var out = {};
            var objFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: SiteID,
                ViewerName: ViewerName
            };
            if (__env.CheckDicomViewerCredentials.split(',').indexOf(ViewerName) !== -1) {
                out.RequiredCredentials = true;
                WorklistService.GetDicomViewerCredentials(objFilter).then(function (result) {
                    if (result != null && result.length > 0) {
                        out.RequiredCredentials = true;
                        out.ShowModal = false;
                        out.Credentials = {};
                        out.Credentials.UserName = result[0].UserName;
                        out.Credentials.Password = result[0].Password;
                    }
                    else {
                        out.ShowModal = true;
                        $scope.DVCred.SiteID = SiteID;
                        $scope.DVCred.ViewerName = ViewerName;
                        $('#ModalDicomViewerCredentials').modal('show');
                    }
                    d.resolve(out);
                });
            }
            else {
                out.RequiredCredentials = false;
                out.ShowModal = false;
                d.resolve(out);
            }
            return d.promise;
        }

        $scope.InsertDicomViewerCredentials = function () {
            var objdata = {
                ID: -1,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: $scope.DVCred.SiteID,
                ViewerName: $scope.DVCred.ViewerName,
                UserName: $scope.DVCred.Username,
                Password: $scope.DVCred.Password,
                Modifyby: $sessionStorage.currentUserData.userId
            };
            WorklistService.InsertDicomViewerCredentials(objdata).then(function (result) {
                $('#ModalDicomViewerCredentials').modal('hide');
                if ($scope.GetDicomViewerCredentialsCallFrom == "OPENSYNAPSESTUDY") {
                    $scope.OpenSynapseStudy($scope.OpenSynapseStudyOrder, $scope.OpenSynapseStudyOptionalDV, $scope.OpenSynapseStudyisOpenPS);
                }
                else if ($scope.GetDicomViewerCredentialsCallFrom == "OPENSINGREPORT") {
                    $scope.OpenSignReport($scope.DataObject.SingReport.Order, $scope.DataObject.SingReport.OrderList);
                }
            });
        };


        function GetOrderData(filter) {
            var filter = {
                PageNum: 1,
                PageSize: 50,
                Accession: filter.Accession,
                Status: 'AL',
                UserID: $sessionStorage.currentUserData.userId,
                STATFilter: '0',
                ShowLockStudy: true,
                SortingByMultiColumn: 'O.ReceivedSinceDateTime ASC',
                Priority: 'All',
                FromSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "00:00")),
                ToSignDate: $filter('CSTDateTime')(moment(moment().format("YYYY-MM-DD") + ' ' + "23:59:59")),
                WorkListName: "Worklist Search"

            };
            var d = $q.defer();
            WorklistService.GetOrdersListQuickFilter(filter).then(function (result) {
                if (result && result.orderLists && result.orderLists.length > 0) {
                    var order = result.orderLists[0];
                    if ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) {
                        var orderAssignmentIndex = _.findIndex(order.listOrderListAssignment, function (assignment) { return assignment.OrderAssingedUserID == $sessionStorage.currentUserData.userId; });

                        order.OrderAssingedUserID = (order.listOrderListAssignment && order.listOrderListAssignment.length > 0 ? order.listOrderListAssignment[0].OrderAssingedUserID : null);
                        //order.OrderAssingedUserName = $scope.getOrderListTooltip(order);
                        order.OrderAssingedUsers = (order.listOrderListAssignment ? order.listOrderListAssignment.length : 0);

                        order.OrderAssingedUser = (orderAssignmentIndex != -1 ? $sessionStorage.currentUserData.userId : null);
                    }
                }
                d.resolve(result.orderLists);
            });
            return d.promise;
        }

        $scope.CloseReportWindow = function () {
            $scope.DataObject.ShowReport = false;
        }

        function FormatOrder(Order) {
            var order = _.clone(Order);
            order.ShowContactBtn = false;
            order.ExamTagKey = order.ExamTag && order.ExamTag != "0" ? _.find($scope.DataObject.MasterData.ExamTags, { 'Value': order.ExamTag }).Key : order.ExamTagKey;
            if (order.RadExamTag && order.RadExamTag != "0") {
                order.RadExamTagKeys = [];
                var SplitExamTags = (order.RadExamTag && order.RadExamTag.includes(',') ? order.RadExamTag.split(',') : order.RadExamTag);
                _.each(SplitExamTags, function (ExamTag) {
                    var obj = _.find($scope.DataObject.MasterData.RadExamTag, { Value: ExamTag });

                    if (obj) {
                        order.RadExamTagKeys.push(obj.Key);
                    }
                });
            }
            else {
                order.RadExamTagKeys = order.RadExamTagKeys;
            }
            if (order && order.ReportSignDate) {
                order.ReportSignDate = moment(
                    ($filter('localDate')(order.ReportSignDate, false, new Date()))
                ).format("MM/DD/YYYY");
            }
            if (order && order.PatientDOB) {
                order.PatientDOB = moment(new Date(order.PatientDOB)).format("MM/DD/YYYY");
            }
            if (order && order.Status) {
                order.OrderStatus = _.find($scope.DataObject.MasterData.OrderStatus, { 'key': order.Status }).value;
            }
            order.OrderDate = $filter('localDate')(order.OrderDate, false, new Date());
            return order;
        }
    }

}());

(function () {
    'use strict';

    angular
        .module('BlurAdmin.theme.components')
        .filter('utcToLocal', utcToLocal);


    function utcToLocal($filter) {
        return function (utcDateString, format) {
            if (!utcDateString) {
                return;
            }

            // append 'Z' to the date string to indicate UTC time if the timezone isn't already specified
            if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
                utcDateString += 'Z';
            }

            return $filter('date')(utcDateString, format);
        };
    }

})();
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('commonAgGrid', {
            templateUrl: 'app/theme/components/common-ag-grid/common-ag-grid.html',
            bindings: {
                columnDefs: '<',
                rowData: '<',
                gridId: '@',
            },
            controller: commonAgGridController
        });

    /** @ngInject */
    function commonAgGridController($scope, $rootScope, $state, $interval, $sessionStorage, uiGridConstants, $log, $q, PaymentContractService, $timeout, $filter, $sce, NgTableParams, APP_CONSTANTS, toaster) {
        var vm = this;
        var gridDiv;
        var TimeoutList = [];
        vm.$onChanges = function (changes) {
            var rowData = changes.rowData ? changes.rowData.currentValue : vm.rowData;
            //gridOptions.api.setRowData([]);
            if (gridOptions.api) { gridOptions.api.setRowData(rowData); }
        };
        vm.$onDestroy = function () {
            _.each(TimeoutList, function (timeout) { $timeout.cancel(timeout); });
        }
        vm.$onInit = function () {
            var timeout = $timeout(function () { onAgGridLoad(); }, 100);
            TimeoutList.push(timeout);
        }

        function onAgGridLoad() {
            gridDiv = document.getElementById(vm.gridId);
            new agGrid.Grid(gridDiv, gridOptions);
        }
        // let the grid know which columns and what data to use
        var gridOptions = {
            columnDefs: vm.columnDefs,
            rowData: vm.rowData,
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
            },
        };



    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('eventLog', {
            templateUrl: 'app/theme/components/event-log/event-log.html',
            bindings: {
                orderId: '<',//order-id
                accession: '<'//accession
            },
            controller: EventLogController
        });

    /** @ngInject */
    function EventLogController($scope, WorklistService, $filter, NgTableParams) {

        var work = this;
        var sortBy = "DESC";
        $scope.sortColumn = "EventCreatedDate";
        $scope.reverseSort = true;

        $scope.onChange = function () {
            init();
        };

        work.$onChanges = function (changes) {
            init();
        }
       
        function init() {
            if (work.accession && work.orderId) {               
                loadData();
            }
        }

        var loadData = function () {
            $scope.isLoading = true;
            $scope.eventLog = null;
            var data = { OrderID: work.orderId, Accession: work.accession, SortBy: sortBy }
            WorklistService.GetReportsOrdersEventDatat(data).then(function (response) {
                $scope.isLoading = false;
                _.each(response, function (data) {
                    if (data.EventCreatedDate) {
                        data.EventCreatedDate = ($filter('localDate')(data.EventCreatedDate, false, new Date(), true));
                    }
                })
                $scope.eventLog = response;
                $scope.tableParams = new NgTableParams({ count: Infinity }, { counts: [], dataset: $scope.eventLog });
            }, function (error) {
                $scope.isLoading = false;
            });

            //$scope.EventLog_Options.dataSource.read();
        }
        $scope.sortDate = function (column) {
            $scope.reverseSort = ($scope.sortColumn) ? !$scope.reverseSort : false;
            $scope.sortColumn = column;
            sortBy = $scope.reverseSort ? "DESC" : "ASC";
            loadData()
        }
        $scope.getSortClass = function (column) {
            if ($scope.sortColumn == column) {
                return $scope.reverseSort ? 'arrow-down' : 'arrow-up';
            }
            return '';
        }
        //$scope.EventLog_Options = {
        //    dataSource: new kendo.data.DataSource({
        //        transport: {
        //            read: function (options) {
        //                var data = { OrderID: work.orderId, Accession: work.accession }
        //                WorklistService.GetReportsOrdersEventDatat(data).then(function (response) {
        //                    $scope.eventLog = response;                            
        //                    options.success(response);
        //                }, function (error) {
        //                    options.error();
        //                });
        //            }
        //        },
        //        pageSize: 10,
        //    }),
        //    pageable: {
        //        refresh: true,
        //        pageSize: 10,
        //        pageSizes: [10, 20, 50, 100],
        //        buttonCount: 5
        //    },
        //    resizable: false,
        //    noRecords: true,
        //    sortable: true,
        //    reorderable: true,
        //    columnMenu: false,
        //    scrollable: true,
        //    selectable: true,
        //    height: 500,
        //    columns:
        //        [
        //            {
        //                field: "EventName",
        //                title: "Event Name",
        //                width: 100,
                        
        //            },
        //            {
        //                field: "AdditionalInfo",
        //                title: "Additional Information",
        //                width: 150
        //            },
        //            {
        //                field: "Username",
        //                title: "Created By",
        //                width: 100
        //            },


        //            {
        //                field: "EventCreatedDate",
        //                title: "Created Date",
        //                width: 100,
        //                sortable: true,
        //                template: function (dataItem) {
        //                    return "{{dataItem.EventCreatedDate | date:'M/d/yy HH:mm'}}";
        //                }
        //            },
        //        ]
        //};

        init();
    }
}());

(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('fileViewer', {
            templateUrl: 'app/theme/components/file-viewer/file-viewer.html',
            transclude: true,
            bindings: {
                title: '<',
                filePath: '<',
                fileUrl: '<', // Use to download file from this url if provide otherwise use fileContent
                fileServiceUrl: '<',// Use for pdf file to copy page or page range if provide
                fileName: '<',
                fileContent: '<', // If fileUrl not provide will render the content of this property     
                fileBinaryContent: '<',  // use for download data          
                fileType: '<',  // use for download data          
                onFileEditCompleted: '&',
                sendFax: '&',
                selectedOrder: '<'
            },
            controller: FileViewerController
        });
        



    /** @ngInject */
    function FileViewerController($scope, $sce, fileHelperService, commonService, APP_CONSTANTS, TechnoService, toastr, toaster, __env) {
        var vm = this;
        var printWindow = null;
        vm.pageSize = 1;
        vm.copyRangeInfo = {
            startPage: 1,
            endPage: 1,
            show: false
        };
        vm.encodedURL = "";
        vm.DocFileFrameSrc = __env._environment.config.attachmentViewerIFrameSRC + __env._environment.config.apiResourceServiceBaseUri + "psorders/GetFileByURI/";

        init();

        $scope.onLoad = function () {
            vm.isLoading = false;
        }

        vm.$onChanges = function (changes) {
            if (changes.fileUrl) {
                init();
            }
        };

        function init() {
            getFile();
        }
        function getFile() {

            $scope.pdfUrl = '';
            $scope.fileContent = '';
            var fileType = fileHelperService.getFileType(vm.fileName);
            if (vm.fileUrl) {
                vm.isLoading = true;
                fileHelperService.loadFileContent(vm.fileUrl, vm.fileName, function (contentData) {
                    vm.fileBinaryContent = contentData.binary;
                    if (fileType == 'image') {
                        $timeout(function () {
                            vm.fileContent = contentData.fileContent;
                        });
                    }
                    vm.isLoading = false;
                }, function (err) {
                    vm.isLoading = false;
                    $scope.loading = err;
                });
            } else if (vm.fileContent) {
                $scope.pdfUrl = vm.fileContent;
                if (fileType == 'image') {
                    var img = new Image();
                    img.src = vm.fileContent;
                    img.onload = function () {
                        $scope.zoomWidth = img.width;
                        //$scope.imgStyle = "{width:'" + img.width + "px'}";
                        //$scope.imgStyle = img.width.toString() + 'px';
                    };
                } else {
                    if (vm.encodedURL == "") {
                        var stringURL = vm.filePath;
                        vm.encodedURL = btoa(stringURL);
                        var frameURL = vm.DocFileFrameSrc + vm.encodedURL;
                        // Office Online fetches the file itself without headers, so behind APIM (PROD) the key goes in
                        // the file URL's query string; the '?' and '=' are encoded so they stay inside the outer src= value
                        if (__env.OcpApimSubscriptionKey) {
                            frameURL += '%3Fsubscription-key%3D' + encodeURIComponent(__env.OcpApimSubscriptionKey);
                        }
                        vm.DocFileFrameSrc = $sce.trustAsResourceUrl(frameURL);
                    }
                }
            }
        };
        vm.downloadFile = function () {
            var mimeType = fileHelperService.getMimeType(vm.fileName);
            commonService.downloadFile(vm.fileBinaryContent, vm.fileName, mimeType);
            //commonService.downloadImage(mimeType, vm.fileBinaryContent, vm.fileName);
            $(window).off('resize');
        }

        vm.getFileType = function () {
            return fileHelperService.getFileType(vm.fileName);
        }

        vm.openFile = function () {
            var fileType = fileHelperService.getFileType(vm.fileName);
            if (fileType == 'pdf') {
                // Block javascript:/vbscript: (and similar) URL schemes before opening a new
                // window - window.open() executes these in the new window's context if not filtered.
                if (/^\s*(javascript|vbscript):/i.test($scope.pdfUrl || '')) {
                    console.error('fileViewer: refusing to open unsafe URL scheme');
                    return;
                }
                window.open($scope.pdfUrl, 'FileViewer', 'height=700,width=900,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
            }
            else if (fileType == 'image') {
                var dialogOptions = {
                    title: vm.fileName,
                    message: '<div class="text-center"><img style="max-width:100%" src=' + vm.fileContent + ' /></div>',
                    width: 500
                };
                commonService.openSimpleDialog(dialogOptions);
            }
        }
        vm.copyPage = function () {
            var fileType = fileHelperService.getFileType(vm.fileName);

            var pageInfo = getPdfPageInfo();
            if (fileType == 'pdf') {
                copyPdfPage(pageInfo.currentPage, pageInfo.currentPage);
            } else {
                var canvas = $("#file-viewer-container canvas");
                if (canvas.length) {
                    var img = canvas[0].toDataURL("image/png");
                    processImage(img);
                }
            }

        }
        vm.showCopyRange = function () {
            vm.copyRangeInfo.show = true;
            var pageInfo = getPdfPageInfo();
            vm.pageSize = pageInfo.pageSize;
            vm.copyRangeInfo.startPage = pageInfo.currentPage;
            vm.copyRangeInfo.endPage = pageInfo.pageSize;
        };


        vm.copyPageRange = function () {
            if (vm.copyRangeInfo.endPage < vm.copyRangeInfo.startPage) {
                toaster.warning({ body: "End page must greater than or equal start page." });
                return;
            }
            copyPdfPage(vm.copyRangeInfo.startPage, vm.copyRangeInfo.endPage);
            vm.copyRangeInfo.show = false;
        }

        function copyPdfPage(startPage, endPage) {
            if (vm.fileServiceUrl) {
                vm.isLoading = true;
                var fileServiceUrl = vm.fileServiceUrl + '?startPage=' + startPage + '&endPage=' + endPage;
                fileHelperService.loadFileContent(fileServiceUrl, vm.fileName, function (fileData) {
                    var fileName = buildPageFileName(startPage, endPage);
                    fileHelperService.blobToBase64(fileData.blob, function (base64Data) {
                        fileData.base64Data = base64Data;
                        fileData.startPage = startPage;
                        fileData.endPage = endPage;
                        processOutputFile(fileName, fileData);
                    });
                    vm.isLoading = false;
                }, function (err) {
                    vm.isLoading = false;
                    $scope.loading = err;
                });
            }
            else {
                toaster.warning({ body: "No file serice url" });
            }

        }


        function getPdfPageInfo() {
            var currentPage = Number($("#file-viewer-container [ng-model=pageNum]").val());
            var pageSize = Number($("#ngPdfPageCount").val() || 1);
            var pageInfo = {
                currentPage: currentPage,
                pageSize: pageSize
            };
            return pageInfo;
        }

        vm.imageApi;
        vm.cropCompleted = function () {
            if (vm.imageApi) {
                vm.imageApi.toPng(function (fileContentBase64) {
                    processImage(fileContentBase64);
                });
            }
        }

        function processImage(fileContentBase64, contentType) {
            contentType = contentType || 'image/png';
            var fileName = commonService.changeFileExtension(vm.fileName, 'png');

            var fileData = {
                base64Data: fileContentBase64,
                mimeType: contentType
            };
            processOutputFile(fileName, fileData);
        }
        function buildPageFileName(startPage, endPage) {
            if (startPage) {
                var arrPage = [startPage];
                if (startPage !== endPage) {
                    arrPage = [startPage, endPage];
                }
                var appendPageNum = '';
                appendPageNum = '-page-' + arrPage.join('-');
                var fileExt = fileHelperService.getFileExtension(vm.fileName);
                return commonService.changeFileExtension(vm.fileName, fileExt, appendPageNum);
            }
            return vm.fileName;
        }
        function processOutputFile(fileName, fileData) {
            if (vm.onFileEditCompleted) {
                var fileChangedData = {
                    fileName: fileName,
                    fileContentBase64: fileData.base64Data,
                    fileContent: fileData.fileContent,
                    contentType: fileData.mimeType,
                    startPage: fileData.startPage,
                    endPage: fileData.endPage,
                };

                vm.onFileEditCompleted({ fileChangedData: fileChangedData });
            }
        }
    }
}());

(function () {
    'use strict';
    angular.module('BlurAdmin.theme.components')
        .component('inputDropdownList', {
            templateUrl: 'app/theme/components/input-dropdown-list/input-dropdown-list.html',
            bindings: {
                options: '<',
                selectedOption: '<',
                placeHolderText:'<',
                onTextChanged: '&',
                onOptionSelected: '&',
            },
            controller: InputDropdownListController
        });
    function InputDropdownListController() {

        var vm = this;
        
        vm.$onChanges = function (changes) {
        }

        vm.$onDestroy = function () {

        }

        vm.$onInit = function () {
        }
    }
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.theme.components')
        .component('mapCustomRvu', {
            templateUrl: 'app/theme/components/map-custom-rvu/map-custom-rvu.html',
            bindings: {
                siteList: '<',
                cptList: '<',
                ngModel: "<",
                divId: '@',
                saveData: '&'
            },
            controller: mapCustomRvuCtrl
        });

    function mapCustomRvuCtrl($scope, $timeout, $compile, toaster, MappingService, $q) {

        var vm = this;
        var gridApi = null;
        var columnApi = null;
        var rowID = 0;
        var ngModelKey = null;
        $scope.DataObject = {
            uploadedFile: null,
            SiteDropdown: {
                SelectedSite: null,
                SiteList: []
            },
            CPTMultiSelect: {
                divId: "CPTMultiSelect" + vm.divId,
                keys: ['CPT_Code', 'CPT_Description'],
                separator: " - ",
                uniqKey: 'CPT_Code',
                placeHolder: "Select CPT(s)",
                SelectedValue: { list: [] },
                cptList: [],
            }
        }

        //#region Component Events
        vm.$onInit = function () {
            var timeout = $timeout(function () {
                if (vm.divId) {
                    var gridDiv = document.querySelector('#' + vm.divId);
                    if (gridDiv) {
                        new agGrid.Grid(gridDiv, gridOptions);
                        gridApi = gridOptions.api;
                        columnApi = gridOptions.columnApi;
                        gridApi.setRowData([]);
                    }
                    $timeout.cancel(timeout);
                    timeout = null;
                }
            }, 100);
        }
        vm.$onChanges = function (changes) {
            if (changes.siteList && changes.siteList.currentValue) {
                $scope.DataObject.SiteDropdown.SiteList = changes.siteList.currentValue;
            }
            if (changes.cptList && changes.cptList.currentValue) {
                $scope.DataObject.CPTMultiSelect.cptList = changes.cptList.currentValue;
            }
            if (changes.ngModel && changes.ngModel.currentValue) {
                ngModelKey = (Object.keys(changes.ngModel.currentValue)) ? Object.keys(changes.ngModel.currentValue)[0] : ngModelKey;
                if (ngModelKey) {
                    (gridApi) ? (gridApi.setRowData(changes.ngModel.currentValue[ngModelKey])) : (gridOptions.rowData = changes.ngModel.currentValue[ngModelKey]);
                }
            }
        }
        vm.$onDestroy = function () {
            if (gridApi) {
                gridApi.destroy();
            }
            gridApi = null;
        }
        //#endregion Component Events

        //#region Cell Renderer
        function SiteCellRenderer(params) {
            if (params && params.data) {
                if (params.data.isPinnedRow) {
                    return '<span class="fw-600"><i class="fa fa-plus"></i> ' + params.data.Site + '</span>';
                }
                else if (!params.data.Site) {
                    return "<span>Click Here!</span>";
                }
                else {
                    return '<span>' + params.data.Site.Site + '</span>';
                }
            }
        }
        function CPTCellRenderer(params) {
            var template = "";
            if (params && params.data && params.data.CPT) {

                template = "<div class='customrvu-cpt'>"

                _.each(params.data.CPT, function (cptObj) {
                    template = template + "<span class='p-4px-all mlp-value-box mr-4px text-nowrap'>" + cptObj.CPT_Code;
                    if (cptObj.CPT_Description && cptObj.CPT_Description != "") {
                        template = template + "<br>" + cptObj.CPT_Description;
                    }
                    template = template + "</span>";
                });

                template = template + "</div>";

            }
            return template;
        }
        //#endregion Cell Renderer

        //#region Cell Editor
        function SiteEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                if (params.data && params.data.Site) {
                    $scope.DataObject.SiteDropdown.SelectedSite = params.data.Site;
                }
                var template = "";

                template = template + '<ui-select class="mult-select site-editor-custom-rvu" ng-model="DataObject.SiteDropdown.SelectedSite" style="z-index:99999;" append-to-body="true" tooltip-class="uibtooltipDenial"' +
                    "uib-tooltip=\"Choose a Site\" tooltip-placement=\"auto top\">" +
                    "<ui-select-match placeholder=\"Choose a Site\" allow-clear=\"true\">" +
                    "{{$select.selected.Site}}" +
                    "</ui-select-match>" +
                    "<ui-select-choices repeat=\"siteObj in DataObject.SiteDropdown.SiteList | propsFilter:  {Site : $select.search}\" position=\'down\'>" +
                    "<div ng-bind-html=\"siteObj.Site | highlight: $select.search\"></div>" +
                    "</ui-select-choices>" +
                    "</ui-select>";

                this.eGui.innerHTML = template;

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function (params) {
                return this.eGui;
            }
            CustomEditor.prototype.destroy = function (params) { }
            CustomEditor.prototype.getValue = function (params) { }

            return CustomEditor;
        }

        function CPTEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                this.eGui = document.createElement('div');

                if (params.data && params.data.CPT) {
                    $scope.DataObject.CPTMultiSelect.SelectedValue = { list: params.data.CPT };
                }

                var template = "";
                template = template + "<multi-Select master-data=\"DataObject.CPTMultiSelect\" class=\"cpt-editor-custom-rvu\"" +
                    "list=\"DataObject.CPTMultiSelect.cptList\"" +
                    "ng-model=\"DataObject.CPTMultiSelect.SelectedValue\" on-search=\"SearchCPT(searchObj)\" search-delay=\"500\">" +
                    "</multi-Select>";
                this.eGui.innerHTML = template;

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function (params) {
                return this.eGui;
            }
            CustomEditor.prototype.destroy = function (params) { }
            CustomEditor.prototype.getValue = function (params) { }

            return CustomEditor;
        }
        //#endregion Cell Editor
        var columnDefs = [
            {
                field: "Site", initialWidth: 250,
                cellRenderer: SiteCellRenderer,
                editable: function (params) {
                    return (params && params.data && !params.data.isPinnedRow);
                },
                cellEditor: SiteEditor(),
                cellEditorPopup: true,
                wrapText: true,
                autoHeight: true,
                cellClass: "site-rvu-cell-render",
            },
            {
                field: "CPT", flex: 1,
                editable: function (params) {
                    return (params && params.data && !params.data.isPinnedRow);
                },
                cellRenderer: CPTCellRenderer,
                cellEditor: CPTEditor(),
                cellEditorPopup: true,
                wrapText: true,
                autoHeight: true,
                cellClass: "cpt-rvu-cell-render"
            },
            {
                field: "CustomwRVU", headerName: "Custom wRVU", initialWidth: 100,
                cellRenderer: function (params) {
                    if (params && params.data && parseFloat(params.data.CustomwRVU) != NaN) {
                        return params.data.CustomwRVU;
                    }
                },
                editable: function (params) {
                    return (params && params.data && !params.data.isPinnedRow);
                },
                cellEditor: 'agNumberCellEditor',
                cellClass: "custom-rvu-cell-render"
            },
            {
                field: "Action", headerName: "", width: 30,
                cellRenderer: function (params) {
                    if (params && params.data && !params.data.isPinnedRow) {
                        return '<i class="fa fa-trash-o txt-clr-31 cursor-pointer fs-16px" aria-hidden="true" title="Delete"></i>';
                    }
                },
                sortable: false,
                suppressMovable: true,
                resizable: false,
            },
        ]
        var gridOptions = {
            rowHeight: 36,
            columnDefs: columnDefs,
            defaultColDef: {
                sortable: true,
                suppressMenu: true,
                lockVisible: true,
                resizable: true,
            },
            singleClickEdit: true,
            getContextMenuItems: [],
            sortingOrder: ['desc', 'asc'],
            onGridReady: function () {
                gridApi.setPinnedBottomRowData([{
                    Site: "Add New Mapping",
                    CPT: "",
                    CustomwRVU: "",
                    rowColor: "#1c1c1c",
                    isPinnedRow: true
                }]);
            },
            getRowId: function (params) {
                if (params && params.data && !params.data.hasOwnProperty("rowID")) {
                    params.data.rowID = rowID;
                    rowID++;
                }
                return params.data.rowID;
            },
            getRowStyle: function (params) {
                if (params && params.data && params.data.rowColor) {
                    return {
                        paddingTop: '4px',
                        background: params.data.rowColor
                    };
                }
            },
            onCellClicked: function (params) {
                if (params.data) {
                    if (params.data.isPinnedRow) {
                        AddNewRow();
                    }
                    else if (params.column.colId == "Action") {
                        gridApi.applyTransaction({ remove: [params.data] });
                    }
                }
            },
            onCellEditingStopped: onCellEditingStopped
        }
        function onCellEditingStopped(params) {
            if (params && params.node && params.node.data) {
                switch (params.column.colId) {
                    case "Site":
                        params.node.data.Site = $scope.DataObject.SiteDropdown.SelectedSite;
                        $scope.DataObject.SiteDropdown.SelectedSite = null;
                        gridApi.refreshCells({ rowNodes: [params.node] });
                        break;

                    case "CPT":
                        params.node.data.CPT = $scope.DataObject.CPTMultiSelect.SelectedValue.list;
                        $scope.DataObject.CPTMultiSelect.SelectedValue = { list: [] };
                        gridApi.refreshCells({ rowNodes: [params.node] });
                        break;
                }
            }
        }
        function AddNewRow() {
            if (gridApi) {
                gridApi.applyTransaction({
                    add: [{
                        Site: null,
                        CPT: null,
                        CustomwRVU: null,
                    }],
                });
            }
        }

        $scope.SaveGridData = function () {
            var gridData = [];
            if (gridApi) {
                gridApi.stopEditing();
                var isGridDataFilled = true;
                gridApi.forEachNode(function (node) {
                    if (node.data) {
                        if ((node.data.CPT && node.data.CPT.length > 0) && node.data.Site && node.data.CustomwRVU) {
                            gridData.push(node.data);
                        }
                        else {
                            isGridDataFilled = false;
                        }
                    }
                });
            }
            if (isGridDataFilled && gridData.length > 0) {
                vm.ngModel[ngModelKey] = _.cloneDeep(gridData);
                var rowNode = CheckDuplication();
                if (rowNode && rowNode.length > 0) {
                    gridApi.flashCells({
                        rowNodes: rowNode,
                        fadeDelay: 7000
                    });
                    toaster.warning({ body: "Please remove duplicate Site and CPT." });
                }
                else {
                    vm.saveData({ gridData: gridData });
                }
            }
            else {
                toaster.warning({ body: "Please enter the required details." });
            }
        }

        $scope.DownloadSampleCSV = function () {
            MappingService.DownloadCustomwRVUMapppingSample().then(function (fileStorage) {
                if (fileStorage) {
                    var byteCharacters = atob(fileStorage.FileContent);
                    var byteNumbers = new Uint8Array(byteCharacters.length);

                    for (var i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    var blob = new Blob([byteNumbers], { type: fileStorage.ContentType });
                    var url = URL.createObjectURL(blob);

                    var a = document.createElement('a');
                    a.href = url;
                    var filename = "Custom wRVU Mapping Sample";
                    a.download = filename + ".xlsx";
                    document.body.appendChild(a);
                    a.click();
                }
            });
        }

        $scope.ResetFileInput = function () {
            document.getElementById("fileInput").value = null;
        }

        $scope.readFile = function () {
            var file = document.getElementById('fileInput').files[0];
            if (file) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var data = e.target.result;
                    var workbook = XLSX.read(data, { type: 'binary' });

                    // Extract the first sheet from the workbook
                    var firstSheetName = workbook.SheetNames[0];
                    var worksheet = workbook.Sheets[firstSheetName];
                    if (worksheet) {

                        var columnList = (XLSX.utils.sheet_to_json(worksheet, { header: 1 }))[0];

                        var isValidFile = false;
                        if (columnList.length == 3) {
                            var SiteColIdx = _.findIndex(columnList, function (col) { return col == "Site" });
                            var CPTColIdx = _.findIndex(columnList, function (col) { return col == "CPT Code" });
                            var RVUColIdx = _.findIndex(columnList, function (col) { return col == "Custom wRVU" });
                            if (SiteColIdx != -1 && CPTColIdx != -1 && RVUColIdx != -1) {
                                isValidFile = true;
                            }
                        }
                        if (isValidFile) {
                            $scope.$apply(function () {
                                var jsonData = XLSX.utils.sheet_to_json(worksheet);
                                if (jsonData.length > 0) {
                                    var rowData = _.map(jsonData, function (item) {
                                        return _.mapKeys(item, function (value, key) {
                                            return (key == "CPT Code") ? "CPT" : ((key == "Custom wRVU") ? "CustomwRVU" : key);
                                        });
                                    });

                                    if (rowData.length > 0) {

                                        _.each(rowData, function (obj) {
                                            obj.CustomwRVU = isNaN(parseFloat(obj.CustomwRVU)) ? null : (obj.CustomwRVU);
                                            var siteObj = _.find($scope.DataObject.SiteDropdown.SiteList, { Site: obj.Site });
                                            obj.Site = (siteObj) ? siteObj : null;
                                        });

                                        var CPTCodes = [];
                                        _.each(rowData, function (obj) {
                                            if (obj.CPT) {
                                                var cptObj = { CPTCode: obj.CPT };
                                                CPTCodes.push(cptObj);
                                            }
                                        });

                                        if (CPTCodes.length > 0) {
                                            GetMappedCPTWRVUList(null, CPTCodes).then(function (result) {
                                                if (result && result.length > 0) {
                                                    $scope.DataObject.CPTMultiSelect.cptList = _.uniqBy(_.concat($scope.DataObject.CPTMultiSelect.cptList, result), "CPT_Code");
                                                }

                                                _.each(rowData, function (obj) {
                                                    var cptObj = _.filter(result, { CPT_Code: obj.CPT });
                                                    obj.CPT = (cptObj && cptObj.length > 0) ? cptObj : null;
                                                });
                                                loadUploadedFileData(rowData);
                                            });
                                        }
                                        else {
                                            loadUploadedFileData(rowData);
                                        }
                                    }
                                    else {
                                        toaster.error({ body: "Invalid Details." })
                                    }
                                }
                                else {
                                    toaster.error({ body: "Invalid Details." })
                                }
                            });
                        }
                        else {
                            toaster.error({ body: "Invalid File." })
                        }
                    } else {
                        toaster.error({ body: "Invalid File." })
                    }
                };

                // Read the file as binary string
                reader.readAsBinaryString(file);
            }
        };
        function loadUploadedFileData(rowData) {
            var gridData = [];
            _.each(rowData, function (obj) {
                if (obj && (obj.CPT && obj.Site && obj.CustomwRVU)) {
                    gridData.push(obj);
                }
            });
            if (gridApi && gridData.length > 0) {
                gridApi.setRowData(gridData);
            }
            else {
                toaster.error({ body: "Invalid Details." })
            }
        }
        $scope.SearchCPT = function (searchObj) {
            if (searchObj && searchObj.isSearched && searchObj.searchKey != "") {
                GetMappedCPTWRVUList(searchObj.searchKey, null).then(function (result) {
                    if (result && result.length > 0) {
                        $scope.DataObject.CPTMultiSelect.cptList = _.uniqBy(_.concat($scope.DataObject.CPTMultiSelect.cptList, result), "CPT_Code");
                    }
                });
            }
        }

        function GetMappedCPTWRVUList(SearchKey, CPTCodes) {
            var d = $q.defer();
            var params = {};
            if (CPTCodes && CPTCodes.length > 0) {
                params.CPTCodes = CPTCodes;
            }
            else if (SearchKey) {
                params.SearchKey = SearchKey;
            }
            MappingService.GetMappedCPTWRVUList(params).then(function (result) {
                d.resolve(result);
            }, function () { d.reject(); });
            return d.promise;
        }

        function ClickEventListner(event) {
            var siteEditor = event.target.closest(".site-editor-custom-rvu");
            var cptEditor = event.target.closest(".cpt-editor-custom-rvu");

            var siteRender = event.target.closest(".site-rvu-cell-render");
            var cptRender = event.target.closest(".cpt-rvu-cell-render");
            var rvuRender = event.target.closest(".custom-rvu-cell-render");

            if (!siteEditor && !cptEditor && !siteRender && !cptRender && !rvuRender && gridApi) {
                gridApi.stopEditing();
            }
        }
        window.addEventListener("click", ClickEventListner);

        function CheckDuplication() {
            var seen = {};
            var duplicates = [];
            gridApi.forEachNode(function (node) {
                if (node.data) {
                    var row = node.data;
                    _.each(row.CPT, function (cptObj) {
                        var key = (cptObj.CPT_Code) + '|' + (row['Site'].Site);
                        if (seen[key]) {
                            duplicates.push(node);
                            var idx = _.findIndex(duplicates, { rowIndex: seen[key].rowIndex });
                            if (idx == -1) {
                                duplicates.push(seen[key]);
                            }
                        }
                        else {
                            seen[key] = node;
                        }
                    });
                }
            });
            return duplicates;
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('multiSelect', {
            templateUrl: 'app/theme/components/multi-select/multi-select.html',
            bindings: {
                masterData: '<',
                list: '<',
                ngModel: '<',
                placeHolder: '@',
                searchDelay: '@',
                onChange: '&',
                onRemoveTag: '&',
                onAddTag: '&',
                onSearch: '&',
                ngDisabled: '<',
            },
            controller: multiSelectCtrl
        });

    /** @ngInject */
    function multiSelectCtrl($scope, $q, $timeout, $compile) {

        /*
         * How to user multi-select Dropdown ? 
         * ----------------------------------------------------------
         * create one masterData object in parent with below listed properties:
         *      1.divId: to create grid with "uniq" id.
         *      2.keys: Array of string which includes Json property to be displayed in Grid and Tags
         *      3.uniqKey: uniqKey to uniquely identify object from JSON Array. for ex: userId in UsersList
         *      4.placeHolder: place holder to be displayed in tags input
         *      5.ngModel: ng-model property is used for default selection and if you do any changes in selection and it will be reflected automatically.
         *                 step1 : create one object like $scope.SelectedValue:{ list: [] } (*variable name can be different.)
         *                 step2: pass only SelectedValue in html side. changes done in selection will be reflected in 'list ' property.
         *      6.search-delay : how many mill sec to wait before hitting on-search method.
         *                 
         * ----------------------------------------------------------
         * EVENTS : this component outbounds 3 events which can be detected on parent side using scope function.
         *      1.on-add-tag(tag): when user select any value then this event will be triggered. Added data can be accessed using "tag" parameter in scope function.
         *      2.on-remove-tag(tag): when user remove/deselect any value then this event will be triggered. Removed data can be accessed using "tag" parameter in scope function.
         *      3.on-change(selectedData): when user select or deselect any value then this event will be triggered. "!!avoid using this!!".
         *      4.on-search(searchObj): custom search logic to bind new data list in dropdown*
         *      
         * ----------------------------------------------------------
         * 
         * Author: Chirag Jadav.
         **/

        var vm = this;
        var DataList = [];
        var availableNodes = [];
        var searchText = "";
        var separator = "";
        $scope.selectedItems = { Obj: null };
        $scope.DataObject = {
            dropUp: false,
            placeHolder: "Select Value",
            searchDelay: 100,
        }
        vm.$onInit = function () {
            initGrid();
        }
        vm.$onChanges = function (changes) {
            if (changes.masterData) {
                if (changes.masterData.currentValue && changes.masterData.currentValue != "") {
                    if (changes.masterData.currentValue.divId) {
                        vm.divId = changes.masterData.currentValue.divId;
                        vm.gridId = vm.divId + 'Grid';
                        vm.dropdownDiv = vm.divId + 'Dropdown';
                        $scope.DataObject.placeHolder = changes.masterData.currentValue.placeHolder;
                        vm.tagsInput = vm.divId + 'tagsId';
                    }
                }
                if (changes.masterData.currentValue && changes.masterData.currentValue.uniqKey) {
                    vm.uniqKey = changes.masterData.currentValue.uniqKey;
                }
                if (changes.masterData.currentValue && changes.masterData.currentValue.SelectedValue) {
                    preSelectData(changes.masterData.currentValue.SelectedValue);
                }
                if (changes.masterData.currentValue && changes.masterData.currentValue.separator) {
                    separator = changes.masterData.currentValue.separator;
                }
            }
            if (changes.list) {
                if (changes.list.currentValue) {
                    DataList = changes.list.currentValue;
                }
                if (vm.masterData && vm.masterData.keys) {
                    DataList = _.sortBy(DataList, vm.masterData.keys);
                }
                if (gridOptions && gridOptions.api) {
                    gridOptions.api.setRowData(DataList);
                    SelectRow();
                    availableNodes = [];
                    gridOptions.api.forEachNode(function (node) {
                        availableNodes.push(node);
                    });
                } else {
                    gridOptions.rowData = DataList;
                }
            }
            if (changes.ngModel && changes.ngModel.currentValue) {
                preSelectData(changes.ngModel.currentValue);
            }
            if (changes.placeHolder && changes.placeHolder.currentValue) {
                $scope.DataObject.placeHolder = changes.placeHolder.currentValue;
            }
        }
        vm.$onDestroy = function () {
            document.removeEventListener('click', onDocumentClick);
            if (gridOptions && gridOptions.api) {
                gridOptions.api.destroy();
            }
        }
        function preSelectData(selectedVal) {
            $scope.selectedItems.Obj = [];
            if (selectedVal && selectedVal.list) {
                createDisplayProp(selectedVal.list);
                $scope.selectedItems.Obj = _.uniqBy(_.cloneDeep(selectedVal.list), vm.uniqKey);
                if (gridOptions && gridOptions.api) {
                    gridOptions.api.deselectAll();
                    SelectRow();
                }
            }
        }
        function initGrid() {
            var d = $q.defer();
            separator = ((vm.masterData && vm.masterData.separator) ? vm.masterData.separator : ", ");
            if (vm.searchDelay && !isNaN(parseInt(vm.searchDelay))) {
                $scope.DataObject.searchDelay = parseInt(vm.searchDelay);
            }
            var timeout = $timeout(function () {
                var columndefs = [{
                    field: "Select All",
                    checkboxSelection: true,
                    suppressMenu: true,
                    minWidth: 30,
                    maxWidth: 30,
                    headerName: "",
                    headerComponent: CustomHeaderCheckBox(),
                }];
                if (vm.masterData.keys && vm.masterData.keys.length > 0) {
                    columndefs.push({
                        headerComponent: CustomHeaderText(),
                        field: vm.masterData.keys[0],
                        headerName: "Select All",
                        suppressMenu: true,
                        flex: 1,
                        autoHeight: true,
                        cellClass: 'pt-3px',
                        cellRenderer: function (params) {
                            var val = "";
                            _.each(vm.masterData.keys, function (key) {
                                if (val == "") {
                                    val = params.data[key];
                                } else if (params.data[key]) {
                                    val = val + separator + params.data[key];
                                }
                            });
                            return val;
                        },
                        getQuickFilterText: function (params) {
                            if (searchText) {
                                return params.data.DisplayProp;
                            };
                        },
                    });
                }
                gridOptions.columnDefs = columndefs;
                var gridDiv = document.getElementById(vm.gridId);
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, gridOptions);
                    availableNodes = [];
                    gridOptions.api.forEachNode(function (node) {
                        availableNodes.push(node);
                    });
                    SelectRow();
                }
                $timeout.cancel(timeout);
                timeout = null;
                d.resolve();
            }, 200);
            return d.promise;
        }
        function CustomHeaderCheckBox() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.className = "d-flex"
                this.eGui.innerHTML = '<div role="presentation" class="ag-labeled ag-label-align-right ag-checkbox ag-input-field ag-header-select-all" aria-hidden="true">' +
                    '<div ref="eLabel" class="ag-input-field-label ag-label ag-hidden ag-checkbox-label" aria-hidden="true" role="presentation"></div>' +
                    '<div ng-class="isAllNodesSelected()"  ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper" role="presentation">' +
                    '<input id="SiteLocCheckbox" ng-click="SelectAllNodes()" ref="eInput" class="ag-input-field-input ag-checkbox-input" type="checkbox">' +
                    '</div>' +
                    '</div>';
                // create and compile AngularJS scope for this component
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }
        function CustomHeaderText() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.className = "d-flex"
                this.eGui.innerHTML = '<div class="ag-cell-label-container" role="presentation" ng-click="SelectAllNodes()" style="width:180px;>' +
                    '<span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '<span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>' +
                    '<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '<span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                    '<span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                    '<span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                    '<span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                    '<span style="color:#e4e4e4 !important"">Select All</span>' +
                    '<span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
                    '<span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '</div>' +
                    '</div>';
                // create and compile AngularJS scope for this component
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }

        $scope.isAllNodesSelected = function () {
            if (gridOptions && gridOptions.api) {
                var selectedNodes = _.filter(availableNodes, function (node) {
                    return node.selected == true || node.selected == undefined;
                });
                if (selectedNodes.length > 0 && availableNodes.length > selectedNodes.length) {
                    return 'ag-indeterminate';
                }
                else if (availableNodes.length == selectedNodes.length) {
                    return 'ag-checked';
                }
            }
            return "";
        }

        $scope.SelectAllNodes = function () {
            if (gridOptions && gridOptions.api) {
                var selectedNodes = gridOptions.api.getSelectedNodes();
                if (availableNodes.length == selectedNodes.length) {
                    $scope.selectedItems.Obj = [];
                    _.each(availableNodes, function (node) {
                        node.setSelected(false);
                    });
                }
                else {
                    _.each(availableNodes, function (node) {
                        if (node.displayed) {
                            node.setSelected(true);
                        }
                    });
                }
            }
        }
        var gridOptions = {
            columnDefs: [],
            defaultColDef: {
                resizable: false,
                suppressMenu: true,
                suppressMovable: true,
            },
            rowData: [],
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            getContextMenuItems: function () { return []; },
            getRowId: function (params) {
                if (params && params.data) {
                    var DisplayProp = "";
                    _.each(vm.masterData.keys, function (key) {
                        if (DisplayProp == "") {
                            DisplayProp = params.data[key];
                        } else if (params.data[key]) {
                            DisplayProp = DisplayProp + separator + params.data[key];
                        }
                    });
                    params.data.DisplayProp = DisplayProp;

                    return String(params.data[vm.uniqKey]);
                }
            },
            onFirstDataRendered: function () {
                SelectRow();
            },
            onCellClicked: function (params) {
                params.node.setSelected(true);
            },
            onRowSelected: function (params) {
                if (params.source != "rowDataChanged") {
                    onRowSelected(params);
                }

            }
        }

        $scope.showSelectDropdown = function () {
            searchText = "";
            $(".overflowDiv").slideUp('fast');
            if(!vm.ngDisabled){
                vm.onSearch({ searchObj: { isSearched: false, searchKey: searchText } });
                var timeout = $timeout(function () {
                    $("#" + vm.dropdownDiv).slideDown('fast');
                    setMultiDropDownPos();
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 100);
            }
        };
        function setMultiDropDownPos() {
            var element = document.querySelector('#' + vm.divId);
            if (element) {
                var rect = element.getBoundingClientRect();
                var bottomDifference = window.innerHeight - rect.bottom;
                // Open upward when not enough space below (panel height ~250px).
                // Use absolute positioning relative to #divId so dropdown stays aligned when an
                // ancestor uses transform (e.g. modal dialog) — fixed + viewport coords breaks.
                $scope.DataObject.dropUp = bottomDifference <= 250;
            }
        }
        function onRowSelected(params) {
            var timeout = $timeout(function () {
                if (gridOptions && gridOptions.api) {
                    var selectedRows = gridOptions.api.getSelectedRows();
                }
                createDisplayProp(selectedRows);

                $scope.selectedItems.Obj = selectedRows;

                vm.onChange({ selectedData: $scope.selectedItems.Obj });

                var key = (vm.ngModel) ? Object.keys(vm.ngModel)[0] : null;
                if (key) {
                    vm.ngModel[key] = $scope.selectedItems.Obj;
                }

                if (params && params.node) {
                    (params.node.selected) ? vm.onAddTag({ tag: params.data }) : vm.onRemoveTag({ tag: params.data });
                }
                setMultiDropDownPos();
                $timeout.cancel(timeout);
                timeout = null;
            }, 0);
        }
        function SelectRow() {
            _.each($scope.selectedItems.Obj, function (obj) {
                var rowNode = gridOptions.api.getRowNode(obj[vm.uniqKey]);
                if (rowNode) { rowNode.setSelected(true); }
            });
        }

        $scope.removeTag = function (tag) {
            if (gridOptions && gridOptions.api) {
                var rowNode = gridOptions.api.getRowNode(tag[vm.uniqKey]);
                if (rowNode) { rowNode.setSelected(false); }
            }
            vm.onRemoveTag({ tag: tag });
        }
        $scope.addTag = function (tag) {
            vm.onAddTag({ tag: tag });
        }
        $scope.Search = function (searchKey, flag) {
            searchText = searchKey;
            vm.onSearch({ searchObj: { isSearched: flag, searchKey: searchText } });
            if (gridOptions && gridOptions.api) {
                gridOptions.api.setQuickFilter(searchKey);
            }
            return [];
        }

        $scope.clearSelection = function () {
            $scope.selectedItems.Obj = [];
            vm.selectedValue = [];
            if (gridOptions && gridOptions.api) {
                gridOptions.api.deselectAll();
            }
            onRowSelected();
            $("#" + vm.dropdownDiv).slideUp('fast');
        }

        function clearSearchTextQuery() {
            var tagListEle = $('.tag-list')
            _.each(tagListEle, function (ele) {
                if (ele.nextSibling && ele.closest(".multiSelectDropdown")) {
                    ele.nextSibling.value = ''
                    ele.nextSibling.style.width = '200px'
                }
            });
            if (gridOptions && gridOptions.api) {
                $scope.Search('', false)
            }
        }
        function createDisplayProp(List) {
            _.each(List, function (item) {
                var DisplayProp = "";
                _.each(vm.masterData.keys, function (key) {
                    if (DisplayProp == "") {
                        DisplayProp = item[key];
                    } else if (item[key]) {
                        DisplayProp = DisplayProp + separator + item[key];
                    }
                });
                item.DisplayProp = DisplayProp;
            });
        }
        //below code is to hide location dropdown
        document.addEventListener('click', onDocumentClick);
        function onDocumentClick(e) {
            if ((!e.target.closest(".multiSelectDropdown")) &&
                (!e.target.closest('.tag-item')) && !e.target.closest('.prevent-clear-search')) {
                $(".overflowDiv").slideUp('fast');
                clearSearchTextQuery();
            }
        }

    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('orderingPhysician', {
            templateUrl: 'app/theme/components/ordering-physician/ordering-physician.html',
            bindings: {

            },
            controller: orderingPhysicianCtrl
        });

    /** @ngInject */
    function orderingPhysicianCtrl($scope, MappingService, $q, toaster, $timeout, $sessionStorage, $filter, $compile, AddressBookListService, SharedService) {

        var vm = this;
        //var ProviderSiteDetails = [];
        $scope.DataObject = {
            OrderingPhysician: {
                SelectedData: null,
            },
            Filter: {
                ReadingProviderName: null, NPI: null, SelectedSite:null,
                SiteTenant: {
                    divId: "filterOrderingPhySite",
                    keys: ['SiteTenant'],
                    uniqKey: 'SiteID',
                    placeHolder: "Select Site(s)",
                    SelectedValue: { list: [] },
                    tooltip: "Select Site(s)",
                    OnChange: function (selectedData) {
                        var toolip = createSiteTooltip(selectedData);
                        $scope.DataObject.Filter.SiteTenant.tooltip = toolip ? toolip : "Select Site(s)";
                    }
                },
            },
            MasterData: {
                SiteTenant: {
                    divId: "dataOrderingPhySite",
                    keys: ['SiteTenant'],
                    uniqKey: 'SiteID',
                    placeHolder: "Select Site(s)",
                    SelectedValue: { list: [] },
                    tooltip: "Select Site(s)",
                    OnChange: function (selectedData) {
                        var toolip = createSiteTooltip(selectedData);
                        $scope.DataObject.MasterData.SiteTenant.tooltip = toolip ? toolip : "Select Site(s)";
                    }
                },
            },
            ShowOrderingPhysicianModal: false,
        }
        vm.$onInit = function () {
            getLookupByType();
            initPhysicianGrid();
            GetSitesAndLocation();
        }
        vm.$onChanges = function (changes) {

        }
        vm.$onDestroy = function () {
            OrderingPhysicianGridOptions.api.destroy();
            _.each(TimeoutList, function (timeout) {
                $timeout.cancel(timeout);
            });
        }

        //#region Ordering Physician
        var OrderingPhysician = {
            List: [],
            TotalRows: "",
            PageNum: 1,
            PageSize: "50",
        };
        var TimeoutList = [];
        var OrderingPhysicianColumnDefs = [
            { field: 'Name', headerName: 'Name', initialWidth: 250, minWidth: 180, tooltipField: 'Name',},
            {
                field: 'Phone', headerName: 'Phone', initialWidth: 100, valueFormatter: function (params) {
                    if (params && params.data && params.data.Phone) {
                        return $filter('formatPhoneNumber')(params.data.Phone);
                    }
                },
                tooltipValueGetter: function (params) {
                    if (params && params.data && params.data.Phone) {
                        return $filter('formatPhoneNumber')(params.data.Phone);
                    }
                }
            },
            {
                field: 'CellPhone', headerName: 'Cell Phone', initialWidth: 100,
                valueFormatter: function (params) {
                    if (params && params.data && params.data.CellPhone) {
                        return $filter('formatPhoneNumber')(params.data.CellPhone);
                    }
                },
                tooltipValueGetter: function (params) {
                    if (params && params.data && params.data.CellPhone) {
                        return $filter('formatPhoneNumber')(params.data.CellPhone);
                    }
                },
            },
            { field: 'Email', headerName: 'Email', initialWidth: 250, tooltipField: 'Email' },
            { field: 'NPI', headerName: 'NPI', initialWidth: 100, tooltipField: 'NPI' },
            {
                field: 'ContactPreferenceType', headerName: 'Contact Preference', initialWidth: 150,
                valueFormatter: function (params) {
                    if (params.data.ContactPreferenceType != null) {
                        var obj = _.find($scope.DataObject.MasterData.ContactPreferenceType, { Key: params.data.ContactPreferenceType });
                        if (obj && obj.Value) {
                            return obj.Value;
                        }
                    }
                },
                tooltipValueGetter: function (params) {
                    if (params.data.ContactPreferenceType != null) {
                        var obj = _.find($scope.DataObject.MasterData.ContactPreferenceType, { Key: params.data.ContactPreferenceType });
                        if (obj && obj.Value) {
                            return obj.Value;
                        }
                    }
                },
            },
            {
                field: 'Site', headerName: 'Site', cellRenderer: SiteCellTemplate,flex:0, initialWidth: 400, minWidth: 230,
                tooltipValueGetter: function (params) {
                    if (params.data.Site && params.data.TenantName) {
                        return params.data.Site + ' (' + params.data.TenantName + ')';
                    }
                }
            },
            {
                field: 'Action', headerName: 'Action', colId: 'Action',
                cellRenderer: getActionItems(),
                initialWidth: 60,
                pinned: 'right',
                sortable: false,
            },
        ];

        var OrderingPhysicianGridOptions = {
            columnDefs: OrderingPhysicianColumnDefs,
            defaultColDef: {
                lockVisible: true,
                minWidth: 50,
                resizable: false,
                sortable: true,
                suppressMovable: true,
                suppressMenu: true,
                flex: 1,
                tooltipValueGetter: null
            },
            sortingOrder: ['desc', 'asc'],
            rowModelType: 'serverSide',
            cacheBlockSize: OrderingPhysician.PageSize,
            maxBlocksInCache: 1,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getContextMenuItems: function () { return []; },
            getRowId: function (params) {
                return params.data.ProviderID + ' - ' + params.data.SiteID;
            },
            onGridReady: function () {

                OrderingPhysicianGridOptions.columnApi.applyColumnState({ state: [{ colId: 'Name', sort: 'desc' }], });

                var fakeServer = createOrderingPhysicianFakeServer();
                // create datasource with a reference to the fake server
                var datasource = createOrderingPhysicianServerSideDatasource(fakeServer);
                // register the datasource with the grid
                OrderingPhysicianGridOptions.api.setServerSideDatasource(datasource);

            },
            onSortChanged: function (params) {
                OrderingPhysicianGridOptions.api.showLoadingOverlay();
                resetOrderingPhysicianGrid();
            },
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getOrderingPhysicianStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },

        };

        function createOrderingPhysicianFakeServer() {
            return {
                getData: function (request) {
                    $scope.DataObject.isPhysicianGridLoading = true;
                    var d = $q.defer();

                    var page = request.startRow > 0 ?
                        _.toInteger(request.endRow / OrderingPhysician.PageSize) :
                        1;
                    if (page <= 0) { page = 1; }
                    OrderingPhysician.PageNo = page;
                    var Filter = {
                        PageNum: OrderingPhysician.PageNo,
                        PageSize: OrderingPhysician.PageSize,
                        Name: ($scope.DataObject.Filter.ReadingProviderName) ? $scope.DataObject.Filter.ReadingProviderName : null,
                        NPI: ($scope.DataObject.Filter.NPI) ? $scope.DataObject.Filter.NPI : null,
                        SiteID: ($scope.DataObject.Filter.SelectedSite) ? $scope.DataObject.Filter.SelectedSite.SiteID : null,
                        OrderByField: (request.sortModel.length > 0) ? request.sortModel[0].colId : '',
                        OrderBy: (request.sortModel.length > 0) ? request.sortModel[0].sort : '',
                        UserID: $sessionStorage.currentUserData.userId,
                    };
                    GetProviders(Filter).then(function (result) {
                        showHideStatusbar(OrderingPhysician.List, OrderingPhysicianGridOptions)
                        $scope.DataObject.isPhysicianGridLoading = false;
                        d.resolve({
                            success: true,
                            rows: result,
                            lastRow: _.toInteger(OrderingPhysician.TotalRows) <= request.endRow ? _.toInteger(OrderingPhysician.TotalRows) : -1,
                        });
                    });
                    return d.promise;
                }
            }
        }

        function createOrderingPhysicianServerSideDatasource(server) {
            return {
                getRows: function (params) {
                    server.getData(params.request).then(function (response) {
                        if (response.success) {
                            params.success({
                                rowData: response.rows,
                                rowCount: response.lastRow,
                            });
                        } else {
                            params.fail();
                        }
                    });
                },
            };
        }
        function getOrderingPhysicianStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }
        function getActionItems() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                $scope[params.rowIndex] = params;
                this.eGui = document.createElement('div');
                this.eGui.className = "d-flex"
                var editIcon = document.createElement('i');
                editIcon.className = 'cursor-pointer glyphicon glyphicon-pencil p-4px-all';
                editIcon.title = 'Edit';
                editIcon.style.color = '#07e6c4';
                editIcon.setAttribute('ng-click', 'EditOrderingPhysician(this[' + params.rowIndex + '])');
                var deleteIcon = document.createElement('i');
                deleteIcon.className = 'cursor-pointer fa fa-trash-o p-4px-all';
                deleteIcon.title = 'Delete';
                deleteIcon.style.color = '#07e6c4';
                deleteIcon.setAttribute('ng-click', 'DeleteOrderingPhysician(this[' + params.rowIndex + '])');
                this.eGui.appendChild(editIcon);
                this.eGui.appendChild(deleteIcon);
                /*+ '<button class="btn btn-transparent border-0 px-0 pt-2px mx-2 my-0 pb-0" title="Delete" style="color:#07e6c4" ng-click="DeleteOrderingPhysician(this[' + params.rowIndex + '])" ><i class="fa fa-trash-o fs-17px"></i>';*/
                // create and compile AngularJS scope for this component
                this.$scope1 = $scope.$new();
                $compile(this.eGui)(this.$scope1);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                var timeout = $timeout(this.$scope1.$apply.bind(this.$scope1), 0);
                $timeout.cancel(timeout);
                timeout = null;

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }
        function resetOrderingPhysicianGrid() {
            OrderingPhysician.List = [];
            OrderingPhysician.TotalRows = 0;
            OrderingPhysicianGridOptions.api.refreshServerSide({ purge: true });
        }
        function initPhysicianGrid() {
            var timeout = $timeout(function () {
                var gridDiv = document.querySelector('#PhysicianGrid');
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, OrderingPhysicianGridOptions);
                }
                $timeout.cancel(timeout);
                timeout = null;
            }, 100);
        }
        function getLookupByType() {
            MappingService.GetLookupByType('ContactPreferenceType').then(function (result) {
                $scope.DataObject.MasterData.ContactPreferenceType = _.filter(result, { Type: 'ContactPreferenceType' });
            });
        }
        $scope.filterOrderingPhysicianList = function () {
            resetOrderingPhysicianGrid();
        }
        $scope.clearOrderingPhysicianList = function () {
            $scope.DataObject.Filter.ReadingProviderName = null;
            $scope.DataObject.Filter.NPI = null;
            $scope.DataObject.Filter.SelectedSite = null;
            //$scope.DataObject.Filter.SiteTenant.SelectedValue = { list: [] };
            resetOrderingPhysicianGrid();
        }
        $scope.NewOrderingPhysician = function () {
            $scope.DataObject.OrderingPhysician.SelectedData = { ContactPreferenceType: '0', StatusFlag: 'N' };
            $scope.DataObject.OrderingPhysician.AddEditText = "Add";
            $scope.DataObject.ShowOrderingPhysicianModal = true;
            $scope.DataObject.MasterData.SiteTenant.SelectedValue = { list: [] };
            $('#addOrderingPhysician').modal('show');
        }
        $scope.onSaveSuccess = function (result, providerData) {
            
            if (!result || !result.success) return;
            if (result.shouldClearModal) $scope.clearModalData();
            if (result.shouldRefreshList) $scope.filterOrderingPhysicianList();
        }
        $scope.EditOrderingPhysician = function (params) {
            $scope.DataObject.OrderingPhysician.SelectedData = _.clone(params.data);
            $scope.DataObject.OrderingPhysician.SelectedData.SelectedSite = _.find($scope.DataObject.MasterData.Sites, { 'SiteID': $scope.DataObject.OrderingPhysician.SelectedData.SiteID });
            if (!$scope.DataObject.OrderingPhysician.SelectedData.SelectedSite) {
                toaster.warning("You can't edit the record due to access restriction to the tenant/site.");
                $scope.DataObject.OrderingPhysician.SelectedData = null;
                return;
            }
            $scope.DataObject.OrderingPhysician.SelectedData.StatusFlag = 'M';
            /*var siteIds = _.map(_.filter(ProviderSiteDetails, { ProviderID: params.data.ProviderID }), 'SiteID');
            $scope.DataObject.MasterData.SiteTenant.SelectedValue.list = _.filter($scope.DataObject.MasterData.Sites, function (item) {
                return _.includes(siteIds, item.SiteID);
            });*/
            
            $scope.DataObject.OrderingPhysician.AddEditText = "Edit";
            $scope.DataObject.ShowOrderingPhysicianModal = true;
            $('#addOrderingPhysician').modal('show');
        }
        $scope.DeleteOrderingPhysician = function (params) {
            swal({
                title: "The ordering physician details will be removed from all mapped instances.<br>Are you sure you want to delete?",
                type: "warning",
                html: true,
                customClass: 'swal-wide',
                showCancelButton: true,
                confirmButtonColor: "#DD6B55", confirmButtonText: "Continue",
                cancelButtonText: "Cancel",
            },
                function (isConfirm) {
                    if (isConfirm) {
                        var providerData = _.clone(params.data);
                        providerData.SelectedSite = _.find($scope.DataObject.MasterData.Sites, { 'SiteID': providerData.SiteID });
                        providerData.StatusFlag = 'D';
                        SharedService.saveOrderingPhysician(providerData, []).then(function (result) {
                            if (result.success) {
                                OrderingPhysicianGridOptions.api.refreshServerSide();
                            }
                        });
                    }
                });
            
        }
        $scope.clearModalData = function (frmOrderingPhysician) {
            if (frmOrderingPhysician) {
                frmOrderingPhysician.$setUntouched();
            }
            $scope.DataObject.OrderingPhysician.SelectedData = null;
            $scope.DataObject.ShowOrderingPhysicianModal = false;
            $scope.DataObject.MasterData.SiteTenant.SelectedValue = { list: [] };
            $scope.DataObject.MasterData.SiteTenant.OnChange($scope.DataObject.MasterData.SiteTenant.SelectedValue.list);
            $('#addOrderingPhysician').modal('hide');
        }
        function GetProviders(GetProviderObject) {
            var d = $q.defer();
            MappingService.GetProviders(GetProviderObject).then(function (result) {
                if (result && result.length > 0) {
                    OrderingPhysician.List = _.concat(OrderingPhysician.List, result);
                    OrderingPhysician.TotalRows = result[0].TotalRows;
                }
                d.resolve(result);
            });
            return d.promise;
        }
        function showHideStatusbar(list, gridOptions) {
            var statusBarComponent = gridOptions.api.getStatusPanel('GridFooter');
            if (list.length == 0) {
                statusBarComponent.eGui.hidden = true;
                gridOptions.api.showNoRowsOverlay();
            } else {
                gridOptions.api.hideOverlay();
                statusBarComponent.eGui.hidden = false;
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
                var totalRows = list.length == 0 ? 0 : list[0].TotalRows;
                statusBarComponent.eGui.textContent = 'Showing ' + list.length + ' of ' + totalRows + ' Total Records';
                statusBarComponent.eGui.style.color = 'white';
            }
        }

        function GetSitesAndLocation() {
            var d = $q.defer();
            AddressBookListService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.DataObject.MasterData.Sites = _.uniqBy(_.filter(result, function (obj) { return obj.SiteID != 0; }), 'SiteID');
                $scope.DataObject.MasterData.Sites = _.map($scope.DataObject.MasterData.Sites, function (item) {
                    return _.assign(item, {
                        SiteTenant: item.Site + " (" + item.TenantName + ")"
                    });
                });
                d.resolve();
            });
            return d.promise;
        }

        function createSiteTooltip(selectedData) {
            var tooltip = null;
            _.each(selectedData, function (obj) {
                if (tooltip) {
                    tooltip = tooltip + "\n" + (obj.SiteTenant);
                }
                else {
                    tooltip = obj.SiteTenant;
                }
            });

            return tooltip;
        }

        function SiteCellTemplate(params) {
            if (params.data && params.data.ProviderID) {
                //var Sites = _.sortBy(_.uniqBy(_.filter(ProviderSiteDetails, { ProviderID: params.data.ProviderID }),'SiteID'), ['Site']);
                var template = '<div class="sites-overflow">';
                template += "<span class='px-4px py-2px mlp-value-box bg-clr-36 mr-4px text-nowrap'>" + params.data.Site + " (" + params.data.TenantName + ")" + "</span>";
                /*_.each(Sites, function (site, index) {
                    

                });*/
                '</div>';
                return template;
            }
            else {
                return "";
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('orderingPhysicianInfo', {
            templateUrl: 'app/theme/components/ordering-physician-info/ordering-physician-info.html',
            bindings: {
                masterData: '<',
                selectedData: '<',
                orderingPhysicianData: '<',
                onSaveSuccess: '&',
                clearModalData: '&',
            },
            controller: orderingPhysicianInfoCtrl
        });

    /** @ngInject */
    function orderingPhysicianInfoCtrl($scope, MappingService, $q, toaster, $timeout, $sessionStorage, $filter, $compile, AddressBookListService, SharedService) {

        var vm = this;
        $scope.DataObject = {
            SelectedData: null,
            SiteTenant: null,
            MasterData: {},
        }
        $scope.frmOrderingPhysician = null;
        vm.$onInit = function () {
            if (vm.masterData) {
                $scope.DataObject.MasterData.ContactPreferenceType = vm.masterData.ContactPreferenceType;
                $scope.DataObject.MasterData.Sites = vm.masterData.Sites;
                $scope.DataObject.MasterData.SiteTenant = vm.masterData.SiteTenant;
            }
            if (vm.selectedData) {
                $scope.DataObject.SelectedData = vm.selectedData;
            }
        }
        vm.$onChanges = function (changes) {
            if (changes.masterData && changes.masterData.currentValue) {
                if (changes.masterData.currentValue.ContactPreferenceType) {
                    $scope.DataObject.MasterData.ContactPreferenceType = changes.masterData.currentValue.ContactPreferenceType;
                }
                if (changes.masterData.currentValue.Sites) {
                    $scope.DataObject.MasterData.Sites = changes.masterData.currentValue.Sites;
                }
                if (changes.masterData.currentValue.SiteTenant) {
                    $scope.DataObject.MasterData.SiteTenant = changes.masterData.currentValue.SiteTenant;
                }
            }
            else {
                $scope.DataObject.MasterData.ContactPreferenceType = vm.masterData.ContactPreferenceType;
                $scope.DataObject.MasterData.Sites = vm.masterData.Sites;
                $scope.DataObject.MasterData.SiteTenant = vm.masterData.SiteTenant;
            }

            if (changes.selectedData) {
                $scope.DataObject.SelectedData = changes.selectedData.currentValue;
            }
        }
        vm.$onDestroy = function () {

        }

        //#region Ordering Physician        

        $scope.clearModalData = function () {
            if (vm.clearModalData) {
                vm.clearModalData();
            }
        }

        $scope.SaveOrderingPhysician = function () {
            var providerData = $scope.DataObject.SelectedData;
            var siteTenantList = $scope.DataObject.MasterData.SiteTenant && $scope.DataObject.MasterData.SiteTenant.SelectedValue &&
                $scope.DataObject.MasterData.SiteTenant.SelectedValue.list && $scope.DataObject.MasterData.SiteTenant.SelectedValue.list.length > 0
                ? $scope.DataObject.MasterData.SiteTenant.SelectedValue.list
                : (providerData.SelectedSite ? [providerData.SelectedSite] : []);

            SharedService.saveOrderingPhysician(providerData, siteTenantList).then(function (result) {
                if (vm.onSaveSuccess) {
                    vm.onSaveSuccess({ result: result, providerData: providerData });
                }
            });
        }

        function createSiteTooltip(selectedData) {
            if (!selectedData || selectedData.length === 0) return null;
            return _.map(selectedData, 'SiteTenant').join('\n');
        }

        $scope.DisableSaveBtn = function () {
            var isDisabled = false;
            if (!$scope.DataObject.SelectedData.SelectedSite) {
                if ((!$scope.DataObject.MasterData.SiteTenant.SelectedValue || $scope.DataObject.MasterData.SiteTenant.SelectedValue.list.length == 0)) {
                    isDisabled = true;
                }
            }
            if (!isDisabled) {
                isDisabled = (!$scope.DataObject.SelectedData.FirstName || !$scope.DataObject.SelectedData.LastName || !$scope.DataObject.SelectedData.NPI);
            }
            if (!isDisabled) {
                var phoneEle = document.getElementById("phone");
                var phoneVal = (phoneEle && phoneEle.value) ? (phoneEle.value).replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "").replaceAll("_", "") : null;
                var cellPhoneEle = document.getElementById("cellPhone");
                var cellPhoneVal = (cellPhoneEle && cellPhoneEle.value) ? (cellPhoneEle.value).replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "").replaceAll("_", "") : null;

                if (!$scope.DataObject.SelectedData.FirstName || !$scope.DataObject.SelectedData.LastName || !$scope.DataObject.SelectedData.NPI ||
                    ((phoneVal && phoneVal.length > 0 && phoneVal.length < 10) || (cellPhoneVal && cellPhoneVal.length > 0 && cellPhoneVal.length < 10))) {
                    isDisabled = true;
                }
            }
            return isDisabled;
        }

        $scope.onPasteCellPhone = function (event) {
            var timeout = $timeout(function () {
                $scope.$apply(function () {
                    var cellPhone = (event.target.value).replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "").replaceAll("_", "");
                    $scope.DataObject.SelectedData.CellPhone = (cellPhone.length == 10) ? cellPhone : null;
                });
                $timeout.cancel(timeout);
            }, 0);
        }
        $scope.onPastePhone = function (event) {
            var timeout = $timeout(function () {
                $scope.$apply(function () {
                    var phone = (event.target.value).replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replaceAll("-", "").replaceAll("_", "");
                    $scope.DataObject.SelectedData.Phone = (phone.length == 10) ? phone : null;
                });
                $timeout.cancel(timeout);
            }, 0);
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('patientdetails', {
            templateUrl: 'app/theme/components/patientDetails/patientDetails.html',
            bindings: {
                selectedOrder: '<',
                buttonClicked: '&',
                showContact: '&',
            },
            controller: patientDetailsController
        });

    /** @ngInject */
    function patientDetailsController($scope, $filter, $sessionStorage) {

        var vm = this;
        $scope.DataObject = {
            selectedOrder: [],
            RemoveRenderingPhysician: false,
        };
        $scope.DataObject.selectedOrder = vm.selectedOrder;
        vm.$onChanges = function (changes) {
            $scope.DataObject.selectedOrder = changes.selectedOrder.currentValue;
            if (changes.showWorklistData && changes.showWorklistData.currentValue) {
                $scope.DataObject.showWorklistData = changes.showWorklistData.currentValue;
            }
            $scope.DataObject.RemoveRenderingPhysician = $sessionStorage.currentUserData && $sessionStorage.currentUserData.RemoveRenderingPhysician && ($sessionStorage.EnableRowsForSelectedTenants && $scope.DataObject.selectedOrder && $sessionStorage.EnableRowsForSelectedTenants.split(',').includes($scope.DataObject.selectedOrder.TenantName));
        };
        vm.$onDestroy = function () {
        }
        vm.$onInit = function () {
            $scope.DataObject.selectedOrder = vm.selectedOrder;
        }

        $scope.ButtonClicked = function (Key) {
            vm.selectedOrder.ButtonClicked = Key;
            vm.buttonClicked();
        }

        $scope.splitCamelCase = function (text) {
            return text.replace(/([a-z])([A-Z])/g, '$1 $2');
        };
    };
}());
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('paymentDashBoard', {
            templateUrl: 'app/theme/components/payment-dash-board/payment-dash-board.html',
            bindings: {

            },
            controller: PaymentDashBoardController
        });

    /** @ngInject */
    function PaymentDashBoardController($scope, PaymentContractService, $sessionStorage, $filter, $q, toaster, $timeout, CommonService, AccountManagerService) {

        var vm = this;
        var InvoicePaymentList = [];
        var BillAPIPaymentBillRequest = {};
        $scope.DataObject = {
            isSaveBtnDisable: false,
            SelectedDate: {
                startDate: moment().subtract(6, 'days'),
                endDate: moment(),
                label: "Last 7 Days",
            },
            SelectedDateTooltip: "Select Date Range",
            TotalEarnings: 0,
            TotalPaidAmount: 0,
            TotalPendingAmount: 0,
            TotalRemainingBalance: 0,
            InvoiceStatusList: [],
            CreateInvoiceAmount: 0,
            CreateInvoiceNotes: null,
            InvoiceData: {},
            userData: {},
        }

        $scope.DOSopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                customRangeLabel: 'Custom range',
            },
            ranges: {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],

            },
            eventHandlers: {
                'apply.daterangepicker': function (event, picker) {
                    $scope.DataObject.SelectedDateTooltip = createDateRangeTooltip($scope.DataObject.SelectedDate);
                    $scope.GetUserPaymentHeader();
                }
            }
        };

        function createDateRangeTooltip(selectedDate) {
            var tooltip = "Select Date Range";
            if (selectedDate && selectedDate.startDate && selectedDate.endDate) {
                tooltip = moment(selectedDate.startDate).format("MM/DD/YYYY") +
                    "-" +
                    moment(selectedDate.endDate).format("MM/DD/YYYY");
            }
            return tooltip;
        }

        $scope.PaymentSummery = { TotalPrice: 0 };
        vm.$onChanges = function (changes) {
            console.log("$onChanges paymentDashBoard changes", changes);
        };
        vm.$onDestroy = function () {
            console.log('Destory paymentDashBoard');
        }
        vm.$onInit = function () {
            $scope.DataObject.SelectedDateTooltip = createDateRangeTooltip($scope.DataObject.SelectedDate);
            $scope.DataObject.userData = $sessionStorage.currentUserData;
            GetInvoiceStatus().then(function () {
                $scope.GetUserPaymentHeader();

            });
        }


        $scope.openCreateInvoiceModal = function () {
            $scope.GetUserPaymentHeader().then(function () {
                GetRemainingPaymentSummary();
            });
        }


        $scope.createInvoice = function () {
            $q.all([EnabledVendorExist()]).then(function () {
                $scope.DataObject.isDataLoading = true;
                var isSameInvoiceDate = false;
                if (InvoicePaymentList && InvoicePaymentList.length > 0) {
                    InvoicePaymentList = _.filter(InvoicePaymentList, function (invoice) { return invoice.InvoiceStatus == 'Pending' });
                    var lastGeneratedInvoice = _.maxBy(InvoicePaymentList, 'InvoiceDate');
                    if (lastGeneratedInvoice != null && lastGeneratedInvoice.InvoiceDate) {
                        var lastGeneratedInvoiceDate = moment(($filter('localDate')(lastGeneratedInvoice.InvoiceDate, false, new Date())));
                        isSameInvoiceDate = (moment().isSame(lastGeneratedInvoiceDate, 'day'))
                    }
                }
                if (!isSameInvoiceDate) {
                    var createdInvoiceStatus = _.find($scope.DataObject.InvoiceStatusList, { InvoiceStatus: "Pending" });
                    if (createdInvoiceStatus) {
                        var dueDate = $filter('CSTDateTime')(moment().add(17, 'days'));
                        var invoiceDate = $filter('CSTDateTime')(moment());
                        var params = {
                            UserID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '',
                            InvoiceAmount: $scope.DataObject.TotalRemainingBalance,
                            InvoiceDate: invoiceDate,
                            DueDate: dueDate,
                            Notes: $scope.DataObject.CreateInvoiceNotes,
                            BillAPIPaymentVendorDetail: {
                                vendorId: $sessionStorage.currentUserData.Address.VendorID,
                                dueDate: moment(dueDate).format("YYYY-MM-DD"),
                                invoiceDate: moment(invoiceDate).format("YYYY-MM-DD")
                            }
                        }

                        PaymentContractService.SendInvoice(params).then(function (result) {
                            if (!result || result.NoPendingPayments) {
                                toaster.pop({ type: 'warning', body: "No pending payments found to invoice." });
                                $scope.DataObject.isDataLoading = false;
                                return;
                            }
                            if (!result.fileStorage) {
                                toaster.pop({ type: 'error', body: "An error occurred while creating the invoice." });
                                $scope.DataObject.isDataLoading = false;
                                return;
                            }
                            toaster.pop({ type: 'success', body: "Invoice created successfully." });
                            $scope.DataObject.InvoicePDFUrl = CommonService.createBlobUrl(result.fileStorage.FileContent, "application/pdf");
                            $scope.DataObject.InvoicePDF = result.fileStorage;
                            $("#paymentInvoicePdfModal").modal('show');
                            $scope.GetUserPaymentHeader();
                            var selectedDate = {
                                startDate: $scope.DataObject.SelectedDate.startDate,
                                label: $scope.DataObject.SelectedDate.label,
                                endDate: $scope.DataObject.SelectedDate.endDate,
                            }
                            $scope.DataObject.SelectedDate = _.cloneDeep(selectedDate);
                            //$scope.resetCreateInvoiceData();
                            $scope.DataObject.isDataLoading = false;
                        }).catch(function (error) {
                            $scope.DataObject.isDataLoading = false;
                            toaster.pop({ type: 'error', body: "An error occurred while creating the invoice." });
                        });
                    }
                }
                else {
                    $scope.DataObject.isDataLoading = false;
                    $scope.DataObject.isSaveBtnDisable = false;
                    $scope.resetCreateInvoiceData();
                    toaster.pop({ type: 'warning', body: "You can generate only one invoice per day." });

                }
            }).catch(function () {
                toaster.pop({ type: 'warning', body: "Please update your address property to create an invoice." });
                return;
            });

        }
        $scope.resetCreateInvoiceData = function () {
            //$scope.DataObject.CreateInvoiceAmount = 0;
            //$scope.DataObject.CreateInvoiceNotes = null;
            $("#paymentInvoicePdfModal").modal('hide');
        }
        $scope.GetUserPaymentHeader = function () {
            var d = $q.defer();
            PaymentContractService.GetUserPaymentHeader({
                UserID: $sessionStorage.currentUserData.userId
            }).then(function (result) {
                if (result && result.userPaymentHeaders) {
                    $scope.DataObject.TotalEarnings = (result.userPaymentHeaders.TotalEarnings) ? result.userPaymentHeaders.TotalEarnings : 0;
                    $scope.DataObject.TotalPaidAmount = (result.userPaymentHeaders.TotalPaidAmount) ? result.userPaymentHeaders.TotalPaidAmount : 0;
                    $scope.DataObject.TotalPendingAmount = (result.userPaymentHeaders.TotalPendingAmount) ? result.userPaymentHeaders.TotalPendingAmount : 0;
                    $scope.DataObject.TotalRemainingBalance = (result.userPaymentHeaders.TotalRemainingBalance) ? result.userPaymentHeaders.TotalRemainingBalance : 0;
                }
                d.resolve(result.userPaymentHeaders);
            }, function (err) {
                toaster.pop({ type: 'error', body: "An error occurred while fetching the user payment header invoice." });
                d.reject();
            });
            return d.promise;
        }
        function GetInvoiceStatus() {
            var d = $q.defer();
            PaymentContractService.GetInvoiceStatus().then(function (result) {
                $scope.DataObject.InvoiceStatusList = result;
                d.resolve(result);
            }, function (err) { d.reject() });
            return d.promise;
        }
        $scope.GetInvoicePaymentDetail = function (invoicePaymentList) {
            InvoicePaymentList = invoicePaymentList
        }

        function GetRemainingPaymentSummary() {
            var d = $q.defer();
            var filter = {
                UserID: $sessionStorage.currentUserData.userId,
                IsInvoice: true,
                PaymentContractType: $scope.DataObject.PaymentContractType,
                InvoiceDate: moment($filter('CSTDateTime')(moment())).format('MM/DD/YYYY HH:mm:ss'),
                InvoiceAmount: $scope.DataObject.TotalRemainingBalance,
                ProviderEmail: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.EmailId : '',
                ProviderName: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName : '',
            };
            PaymentContractService.GetRemainingPaymentSummary(filter).then(function (result) {
                if (result) {
                    var InvoicePDF = document.getElementById('InvoicePDF');
                    InvoicePDF.innerHTML = DOMPurify.sanitize(result.paymentHTML);

                    BillAPIPaymentBillRequest = result.billAPICreateBillRequest;

                    $("#paymentInvoicePdfModal").modal('show');

                    d.resolve();
                }
            }).catch(function () {
                toaster.pop({ type: 'error', body: "An error occurred while fetching the payment summary." });
            });
            return d.promise;
        }

        $scope.getUserPaymentContract = function (PaymentContractType) {
            $scope.DataObject.PaymentContractType = PaymentContractType[0].PaymentContractType;
        }

        function EnabledVendorExist() {
            var d = $q.defer();
            if ($sessionStorage.BillAPIEnable) {
                if (($sessionStorage.currentUserData.Address && $sessionStorage.currentUserData.Address.VendorID)) {
                    d.resolve();
                } else {
                    d.reject();
                }
                //if (!$sessionStorage.currentUserData.Address || ($sessionStorage.currentUserData.Address && !$sessionStorage.currentUserData.Address.VendorID)) {
                //    PaymentContractService.GetVendors({
                //        filter: ""
                //    }).then(function (result) {
                //        if (result.results && result.results.length > 0) {
                //            //var vendor = _.find(result.results, function (vendor) { return vendor.email == $sessionStorage.currentUserData.EmailId || (vendor.name.toLowerCase().includes($sessionStorage.currentUserData.LastName.toLowerCase()) && vendor.name.toLowerCase().includes($sessionStorage.currentUserData.FirstName.toLowerCase())) });
                //            var vendor = _.find(result.results, function (vendor) { return vendor.email == $sessionStorage.currentUserData.EmailId });
                //            if (vendor) {
                //                var sessionAddress = $sessionStorage.currentUserData.Address;
                //                if (sessionAddress) {
                //                    sessionAddress.VendorID = vendor.id;
                //                    sessionAddress.AddressLine1 = vendor.address && vendor.address.line1 ? vendor.address.line1 : sessionAddress.AddressLine1;
                //                    sessionAddress.AddressLine2 = sessionAddress.AddressLine2;
                //                    sessionAddress.City = vendor.address && vendor.address.city ? vendor.address.city : sessionAddress.City;
                //                    sessionAddress.State = vendor.address && vendor.address.stateOrProvince ? vendor.address.stateOrProvince : sessionAddress.State;
                //                    sessionAddress.PostalCode = vendor.address && vendor.address.zipOrPostalCode ? vendor.address.zipOrPostalCode : sessionAddress.PostalCode;
                //                    sessionAddress.CountryCode = vendor.address && vendor.address.country ? vendor.address.country : sessionAddress.CountryCode;
                //                } else {
                //                    sessionAddress = {
                //                        VendorID: vendor.id,
                //                        AddressLine1: vendor.address.line1,
                //                        AddressLine2: '',
                //                        City: vendor.address.city,
                //                        State: vendor.address.stateOrProvince,
                //                        PostalCode: vendor.address.zipOrPostalCode,
                //                        CountryCode: vendor.address.country
                //                    }
                //                }
                //                $sessionStorage.currentUserData.Address = sessionAddress;
                //                UpdateUserVendorDetail(sessionAddress);
                //                d.resolve();
                //            } else {
                //                d.reject();
                //            }
                //        }
                //    }).catch(function (err) {
                //        d.reject();
                //    });
                //} else {
                //    d.resolve();
                //}
            } else {
                d.resolve();
            }
            return d.promise;
        }
        function UpdateUserVendorDetail(sessionAddress) {
            var addresses = [];
            addresses.push({
                AddressLine1: sessionAddress.AddressLine1,
                AddressLine2: '',
                City: sessionAddress.City,
                State: sessionAddress.State,
                PostalCode: sessionAddress.PostalCode,
                CountryCode: sessionAddress.CountryCode,
                UserId: $sessionStorage.currentUserData.userId,
                VendorID: sessionAddress.VendorID,
                CreatedBy: $sessionStorage.currentUserData.userId,
                ModifiedBy: $sessionStorage.currentUserData.userId,
            });
            AccountManagerService.UpdateUserVendorDetail(addresses);
        }
    };


})();
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('contractSummary', {
            templateUrl: 'app/theme/components/payment-contract-summary/payment-contract-summary.html',
            bindings: {
                summaryGridId: '@',
                paymentSummery: '<',
                selectedDate: '<',
                invoiceStatusList: '<',
                onGetPaymentSummary: '&',
                onPaymentCreated: "&",
                onInvoiceDeleted: "&",
                getInvoicePaymentDetail: '&'
            },
            controller: contractSummaryController
        });

    function contractSummaryController($scope, $sessionStorage, $q, PaymentContractService, $timeout, $filter, toaster, $compile) {
        var vm = this;
        var PaymentSummaryList = [];
        var selectedDate = null;
        var ChartList = {};
        var ChartOptionList = {};
        var tippyJsinstance = [{ tippyInstance: null, cellInstance: null, rowNode: null }];
        var invoiceStatusList = [];
        var InvoicePaymentDetails = {
            InvoicePaymentList: [],
            ColumnDefs: [],
            GridOptions: {},
            PageSize: 20,
            PageNum: 1,
            GridAPI: null,
        }
        var Series = [
            {
                type: 'bar',
                xKey: 'LocationModality',
                yKey: 'RVU',
                tooltip: createSummaryChartTooltip(),
                yName: 'Sum of wRVU',
            },
            {
                type: 'bar',
                xKey: 'LocationModality',
                yKey: 'TotalModality',
                tooltip: createSummaryChartTooltip(),
                yName: 'Modality Count',
            },
            {
                type: 'bar',
                xKey: 'LocationModality',
                yKey: 'TotalPrice',
                yName: 'Total Payments',
                tooltip: createSummaryChartTooltip()
            }

        ];

        var ShiftSeries = [
            {
                type: 'bar',
                xKey: 'LocationModality',
                yKey: 'RVU',
                yName: 'Sum of wRVU',
                tooltip: createSummaryChartTooltip()
            },
            {
                type: 'bar',
                xKey: 'LocationModality',
                yKey: 'TotalModality',
                yName: 'Modality Count',
                tooltip: createSummaryChartTooltip()
            }
        ];

        function createSummaryChartTooltip() {
            return {
                enabled: true,

                renderer: function (params) {
                    return {
                        title: params.yName,
                        data: [
                            {
                                value: (params.yKey == "TotalPrice") ? "$" + params.datum[params.yKey].toFixed(2) : params.datum[params.yKey],
                            },
                        ],
                    }
                }
            }
        }
        $scope.DataObject = {
            activeSummaryTab: "Grid",
            InvoicePaymentTab: "Grid",

            selectedRow: null,

            gridRows: {},
            UsersPaymentContract: null,
            isDataLoading: false,
        }

        vm.$onChanges = function (changes) {
            if (changes.paymentSummery) {
                vm.paymentSummery = changes.paymentSummery.currentValue;
            }
            if (changes && changes.selectedDate) {
                selectedDate = changes.selectedDate.currentValue;
                PaymentSummaryList = [];
                if (gridOptions.api) {
                    GetUserPaymentSummary();
                }

                if (InvoicePaymentDetails.GridAPI) {
                    GetInvoicePaymentDetail();
                }
            }
            if (changes.invoiceStatusList && changes.invoiceStatusList.currentValue) {
                invoiceStatusList = changes.invoiceStatusList.currentValue;
            }
        };
        vm.$onDestroy = function () {
        }
        vm.$onInit = function () {
            GetPaymentContractByUserByID().then(function () {
                GetPaymentMethod();
                var timeout = $timeout(function () {
                    onAgGridLoad();
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 100);
                initializePaymentSummaryChart();
            });
        }
        function onAgGridLoad() {
            var gridDiv = document.querySelector('#' + vm.summaryGridId + '');
            new agGrid.Grid(gridDiv, gridOptions);

            gridDiv = document.querySelector('#InvoicePaymentGrid');
            if (gridDiv) {
                new agGrid.Grid(gridDiv, InvoicePaymentDetails.GridOptions);
                InvoicePaymentDetails.GridAPI = InvoicePaymentDetails.GridOptions.api;
            }
        }

        var columnDefs = [
            { field: "Location" },
            { field: "Modality" },
            {
                field: "RVU", headerName: "Sum of wRVU",
                cellRenderer: function (params) {
                    if (params.data && params.data.RVU) {
                        return params.data.RVU;
                    }
                }
            },
            {
                field: "TotalModality", headerName: "Modality Count",
                cellRenderer: function (params) {
                    if (params.data && params.data.TotalModality) {
                        return params.data.TotalModality;
                    }
                }
            },
            {
                field: "TotalPrice", headerName: "Total Payments", cellRenderer: function (params) {
                    if (params && params.data && params.data.TotalPrice) {
                        return (params.node.rowPinned != "bottom") ? "$" + params.data.TotalPrice.toFixed(2) : params.data.TotalPrice;
                    }
                }
            },
        ];

        var ShiftColumnDefs = [
            { field: "Location" },
            { field: "Modality" },
            {
                field: "RVU", headerName: "Sum of wRVU",
                cellRenderer: function (params) {
                    if (params.data && params.data.RVU) {
                        return params.data.RVU;
                    }
                }
            },
            {
                field: "TotalModality", headerName: "Modality Count",
                cellRenderer: function (params) {
                    if (params.data && params.data.TotalModality) {
                        return params.data.TotalModality;
                    }
                }
            },
        ];

        var gridOptions = {
            columnDefs: [],
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: false,
                lockVisible: true,
            },
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            suppressContextMenu: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            onGridReady: function (params) {
                GetUserPaymentSummary();
            },
            getRowHeight: function (params) {
                return params.data.rowHeight;
            },
        };


        function GetUserPaymentSummary() {
            var d = $q.defer();
            $scope.DataObject.isDataLoading = true;
            if (selectedDate && gridOptions.api && ChartList.PaymentSummaryChart) {
                var summaryFilter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    StartDate: $filter('CSTDateTime')(moment(moment(selectedDate.startDate).format("YYYY-MM-DD") + ' ' + "00:00")),
                    EndDate: $filter('CSTDateTime')(moment(moment(selectedDate.endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")),
                    IsInvoice: false
                }
                PaymentContractService.GetUserPaymentSummary(summaryFilter).then(function (result) {
                    PaymentSummaryList = _.clone(result);
                    _.each(PaymentSummaryList, function (obj) {
                        var LocationModality = [];
                        if (obj.Location) {
                            LocationModality.push(obj.Location);
                        }
                        else {
                            LocationModality.push("");
                        }
                        LocationModality.push(obj.Modality);
                        obj.LocationModality = LocationModality;
                        obj.RVU = parseFloat(obj.RVU);
                        obj.TotalModality = _.toInteger(obj.TotalModality);
                        obj.TotalPrice = parseFloat(obj.TotalPrice);
                    });
                    ChartOptionList.PaymentSummaryChartOptions.data = PaymentSummaryList;
                    var obj = _.find($scope.DataObject.UsersPaymentContract, { PaymentContractType: "PayPerShift" });
                    if (obj) {
                        gridOptions.api.setColumnDefs(ShiftColumnDefs);
                        ChartOptionList.PaymentSummaryChartOptions.series = ShiftSeries;
                    }
                    else {
                        gridOptions.api.setColumnDefs(columnDefs);
                        ChartOptionList.PaymentSummaryChartOptions.series = Series;
                    }
                    ChartList.PaymentSummaryChart.update(ChartOptionList.PaymentSummaryChartOptions);
                    gridOptions.api.setRowData([]);
                    var RVUSum = 0;
                    var TotalPriceSum = 0;
                    var TotalModalitySum = 0;
                    _.each(PaymentSummaryList, function (summary) {
                        RVUSum = RVUSum + parseFloat(summary.RVU);
                        TotalPriceSum = TotalPriceSum + parseFloat(summary.TotalPrice);
                        TotalModalitySum = TotalModalitySum + parseFloat(summary.TotalModality);
                    });
                    var row = {
                        "Modality": null,
                        "RVU": 'Sum of wRVU: ' + RVUSum.toFixed(2),
                        "TotalModality": 'Modality Count: ' + TotalModalitySum,
                        "TotalPrice": 'Total Payments: $' + TotalPriceSum.toFixed(2)
                    }
                    //PaymentSummaryList.push(row);
                    vm.paymentSummery.TotalPrice = TotalPriceSum.toFixed(2);
                    vm.onGetPaymentSummary();
                    gridOptions.api.setPinnedBottomRowData([row]);
                    gridOptions.api.setRowData(PaymentSummaryList);
                    $scope.DataObject.isDataLoading = false;
                    d.resolve(result);
                }).catch(function () {
                    $scope.DataObject.isDataLoading = false;
                    toaster.pop({ type: 'error', body: "An error occurred while fetching the payment summary." });
                });
            }
            else {
                $scope.DataObject.isDataLoading = false;
                d.resolve();
            }
            return d.promise;
        }

        var myTheme = {
            baseTheme: 'ag-default-dark',
            palette: {
                fills: ['#03a037', '#00ddff', '#ff0000', '#05c1a4', '#ffb5b5', '#0091ff', '#ff875c', '#b7b100', '#b8075a', '#fff83b', '#c8feb1', '#2c7a54', '#004cff', '#37b700', '#002d97', '#7b00ff', '#c48cff', '#ff00d4', '#ffa1ef', '#ffa803', '#c6c6c6'],
                strokes: ['black'],
            },
            overrides: {
                common: {
                    title: {
                        fontSize: 24,
                    },
                },
                bar: {
                    series: {
                        label: {
                            enabled: false,
                            color: 'black',
                        },
                    },
                },
            },
        };


        ChartOptionList.PaymentSummaryChartOptions = {
            theme: myTheme,
            title: {
                text: "Payment Summary",
                fontSize: 20,
                fontFamily: '"Open Sans", sans-serif'
            },
            subtitle: {
                text: '',
            },
            background: {
                fill: "#2d3436",
            },
            data: [],
            series: [],
            axes: [
                {
                    type: "grouped-category",
                    position: "bottom",
                    label: { rotation: 0 },
                    depthOptions: [{}, { label: { fontWeight: "bold" } }],
                },
                { type: "number", position: "left" },
            ],
        };

        ChartOptionList.InvoicePaymentChartOptions = {
            theme: myTheme,
            title: {
                text: "Invoice Details",
                fontSize: 20,
                fontFamily: '"Open Sans", sans-serif'
            },
            subtitle: {
                text: '',
            },
            background: {
                fill: "#2d3436",
            },
            data: [],
            series: [
                {
                    type: 'bar',
                    xKey: 'InvoiceDate',
                    yKey: 'InvoiceAmount',
                    xName: "Invoice Date",
                    yName: 'Invoice Amount',
                    stacked: true,
                    tooltip: createInvoicePaymentChartTooltip(),
                },
                {
                    type: 'bar',
                    xKey: 'InvoiceDate',
                    yKey: 'PaidAmount',
                    xName: "Invoice Date",
                    yName: 'Paid Amount',
                    stacked: true,
                    tooltip: createInvoicePaymentChartTooltip(),
                },
                {
                    type: 'bar',
                    xKey: 'InvoiceDate',
                    xName: "Invoice Date",
                    yKey: 'TotalAmount',
                    yName: 'Total Amount',
                    stacked: true,
                    tooltip: createInvoicePaymentChartTooltip(),
                },
            ],
        };

        function createInvoicePaymentChartTooltip() {
            return {
                enabled: true,

                renderer: function (params) {
                    return {
                        title: params.yName,
                        data: [
                            {
                                label: "Invoice Number",
                                value: params.datum.InvoiceNo,
                            },
                            {
                                label: "Status",
                                value: params.datum.InvoiceStatus,
                            },
                            {
                                label: "Invoice Amount",
                                value: '$' + params.datum[params.yKey].toFixed(2),
                            },
                        ],
                    }
                }
            }
        }

        function initializePaymentSummaryChart() {
            $timeout(function () {
                ChartOptionList.PaymentSummaryChartOptions.container = document.getElementById('PaymentSummaryChart');
                ChartList.PaymentSummaryChart = agCharts.AgCharts.create(ChartOptionList.PaymentSummaryChartOptions);

                ChartOptionList.InvoicePaymentChartOptions.container = document.getElementById('InvoicePaymentChart');
                ChartList.InvoicePaymentChart = agCharts.AgCharts.create(ChartOptionList.InvoicePaymentChartOptions);
            }, 100);
        }

        $scope.convertChartType = function (chart, chartoption, type) {

            if (ChartOptionList[chartoption]) {
                _.each(ChartOptionList[chartoption].series, function (obj) {
                    obj.type = type;
                    obj.marker = {
                        size: 13,
                    };
                });
                ChartList[chart].update(ChartOptionList[chartoption]);
            }
        }

        //#region InvoicePaymentGrid
        var dateFilterParams = {
            comparator: function (filterLocalDateAtMidnight, cellValue) {

                var cellDate = moment(moment($filter('localDate')(cellValue, false, new Date())).format("MM/DD/YYYY"));
                var currentDate = moment(filterLocalDateAtMidnight);

                if (currentDate.isSame(cellDate)) {
                    return 0;
                }

                if (cellDate.isBefore(currentDate)) {
                    return -1;
                }

                if (cellDate.isAfter(currentDate)) {
                    return 1;
                }
                return 0;
            },
        }
        InvoicePaymentDetails.ColumnDefs = [
            {
                field: "Action", headerName: "",
                minWidth: 60,
                maxWidth: 60,
                cellRenderer: InvoicePaymentActionRenderer()
            },
            { field: "InvoiceNo", headerName: "Invoice Number", },
            { field: "InvoiceStatus", filter: "agSetColumnFilter" },
            {
                field: "InvoiceAmount",
                cellRenderer: function (params) {
                    if (params && params.data && params.data.InvoiceAmount) {
                        return "$" + (parseFloat(params.data.InvoiceAmount)).toFixed(2);
                    }
                },
                filter: "agNumberColumnFilter"
            },
            {
                field: "InvoiceDate",
                cellRenderer: function (params) {
                    if (params && params.data && params.data.InvoiceDate) {
                        return moment($filter('localDate')(params.data.InvoiceDate, false, new Date())).format("MM/DD/YYYY");
                    }
                },
                sort: "asc",
                filter: "agDateColumnFilter",
                filterParams: dateFilterParams,
            },
            {
                field: "DueDate",
                cellRenderer: function (params) {
                    if (params && params.data && params.data.DueDate) {
                        params.data.DueDate = moment($filter('localDate')(params.data.DueDate, false, new Date())).format("MM/DD/YYYY");
                        return params.data.DueDate;
                    }
                },
                filter: "agDateColumnFilter",
                filterParams: dateFilterParams,
            },
            {
                field: "PaidDate",
                cellRenderer: function (params) {
                    if (params && params.data && params.data.PaidDate) {
                        return moment($filter('localDate')(params.data.PaidDate, false, new Date())).format("MM/DD/YYYY");
                    }
                },
                filter: "agDateColumnFilter",
                filterParams: dateFilterParams,
            },
            { field: "InvoicePaymentNo" },
            {
                field: "ProviderName", headerName: "Reading Provider",
                cellRenderer: function (params) {
                    if (params && params.data && params.data.ProviderName) {
                        return params.value.split(', ').map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); }).join(', ');
                    }
                    return "";
                }
            },
            {
                field: "PaidAmount",
                cellRenderer: function (params) {
                    if (params && params.data && params.data.PaidAmount) {
                        return "$" + (parseFloat(params.data.PaidAmount)).toFixed(2);
                    }
                },
                filter: "agNumberColumnFilter"
            },
            {
                field: "TotalAmount",
                cellRenderer: function (params) {
                    if (params && params.data && params.data.TotalAmount) {
                        return "$" + (parseFloat(params.data.TotalAmount)).toFixed(2);
                    }
                },
                filter: "agNumberColumnFilter"
            },
            {
                field: "PaymentMethod",
                filter: "agSetColumnFilter",
            },
            {
                field: "InvoiceNotesJSON",
                headerName: "",
                minWidth: 30,
                maxWidth: 30,
                cellClass: 'p-0 text-center tippy-ttwrapper',
                cellRenderer: function (params) {
                    if (params.node.rowPinned != "bottom") {
                        var className = (params.data.InvoiceNoteID) ? 'cursor-pointer fs-14px pt-5px fa fa-comments green cursor-pointer fs-14px txt-clr-14 pt-5px gray' : 'fa fa-comment-o cursor-pointer fs-14px txt-clr-14 pt-5px gray';
                        var template = '<span class=\'cursor-pointer fs-14px pt-5px ' + className + '\' aria-hidden="true" title=""></span>';
                        return template;
                    }
                }
            }
        ];



        function InvoicePaymentActionRenderer() {
            function CustomRenderer() {
            }
            CustomRenderer.prototype.init = function (params) {
                this.eGui = document.createElement('div');

                if (params && params.data && params.data.InvoiceStatus == "Pending") {
                    var safeInvoiceId = encodeURIComponent(params.data.InvoiceID);
                    $scope.DataObject.gridRows[safeInvoiceId] = params.data;
                    var button = document.createElement('button');
                    button.className = 'btn btn-default txt-clr-14 border-0 d-flex';
                    button.title = 'Delete Invoice';
                    button.setAttribute('ng-click', "DeleteInvoice(this.DataObject.gridRows['" + safeInvoiceId + "'])");
                    var icon = document.createElement('i');
                    icon.className = 'fa fa-trash';
                    button.appendChild(icon);
                    this.eGui.appendChild(button);
                }

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomRenderer.prototype.getGui = function () {
                return this.eGui;
            };
            CustomRenderer.prototype.destroy = function () {
            };
            return CustomRenderer;
        }
        InvoicePaymentDetails.GridOptions = {
            columnDefs: InvoicePaymentDetails.ColumnDefs,
            rowData: [],
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: false,
                lockVisible: true,
                menuTabs: ["filterMenuTab"]
            },
            sortingOrder: ['desc', 'asc'],
            cacheBlockSize: InvoicePaymentDetails.PageSize,
            suppressContextMenu: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getRowId: function (params) {
                return params.data.InvoiceID;
            },
            onGridReady: function (params) {
                GetInvoicePaymentDetail();
            },
            onCellMouseOver: function (params) {
                switch (params.column.colId) {
                    case 'InvoiceNotesJSON':
                        if (params.data && params.data.InvoiceNoteID) {
                            var cellRendererInstances = params.api.getCellRendererInstances({
                                rowNodes: [params.node],
                                columns: [params.column],
                            });
                            createDiscussionPopOver(cellRendererInstances, params)
                        }
                        break;
                }
            },
        }

        function GetInvoicePaymentDetail() {
            if (!$scope.DataObject.isDataLoading) {
                $scope.DataObject.isDataLoading = true;
            }
            PaymentContractService.GetInvoicePaymentDetail({
                UserIDs: $sessionStorage.currentUserData.userId,
                InvoiceStartDate: $filter('CSTDateTime')(moment(moment(selectedDate.startDate).format("YYYY-MM-DD") + ' ' + "00:00")),
                InvoiceEndDate: $filter('CSTDateTime')(moment(moment(selectedDate.endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")),
            }).then(function (result) {
                InvoicePaymentDetails.GridAPI.setRowData([]);
                _.each(result, function (res) {
                    res.InvoiceDate = moment($filter('localDate')(res.InvoiceDate, false, new Date())).format("MM/DD/YYYY")
                });
                InvoicePaymentDetails.InvoicePaymentList = _.uniqBy(result, 'InvoiceID');
                if (InvoicePaymentDetails.InvoicePaymentList == 0) {
                    InvoicePaymentDetails.GridAPI.showNoRowsOverlay();
                } else {
                    InvoicePaymentDetails.GridAPI.hideOverlay();
                }

                var AdjustedAmount = 0;
                var InvoiceAmount = 0;
                var PaidAmount = 0;
                var TotalAmount = 0;
                _.each(InvoicePaymentDetails.InvoicePaymentList, function (obj) {
                    if (obj.AdjustedAmount && !isNaN(parseFloat(obj.AdjustedAmount))) {
                        AdjustedAmount = AdjustedAmount + obj.AdjustedAmount;
                    }
                    if (obj.InvoiceAmount && !isNaN(parseFloat(obj.InvoiceAmount))) {
                        InvoiceAmount = InvoiceAmount + obj.InvoiceAmount;
                    }
                    if (obj.PaidAmount && !isNaN(parseFloat(obj.PaidAmount))) {
                        PaidAmount = PaidAmount + obj.PaidAmount;
                    }
                    if (obj.TotalAmount && !isNaN(parseFloat(obj.TotalAmount))) {
                        TotalAmount = TotalAmount + obj.TotalAmount;
                    }
                });
                var row = {
                    "AdjustedAmount": AdjustedAmount,
                    "InvoiceAmount": InvoiceAmount.toFixed(2),
                    "PaidAmount": PaidAmount,
                    "TotalAmount": TotalAmount
                }
                InvoicePaymentDetails.GridAPI.setPinnedBottomRowData([row]);

                InvoicePaymentDetails.GridAPI.setRowData(InvoicePaymentDetails.InvoicePaymentList);
                ChartOptionList.InvoicePaymentChartOptions.data = InvoicePaymentDetails.InvoicePaymentList;
                ChartList.InvoicePaymentChart.update(ChartOptionList.InvoicePaymentChartOptions);

                vm.getInvoicePaymentDetail({ InvoicePaymentList: InvoicePaymentDetails.InvoicePaymentList });
                $scope.DataObject.isDataLoading = false;
            }, function (err) {
                $scope.DataObject.isDataLoading = false;
                console.log("Error > ", err);
                toaster.pop({ type: 'error', body: "An error occurred while fetching the payment invoice detail." });
                params.fail();
            });
        }


        $scope.DeleteInvoice = function (row) {
            $scope.DataObject.isDataLoading = true;
            PaymentContractService.UpdateInvoice({
                InvoiceID: row.InvoiceID,
                CreatedBy: $sessionStorage.currentUserData.userId,
                StatusFlag: "D",
                Flag: "D",
                UserEmailID: $sessionStorage.currentUserData ? $sessionStorage.currentUserData.EmailId : '',
                InvoiceStatus: "Deleted",
                invoicePaymentBillDetails: row.invoicePaymentBillDetails,
            }).then(function (result) {
                if (result && result.length > 0 && result[0].InvoiceStatus) {
                    if (result[0].InvoiceStatus == "Deleted") {
                        toaster.pop({ type: 'success', body: "Invoice deleted successfully." });
                    }
                    else {
                        toaster.pop({
                            type: 'warning', body: "Since the invoice has already been " + result[0].InvoiceStatus.toLowerCase() + ", it cannot be deleted."
                        });
                    }
                }
                GetInvoicePaymentDetail();
                vm.onInvoiceDeleted();
            }).catch(function () {
                $scope.DataObject.isDataLoading = false;
                toaster.pop({ type: 'error', body: "An error occurred while updating the invoice." });
            });
        }
        function GetPaymentMethod() {
            var d = $q.defer();

            PaymentContractService.GetPaymentMethod().then(function (result) {
                $scope.DataObject.PaymentMethodOptions = result;
                d.resolve();
            }, function (err) { d.reject(); });
            return d.promise;
        }

        //#endregion InvoicePaymentGrid

        //#region tippy

        function createDiscussionPopOver(instance, params) {
            var template = instance[0].eGui;
            hideAllTippyPopUp()
            var tippyInstance = tippy(template);
            tippyInstance.disable();
            configureTippyInstance(tippyInstance);
            if (params.data.InvoiceNotesJSON) {
                tippyJsinstance.push({ tippyInstance: tippyInstance, cellInstance: instance, rowNode: params.node });
            }
            var popOver = createDiscussionComponent(params);
            tippyInstance.setContent(popOver);

        }

        function hideAllTippyPopUp() {
            _.each(tippyJsinstance, function (instance) {
                if (instance.tippyInstance) {
                    instance.tippyInstance.hide();
                }
            });
            tippyJsinstance = [{ tippyInstance: null, cellInstance: null, rowNode: null }];
        }

        function configureTippyInstance(tippyInstance) {
            tippyInstance.enable();
            tippyInstance.show();
            document.getElementById("InvoicePaymentGrid").addEventListener("mouseenter", discsnPopHide);
            function discsnPopHide() {
                tippyInstance.hide();
            }
            tippyInstance.setProps({
                trigger: 'mouseenter',
                placement: 'right',
                interactive: false,
                onMount: function (tippyInstance) {
                    tippyInstance.setProps({ interactive: true });
                },
                appendTo: document.body,
                hideOnClick: false,
                arrow: true,
                zIndex: 99999,
                followCursor: false,
                sticky: true,
                duration: 0,
                offset: [0, 10],
                flip: false,
                delay: 0,
                inertia: false,
                animateFill: false,
                animation: false,
                onShow: function (tippyInstance) {
                    tippy.hideAll({ exclude: tippyInstance });
                }
            });
        }

        function htmlEncode(value) {
            var node = document.createElement('span');
            node.textContent = (value == null ? '' : String(value));
            return node.innerHTML;
        }

        function showPopover(row) {
            var d = $q.defer();
            var htmlpop = '<div class="popchatui dropdown-content dropdown-menu-right">';
            PaymentContractService.GetInvoiceNotesByInvoiceID({ InvoiceID: row.InvoiceID }).then(function (Notes) {
                htmlpop = htmlpop + '<div>';
                _.each(Notes, function (note, index) {
                    htmlpop = htmlpop + '<div class="">' +
                        '<div class="">' +
                        '<div class="fs-12px fw-600 txt-clr-14 mb-4px">' + htmlEncode(note.ProviderName) + '</div>' +
                        '<div class="fs-12px fw-500 text-preline word-break-word mb-4px">' + htmlEncode(note.Notes) + ' </div>' +
                        '<div class="fs-12px fw-500 txt-clr-30 mb-4px">' + ($filter('localDate')(note.CreatedDate, false, new Date())) + '</div>';
                    htmlpop = htmlpop + '</div></div>';
                    if (Notes.length - 1 != index) {
                        htmlpop = htmlpop + '<hr style="margin-top: 6px;margin-bottom: 6px;border: 0;border-top: 1px solid #a0a0a0;"/>'
                    }
                });

                htmlpop = htmlpop + '</div>';
                d.resolve(htmlpop);

            }, function (err) {
                toaster.pop({ type: 'error', body: "An error occurred while fetching invoice notes." });
                d.resolve(htmlpop);
            });
            return d.promise;
        };

        function createDiscussionComponent(params) {
            var popOver = document.createElement('div');
            popOver.innerHTML = "<img src= \'https://i.gifer.com/ZKZx.gif\' style=\'height:20px;width:20px\'></img>"
            //if (params.data.IsDiscussion) {
            if (!params.data.Notes) {
                showPopover(params.data).then(function (res) {
                    var sanitized = DOMPurify.sanitize("<div style='display:block; background-color: #323232;'>" + res + "</div>");
                    params.data.Notes = sanitized;
                    popOver.innerHTML = DOMPurify.sanitize(params.data.Notes);
                });
            } else {
                popOver.innerHTML = DOMPurify.sanitize(params.data.Notes);
            }

            return popOver;
            return d.promise;
        }
        //#endregion tippy

        function GetPaymentContractByUserByID() {
            var d = $q.defer();
            PaymentContractService.GetPaymentContractByUserByID({ UserID: $sessionStorage.currentUserData.userId }).then(function (result) {
                if (result && result.length > 0) {
                    $scope.DataObject.UsersPaymentContract = result;
                }
                d.resolve();
            }).catch(function () {
                toaster.pop({ type: 'error', body: "An error occurred while fetching the payment contract of the user." });
            });
            return d.promise;
        }

        $scope.ExportPaymentSummaryData = function () {
            try {
                toaster.info("You are now exporting.  You'll be informed when it's finished.");
                PaymentContractService.GetUserPaymentDetailExport({
                    UserID: $sessionStorage.currentUserData.userId,
                    StartDate: $filter('CSTDateTime')(moment(moment(selectedDate.startDate).format("YYYY-MM-DD") + ' ' + "00:00")),
                    EndDate: $filter('CSTDateTime')(moment(moment(selectedDate.endDate).format("YYYY-MM-DD") + ' ' + "23:59:59")),
                    TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                }).then(function (result) {
                    if (result && result.fileStorage != null && result.orderList.length > 0) {
                        var byteCharacters = atob(result.fileStorage.FileContent);
                        var byteNumbers = new Uint8Array(byteCharacters.length);

                        for (var i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }

                        var blob = new Blob([byteNumbers], { type: result.fileStorage.ContentType });
                        var url = URL.createObjectURL(blob);

                        var a = document.createElement('a');
                        a.href = url;

                        a.download = result.fileStorage.FileName;
                        document.body.appendChild(a);
                        a.click();
                        toaster.success("You have downloaded your finished export.");
                    }
                    else
                    {
                        toaster.pop({ type: 'warning', title: "You don't have data to export." });
                    }
                }, function (err) {
                    toaster.error("When exporting the payment summary, an error occurred.");
                });
            }
            catch (exception) {
                toaster.error("When exporting the payment summary, an error occurred.");
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('paymentInvoice', {
            templateUrl: 'app/theme/components/payment-invoice/payment-invoice.html',
            bindings: {

            },
            controller: PaymentInvoiceController
        });

    /** @ngInject */
    function PaymentInvoiceController($scope, $log, $sessionStorage, $timeout, $q, ReviewOrderService, $filter, toaster, PaymentContractService, $compile, CommonService) {

        var vm = this;
        var InvoiceList = [];
        var PageSize = 50;
        var TotalRows = 0;
        var tippyJsinstance = [{ tippyInstance: null, cellInstance: null, rowNode: null }];
        $scope.DataObject = {
            isDataLoading: false,
            Filter: {
                OrderByField: 'InvoiceNo',
                OrderBy: 'desc',
                SelectedRadiologist: '',
                UserFilterMultiSelect: {
                    divId: "UserInvoiceFilterMultiSelect",
                    keys: ['LastName', 'FirstName'],
                    uniqKey: 'Id',
                    SelectedValue: { list: [] },
                    onSelectUser: function (selectedData) {
                        $scope.DataObject.Filter.SelectedRadiologist = _.join(_.map(selectedData, function (user) { return user.Id }), ',');
                        $scope.DataObject.RadiologistFilterTooltip = _.join(_.map(selectedData, function (provider) {
                            return provider.LastName + ', ' + provider.FirstName;
                        }), '\n')
                    }
                },
                InvoiceStatus: null,
            },
            InvoiceStatusList: [],
            RadiologistsList: [],
            InvoicePaymentMethodList: [],
            ViewInvoice: {
                InvoiceData: null,
                InvoicePaymentMethod: null,
                DatePaid: null,
                Adjustments: null,
                Notes: '',
                isNotes: false,
                isPaidVia: false,
                isInvoicePDfVisible: false,
            },
            gridRows: {},
            DisableBtn:
            {
                Approve: false,
                Reject: false,
                Pay: false,
            },
            RadiologistFilterTooltip: "Select Radiologist",
        };

        $scope.DataObject.Filter.OrderDate = {
            startDate: moment().subtract(2, "days"),
            endDate: moment()
        };
        $scope.DataObject.Filter.Opts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                cancelLabel: 'Clear',
                customRangeLabel: 'Custom range',
                clearLabel: $scope.DataObject.Filter.OrderDate = {
                    startDate: null,
                    endDate: null
                }
            },
            ranges: {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
            },
            eventHandlers: {
                'apply.daterangepicker': function (event, picker) {
                    $scope.DataObject.Filter.OrderDateTooltip = $scope.DataObject.Filter.OrderDate.startDate && $scope.DataObject.Filter.OrderDate.endDate ? 'Invoice Date: ' + $scope.DataObject.Filter.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.DataObject.Filter.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                }
            }
        }

        vm.$onChanges = function (changes) {
            console.log("$onChanges paymentInvoice changes", changes);
        };
        vm.$onDestroy = function () {
            console.log('Destory paymentInvoice');
        }
        vm.$onInit = function () {
            console.log("$onInit paymentInvoice");
            $q.all([
                GetAllUsers(),
                GetInvoiceStatus(),
                GetPaymentMethod(),
            ]).then(function () {
                initGrid();
                $scope.DataObject.Filter.InvoiceStatus = _.find($scope.DataObject.InvoiceStatusList, { InvoiceStatus: 'Pending' });
            });
        }

        /** localDate expects "YYYY-MM-DD HH:mm:ss"-style strings; API/Dapper often returns culture-specific datetime text. */
        function normalizeDateStringForLocalDateFilter(raw) {
            if (raw == null || raw === '') {
                return '';
            }
            if (angular.isDate(raw)) {
                return isNaN(raw.getTime()) ? '' : moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'number' && isFinite(raw)) {
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'string') {
                var parsed = moment(raw.trim());
                return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : '';
            }
            return '';
        }

        function momentFromLocalDateOutput(localized) {
            if (!localized) {
                return null;
            }
            var m = moment(localized, ['M/D/YYYY HH:mm', 'MM/DD/YYYY HH:mm', 'M/D/YYYY H:mm'], true);
            if (!m.isValid()) {
                m = moment(localized);
            }
            return m.isValid() ? m : null;
        }

        function formatInvoiceGridDate(raw) {
            var normalized = normalizeDateStringForLocalDateFilter(raw);
            if (!normalized) {
                return '';
            }
            var localized = $filter('localDate')(normalized, false, new Date());
            var m = momentFromLocalDateOutput(localized);
            return m ? m.format('MM/DD/YYYY') : '';
        }

        function formatInvoiceNoteCreatedDate(raw) {
            var normalized = normalizeDateStringForLocalDateFilter(raw);
            if (!normalized) {
                return '';
            }
            return $filter('localDate')(normalized, false, new Date()) || '';
        }

        var columnDefs = [
            {
                field: "InvoiceNo",
                tooltipField: "InvoiceNo",
                headerName: "Invoice Number",
                flex: 1,
                hide: false
            },
            {
                field: "ProviderName",
                headerName: "Reading Provider Name",
                cellRenderer: function (params) {
                    if (params && params.data && params.data.ProviderName) {
                        return params.value.split(', ').map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); }).join(', ');
                    }
                    return "";
                },
                flex: 1,
                hide: false
            },
            {
                field: "InvoiceDate",
                headerName: "Invoice Date",
                flex: 1,
                cellRenderer: function (params) {
                    if (!params.node.data) {
                        return '';
                    }
                    var val = formatInvoiceGridDate(params.value);
                    if (!val) {
                        return '';
                    }
                    return "<span title='" + val + "'>" + val + "</span>";
                },
                hide: false
            },
            {
                field: "DueDate",
                headerName: "Due Date",
                flex: 1,
                cellRenderer: function (params) {
                    if (!params.node.data) {
                        return '';
                    }
                    var val = formatInvoiceGridDate(params.value);
                    if (!val) {
                        return '';
                    }
                    return "<span title='" + val + "'>" + val + "</span>";
                },
                hide: false
            },
            {
                field: "InvoiceAmount",
                headerName: "Invoice Amount",
                initialWidth: 200,
                cellRenderer: function (params) {
                    var template = "";
                    if (params.node.data && params.value != null) {
                        template = "<span> $" + params.value.toFixed(2) + "</span>";
                    }
                    return template;
                },
                hide: false
            },
            {
                field: "PaidDate",
                headerName: "Paid Date",
                flex: 1,
                cellRenderer: function (params) {
                    if (!params.node.data || params.value == null || params.value === '') {
                        return '';
                    }
                    var val = formatInvoiceGridDate(params.value);
                    if (!val) {
                        return '';
                    }
                    return "<span title='" + val + "'>" + val + "</span>";
                },
                hide: false
            },
            {
                field: "InvoiceStatus",
                headerName: "Invoice Status",
                flex: 1,
                hide: false
            },
            {
                field: "InvoiceNotesJSON",
                headerName: "Notes",
                headerClass: 'hideHeaderTxt arrowcursor',
                cellClass: 'p-0 text-center tippy-ttwrapper',
                cellRenderer: function (params) {
                    if (params.node.data.InvoiceNoteID) {
                        return '<i class="fa fa-comments fs-14px pt-5px green"></i>';
                    }
                    else {
                        return '<i class="fa fa-comment-o fs-14px txt-clr-14 pt-5px"></i>'
                    }
                },
                sortable: false,
                resizable: false,
                initialWidth: 30,
                hide: false
            },
            {
                field: "Action",
                headerClass: 'hideHeaderTxt arrowcursor',
                cellRenderer: InvoicePaymentActionRenderer(),
                sortable: false,
                resizable: false,
                initialWidth: 130,
                hide: false
            },
        ];

        var gridOptions = {
            columnDefs: columnDefs,
            enableBrowserTooltips: true,
            defaultColDef: {
                sortable: true,
                resizable: true,
            },
            rowSelection: 'single',
            rowModelType: 'serverSide',
            cacheBlockSize: PageSize,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            sortingOrder: ['desc', 'asc'],
            popupParent: document.body,
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },
            defaultExcelExportParams: {
                processCellCallback: function (params) {
                    return DefaultExportParams(params);
                }
            },
            defaultCsvExportParams: {
                processCellCallback: function (params) {
                    return DefaultExportParams(params);
                }
            },
            onGridReady: function () {
                var fakeServer = createFakeServer();

                // create datasource with a reference to the fake server
                var datasource = createServerSideDatasource(fakeServer);

                // register the datasource with the grid

                gridOptions.api.setServerSideDatasource(datasource);
                gridOptions.columnApi.applyColumnState({ state: [{ colId: 'InvoiceDate', sort: 'asc' }], });
            },
            onSortChanged: function (params) {
                if (!$scope.DataObject.isDataLoading) {
                    resetGrid();
                }
                else {
                    return;
                }
            },
            onCellMouseOver: function (params) {
                switch (params.column.colId) {
                    case 'InvoiceNotesJSON':
                        if (params.node.data.InvoiceNoteID) {
                            var cellRendererInstances = params.api.getCellRendererInstances({
                                rowNodes: [params.node],
                                columns: [params.column],
                            });
                            createNotesPopOver(cellRendererInstances, params)
                        } else {
                            hideAllTippyPopUp();
                        }
                        break;
                }
            },
        }

        function createServerSideDatasource(server) {
            return {
                getRows: function (params) {
                    server.getData(params.request).then(function (response) {
                        if (response.success) {
                            params.success({
                                rowData: response.rows,
                                rowCount: response.lastRow,
                            });
                        } else {
                            params.fail();
                        }
                    });
                },
            };
        }

        function createFakeServer() {
            return {
                getData: function (request) {
                    var d = $q.defer();
                    gridOptions.api.showLoadingOverlay();
                    if (request.sortModel.length > 0) {
                        $scope.DataObject.Filter.OrderByField = request.sortModel[0].colId;
                        $scope.DataObject.Filter.OrderBy = request.sortModel[0].sort;
                    }
                    $scope.DataObject.Filter.OrderDateTooltip = $scope.DataObject.Filter.OrderDate.startDate && $scope.DataObject.Filter.OrderDate.endDate ? 'Invoice Date: ' + $scope.DataObject.Filter.OrderDate.startDate.format('MM/DD/YYYY') + ' - ' + $scope.DataObject.Filter.OrderDate.endDate.format('MM/DD/YYYY') : 'DOS';
                    var InvoiceListFilter = {
                        InvoiceNo: '',
                        InvoiceStatusID: $scope.DataObject.Filter.InvoiceStatus ? $scope.DataObject.Filter.InvoiceStatus.InvoiceStatusID : '',
                        PageNum: Math.ceil(request.endRow / PageSize),
                        PageSize: PageSize,
                        UserIDs: $scope.DataObject.Filter.SelectedRadiologist != '' ? $scope.DataObject.Filter.SelectedRadiologist : null,
                        OrderByField: $scope.DataObject.Filter.OrderByField,
                        OrderBy: $scope.DataObject.Filter.OrderBy,
                        InvoiceStartDate: $scope.DataObject.Filter.OrderDate.startDate ? $filter('CSTDateTime')($scope.DataObject.Filter.OrderDate.startDate) : null,
                        InvoiceEndDate: $scope.DataObject.Filter.OrderDate.endDate ? $filter('CSTDateTime')($scope.DataObject.Filter.OrderDate.endDate) : null,
                    };

                    PaymentContractService.GetInvoicePaymentDetail(InvoiceListFilter).then(function (result) {
                        InvoiceList = _.concat(InvoiceList, result);
                        if (InvoiceList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            TotalRows = InvoiceList[0].PageCounts;
                        }
                        showHideStatusbar();
                        $scope.DataObject.isDataLoading = false;
                        gridOptions.api.hideOverlay();
                        if (InvoiceList && InvoiceList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        }

                        var Idx = _.findIndex(columnDefs, { 'field': "Action" });
                        if (Idx != -1) {
                            columnDefs[Idx].hide = $scope.DataObject.Filter.InvoiceStatus && ($scope.DataObject.Filter.InvoiceStatus.InvoiceStatus == 'Pending' || $scope.DataObject.Filter.InvoiceStatus.InvoiceStatus == 'Approved') ? false : true;
                        }
                        gridOptions.api.setColumnDefs(columnDefs);

                        d.resolve({
                            success: true,
                            rows: result,
                        });
                    }, function (error) {
                        toaster.pop({ type: 'error', body: "An error occurred while fetching payment details." });
                        d.reject({ Message: error });
                    });
                    return d.promise;
                },
            };
        }

        function initGrid() {
            var timeout = $timeout(function () {
                var gridDiv = document.getElementById("InvoiceAGGrid");
                if (gridDiv) { new agGrid.Grid(gridDiv, gridOptions); }

                $timeout.cancel(timeout);
                timeout = null;
            }, 200);
        }

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }

        function showHideStatusbar() {
            var statusBarComponent = gridOptions.api.getStatusPanel('GridFooter');
            if (InvoiceList.length == 0) {
                statusBarComponent.eGui.hidden = true;
                gridOptions.api.showNoRowsOverlay();
            } else {
                gridOptions.api.hideOverlay();
                statusBarComponent.eGui.hidden = false;
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
                statusBarComponent.eGui.textContent = 'Showing ' + InvoiceList.length + ' of ' + TotalRows + ' Total Records';
                statusBarComponent.eGui.style.color = 'white';
            }
        }

        function resetGrid() {
            $scope.DataObject.isDataLoading = true;
            InvoiceList = [];
            gridOptions.api.refreshServerSide({ purge: true });
        }

        function GetAllUsers() {
            var d = $q.defer();
            ReviewOrderService.GetAllUsers().then(function (result) {
                $scope.DataObject.RadiologistsList = result.data;
                d.resolve();
            });
            return d.promise;
        }

        function GetInvoiceStatus() {
            var d = $q.defer();
            PaymentContractService.GetInvoiceStatus().then(function (result) {
                $scope.DataObject.InvoiceStatusList = result;
                d.resolve();
            });
            return d.promise;
        }

        function GetPaymentMethod() {
            var d = $q.defer();
            PaymentContractService.GetPaymentMethod().then(function (result) {
                $scope.DataObject.PaymentMethodOptions = result;
                d.resolve();
            });
            return d.promise;
        }

        $scope.clearFilter = function () {
            $scope.DataObject.Filter.SelectedRadiologist = null;
            $scope.DataObject.Filter.UserFilterMultiSelect.SelectedValue = { list: [] };
            $scope.DataObject.Filter.InvoiceStatus = _.find($scope.DataObject.InvoiceStatusList, { InvoiceStatus: 'Pending' });
            $scope.DataObject.Filter.OrderDate = {
                startDate: null,
                endDate: null
            }
            resetGrid();
        };

        $scope.Filter = function () {
            resetGrid();
        };

        $scope.clearModal = function () {
            $scope.DataObject.ViewInvoice = {
                InvoiceData: null,
                InvoicePaymentMethod: null,
                DatePaid: null,
                Adjustments: null,
                Notes: '',
                isInvoicePDfVisible: false,
            };
            $scope.DataObject.DisableBtn =
            {
                Approve: false,
                Reject: false,
                Pay: false,
            };
        }

        $scope.SaveInvoiceStatus = function (Type) {
            switch (Type) {
                case 'Approved':
                    $scope.DataObject.DisableBtn.Approve = true;
                    break;
                case 'Rejected':
                    $scope.DataObject.DisableBtn.Reject = true;
                    if ($scope.DataObject.ViewInvoice.Notes == '') {
                        $scope.DataObject.DisableBtn.Reject = false;
                        $scope.DataObject.ViewInvoice.isNotes = true;
                        return;
                    }
                    break;
            }
            UpdateInvoice(Type).then(function (result) {
                if (result && result && result.length > 0) {
                    if (result.StatusFlag == "D") {
                        toaster.pop({ type: 'warning', body: "Invoice deleted successfully." });
                    }
                    else {
                        if (Type != '') {
                            toaster.success({ body: "Invoice #" + $scope.DataObject.ViewInvoice.InvoiceData.InvoiceNo + " is " + Type.toLowerCase() + "." });
                        }
                    }
                    $('#ViewInvoiceModal').modal('hide');
                    $scope.clearModal();
                    resetGrid();
                }
            });
        };

        function UpdateInvoice(Type) {
            var d = $q.defer();
            var InvoiceStatus = _.find($scope.DataObject.InvoiceStatusList, { InvoiceStatus: Type });
            var CreatedByName = _.find($scope.DataObject.RadiologistsList, { Id: $sessionStorage.currentUserData.userId });
            var UserName = _.find($scope.DataObject.RadiologistsList, { Id: $scope.DataObject.ViewInvoice.InvoiceData.InvoiceUserID });

            var obj = {
                InvoiceStatusID: InvoiceStatus ? InvoiceStatus.InvoiceStatusID : null,
                InvoiceID: $scope.DataObject.ViewInvoice.InvoiceData.InvoiceID,
                StatusFlag: 'M',
                CreatedBy: $sessionStorage.currentUserData.userId,
                Notes: $scope.DataObject.ViewInvoice.Notes,
                UserEmailID: UserName ? UserName.Email : '',
                InvoiceStatus: InvoiceStatus ? InvoiceStatus.InvoiceStatus : '',
                UserName: UserName ? UserName.LastName + ', ' + UserName.FirstName : '',
                CreatedByName: CreatedByName ? CreatedByName.LastName + ', ' + CreatedByName.FirstName : '',
                InvoiceNo: $scope.DataObject.ViewInvoice.InvoiceData.InvoiceNo,
                InvoiceDate: (function () {
                    var invNorm = normalizeDateStringForLocalDateFilter($scope.DataObject.ViewInvoice.InvoiceData.InvoiceDate);
                    var mInv = invNorm ? momentFromLocalDateOutput($filter('localDate')(invNorm, false, new Date())) : null;
                    return mInv ? mInv.format('MM-DD-YYYY') : '';
                })(),
                invoicePaymentBillDetails: $scope.DataObject.ViewInvoice.InvoiceData.invoicePaymentBillDetails,
                VendorID: $scope.DataObject.ViewInvoice.InvoiceData.VendorID,
            }
            PaymentContractService.UpdateInvoice(obj).then(function (result) {
                d.resolve(result);
            }).catch(function () {
                toaster.pop({ type: 'error', body: "An error occurred while updating the invoice." });
            });
            return d.promise;
        }

        //#region tippy popover
        function createNotesPopOver(instance, params) {
            var template = instance[0].eGui;
            hideAllTippyPopUp()
            var tippyInstance = tippy(template);
            tippyInstance.disable();
            configureTippyInstance(tippyInstance);
            if (params.data.InvoiceNotesJSON) {
                tippyJsinstance.push({ tippyInstance: tippyInstance, cellInstance: instance, rowNode: params.node });
            }
            var popOver = createNotesComponent(params);
            tippyInstance.setContent(popOver);
        }

        function hideAllTippyPopUp() {
            _.each(tippyJsinstance, function (instance) {
                if (instance.tippyInstance) {
                    instance.tippyInstance.hide();
                }
            });
            tippyJsinstance = [{ tippyInstance: null, cellInstance: null, rowNode: null }];
        }

        function configureTippyInstance(tippyInstance) {
            tippyInstance.enable();
            tippyInstance.show();
            document.getElementById("InvoiceAGGrid").addEventListener("mouseenter", discsnPopHide);
            function discsnPopHide() {
                tippyInstance.hide();
            }
            tippyInstance.setProps({
                trigger: 'mouseenter',
                placement: 'right',
                interactive: false,
                onMount: function (tippyInstance) {
                    tippyInstance.setProps({ interactive: true });
                },
                appendTo: document.body,
                hideOnClick: false,
                arrow: true,
                zIndex: 99999,
                followCursor: false,
                sticky: true,
                duration: 0,
                offset: [0, 10],
                flip: false,
                delay: 0,
                inertia: false,
                animateFill: false,
                animation: false,
                onShow: function(tippyInstance) {
                    tippy.hideAll({ exclude: tippyInstance });
                }
            });
        }

        function showPopover(row) {
            var d = $q.defer();
            var htmlpop = '<div class="popchatui dropdown-content dropdown-menu-right">';
            GetInvoiceNotesByInvoiceID(row.InvoiceID).then(function (Notes) {
                htmlpop = htmlpop + '<div>';
                _.each(Notes, function (note, index) {
                    htmlpop = htmlpop + '<div class="">' +
                        '<div class="">' +
                        '<div class="fs-12px fw-600 txt-clr-14 mb-4px">' + note.ProviderName + '</div>' +
                        '<div class="fs-12px fw-500 text-preline word-break-word mb-4px">' + note.Notes + ' </div>' +
                        '<div class="fs-12px fw-500 txt-clr-30 mb-4px">' + formatInvoiceNoteCreatedDate(note.CreatedDate) + '</div>';
                    htmlpop = htmlpop + '</div></div>';
                    if (Notes.length - 1 != index) {
                        htmlpop = htmlpop + '<hr style="margin-top: 6px;margin-bottom: 6px;border: 0;border-top: 1px solid #a0a0a0;"/>'
                    }
                });

                htmlpop = htmlpop + '</div>';
                d.resolve(htmlpop);

            }, function (err) { d.resolve(htmlpop); });
            return d.promise;
        };

        function createNotesComponent(params) {
            var popOver = document.createElement('div');
            popOver.innerHTML = "<img src= \'https://i.gifer.com/ZKZx.gif\' style=\'height:20px;width:20px\'></img>"
            //if (params.data.IsDiscussion) {
            if (params.data.AllNotes) {
                popOver.innerHTML = DOMPurify.sanitize("<div style='display:block; background-color: #323232;'>" + params.data.AllNotes + "</div>");
            }
            else {
                showPopover(params.data).then(function (res) {
                    params.data.AllNotes = res;
                    popOver.innerHTML = DOMPurify.sanitize("<div style='display:block; background-color: #323232;'>" + res + "</div>");
                });
            }
            return popOver;
        }
        //#endregion tippy popover

        function GetInvoiceByInvoiceID(InvoiceID) {
            var d = $q.defer();
            PaymentContractService.GetInvoiceByInvoiceID({
                InvoiceID: InvoiceID,
            }).then(function (result) {
                d.resolve(result);
            });
            return d.promise;
        }

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }
        function InvoicePaymentActionRenderer() {
            function CustomRenderer() {
            }
            CustomRenderer.prototype.init = function (params) {
                this.eGui = document.createElement('div');

                if (params && params.data && params.data.InvoiceStatus == "Approved") {
                    $scope.DataObject.gridRows[params.data.InvoiceID] = params.data;
                    var button = document.createElement('button');
                    button.className = 'btn btn-primary mb-3px py-0 px-5px';
                    button.title = 'Create Payment';
                    button.setAttribute('ng-click', "createPayment(this.DataObject.gridRows['" + escapeHtml(params.data.InvoiceID) + "'])");
                    var icon = document.createElement('i');
                    icon.className = 'fa fa-check pr-2px';
                    button.appendChild(icon);
                    button.appendChild(document.createTextNode('Pay'));
                    this.eGui.appendChild(button);
                }
                else if (params && params.data && params.data.InvoiceStatus == "Pending") {
                    $scope.DataObject.gridRows[params.data.InvoiceID] = params.data;
                    var button = document.createElement('button');
                    button.type = 'button';
                    button.className = 'btn btn-primary mb-3px py-0 px-5px';
                    button.title = 'View Invoice';
                    button.setAttribute('ng-click', 'ViewInvoice(this.DataObject.gridRows["' + escapeHtml(params.data.InvoiceID) + '"])');
                    var icon = document.createElement('i');
                    icon.className = 'fa fa-file-text-o pr-5px';
                    button.appendChild(icon);
                    button.appendChild(document.createTextNode('View Invoice'));
                    this.eGui.appendChild(button);
                }

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomRenderer.prototype.getGui = function () {
                return this.eGui;
            };
            CustomRenderer.prototype.destroy = function () {
            };
            return CustomRenderer;
        }

        $scope.ViewInvoice = function (row) {
            $scope.clearModal();
            $scope.DataObject.ViewInvoice.InvoiceData = row;
            GetInvoiceByInvoiceID(row.InvoiceID).then(function (result) {
                if(result == null)
                {
                    return;
                }
                $scope.DataObject.DisableBtn.Approve = false;
                $scope.DataObject.DisableBtn.Reject = false;
                if (result.InvoiceData && result.InvoiceData.fileStorage) {
                    $scope.DataObject.ViewInvoice.InvoicePDF = result.InvoiceData.fileStorage.FileContent;
                    $scope.DataObject.ViewInvoice.InvoicePDFUrl = CommonService.createBlobUrl(result.InvoiceData.fileStorage.FileContent, "application/pdf");
                }else{
                    var InvoicePDF = document.getElementById('ViewInvoicePDF');
                    InvoicePDF.innerHTML = DOMPurify.sanitize(result.InvoiceHTML);
                }
                $('#ViewInvoiceModal').modal('show');
            });

        }

        $scope.createPayment = function (row) {
            resetCreatePayment();
            $scope.clearModal();
            PaymentContractService.GetInvoiceByInvoiceID({ InvoiceID: row.InvoiceID }).then(function (result) {
                if(result == null)
                {
                    return;
                }
                row.InvoiceAmount = _.toNumber(row.InvoiceAmount).toFixed(2);
                $scope.DataObject.createPayment = row;
                $scope.DataObject.createPayment.PaymentMethodOptions = $scope.DataObject.PaymentMethodOptions;
                if (result.InvoiceData && result.InvoiceData.fileStorage) {
                    $scope.DataObject.createPayment.InvoicePDF = result.InvoiceData.fileStorage.FileContent;
                    $scope.DataObject.createPayment.InvoicePDFUrl = CommonService.createBlobUrl(result.InvoiceData.fileStorage.FileContent, "application/pdf");
                }else{
                    var InvoicePDF = document.getElementById('PayInvoicePDF');
                    InvoicePDF.innerHTML = DOMPurify.sanitize(result.InvoiceHTML);
                }
                $("#createPaymentModal").modal('show');
            }).catch(function () {
                toaster.pop({ type: 'error', body: "An error occurred while fetching invoice data." });
            });
        }

        $scope.SetInvoicePayment = function (selectedData) {
            $scope.DataObject.DisableBtn.Pay = true;
            if (selectedData && selectedData.InvoiceAmount && selectedData.InvoicePaymentMethod) {
                var invoiceStatus = _.find($scope.DataObject.InvoiceStatusList, { InvoiceStatus: "Paid" });
                if (invoiceStatus) {
                    var filter = {
                        InvoiceID: $scope.DataObject.createPayment.InvoiceID,
                        InvoiceStatusID: invoiceStatus.InvoiceStatusID,
                        PaymentMethodID: selectedData.InvoicePaymentMethod.PaymentMethodID,
                        PaidDate: $filter('CSTDateTime')(moment()),
                        CreatedBy: $sessionStorage.currentUserData.userId,
                        StatusFlag: 'N',
                        Notes: selectedData.Notes,
                        PaidAmount: selectedData.InvoiceAmount,
                        VendorID: $scope.DataObject.createPayment.VendorID,
                        BillID: $scope.DataObject.createPayment.BillID,
                        sessionId: $sessionStorage.currentUserData.BillAPISessionID
                    }

                    PaymentContractService.SetInvoicePayment(filter).then(function (result) {
                        toaster.pop({ type: 'success', body: "Invoice paid successfully." });
                        resetCreatePayment();
                        $("#createPaymentModal").modal('hide');
                        resetGrid();
                        $scope.DataObject.DisableBtn.Pay = false;
                    }).catch(function () {
                        toaster.pop({ type: 'error', body: "An error occurred while processing the invoice payment." });
                    });
                }
            }
            else {
                $scope.DataObject.DisableBtn.Pay = false;
                toaster.pop({ type: 'warning', body: "Please enter the required fields.." });
            }
        }

        function resetCreatePayment() {
            $scope.DataObject.createPayment = {
                PaidAmount: null,
                AdjustedAmount: null,
                Notes: null,
                PaymentMethod: null,
                PaymentMethodOptions: [],
            }
            $scope.DataObject.DisableBtn.Pay = false;
        }

        function GetInvoiceNotesByInvoiceID(InvoiceID) {
            var d = $q.defer();
            PaymentContractService.GetInvoiceNotesByInvoiceID({ InvoiceID: InvoiceID }).then(function (result) {
                d.resolve(result);
            }).catch(function () {
                toaster.pop({ type: 'error', body: "An error occurred while fetching invoice notes." });
            });
            return d.promise;
        }

        function DefaultExportParams(params) {
            if (params.value != null) {
                if (params.column.colId == "InvoiceDate" || params.column.colId == "DueDate" || params.column.colId == "PaidDate") {
                    return formatInvoiceGridDate(params.value) || '';
                }
                if (params.column.colId == "ProviderName") {
                    return params.value.split(', ').map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); }).join(', ');
                }
                if (params.column.colId == "InvoiceAmount") {
                    return "$" + _.toNumber(params.value).toFixed(2);
                }
            }
            return params.value;
        }

        $scope.onRadiologistFilterSelect = function () {
            if ($scope.DataObject.Filter.SelectedRadiologist && $scope.DataObject.Filter.SelectedRadiologist.length > 0) {
                //$scope.DataObject.RadiologistFilterTooltip = _.join(_.map($scope.DataObject.Filter.SelectedRadiologist, function (provider) { return provider.LastName + ', ' + provider.FirstName; }), '\n')
            } else {
                $scope.clearProviders();
            }
        };

        $scope.clearProviders = function () {
            $scope.DataObject.Filter.SelectedRadiologist = null;
            $scope.DataObject.Filter.UserFilterMultiSelect.SelectedValue = {
                list: []
            }
            $scope.DataObject.RadiologistFilterTooltip = "Select Radiologist";
        }

        $scope.resetDateRange = function () {
            $scope.DataObject.Filter.Opts.ranges = {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
            };
            angular.element(document).ready(function () {
                angular.element('.drp-buttons .cancelBtn').click(function () {
                    angular.element('#daterange3').val('');
                    $scope.DataObject.Filter.OrderDate = {
                        startDate: null,
                        endDate: null
                    };
                });
            });
        }
    };

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('paymentInvoiceHistory', {
            templateUrl: 'app/theme/components/payment-invoice-history/payment-invoice-history.html',
            bindings: {

            },
            controller: PaymentInvoiceHistoryCmpController
        });

    /** @ngInject */
    function PaymentInvoiceHistoryCmpController($scope, PaymentContractService, $timeout, $q, $sessionStorage, $filter, toastr) {

        var vm = this;
        var InvoiceHistoryList = [];
        var PageSize = 50;
        var TotalRows = 0;
        var tippyJsinstance = [{ tippyInstance: null, cellInstance: null, rowNode: null }];
        $scope.DataObject = {
            isDataLoading: false,
            UserInvoice: {
                InvoiceList: [],
                SelectedFileName: null,
            },
            UserInvoiceDetail: {
                InvoiceList: []
            },
        };

        $scope.DataObject.PaymentAccount = {
            Options: [],
            Selected: null,
        };

        function DerivePaymentAccountOptions(invoiceList) {
            var distinctTypes = _.chain(invoiceList)
                .map(function (invoice) { return invoice.ContractType; })
                .filter(function (contractType) { return !!contractType; })
                .uniq()
                .value()
                .sort();
            $scope.DataObject.PaymentAccount.Options = distinctTypes;
            $scope.DataObject.PaymentAccount.Selected = distinctTypes.length > 0 ? distinctTypes[0] : null;
        }

        function GetEffectivePaymentAccount() {
            if ($scope.DataObject.PaymentAccount.Selected) {
                return $scope.DataObject.PaymentAccount.Selected;
            }
            if ($scope.DataObject.PaymentAccount.Options.length === 1) {
                return $scope.DataObject.PaymentAccount.Options[0];
            }
            return null;
        }

        $scope.OnPaymentAccountSelected = function () {
            var filtered = $scope.DataObject.PaymentAccount.Selected
                ? _.filter($scope.DataObject.UserInvoiceDetail.InvoiceList, function (invoice) {
                    return invoice.ContractType === $scope.DataObject.PaymentAccount.Selected;
                })
                : $scope.DataObject.UserInvoiceDetail.InvoiceList;

            var TotalWorkRVU = 0;
            var TotalPayAmount = 0;
            var TotalCount = 0;
            _.each(filtered, function (invoice) {
                TotalWorkRVU = TotalWorkRVU > 0 ? TotalWorkRVU + invoice.WorkRVU : invoice.WorkRVU;
                TotalPayAmount = TotalPayAmount > 0 ? TotalPayAmount + invoice.PayAmount : invoice.PayAmount;
                if (invoice.TransactionTypeID != 2) {
                    TotalCount = TotalCount > 0 ? TotalCount + 1 : 1;
                }
            });

            if (InvoiceSummaryGridOption && InvoiceSummaryGridOption.api) {
                InvoiceSummaryGridOption.api.setRowData(filtered);
                InvoiceSummaryGridOption.api.setPinnedBottomRowData([{
                    ispinnedData: true,
                    "SignDate": "Period Totals",
                    "Modality": "Period Totals",
                    "WorkRVU": TotalWorkRVU,
                    "TotalCount": TotalCount,
                    "PayAmount": TotalPayAmount,
                }]);
            }
            if (InvoiceTransactionGridOption && InvoiceTransactionGridOption.api) {
                InvoiceTransactionGridOption.api.setRowData(filtered);
                InvoiceTransactionGridOption.api.setPinnedBottomRowData([{
                    "SignDateTime": "Payout Totals",
                    "Modality": null,
                    "WorkRVU": TotalWorkRVU,
                    "PayAmount": TotalPayAmount,
                }]);
            }
            UpdateDownloadButtonState();
        };

        function UpdateDownloadButtonState() {
            var paymentAccountSatisfied = $scope.DataObject.PaymentAccount.Options.length === 0 || !!GetEffectivePaymentAccount();
            $scope.DataObject.CanDownloadInvoice = !!($scope.DataObject.UserInvoice.SelectedFileName && paymentAccountSatisfied);
        }

        $scope.DataObject.NoInvoiceFound = {
            ErrorMessage: null,
        };

        function GetCurrentDownloadRequest() {
            return {
                FileName: $scope.DataObject.UserInvoice.SelectedFileName.FileName,
                UserID: $sessionStorage.currentUserData.userId,
                ContractType: GetEffectivePaymentAccount()
            };
        }

        $scope.OnDownloadInvoiceClicked = function () {
            if (!$scope.DataObject.CanDownloadInvoice) {
                return;
            }
            PaymentContractService.DownloadUserInvoicePDF(GetCurrentDownloadRequest()).then(function (result) {
                if (result && result.fileStorage && result.fileStorage.FileContent) {
                    DownloadBase64File(result.fileStorage.FileContent, $scope.DataObject.UserInvoice.SelectedFileName.FileName + '.pdf', 'application/pdf');
                } else {
                    $scope.DataObject.NoInvoiceFound.ErrorMessage = null;
                    $('#NoInvoiceFoundModal').modal('show');
                }
            }, function () {
                toastr.error('Unable to check for an existing invoice PDF. Please try again.', 'Error');
            });
        };

        $scope.OnGenerateInvoiceClicked = function () {
            PaymentContractService.GenerateUserInvoicePDF(GetCurrentDownloadRequest()).then(function (result) {
                if (result && result.fileStorage && result.fileStorage.FileContent) {
                    DownloadBase64File(result.fileStorage.FileContent, $scope.DataObject.UserInvoice.SelectedFileName.FileName + '.pdf', 'application/pdf');
                    $('#NoInvoiceFoundModal').modal('hide');
                } else {
                    $scope.DataObject.NoInvoiceFound.ErrorMessage = 'No transactions found for this period to generate an invoice from.';
                }
            }, function () {
                toastr.error('Unable to generate the invoice PDF. Please try again.', 'Error');
            });
        };

        $scope.OnDownloadAllInvoicesClicked = function () {
            PaymentContractService.GetAllUserInvoicePDFs(GetCurrentDownloadRequest()).then(function (results) {
                if (results && results.length > 0) {
                    _.each(results, function (result, index) {
                        if (result && result.fileStorage && result.fileStorage.FileContent) {
                            $timeout(function () {
                                DownloadBase64File(result.fileStorage.FileContent, $scope.DataObject.UserInvoice.SelectedFileName.FileName + '-' + (index + 1) + '.pdf', 'application/pdf');
                            }, index * 500);
                        }
                    });
                    $('#NoInvoiceFoundModal').modal('hide');
                } else {
                    $scope.DataObject.NoInvoiceFound.ErrorMessage = 'No PDFs exist yet for this period.';
                }
            }, function () {
                toastr.error('Unable to download the invoice PDFs. Please try again.', 'Error');
            });
        };

        function b64toBlob(dataURI, fileType) {
            var byteString = atob(dataURI);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: fileType });
        }

        function DownloadBase64File(data, fileName, contentType) {
            try {
                var linkElement = document.createElement('a');
                var blob = b64toBlob(data, contentType);
                var url = URL.createObjectURL(blob);
                var parser = new UAParser();
                var browserName = parser.getBrowser().name;
                if (browserName != null && browserName.toUpperCase() == "IE") {
                    window.navigator.msSaveBlob(blob, fileName);
                }
                else {
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
                    var clickEvent = new MouseEvent("click", {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        vm.$onChanges = function (changes) {
            console.log("$onChanges paymentInvoiceHistory changes", changes);
        };
        vm.$onDestroy = function () {
            console.log('Destory paymentInvoiceHistory');
        }
        vm.$onInit = function () {
            console.log("$onInit paymentInvoiceHistory");
            $q.all([
                GetUserInvoice()
            ]).then(function (data) {
                initGrid().then(function () {
                    $scope.DataObject.UserInvoice.InvoiceList = data[0];
                    if ($scope.DataObject.UserInvoice.InvoiceList && $scope.DataObject.UserInvoice.InvoiceList.length > 0) {
                        $scope.DataObject.UserInvoice.SelectedFileName = $scope.DataObject.UserInvoice.InvoiceList[0];
                        $scope.OnFileNameSelected();
                    }
                });
            });
        }

        function GetUserInvoice() {
            var d = $q.defer();
            PaymentContractService.GetUserInvoice({
                ProviderName: $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName
            }).then(function (result) {
                d.resolve(result);
            });
            return d.promise;
        }

        function GetUserInvoiceDetail() {
            var d = $q.defer();
            PaymentContractService.GetUserInvoiceDetail({
                ProviderName: $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName,
                UserID: $sessionStorage.currentUserData.userId,
                FileName: $scope.DataObject.UserInvoice.SelectedFileName.FileName
            }).then(function (result) {
                d.resolve(result);
            });
            return d.promise;
        }

        $scope.OnFileNameSelected = function () {
            GetUserInvoiceDetail().then(function (result) {
                var TotalWorkRVU = 0;
                var TotalPayAmount = 0;
                var TotalCount = 0;
                _.each(result, function (invoice) {
                    invoice.SignDate = moment(invoice.SignDate).format('MM-DD-YYYY');
                    TotalWorkRVU = TotalWorkRVU > 0 ? TotalWorkRVU + invoice.WorkRVU : invoice.WorkRVU;
                    TotalPayAmount = TotalPayAmount > 0 ? TotalPayAmount + invoice.PayAmount : invoice.PayAmount;
                    if (invoice.TransactionTypeID != 2) {
                        TotalCount = TotalCount > 0 ? TotalCount + 1 : 1;
                    }
                });
                $scope.DataObject.UserInvoiceDetail.InvoiceList = result;
                DerivePaymentAccountOptions(result);
                UpdateDownloadButtonState();
                var timeout = $timeout(function () {
                    if (InvoiceSummaryGridOption && InvoiceSummaryGridOption.api) {
                        InvoiceSummaryGridOption.api.destroy();
                        var gridDiv = document.getElementById("InvoiceSummaryAGGrid");
                        if (gridDiv) { new agGrid.Grid(gridDiv, InvoiceSummaryGridOption); }

                        var row = {
                            ispinnedData: true,
                            "SignDate": "Period Totals",
                            "Modality": "Period Totals",
                            "WorkRVU": TotalWorkRVU,
                            "TotalCount": TotalCount,
                            "PayAmount": TotalPayAmount,
                        }
                        InvoiceSummaryGridOption.api.setPinnedBottomRowData([row]);

                    }
                    if (InvoiceTransactionGridOption && InvoiceTransactionGridOption.api) {
                        InvoiceTransactionGridOption.api.setRowData($scope.DataObject.UserInvoiceDetail.InvoiceList);

                        var row = {
                            "SignDateTime": "Payout Totals",
                            "Modality": null,
                            "WorkRVU": TotalWorkRVU,
                            "PayAmount": TotalPayAmount,
                        }
                        InvoiceTransactionGridOption.api.setPinnedBottomRowData([row]);
                    }
                    $timeout.cancel(timeout);
                    timeout = null;
                    $scope.OnPaymentAccountSelected();
                }, 100);
            });
        }
        var InvoiceSummaryColDef = [
            {
                field: "SignDate",
                headerName: "Signed Date",
                rowGroup: true,
                hide: true,
            },
            {
                field: "Modality",
                rowGroup: true,
                hide: true,
            },
            {
                field: "WorkRVU",
                headerName: "Total wRVU",
                flex: 1,
                cellRenderer: function (params) {
                    if (params.value) {
                        return params.value.toFixed(2);
                    }
                },
                aggFunc: "sum"
            },
            {
                field: "TotalCount", headerName: 'Total Count',
                cellRenderer: function (params) {
                    if (params.value) {
                        return params.value;
                    }
                    else {
                        var ChildNodes = [];
                        if (params.node) {
                            ChildNodes = _.filter(params.node.allLeafChildren, function (child) {
                                return child.data.TransactionTypeID != 2;
                            });
                        }
                        return (ChildNodes) ? ChildNodes.length : 0;
                    }
                },
            }, // Count occurrences
            {
                field: "PayAmount",
                headerName: "Total Payout",
                flex: 1,
                cellRenderer: function (params) {
                    if (params.value) {
                        return "$" + params.value.toFixed(2);
                    }
                },
                aggFunc: "sum"
            },
        ];
        var InvoiceSummaryGridOption = {
            columnDefs: InvoiceSummaryColDef,
            rowHeight: 36,
            defaultColDef: {
                sortable: false,
                lockVisible: true,
                suppressMovable: true,
                suppressMenu: true,
                suppressContextMenu: true,
                resizable: true,
            },
            autoGroupColumnDef: {
                headerName: 'Period - Modality',
                width: 150,
                cellRendererParams: {
                    suppressCount: true,
                },
                cellRendererSelector: function (params) {
                    return null;
                },
                cellRenderer: function (params) {
                    if (params.data && params.data.ispinnedData) {
                        return params.data.SignDate;
                    }
                    return params.value;
                },
                cellStyle: function (params) {
                    var obj = {}
                    obj.textAlign = 'center';
                    return obj;
                },
            },
            groupDisplayType: "singleColumn",
            groupDefaultExpanded: 1,
            groupSuppressBlankHeader: true,
            suppressAggFuncInHeader: true,
            grandTotalRow: "bottom",
            onGridReady: function () {
                InvoiceSummaryGridOption.api.setRowData($scope.DataObject.UserInvoiceDetail.InvoiceList);
            },
            overlayNoRowsTemplate: '<span class="fs-16px txt-clr-1 text-center">No Data Available</span>',
        };
        var InvoiceTransactionColDef = [
            {
                field: "SignDateTime",
                headerName: "Sign Date",
                initialWidth: 150,
                filter: 'agDateColumnFilter',
                valueFormatter: function (params) {
                    if (params.value) {
                        return $filter('localDate')(params.value, false, new Date());
                    }
                },
            },
            {
                field: "Modality",
                initialWidth: 100,
                filter: 'agSetColumnFilter',
                filterParams: {
                    defaultToNothingSelected: true
                }
            },
            {
                field: "Accession",
                headerName: "Accession",
                initialWidth: 120,
                filter: 'agTextColumnFilter',
            },
            {
                field: "ProcedureDesc",
                headerName: "Description",
                flex: 1,
                filter: 'agTextColumnFilter',
                cellRenderer: function (params) {
                    if ((params.value) || (params.node.data && params.node.data.Remarks)) {
                        return params.node.data && params.node.data.Remarks ? params.node.data.Remarks : params.value;
                    }
                },
            },
            {
                field: "WorkRVU",
                headerName: "wRVU",
                initialWidth: 100,
                filter: "agNumberColumnFilter",
                cellRenderer: function (params) {
                    if (params.value) {
                        return params.value.toFixed(2);
                    }
                },
            },
            {
                field: "PayAmount",
                headerName: "Payout",
                initialWidth: 100,
                filter: "agNumberColumnFilter",
                cellRenderer: function (params) {
                    if (params.value) {
                        return "$" + params.value.toFixed(2);
                    }
                },
            }
        ];
        function DefaultTransactionExportParams(params) {
            if (params.column.colId === "ProcedureDesc" && params.node && params.node.data && params.node.data.Remarks) {
                return params.node.data.Remarks;
            }
            if (params.column.colId === "SignDateTime" && params.value) {
                return $filter('localDate')(params.value, false, new Date());
            }
            return params.value;
        }
        var InvoiceTransactionGridOption = {
            columnDefs: InvoiceTransactionColDef,
            rowHeight: 36,
            defaultColDef: {
                sortable: true,
                lockVisible: true,
                /*suppressMenu: true,*/
                resizable: true,
                menuTabs: ["filterMenuTab"],
            },
            defaultExcelExportParams: {
                processCellCallback: function (params) {
                    return DefaultTransactionExportParams(params);
                }
            },
            defaultCsvExportParams: {
                processCellCallback: function (params) {
                    return DefaultTransactionExportParams(params);
                }
            },
            grandTotalRow: "bottom",
            onGridReady: function () {
                InvoiceTransactionGridOption.api.setRowData([]);
            },
            overlayNoRowsTemplate: '<span class="fs-16px txt-clr-1 text-center">No Data Available</span>',
        }

        function initGrid() {
            var d = $q.defer();
            var timeout = $timeout(function () {
                var gridDiv = document.getElementById("InvoiceSummaryAGGrid");
                if (gridDiv) { new agGrid.Grid(gridDiv, InvoiceSummaryGridOption); }

                var gridDiv = document.getElementById("InvoiceTransactionAGGrid");
                if (gridDiv) { new agGrid.Grid(gridDiv, InvoiceTransactionGridOption); }

                $timeout.cancel(timeout);
                timeout = null;
                d.resolve();
            }, 200);
            return d.promise;
        }
    };

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('pdfViewer', {
            templateUrl: 'app/theme/components/pdf-viewer/pdf-viewer.html',
            transclude: true,
            bindings: {
                fileBinaryContent: '<',  // use for download data
                fileUrl: '<',
                sendFax: '&',
                selectedOrder: '<'
            },
            controller: PDFViewerController
        }).directive('ngMouseWheelUp', function () {
            return function (scope, element, attrs) {
                element.bind("DOMMouseScroll mousewheel onmousewheel", function (event) {
                    // cross-browser wheel delta
                    var event = window.event || event; // old IE support
                    var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

                    if (delta > 0) {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngMouseWheelUp);
                        });

                        // for IE
                        event.returnValue = false;
                        // for Chrome and Firefox
                        if (event.preventDefault) event.preventDefault();
                    }
                });
            };
        }).directive('ngMouseWheelDown', function () {
            return function (scope, element, attrs) {
                element.bind("DOMMouseScroll mousewheel onmousewheel", function (event) {

                    // cross-browser wheel delta
                    var event = window.event || event; // old IE support
                    var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

                    if (delta < 0) {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngMouseWheelDown);
                        });

                        // for IE
                        event.returnValue = false;
                        // for Chrome and Firefox
                        if (event.preventDefault) event.preventDefault();
                    }
                });
            };
        });



    /** @ngInject */
    function PDFViewerController($scope, $sce, APP_CONSTANTS, __env, $sessionStorage, pdfJsLoader) {
        var vm = this;
        var printWindow = null;

        vm.$onChanges = function (changes) {
            vm.fileBinaryContent = changes.fileBinaryContent.currentValue;
            vm.fileUrl = changes.fileUrl.currentValue;
            init();
        };

        function init() {
            getFile();
        }
        function getFile() {
            pdfJsLoader.ensureLoaded().then(function () {
                    var pdfViewer = $("#pdfViewer").data("kendoPDFViewer");
                    if (!pdfViewer) {
                        pdfViewer = $("#pdfViewer").kendoPDFViewer({
                            pdfjsProcessing: {
                                file: {
                                    data: vm.fileBinaryContent
                                }
                            },
                            width: "100%",
                            height: "100%",
                            toolbar: {
                                items: [
                                    "pager", "spacer", "zoom", "toggleSelection", "spacer", "search", "download",
                                    {
                                        name: "print",
                                        template: "<a id='printKendoPDF' class=\"k-flat k-button k-button-icon k-toolbar-last-visible\"><span class=\"k-icon k-i-print\"></span></a>"
                                    },
                                    {
                                        template: "<a id='sendReportFax' class=\"k-flat k-button k-button-icon k-toolbar-last-visible\" title='Send Fax' style='display:none;'><span class=\"fa fa-fax\"></span></a>"
                                    },
                                ]
                            },
                        }).data("kendoPDFViewer");
                    }
                    pdfViewer.bind("render", function () {
                        $('#pdfViewer a[aria-label="Download"]').click(function () {
                            $(window).off('resize');
                        });

                        var printKendoPDFbtn = document.getElementById("printKendoPDF");
                        if (printKendoPDFbtn) {
                            printKendoPDFbtn.addEventListener('click', function (event) {
                                printPDF();
                            });
                        }
                        var sendReportFaxbtn = document.getElementById("sendReportFax");
                        if (sendReportFaxbtn) {
                            if (($sessionStorage.currentUserData.userRoles.includes("Technologist") || $sessionStorage.currentUserData.userRoles.includes("Admin") || $sessionStorage.currentUserData.userRoles.includes("SuperAdmin")) && (vm.selectedOrder && vm.selectedOrder.IsEnableFax)) {
                                sendReportFaxbtn.style.display = "block";
                                sendReportFaxbtn.addEventListener('click', function (event) {
                                    vm.sendFax();
                                });
                            }
                        }
                    })
                });
        }
        function printPDF() {
            if (vm.fileUrl && vm.fileUrl != "") {
                var windowFeatures = "width=" + screen.availWidth + ",height=" + screen.availHeight +
                    ",top=0,left=0,fullscreen=yes";
                if (!printWindow || printWindow.closed) {
                    printWindow = window.open(vm.fileUrl, 'PDFViewer', windowFeatures);
                }
                printWindow.focus();
            }
        }
    }
}());

(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('procedureCptMapping', {
            templateUrl: 'app/theme/components/procedure-cpt-mapping/procedure-cpt-mapping.html',
            bindings: {
                onMap: '&',
            },
            controller: procedureCptMappingController
        });

    /** @ngInject */
    function procedureCptMappingController($scope, $timeout, $q, MappingService, toaster, $sessionStorage) {
        var vm = this;
        var ProcedureList = [];
        var CPTList = [];

        $scope.ProcSearchKey = null;
        $scope.CPTSearchKey = null;

        vm.$onInit = function () {
            $timeout(function () {
                var ProcGridDiv = document.querySelector('#ProcGrid');
                new agGrid.Grid(ProcGridDiv, ProcGridOptions);
                $scope.GetProcedureList();

                var CPTGridDiv = document.querySelector('#CPTGrid');
                new agGrid.Grid(CPTGridDiv, CPTGridOptions);
                $scope.GetCPTList();
            }, 200)
        }
        vm.$onChanges = function () {
        }
        vm.$onDestroy = function () {
        }

        var ProcGridOptions = {
            columnDefs: [
                { field: 'Select', headerName: '', checkboxSelection: true, minWidth: 40, maxWidth: 40, headerCheckboxSelection: true, headerTooltip: 'Select All', },
                { field: 'ProcedureCode', headerName: 'Procedure Code', initialWidth: 120, headerTooltip: 'Procedure Code', },
                { field: 'ProcedureDesc', headerName: 'Procedure Description', tooltipField: 'ProcedureDesc', flex: 1, },
            ],
            defaultColDef: {
                resizable: true,
                lockVisible: true,
                menuTabs: ['generalMenuTab'],
            },
            enableBrowserTooltips: true,
            suppressRowClickSelection: true,
            rowSelection: 'multiple',
            getContextMenuItems: getContextMenuItems,
            onCellClicked: function (params) {
                params.node.setSelected(true);
            },
        }
        var CPTGridOptions = {
            columnDefs: [
                { field: 'Select', headerName: '', checkboxSelection: true, minWidth: 40, maxWidth: 40, headerCheckboxSelection: true, headerTooltip: 'Select All', },
                { field: 'CPT_Code', headerName: 'CPT Code', initialWidth: 120, headerTooltip: 'CPT Code', },
                { field: 'CPT_Description', headerName: 'CPT Description', tooltipField: 'CPT_Description', flex: 1, },
                { field: 'workrvu', headerName: 'wRVU', initialWidth: 80, headerTooltip: 'wRVU', },
            ],
            defaultColDef: {
                resizable: true,
                lockVisible: true,
                menuTabs: ['generalMenuTab'],
            },
            enableBrowserTooltips: true,
            suppressRowClickSelection: true,
            rowSelection: 'multiple',
            getContextMenuItems: getContextMenuItems,
            onCellClicked: function (params) {
                params.node.setSelected(true);
            }
        }
        function getContextMenuItems(params) {
            var ContextMenuItems = [];
            if (params.column.colId == "ProcedureDesc") {
                var ProcSelectedRows = ProcGridOptions.api.getSelectedRows();
                if (ProcSelectedRows.length > 0) {
                    ContextMenuItems.push({
                        name: 'Deselect All',
                        action: function () {
                            if (ProcGridOptions && ProcGridOptions.api) {
                                ProcGridOptions.api.deselectAll();
                            }
                        },
                    });
                }
            } else {
                var CPTSelectedRows = CPTGridOptions.api.getSelectedRows();
                if (CPTSelectedRows.length > 0) {
                    ContextMenuItems.push({
                        name: 'Deselect All',
                        action: function () {
                            if (CPTGridOptions && CPTGridOptions.api) {
                                CPTGridOptions.api.deselectAll();
                            }
                        },
                    });
                }
            }
            return ContextMenuItems;
        }

        $scope.GetProcedureList = function () {
            var d = $q.defer();
            if (ProcGridOptions && ProcGridOptions.api) {
                ProcGridOptions.api.deselectAll();

                var Filter = {
                    Search: $scope.ProcSearchKey
                };
                MappingService.GetProcedure(Filter).then(function (result) {
                    ProcedureList = result;
                    ProcGridOptions.api.setRowData(ProcedureList);
                    d.resolve();
                });
            }
            return d.promise;
        }

        $scope.GetCPTList = function () {
            var d = $q.defer();
            if (CPTGridOptions && CPTGridOptions.api) {
                CPTGridOptions.api.deselectAll();
                var Filter = {
                    Search: $scope.CPTSearchKey
                };
                MappingService.GetCPTList(Filter).then(function (result) {
                    CPTList = result;
                    CPTGridOptions.api.setRowData(CPTList);
                    d.resolve();
                });
            }
            return d.promise;
        }
        $scope.clearProcSearch = function () {
            $scope.ProcSearchKey = null;
            $scope.GetProcedureList();
        }
        $scope.clearCPTSearch = function () {
            $scope.CPTSearchKey = null;
            $scope.GetCPTList();
        }

        $scope.SaveCPTProcedureMap = function () {
            var ProcSelectedRows = ProcGridOptions.api.getSelectedRows();
            var CPTSelectedRows = CPTGridOptions.api.getSelectedRows();

            if (ProcSelectedRows.length > 0 && CPTSelectedRows.length > 0) {
                var ProcedureIDs = []
                var CPTCodes = [];

                _.each(ProcSelectedRows, function (Proc) {
                    ProcedureIDs.push({ ProcedureID: Proc.ProcedureID });
                });
                _.each(CPTSelectedRows, function (CPT) {
                    CPTCodes.push({ CPTCode: CPT.CPT_Code });
                });
                var param = {
                    CPTCodes: CPTCodes,
                    ProcedureIDs: ProcedureIDs,
                    UserID: $sessionStorage.currentUserData.userId
                };
                MappingService.AddCPTProcedureMapping(param).then(function (result) {
                    toaster.success({ body: result });
                    if (result.match('success')) {
                        if (CPTGridOptions && CPTGridOptions.api) {
                            CPTGridOptions.api.deselectAll();
                        }
                        if (ProcGridOptions && ProcGridOptions.api) {
                            ProcGridOptions.api.deselectAll();
                        }
                        $('#ModalMapCPTProcedure').modal('hide');
                        vm.onMap();
                    }

                });
            } else {
                toaster.warning({ body: "Please select Procedure and CPT." });
            }

           
        };
    }
})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('radLocation', {
            templateUrl: 'app/theme/components/rad-location/rad-location.html',
            bindings: {
                locationId: '@',
                locationSearchTextId: '@',
                options: '<',
                selectedValues: '<',
                onUpdate: '&',
            },
            controller: RadLocationController
        });

    /** @ngInject */
    function RadLocationController($log, $timeout, $scope) {
        var vm = this;
        var dropdowntree = undefined;
        var timeoutList = [];

        $scope.locationtooltip = "Select a Site";
        $scope.options = [];
        $scope.kOptions = {};

        vm.$onChanges = function (changes) {
            if (changes.options && changes.options.currentValue) {
                $scope.options = changes.options.currentValue;
                setDS();
            }
            if (changes.selectedValues && changes.selectedValues.currentValue) {
                vm.selectedValues = changes.selectedValues.currentValue;
                var filterTimeout = $timeout(function () {
                    setSelectedLocationFilterSettings();
                }, 100);
                timeoutList.push(filterTimeout);
            }

            var tooltipTimeout = $timeout(function () {
                setLocationtooltip();
            }, 100);
            timeoutList.push(tooltipTimeout);

        }
        vm.$onDestroy = function () {
            if (dropdowntree) dropdowntree.destroy();
            _.each(timeoutList, function (tout) { $timeout.cancel(tout); });
        }
        vm.$onInit = function () {
            loadDropDown();

            var initTimeout = $timeout(function () {
                dropdowntree = $("#" + vm.locationId).data("kendoDropDownTree");

                setDS();

                setSelectedLocationFilterSettings();
                setLocationtooltip();
            }, 100);
            timeoutList.push(initTimeout);
        }

        function loadDropDown() {
            $scope.kOptions = {
                autoClose: false,
                checkAll: true,
                checkboxes: {
                    checkChildren: true,
                    template:
                        "# if (item.level() > 0) { #" +
                        "<input type='checkbox' #= item.checked ? 'checked' : '' #>" +
                        "# } #",
                },
                dataSource: $scope.options,
                dataTextField: "text",
                dataValueField: "value",
                height: "auto",
                loadOnDemand: false,
                placeholder: $scope.locationtooltip,
                headerTemplate: '<span class="k-list-filter"><input id="' + vm.locationSearchTextId + '" class="k-textbox" role="listbox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-disabled="false" autocomplete="off"/><span class="k-icon k-i-zoom"></span></span>',
                open: function (e) {
                    //$log.log("loadDropDown > open > on: ", new Date());
                    //$log.log("loadDropDown > object: ", $("#" + vm.locationSearchTextId));
                    $("#" + vm.locationSearchTextId).change(refreshTree).keyup(refreshTree);
                    $timeout(function () {
                        //$log.log("loadDropDown > open > focus > on: ", new Date());
                        $("#" + vm.locationSearchTextId).focus();
                    }, 1500);
                },
                change: function (e) {
                    //$log.log("loadDropDown > change > on: ", new Date());
                    ClearAll();
                    var nodes = e.sender.dataSource.view();

                    var checkedNodes = e.sender.value();
                    var values = checkedNodeValues(nodes, checkedNodes);

                    //$log.log("loadDropDown > change > values: ", values);
                    var locations = [];
                    if (values && values.length > 0) {
                        _.each($scope.options, function (option) {
                            _.each(values, function (data) {
                                var filter = _.find(option.items, function (item) { return item.value == data; });
                                if (filter != null) {
                                    locations.push(filter);
                                }
                            });
                        });

                        vm.selectedValues.SelectedItems = locations;
                        setLocationtooltip();
                    } else {
                        vm.selectedValues.SelectedItems = [];
                        $scope.locationtooltip = 'Select a Site';
                        $("#" + vm.locationId + "Tooltip").html($scope.locationtooltip);
                    }
                    vm.onUpdate();
                },
                close: function (e) {
                    //$log.log("loadDropDown > close > on: ", new Date());
                    clearLocation();
                },
            };
        }

        function setLocationtooltip() {
            if (vm.locationId.includes('radioLogist')) {
                $scope.locationtooltip = 'Select a Site';
            }
            if (vm.selectedValues.SelectedItems && vm.selectedValues.SelectedItems.length > 0) {
                var tooltipText = [];
                $scope.locationtooltip = '';
                _.each(vm.selectedValues.SelectedItems, function (data) {
                    tooltipText.push(data.text);
                });
                $scope.locationtooltip = _.join(tooltipText, '\n');
            }
            else {
                $scope.locationtooltip = "Select a Site";
            }
            $("#" + vm.locationId + "Tooltip").html($scope.locationtooltip);
            
        }

        function refreshTree() {
            if (dropdowntree) {
                var tree = dropdowntree.treeview;
                var dataSource = dropdowntree.dataSource;
                var value = $("#" + vm.locationSearchTextId).val();
                if (value !== "") {
                    dataSource.filter({
                        field: "text", //if I would use "ChildrenText" here nothing be displayed at all if filtertext is set
                        operator: "contains",
                        value: $("#" + vm.locationSearchTextId).val()
                    });

                    //filtering child node
                    if (dataSource.view() && dataSource.view().length > 0) {
                        for (var i = 0; i < dataSource.view().length; i++) {
                            if (dataSource.view()[i].hasChildren) {
                                dataSource.view()[i].children.filter({
                                    field: "text",
                                    operator: "neq",
                                    value: true
                                })
                            }
                        }
                    }

                    $timeout(function () {
                        tree.expand(".k-item");
                    }, 200);
                } else {
                    dataSource.filter({});

                    $timeout(function () {
                        tree.collapse(".k-item");
                    }, 200);
                }
                angular.element(document).ready(function () {
                    angular.element('.k-item').mouseenter(function () {
                        if (tree) {
                            tree.focus();
                        }
                    });

                });
            }

        }

        function ClearAll() {
            $(".k-check-all").on("click", function () {

                if ($('.k-checkbox').is(':checked') == false) {

                    vm.selectedValues.SelectedItems = [];
                    $scope.locationtooltip = 'Select a Site';
                    $("#" + vm.locationId + "Tooltip").html($scope.locationtooltip);
                    $('.k-multiselect-wrap li').remove();
                }
            })
        }

        function checkedNodeValues(nodes, checkedNodes) {
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && !nodes[i].hasChildren) {
                    if (checkedNodes.indexOf(nodes[i].value) < 0) {
                        checkedNodes.push(nodes[i].value);
                    }
                }
                if (nodes[i].hasChildren) {
                    checkedNodeValues(nodes[i].children.view(), checkedNodes);
                }
            }
            return checkedNodes;
        }

        function clearLocation() {
            $("#" + vm.locationSearchTextId).val('');
            if (dropdowntree) {
                var tree = dropdowntree.treeview;
                var dataSource = dropdowntree.dataSource;
                if (dataSource) dataSource.filter({});
                if (tree) tree.collapse(".k-item");
            }

        }

        function setSelectedLocationFilterSettings() {
            if (dropdowntree) {
                dropdowntree.value(vm.selectedValues.SelectedItems);
            }

        }

        function setDS() {
            if (dropdowntree) {
                var options = dropdowntree.options;
                if (options.dataSource.length == 0) {
                    var dataSource = new kendo.data.HierarchicalDataSource({
                        data: $scope.options
                    });
                    dropdowntree.setDataSource(dataSource);
                }
            }


        }
    }
}());
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('radiologistListCmp', {
            templateUrl: 'app/theme/components/radiologist-list-cmp/radiologist-list-cmp.html',
            bindings: {
                radiologists: '<',
                selectedRadiologists: '<',
                onSelectRadiologist: '&',
                siteTitle: '<',
                modalTitle: '@',
                btnText: '<',
                onCancel: '&',
                paymentContract: '<',
                paymentSubContract: '<',
                radioLogistCmpTooltipId: '@',
            },
            controller: RadiologistListController
        });

    /** @ngInject */
    function RadiologistListController($scope, $log, TechnoService, $sessionStorage, $timeout, $filter, $rootScope, filterFilter, RuleService, $q, PaymentContractService) {

        var vm = this;
        var locationIDs = '';
        var Filterflag = false;
        var RadiologistsFilterList = [];
        var NoRadiologistFound = false;
        $scope.selectedRadiologists = [];
        $scope.RadiologistsFullSet = [];
        $scope.AllowedUser = [];
        $scope.isLoading = false;
        $scope.MasterData = { Radiologists: null, Sites: null, Locations: null };
        $scope.selectedclientsFullSet = [];
        $scope.selectedclients = [];
        $scope.Radiologists = [];
        $scope.search = '';
        $scope.searchclient = '';
        $scope.radiologistSearchOperatorTooltip = 'Select a Site';
        $scope.SelectedData = { Location: null, locationIDs: null, TenantIDs: null, SiteIDs: null, Sites: null };
        $scope.siteTitle = '';
        $scope.isSaveRadiologistOption = false;
        $scope.show = false;
        $scope.SelectedSiteValues = { SelectedItems: [] };
        vm.$onChanges = function (changes) {
            $log.log("$onInit radiologistListCmp changes", changes);
            $scope.Radiologists = changes.radiologists ? changes.radiologists.currentValue : vm.radiologists;
            $scope.RadiologistsFullSet = changes.radiologists ? changes.radiologists.currentValue : vm.radiologists;
            $scope.selectedRadiologists = changes.selectedRadiologists ? changes.selectedRadiologists.currentValue : vm.selectedRadiologists;
            $scope.selectedclientsFullSet = changes.selectedClientsFullSet ? changes.selectedClientsFullSet.currentValue : vm.selectedClientsFullSet;
            $scope.siteTitle = changes.siteTitle ? changes.siteTitle.currentValue : vm.siteTitle;
            $scope.modalTitle = changes.modalTitle ? changes.modalTitle.currentValue : vm.modalTitle;
            $scope.btnText = changes.btnText ? changes.btnText.currentValue : vm.btnText;
            $scope.PaymentContractType = changes.paymentContract ? changes.paymentContract.currentValue : vm.paymentContract;
            $scope.PaymentSubContractType = changes.paymentSubContract ? changes.paymentSubContract.currentValue : vm.paymentSubContract;
            $scope.GetAllRadiologists();
            $scope.search = '';
            $("#" + vm.radioLogistCmpTooltipId).html($scope.radiologistSearchOperatorTooltip);
        };
        vm.$onDestroy = function () {
            $log.log('Destory radiologistListCmp');
        }
        vm.$onInit = function () {
            $log.log("$onInit radiologistListCmp");
            $scope.Radiologists = vm.radiologists;
            $scope.RadiologistsFullSet = vm.radiologists;
            $scope.selectedRadiologists = vm.selectedRadiologists;
            $scope.siteTitle = vm.siteTitle;
            $scope.modalTitle = vm.modalTitle;
            $scope.PaymentContractType = vm.paymentContract;
            $scope.PaymentSubContractType = vm.paymentSubContract;
            GetSitesAndLocation();
            $scope.search = '';
            $("#" + vm.radioLogistCmpTooltipId).html($scope.radiologistSearchOperatorTooltip);
        }
        function selectedRadiologists() {
            var radList = []
            angular.copy($scope.selectedRadiologists, radList);
            return radList;
        }
        function radiologistsFullSet() {
            var radiologists = [];
            if ($scope.AllowedUser.length == 0) {
                angular.copy($scope.RadiologistsFullSet, radiologists);
            } else {
                angular.copy($scope.AllowedUser, radiologists);
            }
            return radiologists;
        }
        $scope.ShowMainLoader = function () {
            $scope.isLoading = true;
        }
        $scope.HideMainLoader = function () {
            $scope.isLoading = false;
        }

        $scope.moveItem = function (items, from, to) {
            //console.log('Move item   Item: ' + item + ' From:: ' + from + ' To:: ' + to);
            //Here from is returned as blank and to as undefined
            if (!items || items.length == 0) {
                $scope.available = null;
                $scope.selected = null;
            }
            angular.forEach(items, function (item) {
                var idx = _.findIndex(from, { 'Id': item.Id });
                if (idx != -1) {
                    from.splice(idx, 1);
                    to.push(item);
                }
            });
            $scope.filterRadiologist();
            $scope.filterselectedclients();
        };
        $scope.moveAll = function (from, to) {
            //console.log('Move all  From:: ' + from + ' To:: ' + to);
            //Here from is returned as blank and to as undefined
            angular.forEach(from, function (item) {
                to.push(item);
            });
            from.length = 0;
        };

        $scope.Save = function () {
            vm.onSelectRadiologist();
            $scope.cancel(false);
        };

        $scope.cancel = function (cancelFlag) {
            $scope.search = '';
            if (cancelFlag) { vm.onCancel(); }
            $scope.SelectedData = { Location: null, locationIDs: null, TenantIDs: null, SiteIDs: null, Sites: null };
            $scope.SelectedSiteValues = { SelectedItems: [] };
            $scope.filter();
        };

        $scope.GetAllRadiologists = function () {
            $scope.RadiologistsFullSet = radiologistsFullSet();
            $scope.selectedclientsFullSet = $scope.selectedRadiologists;
            if ($scope.selectedRadiologists != null && $scope.selectedRadiologists.length > 0) {
                angular.forEach($scope.selectedRadiologists, function (item) {
                    var obj = filterFilter($scope.RadiologistsFullSet, {
                        Id: item.Id
                    })[0];
                    var idx = $scope.RadiologistsFullSet.indexOf(obj);
                    if (idx != -1) {
                        $scope.RadiologistsFullSet.splice(idx, 1);
                    }
                });
            }
            $scope.filterRadiologist();
            $scope.filterselectedclients();
        }

        $scope.filterRadiologist = function () {
            if (NoRadiologistFound) {
                $scope.Radiologists = [];
            }
            else if (RadiologistsFilterList.length > 0) {
                $scope.Radiologists = [];
                _.each(RadiologistsFilterList, function (rad) {
                    var idx = _.findIndex($scope.RadiologistsFullSet, { 'Id': rad.Id });
                    if (idx != -1) {
                        $scope.Radiologists.push(_.filter($scope.RadiologistsFullSet, function (obj) {
                            return obj.Id == rad.Id;
                        })[0]);
                    }
                });
            }
            else {
                $scope.Radiologists = $scope.RadiologistsFullSet;
            }
            $scope.Radiologists = _.sortBy($scope.Radiologists, function (obj) { return obj.FirstName + ' ' + obj.LastName; });
        }

        $scope.filterselectedclients = function () {
            $scope.selectedclients = $scope.selectedclientsFullSet;
            $scope.selectedclients = _.sortBy($scope.selectedclients, function (obj) { return obj.FirstName + ' ' + obj.LastName; });
        }
        function GetSitesAndLocation() {
            var filter = {
                UserID: $sessionStorage.currentUserData.userId,
            }
            PaymentContractService.GetTenantsAndSiteAndLocation(filter).then(function (result) {
                $scope.MasterData.Locations = _.filter(result, function (obj) { return obj.SiteID != 0; });
                //$log.log("Locations > ", $scope.MasterData.Locations);
                var siteIDs = [], tenantsIDs = [];
                _.each($scope.MasterData.Locations, function (value, index) {
                    tenantsIDs.push(value.TenantID);
                    _.each(value.Sites, function (site) {
                        if ($.inArray(site, siteIDs) == -1) {
                            siteIDs.push(site.SiteID);
                        }
                    });

                });

                var localTenants = [];
                for (var parent = 0; parent < tenantsIDs.length; parent++) {
                    var child = 0;
                    var itemTenant = {};
                    var localSites = [];
                    for (var j = 0; j < $scope.MasterData.Locations[parent].Sites.length; j++) {
                        for (var k = 0; k < siteIDs.length; k++) {
                            if (siteIDs[k] == $scope.MasterData.Locations[parent].Sites[j].SiteID) {

                                itemTenant["text"] = $scope.MasterData.Locations[parent].TenantName;
                                itemTenant["parent"] = parent;

                                var itemSite = {}
                                itemSite["text"] = $scope.MasterData.Locations[parent].Sites[j].Site;
                                itemSite["value"] = $scope.MasterData.Locations[parent].Sites[j].SiteID;

                                itemSite["role"] = $scope.userRole;
                                itemSite["parent"] = parent;
                                localSites.push(itemSite);

                                itemTenant["items"] = localSites
                            }
                        }
                    }
                    localTenants.push(itemTenant);
                }
                $scope.MasterData.Sites = localTenants;
            })
        };

        $scope.filter = function () {
            var filter = {
                Search: $scope.search,
                UserID: $sessionStorage.currentUserData.userId,
                TenantSiteIDs: $scope.SelectedData.TenantIDs ? $scope.SelectedData.TenantIDs : null,
                PaymentContract: $scope.PaymentContractType ? $scope.PaymentContractType : null,
                PaymentSubContract: $scope.PaymentSubContractType ? $scope.PaymentSubContractType : null,
            };
            RuleService.GetAllUserByTenant(filter).then(function (result) {
                RadiologistsFilterList = result;
                RadiologistsFilterList = _.sortBy(RadiologistsFilterList, function (obj) { return obj.FirstName + ' ' + obj.LastName; });
                if (RadiologistsFilterList.length == 0) { NoRadiologistFound = true; } else { NoRadiologistFound = false; }
                $scope.filterRadiologist();
                $scope.filterselectedclients();
            });

        };

        $scope.GetAllRadiologists();

        $scope.updateLocationData = function () {
            if ($scope.SelectedSiteValues.SelectedItems && $scope.SelectedSiteValues.SelectedItems.length > 0) {
                var sites = [];
                var tenantIDs = [];
                _.each($scope.SelectedSiteValues.SelectedItems, function (data) {
                    _.each($scope.MasterData.Locations, function (tenant) {
                        var site = _.find(tenant.Sites, { "SiteID": data.value });
                        if (site) {

                            sites.push(site);
                            tenantIDs.push({ 'TenantID': tenant.TenantID, 'SiteID': data.value });

                        }
                    });
                });

                $scope.SelectedData.Sites = sites;
                $scope.SelectedData.TenantIDs = tenantIDs;
            } else {
                $scope.SelectedData.Sites = [];
                $scope.SelectedData.TenantIDs = '';
            }
        }
    };


})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('readingProvider', {
            templateUrl: 'app/theme/components/reading-provider/reading-provider.html',
            bindings: {
            },
            controller: readingProviderController
        });

    /** @ngInject */
    function readingProviderController($scope, $sessionStorage, $filter, $q, MappingService, $compile) {

        //#region Variable Declarations
        var vm = this;
        var readingProviderList = [];
        var PageNum = 1;
        var PageSize = 50;
        var TotalRows = 0;
        var FilterUserIds = "";
        var editReadingProviderTimeout;

        $scope.UsersList = [];
        $scope.SelectedUser = { Obj: null };
        $scope.params;
        $scope.showUserDropDown = false;
        $scope.ReadingProviderName = "";
        $scope.SelectedRadiologist = { Obj: null };
        $scope.RadiologistTypeList = [{
            label: 'All',
            value: 'All'
        },
        {
            label: 'Mapped',
            value: 'Mapped'
        },
        {
            label: 'Unmapped',
            value: 'UnMapped'
        },];
        $scope.SelectedRadiologistType = {
            Obj: {
                label: 'Unmapped',
                value: 'UnMapped'
            }
        };
        $scope.ReadingProviderFilterTooltip = "Select Reading Provider";
        //#endregion Variable Declarations

        vm.$onChanges = function (changes) {
        }
        vm.$onDestroy = function () {
            clearData();
            gridOptions.api.destroy();
            clearTimeout(editReadingProviderTimeout);
        }
        vm.$onInit = function () {
            var gridDiv = document.querySelector('#readingProviderGrid');
            new agGrid.Grid(gridDiv, gridOptions);
            getUsersList();

            var pageTopHeight = $(".page-top").height();
            var MappingHeaderHeight = $("#MappingHeader").height();
            var mappingNavHeight = $("#mappingNav").height();
            var readingProviderFilterHeight = 43;
            $scope.gridHeight = $(window).height() - (pageTopHeight + MappingHeaderHeight + mappingNavHeight + readingProviderFilterHeight);
        }
        var columnDefs = [
            {
                field: 'ProviderName', sortable: true,
                checkboxSelection: function () {
                    return ($scope.SelectedRadiologistType.Obj && $scope.SelectedRadiologistType.Obj.label != 'Mapped') ? true : false;
                },
                showDisabledCheckboxes: true,
            },
            {
                field: 'ReadingProvider', headerName: 'Reading Provider',
                editable: true,
                cellEditor: UserEditor(),
                cellEditorPopup: true,
                valueFormatter: function (params) {
                    if (params.data.ReadingProvider) {
                        return params.data.ReadingProvider;
                    }
                }
            },
            { field: 'Edit', cellRenderer: function () { return "<button  title='Edit' class='btn border-0' style='background-color: transparent;'><i class='glyphicon glyphicon-pencil' style='color:#07e6c4 '> </i></button>" } },
            { field: 'Delete', cellRenderer: function () { return "<button title='Delete' class='btn border-0' style='background-color: transparent;'> <i class='fa fa-trash-o fs-17px' style='color:#07e6c4 '></i></button>" } },
        ];
        var gridOptions = {
            columnDefs: columnDefs,
            defaultColDef: {
                sortable: false,
                lockVisible: true,
                flex: 1,
            },
            rowModelType: 'serverSide',
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            cacheBlockSize: PageSize,
            rowHeight: 33,
            sortingOrder: ['desc', 'asc'],
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getRowId: function (params) {
                return params.data.ID;
            },
            onGridReady: function () {
                var fakeServer = createFakeServer();

                // create datasource with a reference to the fake server
                var datasource = createServerSideDatasource(fakeServer);

                // register the datasource with the grid

                gridOptions.api.setServerSideDatasource(datasource);
                gridOptions.columnApi.applyColumnState({ state: [{ colId: 'ProviderName', sort: 'desc' }], });
            },
            onCellClicked: function (params) {
                if (params.column.colId == "Edit") {
                    $scope.showUserDropDown = true;
                    gridOptions.api.startEditingCell({
                        rowIndex: params.rowIndex,
                        colKey: 'ReadingProvider',
                    });
                }
                if (params.column.colId == "Delete") {
                    $scope.MapUser('D', params);
                }
            },
            onSortChanged: function (params) {
                gridOptions.api.showLoadingOverlay();
                resetGrid();
            },
            onCellEditingStopped: function (params) {

                params.node.setSelected(true);

                var result = gridOptions.api.applyServerSideTransaction({
                    update: [
                        {
                            ID: params.data.ID,
                            ProviderName: params.data.ProviderName,
                            ReadingProvider: params.data.ReadingProvider,
                            TotalRows: params.data.TotalRows,
                            UserID: params.data.UserID,
                        }
                    ]
                });

                //$log.log("Update Transaction > ", result);
                $scope.SelectedUser = { Obj: null };

            },
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },

        };

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }

        function createServerSideDatasource(server) {
            return {
                getRows: function (params) {
                    server.getData(params.request).then(function (response) {
                        if (response.success) {
                            params.success({
                                rowData: response.rows,
                                rowCount: response.lastRow,
                            });
                        } else {
                            params.fail();
                        }
                    });
                },
            };
        }
        function createFakeServer() {
            return {
                getData: function (request) {
                    var d = $q.defer();
                    PageNum = _.toInteger(request.endRow / PageSize);
                    var filter = {
                        PageNum: PageNum,
                        PageSize: PageSize,
                        ProviderName: $scope.ReadingProviderName,
                        MappingStatus: $scope.SelectedRadiologistType.Obj.value
                    }
                    if ($scope.SelectedRadiologist.Obj) {
                        FilterUserIds = "";
                        _.each($scope.SelectedRadiologist.Obj, function (radiologist) {
                            if (FilterUserIds == "") {
                                FilterUserIds = radiologist.Id;
                            } else {
                                FilterUserIds = FilterUserIds + "," + radiologist.Id;
                            }
                        })
                        filter.UserIDs = FilterUserIds;
                    }
                    if (request.sortModel.length > 0) {
                        filter.OrderByField = request.sortModel[0].colId;
                        filter.OrderBy = request.sortModel[0].sort;
                    }
                    MappingService.GetProviderNameUserMappingsList(filter).then(function (result) {
                        if (result.length > 0) {
                            TotalRows = result[0].TotalRows;
                        }
                        readingProviderList = _.concat(readingProviderList, result);
                        readingProviderList = _.uniqBy(readingProviderList, 'ID');
                        if (readingProviderList.length == 0) {
                            gridOptions.api.showNoRowsOverlay();
                        } else {
                            gridOptions.api.hideOverlay();
                        }
                        showHideStatusbar();
                        var rowsForBlock = readingProviderList.slice(request.startRow, request.endRow);
                        d.resolve({
                            success: true,
                            rows: rowsForBlock,
                        });

                    });

                    return d.promise;

                }
            }
        }
        function getUsersList(search) {
            var d = $q.defer();
            var filter = {
                UserID: $sessionStorage.currentUserData.userId,
                Search: (search == "") ? undefined : search,
            }
            MappingService.GetAllProviders(filter).then(function (result) {
                $scope.UsersList = $filter('orderBy')(result, ['LastName', 'FirstName']);
                d.resolve(result);
            });
            return d.promise;
        }

        //UI-select DropDown
        function UserEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                $scope.params = params;
                this.eGui = document.createElement('div');
                this.eGui.className = "d-flex"
                this.eGui.innerHTML =
                    '<ui-select class="mult-select  provider-select w-100 seltype-drop mob-closekeypad" ng-model="SelectedUser.Obj"  on-select="onSelectReadingProvider(params)" on-remove="onSelectReadingProvider(params)">' +
                    '<ui-select-match placeholder="Select User" allow-clear="true">' +
                    '{{radDisplay($select.selected)}}' +
                    '</ui-select-match>' +
                    '<ui-select-choices repeat="list in UsersList" position="down" refresh="searchMapProvider($select.search)" refresh-delay="500"> ' +
                    '<div ng-bind-html="radDisplay(list) | highlight: $select.search"></div>' +
                    '<small>' +
                    '<span ng-if="list.Email.length>0"><i class="fa fa-envelope"></i> {{list.Email}}<br/></span >' +
                    '<span ng-if="list.PhoneNumber.length>0"><i class="fa fa-phone-square"></i> {{list.PhoneNumber}}</span>' +
                    '</small>' +
                    '</ui-select-choices>' +
                    '</ui-select>' +
                    '<button class="btn-primary ml-1" title="Save" ng-click="MapUser(\'M\',params)"><i class="glyphicon glyphicon-floppy-disk"></i></button>';


                // create and compile AngularJS scope for this component
                this.$scope1 = $scope.$new();
                $compile(this.eGui)(this.$scope1);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                editReadingProviderTimeout = setTimeout(this.$scope1.$apply.bind(this.$scope1), 0);

            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                var selectedValue = ($scope.SelectedUser.Obj) ? $scope.radDisplay($scope.SelectedUser.Obj) : "";
                return selectedValue;
            }
            return CustomEditor;
        }
        $scope.searchFilterProvider = function (search) {
            getUsersList(search);
        }
        $scope.searchMapProvider = function (search) {
            getUsersList(search);
        }

        $scope.MapMultipleUser = function () {
            $scope.isLoadingReadingProvider = true;
            var SelectedRows = gridOptions.api.getSelectedRows();
            var ProviderUserMappingIDs = [];
            //$log.log("SelectedRows > ", SelectedRows);
            _.each(SelectedRows, function (row, index) {
                ProviderUserMappingIDs.push({ ID: row.ID, UserID: row.UserID });
            });
            var filter = {
                ModifyBy: $sessionStorage.currentUserData.userId,
                StatusFlag: 'M',
                ProviderUserMappingIDs: ProviderUserMappingIDs,
            }
            //$log.log("Multi User Map ProviderUserMappingIDs > ", ProviderUserMappingIDs);

            EditProviderNameUserMappingsList(filter).then(function (res) {
                gridOptions.api.stopEditing();
                $scope.isLoadingReadingProvider = false;
            });

        }
        $scope.MapUser = function (StatusFlag, params) {
            params.node.setSelected(true);
            var filter = {};
            if (StatusFlag == 'M' && $scope.SelectedUser.Obj) {
                $scope.isLoadingReadingProvider = true;
                $scope.showUserDropDown = false;
                gridOptions.api.stopEditing();
                var ProviderUserMappingIDs = [];
                if ($scope.SelectedUser.Obj && params.data.ID) {
                    ProviderUserMappingIDs.push({ ID: params.data.ID, UserID: $scope.SelectedUser.Obj.Id });
                }
                filter = {
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    StatusFlag: StatusFlag,
                    ProviderUserMappingIDs: ProviderUserMappingIDs,
                }
                EditProviderNameUserMappingsList(filter).then(function (res) {
                    $scope.isLoadingReadingProvider = false;
                });
            }
            else if (StatusFlag == 'D') {
                //$log.log(params);
                filter = {
                    ModifyBy: $sessionStorage.currentUserData.userId,
                    StatusFlag: StatusFlag,
                    ID: params.data.ID
                }
                EditProviderNameUserMappingsList(filter).then(function (res) {
                    $scope.isLoadingReadingProvider = false;
                    var idx = _.findIndex(readingProviderList, { 'ID': params.data.ID });
                    gridOptions.api.applyServerSideTransaction({
                        remove: [
                            { ID: params.data.ID }
                        ]
                    });
                    //$log.log("Delete Transaction > ", result);
                    readingProviderList.splice(idx, 1);
                });
            }
            else {
                gridOptions.api.stopEditing();
            }
        }
        function EditProviderNameUserMappingsList(filter) {
            var d = $q.defer();
            MappingService.EditProviderNameUserMappingsList(filter).then(function (res) {
                $scope.SelectedUser = { Obj: null };
                var selectedRows = gridOptions.api.getSelectedRows();
                _.each(selectedRows, function (row) {
                    if ((row.UserID && $scope.SelectedRadiologistType.Obj && $scope.SelectedRadiologistType.Obj.label == 'Unmapped')) {
                        var idx = _.findIndex(readingProviderList, { 'ID': row.ID });
                        gridOptions.api.applyServerSideTransaction({
                            remove: [
                                { ID: row.ID }
                            ]
                        });
                        //$log.log("Delete Transaction > ", result);
                        readingProviderList.splice(idx, 1);
                        TotalRows = TotalRows - 1;
                    }
                });
                
                showHideStatusbar();
                d.resolve();
            });
            return d.promise;
        }
        $scope.FilterReadingProvider = function () {
            if (gridOptions && gridOptions.api) {
                gridOptions.api.deselectAll();
            }
            resetGrid();
        }
        $scope.clearFilter = function () {
            clearData();
            $scope.FilterReadingProvider();
            $scope.clearSelectedReadingProvider();
        }
        function clearData() {
            $scope.ReadingProviderName = '';
            $scope.SelectedRadiologistType = {
                Obj: {
                    label: 'Unmapped',
                    value: 'UnMapped'
                }
            };
            $scope.SelectedRadiologist = { Obj: null };
        }
        function resetGrid() {
            readingProviderList = [];
            gridOptions.api.refreshServerSide({ purge: true });
        }
        function showHideStatusbar() {
            var statusBarComponent = gridOptions.api.getStatusPanel('GridFooter');
            if (readingProviderList.length == 0) {
                statusBarComponent.eGui.hidden = true;
                gridOptions.api.showNoRowsOverlay();
            } else {
                gridOptions.api.hideOverlay();
                statusBarComponent.eGui.hidden = false;
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
                statusBarComponent.eGui.textContent = 'Showing ' + readingProviderList.length + ' of ' + TotalRows + ' Total Records';
                statusBarComponent.eGui.style.color = 'white';
            }
        }
        $scope.SelectedType = function () {
            if ($scope.SelectedRadiologistType.Obj && $scope.SelectedRadiologistType.Obj.label == 'Unmapped') {
                $scope.SelectedRadiologist = { Obj: null };
            }
            $scope.FilterReadingProvider();
        }
        $scope.onSelectReadingProvider = function (params) {
            if ($scope.SelectedUser.Obj) {
                gridOptions.api.applyServerSideTransaction({
                    update: [
                        {
                            ID: params.data.ID,
                            ProviderName: params.data.ProviderName,
                            ReadingProvider: $scope.radDisplay($scope.SelectedUser.Obj),
                            TotalRows: params.data.TotalRows,
                            UserID: $scope.SelectedUser.Obj.Id,
                        }
                    ]
                });
                params.node.setSelected(true);
            }
            else {
                gridOptions.api.applyServerSideTransaction({
                    update: [
                        {
                            ID: params.data.ID,
                            ProviderName: params.data.ProviderName,
                            ReadingProvider: null,
                            TotalRows: params.data.TotalRows,
                            UserID: null,
                        }
                    ]
                });
            }
        }
        $scope.onReadingProviderFilterSelectRemove = function () {
            $scope.ReadingProviderFilterTooltip = "";
            if ($scope.SelectedRadiologist.Obj && $scope.SelectedRadiologist.Obj.length > 0) {
                $scope.ReadingProviderFilterTooltip = _.join(_.map($scope.SelectedRadiologist.Obj, function (provider) { return $scope.radDisplay(provider); }), '\n')
            } else {
                $scope.ReadingProviderFilterTooltip = "Select Reading Provider";
            }
        }
        $scope.clearSelectedReadingProvider = function () {
            $scope.SelectedRadiologist.Obj = null;
            $scope.ReadingProviderFilterTooltip = "Select Reading Provider";
        }

        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        $scope.radDisplay = function (r) {
            if (!r) return '';
            if (!_isSelf(r.Id || r.UserID) && _hasPrelimRad(r.UserRoles || r.Roles)) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
        $scope.validateMapUsersBtn = function () {
            if (gridOptions.api && (gridOptions.api.getSelectedRows()).length > 0) {
                return false;
            } else {
                return true;
            }
        }
    }
})();
(function () {
	'use strict';

    angular.module('BlurAdmin.theme.components')
	.component('reportViewer', {
        templateUrl: 'app/theme/components/report-viewer/report-viewer.html',   
        bindings: {             
			sourceId: '<'
        },
        controller: ReportViewerController
    });

	/** @ngInject */
    function ReportViewerController($scope, WorklistService, $filter) {

        var work = this;

        $scope.onChange = function() {
            init();
        };

        work.$onChanges = function (changes) { 
            init();
        }
        $scope.isSigned = false;
        function init() {
            if (work.sourceId) {
                $scope.isLoading = true;
                loadData();
            }
        }
        
        $scope.PatientOrderReport = [];

        //var loadData = function () {
        //    $scope.isLoading = true;
        //    //WorklistService.GetDictationReportPDF(work.sourceId, $sessionStorage.currentUserData.TenantName).then(function (response) {
        //    WorklistService.GetDictationReportPDF(work.sourceId, 'CI').then(function (response) {
        //    //WorklistService.GetDictationReportPDF(1164190, 'CI').then(function (response) {
        //        $scope.file = response;
        //        if ($scope.file && $scope.file.FileContent) {
        //            const blob = b64toBlob($scope.file.FileContent, "application/pdf");
        //            const blobUrl = URL.createObjectURL(blob);
        //            $scope.fileurl = blobUrl;
        //        }
        //        $scope.isLoading = false;

        //    }, _respError);
        //}
        var loadData = function () {
            $scope.isLoading = true;
            $scope.report = null;
            WorklistService.GetDictationValueReportPDF(work.sourceId).then(function (response) {
                $scope.report = response;
                if ($scope.report && $scope.report.DOS) {
                    $scope.report.DOS = moment(
                        ($filter('localDate')($scope.report.DOS, false, new Date()))
                    ).format("MM/DD/YYYY");
                }
                if ($scope.report && $scope.report.SingDate) {
                    $scope.report.SingDate = moment(
                        ($filter('localDate')($scope.report.SingDate, false, new Date()))
                    ).format("MM/DD/YYYY");
                }
                if ($scope.report && $scope.report.Patient_DOB) {
                    $scope.report.Patient_DOB = changeDateFormat($scope.report.Patient_DOB);
                }
                $scope.isLoading = false;
            }, _respError);
        }
        function changeDateFormat(date) {
            if (date) {
                return moment(new Date(date)).format("MM/DD/YYYY");
            }
        }
        function b64toBlob(dataURI, fileType) {
            var byteString = atob(dataURI);
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: fileType });
        }
        function _respError(error) {
            $scope.isLoading = false;
        }

        init();
	}
}());

(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('reportWindow', {
            templateUrl: 'app/theme/components/report-window/report-window.html',
            bindings: {
                selectedOrder: '<',
                formattedSelectedOrder: '<',
                masterData: '<',
                closeModal: '&',
            },
            controller: reportWindowController
        });

    /** @ngInject */
    function reportWindowController($scope, $rootScope, $sessionStorage, $q, WorklistService, $timeout, $filter, APP_CONSTANTS, toaster, ManageLocationService, ProfileService) {

        var vm = this;
        var ReportList = [];
        var TimeoutList = [];
        $scope.isComparisonOrderReportsVisible = false;
        $scope.currentWindow = "";
        $scope.DataObject = {
            LoggedInUserDetails: {},
            IsStudyReviewSectionVisible: false,
            IsReportReviewEditable: true,
            ReportListFilter: { DateRange: 'Any', Modality: 'All' },
            ReportList: WorklistService.GetReportListModalityNDateRange(),
            ShowReportModal: false,
            ReportSortingPropName: 'OrderDate',
            ReportSortingRevOrder: true,
            SearchText: '',
            ReportSortingOptions: ['DOS (newest first)', 'DOS (oldest first)', 'Rendering Physician (A to Z)', 'Rendering Physician (Z to A)', 'Procedure (A to Z)', 'Procedure (Z to A)'],
            SelectedSortingOption: 'DOS (newest first)',
            displaySortPopover: false,
            masterData: {},
            ModalReportNDiscussionTabs: [
                {
                    title: 'Report',
                    templateUrl: 'modal_report_tab.html',
                    disabled: false,
                },
                {
                    title: 'Discussion',
                    templateUrl: 'modal_discussion_tab.html',
                    disabled: false,
                },
                {
                    title: 'Attachment',
                    templateUrl: 'modal_attachment_tab.html',
                    disabled: false,
                }
            ],
            ModalReportNDiscussActiveIndex: 0,
            Reference: {},
            FaxDetails: {
                FaxNumTooltip: null,
                disableSendFaxBtn: false,
                FaxNumberList: [],
                FaxNumber: null,
                FaxNumberDropdown: {
                    divId: "FaxNumberDropdown",
                    keys: ['FaxName', 'DisplayFaxNumber'],
                    uniqKey: 'uniqID',
                    placeHolder: "Select Fax Number",
                    SelectedValue: { list: [] },
                    separator: "<br>",
                    onFaxNumbChanged: function (selectedData) {
                        var tooltip = null;
                        _.each(selectedData, function (obj) {
                            if (tooltip) {
                                tooltip = tooltip + "\n" + obj.FaxName + "-" + obj.FaxNumber;
                            }
                            else {
                                tooltip = obj.FaxName + "-" + obj.FaxNumber;
                            }
                        });
                        $scope.DataObject.FaxDetails.FaxNumTooltip = tooltip;
                    }
                }
            },
            RemoveRenderingPhysicianReport: $sessionStorage.currentUserData.RemoveRenderingPhysician,
            EnableRowsForSelectedTenants: $sessionStorage.EnableRowsForSelectedTenants.split(',')
        };
        vm.$onChanges = function (changes) {
            if (changes.selectedOrder && changes.selectedOrder.currentValue) {
                var order = changes.selectedOrder.currentValue;
                if (order.OpenPriorReport) {
                    showPriorReport(order, order.Accession);
                }
                else {
                    switch (order.Status) {
                        case 'RP':
                            if (order.IsPriorOrder) {
                                showPriorReport(order, order.Accession);
                            }
                            break;
                        case 'C':
                        case 'PA':
                        case 'D':
                            ViewOrderReport(order, order.Accession);
                            break;
                    }
                }
            }
            if (changes.masterData && changes.masterData.currentValue) {
                $scope.DataObject.masterData = changes.masterData.currentValue;
            }
            if (changes.formattedSelectedOrder && changes.formattedSelectedOrder.currentValue) {
                $scope.SelectedOrder = _.clone(changes.formattedSelectedOrder.currentValue);
            }
        };
        vm.$onDestroy = function () {
            if ($scope.isComparisonOrderReportsVisible) {
                $scope.win_ComparisonOrderReports.close();
            }
            if ($scope.isModalReportNDiscussVisible) {
                $scope.win_ModalReportNDiscuss.close();
            }
            _.each(TimeoutList, function (timeout) {
                $timeout.cancel(timeout);
            });
        }
        vm.$onInit = function () {
            getLoggedInUserDetails();
        }

        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function isVisibleRad(r) {
            if (!r) return false;
            if (_isSelf(r.Id || r.UserID)) return true;
            return !_hasPrelimRad(r.UserRoles || r.Roles);
        }
        $scope.isVisibleRad = isVisibleRad;
        $scope.radDisplay = function (r) {
            if (!r) return '';
            if (!_isSelf(r.Id || r.UserID) && _hasPrelimRad(r.UserRoles || r.Roles)) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
        $scope.signByDisplay = function (r) {
            if (!r) return '';
            if ($sessionStorage.currentUserData
                && $sessionStorage.currentUserData.RemoveRenderingPhysician
                && $scope.DataObject.EnableRowsForSelectedTenants
                && $scope.SelectedOrder
                && $scope.DataObject.EnableRowsForSelectedTenants.includes($scope.SelectedOrder.TenantName)) {
                return '';
            }
            return r.SignByName || (r.OrderReport && r.OrderReport.SignByName) || '';
        };
        function _isPrelimRadAssignment(userId) {
            if (!userId || _isSelf(userId)) return false;
            var rads = $scope.DataObject.masterData && $scope.DataObject.masterData.Radiologists;
            var rad = _.find(rads, function (r) {
                return (r.Id || r.UserID || '').toLowerCase() === userId.toLowerCase();
            });
            return rad ? _hasPrelimRad(rad.UserRoles || rad.Roles) : false;
        }
        $scope.disName = function (dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        };

        function showPriorReport(SelectedOrder, SelectedOrderAccession) {
            var d = $q.defer();
            $scope.ReportSelectedOrder = _.clone(SelectedOrder);
            $scope.ReportSelectedOrder.ShowContactBtn = false;
            var ComparisionOrderList = [];
            if (SelectedOrder.ComparisonOrder && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                $q.all([
                    viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                ]).then(function (data) {
                    d.resolve(data);
                });

            } else if (SelectedOrder.ComparisonOrder && SelectedOrder.ComparisonOrder.length == 0) {
                $scope.orderComparisonListFilter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = _.clone(result);
                    //SelectedOrder.subGridOptions = _.clone(subUIGridOptions);
                    //SelectedOrder.subGridOptions.data = _.clone(result);
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });
                    $q.all([
                        viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                    ]).then(function (data) {
                        d.resolve(data);
                    });


                }).catch(function (noCantDo) {
                    $scope.DataObject.worklist.loading = false;
                    d.resolve(false);
                });
            }
            else {
                $q.all([
                    viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                ]).then(function (data) {
                    d.resolve(data);
                });
            }
            return d.promise;
        }
        function viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList) {
            var d = $q.defer();
            $scope.showDiscuss = true;
            $scope.isReportAvailable = false;
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN, SelectedOrder.SiteID)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];
                if (data != null && data.length > 0 && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report && report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        SelectedOrder.FormattedOrderDate = new Date($filter('localDate')(SelectedOrder.OrderDate, false, new Date()));
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            rptObject[0].FormattedOrderDate = new Date($filter('localDate')(rptObject[0].OrderDate, false, new Date()));
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            ComparisonOrderReport.FormattedOrderDate = new Date($filter('localDate')(ComparisonOrderReport.OrderDate, false, new Date()));
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });
                }
                $scope.OrderReport = SelectedOrder;
                $scope.reportList = _.uniqBy($scope.reportList, 'OrderID');
                $scope.DataObject.ReportList.Modalities = _.concat($scope.DataObject.ReportList.Modalities, _.uniq(_.map(_.filter($scope.reportList, function (report) { return report.Modality != ''; }), 'Modality')));
                if (report.length == 0) {
                    var reportList = _.orderBy($scope.reportList, ['OrderDate'], ['desc']);
                    $scope.reportList = reportList;
                }
                if ($scope.reportList && $scope.reportList.length > 0) {
                    var objSelectedReport = $scope.reportList[0];
                    if (objSelectedReport) {
                        $scope.SelectedOrderAccession = objSelectedReport.Accession;
                        LoadReport(objSelectedReport.OrderID);
                        if (Hasreport) {
                            $scope.isReportAvailable = true;
                        }
                        $scope.LoadDiscussion($scope.OrderReport.DicomOrderID, 'Discussion');
                    }
                }
                else {
                    $scope.LoadDiscussion($scope.OrderReport.DicomOrderID, 'Discussion');
                }
                ReportList = $scope.reportList;
                if (ReportList.length > 1) {
                    $scope.DataObject.ShowReportModal = true;
                }
                //$scope.isLoading = false;
                d.resolve(true);
            });
            return d.promise;
        }

        function ViewOrderReport(SelectedOrder, SelectedOrderAccession) {
            $scope.ReportSelectedOrder = _.clone(SelectedOrder);
            $scope.ReportSelectedOrder.ShowContactBtn = false;
            $scope.showDiscuss = false;
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;
            var ComparisionOrderList = [];

            if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length == 0) {
                $scope.orderComparisonListFilter = {
                    UserID: vm.selectedData.LoggedInUserID,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = result;
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });

                    setPriorReport(SelectedOrder, ComparisionOrderList);
                }).catch(function (noCantDo) {
                    //$scope.isLoading = false;
                });
            } else if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                setPriorReport(SelectedOrder, ComparisionOrderList);
            } else {
                setPriorReport(SelectedOrder, ComparisionOrderList);
            }
        }
        function setPriorReport(SelectedOrder, ComparisionOrderList) {
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN, SelectedOrder.SiteID)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];

                if (data != null && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        SelectedOrder.FormattedOrderDate = new Date($filter('localDate')(SelectedOrder.OrderDate, false, new Date()));
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            rptObject[0].FormattedOrderDate = new Date($filter('localDate')(rptObject[0].OrderDate, false, new Date()));
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            ComparisonOrderReport.FormattedOrderDate = new Date($filter('localDate')(ComparisonOrderReport.OrderDate, false, new Date()));
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });
                }
                $scope.OrderReport = SelectedOrder;
                $scope.reportList = _.uniqBy($scope.reportList, 'OrderID');
                $scope.DataObject.ReportList.Modalities = _.concat($scope.DataObject.ReportList.Modalities, _.uniq(_.map(_.filter($scope.reportList, function (report) { return report.Modality != ''; }), 'Modality')));
                var objSelectedReport = _.filter($scope.reportList, function (obj) { return obj.Accession == $scope.SelectedOrderAccession; });
                LoadReport(objSelectedReport[0].OrderID);
                if (Hasreport) {
                    $scope.currentWindow = "win_ComparisonOrderReports";
                    $scope.win_ComparisonOrderReports.open();
                    $scope.win_ComparisonOrderReports.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    $scope.win_ComparisonOrderReports.wrapper.addClass("report-top-mdl");
                    var timeout = $timeout(function () {
                        $scope.win_ComparisonOrderReports.center();
                    }, 100);
                    TimeoutList.push(timeout);
                }
                else {
                    toaster.info({ body: "No report found." });
                }
                ReportList = $scope.reportList;
                if (ReportList.length > 1) {
                    $scope.DataObject.ShowReportModal = true;
                }
            });
        }
        function GetPriorReportsByPatientMRN(OrderID, PatientMRN, SiteID) {
            var d = $q.defer();
            var jObject = {
                OrderID: OrderID,
                PatientMRN: PatientMRN,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: SiteID
            }

            WorklistService.GetPriorReportsByPatientMRN(jObject).then(function (results) {
                d.resolve(results);
            });
            return d.promise;
        }
        function LoadReport(OrderId) {
            if ($scope.orderReportList && $scope.orderReportList.length > 0) {
                var data = _.filter($scope.orderReportList, function (obj) { return obj.OrderID == OrderId; });
                if (data && data.length > 0) {
                    $scope.report = data[0];
                    $scope.ReviewOrder = {};
                    angular.copy($scope.report, $scope.ReviewOrder);
                    AssignValuesReportToSelectedOrder();
                    $scope.isReviewReportVisible();
                    //$scope.isLoading = false;
                }
                else {
                    $scope.ReviewOrder = {};
                    getReportData(OrderId);
                }
            }
            else {
                $scope.ReviewOrder = {};
                getReportData(OrderId);
            }
        }
        function getReportData(OrderId) {
            $scope.report = null;
            var UserId = $sessionStorage.currentUserData.userId;
            WorklistService.GetDictationValueReport(OrderId, UserId).then(function (response) {
                if (response) {
                    $scope.report = response;
                    if ($sessionStorage.currentUserData 
                        && $sessionStorage.currentUserData.RemoveRenderingPhysician
                        && ($scope.DataObject.EnableRowsForSelectedTenants
                            && $scope.DataObject.EnableRowsForSelectedTenants.includes($scope.SelectedOrder.TenantName))) {
                        $scope.report.DictationValue = _.toString($scope.report.DictationValue).length > 0 ? $scope.report.DictationValue.replace(/Electronically signed by.*?(?:\n|\r|$)/gi, '').replace(/Workstation:.*?(?:\n|\r|$)/gi, '').replace(/Electronically drafted by.*?(?:\n|\r|$)/gi, '') : '';
                    }
                        
                    $scope.ReviewOrder = response;
                    

                    if ($scope.report && $scope.report.DOS) {
                        $scope.report.DOS = ($filter('localDate')($scope.report.DOS, false, new Date()));
                    }
                    if ($scope.report && $scope.report.SingDate) {
                        $scope.report.SingDate = moment(
                            ($filter('localDate')($scope.report.SingDate, false, new Date()))
                        ).format("MM/DD/YYYY");
                    }
                    if ($scope.report && $scope.report.Patient_DOB) {
                        $scope.report.Patient_DOB = changeDateFormat($scope.report.Patient_DOB);
                    }
                    if ($scope.OrderReport) {
                        $scope.report.Location = $scope.OrderReport.Location;
                        $scope.report.LocationID = $scope.OrderReport.LocationID;
                    }
                    AssignValuesReportToSelectedOrder();
                    $scope.isReviewReportVisible();
                    $scope.orderReportList.push(response);
                }

                //$scope.isLoading = false;
            }, function (error) {
                //$scope.isLoading = false;
            });
        }
        function changeDateFormat(date) {
            if (date) {
                return moment(new Date(date)).format("MM/DD/YYYY");
            }
        }

        function AssignValuesReportToSelectedOrder() {
            $scope.ReportSelectedOrder.SignByName = $scope.report.RED_LastName;
            $scope.ReportSelectedOrder.OrderDate = $scope.report.DOS;
            $scope.ReportSelectedOrder.ReportSignDate = $scope.report.SingDate;
            $scope.ReportSelectedOrder.ReportStatus = $scope.report.Status;
            $scope.ReportSelectedOrder.PatientDOB = $scope.report.Patient_DOB;
            if ($scope.ReportSelectedOrder && $scope.ReportSelectedOrder.Status) {
                $scope.ReportSelectedOrder.OrderStatus = _.find($scope.DataObject.masterData.OrderStatus, { 'key': $scope.ReportSelectedOrder.Status }).value;
            }
            $scope.ReportSelectedOrder.ExamTagKey = $scope.ReportSelectedOrder.ExamTag && $scope.ReportSelectedOrder.ExamTag != "0" ? _.find($scope.DataObject.masterData.ExamTags, { 'Value': $scope.ReportSelectedOrder.ExamTag }).Key : $scope.ReportSelectedOrder.ExamTagKey;
            $scope.ReportSelectedOrder.RadExamTagKey = $scope.ReportSelectedOrder.RadExamTag && $scope.ReportSelectedOrder.RadExamTag != "0" ? _.find($scope.DataObject.masterData.RadExamTag, { 'Value': $scope.ReportSelectedOrder.RadExamTag }).Key : $scope.ReportSelectedOrder.RadExamTagKey;
            $scope.ReportSelectedOrder.RenderingPhysicianEmail = $scope.report.RenderingPhysicianEmail;
            $scope.ReportSelectedOrder.RenderingPhysicianPhone = $scope.report.RenderingPhysicianPhone;
        }

        $scope.onClearFilterReportList = function (ClearFlag) {
            $scope.DataObject.SelectedSortingOption = 'DOS (newest first)';
            $scope.DataObject.ReportListFilter.Modality = 'All';
            $scope.DataObject.ReportListFilter.DateRange = 'Any';
            $scope.DataObject.ReportSortingPropName = 'OrderDate';
            $scope.DataObject.ReportSortingRevOrder = true;
            if (ClearFlag) {
                $scope.DataObject.ReportList.Modalities = ['All'];
                $scope.DataObject.ShowReportModal = false;
            }
            $scope.DataObject.SearchText = '';
        }

        $scope.winDragend = function (e) {
            adjustSize();
        }
        $scope.winResize = function (e) {
            adjustSize();
            if ($scope.currentWindow == 'win_LocationContact') {
                $scope.DataObject.addressBookGridHeight = ((e.height - 100) + "px");
            }
        }
        function adjustSize() {
            // For small screens, maximize the window when it is shown.
            // You can also make the check again in $(window).resize if you want to
            // but you will have to change the way to reference the widget and then
            // to use $("#theWindow").data("kendoWindow").
            // Alternatively, you may want to .center() the window.
            //alert($(window).width());

            if ($scope.currentWindow == 'win_Discussion') {
                $scope.win_Discussion.center();
            } else if ($scope.currentWindow == 'win_ContactList') {
                $scope.win_ContactList.center();
            } else if ($scope.currentWindow == 'win_ComparisonOrderReports') {
                $scope.win_ComparisonOrderReports.center();
            } else if ($scope.currentWindow == 'win_ModalReportNDiscuss') {
                $scope.win_ModalReportNDiscuss.center();
            }
            else if ($scope.currentWindow == 'win_PSUser') {
                $scope.win_PSUser.center();
            } else if ($scope.currentWindow == 'win_HideStudy') {
                $scope.win_HideStudy.center();
            } else if ($scope.currentWindow == 'win_addendum_request') {
                $scope.win_addendum_request.center();
            }

            return true;
        }

        $scope.showReport = function (SelectedOrder) {
            $scope.OrderReport = SelectedOrder;
            $scope.SelectedOrderAccession = SelectedOrder.Accession;
            LoadReport(SelectedOrder.OrderID);
        }

        $scope.FilterReportList = function (FilterFlag) {
            var FilteredList = ReportList;
            var startDate, endDate = null;
            if ($scope.DataObject.ReportListFilter.DateRange != 'Any') {
                switch ($scope.DataObject.ReportListFilter.DateRange) {
                    case '6m':
                        startDate = new Date(moment().subtract(6, 'month'));
                        endDate = new Date(moment());
                        break;
                    case '1y':
                        startDate = new Date(moment().subtract(1, 'year').add(1, 'days'));
                        endDate = new Date(moment());
                        break;
                    case '2y':
                        startDate = new Date(moment().subtract(2, 'year'));
                        endDate = new Date(moment());
                        break;
                    case '5y':
                        startDate = new Date(moment().subtract(5, 'year'));
                        endDate = new Date(moment());
                        break;
                }
                FilteredList = _.filter(FilteredList, function (report) {
                    var itemDate = new Date(report.OrderDate);
                    return itemDate >= startDate && itemDate <= endDate;
                });
            }
            if ($scope.DataObject.ReportListFilter.Modality != 'All') {
                FilteredList = _.filter(FilteredList, { 'Modality': $scope.DataObject.ReportListFilter.Modality });
            }
            if ($scope.DataObject.SearchText != '') {
                var result = null;
                result = _.filter(FilteredList, function (item) {
                    return _.some(['OrderDate', 'ProcedureDesc', 'SignByName'], function (key) {
                        if (key == 'OrderDate') {
                            return moment(_.get(item, key, '')).format('MM/DD/YYYY').toString().toLowerCase().includes($scope.DataObject.SearchText.toLowerCase());
                        }
                        else {
                            var value = _.get(item, key, '');
                            if (value) {
                                return value.toString().toLowerCase().includes($scope.DataObject.SearchText.toLowerCase());
                            }
                        }
                        return false;
                    });
                });
                if (result) { FilteredList = result; }
            }
            $scope.reportList = FilteredList;
            if (FilterFlag && $scope.reportList && $scope.reportList.length > 0) {
                var objSelectedReport = $scope.reportList[$scope.reportList.length - 1];
                if (objSelectedReport) {
                    $scope.SelectedOrderAccession = objSelectedReport.Accession;
                    LoadReport(objSelectedReport.OrderID);
                }
            }
        }

        $scope.onReportSortingClicked = function (sortingOption) {
            $scope.DataObject.SelectedSortingOption = sortingOption;
            var ReportListElement = document.getElementsByClassName('repoHeiFtrWrklst ftlrbtns-height');
            if (ReportListElement && ReportListElement[0] && ReportListElement[0].scrollTop > 0) {
                ReportListElement[0].scrollTop = 0;
            }
            switch (sortingOption) {
                case 'DOS (newest first)':
                    $scope.DataObject.ReportSortingPropName = 'OrderDate';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
                case 'DOS (oldest first)':
                    $scope.DataObject.ReportSortingPropName = 'OrderDate';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Rendering Physician (A to Z)':
                    $scope.DataObject.ReportSortingPropName = 'SignByName';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Rendering Physician (Z to A)':
                    $scope.DataObject.ReportSortingPropName = 'SignByName';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
                case 'Procedure (A to Z)':
                    $scope.DataObject.ReportSortingPropName = 'ProcedureDesc';
                    $scope.DataObject.ReportSortingRevOrder = false;
                    break;
                case 'Procedure (Z to A)':
                    $scope.DataObject.ReportSortingPropName = 'ProcedureDesc';
                    $scope.DataObject.ReportSortingRevOrder = true;
                    break;
            }
        }

        $scope.CloseModal = function () {
            vm.closeModal();
        }

        $scope.CloseReportNDiscussionWindow = function () {
            $scope.isModalReportNDiscussVisible = false;
            $scope.onClearFilterReportList(true);
        }

        $scope.onModalReportNDiscussionTabsChange = function (TabName) {
            switch (TabName) {
                case 'Report':
                    $scope.onClearFilterReportList(false);
                    $scope.FilterReportList(false);
                    $scope.ReportSelectedOrder = _.clone($scope.SelectedOrder);
                    if ($scope.report) {
                        AssignValuesReportToSelectedOrder();
                    }
                    //$scope.ReportSelectedOrder.ReportStatus = $scope.report ? $scope.report.Status : $scope.ReportSelectedOrder.ReportStatus;
                    break;
                case 'Discussion':
                    $scope.DiscussionSelectedOrder = _.clone($scope.SelectedOrder);
                    break;
                case 'Attachment':
                    $scope.DataObject.Reference.ID = null;
                    var timeout = $timeout(function () {
                        $scope.showAttachment = true;
                        $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 50);
                    break;
            }
        }

        $scope.LoadDiscussion = function (referenceID, ODType) {
            $scope.showAttachment = false;
            $scope.ODType = ODType;
            $scope.Discussion = {
                ReferenceID: referenceID,
                Type: 1,
                Comment: '',
                Record_Created_By: $sessionStorage.currentUserData.userId
            };
            $scope.Discussions = [];
            LoadDiscussion($scope.Discussion);
            if ($scope.showDiscuss) {
                if (($scope.reportList && $scope.reportList.length > 0) || ($scope.Discussions && $scope.Discussions.length > 0)) {
                    $scope.currentWindow = 'win_ModalReportNDiscuss';
                    $scope.win_ModalReportNDiscuss.open();
                    $scope.win_ModalReportNDiscuss.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    $scope.win_ModalReportNDiscuss.wrapper.addClass("report-top-mdl");
                    var timeout = $timeout(function () {
                        $scope.win_ModalReportNDiscuss.center();
                    }, 100);
                    TimeoutList.push(timeout);
                }
            }
            /*else {
                $scope.currentWindow = 'win_Discussion';
                $scope.win_Discussion.open();
                $scope.win_Discussion.wrapper.prev(".k-overlay").addClass("custom-overlay");
                $scope.win_Discussion.wrapper.addClass("report-top-mdl");
                var timeout = $timeout(function () {
                    $scope.win_Discussion.center();
                }, 100);
                TimeoutList.push(timeout);
            }*/
            if ($scope.showDiscuss) {
                if ($scope.isReportAvailable) {
                    //selectPriorReportTab("#tabReport");
                    $scope.DataObject.ModalReportNDiscussActiveIndex = 0;
                }
                else if ($scope.OrderReport && $scope.OrderReport.FileCount > 0) {
                    //selectPriorReportTab("#tabDiscussion");
                    $scope.DataObject.ModalReportNDiscussActiveIndex = 2;
                    $scope.DataObject.Reference.ID = null;
                    $scope.showAttachment = true;
                    $scope.DataObject.Reference.ID = $scope.Discussion.ReferenceID;
                }
                else {
                    //selectPriorReportTab("#tabDiscussion");
                    $scope.DataObject.ModalReportNDiscussActiveIndex = 1;
                }
            }
            $scope.DataObject.Loading = false;
        };

        function LoadDiscussion(discussion) {
            WorklistService.GetDiscussions(discussion).then(function (response) {
                $scope.AllDiscussions = _.clone(response);
                $scope.Discussions = _.filter(response, function (item) { return item.Type == 1; });
                if ($scope.showDiscuss && (($scope.isReportAvailable || ($scope.Discussions && $scope.Discussions.length > 0) || $scope.OrderReport.FileCount > 0))) {
                    angular.element('#ModalReportNDiscuss').modal('show');
                    if ($scope.showDiscuss) {
                        $scope.currentWindow = "win_ModalReportNDiscuss";
                        $scope.win_ModalReportNDiscuss.open();
                        $scope.win_ModalReportNDiscuss.wrapper.prev(".k-overlay").addClass("custom-overlay");
                        var timeout = $timeout(function () {
                            $scope.win_ModalReportNDiscuss.center();
                        }, 100);
                        TimeoutList.push(timeout);
                    } /*else {
                        $scope.currentWindow = 'win_Discussion';
                        $scope.win_Discussion.open();
                        $scope.win_Discussion.wrapper.prev(".k-overlay").addClass("custom-overlay");
                        $scope.win_Discussion.wrapper.addClass("report-top-mdl")
                        var timeout = $timeout(function () {
                            $scope.win_Discussion.center();
                        }, 100);
                        TimeoutList.push(timeout);
                    }*/
                }
                $scope.DiscussionSelectedOrder = _.clone($scope.SelectedOrder);
                angular.forEach($scope.Discussions, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            });
        }

        function LoadChildDiscussion(ObjDiscussion) {
            var response = _.filter($scope.AllDiscussions, function (item) { return item.ReferenceID == ObjDiscussion.ID; });
            if (response && (response.length > 0)) {
                if (!ObjDiscussion.Childs || ObjDiscussion.Childs.length != response.length) {
                    ObjDiscussion.Childs = response;
                }
                angular.forEach(ObjDiscussion.Childs, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            }
        }

        $scope.SaveDiscussion = function (EventType) {
            $scope.DataObject.Loading = true;
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedUsers) {
                $scope.SaveDiscussionFlag = true;
                $scope.AssignStudy(EventType);
            }
            if ($scope.Discussion.Comment) {
                $scope.SaveDiscussionFlag = true;
                $scope.Discussion.EventType = EventType ? EventType : 'WC';
                WorklistService.SetDiscussion($scope.Discussion).then(function (response) {
                    $scope.SelectedOrder.IsDiscussion = true;
                    $scope.showDiscuss = false;
                    LoadDiscussion(response);
                    $scope.Discussion.Comment = null;
                    $scope.SaveDiscussionFlag = false;
                    /* var idx = _.findIndex(OrderList, { OrderID: $scope.SelectedOrder.OrderID });
                    if (idx != -1) {
                        OrderList[idx].IsDiscussion = true;
                    }
                    UpdateGridData($scope.SelectedOrder.OrderID); */
                });
            }
            $scope.DataObject.Loading = false;
        };

        $scope.SaveChildDiscussion = function (discussion) {
            if (discussion.ChildComment) {
                var Objdiscussion = {
                    ReferenceID: discussion.ID,
                    Type: 0,
                    Comment: discussion.ChildComment,
                    Record_Created_By: $sessionStorage.currentUserData.userId,
                    CallBackURL: discussion.CallBackURL,
                    ReplyAddendumRequestDiscussion: {
                        Accession: $scope.SelectedOrder.Accession,
                        SiteName: $scope.SelectedOrder.Site,
                        AddendumRequestedBy: $sessionStorage.currentUserData.LastName + ", " + $sessionStorage.currentUserData.FirstName,
                        Comment: discussion.ChildComment,
                    }
                };
                /* if (discussion.Record_Created_By != $sessionStorage.currentUserData.userId) {
                    NotifyToUser(__env._NOTIFY_MSG_, $scope.SelectedOrder.OrderID, discussion.Record_Created_By, "N");
                } */
                $scope.DataObject.Loading = true;
                WorklistService.SetDiscussion(Objdiscussion).then(function (response) {
                    $scope.DataObject.Loading = false;
                    discussion.IsChild = false;
                    discussion.ChildComment = '';
                    $scope.AllDiscussions.push(response);
                    bindChildDiscussion(response);
                });
            }
        };
        function bindChildDiscussion(ObjDiscussion) {
            angular.forEach($scope.Discussions, function (obj, idx) {
                LoadChildDiscussion(obj);
            });
        }
        $scope.SendFax = function () {
            if ($scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list.length > 0 ||
                $scope.DataObject.FaxDetails.FaxNumber) {
                var textFaxNumber = $scope.DataObject.FaxDetails.FaxNumber;
                var dropdownFaxNum = _.join(_.map($scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list, function (obj) { return obj.FaxNumber; }), ',');

                var FaxNumber = textFaxNumber && dropdownFaxNum ? textFaxNumber + "," + dropdownFaxNum : textFaxNumber || dropdownFaxNum || null;
                var params = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    UserID: $sessionStorage.currentUserData.userId,
                    LocationID: $scope.SelectedOrder.LocationID,
                    FaxNumber: FaxNumber,
                    FaxContent: $scope.DataObject.FaxFile.FileContent,
                    FileName: $scope.DataObject.FaxFile.FileName,
                    ReportID: $scope.SelectedOrder.ReportID
                }
                $scope.DataObject.FaxDetails.disableSendFaxBtn = true;
                WorklistService.SendFax(params).then(function (res) {
                    $scope.DataObject.FaxDetails.disableSendFaxBtn = false;
                    toaster.success("Fax sent successfully");
                    $("#SendFaxModal").modal("hide");
                }, function (err) {
                    $scope.DataObject.FaxDetails.disableSendFaxBtn = false;
                    toaster.error("Some error occurred while sending Fax!");
                    $("#SendFaxModal").modal("hide");
                });

            }
        }
        $scope.openFaxModal = function (faxFile) {
            $scope.DataObject.FaxFile = faxFile;
            $scope.DataObject.FaxDetails.FaxNumber = null;
            $scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue = { list: [] }
            $scope.DataObject.FaxDetails.disableSendFaxBtn = false;
            ManageLocationService.GetLocationFaxMapping({ LocationID: $scope.SelectedOrder.LocationID }).then(function (res) {
                _.each(res, function (item, index) {
                    item.uniqID = index;
                    item.DisplayFaxNumber = (!item.PatientClass) ? item.FaxNumber : item.FaxNumber + " (" + item.PatientClass + ")";
                });
                $scope.DataObject.FaxDetails.FaxNumberList = res;
                $("#SendFaxModal").modal("show");
            }, function (err) {
                console.error("err", err);
            });
        }
        $scope.validateFaxNumText = function () {
            var disableBtn = false;
            if (!$scope.DataObject.FaxDetails.disableSendFaxBtn) {

                var faxNumTextInput = document.getElementById("FaxNumText");
                if (faxNumTextInput) {
                    var faxNumVal = _.cloneDeep(faxNumTextInput.value);
                    faxNumVal = faxNumVal.replaceAll('_', '').replaceAll('-', '').replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '');
                }

                if ($scope.DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list.length > 0) {
                    if (faxNumVal.length > 0 && faxNumVal.length < 10) {
                        disableBtn = true;
                    }
                }
                else if (faxNumVal.length >= 0 && faxNumVal.length < 10) {
                    disableBtn = true;
                }
            }
            else {
                disableBtn = true;
            }
            return disableBtn;

        }

        $scope.HideShowReviewReportAction = function () {
            $scope.DataObject.IsStudyReviewSectionVisible = !$scope.DataObject.IsStudyReviewSectionVisible;
        }
        $scope.isReviewReportVisible = function () {
            if ($scope.ReviewOrder.ReviewStatus
                && $scope.ReviewOrder.ReviewStatus.toString().toLowerCase() == 'complete') {
                $scope.ReviewOrder.IsReportReviewEditable = false;
            } else if ($scope.OrderReport
                && ($scope.OrderReport.ReportStatus.toString() == "1"
                    || $scope.OrderReport.ReportStatus.toString() == "5")
                && $scope.OrderReport.SignBy != vm.selectedData.LoggedInUserID
                && $scope.OrderReport.IsPeerReviewEnable
                && $scope.DataObject.LoggedInUserDetails.IsReviewer) {
                $scope.ReviewOrder.IsReportReviewEditable = true;
            } else if ($scope.SelectedOrder.Accession == $scope.OrderReport.Accession) {
                $scope.ReviewOrder.IsReportReviewEditable = ($scope.ReviewOrder.Rating) ? false : true;
            }
            else if ($scope.ReviewOrder.IsReviewable == 1) {
                $scope.ReviewOrder.IsReportReviewEditable = $scope.ReviewOrder.ReviewStatus
                    && $scope.ReviewOrder.ReviewStatus.toString().toLowerCase() == "pending"
                    ? true
                    : false;
                //$scope.DataObject.IsStudyReviewSectionVisible = !$scope.ReviewOrder.IsReportReviewEditable;
            }
            if ($scope.ReviewOrder.IsReportReviewEditable) {
                $scope.ReviewOrder.ReviewReportButtonText = "Review Report";
                $scope.DataObject.IsStudyReviewSectionVisible = false;
            } else {
                $scope.ReviewOrder.ReviewReportButtonText = "View Report Review";
                $scope.DataObject.IsStudyReviewSectionVisible = false;
            }
        }
        $scope.SetOrderPeerReview = function () {
            $scope.ReviewOrder.PeerReviewUserID = $sessionStorage.currentUserData.userId;
            $scope.ReviewOrder.ReviewBy = $sessionStorage.currentUserData.userId;
            var promise = ($scope.ReviewOrder.OrderReviewID) ? WorklistService.UpdateReviewOrder($scope.ReviewOrder) : WorklistService.SetOrderPeerReview($scope.ReviewOrder);
            promise.then(function (result) {
                var orderReportIndex = _.findIndex($scope.orderReportList, { OrderID: $scope.ReviewOrder.OrderID });
                if (orderReportIndex != -1) {
                    $scope.orderReportList[orderReportIndex] = _.clone($scope.ReviewOrder);
                    $scope.orderReportList[orderReportIndex].ReviewStatus = 'Complete';
                    $scope.orderReportList[orderReportIndex].Reviewby = $sessionStorage.currentUserData.userId;
                    $scope.orderReportList[orderReportIndex].IsReviewable = 1;
                }
                var reportIndex = _.findIndex($scope.reportList, { OrderID: $scope.ReviewOrder.OrderID });
                if (reportIndex != -1) {
                    $scope.reportList[reportIndex].IsReviewable = 1;
                }
                $scope.ReviewOrder.IsReportReviewEditable = false;
                $scope.ReviewOrder.ReviewReportButtonText = "View Report Review";
                toaster.success('Review Saved Successfully!');
            });
        }
        $scope.disableReportReviewBtn = function () {
            if (!$scope.ReviewOrder.Rating) {
                return true;
            }
            if ($scope.ReviewOrder.IsInterestingCase) {
                return !$scope.ReviewOrder.Keywords || !($scope.ReviewOrder.Comments);
            }
        }
        function getLoggedInUserDetails() {
            ProfileService.getUserSettingData($sessionStorage.currentUserData.userId).then(function (resp) {
                if (resp.data) {
                    $scope.DataObject.LoggedInUserDetails = resp.data;
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('rule', {
            templateUrl: 'app/theme/components/rule/rule.html',
            bindings: {
                rule: '<',
                ruleTable: '<',
                ruleSetting: '<',
            },
            controller: RuleComponent
        });

    /** @ngInject */
    function RuleComponent($scope, $rootScope, $sessionStorage, $log, $q, RuleService, RuleSharedService, toaster, uuidv4, filterFilter, $timeout, $sce, ManageLocationService, SharedService) {
        var vm = this;
        var i = 0;
        var SpecialitiesList = [];
        var RadSubspecialtyList = [];
        $scope.DataObject = {
            isCustomColor: false,
            defaultRuleColorCode: "#FF685E",
            uibHtmlTooltip: $sce.trustAsHtml('This color will be applied to a study <b>once the SLA is breached</b>. It serves as a visual alert to indicate that the study has exceeded its expected reading time and requires <b>immediate attention or action</b>.'),
            RuleCondMultiSelect: {
                divId: "RuleCondMultiSelect",
                separator: "<br>",
                keys: ['Value', 'Description'],
                uniqKey: 'ID',
                SelectedValue: { list: [] },
                onRowSelected: function (selectedData) {
                    $scope.Condition.RuleTableValues = selectedData;
                }
            },
            ExamTagsMultiSelect: {
                divId: "ExamTagsRule",
                keys: ['Key'],
                uniqKey: 'ID',
                SelectedValue: { list: [] },
                onSelectExamTags: function (selectedData) {
                    $scope.Condition.RuleTableValues = selectedData;
                }
            },
            SpecialtyMultiSelect: {
                divId: "SpecialtyRule",
                keys: ['SpecialityCode'],
                uniqKey: 'SpecialityId',
                SelectedValue: { list: [] },
                onSelectExamTags: function (selectedData) {
                    $scope.Condition.RuleTableValues = selectedData;
                }
            },
            RadSubspecialtyMultiSelect: {
                divId: "RadSubspecialtyRule",
                keys: ['RadSubspecialty'],
                uniqKey: 'RadSubspecialtyID',
                SelectedValue: { list: [] },
                onSelectRadSubspecialty: function (selectedData) {
                    $scope.Condition.RuleTableValues = selectedData;
                }
            },
        }
        $scope.SelectedValues = { SelectedRadiologists: [] };
        $scope.Rule = { Groups: [], RulesProviders: [] };
        $scope.RadiologistsFullSet = [];
        $scope.RuleTable = [];
        $scope.AllowedUser = [];
        $scope.MasterRadiologistsFullSet = [];
        $scope.RulesKey = [];
        $scope.MasterData = { Radiologists: [] };
        $scope.title = "Rule(s)";
        $scope.WorkListVisible = false;
        $scope.AddIsVisible = true;
        $scope.RuleResponse = [];
        $scope.Condition_index = 0;
        $scope.IsVisible = false;
        $scope.GroupConditionFlag = false;
        $scope.flag;
        $scope.AddOrEdit = "Add";
        $scope.selected_group = [];
        $scope.conditions_checked = [];
        $scope.Display = true;
        $scope.Show = false;
        $scope.EditIsVisible = false;
        $scope.myGrid = $('.myGrid').length;
        var oldTable = {};
        var EditRule = {};

        $scope.showAssignRadiologistCmp = { value: false };

        $scope.DOSopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            //cancelButtonClasses: 'dr-btn-none',
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                customRangeLabel: 'Custom range',
                //cancelLabel: 'Clear',
                //clearLabel: $scope.DateValue = {
                //    startDate: null,
                //    endDate: null
                //}
            },
            ranges: {
                'Today': [moment(), moment()],
                //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                //'Last 15 Days': [moment().subtract(14, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                //'This Month': [moment().startOf('month'), moment().endOf('month')],
                //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
                //'All DOS': [],

            }
        };
        vm.$onChanges = function (changes) {
            //$log.log('$onChanges > changes: ', changes);
            if (changes.rule) {
                $scope.Rule = changes.rule.currentValue;
            }
            if (changes.ruleTable) {
                $scope.RuleTable = changes.ruleTable.currentValue;
            }

        };
        vm.$onDestroy = function () {
            $scope.CloseRule();
            $scope.WorkListVisible = false;
        }
        vm.$onInit = function () {

            $scope.Rule = vm.rule;
            $scope.Rule.loading = false;
            $scope.RuleTable = vm.ruleTable;

            $scope.Condition = { AndOr: "AND", Time: "Minute" };
            $scope.maxTATValueMinutes = 2880;
            RuleService.GetMaxTATValueMinutes().then(function (val) {
                $scope.maxTATValueMinutes = val;
            });

            GetAllRadiologists();
            RuleSharedService.getHiddenTypes();
            if ($scope.Rule.IsWorkList == "2") {
                getLookupValue('TATType').then(function (data) { $scope.TATTypeList = data; });
                if (!$scope.Rule.TATType) {
                    $scope.Rule.TATType = 'Minutes';
                }
                if (!$scope.Rule.SLABreachType) {
                    $scope.Rule.SLABreachType = 'Minutes';
                }
            }
            GetAllSpeciality();
            GetAllRadSubspecialty();
            GetTenantsByUserID();
            $scope.DataObject.LoggedInUserRoles = $sessionStorage.currentUserData.userRoles;
        }
        $scope.SetRule = function () {
            var Groups = _.filter($scope.Rule.Groups, function (grp) {
                return grp.deleted != true;
            });

            _.each(Groups, function (grp) {
                _.each(grp.RulesConditions, function (cond) {
                    if (cond.StatusFlag != 'D' && cond.DateValue && cond.DateValue && cond.DateValue.label.includes("Custom")) {
                        cond.DateValue.startDate = moment(new Date(cond.DateValue.startDate)).format("MM-DD-YYYY");
                        cond.DateValue.endDate = moment(new Date(cond.DateValue.endDate)).format("MM-DD-YYYY");
                    }
                    if (cond.Value == 'H' && cond.HiddenType) {
                        cond.Value = cond.Value + ":" + cond.HiddenType.Value;
                    }
                });
            });

            $scope.Rule.RuleName = $scope.Rule.RuleName.trim();
            if ($scope.Rule.IsWorkList) {
                $scope.Rule.WorkListName = $scope.Rule.RuleName;
            }

            if (!$scope.Rule.RuleName) {
                $scope.Rule.RuleName = $scope.Rule.WorkListName;
                $scope.Rule.RuleDescription = $scope.Rule.WorkListName;

            }
            $scope.Rule.ModifyBy = $sessionStorage.currentUserData.userId;
            $scope.Rule.CreatedBy = $sessionStorage.currentUserData.userId;

            if ($scope.Rule.Groups[0].GroupID == 1) {
                $scope.Rule.Groups[0].GroupID = 0;
            }
            $scope.isLoading = true;
            if (!$scope.DataObject.isCustomColor) {
                $scope.Rule.RuleColorCode = null;
            }
            $q.all([
                RuleSharedService.SetRule($scope.Rule)
            ]).then(function (data) {

                var result = _.clone(data[0]);
                EditRule = $scope.Rule;
                $scope.Rule.Groups = result.Groups;
                $scope.Rule = RuleSharedService.VisualizeData($scope.Rule);
                stampTenantLock();

                $scope.isLoading = false;
                if (result.RuleID === -1) {
                    $scope.Rule.RuleName = undefined;
                    $scope.Rule.RuleDescription = undefined;
                    $scope.Rule.WorkListName = undefined;
                    toaster.warning({ body: "Worklist name already exists!" });
                }
                else {
                    $scope.onDeleteClearCondition();
                    $scope.Rule.RuleID = result.RuleID;

                    $scope.Rule.StatusFlag = 'M';
                    _.each($scope.Rule.Groups, function (group) {
                        _.each(group.RulesConditions, function (condition) {
                            if (condition.StatusFlag != 'D') {
                                condition.StatusFlag = 'M';
                            }
                        });
                    });
                    if ($scope.VisulizeBtn) {
                        $scope.Rule.Type = "A";
                        $scope.Rule.PageSize = 50;
                        $scope.Rule.gridId = uuidv4.newuuid();
                        $scope.WorkListVisible = true;
                        $scope.Show = true;
                        $scope.Rule.height = $(window).height();
                        $rootScope.$broadcast('event.Rule.Save', { 'Rule': $scope.Rule, HideWindow: false });
                    } else {

                        $rootScope.$broadcast('event.Rule.Save', { 'Rule': $scope.Rule, HideWindow: !$scope.VisulizeBtn });
                    }

                }
            }, function (error) {
                $scope.isLoading = false;
            });

        };

        $scope.SetRuleCondition = function () {
            // Belt and braces for the hidden Select Type entry: a TAT rule's tenant is fixed by its dropdown.
            if ($scope.Condition && $scope.Condition.RuleTable && !$scope.isRuleTypeAllowed($scope.Condition.RuleTable)) {
                toaster.warning({ body: "The tenant of a TAT rule is set from the Tenant dropdown; a Tenants condition cannot be added." });
                return;
            }

            var Values = '';
            if ($scope.Condition && $scope.Condition.RuleTableValues && $scope.Condition.RuleTableValues.length > 0) {
                if ($scope.Condition.RuleTable.Key == "Specialty") {
                    Values = _.join(_.map($scope.Condition.RuleTableValues, function (val) { return "'" + val.SpecialityId + "'"; }), ',');
                } else if ($scope.Condition.RuleTable.Key == "Rad Subspecialty") {
                    Values = _.join(_.map($scope.Condition.RuleTableValues, function (val) { return "'" + val.RadSubspecialtyID + "'"; }), ',');
                } else {
                    angular.forEach($scope.Condition.RuleTableValues, function (item) {
                        var val;
                        if (Values == '') {
                            val = ($scope.Condition.RuleTable.Key == "Exam Tags (RadAssist)" || $scope.Condition.RuleTable.Key == "Exam Tags (RadFlow)") ? item.Value : item.ID;
                            Values += "'" + val + "'";
                        }
                        else {
                            val = ($scope.Condition.RuleTable.Key == "Exam Tags (RadAssist)" || $scope.Condition.RuleTable.Key == "Exam Tags (RadFlow)") ? item.Value : item.ID;
                            Values += ',' + "'" + val + "'";
                        }
                    });
                }
            } else if ($scope.Condition && $scope.Condition.RuleTableValue) {
                if ($scope.Condition.RuleTable.List) {
                    Values += ($scope.Condition.RuleTable.Key == "Gender") ? "'" + $scope.Condition.RuleTableValue.ID + "'" : $scope.Condition.RuleTableValue.ID;
                }
                else if ($scope.Condition.RuleTable.Key == "Specialty") {
                    Values = "'" + $scope.Condition.RuleTableValue.SpecialityId + "'";
                }
                else if ($scope.Condition.RuleTable.Key == "Rad Subspecialty") {
                    Values = "'" + $scope.Condition.RuleTableValue.RadSubspecialtyID + "'";
                }
                else {
                    var val = ($scope.Condition.RuleTable.Key == "Exam Tags (RadAssist)" || $scope.Condition.RuleTable.Key == "Exam Tags (RadFlow)") ? $scope.Condition.RuleTableValue.Value : $scope.Condition.RuleTableValue.ID;
                    Values += "'" + val + "'";
                }
            }
            else if ($scope.Condition && $scope.Condition.TextValue) {

                if ($scope.Condition.TextValue.indexOf(",") != -1) {
                    $scope.arr = $scope.Condition.TextValue.split(",");
                    if ($scope.arr.length > 0) {
                        angular.forEach($scope.arr, function (data, index) {

                            if (data.trim().length > 0) {
                                if (Values != null && Values.length > 0) {
                                    Values += "," + data.trim();
                                }
                                else {
                                    Values = data.trim();
                                }
                            }

                        })

                    }
                } else if ($scope.Condition.RuleOperator.Key == "Start With" || $scope.Condition.RuleOperator.Key == "End With" || $scope.Condition.RuleOperator.Key == "Contains Words" || $scope.Condition.RuleOperator.Key == "Not Contains Words") {
                    Values = $scope.Condition.TextValue;
                } else {
                    Values = "'" + $scope.Condition.TextValue + "'";
                }

            }
            else if ($scope.Condition && $scope.Condition.DateValue && $scope.Condition.DateValue.startDate && $scope.Condition.DateValue.endDate) {

                if ($scope.Condition.DateValue && $scope.Condition.DateValue.label.includes('Custom')) {
                    //Values = $scope.Condition && $scope.Condition.DateValue.label + " '" + moment(new Date($scope.Condition.DateValue.startDate)).format('MM-DD-YYYY') + "' and '" + moment(new Date($scope.Condition.DateValue.endDate)).format('MM-DD-YYYY') + "'";
                    Values = $scope.Condition && $scope.Condition.DateValue.label + " '" + moment(new Date($scope.Condition.DateValue.startDate)).format('MM-DD-YYYY') + "' and '" + moment(new Date($scope.Condition.DateValue.endDate)).format('MM-DD-YYYY') + "'";
                }
                else {
                    Values = $scope.Condition.DateValue.label;
                }
            }
            else {
                return;
            }
            if (($scope.Condition.RuleTable.Key == "Patient Class" || $scope.Condition.RuleTable.Key == "Tenants") && ($scope.Condition.RuleOperator.Key == "Is" || $scope.Condition.RuleOperator.Key == "Is Not")) {

                Values = "'" + $scope.Condition.RuleTableValue.ID + "'";
            }
            if ($scope.Condition.RuleTable.Key == "Study has been unread" && $scope.Condition.RuleOperator.Key == "Before Time" || $scope.Condition.RuleOperator.Key == "After Time") {

                Values = $scope.Condition.TextValue + " " + $scope.Condition.Time;
            }
            if (($scope.Condition.RuleTable.Key == 'Ordering Physician' || $scope.Condition.RuleTable.Key == 'Reason' || $scope.Condition.RuleTable.Key == 'Procedure Description') && ($scope.Condition.RuleOperator.Key == 'Contains Words' || $scope.Condition.RuleOperator.Key == 'Not Contains Words')) {
                $scope.Condition.ColumnName = $scope.Condition.RuleTable.Contains_ColumnName;
            }
            else {
                $scope.Condition.ColumnName = $scope.Condition.RuleTable.ID;
            }
            $scope.Condition.StatusFlag = "N";

            $scope.Condition.Checked = false;
            $scope.Condition.Operator = $scope.Condition.RuleOperator.Value;

            $scope.Condition.Value = Values;
            $scope.Condition.ModifyBy = $sessionStorage.currentUserData.userId;

            if (!$scope.EditIsVisible) {

                var groupIndex = 0;
                if ($scope.Rule.Groups && $scope.Rule.Groups.length > 0) {
                    groupIndex = _.findIndex($scope.Rule.Groups, { 'GroupID': 0, 'deleted': false });
                    if (groupIndex == -1) {
                        var group = { GroupID: 0, RulesConditions: [], deleted: false };
                        $scope.Rule.Groups.push(group);
                    }
                } else {
                    $scope.Rule.Groups = [];
                    var group = { GroupID: 0, RulesConditions: [], deleted: false };
                    $scope.Rule.Groups.push(group);
                }
                if (groupIndex == -1) {
                    $scope.Rule.Groups[$scope.Rule.Groups.length - 1].RulesConditions.push($scope.Condition);
                } else {
                    $scope.Rule.Groups[groupIndex].RulesConditions.push($scope.Condition);

                }
                //$scope.Rule.Groups = groups;

                if ($scope.Condition.RuleTable.Key == 'Procedure Description') {
                    LoadUserByProcedure(Values, ($scope.Condition.Operator == '<>' ? false : true));
                }
            } else {
                $scope.Condition.Operator = $scope.Condition.RuleOperator.Value;
                $scope.Condition.OperatorText = $scope.Condition.RuleOperator.Key;
                $scope.Condition.edit = false;
                if ($scope.editcond != $scope.Condition && $scope.editcond == 0) {
                    $scope.StatusFlag = "N";

                }
                else {
                    $scope.StatusFlag = "M";
                    $scope.Condition.StatusFlag = "M";
                    $scope.Condition.ConditionText = null;
                }

                var groupIndex = _.findIndex($scope.Rule.Groups, { 'edit': true });
                var conditionIndex = _.findIndex($scope.Rule.Groups[groupIndex].RulesConditions, { 'edit': true });
                $scope.Rule.Groups[groupIndex].RulesConditions[conditionIndex] = _.clone($scope.Condition);
                $scope.AddOrEdit = "Add";
                $scope.EditIsVisible = false;

            }
            SetConditionValueDefault();
        };

        $scope.GetRuleCollections = function (table, search) {
            if ($scope.Condition && $scope.Condition.RuleTable) {
                if ((!$scope.Condition.Collections || $scope.Condition.Collections.length == 0) || (search && search.isSearched)) {
                    if (table) {
                        table.CreatedBy = $sessionStorage.currentUserData.userId;
                    }
                    if (!table) { return; }
                    if (oldTable == table && Collections.length == 200)
                        if (table.List) {
                            $scope.Condition.Collections = table.List;
                            return;
                        }
                    table.SearchKey = null;
                    if (search && search.searchKey) {
                        table.SearchKey = search.searchKey;
                    }
                    switch (table.Key) {
                        case "Exam Priority":
                            if (!$scope.Condition.Collections || $scope.Condition.Collections.length == 0) {
                                getLookupValue("StudyPriority").then(function (data) {
                                    $scope.Condition.Collections = SharedService.mapPriorityToCollection(data, true);
                                });
                            }
                            break;
                        case "Exam Status":
                            $scope.Condition.Collections = table.List;
                            $scope.HiddenTypeList = RuleSharedService.getLocalHiddenTypes();
                            $scope.Condition.HiddenType = $scope.HiddenTypeList[0];
                            break;
                        case "Exam Tags (RadAssist)":
                            if (!$scope.Condition.Collections || $scope.Condition.Collections.length == 0) {
                                getLookupValue("ExamTags").then(function (data) {
                                    $scope.Condition.Collections = data;
                                });
                            }
                            break;

                        case "Exam Tags (RadFlow)":
                            if (!$scope.Condition.Collections || $scope.Condition.Collections.length == 0) {
                                getLookupValue("RadExamTag").then(function (data) {
                                    $scope.Condition.Collections = data;
                                });
                            }
                            break;

                        case "Specialty":
                            $scope.Condition.Collections = SpecialitiesList;
                            break;
                        case "Rad Subspecialty":
                            $scope.Condition.Collections = RadSubspecialtyList;
                            break;
                        default:
                            if ($scope.RuleTable && $scope.Condition.RuleTable.Key) {
                                var idx = _.findIndex($scope.RuleTable, { Key: $scope.Condition.RuleTable.Key });
                                if (idx != -1) {
                                    if ($scope.RuleTable[idx].List && $scope.RuleTable[idx].List.length > 0 && !(search && search.isSearched)) {
                                        $scope.Condition.Collections = $scope.RuleTable[idx].List;
                                    }
                                    else {
                                        RuleService.GetRuleCollections(table).then(function (result) {
                                            var existingCollections = _.cloneDeep(($scope.Condition.Collections) ? $scope.Condition.Collections : []);
                                            _.each(result, function (val) {
                                                var idx = _.findIndex(existingCollections, { "ID": val.ID });
                                                if (idx == -1) {
                                                    existingCollections.push(val);
                                                }
                                            });

                                            $scope.Condition.Collections = existingCollections;
                                            $scope.RuleTable[idx].List = $scope.Condition.Collections;
                                        });
                                    }
                                }
                            }
                            break;
                    }
                }
            }
        };

        $scope.SearchRuleCollection = function (searchObj) {
            console.log("SearchRuleCollection > ", searchObj);
            $scope.GetRuleCollections($scope.Condition.RuleTable, searchObj);
        }

        //to-do : disable AndOr dropdown for first condition
        $scope.disableAndOr = function () {
            //var firstGroup = _.filter($scope.Rule.Groups, { 'GroupID': 0 });
            //var notDeletedConitions = [];
            //if (firstGroup.length > 0) {
            //    notDeletedConitions = _.filter(firstGroup[0].RulesConditions, function (cond) {
            //        return cond.StatusFlag != 'D';
            //    });
            //    if (notDeletedConitions.length == 0) { return true; }
            //}
            //else {
            //    return true;
            //}
            //if (!$scope.Condition.RuleTable) { return false; }
            //if (notDeletedConitions[0].edit) { return true; }
            //else { return false;}

        }
        $scope.onOpenClose = function (isOpen, $select) {
            $select.search = "";
        };

        $scope.resetDateRange = function () {
            //////$log.log("resetDateRange");
            //$scope.DOSopts.ranges = {
            //    'Today': [moment(), moment()],
            //    //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            //    'Last 3 Days': [moment().subtract(2, 'days'), moment()],
            //    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            //    //'Last 15 Days': [moment().subtract(14, 'days'), moment()],
            //    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            //    //'This Month': [moment().startOf('month'), moment().endOf('month')],
            //    //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            //    'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],
            //    //'All DOS': [],
            //};
            //angular.element(document).ready(function () {
            //    angular.element('.drp-buttons .cancelBtn').click(function () {
            //        angular.element('#daterange3').val('');
            //        $scope.OrderDate = {
            //            startDate: null,
            //            endDate: null
            //        };
            //    });
            //});
            //angular.element(document).ready(function () {
            //    $scope.OrderDateType = ($scope.OrderDate.label) ? $scope.OrderDate.label : $scope.OrderDateType;
            //    if ($scope.OrderDate.startDate && $scope.OrderDate.endDate) {
            //        if ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom'))
            //            $scope.OrderDateType = ($scope.OrderDateType != null && $scope.OrderDateType.match('Custom')) ? ($scope.OrderDateType + '#' + moment(new Date($scope.OrderDate.startDate)).format("MM-DD-YYYY") + '#' +
            //                moment(new Date($scope.OrderDate.endDate)).format("MM-DD-YYYY")) : $scope.OrderDateType;

            //    }
            //    else
            //        $scope.OrderDateType = 'Clear';
            //});
        }

        $scope.onDeleteClearCondition = function () {
            if ($scope.Condition.edit) {
                $scope.EditIsVisible = false;
                $scope.AddOrEdit = "Add";
            }
            SetConditionValueDefault();
        };

        $scope.AssignRadiologists = function () {
            $('#RadiologistComponentRule').modal('show');
            $scope.modalTitle = 'Assign Radiologists';
            $scope.SavebtnText = 'OK';
        };

        $scope.GetRuleDetails = function (ruleObj, Flag) {
            //$log.log('GetRuleDetails');
            $scope.isLoading = true;
            RuleSharedService.SetData($scope.RuleTable, $scope.RadiologistsFullSet);
            $q.all([
                RuleSharedService.GetRuleDetails(ruleObj, Flag)
            ]).then(function (data) {
                $scope.isLoading = false;
                if (data && data.length > 0) {
                    $scope.Rule = data[0].Rule;
                    if ($scope.Rule.RuleColorCode) {
                        $scope.DataObject.isCustomColor = true;
                    }
                    $scope.Rule.RuleName = $scope.Rule.RuleName.trim();
                    $scope.SelectedValues.SelectedRadiologists = data[0].selectedRadiologists;
                    $scope.AllowedUser = data[0].AllowedUser;
                    $scope.HiddenTypeList = RuleSharedService.getLocalHiddenTypes();
                    if ($scope.Rule.IsWorkList == "2") {
                        $scope.Rule.TATValue = RuleSharedService.converMinToSelectedType($scope.Rule.TATType, $scope.Rule.TAT);
                        $scope.Rule.SLABreachType = ($scope.Rule.SLABreachType) ? $scope.Rule.SLABreachType : "Minutes";
                        $scope.Rule.SLABreachValue = RuleSharedService.converMinToSelectedType($scope.Rule.SLABreachType, $scope.Rule.SLABreachTime);
                    }
                    // Rule.TenantID came back from Get_RuleList/Get_RuleDetails; reflect it in the
                    // (disabled) dropdown and lock its Tenants condition.
                    syncTenantSelection();
                    stampTenantLock();
                }
            });


        };

        function LoadUserByProcedure(ids, IsShow) {
            $scope.AllowedUser = [];
            RuleService.GetSpecialityUserByProcedure(ids).then(function (resp) {
                var userIds = resp;
                angular.forEach(userIds, function (item) {
                    var obj = filterFilter($scope.RadiologistsFullSet, {
                        Id: item
                    })[0];
                    if (IsShow) {
                        $scope.AllowedUser.push(obj);
                    } else {
                        var idx = $scope.RadiologistsFullSet.indexOf(obj);
                        if (idx != -1) {
                            $scope.RadiologistsFullSet.splice(idx, 1);
                        }
                    }
                });
            }, function (err) {
                $scope.RadiologistsFullSet = null;
            });
        }


        $scope.OpenRule = function (objRule) {
            //$log.log("OpenRule");

            if (objRule && objRule.RuleID) {
                $scope.Rule = _.clone(objRule);
                EditRule = _.clone(objRule);
                $scope.Rule.StatusFlag = "M";

                $scope.GetRuleDetails($scope.Rule, "EDIT");
            } else {
                $scope.Rule.StatusFlag = "N";
                applyDefaultTenantForNewRule();
                syncTenantSelection();
            }
        };


        $scope.CloseRule = function () {
            $rootScope.$broadcast('event.Rule.Close', { 'Rule': EditRule, HideWindow: true });
        }

        var GetAllRadiologists = function () {
            //$log.log("GetAllRadiologists");
            $q.all([
                RuleSharedService.GetAllRadiologists(),
                RuleSharedService.GetRadiologistsByAccessibleSites(),
                RuleSharedService.GetAccessibleTenantSiteIDs()
            ]).then(function (data) {
                // Tenant-wide list: resolves a rule's existing providers even when they sit on sites
                // the editing admin cannot access, so nothing already assigned goes missing.
                $scope.RadiologistsFullSet = data[0];
                $scope.MasterRadiologistsFullSet = data[0];
                // Assign Radiologists picker: only radiologists on the admin's accessible sites. The
                // grid keeps that scope when its own site filter is empty (default-tenant-site-ids).
                $scope.MasterData.Radiologists = _.uniqBy(data[1] || [], 'Id');
                $scope.MasterData.AccessibleTenantSiteIDs = data[2] || [];
                $scope.OpenRule(vm.rule);
            });
        }
        $scope.ResetCollection = function (ResetValueFlag) {
            if (ResetValueFlag) {
                if ($scope.Condition.RuleTable.RuleOperator.length == 1) {
                    $scope.Condition.RuleOperator = {};
                    $scope.Condition.RuleOperator = $scope.Condition.RuleTable.RuleOperator[0];
                }
                else {
                    $scope.Condition.RuleOperator = null;
                }
            }
            $scope.Condition.Collections = [];
            $scope.ResetValue();
        };


        $scope.EditCondition = function (group) {

            $scope.EditIsVisible = true;
            var groupIndex = _.findIndex($scope.Rule.Groups, { 'edit': true });
            var cond = _.find($scope.Rule.Groups[groupIndex].RulesConditions, { 'edit': true });
            if (!cond.RuleTable.IsDate) {
                cond.RuleTable.Ids = null;
            }
            if (cond.RuleTable.IsCollection && (cond.RuleOperator && !cond.RuleOperator.IsText)) {
                $scope.GetRuleCollections(cond.RuleTable);
            }
            $scope.Condition = _.clone(cond);
            if ($scope.Condition.RuleOperator.Key == "Before Time" || $scope.Condition.RuleOperator.Key == "After Time") {
                var StudyHasBeenUnreadTextValue = [];
                StudyHasBeenUnreadTextValue = $scope.Condition.Value.split(' ');
                if (StudyHasBeenUnreadTextValue.length > 0) {
                    $scope.Condition.TextValue = StudyHasBeenUnreadTextValue[0];
                    $scope.Condition.Time = StudyHasBeenUnreadTextValue[1];
                }
            }
            $scope.editcond = _.clone(cond);
            $scope.AddOrEdit = "Update";

            if (cond && cond.RuleTable && $scope.Condition.RuleTableValues) {
                if (cond.RuleTable.Key == "Specialty") {
                    $scope.DataObject.SpecialtyMultiSelect.SelectedValue = { list: $scope.Condition.RuleTableValues };
                }
                else if (cond.RuleTable.Key.includes("Exam Tags")) {
                    $scope.DataObject.ExamTagsMultiSelect.SelectedValue = { list: $scope.Condition.RuleTableValues };
                }
                else if (cond.RuleTable.Key == "Rad Subspecialty") {
                    $scope.DataObject.RadSubspecialtyMultiSelect.SelectedValue = { list: $scope.Condition.RuleTableValues };
                }
                else {
                    $scope.DataObject.RuleCondMultiSelect.SelectedValue = { list: $scope.Condition.RuleTableValues };
                }
            }
        }

        $scope.Cancel = function (cond) {
            $scope.AddOrEdit = "Add";
            $scope.EditIsVisible = false;
            var groupIndex = _.findIndex($scope.Rule.Groups, { 'edit': true });
            var conditonIndex = _.findIndex($scope.Rule.Groups[groupIndex].RulesConditions, { 'edit': true });

            $scope.Rule.Groups[groupIndex].RulesConditions[conditonIndex] = _.clone($scope.editcond);
            SetConditionValueDefault();

        }
        function SetConditionValueDefault() {

            $scope.Condition = null;
            $scope.Condition = {
                AndOr: "AND",
                Time: "Minute",
                HiddenType: ($scope.HiddenTypeList) ? $scope.HiddenTypeList[0] : null
            };
        }
        $scope.ValidateRule = function () {

            var CheckConditionFlag = false;
            var validationSigndate = [];
            var validationDos = [];
            var validationExam = [];
            var validationTenant = [];
            var validationSites = [];
            var validationRadSubspecialty = [];
            if ($scope.Rule.IsWorkList == '1') {
                if ($scope.Rule.IsSmartWorklist && (!$scope.Rule.WorklistPageSize || $scope.Rule.WorklistPageSize <= 0)) {
                    toaster.warning({ body: "The page size must be greater than zero when the smart worklist is enabled!" });
                    return;
                }
            }
            if ($scope.Rule.IsWorkList == '2') {
                // Tenant is chosen at creation and fixed afterwards; legacy rules without one can still be edited.
                if (!$scope.Rule.RuleID && ($scope.Rule.TenantID === null || $scope.Rule.TenantID === undefined)) {
                    toaster.warning({ body: "Please select a tenant!" });
                    return;
                }
                if (!$scope.Rule.TATValue || $scope.Rule.TATValue == "") {
                    toaster.warning({ body: "Please add TAT Value!" });
                    return;
                }
                else if (!$scope.Rule.SLABreachValue || $scope.Rule.SLABreachValue == "") {
                    toaster.warning({ body: "Please add SLA Breach Time!" });
                    return;
                }
                else {
                    $scope.Rule.TAT = converTimeInMin($scope.Rule.TATType, $scope.Rule.TATValue);
                    $scope.Rule.SLABreachTime = converTimeInMin($scope.Rule.SLABreachType, $scope.Rule.SLABreachValue);
                    if (parseInt($scope.Rule.TAT) > $scope.maxTATValueMinutes) {
                        toaster.warning({ body: "TAT value exceeds the maximum allowed limit!" });
                        return;
                    }
                    if (parseInt($scope.Rule.TAT) < parseInt($scope.Rule.SLABreachTime)) {
                        toaster.warning({ body: "TAT Value must be greater then SLA Breach Time!" });
                        return;
                    }
                }
                // TAT/SLA rules apply to every radiologist; saving an empty list also clears any
                // radiologists assigned to older TAT rules (Proc_Set_RuleProviders deletes then inserts).
                $scope.Rule.RulesProviders = [];
                $scope.SelectedValues.SelectedRadiologists = [];
            }

            if ($scope.Rule.RulesProviders === undefined) {

                $scope.Rule.RulesProviders = [];
            }
            if ($scope.Rule.RulesProviders.length == 0 && $scope.Rule.IsWorkList != '2') {
                toaster.warning({ body: "Please select at least one radiologist!" });
                return;
            }

            var validationFlag = false;
            var validateOR = true;
            var Conditions = [];
            var Groups = _.filter($scope.Rule.Groups, function (grp) {
                return grp.deleted != true;
            });

            _.each(Groups, function (group) {
                Conditions = _.filter(group.RulesConditions, function (cond) {
                    return cond.StatusFlag != "D";
                });
                if (Conditions.length > 0) {
                    group.GroupOperator = Conditions[0].AndOr;
                    validationFlag = true;
                    if (validationSigndate.length == 0) {
                        validationSigndate = _.filter(Conditions, function (cond) {
                            return cond.RuleTable.Key == 'Signed Date';
                        });
                    }
                    if (validationExam.length == 0) {
                        validationExam = _.filter(Conditions, function (cond) {
                            return cond.RuleTable.Key == 'Exam Status';
                        });
                    }
                    if (validationDos.length == 0) {
                        validationDos = _.filter(Conditions, function (cond) {
                            return cond.RuleTable.Key == 'DOS';
                        });
                    }
                    if (validationTenant.length == 0) {
                        validationTenant = _.filter(Conditions, function (cond) {
                            return cond.RuleTable.Key == 'Tenants';
                        });
                    }
                    if (validationSites.length == 0) {
                        validationSites = _.filter(Conditions, function (cond) {
                            return cond.RuleTable.Key == 'Sites';
                        });
                    }
                    if (validationRadSubspecialty.length == 0) {
                        validationRadSubspecialty = _.filter(Conditions, function (cond) {
                            return cond.RuleTable.Key == 'Rad Subspecialty';
                        });
                    }
                }
                // The locked tenant condition always leads group 0 with AND, so the "no leading OR"
                // guard applies to the first condition the admin added.
                var firstOwnCondition = _.find(Conditions, function (cond) { return !cond.IsLocked; });
                if (group.GroupID == 0 && firstOwnCondition && firstOwnCondition.AndOr == "OR")
                    validateOR = false;
            });

            if (!validationFlag && $scope.Rule.StatusFlag != "D") {
                toaster.warning({ body: "Empty Rule can't be created!" });
                return;
            }
            // A TAT rule carries exactly one Tenants condition, and it is the rule's own tenant.
            if ($scope.Rule.IsWorkList == '2' && $scope.Rule.TenantID !== null && $scope.Rule.TenantID !== undefined) {
                var tenantConditions = [];
                _.each(Groups, function (group) {
                    _.each(group.RulesConditions, function (cond) {
                        if (cond.StatusFlag != 'D' && cond.RuleTable && cond.RuleTable.Key == 'Tenants') {
                            tenantConditions.push(cond);
                        }
                    });
                });
                if (tenantConditions.length != 1 || !isTenantLockCondition(tenantConditions[0])) {
                    toaster.warning({ body: "A TAT rule must have exactly one Tenants condition, and it must match the selected tenant." });
                    return;
                }
            }
            if (validationRadSubspecialty.length > 0 && validationTenant.length == 0) {
                toaster.warning({ body: "Tenants condition is required when 'Rad Subspecialty' condition is added. Please add at least one 'Tenants' condition!" });
                return;
            }
            if (validationRadSubspecialty.length > 0 && validationSites.length == 0) {
                toaster.warning({ body: "Sites condition is required when 'Rad Subspecialty' condition is added. Please add at least one 'Sites' condition!" });
                return;
            }
            if ($scope.Rule.IsWorkList && $scope.Rule.WorkListName && ($scope.Rule.WorkListName.toLowerCase() == 'practice worklist' || $scope.Rule.WorkListName.toLowerCase() == 'priority worklist' || $scope.Rule.WorkListName.toLowerCase() == 'personal worklist')) {
                swal($scope.Rule.WorkListName + ' is reserved name. Please enter different worklist name!');
                return;
            }
            if (!validateOR) {
                toaster.warning({ body: "Cannot set 'OR' operator for first rule condition" });

                return;
            }

            var message = "";
            var emptyExamOrDOS = false;
            if ($scope.Rule.IsWorkList != '2') {
                if (validationExam.length == 0 && validationDos.length == 0) {
                    message = "A default value for \"DOS\" (Date of Service) to be the last 7 days and \"Exam Status\" to be the \"Result Pending\".<br>Do you want to Continue?";
                    emptyExamOrDOS = true;
                } else if (validationExam.length == 0) {
                    message = "A default value for \"Exam Status\" to be the \"Result Pending\".<br>Do you want to Continue?";
                    emptyExamOrDOS = true;
                } else if (validationDos.length == 0) {
                    message = "A default value for \"DOS\" (Date of Service) to be the last 7 days.<br>Do you want to Continue?";
                    emptyExamOrDOS = true;
                }
            }
            if (validationSigndate.length > 0 || !emptyExamOrDOS) {
                CheckConditionFlag = true;
            }

            if (!CheckConditionFlag) {
                swal({
                    title: message,
                    type: "warning",
                    html: true,
                    customClass: 'swal-wide',
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Continue",
                    cancelButtonText: "Cancel",
                },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.SetRule();
                        }
                    });
            } else {
                $scope.SetRule();

            }

        }

        $scope.ResetValue = function () {
            $scope.Condition.RuleTableValues = null;
            $scope.Condition.RuleTableValue = null;
            $scope.Condition.TextValue = null;
            $scope.Condition.Value = null;
            $scope.Condition.DateValue = null;
            $scope.DataObject.ExamTagsMultiSelect.SelectedValue = { list: [] };
            $scope.DataObject.SpecialtyMultiSelect.SelectedValue = { list: [] };
            $scope.DataObject.RadSubspecialtyMultiSelect.SelectedValue = { list: [] };
            $scope.DataObject.RuleCondMultiSelect.SelectedValue = { list: [] };
        }

        $scope.SaveSelectedRadiologist = function () {
            $('#RadiologistComponentRule').modal('hide');
            if ($scope.SelectedValues.SelectedRadiologists.length > 0) {
                $scope.Rule.RulesProviders = [];
                angular.forEach($scope.SelectedValues.SelectedRadiologists, function (item) {
                    var idx = _.findIndex($scope.Rule.RulesProviders, { ProviderID: item.Id });
                    if (idx == -1) {
                        $scope.Rule.RulesProviders.push({ ProviderID: item.Id, RuleID: $scope.Rule.RuleID });
                    }
                });
            }
            else {
                $scope.Rule.RulesProviders = [];
            }
        }

        $scope.AssignUserCancel = function () {
            if ($scope.Rule) {
                if ($scope.Rule.RulesProviders) {
                    $scope.SelectedValues.SelectedRadiologists = [];
                    _.each($scope.Rule.RulesProviders, function (Provider) {
                        var obj = _.find($scope.RadiologistsFullSet, { Id: Provider.ProviderID });
                        if (obj) {
                            $scope.SelectedValues.SelectedRadiologists.push(obj);
                        }
                    });
                }
            }
            else {
                $scope.SelectedValues.SelectedRadiologists = [];
            }
        }

        $scope.SubmitEventPreventDefault = function (event) {
            if (($("#RadiologistComponentRule").data('bs.modal') || {}).isShown) {
                if (event.keyCode === 13) { event.preventDefault() }
            }
        };
        function converTimeInMin(type, value) {
            switch (type) {
                case 'Day':
                    return (1440 * value);
                    break;
                case 'Hour':
                    return (60 * value);
                    break;
                case 'Minutes':
                    return (value);
                    break;
            }
        }

        function getLookupValue(lookupType) {
            var d = $q.defer();
            RuleService.GetLookupByType(lookupType).then(function (data) {
                d.resolve(data);
            });
            return d.promise;
        }
        function GetAllSpeciality() {
            RuleService.GetAllSpeciality().then(function (result) {
                SpecialitiesList = result;
            });
        }
        function GetAllRadSubspecialty() {
            RuleService.GetAllRadSubspecialty($sessionStorage.currentUserData.userId).then(function (result) {
                RadSubspecialtyList = result;
            });
        }

        $scope.CloseVisualizePanel = function () {
            var timeout = $timeout(function () {
                $scope.VisulizeBtn = false;
                $scope.WorkListVisible = false;
                $timeout.cancel(timeout);
                timeout = null;
            }, 1);
        }
        $scope.onCustomColortoggle = function () {
            if ($scope.DataObject.isCustomColor) {
                $scope.Rule.RuleColorCode = ($scope.Rule.RuleColorCode) ? $scope.Rule.RuleColorCode : $scope.DataObject.defaultRuleColorCode
            }
        }

        function GetTenantsByUserID() {
            var d = $q.defer();
            ManageLocationService.GetTenantsByUserID({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.MasterData.UserTenants = result;
                buildTenantOptions();
                d.resolve();
            }, function () {
                $scope.MasterData.UserTenants = [];
                buildTenantOptions();
                d.resolve();
            });
            return d.promise;
        }

        //#region TAT rule tenant (Rule.TenantID; a TAT rule belongs to exactly one tenant)
        $scope.MasterData.TenantOptions = [];
        var tenantsReady = false;
        function buildTenantOptions() {
            // Order as GetTenantsByUserID returns it: the admin's default tenant first. No "All Tenants".
            $scope.MasterData.TenantOptions = ($scope.MasterData.UserTenants || []).slice();
            tenantsReady = true;
            // Tenants may arrive after the rule was opened; apply the default and resolve the
            // selection either way.
            applyDefaultTenantForNewRule();
            syncTenantSelection();
            stampTenantLock();
        }
        // An existing rule can belong to a tenant the editing admin is not mapped to. Add a
        // placeholder option so the (disabled) dropdown shows it and it round-trips unchanged.
        function ensureTenantOption() {
            var id = $scope.Rule ? $scope.Rule.TenantID : null;
            if (id === null || id === undefined) { return; }
            var known = _.find($scope.MasterData.TenantOptions, function (t) { return t.TenantID == id; });
            if (!known) {
                $scope.MasterData.TenantOptions.push({ TenantID: id, DisplayName: 'Tenant #' + id });
            }
        }
        function isNewTATRule() {
            var rule = $scope.Rule;
            return !!rule && rule.StatusFlag === 'N' && !rule.RuleID && rule.IsWorkList == '2';
        }
        // A brand-new TAT rule preselects the FIRST tenant in display order. An explicit choice is kept.
        var tenantTouched = false;
        function applyDefaultTenantForNewRule() {
            if (!isNewTATRule() || tenantTouched || !tenantsReady) { return; }
            var rule = $scope.Rule;
            if (rule.TenantID === null || rule.TenantID === undefined) {
                var first = $scope.MasterData.TenantOptions[0];
                if (first) {
                    rule.TenantID = first.TenantID;
                    onTenantChanged();
                }
            }
        }
        // ui-select binds the option object (TenantSelection.Obj); Rule.TenantID is what SetRule posts.
        // The template disables the dropdown once the rule exists, so this only fires while creating.
        $scope.TenantSelection = { Obj: null };
        $scope.onTenantSelected = function () {
            tenantTouched = true;
            var option = $scope.TenantSelection.Obj;
            $scope.Rule.TenantID = option ? option.TenantID : null;
            onTenantChanged();
        };
        function syncTenantSelection() {
            ensureTenantOption();
            var id = $scope.Rule ? $scope.Rule.TenantID : null;
            $scope.TenantSelection.Obj = _.find($scope.MasterData.TenantOptions, function (t) { return t.TenantID == id; }) || null;
        }
        // What follows the tenant: the prefilled Tenants condition (new rules only). TAT rules have no
        // radiologist assignment, so nothing else depends on it.
        function onTenantChanged() {
            if (isNewTATRule()) {
                prefillTenantCondition();
            }
        }
        // Adds (or replaces) the condition "Tenants Is <tenant>" on a new TAT rule, shaped the way
        // SetRuleCondition builds one from the form so display, save and re-edit work unchanged.
        function prefillTenantCondition() {
            var rule = $scope.Rule;
            var tenant = _.find($scope.MasterData.TenantOptions, function (t) { return t.TenantID == rule.TenantID; });
            var tenantsTable = _.find($scope.RuleTable || [], { Key: 'Tenants' });
            if (!tenant || !tenantsTable) { return; }
            if (!_.isArray(rule.Groups) || rule.Groups.length === 0) {
                rule.Groups = [{ GroupID: 0, RulesConditions: [], deleted: false }];
            }
            var group = _.find(rule.Groups, { GroupID: 0, deleted: false }) || rule.Groups[0];
            // Drop the previous prefill (tenant changed before save); leave anything the admin added.
            group.RulesConditions = _.reject(group.RulesConditions || [], { IsTenantPrefill: true });
            var table = angular.copy(tenantsTable);
            var operator = _.find(table.RuleOperator, { Key: 'Is' }) || { Key: 'Is', Value: '=' };
            group.RulesConditions.unshift({
                AndOr: 'AND',
                Time: 'Minute',
                RuleTable: table,
                RuleOperator: operator,
                Operator: operator.Value,
                OperatorText: operator.Key,
                ColumnName: table.ID,
                RuleTableValue: { ID: tenant.TenantID, Value: tenant.Name || tenant.DisplayName },
                Value: "'" + tenant.TenantID + "'",
                StatusFlag: 'N',
                Checked: false,
                ModifyBy: $sessionStorage.currentUserData.userId,
                IsTenantPrefill: true,
                IsLocked: true
            });
        }
        // The one condition an admin cannot touch on a TAT rule: "Tenants Is <Rule.TenantID>". Create
        // stamps IsLocked at prefill; existing rules are re-stamped after every load and save because
        // the server round-trip rebuilds the conditions and drops client-only flags.
        function isTenantLockCondition(cond) {
            var rule = $scope.Rule;
            if (!rule || rule.IsWorkList != '2' || rule.TenantID === null || rule.TenantID === undefined) { return false; }
            if (!cond || cond.StatusFlag == 'D' || !cond.RuleTable || cond.RuleTable.Key != 'Tenants') { return false; }
            var operator = cond.Operator || (cond.RuleOperator && cond.RuleOperator.Value);
            if (operator != '=') { return false; }
            var value = (cond.Value === null || cond.Value === undefined) ? '' : String(cond.Value);
            return value.replace(/'/g, '') == String(rule.TenantID);
        }
        function stampTenantLock() {
            var rule = $scope.Rule;
            if (!rule || !_.isArray(rule.Groups)) { return; }
            var locked = 0;
            _.each(rule.Groups, function (group) {
                _.each(group.RulesConditions || [], function (cond) {
                    if (isTenantLockCondition(cond)) { cond.IsLocked = true; locked++; }
                });
            });
            // An existing TAT rule whose tenant was assigned without a matching condition (e.g. by the DB
            // team) gets the locked condition added here, since "Tenants" is no longer offered as a type.
            // It is persisted on the next save; any stray Tenants condition stays deletable.
            if (locked === 0 && rule.RuleID && rule.IsWorkList == '2' && rule.TenantID !== null && rule.TenantID !== undefined && tenantsReady) {
                prefillTenantCondition();
            }
        }
        // Select Type: a TAT rule's tenant comes from the dropdown, so "Tenants" is not offered as a condition.
        $scope.isRuleTypeAllowed = function (table) {
            return !($scope.Rule && $scope.Rule.IsWorkList == '2' && table && table.Key == 'Tenants');
        };
        //#endregion TAT rule tenant
    }
}());




(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('comprulecondition', {
            templateUrl: 'app/theme/components/rule-condition-cmp/rule-condition-cmp.html',
            bindings: {
                rule: '<',
                ruleSetting:'<',
                onEdit: '&',
                onDelete:'&',
                viewMode: '<',
                onClear:'&',
            },
            controller: CompRuleConditionController
        });

    /** @ngInject */
    function CompRuleConditionController($scope, $rootScope, $state, $interval, $sessionStorage, $log, $q, $timeout, $filter, $sce, $uibModal, APP_CONSTANTS, RuleService, RuleSharedService) {
        var vm = this;
        
        $scope.Rule = { Groups: [], RulesProviders: [] };
        $scope.selected_group = [];
        $scope.conditions_checked = [];

        vm.$onChanges = function (changes) {
            $log.log('$onChanges > changes: ', changes);
            $scope.Rule = changes.rule.currentValue;

            

        };
        vm.$onDestroy = function () {
        }
        vm.$onInit = function () {
            $log.log('$onInit');
            $scope.Rule = vm.rule;
            $scope.Condition = { AndOr: "AND" };
            
        }

        $scope.DeleteCondition = function (cond) {
            cond.StatusFlag = "D";
            
            _.each($scope.Rule.Groups, function (group) {
                var deletedCondtions = _.filter(group.RulesConditions, { 'StatusFlag': 'D' });
                if (group.RulesConditions.length == deletedCondtions.length) {
                    group.deleted = true;
                    group.GroupID = -1;
                }
            });

            var deletedGroups = _.filter($scope.Rule.Groups, { 'deleted': false });
            _.each(deletedGroups, function (dGroup, index) {
                dGroup.GroupID = index;
            });
            vm.onDelete();
        };

        $scope.CreateConditionsGroup = function () {
            $scope.conditions_checked = null;
            var groups = _.filter($scope.Rule.Groups, function (group) { return !group.deleted });
            var group_index = _.findIndex(groups, { 'GroupID': 0 });
            $scope.selected_group = _.remove(groups[group_index].RulesConditions, function (obj) {
                return obj.Checked == true;
            })

            var grp = {deleted: false};
            grp.GroupID = groups[groups.length - 1].GroupID + 1;
            grp.GroupOperator = $scope.selected_group[0].AndOr;
            grp.RulesConditions = [];
            _.each($scope.selected_group, function (cond) {
                cond.GroupID = grp.GroupID;
                cond.Checked = false;
                grp.RulesConditions.push(cond);
            })
            $scope.Rule.Groups.push(grp);
            vm.onClear();
        }

        $scope.EditCondition = function (_group, cond) {
            _.each($scope.Rule.Groups, function (group) {
                group.edit = false;
                _.each(group.RulesConditions, function (condition) {
                    condition.edit = false;
                })
            })
            _group.edit = true;
            cond.edit = true;
            vm.onEdit();
        }

      
        $scope.Ungroup = function (group, cond) {
            var condition_index = _.findIndex($scope.Rule.Groups, function (o) { return o.GroupID == group.GroupID; });
            _.each($scope.Rule.Groups[condition_index].RulesConditions, function (obj) {
                obj.GroupID = 0;
                var groupIndex = _.findIndex($scope.Rule.Groups, { GroupID: 0 });
                if (obj.AndOr == null) {
                    obj.AndOr = obj.GroupOperator;
                }
                $scope.Rule.Groups[groupIndex].RulesConditions.push(obj);

            })
            $scope.Rule.Groups.splice(condition_index, 1);
            vm.onClear();
        }

        $scope.DisableGroupIcon = function () {
            var groups = _.filter($scope.Rule.Groups, function (group) { return !group.deleted });
            var conditionChecked = false;
            _.each(groups, function (group) {
                var checkedConditions = _.filter(group.RulesConditions, { 'Checked': true });
                var groupConditions = _.filter(group.RulesConditions, function (group) { return group.StatusFlag != "D" });
                if (checkedConditions.length > 1 && groupConditions.length > checkedConditions.length) {
                    conditionChecked = true;
                }
            });

            return !conditionChecked;
        }
        $scope.CheckConditionsInGroup = function (group) {
            var validationFlag = false;
            var validateCondition = _.filter(group.RulesConditions, function (obj) {
                return obj.StatusFlag != "D";
            });
            if (validateCondition.length > 0)
                validationFlag = true;
            
            if (!validationFlag) {
                return false;
            }
            else
                return true;
        }
    }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('shareexam', {
            templateUrl: 'app/theme/components/shareExamComponent/shareExamComponent.html',
            bindings: {
                check: '<',
                onClose: '&',
                selectedOrder: '<',
                onSend: '&',
            },
            controller: shareExamWindowController
        });

    /** @ngInject */
    function shareExamWindowController($scope, $rootScope, $state, $sessionStorage, OnCallScheduleService) {

        var vm = this;
        vm.isShowChatWindow = false;
        vm.toUserId = "0";
        var mssgWithPatientDetails = {};
        $scope.isChatMenuActive = false;
        $scope.SelectedRadiologist = {};
        $scope.isHighPriority = false;
        $scope.form = { providerTouched: false };
        $scope.activeChatMenuBar = function () {
            $scope.isChatMenuActive = !$scope.isChatMenuActive;
            $scope.isShowChatWindow = true;
            $rootScope.$broadcast('activeChatMenuBar:shareExamComponent', $scope.isChatMenuActive);
        }

        $scope.close = function () {
            $scope.form.providerTouched = false;
            $scope.SelectedRadiologist = {};
            $scope.isHighPriority = false;
            vm.check = true;
            vm.onClose({ check: vm.check });
        }


        function hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function isVisibleRad(r) {
            if (!r) return false;
            if (isSelf(r.Id || r.UserID)) return true;
            return !hasPrelimRad(r.UserRoles || r.Roles);
        }
        $scope.radDisplay = function (r) {
            if (!r) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
        $scope.matchRadSearch = function (search) {
            return function (r) {
                if (!isVisibleRad(r)) return false;
                if (!search) return true;
                var name = ((r.LastName || '') + ', ' + (r.FirstName || '')).toLowerCase();
                return name.indexOf(search.toLowerCase()) >= 0;
            };
        };

        $scope.GetAllUsers = function () {
            if (!vm.selectedOrder || !vm.selectedOrder.SiteID) return;
            OnCallScheduleService.GetAllUsersBySite({ "SiteID": vm.selectedOrder.SiteID, "UserID": $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.Radiologists = _.filter(result, function (obj) {
                    return isVisibleRad(obj) && obj.Id != $sessionStorage.currentUserData.userId;
                });
            });

        };

        vm.$onChanges = function (changes) {
            if (changes.selectedOrder && changes.selectedOrder.currentValue) {
                $scope.GetAllUsers();
            }
        };

        vm.$onDestroy = function () {
        }
        vm.$onInit = function () {
            $scope.GetAllUsers();
        }
        $scope.SendPopupMessage = function (message) {
            $scope.activeChatMenuBar();
            //message with patientdetails passed to the chat component
            mssgWithPatientDetails = {
                "toUserId": $scope.SelectedRadiologist.Obj.Id,
                "message": message,
                "isHighPriority": $scope.isHighPriority,
                "patientDetails": {
                    "PatientName": vm.selectedOrder.PatientName,
                    "Accession": vm.selectedOrder.Accession,
                    "PatientMRN": vm.selectedOrder.PatientMRN,
                    "DicomViewer": vm.selectedOrder.DicomViewer,
                    "DicomViewerURL": vm.selectedOrder.DicomViewerURL,
                    "Site": vm.selectedOrder.Site
                }
            }
            $rootScope.$broadcast('activeChatMenuBar:SendMessage', true, mssgWithPatientDetails);
            $scope.close();
        };

    }

}());

(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('siteLocationGrid', {
            templateUrl: 'app/theme/components/site-location-grid/site-location-grid.html',
            bindings: {
                masterLocations: '<',
                selectedLocation: '<',
                onChange: '&',
            },
            controller: siteLocationGridController
        });

    /** @ngInject */
    function siteLocationGridController($scope, $timeout, $q, $filter, $compile) {

        //#region How to use??
        /**
         * How to use:
         * ---------------------------------------------------------------------------------------------------
         * 1.give id='mainDiv' to your main div in parent
         * ---------------------------------------------------------------------------------------------------
         * 2.inbound selectedLocation with following properies: 
         *      -Ids (Selected LocationIds)
         *      -locations(Selected Locations)
         *      -divId(divID to create id for different div)
         *  inbound master-location 
         * ---------------------------------------------------------------------------------------------------
         * 3.create outbound function which will be called onChange().(*in parent)
         *      -in this function use selectedLocation to where you want.
         * ---------------------------------------------------------------------------------------------------
         * --Chirag Jadav
         * */
        //#endregion How to use

        var vm = this;
        $scope.selectedLocation = { Obj: [] };
        var SitesAndLocation = [];
        var selectedLocation;
        var availableNodes = [];

        vm.$onChanges = function (changes) {
            if (changes.masterLocations) {
                SitesAndLocation = changes.masterLocations.currentValue ? changes.masterLocations.currentValue : [];
                _.each(SitesAndLocation, function (location) {
                    location.path = location.Site + " (" + location.TenantName + ")/path/" + location.Location;
                });
                SitesAndLocation = $filter('orderBy')(SitesAndLocation, ['Site']);

                if (siteLocationGridOptions && siteLocationGridOptions.api) {
                    siteLocationGridOptions.api.setRowData(SitesAndLocation);
                    availableNodes = [];
                    siteLocationGridOptions.api.forEachNode(function (node) {
                        availableNodes.push(node);
                    });
                    createSelectedLocations();
                }
            }
            if (changes.selectedLocation) {
                if (changes.selectedLocation.currentValue && changes.selectedLocation.currentValue != "") {
                    if (changes.selectedLocation.currentValue.divId) {
                        vm.divId = changes.selectedLocation.currentValue.divId;
                        vm.gridId = vm.divId + 'Grid';
                        vm.siteDropdown = vm.divId + 'siteDropdown';
                        vm.locationTooltip = vm.divId + 'locationTooltip';
                        vm.tagsInput = vm.divId + 'tagsId';
                    }
                    selectedLocation = _.clone(changes.selectedLocation.currentValue);
                    if (siteLocationGridOptions && siteLocationGridOptions.api) {
                        createSelectedLocations();
                    }
                }
            }
        }
        vm.$onDestroy = function () {
            document.removeEventListener('click', onDocumentClick);
            if (siteLocationGridOptions && siteLocationGridOptions.api) {
                siteLocationGridOptions.api.destroy();
            }
        }
        vm.$onInit = function () {
            initGrid().then(function () { createSelectedLocations(); });
        }
        function initGrid() {
            var d = $q.defer();
            var timeout = $timeout(function () {
                var gridDiv = document.getElementById(vm.gridId);
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, siteLocationGridOptions);
                    siteLocationGridOptions.api.setRowData(SitesAndLocation);
                    availableNodes = [];
                    siteLocationGridOptions.api.forEachNode(function (node) {
                        availableNodes.push(node);
                    });
                }
                $timeout.cancel(timeout);
                d.resolve();
            }, 200);
            return d.promise;
        }
        function CustomHeader() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.className = "d-flex"
                this.eGui.innerHTML = '<div role="presentation" class="ag-labeled ag-label-align-right ag-checkbox ag-input-field ag-header-select-all" aria-hidden="true">' +
                    '<div ref="eLabel" class="ag-input-field-label ag-label ag-hidden ag-checkbox-label" aria-hidden="true" role="presentation"></div>' +
                    '<div ng-class="isAllNodesSelected()"  ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper" role="presentation">' +
                    '<input id="SiteLocCheckbox" ng-click="SelectAllNodes()" ref="eInput" class="ag-input-field-input ag-checkbox-input" type="checkbox">' +
                    '</div>' +
                    '</div>' +
                    '<div class="ag-cell-label-container" role="presentation" ng-click="SelectAllNodes()" style="width:180px;>' +
                    '<span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '<span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>' +
                    '<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '<span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                    '<span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                    '<span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                    '<span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                    '<span style="color:#e4e4e4 !important"">Select All</span>' +
                    '<span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
                    '<span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '</div>' +
                    '</div>';
                // create and compile AngularJS scope for this component
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }
        $scope.SelectAllNodes = function () {
            if (siteLocationGridOptions && siteLocationGridOptions.api) {
                var selectedNodes = _.filter(availableNodes, function (node) {
                    return node.selected == true || node.selected == undefined;
                });
                if (availableNodes.length == selectedNodes.length) {
                    _.each(availableNodes, function (node) {
                        node.setSelected(false);
                    });
                }
                else {
                    _.each(availableNodes, function (node) {
                        if (!node.expanded) {
                            if (node.displayed) {
                                node.setSelected(true);
                            }
                        }
                        else {
                            _.each(node.allLeafChildren, function (childNode) {
                                if (childNode.displayed) {
                                    childNode.setSelected(true);
                                }
                            });
                        }
                    });
                }
            }
        }
        $scope.isAllNodesSelected = function () {
            if (siteLocationGridOptions && siteLocationGridOptions.api) {
                var selectedNodes = _.filter(availableNodes, function (node) {
                    return node.selected == true || node.selected == undefined;
                });
                if (selectedNodes.length > 0 && availableNodes.length > selectedNodes.length) {
                    return 'ag-indeterminate';
                }
                else if (availableNodes.length == selectedNodes.length) {
                    return 'ag-checked';
                }
            }
            return "";
        }
        var siteLocationGridOptions = {
            columnDefs: [],
            defaultColDef: {
                suppressMenu: true,
                flex: 1,
                headerComponent: CustomHeader(),
            },
            autoGroupColumnDef: {
                headerName: 'Select All',
                minWidth: 180,
                cellRendererParams: {
                    suppressCount: true,
                    checkbox: true,
                },
            },
            getRowId: function (params) {
                return params.data.LocationID;
            },
            treeData: true,
            animateRows: true,
            rowSelection: 'multiple',
            rowHeight: 25,
            groupSelectsChildren: true,
            suppressRowClickSelection: true,
            getContextMenuItems: function () { return []; },
            getDataPath: function (data) {
                return data.path.split("/path/");
            },
            onRowClicked: function (params) {
                if (params.node) {
                    params.node.setSelected(true)
                }
            },
            onRowSelected: function (params) {
                getSelectedLocations();
            },
            icons: {
                groupExpanded:
                    '<div class=\'fa fa-minus fs-12px txt-clr-14 ng-scope\' title=\'Collapse\' style=\'width: 18px; text-align: center; padding-top: 3px;\'></div>',
                groupContracted:
                    '<div class=\'fa fa-plus fs-12px txt-clr-14 ng-scope\' title=\'Expend\' style=\'width: 18px; text-align: center; padding-top: 3px;\'></div>',
            },
        };

        function getSelectedLocations() {
            var timeout = $timeout(function () {
                if (siteLocationGridOptions && siteLocationGridOptions.api) {
                    $scope.selectedLocation.Obj = siteLocationGridOptions.api.getSelectedRows();
                }
                var locIds = "";
                _.each($scope.selectedLocation.Obj, function (loc) {
                    if (locIds == "") {
                        locIds = loc.LocationID;
                    } else {
                        locIds = locIds + "," + loc.LocationID;
                    }
                })
                vm.selectedLocation.Ids = locIds;
                vm.selectedLocation.locations = $scope.selectedLocation.Obj;
                setLocationtooltip();
                vm.onChange();
                $timeout.cancel(timeout);
            }, 0)

        };

        $scope.Search = function (searchKey) {
            if (siteLocationGridOptions && siteLocationGridOptions.api) {
                siteLocationGridOptions.api.setQuickFilter(searchKey);
                if (searchKey !== '') {
                    siteLocationGridOptions.api.expandAll();
                } else {
                    siteLocationGridOptions.api.collapseAll();
                }
            }
            return [];
        };
        $scope.removeTag = function (data) {
            var node = siteLocationGridOptions.api.getRowNode(data.LocationID);
            if (node) {
                node.setSelected(false);
            }
        };

        $scope.showSiteDropdown = function () {
            $(".overflowDiv").slideUp('fast');
            var timeout = $timeout(function () {
                $("#" + vm.siteDropdown).slideDown('fast');
                $timeout.cancel(timeout);
                timeout = null;
            }, 100);
        };

        $scope.clearSelectedLocation = function () {
            $scope.selectedLocation.Obj = null;
            if (siteLocationGridOptions && siteLocationGridOptions.api) {
                siteLocationGridOptions.api.deselectAll();
            }
            setLocationtooltip();
            $("#" + vm.siteDropdown).slideUp('fast');
        }
        function createSelectedLocations() {
            if (selectedLocation.locations && selectedLocation.locations.length > 0) {
                $scope.selectedLocation.Obj = selectedLocation.locations;
                if (siteLocationGridOptions && siteLocationGridOptions.api) {
                    _.each($scope.selectedLocation.Obj, function (data) {
                        var node = siteLocationGridOptions.api.getRowNode(data.LocationID);

                        if (node) {
                            node.setSelected(true);
                        }
                    });
                }
            }
            else if (selectedLocation.Ids && selectedLocation.Ids != "") {
                var LocationIdsList = selectedLocation.Ids.split(",");
                LocationIdsList = _.uniq(LocationIdsList);
                if (SitesAndLocation.length > 0) {
                    _.each(LocationIdsList, function (id) {
                        var obj = _.find(SitesAndLocation, function (loc) {
                            return loc.LocationID == id;
                        })
                        if (obj) {
                            $scope.selectedLocation.Obj.push(obj);
                            if (siteLocationGridOptions && siteLocationGridOptions.api) {
                                var node = siteLocationGridOptions.api.getRowNode(id);
                                if (node) {
                                    node.setSelected(true);
                                }
                            }
                        }

                    });
                }
            }
            else {
                resetDropdown()
            }
        }
        function setLocationtooltip() {
            var locationtooltipText = "Select a Location";
            if ($scope.selectedLocation.Obj && $scope.selectedLocation.Obj.length > 0) {
                var tooltipText = [];
                locationtooltipText = '';
                _.each($scope.selectedLocation.Obj, function (data) {
                    tooltipText.push(data.Location);
                });
                locationtooltipText = _.join(tooltipText, '\n');
            }
            else {
                locationtooltipText = "Select a Location";
            }
            var tooltipElement = document.getElementById(vm.locationTooltip);
            if (tooltipElement) {
                tooltipElement.textContent = locationtooltipText;
            }
        }


        function resetDropdown() {
            $scope.SelectedLocationValues = { SelectedItems: [] };
            if (siteLocationGridOptions && siteLocationGridOptions.api) {
                siteLocationGridOptions.api.deselectAll();
            }
            setLocationtooltip();
        }
        function clearSearchTextQuery() {
            var tagListEle = $('.tag-list')
            _.each(tagListEle, function (ele) {
                if (ele.nextSibling && ele.closest(".siteLocationDropdown")) {
                    ele.nextSibling.value = ''
                    ele.nextSibling.style.width = '200px'
                }
            });
            if (siteLocationGridOptions && siteLocationGridOptions.api) {
                $scope.Search('')
            }
        }

        //below code is to hide location dropdown
        document.addEventListener('click', onDocumentClick);
        function onDocumentClick(e) {
            if ((!e.target.closest(".siteLocationDropdown")) &&
                (!e.target.closest('.tag-item')) && !e.target.closest('.prevent-clear-search')) {
                $(".siteDropdown").slideUp('fast');
                clearSearchTextQuery();
            }
        }
    }
})();
// JavaScript source code
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('studyactionmenu', {
            templateUrl: 'app/theme/components/study-action-menu/study-action-menu.html',
            bindings: {
                selectedOrder: '<',
                actionMenu: '<',
                popUpOpened: '@',
                actionItemClicked: '&',
            },
            controller: studyActionMenuController
        });

    /** @ngInject */
    function studyActionMenuController($scope, $filter) {

        var vm = this;
        $scope.DataObject = {
            popUpOpened: '',
            actionMenu: {},
            selectedOrder: {},
        };
        vm.$onChanges = function (changes) {
            if (changes.popUpOpened && changes.popUpOpened.currentValue) {
                $scope.DataObject.popUpOpened = changes.popUpOpened.currentValue;
            }
            if (changes.selectedOrder && changes.selectedOrder.currentValue) {
                $scope.DataObject.selectedOrder = changes.selectedOrder.currentValue;
            }
            if (changes.actionMenu && changes.actionMenu.currentValue) {
                $scope.DataObject.actionMenu = changes.actionMenu.currentValue;
            }
        };       
        vm.$onDestroy = function () {
        }
        vm.$onInit = function () {
        }
        $scope.ActionItemClicked = function (Key, FileObject) {
            vm.actionMenu.ActionTaken = Key;
            if (Key == 'getFileDetails') {
                vm.actionMenu.FileObject = FileObject;
            }
            vm.actionItemClicked();
        }
    };
}());
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('tenantDicomViewer', {
            templateUrl: 'app/theme/components/tenant-dicom-viewer/tenant-dicom-viewer.html',
            bindings: {
                tenantsList: '<',
                dicomViewerList: '<'
            },
            controller: tenantDicomViewerCtrl
        });

    /** @ngInject */
    function tenantDicomViewerCtrl($scope, ManageLocationService, $q, $sessionStorage, toaster, $compile, $timeout) {

        var vm = this;

        $scope.DataObject = {
            TenantsList: [],
            DicomViewerList: [],
            SelectedTenantFilter: null,
            SelectedTenant: null,
            SelectedDicomViewer: null,
            IsMappingEnabled: false,
            TenantToBeMapped: [],
        }

        var rowId = 0;
        var gridapi = null;
        var columnapi = null;
        var TenantViewerMappingList = [];

        var columndefs = [
            {
                field: "TenantName",
            },
            {
                field: "DicomViewer",
                editable: true,
                cellEditor: DicomViewerCellEditor(),
                cellEditorPopup: true,
                cellRenderer: function (params) {
                    if (params.data && params.data.DicomViewer) {
                        var DicomViewerObj = _.find($scope.DataObject.DicomViewerList, { Value: params.data.DicomViewer });
                        return (DicomViewerObj) ? DicomViewerObj.Key : "";
                    }
                }
            },
            {
                field: "IsEnable",
                cellEditor: "agCheckboxCellEditor",
                editable: true,
            },
            {
                field: "Action",
                cellRenderer: ActionItemCellRenderer()
            }
        ];
        var gridoptions = {
            columnDefs: columndefs,
            defaultColDef: {
                lockVisible: true,
                suppressMovable: true,
                suppressMenu: true,
                resizable: false,
                flex: 1,
            },
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            getContextMenuItems: function () { return [] },
            rowData: [],
            onGridReady: function (params) {
            },
            getRowId: function (params) {
                if (params && params.data && params.data.hasOwnProperty('TenantID')) {
                    return params.data.TenantID;
                }
            },
            onCellEditingStopped: function (params) {
                switch (params.column.colId) {
                    case "IsEnable":
                        if (params.data) {
                            var params = {
                                CreatedBy: $sessionStorage.currentUserData.userId,
                                StatusFlag: 'U',
                                TenantID: params.data.TenantID,
                                DicomViewer: params.data.DicomViewer,
                                IsEnable: params.data.IsEnable,
                            };
                            SetTenantDicomViewerSetting(params);
                        }
                        break;
                    case "DicomViewer":
                        $scope[params.data.TenantID].isEditing = false;
                        if (params.newValue != params.oldValue) {
                            var params = {
                                CreatedBy: $sessionStorage.currentUserData.userId,
                                StatusFlag: 'U',
                                TenantID: params.data.TenantID,
                                DicomViewer: params.newValue,
                                IsEnable: params.data.IsEnable,
                            };
                            SetTenantDicomViewerSetting(params);
                        }
                        break;
                }
            },
            onCellEditingStarted: function (params) {
                if (params.column.colId == "DicomViewer") {
                    $scope[params.data.TenantID].isEditing = true;
                }
            }
        }

        vm.$onInit = function () {
            console.log("tenantDicomViewerCtrl init");
            initGrid();
            $scope.GetTenantDicomViewerSetting();
        }
        vm.$onChanges = function (changes) {
            if (changes) {
                if (changes.tenantsList && changes.tenantsList.currentValue) {
                    $scope.DataObject.TenantsList = changes.tenantsList.currentValue;
                }
                if (changes.dicomViewerList && changes.dicomViewerList.currentValue) {
                    $scope.DataObject.DicomViewerList = changes.dicomViewerList.currentValue;
                }
            }
        }
        vm.$onDestroy = function () { }
        function DicomViewerCellEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                var tenantId = parseInt(params.data.TenantID, 10);
                $scope[tenantId].SelectedDicomViewer = _.find($scope.DataObject.DicomViewerList, { Value: params.data.DicomViewer });
                this.eGui.className = "dicom-viewer-cell-editor";
                this.eGui.innerHTML = '<ui-select class="mult-select"' +
                    ' tooltip-class="uibtooltipDenial"' +
                    'uib-tooltip="Select Dicom Viewer"' +
                    'tooltip-placement="auto left">' +
                    '<ui-select-match placeholder="Select Dicom Viewer" class="overflow-y-auto d-block w-sal lguimatch smuimatch h-auto max-h-100px overflow-y-auto">' +
                    '{{$select.selected.Key}}' +
                    '</ui-select-match>' +
                    '<ui-select-choices repeat="viewer in DataObject.DicomViewerList | filter: {Key: $select.search}">' +
                    '<div ng-bind-html="viewer.Key | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>';
                this.eGui.querySelector('ui-select').setAttribute('ng-model', 'this[' + tenantId + '].SelectedDicomViewer');

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                var val = "";
                var editingCells = gridapi.getEditingCells();
                if (editingCells && editingCells.length > 0) {
                    var node = gridapi.getDisplayedRowAtIndex(editingCells[0].rowIndex);
                    if (node) {
                        val = ($scope[node.data.TenantID].SelectedDicomViewer) ? ($scope[node.data.TenantID].SelectedDicomViewer).Value : "";
                    }
                }
                return val;
            }
            return CustomEditor;
        }
        function mappingButton(title, iconClass) {
            var button = document.createElement('button');
            button.className = 'btn btn-default txt-clr-14 px-5px mx-5px border-0 my-0 py-0';
            button.title = title;
            var icon = document.createElement('span');
            icon.className = iconClass;
            button.appendChild(icon);
            return button;
        }
        function ActionItemCellRenderer() {
            function CustomRenderer() {
            }
            CustomRenderer.prototype.init = function (params) {
                var obj = _.cloneDeep(params.data);
                obj.isEditing = false;
                var tenantId = parseInt(obj.TenantID, 10);
                $scope[tenantId] = obj;
                this.eGui = document.createElement('div');
                var rowExpr = 'this[' + tenantId + ']';
                var wrapper = document.createElement('div');
                var saveButton = mappingButton('Save', 'fa fa-floppy-o');
                saveButton.setAttribute('ng-show', rowExpr + '.isEditing');
                wrapper.appendChild(saveButton);
                var editButton = mappingButton('Edit', 'glyphicon glyphicon-pencil');
                editButton.setAttribute('ng-click', 'AddEditTenantViewerMapping(' + rowExpr + ')');
                editButton.setAttribute('ng-hide', rowExpr + '.isEditing');
                wrapper.appendChild(editButton);
                var deleteButton = mappingButton('Delete', 'fa fa-trash-o');
                deleteButton.setAttribute('ng-click', 'DeleteTenantViewerMapping(' + rowExpr + ')');
                deleteButton.setAttribute('ng-hide', rowExpr + '.isEditing');
                wrapper.appendChild(deleteButton);
                this.eGui.appendChild(wrapper);
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                }, 0);
            };
            CustomRenderer.prototype.getGui = function () {
                return this.eGui;
            };
            CustomRenderer.prototype.destroy = function () {
            };
            return CustomRenderer;
        }

        function initGrid() {
            var gridDiv = document.querySelector('#tenantDicomViewerGrid');
            if (gridDiv && gridoptions && !(gridapi)) {
                new agGrid.Grid(gridDiv, gridoptions);
                gridapi = gridoptions.api;
                columnapi = gridoptions.columnApi;
            }
        }
        $scope.SetTenantDicomViewerSetting = function () {
            var d = $q.defer();
            var params = {
                CreatedBy: $sessionStorage.currentUserData.userId,
                StatusFlag: 'I',
                TenantID: $scope.DataObject.SelectedTenant.TenantID,
                DicomViewer: $scope.DataObject.SelectedDicomViewer.Value,
                IsEnable: $scope.DataObject.IsMappingEnabled,
            };
            SetTenantDicomViewerSetting(params).then(function () {
                d.resolve();
            }, function (err) { d.reject(); });
            return d.promise;
        }
        function SetTenantDicomViewerSetting(params) {
            var d = $q.defer();
            var tenant = _.find(TenantViewerMappingList, { TenantID: params.TenantID });
            params.StatusFlag = (tenant) ? 'U' : 'I';
            ManageLocationService.SetTenantDicomViewerSetting(params).then(function (res) {
                $scope.GetTenantDicomViewerSetting();
                $("#ModalAddEditTenantViewerMapping").modal('hide');
                toaster.success("Tenant Dicom Viewer Mapping Saved Successfully.");
                d.resolve();
            }, function (err) {
                console.error(err);
                $("#ModalAddEditTenantViewerMapping").modal('hide');
                toaster.error("Some error occurred");
                d.reject();
            });
            return d.promise;
        }
        $scope.GetTenantDicomViewerSetting = function () {
            var d = $q.defer();
            var params = {
                UserID: $sessionStorage.currentUserData.userId,
                TenantID: ($scope.DataObject.SelectedTenantFilter) ? $scope.DataObject.SelectedTenantFilter.TenantID : null,
            };
            ManageLocationService.GetTenantDicomViewerSetting(params).then(function (res) {
                TenantViewerMappingList = res;
                if (gridapi) {
                    gridapi.setRowData(res);
                }
                d.resolve(res);
            }, function (err) {
                console.error(err);
                d.reject();
            });
            return d.promise;
        }
        $scope.AddEditTenantViewerMapping = function (data) {
            if (data) {
                $scope[data.TenantID].isEditing = true;
                var node = gridapi.getRowNode(data.TenantID);
                if (node) {
                    gridapi.startEditingCell({
                        rowIndex: node.rowIndex,
                        colKey: 'DicomViewer'
                    });
                }
            }
            else {
                $scope.clearData();
                ManageLocationService.GetTenantsByUserID({
                    UserID: $sessionStorage.currentUserData.userId,
                    IsTenantMapped: true
                }).then(function (result) {
                    $scope.DataObject.TenantToBeMapped = result;
                    $("#ModalAddEditTenantViewerMapping").modal('show');
                });
            }
        }
        $scope.clearData = function () {
            $scope.DataObject.SelectedTenant = null;
            $scope.DataObject.SelectedDicomViewer = null;
            $scope.DataObject.IsMappingEnabled = false;
        }
        $scope.DeleteTenantViewerMapping = function (data) {
            var d = $q.defer();
            var params = {
                CreatedBy: $sessionStorage.currentUserData.userId,
                StatusFlag: 'D',
                TenantID: data.TenantID,
            };
            ManageLocationService.SetTenantDicomViewerSetting(params).then(function (res) {
                $scope.GetTenantDicomViewerSetting();
                toaster.success("Tenant Dicom Viewer Mapping Deleted Successfully.");
                d.resolve();
            }, function (err) {
                console.error(err);
                toaster.error("Some error occurred");
                d.reject();
            });
            return d.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('tenantSiteDropdown', {
            templateUrl: 'app/theme/components/tenant-site-dropdown/tenant-site-dropdown.html',
            bindings: {
                masterSites: '<',
                selectedSites: '<',
                onChange: '&',
            },
            controller: tenantSiteDropdownCtrl
        });

    /** @ngInject */
    function tenantSiteDropdownCtrl($scope, $q, $timeout, $filter, $compile) {

        var vm = this;
        var selectedSites;
        var TenantAndSitesList = [];
        var availableNodes = [];
        $scope.DataObject = {
            selectedSites: [],
        }

        vm.$onChanges = function (changes) {
            if (changes.masterSites) {
                TenantAndSitesList = changes.masterSites.currentValue ? changes.masterSites.currentValue : [];
                _.each(TenantAndSitesList, function (obj) {
                    obj.path = obj.TenantName + "/path/" + obj.Site;
                });
                TenantAndSitesList = $filter('orderBy')(TenantAndSitesList, ['TenantName']);

                if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                    TenantSiteGridOptions.api.setRowData(TenantAndSitesList);
                    availableNodes = [];
                    TenantSiteGridOptions.api.forEachNode(function (node) {
                        availableNodes.push(node);
                    });
                }
            }
            if (changes.selectedSites) {
                if (changes.selectedSites.currentValue) {
                    if (changes.selectedSites.currentValue.divId) {
                        vm.divId = changes.selectedSites.currentValue.divId;
                        vm.gridId = vm.divId + 'TenatnSiteGrid';
                        vm.TenantDropdown = vm.divId + 'TenantSiteDropdown';
                        vm.TenantSiteTooltip = vm.divId + 'SitesTooltip';
                        vm.tagsInput = vm.divId + 'tagsId';
                    }
                    selectedSites = _.clone(changes.selectedSites.currentValue);
                    if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                        PreSelectSites();
                    }
                }
            }
        };

        vm.$onDestroy = function () {
            document.removeEventListener('click', onDocumentClick);
            if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                TenantSiteGridOptions.api.destroy();
            }
        }
        vm.$onInit = function () {
            initGrid().then(function () {
                TenantSiteGridOptions.api.setRowData(TenantAndSitesList);
                availableNodes = [];
                TenantSiteGridOptions.api.forEachNode(function (node) {
                    availableNodes.push(node);
                });
                PreSelectSites();
            });
        }
        function initGrid() {
            var d = $q.defer();
            var timeout = $timeout(function () {
                var gridDiv = document.getElementById(vm.gridId);
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, TenantSiteGridOptions);

                }
                $timeout.cancel(timeout);
                d.resolve();
            }, 200);
            return d.promise;
        }

        var TenantSiteGridOptions = {
            columnDefs: [],
            defaultColDef: {
                headerComponent: CustomHeader(),
                suppressMenu: true,
                flex: 1,
            },
            autoGroupColumnDef: {
                headerName: 'Select All',
                minWidth: 180,
                cellRendererParams: {
                    suppressCount: true,
                    checkbox: true,
                },
            },
            getRowId: function (params) {
                return params.data.SiteID;
            },
            treeData: true,
            animateRows: true,
            rowSelection: 'multiple',
            rowHeight: 25,
            groupSelectsChildren: true,
            suppressRowClickSelection: true,
            getContextMenuItems: function () { return []; },
            getDataPath: function (data) {
                return data.path.split("/path/");
            },
            onRowClicked: function (params) {
                if (params.node) {
                    params.node.setSelected(true)
                }
            },
            onRowSelected: function (params) {
                getSelectedSites();
            },
            icons: {
                groupExpanded:
                    '<div class=\'fa fa-minus fs-12px txt-clr-14 ng-scope\' title=\'Collapse\' style=\'width: 18px; text-align: center; padding-top: 3px;\'></div>',
                groupContracted:
                    '<div class=\'fa fa-plus fs-12px txt-clr-14 ng-scope\' title=\'Expend\' style=\'width: 18px; text-align: center; padding-top: 3px;\'></div>',
            },
        }
        function CustomHeader() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.className = "d-flex"
                this.eGui.innerHTML = '<div role="presentation" class="ag-labeled ag-label-align-right ag-checkbox ag-input-field ag-header-select-all" aria-hidden="true">' +
                    '<div ref="eLabel" class="ag-input-field-label ag-label ag-hidden ag-checkbox-label" aria-hidden="true" role="presentation"></div>' +
                    '<div ng-class="isAllNodesSelected()"  ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper" role="presentation">' +
                    '<input id="SiteLocCheckbox" ng-click="SelectAllNodes()" ref="eInput" class="ag-input-field-input ag-checkbox-input" type="checkbox">' +
                    '</div>' +
                    '</div>' +
                    '<div class="ag-cell-label-container" role="presentation" ng-click="SelectAllNodes()" style="width:180px;>' +
                    '<span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '<span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>' +
                    '<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '<span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                    '<span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                    '<span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                    '<span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                    '<span style="color:#e4e4e4 !important"">Select All</span>' +
                    '<span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
                    '<span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '</div>' +
                    '</div>';
                // create and compile AngularJS scope for this component
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }
        $scope.isAllNodesSelected = function () {
            if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                var selectedNodes = _.filter(availableNodes, function (node) {
                    return node.selected == true || node.selected == undefined;
                });
                if (selectedNodes.length > 0 && availableNodes.length > selectedNodes.length) {
                    return 'ag-indeterminate';
                }
                else if (availableNodes.length == selectedNodes.length) {
                    return 'ag-checked';
                }
            }
            return "";
        }
        $scope.SelectAllNodes = function () {
            if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                var selectedNodes = _.filter(availableNodes, function (node) {
                    return node.selected == true || node.selected == undefined;
                })
                if (availableNodes.length == selectedNodes.length) {
                    _.each(availableNodes, function (node) {
                        node.setSelected(false);
                    });
                }
                else {
                    _.each(availableNodes, function (node) {
                        if (!node.expanded) {
                            if (node.displayed) {
                                node.setSelected(true);
                            }
                        }
                        else {
                            _.each(node.allLeafChildren, function (childNode) {
                                if (childNode.displayed) {
                                    childNode.setSelected(true);
                                }
                            });
                        }
                    });
                }
            }
        }
        $scope.removeTag = function (data) {
            var node = TenantSiteGridOptions.api.getRowNode(data.SiteID);
            if (node) {
                node.setSelected(false);
            }
        }
        $scope.Search = function (searchKey) {
            if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                TenantSiteGridOptions.api.setQuickFilter(searchKey);
                if (searchKey !== '') {
                    TenantSiteGridOptions.api.expandAll();
                } else {
                    TenantSiteGridOptions.api.collapseAll();
                }
            }
            return [];
        }

        function getSelectedSites() {
            var timeout = $timeout(function () {
                $scope.DataObject.selectedSites = TenantSiteGridOptions.api.getSelectedRows();
                var siteIds = "";
                _.each($scope.DataObject.selectedSites, function (site) {
                    if (siteIds == "") {
                        siteIds = site.SiteID;
                    } else {
                        siteIds = siteIds + "," + site.SiteID;
                    }
                });
                vm.selectedSites.Ids = siteIds;
                vm.selectedSites.sites = $scope.DataObject.selectedSites;
                setSitesTooltip();
                vm.onChange();
                $timeout.cancel(timeout);
            }, 0);
        }
        function resetDropdown() {
            //$scope.SelectedLocationValues = { SelectedItems: [] };
            if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                TenantSiteGridOptions.api.deselectAll();
            }
            setSitesTooltip();
        }
        function setSitesTooltip() {
            var siteTooltipText = "Select Site(s)";
            if ($scope.DataObject.selectedSites && $scope.DataObject.selectedSites.length > 0) {
                var tooltipText = [];
                siteTooltipText = '';
                _.each($scope.DataObject.selectedSites, function (data) {
                    tooltipText.push(data.Site);
                });
                siteTooltipText = _.join(tooltipText, '\n');
            }
            else {
                siteTooltipText = "Select Site(s)";
            }
            var tooltipElement = document.getElementById(vm.TenantSiteTooltip);
            if (tooltipElement) {
                tooltipElement.textContent = siteTooltipText;
            }
        }

        function PreSelectSites() {
            if (selectedSites.sites && selectedSites.sites.length > 0) {
                $scope.DataObject.selectedSites = selectedSites.sites;
                if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                    _.each($scope.DataObject.selectedSites, function (data) {
                        var node = TenantSiteGridOptions.api.getRowNode(data.SiteID);
                        if (node) {
                            node.setSelected(true);
                        }
                    });
                }
            }
            else if (selectedSites.Ids && selectedSites.Ids != "") {
                var SitesIdsList = selectedSites.Ids.split(",");
                if (TenantAndSitesList.length > 0) {
                    _.each(SitesIdsList, function (id) {
                        var obj = _.find(TenantAndSitesList, function (site) {
                            return site.SiteID == id;
                        })
                        if (obj) {
                            $scope.DataObject.selectedSites.push(obj);
                            if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                                var node = TenantSiteGridOptions.api.getRowNode(id);
                                if (node) {
                                    node.setSelected(true);
                                }
                            }
                        }

                    });
                }
            }
            else {
                resetDropdown()
            }
        }
        $scope.showTenantSiteDropdown = function () {
            $(".overflowDiv").slideUp('fast');
            var timeout = $timeout(function () {
                $("#" + vm.TenantDropdown).slideDown('fast');
                $timeout.cancel(timeout);
                timeout = null;
            }, 100);
        }
        $scope.clearSelectedSites = function () {
            $scope.DataObject.selectedSites = [];
            vm.selectedSites.Ids = "";
            vm.selectedSites.sites = $scope.DataObject.selectedSites;
            if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                TenantSiteGridOptions.api.deselectAll();
            }
            setSitesTooltip();
            $("#" + vm.TenantDropdown).slideUp('fast');
        }

        function clearSearchTextQuery() {
            var tagListEle = $('.tag-list')
            _.each(tagListEle, function (ele) {
                if (ele.nextSibling && ele.closest(".siteTenantDropdown")) {
                    ele.nextSibling.value = ''
                    ele.nextSibling.style.width = '200px'
                }
            });
            if (TenantSiteGridOptions && TenantSiteGridOptions.api) {
                $scope.Search('')
            }
        }

        document.addEventListener('click', onDocumentClick);
        function onDocumentClick(e) {
            if (e && e.target && e.target.classList) {
                if (!$("." + e.target.classList[0]).parents().hasClass("siteTenantDropdown")) {
                    $(".tenantSiteDiv").slideUp('fast');
                    clearSearchTextQuery();
                }
            }
        }
    }

}());


(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('filterCmp', {
            templateUrl: 'app/theme/components/tenant-site-location-cmp/tenant-site-location-cmp.html',
            bindings: {
                masterData: '<',
                selectedData: '<',
                onChange: '&',
                idx: '<',
            },
            controller: Comptenantsitelocationcontroller
        });

    /** @ngInject */
    function Comptenantsitelocationcontroller($scope, $log, TechnoService, $sessionStorage, $timeout, $filter) {

        var vm = this;
        $scope.locationtooltip = 'Select a Location';
        $scope.MasterData = {};
        vm.$onChanges = function (changes) {
            $scope.MasterData = changes.masterData && changes.masterData.currentValue ? changes.masterData.currentValue : vm.masterData;
            if ($scope.MasterData.Sites != "") {
                loadLocationDropdown();
            }
            if (changes.selectedData && changes.selectedData.currentValue) {
                if (!changes.selectedData.currentValue.locationIDs) {
                    changes.selectedData.currentValue.locationIDs = "";
                }
                if (!changes.selectedData.currentValue.Location) {
                    changes.selectedData.currentValue.Location = [];
                }
                $timeout(function () {
                    setSelectedLocationFilterSettings(changes.selectedData.currentValue.locationIDs);
                    setLocationtooltip();
                }, 10);
            }
        };
        vm.$onDestroy = function () {
        }
        vm.$onInit = function () {
            //$log.log("$onInit");

            $scope.MasterData = vm.masterData;


        }

        function loadLocationDropdown() {
            //$log.log("loadLocationDropdown");
            $scope.locationDropdownTreeOptionsPC = {
                placeholder: $scope.locationtooltip,
                checkboxes: {
                    checkChildren: true,
                    template:
                        "# if (item.level() > 0) { #" +
                        "<input type='checkbox' #= item.checked ? 'checked' : '' #>" +
                        "# } #",
                },
                autoClose: false,
                dataSource: $scope.MasterData.Sites,
                dataTextField: "text",
                dataValueField: "value",
                checkAll: true,
                height: "auto",
                loadOnDemand: false,
                headerTemplate: '<span class="k-list-filter"><input class="k-textbox" role="listbox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-disabled="false" id="tree-text-search" autocomplete="off"/><span class="k-icon k-i-zoom"></span></span>',
                filtering: function (e) {
                    //get filter descriptor
                    var filter = e.filter;
                    // handle the event
                },
                open: function (e) {
                    $("#tree-text-search").change(refreshTree).keyup(refreshTree);
                    setTimeout(function () {
                        $("#tree-text-search").focus();
                    }, 1500);
                },
                change: function (e) {
                    vm.selectedData.locationIDs = '';
                    ClearAll();
                    var nodes = e.sender.dataSource.view();

                    var checkedNodes = e.sender.value();
                    var values = checkedNodeValues(nodes, checkedNodes);
                    if (values && values.length > 0) {
                        var locations = [];
                        _.each(values, function (data) {
                            var filter = _.find(vm.masterData.Locations, function (item) { return item.LocationID == data; });
                            if (filter != null) {
                                locations.push(filter);
                            }
                        });
                        vm.selectedData.Location = locations;
                        setLocationtooltip();
                    } else {
                        vm.selectedData.Location = [];
                        $scope.locationtooltip = 'Select a Location';
                        vm.selectedData.locationIDs = '';
                    }
                    vm.onChange();
                },
                close: function (e) {
                    clearLocation();
                }
            };
        };

        function setLocationtooltip() {
            if (vm.selectedData.Location && vm.selectedData.Location.length > 0) {
                $scope.locationtooltip = '';
                vm.selectedData.locationIDs = '';
                var objLocations = $filter('orderBy')(vm.selectedData.Location, 'Location');
                _.each(objLocations, function (data) {
                    if ($scope.locationtooltip.length > 0) {
                        $scope.locationtooltip = $scope.locationtooltip + "\n" + data.Location;
                    }
                    else if ($scope.locationtooltip.length == 0) {
                        $scope.locationtooltip = data.Location;
                    }
                    //if (vm.selectedData.Location.length > 0) { vm.selectedData.Location = vm.selectedData.Location + "," + data.LocationID; }
                    //else { vm.selectedData.Location = data.LocationID; }
                    if (data.SiteID != 0) {
                        if (vm.selectedData.locationIDs.length > 0) {
                            vm.selectedData.locationIDs = vm.selectedData.locationIDs + "," + data.LocationID;
                        }
                        else if (vm.selectedData.locationIDs.length == 0) {
                            vm.selectedData.locationIDs = data.LocationID;
                        }
                    }

                });
            }
            else {
                $scope.locationtooltip = 'Choose a Location';
            }
        }

        function refreshTree() {
            var drtr = $("#" + vm.idx).data("kendoDropDownTree");
            var tree = drtr.treeview;
            var dataSource = drtr.dataSource;
            var value = $("#tree-text-search").val();
            if (value !== "") {
                dataSource.filter({
                    field: "text", //if I would use "ChildrenText" here nothing be displayed at all if filtertext is set
                    operator: "contains",
                    value: $("#tree-text-search").val()
                });

                //filtering child node
                if (dataSource.view() && dataSource.view().length > 0) {
                    for (var i = 0; i < dataSource.view().length; i++) {
                        if (dataSource.view()[i].hasChildren) {
                            dataSource.view()[i].children.filter({
                                field: "text",
                                operator: "neq",
                                value: true
                            })
                        }
                    }
                }

                setTimeout(function () {
                    tree.expand(".k-item");
                }, 200);
            } else {
                dataSource.filter({});

                setTimeout(function () {
                    tree.collapse(".k-item");
                }, 200);
            }
            angular.element(document).ready(function () {
                angular.element('.k-item').mouseenter(function () {
                    if (tree) {
                        tree.focus();
                    }
                });

            });
        }

        function ClearAll() {
            $(".k-check-all").on("click", function () {

                if ($('.k-checkbox').is(':checked') == false) {

                    //$scope.SelectedList.Site = null;
                    vm.selectedData.Location = null;
                    $scope.locationtooltip = 'Select a Location';

                    $('.k-multiselect-wrap li').remove();
                }
            })
        }

        function checkedNodeValues(nodes, checkedNodes) {
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && !nodes[i].hasChildren) {
                    if (checkedNodes.indexOf(nodes[i].value) < 0) {
                        checkedNodes.push(nodes[i].value);
                    }
                }
                if (nodes[i].hasChildren) {
                    checkedNodeValues(nodes[i].children.view(), checkedNodes);
                }
            }
            return checkedNodes;
        }

        function clearLocation() {
            $("#tree-text-search").val('');
            var drtr = $("#" + vm.idx).data("kendoDropDownTree");
            if (drtr) {
                var tree = drtr.treeview;
                var dataSource = drtr.dataSource;
                $timeout(function () {
                    dataSource.filter({});
                    tree.collapse(".k-item");
                }, 1000);
            }
        }

        function setSelectedLocationFilterSettings(LocationIds) {
            if ((LocationIds.substring(LocationIds.length - 1, LocationIds.length) == ",") || LocationIds != "") {
                LocationIds = LocationIds.split(",");
            } else {
                LocationIds = [LocationIds];
            }
            ////$log.log("setSelectedLocationFilterSettings: " + new Date());
            var ddt = $("#" + vm.idx).data("kendoDropDownTree");
            if (ddt) {
                ddt.value(LocationIds);
                //setLocationtooltip();
            }
        }

    }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('userPaymentContractDetail', {
            templateUrl: 'app/theme/components/user-payment-contract-detail/user-payment-contract-detail.html',
            bindings: {
                userId: '<',
                getUserPaymentContract: '&',
            },
            controller: UserPaymentContractDetailController
        });

    /** @ngInject */
    function UserPaymentContractDetailController($scope, $log, $sessionStorage, $timeout, $q, $filter, toaster, PaymentContractService) {

        var vm = this;

        $scope.DataObject = {
            UsersPaymentContract: null,
        };


        vm.$onChanges = function (changes) {
            $log.log("$onChanges paymentInvoice changes", changes);
        };
        vm.$onDestroy = function () {
            $log.log('Destory paymentInvoice');
        }
        vm.$onInit = function () {
            $log.log("$onInit paymentInvoice");
            if (vm.userId) {
                GetPaymentContractByUserByID();
            }
        }

        function GetPaymentContractByUserByID() {
            var d = $q.defer();
            PaymentContractService.GetPaymentContractByUserByID({ UserID: vm.userId }).then(function (result) {
                if (result && result.length > 0) {
                    $scope.DataObject.UsersPaymentContract = result;
                    vm.getUserPaymentContract({ PaymentContractType: result});
                }
                d.resolve();
            });
            return d.promise;
        }
    };

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('userPreference', {
            templateUrl: 'app/theme/components/user-preference/user-preference.html',
            bindings: {

            },
            controller: UserPreferenceController
        });

    function UserPreferenceController($scope, $sessionStorage, UserPreferenceService, ManageLocationService, ProfileService, WorklistService, filterFilter, windowHandler, $localStorage, $timeout, toaster, $compile, $filter, $q, CommonService, $injector) {

        var vm = this;
        var TenantSitesFullList = [];
        var DicomViewerFullList = [];
        vm.$onInit = function () {
            $q.all([
                GetDicomViewerByUserId(),
                GetSitesByUserId(),
                GetLookupByType(),
            ]).then(function () {
                var gridDiv = document.querySelector('#DicomViewerSettingGrid');
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, DicomViewerGridOption);
                }
                GetUserPreferences();
            }, function (err) { $scope.DataObject.isLoading = false });
        }
        vm.$onDestroy = function () {
            if (DicomViewerGridOption && DicomViewerGridOption.api) {
                DicomViewerGridOption.api.destroy();
            }
            window.removeEventListener("click", windowClicklistner);
        }

        $scope.DataObject = {
            InstSelected: {},
            InstAddInstitution: {},
            SelectedDefaultDicomViewer: {},
            SelectedSite: {},
            SelectedViewer: null,
            PageNo: "1",
            PageSize: "25",
            OrderByField: "SITE",
            ReverseSort: true,
            AddDVCredentials: false,
            Id: -1,
            ChooseNextStudy: null,
            DeficientWarningOnWorklist: null,
            NumberofComparisonInReport: null,
            validNumberpattern: /^[0-9]\d*(\.\d+)?$/,
            isInvalidNumberofComparison: null,
            SelectedDefaultDictationSystem: {},
            DoNotShowStudyAssignedToOtherUsers: {},
            DoNotShowClipboardAddedStudyToOtherUsers: null,
            isLoading: false,
            workList: [],
            IsDisPref: true,
            SelectedLocationsUISelect: [],
            SelectedSites: {
                Ids: '',
                sites: [],
                divId: "UserPref"
            },
            PaymentAddedSound: null,
            IsPaymentContractEnabled: false,
            AllSites: [],
            InstDicomViewerList: [],
        };
        var parser = new UAParser();
        var browser = parser.getBrowser().name;
        if (browser && browser.toUpperCase() == "IE") {
            $scope.DataObject.IsDisPref = false;
        }
        // JS for table row active
        $scope.activeTableTR = function () {
            angular.element(document).ready(function () {
                setTimeout(function () {
                    angular.element(".common-tbl table tr").click(function () {
                        if (angular.element(this).data('clicked', true)) {
                            angular.element(".common-tbl table tr").removeClass('tr-active');
                            angular.element(this).addClass('tr-active');
                        }
                    });
                }, 500);
            });
        }
        //$scope.GetUserWorkList = function () {
        //    $scope.DataObject.isLoading = true;
        //    var userPreference = {
        //        UserID: $sessionStorage.currentUserData.userId
        //    };
        //    UserPreferenceService.GetUserWorkList(userPreference).then(function (result) {
        //        $scope.DataObject.isLoading = false;
        //        $scope.DataObject.workList = result;
        //        GetUserPreferences();
        //    });
        //};

        var SharedVariable = CommonService.getSharedVariables();
        if (SharedVariable && SharedVariable.IsPaymentContractEnabled != null) {
            $scope.DataObject.IsPaymentContractEnabled = SharedVariable.IsPaymentContractEnabled;
            SharedVariable = null;
        }
        function GetUserPreferences() {
            $scope.DataObject.isLoading = true;
            var userPreference = {
                UserID: $sessionStorage.currentUserData.userId
            };
            UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {

                //#region UserPreference
                $scope.DataObject.userPreferences = result.UserPreferences;
                $scope.DataObject.ChooseNextStudy = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "Choose Next Study"
                })[0];
                if ($scope.DataObject.ChooseNextStudy != null) {
                    $scope.DataObject.ChooseNextStudy.PreferenceValue = $scope.DataObject.ChooseNextStudy.PreferenceValue == "1" ? true : false;
                }
                $scope.DataObject.SendDefaultAlertforOncall = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "SendDefaultAlertforOncall"
                })[0];
                if ($scope.DataObject.SendDefaultAlertforOncall == null) {
                    $scope.DataObject.SendDefaultAlertforOncall = {
                        PreferenceType: "SendDefaultAlertforOncall",
                        PreferenceValue: true
                    };
                    //$scope.DataObject.SendDefaultAlertforOncall.PreferenceValue = "1";
                    //$scope.DataObject.SendDefaultAlertforOncall.PreferenceValue = $scope.DataObject.SendDefaultAlertforOncall.PreferenceValue == "1" ? true : false;
                }
                else {
                    $scope.DataObject.SendDefaultAlertforOncall.PreferenceValue = $scope.DataObject.SendDefaultAlertforOncall.PreferenceValue == "0" ? true : false;
                }

                $scope.DataObject.ShowPracticeWorklistPref = _.find($scope.DataObject.userPreferences, { PreferenceType: 'ShowPracticeWorklist' });
                if ($scope.DataObject.ShowPracticeWorklistPref == null) {
                    $scope.DataObject.ShowPracticeWorklistPref = {
                        PreferenceValue: '1',
                    };
                }

                $scope.DataObject.DefaultWorklist = _.find($scope.DataObject.userPreferences, { PreferenceType: "DefaultWorklist" });
                if (!$scope.DataObject.DefaultWorklist || !$scope.DataObject.ShowPracticeWorklistPref || $scope.DataObject.ShowPracticeWorklistPref.PreferenceValue != '1') {
                    $scope.DataObject.DefaultWorklist = {
                        PreferenceType: "DefaultWorklist",
                        PreferenceValue: "PRW"
                    };
                }
                $scope.DataObject.ShowLockStudy = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "ShowLockStudy"
                })[0];
                if ($scope.DataObject.ShowLockStudy == null) {
                    $scope.DataObject.ShowLockStudy = {
                        PreferenceType: "ShowLockStudy",
                        PreferenceValue: true
                    };
                }
                else {
                    $scope.DataObject.ShowLockStudy.PreferenceValue = $scope.DataObject.ShowLockStudy.PreferenceValue == "1" ? true : false;
                }
                $scope.DataObject.DefaultDicomViewer = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "DefaultDicomViewer"
                })[0];
                if ($scope.DataObject.DefaultDicomViewer) {
                    var DefaultDicomViewerPreference = _.filter(DicomViewerFullList, function (obj) { return obj.Value == $scope.DataObject.DefaultDicomViewer.PreferenceValue; })[0];
                    if (DefaultDicomViewerPreference) {
                        $scope.DataObject.SelectedDefaultDicomViewer = DefaultDicomViewerPreference;
                    }
                }
                else {
                    $scope.DataObject.DefaultDicomViewer = {
                        PreferenceType: "DefaultDicomViewer",
                    };
                }
                $scope.DataObject.NumberofComparisonInReport = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "NumberofComparisonInReport"
                })[0];
                if ($scope.DataObject.NumberofComparisonInReport != null) {
                    $scope.DataObject.NumberofComparisonInReport.PreferenceValue = $scope.DataObject.NumberofComparisonInReport.PreferenceValue != null ? $scope.DataObject.NumberofComparisonInReport.PreferenceValue : "";
                } else {
                    $scope.DataObject.NumberofComparisonInReport = {
                        PreferenceType: "NumberofComparisonInReport",
                        PreferenceValue: "5"
                    };
                }
                $scope.DataObject.PushToTalk = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "PushToTalk"
                })[0];
                if ($scope.DataObject.PushToTalk != null) {
                    $scope.DataObject.PushToTalk.PreferenceValue = $scope.DataObject.PushToTalk.PreferenceValue == "1" ? true : false;
                }
                $scope.DataObject.DeficientWarningOnWorklist = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "DeficientWarningOnWorklist"
                })[0];
                if ($scope.DataObject.DeficientWarningOnWorklist != null) {
                    $scope.DataObject.DeficientWarningOnWorklist.PreferenceValue = $scope.DataObject.DeficientWarningOnWorklist.PreferenceValue == "1" ? true : false;
                }

                $scope.DataObject.ShowTemplateWarning = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "ShowTemplateWarning"
                })[0];
                if ($scope.DataObject.ShowTemplateWarning) {
                    $scope.DataObject.ShowTemplateWarning.PreferenceValue = $scope.DataObject.ShowTemplateWarning.PreferenceValue == "1" ? true : false;
                } else {
                    $scope.DataObject.ShowTemplateWarning = { PreferenceValue: true }
                }

                if ($scope.DataObject.IsDisPref) {
                    $scope.DataObject.DisplaySetting = filterFilter($scope.DataObject.userPreferences, {
                        PreferenceType: "DisplaySetting"
                    })[0];
                    var viewer = ['KONICATEST', 'CIVR', 'MedDream', 'NORTHSTARKONICA'];
                    if ($scope.DataObject.DisplaySetting != null) {
                        var hostdisplaysetting = _.filter(JSON.parse($scope.DataObject.DisplaySetting.PreferenceValue), function (obj) { return obj.HostFingerPrintHash == $sessionStorage.currentUserData.HostFingerPrintHash })[0];
                        $scope.DataObject.otherhostdisplaysetting = _.filter(JSON.parse($scope.DataObject.DisplaySetting.PreferenceValue), function (obj) { return obj.HostFingerPrintHash != $sessionStorage.currentUserData.HostFingerPrintHash });
                        $scope.DataObject.DisplaySetting.PreferenceValue = hostdisplaysetting ? hostdisplaysetting.DisplaySetting : [];
                        $scope.DataObject.DisplaySetting.PreferenceValue = _.filter($scope.DataObject.DisplaySetting.PreferenceValue, function (obj) { return obj.viewer != "KONICA" });
                        $scope.LoadDisplay();
                    } else {
                        $scope.DataObject.DisplaySetting = { PreferenceValue: [] };
                    }
                    _.each(viewer, function (v) {
                        if (!_.filter($scope.DataObject.DisplaySetting.PreferenceValue, function (f) { return f.viewer == v })[0]) {
                            if (v == "CI-VIEWER-1") {
                                var d = _.filter($scope.DataObject.DisplaySetting.PreferenceValue, function (f) { return f.viewer == "CI-VIEWER" })[0]
                                if (d) {
                                    d = angular.copy(d);
                                    d.viewer = v;
                                    $scope.DataObject.DisplaySetting.PreferenceValue.push(d);
                                } else {
                                    $scope.DataObject.DisplaySetting.PreferenceValue.push({ viewer: v, top: 0, left: 0 })
                                }
                            } else {
                                $scope.DataObject.DisplaySetting.PreferenceValue.push({ viewer: v, top: 0, left: 0 })
                            }
                        }
                    });
                    $scope.DataObject.DisplaySetting.PreferenceValue = _.sortBy($scope.DataObject.DisplaySetting.PreferenceValue, function (item) {
                        return viewer.indexOf(item.viewer);
                    });
                    $scope.DataObject.DisplaySetting.PreferenceValue = _.filter($scope.DataObject.DisplaySetting.PreferenceValue, function (f) { return viewer.includes(f.viewer) });
                }
                $scope.DataObject.LoadMoreWorklist = _.find($scope.DataObject.userPreferences, { PreferenceType: "LoadMoreWorklist" });
                $scope.DataObject.DoNotShowStudyAssignedToOtherUsers = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "DoNotShowStudyAssignedToOtherUsers"
                })[0];
                if ($scope.DataObject.DoNotShowStudyAssignedToOtherUsers == null) {
                    $scope.DataObject.DoNotShowStudyAssignedToOtherUsers = {
                        PreferenceType: "DoNotShowStudyAssignedToOtherUsers",
                        PreferenceValue: true
                    };
                }
                else {
                    $scope.DataObject.DoNotShowStudyAssignedToOtherUsers.PreferenceValue = $scope.DataObject.DoNotShowStudyAssignedToOtherUsers.PreferenceValue == "0" ? true : false;
                }

                $scope.DataObject.DoNotShowClipboardAddedStudyToOtherUsers = _.find($scope.DataObject.userPreferences, {
                    PreferenceType: "DoNotShowClipboardAddedStudyToOtherUsers"
                });
                if (!$scope.DataObject.DoNotShowClipboardAddedStudyToOtherUsers) {
                    $scope.DataObject.DoNotShowClipboardAddedStudyToOtherUsers = {
                        PreferenceType: "DoNotShowClipboardAddedStudyToOtherUsers",
                        PreferenceValue: true
                    };
                }
                else {
                    $scope.DataObject.DoNotShowClipboardAddedStudyToOtherUsers.PreferenceValue = $scope.DataObject.DoNotShowClipboardAddedStudyToOtherUsers.PreferenceValue == "0" ? true : false;
                }

                $scope.DataObject.MedDreamViewerKeepOpen = filterFilter($scope.DataObject.userPreferences, {
                    PreferenceType: "MedDreamViewerKeepOpen"
                })[0];
                if ($scope.DataObject.MedDreamViewerKeepOpen != null) {
                    $scope.DataObject.MedDreamViewerKeepOpen.PreferenceValue = $scope.DataObject.MedDreamViewerKeepOpen.PreferenceValue == "1" ? true : false;
                }
                else {
                    $scope.DataObject.MedDreamViewerKeepOpen = {
                        PreferenceType: "MedDreamViewerKeepOpen",
                        PreferenceValue: true
                    };
                }

                getDefaultDictationSystem();
                getPaymentAddedSound();
                //#endregion UserPreference

                //#region ViewerSiteMapping
                if (result.ViewerSiteMapping && result.ViewerSiteMapping.length > 0) {
                    var viewerSiteMappingList = [];
                    var siteList = $scope.DataObject.AllSites;
                    var mappedViewers = _.groupBy(result.ViewerSiteMapping, 'DicomViewer');
                    _.each(Object.keys(mappedViewers), function (key) {
                        var DicomViewer = _.find(DicomViewerFullList, { Value: key });
                        if (DicomViewer) {
                            var obj = {
                                DicomViewer: DicomViewer.Key,
                                UserID: $sessionStorage.currentUserData.userId,
                                selectedSites: [],
                                SiteIds: "",
                                selectedViewer: DicomViewer
                            }

                            _.remove($scope.DataObject.InstDicomViewerList, { Value: key });

                            _.each(mappedViewers[key], function (viewer) {
                                var site = _.find(TenantSitesFullList, { SiteID: viewer.SiteID });
                                if (site) {
                                    obj.selectedSites.push({
                                        Site: site.Site,
                                        SiteID: site.SiteID
                                    });
                                    obj.SiteIds = (obj.SiteIds == "") ? site.SiteID : obj.SiteIds + "," + site.SiteID;

                                    siteList = _.filter(siteList, function (obj) { return obj.SiteID != site.SiteID });
                                }

                            });
                            viewerSiteMappingList.push(obj);
                            $scope.DataObject.AllSites = _.cloneDeep(siteList);
                        }
                    });
                    if (DicomViewerGridOption && DicomViewerGridOption.api) {
                        DicomViewerGridOption.api.setRowData(viewerSiteMappingList);
                    }
                }
                //#endregion ViewerSiteMapping

                $scope.DataObject.isLoading = false;

            }, function (err) { $scope.DataObject.isLoading = false });
        };

        //$scope.GetUserWorkList();
        function setPreferance(PreferenceType) {
            // Add new preference for MedDreamViewerKeepOpen early in switch statement
            var userPreference;

            switch (PreferenceType) {
                case "LoadMoreWorklist":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.LoadMoreWorklist.UserPreferenceID ? $scope.DataObject.LoadMoreWorklist.UserPreferenceID : "-1",
                        PreferenceType: "LoadMoreWorklist",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.LoadMoreWorklist.PreferenceValue,
                    };
                    $localStorage.LoadMoreWorklist = $scope.DataObject.LoadMoreWorklist.PreferenceValue;
                    break;

                case "DefaultWorklist":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.DefaultWorklist.UserPreferenceID ? $scope.DataObject.DefaultWorklist.UserPreferenceID : "-1",
                        PreferenceType: "DefaultWorklist",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.DefaultWorklist.PreferenceValue,
                    };
                    break;

                case "Choose Next Study":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.ChooseNextStudy.UserPreferenceID ? $scope.DataObject.ChooseNextStudy.UserPreferenceID : "-1",
                        PreferenceType: "Choose Next Study",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.ChooseNextStudy.PreferenceValue ? "1" : "0",
                    };
                    break;

                case "ShowLockStudy":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.ShowLockStudy.UserPreferenceID ? $scope.DataObject.ShowLockStudy.UserPreferenceID : "-1",
                        PreferenceType: "ShowLockStudy",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.ShowLockStudy.PreferenceValue ? '1' : '0',
                    };
                    break;

                case "DoNotShowStudyAssignedToOtherUsers":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.DoNotShowStudyAssignedToOtherUsers.UserPreferenceID ? $scope.DataObject.DoNotShowStudyAssignedToOtherUsers.UserPreferenceID : "-1",
                        PreferenceType: "DoNotShowStudyAssignedToOtherUsers",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.DoNotShowStudyAssignedToOtherUsers.PreferenceValue ? '0' : '1',
                    };
                    break;
                case "DoNotShowClipboardAddedStudyToOtherUsers":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.DoNotShowClipboardAddedStudyToOtherUsers.UserPreferenceID ? $scope.DataObject.DoNotShowClipboardAddedStudyToOtherUsers.UserPreferenceID : "-1",
                        PreferenceType: "DoNotShowClipboardAddedStudyToOtherUsers",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.DoNotShowClipboardAddedStudyToOtherUsers.PreferenceValue ? '0' : '1',
                    };
                    break;

                case "DefaultDictationSystem":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.DefaultDictationSystem && $scope.DataObject.DefaultDictationSystem.length > 0 && $scope.DataObject.DefaultDictationSystem[0].UserPreferenceID ? $scope.DataObject.DefaultDictationSystem[0].UserPreferenceID : "-1",
                        PreferenceType: "DefaultDictationSystem",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.SelectedDefaultDictationSystem.PreferenceValue ? $scope.DataObject.SelectedDefaultDictationSystem.PreferenceValue : "",
                    };
                    $sessionStorage.DefaultDictationSystem = $scope.DataObject.SelectedDefaultDictationSystem.PreferenceValue;
                    break;

                case "DisplaySetting":
                    if ($scope.DataObject.IsDisPref) {
                        var count = _.filter($scope.DataObject.DisplaySetting.PreferenceValue, function (d) { return !d.display });
                        if (count.length > 0) {
                            toaster.warning({ body: "Please select display setting." });
                            return;
                        }
                        else {
                            //DisplaySetting
                            if ($scope.DataObject.DisplaySetting != null) {
                                var pref = angular.copy($scope.DataObject.DisplaySetting.PreferenceValue);
                                _.each(pref, function (d) {
                                    delete d.display;
                                });
                                if (!$scope.DataObject.otherhostdisplaysetting) {
                                    $scope.DataObject.otherhostdisplaysetting = [];
                                }
                                $scope.DataObject.otherhostdisplaysetting.push({ "HostFingerPrintHash": $sessionStorage.currentUserData.HostFingerPrintHash, "DisplaySetting": pref });
                                userPreference = {
                                    UserPreferenceID: $scope.DataObject.DisplaySetting.UserPreferenceID ? $scope.DataObject.DisplaySetting.UserPreferenceID : "-1",
                                    PreferenceType: "DisplaySetting",
                                    UserID: $sessionStorage.currentUserData.userId,
                                    PreferenceValue: JSON.stringify($scope.DataObject.otherhostdisplaysetting),
                                };
                            }
                        }
                    }
                    break;

                //#region Below Preferences we are not using right now
                case "SendDefaultAlertforOncall":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.SendDefaultAlertforOncall.UserPreferenceID ? $scope.DataObject.SendDefaultAlertforOncall.UserPreferenceID : "-1",
                        PreferenceType: "SendDefaultAlertforOncall",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.SendDefaultAlertforOncall.PreferenceValue ? '0' : '1',
                    };
                    break;

                case "DefaultDicomViewer":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.DefaultDicomViewer.UserPreferenceID ? $scope.DataObject.DefaultDicomViewer.UserPreferenceID : "-1",
                        PreferenceType: "DefaultDicomViewer",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.SelectedDefaultDicomViewer.Value ? $scope.DataObject.SelectedDefaultDicomViewer.Value : "",
                    }
                    break;
                case "NumberofComparisonInReport":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.NumberofComparisonInReport.UserPreferenceID ? $scope.DataObject.NumberofComparisonInReport.UserPreferenceID : "-1",
                        PreferenceType: "NumberofComparisonInReport",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.NumberofComparisonInReport.PreferenceValue
                    };
                    break;
                case "PushToTalk":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.PushToTalk.UserPreferenceID ? $scope.DataObject.PushToTalk.UserPreferenceID : "-1",
                        PreferenceType: "PushToTalk",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.PushToTalk.PreferenceValue ? "1" : "0",
                    };
                    break;
                case "DeficientWarningOnWorklist":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.DeficientWarningOnWorklist.UserPreferenceID ? $scope.DataObject.DeficientWarningOnWorklist.UserPreferenceID : "-1",
                        PreferenceType: "DeficientWarningOnWorklist",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.DeficientWarningOnWorklist.PreferenceValue ? "1" : "0",
                    };
                    break;
                case "ShowTemplateWarning":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.ShowTemplateWarning.UserPreferenceID ? $scope.DataObject.ShowTemplateWarning.UserPreferenceID : "-1",
                        PreferenceType: "ShowTemplateWarning",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.ShowTemplateWarning.PreferenceValue ? "1" : "0",
                    }
                    break;
                case "PaymentAddedSound":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.PaymentAddedSound.UserPreferenceID ? $scope.DataObject.PaymentAddedSound.UserPreferenceID : "-1",
                        PreferenceType: "PaymentAddedSound",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.PaymentAddedSound.PreferenceValue ? "1" : "0",
                    }
                    break;

                case "MedDreamViewerKeepOpen":
                    userPreference = {
                        UserPreferenceID: $scope.DataObject.MedDreamViewerKeepOpen.UserPreferenceID ? $scope.DataObject.MedDreamViewerKeepOpen.UserPreferenceID : "-1",
                        PreferenceType: "MedDreamViewerKeepOpen",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.DataObject.MedDreamViewerKeepOpen.PreferenceValue ? "1" : "0",
                    }
                    break;
                //#endregion Below Preferences we are not using right now
            }
            return userPreference;
        };
        // Helper function to log user events
        function logUserEvent(eventName) {
            var userId = $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '';
            if (userId) {
                var AccountManagerService = $injector.get('AccountManagerService');
                var UserEventLog = [{
                    FromUserID: userId,
                    ToUserID: userId,
                    EventName: eventName
                }];
                AccountManagerService.AddUserEvent(UserEventLog);
            }
        }

        $scope.SavePreference = function (PreferenceType) {
            //if (!$scope.DataObject.NumberofComparisonInReport.PreferenceValue || $scope.DataObject.NumberofComparisonInReport.PreferenceValue <= 0) {
            //    $scope.DataObject.isInvalidNumberofComparison = true;
            //    return;
            //}

            var userPreference = setPreferance(PreferenceType);
            if (userPreference) {
                $scope.DataObject.isLoading = true;
                UserPreferenceService.AddEditUserPreferences([userPreference]).then(function (result) {
                    // Log user event for preference change
                    var eventName = "UPDATE USER PREFERENCE " + PreferenceType.split(/(?=[A-Z])/).join(' ').toUpperCase();
                    logUserEvent(eventName);

                    if (PreferenceType === "MedDreamViewerKeepOpen") {
                        // viewer.service.js reads this session flag at close-time; it is only
                        // populated at login otherwise, so refresh it here for immediate effect.
                        $sessionStorage.MedDreamViewerKeepOpen = userPreference.PreferenceValue === "1";
                    }

                    GetUserPreferences();
                    $scope.DataObject.isLoading = false;
                    toaster.success({ body: "Preference saved successfully!" });
                    //$scope.DataObject.isInvalidNumberofComparison = false;
                }, function (err) { $scope.DataObject.isLoading = false });
            }
        };

        function GetSitesByUserId() {
            var d = $q.defer();
            ProfileService.GetSitesByUserId($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.DataObject.AllSites = result.data;
                TenantSitesFullList = result.data;
                d.resolve(result);
            }, function (err) { $scope.DataObject.isLoading = false });
            return d.promise;
        };
        function GetLookupByType() {
            var d = $q.defer();
            ManageLocationService.GetLookupByType('DictationSystem').then(function (result) {
                $scope.DataObject.DefaultDictationSystemList = _.filter(result, { 'Type': 'DictationSystem' });
                getDefaultDictationSystem();
                d.resolve(result);
            }, function (err) { $scope.DataObject.isLoading = false });
            return d.promise;
        };
        function GetDicomViewerByUserId() {
            var d = $q.defer();
            UserPreferenceService.GetDicomViewerByUserId($sessionStorage.currentUserData.userId).then(function (result) {
                if (result && result.length > 0) {
                    $scope.DataObject.InstDicomViewerList = result;
                    sortDicomViewer();
                    DicomViewerFullList = _.cloneDeep($scope.DataObject.InstDicomViewerList);
                }
                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false });
            return d.promise;
        }

        $scope.InsertDicomViewerCredentials = function () {
            if (!$scope.DataObject.InstSelected.Site) {
                toaster.warning({ body: "Please select site!" });
                return;
            }
            if (!$scope.DataObject.InstAddInstitution.ddlDicomViewer) {
                toaster.warning({ body: "Please select viewer!" });
                return;
            }
            $scope.DataObject.isLoading = true;
            var objdata = {
                ID: $scope.DataObject.Id,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: $scope.DataObject.InstSelected.Site.SiteID,
                ViewerName: $scope.DataObject.InstAddInstitution.ddlDicomViewer.Value,
                UserName: $scope.DataObject.DVCredUsername,
                Password: $scope.DataObject.DVCredPassword,
                Modifyby: $sessionStorage.currentUserData.userId
            };
            WorklistService.InsertDicomViewerCredentials(objdata).then(function (result) {
                if (result != null && result.length > 0) {
                    toaster.error({ body: "Site and viewer already mapped!" });
                }
                else {
                    if ($scope.DataObject.Id > 0) {
                        toaster.success({ body: "Data updated successfully." });
                    }
                    else {
                        toaster.success({ body: "Data updated successfully." });
                    }
                    $scope.clear();
                    $scope.GetAllDicomViewerCredentials();

                }

                $scope.DataObject.isLoading = false;
            }, function (err) { $scope.DataObject.isLoading = false });
        };

        $scope.GetAllDicomViewerCredentials = function () {
            $scope.DataObject.isLoading = true;

            var objFilter = {
                PageNum: $scope.DataObject.PageNo,
                PageSize: $scope.DataObject.PageSize,
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: ($scope.DataObject.SelectedSite.Site) ? $scope.DataObject.SelectedSite.Site.SiteID : null,
                ViewerName: ($scope.DataObject.SelectedViewer.ddlDicomViewer) ? $scope.DataObject.SelectedViewer.ddlDicomViewer.Value : null,
                OrderByField: $scope.DataObject.OrderByField,
                OrderBy: $scope.DataObject.ReverseSort
            };
            ManageLocationService.GetAllDicomViewerCredentials(objFilter).then(function (result) {
                if (result != null && result.length > 0) {
                    $scope.DataObject.TotalRows = result[0].TotalCount;
                    $scope.DataObject.DicomViewerList = result;
                }
                else {
                    $scope.DataObject.TotalRows = "0";
                    $scope.DataObject.DicomViewerList = [];
                }
                $scope.DataObject.isLoading = false;
            }, function (error) {
                $scope.DataObject.isLoading = false;
            });
            $scope.activeTableTR();  // table row active
        };
        $scope.pageChanged = function () {
            $scope.GetAllDicomViewerCredentials();
        };
        $scope.pageSizeChanged = function () {
            $scope.DataObject.PageNo = 1;
            $scope.GetAllDicomViewerCredentials();
        };
        $scope.SortFilter = function (OrderByField) {
            $scope.DataObject.PageNo = 1;
            $scope.DataObject.PageSize = "25";
            $scope.DataObject.OrderByField = OrderByField;
            $scope.DataObject.ReverseSort = !$scope.DataObject.ReverseSort;
            $scope.GetAllDicomViewerCredentials();
        };
        $scope.clear = function () {
            $scope.DataObject.Id = -1;
            $scope.DataObject.InstSelected.Site = null;
            $scope.DataObject.InstAddInstitution.ddlDicomViewer = null;
            $scope.DataObject.DVCredUsername = '';
            $scope.DataObject.DVCredPassword = '';
            $scope.DataObject.AddDVCredentials = false;
        }
        $scope.ClearFilter = function () {
            $scope.DataObject.SelectedSite.Site = null;
            $scope.DataObject.SelectedViewer.ddlDicomViewer = null;
            $scope.GetAllDicomViewerCredentials();
        };
        $scope.LoadData = function (data) {
            $scope.DataObject.AddDVCredentials = true;
            $scope.DataObject.Id = data.ID;
            $scope.DataObject.InstSelected.Site = _.filter($scope.DataObject.AllSites, function (obj) { return obj.SiteID == data.SiteID; })[0];
            //$scope.InstAddInstitution.ddlDicomViewer = _.filter($scope.InstDicomViewerList, function (obj) { return obj.Value == data.ViewerName; })[0];
            $scope.DataObject.InstAddInstitution.ddlDicomViewer = _.filter($scope.DataObject.InstDicomViewerList, function (obj) { return obj.Key == data.ViewerName; })[0];
            $scope.DataObject.DVCredUsername = data.UserName;
            $scope.DataObject.DVCredPassword = data.Password;
        };
        $scope.AddDicomViewerCredentials = function () {
            $scope.DataObject.AddDVCredentials = true;
        }
        $scope.DataObject.Display = [];
        $scope.LoadDisplay = function () {
            if ($scope.DataObject.IsDisPref) {
                if (!$localStorage.Monitors) {
                    $localStorage.Monitors = [
                        {
                            0: "0",
                            1: "0",
                            2: window.screen.availWidth,
                            3: window.screen.availHeight,
                            left: "0",
                            top: "0",
                            width: window.screen.availWidth,
                            height: window.screen.availHeight,
                            originalWidth: window.screen.width,
                            originalHeight: window.screen.height,
                            count: 1,
                            name: "DISPLAY1"
                        }
                    ]
                }
                $scope.DataObject.Display = $localStorage.Monitors;
                if ($scope.DataObject.DisplaySetting && $scope.DataObject.DisplaySetting.PreferenceValue) {
                    _.each($scope.DataObject.DisplaySetting.PreferenceValue, function (d) {
                        d.display = _.filter($scope.DataObject.Display, function (o) { return o.name == d.displayName })[0];
                        if (!d.display) {
                            d.display = { name: d.displayName };
                        }
                    });
                }
            }
        }
        $scope.LoadDisplay();
        $scope.setDisplayValue = function (o) {
            o.displayName; o.width = 0; o.height = 0; o.top = 0; o.left = 0; o.layout = '';
            if (o.display) {
                o.width = o.display.width; o.height = o.display.height; o.displayName = o.display.name;
            }
        }

        $scope.setDisplay = function (o, h, w, x, y, layout) {
            o.width = 0; o.height = 0; o.top = 0; o.left = 0;
            if (o.display) {
                o.height = parseInt(o.display.height * h);
                o.width = parseInt(o.display.width * w);
                o.top = parseInt(o.display.height * x);
                o.left = parseInt(o.display.width * y);
                o.layout = layout;
            }
        }
        $scope.DisplayPreview = function (o) {
            var win = windowHandler._openByPreference('displayLabel.html?display=' + o.displayName, o.viewer + "-" + o.layout, 1000, "", true, null, angular.copy(o));
            $timeout(function () {
                win.close();
            }, 10000);
        }

        function getDefaultDictationSystem() {
            $scope.DataObject.DefaultDictationSystem = filterFilter($scope.DataObject.userPreferences, {
                PreferenceType: "DefaultDictationSystem"
            });
            if ($scope.DataObject.DefaultDictationSystem != null && $scope.DataObject.DefaultDictationSystem.length > 0) {
                var PreferenceValue = _.filter($scope.DataObject.DefaultDictationSystemList, function (obj) { return obj.Value == $scope.DataObject.DefaultDictationSystem[0].PreferenceValue; });
                if (PreferenceValue && PreferenceValue.length > 0) {
                    $scope.DataObject.SelectedDefaultDictationSystem.PreferenceValue = PreferenceValue[0].Value;
                }
            }
            else {
                $scope.DataObject.DefaultDictationSystem = {
                    PreferenceType: "DefaultDictationSystem",
                };
            }
        }

        $scope.setDefaultDisplay = function (o) {
            console.info(o);
            if (!o.display) {
                if ($scope.DataObject.Display && $scope.DataObject.Display.length > 0) {
                    o.display = $scope.DataObject.Display[0];
                    $scope.setDisplayValue(o);
                    $scope.setDisplay(o, 1, 0.5, 0, 0.5, 'L1-2')
                }
            }
        }
        $scope.SetDicomViewerText = function (DV) {
            var viewer = _.filter(DicomViewerFullList, { "Value": DV });
            if (viewer != null && viewer.length > 0) {
                return viewer[0].Key
            }
            else {
                return DV;
            }
        }
        /*
         * will implement this code when we refactor code for display settings
         *
        $scope.setDefaultScreen = function (o) {
            var screen = o.layout.split("-")[0];
            var div = ''
            switch (screen) {
                case 'L1':
                    div = $('#cardscreen1').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L2':
                    div = $('#cardscreen2').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L3':
                    div = $('#cardscreen3').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L4':
                    div = $('#cardscreen4').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L5':
                    div = $('#cardscreen5').prop('outerHTML');
                    console.log("div > ", div)
                    break;
                case 'L6':
                    div = $('#cardscreen6').prop('outerHTML');
                    console.log("div > ", div)
                    break;
            }
            o.selectedScreen = div;
        }
        */

        $scope.checkboxLabel = "No";
        $scope.ChooseStudy = function () {
            $scope.DataObject.userPreferences.PreferenceValue == true;
            if ($scope.DataObject.userPreferences.PreferenceValue == true) {
                $scope.checkboxLabel = "Yes";
            }
            else {
                $scope.checkboxLabel = "No";
            }
        }

        //#region Dicom Viewer AG Grid
        var editingRow = {};
        var addNewRowTxt = "Add New";
        var rowId = -1;
        var DicomViewerColDef = [
            {
                field: "DicomViewer",
                editable: function (params) {
                    return (params.data.DicomViewer != addNewRowTxt) ? true : false;
                },
                cellEditor: ViewerEditor(),
                cellEditorPopup: true,
                initialWidth: 200,
                cellRenderer: function (params) {
                    if (params.data.DicomViewer != addNewRowTxt) {
                        if ($scope.DataObject.SelectedViewer) {
                            params.data.selectedViewer = $scope.DataObject.SelectedViewer;
                            params.data.DicomViewer = $scope.DataObject.SelectedViewer.Key;
                        }
                        return params.data.DicomViewer;
                    } else {
                        return '<span class="fw-600"><i class="fa fa-plus"></i> ' + params.data.DicomViewer + '</span>';
                    }

                },
            },
            {
                field: "Site",
                editable: function (params) {
                    return (params.data.DicomViewer != addNewRowTxt) ? true : false;
                },
                cellEditor: SitesEditor(),
                cellRenderer: function (params) {
                    var template = "<div class='dicomview-sites'>";
                    if (params.data.Site == "Click Here") {
                        template = template + "Click Here!";
                    }
                    if (params.data && params.data.selectedSites) {
                        _.each(params.data.selectedSites, function (site) {
                            template = template + "<span class='p-4px-all mlp-value-box mr-4px text-nowrap'>" + site.Site + "</span>";
                        });
                    }
                    template = template + "</div>";
                    return template;
                },
                cellEditorPopup: true,
                flex: 1,
                wrapText: true,
                autoHeight: true,
            },
            {
                field: "Action",
                cellRenderer: function (params) {
                    if (params.data.DicomViewer != addNewRowTxt) {
                        return '<i class="fa fa-trash-o txt-clr-31 cursor-pointer fs-16px" aria-hidden="true" title="Delete"></i>';
                    }
                },
                initialWidth: 100,
            }
        ];

        var DicomViewerGridOption = {
            columnDefs: DicomViewerColDef,
            rowHeight: 36,
            defaultColDef: {
                sortable: false,
                lockVisible: true,
                suppressMovable: true,
                suppressMenu: true,
                resizable: false,
            },
            suppressClickEdit: true,
            onGridReady: function () {
                DicomViewerGridOption.api.setPinnedBottomRowData([{
                    DicomViewer: addNewRowTxt,
                    Site: "",
                    rowColor: "#1c1c1c"
                }])
            },
            getRowStyle: function (params) {
                if (params && params.data && params.data.rowColor) {
                    return {
                        paddingTop: '4px',
                        background: params.data.rowColor
                    };
                }
            },
            getRowId: function (params) {
                rowId++;
                if (params && params.data && !params.data.hasOwnProperty('ID')) {
                    params.data.ID = rowId.toString();
                }
                if (params.data.hasOwnProperty('ID')) {
                    return params.data.ID;
                }
            },
            onCellClicked: function (params) {
                params.api.stopEditing();
                if (params.data.DicomViewer == addNewRowTxt) {
                    var renderedRows = DicomViewerGridOption.api.getRenderedNodes();
                    if (renderedRows.length != DicomViewerFullList.length) {
                        AddViewerSiteMapping();
                    } else {
                        toaster.warning("No Additional Rows Can Be Added!")
                    }
                }
                else {
                    switch (params.column.colId) {
                        case "Action":
                            DeleteViewerSitePref(params.node.data.ID);
                            break;
                        case "DicomViewer":
                            params.api.startEditingCell({
                                rowIndex: params.rowIndex,
                                colKey: params.column.colId
                            });
                            break;
                        case "Site":
                            if (params.data.selectedViewer) {
                                params.api.startEditingCell({
                                    rowIndex: params.rowIndex,
                                    colKey: params.column.colId
                                });
                            } else {
                                toaster.warning("Please Select Dicom Viewer!");
                                params.api.startEditingCell({
                                    rowIndex: params.rowIndex,
                                    colKey: "DicomViewer"
                                });
                            }
                            break;
                    }
                }
            },
            onCellEditingStarted: function (params) {
                editingRow = params.node.data;
                if (params.column.colId == "DicomViewer") {
                    var timeout = $timeout(function () {
                        $scope.DataObject.SelectedViewer = params.data.selectedViewer;
                        $timeout.cancel(timeout);
                        timeout = null;
                    }, 0);

                    $scope.DataObject.InstDicomViewerList = DicomViewerFullList;
                    DicomViewerGridOption.api.forEachNode(function (node) {
                        if (node.data.selectedViewer) {
                            $scope.DataObject.InstDicomViewerList = _.filter($scope.DataObject.InstDicomViewerList, function (obj) {
                                return obj.Value != node.data.selectedViewer.Value;
                            });
                        }
                    });
                    if (params.data.selectedViewer) {
                        var viewer = _.find($scope.DataObject.InstDicomViewerList, { Value: params.data.selectedViewer.Value });
                        if (!viewer) {
                            var viewer = _.find(DicomViewerFullList, { Value: params.data.selectedViewer.Value });
                            if (viewer) {
                                $scope.DataObject.InstDicomViewerList.push(viewer);
                            }
                        }
                    }
                    sortDicomViewer();
                }
                else if (params.column.colId == "Site") {
                    $scope.DataObject.AllSites = _.filter(TenantSitesFullList, function (site) {
                        if (site.DicomViewer) {
                            return (site.DicomViewer).includes(params.data.selectedViewer.Value);
                        }
                    });
                    DicomViewerGridOption.api.forEachNode(function (node) {
                        if (node.data.selectedSites) {
                            _.each(node.data.selectedSites, function (site) {
                                $scope.DataObject.AllSites = _.filter($scope.DataObject.AllSites, function (obj) {
                                    return obj.SiteID != site.SiteID;
                                });
                            });
                        }
                    });
                    _.each(params.data.selectedSites, function (obj) {
                        var site = _.find($scope.DataObject.AllSites, { SiteID: obj.SiteID });
                        if (!site) {
                            var tenantSite = _.find(TenantSitesFullList, { SiteID: obj.SiteID });
                            if (tenantSite) {
                                $scope.DataObject.AllSites.push(tenantSite);
                            }
                        }
                    });
                    $scope.DataObject.AllSites = $filter('orderBy')($scope.DataObject.AllSites, ['TenantName', 'Site']);

                    if (params.data.selectedSites) {
                        $scope.DataObject.SelectedSites = {
                            Ids: params.data.SiteIds,
                            sites: [],
                            divId: "UserPref"
                        }
                    }
                }
            },
            onCellEditingStopped: function (params) {
                editingRow = {};
                if (params.column.colId == "DicomViewer") {
                    $scope.DataObject.SelectedViewer = null;
                }
                else if (params.column.colId == "Site") {
                    $scope.DataObject.SelectedSites = {
                        Ids: "",
                        sites: [],
                        divId: "UserPref"
                    }
                }

                if (params.data.selectedViewer && (!params.data.selectedSites || params.data.selectedSites.length == 0)) {
                    var row = params.data;
                    row.Site = "Click Here";
                    DicomViewerGridOption.api.applyTransaction({ update: [row] });
                }
            },
            getContextMenuItems: function () { return [] },
            rowData: [],
        }

        function SitesEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                $scope.DataObject.AllSites = _.uniqBy($scope.DataObject.AllSites, 'SiteID');
                this.eGui = document.createElement('div');
                this.eGui.className = ""
                this.eGui.innerHTML = '<tenant-site-dropdown class="site-editor"' +
                    'master-Sites="DataObject.AllSites" ' +
                    'selected-Sites="DataObject.SelectedSites">' +
                    '</tenant-site-dropdown>';

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                if ($scope.DataObject.SelectedSites && $scope.DataObject.SelectedSites.sites) {
                    editingRow.selectedSites = $scope.DataObject.SelectedSites.sites;
                    editingRow.SiteIds = $scope.DataObject.SelectedSites.Ids;
                }
                return editingRow.SiteIds;
            }
            return CustomEditor;
        }
        function ViewerEditor() {
            function CustomEditor() {
            }
            CustomEditor.prototype.init = function (params) {
                $scope.DataObject.InstDicomViewerList = _.uniqBy($scope.DataObject.InstDicomViewerList, 'ID');
                this.eGui = document.createElement('div');
                this.eGui.className = "dicom-viewer-dropdown";
                this.eGui.innerHTML =
                    '<ui-select class="viewer-editor mult-select provider-select seltype-drop mob-closekeypad" ng-model="DataObject.SelectedViewer" on-select="onSelectViewer();">' +
                    '<ui-select-match placeholder="Select Viewer">' +
                    '{{$select.selected.Key}}' +
                    '</ui-select-match>' +
                    '<ui-select-choices repeat="viewer in DataObject.InstDicomViewerList | filter: {Key: $select.search} track by $index"> ' +
                    '<div ng-bind-html="viewer.Key | highlight: $select.search"></div>' +
                    '</ui-select-choices>' +
                    '</ui-select>';

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);
            }
            CustomEditor.prototype.getGui = function () {
                return this.eGui;
            };
            CustomEditor.prototype.destroy = function () {
            };
            CustomEditor.prototype.getValue = function () {
                var val = editingRow.DicomViewer;
                if ($scope.DataObject.SelectedViewer && $scope.DataObject.SelectedViewer.Value) {
                    val = $scope.DataObject.SelectedViewer.Key;
                }
                return val;
            }
            return CustomEditor;
        }

        $scope.onSelectViewer = function () {
            DicomViewerGridOption.api.stopEditing();
        }

        function AddViewerSiteMapping() {
            $scope.DataObject.SelectedSites = {
                Ids: '',
                sites: [],
                divId: "UserPref"
            };
            $scope.DataObject.SelectedViewer = null;

            if (DicomViewerGridOption && DicomViewerGridOption.api) {
                DicomViewerGridOption.api.stopEditing();
                var result = DicomViewerGridOption.api.applyTransaction({
                    add: [{
                        DicomViewer: "Click Here!",
                        Site: ""
                    }],
                });

                if (result && result.add && result.add.length > 0) {
                    DicomViewerGridOption.api.startEditingCell({
                        rowIndex: result.add[0].rowIndex,
                        colKey: "DicomViewer",
                    });
                }
            }
        }
        $scope.SaveViewerSitePref = function () {
            DicomViewerGridOption.api.stopEditing();
            var params = {
                UserID: $sessionStorage.currentUserData.userId,
                Flag: 'I',
                DicomViewerSiteID: []
            }
            var isValidData = true;
            DicomViewerGridOption.api.forEachNode(function (node) {
                if (node.data && node.data.selectedViewer && node.data.selectedSites) {
                    if (node.data.selectedSites.length > 0) {
                        _.each(node.data.selectedSites, function (site) {
                            params.DicomViewerSiteID.push({ DicomViewer: node.data.selectedViewer.Value, SiteID: site.SiteID });
                        });
                    }
                    else {
                        isValidData = false;
                    }
                }
                else {
                    isValidData = false;
                }
            });

            if (isValidData && params.DicomViewerSiteID.length > 0) {
                SetUserSiteViewer(params).then(function () {
                    // Log user event for viewer-site mapping
                    logUserEvent("UPDATE USER PREFERENCE DICOM VIEWER SITE MAPPING");

                    _.each(params.DicomViewerSiteID, function (obj) {
                        _.remove($scope.DataObject.InstDicomViewerList, { Value: obj.DicomViewer });
                    });
                    toaster.success("Dicom Viewer And Site Mapping/s Updated Successfully.");
                }, function (err) { $scope.DataObject.isLoading = false });
            } else {
                toaster.error({
                    title: "Some Error Occured!",
                    body: "Some Details Are Missing."
                })
            }
        }

        function DeleteViewerSitePref(ID) {
            var result = DicomViewerGridOption.api.applyTransaction({
                remove: [{ ID: ID }]
            });
            if (result && result.remove && result.remove.length > 0) {
                if (result.remove[0].data.selectedSites) {
                    var params = {
                        UserID: $sessionStorage.currentUserData.userId,
                        Flag: 'D',
                        DicomViewerSiteID: [{ DicomViewer: result.remove[0].data.selectedViewer.Value, SiteID: null }]
                    }
                    SetUserSiteViewer(params).then(function () {
                        // Log user event for viewer-site mapping deletion
                        logUserEvent("DELETE USER PREFERENCE DICOM VIEWER SITE MAPPING");

                        var viewer = _.find(DicomViewerFullList, { Key: result.remove[0].data.DicomViewer });
                        if (viewer) {
                            $scope.DataObject.InstDicomViewerList.push(viewer);
                            sortDicomViewer();
                        }

                        _.each(result.remove[0].data.selectedSites, function (site) {
                            var obj = _.find($scope.DataObject.AllSites, { SiteID: site.SiteID });
                            if (!obj) {
                                var tenantSite = _.find(TenantSitesFullList, { SiteID: site.SiteID });
                                if (tenantSite) {
                                    $scope.DataObject.AllSites.push(tenantSite);
                                }
                            }
                        });
                        $scope.DataObject.AllSites = $filter('orderBy')($scope.DataObject.AllSites, ['TenantName', 'Site']);
                        DicomViewerGridOption.api.stopEditing();
                        toaster.success("Dicom Viewer And Site Mapping Removed Successfully.");
                    }, function (err) { $scope.DataObject.isLoading = false });
                }
            } else {
                toaster.error({ body: "Some Error Occured!" })
            }


        }
        //#endregion Dicom Viewer AG Grid

        function SetUserSiteViewer(params) {
            var d = $q.defer();
            UserPreferenceService.SetUserSiteViewer(params).then(function (result) {
                d.resolve();
            }, function (err) { $scope.DataObject.isLoading = false });

            return d.promise;
        }

        function sortDicomViewer() {
            $scope.DataObject.InstDicomViewerList.sort(
                function (a, b) {
                    if (a.Key && b.Key && a.Key.toLowerCase() < b.Key.toLowerCase()) return -1;
                    if (a.Key && b.Key && a.Key.toLowerCase() > b.Key.toLowerCase()) return 1;
                    return 0;
                }
            );
        }

        function getPaymentAddedSound() {
            $scope.DataObject.PaymentAddedSound = filterFilter($scope.DataObject.userPreferences, {
                PreferenceType: "PaymentAddedSound"
            })[0];
            if ($scope.DataObject.PaymentAddedSound != null) {
                $scope.DataObject.PaymentAddedSound.PreferenceValue = $scope.DataObject.PaymentAddedSound.PreferenceValue == "1" ? true : false;
            }
            else {
                $scope.DataObject.PaymentAddedSound = {
                    PreferenceType: "PaymentAddedSound",
                }
            }
        }
        window.addEventListener("click", windowClicklistner);

        function windowClicklistner(event) {
            if (event && event.target && event.target.classList) {
                var viewerEditor = event.target.closest(".viewer-editor");
                var siteEditor = event.target.closest(".site-editor");
                if (!viewerEditor && !siteEditor) {
                    if (DicomViewerGridOption && DicomViewerGridOption.api) {
                        DicomViewerGridOption.api.stopEditing();
                    }
                }
            }
        }


    };
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('videocallconsult', {
            templateUrl: 'app/theme/components/vc-consult-component/vc-consult-component.html',
            bindings: {
                check: '<',
                onClose: '&',
                selectedOrder: '<',
                onSend: '&',
            },
            controller: vcconsultWindowController
        });

    /** @ngInject */
    function vcconsultWindowController($scope, $rootScope, $state, $sessionStorage, OnCallScheduleService) {

        var vm = this;
        vm.isShowChatWindow = false;
        vm.toUserId = "0";
        var worklistOrderData = {};
        $scope.isChatMenuActive = false;
        $scope.SelectedRadiologist = {};
        $scope.isHighPriority = false;
        $scope.activeChatMenuBar = function () {
            $scope.isChatMenuActive = !$scope.isChatMenuActive;
            $scope.isShowChatWindow = true;
            $rootScope.$broadcast('activeChatMenuBar:shareExamComponent', $scope.isChatMenuActive);
        }

        $scope.close = function () {
            vm.check = true;
            vm.onClose({ check: vm.check });
        }


        function hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function isVisibleRad(r) {
            if (!r) return false;
            if (isSelf(r.Id || r.UserID)) return true;
            return !hasPrelimRad(r.UserRoles || r.Roles);
        }
        $scope.radDisplay = function (r) {
            if (!r) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
        $scope.matchRadSearch = function (search) {
            return function (r) {
                if (!isVisibleRad(r)) return false;
                if (!search) return true;
                var name = ((r.LastName || '') + ', ' + (r.FirstName || '')).toLowerCase();
                return name.indexOf(search.toLowerCase()) >= 0;
            };
        };

        $scope.GetAllUsers = function () {
            OnCallScheduleService.GetAllUserByTenant({ "UserID": $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.Radiologists = _.filter(result, function (obj) {
                    return isVisibleRad(obj) && obj.Id != $sessionStorage.currentUserData.userId;
                });
                $scope.Radiologists = _.orderBy($scope.Radiologists, ['IsOnline', 'LastName'], ['desc', 'asc']);
            });

        };

        vm.$onChanges = function (changes) {
        };

        vm.$onDestroy = function () {
        }
        vm.$onInit = function () {
            $scope.GetAllUsers();
        }
        $scope.SendPopupMessage = function () {
            $scope.close();
            $scope.activeChatMenuBar();
            //message with patientdetails passed to the chat component
            worklistOrderData = {
                "toUserId": $scope.SelectedRadiologist.Obj.Id,
                //"message": message,
                "isHighPriority": false,//$scope.isHighPriority,
                "selectedOrder":vm.selectedOrder,
                "patientDetails": {
                    "PatientName": vm.selectedOrder.PatientName,
                    "Accession": vm.selectedOrder.Accession,
                    "PatientMRN": vm.selectedOrder.PatientMRN,
                    "DicomViewer": vm.selectedOrder.DicomViewer,
                    "DicomViewerURL": vm.selectedOrder.DicomViewerURL,
                    "Site": vm.selectedOrder.Site,
                    
                }
            }
            $rootScope.$broadcast('activeChatMenuBarformWorkList', true, worklistOrderData);
        };

    }

}());

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('wlGridAdvDate', {
            templateUrl: 'app/theme/components/wl-grid-adv-date/wl-grid-adv-date.html',
            bindings: {
                order: '<',
                type: '@'
            },
            controller: WLGridAdvDateController
        });

    /** @ngInject */
    function WLGridAdvDateController($scope, $rootScope, $state, $interval, $log) {
        var vm = this;
        var interval = null;
        vm.$onChanges = function (changes) {
            vm.sinceDate = getOrderRecievedSince(vm.order.CreatedDate);
            vm.createdDate = convertLocalCreatedDate(vm.order.CreatedDate);

            if (vm.type == 'since') {
                vm.data = vm.sinceDate.toUpperCase();
            } else if (vm.type == 'date') {
                vm.data = vm.createdDate;
            }
        };
        vm.$onDestroy = function () {
            if (interval) {
                $interval.cancel(interval);
            }
        }
        vm.$onInit = function () {
            vm.sinceDate = getOrderRecievedSince(vm.order.CreatedDate);
            vm.createdDate = convertLocalCreatedDate(vm.order.CreatedDate);
            if (vm.type == 'since') {
                vm.data = vm.sinceDate.toUpperCase();
            } else if (vm.type == 'date') {
                vm.data = vm.createdDate;
            }
            interval = $interval(function () {
                vm.sinceDate = getOrderRecievedSince(vm.order.CreatedDate);
                if (vm.type == 'since') {
                    vm.data = vm.sinceDate.toUpperCase();
                } 
            }, 1000 * 60);
        }

        function hasDayLightSavingTime(tsDate) {
            //$log.log("hasDayLightSavingTime");
            var tDate = new Date(tsDate);

            var currentDate = new Date(tsDate);
            var currentYear = currentDate.getFullYear();

            // DST Start
            var firstOfMarch = new Date(currentYear, 2, 1);
            var daysUntilFirstSundayInMarch = (7 - firstOfMarch.getDay()) % 7;
            var secondSundayInMarch = firstOfMarch.getDate() + daysUntilFirstSundayInMarch + 7;
            var dstStartDate = new Date(currentYear, 2, secondSundayInMarch, 2);
            //$log.log("hasDayLightSavingTime > dstStartDate: ", dstStartDate);

            // DST End
            var firstOfNovember = new Date(currentYear, 10, 1);
            var daysUntilFirstSundayInNov = (7 - firstOfNovember.getDay()) % 7;
            var firstSundayInNovember = firstOfNovember.getDate() + daysUntilFirstSundayInNov;
            var dstEndDate = new Date(currentYear, 10, firstSundayInNovember, 1, 59);
            //$log.log("hasDayLightSavingTime > dstEndDate: ", dstEndDate);

            if (tDate.getTime() > dstStartDate.getTime() && tDate.getTime() <= dstEndDate.getTime()) {
                return true;
            } else {
                return false;
            }
        }
        function convertUTCDateToLocalDate(date) {
            //$log.log("convertUTCDateToLocalDate");
            return new Date(date);
        }
        function localizeDateStr(date_to_convert_str) {
            //$log.log("localizeDateStr");
            //$log.log("localizeDateStr > date_to_convert_str: ", date_to_convert_str);

            var isDST = moment(date_to_convert_str).isDST();
            //$log.log("localizeDateStr > isDST: ", isDST);
            var timeZoneFromDB = "-06:00"; //time zone value from database

            if (isDST) {
                timeZoneFromDB = "-05:00";
            }
            var sDate = new Date(date_to_convert_str);
            //$log.log("localizeDateStr > sDate: ", sDate);
            var utcDate = sDate.toISOString();

            return convertUTCDateToLocalDate(utcDate);
        }
        var convertLocalCreatedDate = function (cstDateTime) {
            //$log.log("convertLocalCreatedDate");
            var createdDate = localizeDateStr(cstDateTime);
            return (createdDate.getMonth() + 1) + "/" + createdDate.getDate() + "/" + createdDate.getFullYear() + " " + (createdDate.getHours() < 10 ? "0" + createdDate.getHours() : createdDate.getHours()) + ":" + (createdDate.getMinutes() < 10 ? "0" + createdDate.getMinutes() : createdDate.getMinutes());
        };
        var getOrderRecievedSince = function (cstDateTime) {
            //$log.log("getOrderRecievedSince");
            var fDate = localizeDateStr(cstDateTime);
            var tDate = new Date();

            var delta = Math.abs(fDate - tDate) / 1000;

            var days = Math.floor(delta / 86400);
            delta -= days * 86400;

            var hours = Math.floor(delta / 3600) % 24;
            delta -= hours * 3600;

            var minutes = Math.floor(delta / 60) % 60;
            delta -= minutes * 60;

            var seconds = delta % 60;
            var dDays = days;
            var dHours = hours;
            var dMinutes = minutes;
            var pendingSince = "";
            if (dDays > 0)
                pendingSince += dDays + " Day";
            if (dHours > 0)
                pendingSince += ", " + dHours + " hr";
            if (dMinutes > 0)
                pendingSince += ", " + dMinutes + " min";
            if (pendingSince.startsWith(","))
                pendingSince = pendingSince.substring(2, pendingSince.length);
            return pendingSince;
        }
    }
}());




(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('worklistAccordion', {
            templateUrl: 'app/theme/components/worklist-accordion/worklist-accordion.html',
            bindings: {
                worklist: '<',
                defaultWorklist: '<',
                masterData: '<',
                selectedData: '<',
                index: '<',
                resetClipboard: '&',
                editWorklist: '&',
                removeDefaultWorklist: '&',
                updateUserLayoutPref: '&',
                updateProps: '&',
                refreshWorklist: '&',
                onChooseNextStudy: "&"
            },
            controller: WorklistAccordionController
        });

    /** @ngInject */
    function WorklistAccordionController($log, $scope, $localStorage, $sessionStorage) {
        var vm = this;

        var OnLoadRefreshDuration = 1;

        $scope.DataObject = {
            obj: {},
            open: true,
            MasterData: {},
            SelectedData: {},
            index: 0,
            DefaultWorklists: {},
            selectedModalities: {},
        };

        vm.$onChanges = function (changes) {
            //console.log("$onChanges: ", changes);
            if (changes.worklist) {
                $scope.DataObject.obj = _.clone(changes.worklist.currentValue);
                if ($scope.DataObject.obj && !(($scope.DataObject.obj).hasOwnProperty('ChooseNextStudy'))) {
                    $scope.DataObject.obj.ChooseNextStudy = true;
                }
            }
            if (changes.defaultWorklist) {
                $scope.DataObject.DefaultWorklists = _.clone(changes.defaultWorklist.currentValue);
            }


        };
        vm.$onDestroy = function () {
            //$log.log('$onDestroy');
        }
        vm.$onInit = function () {
            //$log.log('$onInit');

            $scope.DataObject.DefaultWorklists = _.clone(vm.defaultWorklist);
            $scope.DataObject.obj = _.clone(vm.worklist);
            $scope.DataObject.MasterData = _.cloneDeep(vm.masterData);
            $scope.DataObject.SelectedData = vm.selectedData;
            $scope.DataObject.index = vm.index;
            $scope.DataObject.modalities = $scope.DataObject.MasterData.Modalities;

            $scope.ResetModalitiesSelection();
        }

        $scope.openAccordian = function (Rule) {
            $scope.DataObject.obj.open = !$scope.DataObject.obj.open;
            Rule.TimeToLoad = moment().add(OnLoadRefreshDuration, 'seconds');
            vm.worklist.open = $scope.DataObject.obj.open;
            vm.worklist.SaveLayout = true;
            vm.updateProps();
        }
        $scope.onChooseNextStudy = function (worklist) {
            if (worklist.WorklistType == 16) {
                $localStorage.OpenClipboardNextStudy = worklist.OpenClipboardNextStudy;
            }
            vm.onChooseNextStudy({ worklist: worklist });
        }
        $scope.onEditWorklist = function () {
            vm.editWorklist();
        }
        $scope.removeDefaultWorklist = function () {
            //$log.log('removeDefaultWorklist');
            vm.removeDefaultWorklist();
        }
        $scope.onUpdateProps = function () {
            //console.log("onUpdateProps > obj:", $scope.DataObject.obj);
            vm.worklist.ResultPendingCount = $scope.DataObject.obj.ResultPendingCount;
            vm.worklist.UnreadRVU = $scope.DataObject.obj.UnreadRVU;
            vm.worklist.STATCount = $scope.DataObject.obj.STATCount;
            vm.worklist.purge = $scope.DataObject.obj.purge;
            vm.worklist.SortColumns = $scope.DataObject.obj.SortColumns;
            vm.worklist.savedState = $scope.DataObject.obj.savedState;
            vm.worklist.Groups = $scope.DataObject.obj.Groups;
            vm.worklist.ResetFilter = $scope.DataObject.obj.ResetFilter;
            vm.worklist.SignedByPrefUpdated = $scope.DataObject.obj.SignedByPrefUpdated;
            vm.worklist.SignedDatePrefUpdated = $scope.DataObject.obj.SignedDatePrefUpdated;
            vm.worklist.SaveLayout = $scope.DataObject.obj.SaveLayout;
            if ($scope.DataObject.obj && !(($scope.DataObject.obj).hasOwnProperty('ChooseNextStudy'))) {
                vm.worklist.ChooseNextStudy = true;
            }
            vm.worklist.AR = $scope.DataObject.obj.AR;
            vm.worklist.BD = $scope.DataObject.obj.BD;
            vm.worklist.BDUS = $scope.DataObject.obj.BDUS;
            vm.worklist.BMD = $scope.DataObject.obj.BMD;
            vm.worklist.CRDX = $scope.DataObject.obj.CRDX;
            vm.worklist.CT = $scope.DataObject.obj.CT;
            vm.worklist.DEXA = $scope.DataObject.obj.DEXA;
            vm.worklist.KO = $scope.DataObject.obj.KO;
            vm.worklist.MG = $scope.DataObject.obj.MG;
            vm.worklist.MR = $scope.DataObject.obj.MR;
            vm.worklist.NM = $scope.DataObject.obj.NM;
            vm.worklist.PT = $scope.DataObject.obj.PT;
            vm.worklist.RF = $scope.DataObject.obj.RF;
            vm.worklist.US = $scope.DataObject.obj.US;
            vm.worklist.XA = $scope.DataObject.obj.XA;

            //vm.worklist.IsSmartWorklist = $scope.DataObject.obj.IsSmartWorklist;
            //vm.worklist.WorklistPageSize = $scope.DataObject.obj.WorklistPageSize;
            //vm.worklist.open = $scope.DataObject.obj.open;
            vm.updateProps();
        }
        $scope.onSelectModalities = function () {
            var masterData = $scope.DataObject.MasterData;
            var Keys = Object.keys($scope.DataObject.selectedModalities);
            var selectedModality = _.filter(Keys, function (key) { return $scope.DataObject.selectedModalities[key] });
            masterData.selectedModalities = [];
            _.each(selectedModality, function (modality) {
                var obj = _.find($scope.DataObject.modalities, { Code: modality });
                if (obj) {
                    masterData.selectedModalities.push(obj);
                }
            });
            $scope.DataObject.MasterData = _.cloneDeep(masterData);
        }
        $scope.ResetModalitiesSelection = function () {
            $scope.DataObject.selectedModalities = {};
            $scope.onSelectModalities();
        }
        $scope.isModalitySelected = function () {
            var selectedmodality = Object.keys($scope.DataObject.selectedModalities);
            var selectedmodalityFilter = _.filter(selectedmodality, function (key) { return $scope.DataObject.selectedModalities[key] });
            return selectedmodalityFilter.length == 0;
        }
        $scope.updateMoadalityCount = function (modalityCount) {
            _.each($scope.DataObject.modalities, function (modality) {
                var idx = _.findIndex(modalityCount, { ModalityID: modality.Id });
                modality.Count = (idx != -1) ? modalityCount[idx].ModalityCount : null;
            });
        }
        $scope.refreshWorklist = function () {
            $scope.ResetModalitiesSelection();
            vm.refreshWorklist();
        }
        //--------
    }
}());
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('worklistAgGrid', {
            templateUrl: 'app/theme/components/worklist-ag-grid/worklist-ag-grid.html',
            bindings: {
                worklist: '<',
                autoUpdate: '<',
                masterData: '<',
                selectedData: '<',
                index: '<',
                viewMode: '<',
                onChange: '&'
            },
            controller: WorklistAGGridController
        });

    /** @ngInject */
    function WorklistAGGridController($q, $sessionStorage, $log, $scope, WorklistService) {
        var vm = this;

        var SortColumns = [];
        var SortingByMultiColumn = '';
        var OrderListFilter = {};
        var DefaultSortingColumn = 'O.OrderDate';
        var DefaultSortingDirection = 'desc';
        var OrderList = [];
        var autoRefreshing = false;
        var verticalScroll = 0;
        var ID = 0;

        $scope.PageNo = 1;
        $scope.orderList = [];
        $scope.TotalRows = 0;

        var gridOptions = {
            columnDefs: [
                { field: 'Location' },
                { field: 'Accession' },
                { field: 'FormattedOrderDate' },
                { field: 'PatientMRN' },
                { field: 'PatientName' },
                { field: 'FormattedPatientDOB' },
                { field: 'PatientGender' },
                { field: 'PatientAge' },
                { field: 'PatientClass' },
                { field: 'Modality' },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 100,
                resizable: true,
            },

            // use the server-side row model
            rowModelType: 'serverSide',

            // fetch 10 rows at a time (default is 100)
            cacheBlockSize: vm.worklist.PageSize,
            maxBlocksInCache: 3,
            getRowId: function (params) {
                return params.data.ID;
            },
            onGridReady: function (params) {
                $log.log("onGridReady > on: ", new Date());
                //var fakeServer = createFakeServer();
                // create datasource with a reference to the fake server
                
            },
            getRowNodeId: function (params) {
                return params.data.ID;
            },

        };

        vm.$onChanges = function (changes) {
            //$log.log('$onChanges > changes: ', changes);
        };
        vm.$onDestroy = function () {
            //$log.log('$onDestroy');

        }
        vm.$onInit = function () {
            $log.log('$onInit > on: ', new Date());

            var gridDiv = document.querySelector('#myGrid');
            new agGrid.Grid(gridDiv, gridOptions);

            var datasource = createServerSideDatasource();
            // register the datasource with the grid
            gridOptions.api.setServerSideDatasource(datasource);
            // scroll the grid down until row 5000 is at the top of the viewport
            //gridOptions.api.ensureIndexVisible(0, 'top');
            //setInterval(function () { autoRefreshing = true; gridOptions.api.refreshServerSide({ route: undefined, purge: false }); }, 100000);
            setInterval(function () { autoRefreshing = true; gridOptions.api.refreshServerSide(); }, 100000);
            gridOptions.api.addEventListener("bodyScroll", function (event) {
                $log.log('bodyScroll > on: ', new Date());
                var firstDisplayedRow = gridOptions.api.getFirstDisplayedRow();
                var lastDisplayedRow = gridOptions.api.getLastDisplayedRow();
                if (verticalScroll <= 0) {
                    $scope.PageNo = 1;
                } else if (verticalScroll < event.top) {
                    var page = _.toInteger(lastDisplayedRow / vm.worklist.PageSize) + 1;
                    $scope.PageNo = page;
                } else if (verticalScroll > event.top) {
                    
                    var page = _.toInteger(firstDisplayedRow / vm.worklist.PageSize) + 1;
                    $scope.PageNo = page > 1 ? page : 1;
                    //OrderList.splice(($scope.PageNo * vm.worklist.PageSize), vm.worklist.PageSize);
                    //gridOptions.api.refreshServerSide();
                }
                verticalScroll = event.top;
            });
            gridOptions.api.addEventListener("rowClicked", function (event) {
                $log.log('rowClicked > on: ', new Date());
                $log.log('rowClicked > event: ', event);
                
                
                var orderIndex = _.findIndex(OrderList, { 'Accession': event.data.Accession });
                if (orderIndex != -1) {
                    OrderList.splice(orderIndex, 1);
                    //gridOptions.api.refreshServerSide();
                }
                var transaction = { remove: [event.data] };
                gridOptions.api.applyServerSideTransaction(transaction);
            });
        }

        function getData() {
            $log.log("getData: " + new Date());
            var d = $q.defer();
            if (vm.worklist.loading) { return; }


            //sorting(vm.worklist.SortColumns);

            var receivedSinceCol = _.find(gridOptions.columnDefs, { 'name': 'ReceivedSince' });
            if (receivedSinceCol) {
                var visiblePendingSince = receivedSinceCol.visible;
                receivedSinceCol.visible = visiblePendingSince ? vm.selectedData.Status.key == 'RP' || vm.selectedData.Status.key == 'D' : visiblePendingSince;
                receivedSinceCol.enableHiding = vm.selectedData.Status.key == 'RP' || vm.selectedData.Status.key == 'D';
            }
            $q.all([
                refresh()
            ]).then(function (data) {
                //////$log.log("getData received: " + new Date());

                if ($scope.PageNo == 1) {
                    OrderList = [];
                }

                _.pullAllBy(OrderList, data[0], 'OrderID');
                OrderList = _.concat(OrderList, data[0]);
                OrderList = _.uniqBy(OrderList, 'OrderID');

                //sortByField();
                
                //$scope.orderList = OrderList;

                d.resolve(data[0]);

                //$timeout(function () { selectRow(); }, 100);
            }).catch(function (err) {
                d.reject(err);
            });

            return d.promise;
        }
        function sorting(sortColumns) {
            $log.log("sorting ", new Date());
            SortColumns = [];
            SortingByMultiColumn = '';
            if (sortColumns && sortColumns.length > 0) {
                _.each(gridOptions.columnDefs, function (sColumn, index) {


                    var columnDefIndex = _.findIndex(sortColumns, { 'field': sColumn.name });
                    if (columnDefIndex >= 0) {
                        gridOptions.columnDefs[index].sort = sortColumns[columnDefIndex].sort;
                        var SortColumn = {
                            field: sortColumns[columnDefIndex].field, sort: sortColumns[columnDefIndex].sort
                        };
                        SortColumns.push(SortColumn);

                        getSortingString(sortColumns[columnDefIndex].field, sortColumns[columnDefIndex].sort.direction);
                    } else {
                        gridOptions.columnDefs[index].sort = {};
                    }


                });
                SortingByMultiColumn = SortingByMultiColumn.substring(0, SortingByMultiColumn.lastIndexOf(','));
                vm.worklist.ColumnDefs = gridOptions.columnDefs;
                vm.worklist.SortColumns = SortColumns;
            } else {
                _.each(gridOptions.columnDefs, function (sColumn, index) {


                    if (sColumn.name == 'CreatedDate') {
                        gridOptions.columnDefs[index].sort = { direction: uiGridConstants.ASC, priority: 0 };

                        var SortColumn = {
                            field: gridOptions.columnDefs[index].name, sort: gridOptions.columnDefs[index].sort
                        };
                        SortColumns.push(SortColumn);

                        getSortingString(gridOptions.columnDefs[index].name, gridOptions.columnDefs[index].sort.direction);

                        SortingByMultiColumn = SortingByMultiColumn.substring(0, SortingByMultiColumn.lastIndexOf(','));

                    } else {
                        gridOptions.columnDefs[index].sort = {};
                    }


                });
                ////$log.log("sorting > SortColumns: ", SortColumns);
                vm.worklist.SortColumns = SortColumns;
                vm.worklist.ColumnDefs = gridOptions.columnDefs;
                ////$log.log("sorting > vm.worklist.SortColumns: ", vm.worklist.SortColumns);
                vm.onChange();

            }

        }
        function getSortingString(sColumnField, direction) {
            $log.log("getSortingString ", new Date());
            var orderByField = '';
            switch (sColumnField) {
                case "Location":
                    orderByField = "L.Location";
                    break;
                case "Accession":
                    orderByField = "O.Accession";
                    break;
                case "FormattedOrderDate":
                    orderByField = "O.OrderDate";
                    break;
                case "PatientMRN":
                    orderByField = "O.PatientMRN";
                    break;
                case "PatientName":
                    orderByField = "O.PatientLastName|O.PatientFirstName";
                    break;
                case "FormattedPatientDOB":
                    orderByField = "O.PatientDOB";
                    break;
                case "PatientGender":
                    orderByField = "O.PatientGender";
                    break;
                case "PatientAge":
                    orderByField = "O.PatientDOB";
                    break;
                case "PatientClass":
                    orderByField = "O.PatientClass";
                    break;
                case "Modality":
                    orderByField = "O.Modality";
                    break;
                case "ProcedureDesc":
                    orderByField = "O.ProcedureDesc";
                    break;
                case "OrderingPhysician":
                    orderByField = "P.Name";
                    break;
                case "CreatedDate":
                    orderByField = DefaultSortingColumn;
                    break;
            }

            if (orderByField.indexOf('|') > 0) {
                var fields = orderByField.split('|');
                _.each(fields, function (field) {
                    SortingByMultiColumn += field + ' ' + direction + ', ';
                });
            } else {
                SortingByMultiColumn += orderByField + ' ' + direction + ', ';
            }
        }
        function refresh() {
            $log.log("refresh > on: " + new Date());

            var d = $q.defer();

            setFilter();

            vm.worklist.loading = true;
            WorklistService.GetOrderDetails(OrderListFilter).then(function (result) {
                //////$log.log("refresh response: " + new Date());
                vm.worklist.loading = false;
                vm.worklist.ResultPendingCount = result.orderCount && result.orderCount.ResultPendingCount ? result.orderCount.ResultPendingCount : vm.worklist.ResultPendingCount;
                vm.worklist.STATCount = result.orderCount && result.orderCount.STATCount ? result.orderCount.STATCount : vm.worklist.STATCount;

                var TotalRows = $scope.TotalRows;
                //OrderList = result.Orders;
                if (result.orderLists && result.orderLists.length > 0) {
                    TotalRows = result.orderLists[0].TotalRows ? _.toInteger(result.orderLists[0].TotalRows) : 0;

                    //////////$log.log("refresh > orders length: ", $scope.orderList.length);


                }
                $scope.TotalRows = TotalRows;
                if ($scope.TotalRows == 0) {
                    vm.worklist.open = false;
                }


                updateOrders(result.orderLists)

                d.resolve(result.orderLists);


            }).catch(function (noCantDo) {
                vm.worklist.loading = false;
                d.reject(noCantDo);
            });

            return d.promise;
        };
        function setFilter() {
            $log.log("setFilter > on: " + new Date());

            if (vm.worklist.Type == 'D') {
                OrderListFilter = {
                    PageNum: $scope.PageNo,
                    PageSize: vm.worklist.PageSize,
                    OrderDateStartDate: moment().subtract(6, 'days').format("MM-DD-YYYY"),
                    OrderDateEndDate: moment().format("MM-DD-YYYY"),
                    Status: 'RP',
                    UserID: $sessionStorage.currentUserData.userId,
                    WorklistFlag: vm.worklist.RuleID,
                    STATFilter: vm.selectedData.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    FromSignDate: moment().format("MM-DD-YYYY"),
                    ToSignDate: moment().format("MM-DD-YYYY"),
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: 'All',
                };
            } else if (vm.worklist.Type == 'S') {
                OrderListFilter = {
                    PageNum: $scope.PageNo,
                    PageSize: vm.worklist.PageSize,
                    SiteID: vm.selectedData.Site ? vm.selectedData.Site.SiteID : null,
                    LocationID: _.join(_.map(vm.selectedData.Location, 'LocationID'), ','),
                    Accession: vm.selectedData.Accession,
                    ModalityID: _.join(_.map(vm.selectedData.Modality, 'Id'), ','),
                    OrderDateStartDate: (vm.selectedData.OrderDate.startDate) ? moment(new Date(vm.selectedData.OrderDate.startDate)).format("MM-DD-YYYY") : null,
                    OrderDateEndDate: (vm.selectedData.OrderDate.endDate) ? moment(new Date(vm.selectedData.OrderDate.endDate)).format("MM-DD-YYYY") : null,
                    PatientName: vm.selectedData.PatientName,
                    PatientMRN: vm.selectedData.PatientMRN,
                    PatientDOB: formatted_date(vm.selectedData.DOB),
                    PatientClass: vm.selectedData.PatientClass ? vm.selectedData.PatientClass.PatClass : '',
                    OrderingPhysician: vm.selectedData.OrderingPhysician,
                    Status: vm.selectedData.Status.key,
                    UserID: $sessionStorage.currentUserData.userId,
                    WorklistFlag: vm.selectedData.Worklist,
                    STATFilter: vm.selectedData.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    FromSignDate: moment().format("MM-DD-YYYY"),
                    ToSignDate: moment().format("MM-DD-YYYY"),
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: vm.selectedData.StudyPriority ? vm.selectedData.StudyPriority.Key : 'All',
                };
            } else if (vm.worklist.Type == 'A') {
                OrderListFilter = {
                    PageNum: $scope.PageNo,
                    PageSize: vm.worklist.PageSize,
                    Status: vm.selectedData.Status.key,
                    UserID: $sessionStorage.currentUserData.userId,
                    AdminWorklistIds: _.toString(vm.worklist.RuleID),
                    STATFilter: vm.selectedData.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    FromSignDate: moment().format("MM-DD-YYYY"),
                    ToSignDate: moment().format("MM-DD-YYYY"),
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: 'All',
                };
            }

        }
        function formatted_date(date) {
            $log.log("formatted_date > on: ", new Date());
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' == (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        function updateOrders(Orders) {
            //$log.log("updateOrders: " + new Date());

            _.each(Orders, function (order) {
                order.ID = new Date().getTime() + Math.random().toString(16).slice(2);
                //order.subGridOptions = subUIGridOptions;
                order.ComparisonOrder = [];

                //order.$$treeLevel = 1;

                updateOrderAssign(order);
                //order.row = row + 1;

                //row++;



            });

            return Orders;
        }
        function updateOrderAssign(order) {
            //$log.log("updateOrderAssign > on: " + new Date());
            var orderAssignmentIndex = _.findIndex(order.listOrderListAssignment, function (assignment) { return assignment.OrderAssingedUserID == $sessionStorage.currentUserData.userId; });

            order.OrderAssingedUserID = (order.listOrderListAssignment && order.listOrderListAssignment.length > 0 ? order.listOrderListAssignment[0].OrderAssingedUserID : null);
            //order.OrderAssingedUserName = $scope.getOrderListTooltip(order);
            order.OrderAssingedUsers = (order.listOrderListAssignment ? order.listOrderListAssignment.length : 0);

            order.OrderAssingedUser = (orderAssignmentIndex != -1 ? $sessionStorage.currentUserData.userId : null);
        }
        function sortByField() {
            $log.log("sortByField: " + new Date());


            var sortingFields = [];
            var sortingDirections = [];

            var Status = GetStatus();

            if (Status == "RP") {
                sortingFields = ['IsDeficient', function (e) { return e.IsStat || e.IsHighPriority; }, 'DelayedSTAT'];
                sortingDirections = ['desc', 'desc', 'desc'];
            }


            _.each(vm.worklist.SortColumns, function (sColumn, index) {
                switch (sColumn.field) {
                    case 'FormattedOrderDate':
                        sortingFields.push(function (e) { return e.OrderDate ? new Date(e.OrderDate).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    case 'FormattedPatientDOB':
                        sortingFields.push(function (e) { return e.PatientDOB ? new Date(e.PatientDOB).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    case 'CreatedDate':
                        sortingFields.push(function (e) { return e.CreatedDate ? new Date(e.CreatedDate).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    default:
                        sortingFields.push(sColumn.field);
                        break;
                }

                sortingDirections.push(sColumn.sort.direction);

                //if (sColumn.field != 'CreatedDate') {
                //    sortingFields.push('CreatedDate');
                //    sortingDirections.push('desc');
                //}
            });

            OrderList = _.orderBy(OrderList, sortingFields, sortingDirections);

            //////$log.log("sortByField sorted: " + new Date());

        }
        function GetStatus() {
            $log.log("GetStatus > on: " + new Date());
            //$log.log("GetStatus");
            var RuleConditionStatus;
            var Status = vm.selectedData.Status.key;
            //$log.log("GetStatus > Status: ", Status);
            if (vm.worklist.RulesConditions) {
                RuleConditionStatus = _.find(vm.worklist.RulesConditions, { ColumnName: 'ORDERS.ExamStatus' });
            }

            if (RuleConditionStatus && RuleConditionStatus.RuleTableValues && RuleConditionStatus.RuleTableValues.length > 0) {
                Status = vm.worklist.Type == 'D' ? OrderListFilter.Status : vm.worklist.Type == 'A' ? RuleConditionStatus.RuleTableValues[0].ID : vm.selectedData.Status.key;
            } else {
                Status = vm.worklist.Type == 'D' ? OrderListFilter.Status : vm.selectedData.Status.key;
            }
            return Status;
        }
        function createFakeServer() {
            return {
                getData: function(request) {

                    var promise = getData();
                    promise.then(function (response) {
                        // in this simplified fake server all rows are contained in an array
                        var requestedRows = OrderList.slice((($scope.PageNo-1) * vm.worklist.PageSize), ($scope.PageNo * vm.worklist.PageSize));
                        return {
                            success: true,
                            rows: requestedRows,
                        };
                    });
                    
                },
            };
        }
        function createServerSideDatasource() {
            $log.log("createServerSideDatasource > on: " + new Date());
            return {
                getRows: function (params) {
                    $log.log("createServerSideDatasource > getRows > on: " + new Date());
                    setTimeout(function () {
                        $log.log("createServerSideDatasource > getRows ", $scope.PageNo);
                        $log.log("createServerSideDatasource > getRows ", ($scope.PageNo * vm.worklist.PageSize));
                        $log.log("createServerSideDatasource > getRows ", OrderList.length);
                        $log.log("createServerSideDatasource > getRows ", ($scope.PageNo * vm.worklist.PageSize) > OrderList.length);
                        if (autoRefreshing
                            || ($scope.PageNo * vm.worklist.PageSize) > OrderList.length) {
                            var promise = getData();
                            if (promise) {
                                promise.then(function (response) {
                                    $log.log("createServerSideDatasource > getRows > getData > on: " + new Date());
                                    // in this simplified fake server all rows are contained in an array
                                    var requestedRows = OrderList.slice((($scope.PageNo - 1) * vm.worklist.PageSize), ($scope.PageNo * vm.worklist.PageSize));
                                    // supply rows for requested block to grid
                                    params.successCallback(requestedRows, $scope.TotalRows);
                                }, function (error) {
                                    $log.log("createServerSideDatasource > getRows > error > on: " + new Date());
                                    params.fail();
                                });
                                autoRefreshing = false;
                            }
                        } else {
                            var requestedRows = OrderList.slice((($scope.PageNo - 1) * vm.worklist.PageSize), ($scope.PageNo * vm.worklist.PageSize));
                            $log.log("createServerSideDatasource > getRows > requestedRows: ", requestedRows);
                            // supply rows for requested block to grid
                            params.successCallback(requestedRows, $scope.TotalRows);
                        }
                        
                    }, 500);
                    
                },
            };
        }

        function getLastRowIndex(request) {
            var currentLastRow = request.endRow;

            // if on or after the last block, work out the last row, otherwise return 'undefined'
            return currentLastRow < OrderList.length ? currentLastRow : OrderList.length;
        }
    }
}());
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('worklistfont', {
            templateUrl: 'app/theme/components/worklist-font/worklist-font.html',
            bindings: {
                isfontpropertyvisible: '<',
            },
            controller: worklistFontController
        });

    /** @ngInject */
    function worklistFontController($scope, $rootScope, $state, $sessionStorage, WorklistService, $q, UserPreferenceService) {

        var vm = this;
        var defaultSize;
        var WorklistUserPreference;
        var WorklistFontSize;
        var AddedPatientClassPriority = [];
        var PatientClassPriorityMasterData = [];
        $scope.show = false;
        $scope.fontSize = 12;
        $scope.SelectedData = { PatientClassPriority: null };
        $scope.SelectedCombination = [];
        $scope.ColorCode = "#ffe53d";
        vm.$onChanges = function (changes) {
        };

        vm.$onDestroy = function () {
        }
        vm.$onInit = function () {
            getUserPreference().then(function () {
                GetPatientClassPriorityLookupType().then(function () {
                    var worklistFontPref = _.find(WorklistUserPreference, { PreferenceType: "WorklistFontSize" })
                    if (worklistFontPref && worklistFontPref.PreferenceValue) {
                        $scope.fontSize = worklistFontPref.PreferenceValue;
                    }
                    defaultSize = $scope.fontSize;

                    var WorklistColorCode = _.find(WorklistUserPreference, { PreferenceType: 'WorklistColorCode' })
                    if (WorklistColorCode && WorklistColorCode.PreferenceValue) {
                        var worklistPref = JSON.parse(WorklistColorCode.PreferenceValue);
                        if (worklistPref && worklistPref.length > 0) {
                            _.each(worklistPref, function (colorCode) {
                                if (!colorCode.Deleted) {
                                    $scope.SelectedData.PatientClassPriority = _.find(PatientClassPriorityMasterData, { 'Key': colorCode.Key });
                                    $scope.ColorCode = colorCode.Value;
                                    $scope.AddCombination();
                                }
                            })
                        }
                    };

                });
            });
        }
        $scope.openFontProperty = function () {
            $scope.show = !$scope.show;

        }
        $scope.onInputRangeChange = function () {

            //if (newSize <= maxSize && newSize >= minSize) {
            $(".myGrid.stepmenupendingSub .ag-ltr .ag-cell").css("font-size", $scope.fontSize + "px");
            $rootScope.$broadcast('event.worklist', { EventType: 'FontSizeChanged', WorklistFontSize: $scope.fontSize });            
            //}
        };

        $scope.SaveOrCancelFontChanges = function (SaveFontPref) {
            if (!SaveFontPref) {
                $(".myGrid.stepmenupendingSub .ag-ltr .ag-cell").css("font-size", defaultSize + "px");
                $rootScope.$broadcast('event.worklist', { EventType: 'FontSizeChanged', WorklistFontSize: defaultSize});
            }
            else {
                var WorklistFontSize = null, WorklistColorCode = null;
                var idx = _.findIndex(WorklistUserPreference, { PreferenceType: 'WorklistFontSize' });
                if (idx == -1) {
                    WorklistFontSize = {
                        UserPreferenceID: "-1",
                        PreferenceType: "WorklistFontSize",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: $scope.fontSize,
                    };
                }
                else {
                    WorklistUserPreference[idx].PreferenceValue = $scope.fontSize;
                    WorklistFontSize = WorklistUserPreference[idx];
                }
                
                var idx = _.findIndex(WorklistUserPreference, { PreferenceType: 'WorklistColorCode' });
                if (idx == -1) {
                    WorklistColorCode = {
                        UserPreferenceID: "-1",
                        PreferenceType: "WorklistColorCode",
                        UserID: $sessionStorage.currentUserData.userId,
                        PreferenceValue: JSON.stringify($scope.SelectedCombination),
                    };
                }
                else {
                    WorklistUserPreference[idx].PreferenceValue = JSON.stringify($scope.SelectedCombination);
                    WorklistColorCode = WorklistUserPreference[idx];
                }
                UserPreferenceService.AddEditUserPreferences([WorklistFontSize, WorklistColorCode]).then(function (result) {
                    _.each($scope.SelectedCombination, function (obj) {
                        var className = ".row-type-" + obj.Key;
                        var colorValue = obj.Deleted ? "" : obj.Value;
                        $(className).css("color", colorValue);
                    });
                    $rootScope.$broadcast('event.worklist', { EventType: 'FontSizeChanged', WorklistColorCode: $scope.SelectedCombination });
                });
            }
            vm.isfontpropertyvisible.value = false;
        }

        $scope.AddCombination = function () {
            if ($scope.SelectedData && $scope.SelectedData.PatientClassPriority && $scope.ColorCode) {
                var idx = _.findIndex($scope.SelectedCombination, { Key: $scope.SelectedData.PatientClassPriority.Key })
                if (idx == -1) {
                    var obj = { Key: $scope.SelectedData.PatientClassPriority.Key, Value: $scope.ColorCode, Deleted: false };
                    $scope.SelectedCombination.push(obj);
                }
                else {
                    $scope.SelectedCombination[idx].Deleted = false;
                    $scope.SelectedCombination[idx].Value = $scope.ColorCode;
                }
                // AddedPatientClassPriority.push(_.find($scope.PatientClassPriority, { 'Key': $scope.SelectedData.PatientClassPriority.Key }));
                _.remove($scope.PatientClassPriority, { 'Key': $scope.SelectedData.PatientClassPriority.Key });
            }
            $scope.SelectedData.PatientClassPriority = null;
        };

        $scope.RemoveCombination = function (Obj) {
            var idx = _.findIndex(PatientClassPriorityMasterData, { 'Key': Obj.Key });
            if (idx != -1) {
                $scope.PatientClassPriority.push(PatientClassPriorityMasterData[idx]);
                $scope.PatientClassPriority = _.sortBy($scope.PatientClassPriority, 'ID');
                //_.remove($scope.SelectedCombination, { 'Key': Obj.Key });
                // _.remove(AddedPatientClassPriority, { 'Key': Obj.Key });

            }
            idx = _.findIndex($scope.SelectedCombination, { Key: Obj.Key })
            if (idx != -1) {
                $scope.SelectedCombination[idx].Deleted = true;
            }
        };

        $scope.GetPatientClassPriorityValue = function (Key) {
            var value = _.find(PatientClassPriorityMasterData, { 'Key': Key }).Value;
            if (value) {
                return value;
            }
        };
        function GetPatientClassPriorityLookupType() {
            var d = $q.defer();
            WorklistService.GetLookupByType("PatientClassPriority").then(function (result) {
                $scope.PatientClassPriority = result;
                PatientClassPriorityMasterData = _.clone(result);
                d.resolve();
            });
            return d.promise;
        };

        function getUserPreference() {
            var d = $q.defer()
            var userPreference = {
                UserID: $sessionStorage.currentUserData.userId,
                PreferenceType: 'WorklistFontSize,WorklistColorCode',
            };
            UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
                if (result != null && result.UserPreferences != null) {
                    WorklistUserPreference = result.UserPreferences;
                }
                d.resolve();
            });
            return d.promise;
        }

        $scope.sortPatientClassPriority = function (object) {
            return object && object.Value.split(' - ')[0];
        }
    }

}());

(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('worklistGrid', {
            templateUrl: 'app/theme/components/worklist-grid/worklist-grid.html',
            bindings: {
                worklist: '<',
                autoUpdate: '<',
                masterData: '<',
                selectedData: '<',
                index: '<',
                viewMode: '<',
                onChange: '&'
            },
            controller: WorklistGridController
        });

    /** @ngInject */
    function WorklistGridController($scope, $rootScope, $state, $interval, $sessionStorage, uiGridConstants, $log, $q, WorklistService, $timeout, $filter, $sce, NgTableParams, APP_CONSTANTS, gridUserPreferencesService, RCService,toastr,toaster, CommonService) {
        var vm = this;

        $scope.LoggedInUserID = $sessionStorage.currentUserData.userId;
        $scope.userRole = $sessionStorage.currentUserData.roles;
        function _hasPrelimRad(roles) {
            if (!roles) return false;
            return roles.split(',').some(function (r) { return r.trim().toLowerCase() === 'prelimrad'; });
        }
        function _isSelf(id) {
            var me = $sessionStorage.currentUserData && $sessionStorage.currentUserData.userId;
            return !!(me && id && id.toLowerCase() === me.toLowerCase());
        }
        function isVisibleRad(r) {
            if (!r) return false;
            if (_isSelf(r.Id || r.UserID)) return true;
            return !_hasPrelimRad(r.UserRoles || r.Roles);
        }
        vm.isVisibleRad = isVisibleRad;
        vm.radDisplay = function (r) {
            if (!r) return '';
            if (!_isSelf(r.Id || r.UserID) && _hasPrelimRad(r.UserRoles || r.Roles)) return '';
            return (r.LastName || '') + ', ' + (r.FirstName || '');
        };
        vm.disName = function (dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        };
        function _isPrelimRadAssignment(userId) {
            if (!userId || _isSelf(userId)) return false;
            var rad = _.find(vm.masterData.Radiologists, function (r) {
                return (r.Id || r.UserID || '').toLowerCase() === userId.toLowerCase();
            });
            return rad ? _hasPrelimRad(rad.UserRoles || rad.Roles) : false;
        }
        function _assignmentName(userId, name) {
            return _isPrelimRadAssignment(userId) ? '' : name;
        }
        function _discussionDisplayName(dis) {
            if (!dis) return '';
            if (_isSelf(dis.Record_Created_By)) return dis.Record_Created_By_Name;
            return _isPrelimRadAssignment(dis.Record_Created_By) ? '' : dis.Record_Created_By_Name;
        }
        $scope.popoverDicomOrderID = '';
        $scope.RowHeight = 26;
        $scope.orderList = [];
        $scope.selectedComparisonRow = {};
        $scope.popoverOpened1 = false;
        $scope.PageNo = 1;
        var ContactSearch = [];
        var halfScale = $(window).width() < 1199;
        $scope.SingReport = {};
        $scope.loc = { selectedItems: [] };
        var DictationReportStatus = '';
        var DictationReportState = '';
        $scope.LastOpenedOrder = null;
        var LastOpenedOrderID = null;
        $scope.htmlPopover = $sce.trustAsHtml('<div class="single4 v-a-m"></div>');
        $scope.ModalReportNDiscussionTabs = [
            {
                title: 'Report',
                templateUrl: 'modal_report_tab.html',
                disabled: false,
            },
            {
                title: 'Discussion',
                templateUrl: 'modal_discussion_tab.html',
                disabled: false,
            }
        ];
        $scope.ModalReportNDiscussActiveIndex = 0;
        $scope.TotalRows = 0;
        $scope.GridShow = false;
        var OrderListFilter = {};
        $scope.PendingSinceCurrentDate = new Date();
        var DictatedAccessionNumber = [];
        var OpenedAccessionNumber = '';
        $scope.HideOption = 'NotRead';
        $scope.SaveDiscussionFlag = false;

        $scope.winDiscussionWidth = "80%";
        $scope.defaultWindowHeight = "80%";
        $scope.winComparisonOrderReportsWidth = halfScale ? "96%" : "70%";
        //Share Exam popup Window width
        $scope.winShareExamWindowWidth = halfScale ? "80%" : "75%";
        $scope.winConsultExamWindowWidth = halfScale ? "80%" : "75%";

        $scope.win_ContactListWidth_new = "75%";
        $scope.win_ContactListHeight = halfScale ? "80%" : "80%";
        $scope.win_ContactListWidth = "65%";
        $scope.addEditContactWindowHeight = halfScale ? "55%" : "50%";
        $scope.win_SingReportWidth = "50%";
        //----
        $scope.win_PSUserWidth = "60%";
        //----
        $scope.win_HideStudyWidth = "30%";
        $scope.hideStudyWindowHeight = "35%";
        $scope.winComparisonOrderReportsWidth = halfScale ? "96%" : "70%";

        $scope.win_ModalReportNDiscussWidth = halfScale ? "96%" : "70%";


        var parser = new UAParser();
        var browser = parser.getBrowser().name;

        var orderGridApi = null;
        var comparisonOrderGridApi = null;
        var SortColumns = [];
        var OrderList = [];
        var positionChanged = false;
        var SortingByMultiColumn = '';
        var DefaultSortingColumn = 'O.ReceivedSinceDateTime';
        var DefaultSortingDirection = 'ASC';
        var refreshInterval;
        var DuplicateAccession = false;
        var ClipboardConditionData = { ClipboardData: [], SelectedRowsClipboard: [] };
        var ExpadingRow = false;

        var discussionCellTemplate = '<div class="ui-grid-cell-contents pt-0 pb-0">' +
            '<div class="icon-container w-100 float-left text-center pos-rel" ' +
            'style="line-height:2.4em !important" ' +
            //'ng-init="grid.appScope.hidePopover()" ' +
            'ng-mouseenter="grid.appScope.showPopover(row.entity.DicomOrderID, row.entity.IsDiscussion)" ' +
            'ng-click="grid.appScope.LoadOnlyDiscussion(row.entity.DicomOrderID, \'Discussion\')" data-toggle="modal" title="" ' +
            'data-target="#ModalDiscussion" >' +
            '<span class="glyphicon glyphicon-paperclip icon-paperclip cursor-pointer z-i-1 fs-14px pos-abs txt-clr-1" title="Discussion" ' +
            'style="top:2px; left:0; right:0" aria-hidden="true" ng-if="row.entity.FileCount > 0"></span>' +
            '<span class="fa fa-comments cursor-pointer fs-14px pt-5px" aria-hidden="true" title="Discussion" ' +
            'ng-show="row.entity.DicomOrderID" ng-class="row.entity.IsDiscussion ? \'green\' : \'gray\'" ' +
            'ng-if="row.entity.IsDiscussion && row.entity.DicomOrderID == grid.appScope.popoverDicomOrderID" ' +
            'uib-popover-html="grid.appScope.htmlPopover" popover-trigger="outsideClick" ' +
            'popover-placement="auto bottom" popover-is-open="grid.appScope.popoverOpened1" popover-class="popoverwl z-i-10004" ' +
            'popover-append-to-body="true"></span>' +
            '<span class="fa fa-comments cursor-pointer fs-14px pt-5px" aria-hidden="true" title="Discussion" ' +
            'ng-show="row.entity.DicomOrderID" ng-class="row.entity.IsDiscussion ? \'green\' : \'gray\'" ' +
            'ng-if="row.entity.IsDiscussion && row.entity.DicomOrderID != grid.appScope.popoverDicomOrderID" ></span>' +
            '<span class="fa fa-comment-o cursor-pointer fs-14px txt-clr-14 pt-5px" aria-hidden="true" title="Discussion" ' +
            'ng-show="row.entity.DicomOrderID" ng-class="row.entity.IsDiscussion ? \'green\' : \'gray\'" ' +
            'ng-if="!row.entity.IsDiscussion"></span></div >' +
            '</div>' +
            '';

        var col1CellTemplate = '<div class="ui-grid-cell-contents overflow-visible pt-5px">' +
            '<a ng-click="grid.appScope.GetOrdersComparisonList(row)" ' +
            'class="cursor-pointer px-0 tooltip-w-130px d-block text-center" ' +
            'ng-if="row.entity.HasComparison == \'1\' && row.entity.Status != \'X\'" >' +
            '<span class="fa fa-plus fs-15px txt-clr-14" title="Expand"' +
            'ng-if="!row.entity.isCollapsed"> ' +
            '</span> ' +
            '<span class="fa fa-minus fs-15px txt-clr-14" title="Collapse"' +
            'ng-if="row.entity.isCollapsed"> ' +
            '</span> ' +
            '</a> ' +
            '</div>' +
            '';

        var userLockIconCellTemplate = '<div class="ui-grid-cell-contents overflow-visible pt-5px text-center">' +
            '<div ng-switch on="grid.appScope.setUserIconCase(row)">' +
            '<div ng-switch-when="Lock">' +
            '<i class="fa fa fa-lock fs-15px txt-clr-14" title="{{grid.appScope.LoggedInUserID != ' + 'row.entity.LockByProviderID ? row.entity.LockBy : \'\'}}"> ' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="Assignment">' +
            '<span title="{{grid.appScope.getOrderListTooltip(row.entity)}}" class="fa fa-user fs-15px v-a-t d-block py-5px cursor-pointer pt-0 text-center" ' +
            'ng-style="{\'color\' : (row.entity.OrderAssingedUser && ' +
            'grid.appScope.LoggedInUserID == row.entity.OrderAssingedUser) ? \'green\' : \'grey\'}" ' +
            ' ></span>' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="AssignmentMyClipboard" class="d-flex">' +
            '<span title="{{grid.appScope.getOrderListTooltip(row.entity)}}" class="fa fa-user fs-15px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'ng-style="{\'color\' : (row.entity.OrderAssingedUser && ' +
            'grid.appScope.LoggedInUserID == row.entity.OrderAssingedUser) ? \'green\' : \'grey\'}" ' +
            ' ></span>' +
            '<span  class="glyphicon glyphicon-copy fs-9px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'style="color:green" ' +
            ' ></span>' +
            '</div>' +
            '<div ng-switch-when="AssignmentOtherClipboard" class="d-flex">' +
            '<span title="{{grid.appScope.getOrderListTooltip(row.entity)}}" class="fa fa-user fs-15px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'ng-style="{\'color\' : (row.entity.OrderAssingedUser && ' +
            'grid.appScope.LoggedInUserID == row.entity.OrderAssingedUser) ? \'green\' : \'grey\'}" ' +
            ' ></span>' +
            '<span  class="glyphicon glyphicon-copy fs-9px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'style="color:grey" ' +
            ' ></span>' +
            '</div>' +
            '<div ng-switch-when="CopiedtoOtherClipboard">' +
            '<span title="Copied to Other Clipboard" class="glyphicon glyphicon-copy fs-15px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'style="color:grey" ' +
            ' ></span>' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="CopiedtoMyClipboard">' +
            '<span title="Copied to My Clipboard" class="glyphicon glyphicon-copy fs-15px v-a-t d-block cursor-pointer pt-0 text-center" ' +
            'style="color:green" ' +
            ' ></span>' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="NA">' +
            '<i class="fa fa fa-times fs-20px" style="color: red;" > ' +
            '<span class="tultiptext">Study not available!</span> ' +
            '</i> ' +
            '</div>' +
            '<div ng-switch-when="empty">' +
            '<span ></span> ' +
            '</div>' +
            '</div>' +
            '</div>' +
            '';

        var orderddPhysianTemplate = '<div class="ui-grid-cell-contents">' +
            '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body="true" ng-if="row.entity.OrderingPhysicianPhone">' +
            '<a href id="simple-dropdown" uib-dropdown-toggle class="op-nohover" ng-style="{\'color\': row.entity.RowColorCode}">' +
            '{{row.entity.OrderingPhysician | UpperCase }}' +
            '</a>' +
            '<ul class="dropdown-menu opdrop-1 p-0 border-0 min-w-200px" uib-dropdown-menu aria-labelledby="simple-dropdown">' +
            '<li class="no-list-bullet">' +
            '<div class="bg-clr-30 p-5px-all fs-13px cursor-pointer text-center">' +
            '{{row.entity.OrderingPhysician | UpperCase }}' +
            '</div>' +
            '<div class="bg-clr-30 text-truncate py-10px px-5px fs-13px cursor-pointer text-center">' +
            'Contact: {{row.entity.OrderingPhysicianPhone | tel }}' +
            '</div>' +
            '</li>' +
            '</ul>' +
            '</span>' +
            '<span uib-dropdown on-toggle="toggled(open)" dropdown-append-to-body="true" ng-if="!row.entity.OrderingPhysicianPhone">' +
            '<a href id="simple-dropdown" uib-dropdown-toggle class="op-nohover" ng-style="{\'color\': row.entity.RowColorCode}">' +
            '{{row.entity.OrderingPhysician | UpperCase }}' +
            '</a>' +
            '<ul class="dropdown-menu opdrop-2 border-0 rounded-0 fw-500 fs-13px" uib-dropdown-menu aria-labelledby="simple-dropdown" >' +
            '<li ng-click="grid.appScope.showContact(row.entity.OrderingPhysician, row.entity.Location)" class="no-list-bullet">' +
            '<span tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ' +
            'uib-tooltip="Search By Address Book" class="txt-clr-1 cursor-pointer">Search Contact <i class="fa fa-search fs-18px"></i></span> ' +
            '</li>' +
            '</ul>' +
            '</span>' +
            '</div>' +
            '';

        var createdDateTemplate = '<div class="ui-grid-cell-contents py-0 d-flex align-item-center pos-rel rel-b-2-p">' +
            '<span>{{row.entity.CreatedDate | localDate:false}}</span>' +
            '</div>' +
            '';
        var pendingSinceTemplate = '<div class="ui-grid-cell-contents py-0 d-flex align-item-center pos-rel rel-b-2-p">' +
            '<span>{{row.entity.CreatedDate | localDate:true:grid.appScope.PendingSinceCurrentDate}}</span>' +
            '</div>' +
            '';
        var viewerddCellTemplate = '<div class="ui-grid-cell-contents overflow-visible text-center">' +
            '<div class="viewer-section">' +
            '<a href id="viewer-dropdown" >' +
            '<i class="fa fa-picture-o fs-14px txt-clr-14"></i> ' +
            '</a>' +
            '<div class="dropdown-content dropdown-menu-right">' +
            '<ul >' +
            '<li ng-repeat="DV in row.entity.OptionalDicomViewer.split(\',\') | orderBy" ' +
            'ng-click="grid.appScope.OpenSynapseStudy(row.entity, DV, false, true)" >   ' +
            '<a class="d-block txt-clr-17 text-center bb-1-s b-clr-17 fs-13px bor-rad-4px" ng-show="DV == \'AGFA\'">AGFA</a> ' +
            '<a class="d-block txt-clr-17 text-center bb-1-s b-clr-17 fs-13px bor-rad-4px" ng-show="DV == \'CANDELIS\'">CANDELIS</a> ' +
            '<a class="d-block txt-clr-17 text-center bb-1-s b-clr-17 fs-13px bor-rad-4px" ng-show="DV == \'KONICA\'">KONICA</a> ' +
            '<a class="d-block txt-clr-17 text-center bb-1-s b-clr-17 fs-13px bor-rad-4px" ng-show="DV == \'KONICATEST\'">KONICATEST</a> ' +
            '<a class="d-block txt-clr-17 text-center bb-1-s b-clr-17 fs-13px bor-rad-4px" ng-show="DV == \'SYNAPSE\'">SYNAPSE</a> ' +
            '<a class="d-block txt-clr-17 text-center bb-1-s b-clr-17 fs-13px bor-rad-4px" ng-show="DV == \'GECUV\'">GE Centricity</a> ' +
            '<a class="d-block txt-clr-17 text-center bb-1-s b-clr-17 fs-13px bor-rad-4px" ng-show="DV == \'CI-VIEWER\'">CI-VIEWER</a> ' +
            '<a class="d-block txt-clr-17 text-center bb-1-s b-clr-17 fs-13px bor-rad-4px" ng-show="DV == \'North Star Konica\'">North Star Konica</a> ' +
            '</li>' +
            '</ul>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '';

        var civrCellTemplate = '<div class="ui-grid-cell-contents text-center">' +
            '<div class="smw-3 overflow-visible" > ' +
            '<a ' +
            'class="cursor-pointer no-bg" title="Open CIVR" ng-click="grid.appScope.OpenVR(row.entity,true)">' +
            '<img style="top:-3px;" ' +
            'src="assets/img/civricon-16x16.png" class="w-14px pos-rel mr-1px"/> ' +
            '</a> ' +
            '</div> ' +
            '</div>' +
            '';

        var reportParentCellTemplate = '<div class="ui-grid-cell-contents pt-5px text-center">' +
            '<a ng-click="grid.appScope.ViewOrderReport(row.entity, row.entity.Accession)" ' +
            'class="cursor-pointer tultip-right no-bg" ' +
            'ng-if="row.entity.ReportStatus == 1 || row.entity.ReportStatus == 2"> ' +
            '<i class="fa fa-exclamation-triangle fs-14px" ng-if="row.entity.IsDeficient == true" ></i> ' +
            '<i class="fa fa-file-text-o fs-14px txt-clr-14" ng-if="row.entity.IsDeficient == false"></i> ' +
            //'<span class="tultiptext overflow-auto tt-white">View Report</span> ' +
            '</a> ' +
            '</div>' +
            '';

        var shareExamCellTemplate = '<div class="ui-grid-cell-contents text-center">' +
            '<div class="smw-3 overflow-visible" > ' +
            '<a ' +
            'class="cursor-pointer no-bg" title="Share Exam" ng-click="grid.appScope.openShareExamWindow()">' +
            '<i class="fa fa-share txt-clr-14" aria-hidden="true"></i> ' +
            '</a> ' +
            '</div> ' +
            '</div>' +
            '';

        var cellClass = 'py-2px px-5px';
        var textPadding = 'pt-4px px-5px';
        var civrcellclass = 'text-center pt-4px px-5px';
        var columnDefs = [
            { name: "Comparison", displayName: "", enableSorting: false, enableColumnMoving: false, enableHiding: false, width: 30, cellTemplate: col1CellTemplate, enableColumnResizing: false, },
            { name: "User", displayName: "", enableSorting: false, enableColumnMoving: false, enableHiding: false, width: 30, cellTemplate: userLockIconCellTemplate, enableColumnResizing: false, },
            { name: "Location", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "Accession", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            {
                name: "FormattedOrderDate", displayName: "DOS", type: "date", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, maxWidth: 120, width: "*"
            },
            { name: "PatientMRN", displayName: "MRN", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "PatientName", displayName: "Patient Name", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "FormattedPatientDOB", displayName: "DOB", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, maxWidth: 70, width: "*" },
            {
                name: "PatientGender", displayName: "Gender", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, maxWidth: 80, width: "*"
            },
            { name: "PatientAge", displayName: "Age", cellTooltip: true, width: 60, cellClass: textPadding, headerCellClass: cellClass, },
            { name: "PatientClass", displayName: "Type", cellTooltip: false, maxWidth: 70, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "Modality", cellTooltip: true, maxWidth: 90, cellClass: cellClass, headerCellClass: textPadding, width: "*" },
            { name: "ProcedureDesc", displayName: "Procedure", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "OrderingPhysician", displayName: "Ordering Physician", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, cellTemplate: orderddPhysianTemplate, width: "*" },
            { name: "CreatedDate", displayName: "Created Date", cellTooltip: false, cellClass: textPadding, headerCellClass: cellClass, cellTemplate: createdDateTemplate, width: "*" },
            { name: "ReceivedSince", displayName: "Pending Since", cellTooltip: false, cellClass: textPadding, headerCellClass: cellClass, cellTemplate: pendingSinceTemplate, width: "*", visible: (vm.selectedData.Status.key == 'RP' || vm.selectedData.Status.key == 'D'), enableHiding: (vm.selectedData.Status.key == 'RP' || vm.selectedData.Status.key == 'D'), enableSorting: false, },
            { name: "ImageInstance", displayName: "Images", enableColumnMoving: true, cellTooltip: true, maxWidth: 80, enableSorting: false, cellClass: textPadding, headerCellClass: 'cellClass arrowcursor py-2px pl-5px', width: "*" },
            { name: "Priority", displayName: "Priority", enableColumnMoving: true, cellTooltip: true, enableSorting: false, cellClass: textPadding, headerCellClass: 'cellClass arrowcursor py-2px pl-5px', width: "*" },
            { name: "WorkRVU", displayName: "RVU", enableColumnMoving: true, cellTooltip: true, maxWidth: 65, enableSorting: false, cellClass: textPadding, headerCellClass: 'cellClass arrowcursor py-2px pl-5px', width: "*" },
            { name: "Optional Image viewer", displayName: "", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, cellTemplate: viewerddCellTemplate, enableColumnResizing: false, headerCellClass: 'arrowcursor', cellClass: textPadding },
            { name: "Open CIVR", displayName: "", cellClass: civrcellclass, enableColumnMoving: true, enableSorting: false, enableHiding: true, width: 30, visible: browser.toUpperCase() != 'IE', cellTemplate: civrCellTemplate, cellTooltip: function (row, col) { return 'Open CIVR' }, enableColumnResizing: false, headerCellClass: 'arrowcursor', },
            { name: "View Report", displayName: "", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, cellTemplate: reportParentCellTemplate, enableColumnResizing: false, headerCellClass: 'arrowcursor' },
            { name: "Share Exam", displayName: "", cellClass: civrcellclass, enableColumnMoving: true, enableSorting: false, enableHiding: true, width: 30, cellTemplate: shareExamCellTemplate, cellTooltip: function (row, col) { return 'Share Exam' }, enableColumnResizing: false, headerCellClass: 'arrowcursor', },
            { name: "Discussion", displayName: "", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, cellTemplate: discussionCellTemplate, cellClass: "overflow-visible", enableColumnResizing: false, headerCellClass: 'arrowcursor', },
        ];

        var ViewModeColumnDefs = [
            { name: "Location", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "Accession", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            {
                name: "FormattedOrderDate", displayName: "DOS", type: "date", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, maxWidth: 120, width: "*"
            },
            { name: "PatientMRN", displayName: "MRN", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "PatientName", displayName: "Patient Name", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "FormattedPatientDOB", displayName: "DOB", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, maxWidth: 70, width: "*" },
            {
                name: "PatientGender", displayName: "Gender", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, maxWidth: 80, width: "*"
            },
            { name: "PatientAge", displayName: "Age", cellTooltip: true, width: 60, cellClass: textPadding, headerCellClass: cellClass, },
            { name: "PatientClass", displayName: "Type", cellTooltip: false, maxWidth: 70, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "Modality", cellTooltip: true, maxWidth: 90, cellClass: cellClass, headerCellClass: textPadding, width: "*" },
            { name: "ProcedureDesc", displayName: "Procedure", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "OrderingPhysician", displayName: "Ordering Physician", cellTooltip: true, cellClass: textPadding, headerCellClass: cellClass, width: "*" },
            { name: "CreatedDate", displayName: "Created Date", cellTooltip: false, cellClass: textPadding, headerCellClass: cellClass, cellTemplate: createdDateTemplate, width: "*" },
            { name: "ReceivedSince", displayName: "Pending Since", cellTooltip: false, cellClass: textPadding, headerCellClass: cellClass, cellTemplate: pendingSinceTemplate, width: "*", visible: (vm.selectedData.Status.key == 'RP' || vm.selectedData.Status.key == 'D'), enableHiding: (vm.selectedData.Status.key == 'RP' || vm.selectedData.Status.key == 'D'), enableSorting: false, },
            { name: "ImageInstance", displayName: "Images", enableColumnMoving: true, cellTooltip: true, maxWidth: 80, enableSorting: false, cellClass: textPadding, headerCellClass: 'cellClass arrowcursor py-2px pl-5px', width: "*" },
            { name: "Priority", displayName: "Priority", enableColumnMoving: true, cellTooltip: true, enableSorting: false, cellClass: textPadding, headerCellClass: 'cellClass arrowcursor py-2px pl-5px', width: "*" },
            { name: "WorkRVU", displayName: "RVU", enableColumnMoving: true, cellTooltip: true, maxWidth: 65, enableSorting: false, cellClass: textPadding, headerCellClass: 'cellClass arrowcursor py-2px pl-5px', width: "*" },
        ];

        var rowTemplate = '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
            'ng-if="grid.appScope.NoContextMenuOptions(row.entity)"' +
            'ui-grid-cell context-menu="grid.appScope.openContextMenuOptions(row.entity)" ' +
            'ng-dblclick="grid.appScope.OpenSignReport(row.entity, grid.appScope.orderList)"' +
            'ng-click="grid.appScope.setSelected(row.entity.OrderID, row.entity); grid.appScope.clearSelectedChildRows();"' +
            'ng-style="{\'color\': row.entity.RowColorCode}" ' +
            'class="ui-grid-cell px-5px"  ui-grid-cell tooltip-class="uibtooltipDenial" tooltip-placement="auto top-left" uib-tooltip="{{((row.entity.Status == \'D\' && row.entity.SignByName.length > 0) ? ' + '\'Drafted by \' + row.entity.SignByName  : (row.entity.Status == \'C\' && row.entity.SignByName.length > 0) ' + '? \'Signed by \' + row.entity.SignByName : \'\')}}" ' +
            ' > ' +
            '</div>' +
            '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
            'ng-if="!grid.appScope.NoContextMenuOptions(row.entity)"' +
            'ui-grid-cell ' +
            'ng-dblclick="grid.appScope.OpenSignReport(row.entity, grid.appScope.orderList)"' +
            'ng-click="grid.appScope.setSelected(row.entity.OrderID, row.entity); grid.appScope.clearSelectedChildRows();"' +
            'ng-style="{\'color\': row.entity.RowColorCode}" ' +
            'class="ui-grid-cell px-5px"  ui-grid-cell tooltip-class="uibtooltipDenial" tooltip-placement="auto top-left" uib-tooltip="{{((row.entity.Status == \'D\' && row.entity.SignByName.length > 0) ? ' + '\'Drafted by \' + row.entity.SignByName  : (row.entity.Status == \'C\' && row.entity.SignByName.length > 0) ' + '? \'Signed by \' + row.entity.SignByName : \'\')}}" ' +
            ' > ' +
            '</div>';
        var ViewRowTemplate = '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" ' +
            'ng-style="{\'color\': row.entity.RowColorCode}" ' + 'class="ui-grid-cell"  ui-grid-cell  ' + ' > ' + '</div>';


        var expandableRowTemplate = '<div class="anuichildsection" ui-grid="row.entity.subGridOptions" style="width:100%; " ' +
            'ng-style="{height: (((row.entity.ComparisonOrder.length * grid.appScope.RowHeight) + 1) + \'px\')}"' +
            'ng-if="(grid.appScope.VisibleComparisonHover(row.entity) && (grid.appScope.userRole == \'SuperAdmin\' || grid.appScope.userRole == \'Admin\'))" ' +
            'context-menu="grid.appScope.expandedOpenContextMenuOptions(row)" ' +
            'ng-click="grid.appScope.setSelectedComparison()" ' +
            'tooltip-class="uibtooltipDenial tt-black" tooltip-placement="auto top-left" tooltip-append-to-body="true" ' +
            'uib-tooltip="{{((row.entity.Status == \'D\' && row.entity.SignByName.length > 0) ? ' +
            '\'Drafted by \' + row.entity.SignByName  : (row.entity.Status == \'C\' && row.entity.SignByName.length > 0) ' +
            '? \'Signed by \' + row.entity.SignByName : \'\')}}" ui-grid-move-columns ui-grid-auto-resize ui-grid-pinning ui-grid-selection>' +
            '</div>' +
            '<div class="anuichildsection" ui-grid="row.entity.subGridOptions" style="width:100%; " ' +
            'ng-style="{height: (((row.entity.ComparisonOrder.length * grid.appScope.RowHeight) + 1) + \'px\')}"' +
            'ng-if="!(grid.appScope.VisibleComparisonHover(row.entity) && (grid.appScope.userRole == \'SuperAdmin\' || grid.appScope.userRole == \'Admin\'))" ' +
            'ng-click="grid.appScope.setSelectedComparison()" ' +
            'tooltip-class="uibtooltipDenial tt-black" tooltip-placement="auto top-left" tooltip-append-to-body="true" ' +
            'uib-tooltip="{{((row.entity.Status == \'D\' && row.entity.SignByName.length > 0) ? ' +
            '\'Drafted by \' + row.entity.SignByName  : (row.entity.Status == \'C\' && row.entity.SignByName.length > 0) ' +
            '? \'Signed by \' + row.entity.SignByName : \'\')}}" ui-grid-move-columns ui-grid-auto-resize ui-grid-pinning ui-grid-selection ui-grid-resize-columns>' +

            '</div>' +
            '';

        $scope.uiGridOptions = {
            columnDefs: _.clone(columnDefs),
            appScopeProvider: $scope,
            enableColumnResizing: true,
            enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
            excessRows: 100,
            excessColumns: 50,
            virtualizationThreshold: 200,
            columnVirtualizationThreshold: 100,
            showExpandAllButton: false,
            enableOnDblClickExpand: false,
            enableExpandableRowHeader: false,
            expandableRowTemplate: expandableRowTemplate,
            //expandableRowHeight: 150,
            //subGridVariable will be available in subGrid scope
            //expandableRowScope: $scope.scopeVariable,
            expandableRowScope: {
                subGridVariable: 'subGridScopeVariable',
            },
            gridMenuCustomItems: [
                {
                    title: 'Reset',
                    action: function ($event) {
                        //////$log.log("reset");

                        var cols = onReset();
                        var colDefs = [];
                        _.each(cols, function (col) {
                            colDefs.push(col.colDef);
                        });
                        //$scope.uiGridOptions.columnDefs = _.clone(colDefs);
                        vm.worklist.ColumnDefs = _.clone(colDefs);
                        vm.onChange();

                    },
                }
            ],
            enableFullRowSelection: true,
            enableRowHeaderSelection: false, //hide check mark
            enableRowSelection: true,
            enableSelectAll: true,
            enableSelectionBatchEvent: true,
            modifierKeysToMultiSelect: true,
            multiSelect: true,
            noUnselect: true,
            useExternalSorting: true,
            //suppressMultiSort: true,
            //showGridFooter: true,
            infiniteScrollRowsFromEnd: 5,
            infiniteScrollUp: true,
            infiniteScrollDown: true,
            enableColumnMenus: false,
            enableGridMenu: true,
            enableColumnMoving: true,
            rowHeight: $scope.RowHeight, //set row height
            enableHorizontalScrollbar: 2, //hide scroll dot
            rowTemplate: rowTemplate,
            //gridFooterTemplate: '<div class="ui-grid-bottom-panel text-right bg-clr-31 txt-clr-1 fw-500 px-8px showingftxt w-100 h-35px f-f-quicksand footerfix">Showing {{grid.appScope.orderList.length}} of {{grid.appScope.TotalRows}} Total Records</div>',
            data: 'orderList',
            onRegisterApi: function (gridApi) {
                $log.log("onRegisterApi");

                gridApi.infiniteScroll.on.needLoadMoreData($scope, getDataDown);
                gridApi.infiniteScroll.on.needLoadMoreDataTop($scope, getDataUp);

                gridApi.selection.on.rowSelectionChanged($scope, doSelection);
                gridApi.selection.on.rowSelectionChangedBatch($scope, rowsSelectionInBatch);

                gridApi.colMovable.on.columnPositionChanged($scope, columnPositionChanged);

                gridApi.core.on.columnVisibilityChanged($scope, columnVisibilityChanged);
                gridApi.core.on.sortChanged($scope, onSortChanged);

                gridApi.expandable.on.rowExpandedStateChanged($scope, function (row) {
                    row.expandedRowHeight = (row.entity.ComparisonOrder.length * $scope.RowHeight) + 1;
                    $scope.selectedComparisonRow = row;
                    subUIGridOptions.excessRows = row.entity.ComparisonOrder.length;

                    $timeout(function () {
                        updateComparisonColumns();
                    }, 1000);
                });

                gridApi.core.on.rowsRendered($scope, function () {



                });

                gridApi.colResizable.on.columnSizeChanged($scope, onColumnResize);

                angular.element('.fltr-mdl-worklit').parent().addClass('fltr-mdl-worklit-wrapper');


                orderGridApi = gridApi;
            }
        };
        var eCellClass = 'py-2px px-5px txt-clr-32 ordphy-cell-clr';
        var expandableColumnDefs = [
            { name: "Comparison", enableSorting: false, enableColumnMoving: false, enableHiding: false, width: 30, enableColumnResizing: false, },
            { name: "User", enableSorting: false, enableColumnMoving: false, enableHiding: false, width: 30, enableColumnResizing: false, },
            { name: "Location", cellTooltip: true, cellClass: eCellClass, width: "*" },
            { name: "Accession", cellTooltip: true, cellClass: eCellClass, width: "*" },
            {
                name: "FormattedOrderDate", type: "date", cellTooltip: true, cellClass: eCellClass, maxWidth: 120, width: "*"
            },
            { name: "PatientMRN", cellTooltip: true, cellClass: eCellClass, width: "*" },
            { name: "PatientName", cellTooltip: true, cellClass: eCellClass, width: "*" },
            { name: "FormattedPatientDOB", cellTooltip: true, cellClass: eCellClass, maxWidth: 70, width: "*" },
            {
                name: "PatientGender", cellTooltip: true, cellClass: eCellClass, maxWidth: 80, width: "*"
            },
            { name: "PatientAge", cellTooltip: true, width: 60, cellClass: eCellClass, },
            { name: "PatientClass", cellTooltip: false, maxWidth: 70, cellClass: eCellClass, width: "*" },
            { name: "Modality", cellTooltip: true, maxWidth: 90, cellClass: eCellClass, width: "*" },
            { name: "ProcedureDesc", cellTooltip: true, cellClass: eCellClass, width: "*" },
            { name: "OrderingPhysician", cellTooltip: true, cellClass: eCellClass, cellTemplate: orderddPhysianTemplate, width: "*" },
            { name: "CreatedDate", cellTooltip: false, cellClass: eCellClass, cellTemplate: createdDateTemplate, width: "*" },
            { name: "ReceivedSince", cellTooltip: false, cellClass: eCellClass, width: "*", visible: (vm.selectedData.Status.key == 'RP' || vm.selectedData.Status.key == 'D') },
            { name: "ImageInstance", enableColumnMoving: true, cellTooltip: true, maxWidth: 80, enableSorting: false, cellClass: eCellClass, width: "*" },
            { name: "Priority", displayName: "Priority", enableColumnMoving: true, cellTooltip: true, enableSorting: false, cellClass: eCellClass, width: "*" },
            { name: "WorkRVU", enableColumnMoving: true, cellTooltip: true, maxWidth: 65, enableSorting: false, cellClass: eCellClass, width: "*" },
            { name: "Optional Image viewer", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, enableColumnResizing: false, },
            { name: "Open CIVR", cellClass: 'text-center', enableColumnMoving: true, enableSorting: false, enableHiding: true, width: 30, visible: browser.toUpperCase() != 'IE', enableColumnResizing: false, },
            { name: "View Report", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, cellTemplate: reportParentCellTemplate, enableColumnResizing: false, },
            { name: "Share Exam", cellClass: 'text-center', enableColumnMoving: true, enableSorting: false, enableHiding: true, width: 30, enableColumnResizing: false, },
            { name: "Discussion", enableSorting: false, enableColumnMoving: true, enableHiding: true, width: 32, enableColumnResizing: false, },
        ];

        var subUIGridOptions = {
            appScopeProvider: $scope,
            enableColumnResizing: true,
            enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
            noUnselect: true,
            multiSelect: false,
            enableRowHeaderSelection: false, //hide check mark
            enableRowSelection: true,
            //noUnselect: true,
            enableFullRowSelection: true,
            showHeader: false,
            enableColumnMenus: false,
            enableColumnMoving: true,
            columnDefs: expandableColumnDefs,
            data: [],
            //disableRowExpandable: order.HasComparison != '1',
            rowHeight: $scope.RowHeight,
            //expandableRowScope: $scope.scopeVariable,
            //externalScope: $scope.scopeVariable,
            onRegisterApi: function (gridApi) {

                comparisonOrderGridApi = gridApi;

            },
        };

        $scope.$on('event.worklist', function (evt, data) {
            //$log.log('event.worklist > on: ', new Date());
            //$log.log('event.worklist > data: ', data);
            switch (data.EventType) {
                case 'SignReport':
                    //$log.log('event.worklist > SignReport: ', data);
                    if (data.RuleID == vm.worklist.RuleID) {
                        SignReport(data.navFlag, data.MessageResponse);
                    }
                    break;
                case 'OpenDiscussionOrder':
                    $scope.OrderDiscussion = data.OD;
                    _OpenDiscussionOrder();
                    break;
                case 'ReLoadDiscussion':
                    ReloadDiscussion(data.OD);
                    break;
                case 'UnAssignStudy':
                    UnAssignStudy(data.OD);
                    break;
                case 'resizePanel':
                    ResizePanel(data.resizeData);
                    break;
                case 'NotifyOrderListUpdateReportFromRadFLow':
                    if ($scope.NativeMessageResponseReportStatus != -1) {
                        removeOrderFromList(data.OrderID);
                        $scope.NativeMessageResponseReportStatus = -2;
                    }
                    break;
                case 'OrderDiscussionHandler':
                    OrderDiscussionHandler(data);
                    break;
                case 'OrdersListAttachmentUpdateHandler':
                    var objOrderList = _.filter($scope.orderList, function (obj) { return obj.DicomOrderID == data.DiacomOrderId; });
                    if (objOrderList && objOrderList.length > 0) {
                        objOrderList[0].FileCount = data.count;
                        if (data.count > 0) {
                            objOrderList[0].IsDiscussion = true;
                        }
                        $scope.orderList = $scope.orderList.slice();
                    }
                    break;
                case 'NotifyOpenOrder':
                    NotifyOpenOrder(data);
                    break;
                case 'NotifyShowHideOrder':
                    NotifyShowHideOrder(data);
                    break;
                case 'NotifyOrderListSaveReport':
                    var Status = GetStatus();
                    if (Status != 'AL') {
                        removeOrderFromList(data.OrderID);
                    }

                    break;
                case 'ProcessedOrdersUpdate':
                    ProcessedOrdersUpdate(data.ProcessedOrder);
                    break;
                case 'NotifyORUUpdate':
                    removeOrderAccession(data.Accession);
                    break;
                case 'NotifyAssignStudy':
                    NotifyAssignStudy(data);
                    break;
                case 'Dictation':
                    if (data.RuleID == vm.worklist.RuleID) {
                        Dictation(data);
                    }
                    break;
                case 'Reload':
                    if (data.ClipboardConditionData) {
                        ClipboradIconCase(data);
                    }
                    Reload(data);
                    break;
                case 'Deselect':
                    if (data.ID != vm.index) {
                        $scope.SelectedOrderID = null;
                        $scope.SelectedOrder = null;
                        $scope.SelectedComPatisomOrderID = "";
                        orderGridApi.selection.clearSelectedRows();
                        ClipboardConditionData = { ClipboardData: [], SelectedRowsClipboard: [] };
                    }
                    break;
                case 'RemoveOpenOrder':
                    if (data.ID != vm.index && LastOpenedOrderID != null) {
                        removeOrderFromList(LastOpenedOrderID);
                        DeleteOpenOrder();
                    }
                    break;
                case 'deleteFile':
                    if ($scope.SelectedOrder) {
                        $scope.SelectedOrder.FileCount = data.FileCount;
                        if ($scope.SelectedOrder.FileCount == 0) {
                            $scope.showAttachment = false;
                        }
                    }
                    
                    break;
                case 'ClearClipboard':
                    //$log.log("ClearClipboard > on: ", new Date());
                    if (data.ClipboardConditionData.ActionType == "Reset") {
                        $scope.TotalRows = 0;
                        ResetClipboard();
                    }
                    $scope.SelectedOrderID = null;
                    $scope.SelectedOrder = null;
                    vm.selectedData.SelectedOrder = null;
                    ClipboardConditionData = { ClipboardData: [], SelectedRowsClipboard: [] };
                    orderGridApi.selection.clearSelectedRows();
                    if (vm.worklist.WorklistType == 16) {
                        $scope.PageNo = 1;
                        getData();
                    }
                    
                    break;
            }

        });

        vm.$onChanges = function (changes) {
            //$log.log('$onChanges > changes: ', changes);
            if (vm.viewMode) {
                $scope.uiGridOptions.enableGridMenu = false;
                $scope.uiGridOptions.rowTemplate = ViewRowTemplate;
                $scope.uiGridOptions.columnDefs = ViewModeColumnDefs;
                $scope.uiGridOptions.showGridFooter = true;
                $scope.uiGridOptions.gridFooterTemplate = '<div class="ui-grid-bottom-panel text-right bg-clr-31 txt-clr-1 fw-500 px-8px showingftxt w-100 h-35px f-f-quicksand footerfix">Showing {{grid.appScope.orderList.length}} of {{grid.appScope.TotalRows}} Total Records</div>';
                getData();

            }
        };
        vm.$onDestroy = function () {
            //$log.log('$onDestroy');
            $scope.GridShow = false;
            stopRefreshInterval();
            if (LastOpenedOrderID != null) {
                $rootScope.$broadcast('event.CloseReport', { 'Order': $scope.LastOpenedOrder });
                removeOrderFromList(LastOpenedOrderID);
                DeleteOpenOrder();
            }

        }
        vm.$onInit = function () {
            $log.log('$onInit');
            $scope.GridShow = true;           
            $scope.uiGridOptions.columnDefs = vm.worklist.ColumnDefs ? _.clone(vm.worklist.ColumnDefs) : _.clone(columnDefs);

            $log.log('$onInit > vm.worklist: ', vm.worklist);
            if (vm.worklist.RuleID == -1
                || (vm.worklist.WorklistType == 16 && !vm.worklist.open)
                || vm.worklist.WorklistType == 21
                || vm.worklist.IsGlobal
                || vm.viewMode) {
                if (vm.viewMode) {
                    $scope.uiGridOptions.enableGridMenu = false;
                    $scope.uiGridOptions.rowTemplate = ViewRowTemplate;
                    $scope.uiGridOptions.columnDefs = _.clone(ViewModeColumnDefs);

                }
                $scope.uiGridOptions.showGridFooter = true;
                $scope.uiGridOptions.gridFooterTemplate = '<div class="ui-grid-bottom-panel text-right bg-clr-31 txt-clr-1 fw-500 px-8px showingftxt w-100 h-35px f-f-quicksand footerfix">Showing {{grid.appScope.orderList.length}} of {{grid.appScope.TotalRows}} Total Records</div>';
                getData();
            } else {
                startRefreshInterval();
            }


        }

        $scope.showPopover = function (dicomOrderID, IsDiscussion) {
            ////$log.log("showPopover");
            $scope.popoverOpened1 = true;
            $scope.popoverDicomOrderID = dicomOrderID;
            if (IsDiscussion) {
                $scope.Discussion = {
                    ReferenceID: dicomOrderID,
                    Type: 1,
                    Comment: '',
                    Record_Created_By: $scope.LoggedInUserID
                };
                $scope.Discussions = [];
                $q.all([
                    LoadPopOverDiscussion($scope.Discussion)
                ]).then(function (data) {
                    if ($scope.Discussions) {
                        var htmlpop = '<div class="popchatui dropdown-content dropdown-menu-right">';
                        _.each($scope.Discussions, function (discussion) {
                            // htmlpop = htmlpop + '<div>' + discussion.Comment + '</div>';
                            htmlpop = htmlpop + '<div>';
                            var displayName = _discussionDisplayName(discussion);
                            if (discussion.Record_Created_By &&
                                discussion.Record_Created_By == $scope.LoggedInUserID) {
                                htmlpop = htmlpop + '<div class="sendersection">' +
                                    '<div class="sendercomment pos-rel senderborder">' +
                                    (displayName ? '<div class="sendername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline">' + discussion.Comment + '</div>' +
                                    '<div class="senderdate text-preline">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, true);
                                htmlpop = htmlpop + '</div></div>';
                            } else {
                                htmlpop = htmlpop + '<div class="receiversection">' +
                                    '<div class="receivercomment pos-rel receiverborder">' +
                                    (displayName ? '<div class="receivername">' + displayName + '</div>' : '') +
                                    '<div class="text-preline">' + discussion.Comment + '</div>' +
                                    '<div class="receiverdate">' + $filter('localDate')(discussion.Record_Created_At, false) + '</div>';
                                htmlpop = htmlpop + prepareChildDiscussionHTML(discussion, false);
                                htmlpop = htmlpop + '</div></div>';
                            }

                            htmlpop = htmlpop + '</div>';
                            //$log.log(htmlpop);
                        });
                        htmlpop = htmlpop + '</div>';
                        $scope.htmlPopover = $sce.trustAsHtml(DOMPurify.sanitize(htmlpop));
                    }
                });
            }

        }

        $scope.LoadOnlyDiscussion = function (referenceID, ODType) {
            ////$log.log("LoadOnlyDiscussion");
            $scope.showDiscuss = false;
            $scope.LoadDiscussion(referenceID, ODType);
        };

        $scope.LoadDiscussion = function (referenceID, ODType) {
            //$log.log("LoadDiscussion");
            hidePopover();
            $scope.showAttachment = false;
            $scope.ODType = ODType;
            $scope.Discussion = {
                ReferenceID: referenceID,
                Type: 1,
                Comment: '',
                Record_Created_By: $scope.LoggedInUserID
            };
            $scope.Discussions = [];
            LoadDiscussion($scope.Discussion);
            if ($scope.showDiscuss) {
                if (($scope.reportList && $scope.reportList.length > 0) || ($scope.Discussions && $scope.Discussions.length > 0)) {
                    $scope.currentWindow = 'win_ModalReportNDiscuss';
                    $scope.win_ModalReportNDiscuss.open();
                    $scope.win_ModalReportNDiscuss.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    $timeout(function () {
                        $scope.win_ModalReportNDiscuss.center();
                    }, 100);
                }
            }
            else {
                $scope.currentWindow = 'win_Discussion';
                $scope.win_Discussion.open();
                $scope.win_Discussion.wrapper.prev(".k-overlay").addClass("custom-overlay");
                $timeout(function () {
                    $scope.win_Discussion.center();
                }, 100);

            }

            if ($scope.isReportAvailable) {
                //selectPriorReportTab("#tabReport");
                $scope.ModalReportNDiscussActiveIndex = 0;
            }
            else if ($scope.OrderReport && $scope.OrderReport.FileCount > 0) {
                //selectPriorReportTab("#tabDiscussion");
                $scope.ModalReportNDiscussActiveIndex = 1;
                $scope.ReferenceID = null;
                $scope.showAttachment = true;
                $scope.ReferenceID = $scope.Discussion.ReferenceID;
            }
            else {
                //selectPriorReportTab("#tabDiscussion");
                $scope.ModalReportNDiscussActiveIndex = 1;

            }
        };

        $scope.GetOrdersComparisonList = function (row) {
            ////$log.log("GetOrdersComparisonList");
            ExpadingRow = true;
            var d = $q.defer();
            if (!row.isExpanded) {

                vm.worklist.loading = true;
                $scope.orderComparisonListFilter = {
                    UserID: $scope.LoggedInUserID,
                    OrderID: row.entity.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    vm.worklist.loading = false;
                    if (result && result.length > 0) {
                        _.each(result, function (obj) {
                            obj.scopeVariable = $scope.scopeVariable;

                        });
                        row.entity.ComparisonOrder = angular.copy(result);
                        row.entity.subGridOptions = subUIGridOptions;
                        row.entity.subGridOptions.data = result;

                        var rowentity = orderGridApi.expandable.getExpandedRows();
                        if (rowentity && rowentity.length > 0) {
                            rowentity[0].isCollapsed = !rowentity[0].isCollapsed;
                        }
                        orderGridApi.expandable.collapseAllRows();

                        orderGridApi.expandable.expandRow(row.entity);
                        row.entity.isCollapsed = !row.entity.isCollapsed;
                    } else {
                        var idx = _.findIndex(OrderList, { 'OrderID': row.entity.OrderID });
                        if (idx != -1) {
                            OrderList[idx].HasComparison = "0";
                            $scope.orderList = OrderList;
                        }
                    }
                    d.resolve(result);
                    
                }).catch(function (noCantDo) {
                    vm.worklist.loading = false;
                });
            } else {
                orderGridApi.expandable.collapseRow(row.entity);
                row.entity.isCollapsed = !row.entity.isCollapsed;
                d.resolve([]);
            }

            return d.promise;
        };

        $scope.setUserIconCase = function (row) {
            ////$log.log("setUserIconCase");
            var iconCase = '';
            if (row.entity.IsLock && ($scope.LoggedInUserID != row.entity.LockByProviderID)) {
                iconCase = 'Lock';
            } else if (row.entity.OrderAssingedUsers > 0) {
                iconCase = 'Assignment';
                if (row.entity.IsInClipboard == 2) {
                    iconCase = 'AssignmentMyClipboard';
                } else if (row.entity.IsInClipboard == 1) {
                    iconCase = 'AssignmentOtherClipboard';
                }
            }
            else if (row.entity.IsInClipboard == 1) {
                iconCase = 'CopiedtoOtherClipboard';

            } else if (row.entity.IsInClipboard == 2) {
                iconCase = 'CopiedtoMyClipboard';
            }
            else if (row.entity.ProcessError) {
                iconCase = 'NA';
            }
            else {
                iconCase = 'empty';
            }
            return iconCase;
        }

        $scope.getOrderListTooltip = function (Order) {
            ////$log.log("getOrderListTooltip");
            var orderDiscussionTooltip = '';
            var group = 0;
            var groupName = '';
            var user = 0;
            var userName = '';
            var allSpecialityArr = _.map(Order.listOrderListAssignment, function (row) {
                return row.ProviderSpecialityId;
            });
            var uniqueSpeciality = _.filter(allSpecialityArr, function (item, index, arry) { return (arry.indexOf(item) === index) });

            _.each(uniqueSpeciality, function (obj) {
                if (obj > 0) {
                    var findSelectedSpeciality = _.filter(Order.listOrderListAssignment, function (sUser) { return sUser.ProviderSpecialityId == obj });
                    var findAllSpeciality = _.filter(vm.masterData.Radiologists, function (aUser) { return aUser.SpecialityId == obj });
                    var findExistsInGroup = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 1 });
                    var findUserOnly = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 2 });
                    if (findUserOnly.length == 0 && findSelectedSpeciality && findSelectedSpeciality.length > 0 && (findSelectedSpeciality.length == findSelectedSpeciality[0].TotalUsersOfGroup || findSelectedSpeciality.length == findAllSpeciality.length)) {
                        orderDiscussionTooltip += findSelectedSpeciality[0].SpecialityCode + "\n";
                        groupName = findSelectedSpeciality[0].SpecialityCode;
                        group++;
                    } else {
                        if (findUserOnly.length > 0 || findExistsInGroup.length > 0) {
                            if (findUserOnly && findUserOnly.length > 0) {
                                _.each(findUserOnly, function (_user) {
                                    if (!_isPrelimRadAssignment(_user.OrderAssingedUserID)) {
                                        orderDiscussionTooltip += _user.OrderAssingedUserName + "\n";
                                        userName = _user.OrderAssingedUserName;
                                        user++;
                                    }
                                });
                            }
                            if (findExistsInGroup && findExistsInGroup.length > 0) {
                                _.each(findExistsInGroup, function (_user) {
                                    if (!_isPrelimRadAssignment(_user.OrderAssingedUserID)) {
                                        orderDiscussionTooltip += _user.OrderAssingedUserName + "\n";
                                        userName = _user.OrderAssingedUserName;
                                        user++;
                                    }
                                });
                            }
                        } else {
                            if (findSelectedSpeciality && findSelectedSpeciality.length > 0) {
                                _.each(findSelectedSpeciality, function (speciality) {
                                    if (!_isPrelimRadAssignment(speciality.OrderAssingedUserID)) {
                                        orderDiscussionTooltip += speciality.OrderAssingedUserName + "\n";
                                        userName = speciality.OrderAssingedUserName;
                                        user++;
                                    }
                                });
                            }
                        }


                    }
                }
            });

            var filterUsers = _.filter(Order.listOrderListAssignment, function (obj) { return obj.ProviderSpecialityId == 0 });
            if (filterUsers && filterUsers.length > 0) {
                _.each(filterUsers, function (obj) {
                    if (!_isPrelimRadAssignment(obj.OrderAssingedUserID)) {
                        orderDiscussionTooltip += obj.OrderAssingedUserName + "\n";
                        userName = obj.OrderAssingedUserName;
                        user++;
                    }
                });
            }

            if (orderDiscussionTooltip.length == 0) {
                if (Order.listOrderListAssignment && Order.listOrderListAssignment.length > 0) { return ''; }
                orderDiscussionTooltip = '';
                if (Order.isCollapsed) {
                    orderDiscussionTooltip = 'Hide Comparison';
                } else {
                    orderDiscussionTooltip = 'Show Comparison';
                }
                return orderDiscussionTooltip;
            } else {
                var message = '';
                var groupMessage = '';
                var userMessage = '';
                groupMessage += group > 1 ? group + ' Groups' : group == 1 ? groupName : '';
                userMessage += user > 1 ? user + ' Others' : user == 1 ? userName : '';
                if (groupMessage.length > 0 && userMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage + ' and ' + userMessage;
                } else if (groupMessage.length > 0) {
                    message = 'Assigned to ' + groupMessage;
                } else if (userMessage.length > 0) {
                    message = 'Assigned to ' + userMessage;
                }
                return message;
            }


        }

        $scope.showContact = function (OrderingPhysician, Location) {
            ////$log.log("showContact");
            $scope.currentWindow = 'win_ContactList';

            var names = OrderingPhysician.split(' ');
            if (names && names.length > 0) {
                $scope.OrderingPhysicianLName = names[0].replace(',', '');
                $scope.OrderingPhysicianFName = (names.length > 1 ? names[1].replace(',', '') : '');
                setTimeout(function () { ContactSearch.Location = _.filter(vm.masterData.Locations, function (obj) { return obj.Location === Location; })[0]; $scope.getContact($scope.OrderingPhysicianFName, $scope.OrderingPhysicianLName); }, 200);
            }


        }

        $scope.getContact = function (OrderingPhysicianFName, OrderingPhysicianLName) {
            ////$log.log("getContact");
            vm.worklist.loading = true;
            WorklistService.getContact((OrderingPhysicianFName ? OrderingPhysicianFName : '') + '#' + (OrderingPhysicianLName ? OrderingPhysicianLName : '')).then(function (response) {
                $scope.contactList = JSON.parse(response);
                $scope.tableParams = new NgTableParams({ page: 1, count: 19 }, { counts: [], dataset: $scope.contactList });
                if (angular.element(window).width() < 991) {
                    $scope.tableParams = new NgTableParams({ page: 1, count: 15 }, { counts: [], dataset: $scope.contactList });
                }
                //updateContactWindow();
                //$scope.win_ContactListHeight = $scope.contactList.length > 0 ? "80%" : $scope.halfScale ? "50%" : "30%";
                //$scope.win_ContactList.setOptions({ height: $scope.win_ContactListHeight });
                $scope.win_ContactList.open();
                $scope.win_ContactList.wrapper.prev(".k-overlay").addClass("custom-overlay");
                setTimeout(function () {
                    $scope.win_ContactList.center();
                }, 100);
                vm.worklist.loading = false;
            });
        };

        function logPacsEvent(eventName) {
            try {
                if (!__env.appLogSetting || !__env.appLogSetting.isEnabled) { return; }
                var userId = $sessionStorage.currentUserData ? $sessionStorage.currentUserData.userId : '';
                CommonService.LogApplicationInfo({ LogDetails: eventName, Application: 'PACS-Viewer', UserID: userId });
            } catch (e) { }
        }

        $scope.OpenSynapseStudy = function (Order, OptionalDV, isOpenPS, isSingleView) {
            ////$log.log("OpenSynapseStudy");

            $scope.GetDicomViewerCredentialsCallFrom = "OPENSYNAPSESTUDY";
            $scope.OpenSynapseStudyOrder = Order;
            $scope.OpenSynapseStudyOptionalDV = OptionalDV;
            $scope.OpenSynapseStudyisOpenPS = isOpenPS;
            var _correlationId = Date.now();
            var _pacsOpenStart = Date.now();
            var _credStart = Date.now();
            $q.all([
                GetDicomViewerCredentials(Order.SiteID, OptionalDV)
            ]).then(function (data) {
                var credElapsed = Date.now() - _credStart;
                if (data != null && data.length > 0 && data[0] != null) {
                    if (data[0].ShowModal) { return; }
                    else {
                        Order.DicomViewerCredentials = data[0].Credentials;
                        if (__env.showLoaderonPSNViewerLoad) {
                            $scope.isLoadingSynapse = true;
                        }
                        setTimeout(function () {
                            var totalElapsed = Date.now() - _pacsOpenStart;
                            logPacsEvent('[' + _correlationId + '] Step1-WorklistGrid: viewer=' + OptionalDV + ' GetDicomViewerCredentials=' + credElapsed + 'ms (apiCall=' + (data[0].RequiredCredentials ? 'YES' : 'NO') + ') setTimeout=500ms total=' + totalElapsed + 'ms');
                            //OpenSynapseStudy(Order, OptionalDV, isOpenPS, isSingleView);
                            $rootScope.$broadcast('event.OpenSynapse', { 'Order': Order, 'OptionalDV': OptionalDV, 'isOpenPS': isOpenPS, 'isSingleView': isSingleView, 'correlationId': _correlationId });
                            $scope.isLoadingSynapse = false;
                        }, 500);
                    }
                }
            });
        };

        $scope.ViewOrderReport = function (SelectedOrder, SelectedOrderAccession) {
            ////$log.log("ViewOrderReport");
            $scope.showDiscuss = false;
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;

            var ComparisionOrderList = [];

            if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length == 0) {
                $scope.orderComparisonListFilter = {
                    UserID: $scope.LoggedInUserID,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = result;
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });

                    setPriorReport(SelectedOrder, ComparisionOrderList);
                }).catch(function (noCantDo) {
                    //$scope.isLoading = false;
                });
            } else if (SelectedOrder.ComparisonOrder != null && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                setPriorReport(SelectedOrder, ComparisionOrderList);
            } else {
                setPriorReport(SelectedOrder, ComparisionOrderList);
            }



            //var obj = GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList);
        };

        $scope.NoContextMenuOptions = function (Order) {
            ////$log.log('NoContextMenuOptions');
            var hasMenu = false;
            
            if ((!vm.worklist.WorklistType
                && ClipboardConditionData.ClipboardData
                && ClipboardConditionData.ClipboardData.length <= 1)
                || (vm.worklist.WorklistType
                    && vm.worklist.WorklistType == 16
                    && ClipboardConditionData.SelectedRowsClipboard.length == 1)) {
                
                if (Order.Status == 'C' || Order.Status == 'D' || Order.IsLock || (Order.OrderAssingedUsers > 0 && !Order.OrderAssingedUser)) {
                    hasMenu = false;
                } else {
                    hasMenu = true;
                }
                if ($scope.userRole == 'SuperAdmin' || $scope.userRole == 'Admin') {
                    if (Order.Status == 'CO') {
                        hasMenu = true;
                    }

                    hasMenu = true;

                    if (Order.IsLock) {
                        hasMenu = true;
                    }

                }
                if (Order.DicomViewer) { hasMenu = true };
            }
            if (vm.worklist.WorklistType == 16) { hasMenu = true; } else {
                if (ClipboardConditionData.ClipboardData && ClipboardConditionData.ClipboardData.length > 0) { hasMenu = true; }
            }
            return hasMenu;
        }

        $scope.openContextMenuOptions = function (Order) {
            //$log.log('openContextMenuOptions > ', new Date());
            //var row = orderGridApi.grid.getRow(Order);
            //doSelection(row);
            //rowSelectionChangedBatch([row], true);
            $scope.setSelected(Order.OrderID, Order);
            selectRow();

            $scope.contextMenus = [];

            var index = _.findIndex(OrderList, function (lOrder) { return lOrder.OrderID == Order.OrderID; });
            $scope.contextmenuRowIndex = index;


            $scope.isAssignedCurrentUser = false;
            if (Order.OrderAssingedUser == $scope.LoggedInUserID) {
                $scope.isAssignedCurrentUser = true;
            }


            if ((!vm.worklist.WorklistType
                && ClipboardConditionData.ClipboardData.length <= 1)
                || (vm.worklist.WorklistType
                    && vm.worklist.WorklistType == 16
                    && ClipboardConditionData.SelectedRowsClipboard.length == 1)) {

                if (Order.Status == 'C' || Order.Status == 'D' || Order.IsLock || (Order.OrderAssingedUsers > 0 && !Order.OrderAssingedUser)) {
                    $scope.assignMenuVisible = false;
                } else {
                    if ($scope.isAssignedCurrentUser) {
                        $scope.contextMenus.push({
                            text: 'Unassign',
                            click: function ($itemScope, $event, modelValue, text, $li) {
                                unAssignToMe();
                            }
                        });
                    } else {
                        $scope.contextMenus.push({
                            text: 'Assign to Me', click: function ($itemScope, $event, modelValue, text, $li) {
                                assignToMe();
                            }
                        });

                    }
                    //$scope.contextMenus.push($scope.isAssignedCurrentUser ? 'Unassign' : 'Assign to Me');
                }
                if ($scope.userRole == 'SuperAdmin' || $scope.userRole == 'Admin') {
                    if (!(Order.SignByName) && (!Order.OrderAssingedUser && !(_.filter($scope.contextMenus, function (obj) { return obj.text === 'Assign to Me' }).length > 0))) {
                        $scope.contextMenus.push({
                            text: 'Unassign User(s)', click: function ($itemScope, $event, modelValue, text, $li) {
                                unAssignToMe();
                            }
                        });
                    }
                    if (Order.Status == 'CO') {
                        $scope.contextMenus.push({
                            text: 'Remove from Comparison', click: function ($itemScope, $event, modelValue, text, $li) {
                                $scope.removeComparedStudy(Order.OrderID);
                            }
                        });
                    }

                    $scope.contextMenus.push({
                        text: 'View Event', click: function ($itemScope, $event, modelValue, text, $li) {
                            openEventLog();
                        }
                    });

                    if (Order.IsLock) {
                        $scope.contextMenus.push({
                            text: 'Unlock Study', click: function ($itemScope, $event, modelValue, text, $li) {
                                swal({
                                    title: 'Do you want to Unlock the Study?',
                                    type: "warning",
                                    html: true,
                                    customClass: 'swal-wide',
                                    showCancelButton: true,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "Yes",
                                    cancelButtonText: "No",
                                },
                                    function (isConfirm) {
                                        if (isConfirm) {
                                            DeleteOpenOrder(Order.OrderID);
                                        }
                                    });
                            }
                        });
                    }

                }
                if (Order.DicomViewer) {
                    $scope.contextMenus.push({
                        text: 'Share Exam', click: function ($itemScope, $event, modelValue, text, $li) {
                            $scope.openShareExamWindow();
                        }
                    });
                }
                $scope.contextMenus.push({
                    text: 'Consult with Physician', click: function ($itemScope, $event, modelValue, text, $li) {
                        $scope.CallInConsult (Order);
                    }
                });
            }
            if (vm.worklist.WorklistType != 16) {
                if (ClipboardConditionData.ClipboardData && ClipboardConditionData.ClipboardData.length > 0) {
                    $scope.contextMenus.push({
                        text: 'Add To Clipboard',
                        click: function ($itemScope, $event, modelValue, text, $li) {
                            onAddToClipboard("Add");
                        }
                    });
                }
            }
            else {
                $scope.contextMenus.push({
                    text: 'Remove From Clipboard',
                    click: function ($itemScope, $event, modelValue, text, $li) {
                        onRemoveFromClipboard();
                    }
                });
            }
            
            if ($scope.contextMenus.length > 0) {
                $scope.isContextMenuVisible = true;
            }
            $scope.clearSelectedChildRows();

            $scope.assignMenuVisible = true;
            return $scope.contextMenus;
        }

        // New Code
        $scope.CallInConsult = function(order){
            //$scope.isChatMenuActive = true;
           // $rootScope.$broadcast('activeChatMenuBarformWorkList', $scope.isChatMenuActive,order);
           $scope.SelectedOrder = order;
           $scope.currentWindow = 'win_consultExamsWindow';
            OpenWindow($scope.win_consultExamsWindow, 'win_consultExamsWindow');
            $scope.win_consultExamsWindow.wrapper.prev(".k-overlay").addClass("custom-overlay");
        }
        // Old Code
        // $scope.CallInConsult = function(order){
        //     $scope.isChatMenuActive = true;
        //    $rootScope.$broadcast('activeChatMenuBarformWorkList', $scope.isChatMenuActive,order);
        // }

        // $scope.openConsultExamWindow = function () {
        //     $scope.currentWindow = 'win_consultExamsWindow';
        //     OpenWindow($scope.win_consultExamsWindow, 'win_consultExamsWindow');
        // };
        //Close onClick of send message button from shareExamchat.js
        $scope.onCloseConsultExamWindowHandler = function (newCheck) {
            $scope.isConsultExamsWindow = newCheck;
            if ($scope.isConsultExamsWindow == true) {
                $scope.win_consultExamsWindow.close();
            }
        };
        $scope.OpenSignReport = function (Order, OrderList) {
            //$log.log("OpenSignReport");
            clearSelection();

            //$scope.SingReport.Index = index;
            $scope.SingReport.Order = Order;
            $scope.SingReport.OrderList = OrderList;
            vm.selectedData.RuleID = vm.worklist.RuleID;


            var idx = _.findIndex($scope.SingReport.OrderList, { IsDeficient: true });
            if ($scope.SingReport.Order.IsDeficient) {
                idx = null;
            }

            $q.all([
                WarnDeficientCorrection(idx)
            ]).then(function (data) {
                if (data != null && data.length > 0 && data[0] == true) { $scope.SingReport.Order = $scope.SingReport.OrderList[idx]; }
                if ($scope.SingReport.Order.IsDeficient) {
                    WorklistService.GetDeficientErrorByOrderID($scope.SingReport.Order.OrderID).then(function (result) {
                        if (result != null && result.length > 0) {
                            var i = 1;
                            var errorstring = "";
                            result.forEach(function (error) {
                                if (errorstring && errorstring.length > 0) {
                                    errorstring += "<tr><td>" + i + ": " + error.DeficientErrorDesc + "</td></tr>";
                                    i++;
                                }
                                else {
                                    errorstring = "<table style='text-align: left;'><tr><td>" + i + ": " + error.DeficientErrorDesc + "</td></tr>";
                                    i++;
                                }
                            });
                            if (errorstring && errorstring.length > 0) errorstring += "</table>";
                            //$scope.isLoading = false;
                            setTimeout(function () {
                                swal({
                                    title: 'Please correct the below deficiency in the report.',
                                    text: errorstring,
                                    type: "warning",
                                    html: true,
                                    customClass: 'swal-wide',
                                    showCancelButton: true,
                                    confirmButtonColor: "#DD6B55", confirmButtonText: "Ok",
                                    cancelButtonText: "Ignore",
                                },
                                    function (isConfirm) {
                                        if (!isConfirm) {
                                            $scope.SingReport.Order.CheckDeficiency = 0;
                                        }
                                    });
                            }, 500);
                        }
                    });
                }
                $scope.GetDicomViewerCredentialsCallFrom = "OPENSINGREPORT";
                if (vm.selectedData.DefaultDicomViewer != null && vm.selectedData.DefaultDicomViewer.toString().length > 0) {
                    $scope.SingReport.Order.DicomViewer = vm.selectedData.DefaultDicomViewer;
                }
                $q.all([
                    GetDicomViewerCredentials($scope.SingReport.Order.SiteID, $scope.SingReport.Order.DicomViewer)
                ]).then(function (data) {
                    if (data != null && data.length > 0 && data[0] != null) {
                        if (data[0].ShowModal) { return; }
                        else {
                            $scope.SingReport.Order.DicomViewerCredentials = data[0].Credentials;
                            if (Order.ProcessError) {
                                swal("Study not available.");

                                return;
                            }
                            $scope.RetrySignReport = false;
                            if ($scope.Worklist == 'PSW' && $scope.UserRules != null && $scope.UserRules.length > 0) {
                                if (!confirm('As per rule(s) [' + $scope.UserRules + '] this study does not meet the eligibility criteria to be read by you at this time.\nAre you sure do you want to proceed any way?')) {
                                    return;
                                }
                            }



                            var openOrders = {
                                OrderId: $scope.SingReport.Order.OrderID,
                                ProviderID: $scope.LoggedInUserID
                            };

                            WorklistService.VerfiyReadStudy(openOrders).then(function (result) {
                                if (result.orderListAssignments && result.orderListAssignments.length > 0) {
                                    $scope.SingReport.Order.listOrderListAssignment = result.orderListAssignments;
                                    var userIndex = _.findIndex(result.orderListAssignments, function (data) { return data.OrderAssingedUserID == $scope.LoggedInUserID; });
                                    $scope.SingReport.Order.OrderAssingedUserID = data.OrderAssingedUserID;
                                    $scope.SingReport.Order.OrderAssingedUserName = $scope.getOrderListTooltip($scope.SingReport.Order);
                                    $scope.SingReport.Order.OrderAssingedUsers = result.orderListAssignments.length;
                                    $scope.SingReport.Order.OrderAssingedUser = userIndex != -1 ? $scope.LoggedInUserID : null;
                                    if ($scope.SingReport.Order.OrderAssingedUsers > 0 && !$scope.SingReport.Order.OrderAssingedUser) {
                                        if (!confirm('This study is already ' + $scope.SingReport.Order.OrderAssingedUserName.replace("Assigned to", "assigned to") + ', \nDo you still wish to continue reading the study?')) {
                                            return;
                                        }
                                    }
                                }
                                if (result.openOrders && result.openOrders.length > 0) {
                                    if (vm.selectedData.ChooseNextStudy || !vm.worklist.OpenClipboardNextStudy) {
                                        //if (!confirm("This order is locked by " + result.openOrders[0].ProviderName + ".\nAre you sure do you want to proceed any way?")) {
                                        //if (!confirm("This order is presently being dictated by user " + result.openOrders[0].ProviderName + ".\nCaution: Proceeding will create another report.")) {
                                        //    return;
                                        //}
                                        //else {
                                        //    //$scope.Call_SetSignREportModal();
                                        //    return;
                                        //}
                                        confirm("This order is presently being dictated by user " + result.openOrders[0].ProviderName + ".\nCaution: Proceeding will create another report.");
                                        return;

                                    }
                                    else {
                                        //var cnf = confirm("This order is locked by " + result.openOrders[0].ProviderName + ".\nAre you sure you want to skip?");
                                        var cnf = confirm("This order is presently being dictated by user " + result.openOrders[0].ProviderName + ".\nAre you sure you want to skip?");
                                        if (cnf == true) {
                                            NextRec();
                                        } else {
                                            return;
                                        }
                                    }
                                }
                                else {

                                    Call_SetSignREportModal();
                                }
                            });
                        }
                    }
                    else { return; }
                });
            });
        };

        $scope.setSelected = function (SelectedOrderID, SelectedOrder) {
            //$log.log("setSelected > on: ", new Date());
            $rootScope.$broadcast('event.worklist', { EventType: 'Deselect', ID: vm.index });
            $scope.SelectedOrderID = SelectedOrderID;
            $scope.SelectedOrder = SelectedOrder;
            vm.selectedData.SelectedOrder = SelectedOrder;
            $scope.SelectedComPatisomOrderID = "";
            //js for discussion pop wondow to show message box when keypad comes up
            if (angular.element(window).width() < 768) {
                setTimeout(function () {
                    angular.element('.discus-comment .txt-area').focusin(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').addClass('mobscreen-scroll');
                            setTimeout(function () {
                                angular.element('.denial-window.mobscreen-scroll').animate({ scrollTop: $(document).height() }, "fast");
                            }, 100);
                        }
                    });
                    angular.element('.discus-comment .txt-area').focusout(function () {
                        if (angular.element(this).data('clicked', true)) {
                            $('.denial-window').removeClass('mobscreen-scroll');
                        }
                    });
                }, 500);
            }
            //selectRow();
        };


        $scope.clearSelectedChildRows = function () {
            ////$log.log('clearSelectedChildRows');
            if (comparisonOrderGridApi) {
                comparisonOrderGridApi.selection.clearSelectedRows();
            }
        }

        $scope.VisibleComparisonHover = function (Comparison) {
            ////$log.log("VisibleComparisonHover");
            return $scope.userRole == 'SuperAdmin' || $scope.userRole == 'Admin' || Comparison.Status == 'C' || Comparison.Status == 'D';
        }

        $scope.expandedOpenContextMenuOptions = function (row) {
            ////$log.log('expandedOpenContextMenuOptions');
            $scope.contextMenus = [];

            if ($scope.VisibleComparisonHover(row.entity)
                && ($scope.userRole == 'SuperAdmin'
                    || $scope.userRole == 'Admin')) {
                $scope.contextMenus.push({
                    text: "Remove from Comparison",
                    click: function ($itemScope, $event, modelValue, text, $li) {
                        if (comparisonOrderGridApi.selection.getSelectedRows() != null && comparisonOrderGridApi.selection.getSelectedRows().length > 0) {
                            RemoveFromComparison(comparisonOrderGridApi.selection.getSelectedRows()[0].OrderID, comparisonOrderGridApi.selection.getSelectedRows()[0].Orders);
                        }
                    }
                });
            }

            return $scope.contextMenus;
        }

        $scope.setSelectedComparison = function () {
            ////$log.log("setSelectedComparison");
            if (comparisonOrderGridApi && comparisonOrderGridApi.selection.getSelectedRows() && comparisonOrderGridApi.selection.getSelectedRows().length > 0) {
                $scope.SelectedComPatisomOrderID = comparisonOrderGridApi.selection.getSelectedRows()[0].OrderID;
                $scope.SelectedOrderID = comparisonOrderGridApi.selection.getSelectedRows()[0].Orders;
                //swal(SelectedComPatisomOrderID);
                var order = _.find(OrderList, { 'OrderID': $scope.SelectedOrderID });
                if (order) {

                    $scope.setSelected($scope.SelectedOrderID, order);
                    selectRow();
                }
            }

        };

        function onReset() {
            ////$log.log('onReset');
            var cols = [];
            var gridColumns = [];
            if (positionChanged) {
                positionChanged = false;
                gridColumns = orderGridApi.grid.moveColumns.orderCache;
                _.each(_.clone(columnDefs), function (col) {
                    var gridCol = _.find(gridColumns, { 'field': col.name });
                    if (gridCol) {
                        gridCol.width = col.width;
                        gridCol.colDef.width = col.width;
                        cols.push(gridCol);
                    }
                    
                });
                gridColumns.length = 0;
                gridColumns.push.apply(gridColumns, cols);
                orderGridApi.grid.moveColumns.orderCache = gridColumns;
            } else {
                gridColumns = orderGridApi.grid.columns;
                _.each(_.clone(columnDefs), function (col) {
                    var gridCol = _.find(gridColumns, { 'field': col.name });
                    if (gridCol) {
                        gridCol.width = col.width;
                        gridCol.colDef.width = col.width;
                        cols.push(gridCol);
                    }
                    
                });
                gridColumns.length = 0;
                gridColumns.push.apply(gridColumns, cols);
                orderGridApi.grid.columns = gridColumns;

                
            }
            if (gridColumns.length != columnDefs.length) {
                $scope.uiGridOptions.columnDefs = _.clone(columnDefs);
            }
            orderGridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);

            if (comparisonOrderGridApi) {
                resetComparisonGrid();
            }

            return cols;
        }

        function getDataDown() {
            $log.log('getDataDown');
            if (vm.worklist.loading) { return; }
            if (!validateDOS(false)) { return orderGridApi.infiniteScroll.dataLoaded(); }
            hidePopover();
            $scope.PageNo++;
            $q.all([
                refresh()
            ]).then(function (data) {
                var pages = $scope.TotalRows / vm.worklist.PageSize;

                orderGridApi.infiniteScroll.saveScrollPercentage();
                _.pullAllBy(OrderList, data[0], 'OrderID');
                OrderList = _.concat(OrderList, data[0]);
                sortByField();

                var uniqueOrderList = _.uniqBy(OrderList, 'OrderID');
                $scope.orderList = _.slice(uniqueOrderList, 0, ($scope.PageNo * vm.worklist.PageSize));
                return orderGridApi.infiniteScroll.dataLoaded($scope.PageNo > 1, $scope.PageNo < pages).then(function () { checkDataLength('up'); });
            }).catch(function () {
                orderGridApi.infiniteScroll.dataLoaded();
            });
        };

        function getDataUp() {
            $log.log('getDataUp');
            //if (!validateDOS(false)) { return orderGridApi.infiniteScroll.dataLoaded(); }
            hidePopover();
            var pages = $scope.TotalRows / vm.worklist.PageSize;

            $scope.PageNo--;
            if ($scope.PageNo < 1) {
                $scope.PageNo = 1;
            }
            orderGridApi.infiniteScroll.saveScrollPercentage();
            OrderList = _.uniqBy(OrderList, 'OrderID');
            OrderList.splice(($scope.PageNo * vm.worklist.PageSize), vm.worklist.PageSize);
            //sortByField();
            $scope.orderList = _.slice(OrderList, 0);
            return orderGridApi.infiniteScroll.dataLoaded($scope.PageNo > 1, $scope.PageNo < pages).then(function () { checkDataLength('down'); });
        };

        function doSelection(row) {
            //$log.log("doSelection > on: ", new Date());
            //orderGridApi.selection.unSelectRow($scope.SelectedOrder);
            //if (!window.ctrlDown) {
            //    ClipboardConditionData.ClipboardData = [];
            //}
            if (!ExpadingRow) { rowSelectionChangedBatch([row], true); ExpadingRow = false; }
            $scope.setSelected(row.entity.OrderID, row.entity);
            
            
        }

        function columnPositionChanged(colDef, originalPosition, newPosition) {
            ////$log.log("columnPositionChanged");
            if (newPosition > 1) {
                var colDefs = $scope.uiGridOptions.columnDefs;
                _.remove(colDefs, function (obj) {
                    return obj.name == colDef.name;
                });
                colDefs.splice(newPosition, 0, colDef);

                $scope.uiGridOptions.columnDefs = colDefs;
                
                updateComparisonColumns();
                
                vm.worklist.ColumnDefs = $scope.uiGridOptions.columnDefs
                vm.onChange();
            } else {
                var gridColumns = orderGridApi.grid.moveColumns.orderCache;
                var removedGridCol = _.remove(gridColumns, function (obj) {
                    return obj.field == colDef.name;
                });
                gridColumns.splice(originalPosition, 0, removedGridCol[0]);
                orderGridApi.grid.moveColumns.orderCache = gridColumns;
                orderGridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
            }


            positionChanged = true;
        }

        function columnVisibilityChanged(changedColumn) {
            ////$log.log("columnVisibilityChanged");
            var parentGridColums = positionChanged ? orderGridApi.grid.moveColumns.orderCache : orderGridApi.grid.columns;
            var cols = [];
            _.each(parentGridColums, function (col) {
                cols.push(col.colDef);
            });


            updateComparisonColumns();

            vm.worklist.ColumnDefs = cols;
            vm.onChange();

        }

        function onSortChanged(grid, sortColumns) {
            ////$log.log("onSortChanged");
            clearSelection();
            if (sortColumns.length > 0) {
                OrderList = [];

                sorting(sortColumns);
            } else {
                SortColumns[0].sort.direction = SortColumns[0].sort.direction == 'desc' ? 'asc' : 'desc';

                var index = _.findIndex(grid.columns, { 'field': SortColumns[0].field });
                orderGridApi.grid.sortColumn(grid.columns[index], SortColumns[0].sort.direction);
            }
            SortFilter(SortingByMultiColumn);

            vm.worklist.SortColumns = SortColumns;
            vm.onChange();
        }

        function updateComparisonColumns() {
           ////$log.log('updateComparisonColumns');
            if (comparisonOrderGridApi) {
                var parentGridColums = positionChanged ? orderGridApi.grid.moveColumns.orderCache : orderGridApi.grid.columns;
                var cols = [];
                var gridColumns = comparisonOrderGridApi.grid.columns;
                _.each(parentGridColums, function (col) {
                    var gridCol = _.find(gridColumns, { 'field': col.field });
                    if (gridCol) {
                        gridCol.visible = col.visible;
                        gridCol.colDef.visible = col.visible;

                        gridCol.width = col.width;
                        gridCol.colDef.width = col.width;


                        cols.push(gridCol);
                    }

                });
                gridColumns.length = 0;
                gridColumns.push.apply(gridColumns, cols);
                comparisonOrderGridApi.grid.columns = gridColumns;

                comparisonOrderGridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
            }

        }

        function onColumnResize(colDef, deltaChange) {
            ////$log.log("onColumnResize");
            var parentGridColums = orderGridApi.grid.columns;
            var cols = [];
            var gridColumns = orderGridApi.grid.columns;
            _.each(parentGridColums, function (col) {
                var gridCol = _.find(gridColumns, { 'field': col.field });

                gridCol.width = col.width;
                gridCol.colDef.width = col.width;

                cols.push(gridCol.colDef);
            });

            updateComparisonColumns();

            vm.worklist.ColumnDefs = cols;
            vm.onChange();

        }

        function LoadPopOverDiscussion(discussion) {
            ////$log.log("LoadPopOverDiscussion");
            var d = $q.defer();
            WorklistService.GetDiscussions(discussion).then(function (response) {
                $scope.AllDiscussions = _.cloneDeep(response);
                $scope.Discussions = _.filter(response, function (item) { return item.Type == 1; });

                angular.forEach($scope.Discussions, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
                d.resolve();
            }).catch(function (noCantDo) {
                d.resolve();
            });
            return d.promise;
        }

        function getData () {
            //$log.log("getData: " + new Date());
            if (vm.worklist.loading) { return; }

            var d = $q.defer();

            sorting(vm.worklist.SortColumns);

            var receivedSinceCol = _.find($scope.uiGridOptions.columnDefs, { 'name': 'ReceivedSince' });
            if (receivedSinceCol) {
                var visiblePendingSince = receivedSinceCol.visible;
                receivedSinceCol.visible = visiblePendingSince ? vm.selectedData.Status.key == 'RP' || vm.selectedData.Status.key == 'D' : visiblePendingSince;
                receivedSinceCol.enableHiding = vm.selectedData.Status.key == 'RP' || vm.selectedData.Status.key == 'D';
            }

            $q.all([
                refresh()
            ]).then(function (data) {
                //////$log.log("getData received: " + new Date());

                if ($scope.PageNo == 1) {
                    OrderList = [];
                }

                _.pullAllBy(OrderList, data[0], 'OrderID');
                OrderList = _.concat(OrderList, data[0]);
                OrderList = _.uniqBy(OrderList, 'OrderID');
                sortByField();
                $scope.orderList = OrderList;

                d.resolve(data[0]);

                $timeout(function () { selectRow(); }, 100);
            }).catch(function (err) {
                d.reject(err);
            });

            return d.promise;
        }

        function refresh() {
            //$log.log("refresh: " + new Date());

            var d = $q.defer();

            setFilter();

            vm.worklist.loading = true;
            WorklistService.GetOrderDetails(OrderListFilter).then(function (result) {
                //////$log.log("refresh response: " + new Date());
                vm.worklist.loading = false;
                if (OrderListFilter.PageNum == 1) {
                    vm.worklist.ResultPendingCount = result.orderCount.ResultPendingCount;
                    vm.worklist.STATCount = result.orderCount.STATCount;
                }

                var TotalRows = $scope.TotalRows;
                //OrderList = result.Orders;
                if (result.orderLists && result.orderLists.length > 0) {
                    TotalRows = result.orderLists[0].TotalRows ? _.toInteger(result.orderLists[0].TotalRows) : 0;
                    
                    //////////$log.log("refresh > orders length: ", $scope.orderList.length);


                } 
                $scope.TotalRows = TotalRows;
                if ($scope.TotalRows == 0) {
                    vm.worklist.open = false;
                }


                updateOrders(result.orderLists)

                d.resolve(result.orderLists);


            }).catch(function (noCantDo) {
                vm.worklist.loading = false;
                d.reject(noCantDo);
            });

            return d.promise;
        };

        function updateOrders(Orders) {
            ////$log.log("updateOrders: " + new Date());

            _.each(Orders, function (order) {

                order.subGridOptions = subUIGridOptions;
                order.ComparisonOrder = [];

                //order.$$treeLevel = 1;

                updateOrderAssign(order);
                //order.row = row + 1;

                //row++;



            });

            return Orders;
        }

        function sortByField() {
            ////$log.log("sortByField: " + new Date());


            var sortingFields = [];
            var sortingDirections = [];

            var Status = GetStatus();

            if (Status == "RP") {
                sortingFields = ['IsDeficient', function (e) { return e.IsStat || e.IsHighPriority; }, 'DelayedSTAT'];
                sortingDirections = ['desc', 'desc', 'desc'];
            }


            _.each(vm.worklist.SortColumns, function (sColumn, index) {
                switch (sColumn.field) {
                    case 'FormattedOrderDate':
                        sortingFields.push(function (e) { return e.OrderDate ? new Date(e.OrderDate).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    case 'FormattedPatientDOB':
                        sortingFields.push(function (e) { return e.PatientDOB ? new Date(e.PatientDOB).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    case 'CreatedDate':
                        sortingFields.push(function (e) { return e.CreatedDate ? new Date(e.CreatedDate).getTime() : new Date("1900-01-01T00:00:00.00").getTime(); });
                        break;
                    default:
                        sortingFields.push(sColumn.field);
                        break;
                }

                sortingDirections.push(sColumn.sort.direction);

                //if (sColumn.field != 'CreatedDate') {
                //    sortingFields.push('CreatedDate');
                //    sortingDirections.push('desc');
                //}
            });

            OrderList = _.orderBy(OrderList, sortingFields, sortingDirections);

            //////$log.log("sortByField sorted: " + new Date());

        }

        function selectRow() {
            //$log.log("selectRow: ", new Date());
            //$log.log("selectRow > $scope.SelectedOrder: ", $scope.SelectedOrder);
            //$log.log("selectRow > ClipboardConditionData.ClipboardData: ", ClipboardConditionData.ClipboardData);
            if ($scope.SelectedOrder) {
                var selectedRow = _.find(OrderList, { 'OrderID': $scope.SelectedOrder.OrderID });
                orderGridApi.selection.selectRow(selectedRow);
            }
            if (vm.worklist.WorklistType == 16) {
                _.each(ClipboardConditionData.SelectedRowsClipboard, function (order) {
                    var selectedRow = _.find(OrderList, { 'OrderID': order.OrderID });
                    orderGridApi.selection.selectRow(selectedRow);
                });
            } else {
                _.each(ClipboardConditionData.ClipboardData, function (order) {
                    var selectedRow = _.find(OrderList, { 'OrderID': order.OrderID });
                    orderGridApi.selection.selectRow(selectedRow);
                });
            }
        }

        function LoadChildDiscussion(ObjDiscussion) {
            //$log.log("LoadChildDiscussion");
            var response = _.filter($scope.AllDiscussions, function (item) { return item.ReferenceID == ObjDiscussion.ID; });
            if (response && (response.length > 0)) {
                if (!ObjDiscussion.Childs || ObjDiscussion.Childs.length != response.length) {
                    ObjDiscussion.Childs = response;
                }
                angular.forEach(ObjDiscussion.Childs, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            }
        }

        //$scope.prepareChildDiscussionHTML = function (discussion, sender) {
        //    ////$log.log("prepareChildDiscussionHTML");
        //    var htmlpop = '';
        //    if (discussion.Childs && discussion.Childs.length > 0) {
        //        _.each(discussion.Childs, function (childdiscussion) {
        //            if (sender) {
        //                htmlpop = htmlpop + '<div class="replaysection mr-15px w-80 pull-left">' +
        //                    '<div style="background-color: #2F4858 !important;" ' +
        //                    'class="comment pos-rel border text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
        //                    'float-left py-5px px-8px">' +
        //                    '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
        //                    '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childdiscussion.Record_Created_By_Name + '</div>' +
        //                    '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
        //                    '<div style=" color: #a2a2a2 !important;" ' +
        //                    'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('date')(childdiscussion.Record_Created_At, 'MM/dd/yyyy HH:mm a') + '</div>' +
        //                    '</div></div>';
        //            } else {
        //                htmlpop = htmlpop + '<div class="replayreceiver mr-15px w-80 pull-right">' +
        //                    '<div style="background-color: #6c6868 !important;" ' +
        //                    'class="comment receiverborder pos-rel text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
        //                    'float-left py-5px px-8px">' +
        //                    '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
        //                    '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childdiscussion.Record_Created_By_Name + '</div>' +
        //                    '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
        //                    '<div style=" color: #a2a2a2 !important;" ' +
        //                    'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('date')(childdiscussion.Record_Created_At, 'MM/dd/yyyy HH:mm a') + '</div>' +
        //                    '</div></div>';
        //            }

        //            htmlpop = htmlpop + prepareChildDiscussionHTML(childdiscussion, sender);
        //        });
        //    }
        //    return htmlpop;
        //}

        function hidePopover() {
            ////$log.log("hidePopover");
            $scope.popoverOpened1 = false;
            $scope.popoverDicomOrderID = null;
            $scope.Discussions = [];
        }

        function LoadDiscussion(discussion) {
            //$log.log("LoadDiscussion");
            WorklistService.GetDiscussions(discussion).then(function (response) {
                $scope.AllDiscussions = _.cloneDeep(response);
                $scope.Discussions = _.filter(response, function (item) { return item.Type == 1; });

                if ($scope.showDiscuss && ($scope.isReportAvailable || ($scope.Discussions && $scope.Discussions.length > 0) || ($scope.OrderReport && $scope.OrderReport.FileCount > 0))) {
                    angular.element('#ModalReportNDiscuss').modal('show');
                    if ($scope.showDiscuss) {
                        $scope.currentWindow = "win_ModalReportNDiscuss";
                        $scope.win_ModalReportNDiscuss.open();
                        setTimeout(function () {
                            $scope.win_ModalReportNDiscuss.center();
                        }, 100);
                    } else {
                        $scope.currentWindow = 'win_Discussion';                       
                        $scope.win_Discussion.open();
                        setTimeout(function () {
                            $scope.win_Discussion.center();
                        }, 100);
                    }


                }
                angular.forEach($scope.Discussions, function (obj, idx) {
                    LoadChildDiscussion(obj);
                });
            });
        }

        $scope.winResize = function (e) {
            ////$log.log("winResize");
            adjustSize();            
        }
        
        function adjustSize() {
            ////$log.log("adjustSize");
            // For small screens, maximize the window when it is shown.
            // You can also make the check again in $(window).resize if you want to
            // but you will have to change the way to reference the widget and then
            // to use $("#theWindow").data("kendoWindow").
            // Alternatively, you may want to .center() the window.
            //alert($(window).width());

            if ($scope.currentWindow == 'win_Discussion') {
                $scope.win_Discussion.center();
            } else if ($scope.currentWindow == 'win_ContactList') {
                $scope.win_ContactList.center();
            } else if ($scope.currentWindow == 'win_ComparisonOrderReports') {
                $scope.win_ComparisonOrderReports.center();
            } else if ($scope.currentWindow == 'win_ModalReportNDiscuss') {
                $scope.win_ModalReportNDiscuss.center();
            } else if ($scope.currentWindow == 'win_SingReport') {
                $scope.win_SingReport.center();
            } else if ($scope.currentWindow == 'win_PSUser') {
                $scope.win_PSUser.center();
            } else if ($scope.currentWindow == 'win_HideStudy') {
                $scope.win_HideStudy.center();
            }

            return true;
        }

        //Repot pop up resize
        $scope.winDragend = function (e) {
            ////$log.log("winDragend");
            adjustSize();
        }

        function setPriorReport(SelectedOrder, ComparisionOrderList) {
            ////$log.log("setPriorReport");
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];

                if (data != null && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });
                }
                $scope.OrderReport = SelectedOrder;
                $scope.reportList = _.uniq($scope.reportList);

                var objSelectedReport = _.filter($scope.reportList, function (obj) { return obj.Accession == $scope.SelectedOrderAccession; });
                LoadReport(objSelectedReport[0].OrderID);
                if (Hasreport) {
                    $scope.currentWindow = "win_ComparisonOrderReports";
                    $scope.win_ComparisonOrderReports.open();
                    $scope.win_ComparisonOrderReports.wrapper.prev(".k-overlay").addClass("custom-overlay");
                    setTimeout(function () {
                        $scope.win_ComparisonOrderReports.center();
                    }, 100);
                }
                else {
                    toaster.info({ body: "No report found."  });
                }
            });
        }

        function GetComparisonOrderReportByOrderID(OrderID, ComparisionOrderList) {
            ////$log.log("GetComparisonOrderReportByOrderID");
            var d = $q.defer();
            //if (ComparisionOrderList && ComparisionOrderList.length > 0) {
            var comparisionorderObj = {
                OrderID: OrderID,
                UserID: $sessionStorage.currentUserData.userId,
                comparisionorderlist: ComparisionOrderList
            }

            WorklistService.GetComparisonOrderReportByOrderID(comparisionorderObj).then(function (results) {
                d.resolve(results);
            });
            //}
            //else {
            //    return null;
            //}
            return d.promise;
        }

        function LoadReport(OrderId) {
            //$log.log("LoadReport");


            if ($scope.orderReportList && $scope.orderReportList.length > 0) {
                var data = _.filter($scope.orderReportList, function (obj) { return obj.OrderID == OrderId; });
                if (data && data.length > 0) {
                    $scope.report = data[0];
                    $scope.ReviewOrder = {};
                    angular.copy($scope.report, $scope.ReviewOrder);
                    //$scope.isLoading = false;
                }
                else {
                    $scope.ReviewOrder = {};
                    getReportData(OrderId);
                }
            }
            else {
                $scope.ReviewOrder = {};
                getReportData(OrderId);
            }

        }

        function getReportData(OrderId) {
            //$log.log("getReportData");
            $scope.report = null;
            var UserId = $sessionStorage.currentUserData.userId;
            WorklistService.GetDictationValueReport(OrderId, UserId).then(function (response) {
                if (response) {
                    $scope.report = response;
                    $scope.ReviewOrder = response;

                    $scope.orderReportList.push(response);

                    if ($scope.report && $scope.report.DOS) {
                        $scope.report.DOS = changeDateFormat($scope.report.DOS);
                    }
                    if ($scope.report && $scope.report.SingDate) {
                        $scope.report.SingDate = changeDateFormat($scope.report.SingDate);
                    }
                    if ($scope.report && $scope.report.Patient_DOB) {
                        $scope.report.Patient_DOB = changeDateFormat($scope.report.Patient_DOB);
                    }
                }

                //$scope.isLoading = false;
            }, function (error) {
                //$scope.isLoading = false;
            });
        }

        $scope.winOpen = function (e) {
            //////////$log.log("winOpen");
            adjustSize();
        }

        $scope.addContact = function () {
            //////////$log.log("addContact");
            $scope.addEditContactWindowHeight = halfScale ? "55%" : "50%";
            $scope.currentWindow = "AddEditContactWindow";
            $scope.win_AddEditContactTitle = "Add Contact";
            $scope.win_AddEditContact.setOptions({ height: $scope.addEditContactWindowHeight });
            $scope.win_AddEditContact.open();
            $scope.win_AddEditContact.wrapper.prev(".k-overlay").addClass("custom-overlay");
            clearContact();
            $scope.FirstName = $scope.OrderingPhysicianFName;
            $scope.LastName = $scope.OrderingPhysicianLName;
            setTimeout(function () {
                $scope.win_AddEditContact.center();
            }, 100);
        };
        $scope.editContact = function (obj) {
            //////////$log.log("editContact");
            $scope.addEditContactWindowHeight = halfScale ? "55%" : "50%";
            $scope.currentWindow = "AddEditContactWindow";
            $scope.win_AddEditContactTitle = "Edit Contact";
            $scope.win_AddEditContact.setOptions({ height: $scope.addEditContactWindowHeight });
            $scope.win_AddEditContact.open();
            $scope.win_AddEditContact.wrapper.prev(".k-overlay").addClass("custom-overlay");
            setTimeout(function () {
                $scope.win_AddEditContact.center();
            }, 100);
            clearContact();
            $scope.ContactId = obj.Id;
            $scope.FirstName = obj.FirstName;
            $scope.LastName = obj.LastName;
            $scope.loc.selectedItems = _.find(vm.masterData.Locations, function (item) { return item.Location == obj.PrimaryLocation; });

            var mobile = $scope.spiltPhoneNumber(obj.Mobile);
            var office = $scope.spiltPhoneNumber(obj.Office);
            if (mobile && mobile.length > 0) {
                $scope.Mobile = (mobile != null) ? mobile[0] : '';
            }
            if (office && office.length > 0) {
                $scope.Office = (office != null) ? office[0] : '';
            }
            $scope.Email = (obj.EmailId) ? obj.EmailId.trim() : '';

        };
        $scope.saveContact = function (Mobile, Office, Email) {
            //////////$log.log("saveContact");
            $scope.Mobile = Mobile; $scope.Office = Office; $scope.Email = Email;
            if (!$scope.Mobile && !$scope.Office && !$scope.Email) {
                toaster.warning({ body: "Please enter phone number or email id!"  });

            }
            else {

                var phone = [{
                    Id: 0,
                    AddressBookId: 0,
                    PhoneTypeId: 1,
                    Phone: $scope.Office
                },
                {
                    Id: 0,
                    AddressBookId: 0,
                    PhoneTypeId: 2,
                    Phone: $scope.Mobile
                }];

                var email = [{
                    Id: 0,
                    AddressBookId: 0,
                    EmailTypeId: 1,
                    EmailId: $scope.Email
                }];

                var addrbook = {
                    Id: $scope.ContactId,
                    FirstName: $scope.FirstName,
                    LastName: $scope.LastName,
                    PrimaryLocation: ($scope.loc.selectedItems) ? $scope.loc.selectedItems.Location : '',
                    IsPrivate: true,
                    IsDeleted: false,
                    Phones: phone,
                    Emails: email
                }
                vm.worklist.loading = true;
                WorklistService.saveContact(addrbook).then(function (response) {
                    vm.worklist.loading = false;
                    $scope.win_AddEditContact.close();
                    if ($scope.ContactId > 0) {
                        toaster.success({ body: "Contact updated successfully!"  });
                    }
                    else {
                        toaster.success({ body: "Contact added successfully!"  });
                    }
                    $scope.getContact($scope.FirstName, $scope.LastName);
                }, _respError);
            }
        }
        function clearContact() {
            //////////$log.log("clearContact");
            $scope.ContactId = 0;
            $scope.FirstName = '';
            $scope.LastName = '';
            $scope.loc.selectedItems = null;
            $scope.Mobile = '';
            $scope.Office = '';
            $scope.Email = '';
        }

        function clearSelection() {
            //$log.log("clearSelection");
            try {
                if (document.selection && document.selection.empty) {
                    document.selection.empty();
                } else if (window.getSelection) {
                    var sel = window.getSelection();
                    sel.removeAllRanges();
                }
            } catch (error) {
                ////////$log.log(error);
            }

        };

        function WarnDeficientCorrection(index) {
            //$log.log("WarnDeficientCorrection");
            var d = $q.defer();
            var out = false;
            if (index != null && index != -1 && $scope.DeficientWarningOnWorklist) {
                swal({
                    title: 'There are deficient reports in worklist.',
                    text: 'Are you sure you want to correct them?',
                    type: "warning",
                    html: true,
                    customClass: 'swal-wide',
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Ok",
                    cancelButtonText: "Skip",
                },
                    function (isConfirm) {
                        if (isConfirm) {
                            out = true;
                        }
                        else {
                            out = false;
                        }
                        d.resolve(out);
                    });
            }
            else {
                d.resolve(out);
            }
            return d.promise;
        }

        function GetDicomViewerCredentials(SiteID, ViewerName) {
            //$log.log("GetDicomViewerCredentials");
            $scope.DVCred = {};
            var d = $q.defer();
            var out = {};
            var objFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: SiteID,
                ViewerName: ViewerName
            };
            if (__env.CheckDicomViewerCredentials.split(',').indexOf(ViewerName) !== -1) {
                out.RequiredCredentials = true;
                WorklistService.GetDicomViewerCredentials(objFilter).then(function (result) {
                    if (result != null && result.length > 0) {
                        out.RequiredCredentials = true;
                        out.ShowModal = false;
                        out.Credentials = {};
                        out.Credentials.UserName = result[0].UserName;
                        out.Credentials.Password = result[0].Password;
                    }
                    else {
                        out.ShowModal = true;
                        $scope.DVCred.SiteID = SiteID;
                        $scope.DVCred.ViewerName = ViewerName;
                        $('#ModalDicomViewerCredentials').modal('show');
                    }
                    d.resolve(out);
                });
            }
            else {
                out.RequiredCredentials = false;
                out.ShowModal = false;
                d.resolve(out);
            }
            return d.promise;
        }

        function Call_SetSignREportModal() {
            //$log.log("Call_SetSignREportModal");
            $rootScope.$broadcast('event.worklist', { EventType: 'RemoveOpenOrder', ID: vm.index });

            if (LastOpenedOrderID != null && LastOpenedOrderID != $scope.SingReport.Order.OrderID) {
                removeOrderFromList(LastOpenedOrderID);
                DeleteOpenOrder();
            }
            InsertOpenOrder();
            SetSignREportModal($scope.SingReport.Order, $scope.SingReport.OrderList);
            if (!vm.selectedData.ChooseNextStudy || !vm.worklist.OpenClipboardNextStudy) {
                $scope.currentWindow = "win_SingReport";
                $scope.win_SingReport.open();
                $scope.win_SingReport.wrapper.prev(".k-overlay").addClass("custom-overlay");
                setTimeout(function () {
                    $scope.win_SingReport.center();
                }, 100);
            }
        };

        function InsertOpenOrder() {
            //$log.log("InsertOpenOrder > on: ", new Date());
            var order = $scope.SingReport.Order;
            if (!order.IsLock) {
                $scope.LastOpenedOrder = order;
                LastOpenedOrderID = order.OrderID;
                var openOrders = {
                    OrderId: order.OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId,
                    ProviderName: $filter('titleCase')($sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName), //$sessionStorage.currentUserData.displayName,
                    OpenDateTime: new Date().toLocaleString('en-US', { timeZone: 'US/Central' })
                };
                WorklistService.InsertOpenOrder(openOrders).then(function (result) {

                });
            }

        };

        function SetSignREportModal(Order, OrderList) {
            //$log.log("SetSignREportModal: ", new Date());
            $scope.SingReport.CurrentSite = Order.Site + (Order.Location ? "(" + Order.Location + ")" : "");
            $scope.SingReport.CurrentPatientMRN = Order.PatientMRN;
            $scope.SingReport.CurrentPatient = Order.PatientName;
            $scope.SingReport.CurrentAccession = Order.Accession;
            $scope.setSelected(Order.OrderID, Order);

            OpenedAccessionNumber = Order.Accession;
            DictatedAccessionNumber.push(Order.Accession);

            if (vm.selectedData.DefaultDicomViewer != null && vm.selectedData.DefaultDicomViewer.toString().length > 0) {
                $scope.SingReport.Order.DicomViewer = vm.selectedData.DefaultDicomViewer;
            }

            DictationReportStatus = '';

            $scope.SingReport.PrevToolTip = "";
            $scope.SingReport.NextToolTip = "";
            var idx = _.findIndex(OrderList, function (a) { return a.OrderID == Order.OrderID });
            if (idx > 0) {
                $scope.SingReport.PrevToolTip = "Name: " + OrderList[idx - 1].PatientName + " " + "MRN: " + OrderList[idx - 1].PatientMRN + " " + "Accession: " + OrderList[idx - 1].Accession;
            }
            else if (idx <= 0) {
                $scope.SingReport.PrevToolTip = "No Order";
            }
            if (OrderList && OrderList.length > idx + 1) {
                $scope.SingReport.NextToolTip = "Name: " + OrderList[idx + 1].PatientName + " " + "MRN: " + OrderList[idx + 1].PatientMRN + " " + "Accession: " + OrderList[idx + 1].Accession;
            }
            else if (OrderList && OrderList.length <= idx + 1) {
                $scope.SingReport.NextToolTip = "No Order";
            }


            $q.all([
                showPriorReport(Order, Order.Accession)
            ]).then(function (data) {
                //------------------------------------Open PS and Viewer------------------------------------
                if (__env.showLoaderonPSNViewerLoad) {
                    $scope.isLoadingSynapse = true;
                }
                var _autoCorrelationId = Date.now();
                setTimeout(function () {
                    logPacsEvent('[' + _autoCorrelationId + '] Step1-WorklistGrid: viewer=' + Order.DicomViewer + ' auto-open setTimeout=500ms');
                    $rootScope.$broadcast('event.OpenSynapse', { 'Order': Order, 'OptionalDV': Order.DicomViewer, 'isOpenPS': true, 'correlationId': _autoCorrelationId });
                    $scope.isLoadingSynapse = false;
                }, 500);
                //-----------------------------------------------------------------------------------------
            });



        }

        function showPriorReport(SelectedOrder, SelectedOrderAccession) {
            //$log.log("showPriorReport");
            var d = $q.defer();
            var ComparisionOrderList = [];
            if (SelectedOrder.ComparisonOrder && SelectedOrder.ComparisonOrder.length > 0) {
                SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                    ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                });
                $q.all([
                    viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                ]).then(function (data) {
                    d.resolve(data);
                });

            } else {
                $scope.orderComparisonListFilter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    OrderID: SelectedOrder.OrderID
                };
                WorklistService.GetOrdersComparisonList($scope.orderComparisonListFilter).then(function (result) {
                    SelectedOrder.ComparisonOrder = _.clone(result);
                    SelectedOrder.subGridOptions = _.clone(subUIGridOptions);
                    SelectedOrder.subGridOptions.data = _.clone(result);
                    SelectedOrder.ComparisonOrder.forEach(function (ComparisionOrder) {
                        ComparisionOrderList.push({ OrderID: ComparisionOrder.OrderID });
                    });
                    $q.all([
                        viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList)
                    ]).then(function (data) {
                        d.resolve(data);
                    });


                }).catch(function (noCantDo) {
                    vm.worklist.loading = false;
                    d.resolve(false);
                });
            }
            return d.promise;
        }

        function sorting(sortColumns) {
            ////$log.log("sorting ", new Date());
            SortColumns = [];
            SortingByMultiColumn = '';
            if (sortColumns && sortColumns.length > 0) {
                _.each($scope.uiGridOptions.columnDefs, function (sColumn, index) {


                    var columnDefIndex = _.findIndex(sortColumns, { 'field': sColumn.name });
                    if (columnDefIndex >= 0) {
                        $scope.uiGridOptions.columnDefs[index].sort = sortColumns[columnDefIndex].sort;
                        var SortColumn = {
                            field: sortColumns[columnDefIndex].field, sort: sortColumns[columnDefIndex].sort
                        };
                        SortColumns.push(SortColumn);

                        getSortingString(sortColumns[columnDefIndex].field, sortColumns[columnDefIndex].sort.direction);
                    } else {
                        $scope.uiGridOptions.columnDefs[index].sort = {};
                    }


                });
                SortingByMultiColumn = SortingByMultiColumn.substring(0, SortingByMultiColumn.lastIndexOf(','));
                vm.worklist.ColumnDefs = $scope.uiGridOptions.columnDefs;
                vm.worklist.SortColumns = SortColumns;
            } else {
                _.each($scope.uiGridOptions.columnDefs, function (sColumn, index) {


                    if (sColumn.name == 'CreatedDate') {
                        $scope.uiGridOptions.columnDefs[index].sort = { direction: uiGridConstants.ASC, priority: 0 };

                        var SortColumn = {
                            field: $scope.uiGridOptions.columnDefs[index].name, sort: $scope.uiGridOptions.columnDefs[index].sort
                        };
                        SortColumns.push(SortColumn);

                        getSortingString($scope.uiGridOptions.columnDefs[index].name, $scope.uiGridOptions.columnDefs[index].sort.direction);

                        SortingByMultiColumn = SortingByMultiColumn.substring(0, SortingByMultiColumn.lastIndexOf(','));

                    } else {
                        $scope.uiGridOptions.columnDefs[index].sort = {};
                    }


                });
                ////$log.log("sorting > SortColumns: ", SortColumns);
                vm.worklist.SortColumns = SortColumns;
                vm.worklist.ColumnDefs = $scope.uiGridOptions.columnDefs;
                ////$log.log("sorting > vm.worklist.SortColumns: ", vm.worklist.SortColumns);
                vm.onChange();

            }

        }

        function getSortingString(sColumnField, direction) {
            //////$log.log("getSortingString ", new Date());
            var orderByField = '';
            switch (sColumnField) {
                case "Location":
                    orderByField = "L.Location";
                    break;
                case "Accession":
                    orderByField = "O.Accession";
                    break;
                case "FormattedOrderDate":
                    orderByField = "O.OrderDate";
                    break;
                case "PatientMRN":
                    orderByField = "O.PatientMRN";
                    break;
                case "PatientName":
                    orderByField = "O.PatientLastName|O.PatientFirstName";
                    break;
                case "FormattedPatientDOB":
                    orderByField = "O.PatientDOB";
                    break;
                case "PatientGender":
                    orderByField = "O.PatientGender";
                    break;
                case "PatientAge":
                    orderByField = "O.PatientDOB";
                    break;
                case "PatientClass":
                    orderByField = "O.PatientClass";
                    break;
                case "Modality":
                    orderByField = "O.Modality";
                    break;
                case "ProcedureDesc":
                    orderByField = "O.ProcedureDesc";
                    break;
                case "OrderingPhysician":
                    orderByField = "P.Name";
                    break;
                case "CreatedDate":
                    orderByField = DefaultSortingColumn;
                    break;
            }

            if (orderByField.indexOf('|') > 0) {
                var fields = orderByField.split('|');
                _.each(fields, function (field) {
                    SortingByMultiColumn += field + ' ' + direction + ', ';
                });
            } else {
                SortingByMultiColumn += orderByField + ' ' + direction + ', ';
            }
        }

        function OrderExists(OrderID) {
            ////////$log.log("OrderExists");
            var OrderIndex = _.findIndex(OrderList, function (obj) { return obj.OrderID == OrderID });
            return OrderIndex;
        }

        function getRowTemplateColorCode(order) {
            var Status = GetStatus();
            var colorCode = '';
            switch (Status) {
                case 'RP':
                    switch (order.Status) {
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : vm.masterData.DelayStatColorCode ? vm.masterData.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasImage && !order.HasORM) {
                                colorCode = '#b2b266';
                            }
                            break;
                    }
                    break;
                case 'AL':
                    switch (order.Status) {
                        case 'X':
                            colorCode = '#BFDED6';
                            break;
                        case 'CO':
                            colorCode = '#B9ADCF';
                            break;
                        case 'C':
                            colorCode = '#75E284';
                            break;
                        case 'D':
                            colorCode = '#a0c1c5';
                            break;
                        case 'H':
                            colorCode = '#FFC99A';
                            break;
                        case 'RC':
                            colorCode = '#79b384';
                            break;
                        case 'RP':
                            switch (order.DelayedSTAT) {
                                case 1:
                                    colorCode = order.DelayedStatColorCode ? order.DelayedStatColorCode : vm.masterData.DelayStatColorCode ? vm.masterData.DelayStatColorCode.Value : '#ffccb3';
                                    break;
                                case 2:
                                    colorCode = '#FF685E';
                                    break;
                            }
                            if (colorCode.length == 0 && order.HasORM && order.HasImage) {
                                colorCode = '#FFE69A';
                            } else if (colorCode.length == 0 && !order.HasORM && order.HasImage) {
                                colorCode = '#b2b266';
                            } else if (colorCode.length == 0 && order.HasORM && !order.HasImage) {
                                colorCode = '#f4ba4b';
                            }
                            break;
                    }
                    if (colorCode.length == 0 && !order.HasORM) {
                        colorCode = '#ff873a';
                    } else if (colorCode.length == 0 && !order.HasImage) {
                        colorCode = '#f4ba4b';
                    }
                    break;
            }
            return colorCode.length > 0 ? colorCode : '#ffffff';
        }

        function updateOrderList(Order) {
            OrderList = _.uniqBy(OrderList, 'OrderID');

            if ($scope.TotalRows) {
                $scope.TotalRows = $scope.TotalRows + 1;
            }


            sortByField();

            var pages = $scope.TotalRows / vm.worklist.PageSize;
            //orderGridApi.infiniteScroll.saveScrollPercentage();
            $scope.orderList = OrderList;
            orderGridApi.infiniteScroll.dataLoaded($scope.PageNo > 1, $scope.PageNo < pages);

        }

        function validateOrders(Orders) {
            //////$log.log('validateOrders');
            _.each(Orders, function (order) {
                var OrderIndex = OrderExists(order.OrderID);
                if (OrderIndex == -1
                    && validateSite(order.SiteID)
                    && checkOrderFilters(order)
                    && validatePendingOrder(order)
                    && !order.isComparisonOrder
                    && !isComparisonOrder(order)) {
                    ////////////$log.log("ProcessedOrdersUpdate > OrderList: ", OrderList);
                    order.FormattedOrderDate = $filter('date')(order.OrderDate, "M/d/yy HH:mm");
                    order.FormattedPatientDOB = $filter('date')(order.PatientDOB, "M/d/yy");
                    order.RowColorCode = getRowTemplateColorCode(order);
                    OrderList.push(order);
                    updateOrderList(order);

                } if (OrderIndex != -1
                    && !order.isComparisonOrder) {
                    if (checkOrderFilters(order)
                        && validatePendingOrder(order)) {

                        order.FormattedOrderDate = $filter('date')(order.OrderDate, "M/d/yy HH:mm");
                        order.FormattedPatientDOB = $filter('date')(order.PatientDOB, "M/d/yy");
                        order.RowColorCode = getRowTemplateColorCode(order);

                        OrderList[OrderIndex] = order;

                        sortByField();

                        $scope.orderList = OrderList;
                    } else {
                        removeOrderFromList(order.OrderID);
                    }
                } else {
                    isComparisonOrder(order)
                }
            });

        }

        function validateSite(SiteID) {
            ////////$log.log("validateSite");
            var siteIdx = _.findIndex(vm.masterData.Locations, function (lObj) { return lObj.SiteID == SiteID });
            if (siteIdx != -1) {
                return true;
            }
            return false;
        }

        function checkOrderFilters(order) {
            //$log.log("checkOrderFilters > order: ", order);
            var flag = true;
            if (vm.worklist.Type == 'D' || vm.worklist.Type == 'S') {
                if (vm.selectedData && vm.selectedData.Location && vm.selectedData.Location.length > 0) {
                    var idx = _.findIndex(vm.selectedData.Location, function (obj) { return obj.LocationID == order.LocationID; });
                    if (idx == -1) {
                        return false;
                    }
                }
                if (vm.selectedData.Accession) {
                    if (order.Accession != vm.selectedData.Accession) {
                        return false;
                    }
                }
                if (vm.selectedData.OrderDate && vm.selectedData.OrderDate.startDate && vm.selectedData.OrderDate.endDate) {
                    var orderStartDate = moment(new Date(order.OrderDate)).format("MM-DD-YYYY");
                    var startDate = moment(new Date(vm.selectedData.OrderDate.startDate)).format("MM-DD-YYYY");
                    var endDate = moment(new Date(vm.selectedData.OrderDate.endDate)).format("MM-DD-YYYY");
                    if (moment(orderStartDate) >= moment(startDate) && moment(orderStartDate) <= moment(endDate)) {
                        flag = true
                    }
                    else {
                        return false;
                    }
                }
                if (vm.selectedData && vm.selectedData.Modality && vm.selectedData.Modality.length > 0) {
                    var idx = _.findIndex(vm.selectedData.Modality, function (obj) { return obj.Code == order.Modality; });
                    if (idx == -1) {
                        return false;
                    }
                }
                if (vm.selectedData.OrderingPhysician) {
                    if (order.OrderingPhysician.toUpperCase().includes(vm.selectedData.OrderingPhysician.toUpperCase())) {
                        return true;
                    } else {
                        return false;
                    }
                }
                if (vm.selectedData.PatientMRN) {
                    if (order.PatientMRN != vm.selectedData.PatientMRN) {
                        return false;
                    }
                }
                if (vm.selectedData.PatientName) {
                    if (order.PatientName.toUpperCase().includes(vm.selectedData.PatientName.toUpperCase())) {
                        return true;
                    } else {
                        return false;
                    }
                }
                if (vm.selectedData.DOB) {
                    if (moment(new Date(order.PatientDOB)).format("MM-DD-YYYY") != moment(new Date(vm.selectedData.DOB)).format("MM-DD-YYYY")) {
                        return false;
                    }
                }
                if (vm.selectedData.PatientClass) {
                    if (order.PatientClass != vm.selectedData.PatientClass) {
                        return false;
                    }
                }
                if (vm.selectedData.Status.key && vm.selectedData.Status.key != 'AL') {
                    if (vm.selectedData.Status.key == 'OP' && order.Status == 'RP') {
                        flag = true;
                    } else if (order.Status != vm.selectedData.Status.key) {
                        flag = false;
                    }
                }
                if (vm.selectedData.StudyPriority && vm.selectedData.StudyPriority.Key != 'All') {
                    if (order.Priority.toUpperCase() != vm.selectedData.StudyPriority.Value.toUpperCase()) {
                        return false;
                    }
                }
            } else if (vm.worklist.Type == 'A') {
                var Status = GetStatus();
                if (order.Status != Status) {
                    flag = false;
                }
            }

            return flag;
        }

        function validatePendingOrder(order) {
            var validated = false;
            if (vm.selectedData.Status.key == 'OP') {
                if (order.HasImage && !order.HasORM) {
                    validated = true;
                } else if (order.HasImage && order.HasORM) {
                    validated = false;
                }
            } else {
                validated = true;
            }

            return validated;
        }

        function isComparisonOrder(Order) {
            var compOrderIndex = -1;
            if (Order.ParentOrderIDs && Order.ParentOrderIDs.length > 0) {
                if (Order.ParentOrderIDs.indexOf(',') > 0) {
                    var parentOrderIDs = Order.ParentOrderIDs.split(',');
                    _.each(parentOrderIDs, function (IDs) {
                        compOrderIndex = _.findIndex(OrderList, { 'OrderID': IDs });

                        if (compOrderIndex != -1) {
                            OrderList[compOrderIndex].HasComparison = OrderList[compOrderIndex].HasComparison == "0" ? "1" : OrderList[compOrderIndex].HasComparison;
                            if (OrderList[compOrderIndex].ComparisonOrder && OrderList[compOrderIndex].ComparisonOrder.length > 0) {
                                OrderList[compOrderIndex].ComparisonOrder.push(Order);
                            } else {
                                var comparisonOrder = [];
                                comparisonOrder.push(Order);
                                OrderList[compOrderIndex].ComparisonOrder = comparisonOrder;
                            }
                        }
                    });

                } else {
                    compOrderIndex = _.findIndex(OrderList, { 'OrderID': Order.ParentOrderIDs });

                    if (compOrderIndex != -1) {
                        OrderList[compOrderIndex].HasComparison = OrderList[compOrderIndex].HasComparison == "0" ? "1" : OrderList[compOrderIndex].HasComparison;
                        if (OrderList[compOrderIndex].ComparisonOrder && OrderList[compOrderIndex].ComparisonOrder.length > 0) {
                            OrderList[compOrderIndex].ComparisonOrder.push(Order);
                        } else {
                            var comparisonOrder = [];
                            comparisonOrder.push(Order);
                            OrderList[compOrderIndex].ComparisonOrder = comparisonOrder;
                        }
                    }
                }

                return true;
            }

            return false;
        }

        function removeOrderFromList(OrderId) {
            //$log.log("removeOrderFromList > On: ", new Date());
            var idx = _.findIndex(OrderList, function (obj) { return obj.OrderID == OrderId; });
            if (idx != -1) {
                removeOrder(idx);
            }
        }

        function removeOrderAccession(Accession) {
            //////$log.log("removeOrderAccession > Accession: ", Accession);
            var idx = _.findIndex(OrderList, function (obj) { return obj.Accession == Accession; });
            if (idx != -1) {
                removeOrder(idx);
            }
        }

        function removeOrder(idx) {
            //$log.log("removeOrder > on: ", new Date());
            //var orderID = OrderList[idx].OrderID;
            OrderList.splice(idx, 1);


            if ($scope.TotalRows > 0) {
                $scope.TotalRows = $scope.TotalRows - 1;
            }

            $scope.orderList = OrderList;

            if (OrderList && OrderList.length < vm.worklist.PageSize) {
                //////$log.log("removeOrder orderlist length is less than page size");
                //isOrderOnServer = true;
            }


        }

        function validateDOS(Alert) {
            if (vm.selectedData.Status.key == 'AL') {
                if (!vm.selectedData.OrderDate.startDate && !vm.selectedData.OrderDate.endDate) {
                    if (Alert) toaster.warning({ body: "Please select the DOS."  });
                    return false;
                }
                var now = moment(vm.selectedData.OrderDate.endDate).unix();
                var then = moment(vm.selectedData.OrderDate.startDate).unix();
                var diff = (now - then) / (60 * 60 * 24 * 365);
                var years = Math.floor(diff);
                if (diff > 1) {
                    if (Alert) toaster.warning({ body: "Please select the DOS that is max one year."  });
                    return false;
                }
            }
            return true;
        }

        function checkDataLength(discardDirection) {
            //////$log.log("checkDataLength");
            var pages = $scope.TotalRows / vm.worklist.PageSize;
            // work out whether we need to discard a page, if so discard from the direction passed in
            // we want to remove a page
            orderGridApi.infiniteScroll.saveScrollPercentage();

            if (discardDirection === 'up') {
                //$scope.orderList = $scope.orderList.slice(50);
                //gridFirstPage++;
                $timeout(function () {
                    // wait for grid to ingest data changes
                    orderGridApi.infiniteScroll.dataRemovedTop($scope.PageNo > 1, $scope.PageNo < pages);
                });
            } else {
                //$scope.orderList = $scope.orderList.slice(0, (pages * 50));
                //gridLastPage--;
                $timeout(function () {
                    // wait for grid to ingest data changes
                    orderGridApi.infiniteScroll.dataRemovedBottom($scope.PageNo > 1, $scope.PageNo < pages);
                });
            }
        }

        function setFilter() {

            if (vm.worklist.Type == 'D') {
                OrderListFilter = {
                    PageNum: $scope.PageNo,
                    PageSize: vm.worklist.PageSize,
                    OrderDateStartDate: moment().subtract(6, 'days').format("MM-DD-YYYY"),
                    OrderDateEndDate: moment().format("MM-DD-YYYY"),
                    Status: 'RP',
                    UserID: $sessionStorage.currentUserData.userId,
                    WorklistFlag: vm.worklist.RuleID,
                    STATFilter: vm.selectedData.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    FromSignDate: moment().format("MM-DD-YYYY"),
                    ToSignDate: moment().format("MM-DD-YYYY"),
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: 'All',
                };
            } else if (vm.worklist.Type == 'S') {
                OrderListFilter = {
                    PageNum: $scope.PageNo,
                    PageSize: vm.worklist.PageSize,
                    SiteID: vm.selectedData.Site ? vm.selectedData.Site.SiteID : null,
                    LocationID: _.join(_.map(vm.selectedData.Location, 'LocationID'), ','),
                    Accession: vm.selectedData.Accession,
                    ModalityID: _.join(_.map(vm.selectedData.Modality, 'Id'), ','),
                    OrderDateStartDate: (vm.selectedData.OrderDate.startDate) ? moment(new Date(vm.selectedData.OrderDate.startDate)).format("MM-DD-YYYY") : null,
                    OrderDateEndDate: (vm.selectedData.OrderDate.endDate) ? moment(new Date(vm.selectedData.OrderDate.endDate)).format("MM-DD-YYYY") : null,
                    PatientName: vm.selectedData.PatientName,
                    PatientMRN: vm.selectedData.PatientMRN,
                    PatientDOB: formatted_date(vm.selectedData.DOB),
                    PatientClass: vm.selectedData.PatientClass ? vm.selectedData.PatientClass.PatClass : '',
                    OrderingPhysician: vm.selectedData.OrderingPhysician,
                    Status: vm.selectedData.Status.key,
                    UserID: $sessionStorage.currentUserData.userId,
                    WorklistFlag: vm.selectedData.Worklist,
                    STATFilter: vm.selectedData.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    FromSignDate: moment().format("MM-DD-YYYY"),
                    ToSignDate: moment().format("MM-DD-YYYY"),
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: vm.selectedData.StudyPriority ? vm.selectedData.StudyPriority.Key : 'All',
                };
            } else if (vm.worklist.Type == 'A') {
                OrderListFilter = {
                    PageNum: $scope.PageNo,
                    PageSize: vm.worklist.PageSize,
                    Status: vm.selectedData.Status.key,
                    UserID: $sessionStorage.currentUserData.userId,
                    AdminWorklistIds: _.toString(vm.worklist.RuleID),
                    STATFilter: vm.selectedData.STATFilter ? "1" : "0",
                    ShowLockStudy: vm.selectedData.ShowLockStudy,
                    FromSignDate: moment().format("MM-DD-YYYY"),
                    ToSignDate: moment().format("MM-DD-YYYY"),
                    SortingByMultiColumn: SortingByMultiColumn.length > 0 ? SortingByMultiColumn : DefaultSortingColumn + ' ' + DefaultSortingDirection,
                    Priority: 'All',
                };
            }

        }

        function formatted_date(date) {
            //////////$log.log("formatted_date");
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' == (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };

        $scope.keys = {
            F12: function (name, code) {
                var selectedRowsCount = orderGridApi.selection.getSelectedCount();
                if (selectedRowsCount == 1) {
                    HideOrder();
                }
            },
            F11: function (name, code) {
                var selectedRowsCount = orderGridApi.selection.getSelectedCount();
                if (selectedRowsCount == 1) {
                    HelpOrder();
                }
                
            },
        };

        function HideOrder () {
            //////////$log.log("HideOrder");
            if ($scope.SelectedOrderID != null && $scope.SelectedOrderID.length > 0 && $scope.SelectedOrder != null &&
                ($scope.SelectedOrder.Status == 'RP' || $scope.SelectedOrder.Status == 'H') && ($scope.SelectedOrder.IsLock == false || $sessionStorage.currentUserData.userId == $scope.SelectedOrder.LockByProviderID)) {
                if ($scope.SelectedOrder.Status != "H") {

                    $scope.HideOption = 'NotRead';
                    $scope.hideHours = 2;
                    $scope.Comments = '';
                    $scope.currentWindow = "win_HideStudy";
                    $scope.isHideStudyVisible = true;
                    OpenWindow($scope.win_HideStudy, '#win_HideStudy');
                    $scope.win_HideStudy.wrapper.prev(".k-overlay").addClass("custom-overlay");
                }
                else {
                    HideUnhideOrder();
                }


            }
        };

        $scope.CancelHideStudy = function () {
            //////////$log.log("CancelHideStudy");
            $scope.win_HideStudy.close();
        };

        $scope.HideStudy = function (hideHours, Comments) {
            //////$log.log("HideStudy");
            var type = 0;
            $scope.Comments = Comments;
            $scope.hideHours = hideHours;

            if ($scope.HideOption === 'Hide' && !$scope.hideHours) {
                //alert('Please enter hour(s) to hide study.');
                return;
            }
            if ($scope.HideOption === 'NotRead') {
                type = 1;
            }
            else if ($scope.HideOption === 'NeedMoreImages') {
                type = 4;
            }
            else {
                type = ($scope.HideOption === 'Hide' ? 2 : 3);
            }

            //$scope.isLoading = true;
            //Check Study should not be today.
            WorklistService.GetCurrentDateTime().then(function (result) {
                if (formatted_date(new Date(result)) == formatted_date(new Date($scope.SelectedOrder.OrderDate))) {
                    swal({
                        title: 'Are you sure you want to remove this study from the worklist? A report has not been generated for this study and it is a current study.',
                        text: '',
                        type: "warning",
                        html: true,
                        customClass: 'swal-wide',
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Yes",
                        cancelButtonText: "No",
                    },
                        function (isConfirm) {
                            if (isConfirm) {
                                HideUnhideOrder(type);
                            }
                            else {
                                //$scope.isLoading = false;
                            }
                        });
                }
                else {
                    HideUnhideOrder(type);
                }
            });
        };

        function HideUnhideOrder(type) {
            //////$log.log("HideUnhideOrder");
            $scope.isLoading = true;
            var order = {
                OrderID: $scope.SelectedOrderID,
                IsHide: $scope.SelectedOrder.Status == 'H' ? false : true,
                Type: type,
                Min: ($scope.HideOption === 'Hide') ? parseInt($scope.hideHours) * 60 : 0,
                UserId: $sessionStorage.currentUserData.userId,
                PhysicianName: $sessionStorage.currentUserData.displayName,
                order: $scope.SelectedOrder,
                Comments: $scope.Comments
            };
            WorklistService.ShowHideOrder(order).then(function (result) {
                $scope.isLoading = false;
                if (type == 4 && $scope.Comments && $scope.Comments.length > 0) {
                    $scope.Discussion = {
                        ReferenceID: $scope.SelectedOrder.DicomOrderID,
                        Type: 1,
                        Comment: 'Need Additional Images - ' + $scope.Comments,
                        Record_Created_By: $sessionStorage.currentUserData.userId
                    };
                    $scope.SaveDiscussion();
                }

                $scope.SelectedOrderID = "";
                $scope.win_HideStudy.close();
                //$scope.refresh();
                if (type == 4) {
                    WorklistService.sendTextNotification(order);
                }

            });
        }

        function HelpOrder () {
            //////////$log.log("HelpOrder");
            if ($scope.SelectedOrder && $scope.SelectedOrder.DicomOrderID) {
                $scope.ODType = 'Assigner';
                $scope.OrderDiscussion = null;
                $('#ModalDiscussion').modal('show');
                $scope.showDiscuss = false;
                $q.all([
                    GetAllUsers($scope.SelectedOrder.SiteID)
                ]).then(function (data) {
                    $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID, 'Assigner');
                    LoadOrderDiscussionForUser();
                });
            }
        };

        function openEventLog () {
            $scope.currentWindow = 'win_OrderEventLog';
            $scope.win_OrderEventLog.open();
            $scope.win_OrderEventLog.wrapper.prev(".k-overlay").addClass("custom-overlay");
            setTimeout(function () {
                $scope.win_OrderEventLog.center();
            }, 100);
        };

        function assignToMe () {
            //$log.log('assignToMe');
            var index = $scope.contextmenuRowIndex;
            var Order = $scope.orderList[index];

            var SpecialityId = 0;
            var SpecialityCode = '';
            var filter = _.find(vm.masterData.Radiologists, function (dobj) { return dobj.Id == $sessionStorage.currentUserData.userId });
            if (filter) {
                SpecialityId = filter.SpecialityId;
                SpecialityCode = filter.SpecialityCode;
            }

            var orderDiscussionUserGroup = [];
            var userGroup = {
                ToUserID: $sessionStorage.currentUserData.userId,
                ToUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                ProviderSpecialityId: SpecialityId,
                IsUserWithSpecialityGroup: 2
            }
            orderDiscussionUserGroup.push(userGroup);
            var userOfGroup = _.filter(vm.masterData.Radiologists, function (item) { return item.SpecialityId == SpecialityId; });
            var OrderListAssignment = {
                OrderID: $scope.SelectedOrder.OrderID,
                OrderAssingedUserID: $sessionStorage.currentUserData.userId,
                OrderAssingedUserName: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                ProviderSpecialityId: SpecialityId,
                IsUserWithSpecialityGroup: 2,
                SpecialityCode: SpecialityCode,
                TotalUsersOfGroup: userOfGroup.length
            }
            Order.listOrderListAssignment.push(OrderListAssignment);


            var data = {
                OrderID: $scope.SelectedOrder.OrderID,
                FromUserID: $sessionStorage.currentUserData.userId,
                FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                OrderDiscussionUserGroup: orderDiscussionUserGroup,
                Status: 'I',
                Order: $scope.SelectedOrder
            };
            $scope.isLoading = true;
            //$log.log('assignToMe > data: ', data);
            WorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                $scope.isLoading = false;
            });

            $scope.isContextMenuVisible = false;
            $scope.isAssignedCurrentUser = true;
        };

        function unAssignToMe () {
            ////////$log.log("unAssignToMe");
            var index = $scope.contextmenuRowIndex;
            var Order = $scope.orderList[index];

            var orderDiscussionUserGroup = [];
            if (Order.listOrderListAssignment.length > 0) {

                _.each(Order.listOrderListAssignment, function (obj) {
                    var userGroup = {
                        ToUserID: obj.OrderAssingedUserID,
                        ToUser: obj.OrderAssingedUserName,
                        ProviderSpecialityId: obj.ProviderSpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);
                });
                if (!(_.filter(Order.listOrderListAssignment, function (obj) { return obj.OrderAssingedUserID === $sessionStorage.currentUserData.userId }).length > 0)) {
                    Order.listOrderListAssignment = [];
                }
                else {
                    var idx = _.findIndex(Order.listOrderListAssignment, function (order_obj) { return order_obj.OrderAssingedUserID == $sessionStorage.currentUserData.userId });
                    if (idx != -1) {
                        Order.listOrderListAssignment.splice(idx, 1);
                    }
                }
            } else {
                var SpecialityId = 0;
                var filter = _.find(vm.masterData.Radiologists, function (dobj) { return dobj.Id == $sessionStorage.currentUserData.userId });
                if (filter) {
                    SpecialityId = filter.SpecialityId;
                }

                var userGroup = {
                    ToUserID: $sessionStorage.currentUserData.userId,
                    ToUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    ProviderSpecialityId: SpecialityId
                }
                orderDiscussionUserGroup.push(userGroup);
            }
            var userId, userName, data = null;
            if (orderDiscussionUserGroup.length > 0 && !(_.filter(orderDiscussionUserGroup, function (obj) { return obj.ToUserID === $sessionStorage.currentUserData.userId }).length > 0)) {
                _.each(orderDiscussionUserGroup, function (obj) {
                    if (userId) { userId += ',' + obj.ToUserID; } else { userId = obj.ToUserID; }
                    if (userName) { userName += ';' + obj.ToUser; } else { userName = obj.ToUser; }
                });
                data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: userId,
                    FromUser: userName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'D',
                    Order: Order
                };
            }
            else {
                data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'D',
                    Order: Order
                };
            }
            $scope.isLoading = true;

            WorklistService.UnassignStudy(data).then(function (response) {
                $scope.isLoading = false;
                getData();
            });

            $scope.isContextMenuVisible = false;
            $scope.isAssignedCurrentUser = false;
        };

        function updateOrderAssign(order) {
            var orderAssignmentIndex = _.findIndex(order.listOrderListAssignment, function (assignment) { return assignment.OrderAssingedUserID == $sessionStorage.currentUserData.userId; });

            order.OrderAssingedUserID = (order.listOrderListAssignment && order.listOrderListAssignment.length > 0 ? order.listOrderListAssignment[0].OrderAssingedUserID : null);
            //order.OrderAssingedUserName = $scope.getOrderListTooltip(order);
            order.OrderAssingedUsers = (order.listOrderListAssignment ? order.listOrderListAssignment.length : 0);

            order.OrderAssingedUser = (orderAssignmentIndex != -1 ? $sessionStorage.currentUserData.userId : null);
        }

        function RemoveFromComparison (ComparisonOrderID, OrderID) {
            //////////$log.log("RemoveFromComparison");
            if (confirm("Are you sure you want remove this study from comparison?")) {
                $scope.isLoading = true;
                var comparisonOrder = {
                    ComparisonOrderID: ComparisonOrderID,
                    OrderID: OrderID,
                    UserId: $sessionStorage.currentUserData.userId
                };

                WorklistService.RemoveFromComparison(comparisonOrder).then(function (result) {
                    $scope.isLoading = false;

                    var idx = _.findIndex($scope.orderList, function (obj) { return obj.OrderID == OrderID; });
                    if (idx != -1) {
                        var compidx = _.findIndex($scope.orderList[idx].ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderID; });
                        if (compidx != -1) {
                            $scope.orderList[idx].ComparisonOrder.splice(compidx, 1);
                            $scope.SelectedOrder.subGridOptions.data.splice(compidx, 1);
                            if (orderGridApi.selection.getSelectedGridRows() != null && orderGridApi.selection.getSelectedGridRows().length > 0) {
                                orderGridApi.selection.getSelectedGridRows()[0].expandedRowHeight = orderGridApi.selection.getSelectedRows()[0].ComparisonOrder.length * $scope.RowHeight;
                            }
                            if ($scope.orderList[idx].ComparisonOrder && $scope.orderList[idx].ComparisonOrder.length == 0) {
                                $scope.orderList[idx].HasComparison = '0';
                                $scope.SelectedOrder.HasComparison = '0';
                                orderGridApi.expandable.collapseRow($scope.selectedComparisonRow.entity);
                            }

                        }
                    }
                });
            }
        };

        function viewReport(SelectedOrder, SelectedOrderAccession, ComparisionOrderList) {
            //$log.log("viewReport");
            var d = $q.defer();
            $scope.showDiscuss = true;
            $scope.isReportAvailable = false;
            $scope.orderReportList = [];
            //$scope.isLoading = true;
            $scope.OrderReport = null;
            $scope.SelectedOrderAccession = SelectedOrderAccession;
            var Hasreport = false;
            $q.all([
                //GetOrderReportByOrderID(SelectedOrder.OrderID),
                //GetComparisonOrderReportByOrderID(SelectedOrder.OrderID, ComparisionOrderList),
                GetPriorReportsByPatientMRN(SelectedOrder.OrderID, SelectedOrder.PatientMRN)
            ]).then(function (data) {
                $scope.reportList = [];
                var report = [];
                var comparisonReport = [];
                if (data != null && data.length > 0 && data[0] != null && data[0].length > 0) {
                    report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                    comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                    if (report && report.length > 0) {
                        SelectedOrder.OrderReport = report[0];
                        Hasreport = true;
                        $scope.reportList.push(SelectedOrder);
                    }

                }
                if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                    comparisonReport.forEach(function (ComparisonOrderReport) {
                        Hasreport = true;
                        var rptObject = _.filter(SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                        if (rptObject && rptObject.length > 0) {
                            rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                            rptObject[0].IsReviewable = ComparisonOrderReport.IsReviewable;
                            $scope.reportList.push(rptObject[0]);
                        } else {
                            $scope.reportList.push(ComparisonOrderReport);
                        }
                    });
                }
                $scope.OrderReport = SelectedOrder;
                $scope.reportList = _.uniq($scope.reportList);
                if ($scope.reportList && $scope.reportList.length > 0) {
                    var objSelectedReport = $scope.reportList[0];
                    if (objSelectedReport) {
                        $scope.SelectedOrderAccession = objSelectedReport.Accession;
                        LoadReport(objSelectedReport.OrderID);
                        if (Hasreport) {
                            $scope.isReportAvailable = true;
                        }
                        $scope.LoadDiscussion($scope.OrderReport.DicomOrderID, 'Discussion');
                    }
                }
                else {
                    $scope.LoadDiscussion($scope.OrderReport.DicomOrderID, 'Discussion');
                }

                //$scope.isLoading = false;
                d.resolve(true);
            });
            return d.promise;
        }

        //$scope.winModalReportNDiscussionOnOpen = function () {
        //    //////////$log.log("winModalReportNDiscussionOnOpen");
        //    //var tabStrip = $("#tabstrip").kendoTabStrip().data("kendoTabStrip");
        //    if ($scope.reportList && $scope.reportList.length > 0) {
        //        //selectPriorReportTab("#tabReport");
        //        $scope.ModalReportNDiscussionTabs[0].active = true;
        //        $scope.ModalReportNDiscussionTabs[1].active = false;
        //    } else if ($scope.OrderReport.FileCount > 0) {
        //        //selectPriorReportTab("#tabDiscussion");
        //        $scope.ModalReportNDiscussionTabs[0].active = false;
        //        $scope.ModalReportNDiscussionTabs[1].active = true;
        //        $scope.showAttachment = true;

        //    } else {
        //        if ($scope.Discussions && $scope.Discussions.length > 0) {
        //            //tabStrip.select(1);
        //            $scope.ModalReportNDiscussionTabs[0].active = false;
        //            $scope.ModalReportNDiscussionTabs[1].active = true;
        //        } else {
        //            $scope.win_ModalReportNDiscuss.close();
        //        }
        //    }
        //}

        function DeleteOpenOrder(OrderID) {
            //$log.log("DeleteOpenOrder > on: ", new Date());
            //////////$log.log("DeleteOpenOrder > $scope.LastOpenedOrderID: ", $scope.LastOpenedOrderID);
            var lastOrderID;
            var LastOpenedOrder;
            if (OrderID) {
                lastOrderID = OrderID;
                LastOpenedOrder = _.find(OrderList, { 'OrderID': OrderID });
            } else {
                lastOrderID = LastOpenedOrderID;
                LastOpenedOrder = $scope.LastOpenedOrder;
            }

            //////$log.log("DeleteOpenOrder > lastOrderID: ", lastOrderID);
            if (lastOrderID) {
                LastOpenedOrderID = null;
                $scope.LastOpenedOrder = null;
                var openOrders = {
                    OrderId: lastOrderID,
                    UserId: $sessionStorage.currentUserData.userId
                };
                WorklistService.DeleteOpenOrder(openOrders).then(function (result) {
                    if (vm.autoUpdate) {
                        if (DictationReportStatus == 'Draft') {
                            LastOpenedOrder.Status = 'D';
                            LastOpenedOrder.ReportStatus = 2;

                            LastOpenedOrder.SignBy = $scope.LoggedInUserID;
                            LastOpenedOrder.RowColorCode = getRowTemplateColorCode(LastOpenedOrder);

                            $scope.orderList = OrderList;

                            var ProcessedOrders = {
                                UserID: $scope.LoggedInUserID,
                                Type: 'DraftedOrder',
                                OrderList: [LastOpenedOrder],
                            };
                            WorklistService.ProcessedOrdersUpdate(ProcessedOrders);
                        } else if (DictationReportStatus == 'Final' || DictationReportStatus == 'Correction') {
                            LastOpenedOrder.Status = 'C';
                            LastOpenedOrder.ReportStatus = 1;

                            LastOpenedOrder.SignBy = $scope.LoggedInUserID;
                            LastOpenedOrder.RowColorCode = getRowTemplateColorCode(LastOpenedOrder);

                            $scope.orderList = OrderList;

                            var ProcessedOrders = {
                                UserID: $scope.LoggedInUserID,
                                Type: 'SignedOrder',
                                OrderList: [LastOpenedOrder],
                            };
                            WorklistService.ProcessedOrdersUpdate(ProcessedOrders);
                        }
                    }


                    //DictationReportStatus = '';
                    DictationReportState = '';
                    //$scope.LastOpenedOrder = null;
                    //$scope.DictatedAccessionNumber = '';

                });

                //////////$log.log("DeleteOpenOrder > LastOpenedOrder: ", LastOpenedOrder);
                //if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {


                //////$log.log("DeleteOpenOrder > LastOpenedOrder: ", LastOpenedOrder);
                //$log.log("DeleteOpenOrder > DictationReportState: ", DictationReportState);
                if ((LastOpenedOrder)
                    && DictationReportState == "DictateByPS360"
                    && $scope.NativeMessageResponseReportStatus != -1) {

                    var applyRadflowComplete = false;
                    if (vm.selectedData.DefaultDictationSystem.length == 0
                        || vm.selectedData.DefaultDictationSystem == 'PS360') {
                        applyRadflowComplete = true;
                    } else if ((LastOpenedOrder.DictationSystem
                        && LastOpenedOrder.DictationSystem.length == 0)
                        || LastOpenedOrder.DictationSystem == 'PS360') {
                        applyRadflowComplete = true;
                    }

                    if (applyRadflowComplete) {
                        var reportView = {
                            Site: LastOpenedOrder.Site,
                            PSSiteName: LastOpenedOrder.PSSiteName,
                            OrderID: LastOpenedOrder.OrderID,
                            Accession: LastOpenedOrder.Accession,
                            SignBy: $sessionStorage.currentUserData.userId,
                            SignByName: $sessionStorage.currentUserData.displayName,
                            ProcedureDesc: LastOpenedOrder.ProcedureDesc,
                            CheckDeficiency: (LastOpenedOrder.CheckDeficiency == 0 ? 0 : 1),
                            SignDate: $filter('CSTDateTime')(moment().format("YYYY-MM-DD HH:mm:ss")),
                            SourceSignDate: moment().format("YYYY-MM-DDTHH:mm:ss")
                        };
                        WorklistService.SaveReport(reportView).then(function (result) {
                            //////////$log.log("DeleteOpenOrder > SaveReport > result: ", result);

                        });
                    }

                }
            }
        };

        function GetAllUsers (SiteID) {
            //////////$log.log("GetAllUsers");
            var d = $q.defer();
            var filter = {
                SiteID: SiteID
            };
            WorklistService.GetRadiologistsBySite(filter).then(function (result) {
                var rads = result.radiologistsLists || result;
                vm.masterData.Radiologists = _.filter(rads || [], function (r) {
                    return _isSelf(r.Id || r.UserID) || !_hasPrelimRad(r.UserRoles || r.Roles);
                });

                var allSpecialityArr = _.map(vm.masterData.Radiologists, function (row) {
                    return row.SpecialityId;
                });
                var uniqueSpeciality = _.filter(allSpecialityArr, function (item, index, arry) { return (arry.indexOf(item) === index) });
                vm.masterData.RadiologistsGroups = [];
                var mRadiologistsGroups = [];

                _.each(uniqueSpeciality, function (obj) {

                    if (obj) {
                        var RadiologistsGroup = {};
                        RadiologistsGroup['Id'] = obj;
                        var filter = _.filter(vm.masterData.Radiologists, function (item) { return item.SpecialityId == obj; });
                        if (filter != null && filter.length > 0) {
                            RadiologistsGroup['UserName'] = filter[0].SpecialityCode;
                            RadiologistsGroup['Group'] = "YES";
                            mRadiologistsGroups.push(RadiologistsGroup);
                        }
                    }

                });

                mRadiologistsGroups.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                vm.masterData.Radiologists.sort(function (a, b) {
                    var nameA = a.UserName.toUpperCase();
                    var nameB = b.UserName.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    } else if (nameA > nameB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                mRadiologistsGroups = mRadiologistsGroups.concat(vm.masterData.Radiologists);

                vm.masterData.RadiologistsGroups = mRadiologistsGroups;

                d.resolve();
            });
            return d.promise;


        };

        function LoadOrderDiscussionForUser() {
            //////////$log.log("LoadOrderDiscussionForUser");
            $scope.orderDiscussionTooltip = '';
            var data = {
                OrderID: $scope.SelectedOrder.OrderID,
                FromUserID: $sessionStorage.currentUserData.userId
            };
            $scope.isLoading = true;
            $scope.isAssigner = true;
            $scope.OrderDiscussion = {};
            WorklistService.GetOrderDiscussionAssignment(data).then(function (response) {
                $scope.isLoading = false;
                if (response) {
                    $scope.OrderDiscussion = response;
                    $q.all([
                        GetAllUsers($scope.SelectedOrder.SiteID)
                    ]).then(function (data) {
                        $scope.OrderDiscussion.SelectedUsers = [];
                        if ($scope.OrderDiscussion.OrderAssignments && $scope.OrderDiscussion.OrderAssignments.length > 0) {
                            var allSpecialityArr = _.map($scope.OrderDiscussion.OrderAssignments, function (row) {
                                return row.ProviderSpecialityId;
                            });
                            var uniqueSpeciality = _.filter(allSpecialityArr, function (item, index, arry) { return (arry.indexOf(item) === index) });

                            _.each(uniqueSpeciality, function (obj) {
                                if (obj > 0) {
                                    var findSelectedSpeciality = _.filter($scope.OrderDiscussion.OrderAssignments, function (sUser) { return sUser.ProviderSpecialityId == obj });
                                    var findAllSpeciality = _.filter(vm.masterData.Radiologists, function (aUser) { return aUser.SpecialityId == obj });
                                    var findExistsInGroup = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 1 });
                                    var findUserOnly = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 2 });
                                    if (findUserOnly && findUserOnly.length == 0 && findSelectedSpeciality && findAllSpeciality && findSelectedSpeciality.length > 0 && findAllSpeciality.length > 0 && findSelectedSpeciality.length == findAllSpeciality.length) {
                                        $scope.OrderDiscussion.SelectedUsers = $scope.OrderDiscussion.SelectedUsers.concat(findAllSpeciality);
                                        if (findExistsInGroup && findExistsInGroup.length > 0) {
                                            _.each(findExistsInGroup, function (user) {
                                                var findUser = _.find($scope.OrderDiscussion.SelectedUsers, function (aUser) { return aUser.Id == user.ProviderID });
                                                if (findUser) {
                                                    findUser.IsUserWithSpecialityGroup = 1;
                                                }
                                            });
                                        }
                                    } else {
                                        if ((findUserOnly && findUserOnly.length > 0) || (findExistsInGroup && findExistsInGroup.length > 0)) {
                                            if (findUserOnly && findUserOnly.length > 0) {
                                                _.each(findUserOnly, function (user) {
                                                    var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == user.ProviderID });
                                                    if (findUser) {
                                                        findUser.IsUserWithSpecialityGroup = 2;
                                                        $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                    }
                                                });
                                            }
                                            if (findExistsInGroup && findExistsInGroup.length > 0) {
                                                _.each(findExistsInGroup, function (user) {
                                                    var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == user.ProviderID });
                                                    if (findUser) {
                                                        findUser.IsUserWithSpecialityGroup = 1;
                                                        $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                    }
                                                });
                                            }
                                        } else {
                                            if (findSelectedSpeciality && findSelectedSpeciality.length > 0) {
                                                _.each(findSelectedSpeciality, function (speciality) {
                                                    var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == speciality.ProviderID });
                                                    $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                });
                                            }
                                        }


                                    }
                                }
                            });

                            var filterUsers = _.filter($scope.OrderDiscussion.OrderAssignments, function (obj) { return obj.ProviderSpecialityId == 0 });
                            if (filterUsers && filterUsers.length > 0) {
                                _.each(filterUsers, function (obj) {
                                    var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == obj.ProviderID });
                                    if (findUser) {
                                        $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                    }
                                });
                            }

                            setTimeout(function () {
                                $scope.isAssigner = false;
                                setOrderDiscussionUserGroup().then(function (data) {
                                    setOrderDiscussionTooltip();
                                });
                            }, 100);
                        }
                        if ($scope.OrderDiscussion.SelectedUsers && $scope.OrderDiscussion.SelectedUsers.length == 0 && $scope.OrderDiscussion.OrderDiscussionUserGroup && $scope.OrderDiscussion.OrderDiscussionUserGroup.length > 0) {
                            var allSpecialityArr = _.map($scope.OrderDiscussion.OrderDiscussionUserGroup, function (row) {
                                return row.ProviderSpecialityId;
                            });
                            var uniqueSpeciality = _.filter(allSpecialityArr, function (item, index, arry) { return (arry.indexOf(item) === index) });

                            _.each(uniqueSpeciality, function (obj) {
                                if (obj > 0) {
                                    var findSelectedSpeciality = _.filter($scope.OrderDiscussion.OrderDiscussionUserGroup, function (sUser) { return sUser.ProviderSpecialityId == obj });
                                    var findAllSpeciality = _.filter(vm.masterData.Radiologists, function (aUser) { return aUser.SpecialityId == obj });
                                    var findExistsInGroup = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 1 });
                                    var findUserOnly = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 2 });
                                    if (findUserOnly && findUserOnly.length == 0 && findSelectedSpeciality && findAllSpeciality && findSelectedSpeciality.length > 0 && findAllSpeciality.length > 0 && findSelectedSpeciality.length == findAllSpeciality.length) {
                                        $scope.OrderDiscussion.SelectedUsers = $scope.OrderDiscussion.SelectedUsers.concat(findAllSpeciality);
                                        if (findExistsInGroup && findExistsInGroup.length > 0) {
                                            _.each(findExistsInGroup, function (user) {
                                                var findUser = _.find($scope.OrderDiscussion.SelectedUsers, function (aUser) { return aUser.Id == user.ProviderID });
                                                if (findUser) {
                                                    findUser.IsUserWithSpecialityGroup = 1;
                                                }
                                            });
                                        }
                                    } else {
                                        if ((findUserOnly && findUserOnly.length > 0) || (findExistsInGroup && findExistsInGroup.length > 0)) {
                                            if (findUserOnly && findUserOnly.length > 0) {
                                                _.each(findUserOnly, function (user) {
                                                    var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == user.ToUserID });
                                                    if (findUser) {
                                                        findUser.IsUserWithSpecialityGroup = 2;
                                                        $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                    }
                                                });
                                            }
                                            if (findExistsInGroup && findExistsInGroup.length > 0) {
                                                _.each(findExistsInGroup, function (user) {
                                                    var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == user.ToUserID });
                                                    if (findUser) {
                                                        findUser.IsUserWithSpecialityGroup = 1;
                                                        $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                    }
                                                });
                                            }
                                        } else {
                                            if (findSelectedSpeciality && findSelectedSpeciality.length > 0) {
                                                _.each(findSelectedSpeciality, function (speciality) {
                                                    var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == speciality.ProviderID });
                                                    $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                });
                                            }
                                        }


                                    }
                                }
                            });

                            var filterUsers = _.filter($scope.OrderDiscussion.OrderDiscussionUserGroup, function (obj) { return obj.ProviderSpecialityId == 0 });
                            if (filterUsers && filterUsers.length > 0) {
                                _.each(filterUsers, function (obj) {
                                    var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == obj.ToUserID });
                                    if (findUser) {
                                        $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                    }
                                });
                            }

                            setTimeout(function () {
                                $scope.isAssigner = false;
                                setOrderDiscussionUserGroup().then(function (data) {
                                    setOrderDiscussionTooltip();
                                });
                            }, 100);
                        }
                        if ($scope.OrderDiscussion.OrderAssignment) {
                            var list = _.filter(vm.masterData.Radiologists, function (obj) { return $scope.OrderDiscussion.OrderAssignment.ProviderID == obj.Id; });
                            if (list && list.length > 0) {
                                $scope.OrderDiscussion.SelectedUser = list[0];
                                $scope.isAssigner = false;
                            }
                        }
                        var list = _.filter(vm.masterData.Radiologists, function (obj) { return $scope.OrderDiscussion.ToUserID == obj.Id; });
                        if (list && list.length > 0) {
                            $scope.OrderDiscussion.SelectedUser = list[0];
                            $scope.isAssigner = false;
                        }
                    });
                    if ($scope.OrderDiscussion.ID
                        && $scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId
                        && $scope.OrderDiscussion.Status == 'A') {
                        $scope.OrderDiscussion.Status = 'C';
                        WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                        });
                    }
                } else {
                    GetAllUsers($scope.SelectedOrder.SiteID)
                }
            });
        }

        function setOrderDiscussionUserGroup() {
            var d = $q.defer();
            ////////$log.log("setOrderDiscussionUserGroup");
            var ddt = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            var allSpecialityArr = _.map($scope.OrderDiscussion.SelectedUsers, function (row) {
                return row.SpecialityId;
            });
            var uniqueSpeciality = _.filter(allSpecialityArr, function (item, index, arry) { return (arry.indexOf(item) === index) });

            var usergroups = [];

            _.each(uniqueSpeciality, function (obj) {
                if (obj > 0) {
                    var findSelectedSpeciality = _.filter($scope.OrderDiscussion.SelectedUsers, function (sUser) { return sUser.SpecialityId == obj });
                    var findAllSpeciality = _.filter(vm.masterData.Radiologists, function (aUser) { return aUser.SpecialityId == obj });
                    var findExistsInGroup = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 1 });
                    var findUserOnly = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 2 });
                    if (findUserOnly.length == 0 && findSelectedSpeciality && findAllSpeciality && findSelectedSpeciality.length > 0 && findAllSpeciality.length > 0 && findSelectedSpeciality.length == findAllSpeciality.length) {
                        usergroups.push(obj);
                        if (findExistsInGroup && findExistsInGroup.length > 0) {
                            _.each(findExistsInGroup, function (user) {
                                usergroups.push(user.Id);
                            });
                        }
                    } else {
                        if (findUserOnly.length > 0 || findExistsInGroup.length > 0) {
                            if (findUserOnly && findUserOnly.length > 0) {
                                _.each(findUserOnly, function (user) {
                                    usergroups.push(user.Id);
                                });
                            }
                            if (findExistsInGroup && findExistsInGroup.length > 0) {
                                _.each(findExistsInGroup, function (user) {
                                    usergroups.push(user.Id);
                                });
                            }
                        } else {
                            if (findSelectedSpeciality && findSelectedSpeciality.length > 0) {
                                _.each(findSelectedSpeciality, function (speciality) {
                                    usergroups.push(speciality.Id);
                                });
                            }
                        }


                    }
                }
            });

            var filterUsers = _.filter($scope.OrderDiscussion.SelectedUsers, function (obj) { return obj.SpecialityId == 0 });
            if (filterUsers && filterUsers.length > 0) {
                _.each(filterUsers, function (obj) {
                    usergroups.push(obj.Id);
                });
            }
            if (ddt) {
                ddt.value(usergroups);
            }
            d.resolve();
            return d.promise;
        }

        function setOrderDiscussionTooltip() {
            ////////$log.log("setOrderDiscussionTooltip");
            if ($scope.OrderDiscussion.SelectedUsers && $scope.OrderDiscussion.SelectedUsers.length > 0) {
                $scope.orderDiscussionTooltip = '';

                var allSpecialityArr = _.map($scope.OrderDiscussion.SelectedUsers, function (row) {
                    return row.SpecialityId;
                });
                var uniqueSpeciality = _.filter(allSpecialityArr, function (item, index, arry) { return (arry.indexOf(item) === index) });

                _.each(uniqueSpeciality, function (obj) {
                    if (obj > 0) {
                        var findSelectedSpeciality = _.filter($scope.OrderDiscussion.SelectedUsers, function (sUser) { return sUser.SpecialityId == obj });
                        var findAllSpeciality = _.filter(vm.masterData.Radiologists, function (aUser) { return aUser.SpecialityId == obj });
                        var findExistsInGroup = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 1 });
                        var findUserOnly = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 2 });
                        if (findUserOnly.length == 0 && findSelectedSpeciality && findAllSpeciality && findSelectedSpeciality.length > 0 && findAllSpeciality.length > 0 && findSelectedSpeciality.length == findAllSpeciality.length) {
                            $scope.orderDiscussionTooltip += findSelectedSpeciality[0].SpecialityCode + "\n";
                        } else {
                            if (findUserOnly.length > 0 || findExistsInGroup.length > 0) {
                                if (findUserOnly && findUserOnly.length > 0) {
                                    _.each(findUserOnly, function (user) {
                                        $scope.orderDiscussionTooltip += user.UserName + "\n";
                                    });
                                }
                                if (findExistsInGroup && findExistsInGroup.length > 0) {
                                    _.each(findExistsInGroup, function (user) {
                                        $scope.orderDiscussionTooltip += user.UserName + "\n";
                                    });
                                }
                            } else {
                                if (findSelectedSpeciality && findSelectedSpeciality.length > 0) {
                                    _.each(findSelectedSpeciality, function (speciality) {
                                        $scope.orderDiscussionTooltip += speciality.UserName + "\n";
                                    });
                                }
                            }


                        }
                    }
                });

                var filterUsers = _.filter($scope.OrderDiscussion.SelectedUsers, function (obj) { return obj.SpecialityId == 0 });
                if (filterUsers && filterUsers.length > 0) {
                    _.each(filterUsers, function (obj) {
                        $scope.orderDiscussionTooltip += obj.UserName + "\n";
                    });
                }
            }
            else {
                $scope.orderDiscussionTooltip = '';
            }
            angular.element(document).ready(function () {
                angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "hidden");
                if ($scope.orderDiscussionTooltip.length > 0) {
                    angular.element('#OrderDiscussionAssignmentTooltip').css("visibility", "visible");
                }

            });
        }

        $scope.getOrderDiscussionOptions = function () {
            ////////$log.log("getOrderDiscussionOptions");
            var options = {
                template: kendo.template($("#dropdowntree-orderdiscussion-template").html()),
                placeholder: 'Select User / Group',
                checkboxes: {
                    checkChildren: true
                },
                autoClose: false,
                dataSource: vm.masterData.RadiologistsGroups,
                dataTextField: "UserName",
                dataValueField: "Id",
                height: "auto",
                loadOnDemand: false,
                headerTemplate: '<span class="k-list-filter"><input class="k-textbox" role="listbox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-disabled="false" id="ddstOrderDiscussion" autocomplete="off"/><span class="k-icon k-i-zoom"></span></span>',
                filtering: function (e) {
                    //get filter descriptor
                    var filter = e.filter;
                    // handle the event
                },
                open: function (e) {
                    $("#ddstOrderDiscussion").change(refreshTreeOrderDiscussion).keyup(refreshTreeOrderDiscussion);
                    setTimeout(function () {
                        $("#ddstOrderDiscussion").focus();
                    }, 1500);

                    $("#ddstOrderDiscussion").val('');
                    var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
                    if (drtr) {
                        var tree = drtr.treeview;
                        var dataSource = drtr.dataSource;
                        dataSource.filter({});
                        setTimeout(function () {
                            tree.collapse(".k-item");
                        }, 1000);
                    }


                },
                change: function (e) {
                    ClearAll();
                    var nodes = e.sender.dataSource.view();

                    var checkedNodes = e.sender.value();

                    var values = checkedNodeValues(nodes, checkedNodes);
                    var selectedUsers = [];
                    $scope.OrderDiscussion.SelectedUsers = [];

                    _.each(values, function (obj) {
                        if (obj) {
                            var filter = _.find(vm.masterData.RadiologistsGroups, function (dobj) { return dobj.Id == obj });
                            if (filter && filter.Group && filter.Group == "YES") {
                                var filterUsers = _.filter(vm.masterData.Radiologists, function (user) { return user.SpecialityId == filter.Id });
                                if (filterUsers && filterUsers.length > 0) {
                                    _.each(filterUsers, function (user) {
                                        user.IsUserWithSpecialityGroup = 0;
                                        var findDuplicate = _.find(selectedUsers, function (auser) { return auser.Id == user.Id });
                                        if (findDuplicate) {
                                            findDuplicate.IsUserWithSpecialityGroup = 1;
                                        }
                                        selectedUsers.push(user);
                                    });
                                }

                            } else {
                                var findUser = _.find(vm.masterData.Radiologists, function (user) { return user.Id == obj });
                                var findDuplicate = _.find(selectedUsers, function (user) { return user.Id == obj });
                                if (findDuplicate) {
                                    findDuplicate.IsUserWithSpecialityGroup = 1;
                                } else {
                                    if (findUser) {
                                        findUser.IsUserWithSpecialityGroup = 2;
                                        selectedUsers.push(findUser);
                                    }
                                }
                            }


                        }
                    });


                    var allUsers = _.map(selectedUsers, function (row) {
                        return row.Id;
                    });
                    var uniqueUsers = _.filter(allUsers, function (item, index, arry) { return (arry.indexOf(item) === index) });
                    _.each(uniqueUsers, function (user) {
                        var findUser = _.find(vm.masterData.Radiologists, function (radiologist) { return radiologist.Id == user });
                        var filterUser = _.filter(selectedUsers, function (selectedUser) { return selectedUser.Id == user });
                        var filterDuplicate = _.filter(filterUser, function (user) { return user.IsUserWithSpecialityGroup && user.IsUserWithSpecialityGroup == 1 });
                        var filterUserOnly = _.filter(filterUser, function (user) { return user.IsUserWithSpecialityGroup && user.IsUserWithSpecialityGroup == 2 });
                        if (findUser) {
                            if (filterDuplicate && filterDuplicate.length > 0) {
                                findUser.IsUserWithSpecialityGroup = 1;
                            }
                            $scope.OrderDiscussion.SelectedUsers.push(findUser);
                        }
                    });


                    setOrderDiscussionTooltip();

                },
            };
            return options;
        }

        function refreshTreeOrderDiscussion() {
            ////////$log.log("refreshTreeOrderDiscussion");
            var drtr = $("#kddtOrderDiscussion").data("kendoDropDownTree");
            var tree = drtr.treeview;
            var dataSource = drtr.dataSource;
            var value = $("#ddstOrderDiscussion").val();
            if (value !== "") {
                dataSource.filter({
                    field: "UserName", //if I would use "ChildrenText" here nothing be displayed at all if filtertext is set
                    operator: "contains",
                    value: $("#ddstOrderDiscussion").val()
                });

                //filtering child node
                if (dataSource.view().length > 0) {
                    for (var i = 0; i < dataSource.view().length; i++) {
                        if (dataSource.view()[i].hasChildren) {
                            dataSource.view()[i].children.filter({
                                field: "UserName",
                                operator: "neq",
                                value: true
                            })
                        }
                    }
                }

                setTimeout(function () {
                    tree.expand(".k-item");
                }, 200);
            } else {
                dataSource.filter({});

                setTimeout(function () {
                    tree.collapse(".k-item");
                }, 200);
            }
            angular.element(document).ready(function () {
                angular.element('.k-item').mouseenter(function () {
                    if (tree) {
                        tree.focus();
                    }
                });

            });
        }

        function ClearAll() {
            //////////$log.log("ClearAll");
            $(".k-check-all").on("click", function () {

                if ($('.k-checkbox').is(':checked') == false) {

                    $scope.SelectedList.Site = null;
                    $scope.SelectedList.Location = null;
                    $scope.locationtooltip = 'Select a Location';

                    $('.k-multiselect-wrap li').remove();
                }
            })
        }

        function checkedNodeValues(nodes, checkedNodes) {
            //////////$log.log("checkedNodeValues");
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].checked && !nodes[i].hasChildren) {
                    if (checkedNodes.indexOf(nodes[i].value) < 0) {
                        checkedNodes.push(nodes[i].value);
                    }
                }
                if (nodes[i].hasChildren) {
                    checkedNodeValues(nodes[i].children.view(), checkedNodes);
                }
            }
            return checkedNodes;
        }

        $scope.AssignStudy = function () {
            //////////$log.log("AssignStudy");
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];
                $scope.SelectedOrder.listOrderListAssignment = [];

                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_STUDY_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var userOfGroup = _.filter(vm.masterData.Radiologists, function (item) { return item.SpecialityId == obj.SpecialityId; });

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode,
                        TotalUsersOfGroup: userOfGroup.length
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });


                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'I',
                    Order: $scope.SelectedOrder
                };
                //$scope.isLoading = true;


                WorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                    LoadOrderDiscussionForUser();
                    $scope.SaveDiscussionFlag = false;
                });
            }
        };

        $scope.SaveDiscussion = function () {
            //////////$log.log("SaveDiscussion");
            $scope.isLoading = true;
            if ($scope.OrderDiscussion && $scope.OrderDiscussion.SelectedUsers) {
                $scope.SaveDiscussionFlag = true;
                $scope.AssignStudy();
            }
            if ($scope.Discussion.Comment) {
                $scope.SaveDiscussionFlag = true;
                WorklistService.SetDiscussion($scope.Discussion).then(function (response) {
                    $scope.SelectedOrder.IsDiscussion = true;
                    $scope.showDiscuss = false;
                    LoadDiscussion(response);
                    $scope.Discussion.Comment = null;
                    $scope.SaveDiscussionFlag = false;
                });
            }
            $scope.isLoading = false;
        };

        function SortFilter (OrderByField) {
            //////$log.log("SortFilter");
            if (!validateDOS(true)) return;

            clear();
            $q.all([
                getData()
            ]).then(function (data) {
                var pages = $scope.TotalRows / vm.worklist.PageSize;
                orderGridApi.infiniteScroll.resetScroll($scope.PageNo > 1, $scope.PageNo < pages);
            });
        };

        $scope.SaveChildDiscussion = function (discussion) {
            //////////$log.log("SaveChildDiscussion");
            if (discussion.ChildComment) {
                var Objdiscussion = {
                    ReferenceID: discussion.ID,
                    Type: 0,
                    Comment: discussion.ChildComment,
                    Record_Created_By: $sessionStorage.currentUserData.userId
                };
                if (discussion.Record_Created_By != $sessionStorage.currentUserData.userId) {
                    NotifyToUser(__env._NOTIFY_MSG_, $scope.SelectedOrder.OrderID, discussion.Record_Created_By, "N");
                }
                $scope.isLoading = true;
                WorklistService.SetDiscussion(Objdiscussion).then(function (response) {
                    $scope.isLoading = false;
                    discussion.IsChild = false;
                    discussion.ChildComment = '';
                    $scope.AllDiscussions.push(response);
                    bindChildDiscussion(response);
                });
            }
        };

        function bindChildDiscussion(ObjDiscussion) {
            //////////$log.log("LoadChildDiscussion");
            angular.forEach($scope.Discussions, function (obj, idx) {
                LoadChildDiscussion(obj);
            });
        }

        function prepareChildDiscussionHTML (discussion, sender) {
            var htmlpop = '';
            if (discussion.Childs && discussion.Childs.length > 0) {
                _.each(discussion.Childs, function (childdiscussion) {
                    var childName = _discussionDisplayName(childdiscussion);
                    if (sender) {
                        htmlpop = htmlpop + '<div class="replaysection mr-15px w-80 pull-left">' +
                            '<div style="background-color: #2F4858 !important;" ' +
                            'class="comment pos-rel border text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    } else {
                        htmlpop = htmlpop + '<div class="replayreceiver mr-15px w-80 pull-right">' +
                            '<div style="background-color: #6c6868 !important;" ' +
                            'class="comment receiverborder pos-rel text-right fs-12px fw-500 bor-rad-4px my-2px mx-5px w-100 ' +
                            'float-left py-5px px-8px">' +
                            '<div class="txt-clr-14 no-bg text-left fs-12 fw-600 p-2px-all m-0 w-100 bor-rad-4px">' +
                            (childName ? '<span class="glyphicon glyphicon-share-alt mr-5px fs-14px"></span>' + childName : '') + '</div>' +
                            '<div class="txt-clr-1 text-left">' + childdiscussion.Comment + '</div>' +
                            '<div style=" color: #a2a2a2 !important;" ' +
                            'class="no-bg text-left fs-12px fw-500 p-2px-all bor-rad-4px m-0 foat-left w-100">' + $filter('localDate')(childdiscussion.Record_Created_At, false) + '</div>' +
                            '</div></div>';
                    }

                    htmlpop = htmlpop + prepareChildDiscussionHTML(childdiscussion, sender);
                });
            }
            return htmlpop;
        }

        $scope.showFileList = function () {
            //////////$log.log("showFileList");
            $scope.showAttachment = true;
            $scope.ReferenceID = $scope.Discussion.ReferenceID;
        }

        $scope.hideFileList = function () {
            //////////$log.log("hideFileList");
            $scope.showAttachment = false;
        }

        $scope.spiltPhoneNumber = function (phone) {
            //////////$log.log("spiltPhoneNumber");
            if (phone) {
                return phone.split(',');
            }
            else {
                return null;
            }
        }

        function changeDateFormat(date) {
            //////////$log.log("changeDateFormat");
            if (date) {
                return moment(new Date(date)).format("MM/DD/YYYY");
            }
        }

        //$scope.OpenDiscussion = function (referenceID) {
        //    //////////$log.log("OpenDiscussion");
        //    $scope.ODType = 'Discussion';
        //    $scope.LoadDiscussion(referenceID, 'Discussion');
        //};

        $scope.SaveReviewOrder = function () {
            //////////$log.log("SaveReviewOrder");
            //$scope.isLoading = true;
            WorklistService.UpdateReviewOrder($scope.ReviewOrder).then(function (result) {
                ////$scope.isLoading = false;
                $scope.SelectedOrder.Rating = $scope.ReviewOrder.Rating;
                $scope.SelectedOrder.Comments = $scope.ReviewOrder.Comments;
                $scope.SelectedOrder.IsInterestingCase = $scope.ReviewOrder.IsInterestingCase;
                $scope.SelectedOrder.Keywords = $scope.ReviewOrder.Keywords;

                var index = _.findIndex($scope.orderReportList, function (obj) {
                    return obj.OrderID == $scope.ReviewOrder.OrderID;
                });
                if (index != -1)
                    $scope.orderReportList[index] = $scope.ReviewOrder;

                //$scope.refresh();
            });
        }

        $scope.CloseOrderDiscussion = function () {
            //////////$log.log("CloseOrderDiscussion");
            if ($scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId) {
                $scope.OrderDiscussion.Status = 'C';
                _.each($scope.OrderDiscussion.OrderDiscussionUserGroup, function (obj) {
                    NotifyToUser(__env._CLOSE_MSG_, $scope.SelectedOrder.OrderID, obj.ToUserID, null);
                });

            } else {
                NotifyToUser(__env._ANS_MSG_, $scope.SelectedOrder.OrderID, $scope.OrderDiscussion.FromUserID, null);
            }
            WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                /*
                 * Modified By: Tejas Parikh
                 * Task:        Bug 21731: Close discussion button is not working
                 */
                if ($scope.showDiscuss) {
                    $scope.win_ModalReportNDiscuss.close();
                }
                else {
                    $scope.win_Discussion.close();
                }
            });
        };

        $scope.SaveOrderDiscussion = function () {
            //////////$log.log("SaveOrderDiscussion");
            if ($scope.OrderDiscussion.SelectedUsers) {
                var orderDiscussionUserGroup = [];
                $scope.SelectedOrder.listOrderListAssignment = [];

                _.each($scope.OrderDiscussion.SelectedUsers, function (obj) {
                    var userGroup = {
                        ToUserID: obj.Id,
                        ToUser: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup
                    }
                    orderDiscussionUserGroup.push(userGroup);

                    NotifyToUser(__env._ASSIGN_MSG_, $scope.SelectedOrder.OrderID, obj.Id, null);

                    var OrderListAssignment = {
                        OrderID: $scope.SelectedOrder.OrderID,
                        OrderAssingedUserID: obj.Id,
                        OrderAssingedUserName: obj.LastName + ', ' + obj.FirstName,
                        ProviderSpecialityId: obj.SpecialityId,
                        IsUserWithSpecialityGroup: obj.IsUserWithSpecialityGroup,
                        SpecialityCode: obj.SpecialityCode
                    }
                    $scope.SelectedOrder.listOrderListAssignment.push(OrderListAssignment);
                });


                var data = {
                    OrderID: $scope.SelectedOrder.OrderID,
                    FromUserID: $sessionStorage.currentUserData.userId,
                    FromUser: $sessionStorage.currentUserData.LastName + ', ' + $sessionStorage.currentUserData.FirstName,
                    OrderDiscussionUserGroup: orderDiscussionUserGroup,
                    Status: 'O'
                };
                //$scope.isLoading = true;


                WorklistService.SetOrderDiscussionAssignment(data).then(function (response) {
                    $scope.SaveDiscussion();
                    LoadOrderDiscussionForUser();
                });
            }
        };

        $scope.showReport = function (SelectedOrder) {
            //////////$log.log("showReport");
            //$scope.isLoading = true;
            $scope.OrderReport = SelectedOrder;
            $scope.SelectedOrderAccession = SelectedOrder.Accession;
            LoadReport(SelectedOrder.OrderID);
        }

        function resetComparisonGrid() {
            if (comparisonOrderGridApi) {
                var cols = [];
                var gridColumns = comparisonOrderGridApi.grid.columns;
                _.each(_.clone(columnDefs), function (col) {
                    var gridCol = _.find(gridColumns, { 'field': col.name });
                    gridCol.width = col.width;
                    gridCol.colDef.width = col.width;
                    cols.push(gridCol);
                });
                gridColumns.length = 0;
                gridColumns.push.apply(gridColumns, cols);
                comparisonOrderGridApi.grid.columns = gridColumns;
                comparisonOrderGridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
            }
        }

        $scope.OpenVR = function (order, isSingleView) {
            var _correlationId = Date.now();
            logPacsEvent('[' + _correlationId + '] Step1-WorklistGrid-CIVR: viewer=CIVR');
            if (isSingleView) {
                var openOrders = {
                    OrderId: order.OrderID,
                    ProviderID: $scope.LoggedInUserID
                };
                WorklistService.VerfiyReadStudy(openOrders).then(function (result) {
                    if (result.openOrders && result.openOrders.length > 0) {
                        confirm("This order is presently being dictated by user " + result.openOrders[0].ProviderName + ".\nCaution: Proceeding will create another report.");
                        return;
                    }
                    else {
                        $rootScope.$broadcast('event.OpenVR', { order: order, isSingleView: isSingleView, correlationId: _correlationId });
                    }
                });
            }
            else {
                $rootScope.$broadcast('event.OpenVR', { order: order, isSingleView: isSingleView, correlationId: _correlationId });
            }
        }

        //--------
        function PrevRec () {
            ////$log.log("PrevRec");
            if ($scope.SingReport.Order) {
                var idx = _.findIndex($scope.SingReport.OrderList, function (a) { return a.OrderID == $scope.SingReport.Order.OrderID });
                if (idx != -1)
                    idx = idx - 1;
                var openOrders = {
                    OrderId: $scope.SingReport.OrderList[idx].OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId
                };
                WorklistService.GetOpenOrder(openOrders).then(function (result) {
                    if (result && result.length > 0) {
                        PrevRec();
                        return;
                    }
                    else {
                        $scope.SingReport.Order = $scope.SingReport.OrderList[idx];
                        $scope.setSelected($scope.SingReport.Order.OrderID, $scope.SingReport.Order);
                        if (LastOpenedOrderID != null) {
                            removeOrderFromList(LastOpenedOrderID);
                            DeleteOpenOrder();
                        }
                        InsertOpenOrder();
                        SetSignREportModal($scope.SingReport.Order, $scope.SingReport.OrderList);
                    }
                });
            }
            else {
                $scope.win_SingReport.close();
            }
        };

        function NextRec () {
            //$log.log("NextRec > on: ", new Date());
            var idx = _.findIndex($scope.SingReport.OrderList, function (a) { return a.OrderID == $scope.SingReport.Order.OrderID });
            if (idx < $scope.SingReport.OrderList.length - 1) {
                idx = idx + 1;
                $scope.SingReport.Order = $scope.SingReport.OrderList[idx];
                var openOrders = {
                    OrderId: $scope.SingReport.OrderList[idx].OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId
                };
                //$log.log($scope.SingReport.CurrentSite);
                WorklistService.GetOpenOrder(openOrders).then(function (result) {
                    if (result && result.length > 0) {
                        NextRec();
                    }
                    else {
                        if (LastOpenedOrderID != null) {
                            removeOrderFromList(LastOpenedOrderID);
                            DeleteOpenOrder();
                        }
                        InsertOpenOrder();
                        $scope.currentWindow = "win_SingReport";
                        $scope.win_SingReport.open();
                        $scope.win_SingReport.wrapper.prev(".k-overlay").addClass("custom-overlay");
                        $timeout(function () {
                            $scope.win_SingReport.center();
                        }, 100);
                        SetSignREportModal($scope.SingReport.Order, $scope.SingReport.OrderList);
                    }
                });
            }
            else {
                $scope.win_SingReport.close();
                $scope.win_ModalReportNDiscuss.close();
                $scope.win_Discussion.close();
                if (!vm.worklist.OpenClipboardNextStudy) {
                    var pages = $scope.TotalRows / vm.worklist.PageSize;
                    if ($scope.PageNo < pages) {
                        $scope.PageNo++;
                        $q.all([
                            refresh()
                        ]).then(function (data) {
                            $scope.SingReport.OrderList = _.concat($scope.SingReport.OrderList, data[0]);
                            sortByField();

                            var uniqueOrderList = _.uniqBy($scope.SingReport.OrderList, 'OrderID');
                            $scope.SingReport.OrderList = uniqueOrderList;

                            NextRec();
                        });
                    }

                }


            }
        };
        $scope.SignAndNextRec = function () {
            ////////$log.log("SignAndNextRec");
            //$log.log("SignAndNextRec");
            //SignReport("NEXT");
            NextRec();
        };
        $scope.SignAndPrevRec = function () {
            ////////$log.log("SignAndPrevRec");
            //SignReport("PREV");
            //$log.log("SignAndPrevRec");
            PrevRec();
        };
        function SignReport (navFlag, NativeMessageResponse) {
            //$log.log("SignReport > on: ", new Date());
            //$log.log("SignReport > navFlag: ", navFlag);
            //$log.log("SignReport > DictatedAccessionNumber: ", DictatedAccessionNumber);

            $scope.win_ModalReportNDiscuss.close();
            $scope.win_Discussion.close();

            if (DictatedAccessionNumber.length > 0) {
                DuplicateAccession = false;
                if (DictatedAccessionNumber[DictatedAccessionNumber.length - 1] == DictatedAccessionNumber[DictatedAccessionNumber.length - 2]) {
                    //DictatedAccessionNumber.splice(DictatedAccessionNumber.length - 1);
                    DictatedAccessionNumber.pop();
                    DuplicateAccession = true;
                    return;
                }

                //$log.log("SignReport > DuplicateAccession: ", DuplicateAccession);
                if (!DuplicateAccession
                    && NativeMessageResponse.reportResponseDetails.accessionNumbers == OpenedAccessionNumber) {
                    DictationReportStatus = NativeMessageResponse.reportResponseDetails.reportStatus == 2 ? 'Draft' : NativeMessageResponse.reportResponseDetails.reportStatus == 8 ? 'Final' : '';
                    $scope.NativeMessageResponseReportStatus = NativeMessageResponse.reportResponseDetails.reportStatus;

                    var SignedOrDrafted = true;
                    if ($scope.NativeMessageResponseReportStatus == -1) {
                        SignedOrDrafted = false;
                    } else if ($scope.NativeMessageResponseReportStatus == 0) {
                        SignedOrDrafted = false;
                    }
                    //$scope.isLoading = true;

                    $scope.navFlag = navFlag;

                    ////$log.log("SignReport > $scope.NativeMessageResponseReportStatus: ", $scope.NativeMessageResponseReportStatus);
                    ////$log.log("SignReport > $scope.LastOpenedOrderID: ", $scope.LastOpenedOrderID);

                    if (SignedOrDrafted) {
                        removeOrderFromList(LastOpenedOrderID);
                        $scope.NativeMessageResponseReportStatus = -2;
                    }


                    DictationReportState = "DictateByPS360";

                    $scope.SingbtnDisabled = true;
                    var psuserFilter = {
                        UserId: $sessionStorage.currentUserData.userId,
                        SiteID: $scope.SingReport.Order.SiteID,
                        LocationID: $scope.SingReport.Order.LocationID,
                        InstitutionID: $scope.SingReport.Order.InstitutionID
                    };
                    var _psUserCacheKey = 'PSUserBySite_' + psuserFilter.SiteID + '_' + psuserFilter.LocationID + '_' + psuserFilter.InstitutionID;
                    var _psUserCached = $sessionStorage[_psUserCacheKey];
                    var _checkPSUser = _psUserCached
                        ? $q.resolve(_psUserCached)
                        : WorklistService.CheckPSUserBySite(psuserFilter).then(function (res) {
                            if (res && res.length > 0 && !(res[0].CreateORU == true && res[0].IsValid.toString().toUpperCase() == "FALSE")) {
                                $sessionStorage[_psUserCacheKey] = res;
                            }
                            return res;
                        });
                    _checkPSUser.then(function (result) {
                        $scope.PSUser = result;
                        $scope.SingbtnDisabled = false;
                        if ($scope.PSUser == null || $scope.PSUser.length <= 0 || ($scope.PSUser[0].CreateORU == true && $scope.PSUser[0].IsValid.toString().toUpperCase() == "FALSE")) {
                            $scope.PSUser.Username = $scope.PSUser != null && $scope.PSUser.length > 0 ? $scope.PSUser[0].UserName : "";
                            //$scope.isLoading = false;
                            $scope.currentWindow = "win_PSUser";
                            $scope.win_PSUser.open();
                            $scope.win_PSUser.wrapper.prev(".k-overlay").addClass("custom-overlay");
                            $timeout(function () {
                                $scope.win_PSUser.center();
                            }, 100);
                            if ($scope.PSUser && $scope.PSUser.length > 0) { swal("Please update your password."); }
                        } else {
                            //$log.log("SignReport > NativeMessageResponseReportStatus: ", $scope.NativeMessageResponseReportStatus);
                            if (SignedOrDrafted) {
                                if (!vm.selectedData.ChooseNextStudy
                                    || !vm.worklist.OpenClipboardNextStudy) {
                                    if (navFlag == "NEXT") {
                                        NextRec();
                                    }
                                    else if (navFlag == "PREV") {
                                        PrevRec();
                                    }

                                }

                            } else {
                                $scope.win_SingReport.close();
                            }
                            DeleteOpenOrder();
                        }

                    });
                }
            }



        };

        $scope.InsertPSUsersBySIte = function () {
            ////////$log.log("InsertPSUsersBySIte");
            var psuserFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: $scope.SingReport.Order.SiteID,
                LocationID: $scope.SingReport.Order.LocationID,
                UserName: $scope.PSUser.Username,
                Password: $scope.PSUser.Password
            };
            WorklistService.InsertPSUsersBySIte(psuserFilter).then(function (result) {
                $scope.win_PSUser.close();
                SignReport($scope.navFlag);
            });
        };

        function stopRefreshInterval() {
            ////$log.log('stopRefreshInterval');
            if (refreshInterval) {
                $interval.cancel(refreshInterval);
                refreshInterval = undefined;
            }
        }

        function clear() {
            $scope.PageNo = 1;
            OrderList = [];
        }

        $scope.InsertDicomViewerCredentials = function () {
            ////////$log.log("InsertDicomViewerCredentials");
            //$scope.isLoading = true;
            var objdata = {
                ID: -1,
                UserID: $sessionStorage.currentUserData.userId,
                SiteID: $scope.DVCred.SiteID,
                ViewerName: $scope.DVCred.ViewerName,
                UserName: $scope.DVCred.Username,
                Password: $scope.DVCred.Password,
                Modifyby: $sessionStorage.currentUserData.userId
            };
            WorklistService.InsertDicomViewerCredentials(objdata).then(function (result) {
                $('#ModalDicomViewerCredentials').modal('hide');
                if ($scope.GetDicomViewerCredentialsCallFrom == "OPENSYNAPSESTUDY") {
                    $scope.OpenSynapseStudy($scope.OpenSynapseStudyOrder, $scope.OpenSynapseStudyOptionalDV, $scope.OpenSynapseStudyisOpenPS);
                }
                else if ($scope.GetDicomViewerCredentialsCallFrom == "OPENSINGREPORT") {
                    $scope.OpenSignReport($scope.SingReport.Order, $scope.SingReport.OrderList);
                }
                //$scope.isLoading = false;
            });
        };

        //$scope.DeleteOpenOrderByUserID = function () {
        //    //////$log.log("DeleteOpenOrderByUserID");
        //    if ($sessionStorage.currentUserData) {
        //        WorklistService.DeleteOpenOrderByUserID($sessionStorage.currentUserData.userId).then(function (result) {
        //        });
        //    }
        //};

        function startRefreshInterval() {
            ////$log.log('startRefreshInterval');
            if (vm.worklist.TimeToLoad) {
                refreshInterval = $interval(function () {
                    $scope.PendingSinceCurrentDate = new Date();
                    var currentDate = moment();
                    if (currentDate.diff(vm.worklist.TimeToLoad, 'seconds') == 0) {
                        stopRefreshInterval();
                        getData();
                    }

                }, 1000);
            }

        }

        //$scope.GetOpenOrder = function () {
        //    ////////$log.log("GetOpenOrder");
        //    var openOrders = {
        //        OrderId: $scope.SingReport.Order.OrderID
        //    };
        //    WorklistService.GetOpenOrder(openOrders).then(function (result) {
        //        $scope.OpenOrder = result;
        //    });
        //};

        /*$scope.ViewComparisionOrderReport = function (ComparisonOrderID, OrderID, SelectedOrderAccession) {
            ////////$log.log("ViewComparisionOrderReport");
            $scope.showDiscuss = false;
            //$scope.isLoading = true;
            var comparisionorderlist = [];
            var Hasreport = false;
            $scope.SelectedOrderAccession = SelectedOrderAccession;
            $scope.comparisonorders = _.filter($scope.orderList, function (obj) { return obj.OrderID == ComparisonOrderID; });
            if ($scope.comparisonorders && $scope.comparisonorders.length > 0) {
                $scope.comparisonorders.forEach(function (order) {
                    order.ComparisonOrder.forEach(function (report) {
                        var comporder = { OrderID: report.OrderID };
                        comparisionorderlist.push(comporder);
                    });
                });
                if (comparisionorderlist && comparisionorderlist.length > 0) {
                    var comparisionorderObj = {
                        OrderID: 0,
                        UserID: $sessionStorage.currentUserData.userId,
                        comparisionorderlist: comparisionorderlist
                    }
                    WorklistService.GetComparisonOrderReportByOrderID(comparisionorderObj).then(function (results) {
                        if (results && results.length > 0) {
                            results.forEach(function (report) {
                                var comparisonorderreport = _.filter($scope.comparisonorders[0].ComparisonOrder, function (obj) { return obj.OrderID == report.OrderID; });
                                if (comparisonorderreport && comparisonorderreport.length > 0) {
                                    comparisonorderreport[0].ComparisonOrderReport = report.ReportDecation;
                                    $scope.currentWindow = "win_ComparisonOrderReports";
                                    $scope.win_ComparisonOrderReports.open();
                                    $timeout(function () {
                                        $scope.win_ComparisonOrderReports.center();
                                    }, 100);
                                    //$scope.isLoading = false;
                                }
                            });
                        }
                        else {
                            swal("No report found.");
                            //$scope.isLoading = false;
                        }
                    });
                }
                else {
                    //$scope.isLoading = false;
                }
            } else if ($scope.SelectedOrder) {
                $scope.SelectedOrder.ComparisonOrder.forEach(function (report) {
                    var comporder = { OrderID: report.OrderID };
                    comparisionorderlist.push(comporder);
                });
                $q.all([
                    //GetOrderReportByOrderID($scope.SelectedOrder.OrderID),
                    GetComparisonOrderReportByOrderID($scope.SelectedOrder.OrderID, comparisionorderlist)
                ]).then(function (data) {
                    $scope.reportList = [];
                    var report = [];
                    var comparisonReport = [];
                    //if (data != null && data[0] != null && data[0].route == "GetOrderReportByOrderID" && data[0].length > 0) {
                    if (data != null && data.length > 0 && data[0] != null && data[0].length > 0) {
                        report = _.filter(data[0], function (obj) { return obj.ID == 1 && obj.OrderID > 0; });
                        comparisonReport = _.filter(data[0], function (obj) { return obj.ID == 2 && obj.OrderID > 0; });
                        if (report && report.length > 0) {
                            $scope.SelectedOrder.OrderReport = report[0];
                            Hasreport = true;
                            $scope.reportList.push($scope.SelectedOrder);
                        }

                    }
                    //if (data != null && data[1] != null && data[1].route == "GetComparisonOrderReportByOrderID" && data[1].length > 0) {
                    if (data != null && comparisonReport != null && comparisonReport.length > 0) {
                        comparisonReport.forEach(function (ComparisonOrderReport) {
                            var rptObject = _.filter($scope.SelectedOrder.ComparisonOrder, function (obj) { return obj.OrderID == ComparisonOrderReport.OrderID; });
                            if (rptObject && rptObject.length > 0) {
                                rptObject[0].ComparisonOrderReport = ComparisonOrderReport.ReportDecation;
                                Hasreport = true;
                                $scope.reportList.push(rptObject[0]);
                            }
                        });
                    }
                    $scope.OrderReport = $scope.SelectedOrder;
                    $scope.reportList = _.uniq($scope.reportList);

                    var objSelectedReport = _.filter($scope.reportList, function (obj) { return obj.Accession == SelectedOrderAccession; });
                    if (objSelectedReport && objSelectedReport.length > 0) {
                        LoadReport(objSelectedReport[0].OrderID);
                        if (Hasreport) {
                            $scope.currentWindow = "win_ComparisonOrderReports";
                            $scope.win_ComparisonOrderReports.open();
                            setTimeout(function () {
                                $scope.win_ComparisonOrderReports.center();
                            }, 100);
                        }
                        else {
                            swal("No report found.");
                        }
                    }

                    //$scope.isLoading = false;

                });
            } else {
                var orderComparisonListFilter = {
                    UserID: $sessionStorage.currentUserData.userId,
                    OrderID: ComparisonOrderID
                };
                WorklistService.GetOrdersComparisonList(orderComparisonListFilter).then(function (result) {

                }).catch(function (noCantDo) {
                    //$scope.isLoading = false;
                });
            }
        };*/

        $scope.winComparisonOrderReports_OnClose = function () {
            ////////$log.log("winComparisonOrderReports_OnClose");
            var div = document.getElementById('OrderReport' + $scope.SelectedOrderAccession);
            if (div != null) {
                div.scrollIntoView();
            }
        }

        function _OpenDiscussionOrder() {
            ////////$log.log("_OpenDiscussionOrder");
            $scope.ODType = "Helper";
            $scope.SelectedOrder = $scope.OrderDiscussion.Order ? $scope.OrderDiscussion.Order : $scope.OrderDiscussion;
            $scope.SelectedOrderID = $scope.SelectedOrder.OrderID;
            if ($scope.SelectedOrder && !$scope.SelectedOrder.DicomOrderID) {
                $scope.SelectedOrder.DicomOrderID = $scope.SelectedOrderID;
            }
            $('#ModalDiscussion').modal('show');
            $scope.LoadDiscussion($scope.SelectedOrder.DicomOrderID, 'Helper');
            if ($scope.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId) {
                if ($scope.OrderDiscussion.Status == 'A') {
                    $scope.OrderDiscussion.Status = 'C';
                    WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                        LoadOrderDiscussionForUser();
                    }, _respError);
                } else {
                    LoadOrderDiscussionForUser();
                }
            } else {
                if ($scope.OrderDiscussion.Status == 'N' || $scope.OrderDiscussion.Status == 'I') {
                    $scope.ODType = "Discussion";
                    $scope.OrderDiscussion.Status = 'D';
                    WorklistService.SetOrderDiscussionAssignment($scope.OrderDiscussion).then(function (response) {
                        LoadOrderDiscussionForUser();
                    }, _respError);
                    return;
                }
                $q.all([
                    GetAllUsers($scope.SelectedOrder.SiteID)
                ]).then(function (data) {
                    if ($scope.OrderDiscussion.OrderAssignments && $scope.OrderDiscussion.OrderAssignments.length > 0) {
                        $scope.OrderDiscussion.SelectedUsers = [];
                        var allSpecialityArr = _.map($scope.OrderDiscussion.OrderAssignments, function (row) {
                            return row.ProviderSpecialityId;
                        });
                        var uniqueSpeciality = _.filter(allSpecialityArr, function (item, index, arry) { return (arry.indexOf(item) === index) });

                        _.each(uniqueSpeciality, function (obj) {
                            if (obj > 0) {
                                var findSelectedSpeciality = _.filter($scope.OrderDiscussion.OrderAssignments, function (sUser) { return sUser.ProviderSpecialityId == obj });
                                var findAllSpeciality = _.filter(vm.masterData.Radiologists, function (aUser) { return aUser.SpecialityId == obj });
                                var findExistsInGroup = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 1 });
                                var findUserOnly = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 2 });
                                if (findUserOnly.length == 0 && findSelectedSpeciality && findAllSpeciality && findSelectedSpeciality.length > 0 && findAllSpeciality.length > 0 && findSelectedSpeciality.length == findAllSpeciality.length) {
                                    $scope.OrderDiscussion.SelectedUsers = $scope.OrderDiscussion.SelectedUsers.concat(findAllSpeciality);
                                    if (findExistsInGroup && findExistsInGroup.length > 0) {
                                        _.each(findExistsInGroup, function (user) {
                                            var findUser = _.find($scope.OrderDiscussion.SelectedUsers, function (aUser) { return aUser.Id == user.ProviderID });
                                            if (findUser) {
                                                findUser.IsUserWithSpecialityGroup = 1;
                                            }
                                        });
                                    }
                                } else {
                                    if (findUserOnly.length > 0 || findExistsInGroup.length > 0) {
                                        if (findUserOnly && findUserOnly.length > 0) {
                                            _.each(findUserOnly, function (user) {
                                                var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == user.ProviderID });
                                                if (findUser) {
                                                    findUser.IsUserWithSpecialityGroup = 2;
                                                    $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                }
                                            });
                                        }
                                        if (findExistsInGroup && findExistsInGroup.length > 0) {
                                            _.each(findExistsInGroup, function (user) {
                                                var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == user.ProviderID });
                                                if (findUser) {
                                                    findUser.IsUserWithSpecialityGroup = 1;
                                                    $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                }
                                            });
                                        }
                                    } else {
                                        if (findSelectedSpeciality && findSelectedSpeciality.length > 0) {
                                            _.each(findSelectedSpeciality, function (speciality) {
                                                var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == speciality.ProviderID });
                                                $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                            });
                                        }
                                    }


                                }
                            }
                        });

                        var filterUsers = _.filter($scope.OrderDiscussion.OrderAssignments, function (obj) { return obj.ProviderSpecialityId == 0 });
                        if (filterUsers && filterUsers.length > 0) {
                            _.each(filterUsers, function (obj) {
                                var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == obj.ProviderID });
                                if (findUser) {
                                    $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                }
                            });
                        }

                        setTimeout(function () {
                            $scope.isAssigner = false;
                            setOrderDiscussionUserGroup().then(function (data) {
                                setOrderDiscussionTooltip();
                            });
                        }, 100);
                    }
                    if ($scope.OrderDiscussion.OrderDiscussionUserGroup && $scope.OrderDiscussion.OrderDiscussionUserGroup.length > 0) {
                        $scope.OrderDiscussion.SelectedUsers = [];
                        var allSpecialityArr = _.map($scope.OrderDiscussion.OrderDiscussionUserGroup, function (row) {
                            return row.ProviderSpecialityId;
                        });
                        var uniqueSpeciality = _.filter(allSpecialityArr, function (item, index, arry) { return (arry.indexOf(item) === index) });

                        _.each(uniqueSpeciality, function (obj) {
                            if (obj > 0) {
                                var findSelectedSpeciality = _.filter($scope.OrderDiscussion.OrderDiscussionUserGroup, function (sUser) { return sUser.ProviderSpecialityId == obj });
                                var findAllSpeciality = _.filter(vm.asterData.Radiologists, function (aUser) { return aUser.SpecialityId == obj });
                                var findExistsInGroup = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 1 });
                                var findUserOnly = _.filter(findSelectedSpeciality, function (sUser) { return sUser.IsUserWithSpecialityGroup && sUser.IsUserWithSpecialityGroup == 2 });
                                if (findUserOnly.length == 0 && findSelectedSpeciality && findAllSpeciality && findSelectedSpeciality.length > 0 && findAllSpeciality.length > 0 && findSelectedSpeciality.length == findAllSpeciality.length) {
                                    $scope.OrderDiscussion.SelectedUsers = $scope.OrderDiscussion.SelectedUsers.concat(findAllSpeciality);
                                    if (findExistsInGroup && findExistsInGroup.length > 0) {
                                        _.each(findExistsInGroup, function (user) {
                                            var findUser = _.find($scope.OrderDiscussion.SelectedUsers, function (aUser) { return aUser.Id == user.ProviderID });
                                            if (findUser) {
                                                findUser.IsUserWithSpecialityGroup = 1;
                                            }
                                        });
                                    }
                                } else {
                                    if (findUserOnly.length > 0 || findExistsInGroup.length > 0) {
                                        if (findUserOnly && findUserOnly.length > 0) {
                                            _.each(findUserOnly, function (user) {
                                                var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == user.ToUserID });
                                                if (findUser) {
                                                    findUser.IsUserWithSpecialityGroup = 2;
                                                    $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                }
                                            });
                                        }
                                        if (findExistsInGroup && findExistsInGroup.length > 0) {
                                            _.each(findExistsInGroup, function (user) {
                                                var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == user.ToUserID });
                                                if (findUser) {
                                                    findUser.IsUserWithSpecialityGroup = 1;
                                                    $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                                }
                                            });
                                        }
                                    } else {
                                        if (findSelectedSpeciality && findSelectedSpeciality.length > 0) {
                                            _.each(findSelectedSpeciality, function (speciality) {
                                                var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == speciality.ProviderID });
                                                $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                            });
                                        }
                                    }


                                }
                            }
                        });

                        var filterUsers = _.filter($scope.OrderDiscussion.OrderDiscussionUserGroup, function (obj) { return obj.ProviderSpecialityId == 0 });
                        if (filterUsers && filterUsers.length > 0) {
                            _.each(filterUsers, function (obj) {
                                var findUser = _.find(vm.masterData.Radiologists, function (aUser) { return aUser.Id == obj.ToUserID });
                                if (findUser) {
                                    $scope.OrderDiscussion.SelectedUsers.push(findUser);
                                }
                            });
                        }

                        setTimeout(function () {
                            $scope.isAssigner = false;
                            setOrderDiscussionUserGroup().then(function (data) {
                                setOrderDiscussionTooltip();
                            });
                        }, 100);
                    }
                });
                $scope.OrderDiscussion.Status = 'A';
            }
        }
        function NotifyToUser(msg, orderID, toUserID, status) {
            ////////$log.log("NotifyToUser");
            var data = {
                OrderID: orderID,
                FromUserID: $sessionStorage.currentUserData.userId,
                FromUser: $sessionStorage.currentUserData.displayName,
                ToUserID: toUserID,
                Status: status,
                Message: msg
            }
            WorklistService.NotifyToUser(data).then(function (response) {
            });
        }

        $scope.showFileList = function () {
            ////////$log.log("showFileList");
            $scope.showAttachment = true;
            $scope.ReferenceID = $scope.Discussion.ReferenceID;
        }
        $scope.hideFileList = function () {
            ////////$log.log("hideFileList");
            $scope.showAttachment = false;
        }

        function ReloadDiscussion(OD) {
            //$log.log('ReloadDiscussion');
            //$log.log('ReloadDiscussion > OD: ', OD);
            if (OD.Status == 'I') {
                var objOrder = _.filter($scope.orderList, function (obj) { return obj.OrderID == OD.OrderID; });
                if (objOrder && objOrder.length > 0) {
                    if (!objOrder[0].IsLock && vm.selectedData.Worklist === 'PSW') {
                        var ToUserID;
                        var ToUserName;
                        var assignedCurrentUser;
                        if (objOrder[0].listOrderListAssignment) {
                            if (objOrder[0].listOrderListAssignment.length > 0) {
                                ToUserName = $scope.getOrderListTooltip(objOrder[0]);
                                ToUserID = objOrder[0].listOrderListAssignment[0].OrderAssingedUserID;
                            }
                        }

                        if (OD.OrderDiscussionUserGroup) {

                            var userGroup = _.find(OD.OrderDiscussionUserGroup, function (obj) {
                                return obj.ToUserID == $scope.LoggedInUserID;
                            });
                            if (userGroup) {
                                assignedCurrentUser = userGroup.ToUserID;
                            }
                        }
                        objOrder[0].OrderAssingedUserID = ToUserID;
                        objOrder[0].OrderAssingedUserName = ToUserName;
                        objOrder[0].OrderAssingedUsers = OD.OrderDiscussionUserGroup.length;
                        objOrder[0].OrderAssingedUser = assignedCurrentUser;
                        objOrder[0].listOrderListAssignment = OD.Order.listOrderListAssignment;
                    }
                    if (!objOrder[0].IsLock && vm.selectedData.Worklist === 'PRW') {
                        removeOrderFromList(OD.OrderID);
                    }
                }
            } else {
                if (vm.selectedOrder.OrderID == OD.Order.OrderID) {
                    LoadDiscussion($scope.Discussion);
                    if (OD.Status == 'N') {
                        OD.Status = 'D';
                        WorklistService.SetOrderDiscussionAssignment(OD).then(function (response) {
                        });
                    }
                }
            }
        }

        function UnAssignStudy(OD) {
            //$log.log('UnAssignStudy');
            //$log.log('UnAssignStudy > OD: ', OD);
            if (OD.Status == 'D' && OD.FromUserID == $scope.LoggedInUserID) {
                var objOrder = _.filter($scope.orderList, function (obj) { return obj.OrderID == OD.OrderID; });
                if (objOrder && objOrder.length > 0) {
                    if (!objOrder[0].IsLock && vm.Worklist === 'PSW') {

                        var assignedUserID;
                        var findObj = _.find(OD.OrderDiscussionUserGroup, function (obj) {
                            return obj.ToUserID == $scope.LoggedInUserID;
                        });
                        if (findObj) {
                            assignedUserID = OD.OrderDiscussionUserGroup.ToUserID;
                        }
                        var OrderAssingedUsers;
                        var findIndex = _.findIndex(OD.OrderDiscussionUserGroup, function (obj) {
                            return obj.ToUserID == $scope.LoggedInUserID;
                        });
                        if (findIndex != -1) {
                            OD.OrderDiscussionUserGroup.splice(findIndex, 1);
                            OrderAssingedUsers = OD.OrderDiscussionUserGroup.length;
                        } else {
                            OrderAssingedUsers = OD.OrderDiscussionUserGroup.length - 1;
                        }
                        var OrderAssingedUserID;
                        if (OrderAssingedUsers > 0) {
                            OrderAssingedUserID = OD.OrderDiscussionUserGroup[0].ToUserID;
                        }
                        var OrderAssingedUserName;
                        if (OrderAssingedUserID) {
                            var findObj = _.find(objOrder[0].listOrderListAssignment, function (obj) { return obj.OrderAssingedUserID = OrderAssingedUserID });
                            if (findObj) {
                                OrderAssingedUserName = $scope.getOrderListTooltip(objOrder[0]);
                            }
                        }
                        objOrder[0].OrderAssingedUserID = OrderAssingedUserID;
                        objOrder[0].OrderAssingedUserName = OrderAssingedUserName;
                        objOrder[0].OrderAssingedUsers = OrderAssingedUsers;
                        objOrder[0].OrderAssingedUser = assignedUserID ? null : assignedUserID;
                        objOrder[0].listOrderListAssignment = OD.Order.listOrderListAssignment;
                    }
                    if (!objOrder[0].IsLock && vm.Worklist === 'PRW') {
                        removeOrderFromList(OD.OrderID);
                    }
                }
            }
        }

        function ResizePanel(data) {
            if (data.id && data.id == vm.index) {
                vm.worklist.height = data.height;
                getData();
            }
        }

        function OrderDiscussionHandler(data) {
            //$log.log('OrderDiscussionHandler');
            //$log.log('OrderDiscussionHandler > data: ', data);
            if (data.discussion.Type == 1) {
                var objOrderList = _.filter($scope.orderList, function (obj) { return data.discussion.ReferenceID == obj.DicomOrderID; });
                if (objOrderList && objOrderList.length > 0) {
                    objOrderList[0].IsDiscussion = true;
                }
            } else if (data.discussion.Type == 0 && data.orderID) {
                var objOrderList = _.filter($scope.orderList, function (obj) { return data.orderID == obj.OrderID; });
                if (objOrderList && objOrderList.length > 0) {
                    objOrderList[0].IsDiscussion = true;
                }
            }
            if ($scope.isDiscussionVisible) {
                LoadDiscussion($scope.Discussion);
            }
        }

        function NotifyOpenOrder(data) {
            if ($sessionStorage.currentUserData.userId != data.ProviderID) {
                var objOrder = _.filter(OrderList, function (obj) { return obj.OrderID == data.OrderID; });
                if (objOrder && objOrder.length > 0) {
                    if (vm.selectedData.ShowLockStudy) {
                        //////////$log.log(isOpen);
                        if (data.isOpen) {
                            objOrder[0].IsLock = true;
                            objOrder[0].LockBy = data.ProviderName;
                        }
                        else {
                            objOrder[0].IsLock = false;
                        }
                    }
                    $scope.orderList = OrderList;
                }
            }
        }

        function NotifyShowHideOrder(data) {
            var Status = GetStatus();
            var objOrder = _.findIndex(OrderList, function (obj) { return obj.OrderID == data.OrderID; });
            if (objOrder != -1) {
                switch (Status) {
                    case 'H':
                        if (!data.IsHide) {
                            removeOrderFromList(data.OrderID);
                        }
                        break;
                    case 'AL':
                        OrderList[objOrder].Status = data.IsHide ? "H" : "RP";
                        break;
                    case 'RP':
                        if (data.IsHide) {
                            removeOrderFromList(data.OrderID);
                        }
                        break;
                }
            }
            $scope.orderList = OrderList;
        }
        function ProcessedOrdersUpdate(obj) {
            //$log.log("ProcessedOrdersUpdate > ", new Date());
            var Status = GetStatus();
            //$log.log("ProcessedOrdersUpdate > Status: ", Status);
            switch (obj.Type) {
                case 'ShowHideOrder':
                    if (vm.autoUpdate) {
                        _.each(obj.OrderList, function (objOrder) {
                            var order = _.clone(objOrder);
                            $log.log("ProcessedOrdersUpdate > order.Status: ", order.Status);
                            if ((Status == 'H' || Status == 'AL') && order.Status == 'RP') {
                                var OrderIndex = OrderExists(order.OrderID);
                                $log.log("ProcessedOrdersUpdate > OrderIndex: ", OrderIndex);
                                if (OrderIndex != -1) {
                                    order.Status = 'H';
                                    order.RowColorCode = getRowTemplateColorCode(order);

                                    OrderList[OrderIndex] = order;

                                    $scope.orderList = OrderList;
                                } else {
                                    order.Status = 'H';
                                    if (checkOrderFilters(order)
                                        && validateSite(order.SiteID)) {
                                        order.RowColorCode = getRowTemplateColorCode(order);
                                        OrderList.push(order);
                                        updateOrderList(order);
                                    }
                                }
                            } else if ((Status == 'AL' || Status == 'RP') && order.Status == 'H') {

                                var OrderIndex = OrderExists(order.OrderID);
                                if (OrderIndex != -1) {
                                    order.Status = 'RP';
                                    order.RowColorCode = getRowTemplateColorCode(order);

                                    OrderList[OrderIndex] = order;

                                    $scope.orderList = OrderList;
                                } else {
                                    order.Status = 'RP';
                                    if (checkOrderFilters(order)
                                        && validateSite(order.SiteID)) {
                                        order.RowColorCode = getRowTemplateColorCode(order);
                                        OrderList.push(order);
                                        updateOrderList(order);
                                    }
                                }

                            }
                        });
                    }
                    break;
                case 'DraftedOrder':
                    if (obj.UserID != $sessionStorage.currentUserData.userId && vm.autoUpdate) {
                        _.each(obj.OrderList, function (order) {
                            if (Status == 'RP') {
                                removeOrderFromList(order.OrderID);
                            } else if (Status == 'AL') {
                                var OrderIndex = OrderExists(order.OrderID);
                                if (OrderIndex == -1) {
                                    if (checkOrderFilters(order)
                                        && validateSite(order.SiteID)) {
                                        order.Status = 'D';
                                        order.ReportStatus = 2;
                                        order.RowColorCode = getRowTemplateColorCode(order);
                                        OrderList.push(order);
                                        updateOrderList(order);

                                    }
                                } else {
                                    order.Status = 'D';
                                    order.ReportStatus = 2;
                                    order.RowColorCode = getRowTemplateColorCode(order);
                                    OrderList[OrderIndex] = order;
                                    $scope.orderList = OrderList;
                                }
                                $timeout(function () {
                                    selectRow();
                                }, 100);
                            }
                        });

                    }

                    break;
                case 'SignedOrder':
                    if (obj.UserID != $sessionStorage.currentUserData.userId && vm.autoUpdate) {
                        _.each(obj.OrderList, function (order) {
                            if (Status == 'RP' || Status == 'D') {
                                removeOrderFromList(order.OrderID);
                            } else if (Status == 'AL') {
                                var OrderIndex = OrderExists(order.OrderID);
                                if (OrderIndex == -1) {
                                    if (checkOrderFilters(order)
                                        && validateSite(order.SiteID)) {
                                        order.Status = 'C';
                                        order.ReportStatus = 1;
                                        order.RowColorCode = getRowTemplateColorCode(order);
                                        OrderList.push(order);
                                        updateOrderList(order);
                                    }
                                } else {
                                    order.Status = 'C';
                                    order.ReportStatus = 1;
                                    order.RowColorCode = getRowTemplateColorCode(order);
                                    OrderList[OrderIndex] = order;
                                    $scope.orderList = OrderList;
                                }
                                $timeout(function () {
                                    selectRow();
                                }, 100);
                            }
                        });

                    }


                    break;
                default:
                    if (vm.autoUpdate) {
                        if (vm.worklist.Type == 'A' || vm.worklist.Type == 'U') {
                            var OrderIDs = _.map(obj.OrderList, function (order) { return { 'OrderID': order.OrderID, 'QueueSource': '', 'ParentOrderIDs': '' }; });
                            var orderListFilter = {
                                PageNum: 1,
                                PageSize: vm.worklist.PageSize,
                                AdminWorklistIds: vm.worklist.Type == 'A' ? vm.worklist.RuleID : '',
                                UserWorklistIds: vm.worklist.Type == 'U' ? vm.worklist.RuleID : '',
                                jsonOrderIDs: OrderIDs,
                                Status: 'AL',
                                UserID: $sessionStorage.currentUserData.userId,
                            };
                            WorklistService.ValidateOrdersList(orderListFilter).then(function (result) {
                                validateOrders(result);
                            });
                        } else {
                            validateOrders(obj.OrderList);
                        }

                    }
                    break;
            }
        }

        function NotifyAssignStudy(data) {
            if (data.OrderDiscussion && (data.OrderDiscussion.FromUserID != $sessionStorage.currentUserData.userId)) {
                var orderIndex = _.findIndex(OrderList, { 'OrderID': _.toString(data.OrderDiscussion.OrderID) });
                var sorderIndex = _.findIndex($scope.orderList, { 'OrderID': _.toString(data.OrderDiscussion.OrderID) });
                var userOfGroupLength = data.OrderDiscussion.Order.listOrderListAssignment.length;
                var userIndex = _.findIndex(data.OrderDiscussion.Order.listOrderListAssignment, { 'OrderAssingedUserID': $sessionStorage.currentUserData.userId });
                var userName = '';
                if (orderIndex != -1) {
                    OrderList[orderIndex].listOrderListAssignment = data.OrderDiscussion.Order.listOrderListAssignment;
                    userName = $scope.getOrderListTooltip(OrderList[orderIndex]);
                }
                if (sorderIndex != -1) {
                    $scope.orderList[sorderIndex].listOrderListAssignment = data.OrderDiscussion.Order.listOrderListAssignment;
                    userName = $scope.getOrderListTooltip($scope.orderList[sorderIndex]);
                }
                if (data.OrderDiscussion.Order.listOrderListAssignment.length > 0) {
                    _.each(data.OrderDiscussion.Order.listOrderListAssignment, function (data) {
                        if (orderIndex != -1) {
                            OrderList[orderIndex].OrderAssingedUserID = data.OrderAssingedUserID;
                            OrderList[orderIndex].OrderAssingedUserName = userName;
                            OrderList[orderIndex].OrderAssingedUsers = userOfGroupLength;
                            OrderList[orderIndex].OrderAssingedUser = userIndex != -1 ? $sessionStorage.currentUserData.userId : null;
                        }

                        if (sorderIndex != -1) {
                            $scope.orderList[sorderIndex].OrderAssingedUserID = data.OrderAssingedUserID;
                            $scope.orderList[sorderIndex].OrderAssingedUserName = userName;
                            $scope.orderList[sorderIndex].OrderAssingedUsers = userOfGroupLength;
                            $scope.orderList[sorderIndex].OrderAssingedUser = userIndex != -1 ? $sessionStorage.currentUserData.userId : null;
                        }


                    });
                } else {
                    if (orderIndex != -1) {
                        OrderList[orderIndex].OrderAssingedUserID = null;
                        OrderList[orderIndex].OrderAssingedUserName = null;
                        OrderList[orderIndex].OrderAssingedUsers = 0;
                        OrderList[orderIndex].OrderAssingedUser = null;
                    }

                    if (sorderIndex != -1) {
                        $scope.orderList[sorderIndex].OrderAssingedUserID = null;
                        $scope.orderList[sorderIndex].OrderAssingedUserName = null;
                        $scope.orderList[sorderIndex].OrderAssingedUsers = 0;
                        $scope.orderList[sorderIndex].OrderAssingedUser = null;
                    }
                }

            } else if (data.OrderDiscussion && (data.OrderDiscussion.FromUserID == $sessionStorage.currentUserData.userId)) {
                var index = _.findIndex(OrderList, { 'OrderID': data.OrderDiscussion.Order.OrderID });
                if (index != -1) {
                    updateOrderAssign(data.OrderDiscussion.Order);
                    OrderList[index].OrderAssingedUserID = data.OrderDiscussion.Order.OrderAssingedUserID;
                    OrderList[index].OrderAssingedUserName = data.OrderDiscussion.Order.OrderAssingedUserName;
                    OrderList[index].OrderAssingedUsers = data.OrderDiscussion.Order.OrderAssingedUsers;
                    OrderList[index].OrderAssingedUser = data.OrderDiscussion.Order.OrderAssingedUser;
                    $scope.orderList = OrderList;
                }
            }
        }

        function Dictation(data) {
            //$log.log("Dictation > on: ", new Date());
            //$log.log("Dictation > data: ", data);
            var Status = GetStatus();
            //$log.log("Dictation > Status: ", Status);
            DictationReportState = data.DictationReportState;
            DictationReportStatus = data.SelectedOrder._ReportStatus;

            $scope.win_ModalReportNDiscuss.close();
            $scope.win_Discussion.close();

            if (data.SelectedOrder._ReportStatus) {
                if (!vm.selectedData.ChooseNextStudy || !vm.worklist.OpenClipboardNextStudy) {
                    NextRec();
                    $scope.SingbtnDisabled = false;
                } else {
                    
                    
                    //$log.log("Dictation > _ReportStatus: ", data.SelectedOrder._ReportStatus);
                    if ((Status == 'RP' || Status == 'D') && (data.SelectedOrder._ReportStatus == 'Final' || data.SelectedOrder._ReportStatus == 'Correction')) {
                        removeOrderFromList(data.SelectedOrder.OrderID);
                        if (data.SelectedOrder._PatientOrdersMapped) {
                            _.each(data.SelectedOrder._PatientOrdersMapped, function (mappedOrder) {
                                removeOrderFromList(mappedOrder.OrderID);
                            });
                        }
                    }

                    

                }
            }
            DeleteOpenOrder();
        }

        function Reload(data) {
            if (data.WorklistID && data.WorklistID == vm.worklist.RuleID) {
                getData();
            } else if (data.WorklistIDs) {

                if (!($scope.isSingReportVisible
                    || $scope.isPSUserVisible
                    || $scope.isComparisonOrderReportsVisible
                    || $scope.isDiscussionVisible
                    || $scope.isHideStudyVisible)) {
                    _.each(_.split(data.WorklistIDs, ','), function (RuleID) {
                        if (vm.worklist.RuleID == RuleID && !vm.worklist.loading) {
                            startRefreshInterval();
                        }
                    });



                }

            }
        }

        $scope.winSingReport_OnClose = function () {
            ////$log.log("winSingReport_OnClose");
            if (LastOpenedOrderID != null) {
                if (vm.selectedData.DefaultDictationSystem && vm.selectedData.DefaultDictationSystem == 'PS360') {
                    DictationReportState = 'DictateByPS360';
                } else if (vm.selectedData.DefaultDictationSystem && vm.selectedData.DefaultDictationSystem == 'CIVR') {
                    DictationReportState = 'DictateByCIVR';
                } else if ($scope.SelectedOrder.DictationSystem && $scope.SelectedOrder.DictationSystem == 'CIVR') {
                    DictationReportState = 'DictateByCIVR';
                } else if ($scope.SelectedOrder.DictationSystem && $scope.SelectedOrder.DictationSystem == 'PS360') {
                    DictationReportState = 'DictateByPS360';
                }
                removeOrderFromList(LastOpenedOrderID);
                DeleteOpenOrder();
            }
        }

        function OpenWindow(win, key) {           
            if (win) {
                win.open();              
                $timeout(function () {
                    win.center();
                }, 100);
            } else {
                var dialog = $("div[kendo-window='" + key + "']").data("kendoWindow");               
                if (dialog) {
                    dialog.open();
                    $timeout(function () {
                        dialog.center();
                    }, 100);
                }
            }

        }

        function GetStatus() {
            //$log.log("GetStatus");
            var RuleConditionStatus;
            var Status = vm.selectedData.Status.key;
            //$log.log("GetStatus > Status: ", Status);
            if (vm.worklist.RulesConditions) {
                RuleConditionStatus = _.find(vm.worklist.RulesConditions, { ColumnName: 'ORDERS.ExamStatus' });
            }

            if (RuleConditionStatus && RuleConditionStatus.RuleTableValues && RuleConditionStatus.RuleTableValues.length > 0) {
                Status = vm.worklist.Type == 'D' ? OrderListFilter.Status : vm.worklist.Type == 'A' ? RuleConditionStatus.RuleTableValues[0].ID : vm.selectedData.Status.key;
            } else {
                Status = vm.worklist.Type == 'D' ? OrderListFilter.Status : vm.selectedData.Status.key;
            }
            return Status;
        }

        $scope.changeHideStudyOption = function (value) {
            ////////$log.log("changeHideStudyOption");
            $scope.HideOption = value;
            $scope.hideStudyWindowHeight = "35%";
            if (value == "NeedMoreImages") {
                $scope.hideStudyWindowHeight = "45%";
            }
            SetWindowOptions($scope.win_HideStudy, 'win_HideStudy', { height: $scope.hideStudyWindowHeight });
        };

        function SetWindowOptions(win, key, options) {
            if (win) {
                win.setOptions(options);
            } else {
                var dialog = $("div[kendo-window='" + key + "']").data("kendoWindow");
                if (dialog) dialog.setOptions(options);
            }
        }
        //Function to Open Share Exam popup kendo window(onClick of context menu-share Exams)
        $scope.openShareExamWindow = function () {
            $scope.currentWindow = 'win_shareExamsWindow';
            OpenWindow($scope.win_shareExamsWindow, 'win_shareExamsWindow');
            $scope.win_shareExamsWindow.wrapper.prev(".k-overlay").addClass("custom-overlay");
        };
        //Close onClick of send message button from shareExamchat.js
        $scope.onCloseShareExamWindowHandler = function (newCheck) {
            $scope.isShareExamWindowVisible = newCheck;
            if ($scope.isShareExamWindowVisible == true) {
                $scope.win_shareExamsWindow.close();
            }
        };
        function GetPriorReportsByPatientMRN(OrderID, PatientMRN) {
            //$log.log("GetPriorReportsByPatientMRN");
            var d = $q.defer();
            var jObject = {
                OrderID: OrderID,
                PatientMRN: PatientMRN,
                UserID: $sessionStorage.currentUserData.userId,
            }

            WorklistService.GetPriorReportsByPatientMRN(jObject).then(function (results) {
                d.resolve(results);
            });
            //}
            //else {
            //    return null;
            //}
            return d.promise;
        }
        function rowSelectionChangedBatch(rows, singleRow) {
            //$log.log("rowSelectionChangedBatch > on: ", new Date());            
            //$log.log("rowSelectionChangedBatch > rows: ", rows);
            //$log.log("rowSelectionChangedBatch > singleRow: ", singleRow);
            clearSelection();
            if (vm.worklist.WorklistType == 16) {
                var OrderlistClipboard = [], SelectedRowsClipboard = [], RemainingRowsClipboard = [];
                OrderlistClipboard = _.clone($scope.orderList);
                var selectedRows = false;
                _.each(rows, function (row) {
                    if (row.isSelected) { SelectedRowsClipboard.push(row.entity); selectedRows = true; }
                })
                if (selectedRows) {
                    ClipboardConditionData.SelectedRowsClipboard = _.concat(ClipboardConditionData.SelectedRowsClipboard, SelectedRowsClipboard);
                    RemainingRowsClipboard = _.differenceBy(OrderlistClipboard, ClipboardConditionData.SelectedRowsClipboard, 'OrderID');

                    ClipboardConditionData.ClipboardData = RemainingRowsClipboard;
                    selectedRows = false;
                }
                

            }
            else {
                
                //if (singleRow && !window.ctrlDown) { ClipboardConditionData.ClipboardData = [];}
                _.each(rows, function (row) {
                    if (row.isSelected) {
                        var existsIndex = _.findIndex(ClipboardConditionData.ClipboardData, { OrderID: row.entity.OrderID });
                        if (existsIndex == -1) {
                            ClipboardConditionData.ClipboardData.push(row.entity);
                        }
                    }
                    
                });
                var othersClipboard = _.filter(ClipboardConditionData.ClipboardData, function (row) { return row.IsInClipboard == 1; });
                if (othersClipboard.length > 0) {
                    ClipboardConditionData.IsInOtherClipboard = true;
                    ClipboardConditionData.ClipboardData = _.difference(ClipboardConditionData.ClipboardData, othersClipboard);;
                }
            }
        }
        function onAddToClipboard(Type) {
            //$log.log("onAddToClipboard > on: ", new Date());
            
            var orderMinDate = _.minBy(ClipboardConditionData.ClipboardData, function (obj) {
                return obj.OrderDate;
            });
            var orderMaxDate = _.maxBy(ClipboardConditionData.ClipboardData, function (obj) {
                return obj.OrderDate;
            });
            var orderIDs = Array.prototype.map.call(ClipboardConditionData.ClipboardData, function (item) { return item.OrderID; }).join(",");
            
            if (ClipboardConditionData.ClipboardData.length > 0) {
                ClipboardConditionData.OrderDate = {
                    startDate: moment(orderMinDate.OrderDate),
                    endDate: moment(orderMaxDate.OrderDate)
                };
                ClipboardConditionData.OrderIDs = orderIDs;
                ClipboardConditionData.OrderDateType = "Custom range";
                ClipboardConditionData.ActionType = Type;
            } else {
                ClipboardConditionData.OrderDate = {
                    startDate: null,
                    endDate: null
                };
                ClipboardConditionData.OrderIDs = null;
                ClipboardConditionData.OrderDateType = "Custom range";
                ClipboardConditionData.ActionType = Type;
            }
            $rootScope.$broadcast('event.worklist.clipboard', { EventType: 'CreateClipboardConditions', ClipboardConditionData: ClipboardConditionData });
            
        }
        function onRemoveFromClipboard() {
            onAddToClipboard("Remove");
        }
        function ResetClipboard() {
            if ($scope.orderList.length > 0) { $("#onresetclipboard").removeAttr('disabled'); $("#DisableResetClipboard").removeAttr('disabled'); }
            else { $("#onresetclipboard").attr('disabled', 'disabled'); $("#DisableResetClipboard").attr('disabled', 'disabled'); }
        }

        window.ctrlDown = false;

        document.addEventListener('keydown', function (evt) {
            var e = window.event || evt;
            var key = e.which || e.keyCode;
            if (17 == key) {
                window.ctrlDown = true;
                $log.log("keydown > ", window.ctrlDown);
            }
        }, false);

        document.addEventListener('keyup', function (evt) {
            var e = window.event || evt;
            var key = e.which || e.keyCode;
            if (17 == key) {
                window.ctrlDown = false;
                $log.log("keydown > ", window.ctrlDown);
            }
        }, false);

        function rowsSelectionInBatch(rows) {
            rowSelectionChangedBatch(rows, false);
        }
        function ClipboradIconCase(data){
            switch (data.ClipboardConditionData.ActionType) {
                case "Add":
                    var OrderIDList = data.ClipboardConditionData.OrderIDs.split(',');
                    _.each(OrderIDList, function (orderId) {
                        var idx = _.findIndex(OrderList, function (order) { return order.OrderID == orderId });
                        if (idx != -1) {
                            if ($scope.LoggedInUserID == data.ClipboardConditionData.CreatedBy) {
                                OrderList[idx].IsInClipboard = 2;
                            } else {
                                OrderList[idx].IsInClipboard = 1;
                            }
                        }
                    });
                    break;
                case "Remove":
                    var OrderIDList = data.ClipboardConditionData.OrderIdsToRemove.split(',');
                    _.each(OrderIDList, function (orderId) {
                        var idx = _.findIndex(OrderList, function (obj) { return obj.OrderID == orderId });
                        if (idx != -1) {
                            OrderList[idx].IsInClipboard = 0;
                        }
                    });
                    break;
                case "Reset":
                    var OrderIDList = data.ClipboardConditionData.OrderIdsToRemove.split(',');
                    _.each(OrderIDList, function (orderId) {
                        var idx = _.findIndex(OrderList, function (obj) { return obj.OrderID == orderId });
                        if (idx != -1) {
                            OrderList[idx].IsInClipboard = 0;
                        }
                    });
                    break;
            }
        }
        //--------
    }
}());
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('worklistPageHeader', {
            templateUrl: 'app/theme/components/worklist-page-header/worklist-page-header.html',
            bindings: {
                worklistPageHeaderParameter: '<',
                bonusDetails: '<',
                onTourClick: '&',
                onStatusClick: '&',
                onClearFilterClick: '&',
                onUserPaymentClick: '&',
                onRefreshClick: '&',
                isRefreshing: '<',
            },
            controller: WorklistPageHeaderController
        });

    function WorklistPageHeaderController($scope, $sessionStorage, $q, UserPreferenceService, $state, $timeout, $injector, toaster) {

        var vm = this;

        $scope.DataObject = {
            WorklistPageHeaderParameter: { isSOSVisible: false },
            UserPref: { WorklistUserPreference: [] },
            loadMoreWorklist: [],
            isFontPropertyVisible: { value: false },
            helpEleWrapper: { value: false },
            searchTourSteps: '',
            BonusDetails: null,
            BonusTooltip: null,
            XRayTodayTooltip: null,
            SOSMessage: "Dr. @UserName has issued an SOS for RadPod as we are currently experiencing sustained high STAT and total volume, resulting in delayed TATs. Immediate assistance from available radiologists is requested. Thank you for helping maintain timely patient care. Please contact Dhruv Chopra at (972) 215-8064 with any questions. Thank you for your help.",
        };

        vm.currentState = $state.current.name;

        vm.$onChanges = function (changes) {
            if (changes.worklistPageHeaderParameter) {
                $scope.DataObject.WorklistPageHeaderParameter = changes.worklistPageHeaderParameter.currentValue;
            }
            if (changes.bonusDetails) {
                $scope.DataObject.BonusDetails = changes.bonusDetails.currentValue;
                GetBonusTooltipText();
            }
            if($scope.DataObject.SOSMessage && $sessionStorage.currentUserData.displayName && $scope.DataObject.SOSMessage.indexOf('@UserName') !== -1)     {
                $scope.DataObject.SOSMessage = $scope.DataObject.SOSMessage.replace('@UserName', $sessionStorage.currentUserData.displayName);
            }
            if($scope.DataObject.WorklistPageHeaderParameter.isSOSVisible) {
                initSOSButton();
            }
        };
        vm.$onDestroy = function () {
        }
        vm.$onInit = function () {
            $scope.DataObject.WorklistPageHeaderParameter = vm.worklistPageHeaderParameter;
        }

        $scope.$watch('DataObject.WorklistPageHeaderParameter.XRayDetails', function (newVal) {
            if (newVal) {
                GetXRayTodayTooltipText();
            }
        }, true);

        // SOS Floating Button Functionality - Draggable and Clickable Start
        var sosButton = null;
        var isDragging = false;
        var hasMoved = false;
        var justDragged = false;
        var startX = 0;
        var startY = 0;
        var initialTransformX = 0;
        var initialTransformY = 0;
        var dragListenersAttached = false;

        function onMouseDown(e) {
            if (!sosButton) return;
            
            isDragging = true;
            hasMoved = false;
            sosButton.classList.add('dragging');
            
            // Get actual current position from rendered element (works with any scale)
            var rect = sosButton.getBoundingClientRect();
            var btnWidth = sosButton.offsetWidth || 60;
            var btnHeight = sosButton.offsetHeight || 60;
            
            // Calculate base position (CSS: left: calc(50% - 30px), top: 35px)
            var baseLeft = (window.innerWidth / 2) - (btnWidth / 2);
            var baseTop = 35;
            
            // Calculate current transform offset from base position
            initialTransformX = rect.left - baseLeft;
            initialTransformY = rect.top - baseTop;
            
            startX = e.clientX;
            startY = e.clientY;
            
            if (!dragListenersAttached) {
                document.addEventListener('mousemove', onMouseMove, false);
                document.addEventListener('mouseup', onMouseUp, false);
                dragListenersAttached = true;
            }
        }

        function onTouchStart(e) {
            if (!sosButton) return;
            
            e.preventDefault();
            e.stopPropagation();
            
            isDragging = true;
            hasMoved = false;
            sosButton.classList.add('dragging');
            
            // Get actual current position from rendered element (works with any scale)
            var rect = sosButton.getBoundingClientRect();
            var btnWidth = sosButton.offsetWidth || 60;
            var btnHeight = sosButton.offsetHeight || 60;
            
            // Calculate base position (CSS: left: calc(50% - 30px), top: 35px)
            var baseLeft = (window.innerWidth / 2) - (btnWidth / 2);
            var baseTop = 35;
            
            // Calculate current transform offset from base position
            initialTransformX = rect.left - baseLeft;
            initialTransformY = rect.top - baseTop;
            
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            
            if (!dragListenersAttached) {
                document.addEventListener('touchmove', onTouchMove, { passive: false });
                document.addEventListener('touchend', onTouchEnd, false);
                dragListenersAttached = true;
            }
        }

        function onMouseMove(e) {
            if (!isDragging || !sosButton) return;
            
            var deltaX = e.clientX - startX;
            var deltaY = e.clientY - startY;
            var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            
            if (distance > 10) {
                if (!hasMoved) {
                    hasMoved = true;
                    sosButton.style.setProperty('transition', 'none', 'important');
                }
                
                e.preventDefault();
                e.stopPropagation();
                
                var newTransformX = initialTransformX + deltaX;
                var newTransformY = initialTransformY + deltaY;
                
                var btnWidth = sosButton.offsetWidth || 60;
                var btnHeight = sosButton.offsetHeight || 60;
                // Base position is top center: left: 50% (window.innerWidth / 2), top: 35px
                // translateX(-50%) centers the button, so baseLeft is window.innerWidth / 2 - btnWidth / 2
                var baseLeft = (window.innerWidth / 2) - (btnWidth / 2);
                var baseTop = 35; // Default top position
                
                var absX = baseLeft + newTransformX;
                var absY = baseTop + newTransformY;
                
                var maxX = window.innerWidth - btnWidth;
                var maxY = window.innerHeight - btnHeight;
                var minX = 0;
                var minY = 0;
                
                if (absX < minX) newTransformX = minX - baseLeft;
                if (absY < minY) newTransformY = minY - baseTop;
                if (absX > maxX) newTransformX = maxX - baseLeft;
                if (absY > maxY) newTransformY = maxY - baseTop;
                
                sosButton.style.setProperty('transform', 'translate(' + newTransformX + 'px, ' + newTransformY + 'px)', 'important');
                sosButton.offsetHeight; // Force reflow
            }
        }

        function onTouchMove(e) {
            if (!isDragging || !sosButton) return;
            
            var deltaX = e.touches[0].clientX - startX;
            var deltaY = e.touches[0].clientY - startY;
            var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            
            if (distance > 10) {
                if (!hasMoved) {
                    hasMoved = true;
                    sosButton.style.setProperty('transition', 'none', 'important');
                }
                
                e.preventDefault();
                e.stopPropagation();
                
                var newTransformX = initialTransformX + deltaX;
                var newTransformY = initialTransformY + deltaY;
                
                var btnWidth = sosButton.offsetWidth || 60;
                var btnHeight = sosButton.offsetHeight || 60;
                // Base position is top center: left: 50% (window.innerWidth / 2), top: 35px
                // translateX(-50%) centers the button, so baseLeft is window.innerWidth / 2 - btnWidth / 2
                var baseLeft = (window.innerWidth / 2) - (btnWidth / 2);
                var baseTop = 35; // Default top position
                
                var absX = baseLeft + newTransformX;
                var absY = baseTop + newTransformY;
                
                var maxX = window.innerWidth - btnWidth;
                var maxY = window.innerHeight - btnHeight;
                var minX = 0;
                var minY = 0;
                
                if (absX < minX) newTransformX = minX - baseLeft;
                if (absY < minY) newTransformY = minY - baseTop;
                if (absX > maxX) newTransformX = maxX - baseLeft;
                if (absY > maxY) newTransformY = maxY - baseTop;
                
                sosButton.style.setProperty('transform', 'translate(' + newTransformX + 'px, ' + newTransformY + 'px)', 'important');
                sosButton.offsetHeight; // Force reflow
            }
        }

        function onMouseUp(e) {
            if (!sosButton) return;
            
            document.removeEventListener('mousemove', onMouseMove, false);
            document.removeEventListener('mouseup', onMouseUp, false);
            dragListenersAttached = false;
            
            var wasDrag = hasMoved;
            
            if (isDragging) {
                isDragging = false;
                sosButton.classList.remove('dragging');
                sosButton.style.setProperty('transition', '', 'important');
                
                if (wasDrag) {
                    justDragged = true;
                    setTimeout(function() {
                        justDragged = false;
                    }, 300);
                    
                    try {
                        var transform = sosButton.style.transform || '';
                        var transformX = 0;
                        var transformY = 0;
                        if (transform && transform !== 'none') {
                            var match = transform.match(/translate\(([^,]+)px,\s*([^)]+)px\)/);
                            if (match) {
                                transformX = parseFloat(match[1]) || 0;
                                transformY = parseFloat(match[2]) || 0;
                            }
                        }
                        
                        // Validate position after saving
                        $timeout(function() {
                            validateButtonPosition();
                        }, 50);
                    } catch (err) {
                        // Error saving position - silently fail
                    }
                }
            }
            
            if (!wasDrag && !justDragged) {
                showSOSPopup();
            }
            
            hasMoved = false;
        }

        function onTouchEnd(e) {
            if (!sosButton) return;
            
            document.removeEventListener('touchmove', onTouchMove, false);
            document.removeEventListener('touchend', onTouchEnd, false);
            dragListenersAttached = false;
            
            var wasDrag = hasMoved;
            
            if (isDragging) {
                isDragging = false;
                sosButton.classList.remove('dragging');
                sosButton.style.setProperty('transition', '', 'important');
                
                if (wasDrag) {
                    justDragged = true;
                    setTimeout(function() {
                        justDragged = false;
                    }, 300);
                    
                    try {
                        var transform = sosButton.style.transform || '';
                        var transformX = 0;
                        var transformY = 0;
                        if (transform && transform !== 'none') {
                            var match = transform.match(/translate\(([^,]+)px,\s*([^)]+)px\)/);
                            if (match) {
                                transformX = parseFloat(match[1]) || 0;
                                transformY = parseFloat(match[2]) || 0;
                            }
                        }
                        // Validate position after saving
                        $timeout(function() {
                            validateButtonPosition();
                        }, 50);
                    } catch (err) {
                        // Error saving position - silently fail
                    }
                }
            }
            
            if (!wasDrag && !justDragged) {
                showSOSPopup();
            }
            
            hasMoved = false;
        }

        function onButtonClick(e) {
            if (hasMoved || isDragging || justDragged) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        function showSOSPopup() {
            try {
                var chatBubble = document.getElementById('sosChatBubble');
                var sosBtn = document.getElementById('sos-floating-btn');
                if (!chatBubble) {
                    return;
                }
                if (!sosBtn) {
                    return;
                }

                // Clear any existing interval first
                if (chatBubble.dataset.intervalId) {
                    clearInterval(parseInt(chatBubble.dataset.intervalId));
                    chatBubble.dataset.intervalId = '';
                }

                var countdown = 10;
                var countdownInterval = null;
                var progressBar = document.getElementById('sosProgressBar');
                var countdownElement = document.getElementById('sosCountdown');

                var btnRect = sosBtn.getBoundingClientRect();
                var bubbleWidth = 450;
                var bubbleHeight = 280;
                var offsetX = 5;
                var offsetY = 5;
                
                // Determine if button is on the right side of screen
                var screenCenterX = window.innerWidth / 2;
                var buttonCenterX = btnRect.left + (btnRect.width / 2);
                var isButtonOnRightSide = buttonCenterX > screenCenterX;
                
                var leftPos, topPos;
                
                if (isButtonOnRightSide) {
                    // Button is on right side - position popover more to the left
                    // Position popover to the left of button with larger offset to avoid overlap
                    leftPos = btnRect.left - bubbleWidth - offsetX - 20; // Extra 20px offset for right side
                    topPos = btnRect.top - bubbleHeight - offsetY;
                    
                    // If popover would go off left edge, position it to the left edge
                    if (leftPos < 10) {
                        leftPos = 10;
                    }
                } else {
                    // Button is on left side - position popover to the right of button
                    leftPos = btnRect.right + offsetX;
                    topPos = btnRect.top - bubbleHeight - offsetY;
                    
                    // If popover would go off right edge, position it to the left of button instead
                    if (leftPos + bubbleWidth > window.innerWidth - 10) {
                        leftPos = btnRect.left - bubbleWidth - offsetX;
                    }
                }
                
                // Adjust vertical position if needed
                if (topPos < 10) {
                    topPos = btnRect.bottom + offsetY;
                }
                if (topPos + bubbleHeight > window.innerHeight - 10) {
                    topPos = window.innerHeight - bubbleHeight - 10;
                }
                
                // Final check: ensure popover doesn't go off screen horizontally
                if (leftPos < 10) {
                    leftPos = 10;
                }
                if (leftPos + bubbleWidth > window.innerWidth - 10) {
                    leftPos = window.innerWidth - bubbleWidth - 10;
                }

                chatBubble.style.left = leftPos + 'px';
                chatBubble.style.top = topPos + 'px';
                chatBubble.style.display = 'block';

                countdown = 30;
                if (countdownElement) countdownElement.textContent = countdown;
                if (progressBar) {
                    progressBar.style.width = '100%';
                    progressBar.setAttribute('aria-valuenow', '100');
                }

                // Start countdown timer
                countdownInterval = setInterval(function () {
                    countdown--;
                    if (countdownElement) countdownElement.textContent = countdown;

                    if (progressBar) {
                        var percentage = (countdown / 30) * 100;
                        progressBar.style.width = percentage + '%';
                        progressBar.setAttribute('aria-valuenow', percentage);
                    }

                    if (countdown <= 0) {
                        // Clear interval and remove from dataset
                        if (countdownInterval) {
                            clearInterval(countdownInterval);
                            countdownInterval = null;
                        }
                        chatBubble.dataset.intervalId = '';
                        hideSOSPopup();
                        sendSOSMessage();
                    }
                }, 1000);

                // Store interval ID in dataset for later reference
                chatBubble.dataset.intervalId = countdownInterval;

                // Setup cancel button handler
                var cancelBtn = document.getElementById('sosCancelBtn');
                if (cancelBtn) {
                    // Remove any existing onclick handlers
                    cancelBtn.onclick = null;
                    
                    // Set up new cancel handler
                    cancelBtn.onclick = function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        // Clear the interval
                        if (countdownInterval) {
                            clearInterval(countdownInterval);
                            countdownInterval = null;
                        }
                        
                        // Also clear from dataset
                        if (chatBubble.dataset.intervalId) {
                            clearInterval(parseInt(chatBubble.dataset.intervalId));
                            chatBubble.dataset.intervalId = '';
                        }
                        
                        // Hide popup (this will NOT send the message)
                        hideSOSPopup();
                          
                        return false;
                    };
                }
            } catch (err) {
                // Error showing SOS popup - silently fail
            }
        }

        function hideSOSPopup() {
            var chatBubble = document.getElementById('sosChatBubble');
            if (chatBubble) {
                // Clear any running interval
                if (chatBubble.dataset.intervalId) {
                    clearInterval(parseInt(chatBubble.dataset.intervalId));
                    chatBubble.dataset.intervalId = '';
                }
                chatBubble.style.display = 'none';
            }
        }

        function sendSOSMessage() {
            var scope = angular.element(document.body).scope();
            if (scope) {
                scope.$apply(function () {
                    var WorklistService = $injector.get('WorklistService');
                    SetSOSHistory({
                        CreatedBy: $sessionStorage.currentUserData.userId,
                        SOSMsg: $scope.DataObject.SOSMessage,
                        SOSName: "SOS Message",
                        TenantName: $sessionStorage.EnableRowsForSelectedTenants,
                        ChatGroupID: $sessionStorage.SpecialGroup ? $sessionStorage.SpecialGroup[0] : null,
                        Flag: 'N'
                    }).then(function (result) {
                        if(result && result.length > 0) {
                            console.log(result);
                            var SOSHistoryID = result[0].SOSHistoryID;
                            var usersPhoneNumbers = _.join(_.map(result, function (user) { return user.PhoneNumber; }), ',');
                            WorklistService.SendSOSMessage({
                                UsersPhoneNumbers: usersPhoneNumbers,
                                TextMessage: $scope.DataObject.SOSMessage,
                            }).then(function () {
                                toaster.success('SOS message has been shared!');
                                SetSOSHistory({
                                    SOSHistoryID : SOSHistoryID,
                                    Flag: 'M',
                                    CreatedBy: $sessionStorage.currentUserData.userId,
                                }).then(function (result1) {
                                    console.log(result1);
                                });
                            });
                        }
                    });
                });
            } else {
                toaster.error('SOS message has been shared!');
            }
        }

        // Function to validate and adjust button position within viewport bounds
        function validateButtonPosition() {
            if (!sosButton) return;
            
            try {
                // Get actual current position from rendered element (works with any scale)
                var rect = sosButton.getBoundingClientRect();
                var btnWidth = sosButton.offsetWidth || 60;
                var btnHeight = sosButton.offsetHeight || 60;
                
                // Calculate base position (CSS: left: calc(50% - 30px), top: 35px)
                var baseLeft = (window.innerWidth / 2) - (btnWidth / 2);
                var baseTop = 35; // Default top position
                
                // Calculate current transform offset from base position
                var transformX = rect.left - baseLeft;
                var transformY = rect.top - baseTop;
                
                // Calculate absolute position
                var absX = baseLeft + transformX;
                var absY = baseTop + transformY;
                
                // Get viewport bounds
                var maxX = window.innerWidth - btnWidth;
                var maxY = window.innerHeight - btnHeight;
                var minX = 0;
                var minY = 0;
                
                // Check if button is outside viewport and adjust if needed
                var needsAdjustment = false;
                var newTransformX = transformX;
                var newTransformY = transformY;
                
                if (absX < minX) {
                    newTransformX = -baseLeft;
                    needsAdjustment = true;
                } else if (absX > maxX) {
                    newTransformX = maxX - baseLeft;
                    needsAdjustment = true;
                }
                
                if (absY < minY) {
                    newTransformY = -baseTop;
                    needsAdjustment = true;
                } else if (absY > maxY) {
                    newTransformY = maxY - baseTop;
                    needsAdjustment = true;
                }
                
                // Apply adjusted position if needed
                if (needsAdjustment) {
                    sosButton.style.setProperty('transform', 'translate(' + newTransformX + 'px, ' + newTransformY + 'px)', 'important');
                }
            } catch (e) {
                // Ignore errors
            }
        }

        // Window resize handler to reposition button
        var resizeTimeout;
        function handleWindowResize() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                if (sosButton && sosButton.hasAttribute('data-sos-initialized')) {
                    validateButtonPosition();
                }
            }, 150);
        }

        function initSOSButton() {
            $timeout(function() {
                sosButton = document.getElementById('sos-floating-btn');
                if (!sosButton) {
                    setTimeout(initSOSButton, 100);
                    return;
                }

                if (sosButton.hasAttribute('data-sos-initialized')) {
                    // Button already initialized, just validate position
                    validateButtonPosition();
                    return;
                }
                sosButton.setAttribute('data-sos-initialized', 'true');

                sosButton.style.pointerEvents = 'auto';
                sosButton.style.cursor = 'grab';
                sosButton.style.touchAction = 'none';
                sosButton.style.userSelect = 'none';

                // Remove existing listeners
                sosButton.removeEventListener('mousedown', onMouseDown, false);
                sosButton.removeEventListener('touchstart', onTouchStart, false);
                sosButton.removeEventListener('click', onButtonClick, false);

                // Add drag and click listeners
                sosButton.addEventListener('mousedown', onMouseDown, false);
                sosButton.addEventListener('touchstart', onTouchStart, false);
                sosButton.addEventListener('click', onButtonClick, false);
                
                // Add window resize listener
                window.removeEventListener('resize', handleWindowResize);
                window.addEventListener('resize', handleWindowResize, false);
            }, 0);
        }

        // Event delegation for SOS button events
        document.addEventListener('mousedown', function(e) {
            var target = e.target;
            while (target && target !== document.body) {
                if (target.id === 'sos-floating-btn') {
                    e.stopPropagation();
                    onMouseDown(e);
                    return;
                }
                target = target.parentElement;
            }
        }, true);

        document.addEventListener('click', function(e) {
            var target = e.target;
            while (target && target !== document.body) {
                if (target.id === 'sos-floating-btn') {
                    e.stopPropagation();
                    onButtonClick(e);
                    return;
                }
                target = target.parentElement;
            }
        }, true);

        document.addEventListener('touchstart', function(e) {
            var target = e.target;
            while (target && target !== document.body) {
                if (target.id === 'sos-floating-btn') {
                    e.stopPropagation();
                    onTouchStart(e);
                    return;
                }
                target = target.parentElement;
            }
        }, true);

        // Initialize SOS button when DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                $timeout(initSOSButton, 0);
            });
        } else {
            $timeout(initSOSButton, 0);
        }

        // Watch for DOM changes (Angular ng-show/ng-if)
        $timeout(function () {
            var observer = new MutationObserver(function (mutations) {
                var sosBtn = document.getElementById('sos-floating-btn');
                if (sosBtn) {
                    if (!sosBtn.hasAttribute('data-sos-initialized')) {
                        initSOSButton();
                    } else {
                        // Button already initialized, validate position when visibility changes
                        $timeout(function() {
                            validateButtonPosition();
                        }, 100);
                    }
                }
            });

            var body = document.body;
            if (body) {
                observer.observe(body, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['ng-if', 'ng-show']
                });
            }
        }, 500);

        // Periodic initialization attempts
        var initAttempts = 0;
        var maxAttempts = 50;
        var initInterval = setInterval(function () {
            var sosBtn = document.getElementById('sos-floating-btn');
            if (sosBtn) {
                if (!sosBtn.hasAttribute('data-sos-initialized')) {
                    initSOSButton();
                    clearInterval(initInterval);
                } else {
                    // Button initialized, validate position periodically
                    validateButtonPosition();
                }
            }
            initAttempts++;
            if (initAttempts >= maxAttempts) {
                clearInterval(initInterval);
            }
        }, 100);

        // SOS Floating Button Functionality - Draggable and Clickable End

        $scope.restartTour = function () {
            vm.onTourClick();
            $scope.closeHelpView();
        }

        $scope.setStatus = function (status) {
            $scope.DataObject.WorklistPageHeaderParameter.Status = status;
            vm.worklistPageHeaderParameter = $scope.DataObject.WorklistPageHeaderParameter;
            vm.onStatusClick();
        }

        $scope.collapseFiler = function () {
            vm.onClearFilterClick();
        }

        $scope.getUserPayments = function () {
            vm.onUserPaymentClick();
        }

        $scope.refreshSignSummary = function () {
            vm.onRefreshClick();
        }

        $scope.closeHelpView = function () {
            $scope.DataObject.helpEleWrapper.value = false;
            $scope.DataObject.searchTourSteps = '';
            angular.element("#accordion .panel").show().removeClass('activeAccrPanel');
            angular.element("#accordion .panel-collapse").removeClass('in');
            angular.element("#accordion .panel .panel-heading .panel-title .accrbtn").addClass("collapsed");
            angular.element('#accordion .panel-title .accrbtn mark, #accordion .panel-body p mark').addClass('no-mark')
        }
        angular.element(".accrbtn").click(function () {
            if (angular.element(this).data('clicked', true)) {
                angular.element(".accrbtn").parent().parent().parent().removeClass('activeAccrPanel');
                angular.element(this).parent().parent().parent().addClass('activeAccrPanel');
                if (angular.element("#searchHelp").value != '') {
                    angular.element(this).parent().parent().siblings(".panel-collapse").collapse('hide');
                }
            }
        });
        angular.element("#accordion").on("shown.bs.collapse", function () {
            var panelEl = angular.element(this).find('.panel.activeAccrPanel:nth-child(n+14)');
            if (panelEl.length) {
                angular.element('.toursteps-accordn').animate({
                    scrollTop: angular.element(panelEl).offset().top + 100
                }, 500);
            }
        });
        angular.element("#searchHelp").on("keyup", function () {
            var value = angular.element(this).val().toLowerCase();
            var length = angular.element(this).val().length;
            angular.element("#accordion .panel-title .accrbtn, #accordion .panel-body p").filter(function () {
                angular.element(this).parent().parent().parent("#accordion .panel").toggle(angular.element(this).text().toLowerCase().indexOf(value) > -1)
            });

            // highlight text
            angular.element('#accordion .panel-title .accrbtn, #accordion .panel-body p').each(function () {
                var text = angular.element(this).text();
                var textL = text.toLowerCase();
                var index = textL.indexOf(value);
                angular.element("#accordion .panel-collapse").addClass('in');
                angular.element("#accordion .panel-title .accrbtn").removeClass('collapsed').attr("aria-expanded", true);
                if (index !== -1) {
                    var htmlR = text.substr(0, index) + '<mark>' + text.substr(index, length) + '</mark>' + text.substr(index + length);
                    angular.element(this).html(htmlR).show();
                    angular.element("#accordion .panel-collapse").removeClass('in');
                    angular.element("#accordion .panel-title .accrbtn").addClass('collapsed').attr("aria-expanded", false);
                }
            });
        });

        function GetBonusTooltipText() {
            if ($scope.DataObject.BonusDetails) {
                if ($scope.DataObject.BonusDetails.ReadCount < $scope.DataObject.BonusDetails.Target1) {
                    $scope.DataObject.BonusDetails.PendingCount = ($scope.DataObject.BonusDetails.Target1 - $scope.DataObject.BonusDetails.ReadCount);
                    $scope.DataObject.BonusTooltip = "Read " + $scope.DataObject.BonusDetails.PendingCount + " more " + $scope.DataObject.BonusDetails.BonusType + " to unlock the " + $scope.DataObject.BonusDetails.Reward1 + " bonus!";
                }
                else if ($scope.DataObject.BonusDetails.ReadCount >= $scope.DataObject.BonusDetails.Target1 &&
                    $scope.DataObject.BonusDetails.ReadCount < $scope.DataObject.BonusDetails.Target2) {
                    $scope.DataObject.BonusDetails.PendingCount = ($scope.DataObject.BonusDetails.Target2 - $scope.DataObject.BonusDetails.ReadCount);
                    $scope.DataObject.BonusTooltip = "Read " + $scope.DataObject.BonusDetails.PendingCount + " more " + $scope.DataObject.BonusDetails.BonusType + " to unlock the " + $scope.DataObject.BonusDetails.Reward2 + " bonus!";
                }
                else {
                    $scope.DataObject.BonusDetails.PendingCount = 0;
                    $scope.DataObject.BonusTooltip = "Congratulations! You have reached your target for the day. You will earn " + $scope.DataObject.BonusDetails.Reward2 + " more to your earnings!";
                }
            }
        }

        function SetSOSHistory(obj) {
            var d = $q.defer();
            var WorklistService = $injector.get('WorklistService');
            WorklistService.SetSOSHistory(obj).then(function (result) {
                d.resolve(result);
            }).catch(function (error) {
                d.reject(error);
            });
            return d.promise;
        }

        function GetXRayTodayTooltipText() {
            var xray = $scope.DataObject.WorklistPageHeaderParameter &&
                $scope.DataObject.WorklistPageHeaderParameter.XRayDetails;
            if (!xray) return;

            $scope.DataObject.XRayTodayTooltip = "You have read " + xray.ReadCount + " X-Ray(s) for SOL today. ";
        }
    };
})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * Decodes HTML character references (e.g. &#x27; &#xA; &amp;) into plain text.
 * The API HTML-encodes discussion fields (OrdersService.EncodeDiscussionFields);
 * bind the result with {{ }} so Angular renders it as text, never as HTML.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .filter('htmlDecode', htmlDecode);

    /** @ngInject */
    function htmlDecode() {
        var parser = new DOMParser();
        return function (text) {
            if (!text) return '';
            var encoded = String(text);
            if (encoded.indexOf('&') === -1) return encoded;
            var doc = parser.parseFromString(encoded, 'text/html');
            return doc.body ? doc.body.textContent : encoded;
        };
    }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .filter('capitalize', capitalize);

    /** @ngInject */
    function capitalize() {
        return function(input) {
            return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
        }
    }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

(function () {
    'use strict';

    angular.module('radico.pages.psorders.search')
        .controller('PSOrdersSearchListController', PSOrdersSearchListController);
    function PSOrdersSearchListController($scope, $stateParams, PSOrdersSearchService, $state, $sessionStorage, UserPreferenceService, $interval) {
        //getPatientsList
        $scope.PageNo = 1;
        $scope.PageSize = "25";
        $scope.TotalRows = "";
        $scope.Status = "RP";
        $scope.SelectedList = {};
        $scope.SingReport = {};
        $scope.SingReport.Index = 0;
        $scope.LastOpenedOrderID;
        $scope.ChooseNextStudy = false;
        $scope.isCollapsed = true;
        //$scope.RefreshTimmer = "00:00";

        $scope.CloseFrom = ""; //"RADFLOW" , "PS360"
        //$sessionStorage.PSEvent = false;

        var parser = new UAParser();
        $scope.browser = parser.getBrowser().name;


        // removed init function 
        /*function init() {
            try {                
                //console.log($sessionStorage.PSEvent);
                //if (!$sessionStorage.PSEvent) {
                //    console.log("insite");
                //    RadWhereCtrl.Start();
                //    $sessionStorage.PSEvent = true;
                //    RadWhereCtrl.StartListening();
                //    setTimeout(function () { RadWhereCtrl.Login('spatel', 'RAD(pass17)'); }, 5000);
                //} 
                //RadWhereCtrl.StopListening();
                //RadWhereCtrl.StartListening();
                //setTimeout(function () { RadWhereCtrl.Login('spatel', 'RAD(pass17)'); }, 5000);

            } catch (e) {
                //console.log(e);
                //alert("Unable to find the image in Synapse.");
            }
        }
        init();
        */
        $scope.formatted_date = function (date) {
            if (date) {
                var m = ("0" + (date.getMonth() + 1)).slice(-2); // in javascript month start from 0.
                var d = ("0" + date.getDate()).slice(-2); // add leading zero
                var y = date.getFullYear();
                if ('aN-aN-NaN' == (m + '-' + d + '-' + y)) return null;
                return m + '-' + d + '-' + y;
            }
            else {
                return null;
            }
        };
        $scope.pageChanged = function () {
            $scope.refresh();
        };
        $scope.pageSizeChanged = function () {
            $scope.PageNo = 1;
            $scope.refresh();
        };
        $scope.refresh = function () {
            $scope.isLoading = true;
            $scope.orderListFilter = {
                PageNum: $scope.PageNo,
                PageSize: $scope.PageSize,
                SiteID: $scope.SelectedList.Site ? $scope.SelectedList.Site.SiteID : null,
                LocationID: $scope.SelectedList.Location ? $scope.SelectedList.Location.LocationID : null,
                Accession: $scope.Accession,
                OrderDate: $scope.formatted_date($scope.OrderDate),
                PatientName: $scope.PatientName,
                PatientMRN: $scope.PatientMRN,
                PatientDOB: $scope.formatted_date($scope.DOB),
                PatientClass: $scope.SelectedList.PatientClass ? $scope.SelectedList.PatientClass.PatClass : null,
                ProviderPhysician: $scope.ProviderPhysician,
                Status: $scope.Status
            };
            PSOrdersSearchService.GetOrdersList($scope.orderListFilter).then(function (result) {
                $scope.orderList = result;
                if (result != null && result.length > 0) {
                    $scope.TotalRows = result[0].TotalRows;
                }
                else {
                    $scope.TotalRows = "0";
                }                
                $scope.isLoading = false;
            });
        };

        $scope.clearFilter = function () {
            $scope.PageNo = 1;
            $scope.PageSize = "25";
            $scope.Status = "RP";
            $scope.SelectedList.Site = null;
            $scope.SelectedList.Location = null;
            $scope.Accession = "";
            $scope.OrderDate = "";
            $scope.PatientName = "";
            $scope.PatientMRN = "";
            $scope.DOB = "";
            $scope.SelectedList.PatientClass = null;
            $scope.ProviderPhysician = "";

            $scope.refresh();
        };

        $scope.GetSitesAndLocations = function () {
            PSOrdersSearchService.GetSitesAndLocations().then(function (result) {
                $scope.SitesAndLocations = result;
            });
        };
        $scope.GetPatientClass = function (SelectedSite) {
            PSOrdersSearchService.GetPatientClass().then(function (result) {
                $scope.PatientClass = result;
            });
        };
        $scope.GetUserPreferences = function () {
            //$scope.isLoading = true;
            var userPreference = {
                UserID: $sessionStorage.currentUserData.userId,
                PreferenceType: "Choose Next Study",
            };
            UserPreferenceService.GetUserPreferences(userPreference).then(function (result) {
                result = result.UserPreferences;
                if (result != null && result.length > 0) {
                    if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                        $scope.ChooseNextStudy = result[0].PreferenceValue == "1" ? true : false;
                    }
                }
            });
        };

        //setInterval(function () {
        //    //alert($('#ModalSingReport').hasClass('in'));
        //    //alert($('#ModalSingReport').is(':visible'));
        //    if (!$('#ModalSingReport').is(':visible')) {
        //        //alert("Modal is visible")
        //        //alert("sdfs");
        //        $scope.refresh();
        //    }
        //}, 60000);


        $scope.GetPatientClass();
        $scope.GetSitesAndLocations();
        $scope.GetUserPreferences();
        $scope.refresh();
        startTimer(60);
        $scope.SelectedSiteChanged = function (SelectedSite) {
            $scope.Locations = null;
            $scope.SelectedList.Location = null;
            //$scope.SelectedSite = SelectedSite;
            var lookup = {};
            var result = [];
            if (SelectedSite) {
                var items = SelectedSite.Locations;
                items.forEach(function (item) {
                    var name = item.Location;

                    if (!(name in lookup)) {
                        lookup[name] = 1;
                        result.push(item);
                    }
                });
            }
            $scope.Locations = result;
        };

        function SetSignREportModal(index, OrderList) {
            $scope.SingReport.CurrentSite = OrderList[index].Site + (OrderList[index].Location ? "(" + OrderList[index].Location + ")" : "");
            $scope.SingReport.CurrentPatientMRN = OrderList[index].PatientMRN;
            $scope.SingReport.CurrentPatient = OrderList[index].PatientName;
            $scope.SingReport.CurrentAccession = OrderList[index].Accession;
            $scope.setSelected(OrderList[index].OrderID);

            $scope.SingReport.PrevToolTip = "";
            $scope.SingReport.NextToolTip = "";
            if (index > 0) {
                $scope.SingReport.PrevToolTip = "Name: " + OrderList[index - 1].PatientName + " " + "MRN: " + OrderList[index - 1].PatientMRN + " " + "Accession: " + OrderList[index - 1].Accession;
            }
            else if (index <= 0) {
                $scope.SingReport.PrevToolTip = "No Order";
            }
            if (OrderList.length > index + 1) {
                $scope.SingReport.NextToolTip = "Name: " + OrderList[index + 1].PatientName + " " + "MRN: " + OrderList[index + 1].PatientMRN + " " + "Accession: " + OrderList[index + 1].Accession;
            }
            else if (OrderList.length <= index + 1) {
                $scope.SingReport.NextToolTip = "No Order";
            }

            if (OrderList[index].Status == "RP" || OrderList[index].Status == "C") {
                if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                    if ($scope.ChooseNextStudy) {
                        if ($scope.LastOpenedOrderID != null) {
                            //$scope.DeleteOpenOrder();
                        }
                    }
                    setTimeout(function () { OpenSynapseStudy(OrderList[index].Site, OrderList[index].Accession); }, 500);
                }
                else {
                    var param = 'SiteName=' + OrderList[index].Site + '%26Accession=' + OrderList[index].Accession;
                    //window.open("alert:http://localhost:55180/app/src/OpenSynapse.html#?" + param, "_self");
                    //window.open("alert:http://test1.radamatic.com/OpenSynapse.html#?" + param, "_self");
                    window.open("alert:https://test2.radamatic.com/OpenSynapse.html#?" + param, "_self");
                }
            }
        }

        $scope.OpenSingReport = function (index, OrderList) {

            //$scope.SingReport.OrderList = [];
            //OrderList.forEach(function (order) {

            //    if (order.Checked) {
            //        $scope.SingReport.OrderList.push(order);
            //    }
            //});
            //$scope.SingReport.Index = $scope.SingReport.OrderList.findIndex(record => record.OrderID === OrderList[index].OrderID);
            ////$scope.records.findIndex(record => record.Country === "Austria");


            $scope.SingReport.Index = index;
            $scope.SingReport.OrderList = OrderList;
            var openOrders = {
                OrderId: $scope.SingReport.OrderList[$scope.SingReport.Index].OrderID,
                ProviderID: $sessionStorage.currentUserData.userId
            };
            PSOrdersSearchService.GetOpenOrder(openOrders).then(function (result) {
                if (result.length > 0) {
                    if ($scope.ChooseNextStudy) {
                        alert("This order id locked by " + result[0].ProviderName + ".");
                        return;
                    }
                    else {
                        var cnf = confirm("This order id locked by " + result[0].ProviderName + ".\nAre you sure you want to skip?");
                        if (cnf == true) {
                            $scope.NextRec();
                            //setTimeout(function () { $(".modal-backdrop").remove(); }, 500);
                            //$('#ModalSingReport').modal('show');
                        } else {
                            return;
                        }
                    }

                }
                else {
                    if ($scope.LastOpenedOrderID != null) {
                        $scope.DeleteOpenOrder();
                    }
                    $scope.InsertOpenOrder();
                    SetSignREportModal($scope.SingReport.Index, $scope.SingReport.OrderList);
                    if (!$scope.ChooseNextStudy) {
                        setTimeout(function () { $(".modal-backdrop").remove(); }, 500);
                        $('#ModalSingReport').modal('show');
                    }
                }
            });
        };
        $scope.PrevRec = function () {
            if ($scope.SingReport.Index > 0) {
                $scope.SingReport.Index = $scope.SingReport.Index - 1;
                //SetSignREportModal($scope.SingReport.Index, $scope.SingReport.OrderList);
                var openOrders = {
                    OrderId: $scope.SingReport.OrderList[$scope.SingReport.Index].OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId
                };
                PSOrdersSearchService.GetOpenOrder(openOrders).then(function (result) {
                    if (result.length > 0) {
                        $scope.PrevRec();
                        return;
                    }
                    else {
                        if ($scope.LastOpenedOrderID != null) {
                            $scope.DeleteOpenOrder();
                        }
                        $scope.InsertOpenOrder();
                        SetSignREportModal($scope.SingReport.Index, $scope.SingReport.OrderList);
                    }
                });
            }
            else {
                $('#ModalSingReport').modal('hide');
            }
        };

        $scope.NextRec = function () {
            if ($scope.SingReport.Index < $scope.SingReport.OrderList.length - 1) {
                $scope.SingReport.Index = $scope.SingReport.Index + 1;
                //var OpenOrder = $scope.GetOpenOrder();
                var openOrders = {
                    OrderId: $scope.SingReport.OrderList[$scope.SingReport.Index].OrderID,
                    ProviderID: $sessionStorage.currentUserData.userId
                };
                PSOrdersSearchService.GetOpenOrder(openOrders).then(function (result) {
                    if (result.length > 0) {
                        $scope.NextRec();
                        return;
                    }
                    else {
                        if ($scope.LastOpenedOrderID != null) {
                            $scope.DeleteOpenOrder();
                        }
                        $scope.InsertOpenOrder();
                        setTimeout(function () { $(".modal-backdrop").remove(); }, 500);
                        $('#ModalSingReport').modal('show');
                        SetSignREportModal($scope.SingReport.Index, $scope.SingReport.OrderList);
                    }
                });
            }
            else {
                $('#ModalSingReport').modal('hide');
            }
        };
        $scope.SignAndNextRec = function () {
            //var cnf = confirm("Are you sure you want to sign this report?");
            //if (cnf == true) {
            //    $scope.SignReport("NEXT");
            //}
            //else {
            //    $scope.NextRec();
            //}
            $scope.SignReport("NEXT");
        };
        $scope.SignAndPrevRec = function () {
            //var cnf = confirm("Are you sure you want to sign this report?");
            //if (cnf == true) {
            //    $scope.SignReport("PREV");
            //}
            //else {
            //    $scope.PrevRec();
            //}
            $scope.SignReport("PREV");

        };
        $scope.setSelected = function (SelectedOrderID) {
            $scope.SelectedOrderID = SelectedOrderID;
            //console.log(idSelectedVote);
        };
        $scope.SignReport = function (navFlag) {

            $scope.isLoading = true;

            $scope.navFlag = navFlag;

            $scope.SingbtnDisabled = true;
            var psuserFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                SiteID: $scope.SingReport.OrderList[$scope.SingReport.Index].SiteID,
                LocationID: $scope.SingReport.OrderList[$scope.SingReport.Index].LocationID,
                InstitutionID: $scope.SingReport.OrderList[$scope.SingReport.Index].InstitutionID
            };
            PSOrdersSearchService.CheckPSUserBySite(psuserFilter).then(function (result) {
                $scope.PSUser = result;
                //if ($scope.PSUser == null || $scope.PSUser.length <= 0 || ($scope.PSUser[0].CreateORU == true && $scope.PSUser[0].IsValid.toString().toUpperCase() == "FALSE") || ($scope.PSUser != null && $scope.PSUser.length > 0 && $scope.PSUser[0].IsValid.toString().toUpperCase() == "FALSE")) {
                if ($scope.PSUser == null || $scope.PSUser.length <= 0 || ($scope.PSUser[0].CreateORU == true && $scope.PSUser[0].IsValid.toString().toUpperCase() == "FALSE")) {
                    //if ($scope.PSUser == null || $scope.PSUser.length <= 0 || ($scope.PSUser != null && $scope.PSUser.length > 0 && $scope.PSUser[0].IsValid.toString().toUpperCase() == "FALSE")) {
                        $scope.PSUser.Username = $scope.PSUser != null && $scope.PSUser.length > 0 ? $scope.PSUser[0].UserName : "";
                        $scope.isLoading = false;
                        setTimeout(function () { $(".modal-backdrop").remove(); }, 500);
                        $('#ModalPSUser').modal('show');
                        if ($scope.PSUser.length > 0) { alert("Please update your PowerScribe password."); }
                        $scope.SingbtnDisabled = false;
                    //}
                }
                else {
                    var reportView = {
                        Site: $scope.SingReport.OrderList[$scope.SingReport.Index].Site,
                        OrderID: $scope.SingReport.OrderList[$scope.SingReport.Index].OrderID,
                        Accession: $scope.SingReport.OrderList[$scope.SingReport.Index].Accession,
                        SignBy: $sessionStorage.currentUserData.userId,
                        SignByName: $sessionStorage.currentUserData.displayName,
                        SignDate: $filter('CSTDateTime')(moment().format("YYYY-MM-DD HH:mm:ss")),
                        SourceSignDate: moment().format("YYYY-MM-DDTHH:mm:ss")
                    };
                    setTimeout(function () {
                        PSOrdersSearchService.SaveReport(reportView).then(function (result) {
                            if (!result) {
                                $scope.isLoading = false;
                                var cnf = confirm("Empty Report can not be signed!\nAre you sure you want to skip?");
                                if (cnf == true) {
                                    //if (!$scope.ChooseNextStudy) {
                                    //    if (navFlag == "NEXT") {
                                    //        $scope.NextRec();
                                    //    }
                                    //    else if (navFlag == "PREV") {
                                    //        $scope.PrevRec();
                                    //    }
                                    //}
                                    //else {
                                    //    if ($scope.LastOpenedOrderID != null) {
                                    //        $scope.DeleteOpenOrder();
                                    //    }
                                    //}
                                    if (navFlag == "NEXT") {
                                        $scope.NextRec();
                                    }
                                    else if (navFlag == "PREV") {
                                        $scope.PrevRec();
                                    }
                                    $scope.SingbtnDisabled = false;
                                }
                                else {
                                    $scope.SingbtnDisabled = false;
                                    //return;
                                }
                                if ($scope.ChooseNextStudy) {
                                    if ($scope.LastOpenedOrderID != null) {
                                        $scope.DeleteOpenOrder();
                                    }
                                }
                            }
                            else {
                                $scope.isLoading = false;
                                if (!$scope.ChooseNextStudy) {
                                    //$scope.NextRec();                                
                                    if (navFlag == "NEXT") {
                                        $scope.NextRec();
                                    }
                                    else if (navFlag == "PREV") {
                                        $scope.PrevRec();
                                    }
                                    $scope.SingbtnDisabled = false;
                                }
                                else {
                                    //remove object form list
                                    //var index = $scope.bdays.indexOf(item)
                                    //$scope.SingReport.OrderList.splice($scope.SingReport.Index, 1);
                                    $scope.refresh();
                                    //$scope.bdays.splice(index, 1);
                                }
                            }
                        });
                    }, 3000);

                }
            });
            //$scope.SingNavDisabled = true;
        };
        //function SaveReport() {
        //}
        $scope.InsertPSUsersBySIte = function () {
            var psuserFilter = {
                UserId: $sessionStorage.currentUserData.userId,
                //Site: $scope.SingReport.OrderList[$scope.SingReport.Index].Site,
                //Location: $scope.SingReport.OrderList[$scope.SingReport.Index].Location,
                SiteID: $scope.SingReport.OrderList[$scope.SingReport.Index].SiteID,
                LocationID: $scope.SingReport.OrderList[$scope.SingReport.Index].LocationID,
                UserName: $scope.PSUser.Username,
                Password: $scope.PSUser.Password,
            };
            PSOrdersSearchService.InsertPSUsersBySIte(psuserFilter).then(function (result) {
                $('#ModalPSUser').modal('hide');
                $scope.SignReport($scope.navFlag);
            });
        };
        $scope.InsertOpenOrder = function () {
            //alert("insert" + $scope.SingReport.OrderList[$scope.SingReport.Index].OrderID);
            $scope.LastOpenedOrderID = $scope.SingReport.OrderList[$scope.SingReport.Index].OrderID;
            var openOrders = {
                OrderId: $scope.SingReport.OrderList[$scope.SingReport.Index].OrderID,
                ProviderID: $sessionStorage.currentUserData.userId,
                ProviderName: $sessionStorage.currentUserData.displayName,
                OpenDateTime: new Date().toLocaleString()
            };
            PSOrdersSearchService.InsertOpenOrder(openOrders).then(function (result) {
                //$('#ModalPSUser').modal('hide');
            });
        };
        $scope.DeleteOpenOrder = function () {
            //alert("deletee" + $scope.LastOpenedOrderID);
            if ($scope.LastOpenedOrderID != null) {
                var openOrders = {
                    OrderId: $scope.LastOpenedOrderID,
                    UserId: $sessionStorage.currentUserData.userId
                };
                PSOrdersSearchService.DeleteOpenOrder(openOrders).then(function (result) {
                    //$('#ModalPSUser').modal('hide');
                });
            }

        };
        $scope.GetOpenOrder = function () {
            var openOrders = {
                OrderId: $scope.SingReport.OrderList[$scope.SingReport.Index].OrderID
            };
            PSOrdersSearchService.GetOpenOrder(openOrders).then(function (result) {
                $scope.OpenOrder = result;
            });
        };


        //$scope.RefreshTimmer = "1

        function startTimer(duration) {
            var timer = duration, minutes, seconds;
            //setInterval(function () {
            //    minutes = parseInt(timer / 60, 10);
            //    seconds = parseInt(timer % 60, 10);

            //    minutes = minutes < 10 ? "0" + minutes : minutes;
            //    seconds = seconds < 10 ? "0" + seconds : seconds;

            //    $scope.RefreshTimmer = minutes + ":" + seconds;

            //    if (--timer < 0) {
            //        //alert('timeup');
            //        timer = duration;
            //        $scope.refresh();
            //    }
            //}, 1000);
            $interval(function () {
                minutes = parseInt(timer / 60, 10);
                seconds = parseInt(timer % 60, 10);

                minutes = minutes < 10 ? "0" + minutes : minutes;
                seconds = seconds < 10 ? "0" + seconds : seconds;

                $scope.RefreshTimmer = minutes + ":" + seconds;

                if (--timer < 0) {
                    //alert('timeup');
                    timer = duration;
                    $scope.refresh();
                }
            }, 1000);
        }

        //window.onload = function () {
        //    var fiveMinutes = 15,
        //        display = document.querySelector('#time');
        //    startTimer(fiveMinutes, display);
        //};

        $("#ModalSingReport").on('hide.bs.modal', function () {
            //alert('The modal is about to be hidden.');

            if ($scope.LastOpenedOrderID != null) {
                $scope.DeleteOpenOrder();
            }
            $scope.refresh();
        });

        $("#ModalPSUser").on('hide.bs.modal', function () {
            //alert('The modal is about to be hidden.');
            //$scope.SignReport($scope.navFlag);
        });


        //$scope.CheckUncheckHeader = function () {
        //    $scope.IsAllChecked = true;
        //    for (var i = 0; i < $scope.orderList.length; i++) {
        //        if (!$scope.orderList[i].Checked) {
        //            $scope.IsAllChecked = false;
        //            break;
        //        }
        //    };
        //};
        ////$scope.CheckUncheckHeader();

        //$scope.CheckUncheckAll = function () {
        //    for (var i = 0; i < $scope.orderList.length; i++) {
        //        $scope.orderList[i].Checked = $scope.IsAllChecked;
        //    }
        //};


        ///------------------ Code FOR IE Use Only ------------------------------------

        //function OnReportClosed(SiteName, AccessionNumbers) {
        //    alert("Report Closed  SiteName : " + SiteName + " AccessionNumbers :" + AccessionNumbers);
        //    var cnf = confirm("Are you sure you want to sign this report?");
        //    if (cnf == true) {
        //        $scope.SignReport("NEXT");
        //    }
        //    else {
        //        $scope.NextRec();
        //    }
        //};
        function OpenSynapseStudy(SiteName, Accession) {
            try {
                var oSynapseAPI = new ActiveXObject("Synapse.SynapseAPI");
                var sStudyPath = oSynapseAPI.MakePath(1, Accession);
                oSynapseAPI.OpenSynapseExplorer("Synapse", "https://pacs.texasradiology.com", sStudyPath);

            } catch (e) {
                console.log(e);
                alert("Unable to find the image in Synapse.");
            }
            try {
                RadWhereCtrl.Start();
                //RadWhereCtrl.StopListening();
                //RadWhereCtrl.StartListening();                
                //if (!RadWhereCtrl.LoggedIn) {
                //    var r = RadWhereCtrl.Login('spatel', 'RAD(pass17)');
                //}
                //console.log($sessionStorage.PSEvent);
                //if (!$sessionStorage.PSEvent) {
                //    console.log("insite");
                //    RadWhereCtrl.Start();
                //    $sessionStorage.PSEvent = true;
                //    RadWhereCtrl.StartListening();
                //    //setTimeout(function () { RadWhereCtrl.Login('spatel', 'RAD(pass17)'); }, 5000);                    
                //    if (!RadWhereCtrl.LoggedIn) {
                //        var r = RadWhereCtrl.Login('spatel', 'RAD(pass17)');
                //    }
                //} 
                //RadWhereCtrl.Login('spatel', 'RAD(pass17)');
                try {
                    if (RadWhereCtrl.accessionNumbers) {
                        $scope.CloseFrom = "RADFLOW"; //"RADFLOW" , "PS360"
                        var r = RadWhereCtrl.CloseReport(false, false);
                        while (!r) {
                            r = RadWhereCtrl.CloseReport(false, false);
                        }
                    }
                }
                catch (e) {
                    //alert("Unable to find the order in PS360.");
                    console.log(e);
                }
                //Synchronize accession with PowerScribe 360
                RadWhereCtrl.OpenReport(SiteName, Accession);
                //RadWhereCtrl.PreviewOrders('', value);

            } catch (e) {
                alert("Unable to find the order in PS360.");
                console.log(e);
            }
        }
        ///------------------ Code FOR IE Use Only ------------------------------------



        //PSOrdersSearchService.GetAllSites().then(function (result) {
        //    $scope.Sites = result.Items;
        //    $scope.isLoading = false;
        //});        
    }

})();


(function () {
  "use strict";

  angular.module("radico.pages.questionnaire").component("orderQuestionnaireForm", {
    templateUrl: "app/pages/questionnaire/components/order-questionnaire-form/order-questionnaire-form.html",
    bindings: {
      orderId: "<",
      patientId: "<",
      onChanged: "&",
    },

    controller: ComponentController,
  });
  /** @ngInject */
  function ComponentController(
    $scope,
    questionnaireService,
    questionnaireCommonService,
    commonService
  ) {
    var vm = this;

    vm.$onInit = function () {
      initComponent();
    };
    function initComponent() {
      initData();
    }

    function initData() {
      populatequestionnaireForms();
    }
    function populatequestionnaireForms() {
      vm.isLoading = true;
      questionnaireService
        .getQuestionnaireForms()
        .then(function (result) {
          var questionnaireForms = result;
          vm.questionnaireForms = questionnaireForms;
          vm.isLoading = false;
        }, function (error) {
          vm.isLoading = false;
        });

    }

  }
})();

(function () {
  "use strict";

  angular.module("radico.pages.questionnaire").component("questionnaireForm", {
    templateUrl: "app/pages/questionnaire/components/questionnaire-form/questionnaire-form.html",
    bindings: {
      formInfo: "<",
      orderId: "<",
      patientId: "<",
      onChanged: "&",
    },

    controller: ComponentController,
  });
  /** @ngInject */
  function ComponentController(
    $scope,
    $sessionStorage,
    questionnaireService,
    questionnaireCommonService,
    commonService
  ) {
    var vm = this;


    vm.$onInit = function () {
      initComponent();
    };
    function initComponent() {
      populateData();
    }

    function populateData() {
      populateFormCategories();
    }

    function populateFormCategories() {
      vm.isLoading = true;
      questionnaireService
        .getQuestionnaireFormContent(vm.formInfo.questionnaireFormId)
        .then(function (formCategories) {
          questionnaireCommonService.appendMissingQuestionsOptions(formCategories);
          validationQuestionKeys(formCategories)
          populateQuestionAnswers(formCategories);
        });
    }

    function populateQuestionAnswers(formCategories) {
      var answerTarget = {
        questionnaireFormId: vm.formInfo.questionnaireFormId,
        orderId: vm.orderId,
        patientId: vm.patientId,
      }
      questionnaireService
        .getQuestionnaireAnswers(answerTarget)
        .then(function (questionAnswers) {
          console.log({'formCategories': formCategories})
          var allQuestions = questionnaireCommonService.getAllAvaliableQuestions(formCategories);
          _.forEach(allQuestions, function (question) {
            var questionAnswer = _.find(questionAnswers, function (a) {
              return commonService.stringEqual(a.questionnaireQuestionKey, question.key);
            });
            if (questionAnswer) {
              if (questionAnswer.additionalAnswerValue && question.additionalQuestion) {
                question.additionalQuestion.answer = question.additionalQuestion.answer || {};;
                question.additionalQuestion.answer.answerValue = questionAnswer.additionalAnswerValue;
              }
              question.answer = questionAnswer;
            }

          })

          vm.formCategories = formCategories;
          vm.isLoading = false;
        }, function (error) {
          vm.formCategories = formCategories;
          vm.isLoading = false;

        }
        );
    }

    function validationQuestionKeys(formCategories) {
      var allQuestions = questionnaireCommonService.getAllAvaliableQuestions(formCategories);
      var duplicateKeyQuestions = [];
      var questionKeyDict = {};
      _.forEach(allQuestions, function (question) {
        if (questionKeyDict[question.key]) {
          duplicateKeyQuestions.push(question);
          questionKeyDict[question.key] = question;
        }
      })
      console.log({ 'duplicateKeyQuestions': duplicateKeyQuestions })

      if (duplicateKeyQuestions.length) {

        swal({
          html: true,
          title: 'Invalid question keys',
          text: _.join(_.map(duplicateKeyQuestions, function (q) {
            return q.name;
          }), '<br />')
        });
      }
    }
    vm.saveForm = function (formRef) {
      if (!formRef.$valid) {
        swal("Please enter all require fields");
        return;
      }
      var saveRequest = {
        questionAnswers: getQuestionAnswers(),
        target: {
          questionnaireFormId: vm.formInfo.questionnaireFormId,
          orderId: vm.orderId,
          patientId: vm.patientId,
          createdBy: $sessionStorage.currentUserData.userId,
          modifiedBy: $sessionStorage.currentUserData.userId,
        }
      };

      questionnaireService
        .saveFormAnswers(saveRequest)
        .then(function (result) {
            swal("Form Saved Successfully");
          populateData();
        });


    };

    function getQuestionAnswers() {
      var questionAnswers = [];
      var allQuestions = questionnaireCommonService.getAllAvaliableQuestions(vm.formCategories);
      console.log({ allQuestions: allQuestions })
      _.forEach(allQuestions, function (question) {
        var answer = question.answer;

        answer.answerValue = getAnswerValue(question, answer.answerValue);
        answer.additionalAnswerValue = getAnswerValue(question.additionalQuestion, _.get(question, 'additionalQuestion.answer.answerValue'));
        answer.questionnaireFormId = vm.formInfo.questionnaireFormId;
        answer.orderId = vm.orderId;
        answer.patientId = vm.patientId;
        answer.originalQuestionName = question.name;
        answer.questionnaireQuestionKey = question.key;

        questionAnswers.push(answer)
      })

      return questionAnswers;
    }

    function getAnswerValue(question, answerValue) {
      if (commonService.stringEqual(_.get(question, 'controlType'), 'date') && answerValue) {
        answerValue = commonService.formatDate(answerValue);
      }
      else if (commonService.stringEqual(_.get(question, 'controlType'), 'ListCheckbox')) {
        var selectedAnswerOptions = _.filter(question.answerOptions, function (ao) {
          return ao.isSelected
        });
        answerValue = _.join(_.map(selectedAnswerOptions, function (ao) {
          return ao.optionValue;
        }), ',');
      }
      else if (commonService.stringEqual(_.get(question, 'controlType'), 'Checkbox')) {
        if(question.controlOptions.trueValue && answerValue === true) {
          answerValue = question.controlOptions.trueValue;
        }
        if(question.controlOptions.falseValue && answerValue === false) {
          answerValue = question.controlOptions.falseValue;
        }
      }
      return answerValue;
    }
  }
})();

(function () {
    'use strict';

    angular.module('radico.pages.settings.techform')
        .controller('TechFormDetailsController', TechFormDetailsController);
    function TechFormDetailsController($scope, $window, TechFormService, $sessionStorage, toastr, $stateParams, $state, $timeout, $q, $interval, APP_CONSTANTS, WorklistService) {
        $scope.TechForm = {
            Locations: [],
            Procedures: [],
            Modalities: [],
        }
        function errorPop(str) {
            toastr.error(str, 'Error');
        }
        function infoPop(str) {
            toastr.info(str, 'Information');
        }
        $scope.SetTechForm = function () {
            $scope.TechForm.UserID = $sessionStorage.currentUserData.userId;
            $scope.TechForm.CreatedBy = $sessionStorage.currentUserData.userId;
            //add the location and procesdre 
            $scope.TechForm.Locations = [];
            _.each($scope.TechForm._Locations, function (l) {
                $scope.TechForm.Locations.push({ LocationID: l.LocationID, CreatedBy: $sessionStorage.currentUserData.userId });
            });
            $scope.TechForm.Procedures = [];
            _.each($scope.TechForm._Procedures, function (p) {
                $scope.TechForm.Procedures.push({ ProcedureCode: p.CPT_Code, CreatedBy: $sessionStorage.currentUserData.userId });
            });
            $scope.TechForm.Modalities = [];
            _.each($scope.TechForm._Modalities, function (p) {
                $scope.TechForm.Modalities.push({ ModalityID: p.Id, CreatedBy: $sessionStorage.currentUserData.userId });
            });
            $scope.TechForm.IsActive = true;
            var techForm = angular.copy($scope.TechForm);
            delete techForm._Locations;
            delete techForm._Procedures;
            delete techForm._Modalities;
            var reasons = [];
            _.each(techForm.Reasons, function (r) {
                if (r.ReasonCondition && r.ReasonKeyword) {
                    reasons.push(r);
                }
            });
            techForm.Reasons = reasons;
            $scope.isLoading = true;

            TechFormService.SetTechForm(techForm).then(function (result) {
                $scope.isLoading = false;
                $scope.Cancel();
                infoPop("Save successfully.");
            }, function (error) {
                $scope.isLoading = false;
            });
        };
        $scope.$on('$viewContentLoaded', function () {
            if ($stateParams.Template) {
                $scope.TechForm = $stateParams.Template;
                var iframe = document.getElementById('tempid');
                iframe.contentDocument.documentElement.innerHTML = DOMPurify.sanitize($scope.TechForm.JsonValue);
                ConverttoJsonObj(iframe.contentDocument.documentElement.getElementsByTagName('body')[0]);
                document.getElementById('divTechForm').innerHTML = DOMPurify.sanitize(iframe.contentDocument.documentElement.getElementsByTagName('body')[0].innerHTML);
            }
            $scope.GetAllSitesAndLocations($scope.TechForm);
            $scope.GetProcedure(null, $scope.TechForm);
            $scope.GetModality($scope.TechForm);
        });
        $scope.GetAllSitesAndLocations = function (template) {
            //var d = $q.defer();
            //WorklistService.GetAllSitesAndLocations().then(function (result) {
            $scope.Locations = [];
            TechFormService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.Locations = result;
                if (template) {
                    template._Locations = [];
                    _.each(template.Locations, function (l) {
                        //don't make it ===, type missmach.
                        template._Locations.push(_.filter($scope.Locations, function (f) { return l.LocationID == f.LocationID; })[0]);
                    });
                }
                //d.resolve();
            });
            //return d.promise;
        };
        $scope.GetProcedure = function (search, template) {
            $scope.Procedures = [];
            TechFormService.GetGetProcedure(search).then(function (result) {
                $scope.Procedures = result;
                if (template) {
                    template._Procedures = [];
                    _.each(template.Procedures, function (l) {
                        template._Procedures.push(_.filter($scope.Procedures, function (f) { return l.CPT_Code === f.CPT_Code; })[0]);
                    });
                }
            });
        };
        $scope.GetModality = function (template) {
            WorklistService.GetModality().then(function (result) {
                $scope.Modalities = result;
                if (template) {
                    template._Modalities = [];
                    _.each(template.Modalities, function (l) {
                        template._Modalities.push(_.filter($scope.Modalities, function (f) { return l.ModalityID == f.Id; })[0]);
                    });
                }
            });
        };
        $scope.uploadFile = function (input) {
            if (input.files && input.files.length > 0) {
                angular.forEach(input.files, function (file) {
                    var reader = new FileReader();
                    reader.onload = function () {
                        $scope.$apply(function ($scope) {
                            var doc = {};
                            doc.fileContentBase64 = reader.result;
                            doc.Base64 = reader.result.split(',')[1];
                            doc.Filename = file.name;
                            doc.Filetype = file.type;
                            // Parse the uploaded form in an inert DOMParser document: nothing in it runs or loads.
                            var parsedForm = new DOMParser().parseFromString(doc.fileContentBase64, 'text/html');
                            $scope.TechForm.JsonValue = doc.fileContentBase64;
                            ConverttoJsonObj(parsedForm.body);
                            document.getElementById('divTechForm').innerHTML = DOMPurify.sanitize(parsedForm.body.innerHTML);

                            var d = parsedForm.getElementsByTagName('script')[2].textContent
                            var parser = new DOMParser();
                            var xmlDoc = parser.parseFromString(d, "text/xml");
                            $scope.TechForm.TechFormName = xmlDoc.getElementsByTagName("dr_code")[0].textContent;
                            $scope.TechForm.Description = xmlDoc.getElementsByTagName("dr_typename")[0].textContent;
                        });
                    };
                    //reader.readAsDataURL(file);
                    reader.readAsText(file, "UTF-8");
                });
                // JS for file upload input controller
                var browseFileVal = angular.element('#fileInput')[0].files[0].name;
                angular.element('#fileInput').prev('label').text(browseFileVal);
            }
        };
        $scope.uploadFiles = function (input) {
            if (input.files && input.files.length > 0) {
                angular.forEach(input.files, function (file) {
                    var reader = new FileReader();
                    reader.onload = function () {
                        $scope.$apply(function ($scope) {
                            try {
                                var parsedForm = new DOMParser().parseFromString(reader.result, 'text/html');
                                var d = parsedForm.getElementsByTagName('script')[2].textContent
                                var parser = new DOMParser();
                                var xmlDoc = parser.parseFromString(d, "text/xml");
                                $scope.TechForm.TechFormName = xmlDoc.getElementsByTagName("dr_code")[0].textContent;
                                $scope.TechForm.Description = xmlDoc.getElementsByTagName("dr_typename")[0].textContent;
                                var techForm = {
                                    TechFormName: xmlDoc.getElementsByTagName("dr_code")[0].textContent,
                                    Description: xmlDoc.getElementsByTagName("dr_typename")[0].textContent,
                                    UserID: $sessionStorage.currentUserData.userId,
                                    CreatedBy: $sessionStorage.currentUserData.userId,
                                    Procedures: [],
                                    JsonValue: parsedForm.head.innerHTML + parsedForm.body.innerHTML,
                                    IsActive: true,
                                }
                                TechFormService.SetTechForm(techForm).then(function (result) {
                                    infoPop("Save successfully.");
                                }, function (error) {
                                    console.log(error);
                                });
                            } catch (e) {
                                //console.log(e);
                                console.log(file.name);
                            }

                        });
                    };
                    //reader.readAsDataURL(file);
                    reader.readAsText(file, "UTF-8");
                });

            }
        };
        $scope.Cancel = function () {
            $state.go('settings.techformlist', { 'filterData': $stateParams.filterData });
        }
        function ConverttoJsonObj(body) {
            var nodeIterator = document.createNodeIterator(body, NodeFilter.SHOW_ELEMENT,
                function (node) {
                    //node.textContent = node.textContent.replace(/\uFEFF/g, "");
                    return NodeFilter.FILTER_ACCEPT;
                    //return node.textContent.length > 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
                });
            var currentNode;//= nodeIterator.nextNode(); 
            var techForm = [];
            while (currentNode = nodeIterator.nextNode()) {
                //if (!['BODY', 'DIV', 'TABLE', 'TBODY', 'TR', 'TD', 'OPTION'].includes(currentNode.nodeName)) {
                //    if (currentNode.nodeName == "#text"
                //        && currentNode.parentElement.textContent == currentNode.textContent
                //        && !['TD'].includes(currentNode.parentElement.nodeName)) {

                //    } else {
                //        //console.log(currentNode);
                //        var obj = {
                //            Type: currentNode.nodeName,
                //            Text: currentNode.textContent,
                //        }
                //        console.log(obj);
                //    }
                //}
                if (['TABLE'].includes(currentNode.nodeName)) {
                    //currentNode.getAttribute()
                    //currentNode.setAttribute('class', 'table pos-rel wh-table table-scroll');
                    //currentNode.setAttribute('style', currentNode.getAttribute('style')+';width:auto');
                }


            }

            //var obj = {}
            //_.each(body.children, function (node) {


            //});
        }


    }

})();


(function () {
    'use strict';

    angular.module('radico.pages.settings.techform')
        .controller('TechFormListController', TechFormListController);
    function TechFormListController($scope, $window, TechFormService, $sessionStorage, toastr, $state, $stateParams, WorklistService) {
        function errorPop(str) {
            toastr.error(str, 'Error');
        }
        function infoPop(str) {
            toastr.info(str, 'Information');
        }
        $scope.filter = {};
        $scope.filter.Type = "Template";
        //$scope.locationtooltip = 'Choose a Location';
        $scope.$on('$viewContentLoaded', function () {
            $scope.filterData = $stateParams.filterData;
            $scope.UserID = $sessionStorage.currentUserData.userId;
            //$scope.UserRole = $sessionStorage.currentUserData.roles;
            $scope.AllowedUserRoles = ['Admin', 'SuperAdmin'];
            $scope.isUserRoleIncluded = $scope.AllowedUserRoles.includes($sessionStorage.currentUserData.roles)

            $scope.GetAllSitesAndLocations();
            $scope.GetProcedure();
            $scope.GetModality();
            if ($scope.filterData) {
                $scope.VRTemplate_Options.dataSource._page = $scope.filterData.filter.PageNo;
                $scope.VRTemplate_Options.dataSource._pageSize = $scope.filterData.filter.PageSize;
            }
        });

        $scope.VRTemplate_Options = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: function (options) {
                        var params = options.data;
                        $scope.filter.PageSize = options.data.pageSize;
                        $scope.filter.PageNo = options.data.page;
                        if ($scope.filterData) {
                            $scope.filter = $scope.filterData.filter;
                            delete $scope.filterData;
                        }
                        $scope.filter.UserID = $sessionStorage.currentUserData.userId;

                        //$scope.filter.OrderByField = "";
                        //$scope.filter.OrderBy = 'desc';
                        if (options.data.sort && options.data.sort.length > 0) {
                            $scope.filter.OrderByField = options.data.sort[0].field;
                            $scope.filter.OrderBy = options.data.sort[0].dir == 'desc' ? 'desc' : 'asc';
                        }

                        
                        TechFormService.GetTechForm($scope.filter).then(function (result) {
                            $scope.TemplateList = result;
                           
                            var data = {
                                Items: $scope.TemplateList.length === 0 ? [] : $scope.TemplateList,
                                Total: $scope.TemplateList.length > 0 ? $scope.TemplateList[0].PageCounts : 0,
                                PageNumber: $scope.filter.PageSize,
                                Pages: $scope.filter.PageSize
                            };
                            options.success(data);
                        }, function (err) {
                            options.error();
                        });

                    }
                },
                schema: {
                    data: "Items",
                    total: "Total",
                    errors: "Errors"
                },
                pageSize: 20,
                serverPaging: true,
                serverSorting: false,
                serverFiltering: true,
                serverGrouping: true,
                serverAggregates: true,
                sort: { field: "Date", dir:"desc"}

            }),
            
            pageable: {
                refresh: true,
                pageSize: 20,
                pageSizes: [20, 50, 100, 200],
                buttonCount: 5
            },
            resizable: false,
            noRecords: true,
            sortable: true,
            reorderable: true,
            columnMenu: false,
            scrollable: true,
            selectable: true,
            height: $window.innerHeight - 170,
            columns:
                [
                    {
                        field: "",
                        title: "Is Active",
                        width: 58,
                        template: function (dataItem) {
                            return '<kendo-switch ng-change="EnabledTemplate(dataItem,\'IsActive\')" ng-model="dataItem.IsActive"  id="email-switch" checked="true"></kendo-switch> ';
                        }
                    },
                    //{
                    //    field: "",
                    //    title: "Is Global",
                    //    width: 30,
                    //    template: function (dataItem) {
                    //        return '<kendo-switch ng-change="EnabledTemplate(dataItem,\'IsGlobal\')" ng-model="dataItem.IsGlobal"  id="email-switch" checked="true"></kendo-switch> ';
                    //    }
                    //},
                    //{
                    //    field: "Type",
                    //    title: "Type",
                    //    width: 30
                    //},
                    {
                        field: "TechFormName",
                        title: "Name",
                        width: 50
                    },
                    {
                        field: "Description",
                        title: "Description",
                        width: 50
                    },
                    //{
                    //    field: "Locations",
                    //    title: "Locations",
                    //    width: 80,
                    //    template: function (dataItem) {
                    //        if (dataItem.Locations.length > 0) {
                    //            return '<span ng-repeat="l in dataItem.Locations" class="p-2px-all b-clr-1" tooltip-class="uibtooltipDenial" uib-tooltip="Site: {{l.Site}}" tooltip-placement="auto top">{{l.Location}}, </span>';
                    //        }
                    //        return '';
                    //    }
                    //},
                    //{
                    //    field: "Modality",
                    //    title: "Modality",
                    //    width: 80,
                    //    template: function (dataItem) {
                    //        if (dataItem.Modalities.length > 0) {
                    //            return '<span ng-repeat="p in dataItem.Modalities" class="p-2px-all b-clr-1">{{p.ModalityCode}}, </span>';
                    //        }
                    //        return '';
                    //    }
                    //},
                    {
                        field: "Procedures",
                        title: "Procedures",
                        width: 80,
                        template: function (dataItem) {
                            if (dataItem.Procedures.length > 0) {
                                return '<span ng-repeat="p in dataItem.Procedures" class="p-2px-all b-clr-1">{{p.ProcedureDesc}}, </span>';
                            }
                            return '';
                        }
                    },
                    //{
                    //    field: "CreatedBy",
                    //    title: "Created By",
                    //    width: 30,
                    //    template: function (dataItem) {
                    //        return "{{dataItem.CreatedBy}}";
                    //    }
                    //},
                    //{
                    //    field: "CreatedDate",
                    //    title: "Date",
                    //    width: 30,
                    //    template: function (dataItem) {
                    //        return "{{dataItem.CreatedDate| date:'MM/dd/yyyy'}}";
                    //    }
                    //},
                    //{
                    //    field: "ModifyBy",
                    //    title: "Modify By",
                    //    width: 30,
                    //},
                    //{
                    //    field: "ModifyDate",
                    //    title: "Date",
                    //    width: 30,
                    //    template: function (dataItem) {
                    //        return "{{dataItem.ModifyDate| date:'MM/dd/yyyy'}}";
                    //    }
                    //},
                    {
                        field: "Date",
                        title: "Date",
                        width: 36,
                        template: function (dataItem) {
                            return "<span ng-if='!dataItem.ModifyDate'>{{dataItem.CreatedDate| date:'MM/dd/yyyy'}}</span><span  ng-if='dataItem.ModifyDate'>{{dataItem.ModifyDate| date:'MM/dd/yyyy'}}</span>";
                        }
                    },
                    {
                        field: "",
                        title: "",
                        width: 20,
                        attributes: { class: "text-center" },
                        template: function (dataItem) {
                            return '<a href="#" ng-click="OpenTemplateDetail(dataItem)" class="no-bg border-0 txt-clr-1" tooltip-class="uibtooltipDenial" uib-tooltip="View" tooltip-placement="auto top"><i class="fa fa-edit fs-14px" aria-hidden="true"></i></a>';
                        }
                    },
                    //{
                    //    field: "",
                    //    title: "",
                    //    width: 20,
                    //    attributes: { class: "text-center" },
                    //    template: function (dataItem) {
                    //        return '<a href="#" ng-click="CloneTemplateDetail(dataItem)" class="no-bg border-0 txt-clr-15 fs-12px fw-600" tooltip-class="uibtooltipDenial" uib-tooltip="Clone" tooltip-placement="auto top"><i class="fa fa-clone fs-15px pos-rel rel-t-2-p" aria-hidden="true"></i></a>';
                    //    }
                    //},
                    {
                        field: "",
                        title: "",
                        width: 20,
                        attributes: { class: "text-center" },
                        headerTemplate: '<div class="cursor-pointer text-center" ng-click="OpenTemplateDetail()" ng-click-options="{preventDoubleClick: true}" title="Add Template"><i class="fa fa-plus-circle fs-15px pos-rel rel-t-2-p" aria-hidden="true"></i></div>',
                        template: function (dataItem) {
                            return '<a href="#" ng-click="DeleteTemplate(dataItem)" class="btn-link" tooltip-class="uibtooltipDenial" uib-tooltip="Delete" tooltip-placement="auto top"><i class="fa fa-trash fs-18px" aria-hidden="true"></i></a>';
                        }
                    }
                ]
        };

        

        function selectGridRow(id) {
            if (id) {
                setTimeout(function () {
                    $scope.SelectedRequest = null;
                    var grid = $("#VRTemplate_ListGrid").data("kendoGrid");
                    var rows = $("#VRTemplate_ListGrid").find('tbody').children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = grid.dataItem(row);
                        row.removeClass("selected-grid-row");
                        if (dataItem.TemplateID === id) {
                            $scope.VRTemplate = angular.copy(dataItem);
                            row.addClass("selected-grid-row");
                            IsRecall = false;
                            grid.select(row);
                        }
                    }
                }, 100);
            }
        }

        $scope.CloneTemplateDetail = function (Template) {
            var template = angular.copy(Template);
            delete template.TemplateID;
            delete template.TemplateName;
            delete template.Macro;
            $scope.OpenTemplateDetail(template);
        };

        $scope.OpenTemplateDetail = function (Template) {
            $scope.isLoading = true;
            var filterData = {
                filter: $scope.filter
            }
            $state.go('settings.techformdetails', { "Template": Template, 'filterData': filterData });
        };

        $scope.clearFilterAndRefesh = function () {
            $scope.filter = {};
           
            $scope.filter.Type = "Template";
            $scope.VRTemplate_Options.dataSource.sort({ field: "Date", dir: "desc" });

            $scope.VRTemplate_Options.dataSource.page(1);
            
        };

        $scope.refresh = function () {
            $scope.VRTemplate_Options.dataSource.page(1);
        };

        $scope.GetAllSitesAndLocations = function () {
            //var d = $q.defer();
            //WorklistService.GetAllSitesAndLocations().then(function (result) {
            TechFormService.GetSitesAndLocationsByUserID($sessionStorage.currentUserData.userId).then(function (result) {
                $scope.Locations = result;
                //d.resolve();
            });
            //return d.promise;
        };

        $scope.GetProcedure = function (search) {
            TechFormService.GetGetProcedure(search).then(function (result) {
                $scope.Procedures = result;
            });
        };

        $scope.EnabledTemplate = function (template, param) {
            //if ($scope.UserID === template.UserID) {
               
            //} else {
            //    template[param] = !template[param];
            //}

            template.isLoading = true;
            TechFormService.SetTechForm(template).then(function (result) {
                template.isLoading = false;
                infoPop("Update successfully.");
            }, function (error) {
                $scope.isLoading = false;
            });
        };

        $scope.DeleteTemplate = function (template) {
            swal({
                title: "Are you sure you want to delete tech form?",
                //text: "Want to delete rule!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55", confirmButtonText: "Yes",
                cancelButtonText: "No"
            },
                function (isConfirm) {
                    if (isConfirm) {
                        template.isDeleteting = true;
                        var data = {
                            TechFormID: template.TechFormID
                        };
                        TechFormService.DeleteTechForm(template).then(function (result) {
                            template.isDeleteting = false;
                            infoPop("Deleted successfully.");
                            $scope.VRTemplate_Options.dataSource.read();
                        }, function (error) {
                            $scope.isLoading = false;
                        });
                    }
                });
        };

        $scope.GetModality = function () {
            WorklistService.GetModality().then(function (result) {
                $scope.Modalities = result;
            });
        };
        angular.element(document).ready(function () {
            setTimeout(function () {
                var kndFtrDrp = $(".k-grid-pager");
                kndFtrDrp.find(".k-pager-sizes").insertBefore(".k-pager-first");
                // Removes default text near page size.
                angular.element('.k-pager-sizes')
                    .contents()
                    .filter(function () {
                        return this.nodeType === 3;
                    }).remove();
            }, 100)
        });
    }
})();


/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('addEditScheduleCmp', {
            templateUrl: 'app/theme/components/shift-schedule/add-edit-schedule-cmp/add-edit-schedule-cmp.html',
            bindings: {
            },
            controller: addEditScheduleCmpCtrl
        });

    function addEditScheduleCmpCtrl($scope, $q, $sessionStorage, ScheduleService, toaster, $filter, ManageLocationService, CommonService) {
        var vm = this;

        $scope.TenantList = [];

        $scope.DataObject = {
            ProvidersList: [],
            ShiftConfigList: [],
            ShiftClassificationList: [],
            ScheduleList: null,
            scheduleLoadError: false,
            DisplayTypeList: ['Provider', 'Shift'],
            dateSearchOptions: {
                formatYear: 'yyyy',
                startingDay: 1,
                showWeeks: false
            },
            Filter: {
                DisplayType: 'Provider',
                SelectedDate: {
                    startDate: moment(),
                    endDate: moment().add('6', 'days'),
                    label: "7 Days",
                },
                dateRangeTooltip: "Select Date Range",
                SelectedTenant: null,
            },
            addEditSchedule: {
                Shift: null,
                selectedDate: new Date(),
                isSelectedDateOpen: false,
                StartTime: null,
                EndTime: null,
                isSaveBtnDisabled: false,
                ShiftClassification: null,
                ShiftPayAmount: null,
                PricePerExcessRVU: null,
                MinimumWRVUPerHour: null,
            },
            multiSelect: {
                addEditScheduleProviders: {
                    divId: "addEditScheduleProvider",
                    keys: ['LastName', 'FirstName'],
                    uniqKey: 'Id',
                    placeHolder: "Select Provider(s)",
                    SelectedValue: { list: [] },
                    onChange: function (selectedData) {
                        $scope.DataObject.multiSelect.addEditScheduleProviders.tooltip =
                            _.join(_.map(selectedData, function (provider) { return provider.LastName + ", " + provider.FirstName }), '\n')
                    }
                },
                FilterScheduleProviders: {
                    divId: "FilterScheduleProviders",
                    keys: ['LastName', 'FirstName'],
                    uniqKey: 'Id',
                    placeHolder: "Select Provider(s)",
                    SelectedValue: { list: [] },
                    tooltip: null,
                    onChange: function (selectedData) {
                        $scope.DataObject.multiSelect.FilterScheduleProviders.tooltip =
                            _.join(_.map(selectedData, function (provider) { return provider.LastName + ", " + provider.FirstName }), '\n')
                    }
                },
                FilterByShifts: {
                    divId: "FilterByShifts",
                    keys: ['ShiftName'],
                    uniqKey: 'ShiftConfigID',
                    placeHolder: "Select Shift(s)",
                    SelectedValue: { list: [] },
                    onChange: function (selectedData) {
                        $scope.DataObject.multiSelect.FilterByShifts.tooltip =
                            _.join(_.map(selectedData, function (shift) { return shift.ShiftName }), '\n')
                    }
                },
                ShiftClassificationFilter: {
                    divId: "ShiftClassificationFilterShiftConfig",
                    keys: ['ShiftClassificationName'],
                    uniqKey: 'ShiftClassificationID',
                    placeHolder: "Select Classification",
                    SelectedValue: { list: [] },
                    tooltip: null,
                    onChange: function (selectedData) {
                        $scope.DataObject.multiSelect.ShiftClassificationFilter.tooltip = _.join(_.map(selectedData, function (classification) { return classification.ShiftClassificationName; }), '\n');
                    }
                },
            }
        }
        $scope.DataObject.UserRoles = $sessionStorage.currentUserData.userRoles;
        vm.$onInit = function () {
            $scope.DataObject.Filter.dateRangeTooltip =
                ($scope.DataObject.Filter.SelectedDate.startDate && $scope.DataObject.Filter.SelectedDate.endDate) ?
                    $scope.DataObject.Filter.SelectedDate.startDate.format("MM/DD/YYYY") + " - " + $scope.DataObject.Filter.SelectedDate.endDate.format("MM/DD/YYYY") :
                    "Select Date Range";
            GetTenantsByUserID();
        }
        vm.$onDestroy = function () { }
        vm.$onChanges = function () { }

        $scope.DOSopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                customRangeLabel: 'Custom range',
            },
            ranges: {
                'Today': [moment(), moment()],
                '5 Days': [moment(), moment().add('4', 'days')],
                '7 Days': [moment(), moment().add('6', 'days')],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
            },
            eventHandlers: {
                'apply.daterangepicker': function (event, picker) {
                    $scope.DataObject.Filter.dateRangeTooltip =
                        ($scope.DataObject.Filter.SelectedDate.startDate && $scope.DataObject.Filter.SelectedDate.endDate) ?
                            $scope.DataObject.Filter.SelectedDate.startDate.format("MM/DD/YYYY") + " - " + $scope.DataObject.Filter.SelectedDate.endDate.format("MM/DD/YYYY") :
                            "Select Date Range";
                }
            }
        };

        $scope.isExporting = false;

        $scope.Export = function () {
            if (!$scope.isExporting && $scope.DataObject.UserRoles.includes("Admin")) {
                $scope.isExporting = true;

                var params = {};
                var selectedDate = $scope.DataObject.Filter.SelectedDate;
                if (selectedDate && selectedDate.startDate && selectedDate.endDate) {
                    params.StartDate = $filter('CSTDateTime')(moment(moment(new Date(selectedDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                    params.EndDate = $filter('CSTDateTime')(moment(moment(new Date(selectedDate.endDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                }
                if (!$scope.DataObject.UserRoles.includes("Scheduler")) {
                    params.ProviderIDs = $sessionStorage.currentUserData.userId;
                } else if ($scope.DataObject.multiSelect &&
                    $scope.DataObject.multiSelect.FilterScheduleProviders &&
                    $scope.DataObject.multiSelect.FilterScheduleProviders.SelectedValue) {
                    params.ProviderIDs = _.join(_.map($scope.DataObject.multiSelect.FilterScheduleProviders.SelectedValue.list, function (provider) { return provider.Id; }), ',');
                }
                if ($scope.DataObject.multiSelect &&
                    $scope.DataObject.multiSelect.FilterByShifts &&
                    $scope.DataObject.multiSelect.FilterByShifts.SelectedValue) {
                    params.ShiftConfigIDs = _.join(_.map($scope.DataObject.multiSelect.FilterByShifts.SelectedValue.list, function (shift) { return shift.ShiftConfigID; }), ',');
                }
                if ($scope.DataObject.multiSelect &&
                    $scope.DataObject.multiSelect.ShiftClassificationFilter &&
                    $scope.DataObject.multiSelect.ShiftClassificationFilter.SelectedValue) {
                    params.ShiftClassificationIDs = _.join(_.map($scope.DataObject.multiSelect.ShiftClassificationFilter.SelectedValue.list, function (c) { return c.ShiftClassificationID; }), ',');
                }
                if ($scope.DataObject.Filter.SelectedTenant) {
                    params.TenantID = $scope.DataObject.Filter.SelectedTenant.TenantID;
                }

                ScheduleService.GetShiftScheduleCalendarExport(params).then(function (data) {
                    var now = new Date();
                    var timestamp = now.getDate().toString() + now.getMonth().toString() + now.getFullYear().toString() + now.getHours().toString() + now.getMinutes().toString() + now.getSeconds().toString();
                    var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    var fileName = "ScheduleExport_" + timestamp + ".xlsx";

                    if ($scope.browser != null && $scope.browser.toUpperCase() == "IE") {
                        var IEblob = new Blob([data], { type: contentType });
                        window.navigator.msSaveBlob(IEblob, fileName);
                    } else {
                        var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                        if (urlCreator) {
                            var blob = new Blob([data], { type: contentType });
                            var url = urlCreator.createObjectURL(blob);
                            var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style = "display: none";
                            a.href = url;
                            a.download = fileName;
                            a.click();
                            window.URL.revokeObjectURL(url);
                        }
                    }
                    $scope.isExporting = false;
                }, function (err) {
                    $scope.isExporting = false;
                });
            }
        }

        $scope.Clear = function () {
            $scope.DataObject.Filter = {
                DisplayType: "Provider",
                SelectedDate: {
                    startDate: moment(),
                    endDate: moment().add('6', 'days'),
                    label: "7 Days",
                },
                SelectedTenant: applyDefaultTenant($scope.TenantList),
            };
            $scope.DataObject.multiSelect.FilterScheduleProviders.SelectedValue = { list: [] };
            $scope.DataObject.multiSelect.FilterByShifts.SelectedValue = { list: [] };
            $scope.DataObject.multiSelect.ShiftClassificationFilter.SelectedValue = { list: [] };

            var tenantId = $scope.DataObject.Filter.SelectedTenant ? $scope.DataObject.Filter.SelectedTenant.TenantID : null;
            GetAllUsers(tenantId).then(function () {
                $scope.GetShiftScheduleCalendar();
            });
        }

        $scope.OnTenantChanged = function () {
            var tenantId = $scope.DataObject.Filter.SelectedTenant ? $scope.DataObject.Filter.SelectedTenant.TenantID : null;
            $scope.DataObject.ShiftClassificationList = [];
            $scope.DataObject.ShiftConfigList = [];
            if (!tenantId) {
                $scope.DataObject.ProvidersList = [];
                return;
            }
            GetShiftClassification();
            GetAllUsers(tenantId).then(function () {
                $scope.GetShiftScheduleCalendar();
            });
        };

        $scope.showUserScheduleModal = function () {
            angular.element("#AssignScheduleModal").modal('show');
        }

        $scope.AssignSchdeule = function () {
            $scope.DataObject.addEditSchedule.isSaveBtnDisabled = true;
            var Flag = "N";
            var params = {
                ShiftScheduleID: (Flag == "N") ? -1 : $scope.DataObject.addEditSchedule.ShiftScheduleID,
                ShiftConfigID: $scope.DataObject.addEditSchedule.Shift.ShiftConfigID,
                StartTime: ScheduleService.formatTime($scope.DataObject.addEditSchedule.StartTime),
                EndTime: ScheduleService.formatTime($scope.DataObject.addEditSchedule.EndTime),
                CreatedBy: $sessionStorage.currentUserData.userId,
                Flag: Flag,
                ShiftClassificationID: ($scope.DataObject.addEditSchedule.ShiftClassification) ? $scope.DataObject.addEditSchedule.ShiftClassification.ShiftClassificationID : null,
                TenantID: ($scope.DataObject.Filter.SelectedTenant) ? $scope.DataObject.Filter.SelectedTenant.TenantID : null,
                ShiftPayAmount: ($scope.DataObject.addEditSchedule.ShiftPayAmount != null) ? $scope.DataObject.addEditSchedule.ShiftPayAmount : null,
                PricePerExcessRVU: ($scope.DataObject.addEditSchedule.PricePerExcessRVU != null) ? $scope.DataObject.addEditSchedule.PricePerExcessRVU : null,
                MinimumWRVUPerHour: ($scope.DataObject.addEditSchedule.MinimumWRVUPerHour != null) ? $scope.DataObject.addEditSchedule.MinimumWRVUPerHour : null,
            };
            if ($scope.DataObject.multiSelect &&
                $scope.DataObject.multiSelect.addEditScheduleProviders &&
                $scope.DataObject.multiSelect.addEditScheduleProviders.SelectedValue) {
                params.ProviderIDs = _.join(_.map($scope.DataObject.multiSelect.addEditScheduleProviders.SelectedValue.list, function (provider) { return provider.Id; }), ',');
            }
            if ($scope.DataObject.addEditSchedule.selectedDate) {
                var CSTDate = $filter('CSTDateTime')($scope.DataObject.addEditSchedule.selectedDate);
                params.StartDate = moment(CSTDate).format("MM-DD-YYYY") + " 00:00:00";
                params.EndDate = moment(CSTDate).format("MM-DD-YYYY") + " 00:00:00";
            }
            ScheduleService.SetShiftSchedule(params).then(function () {
                $scope.DataObject.addEditSchedule.isSaveBtnDisabled = false;
                angular.element("#AssignScheduleModal").modal('hide');
                $scope.ClearAddEditScheduleData();
                toaster.success("Schedule Saved Successfully.");
                $scope.GetShiftScheduleCalendar();
            }, function (err) {
                $scope.DataObject.addEditSchedule.isSaveBtnDisabled = false;
                toaster.error("Some Error Occurred!");
            });
        }
        $scope.ClearAddEditScheduleData = function () {
            $scope.DataObject.addEditSchedule = {
                Shift: null,
                selectedDate: new Date(),
                isSelectedDateOpen: false,
                StartTime: null,
                EndTime: null,
                isSaveBtnDisabled: false,
                ShiftClassification: null,
                ShiftPayAmount: null,
                PricePerExcessRVU: null,
                MinimumWRVUPerHour: null,
            }
            $scope.DataObject.multiSelect.addEditScheduleProviders.SelectedValue = { list: [] };
        }
        function GetAllUsers(tenantId) {
            var d = $q.defer();
            if (!tenantId) {
                $scope.DataObject.ProvidersList = [];
                d.resolve();
                return d.promise;
            }
            CommonService.GetAllProvidersByTenantID(tenantId).then(function (res) {
                if (res && angular.isFunction(res.plain)) {
                    res = res.plain();
                }
                $scope.DataObject.ProvidersList = angular.isArray(res) ? res : (res ? [res] : []);
                d.resolve();
            }, function (err) {
                console.error('[Radflow] GetAllProvidersByTenantID failed for tenantId:', tenantId, err);
                toaster.error('Failed to load providers list.');
                d.resolve();
            });
            return d.promise;
        }

        $scope.GetShiftConfigurations = function (shiftName) {
            var d = $q.defer();
            ScheduleService.GetShiftConfig({
                OrderByField: "ShiftName",
                OrderBy: "asc",
                ShiftName: shiftName,
                TenantID: ($scope.DataObject.Filter.SelectedTenant) ? $scope.DataObject.Filter.SelectedTenant.TenantID : null,
            }).then(function (res) {
                if (res && res.length > 0) {
                    $scope.DataObject.ShiftConfigList = _.uniqBy(_.concat($scope.DataObject.ShiftConfigList, res), 'ShiftConfigID');
                }
                d.resolve(res);
            })

            return d.promise;
        }
        $scope.GetShiftConfigurationsMultiSelect = function (searchObj) {
            if (searchObj && searchObj.isSearched) {
                $scope.GetShiftConfigurations(searchObj.searchKey);
            }
        }

        $scope.GetShiftScheduleCalendar = function () {
            var d = $q.defer();
            var params = {};
            var selectedDate = $scope.DataObject.Filter.SelectedDate;
            angular.element(".ag-body-horizontal-scroll-viewport").animate({ scrollLeft: '0px' }, 'fast');
            if (selectedDate && selectedDate.startDate && selectedDate.endDate) {
                params.StartDate = $filter('CSTDateTime')(moment(moment(new Date(selectedDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                params.EndDate = $filter('CSTDateTime')(moment(moment(new Date(selectedDate.endDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
            }
            if ($scope.DataObject.Filter.SelectedTenant) {
                params.TenantID = $scope.DataObject.Filter.SelectedTenant.TenantID;
            }
            if (!$scope.DataObject.UserRoles.includes("Scheduler")) {
                params.ProviderIDs = $sessionStorage.currentUserData.userId;
            }
            else if ($scope.DataObject.multiSelect &&
                $scope.DataObject.multiSelect.FilterScheduleProviders &&
                $scope.DataObject.multiSelect.FilterScheduleProviders.SelectedValue) {
                params.ProviderIDs = _.join(_.map($scope.DataObject.multiSelect.FilterScheduleProviders.SelectedValue.list, function (provider) { return provider.Id; }), ',');
            }
            if ($scope.DataObject.multiSelect &&
                $scope.DataObject.multiSelect.FilterByShifts &&
                $scope.DataObject.multiSelect.FilterByShifts.SelectedValue) {
                params.ShiftConfigIDs = _.join(_.map($scope.DataObject.multiSelect.FilterByShifts.SelectedValue.list, function (shift) { return shift.ShiftConfigID; }), ',');
            }
            if ($scope.DataObject.multiSelect &&
                $scope.DataObject.multiSelect.ShiftClassificationFilter &&
                $scope.DataObject.multiSelect.ShiftClassificationFilter.SelectedValue) {
                params.ShiftClassificationIDs = _.join(_.map($scope.DataObject.multiSelect.ShiftClassificationFilter.SelectedValue.list, function (shift) { return shift.ShiftClassificationID; }), ',');
            }
            ScheduleService.GetShiftScheduleCalendar(params).then(function (res) {
                $scope.DataObject.scheduleLoadError = false;
                $scope.DataObject.ScheduleList = angular.isArray(res) ? res : (res ? [res] : []);
                d.resolve($scope.DataObject.ScheduleList);
            }, function (err) {
                $scope.DataObject.scheduleLoadError = true;
                toaster.error('Failed to load schedule data.');
                d.resolve([]);
            });
            return d.promise;
        }
        function applyDefaultTenant(list) {
            if (!list || list.length === 0) {
                return null;
            }
            if (list.length === 1) {
                return list[0];
            }
            return _.find(list, { IsDefault: true }) || null;
        }

        function GetTenantsByUserID() {
            ManageLocationService.GetTenantsByUserID({ UserID: $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.TenantList = result || [];
                $scope.DataObject.Filter.SelectedTenant = applyDefaultTenant($scope.TenantList);
                var tenantId = $scope.DataObject.Filter.SelectedTenant ? $scope.DataObject.Filter.SelectedTenant.TenantID : null;
                GetShiftClassification();
                GetAllUsers(tenantId).then(function () {
                    $scope.GetShiftScheduleCalendar();
                });
            });
        }

        function GetShiftClassification() {
            var d = $q.defer();
            var params = {};
            if ($scope.DataObject.Filter.SelectedTenant) {
                params.tenantID = $scope.DataObject.Filter.SelectedTenant.TenantID;
            }
            ScheduleService.GetShiftClassification(params).then(function (res) {
                $scope.DataObject.ShiftClassificationList = (res && res.length > 0) ? _.sortBy(res, 'ShiftClassificationName') : [];
                d.resolve(res);
            }, function (err) {
                $scope.DataObject.ShiftClassificationList = [];
                d.resolve([]);
            });
            return d.promise;
        }
        $scope.onShiftSelectionChanged = function () {
            if ($scope.DataObject.addEditSchedule && $scope.DataObject.addEditSchedule.Shift) {
                $scope.DataObject.addEditSchedule.StartTime = (($scope.DataObject.addEditSchedule.Shift.StartTime)) ? new Date(1970, 0, 1, ($scope.DataObject.addEditSchedule.Shift.StartTime).split(':')[0], ($scope.DataObject.addEditSchedule.Shift.StartTime).split(':')[1], 0) : null;
                $scope.DataObject.addEditSchedule.EndTime = (($scope.DataObject.addEditSchedule.Shift.EndTime)) ? new Date(1970, 0, 1, ($scope.DataObject.addEditSchedule.Shift.EndTime).split(':')[0], ($scope.DataObject.addEditSchedule.Shift.EndTime).split(':')[1], 0) : null;
            }
            else {
                $scope.DataObject.addEditSchedule.StartTime = null;
                $scope.DataObject.addEditSchedule.EndTime = null;
            }
        }
    }
})();
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('scheduleCalendar', {
            templateUrl: 'app/theme/components/shift-schedule/schedule-calendar/schedule-calendar.html',
            bindings: {
                selectedDate: '<',
                shiftConfigList: "<",
                scheduleList: "<",
                displayType: "<",
                shiftClassificationList: "<",
                getShiftScheduleCalendar: "&",
                selectedTenant: "<"
            },
            controller: scheduleCalendarCtrl
        });

    function scheduleCalendarCtrl($scope, ScheduleService, $q, $filter, $sessionStorage, toaster, $compile, $timeout, CommonService) {
        var vm = this;

        /** Persists via api/common/LogApplicationInfo → CommonService.InsertLogs (DB). */
        function insertLog(editPayload) {
            var uid = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) ? String($sessionStorage.currentUserData.userId) : '';
            var details;
            try {
                details = angular.isString(editPayload) ? editPayload : JSON.stringify(editPayload);
            } catch (e) {
                details = String(editPayload);
            }
            if (CommonService && angular.isFunction(CommonService.LogApplicationInfo)) {
                CommonService.LogApplicationInfo({
                    LogDetails: details,
                    Application: 'ShiftSchedule-EditSchedule-calendar',
                    UserID: uid,
                }).catch(angular.noop);
            }
        }
        var displayType = "Provider"
        var statusBarComponent = null;
        var selectedDate = {
            startDate: moment().subtract(6, 'days'),
            endDate: moment(),
            label: "Last 7 Days",
        };
        var gridAPI = null;
        var providerColumn = {
            field: "ProviderName",
            sort: 'asc',
            pinned: 'left',
            cellStyle: function (params) {
                var obj = {}
                obj.background = '#000000';
                return obj;
            },
            cellRenderer: function (params) {
                var template = "";
                var name = params && params.data ? getScheduleRowField(params.data, 'ProviderName') : null;
                if (name) {
                    template = template + "<div class='cursor-pointer'>" + name + "</div>";
                }
                return template;
            }
        }
        var shiftColumn = {
            field: "ShiftName",
            sort: 'asc',
            pinned: 'left',
            cellStyle: function (params) {
                var obj = {}
                obj.background = '#000000';
                return obj;
            },
            cellRenderer: function (params) {
                var name = params && params.data ? getScheduleRowField(params.data, 'ShiftName') : '';
                return name ? "<div class='cursor-pointer'>" + name + "</div>" : "";
            }
        }
        var columnDefs = [];
        var scheduleList = [];
        $scope.DataObject = {
            ShiftConfigList: [],
            ShiftClassificationList: [],
            SelectedTenant: null,
            dateSearchOptions: {
                formatYear: 'yyyy',
                startingDay: 1,
            },
            addEditSchedule: {
                Shift: null,
                StartDate: null,
                EndDate: null,
                isStartDateOpen: false,
                isEndDateOpen: false,
                StartTime: null,
                EndTime: null,
                ShiftClassification: null,
                ProviderID: null,
                ProviderName: null,
                Email: null,
                ShiftScheduleID: null,
                ShiftPayAmount: null,
                PricePerExcessRVU: null,
                MinimumWRVUPerHour: null,
            }
        }
        vm.$onInit = function () {
            var gridDiv = document.querySelector('#ScheduleCalendarGrid');
            if (gridDiv) {
                new agGrid.Grid(gridDiv, gridOptions);
                gridAPI = gridOptions.api;
                gridAPI.setColumnDefs(columnDefs);
            }
        }
        vm.$onDestroy = function () { }
        vm.$onChanges = function (changes) {
            if (changes.selectedDate && changes.selectedDate.currentValue) {
                selectedDate = changes.selectedDate.currentValue;
                GetShiftScheduleCalendar();
            }
            if (changes.shiftClassificationList && changes.shiftClassificationList.currentValue) {
                $scope.DataObject.ShiftClassificationList = changes.shiftClassificationList.currentValue;
            }
            if (changes.shiftConfigList && changes.shiftConfigList.currentValue) {
                $scope.DataObject.ShiftConfigList = changes.shiftConfigList.currentValue;
            }
            if (changes.scheduleList && changes.scheduleList.currentValue) {
                scheduleList = changes.scheduleList.currentValue;
                if (gridAPI) {
                    createGridDataProviderView(scheduleList)
                }
            }
            if (changes.displayType && changes.displayType.currentValue) {
                displayType = changes.displayType.currentValue;
                if (gridAPI) {
                    GetShiftScheduleCalendar()
                }
            }
            if (changes.selectedTenant) {
                $scope.DataObject.SelectedTenant = changes.selectedTenant.currentValue;
            }
        }

        var gridOptions = {
            columnDefs: columnDefs,
            rowData: scheduleList,
            rowHeight: 120,
            headerHeight: 60,
            domLayout: 'autoHeight',
            defaultColDef: {
                flex: 1,
                wrapText: true,
                autoHeight: true,
                minWidth: 220,
                //minHeight: 300,
                resizable: false,
                sortable: false,
                lockVisible: true,
                suppressMovable: true,
                menuTabs: [],
            },
            getContextMenuItems: getContextMenuItems,
            overlayNoRowsTemplate: '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 20px;gap:12px"><i class="glyphicon glyphicon-calendar" style="font-size:36px;color:#aaa;"></i><span style="font-size:15px;color:#ccc;font-weight:500;letter-spacing:0.5px;">No schedule data available</span><span style="font-size:12px;color:#999;">Try adjusting the date range or filters</span></div>',
            localeText: { loadingError: 'Some error has occurred!' },
            onGridReady: function () {
                statusBarComponent = gridAPI.getStatusPanel('GridFooter');
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
            },

            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },

            onCellClicked: function (params) {
                gridAPI.contextMenuFactory.hideActiveMenu();
                if (params && params.column && (params.column.colId == "ProviderName" || displayType == "Shift")) {
                    params.node.showEmailPhoneNumber = true;
                    var val = params.value;
                    if (displayType == "Shift") {
                        if (params.event.target.id == "providerNameSpan") {
                            val = params.event.target.innerText;
                        }
                    }
                    gridAPI.contextMenuFactory.showMenu(params.node, params.column, val, params.event);
                }
            }
        }

        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }
        function getContextMenuItems(params) {
            var options = [];
            if (params.node && params.node.showEmailPhoneNumber) {
                params.node.showEmailPhoneNumber = false;
                if (params.node.data) {
                    var selectedData = params.node.data;
                    if (displayType == "Shift") {
                        selectedData = _.find(params.node.data.ProviderDetails, function (obj) { return obj.ProviderName == params.value });
                    }
                    if (selectedData && selectedData.Email) {
                        options.push({
                            name: selectedData.Email,
                            action: function () { }
                        });
                    }
                    if (selectedData && selectedData.PhoneNumber) {
                        options.push({
                            name: selectedData.PhoneNumber,
                            action: function () { }
                        });
                    }
                }
            }
            else if (params && params.column && params.column.colId &&
                (params.column.colId != "ProviderName" && params.column.colId != "ShiftName")) {
                if (params.node && params.node.cellData) {
                    options.push({
                        name: 'Edit Schedule',
                        subMenu: getSubMenuOptions(params.node.cellData, "Edit"),
                    });
                    options.push('separator');
                    options.push({
                        name: 'Delete Schedule',
                        subMenu: getSubMenuOptions(params.node.cellData, "Delete"),
                    });

                }
            }
            return options;
        }
        function getSubMenuOptions(row, flag) {
            var subMenu = [];
            //var data = (displayType == "Provider") ? row.ShiftDetails : row.ProviderDetails;
            _.each(row, function (obj, index) {
                subMenu.push({
                    name: (displayType == "Provider") ? getScheduleRowField(obj, 'ShiftName') : getScheduleRowField(obj, 'ProviderName'),
                    Shift: obj,
                    flag: flag,
                    ShiftScheduleID: obj.ShiftScheduleID,
                    action: function () {
                        if (subMenu[0].flag) {
                            if (subMenu[0].flag == "Edit") {
                                EditShiftSchedule(obj);
                            }
                            else {
                                DeleteShiftSchedule(obj);
                            }
                        }
                    }
                });
                if (index < row.length - 1)
                    subMenu.push('separator');
            });
            return subMenu;
        }

        function getScheduleRowField(data, pascalFieldName) {
            if (!data) {
                return null;
            }
            var v = data[pascalFieldName];
            if (v != null && v !== '') {
                return v;
            }
            var camel = pascalFieldName.charAt(0).toLowerCase() + pascalFieldName.slice(1);
            v = data[camel];
            if (v != null && v !== '') {
                return v;
            }
            return null;
        }

        function normalizeShiftScheduleDateForLocalFilter(raw) {
            if (raw == null || raw === '') {
                return '';
            }
            if (angular.isDate(raw)) {
                if (isNaN(raw.getTime())) {
                    return '';
                }
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'number' && isFinite(raw)) {
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'string') {
                var trimmed = raw.trim();
                if (!trimmed) {
                    return '';
                }
                var strictFormats = [
                    'MM-DD-YYYY HH:mm',
                    'MM-DD-YYYY HH:mm:ss',
                    'MM-DD-YYYY',
                    'YYYY-MM-DD HH:mm:ss',
                    'YYYY-MM-DDTHH:mm:ss',
                    'YYYY-MM-DDTHH:mm:ss.SSS',
                    'YYYY-MM-DDTHH:mm:ss.SSSSSSS',
                    'YYYY-MM-DD',
                    'M/D/YYYY H:mm',
                    'M/D/YYYY HH:mm',
                    'M/D/YYYY',
                    'MM/DD/YYYY H:mm',
                    'MM/DD/YYYY HH:mm',
                    'MM/DD/YYYY',
                    'MM/DD/YYYY hh:mm:ss A',
                    'M/D/YYYY h:mm:ss A',
                    'MM/DD/YYYY hh:mm A'
                ];
                var parsed = moment(trimmed, strictFormats, true);
                if (!parsed.isValid()) {
                    parsed = moment(trimmed);
                }
                if (parsed.isValid()) {
                    return parsed.format('YYYY-MM-DD HH:mm:ss');
                }
            }
            return typeof raw === 'string' ? raw : '';
        }

        /** Calendar grid: same pipeline as schedule-setting-cmp so shift rows match column days. */
        function shiftDateToMomentForCalendar(raw) {
            var forFilter = normalizeShiftScheduleDateForLocalFilter(raw);
            if (forFilter === '') {
                return moment.invalid();
            }
            var m;
            var localized = $filter('localDate')(forFilter, false, new Date());
            if (localized) {
                m = moment(localized, 'M/D/YYYY HH:mm', true);
                if (!m.isValid()) {
                    m = moment(localized);
                }
            }
            if (!m || !m.isValid()) {
                m = moment(forFilter, 'YYYY-MM-DD HH:mm:ss', true);
            }
            if (!m.isValid()) {
                m = moment(forFilter);
            }
            return m;
        }

        function calendarColumnDayMoment(colId) {
            var m = moment(colId, 'MM/DD/YYYY HH:mm:ss', true);
            if (!m.isValid()) {
                m = moment(colId, 'MM/DD/YYYY', true);
            }
            if (!m.isValid()) {
                m = moment(colId);
            }
            return m;
        }


        function getScheduleRowField(data, pascalFieldName) {
            if (!data) {
                return null;
            }
            var v = data[pascalFieldName];
            if (v != null && v !== '') {
                return v;
            }
            var camel = pascalFieldName.charAt(0).toLowerCase() + pascalFieldName.slice(1);
            v = data[camel];
            if (v != null && v !== '') {
                return v;
            }
            return null;
        }

        function normalizeShiftScheduleDateForLocalFilter(raw) {
            if (raw == null || raw === '') {
                return '';
            }
            if (angular.isDate(raw)) {
                if (isNaN(raw.getTime())) {
                    return '';
                }
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'number' && isFinite(raw)) {
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'string') {
                var trimmed = raw.trim();
                if (!trimmed) {
                    return '';
                }
                var strictFormats = [
                    'MM-DD-YYYY HH:mm',
                    'MM-DD-YYYY HH:mm:ss',
                    'MM-DD-YYYY',
                    'YYYY-MM-DD HH:mm:ss',
                    'YYYY-MM-DDTHH:mm:ss',
                    'YYYY-MM-DDTHH:mm:ss.SSS',
                    'YYYY-MM-DDTHH:mm:ss.SSSSSSS',
                    'YYYY-MM-DD',
                    'M/D/YYYY H:mm',
                    'M/D/YYYY HH:mm',
                    'M/D/YYYY',
                    'MM/DD/YYYY H:mm',
                    'MM/DD/YYYY HH:mm',
                    'MM/DD/YYYY',
                    'MM/DD/YYYY hh:mm:ss A',
                    'M/D/YYYY h:mm:ss A',
                    'MM/DD/YYYY hh:mm A'
                ];
                var parsed = moment(trimmed, strictFormats, true);
                if (!parsed.isValid()) {
                    parsed = moment(trimmed);
                }
                if (parsed.isValid()) {
                    return parsed.format('YYYY-MM-DD HH:mm:ss');
                }
            }
            return typeof raw === 'string' ? raw : '';
        }

        /** Calendar grid: same pipeline as schedule-setting-cmp so shift rows match column days. */
        function shiftDateToMomentForCalendar(raw) {
            var forFilter = normalizeShiftScheduleDateForLocalFilter(raw);
            if (forFilter === '') {
                return moment.invalid();
            }
            var m;
            var localized = $filter('localDate')(forFilter, false, new Date());
            if (localized) {
                m = moment(localized, 'M/D/YYYY HH:mm', true);
                if (!m.isValid()) {
                    m = moment(localized);
                }
            }
            if (!m || !m.isValid()) {
                m = moment(forFilter, 'YYYY-MM-DD HH:mm:ss', true);
            }
            if (!m.isValid()) {
                m = moment(forFilter);
            }
            return m;
        }

        function calendarColumnDayMoment(colId) {
            var m = moment(colId, 'MM/DD/YYYY HH:mm:ss', true);
            if (!m.isValid()) {
                m = moment(colId, 'MM/DD/YYYY', true);
            }
            if (!m.isValid()) {
                m = moment(colId);
            }
            return m;
        }

        function scheduleValueGetter(params) {
            var cellValue = null;
            params.node.cellData = null;
            if (params && params.data && params.column && params.column.colId) {
                var List = [];
                var uniqKey = "";
                if (displayType == "Provider") {
                    List = params.data.ShiftDetails;
                    uniqKey = "ShiftScheduleID";
                }
                else {
                    List = params.data.ProviderDetails;
                    uniqKey = "ProviderID";
                }
                List = List || [];
                var colDay = calendarColumnDayMoment(params.column.colId);
                if (!colDay.isValid()) {
                    return cellValue;
                }
                var startDate = _.filter(List, function (obj) {
                    var m = shiftDateToMomentForCalendar(getScheduleRowField(obj, 'StartDate'));
                    return m.isValid() && colDay.isSame(m, 'day');
                    var m = shiftDateToMomentForCalendar(getScheduleRowField(obj, 'StartDate'));
                    return m.isValid() && colDay.isSame(m, 'day');
                });
                var endDate = _.filter(List, function (obj) {
                    var m = shiftDateToMomentForCalendar(getScheduleRowField(obj, 'EndDate'));
                    return m.isValid() && colDay.isSame(m, 'day');
                    var m = shiftDateToMomentForCalendar(getScheduleRowField(obj, 'EndDate'));
                    return m.isValid() && colDay.isSame(m, 'day');
                });



                var uniqData = _.uniqBy(_.concat(startDate, endDate), uniqKey);
                if (uniqData && uniqData.length > 0) {
                    params.node.cellData = uniqData;
                    _.each(uniqData, function (obj) {
                        var label = (displayType == "Provider") ?
                            getScheduleRowField(obj, 'ShiftName') : getScheduleRowField(obj, 'ProviderName');
                        if (label == null || label === '') {
                            return;
                        }
                        if (!cellValue) {
                            cellValue = label;
                        } else {
                            cellValue = cellValue + ";" + label;
                        }
                    });
                }
            }
            return cellValue;
        }
        function DateCellRender(params) {

            var template = "<div>";
            if (params && params.value && params.value != "") {
                var data = params.value.split(";");
                _.each(data, function (val) {
                    var ShiftColorCode = "#2e4441";
                    if (displayType == "Shift" && params.data.ShiftColorCode) {
                        ShiftColorCode = params.data.ShiftColorCode;
                    } else {
                        var shift = _.find(params.data.ShiftDetails || [], function (s) {
                            return String(getScheduleRowField(s, 'ShiftName')) === String(val);
                        });
                        var colorRaw = shift && (shift.ShiftColorCode != null ? shift.ShiftColorCode : shift.shiftColorCode);
                        ShiftColorCode = colorRaw ? colorRaw : ShiftColorCode;
                    }
                    var classList = "p-4px-all mlp-value-box mr-4px text-nowrap";
                    classList = (displayType == "Shift") ? classList + ' cursor-pointer' : classList;
                    template = template + "<span class='" + classList+"' style='background:" + ShiftColorCode + " !important'";
                    if (displayType == "Shift") {
                        template = template + " id='providerNameSpan' ";
                    }
                    template = template + " title='" + val + "'>" + val + "</span>";
                });
            }
            template = template + "</div>";

            return template;
        }
        function GetShiftScheduleCalendar() {
            vm.getShiftScheduleCalendar();
        }

        function setColumnDefs() {
            columnDefs = [];
            (displayType == "Provider") ? columnDefs.push(providerColumn) : columnDefs.push(shiftColumn);
            var currentDate = (selectedDate.startDate).clone();
            if (currentDate && selectedDate.endDate) {
                while ((currentDate).isSameOrBefore(selectedDate.endDate)) {
                    columnDefs.push({
                        field: (currentDate).format('MM/DD/YYYY') + " 00:00:00",
                        headerName: (currentDate).format('D MMM ddd'),
                        valueGetter: scheduleValueGetter,
                        cellRenderer: DateCellRender,
                        headerComponent: CustomHeaderText(),
                        cellStyle: function (params) {
                            var obj = {}
                            obj.background = '#2d3436';
                            if (params && params.data && params.data.ShiftColorCode) {
                                obj.background = params.data.ShiftColorCode;
                            }
                            return obj;
                        },
                    });
                    //console.log(currentDate.format('YYYY-MM-DD'));
                    currentDate.add(1, 'days'); // increment by 1 day
                }
            }
            if (gridAPI) {
                gridAPI.setColumnDefs(columnDefs);
            }
        }
        function CustomHeaderText() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                this.eGui.className = "d-flex"
                var colDay = moment(params.column.colId).format('DD');
                var colMonthDay = moment(params.column.colId).format('MMMM / dddd');
                this.eGui.innerHTML = '<div class="ag-cell-label-container" role="presentation" ng-click="SelectAllNodes()" style="width:180px;>' +
                    '<span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '<span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button"></span>' +
                    '<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '<span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                    '<span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                    '<span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                    '<span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                    '<span class="ssch-datwrapper" style="color:#fff !important">' + '<span class="ssch-date d-block fs-20px"></span>' + '<span class="ssch-monthday"></span>' + '</span>' +
                    '<span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
                    '<span data-ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    '</div>' +
                    '</div>';
                this.eGui.querySelector('.ssch-date').textContent = colDay;
                this.eGui.querySelector('.ssch-monthday').textContent = colMonthDay;
                // create and compile AngularJS scope for this component
                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                // in case we are running outside of angular (ie in an ag-grid started VM turn)
                // we call $apply. we put in timeout in case we are inside apply already.
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }
        function createGridDataProviderView(scheduleList) {
            setColumnDefs();
            var rowData = [];

            if (displayType == "Provider") {
                var groupByProvider = _.groupBy(scheduleList, function (row) {
                    return getScheduleRowField(row, 'ProviderID');
                });
                var providerIds = Object.keys(groupByProvider);
                _.each(providerIds, function (id) {
                    var provider = _.find(scheduleList, function (row) {
                        return String(getScheduleRowField(row, 'ProviderID')) === String(id);
                    });
                    if (provider) {
                        rowData.push({
                            ProviderID: getScheduleRowField(provider, 'ProviderID'),
                            ProviderName: getScheduleRowField(provider, 'ProviderName'),
                            Email: getScheduleRowField(provider, 'Email'),
                            PhoneNumber: getScheduleRowField(provider, 'PhoneNumber'),
                            ShiftDetails: groupByProvider[id],
                            ShiftColorCode: provider.ShiftColorCode || provider.shiftColorCode
                        });
                    }
                });
            }
            else {
                var groupByShift = _.groupBy(scheduleList, function (row) {
                    return getScheduleRowField(row, 'ShiftConfigID');
                });
                var shiftIds = Object.keys(groupByShift);
                _.each(shiftIds, function (id) {
                    var shift = _.find(scheduleList, function (row) {
                        return String(getScheduleRowField(row, 'ShiftConfigID')) === String(id);
                    });
                    if (shift) {
                        rowData.push({
                            ShiftConfigID: getScheduleRowField(shift, 'ShiftConfigID'),
                            ShiftName: getScheduleRowField(shift, 'ShiftName'),
                            ShiftColorCode: shift.ShiftColorCode || shift.shiftColorCode,
                            ProviderDetails: groupByShift[id]
                        });
                    }
                });
            }

            if (gridAPI) {
                gridAPI.setRowData(rowData);
            }
        }

        function DeleteShiftSchedule(row) {
            if (row.ShiftScheduleID) {
                var object = row;
                object.CreatedBy = $sessionStorage.currentUserData.userId;
                ScheduleService.DeleteShiftSchedule(object).then(function (res) {
                    toaster.success("Schedule Deleted Successfully!");
                    GetShiftScheduleCalendar();
                }, function (err) {
                    toaster.error("Some Error Occurred!");
                });
            }
        }

        function EditShiftSchedule(shift) {
            if (shift) {
                var logPrefix = '[Radflow EditSchedule][schedule-calendar]';
                var startRaw = getScheduleRowField(shift, 'StartDate');
                var endRaw = getScheduleRowField(shift, 'EndDate');
                var st = getScheduleRowField(shift, 'StartTime');
                var et = getScheduleRowField(shift, 'EndTime');
                var shiftConfigId = getScheduleRowField(shift, 'ShiftConfigID');
                var classId = getScheduleRowField(shift, 'ShiftClassificationID');
                $scope.DataObject.addEditSchedule = {
                    StartDate: moment($filter('localDate')(normalizeShiftScheduleDateForLocalFilter(startRaw), false, new Date())).toDate(),
                    EndDate: moment($filter('localDate')(normalizeShiftScheduleDateForLocalFilter(endRaw), false, new Date())).toDate(),
                    isStartDateOpen: false,
                    isEndDateOpen: false,
                    StartTime: (st) ? new Date(1970, 0, 1, String(st).split(':')[0], String(st).split(':')[1], 0) : null,
                    EndTime: (et) ? new Date(1970, 0, 1, String(et).split(':')[0], String(et).split(':')[1], 0) : null,
                    ProviderID: getScheduleRowField(shift, 'ProviderID'),
                    ShiftScheduleID: getScheduleRowField(shift, 'ShiftScheduleID'),
                    ProviderName: getScheduleRowField(shift, 'ProviderName'),
                    Email: getScheduleRowField(shift, 'Email'),
                    ShiftPayAmount: getScheduleRowField(shift, 'ShiftPayAmount'),
                    PricePerExcessRVU: getScheduleRowField(shift, 'PricePerExcessRVU'),
                    MinimumWRVUPerHour: getScheduleRowField(shift, 'MinimumWRVUPerHour'),
                    /* If ui-select cannot resolve Shift / Classification, save still must not null out FKs (calendar uses INNER JOIN ShiftConfig). */
                    ShiftConfigIDFallback: shiftConfigId,
                    ShiftClassificationIDFallback: classId,
                    ShiftNameFallback: getScheduleRowField(shift, 'ShiftName'),
                }
                var shiftNameVal = getScheduleRowField(shift, 'ShiftName');
                var listLen = ($scope.DataObject.ShiftConfigList && $scope.DataObject.ShiftConfigList.length) || 0;
                var classListLen = ($scope.DataObject.ShiftClassificationList && $scope.DataObject.ShiftClassificationList.length) || 0;
                console.log(logPrefix + ' raw row', {
                    ShiftScheduleID: getScheduleRowField(shift, 'ShiftScheduleID'),
                    ShiftConfigID: shiftConfigId,
                    ShiftNameResolved: shiftNameVal,
                    ShiftClassificationID: classId,
                    hasShiftNameKey: shift && (shift.ShiftName != null || shift.shiftName != null),
                    listShiftConfigCount: listLen,
                    listClassificationCount: classListLen,
                });
                var shiftConfig = _.find($scope.DataObject.ShiftConfigList, function (sc) {
                    return String(sc.ShiftConfigID || sc.shiftConfigID) === String(shiftConfigId);
                });
                var shiftModelSource = 'none';
                if (shiftConfig) {
                    $scope.DataObject.addEditSchedule.Shift = shiftConfig;
                    shiftModelSource = 'ShiftConfigList';
                } else if (shiftConfigId != null && shiftConfigId !== '') {
                    /* ui-select shows nothing without ng-model; list may not be loaded yet or ID type differs */
                    $scope.DataObject.addEditSchedule.Shift = {
                        ShiftConfigID: shiftConfigId,
                        ShiftName: shiftNameVal,
                        shiftName: shiftNameVal,
                    };
                    shiftModelSource = 'stub';
                }
                var classification = _.find($scope.DataObject.ShiftClassificationList, function (c) {
                    return String(c.ShiftClassificationID || c.shiftClassificationID) === String(classId);
                });
                var classModelSource = 'none';
                if (classification) {
                    $scope.DataObject.addEditSchedule.ShiftClassification = classification;
                    classModelSource = 'ShiftClassificationList';
                } else if (classId != null && classId !== '') {
                    var classNameVal = getScheduleRowField(shift, 'ShiftClassificationName');
                    $scope.DataObject.addEditSchedule.ShiftClassification = {
                        ShiftClassificationID: classId,
                        ShiftClassificationName: classNameVal,
                        shiftClassificationName: classNameVal,
                    };
                    classModelSource = 'stub';
                }
                var modalDiag = {
                    shiftModelSource: shiftModelSource,
                    classModelSource: classModelSource,
                    Shift: $scope.DataObject.addEditSchedule.Shift,
                    ShiftClassification: $scope.DataObject.addEditSchedule.ShiftClassification,
                    ShiftNameFallback: $scope.DataObject.addEditSchedule.ShiftNameFallback,
                };
                console.log(logPrefix + ' modal model', modalDiag);
                insertLog({
                    context: 'EditShiftSchedule-open',
                    raw: {
                        ShiftScheduleID: getScheduleRowField(shift, 'ShiftScheduleID'),
                        ShiftConfigID: shiftConfigId,
                        ShiftNameResolved: shiftNameVal,
                        ShiftClassificationID: classId,
                        listShiftConfigCount: listLen,
                        listClassificationCount: classListLen,
                    },
                    modal: modalDiag,
                });
                if (!$scope.$$phase && !$scope.$root.$$phase) {
                    $scope.$apply();
                }
                angular.element("#addEditScheduleCalendar").modal("show");
            } else {
                console.warn('[Radflow EditSchedule][schedule-calendar] EditShiftSchedule called with empty shift');
            }
        }

        $scope.SetShiftSchedule = function () {
            var edit = $scope.DataObject.addEditSchedule;
            var providerId = edit.ProviderID;
            if (providerId != null && providerId !== '') {
                providerId = String(providerId);
            } else {
                providerId = null;
            }
            var sid = edit.ShiftScheduleID;
            if (sid != null && sid !== '') {
                sid = String(sid);
            } else {
                sid = null;
            }
            var shiftCfgId = (edit.Shift && edit.Shift.ShiftConfigID) ? String(edit.Shift.ShiftConfigID) : null;
            if (!shiftCfgId && edit.ShiftConfigIDFallback != null && edit.ShiftConfigIDFallback !== '') {
                shiftCfgId = String(edit.ShiftConfigIDFallback);
            }
            var classIdParam = (edit.ShiftClassification && edit.ShiftClassification.ShiftClassificationID) ?
                String(edit.ShiftClassification.ShiftClassificationID) : null;
            var shiftNameParam = (edit.Shift && edit.Shift.ShiftName) ? edit.Shift.ShiftName : edit.ShiftNameFallback;

            var params = {
                ShiftScheduleID: sid,
                ProviderID: providerId,
                ProviderIDs: providerId,
                ShiftConfigID: shiftCfgId,
                StartTime: ScheduleService.formatTime(edit.StartTime),
                EndTime: ScheduleService.formatTime(edit.EndTime),
                CreatedBy: $sessionStorage.currentUserData.userId ? String($sessionStorage.currentUserData.userId) : null,
                Flag: "M",
                ShiftClassificationID: classIdParam,
                ProviderName: edit.ProviderName,
                Email: edit.Email,
                ShiftName: shiftNameParam || null,
                TenantID: ($scope.DataObject.SelectedTenant) ? String($scope.DataObject.SelectedTenant.TenantID) : null,
                ShiftPayAmount: edit.ShiftPayAmount,
                PricePerExcessRVU: (edit.PricePerExcessRVU != null) ? edit.PricePerExcessRVU : null,
                MinimumWRVUPerHour: (edit.MinimumWRVUPerHour != null) ? edit.MinimumWRVUPerHour : null,
            };
            /* Single date field: keep end in sync for API and proc */
            if (edit.StartDate) {
                edit.EndDate = edit.StartDate;
                var CSTStartDate = $filter('CSTDateTime')(edit.StartDate);
                var startFmt = moment(CSTStartDate).format("MM-DD-YYYY HH:mm");
                params.StartDate = startFmt;
                params.EndDate = startFmt;
            }
            //if ($scope.DataObject.addEditSchedule.StartDate) {
            //    var CSTEndDate = $filter('CSTDateTime')($scope.DataObject.addEditSchedule.EndDate);
            //}
            ScheduleService.SetShiftSchedule(params).then(function () {
                angular.element("#addEditScheduleCalendar").modal('hide');
                $scope.ClearAddEditScheduleData();
                toaster.success("Schedule Updated Successfully.");
                GetShiftScheduleCalendar();
            }, function (err) {
                toaster.error("Some Error Occurred!");
            });
        }

        $scope.ClearAddEditScheduleData = function () {
            $scope.DataObject.addEditSchedule = {
                Shift: null,
                StartDate: null,
                EndDate: null,
                StartTime: null,
                EndTime: null,
                ShiftClassification: null,
                ProviderID: null,
                ShiftScheduleID: null,
                ProviderName: null,
                Email: null,
                ShiftPayAmount: null,
                PricePerExcessRVU: null,
                MinimumWRVUPerHour: null,
            }
        }
    }
})();
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('scheduleSettingCmp', {
            templateUrl: 'app/theme/components/shift-schedule/schedule-setting-cmp/schedule-setting-cmp.html',
            bindings: {
            },
            controller: scheduleSettingCmpCtrl
        });

    function scheduleSettingCmpCtrl($scope, ScheduleService, $q, $sessionStorage, $filter, toaster, $compile, $timeout, CommonService, ManageLocationService) {
        var vm = this;

        /** Persists via api/common/LogApplicationInfo → CommonService.InsertLogs (DB). */
        function insertLog(editPayload) {
            var uid = ($sessionStorage.currentUserData && $sessionStorage.currentUserData.userId) ? String($sessionStorage.currentUserData.userId) : '';
            var details;
            try {
                details = angular.isString(editPayload) ? editPayload : JSON.stringify(editPayload);
            } catch (e) {
                details = String(editPayload);
            }
            if (CommonService && angular.isFunction(CommonService.LogApplicationInfo)) {
                CommonService.LogApplicationInfo({
                    LogDetails: details,
                    Application: 'ShiftSchedule-EditSchedule-setting',
                    UserID: uid,
                }).catch(angular.noop);
            }
        }
        var gridAPI = null;
        var PageSize = 50;
        var ScheduleList = [];
        var statusBarComponent = null;

        $scope.TenantList = [];

        $scope.DataObject = {
            ShiftScheduleIDList: [],
            ShiftClassificationList: [],
            ProvidersList: [],
            ShiftConfigList: [],
            dateSearchOptions: {
                formatYear: 'yyyy',
                startingDay: 1,
                showWeeks: false
            },
            addEditSchedule: {
                ShiftScheduleID: null,
                Provider: null,
                Shift: null,
                StartDate: new Date(),
                isStartDateOpen: false,
                EndDate: new Date(),
                isEndDateOpen: false,
                StartTime: null,
                EndTime: null,
                isSaveBtnDisabled: false,
                ShiftClassification: null,
                ProviderName: null,
                Email: null,
                ShiftName: null,
                ShiftPayAmount: null,
                PricePerExcessRVU: null,
                MinimumWRVUPerHour: null,
            },
            Filter: {
                SelectedDate: {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment(),
                    label: "Last 7 Days",
                },
                dateRangeTooltip: "Select Date Range",
                SearchKey: null,
                SelectedTenant: null,
            },
        }
        $scope.DOSopts = {
            alwaysShowCalendars: true,
            autoUpdateInput: false,
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "MM/DD/YYYY",
                toLabel: "To",
                customRangeLabel: 'Custom range',
            },
            ranges: {
                'Today': [moment(), moment()],
                'Last 3 Days': [moment().subtract(2, 'days'), moment()],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'Last Year': [moment().subtract(1, 'year').add(1, 'days'), moment()],

            },
            eventHandlers: {
                'apply.daterangepicker': function (event, picker) {
                    $scope.DataObject.Filter.dateRangeTooltip =
                        ($scope.DataObject.Filter.SelectedDate.startDate && $scope.DataObject.Filter.SelectedDate.endDate) ?
                            $scope.DataObject.Filter.SelectedDate.startDate.format("MM/DD/YYYY") + " - " + $scope.DataObject.Filter.SelectedDate.endDate.format("MM/DD/YYYY") :
                            "Select Date Range";
                }
            }
        };

        vm.$onInit = function () {
            $scope.DataObject.Filter.dateRangeTooltip =
                ($scope.DataObject.Filter.SelectedDate.startDate && $scope.DataObject.Filter.SelectedDate.endDate) ?
                    $scope.DataObject.Filter.SelectedDate.startDate.format("MM/DD/YYYY") + " - " + $scope.DataObject.Filter.SelectedDate.endDate.format("MM/DD/YYYY") :
                    "Select Date Range";
            GetTenantsByUserID();

        }
        vm.$onDestroy = function () { }
        vm.$onChanges = function () { }

        function ActionButtonRenderer() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                var schedId = parseInt(params.data.ShiftScheduleID, 10);
                $scope.DataObject.ShiftScheduleIDList[schedId] = params;
                var editIcon = document.createElement('i');
                editIcon.className = 'cursor-pointer glyphicon glyphicon-pencil p-4px-all';
                editIcon.title = 'Edit';
                editIcon.style.color = '#07e6c4';
                editIcon.setAttribute('ng-click', 'EditSchedule(DataObject.ShiftScheduleIDList[' + schedId + '])');
                this.eGui.appendChild(editIcon);

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }

        function getScheduleRowField(data, pascalFieldName) {
            if (!data) {
                return null;
            }
            var v = data[pascalFieldName];
            if (v != null && v !== '') {
                return v;
            }
            var camel = pascalFieldName.charAt(0).toLowerCase() + pascalFieldName.slice(1);
            v = data[camel];
            if (v != null && v !== '') {
                return v;
            }
            return null;
        }

        function readScheduleGridDateFromParams(params, fieldPascal) {
            if (typeof params.getValue === 'function') {
                try {
                    var gv = params.getValue();
                    if (gv != null && gv !== '') {
                        return gv;
                    }
                } catch (e) { /* ag-Grid older */ }
            }
            if (params.value != null && params.value !== '') {
                return params.value;
            }
            return getScheduleRowField(params.data, fieldPascal);
        }

        /** localDate filter expects a string; Date/number from API or ag-Grid must be coerced first. */
        function normalizeShiftScheduleDateForLocalFilter(raw) {
            if (raw == null || raw === '') {
                return '';
            }
            if (angular.isDate(raw)) {
                if (isNaN(raw.getTime())) {
                    return '';
                }
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'number' && isFinite(raw)) {
                return moment(raw).format('YYYY-MM-DD HH:mm:ss');
            }
            if (typeof raw === 'string') {
                var trimmed = raw.trim();
                if (!trimmed) {
                    return '';
                }
                var strictFormats = [
                    'MM-DD-YYYY HH:mm',
                    'MM-DD-YYYY HH:mm:ss',
                    'MM-DD-YYYY',
                    'YYYY-MM-DD HH:mm:ss',
                    'YYYY-MM-DDTHH:mm:ss',
                    'YYYY-MM-DDTHH:mm:ss.SSS',
                    'YYYY-MM-DDTHH:mm:ss.SSSSSSS',
                    'YYYY-MM-DD',
                    'M/D/YYYY H:mm',
                    'M/D/YYYY HH:mm',
                    'M/D/YYYY',
                    'MM/DD/YYYY H:mm',
                    'MM/DD/YYYY HH:mm',
                    'MM/DD/YYYY',
                    'MM/DD/YYYY hh:mm:ss A',
                    'M/D/YYYY h:mm:ss A',
                    'MM/DD/YYYY hh:mm A'
                ];
                var parsed = moment(trimmed, strictFormats, true);
                if (!parsed.isValid()) {
                    parsed = moment(trimmed);
                }
                if (parsed.isValid()) {
                    return parsed.format('YYYY-MM-DD HH:mm:ss');
                }
            }
            return typeof raw === 'string' ? raw : '';
        }

        function formatShiftScheduleGridDate(raw) {
            var forFilter = normalizeShiftScheduleDateForLocalFilter(raw);
            if (forFilter === '') {
                return '';
            }
            var m;
            var localized = $filter('localDate')(forFilter, false, new Date());
            if (localized) {
                m = moment(localized, 'M/D/YYYY HH:mm', true);
                if (!m.isValid()) {
                    m = moment(localized);
                }
            }
            if (!m || !m.isValid()) {
                m = moment(forFilter, 'YYYY-MM-DD HH:mm:ss', true);
            }
            if (!m.isValid()) {
                m = moment(forFilter);
            }
            return m.isValid() ? m.format('MM-DD-YYYY') : '';
        }

        var ScheduleGridColDef = [
            {
                field: "ProviderName",
                valueGetter: function (params) {
                    return getScheduleRowField(params.data, 'ProviderName');
                }
            },
            {
                field: "ShiftName",
                sort: 'asc',
                valueGetter: function (params) {
                    return getScheduleRowField(params.data, 'ShiftName');
                }
            },
            {
                field: "ShiftClassificationName",
                valueGetter: function (params) {
                    return getScheduleRowField(params.data, 'ShiftClassificationName');
                }
            },
            {
                field: "StartDate",
                cellRenderer: function (params) {
                    return formatShiftScheduleGridDate(readScheduleGridDateFromParams(params, 'StartDate'));
                }
            },
            {
                field: "StartTime",
                sortable: false,
            },
            {
                field: "EndDate",
                cellRenderer: function (params) {
                    return formatShiftScheduleGridDate(readScheduleGridDateFromParams(params, 'EndDate'));
                }
            },
            {
                field: "EndTime",
                sortable: false,
            },
            {
                headerName: "Shift Pay Amount",
                field: "ShiftPayAmount",
                valueGetter: function (params) {
                    return getScheduleRowField(params.data, 'ShiftPayAmount');
                },
                valueFormatter: function (params) {
                    return (params.value != null && params.value !== '') ? '$' + Number(params.value).toFixed(2) : '';
                },
                sortable: false,
            },
            {
                headerName: "Price per Excess wRVU",
                field: "PricePerExcessRVU",
                valueGetter: function (params) {
                    return getScheduleRowField(params.data, 'PricePerExcessRVU');
                },
                valueFormatter: function (params) {
                    return (params.value != null && params.value !== '') ? '$' + Number(params.value).toFixed(2) : '';
                },
                sortable: false,
            },
            {
                headerName: "Minimum wRVU per hour",
                field: "MinimumWRVUPerHour",
                valueGetter: function (params) {
                    return getScheduleRowField(params.data, 'MinimumWRVUPerHour');
                },
                valueFormatter: function (params) {
                    return (params.value != null && params.value !== '') ? Number(params.value).toFixed(2) : '';
                },
                sortable: false,
            },
            {
                field: "Action",
                cellRenderer: ActionButtonRenderer(),
                initialWidth: 100,
                sortable: false,
                resizable: false,
            },
        ]
        var ScheduleGridOptions = {
            columnDefs: ScheduleGridColDef,
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: true,
                lockVisible: true,
                menuTabs: []
            },
            suppressMultiSort: true,
            sortingOrder: ['desc', 'asc'],
            rowModelType: 'serverSide',
            cacheBlockSize: PageSize,
            suppressContextMenu: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            localeText: { loadingError: 'Some error has occurred!' },
            getRowId: function (params) {
                return params.data.RowID;
            },
            onGridReady: function () {
                statusBarComponent = gridAPI.getStatusPanel('GridFooter');
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';

                var datasource = createServerSideDatasource();
                gridAPI.setServerSideDatasource(datasource);
            },
            onSortChanged: function (params) {
                resetGrid();
            },
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },
        }
        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }
        function createServerSideDatasource() {
            return {
                getRows: function (params) {

                    var obj = {
                        PageSize: PageSize,
                        Search: $scope.DataObject.Filter.SearchKey
                    };

                    if ($scope.DataObject.Filter.SelectedTenant) {
                        obj.TenantID = $scope.DataObject.Filter.SelectedTenant.TenantID;
                    }

                    if (params.request.sortModel.length > 0) {
                        obj.OrderByField = params.request.sortModel[0].colId;
                        obj.OrderBy = params.request.sortModel[0].sort;
                    }
                    obj.PageNum = params.request.endRow / PageSize;

                    if ($scope.DataObject.Filter.SelectedDate) {
                        if ($scope.DataObject.Filter.SelectedDate.startDate) {
                            obj.StartDate = $filter('CSTDateTime')(moment(moment(new Date($scope.DataObject.Filter.SelectedDate.startDate)).format("YYYY-MM-DD") + ' ' + "00:00:00"));
                        }
                        if ($scope.DataObject.Filter.SelectedDate.endDate) {
                            obj.EndDate = $filter('CSTDateTime')(moment(moment(new Date($scope.DataObject.Filter.SelectedDate.endDate)).format("YYYY-MM-DD") + ' ' + "23:59:59"));
                        }
                    }

                    GetShiftSchedule(obj).then(function (data) {
                        statusBarComponent.eGui.hidden = true;
                        if (ScheduleList.length == 0) {
                            gridAPI.showNoRowsOverlay();
                        } else {
                            gridAPI.hideOverlay();
                            statusBarComponent.eGui.hidden = false;
                            var TotalRows = parseInt(ScheduleList[0].PageCounts, 10) || 0;
                            var statusDiv = document.createElement('div');
                            statusDiv.style.color = 'white';
                            statusDiv.textContent = 'Showing ' + ScheduleList.length + ' of ' + TotalRows + ' Total Records';
                            statusBarComponent.eGui.innerHTML = '';
                            statusBarComponent.eGui.appendChild(statusDiv);
                        }
                        var rowsForBlock = ScheduleList.slice(params.request.startRow, params.request.endRow);
                        params.success({
                            rowData: rowsForBlock,
                            rowCount: undefined,
                        });
                    }, function (err) {
                        console.log("Error > ", err);
                        params.fail();
                    });
                },
            };
        }

        $scope.Search = function () {
            resetGrid();
        }

        function resetGrid() {
            ScheduleList = [];
            gridAPI.refreshServerSide({ purge: true })
        }

        $scope.ClearFilter = function () {
            $scope.DataObject.Filter = {
                SelectedDate: {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment(),
                    label: "Last 7 Days",
                },
                SearchKey: null,
                SelectedTenant: applyDefaultTenant($scope.TenantList),
            };
            var tenantId = $scope.DataObject.Filter.SelectedTenant ? $scope.DataObject.Filter.SelectedTenant.TenantID : null;
            GetAllUsers(tenantId).then(function () {
                resetGrid();
            });
        }

        $scope.OnTenantChanged = function () {
            var tenantId = $scope.DataObject.Filter.SelectedTenant ? $scope.DataObject.Filter.SelectedTenant.TenantID : null;
            $scope.DataObject.ShiftClassificationList = [];
            $scope.DataObject.ShiftConfigList = [];
            if (!tenantId) {
                $scope.DataObject.ProvidersList = [];
                return;
            }
            GetShiftClassification();
            GetAllUsers(tenantId);
            // Intentional: schedule-settings uses a server-side paginated grid that is
            // expensive to reload automatically; clear and let the user trigger Search.
            resetGrid();
        };
        function GetShiftSchedule(params) {
            var d = $q.defer();
            ScheduleService.GetShiftSchedule(params).then(function (res) {
                if (res && angular.isFunction(res.plain)) {
                    res = res.plain();
                }
                if (!angular.isArray(res)) {
                    res = res == null ? [] : [res];
                }
                res = ScheduleService.assignRowID(res);
                ScheduleList = _.uniqBy(_.concat(ScheduleList, res), "ShiftScheduleID");
                d.resolve(ScheduleList);
            }, function (err) {
                d.resolve(ScheduleList);
            });
            return d.promise;
        }

        function GetAllUsers(tenantId) {
            var d = $q.defer();
            if (!tenantId) {
                $scope.DataObject.ProvidersList = [];
                d.resolve();
                return d.promise;
            }
            CommonService.GetAllProvidersByTenantID(tenantId).then(function (res) {
                if (res && angular.isFunction(res.plain)) {
                    res = res.plain();
                }
                $scope.DataObject.ProvidersList = angular.isArray(res) ? res : (res ? [res] : []);
                d.resolve();
            }, function (err) {
                console.error('[Radflow] GetAllProvidersByTenantID failed for tenantId:', tenantId, err);
                toaster.error('Failed to load providers list.');
                d.resolve();
            });
            return d.promise;
        }

        $scope.GetShiftConfigurations = function (shiftName) {
            var d = $q.defer();
            ScheduleService.GetShiftConfig({
                OrderByField: "ShiftName",
                OrderBy: "asc",
                ShiftName: shiftName,
                TenantID: ($scope.DataObject.Filter.SelectedTenant) ? $scope.DataObject.Filter.SelectedTenant.TenantID : null,
            }).then(function (res) {
                $scope.DataObject.ShiftConfigList = _.uniqBy(_.concat($scope.DataObject.ShiftConfigList, res), 'ShiftConfigID');
                d.resolve(res);
            })

            return d.promise;
        }
        $scope.EditSchedule = function (row) {
            var logPrefix = '[Radflow EditSchedule][schedule-setting]';
            var rowShiftCfgId = row.data && getScheduleRowField(row.data, 'ShiftConfigID');
            if (!row || !row.data) {
                console.warn(logPrefix + ' missing row.data', row);
                return;
            }
            if (!rowShiftCfgId) {
                var blockedDiag = {
                    rowKeys: Object.keys(row.data || {}),
                    getScheduleRowField_ShiftConfigID: getScheduleRowField(row.data, 'ShiftConfigID'),
                };
                console.warn(logPrefix + ' no ShiftConfigID on row (edit blocked)', blockedDiag);
                insertLog({
                    context: 'EditSchedule-blocked-no-ShiftConfigID',
                    diagnostic: blockedDiag,
                });
            }
            if (row.node && row.data && rowShiftCfgId) {
                row.node.setSelected(true);
                if (row.data) {
                    $scope.DataObject.addEditSchedule = {
                        ShiftScheduleID: row.data.ShiftScheduleID,
                        StartDate: moment($filter('localDate')(normalizeShiftScheduleDateForLocalFilter(getScheduleRowField(row.data, 'StartDate')), false, new Date())).toDate(),
                        isStartDateOpen: false,
                        EndDate: moment($filter('localDate')(normalizeShiftScheduleDateForLocalFilter(getScheduleRowField(row.data, 'EndDate')), false, new Date())).toDate(),
                        isEndDateOpen: false,
                        StartTime: (row.data.StartTime) ? new Date(1970, 0, 1, row.data.StartTime.split(':')[0], row.data.StartTime.split(':')[1], 0) : null,
                        EndTime: (row.data.EndTime) ? new Date(1970, 0, 1, row.data.EndTime.split(':')[0], row.data.EndTime.split(':')[1], 0) : null,
                        isSaveBtnDisabled: false,
                        ShiftConfigIDFallback: getScheduleRowField(row.data, 'ShiftConfigID'),
                        ShiftClassificationIDFallback: getScheduleRowField(row.data, 'ShiftClassificationID'),
                        ShiftNameFallback: getScheduleRowField(row.data, 'ShiftName'),
                        ShiftPayAmount: (getScheduleRowField(row.data, 'ShiftPayAmount') != null) ? getScheduleRowField(row.data, 'ShiftPayAmount') : null,
                        PricePerExcessRVU: (getScheduleRowField(row.data, 'PricePerExcessRVU') != null) ? getScheduleRowField(row.data, 'PricePerExcessRVU') : null,
                        MinimumWRVUPerHour: (getScheduleRowField(row.data, 'MinimumWRVUPerHour') != null) ? getScheduleRowField(row.data, 'MinimumWRVUPerHour') : null,
                    }

                    var selectedProvider = _.find($scope.DataObject.ProvidersList, function (p) {
                        return String(p.Id) === String(row.data.ProviderID);
                    });
                    if (selectedProvider) {
                        $scope.DataObject.addEditSchedule.Provider = selectedProvider;
                    }
                    var scId = getScheduleRowField(row.data, 'ShiftConfigID');
                    var shiftNameVal = getScheduleRowField(row.data, 'ShiftName');
                    var selectedShift = _.find($scope.DataObject.ShiftConfigList, function (sc) {
                        return String(sc.ShiftConfigID || sc.shiftConfigID) === String(scId);
                    });
                    if (selectedShift) {
                        $scope.DataObject.addEditSchedule.Shift = selectedShift;
                    } else if (scId != null && scId !== '') {
                        $scope.DataObject.addEditSchedule.Shift = {
                            ShiftConfigID: scId,
                            ShiftName: shiftNameVal,
                            shiftName: shiftNameVal,
                        };
                    }

                    var clsId = getScheduleRowField(row.data, 'ShiftClassificationID');
                    var classification = _.find($scope.DataObject.ShiftClassificationList, function (c) {
                        return String(c.ShiftClassificationID || c.shiftClassificationID) === String(clsId);
                    });
                    if (classification) {
                        $scope.DataObject.addEditSchedule.ShiftClassification = classification;
                    } else if (clsId != null && clsId !== '') {
                        var clsNameVal = getScheduleRowField(row.data, 'ShiftClassificationName');
                        $scope.DataObject.addEditSchedule.ShiftClassification = {
                            ShiftClassificationID: clsId,
                            ShiftClassificationName: clsNameVal,
                            shiftClassificationName: clsNameVal,
                        };
                    }
                    var shiftBind = selectedShift ? 'ShiftConfigList' : (scId ? 'stub' : 'none');
                    var classBind = classification ? 'ShiftClassificationList' : (clsId ? 'stub' : 'none');
                    var rawDiag = {
                        ShiftScheduleID: row.data.ShiftScheduleID,
                        ShiftConfigID: scId,
                        ShiftNameResolved: shiftNameVal,
                        hasProvider: !!selectedProvider,
                        listShiftConfigCount: ($scope.DataObject.ShiftConfigList && $scope.DataObject.ShiftConfigList.length) || 0,
                    };
                    var modalDiag = {
                        shiftModelSource: shiftBind,
                        classModelSource: classBind,
                        Shift: $scope.DataObject.addEditSchedule.Shift,
                        ShiftNameFallback: $scope.DataObject.addEditSchedule.ShiftNameFallback,
                    };
                    console.log(logPrefix + ' raw row', rawDiag);
                    console.log(logPrefix + ' modal model', modalDiag);
                    insertLog({
                        context: 'EditSchedule-open',
                        raw: rawDiag,
                        modal: modalDiag,
                    });
                    angular.element("#ScheduleModal").modal('show');
                }
            }
        }
        $scope.SetShiftSchedule = function () {
            $scope.DataObject.addEditSchedule.isSaveBtnDisabled = true;
            var Flag = ($scope.DataObject.addEditSchedule.ShiftScheduleID && $scope.DataObject.addEditSchedule.ShiftScheduleID != -1) ? "M" : "N";
            var edit = $scope.DataObject.addEditSchedule;
            var shiftCfgId = (edit.Shift && edit.Shift.ShiftConfigID) ? edit.Shift.ShiftConfigID : null;
            if (!shiftCfgId && edit.ShiftConfigIDFallback != null && edit.ShiftConfigIDFallback !== '') {
                shiftCfgId = edit.ShiftConfigIDFallback;
            }
            var classIdParam = (edit.ShiftClassification && edit.ShiftClassification.ShiftClassificationID) ?
                edit.ShiftClassification.ShiftClassificationID : null;
            var shiftNameParam = (edit.Shift && edit.Shift.ShiftName) ? edit.Shift.ShiftName : edit.ShiftNameFallback;

            var providerIdParam = (edit.Provider && edit.Provider.Id) ? edit.Provider.Id : null;
            var params = {
                ShiftScheduleID: (Flag == "N") ? -1 : edit.ShiftScheduleID,
                ProviderID: providerIdParam,
                ProviderIDs: providerIdParam,
                ShiftConfigID: shiftCfgId,
                StartTime: ScheduleService.formatTime(edit.StartTime),
                EndTime: ScheduleService.formatTime(edit.EndTime),
                CreatedBy: $sessionStorage.currentUserData.userId,
                Flag: Flag,
                ShiftClassificationID: classIdParam,
                ProviderName: (edit.Provider) ?
                    (edit.Provider.LastName + ", " + edit.Provider.FirstName) : null,
                Email: (edit.Provider && edit.Provider.Email) ?
                    edit.Provider.Email : null,
                ShiftName: shiftNameParam || null,
                TenantID: ($scope.DataObject.Filter.SelectedTenant) ? $scope.DataObject.Filter.SelectedTenant.TenantID : null,
                ShiftPayAmount: ($scope.DataObject.addEditSchedule.ShiftPayAmount != null) ? $scope.DataObject.addEditSchedule.ShiftPayAmount : null,
                PricePerExcessRVU: ($scope.DataObject.addEditSchedule.PricePerExcessRVU != null) ? $scope.DataObject.addEditSchedule.PricePerExcessRVU : null,
                MinimumWRVUPerHour: ($scope.DataObject.addEditSchedule.MinimumWRVUPerHour != null) ? $scope.DataObject.addEditSchedule.MinimumWRVUPerHour : null,
            };
            if ($scope.DataObject.addEditSchedule.StartDate) {
                var CSTStartDate = $filter('CSTDateTime')($scope.DataObject.addEditSchedule.StartDate);
                params.StartDate = moment(CSTStartDate).format("MM-DD-YYYY HH:mm");
            }
            if ($scope.DataObject.addEditSchedule.EndDate) {
                var CSTEndDate = $filter('CSTDateTime')($scope.DataObject.addEditSchedule.EndDate);
                params.EndDate = moment(CSTEndDate).format("MM-DD-YYYY HH:mm");
            }
            ScheduleService.SetShiftSchedule(params).then(function () {
                $scope.DataObject.addEditSchedule.isSaveBtnDisabled = false;
                angular.element("#ScheduleModal").modal('hide');
                $scope.ClearAddEditScheduleData();
                (Flag == "N") ? toaster.success("Schedule Saved Successfully.") : toaster.success("Schedule Updated Successfully.")
                resetGrid();
            }, function (err) {
                $scope.DataObject.addEditSchedule.isSaveBtnDisabled = false;
                toaster.error("Some Error Occurred!");
            });
        }

        $scope.ClearAddEditScheduleData = function () {
            $scope.DataObject.addEditSchedule = {
                ShiftScheduleID: null,
                Provider: null,
                Shift: null,
                StartDate: new Date(),
                isStartDateOpen: false,
                EndDate: new Date(),
                isEndDateOpen: false,
                StartTime: null,
                EndTime: null,
                isSaveBtnDisabled: false,
                ShiftClassification: null,
                ProviderName: null,
                Email: null,
                ShiftName: null,
                ShiftPayAmount: null,
                PricePerExcessRVU: null,
                MinimumWRVUPerHour: null,
            }
        }
        function applyDefaultTenant(list) {
            if (!list || list.length === 0) {
                return null;
            }
            if (list.length === 1) {
                return list[0];
            }
            return _.find(list, { IsDefault: true }) || null;
        }

        function GetTenantsByUserID() {
            ManageLocationService.GetTenantsByUserID({ UserID: $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.TenantList = result || [];
                $scope.DataObject.Filter.SelectedTenant = applyDefaultTenant($scope.TenantList);
                var tenantId = $scope.DataObject.Filter.SelectedTenant ? $scope.DataObject.Filter.SelectedTenant.TenantID : null;
                GetShiftClassification();
                GetAllUsers(tenantId);
                var gridDiv = document.querySelector('#ScheduleSettingGrid');
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, ScheduleGridOptions);
                    gridAPI = ScheduleGridOptions.api;
                }
            });
        }

        function GetShiftClassification() {
            var d = $q.defer();
            var params = {};
            if ($scope.DataObject.Filter.SelectedTenant) {
                params.tenantID = $scope.DataObject.Filter.SelectedTenant.TenantID;
            }
            ScheduleService.GetShiftClassification(params).then(function (res) {
                $scope.DataObject.ShiftClassificationList = (res && res.length > 0) ? _.sortBy(res, 'ShiftClassificationName') : [];
                d.resolve(res);
            }, function (err) {
                $scope.DataObject.ShiftClassificationList = [];
                d.resolve([]);
            });
            return d.promise;
        }

        $scope.onShiftSelectionChanged = function () {
            if ($scope.DataObject.addEditSchedule && $scope.DataObject.addEditSchedule.Shift) {
                $scope.DataObject.addEditSchedule.StartTime = (($scope.DataObject.addEditSchedule.Shift.StartTime)) ? new Date(1970, 0, 1, ($scope.DataObject.addEditSchedule.Shift.StartTime).split(':')[0], ($scope.DataObject.addEditSchedule.Shift.StartTime).split(':')[1], 0) : null;
                $scope.DataObject.addEditSchedule.EndTime = (($scope.DataObject.addEditSchedule.Shift.EndTime)) ? new Date(1970, 0, 1, ($scope.DataObject.addEditSchedule.Shift.EndTime).split(':')[0], ($scope.DataObject.addEditSchedule.Shift.EndTime).split(':')[1], 0) : null;
            }
            else {
                $scope.DataObject.addEditSchedule.StartTime = null;
                $scope.DataObject.addEditSchedule.EndTime = null;
            }
        }
    }
})();
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('shiftClassificationCmp', {
            templateUrl: 'app/theme/components/shift-schedule/shift-classification-cmp/shift-classification-cmp.html',
            bindings: {
            },
            controller: shiftClassificationCmpCtrl
        });

    function shiftClassificationCmpCtrl($scope, ScheduleService, $q, toaster, $sessionStorage, $compile, $timeout, ManageLocationService) {
        var vm = this;
        var gridAPI = null;
        $scope.TenantList = [];
        vm.$onInit = function () {
            GetTenantsByUserID();
        }
        vm.$onDestroy = function () { }
        vm.$onChanges = function (changes) { }

        $scope.DataObject = {
            SearchText: null,
            ShiftClassificationIDList: {},
            Filter: {
                SelectedTenant: null,
            },
            addEditClassification: {
                ShiftClassificationID: null,
                ShiftClassificationName: null,
                isSaveBtnDisabled: false,
            }
        }

        function ActionButtonRenderer() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                $scope.DataObject.ShiftClassificationIDList[params.data.ShiftClassificationID] = params;
                var rowExpr = 'this.DataObject.ShiftClassificationIDList[' + params.data.ShiftClassificationID + ']';
                var editIcon = document.createElement('i');
                editIcon.className = 'cursor-pointer glyphicon glyphicon-pencil p-4px-all';
                editIcon.title = 'Edit';
                editIcon.style.color = '#07e6c4';
                editIcon.setAttribute('ng-click', 'EditClassification(' + rowExpr + ')');
                var deleteButton = document.createElement('button');
                deleteButton.className = 'btn btn-transparent border-0 px-0 pt-2px mx-2 my-0 pb-4px';
                deleteButton.title = 'Delete';
                deleteButton.style.color = '#07e6c4';
                deleteButton.setAttribute('ng-click', 'DeleteClassification(' + rowExpr + ')');
                var deleteIcon = document.createElement('i');
                deleteIcon.className = 'fa fa-trash-o fs-17px';
                deleteButton.appendChild(deleteIcon);
                this.eGui.appendChild(editIcon);
                this.eGui.appendChild(deleteButton);

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }

        var ShiftClassificationColumns = [
            {
                field: "ShiftClassificationName",
                sort: "asc",
                flex: 1,
                sortable: true,
            },
            {
                field: "Action", initialWidth: 100,
                cellRenderer: ActionButtonRenderer()
            }
        ];

        var ShiftClassificationGridOptions = {
            columnDefs: ShiftClassificationColumns,
            sortingOrder: ['asc', 'desc'],
            defaultColDef: {
                resizable: false,
                suppressMenu: true,
                suppressMovable: true,
            },
            rowData: [],
            getRowId: function (params) {
                if (params && params.data && params.data.ShiftClassificationID) {
                    return params.data.ShiftClassificationID;
                }
            },
        }

        $scope.addShiftClassification = function () {
            angular.element("#ShiftClassificationModal").modal('show');
        }
        $scope.SaveShiftClassification = function () {
            $scope.DataObject.addEditClassification.isSaveBtnDisabled = true;
            var Flag = ($scope.DataObject.addEditClassification.ShiftClassificationID && $scope.DataObject.addEditClassification.ShiftClassificationID != -1) ? "M" : "N"
            var params = {
                ShiftClassificationID: (Flag != "N") ? $scope.DataObject.addEditClassification.ShiftClassificationID : -1,
                ShiftClassificationName: $scope.DataObject.addEditClassification.ShiftClassificationName,
                CreatedBy: $sessionStorage.currentUserData.userId,
                Flag: Flag,
                TenantID: ($scope.DataObject.Filter.SelectedTenant) ? $scope.DataObject.Filter.SelectedTenant.TenantID : null,
            }
            ScheduleService.SetShiftClassification(params).then(function (res) {
                $scope.DataObject.addEditClassification.isSaveBtnDisabled = false;

                if (res && res.length > 0) {
                    toaster.warning("Classification with the same name already exists.")
                }
                else {
                    angular.element("#ShiftClassificationModal").modal('hide');
                    (Flag == "N") ? toaster.success("Classification Saved Successfully.") : toaster.success("Classification Updated Successfully.");
                    $scope.clearAddClassificationData();
                    GetShiftClassification();
                }
            }, function (err) {
                $scope.DataObject.addEditClassification.isSaveBtnDisabled = false;
                toaster.error("Some Error Occurred!")
            });
        }
        $scope.EditClassification = function (row) {
            if (row.node && row.data && row.data.ShiftClassificationID) {
                row.node.setSelected(true);
                $scope.DataObject.addEditClassification = {
                    ShiftClassificationID: row.data.ShiftClassificationID,
                    ShiftClassificationName: row.data.ShiftClassificationName,
                    isSaveBtnDisabled: false,
                }
                angular.element("#ShiftClassificationModal").modal('show');
            }
        }
        $scope.DeleteClassification = function (row) {
            if (row.node && row.data && row.data.ShiftClassificationID) {
                ScheduleService.SetShiftClassification({
                    ShiftClassificationID: row.data.ShiftClassificationID,
                    ShiftClassificationName: row.data.ShiftClassificationName,
                    CreatedBy: $sessionStorage.currentUserData.userId,
                    Flag: "D",
                    TenantID: ($scope.DataObject.Filter.SelectedTenant) ? $scope.DataObject.Filter.SelectedTenant.TenantID : null,
                }).then(function (res) {
                    if (res && res.length > 0) {
                        toaster.warning("Shift/s mapped with this Shift Classification.")
                    }
                    else {
                        toaster.success("Classification Deleted Successfully.");
                        GetShiftClassification();
                    }
                }, function (err) {
                    toaster.error("Some Error Occurred!")
                });
            }
        }
        $scope.clearAddClassificationData = function () {
            $scope.DataObject.addEditClassification = {
                ShiftClassificationID: null,
                ShiftClassificationName: null,
                isSaveBtnDisabled: false,
            }
        }

        function GetShiftClassification() {
            var d = $q.defer();
            var params = {};
            if ($scope.DataObject.Filter.SelectedTenant) {
                params.tenantID = $scope.DataObject.Filter.SelectedTenant.TenantID;
            }
            ScheduleService.GetShiftClassification(params).then(function (res) {
                if (gridAPI) {
                    gridAPI.setRowData(_.uniqBy(res, "ShiftClassificationID"));
                    gridAPI.redrawRows();
                }
                d.resolve(res);
            }, function (err) {
                if (gridAPI) {
                    gridAPI.setRowData([]);
                }
                d.resolve([]);
            });
            return d.promise;
        }

        function applyDefaultTenant(list) {
            if (!list || list.length === 0) {
                return null;
            }
            if (list.length === 1) {
                return list[0];
            }
            return _.find(list, { IsDefault: true }) || null;
        }

        function GetTenantsByUserID() {
            ManageLocationService.GetTenantsByUserID({ UserID: $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.TenantList = result || [];
                $scope.DataObject.Filter.SelectedTenant = applyDefaultTenant($scope.TenantList);
                var gridDiv = document.getElementById("ShiftClassificationGrid");
                if (gridDiv) {
                    new agGrid.Grid(gridDiv, ShiftClassificationGridOptions);
                    gridAPI = ShiftClassificationGridOptions.api;
                }
                GetShiftClassification();
            });
        }

        $scope.OnTenantChanged = function () {
            GetShiftClassification();
        }

        $scope.SearchClassification = function () {
            if (gridAPI) {
                gridAPI.setQuickFilter($scope.DataObject.SearchText);
            }
        }
    }
})();
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('shiftConfigurationCmp', {
            templateUrl: 'app/theme/components/shift-schedule/shift-configuration-cmp/shift-configuration-cmp.html',
            bindings: {
            },
            controller: shiftConfigurationCmpCtrl
        });

    function shiftConfigurationCmpCtrl($scope, $q, $sessionStorage, $timeout, $compile, $filter, ScheduleService, toaster, ManageLocationService) {
        var vm = this;
        var PageSize = 50;
        var gridAPI = null;
        var ShiftConfigList = [];
        var statusBarComponent = null;
        var defaultShiftColor = "#025c4e";
        $scope.TenantList = [];
        $scope.DataObject = {
            ShiftConfigIDList: {},
            SearchAbbrev: null,
            SearchShiftName: null,
            ShiftClassificationList: [],
            WeekDaysList: [],
            Filter: {
                SelectedTenant: null,
            },

            multiSelectDropdown: {
                ShiftClassificationFilter: {
                    divId: "ShiftClassificationFilterShiftConfig",
                    keys: ['ShiftClassificationName'],
                    uniqKey: 'ShiftClassificationID',
                    placeHolder: "Select Classification",
                    SelectedValue: { list: [] },
                    tooltip: null,
                    onChange: function (selectedData) {
                        $scope.DataObject.multiSelectDropdown.ShiftClassificationFilter.tooltip = _.join(_.map(selectedData, function (classification) { return classification.ShiftClassificationName; }), '\n');
                    }
                },
            },
            addEditShiftConfig: {
                ShiftConfigID: null,
                ShiftAbbrev: null,
                ShiftName: null,
                StartTime: null,
                EndTime: null,
                LowAnomaly: null,
                HighAnomaly: null,
                DayShiftType: {},
                isSaveBtnDisabled: false,
                ShiftColorCode: defaultShiftColor
            }
        }
        vm.$onInit = function () {
            GetTenantsByUserID();
        }
        vm.$onDestroy = function () { }
        vm.$onChanges = function () { }

        function ActionButtonRenderer() {
            function CustomItems() {
            }
            CustomItems.prototype.init = function (params) {
                this.eGui = document.createElement('div');
                var shiftConfigId = parseInt(params.data.ShiftConfigID, 10);
                $scope.DataObject.ShiftConfigIDList[shiftConfigId] = params;
                var rowExpr = 'DataObject.ShiftConfigIDList[' + shiftConfigId + ']';
                var editIcon = document.createElement('i');
                editIcon.className = 'cursor-pointer glyphicon glyphicon-pencil p-4px-all';
                editIcon.title = 'Edit';
                editIcon.style.color = '#07e6c4';
                editIcon.setAttribute('ng-click', 'EditShiftConfig(' + rowExpr + ')');
                var deleteButton = document.createElement('button');
                deleteButton.className = 'btn btn-transparent border-0 px-0 pt-2px mx-2 my-0 pb-4px';
                deleteButton.title = 'Delete';
                deleteButton.style.color = '#07e6c4';
                deleteButton.setAttribute('ng-click', 'DeleteShiftConfig(' + rowExpr + ')');
                var deleteIcon = document.createElement('i');
                deleteIcon.className = 'fa fa-trash-o fs-17px';
                deleteButton.appendChild(deleteIcon);
                this.eGui.appendChild(editIcon);
                this.eGui.appendChild(deleteButton);

                var newScope = $scope.$new();
                $compile(this.eGui)(newScope);
                var timeout = $timeout(function () {
                    newScope.$apply.bind(newScope);
                    $timeout.cancel(timeout);
                    timeout = null;
                }, 0);

            }
            CustomItems.prototype.getGui = function () {
                return this.eGui;
            };
            CustomItems.prototype.destroy = function () {
            };
            return CustomItems;
        }

        var ShiftConfigColDef = [
            {
                field: "ShiftName",
                sortable: true,
                sort: 'asc'
            },
            { field: "StartTime" },
            { field: "EndTime" },
            {
                field: "LowAnomaly",
                sortable: true,
            },
            {
                field: "HighAnomaly",
                sortable: true,
            },
            {
                field: "Action",
                cellRenderer: ActionButtonRenderer(),
                initialWidth: 100,
                resizable: false,
            },
        ]

        var ShiftConfigGridOptions = {
            columnDefs: ShiftConfigColDef,
            defaultColDef: {
                flex: 1,
                minWidth: 120,
                resizable: true,
                sortable: false,
                lockVisible: true,
                menuTabs: [],
            },
            suppressMultiSort: true,
            sortingOrder: ['desc', 'asc'],
            rowModelType: 'serverSide',
            cacheBlockSize: PageSize,
            suppressContextMenu: true,
            overlayNoRowsTemplate: '<span class="ag-overlay-loading-center" style="font-size: 20px; border: 0px">No data available.</span>',
            localeText: { loadingError: 'Some error has occurred!' },
            getRowId: function (params) {
                return params.data.RowID;
            },
            onGridReady: function () {
                statusBarComponent = gridAPI.getStatusPanel('GridFooter');
                statusBarComponent.eGui.style.padding = '5px';
                statusBarComponent.eGui.style.margin = '5px';
                var datasource = createServerSideDatasource();
                gridAPI.setServerSideDatasource(datasource);
            },
            onSortChanged: function (params) {
                resetGrid();
            },
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: getStatusPanel(),
                        key: 'GridFooter',
                    },
                ],
            },
        }
        function getStatusPanel() {
            function CustomPanel() {
            }
            CustomPanel.prototype.init = function (params) {
                this.agParams = params;
                this.eGui = document.createElement('div');
            };
            CustomPanel.prototype.getGui = function () {
                return this.eGui;
            };
            CustomPanel.prototype.destroy = function () {
            };
            return CustomPanel;
        }
        function createServerSideDatasource() {
            return {
                getRows: function (params) {

                    var obj = {
                        ShiftName: $scope.DataObject.SearchShiftName
                    };

                    if (params.request.sortModel.length > 0) {
                        obj.OrderByField = params.request.sortModel[0].colId;
                        obj.OrderBy = params.request.sortModel[0].sort;
                    }
                    obj.PageNum = params.request.endRow / PageSize;
                    obj.PageSize = PageSize;

                    if ($scope.DataObject.multiSelectDropdown.ShiftClassificationFilter.SelectedValue &&
                        $scope.DataObject.multiSelectDropdown.ShiftClassificationFilter.SelectedValue.list) {
                        obj.ClassificationIDs = _.join(_.map($scope.DataObject.multiSelectDropdown.ShiftClassificationFilter.SelectedValue.list, function (obj) { return obj.ShiftClassificationID }), ',')
                    }

                    if ($scope.DataObject.Filter.SelectedTenant) {
                        obj.TenantID = $scope.DataObject.Filter.SelectedTenant.TenantID;
                    }

                    GetShiftConfigurations(obj).then(function (data) {
                        statusBarComponent.eGui.hidden = true;
                        if (ShiftConfigList.length == 0) {
                            gridAPI.showNoRowsOverlay();
                        } else {
                            gridAPI.hideOverlay();
                            statusBarComponent.eGui.hidden = false;
                            var TotalRows = parseInt(ShiftConfigList[0].PageCounts, 10) || 0;
                            var statusDiv = document.createElement('div');
                            statusDiv.style.color = 'white';
                            statusDiv.textContent = 'Showing ' + ShiftConfigList.length + ' of ' + TotalRows + ' Total Records';
                            statusBarComponent.eGui.innerHTML = '';
                            statusBarComponent.eGui.appendChild(statusDiv);
                        }
                        var rowsForBlock = ShiftConfigList.slice(params.request.startRow, params.request.endRow);
                        params.success({
                            rowData: rowsForBlock,
                            rowCount: undefined,
                        });
                    }, function (err) {
                        console.log("Error > ", err);
                        params.fail();
                    });
                },
            };
        }

        function GetShiftConfigurations(params) {
            var d = $q.defer();
            ScheduleService.GetShiftConfig(params).then(function (res) {
                res = ScheduleService.assignRowID(res);
                ShiftConfigList = _.uniqBy(_.concat(ShiftConfigList, res), "ShiftConfigID");
                d.resolve(res);
            }, function (err) {
                d.reject(err);
            });

            return d.promise;
        }
        $scope.SaveShiftConfigurations = function () {
            $scope.DataObject.addEditShiftConfig.isSaveBtnDisabled = true;
            var Flag = ($scope.DataObject.addEditShiftConfig.ShiftConfigID && $scope.DataObject.addEditShiftConfig.ShiftConfigID != -1) ? "M" : "N"
            var params = {
                ShiftConfigID: (Flag == "N") ? -1 : $scope.DataObject.addEditShiftConfig.ShiftConfigID,
                ShiftName: $scope.DataObject.addEditShiftConfig.ShiftName,
                ShiftAbbrev: $scope.DataObject.addEditShiftConfig.ShiftAbbrev,
                StartTime: ScheduleService.formatTime($scope.DataObject.addEditShiftConfig.StartTime),
                EndTime: ScheduleService.formatTime($scope.DataObject.addEditShiftConfig.EndTime),
                LowAnomaly: $scope.DataObject.addEditShiftConfig.LowAnomaly,
                HighAnomaly: $scope.DataObject.addEditShiftConfig.HighAnomaly,
                CreatedBy: $sessionStorage.currentUserData.userId,
                Flag: Flag,
                WeekMappingFlag: "N",
                ShiftColorCode: $scope.DataObject.addEditShiftConfig.ShiftColorCode,
                TenantID: ($scope.DataObject.Filter.SelectedTenant) ? $scope.DataObject.Filter.SelectedTenant.TenantID : null,
            }
            var ShiftConfigWeekMapping = [];
            _.each(Object.keys($scope.DataObject.addEditShiftConfig.DayShiftType), function (key) {
                if ($scope.DataObject.addEditShiftConfig.DayShiftType && $scope.DataObject.addEditShiftConfig.DayShiftType[key]) {
                    var obj = {
                        WeekID: key,
                        ShiftClassificaionID: $scope.DataObject.addEditShiftConfig.DayShiftType[key].ShiftClassificationID,
                    };
                    ShiftConfigWeekMapping.push(obj);
                }
            });
            params.ShiftConfigWeekMapping = ShiftConfigWeekMapping;
            if (ShiftConfigWeekMapping.length == 0) {
                params.WeekMappingFlag = "D";
            }

            ScheduleService.SetShiftConfig(params).then(function (res) {
                $scope.DataObject.addEditShiftConfig.isSaveBtnDisabled = false;
                if (res && res.length > 0) {
                    toaster.warning("Shift with the same name already exists.")
                }
                else {
                    (Flag == "N") ? toaster.success("Shift Configuration Saved Successfully.") : toaster.success("Shift Configuration Updated Successfully.");
                    angular.element("#ShiftChangeModal").modal('hide');
                    $scope.clearAddEditShiftConfigData();
                    resetGrid();
                }

            }, function (err) {
                $scope.DataObject.addEditShiftConfig.isSaveBtnDisabled = false;
                toaster.error("Some Error Occurred!");
            });
        }

        $scope.clearAddEditShiftConfigData = function () {
            $scope.DataObject.addEditShiftConfig = {
                ShiftConfigID: null,
                ShiftAbbrev: null,
                ShiftName: null,
                StartTime: null,
                EndTime: null,
                LowAnomaly: null,
                HighAnomaly: null,
                DayShiftType: {},
                isSaveBtnDisabled: false,
                ShiftColorCode: defaultShiftColor
            }
        }

        function GetShiftClassification() {
            var d = $q.defer();
            var params = {};
            if ($scope.DataObject.Filter.SelectedTenant) {
                params.tenantID = $scope.DataObject.Filter.SelectedTenant.TenantID;
            }
            ScheduleService.GetShiftClassification(params).then(function (res) {
                if (res && res.length > 0) {
                    $scope.DataObject.ShiftClassificationList = _.sortBy(res, 'ShiftClassificationName');
                }
                d.resolve(res);
            }, function (err) {
                d.resolve([]);
            });
            return d.promise;
        }
        function GetWeekDays() {
            var d = $q.defer();
            ScheduleService.GetWeekDays().then(function (res) {
                $scope.DataObject.WeekDaysList = res;
                d.resolve(res);
            }, function (err) {
                d.resolve([]);
            });
            return d.promise;
        }

        $scope.EditShiftConfig = function (row) {
            if (row.node && row.data && row.data.ShiftConfigID) {
                row.node.setSelected(true);
                if (row.data) {
                    $scope.DataObject.addEditShiftConfig = {
                        ShiftConfigID: row.data.ShiftConfigID,
                        ShiftAbbrev: row.data.ShiftAbbrev,
                        ShiftName: row.data.ShiftName,
                        StartTime: (row.data.StartTime) ? new Date(1970, 0, 1, row.data.StartTime.split(':')[0], row.data.StartTime.split(':')[1], 0) : null,
                        EndTime: (row.data.EndTime) ? new Date(1970, 0, 1, row.data.EndTime.split(':')[0], row.data.EndTime.split(':')[1], 0) : null,
                        LowAnomaly: row.data.LowAnomaly,
                        HighAnomaly: row.data.HighAnomaly,
                        DayShiftType: {},
                        ShiftColorCode: (row.data.ShiftColorCode) ? row.data.ShiftColorCode : defaultShiftColor,
                    }
                    _.each($scope.DataObject.WeekDaysList, function (day) {
                        if (row.data[day.WeekDays]) {
                            var shiftClassification = _.find($scope.DataObject.ShiftClassificationList, { ShiftClassificationName: row.data[day.WeekDays] });
                            if (shiftClassification) {
                                $scope.DataObject.addEditShiftConfig.DayShiftType[day.WeekID] = shiftClassification;
                            }
                        }
                    })
                }
                angular.element("#ShiftChangeModal").modal('show');
            }
        }
        $scope.DeleteShiftConfig = function (row) {
            if (row.node && row.data && row.data.ShiftConfigID) {
                row.node.setSelected(true);
                ScheduleService.DeleteShiftConfig({
                    ShiftConfigID: row.data.ShiftConfigID,
                    CreatedBy: $sessionStorage.currentUserData.userId,
                    TenantID: ($scope.DataObject.Filter.SelectedTenant) ? $scope.DataObject.Filter.SelectedTenant.TenantID : null,
                }).then(function (res) {
                    if (res && res.length > 0) {
                        toaster.warning("Shift is mapped to a schedule.")
                    }
                    else {
                        gridAPI.applyServerSideTransaction({ remove: [{ RowID: (row.data.RowID).toString() }] });
                        toaster.success("Shift Configuration Deleted Successfully.");
                        _.remove(ShiftConfigList, { ShiftConfigID: row.data.ShiftConfigID });
                        if (ShiftConfigList.length == 0) {
                            gridAPI.showNoRowsOverlay();
                        }
                        else {
                            gridAPI.hideOverlay();
                        }
                    }
                })
            }
        }

        function resetGrid() {
            ShiftConfigList = [];
            if (gridAPI) {
                gridAPI.refreshServerSide({ purge: true });
            }
        }
        $scope.SearchShiftConfig = function () {
            resetGrid();
        }


        $scope.ClearSearch = function () {
            $scope.DataObject.SearchShiftName = null;
            $scope.DataObject.multiSelectDropdown.ShiftClassificationFilter.SelectedValue = { list: [] };
            resetGrid();
        }

        function applyDefaultTenant(list) {
            if (!list || list.length === 0) {
                return null;
            }
            if (list.length === 1) {
                return list[0];
            }
            return _.find(list, { IsDefault: true }) || null;
        }

        function GetTenantsByUserID() {
            ManageLocationService.GetTenantsByUserID({ UserID: $sessionStorage.currentUserData.userId }).then(function (result) {
                $scope.TenantList = result || [];
                $scope.DataObject.Filter.SelectedTenant = applyDefaultTenant($scope.TenantList);
                $q.all([
                    GetShiftClassification(),
                    GetWeekDays()
                ]).then(function () {
                    var gridDiv = document.querySelector('#SiteConfigGrid');
                    if (gridDiv) {
                        new agGrid.Grid(gridDiv, ShiftConfigGridOptions);
                        gridAPI = ShiftConfigGridOptions.api;
                    }
                });
            });
        }

        $scope.OnTenantChanged = function () {
            $scope.clearAddEditShiftConfigData();
            $scope.DataObject.multiSelectDropdown.ShiftClassificationFilter.SelectedValue = { list: [] };
            GetShiftClassification().then(function () {
                resetGrid();
            });
        }
    }
})();
(function () {

    'use strict';

    angular.module('BlurAdmin.theme.components')
        .component('userScheduleCmp', {
            templateUrl: 'app/theme/components/shift-schedule/user-schedule-cmp/user-schedule-cmp.html',
            bindings: {
            },
            controller: userScheduleCmpCtrl
        });
    
    function userScheduleCmpCtrl($scope) {
        var vm = this;

        vm.$onInit = function () { }
        vm.$onDestroy = function () { }
        vm.$onChanges = function () { }

        $scope.DataObject = {
            SelectedData: {
                Status: { key: 'RP' },
                Worklist: "PSW",
                ChooseNextStudy: false,
                ShowLockStudy: true,
                modalitytooltip: 'Select Modalities',
                toolTipOrderDate: 'DOS',
                locationIDs: '',
                OrderDateType: 'Last 7 Days',
                OrderDate: {
                    startDate: moment().subtract(6, 'days'),
                    endDate: moment()
                },
                DefaultDictationSystem: "",
                QuickSearch: {
                    Status: { key: 'AL' },
                    OrderDate: {
                        startDate: null,
                        endDate: null
                    },
                    OrderDateType: 'Today',
                },
                DeficientWarningOnWorklist: false,
                //LoggedInUserID: $sessionStorage.currentUserData.userId,
                //userRole: $sessionStorage.currentUserData.roles,
                //userRoles: $sessionStorage.currentUserData.userRoles,
                WorklistFontSize: null,
                WorklistColorCode: {},
                SelectedLocations: {
                    Ids: '',
                    locations: [],
                    divId: "NewWorklistFilter"
                },
                OrderIDRemovedFromClipboard: false,
                Modality: [],
            },
        }

        $scope.MultiSelectDropdown = {
            ScheduleFilterPhysician: {
                divId: "ScheduleFilterPhysician",
                keys: ['LastName', 'FirstName'],
                uniqKey: 'Id',
                placeHolder: "Select Physician",
                SelectedValue: { list: [] },
                onChange: function (selectedData) {
                    $scope.SelectedProvider.obj = selectedData;
                },
            },
            ScheduleFilterShift: {
                divId: "ScheduleFilterShift",
                keys: ['', ''],
                uniqKey: 'Id',
                placeHolder: "Select Shift",
                SelectedValue: { list: [] },
                onChange: function (selectedData) {
                    $scope.SelectedProvider.obj = selectedData;
                },
            }
        }
        $scope.showScheduleModal = function () {
            angular.element('#ScheduleModal').modal('show');
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("radico.pages.questionnaire.shared")
    .component("questionnaireFormControl", {
      templateUrl: "app/pages/questionnaire/components/shared/questionnaire-form-control/questionnaire-form-control.html",
      bindings: {
        question: "<",
        answerChange: "&",
      },
      controller: ComponentController,
    });
  /** @ngInject */
  function ComponentController(
    $scope,
    questionnaireCommonService,
    commonService
  ) {
    var vm = this;

    vm.dateOptions = {
      formatYear: 'yyyy',
      startingDay: 1,
      // minDate: new Date(),
    };
    var vm = this;
    vm.dateSearchOptions = {
      formatYear: 'yyyy',
      startingDay: 1,
    };

    vm.$onInit = function () {
      initComponent();
    };
    function initComponent() {
      initDefaultOptions();
      initData();
    }
    function initDefaultOptions() {
      questionnaireCommonService.buildModelAnswerValue(vm.question);
    }

    function initData() { }
  }
})();

angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/addressbook/addressbook.html','<style>\r\n    .input-group-addon, .input-group-btn {\r\n        width: auto !important;\r\n    }\r\n\r\n    .ui-autocomplete {\r\n        max-height: 400px !important;\r\n    }\r\n\r\n    .ui-menu.ui-widget.ui-widget-content {\r\n    width: 230px;\r\n}\r\n\r\n    .ui-menu.ui-widget.ui-widget-content.ui-autocomplete.ui-front .ui-menu-item:hover{\r\n        background-color: #4e4c4c!important;\r\n    }\r\n\r\n    .ui-menu .ui-menu-item {\r\n        position: relative;\r\n        margin: 0;\r\n        padding: 3px 1em 3px .4em;\r\n        cursor: pointer;\r\n        min-height: 0;\r\n        font-size: 14px;\r\n    }\r\n\r\n    .ui-menu {\r\n        list-style: none;\r\n        padding: 0;\r\n        margin: 0;\r\n        outline: none;\r\n        background-color: #262526 !important;\r\n        border: 1px solid #a2a1a1 !important;\r\n    }\r\n    .ui-widget.ui-widget-content {\r\n        border: 1px solid #a2a1a1 !important;\r\n    }\r\n</style><div ng-controller="appAddressBookController as appCtrl" ng-init="appCtr.initPage()" class="chat-wrapper w-100 h-100 pos-rel bg-clr-25"><div ng-show="appCtrl.isLoading" class="spinner-overlay" style="z-index: 80;"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class=""><div class="radf-header"><h2 class="w-50 float-left"><span>Address Book</span> <span class="fs-12px txt-clr-2">(My Contact List)</span></h2><div class="w-70 float-left text-right pt-3px pr-15px"><div class="float-right mb-0 px-2 pt-10px" ng-if="appCtrl.isImport"><div class="float-right"><div class="col-lg-7"><input class="cursor-pointer" type="file" id="file" name="file" onchange="angular.element(this).scope().getFileDetails(this)" accept=".csv"></div><div class="col-lg-5"><button type="button" class="btn btn-primary border-0 mx-5px" ng-click="appCtrl.Import()">Import</button> <button class="btn btn-primary mx-5px" type="button" ng-click="appCtrl.hideFileUploader()">Cancel</button></div></div><div class="clearfix"></div></div></div><div class="clearfix"></div></div><div class=""><div ng-if="!appCtrl.isImport"><div class="row rf-filter-ui m-0 pt-8px filterspace"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr" tooltip-class="uibtooltipDenial" uib-tooltip="First Name" tooltip-placement="auto top"><input id="firstName" class="blk-input form-control col-placeholder" placeholder="First Name" ng-model="appCtrl.firstName"></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr mob-pr-0" tooltip-class="uibtooltipDenial" uib-tooltip="Last Name" tooltip-placement="auto top"><input id="lastName" class="blk-input form-control col-placeholder" placeholder="Last Name" ng-model="appCtrl.lastName"></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 pd-lr mob-pr-0" tooltip-class="uibtooltipDenial" uib-tooltip="Location" tooltip-placement="auto top"><input id="location" class="blk-input form-control col-placeholder" placeholder="Location" ng-model="appCtrl.location"></div><div class="col-lg-6 col-md-6 col-sm-4 col-xs-12 pd-lr mob-pr-0"><button type="button" class="btn btn-primary border-0 rf-btn-sm mr-4px" ng-click="appCtrl.search()">Filter</button> <button type="button" class="btn btn-default rf-btn-sm" ng-click="appCtrl.clearFilter()">Clear</button> <button class="btn btn-primary rf-btn-sm pull-right" data-toggle="modal" data-target="#ContactModal" type="button" ng-click="appCtrl.OpenContactModal()">Add New Contact</button></div></div><div class="clearfix"></div></div></div><div class="clearfix"></div><div class="common-tbl"><table ng-table="appCtrl.tableParams" class="w-100"><tbody class=""><tr ng-repeat="list in $data" class="abookrw-2"><td sortable="\'FirstName\'" data-title="\'First Name\'" class="text-left text-truncate"><span class="" tooltip-class="uibtooltipDenial" uib-tooltip="{{list.FirstName}}" tooltip-placement="auto right">{{list.FirstName}}</span></td><td sortable="\'LastName\'" data-title="\'Last Name\'" class="text-truncate"><span class="" tooltip-class="uibtooltipDenial" uib-tooltip="{{list.LastName}}" tooltip-placement="auto right">{{list.LastName}}</span></td><td sortable="\'PrimaryLocation\'" data-title="\'Primary Location\'" class="text-truncate"><span class="" tooltip-class="uibtooltipDenial" uib-tooltip="{{list.PrimaryLocation}}" tooltip-placement="auto right">{{list.PrimaryLocation}}</span></td><td data-title="\'Office\'"><div ng-repeat="p in appCtrl.spiltPhoneNumber(list.Office)" class="">{{p | tel}}</div></td><td data-title="\'Mobile\'"><div ng-repeat="p in appCtrl.spiltPhoneNumber(list.Mobile)">{{p | tel}}</div></td><td data-title="\'Email\'" class="text-breakall"><span class="fs-13px fw-500">{{list.EmailId}}</span></td><td data-title="\'\'" class="text-center"><span class="txt-clr-14" ng-show="list.IsPrivate" tooltip-class="uibtooltipDenial" uib-tooltip="Private" tooltip-placement="auto top"><i class="fa fa-lock fs-18px"></i></span> <span class="txt-clr-14" ng-show="!list.IsPrivate" tooltip-class="uibtooltipDenial" uib-tooltip="Public" tooltip-placement="auto top"><i class="fa fa-unlock fs-18px"></i></span></td><td data-title="\'\'"><div class="w-30px text-right"><span class="" ng-show="list.Userinfo"><button type="button" class="btn btn-secondary no-bg txt-clr-14 p-0 mr-3 input-icon-delete" ng-click="appCtrl.showUserContactInfo(list.Userinfo)" tooltip-class="uibtooltipDenial" uib-tooltip="Internal Contact" tooltip-placement="auto top"><i class="fa fa-info fs-18px"></i></button></span> <span class="" ng-hide="list.Userinfo"><button type="button" class="btn btn-secondary no-bg txt-clr-14 p-0 mr-3 input-icon-delete" disabled="" tooltip-class="uibtooltipDenial" uib-tooltip="External Contact" tooltip-placement="auto top"><i class="fa fa-info fs-18px"></i></button></span></div></td><td><div class="mb-0 w-150px"><span ng-show="list.CreatedBy== appCtrl.UserId || appCtrl.Permission"><button type="button" class="btn btn-secondary no-bg txt-clr-14 p-0 mr-10px" ng-click="appCtrl.EditContact(list.Id)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit" tooltip-placement="auto top"><i class="fa fa-edit fs-16px"></i></button></span> <span ng-show="list.CreatedBy== appCtrl.UserId || appCtrl.Permission"><button type="button" class="btn btn-secondary no-bg txt-clr-14 input-icon-delete sm-pr-0-i p-0 mr-10px" ng-click="appCtrl.DeleteContact(list.Id)" tooltip-class="uibtooltipDenial" uib-tooltip="Delete" tooltip-placement="auto top"><i class="fa fa-trash fs-16px"></i></button></span> <button type="button" ng-if="false || list.Phones[1].Phone" class="btn btn-secondary no-bg txt-clr-14 p-0 mr-2" ng-hide="list.Userinfo" ng-click="invite(list)" aria-hidden="false" tooltip-class="uibtooltipDenial" uib-tooltip="Invite User" tooltip-placement="right"><i class="fa fa-reply-all fs-14px"></i></button></div></td></tr></tbody></table><div class="text-center py-10px pos-abs centersec abs-t-45"><span ng-hide="appCtrl.AddressBookContactList.length>0"><span class="rf-alert-text">No Record Found</span></span></div></div><div class=""><div class=""><div class="common-footer mob-footer d-flex justify-content-between"><div class="flex-grow-1 pl-8px mob-w-100"><div data-ng-show="appCtrl.filteredCount < appCtrl.totalRecords"><select id="ddlPageSize" class="sing-select form-control mt-10px float-left downArrow-ie w-auto" ng-model="appCtrl.pageSize" ng-change="appCtrl.changePageSize();"><option value="25" ng-selected="appCtrl.pageSize === 25">25</option><option value="50" ng-selected="appCtrl.pageSize === 50">50</option><option value="100" ng-selected="appCtrl.pageSize === 100">100</option><option value="150" ng-selected="appCtrl.pageSize === 150">150</option><option value="200" ng-selected="appCtrl.pageSize === 200">200</option></select></div><div data-ng-show="appCtrl.filteredCount < appCtrl.totalRecords" class="float-left"><ul uib-pagination="" total-items="appCtrl.totalRecords" items-per-page="appCtrl.pageSize" ng-model="appCtrl.currentPage" max-size="5" class="roundedpagin" boundary-link-numbers="true" ng-click="appCtrl.pageChanged(page)" rotate="false"></ul></div></div><div data-ng-show="appCtrl.filteredCount > 0" class="d-table h-50px px-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m pl-10px">Showing <span>{{ appCtrl.filteredCount }} of {{ appCtrl.totalRecords}}</span> Total Contacts</h5></div><div class="clearfix"></div></div></div></div></div><div class="modal fade" id="ContactModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog w-50" role="document"><div class="modal-content"><div class="new-popup"><form name="frmContact" class="width-inherit height-inherit" ng-submit="appCtrl.SaveContact(frmContact.$valid)"><div class="modal-header d-flex align-item-center"><h4 class="modal-title">{{appCtrl.SelectedAddressbookinfo.Id > 0 ? \'Edit Contact\' : \'Add New Contact\'}}</h4><button type="button" class="close otln-0 cursor-pointer fs-inherit" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-close fs-16px"></i></span></button></div><div class="modal-body p-0 pos-rel"><h5 class="fs-16px fw-500 txt-clr-1 text-left my-4 px-15px" ng-if="!appCtrl.SelectedAddressbookinfo.Id > 0">Add <span class="txt-clr-14">Name</span>, <span class="txt-clr-14">Phone Number</span> &amp; <span class="txt-clr-1">Email Id</span> in Address Book</h5><h5 class="fs-16px fw-500 txt-clr-1 text-left my-4 px-15px" ng-if="appCtrl.SelectedAddressbookinfo.Id > 0">Update Contact <span class="txt-clr-14">Name</span>, <span class="txt-clr-14">Phone Number</span> &amp; <span class="txt-clr-1">Email Id</span> in Address Book</h5><div class="row mx-0"><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group py-2 w-100 px-0 pos-rel"><div class="group-register" ng-class="{\'has-success\' : frmContact.FirstName.$valid,\'has-danger\' : frmContact.FirstName.$invalid }"><label class="rf-label">First Name *</label> <input class="blk-input form-control form-border" ng-model="appCtrl.SelectedAddressbookinfo.FirstName" name="FirstName" maxlength="50" type="text" placeholder="First Name" required="" ng-keyup="appCtrl.RemoveExtraSpace()"></div></div><div class="form-group py-2 w-100 px-0 pos-rel"><div class="group-register" ng-class="{\'has-success\' : frmContact.LastName.$valid,\'has-danger\' : frmContact.LastName.$invalid }"><label class="rf-label">Last Name *</label> <input class="blk-input form-control form-border" ng-model="appCtrl.SelectedAddressbookinfo.LastName" name="LastName" maxlength="50" type="text" placeholder="Last Name" required="" ng-keyup="appCtrl.RemoveExtraSpace()"></div></div><div class="form-group py-2 w-100 px-0 pos-rel"><div class="group-register" ng-class="{\'has-success\' : frmContact.PrimaryLocation.$valid,\'has-danger\' : frmContact.PrimaryLocation.$invalid }"><label class="rf-label">Primary Location</label> <input class="blk-input form-control form-border" ng-model="appCtrl.SelectedAddressbookinfo.PrimaryLocation" name="PrimaryLocation" maxlength="50" type="text" placeholder="Primary Location" ng-keyup="appCtrl.RemoveExtraSpace()"></div></div></div><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group py-2 w-100 px-0 pos-rel" ng-repeat="phone in appCtrl.SelectedAddressbookinfo.Phones"><div class="group-register" ng-class="{\'has-success\' : frmContact.{{\'Phone\'+($index+1)}}.$valid,\'has-danger\' : frmContact.{{\'Phone\'+($index+1)}}.$invalid }"><label class="rf-label">{{phone.PhoneTypeId == 1 ? \'Office\' : \'Mobile\'}}</label><input type="text" class="blk-input form-border form-control" id="Phone" ui-mask="(999) 999-9999" maxlength="15" ng-model="phone.Phone" autocomplete="off"></div></div><div class="form-group py-2 w-100 px-0 pos-rel" ng-repeat="email in appCtrl.SelectedAddressbookinfo.Emails"><div class="group-register" ng-class="{\'has-success\' : frmContact.{{\'emailId\'+($index+1)}}.$valid,\'has-danger\' : frmContact.{{\'emailId\'+($index+1)}}.$invalid }"><label class="rf-label">Email</label> <input class="blk-input form-control form-border" ng-model="email.EmailId" name="emailId{{$index+1}}" maxlength="50" placeholder="Email Id" validate-email="" type="email"></div></div></div></div><div class="row mx-0"><div class="form-group py-2 w-100 px-0 pos-rel"><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="adrBkPrivate" ng-model="appCtrl.SelectedAddressbookinfo.IsPrivate"> <label for="adrBkPrivate" class="rf-label cmn-check-label">Private</label></div></div></div></div></div><div class="modal-footer border-0" style="background-color: #3A393A !important;"><button type="submit" class="btn btn-primary">Save</button></div></form></div></div></div></div><div class="modal fade new-popup" id="UserInfoModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog w-750px" role="document"><div class="modal-content"><div class="new-popup"><form><div class="modal-header"><button type="button" class="close cursor-pointer" data-dismiss="modal" aria-label="Close">&times;</button><h4 class="modal-title">User Information</h4></div><div class="modal-body px-0"><div class="row fw-500 m-0"><div class="col-sm-4 col-md-4 col-lg-4"><div class="mb-15px"><div class="fs-14px mb-0 txt-clr-1 d-inline">NPI :</div><div class="fs-14px mb-0 txt-clr-15 d-inline">{{appCtrl.selectedUserInfo.NPI}}</div></div></div><div class="col-sm-4 col-md-4 col-lg-4"><div class="mb-15px"><div class="fs-14px mb-0 txt-clr-1 d-inline">First Name :</div><div class="fs-14px mb-0 txt-clr-15 d-inline">{{appCtrl.selectedUserInfo.FirstName}}</div></div></div><div class="col-sm-4 col-md-4 col-lg-4"><div class="mb-15px"><div class="fs-14px mb-0 txt-clr-1 d-inline">Last Name :</div><div class="fs-14px mb-0 txt-clr-15 d-inline">{{appCtrl.selectedUserInfo.LastName}}</div></div></div></div><div class="row fw-500 m-0"><div class="col-sm-4 col-md-4 col-lg-4"><div class="mb-15px"><div class="fs-14px mb-0 txt-clr-1 d-inline">Email :</div><div class="fs-14px mb-0 txt-clr-15 d-inline">{{appCtrl.selectedUserInfo.EmailId}}</div></div></div><div class="col-sm-4 col-md-4 col-lg-4"><div class="mb-15px"><div class="fs-14px mb-0 txt-clr-1 d-inline">Phone Number :</div><div class="fs-14px mb-0 txt-clr-15 d-inline">{{appCtrl.selectedUserInfo.PhoneNumber}}</div></div></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/analytics/analytics.html','<div class="radf-header bg-clr-32" keyboard="keys"><h2>Analytics</h2></div><div class="pportal-list"><div class="mail-messages-control side-message-navigation-item p-0 collapse in" id="collapseWorklist" role="tabpanel" aria-labelledby="heading_worklist"><div id="tableauVizDiv" ng-bind-html="ReportHtml"></div></div></div>');
$templateCache.put('app/pages/auth/login.html','<style>\r\n    /*input[type="checkbox"] {\r\n        -webkit-appearance: checkbox;\r\n        -moz-appearance: checkbox;\r\n        appearance: checkbox;\r\n        display: inline-block !important;\r\n        width: 30px !important;\r\n        margin: 0px !important;\r\n    }*/\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n    label {\r\n        color: white;\r\n        line-height: 11px !important;\r\n    }\r\n\r\n    /*.login-page .form input.loginputbtn {*/\r\n    /*border-radius: 50px !important;\r\n        border-color: #c1bfbf !important;\r\n        color: #c1bfbf !important;\r\n        text-align: center !important;\r\n        font-weight: 600 !important;*/\r\n    /*text-align:center;\r\n        font-size: 14px !important;\r\n        padding: 16px !important;*/\r\n    /*}*/\r\n\r\n    .login-page .form-control-n:focus {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .update-card-overlay {\r\n        width: 100%;\r\n        height: 100%;\r\n        background: rgba(0, 0, 0, 0.49);\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        z-index: 9;\r\n    }\r\n\r\n    .update-required-card {\r\n        box-shadow: 0px 5px 10px black;\r\n        background: #343334 !important;\r\n        border-radius: 10px;\r\n        width: 500px;\r\n        padding: 20px;\r\n        position: absolute;\r\n        top: 26%;\r\n        left: 35%;\r\n        z-index: 99;\r\n        color: white;\r\n    }\r\n\r\n    .login-page .form-control .form-control {\r\n        border-bottom: 0 !important;\r\n        height: 32px;\r\n    }\r\n\r\n        .login-page .form-control .form-control.btn-default:focus {\r\n            box-shadow: none !important;\r\n        }\r\n\r\n        .login-page .form-control .form-control.btn-default:hover {\r\n            background-color: transparent !important;\r\n        }\r\n\r\n    .logo-section-reg {\r\n        /*height:800px !important;*/\r\n        height: 880px !important;\r\n    }\r\n\r\n    .section-registration.login-page {\r\n        width: 75%;\r\n    }\r\n\r\n        .section-registration.login-page .login-form {\r\n            width: 600px;\r\n        }\r\n\r\n    .login-page.section-registration .logo-section img {\r\n        margin-right: 170px;\r\n    }\r\n    .login-page.login-page-awarenessimg.section-registration .logo-section img {\r\n        margin-right: auto;\r\n    }\r\n    .login-page.login-page-awarenessimg {\r\n        width:75%;\r\n    }\r\n    .login-page.login-page-awarenessimg .logo-section img.radflow-logo-login {\r\n        padding-bottom: 300px;\r\n        right:75px;\r\n    }\r\n    /* 92% (was 100%) so the fixed banner stops short of the logo column right-hand divider line. */\r\n    .login-page.login-page-awarenessimg .logo-section img.awareness-img-login {\r\n        position: unset;\r\n        width: 92%;\r\n        max-width: 100%;\r\n        margin-top: 40px;\r\n    }\r\n    .login-page.login-page-awarenessimg .logo-section .left-logo-block.d-table {\r\n        display: flex !important;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n    .readcons-content {\r\n        max-height: 500px;\r\n    }\r\n    /* signature canvas \u2014 positioned by JS inside PDF container */\r\n    #cocSignatureCanvas {\r\n        cursor: crosshair !important;\r\n        border-radius: 2px !important;\r\n    }\r\n    .coc-step2-inner {\r\n        max-width: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        flex: 1;\r\n        min-height: 0;\r\n    }\r\n    #cocPdfScrollContainer {\r\n        height: 490px; /* fallback for non-step2-mode */\r\n        flex: 1;\r\n        min-height: 200px;\r\n    }\r\n    .coc-step2-inner .elemterms-of-cons-ftr {\r\n        position: relative !important;\r\n        bottom: auto !important;\r\n        width: 100% !important;\r\n    }\r\n    /* Step 1 inside coc-step2-mode: fill flex height with scrollable content + pinned footer */\r\n    .elemterms-of-cons.coc-step2-mode > .coc-step-panel {\r\n        flex: 1;\r\n        display: flex;\r\n        flex-direction: column;\r\n        min-height: 0;\r\n    }\r\n    .elemterms-of-cons.coc-step2-mode > .coc-step-panel .readcons-content {\r\n        flex: 1;\r\n        min-height: 0;\r\n        max-height: none !important;\r\n        overflow-y: auto;\r\n    }\r\n    .elemterms-of-cons.coc-step2-mode > .coc-step-panel .elemterms-of-cons-ftr {\r\n        position: relative !important;\r\n        bottom: auto !important;\r\n        width: 100% !important;\r\n        flex-shrink: 0;\r\n    }\r\n    /* Suppress ngAnimate transitions on CoC step panels to prevent flicker during step switch */\r\n    .coc-step-panel.ng-hide-add,\r\n    .coc-step-panel.ng-hide-remove {\r\n        transition: none !important;\r\n        animation: none !important;\r\n    }\r\n    /* Step 2: fill available viewport height with flex layout */\r\n    .elemterms-of-cons.coc-step2-mode {\r\n        height: calc(100vh - 100px);\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n    .coc-step2-body {\r\n        flex: 1;\r\n        display: flex;\r\n        flex-direction: column;\r\n        min-height: 0;\r\n    }\r\n    .elemterms-of-cons.coc-step2-mode #cocPdfScrollContainer {\r\n        height: auto !important;\r\n    }\r\n    /* Scroll-to-signature hint banner */\r\n    .coc-sig-hint {\r\n        display: flex;\r\n        align-items: center;\r\n        flex-wrap: wrap;\r\n        gap: 4px;\r\n        background: rgba(26, 26, 255, 0.12);\r\n        border: 1px solid rgba(26, 26, 255, 0.35);\r\n        border-radius: 4px;\r\n        padding: 6px 10px;\r\n        margin-top: 6px;\r\n        font-size: 12px;\r\n        color: #c8d0ff;\r\n    }\r\n    /* Step 2 info/action bar \u2014 visually anchored at the bottom */\r\n    .coc-step2-footer {\r\n        flex-shrink: 0;\r\n        border-top: 1px solid #555;\r\n        padding-top: 8px;\r\n    }\r\n    .readcons-content p {\r\n       line-height: 22px;\r\n    }\r\n/* step-2 flex row \u2014 overrides Bootstrap float columns so the two panels stay side-by-side */\r\n    .form.row.coc-step2-row {\r\n        display: flex !important;\r\n        flex-wrap: nowrap !important;\r\n        align-items: stretch;\r\n        margin-left: 0 !important;\r\n        margin-right: 0 !important;\r\n        overflow: hidden;\r\n    }\r\n    .form.row.coc-step2-row .logo-section {\r\n        flex: 0 0 50% !important;\r\n        max-width: 50% !important;\r\n        width: 50% !important;\r\n        float: none !important;\r\n    }\r\n    .form.row.coc-step2-row > .coc-content-col {\r\n        flex: 1 1 auto !important;\r\n        max-width: 50% !important;\r\n        width: 50% !important;\r\n        float: none !important;\r\n        display: block !important;\r\n    }\r\n    @media (max-width: 991px) {\r\n        .form.row.coc-step2-row .logo-section {\r\n            flex: 0 0 41.67% !important;\r\n            max-width: 41.67% !important;\r\n            width: 41.67% !important;\r\n        }\r\n        .form.row.coc-step2-row > .coc-content-col {\r\n            max-width: 58.33% !important;\r\n            width: 58.33% !important;\r\n        }\r\n    }\r\n    /* Match Sign Up container width so Step 2 has same visual weight */\r\n    .auth-block.coc-step2-active {\r\n        width: 75% !important;\r\n    }\r\n    .elemterms-of-cons {\r\n        height: 650px;\r\n        vertical-align: top;\r\n    }\r\n    .elemterms-of-cons-ftr {\r\n        position:absolute;\r\n        bottom: 0;\r\n        width:100%;\r\n    }\r\n    /* css for terms of use sample content start*/\r\n    .readcons-content h1,\r\n    .readcons-content h2 {\r\n        font-weight: 600;\r\n        font-size: 16px;\r\n        margin-bottom: 5px;\r\n        color: #e4e4e4 !important;\r\n    }\r\n    .readcons-content p {\r\n        font-size: 14px;\r\n        margin-left:20px;\r\n    }\r\n    .readcons-content > h1 + p {\r\n        margin-left: 0;\r\n    }\r\n    .readcons-content p,\r\n    .readcons-content h1,\r\n    .readcons-content h2,\r\n    .readcons-content ul li {\r\n        text-align: left;\r\n    }\r\n    .readcons-content a {\r\n       color: #fff !important\r\n    }\r\n    .readcons-content body {\r\n        margin: 0 !important;\r\n    }\r\n    /* css for terms of use sample content end*/\r\n    @media screen and (min-width: 767px) and (max-width: 1200px) {\r\n        .section-registration.login-page {\r\n            width: 100%;\r\n        }\r\n\r\n            .section-registration.login-page .login-form {\r\n                width: 500px;\r\n            }\r\n\r\n        .login-page.section-registration .logo-section img {\r\n            margin-right: auto;\r\n        }\r\n        .login-page.login-page-awarenessimg {\r\n            width: 100%;\r\n        }\r\n        .login-page.login-page-awarenessimg .logo-section img.awareness-img-login {\r\n            width: 84%;\r\n            margin-top: 30px;\r\n        }\r\n        .login-page.login-page-awarenessimg.section-registration .logo-section img.awareness-img-login {\r\n            width: 88%;\r\n        }\r\n        .login-page.login-page-awarenessimg .fpscreens {\r\n            padding: 28% 4% 0 4% !important;\r\n        }\r\n        .login-page.login-page-awarenessimg .elemterms-of-cons.fpscreens {\r\n            padding: 4% 0% 0 0% !important;\r\n        }\r\n        .readcons-content {\r\n            max-height: 530px;\r\n        }\r\n    }\r\n\r\n    @media screen and (min-width: 320px) and (max-width: 767px) {\r\n        body.mobile {\r\n            overflow: auto !important;\r\n            -webkit-overflow-scrolling: auto;\r\n        }\r\n\r\n            body.mobile .login-outer {\r\n                align-items: unset;\r\n                height: 100%;\r\n                -webkit-overflow-scrolling: auto;\r\n            }\r\n\r\n        .login-page .form {\r\n            padding: 20px !important;\r\n        }\r\n\r\n        .login-page .login-form {\r\n            width: 100% !important;\r\n            padding-top: 10px;\r\n        }\r\n\r\n        .login-page .logo-section img {\r\n            width: 25%;\r\n        }\r\n\r\n        .left-logo-block {\r\n            padding-bottom: 20px;\r\n        }\r\n\r\n        .login-form.form-horizontal.reg-sm-margin .mb-25px {\r\n            margin-bottom: 14px !important;\r\n        }\r\n\r\n        .login-form.form-horizontal .form-group {\r\n            margin-bottom: 0 !important;\r\n        }\r\n\r\n        .sm-btn-height {\r\n            padding: 8px 14px !important;\r\n        }\r\n\r\n        .sm-position {\r\n            position: unset !important;\r\n        }\r\n    }\r\n\r\n    @media screen and (max-height: 450px) {\r\n        .login-outer {\r\n            align-items: unset;\r\n        }\r\n    }\r\n    @media (min-width: 768px) and (min-height: 1080px) and (orientation: portrait) {\r\n        .login-page.login-page-awarenessimg .logo-section img.radflow-logo-login {\r\n            padding-bottom: 230px;\r\n            /* padding-bottom: 260px; ribbon added css*/\r\n        }\r\n\r\n        .login-page.login-page-awarenessimg .fpscreens {\r\n            padding: 2% 4% 0 4% !important;\r\n        }\r\n    .elemterms-of-cons {\r\n            height: 460px;\r\n        }\r\n        .readcons-content {\r\n            max-height: 340px;\r\n        }\r\n        #cocPdfScrollContainer {\r\n            height: 310px; /* overridden to auto by .coc-step2-mode in step 2 */\r\n        }\r\n    }\r\n    /* Task 174409: time-limited banner stacked under the fixed banner in the logo column. Overrides the\r\n       generic .logo-section img sizing (135px desktop / 25% mobile). Kept at 84% and centred so it stays\r\n       clear of the column\'s right-hand divider line instead of running into it. */\r\n    .login-page .logo-section img.scheduled-banner-login {\r\n        display: block;\r\n        position: static;\r\n        width: 84%;\r\n        max-width: 100%;\r\n        margin: 24px auto 0;\r\n        border-radius: 8px;\r\n    }\r\n    @media screen and (min-width: 767px) and (max-width: 1200px) {\r\n        .login-page .logo-section img.scheduled-banner-login {\r\n            width: 80%;\r\n        }\r\n    }\r\n    @media screen and (min-width: 320px) and (max-width: 767px) {\r\n        .login-page .logo-section img.scheduled-banner-login {\r\n            width: 90%;\r\n            margin-top: 16px;\r\n        }\r\n    }\r\n</style><div class="login-outer overflow-x-hide"><div class="auth-block login-page" ng-controller="loginController" ng-class="{\'section-registration\': isRegisteringUser, \'login-page-awarenessimg\': bannerImageUrl, \'coc-step2-active\': isCodeOfConductVisible}"><div class="form row" ng-class="{\'coc-step2-row\': isCodeOfConductVisible}"><div class="logo-section" ng-class="{\'col-sm-5 col-md-6\': isRegisteringUser || bannerImageUrl == null, \'col-sm-7 col-md-6\': !isRegisteringUser && bannerImageUrl != null}"><div class="left-logo-block d-table w-100 br-2-s b-clr-7" ng-class="{\'logo-section-reg\': isRegisteringUser || isCodeOfConductVisible}"><div class="d-table-cell v-a-m"><img src="assets/img/radflow-logo.png" class="radlogo-lgn"> <img ng-src="{{bannerImageUrl}}" alt="Login Banner" class="awareness-img-login" ng-if="bannerImageUrl"><img ng-src="{{scheduledBannerUrl}}" alt="Announcement" class="scheduled-banner-login" ng-if="scheduledBannerUrl"></div></div></div><div class="col-xs-12 coc-content-col" ng-if="!isRegisteringUser" ng-class="{\'col-sm-7 col-md-6\': bannerImageUrl == null, \'col-sm-5 col-md-5\': bannerImageUrl != null}" ng-style="isCodeOfConductVisible ? {\'display\': \'block\'} : {\'display\': \'table\'}"><div class="elemterms-of-cons fpscreens pl-10px pr-10px pt-25px pos-rel" ng-if="TermsOfUseVisible && !isCodeOfConductVisible"><h1 class="fs-18px fw-600 txt-clr-1 mb-10px mt-0 pb-5px text-left" style="border-bottom: 1px solid #626262 !important;">Terms Of Use</h1><div class="readcons-content overflow-y-auto txt-clr-1" id="termsofuse"></div><div class="elemterms-of-cons-ftr text-center pt-10px pb-10px mt-10px"><button type="button" class="btn btn-primary" ng-click="OnTermsOfUseSubmit()">Submit</button></div></div><div class="elemterms-of-cons fpscreens pl-10px pr-10px pt-25px pos-rel" ng-if="isCodeOfConductVisible" ng-class="{\'coc-step2-mode\': isCodeOfConductVisible}"><div class="d-flex justify-content-between align-item-center mb-10px pb-5px" style="border-bottom: 1px solid #626262;"><h1 class="fs-18px fw-600 txt-clr-1 mb-0 mt-0"><span ng-show="coc.step === 1">Radiologist Professionalism &amp; Code of Conduct</span> <span ng-show="coc.step === 2">Code of Conduct Attestation</span></h1><span class="txt-clr-5 fs-13px" style="white-space:nowrap;">Step {{coc.step}} of 2</span></div><div ng-show="coc.step === 1" class="coc-step-panel"><div class="readcons-content overflow-y-auto txt-clr-1" id="codeofconduct" when-scroll-ends="cocOnScrollEnd()"></div><div class="elemterms-of-cons-ftr pt-10px pb-10px"><div class="d-flex align-item-center mb-10px"><input type="checkbox" id="cocAgreedChk" class="cmn-checkbx-input m-0" ng-model="coc.hasAgreed" ng-disabled="!coc.hasScrolled"> <label for="cocAgreedChk" class="rf-label cmn-check-label mb-0 ml-5px fs-13px" style="line-height:16px !important;">I have read and agree to the Radiologist Professionalism &amp; Code of Conduct</label></div><div class="text-right"><button type="button" class="btn btn-primary" ng-click="cocGoToStep2()" ng-disabled="!coc.hasAgreed">Next <i class="fa fa-arrow-right"></i></button></div></div></div><div ng-show="coc.step === 2" class="coc-step2-body coc-step-panel"><div class="coc-step2-inner"><div id="cocPdfScrollContainer" style="overflow-y:auto;overflow-x:hidden;border:1px solid #555;border-radius:4px;background:#e8e8e8;"><div ng-if="coc.docLoading" class="text-center fs-13px txt-clr-1" style="padding:30px 0;"><i class="fa fa-spinner fa-spin"></i> Loading document...</div><div ng-if="coc.docError" class="text-center fs-13px txt-clr-1" style="padding:30px 0;"><i class="fa fa-exclamation-triangle"></i> Unable to load document.</div><div id="cocPdfContainer" style="position:relative;"><canvas id="cocSignatureCanvas" style="position:absolute;display:none;cursor:crosshair;background:rgba(255,255,255,0.55);border:1.5px dashed #1a1aff;border-radius:2px;"></canvas></div></div><div class="coc-sig-hint" ng-if="coc.showSigHint"><i class="fa fa-pencil mr-5px"></i> Scroll down to the signature line to complete your attestation.</div><div class="coc-step2-footer"><div class="d-flex justify-content-between align-item-center mb-8px"><span class="fs-12px txt-clr-1"><span class="fw-600">Name:</span> {{coc.userName}}</span> <span class="fs-12px txt-clr-1"><span class="fw-600">Date:</span> {{coc.signatureDate}}</span> <button type="button" class="btn btn-xs btn-default" ng-click="cocClearCanvas()">Clear Signature</button></div><div class="pb-5px d-flex justify-content-between" ng-if="!coc.processingLogin"><button type="button" class="btn btn-default" ng-click="cocGoToStep1()"><i class="fa fa-arrow-left"></i> Back</button> <button type="button" class="btn btn-primary" ng-click="cocSubmit()" ng-disabled="!cocCanSubmit() || coc.isSaving"><span ng-if="!coc.isSaving">Electronically Sign &amp; Submit</span> <span ng-if="coc.isSaving">Saving...</span></button></div><div class="pb-5px text-center" ng-if="coc.processingLogin"><i class="fa fa-spinner fa-spin mr-5px txt-clr-1"></i> <span class="txt-clr-1 fs-13px">Please wait...</span></div></div></div></div></div><form class="form-horizontal login-form fpscreens" ng-submit="formSubmit(username,password,rememberMe)" ng-if="!isVerifyUserName && !isResetPassword && !isPasscode && !TermsOfUseVisible && !isCodeOfConductVisible"><h1 class="mb-25px pt-15px pb-25px txt-clr-1 fw-600">Sign In</h1><div class="form-group mb-0"><div class="col-sm-12 mb-25px"><input type="text" ng-model="username" class="form-control" id="inputEmail3" placeholder="Username" autofocus=""> <i class="fa fa-user txt-clr-2 fs-20px fa-pos" aria-hidden="true"></i></div></div><div class="h-20px"></div><div class="form-group mb-0"><div class="col-sm-12 mb-25px"><input type="password" ng-model="password" class="form-control" id="inputPassword3" placeholder="Password"> <i class="fa fa-lock txt-clr-2 fs-20px fa-pos" aria-hidden="true"></i></div></div><div class="mb-25px"><div class="float-left form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" ng-model="rememberMe" id="rememberMe"> <label for="rememberMe" class="rf-label cmn-check-label">Remember me</label></div><div class="float-right"><a href="javascript:void(0)" ng-click="forgotPassword()" class="txt-clr-16 fw-500">Forgot Password?</a></div><div class="clearfix"></div></div><div class="form-group d-flex justify-content-center" ng-if="showRecaptcha"><div id="loginRecaptcha" style="margin:auto!important;"></div></div><div class="h-20px"></div><div class="form-group d-flex justify-content-center"><div class="col-sm-6" style="margin:auto!important;"><button type="submit" class="btn btn-primary rf-btn-lg w-100"><span ng-show="!isLoading" class="text-capitalize">Sign In</span> <span ng-show="isLoading" class="text-capitalize">Wait...</span></button></div></div><div class="txt-clr-6 fs-13px fw-600 text-center p-5px-all"><span ng-if="!forgotPasswordUrl">{{error}}</span> <span ng-if="forgotPasswordUrl">{{errorBeforeLink}}<a href="javascript:void(0)" ng-click="forgotPassword()" class="txt-clr-16 fw-500" style="text-decoration: underline;">{{errorLinkText}}</a>{{errorAfterLink}}</span></div><div class="clearfix pt-0 txt-clr-2"><a href="javascript:void(0)" ui-sref="PrivacyPolicy" class="txt-clr-2">Privacy Policy</a> | <a href="javascript:void(0)" ui-sref="TermsOfUse" class="txt-clr-2">Terms of Use</a></div><br></form><form class="form-horizontal login-form fpscreens" ng-submit="VerifyUserName(verify_username)" ng-if="isVerifyUserName && !isCodeOfConductVisible"><h1 class="mb-25px pt-15px pb-25px txt-clr-1 fw-600">{{title}}</h1><div class="form-group mb-25px"><div class="col-sm-12"><input type="text" ng-model="verify_username" class="form-control" id="verify_username" placeholder="Username"> <i class="fa fa-user txt-clr-2 fs-20px fa-pos" aria-hidden="true"></i></div></div><div class="form-group py-10px"><div class="col-sm-12"><input type="cancel" class="btn btn-default rf-btn-lg w-45 mr-5px" ng-click="CancelCerification();" value="Cancel"> <button type="submit" class="btn btn-primary rf-btn-lg w-45"><span ng-show="!isLoading" class="text-capitalize">Next</span> <span ng-show="isLoading" class="text-capitalize">Wait...</span></button></div></div><div class="txt-clr-6 fs-13px fw-600 text-center p-5px-all">{{error}}</div></form><form class="form-horizontal login-form fpscreens" ng-submit="ResetPassword(verify_username, password, confirmpassword)" ng-if="isResetPassword && !isCodeOfConductVisible" name="resetpasswordform" id="resetpasswordform"><h1 class="mb-25px pt-15px pb-25px txt-clr-1 fw-600">Reset Password</h1><div class="form-group mb-25px"><div class="col-sm-12 text-left"><label class="rf-label fs-14px txt-clr-16 mb-0">{{verify_username | titleCase}}</label></div></div><div class="form-group mb-25px"><div class="col-sm-12"><input type="password" ng-model="password" name="password" class="form-control" id="password" placeholder="Password" uib-tooltip-template="\'PasswordPolicyTooltip.html\'" tooltip-class="setpwdpolicytooltip" tooltip-trigger="none" tooltip-is-open="(resetPwdPwdFocused && resetpasswordform.password.$invalid) || (!resetPwdPwdFocused && resetpasswordform.password.$dirty && resetpasswordform.password.$viewValue && resetpasswordform.password.$invalid)" tooltip-placement="auto top" ng-focus="resetPwdPwdFocused = true" ng-blur="resetPwdPwdFocused = false" ng-pattern="/^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{12,64}$/" required=""></div></div><div class="form-group mb-25px"><div class="col-sm-12"><input type="password" ng-model="confirmpassword" class="form-control" id="confirmpassword" placeholder="Confirm Password" required=""></div></div><div class="form-group"><div class="col-sm-12"><button type="button" class="btn btn-default rf-btn-lg w-45 mr-5px" ng-click="CancelforgotPassword();">Cancel</button> <button type="submit" class="btn btn-primary rf-btn-lg w-45" ng-disabled="!resetpasswordform.$valid"><span ng-show="!isLoading" class="txt-clr-1 fs-13px fw-600 text-capitalize">Reset</span> <span ng-show="isLoading" class="txt-clr-1 fs-13px fw-600 text-capitalize">Wait...</span></button></div></div><div class="txt-clr-6">{{resetpassworderror}}</div></form><form class="form-horizontal login-form fpscreens" ng-submit="formSubmitPasscode(passcode)" ng-if="isPasscode && !isResetPasscode && !isVerifyUserName && !isCodeOfConductVisible"><h1 class="mb-25px pt-15px pb-25px txt-clr-1 fw-600">Pin</h1><div class="form-group mb-20px"><div class="col-sm-12 text-center"><h4 class="txt-clr-16">{{UserName | titleCase}}</h4></div></div><div class="form-group mb-25px"><div class="col-sm-12"><input ng-model="passcode" id="passcode" numbers-only="" class="form-control text-center" my-set-focus="passcode" maxlength="6" type="password" placeholder="Enter Pin" autofocus="" required=""></div></div><div class="h-20px"></div><div class="form-group d-flex justify-content-center"><div class="col-sm-6" style="margin:auto!important;"><button type="submit" class="btn btn-primary rf-btn-lg w-100"><span ng-show="!isLoading" class="text-capitalize">Submit</span> <span ng-show="isLoading" class="text-capitalize">Wait...</span></button></div></div><div style=""><a href="javascript:void(0)" ng-click="verifyuser()" class="cursor-pointer pt-10px txt-clr-2">Forgot Pin?</a><span class="txt-clr-16 pr-0 pl-2px">|</span> <a href="javascript:void(0)" ng-click="SignOut()" class="cursor-pointer pt-10px txt-clr-2">Sign Out</a></div><br><div class="txt-clr-6 fs-13px fw-600 text-center p-5px-all">{{error}}</div></form><form class="form-horizontal login-form fpscreens" ng-submit="ResetPasscode(verify_username, passcode, confirmpasscode)" ng-if="isResetPasscode && !isCodeOfConductVisible"><h1 class="mb-25px pt-15px pb-25px txt-clr-1 fw-600">Reset Pin</h1><div class="form-group mb-25px"><div class="col-sm-12 text-center"><h4 class="txt-clr-16">{{UserName | titleCase}}</h4></div></div><div class="form-group mb-25px"><div class="col-sm-12 text-left"><input type="password" ng-model="passcode" numbers-only="" maxlength="6" class="form-control" id="password" placeholder="New Pin" required=""> <small class="form-text text-muted txt-clr-5" ng-if="!passcode || passcode.length < 4"><span class="txt-clr-6">Pin must be atleast 4 digit.</span></small></div></div><div class="form-group mb-25px"><div class="col-sm-12"><input type="password" ng-model="confirmpasscode" numbers-only="" maxlength="6" class="form-control" id="confirmpasscode" placeholder="Confirm Pin" required=""></div></div><div class="form-group"><div class="col-sm-12 py-10px"><input type="cancel" class="btn btn-default rf-btn-lg w-45 w-45 mr-5px" ng-click="CancelforgotPasscode();" value="Cancel"> <button type="submit" class="btn btn-primary rf-btn-lg w-45" ng-disabled="!passcode || passcode.length < 4"><span ng-show="!isLoading" class="text-capitalize">Reset</span> <span ng-show="isLoading" class="text-capitalize">Wait...</span></button></div></div><div class="txt-clr-6">{{resetpasscodeerror}}</div></form></div><div class="col-sm-7 col-md-6" ng-if="isRegisteringUser" style=""><form class="form-horizontal reg-sm-margin login-form" name="signupfrom" id="signupfrom" ng-submit="onSignUp()"><h1 class="txt-clr-1 fw-600">Sign Up</h1><div class="h-10px"></div><div class="form-group mb-0"><div class="col-sm-6 mb-25px"><label class="rf-label" style="text-align:left">First Name *</label> <input type="text" ng-model="newUser.FirstName" class="form-control" id="inputFName" placeholder="First Name" autocomplete="off" required=""></div><div class="col-sm-6 mb-25px"><label class="rf-label" style="text-align:left">Last Name *</label> <input type="text" ng-model="newUser.LastName" class="form-control" id="inputLName" placeholder="Last Name" autocomplete="off" required=""></div></div><div class="form-group mb-0"><div class="col-sm-6 mb-25px"><label class="rf-label" style="text-align:left">Email *</label> <input type="text" ng-model="newUser.Email" class="form-control" id="signupfromEmail" name="signupfromEmail" placeholder="Email" autocomplete="off" required="" ng-pattern="emailFormat"></div><div class="col-sm-6 mb-25px"><label class="rf-label" style="text-align:left">Phone Number *</label> <input type="text" ng-model="newUser.PhoneNumber" class="form-control" ui-mask="+1 (999) 999-9999" id="signupfromPhone" name="signupfromPhone" autocomplete="off" required=""></div></div><div class="form-group mb-0"><div class="col-sm-12" ng-if="newUser.RoleName==\'User\'"><label class="rf-label" style="text-align:left">NPI</label> <input type="text" ng-model="newUser.NPI" class="form-control mb-25px" id="inputNPI" placeholder="NPI" autocomplete="off" numbers-only="" maxlength="16"></div></div><div ng-if="newUser.UserRoles.includes(\'User\')"><div class="form-group mb-0"><div class="col-sm-6 mb-25px"><label class="rf-label" style="text-align:left">Address Line 1</label> <input type="text" ng-model="newUser.Address.AddressLine1" class="form-control" id="signupaddressLine1" name="signupfromEmail" placeholder="Address Line 1" autocomplete="off"></div><div class="col-sm-6 mb-25px"><label class="rf-label" style="text-align:left">Address Line 2</label> <input type="text" ng-model="newUser.Address.AddressLine2" class="form-control" id="signupaddressLine2" name="signupfromEmail" placeholder="Address Line 2" autocomplete="off"></div></div><div class="form-group mb-0"><div class="col-sm-6 mb-25px"><label class="rf-label" style="text-align:left">City</label> <input type="text" ng-model="newUser.Address.City" class="form-control" id="signupaddresCity" name="signupfromEmail" placeholder="City" autocomplete="off"></div><div class="col-sm-6 mb-25px"><label class="rf-label" style="text-align:left">Postal Code</label> <input type="text" numbers-only="" maxlength="5" ng-model="newUser.Address.PostalCode" class="form-control" id="signupaddressPostalcode" name="signupfromEmail" placeholder="Postal Code" autocomplete="off"></div></div><div class="form-group mb-0"><div class="col-sm-6 mb-25px"><label class="rf-label" style="text-align:left">State</label> <input type="text" ng-model="newUser.Address.State" class="form-control" id="signupaddresState" name="signupfromEmail" placeholder="State" autocomplete="off"></div><div class="col-sm-6 mb-25px"><div class="group-register"><label class="rf-label" style="text-align:left">Country</label><ui-select skip-focusser="true" class="form-control" ng-model="newUser.Address.CountryCode" title="Select Country"><ui-select-match placeholder="Select Country" allow-clear="true">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="list in CountryCodes | propsFilter: {value: $select.search}" position="down"><div ng-bind-html="list.value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><div class="form-group mb-25px"><label class="col-sm-12 rf-label" style="text-align:left">UserName *</label><div class="col-sm-12"><input type="text" ng-model="newUser.UserName" class="form-control" id="inputNUUserName" placeholder="User Name" autocomplete="off" onkeypress="return event.charCode != 32" required=""> <i class="fa fa-user txt-clr-2 fs-20px fa-pos" aria-hidden="true"></i></div></div><div class="form-group mb-25px"><div class="col-sm-6"><label class="w-100 rf-label" style="text-align:left">Password *</label><div class="pos-rel"><input type="password" ng-model="newUser.Password" name="password" class="form-control" id="inputNUPassword" placeholder="Password" autocomplete="off" uib-tooltip-template="\'PasswordPolicyTooltip.html\'" tooltip-class="setpwdpolicytooltip" tooltip-trigger="none" tooltip-placement="auto top" tooltip-is-open="(signupfrom._pwdFocused && signupfrom.password.$invalid) || (!signupfrom._pwdFocused && signupfrom.password.$dirty && signupfrom.password.$viewValue && signupfrom.password.$invalid)" ng-focus="signupfrom._pwdFocused = true" ng-blur="signupfrom._pwdFocused = false" tooltip-append-to-body="false" ng-pattern="/^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{12,64}$/" required=""> <i class="fa fa-lock txt-clr-2 fs-20px fa-pos" style="right:15px;" aria-hidden="true"></i></div></div><div class="col-sm-6"><label class="w-100 rf-label" style="text-align:left">Confirm Password *</label><div class="pos-rel"><input type="password" ng-model="newUser.ConfirmPassword" class="form-control" id="inputNUConfirmPassword" placeholder="Confirm Password" autocomplete="off" required=""> <i class="fa fa-lock txt-clr-2 fs-20px fa-pos" style="right:15px;" aria-hidden="true"></i></div></div></div><div class="form-group mb-0"><div class="col-sm-12 mb-25px"><label class="rf-label" style="text-align:left">Pin *</label> <input type="password" ng-model="newUser.Passcode" class="form-control" id="inputNUPasscode" placeholder="Enter Pin" autocomplete="off" required="" maxlength="6" numbers-only=""></div></div><div class="h-5px"></div><div class="form-group row"><div class="col-sm-6 col-xs-6" style="margin:auto!important;"><button type="button" class="btn btn-default rf-btn-lg w-100 sm-btn-height" ng-click="onSignUpCancel()"><span class="text-capitalize">Cancel</span></button></div><div class="col-sm-6 col-xs-6" style="margin:auto!important;"><button type="submit" class="btn btn-primary rf-btn-lg w-100 sm-btn-height" ng-disabled="!signupfrom.$valid"><span ng-show="!isLoading" class="text-capitalize">Sign Up</span> <span ng-show="isLoading" class="text-capitalize">Wait...</span></button></div></div><div class="txt-clr-6 fs-13px fw-600 text-center p-5px-all">{{newUser.error}} <span class="error" ng-show="signupfrom.signupfromEmail.$error.pattern">Not valid email!</span> <span class="error" ng-show="signupfrom.signupfromPhone.$error.pattern">Not valid phone number!</span></div><div class="clearfix pt-0 txt-clr-2"><a href="javascript:void(0)" ui-sref="PrivacyPolicy" class="txt-clr-2"><b>Privacy Policy</b></a> | <a href="javascript:void(0)" ui-sref="TermsOfUse" class="txt-clr-2"><b>Terms of Use</b></a></div></form></div></div><div class="modal fade overflow-hide-all" id="OTPVerification" role="dialog" data-keyboard="false" data-backdrop="static"><div class="modal-dialog mt-0"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="CancelCerification()">&times;</button><h4 class="modal-title">Verification Code</h4></div><div class="modal-body" style="max-height:80vh !important; overflow-x: auto"><form name="OTPVerify" id="OTPVerify" ng-submit="VerifyOTP()"><div class="row py-15px"><div class="col-sm-8"><input type="text" ng-model="OTP" class="form-control-n flow-input" id="OTP" maxlength="4" numbers-only="" placeholder="Verification Code"></div><div class="col-sm-4 p-0"><button type="button" class="btn btn-default w-45" value="Resend" ng-click="VerifyUserName(verify_username)" ng-disabled="isResendDisabled || DataObject.isResendLimitReached">Resend</button><button type="submit" class="btn btn-primary btn-sm w-45 ml-5px"><span ng-show="!isLoading" class="txt-clr-23 fs-13px fw-600 text-capitalize">Verify</span> <span ng-show="isLoading" class="txt-clr-23 fs-13px fw-600 text-capitalize">Wait...</span></button></div><div class="col-sm-12 txt-clr-1 mt-5px">{{otp_error}}</div><div class="col-sm-12 txt-clr-1 mt-5px" ng-show="(DataObject.ComesFromLogin)? !DataObject.isResendLimitReached && isResendDisabled : isResendDisabled">Please wait for {{OTPRetryTimer}} seconds before requesting a new verification code.</div><div class="col-sm-12 txt-clr-1 mt-5px" ng-show="DataObject.isResendLimitReached && (DataObject.ComesFromLogin)">You have reached the maximum number of OTP resend attempts (3). Please try again later.</div><div class="col-sm-12 txt-clr-15 mt-5px" ng-show="!DataObject.isResendLimitReached && DataObject.otpResendAttempts > 0 && (DataObject.ComesFromLogin)">Resend attempts: {{DataObject.otpResendAttempts}}/{{DataObject.maxOtpResendAttempts}}</div></div></form></div></div></div></div></div><div ng-if="!isVerifyUserName && !isResetPassword"><div class="d-block w-100 sm-position text-center" style="bottom:0;left:0;right:0;position:fixed;"><div class="pb-5px txt-clr-2 vertxt txt-clr-24"><a class="txt-clr-24"><b>RadFlow</b></a> | <a class="txt-clr-24"><b>{{radflowUIVersion}}</b></a></div></div></div><form ng-submit="ReloadRadFlow()" ng-if="isRadFlowUpdate"><div class="update-card-overlay"><div class="update-required-card"><div class="d-flex align-item-center justify-content-center"><img src="assets/images/redflow-update.png" height="200"></div><h2 class="text-center">App Update Required!</h2><p class="text-center">We have added new features and fixed some bugs to make your experience seamless</p><div class="d-flex align-item-center mt-20px justify-content-center"><button type="submit" class="btn btn-primary rf-btn-lg w-100">Update app</button></div></div></div></form></div></div><script type="text/ng-template" id="PasswordPolicyTooltip.html"><p class="fw-600 fs-13px mb-8px pl-5px mt-5px txt-clr-1">Password Requirements:</p> <ul class="password-policy-tooltip pl-20px m-0 text-left"> <li class="fs-12px mb-8px" ng-repeat="requirement in DataObject.PasswordRequirements"> {{requirement}} </li> </ul></script>');
$templateCache.put('app/pages/campaign/campaign-modal.html','<div class="campaign-modal"><div class="campaign-tab-bar"><button class="campaign-tab" ng-class="{active: vm.activeTab === \'campaign\'}" ng-click="vm.setTab(\'campaign\')">&#127942; Campaign</button> <button class="campaign-tab" ng-if="vm.isLive" ng-class="{active: vm.activeTab === \'live\'}" ng-click="vm.setTab(\'live\')"><span class="campaign-live-dot"></span> Watch the Challenge Unfold Live</button> <button type="button" class="campaign-close-btn" ng-click="vm.close()">&#x2715;</button></div><div ng-show="vm.activeTab === \'campaign\'" class="campaign-modal-body"><div class="campaign-hero"><div class="campaign-trophy-icon">&#127942;</div><div class="campaign-label-tag">LIMITED-TIME CAMPAIGN</div><div class="campaign-title">{{vm.campaign.title}} &#127881;</div><div class="campaign-badge">{{vm.campaign.tagline}}</div><div class="campaign-theme">{{vm.campaign.theme}}</div><div class="campaign-stars">&#9733; &#9733; &#9733; &#9733; &#9733;</div></div><div class="campaign-tab1-content"><div class="campaign-challenge-box"><div class="campaign-challenge-title">&#127919; The Challenge</div><div class="campaign-challenge-desc">This <strong>{{vm.campaign.name}}</strong>, every read counts! Join the challenge and earn recognition for outstanding performance across turnaround, quality and coverage.</div><div class="campaign-goal-box"><span class="campaign-goal-label">&#127919; HOW IT WORKS</span> Several independent award categories, so <strong>different reading styles and shifts all have a chance to win.</strong> Read the way you read best &mdash; every category is scored on its own.</div></div><div class="campaign-timeline"><div class="campaign-timeline-item start"><div class="campaign-tl-label">&#9654; STARTS</div><div class="campaign-tl-val">{{vm.campaign.start}}</div></div><div class="campaign-timeline-item end"><div class="campaign-tl-label">&#9632; ENDS</div><div class="campaign-tl-val">{{vm.campaign.deadline}}</div></div></div><div class="campaign-live-note" ng-if="!vm.isLive"><span>&#128225;</span> <span>Live standings open <strong>{{vm.campaign.start}}</strong>. Until then this is the announcement &mdash; every read from the start counts.</span></div><div class="campaign-compensation-box"><div class="campaign-comp-main">{{vm.campaign.cashReward}} Cash Reward</div><div class="campaign-comp-sub">cash per award category &mdash; added to your invoice</div><div class="campaign-comp-note">&#127941; Top performers will be recognized &amp; rewarded</div></div><div class="campaign-section-title">{{vm.campaign.name}} Champion Awards</div><div class="campaign-award-grid"><div class="campaign-award-card" ng-repeat="award in vm.awards track by award.key" uib-popover="{{award.detail}}" popover-title="{{vm.awardName(award)}}" popover-trigger="mouseenter" popover-placement="top" popover-append-to-body="true" popover-class="campaign-popover"><div class="campaign-award-icon">{{award.icon}}</div><div class="campaign-award-name">{{vm.awardName(award)}}</div><div class="campaign-award-desc">{{award.desc}}</div></div></div><div class="campaign-prize-note">&#127942; Each Champion Award winner receives a <strong>{{vm.campaign.cashReward}} cash reward</strong>, added to the invoice</div></div><div class="campaign-modal-footer"><div class="campaign-footer-title">{{vm.campaign.theme}}</div><div class="campaign-footer-sub">Happy {{vm.campaign.name}} &#127881; &mdash; Thank you for everything you do for our patients and partners.</div><button class="campaign-cta-btn" ng-click="vm.close()">Got It &mdash; Let\'s Read!</button></div></div><div ng-show="vm.activeTab === \'live\'" class="campaign-modal-body"><div class="campaign-tab2-content"><div class="campaign-lb-header"><div class="campaign-lb-title">&#127942; Current Leaders</div><div class="campaign-lb-sub">based on live campaign data</div></div><div class="campaign-leaders-grid"><div class="campaign-leader-card" ng-repeat="award in vm.awards track by award.key" ng-class="{\'campaign-leader-card-open\': !vm.hasWinner(award)}"><div class="campaign-leader-icon">{{award.icon}}</div><div class="campaign-leader-type">{{vm.awardName(award)}}</div><div class="campaign-leader-name" ng-class="{\'campaign-no-winner\': !vm.hasWinner(award)}">{{vm.leaderName(award)}}</div><div class="campaign-leader-stat" ng-if="vm.hasWinner(award)">{{vm.leaderMetric(award)}}</div><div class="campaign-leader-detail" ng-if="vm.leaderDetail(award)">{{vm.leaderDetail(award)}}</div></div></div><div class="campaign-no-data">Standings refresh each time you log in. Awards need a minimum of 10 eligible reads.</div></div><div class="campaign-modal-footer"><div class="campaign-footer-title">{{vm.campaign.theme}}</div><div class="campaign-footer-sub">Happy {{vm.campaign.name}} &#127881; &mdash; Thank you for everything you do for our patients and partners.</div><button class="campaign-cta-btn" ng-click="vm.close()">Got It &mdash; Let\'s Read!</button></div></div></div>');
$templateCache.put('app/pages/cap/cap.html','<style>\r\n    * {\r\n        box-sizing: border-box;\r\n    }\r\n    /* Create two equal columns that floats next to each other */\r\n    .column {\r\n        float: left;\r\n        width: 31%;\r\n        padding: 10px;\r\n        margin: 10px;\r\n        height: 700px; /* Should be removed. Only for demonstration */\r\n    }\r\n    /* Clear floats after the columns */\r\n    /*.row:after {\r\n        content: "";\r\n        display: table;\r\n        clear: both;\r\n    }*/\r\n    .mybr {\r\n        border: 1px solid #000;\r\n    }\r\n\r\n    /*.w-33 {\r\n        width: 33% !important;\r\n    }*/\r\n\r\n    .in-place-edit {\r\n        /* enable new lines */\r\n        white-space: pre-wrap;\r\n    }\r\n    /* just for ease of presentation here */\r\n    .in-place-edit {\r\n        display: inline-block;\r\n    }\r\n\r\n    .pb-chat-panel {\r\n        border: none;\r\n        margin-bottom: -5px;\r\n    }\r\n\r\n    .pb-chat-panel-heading {\r\n        margin-top: -5px;\r\n    }\r\n\r\n    .pb-chat-top-icons {\r\n        margin-top: 4px;\r\n    }\r\n\r\n    #support_label {\r\n        color: #fff;\r\n    }\r\n\r\n    .pb-chat-labels {\r\n        font-size: 15px;\r\n    }\r\n\r\n    .pb-chat-labels-right {\r\n        margin-bottom: 0;\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .pb-chat-labels-left {\r\n        margin-left: 5px;\r\n    }\r\n\r\n    .pb-chat-labels-primary {\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .pb-chat-fa-user {\r\n        border: 1px solid blue;\r\n        padding: 5px;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .pb-chat-textarea {\r\n        resize: none;\r\n    }\r\n\r\n    .pb-chat-dropdown {\r\n        width: 400px;\r\n    }\r\n\r\n    .pb-chat-btn-circle {\r\n        border-radius: 35px;\r\n    }\r\n\r\n    .pb-btn-circle-div {\r\n        padding-left: 0px;\r\n        margin-top: 12px;\r\n    }\r\n\r\n    .panel-info > .panel-heading {\r\n        background-color: #3c8dbc;\r\n    }\r\n\r\n    /*th {\r\n        text-align: left !important;\r\n        font-weight: 500 !important;\r\n    }\r\n\r\n    .table th {\r\n        padding-top: 11px !important;\r\n    }\r\n\r\n    .table th, .table td {\r\n        padding-left: 15px !important;\r\n    }*/\r\n\r\n    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n        font-size: 13px !important;\r\n    }\r\n\r\n    ::-moz-placeholder { /* Firefox 19+ */\r\n        font-size: 13px !important;\r\n    }\r\n\r\n    /*.wh-table tbody tr:nth-child(1) {\r\n        background-color: #273136 !important;\r\n        letter-spacing: 0.04rem;\r\n        font-size: 13px;\r\n        color: #ccc !important;\r\n        vertical-align: middle;\r\n        height: 40px;\r\n    }\r\n\r\n    .form-control {\r\n        border-bottom: none !important;\r\n        height: auto !important;\r\n        font-size: 13px !important;\r\n    }\r\n\r\n        .form-control:focus {\r\n            height: 34px !important;\r\n            box-shadow: none !important;\r\n        }\r\n\r\n    .btn-default-focus {\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    .ui-select-placeholder {\r\n        font-size: 13px !important;\r\n    }\r\n\r\n    .ui-select-bootstrap > .ui-select-choices, .ui-select-bootstrap > .ui-select-no-choice {\r\n        width: auto !important;\r\n    }*/\r\n    .panel ::-webkit-scrollbar-track {\r\n        background: transparent;\r\n    }\r\n\r\n    .panel ::-webkit-scrollbar-thumb {\r\n        background: #d9d9d9;\r\n    }\r\n</style><link rel="stylesheet" async="" difer="" href="https://radico.radamatic.com/assets/vendor/galley-viewer/viewer.css"><script async="" difer="" src="https://radico.radamatic.com/assets/vendor/galley-viewer/viewer.js"></script><div ng-controller="CAPController as capctrl"><div ng-show="capctrl.isLoading" class="spinner-overlay" style="z-index: 80;"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="row RFI-list m-0"><div class="col-lg-12 col-xs-12 col-md-12 p-0"><div class="chat-wrapper w-100 h-100 pos-rel ng-cloak"><div class="overflow-x-hide" ng-if="!capctrl.gotoNextPage"><div class="w-100 height-inherit d-block"><div class=""><div class=""><div class="row mx-0 mb-5px"><div class="radf-header bg-clr-32"><div class="w-50"><h2 class="float-left w-250px">Coding Assistance Portal</h2><div class="float-left"><div class="pt-15px" ng-if="!capctrl.ShowOnlyCoderValue && capctrl.IsCoder">( Question View )</div><div class="pt-15px" ng-if="capctrl.ShowOnlyCoderValue && capctrl.IsCoder">( CAP View )</div></div></div><div class="w-50 float-right text-right"><div ng-if="capctrl.IsCoder"><span class="tultip-bottom"><input type="button" class="btn btn-primary btn-sm m-10px-all" value="Switch to CAP View" ng-if="!capctrl.ShowOnlyCoderValue" ng-click="ShowCodersRFIData(1)"> <input type="button" class="btn btn-primary btn-sm m-10px-all" value="Switch to Question View" ng-if="capctrl.ShowOnlyCoderValue" ng-click="ShowCodersRFIData(0)"> <span class="tultiptext tt-white tt-wh-b-b-0" ng-if="!capctrl.ShowOnlyCoderValue">Click to see<br>CAP view</span> <span class="tultiptext tt-white tt-wh-b-b-0" ng-if="capctrl.ShowOnlyCoderValue">Click to see<br>Question view</span></span></div></div><div class="clearfix"></div></div><div ng-if="!capctrl.IsMediclDirector && !capctrl.IsCoder"></div><div><div class="pos-abs abs-t-0 abs-r-0 p-10px-all" ng-if="capctrl.IsMediclDirector && !capctrl.IsSuperAdminRole"><span class=""><span class="" tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="Select to see All Facility Reports"><input class="pos-rel cursor-pointer" style="top:3px;" type="checkbox" ng-model="capctrl.ShowAll" ng-change="ShowMedicalDirectorData(capctrl.ShowAll)"></span></span> <span class=""><label class="d-inline m-4px-all rf-label cursor-default">View All Facility Reports</label></span></div></div></div><div class="rf-filter row bg-clr-27 pt-8px"><div class=""><div class="col-sm-4 col-md-2 col-xs-2 pr-0 tultip-bottom cap-w-15"><ui-select class="mult-select seltype-drop" name="SearchLocation" ng-required="true" ng-model="capctrl.SearchLocation" theme="bootstrap"><ui-select-match class="singsel-text-truncate" placeholder="Select a Location">{{$select.selected.LocationName}}</ui-select-match><ui-select-choices repeat="item.LocationName as item in capctrl.RFIFacility | filter: $select.search" refresh="refreshAddresses($select.search)"><div ng-bind-html="item.LocationName | highlight: $select.search"></div></ui-select-choices></ui-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-160px" style="top:35px!important;" ng-if="capctrl.SearchLocation">{{capctrl.SearchLocation}}</span> <span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-160px" style="top:35px!important;" ng-if="!capctrl.SearchLocation">Location</span></div><div class="col-sm-1 col-md-2 col-xs-1 pr-0 pl-10px tultip-bottom sel-arrow-p-r-0 cap-w-15 sel-reason-pr"><ui-select class="mult-select bg-clr-31 seltype-drop" name="SearchReason" ng-required="true" ng-model="capctrl.SearchReason" theme="bootstrap"><ui-select-match placeholder="Select Reason">{{$select.selected.Headervalue}}</ui-select-match><ui-select-choices repeat="item.Headervalue as item in capctrl.RFIReasons | filter: $select.search" refresh="refreshAddresses($select.search)"><div ng-bind-html="item.Headervalue | highlight: $select.search"></div></ui-select-choices></ui-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white tt-wh-b-t-0 sl-hsw-180px" style="top:35px!important;" ng-if="capctrl.SearchReason">{{capctrl.SearchReason}}</span> <span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white tt-wh-b-t-0 sl-hsw-180px" style="top:35px!important;" ng-if="!capctrl.SearchReason">Reason</span></div><div class="col-sm-1 col-md-2 col-xs-2 pr-0 pl-10px cap-w-15"><input class="blk-input form-control col-placeholder cap-placeholder-fs-14px" style="border-color:#424242!important;opacity:1 !important" ng-model="capctrl.SearchPatientName" placeholder="Patient Name" tooltip-class="uibtooltipDenial" uib-tooltip="Patient Name" tooltip-placement="auto top"></div><div class="col-sm-1 col-md-2 col-xs-2 pr-0 pl-10px cap-w-15"><input class="blk-input form-control col-placeholder cap-placeholder-fs-14px" ng-model="capctrl.SearchProcedure" placeholder="Procedure" tooltip-class="uibtooltipDenial" uib-tooltip="Procedure" tooltip-placement="auto top"></div><div class="col-sm-2 col-md-1 col-xs-3 pr-0 pl-10px sel-arrow-p-r-0 cap-w-15" tooltip-class="uibtooltipDenial" uib-tooltip="Reading Provider" tooltip-placement="auto top"><ui-select class="mult-select bg-clr-31 seltype-drop" name="SearchReadingProvider" ng-required="true" ng-model="capctrl.SearchReadingProvider" theme="bootstrap"><ui-select-match placeholder="Select Reading Provider">{{$select.selected}}</ui-select-match><ui-select-choices repeat="item in capctrl.RFIReadingProvider | filter: $select.search" refresh="refreshAddresses($select.search)"><div ng-bind-html="item | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-1 col-md-1 col-xs-2 pr-0 pl-10px cap-w-15" tooltip-class="uibtooltipDenial" uib-tooltip="Status" tooltip-placement="auto top"><select style="border-color:#424242!important;background-color:#323232!important;" class="sing-select form-control downArrow-ie p-pw-14 txt-clr-19" ng-model="capctrl.Status" ng-options="x.title as x.title for x in capctrl.Statuses" ng-change="changestatus(Status)"></select></div><div class="col-sm-2 col-md-2 col-xs-2 pr-0 pl-10px fcf-w"><button type="button" value="Search" class="btn btn-primary pull-left rf-btn-xs pr-5px" ng-click="Search()">Filter</button> <button type="button" value="Clear" class="btn btn-default pull-left rf-btn-xs pr-5px" ng-click="clearSearch()">Clear Filter</button></div></div></div></div><div class="clearfix"></div><div class="overflow-auto scrollbar-macosx ie-scroll" data-jquery-scrollbar=""><table ng-table-dynamic="tableParams with cols" show-filter="true" class="table-scroll fxtblui w-100 bg-clr-31" pagination="none"><thead class="bg-clr-31 txt-clr-17"><tr class="caprw-1"><th ng-repeat="col in $columns" class="head-1 txt-clr-14 fs-13px fw-600 text-left py-10px px-5px cursor-pointer"><div ng-if="col.field !=\'color\' && col.field !=\'AssgnRFIToDoctor\' && col.field !=\'Extension\'" class="mr-10px"><span ng-click="clickSortByName(col.field)" class="d-flex"><span ng-switch="col.field" class="d-block text-truncate"><span ng-switch-when="ReasonCode" class="mr-5px">Reason</span> <span ng-switch-when="LocationGroup" class="mr-5px">Location</span> <span ng-switch-when="PatientName" class="mr-5px">Patient Name</span> <span ng-switch-when="ProcedureDescription" class="mr-5px">Procedure Description</span> <span ng-switch-when="DateDiffMin" class="mr-5px">Days To Expire</span> <span ng-switch-when="RFIDays" class="mr-5px">Days In CAP</span> <span ng-switch-when="Status" class="mr-5px">Status</span> <span ng-switch-when="ReadingProviderName" class="mr-5px">Reading Provider Name</span></span> <i class="fa fa-sort-asc fs-12px w-0 mt-4px" ng-hide="(col.field == capctrl.SortByName && capctrl.SortASC == 0)"></i> <i class="fa fa-sort-desc fs-12px w-0 mt-4px" ng-hide="(col.field == capctrl.SortByName && capctrl.SortASC == 1)"></i></span></div></th></tr></thead><tbody class="overflow-auto captblht bg-clr-27"><tr ng-repeat="row in $data" data-toggle="tooltip" data-placement="top" class="caprw-2"><td ng-repeat="col in $columns" ng-click="GoToRFIReport(row, col.field)" class="head-2 txt-clr-18 fs-13px fw-500 text-left py-6px px-5px"><div ng-switch="col.field"><div class="tultip-right" ng-switch-when="color" ng-class="row.IsReplied && row.Status == \'Pending\' ? \'rfi-list-ans\' : (row.IsQuestion && row.Status == \'Pending\'? \'rfi-list-que\':\'\')"><span class="p-2px-all"></span><div class="tultiptext tt-white tt-wh-b-r-0" ng-if="row.IsReplied && row.Status == \'Pending\'">Coder Replied To your Question</div><div class="tultiptext tt-white tt-wh-b-r-0" ng-if="!row.IsReplied && row.IsQuestion && row.Status == \'Pending\'">Waiting for Coder To Reply</div></div><span ng-switch-when="DateDiffMin" class="">{{::row[col.field] | myDateFilter}}</span><div ng-switch-default="" class="text-truncate" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{ ::row[col.field] }}">{{ ::row[col.field] }}</div><span class="cursor-pointer" tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="Edit Expiry Date" ng-click="showExpirycalender(row,$event);" ng-switch-when="DateDiffMin" ng-if="capctrl.IsAdminRole && row.Status == \'Pending\'"><i class="fa fa-edit fs-18px ml-5px"></i></span><div class="mt-5px m-0-auto sm-w-100" ng-if="row.ChangeExpiry" ng-switch-when="DateDiffMin"><div class="input-group blk-calender fixtblcal"><input type="text" class="blk-input form-control col-placeholder" uib-datepicker-popup="MM/dd/yyyy" ng-model="row.ExpirationTime" is-open="showFromDateFlag" datepicker-options="capctrl.dateOptions" close-text="Close" alt-input-formats="altInputFormats" min="{{capctrl.minDate | date:\'yyyy-MM-dd\'}}" max-date="maxDate" ng-click="openCalendar(\'id\');$event.stopPropagation()" ng-change="EditExpiry(row);$event.stopPropagation()" name="FromDate" style="border-color:#a2a1a1!important;"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="showFromDateFlag = true; $event.stopPropagation()" style="border-color:#a2a1a1!important;"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="text-capitalize" ng-switch-when="AssgnRFIToDoctor"><button class="btn btn-primary btn-sm d-inline m-auto bg-clr-39" ng-click="PluckSelectedRFI(row);$event.stopPropagation()" ng-if="row.Status == \'Pending\' && capctrl.ShowOnlyCoderValue" data-toggle="modal" type="button">Assign</button> <span ng-show="capctrl.LoggedInUserNPI != row.ProviderNPI && row.AssignedToName" class="txt-clr-1 d-block text-left m-auto text-preline">Assigned to {{row.AssignedToName}}</span></div><div class="float-right text-capitalize pr-15px" ng-switch-when="Extension" ng-if="row.Status == \'Pending\'"><span class=""><button class="btn btn-primary btn-sm d-block m-auto" data-toggle="modal" ng-click="SelectedRFIforExtension(row);$event.stopPropagation()" ng-disabled="row.IsExpiryDateExtendedByUser" type="button">Extend</button> <span class="" ng-if="row.IsExpiryDateExtendedByUser" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="User Already Extended Expiration Date Once"></span> <span class="" ng-if="!row.IsExpiryDateExtendedByUser" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="Click to Extend Expiration Date"></span></span></div><div class="clearfix"></div></div></td></tr></tbody></table><label class="rf-label txt-clr-6 my-5px pos-abs w-100 text-center m-auto abs-t-18" ng-if="capctrl.NoRecords">No Records Found</label></div><div><ul uib-pagination="" total-items="capctrl.totalItems" items-per-page="capctrl.itemsPerPage" ng-model="capctrl.currentPage" ng-change="pageChanged()" rotate="false" class="pagination mt-4px bg-clr-31" max-size="2" boundary-link-numbers="true"></ul></div><div class="values-section"><div ng-if="capctrl.IsCoder && !capctrl.ShowOnlyCoderValue"><span class="fw-500">{{capctrl.PendingRFI}}</span><span>Total Records</span></div><div ng-if="capctrl.IsCoder && capctrl.ShowOnlyCoderValue" class="smfs-13px">Pending <span>{{capctrl.PendingRFI}}</span> of <span class="fw-500">{{capctrl.TotalRFI}}</span> Total Records</div><div ng-if="!capctrl.IsCoder" class="smfs-13px">Pending <span class="fw-500">{{capctrl.PendingRFI}}</span> of <span class="fw-500">{{capctrl.TotalRFI}}</span> Total Records</div></div></div></div></div><div class="users-container clearfix" ng-if="capctrl.gotoNextPage"><div class="w-100 height-inherit d-block"><div class="users-content-inner margin-0-625-all border-radius-0-25-all"><div class="users-content-inner-header"><div class="radf-header bg-clr-32"><div class="w-50"><h2 class="float-left">Coding Assistance Portal ({{capctrl.selectedRFIData.Status}})</h2></div><div class="w-50 float-right text-right"><button type="button" id="btnSubmit1" ng-click="GoToPreviousPage()" class="btn btn-primary btn-sm m-10px-all">Return to List</button></div><div class="clearfix"></div></div></div></div><div class="clearfix"></div><div class="users-content-inner-content h-85vh"><form name="frmReason" ng-submit="Show(frmReason.$valid)"><div class="bg-clr-23 p-5px-all mx-8px mb-7px mt-7px"><div class="row fw-500 m-0"><div class="col-sm-3"><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Patient Name :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.Patient_FirstName}} {{capctrl.selectedRFIData.Patient_MiddleName}} {{capctrl.selectedRFIData.Patient_LastName}}</span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Patient DOB :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.Patient_DOB | date:\'MM-dd-yyyy\'}}</span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">MRN :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.MRN}}</span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Location Group :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.LocationGroup}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Carrier ID :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.Insurance_CompanyID}}</span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Carrier Name :</span> <span class="fs-14px fw-400 mb-0 txt-clr-15">{{capctrl.selectedRFIData.Insurance_CompanyName}}</span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Policy Number :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.PolicyNumber}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Accession :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.Accession_Number}}</span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Procedure Description :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15 tultip-right">{{capctrl.selectedRFIData.ProcedureDescription}} <span class="tultiptext">{{capctrl.selectedRFIData.ProcedureDescription}}</span></span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Physician :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15 tultip-right">{{capctrl.selectedRFIData.Doctor_FirstName}} {{capctrl.selectedRFIData.Doctor_LastName}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Service Date :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.DOS | date:\'MM-dd-yyyy\'}}</span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Dictation Date :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.DictationDateTime | date:\'MM-dd-yyyy HH:mm\'}}</span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Days in CAP :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15 tultip-right">{{capctrl.selectedRFIData.RFIDays}}</span></div><div class="mb-5px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Expiry Date :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15">{{capctrl.selectedRFIData.ExpirationTime | date:\'MM-dd-yyyy\'}}</span></div></div></div></div><div class="px-8px" ng-if="capctrl.Reason==\'MISSING READING LOCATIONS\'"><div class="w-34 m-r-0-5p float-left b-1-s b-clr-3 h-66vh"><div class="w-100 users-content-inner-content overflow-y-auto scrollbar-macosx overflow-x-hide h-100-per" data-jquery-scrollbar="" style="padding-bottom:20px !important; padding-right:10px;"><h4>Missing Reading Locations Dates</h4><ul class="p-0"><li ng-repeat="item in capctrl.readingLocations" class="txt-clr-3 fw-500 fs-13px p-5px-all bg-clr-22 mb-1px" id="droppable{{$index}}" ui-on-drop="onDrop1($event,$data,$index)" drop-channel="priests" drop-validate="dropValidateHandler1($drop, $event, $data)"><div class="w-40 float-left"><i class="fa fa-caret-right"></i> {{item.ReportDate| date:"EEE, MMM d, y h:mm a"}} :</div><div class="w-60 float-left fw-700" ng-if="item.ReadingLocationName">{{item.ReadingLocationName}}</div><div class="w-60 float-left txt-clr-5 fs-12px" ng-if="!item.ReadingLocationName">[*Drag facility names here]</div><div class="clearfix"></div></li></ul></div></div><div class="w-33-i m-r-0-5p float-left b-1-s b-clr-3 h-66vh p-10px-all"><div class="w-100 users-content-inner-content overflow-y-auto scrollbar-macosx overflow-x-hide h-100-per" data-jquery-scrollbar="" style="padding-bottom:20px !important; padding-right:10px;"><h4>Facility Names</h4><div class="fw-500 fs-12px mb-5px">{{capctrl.Reason}}</div><ul class="p-0" style="padding-right:10px !important;"><li ng-repeat="item in capctrl.facilityNames" class="txt-clr-3 fw-500 fs-13px mb-1px draggable p-5px-all m-auto b-2-s b-clr-8 mb-4px" ui-draggable="true" drag="item" drag-channel="priests" on-drop-success="dropSuccessHandler1($event, $index, item)"><i class="fa fa-chevron-circle-right"></i> &nbsp;{{item.Name}}</li></ul></div></div><div class="w-33-i float-left b-1-s b-clr-3 h-66vh overflow-y-auto scrollbar-macosx overflow-x-hide" data-jquery-scrollbar="" style="padding-bottom:20px !important"><span class="fw-500">No images</span></div><div class="clearfix"></div></div><div class="px-8px" ng-if="capctrl.Reason!=\'MISSING READING LOCATIONS\'"><div class="w-34 m-r-0-5p float-left b-1-s b-clr-3 cap-report-ht users-content-inner-content overflow-y-auto scrollbar-macosx overflow-x-hide p-10px-all"><div ng-switch="" on="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\'"><div ng-switch-when="true"><div class="fs-13px fw-500 text-ws-pl text-break-word txt-clr-1 mb-10px w-100 h-68vh" ng-if="capctrl.ModifiedDisplayReport" ng-model="capctrl.ModifiedDisplayReport" contenteditable="" bind-html-compile="capctrl.ModifiedDisplayReport"></div></div><div ng-switch-when="false"><div id="droppable" class="fs-13px fw-500 in-place-edit text-ws-pl text-break-word txt-clr-1 mb-10px w-100 pb-20px min-h-68vh outline-none" bind-html-compile="capctrl.ModifiedDisplayReport" style="display:{{capctrl.ModifiedDisplayReport ? \'block\' : \'none\'}}" contenteditable="" ng-model="capctrl.ModifiedDisplayReport" ui-on-drop="onDrop($event,$data,$index)" drop-channel="priests" drop-validate="dropValidateHandler($drop, $event, $data)"></div></div></div><style>\r\n                                            /* scrollbar css start */\r\n                                            /*::-webkit-scrollbar {\r\n                                                width: 6px;\r\n                                            }*/\r\n                                            /* Track */\r\n                                            /*::-webkit-scrollbar-track {\r\n                                                box-shadow: inset 0 0 5px rgba(0,0,0,0.3);\r\n                                                border-radius: 10px;\r\n                                            }*/\r\n                                            /* Handle */\r\n                                            /*::-webkit-scrollbar-thumb {\r\n                                                background: #a19999;\r\n                                                border-radius: 10px;\r\n                                            }*/\r\n                                            /* Handle on hover */\r\n                                            /*::-webkit-scrollbar-thumb:hover {\r\n                                                    background: #a19999;\r\n                                                }*/\r\n                                            /* scrollbar css end */\r\n                                            /*#droppable .w-30 {\r\n                                                width: 80% !important;\r\n                                                cursor: default;\r\n                                            }*/\r\n                                        </style></div><div class="w-30 m-r-0-5p float-left b-1-s b-clr-3 cap-report-ht p-10px-all"><div class="mb-10px bb-1-s b-clr-3 tooltip-w-180px"><h4 class="float-left fw-600 mt-3px w-c-100-80px text-truncate txt-clr-1">Reason and Options</h4><button type="button" id="btnSubmit1" ng-click="showPreview()" ng-if="capctrl.RFIFileData" class="btn btn-primary mr-5px float-right btn-sm" tooltip-class="uibtooltipDenial" uib-tooltip="{{capctrl.RFIFileData.FileName}}" tooltip-placement="auto top"><i class="fa fa-file-pdf-o fs-15px"></i> View</button><div class="clearfix"></div></div><div class="h-61vh overflow-y-auto scrollbar-macosx overflow-x-hide hideXscroll" data-jquery-scrollbar=""><div class="txt-clr-1 fw-500 fs-13px p-5px-all bg-clr-32 b-clr-10 b-1-s bor-rad-4px">{{capctrl.Reason}}</div><div class="clearfix"></div><div ng-if="capctrl.options && capctrl.options.length>0" ng-switch="" on="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\'"><div ng-switch-when="true"><ul class="p-0" style="padding-right:10px !important;"><li ng-repeat="option in capctrl.options" class="txt-clr-1 fw-500 fs-13px mb-1px draggable p-5px-all m-auto b-2-s b-clr-8 mb-4px">{{option.replace("%txtbox%","____")}}</li></ul></div><div ng-switch-when="false"><div class="txt-clr-5 fs-12px p-5px-all fw-600 w-90 m-auto pl-0 ml-0" ng-if="capctrl.options.length > 0">[*Drag and Drop below options to report]</div><ul class="p-0" style="padding-right:10px !important;"><li ng-repeat="option in capctrl.options" class="txt-clr-1 fw-500 fs-13px mb-1px draggable p-5px-all m-auto b-2-s b-clr-8 mb-4px" ui-draggable="true" drag="option" drag-channel="priests" on-drop-success="dropSuccessHandler($event, $index, option)">{{option.replace("%txtbox%","____")}}</li></ul></div></div><div ng-if="!capctrl.options || capctrl.options.length==0"></div></div></div><div class="w-36 float-left b-1-s b-clr-3 cap-report-ht overflow-y-auto scrollbar-macosx overflow-x-hide hideYscroll-i hideXscroll" style="padding:0 !important" data-jquery-scrollbar=""><div id="galley"><div ng-if="capctrl.dicomUrl"><iframe class="doc w-100 border-0 h-69vh" ng-src="{{capctrl.dicomUrl}}" name="ifrmDicomViewer" id="ifrmDicomViewer" scrolling="no"></iframe></div></div></div><div class="clearfix"></div></div><div class="p-8px-all w-100 h-60px overflow-hide-all" role="group" aria-label="Transfer Group"><div class="float-left" ng-if="capctrl.selectedRFIData.ReasonCode != \'MISSING READING LOCATIONS\'"><button type="button" id="btnSubmit5" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\'" ng-click="DisableReport()" class="btn btn-primary mx-5px fs-13px">Disable</button> <button type="button" id="btnSubmit3" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\'" ng-click="NoChange()" class="btn btn-primary mx-5px fs-13px">No Change</button> <button type="submit" id="btnSubmit4" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\' || capctrl.ModifiedDisplayReport ==\'<br>\' || capctrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || capctrl.ModifiedDisplayReport == \'\'" class="btn btn-primary mx-5px fs-13px" ng-if="capctrl.RFIReportIndex <= capctrl.PendingRFIReport.length && capctrl.RFIReportIndex > 0">Sign Changes</button></div><div class="float-left" ng-if="capctrl.selectedRFIData.ReasonCode == \'MISSING READING LOCATIONS\'"><button type="button" id="btnSubmit3" ng-disabled="capctrl.savechangeOfReadinglocations" ng-click="SaveChangesOfReadingLocations()" class="btn btn-primary mx-5px fs-13px">Save Changes</button></div><div class="fs-20px fw-700 mb-0 txt-clr-14 text-center float-left">Report {{capctrl.RFIReportIndex}}/{{capctrl.PendingRFIReport.length}}</div><div class="float-right"><button type="button" id="btnSubmit6" ng-click="skip()" class="btn btn-primary mx-5px float-right fs-13px" ng-if="capctrl.RFIReportIndex < capctrl.PendingRFIReport.length && capctrl.RFIReportIndex > 0">skip</button> <button type="button" id="btnSubmit2" ng-click="Previous()" class="btn btn-primary mx-5px float-right fs-13px" ng-if="capctrl.RFIReportIndex < capctrl.PendingRFIReport.length + 1 && capctrl.RFIReportIndex > 1">Previous</button><div class="clearfix"></div></div><div class="clearfix"></div><div style="color:red;font-size:14px;" ng-if="!capctrl.QuestionView">Please do not click sign changes, no change, or disable for this report if you have a question.</div></div></form><div class="pos-abs abs-r-0" style="margin-right: 184px;margin-top: -53px;"><div class="row"><div class=""><div class="btn-group dropup dropdown keep-open"><button class="btn btn-primary mx-5px dropdown-toggle fs-13px" style="height:32px; margin-right:30px !important;" ng-class="capctrl.isBlink ? \'blinking\' : \'\'" ng-click="togglePopup()" aria-haspopup="true" aria-expanded="false"><span class="pull-left">{{capctrl.QuestionView == 1? \'Reply to a question\' : \'Ask A Question\'}}</span></button><ul class="dropdown-menu dropdown-menu-right pb-chat-dropdown mb-8px bg-clr-31" style="display:block"><li><div class="panel panel-info pb-chat-panel no-shadow bb-1-s b-clr-15 border-radius-0-b-l border-radius-0-b-r"><div class="panel-heading pb-chat-panel-heading bg-clr-40 py-5px px-15px b-clr-15"><div class="row"><div class="col-xs-12 pr-5px"><a href="#" class="float-left pt-5px txt-clr-1"><label id="support_label">{{capctrl.QuestionView ? \'Reply to a question\' : \'Ask A Question\'}}</label></a> <button class="btn btn-primary mx-5px dropdown-toggle float-right no-bg border-0 px-0 pt-2px" ng-click="togglePopup()"><span class="fa fa-times"></span></button></div></div></div><div class="panel-body h-38vh p-15px-all bg-clr-31"><div class="pos-rel rel-b-15-p"><input type="hidden" ng-model="capctrl.Id"><div scroll-to-bottom="capctrl.CommentList" class="pos-rel overflow-y-auto scrollbar-macosx overflow-x-hide h-38vh hideXscroll scroller-r-3px-minus p-5px-all bg-clr-31" data-jquery-scrollbar=""><div ng-repeat="comment in capctrl.CommentList | orderBy:[\'CommentDate\']"><div class=""><div id="Me" class="chat-message-container width-inherit height-auto m-t-0-625 m-b-0-625"><div class="otgmg-message-column w-80 float-right clearfix pos-rel"><div class="chat-profile-img w-45px h-45px ml-5px float-right no-bg pos-abs abs-b-30-p abs-r-0"><div class="user-profile-img w-45px h-45px border-radius-50-all float-right pos-rel txt-clr-1 sender-bg-clr text-center lh-3-2"><img alt="User Image" src="{{comment.ProfilePic}}" ng-if="comment.ProfilePic" class="user-profile-img w-45px h-45px border-radius-50-all float-right pos-rel txt-clr-1 sender-bg-clr text-center lh-3-2"><div ng-if="!comment.ProfilePic" class="rounded-circle w-30px h-30px text-center fw-600 bg-clr-41 d-table"><div class="user-profile-img w-45px h-45px border-radius-50-all float-right pos-rel txt-clr-1 sender-bg-clr text-center lh-3-2 fs-14px fw-600 txt-clr-22">{{::showDisplayname(comment.UserId,comment.DisplayName)}}</div></div></div></div><div class="chat-message-container-placeholder float-right min-w-270px max-w-80p height-auto rounded mr-50px"><div class="chat-message-inner no-bg"><div class="float-left px-5px"><button type="button" class="btn btn-secondary no-bg txt-clr-2 p-1 ml-2px tultip-left float-right" ng-click="deleteComment(comment)" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\' || capctrl.ModifiedDisplayReport ==\'<br>\' || capctrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || capctrl.ModifiedDisplayReport == \'\'" ng-if="comment.UserId == capctrl.currUser" tooltip-class="uibtooltipDenial" uib-tooltip="Remove" tooltip-placement="auto left"><i class="fa fa-minus fs-15px"></i></button> <button type="button" class="btn btn-secondary no-bg txt-clr-2 p-1 ml-2px tultip-left float-right" ng-click="editComment(comment)" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\' || capctrl.ModifiedDisplayReport ==\'<br>\' || capctrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || capctrl.ModifiedDisplayReport == \'\'" ng-if="comment.UserId == capctrl.currUser && !comment.IsFile" tooltip-class="uibtooltipDenial" uib-tooltip="Edit" tooltip-placement="auto left"><i class="fa fa-edit fs-15px"></i></button> <button type="button" class="btn btn-secondary no-bg txt-clr-2 p-1 ml-2px tultip-left float-right" ng-click="reply(comment.Id)" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\' || capctrl.ModifiedDisplayReport ==\'<br>\' || capctrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || capctrl.ModifiedDisplayReport == \'\'" ng-if="capctrl.QuestionView" tooltip-class="uibtooltipDenial" uib-tooltip="Reply" tooltip-placement="auto left"><i class="fa fs-15px">&#xf112;</i></button></div><div class="chat-profile-name fs-13px fw-500 ls-1px pr-10px pb-0 pt-5px text-right text-capitalize mb-5px txt-clr-28 mr-5px">{{::setUsername(comment)}}</div><div class="clearfix"></div><div class="chat-message width-auto height-auto pt-0 pl-0 pr-10px pb-0px"><div class="width-inherit height-inherit"><div class="width-inherit height-inherit btnOutlineNone"><p ng-if="comment.IsFile" class="fs-13px fw-500 text-ws-pl text-break-word mb-1 text-left txt-clr-1 bor-rad-8px pos-rel speechsent bg-clr-32 rightline"><span class="cursor-pointer d-block w-90 p-5px-all fs-15px bg-clr-32 bor-rad-8px m-auto" tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="Click to Download"><i class="fa fa-file-text fs-14px otln-0 mr-4px pl-3px txt-clr-28"></i><a style="word-wrap:break-word;" class="fs-12px dochv" ng-click="DownloadFile(comment)">{{comment.Comment}}</a></span></p><div ng-if="!comment.IsFile" style="word-wrap:break-word;"><p ng-if="!comment.IsEdit" class="fs-13px fw-500 text-ws-pl text-break-word mb-1 text-left txt-clr-1 p-20px-all bor-rad-8px pos-rel speechsent bg-clr-32 leftline">{{comment.Comment}}</p><div class="w-100" ng-if="comment.IsEdit"><div class="w-85 float-left"><form ng-submit="updateComment(comment)"><input class="blk-input form-control p-5px-all fs-13px fw-500 bg-clr-31 bor-rad-8px" ng-model="comment.Comment" ng-if="comment.IsEdit" placeholder="type here" type="text" ng-required="true"></form></div><div class="w-15 float-left"><button type="button" class="btn btn-secondary no-bg txt-clr-2 p-1 mr-2 ml-3 float-left" tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="Cancel" ng-click="cancelComment(comment)"><i class="fa fa-close fs-18px"></i></button></div><div class="clearfix"></div></div></div></div><div class="chat-message-timer-container height-2 min-width-12-50 fs-12px mt-5px"><div class="width-auto"><div class="width-auto"><div class="chat-message-time width-2-813 float-right"><p class="m-0 d-inline-block v-a-m fs-12px fw-600 txt-clr-26">on <b class="fs-12px">{{comment.CommentDate | utcToLocal:\'M/d/yy HH:mm\'}}</b></p></div><div class="clearfix"></div></div></div></div></div></div></div></div></div></div></div><div class="chat-message-container width-inherit height-auto clearfix my-10px" ng-repeat="reply in LoadReplies(comment.Id) | orderBy:[\'CommentDate\']"><div class="incmg-message-column w-80 pl-2 clearfix pos-rel"><div class="chat-profile-img w-45px h-45px mr-5px float-left no-bg pos-abs abs-b-30-p abs-l-0"><div class="user-profile-img w-45px h-45px border-radius-50-all float-left pos-rel img-default-clr text-center lh-3-2 bg-clr-44"><input type="hidden" ng-model="comment.Id"> <img alt="User Image" src="{{reply.ProfilePic}}" ng-if="reply.ProfilePic" class="user-profile-img w-45px h-45px border-radius-50-all float-right pos-rel txt-clr-1 sender-bg-clr text-center lh-3-2"><div ng-if="!reply.ProfilePic" class="rounded-circle w-30px h-30px text-center fw-600 bg-clr-41 d-table"><div class="user-profile-img w-45px h-45px border-radius-50-all float-right pos-rel txt-clr-1 sender-bg-clr text-center lh-3-2 fs-14px fw-600 txt-clr-22">{{::showDisplayname(reply.UserId,reply.DisplayName)}}</div></div></div></div><div class="chat-message-container-placeholder float-left min-w-270px max-w-80p height-auto rounded ml-50px"><div class="chat-message-inner no-bg"><div class="float-right px-5px" ng-if="reply.UserId == capctrl.currUser"><button type="button" class="btn btn-secondary no-bg txt-clr-2 p-1 mr-2px tultip-left" style="float:right" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\' || capctrl.ModifiedDisplayReport ==\'<br>\' || capctrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || capctrl.ModifiedDisplayReport == \'\'" ng-click="deleteComment(reply)" tooltip-class="uibtooltipDenial" uib-tooltip="Remove" tooltip-placement="auto left"><i class="fa fa-minus fs-15px"></i></button> <button type="button" class="btn btn-secondary no-bg txt-clr-2 p-1 mr-2px tultip-left" ng-if="!reply.IsFile" style="float:right" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\' || capctrl.ModifiedDisplayReport ==\'<br>\' || capctrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || capctrl.ModifiedDisplayReport == \'\'" ng-click="editComment(reply)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit" tooltip-placement="auto left"><i class="fa fa-edit fs-15px"></i></button></div><div class="chat-profile-name fs-13px fw-500 ls-1px pr-10px pb-0 pt-5px text-capitalize mb-5px txt-clr-28 float-left">{{::setUsername(reply)}}</div><div class="clearfix"></div><div class="chat-message width-auto height-auto pt-0 pl-0 pr-10px pb-0px"><div class="width-inherit height-inherit"><div class="width-inherit height-inherit btnOutlineNone"><p ng-if="reply.IsFile" class="fs-13px fw-500 text-ws-pl text-break-word mb-1 text-left txt-clr-1 bor-rad-8px pos-rel speechreply bg-clr-45 rightline"><span class="cursor-pointer d-block w-90 p-5px-all fs-15px bg-clr-45 bor-rad-8px m-auto" tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="Click to Download"><i class="fa fa-file-text fs-14px otln-0 mr-4px pl-3px txt-clr-28"></i><a style="word-break: break-all;" class="fs-12px dochv" ng-click="DownloadFile(reply)">{{reply.Comment}}</a></span></p><div ng-if="!reply.IsFile"><p ng-if="!reply.IsEdit" class="fs-13px fw-500 text-ws-pl text-break-word mb-1 text-left txt-clr-1 p-20px-all bor-rad-8px pos-rel speechreply bg-clr-45 rightline">{{reply.Comment}}</p><div class="w-100 mb-5px" ng-if="reply.IsEdit"><div class="w-85 float-left"><form ng-submit="updateComment(reply)"><input class="blk-input form-control p-5px-all fs-13px fw-500 bg-clr-31 bor-rad-8px" ng-model="reply.Comment" placeholder="Reply" type="text" ng-required="true"></form></div><div class="w-15 float-left"><button type="button" class="btn btn-secondary no-bg txt-clr-2 p-1 mr-2 ml-3 float-left cursor-pointer" tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="Cancel" ng-click="cancelComment(reply)"><i class="fa fa-close fs-18px"></i></button></div><div class="clearfix"></div></div></div></div><div class="chat-message-timer-container height-2 min-width-12-50 fs-12px mt-5px"><div class="width-auto"><div class="width-auto"><div class="chat-message-time float-left"><p class="m-0 d-inline-block v-a-m fs-12px fw-600 txt-clr-26">on <b class="fs-12px">{{reply.CommentDate | utcToLocal:\'M/d/yy HH:mm\'}}</b></p></div><div class="clearfix"></div></div></div></div></div></div></div><div class="clearfix"></div></div></div></div><div class="w-90 mb-10px ml-20px" style="padding-top:10px;" ng-if="capctrl.RepliedToCommentId == comment.Id"><form class="float-left" ng-submit="sendMessage(\'reply\')"><input class="blk-input form-control p-5px-all width-240-px bg-clr-white" ng-model="capctrl.Reply" id="reply" ng-disabled="capctrl.disabledReply" placeholder="Reply" type="text"></form><button class="btn btn-primary" style="padding: 5px 12px !important;" data-toggle="modal" type="button" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\' || capctrl.ModifiedDisplayReport ==\'<br>\' || capctrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || capctrl.ModifiedDisplayReport == \'\'" ng-click="sendMessage(\'reply\')">Send</button> <label class="btn btn-secondary no-bg a-txt-clr-2-t-1 p-2 mr-2 tultip-top d-inline-block float-left" ng-style="{ \'cursor\' : \'pointer\' }" id="fileInput"><i class="fa fa-paperclip fs-20px txt-clr-14 cursor-pointer icn-hover"></i> <input id="selectedFileRFI" type="file" class="d-none otln-0" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\' || capctrl.ModifiedDisplayReport ==\'<br>\' || capctrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || capctrl.ModifiedDisplayReport == \'\'" onchange="angular.element(this).scope().uploadFile(this,\'reply\');"> <span class="tultiptext fs-0-8125 tt-white tt-wh-b-l-0">Attach File</span></label><div class="clearfix"></div></div></div></div><div class="panel-footer p-0 bg-clr-31 mt-10px border-0 no-shadow"><form ng-submit="sendMessage(\'comment\')"><div class="row m-0 w-100"><div class="col-xs-2 b-1-s b-clr-15 bg-clr-44 bor-rad-5px py-15px px-10px w-90 float-left"><div class="w-88 float-left"><input class="form-control blk-input w-100 h-30px border-0 pl-0 pr-0" style="background-color: #202020 !important;" ng-model="capctrl.Comment" placeholder="Type here... (Ctrl + Enter to break line)" ng-disabled="capctrl.disabledComment" type="text"></div><div class="m-0 px-0 pb-0 w-10 float-left text-right"><label class="btn btn-secondary no-bg txt-clr-1 p-0 m-0 d-inline-block tultip-top" ng-style="{ \'cursor\' : \'pointer\' }" id="fileInput"><svg width="12" height="25" viewbox="0 0 12 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1357 6.14157L10.1698 18.7235C10.1764 21.1415 8.32466 23.0999 6.03189 23.0999C3.73913 23.0999 1.87678 21.1415 1.87023 18.7235L1.83317 5.04748C1.82908 3.53765 2.9877 2.31227 4.41939 2.31227C5.85107 2.31227 7.01633 3.53765 7.02042 5.04748L7.05155 16.5354C7.05319 17.1371 6.58767 17.6295 6.01707 17.6295C5.44647 17.6295 4.97828 17.1371 4.97665 16.5354L4.94849 6.14157H3.39231L3.42048 16.5354C3.42457 18.0452 4.58983 19.2706 6.02152 19.2706C7.4532 19.2706 8.61182 18.0452 8.60773 16.5354L8.5766 5.04748C8.57005 2.62956 6.70771 0.671143 4.41494 0.671143C2.12217 0.671143 0.270444 2.62956 0.276996 5.04748L0.314055 18.7235C0.323068 22.0496 2.88249 24.741 6.03634 24.741C9.19019 24.741 11.735 22.0496 11.726 18.7235L11.6919 6.14157H10.1357Z" fill="#07E6C4"></path></svg><input id="selectedFileRFI" type="file" class="d-none otln-0" ng-disabled="actrl.selectedRFIData.Status == \'Addendum\' || actrl.selectedRFIData.Status == \'Disable\' || actrl.ModifiedDisplayReport ==\'<br>\' || actrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || actrl.ModifiedDisplayReport == \'\'" onchange="angular.element(this).scope().uploadFile(this,\'comment\');"> <span class="tultiptext fs-0-8125 tt-white tt-wh-b-l-0">Attach File</span></label></div></div><div class="col-xs-2 py-10px px-0 w-10 float-left"><button class="btn btn-primary fs-12px py-4px px-8px no-bg border-0" tooltip-class="uibtooltipDenial" uib-tooltip="Send" tooltip-placement="auto top" ng-disabled="capctrl.selectedRFIData.Status == \'Addendum\' || capctrl.selectedRFIData.Status == \'Disable\' || capctrl.ModifiedDisplayReport ==\'<br>\' || capctrl.ModifiedDisplayReport.indexOf(\'</span>\') == -1 || capctrl.ModifiedDisplayReport == \'\'"><img src="assets/images/sendbutton.svg" class="w-22px"></button></div></div></form></div></div></div></div></li></ul></div></div></div></div></div></div></div></div><div id="SignatureModal" class="modal fade" role="dialog"><div class="modal-dialog attes-w" style="bottom:30px;"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="pos-abs abs-t-0-25 abs-r-0 width-1-875 height-1-875 adjBtn txt-clr-1 fs-16px no-bg border-0" data-dismiss="modal" aria-label="Close" ng-click="cancel()"><span aria-hidden="true"><i class="fa fa-close"></i></span></button><h4 class="modal-title">Attestation Statement</h4></div><div class="modal-body"><div class="row fw-500 mb-10px"><div class="col-sm-3"><div class="mb-10px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Patient Name :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15" style="color:#B1FFF4!important;">{{capctrl.selectedRFIData.Patient_FirstName}} {{capctrl.selectedRFIData.Patient_LastName}}</span></div><div class="mb-10px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Accession Number :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15" style="color:#B1FFF4!important;">{{capctrl.selectedRFIData.Accession_Number}}</span></div></div><div class="col-sm-3"><div class="mb-10px"><span class="fs-14px fw-500 mb-0 txt-clr-1">MRN :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15" style="color:#B1FFF4!important;">{{capctrl.selectedRFIData.MRN}}</span></div><div class="mb-10px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Days in CAP :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15" style="color:#B1FFF4!important;">{{capctrl.selectedRFIData.RFIDays}}</span></div></div><div class="col-sm-3"><div class="mb-10px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Procedure Description :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15" style="color:#B1FFF4!important;">{{capctrl.selectedRFIData.ProcedureDescription}}</span></div><div class="mb-10px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Location Group :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15" style="color:#B1FFF4!important;">{{capctrl.selectedRFIData.LocationGroup}}</span></div></div><div class="col-sm-3"><div class="mb-10px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Service Date :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15" style="color:#B1FFF4!important;">{{capctrl.selectedRFIData.DOS | date:\'MM-dd-yyyy\'}}</span></div><div class="mb-10px"><span class="fs-14px fw-500 mb-0 txt-clr-1">Expiry Date :</span> <span class="fs-14px fw-500 mb-0 txt-clr-15" style="color:#B1FFF4!important;">{{capctrl.selectedRFIData.ExpirationTime | date:\'MM-dd-yyyy\'}}</span></div></div></div><div class="attes-statement fs-14px py-20px px-10px w-40 fw-500 float-left h-500px b-1-s" style="border-color: #fff!important;"><div class="fs-14px fw-500 h-440px text-ws-pl text-break-word txt-clr-white overflow-y-auto scrollbar-macosx overflow-x-hide hideXscroll txt-clr-1" ng-if="capctrl.DisplayReport" style="padding-right:10px !important; padding-bottom:0 !important;" ng-bind-html="capctrl.DisplayReport|unsafe"></div></div><div class="attes-statement fs-14px px-10px pt-10px pb-5px w-60 fw-500 float-left h-500px b-1-s overflow-y-auto scrollbar-macosx overflow-x-hide hideXscroll txt-clr-1 attestinput" data-jquery-scrollbar="" style="padding-right:10px !important;"><div class="px-0 mb-20px lh-1-5 txt-clr-1">I,<input type="text" class="blk-input form-control w-50 text-center fw-700 d-inline p-0 sm-w-35" ng-model="capctrl.selectedRFIData.ProviderName">, hereby attest that the medical record entry for<br><div class="font-italic lh-1-4 w-50 text-center txt-clr-1">(Provider Name)</div><input type="text" class="blk-input form-control w-50 text-center fw-700 d-inline p-0 sm-w-30" ng-model="capctrl.DOS"> of service accurately reflect signature/notations that<br><div class="font-italic lh-1-4 w-50 text-center txt-clr-1">(Date(s))</div>I made my capacity as <input type="text" class="blk-input form-control w-75 text-center fw-700 d-inline p-0 sm-w-100" value="Physician"><br><div class="font-italic lh-1-4 w-75 text-center float-right txt-clr-1">(Physician, Non-Physician Practitioner (NPP), etc. credentials)</div><div class="clearfix"></div>when I diagnosed/ treated the beneficiary listed above.</div><div class="px-0 mb-15px txt-clr-1">I do hereby further attest that this information is true, accurate and complete to the best of my knowledge and I understand that any falsification, omission or concealment of material fact may subject me to administrative, civil or criminal liability.</div><div class="mb-15px"><input type="text" class="blk-input form-control w-100 text-center fw-700" ng-model="capctrl.selectedRFIData.ProviderName"> <i class="txt-clr-1">Signature and credentials</i></div><div class="w-60 float-left"><input type="text" class="blk-input form-control w-70 text-center fw-700" ng-model="capctrl.providerInitials"> <i class="txt-clr-1">Provider Initials:</i></div><div class="w-40 float-left"><input type="text" class="blk-input form-control w-70 text-center fw-700" ng-model="capctrl.currentDate"> <i class="txt-clr-1">Date:</i></div><div class="clearfix h-25px"></div><div class="modal-footer border-0 no-bg pb-0" style="background-color: #3A393A !important;"><button class="btn btn-primary mb-5px" ng-click="UpdateReport()"><i class="fa fa-check fs-1-5"></i> Electronically Sign</button></div></div><div class="clearfix"></div></div></div></div></div></div></div><div id="ReportModal" class="modal fade" role="dialog"><div class="modal-dialog new-popup w-40"><div class="modal-content modal-content-small"><div class="modal-header"><div class=""><button type="button" class="pos-abs abs-t-0-25 abs-r-0 width-1-875 height-1-875 adjBtn txt-clr-1 fs-16px no-bg border-0" data-dismiss="modal" aria-label="Close" ng-click="cancel()"><span aria-hidden="true"><i class="fa fa-close"></i></span></button><h4 ng-if="capctrl.Reason!=\'MISSING READING LOCATIONS\'" class="modal-title fs-15px fw-600">Report Preview ({{capctrl.selectedRFIData.Status}})</h4><h4 ng-if="capctrl.Reason==\'MISSING READING LOCATIONS\'" class="modal-title fs-0-8125 fw-700">Reading Locations</h4></div><div class="clearfix"></div></div><div class="modal-body"><div class="w-100 fw-500 float-left h-520px"><div ng-if="capctrl.Reason!=\'MISSING READING LOCATIONS\' && capctrl.DisplayReport" class="fs-13px fw-500 h-500px text-ws-pl text-break-word txt-clr-1 mb-10px overflow-y-auto scrollbar-macosx overflow-x-hide hideXscroll" data-jquery-scrollbar="" style="padding-right:10px !important;">{{capctrl.DisplayReport}}</div><div ng-if="capctrl.Reason==\'MISSING READING LOCATIONS\'" class="mb-10px overflow-y-auto scrollbar-macosx overflow-x-hide hideXscroll" data-jquery-scrollbar="" style="padding-right:10px !important;"><ul class="p-0"><li ng-repeat="item in capctrl.readingLocations" class="txt-clr-3 fw-500 fs-13px p-5px-all bg-clr-22 mb-1px"><div class="w-40 float-left"><i class="fa fa-caret-right"></i> {{item.ReportDate| date:"EEE, MMM d, y h:mm a"}} :</div><div class="w-60 float-left fw-700" ng-if="item.ReadingLocationName">{{item.ReadingLocationName}}</div><div class="clearfix"></div></li></ul></div></div><div class="clearfix"></div></div><div class="modal-footer pt-0" style="background-color:#3A393A!important;"><div ng-if="capctrl.Reason!=\'MISSING READING LOCATIONS\'" class="float-left txt-clr-5 fw-700">* This Report is {{capctrl.selectedRFIData.Status}} .Cannot be edited.</div><button class="btn btn-primary" data-dismiss="modal" aria-label="Close" ng-click="">Okay</button><div class="clearfix"></div></div></div></div></div><div id="AskQuestionModal" class="modal fade" role="dialog"><div class="modal-dialog new-popup" style="width:35%"><div class="modal-content modal-content-small"><form name="frmAskQuestion" ng-submit="AskQuestion(frmReason.$valid)"><div class="modal-header border-0 modalheader-bg p-0-625-all"><div class="w-60 float-left"><button type="button" class="pos-abs abs-t-0-25 abs-r-0 width-1-875 height-1-875 adjBtn txt-clr-1 fs-16px no-bg border-0" data-dismiss="modal" aria-label="Close" ng-click="cancel()"><span aria-hidden="true"><i class="fa fa-close"></i></span></button><h4 class="modal-title fs-0-8125 fw-700">Ask Questions</h4></div><div class="clearfix"></div></div><div class="modal-body"><div class="attes-statement fs-16px w-100 fw-500 float-left h-202px b-1-s"><textarea class="form-control form-border fs-0-75 no-resize br-txtara pt-0 h-txtara h-200px" ng-change="(capctrl.alertMessage)?ChangeQuestion():\'\'" ng-model="capctrl.message" wm-block="" wm-block-length="600" placeholder="Write Question Here" rows="1" required=""></textarea></div><div class="clearfix"></div></div><div class="modal-footer border-0 no-bg"><div class="float-left txt-clr-5 fw-700" ng-if="capctrl.alertMessage">* {{capctrl.alertMessage}} <span class="txt-clr-5 fw-bold">{{capctrl.DisplayNameOfCoder}}</span></div><div class="float-right"><button type="submit" class="btn btn-primary" ng-click="">Submit</button></div><div class="clearfix"></div></div></form></div></div></div><div class="modal fade" id="assignFRIModel" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog" role="document"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close otln-0" data-dismiss="modal" aria-label="Close" ng-click="Clear();"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Assign Report to other physician</h4></div><div class="modal-body"><div class="w-100 h-100px py-3"><h5 class="fs-16px fw-500 txt-clr-3 text-center my-4"><span class="txt-clr-14"></span></h5><h5 class="fs-16px fw-500 txt-clr-3 text-center my-4"><span class="txt-clr-14"></span></h5><div class="group-register mb-0"><input ng-model="capctrl.searchUser" type="text" class="form-control mr-2 fs-13px" placeholder="Search by typing physician name here." style="border-bottom: 1px solid #757575 !important;"> <span class="bar"></span></div></div><div class="w-100 max-h-40 pos-rel"><div class="pos-rel scrollbar-macosx overflow-x-hide w-100 max-h-30 abs-l-0" data-jquery-scrollbar=""><div class="w-100 pos-rel"><div class="width-auto pos-rel height-auto"><div class="row mx-0"><fieldset id="group1" class="moz-pb-20px"><div ng-repeat="user in capctrl.RFIUsers | orderBy:\'DisplayName\' | filter:capctrl.searchUser track by $index" class="user-container trans-200-bg-linear width-c-100-1 pos-rel no-bg border-radius-0-25-all px-0 m-1 float-left max-w-48p h-50px pt-2px" ng-class="{add_user: user.Selected}"><input name="users" type="radio" value="{{user.DisplayName}}" id="chkInvitedUser{{$index}}" class="d-none" ng-checked="user.Selected" ondblclick="return false;" ng-click="addUser(user)"> <label for="chkInvitedUser{{$index}}" role="button" class="w-100"><span class="user-container-inner width-inherit pos-abs mt-3px mb-3px ml-3px clearfix parent no-bg d-block"><span class="user-profile-img w-40px height-inherit mr-3px border-radius-50-all float-left pos-rel no-bg"><span><span><span class="avatar-wrapper text-center pt-5px"><i class="glyphicon glyphicon-user fs-20px txt-clr-14"></i></span><ng-avatar string="{{user.DisplayName | lowercase}}" width="40" round-shape="true" max-length="2" bind="true" auto-color="true"></ng-avatar></span></span></span> <span class="user-bio-placeholder w-c-100-70px height-inherit pos-rel float-left no-bg"><span class="w-100"><span class="fs-0-8125 fw-600 mb-0 text-truncate w-100 d-block aftSelect text-capitalize" style="color:#05C1A4!important;">{{user.DisplayName | lowercase}}</span> <span class="fs-0-75 lh-1-2 text-truncate txt-clr-2 fw-500 w-100 d-block">{{user.EmailId}}</span></span></span> <span class="user-action-placeholder w-15px height-inherit float-left no-bg"><img ng-src="{{(user.Selected) ? \'assets/images/user_check.png\' : \'assets/images/trans.png\'}}"></span></span></label></div><div class="clearfix"></div></fieldset></div></div></div></div></div><div class="my-10px text-right"><button type="button" class="btn btn-primary" ng-hide="grpTab == \'grptab1\'" ng-disabled="frmGroup.$invalid" ng-click="addeditGroup(frmGroup.$valid)" ng-if="capctrl.isGroupUpdating"></button><button type="button" class="btn btn-primary" ng-hide="grpTab == \'grptab1\'" ng-disabled="frmGroup.$invalid" ng-click="addeditGroup(frmGroup.$valid)" ng-if="capctrl.isGroupUpdating"></button> <button type="button" class="btn btn-primary" ng-disabled="capctrl.SelectedNormalUsers == \'\'" ng-click="AssignRFIToUser()">Assign</button><br><span style="color:{{ResultColor}};" class="fs-0-8125" ng-show="capctrl.IsResultMessage"><b>{{ResultMessage}}</b></span><div ng-show="grpTab == \'grptab1\'"><button type="button" class="btn btn-secondary" ng-click="navigateTab(\'grptab0\')"><i class="icon-arrow-left-circle"></i></button> <button type="button" class="btn btn-primary" ng-disabled="capctrl.GroupUsers.length < 2" ng-click="addeditGroup(frmGroup.$valid)"></button></div><div ng-show="grpTab == \'grptab1\'"><button type="button" class="btn btn-secondary" ng-click="navigateTab(\'grptab0\')"><i class="icon-arrow-left-circle"></i></button> <button type="button" class="btn btn-primary" ng-disabled="capctrl.GroupUsers.length < 2" ng-click="addeditGroup(frmGroup.$valid)"></button></div></div></div></div></div></div></div><div class="modal fade" id="ExtentionOfExpiy" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close otln-0" data-dismiss="modal" aria-label="Close" ng-click="Clear();"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Extend Expiration Date</h4></div><div class="modal-body"><div class=""><div class="pos-rel overflow-x-hide w-100 max-h-30 abs-l-0" data-jquery-scrollbar=""><div class="w-100 pos-rel txt-clr-1"><div class="width-auto pos-rel height-auto"><div class="row mx-0 mt-10px"><div class="col-lg-5 col-md-6 col-sm-6 mt-5px px-0"><label class="rf-label">Extend expiration date by :</label></div><div class="col-lg-2 col-md-2 col-sm-2 px-0"><fieldset id="group1"><div><select ng-options="day as day for day in capctrl.Days" ng-model="capctrl.SelectedDay" class="sing-select form-control downArrow-ie"></select></div></fieldset></div><div class="col-lg-2 col-md-2 col-sm-2 text-left mt-5px"><label class="rf-label" ng-if="capctrl.SelectedDay == 1">day</label> <label class="rf-label" ng-if="capctrl.SelectedDay > 1">days</label></div></div><div class="row mx-0 my-15px"><div class="col-lg-12 px-0"><button class="btn btn-primary float-right ng-scope" ng-click="RequestExtentionExpiry(capctrl.SelectedDay);$event.stopPropagation()" type="button">Save</button><div class="clearfix"></div></div></div></div></div></div></div></div></div></div></div></div><div class="modal fade new-popup" id="assignFRIModel" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header border-0"><button type="button" class="close otln-0" data-dismiss="modal" aria-label="Close" ng-click="Clear();"><span aria-hidden="true"><i class="fa fa-close"></i></span></button><h4 class="modal-title fs-0-8125 fw-700">Assign Deficient Report to other physician</h4></div><div class="w-100 h-100px py-3"><h5 class="fs-16px fw-500 txt-clr-3 text-center my-4"><span class="txt-clr-14"></span></h5><h5 class="fs-16px fw-500 txt-clr-3 text-center my-4"><span class="txt-clr-14"></span></h5><div class="group-register mb-0"><input ng-model="capctrl.searchUser" type="text" class="form-control mr-2 fs-13px" placeholder="Search by typing physician name here." style="border-bottom: 1px solid #757575 !important;"> <span class="bar"></span></div></div><div class="w-100 max-h-40 pos-rel"><div class="pos-rel scrollbar-macosx overflow-x-hide w-100 max-h-30 abs-l-0" data-jquery-scrollbar=""><div class="w-100 pos-rel"><div class="width-auto pos-rel height-auto"><div class="row mx-0"><fieldset id="group1"><div ng-repeat="user in capctrl.RFIUsers | orderBy:\'DisplayName\' | filter:searchUser track by $index" class="user-container trans-200-bg-linear width-c-100-1 height-3-125 pos-rel no-bg border-radius-0-25-all px-0 m-1 float-left max-w-48p h-50px pt-2px" ng-class="{add_user: user.Selected}"><input name="users" type="radio" value="{{user.DisplayName}}" id="chkInvitedUser{{$index}}" class="d-none" ng-checked="user.Selected" ondblclick="return false;" ng-click="addUser(user)"> <label for="chkInvitedUser{{$index}}" role="button" class="w-100"><span class="user-container-inner width-inherit pos-abs m-t-0-3125 m-b-0-3125 m-l-0-3125 clearfix parent no-bg d-block"><span class="user-profile-img w-40px height-inherit m-r-0-3125 border-radius-50-all float-left pos-rel no-bg"><span><span><ng-avatar string="{{user.DisplayName | lowercase}}" width="40" round-shape="true" max-length="2" bind="true" auto-color="true"></ng-avatar></span></span></span> <span class="user-bio-placeholder w-c-100-70px height-inherit pos-rel float-left no-bg"><span class="w-100"><span class="fs-0-8125 fw-500 mb-0 text-truncate w-100 d-block aftSelect">{{user.DisplayName | lowercase}}</span> <span class="fs-0-75 lh-1-2 text-truncate txt-clr-2 fw-500 w-100 d-block">{{user.EmailId}}</span></span></span> <span class="user-action-placeholder w-15px height-inherit float-left no-bg"><img ng-src="{{(user.Selected) ? \'assets/icons/user_check.png\' : \'assets/icons/trans.png\'}}"></span></span></label></div></fieldset></div></div></div></div></div><div class="modal-footer border-0"><button type="button" class="btn btn-primary" ng-hide="grpTab == \'grptab1\'" ng-disabled="frmGroup.$invalid" ng-click="addeditGroup(frmGroup.$valid)" ng-if="capctrl.isGroupUpdating"></button><button type="button" class="btn btn-primary" ng-hide="grpTab == \'grptab1\'" ng-disabled="frmGroup.$invalid" ng-click="addeditGroup(frmGroup.$valid)" ng-if="capctrl.isGroupUpdating"></button> <button type="button" class="btn btn-primary" ng-disabled="capctrl.SelectedNormalUsers == \'\'" ng-click="AssignRFIToUser()">Assign</button><br><span style="color:{{capctrl.ResultColor}};" class="fs-0-8125" ng-show="capctrl.IsResultMessage"><b>{{capctrl.ResultMessage}}</b></span><div ng-show="grpTab == \'grptab1\'"><button type="button" class="btn btn-secondary" ng-click="navigateTab(\'grptab0\')"><i class="icon-arrow-left-circle"></i></button> <button type="button" class="btn btn-primary" ng-disabled="capctrl.GroupUsers.length < 2" ng-click="addeditGroup(frmGroup.$valid)"></button></div><div ng-show="grpTab == \'grptab1\'"><button type="button" class="btn btn-secondary" ng-click="navigateTab(\'grptab0\')"><i class="icon-arrow-left-circle"></i></button> <button type="button" class="btn btn-primary" ng-disabled="capctrl.GroupUsers.length < 2" ng-click="addeditGroup(frmGroup.$valid)"></button></div></div></div></div></div><div class="modal fade new-popup" id="previewModal1" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog cap-w-pdf" role="document"><div class="modal-content"><div class="modal-header p-0-625-all border-0"><button type="button" class="close otln-0" ng-click="closePreview()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-close"></i></span></button><h4 class="modal-title fs-0-8125 fw-700">{{capctrl.RFIFileData.FileName}}</h4></div><div class="modal-body"><div class="gc-content"><div class="row mx-0 pdf-toolbar-clr"><file-viewer data-title="\'Preview\'" ng-if="capctrl.fileurl" file-name="capctrl.RFIFileData.FileName" file-content="capctrl.fileurl" file-binary-content="capctrl.FileContent"></file-viewer></div></div></div></div></div></div></div><script type="text/ng-template" id="RFIPopoup.html"><div class="modal-body"> <div class="row"> <h1> {{abc}} </h1> <table ng-table="tableParamUser" class="table pos-rel width-inherit listofexistingusers-table-container wh-table"> <tbody> <tr ng-repeat="users in $data" ng-class="\'table-active\' : \'\'" data-toggle="tooltip" data-placement="top"> <td data-title="\'FirstName\'" filter="{ FirstName: \'text\'}" sortable="\'FirstName\'"> <input type="button" class="fs-0-75 fw-500 txt-clr-3" value="{{users.FirstName}},{{users.NPI}} {{users.LastName}} {{appRFI.RFI_IdPopUpp}}" ng-click="assignRFITo(appRFI.RFI_IdPopUpp)" /> </td> </tr> </tbody> </table> </div> </div></script></div><script>\r\n    window.addEventListener(\'DOMContentLoaded\', function () {\r\n\r\n    });\r\n\r\n    function InitGalley() {\r\n        var galley = document.getElementById(\'galley\');\r\n        var viewer = new Viewer(galley, {\r\n            url: \'data-original\',\r\n            toolbar: {\r\n                oneToOne: true,\r\n\r\n                prev: function () {\r\n                    viewer.prev(true);\r\n                },\r\n\r\n                play: true,\r\n\r\n                next: function () {\r\n                    viewer.next(true);\r\n                },\r\n\r\n                download: function () {\r\n                    const a = document.createElement(\'a\');\r\n\r\n                    a.href = viewer.image.src;\r\n                    a.download = viewer.image.alt;\r\n                    document.body.appendChild(a);\r\n                    a.click();\r\n                    document.body.removeChild(a);\r\n                },\r\n            },\r\n        });\r\n    }\r\n</script>');
$templateCache.put('app/pages/iewarning/iewarning.html','<style>\r\n    body {\r\n        overflow-y: auto !important\r\n    }\r\n\r\n    p {\r\n        margin-bottom: 15px;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .list-ul li {\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .list-ul {\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n</style><div autoscroll="true" autoscroll-body-top="" keyboard="keys"><div class="row mail-client-container transparent" style="margin:0"><div class="col-md-12 txt-clr-1" style="padding: 0;"><div class="w-90 m-0-auto" ng-show="browser.toUpperCase() == \'IE\'"><div class=""><h2 class="txt-clr-1 fw-500 fs-22px py-25px">The following setup/installation is required prior to using RadFlow. Please download the IE Settings Setup File below, and follow instructions. Once installed, you will need to close and re-open your browser. Please contact <a href="mailto: helpdesk@collaborativeimaging.com">helpdesk@collaborativeimaging.com</a> with any questions.</h2><h4 class="txt-clr-15 fw-600 mb-20px">Step 1: Download RadFlow IE Settings setup</h4><ul class="fs-17px list-ul"><li class="">Click &nbsp;<a href="RadFlow IE Settings.exe" download="" class="txt-clr-14 fw-700">here</a>&nbsp; to download RadFlow IE Settings setup file.</li><li style="list-style:none"><img src="assets/images/ie1.jpg" class="b-clr-1 b-1-s mb-10px"> <img src="assets/images/ie2.jpg" class="b-clr-1 b-1-s mb-10px"> <img src="assets/images/ie3.png" class="b-clr-1 b-1-s mb-10px"> <img src="assets/images/ie4.png" class="b-clr-1 b-1-s mb-10px d-block"></li></ul></div><div class=""><h4 class="txt-clr-15 fw-600 mb-20px">Step 2: Install Utility</h4><ul class="fs-15px list-ul"><li class="">Right Click on Radflow IE Setting and run as administrator</li><li class="" style="list-style:none"><img src="assets/images/ie5.png" class="b-clr-1 b-1-s mb-10px"><br><img src="assets/images/ie6.jpg" class="b-clr-1 b-1-s mb-10px"></li></ul></div><div class=""><h4 class="txt-clr-15 fw-600 mb-20px">Step 3: Setup completed successfully</h4><ul class="fs-15px list-ul"><li class="">Close your current browser</li></ul></div><div class=""><h4 class="txt-clr-15 fw-600 mb-20px">Step 4: Run the RadFlow from shortcut created on your desktop</h4><ul class="fs-15px list-ul"><li class="" style="list-style:none;"><img src="assets/images/set-8.jpg" class="b-clr-1 b-1-s mb-10px"></li></ul></div><h4 class="txt-clr-14 mb-20px">Please feel free to call our support number if you need any assistance.</h4></div><div class="w-90 m-0-auto" ng-show="browser.toUpperCase() != \'IE\'"><div class=""><h2 class="txt-clr-1 fw-500 fs-22px py-25px">The following setup/installation is required prior to using RadFlow. Please download the IE Settings Setup File below, and follow instructions. Once installed, you will need to close and re-open your browser. Please contact <a href="mailto: helpdesk@collaborativeimaging.com" class="txt-clr-14">helpdesk@collaborativeimaging.com</a> with any questions.</h2><h4 class="txt-clr-15 fw-600 mb-20px">Step 1: Download RadFlow IE Settings setup</h4><ul class="fs-17px list-ul"><li class="">Click &nbsp;<a href="RadFlow IE Settings.exe" download="" class="txt-clr-14 fw-700">here</a>&nbsp; to download RadFlow IE Settings setup file.</li><li style="list-style:none"><img src="assets/images/ch1.jpg" class="b-clr-1 b-1-s mb-15px"></li><li style="list-style:none"><img src="assets/images/ch2.jpg" class="b-clr-1 b-1-s mb-15px"></li><li style="list-style:none"><img src="assets/images/ch3.jpg" class="b-clr-1 b-1-s mb-15px"></li><li style="list-style:none"><img src="assets/images/ch4.jpg" class="b-clr-1 b-1-s mb-15px"></li></ul></div><div class=""><h4 class="txt-clr-15 fw-600 mb-20px">Step 2: Install Utility</h4><ul class="fs-17px list-ul"><li class="">Right Click on Radflow IE Setting and run as administrator.</li><li class="" style="list-style:none"><img src="assets/images/ch5.png" class="b-clr-1 b-1-s mb-10px"><br><img src="assets/images/ch6.jpg" class="b-clr-1 b-1-s mb-10px"></li></ul></div><div class=""><h4 class="txt-clr-15 fw-600 mb-20px">Step 3: Setup completed successfully</h4><ul class="fs-17px list-ul"><li class="">Close your current browser</li></ul></div><div class=""><h4 class="txt-clr-15 fw-600 mb-20px">Step 4: Run the RadFlow from shortcut created on your desktop</h4><ul class="fs-15px list-ul"><li class="" style="list-style:none;"><img src="assets/images/set-8.jpg" class="b-clr-1 b-1-s mb-10px"></li></ul></div><h4 class="txt-clr-14 mb-20px">Please feel free to call our support number if you need any assistance.</h4></div></div></div></div>');
$templateCache.put('app/pages/newsletter/newsletter-modal.html','<div class="newsletter-modal"><div class="newsletter-header"><span class="newsletter-title" title="{{vm.title}}">&#128240; {{vm.title}}</span> <button ng-if="vm.pdfUrl" type="button" ng-click="vm.download()" class="newsletter-download-btn" title="Download {{vm.fileName}}" aria-label="Download {{vm.fileName}}"><i class="fa fa-download"></i> Download</button> <button type="button" class="newsletter-close-btn" ng-click="vm.close()" title="Close" aria-label="Close">&#x2715;</button></div><div class="newsletter-body"><iframe ng-if="vm.pdfUrl" class="newsletter-frame" ng-src="{{vm.pdfUrl}}" title="{{vm.title}}"></iframe></div></div>');
$templateCache.put('app/pages/payment-dashboard/payment-dashboard.html','<style>\r\n    .DashboardMenu {\r\n        height: 100%;\r\n        display:none;\r\n        width: 180px;\r\n        position: fixed;\r\n        z-index: 1;\r\n        top: 34px;\r\n        left: 0;\r\n        background-color: #323232;\r\n        overflow-x: hidden;\r\n        padding-top: 20px;\r\n        border-radius: 5px;\r\n    }\r\n\r\n        .DashboardMenu a {\r\n            padding: 6px 8px 6px 16px;\r\n            text-decoration: none;\r\n            font-size: 15px;\r\n            color: #818181;\r\n            display: block;\r\n        }\r\n\r\n            .DashboardMenu a:hover {\r\n                color: #f1f1f1;\r\n            }\r\n   \r\n\r\n    .tab-active {\r\n        color: white !important;\r\n    }\r\n\r\n    .blc-card {\r\n        background-color: #323232;\r\n        border-radius: 5px;\r\n        padding: 10px;\r\n    }\r\n\r\n    .stat-card {\r\n        background-color: #323232;\r\n        padding: 5px;\r\n        border-radius: 5px;\r\n    }\r\n        .stat-card .ag-chart-wrapper .ag-chart-dark-overlay div {\r\n            color: #fff !important;\r\n            font-size: 20px !important;\r\n            font-family: "Open Sans", sans-serif !important;\r\n        }\r\n    .ps-modal .rf-timepick .glyphicon.glyphicon-chevron-up, .rf-bs-modal .rf-timepick .glyphicon.glyphicon-chevron-down {\r\n        color: #05C1A4 !important;\r\n    }\r\n\r\n    .ps-modal .uib-datepicker span.ng-binding.text-muted {\r\n        color: #636c72 !important;\r\n    }\r\n\r\n    .ps-modal .uib-datepicker span.ng-binding.text-info {\r\n        color: #5bc0de !important;\r\n    }\r\n\r\n    .ps-modal .blk-calender .uib-datepicker-popup .text-center {\r\n        color: #fff !important;\r\n    }\r\n    @media only screen and (max-width: 1199px) {\r\n        .chart-grid-box {\r\n            height: calc(100vh - 450px) !important;\r\n        }\r\n    }\r\n</style><div><div class="DashboardMenu"><a href="#home" ng-click="ActiveTab=\'Dashboard\' ; onTabChange(ActiveTab)" ng-class="ActiveTab==\'Dashboard\'? \'tab-active\':\'\'"><i class="fa fa-home mr-7px"></i>Dashboard</a> <a href="#invoices" ng-click="ActiveTab=\'Invoice\'; onTabChange(ActiveTab)" ng-class="ActiveTab==\'Invoice\'? \'tab-active\':\'\'" class="d-none"><i class="fa fa-file-text-o mr-7px"></i>Invoices</a> <a href="#transaction_history" ng-click="ActiveTab=\'Transaction History\' ; onTabChange(ActiveTab)" ng-class="ActiveTab==\'Transaction History\'? \'tab-active\':\'\'" class="d-none"><i class="fa fa-history mr-7px"></i>Transaction History</a> <a href="#account" ng-click="ActiveTab=\'Account\' ; onTabChange(ActiveTab)" ng-class="ActiveTab==\'Account\'? \'tab-active\':\'\'" class="d-none"><i class="fa fa-user mr-7px"></i>Account</a> <a href="#payment_schedule" ng-click="ActiveTab=\'Payment Schedule\' ; onTabChange(ActiveTab)" ng-class="ActiveTab==\'Payment Schedule\'? \'tab-active\':\'\'" class="d-none"><i class="mr-7px"></i>Payment Schedule</a></div><div class=""><div ng-if="ActiveTab==\'Dashboard\'" class="dashboard"><payment-dash-board></payment-dash-board></div><div ng-if="ActiveTab==\'Invoice\'"><h1 class="txt-clr-1">Invoice</h1><contract-summary summary-grid-id="FullInvoiceGrid"></contract-summary></div><div ng-if="ActiveTab==\'Transaction History\'"><h1 class="txt-clr-1">Transaction History</h1><common-ag-grid column-defs="columnDefs" row-data="rowData" grid-id="TransactionHistoryFullGrid"></common-ag-grid></div><div ng-if="ActiveTab==\'Account\'"><h1 class="txt-clr-1">Account</h1><div class="bor-rad-4px bg-clr-31 txt-clr-1 m-all-5px"><div class="usr-prf-heading d-flex"><h1 class="fs-14px fw-600 px-15px py-10px m-0">Personal Details</h1><i class="btn fa fa-pencil w-25px px-0 fs-14px icon-hover" title="Edit" ng-click="EditPersonalDetails()"></i></div><div class="row p-15px-all"><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Name</p><p class="fs-12px mb-0">Marie Phillipps</p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Gender</p><p class="fs-12px mb-0">Female</p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">NPI</p><p class="fs-12px mb-0">1234567890</p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Specialist</p><p class="fs-12px mb-0">Technologist</p></div></div><div class="row p-15px-all"><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Phone Number</p><p class="fs-12px mb-0">+1 111 222 345</p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Email</p><p class="fs-12px mb-0">marie@gmail.com</p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Address</p><p class="fs-12px mb-0">123, Main Street Barlingtion, ON</p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Home city</p><p class="fs-12px mb-0">Barlington</p></div></div></div><div class="bor-rad-4px bg-clr-31 txt-clr-1 m-all-5px mt-10px"><div class="usr-prf-heading d-flex"><h1 class="fs-14px fw-600 px-15px py-10px m-0">Bank Account Details</h1><i class="btn fa fa-pencil w-25px px-0 fs-14px icon-hover" title="Edit" ng-click="EditBankAccountDetails()"></i></div><div class="row p-15px-all"><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Bank Name</p><p class="fs-12px mb-0"></p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Bank Account No.</p><p class="fs-12px mb-0">1234567890</p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">(ABA)Bank code</p><p class="fs-12px mb-0"></p></div></div><div class="row p-15px-all"><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Holder Name</p><p class="fs-12px mb-0">Marie Phillipps</p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Email</p><p class="fs-12px mb-0">marie@gmail.com</p></div><div class="col-md-3"><p class="fs-14px mb-0" style="color: #838282;">Phone</p><p class="fs-12px mb-0">1234567890</p></div></div></div></div><div ng-if="ActiveTab==\'Payment Schedule\'"><h1 class="txt-clr-1">Payment Schedule</h1><div class="col-md-2 col-xs-2 pr-1 float-right d-flex justify-content-end"><button ng-click="AddEditPaymentSchedule(\'Add\')" class="btn btn-primary mx-1 rf-btn-xs">Add Payment Schedule</button></div><common-ag-grid column-defs="columnPaymentScheduleDefs" row-data="rowPaymentScheduleData" grid-id="PaymentScheduleGrid"></common-ag-grid></div></div></div><div class="modal fade ps-modal" id="ModalAddEditPaymentSchedule" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog w-45"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="clearPaymentScheduleData()">&times;</button><h4 class="modal-title">Payment Schedule: ${{PaymentBalance}}</h4></div><div class="modal-body"><form name="formPaymentSchedule" id="formPaymentSchedule" ng-submit="SavePaymentSchedule()"><div class="row"><div class="col-md-4 mt-10px"><label class="rf-label">Payment Schedule Type<span style="color: red !important;">*</span></label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="PaymentScheduleType.Obj" on-select="clearPaymentScheduleData()"><ui-select-match placeholder="Select Payment Schedule Type" allow-clear="true">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in PaymentScheduleTypes" position="down"><div ng-bind-html="list"></div></ui-select-choices></ui-select></div><div class="col-md-4 mt-10px" ng-show="PaymentScheduleType.Obj==\'Percentage\'"><label class="rf-label">Percentage<span style="color: red !important;">*</span></label><div class="d-flex"><input class="blk-input form-control" type="text" placeholder="Percentage Value" style="width:100%" ng-model="PercentageValue" ng-required="PaymentScheduleType.Obj==\'Percentage\'"><p class="ml-10px fs-25px txt-clr-1">%</p></div></div><div class="col-md-4 mt-10px" ng-show="PaymentScheduleType.Obj==\'Price\'"><label class="rf-label">Price<span style="color: red !important;">*</span></label><div class="d-flex"><input class="blk-input form-control" type="text" placeholder="Price" style="width:100%" ng-model="Price" ng-required="PaymentScheduleType.Obj==\'Price\'"><p class="ml-10px fs-25px txt-clr-1">$</p></div></div></div><div class="row"><div class="col-md-4 mt-10px"><label class="rf-label">Due Date</label><div class="input-group blk-calender-inpop"><input type="text" class="blk-input form-control form-border" uib-datepicker-popup="MM/dd/yyyy" ng-model="DueDate" is-open="dospopup.opened" readonly="" datepicker-options="dateSearchOptions" close-text="Close" placeholder="Date" show-button-bar="false" ng-disabled="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="dospopup.opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-3"><label class="rf-label">Payment Schedule Option</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="PaymentScheduleOption.Obj" on-select="ChangePaymentScheduleOption()"><ui-select-match placeholder="Select Payment Schedule Option" allow-clear="true">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in PaymentScheduleOptions" position="down"><div ng-bind-html="list"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-12 mt-10px"><button type="submit" class="btn btn-primary" ng-disabled="">Save</button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/paymentinvoice/paymentinvoice.html','<div class="radf-header bg-clr-32" keyboard="keys"><h2>Payment Invoices</h2></div><payment-invoice ng-if="PaymentInvoiceFlag"></payment-invoice>');
$templateCache.put('app/pages/paymentinvoice-history/paymentinvoice-history.html','<script src="cdn/js/dwv-0.26.0.min.js"></script><link rel="stylesheet" href="cdn/css/ui-grid.css"><style>\r\n</style><div><div class="radf-header"><h2>Payment Invoice History</h2></div><div><payment-invoice-history></payment-invoice-history></div></div>');
$templateCache.put('app/pages/physician-worklist/physician-worklist.html','<script src="cdn/js/dwv-0.26.0.min.js"></script><link rel="stylesheet" href="cdn/css/ui-grid.css"><style>\r\n    .spinner-overlay {\r\n        position: absolute !important;\r\n    }\r\n\r\n    .anui .ui-grid-row .ui-grid-cell .w-100 .tooltip.uibtooltipDenial {\r\n        pointer-events: none;\r\n    }\r\n    /*.filtsecion .blk-input.form-control,\r\n    .filtsecion .mult-select .form-control,\r\n    .filtsecion select.form-control {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n        padding: 5px 12px !important;\r\n    }\r\n\r\n    .filtsecion .loc-input {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n\r\n    .filtsecion .mult-select.ui-select-multiple.ui-select-bootstrap {\r\n        min-height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n\r\n    .filtsecion .k-multiselect-wrap,\r\n    .filtsecion .k-multiselect-wrap .k-input {\r\n        height: 30px !important;\r\n        border-width: 0 !important;\r\n    }\r\n\r\n        .filtsecion .k-multiselect-wrap .k-button {\r\n            font-size: 12px !important;\r\n        }\r\n\r\n    .filtsecion select.form-control.status-fs option {\r\n        font-size: 14px !important;\r\n    }*/\r\n\r\n    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {\r\n        /* IE9+ specific styles go here */\r\n        /*.disabled-grid {\r\n                display: block !important;\r\n                overflow-x: hidden !important;\r\n            }\r\n\r\n            .disabled-list-footer {\r\n                position: fixed !important;\r\n                bottom: 0 !important;\r\n                width: 100% !important;\r\n                padding-bottom: 5px;\r\n            }\r\n\r\n            .charges-list {\r\n                padding-bottom: 40px !important;\r\n                padding-top: 100px !important;\r\n            }\r\n\r\n            .mail-messages-control {\r\n                position: absolute;\r\n                width: 100%;\r\n                z-index: 1 !important;\r\n            }\r\n                */\r\n    }\r\n\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    /*ui-select-choices only for this page */\r\n\r\n    /*.sel-block .ui-select-choices {\r\n            position: fixed;\r\n            top: auto;\r\n            left: auto;\r\n            width: auto !important;\r\n        }*/\r\n\r\n    .uib-datepicker-popup.dropdown-menu {\r\n        /*position:fixed*/\r\n    }\r\n\r\n    /*div[uib-datepicker-popup-wrap] {\r\n             position: fixed;\r\n            top: auto !important;\r\n            left: auto !important;\r\n        }*/\r\n    object {\r\n        min-height: 600px !important;\r\n        max-height: 800px !important;\r\n    }\r\n\r\n    .IPAlert {\r\n        text-align: left !important;\r\n        height: auto !important;\r\n        max-height: 200px;\r\n        overflow-y: scroll;\r\n        text-align: left !important;\r\n        background-color: white;\r\n        font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\r\n        border-radius: 5px;\r\n        color: #333;\r\n        font-size: 18px;\r\n        overflow-y: auto !important;\r\n    }\r\n\r\n    .k-grid table thead tr th:first-child {\r\n        padding-left: 15px !important;\r\n    }\r\n\r\n    .k-grid table tbody tr td:first-child {\r\n        padding-left: 15px !important;\r\n    }\r\n\r\n    .k-grid-header .k-header:first-child {\r\n        border-left-width: 1px !important;\r\n    }\r\n\r\n    .st-sort-ascent:before {\r\n        content: \'\\25B2\';\r\n    }\r\n\r\n    .st-sort-descent:before {\r\n        content: \'\\25BC\';\r\n    }\r\n\r\n    .lr-drop-target-before {\r\n        border-left: 2px solid orange;\r\n    }\r\n\r\n    .lr-drop-target-after {\r\n        border-right: 2px solid orange;\r\n    }\r\n\r\n    .dr-btn-none {\r\n        display: none;\r\n    }\r\n\r\n    #divTechForm {\r\n        /*padding: 10px;*/\r\n        height: 60vh;\r\n        overflow: auto;\r\n    }\r\n\r\n    .defaultfontclass select {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 5px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n\r\n    .defaultfontclass input[type="text"] {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 5px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n\r\n    .defaultfontclass input[type="checkbox"] {\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .defaultfontclass input[type="radio"] {\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .defaultfontclass option {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .defaultfontclass textarea {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 0px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n\r\n    label.defaultfontclass {\r\n        box-sizing: border-box;\r\n        color: #fff !important;\r\n        font-weight: 600 !important;\r\n        margin-bottom: 5px;\r\n        font-size: 13px;\r\n        text-align: left;\r\n        display: inline-block !important;\r\n    }\r\n\r\n    .defaultfontclass td select {\r\n        vertical-align: inherit;\r\n    }\r\n\r\n    .defaultfontclass tr td {\r\n        vertical-align: top;\r\n    }\r\n\r\n    .ui-grid-row-selected {\r\n        background-color: #424242;\r\n    }\r\n\r\n    .popover {\r\n        position: absolute;\r\n        /*z-index: 100;*/\r\n    }\r\n\r\n    .ui-grid .ui-grid-render-container-body .ui-grid-viewport {\r\n        overflow-y: auto !important;\r\n        overflow-x: auto !important;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags.focused {\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    #TechnoWorklistPagelocationTooltip.tultiptext {\r\n        top: 58px !important;\r\n    }\r\n\r\n    .popover.tech-icons-bar {\r\n        left: unset !important;\r\n        right: 50px;\r\n    }\r\n\r\n        .popover.tech-icons-bar.bottom > .arrow {\r\n            left: 80% !important;\r\n        }\r\n\r\n    .tech-icons-bar p i {\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .tech-icons-bar p {\r\n        color: white;\r\n    }\r\n\r\n    /*QueryRetrieve*/\r\n    .query-grid .ag-details-grid.ag-details-grid-fixed-height.ag-theme-balham-dark {\r\n        padding: 10px;\r\n    }\r\n\r\n    .query-grid .ag-details-grid.ag-details-grid-auto-height.ag-theme-balham-dark {\r\n        padding: 16px;\r\n        width: 98%;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .ag-full-width-container > .agrow-bg .ag-details-grid.ag-details-grid-auto-height.ag-theme-balham-dark {\r\n        padding: 8px;\r\n        width: 90%;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .ag-center-cols-clipper {\r\n        min-height: 40px !important;\r\n    }\r\n\r\n    .query-grid .ag-header-container {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .query-grid .ag-center-cols-container {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .queryAccessionHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        padding-left: 39px;\r\n        padding-right: 6px;\r\n    }\r\n\r\n    .querySeriesHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        padding-left: 21px;\r\n        padding-right: 6px;\r\n    }\r\n\r\n    .ag-overlay {\r\n        background: rgba(0, 0,0, 0.8);\r\n    }\r\n\r\n    .ag-overlay-loading-center {\r\n        padding: 10px !important;\r\n        background: transparent !important;\r\n    }\r\n\r\n    .hideHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        display: none;\r\n    }\r\n\r\n    .ag-icon.ag-icon-asc {\r\n        display: block !important;\r\n        font-size: var(--ag-icon-size);\r\n    }\r\n\r\n    .settcol-physician .ag-cell-label-container {\r\n        justify-content: center;\r\n    }\r\n\r\n        .settcol-physician .ag-cell-label-container .ag-header-cell-label {\r\n            display: none;\r\n        }\r\n\r\n    .popover.step-usericons {\r\n        top: 20% !important;\r\n    }\r\n\r\n    .popover.step-plusicons {\r\n        top: 15% !important;\r\n    }\r\n\r\n        .popover.step-plusicons.right > .arrow {\r\n            top: 15% !important;\r\n        }\r\n\r\n    .discussion-height {\r\n        height: 53vh !important;\r\n    }\r\n\r\n    .discussion-height-half-scale {\r\n        height: 59vh !important;\r\n    }\r\n\r\n    .rf-techform-tpckr {\r\n        margin: 0 auto auto auto !important;\r\n    }\r\n\r\n        .rf-techform-tpckr .uib-time input {\r\n            width: 40px;\r\n            height: 30px;\r\n            padding: 4px;\r\n        }\r\n\r\n    .editorder-popup .rf-timepick.rf-techform-tpckr td.uib-increment.hours,\r\n    .editorder-popup .rf-timepick.rf-techform-tpckr td.uib-increment.minutes {\r\n        padding: 0 !important;\r\n    }\r\n\r\n    .rating-star .glyphicon-star {\r\n        color: #05c1a4;\r\n    }\r\n\r\n    .rating-star .glyphicon-star-empty {\r\n        color: white;\r\n    }\r\n\r\n    .report-rate-modal .glyphicon-star-empty {\r\n        color: #a1a1a1;\r\n    }\r\n\r\n    .rate-study-icon {\r\n        border: 3px solid #F8BB86;\r\n        border-radius: 50%;\r\n        font-size: 40px;\r\n        color: #F8BB86 !important;\r\n        padding: 10px 34px;\r\n    }\r\n\r\n    @media only screen and (min-width: 767px) and (max-width:1200px) {\r\n        .statdatetime-row {\r\n            flex-wrap: wrap;\r\n        }\r\n\r\n        .stststrktrm .form-controller.mt-2 {\r\n            margin-top: 0 !important;\r\n        }\r\n    }\r\n</style><div class="radf-header wroklist-wrapper" keyboard="keys"><h2 class="float-left w-50 heading-tw">Physician Worklist</h2><span class="float-right mr-10px py-4px" style=""><span class="float-left" style="display:none;"><img class="mr-5px sm-refresh" src="assets/images/refresh.svg" alt="Refresh"></span> <span class="d-inline-block"><button type="button" class="btn filterbt-2 no-bg fs-12px" ng-click="CollapsePhysicianFilter()" id="heading_physicianworklist" data-toggle="collapse" data-parent="#accordion" href="#collapsePhysicianWorklist" aria-expanded="false" aria-controls="collapseTechWorklist"><span><span ng-if="isfilterCollapse">Open Filter<i class="fa fa-filter txt-clr-1 icon-hover fs-12px pl-5px"></i></span> <span ng-if="!isfilterCollapse">Close Filter<i class="fa fa-close txt-clr-1 icon-hover fs-12px pl-5px"></i></span></span></button></span></span><div class="clearfix"></div></div><div class="pportal-list" id="mainDiv"><div class=""><div class="p-0 collapse in b-clr-33 filtsecion filtr-ontop" id="collapsePhysicianWorklist" role="tabpanel" aria-labelledby="heading_physicianworklist"><form id="frmFilter"><div class="rf-filter filter-controller row my-8px rf-filter-ui"><div class="col-sm-4 col-md-3 col-xs-2 mob-w-50 pr-0 tultip-bottom"><site-location-grid master-locations="Locations" selected-location="SelectedLocations" on-change="updateSelectedLocation()"></site-location-grid></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="Accession" placeholder="Accession" tooltip-class="uibtooltipDenial" uib-tooltip="Accession" tooltip-placement="auto top"></div><div class="col-sm-1 col-md-1 col-xs-2 mob-w-50 pr-0 pl-10px d-w-13"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="OrderDate" options="opts" ng-mouseenter="resetDateRange()" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{toolTipOrderDate}}" tooltip-placement="auto top"></div><div class="col-sm-2 col-md-1 col-xs-3 mob-w-50 pr-0 tultip-bottom pl-10px smw-19 w-12 selmod-m"><multi-select master-data="DataObject.ModalityDropdownDataFilter" list="Modalities" ng-model="DataObject.ModalityDropdownDataFilter.SelectedValue" on-change="onSelectedModalityPhysician(selectedData)"></multi-select><span class="tultiptext text-preline overflow-auto max-h-500px text-left tt-white tt-top">{{modalitytooltip}}</span></div><div class="col-sm-1 col-md-2 col-xs-2 mob-w-100 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="OrderingPhysician" placeholder="Ordering Physician" tooltip-class="uibtooltipDenial" uib-tooltip="Ordering Physician" tooltip-placement="auto top"></div></div><div class="rf-filter filter-controller row mb-4px rf-filter-ui"><div class="col-sm-3 col-md-3 col-xs-3 mob-w-50 pr-0"><div class="col-sm-5 col-md-5 col-xs-5 pr-0 pl-0" style="z-index:1"><input type="text" class="blk-input form-control col-placeholder" ng-model="PatientMRN" placeholder="MRN" tooltip-class="uibtooltipDenial" uib-tooltip="MRN" tooltip-placement="auto top"></div><div class="col-sm-7 col-md-7 col-xs-7 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="PatientName" placeholder="Patient Name" tooltip-class="uibtooltipDenial" uib-tooltip="Patient Last Name, First Name" tooltip-placement="auto top"></div></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px"><div class="input-group blk-calender mb-0"><input type="text" class="blk-input form-control col-placeholder" tooltip-class="uibtooltipDenial" uib-tooltip="DOB (mm/dd/yyyy)" tooltip-placement="auto top" uib-datepicker-popup="MM/dd/yyyy" ng-model="DOB" is-open="isDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="DOB" placeholder="DOB" data-container="body" ng-click="isDOBOpen = !isDOBOpen"></div></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px d-w-13 sclt-type-wdth"><ui-select skip-focusser="true" class="mult-select b-clr bg-clr-31 mob-closekeypad" ng-model="SelectedList.PatientClass" title="Select Type"><ui-select-match placeholder="Select Type" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PatientClass | propsFilter: {Value: $select.search}" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px w-12 set-wdth-sm"><select id="ddlStatus" class="condition-select blk-input form-control downArrow-ie opnclr sing-select-2 status-fs" ng-model="Status" ng-change="FilterDICOMOrders(true)"><option value="AL">All</option><option value="X" style="background-color: #BFDED6">Cancelled</option><option value="CO" style="background-color: #B9ADCF">Comparison</option><option value="C" style="background-color: #75E284">Complete</option><option value="D" style="background-color: #a0c1c5">Draft</option><option value="IP" style="background-color: #f4ba4b">Image Pending</option><option value="PA" style="background-color: #ffe6ee" ng-if="IsAddendumRequestVisible">Pending Addendum</option><option value="OP" style="background-color: #b2b266">Pending Order</option><option value="RP" style="background-color: #FFE69A;">Result Pending</option><option value="H" style="background-color: #FFC99A">Hidden</option></select></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px" ng-show="Status == \'H\'"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="HiddenType.obj" ng-change="FilterDICOMOrders()"><ui-select-match>{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="list in HiddenTypeList" position="down"><div ng-bind-html="list.Key"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px filt-w-new-wl fltr-btn-wrapper mob-flt-rt technobt-sec set-on-sm"><button type="button" ng-click="FilterDICOMOrders()" class="btn btn-primary rf-btn-xs">Filter</button> <button type="button" ng-click="SaveFilters();" class="btn btn-primary rf-btn-xs">Save Filter</button> <button type="button" ng-click="clearFilterAndRefesh();" class="btn btn-default rf-btn-xs">Clear</button></div></div></form></div><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="isorderlistLoading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div></div><div id="PhysicianWorklistAgGrid" class="myGrid ag-theme-balham-dark tech-anui anui" style="width:100%; height:765px"></div></div><div class="overflow-hide-all ERA-check-detail discsn-popup techno-dscsn comp-innotab px-0 py-0" kendo-window="win_Discussion" k-on-open="isDiscussionVisible = true;onKendoWindowOpen();windowOpened(win_Discussion)" k-on-close="CloseDiscussionWindow()" k-title="\'Discussion\'" k-visible="false" k-width="DataObject.defaultWindowWidth" k-height="defaultWindowHeight" k-resize="winDiscussionPhyResize" k-dragend="winDiscussionPhyDragend" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div style="background-color:#262526!important;"><div class="spinner-overlay" ng-show="isDiscussionLoading"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div ng-if="isDiscussionVisible" class="techno-lite-discussion"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center" ng-repeat="tabList in DataObject.DiscussionWindowTabList" ng-class="{\'active\':tabList.TabName==DataObject.DiscussionWindowActiveTab}"><a class="py-5px" ng-click="onDiscussionWindowTabChange(tabList.TabName);" href="#{{tabList.TabName}}" data-toggle="tab" ng-class="{\'disable-area\':tabList.TabName==DataObject.DiscussionWindowActiveTab}" ng-if="tabList.TabName.includes(\'Attachment\') ? SelectedOrder.FileCount > 0 : DataObject.ShowDiscussionTab">{{tabList.TabName && tabList.TabName.includes(\'Attachment\') ? tabList.TabName + (SelectedOrder.FileCount ? \' (\'+SelectedOrder.FileCount+\')\' : \'\'): tabList.TabName}}</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Discussion"></studyactionmenu></ul></div><div class="p-8px-all pt-0"><div class="denial-window pt-5px" ng-if="DataObject.DiscussionWindowActiveTab == \'Discussion\'"><div class="fw-500"><patientdetails selected-order="SelectedOrder"></patientdetails><div ng-class="{\'useriprpht\': Status == \'IP\' || Status == \'RP\'}"><div class="d-none" ng-if="Status == \'IP\' || Status == \'RP\'"><div class="row m-0 d-flex align-item-center"><div class="mr-10px"><label class="rf-label- fs-14px mb-0 pl-2px mt-2px fw-400">Assign to:</label></div><div class="col-lg-3 col-md-3 col-sm-3 mt-1 p-0 discussion-sel tultip-bottom"><div id="kddtOrderDiscussion" class="visb-close-icon" style="width: 100%;border-color:#424242!important;background-color:#323232!important;" kendo-dropdowntree="kddtOrderDiscussion" k-options="OrderDiscussionOptions"></div><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px" style="top:33px!important; visibility:hidden;" id="OrderDiscussionAssignmentTooltip">{{orderDiscussionTooltip}}</span></div></div></div><div class="row m-0 clearfix d-none"><div class="col-md-12 form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment."> </textarea></div></div><div class="py-10px d-none"><div class="float-right px-15px discu-choose-files m-p-0"><div class="float-left px-20px m-p-0"><div class="control-fileupload"><label for="file"></label> <input class="cursor-pointer w-100 type-fileupload" type="file" id="file" name="file" multiple="" onchange="angular.element(this).scope().getFileDetails(this)" accept="application/pdf,image/jpeg,image/png,.doc, .docx, .csv, .xls, .xlsx, .ppt, .pptx"></div><span class="fs-13px fw-600 text-left txt-clr-5 d-block py-5px">Only pdf, doc, excel, ppt, png and jpg files are allowed.</span></div><div class="float-left"><input class="btn btn-primary" type="button" ng-click="uploadFiles()" value="Upload"> <button type="button" class="btn btn-primary" ng-click="SaveDiscussion()" ng-disabled="SaveDiscussionFlag">Save</button> <button type="button" class="btn btn-default" ng-click="AssignStudy()" ng-show="AssignStudyVisible" style="display:none;">Assign Study</button></div><div class="clearfix"></div></div><div class="clearfix"></div></div><div class="overflow-y-auto py-10px px-10px" ng-class="{\'discussion-height\': !halfScale, \'discussion-height-half-scale\': halfScale}"><div class=""><div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div></div></div><div class="pt-5px" ng-if="DataObject.DiscussionWindowActiveTab == \'Attachment\' && SelectedOrder.FileCount > 0 && !showDiscuss"><patientdetails selected-order="SelectedOrder"></patientdetails><div><div class="tech-dis-window mt-10px"><div class=""><attachment-viewer ng-if="DataObject.Reference.ID" dicomorder="DataObject.Reference" selected-order="SelectedOrder"></attachment-viewer></div></div></div></div></div></div></div><div class="overflow-x-hide ERA-check-detail editorder-popup p-0 overflow-y-auto" kendo-window="win_PatientInfo" k-on-open="openPatientInfo();onKendoWindowOpen()" k-on-close="isPatientInfoVisible = false;onKendoWindowClose();" k-title="\'View Order\'" k-visible="false" k-width="winPatientInfoPhyWidth" k-height="750" k-resize="winPatientInfoPhyResize" k-dragend="winPatientInfoPhyDragand" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div style="background-color:#262526!important;"><div class="spinner-overlay" ng-show="isPatientInfoLoading"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div ng-if="isPatientInfoVisible"><div class="row m-0 rf-fs-ui" style="pointer-events:none;opacity:0.7"><form name="frmPatientInfo" id="frmPatientInfo" class="mob-editorder"><div class="col-md-12 p-0"><div class="row mx-0"><div class="col-md-12"><div class="row"><div class="col-md-6 col-sm-6 col-lg-6 p-0"><div class="row mx-0 mb-5px"><div class="col-md-12"><fieldset><legend>Patient Information</legend><div class="row m-0"><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">MRN *</label> <input type="text" class="blk-input form-control" id="MRN" placeholder="MRN" ng-model="PatientInfo.PatientMRN" autocomplete="off" ng-required="true" first-char-no-space=""></div></div></div><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">DOB *</label><div class="input-group blk-calender-inpop"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="PatientDOB.DOB" is-open="isPDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="PatientDOB" placeholder="DOB(mm/dd/yyyy)" ng-required="true" first-char-no-space=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="isPDOBOpen = !isPDOBOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="row m-0"><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">Last Name *</label> <input type="text" class="blk-input form-control" id="LastName" placeholder="Last Name" ng-model="PatientInfo.PatientLastName" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">First Name *</label> <input type="text" class="blk-input form-control" id="FirstName" placeholder="First Name" ng-model="PatientInfo.PatientFirstName" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Middle Name</label> <input type="text" class="blk-input form-control" id="MiddleName" placeholder="Middle Name" ng-model="PatientInfo.PatientMiddleName" autocomplete="off" first-char-no-space=""></div></div></div><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">Sex *</label><div class="form-controller d-flex align-item-center"><label class="d-flex align-item-center mr-10px mb-0 h-30px"><input class="cmn-checkbx-input m-0" type="radio" id="male" name="gender" ng-model="PatientInfo.PatientGender" value="M" ng-required="true"> <span class="rf-label cmn-check-label">Male</span></label> <label class="d-flex align-item-center mb-0 h-30px"><input class="cmn-checkbx-input m-0" type="radio" id="female" name="gender" ng-model="PatientInfo.PatientGender" value="F" ng-required="true"> <span class="rf-label cmn-check-label">Female</span></label></div></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Phone</label> <input type="text" class="blk-input form-control" id="PatientPhone" name="PatientPhone" ng-model="PatientInfo.PatientPhone" autocomplete="off" ui-mask="(999) 999-9999" ng-minlength="10" ng-class="{\'border-color-red\': (frmPatientInfo.PatientPhone.$touched && frmPatientInfo.PatientPhone.$invalid)}"></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Email</label> <input type="text" class="blk-input form-control" id="PatientEmailID" name="PatientEmailID" ng-model="PatientInfo.PatientEmailID" autocomplete="off" placeholder="hello@example.com" ng-pattern="/[a-z0-9]+@[a-z]+\\.[a-z]{2,3}$/" ng-class="{\'border-color-red\': (frmPatientInfo.PatientEmailID.$touched && frmPatientInfo.PatientEmailID.$invalid)}"></div></div></div></div></fieldset></div></div><div class="row mx-0 mb-5px"><div class="col-md-12"><fieldset><legend>Ordering Physician</legend><div class="row m-0"><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12 tultip-bottom"><label class="rf-label">Site (Tenant) *</label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="PatientInfo.OrderingPhysicianSite" title="Select Site" ng-disabled="true" ng-required="true"><ui-select-match placeholder="Select Site" allow-clear="true">{{$select.selected.Site}} ({{$select.selected.TenantName}})</ui-select-match><ui-select-choices repeat="list in DataObject.MasterData.Sites | propsFilter: {Site: $select.search} | orderBy:\'Site\'" position="down"><span>{{list.Site}} ({{list.TenantName}})</span></ui-select-choices></ui-select></div></div><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">Last Name *</label> <input type="text" class="blk-input form-control mr-5px" placeholder="Last Name" id="OrderingPhysicianLastName" ng-model="PatientInfo.OrderingPhysicianLastName" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">First Name *</label> <input type="text" class="blk-input form-control mr-5px" placeholder="First Name" id="OrderingPhysicianFirstName" ng-model="PatientInfo.OrderingPhysicianFirstName" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Middle Name</label> <input type="text" class="blk-input form-control ordphy-lastname" placeholder="Middle Name" id="OrderingPhysicianMiddleName" ng-model="PatientInfo.OrderingPhysicianMiddleName" autocomplete="off" first-char-no-space=""></div></div></div><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label"><span>Ordering Physician *</span> <span class="cursor-pointer float-right pr-5px txt-clr-1" title="Edit Ordering Physician"><i class="cursor-pointer glyphicon glyphicon-pencil fs-11px txt-clr-14"></i> Edit</span> <span class="cursor-pointer float-right pr-10px txt-clr-1" ng-click="OpenOrderingPhysicianModal()" title="Add Ordering Physician"><i class="fa fa-plus"></i> Add</span></label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="DataObject.OrderingPhysician.Provider" title="Select Ordering Physician" ng-disabled="!(PatientInfo.OrderingPhysicianSite)" on-select="OnProviderSelected(DataObject.OrderingPhysician.Provider)"><ui-select-match placeholder="Select Ordering Physician">{{$select.selected.Name}}{{$select.selected.NPI ? \' - \' + $select.selected.NPI : \'\'}}</ui-select-match><ui-select-choices repeat="list in DataObject.MasterData.ProvidersList | propsFilter: {FirstName: $select.search, LastName: $select.search, NPI: $select.search} | orderBy:\'Name\'" position="down"><span>{{list.Name}}{{list.NPI ? \' - \' + list.NPI : \'\'}}</span></ui-select-choices></ui-select></div></div><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">NPI</label> <input type="text" class="blk-input form-control" placeholder="NPI" id="OrderingNPI" numbers-only="" maxlength="20" ng-model="PatientInfo.OrderingPhysicianNPI" autocomplete="off" first-char-no-space=""></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Phone</label> <input type="text" class="blk-input form-control" id="OrderingPhone" ui-mask="(999) 999-9999" maxlength="20" ng-model="PatientInfo.OrderingPhysicianPhone" autocomplete="off" name="OrderingPhone" ng-minlength="10" ng-class="{\'border-color-red\': (frmPatientInfo.OrderingPhone.$touched && frmPatientInfo.OrderingPhone.$invalid)}"></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Cell Phone</label> <input type="text" class="blk-input form-control" id="OrderingCellPhone" ui-mask="(999) 999-9999" maxlength="20" ng-model="PatientInfo.OrderingPhysicianCellPhone" autocomplete="off" name="OrderingCellPhone" ng-minlength="10" ng-class="{\'border-color-red\': (frmPatientInfo.OrderingCellPhone.$touched && frmPatientInfo.OrderingCellPhone.$invalid)}"></div></div></div></div></fieldset></div></div><div class="row mx-0 mb-5px" ng-if="isAssignAllowed(PatientInfo.Status)"><div class="col-md-12"><fieldset><legend>Order Assignment</legend><div class="row mb-15px mx-0 d-flex align-item-center flex-nowrap"><div class="col-md-2"><label class="rf-label fs-13px">Assign to:</label></div><div class="col-md-10 mt-1 p-0 discussion-sel tultip-bottom" style="flex: 1; max-width: 450px;"><div id="kddtOrderDiscussion" class="visb-close-icon" style="width: 100%; border-color: #424242 !important; background-color: #a7a7a7 !important; border-radius: 4px !important;" kendo-dropdowntree="kddtOrderDiscussion" k-options="OrderDiscussionOptions"></div><span class="tultiptext text-preline overflow-auto text-left tt-white sl-hsw-180px" style="top:33px!important; max-height:80px; visibility:hidden;" id="OrderDiscussionAssignmentTooltip">{{orderDiscussionTooltip}}</span></div></div></fieldset></div></div></div><div class="col-md-6 col-sm-6 col-lg-6 p-0"><div class="row m-0"><div class="col-md-12"><fieldset><legend>Order Infomation</legend><div class="row mb-5px mx-0"><div class="col-md-4 mb-5px"><label class="rf-label">Location *</label><ui-select skip-focusser="true" class="mult-select mob-closekeypad" ng-model="PatientInfo.SelectedLocation" ng-required="true"><ui-select-match placeholder="Select Location">{{$select.selected.Location}}</ui-select-match><ui-select-choices repeat="list in LocationBySite | propsFilter: {Location: $select.search}" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-4 mb-5px"><label class="rf-label">Accession</label> <input type="text" class="blk-input form-control" id="Accession" placeholder="Accession" ng-model="PatientInfo.Accession" autocomplete="off" disabled=""></div><div class="col-md-4 mb-5px"><label class="rf-label">Patient Class</label><ui-select skip-focusser="true" class="mult-select b-clr bg-clr-31 mob-closekeypad" ng-model="PatientInfo.SelectedPatientClass" title="Select Patient Class"><ui-select-match placeholder="Select Patient Class" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PatientClass | propsFilter: {Value: $select.search}" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row mx-0 d-flex statdatetime-row"><div class="col-lg-4 col-md-4 col-sm-6 col-xs-4 dos-p mb-5px"><label class="rf-label">DOS *</label><div class="input-group blk-calender-inpop"><input type="text" ng-required="true" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="PatientInfo.DOS" is-open="isPDOSOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" enable-time="true" name="OrderDate" placeholder="DOS(mm/dd/yyyy)" first-char-no-space=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="isPDOSOpen = !isPDOSOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-3 sm-pl-0px mb-5px"><uib-timepicker class="rf-timepick rf-techform-tpckr" style="margin:-10px auto auto auto" id="FromTime" name="FromTime" ng-model="PatientInfo.DOSTime" hour-step="hstep" minute-step="mstep" show-meridian="false"></uib-timepicker></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-4 mb-5px stststrktrm d-none"><div class="form-controller mt-2 d-flex align-item-center mr-20px"><input type="checkbox" class="m-0 cmn-checkbx-input" id="STAT" ng-model="PatientInfo.IsSTAT" autocomplete="off" ng-click="IsSTATChecked()"> <label for="STAT" class="rf-label cmn-check-label">STAT</label></div><div class="form-controller mt-2 d-flex align-item-center mr-20px" ng-style="{\'cursor\': !PatientInfo.IsSTAT ? \'not-allowed\': \'pointer\'}"><input type="checkbox" class="m-0 cmn-checkbx-input" id="STATStroke" ng-model="PatientInfo.IsSTATStroke" autocomplete="off" ng-disabled="!PatientInfo.IsSTAT"> <label for="STATStroke" class="rf-label cmn-check-label">Stroke</label></div><div class="form-controller mt-2 d-flex align-item-center" ng-style="{\'cursor\': !PatientInfo.IsSTAT ? \'not-allowed\': \'pointer\'}"><input type="checkbox" class="m-0 cmn-checkbx-input" id="STATTrauma" ng-model="PatientInfo.IsSTATTrauma" autocomplete="off" ng-disabled="!PatientInfo.IsSTAT"> <label for="STATTrauma" class="rf-label cmn-check-label">Trauma</label></div></div></div><div class="row mb-5px mx-0"><div class="col-md-6"><label class="rf-label mb-0">Priority</label><div class="form-controller d-flex align-item-center"><label class="d-flex align-item-center mr-10px mb-0 h-30px" ng-repeat="priority in DataObject.StudyPriorities| orderBy:\'Priority\'"><input class="cmn-checkbx-input m-0" type="radio" id="{{priority.Priority}}" name="priority" ng-model="PatientInfo.DelayedSTAT" value="{{priority.Key}}" ng-click="PatientInfo.DelayedSTAT == 2 ? IsSTATChecked() : null" ng-disabled="priority.Key == 1"> <span class="rf-label cmn-check-label">{{priority.Priority}}</span></label></div></div><div class="col-md-6" ng-if="PatientInfo.DelayedSTAT == 2"><label class="rf-label mb-0">STAT</label><div class="form-controller d-flex align-item-center"><div class="form-controller mt-2 d-flex align-item-center mr-20px" ng-style="{\'cursor\': PatientInfo.DelayedSTAT != 2 ? \'not-allowed\': \'pointer\'}"><input type="checkbox" class="m-0 cmn-checkbx-input" id="STATStroke" ng-model="PatientInfo.IsSTATStroke" autocomplete="off" ng-disabled="PatientInfo.DelayedSTAT != 2"> <label for="STATStroke" class="rf-label cmn-check-label">Stroke</label></div><div class="form-controller mt-2 d-flex align-item-center" ng-style="{\'cursor\': PatientInfo.DelayedSTAT != 2 ? \'not-allowed\': \'pointer\'}"><input type="checkbox" class="m-0 cmn-checkbx-input" id="STATTrauma" ng-model="PatientInfo.IsSTATTrauma" autocomplete="off" ng-disabled="PatientInfo.DelayedSTAT != 2"> <label for="STATTrauma" class="rf-label cmn-check-label">Trauma</label></div></div></div></div><div class="row mb-5px mx-0"><div class="col-lg-2 col-md-4 col-sm-12 col-xs-12 mb-5px"><label class="rf-label">Modality *</label><ui-select skip-focusser="true" class="mult-select mob-closekeypad" ng-model="PatientInfo.Modality" ng-required="true"><ui-select-match placeholder="Select Modalities">{{$select.selected.Code}}</ui-select-match><ui-select-choices repeat="list in Modalities | propsFilter: {Code: $select.search}" position="down"><div ng-bind-html="list.Code | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-5px"><label class="rf-label">Procedure Code</label> <input type="text" class="blk-input form-control" id="ProcedureCode" placeholder="Procedure Code" ng-model="PatientInfo.CPTProcedures" autocomplete="off" first-char-no-space=""></div><div class="col-lg-6 col-md-4 col-sm-12 col-xs-12 mb-5px"><label class="rf-label">Procedure Desc *</label> <input type="text" class="blk-input form-control" placeholder="Procedure Desc" id="ProcedureDesc" ng-model="PatientInfo.CPTProcedureDesc" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-5px mx-0"><div class="col-md-6 mb-5px"><label class="rf-label">Contrast</label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="PatientInfo.ContrastType"><ui-select-match allow-clear="false">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in SiteContrastList | filter: {Value: $select.search}" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6 mb-5px"><label class="rf-label">Contrast Amount</label> <input type="text" class="blk-input form-control" placeholder="Contrast Amount" id="OrderingPhysician" ng-model="PatientInfo.ContrastAmount" autocomplete="off" ng-disabled="!PatientInfo.ContrastType" first-char-no-space=""></div></div><div class="row mb-5px mx-0"><div class="col-md-12"><label class="rf-label">Reason *</label><textarea class="txt-area h-65px w-100 py-6px px-12px" ng-model="PatientInfo.Reason" placeholder="Reason for exam" ng-required="true"> </textarea></div></div><div class="row mb-5px mx-0"><div class="col-md-12"><label class="fs-14px fw-500">Comment</label><textarea class="txt-area h-75px w-100 py-6px px-12px" ng-model="PatientInfo.Comment" placeholder="Add a comment"> </textarea></div></div><div class="row mb-5px mx-0"><div class="col-md-12"><label class="rf-label k-display-inline-block">Technique</label><div class="d-inline-block float-right"><span class="cursor-pointer pr-5px" ng-click="addNewTechnique()" title="Add New Technique"><i class="fa fa-plus"></i> Add</span> <span class="cursor-pointer" ng-click="selectTechnique()" title="Search Technique"><i class="fa fa-search"></i> Search</span></div><div class="clearfix"></div><textarea class="txt-area h-95px w-100 py-6px px-12px" ng-model="PatientInfo.TechniqueValue" placeholder="Add a technique"> </textarea></div></div><div class="row mb-5px mx-0 d-none"><div class="col-md-12"><div class="w-80 float-left"><div class="control-fileupload"><label for="file"></label> <input class="cursor-pointer w-100 type-fileupload" type="file" id="file" name="file" multiple="" onchange="angular.element(this).scope().getFileDetails(this)" accept="application/pdf,image/jpeg,.doc, .docx, .csv, .xls, .xlsx, .ppt, .pptx"></div><span class="fs-13px fw-600 text-left txt-clr-5 d-block pt-5px lh-1">Only pdf, doc, excel, ppt, png and jpg files are allowed.</span></div><div class="w-20 float-left text-right"><input class="btn btn-primary" type="button" ng-click="uploadFiles()" value="Upload"></div><div class="clearfix"></div></div></div></fieldset></div></div></div></div></div></div><div class="row mx-0 d-none"><div class="col-md-12 text-right mt-10px"><button type="button" class="btn btn-default mb-5px" ng-if="PatientInfo.IsPatientWallet" ng-click="sendInvite((frmPatientInfo.PatientEmailID.$touched && frmPatientInfo.PatientEmailID.$invalid),(frmPatientInfo.PatientPhone.$touched && frmPatientInfo.PatientPhone.$invalid))" ng-disabled="!(PatientInfo.PatientFirstName && PatientInfo.PatientLastName && PatientInfo.DOS) || SendInvite">Send Invite</button> <button class="btn btn-default mb-5px" data-dismiss="modal" ng-click="closePatientInfo()">Cancel</button> <button class="btn btn-primary mb-5px" style="background-color:#38dec4!important;" ng-click="BtnOrderComplete(frmPatientInfo.$valid)" ng-if="PatientInfo.OrderStatusID==1">Order Complete</button> <button class="btn btn-primary savebt mb-5px" ng-disabled="(frmPatientInfo.PatientPhone.$touched && frmPatientInfo.PatientPhone.$invalid) || (frmPatientInfo.OrderingPhone.$touched && frmPatientInfo.OrderingPhone.$invalid) || (frmPatientInfo.PatientEmailID.$touched && frmPatientInfo.PatientEmailID.$invalid)" ng-click="BtnSaveOrder(frmPatientInfo.$valid)">Save</button></div></div></div></form></div></div></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_HelpOrder" k-on-open="isHelpOrderVisible = true;onKendoWindowOpen()" k-on-close="isHelpOrderVisible = false;onKendoWindowClose()" k-title="\'Help Order\'" k-visible="false" k-width="win_HelpOrderWidth" k-height="650" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isHelpOrderVisible"><div class="denial-window"><div class="row card-bg-white denial-window-head p-5px-all m-5px-all fw-600"><div class="col-md-3"><div><span class="report_span_title">Location :</span> <span class="report_span">{{SelectedOrder.Location}}</span></div><div><span class="report_span_title">Gender :</span> <span class="report_span">{{SelectedOrder.PatientGender}}</span></div><div><span class="report_span_title">Ordering Physician :</span> <span class="report_span">{{SelectedOrder.OrderingPhysician}}</span></div></div><div class="col-md-3"><div><span class="report_span_title">DOS :</span> <span class="report_span">{{(SelectedOrder.OrderDate) ? (SelectedOrder.OrderDate | date:\'M/d/yy HH:mm\').toString().replace("00:00","") : \'\'}}</span></div><div><span class="report_span_title">Type :</span> <span class="report_span">{{SelectedOrder.PatientClass}}</span></div></div><div class="col-md-3"><div><span class="report_span_title">Patient Name :</span> <span class="report_span">{{SelectedOrder.PatientName}}</span></div><div><span class="report_span_title">Modality :</span> <span class="report_span">{{SelectedOrder.Modality}}</span></div></div><div class="col-md-3"><div><span class="report_span_title">DOB :</span> <span class="report_span">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span></div><div><span class="report_span_title">Procedure :</span> <span class="report_span">{{SelectedOrder.ProcedureDesc}}</span></div><div><button type="button" ng-show="ODType==\'Helper\'" class="btn cmn-btn btn-primary h-30px px-10px fs-13px pull-right" ng-click="CloseOrderDiscussion()">Close Discussion</button></div></div><div class="row"></div><hr><div class="col-lg-3 col-md-3 col-sm-6 mb-8px" ng-hide="Ishelper"><ui-select ng-model="OrderDiscussion.SelectedUser" theme="bootstrap" class="fs-14px dicom-inp-w form-border" style="width: 40%;" ng-disabled="OrderDiscussion.ID"><ui-select-match allow-clear="true" placeholder="Select Radiologist">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices repeat="list in Radiologists | filter: isVisibleRad | filter: {FirstName: $select.search, LastName: $select.search} | orderBy:\'LastName\'"><div class="inst-selectBox" ng-bind-html="radDisplay(list) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-12 form-group mb-10px" ng-hide="Ishelper"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment."> </textarea></div><div class="pull-right" ng-hide="Ishelper"><button type="button" class="btn cmn-btn btn-primary h-30px px-10px fs-13px" ng-click="SaveOrderDiscussion()">Save</button></div><div class="pull-right" ng-show="Ishelper"><button type="button" class="btn cmn-btn btn-primary h-30px px-10px fs-13px" ng-click="CloseOrderDiscussion()">Close Discussion</button></div><div class="h-10px"></div><div class="max-h-43vh overflow-x-auto p-10px-all bg-clr-12"><div class=""><div class="w-100" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0 report-popup px-5px" kendo-window="win_ViewReport" k-on-open="isViewReportVisible = true;onKendoWindowOpen()" k-on-close="isViewReportVisible = false;onKendoWindowClose()" k-title="\'Report\'" k-modal="true" k-visible="false" k-width="winViewReportPhyWidth" k-height="defaultWindowHeight" k-resize="winViewReportPhyResize" k-dragend="winViewReportPhyDragand" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isViewReportVisible"><div class="denial-window"><div class=""><div><report-viewer ng-if="selecteReportId" source-id="selecteReportId"></report-viewer></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0" kendo-window="win_ViewTechnique" k-on-open="isViewTechniqueVisible = true;onKendoWindowOpen()" k-on-close="isViewTechniqueVisible = false;onKendoWindowClose()" k-title="\'Technique\'" k-visible="false" k-width="win_ViewTechniqueWidth" k-height="win_ViewTechniqueHeight" k-modal="true" k-animation="false" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isViewTechniqueVisible"><div class="denial-window"><div class="fw-500"><div class="col-sm-12 col-md-12"><div class="mx-10px float-right"><button ng-click="AddTechnique()" class="btn btn-primary btn-sm adnewbtn">Add New</button></div></div><div class="col-sm-12 col-md-12 mob-p-0"><div class="charges-list bg-clr-27"><table ng-table="tableParams" class="table pos-rel wh-table table-scroll technique-table"><tbody class="h-400px"><tr class="side-message-navigation-item little-human shineHover data-row" ng-repeat="row in $data track by $index"><td class="w-20 text-left" data-title="\'Technique Key\'" filter="{ Key: \'text\'}" sortable="\'Key\'">{{row.Key}}</td><td class="w-70 text-left" data-title="\'Technique Value\'" filter="{ Value: \'text\'}" sortable="\'Value\'">{{row.Value}}</td><td class="w-10 text-right"><button ng-click="SelectTechniqueValue(row.Value)" class="btn btn-primary btn-sm selbtn">Select</button></td></tr></tbody></table></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0" kendo-window="win_AddTechnique" k-on-open="isAddTechniqueVisible = true;onKendoWindowOpen()" k-on-close="isAddTechniqueVisible = false;onKendoWindowClose()" k-title="\'Add Technique\'" k-visible="false" k-width="500" k-height="350" k-animation="false" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isAddTechniqueVisible"><div class="denial-window"><div><form id="frmFilter" ng-submit="SubmitTechnique(frmFilter.$valid,TechniqueKey,TechniqueValue)"><div class="fw-500 row py-15px"><div class="col-sm-12 col-md-12 mb-15px"><label class="rf-label">Key Code</label> <input type="text" class="blk-input form-control" placeholder="Key code" id="TechniqueKey" name="TechniqueKey" ng-model="TechniqueKey" autocomplete="off" ng-required="true" first-char-no-space=""></div><div class="col-sm-12 col-md-12"><label class="rf-label">Value</label><textarea class="txt-area h-150px w-100 p-5px-all" ng-model="TechniqueValue" id="TechniqueValue" name="TechniqueValue" placeholder="Key value" ng-required="true"> </textarea></div><div class="col-sm-12 col-md-12"><div class="py-10px"><label class="rf-label"></label><button ng-click="CancelTechnique()" class="btn btn-default">Cancel</button> <button class="btn btn-primary">Save</button></div></div></div></form></div></div></div></div><script id="dropdowntree-orderdiscussion-template" type="text/kendo-ui-template"># if (item.Group && item.Group == "YES") { # #: item.UserName # # } else { # <i class="fa fa-circle #: item.IsOnline ? \'text-success\' : \'text-gray-dark\' #"></i> #: item.UserName # # } #</script><div class="overflow-hide-all ERA-check-detail" kendo-window="win_TechForm" k-on-open="isTechFormVisible = true;onKendoWindowOpen()" k-on-close="isTechFormVisible = false;onKendoWindowClose()" k-title="\'Tech Form\'" k-visible="false" k-width="win_HelpOrderWidth" k-animation="false" k-height="650" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isTechFormVisible"><div class="denial-window"><iframe id="tempid" style="width:100%;height:500px;position:absolute;top:-1000px;"></iframe><div id="CONCLUSION"></div><div id="divTechForm"></div><div class="py-10px"><div class="float-right px-15px mob-pl0 discu-choose-files"><div class="float-left"><button type="button" class="btn btn-primary" ng-click="SetOrdersTechForm()">Save</button> <button type="button" class="btn btn-default" ng-click="CloseTechForm()">Cancel</button> <button type="button" class="btn btn-default" ng-click="ReloadTechForm()">Reload</button></div><div class="clearfix"></div></div><div class="clearfix"></div></div></div></div></div><div class="modal fade" id="ModalPhysicianWorkList" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog create-filter"><div class="modal-content py-20px px-0" style="border-radius:4px;background-color:#2c2c2c;"><div class=""><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary mr-10px d-none" ng-click="createTechnoWorkList()">Create Filter</button> <button type="button" class="btn btn-primary mr-10px" ng-click="saveFilterOnly()">Save Filter Only</button> <button type="button" class="btn btn-default mr-10px" data-dismiss="modal">Cancel</button></div></div></div></div></div></div><script>\r\n    function setDirty() {\r\n\r\n    }\r\n</script><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs comp-innotab px-0 py-0" kendo-window="win_consultExamsWindow" k-on-open="isConsultExamsWindow = true;onKendoWindowOpen();windowOpened(win_consultExamsWindow)" k-on-close="isConsultExamsWindow = false;onKendoWindowClose();windowClosed(win_consultExamsWindow)" k-title="\'Consult Exams\'" k-modal="true" k-visible="false" k-animation="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isConsultExamsWindow"><div class="row mx-0"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Consult Exams</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Consult with Physician"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><videocallconsult class="clearfix video-call-consult" on-send="setUserChat" selected-order="SelectedOrder" check="isConsultExamsWindow" on-close="onCloseConsultExamWindowHandler(check)"></videocallconsult></div></div></div></div></div><script type="text/ng-template" id="tree_item_renderer.html"><div> <div> <div class="fs-13px text-break-word bg-clr-29 bor-rad-5px p-15px-all"> <p style="white-space:pre-line">{{Dis.Comment | htmlDecode}}</p> </div> <div class="float-right py-5px"> <div class="tultip-top float-left"> <a class="btn btn-default glyphicon glyphicon-share-alt border-0 d-none" ng-click="Dis.IsChild=!Dis.IsChild"></a> <span class="tultiptext">Reply</span> </div> <div class="float-left pt-3px"> <span class="txt-clr-1 fs-15px" ng-if="disName(Dis)">{{disName(Dis) | htmlDecode}}</span> <span class="txt-clr-2 fs-12px">{{Dis.Record_Created_At|date :\'medium\' }}</span> </div> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div ng-show="Dis.IsChild"> <div class="mb-10px w-70 pull-right"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Dis.ChildComment" placeholder="Add a comment."> </textarea> </div> <div class="clearfix"></div> <div class="mb-10px"> <button type="button" class="btn btn-primary pull-right" ng-click="SaveChildDiscussion(Dis)">Save</button> <div class="clearfix"></div> </div> </div> </div> <div class="clearfix"></div> </div> <ul style="list-style:none"> <li class="mb-10px" ng-repeat="Dis in Dis.Childs" ng-include="\'tree_item_renderer.html\'"></li> </ul></script><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs comp-innotab px-0 py-0" kendo-window="win_addendum_request" k-on-open="showAddendumReq = true;onKendoWindowOpen();windowOpened(win_addendum_request)" k-on-close="onAddendumReqClose();onKendoWindowClose();windowClosed(win_addendum_request)" k-title="\'Addendum Request\'" k-modal="true" k-visible="false" k-animation="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="showAddendumReq"><div class="row mx-0"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Addendum Request</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Addendum Request" selected-order="SelectedOrder"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-0"><div class="col-md-12 mb-10px px-0 txt-clr-1 sm-mt-10px"><div class="d-flex align-item-center toggle-div pt-10px pb-10px"><div class="w-400px"><ui-select class="mult-select" ng-model="AddendumRequest.AssignedUser" tooltip-class="uibtooltipDenial" uib-tooltip="{{AddendumRequest.AssignedUserTooltip}}" tooltip-placement="auto top" on-select="onAddendumUserSelect()"><ui-select-match placeholder="Select Radiologist" allow-clear="true">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices style="max-height:150px !important;" repeat="list in Radiologists | filter: isVisibleRad | filter: $select.search" position="down"><div ng-bind-html="radDisplay(list) | highlight: $select.search"></div><small><span class="d-block" ng-if="list.Email"><i class="fa fa-envelope pr-4px"></i>{{list.Email}}</span> <span class="d-block" ng-if="list.PhoneNumber"><i class="fa fa-phone-square pr-4px"></i>{{list.PhoneNumber}}</span></small></ui-select-choices></ui-select></div><label class="rf-label mb-0 ml-20px">High Priority</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="AddendumRequest.isHighPriorityAddendum"> <span class="checkbox-switch-slider round"></span></label></div></div></div><div class="col-md-12 p-0 clearfix"><label class="fw-400">Reason *</label> <textarea class="txt-area mt-1 h-70px w-100 p-5px-all" ng-model="AddendumRequest.AddendumComment" placeholder="Reason for Addendum Request (Required)"> </textarea></div><div class="col-md-12 p-0 clearfix"><button type="button" class="btn btn-primary mt-10px mb-10px pull-right" ng-click="UpdateAddendumRequestReportStatus()" ng-disabled="!(AddendumRequest.AssignedUser && AddendumRequest.AddendumComment)">Send Request</button></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs" kendo-window="win_peer_review" k-on-open="showPeerReview = true;onKendoWindowOpen();windowOpened(win_peer_review)" k-on-close="onPeerReviewClose();onKendoWindowClose();windowClosed(win_peer_review)" k-title="\'Peer Review\'" k-modal="true" k-visible="false" k-animation="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="showPeerReview"><div class="row px-10px mx-0"><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Peer Review"></studyactionmenu><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-0"><div class="col-md-12 mb-10px px-0 txt-clr-1 sm-mt-10px"><div class="d-flex align-item-center toggle-div pt-10px pb-10px"><div class="w-400px"><ui-select class="mult-select" ng-model="PeerReview.AssignedUser" tooltip-class="uibtooltipDenial" uib-tooltip="{{PeerReview.AssignedUserTooltip}}" tooltip-placement="auto top" on-select="onPeerReviewUserSelect()"><ui-select-match placeholder="Select Radiologist" allow-clear="true">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices style="max-height:150px !important;" repeat="list in PeerReviewRadiologists | filter: $select.search" position="down"><div ng-bind-html="radDisplay(list) | highlight: $select.search"></div><small><span class="d-block" ng-if="list.Email"><i class="fa fa-envelope pr-4px"></i>{{list.Email}}</span> <span class="d-block" ng-if="list.PhoneNumber"><i class="fa fa-phone-square pr-4px"></i>{{list.PhoneNumber}}</span></small></ui-select-choices></ui-select></div></div></div><div class="col-md-12 p-0 clearfix"><textarea class="txt-area mt-1 h-70px w-100 p-5px-all" ng-model="PeerReview.Comment" placeholder="Reason for Peer Review (Optional)"> </textarea></div><div><button type="button" class="btn btn-primary mt-10px pull-right" ng-click="AddOrderToSpecificPeer()" ng-disabled="!(PeerReview.AssignedUser)">Send Request</button></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup ord-eve-logs" kendo-window="win_query_retrive" k-on-open="DataObject.onQueryRetrive = true;onKendoWindowOpen();windowOpened(win_query_retrive)" k-on-close="DataObject.onQueryRetrive = false;onKendoWindowClose();windowClosed(win_query_retrive)" k-title="\'Query Retrieve\'" k-modal="true" k-visible="false" k-animation="false" k-width="winAddendumReqWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div class="container-fluid" ng-if="DataObject.onQueryRetrive"><form ng-submit="QueryRetrieveFilter(true)"><div class="row"><div class="col-sm-3 col-md-2 col-xs-6 pd-lr tultip-bottom pl-0 mb-5px">First Name <input ng-model="DataObject.QueryRetrieve.FirstName" type="text" class="blk-input form-control col-placeholder" placeholder="First Name" tooltip-class="uibtooltipDenial" uib-tooltip="First Name" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr pl-0 mb-5px">Last Name <input ng-model="DataObject.QueryRetrieve.LastName" type="text" class="blk-input form-control col-placeholder" placeholder="Last Name" tooltip-class="uibtooltipDenial" uib-tooltip="Last Name" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-pr-0 pl-0 mb-5px">MRN <input ng-model="DataObject.QueryRetrieve.PatientMRN" type="text" class="blk-input form-control col-placeholder" placeholder="MRN" tooltip-class="uibtooltipDenial" uib-tooltip="MRN" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-pr-0 pl-0 mb-5px">Accession <input ng-model="DataObject.QueryRetrieve.Accession" type="text" class="blk-input form-control col-placeholder" placeholder="Accession" tooltip-class="uibtooltipDenial" uib-tooltip="Accession" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-pr-0 pl-0 mb-5px">DOS <input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="DataObject.QueryRetrieve.OrderDate" options="DataObject.QueryRetrieve.opts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial" uib-tooltip="{{DataObject.QueryRetrieve.toolTipOrderDate}}" tooltip-placement="auto top" ng-mouseenter="resetQueryRetrieveDateRange()" datepicker-append-to-body="true"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-w-50 filt-btn-sec mob-pr-0 px-0 mt-20px pl-0 mb-5px"><button type="submit" class="btn btn-primary pull-left rf-btn-xs pb-6px" ng-disabled="DataObject.QueryRetrieve.IsSearchingData">Search</button> <button type="button" ng-click="ClearQueryRetrieve()" class="btn btn-default pull-left ml-2 rf-btn-xs pb-6px">Clear</button></div></div></form></div><div ng-if="DataObject.onQueryRetrive" class="mt-20px"><div class="row mb-5px"><div class="col-md-12 d-flex justify-content-end"><div class="d-flex align-item-center toggle-div p-6px-all" style="border-right: 1px solid #0c6c5e;"><label class="rf-label mb-0">Expand All</label> <label class="checkbox-switch pref-checkbox ml-5px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.QueryRetrieve.IsExpanded" ng-click="ExpandCollapseData(DataObject.QueryRetrieve.IsExpanded)" ng-disabled="DataObject.QueryRetriveObj.patients.length == 0"> <span class="checkbox-switch-slider round"></span></label></div><div class="d-flex align-item-center toggle-div p-6px-all ml-5px" style="border-right: 1px solid #0c6c5e;"><label class="rf-label mb-0">Select All Studies</label> <label class="checkbox-switch pref-checkbox ml-5px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.QueryRetrieve.IsAllStudySelected" ng-click="ExpandCollapseData(DataObject.QueryRetrieve.IsAllStudySelected,true)" ng-disabled="DataObject.QueryRetriveObj.patients.length == 0"> <span class="checkbox-switch-slider round"></span></label></div><button type="button" class="btn btn-primary rf-btn-xs mr-5px ml-10px" title="Retrieve" ng-disabled="DataObject.QueryRetrieve.IsRetrieveBtnDisabled || DataObject.QueryRetriveObj.patients.length == 0" ng-click="MoveInstance()">Retrieve</button></div></div><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="DataObject.isLoadingQueryRetrieve"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div id="myQueryGrid" class="myGrid ag-theme-balham-dark query-grid" style="height: 500px"></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0 report-popup report-rate-modal px-5px comp-innotab px-0 py-0" kendo-window="win_ComparisonOrderReports" k-on-open="isComparisonOrderReportsVisible = true;winOpen();windowOpened(win_ComparisonOrderReports);DataObject.IsStudyRatingWindowVisible = false" k-on-close="isComparisonOrderReportsVisible = false;winComparisonOrderReports_OnClose();onClearFilterReportList(true);windowClosed(win_ComparisonOrderReports);DataObject.IsStudyRatingWindowVisible=false" k-title="\'Report\'" k-modal="true" k-visible="false" k-width="DataObject.defaultWindowWidth" k-height="defaultWindowHeight" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isComparisonOrderReportsVisible"><div class=""><div class=""><div class="row mb-20px m-0"><div class="col-md-12 p-0"><div class="" ng-if="!DataObject.ShowReportModal"><div class="" id="{{OrderReport.OrderID}}"><div class="mob-report"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Report</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Report"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="ReportSelectedOrder"></patientdetails><div class="rprtdscn-fbtns-wrapper d-flex align-item-center p-5px-all px-10px"><div class="w-100"><div class="d-inline-block" ng-if="SelectedOrder.Rating && OrderReport.Accession == SelectedOrder.Accession" title="{{(SelectedOrder.Comments)?SelectedOrder.Comments:(SelectedOrder.Rating +\' Star\')}}"><label class="d-inline-block fw-500 mr-2px">Report Rating:</label> <span ng-repeat="num in [1,2,3,4,5]"><span ng-class="(num <= SelectedOrder.Rating)?\'fa fa-star txt-clr-14\':\'fa fa-star-o txt-clr-2\'"></span></span></div><button type="button" ng-if="SelectedOrder.Status == \'C\' && OrderReport.Accession == SelectedOrder.Accession && !SelectedOrder.Rating" class="btn btn-primary rf-btn-xs pull-right" ng-click="HideShowRateReportAction()">Rate Report</button></div></div><div class="row m-0"><div class="m-0 wlh-pdf" ng-class="(DataObject.IsStudyRatingWindowVisible && !SelectedOrder.Rating) && OrderReport.Accession == SelectedOrder.Accession? \'col-lg-9 col-sm-9 col-xs-9 pl-0 pr-10px\' : \'col-lg-12 col-sm-12 col-xs-12 px-0\'"><div class="w-100" ng-if="report.DictationValue"><div class="w-100 overflow-y-auto overflow-x-hide py-10px bg-clr-49" ng-class="SelectedOrder.Status == \'C\' ? \'repoheight-2 rprtsinglwrklst px-10px repoHeiFtrWrklst\' : \'repoheight-1 px-15px reportmaxwin\'"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="width:100%; display:block; line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div><div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0" ng-if="DataObject.IsStudyRatingWindowVisible && OrderReport.Accession == SelectedOrder.Accession && !SelectedOrder.Rating"><div class="w-100 pt-10px pb-0 px-0"><div class="col-md-12 mb-10px px-0 txt-clr-1 sm-mt-10px"><div class="toggle-div pl-5px pt-10px pb-5px"><label class="fw-400">Please rate the quality of this report.</label><div class="w-400px mt-10px rating-star fs-20px"><span uib-rating="" ng-model="DataObject.StudyRating.Ratings" max="5" read-only="false"></span> <span class="fs-12px txt-clr-2 stars-text pb-5px" ng-if="!DataObject.StudyRating.Ratings">Click to rate (1\u20135 stars)</span></div></div></div><div class="col-md-12 p-0 clearfix"><textarea class="txt-area mt-1 h-70px w-100 p-5px-all" ng-model="DataObject.StudyRating.Comment" placeholder="Additional comments (optional)"> </textarea></div><div class="pb-10px pull-right"><button type="button" class="btn btn-default rf-btn-xs mt-10px" ng-click="ReReadStudy()" ng-if="DataObject.StudyRating.Ratings>0 && DataObject.StudyRating.Ratings<=3">Request Re-Read</button> <button type="button" class="btn btn-primary rf-btn-xs mt-10px" ng-click="AddStudyRatings()" ng-disabled="!DataObject.StudyRating.Ratings">Submit Ratings</button></div></div></div></div></div></div></div></div><div class="m-0" ng-if="DataObject.ShowReportModal"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Report</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Report"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="ReportSelectedOrder"></patientdetails><div class="rprtdscn-fbtns-wrapper d-flex align-item-center justify-content-between p-5px-all px-10px"><div class="d-flex align-item-center"><div class="width-100 mr-15px"><input type="text" class="blk-input form-control col-placeholder h-25px input-filterreport" placeholder="Search" ng-model="DataObject.SearchText" ng-keyup="FilterReportList(true)"></div><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap mr-15px"><li class="pos-rel align-self-center mr-15px"><a class="border-0 btnpopover-sorting bor-rad-2px py-4px px-4px fs-10px text-center" ng-click="DataObject.displaySortPopover = true" uib-tooltip="{{DataObject.SelectedSortingOption}}" tooltip-placement="top" ng-style="DataObject.displaySortPopover == true ? {\'background-color\':\'#05c1a4\'} : {\'background-color\': \'rgba(5, 193, 164, 0.19);\'}"><i class="fa fa-sort-amount-asc" aria-hidden="true"></i></a><div class="popover-sorting p-5px-all bor-rad-2px" ng-show="DataObject.displaySortPopover" ng-mouseleave="DataObject.displaySortPopover = false"><a class="popover-sorting-item d-block p-5px-all cursor-pointer fs-12px fw-400 txt-clr-1" ng-repeat="list in DataObject.ReportSortingOptions" ng-class="{\'active\' : list == DataObject.SelectedSortingOption}" ng-click="onReportSortingClicked(list)">{{list}}</a></div></li><li class="text-center" ng-repeat="list in DataObject.ReportList.DateRange" ng-class="{\'active\' : DataObject.ReportListFilter.DateRange == list}" ng-click="DataObject.ReportListFilter.DateRange=list;FilterReportList(true)"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap"><li class="text-center" ng-repeat="list in DataObject.ReportList.Modalities track by $index" ng-class="{\'active\' : DataObject.ReportListFilter.Modality == list}" ng-click="DataObject.ReportListFilter.Modality=list;FilterReportList(true)"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul></div><div ng-if="SelectedOrder.Rating && OrderReport.Accession == SelectedOrder.Accession" title="{{(SelectedOrder.Comments)?SelectedOrder.Comments:(SelectedOrder.Rating +\' Star\')}}"><label class="d-inline-block fw-500 mr-2px">Report Rating:</label> <span ng-repeat="num in [1,2,3,4,5]"><span ng-class="(num <= SelectedOrder.Rating)?\'fa fa-star txt-clr-14\':\'fa fa-star-o txt-clr-2\'"></span></span></div><div class="d-inline-block pull-right"><button type="button" ng-if="SelectedOrder.Status == \'C\' && OrderReport.Accession == SelectedOrder.Accession && !SelectedOrder.Rating" class="btn btn-primary rf-btn-xs" ng-click="HideShowRateReportAction()">Rate Report</button></div></div><div class="row m-0"><div class="col-lg-2 col-sm-2 col-xs-3 m-0 pl-0 pr-0 pr-5px bg-clr-49"><div class="overflow-auto repoheight-2 repoHeiFtrWrklst ftlrbtns-height"><div ng-repeat="r in reportList | orderBy: DataObject.ReportSortingPropName : DataObject.ReportSortingRevOrder track by $index" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #959595 1px solid;cursor:pointer; word-wrap: break-word !important;">{{r.ProcedureDesc}}<div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}">DOS : {{r.FormattedOrderDate | date:\'MM/dd/yyyy\'}}</div><span ng-if="signByDisplay(r)">{{signByDisplay(r)}}</span> {{r.Location}}</div></div></div><div class="m-0 wlh-pdf pl-0" id="{{OrderReport.OrderID}}" ng-class="(DataObject.IsStudyRatingWindowVisible && !SelectedOrder.Rating) && OrderReport.Accession == SelectedOrder.Accession? \'col-lg-7 col-sm-7 col-xs-9\' :\'col-lg-10 col-sm-10 col-xs-9\'"><div class="row 100 ng-scope ml-0" ng-if="report.DictationValue && reportList.length > 0"><div class="w-100 repoheight-2 rprtsinglwrklst overflow-y-auto overflow-x-hide py-10px px-10px bg-clr-49 repoHeiFtrWrklst"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div><div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 pl-10px pr-0" ng-if="(DataObject.IsStudyRatingWindowVisible && !SelectedOrder.Rating) && OrderReport.Accession == SelectedOrder.Accession"><div class="w-100 pt-10px pb-0 px-0"><div class="col-md-12 mb-10px px-0 txt-clr-1 sm-mt-10px" ng-if="!SelectedOrder.Rating"><div class="toggle-div pl-5px pt-10px pb-5px"><label class="fw-400">Please rate the quality of this report.</label><div class="w-400px mt-10px rating-star fs-20px"><span uib-rating="" ng-model="DataObject.StudyRating.Ratings" max="5" read-only="false"></span> <span class="fs-12px txt-clr-2 pb-5px stars-text" ng-if="!DataObject.StudyRating.Ratings">Click to rate (1\u20135 stars)</span></div></div></div><div class="col-md-12 p-0 clearfix"><textarea class="txt-area mt-1 h-70px w-100 p-5px-all" ng-model="DataObject.StudyRating.Comment" placeholder="Additional comments (optional)"> </textarea></div><div class="pb-10px pull-right"><button type="button" class="btn btn-default rf-btn-xs mt-10px" ng-click="ReReadStudy()" ng-if="DataObject.StudyRating.Ratings>0 && DataObject.StudyRating.Ratings<=3">Request Re-Read</button> <button type="button" class="btn btn-primary rf-btn-xs mt-10px" ng-click="AddStudyRatings()" ng-disabled="!DataObject.StudyRating.Ratings">Submit Ratings</button></div></div></div></div></div></div></div></div></div></div></div><div class="modal fade" id="ConfirmRatingModel" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog create-filter"><div class="modal-content py-20px px-0" style="border-radius:4px;background-color:#2c2c2c !important;"><div class=""><div class=""></div><div class="modal-body"><div align="center"><span class="rate-study-icon" style="color: #F8BB86 !important;">!</span><h2 style="font-size: 16px; color: #f63b34; margin: 10px 0; line-height: normal; font-weight: 600; padding: 15px 0;">The ratings cannot be updated. Do you want to proceed?</h2><button type="button" class="btn btn-default mr-10px" ng-click="HideConfirmRatingModel()">Cancel</button> <button type="button" class="btn btn-primary mr-10px" ng-if="DataObject.StudyRating.Ratings>0 && DataObject.StudyRating.Ratings<=3" ng-click="ReReadStudy()">Request Re-Read</button> <button type="button" class="btn btn-primary mr-10px" ng-click="RateReport()">Continue</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/physician_schedule/schedule.html','<style>\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    .glyphicon-chevron-up,\r\n    .glyphicon-chevron-down,\r\n    .glyphicon-remove {\r\n        color: #767676;\r\n    }\r\n\r\n</style><div class="w-100 h-100 pos-rel row m-0"><div class="users-content-inner margin-0-625-all"><div class="users-content-inner-header pos-rel"><div class="radf-header"><h2 class="w-50 float-left">Schedule</h2><div class="w-50 float-left text-right pt-3px pr-15px"></div><div class="clearfix"></div></div><div class="clearfix"></div></div><div class="dicom-content-inner-content"><div class=""><div class="pos-rel"><div id="divCMWList" class=""><div class="row rf-filter-ui m-0 pt-8px filterspace"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-4 pd-lr"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="sProviderId.Obj" on-select="getSchedule()" tooltip-class="uibtooltipDenial" uib-tooltip="Select Provider" tooltip-placement="auto top"><ui-select-match placeholder="Select Provider" allow-clear="true">{{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="list in ProviderList | filter: {FirstName: $select.search} | orderBy:\'FirstName\'" position="down"><div ng-bind-html="list.FirstName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-4 pd-lr"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="sLocationId.Obj" on-select="getSchedule()" tooltip-class="uibtooltipDenial" uib-tooltip="Select Location" tooltip-placement="auto top"><ui-select-match placeholder="Select Location" allow-clear="true">{{$select.selected.Location}}</ui-select-match><ui-select-choices repeat="list in LocationList | filter: {Location: $select.search}" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-8 col-md-8 col-sm-6 col-xs-4 pd-lr mob-pr-0 text-right"><button type="button" class="btn btn-primary rf-btn-xs" ng-click="AddSchedule()">Add Schedule</button></div></div><div class="common-tbl"><table><thead><tr><th class="text-left w-25">Provider Name</th><th class="text-left w-25">Location</th><th class="text-left w-25">Appointment Date</th><th class="text-left w-7">Action</th></tr></thead><tbody><tr class="" ng-repeat="data in ScheduleList" ng-class="{\'selected\':$index == selectedRow}" ng-click="setClickedRow($index)"><td class="text-left w-25"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{data.ProviderName | titleCase}}" tooltip-placement="auto right">{{data.ProviderName | titleCase}}</span></td><td class="text-left w-25"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{data.LocationName | titleCase}}" tooltip-placement="auto right">{{data.LocationName | titleCase}}</span></td><td class="text-left w-25"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{data.AppointmentDate | date: \'MM/dd/yyyy\'}}" tooltip-placement="auto right">{{data.AppointmentDate | date: \'MM/dd/yyyy\'}}</span></td><td class="text-left w-7 p-0"><button type="button" ng-click="EditSchedule(data)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit" tooltip-placement="auto left" class="btn btn-default txt-clr-14 py-2px px-5px my-0 mx-5px border-0"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="DeleteSchedule(data.Id)" tooltip-class="uibtooltipDenial" uib-tooltip="Delete" tooltip-placement="auto left" class="btn btn-default txt-clr-14 py-2px px-5px my-0 mx-5px border-0"><i class="fa fa-trash-o fs-17px"></i></button></td></tr></tbody></table></div><div class="common-footer mob-footer"><div class="w-75 float-left pl-8px mob-w-100"><select id="ddlPageSize" class="sing-select form-control mt-10px float-left downArrow-ie w-auto" ng-model="PageSize" ng-change="changePageSize();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" total-items="TotalCount" items-per-page="PageSize" ng-model="CurrentPage" ng-change="pageChanged()" max-size="10" class="pagination float-left roundedpagin" boundary-link-numbers="true"></ul><div class="clearfix"></div></div><div class="w-25 float-left text-right d-table h-50px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ FilterCount }} of {{ TotalCount}}</span> Total Records</h5></div><div class="clearfix"></div></div></div></div></div></div></div><div class="modal fade new-popup" id="ScheduleModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog comment-width" role="document"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close otln-0" aria-label="Close" data-dismiss="modal"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">{{Id > 0 ? \'Edit Schedule\' : \'Add Schedule\'}}</h4></div><div class="modal-body"><form name="frmSchedule" id="frmSchedule" ng-submit="AddEditSchedule(frmSchedule.$valid)" role="form"><div class="width-inherit height-inherit"><div class="gc-content"><div class="row mb-10px"><div class="col-lg-12"><label for="Radiologist" class="rf-label">Provider <span class="txt-clr-6">*</span></label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-required="true" ng-model="SelectedProvider.Obj" on-select="bindLocationByUserId(SelectedProvider.Obj.Id, 0)"><ui-select-match placeholder="Select Provider" allow-clear="true">{{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="list in ProviderList | filter: {FirstName: $select.search} | orderBy:\'FirstName\'" position="down"><div ng-bind-html="list.FirstName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row mb-10px"><div class="col-lg-12"><label class="rf-label">Location <span class="txt-clr-6">*</span></label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-required="true" ng-model="SelectedLocation.Obj"><ui-select-match placeholder="Select Location" allow-clear="true">{{$select.selected.Location}}</ui-select-match><ui-select-choices repeat="list in UserLocation | filter: {Location: $select.search}" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row mb-10px"><div class="col-lg-6"><label class="rf-label">Date *</label><div><div class="input-group blk-calender-inpop"><input type="text" class="blk-input form-control form-border" uib-datepicker-popup="MM/dd/yyyy" ng-model="AppointmentDate" is-open="dosFDpopup.opened" readonly="" datepicker-options="dateSearchOptions" ng-required="true" close-text="Close" placeholder="Date" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="dosFDpopup.opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-12"><button type="submit" class="btn btn-primary float-left" ng-disabled="frmSchedule.$invalid">Save</button><div class="clearfix"></div></div></div></div></div></form></div></div></div></div></div><div ng-show="isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><style>\r\n    td.in-range {\r\n        background-color: #357ebd !important;\r\n        border-color: #3071a9 !important;\r\n        color: #fff;\r\n    }\r\n</style>');
$templateCache.put('app/pages/profile/userprofile.html','<style>\r\n\r\n    /*tour accordion start*/\r\n    .toursteps-accordn .accrbtn {\r\n        width: 100% !important;\r\n        display: block;\r\n    }\r\n\r\n    .accrbtn:after {\r\n        /*font-family: "Glyphicons Halflings";\r\n        content: "\\e113";\r\n        float: right;\r\n        margin-left: 0;\r\n        padding-right: 5px;*/\r\n        content: "";\r\n        border: 2px solid #fff;\r\n        width: 10px;\r\n        height: 10px;\r\n        background: transparent;\r\n        border-color: #fff #fff transparent transparent;\r\n        transform: rotate(135deg) translateY(-50%);\r\n        position: absolute;\r\n        right: 26px;\r\n        top: 36%;\r\n    }\r\n\r\n    .toursteps-accordn .accrbtn:hover, .toursteps-accordn .panel .panel-heading:hover {\r\n        background: #353535;\r\n    }\r\n    /* Icon when the collapsible content is hidden */\r\n    .accrbtn.collapsed:after {\r\n        right: 22px;\r\n        top: 48%;\r\n        transform: rotate(315deg);\r\n        /*content: "\\e114";*/\r\n    }\r\n\r\n    .toursteps-accordn .panel {\r\n        border: 2px solid #484848;\r\n        border-radius: 0 !important;\r\n        background: #2e2e2e;\r\n        box-shadow: inset 1px 1px 0 0 #484848;\r\n    }\r\n\r\n        .toursteps-accordn .panel .panel-heading {\r\n            /*background-color: #5d5d5d;\r\n        border-bottom-color: transparent !important;*/\r\n            /*border-bottom-color: #808080 !important;*/\r\n            background-color: #2E2E2E;\r\n            border-bottom-color: #17171A;\r\n            /*border-right: 1px solid #17171A;*/\r\n            border-radius: 0;\r\n            /*box-shadow: inset 1px 1px 0 0 #484848 !important;*/\r\n        }\r\n\r\n    .toursteps-accordn .panel-body {\r\n        /*background-color: #404040;*/\r\n        background-color: #2E2E2E;\r\n    }\r\n\r\n    .toursteps-accordn .accrbtn:after {\r\n        font-size: 10px;\r\n        padding-top: 3px;\r\n    }\r\n\r\n    .accrbtn-goto {\r\n        position: absolute;\r\n        right: 40px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        background: none;\r\n        border: 0;\r\n    }\r\n\r\n    .toursteps-togo {\r\n        /*max-height: 820px;\r\n        overflow-x: hidden;\r\n        overflow-y: auto;*/\r\n        box-shadow: 1px 1px 0 0 #484848;\r\n        border: 1px solid #17171a;\r\n        /*padding-right: 4px;*/\r\n    }\r\n\r\n    .toursteps-accordn .panel .panel-heading .accrbtn:hover {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .form-control.inputsearch {\r\n        padding-left: 30px;\r\n        border-radius: 2px;\r\n        background: #1E1E1E !important;\r\n        /*border-bottom: 1px solid #999 !important;*/\r\n        box-shadow: 0px 1px 2px 0 #757575;\r\n    }\r\n\r\n    .search-forhelp {\r\n        position: absolute;\r\n        right: 17px;\r\n        top: 7px;\r\n        color: #999;\r\n        cursor: pointer;\r\n        font-size: 14px;\r\n        padding: 8px 10px;\r\n        display: none;\r\n    }\r\n\r\n        .search-forhelp:hover {\r\n            color: #fff;\r\n            background: #404040;\r\n        }\r\n\r\n    .search-forsearch {\r\n        position: absolute;\r\n        left: 14px;\r\n        top: 7px;\r\n        color: #999;\r\n        font-size: 14px;\r\n        padding: 8px 10px;\r\n        pointer-events: none;\r\n    }\r\n\r\n    .dtour-close:hover {\r\n        color: #00ffd8 !important;\r\n    }\r\n\r\n    #accordion .panel-title .accrbtn mark, #accordion .panel-body p mark {\r\n        padding: 0 !important;\r\n        background: yellow !important;\r\n    }\r\n\r\n        #accordion .panel-title .accrbtn mark.no-mark, #accordion .panel-body p mark.no-mark {\r\n            background: transparent !important;\r\n            color: inherit;\r\n        }\r\n\r\n    #accordion .panel .collapse.in {\r\n        height: unset !important;\r\n    }\r\n    /*tour accordion end*/\r\n    .diacom-options label.form-controller {\r\n        width: 20%;\r\n    }\r\n\r\n    .toursteps-accordn .accrno-panel .accrbtn:after {\r\n        display: none;\r\n    }\r\n\r\n    body {\r\n        overflow-y: hidden !important;\r\n    }\r\n\r\n    .usrprfl-cols .colhalf:nth-of-type(odd) {\r\n        padding-right: 20px;\r\n    }\r\n\r\n    .usrprfl-div .colhalf:nth-of-type(odd) {\r\n        padding-right: 20px;\r\n    }\r\n\r\n    .usrprfl-cols .mult-select.ui-select-multiple.ui-select-bootstrap input.ui-select-search {\r\n        display: none\r\n    }\r\n\r\n    .usrprfl-cols .mult-select.ui-select-multiple.ui-select-bootstrap {\r\n        padding: 10px !important\r\n    }\r\n\r\n    .usr-prfl-tb .panel ::-webkit-scrollbar-track {\r\n        background: rgb(38 37 38) !important;\r\n    }\r\n\r\n    .usr-prfl-tb .panel ::-webkit-scrollbar-thumb {\r\n        background: rgb(255 255 255) !important;\r\n    }\r\n    /*@media only screen and (min-width: 1200px) and (max-width: 1599px) {\r\n        .pref-wrapper {\r\n            width: 70%;\r\n        }\r\n    }*/\r\n\r\n    /*@media only screen and (min-width: 768px) and (max-width: 1199px) {\r\n        .left-menubar.usrprifile-sidebar {\r\n            width: 200px;\r\n        }\r\n\r\n        .right-dashboard.usrprofile-rtdashbrd {\r\n            width: calc(100% - 200px);\r\n        }\r\n\r\n        .pref-wrapper {\r\n            width: 86%;\r\n        }\r\n\r\n        .checkbox-switch.pref-checkbox .checkbox-switch-slider:before {\r\n            height: 10px;\r\n            width: 10px;\r\n            bottom: 1px;\r\n            transform: translateX(-1px);\r\n        }\r\n\r\n        .checkbox-switch.pref-checkbox {\r\n            width: 26px;\r\n            height: 14px;\r\n        }\r\n    }*/\r\n\r\n</style><div class="row" style="margin:0"><div class="col-md-12" style="padding: 0;"><div class="usr-prfl-tb" ng-controller="ProfileController as appCtrl"><div class="d-flex"><div class="left-menubar usrprifile-sidebar"><div class="vertical-tabs clearfix px-0 pt-0"><ul class="nav nav-tabs left-menulist w-100 m-0 p-0" role="tablist"><li class="nav-item mb-0" ng-class="{\'active\': (PageName == \'ProfileMenu\')}"><a class="nav-link fs-13px fw-600 txt-clr-1 w-100 mr-0" data-toggle="tab" href="#ProfileMenu" role="tab" aria-controls="Profile" ng-click="TabChange(\'ProfileMenu\')">Profile</a></li><li class="nav-item mb-0" ng-class="{\'active\': (PageName == \'UserPreferenceMenu\'), \'d-none\': (appCtrl.IsTechUser)}"><a class="nav-link fs-13px fw-600 txt-clr-1 w-100 mr-0" data-toggle="tab" href="#UserPreferenceMenu" role="tab" aria-controls="UserPreference" ng-click="TabChange(\'UserPreferenceMenu\')">User Preference</a></li><li class="nav-item mb-0" ng-class="{\'d-none\': (appCtrl.IsTechUser)}"><a class="nav-link fs-13px fw-600 txt-clr-1 w-100 mr-0" aria-controls="CIVRSettings" ng-click="OpenCIVRSetting()">CIVR Settings</a></li><li class="nav-item mb-0" ng-class="{\'d-none\' : !(appCtrl.IsPaymentContractEnabled),\'active\': (PageName == \'PaymentDashBoardMenu\')}"><a class="nav-link fs-13px fw-600 txt-clr-1 w-100 mr-0" data-toggle="tab" href="#PaymentDashBoardMenu" role="tab" aria-controls="PaymentDashBoard" ng-click="TabChange(\'PaymentDashBoardMenu\')">Payment Dashboard</a></li></ul></div></div><div class="right-dashboard usrprofile-rtdashbrd"><div class="tab-content clearfix" ng-class="{\'pref-wrapper\': (PageName != \'PaymentDashBoardMenu\' && PageName != \'PaymentInvoiceMenu\')}"><div class="tab-pane clearfix" id="ProfileMenu" role="tabpanel" ng-class="{\'active\': (PageName == \'ProfileMenu\')}"><div class="col-md-12 px-0 mb-0 jump-onsteps toursteps-accordn panel-group" id="accordionProfile"><div class="panel panel-default box-shadow-n mb-20px"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all" data-toggle="collapse" href="#collapse11">User Details <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Manage personal information including name, email, phone, and username.</span></a></h4></div><div id="collapse11" class="panel-collapse collapse in"><div class="panel-body p-20px-all border-0"><form name="frmCreateUser" ng-submit="appCtrl.UpdateUser(frmCreateUser.$valid)" class="w-100 height-inherit" autocomplete="off"><div class="w-100 d-flex flex-wrap justify-content-between usrprfl-cols"><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">First Name *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.FirstName" autocomplete="off" required=""></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Last Name *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.LastName" autocomplete="off" required=""></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Email *</label> <input type="email" class="blk-input form-control b-clr-light" ng-model="appCtrl.Email" autocomplete="off" required=""></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Phone Number *</label> <input type="text" maxlength="15" placeholder="eg: +18687000000" class="blk-input form-control b-clr-light" ng-model="appCtrl.Phone" autocomplete="off" required=""></div></div><div ng-if="appCtrl.UserRoles.includes(\'User\')" class="w-100 d-flex flex-wrap justify-content-between"><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Address Line 1</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.AddressLine1" autocomplete="off"></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Address Line 2</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.AddressLine2" autocomplete="off"></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">City</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.City" autocomplete="off"></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Postal Code</label> <input type="text" maxlength="5" class="blk-input form-control b-clr-light" ng-model="appCtrl.PostalCode" autocomplete="off" numbers-only=""></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">State</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.State" autocomplete="off"></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Country</label><ui-select skip-focusser="true" class="mult-select" ng-model="appCtrl.CountryCode" title="Select Country"><ui-select-match placeholder="Select Country" allow-clear="true">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="list in CountryCodes | propsFilter: {value: $select.search}" position="down"><div ng-bind-html="list.value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="w-50 mb-20px colhalf pr-20px"><div class="group-register"><label class="rf-label">Username *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.UserName" autocomplete="off" required=""></div></div><div class="w-50 mb-20px colhalf pr-0"><div class="group-register"><label class="rf-label">NPI</label> <input type="text" class="blk-input form-control b-clr-light" id="txtNPI" ng-model="appCtrl.NPI" autocomplete="off" ng-disabled="true"></div></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Update" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmCreateUser.$invalid">Update</button></div></div></form></div></div></div><div class="panel panel-default box-shadow-n mb-20px"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all collapsed" data-toggle="collapse" href="#collapse12">Change Password <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Update login credentials for enhanced security.</span></a></h4></div><div id="collapse12" class="panel-collapse collapse"><div class="panel-body p-20px-all border-0"><form name="frmChangePassword" ng-submit="appCtrl.ResetPassword(frmChangePassword.$valid)" class="w-100 height-inherit"><div class="w-100 d-flex justify-content-between"><div class="group-register mb-20px w-33"><label class="rf-label">Current Password *</label> <input type="password" class="blk-input form-control b-clr-light" ng-model="appCtrl.CurrentPassword" autocomplete="off" required=""></div><div class="group-register mb-20px w-33 pl-20px"><label class="rf-label">New Password *</label> <input type="password" class="blk-input form-control b-clr-light" ng-model="appCtrl.Password" name="password" autocomplete="off" uib-tooltip-template="\'PasswordPolicyTooltip.html\'" tooltip-class="setpwdpolicytooltip" tooltip-animation="false" tooltip-placement="top" tooltip-trigger="none" tooltip-is-open="(frmChangePassword._pwdFocused && frmChangePassword.password.$invalid) || (!frmChangePassword._pwdFocused && frmChangePassword.password.$dirty && frmChangePassword.password.$viewValue && frmChangePassword.password.$invalid)" ng-focus="frmChangePassword._pwdFocused = true" ng-blur="frmChangePassword._pwdFocused = false" tooltip-append-to-body="false" ng-pattern="/^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{12,64}$/" required=""></div><div class="group-register mb-20px w-33 pl-20px"><label class="rf-label">Confirm Password *</label> <input type="password" class="blk-input form-control b-clr-light" ng-model="appCtrl.ConfirmPassword" autocomplete="off" required=""></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Invite" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmChangePassword.$invalid">Reset</button></div></div></form></div></div></div><div class="panel panel-default box-shadow-n mb-20px"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all collapsed" data-toggle="collapse" href="#collapse13">Change Pin <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Update login PIN for added security and convenience.</span></a></h4></div><div id="collapse13" class="panel-collapse collapse"><div class="panel-body p-20px-all border-0"><form name="frmResetPasscode" ng-submit="appCtrl.ResetPasscode(frmResetPasscode.$valid)" class="w-100 height-inherit"><div class="w-100 d-flex justify-content-between"><div class="group-register mb-20px w-33"><label class="rf-label">Current Pin *</label> <input type="password" class="blk-input form-control b-clr-light" maxlength="6" numbers-only="" ng-model="appCtrl.CurrentPasscode" ng-pattern="/^[0-9]{4,6}$/" autocomplete="off" required=""></div><div class="group-register mb-20px w-33 pl-20px"><label class="rf-label">New Pin *</label> <input type="password" class="blk-input form-control b-clr-light" maxlength="6" numbers-only="" ng-model="appCtrl.NewPasscode" ng-pattern="/^[0-9]{4,6}$/" autocomplete="off" required=""></div><div class="group-register mb-20px w-33 pl-20px"><label class="rf-label">Confirm Pin *</label> <input type="password" class="blk-input form-control b-clr-light" maxlength="6" numbers-only="" ng-model="appCtrl.ConfirmPasscode" autocomplete="off" required=""></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Invite" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmResetPasscode.$invalid">Reset</button></div></div></form></div></div></div><div class="panel panel-default box-shadow-n mb-20px"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all" data-toggle="collapse" href="#collapse14">User Access <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Manage radiology specialty, users with access to specific tenant and sites, organization-defined target RVU goals, reviewer status, and associated payment contracts.</span></a></h4></div><div id="collapse14" class="panel-collapse collapse in"><div class="panel-body p-20px-all border-0"><form name="frmSite" class="w-100 height-inherit" ng-init="appCtrl.GetAllSites()"><div class="w-100 mb-15px d-flex flex-wrap justify-content-between usrprfl-cols"><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Tenants</label><ui-select class="mult-select" close-on-select="false" ng-model="SelectedTenant.Obj" tooltip-class="uibtooltipDenial" multiple="" ng-required="true" ng-disabled="true"><ui-select-match placeholder="Select Tenant" allow-clear="true" class="overflow-y-auto d-block max-h-75px overflow-x-hide pos-rel">{{$item.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantByUserID | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Site</label><ui-select class="mult-select p-3px-all addfltr-drpovrly" multiple="" ng-model="LocSelected.Sites" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" close-on-select="false" theme="bootstrap" ng-disabled="true"><ui-select-match placeholder="Select a Site" class="max-h-75px overflow-y-auto overflow-x-hide pos-rel d-block">{{$item.Site}}</ui-select-match><ui-select-choices repeat="list in AllSites | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row" ng-if="false"><div class="col-md-6"><button type="submit" ng-disabled="frmSite.$invalid || appCtrl.IsTechUser" ng-click="appCtrl.MapSites(frmSite.$valid)" class="btn btn-primary btn-sm fs-13px txt-clr-1">Submit</button></div></div></form><div class="row m-0"><div class="col-md-12 p-0"><div class="w-100 mb-20px d-flex flex-wrap justify-content-between usrprfl-div"><div class="w-50 mb-20px colhalf"><div class="group-register"><div class="form-group w-100 px-0 pos-rel"><label class="rf-label"><span>Specialty</span></label><multi-select master-data="SpecialityDropdownProfile" list="SpecialityList" ng-model="SpecialityDropdownProfile.SelectedValue" on-change="onSpecialitySelected(selectedData)"></multi-select></div></div></div><div class="w-50 mb-20px colhalf"><div class="group-register"><label class="rf-label">Target RVU</label> <input type="text" class="blk-input form-control b-clr-light" is-number="" ng-model="appCtrl.TargetRVU" autocomplete="off" ng-disabled="appCtrl.IsTechUser" required=""></div></div></div><div class="w-100 mb-20px d-flex flex-wrap justify-content-between usrprfl-cols"><div class="w-50 mb-20px colhalf d-flex"><div class="group-register form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="IsReviwer" ng-model="appCtrl.IsReviwer" ng-selected="appCtrl.IsReviwer" autocomplete="off" ng-disabled="true"> <label for="IsReviwer" class="rf-label cmn-check-label">Is Reviewer</label><div class="clearfix"></div></div></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Update" ng-click="appCtrl.UpdateUserSetting()" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="appCtrl.IsTechUser">Update</button> <input type="button" id="btnCheckout" value="Checkout" class="btn btn-primary btn-sm fs-13px txt-clr-1 d-none" ng-disabled="PaymentContract.Obj == null" ng-click="checkout()"></div></div></div></div></div></div></div><div class="panel panel-default box-shadow-n mb-20px" ng-if="isPCAvailable"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all" data-toggle="collapse" href="#collapse15">User Account Details <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-none">Manage radiology specialty, users with access to specific tenant and sites, organization-defined target RVU goals, reviewer status, and associated payment contracts.</span></a></h4></div><div id="collapse15" class="panel-collapse collapse in"><div class="panel-body p-20px-all border-0"><div class="col-xs-12 col-sm-12 col-md-12 p-15px-all bor-rad-4px"><form name="frmBankAccountDetails" ng-submit="SaveUserAccountDetails()" class="width-inherit height-inherit" autocomplete="off"><div class="w-100"><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Name On Account *</label> <input type="text" class="blk-input form-control b-clr-light" id="txtNameOnAccount" ng-model="BankAccountDetails.AccountName" autocomplete="off" placeholder="Enter Name On Account" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Account Number *</label> <input type="text" class="blk-input form-control b-clr-light" id="txtAccountNumber" ng-model="BankAccountDetails.AccountNumber" autocomplete="off" placeholder="Enter Account Number" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Routing Number *</label> <input type="text" class="blk-input form-control b-clr-light" id="txtRoutingNumber" ng-model="BankAccountDetails.RoutingNumber" autocomplete="off" placeholder="Enter Routing Number" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Type Of Account *</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="BankAccountDetails.AccountType" required=""><ui-select-match placeholder="Select Account Type" allow-clear="false">{{$select.selected.AccountType}}</ui-select-match><ui-select-choices repeat="list in AccountTypeList" position="down"><div ng-bind-html="list.AccountType"></div></ui-select-choices></ui-select></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Payment Currency *</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="BankAccountDetails.PaymentCurrency" required=""><ui-select-match placeholder="Select Payment Currency" allow-clear="false">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="list in PaymentCurrencyList" position="down"><div ng-bind-html="list.Key"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-6"><button type="submit" id="btnSaveAccountDetails" value="Save" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmBankAccountDetails.$invalid">Update</button></div></div></form></div></div></div></div><div class="row d-flex flex-wrap mx-0 my-10px" style="display: none !important;"><div class="col-xs-12 col-sm-6 col-md-3 p-15px-all bor-rad-4px bg-clr-31 profile-col-w"><h1 class="secondary-heading">User Details</h1><div class=""><form name="frmCreateUser" ng-submit="appCtrl.UpdateUser(frmCreateUser.$valid)" class="width-inherit height-inherit" autocomplete="off"><div class="w-100"><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Username *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.UserName" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Email *</label> <input type="email" class="blk-input form-control b-clr-light" ng-model="appCtrl.Email" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">First Name *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.FirstName" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Last Name *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.LastName" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Display Name *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.DisplayName" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Phone Number *</label> <input type="text" maxlength="15" placeholder="eg: +18687000000" class="blk-input form-control b-clr-light" ng-model="appCtrl.Phone" autocomplete="off" required=""></div></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Update" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmCreateUser.$invalid">Update</button></div></div></form></div></div><div class="col-xs-12 col-sm-6 col-md-3 p-15px-all bor-rad-4px bg-clr-31 profile-col-w"><div class="row"><div class="col-lg-12"><h1 class="secondary-heading">Change Password</h1><div class=""><form name="frmResetPassword" ng-submit="appCtrl.ResetPassword(frmResetPassword.$valid)" class="width-inherit height-inherit"><div class="w-100"><div class="w-100"><div class="group-register mb-20px"><label class="rf-label">Current Password *</label> <input type="password" class="blk-input form-control b-clr-light" ng-model="appCtrl.CurrentPassword" autocomplete="off" required=""></div><div class="group-register mb-20px"><label class="rf-label">New Password *</label> <input type="password" class="blk-input form-control b-clr-light" ng-model="appCtrl.Password" autocomplete="off" required=""></div><div class="group-register mb-20px"><label class="rf-label">Confirm Password *</label> <input type="password" class="blk-input form-control b-clr-light" ng-model="appCtrl.ConfirmPassword" autocomplete="off" required=""></div></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Invite" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmResetPassword.$invalid">Reset</button></div></div></form></div></div></div><div class="row"><div class="col-lg-12"><h1 class="secondary-heading">Change Pin</h1><div class=""><form name="frmResetPasscode" ng-submit="appCtrl.ResetPasscode(frmResetPasscode.$valid)" class="width-inherit height-inherit"><div class="w-100"><div class="w-100"><div class="group-register mb-20px"><label class="rf-label">Current Pin *</label> <input type="password" class="blk-input form-control b-clr-light" maxlength="6" numbers-only="" ng-model="appCtrl.CurrentPasscode" ng-pattern="/^[0-9]{4,6}$/" autocomplete="off" required=""></div><div class="group-register mb-20px"><label class="rf-label">New Pin *</label> <input type="password" class="blk-input form-control b-clr-light" maxlength="6" numbers-only="" ng-model="appCtrl.NewPasscode" ng-pattern="/^[0-9]{4,6}$/" autocomplete="off" required=""></div><div class="group-register mb-20px"><label class="rf-label">Confirm Pin *</label> <input type="password" class="blk-input form-control b-clr-light" maxlength="6" numbers-only="" ng-model="appCtrl.ConfirmPasscode" autocomplete="off" required=""></div></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Invite" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmResetPasscode.$invalid">Reset</button></div></div></form></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-3 p-15px-all bor-rad-4px bg-clr-31 profile-col-w"><h1 class="secondary-heading">Site Mapping</h1><div class=""><div class="mb-20px"><div class=""><form name="frmSite" class="width-inherit height-inherit" ng-init="appCtrl.GetAllSites()"><div class="w-100 mb-15px"><div class="group-register"><label class="rf-label">Tenants</label><ui-select class="mult-select" close-on-select="false" ng-model="SelectedTenant.Obj" tooltip-class="uibtooltipDenial" multiple="" uib-tooltip="Choose a Tenant" tooltip-placement="auto top" ng-required="true" ng-disabled="true"><ui-select-match placeholder="Select Tenant" allow-clear="true" class="overflow-y-auto d-block max-h-75px overflow-x-hide pos-rel">{{$item.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantByUserID | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="w-100 mb-15px"><div class="group-register"><label class="rf-label">Site</label><ui-select class="mult-select p-3px-all addfltr-drpovrly" multiple="" ng-model="LocSelected.Sites" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" title="Choose a Site" close-on-select="false" theme="bootstrap" ng-disabled="true"><ui-select-match placeholder="Select a Site" class="max-h-75px overflow-y-auto overflow-x-hide pos-rel d-block">{{$item.Site}}</ui-select-match><ui-select-choices repeat="list in AllSites | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row" ng-if="false"><div class="col-md-6"><button type="submit" ng-disabled="frmSite.$invalid || appCtrl.IsTechUser" ng-click="appCtrl.MapSites(frmSite.$valid)" class="btn btn-primary btn-sm fs-13px txt-clr-1">Submit</button></div></div></form></div></div><div class="row m-0"><div class="col-md-12 p-0"><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Specialty</label><select class="sing-select form-control b-clr-light downArrow-ie" ng-selected="appCtrl.SpecialityId" ng-model="appCtrl.SpecialityId" ng-options="list.SpecialityId as (list.SpecialityCode + \' (\' + list.SpecialityCodeDesc + \')\') for list in appCtrl.SpecialityList" ng-disabled="appCtrl.IsTechUser"><option value="">Select Specialty Code</option></select></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Target RVU</label> <input type="text" class="blk-input form-control b-clr-light" is-number="" ng-model="appCtrl.TargetRVU" autocomplete="off" ng-disabled="appCtrl.IsTechUser" required=""></div></div><div class="w-100 mb-20px"><div class="group-register form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="IsReviwer" ng-model="appCtrl.IsReviwer" ng-selected="appCtrl.IsReviwer" autocomplete="off" ng-disabled="appCtrl.IsTechUser"> <label for="IsReviwer" class="rf-label cmn-check-label">Is Reviewer</label><div class="clearfix"></div></div></div><div class="row m-0"><div class="mb-20px px-0 col-md-6 col-sm-6"><label class="rf-label">Payment Contract</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="PaymentContract.Obj" ng-disabled="true"><ui-select-match placeholder="Select Payment Contract" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PaymentContractList" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="mb-20px pr-0 col-md-6 col-sm-6" ng-if="PaymentContract.Obj.Value==\'Payment Per Shift\'"><label class="rf-label">Helper Shift Based On</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="PaymentContractHelperShift.Obj" ng-disabled="true"><ui-select-match placeholder="Select Payment Contract(Helper Shift)" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PaymentContractList.HelperShiftList" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Update" ng-click="appCtrl.UpdateUserSetting()" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="appCtrl.IsTechUser">Update</button> <input type="button" id="btnCheckout" value="Checkout" class="btn btn-primary btn-sm fs-13px txt-clr-1 d-none" ng-disabled="PaymentContract.Obj == null" ng-click="checkout()"></div></div></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-3 p-15px-all bor-rad-4px bg-clr-31 profile-col-w"><h1 class="secondary-heading">User Account Details</h1><div class=""><form name="frmBankAccountDetails" ng-submit="SaveUserAccountDetails()" class="width-inherit height-inherit" autocomplete="off"><div class="w-100"><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Name On Account *</label> <input type="text" class="blk-input form-control b-clr-light" id="txtNameOnAccount" ng-model="BankAccountDetails.AccountName" autocomplete="off" placeholder="Enter Name On Account" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Account Number *</label> <input type="text" class="blk-input form-control b-clr-light" id="txtAccountNumber" ng-model="BankAccountDetails.AccountNumber" autocomplete="off" placeholder="Enter Account Number" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Routing Number *</label> <input type="text" class="blk-input form-control b-clr-light" id="txtRoutingNumber" ng-model="BankAccountDetails.RoutingNumber" autocomplete="off" placeholder="Enter Routing Number" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Type Of Account *</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="BankAccountDetails.AccountType" required=""><ui-select-match placeholder="Select Account Type" allow-clear="false">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in AccountTypeList" position="down"><div ng-bind-html="list"></div></ui-select-choices></ui-select></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Payment Currency *</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="BankAccountDetails.PaymentCurrency" required=""><ui-select-match placeholder="Select Payment Currency" allow-clear="false">{{$select.selected.Label}}</ui-select-match><ui-select-choices repeat="list in PaymentCurrencyList" position="down"><div ng-bind-html="list.Label"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-6"><button type="submit" id="btnSaveAccountDetails" value="Save" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmBankAccountDetails.$invalid">Update</button></div></div></form></div></div><div class="clearfix"></div></div></div></div><div id="UserPreferenceMenu" class="tab-pane clearfix" role="tabpanel" ng-class="{\'active\': (PageName == \'UserPreferenceMenu\')}"><user-preference ng-if="UserPreferenceFlag"></user-preference></div><div id="PaymentDashBoardMenu" class="tab-pane clearfix" role="tabpanel" ng-class="{\'active\': (PageName == \'PaymentDashBoardMenu\')}"><payment-dash-board ng-if="PaymentDashBoardFlag"></payment-dash-board></div><div id="PaymentInvoiceMenu" class="tab-pane clearfix" role="tabpanel" ng-class="{\'active\': (PageName == \'PaymentInvoiceMenu\')}"><payment-invoice ng-if="PaymentInvoiceFlag"></payment-invoice></div></div></div><div class="h-93vh overflow-y-auto d-none"><div class="row d-flex flex-wrap mx-0 my-10px"><div class="col-xs-12 col-sm-6 col-md-3 p-15px-all bor-rad-4px bg-clr-31 profile-col-w"><h1 class="secondary-heading">User Details</h1><div class=""><form name="frmCreateUser" ng-submit="appCtrl.UpdateUser(frmCreateUser.$valid)" class="width-inherit height-inherit" autocomplete="off"><div class="w-100"><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Username *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.UserName" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Email *</label> <input type="email" class="blk-input form-control b-clr-light" ng-model="appCtrl.Email" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">First Name *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.FirstName" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Last Name *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.LastName" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Display Name *</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="appCtrl.DisplayName" autocomplete="off" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Phone Number *</label> <input type="text" maxlength="15" placeholder="eg: +18687000000" class="blk-input form-control b-clr-light" ng-model="appCtrl.Phone" autocomplete="off" required=""></div></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Update" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmCreateUser.$invalid">Update</button></div></div></form></div></div><div class="col-xs-12 col-sm-6 col-md-3 p-15px-all bor-rad-4px bg-clr-31 profile-col-w"><div class="row"><div class="col-lg-12"><h1 class="secondary-heading">Change Password</h1><div class=""><form name="frmResetPassword" ng-submit="appCtrl.ResetPassword(frmResetPassword.$valid)" class="width-inherit height-inherit"><div class="w-100"><div class="w-100"><div class="group-register mb-20px"><label class="rf-label">Current Password *</label> <input type="password" class="blk-input form-control b-clr-light" ng-model="appCtrl.CurrentPassword" autocomplete="off" required=""></div><div class="group-register mb-20px"><label class="rf-label">New Password *</label> <input type="password" class="blk-input form-control b-clr-light" ng-model="appCtrl.Password" autocomplete="off" required=""></div><div class="group-register mb-20px"><label class="rf-label">Confirm Password *</label> <input type="password" class="blk-input form-control b-clr-light" ng-model="appCtrl.ConfirmPassword" autocomplete="off" required=""></div></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Invite" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmResetPassword.$invalid">Reset</button></div></div></form></div></div></div><div class="row"><div class="col-lg-12"><h1 class="secondary-heading">Change Pin</h1><div class=""><form name="frmResetPasscode" ng-submit="appCtrl.ResetPasscode(frmResetPasscode.$valid)" class="width-inherit height-inherit"><div class="w-100"><div class="w-100"><div class="group-register mb-20px"><label class="rf-label">Current Pin *</label> <input type="password" class="blk-input form-control b-clr-light" maxlength="6" numbers-only="" ng-model="appCtrl.CurrentPasscode" ng-pattern="/^[0-9]{4,6}$/" autocomplete="off" required=""></div><div class="group-register mb-20px"><label class="rf-label">New Pin *</label> <input type="password" class="blk-input form-control b-clr-light" maxlength="6" numbers-only="" ng-model="appCtrl.NewPasscode" ng-pattern="/^[0-9]{4,6}$/" autocomplete="off" required=""></div><div class="group-register mb-20px"><label class="rf-label">Confirm Pin *</label> <input type="password" class="blk-input form-control b-clr-light" maxlength="6" numbers-only="" ng-model="appCtrl.ConfirmPasscode" autocomplete="off" required=""></div></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Invite" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmResetPasscode.$invalid">Reset</button></div></div></form></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-3 p-15px-all bor-rad-4px bg-clr-31 profile-col-w"><h1 class="secondary-heading">Site Mapping</h1><div class=""><div class="mb-20px"><div class=""><form name="frmSite" class="width-inherit height-inherit" ng-init="appCtrl.GetAllSites()"><div class="w-100 mb-15px"><div class="group-register"><label class="rf-label">Tenants</label><ui-select class="mult-select" close-on-select="false" ng-model="SelectedTenant.Obj" tooltip-class="uibtooltipDenial" multiple="" uib-tooltip="Choose a Tenant" tooltip-placement="auto top" ng-required="true" ng-disabled="true"><ui-select-match placeholder="Select Tenant" allow-clear="true" class="overflow-y-auto d-block max-h-75px overflow-x-hide pos-rel">{{$item.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantByUserID | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="w-100 mb-15px"><div class="group-register"><label class="rf-label">Site</label><ui-select class="mult-select p-3px-all addfltr-drpovrly" multiple="" ng-model="LocSelected.Sites" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" title="Choose a Site" close-on-select="false" theme="bootstrap" ng-disabled="true"><ui-select-match placeholder="Select a Site" class="max-h-75px overflow-y-auto overflow-x-hide pos-rel d-block">{{$item.Site}}</ui-select-match><ui-select-choices repeat="list in AllSites | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row" ng-if="false"><div class="col-md-6"><button type="submit" ng-disabled="frmSite.$invalid || appCtrl.IsTechUser" ng-click="appCtrl.MapSites(frmSite.$valid)" class="btn btn-primary btn-sm fs-13px txt-clr-1">Submit</button></div></div></form></div></div><div class="row m-0"><div class="col-md-12 p-0"><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Specialty</label><select class="sing-select form-control b-clr-light downArrow-ie" ng-selected="appCtrl.SpecialityId" ng-model="appCtrl.SpecialityId" ng-options="list.SpecialityId as (list.SpecialityCode + \' (\' + list.SpecialityCodeDesc + \')\') for list in appCtrl.SpecialityList" ng-disabled="appCtrl.IsTechUser"><option value="">Select Specialty Code</option></select></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Target RVU</label> <input type="text" class="blk-input form-control b-clr-light" is-number="" ng-model="appCtrl.TargetRVU" autocomplete="off" ng-disabled="appCtrl.IsTechUser" required=""></div></div><div class="w-100 mb-20px"><div class="group-register form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="IsReviwer" ng-model="appCtrl.IsReviwer" ng-selected="appCtrl.IsReviwer" autocomplete="off" ng-disabled="true"> <label for="IsReviwer" class="rf-label cmn-check-label">Is Reviewer</label><div class="clearfix"></div></div></div><div class="row m-0"><div class="mb-20px px-0 col-md-6 col-sm-6"><label class="rf-label">Payment Contract</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="PaymentContract.Obj" ng-disabled="true"><ui-select-match placeholder="Select Payment Contract" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PaymentContractList" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="mb-20px pr-0 col-md-6 col-sm-6" ng-if="PaymentContract.Obj.Value==\'Payment Per Shift\'"><label class="rf-label">Helper Shift Based On</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="PaymentContractHelperShift.Obj" ng-disabled="true"><ui-select-match placeholder="Select Payment Contract(Helper Shift)" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PaymentContractList.HelperShiftList" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-6"><button type="submit" value="Update" ng-click="appCtrl.UpdateUserSetting()" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="appCtrl.IsTechUser">Update</button> <input type="button" id="btnCheckout" value="Checkout" class="btn btn-primary btn-sm fs-13px txt-clr-1 d-none" ng-disabled="PaymentContract.Obj == null" ng-click="checkout()"></div></div></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-3 p-15px-all bor-rad-4px bg-clr-31 profile-col-w" ng-if="UserRole.includes(\'User\')"><h1 class="secondary-heading">User Account Details</h1><div class=""><form name="frmBankAccountDetails" ng-submit="SaveUserAccountDetails()" class="width-inherit height-inherit" autocomplete="off"><div class="w-100"><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Name On Account *</label> <input type="text" class="blk-input form-control b-clr-light" id="txtNameOnAccount" ng-model="BankAccountDetails.AccountName" autocomplete="off" placeholder="Enter Name On Account" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Account Number *</label> <input type="text" class="blk-input form-control b-clr-light" id="txtAccountNumber" ng-model="BankAccountDetails.AccountNumber" autocomplete="off" placeholder="Enter Account Number" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Routing Number *</label> <input type="text" class="blk-input form-control b-clr-light" id="txtRoutingNumber" ng-model="BankAccountDetails.RoutingNumber" autocomplete="off" placeholder="Enter Routing Number" required=""></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Type Of Account *</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="BankAccountDetails.AccountType" required=""><ui-select-match placeholder="Select Account Type" allow-clear="false">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in AccountTypeList" position="down"><div ng-bind-html="list"></div></ui-select-choices></ui-select></div></div><div class="w-100 mb-20px"><div class="group-register"><label class="rf-label">Payment Currency *</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="BankAccountDetails.PaymentCurrency" required=""><ui-select-match placeholder="Select Payment Currency" allow-clear="false">{{$select.selected.Label}}</ui-select-match><ui-select-choices repeat="list in PaymentCurrencyList" position="down"><div ng-bind-html="list.Label"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-6"><button type="submit" id="btnSaveAccountDetails" value="Save" class="btn btn-primary btn-sm fs-13px txt-clr-1" ng-disabled="frmBankAccountDetails.$invalid">Update</button></div></div></form></div></div><div class="clearfix"></div></div></div></div></div></div></div><style>\r\n        .ui-select-match {\r\n            max-height: 150px !important;\r\n        }\r\n    </style><script type="text/ng-template" id="PasswordPolicyTooltip.html"><p class="fw-600 fs-13px mb-8px pl-5px mt-5px txt-clr-1">Password Requirements:</p> <ul class="password-policy-tooltip pl-20px m-0 text-left"> <li class="fs-12px mb-8px" ng-repeat="requirement in DataObject.PasswordRequirements"> {{requirement}} </li> </ul></script>');
$templateCache.put('app/pages/policy/privacypolicy.html','<style>\r\n    body {overflow-y:auto !important\r\n    }\r\n    p {\r\n        margin-bottom: 15px;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .list-ul li {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .list-ul {\r\n        margin-bottom: 20px;\r\n    }\r\n</style><div class="page-top clearfix" style="height:auto !important"><div class="w-85 m-0-auto"><div class="navbar-custom-menu float-left"><ul class="navbar-nav dropMenu pl-0 w-100" style="list-style:none;"><li class="dropdown messages-menu"><a href="#/dashboard" class="dropdown-toggle d-block pb-10px"><img src="assets/img/radflow.png" class="h-60px"></a></li></ul></div><div class="navbar-custom-menu pull-right"><ul class="nav navbar-nav"><li class="user user-menu nav-hover h-60px"><a href="#" ui-sref="Login" class="pt-20px fs-16px mt-10px txt-clr-16" style="background-color:transparent!important;"><span class=""><i class="fa fa-chevron-left txt-clr-16 fs-16px"></i> Back</span></a></li></ul></div><div class="clearfix"></div></div></div><div class="al-main"><div class="w-85 m-0-auto"><div class="h-70px"></div><div class="fs-16px fw-500 txt-clr-1 lh-1-5 text-justify mb-25px"><h1 class="mb-20px fs-30px">Privacy Policy</h1><p>This Privacy Notice (\u201CNotice\u201D) relates to the operations of two websites, www.myimagingstudy.com and https://radflow.collaborativeimaging.com, and any affiliated mobile applications, and describes the types of information Collaborative Imaging, LLC and its affiliated entities (\u201CCI,\u201D \u201Cwe\u201D or \u201Cus\u201D) may collect from you, your authorized representatives, or third parties. This Notice also describes how we collect, use, process, maintain, protect, and disclose information about you and expresses our commitment to protecting your privacy in accordance with law. Throughout this Privacy Notice the website you are currently accessing will be referred to as \u201Cthe Site\u201D unless the text refers to one of them specifically.</p><h3 class="mb-10px pt-25px fw-500 txt-clr-14">Agreement to Terms and Changes</h3><p>Please read this Notice carefully. If any term is unacceptable to you, please do not use the Site or provide any personal information. <b>If you do access or use the Site, it will mean you expressly agree to the terms contained in this Privacy Notice and that the terms are sufficient to protect your privacy expectations.</b></p><p>This Privacy Notice may change from time to time, <b>and your use of the Site after we make changes is deemed to be your acceptance of those changes,</b> so please check the Site periodically for updates.</p><h3 class="mb-10px pt-25px fw-500 txt-clr-14">Information We May Collect and Store and How We Use It</h3><p>As described in our website Terms of Use and Text Messaging Terms of Service, your healthcare providers and insurers or other payors may send us information about you so that we can provide a convenient, confidential platform for you to access information and Services, as defined in the Terms of Use. We receive information about you, in accordance with law, that you may consider private, including protected health information (\u201CPHI\u201D) as defined in the Health Insurance Portability and Accountability Act of 1996 (\u201CHIPAA\u201D) and the Health Information Technology for Economic and Clinical Health (HITECH) Act. HIPAA and other federal and state laws are designed to protect your privacy and the security of the information your healthcare providers share with us and that we share with others. As described below, we follow these laws and protect your privacy by diligently safeguarding your information from those who do not have a legitimate need for it.</p><p>We also collect information from you through the Site. We may share the information you provide with your healthcare providers, insurance companies, billing companies, and others as permitted by law (\u201Chealthcare entities\u201D). Information we request from you and/or may share with healthcare entities about you may include your full name, address, telephone number(s), social security number, medical appointment reminders, descriptions of upcoming or past healthcare services, health insurance account information, the name of your physician, radiologist or other healthcare provider, reports about your medical condition, information about whether your insurance has paid its share and whether your account shows a balance, no balance, or a credit, and other financial and account information.</p><p>When you use the Site, we collect other information from you such as:</p><ul class="list-ul"><li>Technical information about how and when you use the Site;</li><li>Technical information about your mobile device or computer, including the operating system you use;</li><li>Your general location when you use the Site;</li><li>Your internet protocol (<b>IP</b>) address and MAC address;</li><li>Internet Service Provider (\u201C<b>ISP</b>\u201D);</li><li>Date/time stamp;</li><li>Your browser type and connection speed; and</li><li>Your activities on the Site; and</li><li>Other information your browser may send to us.</li></ul><p>When you access the Site from an application on a mobile device (\u201CApp\u201D), we may also collect information from that device, which may include location data, device identification, and other information about usage. We may use this information to improve the App and to otherwise communicate with you. Additionally, we may send push notifications through the App from time to time to update you about certain services. If you do not wish to receive such communications, you will be able to turn them off at the device level.</p><p>To track users\u2019 activities on the Site, we may use web beacons and cookies. Web beacons are small graphic images or other web programming code that are used to track the online movements of Users of our Site, informing us what content is effective accessed. Cookies are small files that a site or its service provider transfers to your computer\u2019s hard drive through your web browser, if you allow, that help us monitor and measure the use of our Site and improve the Site\u2019s design and content.</p><h3 class="mb-10px pt-25px fw-500 txt-clr-14">How We Protect Your Information</h3><p>When you register through the Site, you will select a unique user name and complex password. You will need to re-enter this information each time you log in to protected areas of the Site. These password-protected areas are referred to Secure Portals. This is where you will submit personal information, including your identity, health, and financial information. In transit between your browser and our system, this information is encrypted with Secure Socket Layers (\u201CSSL\u201D) technology to create a protected connection between you and the Site to ensure confidentiality. Information on the Secure Portals is encrypted and/or otherwise safeguarded in accordance with law. Our data center servers are physically and electronically secured and are protected by firewall and encryption technology.</p><p>We have appropriate security measures (including technical and organizational measures) in place to protect against the loss, misuse, and alteration of any information we receive about you through the Site. <b>Of course we cannot guarantee that information will not be accessed, disclosed, altered, or destroyed by breach of any of our physical, technical, or managerial safeguards. When you submit information to us through our Site, you should be aware that your information is transmitted across the Internet and that no method of transmission over the Internet is completely or 100% secure.</b> Please note in particular that emails, live chat messages and other communications you send to us are not encrypted.</p><h3 class="mb-10px pt-25px fw-500 txt-clr-14">How Long We Retain Your Information</h3><p>We will retain your information for the length of time it takes to provide the Services and then in accordance with law and your health care entities\u2019 requirements.</p></div><div class="h-20px"></div></div></div>');
$templateCache.put('app/pages/policy/termsofuse.html','<style>\r\n    body {\r\n        overflow-y: auto !important\r\n    }\r\n\r\n    p {\r\n        margin-bottom: 15px;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .list-ul li {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .list-ul {\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .list-ol li {\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .list-ol {\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n\r\n    .panel-heading .accordion-toggle:after {\r\n        font-family: \'Glyphicons Halflings\';\r\n        content: "\\e114";\r\n        float: right;\r\n        color: #B1FFF4;\r\n    }\r\n\r\n    .panel-heading .accordion-toggle.collapsed:after {\r\n        content: "\\e080";\r\n    }\r\n    .panel.panel-default {\r\n        border: 1px solid #63686b !important;\r\n    }\r\n    .panel > .panel-heading {\r\n        color: #B1FFF4 !important;\r\n        border-radius: 3px !important;\r\n        background: #191819 !important;\r\n        padding: 11px 15px !important;\r\n        border-bottom: none !important;\r\n        height:46px !important\r\n    }\r\n\r\n    .panel-title a:hover {\r\n        color: #07e6c4;\r\n    }\r\n\r\n    .panel-body {\r\n        color: #e0dede !important;\r\n        background: #1f1e1f !important;\r\n        padding: 25px 20px !important;\r\n    }\r\n\r\n    .panel-group .panel + .panel {\r\n        margin-top: 10px !important;\r\n    }\r\n\r\n\r\n</style><div class="page-top clearfix" style="height:auto !important"><div class="w-85 m-0-auto"><div class="navbar-custom-menu float-left"><ul class="navbar-nav dropMenu pl-0 w-100" style="list-style:none;"><li class="dropdown messages-menu"><a href="#/dashboard" class="dropdown-toggle d-block pb-10px"><img src="assets/img/radflow.png" class="h-60px"></a></li></ul></div><div class="navbar-custom-menu pull-right"><ul class="nav navbar-nav"><li class="user user-menu nav-hover h-60px"><a href="#" ui-sref="Login" class="pt-20px fs-16px mt-10px txt-clr-16" style="background-color:transparent!important;"><span class=""><i class="fa fa-chevron-left txt-clr-16 fs-16px"></i> Back</span></a></li></ul></div><div class="clearfix"></div></div></div><div class="al-main"><div class="w-85 m-0-auto"><div class="h-70px"></div><div class="fs-16px fw-500 txt-clr-1 lh-1-5 text-justify mb-25px"><h1 class="mb-20px fs-30px">Terms of Use</h1><div class="pb-25px"><p>Welcome to our website! These Terms of Use are applicable to two related websites, www.myimagingstudy.com and https://radflow.collaborativeimaging.com. Collaborative Imaging (\u201Cwe,\u201D \u201Cus,\u201D \u201Cour,\u201D or \u201CCI\u201D) makes these websites available exclusively to patients of radiology and other healthcare providers for which we provide administrative services. We developed the websites to provide a convenient, confidential platform for you to access Services, as defined below, that we provide at your healthcare provider\u2019s request.</p><p>If you are viewing these Terms of Use on www.myimagingstudy.com, we may provide you with pre-service information and you may be asked to complete pre-service forms for upcoming healthcare services you scheduled. If you are viewing these Terms of Use on https://radflow.collaborativeimaging.com, we may provide you with post-service information, like insurance coverage and payment information, an opportunity to pay your bill on line, or a way to view records like a radiology report. Throughout these Terms of Use the website you are currently accessing will be referred to as \u201Cthe Site\u201D unless the text refers to one of them specifically.</p></div><div class="b-clr-3"><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseOne"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" onclick="event.preventDefault();">Binding Agreement</a></h4></div><div id="collapseOne" class="panel-collapse collapse"><div class="panel-body"><p>PLEASE READ THESE TERMS OF USE CAREFULLY AND MAKE SURE YOU UNDERSTAND THEM BEFORE YOU PROCEED BECAUSE THE TERMS FORM A BINDING AGREEMENT BETWEEN YOU AND US WHEN YOU USE THE SITE. That is, if you access or use the Site, it will mean you read, understand, and expressly agree to the terms of this agreement, as modified from time to time without notice, that you will use the site only in accordance with all of the terms and conditions herein and in all other applicable agreements, notices, information, services, materials and other content provided by or through the Site and/or CI (\u201CTerms\u201D). If you are using the Services on behalf of a company, legal entity, person, or persons, you are nonetheless individually bound by the Terms even if one or more of these is also bound by the Terms or has a separate agreement with us. PLEASE BE SPECIFICALLY ADVISED THAT THE TERMS INCLUDE AN ARBITRATION PROVISION REQUIRING ALL CLAIMS TO BE RESOLVED THROUGH BINDING ARBITRATION, AND A CLAUSE REQUIRING YOU TO INDEMNIFY CI UNDER CERTAIN CIRCUMSTANCES.</p><p>Unless otherwise expressly permitted by us in writing or permitted by law, you may not use the Site and/or the Services if you do not agree to all Terms in effect when you access the Site and/or the Services. You agree that your healthcare provider(s) and CI are not obligated to offer the Site or Services to you and that CI may suspend or terminate your access to the Site or your ability to access Services for any reason, including violation of the Terms. You may discontinue your use of the Site and/or Services at any time.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" onclick="event.preventDefault();">Who May Use The Services</a></h4></div><div id="collapseTwo" class="panel-collapse collapse"><div class="panel-body"><p>You may use the services available through the Site if you are over the age of 18 or other legal age under applicable state law, and/or have the necessary capacity or authority to enter binding agreements like this through a consenting parent or legal guardian. <b>By proceeding to the Site, you are representing that you are over the age of 18 or other legal age under applicable state law, have the necessary capacity or authority to enter binding agreements, or are a consenting parent or legal guardian with full authority to accept these Terms of Service and to bind the user to these terms.</b> If you are under 18 or other legal age or are not the parent or legal guardian of someone receiving services from a Provider and you do not have such authority or do not agree to these terms, do not proceed to the Site.</p><p><b>Children under the age of 13 may not use the Services under any circumstances.</b></p><p><b>PARENTS/GUARDIANS AGREE TO FULLY INDEMNIFY CI AND TO HOLD CI HARMLESS AGAINST ANY AND ALL CLAIMS AND DAMAGES IF A REGISTERED USER WHO IS A MINOR BREACHES ANY OF THESE TERMS OF SERVICE.</b></p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseThree"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" onclick="event.preventDefault();">License</a></h4></div><div id="collapseThree" class="panel-collapse collapse"><div class="panel-body"><p>You are granted a limited, revocable license to make personal use only of the Site and Services in accordance with these Terms of Use. This license permits you to view the Site and use the Services, but expressly excludes, without limitation, any reproduction, duplication, sale, resale or other commercial use of the Site and the Services and/or making any derivative of the Site or Services. Any use of the Services in excess of this license is strictly prohibited and constitutes a violation of this Agreement, which may result in the termination of your right to access and use the Services.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseFour"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" onclick="event.preventDefault();">Services</a></h4></div><div id="collapseFour" class="panel-collapse collapse"><div class="panel-body"><p>CI performs the kind of services that a physician office staff or service may perform for your convenience, including providing you with appointment reminders, access to records and forms, information about your services, insurance payments, and other account information (\u201CServices\u201D).</p><p>The Services also include sending you healthcare related text messages, including appointment confirmations and reminders, confirmation that your insurance has been verified and authorization provided, information about any applicable deductibles or other co-pays on your account, requests that you complete forms, notification that radiology, lab, or other reports have been provided to your physician(s), and/or information about whether your insurance has paid its share and whether your account shows a balance, no balance, or a credit. See our Text Messaging Terms of Use.</p><p>CI does not provide any medical advice, treatment, diagnosis, interpretation of radiological images, or other medical services and does not practice medicine. The Services are not provided in the course of a professional relationship between a health care provider and a patient and are not intended to create any patient relationship, nor should they be considered a replacement for consultation with a health care professional. You should never disregard medical advice or delay seeking medical advice because of content available on the services or the information you receive through the services.</p><p>You may receive access to some of your medical records through the Site. The availability of any medical records through the Site will depend on various factors, including whether your provider has given us copies and whether technological limitations affect our ability to provide such records through the Site. Further, CI and some of its healthcare provider clients only maintain medical records relating to the services you receive from them. These records are likely a small subset of your permanent medical record.</p><p>Note that your healthcare provider(s) may not send copies of records, reports and other information that they provide to us for posting to the Site unless you ask your provider for them.<b>If you would like copies of medical records that are not available through the Site or want records to be sent to third parties, you must contact your healthcare provider(s) and follow their procedures.</b> While your provider(s) are required by federal and state laws to give their patients copies of certain medical records, CI is not covered by these laws and again, does not receive all of the records you may want.</p><p>If you do not want us to post your medical records on the Site for you to access, please inform us of this choice by emailing us at patientservices@CollaborativeImaging.com.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseFive"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseFive" onclick="event.preventDefault();">Communicating With Us</a></h4></div><div id="collapseFive" class="panel-collapse collapse"><div class="panel-body"><p>You may communicate with us on the Site through our live chat platform (\u201CLive Chat\u201D) or you may email or call us. Live Chat will be available between 8:00 a.m. and 6:00 p.m. central time. As described in our Privacy Policy, which is incorporated into these Terms of Use, the information you provide through Live Chat could be viewed by others, and you may need to provide personal information to validate that you are who you say you are before CI can respond. We will save the text of Live Chats and store it securely until destroyed in accordance with our document destruction policies.</p><p>We cannot guaranty that we will have the information you ask us to provide when you chat with, email, or call us but we will try to promptly respond to your questions and/or requests. If we do not have the answers, we will provide suggestions about who you may contact for more information.</p><p>You will also need to provide information to verify your identity if you chat with, call or email us, as discussed below.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseSix"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseSix" onclick="event.preventDefault();">Reservation of Rights and Intellectual Property</a></h4></div><div id="collapseSix" class="panel-collapse collapse"><div class="panel-body"><p>As used herein, \u201CIntellectual Property Rights\u201D shall mean all tangible and intangible legal rights or interests evidenced by or embodied in: (a) any idea, design, concept, technique, invention, discovery or improvement, regardless of patentability, but including patents, patent applications, trade secrets, and know-how; (b) any work of authorship, regardless of copyright applicability, but including copyrights and any moral rights recognized by law; (c) any trademark, trade name or service mark; and (d) any other intellectual property, proprietary or similar rights, including all goodwill pertaining thereto and in each case, on a worldwide basis. CI, its affiliates, or third parties own and hold all rights, titles and interests in and to the Services and all Intellectual Property Rights contained therein, all documentation, ideas on which the Site and Services are based, software and information, algorithms, methods and processes, institutional knowledge, and all materials related to the Site and the Services, including documents presented to you via the Services (\u201CMaterials\u201D) and all Intellectual Property Rights derived therefrom (\u201CMaterials\u201D).</p><p>You agree not to attempt to copy, reproduce, change, disassemble, reverse engineer, decrypt, frame or translate any part of the Services or otherwise attempt to learn, access, decompile, reverse engineer or otherwise derive the source code, algorithms, structure, or ideas upon which the Services are based or attempt to copy, change, delete or alter any content or functionality within the Services.</p><p>CI reserves all rights not expressly granted to you in these Terms of Use.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseSevan"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseSevan" onclick="event.preventDefault();">Sharing of Information You Provide to Us</a></h4></div><div id="collapseSevan" class="panel-collapse collapse"><div class="panel-body"><p>As described in our Privacy Policy, as part of the Services, CI may convey some but not all information from or about you or your account to your healthcare provider, your health insurance company, the billing company or clearinghouse that processes healthcare claims for services you receive, or a collection company if necessary to collect a debt. You should not assume that messages you send to CI will be conveyed to your healthcare provider(s), insurance company, or other third party. To request that your medical records, invoice, or other documents be sent to another party, please contact your healthcare provider.</p><p>Please be further advised that information you provide on the Site, by email, or by telephone will not be included in your medical record.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseEight"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseEight" onclick="event.preventDefault();">Information You May Need For Accessing the Site And/Or Services</a></h4></div><div id="collapseEight" class="panel-collapse collapse"><div class="panel-body"><p>CI understands that your privacy is important. For details about how we collect and use information about you please review our Privacy Policy. We control access to the Site and Services and require verification of your identity to protect your privacy. To access the Site or use Services, including those offered by email or telephone, we may request information about you including your full name, date of birth, provider account or invoice number, and/or the email address you gave your healthcare provider when you scheduled an appointment.</p><p>Sometimes we may send an email to an address you provided to your healthcare provider or to us containing an enrollment or other code that you may use to access your records, information and forms and/or the Site. The code will remain valid for 24 hours and will be retired after the first use.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseNine"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseNine" onclick="event.preventDefault();">Availability and Operation of the Site</a></h4></div><div id="collapseNine" class="panel-collapse collapse"><div class="panel-body"><p>The Site is designed to be accessible through standard commercial web browsers and internet service providers on laptops, cell phones, tablets, and other devices. The quality of your experience with the Site will depend largely on the equipment and internet connections you use. We do not guarantee that the Services will operate with your computer, tablet, mobile device, network, installed software, internet or mobile carrier service plans, or with any particular computer or other piece of hardware, software, equipment, or device you install on or use with your computer.</p><p>CI will attempt to keep the Site operational at all times, but availability may be interrupted from time to time for maintenance, repair, upgrading, or other activities or due to technical problems, natural disaster or other emergency. We do not represent, warrant, or guarantee that the Services will always be available or are completely free of human or technological errors.</p><p>The Site and/or Services may contain typographical mistakes, inaccuracies, or omissions and some information may not be complete or current. We do not make any representation or warranty concerning errors, omissions, delays, or defects in the Services or any information supplied to you via the Services. We expressly reserve the right to correct any errors, inaccuracies, or omissions and to change or update information at any time without prior notice.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseTen"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTen" onclick="event.preventDefault();">Your Use of the Site and Services And Specific Agreements</a></h4></div><div id="collapseTen" class="panel-collapse collapse"><div class="panel-body"><p>Your Use of the Site and Services And Specific Agreements</p><ol type="1" class="list-ol"><li>You agree that you are solely responsible for your use of the Site and the Services and you represent and warrant that your use will comply with all applicable laws and regulations. You agree that you will not use the Site or the Services in a way that violates the rights of a third party.</li><li>You are responsible for providing all software equipment, and connections necessary to use the Services on the Site.</li><li>You agree not to use the Site or any CI Service to communicate offensive, hateful, defamatory, harassing, threatening, abusive, embarrassing, or discriminatory speech.</li><li><p>You agree that when using the Site and/or Services, you will not:</p><ol type="a" class="list-ol"><li>Delete, modify, hack, or attempt to change or alter any portion of the Site or Services;</li><li>Use any device, software, or routine intended to damage or otherwise interfere with the proper functioning of the Site and Services or take any other action that interferes with any other person\u2019s use of Services or introduce into the Site any back door, time bomb, drop dead device, or other software routine designed to interfere with or disable a computer program automatically with the passage of time or under the positive control of an unauthorized person or any virus, rogue program, Trojan horse, worm, bot, spider, or other automatic or manual device or process, or other malicious or intentionally destructive code, software routines, or equipment components designed to permit unauthorized access to private information on the Site or to disable, erase, or otherwise harm the Services or perform any such actions;</li><li>Copy, modify, create derivative works, reverse engineer, decompile, disassemble, or otherwise attempt to learn the source code, algorithms, structure, or ideas upon which the Site or Services are based;</li><li>Use the Services in any manner that misappropriates any trade secret or infringes any copyright, trademark, patent, rights of publicity, or other proprietary right of any party;</li><li>Access or attempt to access any other person\u2019s information or content;</li><li>Encourage any illegal activities;</li><li>Connect to or access any CI computer system or network without authorization; or</li><li>Use the information in the Services to create or sell a similar service or similar information.</li></ol></li><li>You agree that you will provide accurate and complete information in the registration or activation process on the Site, in any requested forms or submissions to CI, and that if you see inaccuracies in information about you on the Site, you will contact us to correct it. Your use of the Services may be suspended at any time that you do not provide complete information as requested, including information for payment of your account.</li><li>YOU HEREBY EXPRESSLY ASSUME THE SOLE RISK OF ANY UNAUTHORIZED DISCLOSURE OR INTENTIONAL INTRUSION, OR OF ANY DELAY, FAILURE, INTERRUPTION, OR CORRUPTION OF DATA OR OTHER INFORMATION TRANSMITTED IN CONNECTION WITH THE USE OF THIS SERVICE.</li></ol></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseEleven"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseEleven" onclick="event.preventDefault();">Security</a></h4></div><div id="collapseEleven" class="panel-collapse collapse"><div class="panel-body"><p>The Site uses information security safeguards and protections. However, no system can perfectly guard against risks of intentional intrusion or inadvertent disclosure of information. Information may be transmitted over a medium that is beyond our control.</p><p>The security of the information contained on the Site will depend on the equipment and internet connections you use, whether you maintain and regularly use current antivirus and antispyware and firewall software on your computer or other devices, and how you protect your privacy. You are solely responsible for protecting your devices against unauthorized use and access. When you access the Site and your account, you do so at your own risk.</p><p>If you do not want others to gain access to your account or personal health information, you will need to take precautions. For example, if your computer stores and automatically uploads your user names and passwords when you visit websites, you may want to ensure this function is disabled when you log into the Site. If another person has a right to use your computer or other device or you leave your device unattended when it is logged onto the Site, your personal information may be disclosed. CI cannot protect against this kind of unauthorized access.</p><p>You should keep your user ID and password in a secure location and completely confidential. It is your responsibility to also prevent disclosure of any temporary access codes and passwords and to change your password if you feel that your security has been compromised. We shall not be liable for any damages that result from your failure to keep your password secure.</p><p><b>You specifically agree that we will not be liable for any damages that result from your failure to keep your password secure.</b></p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseTwelve"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwelve" onclick="event.preventDefault();">Limitation on Liability</a></h4></div><div id="collapseTwelve" class="panel-collapse collapse"><div class="panel-body"><p><b>CI, its affiliates, owners, and their respective officers, directors, agents, and employees (\u201CCI Parties\u201D) will not be liable to you for your use of the services and may not be held responsible for any damages to you or anyone filing suit on your behalf for any reason. YOU VOLUNTARILY AND UNEQUIVOCALLY WAIVE ANY RIGHT OF ACTION AGAINST US. YOUR SOLE AND EXCLUSIVE REMEDY FOR DISSATISFACTION WITH THE SERVICES WILL BE TO STOP USING THE SERVICES.</b></p><p>Some jurisdictions do not allow the exclusion of certain warranties or the limitation or exclusion of liability for incidental or consequential damages, and as a result some of the above disclaimers may not apply to you. To the extent we may not, as a matter of applicable law, disclaim any implied warranty or limit its liabilities, you agree that the scope and duration of such warranty and the extent of our liability shall be the minimum permitted under applicable law.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseTheirteen"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTheirteen" onclick="event.preventDefault();">Indemnification</a></h4></div><div id="collapseTheirteen" class="panel-collapse collapse"><div class="panel-body"><p>YOU WILL HOLD HARMLESS, INDEMNIFY, AND DEFEND THE CI PARTIES FROM AND AGAINST ANY AND ALL CLAIMS (INCLUDING ANY AND ALL LIABILITIES, DAMAGES, LOSSES, COSTS, EXPENSES, AND REASONABLE ATTORNEYS\u2019 FEES ARISING THEREFROM) RELATING TO ANY ACTION OR PROCEEDING BROUGHT BY A THIRD PARTY AGAINST ANY ONE OR MORE OF THE CI PARTIES: (I) ALLEGING INJURY, DAMAGE, OR LOSS RESULTING FROM YOUR USE OF THE SERVICES; (II) ALLEGING THAT YOUR DATA INFRINGES A COPYRIGHT, PATENT, OR TRADEMARK OR MISAPPROPRIATES A TRADE SECRET OF A THIRD PARTY; (III) RELATED TO ANY ACT OR OMISSION BY YOU WHICH IS A BREACH OF YOUR OBLIGATIONS UNDER THIS AGREEMENT; AND (IV) YOUR USE OF INFORMATION OR RESULTS OBTAINED THROUGH THE SERVICES.</p><p>You will have the right to defend and compromise such claim at your expense for the benefit of the CI Parties; provided, however, you will not have the right to obligate the CI Parties in any respect in connection with any such settlement without the written consent of the indemnified party. Notwithstanding the foregoing, if you fail to assume your obligation to defend, the CI Parties may do so to protect their interests and you will reimburse all costs incurred by the Collaborative Imaging Parties in connection with such defense.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseFourteen"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseFourteen" onclick="event.preventDefault();">Choice of Law</a></h4></div><div id="collapseFourteen" class="panel-collapse collapse"><div class="panel-body"><p>The interpretation of this Agreement and the resolution of any disputes relating to this Agreement will be governed by the laws of the State of Texas without regard to any conflicts of laws provisions.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseFifteen"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseFifteen" onclick="event.preventDefault();">Arbitration</a></h4></div><div id="collapseFifteen" class="panel-collapse collapse"><div class="panel-body"><p><b>You and CI agree that all claims arising out of, or related to, this agreement must be resolved exclusively by binding arbitration located in Plano, Texas, as administered by JAMS or the American Health Lawyers\u2019 Association under the applicable rules then in effect except as otherwise agreed by the parties or as described below. You and CI also agree that the federal arbitration act will not apply to disputes arising out of or related to this agreement. You and CI further agree to submit to the personal jurisdiction of the courts located within Collin County, Texas, for the purpose of litigating any refusal to arbitrate. Notwithstanding the above, you agree that CI shall still be allowed to apply for injunctive remedies (or an equivalent type of urgent legal relief) in any jurisdiction. In no event shall you seek or be entitled to rescission, injunctive or other equitable relief, or to enjoin or restrain the operation of the service, exploitation of any advertising or other materials issued in connection therewith, or exploitation of the services or any content or other material used or displayed through the services.</b></p><p><b>For any claim (excluding claims for injunctive or other equitable relief) where the total amount of the award sought is less than $10,000, the party requesting relief may elect to resolve the dispute in a cost effective manner through binding non-appearance-based arbitration, in which case you and CI must comply with the following rules:</b></p><ol type="a" class="list-ol"><li><b>and CI will each waive any right to participate as a plaintiff or class member in any purported class action or representative proceeding.</b></li><li>Unless otherwise agreed, an arbitrator may not consolidate more than one person\u2019s claims and may not otherwise preside over any form of any class or representative proceeding.</li></ol>Notwithstanding anything to the contrary herein, you and CI agree each will bear their own attorneys\u2019 fees and costs incurred in connection with any dispute, court proceeding, or arbitration.</div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseSixteen"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseSixteen" onclick="event.preventDefault();">SEVERABILITY, TIME LIMITATION ON ACTIONS, AND WAIVER</a></h4></div><div id="collapseSixteen" class="panel-collapse collapse"><div class="panel-body"><p>If any provision of these Terms of Service is found by a court of competent jurisdiction or a duly appointed arbitrator to be invalid, you and CI nevertheless agree that the arbitrator or a court, as applicable, should give the effect to the parties\u2019 intentions as reflected in the provision, and that the other provisions of these Terms of Service remain in full force and effect.</p><p>The security of the information contained on the Site will depend on the equipment and internet connections you use, whether you maintain and regularly use current antivirus and antispyware and firewall software on your computer or other devices, and how you protect your privacy. You are solely responsible for protecting your devices against unauthorized use and access. When you access the Site and your account, you do so at your own risk.</p><p>YOU AND CI AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SERVICES MUST BE COMMENCED WITHIN ONE (!) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.Our failure to act with respect to a breach or violation by you or others of these Terms of Service does not waive our right to act with respect to that breach or subsequent similar or other breaches.</p></div></div></div><div class="panel panel-default"><div class="panel-heading cursor-pointer w-100" data-toggle="collapse" data-parent="#accordion" href="#collapseSevanteen"><h4 class="panel-title"><a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseSevanteen" onclick="event.preventDefault();">Collaborative Imaging SMS (Text Messaging) Terms of Service and Privacy Notice</a></h4></div><div id="collapseSevanteen" class="panel-collapse collapse"><div class="panel-body"><p>If you are reading these SMS (Text Messaging) Terms of Service and Privacy Notice (\u201CTerms of Service\u201D or \u201CTerms\u201D), you probably received a text message from us with a link to this document.<b>We are not a marketing company and we will not attempt to sell goods or services to you.</b> We received your mobile number from your radiology provider (\u201CProvider\u201D) when you made an appointment. Your Provider retained Collaborative Imaging (\u201Cwe,\u201D \u201Cus,\u201D \u201Cour,\u201D or \u201CCI\u201D) to connect you with certain services we provide at no charge to you. We will engage with you via text message for your convenience, based on the terms and assurances we provide you below.</p><p>If you would like a translation of these SMS (Text Messaging) Terms of Service and Use (\u201CTerms of Service\u201D) into another language, please contact us at info@collaborativeimaging.com.</p><p><b>PLEASE READ THESE TERMS OF SERVICE CAREFULLY AND UNDERSTAND THEM BEFORE YOU PROCEED because the terms and conditions form a binding agreement between you and us regarding text messages we exchange. If you respond to any of our text messages, it will mean you read, understood and expressly agree to the Terms and that you will use the text message services only in accordance with all of the terms and conditions herein and all other applicable agreements, information, services, materials and other content provided by or through CI and/or your health plan or Provider. You may not use the services if you do not agree to all terms and conditions in these Terms of Service, including the arbitration and indemnity provisions, unless otherwise agreed or permitted by law. Therefore, if any Term is unacceptable to you, please text \u201CSTOP\u201D to us.</b></p><p><b>If you have questions about a text message you receive or these Terms, please visit the patient section of our website</b>, <a href="https://collaborativeimaging.com/" target="_blank" class="txt-clr-14 a-hov-line">www.COLLABORATIVEIMAGING.com</a>, <b>contact us at <a href="mailto:info@CollaborativeImaging.com" class="txt-clr-14 a-hov-line">info@CollaborativeImaging.com</a> or 888-___-____ or contact your Provider.</b></p><div class="fw-600 fs-23px text-center" style="text-decoration:underline">Terms</div><p></p><ol class="list-ol"><li><div class="mb-5px">You must be 18 years of age or older to receive the SMS (texting) services. By responding to a text message from us, you represent that you are over the age of 18 or other legal age under applicable state law, have the necessary capacity or authority to enter binding agreements like this, or are a consenting parent or legal guardian with full authority to accept these Terms of Service and to bind the user to these terms. If you are under 18 or other legal age or are not the parent or legal guardian of someone receiving services from a Provider and you do not have such authority or do not agree to these terms, please contact us immediately via text message or email [address] or by calling [phone number].</div><div class="mb-5px"><b>Children under the age of 13 may not use the services under any circumstances unless a parent or other guardian with full legal authority contacts us to receive for a Consent And Authorization To Provide Services To Children Under The Age Of 13, In Compliance With The Children\u2019s Online Privacy Protection Act (\u201CCOPPA Consent\u201D), and reviews, completes, understands, verifies, submits and follows the COPPA Consent. The required COPPA Consent form and verification must be returned to CI and you must receive an approval before a child under 13 may use the services.</b></div><div class="mb-5px"><b>PARENTS/GUARDIANS AGREE TO FULLY INDEMNIFY CI AND TO HOLD CI HARMLESS AGAINST ANY AND ALL CLAIMS AND DAMAGES IF A REGISTERED USER WHO IS A MINOR BREACHES ANY OF THESE TERMS OF SERVICE.</b></div></li><li>CI performs the kind of services that a physician office staff or service may perform for your convenience, including providing you with appointment reminders and information about your services, account, and insurance payments (\u201CServices\u201D). The Services include sending you healthcare related messages like appointment confirmations and reminders, confirmation that your insurance has been verified and authorization provided, information about any applicable deductibles or other co-pays on your account, requests that you complete forms, notification that your radiology report has been provided to your physician, information about whether your insurance has paid its share and whether your account shows a balance, no balance, or a credit.</li><li>We value your privacy. To allow us to perform the Services, your Provider sends us information about you, including your mobile phone number, via a secure portal, and we store the information securely and use or disclose it only as necessary to perform the Services and always in compliance with the Health Insurance Portability and Accountability Act (\u201CHIPAA\u201D) and other applicable laws. Find out more how we safeguard and share information about you by reading our privacy policy at: <a href="https://CollaborativeImaging.com/privacypolicy/" class="txt-clr-14 a-hov-line text-break-word" target="_blank">https://CollaborativeImaging.com/privacypolicy/</a></li><li>We value your time. We will not text you outside the hours of 8 a.m. and 6 p.m., will not send you a text more than once, and will try to keep our messages brief.</li><li>We value your choices. Whether or not you use the Services is always your choice. You can cancel our texting Service at any time. Just reply to a text from us with "STOP." After you send the message "STOP" to us, we will send you one more text message to confirm that you have been unsubscribed. After this, you will no longer receive text messages from us. If you later want to receive our texts, simply text \u201CSTART\u201D to _______________.</li><li><p>We try to be responsive to your questions and concerns. If you respond to a text message from us with anything other than \u201CSTOP\u201D or \u201CSTART,\u201D you will receive an automated reply explaining that we are unable to respond to questions via text message but that you may obtain further information by visting <a href="https://collaborativeimaging.com/" target="_blank" class="txt-clr-14 a-hov-line">www.COLLABORATIVEIMAGING.com</a>, reviewing these Terms, emailing your question(s) or comment(s) to info@CollaborativeImaging.com, calling us at 888-\xAC\xAC\xAC___-____, or contacting your provider.</p><ol type="a" class="list-ol"><li>If you visit <a href="https://collaborativeimaging.com/" target="_blank" class="txt-clr-14 a-hov-line">www.COLLABORATIVEIMAGING.com</a> for further information, you will be asked to sign in using your full name and the email address you gave to your radiologist or other provider. We will then send you an email with an enrollment code that you may use to access your records, information and forms. The enrollment code will remain valid for 24 hours and will be retired after the first use.</li><li>If you send us questions via email, rest assured that we will try to respond quickly so we can make sure you have access to information or helpful services. <b>Unless you tell us something different, we will respond by replying to your email, and will assume you want us to send an email to the address you provide even though our email correspondence may not be private and probably is not secure in transmission or in your inbox.</b> We cannot be responsible for the level of security associated with your email account. If you want us to restrict the content of our responses or do not want us to respond via email, please make sure you tell us. We will try to accommodate all reasonable requests.</li></ol>Please do not ask us for any information about your medical condition or treatment. CI does not provide any medical services, practice medicine or any other licensed healthcare profession and will not seek to interfere with the practice of medicine or any other practice by physicians or other licensed practitioners.</li><li>If you do not have an unlimited texting plan with your mobile carrier, you may, of course, incur charges for messages you send to us and those you receive. We are not responsible for these. If you have any questions about your text plan or data plan, please contact your wireless provider, as we cannot help you with this.</li><li>Services offered or provided to you via text messages may have their own terms and conditions. These Terms of Service do not alter in any way the terms or conditions of any written terms, conditions, rules, or agreements you may have or will have with us, health plans, your doctor, other providers or other third parties (\u201COther Agreements\u201D). If there is any conflict between the Terms of Service and Other Agreements, the terms of the more specific Other Agreements will govern.</li><li><b>If you believe that you are entitled or obligated to act contrary to these Terms of Service under any law, you will provide us with a detailed explanation of your reasons in writing at least 30 days before you take action that is contrary to these Terms of Service to allow us to assess whether we may, at our sole discretion, provide an alternative remedy for the situation, though we are under no obligation to do so.</b></li><li>You agree not to use the Services, our text messages or the information or services described in them for commercial or public purposes, and that you will not: a) violate any local, state, national or international law; b) stalk, harass or harm another individual; c) collect or store personal data about other users or persons; d) impersonate any person or entity, or otherwise misrepresent your affiliation with a person or entity; e) interfere with or disrupt the services or disobey any requirements, procedures, policies or regulations connected to the services; and/or f) attempt to gain unauthorized access to any portion of the services or any other accounts, computer systems, or networks connected to the services, whether through hacking, password mining, or any other means; and/or g) impersonate any person or entity or otherwise misrepresent your affiliation with a person or entity.</li><li>You acknowledge and agree that all legal right, title and interest in and to the texting services are owned by CI and that CI owns all rights not expressly granted in and to such services. Except as otherwise required or limited by applicable law, any reproduction, distribution, modification, retransmission, publication or other commercial use of any copyrighted material is strictly prohibited without express written consent or the express written consent of the copyright owner or licensor. We respect the intellectual property rights of others and encourage you to do the same. Accordingly, we remove submissions that we believe may violate intellectual property rights of others and may suspend your access to the services (or any of them) if you violate someone\u2019s intellectual property or other rights.</li><li>We may provide links to third-party websites. If we do, we are not obligated to review such third-party websites, we do not control them, and we are not responsible for the products, services, or content available through any of them. Further, we do not endorse or make any representations about such third-party websites, and/or any information, software, products, services, or materials found there or any results that may be obtained from using them. If you decide to access any third-party websites we may link from the services, you do this entirely at your own risk.</li><li><div class="mb-5px"><b>You also agree that use of the services is at your sole risk and that the services are provided on an \u201Cas is\u201D and \u201Cas available\u201D basis. CI expressly disclaims all warranties of any kind, whether express or implied, any warranties of merchantability, fitness for a particular use or purpose, non-infringement, title, operability, condition, quiet enjoyment, value, accuracy of data and system integration. CI makes no warranty that the services will meet your requirements, or that the services will be uninterrupted, timely, secure, or error free. Further, CI does not make any warranty as to the results that may be obtained from the use of the services, or that defects in the services will be corrected. You understand and agree that you obtain any material through the use of the services at your own discretion and risk and that you will be solely responsible for any damage or loss of data that results, and that no advice or information, whether oral or written, obtained by you from CI or through the services will create any warranty not expressly made herein.</b></div><div class="mb-5px">The services are not intended to provide a substitute for your own sound and reasonably prudent judgment. Persons using the services assume full responsibility for the use of the services, materials and other information provided and agree that CI is not responsible or liable for any claim, loss, or damage arising from their use. Your reliance on the content obtained or used by you is solely at your own risk except as provided by law.</div></li><li><div><b>CI, its affiliates, owners, and their respective officers, directors, agents, and employees (\u201CCI Parties\u201D) will not be liable to you for your use of the services and may not be held responsible for any damages to you or anyone filing suit on your behalf for any reason. YOU VOLUNTARILY AND UNEQUIVOCALLY WAIVE ANY RIGHT OF ACTION AGAINST US. YOUR SOLE AND EXCLUSIVE REMEDY FOR DISSATISFACTION WITH THE SERVICES WILL BE TO STOP USING THE SERVICES.</b></div><div>Some jurisdictions do not allow the exclusion of certain warranties or the limitation or exclusion of liability for incidental or consequential damages, and as a result some of the above disclaimers may not apply to you. To the extent we may not, as a matter of applicable law, disclaim any implied warranty or limit its liabilities, you agree that the scope and duration of such warranty and the extent of our liability shall be the minimum permitted under applicable law.</div></li><li>The interpretation of this Agreement and the resolution of any disputes relating to this Agreement will be governed by the laws of the State of Texas without regard to any conflicts of laws provisions. Except for disputes subject to arbitration as described below, any disputes relating to these Terms of Service or the services we provide will be heard in the courts located in ________ County, Texas.</li><li><p><b>You and CI agree that all claims arising out of, or related to, this agreement must be resolved exclusively by binding arbitration located in ___________, Texas, as administered by JAMS or the American Health Lawyers\u2019 Association under the applicable rules then in effect except as otherwise agreed by the parties or as described below. You and CI also agree that the federal arbitration act will not apply to disputes arising out of or related to this agreement. You and CI further agree to submit to the personal jurisdiction of the courts located within __________ County, Texas, for the purpose of litigating any refusal to arbitrate. Notwithstanding the above, you agree that CI shall still be allowed to apply for injunctive remedies (or an equivalent type of urgent legal relief) in any jurisdiction. In no event shall you seek or be entitled to rescission, injunctive or other equitable relief, or to enjoin or restrain the operation of the service, exploitation of any advertising or other materials issued in connection therewith, or exploitation of the services or any content or other material used or displayed through the services.</b></p><p><b>For any claim (excluding claims for injunctive or other equitable relief) where the total amount of the award sought is less than $10,000, the party requesting relief may elect to resolve the dispute in a cost effective manner through binding non-appearance-based arbitration, in which case you and CI must comply with the following rules:</b></p><ol type="a" class="list-ol"><li><b>You and CI will each waive any right to participate as a plaintiff or class member in any purported class action or representative proceeding.</b></li><li>Unless otherwise agreed, an arbitrator may not consolidate more than one person\u2019s claims and may not otherwise preside over any form of any class or representative proceeding.</li></ol></li><li>Notwithstanding anything to the contrary herein, you and CI agree each will bear their own attorneys\u2019 fees and costs incurred in connection with any dispute, court proceeding, or arbitration.</li><li>If any provision of these Terms of Service is found by a court of competent jurisdiction or a duly appointed arbitrator to be invalid, you and CI nevertheless agree that the arbitrator or a court, as applicable, should give the effect to the parties\u2019 intentions as reflected in the provision, and that the other provisions of these Terms of Service remain in full force and effect.</li><li>Our failure to act with respect to a breach or violation by you or others of these Terms of Service does not waive our right to act with respect to that breach or subsequent similar or other breaches.</li><li>You and IC agree that any cause of action arising out of or related to the Services must be commenced within one (1) year after the cause of action accrues. Otherwise, such cause of action is permanently barred.</li></ol><p></p></div></div></div></div></div></div><div class="h-20px"></div></div></div>');
$templateCache.put('app/pages/revieworder/revieworder.html','<style>\r\n    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {\r\n        /* IE9+ specific styles go here */\r\n        /*.disabled-grid {\r\n            display: block !important;\r\n            overflow-x: hidden !important;\r\n        }\r\n\r\n        .disabled-list-footer {\r\n            position: fixed !important;\r\n            bottom: 0 !important;\r\n            width: 100% !important;\r\n            padding-bottom: 5px;\r\n        }\r\n\r\n        .charges-list {\r\n            padding-bottom: 40px !important;\r\n            padding-top: 100px !important;\r\n        }\r\n\r\n        .mail-messages-control {\r\n            position: absolute;\r\n            width: 100%;\r\n            z-index: 1 !important;\r\n        }\r\n            */\r\n    }\r\n\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    .green {\r\n        color: green;\r\n    }\r\n\r\n    .gray {\r\n        color: gray;\r\n    }\r\n\r\n    /*.k-grid table thead tr th:first-child {\r\n        padding-left: 15px !important;\r\n    }\r\n\r\n    .k-grid table tbody tr td:first-child {\r\n        padding-left: 15px !important;\r\n    }*/\r\n    #ReportSiteDropdown .location-tags-input tags-input .tags {\r\n        border: 1px solid #969696 !important;\r\n    }\r\n    .location-tags-input tags-input .tags.focused {\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    .location-tags-input .tultiptext {\r\n        max-height: 250px !important;\r\n        top: 55px !important;\r\n    }\r\n\r\n    .kn-common-tbl.peer-reviewfooter .k-grid thead {\r\n        border-top: 1px solid #616161;\r\n        border-bottom: 1px solid #616161;\r\n        background-color: #303030;\r\n    }\r\n\r\n        .kn-common-tbl.peer-reviewfooter .k-grid thead th {\r\n            border-top: 1px solid #616161 !important\r\n        }\r\n\r\n    .kn-common-tbl.peer-reviewfooter .k-grid table tbody tr td {\r\n        background-color: #262526 !important;\r\n        border: 1px solid #382d2d !important;\r\n        border-right: 1px solid #382d2d !important;\r\n        border-bottom: 1px solid #616161 !important;\r\n    }\r\n\r\n    .review-exportModal .new-popup .modal-header {\r\n        border-bottom-left-radius: 5px !important;\r\n        border-bottom-right-radius: 5px;\r\n    }\r\n\r\n    .close-expmodal:hover {\r\n        opacity: 0.7\r\n    }\r\n\r\n    .hideHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        display: none;\r\n    }\r\n\r\n    .viewreportdesc {\r\n        border: 1px solid #63686b;\r\n        max-height: none;\r\n        height: calc(100vh - 420px);\r\n    }\r\n\r\n    .export-tooltip {\r\n        display: none;\r\n        padding: 6px;\r\n        background: #424242;\r\n        position: absolute;\r\n        right: 13px;\r\n        top: 34px;\r\n        z-index: 999;\r\n        border-radius: 4px;\r\n    }\r\n\r\n        .export-tooltip::after {\r\n            content: \'\';\r\n            position: absolute;\r\n            top: -12px;\r\n            left: 0;\r\n            right: 0;\r\n            border: 6px solid #494949;\r\n            width: 6px;\r\n            border-color: transparent transparent #494949 transparent;\r\n            margin: 0 auto;\r\n        }\r\n\r\n        .export-tooltip::before {\r\n            content: \'\';\r\n            position: absolute;\r\n            width: 100%;\r\n            height: 10px;\r\n            background: transparent;\r\n            top: -5px;\r\n        }\r\n\r\n        .export-tooltip .alink {\r\n            padding: 4px;\r\n            display: inline-block;\r\n            /*background-color: #494949 !important;*/\r\n        }\r\n\r\n            .export-tooltip .alink:link {\r\n                color: #fff;\r\n            }\r\n\r\n        .reviewExport:hover + .export-tooltip, .export-tooltip:hover {\r\n            display: block;\r\n        }\r\n\r\n        .export-tooltip .alink:hover {\r\n            color: #fff;\r\n            opacity: 0.8;\r\n            /*background-color: #696969 !important;*/\r\n            transition: all 100ms ease-in-out;\r\n        }\r\n\r\n    .modal-dialog {\r\n        vertical-align: baseline;\r\n    }\r\n\r\n     #ReportAGGrid .ag-header-cell .ag-header-cell-label {\r\n        text-align: center;\r\n        justify-content: center;\r\n    }\r\n\r\n     #ReportAGGrid .ag-ltr .ag-cell {\r\n        color: white !important;\r\n    }\r\n\r\n     #ReportAGGrid .ag-row {\r\n        text-align: right;\r\n    }\r\n\r\n     #ReportAGGrid .modal-dialog.review-exportModal {\r\n        height: auto;\r\n        vertical-align: baseline;\r\n    }\r\n\r\n     #ReportAGGrid .modal-body {\r\n        min-height: 150px;\r\n    }\r\n\r\n   #ReportAGGrid {\r\n        height: unset;\r\n        max-height: 750px;\r\n    }\r\n\r\n       #ReportAGGrid .ag-root-wrapper.ag-layout-normal {\r\n            height: unset;\r\n        }\r\n\r\n        #ReportAGGrid .ag-root-wrapper .ag-root-wrapper-body.ag-layout-normal {\r\n            max-height: 700px;\r\n            height: unset;\r\n        }\r\n\r\n              #ReportAGGrid .ag-root-wrapper .ag-root-wrapper-body.ag-layout-normal .ag-root.ag-layout-normal {\r\n                height: unset;\r\n                min-height: 150px;\r\n                max-height: 700px;\r\n            }\r\n\r\n          #ReportAGGrid .ag-ltr .ag-body-viewport {\r\n            height: unset;\r\n            max-height: 666px;\r\n        }\r\n\r\n          #ReportAGGrid .ag-row-last {\r\n            background-color: #1c1c1c;\r\n            text-align: right;\r\n        }\r\n\r\n              #ReportAGGrid .ag-row-last .ag-cell:first-of-type {\r\n                text-align: center !important;\r\n            }\r\n\r\n      .review-exportModal .mult-select .ui-select-match-text .glyphicon-remove {\r\n        right: 9px !important;\r\n        top: -3px !important;\r\n    }\r\n\r\n\r\n    .selected-score {\r\n        background-color: rgb(5 193 164 / 26%);\r\n        border: 1px solid #05C1A4 !important;\r\n        color: white !important;\r\n        border-radius: 5px;\r\n    }\r\n\r\n    .info-list .popover {\r\n        background-color: #323232;\r\n        border-color: #63686b;\r\n    }\r\n\r\n    .section-disbl {\r\n        pointer-events: none;\r\n        opacity: 0.7;\r\n    }\r\n\r\n    .comment-td {\r\n        overflow: visible !important;\r\n    }\r\n\r\n    tags-input .remove-button {\r\n        color: white !important;\r\n    }\r\n\r\n    .report-dec {\r\n        background-color: #272c2d;\r\n        padding: 5px;\r\n    }\r\n\r\n        .report-dec label {\r\n            font-size: 14px !important;\r\n        }\r\n\r\n    #PeerReviewAGGrid .ag-header .ag-header-cell:first-of-type {\r\n        padding-left: 5px !important;\r\n    }\r\n\r\n    .review-exportModal {\r\n        width: 75%;\r\n    }\r\n\r\n    #ReportAGGrid .ag-header .ag-header-cell {\r\n        padding-left: 0px !important;\r\n        padding-right: 0px !important;\r\n    }\r\n\r\n    .popover {\r\n        z-index: 9999999;\r\n    }\r\n\r\n    .selectedsite-width {\r\n        width: 80% !important;\r\n    }\r\n\r\n    #dvPeerReviewReport .col-sm-8 {\r\n        width: 66.66666667% !important;\r\n    }\r\n\r\n    .export-responsive .col-lg-4 {\r\n        width: 33.33333333% !important;\r\n    }\r\n    #ReportSiteDropdownGrid.multiSelectGridDiv\r\n    {\r\n        top: unset !important;\r\n    }\r\n    @media (max-width: 1199px) and (min-width: 768px) {\r\n        .review-exportModal {\r\n            width: 90%;\r\n        }\r\n\r\n        .popover {\r\n            padding-bottom: 10px;\r\n        }\r\n\r\n            .popover .popover-content {\r\n                max-height: 300px;\r\n                overflow-y: auto;\r\n            }\r\n\r\n            .popover.bottom > .arrow {\r\n                left: 55%;\r\n            }\r\n\r\n        .k-widget.k-window {\r\n            top: 50px !important;\r\n        }\r\n\r\n        .pdf-responsive {\r\n            display: none;\r\n        }\r\n\r\n        .selectedsite-width {\r\n            width: 100% !important;\r\n        }\r\n    }\r\n</style><div class="radf-header" keyboard="keys"><h2>Review Worklist</h2></div><div id="mainDiv" class="pportal-list"><div class="p-0 collapse in" id="collapseWorklist" role="tabpanel" aria-labelledby="heading_worklist"><form id="frmFilter" ng-submit="refresh(frmFilter.$valid)"><div class="row rf-filter-ui m-0 pt-8px filterspace peerreview-filterstep" style="margin-bottom:2px !important;"><div class="col-lg-2 col-sm-4 col-md-2 col-xs-6 mb-0 pd-lr tultip-bottom"><site-location-grid master-locations="Locations" selected-location="DataObject.SelectedLocations" on-change="updateSelectedLocation()"></site-location-grid></div><div class="col-lg-2 col-sm-2 col-md-2 col-xs-6 w-12 mob-pr-0 pd-lr"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="OrderDate" options="opts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial" uib-tooltip="{{DataObject.OrderDateTooltip}}" tooltip-placement="auto top"></div><div class="col-lg-1 col-sm-2 col-md-2 col-xs-6 pd-lr"><ui-select class="mult-select stbclr bg-clr-31" ng-model="DataObject.SelectedList.PatientClass" title="Select Type"><ui-select-match placeholder="Select Type" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PatientClass | propsFilter: {Value: $select.search}" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-1 col-sm-2 col-md-2 col-xs-6 pd-lr"><select id="ddlStatus" class="sing-select form-control downArrow-ie p-pw" ng-model="DataObject.ReviewStatus" ng-change="OnReviewStatusChanged()"><option value="Complete">Complete</option><option value="Pending">Pending</option></select></div><div class="col-lg-2 col-sm-3 col-md-2 col-xs-6 w-10 pd-lr review-buttons"><button type="submit" class="btn btn-primary rf-btn-xs pull-left mr-5px" ng-disabled="OnFilterDisabled()">Filter</button> <button type="button" ng-click="clearFilter();" class="btn btn-default rf-btn-xs pull-left mr-5px">Clear</button> <button type="button" class="btn btn-default report-btnstep rf-btn-xs pull-left reviewExport" id="reviewExport" data-toggle="modal" data-target="#ReviewExportModal" ng-if="DataObject.ReviewStatus==\'Complete\'" ng-click="ClearGridData();DataObject.ReportType = 0">Report</button></div></div></form></div><div id="PeerReviewAGGrid" class="myGrid ag-theme-balham-dark peerreview-grid stepmenupendingSub" style="width: 100%;"></div><div ng-show="isLoading" class="spinner-overlay" style="z-index:9999999;"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div class="ERA-check-detail peer-r-popup" kendo-window="win_Review" k-on-open="isReviewVisible = true" k-on-close="isReviewVisible = false;refresh();CloseAllWindows()" k-title="\'Review\'" k-visible="false" k-width="DataObject.win_ReviewWidth" k-height="DataObject.win_ReviewHeight" k-dragend="winDragend" k-modal="true" k-resize="winResize" k-actions=\'["Close"]\' k-animation="false"><div ng-if="isReviewVisible"><div class="denial-window"><div class="overflow-hide-all"><div class="row p-0 m-0"><div ng-form="review"><div class="col-sm-8 pl-0"><table class="blk-table w-100 b-1-s b-clr-1 border-bottom-0 mb-8px"><thead><tr class="side-message-navigation-item little-human shineHover data-row"><th class="w-15 pl-10px">LOCATION</th><th class="w-10">DOS</th><th class="w-6">TYPE</th><th class="w-8">MODALITY</th><th class="w-19">PROCEDURE</th><th class="w-2"></th></tr></thead><tbody><tr class="bb-1-s b-clr-1"><td class="pl-10px"><span style="white-space:pre-wrap;">{{DataObject.SelectedOrder.Location}}</span></td><td>{{DataObject.SelectedOrder.OrderDate}}</td><td>{{DataObject.SelectedOrder.PatientClass}}</td><td>{{DataObject.SelectedOrder.Modality}}</td><td><span style="white-space:pre-wrap;">{{DataObject.SelectedOrder.ProcedureDesc}}</span></td><td class="cursor-pointer"><div class="hovIcon-td text-center pos-rel"><a class="cursor-pointer tultip-left" ng-show="DataObject.SelectedOrder.OptionalDicomViewer.length > 0"><i class="fa fa-picture-o fs-17px txt-clr-14"></i> <span class="tultiptext font-normal">Dicom Viewer</span></a><span class="iconDropdown-2" style="left:-135px;"><a class="cursor-pointer p-0 tultip-left dvnew" ng-repeat="DV in DataObject.SelectedOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(DataObject.SelectedOrder , DV, false)"><span class="agfa d-block">{{SetDicomViewerText(DV)}}</span></a></span></div></td></tr></tbody></table><div class=""><div class="overflow-x-hide overflow-y-auto p-10px-all pl-5px pr-ht text-justify viewreportdesc"><report ng-bind-html="DataObject.SelectedOrder.ReportText" class="" style="white-space:pre-line;line-height:22px"></report></div></div></div><div class="col-sm-4 pl-5px pr-0"><div class="overflow-hide-all"><div><div class="form-group fw-600 form-controller d-flex align-item-center" ng-class="{\'section-disbl\': (ReviewOrder.ReviewStatus==\'COMPLETE\' || ReviewOrder.isReassignPeerReview)}">For Interesting Cases: <input type="checkbox" class="v-a-m ml-5px mt-0 cmn-checkbx-input" ng-checked="DataObject.SelectedOrder.IsInterestingCase" ng-model="ReviewOrder.IsInterestingCase" ng-disabled="DataObject.ReviewStatus==\'Complete\'" ng-click="ReviewOrder.Keywords = null; ReviewOrder.Comments = null"></div><div class="mb-10px" ng-class="{\'section-disbl\': (ReviewOrder.ReviewStatus==\'COMPLETE\' || ReviewOrder.isReassignPeerReview)}"><table class="blk-table w-100 b-1-s b-clr-1 border-bottom-0 tblsrscore"><thead><tr><th class="text-center">Sr.</th><th class="">Score</th></tr></thead></table><div class="pb-1px" style="max-height:50vh; overflow-y:auto;"><table class="blk-table w-100 b-1-s b-clr-1 border-bottom-0 tblsrscoredata"><tbody><tr ng-repeat="ScoreOption in DataObject.ScoreOption" style="border-bottom: solid thin #63686b;"><td class="text-center border-0">{{ScoreOption.Key}}</td><td ng-if="!ScoreOption.SubValue" class="border-0 w-100 p-5px-all"><div class="form-controller d-flex align-item-center p-5px-all" ng-class="{\'selected-score\' : (ReviewOrder.Rating==ScoreOption.Key)}"><input type="radio" class="cmn-checkbx-input mt-2px" id="{{ScoreOption.Key}}" ng-click="ReviewOrder.Rating=ScoreOption.Key" ng-checked="ReviewOrder.Rating==ScoreOption.Key"> <label class="rf-label cmn-check-label" for="{{ScoreOption.Key}}">{{ScoreOption.Value}}</label> <button uib-popover-template="dynamicPopover.templateUrl" type="button" popover-append-to-body="true" popover-placement="{{halfScale ? \'bottom\' : \'right\'}}" class="btn btn-transparent p-0" ng-click="getHtmlContent(ScoreOption.Key)" popover-trigger="focus"><i class="fa fa-info-circle txt-clr-1 pl-10px pt-2px"></i></button></div></td><td ng-if="ScoreOption.SubValue" class="border-0 w-100"><span class="text-preline">{{ScoreOption.Value}}</span><div class="p-5px-all form-controller d-flex align-item-center info-list" ng-repeat="SubValue in ScoreOption.SubValue" ng-class="{\'selected-score\' : (ReviewOrder.Rating==SubValue.Key)}"><input type="radio" class="m-0 cmn-checkbx-input" id="" ng-click="ReviewOrder.Rating=SubValue.Key" ng-checked="ReviewOrder.Rating==SubValue.Key"><label class="rf-label cmn-check-label" for="">{{SubValue.Key}}.{{SubValue.Value}}</label> <button ng-if="SubValue.htmlTemplate != \'\'" popover-append-to-body="true" uib-popover-template="dynamicPopover.templateUrl" type="button" popover-placement="{{halfScale ? \'bottom\' : \'right\'}}" class="btn btn-transparent p-0" ng-click="getHtmlContent(SubValue.Key)" popover-trigger="focus"><i class="fa fa-info-circle txt-clr-1 pl-10px pt-2px"></i></button></div></td></tr></tbody></table></div></div><div class="w-100 mb-10px" ng-show="ReviewOrder.IsInterestingCase" ng-class="{\'section-disbl\': (ReviewOrder.ReviewStatus==\'COMPLETE\' || ReviewOrder.isReassignPeerReview)}"><div class="txt-clr-1 pb-5px pl-5px">Keywords *</div><input type="text" class="blk-input form-control" name="keyword" ng-model="ReviewOrder.Keywords" placeholder="Keywords." ng-required="ReviewOrder.IsInterestingCase"></div><div class="mb-10px"><div class="pb-5px pl-5px fs-13px" ng-show="ReviewOrder.IsInterestingCase">Add a comment *</div><textarea class="txt-area h-70px w-100 outline-none px-10px" rows="4" name="comment" ng-model="ReviewOrder.Comments" placeholder="Add a comment" ng-required="ReviewOrder.IsInterestingCase"> </textarea></div></div><div class=""><button type="button" class="btn btn-primary m-1" ng-disabled="(!review.comment.$valid || !review.keyword.$valid) || ValidateReviewOrder()" ng-click="SaveReviewOrder(\'S\')">Save</button> <button type="button" class="btn btn-default" ng-disabled="ReviewOrder.isReassignPeerReview || ReviewOrder.ReviewStatus==\'COMPLETE\'" ng-click="SaveReviewOrder(\'D\')">Decline</button> <button type="button" class="btn btn-primary float-right m-1" ng-disabled="DataObject.isNextBtnDisable" ng-click="SaveReviewOrder(\'NEXT\')">Next</button> <button type="button" class="btn btn-primary float-right m-1" ng-disabled="DataObject.isPrevBtnDisable" ng-click="SaveReviewOrder(\'PREV\')">Prev</button></div><div class="text-right mt-5px"><span>Showing {{DataObject.SelectedOrder.CurrentOrderIndex}} out of {{DataObject.SelectedOrder.TotalRows}}</span></div></div></div></div></div></div></div></div></div><script type="text/ng-template" id="myPopoverTemplate.html"><div ng-bind-html="dynamicPopover.content"></div></script><div class="overflow-hide-all ERA-check-detail" kendo-window="win_DicomViewerCredentials" k-on-open="isDicomViewerCredentialsVisible = true" k-on-close="isDicomViewerCredentialsVisible = false" k-title="\'Review\'" k-visible="false" k-width="DataObject.win_DicomViewerCredentialsWidth" k-height="340" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Close"]\' k-animation="false"><div ng-if="isDicomViewerCredentialsVisible"><div class="modal-body" style="background:#006c9a !important; border-radius:0 !important"><div class="pScript m-0-auto pb-20px"><img src="assets/images/powerscribe360.png" class="mb-20px"><form name="DVCredform" id="DVCredform" ng-submit="InsertDicomViewerCredentials(DVCredform.$valid)"><div class="w-30 float-left"><label class="rf-label">Username:</label></div><div class="w-70 float-left"><input type="text" id="DVCredUsername" name="DVCredUsername" ng-model="DVCred.Username" ng-required="true" class="w-100 border-0 p-2px-all"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Password:</label></div><div class="w-70 float-left"><input type="password" id="DVCredUsername" name="DVCredUsername" ng-model="DVCred.Password" ng-required="true" class="w-100 border-0 p-2px-all"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-sm py-1px px-15px bor-rad-0 fw-600 bg-clr-12">Save</button></div><div class="clearfix"></div></form></div></div></div></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_DicomViewerCredentials" k-on-open="isDicomViewerCredentialsVisible = true" k-on-close="isDicomViewerCredentialsVisible = false" k-title="\'Review\'" k-visible="false" k-width="DataObject.win_DicomViewerCredentialsWidth" k-height="300" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Close"]\' k-animation="false"><div ng-if="isDicomViewerCredentialsVisible"><div class="modal-body" style="background:#41627d!important;border-radius:0!important;"><div class=""><div class="mdvctxt"><div class="row"><div class="col-md-12 col-sm-12 txt-clr-1"><h5 class="txt-clr-1 fs-18px">GE Healthcare</h5></div><div class="col-md-12 col-sm-12"><h4 class="txt-clr-1 fs-22px">Centricity<sup>*</sup></h4><h2 class="txt-clr-1 fs-26px">Universal Viewer</h2></div></div></div><div class="mdvcfrmouter"><form name="DVCredform" id="DVCredform" ng-submit="InsertDicomViewerCredentials(DVCredform.$valid)" class="mdvcfrm"><div class="w-30 float-left"><label class="rf-label">Username:</label></div><div class="w-70 float-left"><input type="text" id="DVCredUsername" name="DVCredUsername" ng-model="DVCred.Username" ng-required="true" class="w-100 border-0 p-5px-all h-30px" style="background-color:#fff!important;"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Password:</label></div><div class="w-70 float-left"><input type="password" id="DVCredUsername" name="DVCredUsername" ng-model="DVCred.Password" ng-required="true" class="w-100 border-0 p-5px-all h-30px" style="background-color:#fff!important;"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-sm py-1px px-15px bor-rad-0 fw-600 bg-clr-12 w-100 h-30px">Login</button></div><div class="clearfix"></div></form></div><div class="row"><div class="col-md-12 col-sm-12 text-left"><img src="assets/images/mdvc.png"></div></div></div></div></div></div><div id="ReviewExportModal" class="modal fade overflow-hide-all" role="dialog" data-backdrop="static"><div class="modal-dialog modal review-exportModal"><div class="modal-content new-popup"><div class="modal-header d-flex align-item-center"><h4 class="modal-title">Peer Review Report</h4><span class="d-flex"><button class="btn btn-transparent fs-18px txt-clr-1 p-0 icon-hover" ng-click="ReportClearFilter(true)" data-dismiss="modal"><i class="fa fa-times close-expmodal" style="color: #fff !important"></i></button></span></div><div class="modal-body p-0"><div class="row m-0 py-10px px-10px d-flex align-item-center"><div class="d-flex align-item-center pl-0 pr-10px col-lg-3 col-md-3"><label class="form-controller d-flex w-100 align-item-center p-2 mb-0" ng-class="{\'selected-score\' : (DataObject.ReportType == \'0\')}"><input class="m-0 cmn-checkbx-input" type="radio" name="ReportOptions" ng-model="DataObject.ReportType" value="0" ng-click="ReportClearFilter(false)" checked=""> <span class="rf-label cmn-check-label">Tenant Overall Report</span></label></div><div class="d-flex align-item-center pl-0 pr-10px col-md-3"><label class="form-controller w-100 d-flex align-item-center p-2 mb-0" ng-class="{\'selected-score\' : (DataObject.ReportType == \'1\')}"><input class="m-0 cmn-checkbx-input" type="radio" name="ReportOptions" ng-model="DataObject.ReportType" value="1" ng-click="ReportClearFilter(false)"> <span class="rf-label cmn-check-label">Individual Physician Report</span></label></div><div class="d-flex align-item-center pl-0 pr-10px col-md-3"><label class="form-controller w-100 d-flex align-item-center p-2 mb-0" ng-class="{\'selected-score\' : (DataObject.ReportType == \'2\')}"><input class="m-0 cmn-checkbx-input" type="radio" name="ReportOptions" ng-model="DataObject.ReportType" value="2" ng-click="ReportClearFilter(false)"> <span class="rf-label cmn-check-label">Physician Reviewed Record Summary</span></label></div></div><div class="row m-0 px-10px py-10px export-responsive"><div class="col-lg-2 col-md-3 pl-0 pr-10px"><label class="rf-label mb-2px cmn-check-label">Date Range</label> <input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="ReportOrderDate" options="reportOpts" autocomplete="off" readonly=""></div><div class="col-lg-2 col-md-4 pl-0 pr-10px"><label class="rf-label mb-2px cmn-check-label">Tenants</label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="DataObject.SelectedList.Tenant" ng-change="OnChangeTenant()"><ui-select-match placeholder="Select Tenant" class="overflow-y-auto d-block max-h-75px" allow-clear="false">{{$select.selected.TenantName}} <i class="glyphicon glyphicon-remove" aria-hidden="true" ng-click="ReportClearFilter(false)"></i></ui-select-match><ui-select-choices repeat="list in DataObject.Tenants | filter: {TenantName: $select.search}" position="down"><div ng-bind-html="list.TenantName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-3 col-md-5 pl-0 px-10px"><div class="form-group py-0 w-100 px-0 pos-rel"><label class="rf-label mb-2px cmn-check-label"><span>Site</span></label><multi-select master-data="DataObject.ReportSiteDropdown" list="DataObject.Sites" ng-model="DataObject.ReportSiteDropdown.SelectedValue" on-change="onSelectedSiteChange(selectedData)"></multi-select></div></div><div class="col-lg-2 col-md-5 pl-0 px-10px" ng-if="DataObject.ReportType == 1"><label class="rf-label mb-2px cmn-check-label">Physician</label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="DataObject.SelectedList.Provider" ng-change="OnChangeProvider()"><ui-select-match placeholder="Select Physician" class="overflow-y-auto d-block max-h-75px" allow-clear="false">{{$select.selected.FirstName}} <i class="glyphicon glyphicon-remove" aria-hidden="true" ng-click="ClearPhysician()"></i></ui-select-match><ui-select-choices repeat="list in DataObject.ProviderList | filter: {FirstName: $select.search}" position="down"><div ng-bind-html="list.FirstName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div ng-class="{\'col-lg-4\' : (DataObject.ReportType == 0)}" class="col-lg-3 col-md-12 px-0"><button class="btn btn-primary rf-btn-xs pull-left mt-20px mr-5px" ng-click="FilterReport()" ng-disabled="DataObject.DisableReportFilter">Filter</button> <button type="button" ng-click="ReportClearFilter(false)" class="btn btn-default mt-20px rf-btn-xs pull-left mx-5px">Clear</button> <button class="btn btn-default rf-btn-xs ml-2 mt-20px" ng-click="ExportPDF()" ng-if="DataObject.ShowExportAndMail"><i class="fa fa-file-pdf-o pr-2px"></i> Export PDF</button> <button class="btn btn-default rf-btn-xs ml-2 mt-20px" ng-click="ExportExcel()" ng-if="DataObject.ShowExportAndMail && DataObject.ReportType==\'0\'"><i class="fa fa-file-excel-o pr-2px"></i> Export Excel</button> <button class="btn btn-default rf-btn-xs mx-2 mt-20px" ng-click="Mail()" ng-if="DataObject.ShowExportAndMail"><i class="fa fa-envelope-o pr-4px"></i> Send Email</button></div></div><div class="report-dec" id="dvPeerReviewReport"><h3 class="text-center txt-clr-1 mt-10px" ng-if="DataObject.ReportType == \'0\'">Tenant Overall Report</h3><h3 class="text-center txt-clr-1 mt-10px" ng-if="DataObject.ReportType == \'1\'">Individual Physician Report</h3><h3 class="text-center txt-clr-1 mt-10px" ng-if="DataObject.ReportType == \'2\'">Physician Reviewed Record Summary</h3><div ng-class="{\'selectedsite-width\' : (DataObject.SelectedList.Site.length > 12)}" class="w-70" style="margin: 0 auto;"><div class="row m-0"><div ng-class="{\'col-lg-8 col-sm-8\' : (DataObject.SelectedList.Site.length > 10)}" class="col-md-6 col-sm-6 px-0"><div class="row m-0"><div class="col-md-12"><label>Tenant: {{DataObject.ReportData.TenantName}}</label></div></div><div class="row m-0" ng-if="DataObject.ReportData.Site"><div class="col-md-12 txt-clr-1">Site:<div class="d-flex flex-wrap"><span class="fs-12px bor-rad-4px px-5px m-2px-all py-2px" ng-repeat="site in DataObject.ReportData.Site" style="border:1px solid #616161">{{site.Site}}</span></div></div></div><div class="row m-0"><div class="col-md-12"><label ng-if="DataObject.ReportType != \'1\'">Total Participating Physicians: {{DataObject.ReportData.TotalPhysicians}}</label> <label ng-if="DataObject.ReportType == \'1\'">Physician Name: {{DataObject.ReportData.PhysicianName}}</label></div></div><div class="row m-0"><div class="col-md-12"></div></div></div><div ng-class="{\'col-lg-1 col-sm-1\' : (DataObject.SelectedList.Site.length > 10)}" class="col-md-2 pdf-responsive"></div><div ng-class="{\'col-lg-3 col-sm-4\' : (DataObject.SelectedList.Site.length > 10)}" class="col-lg-4 col-md-6 col-sm-6 px-0"><div class="row m-0"><div class="col-md-12 text-right"><label>Report Date: {{DataObject.ReportData.ReportDate | date:\'MM/dd/yyyy\'}}</label></div></div><div class="row m-0"><div class="col-md-12 text-right"><label>From Date: {{DataObject.ReportData.ReportFromDate}}</label></div></div><div class="row m-0"><div class="col-md-12 text-right"><label>To Date: {{DataObject.ReportData.ReportToDate}}</label></div></div></div></div></div><div class="mb-10px" style="margin-left: 2%; margin-right: 2%;"><div id="ReportAGGrid" class="myGrid text-white ag-theme-balham-dark stepmenupendingSub" style="width: 100%;"></div></div><div ng-if="DataObject.ReportType == \'1\' && DataObject.ReportData.PhysicianName && DataObject.ReportData.TenantName && DataObject.ReportData.AllStudiesCount && DataObject.ReportData.AllStudiesCountForTenant" class="text-center"><h5 class="txt-clr-1">Physician {{DataObject.ReportData.PhysicianName}} has reviewed {{DataObject.ReportData.AllStudiesCount}} out of {{DataObject.ReportData.AllStudiesCountForTenant}} total group reviews of this report period</h5></div></div></div><div ng-show="isLoadingReport" class="spinner-overlay" style="z-index:9999999;"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div></div></div><div class="modal fade" id="ModalAddEmailIDs" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog w-40"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="DataObject.SendMailEmailIDs = []">&times;</button><h4 class="modal-title">Send Mail</h4></div><div class="modal-body"><form name="formLocation" id="formLocation"><div class="row"><div class="col-md-12 mb-10px email-tags-input"><label class="rf-label">Email Ids</label><tags-input ng-model="DataObject.SendMailEmailIDs" placeholder="Add Email Address" allowed-tags-pattern="[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?" add-on-paste="true" add-on-enter="true" paste-split-pattern=";" class="prevent-clear-search"></tags-input></div></div><div class="row"><div class="col-md-12 mt-5px"><button class="btn btn-default" data-dismiss="modal" ng-click="DataObject.SendMailEmailIDs = []">Cancel</button> <button type="submit" ng-click="SendMail()" ng-disabled="!(DataObject.SendMailEmailIDs && DataObject.SendMailEmailIDs.length > 0)" class="btn btn-primary mr-5px">Send</button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/techno/techno.html','<script src="cdn/js/dwv-0.26.0.min.js"></script><link rel="stylesheet" href="cdn/css/ui-grid.css"><style>\r\n    .spinner-overlay {\r\n        position: absolute !important;\r\n    }\r\n\r\n    .anui .ui-grid-row .ui-grid-cell .w-100 .tooltip.uibtooltipDenial {\r\n        pointer-events: none;\r\n    }\r\n    /*.filtsecion .blk-input.form-control,\r\n    .filtsecion .mult-select .form-control,\r\n    .filtsecion select.form-control {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n        padding: 5px 12px !important;\r\n    }\r\n\r\n    .filtsecion .loc-input {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n\r\n    .filtsecion .mult-select.ui-select-multiple.ui-select-bootstrap {\r\n        min-height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n\r\n    .filtsecion .k-multiselect-wrap,\r\n    .filtsecion .k-multiselect-wrap .k-input {\r\n        height: 30px !important;\r\n        border-width: 0 !important;\r\n    }\r\n\r\n        .filtsecion .k-multiselect-wrap .k-button {\r\n            font-size: 12px !important;\r\n        }\r\n\r\n    .filtsecion select.form-control.status-fs option {\r\n        font-size: 14px !important;\r\n    }*/\r\n\r\n    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {\r\n        /* IE9+ specific styles go here */\r\n        /*.disabled-grid {\r\n                display: block !important;\r\n                overflow-x: hidden !important;\r\n            }\r\n\r\n            .disabled-list-footer {\r\n                position: fixed !important;\r\n                bottom: 0 !important;\r\n                width: 100% !important;\r\n                padding-bottom: 5px;\r\n            }\r\n\r\n            .charges-list {\r\n                padding-bottom: 40px !important;\r\n                padding-top: 100px !important;\r\n            }\r\n\r\n            .mail-messages-control {\r\n                position: absolute;\r\n                width: 100%;\r\n                z-index: 1 !important;\r\n            }\r\n                */\r\n    }\r\n\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    /*ui-select-choices only for this page */\r\n\r\n    /*.sel-block .ui-select-choices {\r\n            position: fixed;\r\n            top: auto;\r\n            left: auto;\r\n            width: auto !important;\r\n        }*/\r\n\r\n    .uib-datepicker-popup.dropdown-menu {\r\n        /*position:fixed*/\r\n    }\r\n\r\n    /*div[uib-datepicker-popup-wrap] {\r\n             position: fixed;\r\n            top: auto !important;\r\n            left: auto !important;\r\n        }*/\r\n    object {\r\n        min-height: 600px !important;\r\n        max-height: 800px !important;\r\n    }\r\n\r\n    .IPAlert {\r\n        text-align: left !important;\r\n        height: auto !important;\r\n        max-height: 200px;\r\n        overflow-y: scroll;\r\n        text-align: left !important;\r\n        background-color: white;\r\n        font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\r\n        border-radius: 5px;\r\n        color: #333;\r\n        font-size: 18px;\r\n        overflow-y: auto !important;\r\n    }\r\n\r\n    .k-grid table thead tr th:first-child {\r\n        padding-left: 15px !important;\r\n    }\r\n\r\n    .k-grid table tbody tr td:first-child {\r\n        padding-left: 15px !important;\r\n    }\r\n\r\n    .k-grid-header .k-header:first-child {\r\n        border-left-width: 1px !important;\r\n    }\r\n\r\n    .st-sort-ascent:before {\r\n        content: \'\\25B2\';\r\n    }\r\n\r\n    .st-sort-descent:before {\r\n        content: \'\\25BC\';\r\n    }\r\n\r\n    .lr-drop-target-before {\r\n        border-left: 2px solid orange;\r\n    }\r\n\r\n    .lr-drop-target-after {\r\n        border-right: 2px solid orange;\r\n    }\r\n\r\n    .dr-btn-none {\r\n        display: none;\r\n    }\r\n\r\n    #divTechForm {\r\n        /*padding: 10px;*/\r\n        height: 60vh;\r\n        overflow: auto;\r\n    }\r\n\r\n    .defaultfontclass select {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 5px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n\r\n    .defaultfontclass input[type="text"] {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 5px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n\r\n    .defaultfontclass input[type="checkbox"] {\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .defaultfontclass input[type="radio"] {\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .defaultfontclass option {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .defaultfontclass textarea {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 0px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n\r\n    label.defaultfontclass {\r\n        box-sizing: border-box;\r\n        color: #fff !important;\r\n        font-weight: 600 !important;\r\n        margin-bottom: 5px;\r\n        font-size: 13px;\r\n        text-align: left;\r\n        display: inline-block !important;\r\n    }\r\n\r\n    .defaultfontclass td select {\r\n        vertical-align: inherit;\r\n    }\r\n\r\n    .defaultfontclass tr td {\r\n        vertical-align: top;\r\n    }\r\n\r\n    .ui-grid-row-selected {\r\n        background-color: #424242;\r\n    }\r\n\r\n    .popover {\r\n        position: absolute;\r\n        /*z-index: 100;*/\r\n    }\r\n\r\n    .ui-grid .ui-grid-render-container-body .ui-grid-viewport {\r\n        overflow-y: auto !important;\r\n        overflow-x: auto !important;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags.focused {\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    #TechnoWorklistPagelocationTooltip.tultiptext {\r\n        top: 58px !important;\r\n    }\r\n\r\n    .popover.tech-icons-bar {\r\n        left: unset !important;\r\n        right: 50px;\r\n    }\r\n\r\n        .popover.tech-icons-bar.bottom > .arrow {\r\n            left: 80% !important;\r\n        }\r\n\r\n    .tech-icons-bar p i {\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .tech-icons-bar p {\r\n        color: white;\r\n    }\r\n\r\n    /*QueryRetrieve*/\r\n    .query-grid .ag-details-grid.ag-details-grid-fixed-height.ag-theme-balham-dark {\r\n        padding: 10px;\r\n    }\r\n\r\n    .query-grid .ag-details-grid.ag-details-grid-auto-height.ag-theme-balham-dark {\r\n        padding: 16px;\r\n        width: 98%;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .ag-full-width-container > .agrow-bg .ag-details-grid.ag-details-grid-auto-height.ag-theme-balham-dark {\r\n        padding: 8px;\r\n        width: 90%;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .ag-center-cols-clipper {\r\n        min-height: 40px !important;\r\n    }\r\n\r\n    .query-grid .ag-header-container {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .query-grid .ag-center-cols-container {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .queryAccessionHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        padding-left: 39px;\r\n        padding-right: 6px;\r\n    }\r\n\r\n    .querySeriesHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        padding-left: 21px;\r\n        padding-right: 6px;\r\n    }\r\n\r\n    .ag-overlay {\r\n        background: rgba(0, 0,0, 0.8);\r\n    }\r\n\r\n    .ag-overlay-loading-center {\r\n        padding: 10px !important;\r\n        background: transparent !important;\r\n    }\r\n\r\n    .hideHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        display: none;\r\n    }\r\n\r\n    .ag-icon.ag-icon-asc {\r\n        display: block !important;\r\n        font-size: var(--ag-icon-size);\r\n    }\r\n\r\n    .settcol-techno .ag-cell-label-container {\r\n        justify-content: center;\r\n    }\r\n\r\n        .settcol-techno .ag-cell-label-container .ag-header-cell-label {\r\n            display: none;\r\n        }\r\n\r\n    .popover.step-usericons {\r\n        top: 20% !important;\r\n    }\r\n\r\n    .popover.step-plusicons {\r\n        top: 15% !important;\r\n    }\r\n\r\n        .popover.step-plusicons.right > .arrow {\r\n            top: 15% !important;\r\n        }\r\n\r\n    .popover.tech-ord-phy {\r\n        right: 0.5% !important;\r\n        left: unset !important;\r\n    }\r\n\r\n        .popover.tech-ord-phy .arrow {\r\n            left: 90% !important;\r\n        }\r\n\r\n    .rf-techform-tpckr {\r\n        margin: 0 auto auto auto !important;\r\n    }\r\n\r\n        .rf-techform-tpckr .uib-time input {\r\n            width: 40px;\r\n            height: 30px;\r\n            padding: 4px;\r\n        }\r\n\r\n    .editorder-popup .rf-timepick.rf-techform-tpckr td.uib-increment.hours,\r\n    .editorder-popup .rf-timepick.rf-techform-tpckr td.uib-increment.minutes {\r\n        padding: 0 !important;\r\n    }\r\n\r\n    #FaxNumberDropdownGrid.multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n\r\n    .bsmodal-sendfax {\r\n        z-index: 99991 !important;\r\n    }\r\n\r\n    .fax-multiselectbox .location-tags-input tags-input .tags {\r\n        border: 1px solid #a2a1a1 !important;\r\n    }\r\n\r\n    .modal .modal-dialog .modal-body .form-control.inputfax-numner {\r\n        height: 33px;\r\n    }\r\n\r\n    .fax-multiselectbox .location-tags-input tags-input .tags .tag-list {\r\n        max-height: 50px;\r\n    }\r\n\r\n    .tech-dis-window .k-toolbar .k-button {\r\n        margin: 0;\r\n    }\r\n\r\n    .list-tooltip {\r\n        top: 100px !important;\r\n    }\r\n\r\n    #OrderingPhySiteGrid.multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n\r\n    #TechOrderingPhySite .location-tags-input tags-input .tags {\r\n        border: 1px solid #8f8e8e !important;\r\n    }\r\n\r\n    .section-disbl {\r\n        pointer-events: none;\r\n        opacity: 0.7;\r\n    }\r\n\r\n    @media (max-width: 1199px) and (min-width: 768px) {\r\n\r\n        .tech-dis-window .k-pdf-viewer .k-toolbar.k-toolbar-resizable {\r\n            padding-left: 0;\r\n        }\r\n\r\n        .tech-dis-window .k-toolbar div.k-flat[aria-label="Print"] {\r\n            margin: 0 !important;\r\n        }\r\n\r\n        .tech-dis-window .k-toolbar .k-flat.k-toolbar-last-visible {\r\n            margin: 0;\r\n        }\r\n\r\n        .tech-dis-window .k-toolbar .k-overflow-anchor {\r\n            right: -10px;\r\n        }\r\n    }\r\n\r\n    @media only screen and (min-width: 767px) and (max-width:1200px) {\r\n        .statdatetime-row {\r\n            flex-wrap: wrap;\r\n        }\r\n\r\n        .stststrktrm .form-controller.mt-2 {\r\n            margin-top: 0 !important;\r\n        }\r\n    }\r\n\r\n    /* Allow the Assign To DropDownTree popup to overflow the Edit Order modal */\r\n    .technoform-edorder.overflow-hide-all {\r\n        overflow: visible !important;\r\n    }\r\n\r\n    .k-list-container.k-popup.k-group.k-reset.k-multiple-selection.k-popup-dropdowntree {\r\n        height: 252px !important;\r\n    }\r\n</style><div class="radf-header wroklist-wrapper" keyboard="keys"><h2 class="float-left w-50 heading-tw">Technologist Worklist</h2><span class="float-right mr-10px py-4px" style=""><span class="float-left" style="display:none;"><img class="mr-5px sm-refresh" src="assets/images/refresh.svg" alt="Refresh"></span> <span class="d-inline-block"><button type="button" class="btn filterbt-2 no-bg fs-12px" ng-click="CollapseTechnoFilter()" id="heading_Techworklist" data-toggle="collapse" data-parent="#accordion" href="#collapseWorklist" aria-expanded="false" aria-controls="collapseTechWorklist"><span><span ng-if="isfilterCollapse">Open Filter<i class="fa fa-filter txt-clr-1 icon-hover fs-12px pl-5px"></i></span> <span ng-if="!isfilterCollapse">Close Filter<i class="fa fa-close txt-clr-1 icon-hover fs-12px pl-5px"></i></span></span></button></span></span><div class="clearfix"></div></div><div class="pportal-list" id="mainDiv"><div class=""><div class="p-0 collapse in b-clr-33 filtsecion filtr-ontop" id="collapseWorklist" role="tabpanel" aria-labelledby="heading_worklist"><form id="frmFilter"><div class="rf-filter filter-controller row my-8px rf-filter-ui"><div class="col-sm-4 col-md-3 col-xs-2 mob-w-50 pr-0 tultip-bottom"><site-location-grid master-locations="Locations" selected-location="SelectedLocations" on-change="updateSelectedLocation()"></site-location-grid></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="Accession" placeholder="Accession" tooltip-class="uibtooltipDenial" uib-tooltip="Accession" tooltip-placement="auto top"></div><div class="col-sm-1 col-md-1 col-xs-2 mob-w-50 pr-0 pl-10px d-w-13"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="OrderDate" options="opts" ng-mouseenter="resetDateRange()" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{toolTipOrderDate}}" tooltip-placement="auto top"></div><div class="col-sm-2 col-md-1 col-xs-3 mob-w-50 pr-0 tultip-bottom pl-10px smw-19 w-12 selmod-m"><multi-select master-data="DataObject.ModalityDropdownDataFilter" list="Modalities" ng-model="DataObject.ModalityDropdownDataFilter.SelectedValue" on-change="onSelectedModalityTechno(selectedData)"></multi-select><span class="tultiptext text-preline overflow-auto max-h-500px text-left tt-white tt-top">{{modalitytechnotooltip}}</span></div><div class="col-sm-1 col-md-2 col-xs-2 mob-w-100 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="OrderingPhysician" placeholder="Ordering Physician" tooltip-class="uibtooltipDenial" uib-tooltip="Ordering Physician" tooltip-placement="auto top"></div></div><div class="rf-filter filter-controller row mb-4px rf-filter-ui"><div class="col-sm-3 col-md-3 col-xs-3 mob-w-50 pr-0"><div class="col-sm-5 col-md-5 col-xs-5 pr-0 pl-0" style="z-index:1"><input type="text" class="blk-input form-control col-placeholder" ng-model="PatientMRN" placeholder="MRN" tooltip-class="uibtooltipDenial" uib-tooltip="MRN" tooltip-placement="auto top"></div><div class="col-sm-7 col-md-7 col-xs-7 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="PatientName" placeholder="Patient Name" tooltip-class="uibtooltipDenial" uib-tooltip="Patient Last Name, First Name" tooltip-placement="auto top"></div></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px"><div class="input-group blk-calender mb-0"><input type="text" class="blk-input form-control col-placeholder" tooltip-class="uibtooltipDenial" uib-tooltip="DOB (mm/dd/yyyy)" tooltip-placement="auto top" uib-datepicker-popup="MM/dd/yyyy" ng-model="DOB" is-open="isDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="DOB" placeholder="DOB" data-container="body" ng-click="isDOBOpen = !isDOBOpen"></div></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px d-w-13 sclt-type-wdth"><ui-select skip-focusser="true" class="mult-select b-clr bg-clr-31 mob-closekeypad" ng-model="SelectedList.PatientClass" title="Select Type"><ui-select-match placeholder="Select Type" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PatientClass | propsFilter: {Value: $select.search}" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px w-12 set-wdth-sm"><select id="ddlStatus" class="condition-select blk-input form-control downArrow-ie opnclr sing-select-2 status-fs" ng-model="Status" ng-change="FilterDICOMOrders(true)"><option value="AL">All</option><option value="X" style="background-color: #BFDED6">Cancelled</option><option value="CO" style="background-color: #B9ADCF">Comparison</option><option value="C" style="background-color: #75E284">Complete</option><option value="D" style="background-color: #a0c1c5">Draft</option><option value="IP" style="background-color: #f4ba4b">Image Pending</option><option value="PA" style="background-color: #ffe6ee" ng-if="IsAddendumRequestVisible">Pending Addendum</option><option value="OP" style="background-color: #b2b266">Pending Order</option><option value="RP" style="background-color: #FFE69A;">Result Pending</option><option value="H" style="background-color: #FFC99A">Hidden</option></select></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px" ng-show="Status == \'H\'"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="HiddenType.obj" ng-change="FilterDICOMOrders()"><ui-select-match>{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="list in HiddenTypeList" position="down"><div ng-bind-html="list.Key"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px filt-w-new-wl fltr-btn-wrapper mob-flt-rt technobt-sec set-on-sm"><button type="button" ng-click="FilterDICOMOrders()" class="btn btn-primary rf-btn-xs">Filter</button> <button type="button" ng-click="SaveFilters();" class="btn btn-primary rf-btn-xs">Save Filter</button> <button type="button" ng-click="clearFilterAndRefesh();" class="btn btn-default rf-btn-xs">Clear</button></div></div></form></div><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="isorderlistLoading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div></div><div id="TechWorklistAgGrid" class="myGrid ag-theme-balham-dark tech-anui anui" style="width:100%; height:765px"></div></div><div class="overflow-hide-all ERA-check-detail discsn-popup techno-dscsn comp-innotab px-0 py-0" kendo-window="win_Discussion" k-on-open="isDiscussionVisible = true;onKendoWindowOpen();windowOpened(win_Discussion)" k-on-close="isDiscussionVisible = false;onKendoWindowClose();windowClosed(win_Discussion);DataObject.DiscussionWindowActiveTab = \'Discussion\'" k-title="\'Discussion\'" k-visible="false" k-width="DataObject.defaultWindowWidth" k-height="defaultWindowHeight" k-resize="winDiscussionTechResize" k-dragend="winDiscussionTechDragend" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div style="background-color:#262526!important;"><div class="spinner-overlay" ng-show="isDiscussionLoading"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div ng-if="isDiscussionVisible" class="techno-lite-discussion"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center" ng-repeat="tabList in DataObject.DiscussionWindowTabList" ng-class="{\'active\':tabList.TabName==DataObject.DiscussionWindowActiveTab}"><a class="py-5px" ng-click="onDiscussionWindowTabChange(tabList.TabName);" href="#{{tabList.TabName}}" data-toggle="tab" ng-class="{\'disable-area\':tabList.TabName==DataObject.DiscussionWindowActiveTab}" ng-if="tabList.TabName.includes(\'Attachment\') ? SelectedOrder.FileCount > 0 : true">{{tabList.TabName && tabList.TabName.includes(\'Attachment\') ? tabList.TabName + (SelectedOrder.FileCount ? \' (\'+SelectedOrder.FileCount+\')\' : \'\'): tabList.TabName}}</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Discussion" selected-order="SelectedOrder"></studyactionmenu></ul></div><div class="p-8px-all pt-0"><div class="denial-window pt-5px" ng-if="DataObject.DiscussionWindowActiveTab == \'Discussion\'"><div class="fw-500"><patientdetails selected-order="SelectedOrder"></patientdetails><div ng-class="{\'useriprpht\': isAssignAllowed(SelectedOrder.Status)}"><div class="row m-0 d-flex align-item-center flex-nowrap" ng-if="isAssignAllowed(SelectedOrder.Status)"><div class="mr-10px" style="flex-shrink: 0;"><label class="rf-label- fs-14px mb-0 pl-2px mt-2px fw-400">Assign to:</label></div><div class="col-lg-3 col-md-3 col-sm-3 mt-1 p-0 discussion-sel tultip-bottom"><div id="kddtOrderDiscussion" class="visb-close-icon" style="width: 100%;border-color:#424242!important;background-color:#323232!important;" kendo-dropdowntree="kddtOrderDiscussion" k-options="OrderDiscussionOptions"></div><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px" style="top:33px!important; visibility:hidden;" id="OrderDiscussionAssignmentTooltip">{{orderDiscussionTooltip}}</span></div></div><div class="row m-0 clearfix"><div class="col-md-12 form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment."> </textarea></div></div><div class="py-10px"><div class="float-right px-15px discu-choose-files m-p-0"><div class="float-left px-20px m-p-0 d-none"><div class="control-fileupload"><label for="file"></label> <input class="cursor-pointer w-100 type-fileupload" type="file" id="file" name="file" multiple="" onchange="angular.element(this).scope().getFileDetails(this)" accept="application/pdf,image/jpeg,image/png,.doc, .docx, .csv, .xls, .xlsx, .ppt, .pptx"></div><span class="fs-13px fw-600 text-left txt-clr-5 d-block py-5px">Only pdf, doc, excel, ppt, png and jpg files are allowed.</span></div><div class="float-left"><input class="btn btn-primary d-none" type="button" ng-click="uploadFiles()" value="Upload"> <button type="button" class="btn btn-primary" ng-click="SaveDiscussion()" ng-disabled="SaveDiscussionFlag">Save</button> <button type="button" class="btn btn-default" ng-click="AssignStudy()" ng-show="AssignStudyVisible" style="display:none;">Assign Study</button></div><div class="clearfix"></div></div><div class="clearfix"></div></div><div class="discus-comment overflow-y-auto py-10px px-10px technosec"><div class=""><div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div></div></div><div class="pt-5px" ng-if="DataObject.DiscussionWindowActiveTab == \'Attachment\' && SelectedOrder.FileCount > 0 && !showDiscuss"><patientdetails selected-order="SelectedOrder"></patientdetails><div ng-if="SelectedOrder.FileCount > 0 && !showDiscuss"><div class="tech-dis-window mt-10px"><div class=""><attachment-viewer ng-if="DataObject.Reference.ID" dicomorder="DataObject.Reference" send-fax="openFaxModal(faxFile)" selected-order="SelectedOrder" show-pdf="true"></attachment-viewer></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail editorder-popup p-0 technoform-edorder" kendo-window="win_PatientInfo" k-on-open="openPatientInfo();onKendoWindowOpen()" k-on-close="onKendoWindowClose();clearPatientInfoData();" k-title="\'Edit Order\'" k-visible="false" k-width="winPatientInfoTechWidth" k-height="800" k-resize="winPatientInfoTechResize" k-dragend="winPatientInfoTechDragand" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div style="background-color:#262526!important;"><div class="spinner-overlay" ng-show="isPatientInfoLoading"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><uib-tabset active="DataObject.ModalPatientInfoActiveIndex" class="rf-uib-tabset"><uib-tab index="$index" ng-repeat="tab in ::DataObject.ModalPatientInfoTabs" heading="{{tab.title}}"><div ng-include="tab.templateUrl"></div></uib-tab></uib-tabset><div class="modal fade physicianmodal" id="addOrderingPhysician" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog w-800px"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" ng-click="clearModalData(frmOrderingPhysician)">&times;</button><h4 class="modal-title">{{DataObject.OrderingPhysician.AddEditText}} Ordering Physician</h4></div><div class="modal-body"><ordering-physician-info master-data="DataObject.MasterData" selected-data="DataObject.OrderingPhysician.SelectedData" clear-modal-data="clearModalData(frmOrderingPhysician)" on-save-success="onSaveSuccess(result, providerData)" ng-if="DataObject.ShowOrderingPhysicianModal"></ordering-physician-info></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_HelpOrder" k-on-open="isHelpOrderVisible = true;onKendoWindowOpen()" k-on-close="isHelpOrderVisible = false;onKendoWindowClose()" k-title="\'Help Order\'" k-visible="false" k-width="win_HelpOrderWidth" k-height="650" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isHelpOrderVisible"><div class="denial-window"><div class="row card-bg-white denial-window-head p-5px-all m-5px-all fw-600"><div class="col-md-3"><div><span class="report_span_title">Location :</span> <span class="report_span">{{SelectedOrder.Location}}</span></div><div><span class="report_span_title">Gender :</span> <span class="report_span">{{SelectedOrder.PatientGender}}</span></div><div><span class="report_span_title">Ordering Physician :</span> <span class="report_span">{{SelectedOrder.OrderingPhysician}}</span></div></div><div class="col-md-3"><div><span class="report_span_title">DOS :</span> <span class="report_span">{{(SelectedOrder.OrderDate) ? (SelectedOrder.OrderDate | date:\'M/d/yy HH:mm\').toString().replace("00:00","") : \'\'}}</span></div><div><span class="report_span_title">Type :</span> <span class="report_span">{{SelectedOrder.PatientClass}}</span></div></div><div class="col-md-3"><div><span class="report_span_title">Patient Name :</span> <span class="report_span">{{SelectedOrder.PatientName}}</span></div><div><span class="report_span_title">Modality :</span> <span class="report_span">{{SelectedOrder.Modality}}</span></div></div><div class="col-md-3"><div><span class="report_span_title">DOB :</span> <span class="report_span">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span></div><div><span class="report_span_title">Procedure :</span> <span class="report_span">{{SelectedOrder.ProcedureDesc}}</span></div><div><button type="button" ng-show="ODType==\'Helper\'" class="btn cmn-btn btn-primary h-30px px-10px fs-13px pull-right" ng-click="CloseOrderDiscussion()">Close Discussion</button></div></div><div class="row"></div><hr><div class="col-lg-3 col-md-3 col-sm-6 mb-8px" ng-hide="Ishelper"><ui-select ng-model="OrderDiscussion.SelectedUser" theme="bootstrap" class="fs-14px dicom-inp-w form-border" style="width: 40%;" ng-disabled="OrderDiscussion.ID"><ui-select-match allow-clear="true" placeholder="Select Radiologist">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices repeat="list in Radiologists | filter: isVisibleRad | filter: {FirstName: $select.search, LastName: $select.search} | orderBy:\'LastName\'"><div class="inst-selectBox" ng-bind-html="radDisplay(list) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-12 form-group mb-10px" ng-hide="Ishelper"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment."> </textarea></div><div class="pull-right" ng-hide="Ishelper"><button type="button" class="btn cmn-btn btn-primary h-30px px-10px fs-13px" ng-click="SaveOrderDiscussion()">Save</button></div><div class="pull-right" ng-show="Ishelper"><button type="button" class="btn cmn-btn btn-primary h-30px px-10px fs-13px" ng-click="CloseOrderDiscussion()">Close Discussion</button></div><div class="h-10px"></div><div class="max-h-43vh overflow-x-auto p-10px-all bg-clr-12"><div class=""><div class="w-100" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0 report-popup px-5px" kendo-window="win_ViewReport" k-on-open="isViewReportVisible = true;onKendoWindowOpen()" k-on-close="isViewReportVisible = false;onKendoWindowClose()" k-title="\'Report\'" k-modal="true" k-visible="false" k-width="DataObject.defaultWindowWidth" k-height="defaultWindowHeight" k-resize="winViewReportTechResize" k-dragend="winViewReportTechDragand" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isViewReportVisible"><div class="denial-window"><div class=""><div><report-viewer ng-if="selecteReportId" source-id="selecteReportId"></report-viewer></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0" kendo-window="win_ViewTechnique" k-on-open="isViewTechniqueVisible = true;onKendoWindowOpen()" k-on-close="isViewTechniqueVisible = false;onKendoWindowClose()" k-title="\'Technique\'" k-visible="false" k-width="win_ViewTechniqueWidth" k-height="win_ViewTechniqueHeight" k-modal="true" k-animation="false" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isViewTechniqueVisible"><div class="denial-window"><div class="fw-500"><div class="col-sm-12 col-md-12"><div class="mx-10px float-right"><button ng-click="AddTechnique()" class="btn btn-primary btn-sm adnewbtn">Add New</button></div></div><div class="col-sm-12 col-md-12 mob-p-0"><div class="charges-list bg-clr-27"><table ng-table="tableParams" class="table pos-rel wh-table table-scroll technique-table"><tbody class="h-400px"><tr class="side-message-navigation-item little-human shineHover data-row" ng-repeat="row in $data track by $index"><td class="w-20 text-left" data-title="\'Technique Key\'" filter="{ Key: \'text\'}" sortable="\'Key\'">{{row.Key}}</td><td class="w-70 text-left" data-title="\'Technique Value\'" filter="{ Value: \'text\'}" sortable="\'Value\'">{{row.Value}}</td><td class="w-10 text-right"><button ng-click="SelectTechniqueValue(row.Value)" class="btn btn-primary btn-sm selbtn">Select</button></td></tr></tbody></table></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0" kendo-window="win_AddTechnique" k-on-open="isAddTechniqueVisible = true;onKendoWindowOpen()" k-on-close="isAddTechniqueVisible = false;onKendoWindowClose()" k-title="\'Add Technique\'" k-visible="false" k-width="500" k-height="350" k-animation="false" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isAddTechniqueVisible"><div class="denial-window"><div><form id="frmFilter" ng-submit="SubmitTechnique(frmFilter.$valid,TechniqueKey,TechniqueValue)"><div class="fw-500 row py-15px"><div class="col-sm-12 col-md-12 mb-15px"><label class="rf-label">Key Code</label> <input type="text" class="blk-input form-control" placeholder="Key code" id="TechniqueKey" name="TechniqueKey" ng-model="TechniqueKey" autocomplete="off" ng-required="true" first-char-no-space=""></div><div class="col-sm-12 col-md-12"><label class="rf-label">Value</label><textarea class="txt-area h-150px w-100 p-5px-all" ng-model="TechniqueValue" id="TechniqueValue" name="TechniqueValue" placeholder="Key value" ng-required="true"> </textarea></div><div class="col-sm-12 col-md-12"><div class="py-10px"><label class="rf-label"></label><button ng-click="CancelTechnique()" class="btn btn-default">Cancel</button> <button class="btn btn-primary">Save</button></div></div></div></form></div></div></div></div><script id="dropdowntree-orderdiscussion-template" type="text/kendo-ui-template"># if (item.Group && item.Group == "YES") { # #: item.UserName # # } else { # <i class="fa fa-circle #: item.IsOnline ? \'text-success\' : \'text-gray-dark\' #"></i> #: item.UserName # # } #</script><div class="overflow-hide-all ERA-check-detail" kendo-window="win_TechForm" k-on-open="isTechFormVisible = true;onKendoWindowOpen()" k-on-close="isTechFormVisible = false;onKendoWindowClose()" k-title="\'Tech Form\'" k-visible="false" k-width="win_HelpOrderWidth" k-animation="false" k-height="650" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isTechFormVisible"><div class="denial-window"><iframe id="tempid" style="width:100%;height:500px;position:absolute;top:-1000px;"></iframe><div id="CONCLUSION"></div><div id="divTechForm"></div><div class="py-10px"><div class="float-right px-15px mob-pl0 discu-choose-files"><div class="float-left"><button type="button" class="btn btn-primary" ng-click="SetOrdersTechForm()">Save</button> <button type="button" class="btn btn-default" ng-click="CloseTechForm()">Cancel</button> <button type="button" class="btn btn-default" ng-click="ReloadTechForm()">Reload</button></div><div class="clearfix"></div></div><div class="clearfix"></div></div></div></div></div><div class="modal fade" id="ModalTechnoWorkList" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog create-filter"><div class="modal-content py-20px px-0" style="border-radius:4px;background-color:#2c2c2c;"><div class=""><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary mr-10px d-none" ng-click="createTechnoWorkList()">Create Filter</button> <button type="button" class="btn btn-primary mr-10px" ng-click="saveFilterOnly()">Save Filter Only</button> <button type="button" class="btn btn-default mr-10px" data-dismiss="modal">Cancel</button></div></div></div></div></div></div><div class="modal fade bsmodal-sendfax" id="SendFaxModal" role="dialog" data-keyboard="false" data-backdrop="static"><div class="modal-dialog create-filter"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Send Fax</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 mb-10px fax-multiselectbox tultip-bottom" ng-if="DataObject.FaxDetails.FaxNumberList.length > 0"><label class="rf-label">Fax Number</label><multi-select master-data="DataObject.FaxDetails.FaxNumberDropdown" list="DataObject.FaxDetails.FaxNumberList" ng-model="DataObject.FaxDetails.FaxNumberDropdown.SelectedValue" on-change="DataObject.FaxDetails.FaxNumberDropdown.onFaxNumbChanged(selectedData)"></multi-select><span ng-class="{\'list-tooltip\' : DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list.length > 0}" class="tultiptext text-preline overflow-auto max-h-500px text-left tt-white tt-top">{{(DataObject.FaxDetails.FaxNumTooltip)?DataObject.FaxDetails.FaxNumTooltip:\'Select Fax Number\'}}</span></div><div class="col-md-12 mb-20px"><label class="rf-label">Enter Fax Number</label> <input type="text" id="FaxNumText" class="form-control inputfax-numner" name="faxnumber" ui-mask="(999) 999-9999" maxlength="15" ng-model="DataObject.FaxDetails.FaxNumber" autocomplete="off"></div><div class="col-md-12"><button type="button" class="btn btn-primary float-right" ng-disabled="validateFaxNumText()" ng-click="SendFax()">Send Fax</button></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs comp-innotab px-0 py-0" kendo-window="win_consultExamsWindow" k-on-open="isConsultExamsWindow = true;onKendoWindowOpen();windowOpened(win_consultExamsWindow)" k-on-close="isConsultExamsWindow = false;onKendoWindowClose();windowClosed(win_consultExamsWindow)" k-title="\'Consult Exams\'" k-modal="true" k-visible="false" k-animation="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isConsultExamsWindow"><div class="row mx-0"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Consult Exams</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Consult with Physician" selected-order="SelectedOrder"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><videocallconsult class="clearfix video-call-consult" on-send="setUserChat" selected-order="SelectedOrder" check="isConsultExamsWindow" on-close="onCloseConsultExamWindowHandler(check)"></videocallconsult></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup px-5px ord-eve-logs comp-innotab px-0 py-0" kendo-window="win_shareExamsWindow" k-on-open="isShareExamWindowVisible = true;onKendoWindowOpen();windowOpened(win_shareExamsWindow);" k-on-close="isShareExamWindowVisible = false;onKendoWindowClose();windowClosed(win_shareExamsWindow);" k-title="\'Share Exams\'" k-modal="true" k-visible="false" k-width="winShareExamWindowWidth" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false" k-dragend="winDragend"><div ng-if="isShareExamWindowVisible"><div class="row mx-0"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Share Exams</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Share Exam" selected-order="SelectedOrder"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><shareexam check="isShareExamWindowVisible" on-close="onCloseShareExamWindowHandler(check)" selected-order="SelectedOrder" on-send="setUserChat"></shareexam></div></div></div></div></div><script type="text/ng-template" id="tree_item_renderer.html"><div> <div> <div class="fs-13px text-break-word bg-clr-29 bor-rad-5px p-15px-all"> <p style="white-space:pre-line">{{Dis.Comment | htmlDecode}}</p> </div> <div class="float-right py-5px"> <div class="tultip-top float-left"> <a class="btn btn-default glyphicon glyphicon-share-alt border-0" ng-click="Dis.IsChild=!Dis.IsChild"></a> <span class="tultiptext">Reply</span> </div> <div class="float-left pt-3px"> <span class="txt-clr-1 fs-15px" ng-if="disName(Dis)">{{disName(Dis) | htmlDecode}}</span> <span class="txt-clr-2 fs-12px">{{Dis.Record_Created_At|date :\'medium\' }}</span> </div> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div ng-show="Dis.IsChild"> <div class="mb-10px w-70 pull-right"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Dis.ChildComment" placeholder="Add a comment."> </textarea> </div> <div class="clearfix"></div> <div class="mb-10px"> <button type="button" class="btn btn-primary pull-right" ng-click="SaveChildDiscussion(Dis)">Save</button> <div class="clearfix"></div> </div> </div> </div> <div class="clearfix"></div> </div> <ul style="list-style:none"> <li class="mb-10px" ng-repeat="Dis in Dis.Childs" ng-include="\'tree_item_renderer.html\'"></li> </ul></script><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs comp-innotab px-0 py-0" kendo-window="win_addendum_request" k-on-open="showAddendumReq = true;onKendoWindowOpen();windowOpened(win_addendum_request)" k-on-close="onAddendumReqClose();onKendoWindowClose();windowClosed(win_addendum_request)" k-title="\'Addendum Request\'" k-modal="true" k-visible="false" k-animation="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="showAddendumReq"><div class="row mx-0"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Addendum Request</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Addendum Request" selected-order="SelectedOrder"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-0"><div class="col-md-12 mb-10px px-0 txt-clr-1 sm-mt-10px"><div class="d-flex align-item-center toggle-div pt-10px pb-10px"><div class="w-400px"><ui-select class="mult-select" ng-model="AddendumRequest.AssignedUser" tooltip-class="uibtooltipDenial" uib-tooltip="{{AddendumRequest.AssignedUserTooltip}}" tooltip-placement="auto top" on-select="onAddendumUserSelect()"><ui-select-match placeholder="Select Radiologist" allow-clear="true">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices style="max-height:150px !important;" repeat="list in Radiologists | filter: isVisibleRad | filter: $select.search" position="down"><div ng-bind-html="radDisplay(list) | highlight: $select.search"></div><small><span class="d-block" ng-if="list.Email"><i class="fa fa-envelope pr-4px"></i>{{list.Email}}</span> <span class="d-block" ng-if="list.PhoneNumber"><i class="fa fa-phone-square pr-4px"></i>{{list.PhoneNumber}}</span></small></ui-select-choices></ui-select></div><label class="rf-label mb-0 ml-20px">High Priority</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="AddendumRequest.isHighPriorityAddendum"> <span class="checkbox-switch-slider round"></span></label></div></div></div><div class="col-md-12 p-0 clearfix"><label class="rf-label">Reason *</label> <textarea class="txt-area mt-1 h-70px w-100 p-5px-all" ng-model="AddendumRequest.AddendumComment" placeholder="Reason for Addendum Request (Required)"> </textarea></div><div class="col-md-12 p-0 clearfix"><button type="button" class="btn btn-primary mt-10px mb-10px pull-right" ng-click="UpdateAddendumRequestReportStatus()" ng-disabled="!(AddendumRequest.AssignedUser && AddendumRequest.AddendumComment)">Send Request</button></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs comp-innotab px-0 py-0" kendo-window="win_peer_review" k-on-open="showPeerReview = true;onKendoWindowOpen();windowOpened(win_peer_review)" k-on-close="onPeerReviewClose();onKendoWindowClose();windowClosed(win_peer_review)" k-title="\'Peer Review\'" k-modal="true" k-visible="false" k-animation="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="showPeerReview"><div class="row mx-0"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Peer Review</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Peer Review" selected-order="SelectedOrder"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-0"><div class="col-md-12 mb-10px px-0 txt-clr-1 sm-mt-10px" ng-if="!DataObject.isAutoAssignPeerReviewWin"><div class="d-flex align-item-center toggle-div pt-10px pb-10px"><div class="w-400px"><ui-select class="mult-select" ng-model="PeerReview.AssignedUser" tooltip-class="uibtooltipDenial" uib-tooltip="{{PeerReview.AssignedUserTooltip}}" tooltip-placement="auto top" on-select="onPeerReviewUserSelect()"><ui-select-match placeholder="Select Radiologist" allow-clear="true">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices style="max-height:150px !important;" repeat="list in PeerReviewRadiologists | filter: $select.search" position="down"><div ng-bind-html="radDisplay(list) | highlight: $select.search"></div><small><span class="d-block" ng-if="list.Email"><i class="fa fa-envelope pr-4px"></i>{{list.Email}}</span> <span class="d-block" ng-if="list.PhoneNumber"><i class="fa fa-phone-square pr-4px"></i>{{list.PhoneNumber}}</span></small></ui-select-choices></ui-select></div></div></div><div class="col-md-12 p-0 clearfix"><textarea class="txt-area mt-1 h-70px w-100 p-5px-all" ng-model="PeerReview.Comment" placeholder="Reason for Peer Review (Optional)"> </textarea></div><div class="col-md-12 p-0 clearfix"><button type="button" class="btn btn-primary mt-10px mb-10px pull-right" ng-click="AddOrderToSpecificPeer()" ng-disabled="!(PeerReview.AssignedUser)" ng-if="!DataObject.isAutoAssignPeerReviewWin">Send Request</button> <button type="button" class="btn btn-primary mt-10px mb-10px pull-right" ng-click="AutoAssignPeerReview()" ng-if="DataObject.isAutoAssignPeerReviewWin">Send Request</button></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup ord-eve-logs" kendo-window="win_query_retrive" k-on-open="DataObject.onQueryRetrive = true;onKendoWindowOpen();windowOpened(win_query_retrive)" k-on-close="DataObject.onQueryRetrive = false;onKendoWindowClose();windowClosed(win_query_retrive)" k-title="\'Query Retrieve\'" k-modal="true" k-visible="false" k-animation="false" k-width="winPeerReviewWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div class="container-fluid" ng-if="DataObject.onQueryRetrive"><form ng-submit="QueryRetrieveFilter(true)"><div class="row"><div class="col-sm-3 col-md-2 col-xs-6 pd-lr tultip-bottom pl-0 mb-5px">First Name <input ng-model="DataObject.QueryRetrieve.FirstName" type="text" class="blk-input form-control col-placeholder" placeholder="First Name" tooltip-class="uibtooltipDenial" uib-tooltip="First Name" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr pl-0 mb-5px">Last Name <input ng-model="DataObject.QueryRetrieve.LastName" type="text" class="blk-input form-control col-placeholder" placeholder="Last Name" tooltip-class="uibtooltipDenial" uib-tooltip="Last Name" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-pr-0 pl-0 mb-5px">MRN <input ng-model="DataObject.QueryRetrieve.PatientMRN" type="text" class="blk-input form-control col-placeholder" placeholder="MRN" tooltip-class="uibtooltipDenial" uib-tooltip="MRN" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-pr-0 pl-0 mb-5px">Accession <input ng-model="DataObject.QueryRetrieve.Accession" type="text" class="blk-input form-control col-placeholder" placeholder="Accession" tooltip-class="uibtooltipDenial" uib-tooltip="Accession" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-pr-0 pl-0 mb-5px">DOS <input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="DataObject.QueryRetrieve.OrderDate" options="DataObject.QueryRetrieve.opts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial" uib-tooltip="{{DataObject.QueryRetrieve.toolTipOrderDate}}" tooltip-placement="auto top" ng-mouseenter="resetQueryRetrieveDateRange()" datepicker-append-to-body="true"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-w-50 filt-btn-sec mob-pr-0 px-0 mt-20px pl-0 mb-5px"><button type="submit" class="btn btn-primary pull-left rf-btn-xs pb-6px" ng-disabled="DataObject.QueryRetrieve.IsSearchingData">Search</button> <button type="button" ng-click="ClearQueryRetrieve()" class="btn btn-default pull-left ml-2 rf-btn-xs pb-6px">Clear</button></div></div></form></div><div ng-if="DataObject.onQueryRetrive" class="mt-20px"><div class="row mb-5px"><div class="col-md-12 d-flex justify-content-end"><div class="d-flex align-item-center toggle-div p-6px-all" style="border-right: 1px solid #0c6c5e;"><label class="rf-label mb-0">Expand All</label> <label class="checkbox-switch pref-checkbox ml-5px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.QueryRetrieve.IsExpanded" ng-click="ExpandCollapseData(DataObject.QueryRetrieve.IsExpanded)" ng-disabled="DataObject.QueryRetriveObj.patients.length == 0"> <span class="checkbox-switch-slider round"></span></label></div><div class="d-flex align-item-center toggle-div p-6px-all ml-5px" style="border-right: 1px solid #0c6c5e;"><label class="rf-label mb-0">Select All Studies</label> <label class="checkbox-switch pref-checkbox ml-5px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.QueryRetrieve.IsAllStudySelected" ng-click="ExpandCollapseData(DataObject.QueryRetrieve.IsAllStudySelected,true)" ng-disabled="DataObject.QueryRetriveObj.patients.length == 0"> <span class="checkbox-switch-slider round"></span></label></div><button type="button" class="btn btn-primary rf-btn-xs mr-5px ml-10px" title="Retrieve" ng-disabled="DataObject.QueryRetrieve.IsRetrieveBtnDisabled || DataObject.QueryRetriveObj.patients.length == 0" ng-click="MoveInstance()">Retrieve</button></div></div><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="DataObject.isLoadingQueryRetrieve"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div id="myQueryGrid" class="myGrid ag-theme-balham-dark query-grid" style="height: 500px"></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0 report-popup px-5px comp-innotab px-0 py-0" kendo-window="win_ComparisonOrderReports" k-on-open="isComparisonOrderReportsVisible = true;winOpen();windowOpened(win_ComparisonOrderReports);" k-on-close="isComparisonOrderReportsVisible = false;winComparisonOrderReports_OnClose();onClearFilterReportList(true);windowClosed(win_ComparisonOrderReports);" k-title="\'Report\'" k-modal="true" k-visible="false" k-width="DataObject.winComparisonOrderReportsWidth" k-height="defaultWindowHeight" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isComparisonOrderReportsVisible"><div class=""><div class=""><div class="row mb-20px m-0"><div class="col-md-12 p-0"><div class="" ng-if="!DataObject.ShowReportModal"><div class="" id="{{OrderReport.OrderID}}"><div class="mob-report"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Report</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Report" selected-order="SelectedOrder"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="ReportSelectedOrder"></patientdetails><div class="w-100" ng-if="report.DictationValue"><div class="w-100 repoheight-1 overflow-y-auto overflow-x-hide py-10px px-15px reportmaxwin bg-clr-49"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="width:100%; display:block; line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div></div></div></div><div class="m-0" ng-if="DataObject.ShowReportModal"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Report</a></li><studyactionmenu action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Report" selected-order="SelectedOrder"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="ReportSelectedOrder" show-contact="showContact(SelectedOrder.OrderingPhysician, SelectedOrder.LocationID, SelectedOrder.Location)"></patientdetails><div class="rprtdscn-fbtns-wrapper d-flex align-item-center p-5px-all px-10px"><div class="width-100 mr-15px"><input type="text" class="blk-input form-control col-placeholder h-25px input-filterreport" placeholder="Search" ng-model="DataObject.SearchText" ng-keyup="FilterReportList(true)"></div><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap mr-15px"><li class="pos-rel align-self-center mr-15px"><a class="border-0 btnpopover-sorting bor-rad-2px py-4px px-4px fs-10px text-center" ng-click="DataObject.displaySortPopover = true" uib-tooltip="{{DataObject.SelectedSortingOption}}" tooltip-placement="top" ng-style="DataObject.displaySortPopover == true ? {\'background-color\':\'#05c1a4\'} : {\'background-color\': \'rgba(5, 193, 164, 0.19);\'}"><i class="fa fa-sort-amount-asc" aria-hidden="true"></i></a><div class="popover-sorting p-5px-all bor-rad-2px" ng-show="DataObject.displaySortPopover" ng-mouseleave="DataObject.displaySortPopover = false"><a class="popover-sorting-item d-block p-5px-all cursor-pointer fs-12px fw-400 txt-clr-1" ng-repeat="list in DataObject.ReportSortingOptions" ng-class="{\'active\' : list == DataObject.SelectedSortingOption}" ng-click="onReportSortingClicked(list)">{{list}}</a></div></li><li class="text-center" ng-repeat="list in DataObject.ReportList.DateRange" ng-class="{\'active\' : DataObject.ReportListFilter.DateRange == list}" ng-click="DataObject.ReportListFilter.DateRange=list;FilterReportList(true)"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap"><li class="text-center" ng-repeat="list in DataObject.ReportList.Modalities track by $index" ng-class="{\'active\' : DataObject.ReportListFilter.Modality == list}" ng-click="DataObject.ReportListFilter.Modality=list;FilterReportList(true)"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul></div><div class="row m-0"><div class="col-lg-2 col-sm-2 col-xs-3 m-0 pl-0 pr-0 pr-5px bg-clr-49"><div class="overflow-auto repoheight-2 repoHeiFtrWrklst ftlrbtns-height"><div ng-repeat="r in reportList | orderBy: DataObject.ReportSortingPropName : DataObject.ReportSortingRevOrder track by $index" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #959595 1px solid;cursor:pointer; word-wrap: break-word !important;">{{r.ProcedureDesc}}<div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}">DOS : {{r.FormattedOrderDate | date:\'MM/dd/yyyy\'}}</div><span ng-if="signByDisplay(r)">{{signByDisplay(r)}}</span> {{r.Location}}</div></div></div><div class="col-lg-10 col-sm-10 col-xs-9 col-sm-10 m-0 wlh-pdf pl-0" id="{{OrderReport.OrderID}}"><div class="row 100 ng-scope ml-0" ng-if="report.DictationValue && reportList.length > 0"><div class="w-100 repoheight-2 rprtsinglwrklst overflow-y-auto overflow-x-hide py-10px px-10px bg-clr-49 repoHeiFtrWrklst"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div></div></div></div></div></div></div></div></div></div><script type="text/ng-template" id="order_info_tab.html"><div ng-if="isPatientInfoVisible"> <div class="m-0 rf-fs-ui"> <form name="frmPatientInfo" id="frmPatientInfo" class="mob-editorder mt--10px"> <div class="row"> <div class="col-md-12"> <div class="row"> <div class="col-md-6 col-sm-6 col-lg-6 p-0"> <div class="row mx-0 mb-5px"> <div class="col-md-12"> <fieldset> <legend>Patient Information</legend> <div class="row m-0"> <div class="col-md-6"> <div class="row mb-5px"> <div class="col-md-12"> <label class="rf-label">MRN *</label> <input type="text" class="blk-input form-control" id="MRN" placeholder="MRN" ng-model="PatientInfo.PatientMRN" autocomplete="off" ng-required="true" first-char-no-space /> </div> </div> </div> <div class="col-md-6"> <div class="row mb-5px"> <div class="col-md-12"> <label class="rf-label">DOB *</label> <div class="input-group blk-calender-inpop"> <input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="PatientDOB.DOB" is-open="isPDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="PatientDOB" placeholder="DOB(mm/dd/yyyy)" ng-required="true" first-char-no-space> <span class="input-group-btn"> <button type="button" class="btn btn-default" ng-click="isPDOBOpen = !isPDOBOpen"> <i class="glyphicon glyphicon-calendar"></i> </button> </span> </div> </div> </div> </div> </div> <div class="row m-0"> <div class="col-md-6"> <div class="row mb-5px"> <div class="col-md-12"> <label class="rf-label">Last Name *</label> <input type="text" class="blk-input form-control" id="LastName" placeholder="Last Name" ng-model="PatientInfo.PatientLastName" autocomplete="off" ng-required="true" first-char-no-space /> </div> </div> <div class="row mb-5px"> <div class="col-md-12"> <label class="rf-label">First Name *</label> <input type="text" class="blk-input form-control" id="FirstName" placeholder="First Name" ng-model="PatientInfo.PatientFirstName" autocomplete="off" ng-required="true" first-char-no-space /> </div> </div> <div class="row mb-10px"> <div class="col-md-12"> <label class="rf-label">Middle Name</label> <input type="text" class="blk-input form-control" id="MiddleName" placeholder="Middle Name" ng-model="PatientInfo.PatientMiddleName" autocomplete="off" first-char-no-space /> </div> </div> </div> <div class="col-md-6"> <div class="row mb-5px"> <div class="col-md-12"> <label class="rf-label">Sex *</label> <div class="form-controller d-flex align-item-center"> <label class="d-flex align-item-center mr-10px mb-0 h-30px"> <input class="cmn-checkbx-input m-0" type="radio" id="male" name="gender" ng-model="PatientInfo.PatientGender" value="M" ng-required="true"> <span class="rf-label cmn-check-label">Male</span> </label> <label class="d-flex align-item-center mb-0 h-30px"> <input class="cmn-checkbx-input m-0" type="radio" id="female" name="gender" ng-model="PatientInfo.PatientGender" value="F" ng-required="true"> <span class="rf-label cmn-check-label">Female</span> </label> </div> </div> </div> <div class="row mb-10px"> <div class="col-md-12"> <label class="rf-label">Phone</label> <input type="text" class="blk-input form-control" id="PatientPhone" name="PatientPhone" ng-model="PatientInfo.PatientPhone" autocomplete="off" ui-mask="(999) 999-9999" ng-minlength="10" ng-class="{\'border-color-red\': (frmPatientInfo.PatientPhone.$touched && frmPatientInfo.PatientPhone.$invalid)}" /> </div> </div> <div class="row mb-10px"> <div class="col-md-12"> <label class="rf-label">Email</label> <input type="email" class="blk-input form-control" id="PatientEmailID" name="PatientEmailID" ng-model="PatientInfo.PatientEmailID" autocomplete="off" placeholder="hello@example.com" ng-class="{\'border-color-red\': (frmPatientInfo.PatientEmailID.$touched && frmPatientInfo.PatientEmailID.$invalid)}" /> </div> </div> </div> </div> </fieldset> </div> </div> <div class="row mx-0 mb-5px"> <div class="col-md-12"> <fieldset> <legend>Ordering Physician</legend> <div class="row m-0"> <div class="col-md-6"> <div class="row mb-5px" title="To update this field, choose the appropriate ordering physician from the dropdown list."> <div class="col-md-12 tultip-bottom section-disbl"> <label class="rf-label">Site (Tenant) *</label> <ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="PatientInfo.OrderingPhysicianSite" title="Select Site" ng-required="true"> <ui-select-match placeholder="Select Site" allow-clear="true"> {{$select.selected.Site}} ({{$select.selected.TenantName}}) </ui-select-match> <ui-select-choices repeat="list in DataObject.MasterData.Sites | propsFilter: {Site: $select.search} | orderBy:\'Site\'" position=\'down\'> <span>{{list.Site}} ({{list.TenantName}})</span> </ui-select-choices> </ui-select> </div> </div> <div class="row mb-5px" title="To update this field, choose the appropriate ordering physician from the dropdown list."> <div class="col-md-12 section-disbl"> <label class="rf-label">Last Name *</label> <input type="text" class="blk-input form-control mr-5px" placeholder="Last Name" id="OrderingPhysicianLastName" ng-model="PatientInfo.OrderingPhysicianLastName" autocomplete="off" ng-required="true" first-char-no-space /> </div> </div> <div class="row mb-5px" title="To update this field, choose the appropriate ordering physician from the dropdown list."> <div class="col-md-12 section-disbl"> <label class="rf-label">First Name *</label> <input type="text" class="blk-input form-control mr-5px" placeholder="First Name" id="OrderingPhysicianFirstName" ng-model="PatientInfo.OrderingPhysicianFirstName" autocomplete="off" ng-required="true" first-char-no-space /> </div> </div> <div class="row mb-10px" title="To update this field, choose the appropriate ordering physician from the dropdown list."> <div class="col-md-12 section-disbl"> <label class="rf-label">Middle Name</label> <input type="text" class="blk-input form-control ordphy-lastname" placeholder="Middle Name" id="OrderingPhysicianMiddleName" ng-model="PatientInfo.OrderingPhysicianMiddleName" autocomplete="off" first-char-no-space /> </div> </div> </div> <div class="col-md-6"> <div class="row mb-5px"> <div class="col-md-12"> <label class="rf-label"> <span>Ordering Physician *</span> <span class="cursor-pointer float-right pr-5px txt-clr-1" ng-click="EditOrderingPhysicianModal()" title="Edit Ordering Physician"> <i class="cursor-pointer glyphicon glyphicon-pencil fs-11px txt-clr-14"></i> Edit </span> <span class="cursor-pointer float-right pr-10px txt-clr-1" ng-click="OpenOrderingPhysicianModal()" title="Add Ordering Physician"> <i class="fa fa-plus"></i> Add </span> </label> <ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="DataObject.OrderingPhysician.Provider" title="Select Ordering Physician" ng-disabled="!(PatientInfo.OrderingPhysicianSite)" on-select="OnProviderSelected(DataObject.OrderingPhysician.Provider)"> <ui-select-match placeholder="Select Ordering Physician"> {{$select.selected.Name}}{{$select.selected.NPI ? \' - \' + $select.selected.NPI : \'\'}} </ui-select-match> <ui-select-choices repeat="list in DataObject.MasterData.ProvidersList | propsFilter: {FirstName: $select.search, LastName: $select.search, NPI: $select.search} | orderBy:\'Name\'" position=\'down\' refresh="GetProvidersList($select.search)" refresh-delay="500"> <span>{{list.Name}}{{list.NPI ? \' - \' + list.NPI : \'\'}}</span> </ui-select-choices> </ui-select> </div> </div> <div class="row mb-5px" title="To update this field, choose the appropriate ordering physician from the dropdown list."> <div class="col-md-12 section-disbl"> <label class="rf-label">NPI</label> <input type="text" class="blk-input form-control" placeholder="NPI" id="OrderingNPI" numbers-only maxlength="20" ng-model="PatientInfo.OrderingPhysicianNPI" autocomplete="off" first-char-no-space /> </div> </div> <div class="row mb-10px" title="To update this field, choose the appropriate ordering physician from the dropdown list."> <div class="col-md-12 section-disbl"> <label class="rf-label">Phone</label> <input type="text" class="blk-input form-control" id="OrderingPhone" ui-mask="(999) 999-9999" maxlength="20" ng-model="PatientInfo.OrderingPhysicianPhone" autocomplete="off" name="OrderingPhone" ng-minlength="10" ng-class="{\'border-color-red\': (frmPatientInfo.OrderingPhone.$touched && frmPatientInfo.OrderingPhone.$invalid)}" /> </div> </div> <div class="row mb-10px" title="To update this field, choose the appropriate ordering physician from the dropdown list."> <div class="col-md-12 section-disbl"> <label class="rf-label">Cell Phone</label> <input type="text" class="blk-input form-control " id="OrderingCellPhone" ui-mask="(999) 999-9999" maxlength="20" ng-model="PatientInfo.OrderingPhysicianCellPhone" autocomplete="off" name="OrderingCellPhone" ng-minlength="10" ng-class="{\'border-color-red\': (frmPatientInfo.OrderingCellPhone.$touched && frmPatientInfo.OrderingCellPhone.$invalid)}" /> </div> </div> </div> </div> </fieldset> </div> </div> <div class="row mx-0 mb-5px" ng-if="isAssignAllowed(PatientInfo.Status)"> <div class="col-md-12"> <fieldset> <legend>Order Assignment</legend> <div class="row mb-15px mx-0 d-flex align-item-center flex-nowrap"> <div class="col-md-2"> <label class="rf-label fs-13px">Assign to:</label> </div> <div class="col-md-10 mt-1 p-0 discussion-sel tultip-bottom" style="flex: 1; max-width: 450px;"> <div id="kddtOrderDiscussion" class="visb-close-icon" style="width: 100%;border-color:#424242!important;background-color:#323232!important; border-radius: 4px !important;" kendo-dropdowntree="kddtOrderDiscussion" k-options="OrderDiscussionOptions"></div> <span class="tultiptext text-preline overflow-auto text-left tt-white sl-hsw-180px" style="top:33px!important; max-height:80px; visibility:hidden;" id="OrderDiscussionAssignmentTooltip">{{orderDiscussionTooltip}}</span> </div> </div> </fieldset> </div> </div> </div> <div class="col-md-6 col-sm-6 col-lg-6 p-0"> <div class="row m-0"> <div class="col-md-12"> <fieldset> <legend>Order Infomation</legend> <div class="row mb-5px mx-0"> <div class="col-md-4 mb-5px"> <label class="rf-label">Location *</label> <!--<input type="text" class="form-control flow-input" id="Location" placeholder="Location" ng-model="PatientInfo.Location" autocomplete="off" ng-required="true" readonly />--> <ui-select skip-focusser="true" class="mult-select mob-closekeypad" ng-model="PatientInfo.SelectedLocation" ng-required="true"> <ui-select-match placeholder="Select Location"> {{$select.selected.Location}} </ui-select-match> <ui-select-choices repeat="list in LocationBySite | propsFilter: {Location: $select.search}" position=\'down\'> <div ng-bind-html="list.Location | highlight: $select.search"></div> </ui-select-choices> </ui-select> </div> <div class="col-md-4 mb-5px"> <label class="rf-label">Accession</label> <input type="text" class="blk-input form-control" id="Accession" placeholder="Accession" ng-model="PatientInfo.Accession" autocomplete="off" disabled /> </div> <div class="col-md-4 mb-5px"> <label class="rf-label">Patient Class</label> <ui-select skip-focusser="true" class="mult-select b-clr bg-clr-31 mob-closekeypad" ng-model="PatientInfo.SelectedPatientClass" title="Select Patient Class"> <ui-select-match placeholder="Select Patient Class" allow-clear="true"> {{$select.selected.Value}} </ui-select-match> <ui-select-choices repeat="list in PatientClass | propsFilter: {Value: $select.search}" position=\'down\'> <div ng-bind-html="list.Value | highlight: $select.search"></div> </ui-select-choices> </ui-select> </div> </div> <div class="row mx-0 d-flex statdatetime-row"> <div class="col-lg-4 col-md-4 col-sm-6 col-xs-4 dos-p"> <label class="rf-label">DOS *</label> <div class="input-group blk-calender-inpop"> <input type="text" ng-required="true" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="PatientInfo.DOS" is-open="isPDOSOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" enable-time="true" name="OrderDate" placeholder="DOS(mm/dd/yyyy)" first-char-no-space> <span class="input-group-btn"> <button type="button" class="btn btn-default" ng-click="isPDOSOpen = !isPDOSOpen"> <i class="glyphicon glyphicon-calendar"></i> </button> </span> </div> </div> <div class="col-lg-2 col-md-2 col-sm-3 col-xs-3 sm-pl-0px"> <uib-timepicker class="rf-timepick rf-techform-tpckr" style="margin:-10px auto auto auto" id="FromTime" name="FromTime" ng-model="PatientInfo.DOSTime" hour-step="hstep" minute-step="mstep" show-meridian="false"></uib-timepicker> </div> <div class="col-lg-6 col-md-6 col-sm-12 col-xs-4 stststrktrm d-none"> <div class="form-controller mt-2 d-flex align-item-center mr-20px"> <input type="checkbox" class="m-0 cmn-checkbx-input" id="STAT" ng-model="PatientInfo.IsSTAT" autocomplete="off" ng-click="IsSTATChecked()" /> <label for="STAT" class="rf-label cmn-check-label">STAT</label> </div> <div class="form-controller mt-2 d-flex align-item-center mr-20px" ng-style="{\'cursor\': !PatientInfo.IsSTAT ? \'not-allowed\': \'pointer\'}"> <input type="checkbox" class="m-0 cmn-checkbx-input" id="STATStroke" ng-model="PatientInfo.IsSTATStroke" autocomplete="off" ng-disabled="!PatientInfo.IsSTAT" /> <label for="STATStroke" class="rf-label cmn-check-label">Stroke</label> </div> <div class="form-controller mt-2 d-flex align-item-center" ng-style="{\'cursor\': !PatientInfo.IsSTAT ? \'not-allowed\': \'pointer\'}"> <input type="checkbox" class="m-0 cmn-checkbx-input" id="STATTrauma" ng-model="PatientInfo.IsSTATTrauma" autocomplete="off" ng-disabled="!PatientInfo.IsSTAT" /> <label for="STATTrauma" class="rf-label cmn-check-label">Trauma</label> </div> </div> </div> <div class="row mb-5px mx-0"> <div class="col-md-6"> <label class="rf-label mb-0">Priority</label> <div class="form-controller d-flex align-item-center"> <label class="d-flex align-item-center mr-10px mb-0 h-30px" ng-repeat="priority in DataObject.StudyPriorities| orderBy:\'Priority\'"> <input class="cmn-checkbx-input m-0" type="radio" id="{{priority.Priority}}" name="priority" ng-model="PatientInfo.DelayedSTAT" value="{{priority.Key}}" ng-click="PriorityChanged()" ng-disabled="priority.Key == 1"> <span class="rf-label cmn-check-label">{{priority.Priority}}</span> </label> </div> </div> <div class="col-md-6" ng-if="PatientInfo.DelayedSTAT == 2"> <label class="rf-label mb-0">STAT</label> <div class="form-controller d-flex align-item-center"> <div class="form-controller mt-2 d-flex align-item-center mr-20px" ng-style="{\'cursor\': PatientInfo.DelayedSTAT != 2 ? \'not-allowed\': \'pointer\'}"> <input type="checkbox" class="m-0 cmn-checkbx-input" id="STATStroke" ng-model="PatientInfo.IsSTATStroke" autocomplete="off" ng-disabled="PatientInfo.DelayedSTAT != 2" /> <label for="STATStroke" class="rf-label cmn-check-label">Stroke</label> </div> <div class="form-controller mt-2 d-flex align-item-center" ng-style="{\'cursor\': PatientInfo.DelayedSTAT != 2 ? \'not-allowed\': \'pointer\'}"> <input type="checkbox" class="m-0 cmn-checkbx-input" id="STATTrauma" ng-model="PatientInfo.IsSTATTrauma" autocomplete="off" ng-disabled="PatientInfo.DelayedSTAT != 2" /> <label for="STATTrauma" class="rf-label cmn-check-label">Trauma</label> </div> </div> </div> </div> <div class="row mb-5px mx-0"> <div class="col-lg-2 col-md-4 col-sm-12 col-xs-12 mb-5px"> <label class="rf-label">Modality *</label> <ui-select skip-focusser="true" class="mult-select mob-closekeypad" ng-model="PatientInfo.Modality" ng-required="true"> <ui-select-match placeholder="Select Modalities"> {{$select.selected.Code}} </ui-select-match> <ui-select-choices repeat="list in Modalities | propsFilter: {Code: $select.search}" position=\'down\'> <div ng-bind-html="list.Code | highlight: $select.search"></div> </ui-select-choices> </ui-select> </div> <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-5px"> <label class="rf-label">Procedure Code </label> <input type="text" class="blk-input form-control" id="ProcedureCode" placeholder="Procedure Code" ng-model="PatientInfo.CPTProcedures" autocomplete="off" first-char-no-space /> </div> <div class="col-lg-6 col-md-4 col-sm-12 col-xs-12 mb-5px"> <label class="rf-label">Procedure Desc *</label> <input type="text" class="blk-input form-control" placeholder="Procedure Desc" id="ProcedureDesc" ng-model="PatientInfo.CPTProcedureDesc" autocomplete="off" ng-required="true" first-char-no-space /> </div> </div> <div class="row mb-5px mx-0"> <div class="col-md-6 mb-5px"> <label class="rf-label">Contrast </label> <ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="PatientInfo.ContrastType"> <ui-select-match allow-clear="false"> {{$select.selected.Value}} </ui-select-match> <ui-select-choices repeat="list in SiteContrastList | filter: {Value: $select.search}" position=\'down\'> <div ng-bind-html="list.Value | highlight: $select.search"></div> </ui-select-choices> </ui-select> </div> <div class="col-md-6 mb-5px"> <label class="rf-label">Contrast Amount</label> <input type="text" class="blk-input form-control" placeholder="Contrast Amount" id="OrderingPhysician" ng-model="PatientInfo.ContrastAmount" autocomplete="off" ng-disabled="!PatientInfo.ContrastType" first-char-no-space /> </div> </div> <div class="row mb-5px mx-0"> <div class="col-md-12"> <label class="rf-label">Reason *</label> <!--<input type="text" class="form-control flow-input" placeholder="Reason for exam" id="Reason" ng-model="PatientInfo.Reason" autocomplete="off" />--> <textarea class="txt-area h-65px w-100 py-6px px-12px" ng-model="PatientInfo.Reason" placeholder="Reason for exam" ng-required="true"> </textarea> </div> </div> <div class="row mb-5px mx-0"> <div class="col-md-12"> <label class="rf-label">Comment</label> <!--<input type="text" class="form-control flow-input" placeholder="NPI" id="OrderingNPI" ng-model="PatientInfo.OrderingPhysicianNPI" autocomplete="off" />--> <textarea class="txt-area h-75px w-100 py-6px px-12px" ng-model="PatientInfo.Comment" placeholder="Add a comment"> </textarea> </div> </div> <div class="row mb-5px mx-0"> <div class="col-md-12"> <label class="rf-label k-display-inline-block">Technique</label> <div class="d-inline-block float-right"> <span class="cursor-pointer pr-5px txt-clr-1" ng-click="addNewTechnique()" title="Add New Technique"> <i class="fa fa-plus"></i> Add </span> <span class="cursor-pointer txt-clr-1" ng-click="selectTechnique()" title="Search Technique"> <i class="fa fa-search"></i> Search </span> </div> <div class="clearfix"></div> <textarea class="txt-area h-75px w-100 py-6px px-12px" ng-model="PatientInfo.TechniqueValue" placeholder="Add a technique"> </textarea> </div> </div> <div class="row mb-5px mx-0"> <div class="col-md-12"> <div class="w-80 float-left"> <div class="control-fileupload"> <label for="file"></label> <input class="cursor-pointer w-100 type-fileupload" type="file" id="file" name="file" multiple onchange="angular.element(this).scope().getFileDetails(this)" accept="application/pdf,image/jpeg,.doc, .docx, .csv, .xls, .xlsx, .ppt, .pptx" /> </div> <span class="fs-13px fw-600 text-left txt-clr-5 d-block pt-5px lh-1">Only pdf, doc, excel, ppt, png and jpg files are allowed.</span> </div> <div class="w-20 float-left text-right"> <input class="btn btn-primary" type="button" ng-click="uploadFiles()" value="Upload" /> </div> <div class="clearfix"></div> </div> </div> </fieldset> </div> </div> </div> </div> </div> </div> <div class="row mx-0"> <div class="col-md-12 text-right mt-10px"> <button type="button" class="btn btn-default mb-5px" ng-if="PatientInfo.IsPatientWallet" ng-click="sendInvite((frmPatientInfo.PatientEmailID.$touched && frmPatientInfo.PatientEmailID.$invalid),(frmPatientInfo.PatientPhone.$touched && frmPatientInfo.PatientPhone.$invalid))" ng-disabled="!(PatientInfo.PatientFirstName && PatientInfo.PatientLastName && PatientInfo.DOS) || SendInvite"> Send Invite </button> <button class="btn btn-default mb-5px" data-dismiss="modal" ng-click="closePatientInfo()">Cancel</button> <button class="btn btn-primary mb-5px" style="background-color:#38dec4!important;" ng-click="BtnOrderComplete(frmPatientInfo.$valid)" ng-if="PatientInfo.OrderStatusID==1">Order Complete</button> <button class="btn btn-primary savebt mb-5px" ng-disabled="frmPatientInfo.$invalid" ng-click=\'BtnSaveOrder(frmPatientInfo.$valid)\'> Save </button> </div> </div> </form> </div> </div></script><script type="text/ng-template" id="order_forms_tab.html"><order-questionnaire-form order-id="SelectedOrder.OrderID"></order-questionnaire-form></script>');
$templateCache.put('app/pages/techno-lite/techno-lite.html','<script src="cdn/js/dwv-0.26.0.min.js"></script><link rel="stylesheet" href="cdn/css/ui-grid.css"><style>\r\n    .spinner-overlay {\r\n        position: absolute !important;\r\n    }\r\n    .anui .ui-grid-row .ui-grid-cell .w-100 .tooltip.uibtooltipDenial {\r\n        pointer-events: none;\r\n    }\r\n    /*.filtsecion .blk-input.form-control,\r\n    .filtsecion .mult-select .form-control,\r\n    .filtsecion select.form-control {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n        padding: 5px 12px !important;\r\n    }\r\n\r\n    .filtsecion .loc-input {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n\r\n    .filtsecion .mult-select.ui-select-multiple.ui-select-bootstrap {\r\n        min-height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n\r\n    .filtsecion .k-multiselect-wrap,\r\n    .filtsecion .k-multiselect-wrap .k-input {\r\n        height: 30px !important;\r\n        border-width: 0 !important;\r\n    }\r\n\r\n        .filtsecion .k-multiselect-wrap .k-button {\r\n            font-size: 12px !important;\r\n        }\r\n\r\n    .filtsecion select.form-control.status-fs option {\r\n        font-size: 14px !important;\r\n    }*/\r\n\r\n    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {\r\n        /* IE9+ specific styles go here */\r\n        /*.disabled-grid {\r\n                display: block !important;\r\n                overflow-x: hidden !important;\r\n            }\r\n\r\n            .disabled-list-footer {\r\n                position: fixed !important;\r\n                bottom: 0 !important;\r\n                width: 100% !important;\r\n                padding-bottom: 5px;\r\n            }\r\n\r\n            .charges-list {\r\n                padding-bottom: 40px !important;\r\n                padding-top: 100px !important;\r\n            }\r\n\r\n            .mail-messages-control {\r\n                position: absolute;\r\n                width: 100%;\r\n                z-index: 1 !important;\r\n            }\r\n                */\r\n    }\r\n\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    /*ui-select-choices only for this page */\r\n\r\n    /*.sel-block .ui-select-choices {\r\n            position: fixed;\r\n            top: auto;\r\n            left: auto;\r\n            width: auto !important;\r\n        }*/\r\n\r\n    .uib-datepicker-popup.dropdown-menu {\r\n        /*position:fixed*/\r\n    }\r\n\r\n    /*div[uib-datepicker-popup-wrap] {\r\n             position: fixed;\r\n            top: auto !important;\r\n            left: auto !important;\r\n        }*/\r\n    object {\r\n        min-height: 600px !important;\r\n        max-height: 800px !important;\r\n    }\r\n\r\n    .IPAlert {\r\n        text-align: left !important;\r\n        height: auto !important;\r\n        max-height: 200px;\r\n        overflow-y: scroll;\r\n        text-align: left !important;\r\n        background-color: white;\r\n        font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\r\n        border-radius: 5px;\r\n        color: #333;\r\n        font-size: 18px;\r\n        overflow-y: auto !important;\r\n    }\r\n\r\n    .k-grid table thead tr th:first-child {\r\n        padding-left: 15px !important;\r\n    }\r\n\r\n    .k-grid table tbody tr td:first-child {\r\n        padding-left: 15px !important;\r\n    }\r\n\r\n    .k-grid-header .k-header:first-child {\r\n        border-left-width: 1px !important;\r\n    }\r\n\r\n    .st-sort-ascent:before {\r\n        content: \'\\25B2\';\r\n    }\r\n\r\n    .st-sort-descent:before {\r\n        content: \'\\25BC\';\r\n    }\r\n\r\n    .lr-drop-target-before {\r\n        border-left: 2px solid orange;\r\n    }\r\n\r\n    .lr-drop-target-after {\r\n        border-right: 2px solid orange;\r\n    }\r\n\r\n    .dr-btn-none {\r\n        display: none;\r\n    }\r\n\r\n    #divTechForm {\r\n        /*padding: 10px;*/\r\n        height: 60vh;\r\n        overflow: auto;\r\n    }\r\n\r\n    .defaultfontclass select {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 5px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n\r\n    .defaultfontclass input[type="text"] {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 5px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n\r\n    .defaultfontclass input[type="checkbox"] {\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .defaultfontclass input[type="radio"] {\r\n        margin-right: 5px;\r\n    }\r\n\r\n    .defaultfontclass option {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .defaultfontclass textarea {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 0px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n\r\n    label.defaultfontclass {\r\n        box-sizing: border-box;\r\n        color: #fff !important;\r\n        font-weight: 600 !important;\r\n        margin-bottom: 5px;\r\n        font-size: 13px;\r\n        text-align: left;\r\n        display: inline-block !important;\r\n    }\r\n\r\n    .defaultfontclass td select {\r\n        vertical-align: inherit;\r\n    }\r\n\r\n    .defaultfontclass tr td {\r\n        vertical-align: top;\r\n    }\r\n\r\n    .ui-grid-row-selected {\r\n        background-color: #424242;\r\n    }\r\n\r\n    .popover {\r\n        position: absolute;\r\n        z-index: 100;\r\n    }\r\n\r\n    .ui-grid .ui-grid-render-container-body .ui-grid-viewport {\r\n        overflow-y: auto !important;\r\n        overflow-x: auto !important;\r\n    }\r\n</style><div class="radf-header wroklist-wrapper" keyboard="keys"><h2 class="float-left w-50 heading-tw">Technologist Worklist</h2><span class="float-right mr-10px py-4px" style=""><span class="float-left" style="display:none;"><img class="mr-5px sm-refresh" src="assets/images/refresh.svg" alt="Refresh"></span> <span class="d-inline-block"><button type="button" class="btn filterbt-2 no-bg fs-12px" ng-click="CollapseTechnoFilter()" id="heading_Techworklist" data-toggle="collapse" data-parent="#accordion" href="#collapseWorklist" aria-expanded="false" aria-controls="collapseTechWorklist"><span><span ng-if="isfilterCollapse">Open Filter<i class="fa fa-filter txt-clr-1 icon-hover fs-12px pl-5px"></i></span> <span ng-if="!isfilterCollapse">Close Filter<i class="fa fa-close txt-clr-1 icon-hover fs-12px pl-5px"></i></span></span></button></span></span><div class="clearfix"></div></div><div class="pportal-list"><div class=""><div class="p-0 collapse in b-clr-33 filtsecion filtr-ontop" id="collapseWorklist" role="tabpanel" aria-labelledby="heading_worklist"><form id="frmFilter" ng-submit="getDicomOrders(frmFilter.$valid)"><div class="rf-filter filter-controller row my-8px rf-filter-ui"><div class="col-sm-4 col-md-3 col-xs-2 mob-w-50 pr-0 tultip-bottom"><ui-select id="Location" class="mult-select" on-select="onSelected()" on-remove="onSelected()" ng-model="SelectedList.Location" multiple="" close-on-select="false" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" style="display:none!important"><ui-select-match placeholder="Select a Location" allow-clear="true" class="overflow-y-auto d-block overflow-x-hide" style="max-height:25px;">{{$item.Location}}</ui-select-match><ui-select-choices repeat="list in Locations | propsFilterStartWith: {Location: $select.search, Site: $select.search}" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div><small ng-if="list.Site">Site: <span ng-bind-html="list.Site | highlight: $select.search"></span></small></ui-select-choices></ui-select><rad-location location-id="locationTechnoTree" location-search-text-id="locationTechnoSearchText" options="sites" selected-values="RadLocationValues" on-update="updateLocationData()"></rad-location></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="Accession" placeholder="Accession" tooltip-class="uibtooltipDenial" uib-tooltip="Accession" tooltip-placement="auto top"></div><div class="col-sm-1 col-md-1 col-xs-2 mob-w-50 pr-0 pl-10px d-w-13"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="OrderDate" options="opts" ng-mouseenter="resetDateRange()" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{toolTipOrderDate}}" tooltip-placement="auto top"></div><div class="col-sm-2 col-md-1 col-xs-3 mob-w-50 pr-0 tultip-bottom pl-10px smw-19 w-12 selmod-m"><ui-select class="mult-select mod-placeholder selMod-clearall" ng-class="{\'clearallAcDc\' : SelectedList.Modality}" ng-model="SelectedList.Modality" multiple="" close-on-select="false" title="" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" ng-change="onSelectedModalityTechno()"><ui-select-match placeholder="Select Modalities" allow-clear="true" class="overflow-y-auto d-block overflow-x-hide" style="max-height:25px;">{{$item.Code}}</ui-select-match><ui-select-choices repeat="list in Modalities | propsFilter: {Code: $select.search}" position="down"><div ng-bind-html="list.Code | highlight: $select.search"></div></ui-select-choices></ui-select><span class="clearSelModValue" ng-click="clearSelModaValue()">X</span> <span class="tultiptext text-preline overflow-auto max-h-500px text-left tt-white tt-top">{{modalitytechnotooltip}}</span></div><div class="col-sm-1 col-md-2 col-xs-2 mob-w-100 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="OrderingPhysician" placeholder="Ordering Physician" tooltip-class="uibtooltipDenial" uib-tooltip="Ordering Physician" tooltip-placement="auto top"></div></div><div class="rf-filter filter-controller row mb-4px rf-filter-ui"><div class="col-sm-3 col-md-3 col-xs-3 mob-w-50 pr-0"><div class="col-sm-5 col-md-5 col-xs-5 pr-0 pl-0" style="z-index:1"><input type="text" class="blk-input form-control col-placeholder" ng-model="PatientMRN" placeholder="MRN" tooltip-class="uibtooltipDenial" uib-tooltip="MRN" tooltip-placement="auto top"></div><div class="col-sm-7 col-md-7 col-xs-7 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="PatientName" placeholder="Patient Name" tooltip-class="uibtooltipDenial" uib-tooltip="Patient Last Name, First Name" tooltip-placement="auto top"></div></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px"><div class="input-group blk-calender mb-0"><input type="text" class="blk-input form-control col-placeholder" tooltip-class="uibtooltipDenial" uib-tooltip="DOB (mm/dd/yyyy)" tooltip-placement="auto top" uib-datepicker-popup="MM/dd/yyyy" ng-model="DOB" is-open="isDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="DOB" placeholder="DOB" data-container="body" ng-click="isDOBOpen = !isDOBOpen"></div></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px d-w-13 sclt-type-wdth"><ui-select skip-focusser="true" class="mult-select b-clr bg-clr-31 mob-closekeypad" ng-model="SelectedList.PatientClass" title="Select Type"><ui-select-match placeholder="Select Type" allow-clear="true">{{$select.selected.PatClass}}</ui-select-match><ui-select-choices repeat="list in PatientClass | propsFilter: {PatClass: $select.search}" position="down"><div ng-bind-html="list.PatClass | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px w-12 set-wdth-sm"><select id="ddlStatus" class="condition-select blk-input form-control downArrow-ie opnclr sing-select-2 status-fs" ng-model="Status" ng-change="getDicomOrders(true)"><option value="AL">All</option><option value="X" style="background-color: #BFDED6">Cancelled</option><option value="C" style="background-color: #75E284">Complete</option><option value="D" style="background-color: #a0c1c5">Draft</option><option value="IP" style="background-color: #f4ba4b">Image Pending</option><option value="OP" style="background-color: #b2b266">Pending Order</option><option value="RP" style="background-color: #FFE69A;">Result Pending</option><option value="H" style="background-color: #FFC99A">Hidden</option></select></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px" ng-show="Status == \'H\'"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="HiddenType.obj" ng-change="getDicomOrders()"><ui-select-match>{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="list in HiddenTypeList" position="down"><div ng-bind-html="list.Key"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px filt-w-new-wl fltr-btn-wrapper mob-flt-rt technobt-sec set-on-sm"><button type="submit" class="btn btn-primary rf-btn-xs">Filter</button> <button type="button" ng-click="SaveFilters();" class="btn btn-primary rf-btn-xs">Save Filter</button> <button type="button" ng-click="clearFilterAndRefesh();" class="btn btn-default rf-btn-xs">Clear</button></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-0 w-12 fltr-btn-wrapper mob-flt-rt no-pl technobt-sec main-wrps-rfr d-none"><div class="pb-0 pt-6px mb-0 d-flex auto-refresh-checkbox fs-12px txt-clr-1 fw-500"><label class="checkbox-switch" title="Auto Refresh"><input type="checkbox" ng-model="AutoRefresh" ng-change="onChangeAutoRefresh()" class="mr-2px"> <span class="checkbox-switch-slider round"></span></label> <span class="checkbox-switch-label">Auto Update</span></div></div></div></form></div><div class="bg-clr-27 h-5px"><div class="progress m-0 bg-clr-27" ng-if="isorderlistLoading"><div class="progress-bar progress-bar-striped active w-100 bg-clr-46" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div></div><div id="divOrderList" ui-grid="uiGridOptions" class="grid anui techno-table" style="width:100%;" ui-grid-infinite-scroll="" ui-grid-selection="" ui-grid-move-columns="" ui-grid-auto-resize="" ui-grid-resize-columns=""></div></div><div class="overflow-hide-all ERA-check-detail discsn-popup techno-dscsn" kendo-window="win_Discussion" k-on-open="isDiscussionVisible = true" k-on-close="isDiscussionVisible = false" k-title="\'Discussion\'" k-visible="false" k-width="win_DiscussionWidth" k-height="defaultWindowHeight" k-resize="winDiscussionTechResize" k-dragend="winDiscussionTechDragend" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div style="background-color:#262526!important;"><div class="spinner-overlay" ng-show="isDiscussionLoading"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div ng-if="isDiscussionVisible" class="techno-lite-discussion"><div class="denial-window"><div class="fw-500"><div class="row fw-500 mob-discussion mob-report mob-d-flex mob-flex-wrap"><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">Location :</span> <span class="report_span">{{SelectedOrder.Location}}</span></div><div class="mb-5px"><span class="report_span_title">Gender :</span> <span class="report_span">{{SelectedOrder.PatientGender}}</span></div><div class="mb-5px"><span class="report_span_title">Ordering Physician :</span> <span class="report_span">{{SelectedOrder.OrderingPhysician}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">DOS :</span> <span class="report_span">{{(SelectedOrder.OrderDate) ? (SelectedOrder.OrderDate | date:\'M/d/yy HH:mm\').toString().replace("00:00","") : \'\'}}</span></div><div class="mb-5px"><span class="report_span_title">Type :</span><span class="report_span" ng-if="SelectedOrder.PatientClass==\'E\'">Emergency</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'I\'">Inpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'O\'">Outpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'P\'">PreAdmit</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'U\'">Unknown</span></div><div class="d-inline-block pos-rel" ng-if="false"><div class="kendo-actionbtn-section" ng-show="SelectedOrder.OptionalDicomViewer.length > 0"><button class="kendo-dropbtn" uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"><i class="fa fa-file-image-o k-icon-downdir fs-18px"></i></button><div class="kendo-action-dropdown-content"><a href="#" class="btn" ng-click="OpenSynapseStudy(SelectedOrder, DV, false)" ng-if="SelectedOrder.OptionalDicomViewer.includes(\'AGFA\')"><i class="agfa d-block" uib-tooltip-html="\'AGFA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"></i></a> <a href="#" class="btn" ng-click="OpenSynapseStudy(SelectedOrder, DV, false)" ng-if="SelectedOrder.OptionalDicomViewer.includes(\'CANDELIS\')"><i class="candelis d-block" uib-tooltip-html="\'CANDELIS\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"></i></a> <a href="#" class="btn" ng-click="OpenSynapseStudy(SelectedOrder, DV, false)" ng-if="SelectedOrder.OptionalDicomViewer.includes(\'KONICA\')"><i class="konica d-block" uib-tooltip-html="\'KONICA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"></i></a> <a href="#" class="btn" ng-click="OpenSynapseStudy(SelectedOrder, DV, false)" ng-if="SelectedOrder.OptionalDicomViewer.includes(\'SYNAPSE\')"><i class="synapse d-block" uib-tooltip-html="\'SYNAPSE\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"></i></a></div></div></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">Patient Name :</span> <span class="report_span">{{SelectedOrder.PatientName}}</span></div><div class="mb-5px"><span class="report_span_title">Modality :</span> <span class="report_span">{{SelectedOrder.Modality}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">DOB :</span> <span class="report_span">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span></div><div class="mb-5px"><span class="report_span_title">Procedure :</span> <span class="report_span text-breakword">{{SelectedOrder.ProcedureDesc}}</span></div><div class="mb-5px"><button type="button" ng-show="ODType==\'Helper\'" class="btn btn-default pull-right" ng-click="CloseOrderDiscussion()">Close Discussion</button></div></div></div><div class="text-right mt-8px" ng-class="{\'float-right\': !showAttachment}"><a class="cursor-pointer mb-5px" ng-if="SelectedOrder.FileCount > 0 && !showAttachment" ng-click="showFileList()">View Attachment ({{SelectedOrder.FileCount}})</a> <a class="btn btn-default mb-5px" ng-if="showAttachment" ng-click="hideFileList()"><i class="fa fa-arrow-left mr-5px"></i>Back</a></div><div ng-if="!showAttachment" ng-class="{\'useriprpht\': Status == \'IP\' || Status == \'RP\'}"><div class="row m-0" ng-if="Status == \'IP\' || Status == \'RP\'"><div class="col-lg-3 col-md-3 col-sm-3 p-0 discussion-sel tultip-bottom"><div id="kddtOrderDiscussion" class="visb-close-icon" style="width: 100%;border-color:#424242!important;background-color:#323232!important;" kendo-dropdowntree="kddtOrderDiscussion" k-options="OrderDiscussionOptions"></div><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px" style="top:33px!important; visibility:hidden;" id="OrderDiscussionAssignmentTooltip">{{orderDiscussionTooltip}}</span></div></div><div class="row m-0 clearfix"><div class="col-md-12 form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment."> </textarea></div></div><div class="py-10px"><div class="float-right px-15px discu-choose-files m-p-0"><div class="float-left px-20px m-p-0"><div class="control-fileupload"><label for="file"></label> <input class="cursor-pointer w-100 type-fileupload" type="file" id="file" name="file" multiple="" onchange="angular.element(this).scope().getFileDetails(this)" accept="application/pdf,image/jpeg,image/png,.doc, .docx, .csv, .xls, .xlsx, .ppt, .pptx"></div><span class="fs-13px fw-600 text-left txt-clr-5 d-block py-5px">Only pdf, doc, excel, ppt, png and jpg files are allowed.</span></div><div class="float-left"><input class="btn btn-primary" type="button" ng-click="uploadFiles()" value="Upload"> <button type="button" class="btn btn-primary" ng-click="SaveDiscussion()" ng-disabled="SaveDiscussionFlag">Save</button> <button type="button" class="btn btn-default" ng-click="AssignStudy()" ng-show="AssignStudyVisible" style="display:none;">Assign Study</button></div><div class="clearfix"></div></div><div class="clearfix"></div></div><div class="discus-comment overflow-y-auto py-10px px-10px technosec"><div class=""><div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div><div ng-if="showAttachment"><div class=""><div class=""><attachment-viewer ng-if="ReferenceID" dicomorder-id="ReferenceID"></attachment-viewer></div></div></div></div></div></div></div><div class="overflow-x-hide ERA-check-detail editorder-popup p-0 overflow-y-auto" kendo-window="win_PatientInfo" k-on-open="openPatientInfo()" k-on-close="isPatientInfoVisible = false" k-title="\'Edit Order\'" k-visible="false" k-width="winPatientInfoTechWidth" k-height="750" k-resize="winPatientInfoTechResize" k-dragend="winPatientInfoTechDragand" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div style="background-color:#262526!important;"><div class="spinner-overlay" ng-show="isPatientInfoLoading"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div ng-if="isPatientInfoVisible"><div class="row m-0 rf-fs-ui"><form name="frmPatientInfo" id="frmPatientInfo" class="mob-editorder"><div class="col-md-12 p-0"><div class="row mx-0"><div class="col-md-12"><div class="row"><div class="col-md-6 col-sm-6 col-lg-6 p-0"><div class="row mx-0 mb-5px"><div class="col-md-12"><fieldset><legend>Patient Information</legend><div class="row m-0"><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">MRN *</label> <input type="text" class="blk-input form-control" id="MRN" placeholder="MRN" ng-model="PatientInfo.PatientMRN" autocomplete="off" ng-required="true" first-char-no-space=""></div></div></div><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">DOB *</label><div class="input-group blk-calender-inpop"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="PatientDOB.DOB" is-open="isPDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="PatientDOB" placeholder="DOB(mm/dd/yyyy)" ng-required="true" first-char-no-space=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="isPDOBOpen = !isPDOBOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><div class="row m-0"><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">Last Name *</label> <input type="text" class="blk-input form-control" id="LastName" placeholder="Last Name" ng-model="PatientInfo.PatientLastName" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">First Name *</label> <input type="text" class="blk-input form-control" id="FirstName" placeholder="First Name" ng-model="PatientInfo.PatientFirstName" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Middle Name</label> <input type="text" class="blk-input form-control" id="MiddleName" placeholder="Middle Name" ng-model="PatientInfo.PatientMiddleName" autocomplete="off" first-char-no-space=""></div></div></div><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">Sex *</label><div class="form-controller d-flex align-item-center"><label class="d-flex align-item-center mr-10px mb-0 h-30px"><input class="cmn-checkbx-input m-0" type="radio" id="male" name="gender" ng-model="PatientInfo.PatientGender" value="M" ng-required="true"> <span class="rf-label cmn-check-label">Male</span></label> <label class="d-flex align-item-center mb-0 h-30px"><input class="cmn-checkbx-input m-0" type="radio" id="female" name="gender" ng-model="PatientInfo.PatientGender" value="F" ng-required="true"> <span class="rf-label cmn-check-label">Female</span></label></div></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Phone</label> <input type="text" class="blk-input form-control" id="PatientPhone" name="PatientPhone" ng-model="PatientInfo.PatientPhone" autocomplete="off" ui-mask="(999) 999-9999" ng-minlength="10" ng-class="{\'border-color-red\': (frmPatientInfo.PatientPhone.$touched && frmPatientInfo.PatientPhone.$invalid)}"></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Email</label> <input type="text" class="blk-input form-control" id="PatientEmailID" name="PatientEmailID" ng-model="PatientInfo.PatientEmailID" autocomplete="off" placeholder="hello@example.com" ng-pattern="/[a-z0-9]+@[a-z]+\\.[a-z]{2,3}$/" ng-class="{\'border-color-red\': (frmPatientInfo.PatientEmailID.$touched && frmPatientInfo.PatientEmailID.$invalid)}"></div></div></div></div></fieldset></div></div><div class="row mx-0 mb-5px"><div class="col-md-12"><fieldset><legend>Ordering Physician</legend><div class="row m-0"><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">Last Name *</label> <input type="text" class="blk-input form-control mr-5px" placeholder="Last Name" id="OrderingPhysicianLastName" ng-model="PatientInfo.OrderingPhysicianLastName" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">First Name *</label> <input type="text" class="blk-input form-control mr-5px" placeholder="First Name" id="OrderingPhysicianFirstName" ng-model="PatientInfo.OrderingPhysicianFirstName" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Middle Name</label> <input type="text" class="blk-input form-control ordphy-lastname" placeholder="Middle Name" id="OrderingPhysicianMiddleName" ng-model="PatientInfo.OrderingPhysicianMiddleName" autocomplete="off" first-char-no-space=""></div></div></div><div class="col-md-6"><div class="row mb-5px"><div class="col-md-12"><label class="rf-label">NPI</label> <input type="text" class="blk-input form-control" placeholder="NPI" id="OrderingNPI" numbers-only="" maxlength="20" ng-model="PatientInfo.OrderingPhysicianNPI" autocomplete="off" first-char-no-space=""></div></div><div class="row mb-10px"><div class="col-md-12"><label class="rf-label">Phone</label> <input type="text" class="blk-input form-control" id="OrderingPhone" ui-mask="(999) 999-9999" maxlength="20" ng-model="PatientInfo.OrderingPhysicianPhone" autocomplete="off" name="OrderingPhone" ng-minlength="10" ng-class="{\'border-color-red\': (frmPatientInfo.OrderingPhone.$touched && frmPatientInfo.OrderingPhone.$invalid)}"></div></div></div></div></fieldset></div></div></div><div class="col-md-6 col-sm-6 col-lg-6 p-0"><div class="row m-0"><div class="col-md-12"><fieldset><legend>Order Infomation</legend><div class="row mb-5px mx-0"><div class="col-md-6 mb-5px"><label class="rf-label">Location *</label><ui-select skip-focusser="true" class="mult-select mob-closekeypad" ng-model="PatientInfo.SelectedLocation" ng-required="true"><ui-select-match placeholder="Select Location">{{$select.selected.Location}}</ui-select-match><ui-select-choices repeat="list in LocationBySite | propsFilter: {Location: $select.search}" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6"><label class="rf-label">Accession</label> <input type="text" class="blk-input form-control" id="Accession" placeholder="Accession" ng-model="PatientInfo.Accession" autocomplete="off" disabled=""></div></div><div class="row mb-5px mx-0 d-flex flex-wrap align-item-center"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-4 dos-p"><label class="rf-label">DOS *</label><div class="input-group blk-calender-inpop"><input type="text" ng-required="true" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="PatientInfo.DOS" is-open="isPDOSOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" enable-time="true" name="OrderDate" placeholder="DOS(mm/dd/yyyy)" first-char-no-space=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="isPDOSOpen = !isPDOSOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 sm-pl-0px"><uib-timepicker class="rf-timepick" style="margin:-10px auto auto auto" id="FromTime" name="FromTime" ng-model="PatientInfo.DOSTime" hour-step="hstep" minute-step="mstep" show-meridian="false"></uib-timepicker></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-4 text-left sm-pl-0px"><div class="form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="STAT" ng-model="PatientInfo.IsSTAT" autocomplete="off"> <label for="STAT" class="rf-label cmn-check-label">STAT</label></div></div></div><div class="row mb-5px mx-0"><div class="col-lg-2 col-md-4 col-sm-12 col-xs-12 mb-5px"><label class="rf-label">Modality *</label><ui-select skip-focusser="true" class="mult-select mob-closekeypad" ng-model="PatientInfo.Modality" ng-required="true"><ui-select-match placeholder="Select Modalities">{{$select.selected.Code}}</ui-select-match><ui-select-choices repeat="list in Modalities | propsFilter: {Code: $select.search}" position="down"><div ng-bind-html="list.Code | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-5px"><label class="rf-label">Procedure Code</label> <input type="text" class="blk-input form-control" id="ProcedureCode" placeholder="Procedure Code" ng-model="PatientInfo.CPTProcedures" autocomplete="off" first-char-no-space=""></div><div class="col-lg-6 col-md-4 col-sm-12 col-xs-12 mb-5px"><label class="rf-label">Procedure Desc *</label> <input type="text" class="blk-input form-control" placeholder="Procedure Desc" id="ProcedureDesc" ng-model="PatientInfo.CPTProcedureDesc" autocomplete="off" ng-required="true" first-char-no-space=""></div></div><div class="row mb-5px mx-0"><div class="col-md-6 mb-5px"><label class="rf-label">Contrast</label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="PatientInfo.ContrastType"><ui-select-match allow-clear="false">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in SiteContrastList" position="down"><div ng-bind-html="list.Value"></div></ui-select-choices></ui-select></div><div class="col-md-6 mb-5px"><label class="rf-label">Contrast Amount</label> <input type="text" class="blk-input form-control" placeholder="Contrast Amount" id="OrderingPhysician" ng-model="PatientInfo.ContrastAmount" autocomplete="off" ng-disabled="!PatientInfo.ContrastType" first-char-no-space=""></div></div><div class="row mb-5px mx-0"><div class="col-md-12"><label class="rf-label">Reason *</label><textarea class="txt-area h-65px w-100 py-6px px-12px" ng-model="PatientInfo.Reason" placeholder="Reason for exam" ng-required="true"> </textarea></div></div><div class="row mb-5px mx-0"><div class="col-md-12"><label class="fs-14px fw-500">Comment</label><textarea class="txt-area h-75px w-100 py-6px px-12px" ng-model="PatientInfo.Comment" placeholder="Add a comment"> </textarea></div></div><div class="row mb-5px mx-0"><div class="col-md-12"><label class="rf-label k-display-inline-block">Technique</label><div class="d-inline-block float-right"><span class="cursor-pointer pr-5px" ng-click="addNewTechnique()" title="Add New Technique"><i class="fa fa-plus"></i> Add</span> <span class="cursor-pointer" ng-click="selectTechnique()" title="Search Technique"><i class="fa fa-search"></i> Search</span></div><div class="clearfix"></div><textarea class="txt-area h-95px w-100 py-6px px-12px" ng-model="PatientInfo.TechniqueValue" placeholder="Add a technique"> </textarea></div></div><div class="row mb-5px mx-0"><div class="col-md-12"><div class="w-80 float-left"><div class="control-fileupload"><label for="file"></label> <input class="cursor-pointer w-100 type-fileupload" type="file" id="file" name="file" multiple="" onchange="angular.element(this).scope().getFileDetails(this)" accept="application/pdf,image/jpeg,.doc, .docx, .csv, .xls, .xlsx, .ppt, .pptx"></div><span class="fs-13px fw-600 text-left txt-clr-5 d-block pt-5px lh-1">Only pdf, doc, excel, ppt, png and jpg files are allowed.</span></div><div class="w-20 float-left text-right"><input class="btn btn-primary" type="button" ng-click="uploadFiles()" value="Upload"></div><div class="clearfix"></div></div></div></fieldset></div></div></div></div></div></div><div class="row mx-0"><div class="col-md-12 text-right mt-10px"><button type="button" class="btn btn-default mb-5px" ng-if="PatientInfo.IsPatientWallet" ng-click="sendInvite((frmPatientInfo.PatientEmailID.$touched && frmPatientInfo.PatientEmailID.$invalid),(frmPatientInfo.PatientPhone.$touched && frmPatientInfo.PatientPhone.$invalid))" ng-disabled="!(PatientInfo.PatientFirstName && PatientInfo.PatientLastName && PatientInfo.DOS) || SendInvite">Send Invite</button> <button class="btn btn-default mb-5px" data-dismiss="modal" ng-click="closePatientInfo()">Cancel</button> <button class="btn btn-primary mb-5px" style="background-color:#38dec4!important;" ng-click="BtnOrderComplete(frmPatientInfo.$valid)" ng-if="PatientInfo.OrderStatusID==1">Order Complete</button> <button class="btn btn-primary savebt mb-5px" ng-disabled="(frmPatientInfo.PatientPhone.$touched && frmPatientInfo.PatientPhone.$invalid) || (frmPatientInfo.OrderingPhone.$touched && frmPatientInfo.OrderingPhone.$invalid) || (frmPatientInfo.PatientEmailID.$touched && frmPatientInfo.PatientEmailID.$invalid)" ng-click="BtnSaveOrder(frmPatientInfo.$valid)">Save</button></div></div></div></form></div></div></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_HelpOrder" k-on-open="isHelpOrderVisible = true" k-on-close="isHelpOrderVisible = false" k-title="\'Help Order\'" k-visible="false" k-width="win_HelpOrderWidth" k-height="650" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isHelpOrderVisible"><div class="denial-window"><div class="row card-bg-white denial-window-head p-5px-all m-5px-all fw-600"><div class="col-md-3"><div><span class="report_span_title">Location :</span> <span class="report_span">{{SelectedOrder.Location}}</span></div><div><span class="report_span_title">Gender :</span> <span class="report_span">{{SelectedOrder.PatientGender}}</span></div><div><span class="report_span_title">Ordering Physician :</span> <span class="report_span">{{SelectedOrder.OrderingPhysician}}</span></div></div><div class="col-md-3"><div><span class="report_span_title">DOS :</span> <span class="report_span">{{(SelectedOrder.OrderDate) ? (SelectedOrder.OrderDate | date:\'M/d/yy HH:mm\').toString().replace("00:00","") : \'\'}}</span></div><div><span class="report_span_title">Type :</span> <span class="report_span">{{SelectedOrder.PatientClass}}</span></div></div><div class="col-md-3"><div><span class="report_span_title">Patient Name :</span> <span class="report_span">{{SelectedOrder.PatientName}}</span></div><div><span class="report_span_title">Modality :</span> <span class="report_span">{{SelectedOrder.Modality}}</span></div></div><div class="col-md-3"><div><span class="report_span_title">DOB :</span> <span class="report_span">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span></div><div><span class="report_span_title">Procedure :</span> <span class="report_span">{{SelectedOrder.ProcedureDesc}}</span></div><div><button type="button" ng-show="ODType==\'Helper\'" class="btn cmn-btn btn-primary h-30px px-10px fs-13px pull-right" ng-click="CloseOrderDiscussion()">Close Discussion</button></div></div><div class="row"></div><hr><div class="col-lg-3 col-md-3 col-sm-6 mb-8px" ng-hide="Ishelper"><ui-select ng-model="OrderDiscussion.SelectedUser" theme="bootstrap" class="fs-14px dicom-inp-w form-border" style="width: 40%;" ng-disabled="OrderDiscussion.ID"><ui-select-match allow-clear="true" placeholder="Select Radiologist">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices repeat="list in Radiologists | filter: isVisibleRad | filter: {FirstName: $select.search, LastName: $select.search} | orderBy:\'LastName\'"><div class="inst-selectBox" ng-bind-html="radDisplay(list) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-12 form-group mb-10px" ng-hide="Ishelper"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment."> </textarea></div><div class="pull-right" ng-hide="Ishelper"><button type="button" class="btn cmn-btn btn-primary h-30px px-10px fs-13px" ng-click="SaveOrderDiscussion()">Save</button></div><div class="pull-right" ng-show="Ishelper"><button type="button" class="btn cmn-btn btn-primary h-30px px-10px fs-13px" ng-click="CloseOrderDiscussion()">Close Discussion</button></div><div class="h-10px"></div><div class="max-h-43vh overflow-x-auto p-10px-all bg-clr-12"><div class=""><div class="w-100" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0 report-popup px-5px" kendo-window="win_ViewReport" k-on-open="isViewReportVisible = true" k-on-close="isViewReportVisible = false" k-title="\'Report\'" k-modal="true" k-visible="false" k-width="winViewReportTechWidth" k-height="defaultWindowHeight" k-resize="winViewReportTechResize" k-dragend="winViewReportTechDragand" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isViewReportVisible"><div class="denial-window"><div class=""><div><report-viewer ng-if="selecteReportId" source-id="selecteReportId"></report-viewer></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0" kendo-window="win_ViewTechnique" k-on-open="isViewTechniqueVisible = true" k-on-close="isViewTechniqueVisible = false" k-title="\'Technique\'" k-visible="false" k-width="win_ViewTechniqueWidth" k-height="win_ViewTechniqueHeight" k-modal="true" k-animation="false" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isViewTechniqueVisible"><div class="denial-window"><div class="fw-500"><div class="col-sm-12 col-md-12"><div class="mx-10px float-right"><button ng-click="AddTechnique()" class="btn btn-primary btn-sm adnewbtn">Add New</button></div></div><div class="col-sm-12 col-md-12 mob-p-0"><div class="charges-list bg-clr-27"><table ng-table="tableParams" class="table pos-rel wh-table table-scroll technique-table"><tbody class="h-400px"><tr class="side-message-navigation-item little-human shineHover data-row" ng-repeat="row in $data track by $index"><td class="w-20 text-left" data-title="\'Technique Key\'" filter="{ Key: \'text\'}" sortable="\'Key\'">{{row.Key}}</td><td class="w-70 text-left" data-title="\'Technique Value\'" filter="{ Value: \'text\'}" sortable="\'Value\'">{{row.Value}}</td><td class="w-10 text-right"><button ng-click="SelectTechniqueValue(row.Value)" class="btn btn-primary btn-sm selbtn">Select</button></td></tr></tbody></table></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0" kendo-window="win_AddTechnique" k-on-open="isAddTechniqueVisible = true" k-on-close="isAddTechniqueVisible = false" k-title="\'Add Technique\'" k-visible="false" k-width="500" k-height="350" k-animation="false" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isAddTechniqueVisible"><div class="denial-window"><div><form id="frmFilter" ng-submit="SubmitTechnique(frmFilter.$valid,TechniqueKey,TechniqueValue)"><div class="fw-500 row py-15px"><div class="col-sm-12 col-md-12 mb-15px"><label class="rf-label">Key Code</label> <input type="text" class="blk-input form-control" placeholder="Key code" id="TechniqueKey" name="TechniqueKey" ng-model="TechniqueKey" autocomplete="off" ng-required="true" first-char-no-space=""></div><div class="col-sm-12 col-md-12"><label class="rf-label">Value</label><textarea class="txt-area h-150px w-100 p-5px-all" ng-model="TechniqueValue" id="TechniqueValue" name="TechniqueValue" placeholder="Key value" ng-required="true"> </textarea></div><div class="col-sm-12 col-md-12"><div class="py-10px"><label class="rf-label"></label><button ng-click="CancelTechnique()" class="btn btn-default">Cancel</button> <button class="btn btn-primary">Save</button></div></div></div></form></div></div></div></div><script id="dropdowntree-orderdiscussion-template" type="text/kendo-ui-template"># if (item.Group && item.Group == "YES") { # #: item.UserName # # } else { # <i class="fa fa-circle #: item.IsOnline ? \'text-success\' : \'text-gray-dark\' #"></i> #: item.UserName # # } #</script><div class="overflow-hide-all ERA-check-detail" kendo-window="win_TechForm" k-on-open="isTechFormVisible = true" k-on-close="isTechFormVisible = false" k-title="\'Tech Form\'" k-visible="false" k-width="win_HelpOrderWidth" k-animation="false" k-height="650" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isTechFormVisible"><div class="denial-window"><iframe id="tempid" style="width:100%;height:500px;position:absolute;top:-1000px;"></iframe><div id="CONCLUSION"></div><div id="divTechForm"></div><div class="py-10px"><div class="float-right px-15px mob-pl0 discu-choose-files"><div class="float-left"><button type="button" class="btn btn-primary" ng-click="SetOrdersTechForm()">Save</button> <button type="button" class="btn btn-default" ng-click="CloseTechForm()">Cancel</button> <button type="button" class="btn btn-default" ng-click="ReloadTechForm()">Reload</button></div><div class="clearfix"></div></div><div class="clearfix"></div></div></div></div></div><div class="modal fade" id="ModalTechnoWorkList" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog create-filter"><div class="modal-content py-20px px-0" style="border-radius:4px;background-color:#2c2c2c;"><div class=""><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary mr-10px d-none" ng-click="createTechnoWorkList()">Create Filter</button> <button type="button" class="btn btn-primary mr-10px" ng-click="saveFilterOnly()">Save Filter Only</button> <button type="button" class="btn btn-default mr-10px" data-dismiss="modal">Cancel</button></div></div></div></div></div></div><script>\r\n    function setDirty() {\r\n\r\n    }\r\n</script><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs" kendo-window="win_consultExamsWindow" k-on-open="isConsultExamsWindow = true;" k-on-close="isConsultExamsWindow = false;" k-title="\'Consult Exams\'" k-modal="true" k-visible="false" k-animation="false" k-width="winConsultExamWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isConsultExamsWindow"><div class="row px-10px mr-0"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><videocallconsult class="clearfix video-call-consult" on-send="setUserChat" selected-order="SelectedOrder" check="isConsultExamsWindow" on-close="onCloseConsultExamWindowHandler(check)"></videocallconsult></div></div></div></div><script type="text/ng-template" id="tree_item_renderer.html"><div> <div> <div class="fs-13px text-break-word bg-clr-29 bor-rad-5px p-15px-all"> <p style="white-space:pre-line">{{Dis.Comment | htmlDecode}}</p> </div> <div class="float-right py-5px"> <div class="tultip-top float-left"> <a class="btn btn-default glyphicon glyphicon-share-alt border-0" ng-click="Dis.IsChild=!Dis.IsChild"></a> <span class="tultiptext">Reply</span> </div> <div class="float-left pt-3px"> <span class="txt-clr-1 fs-15px" ng-if="disName(Dis)">{{disName(Dis) | htmlDecode}}</span> <span class="txt-clr-2 fs-12px">{{Dis.Record_Created_At|date :\'medium\' }}</span> </div> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div ng-show="Dis.IsChild"> <div class="mb-10px w-70 pull-right"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Dis.ChildComment" placeholder="Add a comment."> </textarea> </div> <div class="clearfix"></div> <div class="mb-10px"> <button type="button" class="btn btn-primary pull-right" ng-click="SaveChildDiscussion(Dis)">Save</button> <div class="clearfix"></div> </div> </div> </div> <div class="clearfix"></div> </div> <ul style="list-style:none"> <li class="mb-10px" ng-repeat="Dis in Dis.Childs" ng-include="\'tree_item_renderer.html\'"></li> </ul></script>');
$templateCache.put('app/pages/user-analytics/user-analytics.html','<style>\r\n    .chart-grid-box {\r\n        overflow-y: auto;\r\n        height: calc(100vh - 120px);\r\n    }\r\n    .uiview-element .chart-grid-box.chartgrid-height-loc {\r\n        height: calc(100vh - 190px);\r\n    }\r\n    .stat-card {\r\n        background-color: #323232;\r\n        overflow: hidden;\r\n        border-radius: 5px;\r\n    }\r\n\r\n    .chart-grid-box::-webkit-scrollbar-track {\r\n        border-radius: 10px;\r\n        background-color: transparent;\r\n    }\r\n\r\n    .chart-grid-box::-webkit-scrollbar {\r\n        width: 5px;\r\n        background-color: transparent;\r\n    }\r\n\r\n    .chart-grid-box::-webkit-scrollbar-thumb {\r\n        border-radius: 1px;\r\n        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\r\n        background-color: #d9d9d9;\r\n    }\r\n\r\n    .stat-card .nav.nav-tabs > li.active > a {\r\n        color: white !important;\r\n        background-color: #424242 !important;\r\n        border-bottom: 2px solid #01bfa3;\r\n    }\r\n    /*  .nav.nav-tabs {\r\n        border-bottom: 1px solid #4d4d4d !important;\r\n    }*/\r\n    .blk-input.form-control {\r\n        border-color: #424242 !important\r\n    }\r\n\r\n    .icon-leftmenu {\r\n        height: calc(100vh - 30px);\r\n        border-bottom: 0;\r\n    }\r\n\r\n    .loc-drop .k-widget.k-dropdowntree {\r\n        border-color: #424242 !important;\r\n    }\r\n\r\n    .ag-charts-toolbar.ag-charts-toolbar--floating-bottom {\r\n        top: 1px !important;\r\n    }\r\n\r\n    .ag-chart-overlay.ag-chart-dark-overlay {\r\n        color: white !important;\r\n    }\r\n\r\n    #AnalyticsPageFilter tags-input .tags {\r\n        border: 1px solid #424242;\r\n    }\r\n\r\n    .dos-toggle {\r\n        width: 100%;\r\n        height: 30px;\r\n        border: 1px solid #05c1a4;\r\n        border-radius: 4px;\r\n        display: flex !important;\r\n        align-items: center;\r\n        justify-content: center;\r\n        position: relative;\r\n        overflow: hidden;\r\n    }\r\n\r\n        .dos-toggle input[type="radio"] {\r\n            display: none;\r\n        }\r\n\r\n        .dos-toggle .left-toggle,\r\n        .dos-toggle .right-toggle {\r\n            width: 50%;\r\n            display: flex !important;\r\n            align-items: center;\r\n            justify-content: center;\r\n            cursor: pointer;\r\n            transition: background-color 0.3s, color 0.3s;\r\n            height: 100%;\r\n            font-weight: 500;\r\n        }\r\n\r\n        .dos-toggle .separator {\r\n            width: 1px;\r\n            height: 100%;\r\n            background-color: #05c1a4;\r\n            position: absolute;\r\n            left: 50%;\r\n            transform: translateX(-50%);\r\n        }\r\n\r\n        /* Default state */\r\n        .dos-toggle .left-toggle,\r\n        .dos-toggle .right-toggle {\r\n            background-color: #323232;\r\n            color: #05c1a4;\r\n        }\r\n\r\n        /* Left toggle selected */\r\n        .dos-toggle input[type="radio"]#toggle-left:checked + label.left-toggle {\r\n            background-color: #05c1a4;\r\n            color: #fdfdfd;\r\n        }\r\n\r\n        /* Right toggle selected */\r\n        .dos-toggle input[type="radio"]#toggle-right:checked + label.right-toggle {\r\n            background-color: #05c1a4;\r\n            color: #fdfdfd;\r\n        }\r\n\r\n    .lbl-tag {\r\n        background-color: #05c1a4;\r\n        color: white;\r\n        display: flex !important;\r\n        align-items: center;\r\n        justify-content: center;\r\n        cursor: pointer;\r\n        height: 30px;\r\n        border: 1px solid #05c1a4;\r\n        border-radius: 4px;\r\n        font-weight: 500;\r\n    }\r\n\r\n    @media (max-width: 1199px) and (min-width: 768px) {\r\n        .tultip-bottom .tultiptext.sl-hsw-180px {\r\n            left: 44% !important;\r\n        }\r\n\r\n        .dos-toggle .left-toggle, .dos-toggle .right-toggle {\r\n            font-size: 11px;\r\n        }\r\n    }\r\n</style><div class="d-flex"><div class="wl-tab-left pt-10px icon-leftmenu"><span class="btn-default btn-primary p-0 writemode-lr add-bt-line" ng-class="{\'chart-active\':DataObject.isMenuVisible}" style="margin: 0 0 20px 0;" ng-click="pinUnpinSidePanel();"><i class="fa fa-bars" style="padding: 5px 0 8px 0;"></i></span></div><div class="left-menubar" ng-if="DataObject.isMenuVisible"><ul class="left-menulist"><li class="cursor-pointer" ng-click="ChangeActiveSection(\'LocationTAT\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'LocationTAT\'}">Location TAT</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'RadiologistTAT\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'RadiologistTAT\'}">Radiologist TAT</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'LocationVolume\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'LocationVolume\'}">Location Volume By Priority</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'ModalityByLocationVolume\')" ng-class="{\'selected-li\' :DataObject.ActiveSection==\'ModalityByLocationVolume\'}">Location Volume By Modality</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'PatientClassByLocationVolume\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'PatientClassByLocationVolume\'}">Location Volume By Patient Class</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'RadiologistVolume\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'RadiologistVolume\'}">Radiologist Volume By Priority</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'ModalityByRadiologistVolume\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'ModalityByRadiologistVolume\'}">Radiologist Volume By Modality</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'PatientClassByRadiologistVolume\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'PatientClassByRadiologistVolume\'}">Radiologist Volume By Patient Class</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'RadiologistVolByLoc\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'RadiologistVolByLoc\'}">Radiologist Volume By Location</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'HiddenVolumeByLocation\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'HiddenVolumeByLocation\'}">Hidden Volume By Location</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'TATStudyCountByHourLocation\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'TATStudyCountByHourLocation\'}">TAT, Sum Of RVU & Study Count By Hour And Location</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'PeerReviewLocation\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'PeerReviewLocation\'}">Peer Review Volume</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'PeerReviewPendingSince\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'PeerReviewPendingSince\'}">Pending Peer Review</li><li class="cursor-pointer" ng-click="ChangeActiveSection(\'AddendumListVolume\')" ng-class="{\'selected-li\':DataObject.ActiveSection==\'AddendumListVolume\'}" ng-if="DataObject.IsAddendumRequestVisible">Addendum Requests</li></ul></div><div class="right-dashboard" ng-style="{\'width\' : (DataObject.isMenuVisible) ? \'calc(100% - 280px)\' : \'calc(100% - 30px)\'}"><div class="radf-header row mx-0"><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'LocationTAT\'">Location TAT</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'RadiologistTAT\'">Radiologist TAT</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'LocationVolume\'">Location Volume By Priority</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'ModalityByLocationVolume\'">Location Volume By Modality</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'PatientClassByLocationVolume\'">Location Volume By Patient Class</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'RadiologistVolume\'">Radiologist Volume By Priority</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'ModalityByRadiologistVolume\'">Radiologist Volume By Modality</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'PatientClassByRadiologistVolume\'">Radiologist Volume By Patient Class</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'RadiologistVolByLoc\'">Radiologist Volume By Location</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'HiddenVolumeByLocation\'">Hidden Volume By Location</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'TATStudyCountByHourLocation\'">TAT, Sum Of RVU & Study Count By Hour And Location</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'PeerReviewLocation\'">Peer Review Volume</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'PeerReviewPendingSince\'">Pending Peer Review</h2><h2 class="float-left w-50 heading-tw" ng-if="DataObject.ActiveSection==\'AddendumListVolume\'">Addendum Requests</h2></div><div class="row m-0 pr-2 pt-3"><form><div class="col-lg-2 col-md-3 pl-6px pr-5px col-sm-4 col-xs-4"><div class="dos-toggle" ng-if="!(DataObject.ActiveSection==\'HiddenVolumeByLocation\' ||DataObject.ActiveSection==\'PeerReviewLocation\' ||DataObject.ActiveSection==\'PeerReviewPendingSince\' ||DataObject.ActiveSection==\'AddendumListVolume\')"><input type="radio" ng-model="DataObject.isDOSorSignedDate" id="toggle-left" name="toggle" value="DOS" checked="" ng-change="onSignedDataDOSSelectionChange()"> <label for="toggle-left" class="left-toggle m-0">DOS</label> <input type="radio" ng-model="DataObject.isDOSorSignedDate" id="toggle-right" name="toggle" value="SignedDate" ng-change="onSignedDataDOSSelectionChange()"> <label for="toggle-right" class="right-toggle m-0">Signed Date</label><div class="separator"></div></div><div><p class="txt-clr-1 mb-2px fs-13px lbl-tag" ng-if="DataObject.ActiveSection==\'HiddenVolumeByLocation\'">DOS</p><div class="dos-toggle" ng-if="DataObject.ActiveSection==\'PeerReviewLocation\'"><input type="radio" ng-model="DataObject.isCreatedOrCompletedDate" id="toggle-left" name="toggle" value="CreatedDate" checked="" ng-change="onCreatedOrCompletedDateSelectionChange()"> <label for="toggle-left" class="left-toggle m-0">Created Date</label> <input type="radio" ng-model="DataObject.isCreatedOrCompletedDate" id="toggle-right" name="toggle" value="CompletedDate" ng-change="onCreatedOrCompletedDateSelectionChange()"> <label for="toggle-right" class="right-toggle m-0">Completed Date</label><div class="separator"></div></div><p class="txt-clr-1 mb-2px fs-13px lbl-tag" ng-if="DataObject.ActiveSection==\'PeerReviewPendingSince\'">Created Date</p><p class="txt-clr-1 mb-2px fs-13px lbl-tag" ng-if="DataObject.ActiveSection==\'AddendumListVolume\'">Requested Date</p></div></div><div class="col-lg-3 col-md-3 pl-6px col-sm-4 col-xs-4"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="Select Date" ng-model="DataObject.datePicker" options="DOSopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{DataObject.DateFilterTooltip}}" tooltip-placement="auto top"></div><div class="col-lg-3 col-md-3 col-sm-4 col-xs-4 pl-0 tultip-bottom loc-drop"><site-location-grid master-locations="DataObject.Locations" selected-location="DataObject.SelectedLocations"></site-location-grid></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 pl-4px"><button class="btn btn-primary rf-btn-xs mr-5px mb-5px" ng-click="refreshCharts()">Filter</button> <button class="btn btn-default rf-btn-xs mr-5px mb-5px" ng-click="clearFilter()">Clear</button></div><div class="col-lg-2 col-md-2 col-sm-6 col-xs-6 pl-0 d-flex align-item-center justify-content-end"><span class="p-1 txt-clr-1">Navigator</span> <label class="checkbox-switch ml-4px mb-0" title="Show/Hide Navigator"><input id="clipboardnextstudyswitch" type="checkbox" class="mr-2px" ng-click="hideShowChartNavigator()" ng-model="DataObject.NavigatorToggle"> <span class="checkbox-switch-slider round"></span></label></div></form></div><div class="row mx-0 chart-grid-box" ng-class="{\'chartgrid-height-loc\': DataObject.SelectedLocations.locations.length > 0}"><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'LocationTAT\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Average TAT By Locations</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByLocationTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.TATByLocationTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByLocationTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.TATByLocationTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByLoc\',\'UserAnalyticsChartOptionsByLoc\',\'area\')" title="Area chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByLoc\',\'UserAnalyticsChartOptionsByLoc\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByLoc\',\'UserAnalyticsChartOptionsByLoc\',\'line\')" title="Line chart"></i></ul><div id="UserAnalyticsGridByLoc" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.TATByLocationTab==\'Grid\'"></div><div id="UserAnalyticsChartByLoc" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.TATByLocationTab==\'Chart\'"></div></div></div></div><div class="col-md-12 mt-10px px-6px col-sm-12" ng-if="DataObject.ActiveSection==\'RadiologistTAT\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Average TAT By Radiologist</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByRadiologistTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.TATByRadiologistTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByRadiologistTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.TATByRadiologistTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByRadiologist\',\'UserAnalyticsChartOptionsByRadiologist\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByRadiologist\',\'UserAnalyticsChartOptionsByRadiologist\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByRadiologist\',\'UserAnalyticsChartOptionsByRadiologist\',\'line\')" title="Line chart"></i></ul><div id="UserAnalyticsGridByRadiologist" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.TATByRadiologistTab==\'Grid\'"></div><div id="UserAnalyticsChartByRadiologist" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.TATByRadiologistTab==\'Chart\'"></div></div></div></div><div class="col-md-6 mt-10px px-6px col-sm-12 d-none" ng-show="DataObject.ActiveSection==\'LocationTAT\' || DataObject.ActiveSection==\'RadiologistTAT\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Average TAT By Modality <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span> <span ng-if="DataObject.SelectedRadiologist != null">({{DataObject.SelectedRadiologist}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByModalityTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.TATByModalityTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByModalityTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.TATByModalityTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByModality\',\'UserAnalyticsChartOptionsByModality\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByModality\',\'UserAnalyticsChartOptionsByModality\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByModality\',\'UserAnalyticsChartOptionsByModality\',\'line\')" title="Line chart"></i></ul><div id="UserAnalyticsGridByModality" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.TATByModalityTab==\'Grid\'"></div><div id="UserAnalyticsChartByModality" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.TATByModalityTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12 d-none" ng-show="DataObject.ActiveSection==\'LocationTAT\' || DataObject.ActiveSection==\'RadiologistTAT\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Average TAT By Patient Class <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span> <span ng-if="DataObject.SelectedRadiologist != null">({{DataObject.SelectedRadiologist}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByPatientClassTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.TATByPatientClassTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByPatientClassTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.TATByPatientClassTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByPatientClass\',\'UserAnalyticsChartOptionsByPatientClass\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByPatientClass\',\'UserAnalyticsChartOptionsByPatientClass\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByPatientClass\',\'UserAnalyticsChartOptionsByPatientClass\',\'line\')" title="Line chart"></i></ul><div id="UserAnalyticsGridByPatientClass" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.TATByPatientClassTab==\'Grid\'"></div><div id="UserAnalyticsChartByPatientClass" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.TATByPatientClassTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-show="DataObject.ActiveSection==\'LocationTAT\' || DataObject.ActiveSection==\'RadiologistTAT\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Average TAT By Patient Class & Modality <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span> <span ng-if="DataObject.SelectedRadiologist != null">({{DataObject.SelectedRadiologist}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByPatientClassModalityTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.TATByPatientClassModalityTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATByPatientClassModalityTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.TATByPatientClassModalityTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByPatientClassModality\',\'UserAnalyticsChartOptionsByPatientClassModality\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByPatientClassModality\',\'UserAnalyticsChartOptionsByPatientClassModality\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'UserAnalyticsChartByPatientClassModality\',\'UserAnalyticsChartOptionsByPatientClassModality\',\'line\')" title="Line chart"></i></ul><div id="UserAnalyticsGridByPatientClassModality" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.TATByPatientClassModalityTab==\'Grid\'"></div><div id="UserAnalyticsChartByPatientClassModality" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.TATByPatientClassModalityTab==\'Chart\'"></div></div></div></div><div class="col-md-12 mt-10px px-6px col-sm-12" ng-if="DataObject.ActiveSection==\'LocationVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Location Volume By Priority</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'VolumeByLocTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.VolumeByLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'VolumeByLocTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.VolumeByLocTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'VolumeByLocChart\',\'VolumeByLocChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'VolumeByLocChart\',\'VolumeByLocChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'VolumeByLocChart\',\'VolumeByLocChartOption\',\'line\')" title="Line chart"></i></ul><div id="VolumeByLocGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.VolumeByLocTab==\'Grid\'"></div><div id="VolumeByLocChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.VolumeByLocTab==\'Chart\'"></div></div></div></div><div class="col-md-12 mt-10px px-6px col-sm-12" ng-if="DataObject.ActiveSection==\'ModalityByLocationVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Location Volume By Modality</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'ModalityByLocTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.ModalityByLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'ModalityByLocTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.ModalityByLocTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'ModalityByLocChart\',\'ModalityByLocChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'ModalityByLocChart\',\'ModalityByLocChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'ModalityByLocChart\',\'ModalityByLocChartOption\',\'line\')" title="Line chart"></i></ul><div id="ModalityByLocGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.ModalityByLocTab==\'Grid\'"></div><div id="ModalityByLocChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.ModalityByLocTab==\'Chart\'"></div></div></div></div><div class="col-md-6 mt-10px px-6px col-sm-12" ng-if="DataObject.ActiveSection==\'ModalityByLocationVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Modality Volume By Month <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'LocModalityVolByMonthTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.LocModalityVolByMonthTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'LocModalityVolByMonthTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.LocModalityVolByMonthTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'LocModalityVolByMonthChart\',\'LocModalityVolByMonthChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'LocModalityVolByMonthChart\',\'LocModalityVolByMonthChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'LocModalityVolByMonthChart\',\'LocModalityVolByMonthChartOption\',\'line\')" title="Line chart"></i></ul><div id="LocModalityVolByMonthGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.LocModalityVolByMonthTab==\'Grid\'"></div><div id="LocModalityVolByMonthChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.LocModalityVolByMonthTab==\'Chart\'"></div></div></div></div><div class="col-md-6 mt-10px px-6px col-sm-12" ng-if="DataObject.ActiveSection==\'ModalityByLocationVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Location Volume By Patient Class <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'SubChartLocVolByPCTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.SubChartLocVolByPCTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'SubChartLocVolByPCTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.SubChartLocVolByPCTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartLocVolByPCChart\',\'SubChartLocVolByPCChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartLocVolByPCChart\',\'SubChartLocVolByPCChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartLocVolByPCChart\',\'SubChartLocVolByPCChartOption\',\'line\')" title="Line chart"></i></ul><div id="SubChartLocVolByPCGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.SubChartLocVolByPCTab==\'Grid\'"></div><div id="SubChartLocVolByPCChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.SubChartLocVolByPCTab==\'Chart\'"></div></div></div></div><div class="col-md-12 mt-10px px-6px col-sm-12" ng-if="DataObject.ActiveSection==\'PatientClassByLocationVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Location Volume By Patient Class</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PatientClassByLocTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.PatientClassByLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PatientClassByLocTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.PatientClassByLocTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PatientClassByLocChart\',\'PatientClassByLocChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PatientClassByLocChart\',\'PatientClassByLocChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PatientClassByLocChart\',\'PatientClassByLocChartOption\',\'line\')" title="Line chart"></i></ul><div id="PatientClassByLocGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.PatientClassByLocTab==\'Grid\'"></div><div id="PatientClassByLocChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.PatientClassByLocTab==\'Chart\'"></div></div></div></div><div class="col-md-6 mt-10px px-6px col-sm-12" ng-if="DataObject.ActiveSection==\'PatientClassByLocationVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Patient Class Volume By Month <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'LocPatientClassVolByMonthTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.LocPatientClassVolByMonthTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'LocPatientClassVolByMonthTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.LocPatientClassVolByMonthTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'LocPatientClassVolByMonthChart\',\'LocPatientClassVolByMonthChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'LocPatientClassVolByMonthChart\',\'LocPatientClassVolByMonthChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'LocPatientClassVolByMonthChart\',\'LocPatientClassVolByMonthChartOption\',\'line\')" title="Line chart"></i></ul><div id="LocPatientClassVolByMonthGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.LocPatientClassVolByMonthTab==\'Grid\'"></div><div id="LocPatientClassVolByMonthChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.LocPatientClassVolByMonthTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'PatientClassByLocationVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Location Volume By Priority <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'SubChartLocVolByModalityTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.SubChartLocVolByModalityTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'SubChartLocVolByModalityTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.SubChartLocVolByModalityTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartLocVolByModalityChart\',\'SubChartLocVolByModalityChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartLocVolByModalityChart\',\'SubChartLocVolByModalityChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartLocVolByModalityChart\',\'SubChartLocVolByModalityChartOption\',\'line\')" title="Line chart"></i></ul><div id="SubChartLocVolByModalityGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.SubChartLocVolByModalityTab==\'Grid\'"></div><div id="SubChartLocVolByModalityChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.SubChartLocVolByModalityTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'RadiologistVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Radiologist Volume By Priority</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'VolumesByRadTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.VolumesByRadTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'VolumesByRadTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.VolumesByRadTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'VolumeByRadiologistChart\',\'VolumeByRadiologistChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'VolumeByRadiologistChart\',\'VolumeByRadiologistChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'VolumeByRadiologistChart\',\'VolumeByRadiologistChartOption\',\'line\')" title="Line chart"></i></ul><div id="VolumeByRadGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.VolumesByRadTab==\'Grid\'"></div><div id="VolumeByRadChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.VolumesByRadTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'ModalityByRadiologistVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Radiologist Volume By Modality</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'ModalityByRadTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.ModalityByRadTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'ModalityByRadTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.ModalityByRadTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'ModalityByRadiologistChart\',\'ModalityByRadiologistChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'ModalityByRadiologistChart\',\'ModalityByRadiologistChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'ModalityByRadiologistChart\',\'ModalityByRadiologistChartOption\',\'line\')" title="Line chart"></i></ul><div id="ModalityByRadGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.ModalityByRadTab==\'Grid\'"></div><div id="ModalityByRadChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.ModalityByRadTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'ModalityByRadiologistVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Modality Volume By Month <span ng-if="DataObject.SelectedRadiologist != null">({{DataObject.SelectedRadiologist}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadModalityVolByMonthTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.RadModalityVolByMonthTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadModalityVolByMonthTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.RadModalityVolByMonthTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadModalityVolByMonthChart\',\'RadModalityVolByMonthChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadModalityVolByMonthChart\',\'RadModalityVolByMonthChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadModalityVolByMonthChart\',\'RadModalityVolByMonthChartOption\',\'line\')" title="Line chart"></i></ul><div id="RadModalityVolByMonthGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.RadModalityVolByMonthTab==\'Grid\'"></div><div id="RadModalityVolByMonthChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.RadModalityVolByMonthTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'ModalityByRadiologistVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Radiologist Volume By Patient Class <span ng-if="DataObject.SelectedRadiologist != null">({{DataObject.SelectedRadiologist}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'SubChartRadVolByPCTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.SubChartRadVolByPCTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'SubChartRadVolByPCTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.SubChartRadVolByPCTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartRadVolByPCChart\',\'SubChartRadVolByPCChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartRadVolByPCChart\',\'SubChartRadVolByPCChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartRadVolByPCChart\',\'SubChartRadVolByPCChartOption\',\'line\')" title="Line chart"></i></ul><div id="SubChartRadVolByPCGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.SubChartRadVolByPCTab==\'Grid\'"></div><div id="SubChartRadVolByPCChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.SubChartRadVolByPCTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'PatientClassByRadiologistVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Radiologist Volume By Patient Class</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PatientClassByRadTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.PatientClassByRadTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PatientClassByRadTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.PatientClassByRadTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PatientClassByRadiologistChart\',\'PatientClassByRadiologistChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PatientClassByRadiologistChart\',\'PatientClassByRadiologistChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PatientClassByRadiologistChart\',\'PatientClassByRadiologistChartOption\',\'line\')" title="Line chart"></i></ul><div id="PatientClassByRadGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.PatientClassByRadTab==\'Grid\'"></div><div id="PatientClassByRadChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.PatientClassByRadTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'PatientClassByRadiologistVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Patient Class Volume By Month <span ng-if="DataObject.SelectedRadiologist != null">({{DataObject.SelectedRadiologist}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadPatientClassVolByMonthTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.RadPatientClassVolByMonthTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadPatientClassVolByMonthTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.RadPatientClassVolByMonthTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadPatientClassVolByMonthChart\',\'RadPatientClassVolByMonthChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadPatientClassVolByMonthChart\',\'RadPatientClassVolByMonthChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadPatientClassVolByMonthChart\',\'RadPatientClassVolByMonthChartOption\',\'line\')" title="Line chart"></i></ul><div id="RadPatientClassVolByMonthGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.RadPatientClassVolByMonthTab==\'Grid\'"></div><div id="RadPatientClassVolByMonthChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.RadPatientClassVolByMonthTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'PatientClassByRadiologistVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Radiologist Volume By Priority <span ng-if="DataObject.SelectedRadiologist != null">({{DataObject.SelectedRadiologist}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'SubChartRadVolByModalityTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.SubChartRadVolByModalityTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'SubChartRadVolByModalityTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.SubChartRadVolByModalityTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartRadVolByModalityChart\',\'SubChartRadVolByModalityChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartRadVolByModalityChart\',\'SubChartRadVolByModalityChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'SubChartRadVolByModalityChart\',\'SubChartRadVolByModalityChartOption\',\'line\')" title="Line chart"></i></ul><div id="SubChartRadVolByModalityGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.SubChartRadVolByModalityTab==\'Grid\'"></div><div id="SubChartRadVolByModalityChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.SubChartRadVolByModalityTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'RadiologistVolByLoc\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Radiologist Volume By Location</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadiologistVolByLocTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.RadiologistVolByLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadiologistVolByLocTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.RadiologistVolByLocTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadiologistVolByLocChart\',\'RadiologistVolByLocChartOptions\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadiologistVolByLocChart\',\'RadiologistVolByLocChartOptions\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadiologistVolByLocChart\',\'RadiologistVolByLocChartOptions\',\'line\')" title="Line chart"></i></ul><div id="RadiologistVolByLocGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.RadiologistVolByLocTab==\'Grid\'"></div><div id="RadiologistVolByLocChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.RadiologistVolByLocTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'RadiologistVolByLoc\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Radiologist Volume By Months Based On Location <span ng-if="DataObject.SelectedRadiologist != null">({{DataObject.SelectedRadiologist}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadiologistVolByLocMonthsTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.RadiologistVolByLocMonthsTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadiologistVolByLocMonthsTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.RadiologistVolByLocMonthsTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadiologistVolByLocMonthsChart\',\'RadiologistVolByLocMonthChartOptions\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadiologistVolByLocMonthsChart\',\'RadiologistVolByLocMonthChartOptions\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadiologistVolByLocMonthsChart\',\'RadiologistVolByLocMonthChartOptions\',\'line\')" title="Line chart"></i></ul><div id="RadiologistVolByLocMonthsGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.RadiologistVolByLocMonthsTab==\'Grid\'"></div><div id="RadiologistVolByLocMonthsChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.RadiologistVolByLocMonthsTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'RadiologistVolByLoc\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Radiologist Volume By Modality Based On Location <span ng-if="DataObject.SelectedRadiologist != null">({{DataObject.SelectedRadiologist}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadiologistVolByLocModalityTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.RadiologistVolByLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadiologistVolByLocModalityTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.RadiologistVolByLocModalityTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadiologistVolByLocModalityChart\',\'RadiologistVolByLocModalityChartOptions\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadiologistVolByLocModalityChart\',\'RadiologistVolByLocModalityChartOptions\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadiologistVolByLocModalityChart\',\'RadiologistVolByLocModalityChartOptions\',\'line\')" title="Line chart"></i></ul><div id="RadiologistVolByLocModalityGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.RadiologistVolByLocModalityTab==\'Grid\'"></div><div id="RadiologistVolByLocModalityChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.RadiologistVolByLocModalityTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'LocationVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span ng-if="DataObject.SelectedLocation != null">{{DataObject.SelectedLocation}} Volume By Month</span> <span ng-if="DataObject.SelectedLocation == null">Location Volume By Month</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'MonthsGroupByLocVolTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.MonthsGroupByLocVolTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'MonthsGroupByLocVolTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.MonthsGroupByLocVolTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'MonthsGroupByLocVolChart\',\'MonthsGroupByLocVolChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'MonthsGroupByLocVolChart\',\'MonthsGroupByLocVolChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'MonthsGroupByLocVolChart\',\'MonthsGroupByLocVolChartOption\',\'line\')" title="Line chart"></i></ul><div id="MonthsGroupByLocVolGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.MonthsGroupByLocVolTab==\'Grid\'"></div><div id="MonthsGroupByLocVolChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.MonthsGroupByLocVolTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'LocationVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span ng-if="DataObject.SelectedLocation != null">{{DataObject.SelectedLocation}} Volume By Modality</span> <span ng-if="DataObject.SelectedLocation == null">Location Volume By Modality</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'ModalityGroupByMonthTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.ModalityGroupByMonthTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'ModalityGroupByMonthTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.ModalityGroupByMonthTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'ModalityGroupByMonthChart\',\'ModalityGroupByMonthChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'ModalityGroupByMonthChart\',\'ModalityGroupByMonthChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'ModalityGroupByMonthChart\',\'ModalityGroupByMonthChartOption\',\'line\')" title="Line chart"></i></ul><div id="ModalityGroupByMonthGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.ModalityGroupByMonthTab==\'Grid\'"></div><div id="ModalityGroupByMonthChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.ModalityGroupByMonthTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'RadiologistVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span ng-if="DataObject.SelectedRadiologist != null">{{DataObject.SelectedRadiologist}} Volume By Month</span> <span ng-if="DataObject.SelectedRadiologist == null">Radiologist Volume By Month</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'MonthsGroupByRadVolTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.MonthsGroupByRadVolTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'MonthsGroupByRadVolTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.MonthsGroupByRadVolTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'MonthsGroupByRadVolChart\',\'MonthsGroupByRadVolChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'MonthsGroupByRadVolChart\',\'MonthsGroupByRadVolChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'MonthsGroupByRadVolChart\',\'MonthsGroupByRadVolChartOption\',\'line\')" title="Line chart"></i></ul><div id="MonthsGroupByRadVolGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.MonthsGroupByRadVolTab==\'Grid\'"></div><div id="MonthsGroupByRadVolChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.MonthsGroupByRadVolTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'RadiologistVolume\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span ng-if="DataObject.SelectedRadiologist != null">{{DataObject.SelectedRadiologist}} Volume By Modality</span> <span ng-if="DataObject.SelectedRadiologist == null">Radiologist Volume By Modality</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadVolumeByModalityGroup\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.RadVolumeByModalityGroup==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'RadVolumeByModalityGroup\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.RadVolumeByModalityGroup==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadVolumeByModalityGroupChart\',\'RadVolumeByModalityGroupChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadVolumeByModalityGroupChart\',\'RadVolumeByModalityGroupChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'RadVolumeByModalityGroupChart\',\'RadVolumeByModalityGroupChartOption\',\'line\')" title="Line chart"></i></ul><div id="RadVolumeByModalityGroupGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.RadVolumeByModalityGroup==\'Grid\'"></div><div id="RadVolumeByModalityGroupChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.RadVolumeByModalityGroup==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'HiddenVolumeByLocation\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>Hidden Volume By Location</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'HiddenVolByLocTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.HiddenVolByLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'HiddenVolByLocTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.HiddenVolByLocTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'HiddenVolByLocChart\',\'HiddenVolByLocChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'HiddenVolByLocChart\',\'HiddenVolByLocChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'HiddenVolByLocChart\',\'HiddenVolByLocChartOption\',\'line\')" title="Line chart"></i></ul><div id="HiddenVolByLocGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.HiddenVolByLocTab==\'Grid\'"></div><div id="HiddenVolByLocChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.HiddenVolByLocTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'HiddenVolumeByLocation\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>Hidden Volume By Time</span> <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'LocHiddenVolByMonthTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.LocHiddenVolByMonthTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'LocHiddenVolByMonthTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.LocHiddenVolByMonthTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'LocHiddenVolByMonthChart\',\'LocHiddenVolByMonthChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'LocHiddenVolByMonthChart\',\'LocHiddenVolByMonthChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'LocHiddenVolByMonthChart\',\'LocHiddenVolByMonthChartOption\',\'line\')" title="Line chart"></i></ul><div id="LocHiddenVolByMonthGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.LocHiddenVolByMonthTab==\'Grid\'"></div><div id="LocHiddenVolByMonthChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.LocHiddenVolByMonthTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'TATStudyCountByHourLocation\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>TAT Count By Location</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATCountDOSLocTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.TATCountDOSLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATCountDOSLocTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.TATCountDOSLocTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountDOSLocChart\',\'TATCountDOSLocChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountDOSLocChart\',\'TATCountDOSLocChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountDOSLocChart\',\'TATCountDOSLocChartOption\',\'line\')" title="Line chart"></i></ul><div id="TATCountDOSLocGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.TATCountDOSLocTab==\'Grid\'"></div><div id="TATCountDOSLocChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.TATCountDOSLocTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'TATStudyCountByHourLocation\'" ng-show="DataObject.SelectedLocation == null"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>TAT Count By {{DataObject.isDOSorSignedDate==\'DOS\'?\'DOS\':\'Signed Date\'}} & Locations</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATCountByDOSAndLocTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.TATCountByDOSAndLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATCountByDOSAndLocTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.TATCountByDOSAndLocTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountByDOSAndLocChart\',\'TATCountByDOSAndLocChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountByDOSAndLocChart\',\'TATCountByDOSAndLocChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountByDOSAndLocChart\',\'TATCountByDOSAndLocChartOption\',\'line\')" title="Line chart"></i></ul><div id="TATCountByDOSAndLocGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.TATCountByDOSAndLocTab==\'Grid\'"></div><div id="TATCountByDOSAndLocChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.TATCountByDOSAndLocTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'TATStudyCountByHourLocation\'" ng-show="DataObject.SelectedLocation != null"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>TAT Count By {{DataObject.isDOSorSignedDate==\'DOS\'?\'DOS\':\'Signed Date\'}}</span> <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATCountByDOSTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.TATCountByDOSTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATCountByDOSTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.TATCountByDOSTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountByDOSChart\',\'TATCountByDOSChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountByDOSChart\',\'TATCountByDOSChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountByDOSChart\',\'TATCountByDOSChartOption\',\'line\')" title="Line chart"></i></ul><div id="TATCountByDOSGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.TATCountByDOSTab==\'Grid\'"></div><div id="TATCountByDOSChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.TATCountByDOSTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'TATStudyCountByHourLocation\'" ng-show="DataObject.SelectedLocation != null"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>TAT Count By Hours</span> <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATCountByHourTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.TATCountByHourTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'TATCountByHourTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.TATCountByHourTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountByHourChart\',\'TATCountByHourChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountByHourChart\',\'TATCountByHourChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'TATCountByHourChart\',\'TATCountByHourChartOption\',\'line\')" title="Line chart"></i></ul><div id="TATCountByHourGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.TATCountByHourTab==\'Grid\'"></div><div id="TATCountByHourChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.TATCountByHourTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'PeerReviewLocation\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>Peer Review Volume By Location</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PeerReviewLocationTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.PeerReviewLocationTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PeerReviewLocationTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.PeerReviewLocationTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewLocationChart\',\'PeerReviewLocationChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewLocationChart\',\'PeerReviewLocationChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewLocationChart\',\'PeerReviewLocationChartOption\',\'line\')" title="Line chart"></i></ul><div id="PeerReviewLocationGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.PeerReviewLocationTab==\'Grid\'"></div><div id="PeerReviewLocationChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.PeerReviewLocationTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'PeerReviewLocation\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>Peer Review Volume By Radiologist</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PeerReviewRadiologistTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.PeerReviewRadiologistTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PeerReviewRadiologistTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.PeerReviewRadiologistTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewRadiologistChart\',\'PeerReviewRadiologistChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewRadiologistChart\',\'PeerReviewRadiologistChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewRadiologistChart\',\'PeerReviewRadiologistChartOption\',\'line\')" title="Line chart"></i></ul><div id="PeerReviewRadiologistGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.PeerReviewRadiologistTab==\'Grid\'"></div><div id="PeerReviewRadiologistChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.PeerReviewRadiologistTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'PeerReviewPendingSince\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>Pending Peer Review By Location</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PeerReviewPendingSinceByLocTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.PeerReviewPendingSinceByLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PeerReviewPendingSinceByLocTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.PeerReviewPendingSinceByLocTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewPendingSinceByLocChart\',\'PeerReviewPendingSinceByLocChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewPendingSinceByLocChart\',\'PeerReviewPendingSinceByLocChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewPendingSinceByLocChart\',\'PeerReviewPendingSinceByLocChartOption\',\'line\')" title="Line chart"></i></ul><div id="PeerReviewPendingSinceByLocGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.PeerReviewPendingSinceByLocTab==\'Grid\'"></div><div id="PeerReviewPendingSinceByLocChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.PeerReviewPendingSinceByLocTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'PeerReviewPendingSince\'"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>Pending Peer Review By Radiologist</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PeerReviewPendingSinceByRadTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.PeerReviewPendingSinceByRadTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'PeerReviewPendingSinceByRadTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.PeerReviewPendingSinceByRadTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewPendingSinceByRadChart\',\'PeerReviewPendingSinceByRadChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewPendingSinceByRadChart\',\'PeerReviewPendingSinceByRadChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PeerReviewPendingSinceByRadChart\',\'PeerReviewPendingSinceByRadChartOption\',\'line\')" title="Line chart"></i></ul><div id="PeerReviewPendingSinceByRadGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.PeerReviewPendingSinceByRadTab==\'Grid\'"></div><div id="PeerReviewPendingSinceByRadChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.PeerReviewPendingSinceByRadTab==\'Chart\'"></div></div></div></div><div class="col-md-12 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'AddendumListVolume\'" ng-show="DataObject.IsAddendumRequestVisible"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>Addendum Requests By Location</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'AddendumListByLocTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.AddendumListByLocTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'AddendumListByLocTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.AddendumListByLocTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'AddendumListByLocChart\',\'AddendumListByLocChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'AddendumListByLocChart\',\'AddendumListByLocChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'AddendumListByLocChart\',\'AddendumListByLocChartOption\',\'line\')" title="Line chart"></i></ul><div id="AddendumListByLocGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.AddendumListByLocTab==\'Grid\'"></div><div id="AddendumListByLocChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.AddendumListByLocTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'AddendumListVolume\'" ng-show="DataObject.IsAddendumRequestVisible"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>Addendum Requests By User</span> <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'AddendumListByRadTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.AddendumListByRadTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'AddendumListByRadTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.AddendumListByRadTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'AddendumListByRadChart\',\'AddendumListByRadChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'AddendumListByRadChart\',\'AddendumListByRadChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'AddendumListByRadChart\',\'AddendumListByRadChartOption\',\'line\')" title="Line chart"></i></ul><div id="AddendumListByRadGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.AddendumListByRadTab==\'Grid\'"></div><div id="AddendumListByRadChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.AddendumListByRadTab==\'Chart\'"></div></div></div></div><div class="col-md-6 px-6px mt-10px col-sm-12" ng-if="DataObject.ActiveSection==\'AddendumListVolume\'" ng-show="DataObject.IsAddendumRequestVisible"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;"><span>Addendum Requests To User</span> <span ng-if="DataObject.SelectedLocation != null">({{DataObject.SelectedLocation}})</span></p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'AddendumListToRadTab\',\'Chart\')" ng-class="{\'active\':DataObject.Tabs.AddendumListToRadTab==\'Chart\'}"><a href="#Chart" data-toggle="tab">Chart</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeChartDataTab(\'AddendumListToRadTab\',\'Grid\')" ng-class="{\'active\':DataObject.Tabs.AddendumListToRadTab==\'Grid\'}"><a href="#Grid" data-toggle="tab">Data</a></li><i class="fa fa-refresh fs-14px pt-2px txt-clr-14 float-right mr-5px cursor-pointer" aria-hidden="true" ng-click="refreshCharts()" title="Reset Selection"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'AddendumListToRadChart\',\'AddendumListToRadChartOption\',\'area\')" title="Area Chart"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'AddendumListToRadChart\',\'AddendumListToRadChartOption\',\'bar\')" title="Bar Chart"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'AddendumListToRadChart\',\'AddendumListToRadChartOption\',\'line\')" title="Line chart"></i></ul><div id="AddendumListToRadGrid" class="myGrid ag-theme-balham-dark" style="height: 335px; width: 100%" ng-show="DataObject.Tabs.AddendumListToRadTab==\'Grid\'"></div><div id="AddendumListToRadChart" class="stat-card p-0" style="height: 335px;" ng-show="DataObject.Tabs.AddendumListToRadTab==\'Chart\'"></div></div></div></div></div></div></div><div ng-show="DataObject.isLoading" class="spinner-overlay" style="z-index: 80;"><div class="spinner-overlay-body"></div><div class="single4"></div></div>');
$templateCache.put('app/pages/worklist/worklist.html','<link rel="stylesheet" href="cdn/css/ui-grid.css"><style>\r\n    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {\r\n    }\r\n    /*.filtsecion .blk-input.form-control,\r\n    .filtsecion .mult-select .form-control,\r\n    .filtsecion select.form-control {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n        padding: 5px 12px !important;\r\n    }\r\n    .filtsecion .loc-input {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n    .filtsecion .mult-select.ui-select-multiple.ui-select-bootstrap {\r\n        min-height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n    .filtsecion .k-multiselect-wrap,\r\n    .filtsecion .k-multiselect-wrap .k-input {\r\n        height: 28px !important;\r\n        border-width: 0 !important;\r\n    }\r\n    .filtsecion .k-multiselect-wrap .k-button {\r\n        font-size: 12px !important;\r\n    }\r\n    .filtsecion select.form-control.status-fs option {\r\n        font-size: 14px !important;\r\n    }*/\r\n\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n   /*added for OrderingPhysician*/\r\n    .dropdown-menu.opdrop-1 > li > div {\r\n        background-color: #414141 !important;\r\n        border-color: #414141 !important;\r\n        color: #fff !important;\r\n    }\r\n\r\n    .swal-wide {\r\n        width: 500px;\r\n    }\r\n\r\n    /*worklist page top btn zoom effect css start*/\r\n\r\n    .stcircle {\r\n        width: 12px;\r\n        height: 12px;\r\n        border-radius: 50%;\r\n        margin: 0px auto 2px;\r\n        display: none; /* to hide small circle*/\r\n    }\r\n\r\n    .wl-topbtnsection {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .wlzoomeffect span {\r\n        /*display: block;*/\r\n        text-align: center;\r\n        /*color: #c9edff;*/\r\n        color: #bdbdbd;\r\n    }\r\n\r\n    .wlzoomeffect.prvu span:nth-child(2) {\r\n        float: left;\r\n        padding-right: 5px;\r\n    }\r\n\r\n    .wlzoomeffect {\r\n        display: inline-block;\r\n        border: 0;\r\n        width: auto;\r\n        height: auto;\r\n        position: relative;\r\n        cursor: pointer;\r\n        margin: 0;\r\n        padding: 6px;\r\n    }\r\n\r\n     .wlzoomeffect:hover {\r\n\r\n     }\r\n\r\n    .wlzoomeffect.prvu:hover {\r\n     z-index: 2;\r\n    -webkit-transition: all 200ms ease-in;\r\n    -webkit-transform: scale(1.5);\r\n    -ms-transition: all 200ms ease-in;\r\n    -ms-transform: scale(1.5);\r\n    -moz-transition: all 200ms ease-in;\r\n    -moz-transform: scale(1.5);\r\n    transition: all 200ms ease-in;\r\n    transform: scale(1.5);\r\n    cursor: pointer;\r\n    }\r\n    .wlzoomeffect.adborder:hover::after {\r\n        content:\'\';\r\n        width: 100%;\r\n        position:absolute;\r\n        bottom:0;\r\n        left:0;\r\n        z-index:1;\r\n        border-bottom: 2px solid;\r\n    }\r\n    .wlzoomeffect.adborder:hover {\r\n        background-color: #323232;\r\n    }\r\n\r\n    .wlzoomeffect .cancel:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .cancel:after {\r\n        content: "Cancelled";\r\n    }\r\n\r\n    .wlzoomeffect .cancel:hover:after {\r\n        content: "Cancelled" !important;\r\n    }\r\n\r\n    .wlzoomeffect .comparison:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .comparison:after {\r\n        content: "Comparison";\r\n    }\r\n\r\n    .wlzoomeffect .comparison:hover:after {\r\n        content: "Comparison" !important;\r\n    }\r\n\r\n    .wlzoomeffect.draft:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .draft:after {\r\n        content: "Draft ({{DraftCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .draft:hover:after {\r\n        content: "Draft ({{DraftCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect.complete:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .complete:after {\r\n        content: "Complete ({{CompleteCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .complete:hover:after {\r\n        content: "Complete ({{CompleteCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .hst:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .hst:after {\r\n        content: "Hidden ({{HiddenCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .hst:hover:after {\r\n        content: "Hidden ({{HiddenCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .resultpending:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .resultpending:after {\r\n        content: "Result Pending ({{ResultPendingCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .resultpending:hover:after {\r\n        content: "Result Pending ({{ResultPendingCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .rps:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .rps:after {\r\n        content: "STAT/High Priority ({{StatCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .rps:hover:after {\r\n        content: "STAT/High Priority ({{StatCount}})" !important;\r\n    }\r\n    .wlzoomeffect .st:after {\r\n        content: "Signed Today ({{SignedToday}})";\r\n    }\r\n\r\n    .wlzoomeffect .st:hover:after {\r\n        content: "Signed Today ({{SignedToday}})" !important;\r\n    }\r\n        .wlzoomeffect .pc:after {\r\n            content: "(${{Charges}})";\r\n        }\r\n\r\n        .wlzoomeffect .pc:hover:after {\r\n            content: "(${{Charges}})" !important;\r\n        }\r\n\r\n    .wlzoomeffect .imagepending:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .imagepending:after {\r\n        content: "Image Pending";\r\n    }\r\n\r\n    .wlzoomeffect .imagepending:hover:after {\r\n        content: "Image Pending" !important;\r\n    }\r\n\r\n    .wlzoomeffect .ormpending:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .ormpending:after {\r\n        content: "ORM Pending";\r\n    }\r\n\r\n    .wlzoomeffect .ormpending:hover:after {\r\n        content: "ORM Pending" !important;\r\n    }\r\n\r\n    .wlzoomeffect.prvu:hover {\r\n        background-color: #3cc57e;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .wlzoomeffect.prvu:hover span {\r\n        color: #424242;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .p-zoom {\r\n        /*padding: 3px 3px;*/\r\n    }\r\n    .old-wedit .k-group.k-treeview-lines .k-item {\r\n        padding-left: 0 !important;\r\n    }\r\n    .old-wedit > .k-popup {\r\n        min-width:220px !important;\r\n        right:0;\r\n    }\r\n    ul.dropdown-menu li a.dropdown-item {\r\n        border-top: 0 !important;\r\n        border-bottom: 1px solid #686868 !important;\r\n    }\r\n\r\n    ul.dropdown-menu li:last-child a.dropdown-item {\r\n        border-top: 0 !important;\r\n        border-bottom: 0 !important;\r\n    }\r\n\r\n    ul.dropdown-menu li:nth-child(2) a.dropdown-item {\r\n        border-top: 0 !important;\r\n    }\r\n    ul.dropdown-menu li a.dropdown-item:hover {\r\n        background: #1c171c !important\r\n    }\r\n    .custom-overlay {\r\n        background-color: rgba(0,0,0,0.83);\r\n    }\r\n    @media only screen and (min-width: 320px) and (max-width: 1200px) {\r\n        .p-zoom {\r\n            padding: 3px 2px;\r\n        }\r\n\r\n        .wlzoomeffect .imagepending:after {\r\n            content: "IP" !important;\r\n        }\r\n\r\n        .wlzoomeffect .ormpending:after {\r\n            content: "ORM P" !important;\r\n        }\r\n\r\n        .wlzoomeffect .cancel:after {\r\n            content: "CA" !important;\r\n        }\r\n\r\n        .wlzoomeffect .comparison:after {\r\n            content: "Co" !important;\r\n        }\r\n\r\n        /*Bug 19801: The study count is not visible on status*/\r\n        .wlzoomeffect .draft:after {\r\n            content: "D" !important;\r\n        }\r\n        .wlzoomeffect .complete:after {\r\n            content: "C" !important;\r\n        }\r\n\r\n        .wlzoomeffect .hst:after {\r\n            content: "H" !important;\r\n        }\r\n\r\n        .wlzoomeffect .resultpending:after {\r\n            content: "RP" !important;\r\n        }\r\n\r\n        .wlzoomeffect .rps:after {\r\n            content: "STAT" !important;\r\n        }\r\n        .wlzoomeffect .st:after {\r\n            content: "ST" !important;\r\n        }\r\n        .wlzoomeffect .pc:after {\r\n            content: "${{WorklistPageHeaderParameter.Charges}}" !important;\r\n        }\r\n    }\r\n    /*worklist page top btn zoom effect css end*/\r\n\r\n    object {\r\n        min-height: 600px !important;\r\n        max-height: 800px !important;\r\n    }\r\n\r\n    #ModalFileAttachment .modal.fade .modal-dialog {\r\n        background-color: #fff !important;\r\n    }\r\n\r\n    .order_bg_84D9FF {\r\n        background-color: #84D9FF !important;\r\n    }\r\n\r\n    .order_bg_FF685E {\r\n        background-color: #FF685E !important;\r\n    }\r\n\r\n    .order_bg_BFDED6 {\r\n        background-color: #BFDED6 !important;\r\n    }\r\n\r\n    .order_bg_B9ADCF {\r\n        background-color: #B9ADCF !important;\r\n    }\r\n\r\n    .order_bg_75E284 {\r\n        background-color: #75E284 !important;\r\n    }\r\n\r\n    .order_bg_FFC99A {\r\n        background-color: #FFC99A !important;\r\n    }\r\n\r\n    .order_bg_FFE69A {\r\n        background-color: #FFE69A !important;\r\n    }\r\n\r\n    .order_bg_darkseagreen {\r\n        background-color: darkseagreen !important;\r\n    }\r\n\r\n    .order_bg_FBA46E {\r\n        background-color: #FBA46E !important;\r\n    }\r\n\r\n    .st-sort-ascent:before {\r\n        content: \'\\25B2\';\r\n    }\r\n\r\n    .st-sort-descent:before {\r\n        content: \'\\25BC\';\r\n    }\r\n\r\n    .lr-drop-target-before {\r\n        border-left: 2px solid orange;\r\n    }\r\n\r\n    .lr-drop-target-after {\r\n        border-right: 2px solid orange;\r\n    }\r\n    .dr-btn-none{\r\n        display: none;\r\n    }\r\n\r\n\r\n    .context-menu {\r\n        position: absolute;\r\n    }\r\n\r\n        .context-menu .dropdown-menu {\r\n            display: block;\r\n            position: static;\r\n            background-color: #323232 !important;\r\n            background: #323232 !important;\r\n        }\r\n        .context-menu .dropdown-menu li > a {\r\n            color: #05c1a4 !important;\r\n            background-color: transparent !important;\r\n            cursor:pointer;\r\n        }\r\n            .context-menu .dropdown-menu li > a:hover {\r\n                color: #05c1a4 !important;\r\n                background-color: transparent !important;\r\n\r\n            }\r\n\r\n            /*Load More scroll*/\r\n    .st-sort-ascent:before {\r\n        content: \'\\25B2\';\r\n    }\r\n\r\n    .st-sort-descent:before {\r\n        content: \'\\25BC\';\r\n    }\r\n\r\n    .table-container {\r\n        /*height: 500px;\r\n        overflow-y: scroll;*/\r\n    }\r\n\r\n    .loading-indicator {\r\n        box-sizing: border-box;\r\n        -webkit-box-sizing: border-box;\r\n        -moz-box-sizing: border-box;\r\n        width: auto;\r\n        text-align: center;\r\n        padding: 0.7em;\r\n    }\r\n\r\n        .loading-indicator:before {\r\n            display: inline-block;\r\n            margin: 0 0.4em;\r\n            min-width: 1em;\r\n            min-height: 1em;\r\n            border-top: 4px solid #646464;\r\n            border-right: 4px solid #e6e6e6;\r\n            border-left: 4px solid #e6e6e6;\r\n            border-bottom: 4px solid #646464;\r\n            content: "";\r\n            -webkit-animation: halfspin 1s ease infinite;\r\n            -moz-animation: halfspin 1s ease infinite;\r\n            -o-animation: halfspin 1s ease infinite;\r\n            animation: halfspin 1s ease infinite;\r\n            border-radius: 100%;\r\n        }\r\n\r\n    ul.dropdown-menu.contborder li:nth-child(2) a {\r\n        border-top: 1px solid #686868 !important;\r\n    }\r\n\r\n    @-webkit-keyframes halfspin {\r\n        to {\r\n            -webkit-transform: rotate(180deg);\r\n            -moz-transform: rotate(180deg);\r\n            transform: rotate(180deg);\r\n        }\r\n    }\r\n\r\n    @-moz-keyframes halfspin {\r\n        to {\r\n            -webkit-transform: rotate(180deg);\r\n            -moz-transform: rotate(180deg);\r\n            transform: rotate(180deg);\r\n        }\r\n    }\r\n\r\n    @keyframes halfspin {\r\n        to {\r\n            -webkit-transform: rotate(180deg);\r\n            -moz-transform: rotate(180deg);\r\n            transform: rotate(180deg);\r\n        }\r\n    }\r\n    .ui-grid-viewport {\r\n        overflow-anchor: none;\r\n    }\r\n    .ui-grid-row-selected {\r\n        background-color: #424242;\r\n        border-bottom: 1px solid #616161 !important;\r\n    }\r\n    .expandableRow .ui-grid-render-container-body .ui-grid-viewport {\r\n        overflow: hidden !important;\r\n        /* or use: overflow-x: hide!important; */\r\n    }\r\n\r\n    /*.ui-grid .ui-grid-render-container-body .ui-grid-viewport:first-child {\r\n        overflow-y: auto !important;\r\n        overflow-x: auto !important;\r\n    }*/\r\n    .hide-study-select {\r\n        background-color: rgb(5 193 164 / 26%);\r\n        border: 1px solid #05C1A4 !important;\r\n        color: white !important;\r\n    }\r\n    .hideStudy-info .tooltip.uibtooltipDenial .tooltip-inner {\r\n        width: 250px !important;\r\n        max-width: 400px !important;\r\n    }\r\n    .location-tags-input tags-input .tags.focused {\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #424242 !important;\r\n    }\r\n    #OldWorklistFilterlocationTooltip.tultiptext {\r\n        top: 58px !important;\r\n    }\r\n    .section-disbl {\r\n        pointer-events: none;\r\n        opacity: 0.8;\r\n    }\r\n    .rating-box-1 {\r\n        max-height: 590px;\r\n        overflow-y: auto;\r\n        overflow-x: hidden;\r\n    }\r\n</style><script id="template_tooltip" type="text/x-kendo-template"><div>#:value ? value : "N/A" #</div></script><div class="radf-header wroklist-wrapper" keyboard="keys"><worklist-page-header worklist-page-header-parameter="WorklistPageHeaderParameter" on-status-click="setStatus()" on-clear-filter-click="CollapseFiler()" on-user-payment-click="getUserPayments()"></worklist-page-header></div><div class="pportal-list" id="mainDiv"><div class=""><div class="p-0 collapse in b-clr-33 filtsecion filtr-ontop" id="collapseWorklist" role="tabpanel" aria-labelledby="heading_worklist"><form id="frmFilter" ng-submit="filter(frmFilter.$valid)"><div class="rf-filter filter-controller row mt-8px mb-2px rf-filter-ui stepSearchBar"><div class="col-sm-4 col-md-3 col-xs-2 mob-w-50 pr-0 tultip-bottom"><div class="width-100 tultip-bottom mb-5px"><site-location-grid master-locations="Locations" selected-location="SelectedLocations" on-change="updateSelectedLocation()"></site-location-grid></div></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="Accession" placeholder="Accession" tooltip-class="uibtooltipDenial" uib-tooltip="Accession" tooltip-placement="auto top" ng-change="OnChangeFilter()"></div><div class="col-sm-1 col-md-1 col-xs-2 mob-w-50 pr-0 pl-10px d-w-13"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="OrderDate" options="opts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{toolTipOrderDate}}" tooltip-placement="auto top" ng-mouseenter="resetDateRange()" ng-change="OnChangeFilter()"></div><div class="col-sm-2 col-md-1 col-xs-3 mob-w-50 pr-0 tultip-bottom pl-10px smw-19 w-12"><multi-select master-data="ModalityDropdownDataFilter" list="Modalities" ng-model="ModalityDropdownDataFilter.SelectedValue" on-change="onSelectedModality(selectedData)"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white tt-top" style="top:54px;">{{modalitytooltip}}</span></div><div class="col-sm-1 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="OrderingPhysician" placeholder="Ordering Physician" tooltip-class="uibtooltipDenial" uib-tooltip="Ordering Physician" tooltip-placement="auto top" ng-change="OnChangeFilter()"></div><div class="col-sm-2 col-md-2 col-xs-4 mob-w-50 old-wedit pr-10px pl-10px mob-pr0 tultip-bottom"><div id="worklistDropdownTree" class="loc-input w-100 hide-df-Select visb-close-icon" kendo-dropdowntree="worklistDropdownTree" k-options="worklistDropdownTreeOptions"></div><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px" style="top:33px!important;">{{worklisttooltip}}</span></div></div><div class="rf-filter filter-controller row mb-4px rf-filter-ui"><div class="col-sm-3 col-md-3 col-xs-3 mob-w-50 pr-0"><div class="col-sm-5 col-md-5 col-xs-5 pr-0 pl-0" style="z-index:1"><input type="text" class="blk-input form-control col-placeholder" ng-model="PatientMRN" placeholder="MRN" tooltip-class="uibtooltipDenial" uib-tooltip="MRN" tooltip-placement="auto top" ng-change="OnChangeFilter()"></div><div class="col-sm-7 col-md-7 col-xs-7 mob-w-58 pr-0 pl-10px"><input type="text" class="blk-input form-control col-placeholder" ng-model="PatientName" placeholder="Patient Name" tooltip-class="uibtooltipDenial" uib-tooltip="Patient Last Name, First Name" tooltip-placement="auto top" ng-change="OnChangeFilter()"></div></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px"><div class="input-group blk-calender mb-0"><input type="text" class="blk-input form-control col-placeholder" tooltip-class="uibtooltipDenial" uib-tooltip="DOB (mm/dd/yyyy)" tooltip-placement="auto top" uib-datepicker-popup="MM/dd/yyyy" ng-model="DOB" is-open="isDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="DOB" placeholder="DOB" data-container="body" ng-click="isDOBOpen = !isDOBOpen" ng-change="OnChangeFilter()"></div></div><div class="col-sm-8 col-md-8 col-xs-8 pr-0 pl-0 mob-w-100"><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="SelectedList.PatientClass" title="Select Type" on-select="OnSelectFilter($item)"><ui-select-match placeholder="Select Type" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PatientClass | propsFilter: {Value: $select.search}" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px"><select class="condition-select blk-input form-control downArrow-ie opnclr sing-select-2 status-fs" ng-model="Status.key" ng-change="filter()"><option ng-repeat="os in OrderStatus" value="{{os.key}}" ng-style="{{os.bgcolor}}">{{os.value}}</option></select></div><div class="col-sm-1 col-md-1 col-xs-1 mob-w-50 pr-0 pl-10px sm-w-11 w-135px"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="SelectedList.StudyPriority" title="Select Priority"><ui-select-match placeholder="Select Priority">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in StudyPriorities | propsFilter: {Value: $select.search}" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-3 col-md-2 col-xs-2 mob-w-50 pr-0 pl-10px wrklst-wdth-sm"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="SelectedList.Worklist" title="Select Worklist Type" on-select="changeWorklist()"><ui-select-match placeholder="Select Worklist Type">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in WorklistDropdown" position="down"><div ng-bind-html="list.Value"></div></ui-select-choices></ui-select></div><div class="col-sm-5 col-md-5 col-xs-3 mob-w-50 pr-0 pl-10px fltr-btn-wrapper no-pl filt-w-new-wl wdth-for-sm"><button type="submit" class="btn btn-primary rf-btn-xs" ng-disabled="isLoading">Filter</button> <button class="btn btn-primary rf-btn-xs" style="background-color:#00A8A2 !important" ng-show="SelectedList.Worklist.Key === \'PSW\'" ng-click="SaveFilters()">Save Filter</button> <button type="button" ng-click="clearFilterAndRefesh();" class="btn btn-default rf-btn-xs" ng-disabled="isLoading">Clear</button></div><div class="col-sm-1 col-md-2 col-xs-2 mob-w-50 pr-0 pl-0 sm-w-6 w-115px"><div class="txt-clr-2"><span class="fw-600" ng-if="RefreshTimmer > 0"><span class="full-w">Refresh in {{RefreshTimmer}} Seconds</span> <span class="half-w fs-12px">{{RefreshTimmer}} (Sec)</span></span> <a ng-click="getData();" class="btn btn-default pull-left ml-2 pf-3px d-none"><span>{{NewOrders}}</span> <i class="fa fa-caret-down"></i></a><div class="pb-0 pt-6px mb-0 auto-refresh-checkbox fs-12px txt-clr-1 fw-500 d-none"><label class="checkbox-switch" title="Auto Refresh"><input type="checkbox" ng-model="AutoRefresh" ng-change="onChangeAutoRefresh()" class="mr-2px"> <span class="checkbox-switch-slider round"></span></label> <span class="checkbox-switch-label">Auto Update</span></div></div><div class="clearfix"></div></div></div></div></form></div><div class="h-5px bg-clr-27"><div class="progress m-0 h-5px bg-clr-27" ng-show="isLoading"><div class="progress-bar progress-bar-striped active w-100 bg-clr-46" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div></div><div id="divOrderList" ui-grid="uiGridOptions" class="grid anui wlai old-wrklist-uigrid" style="width:100%;" ui-grid-infinite-scroll="" ui-grid-selection="" ui-grid-move-columns="" ui-grid-auto-resize="" ui-grid-expandable="" ui-grid-pinning="" ui-grid-resize-columns=""></div><div ng-show="isLoadingSynapse" class="spinner-overlay" style="z-index: 99999;"><div class="spinner-overlay-body" style="opacity:0.8 !important"><div class="w-100 txt-clr-2 text-center fs-22px fw-700 d-table h-100"><div class="d-table-cell v-a-m" style="padding-top:65px;">Loading study...</div></div></div><div class="single4"></div></div><script type="text/ng-template" id="tree_item_renderer.html"><div> <div> <div class="wrps-discus-chats fs-13px text-break-word bg-clr-29 bor-rad-5px p-15px-all"> <p class="discus-chats mb-0" style="white-space:pre-line">{{Dis.Comment | htmlDecode}}</p> </div> <div class="float-right py-5px"> <div class="tultip-top float-left"> <a class="btn btn-default glyphicon glyphicon-share-alt border-0" ng-click="Dis.IsChild=!Dis.IsChild"></a> <span class="tultiptext">Reply</span> </div> <div class="float-left pt-3px"> <span class="txt-clr-1 fs-15px dis-crt-name" ng-if="disName(Dis)">{{disName(Dis) | htmlDecode}}</span> <span class="txt-clr-2 fs-12px"> {{Dis.Record_Created_At|localDate :false }}</span> </div> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div class="" ng-show="Dis.IsChild"> <div class="mb-10px w-70 pull-right"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Dis.ChildComment" placeholder="Add a comment"> </textarea> </div> <div class="clearfix"></div> <div class="mb-10px"> <button type="button" class="btn btn-primary pull-right" ng-click="SaveChildDiscussion(Dis)">Save</button> <div class="clearfix"></div> </div> </div> </div> <div class="clearfix"></div> </div> <ul style="list-style:none"> <li class="mb-10px" ng-repeat="Dis in Dis.Childs" ng-include="\'tree_item_renderer.html\'"></li> </ul></script></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_SingReport" k-on-open="isSingReportVisible = true" k-on-close="isSingReportVisible = false;winSingReport_OnClose();" k-title="\'Open Study\'" k-visible="false" k-modal="true" k-width="win_SingReportWidth" k-height="230" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Close"]\' k-animation="false"><div ng-if="isSingReportVisible"><div class="denial-window pt-10px"><div class="row card-bg-white denial-window-head"><div class="col-md-12 mb-10px"><div><span class="report_span_title">Site :</span> <span class="report_span">{{SingReport.CurrentSite}}</span></div></div><div class="col-md-12 mb-10px"><div><span class="report_span_title">MRN :</span> <span class="report_span">{{SingReport.CurrentPatientMRN}}</span></div></div><div class="col-md-12 mb-10px"><div><span class="report_span_title">Patient :</span> <span class="report_span">{{SingReport.CurrentPatient}}</span></div></div><div class="col-md-12 mb-20px"><div><span class="report_span_title">Accession :</span> <span class="report_span">{{SingReport.CurrentAccession}}</span></div></div><div class="col-md-12"><button ng-click="SignAndPrevRec()" class="btn btn-primary btn-sm tultip-bottom" title="" ng-disabled="SingbtnDisabled" tooltip-class="uibtooltipDenial" uib-tooltip="{{SingReport.PrevToolTip}}" tooltip-placement="auto right"><i class="fa fa-chevron-left pr-2px"></i>Previous</button> <button ng-click="SignAndNextRec()" class="btn btn-primary btn-sm tultip-bottom" title="" ng-disabled="SingbtnDisabled" tooltip-class="uibtooltipDenial" uib-tooltip="{{SingReport.NextToolTip}}" tooltip-placement="auto right">Next<i class="fa fa-chevron-right pl-2px"></i></button></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_PSUser" k-on-open="isPSUserVisible = true" k-on-close="isPSUserVisible = false" k-title="\'Login\'" k-visible="false" k-width="win_PSUserWidth" k-height="300" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Close"]\'><div ng-if="isPSUserVisible"><div class="pScript m-0-auto pb-20px"><h5>Please provide your credentials below for the dictation system where your radiology report needs to be placed.</h5><form name="PSUserform" id="PSUserform" ng-submit="InsertPSUsersBySIte(PSUserform.$valid)"><div class="w-30 float-left"><label class="rf-label">Location:</label></div><div class="w-70 float-left"><label class="fw-500 txt-clr-1 p-2px-all">{{SingReport.OrderList[SingReport.Index].Location}}</label></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Username:</label></div><div class="w-70 float-left"><input type="text" id="PSUserUsername" name="PSUserUsername" ng-model="PSUser.Username" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Password:</label></div><div class="w-70 float-left"><input type="password" id="PSUserPassword" name="PSUserPassword" ng-model="PSUser.Password" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-primary">Log On</button></div><div class="clearfix"></div></form></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0 report-popup px-5px" kendo-window="win_ComparisonOrderReports" k-on-open="isComparisonOrderReportsVisible = true;winOpen();" k-on-close="isComparisonOrderReportsVisible = false;winComparisonOrderReports_OnClose();onClearFilterReportList(true);" k-title="\'Report\'" k-modal="true" k-visible="false" k-width="winComparisonOrderReportsWidth" k-height="defaultWindowHeight" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isComparisonOrderReportsVisible"><div class=""><div class=""><div class="row mb-20px m-0"><div class="col-md-12 p-0"><div class="" ng-if="!PriorReportFilter.Modal"><div class="" id="{{OrderReport.OrderID}}"><div class="mob-report"><div class="row bg-clr-24 pt-10px pb-5px m-0 mob-d-flex mob-flex-wrap"><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Patient Name:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.Patient_LastName}}, {{report.Patient_FirstName}}">{{report.Patient_LastName}}, {{report.Patient_FirstName}}</span></div><div class="mb-5px text-truncate"><span>Patient DOB:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.Patient_DOB}}">{{report.Patient_DOB}}</span></div><div class="mb-5px text-truncate"><span>Patient Gender:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto right" uib-tooltip="{{report.Patient_Gender}}">{{report.Patient_Gender}}</span></div></div><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Patient Class:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.PatientClass}}">{{report.PatientClass}}</span></div><div class="mb-5px text-truncate"><span>Patient Location:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.PatientLocation}}">{{report.PatientLocation}}</span></div><div class="mb-5px text-truncate"><span>Reading Location:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.ReadingLocation}}">{{report.ReadingLocation}}</span></div></div><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Rend. Doc:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.RED_LastName}}">{{report.RED_LastName}}</span></div><div class="mb-5px"><span class="float-left">Ord. Doc:</span> <span class="txt-clr-15 float-left"><span class="hovIcon-td float-left" ng-if="report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span text-truncate float-left w-od" style="padding: 0px 0px 5px 5px;" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.OrderingPhysician}}">{{report.OrderingPhysician}}</span> <span class="iconDropdown cursor-pointer sm-pl" style="top: 24px;"><span class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{report.OrderingPhysicianPhone | tel}}</span></span></span></span> <span class="hovIcon-td tooltip-w-100px float-left" ng-if="!report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span text-truncate float-left w-od" style="padding: 0px 0px 5px 5px;" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.OrderingPhysician}}">{{report.OrderingPhysician}}</span> <span class="iconDropdown cursor-pointer sm-pl" style="top: 21px !important;" ng-if="report.OrderingPhysician"><a ng-click="showContact(report.OrderingPhysician, report.LocationID, report.Location)" class="cursor-pointer w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto button" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></span></span></span></div><div class="clearfix"></div><div class="mb-5px text-truncate"><span>DOS:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.DOS}}">{{report.DOS}}</span></div></div><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Signed Date:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto right" uib-tooltip="{{report.SingDate}}">{{report.SingDate}}</span></div><div class="mb-5px text-truncate"><span>Status:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto right" uib-tooltip="{{report.Status}}">{{report.Status}}</span></div><div class="mb-5px text-truncate"><div class="d-inline">Procedure:</div><div class="txt-clr-15 d-inline" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.ProcedureDescription}}">{{report.ProcedureDescription}}</div></div></div></div><div class="w-100" ng-if="report.DictationValue"><div class="w-100 repoheight-1 old-wrklst-rprtwnd overflow-y-auto overflow-x-hide py-10px px-15px reportmaxwin bg-clr-49"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="width:100%; display:block; line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div></div></div><div class="m-0" ng-if="PriorReportFilter.Modal"><div class="row m-0 bg-clr-24 pt-10px pb-5px mob-report setHeight-scroll"><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Patient Name:</span> <span class="txt-clr-15 d-inline" title="{{report.Patient_LastName}}, {{report.Patient_FirstName}}">{{report.Patient_LastName}}, {{report.Patient_FirstName}}</span></div><div class="mb-5px"><span>Patient DOB:</span> <span class="txt-clr-15">{{report.Patient_DOB}}</span></div><div class="mb-5px"><span>Patient Gender:</span> <span class="txt-clr-15">{{report.Patient_Gender}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Patient Class:</span> <span class="txt-clr-15">{{report.PatientClass}}</span></div><div class="mb-5px text-truncate"><span>Patient Location:</span> <span class="txt-clr-15 d-inline" title="{{report.PatientLocation}}">{{report.PatientLocation}}</span></div><div class="mb-5px text-truncate"><span>Reading Location:</span> <span class="txt-clr-15 d-inline" title="{{report.ReadingLocation}}">{{report.ReadingLocation}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Rend. Doc:</span> <span class="txt-clr-15 text-breakword">{{report.RED_LastName}}</span></div><div class="mb-5px"><div class="d-inline">Ord. Doc:</div><div class="d-inline txt-clr-15"><div class="hovIcon-td d-inline" ng-if="report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px;"><span class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{report.OrderingPhysicianPhone | tel}}</span></span></div></div><div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px !important;" ng-if="report.OrderingPhysician"><a ng-click="showContact(report.OrderingPhysician, report.LocationID, report.Location)" class="cursor-pointer w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></div></div></div></div><div class="mb-5px"><span>DOS:</span> <span class="txt-clr-15">{{report.DOS}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Signed Date:</span> <span class="txt-clr-15">{{report.SingDate}}</span></div><div class="mb-5px"><span>Status:</span> <span class="txt-clr-15">{{report.Status}}</span></div><div class="mb-5px text-truncate"><span>Procedure:</span> <span class="txt-clr-15 d-inline" title="{{report.ProcedureDescription}}">{{report.ProcedureDescription}}</span></div></div></div><div class="rprtdscn-fbtns-wrapper d-flex align-item-center p-5px-all px-10px"><div class="width-100 mr-15px"><input type="text" class="blk-input form-control col-placeholder h-25px input-filterreport" placeholder="Search" ng-model="PriorReportFilter.Options.SearchText" ng-keyup="FilterReportList()"></div><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap mr-15px"><li class="pos-rel align-self-center mr-15px"><a class="border-0 btnpopover-sorting bor-rad-2px py-4px px-4px fs-10px text-center" ng-click="displaySortPopover = true" uib-tooltip="{{PriorReportFilter.SortingOption}}" tooltip-placement="top" ng-style="displaySortPopover == true ? {\'background-color\':\'#05c1a4\'} : {\'background-color\': \'rgba(5, 193, 164, 0.19);\'}"><i class="fa fa-sort-amount-asc" aria-hidden="true"></i></a><div class="popover-sorting p-5px-all bor-rad-2px" ng-show="displaySortPopover" ng-mouseleave="displaySortPopover = false"><a class="popover-sorting-item d-block p-5px-all cursor-pointer fs-12px fw-400 txt-clr-1" ng-repeat="list in PriorReportFilter.SortingOptions" ng-class="{\'active\' : list == PriorReportFilter.SortingOption}" ng-click="onReportSortingClicked(list)">{{list}}</a></div></li><li class="text-center" ng-repeat="list in PriorReportFilter.List.DateRange" ng-class="{\'active\' : PriorReportFilter.Options.DateRange == list}" ng-click="PriorReportFilter.Options.DateRange=list;FilterReportList()"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap"><li class="text-center" ng-repeat="list in PriorReportFilter.List.Modalities track by $index" ng-class="{\'active\' : PriorReportFilter.Options.Modality == list}" ng-click="PriorReportFilter.Options.Modality=list;FilterReportList()"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul></div><div class="row m-0"><div class="col-lg-2 col-sm-2 col-xs-3 m-0 pl-0 pr-0 pr-5px bg-clr-49"><div class="overflow-auto repoheight-2 repoHeiFtrWrklst ftlrbtns-height singlewrklist"><div ng-repeat="r in reportList | orderBy: PriorReportFilter.SortingPropName : PriorReportFilter.SortingOrder track by $index" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #959595 1px solid;cursor:pointer; word-wrap: break-word !important;">{{r.ProcedureDesc}}<div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}">DOS : {{r.OrderDate | date:\'MM/dd/yyyy\'}}<div style="text-align: right;" ng-if="r.IsReviewable == 1"><i class="fa fa-star txt-clr-8" aria-hidden="true"></i></div></div><span ng-if="signByDisplay(r)">{{signByDisplay(r)}}</span></div></div></div><div ng-class="ReviewOrder && ReviewOrder.IsReviewable? \'col-lg-7 col-sm-7 col-xs-9 col-sm-7 m-0 wlh-pdf\' :\'col-lg-10 col-sm-10 col-xs-9 col-sm-10 m-0 wlh-pdf pl-0\'" id="{{OrderReport.OrderID}}"><div class="row 100 ng-scope ml-0" ng-if="report.DictationValue && reportList.length > 0"><div class="w-100 repoheight-2 singlewrklisrprt overflow-y-auto overflow-x-hide py-10px px-10px bg-clr-49"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div><div ng-if="ReviewOrder && ReviewOrder.IsReviewable" class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0" id="{{OrderReport.OrderID}}"><div ng-form="review" class="p-10px-all"><div class="row"><div class="col-md-12 form-group fw-600 section-disbl">For Interesting Cases: <input type="checkbox" class="v-a-m mt-0" ng-checked="ReviewOrder.IsInterestingCase" ng-model="ReviewOrder.IsInterestingCase" ng-disabled="true"> <span align="left" class="cursor-pointer hovIcon-td float-right d-none"><a uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" class="cursor-pointer no-bg" ng-show="ReviewOrder.OptionalDicomViewer.length > 0"><i class="fa fa-picture-o fs-17px txt-clr-14"></i></a> <span class="iconDropdown-2" style="left:-135px;"><a class="cursor-pointer p-0 tultip-left dvnew" ng-repeat="DV in ReviewOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(OrderReport , DV, false)"><span class="agfa d-block">{{SetDicomViewerText(DV)}}</span></a></span></span><div class="clearfix"></div></div><div class="col-md-12 form-group mb-5px section-disbl"><table class="patient-table w-100 b-1-s b-clr-1"><thead><tr class="bg-clr-23" style="border:0!important;background-color:#05c1a4!important;"><th class="w-40px text-center py-2px fw-600">Sr.</th><th class="py-2px fw-600">Score</th></tr></thead><tbody class="bg-clr-23 pt-5px"><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">1</td><td><div style="padding: 0px 5px 5px 5px;" class="txt-clr-1"><input class="pos-rel cmn-checkbx-input mt-1" style="top:2px;" type="radio" ng-click="ReviewOrder.Rating=\'1\'" ng-checked="ReviewOrder.Rating==\'1\'"> Concur with Interpretation</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">2</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/not ordinarily expected to be made(understandable miss)</span><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'2a\'" ng-checked="ReviewOrder.Rating==\'2a\'">2a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'2b\'" ng-checked="ReviewOrder.Rating==\'2b\'">2b.Likely to be signficant</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">3</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/Should be made most of time</span><br><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'3a\'" ng-checked="ReviewOrder.Rating==\'3a\'">3a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'3b\'" ng-checked="ReviewOrder.Rating==\'3b\'">3b.Likely to be signficant</div></td></tr><tr class="bg-clr-23" style="border: 0 !important;"><td class="text-center v-a-t w-40px txt-clr-1">4</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/Should be made almost every time - misinterpretation of findings</span><br><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'4a\'" ng-checked="ReviewOrder.Rating==\'4a\'">4a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'4b\'" ng-checked="ReviewOrder.Rating==\'4b\'">4b.Likely to be signficant</div></td></tr></tbody></table></div><div class="col-md-12 col-sm-12 mb-10 section-disbl" ng-show="ReviewOrder.IsInterestingCase"><span ng-show="ReviewOrder.IsInterestingCase" style="color:white;float:left;">Keywords *</span> <input type="text" class="blk-input form-control w-100 mb-10px" name="keyword" ng-model="ReviewOrder.Keywords" placeholder="Keywords." ng-required="ReviewOrder.IsInterestingCase"><div class="clearfix"></div></div><div class="clearfix"></div><div class="col-md-12 form-group fw-600"><span ng-show="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')" style="color:white; float:left;">Add a comment *</span><div class="clearfix"></div><textarea class="txt-area h-70px w-100 p-5px-all" rows="4" name="comment" ng-model="ReviewOrder.Comments" placeholder="Add a comment." ng-required="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')"> </textarea></div><div class="col-md-12 d-none"><button type="button" class="btn btn-primary h-30px px-10px fs-13px pull-left" ng-disabled="(!review.comment.$valid || !review.keyword.$valid) || (!ReviewOrder.IsInterestingCase && (!ReviewOrder.Rating || ReviewOrder.Rating==\'\'))" ng-click="SaveReviewOrder()">Save</button></div></div></div></div></div></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail discsn-popup" kendo-window="win_Discussion" k-on-open="isDiscussionVisible = true" k-on-close="isDiscussionVisible = false" k-title="\'Discussion\'" k-visible="false" k-width="winDiscussionWidth" k-height="defaultWindowHeight" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isDiscussionVisible"><div class="denial-window"><div class="fw-500"><div class="row fw-500 mob-discussion mob-d-flex mob-flex-wrap"><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">Location :</span> <span class="report_span">{{SelectedOrder.Location}}</span></div><div class="mb-5px"><span class="report_span_title">Gender :</span> <span class="report_span">{{SelectedOrder.PatientGender}}</span></div><div class="mb-5px"><span class="report_span_title">Ordering Physician :</span><div class="hovIcon-td d-inline" ng-if="SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top:25px;"><div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{SelectedOrder.OrderingPhysicianPhone | tel}}</span></div></div></div><div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px !important;" ng-if="SelectedOrder.OrderingPhysician"><a ng-click="showContact(SelectedOrder.OrderingPhysician, SelectedOrder.LocationID, SelectedOrder.Location)" class="cursor-pointer w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></div></div></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">DOS :</span> <span class="report_span">{{(SelectedOrder.OrderDate) ? (SelectedOrder.OrderDate | date:\'M/d/yy HH:mm\').toString().replace("00:00","") : \'\'}}</span></div><div class="mb-5px"><span class="report_span_title">Type :</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'E\'">Emergency</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'I\'">Inpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'O\'">Outpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'P\'">PreAdmit</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'U\'">Unknown</span></div><div class="d-inline-block pos-rel"><div class="kendo-actionbtn-section" ng-show="SelectedOrder.OptionalDicomViewer.length > 0"><div class="float-left">Dicom Viewer</div><div class="float-left pos-rel"><button class="kendo-dropbtn outline-none txt-clr-14" uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"><i class="fa fa-file-image-o k-icon-downdir fs-18px"></i></button><div class="kendo-action-dropdown-content"><a href="#" class="" ng-repeat="DV in SelectedOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(SelectedOrder, DV, false)"><span class="agfa d-block">{{SetDicomViewerText(DV)}}</span></a></div></div><div class="clearfix"></div></div></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">Patient Name :</span> <span class="report_span">{{SelectedOrder.PatientName}}</span></div><div class="mb-5px"><span class="report_span_title">Modality :</span> <span class="report_span">{{SelectedOrder.Modality}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">DOB :</span> <span class="report_span">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span></div><div class="mb-5px"><span class="report_span_title">Procedure :</span> <span class="report_span text-breakword">{{SelectedOrder.ProcedureDesc}}</span></div><div class="mb-5px"><button type="button" ng-show="OrderDiscussion.ID && (ODType==\'Assigner\' || ODType==\'Helper\')" class="btn btn-default pull-right" ng-click="CloseOrderDiscussion()">Close Discussion</button></div></div></div><div class="text-right mt-8px" ng-class="{\'float-right\': !showAttachment}"><a class="cursor-pointer mb-5px" ng-if="SelectedOrder.FileCount > 0 && !showAttachment" ng-click="showFileList()">View Attachment ({{SelectedOrder.FileCount}})</a> <a class="btn btn-default mb-5px" ng-if="showAttachment" ng-click="hideFileList()"><i class="fa fa-arrow-left mr-5px"></i>Back</a></div><div ng-if="!showAttachment"><div class="row m-0"><div class="col-lg-3 col-md-3 col-sm-3 p-0 discussion-sel tultip-bottom"><div ng-show="ODType==\'Assigner\' && SelectedOrder.Status != \'C\'"><div id="kddtOrderDiscussion" class="visb-close-icon" style="width: 100%;border-color:#424242!important;background-color:#323232!important;" kendo-dropdowntree="kddtOrderDiscussion" k-options="getOrderDiscussionOptions()"></div><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white ug-tt-width z-i-9999" style="top:35px!important; visibility: hidden;" id="OrderDiscussionAssignmentTooltip">{{orderDiscussionTooltip}}</span></div></div></div><div class="row m-0"><div class="col-md-12 p-0" ng-show="ODType==\'Discussion\' || ODType==\'Helper\'"><div class="form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea></div><div class=""><button type="button" class="btn btn-primary pull-right border-0" ng-click="SaveDiscussion()">Save</button></div></div><div class="col-md-12 pr-0 pl-0" ng-show="ODType==\'Assigner\'"><div class="col-md-12 form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea></div><button type="button" class="btn btn-primary pull-right ml-5px" ng-click="SaveOrderDiscussion()" style="display:none;">Consult Study</button> <button type="button" class="btn btn-primary pull-right ml-5px" ng-click="AssignStudy()" ng-disabled="AssignStudyFlag" style="display:none;">Assign Study</button> <button type="button" class="btn btn-primary pull-right" ng-click="SaveDiscussion()" ng-disabled="SaveDiscussionFlag">Save</button></div><div class="clearfix h-10px"></div><div class="discus-comment fxd-mx-height overflow-y-auto py-10px px-10px"><div class=""><div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div></div><div ng-if="showAttachment && !showDiscuss" class="new-wl-discussion"><div class="discussion-attachment-sec"><div class="row m-0"><attachment-viewer ng-if="ReferenceID" dicomorder-id="ReferenceID"></attachment-viewer></div></div></div></div></div></div></div><div class="overflow-hide-all no-min-h-310px height-auto ERA-check-detail" kendo-window="win_HideStudy" k-on-open="isHideStudyVisible = true" k-on-close="isHideStudyVisible = false" k-title="\'Hide Study\'" k-visible="false" k-width="win_HideStudyWidth" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="isHideStudyVisible"><form id="hidehours"><div class="row mb-20px"><div class="col-lg-12"><div class="row m-0"><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-md-12 col-sm-12 col-xs-12 px-0" ng-repeat="HiddenType in HiddenTypeList | orderBy : \'Key\' | limitTo : 4"><label class="form-controller hideStudy-info d-flex align-item-center mb-10px" ng-class="{\'hide-study-select\' : (HiddenType.Key == HideOption.Key)}" style="padding: 7px 10px !important; border: 1px solid #525252; border-radius: 5px;"><input type="radio" ng-model="HideOption.Key" class="m-0 cmn-checkbx-input" ng-value="HiddenType.Key" id="{{HiddenType.ID}}" autocomplete="off" name="HiddenType" ng-click="clearCommentBox()"> <span class="rf-label cmn-check-label">{{HiddenType.Key}}</span><i class="fa fa-info-circle pl-5px" tooltip-class="uibtooltipDenial" tooltip-placement="bottom" uib-tooltip="{{HiddenType.tooltip}}"></i></label></div></div><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-md-12 col-sm-12 col-xs-12 px-0" ng-repeat="HiddenType in HiddenTypeList | orderBy : \'Key\' | limitTo : -3"><label class="form-controller d-flex hideStudy-info align-item-center mb-10px" ng-class="{\'hide-study-select\' : (HiddenType.Key == HideOption.Key)}" style="padding: 7px 10px !important; border: 1px solid #525252; border-radius: 5px;"><input type="radio" ng-model="HideOption.Key" class="m-0 cmn-checkbx-input" ng-value="HiddenType.Key" id="{{HiddenType.ID}}" autocomplete="off" name="HiddenType" ng-click="clearCommentBox()"> <span class="rf-label cmn-check-label">{{HiddenType.Key}}</span><i class="fa fa-info-circle pl-5px" tooltip-class="uibtooltipDenial" tooltip-placement="bottom" uib-tooltip="{{HiddenType.tooltip}}"></i></label></div></div></div><div class="row mb-10px" ng-show="HideOption.Key != \'Not to be Read\'"><div class="col-lg-12"><div class="px-15px"><textarea class="txt-area h-70px px-10px w-100" maxlength="2000" id="Comments" name="Comments" ng-model="HideOption.Comments" placeholder="Add Comment" autocomplete="off"> </textarea></div></div></div></div></div><div class="w-100 py-15px"><div class="float-right"><button type="submit" class="btn btn-default mr-5px" data-dismiss="modal" ng-click="CancelHideStudy()">Cancel</button> <button type="submit" class="btn btn-primary" ng-click="HideStudy(HideOption.Comments)">Save</button></div><div class="clearfix"></div></div></form></div></div><div class="overflow-hide-all ERA-check-detail modal-search-contact" kendo-window="win_ContactList" k-on-open="iswin_ContactListVisible = true" k-on-close="iswin_ContactListVisible = false" k-title="\'Contact\'" k-visible="false" k-width="win_ContactListWidth_new" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="iswin_ContactListVisible"><div class="modal-body p-0 sm-pr-0"><div class="row mb-10px"><div class="col-lg-3 col-sm-5 mb-5px"><label>Name</label> <input type="text" class="blk-input form-control" id="Name" ng-model="FilterAddressBook.Name" autocomplete="off" ng-required="true" placeholder="Name"></div><div class="col-lg-5 col-sm-5 mb-5px"><label>Location</label> <input type="text" class="blk-input form-control" id="Location" ng-model="FilterAddressBook.LocationName" autocomplete="off" ng-required="true" placeholder="Location" ng-disabled="true"></div><div class="col-lg-6 col-sm-12 mb-5px"><label>&nbsp;</label> <button class="btn btn-primary" ng-click="getContact(FilterAddressBook.Name,FilterAddressBook.LocationIDs,FilterAddressBook.LocationName)">Search</button> <button class="btn btn-primary d-none" ng-click="addContact(FilterAddressBook.LocationIDs)">Add Contact</button></div></div><address-book-grid edit-contact="EditContact()" delete-contact="DeleteContact()" address-book-info="AddressBookInfo" filter-address-book="FilterAddressBook" view-mode="true" id="SearchContactModal"></address-book-grid></div></div></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_AddEditContact" k-on-open="iswin_AddEditContactVisible = true" k-on-close="iswin_AddEditContactVisible = false" k-visible="false" k-title="win_AddEditContactTitle" k-width="win_ContactListWidth" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="iswin_AddEditContactVisible"><div class="modal-body p-0 sm-pr-0"><address-book-contact-form address-book-info="AddressBookInfo" on-save-contact="saveContact(AddressBookInfo.Flag)" save-other-btn="false"></address-book-contact-form></div></div></div><div class="overflow-hide-all ERA-check-detail fix-height-repodiscwin px-5px py-0" kendo-window="win_ModalReportNDiscuss" k-visible="false" k-width="win_ModalReportNDiscussWidth" k-height="defaultWindowHeight" k-title="\'Report - Discussion\'" k-resize="winResize" k-dragend="winDragend" k-on-open="winModalReportNDiscussionOnOpen()" k-on-close="onClearFilterReportList(true)" k-modal="true" k-animation="false" k-actions=\'["Minimize", "Maximize", "Close"]\'><div><div class="k-content bg-clr-23"><div id="tabstrip"><ul><li class="k-state-active" id="tabReport" ng-click="onClearFilterReportList(false);FilterReportList();">Report</li><li id="tabDiscussion" ng-click="openDiscussion();">Discussion</li></ul><div id="Report" style="opacity:1 !important" class="overflow-x-hide pt-0 pr-0 p-0"><div class="max-h-90vh h-80vh p-0 mt-5px" ng-if="!isReportAvailable">Report not available</div><div class="" ng-if="isReportAvailable"><div class="row mb-0 mx-0 m-0"><div class="col-md-12 p-0"><div class="m-0" ng-if="!PriorReportFilter.Modal"><div class="" id="{{OrderReport.OrderID}}"><div class="row m-0 bg-clr-24 pt-10px pb-5px make-col-50"><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Patient Name:</span> <span class="txt-clr-15 d-inline" title="{{report.Patient_LastName}}, {{report.Patient_FirstName}}">{{report.Patient_LastName}}, {{report.Patient_FirstName}}</span></div><div class="mb-5px"><span>Patient DOB:</span> <span class="txt-clr-15">{{report.Patient_DOB}}</span></div><div class="mb-5px"><span>Patient Gender:</span> <span class="txt-clr-15">{{report.Patient_Gender}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Patient Class:</span> <span class="txt-clr-15">{{report.PatientClass}}</span></div><div class="mb-5px text-truncate"><span>Patient Location:</span> <span class="txt-clr-15 d-inline" title="{{report.PatientLocation}}">{{report.PatientLocation}}</span></div><div class="mb-5px text-truncate"><span>Reading Location:</span> <span class="txt-clr-15 d-inline" title="{{report.ReadingLocation}}">{{report.ReadingLocation}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Rend. Doc:</span> <span class="txt-clr-15">{{report.RED_LastName}}</span></div><div class="mb-5px"><div class="d-inline">Ord. Doc:</div><div class="hovIcon-td d-inline" ng-if="report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px 5px 5px 0px;">{{report.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 21px;"><div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{report.OrderingPhysicianPhone | tel}}</span></div></div></div><div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 21px !important;" ng-if="report.OrderingPhysician"><a ng-click="showContact(report.OrderingPhysician, report.LocationID, report.Location)" class="cursor-pointer w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></div></div></div><div class="mb-5px"><span>DOS:</span> <span class="txt-clr-15">{{report.DOS}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Signed Date:</span> <span class="txt-clr-15">{{report.SingDate}}</span></div><div class="mb-5px"><span>Status:</span> <span class="txt-clr-15">{{report.Status}}</span></div><div class="mb-5px text-truncate"><span>Procedure:</span> <span class="txt-clr-15 d-inline" title="{{report.ProcedureDescription}}">{{report.ProcedureDescription}}</span><div class="mb-5px"><button class="btn btn-default mb-5px" ng-click="openShareExamWindow()">Share Exam</button></div></div></div></div><div ng-class="ReviewOrder && ReviewOrder.IsReviewable? \'col-lg-9 col-sm-9 col-xs-9 col-sm-9 m-0 wlh-pdf\' :\'col-lg-12 col-sm-12 col-xs-12 col-sm-12 m-0 wlh-pdf\'" id="{{OrderReport.OrderID}}" style="padding:0!important;"><div class="w-100" ng-if="report.DictationValue"><div class="w-100 repoheight-4 overflow-y-auto overflow-x-hide py-10px px-15px reportmaxwin-2 bg-clr-49"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height: 1.4;font-family: Menlo, Monaco, Consolas, \'Courier New\', monospace !important;white-space: pre-line;background-color: transparent;border: none;font-size: 16px;"></report></div></div></div><div ng-if="ReviewOrder && ReviewOrder.IsReviewable" class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box-1" id="{{OrderReport.OrderID}}"><div ng-form="review" class="p-10px-all"><div class="row"><div class="col-md-12 form-group fw-600 section-disbl">For Interesting Cases: <input type="checkbox" class="v-a-m mt-0" ng-checked="ReviewOrder.IsInterestingCase" ng-model="ReviewOrder.IsInterestingCase" ng-disabled="true"> <span align="left" class="cursor-pointer hovIcon-td float-right d-none"><a uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" class="cursor-pointer no-bg" ng-show="ReviewOrder.OptionalDicomViewer.length > 0"><i class="fa fa-picture-o fs-17px txt-clr-14"></i></a> <span class="iconDropdown-2" style="left:-135px;"><a class="cursor-pointer p-0 tultip-left dvnew" ng-repeat="DV in ReviewOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(OrderReport , DV, false)"><span class="agfa d-block">{{SetDicomViewerText(DV)}}</span></a></span></span><div class="clearfix"></div></div><div class="col-md-12 form-group mb-5px section-disbl"><table class="patient-table w-100 b-1-s b-clr-1"><thead><tr class="bg-clr-23" style="border:0!important;background-color:#05c1a4!important;"><th class="w-40px text-center py-2px fw-600">Sr.</th><th class="py-2px fw-600">Score</th></tr></thead><tbody class="bg-clr-23 pt-5px"><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">1</td><td><div style="padding: 0px 5px 5px 5px;" class="txt-clr-1"><input type="radio" class="cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'1\'" ng-checked="ReviewOrder.Rating==\'1\'"> Concur with Interpretation</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">2</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/not ordinarily expected to be made(understandable miss)</span><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'2a\'" ng-checked="ReviewOrder.Rating==\'2a\'">2a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'2b\'" ng-checked="ReviewOrder.Rating==\'2b\'">2b.Likely to be signficant</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">3</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/Should be made most of time</span><br><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'3a\'" ng-checked="ReviewOrder.Rating==\'3a\'">3a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'3b\'" ng-checked="ReviewOrder.Rating==\'3b\'">3b.Likely to be signficant</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">4</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/Should be made almost every time - misinterpretation of findings</span><br><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'4a\'" ng-checked="ReviewOrder.Rating==\'4a\'">4a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'4b\'" ng-checked="ReviewOrder.Rating==\'4b\'">4b.Likely to be signficant</div></td></tr></tbody></table></div><div class="col-md-12 col-sm-12 mb-10 section-disbl" ng-show="ReviewOrder.IsInterestingCase"><span ng-show="ReviewOrder.IsInterestingCase" style="color:white;float:left;">Keywords *</span> <input type="text" class="blk-input form-control w-100 mb-10px" name="keyword" ng-model="ReviewOrder.Keywords" placeholder="Keywords." ng-required="ReviewOrder.IsInterestingCase" ng-disabled="true"><div class="clearfix"></div></div><div class="clearfix"></div><div class="col-md-12 form-group fw-600"><span ng-show="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')" style="color:white; float:left;">Add a comment *</span><div class="clearfix"></div><textarea class="txt-area h-70px w-100 p-5px-all" rows="4" name="comment" ng-model="ReviewOrder.Comments" placeholder="Add a comment." ng-required="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')"> </textarea></div><div class="col-md-12 d-none"><button type="button" class="btn btn-primary h-30px px-10px fs-13px pull-left" ng-disabled="(!review.comment.$valid || !review.keyword.$valid) || (!ReviewOrder.IsInterestingCase && (!ReviewOrder.Rating || ReviewOrder.Rating==\'\'))" ng-click="SaveReviewOrder()">Save</button></div></div></div></div></div></div></div></div><div class="m-0" ng-if="PriorReportFilter.Modal"><div class="row m-0 bg-clr-24 pt-10px pb-5px make-col-50"><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Patient Name:</span> <span class="txt-clr-15 d-inline" title="{{report.Patient_LastName}}, {{report.Patient_FirstName}}">{{report.Patient_LastName}}, {{report.Patient_FirstName}}</span></div><div class="mb-5px"><span>Patient DOB:</span> <span class="txt-clr-15">{{report.Patient_DOB}}</span></div><div class="mb-5px"><span>Patient Gender:</span> <span class="txt-clr-15">{{report.Patient_Gender}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Patient Class:</span> <span class="txt-clr-15">{{report.PatientClass}}</span></div><div class="mb-5px text-truncate"><span>Patient Location:</span> <span class="txt-clr-15 d-inline" title="{{report.PatientLocation}}">{{report.PatientLocation}}</span></div><div class="mb-5px text-truncate"><span>Reading Location:</span> <span class="txt-clr-15 d-inline" title="{{report.ReadingLocation}}">{{report.ReadingLocation}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Rend. Doc:</span> <span class="txt-clr-15">{{report.RED_LastName}}</span></div><div class="mb-5px"><div class="d-inline">Ord. Doc:</div><div class="txt-clr-15 d-inline"><div class="hovIcon-td d-inline" ng-if="report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px;"><div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{report.OrderingPhysicianPhone | tel}}</span></div></div></div><div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px !important;" ng-if="report.OrderingPhysician"><a ng-click="showContact(report.OrderingPhysician, report.LocationID, report.Location)" class="cursor-pointer w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></div></div></div></div><div class="mb-5px"><span>DOS:</span> <span class="txt-clr-15">{{report.DOS}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Signed Date:</span> <span class="txt-clr-15">{{report.SingDate}}</span></div><div class="mb-5px"><span>Status:</span> <span class="txt-clr-15">{{report.Status}}</span></div><div class="mb-5px text-truncate"><span>Procedure:</span> <span class="txt-clr-15 d-inline" title="{{report.ProcedureDescription}}">{{report.ProcedureDescription}}</span><div class="mb-5px"><button class="btn btn-default mb-5px" ng-click="openShareExamWindow()">Share Exam</button></div></div></div></div><div class="rprtdscn-fbtns-wrapper d-flex align-item-center p-5px-all px-10px"><div class="width-100 mr-15px"><input type="text" class="blk-input form-control col-placeholder h-25px input-filterreport" placeholder="Search" ng-model="PriorReportFilter.Options.SearchText" ng-keyup="FilterReportList()"></div><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap mr-15px"><li class="pos-rel align-self-center mr-15px"><a class="border-0 btnpopover-sorting bor-rad-2px py-4px px-4px fs-10px text-center" ng-click="displaySortPopover = true" uib-tooltip="{{PriorReportFilter.SortingOption}}" tooltip-placement="top" ng-style="displaySortPopover == true ? {\'background-color\':\'#05c1a4\'} : {\'background-color\': \'rgba(5, 193, 164, 0.19);\'}"><i class="fa fa-sort-amount-asc" aria-hidden="true"></i></a><div class="popover-sorting p-5px-all bor-rad-2px" ng-show="displaySortPopover" ng-mouseleave="displaySortPopover = false"><a class="popover-sorting-item d-block p-5px-all cursor-pointer fs-12px fw-400 txt-clr-1" ng-repeat="list in PriorReportFilter.SortingOptions" ng-class="{\'active\' : list == PriorReportFilter.SortingOption}" ng-click="onReportSortingClicked(list)">{{list}}</a></div></li><li class="text-center" ng-repeat="list in PriorReportFilter.List.DateRange" ng-class="{\'active\' : PriorReportFilter.Options.DateRange == list}" ng-click="PriorReportFilter.Options.DateRange=list;FilterReportList()"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap"><li class="text-center" ng-repeat="list in PriorReportFilter.List.Modalities track by $index" ng-class="{\'active\' : PriorReportFilter.Options.Modality == list}" ng-click="PriorReportFilter.Options.Modality=list;FilterReportList()"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul></div><div class="row m-0"><div class="col-lg-2 col-sm-2 col-xs-3 m-0 pl-0 pr-0 pr-5px bg-clr-49"><div class="overflow-auto repoheight-2 repoHeiFtrWrklst ftlrbtns-height singlewrklist"><div ng-repeat="r in reportList | orderBy: PriorReportFilter.SortingPropName : PriorReportFilter.SortingOrder track by $index" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #959595 1px solid;cursor:pointer; word-wrap: break-word !important;">{{r.ProcedureDesc}}<div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}">DOS : {{r.OrderDate | date:\'MM/dd/yyyy\'}}<div style="text-align: right;" ng-if="r.IsReviewable == 1"><i class="fa fa-star txt-clr-8" aria-hidden="true"></i></div></div><span ng-if="signByDisplay(r)">{{signByDisplay(r)}}</span></div></div></div><div ng-class="ReviewOrder && ReviewOrder.IsReviewable? \'col-lg-7 col-sm-7 col-xs-7 col-sm-7 m-0 wlh-pdf\' :\'col-lg-10 col-sm-10 col-xs-9 col-sm-10 m-0 wlh-pdf pr-0 pl-0\'" id="{{OrderReport.OrderID}}"><div class="w-100" ng-if="report.DictationValue && reportList.length > 0"><div class="w-100 repoheight-5 repohgth-5 snglerklistrprtr overflow-y-auto overflow-x-hide py-5px px-10px leftsecmaxwindowht bg-clr-49"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:16px;"></report></div></div></div><div ng-if="ReviewOrder && ReviewOrder.IsReviewable" class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box-1" id="{{OrderReport.OrderID}}"><div ng-form="review" class="p-10px-all"><div class="row"><div class="col-md-12 form-group fw-600 section-disbl">For Interesting Cases: <input type="checkbox" class="v-a-m mt-0" ng-checked="ReviewOrder.IsInterestingCase" ng-model="ReviewOrder.IsInterestingCase" ng-disabled="true"> <span align="left" class="cursor-pointer hovIcon-td float-right d-none"><a uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" class="cursor-pointer no-bg" ng-show="ReviewOrder.OptionalDicomViewer.length > 0"><i class="fa fa-picture-o fs-17px txt-clr-14"></i></a> <span class="iconDropdown-2" style="left:-135px;"><a class="cursor-pointer p-0 tultip-left dvnew" ng-repeat="DV in ReviewOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(OrderReport , DV, false)"><span class="agfa d-block">{{SetDicomViewerText(DV)}}</span></a></span></span><div class="clearfix"></div></div><div class="col-md-12 form-group mb-5px section-disbl"><table class="patient-table w-100 b-1-s b-clr-1"><thead><tr class="bg-clr-23" style="border:0!important;background-color:#05c1a4!important;"><th class="w-40px text-center py-2px fw-600">Sr.</th><th class="py-2px fw-600">Score</th></tr></thead><tbody class="bg-clr-23 pt-5px"><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">1</td><td class="txt-clr-1"><div style="padding: 0px 5px 5px 5px;" class="txt-clr-1"><input type="radio" class="cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'1\'" ng-checked="ReviewOrder.Rating==\'1\'"> Concur with Interpretation</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">2</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/not ordinarily expected to be made(understandable miss)</span><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'2a\'" ng-checked="ReviewOrder.Rating==\'2a\'">2a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'2b\'" ng-checked="ReviewOrder.Rating==\'2b\'">2b.Likely to be signficant</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">3</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/Should be made most of time</span><br><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'3a\'" ng-checked="ReviewOrder.Rating==\'3a\'">3a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'3b\'" ng-checked="ReviewOrder.Rating==\'3b\'">3b.Likely to be signficant</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">4</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/Should be made almost every time - misinterpretation of findings</span><br><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'4a\'" ng-checked="ReviewOrder.Rating==\'4a\'">4a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1" ng-click="ReviewOrder.Rating=\'4b\'" ng-checked="ReviewOrder.Rating==\'4b\'">4b.Likely to be signficant</div></td></tr></tbody></table></div><div class="col-md-12 col-sm-12 mb-10 section-disbl" ng-show="ReviewOrder.IsInterestingCase"><span ng-show="ReviewOrder.IsInterestingCase" style="color:white;float:left;">Keywords *</span> <input type="text" class="blk-input form-control w-100 mb-10px" name="keyword" ng-model="ReviewOrder.Keywords" placeholder="Keywords." ng-required="ReviewOrder.IsInterestingCase" ng-disabled="true"><div class="clearfix"></div></div><div class="clearfix"></div><div class="col-md-12 form-group fw-600"><span ng-show="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')" style="color:white; float:left;">Add a comment *</span><div class="clearfix"></div><textarea class="txt-area h-70px w-100 p-5px-all" rows="4" name="comment" ng-model="ReviewOrder.Comments" placeholder="Add a comment." ng-required="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')"> </textarea></div><div class="col-md-12 d-none"><button type="button" class="btn btn-primary h-30px px-10px fs-13px pull-left" ng-disabled="(!review.comment.$valid || !review.keyword.$valid) || (!ReviewOrder.IsInterestingCase && (!ReviewOrder.Rating || ReviewOrder.Rating==\'\'))" ng-click="SaveReviewOrder()">Save</button></div></div></div></div></div></div></div></div><div id="Discussion" style="opacity:1 !important"><div class="fw-500 pt-10px"><div class="row fw-500 mr-0 make-col-50"><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">Location :</span> <span class="report_span">{{SelectedOrder.Location}}</span></div><div class="mb-5px"><span class="report_span_title">Gender :</span> <span class="report_span">{{SelectedOrder.PatientGender}}</span></div><div class="mb-0"><span class="report_span_title">Ordering Physician :</span><div class="hovIcon-td d-inline" ng-if="SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px;"><div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{SelectedOrder.OrderingPhysicianPhone | tel}}</span></div></div></div><div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px !important;" ng-if="SelectedOrder.OrderingPhysician"><a ng-click="showContact(SelectedOrder.OrderingPhysician, SelectedOrder.LocationID, SelectedOrder.Location)" class="cursor-pointer w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></div></div></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">DOS :</span> <span class="report_span">{{(SelectedOrder.OrderDate) ? (SelectedOrder.OrderDate | date:\'M/d/yy HH:mm\').toString().replace("00:00","") : \'\'}}</span></div><div class="mb-5px"><span class="report_span_title">Type :</span><span class="report_span" ng-if="SelectedOrder.PatientClass==\'E\'">Emergency</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'I\'">Inpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'O\'">Outpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'P\'">PreAdmit</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'U\'">Unknown</span></div><div class="mb-0"><div class="d-inline-block pos-rel"><div class="kendo-actionbtn-section" ng-show="SelectedOrder.OptionalDicomViewer.length > 0"><div class="float-left">Dicom Viewer :</div><div class="float-left pos-rel"><div><button class="kendo-dropbtn outline-none txt-clr-14" uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"><i class="fa fa-file-image-o k-icon-downdir fs-18px"></i></button><div class="kendo-action-dropdown-content"><a class="btn" ng-repeat="DV in SelectedOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(SelectedOrder, DV, false)"><span class="agfa d-block">{{SetDicomViewerText(DV)}}</span></a></div></div></div><div class="clearfix"></div><button type="button" ng-show="ODType==\'Helper\'" class="btn cmn-btn btn-primary h-30px px-10px fs-13px pull-right" ng-click="CloseOrderDiscussion()">Close Discussion</button></div></div></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">Patient Name :</span> <span class="report_span">{{SelectedOrder.PatientName}}</span></div><div class="mb-5px"><span class="report_span_title">Modality :</span> <span class="report_span">{{SelectedOrder.Modality}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">DOB :</span> <span class="report_span">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span></div><div class="mb-5px"><span class="report_span_title">Procedure :</span> <span class="report_span">{{SelectedOrder.ProcedureDesc}}</span></div></div></div><div class="text-right mt-8px" ng-class="{\'right-postn-elem\': !showAttachment}"><a class="cursor-pointer mb-5px" ng-if="SelectedOrder.FileCount > 0 && !showAttachment" ng-click="showFileList()">View Attachment ({{SelectedOrder.FileCount}})</a> <a class="btn btn-default mb-5px" ng-if="showAttachment" ng-click="hideFileList()"><i class="fa fa-arrow-left mr-5px"></i>Back</a> <button class="btn btn-default mb-5px" ng-click="openShareExamWindow()">Share Exam</button></div><div ng-if="!showAttachment"><div class="row m-0"><div class="col-lg-3 col-md-3 col-sm-3 p-0"><div ng-show="ODType==\'Assigner\'"><ui-select ng-model="OrderDiscussion.SelectedUser" theme="bootstrap" class="dicom-inp-w" ng-disabled="OrderDiscussion.ID"><ui-select-match allow-clear="true" placeholder="Select Radiologist">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices repeat="list in Radiologists | filter: isVisibleRad | propsFilter: {FirstName: $select.search, LastName: $select.search} | orderBy:\'LastName\'"><small><i class="fa fa-circle" ng-class="{\'text-success\':list.IsOnline,\'text-gray-dark\':!list.IsOnline}"></i> {{radDisplay(list)}}</small></ui-select-choices></ui-select></div></div></div><div class="row m-0"><div class="col-md-12 p-0" ng-show="ODType==\'Discussion\' || ODType==\'Helper\'"><div class="form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea></div><div class="col-lg-12 col-md-12 p-0"><button type="button" class="btn btn-primary pull-right border-0" ng-click="SaveDiscussion()">Save</button></div></div><div class="col-md-12 pr-0 pl-0" ng-show="ODType==\'Assigner\'"><div class="col-md-12 form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea></div><button type="button" ng-hide="OrderDiscussion.ID" class="btn btn-primary pull-right ml-5px" ng-click="SaveOrderDiscussion()">Consult Study</button> <button type="button" ng-hide="OrderDiscussion.ID" class="btn btn-primary pull-right ml-5px" ng-click="AssignStudy()">Assign Study</button> <button type="button" ng-show="OrderDiscussion.ID" class="btn btn-primary pull-right" ng-click="SaveDiscussion()">Save</button></div><div class="clearfix h-10px"></div><div class="discus-comment overflow-y-auto py-10px px-10px wl-async"><div class=""><div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div></div><div ng-if="showAttachment && showDiscuss" class="new-wl-rep-dis"><div class="discussion-attachment-sec overflow-x-hide"><div class="row m-0"><attachment-viewer ng-if="ReferenceID" dicomorder-id="ReferenceID"></attachment-viewer></div></div></div></div></div></div></div></div></div><div class="modal fade" id="ModalWorkList" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog create-filter"><div class="modal-content py-20px px-0" style="border-radius:4px;background-color:#2c2c2c;"><div class=""><div class=""></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary mr-10px" ng-click="createWorkList()">Create Worklist</button> <button type="button" class="btn btn-primary mr-10px" ng-click="saveFilterOnly()">Save Filter Only</button> <button type="button" class="btn btn-default mr-10px" data-dismiss="modal">Cancel</button></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs" kendo-window="win_shareExamsWindow" k-on-open="isShareExamWindowVisible = true;" k-on-close="isShareExamWindowVisible = false;" k-title="\'Share Exams\'" k-modal="true" k-visible="false" k-width="winShareExamWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isShareExamWindowVisible"><div class="row px-10px mr-0"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><shareexam on-send="setUserChat" selected-order="SelectedOrder" check="isShareExamWindowVisible" on-close="onCloseShareExamWindowHandler(check)"></shareexam></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs" kendo-window="win_consultExamsWindow" k-on-open="isConsultExamsWindow = true;" k-on-close="isConsultExamsWindow = false;" k-title="\'Consult Exams\'" k-modal="true" k-visible="false" k-width="winConsultExamWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isConsultExamsWindow"><div class="row px-10px mr-0"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><videocallconsult class="clearfix video-call-consult" on-send="setUserChat" selected-order="SelectedOrder" check="isConsultExamsWindow" on-close="onCloseConsultExamWindowHandler(check)"></videocallconsult></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs" kendo-window="win_OrderEventLog" k-on-open="isOrderEventLogVisible = true;" k-on-close="isOrderEventLogVisible = false;" k-title="\'Order Event Logs\'" k-modal="true" k-visible="false" k-width="winComparisonOrderReportsWidth" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isOrderEventLogVisible"><div class=""><div class=""><div class="row mr-0"><div class=""><div class="bg-clr-24 rslvd-ovrflw"><div class="col-sm-3 mob-width-50"><div class="mb-10px"><span>Patient Name:</span> <span class="txt-clr-15">{{SelectedOrder.PatientName}}</span></div><div class="mb-10px"><span>Patient DOB:</span> <span class="txt-clr-15">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span></div><div class="mb-10px"><span>Patient Gender:</span> <span class="txt-clr-15">{{SelectedOrder.PatientGender}}</span></div></div><div class="col-sm-3 mob-width-50"><div class="mb-10px"><span>Patient Class:</span><span class="report_span" ng-if="SelectedOrder.PatientClass==\'E\'">Emergency</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'I\'">Inpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'O\'">Outpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'P\'">PreAdmit</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'U\'">Unknown</span></div><div class="mb-10px"><span>Patient Location:</span> <span class="txt-clr-15">{{SelectedOrder.Location}}</span></div><div class="mb-10px"><span>Status:</span> <span class="txt-clr-15">{{SelectedOrder.Status}}</span></div></div><div class="col-sm-6 mob-width-100 mob-d-flex mob-flex-wrap"><div class="mb-10px mob-mb-0 mob-width-50"><div class="d-inline">Ord. Doc:</div><div class="txt-clr-15 d-inline"><div class="hovIcon-td d-inline" ng-if="SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px;"><div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{SelectedOrder.OrderingPhysicianPhone | tel}}</span></div></div></div><div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 19px !important;" ng-if="SelectedOrder.OrderingPhysician"><a ng-click="showContact(SelectedOrder.OrderingPhysician, SelectedOrder.LocationID, SelectedOrder.Location)" class="cursor-pointer p-5px-all ordevntlog"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></div></div></div></div><div class="mb-10px mob-mb-0 mob-width-50 mob-pl-15"><span>Procedure:</span> <span class="txt-clr-15">{{SelectedOrder.ProcedureDesc}}</span></div></div></div><div class="w-100"><div class="w-100 overflow-y-auto overflow-x-hide pt-10px pb-0 px-5px order-event-logsec"><event-log order-id="SelectedOrder.OrderID" accession="SelectedOrder.Accession"></event-log></div></div></div></div></div></div></div></div><script>\r\n    $(document).ready(function () {\r\n        $("#tabstrip").kendoTabStrip({\r\n            animation: false\r\n        });\r\n    });\r\n</script><div class="modal fade z-i-9999" id="ModalDicomViewerCredentials" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important; z-index:99999 !important;"><div class="modal-dialog mdvcpopup"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Centricity Login</h4></div><div class="modal-body"><div class=""><div class="mdvctxt"><div class="row"><div class="col-md-12 col-sm-12 txt-clr-1"><h5 class="txt-clr-1 fs-18px">GE Healthcare</h5></div><div class="col-md-12 col-sm-12"><h4 class="txt-clr-1 fs-22px">Centricity<sup>*</sup></h4><h2 class="txt-clr-1 fs-26px">Universal Viewer</h2></div></div></div><div class="mdvcfrmouter"><form name="DVCredform" id="DVCredform" ng-submit="InsertDicomViewerCredentials(DVCredform.$valid)" class="mdvcfrm"><div class="w-30 float-left"><label class="txt-clr-1 fw-500">Username:</label></div><div class="w-70 float-left"><input type="text" name="DVCredUsername" ng-model="DVCred.Username" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="txt-clr-1 fw-500">Password:</label></div><div class="w-70 float-left"><input type="password" name="DVCredUsername" ng-model="DVCred.Password" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-primary">Login</button></div><div class="clearfix"></div></form></div><div class="row"><div class="col-md-12 col-sm-12 text-left"><img src="assets/images/mdvc.png"></div></div></div></div></div></div></div></div><script id="dropdowntree-template" type="text/kendo-ui-template"><div class=\'w-c-100-50px text-truncate filterTarget float-left pt-3px\' title=\'#: item.WorkListName #\'> #: item.WorkListName # </div> <div class=\'w-50px float-left\' style=\'text-align:right;\'> <span class=\'w-25px\'> #if(item.LoggedInUserID == item.CreatedBy || item.isAdmin) {# <i onclick=\'onEditWorklist(event, #: item.RuleID #)\' title=\'Edit\' class=\'btn fa fa-pencil px-0 txt-clr-14\' align=\'right\'></i> #}# </span> <i onclick=\'onDeleteWorklist(event,#: item.RuleID #);\' title=\'Delete\' class=\'btn fa fa-trash w-25px px-0 txt-clr-14\' align=\'right\'></i> </div> <div class="clearfix"></div></script><script>\r\n\r\n    function deleteWorklist(event, value, type) {\r\n        event.stopPropagation();\r\n        var val = value;\r\n        angular.element(document.getElementById(\'worklistDropdownTree\')).scope().deleteWorklist(val, type);\r\n    }\r\n    function editWorklist(event, value, Id) {\r\n        event.stopPropagation();\r\n        var val = value;\r\n        angular.element(document.getElementById(\'worklistDropdownTree\')).scope().editWorklist(val, Id);\r\n    }\r\n    function editAdminWorklist(value) {\r\n        var val = value;\r\n        angular.element(document.getElementById(\'worklistDropdownTree\')).scope().editAdminWorklist(val);\r\n    }\r\n    function onEditWorklist(event, RuleID) {\r\n        event.stopPropagation();\r\n        var ruleid = RuleID;\r\n        angular.element(document.getElementById(\'worklistDropdownTree\')).scope().onEditWorklist(ruleid);\r\n    }\r\n    function onDeleteWorklist(event, RuleID) {\r\n        event.stopPropagation();\r\n        var ruleid = RuleID;\r\n        angular.element(document.getElementById(\'worklistDropdownTree\')).scope().onDeleteWorklist(ruleid);\r\n    }\r\n    function notify() {\r\n        angular.element(document.getElementById(\'container\')).scope().refreshAndHideNotification();\r\n    }\r\n</script><div class="modal fade z-i-1049" id="ModalEditWorkList" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important;"><div class="modal-dialog edit-filter"><div class="modal-content px-0"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="CloseWorklistModal()">&times;</button><h4 style="color:#fff;">Edit Worklist</h4></div><rule rule="Rule" rule-table="RuleTable" rule-setting="false" ng-if="ModalWorklistOpened"></rule></div></div></div></div><script id="dropdowntree-orderdiscussion-template" type="text/kendo-ui-template"># if (item.Group && item.Group == "YES") { # #: item.UserName # # } else { # <i class="fa fa-circle #: item.IsOnline ? \'text-success\' : \'text-gray-dark\' #"></i> #: item.UserName # # } #</script><script id="myAlertTemplate" type="text/kendo-ui-template"><div class=\'myWarning\'>#= message # Please <a class=\'txt-clr-14 cursor-pointer\' onclick=\'notify()\'>click here</a> to refresh.</div></script><script type="text/ng-template" id="custom_template.html"><div class="ui-notification custom-template"> <div class="message" ng-click="refreshAndHideNotification()"> <div style="cursor: pointer !important;">Click here to update the worklist for incoming and updated studies.</div> </div> </div></script>');
$templateCache.put('app/pages/worklist-async/expandableRowTemplate.html','<div ui-grid="row.entity.subGridOptions" style="height:140px;"></div>');
$templateCache.put('app/pages/worklist-async/worklist-async.html','<style>\r\n\r\n    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {\r\n    }\r\n    /*.filtsecion .blk-input.form-control,\r\n    .filtsecion .mult-select .form-control,\r\n    .filtsecion select.form-control {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n        padding: 5px 12px !important;\r\n    }\r\n    .filtsecion .loc-input {\r\n        height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n    .filtsecion .mult-select.ui-select-multiple.ui-select-bootstrap {\r\n        min-height: 30px !important;\r\n        font-size: 12px !important;\r\n    }\r\n    .filtsecion .k-multiselect-wrap,\r\n    .filtsecion .k-multiselect-wrap .k-input {\r\n        height: 28px !important;\r\n        border-width: 0 !important;\r\n    }\r\n    .filtsecion .k-multiselect-wrap .k-button {\r\n        font-size: 12px !important;\r\n    }\r\n    .filtsecion select.form-control.status-fs option {\r\n        font-size: 14px !important;\r\n    }*/\r\n\r\n    #sidebar {\r\n        background-color: #EEE;\r\n        position: absolute;\r\n        top: 35px;\r\n        bottom: 0;\r\n        left: 0;\r\n        width: 200px;\r\n        overflow: auto;\r\n    }\r\n\r\n    #content {\r\n        position: absolute;\r\n        top: 35px;\r\n        bottom: 0;\r\n        left: 206px /* 200 + 6*/;\r\n        right: 0;\r\n        overflow: hidden;\r\n        color: #FFF;\r\n    }\r\n\r\n    #top-content {\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: auto; /* 130 + 6 */\r\n        left: 0;\r\n        right: 0;\r\n        background-color: #444;\r\n        overflow: auto;\r\n    }\r\n\r\n    #bottom-content {\r\n        position: absolute;\r\n        height: 130px;\r\n        bottom: 0;\r\n        left: 0;\r\n        right: 0;\r\n        overflow: auto;\r\n        background-color: #777;\r\n    }\r\n\r\n    #sidebar-resizer {\r\n        /*background-color: #666;*/\r\n        background-color: #b3adad;\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: 0;\r\n        left: calc(250px + 29px);\r\n        width: 2px;\r\n        cursor: e-resize;\r\n    }\r\n\r\n    #content-resizer {\r\n        position: absolute;\r\n        height: 6px;\r\n        bottom: 130px;\r\n        left: 0;\r\n        right: 0;\r\n        background-color: #666;\r\n        cursor: n-resize;\r\n    }\r\n\r\n    #sidebar-resizer:hover, #preview-resizer:hover {\r\n        background-color: #AAA;\r\n    }\r\n\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n   /*added for OrderingPhysician*/\r\n    .dropdown-menu.opdrop-1 > li > div {\r\n        background-color: #414141 !important;\r\n        border-color: #414141 !important;\r\n        color: #fff !important;\r\n    }\r\n\r\n    .swal-wide {\r\n        width: 500px;\r\n    }\r\n\r\n    /*worklist page top btn zoom effect css start*/\r\n\r\n    .stcircle {\r\n        width: 12px;\r\n        height: 12px;\r\n        border-radius: 50%;\r\n        margin: 0px auto 2px;\r\n        display: none; /* to hide small circle*/\r\n    }\r\n\r\n    .wl-topbtnsection {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .wlzoomeffect span {\r\n        /*display: block;*/\r\n        text-align: center;\r\n        /*color: #c9edff;*/\r\n        color: #bdbdbd;\r\n    }\r\n\r\n    .wlzoomeffect.prvu span:nth-child(2) {\r\n        float: left;\r\n        padding-right: 5px;\r\n    }\r\n\r\n    .wlzoomeffect {\r\n        display: inline-block;\r\n        border: 0;\r\n        width: auto;\r\n        height: auto;\r\n        position: relative;\r\n        cursor: pointer;\r\n        margin: 0;\r\n        /*padding: 6px;*/\r\n        padding: 6px 4px 4px;\r\n    }\r\n\r\n     .wlzoomeffect:hover {\r\n\r\n     }\r\n\r\n    .wlzoomeffect.prvu:hover {\r\n     z-index: 2;\r\n    -webkit-transition: all 200ms ease-in;\r\n    -webkit-transform: scale(1.2);\r\n    -ms-transition: all 200ms ease-in;\r\n    -ms-transform: scale(1.2);\r\n    -moz-transition: all 200ms ease-in;\r\n    -moz-transform: scale(1.2);\r\n    transition: all 200ms ease-in;\r\n     /*transform: scale(1.5);*/\r\n    transform: scale(1.2);\r\n    cursor: pointer;\r\n    }\r\n    .wlzoomeffect.adborder:hover::after {\r\n        content:\'\';\r\n        width: 100%;\r\n        position:absolute;\r\n        bottom:0;\r\n        left:0;\r\n        z-index:1;\r\n        border-bottom: 2px solid;\r\n    }\r\n    .wlzoomeffect.adborder:hover {\r\n        background-color: #323232;\r\n    }\r\n\r\n    .wlzoomeffect .cancel:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .cancel:after {\r\n        content: "Cancelled";\r\n    }\r\n\r\n    .wlzoomeffect .cancel:hover:after {\r\n        content: "Cancelled" !important;\r\n    }\r\n\r\n    .wlzoomeffect .comparison:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .comparison:after {\r\n        content: "Comparison";\r\n    }\r\n\r\n    .wlzoomeffect .comparison:hover:after {\r\n        content: "Comparison" !important;\r\n    }\r\n\r\n    .wlzoomeffect.draft:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .draft:after {\r\n        content: "Draft ({{DraftCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .draft:hover:after {\r\n        content: "Draft ({{DraftCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect.complete:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .complete:after {\r\n        content: "Complete ({{CompleteCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .complete:hover:after {\r\n        content: "Complete ({{CompleteCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .hst:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .hst:after {\r\n        content: "Hidden ({{HiddenCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .hst:hover:after {\r\n        content: "Hidden ({{HiddenCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .resultpending:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .resultpending:after {\r\n        content: "Result Pending ({{ResultPendingCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .resultpending:hover:after {\r\n        content: "Result Pending ({{ResultPendingCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .rps:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .rps:after {\r\n        content: "STAT/High Priority ({{StatCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .rps:hover:after {\r\n        content: "STAT/High Priority ({{StatCount}})" !important;\r\n    }\r\n        .wlzoomeffect .st:after {\r\n            content: "Signed Today ({{SignedToday}})";\r\n        }\r\n\r\n        .wlzoomeffect .st:hover:after {\r\n            content: "Signed Today ({{SignedToday}})" !important;\r\n        }\r\n        .wlzoomeffect .pc:after {\r\n            content: "(${{Charges}})";\r\n        }\r\n\r\n        .wlzoomeffect .pc:hover:after {\r\n            content: "(${{Charges}})" !important;\r\n        }\r\n\r\n    .wlzoomeffect .imagepending:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .imagepending:after {\r\n        content: "Image Pending";\r\n    }\r\n\r\n    .wlzoomeffect .imagepending:hover:after {\r\n        content: "Image Pending" !important;\r\n    }\r\n\r\n    .wlzoomeffect .ormpending:hover span {\r\n        display: none;\r\n    }\r\n\r\n    .wlzoomeffect .ormpending:after {\r\n        content: "ORM Pending";\r\n    }\r\n\r\n    .wlzoomeffect .ormpending:hover:after {\r\n        content: "ORM Pending" !important;\r\n    }\r\n\r\n    .wlzoomeffect.prvu:hover {\r\n        background-color: #3cc57e;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .wlzoomeffect.prvu:hover span {\r\n        color: #424242;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .p-zoom {\r\n        /*padding: 3px 3px;*/\r\n    }\r\n\r\n    /*new css start*/\r\n    .wltabactive img {\r\n       filter: brightness(0) saturate(100%) invert(65%) sepia(53%) saturate(1729%) hue-rotate(121deg) brightness(104%) contrast(94%);\r\n    }\r\n    .add-bt-line:hover {\r\n        filter: brightness(0) saturate(100%) invert(65%) sepia(53%) saturate(1729%) hue-rotate(121deg) brightness(104%) contrast(94%);\r\n        color: white !important;\r\n        border-right: 2px solid white !important;\r\n    }\r\n    .add-bt-line:last-child\r\n    {\r\n        position:relative;\r\n    }\r\n    .add-bt-line:last-child:hover {\r\n        filter: none;\r\n        color: #05c1a4 !important;\r\n        border-right: 2px solid #05c1a4 !important;\r\n    }\r\n    .adm-count-tag, .wl-tab-left span.adm-count-tag {\r\n        background-color: #ea4848;\r\n        border-radius: 100%;\r\n        bottom: -20px;\r\n        padding: 2px !important;\r\n        text-align: center;\r\n        min-width: 16px !important;\r\n        min-height: 16px;\r\n        width: auto !important;\r\n        height: auto;\r\n        transform: rotate(267deg);\r\n    }\r\n    .attop-droptarget .wl-tab-left span.adm-count-tag:first-child,\r\n    .attop-droptarget .wl-tab-left span.adm-count-tag {\r\n        height: 16px;\r\n        bottom: 0;\r\n        padding: 2px !important;\r\n        margin: 0 0 0 5px !important;\r\n        transform: rotate(0deg);\r\n    }\r\n    @keyframes overdue-bounce {\r\n        0%, 20%, 50%, 80%, 100% { transform: translateX(0); }\r\n        40%  { transform: translateX(5px); }\r\n        60%  { transform: translateX(3px); }\r\n    }\r\n    @keyframes overdue-bounce-top {\r\n        0%, 20%, 50%, 80%, 100% { transform: translateY(0); }\r\n        40%  { transform: translateY(-5px); }\r\n        60%  { transform: translateY(-3px); }\r\n    }\r\n    .overdue-ball {\r\n        display: inline-block !important;\r\n        writing-mode: horizontal-tb !important;\r\n        width: 10px !important;\r\n        height: 10px !important;\r\n        background-color: #ea4848 !important;\r\n        border-radius: 50% !important;\r\n        padding: 0 !important;\r\n        margin-top: 4px;\r\n        animation: overdue-bounce 1.6s ease infinite;\r\n        box-sizing: border-box;\r\n    }\r\n    .attop-droptarget .overdue-ball {\r\n        display: inline-block !important;\r\n        width: 10px !important;\r\n        height: 10px !important;\r\n        background-color: #ea4848 !important;\r\n        border-radius: 50% !important;\r\n        margin: 0 0 0 4px !important;\r\n        padding: 0 !important;\r\n        vertical-align: middle !important;\r\n        flex-shrink: 0;\r\n        animation: overdue-bounce-top 1.6s ease infinite !important;\r\n    }\r\n    .attop-droptarget .add-bt-line:last-child:hover {\r\n        border-right: 0 !important;\r\n    }\r\n    .cherry-pick-icon {\r\n        background: url(\'assets/images/cherry-icon-W.svg\');\r\n        width: 20px;\r\n        height: 20px;\r\n        background-repeat: no-repeat;\r\n        background-size: 20px 20px;\r\n        display: inline-block;\r\n    }\r\n    .msla-icon {\r\n        background: url(\'assets/images/SLA-Icon_white.svg\');\r\n        width: 20px;\r\n        height: 20px;\r\n        background-repeat: no-repeat;\r\n        background-size: 20px 20px;\r\n        display: inline-block;\r\n    }\r\n    .fltr-mdl-worklit-wrapper .k-window-title {\r\n        display: flex;\r\n    }\r\n    .dragging.drag-over {\r\n        background-color: #505050;\r\n        border-color: #484545;\r\n        z-index: 1000 !important;\r\n        padding: 0 5px;\r\n    }\r\n    .rf-accordion .drop-inside\r\n    {\r\n        background-color:red;\r\n    }\r\n   .drop-hv.drag-enter .rf-uibaccr-grp{\r\n        width: 100%;\r\n        height: 100%;\r\n        border: solid 2px #05C1A4;\r\n        color: white;\r\n        text-align: center;\r\n    }\r\n    .drag-enter .active-drag-section {\r\n        opacity: 0.5;\r\n    }\r\n    .drop-hv.drag-enter .rf-uibaccr-grp::before {\r\n        color: white;\r\n        font-size: 20px;\r\n        content: "Drop Here";\r\n        left: 45%;\r\n        position: absolute;\r\n        z-index: 10 !important;\r\n    }\r\n    .custom-overlay {\r\n        background-color: rgba(0,0,0,0.83);\r\n    }\r\n    #sidebar-resizer.wl-menu-left-content-float\r\n    {\r\n        z-index:98;\r\n    }\r\n    #WorklistListsGrid.ag-theme-balham-dark {\r\n        /* bright green, 10% opacity */\r\n        width: 100%;\r\n        --ag-selected-row-background-color: #0c4b42 !important;\r\n    }\r\n        #WorklistListsGrid.ag-theme-balham-dark .ag-checkbox-input-wrapper.ag-checked:after {\r\n            color: #07e6c4;\r\n        }\r\n    #WorklistListsGrid.ag-theme-balham-dark .ag-row {\r\n       border:0 !important;\r\n    }\r\n        #WorklistListsGrid.ag-theme-balham-dark .ag-selection-checkbox\r\n        {\r\n            margin-right:5px;\r\n        }\r\n        .edit-list-icon {\r\n            position: absolute;\r\n            right: 1px;\r\n            top: -1px;\r\n            padding: 1px;\r\n        }\r\n    .ag-row-hover .worklist-hover {\r\n        width: 150px !important;\r\n        display: block;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n    }\r\n    .worklist-list {\r\n        width: 200px;\r\n        display: block;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n    }\r\n    .front {\r\n        display: none;\r\n    }\r\n\r\n    .ag-row-hover .front {\r\n        display: inherit;\r\n    }\r\n    .ag-cell .edit-list-icon {\r\n        background: #3d4749;\r\n    }\r\n    .ag-row-selected .ag-cell .edit-list-icon {\r\n        background: #0c4b42;\r\n    }\r\n    .attop-droptarget #WorklistListsGrid .ag-center-cols-clipper {\r\n        /*height: 105px !important;*/\r\n    }\r\n    .attop-droptarget #WorklistListsGrid .ag-center-cols-container {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        height: auto !important;\r\n        max-height: 350px;\r\n        overflow-y: auto;\r\n    }\r\n    .attop-droptarget #WorklistListsGrid .ag-center-cols-container .ag-row {\r\n        position: relative;\r\n        transform: none !important;\r\n        width: 47%;\r\n        transition: none;\r\n        margin: 3px 0 3px 10px;\r\n    }\r\n    .attop-droptarget #WorklistListsGrid .ag-center-cols-container .ag-row .ag-cell {\r\n        width: 100% !important;\r\n        position: relative !important;\r\n    }\r\n    #RadiologistComponentGroupChat .location-tags-input tags-input .tags.focused {\r\n        border: 1px solid #a9a9a9 !important;\r\n    }\r\n\r\n    #RadiologistComponentGroupChat .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #a9a9a9 !important;\r\n    }\r\n    .location-tags-input tags-input .tags.focused {\r\n        border: 1px solid #424242 !important;\r\n    }\r\n    .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #424242 !important;\r\n    }\r\n    /*new css end*/\r\n    .ag-popup .ag-popup-child[aria-label="Column Menu"] .ag-set-filter-list {\r\n        height: 100%;\r\n        max-height: 200px !important;\r\n        overflow-y: auto;\r\n    }\r\n    .rf-filter > .width-100.tultip-bottom .mult-select.selMod-clearall.ng-empty + .clearSelModValue {\r\n        display: none;\r\n    }\r\n    .search-tab-popup {\r\n        width: 500px;\r\n        height: 400px;\r\n        z-index: 99;\r\n        box-shadow: 0px 5px 10px black;\r\n        background: #343334 !important;\r\n        border-radius: 2px;\r\n        position: fixed;\r\n        top: 92px;\r\n        left: 5px;\r\n    }\r\n        .search-tab-popup .rf-filter-ui .blk-input.form-control,\r\n        .search-tab-popup .rf-filter-ui .mult-select.ui-select-multiple.ui-select-bootstrap,\r\n        .search-tab-popup .rf-filter-ui .sing-select.form-control,\r\n        .search-tab-popup .rf-filter-ui .sweet-alert.show-input fieldset input,\r\n        .search-tab-popup .rf-filter-ui .mult-select.ui-select-container,\r\n        .search-tab-popup .rf-filter-ui .mult-select.ui-select-container .btn.btn-default.form-control,\r\n        .search-tab-popup .rf-filter-ui .loc-input,\r\n        .search-tab-popup .rf-filter-ui .blk-calender .input-group-btn > .btn-default {\r\n            border-color: #9b9b9b !important;\r\n        }\r\n        .search-tab-popup .location-tags-input tags-input .tags {\r\n            border: 1px solid #9b9b9b !important;\r\n        }\r\n        .search-tab-popup .form-control {\r\n            border-color: #9b9b9b !important;\r\n        }\r\n    .quick-search-tab-popup {\r\n        width: 400px;\r\n        height: 460px;\r\n        z-index: 99;\r\n        padding:5px;\r\n        box-shadow: 0px 5px 10px black;\r\n        background: #343334 !important;\r\n        border-radius: 2px;\r\n        position: fixed;\r\n        top: 92px;\r\n        left: 90px;\r\n    }\r\n        .quick-search-tab-popup .panel > .panel-body\r\n        {\r\n            height:415px;\r\n        }\r\n        .quick-search-tab-popup .rf-filter-ui .blk-input.form-control,\r\n        .quick-search-tab-popup .rf-filter-ui .mult-select.ui-select-multiple.ui-select-bootstrap,\r\n        .quick-search-tab-popup .rf-filter-ui .sing-select.form-control,\r\n        .quick-search-tab-popup .rf-filter-ui .sweet-alert.show-input fieldset input,\r\n        .quick-search-tab-popup .rf-filter-ui .mult-select.ui-select-container,\r\n        .quick-search-tab-popup .rf-filter-ui .mult-select.ui-select-container .btn.btn-default.form-control,\r\n        .quick-search-tab-popup .rf-filter-ui .loc-input,\r\n        .quick-search-tab-popup .ui-quick-serach.mult-select.ui-select-container .btn.btn-default.form-control,\r\n        .quick-search-tab-popup .rf-filter-ui .blk-calender .input-group-btn > .btn-default {\r\n            border-color: #9b9b9b !important;\r\n        }\r\n        .quick-search-tab-popup .location-tags-input tags-input .tags {\r\n            border: 1px solid #9b9b9b !important;\r\n        }\r\n        .quick-search-tab-popup .form-control\r\n        {\r\n            border-color: #9b9b9b !important;\r\n        }\r\n        .search-tab-popup .condition-select.form-control:focus , .quick-search-tab-popup .condition-select.form-control:focus {\r\n            border: 1px solid #9b9b9b !important;\r\n        }\r\n    .popup-footer-btn {\r\n        border-top: 1px solid #424242;\r\n        position: absolute;\r\n        bottom: 0;\r\n        left: 0;\r\n        right: 0;\r\n        justify-content: flex-end;\r\n        padding-top: 10px;\r\n        display: flex;\r\n    }\r\n\r\n    .worklist-tab-popup {\r\n        width: 500px;\r\n        height: 400px;\r\n        z-index: 99;\r\n        padding: 5px;\r\n        overflow: hidden;\r\n        box-shadow: 0px 5px 10px black;\r\n        background: #343334 !important;\r\n        border-radius: 2px;\r\n        position: fixed;\r\n        top: 92px;\r\n        left: 175px;\r\n    }\r\n    .attop-droptarget .worklist-tab-popup .search-actions .headtxt {\r\n        padding: 7px 12px !important;\r\n    }\r\n    .selectworklist-wrapper {\r\n        padding: 20px;\r\n        width: 50%;\r\n    }\r\n    .selectworklist-tag {\r\n        padding-left: 12px;\r\n    }\r\n    .selectworklist-tag:before {\r\n        content: \'\';\r\n        width: 6px;\r\n        height: 21px;\r\n        position: absolute;\r\n        top: 8px;\r\n        left: 0;\r\n        background-color: #00C7A6;\r\n    }\r\n    #RuleCondMultiSelectGrid.multiSelectGridDiv, #ExamTagsRuleGrid.multiSelectGridDiv, #SpecialtyRuleDropdown.multiSelectGridDiv, #SpecialtyRuleGrid.multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n    .popover.tour.view-contact-step    \r\n    {\r\n        left:10% !important;\r\n    }\r\n    .popover.tour.type-click-step {\r\n        left: 43% !important;\r\n    } \r\n  \r\n    @media only screen and (min-width: 320px) and (max-width: 1200px) {\r\n        .p-zoom {\r\n                padding: 3px 2px;\r\n            }\r\n\r\n            .wlzoomeffect .imagepending:after {\r\n                content: "IP" !important;\r\n            }\r\n\r\n            .wlzoomeffect .ormpending:after {\r\n                content: "ORM P" !important;\r\n            }\r\n\r\n            .wlzoomeffect .cancel:after {\r\n                content: "CA" !important;\r\n            }\r\n\r\n            .wlzoomeffect .comparison:after {\r\n                content: "Co" !important;\r\n            }\r\n\r\n            /*Bug 19801: The study count is not visible on status*/\r\n            .wlzoomeffect .draft:after {\r\n                content: "D" !important;\r\n            }\r\n\r\n            .wlzoomeffect .complete:after {\r\n                content: "C" !important;\r\n            }\r\n\r\n            .wlzoomeffect .hst:after {\r\n                content: "H" !important;\r\n            }\r\n\r\n            .wlzoomeffect .resultpending:after {\r\n                content: "RP" !important;\r\n            }\r\n\r\n            .wlzoomeffect .rps:after {\r\n                content: "STAT" !important;\r\n            }\r\n\r\n            .wlzoomeffect .st:after {\r\n                content: "ST" !important;\r\n            }\r\n        }\r\n        /*worklist page top btn zoom effect css end*/\r\n\r\n        object {\r\n        min-height: 600px !important;\r\n        max-height: 800px !important;\r\n    }\r\n\r\n    #ModalFileAttachment .modal.fade .modal-dialog {\r\n        background-color: #fff !important;\r\n    }\r\n\r\n    .order_bg_84D9FF {\r\n        background-color: #84D9FF !important;\r\n    }\r\n\r\n    .order_bg_FF685E {\r\n        background-color: #FF685E !important;\r\n    }\r\n\r\n    .order_bg_BFDED6 {\r\n        background-color: #BFDED6 !important;\r\n    }\r\n\r\n    .order_bg_B9ADCF {\r\n        background-color: #B9ADCF !important;\r\n    }\r\n\r\n    .order_bg_75E284 {\r\n        background-color: #75E284 !important;\r\n    }\r\n\r\n    .order_bg_FFC99A {\r\n        background-color: #FFC99A !important;\r\n    }\r\n\r\n    .order_bg_FFE69A {\r\n        background-color: #FFE69A !important;\r\n    }\r\n\r\n    .order_bg_darkseagreen {\r\n        background-color: darkseagreen !important;\r\n    }\r\n\r\n    .order_bg_FBA46E {\r\n        background-color: #FBA46E !important;\r\n    }\r\n\r\n    .st-sort-ascent:before {\r\n        content: \'\\25B2\';\r\n    }\r\n\r\n    .st-sort-descent:before {\r\n        content: \'\\25BC\';\r\n    }\r\n\r\n    .lr-drop-target-before {\r\n        border-left: 2px solid orange;\r\n    }\r\n\r\n    .lr-drop-target-after {\r\n        border-right: 2px solid orange;\r\n    }\r\n    .dr-btn-none{\r\n        display: none;\r\n    }\r\n\r\n\r\n    .context-menu {\r\n        position: absolute;\r\n    }\r\n\r\n        .context-menu .dropdown-menu {\r\n            display: block;\r\n            position: static;\r\n            background-color: #323232 !important;\r\n            background: #323232 !important;\r\n        }\r\n        .context-menu .dropdown-menu li > a {\r\n            color: #05c1a4 !important;\r\n            background-color: transparent !important;\r\n            cursor:pointer;\r\n        }\r\n            .context-menu .dropdown-menu li > a:hover {\r\n                color: #05c1a4 !important;\r\n                background-color: transparent !important;\r\n\r\n            }\r\n\r\n            /*Load More scroll*/\r\n    .st-sort-ascent:before {\r\n        content: \'\\25B2\';\r\n    }\r\n\r\n    .st-sort-descent:before {\r\n        content: \'\\25BC\';\r\n    }\r\n\r\n    .table-container {\r\n        /*height: 500px;\r\n        overflow-y: scroll;*/\r\n    }\r\n\r\n    .loading-indicator {\r\n        box-sizing: border-box;\r\n        -webkit-box-sizing: border-box;\r\n        -moz-box-sizing: border-box;\r\n        width: auto;\r\n        text-align: center;\r\n        padding: 0.7em;\r\n    }\r\n\r\n        .loading-indicator:before {\r\n            display: inline-block;\r\n            margin: 0 0.4em;\r\n            min-width: 1em;\r\n            min-height: 1em;\r\n            border-top: 4px solid #646464;\r\n            border-right: 4px solid #e6e6e6;\r\n            border-left: 4px solid #e6e6e6;\r\n            border-bottom: 4px solid #646464;\r\n            content: "";\r\n            -webkit-animation: halfspin 1s ease infinite;\r\n            -moz-animation: halfspin 1s ease infinite;\r\n            -o-animation: halfspin 1s ease infinite;\r\n            animation: halfspin 1s ease infinite;\r\n            border-radius: 100%;\r\n        }\r\n\r\n    ul.dropdown-menu.contborder li:nth-child(2) a {\r\n        border-top: 1px solid #686868 !important;\r\n    }\r\n\r\n    @-webkit-keyframes halfspin {\r\n        to {\r\n            -webkit-transform: rotate(180deg);\r\n            -moz-transform: rotate(180deg);\r\n            transform: rotate(180deg);\r\n        }\r\n    }\r\n\r\n    @-moz-keyframes halfspin {\r\n        to {\r\n            -webkit-transform: rotate(180deg);\r\n            -moz-transform: rotate(180deg);\r\n            transform: rotate(180deg);\r\n        }\r\n    }\r\n\r\n    @keyframes halfspin {\r\n        to {\r\n            -webkit-transform: rotate(180deg);\r\n            -moz-transform: rotate(180deg);\r\n            transform: rotate(180deg);\r\n        }\r\n    }\r\n    .ui-grid-viewport {\r\n        overflow-anchor: none;\r\n    }\r\n    .ui-grid-row-selected {\r\n        background-color: #424242;\r\n        border-bottom: 1px solid #616161 !important;\r\n    }\r\n    .ui-grid-selection-row-header-buttons.ui-grid-row-selected {\r\n        background-color: #424242;\r\n        border-bottom: 0 !important;\r\n    }\r\n    .expandableRow .ui-grid-render-container-body .ui-grid-viewport {\r\n        overflow: hidden !important;\r\n        /* or use: overflow-x: hide!important; */\r\n    }\r\n\r\n    .ui-grid .ui-grid-render-container-body .ui-grid-viewport:first-child {\r\n        overflow-y: auto !important;\r\n        overflow-x: auto !important;\r\n    }\r\n    .inner {\r\n        box-sizing: border-box;\r\n        overflow: hidden;\r\n        padding: 1em;\r\n        height: 100%;\r\n        width: 100%;\r\n    }\r\n    .waiting {\r\n        cursor: wait !important;\r\n    }\r\n       .quick-search-panel\r\n    {\r\n        background-color:transparent;\r\n        box-shadow:none;\r\n    }\r\n        .quick-search-panel .panel-heading {\r\n            background-color: transparent;\r\n            color: white;\r\n            overflow:hidden\r\n        }\r\n\r\n        .quick-search-panel .panel-heading .panel-title {\r\n            font-weight: 400;\r\n            text-transform: none;\r\n            opacity: 0.9;\r\n        }\r\n    .h-25px\r\n    {\r\n        height:25px !important;\r\n    }\r\n    .ui-quick-serach.mult-select.ui-select-container .btn.btn-default.form-control {\r\n        height: 25px !important;\r\n        padding: 3px 12px !important;\r\n        border-color: #424242 !important;\r\n    }\r\n    .box-shadow-n\r\n    {\r\n        box-shadow: none !important;\r\n    }\r\n    .rf-filter-ui .mult-select.ui-select-multiple.ui-select-bootstrap > div:first-child {\r\n        overflow: hidden\r\n\r\n    }\r\n    .wrklstFilterWraaper .tultip-bottom #locationTreeTooltip.tultiptext, .wrklstFilterWraaper .tultip-bottom .location-tags-input .tultiptext {\r\n        position: fixed;\r\n        top: 170px !important;\r\n        left: 130px;\r\n    }\r\n    .wrklstFilterWraaper .tultip-bottom .location-tags-input .ng-empty + #locationTreeTooltip.tultiptext,\r\n    .wrklstFilterWraaper .tultip-bottom .location-tags-input .ng-empty + .tultiptext {\r\n        top: 140px !important;\r\n    }\r\n    .atright-droptarget .tultip-bottom #locationTreeTooltip.tultiptext, .atright-droptarget .tultip-bottom .location-tags-input .tultiptext {\r\n        position: fixed;\r\n        top: 170px !important;\r\n        right: 0;\r\n        left: unset !important;\r\n        min-width: 150px;\r\n    }\r\n    .atright-droptarget .tultip-bottom .location-tags-input .ng-empty + #locationTreeTooltip.tultiptext,\r\n    .atright-droptarget .tultip-bottom .location-tags-input .ng-empty + .tultiptext {\r\n        top: 140px !important;\r\n    }\r\n    .atright-droptarget .tultip-bottom .siteLocationGridDiv\r\n    {\r\n    right:39px;\r\n    }\r\n    .attop-droptarget .tultip-bottom #locationTreeTooltip.tultiptext, .attop-droptarge .tultip-bottom .location-tags-input .tultiptext {\r\n        left: 150px !important;\r\n    }\r\n    /*Bootstrap Tour*/\r\n    .tour-backdrop {\r\n        opacity: 0.6 !important;\r\n    }\r\n    .popover.tour-tour {\r\n        border-color: #828282;\r\n        background-color: #404040 !important;\r\n    }\r\n    .popover.tour-tour .popover-content {\r\n        color: white;\r\n    }\r\n    .popover.tour-tour .popover-title {\r\n        background-color: transparent !important;\r\n        color: white !important;\r\n        border-bottom: 0;\r\n    }\r\n    .popover-navigation .btn.btn-sm.btn-default\r\n    {\r\n        margin:5px;\r\n    }\r\n    .tour-close {\r\n        font-size: 14px;\r\n        color: #959595 !important;\r\n    }\r\n        .tour-close:hover {\r\n            color: white !important;\r\n        }\r\n    .popover.tour-tour.right > .arrow:after {\r\n        background-image: url(../../assets/images/tooltip-arrow-filled.svg);\r\n        background-repeat: no-repeat;\r\n        width: 15px;\r\n        height: 20px;\r\n        border: none;\r\n        left: -3px;\r\n    }\r\n    .popover.tour-tour.bottom > .arrow:after {\r\n        background-image: url(../../assets/images/tooltip-arrow-filled.svg);\r\n        background-repeat: no-repeat;\r\n        width: 15px;\r\n        height: 24px;\r\n        border: none;\r\n        top: -9px;\r\n        transform: rotate(90deg);\r\n    }\r\n    .popover.tour-tour.left > .arrow:after {\r\n        background-image: url(../../assets/images/tooltip-arrow-filled.svg);\r\n        background-repeat: no-repeat;\r\n        width: 15px;\r\n        height: 24px;\r\n        border: none;\r\n        right: -4px;\r\n        transform: rotate(180deg);\r\n    }\r\n    .popover.tour-tour.top > .arrow:after {\r\n        background-image: url(../../assets/images/tooltip-arrow-filled.svg);\r\n        background-repeat: no-repeat;\r\n        width: 15px;\r\n        height: 24px;\r\n        border: none;\r\n        bottom: -9px;\r\n        transform: rotate(271deg);\r\n    }\r\n    .tour-nxt-btns {\r\n        display: flex;\r\n        height: 23px;\r\n        border-radius: 3px;\r\n        align-items: center;\r\n    }\r\n    .tour-back-btns {\r\n        height: 23px;\r\n        border-radius: 3px !important;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .step-header {\r\n        background-color: #373737;\r\n        font-weight: 600;\r\n    }\r\n    .tour-section-disbl {\r\n        pointer-events: none;\r\n        opacity: 0.9;\r\n    }\r\n    /*Highlight Steps End*/\r\n    /*filter panel docking css start*/\r\n    .atright-droptarget {\r\n        height: 100%;\r\n        width: 280px;\r\n        background: #000;\r\n        position: relative;\r\n        display: none;\r\n    }\r\n\r\n    .attop-droptarget {\r\n        width: 100%;\r\n        height: 157px;\r\n        /*height:136px;*/\r\n        overflow: hidden;\r\n        position: relative;\r\n        display: none;\r\n    }\r\n\r\n        .attop-droptarget.inActive,\r\n        .attop-droptarget.outActive.atTopsetHght,\r\n        .attop-droptarget.outActive.searcHideHeight,\r\n        .attop-droptarget.outActive.docrtop-height {\r\n            /*max-height: 128px;*/\r\n            max-height: 35px;\r\n            height: auto;\r\n        }\r\n        .outActive {\r\n            border: 1px solid #047463;\r\n        }\r\n    /*.outActive::after {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        z-index: 1;\r\n        color: #05C1A4;\r\n        font-size: 16px;\r\n        transform: translate(-50%,-50%);\r\n        content: "Drop here";\r\n    }*/\r\n    /*.atright-droptarget.outActive::after,\r\n    .attop-droptarget.outActive::after,\r\n    .wrklstFilterWraaper.outActive::after {\r\n        display:none;\r\n    }*/\r\n    .atright-droptarget.outActive,\r\n    .atright-droptarget.inActive,\r\n    .attop-droptarget.outActive,\r\n    .attop-droptarget.inActive {\r\n        display: block !important;\r\n    }\r\n\r\n    .atright-droptarget.inActive,\r\n    .atright-droptarget.docright-width {\r\n        max-width: 338px;\r\n        width: auto;\r\n    }\r\n\r\n        .atright-droptarget.outActive + #sidebar-resizer,\r\n        .attop-droptarget.outActive + #sidebar-resizer,\r\n        .atright-droptarget.inActive + #sidebar-resizer,\r\n        .attop-droptarget.inActive + #sidebar-resizer,\r\n        .attop-droptarget.inActive + .pportal-list #sidebar-resizer,\r\n        .attop-droptarget.outActive + .pportal-list #sidebar-resizer {\r\n            display: none;\r\n        }\r\n\r\n    .wrklstFilterWraaper.outActive {\r\n        height: 100%;\r\n        width: 320px;\r\n        position: relative;\r\n    }\r\n\r\n    .wrklstFilterWraaper.inActive, .atright-droptarget.inActive,\r\n    .attop-droptarget.inActive {\r\n        display: block !important;\r\n    }\r\n\r\n    .atright-droptarget.outActive,\r\n    .attop-droptarget.outActive,\r\n    .wrklstFilterWraaper.outActive {\r\n        background-color: #000;\r\n        border: 0;\r\n        /*border: 1px solid #047463;\r\n        border-radius: 3px;*/\r\n    }\r\n\r\n    .atright-droptarget .drag-fltrpanel {\r\n        display: flex;\r\n        flex-direction: row-reverse;\r\n    }\r\n\r\n    .drag-fltrpanel {\r\n        height: 100%;\r\n        cursor:grab;\r\n    }\r\n    .attop-droptarget .drag-fltrpanel {\r\n        max-height: 26px;\r\n        height: 100%;\r\n        width: 100%;\r\n        display: inline-block;\r\n    }\r\n    .atright-droptarget .wl-menu-left-content {\r\n        border-left: 1px solid #b3adad;\r\n        border-right: 0;\r\n    }\r\n\r\n    .atright-droptarget .wl-menu-left-content-float {\r\n        left: auto;\r\n        right: 30px;\r\n    }\r\n\r\n    .atright-droptarget .blk-calender.set-pos-fixed .uib-datepicker-popup.dropdown-menu {\r\n        top: 410px !important;\r\n        left: unset !important;\r\n        right: 20px;\r\n    }\r\n\r\n    .attop-droptarget .wl-tab-left {\r\n        width: 100%;\r\n        height: auto;\r\n        border: 0;\r\n        border-top: 1px solid #7f7f7f;\r\n        padding: 3px !important;\r\n        border-bottom: 1px solid #7f7f7f;\r\n    }\r\n\r\n    .attop-droptarget .wl-tab-left span {\r\n        width: auto;\r\n        padding: 0 !important;\r\n        border-right: 0 !important;\r\n        margin: 0 0 5px 18px !important;\r\n    }\r\n\r\n            .attop-droptarget .wl-tab-left span.btn-primary,\r\n            .attop-droptarget .wl-tab-left span.btn-default {\r\n                font-size: 12px;\r\n            }\r\n\r\n            .attop-droptarget .wl-tab-left span:first-child {\r\n                margin-left: 12px !important;\r\n                padding-left: 0 !important;\r\n            }\r\n\r\n            .attop-droptarget .wl-tab-left span .fa {\r\n                padding-right: 5px !important;\r\n            }\r\n\r\n    .attop-droptarget .writemode-lr {\r\n        writing-mode: horizontal-tb;\r\n    }\r\n\r\n    .attop-droptarget .wltabactive {\r\n        border-right: 0 !important;\r\n        border-bottom: 2px solid #05C1A4 !important;\r\n    }\r\n\r\n    .attop-droptarget .wl-menu-left-content {\r\n        width: 100%;\r\n        border-top: 0;\r\n        /*height: 100% !important;*/\r\n    }\r\n\r\n    .attop-droptarget .mb-5px.search-actions {\r\n        margin-bottom: 2px !important;\r\n    }\r\n\r\n    .attop-droptarget .search-actions .headtxt {\r\n        padding: 3px 12px;\r\n        font-size: 12px !important;\r\n        background-color: #323232;\r\n    }\r\n\r\n        .attop-droptarget .search-actions .headtxt span.txt-clr-1 {\r\n            color: #05c1a4 !important;\r\n            font-weight: 600;\r\n        }\r\n\r\n    .attop-droptarget .search-actions {\r\n        /*display: none;*/\r\n    }\r\n\r\n    .attop-droptarget .rf-filter {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        /*overflow: hidden;*/\r\n        margin-bottom: 0 !important;\r\n        margin-top: 4px !important;\r\n    }\r\n\r\n    .search-tab-popup #NewWorklistFilterlocationTooltip.tultiptext {\r\n        top: 100% !important;\r\n    }\r\n    .attop-droptarget .rf-filter > .width-100 {\r\n        width: 49%;\r\n    }\r\n        .attop-droptarget .rf-filter > .width-100:nth-child(odd) {\r\n           margin-right:5px;\r\n        }\r\n\r\n    .attop-droptarget .wl-menu-left-content {\r\n        width:100% !important;\r\n        border: 0;\r\n    }\r\n\r\n    .attop-droptarget .wl-menu-left-content .filtsecion, .attop-droptarget .leftpanel-drop,\r\n    .attop-droptarget .wl-tabcontent.search-wlheight {\r\n        height: 100% !important;\r\n    }\r\n\r\n        .attop-droptarget .wl-menu-left-content .filtsecion {\r\n            /*max-height: 105px;*/\r\n            max-height: 105px;\r\n        }\r\n    .attop-droptarget .ui-select-bootstrap > .ui-select-choices {\r\n        position: fixed !important;\r\n        left: auto;\r\n        top: auto !important;\r\n        width: 100%;\r\n        max-width: 124px;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .ui-select-bootstrap .ui-select-toggle > a.btn {\r\n        top:3px;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .mult-select input.form-control.ui-select-search {\r\n        height:25px !important;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .ui-select-bootstrap > .ui-select-choices {\r\n        max-width: 150px;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .ui-select-bootstrap.selMod-clearall > .ui-select-choices {\r\n        max-width: 153px;\r\n        transform: translateX(-12px);\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-modality .clearSelModValue {\r\n        top: 0 !important;\r\n    }\r\n    .attop-droptarget .rf-filter > .width-100.tultip-bottom:nth-child(4) .ui-select-bootstrap > .ui-select-choices {\r\n        max-width: 160px;\r\n        transform: translateX(-12px);\r\n    }\r\n    .attop-droptarget .blk-calender.set-pos-fixed .uib-datepicker-popup.dropdown-menu {\r\n        top: inherit !important;\r\n        left: inherit !important;\r\n        transform: translateY(27px);\r\n    }\r\n\r\n    .attop-droptarget .width-100 .tultip-bottom .location-tags-input .tultiptext {\r\n        position: fixed;\r\n        bottom: inherit;\r\n        max-width: 180px;\r\n        left: 152px !important;\r\n        transform: translate(-140px, 30px);\r\n        top: 150px !important;\r\n    }\r\n    .attop-droptarget .search-tab-popup .location-tags-input tags-input.ng-empty + #NewWorklistFilterlocationTooltip.tultiptext {\r\n        top: 140px !important;\r\n    }\r\n    .attop-droptarget .search-tab-popup .location-tags-input #NewWorklistFilterlocationTooltip.tultiptext {\r\n        top: 166px !important;\r\n    }\r\n    .attop-droptarget .wl-menu-left-content-float {\r\n        left: unset;\r\n        z-index: unset;\r\n        position: unset;\r\n    }\r\n\r\n    .attop-droptarget .leftpanel-drop {\r\n        display: inline-block;\r\n        height: auto !important;\r\n    }\r\n\r\n    .attop-droptarget .leftpanel-drop li {\r\n        float: left;\r\n        margin-right: 10px;\r\n        width: 13%;\r\n        margin-bottom: 15px;\r\n        border-right: 1px solid #666565;\r\n    }\r\n\r\n    .attop-droptarget .leftpanel-drop li .sidebar-lists-content {\r\n        width: 175px;\r\n        margin-right: 10px;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    .attop-droptarget .leftpanel-drop li .fa.fa-trash-o,\r\n    .attop-droptarget .leftpanel-drop li .glyphicon.glyphicon-pencil {\r\n        font-size: 12px !important;\r\n    }\r\n\r\n    .attop-droptarget .leftpanel-drop li .glyphicon.glyphicon-pencil {\r\n        font-size: 10px !important;\r\n    }\r\n\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel.panel {\r\n        margin-bottom: 0 !important;\r\n    }\r\n\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .panel-heading {\r\n        height:19px !important;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .panel-title {\r\n        opacity: 1;\r\n        line-height: 10px;\r\n    }\r\n\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .panel-title a {\r\n        pointer-events: none;\r\n        font-size: 12px !important;\r\n        font-weight: 600 !important;\r\n        padding-left: 6px;\r\n    }\r\n\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .attop-fltr-srch {\r\n        position: fixed !important;\r\n    }\r\n    .attop-droptarget #frmFilter.locanotempty + #frmQuickFilter .quick-search-panel .attop-fltr-srch {\r\n        top: 140px;\r\n        right:30px;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .attop-fltr-srch::before {\r\n        content: \'\';\r\n        width: 100%;\r\n        height: 26px;\r\n        background: transparent;\r\n        position: absolute;\r\n        top: -26px;\r\n        left: 0;\r\n        right: 0;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .stepQuickFilter:hover + .attop-fltr-srch.ng-hide,\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .attop-fltr-srch.ng-hide:hover {\r\n        display: block !important;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .panel-title a .fa-caret-down {\r\n        transform: rotate(272deg) translateX(3px);\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .panel-title a .fa {\r\n        display: none;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .mult-select.clearallAcDc {\r\n        position: absolute;\r\n        top: -25px;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .mult-select.clearallAcDc.ng-empty {\r\n        top: 0;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .tultip-top .selMod-clearall + .clearSelModValue + .tultiptext {\r\n        bottom: unset;\r\n        top: inherit;\r\n        position: fixed !important;\r\n        left: inherit;\r\n        transform: translate(10px, 1px);\r\n    }\r\n\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel .tultip-top .selMod-clearall.clearallAcDc + .clearSelModValue + .tultiptext {\r\n        transform: translate(10px, 28px);\r\n    }\r\n\r\n    .attop-droptarget.inActive + .pportal-list,\r\n    .attop-droptarget.outActive + .pportal-list {\r\n        overflow-x: hidden;\r\n        overflow-y: hidden;\r\n        /*height: calc(100vh - 225px);*/\r\n    }\r\n  /*  .attop-droptarget.inActive + .pportal-list .wl-menu-right-float,\r\n    .attop-droptarget.outActive + .pportal-list .wl-menu-right-float,\r\n    .attop-droptarget.outActive + .pportal-list .wl-menu-right-half {\r\n        height: calc(100vh - 59px);\r\n    }\r\n    .attop-droptarget.searcHideHeight.inActive + .pportal-list .wl-menu-right-float,\r\n    .attop-droptarget.searcHideHeight.outActive + .pportal-list .wl-menu-right-float {\r\n        height: calc(100vh - 89px);\r\n    }\r\n\r\n    .attop-droptarget.inActive + .pportal-list .outer-section .wl-menu-right-full,\r\n    .attop-droptarget.inActive + .pportal-list .wl-menu-right-half{\r\n        width: 100% !important;\r\n        height: calc(100vh - 95px);\r\n    }*/\r\n        .attop-droptarget.inActive + .pportal-list .outer-section .wl-menu-right-full,\r\n        .attop-droptarget.inActive + .pportal-list .wl-menu-right-half {\r\n            width: 100% !important;\r\n        }\r\n\r\n        .attop-droptarget.inActive + .pportal-list .outer-section {\r\n            height: calc(100vh - 92px) !important;\r\n        }\r\n        .attop-droptarget.inActive .wl-tabcontent.wrklst-wlheight {\r\n        height: auto !important;\r\n    }\r\n\r\n    .attop-droptarget .wl-tabcontent.wrklst-wlheight .leftpanel-drop {\r\n        height: 105px !important;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .attop-droptarget.atTopsetHght.inActive + .pportal-list .wl-menu-right-float,\r\n    .attop-droptarget.atTopsetHght.outActive + .pportal-list .wl-menu-right-float,\r\n    .attop-droptarget.atTopsetHght.inActive + .pportal-list .wl-menu-right-half,\r\n    .attop-droptarget.atTopsetHght.outActive + .pportal-list .wl-menu-right-half {\r\n        height: calc(100vh - 85px);\r\n    }\r\n\r\n    .attop-droptarget .rf-filter .blk-calender input.form-control {\r\n        height: 30px !important;\r\n    }\r\n\r\n    .DOSAtTop .daterangepicker.drop-up {\r\n        top: 320px !important\r\n    }\r\n\r\n    .daterangepicker.drop-up:after,\r\n    .daterangepicker.drop-up:before,\r\n    .daterangepicker.opensright:after,\r\n    .daterangepicker.opensright:before {\r\n        display: none !important;\r\n    }\r\n\r\n    .blk-calender.set-pos-fixed.quicksearch-dob .uib-datepicker-popup.dropdown-menu {\r\n        /* position: fixed;\r\n        top: inherit !important;\r\n        left: inherit !important;\r\n        transform: translate(0px, 35px);*/\r\n    }\r\n    .attop-droptarget .stepPinWorklist {\r\n        display: none\r\n    }\r\n    .attop-droptarget.outActive + .pportal-list .outer-section .wl-menu-right-float,\r\n    .attop-droptarget.outActive + .pportal-list .outer-section .wl-menu-right-full {\r\n        width: 100% !important;\r\n    }\r\n    .ag-overlay {\r\n        background: rgba(0, 0,0, 0.8);\r\n    }\r\n    .ag-overlay-loading-center {\r\n        padding: 10px !important;\r\n        background: transparent !important;\r\n    }\r\n    .attop-droptarget #frmQuickFilter .quick-search-panel span.ui-select-match-item.btn.btn-default.btn-xs {\r\n        padding: 2px 4px !important;\r\n    }\r\n    /*filter panel docking css end*/\r\n    /*panel docking & highlight steps css Start*/\r\n    .DOSAtTop .dt-WorklistPan {\r\n        top: 100px !important;\r\n        left: 0 !important;\r\n    }\r\n        .DOSAtTop .dt-WorklistPan .arrow {\r\n            top: -7px !important;\r\n            left: 7% !important;\r\n            transform: rotate(90deg) !important;\r\n        }\r\n    .DOSAtTop .dt-QuickSearch {\r\n        top: 100px !important;\r\n        left: 20px !important;\r\n    }\r\n\r\n    .DOSAtTop .dt-QuickSearch .arrow {\r\n        top: -7px !important;\r\n        left: 30% !important;\r\n        transform: rotate(90deg) !important;\r\n    }\r\n    .DOSAtTop .dt-QuickFliter{\r\n        top: 0 !important;\r\n        bottom: unset;\r\n    }\r\n        .DOSAtTop .dt-QuickFliter .arrow {\r\n            top: 41.1111% !important;\r\n        }\r\n    /*panel docking & highlight steps css End*/\r\n    .quick-modality ::-webkit-scrollbar {\r\n        width: 5px; /* Set the width of the scrollbar */\r\n    }\r\n\r\n    .quick-modality ::-webkit-scrollbar-thumb {\r\n        background-color: #ccc;\r\n        border: 1px solid #ccc;\r\n    }\r\n    .quick-modality ::-webkit-scrollbar-track {\r\n        border: none;\r\n        background-color: transparent;\r\n    }\r\n    .quick-modality .location-tags-input tags-input .tags .input\r\n{\r\n        height:17px;\r\n    }\r\n    @media only screen and (max-width: 1680px) {\r\n        .attop-droptarget .leftpanel-drop li .sidebar-lists-content\r\n        {\r\n            width:160px;\r\n        }\r\n        .attop-droptarget .leftpanel-drop li\r\n        {\r\n            width:16%;\r\n        }\r\n    }\r\n    @media only screen and (min-width: 1199px) and (max-width: 1440px) {\r\n        .attop-droptarget .leftpanel-drop li {\r\n            width: 19%;\r\n        }\r\n    }\r\n    @media only screen and (max-width: 1199px) {\r\n        .attop-droptarget .leftpanel-drop li {\r\n            width: 23%;\r\n        }\r\n    }\r\n    @media only screen and (max-width: 980px) {\r\n        .attop-droptarget .leftpanel-drop li {\r\n            width: 30%;\r\n        }\r\n    }\r\n    @media screen and (max-height: 910px) {\r\n        .k-widget.k-window {\r\n            top: 50px !important;\r\n        }\r\n        .denial-window.onmodal-worklist .myGrid .ag-root-wrapper .ag-root-wrapper-body.ag-layout-normal {\r\n            height: unset;\r\n            max-height: 600px;\r\n        }\r\n        .denial-window.onmodal-worklist .myGrid .ag-ltr .ag-body-viewport {\r\n            height: unset !important;\r\n            max-height: 565px;\r\n        }\r\n    }\r\n    @media screen and (max-height: 780px) {\r\n        .k-widget.k-window {\r\n            top: 30px !important;\r\n        }\r\n\r\n        .denial-window.onmodal-worklist .myGrid .ag-root-wrapper .ag-root-wrapper-body.ag-layout-normal {\r\n            height: unset;\r\n            max-height: 500px;\r\n        }\r\n\r\n        .denial-window.onmodal-worklist .myGrid .ag-ltr .ag-body-viewport {\r\n            height: unset !important;\r\n            max-height: 465px;\r\n        }\r\n        .blk-calender.set-pos-fixed .uib-datepicker-popup.dropdown-menu {\r\n            top: 300px !important;\r\n        }\r\n        .atright-droptarget .blk-calender.set-pos-fixed .uib-datepicker-popup.dropdown-menu {\r\n            top: 300px !important;\r\n            left: unset !important;\r\n            right: 20px;\r\n        }\r\n        .DOSAtTop .dt-colManage .arrow {\r\n            top: 140px !important;\r\n            left: -5px !important;\r\n            transform: rotate(270deg) !important;\r\n        }\r\n\r\n        .DOSAtTop .dt-colManage {\r\n            top: 100px !important;\r\n            left: 40px !important;\r\n        }\r\n        .DOSAtTop .dt-gridSetting .arrow {\r\n            top: 140px !important;\r\n            left: -5px !important;\r\n            transform: rotate(270deg) !important;\r\n        }\r\n\r\n        .DOSAtTop .dt-gridSetting {\r\n            top: 100px !important;\r\n            left: 40px !important;\r\n        }\r\n        .DOSAtTop .dt-actionMenu .arrow {\r\n            top: 175px !important;\r\n            left: -5px !important;\r\n            transform: rotate(270deg) !important;\r\n        }\r\n\r\n        .DOSAtTop .dt-actionMenu {\r\n            top: 100px !important;\r\n            left: 50% !important;\r\n        }\r\n        .dt-QuickFliter\r\n        {\r\n            top:unset !important;\r\n            bottom:0;\r\n        }\r\n    }\r\n    @media only screen and (min-width:768px) and (max-width: 1199px) {\r\n\r\n        .attop-droptarget #frmQuickFilter .quick-search-panel .panel-body {\r\n            flex-wrap: wrap;\r\n        }\r\n        .attop-droptarget.inActive,\r\n        .attop-droptarget.outActive,\r\n        .attop-droptarget.outActive.atTopsetHght,\r\n        .attop-droptarget.outActive.searcHideHeight,\r\n        .attop-droptarget.outActive.docrtop-height {\r\n            max-height: 30px;\r\n            /*max-height: 166px;*/\r\n        }\r\n        .attop-droptarget .wl-tabcontent.search-wlheight {\r\n            overflow-y: auto !important;\r\n            max-height: 205px !important;\r\n        }\r\n        .attop-droptarget {\r\n            height: 225px;\r\n        }\r\n            .attop-droptarget .leftpanel-drop li {\r\n                width: 30%;\r\n            }\r\n            .attop-droptarget .wl-menu-left-content .filtsecion,\r\n            .attop-droptarget .wl-menu-left-content-float {\r\n                height: auto !important;\r\n                 overflow-y: hidden !important;\r\n                 max-height: unset !important;\r\n                /*max-height: 175px;*/\r\n            }\r\n            .attop-droptarget #frmQuickFilter .quick-search-panel .attop-fltr-srch {\r\n                transform: translate(-18px, -55px);\r\n            }\r\n            .attop-droptarget .mult-select.clearallAcDc > div {\r\n                display: flex;\r\n            }\r\n            .attop-droptarget .mult-select.clearallAcDc input.ui-select-search {\r\n                /*width: 68px !important;*/\r\n                width:100% !important;\r\n                flex:1;\r\n            }\r\n            .attop-droptarget #frmQuickFilter .mult-select.clearallAcDc input.ui-select-search {\r\n                width: 86px !important;\r\n            }\r\n            .attop-droptarget #frmQuickFilter .quick-search-panel .panel-body .mult-select.ui-select-multiple.ui-select-bootstrap.selMod-clearall .ui-select-search.input-xs {\r\n                width: 100% !important;\r\n                flex:1;\r\n            }\r\n            .attop-droptarget #frmQuickFilter .quick-search-panel .panel-body .quick-modality .clearSelModValue {\r\n                top: 50% !important;\r\n                transform: translateY(-50%);\r\n            }\r\n            .attop-droptarget #frmQuickFilter .quick-search-panel .mult-select.clearallAcDc {\r\n                position: absolute;\r\n                top: -5px;\r\n            }\r\n            .attop-droptarget #frmQuickFilter .selMod-clearall .ui-select-match,\r\n            .attop-droptarget .selMod-clearall .ui-select-match {\r\n                padding-right: 0px;\r\n                max-width: 52px;\r\n            }\r\n            .attop-droptarget #frmQuickFilter .quick-search-panel .mult-select .ui-select-match-item.btn.btn-default.btn-xs {\r\n                padding: 0 4px !important;\r\n                margin-bottom: 2px !important;\r\n            }\r\n            .attop-droptarget .mult-select.ui-select-multiple.ui-select-bootstrap {\r\n                padding: 4px 3px 0 6px !important;\r\n            }\r\n            .attop-droptarget #frmQuickFilter .quick-search-panel .panel-body .width-100.quick-modality .mult-select.ui-select-multiple.ui-select-bootstrap {\r\n                padding: 1px 3px 0 8px !important;\r\n            }\r\n            .attop-droptarget.inActive + .pportal-list,\r\n            .attop-droptarget.outActive + .pportal-list {\r\n                /*height: calc(100vh - 290px);*/\r\n            }\r\n               /* .attop-droptarget.inActive + .pportal-list .wl-menu-right-float,\r\n                .attop-droptarget.outActive + .pportal-list .wl-menu-right-float,\r\n                .attop-droptarget.inActive + .pportal-list .wl-menu-right-half,\r\n                .attop-droptarget.outActive + .pportal-list .wl-menu-right-half {\r\n                    height: calc(100vh - 70px);\r\n                }*/\r\n          /*  .attop-droptarget.inActive.atTopsetHght + .pportal-list .wl-menu-right-float,\r\n            .attop-droptarget.outActive.atTopsetHght + .pportal-list .wl-menu-right-float,\r\n            .attop-droptarget.inActive.atTopsetHght + .pportal-list .wl-menu-right-half,\r\n            .attop-droptarget.outActive.atTopsetHght + .pportal-list .wl-menu-right-half,\r\n            .attop-droptarget.inActive.atTopsetHght + .pportal-list .wl-menu-right-full,\r\n            .attop-droptarget.outActive.atTopsetHght + .pportal-list .wl-menu-right-full {\r\n                height: calc(100vh - 70px);\r\n            }*/\r\n            .attop-droptarget .wl-tabcontent.wrklst-wlheight .leftpanel-drop {\r\n                /*height: auto !important;*/\r\n                max-height: 185px;\r\n            }\r\n        .atright-droptarget .blk-calender.set-pos-fixed .uib-datepicker-popup.dropdown-menu {\r\n            top: 433px !important;\r\n            left: 71% !important;\r\n            right:unset;\r\n        }\r\n        .DOSAtTop .daterangepicker.drop-up {\r\n            top: 320px !important;\r\n        }\r\n        .attop-droptarget.inActive + .pportal-list .wl-menu-right,\r\n        .attop-droptarget.outActive + .pportal-list .wl-menu-right {\r\n            /*overflow-y: hidden;*/\r\n        }\r\n        .attop-droptarget.inActive + .pportal-list,\r\n        .attop-droptarget.outActive + .pportal-list {\r\n            overflow-y: hidden;\r\n        }\r\n        .attop-droptarget .width-100.tultip-bottom:first-child:hover .tultiptext {\r\n            transform: translate(-206px, 30px);\r\n        }\r\n        .tultip-bottom .tultiptext {\r\n            transform: translateX(-86%);\r\n        }\r\n        .tultip-bottom .tultiptext#OrderDiscussionAssignmentTooltip {\r\n            transform: none;\r\n            left: 0 !important;\r\n        }\r\n        .attop-droptarget .drag-fltrpanel {\r\n            max-height: 225px;\r\n            height: 100%;\r\n        }\r\n        .wrklstFilterWraaper .tultip-bottom #locationTreeTooltip.tultiptext, .wrklstFilterWraaper .tultip-bottom .location-tags-input .tultiptext {\r\n            left: 200px !important;\r\n        }\r\n        .attop-droptarget .tultip-bottom #locationTreeTooltip.tultiptext, .attop-droptarget .tultip-bottom .location-tags-input .tultiptext {\r\n            left: 180px !important;\r\n            top: 55px !important;\r\n        }\r\n       /* .attop-droptarget #WorklistListsGrid .ag-center-cols-container .ag-row {\r\n            width: 22%;\r\n        }\r\n        .attop-droptarget .wl-tabcontent.wrklst-wlheight #WorklistListsGrid.leftpanel-drop {\r\n            height: 177px !important;\r\n        }\r\n        .attop-droptarget #WorklistListsGrid .ag-center-cols-container {\r\n            max-height: 160px;\r\n        }*/\r\n        .attop-droptarget #frmFilter.locanotempty + #frmQuickFilter .quick-search-panel .attop-fltr-srch {\r\n            top: 240px;\r\n            right: 5px;\r\n        }\r\n        .selectworklist-wrapper {\r\n            width: 80%;\r\n        }\r\n        .selectworklist-tag {\r\n            font-size: 20px !important;\r\n        }\r\n    }\r\n    .eleDropped {\r\n        display: none;\r\n    }\r\n    .eleDropped.inActive, .eleDropped.outActive {\r\n        display: block !important;\r\n    }\r\n    .loc-width-55\r\n    {\r\n        width:50%;\r\n    }\r\n    .loc-width-0\r\n    {\r\n        width:0;\r\n    }\r\n     .btn-primary.jump-onstep {\r\n        background: none !important;\r\n        border: 0;\r\n        border-bottom: 1px solid #646464 !important;\r\n        border-radius: 0 !important;\r\n        width: 94%;\r\n        text-align: left;\r\n        margin: 0 10px !important;\r\n        margin-bottom: 4px !important;\r\n        padding: 4px 4px !important;\r\n        box-sizing: border-box;\r\n        height: auto !important;\r\n        box-shadow: none !important;\r\n    }\r\n    .btn-primary.jump-onstep:hover {\r\n        background: #515151 !important;\r\n    }\r\n    .popchatui .sendercomment, .popchatui .receivercomment {\r\n        word-break: break-word;\r\n    }\r\n</style><script id="template_tooltip" type="text/x-kendo-template"><div>#:value ? value : "N/A" #</div></script><div keyboard="keys" id="worklistdata"><div class="radf-header wroklist-wrapper" keyboard="keys"><worklist-page-header worklist-page-header-parameter="WorklistPageHeaderParameter" bonus-details="WorklistPageHeaderParameter.BonusDetails" on-tour-click="restartTour()" on-status-click="setStatus()" on-user-payment-click="getUserPayments()" on-refresh-click="RefreshSignSummary()" is-refreshing="IsRefreshingSignSummary"></worklist-page-header></div><div class="attop-droptarget eleDropped" id="dropToTop" ondrop="drop(event)" ondragover="allowDrop(event)"></div><div class="pportal-list" id="mainDiv"><div ng-if="isUserGuideVisible" class="spinner-overlay" style="z-index: 80;"><div class="spinner-overlay-body text-center" style="opacity: 1 !important;"><i class="fa fa-close" titlt="Close" style="color: #1ddcbe; font-size: 35px; position: absolute; top: 50px; right: 25px;" ng-click="HideUserGuideVisible()"></i> <img src="assets/images/worklistasyncguide.png" style="width:90%; margin-top: 20px;"></div></div><div class=""><div style="background-color:#262526!important;" class="d-none"><div class="progress m-0 h-5px" style="background-color:#262526!important;"><div ng-if="isLoading" class="progress-bar progress-bar-striped active w-100" style="background-color:#45857b;" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div></div><div class="outer-section"><div id="wrklstFilterWraaper" class="wrklstFilterWraaper eleDropped" ondrop="drop(event)" ondragover="allowDrop(event)"><div class="drag-fltrpanel eleDraggable" ng-class="{\'stepWorklistPan\' :DataObject.DockerPosition != \'Top\'}" draggable="true" ondragstart="drag(event)" ondragend="dragEnd(event)" id="dragtarget"><div class="wl-tab-left pt-20px"><span class="btn-default btn-primary p-0 writemode-lr add-bt-line" ng-class="{\'wltabactive\':DataObject.wlTabName==\'Search\' , \'stepWorklistPan\' :DataObject.DockerPosition == \'Top\'}" style="margin: 0 0 20px 0;" ng-click="setWorklistTab(\'Search\')"><i class="fa fa-filter" style="padding: 0 0 5px 0;"></i>Search</span> <span class="btn-default btn-primary p-0 writemode-lr add-bt-line stepQuickSearch" ng-class="{\'wltabactive\':DataObject.wlTabName==\'Quick Search\'}" style="margin: 0 0 20px 0;" ng-click="setWorklistTab(\'Quick Search\')" ng-if="DataObject.DockerPosition == \'Top\'"><i class="fa fa-filter" style="padding: 0 0 5px 0;"></i>Quick Search</span> <span class="btn-default btn-primary p-0 writemode-lr add-bt-line" ng-class="{\'wltabactive\':DataObject.wlTabName==\'Worklist\', \'stepNewWorklist\' :DataObject.DockerPosition == \'Top\'}" style="margin: 0 0 20px 0;" ng-click="setWorklistTab(\'Worklist\')"><i class="fa fa-th" style="padding: 0 0 5px 0;"></i>Worklist</span> <span class="btn-default btn-primary p-0 writemode-lr add-bt-line" ng-class="{\'wltabactive\':DataObject.WorklistPopupTitle==rule.RuleName, \'stepCherryPan\' :rule.RuleName === \'Cherry Pick\', \'stepMissedPan\' :rule.RuleName === \'Missed SLA\', \'stepClipboardPan\' :rule.RuleName === \'My ClipBoard\'}" style="margin: 0 0 20px 0;" ng-click="viewGlobalRuleWorklist(rule)" ng-repeat="rule in DataObject.GlobalRules" ng-if="rule.IsEnabled && (rule.WorklistType != 51 || DataObject.OverdueReadsCount > 0)"><span ng-if="rule.WorklistType != 31 && rule.WorklistType != 51"><img src="assets/images/cherry-icon-W.svg" ng-if="rule.RuleName === \'Cherry Pick\'" style="width:20px;height:20px;padding-right:5px;padding-bottom:5px;"> <img src="assets/images/SLA-Icon_white.svg" ng-if="rule.RuleName === \'Missed SLA\'" style="width: 22px; height: 22px; padding-right: 5px; padding-bottom: 5px;"> {{rule.RuleName}}</span> <span ng-if="rule.WorklistType == 31 && DataObject.IsAddendumRequestVisible">{{rule.RuleName}}<span class="adm-count-tag d-inline-block pos-abs txt-clr-1 fw-500 fs-9px" ng-if="rule.WorklistType == 31 && (DataObject.PendingAddendumCount && DataObject.PendingAddendumCount > 0)">{{DataObject.PendingAddendumCount}}</span></span> <span ng-if="rule.WorklistType == 51">{{rule.RuleName}}<span class="overdue-ball" ng-if="DataObject.OverdueReadsCount > 0"></span></span></span></div><div id="leftSidebarSection" class="" ng-class="{\'d-none\':!DataObject.wlTabName, \'wl-menu-left-content-float\':DataObject.iswlTabAutoHide , \'wl-menu-left-content\' : (DataObject.DockerPosition && (DataObject.DockerPosition == \'Left\' || DataObject.DockerPosition == \'Right\'))}"><div id="search" class="" ng-class="{\'wl-tabcontent search-wlheight\': (DataObject.DockerPosition == \'Left\' || DataObject.DockerPosition == \'Right\'),\'search-tab-popup\' : (DataObject.DockerPosition == \'Top\'), \'quick-search-tab-popup\' : (DataObject.DockerPosition == \'Top\' && DataObject.wlTabName==\'Quick Search\')}" ng-if="DataObject.wlTabName==\'Search\' || DataObject.wlTabName==\'Quick Search\'"><div class="text-right mb-5px search-actions overflow-hide-all"><div class="headtxt" ng-if="DataObject.DockerPosition && (DataObject.DockerPosition == \'Left\' || DataObject.DockerPosition == \'Right\')"><span class="txt-clr-1 pull-left">Search</span> <span class="sidebaricons cursor-pointer icon-hover" ng-click="setwlTabAutiHide()" ng-class="{\'stepPinWorklist\':DataObject.wlTabName==\'Search\' && DataObject.wlTabName==\'Quick Search\'}"><i class="fa fa-thumb-tack fs-12px cursor-pointer icon-hover" ng-class="{\'trans-90-deg\': DataObject.iswlTabAutoHide}"></i></span> <span class="sidebaricons cursor-pointer icon-hover" ng-click="setwlTabAutiHide(true)" ng-class="{\'stepHideWorklist\':DataObject.wlTabName==\'Search\'}"><i class="fa fa-times icon-hover fs-12px txt-clr-1 cursor-pointer"></i></span></div></div><div class="" ng-class="{\'p-0 collapse in b-clr-33 filtsecion filtr-ontop h-100-per overflow-y-auto overflow-x-hide\': (DataObject.DockerPosition && (DataObject.DockerPosition == \'Left\' || DataObject.DockerPosition == \'Right\'))}" id="collapseWorklist" role="tabpanel" aria-labelledby="heading_worklist"><div class="row m-0 d-flex px-15px py-10px justify-content-between align-item-center" ng-if="DataObject.DockerPosition && DataObject.DockerPosition == \'Top\' && DataObject.wlTabName==\'Search\'"><h5 class="fs-14px txt-clr-14 mb-0">Search</h5><i ng-click="setwlTabAutiHide(true)" class="fa fa-times icon-hover fs-12px txt-clr-1 cursor-pointer"></i></div><div class="row m-0 d-flex p-2 justify-content-between align-item-center" ng-if="DataObject.DockerPosition && DataObject.DockerPosition == \'Top\' && DataObject.wlTabName==\'Quick Search\'"><h5 class="fs-14px txt-clr-14 mb-0">Quick Search</h5><i ng-click="setwlTabAutiHide(true)" class="fa fa-times icon-hover fs-12px txt-clr-1 cursor-pointer"></i></div><form id="frmFilter" ng-submit="filter(frmFilter.$valid)" ng-if="DataObject.wlTabName==\'Search\'"><div class="rf-filter filter-controller row my-8px rf-filter-ui px-10px"><div class="width-100 location-top mb-5px"><site-location-grid master-locations="DataObject.MasterData.Locations" selected-location="DataObject.SelectedData.SelectedLocations" on-change="updateSelectedLocation()"></site-location-grid></div><div class="width-100 mb-5px"><input type="text" class="blk-input form-control col-placeholder" ng-model="DataObject.SelectedData.Accession" placeholder="Accession" tooltip-class="uibtooltipDenial" uib-tooltip="Accession" tooltip-placement="auto top" onmousemove="rmvDragg()" onmouseout="addDragg()"></div><div class="width-100 mb-5px"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="DataObject.SelectedData.OrderDate" options="opts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial" uib-tooltip="{{DataObject.SelectedData.toolTipOrderDate}}" tooltip-placement="auto top" ng-mouseenter="resetDateRange()"></div><div class="width-100 mb-5px tultip-bottom"><multi-select master-data="DataObject.ModalityDropdownDataFilter" list="DataObject.MasterData.Modalities" ng-model="DataObject.ModalityDropdownDataFilter.SelectedValue" on-change="onSelectedModalityFilter(selectedData)"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white tt-top" style="top:54px;">{{DataObject.SelectedData.modalitytooltip}}</span></div><div class="width-100 mb-5px"><input type="text" class="blk-input form-control col-placeholder" ng-model="DataObject.SelectedData.OrderingPhysician" placeholder="Ordering Physician" tooltip-class="uibtooltipDenial" uib-tooltip="Ordering Physician" tooltip-placement="auto top" onmousemove="rmvDragg()" onmouseout="addDragg()"></div><div class="width-100 mb-5px"><input type="text" class="blk-input form-control col-placeholder" ng-model="DataObject.SelectedData.PatientMRN" placeholder="MRN" tooltip-class="uibtooltipDenial" uib-tooltip="MRN" tooltip-placement="auto top" onmousemove="rmvDragg()" onmouseout="addDragg()"></div><div class="width-100 mb-5px"><input type="text" class="blk-input form-control col-placeholder" ng-model="DataObject.SelectedData.PatientName" placeholder="Patient Name" tooltip-class="uibtooltipDenial" uib-tooltip="Patient Last Name, First Name" tooltip-placement="auto top" onmousemove="rmvDragg()" onmouseout="addDragg()"></div><div class="width-100 mb-5px"><div class="input-group blk-calender set-pos-fixed"><input type="text" class="form-control col-placeholder" tooltip-class="uibtooltipDenial" uib-tooltip="DOB" tooltip-placement="auto top" uib-datepicker-popup="MM/dd/yyyy" ng-model="DataObject.SelectedData.DOB" is-open="isDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="DOB" placeholder="DOB" data-container="body" ng-click="isDOBOpen = !isDOBOpen"></div></div><div class="width-100 mb-5px"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="DataObject.SelectedData.PatientClass" title="Select Type"><ui-select-match placeholder="Select Type" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in DataObject.MasterData.PatientClass | propsFilter: {Value: $select.search}" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="width-100 mb-5px"><div class="rf-select-wrapper pos-rel"><select class="condition-select blk-input form-control downArrow-ie opnclr sing-select-2 status-fs" ng-model="DataObject.SelectedData.Status.key"><option ng-repeat="os in DataObject.OrderStatus" value="{{os.key}}" ng-style="{{os.bgcolor}}">{{os.value}}</option></select></div></div><div class="width-100 mb-5px"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="DataObject.SelectedData.StudyPriority" title="Select Priority"><ui-select-match placeholder="Select Priority">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in DataObject.MasterData.StudyPriorities | propsFilter: {Value: $select.search}" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="w-100 mb-5px mt-10px clearfix d-flex flex-wrap" ng-class="{\'px-10px popup-footer-btn\': DataObject.DockerPosition == \'Top\'}"><button type="submit" class="btn btn-primary rf-btn-xs mr-5px mb-8px">Filter</button> <button type="button" class="btn btn-primary rf-btn-xs mr-5px mb-8px" style="background-color:#00A8A2 !important" ng-if="DataObject.SelectedData.Worklist === \'PSW\'" ng-click="SaveFilters()">Save Filter</button> <button type="button" ng-click="clearFilterAndRefesh();" class="btn btn-default rf-btn-xs mr-10px mb-8px">Clear</button></div><div class="width-100"><div class="txt-clr-2 w-100 d-flex"><span class="fw-600 mr-5px align-self-center mb-5px mt-10px" ng-if="RefreshTimmer > 0"><span class="full-w">Refresh in {{RefreshTimmer}} Seconds</span> <span class="half-w fs-12px">{{RefreshTimmer}} (Sec)</span></span></div></div></div></form><form id="frmQuickFilter" ng-if="(DataObject.DockerPosition && (DataObject.DockerPosition == \'Left\' || DataObject.DockerPosition == \'Right\'))|| (DataObject.DockerPosition == \'Top\' && DataObject.wlTabName==\'Quick Search\')" ng-submit="onSubmitQuickFilter(frmQuickFilter.$valid)"><div class="panel panel-default quick-search-panel stepQuickSearch"><div class="panel-heading px-1 py-0 h-25px border-0" role="tab" id="headingOne" ng-if="DataObject.DockerPosition != \'Top\'"><div class="panel-title"><a role="button" class="fs-13px" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" ng-click="quickSearchTab()"><i class="fa fs-13px txt-clr-14 icon-hover mt-2 pr-5px float-left" ng-class="{\'fa-caret-left\': DataObject.OpenQuickFilter, \'fa-caret-down\': !DataObject.OpenQuickFilter}"></i> <span class="txt-clr-14">Quick Search</span></a></div></div><div class="panel-body p-2 pos-rel"><div class="float-right d-inline-block pos-abs abs-r-0" style="top:-25px;" ng-if="DataObject.DockerPosition != \'Top\'" ng-mouseenter="DataObject.showQuickFilter = true" ng-mouseleave="DataObject.showQuickFilter = false"><div class="float-right d-inline-block"><button class="btn btn-transparent dropdown-toggle float-right p-0 stepQuickFilter" type="button" ng-disabled="DataObject.OpenQuickFilter"><i class="fa fa-filter fs-14px txt-clr-14 icon-hover pr-2"></i></button><div class="bg-clr-49 pos-abs mt-4 bor-rad-5px z-i-10 p-2 attop-fltr-srch w-170px" ng-class="{\'rel-r-5-p\': DataObject.DockerPosition != \'Top\'}" ng-show="DataObject.showQuickFilter && !DataObject.OpenQuickFilter"><div class="form-controller d-flex align-item-center mb-1"><input class="cmn-checkbx-input" type="checkbox" name="QuickSearchField" id="chk-all" ng-model="DataObject.SelectQuickFilter.obj" ng-change="SelectAllField()"> <label class="rf-label cmn-check-label fs-13px fw-600" for="chk-all">Select All</label></div><div class="form-controller d-flex align-item-center mb-1" ng-repeat="field in ::QuickSearchField"><input class="cmn-checkbx-input" type="checkbox" name="QuickSearchField" ng-model="field.checked" ng-value="field" ng-change="onChangeQuickFilter(field)"> <label class="rf-label cmn-check-label">{{field.key}}</label></div></div></div></div><div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne"><div ng-repeat="field in ::QuickSearchField"><div ng-switch="field.type"><div ng-switch-when="text"><div onmousemove="rmvDragg()" onmouseout="addDragg()"><input-dropdown-list options="DataObject.InputDropdownList.Options" place-holder-text="field.key" selected-option="field.SelectedOption" on-text-changed="onChangeClearInputDropDownText(field)" ng-if="(DataObject.DockerPosition == \'Top\') || field.checked"></input-dropdown-list></div></div><div ng-switch-when="date"><div class="width-100 mb-5px" ng-if="(DataObject.DockerPosition == \'Top\') || field.checked"><div class="input-group blk-calender set-pos-fixed quicksearch-dob"><input type="text" class="form-control h-25px col-placeholder" tooltip-class="uibtooltipDenial" uib-tooltip="DOB" tooltip-placement="auto top" uib-datepicker-popup="MM/dd/yyyy" ng-model="field.value" is-open="isQuickSearchDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="DOB" placeholder="DOB" data-container="body" ng-click="isQuickSearchDOBOpen = !isQuickSearchDOBOpen"></div></div></div><div ng-switch-when="date-range"><div class="width-100 mb-5px" ng-if="(DataObject.DockerPosition == \'Top\') || field.checked"><input date-range-picker="" class="h-25px form-control col-placeholder" type="text" style="background-color: #323232 !important;" placeholder="DOS" ng-model="field.value" options="QuickSearchopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial" uib-tooltip="{{field.value.toolTipOrderDate}}" tooltip-placement="auto top" ng-mouseenter="resetDateRangeQuickSearch()"></div></div><div ng-switch-when="multi-select"><div ng-class="{\'tultip-bottom\': (DataObject.DockerPosition == \'Top\'), \'tultip-top\': (DataObject.DockerPosition != \'Top\')}" class="width-100 mb-5px pos-rel quick-modality" ng-if="(DataObject.DockerPosition == \'Top\') || field.checked"><multi-select master-data="DataObject.ModalityDropdownDataQC" list="DataObject.MasterData.Modalities" on-change="onSelectedModalityQS(selectedData,field)" ng-model="DataObject.ModalityDropdownDataQC.SelectedValue"></multi-select><span class="clearSelModValue rel-b-1-p abs-r-0" style="top:28px;" ng-click="clearSelModaValue(field)">X</span> <span class="tultiptext text-preline max-h-500px text-left tt-white">{{field.modalitytooltip}}</span></div></div><div ng-switch-when="single-select"><div class="width-100 attop-select-drp mb-5px pos-rel" ng-if="(DataObject.DockerPosition == \'Top\') || field.checked"><ui-select skip-focusser="true" class="mult-select ui-quick-serach seltype-drop mob-closekeypad" style="min-height: 25px;" ng-model="field.value" title="{{field.key}}"><ui-select-match placeholder="{{field.key}}" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in field.list | propsFilter: {Value: $select.search}" position="auto"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div ng-switch-when="single-select-bgcolor"><div class="width-100 mb-5px" ng-if="(DataObject.DockerPosition == \'Top\') || field.checked"><div class="rf-select-wrapper pos-rel"><select class="condition-select h-25px py-1 form-control downArrow-ie opnclr sing-select-2 status-fs" ng-model="field.value"><option ng-repeat="os in ::DataObject.OrderStatus" value="{{os.key}}" ng-style="{{os.bgcolor}}">{{os.value}}</option></select></div></div></div></div></div><div class="" ng-class="{\'mt-10px popup-footer-btn\': DataObject.DockerPosition == \'Top\'}"><button type="submit" class="btn btn-primary rf-btn-xs mr-4px mb-8px" ng-disabled="validateQuichSearch()">Search</button> <button type="button" class="btn btn-primary rf-btn-xs mr-4px mb-8px" style="background-color:#00A8A2 !important" ng-click="SaveFilterQuickSearch()" ng-disabled="validateQuichSearchSaveFilter()">Save Filter</button> <button type="button" ng-click="clearQuickFilter();" class="btn btn-default rf-btn-xs mr-10px mb-8px">Clear</button></div></div></div></div></form></div></div><div id="Worklist" class="" ng-class="{\'wl-tabcontent wrklst-wlheight\': (DataObject.DockerPosition == \'Left\' || DataObject.DockerPosition == \'Right\'),\'worklist-tab-popup\' : (DataObject.DockerPosition == \'Top\')}" ng-if="DataObject.wlTabName==\'Worklist\'"><div class="text-right search-actions overflow-hide-all"><div class="headtxt"><span class="txt-clr-1 pull-left">Worklist</span> <a class="cursor-pointer sidebaricons icon-hover" ng-class="{\'stepNewWorklist\':DataObject.wlTabName==\'Worklist\'}" ng-click="AddNewWorklist()"><i class="glyphicon glyphicon-plus icon-hover fs-10px txt-clr-14"></i></a> <span class="sidebaricons icon-hover cursor-pointer" ng-class="{\'stepPinWorklist\':DataObject.wlTabName==\'Worklist\'}" ng-click="setwlTabAutiHide()"><i class="fa fa-thumb-tack icon-hover fs-12px cursor-pointer" ng-class="{\'trans-90-deg\': DataObject.iswlTabAutoHide}"></i></span> <span class="sidebaricons icon-hover cursor-pointer" ng-class="{\'stepHideWorklist\':DataObject.wlTabName==\'Worklist\'}" ng-click="setwlTabAutiHide(true)"><i class="fa fa-times icon-hover fs-12px txt-clr-1 cursor-pointer"></i></span></div></div><div id="WorklistListsGrid" class="ag-theme-balham-dark leftpanel-drop m-0 worklist-steps"></div></div></div></div></div><div id="rightContentSection" class="wl-menu-right droponhover" ng-class="{\'wl-menu-right-full\':!DataObject.wlTabName,\'wl-menu-right-half\':DataObject.wlTabName, \'wl-menu-right-float\':DataObject.iswlTabAutoHide ,\'d-flex justify-content-center\':(DataObject.DefaultWorklists && DataObject.DefaultWorklists.length==0)}" ng-if="DataObject.AccordianShow"><div class="selectworklist-wrapper" ng-if="!DataObject.isWorklistLoading && (DataObject.DefaultWorklists && DataObject.DefaultWorklists.length==0)"><div class="d-flex justify-content-between row mb-30px"><div class="col-md-6"><h2 class="selectworklist-tag pos-rel txt-clr-1 fs-26px fw-500 mt-20px">Please select a worklist from the Worklist tab to load your data.</h2></div><div class="col-md-6"><img src="assets/images/select-worklist.png" alt="Select Worklist" style="max-width:100%"></div></div><div class="d-flex justify-content-between row mb-30px"><div class="col-md-12"><img src="assets/images/select-worklist-list1.png" alt="Select Worklist" style="max-width:100%"></div></div><div class="d-flex justify-content-between row"><div class="col-md-6"><img src="assets/images/add-worklist-screen.png" alt="Select Worklist" style="max-width:100%"></div><div class="col-md-6"><h2 class="selectworklist-tag pos-rel txt-clr-1 fs-26px fw-500 mt-20px">Add a new worklist using the Add Worklist option.</h2></div></div></div><uib-accordion class="rf-accordion" close-others="false" id="uibDefaultWorklistsaccordion" ng-if="!DataObject.isWorklistLoading && (DataObject.DefaultWorklists && DataObject.DefaultWorklists.length > 0)"><worklist-accordion ng-repeat="obj in DataObject.DefaultWorklists track by obj.RuleID" ng-drop="true" ng-drop-success="onDropWorklistOrder($index, $data, $event)" default-worklist="DataObject.DefaultWorklists" worklist="obj" master-data="DataObject.MasterData" selected-data="DataObject.SelectedData" index="$index" reset-clipboard="onResetClipboard(obj)" edit-worklist="onEditWorklist(obj)" remove-default-worklist="RemoveDefaultWorklist(obj)" update-user-layout-pref="updateUserLayoutPref(obj)" class="drop-hv" update-props="onUpdateProps(obj)" refresh-worklist="OnRefreshWorklist(obj)" on-choose-next-study="onChooseNextStudy(worklist)"></worklist-accordion></uib-accordion></div><div class="atright-droptarget eleDropped" id="dropToRight" ondrop="drop(event)" ondragover="allowDrop(event)"></div><div id="sidebar-resizer" resizer="vertical" resizer-width="2" resizer-left="#leftSidebarSection" resizer-right="#rightContentSection" resizer-max="250" resizer-min="200" ng-class="{\'d-none\':!DataObject.wlTabName, \'wl-menu-left-content-float\':DataObject.iswlTabAutoHide}"></div></div><div ng-if="isLoadingSynapse" class="spinner-overlay" style="z-index: 99999;"><div class="spinner-overlay-body" style="opacity:0.8 !important"><div class="w-100 txt-clr-2 text-center fs-22px fw-700 d-table h-100"><div class="d-table-cell v-a-m" style="padding-top:65px;">Loading study...</div></div></div><div class="single4"></div></div></div><div class="modal fade" id="ModalWorkList" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog create-filter"><div class="modal-content py-20px px-0" style="border-radius:4px;background-color:#2c2c2c;"><div class=""><div class=""></div><div class="modal-body"><div align="center"><button type="button" class="btn btn-primary mr-10px" ng-click="createWorkList()">Create Worklist</button> <button type="button" class="btn btn-primary mr-10px" ng-click="saveFilterOnly()">Save Filter Only</button> <button type="button" class="btn btn-default mr-10px" data-dismiss="modal">Cancel</button></div></div></div></div></div></div><script>\r\n\r\n        function deleteWorklist(event, value, type) {\r\n            event.stopPropagation();\r\n            var val = value;\r\n            angular.element(document.getElementById(\'worklistDropdownTree\')).scope().deleteWorklist(val, type);\r\n        }\r\n        function editWorklist(event, value, Id) {\r\n            event.stopPropagation();\r\n            var val = value;\r\n            angular.element(document.getElementById(\'worklistDropdownTree\')).scope().editWorklist(val, Id);\r\n        }\r\n        function editAdminWorklist(value) {\r\n            var val = value;\r\n            angular.element(document.getElementById(\'worklistDropdownTree\')).scope().editAdminWorklist(val);\r\n        }\r\n        function notify() {\r\n            angular.element(document.getElementById(\'container\')).scope().refreshAndHideNotification();\r\n        }\r\n    </script><div class="modal fade z-i-1049" id="ModalEditWorkList" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important;"><div class="modal-dialog edit-filter addwlrule-popup" style="margin:0 !important;"><div class="modal-content px-0"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="OnCloseAddEditWorklistWin(DataObject.Rule.RuleID)">&times;</button><h4 style="color:#fff;">{{DataObject.AddEditWorklistTitle}}</h4></div><rule rule="DataObject.Rule" rule-table="DataObject.RuleTable" rule-setting="false" ng-if="DataObject.ModalWorklistOpened"></rule></div></div></div></div><script id="dropdowntree-orderdiscussion-template" type="text/kendo-ui-template"># if (item.Group && item.Group == "YES") { # #: item.UserName # # } else { # <i class="fa fa-circle #: item.IsOnline ? \'text-success\' : \'text-gray-dark\' #"></i> #: item.UserName # # } #</script><div class="overflow-hide-all ERA-check-detail discsn-popup p-0 fltr-mdl-worklit" kendo-window="win_Worklist" k-on-open="onOpenWinWorklist()" k-on-close="onCloseWinWorklist()" k-title="DataObject.WorklistPopupTitle" k-visible="false" k-width="DataObject.winFilterWorklist" k-height="DataObject.defaultWindowHeight" k-resize="winResize" k-modal="true" k-actions=\'["Maximize", "Close"]\' k-animation="false"><div ng-if="DataObject.ShowWorklistWindow"><div class="denial-window onmodal-worklist"><div class="fw-500" id="win_Worklist" style="visibility:hidden;"><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="DataObject.SearchedWorklist.loading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><ag-grid worklist="DataObject.SearchedWorklist" master-data="DataObject.MasterData" selected-data="DataObject.SelectedData" view-mode="false" index="DataObject.SearchedWorklist.RuleID" update-user-layout-pref="updateUserLayoutPref(DataObject.SearchedWorklist)" update-props="onUpdateProps(DataObject.SearchedWorklist)"></ag-grid></div></div></div></div><div ng-show="DataObject.isWorklistLoading" class="spinner-overlay h-100"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div>');
$templateCache.put('app/pages/prtg/prtg.html','<style>\r\n    .status-bar {\r\n        padding: 2px 4px;\r\n        color: white;\r\n        font-weight: 500;\r\n        display: flex;\r\n        gap: 1px;\r\n        align-items: baseline;\r\n        width: fit-content;\r\n        border-radius: 3px;\r\n        /*border-bottom:solid 1px white;*/\r\n    }\r\n\r\n    .sensor-title {\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .icon-check {\r\n        color: green;\r\n        font-size: 20px;\r\n    }\r\n\r\n    .rating {\r\n        color: blue;\r\n    }\r\n\r\n    .tab-content {\r\n        padding: 15px;\r\n        color: white;\r\n    }\r\n\r\n    .breadcrumb {\r\n        background-color: transparent !important;\r\n        padding: 0;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .nav-tabs {\r\n        background-color: transparent !important;\r\n    }\r\n\r\n    .breadcrumb li a:hover, .breadcrumb li a:link {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .al-sidebar-sublist {\r\n        display: none;\r\n    }\r\n\r\n    .al-sidebar-list li.al-sidebar-list-item:hover > .al-sidebar-sublist {\r\n        position: absolute !important;\r\n        min-width: 170px !important;\r\n        display: block;\r\n    }\r\n\r\n    .al-sidebar-list li.al-sidebar-list-item .ba-sidebar-sublist-item:hover > .al-sidebar-sublist {\r\n        position: absolute !important;\r\n        min-width: 100% !important;\r\n        display: block;\r\n        left: 175px;\r\n        top: 0;\r\n    }\r\n\r\n    .tab-active {\r\n        background-color: #1f1f1f;\r\n        border-bottom: 3px solid #04c1a3;\r\n    }\r\n\r\n    .stat-card {\r\n        overflow: auto;\r\n        max-height: 90vh;\r\n        max-width: 100%;\r\n        width: 99%;\r\n        border-color: #737373 !important;\r\n        /*height: 16vh;*/\r\n        border: 1px solid #ffffffa6;\r\n        flex-grow: 1;\r\n        margin: 5px;\r\n        background: #313131;\r\n        border-radius: 2px;\r\n    }\r\n\r\n    .row {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .box {\r\n        /*width: 49.4% !important;*/\r\n        width: 32.7% !important;\r\n        height: 44.5vh;\r\n        border: 1px solid #7e7e7e;\r\n        margin: 10px 0 0 10px;\r\n        resize: both;\r\n        overflow: hidden;\r\n        background: #000000;\r\n    }\r\n\r\n        .box:last-child {\r\n            margin-bottom: 14px;\r\n        }\r\n\r\n    .box-wrapper {\r\n        /*height: 45.5vh;*/\r\n        height: 93%;\r\n        background: #000000;\r\n        overflow-x: hidden;\r\n        overflow-y: auto;\r\n    }\r\n\r\n        .box-wrapper .stat-card:last-child {\r\n            margin-bottom: 10px;\r\n        }\r\n\r\n    .prtg-tbl.wh-table > thead > tr > th > label {\r\n        font-size: 12px !important;\r\n        color: #05C1A4 !important;\r\n        font-weight: 600 !important;\r\n    }\r\n\r\n    .prtg-tbl.wh-table > tbody > tr > td {\r\n        height: 26px;\r\n        padding: 3px 3px 10px 7px !important;\r\n        /*color: #07e6b9 !important;*/\r\n        line-height: 6px;\r\n        font-size: 12px;\r\n        font-weight: 400;\r\n        color: #e8e8e8;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .prtg-tbl.wh-table > thead > tr > th label {\r\n        margin-bottom: 0 !important;\r\n    }\r\n\r\n    .prtg-tbl.wh-table thead tr:nth-child(1) th:nth-child(1) {\r\n        padding-left: 6px !important;\r\n    }\r\n\r\n    .status-bar .tooltip-inner {\r\n        border: 1px solid #5e5e5e;\r\n        background: #595959;\r\n        color: #fff;\r\n    }\r\n\r\n    .status-bar .tooltip.left .tooltip-arrow {\r\n        border-left-color: #595959;\r\n    }\r\n\r\n    .prtg-wrapper {\r\n        overflow-y: auto;\r\n        height: calc(100vh - 40px);\r\n    }\r\n    .uiview-element .prtg-wrapper {\r\n        overflow-y: auto;\r\n        height: calc(100vh - 70px);\r\n    }\r\n    .bx-tbl-head {\r\n        width: 450px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n        .bx-tbl-head .sensor-title:last-child {\r\n            white-space: nowrap;\r\n            text-overflow: ellipsis;\r\n            display: block;\r\n            overflow: hidden\r\n        }\r\n\r\n    .prtgtime-wraaper {\r\n        width: 15%;\r\n    }\r\n\r\n    .lbl-refreshtime {\r\n        width: 50%;\r\n    }\r\n\r\n    .refresh-time-box {\r\n        width: 100%;\r\n    }\r\n\r\n    @media only screen and (min-width: 767px) and (max-width: 1600px) {\r\n        .box {\r\n            width: 100% !important;\r\n        }\r\n\r\n        .prtg-wrapper {\r\n            overflow-y: auto;\r\n            height: calc(100vh - 70px);\r\n        }\r\n    }\r\n</style><div class="radf-header d-flex align-item-center py-4px" keyboard="keys"><h2 class="float-left mb-0">PRTG Dashboard</h2><div class="pb-3px pt-2px pr-15px d-flex align-item-center prtgtime-wraaper"><label class="fs-12px fw-500 lbl-refreshtime mb-0">Refresh Time</label><ui-select class="mult-select seltype-drop mob-closekeypad refresh-time-box" ng-model="DataObject.selectedInterval" ng-change="changeInterval()"><ui-select-match allow-clear="false">{{$select.selected.optionValue}}</ui-select-match><ui-select-choices repeat="obj in DataObject.IntervalTime | filter: {optionValue: $select.search} | orderBy:\'optionValue\'" position="down"><div ng-bind-html="obj.optionValue | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="prtg-wrapper d-flex flex-wrap"><div class="box pos-rel" ng-repeat="site in DataObject.SiteList"><div class="px-10px py-5px mb-0 box-innerhead" style="background-color: rgba(64, 64, 64, 0.8);"><nav><ol class="breadcrumb"><li class="breadcrumb-item"><a href="#" class="txt-clr-1 fs-14px fw-600">{{site.Site}}</a></li></ol></nav></div><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="site.isLoading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div class="box-wrapper"><div class="stat-card" ng-repeat="sensor in site.SensorData"><div class=""><div class="d-flex align-items-center justify-content-between" style="border-bottom: solid #616161 1px;"><div class="bx-tbl-head d-flex mt-5px mb-5px" title="Sensor {{sensor.type}} / {{sensor.group}} / {{sensor.device}}"><div class="sensor-title mb-1 ml-5px" style="color:white">Sensor {{sensor.type}}</div><div class="sensor-title mb-1 ml-5px" style="color:white" ng-show="sensor.group">/ {{sensor.group}}</div><div class="sensor-title mb-1 ml-5px" style="color:white" ng-show="sensor.device">/ {{sensor.device}}</div></div><div class="status-bar fs-13px mx-5px mt-5px mb-5px" ng-style="{\'background\': sensor.message_raw === \'OK\' ? \'green\' : \'red\' }"><div><span>Last Message:</span> <span ng-show="sensor.message_raw == \'OK\'">{{sensor.message_raw}}</span> <span ng-show="sensor.message_raw != \'OK\'">Error <i class="fa fa-info-circle" aria-hidden="true" uib-tooltip="{{sensor.message_raw}}" tooltip-placement="left"></i></span></div></div></div></div><div class="tab-content txt-clr-1 p-0"><div class="tab-pane active"><div class="overflow-y-auto orderevent-contetnt"><div class="row m-0"><table class="table pos-rel prtg-tbl wh-table ordereventlog-table overflow-x-hide overflow-y-auto"><thead><tr><th class="text-left"><label>Last Scan</label></th><th class="text-left"><label>Last Up</label></th><th class="text-left"><label>Last Down</label></th><th class="text-left"><label>Up Time</label></th><th class="text-left"><label>Down Time</label></th><th class="text-left"><label>Sensor Type</label></th><th class="text-left"><label>Interval</label></th><th class="text-left"><label>Id</label></th></tr></thead><tbody style="font-weight:normal"><tr><td align="left" class="text-left">{{sensor.lastcheck.split(\'[\')[1].split(\'ago\')[0].trim()}}</td><td align="left" class="text-left">{{sensor.lastup.split(\'[\')[1].split(\'ago\')[0].trim()}}</td><td align="left" class="text-left">{{sensor.lastdown.split(\'[\')[1].split(\'ago\')[0].trim()}}</td><td align="left" class="text-left">{{ sensor.uptime ? sensor.uptime.split(\'.\')[0] + "%" : "" }}</td><td align="left" class="text-left">{{ sensor.downtime ? sensor.downtime.split(\'.\')[0] + "%" : "" }}</td><td align="left" class="text-left">{{sensor.type}}</td><td align="left" class="text-left">{{ sensor.interval ? sensor.interval.split(\'.\')[0]: "" }}</td><td align="left" class="text-left">{{sensor.parentid}}</td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/address-book-grid/address-book-grid.html','<style>\r\n    #AddressBookGrid .ag-row .ag-cell {\r\n        color: white;\r\n    }\r\n    .addressbook-grid {\r\n        height: calc(100vh - 114px) !important;\r\n    }\r\n    .address-grid-h .addressbook-grid {\r\n        height: calc(100vh - 138px) !important;\r\n    }\r\n    </style><div id="AddressBookGrid" class="ag-theme-balham-dark addressbook-grid w-100"></div><div ng-if="isLoadingAddressBook" class="spinner-overlay" style="z-index: 99999;"><div class="spinner-overlay-body" style="opacity:0.8 !important"></div><div class="single4"></div></div>');
$templateCache.put('app/theme/components/address-book-info/address-book-info.html','<style>\r\n    #locationAddressBookModalTreeTooltip {\r\n        max-height: 250px !important;\r\n    }\r\n</style><form name="frmContact" id="frmContact" class="width-inherit height-inherit"><div><div id="mappingNav" class="px-0 mb-10px"><ul class="nav nav-tabs no-bg"><li class="active mob-flaot-none mob-text-center" ng-click="changeTab(\'Department\')" ng-class="{\'disable-area\':currentTab.Department}"><a href="#Department" style="color: white !important;" data-toggle="tab">Department</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeTab(\'Person\')" ng-class="{\'disable-area\':currentTab.Person}" ng-if="false"><a href="#Person" style="color: white !important;" data-toggle="tab">Person</a></li></ul></div></div><div class="row mx-0" ng-if="currentTab.Department"><div class="col-lg-12 col-md-12 px-0 col-sm-12"><div class="form-group mb-10px py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Location *</label><div class="tultip-bottom"><ui-select ng-model="SelectedValue.Location" theme="bootstrap" class="mult-select" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" required=""><ui-select-match class="" placeholder="Select Location">{{$select.selected.Location}}</ui-select-match><ui-select-choices repeat="list in $ctrl.addressBookInfo.Locations | propsFilter: {Location: $select.search} | orderBy:\'Location\'" class="boxshadow-none"><div class="inst-selectBox" ng-bind-html="list.Location | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row mx-0"><div class="col-md-6 col-sm-6 pl-0"><div class="form-group mb-10px py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Modality</label><ui-select ng-model="SelectedValue.Modality" theme="bootstrap" class="mult-select" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false"><ui-select-match class="" placeholder="Select Modality">{{$select.selected.Code}}</ui-select-match><ui-select-choices repeat="list in $ctrl.addressBookInfo.Modality | propsFilter: {Code: $select.search} | orderBy:\'Code\'"><div class="inst-selectBox" ng-bind-html="list.Code | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="col-md-6 col-sm-6 pr-0"><div class="form-group mb-10px py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Department</label><ui-select ng-model="SelectedValue.Department" theme="bootstrap" class="mult-select" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false"><ui-select-match class="" placeholder="Select Department">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in $ctrl.addressBookInfo.ContactDepartmentType | propsFilter: {Value: $select.search} | orderBy:\'Value\'" class="boxshadow-none"><div class="inst-selectBox" ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><div class="row mx-0"><div class="col-md-6 col-sm-6 pl-0"><div class="form-group mb-10px py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">First Name *</label> <input class="blk-input form-control form-border" ng-model="$ctrl.addressBookInfo.SelectedData.FirstName" name="FirstName" maxlength="50" type="text" placeholder="First Name" required="" ng-class="{\'border-color-red\' : (frmContact.FirstName.$touched && frmContact.FirstName.$invalid) }"></div></div></div><div class="col-md-6 col-sm-6 pr-0"><div class="form-group mb-10px py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Last Name *</label> <input class="blk-input form-control form-border" ng-model="$ctrl.addressBookInfo.SelectedData.LastName" name="LastName" maxlength="50" type="text" placeholder="Last Name" required="" ng-class="{\'border-color-red\' : (frmContact.LastName.$touched && frmContact.LastName.$invalid) }"></div></div></div></div><div class="row mx-0"><div class="col-md-6 col-sm-6 pl-0"><div class="form-group mb-10px py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Office</label> <input type="text" class="blk-input form-border form-control" name="OfficePhone" ui-mask="(999) 999-9999" maxlength="15" ng-model="$ctrl.addressBookInfo.SelectedData.OfficePhone" autocomplete="off" ng-class="{\'border-color-red\' : frmContact.OfficePhone.$invalid }"></div></div></div><div class="col-md-6 col-sm-6 pr-0"><div class="form-group mb-10px py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Mobile</label> <input type="text" class="blk-input form-border form-control" name="MobilePhone" ui-mask="(999) 999-9999" maxlength="15" ng-model="$ctrl.addressBookInfo.SelectedData.MobilePhone" autocomplete="off" ng-class="{\'border-color-red\' : frmContact.MobilePhone.$invalid }"></div></div></div></div><div class="form-group mb-10px py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Email</label> <input class="blk-input form-control form-border" ng-model="$ctrl.addressBookInfo.SelectedData.Email" name="emailId" maxlength="50" placeholder="Email Id" validate-email="" type="text" ng-pattern="/[a-z0-9]+@[a-z]+\\.[a-z]{2,7}$/" ng-class="{\'border-color-red\' : (frmContact.emailId.$touched && frmContact.emailId.$invalid) }"></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Contact Preference *</label> <span class="pr-10px" ng-repeat="contactPreference in $ctrl.addressBookInfo.ContactPreferenceType"><input name="contactPreference" type="radio" value="{{contactPreference.Key}}" class="cmn-checkbx-input mt-2px mr-2px" ng-model="$ctrl.addressBookInfo.SelectedData.ContactPreferenceType" required=""> {{contactPreference.Value}}</span></div></div><div class="form-group py-1 w-100 px-0 pos-rel d-none"><div class="group-register"><label class="rf-label">Is Default *</label></div></div></div></div><div class="row mx-0" ng-if="currentTab.Person"><div class="col-lg-12 col-md-12 px-0 col-sm-12"><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Location *</label><div class="tultip-bottom"></div></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">First Name *</label> <input class="blk-input form-control form-border" ng-model="$ctrl.addressBookInfo.SelectedData.FirstName" name="FirstName" maxlength="50" type="text" placeholder="First Name" required="" ng-class="{\'border-color-red\' : (frmContact.FirstName.$touched && frmContact.FirstName.$invalid) }"></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Last Name *</label> <input class="blk-input form-control form-border" ng-model="$ctrl.addressBookInfo.SelectedData.LastName" name="LastName" maxlength="50" type="text" placeholder="Last Name" required="" ng-class="{\'border-color-red\' : (frmContact.LastName.$touched && frmContact.LastName.$invalid) }"></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Office</label> <input type="text" class="blk-input form-border form-control" name="OfficePhone" ui-mask="(999) 999-9999" maxlength="15" ng-model="$ctrl.addressBookInfo.SelectedData.OfficePhone" autocomplete="off" ng-class="{\'border-color-red\' : frmContact.OfficePhone.$invalid }"></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Mobile</label> <input type="text" class="blk-input form-border form-control" name="MobilePhone" ui-mask="(999) 999-9999" maxlength="15" ng-model="$ctrl.addressBookInfo.SelectedData.MobilePhone" autocomplete="off" ng-class="{\'border-color-red\' : frmContact.MobilePhone.$invalid }"></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Email</label> <input class="blk-input form-control form-border" ng-model="$ctrl.addressBookInfo.SelectedData.Email" name="emailId" maxlength="50" placeholder="Email Id" validate-email="" type="text" ng-pattern="/[a-z0-9]+@[a-z]+\\.[a-z]{2,3}$/" ng-class="{\'border-color-red\' : (frmContact.emailId.$touched && frmContact.emailId.$invalid) }"></div></div></div></div><div class="modal-footer p-0 border-0" style="background-color: #3A393A !important;"><button class="btn btn-primary" ng-disabled="!frmContact.$valid" ng-click="SaveContact(\'S\')">Save</button> <button class="btn btn-default" ng-disabled="!frmContact.$valid" ng-click="SaveContact(\'SA\')" ng-if="$ctrl.saveOtherBtn">Save and add another</button></div></form>');
$templateCache.put('app/theme/components/ag-grid/ag-grid.html','<style>\r\n    .ag-cell-data-changed {\r\n        background-color: rgba(255, 1, 1, 0.21) !important;\r\n    }\r\n\r\n    .ag-cell-data-changed-animation {\r\n        background-color: transparent;\r\n        transition: background-color 5s !important;\r\n        -webkit-transition: background-color 5s !important;\r\n        -moz-transition: background-color 5s !important;\r\n        -o-transition: background-color 5s !important;\r\n    }\r\n\r\n    .ag-button[ref="applyFilterButton"], .ag-button[ref="clearFilterButton"] {\r\n        border-radius: 4px !important;\r\n        cursor: pointer;\r\n        color: #fff !important;\r\n        border: 1px solid #05C1A4 !important;\r\n        border-width: 1px !important;\r\n        font-weight: 400;\r\n        letter-spacing: 0.2px;\r\n        padding: 4px 7px;\r\n        font-family: "Open Sans", sans-serif !important;\r\n        background-color: #05C1A4;\r\n    }\r\n\r\n    .ag-button[ref="resetFilterButton"] {\r\n        background-color: transparent;\r\n        border: 1px solid #05c1a4;\r\n        border-radius: 5px;\r\n    }\r\n\r\n        .ag-button[ref="resetFilterButton"]:hover {\r\n            background-color: #05c1a4 !important;\r\n            color: #fff !important;\r\n        }\r\n\r\n    .ag-theme-balham-dark .ag-ltr input.ag-input-field-input.ag-text-field-input[type=text], .ag-number-field-input[type=number],\r\n    .ag-filter-select .ag-picker-field-wrapper {\r\n        box-shadow: none;\r\n        height: 30px;\r\n        border-radius: 2px;\r\n        border-color: #424242;\r\n        font-family: "Open Sans", sans-serif !important;\r\n    }\r\n\r\n    .ag-theme-balham-dark .ag-ltr input.ag-input-field-input.ag-text-field-input[type=text], .ag-number-field-input[type=number],\r\n    .ag-filter-select .ag-picker-field-wrapper {\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .ag-theme-balham-dark .ag-filter-body .ag-input-field.ag-filter-from.ag-filter-filter {\r\n        margin-top: 5px;\r\n    }\r\n\r\n    .ag-theme-balham-dark .ag-filter .ag-filter-apply-panel {\r\n        padding: 10px 4px;\r\n    }\r\n\r\n    .ag-popup .ag-menu.ag-ltr.ag-popup-child.ag-popup-child[aria-label="Context Menu"],\r\n    .ag-popup + .ag-popup .ag-menu.ag-ltr.ag-popup-child.ag-popup-child[aria-label="SubMenu"],\r\n    .ag-popup .ag-menu.ag-ltr.ag-popup-child.ag-popup-child[aria-label="Column Menu"],\r\n    .ag-popup + .ag-popup .ag-popup-child[aria-label="Select Field"] {\r\n        z-index: 10009;\r\n    }\r\n\r\n    .ag-menu.ag-ltr.ag-popup-child.ag-popup-child {\r\n        z-index: 1;\r\n    }\r\n\r\n    .hideHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        display: none;\r\n    }\r\n\r\n    .ag-icon.ag-icon-asc {\r\n        display: block !important;\r\n        font-size: var(--ag-icon-size);\r\n    }\r\n    /*\r\n    .rf-accordion .ag-details-row {\r\n        width: 100.1% !important;\r\n    }*/\r\n    .hide-study-select {\r\n        background-color: rgb(5 193 164 / 26%);\r\n        border: 1px solid #05C1A4 !important;\r\n        color: white !important;\r\n    }\r\n\r\n    .hideStudy-info .tooltip.uibtooltipDenial .tooltip-inner {\r\n        width: 250px !important;\r\n        max-width: 400px !important;\r\n    }\r\n\r\n    .section-disbl {\r\n        pointer-events: none;\r\n        opacity: 0.8;\r\n    }\r\n\r\n    .row-disbl {\r\n        cursor: not-allowed;\r\n        opacity: 0.6;\r\n    }\r\n\r\n        .row-disbl * {\r\n            pointer-events: none;\r\n        }\r\n\r\n    .row-disbl-splash {\r\n        -webkit-user-select: none; /* Safari */\r\n        -ms-user-select: none; /* IE 10 and IE 11 */\r\n        user-select: none; /* Standard syntax */\r\n        opacity: 0.6;\r\n        cursor: not-allowed;\r\n    }\r\n\r\n    /*.row-disbl-splash * {\r\n            pointer-events: none;\r\n        }*/\r\n\r\n    .rating-box {\r\n        max-height: 55vh !important;\r\n        overflow-y: auto;\r\n        overflow-x: hidden;\r\n    }\r\n\r\n    .rating-box-1 {\r\n        max-height: 55vh !important;\r\n        overflow-y: auto;\r\n        overflow-x: hidden;\r\n    }\r\n\r\n    .exam-tag.btn:hover, .btn:active, .btn:focus {\r\n        color: white;\r\n    }\r\n\r\n    div[col-id=\'HasComparison\'] .ag-header-icon.ag-header-cell-menu-button {\r\n        opacity: 1 !important;\r\n    }\r\n\r\n    .query-grid .ag-details-grid.ag-details-grid-fixed-height.ag-theme-balham-dark {\r\n        padding: 10px;\r\n    }\r\n\r\n    .query-grid .ag-details-grid.ag-details-grid-auto-height.ag-theme-balham-dark {\r\n        padding: 16px;\r\n        width: 98%;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .ag-full-width-container > .agrow-bg .ag-details-grid.ag-details-grid-auto-height.ag-theme-balham-dark {\r\n        padding: 8px;\r\n        width: 90%;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .ag-center-cols-clipper {\r\n        min-height: 40px !important;\r\n    }\r\n\r\n    .query-grid .ag-header-container {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .query-grid .ag-center-cols-container {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .queryAccessionHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        padding-left: 39px;\r\n        padding-right: 6px;\r\n    }\r\n\r\n    .querySeriesHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        padding-left: 21px;\r\n        padding-right: 6px;\r\n    }\r\n\r\n    .k-widget.k-window.k-window-maximized {\r\n        top: 10px !important;\r\n    }\r\n\r\n    .k-widget.k-window.report-top-mdl {\r\n        top: 80px !important;\r\n    }\r\n\r\n    .alertStatStudiesFirst label.form-controller {\r\n        width: fit-content;\r\n    }\r\n\r\n    .k-widget.k-window.k-window-titleless {\r\n        top: 30% !important;\r\n    }\r\n\r\n    #FaxNumberDropdownGrid.multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n\r\n    #uibDefaultWorklistsaccordion .panel-group worklist-accordion:only-child ag-grid #FaxNumberDropdownGrid.multiSelectGridDiv.ag-theme-balham-dark {\r\n        height: 250px !important;\r\n    }\r\n\r\n    .bsmodal-sendfax {\r\n        z-index: 99991 !important;\r\n    }\r\n\r\n    .fax-multiselectbox .location-tags-input tags-input .tags {\r\n        border: 1px solid #a2a1a1 !important;\r\n    }\r\n\r\n    .modal .modal-dialog .modal-body .form-control.inputfax-numner {\r\n        height: 33px;\r\n    }\r\n\r\n    .fax-multiselectbox .location-tags-input tags-input .tags .tag-list {\r\n        max-height: 50px;\r\n    }\r\n\r\n    .new-wl-discussion .k-toolbar .k-button, .new-wl-rep-dis .k-toolbar .k-button {\r\n        margin: 0;\r\n    }\r\n\r\n    .list-tooltip {\r\n        top: 100px !important;\r\n    }\r\n\r\n    #uibDefaultWorklistsaccordion .panel-group worklist-accordion ag-grid .myGrid.ag-theme-balham-dark .ag-status-bar,\r\n    .fltr-mdl-worklit-wrapper .onmodal-worklist ag-grid .myGrid.ag-theme-balham-dark .ag-status-bar,\r\n    .rule-vislise-worklist ag-grid .myGrid.ag-theme-balham-dark .ag-status-bar {\r\n        background-color: rgba(60,60,60,1);\r\n    }\r\n\r\n    #ModalEditWorkList .edit-filter.addwlrule-popup .rule-grid-worklist .myGrid {\r\n        height: calc(100vh - 254px) !important;\r\n    }\r\n\r\n    @media (max-width: 1199px) and (min-width: 768px) {\r\n        .new-wl-discussion .k-pdf-viewer .k-toolbar.k-toolbar-resizable, .new-wl-rep-dis .k-pdf-viewer .k-toolbar.k-toolbar-resizable {\r\n            padding-left: 0;\r\n        }\r\n\r\n        .new-wl-discussion .k-toolbar div.k-flat[aria-label="Print"], .new-wl-rep-dis .k-toolbar div.k-flat[aria-label="Print"] {\r\n            margin: 0 !important;\r\n        }\r\n\r\n        .new-wl-discussion .k-toolbar .k-flat.k-toolbar-last-visible, .new-wl-rep-dis .k-toolbar .k-flat.k-toolbar-last-visible {\r\n            margin: 0;\r\n        }\r\n\r\n        .new-wl-discussion .k-toolbar .k-overflow-anchor, .new-wl-rep-dis .k-toolbar .k-overflow-anchor {\r\n            right: -10px;\r\n        }\r\n    }\r\n</style><div id="divOrderList{{DataObject.index}}"></div><div id="{{DataObject.worklist.gridId}}" class="myGrid ag-theme-balham-dark stepmenupendingSub" ng-style="{height:DataObject.worklist.height+\'px\'}" style="width:100%;"></div><div class="overflow-hide-all ERA-check-detail discsn-popup comp-innotab px-0 py-0" kendo-window="win_Discussion" k-on-open="isDiscussionVisible = true;windowOpened(win_Discussion);" k-on-close="CloseDiscussionWindow()" k-title="\'Discussion\'" k-visible="false" k-width="DataObject.defaultWindowWidth" k-height="DataObject.defaultWindowHeight" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div style="background-color:#262526!important;"><div class="spinner-overlay" ng-show="DataObject.Loading"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div ng-if="isDiscussionVisible"><div ng-include="\'faxModelBodyContent.html\'"></div><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center" ng-repeat="tabList in DataObject.DiscussionWindowTabList" ng-class="{\'active\':tabList.TabName==DataObject.DiscussionWindowActiveTab}"><a class="py-5px" ng-click="onDiscussionWindowTabChange(tabList.TabName);" href="#{{tabList.TabName}}" data-toggle="tab" ng-class="{\'disable-area\':tabList.TabName==DataObject.DiscussionWindowActiveTab}" ng-if="tabList.TabName.includes(\'Attachment\') ? DataObject.ShowAttachmentTab : true">{{tabList.TabName && tabList.TabName.includes(\'Attachment\') ? tabList.TabName + \' (\'+SelectedOrder.FileCount+\')\' : tabList.TabName}}</a></li><studyactionmenu selected-order="DiscussionSelectedOrder" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Discussion"></studyactionmenu></ul></div><div class="p-8px-all pt-0"><div class="denial-window pt-5px" ng-if="DataObject.DiscussionWindowActiveTab == \'Discussion\'"><div class="fw-500"><patientdetails selected-order="DiscussionSelectedOrder" button-clicked="ButtonClicked(DiscussionSelectedOrder)"></patientdetails><div><div class="row m-0 d-flex align-item-center" ng-if="ODType==\'Assigner\' && isAssignAllowed(SelectedOrder.Status)"><div class="mr-10px"><label class="rf-label- fs-14px mb-0 pl-2px mt-2px fw-400">Assign to:</label></div><div class="col-lg-3 col-md-3 col-sm-3 p-0 mt-1 discussion-sel tultip-bottom"><div><div id="kddtOrderDiscussion" style="width: 100%;border-color:#424242!important;background-color:#323232!important;" kendo-dropdowntree="kddtOrderDiscussion" k-options="getOrderDiscussionOptions()"></div><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white ug-tt-width z-i-9999" style="top:35px!important; visibility: hidden;" id="OrderDiscussionAssignmentTooltip">{{orderDiscussionTooltip}}</span></div></div></div><div class="row m-0"><div class="col-md-12 p-0" ng-if="ODType==\'Discussion\' || ODType==\'Helper\'"><div class="form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea></div><div class=""><button type="button" class="btn btn-primary pull-right border-0" ng-click="SaveDiscussion()">Save</button></div></div><div class="col-md-12 pr-0 pl-0" ng-if="ODType==\'Assigner\'"><div class="col-md-12 form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea></div><button type="button" class="btn btn-primary pull-right ml-5px" ng-click="SaveOrderDiscussion()" style="display:none;">Consult Study</button> <button type="button" class="btn btn-primary pull-right ml-5px" ng-click="AssignStudy()" ng-disabled="AssignStudyFlag" style="display:none;">Assign Study</button> <button type="button" class="btn btn-primary pull-right" ng-click="SaveDiscussion()" ng-disabled="SaveDiscussionFlag">Save</button></div><div class="clearfix h-10px"></div><div class="discus-comment overflow-y-auto py-10px px-10px"><div class=""><div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div></div></div></div><div class="pt-5px" ng-if="DataObject.DiscussionWindowActiveTab == \'Attachment\' && SelectedOrder.FileCount > 0 && !showDiscuss"><patientdetails selected-order="DiscussionSelectedOrder" button-clicked="ButtonClicked(DiscussionSelectedOrder)"></patientdetails><div class="new-wl-discussion mt-5px"><div class="discussion-attachment-sec"><div class="row m-0"><attachment-viewer ng-if="DataObject.Reference.ID" dicomorder="DataObject.Reference" send-fax="openFaxModal(faxFile)" selected-order="DiscussionSelectedOrder"></attachment-viewer></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0 report-popup px-5px comp-innotab px-0 py-0" kendo-window="win_ComparisonOrderReports" k-on-open="DataObject.IsStudyReviewSectionVisible=false; isComparisonOrderReportsVisible = true;winOpen();windowOpened(win_ComparisonOrderReports);" k-on-close="isComparisonOrderReportsVisible = false;winComparisonOrderReports_OnClose();onClearFilterReportList(true);windowClosed(win_ComparisonOrderReports);" k-title="\'Report\'" k-modal="true" k-visible="false" k-width="DataObject.defaultWindowWidth" k-height="DataObject.defaultWindowHeight" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isComparisonOrderReportsVisible"><div class=""><div class=""><div class="row mb-20px m-0"><div class="col-md-12 p-0"><div class="" ng-if="!DataObject.ShowReportModal"><div class="" id="{{OrderReport.OrderID}}"><div class="mob-report"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Report</a></li><studyactionmenu selected-order="ReportSelectedOrder" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Report"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="ReportSelectedOrder" button-clicked="ButtonClicked(ReportSelectedOrder)"></patientdetails><div class="row m-0 rprtdscn-fbtns-wrapper" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"><button type="button" class="btn btn-primary rf-btn-xs pull-right mr-10px" ng-click="HideShowReviewReportAction()" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable">{{ReviewOrder.ReviewReportButtonText}}</button></div><div class="row m-0"><div class="px-0" ng-class="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible ? \'col-lg-9 col-sm-9 col-xs-9\' :\'col-lg-12 col-sm-12 col-xs-12\'" ng-if="report.DictationValue"><div class="w-100 repoheight-2 rprtsinglwrklst overflow-y-auto overflow-x-hide py-10px px-10px bg-clr-49 repoHeiFtrWrklst"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="width:100%; display:block; line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div><div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box" id="{{OrderReport.OrderID}}" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"><div ng-include="\'peerReviewSection.html\'"></div></div></div></div></div></div></div><div class="m-0" ng-if="DataObject.ShowReportModal"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Report</a></li><studyactionmenu selected-order="ReportSelectedOrder" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Report"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="ReportSelectedOrder" button-clicked="ButtonClicked(ReportSelectedOrder)"></patientdetails><div class="rprtdscn-fbtns-wrapper d-flex align-item-center justify-content-between p-5px-all px-10px"><div class="d-flex align-item-center"><div class="width-100 mr-15px"><input type="text" class="blk-input form-control col-placeholder h-25px input-filterreport" placeholder="Search" ng-model="DataObject.SearchText" ng-keyup="FilterReportList(true)"></div><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap mr-15px"><li class="pos-rel align-self-center mr-15px"><a class="border-0 btnpopover-sorting bor-rad-2px py-4px px-4px fs-10px text-center" ng-click="DataObject.displaySortPopover = true" uib-tooltip="{{DataObject.SelectedSortingOption}}" tooltip-placement="top" ng-style="DataObject.displaySortPopover == true ? {\'background-color\':\'#05c1a4\'} : {\'background-color\': \'rgba(5, 193, 164, 0.19);\'}"><i class="fa fa-sort-amount-asc" aria-hidden="true"></i></a><div class="popover-sorting p-5px-all bor-rad-2px" ng-show="DataObject.displaySortPopover" ng-mouseleave="DataObject.displaySortPopover = false"><a class="popover-sorting-item d-block p-5px-all cursor-pointer fs-12px fw-400 txt-clr-1" ng-repeat="list in DataObject.ReportSortingOptions" ng-class="{\'active\' : list == DataObject.SelectedSortingOption}" ng-click="onReportSortingClicked(list)">{{list}}</a></div></li><li class="text-center" ng-repeat="list in DataObject.ReportList.DateRange" ng-class="{\'active\' : DataObject.ReportListFilter.DateRange == list}" ng-click="DataObject.ReportListFilter.DateRange=list;FilterReportList(true)"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap"><li class="text-center" ng-repeat="list in DataObject.ReportList.Modalities track by $index" ng-class="{\'active\' : DataObject.ReportListFilter.Modality == list}" ng-click="DataObject.ReportListFilter.Modality=list;FilterReportList(true)"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul></div><div class="d-inline-block pull-right" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"><button type="button" class="btn btn-primary rf-btn-xs pull-right mr-10px" ng-click="HideShowReviewReportAction()" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable">{{ReviewOrder.ReviewReportButtonText}}</button></div></div><div class="row m-0"><div class="col-lg-2 col-sm-2 col-xs-3 m-0 pl-0 pr-0 pr-5px bg-clr-49"><div class="overflow-auto repoheight-2 repoHeiFtrWrklst ftlrbtns-height"><div ng-repeat="r in reportList | orderBy: DataObject.ReportSortingPropName : DataObject.ReportSortingRevOrder track by $index" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #959595 1px solid;cursor:pointer; word-wrap: break-word !important;">{{r.ProcedureDesc}}<div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}">DOS : {{r.FormattedOrderDate | date:\'MM/dd/yyyy\'}}<div style="text-align: right;" ng-if="r.IsReviewable == 1"><i class="fa fa-star txt-clr-8" aria-hidden="true"></i></div></div>{{r.Location}}</div></div></div><div ng-class="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible? \'col-lg-7 col-sm-7 col-xs-9 col-sm-7 m-0 wlh-pdf pl-0\' :\'col-lg-10 col-sm-10 col-xs-9 col-sm-10 m-0 wlh-pdf pl-0\'" id="{{OrderReport.OrderID}}"><div class="row 100 ng-scope ml-0" ng-if="report.DictationValue && reportList.length > 0"><div class="w-100 repoheight-2 rprtsinglwrklst overflow-y-auto overflow-x-hide py-10px px-10px bg-clr-49 repoHeiFtrWrklst"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div><div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box" id="{{OrderReport.OrderID}}" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"><div ng-include="\'peerReviewSection.html\'"></div></div></div></div></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail modal-search-contact" kendo-window="win_ContactList" k-on-open="iswin_ContactListVisible = true" k-on-close="iswin_ContactListVisible = false" k-title="\'Contact\'" k-visible="false" k-width="DataObject.win_ContactListWidth_new" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="iswin_ContactListVisible"><div class="modal-body p-0 sm-pr-0"><div class="row mb-10px"><div class="col-lg-5 col-sm-5 mb-5px"><label>Name</label> <input type="text" class="blk-input form-control" id="Name" ng-model="DataObject.FilterAddressBook.Name" autocomplete="off" ng-required="true" placeholder="Name"></div><div class="col-lg-5 col-sm-5 mb-5px"><label>Location</label> <input type="text" class="blk-input form-control" id="Location" ng-model="DataObject.FilterAddressBook.LocationName" autocomplete="off" ng-required="true" placeholder="Location" ng-disabled="true"></div><div class="col-lg-6 col-sm-12 mb-5px"><label>&nbsp;</label> <button class="btn btn-primary" ng-click="getContact(DataObject.FilterAddressBook.Name,DataObject.FilterAddressBook.LocationIDs,DataObject.FilterAddressBook.LocationName)">Search</button> <button class="btn btn-primary d-none" ng-click="addContact(FilterAddressBook.LocationIDs)">Add Contact</button></div></div><address-book-grid edit-contact="EditContact()" delete-contact="DeleteContact()" address-book-info="DataObject.AddressBookInfo" filter-address-book="DataObject.FilterAddressBook" view-mode="true" id="SearchContactModal"></address-book-grid></div></div></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_AddEditContact" k-on-open="iswin_AddEditContactVisible = true" k-on-close="iswin_AddEditContactVisible = false" k-visible="false" k-title="DataObject.win_AddEditContactTitle" k-width="DataObject.win_ContactListWidth" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="iswin_AddEditContactVisible"><div class="modal-body p-0 sm-pr-0"><address-book-contact-form address-book-info="DataObject.AddressBookInfo" on-save-contact="saveContact(DataObject.AddressBookInfo.Flag)" save-other-btn="false"></address-book-contact-form></div></div></div><div class="overflow-hide-all no-min-h-310px height-auto ERA-check-detail" kendo-window="win_HideStudy" k-on-open="isHideStudyVisible = true" k-on-close="isHideStudyVisible = false" k-title="\'Hide Study\'" k-visible="false" k-width="DataObject.win_HideStudyWidth" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="isHideStudyVisible"><form id="hidehours"><div class="row mb-20px"><div class="col-lg-12"><div class="row m-0"><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-md-12 col-sm-12 col-xs-12 px-0" ng-repeat="HiddenType in ::DataObject.HiddenTypeList | orderBy : \'Key\' | limitTo : 4"><label class="form-controller hideStudy-info d-flex align-item-center mb-10px" ng-class="{\'hide-study-select\' : (HiddenType.Key == DataObject.HideOption.Key)}" style="padding: 7px 10px !important; border: 1px solid #525252; border-radius: 5px;"><input type="radio" ng-model="DataObject.HideOption.Key" class="m-0 cmn-checkbx-input" ng-value="HiddenType.Key" id="{{HiddenType.ID}}" autocomplete="off" name="HiddenType" ng-click="clearCommentBox()"> <span class="rf-label cmn-check-label">{{HiddenType.Key}}</span> <i class="fa fa-info-circle pl-5px" tooltip-class="uibtooltipDenial" tooltip-placement="bottom" uib-tooltip="{{HiddenType.tooltip}}"></i></label></div></div><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-md-12 col-sm-12 col-xs-12 px-0" ng-repeat="HiddenType in ::DataObject.HiddenTypeList | orderBy : \'Key\' | limitTo : -3"><label class="form-controller hideStudy-info d-flex align-item-center mb-10px" ng-class="{\'hide-study-select\' : (HiddenType.Key == DataObject.HideOption.Key)}" style="padding: 7px 10px !important; border: 1px solid #525252; border-radius: 5px;"><input type="radio" ng-model="DataObject.HideOption.Key" class="m-0 cmn-checkbx-input" ng-value="HiddenType.Key" id="{{HiddenType.ID}}" autocomplete="off" name="HiddenType" ng-click="clearCommentBox()"> <span class="rf-label cmn-check-label">{{HiddenType.Key}}</span> <i class="fa fa-info-circle pl-5px" tooltip-class="uibtooltipDenial" tooltip-placement="bottom" uib-tooltip="{{HiddenType.tooltip}}"></i></label></div></div></div><div class="row mb-10px" ng-show="DataObject.HideOption.Key != \'Not to be Read\'"><div class="col-lg-12"><div class="px-15px"><textarea class="txt-area h-70px px-10px w-100" maxlength="2000" id="Comments" name="Comments" ng-model="DataObject.HideOption.Comments" placeholder="Add Comment" autocomplete="off"> </textarea></div></div></div></div></div><div class="w-100 py-15px"><div class="float-right"><button type="submit" class="btn btn-default mr-5px" data-dismiss="modal" ng-click="CancelHideStudy()">Cancel</button> <button type="submit" class="btn btn-primary" ng-click="HideStudy(DataObject.HideOption.Comments)">Save</button></div><div class="clearfix"></div></div></form></div></div><div class="overflow-hide-all ERA-check-detail report-popup px-5px ord-eve-logs comp-innotab px-0 py-0" kendo-window="win_shareExamsWindow" k-on-open="isShareExamWindowVisible = true;windowOpened(win_shareExamsWindow);" k-on-close="isShareExamWindowVisible = false;windowClosed(win_shareExamsWindow);" k-title="\'Share Exams\'" k-modal="true" k-visible="false" k-width="DataObject.defaultWindowWidth" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isShareExamWindowVisible"><div class="row mx-0"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Share Exams</a></li><studyactionmenu selected-order="SelectedOrderShareExam" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Share Exam"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="SelectedOrderShareExam" button-clicked="ButtonClicked(SelectedOrderShareExam)"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><shareexam on-send="setUserChat" selected-order="SelectedOrder" check="isShareExamWindowVisible" on-close="onCloseShareExamWindowHandler(check)"></shareexam></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs comp-innotab px-0 py-0" kendo-window="win_consultExamsWindow" k-on-open="isConsultExamsWindow = true;windowOpened(win_consultExamsWindow)" k-on-close="isConsultExamsWindow = false;windowClosed(win_consultExamsWindow)" k-title="\'Consult Exams\'" k-modal="true" k-visible="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isConsultExamsWindow"><div class="row mx-0"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Consult Exams</a></li><studyactionmenu selected-order="SelectedOrder" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Consult with Physician"></studyactionmenu></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="SelectedOrder" button-clicked="ButtonClicked(SelectedOrder)"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><videocallconsult class="clearfix video-call-consult" on-send="setUserChat" selected-order="SelectedOrder" check="isConsultExamsWindow" on-close="onCloseConsultExamWindowHandler(check)"></videocallconsult></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs comp-innotab" kendo-window="win_OrderEventLog" k-on-open="isOrderEventLogVisible = true;windowOpened(win_OrderEventLog)" k-on-close="isOrderEventLogVisible = false;windowClosed(win_OrderEventLog)" k-title="\'Order Event Logs\'" k-modal="true" k-visible="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isOrderEventLogVisible"><div class=""><div class=""><div class="row mx-0"><div class=""><studyactionmenu selected-order="SelectedOrder" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Order Event Logs"></studyactionmenu><patientdetails selected-order="SelectedOrder" button-clicked="ButtonClicked(SelectedOrder)"></patientdetails><div class="w-100"><div class="w-100 overflow-y-auto overflow-x-hide pt-10px pb-0 px-5px order-event-logsec"><event-log order-id="SelectedOrder.OrderID" accession="SelectedOrder.Accession"></event-log></div></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail px-0 py-0" kendo-window="win_ModalReportNDiscuss" k-visible="false" k-width="DataObject.defaultWindowWidth" k-height="DataObject.defaultWindowHeight" k-title="\'Report - Discussion\'" k-resize="winResize" k-dragend="winDragend" k-on-open="isModalReportNDiscussVisible = true;windowOpened(win_ModalReportNDiscuss)" k-on-close="CloseReportNDiscussionWindow()" k-modal="true" k-animation="false" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isModalReportNDiscussVisible" class="mdl-report-discsn"><div ng-include="\'faxModelBodyContent.html\'"></div><uib-tabset active="DataObject.ModalReportNDiscussActiveIndex" class="rf-uib-tabset"><uib-tab index="$index" ng-repeat="tab in ::DataObject.ModalReportNDiscussionTabs" heading="{{tab.title && tab.title.includes(\'Attachment\') ? tab.title + \' (\'+SelectedOrder.FileCount+\')\' : tab.title}}" disable="tab.disabled" select="onModalReportNDiscussionTabsChange(tab.title)" ng-if="tab.title.includes(\'Attachment\') ? SelectedOrder.FileCount > 0 : true"><div ng-include="tab.templateUrl"></div></uib-tab><studyactionmenu selected-order="SelectedOrder" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Report-Discussion" class="mdl-action-wrapper"></studyactionmenu><div class="btns-chsnxtstudy d-flex align-item-center" ng-if="DataObject.ShowPrevNextBtn"><button ng-click="SignAndPrevRec()" class="btn btn-primary btn-sm tultip-bottom fs-12px fw-600 d-flex align-item-center justify-content-center line-height-normal border-0" title="" ng-disabled="DataObject.NoPrevOrder" tooltip-class="uibtooltipDenial tt-chsnxtstd" uib-tooltip-html="DataObject.SingReport.PrevToolTip" tooltip-placement="auto bottom" tooltip-append-to-body="true"><i class="fa fa-chevron-left pr-2px"></i>Previous</button> <button ng-click="SignAndNextRec()" class="btn btn-primary btn-sm tultip-bottom fs-12px fw-600 d-flex align-item-center justify-content-center line-height-normal border-0" title="" ng-disabled="DataObject.NoNextOrder" tooltip-class="uibtooltipDenial tt-chsnxtstd" uib-tooltip-html="DataObject.SingReport.NextToolTip" tooltip-placement="auto bottom" tooltip-append-to-body="true">Next<i class="fa fa-chevron-right pl-2px"></i></button></div></uib-tabset></div></div><script type="text/ng-template" id="tree_item_renderer.html"><div> <div> <div class="wrps-discus-chats fs-13px text-break-word bg-clr-29 bor-rad-5px p-15px-all"> <p class="discus-chats txt-clr-1 mb-0" style="white-space:pre-line">{{Dis.Comment | htmlDecode}}</p> </div> <div class="float-right py-5px"> <div class="tultip-top float-left"> <a class="btn btn-default glyphicon glyphicon-share-alt border-0" ng-click="Dis.IsChild=!Dis.IsChild"></a> <span class="tultiptext">Reply</span> </div> <div class="float-left pt-3px"> <span class="txt-clr-1 fs-15px dis-crt-name" ng-if="disName(Dis)">{{disName(Dis) | htmlDecode}}</span> <span class="txt-clr-2 fs-12px"> {{Dis.Record_Created_At|localDate :false }}</span> </div> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div class="" ng-if="Dis.IsChild"> <div class="mb-10px w-70 pull-right"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Dis.ChildComment" placeholder="Add a comment"> </textarea> </div> <div class="clearfix"></div> <div class="mb-10px"> <button type="button" class="btn btn-primary pull-right" ng-click="SaveChildDiscussion(Dis)">Save</button> <div class="clearfix"></div> </div> </div> </div> <div class="clearfix"></div> </div> <ul style="list-style:none"> <li class="mb-10px" ng-repeat="Dis in Dis.Childs" ng-include="\'tree_item_renderer.html\'"></li> </ul></script><div class="overflow-hide-all ERA-check-detail" kendo-window="win_PSUser" k-on-open="ReviewOrder.IsReportReviewEditable=false;isPSUserVisible = true" k-on-close="isPSUserVisible = false" k-title="\'Login\'" k-visible="false" k-width="DataObject.win_PSUserWidth" k-height="300" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Close"]\'><div ng-if="isPSUserVisible"><div class="pScript m-0-auto pb-20px"><h5>Please provide your credentials below for the dictation system where your radiology report needs to be placed.</h5><form name="PSUserform" id="PSUserform" ng-submit="InsertPSUsersBySIte(PSUserform.$valid)"><div class="w-30 float-left"><label class="rf-label">Location:</label></div><div class="w-70 float-left"><label class="fw-500 txt-clr-1 p-2px-all">{{DataObject.SingReport.OrderList[SingReport.Index].Location}}</label></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Username:</label></div><div class="w-70 float-left"><input type="text" id="PSUserUsername" name="PSUserUsername" ng-model="PSUser.Username" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Password:</label></div><div class="w-70 float-left"><input type="password" id="PSUserPassword" name="PSUserPassword" ng-model="PSUser.Password" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-primary">Log On</button></div><div class="clearfix"></div></form></div></div></div><script type="text/ng-template" id="modal_report_tab.html"><div id="Report" style="opacity:1 !important" class="overflow-x-hide pt-5px pb-0 px-0"> <div class="max-h-90vh h-80vh p-0 mt-5px" ng-if="!isReportAvailable"> <patientdetails selected-Order="SelectedOrder" button-clicked="ButtonClicked(SelectedOrder)"></patientdetails> <div class="d-flex justify-content-center align-item-center" style="height:50vh;"> <h2 class="txt-clr-1 text-center"> Report not available</h2> </div> </div> <div class="" ng-if="isReportAvailable"> <!--<div class="row mb-20px m-0" id="OrderReport{{OrderReport.Accession}}" ng-if="OrderReport.OrderReport.ReportDecation.length > 0">--> <div class="row mb-0 mx-0 m-0" ng-if="!DataObject.ShowReportModal"> <div class="col-md-12 p-0"> <div class="m-0"> <patientdetails selected-Order="ReportSelectedOrder" button-clicked="ButtonClicked(ReportSelectedOrder)"></patientdetails> <div class="row m-0 rprtdscn-fbtns-wrapper" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"> <button type="button" class="btn btn-primary rf-btn-xs pull-right mr-10px" ng-click="HideShowReviewReportAction()" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable">{{ReviewOrder.ReviewReportButtonText}}</button> </div> <div class="row m-0" id="{{OrderReport.OrderID}}"> <!--<report-viewer ng-if="selecteReportId" source-id="selecteReportId"></report-viewer>--> <div ng-class="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible ? \'col-lg-9 col-sm-9 col-xs-9\' :\'col-lg-12 col-sm-12 col-xs-12\'" id="{{OrderReport.OrderID}}" style="padding:0!important;"> <div class="w-100" ng-if="report.DictationValue"> <div class="w-100 repoheight-4 overflow-y-auto overflow-x-hide py-10px px-15px reportmaxwin-2 bg-clr-49"> <!--<pre style="word-break:break-all;white-space:pre-line; background-color:transparent; border:none;font-size:18px;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace;"> {{report.DictationValue}} </pre>--> <report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height: 1.4;font-family: Menlo, Monaco, Consolas, \'Courier New\', monospace !important;white-space: pre-line;background-color: transparent;border: none;font-size: 16px;"></report> </div> </div> </div> <div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box" id="{{OrderReport.OrderID}}" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"> <div ng-include="\'peerReviewSection.html\'"></div> </div> </div> </div> </div> </div> <div class="m-0" ng-if="DataObject.ShowReportModal"> <patientdetails selected-Order="ReportSelectedOrder" button-clicked="ButtonClicked(ReportSelectedOrder)"></patientdetails> <div class="rprtdscn-fbtns-wrapper d-flex align-item-center justify-content-between p-5px-all px-10px"> <div class="d-flex align-item-center"> <div class="width-100 mr-15px"> <input type="text" class="blk-input form-control col-placeholder h-25px input-filterreport" placeholder="Search" ng-model="DataObject.SearchText" ng-keyup="FilterReportList(true)"> </div> <ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap mr-15px"> <li class="pos-rel align-self-center mr-15px"> <a class="border-0 btnpopover-sorting bor-rad-2px py-4px px-4px fs-10px text-center" ng-click="DataObject.displaySortPopover = true" uib-tooltip="{{DataObject.SelectedSortingOption}}" tooltip-placement="top" ng-style="DataObject.displaySortPopover == true ? {\'background-color\':\'#05c1a4\'} : {\'background-color\': \'rgba(5, 193, 164, 0.19);\'}"> <i class="fa fa-sort-amount-asc" aria-hidden="true"></i> </a> <div class="popover-sorting p-5px-all bor-rad-2px" ng-show="DataObject.displaySortPopover" ng-mouseleave="DataObject.displaySortPopover = false"> <a class="popover-sorting-item d-block p-5px-all cursor-pointer fs-12px fw-400 txt-clr-1" ng-repeat="list in DataObject.ReportSortingOptions" ng-class="{\'active\' : list == DataObject.SelectedSortingOption}" ng-click="onReportSortingClicked(list)">{{list}}</a> </div> </li> <li class="text-center" ng-repeat="list in DataObject.ReportList.DateRange" ng-class="{\'active\' : DataObject.ReportListFilter.DateRange == list}" ng-click="DataObject.ReportListFilter.DateRange=list;FilterReportList(true)"> <a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a> </li> </ul> <ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap"> <li class="text-center" ng-repeat="list in DataObject.ReportList.Modalities track by $index" ng-class="{\'active\' : DataObject.ReportListFilter.Modality == list}" ng-click="DataObject.ReportListFilter.Modality=list;FilterReportList(true)"> <a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a> </li> </ul> </div> <div class="d-inline-block pull-right" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"> <button type="button" class="btn btn-primary rf-btn-xs pull-right mr-10px" ng-click="HideShowReviewReportAction()" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable">{{ReviewOrder.ReviewReportButtonText}}</button> </div> </div> <div class="row m-0"> <div class="col-lg-2 col-sm-2 col-xs-3 m-0 pl-0 pr-0 pr-5px bg-clr-49"> <div class="overflow-auto repoheight-2 repoHeiFtrWrklst ftlrbtns-height"> <div ng-repeat="r in reportList | orderBy: DataObject.ReportSortingPropName : DataObject.ReportSortingRevOrder" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #959595 1px solid;cursor:pointer; word-wrap: break-word !important;"> {{r.ProcedureDesc}} <div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}"> DOS : {{r.FormattedOrderDate | date:\'MM/dd/yyyy\'}} <div style="text-align: right;" ng-if="r.IsReviewable == 1"><i class="fa fa-star txt-clr-8" aria-hidden="true"></i></div> </div> <!--<span ng-hide="DataObject.RemoveRenderingPhysicianReport && DataObject.EnableRowsForSelectedTenants && DataObject.EnableRowsForSelectedTenants.includes(SelectedOrder.TenantName)">{{r.SignByName}}</span>--> {{r.Location}} </div> </div> </div> <div ng-class="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible? \'col-lg-7 col-sm-7 col-xs-9 col-sm-7 m-0 wlh-pdf px-0\' :\'col-lg-10 col-sm-10 col-xs-9 col-sm-10 m-0 wlh-pdf px-0\'" id="{{OrderReport.OrderID}}"> <!--<report ng-bind-html="OrderReport.OrderReport.ReportDecation" style="white-space:pre-line;"></report>--> <!--<report-viewer ng-if="selecteReportId" source-id="selecteReportId"></report-viewer>--> <div class="w-100" ng-if="report.DictationValue && reportList.length > 0"> <div class="w-100 repoheight-5 filtr-repoheight-5 overflow-y-auto overflow-x-hide py-5px px-10px leftsecmaxwindowht bg-clr-49"> <!--<pre style="white-space:pre-line; background-color:transparent; border:none; font-size:18px; font-weight:bold;"> {{report.DictationValue}} </pre>--> <report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:16px;"></report> </div> </div> </div> <div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box-1" id="{{OrderReport.OrderID}}" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"> <div ng-include="\'peerReviewSection.html\'"></div> </div> </div> </div> </div> </div></script><script type="text/ng-template" id="modal_discussion_tab.html"><div id="Discussion" style="opacity:1 !important"> <div class="fw-500 pt-5px"> <patientdetails selected-Order="DiscussionSelectedOrder" button-clicked="ButtonClicked(DiscussionSelectedOrder)"></patientdetails> <div> <div class="row m-0"> <div class="col-lg-3 col-md-3 col-sm-3 p-0"> <div ng-if="ODType==\'Assigner\'"> <ui-select ng-model="OrderDiscussion.SelectedUser" theme="bootstrap" class="dicom-inp-w" ng-disabled="OrderDiscussion.ID"> <ui-select-match allow-clear="true" placeholder="Select Radiologist"> {{radDisplay($select.selected)}}</ui-select-match> <ui-select-choices repeat="list in DataObject.masterData.Radiologists | filter: isVisibleRad | propsFilter: {FirstName: $select.search, LastName: $select.search} | orderBy:\'LastName\'"> <small> <i class="fa fa-circle" ng-class="{\'text-success\':list.IsOnline,\'text-gray-dark\':!list.IsOnline}"></i> {{radDisplay(list)}} </small> </ui-select-choices> </ui-select> </div> </div> </div> <div class="row m-0"> <div class="col-md-12 p-0" ng-if="ODType==\'Discussion\' || ODType==\'Helper\'"> <div class="form-group my-10px p-0"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea> </div> <div class="col-lg-12 col-md-12 p-0"> <button type="button" class="btn btn-primary pull-right border-0" ng-click="SaveDiscussion()">Save</button> </div> </div> <div class="col-md-12 pr-0 pl-0 " ng-if="ODType==\'Assigner\'"> <div class="col-md-12 form-group my-10px p-0"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea> </div> <button type="button" ng-hide="OrderDiscussion.ID" class="btn btn-primary pull-right ml-5px" ng-click="SaveOrderDiscussion()">Consult Study</button> <button type="button" ng-hide="OrderDiscussion.ID" class="btn btn-primary pull-right ml-5px" ng-click="AssignStudy()">Assign Study</button> <button type="button" ng-if="OrderDiscussion.ID" class="btn btn-primary pull-right" ng-click="SaveDiscussion()">Save</button> </div> <div class="clearfix h-10px"></div> <div class="discus-comment overflow-y-auto py-10px px-10px wl-async"> <!--discuss--> <div class=""> <div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div> <div class="clearfix"></div> </div> </div> </div> </div> </div> </div></script><script type="text/ng-template" id="modal_attachment_tab.html"><div class="fw-500 pt-5px"> <patientdetails selected-Order="DiscussionSelectedOrder" button-clicked="ButtonClicked(DiscussionSelectedOrder)"></patientdetails> <div id="" class="mt-5px" style="opacity:1 !important"> <div class="fw-500 pt-10px"> <div class="new-wl-rep-dis"> <div class="discussion-attachment-sec overflow-x-hide"> <div class="row m-0"> <attachment-viewer ng-if="DataObject.Reference.ID" dicomorder="DataObject.Reference" send-fax="openFaxModal(faxFile)" selected-order="DiscussionSelectedOrder"></attachment-viewer> </div> </div> </div> </div> </div> </div></script><div class="modal fade z-i-9999" id="ModalDicomViewerCredentials" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important; z-index:99999 !important;"><div class="modal-dialog mdvcpopup"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Centricity Login</h4></div><div class="modal-body"><div class=""><div class="mdvctxt"><div class="row"><div class="col-md-12 col-sm-12 txt-clr-1"><h5 class="txt-clr-1 fs-18px">GE Healthcare</h5></div><div class="col-md-12 col-sm-12"><h4 class="txt-clr-1 fs-22px">Centricity<sup>*</sup></h4><h2 class="txt-clr-1 fs-26px">Universal Viewer</h2></div></div></div><div class="mdvcfrmouter"><form name="DVCredform" ng-submit="InsertDicomViewerCredentials(DVCredform.$valid)" class="mdvcfrm"><div class="w-30 float-left"><label class="txt-clr-1 fw-500">Username:</label></div><div class="w-70 float-left"><input type="text" name="DVCredUsername" ng-model="DVCred.Username" ng-required="true" class="w-100 blk-input form-control" autocomplete="on"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="txt-clr-1 fw-500">Password:</label></div><div class="w-70 float-left"><input type="password" name="DVCredPassword" ng-model="DVCred.Password" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-primary">Login</button></div><div class="clearfix"></div></form></div><div class="row"><div class="col-md-12 col-sm-12 text-left"><img src="assets/images/mdvc.png"></div></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs comp-innotab" kendo-window="win_addendum_request" k-on-open="DataObject.AddendumRequest.showAddendumReq = true;windowOpened(win_addendum_request)" k-on-close="onAddendumReqClose();windowClosed(win_addendum_request)" k-title="\'Addendum Request\'" k-modal="true" k-visible="false" k-animation="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="DataObject.AddendumRequest.showAddendumReq"><div class="row px-10px mx-0"><studyactionmenu selected-order="SelectedOrder" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Addendum Request"></studyactionmenu><patientdetails selected-order="SelectedOrder" button-clicked="ButtonClicked(SelectedOrder)"></patientdetails><div class="w-100 pt-10px pb-0 px-0"><div class="col-md-12 mb-10px px-0 txt-clr-1 sm-mt-10px"><div class="d-flex align-item-center toggle-div pt-10px pb-10px"><div class="w-400px"><ui-select class="mult-select" ng-model="DataObject.AddendumRequest.AssignedUser" tooltip-class="uibtooltipDenial" uib-tooltip="{{DataObject.AddendumRequest.AssignedUserTooltip}}" tooltip-placement="auto top" on-select="onAddendumUserSelect()"><ui-select-match placeholder="Select Radiologist" allow-clear="true">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices style="max-height:150px !important;" repeat="list in DataObject.masterData.Radiologists | filter: isVisibleRad | filter: $select.search" position="down"><div ng-bind-html="radDisplay(list) | highlight: $select.search"></div><small><span class="d-block" ng-if="list.Email"><i class="fa fa-envelope pr-4px"></i>{{list.Email}}</span> <span class="d-block" ng-if="list.PhoneNumber"><i class="fa fa-phone-square pr-4px"></i>{{list.PhoneNumber}}</span></small></ui-select-choices></ui-select></div><label class="rf-label mb-0 ml-20px">High Priority</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.AddendumRequest.isHighPriorityAddendum"> <span class="checkbox-switch-slider round"></span></label></div></div></div><div class="col-md-12 p-0 clearfix"><label class="rf-label">Reason *</label> <textarea class="txt-area mt-1 h-70px w-100 p-5px-all" ng-model="DataObject.AddendumRequest.AddendumComment" placeholder="Reason for Addendum Request (Required)"> </textarea></div><div><button type="button" class="btn btn-primary mt-10px pull-right" ng-click="UpdateAddendumRequestReportStatus()" ng-disabled="!(DataObject.AddendumRequest.AssignedUser && DataObject.AddendumRequest.AddendumComment)">Send Request</button></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs comp-innotab" kendo-window="win_peer_review" k-on-open="DataObject.PeerReview.showPeerReview = true;windowOpened(win_peer_review)" k-on-close="onPeerReviewClose();windowClosed(win_peer_review)" k-title="\'Peer Review\'" k-modal="true" k-visible="false" k-animation="false" k-width="DataObject.defaultWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="DataObject.PeerReview.showPeerReview"><div class="row px-10px mx-0"><studyactionmenu selected-order="SelectedOrder" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Peer Review"></studyactionmenu><patientdetails selected-order="SelectedOrder" button-clicked="ButtonClicked(SelectedOrder)"></patientdetails><div class="w-100 pt-10px pb-0 px-0"><div class="col-md-12 mb-10px px-0 txt-clr-1 sm-mt-10px" ng-show="!DataObject.isAutoAssignPeerReviewWin"><div class="d-flex align-item-center toggle-div pt-10px pb-10px"><div class="w-400px"><ui-select class="mult-select" ng-model="DataObject.PeerReview.AssignedUser" tooltip-class="uibtooltipDenial" uib-tooltip="{{DataObject.PeerReview.AssignedUserTooltip}}" tooltip-placement="auto top" on-select="onPeerReviewUserSelect()"><ui-select-match placeholder="Select Radiologist" allow-clear="true">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices style="max-height:150px !important;" repeat="list in DataObject.masterData.PeerReviewRadiologists | filter: $select.search" position="down"><div ng-bind-html="radDisplay(list) | highlight: $select.search"></div><small><span class="d-block" ng-if="list.Email"><i class="fa fa-envelope pr-4px"></i>{{list.Email}}</span> <span class="d-block" ng-if="list.PhoneNumber"><i class="fa fa-phone-square pr-4px"></i>{{list.PhoneNumber}}</span></small></ui-select-choices></ui-select></div></div></div><div class="col-md-12 p-0 clearfix"><textarea class="txt-area mt-1 h-70px w-100 p-5px-all" ng-model="DataObject.PeerReview.Comment" placeholder="Reason for Peer Review (Optional)"> </textarea></div><div><button type="button" class="btn btn-primary mt-10px pull-right" ng-click="AddOrderToSpecificPeer()" ng-disabled="!(DataObject.PeerReview.AssignedUser)" ng-if="!DataObject.isAutoAssignPeerReviewWin">Send Request</button> <button type="button" class="btn btn-primary mt-10px pull-right" ng-click="AutoAssignPeerReview()" ng-if="DataObject.isAutoAssignPeerReviewWin">Send Request</button></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup ord-eve-logs" kendo-window="win_query_retrive" k-on-open="DataObject.onQueryRetrive = true;windowOpened(win_query_retrive)" k-on-close="DataObject.onQueryRetrive = false;windowClosed(win_query_retrive)" k-title="\'Query Retrieve\'" k-modal="true" k-visible="false" k-animation="false" k-width="DataObject.winAddendumReqWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\'><div class="container-fluid"><form ng-submit="QueryRetrieveFilter(true)"><div class="row"><div class="col-sm-3 col-md-2 col-xs-6 pd-lr tultip-bottom pl-0 mb-5px">First Name <input ng-model="DataObject.QueryRetrieve.FirstName" type="text" class="blk-input form-control col-placeholder" placeholder="First Name" tooltip-class="uibtooltipDenial" uib-tooltip="First Name" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr pl-0 mb-5px">Last Name <input ng-model="DataObject.QueryRetrieve.LastName" type="text" class="blk-input form-control col-placeholder" placeholder="Last Name" tooltip-class="uibtooltipDenial" uib-tooltip="Last Name" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-pr-0 pl-0 mb-5px">MRN <input ng-model="DataObject.QueryRetrieve.PatientMRN" type="text" class="blk-input form-control col-placeholder" placeholder="MRN" tooltip-class="uibtooltipDenial" uib-tooltip="MRN" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-pr-0 pl-0 mb-5px">Accession <input ng-model="DataObject.QueryRetrieve.Accession" type="text" class="blk-input form-control col-placeholder" placeholder="Accession" tooltip-class="uibtooltipDenial" uib-tooltip="Accession" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-pr-0 pl-0 mb-5px">DOS <input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="DataObject.QueryRetrieve.OrderDate" options="DataObject.QueryRetrieve.opts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial" uib-tooltip="{{DataObject.QueryRetrieve.toolTipOrderDate}}" tooltip-placement="bottom" ng-mouseenter="resetDateRange()"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-w-50 filt-btn-sec mob-pr-0 px-0 mt-20px pl-0 mb-5px"><button type="submit" class="btn btn-primary pull-left rf-btn-xs pb-6px" ng-disabled="DataObject.QueryRetrieve.IsSearchingData">Search</button> <button type="button" ng-click="ClearQueryRetrieve()" class="btn btn-default pull-left ml-2 rf-btn-xs pb-6px">Clear</button></div></div></form></div><div ng-if="DataObject.onQueryRetrive" class="mt-20px"><div class="row mb-5px"><div class="col-md-12 d-flex justify-content-end"><div class="d-flex align-item-center toggle-div p-6px-all" style="border-right: 1px solid #0c6c5e;"><label class="rf-label mb-0">Expand All</label> <label class="checkbox-switch pref-checkbox ml-5px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.QueryRetrieve.IsExpanded" ng-click="ExpandCollapseData(DataObject.QueryRetrieve.IsExpanded)" ng-disabled="DataObject.QueryRetriveObj.patients.length == 0"> <span class="checkbox-switch-slider round"></span></label></div><div class="d-flex align-item-center toggle-div p-6px-all ml-5px" style="border-right: 1px solid #0c6c5e;"><label class="rf-label mb-0">Select All Studies</label> <label class="checkbox-switch pref-checkbox ml-5px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.QueryRetrieve.IsAllStudySelected" ng-click="ExpandCollapseData(DataObject.QueryRetrieve.IsAllStudySelected,true)" ng-disabled="DataObject.QueryRetriveObj.patients.length == 0"> <span class="checkbox-switch-slider round"></span></label></div><button type="button" class="btn btn-primary rf-btn-xs mr-5px ml-10px" title="Retrieve" ng-disabled="DataObject.QueryRetrieve.IsRetrieveBtnDisabled || DataObject.QueryRetriveObj.patients.length == 0" ng-click="MoveInstance()">Retrieve</button></div></div><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="DataObject.isLoadingQueryRetrieve"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div id="myQueryGrid" class="myGrid ag-theme-balham-dark query-grid" style="height: 500px"></div></div></div><div class="overflow-hide-all ERA-check-detail modal-search-contact" kendo-window="win_LocationContact" k-on-open="LocationContactWindowVisible = true" k-on-close="LocationContactWindowVisible = false" k-title="\'View Contact Details\'" k-visible="false" k-width="DataObject.LocationContactWindowWidth" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="LocationContactWindowVisible"><div class="modal-body p-0 sm-pr-0"><div class="row mb-10px"><div class="location-top col-lg-8 col-sm-8 mb-5px"><site-location-grid master-locations="DataObject.masterData.Locations" selected-location="DataObject.FilterLocationAddressBook" on-change="updateSelectedLocationContact()"></site-location-grid></div><div class="col-lg-4 col-sm-4 mb-5px"><button class="btn btn-primary" ng-click="getLocationContact(DataObject.FilterLocationAddressBook.Ids,DataObject.FilterLocationAddressBook.LocationName)">Search</button></div></div><address-book-grid filter-address-book="DataObject.FilterLocationAddressBook" view-mode="true" id="SearchLocationContactModal" grid-height="{{DataObject.addressBookGridHeight}}"></address-book-grid></div></div></div><div class="overflow-hide-all ERA-check-detail modal-search-contact alertStatStudiesFirst" kendo-window="win_STATStudiesFirst" k-on-open="STATStudiesFirstWindowVisible = true" k-on-close="STATStudiesFirstWindowVisible = false" k-title="false" k-visible="false" k-width="DataObject.STATStudiesFirstWindowWidth" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-animation="false"><div ng-if="STATStudiesFirstWindowVisible"><h1 class="fs-18px fw-600 d-flex mb-15px"><i class="fa fa-exclamation-triangle mr-10px fs-24px" aria-hidden="true" style="color: #ff5050;"></i> STAT STUDIES FIRST!</h1><p class="fs-14px txt-clr-1 mb-5px">You have STAT studies on your worklist.</p><p class="fs-14px txt-clr-1 mb-15px">Please prioritize these before Routine exams to ensure timely patient care.</p><div class="row mb-20px"><div class="col-md-12"><p class="fs-14px mb-10px txt-clr-1 fw-600">What would you like to do?</p></div><div class="row pl-10px m-0"><div class="col-sm-4 col-md-4"><label class="form-controller d-flex align-item-center flex-wrap mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="statStudiesOption" ng-model="DataObject.SingReport.STATStudies" value="YES"> <span class="rf-label cmn-check-label pl-10px">Go to STAT studies</span></label></div><div class="col-sm-8 col-md-8"><label class="form-controller d-flex align-item-center flex-wrap mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="statStudiesOption" ng-model="DataObject.SingReport.STATStudies" value="NO"> <span class="rf-label cmn-check-label pl-10px">Continue to Routine (Override Warning)</span></label></div></div></div><div class="row mb-25px" ng-if="DataObject.SingReport.STATStudies == \'NO\'"><div class="col-md-12"><p class="fs-14px mb-10px txt-clr-1 fw-600">Reason for overriding STAT priority:</p></div><div class="row pl-10px m-0"><div class="col-sm-12 col-md-12 mb-8px" ng-repeat="reason in DataObject.masterData.RoutineStudiesReasons"><label class="form-controller d-flex align-item-center flex-wrap mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="ReasonStudyOption" ng-model="DataObject.SingReport.SelectedRoutineStudyReason" ng-value="reason.Value"> <span class="rf-label cmn-check-label pl-10px">{{reason.Value}}</span></label></div></div></div><div class="d-flex align-item-center justify-content-end"><button type="button" class="btn btn-default rf-btn-md sm-btn-height" ng-click="closeSTATStudiesFirstWin()"><span class="text-capitalize">Cancel</span></button> <button type="button" class="btn btn-primary rf-btn-md sm-btn-height ml-10px" ng-disabled="!(DataObject.SingReport.STATStudies == \'YES\' || (DataObject.SingReport.STATStudies == \'NO\' && DataObject.SingReport.SelectedRoutineStudyReason))" ng-click="OnUpdateAllowRoutineStudies()"><span class="text-capitalize">Update</span></button></div><div class="mt-20px"><p class="fs-12px fw-400 mb-0" style="color: #eaeaea !important;letter-spacing: 0.2px;"><span class="fw-600">Disclosure:</span> Please be aware that prioritizing routine exams over pending STAT studies delays critical care, as STAT exams are currently waiting on your worklist.</p></div></div></div><script type="text/ng-template" id="faxModelBodyContent.html"><div class="modal fade bsmodal-sendfax" id="SendFaxModal" role="dialog" data-keyboard="false" data-backdrop="static"> <div class="modal-dialog create-filter"> <!-- Modal content--> <div class="modal-content"> <div class="new-popup"> <div class="modal-header"> <button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button> <h4 class="modal-title">Send Fax</h4> </div> <div class="modal-body"> <div class="row"> <div class="col-md-12 mb-10px fax-multiselectbox tultip-bottom" ng-if="DataObject.FaxDetails.FaxNumberList.length > 0"> <label class="rf-label">Fax Number</label> <multi-Select master-data="DataObject.FaxDetails.FaxNumberDropdown" list="DataObject.FaxDetails.FaxNumberList" ng-model="DataObject.FaxDetails.FaxNumberDropdown.SelectedValue" on-change="DataObject.FaxDetails.FaxNumberDropdown.onFaxNumbChanged(selectedData)"> </multi-Select> <span ng-class="{\'list-tooltip\' : DataObject.FaxDetails.FaxNumberDropdown.SelectedValue.list.length > 0}" class="tultiptext text-preline overflow-auto max-h-500px text-left tt-white tt-top">{{(DataObject.FaxDetails.FaxNumTooltip)?DataObject.FaxDetails.FaxNumTooltip:\'Select Fax Number\'}}</span> </div> <div class="col-md-12 mb-20px"> <label class="rf-label">Enter Fax Number</label> <input type="text" id="FaxNumText" class="form-control inputfax-numner" name="faxnumber" ui-mask="(999) 999-9999" maxlength="15" ng-model="DataObject.FaxDetails.FaxNumber" autocomplete="off" /> </div> <div class="col-md-12"> <button type="button" class="btn btn-primary float-right" ng-disabled="validateFaxNumText()" ng-click="SendFax()">Send Fax</button> </div> </div> </div> </div> </div> </div> </div></script><script type="text/ng-template" id="peerReviewSection.html"><div ng-if="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible"> <div ng-form="review" class="p-10px-all"> <div class="row"> <div class="col-md-12 form-group fw-600" ng-if="ReviewOrder.IsReportReviewEditable"> For Interesting Cases: <input type="checkbox" class="v-a-m ml-5px mt-0 cmn-checkbx-input" ng-checked="ReviewOrder.IsInterestingCase" ng-model="ReviewOrder.IsInterestingCase" ng-disabled="!ReviewOrder.IsReportReviewEditable" /> </div> <div class="col-md-12 form-group mb-5px" ng-if="ReviewOrder.IsReportReviewEditable"> <table class="patient-table w-100 b-1-s b-clr-1"> <thead> <tr class="bg-clr-23" style="border:0!important;background-color:#05c1a4!important;"> <th class="w-40px text-center py-2px fw-600">Sr.</th> <th class="py-2px fw-600">Score</th> </tr> </thead> <tbody class="bg-clr-23 pt-5px"> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">1</td> <td> <div style="padding: 0px 5px 5px 5px;" class="txt-clr-1"> <input class="pos-rel mt-0 cmn-checkbx-input" style="top:2px;" type="radio" ng-click="ReviewOrder.Rating=\'1\'" ng-checked="ReviewOrder.Rating==\'1\'" ng-disabled="!ReviewOrder.IsReportReviewEditable"> Concur with Interpretation </div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">2</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/not ordinarily expected to be made(understandable miss)</span> <div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1 " ng-click="ReviewOrder.Rating=\'2a\'" ng-checked="ReviewOrder.Rating==\'2a\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">2a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'2b\'" ng-checked="ReviewOrder.Rating==\'2b\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">2b.Likely to be signficant</div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">3</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/Should be made most of time</span> <br> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'3a\'" ng-checked="ReviewOrder.Rating==\'3a\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">3a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'3b\'" ng-checked="ReviewOrder.Rating==\'3b\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">3b.Likely to be signficant</div> </td> </tr> <tr class="bg-clr-23" style="border: 0 !important;"> <td class="text-center v-a-t w-40px txt-clr-1">4</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/Should be made almost every time - misinterpretation of findings</span><br /> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'4a\'" ng-checked="ReviewOrder.Rating==\'4a\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">4a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'4b\'" ng-checked="ReviewOrder.Rating==\'4b\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">4b.Likely to be signficant</div> </td> </tr> </tbody> </table> </div> <div class="col-md-12 col-sm-12 mb-10" ng-if="ReviewOrder.IsInterestingCase && ReviewOrder.IsReportReviewEditable"> <span ng-if="ReviewOrder.IsInterestingCase" style="color:white;float:left;">Keywords *</span> <input type="text" class="blk-input form-control w-100 mb-10px" name="keyword" ng-model="ReviewOrder.Keywords" placeholder="Keywords." ng-required="ReviewOrder.IsInterestingCase" ng-disabled="!ReviewOrder.IsReportReviewEditable"> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div class="col-md-12 form-group mb-0 fw-600"> <div ng-if="ReviewOrder.IsReportReviewEditable"> <span ng-if="ReviewOrder.IsInterestingCase" style="color:white; float:left;">Add a comment *</span> <div class="clearfix"></div> <textarea class="txt-area h-70px w-100 p-5px-all" rows="4" name="comment" ng-model="ReviewOrder.Comments" placeholder="Add a comment." ng-required="ReviewOrder.IsInterestingCase"> </textarea> </div> <div ng-if="!ReviewOrder.IsReportReviewEditable && ReviewOrder.Comments"> <span style="color:white; float:left;">Comment: {{ReviewOrder.Comments}}</span> </div> </div> <div class="col-md-12"> <button type="button" class="btn btn-primary pull-right m-1" ng-click="SetOrderPeerReview()" ng-if="ReviewOrder.IsReportReviewEditable" ng-disabled="disableReportReviewBtn()">Save</button> </div> </div> </div> </div></script>');
$templateCache.put('app/theme/components/assign-radiologist-grid/assign-radiologist-grid.html','<style>\r\n    .ag-cell {\r\n        color: white !important;\r\n    }\r\n</style><div class="new-popup"><div class="modal-header" ng-if="!$ctrl.viewMode"><button type="button" class="close adjBtn-2" data-dismiss="modal" aria-label="Close" ng-click="cancel()">&times;</button><h4 class="modal-title f-f-quicksand fs-15px">{{$ctrl.modalTitle}}</h4></div><div class="modal-body"><div class="w-100" style="border-bottom: 1px solid gray; margin-bottom: 5px" ng-if="$ctrl.siteTitle"><h4 class="fs-14px txt-clr-1 mb-5px fw-600">Site: {{$ctrl.siteTitle}}</h4></div><div class="w-100 pt-10px"><div class="row m-0 pb-2"><div class="col-md-4 col-sm-4 pl-0 mb-10px"><input type="text" class="blk-input form-control" ng-model="search" placeholder="Search Users" ng-keydown="$event.keyCode === 13 && FilterRadiologist()"></div><div class="col-md-4 col-sm-4 pl-0 tultip-bottom mb-10px"><tenant-site-dropdown class="site-editor" master-sites="MasterData.Sites" selected-sites="SelectedSiteValues"></tenant-site-dropdown></div><div class="col-md-4 col-sm-4 pl-0 mb-10px"><button type="button" ng-click="FilterRadiologist()" title="Filter" class="btn btn-primary"><i class="fa fa-search"></i></button> <button type="button" class="btn btn-default pb-5px" title="Clear" ng-click="clearFilter()"><i class="glyphicon mt-2px glyphicon-remove"></i></button> <span class="txt-clr-1 pull-right mt-5px" ng-if="$ctrl.radioLogistCmpTooltipId==\'radioLogistManageLocationCmp\'">All Users</span> <label class="checkbox-switch ml-10px mb-0 mt-5px pull-right" title="Show All" ng-if="$ctrl.radioLogistCmpTooltipId==\'radioLogistManageLocationCmp\'"><input type="checkbox" ng-model="ShowAllUserSwitch.Obj" class="mr-2px" ng-change="FilterRadiologist()"> <span class="checkbox-switch-slider round"></span></label></div><div class="w-45 float-left"><label for="aclients" class="rf-label mx-1px p-5px-all mb-0" style="background-color: #1c1c1c;">Available Users</label><div id="AvailableRadGridDiv" class="ag-theme-balham-dark w-100 h-500px"></div></div><div class="w-10 float-left px-10px"><div class="h-100px">&nbsp;</div><div class=""><input id="moveright" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value=">" ng-click="moveAvailableToSelected()"></div><div class=""><input id="move left" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value="<" ng-click="moveSelectedToAvailable()"></div></div><div class="w-45 float-left"><label for="sclients" class="rf-label mx-1px p-5px-all mb-0" style="background-color: #1c1c1c;">Selected Users</label><div id="SelectedRadGridDiv" class="ag-theme-balham-dark w-100 h-500px"></div></div></div></div><div class="border-0 py-10px pr-10px"><div class="form-actions text-right"><button type="button" class="btn btn-primary" ng-click="Save()">{{$ctrl.btnText}}</button></div></div></div></div>');
$templateCache.put('app/theme/components/assign-radiologists-cmp/assign-radiologists-cmp.html','<style>\r\n    .rad-name {\r\n        padding: 3px 5px;\r\n        margin: 3px 7px;\r\n        border: 1px solid #00584b;\r\n        border-radius: 4px;\r\n    }\r\n</style><div ng-class="{\'b-1-s b-clr-1\': !$ctrl.viewMode}" class="overflow-y-auto overflow-x-hide pos-rel d-flex flex-wrap min-h-10vh max-h-65px radlogist-wraaper"><div ng-class="{\'col-lg-1 col-md-2 col-sm-2\': !$ctrl.viewGroup && !$ctrl.flag ,\'col-lg-3 col-md-3 col-sm-3\': $ctrl.viewGroup, \'col-lg-2 col-md-2 col-sm-2\': !$ctrl.viewGroup && $ctrl.flag }" class="rad-name word-break-word ws-normal" ng-repeat="Radiologists in assignedRadiologist" ng-if="radDisplay(Radiologists)"><i class="fa fa-caret-right text-white"></i> <span class="fs-12px fw-400">{{radDisplay(Radiologists)}}</span></div></div>');
$templateCache.put('app/theme/components/attachment-viewer/attachment-viewer.html','<div ng-show="isLoading" class="spinner-overlay pos-abs"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="row"><div class="col-sm-3 col-xs-3 viewer-block overflow-y-auto overflow-x-hide pr-0"><div class="cursor-pointer attach-wrapper {{file.Id}}" ng-repeat="file in FileList"><div class="bb-1-s b-clr-1 py-10px attchment-block"><a class="viewer-a w-c-100-30px float-left cursor-pointer ttfilename" ng-click="showFile(file.FilePath, file.FileType, file.Id, file.FileName);"><i class="fa fa-file-pdf-o fs-18px float-left w-30px text-center" ng-if="file.FileType ==\'application/pdf\'"></i> <i class="fa fa-file-image-o fs-18px float-left w-30px text-center" ng-if="file.FileType ==\'image/jpeg\' || file.FileType ==\'image/jpg\' || file.FileType ==\'image/png\'"></i> <i class="fa fa-files-o fs-18px float-left w-30px text-center" ng-if="file.FileExtension == \'.doc\' || file.FileExtension == \'.docx\' || file.FileExtension == \'.csv\' || file.FileExtension == \'.ppt\' || file.FileExtension == \'.pptx\' || file.FileExtension == \'.xls\' || file.FileExtension == \'.xlsx\'"></i><div class="float-left w-c-100-30px text-truncate {{((currState == \'techno\') && file.UploadBy == userId) ? \'long-filename\' : \'wl-longfilename\'}}" tooltip-class="uibtooltipDenial" uib-tooltip="{{file.FileName}}" tooltip-placement="auto top">{{file.FileName}}</div><div class="clearfix"></div></a><div class="w-30px float-left text-center"><a class="cursor-pointer delicon" ng-if="(!(currState== \'physician-worklist\' && userRole.includes(\'Physician\'))) && (userRole.includes(\'SuperAdmin\')|| userRole.includes(\'Admin\') || file.UploadBy == userId)" ng-click="deleteFile(file)" tooltip-class="uibtooltipDenial" tooltip-placement="auto top" uib-tooltip="{{file.FileName}}"><i class="fa fa-trash pos-rel fs-18px" aria-hidden="true"></i></a></div><div class="clearfix"></div></div><hr class="helpPoupup m-0 border-0"></div></div><div class="col-sm-9 col-xs-9 sm-pl-0px" align="center"><div id="LoadFile"><file-viewer data-title="\'Preview\'" ng-if="fileurl" file-name="fileName" file-content="fileurl" file-binary-content="file.FileContent" file-path="filePath" file-type="FileType" send-fax="$ctrl.sendFax({faxFile:file})" selected-order="$ctrl.selectedOrder"></file-viewer></div></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<style>\r\n    .al-sidebar-sublist {\r\n        display: none;\r\n    }\r\n\r\n    .al-sidebar-list li.al-sidebar-list-item:hover > .al-sidebar-sublist {\r\n        position: absolute !important;\r\n        min-width: 170px !important;\r\n        display: block;\r\n    }\r\n    .al-sidebar-list li.al-sidebar-list-item .ba-sidebar-sublist-item:hover > .al-sidebar-sublist {\r\n        position: absolute !important;\r\n        min-width: 100% !important;\r\n        display: block;\r\n        left: 175px;\r\n        top: 0;\r\n    }\r\n    .tab-active {\r\n        background-color: #1f1f1f;\r\n        border-bottom: 3px solid #04c1a3;\r\n    }\r\n</style><aside class="al-sidebar target-slimsrcoll" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item mr-10px" ng-class="::{\'with-sub-menu\': item.subMenu , \'peer-badge-step\': item.title == \'Peer Review\'}" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::(!item.subMenu && item.title != \'Analytics\')" ng-hide="!((item.title == \'Payment Invoice History\' && ShowPaymentInvoiceHistory != null) ? ShowPaymentInvoiceHistory: true)" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }} <span class="notification-label label-danger set-pos-right fs-10px border-radius-50-all badge px-4px py-2px" style="vertical-align:baseline" ng-if="item.title == \'Peer Review\' && PeerReviewPendingCount > 0">{{PeerReviewPendingCount}}</span></span></a> <a ng-mouseenter="hoverItem($event, item)" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::(!item.subMenu && item.title == \'Analytics\')" class="al-sidebar-list-link" ng-click="onMenuOptionClicked(menuItems,item.stateRef)" ng-class="{\'tab-active\': currentStateTitle == \'Analytics\'}"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist width-190-px" ng-class="{\'slide-right\': item.slideRight}"><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" class="al-sidebar-list-link subitem-submenu-link"><i class="fa fa-caret-right mr-0"></i> <span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}"><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link"><i class="fa fa-angle-right"></i> {{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}"><i class="fa fa-angle-right"></i> {{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link"><i class="fa fa-caret-right"></i> {{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}"><i class="fa fa-caret-right"></i> {{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/chat/chat.html','<style>\r\n    .display-block {\r\n        display: block !important;\r\n    }\r\n\r\n    .display-none {\r\n        display: none !important;\r\n    }\r\n\r\n    .d-grid {\r\n        display: grid;\r\n    }\r\n\r\n    .progress-striped .progress-bar.grid-xs-loader, .progress-bar-striped.progress-bar-striped.grid-xs-loader {\r\n        background-color: #05c1a4 !important;\r\n        background-size: 10px 10px !important;\r\n        background-image: linear-gradient(45deg, #2e2d32 25%, transparent 25%, transparent 75%, #2e2d32 50%, #2e2d32 80%, transparent 95%, transparent) !important;\r\n    }\r\n\r\n    #chat-bottom-btn {\r\n        position: absolute;\r\n        right: 14px;\r\n        bottom: 65px;\r\n        padding: 5px 8px;\r\n        background: #424242;\r\n        border-radius: 50% !important;\r\n        cursor: pointer;\r\n        color: #00dfbd !important;\r\n        border: 1px solid #00dfbd;\r\n        font-size: 14px;\r\n        text-align: center;\r\n    }\r\n\r\n        #chat-bottom-btn:hover {\r\n            color: white !important;\r\n            background: #00dfbd;\r\n            border: 0;\r\n        }\r\n\r\n    .daterangepicker {\r\n        z-index: 10007 !important;\r\n    }\r\n</style><div class="dummychat chatsec" id="controllerId"><div class="control-sidebar pt-0 w-auto" ng-class="(isChatMenuActive)?\'display-block\':\'display-none\'"><div class="w-450px p-0 float-left contsidebar-sec mob-w-100" style="display:none;" ng-class="(isShowChatWindow)?\'display-block\':\'display-none\'"><div class="col-lg-12 col-xs-12 p-0"><div class="chat-header"><p class="m-0 txt-clr-1 fs-15px d-inline-block float-left fw-600 text-truncate text-capitalize">{{maskName(selectedUserObject.LastName, selectedUserObject.FirstName, selectedUserObject.UserRoles, selectedUserObject.Id) | lowercase}} <i class="fa fa-commenting-o fs-14px blinkicon px-1px"></i></p><span class="v-a-m fs-15px" ng-click="openVideoChat(selectedUserObject.FirstName + \' \' + selectedUserObject.LastName, false,\'\')" data-bs-toggle="modal" data-bs-target="#container"><i class="fa fa-video-camera" aria-hidden="true"></i></span> <span class="v-a-m pl-3px fs-15px icon-hover" ng-click="minChatWindow()" ng-show="!hideChatWindow" title="Minimize"><i class="fa fa-minus" aria-hidden="true"></i></span> <span ng-click="maxChatWindow()" ng-show="hideChatWindow" title="Maximize"><span class="v-a-m pl-2px icon-hover fs-18px k-icon k-i-window-maximize"></span></span> <span class="fa fa-close v-a-m fs-16px icon-hover" title="Close" ng-click="closeChatWindow()"></span><div class="clearfix"></div></div><div class="chat-inner bg-clr-31" style="border: 1px solid #46454a;"><div class="chat-history overflow-hide-all pt-10px"><div style="background-color: #2e2d32 !important; position:relative;" ng-show="showChatLoader"><div class="progress m-0" style="background-color: #2e2d32 !important; margin-bottom:-20px !important"><div class="progress-bar progress-bar-striped grid-xs-loader pos-abs h-2px active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div id="messageMe" ng-scroll-bottom="" scrollbottom="MessageList" scrollltobottom="scrolllToBottom" deletemessagescrollposition="DeleteMessageScrollPosition" when-scrolled-top="GetMessageNextPage()" class="chat-history-inner msg-sec w-100 scrollbar-macosx overflow-x-hide" ng-show="!IsShowCategoryUsers"><div ng-repeat="curMessageObj in MessageList" adapter="adapter" buffer-size="1" top-visible="topVisibleMessage" class="width-inherit"><div class="width-inherit"><div ng-if="getMessageDate(curMessageObj)" class="stick z-i-10" scrolling-elem="myScrollingView" listen-resize="listenResize" ng-sticky=""><div class="sticky-timer-placeholder d-block min-width-1 pos-rel py-2"><span class="sticky-timer-text text-center text-uppercase fw-700 l-s-0-075 fs-11px txt-clr-26 d-block w-90 m-0-auto lh-1-0 bb-1-s b-clr-15"><span class="bg-clr-31 px-10px">{{getMessageDate(curMessageObj)}}</span></span></div></div></div><div ng-if="currUserId != curMessageObj.FromUserId" class="chat-message-container width-inherit height-auto clearfix my-5px"><div class="incmg-message-column w-100 mob-w-100 float-left clearfix pos-rel mb-10px"><div class="chat-profile-img float-left no-bg pos-rel rel-t-20-p"><div class="chat-name-circle d-flex align-item-center justify-content-center receiver-pic-bg"><div ng-if="!selectedUserObject.ProfilePic" class="user-profile-name">{{maskInitials(selectedUserObject.LastName, selectedUserObject.FirstName, selectedUserObject.UserRoles, selectedUserObject.Id)}}</div><img class="rounded-circle weight-inherit height-inherit br-upi" data-toggle="modal" ng-src="{{selectedUserObject.ProfilePic}}" ng-if="selectedUserObject.ProfilePic"></div></div><div class="otg-message-action-container float-right w-20px no-bg trans-200-all-linear pos-rel rel-t-25-p" style="left:-10px"><button class="btn-secondary p-0 no-bg a-txt-clr-2-t-1 trans-200-bg-linear border-0 tultip-left" type="button" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && curMessageObj.Message.includes(\'Call has been scheduled\')" ng-click="reScheduledCall(curMessageObj)"><i class="fa fa-calendar fs-16px fw-500 txt-clr-33"></i> <span class="tultiptext tt-white">Reschedule</span></button></div><div class="chat-message-container-placeholder float-left height-auto rounded chatmsg-width" ng-class="(curMessageObj.isDeleted) ? \'bg-clr-21 txt-clr-3\' : (curMessageObj.isHighPriority) ? \'no-bg receiver-name-clr highprio-msg\' : \'no-bg receiver-name-clr\'"><div class="no-bg pl-10px"><div class="mb-5px"><span class="chat-profile-name fs-12px fw-500 text-capitalize">{{maskName(selectedUserObject.LastName, selectedUserObject.FirstName, selectedUserObject.UserRoles, selectedUserObject.Id) | lowercase}}</span> <span class="chat-message-time m-0 float-right v-a-m fs-12px fw-500 txt-clr-26">{{curMessageObj.MessageTime| utcToLocal:\'M/d/yy HH:mm\'}}</span></div><div class="chat-message width-auto height-auto pt-0 pb-0px"><div class="width-inherit height-inherit"><div class="fs-13px fw-500 text-ws-pl text-break-word mb-1 txt-clr-1 p-10px-all bor-rad-8px pos-rel speechreceived bg-clr-44 rightline d-flex justify-content-between" style="align-items:flex-start" ng-if="!curMessageObj.isFile && curMessageObj.Message.includes(\'|SHAREEXAMOBJ|\')"><div style="display: inline-grid;width:100%"><p class="m-0 d-table p-0" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[0]!=\'undefined\' || curMessageObj.Message.includes(\'Call has been scheduled\') || curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')"><span>{{curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[0] | limitTo:curMessageObj.numLimit}}</span> <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span></p><p ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1].length>0" class="fs-12px d-grid mb-1 fw-500 m-0 p-0 txt-clr-14"><span>Name: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span>MRN: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'MRN\')}}</span> <span>Accession: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'ACCESSION\')}}</span></p><button ng-click="OpenExam(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1])" class="btn btn-default rf-btn-xs px-4px py-2px fs-11px" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1].length>0" style="position: absolute; right: 10px; bottom: 10px;">Open Exam</button></div></div><p class="fs-13px fw-500 text-ws-pl text-break-word mb-1 txt-clr-1 p-10px-all bor-rad-8px pos-rel speechreceived bg-clr-44 rightline" ng-if="!curMessageObj.Message.includes(\'|SHAREEXAMOBJ|\') && !curMessageObj.isFile && !curMessageObj.Message.includes(\'Call has been scheduled\') && !curMessageObj.Message.includes(\'Video Call Link\') && !curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')"><span class="d-inline-block no-w-c-100-58px">{{curMessageObj.Message | limitTo:curMessageObj.numLimit}}</span> <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span></p><p class="fs-13px fw-500 text-ws-pl text-break-word mb-1 txt-clr-1 p-10px-all bor-rad-8px pos-rel speechreceived bg-clr-44 rightline" ng-if="!curMessageObj.isFile && (curMessageObj.Message.includes(\'Call has been scheduled\') || curMessageObj.Message.includes(\'Video Call Link\') || curMessageObj.Message.includes(\'wants to consult a study for the below procedure\'))"><span class="d-inline-block no-w-c-100-58px">{{curMessageObj.Message | limitTo:curMessageObj.numLimit}}</span> <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span> <span class="d-flex justify-content-end align-item-center mt-8px"><button ng-click="OpenExamVideoConf(curMessageObj.Message)" class="btn btn-default rf-btn-xs px-4px py-2px fs-11px" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && (curMessageObj.Message.includes(\'Call has been scheduled to consult a study for the below procedure\') || curMessageObj.Message.includes(\'wants to consult a study for the below procedure\'))">Open Exam</button> <a class="vc-text vc-link d-flex justify-content-center align-item-center w-58px ml-8px px-4px py-2px" href="#" ng-click="openVideoChat(selectedUserObject.FirstName + \' \' + selectedUserObject.LastName,true,curMessageObj)"><span>Join Now</span></a></span></p><p class="fs-13px fw-500 text-ws-pl text-break-word mb-1 text-left bor-rad-8px bg-clr-44 mt-5px pos-rel py-10px px-10px speechreceived" ng-if="curMessageObj.isFile"><i class="fa fa-download cursor-pointer p-10px-all fs-15px bg-clr-31 bor-rad-8px w-100" ng-click="downloadFile(curMessageObj)"><span class="txt-clr-1 pl-5px fs-13px v-a-t">{{curMessageObj.FileName}}</span></i></p></div></div></div></div></div></div><div ng-if="currUserId == curMessageObj.FromUserId" class="chat-message-container width-inherit height-auto clearfix my-5px"><div class="otgmg-message-column w-100 mob-w-100 float-right clearfix pos-rel mb-10px"><div class="chat-profile-img float-right no-bg pos-rel rel-t-20-p"><div class="chat-name-circle sender-pic-bg d-flex align-item-center justify-content-center"><div ng-if="!userObj.profilePic" class="user-profile-name">{{currLastName.substring(0,1) + \'\' + currFirstName.substring(0,1)}}</div><img class="rounded-circle weight-inherit height-inherit br-upi" data-toggle="modal" ng-src="{{userObj.profilePic}}" ng-if="userObj.profilePic"></div></div><div class="chat-message-container-placeholder float-right height-auto rounded chatmsg-width" ng-class="(curMessageObj.isDeleted) ? \'bg-clr-38 txt-clr-17\' : (curMessageObj.isHighPriority) ? \'no-bg txt-clr-17 highprio-msg\' : \'no-bg txt-clr-17\'"><div class="no-bg pr-10px"><div class="mb-5px"><span class="chat-profile-name fs-12px fw-500 text-capitalize sender-name-clr">{{(currLastName + \' \' + currFirstName) | lowercase}}</span> <span class="chat-message-time m-0 float-right v-a-m fs-12px fw-500 txt-clr-26">{{curMessageObj.MessageTime | utcToLocal:\'M/d/yy HH:mm\'}}</span></div><div class="chat-message width-auto height-auto pt-0 pb-0px"><div class="width-inherit height-inherit"><div class="fs-13px fw-500 text-ws-pl text-break-word mb-0 d-flex justify-content-between text-left txt-clr-1 py-8px px-12px bor-rad-8px pos-rel speechsent sender-msg-bg-clr leftline" style="align-items:flex-start" ng-if="!curMessageObj.isFile && curMessageObj.Message.includes(\'|SHAREEXAMOBJ|\')"><div style="display: inline-grid;width:100%"><p class="m-0 d-table p-0" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[0]!=\'undefined\'"><span>{{curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[0] | limitTo:curMessageObj.numLimit}}</span> <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span></p><p class="fs-12px mb-1 d-grid fw-500 m-0 p-0 txt-clr-14" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1].length>0"><span>Name: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span>MRN: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'MRN\')}}</span> <span>Accession: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'ACCESSION\')}}</span></p><button ng-click="OpenExam(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1])" class="btn btn-default rf-btn-xs px-4px py-2px fs-11px" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1].length>0" style="position: absolute; right: 10px; bottom: 10px;">Open Exam</button></div></div><p class="fs-13px fw-500 text-ws-pl text-break-word mb-0 text-left txt-clr-1 py-8px px-12px bor-rad-8px pos-rel speechsent sender-msg-bg-clr leftline" ng-if="!curMessageObj.Message.includes(\'|SHAREEXAMOBJ|\') && !curMessageObj.isFile">{{curMessageObj.Message | limitTo:curMessageObj.numLimit}} <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span> <span class="d-flex justify-content-end align-item-center mt-8px"><button ng-click="OpenExamVideoConf(curMessageObj.Message)" class="btn btn-default rf-btn-xs px-4px py-2px fs-11px" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && (curMessageObj.Message.includes(\'Call has been scheduled to consult a study for the below procedure\') || curMessageObj.Message.includes(\'wants to consult a study for the below procedure\'))">Open Exam</button> <a class="vc-text pos-set-right vc-link d-inline-block w-58px ml-8px px-4px py-2px" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && curMessageObj.Message.includes(\'Call has been scheduled\') && !curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')" ng-click="scheduledCallJoin(curMessageObj)"><span class="">Join Now</span></a><a class="vc-text pos-set-right vc-link d-inline-block w-58px ml-8px px-4px py-2px" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && !curMessageObj.Message.includes(\'Call has been scheduled\') && curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')" ng-click="scheduledCallJoin(curMessageObj)"><span class="">Join Now</span></a></span></p><p class="fs-13px fw-500 text-ws-pl text-break-word m-0 text-left bor-rad-8px sender-msg-bg-clr py-8px px-12px pos-rel speechsent" ng-if="curMessageObj.isFile"><i class="fa fa-download cursor-pointer fs-12px w-100" ng-click="downloadFile(curMessageObj)"><span class="txt-clr-1 pl-5px fs-13px fw-500 v-a-t">{{curMessageObj.FileName}}</span></i></p></div></div></div></div><div class="otg-message-action-container float-right w-20px no-bg trans-200-all-linear pos-rel rel-t-25-p"><button class="btn-secondary p-0 no-bg a-txt-clr-2-t-1 trans-200-bg-linear border-0 tultip-top" type="button" ng-if="!curMessageObj.isDeleted" ng-click="deleteMsg(curMessageObj)"><i class="fa fa-trash fs-18px fw-500 txt-clr-33"></i> <span class="tultiptext tt-white">Delete</span></button></div><div class="otg-message-action-container float-right w-20px no-bg trans-200-all-linear pos-rel rel-t-25-p mt-7px"><button class="btn-secondary p-0 no-bg a-txt-clr-2-t-1 trans-200-bg-linear border-0 tultip-right" type="button" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && curMessageObj.Message.includes(\'Call has been scheduled\')" ng-click="reScheduledCall(curMessageObj)"><i class="fa fa-calendar fs-16px fw-500 txt-clr-33"></i> <span class="tultiptext tt-white">Reschedule</span></button></div></div><div class="clearfix"></div></div></div><button type="button" ng-click="topFunction()" id="chat-bottom-btn" tooltip-class="uibtooltipDenial" uib-tooltip="Back to Bottom" tooltip-placement="auto left"><i class="fa fa-chevron-down"></i></button></div></div><div class="chat-user-action-container w-100 bg-clr-31 pos-rel"><div class="show-hi-pri-alert a-trans-t-500-cb highpriority-alert-section show-hi-pri-alert-active" style="top:-40px;" ng-show="isHighPriority"><h5 class="m-0 text-center fs-12px pt-1 txt-clr-1 rounded">You have clicked on High-Priority Message. This message will be sent as a High Priority message.</h5></div><div class="chat-user-action-inner w-100 height-inherit pos-rel bg-clr-31 typesec"><div class="ui-chat-reply-container w-100 h-30px"><div class="ui-chat-highpriority float-left w-20px height-inherit v-a-m text-center"><button type="button" class="btn-secondary width-inherit height-inherit no-bg otln-0 a-txt-clr-2-t-1 tultip-top fs-20px" ng-disabled="isDisabled()" ng-click="changePriority()" ng-style="{ \'cursor\' : (isDisabled()) ? \'not-allowed\' : \'pointer\' }" tooltip-class="uibtooltipDenial" uib-tooltip="Mark as Important" tooltip-placement="auto top-left"><span ng-class="{\'txt-clr-6\':isHighPriority,\'txt-clr-14\':!isHighPriority}"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></button></div><div class="ui-chat-reply-placeholder w-c-100-50px my-0 mx-5px float-left b-1-s b-clr-3 bg-clr-44 bor-rad-5px nohvr" style="border-color: #686868 !important;"><textarea placeholder="Type your message here. (Ctrl + Enter to break line)" id="message" ng-model="message" ng-trim="true" ng-keydown="onFolderNumberKeyPress($event,message)" ng-disabled="EnterKeyFlag" spellcheck="true" class="w-90 border-0 no-resize otln-0 fs-13px scrollbar-macosx overflow-x-hide no-bg txt-clr-19 bor-rad-5px bg-clr-44 typeheresec" data-jquery-scrollbar=""></textarea></div><div class="ui-chat-utility-placeholder float-left w-20px height-inherit v-a-m"><div class="image-upload w-20px h-20px float-left cursor-pointer pos-rel"><label for="file-input" class="text-center tultip-top pos-abs chatclip mx-8px" tooltip-class="uibtooltipDenial" uib-tooltip="Allowed: pdf, doc, docx, xls, xlsx, csv, zip, jpg, png, gif, bmp, tiff, dcm, txt (max 5MB)" tooltip-placement="auto top" style="top:10px;left:-40px;"><img src="assets/images/clip-01.svg" class="attach-icon cursor-pointer" alt="Attach File"></label><input id="file-input" type="file" style="display:none" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx" onchange="angular.element(this).scope().uploadFile(this)"></div><div class="float-left w-20px" role="group" aria-label="Chat Utility Action"><button type="button" class="btn-secondary p-0 otln-0 chat-send-btn border-0 no-bg cursor-pointer pos-rel" style="left: 2px; top: -10px;" tooltip-class="uibtooltipDenial" uib-tooltip="Send" tooltip-placement="auto left" ng-disabled="isSendDisabled()" ng-click="sendMessage(message)" ng-style="{ \'cursor\' : (isDisabled()) ? \'not-allowed\' : \'pointer\' }"><svg class="send-icon" width="27" height="29" viewbox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.6882 0.473358C26.5362 0.31426 26.3442 0.204107 26.1347 0.15585C25.9252 0.107593 25.7069 0.123237 25.5056 0.200944L0.726865 9.67618C0.513168 9.76142 0.329188 9.91301 0.19936 10.1108C0.069532 10.3086 0 10.5433 0 10.7836C0 11.0239 0.069532 11.2586 0.19936 11.4564C0.329188 11.6542 0.513168 11.8058 0.726865 11.891L10.4018 15.9535L17.5426 8.42072L19.1307 10.0907L11.9561 17.6354L15.8306 27.8094C15.9141 28.0298 16.0586 28.2188 16.2453 28.3518C16.4321 28.4848 16.6525 28.5558 16.8781 28.5556C17.1057 28.5507 17.3266 28.4734 17.5115 28.3338C17.6965 28.1943 17.837 27.9991 17.9143 27.7739L26.9248 1.71698C27.0015 1.50743 27.02 1.27926 26.9781 1.05907C26.9363 0.838885 26.8357 0.635751 26.6882 0.473358Z" ng-style="{\'fill\': isHighPriority ? \'#c73e3e\' : \'#07E6C4\'}"></path></svg></button></div></div><div class="clearfix"></div></div><div class="chat-istyping-container w-100"><div class="chat-istyping-inner w-30 m-y-0-125 height-2 pos-abs abs-l-0 pl-5px"><h5 class="px-0 m-0 p-y-0-1875 fs-12px txt-clr-10 fw-400 fs-13px" ng-show="isTypingMessage"><span class="fw-400 txt-clr-10">{{isTypingMessage}}</span></h5></div></div></div></div></div></div></div><div class="w-240px mob-w-100 mob-h-100vh float-left bg-clr-50 pb-10px pr-0 ch-userlist" style="border: 1px solid #46454a;"><div class="user-search-placeholder w-100 pos-rel abs-t-0 h-80px bg-clr-32"><div class="row mx-0 p-t-0-25"><div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 bg-clr-50"><div class="input-group w-100 mb-8px dummychat-placeholder"><div class="d-flex justify-content-between align-content-center mb-5px pb-5px chat-users-header pl-10px" style="border-left: 5px solid #18bd9f;"><span class="d-inline-block fs-15px fw-600 fc-ffffff align-self-center ct-usrs--heading">Chat</span> <a ng-click="activeChatMenuBar()"><span class="chervon-toggle icon-hover-bg close-ct-users align-self-center"><i class="fa fa-close txt-clr-14 cursor-pointer fs-12px fw-500"></i></span></a></div><div style="background-color: #2e2d32 !important; position:relative;" ng-show="showUsersLoader"><div class="progress m-0" style="background-color: #2e2d32 !important; margin-bottom:-20px !important"><div class="progress-bar progress-bar-striped grid-xs-loader pos-abs h-2px active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div><input type="text" class="searchBar blk-input mt-5px form-control ui-user-search txt-clr-1 fw-100 border-0 float-left mr-0 ml-10px bg-clr-31 w-96 pr-62px" ng-model="UserName" placeholder="I\'m looking for" tooltip-class="uibtooltipDenial" uib-tooltip="Last Name, First Name" tooltip-placement="auto top" ng-change="OnChangeFilter()" ng-model-options="{ debounce: 500 }"></div></div></div></div></div><div id="UserLsitID" infinitescroll="UserListNextPage()" style="overflow: auto; box-shadow: none !important; outline: 0 !important; border-left-color: #1e1e1e !important;" class="user-list-placeholder w-100 pos-rel abs-t-3 scrollbar-macosx overflow-x-hide p-r-2 pt-1 pl-10px"><div><div id="collapseContent_demo" role="tabpanel" aria-labelledby="heading_demo" class="collapse in"><div ng-repeat="curUserObj in userList track by curUserObj.Id" ng-click="itemClicked(curUserObj,isShareChatLink)" ui-draggable="true" drag="curUserObj" drag-channel="priests" on-drop-success="dropSuccessHandler($event, $index, userListVM)" set-profile-pic="" class="trans-200-bg-linear width-inherit pos-rel fx-fade-normal fx-dur-300 fx-ease-cubic fx-stagger-0 chat-userlist-container h-42px cursor-pointer py-3px mb-1px ng-scope user-container no-bg" ng-class="(!curUserObj.IsInvited) ? ((selectedUserId && curUserObj.Id == selectedUserId) ? \'user-obj-selected user-container\' : \'user-container no-bg\') : \'pointer-null\'"><div class="user-container-inner w-100 pos-abs clearfix no-bg pl-3px" ng-click="((!curUserObj.IsGroupType) ? ((curUserObj.IsInvited) ? \'\' : setUserChat(curUserObj)) : setGroupChat(curUserObj))"><div class="user-active-state-indicator w-5px height-inherit float-left pos-rel"><div class="user-active-state-indicator-inner width-0-25 height-inherit" ng-class="(!curUserObj.IsInvited) ? ((curUserObj.Id == selectedUserId) ? \'\' : \'\') : \'\'"></div></div><div class="chat-name-circle list-userpic-bg"><i class="fa fa-circle pos-rel usr-circle" ng-class="{\'usronline\':curUserObj.IsOnline,\'txt-clr-25\':!curUserObj.IsOnline}"></i><div ng-if="!curUserObj.ProfilePic"><div ng-if="!curUserObj.IsGroupType"><div data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="profilepic">{{maskInitials(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id)}}</div></div><div ng-if="curUserObj.IsGroupType"><div data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="otln-0"><ng-avatar string="#" width="40" max-length="1" upper-case="true" data-toggle="modal" bind="true" bg-color="#0774c6" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="br-upi"></ng-avatar></div></div></div><img class="rounded-circle weight-2-5 br-upi w-40px h-40px" data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" ng-src="{{curUserObj.ProfilePic}}" ng-if="curUserObj.ProfilePic"></div><div class="user-bio-placeholder w-c-100-75px height-inherit pos-rel float-left no-bg pl-6px"><div class="chat-and-time" ng-class="(selectedUserId && curUserObj.Id == selectedUserId) ? \'txt-clr-1\' : \'\'"><div class="chat-user-name txt-clr-1 w-120px" tooltip-class="uibtooltipDenial" uib-tooltip="{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}" tooltip-placement="auto top">{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}</div><div class="chat-content w-150px pt-1"><i class="fa fa-share fs-12px" ng-if="!(curUserObj.FileName.length > 0) && (curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)"></i> <i class="fa fa-paperclip fs-12px" ng-if="curUserObj.FileName.length > 0"></i> <span ng-if="!(curUserObj.FileName.length > 0) && (curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] != \'undefined\')">{{curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0]}}</span> <span ng-if="!(curUserObj.FileName.length > 0) && (curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] == \'undefined\')">{{ViewPatientDetails(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span ng-if="!(curUserObj.FileName.length > 0) && !(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)">{{curUserObj.LastMessage}}</span> <span ng-if="curUserObj.FileName.length > 0">{{curUserObj.FileName}}</span></div><span class="pos-abs chat-content" style="right: -35px; top: 0; font-size:10px;" ng-if="curUserObj.LastMessage.length > 0">{{LastMessageTimeStamp(curUserObj.MessageDT)}}</span></div></div><div class="user-action-placeholder w-30px height-inherit float-left no-bg" ng-show="curUserObj.IsInvited"><div class="invited-user-container d-table width-inherit height-inherit" ng-show="curUserObj.IsInvited"><i class="icon-envelope-letter d-table-cell text-center fs-1-25 v-a-m txt-clr-2"></i></div></div><div class="message-ticker-placeholder height-inherit float-right no-bg message-number-indicator" style="position: absolute; bottom:0; right: 4px;" ng-show="curUserObj.UnreadMsgCount > 0"><div class="message-ticker-inner d-table height-inherit width-inherit"><div class="message-ticker d-table-cell text-center v-a-m height-inherit width-inherit fw-700"><span class="d-inline-block min-width-17px border-radius-50-all width-inherit bg-c73434 txt-clr-1 fs-10px p-2px-all">{{curUserObj.UnreadMsgCount}}</span></div></div></div></div></div></div></div></div></div></div></div><script type="text/ng-template" id="UserMessageExpiryModal.html"><div class="new-popup"> <div class="modal-header p-0-625-all border-0 messageexpirytimer-modal-header"> <button type="button" class="close pos-abs abs-t-0 abs-r-0 width-1-875 height-1-875" data-dismiss="modal" aria-label="Close" ng-click="cancel()"> <span aria-hidden="true"><i class="icon-close"></i></span> </button> <h4 class="modal-title fs-0-8125 fw-700"> Message Expiry Timer <small class="d-block">Change message expiry timer.</small> </h4> <input type="hidden" ng-model="hdntoUserId" /> </div> <div class="modal-body"> <form name="frmUserSettings" ng-submit="SaveMySettings(frmUserSettings.$valid)"> <div class="row mx-0"> <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 px-0 br-1-s"> <h5 class="fs-0-75 txt-clr-3">Your message will expire in: </h5> <h4 class="txt-clr-10 fw-700 fs-20px">{{messageExpiryResult}} <small class="fs-0-625" ng-show="messageExpiryResult">(hh:mm:ss)</small></h4> </div> <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 px-0"> <div class="switch-wrapper float-right"> <h5 class="fs-0-75 txt-clr-3 text-right">Do you want to use default expiry time? </h5> <div class="onoffswitch"> <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" ng-model="useDefaultExpirySetting" ng-change="setUserExpirySetting();" id="myonoffswitch"> <label class="onoffswitch-label" for="myonoffswitch"> <span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> </label> </div> </div> </div> </div> <hr /> <div ng-show="!useDefaultExpirySetting" class="width-inherit height-auto" ng-cloak> <div class="row mx-0"> <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0"> <h5 class="fs-0-75 fw-700 text-center text-warning">Set your own message expiry time limit.</h5> </div> </div> <div class="row mx-0"> <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0"> <h5 class="fs-0-75 txt-clr-3 text-center">Set expiry timer between <span class="fs-0-8125 fw-700 txt-clr-10">00:15:00</span> to <span class="fs-0-8125 fw-700 txt-clr-10">{{maxRangeLimit}}</span> range.</h5> <div uib-timepicker id="messageExpiryTimepicker" name="msgExpiryTimepicker" ng-model="messageExpiryTimeLimit" ng-change="ChangeMessageExpiryTime(frmUserSettings, messageExpiryTimeLimit)" show-seconds="true" hour-step="1" minute-step="1" second-Step="15" show-meridian="false" required style="width:170px;" class="d-block m-0-auto"></div> <div ng-show="frmUserSettings.msgExpiryTimepicker.$invalid && !frmUserSettings.msgExpiryTimepicker.$pristine" class="alert alert-danger fs-0-75 fw-700 text-center fx-zoom-normal fx-dur-600 fx-ease-none" role="alert" ng-cloak> Set expiry timer between <span class="fs-0-8125 fw-700 txt-clr-1">00:15:00</span> to <span class="fs-0-8125 fw-700 txt-clr-1">{{maxRangeLimit}}</span> range. </div> </div> </div> </div> <div class="row mx-0"> <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 justify-content-center"> <button type="submit" id="btnSave" class="btn btn-primary" ng-disabled="!messageExpiryResult">Save Changes</button> <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button> </div> </div> </form> </div> </div></script><div kendo-window="window" k-on-close="closeKendoVideoChat()" k-visible="false" class="modal-RadSceureVCall overflow-auto svcall pb-0px px-3px pt-1px bg-clr-51 overflow-x-hide"><div class="spin-loader-lrg h-100-per" ng-show="showVideoChatLoader"><div class="page-inner-content-loader pos-abs w-100 h-100 abs-t-0 abs-l-0 z-i-10"><div class="pos-rel w-100 h-100 d-table" ng-cloak=""><div class="content-loader-container w-100 h-90vh d-table-cell v-a-m"><div class="loader-blue m-0-auto"></div></div></div></div></div><patientdetails ng-if="selectedOrder.Location" selected-order="selectedOrder" class="vcall-patdetails"></patientdetails><div id="container" class="container video-conf-section"><div id="local" class="participant"><div class="pos-rel"></div><div class="me-text nameLabel">Me</div><div class="conf-btn-sec"><button id="join_leave" class="btn videobtn joincall-off" title="End call"></button> <button id="share_screen" class="btn videobtn sharescreen-on" title="Share screen"></button> <button id="mute-unmute-audio-button" class="btn videobtn mic-on" title="Mute audio"></button> <button id="mute-unmute-video-button" class="btn videobtn video-on" title="Mute video"></button> <button id="mute-unmute-video-button" class="btn videobtn adduser-on" ng-click="shareVideoCallDetails()" title="Add user"></button></div></div></div></div><div kendo-window="schedulelaterDlgOptionWindow" id="scheduleLaterWindow" k-on-close="closeKendoScheduleLater()" k-visible="false" class="overflow-auto svcall h-350px" k-width="800" style="min-width:800px;"><div class="row"><div class="col-md-6"><form name="frmCallScheduleLater" ng-submit="SaveOnCallScheduleLater(frmCallScheduleLater.$valid)" role="form"><div class="form-group"><label class="rf-label">Schedule For Date/Time *</label> <input date-range-picker="" id="daterangeSchedule" name="daterangeSchedule" class="form-control" type="text" ng-model="ScheduleForDateNew.date" options="scheduleForDateOptionsNew" autocomplete="off" required=""></div><div role="alert"><span style="color:red" class="error fs-14px fw-500" ng-show="frmCallScheduleLater.daterangeSchedule.$error.required">Schedule date & time required!</span></div><a class="btn btn-default rf-btn-xs" data-dismiss="modal" aria-label="Close" ng-click="CancelScheduleLater()">Cancel</a> <button type="submit" ng-click-options="{preventDoubleClick: true}" onlysingleclick="" ng-disabled="( !frmCallScheduleLater.$valid)" class="btn btn-primary rf-btn-xs mr-5px">Schedule Meeting</button></form></div></div></div>');
$templateCache.put('app/theme/components/chat-list-update/chatlistupdate.html','<style>\r\n    .popover {\r\n        font-family: "Open Sans", sans-serif !important;\r\n    }\r\n\r\n    :root {\r\n        --icon-rad-color: #05C1A4;\r\n    }\r\n\r\n    .rad-svg-icon path {\r\n        stroke: var(--icon-rad-color);\r\n        filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.5));\r\n    }\r\n\r\n    .grp-svg-icon path {\r\n        stroke: var(--icon-rad-color);\r\n    }\r\n\r\n    .display-block {\r\n        display: block !important;\r\n    }\r\n\r\n    .display-none {\r\n        display: none !important;\r\n    }\r\n\r\n    .d-grid {\r\n        display: grid;\r\n    }\r\n\r\n    .progress-striped .progress-bar.grid-xs-loader, .progress-bar-striped.progress-bar-striped.grid-xs-loader {\r\n        background-color: #05c1a4 !important;\r\n        background-size: 10px 10px !important;\r\n        background-image: linear-gradient(45deg, #2e2d32 25%, transparent 25%, transparent 75%, #2e2d32 50%, #2e2d32 80%, transparent 95%, transparent) !important;\r\n    }\r\n\r\n    #chat-bottom-btn {\r\n        position: absolute;\r\n        right: 14px;\r\n        bottom: 65px;\r\n        padding: 5px 8px;\r\n        background: #424242;\r\n        border-radius: 50% !important;\r\n        cursor: pointer;\r\n        color: #00dfbd !important;\r\n        border: 1px solid #00dfbd;\r\n        font-size: 14px;\r\n        text-align: center;\r\n    }\r\n\r\n        #chat-bottom-btn:hover {\r\n            color: white !important;\r\n            background: #00dfbd;\r\n            border: 0;\r\n        }\r\n\r\n    .daterangepicker {\r\n        z-index: 100025 !important;\r\n    }\r\n\r\n    .chattabmenu.nav.nav-tabs {\r\n        position: absolute;\r\n        top: 0;\r\n        right: -54px;\r\n        height: 100vh;\r\n        width: 54px;\r\n        border-radius: 0;\r\n        background: #424242 !important;\r\n        border-left: 1px solid #b3adad;\r\n        border-top: 1px solid #b3adad;\r\n    }\r\n\r\n        .chattabmenu.nav.nav-tabs > li > a {\r\n            padding: 10px 4px;\r\n            margin-right: 0px !important;\r\n            border-radius: 0px !important;\r\n        }\r\n\r\n        .chattabmenu.nav.nav-tabs > li.active > a {\r\n            background-color: transparent !important;\r\n            color: #05C1A4 !important;\r\n            font-weight: 600 !important;\r\n            border-left: 2px solid;\r\n        }\r\n\r\n        .chattabmenu.nav.nav-tabs > li {\r\n            width: 100%;\r\n            text-align: center;\r\n            margin-bottom: 8px;\r\n        }\r\n\r\n    .ch-userlist.w-240px {\r\n        height: 100vh;\r\n        width: 280px;\r\n    }\r\n\r\n    .chat-userlist-filter {\r\n        background: #2a2a2a;\r\n        margin: 5px 0;\r\n        padding-top: 5px;\r\n        padding-bottom: 5px;\r\n        font-weight: 600 !important;\r\n        padding-left: 15px;\r\n        cursor: pointer;\r\n        color: #d9d9d9;\r\n        margin-left: -4px !important;\r\n    }\r\n\r\n        .chat-userlist-filter:hover {\r\n            color: #05C1A4;\r\n        }\r\n\r\n        .chat-userlist-filter::before {\r\n            content: \'\';\r\n            border: 5px solid #05C1A4;\r\n            position: absolute;\r\n            top: 12px;\r\n            left: 2px;\r\n            border-color: #05C1A4 transparent transparent transparent;\r\n        }\r\n\r\n        .chat-userlist-filter.collapsed {\r\n            width: auto;\r\n        }\r\n\r\n            .chat-userlist-filter.collapsed::before {\r\n                left: 4px;\r\n                top: 10px;\r\n                border-color: transparent transparent transparent #05C1A4;\r\n            }\r\n\r\n    .chatuser-pin.fa.fa-thumb-tack {\r\n        color: #686868 !important;\r\n        transform: rotate(0deg);\r\n        position: absolute;\r\n        right: 33px;\r\n        top: 7px;\r\n        cursor: pointer;\r\n        padding-right: 5px;\r\n        font-size: 11px;\r\n        z-index: 1;\r\n        margin: 0 !important;\r\n    }\r\n\r\n    .chatuser-pin.pinned.fa.fa-thumb-tack {\r\n        transform: rotate(45deg);\r\n        color: #05C1A4 !important;\r\n    }\r\n\r\n        .chatuser-pin.fa.fa-thumb-tack:hover,\r\n        .chatuser-pin.pinned.fa.fa-thumb-tack:hover {\r\n            color: #00ffd8 !important;\r\n        }\r\n\r\n    .chat-userlist-badge {\r\n        position: absolute;\r\n        padding: 1px 6px;\r\n        background-color: #04c1a3;\r\n        border-radius: 4px;\r\n        display: inline-block;\r\n        color: #fff;\r\n        right: -36px;\r\n        top: 17px;\r\n    }\r\n\r\n    .chat-users-header {\r\n        background-color: #424242;\r\n    }\r\n\r\n    .bg-clr-50.ch-userlist, .bg-clr-50.insearch-bgcolor {\r\n        background-color: #262526 !important;\r\n        border-left-color: #b3adad !important;\r\n        border-top-color: #b3adad !important;\r\n    }\r\n\r\n    .searchBar.blk-input {\r\n        border: 0 transparent !important;\r\n        border-radius: 2px !important;\r\n        border-bottom: 1px solid #4c4b4b !important;\r\n    }\r\n\r\n    .contsidebar-sec {\r\n        border-left: 1px solid #b3adad;\r\n        border-top: 1px solid #b3adad;\r\n    }\r\n\r\n    .chat-userlist-container.h-42px {\r\n        height: 46px !important;\r\n    }\r\n\r\n    .chat-userlist-container.mb-1px {\r\n        margin-bottom: 4px !important;\r\n    }\r\n\r\n    .chatsec .control-sidebar {\r\n        transition: 2.2s cubic-bezier(.36,-0.01,0,.77) !important;\r\n        /*animation: movechatsec 800ms;*/\r\n    }\r\n\r\n    @keyframes movechatsec {\r\n        from {\r\n            right: 0px;\r\n        }\r\n\r\n        to {\r\n            right: 334px;\r\n        }\r\n    }\r\n\r\n    .context-menu {\r\n        color: white;\r\n        width: 93px;\r\n        padding: 5px;\r\n        border: 1px solid #5c5c5c;\r\n        /*display: none;*/\r\n        border-radius: 2px;\r\n        position: absolute;\r\n        background-color: #424242;\r\n        z-index: 99999;\r\n    }\r\n\r\n    .right-inner-addon {\r\n        position: relative;\r\n    }\r\n\r\n        .right-inner-addon input {\r\n            padding-right: 28px !important;\r\n        }\r\n\r\n        .right-inner-addon button {\r\n            position: absolute;\r\n            color: grey;\r\n            right: 8px;\r\n            padding: 11px;\r\n            cursor: pointer !important;\r\n            z-index: 9;\r\n        }\r\n\r\n    .selected-member .radlogist-wraaper {\r\n        border-radius: 5px;\r\n        max-height: 150px;\r\n    }\r\n\r\n    .grp-userlist:hover {\r\n        background-color: #393939 !important;\r\n    }\r\n\r\n    .add-member-card {\r\n        position: absolute;\r\n        right: 5px;\r\n        top: 30px;\r\n        z-index: 99;\r\n        box-shadow: 0px 0px 8px black;\r\n        background: #343334 !important;\r\n        border-radius: 2px;\r\n        width: 250px;\r\n    }\r\n\r\n    .edit-grouptitle-card {\r\n        position: absolute;\r\n        right: 10px;\r\n        top: 30px;\r\n        z-index: 99;\r\n        box-shadow: 0px 0px 8px black;\r\n        background: #343334 !important;\r\n        border-radius: 2px;\r\n        width: 400px;\r\n    }\r\n\r\n    #AssignRadiologistSitesTooltip {\r\n        z-index: 99 !important;\r\n    }\r\n\r\n    .sweet-overlay {\r\n        z-index: 99999 !important;\r\n    }\r\n\r\n    .openexam-block {\r\n        position: absolute;\r\n        right: 10px;\r\n        bottom: 12px;\r\n    }\r\n\r\n    .imageviewlinks ul li a {\r\n        cursor: pointer;\r\n        padding: 3px 0;\r\n        border-bottom: 1px solid #505050;\r\n    }\r\n\r\n    .imageviewlinks ul li:last-child a {\r\n        border-bottom: none;\r\n    }\r\n\r\n    .imageviewlinks ul li a:hover {\r\n        background: #404040;\r\n    }\r\n    .rating-box {\r\n        max-height: 55vh !important;\r\n        overflow-y: auto;\r\n        overflow-x: hidden;\r\n    }\r\n\r\n    .rating-box-1 {\r\n        max-height: 55vh !important;\r\n        overflow-y: auto;\r\n        overflow-x: hidden;\r\n    }\r\n</style><div class="dummychat chatsec" id="controllerId"><div class="control-sidebar pt-0 w-auto" style="z-index:999 !important;" ng-class="(isChatMenuActive)?\'display-block\':\'display-none\'"><div class="w-450px p-0 float-left contsidebar-sec mob-w-100" style="display:none;" ng-class="(isShowChatWindow)?\'display-block\':\'display-none\'"><div class="col-lg-12 col-xs-12 p-0"><div class="chat-header"><p class="m-0 txt-clr-1 fs-15px d-flex align-item-center float-left fw-600 text-truncate text-capitalize" ng-if="!selectedUserObject.ChatGroupID">{{maskName(selectedUserObject.LastName, selectedUserObject.FirstName, selectedUserObject.UserRoles, selectedUserObject.Id) | lowercase}} <i class="fa fa-commenting-o fs-14px blinkicon pl-5px pr-1px"></i></p><p class="m-0 txt-clr-1 fs-15px d-flex align-item-center justify-content-between w-90 float-left fw-600 text-truncate text-capitalize" ng-if="selectedUserObject.ChatGroupID"><span><span style="text-overflow: ellipsis; overflow: hidden; display: inline-block; max-width: 330px; text-align: left; width: auto;">{{(selectedUserObject.GroupName) | lowercase}}</span> <i ng-click="UpdateGroupName()" title="Name group chat" style="vertical-align: text-top;" id="editGroupBtn" class="fa fa-pencil txt-clr-14 fs-14px pl-10px pr-1px" ng-if="(selectedUserObject.UserIDs.includes(currUserId)) && !(selectedUserObject.IsDistributed) && (DataObject.CurrentUserRoles.includes(\'Admin\'))"></i></span> <a data-toggle="tab" id="editGroupMember" class="d-flex align-item-center justify-content-center pl-5px cursor-pointer all-role-step" title="View and add member" style="flex-direction: column;" ng-click="UpdateMembers()" ng-if="((selectedUserObject.IsDistributed) ? (selectedUserObject.UserIDs.includes(currUserId)) && (DataObject.CurrentUserRoles.includes(\'Admin\')) && (selectedUserObject.CreatedBy == currUserId) : (selectedUserObject.UserIDs.includes(currUserId)) && (DataObject.CurrentUserRoles.includes(\'Admin\')))"><svg width="20" height="19" viewbox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.81124 4.05662C8.81124 2.74363 7.74686 1.67925 6.43387 1.67925C5.12089 1.67925 4.05651 2.74363 4.05651 4.05662C4.05651 5.3696 5.12089 6.43398 6.43387 6.43398V7.11323C4.74575 7.11323 3.37726 5.74474 3.37726 4.05662C3.37726 2.36849 4.74575 1 6.43387 1C8.122 1 9.49049 2.36849 9.49049 4.05662C9.49049 5.74474 8.122 7.11323 6.43387 7.11323V6.43398C7.74686 6.43398 8.81124 5.3696 8.81124 4.05662Z" fill="#33DEA1"></path><path d="M16.2829 5.07588C16.2829 3.95046 15.3706 3.03813 14.2452 3.03813C13.1198 3.03813 12.2074 3.95046 12.2074 5.07588C12.2074 6.20129 13.1198 7.11362 14.2452 7.11362V7.79287C12.7446 7.79287 11.5282 6.57643 11.5282 5.07588C11.5282 3.57533 12.7446 2.35889 14.2452 2.35889C15.7457 2.35889 16.9622 3.57533 16.9622 5.07588C16.9622 6.57643 15.7457 7.79287 14.2452 7.79287V7.11362C15.3706 7.11362 16.2829 6.20129 16.2829 5.07588Z" fill="#33DEA1"></path><path d="M0.999878 9.67925C1.00004 8.44987 1.99662 7.45328 3.22601 7.45312H9.64172C10.4487 7.45323 11.1547 7.88284 11.5448 8.5244L11.6184 8.65508L11.6443 8.71942C11.6872 8.87118 11.6192 9.03716 11.4738 9.11277C11.3282 9.18836 11.1527 9.14858 11.0533 9.02588L11.0155 8.96817L10.9644 8.87663C10.6926 8.42986 10.2016 8.13248 9.64172 8.13237H3.22601C2.37176 8.13253 1.67929 8.82501 1.67913 9.67925C1.67913 12.201 3.72371 14.2456 6.24548 14.2456H6.62225C7.68224 14.2456 8.6573 13.8848 9.4321 13.2791L9.49048 13.2427C9.63192 13.1722 9.80793 13.2082 9.90904 13.3375C10.0245 13.4853 9.99841 13.6989 9.85066 13.8144L9.68085 13.9411C8.81988 14.56 7.76315 14.9249 6.62225 14.9249H6.24548C3.34858 14.9249 0.999878 12.5762 0.999878 9.67925Z" fill="#33DEA1"></path><path d="M14.5849 8.47217C17.0233 8.47217 19 10.4489 19 12.8873C19 15.3257 17.0233 17.3024 14.5849 17.3024C12.1465 17.3024 10.1698 15.3257 10.1698 12.8873C10.1698 10.4489 12.1465 8.47217 14.5849 8.47217ZM14.5849 10.5099C14.3084 10.5099 14.0841 10.7343 14.0841 11.0107V12.3865H12.7084C12.4319 12.3865 12.2075 12.6109 12.2075 12.8873C12.2075 13.1637 12.4319 13.3881 12.7084 13.3881H14.0841V14.7638C14.0841 15.0402 14.3084 15.2646 14.5849 15.2646C14.8613 15.2646 15.0857 15.0402 15.0857 14.7638V13.3881H16.4615C16.7378 13.3881 16.9623 13.1637 16.9623 12.8873C16.9623 12.6109 16.7378 12.3865 16.4615 12.3865H15.0857V11.0107C15.0857 10.7343 14.8613 10.5099 14.5849 10.5099Z" fill="#33DEA1"></path></svg></a></p><span class="v-a-m fs-15px" ng-click="openVideoChat(selectedUserObject.FirstName + \' \' + selectedUserObject.LastName, false,\'\')" data-bs-toggle="modal" data-bs-target="#container" ng-if="!selectedUserObject.ChatGroupID"><i class="fa fa-video-camera" aria-hidden="true"></i></span> <span class="v-a-m pl-3px fs-15px icon-hover" ng-click="minChatWindow()" ng-show="!hideChatWindow" title="Minimize"><i class="fa fa-minus" aria-hidden="true"></i></span> <span ng-click="maxChatWindow()" ng-show="hideChatWindow" title="Maximize"><span class="v-a-m pl-2px icon-hover fs-18px k-icon k-i-window-maximize"></span></span> <span class="fa fa-close v-a-m fs-16px icon-hover" title="Close" ng-click="closeChatWindow()"></span><div class="clearfix"></div><div class="add-member-card card" id="groupMemberEdit" ng-if="DataObject.isAddMemberVisible.value"><div class="card-body p-3"><p class="txt-clr-2 fs-12px pl-5px text-left">User(s) <span class="rf-badge-rp badge align-item-center justify-content-center" style="min-width: 19px; height: 19px; max-width: 100px;padding: 4px; display: inline-flex; background: #545454 !important; color: #d6d6d6 !important; border-radius: 100%;" ng-if="(selectedUserObject.UserIDs.includes(currUserId))">{{visibleGroupMemberCount(DataObject.GroupDetails.SelectedRadiologists, true)}}</span> <span class="rf-badge-rp badge align-item-center justify-content-center" style="min-width: 19px; height: 19px; max-width: 100px;padding: 4px; display: inline-flex; background: #545454 !important; color: #d6d6d6 !important; border-radius: 100%;" ng-if="!(selectedUserObject.UserIDs.includes(currUserId))">{{visibleGroupMemberCount(DataObject.GroupDetails.SelectedRadiologists, false)}}</span></p><div class="chatgroupuser-siteaccessscroll overflow-x-hide overflow-y-auto" style="max-height:450px;"><div class="d-flex align-item-center justify-content-between p-1 bor-rad-5px grp-userlist mb-5px" ng-repeat="user in DataObject.GroupDetails.SelectedRadiologists | orderBy:[\'LastName\',\'FirstName\']" ng-if="user.Id && user.Id != currUserId && isVisibleMember(user)"><div class="d-flex align-item-center w-100"><div class="chat-name-circle list-userpic-bg pos-rel" popover-class="popoverchatuser" uib-popover-template="\'toGroupUserProfileDetails.html\'" popover-trigger="outsideClick" popover-append-to-body="true" popover-placement="auto" popover-animation="true" popover-is-open="user.isgrouppopOverOpen" ng-mouseenter="showGroupToUserDetails(user);" ng-mouseleave="hideGroupToUserDetails();"><i class="fa fa-circle usr-circle pos-abs" style="bottom: 0; top: unset;" ng-class="{\'usronline\':user.IsOnline,\'txt-clr-25\':!user.IsOnline}"></i><div ng-if="!user.ProfilePic"><div ng-if="!user.IsGroupType"><div data-toggle="modal" ng-click="showUserInfo(user); $event.stopPropagation()" style="position:absolute;top:18px;left:10px;" class="profilepic">{{maskInitials(user.LastName, user.FirstName, user.UserRoles || user.Roles, user.Id || user.UserID)}}</div></div></div><img class="rounded-circle weight-2-5 br-upi w-40px h-40px" data-toggle="modal" ng-click="showUserInfo(user); $event.stopPropagation()" ng-src="{{user.ProfilePic}}" ng-if="user.ProfilePic"></div><p class="txt-clr-1 fs-12px text-left mb-1px pl-4px" style="max-width: 165px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{maskName(user.LastName, user.FirstName, user.UserRoles || user.Roles, user.Id || user.UserID)}}</p></div><i class="fa fa-times pl-5px cursor-pointer float-right" aria-hidden="true" ng-click="DeleteOrLeaveGroup(\'Leave\',DataObject.GroupDetails,user)" ng-if="DataObject.GroupDetails.UserIDs.includes(currUserId) && (DataObject.CurrentUserRoles.includes(\'Admin\')) && (DataObject.GroupDetails.SelectedRadiologists.length > 2)"></i></div></div><div class="mt-5px" style="border-top:1px solid"><div class="icon-hover txt-clr-1 px-10px py-10px text-left" ng-click="DataObject.showAssignRadiologistCmp.value=true;AddUsers();" ng-if="((DataObject.GroupDetails.IsDistributed) ? (selectedUserObject.UserIDs.includes(currUserId)) && (selectedUserObject.CreatedBy == currUserId) && (DataObject.CurrentUserRoles.includes(\'Admin\')) : (selectedUserObject.UserIDs.includes(currUserId)) && (DataObject.CurrentUserRoles.includes(\'Admin\')))"><i class="fa fa-user-plus pr-5px" aria-hidden="true"></i> <span>Add Member</span></div><div class="icon-hover txt-clr-1 px-10px py-10px text-left" ng-click="DeleteOrLeaveGroup(\'Leave\',DataObject.GroupDetails, DataObject.currentUser)" ng-if="((DataObject.GroupDetails.IsDistributed) ? false : (DataObject.GroupDetails.SelectedRadiologists.length > 2))"><i class="fa fa-sign-out pr-5px" aria-hidden="true"></i> <span>Leave</span></div><div class="icon-hover txt-clr-1 px-10px py-10px text-left" ng-click="DeleteOrLeaveGroup(\'Delete\',DataObject.GroupDetails)" ng-if="(!(DataObject.GroupDetails.IsDistributed))"><i class="fa fa-trash pr-5px" aria-hidden="true"></i> <span>Delete</span></div></div></div></div><div class="edit-grouptitle-card card" id="groupTitleEdit" ng-if="DataObject.isEditGroupTitleVisible.value"><div class="card-body p-3"><div><label class="rf-label text-left">Group Name *</label> <input type="text" name="GroupName" ng-model="DataObject.GroupDetails.GroupName" class="blk-input form-control input-sm" required=""></div><div class="d-flex justify-content-end mt-2"><button type="submit" ng-click="DataObject.isEditGroupTitleVisible.value = false" class="btn btn-default rf-btn-xs mr-10px">Cancel</button> <button type="submit" class="btn btn-primary rf-btn-xs" ng-click="AddUpdateGroup(\'Update\')" ng-disabled="DataObject.GroupDetails.GroupName == \'\' || DataObject.GroupDetails.GroupName == null">Save</button></div></div></div></div><div class="chat-inner bg-clr-31" style="border: 1px solid #46454a;"><div class="chat-history overflow-hide-all pt-10px"><div style="background-color: #2e2d32 !important; position:relative;" ng-show="showChatLoader"><div class="progress m-0" style="background-color: transparent !important; margin-bottom:-15px !important"><div class="progress-bar progress-bar-striped grid-xs-loader pos-abs h-2px active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div id="messageMe" ng-scroll-bottom="" scrollbottom="MessageList" scrollltobottom="scrolllToBottom" deletemessagescrollposition="DeleteMessageScrollPosition" when-scrolled-top="GetMessageNextPage()" class="chat-history-inner msg-sec w-100 scrollbar-macosx overflow-x-hide" ng-show="!IsShowCategoryUsers"><div class="p-10px-all bor-rad-5px bg-clr-23 mx-15px mb-5px text-center txt-clr-1" ng-if="!showChatLoader && selectedUserObject.ChatGroupID && selectedUserObject.LastMessage.includes(\'NEWGROUP\')"><div class="d-flex justify-content-center mb-5px"><div class="chat-name-circle list-userpic-bg pt-8px" style="float:none"><div data-toggle="modal" class="profilepic"><svg width="20" class="" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9942 12.5L12.9939 12C12.7178 12.0002 12.4941 12.2241 12.4942 12.5002C12.4943 12.7762 12.7182 13 12.9943 13L12.9942 12.5ZM18.21 15.7084C18.3687 15.9344 18.6805 15.989 18.9065 15.8304C19.1325 15.6717 19.1871 15.3598 19.0285 15.1338L18.21 15.7084ZM0.590966 15.134C0.432151 15.3599 0.486536 15.6718 0.712439 15.8306C0.938343 15.9894 1.25022 15.935 1.40903 15.7091L0.590966 15.134ZM11.8413 15.7087C12.0002 15.9346 12.3121 15.989 12.5379 15.8302C12.7638 15.6713 12.8182 15.3594 12.6594 15.1335L11.8413 15.7087ZM11.7563 4.04502C11.4905 4.11991 11.3358 4.39608 11.4106 4.66188C11.4855 4.92767 11.7617 5.08243 12.0275 5.00754L11.7563 4.04502ZM12.9946 13C14.0176 12.9992 15.0256 13.245 15.9335 13.7164L16.3944 12.829C15.3439 12.2835 14.1775 11.9991 12.9939 12L12.9946 13ZM15.9335 13.7164C16.8413 14.1879 17.6222 14.8712 18.21 15.7084L19.0285 15.1338C18.3483 14.1651 17.4448 13.3745 16.3944 12.829L15.9335 13.7164ZM1.40903 15.7091C1.99738 14.8723 2.77844 14.1892 3.68628 13.7177L3.22536 12.8303C2.17514 13.3757 1.27158 14.1659 0.590966 15.134L1.40903 15.7091ZM3.68628 13.7177C4.59413 13.2462 5.60209 13 6.62508 13L6.62505 12C5.44162 12 4.27557 12.2848 3.22536 12.8303L3.68628 13.7177ZM6.62508 13C7.64808 12.9999 8.65606 13.246 9.56394 13.7175L10.0248 12.83C8.97454 12.2846 7.80847 11.9999 6.62505 12L6.62508 13ZM9.56394 13.7175C10.4718 14.1889 11.2529 14.8719 11.8413 15.7087L12.6594 15.1335C11.9787 14.1655 11.0751 13.3754 10.0248 12.83L9.56394 13.7175ZM10.1878 8.43745C10.1878 10.4049 8.59262 12 6.62506 12V13C9.14482 13 11.1878 10.9573 11.1878 8.43745H10.1878ZM6.62506 12C4.65759 12 3.06283 10.405 3.06283 8.43745H2.06283C2.06283 10.9572 4.10522 13 6.62506 13V12ZM3.06283 8.43745C3.06283 6.46994 4.65781 4.87495 6.62533 4.87495V3.87495C4.10553 3.87495 2.06283 5.91765 2.06283 8.43745H3.06283ZM6.62533 4.87495C8.59284 4.87495 10.1878 6.46994 10.1878 8.43745H11.1878C11.1878 5.91765 9.14513 3.87495 6.62533 3.87495V4.87495ZM12.0275 5.00754C12.5175 4.86949 13.0314 4.83804 13.5346 4.91531L13.6864 3.9269C13.042 3.82793 12.3838 3.86821 11.7563 4.04502L12.0275 5.00754ZM13.5346 4.91531C14.0378 4.99259 14.5185 5.17679 14.9445 5.45552L15.4921 4.61873C14.9465 4.26177 14.3308 4.02586 13.6864 3.9269L13.5346 4.91531ZM14.9445 5.45552C15.3705 5.73425 15.7318 6.10104 16.0042 6.53117L16.8491 5.99627C16.5003 5.44542 16.0376 4.97569 15.4921 4.61873L14.9445 5.45552ZM16.0042 6.53117C16.2765 6.9613 16.4534 7.44479 16.5231 7.94907L17.5137 7.81213C17.4244 7.16631 17.1978 6.54712 16.8491 5.99627L16.0042 6.53117ZM16.5231 7.94907C16.5929 8.45335 16.5537 8.96672 16.4083 9.4546L17.3666 9.74021C17.5529 9.1154 17.603 8.45795 17.5137 7.81213L16.5231 7.94907ZM16.4083 9.4546C16.2629 9.94247 16.0146 10.3935 15.6802 10.7774L16.4343 11.4342C16.8625 10.9427 17.1804 10.365 17.3666 9.74021L16.4083 9.4546ZM15.6802 10.7774C15.3459 11.1612 14.9331 11.469 14.4697 11.6799L14.884 12.59C15.4774 12.3199 16.006 11.9258 16.4343 11.4342L15.6802 10.7774ZM14.4697 11.6799C14.0064 11.8907 13.5032 11.9999 12.9942 12L12.9943 13C13.6462 12.9999 14.2906 12.8601 14.884 12.59L14.4697 11.6799Z" fill="white"></path></svg></div></div></div><p ng-if="selectedUserObject.CreatedBy == currUserId">You created this group</p><p ng-if="selectedUserObject.CreatedBy != currUserId">{{selectedUserObject.CreatedName}} created this group</p><p>Group {{selectedUserObject.SelectedRadiologists.length}} members</p></div><div ng-repeat="curMessageObj in MessageList track by curMessageObj.Id" adapter="adapter" buffer-size="1" top-visible="topVisibleMessage" class="width-inherit chat-block"><div class="width-inherit"><div ng-if="getMessageDate(curMessageObj)" class="stick z-i-10" scrolling-elem="myScrollingView" listen-resize="listenResize" ng-sticky=""><div class="sticky-timer-placeholder d-block min-width-1 pos-rel py-2"><span class="sticky-timer-text text-center text-uppercase fw-700 l-s-0-075 fs-11px txt-clr-26 d-block w-90 m-0-auto lh-1-0 bb-1-s b-clr-15"><span class="bg-clr-31 px-10px">{{getMessageDate(curMessageObj)}}</span></span></div></div></div><div class="width-inherit" ng-if="curMessageObj.Type"><div class="stick z-i-10" scrolling-elem="myScrollingView" listen-resize="listenResize" ng-sticky="" ng-if="curMessageObj.Type == \'ADDUSER\'"><div class="sticky-timer-placeholder d-block min-width-1 pos-rel py-2"><span class="text-left fw-700 fs-11px txt-clr-26 d-block w-100"><span class="bg-clr-31 d-flex align-item-center px-10px" ng-if="curMessageObj.Message"><i class="fa fa-user-plus fs-12px pr-1"></i> <span>{{curMessageObj.Message}}</span></span></span></div></div><div class="stick z-i-10" scrolling-elem="myScrollingView" listen-resize="listenResize" ng-sticky="" ng-if="curMessageObj.Type == \'REMOVEUSER\'"><div class="sticky-timer-placeholder d-block min-width-1 pos-rel py-2"><span class="text-left fw-700 fs-11px txt-clr-26 d-block w-100"><span class="bg-clr-31 d-flex align-item-center px-10px" ng-if="curMessageObj.Message"><i class="fa fa-user-times fs-12px pr-1"></i> <span>{{curMessageObj.Message}}</span></span></span></div></div></div><div ng-if="currUserId != curMessageObj.FromUserId && !curMessageObj.Type" class="chat-message-container width-inherit height-auto clearfix my-5px"><div class="incmg-message-column w-100 mob-w-100 float-left clearfix pos-rel mb-10px"><div class="chat-profile-img float-left no-bg pos-rel rel-t-20-p"><div class="chat-name-circle d-flex align-item-center justify-content-center receiver-pic-bg"><div ng-if="!selectedUserObject.ProfilePic && !selectedUserObject.ChatGroupID" class="user-profile-name">{{selectedUserObject.LastName.substring(0,1) + \'\' + selectedUserObject.FirstName.substring(0,1)}}</div><div ng-if="!selectedUserObject.ProfilePic && selectedUserObject.ChatGroupID" class="user-profile-name">{{curMessageObj.FromInitials}}</div><img class="rounded-circle weight-inherit height-inherit br-upi" data-toggle="modal" ng-src="{{selectedUserObject.ProfilePic}}" ng-if="selectedUserObject.ProfilePic"></div></div><div class="otg-message-action-container float-right w-20px no-bg trans-200-all-linear pos-rel rel-t-25-p" style="left:-10px"><button class="btn-secondary p-0 no-bg a-txt-clr-2-t-1 trans-200-bg-linear border-0 tultip-left" type="button" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && curMessageObj.Message.includes(\'Call has been scheduled\')" ng-click="reScheduledCall(curMessageObj)"><i class="fa fa-calendar fs-16px fw-500 txt-clr-33"></i> <span class="tultiptext tt-white">Reschedule</span></button></div><div class="chat-message-container-placeholder float-left height-auto rounded chatmsg-width" ng-class="(curMessageObj.isDeleted) ? \'bg-clr-21 txt-clr-3\' : (curMessageObj.isHighPriority) ? \'no-bg receiver-name-clr highprio-msg\' : \'no-bg receiver-name-clr\'"><div class="no-bg pl-10px"><div class="mb-5px"><span class="chat-profile-name fs-12px fw-500 text-capitalize" ng-if="!curMessageObj.ChatGroupID">{{maskName(selectedUserObject.LastName, selectedUserObject.FirstName, selectedUserObject.UserRoles, selectedUserObject.Id) | lowercase}}</span> <span class="chat-profile-name fs-12px fw-500 text-capitalize" ng-if="curMessageObj.ChatGroupID">{{curMessageObj.FromUserDisplayName | lowercase}}</span> <span class="chat-message-time m-0 float-right v-a-m fs-12px fw-500 txt-clr-26">{{curMessageObj.MessageTime| utcToLocal:\'M/d/yy HH:mm\'}}</span></div><div class="chat-message width-auto height-auto pt-0 pb-0px"><div class="width-inherit height-inherit"><div class="fs-13px fw-500 text-ws-pl text-break-word mb-1 txt-clr-1 p-10px-all bor-rad-8px pos-rel speechreceived bg-clr-44 rightline d-flex justify-content-between" style="align-items:flex-start" ng-if="!curMessageObj.isFile && curMessageObj.Message.includes(\'|SHAREEXAMOBJ|\')"><div style="display: inline-grid;width:100%"><p class="m-0 d-table p-0" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[0]!=\'undefined\' || curMessageObj.Message.includes(\'Call has been scheduled\') || curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')"><span>{{curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[0] | limitTo:curMessageObj.numLimit}}</span> <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span></p><p ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1].length>0" class="fs-12px d-grid mb-1 fw-500 m-0 p-0 txt-clr-14"><span>Name: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span>MRN: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'MRN\') | uppercase}}</span> <span>Accession: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'ACCESSION\') | uppercase}}</span></p><span class="d-flex justify-content-end align-item-center openexam-block" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1].length>0 && (DataObject.CurrentUserRoles.includes(\'User\'))"><a id="" ng-click="OpenStudy(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], true)" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1].length>0" class="d-flex align-self-center cursor-pointer tultip-right mr-7px pt-2px mt-8px" tooltip-class="uibtooltipDenial" uib-tooltip="Launch Study" tooltip-placement="auto bottom" tooltip-append-to-body="true"><i class="fa fa-external-link fs-16px txt-clr-14"></i></a> <span class="btn-group chatbtn-group d-flex align-self-center cursor-pointer tultip-right mr-7px mt-8px" uib-dropdown="" on-toggle="onViewerDropdownToggle(open, curMessageObj, \'single-button\' + curMessageObj.Id)" ng-class="{dropup: curMessageObj.viewerDropUp}"><a id="single-button{{curMessageObj.Id}}" class="d-flex align-self-center cursor-pointer" uib-dropdown-toggle="" ng-click="imageViewerOptions(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1])"><i class="fa fa-picture-o fs-16px txt-clr-14"></i></a> <span class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="single-button{{curMessageObj.Id}}" ng-if="DicomViewerList.length > 0"><span class="dropdown-menuItem" role="menuitem" ng-repeat="viewer in DicomViewerList"><a href="#" class="fs-13px txt-clr-1" ng-click="OpenSynapseStudy(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1],viewer)">{{SetDicomViewerText(viewer)}}</a></span></span></span> <a id="" class="d-flex align-self-center cursor-pointer tultip-right mt-8px" tooltip-class="uibtooltipDenial" uib-tooltip="View Report" tooltip-placement="auto bottom" tooltip-append-to-body="true" ng-click="ViewReport(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1])"><i class="fa fa-file-text-o fs-16px txt-clr-14"></i></a></span></div></div><p class="fs-13px fw-500 text-ws-pl text-break-word mb-1 txt-clr-1 p-10px-all bor-rad-8px pos-rel speechreceived bg-clr-44 rightline" ng-if="!curMessageObj.Message.includes(\'|SHAREEXAMOBJ|\') && !curMessageObj.isFile && !curMessageObj.Message.includes(\'Call has been scheduled\') && !curMessageObj.Message.includes(\'Video Call Link\') && !curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')"><span class="d-inline-block no-w-c-100-58px">{{curMessageObj.Message | limitTo:curMessageObj.numLimit}}</span> <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span></p><p class="fs-13px fw-500 text-ws-pl text-break-word mb-1 txt-clr-1 p-10px-all bor-rad-8px pos-rel speechreceived bg-clr-44 rightline" ng-if="!curMessageObj.isFile && (curMessageObj.Message.includes(\'Call has been scheduled\') || curMessageObj.Message.includes(\'Video Call Link\') || curMessageObj.Message.includes(\'wants to consult a study for the below procedure\') && ((DataObject.CurrentUserRoles.includes(\'User\') || DataObject.CurrentUserRoles.includes(\'Admin\'))))"><span class="d-inline-block no-w-c-100-58px">{{curMessageObj.Message | limitTo:curMessageObj.numLimit}}</span> <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span> <span class="d-flex justify-content-end align-item-center"><span class="d-flex justify-content-end align-item-center" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && (curMessageObj.Message.includes(\'Call has been scheduled to consult a study for the below procedure\') || curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')) && (DataObject.CurrentUserRoles.includes(\'User\'))"><a id="" ng-click="OpenStudy(curMessageObj.Message, true)" class="d-flex align-self-center cursor-pointer tultip-right mr-7px pt-2px mt-8px" tooltip-class="uibtooltipDenial" uib-tooltip="Launch Study" tooltip-placement="auto bottom" tooltip-append-to-body="true"><i class="fa fa-external-link txt-clr-14 fs-16px"></i></a> <span class="btn-group chatbtn-group d-flex align-self-center cursor-pointer tultip-right mr-7px mt-8px" uib-dropdown="" on-toggle="onViewerDropdownToggle(open, curMessageObj, \'single-button\' + curMessageObj.Id)" ng-class="{dropup: curMessageObj.viewerDropUp}"><a id="single-button{{curMessageObj.Id}}" class="d-flex align-self-center cursor-pointer" uib-dropdown-toggle="" ng-click="imageViewerOptions(curMessageObj.Message)"><i class="fa fa-picture-o fs-16px txt-clr-14"></i></a> <span class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="single-button{{curMessageObj.Id}}" ng-if="DicomViewerList.length > 0"><span class="dropdown-menuItem" role="menuitem" ng-repeat="viewer in DicomViewerList"><a href="#" class="fs-13px txt-clr-1" ng-click="OpenSynapseStudy(curMessageObj.Message,viewer)">{{SetDicomViewerText(viewer)}}</a></span></span></span> <a id="" class="d-flex align-self-center cursor-pointer tultip-right mt-8px" tooltip-class="uibtooltipDenial" uib-tooltip="View Report" tooltip-placement="auto bottom" tooltip-append-to-body="true" ng-click="ViewReport(curMessageObj.Message)"><i class="fa fa-file-text-o fs-16px txt-clr-14"></i></a></span><a class="vc-text vc-link d-flex justify-content-center align-item-center w-58px ml-8px px-4px py-2px mt-8px" href="#" ng-click="openVideoChat(selectedUserObject.FirstName + \' \' + selectedUserObject.LastName,true,curMessageObj)"><span>Join Now</span></a></span></p><p class="fs-13px fw-500 text-ws-pl text-break-word mb-1 text-left bor-rad-8px bg-clr-44 mt-5px pos-rel py-10px px-10px speechreceived" ng-if="curMessageObj.isFile"><i class="fa fa-download cursor-pointer p-10px-all fs-15px bg-clr-31 bor-rad-8px w-100" ng-click="downloadFile(curMessageObj)"><span class="txt-clr-1 pl-5px fs-13px v-a-t">{{curMessageObj.FileName}}</span></i></p></div></div></div></div></div></div><div ng-if="currUserId == curMessageObj.FromUserId && !curMessageObj.Type" class="chat-message-container width-inherit height-auto clearfix my-5px"><div class="otgmg-message-column w-100 mob-w-100 float-right clearfix pos-rel mb-10px"><div class="chat-profile-img float-right no-bg pos-rel rel-t-20-p"><div class="chat-name-circle sender-pic-bg d-flex align-item-center justify-content-center"><div ng-if="!userObj.profilePic" class="user-profile-name">{{currLastName.substring(0,1) + \'\' + currFirstName.substring(0,1)}}</div><img class="rounded-circle weight-inherit height-inherit br-upi" data-toggle="modal" ng-src="{{userObj.profilePic}}" ng-if="userObj.profilePic"></div></div><div class="chat-message-container-placeholder float-right height-auto rounded chatmsg-width" ng-class="(curMessageObj.isDeleted) ? \'bg-clr-38 txt-clr-17\' : (curMessageObj.isHighPriority) ? \'no-bg txt-clr-17 highprio-msg\' : \'no-bg txt-clr-17\'"><div class="no-bg pr-10px"><div class="mb-5px"><span class="chat-profile-name fs-12px fw-500 text-capitalize sender-name-clr">{{(currLastName + \' \' + currFirstName) | lowercase}}</span> <span class="chat-message-time m-0 float-right v-a-m fs-12px fw-500 txt-clr-26">{{curMessageObj.MessageTime | utcToLocal:\'M/d/yy HH:mm\'}}</span></div><div class="chat-message width-auto height-auto pt-0 pb-0px"><div class="width-inherit height-inherit"><div class="fs-13px fw-500 text-ws-pl text-break-word mb-0 d-flex justify-content-between text-left txt-clr-1 py-8px px-12px bor-rad-8px pos-rel speechsent sender-msg-bg-clr leftline" style="align-items:flex-start" ng-if="!curMessageObj.isFile && curMessageObj.Message.includes(\'|SHAREEXAMOBJ|\')"><div style="display: inline-grid;width:100%"><p class="m-0 d-table p-0" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[0]!=\'undefined\'"><span>{{curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[0] | limitTo:curMessageObj.numLimit}}</span> <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span></p><p class="fs-12px mb-1 d-grid fw-500 m-0 p-0 txt-clr-14" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1].length>0"><span>Name: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span>MRN: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'MRN\') | uppercase}}</span> <span>Accession: {{ViewPatientDetails(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], \'ACCESSION\') | uppercase}}</span></p><span class="d-flex justify-content-end k-align-items-end mt-0 openexam-block" ng-if="curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1].length>0 && (DataObject.CurrentUserRoles.includes(\'User\'))"><a id="" ng-click="OpenStudy(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1], true)" class="d-flex align-self-center cursor-pointer tultip-right mr-7px pt-2px" tooltip-class="uibtooltipDenial" uib-tooltip="Launch Study" tooltip-placement="auto bottom" tooltip-append-to-body="true"><i class="fa fa-external-link fs-16px txt-clr-14"></i></a> <span class="btn-group chatbtn-group d-flex align-self-center cursor-pointer tultip-right mr-7px" uib-dropdown="" on-toggle="onViewerDropdownToggle(open, curMessageObj, \'single-button\' + curMessageObj.Id)" ng-class="{dropup: curMessageObj.viewerDropUp}"><a id="single-button{{curMessageObj.Id}}" class="d-flex align-self-center cursor-pointer" uib-dropdown-toggle="" ng-click="imageViewerOptions(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1])"><i class="fa fa-picture-o fs-16px txt-clr-14"></i></a> <span class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="single-button{{curMessageObj.Id}}" ng-if="DicomViewerList.length > 0"><span class="dropdown-menuItem" role="menuitem" ng-repeat="viewer in DicomViewerList"><a href="#" class="fs-13px txt-clr-1" ng-click="OpenSynapseStudy(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1],viewer)">{{SetDicomViewerText(viewer)}}</a></span></span></span> <a id="" class="d-flex align-self-center cursor-pointer tultip-right" tooltip-class="uibtooltipDenial" uib-tooltip="View Report" tooltip-placement="auto bottom" tooltip-append-to-body="true" ng-click="ViewReport(curMessageObj.Message.split(\'|SHAREEXAMOBJ|\')[1])"><i class="fa fa-file-text-o fs-16px txt-clr-14"></i></a></span><span class="chaticon-sendview pos-abs" ng-if="curMessageObj.ReadMessage && curMessageObj.Id"><i class="fa fa-check-circle-o fs-14px fw-400" aria-hidden="true" tooltip-class="uibtooltipDenial" uib-tooltip="Sent" tooltip-placement="auto top" tooltip-append-to-body="true" ng-if="curMessageObj.ChatGroupID ? !curMessageObj.IsReadByAllUser : curMessageObj.IsRead"></i> <i class="fa fa-eye fs-14px fw-400" aria-hidden="true" tooltip-class="uibtooltipDenial" uib-tooltip="Seen" tooltip-placement="auto top" tooltip-append-to-body="true" ng-if="curMessageObj.ChatGroupID ? curMessageObj.IsReadByAllUser : !curMessageObj.IsRead"></i></span></div></div><p class="fs-13px fw-500 text-ws-pl text-break-word mb-0 text-left txt-clr-1 py-8px px-12px bor-rad-8px pos-rel speechsent sender-msg-bg-clr leftline" ng-if="!curMessageObj.Message.includes(\'|SHAREEXAMOBJ|\') && !curMessageObj.isFile"><span>{{curMessageObj.Message | limitTo:curMessageObj.numLimit}}</span> <span class="txt-clr-31 cursor-pointer px-5px" ng-if="curMessageObj.isExpandable" ng-click="readMore(curMessageObj)">{{curMessageObj.readMoreTxt}}</span> <span class="d-flex justify-content-end align-item-center"><span class="d-flex justify-content-end align-item-center" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && (curMessageObj.Message.includes(\'Call has been scheduled to consult a study for the below procedure\') || curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')) && (DataObject.CurrentUserRoles.includes(\'User\'))"><a id="" ng-click="OpenStudy(curMessageObj.Message, true)" class="d-flex align-self-center cursor-pointer tultip-right mr-7px pt-2px mt-8px" tooltip-class="uibtooltipDenial" uib-tooltip="Launch Study" tooltip-placement="auto bottom" tooltip-append-to-body="true"><i class="fa fa-external-link fs-16px txt-clr-14"></i></a> <span class="btn-group chatbtn-group d-flex align-self-center cursor-pointer tultip-right mr-7px mt-8px" uib-dropdown="" on-toggle="onViewerDropdownToggle(open, curMessageObj, \'single-button\' + curMessageObj.Id)" ng-class="{dropup: curMessageObj.viewerDropUp}"><a id="single-button{{curMessageObj.Id}}" class="d-flex align-self-center cursor-pointer" uib-dropdown-toggle="" ng-click="imageViewerOptions(curMessageObj.Message)"><i class="fa fa-picture-o fs-16px txt-clr-14"></i></a> <span class="dropdown-menu" uib-dropdown-menu="" role="menu" aria-labelledby="single-button{{curMessageObj.Id}}" ng-if="DicomViewerList.length > 0"><span class="dropdown-menuItem" role="menuitem" ng-repeat="viewer in DicomViewerList"><a href="#" class="fs-13px txt-clr-1" ng-click="OpenSynapseStudy(curMessageObj.Message,viewer)">{{SetDicomViewerText(viewer)}}</a></span></span></span> <a id="" class="d-flex align-self-center cursor-pointer tultip-right mt-8px" tooltip-class="uibtooltipDenial" uib-tooltip="View Report" tooltip-placement="auto bottom" tooltip-append-to-body="true" ng-click="ViewReport(curMessageObj.Message)"><i class="fa fa-file-text-o fs-16px txt-clr-14"></i></a></span><a class="vc-text pos-set-right vc-link d-inline-block w-58px ml-8px px-4px py-2px mt-8px" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && curMessageObj.Message.includes(\'Call has been scheduled\') && !curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')" ng-click="scheduledCallJoin(curMessageObj)"><span class="">Join Now</span></a><a class="vc-text pos-set-right vc-link d-inline-block w-58px ml-8px px-4px py-2px mt-8px" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && !curMessageObj.Message.includes(\'Call has been scheduled\') && curMessageObj.Message.includes(\'wants to consult a study for the below procedure\')" ng-click="scheduledCallJoin(curMessageObj)"><span class="">Join Now</span></a></span> <span class="chaticon-sendview pos-abs" ng-if="curMessageObj.ReadMessage && curMessageObj.Id"><i class="fa fa-check-circle-o fs-14px fw-400" aria-hidden="true" tooltip-class="uibtooltipDenial" uib-tooltip="Sent" tooltip-placement="auto top" tooltip-append-to-body="true" ng-if="curMessageObj.ChatGroupID ? !curMessageObj.IsReadByAllUser : curMessageObj.IsRead"></i> <i class="fa fa-eye fs-14px fw-400" aria-hidden="true" tooltip-class="uibtooltipDenial" uib-tooltip="Seen" tooltip-placement="auto top" tooltip-append-to-body="true" ng-if="curMessageObj.ChatGroupID ? curMessageObj.IsReadByAllUser : !curMessageObj.IsRead"></i></span></p><p class="fs-13px fw-500 text-break-word m-0 text-left bor-rad-8px sender-msg-bg-clr py-8px px-12px pos-rel speechsent" ng-if="curMessageObj.isFile"><i class="fa fa-download cursor-pointer fs-12px w-100 d-flex align-item-center" ng-click="downloadFile(curMessageObj)"><span class="txt-clr-1 pl-5px fs-13px fw-500 v-a-t">{{curMessageObj.FileName}}</span></i> <span class="chaticon-sendview pos-abs" ng-if="curMessageObj.ReadMessage && curMessageObj.Id"><i class="fa fa-check-circle-o fs-14px fw-400" aria-hidden="true" tooltip-class="uibtooltipDenial" uib-tooltip="Sent" tooltip-placement="auto top" tooltip-append-to-body="true" ng-if="curMessageObj.ChatGroupID ? !curMessageObj.IsReadByAllUser : curMessageObj.IsRead"></i> <i class="fa fa-eye fs-14px fw-400" aria-hidden="true" tooltip-class="uibtooltipDenial" uib-tooltip="Seen" tooltip-placement="auto top" tooltip-append-to-body="true" ng-if="curMessageObj.ChatGroupID ? curMessageObj.IsReadByAllUser : !curMessageObj.IsRead"></i></span></p></div></div></div></div><div class="otg-message-action-container float-right w-20px no-bg trans-200-all-linear pos-rel rel-t-25-p" ng-if="curMessageObj.Id"><button class="btn-secondary p-0 no-bg a-txt-clr-2-t-1 trans-200-bg-linear border-0 tultip-top" type="button" ng-if="((selectedUserObject.ChatGroupID) ? (selectedUserObject.UserIDs.includes(currUserId)) && !(curMessageObj.isDeleted) : !(curMessageObj.isDeleted))" ng-click="deleteMsg(curMessageObj, $index)"><i class="fa fa-trash fs-18px fw-500 txt-clr-33"></i> <span class="tultiptext tt-white">Delete</span></button></div><div class="otg-message-action-container chat-retry float-right w-20px no-bg trans-200-all-linear pos-rel rel-t-25-p" ng-if="!curMessageObj.Id"><button class="btn-secondary p-0 no-bg a-txt-clr-2-t-1 trans-200-bg-linear border-0 tultip-top" type="button" ng-click="retryMessage(curMessageObj, $index)"><i class="fa fa-rotate-right fs-18px fw-500 txt-clr-33"></i> <span class="tultiptext tt-white">Retry</span></button></div><div class="otg-message-action-container float-right w-20px no-bg trans-200-all-linear pos-rel rel-t-25-p mt-7px"><button class="btn-secondary p-0 no-bg a-txt-clr-2-t-1 trans-200-bg-linear border-0 tultip-right" type="button" ng-if="!curMessageObj.isDeleted && !curMessageObj.isFile && curMessageObj.Message.includes(\'Call has been scheduled\')" ng-click="reScheduledCall(curMessageObj)"><i class="fa fa-calendar fs-16px fw-500 txt-clr-33"></i> <span class="tultiptext tt-white">Reschedule</span></button></div></div><div class="clearfix"></div></div></div><button type="button" ng-click="topFunction()" id="chat-bottom-btn" tooltip-class="uibtooltipDenial" uib-tooltip="Back to Bottom" tooltip-placement="auto left"><i class="fa fa-chevron-down"></i></button></div></div><div class="chat-user-action-container w-100 bg-clr-31 pos-rel"><div class="show-hi-pri-alert a-trans-t-500-cb highpriority-alert-section show-hi-pri-alert-active" style="top:-40px;" ng-show="isHighPriority"><h5 class="m-0 text-center fs-12px pt-1 txt-clr-1 rounded">You have clicked on High-Priority Message. This message will be sent as a High Priority message.</h5></div><div class="chat-user-action-inner w-100 height-inherit pos-rel bg-clr-31 typesec"><div class="ui-chat-reply-container w-100 h-30px"><div class="ui-chat-highpriority float-left w-20px height-inherit v-a-m text-center" ng-class="{\'d-none\': (selectedUserObject.UserIDs && DataObject.SpecialGroupIDs.includes(selectedUserObject.ChatGroupID)) ? !((DataObject.SpecialUserEmailIDs.includes(DataObject.CurrentUserEmail) && (selectedUserObject.UserIDs.includes(currUserId)))) : selectedUserObject.UserIDs ? !(selectedUserObject.UserIDs.includes(currUserId)) : false}"><button type="button" class="btn-secondary width-inherit height-inherit no-bg otln-0 a-txt-clr-2-t-1 tultip-top fs-20px" ng-disabled="isDisabled()" ng-click="changePriority()" ng-style="{ \'cursor\' : (isDisabled()) ? \'not-allowed\' : \'pointer\' }" tooltip-class="uibtooltipDenial" uib-tooltip="Mark as Important" tooltip-placement="auto top-left"><span ng-class="{\'txt-clr-6\':isHighPriority,\'txt-clr-14\':!isHighPriority}"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></button></div><div ng-class="{\'d-none\':(selectedUserObject.UserIDs && DataObject.SpecialGroupIDs.includes(selectedUserObject.ChatGroupID)) ? !((DataObject.SpecialUserEmailIDs.includes(DataObject.CurrentUserEmail) && (selectedUserObject.UserIDs.includes(currUserId)))) : selectedUserObject.UserIDs ? !(selectedUserObject.UserIDs.includes(currUserId)) : false}" class="ui-chat-reply-placeholder w-c-100-50px my-0 mx-5px float-left b-1-s b-clr-3 bg-clr-44 bor-rad-5px nohvr" style="border-color: #686868 !important;"><textarea placeholder="Type your message here. (Ctrl + Enter to break line)" id="message" ng-model="message" ng-trim="true" ng-keydown="onFolderNumberKeyPress($event,message)" ng-disabled="EnterKeyFlag" spellcheck="true" class="w-90 border-0 no-resize otln-0 fs-13px scrollbar-macosx overflow-x-hide no-bg txt-clr-19 bor-rad-5px bg-clr-44 typeheresec" data-jquery-scrollbar=""></textarea></div><div class="ui-chat-utility-placeholder float-left w-20px height-inherit v-a-m" ng-class="{\'d-none\':(selectedUserObject.UserIDs && DataObject.SpecialGroupIDs.includes(selectedUserObject.ChatGroupID)) ? !((DataObject.SpecialUserEmailIDs.includes(DataObject.CurrentUserEmail) && (selectedUserObject.UserIDs.includes(currUserId)))) : selectedUserObject.UserIDs ? !(selectedUserObject.UserIDs.includes(currUserId)) : false}"><div class="image-upload w-20px h-20px float-left cursor-pointer pos-rel"><label for="file-input" class="text-center tultip-top pos-abs chatclip mx-8px" tooltip-class="uibtooltipDenial" uib-tooltip="Attach File" tooltip-placement="auto top" style="top:10px;left:-40px;"><img src="assets/images/clip-01.svg" class="attach-icon cursor-pointer" alt="Attach File"></label> <input id="file-input" type="file" style="display:none" onchange="angular.element(this).scope().uploadFile(this)"></div><div class="float-left w-20px" role="group" aria-label="Chat Utility Action"><button type="button" class="btn-secondary p-0 otln-0 chat-send-btn border-0 no-bg cursor-pointer pos-rel" style="left: 2px; top: -10px;" tooltip-class="uibtooltipDenial" uib-tooltip="Send" tooltip-placement="auto left" ng-disabled="isSendDisabled()" ng-click="sendMessage(message)" ng-style="{ \'cursor\' : (isDisabled()) ? \'not-allowed\' : \'pointer\' }"><svg class="send-icon" width="27" height="29" viewbox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.6882 0.473358C26.5362 0.31426 26.3442 0.204107 26.1347 0.15585C25.9252 0.107593 25.7069 0.123237 25.5056 0.200944L0.726865 9.67618C0.513168 9.76142 0.329188 9.91301 0.19936 10.1108C0.069532 10.3086 0 10.5433 0 10.7836C0 11.0239 0.069532 11.2586 0.19936 11.4564C0.329188 11.6542 0.513168 11.8058 0.726865 11.891L10.4018 15.9535L17.5426 8.42072L19.1307 10.0907L11.9561 17.6354L15.8306 27.8094C15.9141 28.0298 16.0586 28.2188 16.2453 28.3518C16.4321 28.4848 16.6525 28.5558 16.8781 28.5556C17.1057 28.5507 17.3266 28.4734 17.5115 28.3338C17.6965 28.1943 17.837 27.9991 17.9143 27.7739L26.9248 1.71698C27.0015 1.50743 27.02 1.27926 26.9781 1.05907C26.9363 0.838885 26.8357 0.635751 26.6882 0.473358Z" ng-style="{\'fill\': isHighPriority ? \'#c73e3e\' : \'#07E6C4\'}"></path></svg></button></div></div><div class="text-center txt-clr-2" ng-class="{\'d-none\': (selectedUserObject.UserIDs && DataObject.SpecialGroupIDs.includes(selectedUserObject.ChatGroupID)) ? ((DataObject.SpecialUserEmailIDs.includes(DataObject.CurrentUserEmail) && (selectedUserObject.UserIDs.includes(currUserId)))) : selectedUserObject.UserIDs ? (selectedUserObject.UserIDs.includes(currUserId)) : true}">Because you\'re not a member, you can\'t send messages to this group.</div><div class="clearfix"></div></div><div class="chat-istyping-container w-100"><div class="chat-istyping-inner w-30 m-y-0-125 height-2 pos-abs abs-l-0 pl-5px"><h5 class="px-0 m-0 p-y-0-1875 fs-12px txt-clr-10 fw-400 fs-13px" ng-show="isTypingMessage"><span class="fw-400 txt-clr-10">{{isTypingMessage}}</span></h5></div></div></div></div></div></div></div><div class="w-240px mob-w-100 mob-h-100vh float-left bg-clr-50 pb-10px pr-0 ch-userlist" style="border: 1px solid #46454a;"><ul class="chattabmenu nav nav-tabs"><li id="chatall" class="active"><a data-toggle="tab" class="d-flex align-item-center justify-content-center p-5px-all all-role-step" style="flex-direction: column;" ng-click="onChatTabChange(\'All\')"><svg width="27" class="" ng-class="{\'rad-svg-icon\': UserRoleTab == \'All\'}" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9942 12.5L12.9939 12C12.7178 12.0002 12.4941 12.2241 12.4942 12.5002C12.4943 12.7762 12.7182 13 12.9943 13L12.9942 12.5ZM18.21 15.7084C18.3687 15.9344 18.6805 15.989 18.9065 15.8304C19.1325 15.6717 19.1871 15.3598 19.0285 15.1338L18.21 15.7084ZM0.590966 15.134C0.432151 15.3599 0.486536 15.6718 0.712439 15.8306C0.938343 15.9894 1.25022 15.935 1.40903 15.7091L0.590966 15.134ZM11.8413 15.7087C12.0002 15.9346 12.3121 15.989 12.5379 15.8302C12.7638 15.6713 12.8182 15.3594 12.6594 15.1335L11.8413 15.7087ZM11.7563 4.04502C11.4905 4.11991 11.3358 4.39608 11.4106 4.66188C11.4855 4.92767 11.7617 5.08243 12.0275 5.00754L11.7563 4.04502ZM12.9946 13C14.0176 12.9992 15.0256 13.245 15.9335 13.7164L16.3944 12.829C15.3439 12.2835 14.1775 11.9991 12.9939 12L12.9946 13ZM15.9335 13.7164C16.8413 14.1879 17.6222 14.8712 18.21 15.7084L19.0285 15.1338C18.3483 14.1651 17.4448 13.3745 16.3944 12.829L15.9335 13.7164ZM1.40903 15.7091C1.99738 14.8723 2.77844 14.1892 3.68628 13.7177L3.22536 12.8303C2.17514 13.3757 1.27158 14.1659 0.590966 15.134L1.40903 15.7091ZM3.68628 13.7177C4.59413 13.2462 5.60209 13 6.62508 13L6.62505 12C5.44162 12 4.27557 12.2848 3.22536 12.8303L3.68628 13.7177ZM6.62508 13C7.64808 12.9999 8.65606 13.246 9.56394 13.7175L10.0248 12.83C8.97454 12.2846 7.80847 11.9999 6.62505 12L6.62508 13ZM9.56394 13.7175C10.4718 14.1889 11.2529 14.8719 11.8413 15.7087L12.6594 15.1335C11.9787 14.1655 11.0751 13.3754 10.0248 12.83L9.56394 13.7175ZM10.1878 8.43745C10.1878 10.4049 8.59262 12 6.62506 12V13C9.14482 13 11.1878 10.9573 11.1878 8.43745H10.1878ZM6.62506 12C4.65759 12 3.06283 10.405 3.06283 8.43745H2.06283C2.06283 10.9572 4.10522 13 6.62506 13V12ZM3.06283 8.43745C3.06283 6.46994 4.65781 4.87495 6.62533 4.87495V3.87495C4.10553 3.87495 2.06283 5.91765 2.06283 8.43745H3.06283ZM6.62533 4.87495C8.59284 4.87495 10.1878 6.46994 10.1878 8.43745H11.1878C11.1878 5.91765 9.14513 3.87495 6.62533 3.87495V4.87495ZM12.0275 5.00754C12.5175 4.86949 13.0314 4.83804 13.5346 4.91531L13.6864 3.9269C13.042 3.82793 12.3838 3.86821 11.7563 4.04502L12.0275 5.00754ZM13.5346 4.91531C14.0378 4.99259 14.5185 5.17679 14.9445 5.45552L15.4921 4.61873C14.9465 4.26177 14.3308 4.02586 13.6864 3.9269L13.5346 4.91531ZM14.9445 5.45552C15.3705 5.73425 15.7318 6.10104 16.0042 6.53117L16.8491 5.99627C16.5003 5.44542 16.0376 4.97569 15.4921 4.61873L14.9445 5.45552ZM16.0042 6.53117C16.2765 6.9613 16.4534 7.44479 16.5231 7.94907L17.5137 7.81213C17.4244 7.16631 17.1978 6.54712 16.8491 5.99627L16.0042 6.53117ZM16.5231 7.94907C16.5929 8.45335 16.5537 8.96672 16.4083 9.4546L17.3666 9.74021C17.5529 9.1154 17.603 8.45795 17.5137 7.81213L16.5231 7.94907ZM16.4083 9.4546C16.2629 9.94247 16.0146 10.3935 15.6802 10.7774L16.4343 11.4342C16.8625 10.9427 17.1804 10.365 17.3666 9.74021L16.4083 9.4546ZM15.6802 10.7774C15.3459 11.1612 14.9331 11.469 14.4697 11.6799L14.884 12.59C15.4774 12.3199 16.006 11.9258 16.4343 11.4342L15.6802 10.7774ZM14.4697 11.6799C14.0064 11.8907 13.5032 11.9999 12.9942 12L12.9943 13C13.6462 12.9999 14.2906 12.8601 14.884 12.59L14.4697 11.6799Z" fill="white"></path></svg>All</a></li><li id="chatuser"><a data-toggle="tab" class="d-flex align-item-center justify-content-center p-5px-all rad-role-step" style="flex-direction: column;" ng-click="onChatTabChange(\'Radiologist\')"><svg width="27" class="" ng-class="{\'rad-svg-icon\': UserRoleTab == \'Radiologist\'}" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.42188 16.8743C3.19028 15.5442 4.29517 14.4398 5.62553 13.672C6.9559 12.9042 8.4649 12.5 10.0009 12.5C11.537 12.5 13.046 12.9043 14.3763 13.6721C15.7067 14.44 16.8116 15.5444 17.5799 16.8744M13.7509 4.375H17.5009M15.6259 2.5V6.25M14.6924 9.23303C14.3581 10.1354 13.7705 10.9221 13 11.4987C12.2295 12.0752 11.3089 12.417 10.3489 12.483C9.38885 12.549 8.43016 12.3364 7.58801 11.8708C6.74585 11.4052 6.05604 10.7063 5.60145 9.85814C5.14686 9.00997 4.94682 8.04859 5.02536 7.0895C5.10391 6.1304 5.45769 5.21438 6.04422 4.45148C6.63074 3.68857 7.42506 3.11124 8.33175 2.78883C9.23844 2.46642 10.2189 2.41265 11.1554 2.63397" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg>Rad</a></li><li id="chattechnologist"><a data-toggle="tab" class="d-flex align-item-center justify-content-center p-5px-all tech-role-step" style="flex-direction: column;" ng-click="onChatTabChange(\'Technologist\')"><svg width="27" class="" ng-class="{\'rad-svg-icon\': UserRoleTab == \'Technologist\'}" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.42188 16.8743C3.19028 15.5442 4.29517 14.4398 5.62553 13.672C6.9559 12.9042 8.4649 12.5 10.0009 12.5C11.537 12.5 13.046 12.9043 14.3763 13.6721C15.7067 14.44 16.8116 15.5444 17.5799 16.8744M13.7509 4.375H17.5009M15.6259 2.5V6.25M14.6924 9.23303C14.3581 10.1354 13.7705 10.9221 13 11.4987C12.2295 12.0752 11.3089 12.417 10.3489 12.483C9.38885 12.549 8.43016 12.3364 7.58801 11.8708C6.74585 11.4052 6.05604 10.7063 5.60145 9.85814C5.14686 9.00997 4.94682 8.04859 5.02536 7.0895C5.10391 6.1304 5.45769 5.21438 6.04422 4.45148C6.63074 3.68857 7.42506 3.11124 8.33175 2.78883C9.23844 2.46642 10.2189 2.41265 11.1554 2.63397" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg>Tech</a></li><li id="chatadmin"><a data-toggle="tab" class="d-flex align-item-center justify-content-center p-5px-all admin-role-step" style="flex-direction: column;" ng-click="onChatTabChange(\'Admin\')"><svg width="27" class="" ng-class="{\'rad-svg-icon\': UserRoleTab == \'Admin\'}" viewbox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.92188 16.8743C3.69028 15.5442 4.79517 14.4398 6.12553 13.672C7.4559 12.9042 8.9649 12.5 10.5009 12.5C12.037 12.5 13.546 12.9043 14.8763 13.6721C16.2067 14.44 17.3116 15.5444 18.0799 16.8744M16.1259 5.625V6.5625M16.1259 5.625C16.8162 5.625 17.3759 5.06536 17.3759 4.375C17.3759 3.68464 16.8162 3.125 16.1259 3.125M16.1259 5.625C15.4355 5.625 14.8759 5.06536 14.8759 4.375C14.8759 3.68464 15.4355 3.125 16.1259 3.125M16.1259 3.125V2.1875M17.2084 5L18.0203 5.46875M15.0433 5L14.2314 5.46875M17.2084 3.75L18.0203 3.28125M15.0433 3.75L14.2314 3.28125M15.0811 9.50855C14.707 10.3598 14.1029 11.0898 13.3366 11.6166C12.5704 12.1433 11.6724 12.4458 10.7436 12.4901C9.81488 12.5345 8.89216 12.3188 8.07925 11.8674C7.26633 11.4161 6.59545 10.7469 6.14203 9.93508C5.68861 9.1233 5.47064 8.20114 5.51262 7.27226C5.5546 6.34339 5.85487 5.44464 6.37966 4.67707C6.90446 3.9095 7.63297 3.30355 8.48329 2.92735C9.33361 2.55114 10.272 2.4196 11.193 2.54752" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg>Admin</a></li><li id="chatphysician"><a data-toggle="tab" class="d-flex align-item-center justify-content-center p-5px-all rad-role-step" style="flex-direction: column; font-size:11px" ng-click="onChatTabChange(\'Physician\')"><svg width="27" class="" ng-class="{\'rad-svg-icon\': UserRoleTab == \'Physician\'}" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.42188 16.8743C3.19028 15.5442 4.29517 14.4398 5.62553 13.672C6.9559 12.9042 8.4649 12.5 10.0009 12.5C11.537 12.5 13.046 12.9043 14.3763 13.6721C15.7067 14.44 16.8116 15.5444 17.5799 16.8744M13.7509 4.375H17.5009M15.6259 2.5V6.25M14.6924 9.23303C14.3581 10.1354 13.7705 10.9221 13 11.4987C12.2295 12.0752 11.3089 12.417 10.3489 12.483C9.38885 12.549 8.43016 12.3364 7.58801 11.8708C6.74585 11.4052 6.05604 10.7063 5.60145 9.85814C5.14686 9.00997 4.94682 8.04859 5.02536 7.0895C5.10391 6.1304 5.45769 5.21438 6.04422 4.45148C6.63074 3.68857 7.42506 3.11124 8.33175 2.78883C9.23844 2.46642 10.2189 2.41265 11.1554 2.63397" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg>Physician</a></li><li id="chatclinical"><a data-toggle="tab" class="d-flex align-item-center justify-content-center p-5px-all tech-role-step" style="flex-direction: column;" ng-click="onChatTabChange(\'ClinicalCare\')"><svg width="27" class="" ng-class="{\'rad-svg-icon\': UserRoleTab == \'ClinicalCare\'}" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.42188 16.8743C3.19028 15.5442 4.29517 14.4398 5.62553 13.672C6.9559 12.9042 8.4649 12.5 10.0009 12.5C11.537 12.5 13.046 12.9043 14.3763 13.6721C15.7067 14.44 16.8116 15.5444 17.5799 16.8744M13.7509 4.375H17.5009M15.6259 2.5V6.25M14.6924 9.23303C14.3581 10.1354 13.7705 10.9221 13 11.4987C12.2295 12.0752 11.3089 12.417 10.3489 12.483C9.38885 12.549 8.43016 12.3364 7.58801 11.8708C6.74585 11.4052 6.05604 10.7063 5.60145 9.85814C5.14686 9.00997 4.94682 8.04859 5.02536 7.0895C5.10391 6.1304 5.45769 5.21438 6.04422 4.45148C6.63074 3.68857 7.42506 3.11124 8.33175 2.78883C9.23844 2.46642 10.2189 2.41265 11.1554 2.63397" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg>Clinical Care</a></li><li id="chatgroup"><a data-toggle="tab" class="d-flex align-item-center justify-content-center p-5px-all all-role-step" style="flex-direction: column;" ng-click="onChatTabChange(\'Group\')"><svg width="28" height="27" class="" ng-class="{\'rad-svg-icon\': UserRoleTab == \'Group\'}" viewbox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.8794 16.8753L17.8791 16.3753C17.603 16.3755 17.3793 16.5994 17.3794 16.8755C17.3796 17.1516 17.6034 17.3753 17.8795 17.3753L17.8794 16.8753ZM25.064 21.1062C25.2227 21.3322 25.5345 21.3868 25.7605 21.2281C25.9865 21.0694 26.0411 20.7576 25.8825 20.5316L25.064 21.1062ZM1.27822 20.5319C1.11941 20.7578 1.17379 21.0697 1.3997 21.2285C1.6256 21.3873 1.93747 21.3329 2.09629 21.107L1.27822 20.5319ZM16.4662 21.1065C16.6251 21.3324 16.9369 21.3867 17.1628 21.2279C17.3887 21.0691 17.4431 20.7572 17.2842 20.5313L16.4662 21.1065ZM16.2557 5.62956C15.9899 5.70445 15.8352 5.98062 15.9101 6.24642C15.985 6.51221 16.2611 6.66697 16.5269 6.59208L16.2557 5.62956ZM17.8794 16.8753L17.8798 17.3753C19.2889 17.3743 20.6776 17.7128 21.9281 18.3622L22.1586 17.9185L22.389 17.4748C20.9959 16.7513 19.4489 16.3741 17.8791 16.3753L17.8794 16.8753ZM22.1586 17.9185L21.9281 18.3622C23.1787 19.0117 24.2543 19.9529 25.064 21.1062L25.4732 20.8189L25.8825 20.5316C24.9805 19.2468 23.7822 18.1983 22.389 17.4748L22.1586 17.9185ZM1.68726 20.8195L2.09629 21.107C2.9067 19.9543 3.98258 19.0134 5.23308 18.3639L5.00261 17.9202L4.77215 17.4765C3.37927 18.1999 2.1809 19.2479 1.27822 20.5319L1.68726 20.8195ZM5.00261 17.9202L5.23308 18.3639C6.48358 17.7144 7.872 17.3753 9.28111 17.3753L9.28109 16.8753L9.28107 16.3753C7.71152 16.3753 6.16503 16.753 4.77215 17.4765L5.00261 17.9202ZM9.28109 16.8753L9.28111 17.3753C10.6902 17.3752 12.0787 17.7142 13.3292 18.3636L13.5597 17.9199L13.7901 17.4761C12.3972 16.7528 10.8506 16.3752 9.28107 16.3753L9.28109 16.8753ZM13.5597 17.9199L13.3292 18.3636C14.5798 19.013 15.6557 19.9538 16.4662 21.1065L16.8752 20.8189L17.2842 20.5313C16.3815 19.2474 15.183 18.1995 13.7901 17.4761L13.5597 17.9199ZM14.7658 11.3909H14.2658C14.2658 14.1437 12.0339 16.3753 9.28109 16.3753V16.8753V17.3753C12.5861 17.3753 15.2658 14.696 15.2658 11.3909H14.7658ZM9.28109 16.8753V16.3753C6.52834 16.3753 4.29707 14.1437 4.29707 11.3909H3.79707H3.29707C3.29707 14.6959 5.97597 17.3753 9.28109 17.3753V16.8753ZM3.79707 11.3909H4.29707C4.29707 8.63811 6.52865 6.40653 9.28145 6.40653V5.90653V5.40653C5.97637 5.40653 3.29707 8.08582 3.29707 11.3909H3.79707ZM9.28145 5.90653V6.40653C12.0342 6.40653 14.2658 8.63811 14.2658 11.3909H14.7658H15.2658C15.2658 8.08582 12.5865 5.40653 9.28145 5.40653V5.90653ZM16.3913 6.11082L16.5269 6.59208C17.2125 6.39893 17.9315 6.35492 18.6355 6.46304L18.7114 5.96883L18.7873 5.47463C17.9421 5.34482 17.0788 5.39765 16.2557 5.62956L16.3913 6.11082ZM18.7114 5.96883L18.6355 6.46304C19.3395 6.57116 20.0122 6.82888 20.6082 7.21886L20.882 6.80046L21.1557 6.38207C20.4401 5.91386 19.6325 5.60443 18.7873 5.47463L18.7114 5.96883ZM20.882 6.80046L20.6082 7.21886C21.2042 7.60884 21.7097 8.12201 22.0907 8.72381L22.5132 8.45636L22.9356 8.18891C22.4782 7.46639 21.8713 6.85027 21.1557 6.38207L20.882 6.80046ZM22.5132 8.45636L22.0907 8.72381C22.4717 9.32561 22.7193 10.0021 22.8169 10.7076L23.3121 10.6392L23.8074 10.5707C23.6903 9.72359 23.3931 8.91144 22.9356 8.18891L22.5132 8.45636ZM23.3121 10.6392L22.8169 10.7076C22.9144 11.4132 22.8596 12.1314 22.6562 12.814L23.1353 12.9568L23.6145 13.0996C23.8588 12.2801 23.9245 11.4178 23.8074 10.5707L23.3121 10.6392ZM23.1353 12.9568L22.6562 12.814C22.4527 13.4966 22.1054 14.1277 21.6375 14.6648L22.0145 14.9932L22.3916 15.3216C22.9533 14.6768 23.3703 13.9192 23.6145 13.0996L23.1353 12.9568ZM22.0145 14.9932L21.6375 14.6648C21.1697 15.2018 20.5922 15.6324 19.9439 15.9274L20.151 16.3825L20.3582 16.8376C21.1365 16.4833 21.8298 15.9664 22.3916 15.3216L22.0145 14.9932ZM20.151 16.3825L19.9439 15.9274C19.2956 16.2225 18.5917 16.3752 17.8794 16.3753L17.8794 16.8753L17.8795 17.3753C18.7346 17.3752 19.5798 17.1918 20.3582 16.8376L20.151 16.3825Z" fill="white"></path><path d="M21.6001 3.88086H26.6626M24.1313 1.34961V6.41211" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg>Group</a></li></ul><div><div class="user-search-placeholder w-100 pos-rel abs-t-0 h-80px bg-clr-32"><div class="row mx-0 p-t-0-25"><div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 bg-clr-50 insearch-bgcolor"><div class="input-group w-100 mb-8px dummychat-placeholder"><div class="d-flex justify-content-between align-content-center mb-5px py-3px chat-users-header pl-10px"><span class="d-inline-block fs-15px fw-600 fc-ffffff align-self-center ct-usrs--heading">Chat</span> <span class="d-flex align-item-center"><a data-toggle="tab" class="d-flex align-item-center justify-content-center cursor-pointer px-2px all-role-step" title="Create Group" style="flex-direction: column;" ng-click="OpenGroupModal(\'Create\')"><svg width="20" height="19" viewbox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.81124 4.05662C8.81124 2.74363 7.74686 1.67925 6.43387 1.67925C5.12089 1.67925 4.05651 2.74363 4.05651 4.05662C4.05651 5.3696 5.12089 6.43398 6.43387 6.43398V7.11323C4.74575 7.11323 3.37726 5.74474 3.37726 4.05662C3.37726 2.36849 4.74575 1 6.43387 1C8.122 1 9.49049 2.36849 9.49049 4.05662C9.49049 5.74474 8.122 7.11323 6.43387 7.11323V6.43398C7.74686 6.43398 8.81124 5.3696 8.81124 4.05662Z" fill="#33DEA1"></path><path d="M16.2829 5.07588C16.2829 3.95046 15.3706 3.03813 14.2452 3.03813C13.1198 3.03813 12.2074 3.95046 12.2074 5.07588C12.2074 6.20129 13.1198 7.11362 14.2452 7.11362V7.79287C12.7446 7.79287 11.5282 6.57643 11.5282 5.07588C11.5282 3.57533 12.7446 2.35889 14.2452 2.35889C15.7457 2.35889 16.9622 3.57533 16.9622 5.07588C16.9622 6.57643 15.7457 7.79287 14.2452 7.79287V7.11362C15.3706 7.11362 16.2829 6.20129 16.2829 5.07588Z" fill="#33DEA1"></path><path d="M0.999878 9.67925C1.00004 8.44987 1.99662 7.45328 3.22601 7.45312H9.64172C10.4487 7.45323 11.1547 7.88284 11.5448 8.5244L11.6184 8.65508L11.6443 8.71942C11.6872 8.87118 11.6192 9.03716 11.4738 9.11277C11.3282 9.18836 11.1527 9.14858 11.0533 9.02588L11.0155 8.96817L10.9644 8.87663C10.6926 8.42986 10.2016 8.13248 9.64172 8.13237H3.22601C2.37176 8.13253 1.67929 8.82501 1.67913 9.67925C1.67913 12.201 3.72371 14.2456 6.24548 14.2456H6.62225C7.68224 14.2456 8.6573 13.8848 9.4321 13.2791L9.49048 13.2427C9.63192 13.1722 9.80793 13.2082 9.90904 13.3375C10.0245 13.4853 9.99841 13.6989 9.85066 13.8144L9.68085 13.9411C8.81988 14.56 7.76315 14.9249 6.62225 14.9249H6.24548C3.34858 14.9249 0.999878 12.5762 0.999878 9.67925Z" fill="#33DEA1"></path><path d="M14.5849 8.47217C17.0233 8.47217 19 10.4489 19 12.8873C19 15.3257 17.0233 17.3024 14.5849 17.3024C12.1465 17.3024 10.1698 15.3257 10.1698 12.8873C10.1698 10.4489 12.1465 8.47217 14.5849 8.47217ZM14.5849 10.5099C14.3084 10.5099 14.0841 10.7343 14.0841 11.0107V12.3865H12.7084C12.4319 12.3865 12.2075 12.6109 12.2075 12.8873C12.2075 13.1637 12.4319 13.3881 12.7084 13.3881H14.0841V14.7638C14.0841 15.0402 14.3084 15.2646 14.5849 15.2646C14.8613 15.2646 15.0857 15.0402 15.0857 14.7638V13.3881H16.4615C16.7378 13.3881 16.9623 13.1637 16.9623 12.8873C16.9623 12.6109 16.7378 12.3865 16.4615 12.3865H15.0857V11.0107C15.0857 10.7343 14.8613 10.5099 14.5849 10.5099Z" fill="#33DEA1"></path></svg></a> <a ng-click="activeChatMenuBar()"><span class="chervon-toggle icon-hover-bg close-ct-users align-self-center"><i class="fa fa-close txt-clr-14 cursor-pointer fs-12px fw-500"></i></span></a></span></div><div style="background-color: #2e2d32 !important; position:relative;" ng-show="showUsersLoader"><div class="progress m-0" style="background-color: #2e2d32 !important; margin-bottom:-20px !important"><div class="progress-bar progress-bar-striped grid-xs-loader pos-abs h-2px active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div class="right-inner-addon"><input type="text" class="searchBar blk-input mt-5px form-control ui-user-search txt-clr-1 fw-100 border-0 float-left mr-0 ml-10px bg-clr-31 w-92 pr-62px" ng-model="UserName" placeholder="I\'m looking for" tooltip-class="uibtooltipDenial" uib-tooltip="Last Name, First Name Or Group Name" tooltip-placement="auto top" ng-change="OnChangeFilter()" ng-model-options="{ debounce: 500 }"> <button type="button" class="btn-transparent otln-0 border-0 no-bg cursor-pointer" ng-click="clearChatFilter();"><i class="fa fa-close" ng-if="UserName && UserName!=\'\'"></i></button></div></div></div></div></div><div class="tab-content p-0" id="ChatUserListDiv"><div id="UserListID" infinitescroll="UserListNextPage()" style="overflow: auto; box-shadow: none !important; outline: 0 !important; border-left-color: #1e1e1e !important;" class="tab-pane fade in active user-list-placeholder w-100 pos-rel abs-t-3 scrollbar-macosx overflow-x-hide p-r-2 pt-1 pl-10px userlist-wrapper"><div><a data-toggle="collapse" data-target="#PinnedUsersList" class="chat-userlist-filter pintab-step d-block pos-rel mt-0">Pinned</a><div id="PinnedUsersList" role="tabpanel" aria-labelledby="heading_demo" class="collapse in"><div ng-repeat="curUserObj in pinnedUserList" class="pos-rel" ng-mousedown="showContextMenu($event,curUserObj)" ng-if="pinnedUserList.length>0"><div ng-click="itemClicked(curUserObj,isShareChatLink)" ui-draggable="true" drag="curUserObj" drag-channel="priests" on-drop-success="dropSuccessHandler($event, $index, userListVM)" set-profile-pic="" class="trans-200-bg-linear width-inherit pos-rel fx-fade-normal fx-dur-300 fx-ease-cubic fx-stagger-0 chat-userlist-container h-42px cursor-pointer py-3px mb-1px ng-scope user-container no-bg" ng-class="(!curUserObj.IsInvited) ? ((selectedUserId && curUserObj.Id == selectedUserId) || (selectedChatGroupId && curUserObj.ChatGroupID == selectedChatGroupId) ? \'user-obj-selected user-container\' : \'user-container no-bg\') : \'pointer-null\'"><div class="user-container-inner w-100 pos-abs clearfix no-bg pl-3px" ng-click="((curUserObj.IsInvited) ? \'\' : setUserChat(curUserObj))"><div class="user-active-state-indicator w-5px height-inherit float-left pos-rel"><div class="user-active-state-indicator-inner width-0-25 height-inherit" ng-class="(!curUserObj.IsInvited) ? ((curUserObj.Id == selectedUserId) || (curUserObj.ChatGroupID == selectedChatGroupId) ? \'\' : \'\') : \'\'"></div></div><div class="chat-name-circle list-userpic-bg" popover-class="popoverchatuser" uib-popover-template="\'toUserProfileDetails.html\'" popover-trigger="outsideClick" popover-append-to-body="true" popover-placement="auto" popover-animation="true" popover-is-open="curUserObj.ispopOverOpen" ng-mouseenter="showToUserDetails(curUserObj)" ng-mouseleave="hideToUserDetails();"><i class="fa fa-circle pos-rel usr-circle" ng-class="{\'usronline\':curUserObj.IsOnline,\'txt-clr-25\':!curUserObj.IsOnline}" ng-if="!curUserObj.ChatGroupID"></i><div ng-if="!curUserObj.ProfilePic"><div ng-if="!curUserObj.IsGroupType"><div data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="profilepic">{{maskInitials(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id)}}</div></div><div ng-if="curUserObj.ChatGroupID"><div data-toggle="modal" class="profilepic pos-rel pt-8px"><svg width="20" class="" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9942 12.5L12.9939 12C12.7178 12.0002 12.4941 12.2241 12.4942 12.5002C12.4943 12.7762 12.7182 13 12.9943 13L12.9942 12.5ZM18.21 15.7084C18.3687 15.9344 18.6805 15.989 18.9065 15.8304C19.1325 15.6717 19.1871 15.3598 19.0285 15.1338L18.21 15.7084ZM0.590966 15.134C0.432151 15.3599 0.486536 15.6718 0.712439 15.8306C0.938343 15.9894 1.25022 15.935 1.40903 15.7091L0.590966 15.134ZM11.8413 15.7087C12.0002 15.9346 12.3121 15.989 12.5379 15.8302C12.7638 15.6713 12.8182 15.3594 12.6594 15.1335L11.8413 15.7087ZM11.7563 4.04502C11.4905 4.11991 11.3358 4.39608 11.4106 4.66188C11.4855 4.92767 11.7617 5.08243 12.0275 5.00754L11.7563 4.04502ZM12.9946 13C14.0176 12.9992 15.0256 13.245 15.9335 13.7164L16.3944 12.829C15.3439 12.2835 14.1775 11.9991 12.9939 12L12.9946 13ZM15.9335 13.7164C16.8413 14.1879 17.6222 14.8712 18.21 15.7084L19.0285 15.1338C18.3483 14.1651 17.4448 13.3745 16.3944 12.829L15.9335 13.7164ZM1.40903 15.7091C1.99738 14.8723 2.77844 14.1892 3.68628 13.7177L3.22536 12.8303C2.17514 13.3757 1.27158 14.1659 0.590966 15.134L1.40903 15.7091ZM3.68628 13.7177C4.59413 13.2462 5.60209 13 6.62508 13L6.62505 12C5.44162 12 4.27557 12.2848 3.22536 12.8303L3.68628 13.7177ZM6.62508 13C7.64808 12.9999 8.65606 13.246 9.56394 13.7175L10.0248 12.83C8.97454 12.2846 7.80847 11.9999 6.62505 12L6.62508 13ZM9.56394 13.7175C10.4718 14.1889 11.2529 14.8719 11.8413 15.7087L12.6594 15.1335C11.9787 14.1655 11.0751 13.3754 10.0248 12.83L9.56394 13.7175ZM10.1878 8.43745C10.1878 10.4049 8.59262 12 6.62506 12V13C9.14482 13 11.1878 10.9573 11.1878 8.43745H10.1878ZM6.62506 12C4.65759 12 3.06283 10.405 3.06283 8.43745H2.06283C2.06283 10.9572 4.10522 13 6.62506 13V12ZM3.06283 8.43745C3.06283 6.46994 4.65781 4.87495 6.62533 4.87495V3.87495C4.10553 3.87495 2.06283 5.91765 2.06283 8.43745H3.06283ZM6.62533 4.87495C8.59284 4.87495 10.1878 6.46994 10.1878 8.43745H11.1878C11.1878 5.91765 9.14513 3.87495 6.62533 3.87495V4.87495ZM12.0275 5.00754C12.5175 4.86949 13.0314 4.83804 13.5346 4.91531L13.6864 3.9269C13.042 3.82793 12.3838 3.86821 11.7563 4.04502L12.0275 5.00754ZM13.5346 4.91531C14.0378 4.99259 14.5185 5.17679 14.9445 5.45552L15.4921 4.61873C14.9465 4.26177 14.3308 4.02586 13.6864 3.9269L13.5346 4.91531ZM14.9445 5.45552C15.3705 5.73425 15.7318 6.10104 16.0042 6.53117L16.8491 5.99627C16.5003 5.44542 16.0376 4.97569 15.4921 4.61873L14.9445 5.45552ZM16.0042 6.53117C16.2765 6.9613 16.4534 7.44479 16.5231 7.94907L17.5137 7.81213C17.4244 7.16631 17.1978 6.54712 16.8491 5.99627L16.0042 6.53117ZM16.5231 7.94907C16.5929 8.45335 16.5537 8.96672 16.4083 9.4546L17.3666 9.74021C17.5529 9.1154 17.603 8.45795 17.5137 7.81213L16.5231 7.94907ZM16.4083 9.4546C16.2629 9.94247 16.0146 10.3935 15.6802 10.7774L16.4343 11.4342C16.8625 10.9427 17.1804 10.365 17.3666 9.74021L16.4083 9.4546ZM15.6802 10.7774C15.3459 11.1612 14.9331 11.469 14.4697 11.6799L14.884 12.59C15.4774 12.3199 16.006 11.9258 16.4343 11.4342L15.6802 10.7774ZM14.4697 11.6799C14.0064 11.8907 13.5032 11.9999 12.9942 12L12.9943 13C13.6462 12.9999 14.2906 12.8601 14.884 12.59L14.4697 11.6799Z" fill="white"></path></svg></div><i ng-if="curUserObj.IsDistributed" style="position: absolute; bottom: 0; right: 0; color: #ccc; text-shadow: 0px 0px 5px #262526;" class="fa fa-lock" aria-hidden="true"></i></div></div><img class="rounded-circle weight-2-5 br-upi w-40px h-40px" data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" ng-src="{{curUserObj.ProfilePic}}" ng-if="curUserObj.ProfilePic"></div><div class="user-bio-placeholder w-c-100-75px height-inherit pos-rel float-left no-bg pl-6px"><div class="chat-and-time" ng-class="(selectedUserId && curUserObj.Id == selectedUserId) ? \'txt-clr-1\' : \'\'"><div class="chat-user-name txt-clr-1 w-150px" tooltip-class="uibtooltipDenial" uib-tooltip="{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}" tooltip-placement="auto top" ng-if="!curUserObj.ChatGroupID">{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}</div><div class="chat-user-name txt-clr-1 w-150px" tooltip-class="uibtooltipDenial" uib-tooltip="{{(curUserObj.GroupName) | lowercase}}" tooltip-placement="auto top" ng-if="curUserObj.ChatGroupID">{{(curUserObj.GroupName) | lowercase}}</div><div class="chat-content w-150px pt-1" ng-if="curUserObj.ChatGroupID"><div ng-if="(curUserObj.UserIDs.includes(currUserId))"><div ng-if="!(curUserObj.FileName.length > 0)"><i class="fa fa-share fs-12px" ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)"></i> <span ng-if="(curUserObj.LastMessage.split(\'|NEWGROUP|\')[1].length > 0)">{{curUserObj.LastMessage.split(\'|NEWGROUP|\')[1]}}</span> <span ng-if="(curUserObj.LastMessage.split(\'|ADDUSER|\')[1].length > 0)">{{curUserObj.ModifiedName}} has added the user to this group.</span> <span ng-if="(curUserObj.LastMessage.split(\'|REMOVEUSER|\')[1].length > 0)">{{curUserObj.ModifiedName}} has removed the user to this group.</span> <span ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] != \'undefined\')">{{curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0]}}</span> <span ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] == \'undefined\')">{{ViewPatientDetails(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span ng-if="!(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0) && !(curUserObj.LastMessage.split(\'|NEWGROUP|\')[1].length > 0) && !(curUserObj.LastMessage.split(\'|ADDUSER|\')[1].length > 0) && !(curUserObj.LastMessage.split(\'|REMOVEUSER|\')[1].length > 0)">{{curUserObj.LastMessage}}</span></div><div ng-if="(curUserObj.FileName.length > 0)"><i class="fa fa-paperclip fs-12px"></i> <span>{{curUserObj.FileName}}</span></div></div><span ng-if="!(curUserObj.UserIDs.includes(currUserId))">You don\'t belong to this group.</span></div><div class="chat-content w-150px pt-1" ng-if="!curUserObj.ChatGroupID"><div ng-if="!(curUserObj.FileName.length > 0)"><i class="fa fa-share fs-12px" ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)"></i> <span ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] != \'undefined\')">{{curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0]}}</span> <span ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] == \'undefined\')">{{ViewPatientDetails(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span ng-if="!(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)">{{curUserObj.LastMessage}}</span></div><div ng-if="(curUserObj.FileName.length > 0)"><i class="fa fa-paperclip fs-12px"></i> <span>{{curUserObj.FileName}}</span></div></div><span class="pos-abs chat-content" style="right: -35px; top: 0; font-size:10px;"><span ng-if="curUserObj.LastMessage.length > 0">{{LastMessageTimeStamp(curUserObj.MessageDT)}}</span></span></div></div><div class="user-action-placeholder w-30px height-inherit float-left no-bg" ng-show="curUserObj.IsInvited"><div class="invited-user-container d-table width-inherit height-inherit" ng-show="curUserObj.IsInvited"><i class="icon-envelope-letter d-table-cell text-center fs-1-25 v-a-m txt-clr-2"></i></div></div><div class="message-ticker-placeholder height-inherit d-flex float-right no-bg message-number-indicator d-flex" style="position: absolute; bottom:0; right: 4px;"><div class="message-ticker-inner d-table height-inherit width-inherit" ng-show="curUserObj.UnreadMsgCount > 0"><div class="message-ticker d-table-cell text-center v-a-m height-inherit width-inherit fw-700"><span class="d-inline-block min-width-17px border-radius-50-all width-inherit bg-clr-39 txt-clr-1 fs-10px p-2px-all">{{curUserObj.UnreadMsgCount}}</span></div></div></div></div></div></div></div><a data-toggle="collapse" data-target="#RecentUserListOnline" class="chat-userlist-filter d-block pos-rel" ng-if="UserRoleTab==\'All\' || UserRoleTab==\'Group\'">Recent</a><div id="RecentUserListOnline" class="collapse in" ng-if="UserRoleTab==\'All\' || UserRoleTab==\'Group\'"><div ng-repeat="curUserObj in userList" class="pos-rel"><div ng-click="itemClicked(curUserObj,isShareChatLink)" ui-draggable="true" ng-mousedown="showContextMenu($event,curUserObj)" drag="curUserObj" drag-channel="priests" on-drop-success="dropSuccessHandler($event, $index, userListVM)" set-profile-pic="" class="trans-200-bg-linear width-inherit pos-rel fx-fade-normal fx-dur-300 fx-ease-cubic fx-stagger-0 chat-userlist-container h-42px cursor-pointer py-3px mb-1px ng-scope user-container no-bg" ng-class="(!curUserObj.IsInvited) ? ((selectedUserId && curUserObj.Id == selectedUserId) || (selectedChatGroupId && curUserObj.ChatGroupID == selectedChatGroupId) ? \'user-obj-selected user-container\' : \'user-container no-bg\') : \'pointer-null\'"><div class="user-container-inner w-100 pos-abs clearfix no-bg pl-3px" ng-click="((!curUserObj.IsGroupType) ? ((curUserObj.IsInvited) ? \'\' : setUserChat(curUserObj)) : setGroupChat(curUserObj))"><div class="user-active-state-indicator w-5px height-inherit float-left pos-rel"><div class="user-active-state-indicator-inner width-0-25 height-inherit" ng-class="(!curUserObj.IsInvited) ? ((curUserObj.Id == selectedUserId) || (curUserObj.ChatGroupID == selectedChatGroupId) ? \'\' : \'\') : \'\'"></div></div><div class="chat-name-circle list-userpic-bg" popover-class="popoverchatuser" uib-popover-template="\'toUserProfileDetails.html\'" popover-trigger="outsideClick" popover-append-to-body="true" popover-placement="auto" popover-animation="true" popover-is-open="curUserObj.ispopOverOpen" ng-mouseenter="showToUserDetails(curUserObj);" ng-mouseleave="hideToUserDetails();"><i class="fa fa-circle pos-rel usr-circle" ng-class="{\'usronline\':curUserObj.IsOnline,\'txt-clr-25\':!curUserObj.IsOnline}" ng-if="!curUserObj.ChatGroupID"></i><div ng-if="!curUserObj.ProfilePic"><div ng-if="!curUserObj.ChatGroupID"><div data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="profilepic">{{maskInitials(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id)}}</div></div><div ng-if="curUserObj.ChatGroupID"><div data-toggle="modal" class="profilepic pt-8px pos-rel"><svg width="20" class="" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9942 12.5L12.9939 12C12.7178 12.0002 12.4941 12.2241 12.4942 12.5002C12.4943 12.7762 12.7182 13 12.9943 13L12.9942 12.5ZM18.21 15.7084C18.3687 15.9344 18.6805 15.989 18.9065 15.8304C19.1325 15.6717 19.1871 15.3598 19.0285 15.1338L18.21 15.7084ZM0.590966 15.134C0.432151 15.3599 0.486536 15.6718 0.712439 15.8306C0.938343 15.9894 1.25022 15.935 1.40903 15.7091L0.590966 15.134ZM11.8413 15.7087C12.0002 15.9346 12.3121 15.989 12.5379 15.8302C12.7638 15.6713 12.8182 15.3594 12.6594 15.1335L11.8413 15.7087ZM11.7563 4.04502C11.4905 4.11991 11.3358 4.39608 11.4106 4.66188C11.4855 4.92767 11.7617 5.08243 12.0275 5.00754L11.7563 4.04502ZM12.9946 13C14.0176 12.9992 15.0256 13.245 15.9335 13.7164L16.3944 12.829C15.3439 12.2835 14.1775 11.9991 12.9939 12L12.9946 13ZM15.9335 13.7164C16.8413 14.1879 17.6222 14.8712 18.21 15.7084L19.0285 15.1338C18.3483 14.1651 17.4448 13.3745 16.3944 12.829L15.9335 13.7164ZM1.40903 15.7091C1.99738 14.8723 2.77844 14.1892 3.68628 13.7177L3.22536 12.8303C2.17514 13.3757 1.27158 14.1659 0.590966 15.134L1.40903 15.7091ZM3.68628 13.7177C4.59413 13.2462 5.60209 13 6.62508 13L6.62505 12C5.44162 12 4.27557 12.2848 3.22536 12.8303L3.68628 13.7177ZM6.62508 13C7.64808 12.9999 8.65606 13.246 9.56394 13.7175L10.0248 12.83C8.97454 12.2846 7.80847 11.9999 6.62505 12L6.62508 13ZM9.56394 13.7175C10.4718 14.1889 11.2529 14.8719 11.8413 15.7087L12.6594 15.1335C11.9787 14.1655 11.0751 13.3754 10.0248 12.83L9.56394 13.7175ZM10.1878 8.43745C10.1878 10.4049 8.59262 12 6.62506 12V13C9.14482 13 11.1878 10.9573 11.1878 8.43745H10.1878ZM6.62506 12C4.65759 12 3.06283 10.405 3.06283 8.43745H2.06283C2.06283 10.9572 4.10522 13 6.62506 13V12ZM3.06283 8.43745C3.06283 6.46994 4.65781 4.87495 6.62533 4.87495V3.87495C4.10553 3.87495 2.06283 5.91765 2.06283 8.43745H3.06283ZM6.62533 4.87495C8.59284 4.87495 10.1878 6.46994 10.1878 8.43745H11.1878C11.1878 5.91765 9.14513 3.87495 6.62533 3.87495V4.87495ZM12.0275 5.00754C12.5175 4.86949 13.0314 4.83804 13.5346 4.91531L13.6864 3.9269C13.042 3.82793 12.3838 3.86821 11.7563 4.04502L12.0275 5.00754ZM13.5346 4.91531C14.0378 4.99259 14.5185 5.17679 14.9445 5.45552L15.4921 4.61873C14.9465 4.26177 14.3308 4.02586 13.6864 3.9269L13.5346 4.91531ZM14.9445 5.45552C15.3705 5.73425 15.7318 6.10104 16.0042 6.53117L16.8491 5.99627C16.5003 5.44542 16.0376 4.97569 15.4921 4.61873L14.9445 5.45552ZM16.0042 6.53117C16.2765 6.9613 16.4534 7.44479 16.5231 7.94907L17.5137 7.81213C17.4244 7.16631 17.1978 6.54712 16.8491 5.99627L16.0042 6.53117ZM16.5231 7.94907C16.5929 8.45335 16.5537 8.96672 16.4083 9.4546L17.3666 9.74021C17.5529 9.1154 17.603 8.45795 17.5137 7.81213L16.5231 7.94907ZM16.4083 9.4546C16.2629 9.94247 16.0146 10.3935 15.6802 10.7774L16.4343 11.4342C16.8625 10.9427 17.1804 10.365 17.3666 9.74021L16.4083 9.4546ZM15.6802 10.7774C15.3459 11.1612 14.9331 11.469 14.4697 11.6799L14.884 12.59C15.4774 12.3199 16.006 11.9258 16.4343 11.4342L15.6802 10.7774ZM14.4697 11.6799C14.0064 11.8907 13.5032 11.9999 12.9942 12L12.9943 13C13.6462 12.9999 14.2906 12.8601 14.884 12.59L14.4697 11.6799Z" fill="white"></path></svg><i ng-if="curUserObj.IsDistributed" style="position: absolute; bottom: -7px; right: 0; color: #ccc; text-shadow: 0px 0px 5px #262526;" class="fa fa-lock fs-13px" aria-hidden="true"></i></div></div></div><img class="rounded-circle weight-2-5 br-upi w-40px h-40px" data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" ng-src="{{curUserObj.ProfilePic}}" ng-if="curUserObj.ProfilePic"></div><div class="user-bio-placeholder w-c-100-75px height-inherit pos-rel float-left no-bg pl-6px"><div class="chat-and-time" ng-class="((selectedUserId && curUserObj.Id == selectedUserId) || (selectedChatGroupId && curUserObj.ChatGroupID == selectedChatGroupId)) ? \'txt-clr-1\' : \'\'"><div class="chat-user-name txt-clr-1 w-150px" tooltip-class="uibtooltipDenial" uib-tooltip="{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}" tooltip-placement="auto top" ng-if="!curUserObj.ChatGroupID">{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}</div><div class="chat-user-name txt-clr-1 w-150px" tooltip-class="uibtooltipDenial" uib-tooltip="{{(curUserObj.GroupName) | lowercase}}" tooltip-placement="auto top" ng-if="curUserObj.ChatGroupID">{{(curUserObj.GroupName) | lowercase}}</div><div class="chat-content w-150px pt-1" ng-if="curUserObj.ChatGroupID"><div ng-if="(curUserObj.UserIDs.includes(currUserId))"><div ng-if="!(curUserObj.FileName.length > 0)"><i class="fa fa-share fs-12px" ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)"></i> <span ng-if="(curUserObj.LastMessage.split(\'|NEWGROUP|\')[1].length > 0)">{{curUserObj.LastMessage.split(\'|NEWGROUP|\')[1]}}</span> <span ng-if="(curUserObj.LastMessage.split(\'|ADDUSER|\')[1].length > 0)">{{curUserObj.ModifiedName}} has added the user to this group.</span> <span ng-if="(curUserObj.LastMessage.split(\'|REMOVEUSER|\')[1].length > 0)">{{curUserObj.ModifiedName}} has removed the user to this group.</span> <span ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] != \'undefined\')">{{curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0]}}</span> <span ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] == \'undefined\')">{{ViewPatientDetails(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span ng-if="!(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0) && !(curUserObj.LastMessage.split(\'|NEWGROUP|\')[1].length > 0) && !(curUserObj.LastMessage.split(\'|ADDUSER|\')[1].length > 0) && !(curUserObj.LastMessage.split(\'|REMOVEUSER|\')[1].length > 0)">{{curUserObj.LastMessage}}</span></div><div ng-if="(curUserObj.FileName.length > 0)"><i class="fa fa-paperclip fs-12px"></i> <span>{{curUserObj.FileName}}</span></div></div><span ng-if="!(curUserObj.UserIDs.includes(currUserId))">You don\'t belong to this group.</span></div><div class="chat-content w-150px pt-1" ng-if="!curUserObj.ChatGroupID"><div ng-if="!(curUserObj.FileName.length > 0)"><i class="fa fa-share fs-12px" ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)"></i> <span ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] != \'undefined\')">{{curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0]}}</span> <span ng-if="(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] == \'undefined\')">{{ViewPatientDetails(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span ng-if="!(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)">{{curUserObj.LastMessage}}</span></div><div ng-if="(curUserObj.FileName.length > 0)"><i class="fa fa-paperclip fs-12px"></i> <span>{{curUserObj.FileName}}</span></div></div><span class="pos-abs chat-content" style="right: -35px; top: 0; font-size:10px;" ng-if="curUserObj.LastMessage.length > 0">{{LastMessageTimeStamp(curUserObj.MessageDT)}}</span></div></div><div class="user-action-placeholder w-30px height-inherit float-left no-bg" ng-show="curUserObj.IsInvited"><div class="invited-user-container d-table width-inherit height-inherit" ng-show="curUserObj.IsInvited"><i class="icon-envelope-letter d-table-cell text-center fs-1-25 v-a-m txt-clr-2"></i></div></div><div class="message-ticker-placeholder height-inherit d-flex float-right no-bg message-number-indicator" style="position: absolute; bottom:0; right: 4px;"><div class="message-ticker-inner d-table height-inherit width-inherit" ng-show="curUserObj.UnreadMsgCount > 0"><div class="message-ticker d-table-cell text-center v-a-m height-inherit width-inherit fw-700"><span class="d-inline-block min-width-17px border-radius-50-all width-inherit bg-clr-39 txt-clr-1 fs-10px p-2px-all">{{curUserObj.UnreadMsgCount}}</span></div></div></div></div></div></div></div><a data-toggle="collapse" data-target="#RadUserListOnline" class="chat-userlist-filter d-block pos-rel" ng-if="UserRoleTab!=\'All\' && UserRoleTab!=\'Group\'">Online</a><div id="RadUserListOnline" class="collapse in" ng-if="UserRoleTab!=\'All\' && UserRoleTab!=\'Group\'"><div ng-if="curUserObj.IsOnline" ng-repeat="curUserObj in userList" class="pos-rel" ng-mousedown="showContextMenu($event,curUserObj)"><div ng-click="itemClicked(curUserObj,isShareChatLink)" ui-draggable="true" drag="curUserObj" drag-channel="priests" on-drop-success="dropSuccessHandler($event, $index, userListVM)" set-profile-pic="" class="trans-200-bg-linear width-inherit pos-rel fx-fade-normal fx-dur-300 fx-ease-cubic fx-stagger-0 chat-userlist-container h-42px cursor-pointer py-3px mb-1px ng-scope user-container no-bg" ng-class="(!curUserObj.IsInvited) ? ((selectedUserId && curUserObj.Id == selectedUserId) || (selectedChatGroupId && curUserObj.ChatGroupID == selectedChatGroupId) ? \'user-obj-selected user-container\' : \'user-container no-bg\') : \'pointer-null\'"><div class="user-container-inner w-100 pos-abs clearfix no-bg pl-3px" ng-click="((!curUserObj.IsGroupType) ? ((curUserObj.IsInvited) ? \'\' : setUserChat(curUserObj)) : setGroupChat(curUserObj))"><div class="user-active-state-indicator w-5px height-inherit float-left pos-rel"><div class="user-active-state-indicator-inner width-0-25 height-inherit" ng-class="(!curUserObj.IsInvited) ? ((curUserObj.Id == selectedUserId) || (curUserObj.ChatGroupID == selectedChatGroupId) ? \'\' : \'\') : \'\'"></div></div><div class="chat-name-circle list-userpic-bg" uib-popover-template="\'toUserProfileDetails.html\'" popover-trigger="outsideClick" popover-append-to-body="true" popover-placement="auto" popover-animation="true" popover-is-open="curUserObj.ispopOverOpen" ng-mouseenter="showToUserDetails(curUserObj);" ng-mouseleave="hideToUserDetails();"><i class="fa fa-circle pos-rel usr-circle" ng-class="{\'usronline\':curUserObj.IsOnline,\'txt-clr-25\':!curUserObj.IsOnline}"></i><div ng-if="!curUserObj.ProfilePic"><div ng-if="!curUserObj.IsGroupType"><div data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="profilepic">{{maskInitials(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id)}}</div></div><div ng-if="curUserObj.IsGroupType"><div data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="otln-0"><ng-avatar string="#" width="40" max-length="1" upper-case="true" data-toggle="modal" bind="true" bg-color="#0774c6" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="br-upi"></ng-avatar></div></div></div><img class="rounded-circle weight-2-5 br-upi w-40px h-40px" data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" ng-src="{{curUserObj.ProfilePic}}" ng-if="curUserObj.ProfilePic"></div><div class="user-bio-placeholder w-c-100-75px height-inherit pos-rel float-left no-bg pl-6px"><div class="chat-and-time" ng-class="(selectedUserId && curUserObj.Id == selectedUserId) ? \'txt-clr-1\' : \'\'"><div class="chat-user-name txt-clr-1 w-150px" tooltip-class="uibtooltipDenial" uib-tooltip="{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}" tooltip-placement="auto top">{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}</div><div class="chat-content w-150px pt-1"><i class="fa fa-share fs-12px" ng-if="!(curUserObj.FileName.length > 0) && (curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)"></i> <i class="fa fa-paperclip fs-12px" ng-if="curUserObj.FileName.length > 0"></i> <span ng-if="!(curUserObj.FileName.length > 0) && (curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] != \'undefined\')">{{(curUserObj.LastMessageUserId==currUserId)?\'You: \':\'\'}} {{curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0]}}</span> <span ng-if="!(curUserObj.FileName.length > 0) && (curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] == \'undefined\')">{{(curUserObj.LastMessageUserId==currUserId)?\'You: \':\'\'}} {{ViewPatientDetails(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span ng-if="!(curUserObj.FileName.length > 0) && !(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)">{{(curUserObj.LastMessageUserId==currUserId)?\'You: \':\'\'}} {{curUserObj.LastMessage}}</span> <span ng-if="curUserObj.FileName.length > 0">{{(curUserObj.LastMessageUserId==currUserId)?\'You: \':\'\'}} {{curUserObj.FileName}}</span></div><span class="pos-abs chat-content" style="right: -35px; top: 0; font-size:10px;" ng-if="curUserObj.LastMessage.length > 0">{{LastMessageTimeStamp(curUserObj.MessageDT)}}</span></div></div><div class="user-action-placeholder w-30px height-inherit float-left no-bg" ng-show="curUserObj.IsInvited"><div class="invited-user-container d-table width-inherit height-inherit" ng-show="curUserObj.IsInvited"><i class="icon-envelope-letter d-table-cell text-center fs-1-25 v-a-m txt-clr-2"></i></div></div><div class="message-ticker-placeholder height-inherit d-flex float-right no-bg message-number-indicator" style="position: absolute; bottom:0; right: 4px;"><div class="message-ticker-inner d-table height-inherit width-inherit" ng-show="curUserObj.UnreadMsgCount > 0"><div class="message-ticker d-table-cell text-center v-a-m height-inherit width-inherit fw-700"><span class="d-inline-block min-width-17px border-radius-50-all width-inherit bg-clr-39 txt-clr-1 fs-10px p-2px-all">{{curUserObj.UnreadMsgCount}}</span></div></div></div></div></div></div></div><a data-toggle="collapse" data-target="#RadUserListOffline" class="chat-userlist-filter d-block pos-rel" ng-if="UserRoleTab!=\'All\' && UserRoleTab!=\'Group\'">Offline</a><div id="RadUserListOffline" class="collapse in" ng-if="UserRoleTab!=\'All\' && UserRoleTab!=\'Group\'"><div ng-if="!curUserObj.IsOnline" ng-repeat="curUserObj in userList" class="pos-rel" ng-mousedown="showContextMenu($event,curUserObj)"><div ng-click="itemClicked(curUserObj,isShareChatLink)" ui-draggable="true" drag="curUserObj" drag-channel="priests" on-drop-success="dropSuccessHandler($event, $index, userListVM)" set-profile-pic="" class="trans-200-bg-linear width-inherit pos-rel fx-fade-normal fx-dur-300 fx-ease-cubic fx-stagger-0 chat-userlist-container h-42px cursor-pointer py-3px mb-1px ng-scope user-container no-bg" ng-class="(!curUserObj.IsInvited) ? ((selectedUserId && curUserObj.Id == selectedUserId) ? \'user-obj-selected user-container\' : \'user-container no-bg\') : \'pointer-null\'" ng-if="!curUserObj.ChatGroupID"><div class="user-container-inner w-100 pos-abs clearfix no-bg pl-3px" ng-click="((!curUserObj.IsGroupType) ? ((curUserObj.IsInvited) ? \'\' : setUserChat(curUserObj)) : setGroupChat(curUserObj))"><div class="user-active-state-indicator w-5px height-inherit float-left pos-rel"><div class="user-active-state-indicator-inner width-0-25 height-inherit" ng-class="(!curUserObj.IsInvited) ? ((curUserObj.Id == selectedUserId) ? \'\' : \'\') : \'\'"></div></div><div class="chat-name-circle list-userpic-bg" uib-popover-template="\'toUserProfileDetails.html\'" popover-trigger="outsideClick" popover-append-to-body="true" popover-placement="auto" popover-is-open="curUserObj.ispopOverOpen" ng-mouseenter="showToUserDetails(curUserObj);" ng-mouseleave="hideToUserDetails();"><i class="fa fa-circle pos-rel usr-circle" ng-class="{\'usronline\':curUserObj.IsOnline,\'txt-clr-25\':!curUserObj.IsOnline}"></i><div ng-if="!curUserObj.ProfilePic"><div ng-if="!curUserObj.IsGroupType"><div data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="profilepic">{{maskInitials(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id)}}</div></div><div ng-if="curUserObj.IsGroupType"><div data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="otln-0"><ng-avatar string="#" width="40" max-length="1" upper-case="true" data-toggle="modal" bind="true" bg-color="#0774c6" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" class="br-upi"></ng-avatar></div></div></div><img class="rounded-circle weight-2-5 br-upi w-40px h-40px" data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" ng-src="{{curUserObj.ProfilePic}}" ng-if="curUserObj.ProfilePic"></div><div class="user-bio-placeholder w-c-100-75px height-inherit pos-rel float-left no-bg pl-6px"><div class="chat-and-time" ng-class="(selectedUserId && curUserObj.Id == selectedUserId) ? \'txt-clr-1\' : \'\'"><div class="chat-user-name txt-clr-1 w-150px" tooltip-class="uibtooltipDenial" uib-tooltip="{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}" tooltip-placement="auto top">{{maskName(curUserObj.LastName, curUserObj.FirstName, curUserObj.UserRoles, curUserObj.Id) | lowercase}}</div><div class="chat-content w-150px pt-1"><i class="fa fa-share fs-12px" ng-if="!(curUserObj.FileName.length > 0) && (curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)"></i> <i class="fa fa-paperclip fs-12px" ng-if="curUserObj.FileName.length > 0"></i> <span ng-if="!(curUserObj.FileName.length > 0) && (curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] != \'undefined\')">{{(curUserObj.LastMessageUserId==currUserId)?\'You: \':\'\'}} {{curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0]}}</span> <span ng-if="!(curUserObj.FileName.length > 0) && (curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0 && curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[0] == \'undefined\')">{{(curUserObj.LastMessageUserId==currUserId)?\'You: \':\'\'}} {{ViewPatientDetails(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1], \'NAME\')}}</span> <span ng-if="!(curUserObj.FileName.length > 0) && !(curUserObj.LastMessage.split(\'|SHAREEXAMOBJ|\')[1].length > 0)">{{(curUserObj.LastMessageUserId==currUserId)?\'You: \':\'\'}} {{curUserObj.LastMessage}}</span> <span ng-if="curUserObj.FileName.length > 0">{{(curUserObj.LastMessageUserId==currUserId)?\'You: \':\'\'}} {{curUserObj.FileName}}</span></div><span class="pos-abs chat-content" style="right: -35px; top: 0; font-size:10px;" ng-if="curUserObj.LastMessage.length > 0">{{LastMessageTimeStamp(curUserObj.MessageDT)}}</span></div></div><div class="user-action-placeholder w-30px height-inherit float-left no-bg" ng-show="curUserObj.IsInvited"><div class="invited-user-container d-table width-inherit height-inherit" ng-show="curUserObj.IsInvited"><i class="icon-envelope-letter d-table-cell text-center fs-1-25 v-a-m txt-clr-2"></i></div></div><div class="message-ticker-placeholder height-inherit d-flex float-right no-bg message-number-indicator" style="position: absolute; bottom:0; right: 4px;"><div class="message-ticker-inner d-table height-inherit width-inherit" ng-show="curUserObj.UnreadMsgCount > 0"><div class="message-ticker d-table-cell text-center v-a-m height-inherit width-inherit fw-700"><span class="d-inline-block min-width-17px border-radius-50-all width-inherit bg-clr-39 txt-clr-1 fs-10px p-2px-all">{{curUserObj.UnreadMsgCount}}</span></div></div></div></div></div></div></div></div></div></div></div></div></div></div><script type="text/ng-template" id="toUserProfileDetails.html"><div ng-mouseenter="mouseEnterOutPopUp(true, false);" ng-mouseleave="mouseEnterOutPopUp(false, false)" style="min-width:180px;"> <div class="clearfix d-flex align-item-center mb-10px pb-10px chatsec" style="border-bottom: 1px solid #494949;"> <div class="chat-name-circle list-userpic-bg"> <i class="fa fa-circle pos-rel usr-circle" ng-class="{\'usronline\':toUserDetails.IsOnline,\'txt-clr-25\':!toUserDetails.IsOnline}" ng-if="!toUserDetails.ChatGroupID"></i> <div ng-if="!toUserDetails.ProfilePic"> <div ng-if="!toUserDetails.IsGroupType || !toUserDetails.ChatGroupID"> <div data-toggle="modal" ng-click="showUserInfo(toUserDetails); $event.stopPropagation()" class="profilepic"> {{maskInitials(toUserDetails.LastName, toUserDetails.FirstName, toUserDetails.UserRoles, toUserDetails.Id)}} </div> </div> <div ng-if="toUserDetails.IsGroupType || toUserDetails.ChatGroupID"> <div data-toggle="modal" class="profilepic pt-6px"> <svg width="20" class="" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.9942 12.5L12.9939 12C12.7178 12.0002 12.4941 12.2241 12.4942 12.5002C12.4943 12.7762 12.7182 13 12.9943 13L12.9942 12.5ZM18.21 15.7084C18.3687 15.9344 18.6805 15.989 18.9065 15.8304C19.1325 15.6717 19.1871 15.3598 19.0285 15.1338L18.21 15.7084ZM0.590966 15.134C0.432151 15.3599 0.486536 15.6718 0.712439 15.8306C0.938343 15.9894 1.25022 15.935 1.40903 15.7091L0.590966 15.134ZM11.8413 15.7087C12.0002 15.9346 12.3121 15.989 12.5379 15.8302C12.7638 15.6713 12.8182 15.3594 12.6594 15.1335L11.8413 15.7087ZM11.7563 4.04502C11.4905 4.11991 11.3358 4.39608 11.4106 4.66188C11.4855 4.92767 11.7617 5.08243 12.0275 5.00754L11.7563 4.04502ZM12.9946 13C14.0176 12.9992 15.0256 13.245 15.9335 13.7164L16.3944 12.829C15.3439 12.2835 14.1775 11.9991 12.9939 12L12.9946 13ZM15.9335 13.7164C16.8413 14.1879 17.6222 14.8712 18.21 15.7084L19.0285 15.1338C18.3483 14.1651 17.4448 13.3745 16.3944 12.829L15.9335 13.7164ZM1.40903 15.7091C1.99738 14.8723 2.77844 14.1892 3.68628 13.7177L3.22536 12.8303C2.17514 13.3757 1.27158 14.1659 0.590966 15.134L1.40903 15.7091ZM3.68628 13.7177C4.59413 13.2462 5.60209 13 6.62508 13L6.62505 12C5.44162 12 4.27557 12.2848 3.22536 12.8303L3.68628 13.7177ZM6.62508 13C7.64808 12.9999 8.65606 13.246 9.56394 13.7175L10.0248 12.83C8.97454 12.2846 7.80847 11.9999 6.62505 12L6.62508 13ZM9.56394 13.7175C10.4718 14.1889 11.2529 14.8719 11.8413 15.7087L12.6594 15.1335C11.9787 14.1655 11.0751 13.3754 10.0248 12.83L9.56394 13.7175ZM10.1878 8.43745C10.1878 10.4049 8.59262 12 6.62506 12V13C9.14482 13 11.1878 10.9573 11.1878 8.43745H10.1878ZM6.62506 12C4.65759 12 3.06283 10.405 3.06283 8.43745H2.06283C2.06283 10.9572 4.10522 13 6.62506 13V12ZM3.06283 8.43745C3.06283 6.46994 4.65781 4.87495 6.62533 4.87495V3.87495C4.10553 3.87495 2.06283 5.91765 2.06283 8.43745H3.06283ZM6.62533 4.87495C8.59284 4.87495 10.1878 6.46994 10.1878 8.43745H11.1878C11.1878 5.91765 9.14513 3.87495 6.62533 3.87495V4.87495ZM12.0275 5.00754C12.5175 4.86949 13.0314 4.83804 13.5346 4.91531L13.6864 3.9269C13.042 3.82793 12.3838 3.86821 11.7563 4.04502L12.0275 5.00754ZM13.5346 4.91531C14.0378 4.99259 14.5185 5.17679 14.9445 5.45552L15.4921 4.61873C14.9465 4.26177 14.3308 4.02586 13.6864 3.9269L13.5346 4.91531ZM14.9445 5.45552C15.3705 5.73425 15.7318 6.10104 16.0042 6.53117L16.8491 5.99627C16.5003 5.44542 16.0376 4.97569 15.4921 4.61873L14.9445 5.45552ZM16.0042 6.53117C16.2765 6.9613 16.4534 7.44479 16.5231 7.94907L17.5137 7.81213C17.4244 7.16631 17.1978 6.54712 16.8491 5.99627L16.0042 6.53117ZM16.5231 7.94907C16.5929 8.45335 16.5537 8.96672 16.4083 9.4546L17.3666 9.74021C17.5529 9.1154 17.603 8.45795 17.5137 7.81213L16.5231 7.94907ZM16.4083 9.4546C16.2629 9.94247 16.0146 10.3935 15.6802 10.7774L16.4343 11.4342C16.8625 10.9427 17.1804 10.365 17.3666 9.74021L16.4083 9.4546ZM15.6802 10.7774C15.3459 11.1612 14.9331 11.469 14.4697 11.6799L14.884 12.59C15.4774 12.3199 16.006 11.9258 16.4343 11.4342L15.6802 10.7774ZM14.4697 11.6799C14.0064 11.8907 13.5032 11.9999 12.9942 12L12.9943 13C13.6462 12.9999 14.2906 12.8601 14.884 12.59L14.4697 11.6799Z" fill="white" /> </svg> </div> </div> </div> <img class="rounded-circle weight-2-5 br-upi w-40px h-40px" data-toggle="modal" ng-click="showUserInfo(toUserDetails); $event.stopPropagation()" ng-src="{{toUserDetails.ProfilePic}}" ng-if="toUserDetails.ProfilePic"> <!-- User Online / Away Start --> <!-- User Online / Away End --> </div> <div class="user-bio-placeholder w-c-100-75px height-inherit pos-rel float-left no-bg pl-6px"> <div class="chat-and-time" ng-class="(selectedUserId && toUserDetails.Id == selectedUserId) ? \'txt-clr-1\' : \'\' " ng-if="!toUserDetails.ChatGroupID"> <div class="chat-user-name txt-clr-1 fs-13px w-100 text-overflow-unset white-space-normal overflow-unset fw-600"> {{maskName(toUserDetails.LastName, toUserDetails.FirstName, toUserDetails.UserRoles, toUserDetails.Id) | lowercase}} </div> </div> <div class="chat-and-time" ng-class="(selectedChatGroupId && toUserDetails.ChatGroupID == selectedChatGroupId) ? \'txt-clr-1\' : \'\' " ng-if="toUserDetails.ChatGroupID"> <div class="chat-user-name txt-clr-1 fs-13px w-100 text-overflow-unset white-space-normal overflow-unset fw-600"> {{(toUserDetails.GroupName) | lowercase}} </div> </div> </div> </div> <div class="contactbox-userchat mb-10px pb-5px" style="border-bottom: 1px solid #494949; " ng-if="!toUserDetails.ChatGroupID"> <h4 class="txt-clr-1 fs-13px mt-0 mb-5px fw-600">Contact </h4> <div class="contactbox-userchat email txt-clr-1 fs-12px mb-4px pl-4px"><i class="fa fa-envelope pr-2px fs-10px mb-4px" aria-hidden="true"></i> {{ toUserDetails.Email }}</div> <div class="contactbox-userchat phone txt-clr-1 fs-12px mb-4px pl-4px"><i class="fa fa-phone pr-2px fs-12px mb-4px" aria-hidden="true"></i> {{ toUserDetails.PhoneNumber }}</div> </div> <div class="chatuser-siteaccess" ng-if="!toUserDetails.ChatGroupID"> <h4 class="txt-clr-1 fs-13px mt-0 mb-5px fw-600">Site(s) </h4> <div class="chatuser-siteaccessscroll overflow-x-hide overflow-y-auto"> <p class="txt-clr-1 fs-12px mb-4px pl-4px" ng-repeat="site in toUserSiteAccessList">{{site.Site}}</p> </div> </div> <div class="chatuser-siteaccess" ng-if="toUserDetails.ChatGroupID"> <h4 class="txt-clr-1 fs-13px mt-0 mb-5px fw-600"> User(s) <span class="rf-badge-rp badge align-item-center justify-content-center" style="min-width: 19px; height: 19px; max-width: 100px;padding: 4px; display: inline-flex; background: #545454 !important; color: #d6d6d6 !important; border-radius: 100%; " ng-If="(toUserDetails.UserIDs.includes(currUserId))">{{visibleGroupMemberCount(toUserDetails.SelectedRadiologists, true)}}</span> <span class="rf-badge-rp badge align-item-center justify-content-center" style="min-width: 19px; height: 19px; max-width: 100px;padding: 4px; display: inline-flex; background: #545454 !important; color: #d6d6d6 !important; border-radius: 100%; " ng-If="!(toUserDetails.UserIDs.includes(currUserId))">{{visibleGroupMemberCount(toUserDetails.SelectedRadiologists, false)}}</span> </h4> <div class="chatgroupuser-siteaccessscroll overflow-x-hide overflow-y-auto"> <div class="d-flex align-item-center justify-content-between p-1 bor-rad-5px grp-userlist mb-5px" ng-repeat="user in toUserDetails.SelectedRadiologists | orderBy:[\'LastName\',\'FirstName\']" ng-If="user.Id && user.Id != currUserId && isVisibleMember(user)"> <div class="d-flex align-item-center w-100"> <div class="chat-name-circle list-userpic-bg" popover-class="popoverchatuser" uib-popover-template="\'toGroupUserProfileDetails.html\'" popover-trigger="outsideClick" popover-append-to-body="true" popover-placement="auto" popover-animation="true" popover-is-open="user.isgrouppopOverOpen" ng-mouseenter="showGroupToUserDetails(user);" ng-mouseleave="hideGroupToUserDetails();"> <i class="fa fa-circle pos-rel usr-circle" ng-class="{\'usronline\':user.IsOnline,\'txt-clr-25\':!user.IsOnline}"></i> <div ng-if="!user.ProfilePic"> <div ng-if="!user.IsGroupType"> <div data-toggle="modal" ng-click="showUserInfo(user); $event.stopPropagation()" style="position:absolute;top:8px;left:9px;" class="profilepic"> {{maskInitials(user.LastName, user.FirstName, user.UserRoles || user.Roles, user.Id || user.UserID)}} </div> </div> </div> <img class="rounded-circle weight-2-5 br-upi w-40px h-40px" data-toggle="modal" ng-click="showUserInfo(curUserObj); $event.stopPropagation()" ng-src="{{curUserObj.ProfilePic}}" ng-if="curUserObj.ProfilePic"> <!-- User Online / Away Start --> <!-- User Online / Away End --> </div> <p class="txt-clr-1 fs-12px mb-1px pl-4px">{{maskName(user.LastName, user.FirstName, user.UserRoles || user.Roles, user.Id || user.UserID)}}</p> </div> <i class="fa fa-times pl-5px cursor-pointer float-right" aria-hidden="true" ng-click="DeleteOrLeaveGroup(\'Leave\',toUserDetails,user)" ng-if="((toUserDetails.IsDistributed) ? (toUserDetails.CreatedBy == currUserId) && (toUserDetails.UserIDs.includes(currUserId)) && (toUserDetails.SelectedRadiologists.length > 2) : (toUserDetails.UserIDs.includes(currUserId)) && (DataObject.CurrentUserRoles.includes(\'Admin\')) && (toUserDetails.SelectedRadiologists.length > 2))"></i> </div> </div> </div> </div></script><script type="text/ng-template" id="toGroupUserProfileDetails.html"><div ng-mouseenter="mouseEnterOutPopUp(true, true);" ng-mouseleave="mouseEnterOutPopUp(false, true)" style="min-width:180px;"> <div class="clearfix d-flex align-item-center mb-10px pb-10px chatsec" style="border-bottom: 1px solid #494949;"> <div class="chat-name-circle list-userpic-bg" style="padding-top:18px"> <i class="fa fa-circle pos-rel usr-circle" ng-class="{\'usronline\':toGroupUserDetails.IsOnline,\'txt-clr-25\':!toGroupUserDetails.IsOnline}" ng-if="!toGroupUserDetails.ChatGroupID"></i> <div ng-if="!toGroupUserDetails.ProfilePic"> <div ng-if="!toGroupUserDetails.IsGroupType"> <div data-toggle="modal" ng-click="showUserInfo(toGroupUserDetails); $event.stopPropagation()" class="profilepic"> {{toGroupUserDetails.LastName.substring(0,1).toUpperCase() + \'\' +toGroupUserDetails.FirstName.substring(0,1).toUpperCase()}} </div> </div> <div ng-if="toGroupUserDetails.IsGroupType"> <div data-toggle="modal" class="profilepic pt-6px"> <svg width="20" class="" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.9942 12.5L12.9939 12C12.7178 12.0002 12.4941 12.2241 12.4942 12.5002C12.4943 12.7762 12.7182 13 12.9943 13L12.9942 12.5ZM18.21 15.7084C18.3687 15.9344 18.6805 15.989 18.9065 15.8304C19.1325 15.6717 19.1871 15.3598 19.0285 15.1338L18.21 15.7084ZM0.590966 15.134C0.432151 15.3599 0.486536 15.6718 0.712439 15.8306C0.938343 15.9894 1.25022 15.935 1.40903 15.7091L0.590966 15.134ZM11.8413 15.7087C12.0002 15.9346 12.3121 15.989 12.5379 15.8302C12.7638 15.6713 12.8182 15.3594 12.6594 15.1335L11.8413 15.7087ZM11.7563 4.04502C11.4905 4.11991 11.3358 4.39608 11.4106 4.66188C11.4855 4.92767 11.7617 5.08243 12.0275 5.00754L11.7563 4.04502ZM12.9946 13C14.0176 12.9992 15.0256 13.245 15.9335 13.7164L16.3944 12.829C15.3439 12.2835 14.1775 11.9991 12.9939 12L12.9946 13ZM15.9335 13.7164C16.8413 14.1879 17.6222 14.8712 18.21 15.7084L19.0285 15.1338C18.3483 14.1651 17.4448 13.3745 16.3944 12.829L15.9335 13.7164ZM1.40903 15.7091C1.99738 14.8723 2.77844 14.1892 3.68628 13.7177L3.22536 12.8303C2.17514 13.3757 1.27158 14.1659 0.590966 15.134L1.40903 15.7091ZM3.68628 13.7177C4.59413 13.2462 5.60209 13 6.62508 13L6.62505 12C5.44162 12 4.27557 12.2848 3.22536 12.8303L3.68628 13.7177ZM6.62508 13C7.64808 12.9999 8.65606 13.246 9.56394 13.7175L10.0248 12.83C8.97454 12.2846 7.80847 11.9999 6.62505 12L6.62508 13ZM9.56394 13.7175C10.4718 14.1889 11.2529 14.8719 11.8413 15.7087L12.6594 15.1335C11.9787 14.1655 11.0751 13.3754 10.0248 12.83L9.56394 13.7175ZM10.1878 8.43745C10.1878 10.4049 8.59262 12 6.62506 12V13C9.14482 13 11.1878 10.9573 11.1878 8.43745H10.1878ZM6.62506 12C4.65759 12 3.06283 10.405 3.06283 8.43745H2.06283C2.06283 10.9572 4.10522 13 6.62506 13V12ZM3.06283 8.43745C3.06283 6.46994 4.65781 4.87495 6.62533 4.87495V3.87495C4.10553 3.87495 2.06283 5.91765 2.06283 8.43745H3.06283ZM6.62533 4.87495C8.59284 4.87495 10.1878 6.46994 10.1878 8.43745H11.1878C11.1878 5.91765 9.14513 3.87495 6.62533 3.87495V4.87495ZM12.0275 5.00754C12.5175 4.86949 13.0314 4.83804 13.5346 4.91531L13.6864 3.9269C13.042 3.82793 12.3838 3.86821 11.7563 4.04502L12.0275 5.00754ZM13.5346 4.91531C14.0378 4.99259 14.5185 5.17679 14.9445 5.45552L15.4921 4.61873C14.9465 4.26177 14.3308 4.02586 13.6864 3.9269L13.5346 4.91531ZM14.9445 5.45552C15.3705 5.73425 15.7318 6.10104 16.0042 6.53117L16.8491 5.99627C16.5003 5.44542 16.0376 4.97569 15.4921 4.61873L14.9445 5.45552ZM16.0042 6.53117C16.2765 6.9613 16.4534 7.44479 16.5231 7.94907L17.5137 7.81213C17.4244 7.16631 17.1978 6.54712 16.8491 5.99627L16.0042 6.53117ZM16.5231 7.94907C16.5929 8.45335 16.5537 8.96672 16.4083 9.4546L17.3666 9.74021C17.5529 9.1154 17.603 8.45795 17.5137 7.81213L16.5231 7.94907ZM16.4083 9.4546C16.2629 9.94247 16.0146 10.3935 15.6802 10.7774L16.4343 11.4342C16.8625 10.9427 17.1804 10.365 17.3666 9.74021L16.4083 9.4546ZM15.6802 10.7774C15.3459 11.1612 14.9331 11.469 14.4697 11.6799L14.884 12.59C15.4774 12.3199 16.006 11.9258 16.4343 11.4342L15.6802 10.7774ZM14.4697 11.6799C14.0064 11.8907 13.5032 11.9999 12.9942 12L12.9943 13C13.6462 12.9999 14.2906 12.8601 14.884 12.59L14.4697 11.6799Z" fill="white" /> </svg> </div> </div> </div> <img class="rounded-circle weight-2-5 br-upi w-40px h-40px" data-toggle="modal" ng-click="showUserInfo(toGroupUserDetails); $event.stopPropagation()" ng-src="{{toGroupUserDetails.ProfilePic}}" ng-if="toGroupUserDetails.ProfilePic"> <!-- User Online / Away Start --> <!-- User Online / Away End --> </div> <div class="user-bio-placeholder w-c-100-75px height-inherit pos-rel float-left no-bg pl-6px"> <div class="chat-and-time"> <div class="chat-user-name txt-clr-1 fs-13px w-100 text-overflow-unset white-space-normal overflow-unset fw-600"> {{(toGroupUserDetails.LastName +\', \'+ toGroupUserDetails.FirstName) | lowercase}} </div> </div> </div> </div> <div class="contactbox-userchat mb-10px pb-5px" style="border-bottom: 1px solid #494949; "> <h4 class="txt-clr-1 fs-13px mt-0 mb-5px fw-600">Contact </h4> <div class="contactbox-userchat email txt-clr-1 fs-12px mb-4px pl-4px"><i class="fa fa-envelope pr-2px fs-10px mb-4px" aria-hidden="true"></i> {{ toGroupUserDetails.Email }}</div> <div class="contactbox-userchat phone txt-clr-1 fs-12px mb-4px pl-4px"><i class="fa fa-phone pr-2px fs-12px mb-4px" aria-hidden="true"></i> {{ toGroupUserDetails.PhoneNumber }}</div> </div> <div class="chatuser-siteaccess"> <h4 class="txt-clr-1 fs-13px mt-0 mb-5px fw-600">Site(s) </h4> <div class="chatuser-siteaccessscroll overflow-x-hide overflow-y-auto"> <p class="txt-clr-1 fs-12px mb-4px pl-4px" ng-repeat="site in toGroupUserSiteAccessList">{{site.Site}}</p> </div> </div> </div></script><div class="context-menu cursor-pointer" id="contectMenuDiv" ng-style="contextMenuStyle" ng-show="isMenuVisible"><div ng-click="DeleteOrLeaveGroup(\'Delete\',ContextMenuSelectedUser)" style="border-bottom: 1px solid #5c5c5c;" class="p-5px-all" ng-if="ContextMenuSelectedUser.ChatGroupID && ContextMenuSelectedUser.UserIDs.includes(currUserId) && DataObject.CurrentUserRoles.includes(\'Admin\') && !ContextMenuSelectedUser.IsDistributed"><i class="fa fa-trash fs-16px ml-2px mr-1 txt-clr-14"></i> Delete</div><div ng-click="DeleteOrLeaveGroup(\'Leave\',ContextMenuSelectedUser, DataObject.currentUser)" style="border-bottom: 1px solid #5c5c5c;" class="p-5px-all" ng-if="ContextMenuSelectedUser.ChatGroupID && ContextMenuSelectedUser.UserIDs.includes(currUserId) && !ContextMenuSelectedUser.IsDistributed && (ContextMenuSelectedUser.SelectedRadiologists.length > 2)"><i class="fa fa-sign-out fs-16px ml-2px mr-1 txt-clr-14"></i> Leave</div><div ng-click="pinUnpinUser()" class="p-5px-all" ng-if="!ContextMenuSelectedUser.ChatGroupID"><img src="assets/images/Pin.svg" ng-if="!ContextMenuSelectedUser.IsPinnedUser" width="16" style="transform: rotate(45deg)" class="mr-1 cursor-pointer"> <img src="assets/images/Unpin.svg" ng-if="ContextMenuSelectedUser.IsPinnedUser" width="16" class="mr-1 cursor-pointer">{{(ContextMenuSelectedUser.IsPinnedUser)?\'Unpin\':\'Pin\'}}</div><div ng-click="pinUnpinUser()" class="p-5px-all" ng-if="ContextMenuSelectedUser.ChatGroupID"><img src="assets/images/Pin.svg" ng-if="!ContextMenuSelectedUser.IsPinnedGroup" width="16" style="transform: rotate(45deg)" class="mr-1 cursor-pointer"> <img src="assets/images/Unpin.svg" ng-if="ContextMenuSelectedUser.IsPinnedGroup" width="16" class="mr-1 cursor-pointer">{{(ContextMenuSelectedUser.IsPinnedGroup)?\'Unpin\':\'Pin\'}}</div></div><script type="text/ng-template" id="UserMessageExpiryModal.html"><div class="new-popup"> <div class="modal-header p-0-625-all border-0 messageexpirytimer-modal-header"> <button type="button" class="close pos-abs abs-t-0 abs-r-0 width-1-875 height-1-875" data-dismiss="modal" aria-label="Close" ng-click="cancel()"> <span aria-hidden="true"><i class="icon-close"></i></span> </button> <h4 class="modal-title fs-0-8125 fw-700"> Message Expiry Timer <small class="d-block">Change message expiry timer.</small> </h4> <input type="hidden" ng-model="hdntoUserId" /> </div> <div class="modal-body"> <form name="frmUserSettings" ng-submit="SaveMySettings(frmUserSettings.$valid)"> <div class="row mx-0"> <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 px-0 br-1-s"> <h5 class="fs-0-75 txt-clr-3">Your message will expire in: </h5> <h4 class="txt-clr-10 fw-700 fs-20px">{{messageExpiryResult}} <small class="fs-0-625" ng-show="messageExpiryResult">(hh:mm:ss)</small></h4> </div> <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 px-0"> <div class="switch-wrapper float-right"> <h5 class="fs-0-75 txt-clr-3 text-right">Do you want to use default expiry time? </h5> <div class="onoffswitch"> <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" ng-model="useDefaultExpirySetting" ng-change="setUserExpirySetting();" id="myonoffswitch"> <label class="onoffswitch-label" for="myonoffswitch"> <span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> </label> </div> </div> </div> </div> <hr /> <div ng-show="!useDefaultExpirySetting" class="width-inherit height-auto" ng-cloak> <div class="row mx-0"> <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0"> <h5 class="fs-0-75 fw-700 text-center text-warning">Set your own message expiry time limit.</h5> </div> </div> <div class="row mx-0"> <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0"> <h5 class="fs-0-75 txt-clr-3 text-center">Set expiry timer between <span class="fs-0-8125 fw-700 txt-clr-10">00:15:00</span> to <span class="fs-0-8125 fw-700 txt-clr-10">{{maxRangeLimit}}</span> range.</h5> <div uib-timepicker id="messageExpiryTimepicker" name="msgExpiryTimepicker" ng-model="messageExpiryTimeLimit" ng-change="ChangeMessageExpiryTime(frmUserSettings, messageExpiryTimeLimit)" show-seconds="true" hour-step="1" minute-step="1" second-Step="15" show-meridian="false" required style="width:170px;" class="d-block m-0-auto"></div> <div ng-show="frmUserSettings.msgExpiryTimepicker.$invalid && !frmUserSettings.msgExpiryTimepicker.$pristine" class="alert alert-danger fs-0-75 fw-700 text-center fx-zoom-normal fx-dur-600 fx-ease-none" role="alert" ng-cloak> Set expiry timer between <span class="fs-0-8125 fw-700 txt-clr-1">00:15:00</span> to <span class="fs-0-8125 fw-700 txt-clr-1">{{maxRangeLimit}}</span> range. </div> </div> </div> </div> <div class="row mx-0"> <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 justify-content-center"> <button type="submit" id="btnSave" class="btn btn-primary" ng-disabled="!messageExpiryResult">Save Changes</button> <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button> </div> </div> </form> </div> </div></script><div kendo-window="window" k-on-close="closeKendoVideoChat()" k-visible="false" class="modal-RadSceureVCall overflow-auto svcall pb-0px px-3px pt-1px bg-clr-51 overflow-x-hide"><div class="spin-loader-lrg h-100-per" ng-show="showVideoChatLoader"><div class="page-inner-content-loader pos-abs w-100 h-100 abs-t-0 abs-l-0 z-i-10"><div class="pos-rel w-100 h-100 d-table" ng-cloak=""><div class="content-loader-container w-100 h-90vh d-table-cell v-a-m"><div class="loader-blue m-0-auto"></div></div></div></div></div><patientdetails ng-if="selectedOrder.Location" selected-order="selectedOrder" class="vcall-patdetails"></patientdetails><div id="container" class="container video-conf-section"><div id="local" class="participant"><div class="pos-rel"></div><div class="me-text nameLabel">Me</div><div class="conf-btn-sec"><button id="join_leave" class="btn videobtn joincall-off" title="End call"></button> <button id="share_screen" class="btn videobtn sharescreen-on" title="Share screen"></button> <button id="mute-unmute-audio-button" class="btn videobtn mic-on" title="Mute audio"></button> <button id="mute-unmute-video-button" class="btn videobtn video-on" title="Mute video"></button> <button id="mute-unmute-video-button" class="btn videobtn adduser-on" ng-click="shareVideoCallDetails()" title="Add user"></button></div></div></div></div><div kendo-window="schedulelaterDlgOptionWindow" id="scheduleLaterWindow" k-on-close="closeKendoScheduleLater()" k-visible="false" class="overflow-auto svcall h-350px" k-width="800" style="min-width:800px;"><div class="row"><div class="col-md-6"><form name="frmCallScheduleLater" ng-submit="SaveOnCallScheduleLater(frmCallScheduleLater.$valid)" role="form"><div class="form-group"><label class="rf-label">Schedule For Date/Time *</label> <input date-range-picker="" id="daterangeSchedule" name="daterangeSchedule" class="form-control" type="text" ng-model="ScheduleForDateNew.date" options="scheduleForDateOptionsNew" autocomplete="off" required=""></div><div role="alert"><span style="color:red" class="error fs-14px fw-500" ng-show="frmCallScheduleLater.daterangeSchedule.$error.required">Schedule date & time required!</span></div><a class="btn btn-default rf-btn-xs" data-dismiss="modal" aria-label="Close" ng-click="CancelScheduleLater()">Cancel</a> <button type="submit" ng-click-options="{preventDoubleClick: true}" onlysingleclick="" ng-disabled="( !frmCallScheduleLater.$valid)" class="btn btn-primary rf-btn-xs mr-5px">Schedule Meeting</button></form></div></div></div><div class="modal fade" id="AddEditGroupModal" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog w-700px" style="transform: translate(0, 0)!important;"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="ClearModalData()">&times;</button><h4 class="modal-title" ng-hide="(DataObject.GroupChatText != \'Create\') && (!(DataObject.GroupDetails.CreatedBy == currUserId || DataObject.CurrentUserRoles.includes(\'Admin\')))">{{DataObject.GroupChatText}} Group</h4><h4 class="modal-title" ng-show="(DataObject.GroupChatText != \'Create\') && (!(DataObject.GroupDetails.CreatedBy == currUserId || DataObject.CurrentUserRoles.includes(\'Admin\')))">View Group Details</h4></div><div class="modal-body"><div class="spinner-overlay" ng-show="false"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="w-100 clearfix"><form name="frmChatGroup" class="width-inherit height-inherit" ng-init="appCtrl.GetAllSites()"><div ng-hide="(DataObject.GroupChatText != \'Create\') && (!(DataObject.GroupDetails.CreatedBy == currUserId || DataObject.CurrentUserRoles.includes(\'Admin\')))"><label class="rf-label">Group Name *</label> <input type="text" name="GroupName" ng-model="DataObject.GroupDetails.GroupName" class="edit-input form-control input-sm" required=""></div><div ng-show="(DataObject.GroupChatText != \'Create\') && (!(DataObject.GroupDetails.CreatedBy == currUserId || DataObject.CurrentUserRoles.includes(\'Admin\')))"><label class="rf-label">Group Name</label> <b class="txt-clr-1">{{DataObject.GroupDetails.GroupName}}</b></div><div class="col-lg-12 px-0 my-10px selected-member"><cmpassignradiologists assigned-radiologist="DataObject.GroupDetails.SelectedRadiologists" view-mode="false" view-group="true" flag="true" ng-if="DataObject.GroupDetails.SelectedRadiologists.length>0"></cmpassignradiologists></div><div class="row mt-20px clearfix" ng-hide="(DataObject.GroupChatText != \'Create\') && (!(DataObject.GroupDetails.CreatedBy == currUserId || DataObject.CurrentUserRoles.includes(\'Admin\')))"><div class="col-md-12 d-flex align-item-center justify-content-between"><div class="mr-10px"><input type="button" ng-click="DataObject.showAssignRadiologistCmp.value=true;AddUsers();" class="btn btn-primary" value="{{DataObject.AssignUserText}}"> <span class="txt-clr-5 pl-10px fw-600 mt-10px fs-12px" ng-show="DataObject.GroupDetails.SelectedRadiologists.length<=2" style="color: red !important;">Please select more than two members to create a group.</span></div><div class="mr-10px d-flex align-item-center"><div class="d-flex align-item-center" ng-if="DataObject.CurrentUserRoles.includes(\'Admin\')"><input type="checkbox" class="mt-2px cmn-checkbx-input ng-pristine ng-untouched ng-valid ng-not-empty" id="Distributed" ng-model="DataObject.GroupDetails.IsDistributed" autocomplete="off"> <label for="Distributed" class="rf-label cmn-check-label">Private</label></div><button type="submit" ng-click="AddUpdateGroup(\'Create\')" ng-disabled="frmChatGroup.$invalid || DataObject.GroupDetails.SelectedRadiologists.length==0 || DataObject.GroupDetails.SelectedRadiologists.length<=2 || DataObject.isSaveEditBtnDisable" class="btn ml-10px btn-primary mr-5px">{{DataObject.BtnText}}</button></div></div></div></form></div></div></div></div></div></div><div class="modal fade" id="RadiologistComponentGroupChat" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog assign-user-modal" ng-if="DataObject.showAssignRadiologistCmp.value"><div class="modal-content"><assign-radiologist-grid radiologists="DataObject.MasterData.Radiologists" selected-values="DataObject.GroupDetails" modal-title="Add/Remove Members" btn-text="DataObject.BtnText" on-select-radiologist="SaveAddUsers()" on-cancel="AssignUserCancel()" radio-logist-cmp-tooltip-id="radioLogistGroupChatCmp" show-assign-radiologist-cmp="DataObject.showAssignRadiologistCmp"></assign-radiologist-grid></div></div></div><div><report-window selected-order="DataObject.ReportSelectedOrder" master-data="DataObject.MasterData" ng-if="DataObject.ShowReport" close-modal="CloseReportWindow()" formatted-selected-order="DataObject.FormattedSelectedOrder"></report-window></div><div class="modal fade z-i-9999" id="ModalDicomViewerCredentials" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important; z-index:99999 !important;"><div class="modal-dialog mdvcpopup"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Centricity Login</h4></div><div class="modal-body"><div class=""><div class="mdvctxt"><div class="row"><div class="col-md-12 col-sm-12 txt-clr-1"><h5 class="txt-clr-1 fs-18px">GE Healthcare</h5></div><div class="col-md-12 col-sm-12"><h4 class="txt-clr-1 fs-22px">Centricity<sup>*</sup></h4><h2 class="txt-clr-1 fs-26px">Universal Viewer</h2></div></div></div><div class="mdvcfrmouter"><form name="DVCredform" ng-submit="InsertDicomViewerCredentials(DVCredform.$valid)" class="mdvcfrm"><div class="w-30 float-left"><label class="txt-clr-1 fw-500">Username:</label></div><div class="w-70 float-left"><input type="text" name="DVCredUsername" ng-model="DVCred.Username" ng-required="true" class="w-100 blk-input form-control" autocomplete="on"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="txt-clr-1 fw-500">Password:</label></div><div class="w-70 float-left"><input type="password" name="DVCredPassword" ng-model="DVCred.Password" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-primary">Login</button></div><div class="clearfix"></div></form></div><div class="row"><div class="col-md-12 col-sm-12 text-left"><img src="assets/images/mdvc.png"></div></div></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/common-ag-grid/common-ag-grid.html','<div id="{{$ctrl.gridId}}" class="ag-theme-balham-dark" style="height:300px; border-radius:5px" keyboard="keys"></div>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/event-log/event-log.html','<style>\r\n    .arrow-up {\r\n        width: 0;\r\n        height: 0;\r\n        border-left: 5px solid transparent;\r\n        border-right: 5px solid transparent;\r\n        border-bottom: 6px solid #ccc;\r\n        display: inline-block;\r\n        cursor: pointer;\r\n        margin-bottom: 2px;\r\n    }\r\n\r\n    .arrow-down {\r\n        width: 0;\r\n        height: 0;\r\n        border-left: 5px solid transparent;\r\n        border-right: 5px solid transparent;\r\n        border-top: 6px solid #ccc;\r\n        display: inline-block;\r\n        cursor: pointer;\r\n        margin-bottom: 2px;\r\n    }\r\n\r\n    .wh-table.ordereventlog-table thead tr:nth-child(1) th:last-child {\r\n        padding-right: 5px !important;\r\n    }\r\n</style><div class="overflow-y-auto orderevent-contetnt w-200"><div class="row m-0 w-100"><table class="table pos-rel wh-table ordereventlog-table overflow-x-hide overflow-y-auto"><thead><tr><th class="text-left w-20"><label>Event Name</label></th><th class="text-left w-55"><label>Additional Information</label></th><th class="text-left w-15"><label>Created By</label></th><th ng-click="sortDate(\'EventCreatedDate\')" class="text-left w-10"><label class="d-inline-block">Event Created Date</label> <span ng-class="getSortClass(\'EventCreatedDate\')"></span></th></tr></thead><tbody ng-show="eventLog.length > 0"><tr ng-repeat="Log in eventLog"><td align="left" class="text-left w-20">{{Log.EventName}}</td><td align="left" class="text-left w-55"><p class="m-0" ng-bind-html="Log.AdditionalInfo"></p></td><td align="left" class="text-left w-15">{{Log.Username}}</td><td align="left" class="text-left w-10">{{Log.EventCreatedDate | date:\'M/d/yy HH:mm:ss\'}}</td></tr></tbody><tbody ng-show="eventLog.length == 0"><tr><td class="text-center w-100 py-10px" colspan="4" style="padding: 20px 0px !important;">No event logs found for this Order.</td></tr></tbody></table></div></div>');
$templateCache.put('app/theme/components/file-viewer/file-viewer.html','<style>\r\n    /*#imageFile img {\r\n        cursor: -webkit-zoom-in;\r\n        cursor: -moz-zoom-in;\r\n    }*/\r\n\r\n    .dragscroll {\r\n        /*border: 1px solid rgb(31, 40, 49);*/\r\n        /*background-color: #283849;*/\r\n        overflow: hidden;\r\n        /*width: 270px;\r\n        height: 380px;*/\r\n        padding: 20px;\r\n        cursor: -webkit-grab;\r\n        cursor: -moz-grab;\r\n        cursor: -o-grab;\r\n        cursor: grab;\r\n        margin: 0px auto 0px auto;\r\n        color: #fff;\r\n    }\r\n\r\n        .dragscroll:active {\r\n            cursor: -webkit-grabbing;\r\n            cursor: -moz-grabbing;\r\n            cursor: -o-grabbing;\r\n            cursor: grabbing;\r\n        }\r\n\r\n    .some-pdf-container {\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n    iframe {\r\n        width: 100%;\r\n        height: 500px;\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n    \r\n\r\n</style><div class="b-1-s b-clr-1 bg-clr-23 viewer-block overflow-hide-all pos-rel"><div ng-show="$ctrl.isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="fs-head mr-0 ml-0 mb-0"><div class="p-0-all text-right" ng-if="$ctrl.getFileType() == \'image\'"><a ng-click="$ctrl.downloadFile()" title="Download - {{$ctrl.fileName}}" ng-show="!$ctrl.isLoading" class="d-inline-block m-10px-all cursor-pointer"><span class="glyphicon glyphicon-save change-txtclr"></span></a></div></div><div ng-if="!$ctrl.isLoading"><screenshot is-open="$ctrl.isUrlOpen" api="$ctrl.imageApi" class="pv-report"><div class="wrapper w-100 pos-rel pdfcnvs" id="file-viewer-container"><div><div ng-if="$ctrl.getFileType() != \'pdf\' && $ctrl.getFileType() != \'image\'" style="height:100%" class="overflow-x-hide overflow-y-auto ifrm-height"><iframe ng-src="{{$ctrl.DocFileFrameSrc}}" frameborder="0"></iframe></div><div ng-if="$ctrl.getFileType() == \'pdf\'" class="pdf-view overflow-x-hide overflow-y-auto some-pdf-container"><pdf-viewer file-binary-content="$ctrl.fileBinaryContent" file-url="$ctrl.fileContent" send-fax="$ctrl.sendFax()" selected-order="$ctrl.selectedOrder"></pdf-viewer></div><div ng-if="$ctrl.getFileType() == \'image\'" class="img-view text-center" id="imageFile"><div class="top-imgzoom-sec"><div class="k-content wide scroll-img-section w-100" id="container" style="cursor: grab; cursor : -o-grab; cursor : -moz-grab; cursor : -webkit-grab;"><img ng-src="{{$ctrl.fileContent}}" id="imgFile" class="zoom" style="width:1px; display:none;"><div id="viewer2" class="viewer"></div></div><style>\r\n                                #viewer2 {\r\n                                    overflow: visible !important;\r\n                                }\r\n\r\n                                    #viewer2 img {\r\n                                        /*top:0 !important;\r\n                                    bottom:0 !important;\r\n                                    left:0 !important;\r\n                                    right:0 !important;\r\n                                    margin:auto !important;*/\r\n                                    }\r\n\r\n                                .viewer {\r\n                                    -ms-touch-action: none;\r\n                                }\r\n\r\n                                .iviewer_common {\r\n                                    position: absolute;\r\n                                    bottom: -14px;\r\n                                    left: 0;\r\n                                    right: 0;\r\n                                    margin: 0px auto;\r\n                                    border: 1px solid #000;\r\n                                    height: 28px;\r\n                                    z-index: 5000;\r\n                                }\r\n\r\n                                .iviewer_cursor {\r\n                                    /*cursor: url(/img/hand.cur) 6 8, pointer;*/\r\n                                    cursor: -webkit-grab;\r\n                                    cursor: -moz-grab;\r\n                                    cursor: -o-grab;\r\n                                    cursor: grab;\r\n                                }\r\n\r\n                                .iviewer_drag_cursor {\r\n                                    /*cursor: url(/img/grab.cur) 6 8, pointer;*/\r\n                                    cursor: -webkit-grabbing;\r\n                                    cursor: -moz-grabbing;\r\n                                    cursor: -o-grabbing;\r\n                                    cursor: grabbing;\r\n                                }\r\n\r\n                                .iviewer_button {\r\n                                    width: 28px;\r\n                                    cursor: pointer;\r\n                                    background-position: center center;\r\n                                    background-repeat: no-repeat;\r\n                                }\r\n\r\n                                .iviewer_zoom_in {\r\n                                    left: -133px;\r\n                                    background-color: #fff;\r\n                                }\r\n\r\n                                    .iviewer_zoom_in:before {\r\n                                        content: \'+\';\r\n                                        color: #000;\r\n                                        font-size: 20px;\r\n                                        vertical-align: middle;\r\n                                        line-height: 1.2;\r\n                                    }\r\n\r\n                                .iviewer_zoom_out {\r\n                                    left: -65px;\r\n                                    background-color: #fff;\r\n                                }\r\n\r\n                                    .iviewer_zoom_out:before {\r\n                                        content: \'-\';\r\n                                        color: #000;\r\n                                        font-size: 20px;\r\n                                        vertical-align: middle;\r\n                                        line-height: 1.2;\r\n                                    }\r\n\r\n                                .iviewer_zoom_zero {\r\n                                    left: -60px;\r\n                                    background-color: #fff;\r\n                                }\r\n\r\n                                    .iviewer_zoom_zero:before {\r\n                                        content: \'1:1\';\r\n                                        color: #000;\r\n                                        font-size: 16px;\r\n                                        vertical-align: middle;\r\n                                        line-height: 1.7;\r\n                                    }\r\n\r\n                                .iviewer_zoom_fit {\r\n                                    left: 5px;\r\n                                    background-color: #fff;\r\n                                }\r\n\r\n                                    .iviewer_zoom_fit:before {\r\n                                        content: \'[ ]\';\r\n                                        color: #000;\r\n                                        font-size: 17px;\r\n                                        vertical-align: middle;\r\n                                        line-height: 1.4;\r\n                                    }\r\n\r\n                                .iviewer_zoom_status {\r\n                                    left: 95px;\r\n                                    font-size: 16px;\r\n                                    background-color: #fff;\r\n                                    text-align: center;\r\n                                    width: 50px;\r\n                                    line-height: 1.6;\r\n                                }\r\n\r\n                                .iviewer_rotate_left {\r\n                                    left: 255px;\r\n                                    background-color: #fff;\r\n                                }\r\n\r\n                                    .iviewer_rotate_left:before {\r\n                                        content: \'\\27F2\';\r\n                                        color: #000;\r\n                                        font-size: 17px;\r\n                                        vertical-align: middle;\r\n                                        position: relative;\r\n                                        top: 3px;\r\n                                    }\r\n\r\n                                .iviewer_rotate_right {\r\n                                    left: 185px;\r\n                                    background-color: #fff;\r\n                                }\r\n\r\n                                    .iviewer_rotate_right:before {\r\n                                        content: \'\\27F3\';\r\n                                        color: #000;\r\n                                        font-size: 17px;\r\n                                        vertical-align: middle;\r\n                                        line-height: 1.4 !important;\r\n                                        position: relative;\r\n                                        top: 3px;\r\n                                    }\r\n\r\n                                .viewer {\r\n                                    width: 100%;\r\n                                    /*height: 440px;*/\r\n                                    height: 530px;\r\n                                    /*border: 1px solid black;*/\r\n                                    position: absolute;\r\n                                    top: 0px;\r\n                                }\r\n\r\n                                .k-window-maximized .viewer {\r\n                                    height: calc(100vh - 300px);\r\n                                }\r\n\r\n                                .wrapper {\r\n                                    overflow: hidden;\r\n                                }\r\n\r\n                                @media (max-width: 1200px) and (min-width: 500px) {\r\n                                    /*.iviewer_common {\r\n                                        bottom: 30px;\r\n                                    }*/\r\n                                }\r\n                            </style><script>\r\n\r\n                                $(document).ready(function () {\r\n\r\n                                    var imgsrc = document.getElementById(\'imgFile\').src;\r\n                                    var iv1 = $("#viewer").iviewer({\r\n                                        src: imgsrc,\r\n                                        zoom_max: "400",\r\n                                        update_on_resize: false,\r\n                                        zoom_animation: false,\r\n                                        mousewheel: false,\r\n                                        onMouseMove: function (ev, coords) { },\r\n                                        onStartDrag: function (ev, coords) { return false; }, //this image will not be dragged\r\n                                        onDrag: function (ev, coords) { }\r\n                                    });\r\n\r\n                                    $("#in").click(function () { iv1.iviewer(\'zoom_by\', 1); });\r\n                                    $("#out").click(function () { iv1.iviewer(\'zoom_by\', -1); });\r\n                                    $("#fit").click(function () { iv1.iviewer(\'fit\'); });\r\n                                    $("#orig").click(function () { iv1.iviewer(\'set_zoom\', 100); });\r\n                                    $("#update").click(function () { iv1.iviewer(\'update_container_info\'); });\r\n\r\n                                    var iv2 = $("#viewer2").iviewer(\r\n                                        {\r\n                                            src: imgsrc,\r\n                                            zoom_base: 10,\r\n                                            zoom_delta: 1.1,\r\n                                        });\r\n\r\n                                    $("#chimg").click(function () {\r\n                                        iv2.iviewer(\'loadImage\', imgsrc);\r\n                                        return false;\r\n                                    });\r\n\r\n                                    var fill = false;\r\n                                    $("#fill").click(function () {\r\n                                        fill = !fill;\r\n                                        iv2.iviewer(\'fill_container\', fill);\r\n                                        return false;\r\n                                    });\r\n\r\n                                    \r\n                                });\r\n\r\n                            </script></div></div></div></div></screenshot></div></div>');
$templateCache.put('app/theme/components/input-dropdown-list/input-dropdown-list.html','<style>\r\n    .min-height-unset {\r\n        min-height: unset !important;\r\n    }\r\n    .dropdown-withtext.b-clr-10.mult-select.ui-select-multiple.ui-select-bootstrap {\r\n        border-color: #424242 !important;\r\n        padding: 2px 6px 0 !important;\r\n        border-top-right-radius: 0 !important;\r\n        border-bottom-right-radius: 0 !important;\r\n    }\r\n    .dropdown-withtext.mult-select.ui-select-multiple.ui-select-bootstrap input.ui-select-search {\r\n        width: 100% !important;\r\n        opacity: 1 !important;\r\n    }\r\n    .dropdown-withtext.ui-select-bootstrap > .ui-select-choices:empty {\r\n        border: 0 !important;\r\n    }\r\n    .dropdown-withtext {\r\n        padding: 0 0 0 1px !important;\r\n        border-right: 0;\r\n        border-top-right-radius: 0 !important;\r\n        border-bottom-right-radius: 0 !important;\r\n    }\r\n    .textbox-withdropdown {\r\n        border-top-left-radius: 0 !important;\r\n        border-bottom-left-radius: 0 !important;\r\n    }\r\n</style><div class="d-flex align-item-center mb-5px"><div class="w-40 left-drop"><select ng-model="$ctrl.selectedOption.FilterOption" ng-options="option.Value for option in $ctrl.options track by option.Key" class="dropdown-withtext fs-11px form-control h-25px col-placeholder"></select></div><div class="w-100"><input type="text" class="form-control h-25px col-placeholder textbox-withdropdown" placeholder="{{$ctrl.placeHolderText}}" tooltip-class="uibtooltipDenial" uib-tooltip="{{$ctrl.placeHolderText}}" tooltip-placement="auto top" ng-model="$ctrl.selectedOption.text" ng-text-change="$ctrl.onTextChanged()"></div></div>');
$templateCache.put('app/theme/components/map-custom-rvu/map-custom-rvu.html','<style>\r\n\r\n    .mlp-value-box {\r\n        background-color: #555555 !important;\r\n    }\r\n    .customrvu-cpt {\r\n        margin-top: 3px;\r\n        margin-bottom: 3px;\r\n        overflow-y: auto;\r\n        max-height: 82px;\r\n    }\r\n    #CPTMultiSelectaddNewMapPopupGrid.multiSelectGridDiv {\r\n        top:unset !important;\r\n    }\r\n    #addNewMapPopup .mult-select.ui-select-container.ui-select-bootstrap\r\n    {\r\n        min-width:247px;\r\n    }\r\n    #addNewMapPopup .ag-input-field-input.ag-text-field-input, #addNewMapPopup .ag-cell-value.ag-cell {\r\n        color: white;\r\n        border: 0;\r\n        background: transparent;\r\n    }\r\n    #addNewMapPopup #CPTMultiSelectaddNewMapPopup .location-tags-input.pos-rel {\r\n        min-width: 930px;\r\n        max-width: 930px;\r\n    }\r\n    .custom-rvu-grid .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within {\r\n        border: 0 !important;\r\n    }\r\n    #addNewMapPopup #CPTMultiSelectaddNewMapPopup .location-tags-input tags-input .tags {\r\n        border: 1px solid #9b9b9b !important;\r\n    }\r\n    #addNewMapPopup #CPTMultiSelectaddNewMapPopup .location-tags-input tags-input .tags.focused {\r\n        border: 1px solid #d2d2d2 !important;\r\n    }\r\n    .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=number] {\r\n        color: #fff;\r\n        border-color: #9b9b9b;\r\n        border-radius: 4px;\r\n    }\r\n    .ag-theme-balham-dark .ag-ltr input[class^=ag-][type=number]:focus {\r\n        box-shadow: none;\r\n    }\r\n    @media (min-width: 768px) and (max-width: 992px) {\r\n        #addNewMapPopup .mult-select.ui-select-container.ui-select-bootstrap {\r\n            min-width: 227px;\r\n        }\r\n\r\n        #addNewMapPopup #CPTMultiSelectaddNewMapPopup .location-tags-input.pos-rel {\r\n            min-width: 440px;\r\n            max-width: 440px;\r\n        }\r\n        #addCustomRVUMapping .modal-dialog.w-70 {\r\n            width: 90% !important;\r\n        }\r\n    }\r\n</style><div><div class="d-flex justify-content-end mb-10px"><button ng-click="DownloadSampleCSV()" class="btn btn-primary rf-btn-xs mr-10px">Download Sample File</button><label class="my-0 w-100px py-4px mr-10px custfile pos-rel"><input class="cursor-pointer w-100 invisible" type="file" id="fileInput" name="fileInput" ng-model="DataObject.uploadedFile" onchange="angular.element(this).scope().readFile(this)" ng-click="ResetFileInput()" accept=".xlsx"> <span class="pos-abs fs-13px py-5px abs-t-0"><i class="fa fa-cloud-upload fs-16px v-a-m"></i> Import</span></label></div><div id="{{$ctrl.divId}}" class="custom-rvu-grid ag-theme-balham-dark" style="width:100%;height:500px"></div><div class="d-flex justify-content-end mt-10px"><button ng-click="SaveGridData()" class="btn btn-primary rf-btn-xs">Save</button></div></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/multi-select/multi-select.html','<style>\r\n    .overflowDiv .ag-theme-balham-dark .ag-body .ag-body-viewport .ag-center-cols-container .ag-row .ag-ltrs.ag-cell {\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    /* Panel is absolutely positioned to .multiSelectDropdown so the list stays aligned to the\r\n       trigger even when an ancestor has transform (which breaks position:fixed + viewport math). */\r\n    .multiSelectDropdown .ms-dropdown-panel {\r\n        position: absolute;\r\n        left: 0;\r\n        width: 100%;\r\n        min-width: 230px;\r\n        z-index: 10000;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    /* Match ui-select list offset (.addfltr-drpovrly .ui-select-choices uses margin-top: 2px) */\r\n    .multiSelectDropdown .ms-dropdown-panel.ms-dropdown-down {\r\n        top: 100%;\r\n        margin-top: 2px;\r\n        bottom: auto;\r\n    }\r\n\r\n    .multiSelectDropdown .ms-dropdown-panel.ms-dropdown-up {\r\n        bottom: 100%;\r\n        margin-bottom: 2px;\r\n        top: auto;\r\n    }\r\n\r\n    .multiSelectGridDiv {\r\n        height: 250px;\r\n        width: 100%;\r\n        position: relative;\r\n        border-radius: 5px;\r\n        overflow: hidden;\r\n        border: 1px solid #a2a1a1 !important;\r\n    }\r\n\r\n        .multiSelectGridDiv .ag-header .ag-header-cell {\r\n            padding-left: 4px !important;\r\n        }\r\n\r\n        .multiSelectGridDiv .ag-header {\r\n            background-color: #323232;\r\n        }\r\n\r\n        .multiSelectGridDiv .ag-body.ag-layout-normal {\r\n            background-color: #323232;\r\n        }\r\n\r\n        .multiSelectGridDiv .ag-cell {\r\n            padding-left: 3px !important;\r\n        }\r\n\r\n        .multiSelectGridDiv .ag-row {\r\n            background-color: #323232;\r\n            border: 0;\r\n        }\r\n\r\n        .multiSelectGridDiv .ag-group-expanded, .multiSelectGridDiv .ag-group-contracted {\r\n            margin-right: 4px;\r\n        }\r\n\r\n        .multiSelectGridDiv .ag-row-odd {\r\n            background-color: #323232;\r\n            border: 0;\r\n        }\r\n\r\n        .multiSelectGridDiv .ag-row-group-leaf-indent {\r\n            padding-left: 10px;\r\n        }\r\n\r\n        .multiSelectGridDiv .ag-checkbox .ag-input-wrapper {\r\n            line-height: 14px !important;\r\n            width: 14px !important;\r\n            height: 14px !important;\r\n            font-size: 14px !important;\r\n        }\r\n\r\n    .max-w-180px {\r\n        max-width: 180px;\r\n    }\r\n\r\n    .multiSelectGridDiv .ag-cell-value {\r\n        overflow: visible !important;\r\n        text-overflow: unset !important;\r\n        white-space: normal;\r\n        line-height: 20.5px;\r\n    }\r\n\r\n    .multiSelectGridDiv .ag-header-cell-text {\r\n        color: #e4e4e4 !important;\r\n    }\r\n\r\n    .multiSelectDropdown .tag-item {\r\n        height: auto !important;\r\n    }\r\n\r\n    #frmQuickFilter tags-input {\r\n        min-height: 25px;\r\n    }\r\n</style><div id="{{$ctrl.divId}}" class="pos-rel tultip-bottom multiSelectDropdown"><div class="location-tags-input pos-rel"><tags-input id="{{$ctrl.tagsInput}}" style="width: 100%" ng-model="selectedItems.Obj" key-property="{{$ctrl.uniqKey}}" add-on-enter="false" add-on-comma="false" add-on-blur="false" on-tag-removed="removeTag($tag)" allow-leftover-text="true" placeholder="{{DataObject.placeHolder}}" ng-click="showSelectDropdown()" on-tag-added="addTag($tag)" template="tagsInputTemplate" ng-disabled="$ctrl.ngDisabled"><auto-complete min-length="0" debounce-delay="{{DataObject.searchDelay}}" load-on-empty="true" source="Search($query,true)"></auto-complete></tags-input><button type="button" class="pos-abs no-bg border-0 loc-cleareall abs-r-0 abs-b-0 cursor-pointer p-5px-all fs-17px txt-clr-2 fw-600" ng-if="(selectedItems.Obj && selectedItems.Obj.length > 0) && !$ctrl.ngDisabled" tooltip-class="uibtooltipDenial" uib-tooltip="Clear Selected" tooltip-placement="auto left" ng-click="clearSelection()">x</button></div><div id="{{$ctrl.dropdownDiv}}" class="overflowDiv ms-dropdown-panel" ng-class="{\'ms-dropdown-up\': DataObject.dropUp, \'ms-dropdown-down\': !DataObject.dropUp}" style="width: 100%; display: none"><div id="{{$ctrl.gridId}}" class="multiSelectGridDiv ag-theme-balham-dark"></div></div></div><script type="text/ng-template" id="tagsInputTemplate"><div class="tag-template"> <div> <span ng-bind-html="data.DisplayProp"></span> <a class="cursor-pointer" ng-click="$removeTag()">\xD7</a> </div> </div></script>');
$templateCache.put('app/theme/components/ordering-physician/ordering-physician.html','<style>\r\n    .custom-wrvumap-grid.odr-physgrid {\r\n        height: calc(100vh - 130px);\r\n    }\r\n\r\n        .custom-wrvumap-grid.odr-physgrid.cust-wrvumap-site {\r\n            height: calc(100vh - 153px);\r\n        }\r\n\r\n    .sitetooltip-elem .tultiptext.multselect-haslist {\r\n        top: 62px !important;\r\n        left: 130px !important;\r\n    }\r\n\r\n    #dataOrderingPhySiteGrid.multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n\r\n    .sites-overflow {\r\n        width: 99%;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    @media (min-width: 768px) and (max-width: 992px) {\r\n        .sitetooltip-elem .tultiptext, .sitetooltip-elem .tultiptext.multselect-haslist {\r\n            left: 91px !important;\r\n        }\r\n    }\r\n\r\n    .ag-tooltip {\r\n        max-width: 250px !important; /* set width */\r\n        white-space: normal !important; /* wrap text */\r\n        height: auto !important; /* auto height */\r\n        padding: 8px 10px !important; /* adjust spacing */\r\n        font-size: 13px;\r\n    }\r\n</style><div><div class="pt-8px"><div class="row rf-filter-ui m-0 filterspace"><form id="frmOrderingPhysicianFilter" ng-submit="filterOrderingPhysicianList()"><div class="col-md-2 col-xs-2 pl-0"><input type="text" class="blk-input form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="DataObject.Filter.ReadingProviderName" placeholder="Enter Ordering Physician Name" title="Enter Ordering Physician Name"></div><div class="col-md-2 col-xs-2 pl-0"><input type="text" class="blk-input form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="DataObject.Filter.NPI" placeholder="Enter NPI" title="Enter NPI"></div><div class="col-md-2 col-sm-2 px-0 pos-rel tultip-bottom sitetooltip-elem"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="DataObject.Filter.SelectedSite" title="Select Site(s)"><ui-select-match placeholder="Select Site(s)" allow-clear="true">{{$select.selected.Site}} ({{$select.selected.TenantName}})</ui-select-match><ui-select-choices repeat="list in DataObject.MasterData.Sites | propsFilter: {Site: $select.search} | orderBy:\'Site\'" position="down"><span>{{list.Site}} ({{list.TenantName}})</span></ui-select-choices></ui-select></div><div class="col-lg-1 col-md-2 col-sm-2 col-xs-6 pd-lr pl-2"><button type="submit" class="btn btn-primary rf-btn-xs mr-4px" ng-disabled="DataObject.isPhysicianGridLoading">Filter</button> <button ng-click="clearOrderingPhysicianList()" class="btn btn-default rf-btn-xs" ng-disabled="DataObject.isPhysicianGridLoading">Clear</button></div></form><div class="col-lg-4 d-flex custm-rvu col-md-4 col-sm-4 col-xs-12 pd-lr mob-pr-0 pull-right" style="justify-content: end !important;"><div class="d-flex align-item-center"><button ng-click="NewOrderingPhysician();" class="btn btn-primary rf-btn-xs pull-right">Add New Ordering Physician</button></div></div></div></div><div id="PhysicianGrid" class="ag-theme-balham-dark w-100 custom-wrvumap-grid odr-physgrid" ng-class="{\'cust-wrvumap-site\': DataObject.Filter.SiteTenant.SelectedValue.list.length > 0}"></div></div><div class="modal fade physicianmodal" id="addOrderingPhysician" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog w-800px"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" ng-click="clearModalData(frmOrderingPhysician)">&times;</button><h4 class="modal-title">{{DataObject.OrderingPhysician.AddEditText}} Ordering Physician</h4></div><div class="modal-body pb-0"><ordering-physician-info master-data="DataObject.MasterData" selected-data="DataObject.OrderingPhysician.SelectedData" clear-modal-data="clearModalData(frmOrderingPhysician)" on-save-success="onSaveSuccess(result, providerData)" ng-if="DataObject.ShowOrderingPhysicianModal"></ordering-physician-info></div></div></div></div></div>');
$templateCache.put('app/theme/components/ordering-physician-info/ordering-physician-info.html','<style>\r\n    #dataOrderingPhySite .location-tags-input tags-input .tags,\r\n    #OrderingPhySite .location-tags-input tags-input .tags {\r\n        border: 1px solid #8f8e8e !important;\r\n    }\r\n\r\n    .height-380px {\r\n        height: 380px;\r\n    }\r\n</style><div><form name="frmOrderingPhysician" id="frmOrderingPhysician" class="width-inherit height-380px"><div class="row mx-0"><div class="col-lg-12 col-md-12 px-0 col-sm-12"><div class="row mx-0"><div class="col-md-12 col-sm-12 px-0"><div class="form-group py-1 w-100 px-0 pos-rel"><label class="rf-label">Site (Tenant) *</label> <span class="fw-700" ng-if="DataObject.SelectedData.SelectedSite">{{DataObject.SelectedData.SelectedSite.SiteTenant}}</span><multi-select master-data="DataObject.MasterData.SiteTenant" ng-model="DataObject.MasterData.SiteTenant.SelectedValue" list="DataObject.MasterData.Sites" on-change="DataObject.MasterData.SiteTenant.OnChange(selectedData)" tooltip-class="uibtooltipDenial" uib-tooltip="Select Site(s)" tooltip-placement="auto top" ng-if="!DataObject.SelectedData.SelectedSite"></multi-select></div></div></div><div class="row mx-0"><div class="col-md-4 col-sm-4 pl-0"><div class="form-group py-1 w-100 mb-10px px-0 pos-rel"><div class="group-register"><label class="rf-label">First Name *</label> <input class="blk-input form-control form-border" ng-model="DataObject.SelectedData.FirstName" name="FirstName" maxlength="50" type="text" placeholder="First Name" required="" ng-class="{\'border-color-red\' : (frmOrderingPhysician.FirstName.$touched && frmOrderingPhysician.FirstName.$invalid) }"></div></div></div><div class="col-md-4 col-sm-4"><div class="form-group py-1 w-100 mb-10px px-0 pos-rel"><div class="group-register"><label class="rf-label">Middle Name</label> <input class="blk-input form-control form-border" ng-model="DataObject.SelectedData.MiddleName" name="MiddleName" maxlength="50" type="text" placeholder="Middle Name" ng-class="{\'border-color-red\' : (frmOrderingPhysician.MiddleName.$touched && frmOrderingPhysician.MiddleName.$invalid) }"></div></div></div><div class="col-md-4 col-sm-4 pr-0"><div class="form-group py-1 w-100 mb-10px px-0 pos-rel"><div class="group-register"><label class="rf-label">Last Name *</label> <input class="blk-input form-control form-border" ng-model="DataObject.SelectedData.LastName" name="LastName" maxlength="50" type="text" placeholder="Last Name" required="" ng-class="{\'border-color-red\' : (frmOrderingPhysician.LastName.$touched && frmOrderingPhysician.LastName.$invalid) }"></div></div></div></div><div class="row mx-0"><div class="col-md-6 col-sm-6 pl-0 email-tags-input"><div class="form-group py-1 w-100 mb-10px px-0 pos-rel"><div class="group-register"><label class="rf-label">Phone</label> <input type="text" id="phone" class="blk-input form-border form-control" name="Phone" ui-mask="(999) 999-9999" maxlength="15" ng-model="DataObject.SelectedData.Phone" ng-paste="onPastePhone($event)" autocomplete="off" ng-class="{\'border-color-red\' : DataObject.SelectedData.Phone && (DataObject.SelectedData.Phone.length>0 && DataObject.SelectedData.Phone.length<10) }"></div></div></div><div class="col-md-6 col-sm-6 pr-0 email-tags-input"><div class="form-group py-1 w-100 mb-10px px-0 pos-rel"><div class="group-register"><label class="rf-label">Cell Phone</label> <input type="text" id="cellPhone" class="blk-input form-border form-control" name="CellPhone" ui-mask="(999) 999-9999" ng-paste="onPasteCellPhone($event)" maxlength="15" ng-model="DataObject.SelectedData.CellPhone" autocomplete="off" ng-class="{\'border-color-red\' : DataObject.SelectedData.CellPhone && (DataObject.SelectedData.CellPhone.length>0 && DataObject.SelectedData.CellPhone.length<10) }"></div></div></div></div><div class="row mx-0"><div class="col-md-6 col-sm-6 pl-0"><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">Email</label> <input class="blk-input form-control form-border" ng-model="DataObject.SelectedData.Email" name="emailId" maxlength="50" placeholder="Email" validate-email="" type="text" ng-pattern="/[a-z0-9]+@[a-z]+\\.[a-z]{2,3}$/" ng-class="{\'border-color-red\' : (frmOrderingPhysician.emailId.$touched && frmOrderingPhysician.emailId.$invalid) }"></div></div></div><div class="col-md-6 col-sm-6 pr-0"><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group-register"><label class="rf-label">NPI *</label> <input class="blk-input form-control form-border" ng-model="DataObject.SelectedData.NPI" name="NPI" type="text" placeholder="NPI" ng-class="{\'border-color-red\' : (frmOrderingPhysician.NPI.$touched && frmOrderingPhysician.NPI.$invalid) }" numbers-only="" required=""></div></div></div></div><div class="form-group py-1 w-100 mb-10px px-0 pos-rel"><div class="group-register"><label class="rf-label">Contact Preference *</label> <span class="pr-10px" ng-repeat="contactPreference in DataObject.MasterData.ContactPreferenceType"><input name="contactPreference" type="radio" value="{{contactPreference.Key}}" class="cmn-checkbx-input mt-2px mr-2px" ng-model="DataObject.SelectedData.ContactPreferenceType" required=""> {{contactPreference.Value}}</span></div></div></div></div></form></div><div class="modal-footer border-0" style="background-color: #3A393A !important;"><button class="btn btn-default" ng-click="clearModalData(frmOrderingPhysician)">Cancel</button> <button class="btn btn-primary" ng-disabled="DisableSaveBtn()" ng-click="SaveOrderingPhysician();">Save</button></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<style>\r\n    /*worklist page top btn zoom effect css start*/\r\n    .user-loggedin.dropdown-menu li a img {\r\n        width: 26px;\r\n    }\r\n    .stcircle {\r\n        width: 12px;\r\n        height: 12px;\r\n        border-radius: 50%;\r\n        margin: 0px auto 2px;\r\n        display: none; /* to hide small circle*/\r\n    }\r\n\r\n    .wl-topbtnsection {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .wlzoomeffect span {\r\n        /*display: block;*/\r\n        text-align: center;\r\n        /*color: #c9edff;*/\r\n        color: #bdbdbd;\r\n    }\r\n\r\n    .wlzoomeffect.prvu span:nth-child(2) {\r\n        float: left;\r\n        padding-right: 5px;\r\n    }\r\n\r\n    .wlzoomeffect {\r\n        display: inline-block;\r\n        border: 0;\r\n        width: auto;\r\n        height: auto;\r\n        position: relative;\r\n        cursor: pointer;\r\n        margin: 0;\r\n        padding: 6px;\r\n    }\r\n\r\n        .wlzoomeffect:hover {\r\n        }\r\n\r\n        .wlzoomeffect.prvu:hover {\r\n            z-index: 2;\r\n            -webkit-transition: all 200ms ease-in;\r\n            -webkit-transform: scale(1.5);\r\n            -ms-transition: all 200ms ease-in;\r\n            -ms-transform: scale(1.5);\r\n            -moz-transition: all 200ms ease-in;\r\n            -moz-transform: scale(1.5);\r\n            transition: all 200ms ease-in;\r\n            transform: scale(1.5);\r\n            cursor: pointer;\r\n        }\r\n\r\n        .wlzoomeffect.adborder:hover::after {\r\n            content: \'\';\r\n            width: 100%;\r\n            position: absolute;\r\n            bottom: 0;\r\n            left: 0;\r\n            z-index: 1;\r\n            border-bottom: 2px solid;\r\n        }\r\n\r\n        .wlzoomeffect.adborder:hover {\r\n            background-color: #323232;\r\n        }\r\n\r\n        .wlzoomeffect .cancel:hover span {\r\n            display: none;\r\n        }\r\n\r\n        .wlzoomeffect .cancel:after {\r\n            content: "Cancelled";\r\n        }\r\n\r\n        .wlzoomeffect .cancel:hover:after {\r\n            content: "Cancelled" !important;\r\n        }\r\n\r\n        .wlzoomeffect .comparison:hover span {\r\n            display: none;\r\n        }\r\n\r\n        .wlzoomeffect .comparison:after {\r\n            content: "Comparison";\r\n        }\r\n\r\n        .wlzoomeffect .comparison:hover:after {\r\n            content: "Comparison" !important;\r\n        }\r\n\r\n        .wlzoomeffect.draft:hover span {\r\n            display: none;\r\n        }\r\n\r\n        .wlzoomeffect .draft:after {\r\n            content: "Draft ({{DraftCount}})";\r\n        }\r\n\r\n        .wlzoomeffect .draft:hover:after {\r\n            content: "Draft ({{DraftCount}})" !important;\r\n        }\r\n\r\n        .wlzoomeffect.complete:hover span {\r\n            display: none;\r\n        }\r\n\r\n        .wlzoomeffect .complete:after {\r\n            content: "Complete ({{CompleteCount}})";\r\n        }\r\n\r\n        .wlzoomeffect .complete:hover:after {\r\n            content: "Complete ({{CompleteCount}})" !important;\r\n        }\r\n\r\n        .wlzoomeffect .hst:hover span {\r\n            display: none;\r\n        }\r\n\r\n        .wlzoomeffect .hst:after {\r\n            content: "Hidden ({{HiddenCount}})";\r\n        }\r\n\r\n        .wlzoomeffect .hst:hover:after {\r\n            content: "Hidden ({{HiddenCount}})" !important;\r\n        }\r\n\r\n        .wlzoomeffect .resultpending:hover span {\r\n            display: none;\r\n        }\r\n\r\n        .wlzoomeffect .resultpending:after {\r\n            content: "Result Pending ({{ResultPendingCount}})";\r\n        }\r\n\r\n        .wlzoomeffect .resultpending:hover:after {\r\n            content: "Result Pending ({{ResultPendingCount}})" !important;\r\n        }\r\n\r\n        .wlzoomeffect .rps:hover span {\r\n            display: none;\r\n        }\r\n\r\n        .wlzoomeffect .rps:after {\r\n            content: "STAT/High Priority ({{StatCount}})";\r\n        }\r\n\r\n        .wlzoomeffect .rps:hover:after {\r\n            content: "STAT/High Priority ({{StatCount}})" !important;\r\n        }\r\n\r\n        .wlzoomeffect .st:after {\r\n            content: "Signed Today ({{SignedToday}})";\r\n        }\r\n\r\n        .wlzoomeffect .st:hover:after {\r\n            content: "Signed Today ({{SignedToday}})" !important;\r\n        }\r\n\r\n        .wlzoomeffect .imagepending:hover span {\r\n            display: none;\r\n        }\r\n\r\n        .wlzoomeffect .imagepending:after {\r\n            content: "Image Pending";\r\n        }\r\n\r\n        .wlzoomeffect .imagepending:hover:after {\r\n            content: "Image Pending" !important;\r\n        }\r\n\r\n        .wlzoomeffect .ormpending:hover span {\r\n            display: none;\r\n        }\r\n\r\n        .wlzoomeffect .ormpending:after {\r\n            content: "ORM Pending";\r\n        }\r\n\r\n        .wlzoomeffect .ormpending:hover:after {\r\n            content: "ORM Pending" !important;\r\n        }\r\n\r\n        .wlzoomeffect.prvu:hover {\r\n            background-color: #3cc57e;\r\n            cursor: pointer;\r\n        }\r\n\r\n            .wlzoomeffect.prvu:hover span {\r\n                color: #424242;\r\n                cursor: pointer;\r\n            }\r\n\r\n    .p-zoom {\r\n        /*padding: 3px 3px;*/\r\n    }\r\n    .rfmenuright .nav-hover:hover {\r\n        background-color: #1c171c !important;\r\n    }\r\n    @media only screen and (min-width: 320px) and (max-width: 1200px) {\r\n        .p-zoom {\r\n            padding: 3px 2px;\r\n        }\r\n\r\n        .wlzoomeffect .imagepending:after {\r\n            content: "IP" !important;\r\n        }\r\n\r\n        .wlzoomeffect .ormpending:after {\r\n            content: "ORM P" !important;\r\n        }\r\n\r\n        .wlzoomeffect .cancel:after {\r\n            content: "CA" !important;\r\n        }\r\n\r\n        .wlzoomeffect .comparison:after {\r\n            content: "Co" !important;\r\n        }\r\n\r\n        /*Bug 19801: The study count is not visible on status*/\r\n        .wlzoomeffect .draft:after {\r\n            content: "D" !important;\r\n        }\r\n\r\n        .wlzoomeffect .complete:after {\r\n            content: "C" !important;\r\n        }\r\n\r\n        .wlzoomeffect .hst:after {\r\n            content: "H" !important;\r\n        }\r\n\r\n        .wlzoomeffect .resultpending:after {\r\n            content: "RP" !important;\r\n        }\r\n\r\n        .wlzoomeffect .rps:after {\r\n            content: "STAT" !important;\r\n        }\r\n\r\n        .wlzoomeffect .st:after {\r\n            content: "ST" !important;\r\n        }\r\n    }\r\n    /*worklist page top btn zoom effect css end*/\r\n</style><div class="page-top d-flex clearfix bg-clr-31 p-0" scroll-position="scrolled"><nav id="navtop" class="navbar navbar-default no-bg border-0 m-0 p-0 rfmenuleft"><div class="nav-p d-flex"><div class="navbar-header"><button type="button" class="navbar-toggle collapsed no-bg hambtn" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar" ng-if="menuItems.length > 0"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="float-left px-8px py-2px rflogo" href="#"><img src="assets/img/radflow.svg" class=""></a></div><div id="navbar" class="pagetop-nav navbar-collapse collapse"><div class="hmbr-menu-heading d-flex align-item-center mb-10px"><h1 class="rf-menu-heading m-0">Menu</h1><a href="javascript:void(0);" class="rf-menu-close">x</a></div><ul class="nav navbar-nav"><li><ba-sidebar></ba-sidebar></li></ul></div></div></nav><div class="rfmenuright d-flex" ng-if="AnalyticsWindowPopout"><div class="navbar-custom-menu"><ul class="nav navbar-nav dropMenu"><li class="dropdown user user-menu nav-hover br-1-s b-clr-10 float-left pos-rel"><a class="dropdown-toggle helphover d-flex align-item-center" style="cursor:pointer;color:#eeeeee!important;" ng-mouseover="HelpMenuAction(false)"><i class="fa fa-question-circle fs-16px txt-clr-18" aria-hidden="true" style="padding-right: 3px;"></i><div class="d-inline mr-5px txt-clr-18">Help</div></a><ul class="user-loggedin dropdown-menu helpsection-wrapper p-10px-all bor-rad-5px" ng-class="{\'helpsection-collapsed\' : helpMenuCliked}"><li><a class="d-block p-5px-all cursor-pointer fs-13px fw-600" id="tourWorklistMultiView" ng-if="userRoles.includes(\'User\')" ng-click="HelpMenuAction(true)">Worklist (Start Tour)</a></li><li><a class="d-block p-5px-all cursor-pointer fs-13px fw-600" id="tourTechnologist" ng-style="{ \'border-top\' : (userRoles.length == 1 && userRoles.includes(\'Technologist\')) ? \'0\' : \'\' }" ng-if="userRoles.includes(\'Technologist\')" ng-click="HelpMenuAction(true)">Technologist Worklist (Start Tour)</a></li><li><a class="d-block p-5px-all cursor-pointer fs-13px fw-600" id="tourPhysician" ng-style="{ \'border-top\' : (userRoles.length == 1 && userRoles.includes(\'Physician\')) ? \'0\' : \'\' }" ng-if="userRoles.includes(\'Physician\')" ng-click="HelpMenuAction(true)">Physician Worklist (Start Tour)</a></li><li><a class="d-block p-5px-all cursor-pointer fs-13px fw-600" id="tourPeerReview" ng-if="userRoles.includes(\'User\')" ng-click="HelpMenuAction(true)">Peer Review (Start Tour)</a></li><li><a class="d-block p-5px-all cursor-pointer fs-13px fw-600 btnhelpmenu" ng-click="HelpMenuAction(true)">FAQ</a></li></ul></li><li class="dropdown user user-menu nav-hover chat-step br-1-s b-clr-10 float-left"><a class="dropdown-toggle" style="cursor:pointer;color:#eeeeee!important;" title="Chat" ng-click="activeChatMenuBar()"><span id="spanChat" class=""><i class="fa fa-comment fs-16px txt-clr-18"></i></span> <span class="notification-label label-danger set-pos-right px-3px py-2px fs-10px border-radius-50-all" ng-if="UnreadCount > 0">{{UnreadCount}}</span><div class="d-inline mr-5px txt-clr-18">Chat</div></a></li><li class="dropdown user user-menu nav-hover br-1-s b-clr-10 float-left"><a href="#" class="dropdown-toggle no-bg"><img src="assets/images/envelope.svg" alt="Envelope"> <span class="notification-label label-danger fs-10px border-radius-50-all" ng-show="OrderDiscussions.length>0">{{OrderDiscussions.length}}</span></a><ul class="dropdown-menu overflow-y-auto max-h-200px text-left p-10px-all"><li class="text-left bb-1-s b-clr-10"><a href="#"><p class="mb-0 fs-12px" style="white-space: normal;" ng-show="OrderDiscussions.length>0">You have {{OrderDiscussions.length}} messages</p><p class="mb-0 fs-12px" style="white-space: normal;" ng-show="OrderDiscussions.length==0">No messages</p></a></li><li class="text-left" ng-repeat="OD in OrderDiscussions"><a href="#" ng-click="OpenOrderDiscussion(OD)"><p class="fs-12px mb-0" style="white-space: normal;" ng-show="OD.Status==\'O\'">{{OD.FromUser}} wants to consult with you on a study.</p><p class="fs-12px mb-0" style="white-space: normal;" ng-show="OD.Status==\'A\'">{{OD.ToUser}} replied on a study.</p><p class="fs-12px mb-0" style="white-space: normal;" ng-show="OD.Status==\'N\'">{{OD.FromUser}} replied on your comment.</p><p class="fs-12px mb-0" style="white-space: normal;" ng-show="OD.Status==\'I\'">You have a new study assigned by {{OD.FromUser}}.</p><p class="fs-12px mb-0 d-flex align-item-center" style="white-space: normal;" ng-show="OD.RequestType==\'Addendum Request\'"><span ng-if="OD.IsHighPriority"><i class="fa fa-exclamation text-danger px-5px fs-20px w-30px" title="High Priority" aria-hidden="true"></i></span> <span>{{OD.FromUser}} has submitted a request for an addendum to the study.</span></p></a></li></ul></li><li class="dropdown user user-menu nav-hover br-1-s b-clr-10 float-left"><a class="dropdown-toggle"><div class=""><span id="spanPriorityCount" class="barStudyCount bartop-nocount"><i class="fa fa fa-user fs-12px mr-1px"></i> {{PendingCount.PriorityCount}}</span></div></a></li><li class="dropdown user user-menu nav-hover br-1-s b-clr-10 float-left"><a class="dropdown-toggle"><div class=""><span id="spanPracticeCount" class="barStudyCount bartop-nocount"><i class="fa fa-users fs-12px mr-1px"></i>{{PendingCount.PracticeCount}}</span></div></a></li><li class="dropdown user user-menu nav-hover float-left profile-step"><a href="#" class="dropdown-toggle drp-tg-usrprfl no-bg txt-clr-18 d-flex align-item-center justify-content-center"><span class="d-none"><img src="assets/images/user.svg" style="width:85%"></span> <span class="full-w-no d-flex fs-11px user-prfcrcl" style="letter-spacing:1px;">{{LastName.substring(0,1)}}{{FirstName.substring(0,1)}}</span></a><ul class="user-loggedin dropdown-menu" ng-class="{\'login-techuser\' : IsTechUser}"><li class="user-header ml-5px pt-0"><span class="user-log-photo d-flex k-justify-content-center align-item-center txt-clr-1 fs-12px" style="font-weight:300;letter-spacing:1px;">{{LastName.substring(0,1)}}{{FirstName.substring(0,1)}}</span><h1 class="user-log-name mb-0 txt-clr-1">{{LastName}}, {{FirstName}}</h1></li><li class="mt-5px"><a href="javascript:void(0)" class="pl-5px d-flex align-item-center" ng-click="OpenProfileUserPref(\'ProfileMenu\')"><img src="assets/images/Profile.svg" class="">Profile</a></li><li class="mt-5px" ng-if="!IsTechUser"><a href="javascript:void(0)" class="pl-5px d-flex align-item-center" ng-click="OpenProfileUserPref(\'UserPreferenceMenu\')"><img src="assets/images/user_preference.svg">User Preference</a></li><li class="mt-5px" ng-if="!IsTechUser"><a href="javascript:void(0)" class="pl-5px d-flex align-item-center" ng-click="OpenCIVRSetting()"><img src="assets/images/CIVR_settings.svg"> CIVR Settings</a></li><li class="mt-5px" ng-if="IsPaymentContractEnabled"><a href="javascript:void(0)" class="pl-5px d-flex align-item-center" ng-click="OpenProfileUserPref(\'PaymentDashBoardMenu\')"><i class="fa fa-dashboard pl-2px pr-10px" aria-hidden="true"></i>Payment Dashboard</a></li><li class="mt-5px"><a href="javascript:void(0)" class="pl-5px d-flex align-item-center" ng-click="logout()"><img src="assets/images/Logout.svg" class="pl-5px pr-10px"> Sign out</a></li></ul></li></ul></div></div><div class="clearfix"></div></div><div ng-if="false" ng-controller="AccountManagerListController as accListCtrl" class="modal fade" id="resetUserPasswordModal" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Reset Password</h4><span style="color:red; float:left">{{accListCtrl.Message}}</span></div><div class="modal-body"><div class="w-100 h-100 p-10px-all clearfix"><div class="h-100 w-12 float-left no-bg bc-25292c pr-2"><div class="height-c-100-7 pos-rel"><div class="w-100 pos-abs h-100 abs-l-0 overflow-x-hide" data-jquery-scrollbar=""><div class="w-100 h-100 pos-rel"><form name="frmUserResetPassword" ng-submit="accListCtrl.ResetUserPassword(frmUserResetPassword.$valid)" class="width-inherit height-inherit"><div class="width-auto"><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group"><input type="password" class="form-control px-0" ng-model="accListCtrl.OldPassword" autocomplete="off" required=""> <span class="bar"></span> <label class="rf-label mb-0 txt-clr-3">Old Password *</label></div><div class="group"><input type="password" class="form-control px-0" ng-model="accListCtrl.Password" autocomplete="off" required=""> <span class="bar"></span> <label class="rf-label mb-0 txt-clr-3">New Password *</label></div><div class="group"><input type="password" class="form-control px-0" ng-model="accListCtrl.ConfirmPassword" autocomplete="off" required=""> <span class="bar"></span> <label class="rf-label mb-0 txt-clr-3">Confirm Password *</label></div></div></div><br><div class="modal-footer"><span style="color:red; float:left">* mandatory fields</span> <button type="submit" value="Invite" class="btn btn-primary w-100 m-0-auto px-0 d-block" ng-disabled="frmUserResetPassword.$invalid">Reset</button></div></form></div></div></div></div></div></div></div></div></div><div class="modal fade faq-modal right" id="FAQModal" role="dialog"><div class="modal-dialog modal-lg faq-modal-lg" style="width: 100% !important;"><div class="modal-content bg-2e2e2e border-0 h-100-per"><div class="modal-header txt-clr-1 border-0"><button type="button" class="close colse-brdicon fs-40px pos-rel p-12px-all" data-dismiss="modal"></button><h1 class="modal-title txt-clr-1 fs-40px fw-600">Frequently Asked Questions</h1></div><div class="modal-body"><input type="text" name="name" class="blk-input form-control faq-inputbox w-100 border-0 bor-rad-5px" placeholder="Ask a question" autocomplete="off"><div class="faqs-wraaper"><div class="row"><div class="col-md-8"><div class="row"><div class="col-md-6"><h2 class="txt-clr-1">User Guidance</h2><div class="faqs-accordion panel-group" id="accordionTourSteps"><div class="panel panel-default no-box-shadow bor-rad-0"><div class="panel-heading p-15px-all h-auto box-shadow-n border-bottom-0"><h4 class="panel-title fs-15px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordionTourSteps" href="#collapseStep1">Search and Worklist Tab</a></h4></div><div id="collapseStep1" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0 pl-20px"><p class="fs-13px m-0">Effortless and Simplified worklist management with the intuitive search and selection tools</p></div></div></div><div class="panel panel-default no-box-shadow bor-rad-0"><div class="panel-heading p-15px-all h-auto box-shadow-n border-bottom-0"><h4 class="panel-title fs-15px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordionTourSteps" href="#collapseStep2">Search and Worklist Tab</a></h4></div><div id="collapseStep2" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0 pl-20px"><p class="fs-13px m-0">Effortless and Simplified worklist management with the intuitive search and selection tools</p></div></div></div><div class="panel panel-default no-box-shadow bor-rad-0"><div class="panel-heading p-15px-all h-auto box-shadow-n border-bottom-0"><h4 class="panel-title fs-15px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordionTourSteps" href="#collapseStep3">Search and Worklist Tab</a></h4></div><div id="collapseStep3" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0 pl-20px"><p class="fs-13px m-0">Effortless and Simplified worklist management with the intuitive search and selection tools</p></div></div></div><div class="panel panel-default no-box-shadow bor-rad-0"><div class="panel-heading p-15px-all h-auto box-shadow-n border-bottom-0"><h4 class="panel-title fs-15px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordionTourSteps" href="#collapseStep4">Search and Worklist Tab</a></h4></div><div id="collapseStep4" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0 pl-20px"><p class="fs-13px m-0">Effortless and Simplified worklist management with the intuitive search and selection tools</p></div></div></div></div></div><div class="col-md-6"><h2 class="txt-clr-1">Account & Settings</h2><div class="faqs-accordion panel-group" id="accordionAccSettings"><div class="panel panel-default no-box-shadow bor-rad-0"><div class="panel-heading p-15px-all h-auto box-shadow-n border-bottom-0"><h4 class="panel-title fs-15px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordionAccSettings" href="#AccSetProfileStep">Profile</a></h4></div><div id="AccSetProfileStep" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0 pl-20px"><p class="fs-13px m-0">Your personal dashboard where you can manage and customize your account settings. Here, you can <a href="#/profile" style="color: #00C7A6; text-decoration: underline !important" class="fw-600 txt">update</a> user details, password, PIN & user access.</p></div></div></div><div class="panel panel-default no-box-shadow bor-rad-0"><div class="panel-heading p-15px-all h-auto box-shadow-n border-bottom-0"><h4 class="panel-title fs-15px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordionAccSettings" href="#AccSetUserPref">User Preference</a></h4></div><div id="AccSetUserPref" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0 pl-20px"><p class="fs-13px m-0">This section allows you to customize your experience and tailor the application to your needs. Here, you can <a href="#" style="color: #00C7A6; text-decoration: underline !important" class="fw-600 txt">set up</a> worklist settings: worklist view, practice or personal worklist, choose next study, other users\' assigned studies in the worklist, preferred DICOM viewer and preferred dictation system. App launch settings: position for launching select apps in the new window.\uFFFD</p></div></div></div><div class="panel panel-default no-box-shadow bor-rad-0"><div class="panel-heading p-15px-all h-auto box-shadow-n border-bottom-0"><h4 class="panel-title fs-15px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordionAccSettings" href="#AccSetCIVESet">CIVR Settings</a></h4></div><div id="AccSetCIVESet" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0 pl-20px"><p class="fs-13px m-0">In this section, you can <a href="#" style="color: #00C7A6; text-decoration: underline !important" class="fw-600 txt">set up</a> general preferences, Keyboard shortcuts, dictation microphone buttons, recording mode, voice commands, phare list, template, template library for the CIVR application.\uFFFD</p></div></div></div></div></div></div></div><div class="col-md-4"><div class="row"><div class="col-md-12"><h2 class="txt-clr-1">Others</h2></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/patientDetails/patientDetails.html','<style>\r\n    .groupbox {\r\n        padding: 10px 18px;\r\n        border: 1px solid #5f5f5f;\r\n        border-radius: 6px;\r\n        width: 100%;\r\n        height: 100%;\r\n        margin: 0;\r\n        position: relative;\r\n    }\r\n\r\n        .groupbox .groupbox-label {\r\n            position: absolute;\r\n            top: -10px;\r\n            left: 12px;\r\n            background: #272627;\r\n            padding-left: 5px;\r\n            padding-right: 5px;\r\n        }\r\n\r\n    .patient-card .report_span_title {\r\n        color: #b4b4b4 !important;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .patient-card .report_span {\r\n        color: #fff;\r\n        font-size: 13px;\r\n        display: inline-block;\r\n        line-height: normal;\r\n        margin-bottom: -4px;\r\n        max-width: 217px;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        text-transform: uppercase;\r\n    }\r\n\r\n        .patient-card .report_span.reason-txt {\r\n            max-width: 240px;\r\n        }\r\n\r\n        .patient-card .report_span.proc-txt {\r\n            max-width: 180px;\r\n        }\r\n\r\n        .patient-card .report_span.loc-txt {\r\n            font-size: 12px;\r\n        }\r\n\r\n    .exam-tag-group {\r\n        max-width: 274px;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        display: inline-block;\r\n        line-height: 20px;\r\n        margin-bottom: -5px;\r\n    }\r\n\r\n    .exam-tag {\r\n        font-size: 11px;\r\n        padding: 2px 5px;\r\n        border-radius: 4px;\r\n        background-color: #006f5e;\r\n        border: 1px solid #05c1a4;\r\n        display: inline;\r\n    }\r\n\r\n    .priority-badge {\r\n        font-size: 11px;\r\n        padding: 2px 5px;\r\n        color: #05c1a4 !important;\r\n        display: inline;\r\n        font-weight: 600;\r\n        max-width: 190px !important;\r\n        border-radius: 4px;\r\n        background-color: rgba(5, 193, 164, 0.19);\r\n    }\r\n\r\n    .stat-priority-badge {\r\n        font-size: 11px;\r\n        padding: 2px 5px;\r\n        color: white !important;\r\n        display: inline;\r\n        font-weight: 600;\r\n        border-radius: 4px;\r\n        background-color: rgba(230, 0, 0, 72) !important;\r\n    }\r\n\r\n    /*  .status-badge {\r\n            font-size: 11px;\r\n            padding: 2px 5px;\r\n            color: #05c1a4 !important;\r\n            display: inline;\r\n            font-weight: 600;\r\n            border-radius: 4px;\r\n            background-color: rgba(5, 193, 164, 0.19);\r\n        }\r\n    */\r\n    .patient-card {\r\n        background-color: #272627;\r\n        border-radius: 5px;\r\n    }\r\n\r\n    .new-ui-context {\r\n        z-index: 9;\r\n        text-align: center;\r\n        border-radius: 10px;\r\n        font-size: 12px;\r\n        /*box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;*/\r\n        border: 1px solid rgba(0, 0, 0, .15);\r\n        box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\r\n    }\r\n\r\n\r\n    .nohover:hover {\r\n        color: white;\r\n    }\r\n\r\n    .custom-ellipsis {        \r\n        font-size: 22px;\r\n        cursor:pointer;\r\n        color: #05C1A4;\r\n    }\r\n\r\n    /* half window screen for both browser IE & Chrome start */\r\n    @media (max-width: 1199px) and (min-width: 768px) {\r\n        .patient-card .report_span_title {\r\n            font-size: 11px;\r\n        }\r\n\r\n        .patient-card .report_span.loc-txt {\r\n            font-size: 11px;\r\n        }\r\n\r\n        .patient-card .Patient-info .report_span {\r\n            max-width: 140px;\r\n        }\r\n\r\n        .patient-card .report_span {\r\n            font-size: 11px;\r\n            display: inline-block;\r\n            max-width: 120px;\r\n            white-space: nowrap;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n        }\r\n\r\n            .patient-card .report_span.proc-txt {\r\n                font-size: 11px;\r\n                display: inline-block;\r\n                max-width: 100px;\r\n                white-space: nowrap;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n            }\r\n\r\n        .patient-card .exam-tag-group.more-tags {\r\n            max-width: 160px;\r\n        }\r\n            .patient-card .report_span.exam-tag, .exam-tag-group {\r\n                max-width: 170px;\r\n            }\r\n\r\n            .patient-card .report_span.reason-txt {\r\n                max-width: 145px;\r\n            }\r\n\r\n            .patient-card .report_span.loc-txt {\r\n                max-width: 130px;\r\n            }\r\n\r\n            .patient-card .report_span.priority-badge {\r\n                max-width: 100px !important;\r\n            }\r\n\r\n        .new-ui-context.phy-con {\r\n            right: -20px !important;\r\n        }\r\n\r\n        .new-ui-context.search-con {\r\n            right: -10px !important;\r\n        }\r\n    }\r\n    /* half window screen for both browser IE & Chrome end */\r\n</style><div class="fw-500 patient-card mt-3px pb-2px px-10px"><div class="row d-flex mx-0 mb-10px"><div class="col-md-3 col-sm-3 pl-0 pr-5px mt-10px"><div class="groupbox pos-rel px-0"><label class="groupbox-label rf-label">Patient Info</label><div class="row m-0 Patient-info"><div class="col-md-12 pr-0 mb-5px"><span class="report_span_title">MRN:</span> <span class="report_span text-uppercase" title="{{DataObject.selectedOrder.PatientMRN}}" ng-if="DataObject.selectedOrder.PatientMRN">{{DataObject.selectedOrder.PatientMRN}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.PatientMRN">NA</span></div><div class="col-md-12 pr-0 mb-5px"><span class="report_span_title">Name:</span> <span class="report_span" title="{{DataObject.selectedOrder.PatientName}}" ng-if="DataObject.selectedOrder.PatientName">{{DataObject.selectedOrder.PatientName}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.PatientName">NA</span></div><div class="col-md-12 pr-0 mb-5px"><span class="report_span_title">Age/DOB:</span> <span class="report_span" ng-if="DataObject.selectedOrder.PatientAge && DataObject.selectedOrder.PatientDOB">{{DataObject.selectedOrder.PatientAge}} ({{DataObject.selectedOrder.PatientDOB}})</span> <span class="report_span" ng-if="!DataObject.selectedOrder.PatientAge && !DataObject.selectedOrder.PatientDOB">NA</span></div><div class="col-md-12 pr-0 mb-5px"><span class="report_span_title">Gender:</span> <span class="report_span" ng-if="DataObject.selectedOrder.PatientGender == \'F\'">Female</span> <span class="report_span" ng-if="DataObject.selectedOrder.PatientGender == \'M\'">Male</span> <span class="report_span" ng-if="DataObject.selectedOrder.PatientGender == \'O\'">Other</span> <span class="report_span" ng-if="!DataObject.selectedOrder.PatientGender">NA</span></div><div class="col-md-12 pr-0 mb-5px"><span class="report_span_title">Phone:</span> <span class="report_span" title="{{DataObject.selectedOrder.PatientPhone}}" ng-if="DataObject.selectedOrder.PatientPhone">{{DataObject.selectedOrder.PatientPhone}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.PatientPhone">NA</span></div><div class="col-md-12 pr-0 mb-5px"><span class="report_span_title">Email:</span> <span class="report_span" title="{{DataObject.selectedOrder.PatientEmailID}}" ng-if="DataObject.selectedOrder.PatientEmailID">{{DataObject.selectedOrder.PatientEmailID}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.PatientEmailID">NA</span></div></div></div></div><div class="col-md-6 col-sm-6 px-0 mt-10px"><div class="groupbox pos-rel px-0"><label class="groupbox-label rf-label">Order Info</label><div class="row d-flex flex-wrap m-0"><div class="col-md-6 col-sm-6 pr-0 mb-5px"><span class="report_span_title">Location:</span> <span class="report_span pr-1 loc-txt" title="{{DataObject.selectedOrder.Location}}" ng-if="DataObject.selectedOrder.Location">{{DataObject.selectedOrder.Location}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.Location">NA</span><div class="tooltip-w-100px d-inline pos-rel" ng-if="DataObject.selectedOrder.Location && DataObject.selectedOrder.ShowContactBtn" ng-mouseover="showDivOnHover = true" ng-mouseleave="showDivOnHover = false"><i class="fa fa-phone cursor-pointer txt-clr-14" aria-hidden="true"></i><div class="cursor-pointer sm-pl d-block pos-abs px-5px py-2 new-ui-context bg-clr-30" style="top: 0px !important;z-index:9; left: 16px; width:130px;" ng-show="showDivOnHover"><a ng-click="ButtonClicked(\'ViewContact\')" class="cursor-pointer nohover w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom">View Contact<i class="fa fa-search pl-5px fs-12px"></i></span></a></div></div></div><div class="col-md-6 col-sm-6 mb-5px"><span class="report_span_title">Modality:</span> <span class="report_span" ng-if="DataObject.selectedOrder.Modality">{{DataObject.selectedOrder.Modality}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.Modality">NA</span></div><div class="col-md-6 col-sm-6 mb-5px"><span class="report_span_title">Accession:</span> <span class="report_span text-uppercase" title="{{DataObject.selectedOrder.Accession}}" ng-if="DataObject.selectedOrder.Accession">{{DataObject.selectedOrder.Accession}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.Accession">NA</span></div><div class="col-md-6 col-sm-6 pr-0 mb-5px"><span class="report_span_title">Procedure Desc:</span> <span class="report_span proc-txt" title="{{DataObject.selectedOrder.ProcedureDesc}}" ng-if="DataObject.selectedOrder.ProcedureDesc">{{DataObject.selectedOrder.ProcedureDesc}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.ProcedureDesc">NA</span></div><div class="col-md-6 col-sm-6 mb-5px"><span class="report_span_title">DOS:</span> <span class="report_span" ng-if="DataObject.selectedOrder.OrderDate">{{DataObject.selectedOrder.OrderDate}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.OrderDate">NA</span></div><div class="col-md-6 col-sm-6 mb-5px"><span class="report_span_title">wRVU:</span> <span class="report_span" ng-if="DataObject.selectedOrder.WorkRVU">{{DataObject.selectedOrder.WorkRVU}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.WorkRVU">NA</span></div><div class="col-md-6 col-sm-6 mb-5px"><span class="report_span_title">Pending Since:</span> <span class="report_span proc-txt" title="{{DataObject.selectedOrder.ReceivedSince}}" ng-if="(DataObject.selectedOrder.Status != \'C\' && DataObject.selectedOrder.Status != \'PA\') && DataObject.selectedOrder.ReceivedSince">{{DataObject.selectedOrder.ReceivedSince}}</span> <span class="report_span" ng-if="(DataObject.selectedOrder.Status == \'C\' || DataObject.selectedOrder.Status == \'PA\') || !DataObject.selectedOrder.ReceivedSince">NA</span></div><div class="col-md-6 col-sm-6 pr-0 mb-5px"><span class="report_span_title">Reason:</span> <span class="report_span reason-txt" title="{{DataObject.selectedOrder.Reason}}" ng-if="DataObject.selectedOrder.Reason">{{DataObject.selectedOrder.Reason}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.Reason">NA</span></div><div class="col-md-6 col-sm-6 mb-5px"><span class="report_span_title">Status:</span> <span class="report_span reason-txt" title="{{DataObject.selectedOrder.OrderStatus}}" ng-if="DataObject.selectedOrder.OrderStatus">{{DataObject.selectedOrder.OrderStatus}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.OrderStatus">NA</span></div><div class="col-md-6 col-sm-6 pr-0 mb-5px pos-rel"><span class="report_span_title">Tag:</span> <span ng-if="DataObject.selectedOrder.ExamTagKey || (DataObject.selectedOrder.RadExamTagKeys && DataObject.selectedOrder.RadExamTagKeys.length > 0)"><span title="{{DataObject.selectedOrder.ExamTagKey}}" ng-if="DataObject.selectedOrder.ExamTagKey" ng-class="{\'exam-tag-group more-tags\' : DataObject.selectedOrder.RadExamTagKeys.length > 0}"><span class="report_span exam-tag">{{DataObject.selectedOrder.ExamTagKey}}</span></span> <span class="exam-tag-group" title="{{DataObject.selectedOrder.RadExamTagKeys[0]}}" ng-if="!DataObject.selectedOrder.ExamTagKey && DataObject.selectedOrder.RadExamTagKeys" ng-class="{\'exam-tag-group more-tags\' : DataObject.selectedOrder.RadExamTagKeys.length > 0}"><span class="exam-tag mr-1">{{DataObject.selectedOrder.RadExamTagKeys[0]}}</span></span></span> <span class="report_span" ng-if="!DataObject.selectedOrder.ExamTagKey && (!DataObject.selectedOrder.RadExamTagKeys || DataObject.selectedOrder.RadExamTagKeys.length == 0)">NA</span><div class="d-inline txt-clr-15"><div class="hovIcon-td d-inline" ng-if="DataObject.selectedOrder.ExamTagKey ? DataObject.selectedOrder.RadExamTagKeys.length > 0 : DataObject.selectedOrder.RadExamTagKeys.length > 1"><span class="report_span txt-clr-1" ng-if="DataObject.selectedOrder.ExamTagKey ? (DataObject.selectedOrder.RadExamTagKeys && DataObject.selectedOrder.RadExamTagKeys.length > 0):(DataObject.selectedOrder.RadExamTagKeys && DataObject.selectedOrder.RadExamTagKeys.length > 1)"><span class="custom-ellipsis">...</span></span><div class="iconDropdown bg-clr-30 cursor-pointer sm-pl w-200px new-ui-context phy-con px-10px py-5px" style="top: 25px; right: 0; left: unset; z-index: 9;"><div class="d-flex flex-wrap"><span ng-repeat="RadExamTag in DataObject.selectedOrder.RadExamTagKeys" ng-if="DataObject.selectedOrder.ExamTagKey && DataObject.selectedOrder.RadExamTagKeys" class="exam-tag m-1">{{RadExamTag}}</span> <span ng-repeat="RadExamTag in DataObject.selectedOrder.RadExamTagKeys.slice(1)" ng-if="!DataObject.selectedOrder.ExamTagKey && DataObject.selectedOrder.RadExamTagKeys" class="exam-tag m-1">{{RadExamTag}}</span></div></div></div></div></div><div class="col-md-6 col-sm-6 pr-0 mb-5px"><span class="report_span_title">Type/Priority:</span> <span class="report_span priority-badge" ng-class="{\'stat-priority-badge\' : DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'STAT\') || DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'HIGH\')}" ng-if="DataObject.selectedOrder.PatientClass==\'E\'" title="Emergency / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}">Emergency / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}</span> <span class="report_span priority-badge" ng-class="{\'stat-priority-badge\' : DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'STAT\') || DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'HIGH\')}" ng-if="DataObject.selectedOrder.PatientClass==\'I\'" title="Inpatient / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}">Inpatient / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}</span> <span class="report_span priority-badge" ng-class="{\'stat-priority-badge\' : DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'STAT\') || DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'HIGH\')}" ng-if="DataObject.selectedOrder.PatientClass==\'O\'" title="Outpatient / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}">Outpatient / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}</span> <span class="report_span priority-badge" ng-class="{\'stat-priority-badge\' : DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'STAT\') || DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'HIGH\')}" ng-if="DataObject.selectedOrder.PatientClass==\'P\'" title="PreAdmit / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}">PreAdmit / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}</span> <span class="report_span priority-badge" ng-class="{\'stat-priority-badge\' : DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'STAT\') || DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'HIGH\')}" ng-if="DataObject.selectedOrder.PatientClass==\'U\'" title="Unknown / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}">Unknown / {{DataObject.selectedOrder.Priority ? DataObject.selectedOrder.Priority : \'NA\'}}</span><span class="report_span priority-badge" ng-class="{\'stat-priority-badge\' :DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'STAT\') || DataObject.selectedOrder.Priority.toUpperCase().trim().includes(\'HIGH\')}" ng-if="DataObject.selectedOrder.Priority && !DataObject.selectedOrder.PatientClass" title="NA / {{DataObject.selectedOrder.Priority}}">NA / {{DataObject.selectedOrder.Priority}}</span> <span class="report_span priority-badge" ng-if="!DataObject.selectedOrder.PatientClass && !DataObject.selectedOrder.Priority">NA</span><div class="hovIcon-td d-inline" ng-if="DataObject.selectedOrder.ShowContactBtn && (DataObject.selectedOrder.PatientClass==\'E\' || DataObject.selectedOrder.PatientClass==\'U\' || DataObject.selectedOrder.PatientClass==\'O\')"><i class="fa fa-phone cursor-pointer pl-1 txt-clr-14" aria-hidden="true" ng-mouseover="ButtonClicked(\'GetTypeContactMessage\')"></i><div class="iconDropdown bg-clr-30 cursor-pointer new-ui-context sm-pl w-230px" style="top: 25px;" ng-if="DataObject.selectedOrder.TypeContactMessage"><div class="text-truncate text-left w-230px px-10px py-5px txt-clr-1"><span class="txt-clr-1" ng-bind-html="DataObject.selectedOrder.TypeContactMessage"></span></div></div></div></div><div class="col-md-6 col-sm-6 mb-5px"><span class="report_span_title">STAT Stroke:</span> <span class="report_span priority-badge" ng-class="{\'stat-priority-badge\' : DataObject.selectedOrder.IsSTATStroke}">{{DataObject.selectedOrder.IsSTATStroke ? \'YES\' : \'NO\'}}</span></div></div></div></div><div class="col-md-3 col-sm-3 pr-0 pl-5px mt-10px"><div class="groupbox pos-rel px-0"><label class="groupbox-label rf-label">Physician Info</label><div class="row m-0"><div class="col-md-12 pr-0 mb-5px"><span class="report_span_title">Ordering:</span> <span class="report_span pr-1" title="{{DataObject.selectedOrder.OrderingPhysician}}" ng-if="DataObject.selectedOrder.OrderingPhysician">{{DataObject.selectedOrder.OrderingPhysician}}</span> <span class="report_span" ng-if="!DataObject.selectedOrder.OrderingPhysician">NA</span><div class="d-inline txt-clr-15"><div class="hovIcon-td d-inline" ng-if="DataObject.selectedOrder.OrderingPhysician && (DataObject.selectedOrder.OrderingPhysicianPhone || DataObject.selectedOrder.OrderingPhysicianCellPhone)"><i class="fa fa-phone cursor-pointer txt-clr-14" aria-hidden="true"></i><div class="iconDropdown bg-clr-30 cursor-pointer sm-pl w-200px new-ui-context phy-con px-10px py-5px" style="top: 25px; right: -50px; left: unset; z-index: 9;"><div class="text-truncate text-left w-200px pb-5px txt-clr-1" ng-if="DataObject.selectedOrder.OrderingPhysicianPhone"><span class="fs-12px fw-600 txt-clr-ccc">Contact:</span> <span class="fs-12px txt-clr-15">{{DataObject.selectedOrder.OrderingPhysicianPhone}}</span></div><div class="text-truncate text-left w-200px txt-clr-1" ng-if="DataObject.selectedOrder.OrderingPhysicianCellPhone"><span class="fs-12px fw-600 txt-clr-ccc">Cell Phone:</span> <span class="fs-12px txt-clr-15">{{DataObject.selectedOrder.OrderingPhysicianCellPhone}}</span></div></div></div><div class="tooltip-w-100px d-inline pos-rel" ng-if="!DataObject.selectedOrder.OrderingPhysicianPhone && !DataObject.selectedOrder.OrderingPhysicianCellPhone && DataObject.selectedOrder.OrderingPhysician && DataObject.selectedOrder.ShowContactBtn" ng-mouseover="showContactDivOnHover = true" ng-mouseleave="showContactDivOnHover = false"><i class="fa fa-phone cursor-pointer txt-clr-14" aria-hidden="true"></i><div class="cursor-pointer sm-pl d-block pos-abs bg-clr-30 w-150px px-5px py-2 new-ui-context search-con" style="text-align: center; top: 20px !important; right: -20px; z-index: 9;" ng-show="showContactDivOnHover"><a ng-click="ButtonClicked(\'showContact\')" class="cursor-pointer nohover w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom">Search Contact <i class="fa fa-search fs-12px pl-1"></i></span></a></div></div></div></div><div class="col-md-12 pr-0 mb-5px"><span class="report_span_title">Rendering:</span> <span class="report_span text-breakword proc-txt pr-1" title="{{DataObject.selectedOrder.SignByName}}" ng-if="(!DataObject.RemoveRenderingPhysician) && (DataObject.selectedOrder.SignByName)">{{DataObject.selectedOrder.SignByName}}</span> <span class="report_span" ng-if="(DataObject.RemoveRenderingPhysician) || (!DataObject.selectedOrder.SignByName)">NA</span><div class="d-inline txt-clr-15"><div class="hovIcon-td d-inline" ng-if="(!DataObject.RemoveRenderingPhysician) && (DataObject.selectedOrder.SignByName && (DataObject.selectedOrder.RenderingPhysicianPhone || DataObject.selectedOrder.RenderingPhysicianEmail))"><i class="fa fa-phone cursor-pointer txt-clr-14" aria-hidden="true"></i><div class="iconDropdown bg-clr-30 cursor-pointer sm-pl w-250px new-ui-context phy-con px-10px py-5px" style="top: 25px !important; left:unset; right: -40px;"><div class="text-truncate text-left w-250px pb-5px txt-clr-1" ng-if="DataObject.selectedOrder.RenderingPhysicianPhone"><span class="fs-12px fw-600 txt-clr-ccc">Contact:</span> <span class="fs-12px txt-clr-15">{{DataObject.selectedOrder.RenderingPhysicianPhone}}</span></div><div class="text-truncate text-left w-250px txt-clr-1" ng-if="DataObject.selectedOrder.RenderingPhysicianEmail"><span class="fs-12px fw-600 txt-clr-ccc">Email:</span> <span class="fs-12px txt-clr-15">{{DataObject.selectedOrder.RenderingPhysicianEmail}}</span></div></div></div></div></div><div class="col-md-12 mb-5px"><span class="report_span_title">Report Date:</span> <span class="report_span text-breakword" ng-if="DataObject.selectedOrder.ReportSignDate && !DataObject.selectedOrder.DontShowReportData" title="{{DataObject.selectedOrder.ReportSignDate}}">{{DataObject.selectedOrder.ReportSignDate}}</span> <span class="report_span" ng-if="DataObject.selectedOrder.DontShowReportData || !DataObject.selectedOrder.ReportSignDate">NA</span></div><div class="col-md-12 mb-5px"><span class="report_span_title">Report Status:</span> <span class="report_span proc-txt text-breakword" ng-if="DataObject.selectedOrder.ReportStatus && DataObject.selectedOrder.ReportStatus % 1 !== 0 && !DataObject.selectedOrder.DontShowReportData" title="{{splitCamelCase(DataObject.selectedOrder.ReportStatus)}}">{{splitCamelCase(DataObject.selectedOrder.ReportStatus)}}</span> <span class="report_span proc-txt text-breakword" ng-if="DataObject.selectedOrder.ReportStatus % 1 === 0 && DataObject.selectedOrder.OrderReportStatus && !DataObject.selectedOrder.DontShowReportData" title="{{splitCamelCase(DataObject.selectedOrder.OrderReportStatus)}}">{{splitCamelCase(DataObject.selectedOrder.OrderReportStatus)}}</span> <span class="report_span" ng-if="DataObject.selectedOrder.DontShowReportData || (!DataObject.selectedOrder.ReportStatus && !DataObject.selectedOrder.OrderReportStatus) || (DataObject.selectedOrder.ReportStatus % 1 === 0 && !DataObject.selectedOrder.OrderReportStatus)">NA</span></div></div></div></div></div><div class="mb-5px"><button type="button" ng-show="OrderDiscussion.ID && (ODType==\'Assigner\' || ODType==\'Helper\')" class="btn btn-default pull-right" ng-click="CloseOrderDiscussion()">Close Discussion</button></div></div>');
$templateCache.put('app/theme/components/payment-contract-summary/payment-contract-summary.html','<style>\r\n    .chart-grid-box {\r\n        overflow-y: auto;\r\n        height: calc(100vh - 368px);\r\n    }\r\n\r\n    .stat-card {\r\n        background-color: #323232;\r\n        padding: 5px;\r\n        border-radius: 5px;\r\n    }\r\n\r\n        .stat-card .ag-chart-wrapper .ag-chart-dark-overlay div {\r\n            color: #fff !important;\r\n            font-size: 20px !important;\r\n            font-family: "Open Sans", sans-serif !important;\r\n        }\r\n\r\n    ::-webkit-scrollbar-track {\r\n        border-radius: 10px;\r\n        background-color: transparent;\r\n    }\r\n\r\n    ::-webkit-scrollbar {\r\n        width: 8px;\r\n        background-color: transparent;\r\n    }\r\n\r\n    ::-webkit-scrollbar-thumb {\r\n        border-radius: 10px;\r\n        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\r\n        background-color: #323232;\r\n    }\r\n\r\n    .tippy-ttwrapper {\r\n        pointer-events: none;\r\n    }\r\n\r\n        .tippy-ttwrapper .fa.fa-comments.green {\r\n            pointer-events: all;\r\n        }\r\n\r\n    .spinner-overlay .spinner-overlay-body {\r\n        width: 100%;\r\n        height: 100%;\r\n        background-color: black;\r\n        opacity: 0.7;\r\n    }\r\n\r\n    @media only screen and (max-width: 1199px) {\r\n        .chart-grid-box {\r\n            /*height: calc(100vh - 410px) !important;*/\r\n            height: calc(100vh - 470px) !important;\r\n        }\r\n    }\r\n</style><div class="row chart-grid-box"><div class="col-md-6 mt-10px col-sm-12"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Payment Summary</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-class="{\'active\':DataObject.activeSummaryTab==\'Grid\'}"><a data-toggle="tab" ng-click="DataObject.activeSummaryTab=\'Grid\'">Data</a></li><li class="mob-flaot-none mob-text-center" ng-class="{\'active\':DataObject.activeSummaryTab==\'Chart\'}"><a data-toggle="tab" ng-click="DataObject.activeSummaryTab=\'Chart\'">Chart</a></li><i class="fa fa-download fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" title="Export Data" ng-click="ExportPaymentSummaryData()"></i> <i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PaymentSummaryChart\',\'PaymentSummaryChartOptions\',\'area\')" title="Area Chart" ng-show="DataObject.activeSummaryTab==\'Chart\'"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PaymentSummaryChart\',\'PaymentSummaryChartOptions\',\'bar\')" title="Bar Chart" ng-show="DataObject.activeSummaryTab==\'Chart\'"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'PaymentSummaryChart\',\'PaymentSummaryChartOptions\',\'line\')" title="Line chart" ng-show="DataObject.activeSummaryTab==\'Chart\'"></i></ul><div id="{{$ctrl.summaryGridId}}" class="myGrid ag-theme-balham-dark" style="height: 500px; width: 100%" ng-show="DataObject.activeSummaryTab==\'Grid\'"></div><div id="PaymentSummaryChart" class="stat-card" style="height: 500px;" ng-show="DataObject.activeSummaryTab==\'Chart\'"></div></div></div></div><div class="col-md-6 mt-10px col-sm-12"><div class="stat-card"><p class="txt-clr-1 px-10px py-5px mb-0 text-center fs-15px" style="background-color: #424242;">Invoice Details</p><div class="px-5px pt-3px pb-5px"><ul class="nav nav-tabs no-bg mt-4px"><li class="mob-flaot-none mob-text-center" ng-class="{\'active\':DataObject.InvoicePaymentTab==\'Grid\'}"><a data-toggle="tab" ng-click="DataObject.InvoicePaymentTab=\'Grid\'">Data</a></li><li class="mob-flaot-none mob-text-center" ng-class="{\'active\':DataObject.InvoicePaymentTab==\'Chart\'}"><a data-toggle="tab" ng-click="DataObject.InvoicePaymentTab=\'Chart\'">Chart</a></li><i class="fa fa-area-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'InvoicePaymentChart\',\'InvoicePaymentChartOptions\',\'area\')" title="Area Chart" ng-show="DataObject.InvoicePaymentTab==\'Chart\'"></i> <i class="fa fa-bar-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'InvoicePaymentChart\',\'InvoicePaymentChartOptions\',\'bar\')" title="Bar Chart" ng-show="DataObject.InvoicePaymentTab==\'Chart\'"></i> <i class="fa fa-line-chart fs-14px pt-2px txt-clr-14 float-right mr-7px cursor-pointer" aria-hidden="true" ng-click="convertChartType(\'InvoicePaymentChart\',\'InvoicePaymentChartOptions\',\'line\')" title="Line chart" ng-show="DataObject.InvoicePaymentTab==\'Chart\'"></i></ul><div id="InvoicePaymentGrid" class="myGrid ag-theme-balham-dark" style="height: 500px; width: 100%" ng-show="DataObject.InvoicePaymentTab==\'Grid\'"></div><div id="InvoicePaymentChart" class="stat-card" style="height: 500px;" ng-show="DataObject.InvoicePaymentTab==\'Chart\'"></div></div></div></div></div><div ng-show="DataObject.isDataLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div>');
$templateCache.put('app/theme/components/payment-dash-board/payment-dash-board.html','<style>\r\n    .blc-card {\r\n        background-color: #323232;\r\n        border-radius: 5px;\r\n        padding: 10px;\r\n        border-bottom: 1px solid #01bfa3;\r\n    }\r\n    .blc-card::before {\r\n        content: \'\';\r\n        width: 3px;\r\n        height: 20px;\r\n        background: #01bfa3;\r\n        position: absolute;\r\n        top: 10px;\r\n        left: 0;\r\n    }\r\n    .modal .modal-dialog.w-50.create-inv-modal {\r\n        transform: translate(0, 0) !important;\r\n        margin-top: 4px !important;\r\n        /*width: 99.6% !important;*/\r\n        width: 45% !important;\r\n    }\r\n    .modal .modal-dialog.create-inv-modal .modal-body {\r\n        /*max-height: 890px;\r\n        overflow-y: auto;*/\r\n        padding: 5px;\r\n    }\r\n        .modal .modal-dialog.create-inv-modal .modal-body .dash-invpdf {\r\n            max-height: 700px;\r\n            overflow-y: auto;\r\n        }\r\n    .ag-ltr .ag-body-horizontal-scroll, .ag-ltr .ag-body-vertical-scroll {\r\n        background: #000 !important;\r\n    }\r\n\r\n    ::-webkit-scrollbar-thumb {\r\n        background-color: #c0c0c0 !important;\r\n    }\r\n    .page-content {\r\n        /* margin-left: 180px;  Same as the width of the .PaymentContractDashboardMenu */\r\n        font-size: 28px; /* Increased text to enable scrolling */\r\n        padding: 0px 10px;\r\n        margin-top: 14px;\r\n    }\r\n    @media only screen and (min-width: 767px) and (max-width: 1199px) {\r\n        .blc-card {\r\n            margin-bottom: 15px;\r\n        }\r\n        .modal .modal-dialog.w-50.create-inv-modal {\r\n            width: 90% !important;\r\n        }\r\n    }\r\n    @media only screen and (min-width: 1200px) and (max-width: 1899px) {\r\n        .modal .modal-dialog.w-50.create-inv-modal {\r\n            width: 70% !important;\r\n        }\r\n    }\r\n    @media (min-width: 768px) and (min-height: 1080px) and (orientation: portrait) {\r\n        \r\n        .modal .modal-dialog.w-50.create-inv-modal {\r\n            width: 81% !important;\r\n        }\r\n        .modal .modal-dialog.create-inv-modal .modal-body {\r\n            max-height: 1300px;\r\n        }\r\n    }\r\n</style><div class="row m-0"><div class="col-md-12"><h1 class="txt-clr-1 fs-24px">Payment Dashboard</h1></div></div><div class="row m-0"><div class="col-md-12 txt-clr-1"><user-payment-contract-detail user-id="DataObject.userData.userId" get-user-payment-contract="getUserPaymentContract(PaymentContractType)"></user-payment-contract-detail></div></div><div class="row mx-0 mb-25px"><div class="col-md-3 col-sm-4"><label class="txt-clr-1 fw-400">Date Range</label> <input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="Select Date Range" ng-model="DataObject.SelectedDate" options="DOSopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{DataObject.SelectedDateTooltip}}" tooltip-placement="auto top"></div></div><div class="row d-flex flex-wrap mx-0 mb-15px"><div class="col-md-3 col-sm-6 txt-clr-1"><div class="blc-card pos-rel"><label class="fw-600">Total Earning</label> <span class="page-content">${{DataObject.TotalEarnings}}</span></div></div><div class="col-md-3 col-sm-6 txt-clr-1"><div class="blc-card pos-rel"><label class="d-flex justify-content-between"><label class="fw-600">Remaining Balance</label> <button class="btn btn-transparent txt-clr-14 py-0 btn-sm fs-13px fw-600" title="Create Invoice" ng-click="createInvoice()" ng-if="!(DataObject.TotalRemainingBalance == 0.00)"><i class="fa fa-plus pr-3px"></i> Invoice</button></label> <span class="page-content">${{DataObject.TotalRemainingBalance}}</span></div></div><div class="col-md-3 col-sm-6 txt-clr-1"><div class="blc-card pos-rel"><label class="fw-600">Pending Invoice</label> <span class="page-content">${{DataObject.TotalPendingAmount}}</span></div></div><div class="col-md-3 col-sm-6 txt-clr-1"><div class="blc-card pos-rel"><label class="fw-600">Paid Invoice</label> <span class="page-content">${{DataObject.TotalPaidAmount}}</span></div></div></div><div class="row mx-0"><div class="col-md-12"><div><contract-summary summary-grid-id="SmallInvoiceGrid" payment-summery="PaymentSummery" on-get-payment-summary="onGetPaymentSummary()" selected-date="DataObject.SelectedDate" on-payment-created="GetUserPaymentHeader()" on-invoice-deleted="GetUserPaymentHeader()" invoice-status-list="DataObject.InvoiceStatusList" get-invoice-payment-detail="GetInvoicePaymentDetail(InvoicePaymentList)"></contract-summary></div></div></div><div ng-show="DataObject.isDataLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="modal fade" id="paymentInvoicePdfModal" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog w-50 create-inv-modal"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="resetCreateInvoiceData()">&times;</button><h4 class="modal-title">Invoice Details</h4></div><div class="modal-body overflow-x-hide"><div class="pdf-view overflow-x-hide overflow-y-auto some-pdf-container" style="height: 600px;" ng-if="DataObject.InvoicePDFUrl"><pdf-viewer file-url="DataObject.InvoicePDFUrl" file-binary-content="DataObject.InvoicePDF.FileContent"></pdf-viewer></div><div class="row mb-15px px-20px mt-10px d-none"><div class="col-md-12"><label class="txt-clr-1">Notes:</label> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="DataObject.CreateInvoiceNotes" placeholder="Add a Note"> </textarea></div></div><div class="d-flex justify-content-end pt-10px mb-10px"><button class="btn btn-default btn-sm mr-10px" data-dismiss="modal" ng-click="resetCreateInvoiceData()">Close</button> <button class="btn btn-primary btn-sm d-none" ng-click="createInvoice()" ng-disabled="DataObject.isSaveBtnDisable">Create</button></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/payment-invoice/payment-invoice.html','<style>\r\n    .hideHeaderTxt .ag-header-cell-comp-wrapper .ag-header-cell-label .ag-header-cell-text {\r\n        display: none;\r\n    }\r\n\r\n    .ag-overlay {\r\n        background: rgba(0, 0,0, 0.8) !important;\r\n    }\r\n\r\n    .ag-overlay-loading-center {\r\n        padding: 10px !important;\r\n        background: transparent !important;\r\n    }\r\n\r\n    .modal .modal-dialog .modal-body .form-control.blk-input.form-control.border-color-red,\r\n    .modal .modal-dialog .modal-body .form-control.blk-input.form-control.border-color-red:focus {\r\n        border-color: red !important;\r\n    }\r\n     .modal .modal-dialog.w-50.create-inv-modal {\r\n        transform: translate(0, 0) !important;\r\n        margin-top: 4px !important;\r\n        /*width: 99.6% !important;*/\r\n    }\r\n    .modal .modal-dialog.create-inv-modal .modal-body {\r\n        max-height: 890px;\r\n        overflow-y: auto;\r\n        padding: 5px;\r\n    }\r\n    .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #424242 !important;\r\n    }\r\n    .custom-payinvest-grid {\r\n        height: calc(100vh - 113px);\r\n    }\r\n    .custom-payinvest-grid.cust-payinvest-site {\r\n        height: calc(100vh - 140px);\r\n    }\r\n    .tippy-ttwrapper {\r\n        pointer-events: none;\r\n    }\r\n    .tippy-ttwrapper .fa.fa-comments.green {\r\n        pointer-events: all;\r\n    }\r\n    @media only screen and (min-width: 767px) and (max-width: 1199px) {\r\n        .modal .modal-dialog.w-50.create-inv-modal {\r\n            width: 91% !important;\r\n        }\r\n    }\r\n    @media only screen and (min-width: 1200px) and (max-width: 1199px) {\r\n        .modal .modal-dialog.w-50.create-inv-modal {\r\n            width: 71% !important\r\n        }\r\n    }\r\n    @media only screen and (min-width: 1200px) and (max-width: 1650px) {\r\n        .modal .modal-dialog.w-50.create-inv-modal {\r\n            width: 70% !important\r\n        }\r\n        .col-lg-6.forpayinv-box {\r\n            width: 100%;\r\n        }\r\n    }\r\n    @media (min-width: 768px) and (min-height: 1080px) and (orientation: portrait) {\r\n        .modal .modal-dialog.w-50.create-inv-modal {\r\n            width: 78% !important;\r\n        }\r\n    }\r\n</style><div id="rightContentSection"><div class=""><form ng-submit="Filter()" name="InvoiveFilterForm"><div class="row rf-filter-ui m-0 pt-8px filterspace"><div class="col-md-3 col-sm-4 pd-lr tultip-bottom"><multi-select master-data="DataObject.Filter.UserFilterMultiSelect" list="DataObject.RadiologistsList" ng-model="DataObject.Filter.UserFilterMultiSelect.SelectedValue" on-change="DataObject.Filter.UserFilterMultiSelect.onSelectUser(selectedData)" on-add-tag="onRadiologistFilterSelect()" on-remove-tag="onRadiologistFilterSelect()" place-holder="Select Radiologists"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px wd-max-content max-w-180px" tooltip-class="uibtooltipDenial" style="z-index: 999; top: 60px !important;" tooltip-placement="auto bottom">{{DataObject.RadiologistFilterTooltip}}</span></div><div class="col-md-2 col-sm-3 pd-lr"><label class="rf-label mb-2px cmn-check-label d-none">Date Range</label> <input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="Invoice Date" ng-model="DataObject.Filter.OrderDate" options="DataObject.Filter.Opts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial" uib-tooltip="{{DataObject.Filter.OrderDateTooltip}}" tooltip-placement="auto top" ng-mouseenter="resetDateRange()"></div><div class="col-md-2 col-sm-3 pd-lr"><ui-select class="mult-select stbclr bg-clr-31" ng-model="DataObject.Filter.InvoiceStatus" title="Select Invoice Status" on-select="Filter()"><ui-select-match placeholder="Select Invoice Status" allow-clear="true">{{$select.selected.InvoiceStatus}}</ui-select-match><ui-select-choices repeat="list in DataObject.InvoiceStatusList | propsFilter: {InvoiceStatus: $select.search}" position="down"><div ng-bind-html="list.InvoiceStatus | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-2 col-sm-2 pd-lr"><button type="submit" class="btn btn-primary rf-btn-xs pull-left mr-5px" ng-disabled="false">Filter</button> <button type="button" ng-click="clearFilter();" class="btn btn-default rf-btn-xs pull-left mr-5px">Clear</button></div></div></form></div><div><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="DataObject.isDataLoading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div id="InvoiceAGGrid" class="myGrid ag-theme-balham-dark peerreview-grid custom-payinvest-grid stepmenupendingSub" ng-class="{\'cust-payinvest-site\': DataObject.Filter.UserFilterMultiSelect.SelectedValue.list.length > 0}" style="width: 100%;"></div></div></div><div id="ViewInvoiceModal" class="modal fade overflow-hide-all" role="dialog" data-backdrop="static"><div class="modal-dialog w-50 create-inv-modal"><div class="modal-content new-popup"><div class="modal-header d-flex align-item-center"><h4 class="modal-title">View Invoice</h4><span class="d-flex"><button class="btn btn-transparent fs-18px txt-clr-1 p-0 icon-hover" ng-click="clearModal()" data-dismiss="modal"><i class="fa fa-times close-expmodal" style="color: #fff !important"></i></button></span></div><div class="modal-body overflow-x-hide"><div class=""><div class="row m-0"><div class="col-md-12 mb-10px" id="ViewInvoicePDF" ng-if="!DataObject.ViewInvoice.InvoicePDF"></div><form name="FormPayInvoice" id="FormPayInvoice"><div class="col-lg-12 col-md-12 col-sm-12 mb-10px forpayinv-box"><div class="row" ng-if="DataObject.ViewInvoice.InvoicePDF"><div class="col-md-12" style="height: 80vh; margin-bottom: 10px;"><pdf-viewer file-binary-content="DataObject.ViewInvoice.InvoicePDF" file-url="DataObject.ViewInvoice.InvoicePDFUrl"></pdf-viewer></div></div><div class="row"><div class="col-md-12"><div class="form-group my-10px"><label class="rf-label">Notes<span ng-if="DataObject.ViewInvoice.isNotes">*</span>:</label> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="DataObject.ViewInvoice.Notes" placeholder="Add a Note" ng-class="{\'border-color-red\':(DataObject.ViewInvoice.isNotes)}"> </textarea></div></div></div><div class="row mb-5px"><div class="col-md-12 d-flex align-item-center"><button type="button" ng-click="SaveInvoiceStatus(\'Approved\')" class="btn btn-primary rf-btn-xs pull-left mr-5px" ng-disabled="DataObject.DisableBtn.Approve">Approve</button> <button type="button" ng-click="SaveInvoiceStatus(\'Rejected\')" class="btn btn-primary rf-btn-xs pull-left mr-5px" ng-disabled="DataObject.DisableBtn.Reject">Reject</button></div></div><div class="row" ng-if="DataObject.ViewInvoice.isNotes"><div class="col-md-12"><label class="txt-clr-6 fs-13px fw-600" style="color:red !important;">Please fill mandatory fields</label></div></div></div></form></div></div></div></div></div></div><div class="modal fade" id="createPaymentModal" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog w-50 create-inv-modal"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Create Payment</h4></div><div class="modal-body"><div class=""><div class="row m-0"><div class="col-md-12 mb-10px" id="PayInvoicePDF" ng-if="!DataObject.createPayment.InvoicePDF"></div><form name="FormPayInvoice" id="FormPayInvoice"><div class="col-lg-12 col-md-12 col-sm-12 mb-10px forpayinv-box"><div class="row" ng-if="DataObject.createPayment.InvoicePDF"><div class="col-md-12" style="height: 80vh; margin-bottom: 10px;"><pdf-viewer file-binary-content="DataObject.createPayment.InvoicePDF" file-url="DataObject.createPayment.InvoicePDFUrl"></pdf-viewer></div></div><div class="row"><div class="col-md-6 mb-10px"><label class="rf-label">Pay Amount <span class="fw-600">($)</span> *:</label> <input type="text" name="Pay" id="Pay" ng-model="DataObject.createPayment.InvoiceAmount" class="blk-input form-control" ng-pattern="/^\\d*\\.?(?:\\d{1,2})?$/" ng-class="{\'border-color-red\': (FormPayInvoice.Pay.$touched && FormPayInvoice.Pay.$invalid)}" ng-disabled="true"></div><div class="col-md-6 mb-10px d-none"><label class="rf-label">Adjustment Amount <span class="fw-600">($)</span>:</label> <input type="text" name="Adjustments" id="Adjustments" ng-model="DataObject.createPayment.AdjustedAmount" class="blk-input form-control" ng-pattern="/^\\d*\\.?(?:\\d{1,2})?$/" ng-class="{\'border-color-red\': (FormPayInvoice.Adjustments.$touched && FormPayInvoice.Adjustments.$invalid)}"></div><div class="col-md-6 mb-10px"><label class="rf-label">Paid Via <span>*</span>:</label><ui-select class="mult-select stbclr bg-clr-31" ng-model="DataObject.createPayment.InvoicePaymentMethod" title="Select Invoice Payment Method" ng-class="{\'border-color-red\':(DataObject.ViewInvoice.isPaidVia)}"><ui-select-match placeholder="Select Invoice Payment Method">{{$select.selected.PaymentMethod}}</ui-select-match><ui-select-choices repeat="list in DataObject.createPayment.PaymentMethodOptions | propsFilter: {PaymentMethod: $select.search}" position="down"><div ng-bind-html="list.PaymentMethod | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-12"><div class="form-group my-10px"><label class="rf-label">Notes:</label> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="DataObject.createPayment.Notes" placeholder="Add a Note" ng-class="{\'border-color-red\':(DataObject.ViewInvoice.isNotes)}"> </textarea></div></div></div><div class="row mb-5px"><div class="col-md-12 d-flex align-item-center"><button type="button" ng-click="SetInvoicePayment(DataObject.createPayment)" class="btn btn-primary rf-btn-xs pull-left mr-5px" ng-disabled="DataObject.DisableBtn.Pay || FormPayInvoice.$invalid">Pay</button></div></div></div></form></div></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/payment-invoice-history/payment-invoice-history.html','<style>\r\n    .pl-0 { padding-left: 0 !important;}\r\n    .ag-row-group.ag-row-group-contracted {\r\n        /*background-color: #343c3e;*/\r\n        background-color: #202324;\r\n        border-bottom-color: #3c3c3c;\r\n    }\r\n    .ag-row-group.ag-row-group-expanded {\r\n        /*background-color: #2d3436;*/\r\n        background-color: #262c2e;\r\n    }\r\n    .ag-row-group-expanded .ag-cell {\r\n        font-weight: 700 !important;\r\n        font-size: 14px !important;\r\n    }\r\n    .ag-row-group-contracted .ag-cell {\r\n        font-weight: 400 !important;\r\n        font-size: 12px !important;\r\n    }\r\n    .ag-header-cell-text {\r\n        font-size: 13px;\r\n    }\r\n    .ag-header {\r\n        background-color:#1c1c1c;\r\n    }\r\n    .invoicesum-grid, .invoicetrans-grid {\r\n        height: calc(100vh - 144px);\r\n    }\r\n    .invgrid-headeing {\r\n        background-color: #424242;\r\n        border-top-left-radius: 3px;\r\n        border-top-right-radius: 3px;\r\n    }\r\n    .invoicesum-grid .ag-floating-bottom-viewport .ag-cell,\r\n    .invoicetrans-grid .ag-floating-bottom-viewport .ag-cell {\r\n        font-size: 14px !important;\r\n        font-weight: 700 !important;\r\n    }\r\n</style><div class="row m-0"><div class="col-lg-3 col-md-3 col-sm-3 py-10px d-flex align-item-center"><label class="rf-label m-0">Period:</label><ui-select class="mult-select stbclr bg-clr-31 w-100 ml-5px" ng-model="DataObject.UserInvoice.SelectedFileName" title="Select Invoice" on-select="OnFileNameSelected()"><ui-select-match placeholder="Select Invoice" allow-clear="false">{{$select.selected.FileName}} - Total wRVU({{$select.selected.TotalWorkRVU}})</ui-select-match><ui-select-choices repeat="list in DataObject.UserInvoice.InvoiceList | propsFilter: {FileName: $select.search}" position="down"><div ng-bind-html="(list.FileName+ \' - Total wRVU(\'+ list.TotalWorkRVU+\')\') | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-3 col-md-3 col-sm-3 py-10px d-flex align-item-center"><label class="rf-label m-0">Payment Account:</label><ui-select class="mult-select stbclr bg-clr-31 w-100 ml-5px" ng-model="DataObject.PaymentAccount.Selected" title="Select Payment Account" on-select="OnPaymentAccountSelected()"><ui-select-match placeholder="Select Payment Account" allow-clear="true">{{$select.selected}}</ui-select-match><ui-select-choices repeat="option in DataObject.PaymentAccount.Options | filter: $select.search" position="down"><div ng-bind-html="option | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-2 col-sm-2 py-10px d-flex align-item-center"><button type="button" class="btn btn-primary" ng-disabled="!DataObject.CanDownloadInvoice" ng-click="OnDownloadInvoiceClicked()">Download PDF</button></div></div><div class="d-flex row m-0"><div class="col-lg-6 col-md-6 col-sm-6 p-10px"><h2 class="fs-15px mb-5px fw-500 txt-clr-1 px-10px py-5px mb-0 text-center invgrid-headeing">Summary</h2><div id="InvoiceSummaryAGGrid" class="myGrid text-white ag-theme-balham-dark stepmenupendingSub invoicesum-grid w-100"></div></div><div class="col-lg-6 col-md-6 col-sm-6 p-10px pl-0"><h2 class="fs-15px mb-5px fw-500 txt-clr-1 px-10px py-5px mb-0 text-center invgrid-headeing">Transactions</h2><div id="InvoiceTransactionAGGrid" class="myGrid text-white ag-theme-balham-dark stepmenupendingSub invoicetrans-grid w-100"></div></div></div><div class="modal fade" id="NoInvoiceFoundModal" tabindex="-1" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title txt-clr-1">No Invoice PDF Found</h4></div><div class="modal-body"><p class="txt-clr-1">No invoice PDF was found for this selection.</p><p ng-if="DataObject.NoInvoiceFound.ErrorMessage" class="txt-clr-6">{{DataObject.NoInvoiceFound.ErrorMessage}}</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="OnGenerateInvoiceClicked()">Generate PDF</button> <button type="button" class="btn btn-default" ng-click="OnDownloadAllInvoicesClicked()">Download all available PDFs for this period</button> <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button></div></div></div></div>');
$templateCache.put('app/theme/components/pdf-viewer/pdf-viewer.html','<div id="pdfViewer"></div>');
$templateCache.put('app/theme/components/procedure-cpt-mapping/procedure-cpt-mapping.html','<style>\r\n    .ag-cell{\r\n        color:white !important;\r\n    }\r\n</style><div class="h-650px"><div class="row mx-0"><div class="col-md-6 col-sm-6 px-10px float-left"><div><form id="searchProcForm"><div class="d-flex pos-rel mb-10px"><input type="text" placeholder="Search Procedure" class="form-control col-placeholder" ng-model="ProcSearchKey"> <button type="reset" class="pos-abs no-bg border-0 abs-b-0 cursor-pointer p-5px-all fs-17px" style="right:50px" ng-click="clearProcSearch()" title="Clear Procedure" ng-show="ProcSearchKey"><i class="fa fa-times"></i></button> <button type="submit" class="btn-default btn ml-10px" ng-click="GetProcedureList()" title="Search Procedure"><i class="fa fa-search"></i></button></div></form></div><div id="ProcGrid" class="ag-theme-balham-dark w-100 h-500px"></div></div><div class="col-md-6 col-sm-6 px-10px float-left"><div><form id="searchCPTForm"><div class="d-flex pos-rel mb-10px"><input type="text" placeholder="Search CPT" class="form-control col-placeholder" ng-model="CPTSearchKey"> <button type="reset" class="pos-abs no-bg border-0 abs-b-0 cursor-pointer p-5px-all fs-17px" style="right:50px" ng-click="clearCPTSearch()" title="Clear CPT" ng-show="CPTSearchKey"><i class="fa fa-times"></i></button> <button type="submit" class="btn-default btn ml-10px" ng-click="GetCPTList()" title="Search CPT"><i class="fa fa-search"></i></button></div></form></div><div id="CPTGrid" class="ag-theme-balham-dark w-100 h-500px"></div></div></div><div><form id="mapForm"><button class="btn btn-primary my-15px pull-right mr-15px" ng-click="SaveCPTProcedureMap()">Save</button></form></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/rad-location/rad-location.html','<style>\r\n    .loc-input.model-loc-input .k-multiselect-wrap.k-floatwrap {\r\n        max-height: 59px;\r\n        min-height: 31px;\r\n        height: 100% !important;\r\n    }\r\n\r\n    .loc-payment-input {\r\n        max-height: 61px !important;\r\n        min-height: 32px !important;\r\n        height: 100% !important;\r\n    }\r\n    .max-w-180px\r\n    {\r\n        max-width:180px;\r\n    }\r\n</style><input id="{{$ctrl.locationId}}" kendo-dropdowntree="{{$ctrl.locationId}}" k-options="kOptions" class="loc-input w-100 visb-close-icon" ng-class="$ctrl.locationId==\'locationPaymentContractTree\' || $ctrl.locationId==\'locationAddressBookModalTree\'?\'model-loc-input loc-payment-input\':\'\'"> <span id="{{$ctrl.locationId}}Tooltip" class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px wd-max-content max-w-180px abs-t-33-p" style="z-index:999;"></span>');
$templateCache.put('app/theme/components/radiologist-list-cmp/radiologist-list-cmp.html','<div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" aria-label="Close" ng-click="cancel(true)">&times;</button><h4 class="modal-title f-f-quicksand fs-15px">{{modalTitle}}</h4></div><div class="modal-body"><div class="w-100" style="border-bottom: 1px solid gray; margin-bottom: 5px" ng-if="siteTitle"><h4 class="fs-14px txt-clr-1 mb-5px fw-600">Site: {{siteTitle}}</h4></div><div class="w-100"><div class="row pb-2"><div class="col-md-4 col-sm-4"><input type="text" class="blk-input form-control" ng-model="search" placeholder="Search Radiologists" ng-keydown="$event.keyCode === 13 && filter()"></div><div class="col-md-4 px-0 tultip-bottom col-sm-4"><rad-location location-id="{{$ctrl.radioLogistCmpTooltipId}}Tree" location-search-text-id="{{$ctrl.radioLogistCmpTooltipId}}SearchText" options="MasterData.Sites" selected-values="SelectedSiteValues" on-update="updateLocationData()"></rad-location></div><div class="col-md-4 col-sm-4"><input type="button" ng-click="filter()" class="btn btn-primary py-1" value="Filter"> <input type="button" class="btn btn-default mx-1 rf-btn-xs" ng-click="cancel()" value="Clear"></div></div><div class="w-45 float-left"><label for="aclients" class="rf-label">Available Radiologists</label><select id="aclients" class="sing-select w-100 outline-none downArrow-ie" multiple="" ng-model="available" ng-options="Radiologist as Radiologist.LastName + \', \' + Radiologist.FirstName for Radiologist in Radiologists | orderBy:\'LastName\'" style="background-color: #1f1f1f !important; height:500px"></select></div><div class="w-10 float-left px-10px"><div class="h-100px">&nbsp;</div><div class=""><input id="moveright" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value=">" ng-click="moveItem(available, RadiologistsFullSet,selectedclientsFullSet)"></div><div class=""><input id="moverightall" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value=">>" ng-click="moveItem(Radiologists,RadiologistsFullSet,selectedclientsFullSet)"></div><div class=""><input id="move left" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value="<" ng-click="moveItem(selected, selectedclientsFullSet,RadiologistsFullSet)"></div><div class=""><input id="moveleftall" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value="<<" ng-click="moveItem(selectedclients,selectedclientsFullSet,RadiologistsFullSet)"></div></div><div class="w-45 float-left"><label for="sclients" class="rf-label">Selected Radiologists</label><select id="sclients" class="sing-select w-100 outline-none downArrow-ie" multiple="" ng-model="selected" ng-options="Radiologist as Radiologist.LastName + \', \' + Radiologist.FirstName for Radiologist in selectedclients | orderBy:\'LastName\'" style="background-color: #1f1f1f !important;height:500px;"></select></div><div class="clearfix"></div></div><div class="modal-footer border-0 py-10px pr-10px"><div class="form-actions"><button type="button" class="btn btn-primary" ng-click="Save()">{{btnText}}</button></div></div></div></div>');
$templateCache.put('app/theme/components/reading-provider/reading-provider.html','<style>\r\n    .readingProviderGrid .ag-theme-balham-dark .ag-popup-editor.ag-popup-child {\r\n        width: 20% !important;\r\n    }\r\n    .readingProviderGrid {\r\n        height: calc(100vh - 132px);\r\n    }\r\n    .readingProviderGrid.radprov-radoilo-grid {\r\n        height: calc(100vh - 157px);\r\n    }\r\n    @media only screen and (max-width: 850px) {\r\n        .readingProviderGrid .ag-theme-balham-dark .ag-popup-editor.ag-popup-child {\r\n            width: 25% !important;\r\n        }\r\n    }\r\n</style><div id="readingProviderFilterId" class="row mt-1 mx-0 p-2"><form><div class="col-md-3 col-xs-3 pl-0"><input type="text" class="blk-input form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="ReadingProviderName" placeholder="Enter Provider Name"></div><div class="col-md-2 col-xs-2 pl-0"><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="SelectedRadiologistType.Obj" on-select="SelectedType()"><ui-select-match placeholder="Select Type" allow-clear="false">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="type in RadiologistTypeList" position="down"><div ng-bind-html="type.label" |="" highlight:="" $select.search"=""></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr pl-0 px-0 pos-rel"><button type="button" class="pos-abs no-bg border-0 abs-r-0 abs-b-0 cursor-pointer p-5px-all fs-17px ng-scope" tooltip-class="uibtooltipDenial" uib-tooltip="Clear Selected" tooltip-placement="auto left" style="z-index: 1;" ng-click="clearSelectedReadingProvider()" ng-if="SelectedRadiologist.Obj && SelectedRadiologist.Obj.length > 0"><i class="fa fa-times"></i></button><ui-select class="mult-select provider-select seltype-drop mob-closekeypad" ng-model="SelectedRadiologist.Obj" multiple="" close-on-select="false" ng-disabled="SelectedRadiologistType.Obj.label==\'Unmapped\';" tooltip-class="uibtooltipDenial" uib-tooltip="{{ReadingProviderFilterTooltip}}" tooltip-placement="auto bottom" on-select="onReadingProviderFilterSelectRemove()" on-remove="onReadingProviderFilterSelectRemove()"><ui-select-match placeholder="Select Reading Provider" class="overflow-y-auto d-block overflow-x-hide" style="max-height:27px;" allow-clear="true">{{radDisplay($item)}}</ui-select-match><ui-select-choices repeat="list in UsersList" position="down" refresh="searchFilterProvider($select.search)" refresh-delay="500"><div ng-bind-html="radDisplay(list) | highlight: $select.search"></div><small><span ng-if="list.Email.length>0"><i class="fa fa-envelope"></i> {{list.Email}}<br></span> <span ng-if="list.PhoneNumber.length>0"><i class="fa fa-phone-square"></i> {{list.PhoneNumber}}</span></small></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><button type="submit" class="btn btn-primary mx-1 rf-btn-xs" ng-click="FilterReadingProvider()">Filter</button> <button type="reset" class="btn btn-default mx-1 rf-btn-xs" ng-click="clearFilter()">Clear</button></div><div class="col-md-1 col-xs-1 pl-0 pull-right" ng-if="SelectedRadiologistType.Obj.label==\'Unmapped\' || SelectedRadiologistType.Obj.label==\'All\';"><button class="btn btn-primary mx-1 rf-btn-xs pull-right" ng-click="MapMultipleUser()" ng-disabled="validateMapUsersBtn()">Map Users</button></div></form></div><div id="readingProviderGrid" class="readingProviderGrid ag-theme-balham-dark w-100" ng-class="{\'radprov-radoilo-grid\': SelectedRadiologist.Obj.length > 0}"></div><div ng-show="isLoadingReadingProvider" class="spinner-overlay" style="z-index: 80;"><div class="spinner-overlay-body"></div><div class="single4"></div></div>');
$templateCache.put('app/theme/components/report-viewer/report-viewer.html','<div class="w-100"><div ng-show="isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div><div class="row m-0 bg-clr-24 pt-10px pb-5px mob-report mob-d-flex mob-flex-wrap"><div class="col-sm-3"><div class="mb-5px"><span>Patient Name:</span> <span class="txt-clr-15">{{report.Patient_LastName}}, {{report.Patient_FirstName}}</span></div><div class="mb-5px"><span>Patient DOB:</span> <span class="txt-clr-15">{{report.Patient_DOB}}</span></div><div class="mb-5px"><span>Patient Gender:</span> <span class="txt-clr-15">{{report.Patient_Gender}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Patient Class:</span> <span class="txt-clr-15">{{report.PatientClass}}</span></div><div class="mb-5px"><span>Patient Location:</span> <span class="txt-clr-15">{{report.PatientLocation}}</span></div><div class="mb-5px"><span>Reading Location:</span> <span class="txt-clr-15">{{report.ReadingLocation}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Signed Date:</span> <span class="txt-clr-15">{{report.SingDate}}</span></div><div class="mb-5px"><span class="">Ord. Doc:</span> <span class="txt-clr-15">{{report.OrderingPhysician}}</span></div><div class="mb-5px"><span>DOS:</span> <span class="txt-clr-15">{{report.DOS}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Status:</span> <span class="txt-clr-15">{{report.Status}}</span></div><div class="mb-5px"><span>Procedure:</span> <span class="txt-clr-15">{{report.ProcedureDescription}}</span></div></div></div></div><div class="w-100" ng-if="report.DictationValue"><div class="newreportht w-100 repoheight-2 overflow-y-auto overflow-x-hide py-10px px-15px reportmaxwin bg-clr-49"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:16px;"></report></div></div></div><style>\r\n    .report-header-action-bar {\r\n        color: white !important;\r\n        text-align: right;\r\n        padding-right: 25px;\r\n    }\r\n\r\n        .report-header-action-bar i {\r\n            margin-left: 5px;\r\n        }\r\n\r\n            .report-header-action-bar i:hover {\r\n                cursor: pointer;\r\n                color: #3779cd !important;\r\n            }\r\n\r\n    .k-pdf-viewer .k-toolbar .k-button .k-icon {\r\n        color: #000000 !important;\r\n    }\r\n\r\n    hr {\r\n        border-top: 1px solid #333;\r\n    }\r\n</style>');
$templateCache.put('app/theme/components/report-window/report-window.html','<div class="overflow-hide-all ERA-check-detail pt-0 report-popup px-5px comp-innotab px-0 py-0" kendo-window="win_ComparisonOrderReports" k-on-open="isComparisonOrderReportsVisible = true;" k-on-close="isComparisonOrderReportsVisible = false;onClearFilterReportList(true);CloseModal();" k-title="\'Report\'" k-modal="true" k-visible="false" k-width="DataObject.masterData.defaultWindowWidth" k-height="DataObject.masterData.defaultWindowHeight" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isComparisonOrderReportsVisible"><div class=""><div class=""><div class="row mb-20px m-0"><div class="col-md-12 p-0"><div class="" ng-if="!DataObject.ShowReportModal"><div class="" id="{{OrderReport.OrderID}}"><div class="mob-report"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Report</a></li></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="ReportSelectedOrder" button-clicked="ButtonClicked(ReportSelectedOrder)"></patientdetails><div class="row m-0 rprtdscn-fbtns-wrapper" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"><button type="button" class="btn btn-primary rf-btn-xs pull-right mr-10px" ng-click="HideShowReviewReportAction()" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable">{{ReviewOrder.ReviewReportButtonText}}</button></div><div class="row m-0"><div class="px-0" ng-class="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible ? \'col-lg-9 col-sm-9 col-xs-9\' :\'col-lg-12 col-sm-12 col-xs-12\'" ng-if="report.DictationValue"><div class="w-100 repoheight-1 overflow-y-auto overflow-x-hide py-10px px-15px reportmaxwin bg-clr-49"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="width:100%; display:block; line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div><div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box" id="{{OrderReport.OrderID}}" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"><div ng-include="\'peerReviewSection.html\'"></div></div></div></div></div></div></div><div class="m-0" ng-if="DataObject.ShowReportModal"><div class=""><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center active"><a class="py-5px disable-area">Report</a></li></ul></div><div class="p-8px-all pt-5px lesspadng"><patientdetails selected-order="ReportSelectedOrder" button-clicked="ButtonClicked(ReportSelectedOrder)"></patientdetails><div class="rprtdscn-fbtns-wrapper d-flex align-item-center justify-content-between p-5px-all px-10px"><div class="d-flex align-item-center"><div class="width-100 mr-15px"><input type="text" class="blk-input form-control col-placeholder h-25px input-filterreport" placeholder="Search" ng-model="DataObject.SearchText" ng-keyup="FilterReportList(true)"></div><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap mr-15px"><li class="pos-rel align-self-center mr-15px"><a class="border-0 btnpopover-sorting bor-rad-2px py-4px px-4px fs-10px text-center" ng-click="DataObject.displaySortPopover = true" uib-tooltip="{{DataObject.SelectedSortingOption}}" tooltip-placement="top" ng-style="DataObject.displaySortPopover == true ? {\'background-color\':\'#05c1a4\'} : {\'background-color\': \'rgba(5, 193, 164, 0.19);\'}"><i class="fa fa-sort-amount-asc" aria-hidden="true"></i></a><div class="popover-sorting p-5px-all bor-rad-2px" ng-show="DataObject.displaySortPopover" ng-mouseleave="DataObject.displaySortPopover = false"><a class="popover-sorting-item d-block p-5px-all cursor-pointer fs-12px fw-400 txt-clr-1" ng-repeat="list in DataObject.ReportSortingOptions" ng-class="{\'active\' : list == DataObject.SelectedSortingOption}" ng-click="onReportSortingClicked(list)">{{list}}</a></div></li><li class="text-center" ng-repeat="list in DataObject.ReportList.DateRange" ng-class="{\'active\' : DataObject.ReportListFilter.DateRange == list}" ng-click="DataObject.ReportListFilter.DateRange=list;FilterReportList(true)"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul><ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap"><li class="text-center" ng-repeat="list in DataObject.ReportList.Modalities track by $index" ng-class="{\'active\' : DataObject.ReportListFilter.Modality == list}" ng-click="DataObject.ReportListFilter.Modality=list;FilterReportList(true)"><a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a></li></ul></div><div class="d-inline-block pull-right" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"><button type="button" class="btn btn-primary rf-btn-xs pull-right mr-10px" ng-click="HideShowReviewReportAction()" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable">{{ReviewOrder.ReviewReportButtonText}}</button></div></div><div class="row m-0"><div class="col-lg-2 col-sm-2 col-xs-3 m-0 pl-0 pr-0 pr-5px bg-clr-49"><div class="overflow-auto repoheight-2 repoHeiFtrWrklst ftlrbtns-height"><div ng-repeat="r in reportList | orderBy: DataObject.ReportSortingPropName : DataObject.ReportSortingRevOrder track by $index" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #959595 1px solid;cursor:pointer; word-wrap: break-word !important;">{{r.ProcedureDesc}}<div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}">DOS : {{r.FormattedOrderDate | date:\'MM/dd/yyyy\'}}<div style="text-align: right;" ng-if="r.IsReviewable == 1"><i class="fa fa-star txt-clr-8" aria-hidden="true"></i></div></div><span ng-if="signByDisplay(r)">{{signByDisplay(r)}}</span> {{r.Location}}</div></div></div><div ng-class="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible ? \'col-lg-7 col-sm-7 col-xs-9 col-sm-7 m-0 wlh-pdf pl-0\' :\'col-lg-10 col-sm-10 col-xs-9 col-sm-10 m-0 wlh-pdf pl-0\'" id="{{OrderReport.OrderID}}"><div class="row 100 ng-scope ml-0" ng-if="report.DictationValue && reportList.length > 0"><div class="w-100 repoheight-2 rprtsinglwrklst overflow-y-auto overflow-x-hide py-10px px-10px bg-clr-49 repoHeiFtrWrklst"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div><div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box" id="{{OrderReport.OrderID}}" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"><div ng-include="\'peerReviewSection.html\'"></div></div></div></div></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail px-0 py-0" kendo-window="win_ModalReportNDiscuss" k-visible="false" k-width="DataObject.masterData.defaultWindowWidth" k-height="DataObject.masterData.defaultWindowHeight" k-title="\'Report - Discussion\'" k-resize="winResize" k-dragend="winDragend" k-on-open="isModalReportNDiscussVisible = true;" k-on-close="CloseReportNDiscussionWindow()" k-modal="true" k-animation="false" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isModalReportNDiscussVisible" class="mdl-report-discsn"><div ng-include="\'faxModelBodyContent.html\'"></div><uib-tabset active="DataObject.ModalReportNDiscussActiveIndex" class="rf-uib-tabset"><uib-tab index="$index" ng-repeat="tab in ::DataObject.ModalReportNDiscussionTabs" heading="{{tab.title && tab.title.includes(\'Attachment\') ? tab.title + \' (\'+SelectedOrder.FileCount+\')\' : tab.title}}" disable="tab.disabled" select="onModalReportNDiscussionTabsChange(tab.title)" ng-if="tab.title.includes(\'Attachment\') ? SelectedOrder.FileCount > 0 : true"><div ng-include="tab.templateUrl"></div></uib-tab><studyactionmenu selected-order="SelectedOrder" action-menu="DataObject.ActionMenu" action-item-clicked="ActionItemClicked(DataObject.ActionMenu,SelectedOrder)" pop-up-opened="Report-Discussion" class="mdl-action-wrapper"></studyactionmenu><div class="btns-chsnxtstudy d-flex align-item-center d-none" ng-if="DataObject.ShowPrevNextBtn"><button ng-click="SignAndPrevRec()" class="btn btn-primary btn-sm tultip-bottom fs-12px fw-600 d-flex align-item-center justify-content-center line-height-normal border-0" title="" ng-disabled="DataObject.NoPrevOrder" tooltip-class="uibtooltipDenial tt-chsnxtstd" uib-tooltip-html="DataObject.SingReport.PrevToolTip" tooltip-placement="auto bottom" tooltip-append-to-body="true"><i class="fa fa-chevron-left pr-2px"></i>Previous</button> <button ng-click="SignAndNextRec()" class="btn btn-primary btn-sm tultip-bottom fs-12px fw-600 d-flex align-item-center justify-content-center line-height-normal border-0" title="" ng-disabled="DataObject.NoNextOrder" tooltip-class="uibtooltipDenial tt-chsnxtstd" uib-tooltip-html="DataObject.SingReport.NextToolTip" tooltip-placement="auto bottom" tooltip-append-to-body="true">Next<i class="fa fa-chevron-right pl-2px"></i></button></div></uib-tabset></div></div><script type="text/ng-template" id="tree_item_renderer.html"><div> <div> <div class="wrps-discus-chats fs-13px text-break-word bg-clr-29 bor-rad-5px p-15px-all"> <p class="discus-chats txt-clr-1 mb-0" style="white-space:pre-line;color:white;">{{Dis.Comment | htmlDecode}}</p> </div> <div class="float-right py-5px"> <div class="tultip-top float-left"> <a class="btn btn-default glyphicon glyphicon-share-alt border-0" ng-click="Dis.IsChild=!Dis.IsChild"></a> <span class="tultiptext">Reply</span> </div> <div class="float-left pt-3px"> <span class="txt-clr-1 fs-15px dis-crt-name" ng-if="disName(Dis)">{{disName(Dis) | htmlDecode}}</span> <span class="txt-clr-2 fs-12px"> {{Dis.Record_Created_At|localDate :false }}</span> </div> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div class="" ng-if="Dis.IsChild"> <div class="mb-10px w-70 pull-right"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Dis.ChildComment" placeholder="Add a comment"> </textarea> </div> <div class="clearfix"></div> <div class="mb-10px"> <button type="button" class="btn btn-primary pull-right" ng-click="SaveChildDiscussion(Dis)">Save</button> <div class="clearfix"></div> </div> </div> </div> <div class="clearfix"></div> </div> <ul style="list-style:none"> <li class="mb-10px" ng-repeat="Dis in Dis.Childs" ng-include="\'tree_item_renderer.html\'"></li> </ul></script><script type="text/ng-template" id="modal_report_tab.html"><div id="Report" style="opacity:1 !important" class="overflow-x-hide pt-5px pb-0 px-0"> <div class="max-h-90vh h-80vh p-0 mt-5px" ng-if="!isReportAvailable"> <patientdetails selected-Order="SelectedOrder" button-clicked="ButtonClicked(SelectedOrder)"></patientdetails> <div class="d-flex justify-content-center align-item-center" style="height:50vh;"> <h2 class="txt-clr-1 text-center"> Report not available</h2> </div> </div> <div class="" ng-if="isReportAvailable"> <!--<div class="row mb-20px m-0" id="OrderReport{{OrderReport.Accession}}" ng-if="OrderReport.OrderReport.ReportDecation.length > 0">--> <div class="row mb-0 mx-0 m-0" ng-if="!DataObject.ShowReportModal"> <div class="col-md-12 p-0"> <div class="m-0"> <patientdetails selected-Order="ReportSelectedOrder" button-clicked="ButtonClicked(ReportSelectedOrder)"></patientdetails> <div class="row m-0 rprtdscn-fbtns-wrapper" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"> <button type="button" class="btn btn-primary rf-btn-xs pull-right mr-10px" ng-click="HideShowReviewReportAction()" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable">{{ReviewOrder.ReviewReportButtonText}}</button> </div> <div class="row m-0" id="{{OrderReport.OrderID}}"> <!--<report-viewer ng-if="selecteReportId" source-id="selecteReportId"></report-viewer>--> <div class="px-0" ng-class="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible ?\'col-lg-9 col-sm-9 col-xs-9 col-sm-9 m-0 wlh-pdf\' :\'col-lg-12 col-sm-12 col-xs-12 col-sm-12 m-0 wlh-pdf\'" id="{{OrderReport.OrderID}}" style="padding:0!important;"> <div class="w-100" ng-if="report.DictationValue"> <div class="w-100 repoheight-4 overflow-y-auto overflow-x-hide py-10px px-15px reportmaxwin-2 bg-clr-49"> <!--<pre style="word-break:break-all;white-space:pre-line; background-color:transparent; border:none;font-size:18px;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace;"> {{report.DictationValue}} </pre>--> <report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height: 1.4;font-family: Menlo, Monaco, Consolas, \'Courier New\', monospace !important;white-space: pre-line;background-color: transparent;border: none;font-size: 16px;"></report> </div> </div> </div> <div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box" id="{{OrderReport.OrderID}}" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"> <div ng-include="\'peerReviewSection.html\'"></div> </div> </div> </div> </div> </div> <div class="m-0" ng-if="DataObject.ShowReportModal"> <patientdetails selected-Order="ReportSelectedOrder" button-clicked="ButtonClicked(ReportSelectedOrder)"></patientdetails> <div class="rprtdscn-fbtns-wrapper d-flex align-item-center justify-content-between p-5px-all px-10px"> <div class="d-flex align-item-center"> <div class="width-100 mr-15px"> <input type="text" class="blk-input form-control col-placeholder h-25px input-filterreport" placeholder="Search" ng-model="DataObject.SearchText" ng-keyup="FilterReportList(true)"> </div> <ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap mr-15px"> <li class="pos-rel align-self-center mr-15px"> <a class="border-0 btnpopover-sorting bor-rad-2px py-4px px-4px fs-10px text-center" ng-click="DataObject.displaySortPopover = true" uib-tooltip="{{DataObject.SelectedSortingOption}}" tooltip-placement="top" ng-style="DataObject.displaySortPopover == true ? {\'background-color\':\'#05c1a4\'} : {\'background-color\': \'rgba(5, 193, 164, 0.19);\'}"> <i class="fa fa-sort-amount-asc" aria-hidden="true"></i> </a> <div class="popover-sorting p-5px-all bor-rad-2px" ng-show="DataObject.displaySortPopover" ng-mouseleave="DataObject.displaySortPopover = false"> <a class="popover-sorting-item d-block p-5px-all cursor-pointer fs-12px fw-400 txt-clr-1" ng-repeat="list in DataObject.ReportSortingOptions" ng-class="{\'active\' : list == DataObject.SelectedSortingOption}" ng-click="onReportSortingClicked(list)">{{list}}</a> </div> </li> <li class="text-center" ng-repeat="list in DataObject.ReportList.DateRange" ng-class="{\'active\' : DataObject.ReportListFilter.DateRange == list}" ng-click="DataObject.ReportListFilter.DateRange=list;FilterReportList(true)"> <a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a> </li> </ul> <ul class="nav nav-pills repo-discs-filterbtns d-flex flex-wrap"> <li class="text-center" ng-repeat="list in DataObject.ReportList.Modalities track by $index" ng-class="{\'active\' : DataObject.ReportListFilter.Modality == list}" ng-click="DataObject.ReportListFilter.Modality=list;FilterReportList(true)"> <a data-toggle="pill" class="py-4px px-4px fs-10px fw-400 bor-rad-2px">{{list | uppercase}}</a> </li> </ul> </div> <div class="d-inline-block pull-right" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"> <button type="button" class="btn btn-primary rf-btn-xs pull-right mr-10px" ng-click="HideShowReviewReportAction()" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable">{{ReviewOrder.ReviewReportButtonText}}</button> </div> </div> <div class="row m-0"> <div class="col-lg-2 col-sm-2 col-xs-3 m-0 pl-0 pr-0 pr-5px bg-clr-49"> <div class="overflow-auto repoheight-2 repoHeiFtrWrklst ftlrbtns-height"> <div ng-repeat="r in reportList | orderBy: DataObject.ReportSortingPropName : DataObject.ReportSortingRevOrder" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #959595 1px solid;cursor:pointer; word-wrap: break-word !important;"> {{r.ProcedureDesc}} <div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}"> DOS : {{r.FormattedOrderDate | date:\'MM/dd/yyyy\'}} <div style="text-align: right;" ng-if="r.IsReviewable == 1"><i class="fa fa-star txt-clr-8" aria-hidden="true"></i></div> </div> <span ng-if="signByDisplay(r)">{{signByDisplay(r)}}</span> {{r.Location}} </div> </div> </div> <div ng-class="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible ? \'col-lg-7 col-sm-7 col-xs-7 col-sm-7 m-0 wlh-pdf pl-0\' :\'col-lg-10 col-sm-10 col-xs-9 col-sm-10 m-0 wlh-pdf pr-0 pl-0\'" id="{{OrderReport.OrderID}}"> <!--<report ng-bind-html="OrderReport.OrderReport.ReportDecation" style="white-space:pre-line;"></report>--> <!--<report-viewer ng-if="selecteReportId" source-id="selecteReportId"></report-viewer>--> <div class="w-100" ng-if="report.DictationValue && reportList.length > 0"> <div class="w-100 repoheight-5 filtr-repoheight-5 overflow-y-auto overflow-x-hide py-5px px-10px leftsecmaxwindowht bg-clr-49"> <!--<pre style="white-space:pre-line; background-color:transparent; border:none; font-size:18px; font-weight:bold;"> {{report.DictationValue}} </pre>--> <report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:16px;"></report> </div> </div> </div> <div class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0 rating-box-1" id="{{OrderReport.OrderID}}" ng-if="ReviewOrder.Reviewable && ReviewOrder.IsReportReviewEditable"> <div ng-include="\'peerReviewSection.html\'"></div> </div> </div> </div> </div> </div></script><script type="text/ng-template" id="modal_discussion_tab.html"><div id="Discussion" style="opacity:1 !important"> <div class="fw-500 pt-5px"> <patientdetails selected-Order="DiscussionSelectedOrder" button-clicked="ButtonClicked(DiscussionSelectedOrder)"></patientdetails> <div> <div class="row m-0"> <div class="col-lg-3 col-md-3 col-sm-3 p-0"> <div ng-if="ODType==\'Assigner\'"> <ui-select ng-model="OrderDiscussion.SelectedUser" theme="bootstrap" class="dicom-inp-w" ng-disabled="OrderDiscussion.ID"> <ui-select-match allow-clear="true" placeholder="Select Radiologist"> {{radDisplay($select.selected)}}</ui-select-match> <ui-select-choices repeat="list in DataObject.masterData.Radiologists | filter: isVisibleRad | propsFilter: {FirstName: $select.search, LastName: $select.search} | orderBy:\'LastName\'"> <small> <i class="fa fa-circle" ng-class="{\'text-success\':list.IsOnline,\'text-gray-dark\':!list.IsOnline}"></i> {{radDisplay(list)}} </small> </ui-select-choices> </ui-select> </div> </div> </div> <div class="row m-0"> <div class="col-md-12 p-0" ng-if="ODType==\'Discussion\' || ODType==\'Helper\'"> <div class="form-group my-10px p-0"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea> </div> <div class="col-lg-12 col-md-12 p-0"> <button type="button" class="btn btn-primary pull-right border-0" ng-click="SaveDiscussion()">Save</button> </div> </div> <div class="col-md-12 pr-0 pl-0 " ng-if="ODType==\'Assigner\'"> <div class="col-md-12 form-group my-10px p-0"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea> </div> <button type="button" ng-hide="OrderDiscussion.ID" class="btn btn-primary pull-right ml-5px" ng-click="SaveOrderDiscussion()">Consult Study</button> <button type="button" ng-hide="OrderDiscussion.ID" class="btn btn-primary pull-right ml-5px" ng-click="AssignStudy()">Assign Study</button> <button type="button" ng-if="OrderDiscussion.ID" class="btn btn-primary pull-right" ng-click="SaveDiscussion()">Save</button> </div> <div class="clearfix h-10px"></div> <div class="discus-comment overflow-y-auto py-10px px-10px wl-async"> <!--discuss--> <div class=""> <div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div> <div class="clearfix"></div> </div> </div> </div> </div> </div> </div></script><script type="text/ng-template" id="modal_attachment_tab.html"><div class="fw-500 pt-5px"> <patientdetails selected-Order="DiscussionSelectedOrder" button-clicked="ButtonClicked(DiscussionSelectedOrder)"></patientdetails> <div id="" class="mt-5px" style="opacity:1 !important"> <div class="fw-500 pt-10px"> <div class="new-wl-rep-dis"> <div class="discussion-attachment-sec overflow-x-hide"> <div class="row m-0"> <attachment-viewer ng-if="DataObject.Reference.ID" dicomorder="DataObject.Reference" send-fax="openFaxModal(faxFile)" selected-order="DiscussionSelectedOrder"></attachment-viewer> </div> </div> </div> </div> </div> </div></script><script type="text/ng-template" id="faxModelBodyContent.html"><div class="modal fade bsmodal-sendfax" id="SendFaxModal" role="dialog" data-keyboard="false" data-backdrop="static"> <div class="modal-dialog create-filter"> <!-- Modal content--> <div class="modal-content"> <div class="new-popup"> <div class="modal-header"> <button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button> <h4 class="modal-title">Send Fax</h4> </div> <div class="modal-body"> <div class="row"> <div class="col-md-12 mb-10px fax-multiselectbox tultip-bottom" ng-if="DataObject.FaxDetails.FaxNumberList.length > 0"> <label class="rf-label">Fax Number</label> <multi-Select master-data="DataObject.FaxDetails.FaxNumberDropdown" list="DataObject.FaxDetails.FaxNumberList" ng-model="DataObject.FaxDetails.FaxNumberDropdown.SelectedValue" on-change="DataObject.FaxDetails.FaxNumberDropdown.onFaxNumbChanged(selectedData)"> </multi-Select> <span class="tultiptext text-preline overflow-auto max-h-500px text-left tt-white tt-top">{{(DataObject.FaxDetails.FaxNumTooltip)?DataObject.FaxDetails.FaxNumTooltip:\'Select Fax Number\'}}</span> </div> <div class="col-md-12 mb-20px"> <label class="rf-label">Enter Fax Number</label> <input type="text" id="FaxNumText" class="form-control inputfax-numner" name="faxnumber" ui-mask="(999) 999-9999" maxlength="15" ng-model="DataObject.FaxDetails.FaxNumber" autocomplete="off" /> </div> <div class="col-md-12"> <button type="button" class="btn btn-primary float-right" ng-disabled="validateFaxNumText()" ng-click="SendFax()">Send Fax</button> </div> </div> </div> </div> </div> </div> </div></script><script type="text/ng-template" id="peerReviewSection.html"><div ng-if="ReviewOrder.Reviewable && DataObject.IsStudyReviewSectionVisible"> <div ng-form="review" class="p-10px-all"> <div class="row"> <div class="col-md-12 form-group fw-600" ng-if="ReviewOrder.IsReportReviewEditable"> For Interesting Cases: <input type="checkbox" class="v-a-m ml-5px mt-0 cmn-checkbx-input" ng-checked="ReviewOrder.IsInterestingCase" ng-model="ReviewOrder.IsInterestingCase" ng-disabled="!ReviewOrder.IsReportReviewEditable" /> </div> <div class="col-md-12 form-group mb-5px" ng-if="ReviewOrder.IsReportReviewEditable"> <table class="patient-table w-100 b-1-s b-clr-1"> <thead> <tr class="bg-clr-23" style="border:0!important;background-color:#05c1a4!important;"> <th class="w-40px text-center py-2px fw-600">Sr.</th> <th class="py-2px fw-600">Score</th> </tr> </thead> <tbody class="bg-clr-23 pt-5px"> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">1</td> <td> <div style="padding: 0px 5px 5px 5px;" class="txt-clr-1"> <input class="pos-rel mt-0 cmn-checkbx-input" style="top:2px;" type="radio" ng-click="ReviewOrder.Rating=\'1\'" ng-checked="ReviewOrder.Rating==\'1\'" ng-disabled="!ReviewOrder.IsReportReviewEditable"> Concur with Interpretation </div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">2</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/not ordinarily expected to be made(understandable miss)</span> <div class="p-5px-all"><input type="radio" class="m-5px-all cmn-checkbx-input mt-1 " ng-click="ReviewOrder.Rating=\'2a\'" ng-checked="ReviewOrder.Rating==\'2a\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">2a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'2b\'" ng-checked="ReviewOrder.Rating==\'2b\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">2b.Likely to be signficant</div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">3</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/Should be made most of time</span> <br> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'3a\'" ng-checked="ReviewOrder.Rating==\'3a\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">3a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'3b\'" ng-checked="ReviewOrder.Rating==\'3b\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">3b.Likely to be signficant</div> </td> </tr> <tr class="bg-clr-23" style="border: 0 !important;"> <td class="text-center v-a-t w-40px txt-clr-1">4</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/Should be made almost every time - misinterpretation of findings</span><br /> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'4a\'" ng-checked="ReviewOrder.Rating==\'4a\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">4a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all mt-1 cmn-checkbx-input" ng-click="ReviewOrder.Rating=\'4b\'" ng-checked="ReviewOrder.Rating==\'4b\'" ng-disabled="!ReviewOrder.IsReportReviewEditable">4b.Likely to be signficant</div> </td> </tr> </tbody> </table> </div> <div class="col-md-12 col-sm-12 mb-10" ng-if="ReviewOrder.IsInterestingCase && ReviewOrder.IsReportReviewEditable"> <span ng-if="ReviewOrder.IsInterestingCase" style="color:white;float:left;">Keywords *</span> <input type="text" class="blk-input form-control w-100 mb-10px" name="keyword" ng-model="ReviewOrder.Keywords" placeholder="Keywords." ng-required="ReviewOrder.IsInterestingCase" ng-disabled="!ReviewOrder.IsReportReviewEditable"> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div class="col-md-12 form-group mb-0 fw-600"> <div ng-if="ReviewOrder.IsReportReviewEditable"> <span ng-if="ReviewOrder.IsInterestingCase" style="color:white; float:left;">Add a comment *</span> <div class="clearfix"></div> <textarea class="txt-area h-70px w-100 p-5px-all" rows="4" name="comment" ng-model="ReviewOrder.Comments" placeholder="Add a comment." ng-required="ReviewOrder.IsInterestingCase"> </textarea> </div> <div ng-if="!ReviewOrder.IsReportReviewEditable && ReviewOrder.Comments"> <span style="color:white; float:left;">Comment: {{ReviewOrder.Comments}}</span> </div> </div> <div class="col-md-12"> <button type="button" class="btn btn-primary pull-right m-1" ng-click="SetOrderPeerReview()" ng-if="ReviewOrder.IsReportReviewEditable" ng-disabled="disableReportReviewBtn()">Save</button> </div> </div> </div> </div></script>');
$templateCache.put('app/theme/components/rule/rule.html','<link rel="stylesheet" href="cdn/css/ui-grid.css"><style>\r\n    .rule-table .blk-input.form-control:focus,\r\n    .rule-table .sing-select.form-control:focus,\r\n    .rule-table .condition-select.form-control:focus,\r\n    .rule-table .edit-input.form-control:focus,\r\n    .rule-table .edit-select.form-control:focus,\r\n    .rule-table .k-widget.k-dropdowntree.k-dropdowntree-clearable.k-state-border-down:focus,\r\n    .rule-table .mult-select.ui-select-container .btn.btn-default.form-control:focus,\r\n    .rule-table .mult-select.ui-select-multiple.ui-select-bootstrap:focus {\r\n        background-color: #323232 !important;\r\n        border-color: #05c1a4 !important;\r\n        outline: 0 !important;\r\n    }\r\n\r\n    .rule-grid-worklist .anui .ui-grid-render-container-body .ui-grid-viewport {\r\n        height: 200px !important;\r\n    }\r\n\r\n    .ruleSetting-grid-worklist .anui .ui-grid-render-container-body .ui-grid-viewport {\r\n        height: 215px !important\r\n    }\r\n\r\n    .rule-grid-worklist .anui.ui-grid {\r\n        height: 258px !important\r\n    }\r\n\r\n        .rule-grid-worklist .anui.ui-grid .footerfix {\r\n            bottom: 0;\r\n        }\r\n\r\n    .ruleSetting-grid-worklist .anui.ui-grid {\r\n        height: 270px !important;\r\n    }\r\n\r\n        .ruleSetting-grid-worklist .anui.ui-grid .footerfix {\r\n            bottom: 0;\r\n        }\r\n\r\n    .rule-text-overflow {\r\n        white-space: nowrap;\r\n        width: 180px;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    .rad-name {\r\n        padding: 3px 5px;\r\n        margin: 3px 7px;\r\n        border: 1px solid #00584b;\r\n        border-radius: 4px;\r\n    }\r\n    .page-size-input\r\n    {\r\n        width:100px;\r\n    }\r\n    /*half screen css start*/\r\n    .editrule-form {\r\n        flex: 1;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .rule-vislise-worklist {\r\n        width: 50%;\r\n        border: 1px solid #474747;\r\n        box-shadow: -10px 0px 30px 0px rgba(0, 0, 0, 0.6);\r\n    }\r\n\r\n    .worklistvisb .inflfd-rulename,\r\n    .worklistvisb .inflfd-ruledescp,\r\n    .worklistvisb .inflfd-rulett,\r\n    .worklistvisb .inflfd-ruleanor,\r\n    .worklistvisb .inflfd-rulest,\r\n    .worklistvisb .inflfd-rulesc {\r\n        padding-right: 0;\r\n    }\r\n\r\n    .worklistvisb .inflfd-ruleselval {\r\n        padding-right: 10px;\r\n    }\r\n\r\n    .worklistvisb .inflfd-rulesc .pl-20px.rule-table {\r\n        padding-left: 10px !important;\r\n    }\r\n\r\n    .worklistvisb .inflfd-rulename, .worklistvisb .inflfd-ruledescp {\r\n        width: 25%;\r\n    }\r\n\r\n    .worklistvisb .inflfd-rulett {\r\n        width: 48%;\r\n    }\r\n\r\n        .worklistvisb .inflfd-rulett.ttatrules {\r\n            width: 80%;\r\n        }\r\n\r\n    .infld-rulettelem {\r\n        padding-left: 0 !important;\r\n    }\r\n\r\n    .worklistvisb .inflfd-rulett .infld-rulettelem {\r\n        /*width: 100%;*/\r\n        margin-top: 10px;\r\n        padding-left: 0 !important;\r\n    }\r\n\r\n        .worklistvisb .inflfd-rulett .infld-rulettelem .sing-select.form-control,\r\n        .worklistvisb .inflfd-rulett .infld-rulettelem input {\r\n            margin-left: 0 !important;\r\n        }\r\n\r\n    .worklistvisb .inflfd-ruleanor {\r\n        width: 12%;\r\n    }\r\n\r\n    .worklistvisb .inflfd-rulest {\r\n        width: 21%;\r\n    }\r\n\r\n    .worklistvisb .inflfd-rulesc {\r\n        width: 33%;\r\n    }\r\n    .worklistvisb .col-lg-3.breach-color-box {\r\n        width: 33%;\r\n    }\r\n    .ruleedit-wraaper {\r\n        height: 94vh !important;\r\n    }\r\n\r\n        .ruleedit-wraaper .rulecondin-wrappwer.max-h-200px {\r\n            max-height: 465px;\r\n        }\r\n\r\n        .ruleedit-wraaper .radlogist-wraaper.max-h-65px {\r\n            max-height: 130px;\r\n            border-top: 0 !important;\r\n            /*padding: 4px 0;*/\r\n        }\r\n\r\n    .rule-vislise-worklist .ruleSetting-grid-worklist .myGrid {\r\n        max-height: unset;\r\n        height: calc(100vh - 90px) !important;\r\n    }\r\n\r\n    .rule-showMessage .rule-add-edit {\r\n        height: 20px;\r\n        width: 20px;\r\n        align-self: center;\r\n        background-color: #067866 !important;\r\n    }\r\n\r\n    .worklistvisb .mlpbox-wrpr {\r\n        width: 33%;\r\n    }\r\n\r\n    .worklistvisb .rad-name {\r\n        width: 18%;\r\n    }\r\n\r\n    .radiol-strip {\r\n        background-color: #313131;\r\n        padding: 6px;\r\n    }\r\n\r\n    .close-viewrule {\r\n        height: 18px;\r\n        width: 18px;\r\n        padding: 0 !important;\r\n        border: 0 !important;\r\n        cursor: pointer;\r\n        color: #fff !important;\r\n        background-color: transparent !important;\r\n        font-size: 14px;\r\n        text-align: center;\r\n    }\r\n\r\n    .infld-rulettelem {\r\n        width: 100%;\r\n    }\r\n\r\n        .infld-rulettelem.setwidth-slabrch {\r\n            /*width: 73%;*/\r\n        }\r\n\r\n    .edit-filter.addwlrule-popup .ruleedit-wraaper {\r\n        height: 75.6vh !important;\r\n    }\r\n\r\n    .edit-filter.addwlrule-popup .checkbox-switch .cmn-checkbx-input:disabled,\r\n    .edit-filter.addwlrule-popup .checkbox-switch .cmn-checkbx-input[disabled] {\r\n        visibility: hidden;\r\n    }\r\n\r\n    .edit-filter.addwlrule-popup .checkbox-switch.pref-checkbox.rlsEnable input:checked + .checkbox-switch-slider {\r\n        opacity: 0.5;\r\n        cursor: not-allowed;\r\n    }\r\n\r\n    .edit-filter.addwlrule-popup .rule-grid-worklist .myGrid {\r\n        height: calc(100vh - 262px) !important;\r\n        max-height: unset;\r\n    }\r\n\r\n    .edit-filter.addwlrule-popup .ruleedit-wraaper .rulecondin-wrappwer.max-h-200px {\r\n        max-height: 440px;\r\n    }\r\n\r\n    .edit-filter.addwlrule-popup .worklistvisb .inflfd-rulesc {\r\n        width: 28%;\r\n    }\r\n\r\n    .edit-filter.addwlrule-popup .worklistvisb .inflfd-ruleselval {\r\n        width: 30%;\r\n    }\r\n\r\n    .myGrid.stepmenupendingSub .ag-header-cell {\r\n        min-width: 60px !important;\r\n    }\r\n\r\n    .addwlrule-popup .location-tags-input tags-input .tags .tag-list {\r\n        max-height: 45px !important\r\n    }\r\n\r\n    .location-tags-input tags-input .tags .tag-list {\r\n        max-height: 130px !important\r\n    }\r\n\r\n    input[type="color"] {\r\n        border: none;\r\n        background-color: transparent;\r\n        width: 38px;\r\n        height: 38px;\r\n        outline: none;\r\n    }\r\n\r\n        input[type="color"].clrpicker {\r\n            width: 86px;\r\n            /*width: 50px;*/\r\n        }\r\n\r\n    .nocustomcolor-field {\r\n        height: 38px;\r\n    }\r\n\r\n    #color-picker::-webkit-color-swatch {\r\n        border-radius: 7px;\r\n    }\r\n\r\n    .ttvalmin {\r\n        width: 70%;\r\n    }\r\n\r\n    .tatvalbx, .slabreahbox {\r\n        width: 74%;\r\n    }\r\n\r\n    .sing-select.form-control.slabrtimeval {\r\n        padding: 4px 6px !important;\r\n    }\r\n\r\n    .maintgl-element {\r\n        height: 30px;\r\n        padding-top: 4px;\r\n    }\r\n\r\n    .slabrchlbl {\r\n        position: relative;\r\n        top: -5px;\r\n    }\r\n\r\n    .nocstmclrlbl, .clrpckrintbox {\r\n        position: absolute !important;\r\n        left: 33px;\r\n    }\r\n\r\n    .clrpckrintbox {\r\n        left: 40px;\r\n        top: 15px;\r\n    }\r\n\r\n    .nocstmclrlbl img {\r\n        height: 34px;\r\n    }\r\n\r\n    @media (min-width: 768px) and (max-width: 1199px) {\r\n        .sm-mt-10px {\r\n            margin-top: 10px;\r\n        }\r\n\r\n        .ruletable-cdns2 .rad-name {\r\n            width: 30%;\r\n        }\r\n\r\n        .mlpbox-wrpr {\r\n            width: 33%;\r\n        }\r\n\r\n        .mlpbox-wrpr {\r\n            width: 33%;\r\n        }\r\n\r\n        .rule-vislise-worklist {\r\n            width: 50%;\r\n        }\r\n\r\n        .inflfd-rulename,\r\n        .inflfd-ruledescp,\r\n        .inflfd-rulett,\r\n        .inflfd-ruleanor,\r\n        .inflfd-rulest,\r\n        .inflfd-rulesc {\r\n            padding-right: 0;\r\n        }\r\n\r\n            .inflfd-rulesc .pl-20px.rule-table {\r\n                padding-left: 10px !important;\r\n            }\r\n\r\n        .inflfd-rulename, .inflfd-ruledescp {\r\n            width: 28%;\r\n        }\r\n\r\n        .inflfd-rulett {\r\n            width: 44%;\r\n        }\r\n\r\n        .inflfd-ruleanor {\r\n            width: 12%;\r\n        }\r\n\r\n        .inflfd-rulest {\r\n            width: 21%;\r\n        }\r\n\r\n        .inflfd-rulesc {\r\n            width: 33%;\r\n        }\r\n\r\n        .ruleedit-wraaper .rulecondin-wrappwer.max-h-200px {\r\n            max-height: 175px;\r\n        }\r\n\r\n        .ruleedit-wraaper .radlogist-wraaper.max-h-65px {\r\n            max-height: 50px;\r\n        }\r\n        /*.ruleedit-wraaper .worklistvisb .rulecondin-wrappwer.max-h-200px {\r\n            max-height: 360px;\r\n        }*/\r\n        .infld-rulettelem {\r\n            /*width: 40%;*/\r\n            width: 51%;\r\n            display: flex;\r\n            margin-top: 10px;\r\n        }\r\n\r\n            .infld-rulettelem.setwidth-slabrch {\r\n                /*width:41%;*/\r\n            }\r\n\r\n        .sm-pt-25px {\r\n            padding-top: 25px !important;\r\n        }\r\n\r\n        .worklistvisb .inflfd-rulett .infld-rulettelem .col-md-4 {\r\n            width: 33%;\r\n        }\r\n\r\n            .worklistvisb .inflfd-rulett .infld-rulettelem .col-md-4:nth-child(2),\r\n            .worklistvisb .inflfd-rulett .infld-rulettelem .col-md-4:last-child {\r\n                width: 38%;\r\n            }\r\n\r\n        .worklistvisb .inflfd-rulett .infld-rulettelem {\r\n            display: flex;\r\n        }\r\n\r\n        .worklistvisb .inflfd-rulett.ttatrules {\r\n            width: 100%;\r\n        }\r\n        .worklistvisb .col-lg-3.breach-color-box {\r\n            width: 16%;\r\n        }\r\n        .inflfd-rulett.ttatrules {\r\n            width: 100%;\r\n        }\r\n\r\n        .rule-grid-worklist .myGrid {\r\n            height: calc(100vh - 650px) !important;\r\n        }\r\n\r\n        .rule-vislise-worklist {\r\n            width: 100%;\r\n        }\r\n\r\n        .editrule-form {\r\n            flex: unset;\r\n            height: 515px;\r\n            width: 100%;\r\n        }\r\n\r\n        .ruleedit-wraaper {\r\n            flex-wrap: wrap;\r\n        }\r\n\r\n        .ttatrules .sing-select.form-control, .ttatrules input {\r\n            margin-left: 0 !important;\r\n        }\r\n\r\n        .rule-vislise-worklist .ruleSetting-grid-worklist .myGrid {\r\n            max-height: unset;\r\n            height: calc(100vh - 610px) !important;\r\n        }\r\n\r\n        .modal.fade .modal-dialog.edit-filter.addwlrule-popup {\r\n            width: 98%;\r\n            transform: translate(0, 0%) !important;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .ruleedit-wraaper {\r\n            height: 84vh !important;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .editrule-form {\r\n            height: 450px;\r\n            width: 100%;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .rule-grid-worklist .myGrid {\r\n            height: calc(100vh - 634px) !important;\r\n            max-height: unset;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .ruleedit-wraaper .rulecondin-wrappwer.max-h-200px {\r\n            max-height: 170px;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .inflfd-rulesc,\r\n        .edit-filter.addwlrule-popup .worklistvisb .inflfd-rulesc {\r\n            width: 23%;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .inflfd-ruleselval,\r\n        .edit-filter.addwlrule-popup .worklistvisb .inflfd-ruleselval {\r\n            width: 25%;\r\n        }\r\n\r\n        .location-tags-input tags-input .tags .tag-list {\r\n            max-height: 45px !important\r\n        }\r\n\r\n        .nocstmclrlbl {\r\n            left: 31px;\r\n        }\r\n\r\n        .slabrchlbl {\r\n            top: -4px;\r\n        }\r\n\r\n        .maintgl-element {\r\n            padding-top: 6px;\r\n        }\r\n\r\n        .clrpckrintbox {\r\n            left: 38px;\r\n            top: 15px;\r\n        }\r\n\r\n        .page-size-input {\r\n            width: 80px;\r\n        }\r\n    }\r\n\r\n    @media (min-width: 768px) and (min-height: 1080px) and (orientation: portrait) {\r\n        .ruleedit-wraaper .rulecondin-wrappwer.max-h-200px {\r\n            max-height: 380px;\r\n        }\r\n\r\n        .ruleedit-wraaper .radlogist-wraaper.max-h-65px {\r\n            max-height: 100px;\r\n        }\r\n\r\n        .ruleedit-wraaper {\r\n            height: 110vh !important;\r\n        }\r\n\r\n        .ruletable-cdns1 .rulecondin-wrappwer tbody.setheightrule {\r\n            max-height: 1050px !important;\r\n        }\r\n\r\n        .editrule-form {\r\n            height: 820px;\r\n        }\r\n\r\n        .rule-vislise-worklist {\r\n            width: 100%;\r\n            height: calc(100vh - 650px) !important;\r\n        }\r\n\r\n            .rule-vislise-worklist .ruleSetting-grid-worklist .myGrid {\r\n                max-height: unset;\r\n                height: 876px !important;\r\n            }\r\n\r\n        .edit-filter.addwlrule-popup .editrule-form {\r\n            height: 560px;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .rule-vislise-worklist {\r\n            width: 100%;\r\n            height: calc(100vh - 790px) !important;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .rule-vislise-worklist {\r\n            height: calc(100vh - 905px) !important;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .rule-grid-worklist .myGrid {\r\n            height: 888px !important;\r\n        }\r\n\r\n        .edit-filter.addwlrule-popup .ruleedit-wraaper .rulecondin-wrappwer.max-h-200px {\r\n            max-height: 282px;\r\n        }\r\n\r\n        .location-tags-input tags-input .tags .tag-list {\r\n            max-height: 45px !important\r\n        }\r\n    }\r\n    /*half screen css end*/\r\n</style><div class="" ng-hide="ShowListView"><div class=""><div class="radf-header"><h2 class="w-100">{{ title }}</h2></div></div><div class="bg-clr-27 overflow-y-auto d-flex ruleedit-wraaper" ng-class="{\'h-75-6vh\': (!$ctrl.ruleSetting) , \'h-90vh\': ($ctrl.ruleSetting) }"><form name="frmEdit" role="form" ng-submit="ValidateRule()" ng-keypress="SubmitEventPreventDefault($event)" class="editrule-form"><div ng-class="{\'worklistvisb\':WorkListVisible}"><div class="p-15px-all txt-clr-1"><div class="row pb-10px d-flex align-item-center flex-wrap"><div class="col-md-3 col-sm-3 inflfd-rulename"><div class="rule-table" ng-class="{\'has-error\': (frmEdit.RuleName.$dirty && frmEdit.RuleName.$error.required) }"><label for="RuleName" class="rf-label">Rule Name *</label> <input type="text" name="RuleName" id="RuleName" class="blk-input form-control" maxlength="99" ng-model="Rule.RuleName" required=""> <span ng-show="frmEdit.RuleName.$dirty && frmEdit.RuleName.$error.required" class="txt-clr-5 fw-500 fs-12px">Rule name is required</span></div></div><div class="col-md-3 col-sm-3 inflfd-ruledescp" ng-if="$ctrl.ruleSetting"><div class="rule-table" ng-class="{\'has-error\': (frmEdit.RuleDesc.$dirty) }" ng-if="$ctrl.ruleSetting"><label for="username" class="rf-label">Rule Description</label> <input type="text" name="RuleDesc" id="RuleDesc" class="blk-input form-control" ng-model="Rule.RuleDescription" maxlength="499"></div></div><div class="col-lg-6 col-md-4 col-sm-6 d-flex inflfd-rulett" ng-class="{\'align-item-center ttatrules\' : (Rule.IsWorkList==\'2\')}"><div class="page-size-input pl-0 pr-15px" ng-if="Rule.IsWorkList==\'1\' && (DataObject.LoggedInUserRoles.includes(\'Admin\') || DataObject.LoggedInUserRoles.includes(\'SuperAdmin\')) && Rule.IsSmartWorklist"><label class="rf-label mb-0">Page Size</label> <input type="text" ng-model="Rule.WorklistPageSize" id="SLABreachTime" class="blk-input ml-0 m-5px-all form-control" oninput="this.value = this.value.replace(/[^0-9]/g, \'\');" maxlength="9"></div><div class="pt-15px pr-10px sm-pt-25px" ng-if="Rule.IsWorkList==\'1\' && (DataObject.LoggedInUserRoles.includes(\'Admin\') || DataObject.LoggedInUserRoles.includes(\'SuperAdmin\'))"><div class="form-controller d-flex align-item-center"><label class="checkbox-switch pref-checkbox mb-0 mt-5px"><input type="checkbox" id="noCustomColor" class="cmn-checkbx-input m-0" ng-model="Rule.IsSmartWorklist"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 mt-5px chktgl-value">Smart Worklist</span></div></div><div ng-if="Rule.IsWorkList==\'2\'" class="pr-5px mx-0 row infld-rulettelem" ng-class="{\'setwidth-slabrch\': ($ctrl.ruleSetting && (Rule.IsWorkList==\'2\') && DataObject.isCustomColor)}"><div class="col-md-6 pl-0 pr-2"><label class="rf-label mb-0">TAT Value *</label><div class="d-flex"><input type="text" ng-model="Rule.TATValue" id="TATValue" class="blk-input ml-0 m-5px-all form-control tatvalbx" oninput="this.value = this.value.replace(/[^0-9]/g, \'\');" maxlength="9"><select ng-model="Rule.TATType" name="TATType" id="TATType" class="sing-select form-control m-5px-all downArrow-ie ttvalmin slabrtimeval"><option ng-repeat="TATType in TATTypeList" value="{{TATType.Key}}">{{TATType.Key}}</option></select></div></div><div class="col-md-6 px-0"><label class="rf-label mb-0">SLA Breach Time *</label><div class="d-flex"><input type="text" ng-model="Rule.SLABreachValue" id="SLABreachTime" class="blk-input ml-0 m-5px-all form-control slabreahbox" oninput="this.value = this.value.replace(/[^0-9]/g, \'\');" maxlength="9"><select ng-model="Rule.SLABreachType" name="SLABreachType" id="SLABreachType" class="sing-select form-control m-5px-all downArrow-ie ttvalmin slabrtimeval"><option ng-repeat="TATType in TATTypeList" value="{{TATType.Key}}">{{TATType.Key}}</option></select></div></div></div><div class="col-lg-3 col-md-4 col-sm-2 px-5px sm-mt-10px breach-color-box" ng-if="Rule.IsWorkList==\'2\'"><label class="rf-label mb-0 slabrchlbl">SLA Breach Color <i class="fa fa-info-circle cursor-pointer" aria-hidden="true" uib-tooltip-html="DataObject.uibHtmlTooltip" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" tooltip-append-to-body="true"></i></label><div class="d-flex align-item-center maintgl-element" ng-class="{\'csttmclr-formctrl\': ($ctrl.ruleSetting && (Rule.IsWorkList==\'2\') && DataObject.isCustomColor)}"><div class="form-controller d-flex align-item-center pos-rel" ng-if="Rule.IsWorkList==\'2\'" ng-class="{\'nocsttmclr-formctrl\': !($ctrl.ruleSetting && (Rule.IsWorkList==\'2\') && DataObject.isCustomColor)}"><label class="checkbox-switch pref-checkbox mb-0 mt-0"><input type="checkbox" id="noCustomColor" class="cmn-checkbx-input m-0" ng-model="DataObject.isCustomColor" ng-change="onCustomColortoggle()"> <span class="checkbox-switch-slider round"></span></label> <span class="mt-0 nocstmclrlbl" ng-if="Rule.IsWorkList==\'2\' && !DataObject.isCustomColor"><img class="" src="assets/images/90x35px_nocolorboxbrd2.png" alt="No Color" style="vertical-align: baseline; cursor: not-allowed;"></span></div><div class="form-controller d-flex align-item-center clrpckrintbox" ng-if="$ctrl.ruleSetting && Rule.IsWorkList==\'2\' && DataObject.isCustomColor"><input type="color" id="color-picker" value="" class="cursor-pointer clrpicker pl-0 mt-0" title="Pick a Color" ng-model="Rule.RuleColorCode"></div></div></div><div class="pt-15px pr-10px sm-pt-25px"><div class="form-controller d-flex align-item-center"><label class="checkbox-switch pref-checkbox rlsEnable mb-0 mt-5px"><input type="checkbox" ng-model="Rule.IsEnabled" class="cmn-checkbx-input m-0" id="rlsEnable" ng-disabled="!$ctrl.ruleSetting"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 mt-5px chktgl-value">Enable</span></div></div><div class="pt-15px px-5px sm-pt-25px" ng-if="$ctrl.ruleSetting"><div class="form-controller d-flex align-item-center"><label class="checkbox-switch pref-checkbox mb-0 mt-5px"><input type="checkbox" ng-model="Rule.IsHighpriority" class="cmn-checkbx-input m-0" id="rlsHighPri"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 mt-5px w-80px chktgl-value">High Priority</span></div></div></div></div><div class="row pb-10px d-flex align-item-center flex-wrap" ng-if="Rule.IsWorkList==\'2\'"><div class="col-md-3 col-sm-4 col-xs-12 inflfd-rulename"><div class="rule-table"><label for="TATTenant" class="rf-label">Tenant</label><ui-select skip-focusser="true" id="TATTenant" name="TATTenant" class="mult-select seltype-drop mob-closekeypad" ng-model="TenantSelection.Obj" on-select="onTenantSelected()" ng-disabled="!!Rule.RuleID"><ui-select-match allow-clear="false" placeholder="Select Tenant">{{$select.selected.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in MasterData.TenantOptions | filter: {DisplayName: $select.search}" position="down"><div ng-bind-html="tenant.DisplayName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-6 col-sm-8 col-xs-12 pt-20px sm-pt-5px"><span class="fs-12px txt-clr-16" ng-if="Rule.RuleID">The tenant is fixed once a TAT rule has been created.</span> <span class="fs-12px txt-clr-16" ng-if="!Rule.RuleID && TenantSelection.Obj">Applies only to studies from <strong class="txt-clr-1">{{TenantSelection.Obj.DisplayName}}</strong> sites. A matching Tenants condition is added below and stays locked.</span> <span class="fs-12px txt-clr-16" ng-if="!Rule.RuleID && !TenantSelection.Obj">Select the tenant this rule belongs to.</span></div></div><div class="row pb-10px d-flex justify-content-left flex-wrap"><div class="col-lg-1 col-md-1 col-sm-1 inflfd-ruleanor"><div class="rule-table"><label for="AndOr" class="rf-label pl-5px">AND/OR</label><select class="sing-select form-control m-5px-all ml-0 downArrow-ie" name="AndOr" id="AndOr" ng-model="Condition.AndOr" ng-change="ChangeAndOr(Condition,Condition.AndOr)" ng-disabled="disableAndOr()"><option value="AND">AND</option><option value="OR">OR</option></select></div></div><div class="col-lg-2 col-md-2 col-sm-2 rule-table mb-10px inflfd-rulest"><label for="RuleTableSelect" class="rf-label">Select Type</label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" name="RuleTableSelect" id="RuleTableSelect" ng-model="Condition.RuleTable" on-select="ResetCollection(true)"><ui-select-match allow-clear="false">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="list in RuleTable | filter: isRuleTypeAllowed | filter: {Key: $select.search} | orderBy:\'Key\'" position="down"><div ng-bind-html="list.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-3 col-md-3 col-sm-3 mb-10px d-flex justify-content-between inflfd-rulesc"><div class="w-100 rule-table"><label for="repeatSelect" class="rf-label">Select Condition:</label><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" name="RuleOperatorSelect" id="RuleOperatorSelect" ng-model="Condition.RuleOperator" on-select="ResetCollection(false)"><ui-select-match allow-clear="false">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="list in Condition.RuleTable.RuleOperator | orderBy:\'Key\'" position="down"><div ng-bind-html="list.Key"></div></ui-select-choices></ui-select></div><div class=""><div class="pl-20px rule-table" ng-show="Condition.RuleOperator.Key==\'Before Time\' || Condition.RuleOperator.Key==\'After Time\'"><label for="Time" class="rf-label">Time</label><select class="sing-select form-control m-5px-all mr-0 downArrow-ie" style="width: 75px; padding: 4px 8px 4px 0 !important ;" name="Time" id="Time" ng-model="Condition.Time" ng-change="ResetValue()"><option value="Day">Day</option><option value="Hour">Hour</option><option value="Minute">Minute</option></select></div></div></div><div class="col-md-3 col-sm-3 inflfd-ruleselval" ng-class="{\'col-lg-5\': ($ctrl.ruleSetting && (Condition.RuleTable.Key==\'Locations\')),\'col-lg-3\': ($ctrl.ruleSetting && !(Condition.RuleTable.Key==\'Locations\')), \'col-lg-3\': (!$ctrl.ruleSetting)}"><div class="rule-table" ng-show="!Condition.RuleTable.IsText && !Condition.RuleTable.IsDate && !Condition.RuleOperator.IsText && !Condition.RuleTable.IsNum"><label for="Value" class="rf-label"><span for="Value" ng-show="Condition.RuleTable.Key==null">Select Value(s)</span>{{Condition.RuleTable.Key}}</label><div ng-if="Condition.RuleTable.Key!=\'Exam Tags (RadAssist)\' && Condition.RuleTable.Key!=\'Exam Tags (RadFlow)\' && Condition.RuleTable.Key!=\'Specialty\' && Condition.RuleTable.Key!=\'Rad Subspecialty\'"><multi-select master-data="DataObject.RuleCondMultiSelect" list="Condition.Collections" ng-model="DataObject.RuleCondMultiSelect.SelectedValue" on-change="DataObject.RuleCondMultiSelect.onRowSelected(selectedData)" place-holder="Select {{Condition.RuleTable.Key}}" ng-if="Condition.RuleOperator.Value == \'IN\' || Condition.RuleOperator.Value == \'NOT IN\'" search-delay="2000" on-search="SearchRuleCollection(searchObj)"></multi-select><ui-select ng-model="Condition.RuleTableValue" theme="bootstrap" class="mult-select" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" ng-hide="Condition.RuleOperator.Value == \'IN\' || Condition.RuleOperator.Value == \'NOT IN\'"><ui-select-match class="" placeholder="Select {{Condition.RuleTable.Key}}">{{$select.selected.Value}}</ui-select-match><ui-select-choices refresh="GetRuleCollections(Condition.RuleTable,$select.search)" refresh-delay="2000" repeat="list in Condition.Collections | propsFilter: {Value: $select.search, Description: $select.search} | orderBy:\'Value\'" class="boxshadow-none"><div class="inst-selectBox" ng-bind-html="list.Value | highlight: $select.search"></div><small style="font-size:75%" ng-show="list.Description"><span>{{list.Description}}</span></small></ui-select-choices></ui-select></div><div ng-if="(Condition.RuleTable.Key==\'Exam Tags (RadAssist)\' || Condition.RuleTable.Key==\'Exam Tags (RadFlow)\') && Condition.RuleTable.Key!=\'Specialty\'"><multi-select master-data="DataObject.ExamTagsMultiSelect" list="Condition.Collections" ng-model="DataObject.ExamTagsMultiSelect.SelectedValue" on-change="DataObject.ExamTagsMultiSelect.onSelectExamTags(selectedData)" place-holder="Select {{Condition.RuleTable.Key}}" ng-if="Condition.RuleOperator.Value == \'IN\' || Condition.RuleOperator.Value == \'NOT IN\'" ng-click="GetRuleCollections(Condition.RuleTable)"></multi-select><ui-select ng-model="Condition.RuleTableValue" theme="bootstrap" class="mult-select" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" ng-hide="Condition.RuleOperator.Value == \'IN\' || Condition.RuleOperator.Value == \'NOT IN\'"><ui-select-match class="" placeholder="Select {{Condition.RuleTable.Key}}">{{$select.selected.Key}}</ui-select-match><ui-select-choices refresh="GetRuleCollections(Condition.RuleTable)" refresh-delay="2000" repeat="list in Condition.Collections | propsFilter: {Key: $select.search } | orderBy:\'Key\'" class="boxshadow-none"><div class="inst-selectBox" ng-bind-html="list.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div><div ng-if="Condition.RuleTable.Key==\'Specialty\'"><multi-select master-data="DataObject.SpecialtyMultiSelect" list="Condition.Collections" ng-model="DataObject.SpecialtyMultiSelect.SelectedValue" on-change="DataObject.SpecialtyMultiSelect.onSelectExamTags(selectedData)" place-holder="Select {{Condition.RuleTable.Key}}" ng-if="Condition.RuleOperator.Value == \'IN\' || Condition.RuleOperator.Value == \'NOT IN\'" ng-click="GetRuleCollections(Condition.RuleTable)"></multi-select><ui-select ng-model="Condition.RuleTableValue" close-on-select="true" class="mult-select p-3px-all addfltr-drpovrly" ng-hide="Condition.RuleOperator.Value == \'IN\' || Condition.RuleOperator.Value == \'NOT IN\'"><ui-select-match class="max-h-75px overflow-y-auto overflow-x-hide pos-rel d-block" placeholder="Select {{Condition.RuleTable.Key}}">{{$select.selected.SpecialityCode}}</ui-select-match><ui-select-choices refresh="GetRuleCollections(Condition.RuleTable)" repeat="list in Condition.Collections | propsFilter: {SpecialityCode: $select.search}"><div class="inst-selectBox" ng-bind-html="list.SpecialityCode | highlight: $select.search"></div></ui-select-choices></ui-select></div><div ng-if="Condition.RuleTable.Key==\'Rad Subspecialty\'"><multi-select master-data="DataObject.RadSubspecialtyMultiSelect" list="Condition.Collections" ng-model="DataObject.RadSubspecialtyMultiSelect.SelectedValue" on-change="DataObject.RadSubspecialtyMultiSelect.onSelectRadSubspecialty(selectedData)" place-holder="Select {{Condition.RuleTable.Key}}" ng-if="Condition.RuleOperator.Value == \'IN\' || Condition.RuleOperator.Value == \'NOT IN\'" ng-click="GetRuleCollections(Condition.RuleTable)"></multi-select><ui-select ng-model="Condition.RuleTableValue" close-on-select="true" class="mult-select p-3px-all addfltr-drpovrly" ng-hide="Condition.RuleOperator.Value == \'IN\' || Condition.RuleOperator.Value == \'NOT IN\'"><ui-select-match class="max-h-75px overflow-y-auto overflow-x-hide pos-rel d-block" placeholder="Select {{Condition.RuleTable.Key}}">{{$select.selected.RadSubspecialty}}</ui-select-match><ui-select-choices refresh="GetRuleCollections(Condition.RuleTable)" repeat="list in Condition.Collections | propsFilter: {RadSubspecialty: $select.search}"><div class="inst-selectBox" ng-bind-html="list.RadSubspecialty | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="rule-table" ng-show="Condition.RuleTable.IsText || Condition.RuleOperator.IsText && !Condition.RuleTable.IsDate"><label for="Value" class="rf-label"><span for="Value" ng-show="Condition.RuleTable.Key==null">Enter Value {{Condition.RuleTable.Key}}</span>{{Condition.RuleTable.Key}}</label> <input type="text" class="blk-input form-control" ng-model="Condition.TextValue"></div><div class="rule-table" ng-show="!Condition.RuleTable.IsText && Condition.RuleTable.IsDate"><label for="Value" class="rf-label"><span for="Value" ng-show="Condition.RuleTable.Key==null">Enter Date</span> {{Condition.RuleTable.Key}}</label> <input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="{{Condition.RuleTable.Key}}" ng-model="Condition.DateValue" options="DOSopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{toolTipOrderDate}}" tooltip-placement="auto top" ng-mouseenter="resetDateRange()" ng-change="OnChangeFilter()"></div><div ng-show="!Condition.RuleTable.IsText && Condition.RuleTable.IsNum"><label for="Value" class="rf-label rule-text-overflow">Enter {{Condition.RuleTable.Key}}<span ng-if="Condition.RuleTable.Key==\'Patient Age\'">(Years)</span></label> <input type="text" class="blk-input form-control" ng-model="Condition.TextValue" oninput="this.value = this.value.replace(/[^0-9]/g, \'\');" maxlength="9"></div></div><div class="col-sm-2 col-lg-2 inflfd-ruleselHidtype" ng-show="Condition.RuleTableValue.Value==\'Hidden\' && Condition.RuleTableValue.ID==\'H\'"><div class="rule-table"><label for="Value" class="rf-label"><span for="Value">Select Hidden Type</span></label><ui-select ng-model="Condition.HiddenType" theme="bootstrap" class="mult-select" uis-open-close="onOpenClose(isOpen,$select)"><ui-select-match class="" placeholder="Select Hidden Type">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="list in HiddenTypeList" class="boxshadow-none"><div class="inst-selectBox" ng-bind-html="list.Key"></div></ui-select-choices></ui-select></div></div><div class="px-1"><label class="mb-5px">&nbsp;</label> <button type="button" class="btn rule-add-edit" tooltip-class="uibtooltipDenial" uib-tooltip="{{AddOrEdit}}" tooltip-placement="auto bottom" ng-click="SetRuleCondition()" ng-class="{\'fa fa-floppy-o\': AddOrEdit == \'Update\' , \'glyphicon glyphicon-plus\': AddOrEdit == \'Add\'}"></button> <button type="button" class="btn rule-add-edit" tooltip-class="uibtooltipDenial" uib-tooltip="Cancel" tooltip-placement="auto bottom" ng-if="EditIsVisible" ng-click="Cancel(Condition)"><span class="glyphicon glyphicon-remove"></span></button></div></div><div style="background-color:#262526!important;"><div class="spinner-overlay" ng-show="isLoading"><div class="spinner-overlay-body"></div><div class="single4"></div></div><comprulecondition rule="Rule" on-delete="onDeleteClearCondition()" on-edit="EditCondition(Rule.Groups)" view-mode="false" rule-setting="$ctrl.ruleSetting" on-clear="onDeleteClearCondition()"></comprulecondition></div><div class="w-100 mb-10px" ng-if="$ctrl.ruleSetting && Rule.IsWorkList!=\'2\'"><div class="radiol-strip fs-14px d-flex justify-content-between align-item-center"><label class="rf-label mb-0 txt-clr-16">Radiologists</label><div class="float-right"><button type="button" class="btn btn-primary" ng-click="showAssignRadiologistCmp.value=true;AssignRadiologists()">Assign Radiologists</button></div></div><cmpassignradiologists assigned-radiologist="SelectedValues.SelectedRadiologists" view-mode="false"></cmpassignradiologists></div><div class="row mt-16px"><div class="col-md-12"><a class="btn btn-default" data-dismiss="modal" aria-label="Close" ng-click="CloseRule()">Cancel</a> <button type="submit" ng-click="VisulizeBtn = false; WorkListVisible = false;" class="btn btn-primary" ng-disabled="frmEdit.$invalid">Save</button> <button type="submit" ng-click="VisulizeBtn = true; WorkListVisible = false;" class="btn btn-primary" ng-disabled="frmEdit.$invalid">Visualize</button></div></div><div class="modal fade" id="RadiologistComponentRule" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog assign-user-modal" ng-if="showAssignRadiologistCmp.value"><div class="modal-content"><assign-radiologist-grid radiologists="MasterData.Radiologists" default-tenant-site-ids="MasterData.AccessibleTenantSiteIDs" tenant-id="Rule.TenantID" selected-values="SelectedValues" on-select-radiologist="SaveSelectedRadiologist()" modal-title="Assign Radiologists" btn-text="SavebtnText" on-cancel="AssignUserCancel()" radio-logist-cmp-tooltip-id="radioLogistRuleCmp" show-assign-radiologist-cmp="showAssignRadiologistCmp"></assign-radiologist-grid></div></div></div></div></div></form><div ng-if="WorkListVisible" class="rule-vislise-worklist"><div class="w-100 fs-14px fw-500 rule-showMessage d-flex justify-content-between"><span style="text-align:left;">Rule has been saved with modifications.</span> <button type="button" class="btn close-viewrule" title="close" ng-click="CloseVisualizePanel()"><span class="glyphicon glyphicon-remove"></span></button></div><div style="background-color:#262526!important;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="Rule.loading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><ag-grid worklist="Rule" master-data="MasterData" selected-data="{Status:{key: \'RP\'}, STATFilter: 0, ShowLockStudy: true}" index="Rule.RuleID" view-mode="true" ng-class="{\'rule-grid-worklist\': (!$ctrl.ruleSetting) , \'ruleSetting-grid-worklist\': ($ctrl.ruleSetting) }"></ag-grid></div></div></div>');
$templateCache.put('app/theme/components/rule-condition-cmp/rule-condition-cmp.html','<style>\r\n    .common-tbl .ungroup-block {\r\n        width: 40px !important;\r\n    }\r\n</style><div class="w-100 max-h-200px overflow-y-auto scrollbar-macosx overflow-x-hide mb-10px b-1-s pos-rel b-clr-1 rulecondin-wrappwer" ng-show="Rule.Groups.length > 0"><div class="common-tbl" style="position: sticky; top: 0; display: block; z-index: 10;height:29px;" ng-style="{\'display\': $ctrl.viewMode ? \'none\' : \'block\'}"><table class=""><thead class="border-top-0"><tr class=""><th class="text-left group-btn" style="width: 40px !important;"><button class="pl-0" type="button" tooltip-class="uibtooltipDenial" uib-tooltip="Group Selected" tooltip-placement="auto left" ng-click="CreateConditionsGroup()" ng-model="Group" ng-disabled="DisableGroupIcon(Group) || $ctrl.viewMode"><img src="assets/images/group-icon.svg" width="18" alt="Group"></button></th><th class="text-left w-10">AND/OR</th><th class="text-left w-10">Type</th><th class="text-left w-10">Condition</th><th class="text-left w-70" ng-class="{\'w-75\': $ctrl.viewMode}">Value</th><th class="" style="width:80px; min-width:80px;" ng-if="!$ctrl.viewMode">Action</th></tr></thead></table></div><div class="pos-rel d-block common-tbl h-auto" ng-class="{\'group-of-group\': (Group.GroupID>0)}" ng-class-odd="\'group-odd\'" ng-class-even="\'group-even\'" data-jquery-scrollbar="" ng-repeat="Group in Rule.Groups" ng-if="Group.RulesConditions.length > 0 && !Group.deleted"><div ng-style="{\'display\': Group.GroupID > 0 ? \'flex\' : \'\'}"><div class="ungroup-block" ng-if="Group.GroupID > 0 && CheckConditionsInGroup(Group)" ng-disabled="$ctrl.viewMode"><button ng-click="Ungroup(Group,Cond)" type="button" tooltip-class="uibtooltipDenial" uib-tooltip="Ungroup" tooltip-placement="auto left" class="btn btn-transparent p-0" ng-disabled="$ctrl.viewMode"><img src="assets/images/ungroup-icon.svg" width="19" alt="Ungroup"></button></div><table class="" ng-class="{\'grouped-tbl\': (Group.GroupID > 0) || $ctrl.viewMode}"><thead class="border-top-0" style="z-index: 0 !important;" ng-hide="Group.GroupID > 0" ng-style="{\'display\': $ctrl.viewMode ? \'block\' : \'none\'}"><tr class=""><th class="text-left group-btn" style="width: 40px !important;" ng-show="(Rule.Groups.length > 1 && $ctrl.viewMode) || (Group.GroupID==0 && !$ctrl.viewMode)"><button class="pl-0" type="button" tooltip-class="uibtooltipDenial" uib-tooltip="Group Selected Clauses" tooltip-placement="auto left" ng-click="CreateConditionsGroup(Group)" ng-model="Group" ng-disabled="DisableGroupIcon(Group) || $ctrl.viewMode"><img src="assets/images/group-icon.svg" width="18" alt="Group"></button></th><th class="text-left w-10">AND/OR</th><th class="text-left w-10">Type</th><th class="text-left w-10">Condition</th><th class="text-left w-70" ng-class="{\'w-75\': $ctrl.viewMode}">Value</th><th class="w-10" ng-if="!$ctrl.viewMode">Action</th></tr></thead><tbody class="setheightrule"><tr ng-repeat="Condition in Group.RulesConditions" ng-hide="Condition.StatusFlag==\'D\'"><td class="text-left v-a-t py-5px pl-7px" style="padding-left: 7px; width: 40px !important;" ng-hide="Group.GroupID>0" ng-show="(Rule.Groups.length > 1 && $ctrl.viewMode) || (!$ctrl.viewMode && Group.GroupID==0)" ng-style="{\'display\': ($ctrl.viewMode && Rule.Groups.length == 1) ? \'none\' : \'\'}"><input type="checkbox" ng-if="!Condition.IsLocked" ng-model="Condition.Checked" ng-style="{\'display\': $ctrl.viewMode ? \'none\' : \'\'}" class="cmn-checkbx-input m-0" id="group_checked"></td><td class="text-left v-a-t py-5px w-10"><span ng-if="Condition.AndOr">{{Condition.AndOr}}</span><span ng-if="!Condition.AndOr">And</span></td><td class="text-left w-10 v-a-t py-5px">{{Condition.RuleTable.Key}}</td><td class="text-left w-10 v-a-t py-5px"><span ng-show="Condition.Operator==\'=\'">Is</span> <span ng-show="Condition.Operator===\'gt\'">Greater Than</span> <span ng-show="Condition.Operator===\'lt\'">Less Than</span> <span ng-show="Condition.Operator==\'>=\'">Greater Than Equals</span> <span ng-show="Condition.Operator==\'<=\'">Less Than Equals</span> <span ng-show="Condition.Operator==\'<>\'">Is Not</span> <span ng-show="Condition.Operator==\'IN\'">Contains</span> <span ng-show="Condition.Operator==\'NOT IN\'">Not Contains</span> <span ng-show="Condition.Operator==\'LIKE%\'">Start With</span> <span ng-show="Condition.Operator==\'%LIKE\'">End With</span> <span ng-show="Condition.Operator==\'<\'">Before Time</span> <span ng-show="Condition.Operator===\'>\'">After Time</span> <span ng-show="Condition.Operator==\'LIKE\'">Contains Words</span> <span ng-show="Condition.Operator==\'NOT LIKE\'">Not Contains Words</span></td><td class="text-left w-70 v-a-t py-5px" ng-class="{\'w-75\': $ctrl.viewMode}"><div class="row m-0 d-flex flex-wrap"><div ng-class="{\'col-lg-2\': $ctrl.ruleSetting || $ctrl.viewMode }" class="fs-12px p-3px-all ws-normal word-break col-md-3 col-sm-4 mlpbox-wrpr" ng-repeat="Text in Condition.RuleTableValues | orderBy:\'Value\'"><div class="p-4px-all mlp-value-box" style="background: rgba(49, 49, 49, 0.91) !important;"><div ng-if="Condition.RuleTable.ID!=\'OrderDetail.ExamTag\' && Condition.RuleTable.ID!=\'OrderDetail.RadExamTag\' && Condition.RuleTable.ID!=\'OrderDetail.ProviderSpecialityId\' && Condition.RuleTable.ID!=\'OrderDetail.RadSubspecialtyID\'"><i class="fa fa-caret-right" ng-if="Text.Value.length > 0"></i> <span>{{Text.Value}}</span> <span class="fw-500" ng-if="Text.Value.length > 0" ng-show="Text.Description"><br>{{Text.Description}}</span></div><div ng-if="Condition.RuleTable.ID==\'OrderDetail.ExamTag\' || Condition.RuleTable.ID==\'OrderDetail.RadExamTag\'"><i class="fa fa-caret-right"></i> <span>{{Text.Key}}</span></div><div ng-if="Condition.RuleTable.ID==\'OrderDetail.ProviderSpecialityId\'"><i class="fa fa-caret-right"></i> <span>{{Text.SpecialityCode}}</span></div><div ng-if="Condition.RuleTable.ID==\'OrderDetail.RadSubspecialtyID\'"><i class="fa fa-caret-right"></i> <span>{{Text.RadSubspecialty}}</span></div></div></div><div ng-if="Condition.RuleTableValue.Value.length > 0"><i class="fa fa-caret-right"></i> <span ng-if="Condition.RuleTable.ID==\'OrderDetail.ExamTag\' || Condition.RuleTable.ID==\'OrderDetail.RadExamTag\'">{{Condition.RuleTableValue.Key}}</span> <span ng-if="Condition.RuleTable.ID!=\'OrderDetail.ExamTag\' && Condition.RuleTable.ID!=\'OrderDetail.RadExamTag\' && Condition.RuleTable.ID!=\'OrderDetail.ProviderSpecialityId\' && Condition.RuleTable.ID!=\'OrderDetail.RadSubspecialtyID\'">{{Condition.RuleTableValue.Value}}</span> <span ng-show="Condition.RuleTableValue.Description"><br>{{Condition.RuleTableValue.Description}}</span> <span class="fw-500" ng-show="Condition.RuleTableValue.Value==\'Hidden\'"><br>{{Condition.HiddenType.Key}}</span></div><div ng-if="Condition.RuleTable.ID==\'OrderDetail.ProviderSpecialityId\' && Condition.RuleTableValue.SpecialityCode">{{Condition.RuleTableValue.SpecialityCode}}</div><div ng-if="Condition.RuleTable.ID==\'OrderDetail.RadSubspecialtyID\' && Condition.RuleTableValue.RadSubspecialty">{{Condition.RuleTableValue.RadSubspecialty}}</div><div ng-if="Condition.TextValue.length > 0 && Condition.RuleTable.Key!=\'Study has been unread\'"><i class="fa fa-caret-right"></i> <span>{{Condition.TextValue}}</span></div><div ng-if="Condition.Value.length > 0 && Condition.RuleTable.Key==\'Study has been unread\'"><i class="fa fa-caret-right"></i> <span>{{Condition.Value}}</span></div><div ng-if="Condition.RuleTable.Key == \'DOS\' || Condition.RuleTable.Key == \'Signed Date\' && Condition.Value"><i class="fa fa-caret-right"></i> <span>{{Condition.Value.replace(\'and\',\'-\')}}</span></div></div></td><td class="v-a-t t-overflow-initial" style="width:80px; min-width:80px;" ng-if="!$ctrl.viewMode"><span ng-if="Condition.IsLocked" tooltip-class="uibtooltipDenial" uib-tooltip="Set by the rule\'s tenant" tooltip-placement="auto left" class="btn btn-transparent txt-clr-14 border-0 my-0 py-1" style="cursor: default;"><i class="fa fa-lock fs-18px"></i></span> <button type="button" ng-if="!Condition.IsLocked" ng-click="EditCondition(Group, Condition)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit" tooltip-placement="auto left" class="btn btn-transparent txt-clr-14 border-0 my-0 px-0 py-1"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-if="!Condition.IsLocked" ng-click="DeleteCondition(Condition)" tooltip-class="uibtooltipDenial" uib-tooltip="Delete" tooltip-placement="auto left" class="btn btn-transparent txt-clr-14 border-0 my-0 py-1"><i class="fa fa-trash-o fs-18px"></i></button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/theme/components/shareExamComponent/shareExamComponent.html','<style>\r\n    .ui-select-bootstrap > .ui-select-choices {\r\n        height: 120px !important;\r\n    }\r\n    .ui-select-bootstrap .ui-select-toggle > a.btn {\r\n        top: 6px;\r\n    }\r\n    .show-hi-pri-alert.highpriority-alert-section.share-exam-hprior {\r\n        background-color: #c73e3e;\r\n        height: auto !important;\r\n        width: 60% !important;\r\n        position: absolute;\r\n        left: 0px;\r\n        top: initial;\r\n        bottom: 0;\r\n        border-top-right-radius: 6px;\r\n        z-index: 10;\r\n    }\r\n</style><div class="py-15px clearfix"><div class="col-md-6 col-sm-12 p-0 h-70px clearfix min-width-250px"><label for="username" class="rf-label">Select Provider <span>*</span>&nbsp;<span class="py-15px txt-clr-5 fw-600 fs-12px" ng-show="form.providerTouched && !SelectedRadiologist.Obj">Provider is required</span></label><ui-select class="mult-select" ng-model="SelectedRadiologist.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Radiologist" tooltip-placement="auto top" ng-required="true" ng-click="form.providerTouched=true"><ui-select-match placeholder="Select Provider" allow-clear="true">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices repeat="list in Radiologists | filter: matchRadSearch($select.search) | orderBy:\'LastName\'" position="down"><div ng-bind-html="radDisplay(list) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-12 p-0 clearfix"><textarea class="txt-area mt-1 h-70px w-100 p-5px-all" ng-model="message" placeholder="Type Message"> </textarea></div><div class="show-hi-pri-alert a-trans-t-500-cb highpriority-alert-section share-exam-hprior show-hi-pri-alert-active" ng-show="isHighPriority"><h5 class="m-0 text-center fs-12px pt-1 txt-clr-1 rounded">You have clicked on High-Priority Message. This message will be sent as a High Priority message.</h5></div><button type="button" class="btn btn-primary mt-1 pull-right" ng-disabled="!SelectedRadiologist.Obj" ng-click="SendPopupMessage(message)">Share Exam</button> <button type="button" class="btn btn-default mt-1 mr-2 pull-right" ng-disabled="!SelectedRadiologist.Obj" ng-click="isHighPriority=!isHighPriority" title="Mark as Important"><span ng-class="{\'txt-clr-6\':isHighPriority,\'txt-clr-1\':!isHighPriority}"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></button></div>');
$templateCache.put('app/theme/components/site-location-grid/site-location-grid.html','<style>\r\n    .siteDropdown .ag-theme-balham-dark .ag-body .ag-body-viewport .ag-center-cols-container .ag-row .ag-ltrs.ag-cell {\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }    \r\n\r\n    .siteLocationGridDiv {\r\n        height: 285px;\r\n        width: 230px;\r\n        position: fixed;\r\n        z-index: 9999;\r\n        border-radius: 5px;\r\n        overflow: hidden;\r\n        border: 1px solid #a2a1a1 !important;\r\n        margin-top: -4px;\r\n    }\r\n        .siteLocationGridDiv .ag-header {\r\n            background-color: #323232;\r\n        }\r\n        .siteLocationGridDiv .ag-cell {\r\n            padding-left:3px !important;\r\n        }\r\n        .siteLocationGridDiv .ag-row {\r\n            background-color: #323232;\r\n            border:0;\r\n        }\r\n        .siteLocationGridDiv .ag-group-expanded, .siteLocationGridDiv .ag-group-contracted {\r\n            margin-right: 4px;\r\n        }\r\n        .siteLocationGridDiv .ag-row-odd {\r\n            background-color: #323232;\r\n            border: 0;\r\n        }\r\n        .siteLocationGridDiv .ag-row-group-leaf-indent {\r\n            padding-left: 10px;\r\n        }\r\n        .siteLocationGridDiv .ag-checkbox .ag-input-wrapper {\r\n            line-height: 14px !important;\r\n            width: 14px !important;\r\n            height: 14px !important;\r\n            font-size: 14px !important;\r\n        }\r\n    .max-w-180px {\r\n        max-width: 180px;\r\n    }\r\n</style><div id="{{$ctrl.divId}}" class="pos-rel tultip-bottom siteLocationDropdown"><div class="location-tags-input pos-rel"><tags-input id="{{$ctrl.tagsInput}}" style="width: 100%" ng-model="selectedLocation.Obj" display-property="Location" key-property="LocationID" add-on-enter="false" add-on-comma="false" add-on-blur="false" on-tag-removed="removeTag($tag)" allow-leftover-text="true" placeholder="Select a Location" ng-click="showSiteDropdown()"><auto-complete min-length="0" load-on-empty="true" source="Search($query)"></auto-complete></tags-input><button type="button" class="pos-abs no-bg border-0 loc-cleareall abs-r-0 abs-b-0 cursor-pointer p-5px-all fs-17px txt-clr-2 fw-600" ng-if="selectedLocation.Obj && selectedLocation.Obj.length > 0" tooltip-class="uibtooltipDenial" uib-tooltip="Clear Selected" tooltip-placement="auto left" ng-click="clearSelectedLocation()">x</button> <span id="{{$ctrl.locationTooltip}}" class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px wd-max-content max-w-180px abs-t-33-p" style="z-index:999;"></span></div><div id="{{$ctrl.siteDropdown}}" class="siteDropdown" style="width: 100%; display: none"><div id="{{$ctrl.gridId}}" class="siteLocationGridDiv ag-theme-balham-dark"></div></div></div>');
$templateCache.put('app/theme/components/study-action-menu/study-action-menu.html','<style>\r\n    .modalmenu-list {\r\n        min-height: 0;\r\n        padding-right: 15px;\r\n    }\r\n\r\n        .modalmenu-list .nav.navbar-nav li a {\r\n            margin: 0;\r\n            padding: 4px 8px;\r\n            line-height: 16px;\r\n            letter-spacing: 0.3px;\r\n            position: relative;\r\n        }\r\n\r\n        .modalmenu-list .nav.navbar-nav li {\r\n            /*border-right: 1px solid #7c7c7c;*/\r\n            /*position: relative;*/\r\n        }\r\n\r\n        .modalmenu-list .nav.navbar-nav > li > a.onlyli-select::before {\r\n            display: none;\r\n        }\r\n\r\n        .modalmenu-list .nav.navbar-nav > li:not(:last-child) > a::before {\r\n            content: "";\r\n            width: 1px;\r\n            height: 18px;\r\n            background: #7c7c7c;\r\n            position: absolute;\r\n            right: 0;\r\n            top: 3px;\r\n        }\r\n\r\n        .modalmenu-list .nav.navbar-nav li a:link {\r\n            background-color: transparent !important;\r\n            color: #fff !important;\r\n        }\r\n\r\n        .modalmenu-list .nav.navbar-nav li a:hover {\r\n            background-color: transparent !important;\r\n            color: #00C7A6 !important;\r\n        }\r\n\r\n        .modalmenu-list .nav.navbar-nav .dropdown .dropdown-toggle:hover + .dropdown-menu,\r\n        .modalmenu-list .nav.navbar-nav .dropdown .dropdown-menu:hover {\r\n            display: block !important;\r\n        }\r\n\r\n        .modalmenu-list .nav.navbar-nav .dropdown .dropdown-menu li:not(:last-child) a {\r\n            border-right: 0;\r\n            border-bottom: 1px solid #504e4e;\r\n        }\r\n\r\n        .modalmenu-list .nav.navbar-nav .dropdown .dropdown-menu li a {\r\n            padding: 10px 8px;\r\n        }\r\n\r\n        .modalmenu-list .nav.navbar-nav .dropdown .dropdown-menu li a {\r\n            background: #333;\r\n        }\r\n\r\n            .modalmenu-list .nav.navbar-nav .dropdown .dropdown-menu li a:hover {\r\n                background: #000;\r\n            }\r\n\r\n    .k-window-content .rf-uib-tabset .nav.nav-tabs > li > a {\r\n        /*padding: 10px 8px;*/\r\n    }\r\n\r\n    .comp-innotab.k-window-content {\r\n        padding-top: 0;\r\n        padding-left: 5px;\r\n        padding-right: 5px;\r\n    }\r\n\r\n    .comp-innotab .modalmenu-list,\r\n    .comp-innotab .navbar-collapse.collapse {\r\n        padding-right: 0;\r\n    }\r\n\r\n    .modalmenu-list .navbar-nav > li:last-child > .dropdown-menu {\r\n        left: -74px;\r\n    }\r\n\r\n    @media only screen and (min-width: 768px) and (max-width: 1200px) {\r\n        /*.modalmenu-list .navbar-toggle {\r\n            display: block !important;\r\n            border: 0;\r\n            cursor: pointer;\r\n        }*/\r\n\r\n        /*#modalRepotMenulist.navbar-collapse.collapse {\r\n            display: none !important;\r\n        }*/\r\n\r\n        /*.modalmenu-list .navbar-toggle:hover + #modalRepotMenulist.navbar-collapse.collapse,\r\n            #modalRepotMenulist.navbar-collapse.collapse:hover {\r\n                display: block !important;\r\n                position: absolute;\r\n                width: 190px;\r\n                top: 31px;\r\n                background: #323232;\r\n                z-index: 9;\r\n                border: 1px solid #585858;\r\n                border-radius: 4px;\r\n            }*/\r\n\r\n        /* .modalmenu-list .navbar-collapse.collapse .nav.navbar-nav li:not(:last-child) {\r\n            border-right: 1px solid #7c7c7c;\r\n            width: 100%;\r\n            border-right: 0;\r\n            border-bottom: 1px solid #504e4e;\r\n        }*/\r\n\r\n        /*#modalRepotMenulist.navbar-collapse.collapse::before {\r\n            content: \'\';\r\n            width: 100%;\r\n            height: 30px;\r\n            background: transparent;\r\n            top: -27px;\r\n            right: 0;\r\n            position: absolute;\r\n            z-index: 99;\r\n            cursor: pointer;\r\n        }*/\r\n\r\n        /*.modalmenu-list .nav.navbar-nav li a {\r\n            padding: 8px;\r\n        }*/\r\n\r\n        .modalmenu-list .nav.navbar-nav .dropdown .dropdown-toggle + .dropdown-menu {\r\n            left: -36px;\r\n        }\r\n    }\r\n\r\n    @media (min-width: 768px) and (min-height: 1080px) and (orientation: portrait) {\r\n        .navbar-toggle .icon-bar {\r\n            border: 1px solid #fff;\r\n        }\r\n\r\n        .modalmenu-list .navbar-toggle {\r\n            margin: 0;\r\n        }\r\n    }\r\n</style><div><nav class="navbar m-0 border-0 modalmenu-list d-flex align-item-center justify-content-end"><button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#modalRepotMenulist"><span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button><div class="collapse navbar-collapse" id="modalRepotMenulist"><ul class="nav navbar-nav m-0 pt-2px"><li ng-repeat="menu in DataObject.actionMenu.MenuItems" ng-class="{\'dropdown\' : menu.subMenu}" ng-if="(menu.name == \'Share Exam\' ? DataObject.selectedOrder.DicomViewer : (menu.name == \'Unhide Study\' ? DataObject.selectedOrder.Status == \'H\' : (menu.name == \'Hide Study (F12)\' ? DataObject.selectedOrder.Status == \'RP\' : (menu.name == \'Not to be Read\' ? DataObject.selectedOrder.Status == \'RP\' && !DataObject.selectedOrder.IsLock : (menu.name == \'Open Discussion (F11)\' && DataObject.popUpOpened == \'Report-Discussion\' ? false : true)))))"><a class="fs-12px fw-600 txt-clr-1" data-toggle="dropdown" href="#" ng-click="ActionItemClicked(menu.name)" ng-class="{\'dropdown-toggle\' : menu.subMenu,\'onlyli-select\' : DataObject.actionMenu.WorklistName == \'Physician\' ? DataObject.popUpOpened == \'Discussion\' || DataObject.popUpOpened == \'Report-Discussion\' : false}" ng-hide="menu.name == \'Upload Attachment\' || menu.name.includes(DataObject.popUpOpened)">{{menu.name}} <i class="fa fa-angle-down" ng-if="menu.subMenu"></i></a><div class="" ng-if="menu.name == \'Upload Attachment\' && DataObject.actionMenu.WorklistName == \'Technologist\' && DataObject.popUpOpened == \'Discussion\'"><label class="my-0 py-4px mx-10px fs-12px fw-600 txt-clr-14 pos-rel"><input class="cursor-pointer w-100 type-fileupload" type="file" id="file" name="file" multiple="" onchange="angular.element(this).scope().ActionItemClicked(\'getFileDetails\',this)" accept="application/pdf,image/jpeg,image/png,.doc, .docx, .csv, .xls, .xlsx, .ppt, .pptx" title="Upload Attachment"> <span class="">{{menu.name}}</span></label></div><ul class="dropdown-menu" ng-if="menu.subMenu" ng-class="{\'dropdown-menu\' : menu.subMenu}"><li ng-repeat="submenu in menu.subMenu"><a href="#" class="fs-12px fw-600 txt-clr-1" ng-click="ActionItemClicked(submenu.name)">{{submenu.name}}</a></li></ul></li></ul></div></nav></div>');
$templateCache.put('app/theme/components/tenant-dicom-viewer/tenant-dicom-viewer.html','<style>\r\n    #ModalAddEditTenantViewerMapping.modal:before {\r\n        height: 80vh;\r\n    }\r\n    .dicom-viewer-cell-editor .form-control.ui-select-search, .dicom-viewer-cell-editor .btn-default.form-control.ui-select-toggle {\r\n        width: 200px;\r\n    }\r\n    @media (max-width: 1199px) and (min-width: 768px) {\r\n        .modal-dialog.w-40{\r\n            width:80% !important;\r\n        }\r\n        #ModalAddEditTenantViewerMapping.modal:before {\r\n            height: 100vh;\r\n        }\r\n    }\r\n\r\n</style><div class="row rf-filter-ui m-0 filterspace"><div class="col-md-3 col-sm-5 pd-lr"><div class="tultip-bottom"><ui-select class="mult-select" ng-model="DataObject.SelectedTenantFilter" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Tenant" tooltip-placement="auto top" ng-change="GetTenantDicomViewerSetting()"><ui-select-match placeholder="Select Tenant" allow-clear="false">{{$select.selected.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in DataObject.TenantsList | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-4 col-sm-4 pd-lr mob-pr-0"><button class="btn btn-primary rf-btn-xs mr-4px" ng-click="GetTenantDicomViewerSetting()">Filter</button> <button class="btn btn-default rf-btn-xs" ng-click="DataObject.SelectedTenantFilter=null; GetTenantDicomViewerSetting()">Clear</button><div class="clearfix"></div></div><div class="col-md-5 col-sm-3 pd-lr mob-pr-0"><button type="submit" ng-click="AddEditTenantViewerMapping()" class="btn btn-primary rf-btn-xs pull-right">Add Tenants</button></div></div><div class="ag-theme-balham-dark" id="tenantDicomViewerGrid" style="width: 100%; height: calc(100vh - 135px)"></div><div class="modal" id="ModalAddEditTenantViewerMapping" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog w-40"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="clearData()">&times;</button><h4 class="modal-title">Tenant-Dicom Viewer Mapping</h4></div><div class="modal-body"><form id="TenantDicomViewerForm"><div class="row m-0"><div class="col-md-6 col-sm-6 mb-10px pl-0 tultip-bottom"><label class="rf-label">Tenant *</label><ui-select class="mult-select" ng-model="DataObject.SelectedTenant" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Tenant" tooltip-placement="auto top"><ui-select-match placeholder="Select Tenant" allow-clear="false">{{$select.selected.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in DataObject.TenantToBeMapped | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6 col-sm-6 mb-10px pr-0 tultip-bottom"><label class="rf-label">Dicom Viewer *</label><ui-select class="mult-select" ng-model="DataObject.SelectedDicomViewer" tooltip-class="uibtooltipDenial" uib-tooltip="Select Dicom Viewer" tooltip-placement="auto top"><ui-select-match placeholder="Select Dicom Viewer" class="overflow-y-auto d-block w-sal lguimatch smuimatch h-auto max-h-50px overflow-y-auto">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="viewer in DataObject.DicomViewerList | filter: {Key: $select.search}"><div ng-bind-html="viewer.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="clearfix"></div><div class="col-md-12 mb-10px px-0"><div class="d-flex align-item-center justify-content-between my-10px py-6px px-8px isenable-toggle"><label class="rf-label mb-0">Is Enable</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.IsMappingEnabled"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="DataObject.IsMappingEnabled">Yes</span> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="!DataObject.IsMappingEnabled">No</span></div></div></div><div class="col-md-12 px-0"><div class="d-flex justify-content-end"><button class="btn btn-default mr-2" type="button" data-dismiss="modal" ng-click="clearData()">Cancel</button> <button class="btn btn-primary" ng-disabled="!DataObject.SelectedTenant || !DataObject.SelectedDicomViewer" ng-click="SetTenantDicomViewerSetting()">Save</button></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/theme/components/tenant-site-dropdown/tenant-site-dropdown.html','<style>\r\n    .tenantSiteDiv .ag-theme-balham-dark .ag-body .ag-body-viewport .ag-center-cols-container .ag-row .ag-ltrs.ag-cell {\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    .TenantSiteGrid {\r\n        height: 285px;\r\n        width: 230px;\r\n        z-index: 9999;\r\n        border-radius: 5px;\r\n        overflow: hidden;\r\n        border: 1px solid #a2a1a1 !important;\r\n        margin-top: -4px;\r\n    }\r\n\r\n        .TenantSiteGrid .ag-header {\r\n            background-color: #323232;\r\n        }\r\n\r\n        .TenantSiteGrid .ag-cell {\r\n            padding-left: 3px !important;\r\n        }\r\n\r\n        .TenantSiteGrid .ag-row {\r\n            background-color: #323232;\r\n            border: 0;\r\n        }\r\n\r\n        .TenantSiteGrid .ag-group-expanded, .TenantSiteGrid .ag-group-contracted {\r\n            margin-right: 4px;\r\n        }\r\n\r\n        .TenantSiteGrid .ag-row-odd {\r\n            background-color: #323232;\r\n            border: 0;\r\n        }\r\n\r\n        .TenantSiteGrid .ag-row-group-leaf-indent {\r\n            padding-left: 10px;\r\n        }\r\n\r\n        .TenantSiteGrid .ag-checkbox .ag-input-wrapper {\r\n            line-height: 14px !important;\r\n            width: 14px !important;\r\n            height: 14px !important;\r\n            font-size: 14px !important;\r\n        }\r\n    .max-w-180px {\r\n        max-width: 180px;\r\n    }\r\n</style><div id="{{$ctrl.divId}}" class="siteTenantDropdown tultip-bottom"><div class="location-tags-input pos-rel"><tags-input id="{{$ctrl.tagsInput}}" style="width: 100%" ng-model="DataObject.selectedSites" display-property="Site" key-property="SiteID" add-on-enter="false" add-on-comma="false" add-on-blur="false" on-tag-removed="removeTag($tag)" allow-leftover-text="true" placeholder="Select Site(s)" ng-click="showTenantSiteDropdown()"><auto-complete min-length="0" load-on-empty="true" source="Search($query)"></auto-complete></tags-input><button type="button" class="pos-abs no-bg border-0 loc-cleareall abs-r-0 abs-b-0 cursor-pointer p-5px-all fs-17px txt-clr-2 fw-600" ng-if="DataObject.selectedSites && DataObject.selectedSites.length > 0" tooltip-class="uibtooltipDenial" uib-tooltip="Clear Selected" tooltip-placement="auto left" ng-click="clearSelectedSites()">x</button> <span id="{{$ctrl.TenantSiteTooltip}}" class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px wd-max-content max-w-180px abs-t-33-p" style="z-index:999;">Select Site(s)</span></div><div class="pos-rel"><div id="{{$ctrl.TenantDropdown}}" class="tenantSiteDiv" style="width: 100%; height: 300px; display: none; position: absolute; z-index: 99; }"><div id="{{$ctrl.gridId}}" class="TenantSiteGrid ag-theme-balham-dark"></div></div></div></div>');
$templateCache.put('app/theme/components/tenant-site-location-cmp/tenant-site-location-cmp.html','<div class="col-md-12 px-0 tultip-bottom"><input id="{{$ctrl.idx}}" class="loc-input w-100 visb-close-icon" kendo-dropdowntree="locationDropdownTree" k-options="locationDropdownTreeOptionsPC"> <span class="tultiptext text-preline max-h-200px overflow-auto text-left tt-white sl-hsw-180px" style="top:30px!important;">{{locationtooltip}}</span></div>');
$templateCache.put('app/theme/components/user-payment-contract-detail/user-payment-contract-detail.html','<style>\r\n    .paycont-name {\r\n        background: #01bfa3;\r\n        padding: 4px 6px;\r\n        width: fit-content;\r\n        border-radius: 2px;\r\n        color: #000;\r\n    }\r\n    .mr-10px {\r\n        margin-right: 10px !important\r\n    }\r\n</style><div class="mb-15px d-flex flex-wrap"><div class="mr-10px" ng-repeat="contract in DataObject.UsersPaymentContract"><label ng-if="!contract.PaymentContractSubType" class="paycont-name fw-600">Payment Contract: {{contract.PaymentContractType | camelCaseToSpace}}</label> <label ng-if="contract.PaymentContractSubType" class="paycont-name fw-600">Helper Shift: {{contract.PaymentContractSubType | camelCaseToSpace}}</label></div></div>');
$templateCache.put('app/theme/components/user-preference/user-preference.html','<style>\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    .b-clr-3:hover {\r\n        background-color: #07e6c4 !important\r\n    }\r\n\r\n    .screen-select {\r\n        background-color: #07e6c4 !important\r\n    }\r\n\r\n    .h-120px {\r\n        height: 120px !important;\r\n    }\r\n\r\n    .disppfre-wrapper .col-xs-12.col-sm-6.col-md-6.mb-20px:nth-last-child(2),\r\n    .disppfre-wrapper .col-xs-12.col-sm-6.col-md-6.mb-20px:last-child {\r\n        margin-bottom: 0 !important;\r\n    }\r\n\r\n    #UserPreferenceMenu.panel ::-webkit-scrollbar-track {\r\n        background: rgb(38 37 38) !important;\r\n    }\r\n\r\n    #UserPreferenceMenu.panel ::-webkit-scrollbar-thumb {\r\n        background: rgb(255 255 255) !important;\r\n    }\r\n\r\n    .upref-displaybox {\r\n        box-shadow: 0px 0px 10px 0 rgba(145, 145, 145, 0.29);\r\n    }\r\n\r\n    .savebtn-wrapper {\r\n        position: fixed;\r\n        bottom: 0;\r\n        right: 0;\r\n        background: #262526;\r\n        clear: both;\r\n        padding: 10px;\r\n        width: calc(100% - 250px);\r\n        border-top: 1px solid #000;\r\n    }\r\n\r\n    .savebtnw-container {\r\n        width: 55%;\r\n    }\r\n\r\n    .chktgl-value {\r\n        width: 20px;\r\n    }\r\n    .dicom-viewer-grid .ag-popup-editor {\r\n        box-shadow: none;\r\n        border:0;\r\n        background-color: transparent;\r\n    }\r\n    .dicom-viewer-grid .ag-popup-editor tenant-site-dropdown {\r\n        width: 580px !important;\r\n    }\r\n    .dicom-viewer-grid .ag-popup-editor #UserPref {\r\n        width: 580px !important;\r\n    }\r\n    .dicom-viewer-grid .ag-popup-editor .dicom-viewer-dropdown {\r\n        width: 180px !important;\r\n    }\r\n    .dicom-viewer-grid .ag-popup-editor #UserPref, .dicom-viewer-grid .ag-popup-editor .dicom-viewer-dropdown {\r\n        /*margin: 1px 0 0 4px;*/\r\n        margin: 5px;\r\n        background: transparent;\r\n        border: 0;\r\n    }\r\n    .dicom-viewer-grid .ag-popup-editor #UserPrefSitesTooltip {\r\n        z-index:99 !important;\r\n        left: -72px !important;\r\n        top: 0 !important;\r\n        width: 140px !important;\r\n        overflow: visible !important;\r\n    }\r\n    .dicom-viewer-grid .ag-popup-editor .tultip-bottom .tultiptext::after {\r\n        content: "";\r\n        position: absolute;\r\n        top: 8px;\r\n        left: unset;\r\n        margin-left: 0;\r\n        right: -12px;\r\n        border: 6px solid red;\r\n        z-index: 1000005 !important;\r\n        border-color: transparent transparent transparent #fff;\r\n    }\r\n    .dicom-viewer-grid .ag-popup-editor #UserPref .TenantSiteGrid {\r\n        width: 100% !important;\r\n    }\r\n    .dicom-viewer-grid .ag-cell-value.ag-cell {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    /*.dicom-viewer-grid .ag-cell-value.ag-cell:first-child {\r\n        align-items: center;\r\n    }*/\r\n    .dicom-viewer-grid .ag-floating-bottom-viewport .ag-row-even {\r\n        padding-top: 0 !important;\r\n    }\r\n\r\n    .mlp-value-box {\r\n        background-color: #555555 !important;\r\n    }\r\n\r\n    .dicomview-sites {\r\n        margin-top: 3px;\r\n        margin-bottom: 3px;\r\n        overflow-y: auto;\r\n        max-height: 82px;\r\n    }\r\n\r\n    #DicomViewerSettingGrid .ag-root-wrapper.ag-layout-normal {\r\n        overflow: visible;\r\n    }\r\n    .dicom-viewer-grid .ag-poup .ag-popup-editor {\r\n        background: no-repeat;\r\n        border: none;\r\n        box-shadow: none;\r\n    }\r\n    .dicom-viewer-grid .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within {\r\n        border: 0 !important;\r\n    }\r\n    .dicom-viewer-grid .mult-select.ui-select-container .btn.btn-default.form-control {\r\n        height: 25px !important;\r\n        padding: 2px 4px !important;\r\n        border-color: #5e5e5e !important;\r\n        box-shadow: none !important;\r\n    }\r\n    .dicom-viewer-grid .location-tags-input tags-input .tags {\r\n        border-color: #5e5e5e !important;\r\n        transform: translateY(-2px);\r\n    }\r\n    .location-tags-input tags-input .tags .input {\r\n        height: 20px;\r\n        font-size: 12px;\r\n        width: 100% !important;\r\n    }\r\n    .ui-select-bootstrap > .ui-select-choices {\r\n        border-color: #5e5e5e !important;\r\n    }\r\n    @media only screen and (min-width: 768px) and (max-width: 1199px) {\r\n        .savebtn-wrapper {\r\n            width: calc(100% - 200px);\r\n        }\r\n\r\n        .savebtnw-container {\r\n            width: 85%;\r\n        }\r\n        .dicom-viewer-grid .ag-popup-editor #UserPref {\r\n            width: 298px !important;\r\n        }\r\n    }\r\n</style><div class="col-md-12 px-0 mb-0 jump-onsteps toursteps-accordn panel-group" id="accordion"><h1 class="txt-clr-1 fs-14px fw-600 mb-10px p-0">Worklist Settings</h1><div class="panel panel-default box-shadow-n mb-20px" ng-if="false"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all" data-toggle="collapse" href="#collapse4">Worklist View <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Choose between single or multi-view for enhanced workflow flexibility.</span></a></h4></div><div id="collapse4" class="panel-collapse collapse in"><div class="panel-body p-20px-all border-0"><div class="mb-20px"><label class="form-controller d-flex align-item-center flex-wrap mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="SingleMultiWrorklist" ng-model="DataObject.LoadMoreWorklist.PreferenceValue" value="0" checked="" ng-change="SavePreference(\'LoadMoreWorklist\')"> <span class="rf-label cmn-check-label pl-10px">Single View</span> <span class="d-block fs-12px txt-clr-1 fw-400 w-100 pl-25px">Displays only one selected list for streamlined viewing.</span></label></div><div class=""><label class="form-controller d-flex align-item-cente flex-wrap mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="SingleMultiWrorklist" ng-model="DataObject.LoadMoreWorklist.PreferenceValue" value="1" ng-change="SavePreference(\'LoadMoreWorklist\')"> <span class="rf-label cmn-check-label pl-10px">Multi View</span> <span class="d-block fs-12px txt-clr-1 fw-400 w-100 pl-25px">Simultaneously displays multiple worklists for efficient management.</span></label></div></div></div></div><div class="panel panel-default box-shadow-n mb-20px"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all" data-toggle="collapse" href="#collapse1">Worklist <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Choose between practice or personal worklist for efficiency.</span></a></h4></div><div id="collapse1" class="panel-collapse collapse in"><div class="panel-body p-20px-all border-0"><div class="mb-20px" ng-if="DataObject.ShowPracticeWorklistPref.PreferenceValue == \'1\'"><label class="form-controller d-flex align-item-center flex-wrap mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="PrefNewWrklst" ng-model="DataObject.DefaultWorklist.PreferenceValue" value="PSW" checked="" ng-change="SavePreference(\'DefaultWorklist\')"> <span class="rf-label cmn-check-label pl-10px">Practice Worklist</span> <span class="d-block fs-12px txt-clr-1 fw-400 w-100 pl-25px">View studies from all accessible sites for streamlined workflow.</span></label></div><div class=""><label class="form-controller d-flex align-item-cente flex-wrap mb-20px"><input class="m-0 cmn-checkbx-input" type="radio" name="PrefNewWrklst" ng-model="DataObject.DefaultWorklist.PreferenceValue" value="PRW" ng-change="SavePreference(\'DefaultWorklist\')"> <span class="rf-label cmn-check-label pl-10px">Personal Worklist</span> <span class="d-block fs-12px txt-clr-1 fw-400 w-100 pl-25px">Displays studies assigned based on rules or manually from all sites for efficient management.</span></label></div></div></div></div><div class="panel panel-default box-shadow-n mb-20px accrno-panel"><div class="panel-heading p-0 h-auto d-flex"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all pr-0">Show Locked Studies in Worklist <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Display studies locked by other users if set to "yes"; hide locked studies if set to "no".</span></a></h4><div class="d-flex align-item-center p-20px-all"><label class="checkbox-switch pref-checkbox ml-10px mb-0 mt-5px pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.ShowLockStudy.PreferenceValue" ng-change="SavePreference(\'ShowLockStudy\')"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="DataObject.ShowLockStudy.PreferenceValue">Yes</span> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="!DataObject.ShowLockStudy.PreferenceValue">No</span></div></div></div><div class="panel panel-default box-shadow-n mb-20px accrno-panel"><div class="panel-heading p-0 h-auto d-flex"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all pr-0">Show Other Users\' Assigned Studies in Worklist <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Display studies assigned to other users if set to "yes"; hide assigned studies if set to "no".</span></a></h4><div class="d-flex align-item-center p-20px-all"><label class="checkbox-switch pref-checkbox ml-10px mb-0 mt-5px pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.DoNotShowStudyAssignedToOtherUsers.PreferenceValue" checked="" ng-change="SavePreference(\'DoNotShowStudyAssignedToOtherUsers\')"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="DataObject.DoNotShowStudyAssignedToOtherUsers.PreferenceValue">Yes</span> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="!DataObject.DoNotShowStudyAssignedToOtherUsers.PreferenceValue">No</span></div></div></div><div class="panel panel-default box-shadow-n mb-20px accrno-panel"><div class="panel-heading p-0 h-auto d-flex"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all pr-0">Show Studies Added to Other Users\' Clipboard in Worklist <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Display studies added in other users\' clipboard if set to "yes"; hide clipboard studies if set to "no".</span></a></h4><div class="d-flex align-item-center p-20px-all"><label class="checkbox-switch pref-checkbox ml-10px mb-0 mt-5px pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.DoNotShowClipboardAddedStudyToOtherUsers.PreferenceValue" checked="" ng-change="SavePreference(\'DoNotShowClipboardAddedStudyToOtherUsers\')"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="DataObject.DoNotShowClipboardAddedStudyToOtherUsers.PreferenceValue">Yes</span> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="!DataObject.DoNotShowClipboardAddedStudyToOtherUsers.PreferenceValue">No</span></div></div></div><div class="panel panel-default box-shadow-n mb-20px accrno-panel" ng-if="DataObject.IsPaymentContractEnabled"><div class="panel-heading p-0 h-auto d-flex"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all pr-0">Sound Notification for Payment Collection <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Play a sound whenever your payment collection amount is updated if set to "Yes"; no sound will be played if set to "No".</span></a></h4><div class="d-flex align-item-center p-20px-all"><label class="checkbox-switch pref-checkbox ml-10px mb-0 mt-5px pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.PaymentAddedSound.PreferenceValue" checked="" ng-change="SavePreference(\'PaymentAddedSound\')"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="DataObject.PaymentAddedSound.PreferenceValue">Yes</span> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="!DataObject.PaymentAddedSound.PreferenceValue">No</span></div></div></div><div class="panel panel-default box-shadow-n mb-20px accrno-panel"><div class="panel-heading p-0 h-auto d-flex"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all pr-0">Keep cView Open After Study <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">When enabled, the cView viewer window will stay open after you finish reading a study. When disabled, it will close automatically.</span></a></h4><div class="d-flex align-item-center p-20px-all"><label class="checkbox-switch pref-checkbox ml-10px mb-0 mt-5px pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.MedDreamViewerKeepOpen.PreferenceValue" ng-change="SavePreference(\'MedDreamViewerKeepOpen\')"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="DataObject.MedDreamViewerKeepOpen.PreferenceValue">Yes</span> <span class="fs-12px txt-clr-1 pull-right mt-5px chktgl-value" ng-if="!DataObject.MedDreamViewerKeepOpen.PreferenceValue">No</span></div></div></div><div class="panel panel-default box-shadow-n mb-20px"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all" data-toggle="collapse" href="#collapse2">Dicom Viewer <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Choose preferred DICOM viewer from list for personal preference.</span></a></h4></div><div id="collapse2" class="panel-collapse collapse in"><div class="panel-body px-5px py-4px border-0"><div id="DicomViewerSettingGrid" class="DicomViewerSettingGrid ag-theme-balham-dark dicom-viewer-grid" style="height:252px;width:100%"></div><button class="btn btn-primary txt-clr-1 fs-12px mt-10px mb-10px float-left" title="Update" ng-click="SaveViewerSitePref()"><i class="fa fa-floppy-o"></i> Update</button></div></div></div><div class="panel panel-default box-shadow-n mb-20px"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all" data-toggle="collapse" href="#collapse3">Dictation System <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">Choose preferred dictation system from list for personal preference.</span></a></h4></div><div id="collapse3" class="panel-collapse collapse in"><div class="panel-body p-20px-all border-0"><div class="mb-20px" ng-repeat="dictationSystem in DataObject.DefaultDictationSystemList"><label class="form-controller d-flex align-item-center flex-wrap mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="DefDictationSystem" value="{{dictationSystem.Value}}" ng-model="DataObject.SelectedDefaultDictationSystem.PreferenceValue" checked="" ng-change="SavePreference(\'DefaultDictationSystem\')"> <span class="rf-label cmn-check-label pl-10px">{{dictationSystem.Key}}</span> <span class="d-block fs-12px txt-clr-1 fw-400 w-100 pl-25px" ng-if="dictationSystem.Value == \'PS360\'">PowerScribe dictation system for efficient medical transcription.</span> <span class="d-block fs-12px txt-clr-1 fw-400 w-100 pl-25px" ng-if="dictationSystem.Value == \'CIVR\'">Advanced dictation system for efficient medical transcription.</span></label></div><div class="d-flex"><button class="btn btn-default rf-btn-xs" ng-click="DataObject.SelectedDefaultDictationSystem.PreferenceValue = \'\';SavePreference(\'DefaultDictationSystem\')">Clear Selection</button></div></div></div></div><h1 class="txt-clr-1 fs-14px fw-600 mb-10px p-0">App Launch Settings</h1><div class="panel panel-default box-shadow-n mb-20px"><div class="panel-heading p-0 h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 p-20px-all" data-toggle="collapse" href="#collapse5">App Position <span class="fs-12px fw-400 txt-clr-1 pr-20px mb-0 mt-4px d-block">View and set the position for launching select apps in new windows within a single or multi-monitor setup.</span></a></h4></div><div id="collapse5" class="panel-collapse collapse in"><div class="panel-body p-20px-all border-0"><div class="row mx-0 mb-5px d-flex flex-wrap disppfre-wrapper" ng-show="DataObject.IsDisPref"><div class="col-xs-12 col-sm-6 col-md-6 mb-20px" ng-repeat="v in DataObject.DisplaySetting.PreferenceValue track by $index"><div class="bor-rad-4px bg-clr-31 upref-displaybox" style="border: 1px solid #606060;"><div class="usr-prf-heading d-flex align-item-center" style="border-bottom: 1px solid #606060;"><h1 class="fs-14px fw-600 px-15px py-10px m-0 txt-clr-1">{{SetDicomViewerText(v.viewer)}}</h1><a class="cursor-pointer pull-right mr-10px" title="Preview" ng-click="DisplayPreview(v)"><i class="fa fa-eye fs-18px txt-clr-14"></i></a></div><div class="usr-prf-content py-10px"><div class="mx-10px"><ui-select class="mult-select mb-10px" ng-model="v.display" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Display" tooltip-placement="auto top" ng-required="true" ng-change="setDisplayValue(v)" ng-init="setDefaultDisplay(v)"><ui-select-match placeholder="Choose a Display" allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="dis in DataObject.Display | propsFilter: {name: $select.search}" position="down"><div ng-bind-html="dis.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="row m-0"><div class="col-xs-12 col-sm-6 col-md-6"><input class="cmn-checkbx-input" type="checkbox" ng-model="v.isFullScreen"> <span class="pt-3px txt-clr-1">Full Screen</span></div><div class="col-xs-12 col-sm-6 col-md-6"><input class="cmn-checkbx-input" type="checkbox" ng-model="v.isFocused"> <span class="pt-3px txt-clr-1">Focused</span></div></div><div class="p-10px-all"><a class="cursor-pointer tultip-bottom no-bg"><div class="h-150px d-flex align-item-center" style="border: 1px solid #606060; justify-content:center" ng-if="!v.layout || v.layout==\'\'"><i class="fa fa-tv fs-30px txt-clr-14 tvhvr"></i></div><div id="cardscreen1" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L1-1\' || v.layout==\'L1-2\'"><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.5,0,0,\'L1-1\')" ng-class="{\'screen-select\':v.layout==\'L1-1\'}"></div></div><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.5,0,0.5,\'L1-2\')" ng-class="{\'screen-select\':v.layout==\'L1-2\'}"></div></div></div><div id="cardscreen2" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L2-1\' || v.layout==\'L2-2\'"><div class="col-sm-8 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.66,0,0,\'L2-1\')" ng-class="{\'screen-select\':v.layout==\'L2-1\'}"></div></div><div class="col-sm-4 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L2-2\')" ng-class="{\'screen-select\':v.layout==\'L2-2\'}"></div></div></div><div id="cardscreen3" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L3-1\' || v.layout==\'L3-2\' || v.layout==\'L3-3\'"><div class="col-sm-4 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.33,0,0,\'L3-1\')" ng-class="{\'screen-select\':v.layout==\'L3-1\'}"></div></div><div class="col-sm-4 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.33,0,0.33,\'L3-2\')" ng-class="{\'screen-select\':v.layout==\'L3-2\'}"></div></div><div class="col-sm-4 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L3-3\')" ng-class="{\'screen-select\':v.layout==\'L3-3\'}"></div></div></div><div id="cardscreen4" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L4-1\' || v.layout==\'L4-2\' || v.layout==\'L4-3\'"><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.5,0,0,\'L4-1\')" ng-class="{\'screen-select\':v.layout==\'L4-1\'}"></div></div><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px mb-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L4-2\')" ng-class="{\'screen-select\':v.layout==\'L4-2\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px" style="height:57px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L4-3\')" ng-class="{\'screen-select\':v.layout==\'L4-3\'}"></div></div></div><div id="cardscreen5" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L5-1\' || v.layout==\'L5-2\' || v.layout==\'L5-3\'|| v.layout==\'L5-4\'"><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px mb-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0,0,\'L5-1\')" ng-class="{\'screen-select\':v.layout==\'L5-1\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0.5,0,\'L5-2\')" ng-class="{\'screen-select\':v.layout==\'L5-2\'}"></div></div><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px mb-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L5-3\')" ng-class="{\'screen-select\':v.layout==\'L5-3\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L5-4\')" ng-class="{\'screen-select\':v.layout==\'L5-4\'}"></div></div></div><div id="cardscreen6" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L6-1\' || v.layout==\'L6-2\' || v.layout==\'L6-3\'"><div class="col-sm-3 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.25,0,0,\'L6-1\')" ng-class="{\'screen-select\':v.layout==\'L6-1\'}"></div></div><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.5,0,0.25,\'L6-2\')" ng-class="{\'screen-select\':v.layout==\'L6-2\'}"></div></div><div class="col-sm-3 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.25,0,0.75,\'L6-3\')" ng-class="{\'screen-select\':v.layout==\'L6-3\'}"></div></div></div><div id="cardscreen7" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L7-1\' || v.layout==\'L7-2\'"><div class="col-sm-12 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,0.5,1,0,0,\'L7-1\')" ng-class="{\'screen-select\':v.layout==\'L7-1\'}"></div></div><div class="col-sm-12 pt-2px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,0.5,1,0.5,0,\'L7-2\')" ng-class="{\'screen-select\':v.layout==\'L7-2\'}"></div></div></div><div class="tultiptext overflow-auto tt-white lingrd-1" style="left: 50% !important; top:20% !important;"><div class="w-340px"><div class="w-100 d-flex mb-5px mt-5px"><div id="screen1" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0,\'L1-1\')" ng-class="{\'screen-select\':v.layout==\'L1-1\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0.5,\'L1-2\')" ng-class="{\'screen-select\':v.layout==\'L1-2\'}"></div></div></div><div id="screen2" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-8 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.66,0,0,\'L2-1\')" ng-class="{\'screen-select\':v.layout==\'L2-1\'}"></div></div><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L2-2\')" ng-class="{\'screen-select\':v.layout==\'L2-2\'}"></div></div></div><div id="screen3" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0,\'L3-1\')" ng-class="{\'screen-select\':v.layout==\'L3-1\'}"></div></div><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0.33,\'L3-2\')" ng-class="{\'screen-select\':v.layout==\'L3-2\'}"></div></div><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L3-3\')" ng-class="{\'screen-select\':v.layout==\'L3-3\'}"></div></div></div></div><div class="w-100 d-flex my-2px"><div id="screen4" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0,\'L4-1\')" ng-class="{\'screen-select\':v.layout==\'L4-1\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px mb-4px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L4-2\')" ng-class="{\'screen-select\':v.layout==\'L4-2\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L4-3\')" ng-class="{\'screen-select\':v.layout==\'L4-3\'}"></div></div></div><div id="screen5" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px mb-4px" ng-click="setDisplay(v,0.5,0.5,0,0,\'L5-1\')" ng-class="{\'screen-select\':v.layout==\'L5-1\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px" ng-click="setDisplay(v,0.5,0.5,0.5,0,\'L5-2\')" ng-class="{\'screen-select\':v.layout==\'L5-2\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px mb-4px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L5-3\')" ng-class="{\'screen-select\':v.layout==\'L5-3\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L5-4\')" ng-class="{\'screen-select\':v.layout==\'L5-4\'}"></div></div></div><div id="screen6" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-3 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.25,0,0,\'L6-1\')" ng-class="{\'screen-select\':v.layout==\'L6-1\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0.25,\'L6-2\')" ng-class="{\'screen-select\':v.layout==\'L6-2\'}"></div></div><div class="col-sm-3 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.25,0,0.75,\'L6-3\')" ng-class="{\'screen-select\':v.layout==\'L6-3\'}"></div></div></div></div><div class="w-100 d-flex my-2px"><div id="screen7" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-12 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-30px mb-4px" ng-click="setDisplay(v,0.5,1,0,0,\'L7-1\')" ng-class="{\'screen-select\':v.layout==\'L7-1\'}"></div></div><div class="col-sm-12 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-30px" ng-click="setDisplay(v,0.5,1,0.5,0,\'L7-2\')" ng-class="{\'screen-select\':v.layout==\'L7-2\'}"></div></div></div></div></div></div></a></div></div></div></div></div><div class="row mx-0 mb-5px"><div class="col-md-12 col-sm-12"><button class="btn btn-primary txt-clr-1 fs-12px mt-10px float-left" title="" ng-click="SavePreference(\'DisplaySetting\')"><i class="fa fa-floppy-o"></i> Update</button></div></div></div></div></div></div><div ng-show="DataObject.isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div>');
$templateCache.put('app/theme/components/vc-consult-component/vc-consult-component.html','<style>\r\n    .ui-select-bootstrap > .ui-select-choices {\r\n        height: 115px !important;\r\n    }\r\n    .ui-select-bootstrap .ui-select-toggle > a.btn {\r\n        top: 6px;\r\n    }\r\n    .show-hi-pri-alert.highpriority-alert-section {\r\n        background-color: #c73e3e;\r\n        height: auto !important;\r\n        width: 60% !important;\r\n        position: absolute;\r\n        left: 0px;\r\n        top: initial;\r\n        bottom: 0;\r\n        border-top-right-radius: 6px;\r\n        z-index: 10;\r\n    }\r\n</style><div class="py-15px"><div class="col-md-3 col-sm-6 p-0 h-70px clearfix"><label for="username" class="rf-label">Select Provider <span>*</span>&nbsp;<span class="py-15px txt-clr-5 fw-600 fs-12px" ng-show="!SelectedRadiologist.Obj">Provider is required</span></label><ui-select class="mult-select" ng-model="SelectedRadiologist.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Radiologist" tooltip-placement="auto top" ng-required="true"><ui-select-match placeholder="Select Provider" allow-clear="true">{{radDisplay($select.selected)}}</ui-select-match><ui-select-choices repeat="list in Radiologists | filter: matchRadSearch($select.search)" position="down"><div><i class="fa fa-circle text-success" ng-if="list.IsOnline"></i> <i class="fa fa-circle text-gray-dark" ng-if="!list.IsOnline"></i> <span ng-bind-html="radDisplay(list) | highlight: $select.search"></span></div></ui-select-choices></ui-select></div><div class="col-md-12 p-0 clearfix"></div><div class="col-md-12 p-0 clearfix"></div><div class="col-md-12 p-0 clearfix"></div><div style="display: none;" class="show-hi-pri-alert a-trans-t-500-cb highpriority-alert-section show-hi-pri-alert-active" ng-show="isHighPriority"><h5 class="m-0 text-center fs-12px pt-1 txt-clr-1 rounded">You have clicked on High-Priority Message. This message will be sent as a High Priority message.</h5></div><button type="button" class="btn btn-primary mt-1 pull-right" ng-disabled="!SelectedRadiologist.Obj" ng-click="SendPopupMessage()">Consult Exam</button> <button style="display: none;" type="button" class="btn btn-default mt-1 mr-2 pull-right" ng-disabled="!SelectedRadiologist.Obj" ng-click="isHighPriority=!isHighPriority" title="Mark as Important"><span ng-class="{\'txt-clr-6\':isHighPriority,\'txt-clr-1\':!isHighPriority}"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></button></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/components/wl-grid-adv-date/wl-grid-adv-date.html','<span class="fs-12px d-block text-truncate" title="{{$ctrl.data}}">{{$ctrl.data}}</span>');
$templateCache.put('app/theme/components/worklist-accordion/worklist-accordion.html','<style>\r\n    .repo-discs-filterbtns.nav-pills > li > a {\r\n        background-color: #505050;\r\n    }\r\n    .fltr-mdl-worklit-wrapper .modality-wrapper {\r\n        margin-right: 10px;\r\n    }\r\n    @media screen and (min-width: 768px) and (max-width: 1200px) {\r\n        .modality-wrapper {\r\n            flex-wrap: wrap;\r\n        }\r\n\r\n        .btn-mod-all {\r\n            padding: 2px !important;\r\n        }\r\n        .modality-wrapper div label.fs-10px, .btn-mod-all {\r\n            margin-bottom: 4px !important;\r\n        }\r\n\r\n        .fltr-mdl-worklit-wrapper .k-window-titlebar.k-header {\r\n            align-items: flex-start;\r\n        }\r\n\r\n        .fltr-mdl-worklit-wrapper .k-window-title {\r\n            flex: 1;\r\n        }\r\n\r\n        .fltr-mdl-worklit-wrapper .modality-wrapper {\r\n            width: 65%;\r\n            margin-left: 30px;\r\n        }\r\n        .stepresult-pending {\r\n            margin-top: 3px;\r\n            display: block !important;\r\n        }\r\n        .stepresult-pending .rf-badge-rp.badge {\r\n            margin-left: 0 !important;\r\n        }\r\n        .pull-right.d-flex.steptoggle-worklist {\r\n            flex: 1;\r\n            margin-left: 40px;\r\n        }\r\n        .acrdn-drag {\r\n            flex: unset;\r\n        }\r\n    }\r\n</style><uib-accordion-group class="rf-uibaccr-grp" is-open="DataObject.obj.open" is-disabled="true"><div class="rsz-vrtcl-scroll" resizable="" r-directions="[\'bottom\']" r-height="obj.height" id="{{DataObject.obj.RuleID}}" ng-if="DataObject.obj.IsEnabled"><div class="active-drag-section" ng-class="{\'stepmenupending\': DataObject.index == 0}"><uib-accordion-heading><div class="text-left txt-clr-1 acrdn-drag d-flex" ng-drag="true" ng-drag-data="DataObject.obj" data-allow-transform="true"><span ng-click="openAccordian(DataObject.obj)" style="cursor:pointer;"><span class="stepexpand-worklsit d-inline-flex align-item-center" ng-class="{\'stepExpandWorklist\': DataObject.index == 0}"><i class="glyphicon fs-12px txt-clr-14 icon-hover pr-5px" ng-class="{\'glyphicon-chevron-down\': DataObject.obj.open, \'glyphicon-chevron-right\': !DataObject.obj.open}"></i></span> {{DataObject.obj.WorkListName}} <span class="stepresult-pending d-inline-flex align-item-center" ng-class="{\'stepResultPending\': DataObject.index == 0}"><span class="rf-badge-rp badge ml-6px">{{DataObject.obj.ResultPendingCount}}</span> <span class="rf-badge-rps badge ml-6px">{{DataObject.obj.STATCount}}</span> <span class="txt-clr-2 ml-6px" style="text-transform: none;">Unread wRVU {{DataObject.obj.UnreadRVU}}</span></span></span></div><div class="pull-right d-flex steptoggle-worklist" style="cursor: pointer;"><div class="d-flex align-item-center modality-wrapper"><button type="submit" ng-class="{\'active\': isModalitySelected()}" class="btn btn-primary btn-mod-all rf-btn-xs fs-10px fw-400 txt-clr-1 px-4px py-4px bor-rad-2px border-0 line-height-normal mr-5px" ng-click="ResetModalitiesSelection()">All</button><div class="d-flex align-item-center mr-5px" ng-repeat="modality in DataObject.modalities" ng-click="$event.stopPropagation();" ng-if="modality.Code != \'DX\'"><input type="checkbox" ng-model="DataObject.selectedModalities[modality.Code]" ng-change="onSelectModalities()" id="modality{{modality.Code}}{{DataObject.obj.RuleID}}" class="custom-chckbox" ng-if="modality.Code != \'CR\'"> <label for="modality{{modality.Code}}{{DataObject.obj.RuleID}}" ng-click="$event.stopPropagation();" class="fs-10px fw-400 txt-clr-1 px-4px py-4px m-0 bor-rad-2px text-center cursor-pointer" ng-if="modality.Code != \'CR\'">{{modality.Code}}{{(DataObject.obj[modality.Code])?" ("+DataObject.obj[modality.Code]+")":""}}</label> <input type="checkbox" ng-model="DataObject.selectedModalities[modality.Code]" ng-change="onSelectModalities()" id="modality{{modality.Code}}{{DataObject.obj.RuleID}}" class="custom-chckbox" ng-if="modality.Code == \'CR\'"> <label for="modality{{modality.Code}}{{DataObject.obj.RuleID}}" ng-click="$event.stopPropagation();" class="fs-10px fw-400 txt-clr-1 px-4px py-4px m-0 bor-rad-2px text-center cursor-pointer" ng-if="modality.Code == \'CR\'">{{modality.Code}}/DX{{(DataObject.obj[\'CRDX\'])?" ("+DataObject.obj[\'CRDX\']+")":""}}</label></div></div><span class="d-inline-block w-35px text-right"><button class="no-bg px-0 border-0 mr-5px" ng-click="refreshWorklist()" title="Refresh"><i class="fa fa-refresh fs-14px pt-2px txt-clr-14" aria-hidden="true"></i></button></span> <span class="d-inline-block w-35px text-right ml-3px"><label class="checkbox-switch" title="Choose next study" ng-click="$event.stopPropagation();"><input type="checkbox" class="mr-2px" ng-model="DataObject.obj.OpenClipboardNextStudy" ng-click="onChooseNextStudy(DataObject.obj)" ng-if="DataObject.obj.WorklistType == 16"> <input type="checkbox" class="mr-2px" ng-model="DataObject.obj.ChooseNextStudy" ng-click="onChooseNextStudy(DataObject.obj)" ng-if="DataObject.obj.WorklistType != 16"> <span class="checkbox-switch-slider round"></span></label></span> <span class="w-20px d-inline-block text-center" ng-if="DataObject.obj.WorklistType == 16" id="DisableResetClipboard"><button class="no-bg px-0 border-0" ng-click="$ctrl.resetClipboard()"><img class="m-0" width="14" src="assets/images/secondaryToolbarButton-rotateCcw.png" alt="Reset" title="Reset"></button></span> <span class="d-flex align-item-center stepremove-worklist" ng-class="{\'stepRemoveWorklist\': DataObject.index == 0 && DataObject.DefaultWorklists.length > 1}"><span class="d-inline-block text-right h-100-per" ng-if="DataObject.obj.Type != \'D\' && (DataObject.SelectedData.LoggedInUserID === DataObject.obj.CreatedBy || DataObject.SelectedData.userRoles.includes(\'Admin\') || DataObject.SelectedData.userRoles.includes(\'SuperAdmin\')) && !(DataObject.obj.RuleID==\'PRW\' || DataObject.obj.RuleID==\'PSW\') && (DataObject.obj.WorklistType != 16 && DataObject.obj.WorklistType != 31 && DataObject.obj.WorklistType != 51)"><a ng-click="onEditWorklist()" class="mt-2px px-2 h-100-per accrwrklist-icon d-inline-block"><i class="glyphicon glyphicon-pencil icon-hover fs-12px txt-clr-31"></i></a></span> <span class="d-inline-block h-100-per" ng-if="DataObject.obj.WorklistType != 16 && DataObject.obj.WorklistType != 31 && DataObject.obj.WorklistType != 51"><a ng-click="removeDefaultWorklist()" class="pull-right mt-2px px-2 h-100-per accrwrklist-icon d-inline-block" stop-event="click"><i class="glyphicon glyphicon-remove icon-hover pull-right fs-12px txt-clr-14"></i></a></span></span></div></uib-accordion-heading><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="DataObject.obj.loading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><ag-grid worklist="DataObject.obj" master-data="DataObject.MasterData" selected-data="DataObject.SelectedData" index="DataObject.obj.RuleID" view-mode="false" update-user-layout-pref="$ctrl.updateUserLayoutPref()" update-props="onUpdateProps()" update-moadality-count="updateMoadalityCount(modalityCount)"></ag-grid></div></div></uib-accordion-group>');
$templateCache.put('app/theme/components/worklist-ag-grid/worklist-ag-grid.html','<div id="myGrid" ng-style="{height:$ctrl.worklist.height+\'px\'}" class="ag-theme-alpine"></div>');
$templateCache.put('app/theme/components/worklist-font/worklist-font.html','<style>\r\n    .font-property-card {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 30px;\r\n        z-index: 99;\r\n        box-shadow: 0px 5px 10px black;\r\n        background: #343334 !important;\r\n        border-radius: 2px;\r\n        width: 500px;\r\n    }\r\n\r\n    .font-slider {\r\n        line-height: 18px;\r\n        display: flex;\r\n        align-items: center;\r\n        padding: 10px 0;\r\n        position: relative;\r\n        transition: all 0.5s ease;\r\n    }\r\n\r\n        .font-slider:after {\r\n            bottom: 99%;\r\n            right: 8%;\r\n            border-color: rgba(136, 183, 213, 0);\r\n            border-bottom-color: #fff;\r\n            border-width: 10px;\r\n            content: " ";\r\n            height: 0;\r\n            margin-left: -10px;\r\n            position: absolute;\r\n            pointer-events: none;\r\n            width: 0;\r\n        }\r\n\r\n\r\n    .font-slider__range {\r\n        -webkit-appearance: none;\r\n        appearance: none;\r\n        width: 100%;\r\n        cursor: pointer;\r\n        outline: none;\r\n        /*overflow: hidden;*/\r\n        margin: 5px 0;\r\n        border-radius: 16px;\r\n    }\r\n\r\n        .font-slider__range::-webkit-slider-runnable-track {\r\n            height: 10px;\r\n            background: #ccc;\r\n            border-radius: 16px;\r\n        }\r\n\r\n        .font-slider__range::-webkit-slider-thumb {\r\n            -webkit-appearance: none;\r\n            appearance: none;\r\n            height: 20px;\r\n            width: 20px;\r\n            border-radius: 50%;\r\n            background-color: #05C1A4;\r\n            margin-top: -5.5px;            \r\n            /* border: 2px solid #05C1A4;\r\n            box-shadow: -407px 0 0 400px #05C1A4;*/\r\n        }\r\n\r\n    .font-small,\r\n    .font-large {\r\n        color: #e6c03a;\r\n        font-family: ApexSerifMedium;\r\n        font-kerning: none;\r\n    }\r\n\r\n    .font-small {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .font-large {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .range-min,\r\n    .range-max {\r\n        position: absolute;\r\n        bottom: 14px;\r\n    }\r\n\r\n    .range-min {\r\n        left: 16px;\r\n        color: white;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .range-max {\r\n        right: 16px;\r\n        color: white;\r\n        font-size: 12px;\r\n    }\r\n\r\n    input[type="color"] {\r\n        border: none;\r\n        background-color: transparent;\r\n        width: 38px;\r\n        height: 38px;\r\n        outline: none;\r\n    }\r\n\r\n    #color-picker::-webkit-color-swatch {\r\n        border-radius: 7px;\r\n    }\r\n\r\n    hr {\r\n        border-top: 1px solid #616161;\r\n    }\r\n    /* Adding tick marks */\r\n    .range-slider {\r\n        flex: 1;\r\n    }\r\n\r\n    .sliderticks {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        padding: 0 10px;\r\n    }\r\n\r\n        .sliderticks span {\r\n            display: flex;\r\n            justify-content: center;\r\n            width: 1px;\r\n            height: 10px;\r\n            background: #616161;\r\n            color: #888888;\r\n            line-height: 40px;\r\n            font-size:11px;\r\n        }\r\n\r\n    /* End tick marks */\r\n    .condition-list {\r\n        max-height: 185px;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .priority-list {\r\n        border: 1px solid #616161;\r\n        border-radius: 4px;\r\n        padding: 7px;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .worklist-color {\r\n        width: 18px;\r\n        height: 16px;\r\n        border-radius: 3px;\r\n        display: inline-block;\r\n    }\r\n</style><div class="card font-property-card"><div class="card-body p-3"><div class="row m-0 d-flex justify-content-between"><h5 class="fs-14px">Worklist Font Style</h5><i ng-click="SaveOrCancelFontChanges(false)" class="glyphicon glyphicon-remove icon-hover cursor-pointer"></i></div><div class="d-flex justify-content-between align-item-center"><span class="fs-13px">Font Size</span> <input type="text" disabled="" class="form-control blk-input w-40px h-25px" ng-model="fontSize"></div><div class="font-slider"><p class="m-0 text-white d-inline-block pr-5px">A<span class="fs-9px">A</span></p><div class="range-slider"><input type="range" class="font-slider__range" min="12" max="25" ng-model="fontSize" ng-change="onInputRangeChange()"><div class="sliderticks"><span>12</span> <span>13</span> <span>14</span> <span>15</span> <span>16</span> <span>17</span> <span>18</span> <span>19</span> <span>20</span> <span>21</span> <span>22</span> <span>23</span> <span>24</span> <span>25</span></div></div></div><hr class="mt-20px mb-15px"><div class="row mx-0 mb-15px d-flex align-item-center"><div class="col-md-11 col-sm-11 pr-10px pl-0"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="SelectedData.PatientClassPriority" title="Select Patient Class - Priority" ng-disabled="PatientClassPriority.length == 0"><ui-select-match placeholder="Select Patient Class - Priority" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PatientClassPriority | propsFilter: {Value: $select.search} | orderBy: sortPatientClassPriority" position="down"><div ng-bind-html="list.Value | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-1 col-sm-1 px-0 d-flex align-item-center"><input type="color" id="color-picker" value="" ng-model="ColorCode" ng-disabled="PatientClassPriority.length == 0"></div><button class="btn-transparent btn icon-hover p-0" title="Set Color" ng-click="AddCombination()" ng-disabled="PatientClassPriority.length == 0"><i class="fa fa-plus-circle pl-5px icon-hover fs-30px txt-clr-14" aria-hidden="true"></i></button></div><div class="condition-list row px-10px"><div class="col-md-6 col-sm-6 px-5px mb-10px" ng-repeat="obj in SelectedCombination track by $index" ng-if="!obj.Deleted"><div class="row mx-0 priority-list"><div class="col-md-11 col-sm-11 px-0 d-flex align-item-center"><div class="worklist-color" ng-style="{\'background-color\':obj.Value}"></div><span class="txt-clr-1 pl-5px">{{GetPatientClassPriorityValue(obj.Key)}}</span></div><div class="col-md-1 col-sm-1 px-0"><button class="btn-transparent btn icon-hover p-0" title="Remove" ng-click="RemoveCombination(obj)"><i class="fa fa-trash fs-15px txt-clr-6" aria-hidden="true"></i></button></div></div></div></div><div class="text-right mt-20px"><button type="submit" class="btn btn-primary rf-btn-xs w-60px mr-5px mb-8px" ng-click="SaveOrCancelFontChanges(true)">Save</button> <button type="button" class="btn btn-default rf-btn-xs w-60px mb-8px" ng-click="SaveOrCancelFontChanges(false)">Cancel</button></div></div></div>');
$templateCache.put('app/theme/components/worklist-grid/worklist-grid.html','<style>\r\n    .watermark {\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        opacity: 0.25;\r\n        color: #fff;\r\n        font-size: 2em;\r\n        width: 100%;\r\n        text-align: center;\r\n        z-index: 1000;\r\n    }\r\n\r\n    ul.dropdown-menu {\r\n        z-index: 19999 !important; /* added to show right click menu in kendo window popup*/\r\n    }\r\n\r\n        ul.dropdown-menu li a.dropdown-item {\r\n            border-top: 0 !important;\r\n            border-bottom: 1px solid #686868 !important;\r\n        }\r\n        ul.dropdown-menu li:last-child a.dropdown-item {\r\n            border-top: 0 !important;\r\n            border-bottom: 0 !important;\r\n        }\r\n        ul.dropdown-menu li:nth-child(2) a.dropdown-item {\r\n            border-top: 0 !important;\r\n        }\r\n        ul.dropdown-menu li a.dropdown-item:hover {\r\n            background: #1c171c !important\r\n        }\r\n    .ui-grid-row.ui-grid-row-focused .scrollFiller\r\n    {\r\n        float: left;\r\n        border: 0;\r\n        background: #262526;\r\n    }\r\n    /* .anui .ui-grid-disable-selection {\r\n        user-select: none !important;\r\n    }*/\r\n    .custom-overlay {\r\n        background-color: rgba(0,0,0,0.83);\r\n    }\r\n</style><div id="divOrderList{{$ctrl.index}}" ui-grid="uiGridOptions" class="grid anui wlai multwrklst-uigrid" style="width:100%;" keyboard="keys" ng-style="{height:$ctrl.worklist.height+\'px\'}" ui-grid-infinite-scroll="" ui-grid-selection="" ui-grid-move-columns="" ui-grid-auto-resize="" ui-grid-expandable="" ui-grid-pinning="" ui-grid-resize-columns=""><div class="watermark" ng-if="!$ctrl.worklist.loading && !orderList.length">No data available</div></div><div class="overflow-hide-all ERA-check-detail discsn-popup" kendo-window="win_Discussion" k-on-open="isDiscussionVisible = true" k-on-close="isDiscussionVisible = false" k-title="\'Discussion\'" k-visible="false" k-width="winDiscussionWidth" k-height="defaultWindowHeight" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div style="background-color:#262526!important;"><div class="spinner-overlay" ng-show="isLoading"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div ng-if="isDiscussionVisible"><div class="denial-window"><div class="fw-500"><div class="row fw-500 mob-discussion mob-d-flex mob-flex-wrap"><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">Location :</span> <span class="report_span">{{SelectedOrder.Location}}</span></div><div class="mb-5px"><span class="report_span_title">Gender :</span> <span class="report_span">{{SelectedOrder.PatientGender}}</span></div><div class="mb-5px"><span class="report_span_title">Ordering Physician :</span><div class="hovIcon-td d-inline" ng-if="SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top:25px;"><div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{SelectedOrder.OrderingPhysicianPhone | tel}}</span></div></div></div><div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px !important;" ng-if="SelectedOrder.OrderingPhysician"><a ng-click="showContact(SelectedOrder.OrderingPhysician, SelectedOrder.Location)" class="cursor-pointer w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></div></div></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">DOS :</span> <span class="report_span">{{(SelectedOrder.OrderDate) ? (SelectedOrder.OrderDate | date:\'M/d/yy HH:mm\').toString().replace("00:00","") : \'\'}}</span></div><div class="mb-5px"><span class="report_span_title">Type :</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'E\'">Emergency</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'I\'">Inpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'O\'">Outpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'P\'">PreAdmit</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'U\'">Unknown</span></div><div class="d-inline-block pos-rel"><div class="kendo-actionbtn-section" ng-if="SelectedOrder.OptionalDicomViewer.length > 0"><div class="float-left">Dicom Viewer</div><div class="float-left pos-rel"><button class="kendo-dropbtn outline-none txt-clr-14" uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"><i class="fa fa-file-image-o k-icon-downdir fs-18px"></i></button><div class="kendo-action-dropdown-content"><a href="#" class="" ng-repeat="DV in SelectedOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(SelectedOrder, DV, false)"><span class="agfa d-block" uib-tooltip-html="\'AGFA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'AGFA\'">AGFA</span> <span class="candelis d-block" uib-tooltip-html="\'CANDELIS\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'CANDELIS\'">CANDELIS</span> <span class="konica d-block" uib-tooltip-html="\'KONICA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'KONICA\'">KONICA</span> <span class="konica d-block" uib-tooltip-html="\'KONICATEST\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'KONICATEST\'">KONICA TEST</span> <span class="synapse d-block" uib-tooltip-html="\'SYNAPSE\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'SYNAPSE\'">SYNAPSE</span> <span class="gecuv d-block" uib-tooltip-html="\'GE Centricity\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'GECUV\'">GECUV</span> <span class="gecuv d-block" uib-tooltip-html="\'CI DICOM VIEWER\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'CI-VIEWER\'">CI-VIEWER</span> <span class="gecuv d-block" uib-tooltip-html="\'North Star Konica\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'North Star Konica\'">North Star Konica</span></a></div></div><div class="clearfix"></div></div></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">Patient Name :</span> <span class="report_span">{{SelectedOrder.PatientName}}</span></div><div class="mb-5px"><span class="report_span_title">Modality :</span> <span class="report_span">{{SelectedOrder.Modality}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span class="report_span_title">DOB :</span> <span class="report_span">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span></div><div class="mb-5px"><span class="report_span_title">Procedure :</span> <span class="report_span text-breakword">{{SelectedOrder.ProcedureDesc}}</span></div><div class="mb-5px"><button type="button" ng-if="OrderDiscussion.ID && (ODType==\'Assigner\' || ODType==\'Helper\')" class="btn btn-default pull-right" ng-click="CloseOrderDiscussion()">Close Discussion</button></div></div></div><div class="text-right"><a class="cursor-pointer mb-5px" ng-if="SelectedOrder.FileCount > 0 && !showAttachment" ng-click="showFileList()">View Attachment ({{SelectedOrder.FileCount}})</a> <a class="btn btn-default mb-5px" ng-if="showAttachment" ng-click="hideFileList()"><i class="fa fa-arrow-left mr-5px"></i>Back</a></div><div ng-if="!showAttachment"><div class="row m-0"><div class="col-lg-3 col-md-3 col-sm-3 p-0 discussion-sel tultip-bottom"><div ng-if="ODType==\'Assigner\'"><div id="kddtOrderDiscussion" style="width: 100%;border-color:#424242!important;background-color:#323232!important;" kendo-dropdowntree="kddtOrderDiscussion" k-options="getOrderDiscussionOptions()"></div><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white ug-tt-width z-i-9999" style="top:35px!important; visibility: hidden;" id="OrderDiscussionAssignmentTooltip">{{orderDiscussionTooltip}}</span></div></div></div><div class="row m-0"><div class="col-md-12 p-0" ng-if="ODType==\'Discussion\' || ODType==\'Helper\'"><div class="form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea></div><div class=""><button type="button" class="btn btn-primary pull-right border-0" ng-click="SaveDiscussion()">Save</button></div></div><div class="col-md-12 pr-0 pl-0" ng-if="ODType==\'Assigner\'"><div class="col-md-12 form-group my-10px p-0"><textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea></div><button type="button" class="btn btn-primary pull-right ml-5px" ng-click="SaveOrderDiscussion()" style="display:none;">Consult Study</button> <button type="button" class="btn btn-primary pull-right ml-5px" ng-click="AssignStudy()" ng-disabled="AssignStudyFlag" style="display:none;">Assign Study</button> <button type="button" class="btn btn-primary pull-right" ng-click="SaveDiscussion()" ng-disabled="SaveDiscussionFlag">Save</button></div><div class="clearfix h-10px"></div><div class="discus-comment overflow-y-auto py-10px px-10px"><div class=""><div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div><div class="clearfix"></div></div></div></div></div><div ng-if="showAttachment && !showDiscuss" class="new-wl-discussion"><div class="discussion-attachment-sec"><div class="row m-0"><attachment-viewer ng-if="ReferenceID" dicomorder-id="ReferenceID"></attachment-viewer></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail pt-0 report-popup px-5px" kendo-window="win_ComparisonOrderReports" k-on-open="isComparisonOrderReportsVisible = true;winOpen();" k-on-close="isComparisonOrderReportsVisible = false;winComparisonOrderReports_OnClose();" k-title="\'Report\'" k-modal="true" k-visible="false" k-width="winComparisonOrderReportsWidth" k-height="defaultWindowHeight" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isComparisonOrderReportsVisible"><div class=""><div class=""><div class="row mb-20px m-0"><div class="col-md-12 p-0"><div class="" ng-if="reportList.length == 1"><div class="" id="{{OrderReport.OrderID}}"><div class="mob-report"><div class="row bg-clr-24 pt-10px pb-5px m-0 mob-d-flex mob-flex-wrap"><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Patient Name:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.Patient_LastName}}, {{report.Patient_FirstName}}">{{report.Patient_LastName}}, {{report.Patient_FirstName}}</span></div><div class="mb-5px text-truncate"><span>Patient DOB:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.Patient_DOB}}">{{report.Patient_DOB}}</span></div><div class="mb-5px text-truncate"><span>Patient Gender:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.Patient_Gender}}">{{report.Patient_Gender}}</span></div></div><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Patient Class:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.PatientClass}}">{{report.PatientClass}}</span></div><div class="mb-5px text-truncate"><span>Patient Location:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.PatientLocation}}">{{report.PatientLocation}}</span></div><div class="mb-5px text-truncate"><span>Reading Location:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.ReadingLocation}}">{{report.ReadingLocation}}</span></div></div><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Rend. Doc:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.RED_LastName}}">{{report.RED_LastName}}</span></div><div class="mb-5px"><span class="float-left">Ord. Doc:</span> <span class="txt-clr-15 float-left"><span class="hovIcon-td float-left" ng-if="report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span text-truncate float-left w-od" style="padding: 0px 0px 5px 5px;" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.OrderingPhysician}}">{{report.OrderingPhysician}}</span> <span class="iconDropdown cursor-pointer sm-pl" style="top: 24px;"><span class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{report.OrderingPhysicianPhone | tel}}</span></span></span></span> <span class="hovIcon-td tooltip-w-100px float-left" ng-if="!report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span text-truncate float-left w-od" style="padding: 0px 0px 5px 5px;" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.OrderingPhysician}}">{{report.OrderingPhysician}}</span> <span class="iconDropdown cursor-pointer sm-pl" style="top: 21px !important;" ng-if="report.OrderingPhysician"><a ng-click="showContact(report.OrderingPhysician, report.Location)" class="cursor-pointer w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></span></span></span></div><div class="clearfix"></div><div class="mb-5px text-truncate"><span>DOS:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.DOS}}">{{report.DOS}}</span></div></div><div class="col-sm-3"><div class="mb-5px text-truncate"><span>Signed Date:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" uib-tooltip="{{report.SingDate}}">{{report.SingDate}}</span></div><div class="mb-5px text-truncate"><span>Status:</span> <span class="txt-clr-15" tooltip-class="uibtooltipDenial" tooltip-placement="auto right" uib-tooltip="{{report.Status}}">{{report.Status}}</span></div><div class="mb-5px text-truncate"><div class="d-inline">Procedure:</div><div class="txt-clr-15 d-inline" tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="{{report.ProcedureDescription}}">{{report.ProcedureDescription}}</div></div><div class="mb-5px"><button class="btn btn-default mb-5px" ng-click="openShareExamWindow()">Share Exam</button></div></div></div><div class="w-100" ng-if="report.DictationValue"><div class="w-100 repoheight-1 overflow-y-auto overflow-x-hide py-10px px-15px reportmaxwin bg-clr-49"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="width:100%; display:block; line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div></div></div><div class="m-0" ng-if="reportList.length > 1"><div class="row m-0 bg-clr-24 pt-10px pb-5px mob-report"><div class="col-sm-3"><div class="mb-5px"><span>Patient Name:</span> <span class="txt-clr-15">{{report.Patient_LastName}}, {{report.Patient_FirstName}}</span></div><div class="mb-5px"><span>Patient DOB:</span> <span class="txt-clr-15">{{report.Patient_DOB}}</span></div><div class="mb-5px"><span>Patient Gender:</span> <span class="txt-clr-15">{{report.Patient_Gender}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Patient Class:</span> <span class="txt-clr-15">{{report.PatientClass}}</span></div><div class="mb-5px"><span>Patient Location:</span> <span class="txt-clr-15">{{report.PatientLocation}}</span></div><div class="mb-5px"><span>Reading Location:</span> <span class="txt-clr-15">{{report.ReadingLocation}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Rend. Doc:</span> <span class="txt-clr-15 text-breakword">{{report.RED_LastName}}</span></div><div class="mb-5px"><div class="d-inline">Ord. Doc:</div><div class="d-inline txt-clr-15"><div class="hovIcon-td d-inline" ng-if="report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px;"><span class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{report.OrderingPhysicianPhone | tel}}</span></span></div></div><div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!report.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px !important;" ng-if="report.OrderingPhysician"><a ng-click="showContact(report.OrderingPhysician, report.Location)" class="cursor-pointer w-100 p-5px-all" style="width: 150px!important;"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></div></div></div></div><div class="mb-5px"><span>DOS:</span> <span class="txt-clr-15">{{report.DOS}}</span></div></div><div class="col-sm-3"><div class="mb-5px"><span>Signed Date:</span> <span class="txt-clr-15">{{report.SingDate}}</span></div><div class="mb-5px"><span>Status:</span> <span class="txt-clr-15">{{report.Status}}</span></div><div class="mb-5px"><span>Procedure:</span> <span class="txt-clr-15">{{report.ProcedureDescription}}</span><div class="mb-5px"><button class="btn btn-default mb-5px" ng-click="openShareExamWindow()">Share Exam</button></div></div></div></div><div class="col-lg-2 col-sm-2 col-xs-3 m-0 overflow-auto pl-0 pr-0 pr-5px bg-clr-49 repoheight-2"><div ng-repeat="r in reportList | orderBy: \'OrderDate\' : true track by $index" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #fff 1px solid;cursor:pointer; word-wrap: break-word !important;">{{r.ProcedureDesc}}<div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}">DOS : {{r.OrderDate | date:\'M/d/yy\'}}<div style="text-align: right;" ng-if="r.IsReviewable == 1"><i class="fa fa-star txt-clr-8" aria-hidden="true"></i></div></div></div></div><div ng-class="ReviewOrder && ReviewOrder.IsReviewable? \'col-lg-7 col-sm-7 col-xs-9 col-sm-7 m-0 wlh-pdf\' :\'col-lg-10 col-sm-10 col-xs-9 col-sm-10 m-0 wlh-pdf pl-0\'" id="{{OrderReport.OrderID}}"><div class="row 100 ng-scope ml-0" ng-if="report.DictationValue"><div class="w-100 repoheight-2 overflow-y-auto overflow-x-hide py-10px px-10px bg-clr-49"><report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:15px;"></report></div></div></div><div ng-if="ReviewOrder && ReviewOrder.IsReviewable" class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0" id="{{OrderReport.OrderID}}"><div ng-form="review" class="p-10px-all"><div class="row"><div class="col-md-12 form-group fw-600">For Interesting Cases: <input type="checkbox" class="v-a-m mt-0" ng-checked="ReviewOrder.IsInterestingCase" ng-model="ReviewOrder.IsInterestingCase"> <span align="left" class="cursor-pointer hovIcon-td float-right"><a uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" class="cursor-pointer no-bg" ng-if="ReviewOrder.OptionalDicomViewer.length > 0"><i class="fa fa-picture-o fs-17px txt-clr-14"></i></a> <span class="iconDropdown-2" style="left:-135px;"><a class="cursor-pointer p-0 tultip-left dvnew" ng-repeat="DV in ReviewOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(OrderReport , DV, false)"><span class="agfa d-block" ng-if="DV == \'AGFA\'" uib-tooltip-html="\'AGFA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">AGFA</span> <span class="candelis d-block" ng-if="DV == \'CANDELIS\'" uib-tooltip-html="\'CANDELIS\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">CANDELIS</span> <span class="konica d-block" ng-if="DV == \'KONICA\'" uib-tooltip-html="\'KONICA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">KONICA</span> <span class="konica d-block" uib-tooltip-html="\'KONICATEST\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'KONICATEST\'">KONICA TEST</span> <span class="synapse d-block" ng-if="DV == \'SYNAPSE\'" uib-tooltip-html="\'SYNAPSE\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">SYNAPSE</span> <span class="gecuv d-block" ng-if="DV == \'GECUV\'" uib-tooltip-html="\'GE Centricity\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">GECUV</span> <span class="gecuv d-block" uib-tooltip-html="\'CI DICOM VIEWER\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'CI-VIEWER\'">CI-VIEWER</span> <span class="gecuv d-block" uib-tooltip-html="\'North Star Konica\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'North Star Konica\'">North Star Konica</span></a></span></span><div class="clearfix"></div></div><div class="col-md-12 form-group mb-5px" ng-hide="ReviewOrder.IsInterestingCase"><table class="patient-table w-100 b-1-s b-clr-1"><thead><tr class="bg-clr-23" style="border:0!important;background-color:#05c1a4!important;"><th class="w-40px text-center py-2px fw-600">Sr.</th><th class="py-2px fw-600">Score</th></tr></thead><tbody class="bg-clr-23 pt-5px h-300px"><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">1</td><td><div style="padding: 0px 5px 5px 5px;" class="txt-clr-1"><input class="pos-rel" style="top:2px;" type="radio" ng-click="ReviewOrder.Rating=\'1\'" ng-checked="ReviewOrder.Rating==\'1\'"> Concur with Interpretation</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">2</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/not ordinarily expected to be made(understandable miss)</span><div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'2a\'" ng-checked="ReviewOrder.Rating==\'2a\'">2a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'2b\'" ng-checked="ReviewOrder.Rating==\'2b\'">2b.Likely to be signficant</div></td></tr><tr class="bg-clr-23" style="border:0!important;"><td class="text-center v-a-t w-40px txt-clr-1">3</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/Should be made most of time</span><br><div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'3a\'" ng-checked="ReviewOrder.Rating==\'3a\'">3a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'3b\'" ng-checked="ReviewOrder.Rating==\'3b\'">3b.Likely to be signficant</div></td></tr><tr class="bg-clr-23" style="border: 0 !important;"><td class="text-center v-a-t w-40px txt-clr-1">4</td><td class="txt-clr-1"><span class="text-preline">Discrepancy in Interpretation/Should be made almost every time - misinterpretation of findings</span><br><div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'4a\'" ng-checked="ReviewOrder.Rating==\'4a\'">4a.Unlikely to be signficant</div><div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'4b\'" ng-checked="ReviewOrder.Rating==\'4b\'">4b.Likely to be signficant</div></td></tr></tbody></table></div><div class="col-md-6 col-sm-6 mb-10" ng-if="ReviewOrder.IsInterestingCase"><span ng-if="ReviewOrder.IsInterestingCase" style="color:red;float:left;">*</span> <input type="text" class="blk-input form-control w-100 mb-10px" name="keyword" ng-model="ReviewOrder.Keywords" placeholder="Keywords." ng-required="ReviewOrder.IsInterestingCase"><div class="clearfix"></div></div><div class="clearfix"></div><div class="col-md-12 form-group fw-600"><span ng-if="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')" style="color:red; float:left;">*</span><div class="clearfix"></div><textarea class="txt-area h-70px w-100 p-5px-all" rows="4" name="comment" ng-model="ReviewOrder.Comments" placeholder="Add a comment." ng-required="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')"> </textarea></div><div class="col-md-12"><button type="button" class="btn btn-primary h-30px px-10px fs-13px pull-left" ng-disabled="(!review.comment.$valid || !review.keyword.$valid) || (!ReviewOrder.IsInterestingCase && (!ReviewOrder.Rating || ReviewOrder.Rating==\'\'))" ng-click="SaveReviewOrder()">Save</button></div></div></div></div></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail modal-search-contact" kendo-window="win_ContactList" k-on-open="iswin_ContactListVisible = true" k-on-close="iswin_ContactListVisible = false" k-title="\'Contact\'" k-visible="false" k-width="win_ContactListWidth_new" k-height="win_ContactListHeight" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="iswin_ContactListVisible"><div class="modal-body sm-pr-0"><div class="row mb-10px"><div class="col-lg-3 mb-5px"><label>First Name</label> <input type="text" class="blk-input form-control" id="FirstName" ng-model="OrderingPhysicianFName" autocomplete="off" ng-required="true" placeholder="First Name"></div><div class="col-lg-3 mb-5px"><label>Last Name</label> <input type="text" class="blk-input form-control" id="LastName" ng-model="OrderingPhysicianLName" autocomplete="off" ng-required="true" placeholder="Last Name"></div><div class="col-lg-6 mb-5px"><label>&nbsp;</label><button class="btn btn-primary" ng-click="getContact(OrderingPhysicianFName,OrderingPhysicianLName)">Search</button> <button class="btn btn-primary" ng-click="addContact()">Add Contact</button></div></div><div class="row p-20px-all text-center pm-nrctext" ng-if="contactList.length == 0"><span class="trf-alert-text">No record found.</span></div><div class="overflow-y-auto sm-sercont-2 ord-phy-srch search-conwin"><div class="row m-0 w-100 width-mxcontent" ng-if="contactList.length > 0"><table ng-table="tableParams" class="table pos-rel wh-table overflow-x-hide overflow-y-auto"><tbody><tr ng-repeat="list in $data"><td sortable="\'FirstName\'" data-title="\'First Name\'" align="left" class="text-left">{{list.FirstName}}</td><td sortable="\'LastName\'" data-title="\'Last Name\'" align="left">{{list.LastName}}</td><td sortable="\'PrimaryLocation\'" data-title="\'Primary Location\'" align="left">{{list.PrimaryLocation}}</td><td data-title="\'Office\'" align="left"><div ng-repeat="p in spiltPhoneNumber(list.Office)" class="">{{p | tel}}</div></td><td data-title="\'Mobile\'" align="left"><div ng-repeat="p in spiltPhoneNumber(list.Mobile)" class="">{{p | tel}}</div></td><td data-title="\'Email\'" align="left" class="text-left">{{list.EmailId}}</td><td data-title="\'Edit\'" align="left" class="text-left"><button class="btn btn-default txt-clr-14 border-0 my-0 py-0" ng-click="editContact(list)"><span class="glyphicon glyphicon-pencil"></span></button></td></tr></tbody></table></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_AddEditContact" k-on-open="iswin_AddEditContactVisible = true" k-on-close="iswin_AddEditContactVisible = false" k-visible="false" k-title="win_AddEditContactTitle" k-width="win_ContactListWidth" k-height="addEditContactWindowHeight" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="iswin_AddEditContactVisible"><div class="modal-body sm-pr-0"><form id="frmContact" ng-submit="saveContact(Mobile,Office,Email)"><div class="row"><div class="col-lg-6 col-md-6 mb-8px"><label>First Name</label> <input type="text" class="blk-input form-control" ng-disabled="true" id="FirstName" ng-model="FirstName" autocomplete="off" ng-required="true" placeholder="First Name"></div><div class="col-lg-6 col-md-6 mb-8px"><label>Last Name</label> <input type="text" class="blk-input form-control" ng-disabled="true" id="LastName" ng-model="LastName" autocomplete="off" ng-required="true" placeholder="Last Name"></div><div class="col-lg-12 col-md-12 mb-8px"><label>Location</label><ui-select ng-model="loc.selectedItems" ng-required="true" name="loc" id="loc" class="mult-select"><ui-select-match placeholder="Select Location">{{$select.selected.Location}}</ui-select-match><ui-select-choices repeat="list in $ctrl.masterData.Locations | propsFilter: {Location: $select.search}" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div><small ng-if="list.Site">Site: <span ng-bind-html="list.Site | highlight: $select.search"></span></small></ui-select-choices></ui-select></div><div class="col-lg-6 col-md-6 mb-8px"><label class="">Mobile Number</label> <input type="text" class="blk-input form-control" id="Mobile" name="Mobile" ui-mask="(999) 999-9999" maxlength="20" ng-model="Mobile" autocomplete="off"></div><div class="col-lg-6 col-md-6 mb-8px"><label class="">Office Number</label> <input type="text" class="blk-input form-control" id="Office" name="Office" ui-mask="(999) 999-9999" maxlength="20" ng-model="Office" autocomplete="off"></div><div class="col-lg-12 col-md-12 mb-12px"><label class="">Email</label> <input type="email" class="blk-input form-control" id="Email" name="Email" ng-model="Email" autocomplete="off"></div><div class="col-lg-12 col-md-3"><button class="btn btn-primary" ng-disabled="frmContact.$invalid">Save</button></div></div></form></div></div></div><div class="overflow-hide-all ERA-check-detail" kendo-window="win_SingReport" k-on-open="isSingReportVisible = true" k-on-close="isSingReportVisible = false;winSingReport_OnClose();" k-title="\'Open Study\'" k-visible="false" k-modal="true" k-width="win_SingReportWidth" k-height="230" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Close"]\' k-animation="false"><div ng-if="isSingReportVisible"><div class="denial-window pt-10px"><div class="row card-bg-white denial-window-head"><div class="col-md-12 mb-10px"><div><span class="report_span_title">Site :</span> <span class="report_span">{{SingReport.CurrentSite}}</span></div></div><div class="col-md-12 mb-10px"><div><span class="report_span_title">MRN :</span> <span class="report_span">{{SingReport.CurrentPatientMRN}}</span></div></div><div class="col-md-12 mb-10px"><div><span class="report_span_title">Patient :</span> <span class="report_span">{{SingReport.CurrentPatient}}</span></div></div><div class="col-md-12 mb-20px"><div><span class="report_span_title">Accession :</span> <span class="report_span">{{SingReport.CurrentAccession}}</span></div></div><div class="col-md-12"><button ng-click="SignAndPrevRec()" class="btn btn-primary btn-sm tultip-bottom" title="" ng-disabled="SingbtnDisabled" tooltip-class="uibtooltipDenial" uib-tooltip="{{SingReport.PrevToolTip}}" tooltip-placement="auto right"><i class="fa fa-chevron-left pr-2px"></i>Previous</button> <button ng-click="SignAndNextRec()" class="btn btn-primary btn-sm tultip-bottom" title="" ng-disabled="SingbtnDisabled" tooltip-class="uibtooltipDenial" uib-tooltip="{{SingReport.NextToolTip}}" tooltip-placement="auto right">Next<i class="fa fa-chevron-right pl-2px"></i></button></div></div></div></div></div><div class="overflow-hide-all no-min-h-310px height-auto ERA-check-detail" kendo-window="win_HideStudy" k-on-open="isHideStudyVisible = true" k-on-close="isHideStudyVisible = false" k-title="\'Hide Study\'" k-visible="false" k-width="win_HideStudyWidth" k-height="hideStudyWindowHeight" k-resize="winResize" k-dragend="winDragend" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="isHideStudyVisible"><form id="hidehours" class="tooltip-w-180px"><div class="row pt-15px mb-20px"><div class="col-lg-12"><label class="form-controller d-flex align-item-center mb-0"><input type="radio" ng-model="HideOption" class="m-0 cmn-checkbx-input" value="NotRead" id="IsLocationShow" autocomplete="off" ng-change="changeHideStudyOption(HideOption)"><span class="rf-label cmn-check-label">Not to be Read</span>. <i class="fa fa-info-circle pl-5px" tooltip-class="uibtooltipDenial" tooltip-placement="bottom" uib-tooltip="This study will be moved under the hidden status, it will stay hidden until the user manually moves it back to the worklist."></i></label></div></div><div class="row mb-20px"><div class="col-lg-12"><div><label class="form-controller d-flex align-item-center mb-0"><input type="radio" ng-model="HideOption" class="m-0 cmn-checkbx-input" value="Hide" id="IsAccessionShow" autocomplete="off" ng-change="changeHideStudyOption(HideOption)"><span class="rf-label cmn-check-label pr-5px">Hide for</span> <input type="number" class="blk-input form-control w-60px d-inline-block" min="1" max="240" ng-model="hideHours"><span class="rf-label pl-5px">hour(s).</span> <i class="fa fa-info-circle pl-5px" tooltip-class="uibtooltipDenial" tooltip-placement="right" uib-tooltip="This study will be hidden for {{hideHours}} hours and it will appear in the worklist automatically after {{hideHours}} hours."></i></label></div></div></div><div class="row mb-20px"><div class="col-lg-12"><label class="form-controller d-flex align-item-center mb-0"><input type="radio" ng-model="HideOption" class="m-0 cmn-checkbx-input" value="Comparison" id="IsDOSShow" autocomplete="off" ng-change="changeHideStudyOption(HideOption)"><span class="rf-label cmn-check-label">Need Comparison</span>. <i class="fa fa-info-circle pl-5px" tooltip-class="uibtooltipDenial" tooltip-placement="right" uib-tooltip="This study will be hidden until we receive any comparison for it. Then it will be automatically moved to the worklist. If we don\'t get any comparison for it in 24 hours, it will be moved to the worklist after these 24 hours."></i></label></div></div><div class="row mb-20px"><div class="col-lg-12"><label class="form-controller d-flex align-item-center mb-0"><input type="radio" ng-model="HideOption" class="m-0 cmn-checkbx-input" value="NeedMoreImages" id="MoreImage" autocomplete="off" ng-change="changeHideStudyOption(HideOption)"><span class="rf-label cmn-check-label">Need Additional Images</span>. <i class="fa fa-info-circle pl-5px" tooltip-class="uibtooltipDenial" tooltip-placement="right" uib-tooltip="This study will be hidden until we receive remaining images of same study. Then it will be automatically moved to the worklist. If we don\'t get remaining images for it in 24 hours, it will be moved to the worklist after these 24 hours."></i></label></div></div><div class="row mb-10px" ng-if="HideOption === \'NeedMoreImages\'"><div class="col-lg-12"><div class="pl-20px"><textarea class="txt-area h-70px w-100" maxlength="2000" id="Comments" name="Comments" ng-model="Comments" placeholder="Add a comment" autocomplete="off"> </textarea></div></div></div><div class="w-100 py-15px"><div class="float-right"><button type="submit" class="btn btn-default mr-5px" data-dismiss="modal" ng-click="CancelHideStudy()">Cancel</button> <button type="submit" class="btn btn-primary" ng-click="HideStudy(hideHours, Comments)">Save</button></div><div class="clearfix"></div></div></form></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs" kendo-window="win_shareExamsWindow" k-on-open="isShareExamWindowVisible = true;" k-on-close="isShareExamWindowVisible = false;" k-title="\'Share Exams\'" k-modal="true" k-visible="false" k-width="winShareExamWindowWidth" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isShareExamWindowVisible"><div class="row mr-0 px-10px"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><shareexam on-send="setUserChat" selected-order="SelectedOrder" check="isShareExamWindowVisible" on-close="onCloseShareExamWindowHandler(check)"></shareexam></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs" kendo-window="win_consultExamsWindow" k-on-open="isConsultExamsWindow = true;" k-on-close="isConsultExamsWindow = false;" k-title="\'Consult Exams\'" k-modal="true" k-visible="false" k-width="winConsultExamWindowWidth" k-dragend="winDragend" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isConsultExamsWindow"><div class="row px-10px mr-0"><patientdetails selected-order="SelectedOrder"></patientdetails><div class="w-100 pt-10px pb-0 px-5px"><videocallconsult class="clearfix video-call-consult" on-send="setUserChat" selected-order="SelectedOrder" check="isConsultExamsWindow" on-close="onCloseConsultExamWindowHandler(check)"></videocallconsult></div></div></div></div><div class="overflow-hide-all ERA-check-detail report-popup pr-1px ord-eve-logs" kendo-window="win_OrderEventLog" k-on-open="isOrderEventLogVisible = true;" k-on-close="isOrderEventLogVisible = false;" k-title="\'Order Event Logs\'" k-modal="true" k-visible="false" k-width="winComparisonOrderReportsWidth" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Minimize", "Maximize", "Close"]\' k-animation="false"><div ng-if="isOrderEventLogVisible"><div class=""><div class=""><div class="row mr-0"><div class=""><div class="bg-clr-24 rslvd-ovrflw"><div class="col-sm-3 mob-width-50"><div class="mb-10px"><span>Patient Name:</span> <span class="txt-clr-15">{{SelectedOrder.PatientName}}</span></div><div class="mb-10px"><span>Patient DOB:</span> <span class="txt-clr-15">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span></div><div class="mb-10px"><span>Patient Gender:</span> <span class="txt-clr-15">{{SelectedOrder.PatientGender}}</span></div></div><div class="col-sm-3 mob-width-50"><div class="mb-10px"><span>Patient Class:</span><span class="report_span" ng-if="SelectedOrder.PatientClass==\'E\'">Emergency</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'I\'">Inpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'O\'">Outpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'P\'">PreAdmit</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'U\'">Unknown</span></div><div class="mb-10px"><span>Patient Location:</span> <span class="txt-clr-15">{{SelectedOrder.Location}}</span></div><div class="mb-10px"><span>Status:</span> <span class="txt-clr-15">{{SelectedOrder.Status}}</span></div></div><div class="col-sm-6 mob-width-100 mob-d-flex mob-flex-wrap"><div class="mb-10px mob-mb-0 mob-width-50"><div class="d-inline">Ord. Doc:</div><div class="txt-clr-15 d-inline"><div class="hovIcon-td d-inline" ng-if="SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 25px;"><div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all">Contact: <span class="txt-clr-15">{{SelectedOrder.OrderingPhysicianPhone | tel}}</span></div></div></div><div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!SelectedOrder.OrderingPhysicianPhone"><span class="cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span><div class="iconDropdown cursor-pointer sm-pl" style="top: 19px !important;" ng-if="SelectedOrder.OrderingPhysician"><a ng-click="showContact(SelectedOrder.OrderingPhysician, SelectedOrder.Location)" class="cursor-pointer p-5px-all ordevntlog"><span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span></a></div></div></div></div><div class="mb-10px mob-mb-0 mob-width-50 mob-pl-15"><span>Procedure:</span> <span class="txt-clr-15">{{SelectedOrder.ProcedureDesc}}</span></div></div></div><div class="w-100"><div class="w-100 overflow-y-auto overflow-x-hide pt-10px pb-0 px-5px order-event-logsec"><event-log order-id="SelectedOrder.OrderID" accession="SelectedOrder.Accession"></event-log></div></div></div></div></div></div></div></div><div class="overflow-hide-all ERA-check-detail px-0 py-0" kendo-window="win_ModalReportNDiscuss" k-visible="false" k-width="win_ModalReportNDiscussWidth" k-height="defaultWindowHeight" k-title="\'Report - Discussion\'" k-resize="winResize" k-dragend="winDragend" k-on-open="isModalReportNDiscussVisible = true;" k-on-close="isModalReportNDiscussVisible = false;" k-modal="true" k-animation="false" k-actions=\'["Minimize", "Maximize", "Close"]\'><div ng-if="isModalReportNDiscussVisible" class="mdl-report-discsn"><uib-tabset active="ModalReportNDiscussActiveIndex" class="rf-uib-tabset"><uib-tab index="$index" ng-repeat="tab in ModalReportNDiscussionTabs" heading="{{tab.title}}" disable="tab.disabled"><div ng-include="tab.templateUrl"></div></uib-tab></uib-tabset></div></div><script type="text/ng-template" id="tree_item_renderer.html"><div> <div> <div class="wrps-discus-chats fs-13px text-break-word bg-clr-29 bor-rad-5px p-15px-all"> <p class="discus-chats txt-clr-1 mb-0" style="white-space:pre-line">{{Dis.Comment | htmlDecode}}</p> </div> <div class="float-right py-5px"> <div class="tultip-top float-left"> <a class="btn btn-default glyphicon glyphicon-share-alt border-0" ng-click="Dis.IsChild=!Dis.IsChild"></a> <span class="tultiptext">Reply</span> </div> <div class="float-left pt-3px"> <span class="txt-clr-1 fs-15px dis-crt-name" ng-if="$ctrl.disName(Dis)">{{$ctrl.disName(Dis) | htmlDecode}}</span> <span class="txt-clr-2 fs-12px"> {{Dis.Record_Created_At|localDate :false }}</span> </div> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div class="" ng-if="Dis.IsChild"> <div class="mb-10px w-70 pull-right"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Dis.ChildComment" placeholder="Add a comment"> </textarea> </div> <div class="clearfix"></div> <div class="mb-10px"> <button type="button" class="btn btn-primary pull-right" ng-click="SaveChildDiscussion(Dis)">Save</button> <div class="clearfix"></div> </div> </div> </div> <div class="clearfix"></div> </div> <ul style="list-style:none"> <li class="mb-10px" ng-repeat="Dis in Dis.Childs" ng-include="\'tree_item_renderer.html\'"></li> </ul></script><div class="overflow-hide-all ERA-check-detail" kendo-window="win_PSUser" k-on-open="isPSUserVisible = true" k-on-close="isPSUserVisible = false" k-title="\'Login\'" k-visible="false" k-width="win_PSUserWidth" k-height="300" k-dragend="winDragend" k-resize="winResize" k-actions=\'["Close"]\'><div ng-if="isPSUserVisible"><div class="pScript m-0-auto pb-20px"><h5>Please provide your credentials below for the dictation system where your radiology report needs to be placed.</h5><form name="PSUserform" id="PSUserform" ng-submit="InsertPSUsersBySIte(PSUserform.$valid)"><div class="w-30 float-left"><label class="rf-label">Location:</label></div><div class="w-70 float-left"><label class="fw-500 txt-clr-1 p-2px-all">{{SingReport.OrderList[SingReport.Index].Location}}</label></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Username:</label></div><div class="w-70 float-left"><input type="text" id="PSUserUsername" name="PSUserUsername" ng-model="PSUser.Username" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Password:</label></div><div class="w-70 float-left"><input type="password" id="PSUserPassword" name="PSUserPassword" ng-model="PSUser.Password" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-primary">Log On</button></div><div class="clearfix"></div></form></div></div></div><script type="text/ng-template" id="modal_report_tab.html"><div id="Report" style="opacity:1 !important" class="overflow-x-hide pt-0 pr-0 p-0"> <div class="max-h-90vh h-80vh p-0 mt-5px" ng-if="!isReportAvailable"> Report not available </div> <div class="" ng-if="isReportAvailable"> <!--<div class="row mb-20px m-0" id="OrderReport{{OrderReport.Accession}}" ng-if="OrderReport.OrderReport.ReportDecation.length > 0">--> <div class="row mb-0 mx-0 m-0"> <div class="col-md-12 p-0"> <div class="m-0" ng-if="reportList.length == 1"> <div class="" id="{{OrderReport.OrderID}}"> <!--<report-viewer ng-if="selecteReportId" source-id="selecteReportId"></report-viewer>--> <div class="row m-0 bg-clr-24 pt-10px pb-5px make-col-50"> <div class="col-sm-3"> <div class="mb-5px"> <span> Patient Name: </span> <span class="txt-clr-15"> {{report.Patient_LastName}}, {{report.Patient_FirstName}} </span> </div> <div class="mb-5px"> <span> Patient DOB: </span> <span class="txt-clr-15"> {{report.Patient_DOB}} </span> </div> <div class="mb-5px"> <span> Patient Gender: </span> <span class="txt-clr-15"> {{report.Patient_Gender}} </span> </div> </div> <div class="col-sm-3"> <div class="mb-5px"> <span> Patient Class: </span> <span class="txt-clr-15"> {{report.PatientClass}} </span> </div> <div class="mb-5px"> <span> Patient Location: </span> <span class="txt-clr-15"> {{report.PatientLocation}} </span> </div> <div class="mb-5px"> <span> Reading Location: </span> <span class="txt-clr-15"> {{report.ReadingLocation}} </span> </div> </div> <div class="col-sm-3"> <div class="mb-5px"> <span> Rend. Doc: </span> <span class="txt-clr-15"> {{report.RED_LastName}} </span> </div> <div class="mb-5px"> <div class="d-inline"> Ord. Doc: </div> <div class="hovIcon-td d-inline" ng-if="report.OrderingPhysicianPhone"> <span class=" cursor-pointer sm-pl report_span" style="padding: 5px 5px 5px 0px;">{{report.OrderingPhysician}}</span> <div class="iconDropdown cursor-pointer sm-pl" style="top: 21px;"> <div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all"> Contact: <span class="txt-clr-15">{{report.OrderingPhysicianPhone | tel}}</span> </div> </div> </div> <div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!report.OrderingPhysicianPhone"> <span class=" cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span> <div class="iconDropdown cursor-pointer sm-pl" style="top: 21px !important;" ng-if="report.OrderingPhysician"> <a ng-click="showContact(report.OrderingPhysician, report.Location)" class="cursor-pointer w-100 p-5px-all" style=" width: 150px!important;"> <span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span> </a> </div> </div> <!--{{report.OrderingPhysician}}<br />{{report.OrderingPhysicianPhone | tel}}--> </div> <div class="mb-5px"> <span> DOS: </span> <span class="txt-clr-15"> {{report.DOS}} </span> </div> </div> <div class="col-sm-3"> <div class="mb-5px"> <span> Signed Date: </span> <span class="txt-clr-15"> {{report.SingDate}} </span> </div> <div class="mb-5px"> <span> Status: </span> <span class="txt-clr-15"> {{report.Status}} </span> </div> <div class="mb-5px"> <span> Procedure: </span> <span class="txt-clr-15"> {{report.ProcedureDescription}} </span> </div> <div class="mb-5px"> <button class="btn btn-default mb-5px" ng-click="openShareExamWindow()">Share Exam</button> </div> </div> </div> <div ng-class="ReviewOrder && ReviewOrder.IsReviewable? \'col-lg-9 col-sm-9 col-xs-9 col-sm-9 m-0 wlh-pdf\' :\'col-lg-12 col-sm-12 col-xs-12 col-sm-12 m-0 wlh-pdf\'" id="{{OrderReport.OrderID}}" style="padding:0!important;"> <div class="w-100" ng-if="report.DictationValue"> <div class="w-100 repoheight-4 overflow-y-auto overflow-x-hide py-10px px-15px reportmaxwin-2 bg-clr-49"> <!--<pre style="word-break:break-all;white-space:pre-line; background-color:transparent; border:none;font-size:18px;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace;"> {{report.DictationValue}} </pre>--> <report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height: 1.4;font-family: Menlo, Monaco, Consolas, \'Courier New\', monospace !important;white-space: pre-line;background-color: transparent;border: none;font-size: 16px;"></report> </div> </div> </div> <div ng-if="ReviewOrder && ReviewOrder.IsReviewable" class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0" id="{{OrderReport.OrderID}}"> <div ng-form="review" class="p-10px-all"> <div class="row"> <div class="col-md-12 form-group fw-600"> For Interesting Cases: <input type="checkbox" class="v-a-m mt-0" ng-checked="ReviewOrder.IsInterestingCase" ng-model="ReviewOrder.IsInterestingCase" /> <span align="left" class="cursor-pointer hovIcon-td float-right"> <a uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" class="cursor-pointer no-bg" ng-if="ReviewOrder.OptionalDicomViewer.length > 0"> <i class="fa fa-picture-o fs-17px txt-clr-14"></i> </a> <span class="iconDropdown-2" style="left:-135px;"> <a class="cursor-pointer p-0 tultip-left dvnew" ng-repeat="DV in ReviewOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(OrderReport , DV, false)"> <span class="agfa d-block" ng-if="DV == \'AGFA\'" uib-tooltip-html="\'AGFA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">AGFA</span> <span class="candelis d-block" ng-if="DV == \'CANDELIS\'" uib-tooltip-html="\'CANDELIS\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">CANDELIS</span> <span class="konica d-block" ng-if="DV == \'KONICA\'" uib-tooltip-html="\'KONICA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">KONICA</span> <span class="konica d-block" uib-tooltip-html="\'KONICATEST\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'KONICATEST\'">KONICA TEST</span> <span class="synapse d-block" ng-if="DV == \'SYNAPSE\'" uib-tooltip-html="\'SYNAPSE\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">SYNAPSE</span> <span class="gecuv d-block" ng-if="DV == \'GECUV\'" uib-tooltip-html="\'GE Centricity\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">GECUV</span> <span class="gecuv d-block" uib-tooltip-html="\'CI DICOM VIEWER\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'CI-VIEWER\'">CI-VIEWER</span> <span class="gecuv d-block" uib-tooltip-html="\'North Star Konica\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'North Star Konica\'">North Star Konica</span> </a> </span> </span> <div class="clearfix"></div> </div> <div class="col-md-12 form-group mb-5px" ng-hide="ReviewOrder.IsInterestingCase"> <table class="patient-table w-100 b-1-s b-clr-1"> <thead> <tr class="bg-clr-23" style="border:0!important;background-color:#05c1a4!important;"> <th class="w-40px text-center py-2px fw-600">Sr.</th> <th class="py-2px fw-600">Score</th> </tr> </thead> <tbody class="bg-clr-23 pt-5px h-300px"> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">1</td> <td> <div style="padding: 0px 5px 5px 5px;"> <input type="radio" ng-click="ReviewOrder.Rating=\'1\'" ng-checked="ReviewOrder.Rating==\'1\'"> Concur with Interpretation </div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">2</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/not ordinarily expected to be made(understandable miss)</span> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'2a\'" ng-checked="ReviewOrder.Rating==\'2a\'">2a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'2b\'" ng-checked="ReviewOrder.Rating==\'2b\'">2b.Likely to be signficant</div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">3</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/Should be made most of time</span> <br> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'3a\'" ng-checked="ReviewOrder.Rating==\'3a\'">3a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'3b\'" ng-checked="ReviewOrder.Rating==\'3b\'">3b.Likely to be signficant</div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">4</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/Should be made almost every time - misinterpretation of findings</span><br /> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'4a\'" ng-checked="ReviewOrder.Rating==\'4a\'">4a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'4b\'" ng-checked="ReviewOrder.Rating==\'4b\'">4b.Likely to be signficant</div> </td> </tr> </tbody> </table> </div> <div class="col-md-6 col-sm-6 mb-10" ng-if="ReviewOrder.IsInterestingCase"> <span ng-if="ReviewOrder.IsInterestingCase" style="color:red;float:left;">*</span> <input type="text" class="blk-input form-control w-100 mb-10px" name="keyword" ng-model="ReviewOrder.Keywords" placeholder="Keywords." ng-required="ReviewOrder.IsInterestingCase"> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div class="col-md-12 form-group fw-600"> <span ng-if="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')" style="color:red; float:left;">*</span> <div class="clearfix"></div> <textarea class="txt-area h-70px w-100 p-5px-all" rows="4" name="comment" ng-model="ReviewOrder.Comments" placeholder="Add a comment." ng-required="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')"> </textarea> </div> <div class="col-md-12"> <button type="button" class="btn btn-primary h-30px px-10px fs-13px pull-left" ng-disabled="(!review.comment.$valid || !review.keyword.$valid) || (!ReviewOrder.IsInterestingCase && (!ReviewOrder.Rating || ReviewOrder.Rating==\'\'))" ng-click="SaveReviewOrder()">Save</button> </div> </div> </div> </div> </div> </div> </div> </div> <div class="m-0" ng-if="reportList.length > 1"> <div class="row m-0 bg-clr-24 pt-10px pb-5px make-col-50"> <div class="col-sm-3"> <div class="mb-5px"> <span> Patient Name: </span> <span class="txt-clr-15"> {{report.Patient_LastName}}, {{report.Patient_FirstName}} </span> </div> <div class="mb-5px"> <span> Patient DOB: </span> <span class="txt-clr-15"> {{report.Patient_DOB}} </span> </div> <div class="mb-5px"> <span> Patient Gender: </span> <span class="txt-clr-15"> {{report.Patient_Gender}} </span> </div> </div> <div class="col-sm-3"> <div class="mb-5px"> <span> Patient Class: </span> <span class="txt-clr-15"> {{report.PatientClass}} </span> </div> <div class="mb-5px"> <span> Patient Location: </span> <span class="txt-clr-15"> {{report.PatientLocation}} </span> </div> <div class="mb-5px"> <span> Reading Location: </span> <span class="txt-clr-15"> {{report.ReadingLocation}} </span> </div> </div> <div class="col-sm-3"> <div class="mb-5px"> <span> Rend. Doc: </span> <span class="txt-clr-15"> {{report.RED_LastName}} </span> </div> <div class="mb-5px"> <div class="d-inline"> Ord. Doc: </div> <div class="txt-clr-15 d-inline"> <div class="hovIcon-td d-inline" ng-if="report.OrderingPhysicianPhone"> <span class=" cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span> <div class="iconDropdown cursor-pointer sm-pl" style="top: 25px;"> <div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all"> Contact: <span class="txt-clr-15">{{report.OrderingPhysicianPhone | tel}}</span> </div> </div> </div> <div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!report.OrderingPhysicianPhone"> <span class=" cursor-pointer sm-pl report_span" style="padding: 5px;">{{report.OrderingPhysician}}</span> <div class="iconDropdown cursor-pointer sm-pl" style="top: 25px !important;" ng-if="report.OrderingPhysician"> <a ng-click="showContact(report.OrderingPhysician, report.Location)" class="cursor-pointer w-100 p-5px-all" style=" width: 150px!important;"> <span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span> </a> </div> </div> <!--{{report.OrderingPhysician}}<br />{{report.OrderingPhysicianPhone | tel}}--> </div> </div> <div class="mb-5px"> <span> DOS: </span> <span class="txt-clr-15"> {{report.DOS}} </span> </div> </div> <div class="col-sm-3"> <div class="mb-5px"> <span> Signed Date: </span> <span class="txt-clr-15"> {{report.SingDate}} </span> </div> <div class="mb-5px"> <span> Status: </span> <span class="txt-clr-15"> {{report.Status}} </span> </div> <div class="mb-5px"> <span> Procedure: </span> <span class="txt-clr-15"> {{report.ProcedureDescription}} </span> <div class="mb-5px"> <button class="btn btn-default mb-5px" ng-click="openShareExamWindow()">Share Exam</button> </div> </div> </div> </div> <div class="col-lg-2 col-sm-2 col-xs-3 mx-0 mb-0 overflow-auto pl-0 pr-0 pr-5px repoheight-5 leftsecmaxwindowht bg-clr-49"> <div ng-repeat="r in reportList | orderBy: \'OrderDate\' : true track by $index" ng-click="showReport(r)" class="{{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}" style="padding: 4px 10px; border-bottom: #fff 1px solid;cursor:pointer;"> {{r.ProcedureDesc}} <div class="d-flex justify-sp-btwn {{r.Accession == SelectedOrderAccession ? \'reportActive\' : \'\'}}"> DOS : {{r.OrderDate | date:\'M/d/yy\'}} <div style="text-align: right;" ng-if="r.IsReviewable == 1"><i class="fa fa-star txt-clr-8" aria-hidden="true"></i></div> </div> </div> </div> <div ng-class="ReviewOrder && ReviewOrder.IsReviewable? \'col-lg-7 col-sm-7 col-xs-7 col-sm-7 m-0 wlh-pdf\' :\'col-lg-10 col-sm-10 col-xs-9 col-sm-10 m-0 wlh-pdf pr-0 pl-0\'" id="{{OrderReport.OrderID}}"> <!--<report ng-bind-html="OrderReport.OrderReport.ReportDecation" style="white-space:pre-line;"></report>--> <!--<report-viewer ng-if="selecteReportId" source-id="selecteReportId"></report-viewer>--> <div class="w-100" ng-if="report.DictationValue"> <div class="w-100 repoheight-5 overflow-y-auto overflow-x-hide py-5px px-10px leftsecmaxwindowht bg-clr-49"> <!--<pre style="white-space:pre-line; background-color:transparent; border:none; font-size:18px; font-weight:bold;"> {{report.DictationValue}} </pre>--> <report ng-bind-html="report.DictationValue" class="report-cont-fsz" style="line-height:1.4;font-family:Menlo, Monaco, Consolas, \'Courier New\', monospace !important; white-space:pre-line;background-color:transparent; border:none; font-size:16px;"></report> </div> </div> </div> <div ng-if="ReviewOrder && ReviewOrder.IsReviewable" class="col-lg-3 col-sm-3 col-xs-3 wlh-pdf bg-clr-23 p-0" id="{{OrderReport.OrderID}}"> <div ng-form="review" class="p-10px-all"> <div class="row"> <div class="col-md-12 form-group fw-600"> For Interesting Cases: <input type="checkbox" class="v-a-m mt-0" ng-checked="ReviewOrder.IsInterestingCase" ng-model="ReviewOrder.IsInterestingCase" /> <span align="left" class="cursor-pointer hovIcon-td float-right"> <a uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" class="cursor-pointer no-bg" ng-if="ReviewOrder.OptionalDicomViewer.length > 0"> <i class="fa fa-picture-o fs-17px txt-clr-14"></i> </a> <span class="iconDropdown-2" style="left:-135px;"> <a class="cursor-pointer p-0 tultip-left dvnew" ng-repeat="DV in ReviewOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(OrderReport , DV, false)"> <span class="agfa d-block" ng-if="DV == \'AGFA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">AGFA</span> <span class="candelis d-block" ng-if="DV == \'CANDELIS\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">CANDELIS</span> <span class="synapse d-block" ng-if="DV == \'SYNAPSE\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">SYNAPSE</span> <span class="konica d-block" ng-if="DV == \'KONICA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">KONICA</span> <span class="konica d-block" uib-tooltip-html="\'KONICATEST\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'KONICATEST\'">KONICA TEST</span> <span class="gecuv d-block" ng-if="DV == \'GECUV\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">GECUV</span> <span class="gecuv d-block" uib-tooltip-html="\'North Star Konica\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'North Star Konica\'">North Star Konica</span> </a> </span> </span> <div class="clearfix"></div> </div> <div class="col-md-12 form-group mb-5px" ng-hide="ReviewOrder.IsInterestingCase"> <table class="patient-table w-100 b-1-s b-clr-1"> <thead> <tr class="bg-clr-23" style="border:0!important;background-color:#05c1a4!important;"> <th class="w-40px text-center py-2px fw-600">Sr.</th> <th class="py-2px fw-600">Score</th> <!--<th class=""> Clinical Signficance </th>--> </tr> </thead> <tbody class="bg-clr-23 pt-5px h-300px"> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">1</td> <td class="txt-clr-1"> <div style="padding: 0px 5px 5px 5px;"> <input type="radio" ng-click="ReviewOrder.Rating=\'1\'" ng-checked="ReviewOrder.Rating==\'1\'"> Concur with Interpretation </div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">2</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/not ordinarily expected to be made(understandable miss)</span> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'2a\'" ng-checked="ReviewOrder.Rating==\'2a\'">2a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'2b\'" ng-checked="ReviewOrder.Rating==\'2b\'">2b.Likely to be signficant</div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">3</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/Should be made most of time</span> <br> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'3a\'" ng-checked="ReviewOrder.Rating==\'3a\'">3a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'3b\'" ng-checked="ReviewOrder.Rating==\'3b\'">3b.Likely to be signficant</div> </td> </tr> <tr class="bg-clr-23" style="border:0!important;"> <td class="text-center v-a-t w-40px txt-clr-1">4</td> <td class="txt-clr-1"> <span class="text-preline">Discrepancy in Interpretation/Should be made almost every time - misinterpretation of findings</span><br /> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'4a\'" ng-checked="ReviewOrder.Rating==\'4a\'">4a.Unlikely to be signficant</div> <div class="p-5px-all"><input type="radio" class="m-5px-all" ng-click="ReviewOrder.Rating=\'4b\'" ng-checked="ReviewOrder.Rating==\'4b\'">4b.Likely to be signficant</div> </td> </tr> </tbody> </table> </div> <div class="col-md-6 col-sm-6 mb-10" ng-if="ReviewOrder.IsInterestingCase"> <span ng-if="ReviewOrder.IsInterestingCase" style="color:red;float:left;">*</span> <input type="text" class="blk-input form-control w-100 mb-10px" name="keyword" ng-model="ReviewOrder.Keywords" placeholder="Keywords." ng-required="ReviewOrder.IsInterestingCase"> <div class="clearfix"></div> </div> <div class="clearfix"></div> <div class="col-md-12 form-group fw-600"> <span ng-if="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')" style="color:red; float:left;">*</span> <div class="clearfix"></div> <textarea class="txt-area h-70px w-100 p-5px-all" rows="4" name="comment" ng-model="ReviewOrder.Comments" placeholder="Add a comment." ng-required="ReviewOrder.IsInterestingCase || (ReviewOrder.Rating==\'2b\' || ReviewOrder.Rating==\'3a\'|| ReviewOrder.Rating==\'3b\'|| ReviewOrder.Rating==\'4a\'|| ReviewOrder.Rating==\'4b\')"> </textarea> </div> <div class="col-md-12"> <button type="button" class="btn btn-primary h-30px px-10px fs-13px pull-left" ng-disabled="(!review.comment.$valid || !review.keyword.$valid) || (!ReviewOrder.IsInterestingCase && (!ReviewOrder.Rating || ReviewOrder.Rating==\'\'))" ng-click="SaveReviewOrder()">Save</button> </div> </div> </div> </div> </div> </div> </div></script><script type="text/ng-template" id="modal_discussion_tab.html"><div id="Discussion" style="opacity:1 !important"> <div class="fw-500 pt-10px"> <div class="row fw-500 mr-0 make-col-50"> <div class="col-sm-3"> <div class="mb-5px"> <span class="report_span_title">Location :</span> <span class="report_span">{{SelectedOrder.Location}}</span> </div> <div class="mb-5px"> <span class="report_span_title">Gender :</span> <span class="report_span">{{SelectedOrder.PatientGender}}</span> </div> <div class="mb-0"> <span class="report_span_title">Ordering Physician :</span> <div class="hovIcon-td d-inline" ng-if="SelectedOrder.OrderingPhysicianPhone"> <span class=" cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span> <div class="iconDropdown cursor-pointer sm-pl" style="top: 25px;"> <div class="bg-clr-30 text-truncate ng-binding w-200px p-5px-all"> Contact: <span class="txt-clr-15">{{SelectedOrder.OrderingPhysicianPhone | tel}}</span> </div> </div> </div> <div class="hovIcon-td d-inline tooltip-w-100px" ng-if="!SelectedOrder.OrderingPhysicianPhone"> <span class=" cursor-pointer sm-pl report_span" style="padding: 5px;">{{SelectedOrder.OrderingPhysician}}</span> <div class="iconDropdown cursor-pointer sm-pl" style="top: 25px !important;" ng-if="SelectedOrder.OrderingPhysician"> <a ng-click="showContact(SelectedOrder.OrderingPhysician, SelectedOrder.Location)" class="cursor-pointer w-100 p-5px-all" style=" width: 150px!important;"> <span tooltip-class="uibtooltipDenial" tooltip-placement="auto bottom" uib-tooltip="Search By Address Book">Search Contact <i class="fa fa-search fs-18px"></i></span> </a> </div> </div> <!--<span class="report_span">{{SelectedOrder.OrderingPhysician}}<br />{{SelectedOrder.OrderingPhysicianPhone | tel}}</span>--> </div> </div> <div class="col-sm-3"> <div class="mb-5px"> <span class="report_span_title">DOS :</span> <span class="report_span"> <!--{{SelectedOrder.OrderDate}}--> {{(SelectedOrder.OrderDate) ? (SelectedOrder.OrderDate | date:\'M/d/yy HH:mm\').toString().replace("00:00","") : \'\'}} </span> </div> <div class="mb-5px"> <span class="report_span_title">Type :</span> <!--<span class="report_span">{{SelectedOrder.PatientClass}}</span>--> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'E\'">Emergency</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'I\'">Inpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'O\'">Outpatient</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'P\'">PreAdmit</span> <span class="report_span" ng-if="SelectedOrder.PatientClass==\'U\'">Unknown</span> </div> <div class="mb-0"> <div class="d-inline-block pos-rel"> <div class="kendo-actionbtn-section" ng-if="SelectedOrder.OptionalDicomViewer.length > 0"> <div class="float-left">Dicom Viewer :</div> <div class="float-left pos-rel"> <div> <button class="kendo-dropbtn outline-none txt-clr-14" uib-tooltip-html="\'Dicom Viewer\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"> <i class="fa fa-file-image-o k-icon-downdir fs-18px"></i> </button> <div class="kendo-action-dropdown-content"> <a class="btn" ng-repeat="DV in SelectedOrder.OptionalDicomViewer.split(\',\') | orderBy" ng-click="OpenSynapseStudy(SelectedOrder, DV, false)"> <!--<i class="agfa d-block" ng-show="DV == \'AGFA\'" uib-tooltip-html="\'AGFA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left"></i>--> <span class="agfa d-block" ng-if="DV == \'AGFA\'" uib-tooltip-html="\'AGFA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">AGFA</span> <span class="candelis d-block " ng-if="DV == \'CANDELIS\'" uib-tooltip-html="\'CANDELIS\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">CANDELIS</span> <span class="synapse d-block" ng-if="DV == \'SYNAPSE\'" uib-tooltip-html="\'SYNAPSE\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">SYNAPSE</span> <span class="konica d-block" ng-if="DV == \'KONICA\'" uib-tooltip-html="\'KONICA\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">KONICA</span> <span class="konica d-block" uib-tooltip-html="\'KONICATEST\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'KONICATEST\'">KONICA TEST</span> <span class="gecuv d-block" ng-if="DV == \'GECUV\'" uib-tooltip-html="\'GE Centricity\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left">GECUV</span> <span class="gecuv d-block" uib-tooltip-html="\'CI DICOM VIEWER\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'CI-VIEWER\'">CI-VIEWER</span> <span class="gecuv d-block" uib-tooltip-html="\'North Star Konica\'" tooltip-class="uibtooltipDenial" tooltip-placement="auto left" ng-if="DV == \'North Star Konica\'">North Star Konica</span> </a> </div> </div> </div> <div class="clearfix"></div> <button type="button" ng-if="ODType==\'Helper\'" class="btn cmn-btn btn-primary h-30px px-10px fs-13px pull-right" ng-click="CloseOrderDiscussion()">Close Discussion</button> </div> </div> </div> </div> <div class="col-sm-3"> <div class="mb-5px"> <span class="report_span_title">Patient Name :</span> <span class="report_span">{{SelectedOrder.PatientName}}</span> </div> <div class="mb-5px"> <span class="report_span_title">Modality :</span> <span class="report_span">{{SelectedOrder.Modality}}</span> </div> </div> <div class="col-sm-3"> <div class="mb-5px"> <span class="report_span_title">DOB :</span> <span class="report_span">{{SelectedOrder.PatientDOB | date:\'M/d/yy\'}}</span> </div> <div class="mb-5px"> <span class="report_span_title">Procedure :</span> <span class="report_span">{{SelectedOrder.ProcedureDesc}}</span> </div> </div> </div> <div class="text-right"> <a class="cursor-pointer mb-5px" ng-if="SelectedOrder.FileCount > 0 && !showAttachment" ng-click="showFileList()">View Attachment ({{SelectedOrder.FileCount}})</a> <a class="btn btn-default mb-5px" ng-if="showAttachment" ng-click="hideFileList()"> <i class="fa fa-arrow-left mr-5px"></i>Back </a> <button class="btn btn-default mb-5px" ng-click="openShareExamWindow()">Share Exam</button> </div> <div ng-if="!showAttachment"> <div class="row m-0"> <div class="col-lg-3 col-md-3 col-sm-3 p-0"> <div ng-if="ODType==\'Assigner\'"> <ui-select ng-model="OrderDiscussion.SelectedUser" theme="bootstrap" class="dicom-inp-w" ng-disabled="OrderDiscussion.ID"> <ui-select-match allow-clear="true" placeholder="Select Radiologist"> {{$ctrl.radDisplay($select.selected)}}</ui-select-match> <ui-select-choices repeat="list in $ctrl.masterData.Radiologists | filter: $ctrl.isVisibleRad | propsFilter: {FirstName: $select.search, LastName: $select.search} | orderBy:\'LastName\'"> <small> <i class="fa fa-circle" ng-class="{\'text-success\':list.IsOnline,\'text-gray-dark\':!list.IsOnline}"></i> {{$ctrl.radDisplay(list)}} </small> </ui-select-choices> </ui-select> </div> </div> </div> <div class="row m-0"> <div class="col-md-12 p-0" ng-if="ODType==\'Discussion\' || ODType==\'Helper\'"> <div class="form-group my-10px p-0"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea> </div> <div class="col-lg-12 col-md-12 p-0"> <button type="button" class="btn btn-primary pull-right border-0" ng-click="SaveDiscussion()">Save</button> </div> </div> <div class="col-md-12 pr-0 pl-0 " ng-if="ODType==\'Assigner\'"> <div class="col-md-12 form-group my-10px p-0"> <textarea class="txt-area h-70px w-100 p-5px-all" ng-model="Discussion.Comment" placeholder="Add a comment"> </textarea> </div> <button type="button" ng-hide="OrderDiscussion.ID" class="btn btn-primary pull-right ml-5px" ng-click="SaveOrderDiscussion()">Consult Study</button> <button type="button" ng-hide="OrderDiscussion.ID" class="btn btn-primary pull-right ml-5px" ng-click="AssignStudy()">Assign Study</button> <button type="button" ng-if="OrderDiscussion.ID" class="btn btn-primary pull-right" ng-click="SaveDiscussion()">Save</button> </div> <div class="clearfix h-10px"></div> <div class="discus-comment overflow-y-auto py-10px px-10px wl-async"> <!--discuss--> <div class=""> <div class="w-100 toselect-first-ul" ng-repeat="Dis in Discussions" ng-include="\'tree_item_renderer.html\'"></div> <div class="clearfix"></div> </div> </div> </div> </div> <div ng-if="showAttachment && showDiscuss" class="new-wl-rep-dis"> <div class="discussion-attachment-sec overflow-x-hide"> <div class="row m-0"> <attachment-viewer ng-if="ReferenceID" dicomorder-id="ReferenceID"></attachment-viewer> </div> </div> </div> </div> </div></script><div class="modal fade z-i-9999" id="ModalDicomViewerCredentials" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important; z-index:99999 !important;"><div class="modal-dialog mdvcpopup"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Centricity Login</h4></div><div class="modal-body"><div class=""><div class="mdvctxt"><div class="row"><div class="col-md-12 col-sm-12 txt-clr-1"><h5 class="txt-clr-1 fs-18px">GE Healthcare</h5></div><div class="col-md-12 col-sm-12"><h4 class="txt-clr-1 fs-22px">Centricity<sup>*</sup></h4><h2 class="txt-clr-1 fs-26px">Universal Viewer</h2></div></div></div><div class="mdvcfrmouter"><form name="DVCredform" id="DVCredform" ng-submit="InsertDicomViewerCredentials(DVCredform.$valid)" class="mdvcfrm"><div class="w-30 float-left"><label class="txt-clr-1 fw-500">Username:</label></div><div class="w-70 float-left"><input type="text" id="DVCredUsername" name="DVCredUsername" ng-model="DVCred.Username" ng-required="true" class="w-100 blk-input form-control" autocomplete="on"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="txt-clr-1 fw-500">Password:</label></div><div class="w-70 float-left"><input type="password" id="DVCredPassword" name="DVCredPassword" ng-model="DVCred.Password" ng-required="true" class="w-100 blk-input form-control"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-primary">Login</button></div><div class="clearfix"></div></form></div><div class="row"><div class="col-md-12 col-sm-12 text-left"><img src="assets/images/mdvc.png"></div></div></div></div></div></div></div></div>');
$templateCache.put('app/theme/components/worklist-page-header/worklist-page-header.html','<style>\r\n    .wlzoomeffect .draft:after {\r\n        content: "Draft ({{DataObject.WorklistPageHeaderParameter.DraftCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .draft:hover:after {\r\n        content: "Draft ({{DataObject.WorklistPageHeaderParameter.DraftCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .complete:after {\r\n        content: "Complete ({{DataObject.WorklistPageHeaderParameter.CompleteCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .complete:hover:after {\r\n        content: "Complete ({{DataObject.WorklistPageHeaderParameter.CompleteCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .hst:after {\r\n        content: "Hidden ({{DataObject.WorklistPageHeaderParameter.HiddenCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .hst:hover:after {\r\n        content: "Hidden ({{DataObject.WorklistPageHeaderParameter.HiddenCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .resultpending:after {\r\n        content: "Result Pending ({{DataObject.WorklistPageHeaderParameter.ResultPendingCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .resultpending:hover:after {\r\n        content: "Result Pending ({{DataObject.WorklistPageHeaderParameter.ResultPendingCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .rps:after {\r\n        content: "STAT/High Priority ({{DataObject.WorklistPageHeaderParameter.StatCount}})";\r\n    }\r\n\r\n    .wlzoomeffect .rps:hover:after {\r\n        content: "STAT/High Priority ({{DataObject.WorklistPageHeaderParameter.StatCount}})" !important;\r\n    }\r\n\r\n    .wlzoomeffect .st:after {\r\n        content: "Signed Today ({{DataObject.WorklistPageHeaderParameter.SignedToday}})";\r\n    }\r\n\r\n    .wlzoomeffect .st:hover:after {\r\n        content: "Signed Today ({{DataObject.WorklistPageHeaderParameter.SignedToday}})" !important;\r\n    }\r\n\r\n    \r\n    .btn-collectionday:hover {\r\n        background: #20da79 !important;\r\n    }\r\n    /*Bootstrap Tour*/\r\n    .tour-backdrop {\r\n        opacity: 0.6 !important;\r\n    }\r\n\r\n    .popover.tour-tour {\r\n        border-color: #828282;\r\n        background-color: #404040 !important;\r\n    }\r\n\r\n        .popover.tour-tour .popover-content {\r\n            color: white;\r\n        }\r\n\r\n        .popover.tour-tour .popover-title {\r\n            background-color: transparent !important;\r\n            color: white !important;\r\n            border-bottom: 0;\r\n        }\r\n\r\n    .popover-navigation .btn.btn-sm.btn-default {\r\n        margin: 5px;\r\n    }\r\n\r\n    .tour-close {\r\n        font-size: 14px;\r\n        color: #959595 !important;\r\n    }\r\n\r\n        .tour-close:hover {\r\n            color: white !important;\r\n        }\r\n\r\n    .popover.tour-tour.left > .arrow:after {\r\n        background-image: url(../../assets/images/tooltip-arrow-filled.svg);\r\n        background-repeat: no-repeat;\r\n        width: 15px;\r\n        height: 24px;\r\n        border: none;\r\n        right: -4px;\r\n        transform: rotate(180deg);\r\n    }\r\n\r\n    .tour-nxt-btns {\r\n        display: flex;\r\n        height: 23px;\r\n        border-radius: 3px;\r\n        align-items: center;\r\n    }\r\n\r\n    .tour-back-btns {\r\n        height: 23px;\r\n        border-radius: 3px !important;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .step-header {\r\n        background-color: #373737;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .tour-section-disbl {\r\n        pointer-events: none;\r\n        opacity: 0.9;\r\n    }\r\n    /*Highlight Steps End*/\r\n    /*help section css start*/\r\n    .helpcenter-wrapper {\r\n        width: 440px;\r\n        background: #2E2E2E;\r\n        /*background: #1a1a1a;*/\r\n        border-radius: 2px;\r\n        border: 1px solid #000;\r\n        height: calc(100vh - 67px);\r\n        box-shadow: 2px 0 0 0 #484848, 0px 0px 0 0 #484848, -2px -2px 0 0 #484848;\r\n        top: 33px;\r\n        right: 0;\r\n        z-index: 9;\r\n    }\r\n    .touracr-wrapper {\r\n        \r\n    }\r\n    .toursteps-accordn {\r\n        /*max-height: 736px;*/\r\n        overflow-x: hidden;\r\n        overflow-y: auto;\r\n        height: calc(100vh - 219px);\r\n    }\r\n    .toursteps-accordn.panel-group .panel + .panel {\r\n        margin-top: 0px;\r\n    }\r\n    .toursteps-accordn.panel-group .panel {\r\n        /*box-shadow: 1px 1px 0 0 #484848 !important;*/\r\n        box-shadow: none !important\r\n    }\r\n    .toursteps-accordn.panel-group .panel-collapse .panel-body {\r\n        background-color: #262526;\r\n        box-shadow: inset 1px 1px 0 0 #484848 !important;\r\n        border: 1px solid #171717 !important;\r\n        padding: 14px 24px !important;\r\n    }\r\n    .btn.btn-primary.starTour {\r\n        background-color: transparent !important;\r\n    }\r\n    .btn.btn-primary.starTour:hover {\r\n        box-shadow: 0 1px 2px 0 #05c1a4 !important;\r\n    }\r\n    .toursteps-accordn.panel-group .panel-collapse.collapse.in .panel-body {\r\n        background-color: #212121 !important;\r\n        /*border: 1px solid #8f8f8f !important;\r\n        box-shadow: none !important;*/\r\n    }\r\n    .toursteps-accordn.panel-group .panel.activeAccrPanel {\r\n        border: 1px solid #8f8f8f !important;\r\n        border-radius: 0;\r\n    }\r\n    .toursteps-accordn .panel.activeAccrPanel .panel-heading {\r\n        background-color: #424242;\r\n    }\r\n    /*tour accordion start*/\r\n    .toursteps-accordn .accrbtn {\r\n        width: 100% !important;\r\n        display: block;\r\n    }\r\n    .accrbtn:after {\r\n        font-family: "Glyphicons Halflings";\r\n        content: "\\e252";\r\n        float: left;\r\n        margin-left: 0;\r\n        padding-right: 5px;\r\n        /*content: "\\e114";*/\r\n        /*float: right;\r\n        margin-left: 15px;*/\r\n    }\r\n    /* Icon when the collapsible content is hidden */\r\n    .accrbtn.collapsed:after {\r\n        content: "\\e250";\r\n        /*content: "\\e080";*/\r\n    }\r\n    .toursteps-accordn .panel .panel-heading {\r\n        /*background-color: #5d5d5d;\r\n        border-bottom-color: transparent !important;*/\r\n        /*border-bottom-color: #808080 !important;*/\r\n        background-color: #2E2E2E;\r\n        border-bottom-color: #17171A;\r\n        border-right: 1px solid #17171A;\r\n        border-radius: 0;\r\n        box-shadow: inset 1px 1px 0 0 #484848 !important;\r\n    }\r\n    .toursteps-accordn .panel-body {\r\n        background-color: #404040;\r\n    }\r\n    .toursteps-accordn .accrbtn:after {\r\n        font-size: 10px;\r\n        font-size: 10px;\r\n        padding-top: 3px;\r\n    }\r\n    .accrbtn-goto {\r\n        position: absolute;\r\n        right: 40px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        background: none;\r\n        border: 0;\r\n    }\r\n    .toursteps-togo {\r\n        /*max-height: 820px;\r\n        overflow-x: hidden;\r\n        overflow-y: auto;*/\r\n        box-shadow: 1px 1px 0 0 #484848;\r\n        border: 1px solid #17171a;\r\n        /*padding-right: 4px;*/\r\n    }\r\n    .toursteps-accordn .panel .panel-heading .accrbtn:hover {\r\n        color: #fff !important;\r\n    }\r\n    .form-control.inputsearch {\r\n        padding-left: 30px;\r\n        border-radius: 2px;\r\n        background: #1E1E1E !important;\r\n        /*border-bottom: 1px solid #999 !important;*/\r\n        box-shadow: 0px 1px 2px 0 #757575;\r\n    }\r\n    .search-forhelp {\r\n        position: absolute;\r\n        right: 17px;\r\n        top: 7px;\r\n        color: #999;\r\n        cursor: pointer;\r\n        font-size: 14px;\r\n        padding: 8px 10px;\r\n        display: none;\r\n    }\r\n    .search-forhelp:hover {\r\n        color: #fff;\r\n        background: #404040;\r\n    }\r\n    .search-forsearch {\r\n        position: absolute;\r\n        left: 14px;\r\n        top: 7px;\r\n        color: #999;\r\n        font-size: 14px;\r\n        padding: 8px 10px;\r\n        pointer-events: none;\r\n    }\r\n    .dtour-close:hover {\r\n        color: #00ffd8 !important;\r\n    }\r\n    #accordion .panel-title .accrbtn mark, #accordion .panel-body p mark {\r\n        padding: 0 !important;\r\n        background: yellow !important;\r\n    }\r\n    #accordion .panel-title .accrbtn mark.no-mark, #accordion .panel-body p mark.no-mark {\r\n        background: transparent !important;\r\n        color: inherit;\r\n    }\r\n    #accordion .panel .collapse.in {\r\n        height: unset !important;\r\n    }\r\n    /*tour accordion end*/\r\n    .d-inline-flex\r\n    {\r\n        display:inline-flex !important;\r\n    }\r\n    /*help section css end*/\r\n    /*css - x-ray read & pendig coutn start*/\r\n    .xray-readcount {\r\n        width: max-content;\r\n        display: inline !important;\r\n        background: #5d5d5d;\r\n        padding-left: 10px !important;\r\n        padding-right: 10px !important;\r\n    }\r\n    .xray-readcount:hover {\r\n        background: #000;\r\n    }\r\n    .xray-countbadge {\r\n        color: #000000 !important;\r\n        background: #a3da63;\r\n        padding: 2px 4px;\r\n        border-radius: 6px;\r\n        letter-spacing: 0.3px;\r\n        margin-left: 2px;\r\n        min-width: 26px;\r\n        display: inline-block;\r\n    }\r\n    .tooltip.xary-counttt .tooltip-inner {\r\n        width: auto !important;\r\n        max-width: 400px !important;\r\n        text-align: left;\r\n        padding: 8px !important;\r\n        border-radius: 5px !important;\r\n        border: 2px solid #FF6850;\r\n    }\r\n    .xray-fs-badge { display: inline-flex !important; }\r\n    .xray-hs-badge { display: none !important; }\r\n    /*css - x-ray read & pendig cout nend*/\r\n    @media only screen and (min-width:768px) and (max-width:1200px) {\r\n        .wlzoomeffect.btn-collectionday {\r\n            position: absolute;\r\n            top: 34px;\r\n            right: 36px;\r\n            padding: 4px 3px !important;\r\n        }\r\n        .wlzoomeffect.btn-collectionday:hover {\r\n            z-index:1;\r\n        }\r\n        .xray-readcount {\r\n            position: absolute !important;\r\n            padding: 4px 4px 4px 4px !important;\r\n            font-size: 12px !important;\r\n            margin-right: 2px !important;\r\n            margin-left: 2px;\r\n        }\r\n        .xray-readcount:hover {\r\n            transform: scale(1.1);\r\n        }\r\n        .cfday-elem label, .xraycnt-label  {\r\n            display: none !important;\r\n        }\r\n        .cfday-elem:hover > label {\r\n            display: block !important;\r\n        }\r\n        .xray-readcount:hover .xraycnt-label {\r\n            display: inline-block !important;\r\n        }\r\n        .xraycnt-mainlbl {\r\n            width: 44px;\r\n            display: inline-block;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n            vertical-align: middle;\r\n        }\r\n        .xray-countbadge {\r\n            min-width: 20px;\r\n            max-width: 24px;\r\n            display: inline-block;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n            vertical-align: middle;\r\n        }\r\n        .xray-readcount:hover .xraycnt-mainlbl, .xray-readcount:hover .xray-countbadge {\r\n            width: auto;\r\n            max-width: unset;\r\n            overflow: unset;\r\n            text-overflow: unset;\r\n            white-space: unset;\r\n            vertical-align: unset;\r\n        }\r\n        .xarylbl-wrapper.ml-3px {\r\n            margin-left: 0 !important;\r\n        }\r\n        .xray-fs-badge { display: none !important; }\r\n        .xray-hs-badge { display: inline-flex !important; }\r\n        .tooltip.xary-counttt .tooltip-inner {\r\n            width: fit-content !important;\r\n            max-width: min(320px, 90vw) !important;\r\n        }\r\n        .wlzoomeffect .cfday-elem span {\r\n            min-width: 30px;\r\n            max-width: 52px;\r\n            display: inline-block;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n            vertical-align: middle;\r\n        }\r\n        .wlzoomeffect .cfday-elem:hover span {\r\n            width: auto;\r\n            max-width: unset;\r\n            overflow: unset;\r\n            text-overflow: unset;\r\n            white-space: unset;\r\n            vertical-align: unset;\r\n        }\r\n    }\r\n    @media (min-width: 768px) and (min-height: 1080px) and (orientation: portrait) {\r\n        .xray-readcount {\r\n            position: absolute !important;\r\n            padding: 4px !important;\r\n            margin-right: 5px !important;\r\n            right: 260px;\r\n        }\r\n        .xraycnt-label {\r\n            display: inline-block !important;\r\n        }\r\n    }\r\n    \r\n    /* SOS Floating Button Styles Start*/\r\n\r\n    #sos-floating-btn {\r\n        position: fixed;\r\n        top: 35px;\r\n        left: calc(50% - 30px);\r\n        display: flex;\r\n        width: 60px;\r\n        height: 60px;\r\n        background: rgba(204, 0, 0, 0.925);\r\n        backdrop-filter: blur(10px);\r\n        border-radius: 50%;\r\n        box-shadow: 0 2px 8px rgba(177, 26, 26, 0.4);\r\n        cursor:grab;\r\n        z-index: 1040 !important;\r\n        align-items: center;\r\n        justify-content: center;\r\n        color: white;\r\n        font-weight: bold;\r\n        font-size: 19px;\r\n        text-align: center;\r\n        user-select: none;\r\n        transition: transform 0.2s, box-shadow 0.2s, background 0.2s;\r\n        border: 2px solid rgba(255, 255, 255, 0.2);\r\n        pointer-events: auto !important;\r\n        touch-action: none;\r\n    }\r\n\r\n        #sos-floating-btn.dragging {\r\n            transition: none;\r\n            cursor: grab;\r\n            opacity: 0.8;\r\n        }\r\n\r\n    /* Common hover and active styles */\r\n    #sos-floating-btn:hover {\r\n        background: rgba(208, 0, 0, 0.925);\r\n        box-shadow: 0 4px 12px rgba(177, 26, 26, 0.5);\r\n        border: 2px solid rgba(255, 255, 255, 0.3);\r\n    }\r\n\r\n    #sos-floating-btn:active {\r\n        transform: scale(0.9);\r\n    }\r\n\r\n    @keyframes pulseRed {\r\n        0% {\r\n            box-shadow: 0 0 20px rgba(255, 0, 0, 0.6);\r\n        }\r\n        50% {\r\n            box-shadow: 0 0 40px rgba(255, 0, 0, 0.9);\r\n        }\r\n        100% {\r\n            box-shadow: 0 0 20px rgba(255, 0, 0, 0.6);\r\n        }\r\n    }\r\n\r\n    #sos-floating-btn.pulseRed {\r\n        animation: pulse 2s infinite;\r\n    }\r\n\r\n    /* SOS Chat Bubble Styles */\r\n    #sosChatBubble {\r\n        display: none;\r\n        position: fixed;\r\n        z-index: 1041;\r\n        max-width: 450px;\r\n        animation: slideInUp 0.3s ease-out;\r\n    }\r\n\r\n    @keyframes slideInUp {\r\n        from {\r\n            opacity: 0;\r\n            transform: translateY(20px);\r\n        }\r\n        to {\r\n            opacity: 1;\r\n            transform: translateY(0);\r\n        }\r\n    }\r\n\r\n    /* SOS Chat Bubble Popover Style */\r\n    #sosChatBubble > div {\r\n        position: relative;\r\n        background-color: #323232;\r\n        border-radius: 12px;\r\n        padding: 15px 18px;\r\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n        border: 1px solid #555;\r\n    }\r\n\r\n    #sosChatBubble .sos-header { \r\n        display: flex; \r\n        align-items: center; \r\n        margin-bottom: 10px; \r\n        padding-bottom: 10px; \r\n        border-bottom: 1px solid #444; \r\n    }\r\n    #sosChatBubble .sos-header .sos-emoji { font-size: 18px; margin-right: 8px; animation: blink 1s infinite; display: inline-block; }\r\n    #sosChatBubble .sos-header span { color: #ff0000; font-weight: 600; font-size: 14px; text-transform: uppercase; }\r\n    #sosChatBubble .sos-message { \r\n        background-color: transparent; \r\n        border-left: 2px solid #ff0000; \r\n        border-radius: 0; \r\n        padding: 10px 0 10px 12px; \r\n        margin-bottom: 12px; \r\n    }\r\n    #sosChatBubble .sos-countdown { \r\n        color: #e4e4e4; \r\n        font-size: 12px; \r\n        margin-bottom: 8px; \r\n        text-align: left; \r\n    }\r\n    #sosChatBubble .sos-countdown span { font-weight: bold; color: #209e91; font-size: 18px; }\r\n    #sosChatBubble .sos-progress { \r\n        background-color: #2a2a2a; \r\n        border-radius: 4px; \r\n        padding: 4px; \r\n        margin-bottom: 12px; \r\n    }\r\n\r\n    #sosChatBubble button:hover {\r\n        opacity: 0.9;\r\n        transform: scale(1.02);\r\n    }\r\n\r\n    #sosChatBubble #sosCancelBtn:hover {\r\n        background-color: #0e8174 !important;\r\n    }\r\n    \r\n    @keyframes blink {\r\n        0%, 100% { opacity: 1; }\r\n        50% { opacity: 0.3; }\r\n    }\r\n    /* SOS Floating Button Styles End */\r\n</style><div class="wl-topbtnsection d-inline-block v-a-t"><h2 class="d-inline mt-5px">Worklist</h2><div class="d-inline" ng-show="$ctrl.currentState==\'worklist\'"><div class="wlzoomeffect adborder" style="color:#A0C1C5;border-color:#A0C1C5;" ng-click="setStatus(\'D\')"><div class="draft"><div class="stcircle" style="background-color: #A0C1C5;"></div></div></div><div class="wlzoomeffect adborder" style="color:#FFA95E;border-color:#FFA95E;" ng-click="setStatus(\'H\')"><div class="hst"><div class="stcircle" style="background-color:#FFA95E;"></div></div></div><div class="wlzoomeffect adborder" style="color:#FFD75E;border-color:#FFD75E;" ng-click="setStatus(\'RP\')"><div class="resultpending"><div class="stcircle"></div></div></div><div class="wlzoomeffect adborder" style="color:#FF4B4B;border-color:#FF4B4B;" ng-click="setStatus(\'Stat\')"><div class="rps"><div class="stcircle" style="background-color:#FF4B4B;"></div></div></div></div><div class="wlzoomeffect adborder" style="color: #75E284; border-color: #75E284;" ng-click="setStatus(\'ST\')"><div class="st"><div class="stcircle" style="background-color: #75E284;"></div></div></div></div><div class="fs-12px d-inline"><div class="d-inline-flex align-item-center"><span class="wlzoomeffect prvu p-zoom stepPRVU"><span>{{DataObject.WorklistPageHeaderParameter.HospitalRVU | number : 2}}</span> <span>Practice wRVU</span></span> <span class="wlzoomeffect prvu p-zoom"><span>{{DataObject.WorklistPageHeaderParameter.TopUserRVU | number : 2}}</span> <span>High wRVU</span></span> <span class="wlzoomeffect prvu p-zoom"><span>{{DataObject.WorklistPageHeaderParameter.MyRVU | number : 2}}</span> <span>My wRVU</span></span> <span class="wlzoomeffect prvu p-zoom"><span>{{DataObject.WorklistPageHeaderParameter.LowRVU| number : 2}}</span> <span>Low wRVU</span></span> <span class="wlzoomeffect prvu p-zoom stepLRVU"><span>{{DataObject.WorklistPageHeaderParameter.UnreadRVU| number : 2}}</span> <span>Unread wRVU</span></span> <button type="button" ng-click="refreshSignSummary();" ng-disabled="$ctrl.isRefreshing" class="btn btn-transparent icon-hover text-white p-1" title="Refresh RVU/Signed Today"><i class="fa fa-refresh" ng-hide="$ctrl.isRefreshing" aria-hidden="true"></i> <i class="fa fa-spinner fa-spin" ng-show="$ctrl.isRefreshing" aria-hidden="true"></i></button></div><div style="float:right;" ng-show="$ctrl.currentState==\'worklist-lite\'" class="pos-rel"><div class="helpcenter-wrapper pos-abs" ng-show="DataObject.helpEleWrapper.value"><div class="rm-tour hca-tooltip--left-nav touracr-wrapper py-10px px-10px"><div class="row mb-10px"><div class="col-md-12 mb-5px clearfix"><p class="m-0 pull-left">Help & Resources</p><i class="fa fa-close txt-clr-14 cursor-pointer fs-16px fw-500 dtour-close close pull-right" title="Close" ng-click="closeHelpView()"></i></div><div class="col-md-12 mt-10px mb-5px clearfix"><button id="startTourBtn" class="btn rf-btn-xs pull-right btn-primary starTour fs-14px w-100 d-flex justify-content-center align-item-center" title="Start Tour" ng-click="restartTour()">Start Tour <i class="fa fs-16px txt-clr-14 icon-hover rmt-2 fpt-2px pr-5px pl-5px fa-caret-right"></i></button></div></div><div class="row m-0 toursteps-togo"><div class="col-md-12 clearfix pos-rel search-helpandres"><i class="fa fa-search search-forsearch" aria-hidden="true"></i> <input type="search" name="name" value="" id="searchHelp" ng-model="DataObject.searchTourSteps" class="form-control mb-8px mt-5px inputsearch border-0" placeholder="Search" autocomplete="off"> <i class="fa fa-angle-right search-forhelp" aria-hidden="true"></i></div><div class="col-md-12 px-0 mb-0 jump-onsteps toursteps-accordn panel-group" id="accordion"><div class="panel panel-default box-shadow-n"><div class="panel-heading p-12px-all h-auto box-shadow-n"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse1" ng-click="ariaExpanedTrue()">Search and Worklist Tab</a></h4></div><div id="collapse1" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">Effortless and Simplified worklist management with the intuitive search and selection tools</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse2">Quick Search</a></h4></div><div id="collapse2" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">Quick search enables rapid and efficient data retrieval with a streamlined search feature.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse3">Quick Filter Management</a></h4></div><div id="collapse3" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><img style="border: 1px solid #ccc; border-radius: 5px;" src="assets/images/quick-filter-menu.png"><p class="fs-14px txt-clr-1 m-0">It simplifies and enhances data filtering for effortless information refinement.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse4">Cherry Pick Tab</a></h4></div><div id="collapse4" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">The Cherry Pick worklist conveniently gathers specific studies for quick reference and easy handling.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse5">Missed SLA Tab</a></h4></div><div id="collapse5" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">In the Missed SLA worklist, studies with rule-defined timeouts are categorized, allowing for efficient monitoring and resolution.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse6">My ClipBoard Tab</a></h4></div><div id="collapse6" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">Simplify access and management of clipboard items for enhanced efficiency.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse7">Create a New Worklist</a></h4></div><div id="collapse7" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">Simplified worklist creation, to streamline the task organization.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse8">Pin the Search/Worklist Tab</a></h4></div><div id="collapse8" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">Keep the search and worklist tabs at hand with the tab-pinning feature, ensuring easy access.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse9">Hide the Tab</a></h4></div><div id="collapse9" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">Easily conceal the tab using the intuitive hide option provided.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse10">Select/Deselect Worklist</a></h4></div><div id="collapse10" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">Streamline the worklist selection and deselection by utilizing the provided checkboxes for efficient management..</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse11">Edit/Delete Worklist</a></h4></div><div id="collapse11" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><img src="assets/images/worklist-item.png"><p class="fs-14px txt-clr-1 m-0">Utilize the provided edit and delete icons for effortless worklist editing and removal.</p><p class="fs-14px txt-clr-1 m-0">Double click any item or Click \'<i class="fa fa-external-link pt-1px txt-clr-14 fs-13px icon-hover"></i>\' for pop out worklist window.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse12">Expand And Collapse the Worklist</a></h4></div><div id="collapse12" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">Effortlessly expand and collapse the worklist for efficient work management.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse13">Pending Count/STAT Count</a></h4></div><div id="collapse13" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0">Easy access to Pending and STAT counts.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse14">Column Management Options</a></h4></div><div id="collapse14" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><img src="assets/images/header-menu.png"><p class="fs-14px txt-clr-1 m-0"><strong>Auto size Columns :</strong> It allows column(s) to automatically adjust column width to fit the content within them.</p><p class="fs-14px txt-clr-1 m-0"><strong>Reset :</strong> to reset columns</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse15">Edit/Remove Worklist</a></h4></div><div id="collapse15" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><p class="fs-14px txt-clr-1 m-0"><i class="glyphicon glyphicon-pencil icon-hover fs-14px txt-clr-14"></i> Modify worklists with ease using the editing capabilities provided.</p><p class="fs-14px txt-clr-1 m-0"><i class="fa fa-times icon-hover fs-18px txt-clr-14"></i> Effortlessly delete the worklists with the removal feature.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse16">Grid Settings</a></h4></div><div id="collapse16" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><img src="assets/images/header-menu-2.png"><p class="fs-14px txt-clr-1 m-0">Grid settings are used to customize the appearance of data grids to suit the user preferences and requirements.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse17">Worklist Font Style</a></h4></div><div id="collapse17" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><img height="300" src="assets/images/worklist_Colorcode.png"><p class="fs-14px txt-clr-1 m-0">This feature customizes worklist presentation, enabling font size, color adjustments, and patient class priority assignment.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse18">Exam Tag Column</a></h4></div><div id="collapse18" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><img src="assets/images/exam_tags.png"><p class="fs-14px txt-clr-1 m-0"><strong>Exam tag :</strong> The exam tag column reflects the exam status, derived from information collected at the radiology assistant end, for the corresponding exam or study.</p></div></div></div><div class="panel panel-default"><div class="panel-heading p-12px-all h-auto"><h4 class="panel-title fs-14px txt-clr-1 pos-rel"><a class="accrbtn text-capitalize fw-600 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse19">Actions Menu</a></h4></div><div id="collapse19" class="panel-collapse collapse"><div class="panel-body p-12px-all border-0"><img src="assets/images/add-tags.png"><p class="fs-14px txt-clr-1 m-0">Right-click on any study, to open the Actions menu.</p></div></div></div></div></div></div></div></div><span class="float-right mr-10px pos-rel stepfontsize" ng-show="$ctrl.currentState==\'worklist-lite\'"><button class="btn-transparent btn text-white icon-hover p-1" title="Custom Worklist Font Size" ng-click="DataObject.isFontPropertyVisible.value=!DataObject.isFontPropertyVisible.value">A<span class="fs-9px">A</span> <i class="fa fa-angle-down pl-2px"></i></button><worklistfont ng-if="DataObject.isFontPropertyVisible.value" isfontpropertyvisible="DataObject.isFontPropertyVisible"></worklistfont></span><div class="wlzoomeffect btn-collectionday bor-rad-4px mr-10px fs-14px p-6px-all py-4px d-flex align-item-center" style="float: right; background-color: #3cc57e;" ng-click="getUserPayments()" ng-if="$ctrl.worklistPageHeaderParameter.isPCAvailable" ng-show="$ctrl.currentState==\'worklist-lite\'"><div class="cfday-elem d-flex align-item-center"><label class="fs-14px fw-500 m-0 p-0 cursor-pointer">Collections for Day :</label> <span class="fs-15px fw-600 m-0 txt-clr-1 pl-5px">${{DataObject.WorklistPageHeaderParameter.TotalCollectionForDay}}</span></div><span class="txt-clr-1 px-5px">|</span><div class="cfday-elem d-flex align-item-center"><label class="fs-14px fw-500 m-0 p-0 cursor-pointer">Remaining Balance :</label> <span class="fs-15px fw-600 m-0 txt-clr-1 pl-5px">${{DataObject.WorklistPageHeaderParameter.TotalRemainingBalance}}</span></div><span class="txt-clr-1 px-5px">|</span><div class="cfday-elem d-flex align-item-center"><label class="fs-14px fw-500 m-0 p-0 cursor-pointer">Total Earning :</label> <span class="fs-15px fw-600 m-0 txt-clr-1 pl-5px">${{DataObject.WorklistPageHeaderParameter.TotalEarnings}}</span></div></div><div id="sosChatBubble"><div style="position: relative; border-radius: 18px; padding: 15px 18px;"><div class="sos-header"><span class="sos-emoji">\uD83D\uDEA8</span> <span>Escalation: Radiologist Assistance Requested</span></div><div class="sos-message"><div id="sosMessageFull" style="color: #ffcccc; font-size: 13px; line-height: 1.6;">{{DataObject.SOSMessage}}</div></div><div class="sos-countdown">Sharing in <span id="sosCountdown" class="pr-2px" style="font-weight: bold; color: #209e91; font-size: 18px;">10</span> second(s).</div><div class="sos-progress"><div class="progress" style="height: 6px; margin-bottom: 0; background-color: #1a1a1a; border-radius: 3px;"><div id="sosProgressBar" class="progress-bar" role="progressbar" style="width: 100%; background-color: #209e91; border-radius: 3px; transition: width 0.3s ease;"></div></div></div><div style="display: flex; gap: 8px;"><button id="sosCancelBtn" style="flex: 1; background-color: #209e91; color: white; border: none; border-radius: 6px; padding: 10px 12px; font-size: 13px; cursor: pointer; transition: all 0.2s; font-weight: bold;">Cancel</button></div></div></div><div ng-if="DataObject.BonusDetails" class="xray-fs-badge d-flex wlzoomeffect pos-rel xray-readcount bor-rad-4px mr-10px fs-14px p-4px-all py-6px float-right align-item-center txt-clr-1" uib-tooltip-template="\'XRayReadPendingCount.html\'" tooltip-placement="bottom" tooltip-class="xary-counttt"><span class="xraycnt-mainlbl txt-clr-1"><b>{{DataObject.BonusDetails.BonusType}} Bonus:</b></span> <span class="xarylbl-wrapper ml-3px"><span class="xraycnt-label txt-clr-1">Read</span> <span class="xray-countbadge"><b>{{DataObject.BonusDetails.ReadCount}}</b></span></span> <span class="xarylbl-wrapper ml-3px"><span class="xraycnt-label txt-clr-1">Pending</span> <span class="xray-countbadge"><b>{{DataObject.BonusDetails.PendingCount}}</b></span></span></div><div ng-if="DataObject.WorklistPageHeaderParameter.XRayDetails.HasSOLAccess" class="xray-fs-badge d-flex wlzoomeffect pos-rel xray-readcount bor-rad-4px mr-10px fs-14px p-4px-all py-6px float-right align-item-center txt-clr-1" uib-tooltip-template="\'XRayTodayCount.html\'" tooltip-placement="bottom" tooltip-class="xary-counttt"><span class="xraycnt-mainlbl txt-clr-1"><b>X-Rays:</b></span> <span class="xarylbl-wrapper ml-3px"><span class="xraycnt-label txt-clr-1">Read</span> <span class="xray-countbadge"><b>{{DataObject.WorklistPageHeaderParameter.XRayDetails.ReadCount || 0}}</b></span></span> <span class="xarylbl-wrapper ml-3px"><span class="xraycnt-label txt-clr-1">Pending</span> <span class="xray-countbadge"><b>{{DataObject.WorklistPageHeaderParameter.XRayDetails.PendingCount || 0}}</b></span></span></div><div ng-if="DataObject.WorklistPageHeaderParameter.XRayDetails.HasSOLAccess || DataObject.BonusDetails" class="xray-hs-badge wlzoomeffect pos-rel xray-readcount bor-rad-4px mr-10px fs-14px p-4px-all py-6px float-right align-item-center txt-clr-1" uib-tooltip-template="DataObject.WorklistPageHeaderParameter.XRayDetails.HasSOLAccess && DataObject.BonusDetails ? \'XRayCombined.html\' : (DataObject.WorklistPageHeaderParameter.XRayDetails.HasSOLAccess ? \'XRayTodayCount.html\' : \'XRayReadPendingCount.html\')" tooltip-placement="bottom" tooltip-class="xary-counttt"><span ng-if="DataObject.WorklistPageHeaderParameter.XRayDetails.HasSOLAccess && !DataObject.BonusDetails"><span class="xraycnt-mainlbl txt-clr-1"><b>X-Rays:</b></span> <span class="xarylbl-wrapper ml-3px"><span class="xraycnt-label txt-clr-1">Read</span> <span class="xray-countbadge"><b>{{DataObject.WorklistPageHeaderParameter.XRayDetails.ReadCount || 0}}</b></span></span> <span class="xarylbl-wrapper ml-3px"><span class="xraycnt-label txt-clr-1">Pending</span> <span class="xray-countbadge"><b>{{DataObject.WorklistPageHeaderParameter.XRayDetails.PendingCount || 0}}</b></span></span></span><span ng-if="!DataObject.WorklistPageHeaderParameter.XRayDetails.HasSOLAccess && DataObject.BonusDetails"><span class="xraycnt-mainlbl txt-clr-1"><b>{{DataObject.BonusDetails.BonusType}} Bonus:</b></span> <span class="xarylbl-wrapper ml-3px"><span class="xraycnt-label txt-clr-1">Read</span> <span class="xray-countbadge"><b>{{DataObject.BonusDetails.ReadCount}}</b></span></span> <span class="xarylbl-wrapper ml-3px"><span class="xraycnt-label txt-clr-1">Pending</span> <span class="xray-countbadge"><b>{{DataObject.BonusDetails.PendingCount}}</b></span></span></span><span ng-if="DataObject.WorklistPageHeaderParameter.XRayDetails.HasSOLAccess && DataObject.BonusDetails" class="txt-clr-1"><b>X-Rays</b></span></div></div><div id="sos-floating-btn" class="pulse" title="SOS - Drag to move, Click to open" ng-if="$ctrl.currentState==\'worklist-lite\' && DataObject.WorklistPageHeaderParameter.isSOSVisible">SOS</div><div class="fltr-tgl-btn mr-10px py-2px" ng-show="$ctrl.currentState==\'worklist-lite\'"><span class="float-left" style="display:none;"><img class="mr-5px sm-refresh" src="assets/images/refresh.svg" alt="Refresh"></span> <span class="d-inline-block" style="display:none !important;"><button type="button" class="btn filterbt-2 no-bg fs-12px" id="heading_worklist" data-toggle="collapse" data-parent="#accordion" href="#collapseWorklist" aria-expanded="false" aria-controls="collapseWorklist" ng-click="CollapseFiler()" ng-disabled="isDisabled"><span ng-if="DataObject.WorklistPageHeaderParameter.isfilterCollapse">Open Worklist<i class="fa fa-filter txt-clr-1 fs-12 pl-5px"></i></span> <span ng-if="!DataObject.WorklistPageHeaderParameter.isfilterCollapse">Close Worklist<i class="fa fa-close txt-clr-1 fs-12px pl-5px"></i></span></button></span></div><div class="fltr-tgl-btn mr-10px py-2px" ng-show="$ctrl.currentState==\'worklist\'"><span class="float-left" style="display:none;"><img class="mr-5px sm-refresh" src="assets/images/refresh.svg" alt="Refresh"></span> <span class="d-inline-block float-right"><button type="button" class="btn filterbt-2 no-bg fs-12px" id="heading_worklist" data-toggle="collapse" data-parent="#accordion" href="#collapseWorklist" aria-expanded="false" aria-controls="collapseWorklist" ng-click="collapseFiler()" ng-disabled="isDisabled"><span ng-if="DataObject.WorklistPageHeaderParameter.isfilterCollapse">Open Filter<i class="fa fa-filter txt-clr-1 icon-hover fs-12 pl-5px"></i></span> <span ng-if="!DataObject.WorklistPageHeaderParameter.isfilterCollapse">Close Filter<i class="fa fa-close icon-hover txt-clr-1 fs-12px pl-5px"></i></span></button></span><div class="wlzoomeffect mr-10px fs-12px p-6px-all" style="float: right; background-color: #3cc57e;" ng-click="getUserPayments()" ng-show="$ctrl.currentState==\'worklist\'" ng-if="$ctrl.worklistPageHeaderParameter.isPCAvailable"><div class="pc"><div class="stcircle" style="background-color: #75E284;"></div></div></div></div><div class="clearfix"></div><script type="text/ng-template" id="XRayReadPendingCount.html"><p class="m-0 p-0 fw-600 text-justify fs-14px">{{DataObject.BonusTooltip}}</p></script><script type="text/ng-template" id="XRayTodayCount.html"><p class="m-0 p-0 fw-600 text-justify fs-14px">{{DataObject.XRayTodayTooltip}}</p></script><script type="text/ng-template" id="XRayCombined.html"><div style="margin:0;padding:0;"><div ng-if="DataObject.WorklistPageHeaderParameter.XRayDetails.HasSOLAccess" style="margin:0;padding:0;"><span class="fw-600 fs-14px">X-Rays:</span> <span class="fw-600 fs-14px">Read</span> <span class="xray-countbadge"><b>{{DataObject.WorklistPageHeaderParameter.XRayDetails.ReadCount || 0}}</b></span> <span class="ml-4px fw-600 fs-14px">Pending</span> <span class="xray-countbadge"><b>{{DataObject.WorklistPageHeaderParameter.XRayDetails.PendingCount || 0}}</b></span><div ng-if="DataObject.XRayTodayTooltip" style="margin:2px 0 0 0;font-weight:600;font-size:14px;">{{DataObject.XRayTodayTooltip}}</div></div><div ng-if="DataObject.WorklistPageHeaderParameter.XRayDetails.HasSOLAccess && DataObject.BonusDetails" style="border-top:1px solid #FF6850;margin:4px 0;height:0;line-height:0;font-size:0;"></div><div ng-if="DataObject.BonusDetails" style="margin:0;padding:0;"><span class="fw-600 fs-14px">{{DataObject.BonusDetails.BonusType}} Bonus:</span> <span class="fw-600 fs-14px">Read</span> <span class="xray-countbadge"><b>{{DataObject.BonusDetails.ReadCount}}</b></span> <span class="ml-4px fw-600 fs-14px">Pending</span> <span class="xray-countbadge"><b>{{DataObject.BonusDetails.PendingCount}}</b></span><div ng-if="DataObject.BonusTooltip" style="margin:2px 0 0 0;font-weight:600;font-size:14px;">{{DataObject.BonusTooltip}}</div></div></div></script>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/account/list/list.html','<style>\r\n\r\n    .userroll-drop .ui-select-multiple.ui-select-bootstrap div:first-of-type {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .userroll-drop .ui-select-multiple.ui-select-bootstrap .ui-select-match {\r\n        width: 100%;\r\n        display: inline-block;\r\n        overflow-x: auto;\r\n    }\r\n\r\n    .editable-text + .tooltip.uibtooltipDenial .tooltip-inner {\r\n        max-width: fit-content !important;\r\n        white-space: unset !important;\r\n        word-break: unset !important;\r\n    }\r\n\r\n    .disable-checkbox {\r\n        pointer-events: unset !important;\r\n        cursor: not-allowed;\r\n        filter: none;\r\n        opacity: 0.5;\r\n    }\r\n\r\n    .user-label {\r\n        font-size: 14px !important;\r\n        font-weight: 600 !important;\r\n        padding-left: 10px;\r\n        color: #fff !important;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .user-title {\r\n        background-color: #323232;\r\n        border-radius: 5px;\r\n        align-items: center;\r\n        display: flex;\r\n        padding: 8px;\r\n    }\r\n\r\n    #SpecialtyUserSettingsGrid.multiSelectGridDiv, #ExcludedSpecialtyUserSettingsGrid.multiSelectGridDiv, #TenantUserSettingsGrid.multiSelectGridDiv, #SiteUserSettingsGrid.multiSelectGridDiv,\r\n    #RoleInviteUserGrid.multiSelectGridDiv, #TenantInviteUserGrid.multiSelectGridDiv, #SiteInviteUserGrid.multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n\r\n    .pass-list:hover {\r\n        background-color: #05C1A4;\r\n    }\r\n\r\n    .groupbox {\r\n        padding: 10px 18px;\r\n        border: 1px solid #5f5f5f;\r\n        border-radius: 6px;\r\n        width: 98%;\r\n        margin: 0 auto;\r\n        position: relative;\r\n    }\r\n\r\n        .groupbox .groupbox-label {\r\n            position: absolute;\r\n            top: -10px;\r\n            left: 12px;\r\n            background: #3a393a;\r\n            padding-left: 5px;\r\n            padding-right: 5px;\r\n        }\r\n\r\n    #editUserModal .ui-select-bootstrap > .ui-select-choices {\r\n        height: 150px;\r\n    }\r\n\r\n    #editUserRole.multiSelectDropdown #editUserRoleGrid {\r\n        top: unset !important;\r\n    }\r\n\r\n    @media only screen and (min-width: 767px) and (max-width: 1199px) {\r\n        .newtblui.mang-invtabale {\r\n            width: 1850px;\r\n        }\r\n    }\r\n</style><div id="user-list-div" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}" class="bg-clr-27 h-100vh am-height"><div><div class="radf-header"><h2 class="w-50 float-left mb-0">Account Manager</h2><div class="clearfix"></div></div><div class="clearfix"></div><div class="row bg-clr-27 pt-8px m-0 rf-filter-ui filterspace pb-1px"><form id="frmFilter" ng-submit="Filter(frmFilter.$valid)"><div class="col-sm-3 col-md-2 col-xs-6 pd-lr tultip-bottom am-input-width"><input ng-model="UserName" type="text" class="blk-input form-control col-placeholder" placeholder="User Name" tooltip-class="uibtooltipDenial" uib-tooltip="User Name" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr am-input-width mob-pr-0"><input ng-model="FirstName" type="text" class="blk-input form-control col-placeholder" placeholder="First Name" tooltip-class="uibtooltipDenial" uib-tooltip="First Name" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr am-input-width"><input ng-model="LastName" type="text" class="blk-input form-control col-placeholder" placeholder="Last Name" tooltip-class="uibtooltipDenial" uib-tooltip="Last Name" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr am-input-width mob-pr-0"><input ng-model="Email" type="text" class="blk-input form-control col-placeholder" placeholder="Email" tooltip-class="uibtooltipDenial" uib-tooltip="Email" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr am-input-width"><input ng-model="PhoneNumber" type="text" class="blk-input form-control col-placeholder" placeholder="Phone Number" tooltip-class="uibtooltipDenial" uib-tooltip="Phone Number" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr am-input-width mob-pr-0"><input ng-model="Roles" type="text" class="blk-input form-control col-placeholder" placeholder="Roles" tooltip-class="uibtooltipDenial" uib-tooltip="Roles" tooltip-placement="auto top"></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr d-none"><div class="input-group blk-calender mb-0"><input type="text" class="blk-input form-control col-placeholder" tooltip-class="uibtooltipDenial" uib-tooltip="DOB (mm/dd/yyyy)" tooltip-placement="auto top" uib-datepicker-popup="MM/dd/yyyy" ng-model="DOB" is-open="isDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="DOB" placeholder="Join Date" data-container="body" ng-click="isDOBOpen = !isDOBOpen"></div></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr mob-w-50 filt-btn-sec w-192px mob-pr-0 px-0"><button type="submit" class="btn btn-primary pull-left rf-btn-xs pb-6px">Filter</button> <button type="button" ng-click="clearFilterAndRefesh();" class="btn btn-default pull-left ml-2 rf-btn-xs pb-6px">Clear</button><div class="form-controller d-flex align-item-center form-check pull-left w-65px ml-10px mt-7px"><input type="checkbox" ng-model="IsRegisterUser" class="m-0 cmn-checkbx-input" id="IsShowAll" ng-change="Filter()"> <label class="rf-label cmn-check-label" for="IsShowAll">Invited</label></div></div><div class="col-sm-3 col-md-2 col-xs-6 pd-lr w-190px float-right text-right mob-px-0 mob-w-50"><button type="button" value="Bulk Invite" class="btn btn-primary rf-btn-xs mr-5px pb-6px" ng-click="accListCtrl.OpenCreateUser()" data-toggle="modal" data-target="#myModal">Invite User</button> <button type="button" value="Bulk Invite" class="btn btn-primary rf-btn-xs pb-6px" ng-click="accListCtrl.OpenBulkInvite()">Bulk Invite</button></div><div class="clearfix"></div></form></div></div><div class=""><div class="common-tbl tbl-height-xs-2"><table><thead><tr><th align="left" class="w-7"><a href="#" ng-click="SortFilter(\'UserName\');">User Name <span ng-show="SortField == \'UserName\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="SortField == \'UserName\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th align="left" class="w-5"><a href="#" ng-click="SortFilter(\'FirstName\');">First Name <span ng-show="SortField == \'FirstName\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="SortField == \'FirstName\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th align="left" class="w-5"><a href="#" ng-click="SortFilter(\'LastName\');">Last Name <span ng-show="SortField == \'LastName\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="SortField == \'LastName\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th align="left" class="w-6"><a href="#" ng-click="SortFilter(\'Email\');">Email <span ng-show="SortField == \'Email\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="SortField == \'Email\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th align="left" class="w-5"><a href="#" ng-click="SortFilter(\'PhoneNumber\');">Phone Number <span ng-show="SortField == \'PhoneNumber\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="SortField == \'PhoneNumber\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th align="left" class="w-8"><a href="#" ng-click="SortFilter(\'Roles\');">Roles <span ng-show="SortField == \'Roles\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="SortField == \'Roles\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th align="left" class="w-5"><a href="#">Pin</a></th><th align="left" class="w-5"><a href="#" ng-click="SortFilter(\'JoinDate\');">Join Date <span ng-show="SortField == \'JoinDate\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="SortField == \'JoinDate\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th align="left" class="w-5"><a href="#" ng-click="SortFilter(\'NPI\');">NPI <span ng-show="SortField == \'NPI\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="SortField == \'NPI\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th align="left" class="w-6"></th></tr></thead><tbody class="overflow-visible"><tr ng-repeat="row in originalData"><td class="txt-clr-1 w-7" sortable="\'UserName\'" ng-form="UserName" style="text-align:left"><span class="editable-text" tooltip-class="uibtooltipDenial" uib-tooltip="{{row.UserName}}" tooltip-placement="auto right"><i class="fa fa-circle text-success" tooltip-class="uibtooltipDenial" uib-tooltip="Online" tooltip-placement="auto bottom" ng-show="row.IsOnline"></i> {{row.UserName}}</span></td><td class="txt-clr-1 w-5" data-title="\'First Name\'" filter="{ FirstName: \'text\'}" sortable="\'FirstName\'" ng-form="FirstName"><span class="editable-text" tooltip-class="uibtooltipDenial" uib-tooltip="{{row.FirstName | titleCase}}" tooltip-placement="auto right">{{row.FirstName | titleCase}}</span></td><td class="txt-clr-1 w-5" data-title="\'Last Name\'" filter="{ LastName: \'text\'}" sortable="\'LastName\'" ng-form="LastName"><span class="editable-text" tooltip-class="uibtooltipDenial" uib-tooltip="{{row.LastName | titleCase}}" tooltip-placement="auto right">{{row.LastName | titleCase}}</span></td><td class="txt-clr-1 w-6" data-title="\'Email\'" filter="{ Email: \'text\'}" sortable="\'Email\'" ng-form="Email"><span class="editable-text" tooltip-class="uibtooltipDenial" uib-tooltip="{{row.Email}}" tooltip-placement="auto right">{{row.Email}}</span></td><td class="txt-clr-1 w-5" data-title="\'Phone Number\'" filter="{ PhoneNumber: \'text\'}" sortable="\'PhoneNumber\'" ng-form="PhoneNumber"><span class="editable-text" tooltip-class="uibtooltipDenial" uib-tooltip="{{row.PhoneNumber}}" tooltip-placement="auto right">{{row.PhoneNumber}}</span></td><td class="txt-clr-1 w-8 overflow-visible" data-title="\'Roles\'" filter="{ Roles: \'text\'}" sortable="\'Roles\'" ng-form="Roles"><span class="editable-text" style="display: inline-block; overflow: hidden; max-width: 100%; text-overflow: ellipsis;" tooltip-class="uibtooltipDenial" uib-tooltip="{{row.Roles}}" tooltip-placement="auto right">{{row.Roles}}</span></td><td class="txt-clr-1 w-5" data-title="\'Pin\'" filter="{ Passcode: \'text\'}" sortable="\'Passcode\'"><span class="editable-text"><input type="password" name="Passcode" readonly="" ng-model="row.Passcode" style="background:transparent !important; border:none !important; outline:none !important" class="no-bg form-control input-sm b-1-s b-clr-1 px-0"></span></td><td class="txt-clr-1 w-5" data-title="\'JoinDate\'" sortable="\'JoinDate\'" ng-form="JoinDate"><span class="editable-text" tooltip-class="uibtooltipDenial" uib-tooltip="{{row.JoinDate | date: \'MM/dd/yyyy hh:mm a\'}}" tooltip-placement="auto right">{{row.JoinDate | date: \'MM/dd/yyyy hh:mm a\'}}</span></td><td class="txt-clr-1 w-5" data-title="\'NPI\'" sortable="\'NPI\'" ng-form="NPI"><span class="editable-text" tooltip-class="uibtooltipDenial" uib-tooltip="{{row.NPI}}" tooltip-placement="auto right">{{row.NPI}}</span></td><td data-title="\' &nbsp; \'" class="w-6 text-center overflow-visible"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups" style="white-space:nowrap!important;"><div class="btn-group m-0" role="group" aria-label="First group" style="float:none!important;"><button tooltip-class="uibtooltipDenial" uib-tooltip="Edit User" tooltip-placement="auto left" type="button" class="btn btn-default txt-clr-14 py-2px px-5px my-0 mx-5px border-0" ng-disabled="row.IsDeleted" ng-click="accListCtrl.setRoleOption(row)" data-toggle="modal" data-target="#editUserModal" style="float:none!important;"><span class="glyphicon glyphicon-pencil"></span></button> <button id="resetPwdBtn" tooltip-class="uibtooltipDenial" uib-tooltip="Reset Password" tooltip-placement="auto left" ng-click="accListCtrl.selectedUser(row);showResetPwdContextMenu($event,row)" type="button" ng-if="row.IsRegisterUser" ng-disabled="row.IsDeleted" class="btn btn-default txt-clr-14 py-2px px-5px my-0 mx-5px border-0" style="float:none!important;"><i class="fa fa-key fs-17px"></i></button> <button tooltip-class="uibtooltipDenial" uib-tooltip="Delete User" tooltip-placement="auto left" type="button" class="btn btn-default txt-clr-14 py-2px px-5px my-0 mx-5px border-0" ng-disabled="row.IsDeleted" ng-click="accListCtrl.delete(row)" style="float:none!important;"><i class="fa fa-trash-o fs-17px"></i></button><button tooltip-class="uibtooltipDenial" uib-tooltip="Save" tooltip-placement="auto left" type="button" class="btn btn-default txt-clr-14 py-2px px-5px my-0 mx-5px border-0" ng-if="false" ng-disabled="rowForm.$pristine || rowForm.$invalid" ng-click="accListCtrl.save(row, rowForm)" style="float:none!important;"><i class="glyphicon glyphicon-floppy-disk"></i></button> <button tooltip-class="uibtooltipDenial" uib-tooltip="Cancel" tooltip-placement="auto left" type="button" class="btn btn-default txt-clr-14 py-2px px-5px my-0 mx-5px border-0" ng-if="false" ng-click="accListCtrl.cancel(row, rowForm)" style="float:none!important;"><i class="fa fa-close fs-18px"></i></button><div class="tooltip-w-100px d-inline-block"><button tooltip-class="uibtooltipDenial" uib-tooltip="User Setting" tooltip-placement="auto left" type="button" class="btn btn-default txt-clr-14 py-2px px-5px my-0 mx-5px border-0" ng-click="accListCtrl.openUserSetting(row)" style="float:none!important;"><span class="glyphicon glyphicon-cog"></span></button></div><div class="tooltip-w-100px d-inline-block"><button tooltip-class="uibtooltipDenial" uib-tooltip="Re-send Invitation" tooltip-placement="auto left" type="button" class="btn btn-default txt-clr-14 py-2px px-5px my-0 mx-5px border-0" ng-click="accListCtrl.SendInvitation(row)" style="float:none!important;" ng-if="!row.IsRegisterUser"><span class="fa fa-envelope"></span></button></div></div></div></td></tr></tbody></table></div><div class="common-footer newfoot mob-footer mob-bottom-minus-25px"><div class="w-75 float-left pl-8px overflow-hidden mob-w-100"><select id="ddlPageSize" class="sing-select form-control mt-10px float-left downArrow-ie w-auto" ng-model="PageSize" ng-change="pageSizeChanged();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" boundary-links="true" total-items="PageCounts" max-size="10" items-per-page="PageSize" ng-model="PageNum" ng-change="pageChanged()" class="pagination-sm float-left" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul><div class="clearfix"></div></div><div class="w-25 float-left text-right d-table h-50px pr-8px overflow-hidden mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m txt-clr-1 smfs-13px">Showing <span>{{ ShowingRedords }} of {{PageCounts}}</span> Total Records</h5></div><div class="clearfix"></div></div><div class="bg-clr-27 h-88vh ht-hs overflow-x-auto overflow-y-hide d-none"><table ng-table="accListCtrl.tableParams" class="table pos-rel wh-table"><tbody><tr ng-repeat="row in $data" ng-form="rowForm" demo-tracked-table-row="row" style="background-color: {{row.IsDeleted ? \'#f5f5f5\' : \'\'}}"><td data-title="\'User Name\'" filter="{ UserName: \'text\'}" sortable="\'UserName\'" ng-switch="row.IsEditing" ng-class="name.$dirty && row.IsEditing ? \'bg-warning\' : \'\'" ng-form="UserName" style="text-align:left"><span ng-switch-default="" class="editable-text"><i class="fa fa-circle text-success" ng-show="row.IsOnline" title="Online"></i> {{row.UserName}}</span><div class="controls py-10px" ng-class="UserName.$invalid && UserName.$dirty ? \'has-error\' : \'\'" ng-switch-when="true"><input type="text" name="UserName" ng-model="row.UserName" class="edit-input form-control input-sm" required=""></div></td><td data-title="\'First Name\'" filter="{ FirstName: \'text\'}" sortable="\'FirstName\'" ng-switch="row.IsEditing" ng-class="name.$dirty && row.IsEditing ? \'bg-warning\' : \'\'" ng-form="FirstName"><span ng-switch-default="" class="editable-text">{{row.FirstName | titleCase}}</span><div class="controls py-10px" ng-class="FirstName.$invalid && FirstName.$dirty ? \'has-error\' : \'\'" ng-switch-when="true"><input type="text" name="FirstName" ng-model="row.FirstName" class="edit-input form-control input-sm" required=""></div></td><td data-title="\'Last Name\'" filter="{ LastName: \'text\'}" sortable="\'LastName\'" ng-switch="row.IsEditing" ng-class="name.$dirty && row.IsEditing ? \'bg-warning\' : \'\'" ng-form="LastName"><span ng-switch-default="" class="editable-text">{{row.LastName | titleCase}}</span><div class="controls py-10px" ng-class="LastName.$invalid && LastName.$dirty ? \'has-error\' : \'\'" ng-switch-when="true"><input type="text" name="LastName" ng-model="row.LastName" class="edit-input form-control input-sm" required=""></div></td><td data-title="\'Email\'" filter="{ Email: \'text\'}" sortable="\'Email\'" ng-switch="row.IsEditing" ng-class="name.$dirty && row.IsEditing ? \'bg-warning\' : \'\'" ng-form="Email"><span ng-switch-default="" class="editable-text">{{row.Email}}</span><div class="controls py-10px" ng-class="Email.$invalid && Email.$dirty ? \'has-error\' : \'\'" ng-switch-when="true"><input type="text" name="Email" ng-model="row.Email" class="edit-input form-control input-sm" required=""></div></td><td data-title="\'Phone Number\'" filter="{ PhoneNumber: \'text\'}" sortable="\'PhoneNumber\'" ng-switch="row.IsEditing" ng-class="name.$dirty && row.IsEditing ? \'bg-warning\' : \'\'" ng-form="PhoneNumber"><span ng-switch-default="" class="editable-text">{{row.PhoneNumber}}</span><div class="controls py-10px" ng-class="PhoneNumber.$invalid && PhoneNumber.$dirty ? \'has-error\' : \'\'" ng-switch-when="true"><input type="text" name="PhoneNumber" ng-model="row.PhoneNumber" class="edit-input form-control input-sm" required=""></div></td><td data-title="\'Roles\'" filter="{ Roles: \'text\'}" sortable="\'Roles\'" ng-switch="row.IsEditing" ng-class="Roles.$dirty && row.IsEditing ? \'bg-warning\' : \'\'" ng-form="Roles"><span ng-switch-default="" class="editable-text">{{row.Roles[0]}}</span><div class="controls py-10px" ng-class="Roles.$invalid && Roles.$dirty ? \'has-error\' : \'\'" ng-switch-when="true"><select class="edit-select form-control input-sm downArrow-ie" ng-options="role for role in RolesList track by role" ng-model="row.Roles[0]" required=""></select><div>{{selectedData}}</div></div></td><td data-title="\'Pin\'" filter="{ Passcode: \'text\'}" sortable="\'Passcode\'" ng-switch="row.IsEditing"><span ng-switch-default="" class="editable-text"><input type="password" name="Passcode" readonly="" ng-model="row.Passcode" style="background:transparent !important; border:none !important; outline:none !important" class="no-bg form-control input-sm b-1-s b-clr-1"></span><div class="controls py-10px" ng-class="Passcode.$invalid && Passcode.$dirty ? \'has-error\' : \'\'" ng-switch-when="true"><input type="password" name="Passcode" maxlength="6" numbers-only="" ng-model="row.Passcode" class="edit-input form-control input-sm" required=""></div></td><td data-title="\'JoinDate\'" sortable="\'JoinDate\'" ng-switch="row.IsEditing" ng-class="JoinDate.$dirty && row.IsEditing ? \'bg-warning\' : \'\'" ng-form="JoinDate"><span ng-switch-default="" class="editable-text">{{row.JoinDate}}</span></td><td data-title="\' &nbsp; \'" class="w-10 text-center"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups" style="white-space:nowrap!important;"><div class="btn-group m-0" role="group" aria-label="First group" style="float:none!important;"><button tooltip-class="uibtooltipDenial" uib-tooltip="Edit User" tooltip-placement="auto top" type="button" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0" ng-disabled="row.IsDeleted" ng-click="accListCtrl.setRoleOption(row)" ng-if="!row.IsEditing" style="float:none!important;"><span class="glyphicon glyphicon-pencil"></span></button> <button tooltip-class="uibtooltipDenial" uib-tooltip="Reset Password" tooltip-placement="auto top" ng-click="accListCtrl.selectedUser(row)" type="button" ng-if="!row.IsEditing" ng-disabled="row.IsDeleted" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0" data-toggle="modal" data-target="#resetPasswordModal" style="float:none!important;"><i class="fa fa-key fs-18px"></i></button> <button tooltip-class="uibtooltipDenial" uib-tooltip="Delete User" tooltip-placement="auto top" type="button" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0" ng-disabled="row.IsDeleted" ng-if="!row.IsEditing" ng-click="accListCtrl.delete(row)" style="float:none!important;"><i class="fa fa-trash-o fs-18px"></i></button><button tooltip-class="uibtooltipDenial" uib-tooltip="Save" tooltip-placement="auto top" type="button" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0" ng-if="row.IsEditing" ng-disabled="rowForm.$pristine || rowForm.$invalid" ng-click="accListCtrl.save(row, rowForm)" style="float:none!important;"><i class="glyphicon glyphicon-floppy-disk"></i></button> <button tooltip-class="uibtooltipDenial" uib-tooltip="Cancel" tooltip-placement="auto top" type="button" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0" ng-if="row.IsEditing" ng-click="accListCtrl.cancel(row, rowForm)" style="float:none!important;"><i class="fa fa-close fs-18px"></i></button><div class="tooltip-w-100px d-inline-block"><button tooltip-class="uibtooltipDenial" uib-tooltip="User Setting" tooltip-placement="auto top" type="button" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0" ng-click="accListCtrl.openUserSetting(row)" style="float:none!important;"><span class="glyphicon glyphicon-cog"></span></button></div></div></div></td></tr></tbody></table></div><div style="text-align:center; margin-top:45px;" ng-show="accListCtrl.messages.length == 0">NO DATA</div><div class="modal fade" id="UserSettingModal" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog w-700px" style="transform: translate(0, 0)!important;"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="closeUserSettings()">&times;</button><h4 class="modal-title">User Setting</h4></div><div class="modal-body"><div class="spinner-overlay" ng-show="isUserSettingModalLoading"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="w-100 clearfix"><div class=""><div class="pos-rel"><div class="w-100"><div class="w-100 pos-rel"><div class=""><div class="width-auto"><div class="mb-15px"><div class="group-register user-title"><label class="user-label pl-0" style="font-size:14px !important; font-weight:600 !important;">Name :</label> <label class="user-label" style="font-size:14px !important; font-weight:600 !important;">{{FullName}}</label></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><label class="rf-label"><span>Specialty</span></label><multi-select master-data="MultiSelectDropdowns.SpecialtyUserSettings" ng-model="MultiSelectDropdowns.SpecialtyUserSettings.SelectedValue" list="SpecialityList" on-change="MultiSelectDropdowns.SpecialtyUserSettings.onSelectedSpecialty(selectedData)"></multi-select></div><div class="form-group py-1 w-100 px-0 pos-rel"><label class="rf-label"><span>Exclude Specialties from Auto Mapping</span></label><multi-select master-data="MultiSelectDropdowns.ExcludedSpecialtyUserSettings" ng-model="MultiSelectDropdowns.ExcludedSpecialtyUserSettings.SelectedValue" list="ExcludedSpecialityList" on-change="MultiSelectDropdowns.ExcludedSpecialtyUserSettings.onSelectedExcludedSpecialty(selectedData)"></multi-select></div><div class="form-group py-1 w-100 px-0 pos-rel"><label class="rf-label"><span>Select Tenants *</span></label><multi-select master-data="MultiSelectDropdowns.TenantUserSettings" ng-model="MultiSelectDropdowns.TenantUserSettings.SelectedValue" list="TenantByUserID" on-change="MultiSelectDropdowns.TenantUserSettings.onSelectedTenant(selectedData)" tooltip-class="uibtooltipDenial" multiple="" uib-tooltip="Choose a Tenant" tooltip-placement="auto top"></multi-select></div><div class="mb-20px"><label class="rf-label"><span>Sites *<span class="py-15px txt-clr-5 fw-600 fs-12px" ng-show="LocSelected.Sites.length==0" style="color: red !important;">Site is required</span></span></label><multi-select master-data="MultiSelectDropdowns.SiteUserSettings" ng-model="MultiSelectDropdowns.SiteUserSettings.SelectedValue" list="SitesByTenants" on-change="MultiSelectDropdowns.SiteUserSettings.onSelectedSite(selectedData)" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Site" tooltip-placement="auto top"></multi-select></div><div class="d-flex align-item-center"><div class="mb-10px mr-20px"><label class="rf-label">Target RVU</label> <input type="text" class="blk-input form-control" is-number="" style="width:100px" id="txtTargetRVU" ng-model="TargetRVU" autocomplete="off" required=""></div><div class="d-flex flex-wrap mb-5px"><div class="mr-20px mt-5px form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="IsReviwer" ng-model="IsReviwer" ng-selected="IsReviwer" autocomplete="off"> <label for="IsReviwer" class="rf-label cmn-check-label">Is Reviewer</label></div><div class="mr-20px mt-5px form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="ShowPracticeWorklist" ng-model="DataObject.ShowPracticeWorklist" ng-selected="DataObject.ShowPracticeWorklist" autocomplete="off" ng-disabled="DataObject.isPSWCheckboxDisableUserSettings" ng-class="DataObject.isPSWCheckboxDisableUserSettings ? \'disable-checkbox\' : \'\'"> <label for="ShowPracticeWorklist" class="rf-label cmn-check-label" ng-class="DataObject.isPSWCheckboxDisableUserSettings ? \'disable-checkbox\' : \'\'">Show Practice Worklist</label></div><div class="mr-20px mt-5px form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="DoNotSendPaymentSummary" ng-model="DataObject.DoNotSendPaymentSummary" ng-selected="DataObject.DoNotSendPaymentSummary" autocomplete="off"> <label for="DoNotSendPaymentSummary" class="rf-label cmn-check-label">Do Not Send Payment Summary</label></div><div class="mr-20px mt-5px form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="EnableTwoFactorAuthentication" ng-model="DataObject.EnableTwoFactorAuthentication" ng-selected="DataObject.EnableTwoFactorAuthentication" autocomplete="off"> <label for="EnableTwoFactorAuthentication" class="rf-label cmn-check-label">Enable TFA</label></div><div class="mt-5px form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="MedDreamViewerKeepOpen" ng-model="DataObject.MedDreamViewerKeepOpen" ng-selected="DataObject.MedDreamViewerKeepOpen" autocomplete="off"> <label for="MedDreamViewerKeepOpen" class="rf-label cmn-check-label" tooltip-class="uibtooltipDenial" uib-tooltip="When enabled, the cView viewer window stays open after finishing a study. When disabled, it closes automatically." tooltip-placement="auto top">Keep cView Open After Study</label></div></div></div><div class="panel-body px-0 py-10px border-0"><label class="groupbox-label rf-label">Dicom Viewer Credentials</label><div id="DicomViewerGridSetting" class="DicomViewerGridSetting ag-theme-balham-dark dicom-viewer-grid" style="height:145px;width:100%"></div></div><div class="" ng-if="DataObject.ShowPaymentContractDetail"><user-payment-contract-detail user-id="userId"></user-payment-contract-detail></div></div><div class="w-100"><button type="submit" id="btnUpdate" value="Update" class="btn btn-primary" ng-click="accListCtrl.UpdateUserSetting(SpecialityId,IsReviwer)" ng-disabled="(DataObject.SaveUserSettingFlag || !SelectedTenant.Obj || (SelectedTenant.Obj && SelectedTenant.Obj.length==0))|| LocSelected.Sites.length==0 || !LocSelected.Sites || (PaymentContract.Obj.Value==\'Payment Per Shift\' && !PaymentContractHelperShift.Obj)">Submit</button></div></div></div></div></div></div></div></div></div></div></div></div></div><div class="modal fade" id="resetPasswordModal" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Reset Password</h4></div><div class="modal-body"><div class="w-100 clearfix"><div class=""><div class="pos-rel"><div class="w-100"><div class="w-100 pos-rel"><form name="frmResetPassword" ng-submit="accListCtrl.ResetPassword(frmResetPassword.$valid)" class="width-inherit height-inherit"><div class="w-100"><div class="w-100 pos-rel py-10px"><div class="mb-20px"><h4 class="txt-clr-1">{{selectedRow.FirstName}} {{selectedRow.LastName}}</h4></div><div class="mb-20px"><label class="fs-14px txt-clr-1 mb-10px">Username</label> <label class="fs-14px txt-clr-15">{{selectedRow.UserName}}</label></div><div class="mb-20px"><label class="fs-14px txt-clr-1 mb-10px">Password *</label> <input type="password" class="blk-input form-control" ng-model="accListCtrl.Password" name="password" autocomplete="off" uib-tooltip-template="\'PasswordPolicyTooltip.html\'" tooltip-class="setpwdpolicytooltip" tooltip-placement="auto top" tooltip-trigger="none" tooltip-is-open="(frmResetPassword._pwdFocused && frmResetPassword.password.$invalid) || (!frmResetPassword._pwdFocused && frmResetPassword.password.$dirty && frmResetPassword.password.$viewValue && frmResetPassword.password.$invalid)" ng-focus="frmResetPassword._pwdFocused = true" ng-blur="frmResetPassword._pwdFocused = false" tooltip-append-to-body="false" ng-pattern="/^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{12,64}$/" required=""></div><div class=""><label class="fs-14px txt-clr-1 mb-10px">Confirm Password *</label> <input type="password" class="blk-input form-control" ng-model="accListCtrl.ConfirmPassword" autocomplete="off" required=""><div class="txt-clr-5 fs-14px fw-600 py-5px">{{accListCtrl.Message}}</div></div></div></div><div class="w-100"><button type="submit" value="Invite" class="btn btn-primary txt-clr-1" ng-disabled="frmResetPassword.$invalid">Reset</button></div></form></div></div></div></div></div></div></div></div></div></div><div ng-show="accListCtrl.isLoading" class="spinner-overlay h-100"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="modal fade" id="myModal" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog" style="top: -100px;"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="CloseInviteUser()">&times;</button><h4 class="modal-title">Invite User</h4></div><div class="modal-body"><div class="w-100 clearfix"><div class="pos-rel"><div class="w-100"><div class="w-100 pos-rel"><form name="frmCreateUser" ng-submit="accListCtrl.CreateUser(frmCreateUser.$valid)" class=""><div class="width-auto"><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group"><label class="rf-label txt-clr-1">First Name *</label> <input type="text" class="blk-input form-control" id="txtFirstName" ng-model="NewUser.FirstName" autocomplete="off" placeholder="First Name" required=""></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group"><label class="rf-label txt-clr-1">Last Name *</label> <input type="text" class="blk-input form-control" id="txtLastName" ng-model="NewUser.LastName" autocomplete="off" placeholder="Last Name" required=""></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group"><label class="rf-label txt-clr-1">Email *</label> <input type="email" class="blk-input form-control" id="txtEmail" ng-model="NewUser.Email" autocomplete="off" placeholder="Email" required=""></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group"><label class="rf-label txt-clr-1">Phone Number</label> <input type="text" id="txtPhone" ui-mask="+1 (999) 999-9999" class="blk-input form-control" ng-model="NewUser.PhoneNumber" autocomplete="off"></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><div class="group"><label class="rf-label txt-clr-1">Role *</label><multi-select master-data="MultiSelectDropdowns.RoleInviteUser" ng-model="MultiSelectDropdowns.RoleInviteUser.SelectedValue" list="RolesList" on-change="MultiSelectDropdowns.RoleInviteUser.onSelectedRole(selectedData)"></multi-select></div></div><div class="form-group py-1 w-100 px-0 pos-rel"><label class="rf-label">Select Tenants *</label><multi-select master-data="MultiSelectDropdowns.TenantInviteUser" ng-model="MultiSelectDropdowns.TenantInviteUser.SelectedValue" list="TenantByUserID" on-change="MultiSelectDropdowns.TenantInviteUser.onSelectedTenant(selectedData)" tooltip-class="uibtooltipDenial" multiple="" uib-tooltip="Choose a Tenant" tooltip-placement="auto top"></multi-select></div><div class="form-group py-1 w-100 px-0 pos-rel inviteuser-site"><div class="group site-slection"><label class="rf-label txt-clr-1">Site *</label><multi-select master-data="MultiSelectDropdowns.SiteInviteUser" ng-model="MultiSelectDropdowns.SiteInviteUser.SelectedValue" list="SitesByTenants" on-change="MultiSelectDropdowns.SiteInviteUser.onSelectedSite(selectedData)" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Site" tooltip-placement="auto top"></multi-select></div></div><div class="mb-20px form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="ShowPracticeWorklist" ng-model="NewUser.ShowPracticeWorklist" ng-selected="NewUser.ShowPracticeWorklist" autocomplete="off" ng-disabled="DataObject.isPSWCheckboxDisableInviteUser" ng-class="DataObject.isPSWCheckboxDisableInviteUser ? \'disable-checkbox\' : \'\'"> <label for="ShowPracticeWorklist" class="rf-label cmn-check-label" ng-class="DataObject.isPSWCheckboxDisableInviteUser ? \'disable-checkbox\' : \'\'">Show Practice Worklist</label></div><div class="mb-20px form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="DoNotSendPaymentSummary" ng-model="NewUser.DoNotSendPaymentSummary" ng-selected="NewUser.DoNotSendPaymentSummary" autocomplete="off"> <label for="DoNotSendPaymentSummary" class="rf-label cmn-check-label">Do Not Send Payment Summary</label></div><div class="mb-20px form-controller d-flex align-item-center"><input type="checkbox" class="m-0 cmn-checkbx-input" id="EnableTwoFactorAuthentication" ng-model="NewUser.EnableTwoFactorAuthentication" ng-selected="NewUser.EnableTwoFactorAuthentication" autocomplete="off"> <label for="EnableTwoFactorAuthentication" class="rf-label cmn-check-label">Enable TFA</label></div></div><div class="w-100"><button type="submit" value="Invite" class="btn btn-primary" ng-disabled="(!SelectedTenant.Obj ||(SelectedTenant.Obj && SelectedTenant.Obj.length==0))|| frmCreateUser.$invalid || !(NewUser.Sites && NewUser.Sites.length > 0) || !NewUser.RoleName">Invite</button></div></form></div></div></div></div></div></div></div></div></div><div class="overflow-hide-all min-h-310px ERA-check-detail" kendo-window="win_BulkInvite" k-on-open="isBulkInviteVisible = true" k-on-close="isBulkInviteVisible = false" k-title="\'Bulk Invite\'" k-visible="false" k-height="730" k-width="winBulkInviteWidth" k-modal="true" k-actions=\'["Close"]\' k-animation="false"><div ng-if="isBulkInviteVisible"><form id="frmFilter" ng-submit="Filter(frmFilter.$valid)"><div class="col-sm-3 col-md-2 col-xs-2 tultip-bottom w-200px pl-0"><label class="m-0 custfile"><input class="cursor-pointer w-100 invisible" type="file" id="fileInput" ng-model="inputfileModelDoc" name="fileInput" onchange="angular.element(this).scope().uploadFile(this)" ng-click="ResetFileInput()" accept=".csv"> <span class="pos-abs py-7px abs-t-0"><i class="fa fa-cloud-upload fs-18px v-a-m"></i> Upload CSV File</span></label> <span class="fs-13px fw-600 text-left txt-clr-5 d-block py-5px">Only CSV files are allowed</span></div><div class="col-sm-3 col-md-2 col-xs-2 pl-0 w-200px"><button type="button" ng-click="downloadSampleFile();" class="btn btn-primary pull-left ml-2"><i class="fa fa-download v-a-m"></i> Download Sample File</button></div><div class="col-sm-3 col-md-2 col-xs-2 mb-5px pos-rel"><multi-select master-data="MultiSelectDropdowns.TenantBulkInvite" ng-model="MultiSelectDropdowns.TenantBulkInvite.SelectedValue" list="TenantByUserID" on-change="MultiSelectDropdowns.TenantBulkInvite.onSelectedTenant(selectedData)" on-add-tag="OnSelectTenant(tag)" on-remove-tag="OnRemovedTenant(tag)" tooltip-class="uibtooltipDenial" multiple="" uib-tooltip="Choose a Tenant" tooltip-placement="auto bottom" ng-if="accListCtrl.selectedAtOne"></multi-select></div><div class="col-sm-3 col-md-2 col-xs-2 mb-5px"><multi-select master-data="MultiSelectDropdowns.SiteBulkInvite" ng-model="MultiSelectDropdowns.SiteBulkInvite.SelectedValue" list="SitesByTenants" on-change="MultiSelectDropdowns.SiteBulkInvite.onSelectedSite(selectedData)" on-add-tag="accListCtrl.OnSelectSite(tag)" on-remove-tag="accListCtrl.OnRemovedSite(tag)" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Site" tooltip-placement="auto bottom" ng-if="accListCtrl.selectedAtOne"></multi-select></div><div class="col-sm-3 col-md-2 col-xs-2 pl-0"><button type="button" ng-click="InviteAll();" class="btn btn-primary pull-left ml-2" ng-if="accListCtrl.selectedAtOne" ng-disabled="disableInvitation()">Send Invitation</button></div></form><div ng-if="collection.length>0" class="clearfix overflow-x-auto"><table class="table-scroll newtblui mang-invtabale" style="border-top:0!important;border-bottom:0!important;"><thead class="bg-clr-31 txt-clr-17" style="border-top:0!important;"><tr><th style="width: 3%; text-overflow: clip;"><input type="checkbox" class="m-0 cmn-checkbx-input" ng-model="accListCtrl.SelectedALL" ng-change="onSelectAll()"></th><th style="width:8%"><span class="txt-clr-14">First Name</span></th><th style="width:8%"><span class="txt-clr-14">Last Name</span></th><th style="width:10%"><span class="txt-clr-14">Email</span></th><th style="width:8%" title="Phone Number"><span class="txt-clr-14">Phone Number</span></th><th style="width:8%"><span class="txt-clr-14">Role</span></th><th style="width:20%"><span class="txt-clr-14">Tenant</span></th><th style="width:20%"><span class="txt-clr-14">Site</span></th><th style="width:12%" title="Show Practice Worklist"><span class="txt-clr-14">Show Practice Worklist</span></th><th style="width:16%" title="Do Not Send Payment Summar"><span class="txt-clr-14">Do Not Send Payment Summary</span></th><th style="width:16%" title="Enable Two Factor Authentication"><span class="txt-clr-14">Enable TFA</span></th><th style="width:11%"></th></tr></thead><tbody class="overflow-auto bg-clr-27 h-58vh" style="-ms-overflow-style: inherit !important;"><tr ng-repeat="item in collection" style="color: white; border-left: 0px;" ng-if="!item.IsInvited"><td style="width:3%; text-overflow: clip;"><input type="checkbox" class="m-0 cmn-checkbx-input" ng-model="item.Selected" ng-change="onSelect()"></td><td style="width:8%"><span>{{item.FirstName}}</span></td><td style="width:8%"><span>{{item.LastName}}</span></td><td style="width:10%"><span>{{item.Email}}</span></td><td style="width:8%"><span>{{item.PhoneNumber}}</span></td><td style="width:8%"><span>{{item.RoleName}}</span></td><td style="width:20%" class="overflow-visible text-ws-normal"><div class="pos-rel"><button type="button" class="pos-abs no-bg border-0 abs-r-0 abs-b-0 cursor-pointer p-5px-all fs-17px" ng-if="clearAllTenantBtn(item.SelectedTenant.Obj)" tooltip-class="uibtooltipDenial" uib-tooltip="Clear Selected" tooltip-placement="auto left" style="z-index: 1;" ng-click="clearSelectedTenantObj($index)"><i class="fa fa-times"></i></button><ui-select class="mult-select" ng-model="item.SelectedTenant.Obj" on-select="TenantSiteList(item.SelectedTenant.Obj)" tooltip-class="uibtooltipDenial" multiple="" uib-tooltip="Choose a Tenant" tooltip-placement="auto top" close-on-select="false" ng-required="true" on-remove="OnRemovedTenant($item,$index)"><ui-select-match placeholder="Select Tenant" allow-clear="true" class="overflow-y-auto d-block overflow-x-hide" style="height: auto;max-height: 50px; overflow-y: scroll !important;">{{$item.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantByUserID | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div></td><td style="width:20%" class="overflow-visible text-ws-normal"><div class="pos-rel"><button type="button" class="pos-abs no-bg border-0 abs-r-0 abs-b-0 cursor-pointer p-5px-all fs-17px" ng-if="clearAllSiteBtn(item.Site)" tooltip-class="uibtooltipDenial" uib-tooltip="Clear Selected" tooltip-placement="auto left" style="z-index: 1;" ng-click="clearSelectedSite($index)"><i class="fa fa-times"></i></button><ui-select class="mult-select ui-select-multiple ui-select-bootstrap px-5px sel-site" multiple="" ng-model="item.Site" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" title="Choose a Site" close-on-select="false" theme="bootstrap" ng-click="SiteSelect(item.SelectedTenant.Obj)"><ui-select-match placeholder="Select a Site" class="overflow-y-auto d-block overflow-x-hide" style="height: auto;max-height: 50px; overflow-y: scroll !important;">{{$item.Site}}</ui-select-match><ui-select-choices repeat="list in SitesByTenants | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div></td><td style="width: 12%; text-overflow: clip; padding-left: 20px;"><div class="form-controller"><input type="checkbox" class="m-0 cmn-checkbx-input" id="ShowPracticeWorklist" ng-model="item.ShowPracticeWorklist" ng-selected="item.ShowPracticeWorklist" autocomplete="off" ng-disabled="!(item.RoleName.includes(\'User\'))" ng-class="!(item.RoleName.includes(\'User\')) ? \'disable-checkbox\' : \'\'"></div></td><td style="width: 16%; text-overflow: clip; padding-left: 20px;"><div class="form-controller"><input type="checkbox" class="m-0 cmn-checkbx-input" id="DoNotSendPaymentSummary" ng-model="item.DoNotSendPaymentSummary" ng-selected="item.DoNotSendPaymentSummary" autocomplete="off"></div></td><td style="width: 16%; text-overflow: clip; padding-left: 20px;"><div class="form-controller"><input type="checkbox" class="m-0 cmn-checkbx-input" id="EnableTwoFactorAuthentication" ng-model="item.EnableTwoFactorAuthentication" ng-selected="item.EnableTwoFactorAuthentication" autocomplete="off"></div></td><td style="width:11%" class="overflow-visible text-ws-normal"><span class="txt-clr-6 fs-13px fw-600">{{item.Message}}</span></td></tr></tbody></table></div></div></div></div><div class="modal fade" id="editUserModal" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog w-700px"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="accListCtrl.cancel(selectedRow, rowForm)">&times;</button><h4 class="modal-title">Edit User</h4></div><div class="modal-body"><div class="w-100 clearfix"><div class=""><div class="pos-rel"><div class="w-100 overflow-x-hide"><div class="w-100 pos-rel"><form name="frmUserDetails" ng-submit="accListCtrl.save(selectedRow, rowForm)" class="width-inherit height-inherit" autocomplete="off"><div class="row mx-0 mb-10px"><div class="col-md-6 col-sm-6"><label class="fs-14px txt-clr-1 mb-5px">First Name *</label> <input type="text" name="FirstName" ng-model="selectedRow.FirstName" class="edit-input form-control input-sm" required=""></div><div class="col-md-6 col-sm-6"><label class="fs-14px txt-clr-1 mb-5px">Last Name *</label> <input type="text" name="LastName" ng-model="selectedRow.LastName" class="edit-input form-control input-sm" required=""></div></div><div class="row mx-0 mb-10px"><div class="col-md-6 col-sm-6"><label class="fs-14px txt-clr-1 mb-5px">Email *</label> <input type="text" name="Email" ng-model="selectedRow.Email" class="edit-input form-control input-sm" required=""></div><div class="col-md-6 col-sm-6"><label class="fs-14px txt-clr-1 mb-5px">Phone Number *</label> <input type="text" name="PhoneNumber" ng-model="selectedRow.PhoneNumber" class="edit-input form-control input-sm" required=""></div></div><div ng-if="selectedRow.UserRoleExists"><div class="row mx-0 mb-10px"><div class="col-md-6 col-sm-6"><div class="group-register"><label class="rf-label">Address Line 1</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="selectedRow.AddressLine1" autocomplete="off"></div></div><div class="col-md-6 col-sm-6"><div class="group-register"><label class="rf-label">Address Line 2</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="selectedRow.AddressLine2" autocomplete="off"></div></div></div><div class="row mx-0 mb-10px"><div class="col-md-6 col-sm-6"><div class="group-register"><label class="rf-label">City</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="selectedRow.City" autocomplete="off"></div></div><div class="col-md-6 col-sm-6"><div class="group-register"><label class="rf-label">Postal Code</label> <input type="text" maxlength="5" class="blk-input form-control b-clr-light" ng-model="selectedRow.PostalCode" autocomplete="off" numbers-only=""></div></div></div><div class="row mx-0 mb-10px"><div class="col-md-6 col-sm-6"><div class="group-register"><label class="rf-label">State</label> <input type="text" class="blk-input form-control b-clr-light" ng-model="selectedRow.State" autocomplete="off"></div></div><div class="col-md-6 col-sm-6"><div class="group-register"><label class="rf-label">Country</label><ui-select skip-focusser="true" class="mult-select" ng-model="selectedRow.CountryCode" title="Select Country"><ui-select-match placeholder="Select Country" allow-clear="true">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="list in CountryCodes | propsFilter: {value: $select.search}" position="down"><div ng-bind-html="list.value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><div class="row mx-0 mb-10px"><div class="col-md-6 col-sm-6"><label class="fs-14px txt-clr-1 mb-5px">User Name *</label> <input type="text" name="UserName" ng-model="selectedRow.UserName" class="blk-input form-control" required=""></div><div class="col-md-6 col-sm-6"><label class="fs-14px txt-clr-1 mb-5px">Roles *</label><multi-select master-data="MultiSelectDropdowns.editUserRole" ng-model="MultiSelectDropdowns.editUserRole.SelectedValue" list="RolesList" on-change="MultiSelectDropdowns.editUserRole.onSelectedRole(selectedData)"></multi-select></div></div><div class="row mx-0 mb-10px"><div class="col-md-6 col-sm-6"><label class="fs-14px txt-clr-1 mb-5px">Pin *</label> <input type="password" name="Passcode" autocomplete="off" maxlength="6" numbers-only="" ng-model="selectedRow.Passcode" class="edit-input form-control input-sm" required=""></div><div class="col-md-6 col-sm-6"><label class="fs-14px txt-clr-1 mb-5px">NPI</label> <input type="text" name="NPI" maxlength="16" numbers-only="" ng-model="selectedRow.NPI" class="edit-input form-control input-sm"></div></div><div class="col-md-12 mt-10px"><button type="submit" ng-click="DataObject.SaveNext = true" class="btn btn-primary float-right txt-clr-1" ng-disabled="frmUserDetails.$invalid || accListCtrl.isLoading">Save & Next</button> <button type="submit" class="btn btn-primary mx-10px float-right txt-clr-1" ng-disabled="frmUserDetails.$invalid || accListCtrl.isLoading">Save</button> <button type="button" ng-click="accListCtrl.cancel(selectedRow, rowForm)" class="btn btn-default float-right txt-clr-1">Cancel</button></div></form></div></div></div></div></div></div></div></div></div></div><div class="context-menu w-150px cursor-pointer" id="contextMenuDiv" ng-show="DataObject.isResetPwdMenuVisible"><div class="p-5px-all pass-list" style="border-bottom: 1px solid #616161;" ng-click="showResetPasswordModel()">Reset Password</div><div class="p-5px-all pass-list" ng-click="sendResetPasswordLink()">Send Link</div></div><script type="text/ng-template" id="PasswordPolicyTooltip.html"><p class="fw-600 fs-13px mb-8px pl-5px mt-5px txt-clr-1">Password Requirements:</p> <ul class="password-policy-tooltip pl-20px m-0 text-left"> <li class="fs-12px mb-8px txt-clr-1" ng-repeat="requirement in DataObject.PasswordRequirements"> {{requirement}} </li> </ul></script><script>\r\n    $(document).ready(function () {\r\n        var isIE10 = !!navigator.userAgent.match(/Trident.*rv\\:10\\./);\r\n        var isIE11 = !!navigator.userAgent.match(/Trident.*rv\\:11\\./);\r\n        if (isIE10 || isIE11) {\r\n            $("#txtRole").hover(function () {\r\n                $("#txtFirstName, #txtLastName, #txtEmail, #txtPhone, .site-slection input[type=\'search\']").blur();\r\n            });\r\n        }\r\n    });\r\n</script>');
$templateCache.put('app/pages/addressbook/list/addressbook_list.html','<style>\r\n    .contactmodal .blk-input.form-control.form-border.border-color-red {\r\n        border-color: red !important;\r\n    }\r\n\r\n    #locationAddressBookModalTreeTooltip {\r\n        max-height: 250px !important;\r\n    }\r\n\r\n    .loc-input.model-loc-input .k-multiselect-wrap.k-floatwrap {\r\n        max-height: 59px;\r\n        min-height: 31px;\r\n        height: 100% !important;\r\n    }\r\n\r\n    .drop-height .addfltr-drpovrly .ui-select-match {\r\n        max-height: 27px;\r\n        display: inherit;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags.focused {\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    #addressBookPagelocationTooltip.tultiptext {\r\n        top: 58px !important;\r\n    }\r\n</style><div id="mainDiv" class="chat-wrapper w-100 h-100 pos-rel bg-clr-25"><div class=""><div class="radf-header"><h2>Address Book</h2></div><div class=""><div><div class="row rf-filter-ui m-0 pt-8px filterspace"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr mob-pr-0" tooltip-class="uibtooltipDenial" uib-tooltip="Name" tooltip-placement="auto top"><input id="Name" class="blk-input form-control col-placeholder" placeholder="Name" ng-model="FilterAddressBook.Name"></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-12 pd-lr mob-pr-0 tultip-bottom"><site-location-grid master-locations="AddressBookInfo.Locations" selected-location="SelectedLocations" on-change="updateSelectedLocation()"></site-location-grid></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr mob-pr-0 drop-height" tooltip-class="uibtooltipDenial" uib-tooltip="Modality" tooltip-placement="auto top"><multi-select master-data="MultiSelectDropdowns.ModalityAddressBookFilter" ng-model="MultiSelectDropdowns.ModalityAddressBookFilter.SelectedValue" list="AddressBookInfo.Modality" on-change="onSelectedModalityFilter(selectedData)"></multi-select></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr mob-pr-0 drop-height" tooltip-class="uibtooltipDenial" uib-tooltip="Department" tooltip-placement="auto top"><multi-select master-data="MultiSelectDropdowns.DeptAddressBookFilter" ng-model="MultiSelectDropdowns.DeptAddressBookFilter.SelectedValue" list="AddressBookInfo.ContactDepartmentType" on-change="onSelectedDeptFilter(selectedData)"></multi-select></div><div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 pd-lr mob-pr-0"><button type="button" class="btn btn-primary border-0 rf-btn-sm mr-4px" ng-click="search()">Filter</button> <button type="button" class="btn btn-default rf-btn-sm" ng-click="clearFilter()">Clear</button> <button class="btn btn-primary rf-btn-sm pull-right ml-10px" data-toggle="modal" data-target="#ContactModal" type="button" ng-click="OpenContactModal()">Add New Contact</button><div class="tultip-bottom col-md-2 col-sm-2 w-100px pr-0 pull-right"><label class="m-0 h-31px custfile"><input class="cursor-pointer w-100 invisible" type="file" id="fileInput" ng-model="inputfileModelDoc" name="fileInput" onchange="angular.element(this).scope().uploadFile(this)" ng-click="ResetFileInput()" accept=".csv"> <span class="pos-abs py-7px text-white fs-12px abs-t-0"><i class="fa fa-cloud-upload fs-16px v-a-m"></i> Import</span></label></div><button type="button" ng-click="ExportCSVDemo();" class="btn btn-primary rf-btn-sm pull-right" title="Download Sample File"><i class="fa fa-download v-a-m"></i></button></div></div><div class="clearfix"></div></div></div><div class="clearfix"></div></div><div ng-class="{\'address-grid-h\': MultiSelectDropdowns.DeptAddressBookFilter.SelectedValue.list.length > 0 || MultiSelectDropdowns.ModalityAddressBookFilter.SelectedValue.list.length > 0 || SelectedLocations.locations.length > 0}"><address-book-grid edit-contact="EditContact()" delete-contact="DeleteContact()" address-book-info="AddressBookInfo" filter-address-book="FilterAddressBook" view-mode="false" contact-preference-type="AddressBookInfo.ContactPreferenceType" export-csv-demo="ExportCSVDemo()"></address-book-grid></div><div class="contactmodal modal fade" id="ContactModal" role="dialog" aria-labelledby="exampleModalLabel" data-keyboard="false" data-backdrop="static" style="overflow: hidden !important;"><div class="modal-dialog w-500px" role="document"><div class="modal-content"><div class="new-popup"><div class="modal-header d-flex align-item-center"><h4 class="modal-title">{{ModalTitle}}</h4><button type="button" class="close otln-0 cursor-pointer fs-inherit" data-dismiss="modal" aria-label="Close" ng-click="EditMode=false"><span aria-hidden="true"><i class="fa fa-close fs-16px"></i></span></button></div><div class="modal-body pos-rel" ng-if="EditMode" style="height: 525px;"><address-book-contact-form address-book-info="AddressBookInfo" on-save-contact="SaveContact(AddressBookInfo.Flag)" save-other-btn="true"></address-book-contact-form></div></div></div></div></div></div>');
$templateCache.put('app/pages/psorders/search/search.html','<div class="row mail-client-container transparent" style="margin:0"><div class="col-md-12" style="padding: 0;"><div class="panel-body"><div class="radf-header"><h2 class="w-80 float-left">Orders</h2><div class="w-20 float-left text-right"></div><div class="clearfix"></div></div><ui-view></ui-view></div></div></div>');
$templateCache.put('app/pages/schedule/add-edit-schedule/addEditSchedule.html','<div class="txt-clr-1"><add-edit-schedule-cmp></add-edit-schedule-cmp></div>');
$templateCache.put('app/pages/schedule/schedule-setting/schedule-setting.html','<div class="txt-clr-1"><schedule-setting-cmp></schedule-setting-cmp></div>');
$templateCache.put('app/pages/schedule/shift-classification/shiftClassification.html','<div class="txt-clr-1"><shift-classification-cmp></shift-classification-cmp></div>');
$templateCache.put('app/pages/schedule/shift-configuration/shiftConfiguration.html','<div class="txt-clr-1"><shift-configuration-cmp></shift-configuration-cmp></div>');
$templateCache.put('app/pages/schedule/user-schedule/user-schedule.html','<div class="txt-clr-1"><user-schedule-cmp></user-schedule-cmp></div>');
$templateCache.put('app/pages/settings/lookup/lookup.html','<style>\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    /*.glyphicon-chevron-up,\r\n    .glyphicon-chevron-down,\r\n    .glyphicon-remove {\r\n        color: #767676;\r\n    }\r\n\r\n    .glyphicon-chevron-up:hover {\r\n        color: dodgerblue;\r\n    }\r\n\r\n    .glyphicon-chevron-down:hover {\r\n        color: dodgerblue;\r\n    }*/\r\n\r\n</style><div class="" ng-init="Init()"><div><div><div class="radf-header"><h2 class="w-50 float-left">{{ title }}</h2><div class="w-50 float-left text-right pt-3px pr-15px"></div><div class="clearfix"></div></div><div class="clearfix"></div></div><div class=""><div class=""><div class="pos-rel h-86vh"><div id="divCMWList"><div class="pt-8px"><div class="row charges-filter-bar m-0"><div class="col-md-12 p-0"><form name="LookupFilter"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-3 col-sm-2 col-xs-6 pd-lr mob-pl-0"><ui-select class="mult-select fs-12px" ng-model="Filter.Type" multiple="" close-on-select="false" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" tooltip-class="uibtooltipDenial" uib-tooltip="Select Lookup Type" tooltip-placement="auto top"><ui-select-match placeholder="Select Lookup Type" allow-clear="true" class="overflow-y-auto d-block overflow-x-hide" style="max-height:25px;">{{$item}}</ui-select-match><ui-select-choices repeat="lookup in LookupTypes" position="down"><div ng-bind-html="lookup | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-2 col-xs-6 pd-lr mob-pr-0" tooltip-class="uibtooltipDenial" uib-tooltip="Enter Key" tooltip-placement="auto top"><input type="text" class="blk-input form-control col-placeholder" style="opacity: 1 !important" ng-model="Filter.Key" placeholder="Enter Key"></div><div class="col-lg-2 col-md-3 col-sm-2 col-xs-12 pd-lr mob-pr-0" tooltip-class="uibtooltipDenial" uib-tooltip="Enter Value" tooltip-placement="auto top"><input type="text" class="blk-input form-control col-placeholder" style="opacity: 1 !important" ng-model="Filter.Value" placeholder="Enter Value"></div><div class="col-lg-6 col-md-3 col-sm-6 col-xs-12 pd-lr mob-pr-0"><button type="submit" ng-click="GetLookupData()" class="btn btn-primary rf-btn-xs mr-4px">Filter</button> <button ng-click="clearFilterAndRefesh()" class="btn btn-default rf-btn-xs">Clear</button> <button type="button" class="btn btn-primary rf-btn-xs pull-right" ng-click="AddEditLookup(null)">Add {{ title }}</button></div><div class="clearfix"></div></div></form></div></div></div><div class="common-tbl tbl-height-xs"><table><thead><tr><th class="w-20 text-left border-0"><a href="#" class="txt-clr-16">Type</a></th><th class="w-20 border-0"><a href="#" class="txt-clr-16">Key</a></th><th class="w-54 border-0"><a href="#" class="txt-clr-16">Value</a></th><th class="w-6 text-left border-0"><a href="#" class="txt-clr-16">Action</a></th></tr></thead><tbody><tr ng-repeat="Lookup in LookupData" ng-class="{\'selected\':$index == selectedRow}" ng-click="setClickedRow($index)"><td class="w-20 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{Lookup.Type}}" tooltip-placement="auto right">{{Lookup.Type}}</span></td><td class="w-20"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{Lookup.Key}}" tooltip-placement="auto right">{{Lookup.Key}}</span></td><td class="w-54"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{Lookup.Value}}" tooltip-placement="auto right">{{Lookup.Value}}</span></td><td class="w-6 text-left p-0"><button type="button" ng-click="AddEditLookup(Lookup)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit" tooltip-placement="auto left" class="btn btn-default txt-clr-14 border-0 my-0 py-0"><span class="glyphicon glyphicon-pencil"></span></button></td></tr></tbody></table></div><div class="common-footer newfoot mob-footer"><div class="w-75 float-left pl-8px mob-w-100"><select id="ddlPageSize" class="sing-select form-control mt-10px float-left downArrow-ie w-auto" ng-model="PageSize" ng-change="pageSizeChanged();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" boundary-links="true" total-items="TotalRows" max-size="10" items-per-page="PageSize" ng-model="PageNum" ng-change="PageNoChanged()" class="pagination float-left" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul><div class="clearfix"></div></div><div class="w-25 float-left text-right d-table h-50px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ LookupData.length }} of {{ TotalRows}}</span> Total Records</h5></div><div class="clearfix"></div></div></div></div></div></div></div><div ng-show="isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div class="modal fade" id="ModalAddEditLookup" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog" style="width:600px!important;"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="CloseLookupModal()">&times;</button><h4 class="modal-title">Lookup</h4></div><div class="modal-body"><form name="formLookup" id="formLookup"><div class="row mb-5px"><div class="col-md-10"><label class="rf-label">Type</label><ui-select name="LocAddLookupSite" class="mult-select h-35px" ng-model="LocAddLookup.Type" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Type" tooltip-placement="auto top" style="text-transform:none !important;" ng-required="true"><ui-select-match placeholder="Select a Type" allow-clear="true">{{$select.selected}}</ui-select-match><ui-select-choices repeat="list in LookupTypes" position="down"><div ng-bind-html="list | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row mb-10px"><div class="col-md-10"><label class="rf-label">Key</label> <input type="text" class="blk-input form-control pl-10px w-100" name="txtLookupKey" ng-model="LocAddLookup.Key" ng-required="true"></div></div><div class="row mb-10px"><div class="col-md-10"><label class="rf-label">Value</label><textarea class="txt-area h-70px w-100 py-6px px-12px" ng-model="LocAddLookup.Value" placeholder="Add a value"> </textarea></div></div><div class="row"><div class="col-md-12"><button type="submit" ng-click="SaveLookup()" ng-disabled="!formLookup.$valid" class="btn btn-primary mr-5px">Save</button></div></div></form></div></div></div></div></div><style>\r\n    td.in-range {\r\n        background-color: #357ebd !important;\r\n        border-color: #3071a9 !important;\r\n        color: #fff;\r\n    }\r\n\r\n    .modal-dialog {\r\n        left: 0px !important;\r\n    }\r\n</style>');
$templateCache.put('app/pages/settings/managelocation/managelocation.html','<style>\r\n\tbody {\r\n\t\toverflow: hidden !important;\r\n\t}\r\n\r\n\t.pagination {\r\n\t\tpadding: 5px 8px 0 !important;\r\n\t}\r\n\r\n\t.save-technique option {\r\n\t\tborder-bottom: 1px solid #424242 !important;\r\n\t\tpadding: 3px !important;\r\n\t}\r\n\r\n\t#Sites .common-tbl table tr td .btn.p-5px-all {\r\n\t\tpadding: 1px !important\r\n\t}\r\n\r\n\t.toggle-div {\r\n\t\tjustify-content: space-between;\r\n\t\tpadding: 4px !important;\r\n\t\tposition: relative;\r\n\t}\r\n\r\n\t\t.toggle-div::after {\r\n\t\t\tcontent: \'\';\r\n\t\t\twidth: 1px;\r\n\t\t\theight: 100%;\r\n\t\t\tbackground-color: #17917e;\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 0;\r\n\t\t\tright: -10px;\r\n\t\t}\r\n\r\n\t.chktgl-value {\r\n\t\twidth: 20px;\r\n\t}\r\n\r\n\t.ui-select-container.ui-select-bootstrap.dropdown + .tooltip.top .tooltip-arrow {\r\n\t\tdisplay: block;\r\n\t\tborder-top-color: #f7f7f7;\r\n\t}\r\n\r\n\t.common-tbl.cmnsite-table thead tr th {\r\n\t\tborder-right: 1px solid #626262;\r\n\t}\r\n\r\n\t.common-tbl.cmnsite-table thead tr th, .common-tbl.cmnsite-table tbody tr td {\r\n\t\ttext-align: center !important;\r\n\t\tborder-bottom-color: transparent;\r\n\t}\r\n\r\n\t.common-tbl.cmnsite-table tbody tr:first-child td {\r\n\t\tborder-top-color: transparent;\r\n\t}\r\n\r\n\t.common-tbl.cmnsite-table tbody tr th {\r\n\t\tborder-bottom: 1px solid #626262;\r\n\t}\r\n\r\n\t.common-tbl.cmnsite-table td {\r\n\t\tborder: 1px solid #626262;\r\n\t\tborder-bottom-color: transparent;\r\n\t}\r\n\r\n\t.common-tbl.cmnsite-table tr:last-child td {\r\n\t\tborder-bottom-color: #626262;\r\n\t}\r\n\r\n\t.Site-ar-grid .ag-cell-value, .Site-ar-grid .ag-cell-value .ng-scope, .Site-ar-grid .ag-input-field-input.ag-text-field-input {\r\n\t\tcolor: #fff !important;\r\n\t}\r\n\r\n\t.Site-ar-grid .ag-pinned-left-cols-container .ag-cell-value {\r\n\t\tfont-weight: 600 !important;\r\n\t\tcolor: #fff !important;\r\n\t}\r\n\r\n\t/*#formSite .mult-select.ui-select-multiple.badgeui-dropdown .ui-select-choices .ui-select-choices-group {\r\n\t\tdisplay: flex;\r\n\t\tflex-wrap: wrap;\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t#formSite .ui-select-bootstrap.badgeui-dropdown .ui-select-choices-row.active,\r\n\t#formSite .ui-select-bootstrap.badgeui-dropdown .ui-select-choices-row .ui-select-choices-row-inner {\r\n\t\tmax-width: 100%;\r\n\t\tbackground-color: rgba(115, 130, 154, 0.44) !important;\r\n\t\tborder-radius: 2px;\r\n\t}\r\n\r\n\t#formSite .ui-select-bootstrap.badgeui-dropdown .ui-select-choices-row {\r\n\t\tmargin: 3px;\r\n\t}*/\r\n\r\n\t.groupbox {\r\n\t\tpadding: 10px 18px;\r\n\t\tborder: 1px solid #5f5f5f;\r\n\t\tborder-radius: 6px;\r\n\t\twidth: 98%;\r\n\t\tmargin: 0 auto;\r\n\t\tposition: relative;\r\n\t}\r\n\r\n\t\t.groupbox .groupbox-label {\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: -10px;\r\n\t\t\tleft: 12px;\r\n\t\t\tbackground: #3a393a;\r\n\t\t\tpadding-left: 5px;\r\n\t\t\tpadding-right: 5px;\r\n\t\t}\r\n\r\n\t.percentin-box .input-group-addon {\r\n\t\tcolor: #fff !important;\r\n\t\tbackground: #515151;\r\n\t\tborder: 0;\r\n\t\tposition: absolute;\r\n\t\tright: 1px;\r\n\t\ttop: 1px;\r\n\t\tz-index: 9;\r\n\t\ttext-align: center;\r\n\t\twidth: 20px;\r\n\t\theight: 28px;\r\n\t\tpadding: 0;\r\n\t\tvertical-align: middle;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\r\n\t\tborder-top-right-radius: 3px;\r\n\t\tborder-bottom-right-radius: 3px;\r\n\t}\r\n\r\n\t.btntoggle-box-site .col-sm-6:nth-child(3) .toggle-div::after {\r\n\t\tdisplay: none;\r\n\t}\r\n    .btntoggle-box-site .col-md-4:nth-child(3) .toggle-div::after,\r\n    .btntoggle-box-site .col-md-4:nth-child(6) .toggle-div::after {\r\n        display: none;\r\n    }\r\n\r\n\t.no-number-arrows::-webkit-inner-spin-button,\r\n\t.no-number-arrows::-webkit-outer-spin-button {\r\n\t\t-webkit-appearance: none;\r\n\t\tmargin: 0;\r\n\t}\r\n\r\n\t.groupbox .tooltip .tooltip-inner {\r\n\t\tcolor: #fff !important;\r\n\t}\r\n\r\n\t.groupbox .tooltip.uibtooltipDenial .tooltip-inner {\r\n\t\tcolor: #000 !important;\r\n\t}\r\n\r\n\t.PrefixSuffixGrid .ag-popup-editor {\r\n\t\tbackground: transparent;\r\n\t\twidth: 47%;\r\n\t\tmax-width: 100%;\r\n\t}\r\n\r\n\t.prefix-editor, .suffix-editor {\r\n\t\toutline: 0;\r\n\t\tcolor: rgb(255, 255, 255);\r\n\t\twidth: 100%;\r\n\t\tmargin-left: 5px;\r\n\t\theight: 25px;\r\n\t\tfont-weight: 400;\r\n\t\tborder-radius: 0 !important;\r\n\t\tborder: 1px solid #fff !important;\r\n\t\tbox-shadow: none !important;\r\n\t\tbackground: #2d3436 !important;\r\n\t}\r\n\r\n\t\t.prefix-editor:focus, .suffix-editor:focus {\r\n\t\t\toutline: none;\r\n\t\t\tbox-shadow: 0 0 2px 1px #719ece !important;\r\n\t\t\tborder-color: #719ece !important;\r\n\t\t}\r\n\r\n\t#defaultDicomViewerGrid.multiSelectGridDiv, #OptionalDVGrid.multiSelectGridDiv, #ContrastTypeGrid.multiSelectGridDiv {\r\n\t\ttop: unset !important;\r\n\t}\r\n\r\n\t#PrtgDeviceGrid.multiSelectGridDiv {\r\n\t\ttop: auto !important;\r\n\t}\r\n    .modal.fade#ModalAddEditSite .modal-dialog {\r\n        transform: translate(0, 0) !important;\r\n    }\r\n    .ag-input-field-input.ag-text-field-input {\r\n\t\tcolor: #fff !important;\r\n    }\r\n    .faxdetail-grid .mult-select.ui-select-container .btn.btn-default.form-control {\r\n        height: 26px !important;\r\n        padding: 3px 24px 2px 12px !important;\r\n        width: 220px;\r\n    }\r\n    .faxdetail-grid .mult-select input.form-control.ui-select-search {\r\n        height: 26px !important;\r\n        width: 220px;\r\n    }\r\n    body > .ui-select-bootstrap.open.viewer-editor.mult-select.provider-select {\r\n        z-index: 10008;\r\n    }\r\n    .isenable-toggle {\r\n        background-color: #323232;\r\n        border-radius: 5px;\r\n        border: 1px solid #9b9b9b;\r\n    }\r\n    @media screen and (max-width: 1199px) {\r\n        #ModalAddEditSite .modal-dialog {\r\n\t\t\twidth: 97% !important;\r\n\t\t\ttop: -20px;\r\n\t\t}\r\n\r\n\t\t\t#ModalAddEditSite .modal-dialog .pt-15px {\r\n\t\t\t\tpadding-top: 8px !important;\r\n\t\t\t}\r\n\r\n\t\t#ModalAddEditSite .new-popup .modal-header {\r\n\t\t\tpadding: 6px 10px !important;\r\n\t\t\theight: auto;\r\n\t\t}\r\n\r\n\t\t#ModalAddEditSite .btntoggle-box-site .mb-10px {\r\n\t\t\tmargin-bottom: 5px !important;\r\n\t\t}\r\n        .modal-AddEditLocation .modal-dialog.w-40 {\r\n            width: 80% !important;\r\n        }\r\n\t}\r\n</style><div class=""><div class=""><div class=""><div class="radf-header"><h2>Manage Location</h2></div><div id="exTab2" class="w-100"><div class="px-10px bg-clr-26"><ul class="nav nav-tabs no-bg"><li class="active"><a href="#Sites" data-toggle="tab">Sites</a></li><li><a href="#Locations" data-toggle="tab">Locations</a></li><li><a href="#Institutions" data-toggle="tab">Institutions</a></li><li><a href="#Tenants" data-toggle="tab">Tenants</a></li></ul></div><div class="tab-content txt-clr-1 p-0"><div class="tab-pane active" id="Sites"><div class="pt-8px"><form name="formSiteFilter" id="formSiteFilter"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><input type="text" class="blk-input form-control" ng-model="SiteTenantName" placeholder="Select Tenant" tooltip-class="uibtooltipDenial" uib-tooltip="Select Tenant" tooltip-placement="auto top"></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr mob-pr-0"><input type="text" class="blk-input form-control" ng-model="Site" placeholder="Select site" tooltip-class="uibtooltipDenial" uib-tooltip="Select site" tooltip-placement="auto top"></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><input type="text" class="blk-input form-control" ng-model="PSSiteName" placeholder="PowerScribe Site" tooltip-class="uibtooltipDenial" uib-tooltip="PowerScribe Site" tooltip-placement="auto top"></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 tultip-bottom pd-lr mob-pr-0"><div id="usersDropdownTree" class="blk-input w-100" kendo-dropdowntree="usersDropdownTree" k-options="usersDropdownTreeOptions"></div><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-140px" style="top:36px!important;">{{userstooltip}}</span></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><button type="submit" ng-click="refresh()" class="btn btn-primary rf-btn-xs mr-4px">Filter</button> <button ng-click="ClearFilter()" class="btn btn-default rf-btn-xs">Clear</button><div class="clearfix"></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr mob-pr-0"><button ng-click="AddSite()" class="btn btn-primary rf-btn-xs pull-right">Add Site</button></div></div></form></div><div class="common-tbl tabnrow-height"><table><thead><tr><th class="w-20 text-left">Tenant</th><th class="w-30 text-left">Site</th><th class="w-20 text-left">PowerScribe Site</th><th class="w-11 text-left">Comparison Time (Hrs)</th><th class="w-14 text-left">Timezone</th><th class="w-17 text-left">Dicom Viewer</th><th class="w-17 text-left pr-0">Action</th></tr></thead><tbody><tr ng-dblclick="EditSite(site)" ng-repeat="site in SiteList track by $index" ng-hide="isLoading" ng-click="setSelected(site.SiteID)" ng-class="(site.SiteID === SelectedSiteID) ? \'row-select-clr\' : \'\'"><td class="w-20 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{site.TenantName}}" tooltip-placement="auto right">{{site.TenantName}}</span></td><td class="w-30 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{site.Site}}" tooltip-placement="auto right">{{site.Site}}</span></td><td class="w-20 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{site.PSSiteName}}" tooltip-placement="auto right">{{site.PSSiteName}}</span></td><td class="w-11 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{site.OldOrdersComparisonTime | minuteToHours}}" tooltip-placement="auto right">{{site.OldOrdersComparisonTime | minuteToHours}}</span></td><td class="w-14 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{site.TimeZone}}" tooltip-placement="auto right">{{site.TimeZone}}</span></td><td class="w-17 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{site.DicomViewer}}" tooltip-placement="auto right">{{site.DicomViewer}}</span></td><td class="w-17 text-left pr-0"><button type="button" class="btn btn-primary rf-btn-xxs py-2px my-3px" data-toggle="modal" ng-click="LoadAssignRadiologists(site)">Assign Users</button> <button ng-click="EditSite(site)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit Site" tooltip-placement="auto left" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0 my-0 py-0"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="DeleteSite(site)" tooltip-class="uibtooltipDenial" uib-tooltip="Delete Site" tooltip-placement="auto left" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0 my-0 py-0"><i class="fa fa-trash-o fs-18px"></i></button></td></tr></tbody></table></div><div class="common-footer h-40px newfoot mob-footer"><div class="w-70 float-left pl-8px mob-w-100"><select id="ddlPageSize" class="sing-select form-control mt-5px float-left downArrow-ie w-auto" ng-model="PageSize" ng-change="pageSizeChanged();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" boundary-links="true" total-items="TotalRows" max-size="10" items-per-page="PageSize" ng-model="PageNo" ng-change="PageNoChanged()" class="pagination float-left" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul><div class="clearfix"></div></div><div class="w-30 float-left text-right d-table h-40px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ SiteList.length }} of {{TotalRows}}</span> Total Records</h5></div></div></div><div class="tab-pane" id="Locations"><div class="pt-8px"><form name="formLocFilter" id="formLocFilter"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-12 pd-lr mob-pr-0"><ui-select class="mult-select" ng-model="LocSelected.Site" tooltip-class="uibtooltipDenial" uib-tooltip="Select site" tooltip-placement="auto top"><ui-select-match placeholder="Select Site" allow-clear="true">{{$select.selected.Site}}</ui-select-match><ui-select-choices repeat="list in AllSites | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-12 pd-lr mob-pr-0"><input type="text" class="blk-input form-control" ng-model="Location" id="input01" placeholder="Select Location" tooltip-class="uibtooltipDenial" uib-tooltip="Select Location" tooltip-placement="auto top"></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr"><button type="submit" ng-click="LocRefresh()" class="btn btn-primary rf-btn-xs mr-4px">Filter</button> <button ng-click="LocClearFilter()" class="btn btn-default rf-btn-xs">Clear</button><div class="clearfix"></div></div><div class="col-lg-6 col-md-6 col-sm-3 col-xs-6 pd-lr mob-pr-0"><button ng-click="AddLocation()" class="btn btn-primary rf-btn-xs pull-right">Add Location</button></div></div></form></div><div class="common-tbl tabnrow-height"><table><thead><tr><th class="w-25 text-left">Location</th><th class="w-32 text-left">Site</th><th class="w-25 text-left">Email ID to notify additional images</th><th class="w-18 text-left pt-0">Action</th></tr></thead><tbody><tr ng-dblclick="EditLocation(location)" ng-repeat="location in LocationList track by $index" ng-hide="isLoading" ng-click="setLocSelected(location.LocationID)" ng-class="(location.LocationID === SelectedLocationID) ? \'row-select-clr\' : \'\'"><td class="w-25 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{location.Location | titleCase}}" tooltip-placement="auto right">{{location.Location | titleCase}}</span></td><td class="w-32 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{location.Site}}" tooltip-placement="auto right">{{location.Site}}</span></td><td class="w-25 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{location.HideStudyEmailId}}" tooltip-placement="auto right">{{location.HideStudyEmailId}}</span></td><td class="w-18 text-left pr-0"><button ng-click="MapTechnique(location)" class="btn btn-primary rf-btn-xxs py-2px my-3px">Map Technique</button> <button ng-click="EditLocation(location)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit Location" tooltip-placement="auto left" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0 my-0 py-0"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="DeleteLocation(location)" tooltip-class="uibtooltipDenial" uib-tooltip="Delete Location" tooltip-placement="auto left" class="btn btn-default txt-clr-14 p-5px-all m-5px-all border-0 my-0 py-0"><i class="fa fa-trash-o fs-18px"></i></button></td></tr></tbody></table></div><div class="common-footer h-40px newfoot mob-footer"><div class="w-70 float-left pl-8px mob-w-100"><select id="ddlLocPageSize" class="sing-select form-control mt-5px float-left downArrow-ie w-auto" ng-model="LocPageSize" ng-change="LocPageSizeChanged();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" boundary-links="true" total-items="LocTotalRows" max-size="10" items-per-page="LocPageSize" ng-model="LocPageNo" ng-change="LocPageNoChanged()" class="pagination float-left" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul><div class="clearfix"></div></div><div class="w-30 float-left text-right d-table h-40px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ LocationList.length }} of {{LocTotalRows}}</span> Total Records</h5></div></div></div><div class="tab-pane" id="Institutions"><div class="pt-8px"><form name="formInstFilter" id="formInstFilter"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr"><ui-select class="mult-select" ng-model="InstSelected.Site" tooltip-class="uibtooltipDenial" uib-tooltip="Select site" tooltip-placement="auto top" ng-change="InstSiteChanged(InstSelected.Site)"><ui-select-match placeholder="Select Site" allow-clear="true">{{$select.selected.Site}}</ui-select-match><ui-select-choices repeat="list in AllSites | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr mob-pr-0"><ui-select class="mult-select overflow-visible text-capitalize hidename" name="InstAddInstitutionLocation" ng-model="InstSelected.Location" placeholder="Select Location" tooltip-class="uibtooltipDenial" uib-tooltip="Select Location" tooltip-placement="auto top"><ui-select-match placeholder="Select Location" allow-clear="true">{{$select.selected.Location}}</ui-select-match><ui-select-choices repeat="list in AllLocations | propsFilter: {Location: $select.search}" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-2 col-xs-12 pd-lr mob-pr-0"><input type="text" class="blk-input form-control" ng-model="InstitutionName" placeholder="Select Institution" tooltip-class="uibtooltipDenial" uib-tooltip="Select Institution" tooltip-placement="auto top"></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><button ng-click="InstRefresh()" class="btn btn-primary rf-btn-xs mr-4px">Filter</button> <button ng-click="InstClearFilter()" class="btn btn-default rf-btn-xs">Clear</button><div class="clearfix"></div></div><div class="col-lg-4 col-md-1 col-sm-2 col-xs-6 pd-lr mob-pr-0"><button type="submit" ng-click="AddInstitution()" class="btn btn-primary rf-btn-xs pull-right">Add Institution</button></div></div></form></div><div class="common-tbl tabnrow-height"><table><thead><tr><th class="w-12 text-left">Institution</th><th class="w-6 text-left">Create ORM</th><th class="w-6 text-left">Create ORU</th><th class="w-12 text-left">Location</th><th class="w-8 text-left">Site</th><th class="w-12 text-left">Dicom Viewer</th><th class="w-12text-left">Optional Dicom Viewer</th><th class="w-12 text-left">Dictation System</th><th class="w-10 text-left">Delayed STAT (In Minutes)</th><th class="w-10 text-left">Action</th></tr></thead><tbody><tr ng-dblclick="EditInstitution(institution)" ng-repeat="institution in InstitutionList track by $index" ng-hide="isLoading" ng-click="setInstSelected(institution.InstitutionID)" ng-class="(institution.InstitutionID === SelectedInstitutionID) ? \'row-select-clr\' : \'\'"><td class="w-12 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{institution.InstitutionName | titleCase}}" tooltip-placement="auto right">{{institution.InstitutionName | titleCase}}</span></td><td class="w-6 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{institution.CreateORM == true ? \'Yes\' : \'No\'}}" tooltip-placement="auto right">{{institution.CreateORM == true ? "Yes" : "No"}}</span></td><td class="w-6 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="" tooltip-placement="auto right">{{institution.CreateORU == true ? "Yes" : "No"}}</span></td><td class="w-12 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{institution.Location | titleCase}}" tooltip-placement="auto right">{{institution.Location | titleCase}}</span></td><td class="w-8 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{institution.Site | titleCase}}" tooltip-placement="auto right">{{institution.Site | titleCase}}</span></td><td class="w-12 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{institution.DicomViewer}}" tooltip-placement="auto right">{{institution.DicomViewer}}</span></td><td class="w-12 text-left text-break-word"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{institution.OptionalDicomViewer}}" tooltip-placement="auto left">{{institution.OptionalDicomViewer}}</span></td><td class="w-12 text-left text-break-word"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{institution.DictationSystem}}" tooltip-placement="auto right">{{institution.DictationSystem}}</span></td><td class="w-10 text-left text-break-word"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{institution.DelayedStatMins}}" tooltip-placement="auto right">{{institution.DelayedStatMins}}</span></td><td class="w-10 text-left p-0"><button ng-click="EditInstitution(institution)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit Institution" tooltip-placement="auto left" class="btn btn-default txt-clr-14 px-5px mx-5px border-0 my-4px py-0"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="DeleteInstitution(institution)" tooltip-class="uibtooltipDenial" uib-tooltip="Delete Institution" tooltip-placement="auto left" class="btn btn-default txt-clr-14 px-5px mx-5px border-0 my-4px py-0"><i class="fa fa-trash-o fs-18px"></i></button></td></tr></tbody></table></div><div class="common-footer h-40px newfoot mob-footer"><div class="w-70 float-left pl-8px mob-w-100"><select id="ddlInstPageSize" class="sing-select form-control mt-5px float-left downArrow-ie w-auto" ng-model="InstPageSize" ng-change="InstPageSizeChanged();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" boundary-links="true" total-items="InstTotalRows" max-size="10" items-per-page="InstPageSize" ng-model="InstPageNo" ng-change="InstPageNoChanged()" class="pagination float-left" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul><div class="clearfix"></div></div><div class="w-30 float-left text-right d-table h-40px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ InstitutionList.length }} of {{InstTotalRows}}</span> Total Records</h5></div><div class="clearfix"></div></div></div><div id="Tenants" class="tab-pane"><div class="pt-8px"><tenant-dicom-viewer tenants-list="TenantByUserID" dicom-viewer-list="InstDicomViewerList"></tenant-dicom-viewer></div></div></div></div></div></div></div><div class="modal fade" id="ModalAddEditSite" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog modal-lg" style="vertical-align: top;"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="disableSiteTimezone = false;">&times;</button><h4 class="modal-title">Site</h4></div><div class="modal-body pt-8px"><form name="formSite" id="formSite"><div class="row"><div class="col-md-4 col-sm-4 px-10px sm-mt-10px mb-10px"><label class="rf-label">Tenant *</label><ui-select class="mult-select" ng-model="SelectedTenant.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Tenant" tooltip-placement="auto top" ng-required="true" ng-change="GetAllRadiologistsByTenat(SelectedTenant)"><ui-select-match placeholder="Select Tenant" allow-clear="false">{{$select.selected.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantByUserID | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-4 col-sm-4 px-10px sm-mt-10px mb-10px"><label class="rf-label">Site *</label> <input class="blk-input form-control" type="text" placeholder="Site" style="width:100%" ng-model="txtSite" ng-required="true"></div><div class="col-md-4 col-sm-4 px-10px sm-mt-10px mb-10px"><label class="rf-label">PowerScribe Site *</label> <input class="blk-input form-control" type="text" placeholder="PowerScribe Site" style="width:100%" ng-model="txtPSSiteName" ng-required="true"></div></div><div class="row"><div class="col-md-4 col-sm-4 px-10px sm-mt-10px mb-10px" ng-if="AllTimeZoneList.length>0"><label class="rf-label">Timezone *</label><ui-select class="mult-select" ng-model="SelectedTimeZone.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Timezone" tooltip-placement="auto top" ng-required="true" ng-disabled="disableSiteTimezone"><ui-select-match placeholder="Select Timezone" allow-clear="false">(UTC{{$select.selected.current_utc_offset}}) {{$select.selected.TimeZone}}</ui-select-match><ui-select-choices repeat="timezone in AllTimeZoneList | filter: {TimeZone: $select.search}" position="down"><div ng-bind-html="\'(UTC\'+timezone.current_utc_offset+\') \'+timezone.TimeZone | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-4 col-sm-4 px-10px sm-mt-10px mb-10px"><label class="rf-label">Comparison Time (Hrs) *</label> <input class="blk-input form-control" type="number" placeholder="Comparison Time (Hrs)" style="width:100%" ng-model="ObjSite.OldOrdersComparisonTime" ng-required="true" min="1"></div><div class="col-md-4 col-sm-4 px-10px sm-mt-10px percentin-box mb-10px"><label class="rf-label">Peer Review Percentage</label><div class="input-group mb-0"><input class="blk-input form-control pr-20px no-number-arrows" type="number" style="width:100%" ng-model="DataObject.ReviewPercentage" pattern="\\d+" max="100" min="0" placeholder="Peer Review Percentage"> <span class="input-group-addon" style="">%</span></div></div></div><div class="row"><div class="col-md-6 col-sm-6 px-10px sm-mt-10px mb-10px"><label class="rf-label">Dicom Viewer *</label><multi-select master-data="multiSelectDropdowns.defaultDicomViewer" list="InstDicomViewerList" ng-model="multiSelectDropdowns.defaultDicomViewer.SelectedValue" on-change="multiSelectDropdowns.defaultDicomViewer.onSelectedDefaultDV(selectedData)" on-remove-tag="removeDicomViewer(tag)"></multi-select></div><div class="col-md-6 col-sm-6 px-10px sm-mt-10px mb-10px"><label class="rf-label">Contrast Type</label><multi-select master-data="multiSelectDropdowns.ContrastType" list="ContrastTypeList" ng-model="multiSelectDropdowns.ContrastType.SelectedValue" on-change="multiSelectDropdowns.ContrastType.onSelectedContrastType(selectedData)"></multi-select></div></div><div class="row mb-20px"><div class="col-md-6 col-sm-6 px-10px sm-mt-10px"><label class="rf-label">PRTG Device</label><multi-select master-data="multiSelectDropdowns.PrtgDevice" list="PrtgDeviceList" ng-model="multiSelectDropdowns.PrtgDevice.SelectedValue" on-change="multiSelectDropdowns.PrtgDevice.onSelectedPrtgDevice(selectedData)"></multi-select></div></div><div class="row mb-10px"><div class="col-md-12 px-0"><div class="groupbox pos-rel px-10px"><label class="groupbox-label rf-label">Query Retrieve</label><div id="mySiteConfigGrid" style="width: 100%; height: 148px" class="ag-theme-balham-dark Site-ar-grid mt-5px"></div><label class="rf-label">Remove Prefix/Suffix <i class="fa fa-info-circle" aria-hidden="true" tooltip-placement="top" uib-tooltip="When sending a query to the PACS, RadFlow will remove any prefixes and suffixes from the Patient ID (MRN) and the Accession.!"></i></label><div id="PrefixSuffixGrid" class="PrefixSuffixGrid ag-theme-balham-dark dicom-viewer-grid" style="height:152px;width:100%"></div></div></div></div><div class="row btntoggle-box-site"><div class="col-md-4 col-sm-4 mb-10px px-10px txt-clr-1 sm-mt-10px"><div class="d-flex align-item-center toggle-div p-6px-all"><label class="rf-label mb-0">Create Report PDF</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="ObjSite.CreateReportPDF"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="ObjSite.CreateReportPDF">Yes</span> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="!ObjSite.CreateReportPDF">No</span></div></div></div><div class="col-md-4 col-sm-4 px-10px mb-10px sm-mt-10px"><div class="d-flex align-item-center p-6px-all toggle-div"><label class="rf-label mb-0">Dicomize PDF</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="ObjSite.IsDicomizePDF" id="IsDicomizePDF"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="ObjSite.IsDicomizePDF">Yes</span> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="!ObjSite.IsDicomizePDF">No</span></div></div></div><div class="col-md-4 col-sm-4 txt-clr-1 mb-10px px-10px sm-mt-10px"><div class="d-flex align-item-center p-6px-all toggle-div"><label class="rf-label mb-0">Enable Patient Wallet</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="ObjSite.EnablePatientWallet"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="ObjSite.EnablePatientWallet">Yes</span> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="!ObjSite.EnablePatientWallet">No</span></div></div></div><div class="col-md-4 col-sm-4 mb-10px sm-mt-10px px-10px"><div class="d-flex align-item-center p-6px-all toggle-div"><label class="rf-label mb-0">Image viewable for technologist</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="ObjSite.IsImageViewableForTech" id="IsImageViewableForTech"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="ObjSite.IsImageViewableForTech">Yes</span> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="!ObjSite.IsImageViewableForTech">No</span></div></div></div><div class="col-md-4 col-sm-4 mb-10px sm-mt-10px px-10px"><div class="d-flex align-item-center p-6px-all toggle-div"><label class="rf-label mb-0">Order finalize by technologist</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="ObjSite.IsFinalize" id="IsFinalize"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="ObjSite.IsFinalize">Yes</span> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="!ObjSite.IsFinalize">No</span></div></div></div><div class="col-md-4 col-sm-4 mb-10px sm-mt-10px px-10px"><div class="d-flex align-item-center p-6px-all toggle-div"><label class="rf-label mb-0">Enable Fax</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="ObjSite.IsEnableFax" id="IsEnableFax"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="ObjSite.IsEnableFax">Yes</span> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="!ObjSite.IsEnableFax">No</span></div></div></div></div><div class="row"></div><div class="row"><div class="col-md-12"><div class="pt-15px d-flex justify-content-end" style="border-top: 1px solid #504f4f;"><div class="d-flex mr-5px" style="align-items:flex-end;"><span class="txt-clr-5 pl-10px fw-600 mt-10px fs-12px mr-5px" ng-show="selectedRadiologists.length==0" style="color: red !important;">Radiologist is required</span> <button type="button" class="btn btn-primary" data-toggle="modal" ng-disabled="!SelectedTenant.Obj" ng-click="showAssignRadiologistCmp.value=true;AssignRadiologists()">Assign Users</button></div><button class="btn btn-default mr-5px" data-dismiss="modal">Cancel</button> <button type="submit" ng-click="SaveSite()" ng-disabled="!formSite.$valid || SiteSaved || selectedclientsFullSet.length == 0 || checkInstitutionViewerMap||(!ObjSite.DicomViewer || ObjSite.DicomViewer.length==0)" class="btn btn-primary">Save</button></div></div></div></form></div></div></div></div></div><div class="modal fade" id="AssignUsers" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog assign-user-modal" ng-if="showAssignRadiologistCmp.value"><div class="modal-content"><assign-radiologist-grid radiologists="RadiologistsFullSet" selected-values="selectedValues" on-select-radiologist="_SaveRadiologists()" btn-text="SavebtnText" site-title="txtSite" modal-title="Assign Users" on-cancel="AssignUserCancel()" radio-logist-cmp-tooltip-id="radioLogistManageLocationCmp" show-assign-radiologist-cmp="showAssignRadiologistCmp" tenant-id="SelectedTenantId"></assign-radiologist-grid></div></div></div><div class="modal modal-AddEditLocation fade" id="ModalAddEditLocation" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog w-40"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Location</h4></div><div class="modal-body"><form name="formLocation" id="formLocation"><div class="row"><div class="col-md-6 col-sm-6 mb-10px"><label class="rf-label">Site</label><ui-select name="LocAddLocationSite" class="mult-select overflow-visible text-capitalize hidename" ng-model="LocAddLocation.Site" tooltip-class="uibtooltipDenial" uib-tooltip="Select Site" tooltip-placement="auto top" ng-required="true" ng-disabled="LocFlagEdit"><ui-select-match placeholder="Select Site" allow-clear="true">{{$select.selected.Site}}</ui-select-match><ui-select-choices repeat="list in AllSites | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6 col-sm-6 mb-10px"><label class="rf-label">Location</label> <input type="text" class="blk-input form-control" style="width:100%" placeholder="Location" name="txtLocation" ng-model="LocAddLocation.txtLocation" ng-required="true"></div></div><div class="row"><div class="col-md-12 mb-10px email-tags-input"><label class="rf-label">Email Id To notify Additional images</label><tags-input ng-model="LocAddLocation.HideStudyEmailId" ng-if="loadEmailidInput" placeholder="Add Email Address" allowed-tags-pattern="[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?" add-on-paste="true" add-on-enter="true" paste-split-pattern=";" class="prevent-clear-search"></tags-input></div></div><div class="float-left w-100 mb-10px" ng-if="ShowAddressBookGrid"><label class="rf-label mx-1px p-5px-all mb-0" style="background-color: #1c1c1c;">Contact Detail</label><address-book-grid view-mode="true" filter-address-book="FilterAddressBook"></address-book-grid></div><div class="row" ng-show="LocAddLocation.Site &&LocAddLocation.Site.IsEnableFax"><div class="col-md-12 d-flex align-item-center mb-10px email-tags-input"><label class="rf-label mb-0">Automated Fax</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="LocAddLocation.IsAutomateFax" id="IsAutomateFax"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="LocAddLocation.IsAutomateFax">Yes</span> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="!LocAddLocation.IsAutomateFax">No</span></div></div></div><div class="float-left w-100 mb-10px" ng-show="LocAddLocation.Site &&LocAddLocation.Site.IsEnableFax"><label class="rf-label mx-1px p-5px-all mb-0" style="background-color: #1c1c1c;">Fax Detail</label><div id="FaxDetailsGrid" class="w-100 ag-theme-balham-dark faxdetail-grid" style="height: 200px;"></div></div><div class="row clearfix"><div class="col-md-12 mt-5px"><button class="btn btn-default" data-dismiss="modal">Cancel</button> <button type="submit" ng-click="SaveLocation()" ng-disabled="!formLocation.$valid || LocationSaved" class="btn btn-primary mr-5px">Save</button></div></div></form></div></div></div></div></div><div class="modal fade" id="ModalAddEditInstitution" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Institution</h4></div><div class="modal-body"><form name="formInstitution" id="formInstitution"><div class="row mb-20px"><div class="col-md-6"><label class="rf-label">Site</label><ui-select class="mult-select overflow-visible text-capitalize hidename" name="InstAddInstitutionSite" ng-model="InstAddInstitution.Site" tooltip-class="uibtooltipDenial" uib-tooltip="Select Site" tooltip-placement="auto top" ng-required="true" ng-disabled="InstFlagEdit" ng-change="InstAddInstitutionSiteChanged(InstAddInstitution.Site)"><ui-select-match placeholder="Select Site">{{$select.selected.Site}} <i class="glyphicon glyphicon-remove clear-place" ng-click="$event.stopPropagation();InstAddInstitutionSiteChanged();" ng-if="!InstFlagEdit"></i></ui-select-match><ui-select-choices repeat="list in AllSites | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6"><label class="rf-label">Location</label><ui-select class="mult-select overflow-visible text-capitalize hidename" name="InstAddInstitutionLocation" ng-model="InstAddInstitution.Location" tooltip-class="uibtooltipDenial" uib-tooltip="Select Location" tooltip-placement="auto top" ng-required="true" ng-disabled="InstFlagEdit"><ui-select-match placeholder="Select Location" allow-clear="true">{{$select.selected.Location}}</ui-select-match><ui-select-choices repeat="list in InstAllLocations | propsFilter: {Location: $select.search}" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row mb-5px"><div class="col-md-6 mb-20px"><label class="rf-label">Institution</label> <input type="text" class="blk-input form-control" placeholder="Institution" name="txtInstitution" ng-model="InstAddInstitution.txtInstitutionName" ng-required="true"></div><div class="clearfix"></div><div class="col-md-6 mb-20px txt-clr-1"><label class="rf-label">Create ORM</label><div class="d-flex align-item-center"><label class="form-controller d-flex align-item-center mr-10px mb-0"><input type="radio" name="InstAddInstitutionCreateORM" ng-model="InstAddInstitution.CreateORM" value="1" class="cmn-checkbx-input m-0"> <span class="rf-label cmn-check-label">Yes</span></label> <label class="form-controller d-flex align-item-center mb-0"><input type="radio" name="InstAddInstitutionCreateORM" ng-model="InstAddInstitution.CreateORM" value="0" class="cmn-checkbx-input m-0"> <span class="rf-label cmn-check-label">No</span></label></div></div><div class="col-md-6 mb-20px txt-clr-1"><label class="rf-label">Create ORU</label><div class="d-flex align-item-center"><label class="form-controller d-flex align-item-center mr-10px mb-0"><input type="radio" name="InstAddInstitutionCreateORU" ng-model="InstAddInstitution.CreateORU" value="1" class="cmn-checkbx-input m-0"> <span class="rf-label cmn-check-label">Yes</span></label> <label class="form-controller d-flex align-item-center mb-0"><input type="radio" name="InstAddInstitutionCreateORU" ng-model="InstAddInstitution.CreateORU" value="0" class="cmn-checkbx-input m-0"> <span class="rf-label cmn-check-label">No</span></label></div></div><div class="col-md-6 mb-20px"><label class="rf-label">Dicom Viewer</label><ui-select class="mult-select" ng-model="InstAddInstitution.ddlDicomViewer" tooltip-class="uibtooltipDenial" uib-tooltip="Select Viewer" tooltip-placement="auto top" ng-required="true" on-select="onSelectedInst($item)"><ui-select-match placeholder="Select Viewer"><span>{{$select.selected.Key}}</span> <i class="glyphicon glyphicon-remove clear-place" ng-click="clearInst($event)"></i></ui-select-match><ui-select-choices repeat="dicomviewer in InstDicomViewerList | propsFilter: {Key: $select.search}" position="down"><div ng-bind-html="dicomviewer.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-6 mb-20px"><label class="rf-label">Default Dictation System</label><ui-select class="mult-select" ng-model="InstAddInstitution.ddlDictationSystem" tooltip-class="uibtooltipDenial" uib-tooltip="Select Dictation System" tooltip-placement="auto top"><ui-select-match placeholder="Select Dictation System"><span>{{$select.selected.Key}}</span> <i class="glyphicon glyphicon-remove clear-place" ng-click="clearDictation($event)"></i></ui-select-match><ui-select-choices repeat="dictationSystem in DefaultDictationSystemList | propsFilter: {Key: $select.search}" position="down"><div ng-bind-html="dictationSystem.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-12 mb-10px"><label class="rf-label">Optional Dicom Viewer</label><multi-select master-data="multiSelectDropdowns.OptionalDV" list="InstDicomViewerList" ng-model="multiSelectDropdowns.OptionalDV.SelectedValue" on-change="onSelectedOptionalDV(selectedData)"></multi-select></div><div ng-repeat="dicomViewer in dicomViewers track by $index"><div class="w-50 float-left px-15px mb-10px" ng-show="visibleDicom(dicomViewer) || diacomViewerURLVisible"><label class="rf-label">{{dicomViewer}} URL</label> <input type="text" class="blk-input form-control" placeholder="Dicom Viewer URL" name="txtDicomViewerURL" ng-model="InstAddInstitution.txtDicomViewerURL" ng-required="visibleDicom(dicomViewer) || diacomViewerURLVisible"></div></div><div class="w-50 float-left px-15px mb-10px"><label class="rf-label">Delayed STAT (In Minutes)</label> <input type="number" class="blk-input form-control" placeholder="Delayed STAT" name="txtDelayedSTAT" ng-model="InstAddInstitution.txtDelayedSTAT" ng-required="true" min="0"></div><div class="w-50 float-left px-15px mb-10px"><label class="rf-label">Delayed STAT Color Code</label> <input type="color" id="DelayedSTATColor" name="DelayedSTATColor" ng-model="InstAddInstitution.txtDelayedSTATColor" class="mr-5px p-0 border-0 h-20px v-a-m w-90px"><button id="btnDelayedSTATColor" type="button" class="btn btn-primary py-5px px-10px" ng-click="InstResetDelayedSTATColor()">Reset</button></div><div class="clearfix"></div></div><div class="row"><div class="col-md-12"><button class="btn btn-default" data-dismiss="modal">Cancel</button> <button type="submit" ng-click="SaveInstitution()" ng-disabled="!formInstitution.$valid || InstitutionSaved" class="btn btn-primary mr-5px">Save</button></div></div></form></div></div></div></div></div><div ng-show="isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="modal fade" id="ModalMapTechnique" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="search = null;searchclient = null;">&times;</button><h4 class="modal-title">Technique Mapping</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><label class="fs-14px txt-clr-1 mb-5px">Location: {{LocationName}}</label></div></div><div class="w-100"><div class="w-45 float-left"><label class="rf-label">Available Technique</label><div class="form-group"><input type="text" class="blk-input form-control" ng-model="search" ng-keyup="filterTechnique()" placeholder="Search Technique Key"></div><select class="sing-select save-technique w-100 outline-none downArrow-ie" multiple="" ng-model="available" title="{{item.Value}}" ng-options="item as item.Key for item in TechniqueList | orderBy:\'Key\'" style="height:500px; background-color: #1f1f1f !important;"></select></div><div class="w-10 float-left px-10px"><div class="h-100px">&nbsp;</div><div class=""><input id="moveright" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value=">" ng-click="moveItem(available, \'select\')"></div><div class=""><input id="moverightall" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value=">>" ng-click="selectAllItem()"></div><div class=""><input id="move left" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value="<" ng-click="moveItem(selected, \'deselect\')"></div><div class=""><input id="moveleftall" type="button" class="btn-primary w-100 h-25px border-0 mb-10px" value="<<" ng-click="deselectAll()"></div></div><div class="w-45 float-left"><label class="rf-label">Selected Technique</label><div class="form-group"><input type="text" class="blk-input form-control" ng-model="searchclient" ng-keyup="filterselectedTechnique()" placeholder="Search Selected Technique Key"></div><select class="save-technique sing-select w-100 outline-none downArrow-ie" multiple="" ng-model="selected" title="{{item.Value}}" ng-options="item as item.Key for item in SelectedTechniques | orderBy:\'Key\'" style="height:500px; background-color: #1f1f1f !important;"></select></div><div class="clearfix"></div></div><div class="row"><div class="col-md-12" style="padding-top:10px;"><button class="btn btn-default mr-5px" data-dismiss="modal">Cancel</button> <button type="submit" ng-click="SaveTechnique()" class="btn btn-primary">Save</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/settings/mapping/mapping.html','<style>\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    .csv-filename {\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        width: 150px;\r\n        display: block;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags.focused {\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    .location-tags-input .tultiptext {\r\n        max-height: 250px !important;\r\n        top: 55px !important;\r\n        left: 50% !important;\r\n    }\r\n\r\n    .custm-rvu {\r\n        justify-content: flex-end;\r\n    }\r\n\r\n    .custom-wrvumap-grid {\r\n        height: calc(100vh - 135px);\r\n    }\r\n\r\n        .custom-wrvumap-grid.cust-wrvumap-site {\r\n            height: calc(100vh - 158px);\r\n        }\r\n\r\n    .sitetooltip-elem .tultiptext {\r\n        top: 32px !important;\r\n        left: 47px !important;\r\n        max-width: 250px !important;\r\n    }\r\n\r\n        .sitetooltip-elem .tultiptext.multselect-haslist {\r\n            top: 62px !important;\r\n            left: 68px !important;\r\n        }\r\n\r\n    .physicianmodal .blk-input.form-control.form-border.border-color-red {\r\n        border-color: red !important;\r\n    }\r\n    \r\n    @media (min-width: 768px) and (max-width: 992px) {\r\n        .custom-wrvumap-grid {\r\n            height: calc(100vh - 175px);\r\n        }\r\n\r\n            .custom-wrvumap-grid.cust-wrvumap-site {\r\n                height: calc(100vh - 198px);\r\n            }\r\n\r\n        .sitetooltip-elem .tultiptext, .sitetooltip-elem .tultiptext.multselect-haslist {\r\n            left: 91px !important;\r\n        }\r\n    }\r\n</style><div class=""><div class=""><div id="mainDiv" class="mappingsec"><div id="MappingHeader" class="radf-header"><h2>Mapping</h2></div><div id="exTab2" class=""><div id="mappingNav" class="px-10px bg-clr-26"><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center" ng-click="changeTab(\'CustomwRVU\')" ng-class="{\'disable-area active\':currentTab.customwRVUTab}"><a href="#customwRVUTab" data-toggle="tab">Custom wRVU Mapping</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeTab(\'ReadingProviderMapping\')" ng-class="{\'disable-area active\':currentTab.ReadingProviderMapping}"><a href="#ReadingProviderMapping" data-toggle="tab">Reading Provider Mapping</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeTab(\'ProcedureSpecialityMapping\')" ng-class="{\'disable-area active\':currentTab.ProcedureSpecialityMapping}"><a href="#ProcedureSpecialityMapping" data-toggle="tab">Procedure Specialty Mapping</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeTab(\'OrderingPhysician\')" ng-class="{\'disable-area active\':currentTab.OrderingPhysician}"><a href="#OrderingPhysician" data-toggle="tab">Ordering Physician</a></li></ul></div><div class="tab-content txt-clr-1 p-0" ng-if="currentTab.ReadingProviderMapping"><div class="tab-pane active" id="ReadingProviderMapping"><reading-provider ng-if="!isShowGrid"></reading-provider></div></div><div class="tab-content txt-clr-1 p-0"><div class="tab-pane" id="ProcedureSpecialityMapping" ng-if="currentTab.ProcedureSpecialityMapping"><div class="pt-8px"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr"><ui-select class="mult-select" ng-model="sProcedure.Code" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Procedure Code" tooltip-placement="auto top"><ui-select-match placeholder="Choose a Procedure Code" allow-clear="true">{{$select.selected.ProcedureCode}} {{$select.selected.ProcedureDesc}}</ui-select-match><ui-select-choices repeat="list in ProcedureList | propsFilter: {ProcedureCode: $select.search, ProcedureDesc: $select.search}" position="down" refresh="checkLoadProcedureList($select.search)" refresh-delay="500"><div ng-bind-html="list.ProcedureCode | highlight: $select.search"></div><small ng-show="list.ProcedureDesc">Desc: <span ng-bind-html="list.ProcedureDesc | highlight: $select.search"></span></small></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr mob-pr-0"><ui-select class="mult-select" ng-model="sSpeciality.Code" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Speciality Code" tooltip-placement="auto top"><ui-select-match placeholder="Choose a Specialty Code" allow-clear="true">{{$select.selected.SpecialityCode}}</ui-select-match><ui-select-choices repeat="list in SpecialityList | propsFilter: {SpecialityCode: $select.search, SpecialityCodeDesc : $select.search}" position="down"><div ng-bind-html="list.SpecialityCode | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-2 col-xs-6 pd-lr"><button type="submit" ng-click="refresh()" class="btn btn-primary rf-btn-xs mr-4px">Filter</button> <button ng-click="ClearFilter()" class="btn btn-default rf-btn-xs">Clear</button></div><div class="col-lg-6 col-md-3 col-sm-4 col-xs-6 pd-lr mob-pr-0"><button ng-click="MapProcedureSpeciality()" class="btn btn-primary rf-btn-xs pull-right">Map Procedure Specialty</button><div class="clearfix"></div></div></div></div><div class="common-tbl mapping-tbl-height"><table><thead><tr><th class="w-20 text-left">Procedure Code</th><th class="w-30 text-left">Procedure Desc</th><th class="w-25 text-left">Specialty Desc</th><th class="w-15 text-left">Specialty Code</th><th class="w-10 text-left">Action</th></tr></thead><tbody><tr ng-repeat="ps in ProcedureSpecialityList track by $index" ng-hide="isLoading"><td class="w-20 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{ps.ProcedureCode}}" tooltip-placement="auto right">{{ps.ProcedureCode}}</span></td><td class="w-30 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{ps.ProcedureDesc}}" tooltip-placement="auto right">{{ps.ProcedureDesc}}</span></td><td class="w-25 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{ps.SpecialityCode}}" tooltip-placement="auto right">{{ps.SpecialityCode}}</span></td><td class="w-15 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{ps.SpecialityCodeDesc}}" tooltip-placement="auto right">{{ps.SpecialityCodeDesc}}</span></td><td class="w-10 text-left p-0"><button ng-click="EditProcedureSpeciality(ps)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit Procedure" tooltip-placement="auto left" class="btn btn-default txt-clr-14 border-0 my-0 py-0"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="DeleteProcedureSpeciality(ps.MapId)" tooltip-class="uibtooltipDenial" uib-tooltip="Delete Procedure" tooltip-placement="auto left" class="btn btn-default txt-clr-14 border-0 my-0 py-0"><i class="fa fa-trash-o fs-18px"></i></button></td></tr></tbody></table></div><div class="common-footer newfoot mob-footer"><div class="w-70 float-left pl-8px mob-w-100"><select id="ddlPageSize" class="sing-select form-control mt-10px float-left downArrow-ie w-auto" ng-model="PageSize" ng-change="pageSizeChanged();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" boundary-links="true" total-items="TotalRows" max-size="5" items-per-page="PageSize" ng-model="PageNo" ng-change="PageNoChanged()" class="pagination float-left" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul><div class="clearfix"></div></div><div class="w-30 float-left text-right d-table h-50px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ ProcedureSpecialityList.length }} of {{TotalRows}}</span> Total Records</h5></div></div></div><div class="tab-pane active" id="CPTProcedureMapping" ng-if="currentTab.CPTProcedureMapping"><div id="CPTFilterPanel" class="pt-8px"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr"><ui-select class="mult-select" ng-model="cpmCPT.Code" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a CPT Code" tooltip-placement="auto top"><ui-select-match placeholder="Choose a CPT Code" allow-clear="true">{{$select.selected.CPT_Code}} - {{$select.selected.CPT_Description}}</ui-select-match><ui-select-choices repeat="list in CPTList | propsFilter: {CPT_Code: $select.search, CPT_Description: $select.search}" position="down" refresh="checkLoadCPTList($select.search)" refresh-delay="500"><div ng-bind-html="list.CPT_Code | highlight: $select.search"></div><small ng-if="list.CPT_Description">Desc: <span ng-bind-html="list.CPT_Description | highlight: $select.search"></span></small></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr mob-pr-0"><ui-select class="mult-select" ng-model="cpmProcedure.Code" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Procedure Code" tooltip-placement="auto top"><ui-select-match placeholder="Choose a Procedure Code" allow-clear="true">{{$select.selected.ProcedureCode}} {{$select.selected.ProcedureDesc}}</ui-select-match><ui-select-choices repeat="list in ProcedureList | propsFilter: {ProcedureCode: $select.search, ProcedureDesc: $select.search}" position="down" refresh="checkLoadProcedureList($select.search)" refresh-delay="500"><div ng-bind-html="list.ProcedureCode | highlight: $select.search"></div><small ng-show="list.ProcedureDesc">Desc: <span ng-bind-html="list.ProcedureDesc | highlight: $select.search"></span></small></ui-select-choices></ui-select></div><div class="col-lg-1 col-md-2 col-sm-3 col-xs-6 pd-lr"><ui-select skip-focusser="true" class="mult-select seltype-drop mob-closekeypad" ng-model="CPTMapStatus.Obj" title="Select Type" on-select="SelectCPTMapStatus()"><ui-select-match placeholder="Select Type" allow-clear="false">{{$select.selected.key}}</ui-select-match><ui-select-choices repeat="list in CPTMapStatusOptions" position="down"><div ng-bind-html="list.key"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr tultip-bottom"><site-location-grid master-locations="MasterData.Locations" selected-location="SelectedLocations" on-change=""></site-location-grid></div><div class="col-lg-1 col-md-3 col-sm-2 col-xs-6 pd-lr"><button type="submit" ng-click="bindCPTProcedureList()" class="btn btn-primary rf-btn-xs mr-4px" ng-disabled="disableProcCPTFilter">Filter</button> <button ng-click="ClearCPTProcedureFilter()" class="btn btn-default rf-btn-xs" ng-disabled="disableProcCPTFilter">Clear</button></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr"><span class="txt-clr-1 pull-right mt-5px">Empty Custom wRVU</span> <label class="checkbox-switch ml-10px mb-0 mt-5px pull-right" title="Empty Custom wRVU"><input type="checkbox" ng-model="ShowEmptyCustomwRVU.Obj" class="mr-2px" ng-change="bindCPTProcedureList()"> <span class="checkbox-switch-slider round"></span></label></div><div class="col-lg-2 d-flex justify-content-end col-md-3 col-sm-4 col-xs-6 pd-lr mob-pr-0 pull-right"><label class="my-0 w-120px py-4px mr-10px custfile"><input class="cursor-pointer w-100 invisible" type="file" id="fileInput" ng-model="inputfileModelDoc" name="fileInput" onchange="angular.element(this).scope().uploadFile(this)" ng-click="ResetFileInput()" accept=".csv"> <span class="pos-abs fs-13px py-7px abs-t-0"><i class="fa fa-cloud-upload fs-16px v-a-m"></i> Import CSV</span></label> <button ng-click="MapCPTProcedure()" class="btn btn-primary rf-btn-xs pull-right">Map Procedure and CPT</button></div></div></div><div id="cptAgGrid" class="ag-theme-balham-dark" ng-style="{\'height\' : halfScale ? \'calc(100vh - 200px)\' : \'calc(100vh - 160px)\'}" style="width: 100%;"></div></div><div class="tab-pane active" id="customwRVU" ng-if="currentTab.customwRVUTab"><div class="pt-8px"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr"><ui-select class="mult-select" ng-model="DataObject.SiteMultiSelectFilter.SelectedCPT" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a CPT Code" tooltip-placement="auto top"><ui-select-match placeholder="Choose a CPT Code" allow-clear="true">{{$select.selected.CPT_Code}}</ui-select-match><ui-select-choices repeat="list in DataObject.MappedCPTWRVUList | propsFilter: {CPT_Code: $select.search, CPT_Description: $select.search}" position="down" refresh="GetMappedCPTWRVUList($select.search)" refresh-delay="1500"><div ng-bind-html="list.CPT_Code | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr pos-rel tultip-bottom sitetooltip-elem"><multi-select master-data="DataObject.SiteMultiSelectFilter" list="DataObject.SiteList" ng-model="DataObject.SiteMultiSelectFilter.SelectedValue" on-change="DataObject.SiteMultiSelectFilter.onChange(selectedData)"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px" style="z-index:999;" ng-class="{\'multselect-haslist\': DataObject.SiteMultiSelectFilter.SelectedValue.list.length > 0}">{{DataObject.SiteMultiSelectFilter.tooltip}}</span></div><div class="col-lg-1 col-md-2 col-sm-2 col-xs-6 pd-lr"><button type="submit" ng-click="filterCustomwRVUList()" class="btn btn-primary rf-btn-xs mr-4px" ng-disabled="DataObject.isCustomwRVUGridLoading">Filter</button> <button ng-click="clearCustomwRVUList()" class="btn btn-default rf-btn-xs" ng-disabled="DataObject.isCustomwRVUGridLoading">Clear</button></div><div class="col-lg-4 d-flex custm-rvu col-md-4 col-sm-12 col-xs-12 pd-lr mob-pr-0 pull-right"><div class="pd-lr"><span class="txt-clr-1 pull-right mt-5px">Empty Custom wRVU</span> <label class="checkbox-switch ml-10px mb-0 mt-5px pull-right" title="Empty Custom wRVU"><input type="checkbox" ng-model="DataObject.SiteMultiSelectFilter.ShowEmptyCustomwRVU" class="mr-2px" ng-change="filterCustomwRVUList()"> <span class="checkbox-switch-slider round"></span></label></div><div class="d-flex align-item-center"><button ng-click="openShowAddCustomRVUModel(false)" class="btn btn-primary rf-btn-xs pull-right">Map Custom wRVU</button></div></div></div></div><div id="customwRVUGrid" class="ag-theme-balham-dark w-100 custom-wrvumap-grid" ng-class="{\'cust-wrvumap-site\': DataObject.SiteMultiSelectFilter.SelectedValue.list.length > 0}"></div></div><div class="tab-pane active" id="OrderingPhysician" ng-if="currentTab.OrderingPhysician"><ordering-physician ng-if="currentTab.OrderingPhysician"></ordering-physician></div></div></div></div></div></div><div class="modal fade" id="ModalMapProcedureSpeciality" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Map Procedure and Specialty</h4></div><div class="modal-body"><form name="formSite" id="formSite" class="py-10px"><div class="row mb-20px"><div class="col-md-9"><label class="rf-label">Procedure:</label><ui-select class="mult-select" name="modalSpecilityProcedure" ng-model="Modalmps.Procedure" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Procedure Code" tooltip-placement="auto top" ng-required="true"><ui-select-match placeholder="Choose a Procedure Code" allow-clear="true">{{$select.selected.ProcedureCode}} - {{$select.selected.ProcedureDesc}}</ui-select-match><ui-select-choices repeat="list in ProcedureList | propsFilter: {ProcedureCode: $select.search, ProcedureDesc: $select.search }" position="down" refresh="checkLoadProcedureList($select.search)" refresh-delay="500"><div ng-bind-html="list.ProcedureCode | highlight: $select.search"></div><small ng-show="list.ProcedureDesc">Desc: <span ng-bind-html="list.ProcedureDesc | highlight: $select.search"></span></small></ui-select-choices></ui-select></div></div><div class="row mb-20px"><div class="col-md-9"><label class="rf-label">Specialty:</label><ui-select class="mult-select" name="modalSpecilitySpeciality" ng-model="Modalmps.Speciality" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Specialty Code" tooltip-placement="auto top" ng-required="true"><ui-select-match placeholder="Choose a Specialty Code" allow-clear="true">{{$select.selected.SpecialityCode}}</ui-select-match><ui-select-choices repeat="list in SpecialityList | propsFilter: {SpecialityCode: $select.search, SpecialityCodeDesc: $select.search }" position="down"><div ng-bind-html="list.SpecialityCode | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-12"><button class="btn btn-default" data-dismiss="modal">Cancel</button> <button type="submit" ng-click="Save()" ng-disabled="formSite.$invalid" class="btn btn-primary mr-5px">Save</button></div></div></form></div></div></div></div></div><div class="modal fade" id="ModalMapCPTProcedure" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important" ng-if="currentTab.CPTProcedureMapping"><div class="modal-dialog w-70"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="closeModalMapCPTProcedure();">&times;</button><h4 class="modal-title">Map Procedure and CPT</h4></div><div class="modal-body" ng-if="loadProcCPTMap"><procedure-cpt-mapping on-map="bindCPTProcedureList();"></procedure-cpt-mapping></div></div></div></div></div><div class="modal fade" id="addCustomRVUMapping" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important" ng-if="currentTab.customwRVUTab"><div class="modal-dialog w-70"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="openShowAddCustomRVUModel(true)">&times;</button><h4 class="modal-title">Map Custom wRVU</h4></div><div class="modal-body"><map-custom-rvu div-id="addNewMapPopup" site-list="DataObject.SiteList" cpt-list="DataObject.MappedCPTWRVUList" save-data="SetSiteCPTWorkRVU(gridData)" ng-model="DataObject.SiteCPTCustomwRVUList"></map-custom-rvu></div></div></div></div></div><div ng-show="isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div>');
$templateCache.put('app/pages/settings/oncall/oncallschedule.html','<style>\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    .mult-select .ui-select-match span .text-muted {\r\n        padding-right: 5px !important;\r\n        display: block;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n</style><div class="" ng-init="Load()"><div class=""><div class=""><div class="" ng-show="ShowListView"><div class=""><div class="radf-header bb-1-s b-clr-8"><h2 class="w-50 float-left">{{ title }}</h2><div class="w-50 float-left text-right pt-4px"><button style="display:none!important;" type="button" class="btn filterbt mr-10px" ng-click="ShowHideFilter()"><span class="glyphicon glyphicon-filter fs-12px v-a-m"></span></button></div><div class="clearfix"></div></div></div><div class=""><div class=""><div class="pos-rel"><div id="divCMWList" class=""><div class="pt-8px"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><ui-select class="mult-select" ng-model="InstSearch.Obj" ng-change="SearchInstitutionsSelectChange(Search.Name)" tooltip-class="uibtooltipDenial" uib-tooltip="Select Institution" tooltip-placement="auto top"><ui-select-match class="" allow-clear="true" placeholder="Select Institution">{{$select.selected.Name}}</ui-select-match><ui-select-choices class="br-0" repeat="Institution in Institutions | filter: {Name: $select.search}"><div class="inst-selectBox" ng-bind-html="Institution.Name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr mob-pr-0"><ui-select class="mult-select" ng-model="Search.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Select Radiologist" tooltip-placement="auto top"><ui-select-match allow-clear="true" placeholder="Select Radiologist">{{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="list in Radiologists | filter: {FirstName: $select.search} | orderBy:\'FirstName\'"><div class="inst-selectBox" ng-bind-html="(list.FirstName) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><ui-select class="mult-select" ng-model="AltSearch.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Select Alternative Radiologist" tooltip-placement="auto top"><ui-select-match allow-clear="true" placeholder="Select Alternative Radiologist">{{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="list in Radiologists | filter: {FirstName: $select.search} | orderBy:\'FirstName\'"><div class="inst-selectBox" ng-bind-html="(list.FirstName) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-2 col-xs-3 pd-lr ocs-date-w"><div class="input-group blk-calender mb-0" tooltip-class="uibtooltipDenial" uib-tooltip="From Date" tooltip-placement="auto top"><input type="text" class="blk-input form-control col-placeholder" style="opacity:1!important;" uib-datepicker-popup="MM/dd/yyyy" ng-model="FromSearch.Obj" is-open="dosFDpopup.opened" readonly="" datepicker-options="dateSearchOptions" ng-required="true" close-text="Close" placeholder="From Date" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="dosFromDateOpen()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-lg-2 col-md-3 col-sm-2 col-xs-3 pd-lr ocs-date-w mob-pr-0"><div class="input-group blk-calender mb-0" tooltip-class="uibtooltipDenial" uib-tooltip="To Date" tooltip-placement="auto top"><input type="text" class="blk-input form-control col-placeholder" style="opacity:1!important;" uib-datepicker-popup="MM/dd/yyyy" ng-model="ToSearch.Obj" is-open="dosTDpopup.opened" readonly="" datepicker-options="dateSearchOptions" ng-required="true" close-text="Close" placeholder="To Date" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="dosToDateOpen()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-12 pd-lr mob-pr-0 rm-pull-right"><button type="button" class="btn btn-primary rf-btn-xs mr-4px" ng-click="SearchFilter()">Filter</button> <button type="button" class="btn btn-default rf-btn-xs mr-5px" ng-click="ClearFilter()">Clear</button> <button ng-click="export()" class="btn btn-primary rf-btn-xs pull-right" tooltip-class="uibtooltipDenial" uib-tooltip="Export" tooltip-placement="auto top"><i class="fa fa-share-square-o fs-15px" ng-hide="isExporting"></i> <i ng-show="isExporting" class="fa fa-spinner"></i></button> <button type="button" class="btn btn-primary rf-btn-xs mr-5px pull-right" ng-click="CreateOnCallSchedule()">Add</button></div></div></div><div class="common-tbl tbl-height-xs"><table><thead><tr><th class="w-20 text-left text-truncate"><a href="#" ng-click="orderByField=\'RADIOLOGISTNAME\'; reverseSort = !reverseSort; SortFilter();" class="txt-clr-16">Radiologist Name <span ng-show="orderByField == \'RADIOLOGISTNAME\' && reverseSort" class="fa fa-caret-down"></span> <span ng-show="orderByField == \'RADIOLOGISTNAME\' && !reverseSort" class="fa fa-caret-up"></span></a></th><th class="w-20 text-left text-truncate"><a href="#" ng-click="orderByField=\'ALTERNATIVERADIOLOGISTNAME\'; reverseSort = !reverseSort; SortFilter();" class="txt-clr-16">Alternative Radiologist Name <span ng-show="orderByField == \'ALTERNATIVERADIOLOGISTNAME\' && reverseSort" class="fa fa-caret-down"></span> <span ng-show="orderByField == \'ALTERNATIVERADIOLOGISTNAME\' && !reverseSort" class="fa fa-caret-up"></span></a></th><th class="w-15 text-left text-truncate"><a href="#" ng-click="orderByField=\'SCHEDULEDATE\'; reverseSort = !reverseSort; SortFilter();" class="txt-clr-16">Schedule Date <span ng-show="orderByField == \'SCHEDULEDATE\' && reverseSort" class="fa fa-caret-down"></span> <span ng-show="orderByField == \'SCHEDULEDATE\' && !reverseSort" class="fa fa-caret-up"></span></a></th><th class="w-10 text-left text-truncate"><a href="#" ng-click="orderByField=\'SCHEDULETIME\'; reverseSort = !reverseSort; SortFilter();" class="txt-clr-16">Schedule Time <span ng-show="orderByField == \'SCHEDULETIME\' && reverseSort" class="fa fa-caret-down"></span> <span ng-show="orderByField == \'SCHEDULETIME\' && !reverseSort" class="fa fa-caret-up"></span></a></th><th class="w-10 text-left text-truncate"><a href="#" ng-click="orderByField=\'SCHEDULEFLAG\'; reverseSort = !reverseSort; SortFilter();" class="txt-clr-16">Schedule Flag <span ng-show="orderByField == \'SCHEDULEFLAG\' && reverseSort" class="fa fa-caret-down"></span> <span ng-show="orderByField == \'SCHEDULEFLAG\' && !reverseSort" class="fa fa-caret-up"></span></a></th><th class="w-15 text-left text-truncate"><a href="#" ng-click="orderByField=\'INSTITUTION\'; reverseSort = !reverseSort; SortFilter();" class="txt-clr-16">Institution <span ng-show="orderByField == \'INSTITUTION\' && reverseSort" class="fa fa-caret-down"></span> <span ng-show="orderByField == \'INSTITUTION\' && !reverseSort" class="fa fa-caret-up"></span></a></th><th class="w-10 text-left">Action</th></tr></thead><tbody><tr ng-repeat="data in OnCallScheduleList" ng-class="{\'selected\':$index == selectedRow}" ng-click="setClickedRow($index)"><td class="w-20 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{data.Provider | titleCase}}" tooltip-placement="auto right">{{data.Provider | titleCase}}</span></td><td class="w-20 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{data.AlternateProvider | titleCase}}" tooltip-placement="auto right">{{data.AlternateProvider | titleCase}}</span></td><td class="w-15 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{data.FromDate | date: \'MM/dd/yyyy\'}} - {{data.ToDate | date: \'MM/dd/yyyy\'}}" tooltip-placement="auto right">{{data.FromDate | date: \'MM/dd/yyyy\'}} - {{data.ToDate | date: \'MM/dd/yyyy\'}}</span></td><td class="w-10 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{data.FromTime}} - {{data.ToTime}}" tooltip-placement="auto right">{{data.FromTime}} - {{data.ToTime}}</span></td><td class="w-10 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{data.ScheduleFlag}}" tooltip-placement="auto right">{{data.ScheduleFlag}}</span></td><td class="w-15 text-left"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{data.Institution | titleCase}}" tooltip-placement="auto right">{{data.Institution | titleCase}}</span></td><td class="w-10 text-left text-nowrap p-0"><button type="button" ng-click="EditOnCallSchedule(data)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit" tooltip-placement="auto left" class="btn btn-default txt-clr-14 border-0 my-0 py-0"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="DeleteOnCallSchedule(data)" tooltip-class="uibtooltipDenial" uib-tooltip="Delete" tooltip-placement="auto left" class="btn btn-default txt-clr-14 border-0 my-0 py-0"><i class="fa fa-trash-o fs-18px"></i></button></td></tr></tbody></table></div><div class="common-footer mob-footer"><div class="w-75 float-left pl-8px mob-w-100"><select id="ddlPageSize" class="sing-select form-control mt-10px float-left downArrow-ie w-auto" ng-model="PageSize" ng-change="changePageSize();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" total-items="TotalCount" items-per-page="PageSize" ng-model="CurrentPage" ng-change="pageChanged()" max-size="5" class="pagination float-left roundedpagin" boundary-link-numbers="true"></ul><div class="clearfix"></div></div><div class="w-25 float-left text-right d-table h-50px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ FilterCount }} of {{ TotalCount}}</span> Total Records</h5></div><div class="clearfix"></div></div></div></div></div></div></div><div class="" ng-hide="ShowListView"><div class=""><div class="radf-header"><h2 class="w-100">{{ title }}</h2><div class="clearfix"></div></div></div><div class="bg-clr-27"><form name="frmEdit" ng-submit="SaveOnCallSchedule(frmEdit.$valid)" role="form"><div class=""><div class="radf-subheader bb-1-s b-clr-8"><h3 class=""><span ng-show="Flag == \'ADD\'">Add</span> <span ng-show="Flag == \'EDIT\'">Edit</span>{{ title }}</h3></div><div class="p-15px-all txt-clr-1"><div class="row py-15px"><div class="col-md-3 col-sm-6"><div class=""><label for="Institution" class="rf-label">Institution *</label><ui-select class="mult-select" ng-model="SelectedInstitution.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Choose an Institution" tooltip-placement="auto top" ng-change="InstitutionsSelectChange(SelectedInstitution.Obj)" ng-required="true"><ui-select-match placeholder="Select an Institution" allow-clear="true">{{$select.selected.Name}}</ui-select-match><ui-select-choices repeat="list in Institutions | filter: {Name: $select.search}" position="down"><div ng-bind-html="list.Name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row py-15px"><div class="col-md-3 col-sm-6"><div class=""><label for="Radiologist" class="rf-label">Radiologist *</label><ui-select class="mult-select" ng-model="SelectedRadiologist.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Radiologist" tooltip-placement="auto top" ng-required="true" ng-change="RadiologistChange(SelectedRadiologist)"><ui-select-match placeholder="Select a Radiologist" allow-clear="true">{{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="list in UserList | filter: {FirstName: $select.search} | orderBy:\'FirstName\'" position="down"><div ng-bind-html="(list.FirstName) | highlight: $select.search"></div><div style="font-size:11px;"><span>Ph No: {{list.PhoneNumber}}</span>, <span>Email: {{list.Email}}</span></div></ui-select-choices></ui-select></div><div class="float-right mt-8px" ng-show="SelectedRadiologist.Obj && !(SelectedRadiologist.isEdit)"><button type="button" class="btn btn-primary rf-btn-xs" title="Send test text message." ng-click="SendTestNotification(\'TEXT\',SelectedRadiologist.Obj)"><i class="fa fa-comments"></i></button> <button type="button" class="btn btn-primary rf-btn-xs" title="Send test ivr call." ng-click="SendTestNotification(\'IVR\',SelectedRadiologist.Obj)"><i class="glyphicon glyphicon-earphone"></i></button> <button type="button" class="btn btn-primary rf-btn-xs" title="edit user" ng-click="EditUserInfo(SelectedRadiologist)"><i class="glyphicon glyphicon-pencil"></i></button></div><div ng-show="SelectedRadiologist.isEdit"><div class="mt-8px"><div class="fs-14px fw-500 mb-5px">Email *</div><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" ng-model="SelectedRadiologist.Email"></div></div></div><div class="mt-8px"><div class="fs-14px fw-500 mb-5px">Phone Number *</div><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" ng-model="SelectedRadiologist.PhoneNumber"></div></div></div><div class="mt-8px"><button type="button" class="btn btn-default" ng-click="RadiologistChange(SelectedRadiologist)">Cancel</button> <button type="button" class="btn btn-primary" ng-click="UpdateUserContact(SelectedRadiologist)">Save</button></div></div><label class="fs-14px fw-500 mb-5px" style="color: red;">{{SelectedRadiologist.msg}}</label></div><div class="col-md-3 col-sm-6"><div class=""><label for="Radiologist" class="rf-label">Alternative Radiologist *</label><ui-select class="mult-select" ng-model="SelectedRadiologistAlternative.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Choose Alternative Radiologist" tooltip-placement="auto top" ng-required="true" ng-change="RadiologistChange(SelectedRadiologistAlternative)"><ui-select-match placeholder="Select Alternative Radiologist" allow-clear="true">{{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="list in UserList | filter: {FirstName: $select.search} | orderBy:\'FirstName\'" position="down"><div ng-bind-html="(list.FirstName) | highlight: $select.search"></div><div style="font-size:11px;"><span>Ph No: {{list.PhoneNumber}}</span>, <span>Email: {{list.Email}}</span></div></ui-select-choices></ui-select></div><div class="float-right mt-8px" ng-show="SelectedRadiologistAlternative.Obj && !(SelectedRadiologistAlternative.isEdit)"><button type="button" class="btn btn-primary rf-btn-xs" title="Send test text message." ng-click="SendTestNotification(\'TEXT\',SelectedRadiologistAlternative.Obj)"><i class="fa fa-comments"></i></button> <button type="button" class="btn btn-primary rf-btn-xs" title="Send test ivr call." ng-click="SendTestNotification(\'IVR\',SelectedRadiologistAlternative.Obj)"><i class="glyphicon glyphicon-earphone"></i></button> <button type="button" class="btn btn-primary rf-btn-xs" title="edit user" ng-click="EditUserInfo(SelectedRadiologistAlternative)"><i class="glyphicon glyphicon-pencil"></i></button></div><div ng-show="SelectedRadiologistAlternative.isEdit"><div class="mt-8px"><label class="rf-label">Email *</label><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" ng-model="SelectedRadiologistAlternative.Email"></div></div></div><div class="mt-8px"><div class="fs-14px fw-500 mb-5px">Phone Number *</div><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" ng-model="SelectedRadiologistAlternative.PhoneNumber"></div></div></div><div class="mt-8px"><button type="button" class="btn btn-default" ng-click="RadiologistChange(SelectedRadiologistAlternative)">Cancel</button> <button type="button" class="btn btn-primary" ng-click="UpdateUserContact(SelectedRadiologistAlternative)">Save</button></div></div><label class="fs-14px fw-500 mb-5px" style="color: red;">{{SelectedRadiologistAlternative.msg}}</label></div></div><div class="row py-15px"><div class="col-md-3 col-sm-6"><label class="rf-label">From Date *</label><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="FromSearchEdit.Obj" is-open="dosFDpopup.opened" readonly="" datepicker-options="dateSearchOptions" ng-required="true" close-text="Close" placeholder="From Date" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="dosFromDateOpen()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-3 col-sm-6"><label class="rf-label">To Date *</label><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="ToSearchEdit.Obj" is-open="dosTDpopup.opened" readonly="" datepicker-options="dateSearchOptions" ng-required="true" close-text="Close" placeholder="To Date" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="dosToDateOpen()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row py-15px"><div class="col-md-12"><div class="form-controller d-flex align-item-center"><input type="checkbox" ng-model="ScheduleFlag" ng-checked="ScheduleFlag" id="onCallSdlFalg" class="m-0 cmn-checkbx-input"> <label for="onCallSdlFalg" class="rf-label cmn-check-label">Schedule Flag</label></div></div></div><div class="row py-15px"><div class="col-md-2 col-sm-3"><div class=""><label class="rf-label">From Time *</label><uib-timepicker class="rf-timepick" id="FromTime" name="FromTime" ng-model="FromTime" hour-step="hstep" minute-step="mstep" show-meridian="false"></uib-timepicker><div role="alert"><span style="color:red" class="error fs-14px fw-500" ng-show="frmEdit.FromTime.$error.required">Required!</span> <span style="color:red" class="error fs-14px fw-500" ng-show="frmEdit.FromTime.$error.time">Not a valid time!</span></div></div></div><div class="col-md-2 col-sm-3"><div class=""><label class="rf-label">To Time *</label><uib-timepicker class="rf-timepick" id="ToTime" name="ToTime" ng-model="ToTime" hour-step="hstep" minute-step="mstep" show-meridian="false"></uib-timepicker><div role="alert"><span style="color:red" class="error fs-14px fw-500" ng-show="frmEdit.ToTime.$error.required">Required!</span> <span style="color:red" class="error fs-14px fw-500" ng-show="frmEdit.ToTime.$error.time">Not a valid time!</span></div></div></div></div><div class="row" ng-show="FromSearchEdit.Obj > ToSearchEdit.Obj"><div class="col-md-12"><div class="form-group"><span class="fs-14px fw-500 mb-4px" ng-show="FromSearchEdit.Obj > ToSearchEdit.Obj" style="color:red">To-Date should be greater than From-Date</span></div></div></div><div class="row py-15px"><div class="col-md-12"><a class="btn btn-default rf-btn-xs" data-dismiss="modal" aria-label="Close" ng-click="Cancel()">Cancel</a> <button type="submit" ng-disabled="( !frmEdit.$valid || FromSearchEdit.Obj > ToSearchEdit.Obj)" class="btn btn-primary rf-btn-xs mr-5px">Save</button></div></div></div></div></form></div></div><div ng-show="isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div></div></div><style>\r\n    td.in-range {\r\n        background-color: #357ebd !important;\r\n        border-color: #3071a9 !important;\r\n        color: #fff;\r\n    }\r\n</style>');
$templateCache.put('app/pages/settings/paymentcontract/paymentcontract.html','<style>\r\n    .price-input {\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #a2a1a1;\r\n        color: #e4e4e4 !important;\r\n        display: block;\r\n        width: 100%;\r\n        height: 30px;\r\n        opacity: 1;\r\n        padding: 6px 12px;\r\n        font-size: 13px;\r\n        line-height: 1.42857143;\r\n        background-color: #fff;\r\n        background-image: none;\r\n        border: 1px solid #ccc;\r\n    }\r\n\r\n        .price-input:focus {\r\n            border-color: #fff !important;\r\n        }\r\n\r\n    .modal .modal-dialog .modal-body .form-control.blk-input.form-control.border-color-red,\r\n    .modal .modal-dialog .modal-body .form-control.blk-input.form-control.border-color-red:focus {\r\n        border-color: red !important;\r\n    }\r\n\r\n    .watermark {\r\n        opacity: 0.25;\r\n        color: #fff;\r\n        font-size: 1.5em;\r\n        width: 100%;\r\n        text-align: center;\r\n        z-index: 1000;\r\n    }\r\n\r\n    .rf-bs-modal .rf-timepick .glyphicon.glyphicon-chevron-up,\r\n    .rf-bs-modal .rf-timepick .glyphicon.glyphicon-chevron-down {\r\n        color: #05C1A4 !important;\r\n    }\r\n\r\n    .rf-bs-modal .uib-datepicker span.ng-binding.text-muted {\r\n        color: #636c72 !important;\r\n    }\r\n\r\n    .rf-bs-modal .uib-datepicker span.ng-binding.text-info {\r\n        color: #5bc0de !important;\r\n    }\r\n\r\n    .rf-bs-modal .blk-calender .uib-datepicker-popup .text-center {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .slct-cpt-ctrl .ui-select-match {\r\n        padding-right: 18px !important;\r\n    }\r\n\r\n    .clearall-cpt {\r\n        position: absolute;\r\n        bottom: 35%;\r\n        right: 12px;\r\n        color: #05c1a4;\r\n        font-size: 12px;\r\n        line-height: normal;\r\n        cursor: pointer;\r\n        display: none;\r\n    }\r\n\r\n        .clearall-cpt:hover {\r\n            color: #fff;\r\n        }\r\n\r\n    .ui-select-multiple.ng-not-empty-add + .clearall-cpt {\r\n        display: block;\r\n    }\r\n\r\n    .ui-select-multiple.ng-not-empty-add.ng-empty + .clearall-cpt {\r\n        display: none;\r\n    }\r\n\r\n    .loc-input.model-loc-input .k-multiselect-wrap.k-floatwrap {\r\n        max-height: 59px;\r\n        min-height: 31px;\r\n        height: 100% !important;\r\n    }\r\n\r\n    .modal.fade .modal-dialog.pay-contract {\r\n        top: -100px;\r\n    }\r\n\r\n    .location-tags-input .tultiptext {\r\n        max-height: 250px !important;\r\n        top: 55px !important;\r\n    }\r\n\r\n    .myGrid.paymtcontract-grid {\r\n        height: calc(100vh - 139px) !important;\r\n    }\r\n\r\n        .myGrid.paymtcontract-grid.paymtcontract-grid-height {\r\n            height: calc(100vh - 163px) !important;\r\n        }\r\n\r\n    .payment-modal-location .location-tags-input tags-input .tags .tag-list {\r\n        max-height: 80px !important\r\n    }\r\n\r\n    #ModalAddEditPaymentContract .payment-modal-rad .max-h-65px {\r\n        max-height: 150px;\r\n    }\r\n\r\n    #PaymentContractAddEditlocationTooltip {\r\n        top: auto !important;\r\n    }\r\n\r\n    #toast-container .toast.toast-error {\r\n        max-width: 480px;\r\n        width: auto;\r\n        background-position: 14px 26px;\r\n    }\r\n\r\n        #toast-container .toast.toast-error ul {\r\n            padding: 10px 0 0 20px;\r\n        }\r\n\r\n            #toast-container .toast.toast-error ul li {\r\n                margin-bottom: 10px;\r\n            }\r\n\r\n    @media screen and (max-width: 1199px) {\r\n        .rad-name {\r\n            width: 46%;\r\n        }\r\n\r\n        .max-h-65px.radlogist-wraaper {\r\n            max-height: 80px !important;\r\n        }\r\n    }\r\n</style><div id="mainDiv"><div style="color:aliceblue" id="headerDiv"><div class="radf-header"><h2>Payment Contract</h2></div><form><div class="px-10px pt-1 bg-clr-26"><ul class="nav nav-tabs no-bg"><li class="mob-flaot-none mob-text-center" ng-repeat="tabList in TabList" ng-class="{\'active\':tabList.Value==PaymentContractSelection}"><a ng-click="OnTabChanged(tabList.Value);" href="#{{tabList.Value}}" data-toggle="tab" ng-class="{\'disable-area\':tabList.Value==PaymentContractSelection}">{{tabList.Label}}</a></li></ul></div><div class="row mt-1 mx-0 p-2"><div class="col-md-2 col-xs-2 pl-0"><input type="text" class="blk-input form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="PaymentContractNameFilter" placeholder="Payment contract name"></div><div class="col-md-2 col-xs-2 pl-0 tultip-bottom"><site-location-grid master-locations="MasterData.Locations" selected-location="SelectedLocations.Filter" on-change="updateLocationFilterData()"></site-location-grid></div><div class="col-md-2 col-xs-2 pl-0 tultip-bottom"><button type="button" class="pos-abs no-bg border-0 rel-r-9-p abs-b-0 cursor-pointer p-5px-all fs-17px" ng-if="SelectedProvider.obj!=null && SelectedProvider.obj.length>0" tooltip-class="uibtooltipDenial" uib-tooltip="Clear Selected" tooltip-placement="auto left" style="z-index: 1;" ng-click="clearProviders();"><i class="fa fa-times"></i></button><ui-select class="mult-select p-3px-all" ng-model="SelectedProvider.obj" multiple="" close-on-select="false" reset-search-input="true" tooltip-class="uibtooltipDenial" uib-tooltip="{{RadiologistFilterTooltip}}" tooltip-placement="auto bottom" on-select="onRadiologistFilterSelect()" on-remove="onRadiologistFilterSelect()"><ui-select-match placeholder="Select Radiologists" allow-clear="true" class="overflow-y-auto d-block htSelRadio" style="max-height:25px;">{{$item.LastName + \', \' + $item.FirstName}}</ui-select-match><ui-select-choices repeat="provider in MultiSelectDropdown.RadiologistFilterPC.UserList | propsFilter: {LastName: $select.search, FirstName: $select.search, Email: $select.search, PhoneNumber: $select.search}" refresh="GetPaymentContractUsers($select.search)" refresh-delay="500" position="down"><div ng-bind-html="provider.LastName + \', \' + provider.FirstName | highlight: $select.search"></div><small><span ng-if="provider.Email.length>0"><i class="fa fa-envelope"></i> {{provider.Email}}<br></span> <span ng-if="provider.PhoneNumber.length>0"><i class="fa fa-phone-square"></i> {{provider.PhoneNumber}}</span></small></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><button class="btn btn-primary mx-1 rf-btn-xs" ng-click="FilterPaymentContractList()">Filter</button> <button class="btn btn-default mx-1 rf-btn-xs" ng-click="clearFilter()">Clear</button></div><div class="col-md-2 col-xs-2 pr-1 float-right d-flex justify-content-end"><button ng-click="AddEditPaymentContract()" class="btn btn-primary mx-1 rf-btn-xs">Add Payment Contract</button></div></div></form><div style="background-color:#262526!important;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="loading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div></div><div id="myGrid" class="myGrid paymtcontract-grid ag-theme-balham-dark w-100" ng-class="{\'paymtcontract-grid-height\': SelectedDataFilter.Location.length > 0 || SelectedProvider.obj.length > 0}"></div><div class="modal fade rf-bs-modal" id="ModalAddEditPaymentContract" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog pay-contract w-800px"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="clearData()">&times;</button><h4 class="modal-title">Payment Contract: {{PaymentContractSelection | camelCaseToSpace}}</h4></div><div class="modal-body"><form name="formPaymentContract" id="formPaymentContract"><div class="row"><div class="col-md-4 mt-10px" ng-if="PaymentContractSelection==\'HelperShift\'"><label class="rf-label">Payment Contract Helper Shift *</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="PaymentContractHelperShift.Obj" ng-required="true" ng-disabled="DisablePaymentContract" on-select="GetPaymentContractUsers()"><ui-select-match placeholder="Select Payment Contract Helper Shift" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in PaymentContractHelperTypes" position="down"><div ng-bind-html="list.Value"></div></ui-select-choices></ui-select></div><div class="col-md-4 mt-10px"><label class="rf-label">Payment Contract Name *</label> <input class="blk-input form-control" type="text" placeholder="Payment Contract Name" style="width:100%" ng-model="PaymentContractName" ng-required="true"></div><div class="col-md-3 mt-10px"><label class="rf-label">Price($) *</label> <input class="price-input mt-5px" type="text" placeholder="Price" id="Price" name="Price" ng-model="Price" ng-required="true" ng-pattern="/^\\d*\\.?(?:\\d{1,2})?$/" ng-class="{\'border-color-red\': (formPaymentContract.Price.$touched && formPaymentContract.Price.$invalid)}"></div></div><div class="row mt-20px" ng-if="PaymentContractSelection==\'PayPerProcedure\' || PaymentContractHelperShift.Obj.Key==\'PayPerProcedure\'"><div class="col-md-4 mb-10px"><label class="rf-label">Modality *</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="SelectedModality.Obj" tooltip-class="uibtooltipDenial" uib-tooltip="Choose Modality" tooltip-placement="auto top" ng-required="true"><ui-select-match placeholder="Select Modality" allow-clear="true" class="overflow-y-auto d-block overflow-x-hide h-auto max-h-50px">{{$select.selected.Code}}</ui-select-match><ui-select-choices repeat="list in Modalities | filter: {Code: $select.search}" position="down"><div ng-bind-html="(list.Code) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-4 mb-10px"><div ng-hide="isCPTVisible"><input type="button" ng-click="isCPTVisible =!isCPTVisible" class="btn btn-primary mt-18px mr-5px" value="{{CPTHideShow}}"></div><div ng-show="isCPTVisible" class="tultip-bottom atbtm"><span class="tultiptext text-preline max-h-200px overflow-auto text-left tt-white sl-hsw-180px">{{CptCodeTooltip}}</span> <label class="rf-label">Select CPT</label><ui-select class="mult-select ui-select-multiple ui-select-bootstrap sel-site ss-choices-ht slct-cpt-ctrl" multiple="" ng-model="SelectedCPT.Obj" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" tooltip-class="uibtooltipDenial" tooltip-placement="auto top" close-on-select="false" theme="bootstrap" on-select="onCptSelect()" on-remove="onCptSelect()"><ui-select-match placeholder="Select a CPT" class="overflow-y-auto d-block max-h-75px">{{$item.CPT_Code}}</ui-select-match><ui-select-choices repeat="list in CPTList| propsFilter: {CPT_Code: $select.search, CPT_Description: $select.search}" position="down" refresh="GetCPTList($select.search)" refresh-delay="500"><div ng-bind-html="list.CPT_Code| highlight: $select.search"></div><small ng-if="list.CPT_Description">Desc: <span ng-bind-html="list.CPT_Description | highlight: $select.search"></span></small></ui-select-choices></ui-select><a class="clearall-cpt" ng-click="clearAllCPT()" title="clear all"><i class="glyphicon glyphicon-remove" aria-hidden="true"></i></a></div></div></div><div ng-if="PaymentContractSelection==\'PayPerShift\'"><div class="row py-15px"><div class="col-md-4 col-sm-6"><label class="rf-label">From Date *</label><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="FromDate" is-open="dosFromDatePopup.opened" readonly="" datepicker-options="dateSearchOptions" ng-required="true" close-text="Close" placeholder="From Date" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="dosFromDateOpen()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-4 col-sm-6"><label class="rf-label">To Date *</label><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="ToDate" is-open="dosToDatePopup.opened" readonly="" datepicker-options="dateSearchOptions" ng-required="PaymentContractSelection==\'PayPerShift\'" close-text="Close" placeholder="To Date" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="dosToDateOpen()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row py-15px"><div class="col-md-4 col-sm-6"><div class=""><label class="rf-label">From Time *</label><uib-timepicker class="rf-timepick" id="FromTime" name="FromTime" ng-model="FromTime" hour-step="hourStep" minute-step="minuteStep" show-meridian="false"></uib-timepicker><div role="alert"><span style="color: red !important;" class="error fs-14px fw-500" ng-show="formPaymentContract.FromTime.$error.required">Required!</span> <span style="color: red !important;" class="error fs-14px fw-500" ng-show="formPaymentContract.FromTime.$error.time">Not a valid time!</span></div></div></div><div class="col-md-3 col-sm-3"><div class=""><label class="rf-label">To Time *</label><uib-timepicker class="rf-timepick" id="ToTime" name="ToTime" ng-model="ToTime" hour-step="hourStep" minute-step="minuteStep" show-meridian="false"></uib-timepicker><div role="alert"><span style="color: red !important;" class="error fs-14px fw-500" ng-show="formPaymentContract.ToTime.$error.required">Required!</span> <span style="color: red !important;" class="error fs-14px fw-500" ng-show="formPaymentContract.ToTime.$error.time">Not a valid time!</span></div></div></div></div><div class="row py-15px"><div class="col-md-12"><div class="form-controller d-flex align-item-center"><input type="checkbox" ng-model="DoNotRepeat" ng-checked="DoNotRepeat" id="onDoNotRepeatFlag" class="m-0 cmn-checkbx-input"> <label for="onDoNotRepeatFlag" class="rf-label cmn-check-label">Do not repeat</label></div></div></div><div class="row" ng-show="FromDate > ToDate"><div class="col-md-12"><div class="form-group"><span class="fs-14px fw-500 mb-4px" ng-show="FromDate > ToDate" style="color: red !important;">To-Date should be greater than From-Date</span></div></div></div></div><div class="row"><div class="col-md-3 mt-10px"><label class="rf-label">Payment Account *</label><ui-select class="mult-select seltype-drop mob-closekeypad" ng-model="DataObject.SelectedPaymentContractDetail.PaymentAccountType"><ui-select-match placeholder="Select Payment Account" allow-clear="true">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="list in DataObject.PaymentAccountTypes" position="down"><div ng-bind-html="list.Value"></div></ui-select-choices></ui-select><input type="hidden" name="paymentaccount" ng-model="DataObject.SelectedPaymentContractDetail.PaymentAccountType.Value" required=""></div></div><div class="row"><div class="col-md-12 mt-10px col-sm-12"><label class="rf-label">Locations</label><div class="col-md-12 px-0 payment-modal-location tultip-bottom"><site-location-grid master-locations="MasterData.Locations" selected-location="SelectedLocations.AddEdit" on-change="updateLocationData()"></site-location-grid></div></div></div><div class="col-md-12 col-sm-12 py-3 px-0 payment-modal-rad"><label class="rf-label" ng-if="SelectedValues.SelectedRadiologists.length>0">Radiologist</label><cmpassignradiologists assigned-radiologist="SelectedValues.SelectedRadiologists" view-mode="false" flag="true" ng-if="SelectedValues.SelectedRadiologists.length>0"></cmpassignradiologists></div><div class="row mt-20px clearfix"><div class="col-md-7 col-sm-7"><input type="button" ng-click="showAssignRadiologistCmp.value=true;AddUsers();" class="btn btn-primary" value="{{AssignUserText}}" ng-disabled="DataObject.disableAddUserBtn"> <span class="txt-clr-5 pl-10px fw-600 mt-10px fs-12px" ng-show="SelectedValues.SelectedRadiologists.length==0" style="color: red !important;">Radiologist is required</span></div><div class="col-md-5 col-sm-5"><button type="submit" ng-click="SaveOrEdit()" ng-disabled="(formPaymentContract.Price.$touched && formPaymentContract.Price.$invalid) || formPaymentContract.$invalid || SelectedValues.SelectedRadiologists.length==0 || FromDate>ToDate || DataObject.isSaveEditBtnDisable" class="btn btn-primary float-right mr-5px">Save</button> <button type="button" ng-click="clearData()" data-dismiss="modal" class="btn btn-default float-right mr-5px">Cancel</button></div></div></form></div></div></div></div><div ng-show="isLoading" class="spinner-overlay" style="z-index: 80;"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><div class="modal fade" id="RadiologistComponentPaymentContract" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog assign-user-modal" ng-if="showAssignRadiologistCmp.value"><div class="modal-content"><assign-radiologist-grid radiologists="MasterData.Radiologists" selected-values="SelectedValues" modal-title="Add Radiologists" btn-text="SavebtnText" on-select-radiologist="SaveAddUsers()" on-cancel="AssignUserCancel()" payment-contract="PaymentContractSelection" payment-sub-contract="(PaymentContractHelperShift.Obj && PaymentContractHelperShift.Obj.Key) ? PaymentContractHelperShift.Obj.Key : null" radio-logist-cmp-tooltip-id="radioLogistPaymentContractCmp" show-assign-radiologist-cmp="showAssignRadiologistCmp"></assign-radiologist-grid></div></div></div></div>');
$templateCache.put('app/pages/settings/rule/rule.html','<style>\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    td.in-range {\r\n        background-color: #357ebd !important;\r\n        border-color: #3071a9 !important;\r\n        color: #fff;\r\n    }\r\n\r\n    .modal-dialog {\r\n        left: 0px !important;\r\n    }\r\n\r\n    .tippy-content {\r\n        border: 0 !important;\r\n    }\r\n\r\n    .common-tbl.rule-tbl {\r\n        height: calc(100vh - 180px);\r\n    }\r\n\r\n    .common-tbl.rule-tbl.hasradiolog {\r\n        height: calc(100vh - 203px);\r\n    }\r\n\r\n    .rule-table-enhs .common-tbl tr td:first-child {\r\n        text-overflow: unset;\r\n    }\r\n\r\n    .ruletable-cdns1 .common-tbl td {\r\n        border-color: #444444 !important;\r\n    }\r\n\r\n        .ruletable-cdns1 .common-tbl th.w-10:nth-child(2),\r\n        .ruletable-cdns1 .common-tbl td.w-10:nth-child(2) {\r\n            width: 7% !important;\r\n        }\r\n\r\n        .ruletable-cdns1 .common-tbl th.w-10:not(:nth-child(2)),\r\n        .ruletable-cdns1 .common-tbl td.w-10:not(:nth-child(2)) {\r\n            width: 14% !important;\r\n        }\r\n\r\n        .ruletable-cdns1 .common-tbl th.w-10:nth-child(4),\r\n        .ruletable-cdns1 .common-tbl td.w-10:nth-child(4) {\r\n            width: 10% !important;\r\n        }\r\n\r\n        .ruletable-cdns1 .common-tbl td.w-70 .row .p-3px-all {\r\n            width: 33%;\r\n            /*width: max-content;*/\r\n        }\r\n\r\n    .ruletable-cdns2 .rad-name {\r\n        width: 18%;\r\n    }\r\n\r\n    .ruletable-cdns2 table .radlogist-wraaper {\r\n        min-height: unset;\r\n        max-height: unset;\r\n    }\r\n\r\n    .ruletable-cdns2 table .radiologist-tbody {\r\n        padding: 10px 0;\r\n        max-height: 444px;\r\n    }\r\n\r\n    .ruletable-cdns1 .common-tbl th,\r\n    .common-tbl .ruletable-cdns1 th,\r\n    .ruletable-cdns2 table th {\r\n        background: #116A5C !important;\r\n        color: #fff !important;\r\n        border-color: #116a5c;\r\n    }\r\n\r\n    .ruletable-cdns1 .common-tbl thead,\r\n    .ruletable-cdns2.common-tbl thead {\r\n        border-bottom: 0;\r\n    }\r\n\r\n    .ruletable-cdns2.common-tbl table {\r\n        border: 1px solid #444444;\r\n        border-collapse: unset;\r\n    }\r\n\r\n    .ruletable-cdns1 .grouped-tbl {\r\n        border: 1px solid transparent;\r\n        /*border-collapse: unset;*/\r\n    }\r\n    /*.ruletable-cdns1 .group-odd .grouped-tbl {\r\n        border-bottom: 1px solid #444 !important;\r\n    }*/\r\n    /*.ruletable-cdns1 .group-odd .grouped-tbl tr td:last-child{\r\n        border-right: 0 !important;\r\n    }*/\r\n    .ruletable-cdns1 .ungroup-block {\r\n        border: 1px solid #444444;\r\n        /*border-collapse: unset;*/\r\n    }\r\n\r\n    .ruletable-cdns1 .grouped-tbl:first-child {\r\n        border-bottom: 0 !important;\r\n    }\r\n\r\n    .ruletable-cdns1 .common-tbl .ungroup-block {\r\n        border-top: 0;\r\n        border-right: 0;\r\n        width: 43px !important;\r\n    }\r\n\r\n    .ruletable-cdns1 .ungroup-block + .grouped-tbl {\r\n        border-top: 0;\r\n        border-left: 0\r\n    }\r\n\r\n    .ruletable-cdns1 .rulecondin-wrappwer.max-h-200px.b-clr-1 {\r\n        max-height: unset !important;\r\n        border-color: transparent !important;\r\n        overflow: hidden !important\r\n    }\r\n\r\n    .ruletable-cdns1 .rulecondin-wrappwer tbody.setheightrule {\r\n        max-height: 600px !important;\r\n        overflow-y: auto;\r\n        border-bottom: 1px solid #444;\r\n    }\r\n\r\n    .ruletable-cdns1 .common-tbl td,\r\n    .ruletable-cdns2 table td,\r\n    .ruletable-cdns1 .ungroup-block {\r\n        background: #202020;\r\n    }\r\n\r\n    .ruletable-cdns1 .mlp-value-box .fa-caret-right + span {\r\n        word-break: break-word;\r\n    }\r\n\r\n    .cmntbody-ltcontnet tr.active-row {\r\n        background-color: #25A38F !important;\r\n        /*transform: scale(1.002);*/\r\n    }\r\n\r\n    .cmntbody-ltcontnet tr .glyphicon {\r\n        color: #b4b4b4;\r\n    }\r\n    .cmntbody-ltcontnet tr.active-row .glyphicon-eye-open, \r\n    .cmntbody-ltcontnet tr.active-row .fa-trash-o,    \r\n    .cmntbody-ltcontnet tr.active-row .glyphicon-pencil {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .cmntbody-ltcontnet tr.active-row td {\r\n        border-color: transparent !important;\r\n    }\r\n\r\n    .rule-table-enhs .common-footer {\r\n        /*width: 58.5%;*/\r\n    }\r\n\r\n    .ruletable-cdns-wraaper {\r\n        padding: 30px 20px 20px 20px;\r\n        /*height: calc(100vh - 132px);*/\r\n        height: calc(100vh - 181px);\r\n        background-color: #202020;\r\n        border: 1px solid #474747;\r\n        border-left-width: 2px;\r\n        border-left-color: #828282;\r\n        overflow-y: auto;\r\n        height: calc(100vh - 187px);\r\n        /*height: calc(100vh - 172px);*/\r\n        border-bottom: 0;\r\n        box-shadow: -5px 0px 20px 0px rgba(0,0,0,0.5);\r\n    }\r\n    .uiview-element .ruletable-cdns-wraaper {\r\n        height: calc(100vh - 172px);\r\n    }\r\n    .ruletable-cdns-wraaper.hasradiolog {\r\n        height: calc(100vh - 214px);\r\n    }\r\n    .rule-table-enhs {\r\n        /*width: 100%;*/\r\n        flex: 1;\r\n    }\r\n\r\n    .rule-view-enhs {\r\n        width: 58%;\r\n    }\r\n\r\n    .btn.btn-default:hover .glyphicon {\r\n        color: #fff !important;\r\n    }\r\n    .halfscle-ruletabl\r\n    {\r\n        display:flex;\r\n    }\r\n    .close-viewrule {\r\n        height: 18px;\r\n        width: 18px;\r\n        padding: 0 !important;\r\n        border: 0 !important;\r\n        cursor: pointer;\r\n        color: #fff !important;\r\n        background-color: transparent !important;\r\n        font-size: 14px;\r\n        text-align: center;\r\n    }\r\n   .close-viewrule .glyphicon {\r\n            top: 0;\r\n        }\r\n    .rulename-header {\r\n        position: absolute;\r\n        top: 0;\r\n        z-index: 1;\r\n        left: 1px;\r\n        right: 2px;\r\n        background-color: #313131;\r\n        padding: 6px;\r\n        border-left: 1px solid #828282;\r\n    }\r\n\r\n    .detail-color {\r\n        border: none;\r\n        background-color: transparent;\r\n        width: 30px;\r\n        height: 25px;\r\n        outline: none;\r\n    }\r\n\r\n    #color-picker::-webkit-color-swatch {\r\n        border-radius: 4px;\r\n    }\r\n\r\n    @media only screen and (min-width:767px) and (max-width:1199px) {\r\n        .halfscle-ruletabl .rule-table-enhs {\r\n            width: 100%;\r\n            flex: unset;\r\n            height: calc(100vh - 65vh);\r\n            overflow-y: auto;\r\n        }\r\n        .halfscle-ruletabl .rule-view-enhs {\r\n            width: 100%;\r\n            border-top: 2px solid #7f7f7f;\r\n        }\r\n        .common-tbl.rule-tbl-enhance tbody.cmntbody-ltcontnet {\r\n            /*width: 600px;*/\r\n        }\r\n\r\n        .rule-table-enhs .common-footer {\r\n            width: 100%;\r\n        }\r\n\r\n        .ruletable-cdns-wraaper {\r\n            height: calc(100vh - 54vh);\r\n            border-top-width: 2px;\r\n            border-top-color: #828282;\r\n            border-left-width: 1px;\r\n            border-left-color: transparent;\r\n        }\r\n        .ruletable-cdns-wraaper.hasradiolog {\r\n            height: calc(100vh - 543px);\r\n        }\r\n        .rulename-header {\r\n            border-left:0;\r\n        }\r\n        .halfscle-ruletabl {\r\n            flex-wrap: wrap;\r\n        }               \r\n        .ruletable-cdns2 .rad-name {\r\n            width: 30%;\r\n        }\r\n        .ruletable-cdns1 .rulecondin-wrappwer tbody.setheightrule {\r\n            max-height: 300px !important;\r\n        }\r\n        .ruletable-cdns2 table .radiologist-tbody {\r\n            max-height: 104px;\r\n        }\r\n        .halfscle-ruletabl .common-tbl.rule-tbl.rule-tbl-enhance {\r\n            height: 100%;\r\n        }\r\n    }\r\n    @media (min-width: 768px) and (min-height: 1080px) and (orientation: portrait) {\r\n        .ruletable-cdns1 .rulecondin-wrappwer tbody.setheightrule {\r\n            max-height: 750px !important;\r\n        }\r\n        .ruletable-cdns-wraaper {\r\n            height: calc(100vh - 810px);\r\n        }\r\n        .ruletable-cdns-wraaper.hasradiolog {\r\n            height: calc(100vh - 835px);\r\n        }\r\n        .ruletable-cdns-wraaper.hasradiolog .ruletable-cdns1 .rulecondin-wrappwer tbody.setheightrule {\r\n            max-height: 730px !important;\r\n        }\r\n    }\r\n</style><div ng-init="Init()"><div class="" ng-show="ShowListView"><div class=""><div class="radf-header"><h2 class="w-50 float-left">{{ title }}</h2><div class="w-50 float-left text-right pt-3px pr-15px"></div><div class="clearfix"></div></div><div class="clearfix"></div></div><div class=""><div class=""><div class="pos-rel h-86vh"><div id="divCMWList" class=""><div class="pt-8px" ng-show="ShowFilter"><form name="OrderListFilter"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pl-0" tooltip-class="uibtooltipDenial" uib-tooltip="Rule Name" tooltip-placement="auto top"><input type="text" ng-model="Filter.RuleName" id="input01" placeholder="Rule Name" class="blk-input form-control"></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr mob-pr-0" ng-if="currentTab.TATRules" tooltip-class="uibtooltipDenial" uib-tooltip="Tenant" tooltip-placement="auto top"><ui-select skip-focusser="true" id="ddlTenantFilter" class="mult-select mob-closekeypad" ng-model="selectedTenant.Obj" on-select="changeTenantFilter()"><ui-select-match allow-clear="false" placeholder="Select Tenant">{{$select.selected.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantList | filter: {DisplayName: $select.search}" position="down"><div ng-bind-html="tenant.DisplayName | highlight: $select.search"></div></ui-select-choices></ui-select><div class="clearfix"></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr mob-pr-0 pos-rel" ng-if="!currentTab.TATRules"><button type="button" class="pos-abs no-bg border-0 rel-r-9-p abs-b-0 cursor-pointer p-5px-all fs-17px" ng-if="Filter.Provider.length > 0" tooltip-class="uibtooltipDenial" uib-tooltip="Clear Selected" tooltip-placement="auto left" style="z-index: 1;" ng-click="clearProvider()"><i class="fa fa-times"></i></button><multi-select master-data="DataObject.UserFilterMultiSelect" list="FilterRadiologists" ng-model="DataObject.UserFilterMultiSelect.SelectedValue" on-change="DataObject.UserFilterMultiSelect.onSelectUser(selectedData)" place-holder="Select Radiologists" tooltip-class="uibtooltipDenial" uib-tooltip="Select Radiologists"></multi-select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr" tooltip-class="uibtooltipDenial" uib-tooltip="Set Priority" tooltip-placement="auto top"><ui-select skip-focusser="true" id="ddlIsHighPriority" class="mult-select mob-closekeypad" ng-model="selectedPriority.Obj" on-select="changePriorityFilter()"><ui-select-match allow-clear="false">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="list in PriorityList" position="down"><div ng-bind-html="list.value"></div></ui-select-choices></ui-select><div class="clearfix"></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr mob-pr-0" tooltip-class="uibtooltipDenial" uib-tooltip="Status" tooltip-placement="auto top"><ui-select skip-focusser="true" id="ddlIsHighPriority" class="mult-select mob-closekeypad" ng-model="selectedStatus.Obj" on-select="changeStatusFilter()"><ui-select-match allow-clear="false">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="list in StatusList" position="down"><div ng-bind-html="list.value"></div></ui-select-choices></ui-select><div class="clearfix"></div></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><button type="submit" ng-click="GetRuleList()" class="btn btn-primary rf-btn-xs mr-4px">Filter</button> <button ng-click="clearFilterAndRefesh()" class="btn btn-default rf-btn-xs">Clear</button></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr mob-pr-0 text-right" id="ruleOptionMenuDiv"><button type="button" class="btn btn-primary rf-btn-xs" id="addRuleBtn">Add {{ title }}</button></div><div class="clearfix"></div></div></form></div><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="DataObject.isFilterLoading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div><div id="mappingNav" class="px-10px bg-clr-26"><ul class="nav nav-tabs no-bg"><li class="active mob-flaot-none mob-text-center" ng-click="changeTab(\'Worklists\')" ng-class="{\'disable-area\':currentTab.Worklists}"><a href="#Worklists" data-toggle="tab">Worklists</a></li><li class="mob-flaot-none mob-text-center" ng-click="changeTab(\'TATRules\')" ng-class="{\'disable-area\':currentTab.TATRules}"><a href="#TATRules" data-toggle="tab">TAT Rules</a></li><li ng-click="changeTab(\'Rules\')" class="mob-flaot-none mob-text-center" ng-class="{\'disable-area\':currentTab.Rules}"><a href="#Rules" data-toggle="tab">Rules</a></li></ul></div></div><div class="" ng-class="{\'halfscle-ruletabl\':DataObject.isRuleDetailsVisible}"><div class="rule-table-enhs pr-0"><div class="common-tbl rule-tbl rule-tbl-enhance tbl-height-xs" ng-class="{\'hasradiolog\': Filter.Provider.length > 0}"><table class="pos-relno"><thead style="z-index: 7 !important;"><tr><th class="w-18"><a href="#" ng-click="SortFilter(\'RULENAME\');" class="txt-clr-16">Rule Name <span ng-show="Filter.OrderByField == \'RULENAME\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="Filter.OrderByField == \'RULENAME\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th class="w-20"><a href="#" ng-click="SortFilter(\'DESCRIPTION\');" class="txt-clr-16">Description <span ng-show="Filter.OrderByField == \'DESCRIPTION\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="Filter.OrderByField == \'DESCRIPTION\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th class="w-10"><a href="#" ng-click="SortFilter(\'PRIORITY\');" class="txt-clr-16">Priority <span ng-show="Filter.OrderByField == \'PRIORITY\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="Filter.OrderByField == \'PRIORITY\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th class="w-10"><a href="#" ng-click="SortFilter(\'STATUS\');" class="txt-clr-16">Status <span ng-show="Filter.OrderByField == \'STATUS\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="Filter.OrderByField == \'STATUS\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th class="w-15" ng-if="currentTab.TATRules"><a class="txt-clr-16">Tenant</a></th><th class="w-15" ng-if="!currentTab.TATRules"><a href="#" ng-click="SortFilter(\'WORKLISTNAME\');" class="txt-clr-16">Filter Name <span ng-show="Filter.OrderByField == \'WORKLISTNAME\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="Filter.OrderByField == \'WORKLISTNAME\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th class="w-10 text-left"><a class="txt-clr-16">Action</a></th></tr></thead><tbody class="cmntbody-ltcontnet"><tr ng-repeat="objRule in RulesList" ng-class="{\'active-row\':DataObject.activeRow === objRule.RuleID}"><td class="w-18"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{objRule.RuleName}}" tooltip-placement="auto right">{{objRule.RuleName}}</span></td><td class="w-20"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{objRule.RuleDescription}}" tooltip-placement="auto right">{{objRule.RuleDescription}}</span></td><td class="w-10"><span ng-show="objRule.IsHighpriority" tooltip-class="uibtooltipDenial" uib-tooltip="High Priority" tooltip-placement="auto right">High Priority</span></td><td class="w-10"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{objRule.IsEnabled ? \'Enabled\' : \'Disabled\'}}" tooltip-placement="auto right">{{objRule.IsEnabled ? \'Enabled\' : \'Disabled\'}}</span></td><td class="w-15" ng-if="currentTab.TATRules"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{tenantName(objRule.TenantID)}}" tooltip-placement="auto right">{{tenantName(objRule.TenantID)}}</span></td><td class="w-15" ng-if="!currentTab.TATRules"><span tooltip-class="uibtooltipDenial" uib-tooltip="{{objRule.WorkListName}}" tooltip-placement="auto right">{{objRule.WorkListName}}</span></td><td class="w-10 text-left t-overflow-initial p-0"><button type="button" ng-click="OpenRule(objRule)" tooltip-class="uibtooltipDenial" uib-tooltip="Edit Rule" tooltip-placement="auto left" class="btn btn-default txt-clr-14 px-1 border-0 mx-1 my-0 py-0"><span class="glyphicon glyphicon-pencil txt-clr-14"></span></button> <button type="button" ng-disabled="(UserRoles.includes(\'Admin\') || UserRoles.includes(\'SuperAdmin\')) && (objRule.WorklistType == 21 || objRule.WorklistType == 11)" ng-click="DeleteRule(objRule)" tooltip-class="uibtooltipDenial" uib-tooltip="Delete Rule" tooltip-placement="auto left" class="btn btn-default txt-clr-14 border-0 px-1 mx-1 my-0 py-0"><i class="fa fa-trash-o fs-18px"></i></button> <button ng-click="GetRuleDetails(objRule,\'VIEW\')" class="btn btn-default txt-clr-14 border-0 px-1 mx-1 my-0 py-0" tooltip-class="uibtooltipDenial" uib-tooltip="View Rule" tooltip-placement="auto left"><span class="glyphicon glyphicon-eye-open txt-clr-14"></span></button></td></tr></tbody></table></div><div class="common-footer mob-footer"><div class="w-75 float-left pl-8px mob-w-100"><select id="ddlPageSize" class="sing-select form-control mt-10px float-left downArrow-ie w-auto" ng-model="Filter.PageSize" ng-change="changePageSize();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" total-items="TotalCount" items-per-page="Filter.PageSize" ng-model="Filter.PageNum" ng-change="pageChanged()" max-size="10" class="pagination float-left roundedpagin" boundary-link-numbers="true"></ul><div class="clearfix"></div></div><div class="w-25 float-left text-right d-table h-50px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ FilterCount }} of {{ TotalCount}}</span> Total Records</h5></div><div class="clearfix"></div></div></div><div class="rule-view-enhs pos-rel" ng-show="DataObject.isRuleDetailsVisible"><div class="d-flex justify-content-between rulename-header"><span class="txt-clr-1 fw-600">{{DataObject.RuleDetail.RuleName}}</span> <button class="btn close-viewrule" title="close" ng-click="DataObject.isRuleDetailsVisible = false; DataObject.activeRow = null;"><span class="glyphicon glyphicon-remove"></span></button></div><div class="ruletable-cdns-wraaper pos-rel" ng-class="{\'hasradiolog\': Filter.Provider.length > 0}"><div class="ruletable-cdns1"><comprulecondition rule="DataObject.RuleDetail" view-mode="true"></comprulecondition></div><div class="d-flex align-item-center mt-10px ml-5px" ng-if="currentTab.TATRules"><label class="txt-clr-1 mb-0 pr-20px">Tenant: {{tenantName(DataObject.RuleDetail.TenantID)}}</label> <label class="txt-clr-1 mb-0">TAT Value: {{DataObject.RuleDetail.TATValue}} {{DataObject.RuleDetail.TATType}}</label> <label class="pl-20px mb-0 txt-clr-1">SLA Breach Time: {{DataObject.RuleDetail.SLABreachValue}} {{DataObject.RuleDetail.SLABreachType}}</label> <label class="pl-20px mb-0 txt-clr-1" ng-if="DataObject.RuleDetail.RuleColorCode">SLA Breach Color:</label> <input type="color" id="color-picker" class="detail-color" value="" ng-disabled="true" ng-model="DataObject.RuleDetail.RuleColorCode" ng-if="DataObject.RuleDetail.RuleColorCode"></div><div class="d-flex align-item-center my-10px ml-5px" ng-if="currentTab.Worklists && DataObject.RuleDetail.IsSmartWorklist"><label class="txt-clr-1 mb-0">Page Size: {{DataObject.RuleDetail.WorklistPageSize}}</label> <label class="txt-clr-1 ml-20px mb-0">Smart Worklist: Enabled</label></div><div class="ruletable-cdns2 common-tbl height-auto" ng-if="!currentTab.TATRules"><table class="w-100 txt-clr-1"><thead class="border-top-0" style="z-index: 0;"><tr class=""><th class="text-left">Radiologists</th></tr></thead><tbody class="radiologist-tbody"><tr><td class="text-left border-bottom-0"><cmpassignradiologists assigned-radiologist="DataObject.RuleDetail.selectedRadiologists" view-mode="true"></cmpassignradiologists></td></tr></tbody></table></div></div></div></div></div></div></div></div></div><rule rule="Rule" rule-table="RuleTable" rule-setting="true" ng-if="!ShowListView"></rule></div>');
$templateCache.put('app/pages/settings/tat-notification/tat-notification.html','<style>\r\n    #addScheduleRadiologistGrid.multiSelectGridDiv, #addScheduleAlternateRadiologistGrid.multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n\r\n    .blk-calender .uib-datepicker {\r\n        color: white !important;\r\n    }\r\n\r\n    #addScheduleModal .fa-caret-right {\r\n        color: white !important;\r\n    }\r\n\r\n    .row.rf-filter-ui .location-tags-input tags-input .tags {\r\n        border: 1px solid #424242;\r\n    }\r\n\r\n    .provider-title {\r\n        background: #116A5C !important;\r\n        color: #fff !important;\r\n        border-color: #116a5c;\r\n        padding: 4px;\r\n        margin: 0;\r\n    }\r\n\r\n    .provider-box {\r\n        border: 1px solid #444444;\r\n        border-collapse: unset;\r\n    }\r\n\r\n    .provider-namelist {\r\n        padding: 3px 5px;\r\n        margin: 3px 7px;\r\n        border: 1px solid #00584b;\r\n        border-radius: 4px;\r\n    }\r\n\r\n    .provider-namelist-box {\r\n        padding: 5px;\r\n        min-height: 45px;\r\n        align-items:flex-start;\r\n        max-height: 100px;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .paymtcontract-grid {\r\n        /*height: calc(100vh - 120px);*/\r\n        height: calc(100vh - 116px);\r\n    }\r\n\r\n        .paymtcontract-grid.tat-grid-h {\r\n            /*height: calc(100vh - 145px);*/\r\n            height: calc(100vh - 144px);\r\n        }\r\n\r\n    .tat-rule-div {\r\n        padding: 40px 20px 24px 20px;\r\n        background-color: #202020;\r\n        border: 1px solid #474747;\r\n        border-left-width: 2px;\r\n        border-left-color: #828282;\r\n        overflow-y: auto;\r\n        box-shadow: -5px 0px 20px 0px rgba(0,0,0,0.5);\r\n    }\r\n\r\n    .tatradiolog .tat-rule-div {\r\n        width: 45%;\r\n    }\r\n\r\n    .close-viewrule {\r\n        height: 18px;\r\n        width: 18px;\r\n        padding: 0 !important;\r\n        border: 0 !important;\r\n        cursor: pointer;\r\n        color: #fff !important;\r\n        background-color: transparent !important;\r\n        font-size: 14px;\r\n        text-align: center;\r\n    }\r\n\r\n        .close-viewrule .glyphicon {\r\n            top: 0;\r\n        }\r\n\r\n    .rulename-header {\r\n        position: absolute;\r\n        top: 0;\r\n        z-index: 1;\r\n        left: 0;\r\n        right: 1px;\r\n        background-color: #313131;\r\n        padding: 6px;\r\n        border-left: 1px solid #828282;\r\n    }\r\n\r\n    .tatradiolog #tatNotificationGrid {\r\n        width: 55%;\r\n    }\r\n\r\n    .tatradiolog {\r\n        display: flex;\r\n    }\r\n\r\n    .btn.btn-default:hover .glyphicon {\r\n        color: #fff !important;\r\n    }\r\n    .add-sched-modal-h .max-h-300px {\r\n        max-height: 200px;\r\n    }\r\n    .detail-color {\r\n        border: none;\r\n        background-color: transparent;\r\n        width: 30px;\r\n        height: 25px;\r\n        outline: none;\r\n    }\r\n    #color-picker::-webkit-color-swatch {\r\n        border-radius: 4px;\r\n    }\r\n    @media (max-width: 1199px) and (min-width: 768px) {\r\n        .tat-rule-div {\r\n            border-left-width: 0 !important;\r\n        }\r\n        .tatradiolog {\r\n            display: block;\r\n        }\r\n        .add-sched-modal-h .max-h-300px {\r\n            max-height: 180px;\r\n        }\r\n            .tatradiolog #tatNotificationGrid {\r\n                width: 100%;\r\n            }\r\n\r\n            .tatradiolog .tat-rule-div {\r\n                width: 100%;\r\n                height:370px;\r\n                overflow-y:auto;\r\n            }\r\n                .tatradiolog .tat-rule-div.tat-grid-h {\r\n                    width: 100%;\r\n                    height: 315px;\r\n                    overflow-y: auto;\r\n                }\r\n        .paymtcontract-grid {\r\n            height: calc(100vh - 530px) !important;\r\n        }\r\n\r\n            .paymtcontract-grid.tat-grid-h {\r\n                height: calc(100vh - 500px) !important;\r\n            }\r\n            .paymtcontract-grid.tatgrid-portrait {\r\n                height: calc(100vh - 155px) !important;\r\n            }\r\n\r\n            .paymtcontract-grid.tat-grid-h.tatgrid-portrait {\r\n                height: calc(100vh - 185px) !important;\r\n            }\r\n    }\r\n    @media (min-width: 768px) and (min-height: 1080px) and (orientation: portrait) {\r\n        .tatradiolog .tat-rule-div {\r\n            width: 100%;\r\n            height: 610px;\r\n            overflow-y: auto;\r\n        }\r\n\r\n            .tatradiolog .tat-rule-div.tat-grid-h {\r\n                width: 100%;\r\n                height: 550px;\r\n                overflow-y: auto;\r\n            }\r\n\r\n        .paymtcontract-grid {\r\n            height: calc(100vh - 730px) !important;\r\n        }\r\n\r\n            .paymtcontract-grid.tat-grid-h {\r\n                height: calc(100vh - 700px) !important;\r\n            }\r\n            .paymtcontract-grid.tatgrid-portrait {\r\n                height: calc(100vh - 120px) !important;\r\n            }\r\n            .paymtcontract-grid.tat-grid-h.tatgrid-portrait {\r\n                height: calc(100vh - 150px) !important;\r\n            }\r\n    }\r\n</style><div><div class="radf-header"><h2>TAT Notification</h2></div><div class="row mt-10px rf-filter-ui mx-0 filterspace"><div class="col-md-2 col-sm-2 col-xs-6 pd-lr"><input type="text" class="blk-input form-control" placeholder="Schedule Name" ng-model="DataObject.filter.ScheduleName"></div><div class="col-md-2 col-sm-2 col-xs-6 pd-lr"><ui-select class="mult-select mob-closekeypad" ng-model="DataObject.filter.selectedRule"><ui-select-match allow-clear="false" placeholder="Select TAT Rule">{{$select.selected.RuleName}}</ui-select-match><ui-select-choices repeat="rule in DataObject.TATRuleList | filter: {RuleName: $select.search} | orderBy:\'RuleName\'" position="down"><div ng-bind-html="rule.RuleName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-2 col-sm-4 col-xs-6 pd-lr tultip-bottom"><multi-select master-data="DataObject.filter.Radiologist" ng-model="DataObject.filter.Radiologist.SelectedValue" list="DataObject.MasterRadiologistsList" on-change="DataObject.filter.Radiologist.OnChange(selectedData)"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px wd-max-content max-w-180px" tooltip-class="uibtooltipDenial" style="z-index: 999; top: 60px !important;" tooltip-placement="auto bottom">{{DataObject.filter.Radiologist.tooltip}}</span></div><div class="col-md-2 col-sm-2 col-xs-6 pd-lr"><div class="input-group blk-calender mb-0" tooltip-class="uibtooltipDenial" uib-tooltip="Start Effective Date" tooltip-placement="auto top"><input type="text" class="blk-input form-control col-placeholder" style="opacity:1!important;" uib-datepicker-popup="MM/dd/yyyy" ng-model="DataObject.filter.FromDate" readonly="" datepicker-options="DataObject.dateSearchOptions" is-open="DataObject.FromDateOpenFilter" ng-required="true" close-text="Close" placeholder="Start Effective Date" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="DataObject.FromDateOpenFilter=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-2 col-sm-2 col-xs-6 pd-lr"><div class="input-group blk-calender mb-0" tooltip-class="uibtooltipDenial" uib-tooltip="End Effective Date" tooltip-placement="auto top"><input type="text" class="blk-input form-control col-placeholder" style="opacity:1!important;" uib-datepicker-popup="MM/dd/yyyy" ng-model="DataObject.filter.ToDate" readonly="" datepicker-options="DataObject.dateSearchOptions" is-open="DataObject.ToDateOpenFilter" ng-required="true" close-text="Close" placeholder="End Effective Date" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="DataObject.ToDateOpenFilter=true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="pd-lr col-md-2 col-sm-12 col-xs-12"><button class="btn btn-primary rf-btn-sm" ng-click="DataObject.FilterTATScheduleList();clearAddScheduleData();">Filter</button> <button class="btn btn-default rf-btn-sm" ng-click="DataObject.ClearTATScheduleListFilter()">Clear</button> <button class="btn btn-primary float-right rf-btn-sm" ng-click="DataObject.openAddScheduleModal()">Add</button></div></div><div ng-class="{\'tatradiolog\': DataObject.isRowDetailsVisible}"><div id="tatNotificationGrid" class="myGrid paymtcontract-grid ag-theme-balham-dark" ng-class="{\'tat-grid-h\' : (DataObject.filter.Radiologist.SelectedValue.list.length > 0) , \'tatgrid-portrait\' : (!DataObject.isRowDetailsVisible) }"></div><div ng-if="DataObject.isRowDetailsVisible" class="txt-clr-1 tat-rule-div pos-rel" ng-class="{\'tat-grid-h\' : DataObject.filter.Radiologist.SelectedValue.list.length > 0 }"><div class="d-flex justify-content-between rulename-header"><span class="txt-clr-1 fw-600">{{DataObject.addScheduleObj.ScheduleName}}</span> <button type="button" class="btn close-viewrule" ng-click="clearAddScheduleData()"><span class="glyphicon glyphicon-remove"></span></button></div><div><comprulecondition rule="DataObject.addScheduleObj.selectedRule" view-mode="true"></comprulecondition><div class="d-flex align-item-center"><label class="mb-0">TAT Time: {{DataObject.addScheduleObj.selectedRule.TATValue}} {{DataObject.addScheduleObj.selectedRule.TATType}}</label> <label class="pl-20px mb-0">SLA Breach Time: {{DataObject.addScheduleObj.selectedRule.SLABreachValue}} {{DataObject.addScheduleObj.selectedRule.SLABreachType}}</label> <label class="pl-20px mb-0 txt-clr-1" ng-if="DataObject.addScheduleObj.selectedRule.RuleColorCode">SLA Breach Color:</label> <input type="color" id="color-picker" class="detail-color" value="" ng-disabled="true" ng-model="DataObject.addScheduleObj.selectedRule.RuleColorCode" ng-if="DataObject.addScheduleObj.selectedRule.RuleColorCode"></div></div><div class="provider-box mb-15px"><p class="provider-title mb-0">Providers</p><div class="d-flex flex-wrap provider-namelist-box"><span ng-repeat="provider in DataObject.addScheduleObj.Radiologist.SelectedValue.list" class="provider-namelist col-lg-3 col-md-3 col-sm-2 word-break-word ws-normal">{{provider.LastName+", "+ provider.FirstName}}</span></div></div><div class="provider-box"><p class="provider-title mb-0">Alternate Providers</p><div class="d-flex flex-wrap provider-namelist-box"><span ng-repeat="provider in DataObject.addScheduleObj.AlternateRadiologist.SelectedValue.list" class="provider-namelist col-lg-3 col-md-3 col-sm-2 word-break-word ws-normal">{{provider.LastName+", "+ provider.FirstName}}</span></div></div></div></div></div><div class="modal fade new-popup" id="addScheduleModal" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog add-sched-modal-w create-inv-modal"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal" ng-click="clearAddScheduleData()">&times;</button><h4 class="modal-title">{{(DataObject.selectedRow)?"Edit Notification Schedule":"Add Notification Schedule"}}</h4></div><div class="modal-body p-2 add-sched-modal-h"><div class="row mb-15px px-20px mt-10px"><div class="col-md-12 mb-10px"><label>Schedule Name*</label> <input type="text" class="blk-input form-control" placeholder="Add Schedule Name" ng-model="DataObject.addScheduleObj.ScheduleName"></div><div class="col-md-12 mb-10px"><label>Select TAT Rule*</label><ui-select class="mult-select mob-closekeypad" ng-model="DataObject.addScheduleObj.selectedRule" ng-change="DataObject.onRuleSelected()"><ui-select-match allow-clear="false" placeholder="Select TAT Rule">{{$select.selected.RuleName}}</ui-select-match><ui-select-choices repeat="rule in DataObject.TATRuleList | filter: {RuleName: $select.search} | orderBy:\'RuleName\'" position="down"><div ng-bind-html="rule.RuleName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-md-12"><div class="rule-view-enhs pos-rel mb-10px" ng-show="DataObject.addScheduleObj.selectedRule"><div class="ruletable-cdns-wraaper pos-rel" ng-if="DataObject.addScheduleObj.selectedRule.Groups"><div class="ruletable-cdns1"><div class="d-flex align-item-center mb-5px"><label class="mb-0">TAT Time: {{DataObject.addScheduleObj.selectedRule.TATValue}} {{DataObject.addScheduleObj.selectedRule.TATType}}</label> <label class="pl-20px mb-0">SLA Breach Time: {{DataObject.addScheduleObj.selectedRule.SLABreachValue}} {{DataObject.addScheduleObj.selectedRule.SLABreachType}}</label> <label class="pl-20px mb-0 txt-clr-1" ng-if="DataObject.addScheduleObj.selectedRule.RuleColorCode">SLA Breach Color:</label> <input type="color" id="color-picker" class="detail-color" value="" ng-disabled="true" ng-model="DataObject.addScheduleObj.selectedRule.RuleColorCode" ng-if="DataObject.addScheduleObj.selectedRule.RuleColorCode"></div><comprulecondition rule="DataObject.addScheduleObj.selectedRule" view-mode="true"></comprulecondition></div></div></div></div><div class="row m-0"><div class="col-md-6 mb-10px tultip-bottom"><label>Providers*</label><multi-select master-data="DataObject.addScheduleObj.Radiologist" ng-model="DataObject.addScheduleObj.Radiologist.SelectedValue" list="DataObject.RadiologistsList" on-add-tag="DataObject.onRadiologistSelected(tag)" on-remove-tag="DataObject.onRadiologistRemoved(tag)"></multi-select><span class="tultiptext text-preline max-h-300px overflow-auto text-left tt-white sl-hsw-180px wd-max-content max-w-180px" tooltip-class="uibtooltipDenial" style="z-index: 999; top: 60px !important;" tooltip-placement="auto bottom">{{DataObject.addScheduleObj.Radiologist.tooltip}}</span></div><div class="col-md-6 mb-10px tultip-bottom"><label>Alternate Providers*</label><multi-select master-data="DataObject.addScheduleObj.AlternateRadiologist" ng-model="DataObject.addScheduleObj.AlternateRadiologist.SelectedValue" list="DataObject.AlternateRadiologistsList" on-add-tag="DataObject.onAltRadiologistSelected(tag)" on-remove-tag="DataObject.onAltRadiologistRemoved(tag)"></multi-select><span class="tultiptext text-preline max-h-300px overflow-auto text-left tt-white sl-hsw-180px wd-max-content max-w-180px" tooltip-class="uibtooltipDenial" style="z-index: 999; top: 60px !important;" tooltip-placement="auto bottom">{{DataObject.addScheduleObj.AlternateRadiologist.tooltip}}</span></div></div><div class="row m-0"><div class="col-md-6 mb-10px"><label>Start Effective Date*</label><div class="input-group blk-calender mb-0" tooltip-class="uibtooltipDenial" uib-tooltip="Start Effective Date" tooltip-placement="auto top"><input type="text" class="blk-input form-control col-placeholder" style="opacity:1!important;" uib-datepicker-popup="MM/dd/yyyy" ng-model="DataObject.addScheduleObj.FromDate" readonly="" datepicker-options="DataObject.dateSearchOptions" is-open="DataObject.FromDateOpen" ng-required="true" close-text="Close" placeholder="Start Effective Date" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="DataObject.openFromDate()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-6 mb-10px"><label>End Effective Date*</label><div class="input-group blk-calender mb-0" tooltip-class="uibtooltipDenial" uib-tooltip="End Effective Date" tooltip-placement="auto top"><input type="text" class="blk-input form-control col-placeholder" style="opacity:1!important;" uib-datepicker-popup="MM/dd/yyyy" ng-model="DataObject.addScheduleObj.ToDate" readonly="" datepicker-options="DataObject.dateSearchOptions" is-open="DataObject.ToDateOpen" ng-required="true" close-text="Close" placeholder="End Effective Date" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="DataObject.openToDate()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-12"><button class="btn btn-default" ng-click="clearAddScheduleData()" data-dismiss="modal">Cancel</button> <button class="btn btn-primary" ng-click="DataObject.SaveOnCallSchedule();" ng-disabled="DataObject.isAddScheduleDisabled()">Save</button></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/settings/techform/techform.html','<ui-view></ui-view>');
$templateCache.put('app/pages/settings/timer-ticker/timer-ticker.html','<style>\r\n    .isenable-toggle {\r\n        background-color: #323232;\r\n        border-radius: 5px;\r\n        border: 1px solid #9b9b9b;\r\n    }\r\n     .site-tenant .multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n    @media only screen and (min-width: 768px)  and (max-width: 1400px) {\r\n        .add-timerTickerModal .modal-dialog.modal-lg {\r\n            width: 850px;\r\n        }\r\n    }\r\n</style><div><div class="radf-header"><h2 class="w-50 float-left">Timer Ticker</h2><div class="w-50 float-left text-right pt-3px pr-15px"></div><div class="clearfix"></div></div><div class="clearfix"></div></div><div class="pos-rel h-86vh"><div id="timerTickerFilterDiv" class=""><div class="pt-8px"><form name="TimerTickerFilter"><div class="row rf-filter-ui m-0 filterspace d-flex"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr mob-pr-0"><div class="tultip-bottom"><ui-select class="mult-select" ng-model="DataObject.Filter.SelectedTenant" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Tenant" tooltip-placement="auto top" skip-focusser="true" ng-change="FilterTimerTickerList()"><ui-select-match placeholder="Select Tenant" allow-clear="false">{{$select.selected.TenantName}}</ui-select-match><ui-select-choices repeat="tenant in DataObject.TenantsList | filter: {TenantName: $select.search} | orderBy:\'TenantName\'" position="down"><div ng-bind-html="(tenant.TenantName) | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr mob-pr-0"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="Select Date Range" ng-model="DataObject.Filter.SelectedFilterDateRange" options="FilterDOSopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{DataObject.Filter.SelectedFilterDateRangeTooltip}}" tooltip-placement="auto top"></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr mob-pr-0" tooltip-class="uibtooltipDenial" uib-tooltip="Status" tooltip-placement="auto top"><ui-select skip-focusser="true" class="mult-select mob-closekeypad" ng-model="DataObject.Filter.selectedStatus" ng-change="FilterTimerTickerList()"><ui-select-match allow-clear="false">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="list in DataObject.StatusList" position="down"><div ng-bind-html="list.value"></div></ui-select-choices></ui-select><div class="clearfix"></div></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr d-flex"><button type="submit" class="btn btn-primary rf-btn-xs mr-4px" ng-click="FilterTimerTickerList()">Filter</button> <button class="btn btn-default rf-btn-xs" ng-click="ClearFilter()">Clear</button></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr mob-pr-0 text-right d-flex justify-content-end flex-grow-1" id=""><button type="button" class="btn btn-primary rf-btn-xs" ng-click="AddTimerTicker()">Add Timer Ticker</button></div><div class="clearfix"></div></div></form></div><div style="background-color:#262526!important;height:1px;"><div class="progress m-0 h-1px" style="background-color:#262526!important;" ng-if="DataObject.isFilterLoading"><div class="progress-bar progress-bar-striped grid-xs-loader active w-100" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div></div></div><div class="ag-theme-balham-dark" id="timerTickerGrid" style="width: 100%; height: calc(100vh - 110px)"></div></div></div><div class="modal fade add-timerTickerModal" id="addTimerTickerModal" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">{{DataObject.SiteMarqueeSettingID ? \'Edit\' : \'Add\'}} Timer Ticker</h4></div><div class="modal-body"><form id="TimerTickerForm"><div class="row m-0"><div class="col-lg-5 col-md-5 col-sm-4 mb-10px pl-0"><div class="form-group w-100 px-0 mb-0 pos-rel site-tenant"><label class="rf-label">Site (Tenant) *</label><multi-select master-data="DataObject.multiSelectDropdown.SiteDropdown" ng-model="DataObject.SelectedSites" list="DataObject.SitesList" ng-disabled="DataObject.SiteMarqueeSettingID" tooltip-class="uibtooltipDenial" uib-tooltip="Select Site(s)" tooltip-placement="auto top"></multi-select></div></div><div class="col-lg-4 col-md-4 col-sm-4 mb-10px pr-0 tultip-bottom"><label class="rf-label">Select Date Range *</label> <input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="Select Date Range" ng-model="DataObject.SelectedDateRange" options="DOSopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt"></div><div class="col-lg-3 col-md-3 col-sm-4 mb-10px pr-0"><div class="d-flex align-item-center mt-25px my-10px py-6px px-8px noisenable-toggle"><label class="rf-label mb-0">Is Enable</label><div class="d-flex align-item-center"><label class="checkbox-switch pref-checkbox ml-10px mb-0 pull-right" title=""><input type="checkbox" class="mr-2px" ng-model="DataObject.IsTickerEnabled"> <span class="checkbox-switch-slider round"></span></label> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="DataObject.IsTickerEnabled">Yes</span> <span class="fs-12px txt-clr-1 pull-right chktgl-value" ng-if="!DataObject.IsTickerEnabled">No</span></div></div></div></div><div class="row m-0"><div class="col-lg-12 col-md-12 col-sm-12 mb-10px pl-0"><label class="rf-label">Ticker Message *</label> <textarea class="txt-area timer-ticker-txtarea h-75px w-100 py-6px px-12px" ng-model="DataObject.TickerValue" placeholder="Enter Ticker Message"></textarea></div></div><div class="row m-0"><div class="col-md-12 px-0"><div class="d-flex justify-content-end"><button class="btn btn-default mr-2" type="button" data-dismiss="modal">Cancel</button> <button class="btn btn-primary" ng-click="SaveTimerTicker()" ng-disabled="!DataObject.SelectedSites || DataObject.SelectedSites.list.length === 0 || !DataObject.SelectedDateRange || !DataObject.SelectedDateRange.startDate || !DataObject.SelectedDateRange.endDate || !DataObject.TickerValue">Save</button></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/settings/update-viewer/update-viewer.html','<style>\r\n    .update-viewer-grid {\r\n        height: calc(100vh - 185px);\r\n    }\r\n    .update-viewer-grid.filter-expanded {\r\n        height: calc(100vh - 220px);\r\n    }\r\n    .pagination {\r\n        padding: 5px 8px 0 !important;\r\n    }\r\n    .update-viewer-modal .site-tenant .multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n    .tooltip-multiline .tooltip-inner {\r\n        white-space: pre-line;\r\n        text-align: left;\r\n    }\r\n\r\n    .update-viewer-modal .modal-dialog {\r\n        -webkit-transform: none !important;\r\n        transform: none !important;\r\n    }\r\n    .update-viewer-modal .ui-select-bootstrap > .ui-select-choices {\r\n        z-index: 9999 !important;\r\n        max-height: 250px;\r\n        overflow-y: auto;\r\n        min-width: 250px;\r\n    }\r\n</style><div class="txt-clr-1"><div class="radf-header"><h2>Update Viewer</h2></div><div class="row rf-filter-ui m-0 pt-8px filterspace"><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr site-tenant"><multi-select master-data="vm.filterSiteConfig" ng-model="vm.filter.SelectedSites" list="vm.sitesList" tooltip-class="uibtooltipDenial tooltip-multiline" uib-tooltip="{{vm.getSiteTooltip(vm.filter.SelectedSites)}}" tooltip-placement="auto top"></multi-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr"><ui-select class="mult-select p-3px-all" multiple="" ng-model="vm.filter.selectedRadiologists" close-on-select="false" reset-search-input="true" tooltip-class="uibtooltipDenial tooltip-multiline" uib-tooltip="{{vm.getRadiologistTooltip(vm.filter.selectedRadiologists)}}" tooltip-placement="auto top"><ui-select-match placeholder="Radiologist" allow-clear="true" class="overflow-y-auto d-block htSelRadio" style="max-height:25px;">{{$item.LastName}}, {{$item.FirstName}}</ui-select-match><ui-select-choices repeat="rad in vm.filterRadiologistMatches | propsFilter: {LastName: $select.search, FirstName: $select.search, Email: $select.search, PhoneNumber: $select.search}" refresh="vm.searchRadiologists($select.search, \'filter\')" refresh-delay="300" position="down"><div ng-bind-html="rad.LastName + \', \' + rad.FirstName | highlight: $select.search"></div><small><span ng-if="rad.Email && rad.Email.length > 0"><i class="fa fa-envelope"></i> {{rad.Email}}<br></span> <span ng-if="rad.PhoneNumber && rad.PhoneNumber.length > 0"><i class="fa fa-phone-square"></i> {{rad.PhoneNumber}}</span></small></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="Select Date Range" ng-model="vm.filter.SelectedFilterDateRange" options="vm.FilterDOSopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{vm.getDateRangeTooltip(vm.filter.SelectedFilterDateRange)}}" tooltip-placement="auto top"></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><select class="sing-select form-control downArrow-ie" ng-model="vm.filter.dicomViewer" tooltip-class="uibtooltipDenial" uib-tooltip="{{vm.filter.dicomViewer ? (vm.viewerLookup[vm.filter.dicomViewer] || vm.filter.dicomViewer) : \'All\'}}" tooltip-placement="auto top"><option value="">All</option><option ng-repeat="opt in vm.viewerOptions" value="{{opt.Value}}">{{opt.Key}}</option></select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr d-flex"><button type="button" class="btn btn-primary rf-btn-xs mr-4px" ng-click="vm.search()">Search</button> <button type="button" class="btn btn-default rf-btn-xs" ng-click="vm.reset()">Reset</button></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-6 pd-lr"><button type="button" class="btn btn-primary rf-btn-xs pull-right" ng-click="vm.openModal(null)">Add New</button></div></div><div id="updateViewerGrid" class="ag-theme-balham-dark w-100 update-viewer-grid" ag-grid="vm.gridOptions"></div><div class="common-footer h-40px newfoot mob-footer"><div class="w-70 float-left pl-8px mob-w-100"><ul uib-pagination="" boundary-links="true" total-items="vm.totalRows" max-size="10" items-per-page="vm.pageSize" ng-model="vm.currentPage" ng-change="vm.pageChanged()" class="pagination float-left" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul><div class="clearfix"></div></div><div class="w-30 float-left text-right d-table h-40px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Total Records: <span>{{vm.totalRows}}</span></h5></div></div></div><div class="modal fade new-popup update-viewer-modal" id="updateViewerModal" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow: hidden !important;"><div class="modal-dialog" role="document"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">{{vm.modalTitle}}</h4></div><div class="modal-body"><form name="frmUpdateViewer" id="frmUpdateViewer" novalidate=""><div class="row"><div class="col-md-12 mb-10px"><label class="rf-label">Site (Tenant) <span class="txt-clr-6">*</span></label><div class="site-tenant"><multi-select master-data="vm.modalSiteConfig" ng-model="vm.modal.SelectedSites" list="vm.sitesList" tooltip-class="uibtooltipDenial tooltip-multiline" uib-tooltip="{{vm.getSiteTooltip(vm.modal.SelectedSites)}}" tooltip-placement="auto top"></multi-select></div></div></div><div class="row"><div class="col-md-12 mb-10px"><label class="rf-label">Radiologist</label><ui-select class="mult-select p-3px-all" multiple="" ng-model="vm.modal.selectedRadiologists" close-on-select="false" reset-search-input="true" tooltip-class="uibtooltipDenial tooltip-multiline" uib-tooltip="{{vm.getRadiologistTooltip(vm.modal.selectedRadiologists)}}" tooltip-placement="auto top"><ui-select-match placeholder="Select Radiologist (optional)" allow-clear="true" class="overflow-y-auto d-block htSelRadio" style="max-height:25px;">{{$item.LastName}}, {{$item.FirstName}}</ui-select-match><ui-select-choices repeat="rad in vm.modalRadiologistMatches | propsFilter: {LastName: $select.search, FirstName: $select.search, Email: $select.search, PhoneNumber: $select.search}" refresh="vm.searchRadiologists($select.search, \'modal\')" refresh-delay="300" position="down"><div ng-bind-html="rad.LastName + \', \' + rad.FirstName | highlight: $select.search"></div><small><span ng-if="rad.Email && rad.Email.length > 0"><i class="fa fa-envelope"></i> {{rad.Email}}<br></span> <span ng-if="rad.PhoneNumber && rad.PhoneNumber.length > 0"><i class="fa fa-phone-square"></i> {{rad.PhoneNumber}}</span></small></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-12 mb-10px tultip-bottom"><label class="rf-label">Effective Date Range <span class="txt-clr-6">*</span></label> <input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="Select Date Range" ng-model="vm.modal.SelectedDateRange" options="vm.DOSopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{vm.getDateRangeTooltip(vm.modal.SelectedDateRange)}}" tooltip-placement="auto top"></div></div><div class="row"><div class="col-md-12 mb-10px"><label class="rf-label">DICOM Viewer <span class="txt-clr-6">*</span></label><ui-select class="mult-select" ng-model="vm.modal.dicomViewer" ng-required="true" tooltip-class="uibtooltipDenial" uib-tooltip="{{vm.modal.dicomViewer ? vm.modal.dicomViewer.Key : \'Select DICOM Viewer\'}}" tooltip-placement="auto top"><ui-select-match placeholder="Select DICOM Viewer" allow-clear="false">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="viewer in vm.viewerOptions | propsFilter: {Key: $select.search}" position="down"><div ng-bind-html="viewer.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-md-12 pt-10px" style="border-top: 1px solid #504f4f;"><div class="d-flex justify-content-end"><button type="button" class="btn btn-default mr-5px" data-dismiss="modal">Cancel</button> <button type="submit" class="btn btn-primary" ng-click="vm.saveOverride()" ng-disabled="!vm.modal.SelectedSites || vm.modal.SelectedSites.list.length === 0 || !vm.modal.SelectedDateRange || !vm.modal.SelectedDateRange.startDate || !vm.modal.dicomViewer">Save</button></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/settings/userpreference/userpreference.html','<style>\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    .b-clr-3:hover {\r\n        background-color: #07e6c4 !important\r\n    }\r\n\r\n    .screen-select {\r\n        background-color: #07e6c4 !important\r\n    }\r\n\r\n    .h-120px {\r\n        height: 120px !important;\r\n    }\r\n</style><div class=""><div class=""><div class=""><div class="radf-header"><h2>User Preference</h2></div><div id="exTab2" class=""><div class="px-10px bg-clr-26"><ul class="nav nav-tabs no-bg"><li class="active"><a href="#Preference" data-toggle="tab">Preference</a></li><li ng-click="GetAllDicomViewerCredentials()"><a href="#SetViewer" data-toggle="tab">Set Viewer Credential</a></li></ul></div><div class="tab-content txt-clr-1 p-0"><div class="tab-pane active userprep-height" id="Preference"><form name="myForm" class="" novalidate=""><div class="row d-flex sm-flex-wrap mt-13px mx-10px"><div class="col-xs-12 col-sm-12 col-md-6 bor-rad-4px bg-clr-31 p-0 mr-20px mb-10px rmv-mr-mob sm-mr-0"><div class="usr-prf-heading"><h1 class="fs-14px fw-600 px-15px py-10px m-0">Worklist Settings</h1></div><div class="usr-prf-content py-16px clearfix"><div class="clearfix"><div class="col-md-4 col-sm-4 mb-25px"><div class="form-controller rw-30"><label class="rf-label d-block">Default Worklist</label><select id="ddlWorklist" class="sing-select form-control downArrow-ie b-clr-5f" ng-model="DefaultWorklist.PreferenceValue"><option value="PSW">Practice Worklist</option><option value="PRW">Personal Worklist</option></select></div></div><div class="col-md-4 col-sm-4 mb-25px"><div class="form-controller rw-30"><label class="rf-label d-block">Dicom Viewer</label><ui-select class="mult-select b-clr-5f min-h-30px" ng-model="SelectedDefaultDicomViewer.PreferenceValue" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Viewer" tooltip-placement="auto top" ng-required="true"><ui-select-match placeholder="Choose a Viewer" allow-clear="true">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="dicomviewer in InstDicomViewerList | propsFilter: {Key: $select.search}" position="down"><div ng-bind-html="dicomviewer.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-md-4 col-sm-4 mb-25px"><div class="form-controller rw-30"><label class="rf-label d-block">Default Dictation System</label><ui-select class="mult-select b-clr-5f min-h-30px" ng-model="SelectedDefaultDictationSystem.PreferenceValue" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Dictation System" tooltip-placement="auto top"><ui-select-match placeholder="Choose a Dictation System" allow-clear="true">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="dictationSystem in DefaultDictationSystemList | propsFilter: {Key: $select.search}" position="down"><div ng-bind-html="dictationSystem.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="clearfix"><div class="col-md-4 col-sm-4 mb-25px"><div class="form-controller d-flex align-item-center p-10px"><input class="m-0 cmn-checkbx-input" type="checkbox" id="prfChsNextStudy" ng-model="ChooseNextStudy.PreferenceValue" ng-checked="ChooseNextStudy.PreferenceValue"> <label for="prfChsNextStudy" class="rf-label cmn-check-label">Choose Next Study</label></div></div><div class="col-md-4 col-sm-4 mb-25px"><div class="form-controller d-flex align-item-center"><input class="m-0 cmn-checkbx-input" type="checkbox" id="prfShowDefi" ng-model="DeficientWarningOnWorklist.PreferenceValue" ng-checked="DeficientWarningOnWorklist.PreferenceValue"> <label for="prfShowDefi" class="rf-label cmn-check-label">Show Deficient Warning On Worklist</label></div></div></div><div class="clearfix"><div class="mb-25px col-md-4 col-sm-4"><label class="rf-label d-block">Worklist</label><div class="d-flex align-item-center"><label class="form-controller d-flex align-item-center mr-10px mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="PrefNewWrklst" ng-model="LoadMoreWorklist.PreferenceValue" value="0" checked=""> <span class="rf-label cmn-check-label">Single View</span></label> <label class="form-controller d-flex align-item-center mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="PrefNewWrklst" ng-model="LoadMoreWorklist.PreferenceValue" value="1"> <span class="rf-label cmn-check-label">Multi View</span></label></div></div><div class="mb-25px col-md-4 col-sm-4"><label class="rf-label d-block">Show locked study in worklist</label><div class="d-flex align-item-center"><label class="form-controller d-flex align-item-center mr-10px mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="ShowLockStudy" ng-model="ShowLockStudy.PreferenceValue" value="1" checked=""><span class="rf-label cmn-check-label">Yes</span></label> <label class="form-controller d-flex align-item-center mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="ShowLockStudy" ng-model="ShowLockStudy.PreferenceValue" value="0"><span class="rf-label cmn-check-label">No</span></label></div></div><div class="mb-25px col-md-4 col-sm-4"><label class="rf-label d-block">Send amber alert notification</label><div class="d-flex align-item-center"><label class="form-controller d-flex align-item-center mr-10px mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="SendDefaultAlertforOncall" ng-model="SendDefaultAlertforOncall.PreferenceValue" value="0" checked=""> <span class="rf-label cmn-check-label">Yes</span></label> <label class="form-controller d-flex align-item-center mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="SendDefaultAlertforOncall" ng-model="SendDefaultAlertforOncall.PreferenceValue" value="1"> <span class="rf-label cmn-check-label">No</span></label></div></div><div class="mb-25px col-md-4 col-sm-4"><label class="rf-label d-block">Show other users assigned studies in the worklist</label><div class="d-flex align-item-center"><label class="form-controller d-flex align-item-center mr-10px mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="DoNotShowStudyAssignedToOtherUsers" ng-model="DoNotShowStudyAssignedToOtherUsers.PreferenceValue" value="0" checked=""> <span class="rf-label cmn-check-label">Yes</span></label> <label class="form-controller d-flex align-item-center mb-0"><input class="m-0 cmn-checkbx-input" type="radio" name="DoNotShowStudyAssignedToOtherUsers" ng-model="DoNotShowStudyAssignedToOtherUsers.PreferenceValue" value="1"> <span class="rf-label cmn-check-label">No</span></label></div></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-6 bor-rad-4px bg-clr-31 p-0 mb-10px"><div class="usr-prf-heading"><h1 class="fs-14px fw-600 px-15px py-10px m-0">CIVR Settings</h1></div><div class="usr-prf-content py-16px"><div><div class="up-fields-w"><div class="form-controller d-flex align-item-center mb-25px"><input class="m-0 cmn-checkbx-input" type="checkbox" id="prfPushTlk" ng-model="PushToTalk.PreferenceValue" ng-checked="PushToTalk.PreferenceValue"> <label for="prfPushTlk" class="rf-label cmn-check-label">Push to talk</label></div></div><div class="up-fields-w"><div class="form-controller d-flex align-item-center mb-25px"><input class="m-0 cmn-checkbx-input" type="checkbox" id="prfShowSave" ng-model="ShowTemplateWarning.PreferenceValue" ng-checked="ShowTemplateWarning.PreferenceValue"> <label for="prfShowSave" class="rf-label cmn-check-label">Show save as template warning</label></div></div><div class="clearfix"></div></div><div><div class="up-fields-w"><div class="form-controller rw-30"><label class="rf-label d-block">Number of Comparison In Report</label> <input class="blk-input form-control b-clr-light pl-10px w-100" type="text" ng-model="NumberofComparisonInReport.PreferenceValue" numbers-only="" placeholder="Enter Value" ng-required="true"><br><span ng-if="isInvalidNumberofComparison" style="color:#dd4b39" class="fw-500 fs-14px">Please enter valid positive number.</span></div></div></div></div></div></div><div class="row bor-rad-4px bg-clr-31 m-10px-all d-none"><div class="col-md-2 col-sm-4 py-15px" ng-show="IsDisPref"><label class="rf-label fs-14px">Display Setting</label></div><div class="clearfix"></div><div class="common-tbl h-100-per overflow-visible" id="ScreenDiv"><table class="table" ng-show="IsDisPref"><thead><tr><th class="w-10 text-left">Viewer</th><th class="w-13 text-left">Display</th><th class="w-10 text-left">FullScreen</th><th class="w-10 text-left">Focused</th><th class="w-12 text-left"></th><th class="w-15 text-left d-none">Width(px)</th><th class="w-15 text-left d-none">Height(px)</th><th class="w-15 text-left d-none">Top(px)</th><th class="w-15 text-left d-none">Left(px)</th><th class="w-15 text-left">Preview</th></tr></thead><tbody class="overflow-visible"><tr ng-repeat="v in DisplaySetting.PreferenceValue track by $index"><td class="w-10 text-left pt-5px">{{SetDicomViewerText(v.viewer)}}</td><td class="w-13 text-left overflow-visible"><ui-select class="mult-select my-5px" ng-model="v.display" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Display" tooltip-placement="auto top" ng-required="true" ng-change="setDisplayValue(v)" ng-init="setDefaultDisplay(v)"><ui-select-match placeholder="Choose a Display" allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="dis in Display | propsFilter: {name: $select.search}" position="down"><div ng-bind-html="dis.name | highlight: $select.search"></div></ui-select-choices></ui-select></td><td class="w-10 text-left pt-2px"><input class="cmn-checkbx-input" type="checkbox" ng-model="v.isFullScreen"></td><td class="w-10 text-left pt-2px"><input class="cmn-checkbx-input" type="checkbox" ng-model="v.isFocused"></td><td class="w-12 text-left overflow-visible pt-5px"><a class="cursor-pointer tultip-right no-bg" ng-init="setDefaultScreen(v)"><div ng-bind-html="v.selectedScreen"></div><i class="fa fa-tv fs-18px txt-clr-14 tvhvr" ng-if="!v.selectedScreen"></i><div class="tultiptext overflow-auto tt-white lingrd-1" style="left: 40% !important;"><div class="w-340px"><div class="w-100 d-flex mb-5px mt-5px"><div id="screen1" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0,\'L1-1\')" ng-class="{\'screen-select\':v.layout==\'L1-1\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0.5,\'L1-2\')" ng-class="{\'screen-select\':v.layout==\'L1-2\'}"></div></div></div><div id="screen2" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-8 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.66,0,0,\'L2-1\')" ng-class="{\'screen-select\':v.layout==\'L2-1\'}"></div></div><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L2-2\')" ng-class="{\'screen-select\':v.layout==\'L2-2\'}"></div></div></div><div id="screen3" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0,\'L3-1\')" ng-class="{\'screen-select\':v.layout==\'L3-1\'}"></div></div><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0.33,\'L3-2\')" ng-class="{\'screen-select\':v.layout==\'L3-2\'}"></div></div><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L3-3\')" ng-class="{\'screen-select\':v.layout==\'L3-3\'}"></div></div></div></div><div class="w-100 d-flex my-2px"><div id="screen4" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0,\'L4-1\')" ng-class="{\'screen-select\':v.layout==\'L4-1\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px mb-4px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L4-2\')" ng-class="{\'screen-select\':v.layout==\'L4-2\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L4-3\')" ng-class="{\'screen-select\':v.layout==\'L4-3\'}"></div></div></div><div id="screen5" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px mb-4px" ng-click="setDisplay(v,0.5,0.5,0,0,\'L5-1\')" ng-class="{\'screen-select\':v.layout==\'L5-1\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px" ng-click="setDisplay(v,0.5,0.5,0.5,0,\'L5-2\')" ng-class="{\'screen-select\':v.layout==\'L5-2\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px mb-4px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L5-3\')" ng-class="{\'screen-select\':v.layout==\'L5-3\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L5-4\')" ng-class="{\'screen-select\':v.layout==\'L5-4\'}"></div></div></div><div id="screen6" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-3 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.25,0,0,\'L6-1\')" ng-class="{\'screen-select\':v.layout==\'L6-1\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0.25,\'L6-2\')" ng-class="{\'screen-select\':v.layout==\'L6-2\'}"></div></div><div class="col-sm-3 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.25,0,0.75,\'L6-3\')" ng-class="{\'screen-select\':v.layout==\'L6-3\'}"></div></div></div></div></div></div></a></td><td class="w-15 text-left pt-5px d-none"><input type="number" class="blk-input form-control" ng-model="v.width"></td><td class="w-15 text-left pt-5px d-none"><input type="number" class="blk-input form-control" ng-model="v.height"></td><td class="w-15 text-left pt-5px d-none"><input type="number" class="blk-input form-control" ng-model="v.top"></td><td class="w-15 text-left pt-5px d-none"><input type="number" class="blk-input form-control" ng-model="v.left"></td><td class="w-15 text-left pt-2px"><a class="cursor-pointer" title="Preview" ng-click="DisplayPreview(v)"><i class="fa fa-eye fs-18px txt-clr-14"></i></a></td></tr></tbody></table></div><div class="clearfix"></div><div class="col-md-12 py-10px"><button type="submit" ng-click="SavePreference()" class="btn btn-primary">Save</button></div></div><div class="bor-rad-4px bg-clr-31 mx-10px p-5px-all"><div class="usr-prf-heading"><h1 class="fs-14px fw-600 px-15px py-10px m-0">Display Settings</h1></div><div class="row mx-0 mb-5px" ng-show="IsDisPref"><div class="col-xs-12 col-sm-6 col-md-2 mb-10px" ng-repeat="v in DisplaySetting.PreferenceValue track by $index"><div class="bor-rad-4px bg-clr-31" style="border: 1px solid #606060;"><div class="usr-prf-heading d-flex align-item-center" style="border-bottom: 1px solid #606060;"><h1 class="fs-14px fw-600 px-15px py-10px m-0">{{SetDicomViewerText(v.viewer)}}</h1><a class="cursor-pointer pull-right mr-10px" title="Preview" ng-click="DisplayPreview(v)"><i class="fa fa-eye fs-18px txt-clr-14"></i></a></div><div class="usr-prf-content py-10px"><div class="mx-10px"><ui-select class="mult-select mb-10px" ng-model="v.display" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Display" tooltip-placement="auto top" ng-required="true" ng-change="setDisplayValue(v)" ng-init="setDefaultDisplay(v)"><ui-select-match placeholder="Choose a Display" allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="dis in Display | propsFilter: {name: $select.search}" position="down"><div ng-bind-html="dis.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="row m-0"><div class="col-md-6"><input class="cmn-checkbx-input" type="checkbox" ng-model="v.isFullScreen"> <span class="pt-3px">Full Screen</span></div><div class="col-md-6"><input class="cmn-checkbx-input" type="checkbox" ng-model="v.isFocused"> <span class="pt-3px">Focused</span></div></div><div class="p-10px-all"><a class="cursor-pointer tultip-bottom no-bg"><div class="h-150px d-flex align-item-center" style="border: 1px solid #606060; justify-content:center" ng-if="!v.layout || v.layout==\'\'"><i class="fa fa-tv fs-30px txt-clr-14 tvhvr"></i></div><div id="cardscreen1" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L1-1\' || v.layout==\'L1-2\'"><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.5,0,0,\'L1-1\')" ng-class="{\'screen-select\':v.layout==\'L1-1\'}"></div></div><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.5,0,0.5,\'L1-2\')" ng-class="{\'screen-select\':v.layout==\'L1-2\'}"></div></div></div><div id="cardscreen2" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L2-1\' || v.layout==\'L2-2\'"><div class="col-sm-8 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.66,0,0,\'L2-1\')" ng-class="{\'screen-select\':v.layout==\'L2-1\'}"></div></div><div class="col-sm-4 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L2-2\')" ng-class="{\'screen-select\':v.layout==\'L2-2\'}"></div></div></div><div id="cardscreen3" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L3-1\' || v.layout==\'L3-2\' || v.layout==\'L3-3\'"><div class="col-sm-4 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.33,0,0,\'L3-1\')" ng-class="{\'screen-select\':v.layout==\'L3-1\'}"></div></div><div class="col-sm-4 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.33,0,0.33,\'L3-2\')" ng-class="{\'screen-select\':v.layout==\'L3-2\'}"></div></div><div class="col-sm-4 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L3-3\')" ng-class="{\'screen-select\':v.layout==\'L3-3\'}"></div></div></div><div id="cardscreen4" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L4-1\' || v.layout==\'L4-2\' || v.layout==\'L4-3\'"><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.5,0,0,\'L4-1\')" ng-class="{\'screen-select\':v.layout==\'L4-1\'}"></div></div><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px mb-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L4-2\')" ng-class="{\'screen-select\':v.layout==\'L4-2\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px" style="height:57px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L4-3\')" ng-class="{\'screen-select\':v.layout==\'L4-3\'}"></div></div></div><div id="cardscreen5" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L5-1\' || v.layout==\'L5-2\' || v.layout==\'L5-3\'|| v.layout==\'L5-4\'"><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px mb-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0,0,\'L5-1\')" ng-class="{\'screen-select\':v.layout==\'L5-1\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0.5,0,\'L5-2\')" ng-class="{\'screen-select\':v.layout==\'L5-2\'}"></div></div><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px mb-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L5-3\')" ng-class="{\'screen-select\':v.layout==\'L5-3\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px" style="height:58px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L5-4\')" ng-class="{\'screen-select\':v.layout==\'L5-4\'}"></div></div></div><div id="cardscreen6" class="w-100 h-150px row m-0 p-8px-all desktopbg" ng-if="v.layout==\'L6-1\' || v.layout==\'L6-2\' || v.layout==\'L6-3\'"><div class="col-sm-3 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.25,0,0,\'L6-1\')" ng-class="{\'screen-select\':v.layout==\'L6-1\'}"></div></div><div class="col-sm-6 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.5,0,0.25,\'L6-2\')" ng-class="{\'screen-select\':v.layout==\'L6-2\'}"></div></div><div class="col-sm-3 pt-15px px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-120px" ng-click="setDisplay(v,1,0.25,0,0.75,\'L6-3\')" ng-class="{\'screen-select\':v.layout==\'L6-3\'}"></div></div></div><div class="tultiptext overflow-auto tt-white lingrd-1" style="left: 50% !important; top:20% !important;"><div class="w-340px"><div class="w-100 d-flex mb-5px mt-5px"><div id="screen1" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0,\'L1-1\')" ng-class="{\'screen-select\':v.layout==\'L1-1\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0.5,\'L1-2\')" ng-class="{\'screen-select\':v.layout==\'L1-2\'}"></div></div></div><div id="screen2" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-8 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.66,0,0,\'L2-1\')" ng-class="{\'screen-select\':v.layout==\'L2-1\'}"></div></div><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L2-2\')" ng-class="{\'screen-select\':v.layout==\'L2-2\'}"></div></div></div><div id="screen3" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0,\'L3-1\')" ng-class="{\'screen-select\':v.layout==\'L3-1\'}"></div></div><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0.33,\'L3-2\')" ng-class="{\'screen-select\':v.layout==\'L3-2\'}"></div></div><div class="col-sm-4 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.33,0,0.66,\'L3-3\')" ng-class="{\'screen-select\':v.layout==\'L3-3\'}"></div></div></div></div><div class="w-100 d-flex my-2px"><div id="screen4" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0,\'L4-1\')" ng-class="{\'screen-select\':v.layout==\'L4-1\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px mb-4px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L4-2\')" ng-class="{\'screen-select\':v.layout==\'L4-2\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L4-3\')" ng-class="{\'screen-select\':v.layout==\'L4-3\'}"></div></div></div><div id="screen5" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px mb-4px" ng-click="setDisplay(v,0.5,0.5,0,0,\'L5-1\')" ng-class="{\'screen-select\':v.layout==\'L5-1\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px" ng-click="setDisplay(v,0.5,0.5,0.5,0,\'L5-2\')" ng-class="{\'screen-select\':v.layout==\'L5-2\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px mb-4px" ng-click="setDisplay(v,0.5,0.5,0,0.5,\'L5-3\')" ng-class="{\'screen-select\':v.layout==\'L5-3\'}"></div><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-28px" ng-click="setDisplay(v,0.5,0.5,0.5,0.5,\'L5-4\')" ng-class="{\'screen-select\':v.layout==\'L5-4\'}"></div></div></div><div id="screen6" class="w-33 row my-0 mx-3px p-8px-all desktopbg"><div class="col-sm-3 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.25,0,0,\'L6-1\')" ng-class="{\'screen-select\':v.layout==\'L6-1\'}"></div></div><div class="col-sm-6 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.5,0,0.25,\'L6-2\')" ng-class="{\'screen-select\':v.layout==\'L6-2\'}"></div></div><div class="col-sm-3 px-2px"><div class="b-clr-3 b-1-s bg-clr-11 bor-rad-4px h-60px" ng-click="setDisplay(v,1,0.25,0,0.75,\'L6-3\')" ng-class="{\'screen-select\':v.layout==\'L6-3\'}"></div></div></div></div></div></div></a></div></div></div></div></div></div><div class="p-10px-all"><button type="submit" ng-click="SavePreference()" class="btn btn-primary">Save</button></div></form></div><div class="tab-pane" id="SetViewer"><div class="pt-8px"><form name="DVCredform" id="DVCredform" class="" ng-submit="InsertDicomViewerCredentials(DVCredform.$valid)"><div class="row rf-filter-ui m-0 filterspace" ng-show="AddDVCredentials"><div class="col-sm-2 col-md-2 pl-0"><label class="rf-label">Site</label><ui-select class="mult-select" ng-model="InstSelected.Site" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Site" tooltip-placement="auto top"><ui-select-match placeholder="Choose a Site" allow-clear="true">{{$select.selected.Site}}</ui-select-match><ui-select-choices repeat="list in AllSites | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 pl-0"><label class="rf-label">Dicom Viewer</label><ui-select class="mult-select" ng-model="InstAddInstitution.ddlDicomViewer" tooltip-class="uibtooltipDenial" uib-tooltip="Choose a Viewer" tooltip-placement="auto top" ng-required="true"><ui-select-match placeholder="Choose a Viewer" allow-clear="true">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="dicomviewer in InstDicomViewerList | propsFilter: {Key: $select.search}" position="down"><div ng-bind-html="dicomviewer.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 pl-0"><label class="rf-label">Username</label> <input type="text" id="DVCredUsername" name="DVCredUsername" ng-model="DVCredUsername" ng-required="true" class="blk-input form-control"></div><div class="col-sm-2 col-md-2 pl-0"><label class="rf-label">Password</label> <input type="password" id="DVCredUsername" name="DVCredUsername" ng-model="DVCredPassword" ng-required="true" class="blk-input form-control"></div><div class="col-sm-4 col-md-4 pl-0"><label class="rf-label">&nbsp;</label><button type="button" class="btn btn-default rf-btn-xs mr-2" ng-click="clear();">Cancel</button> <button type="submit" class="btn btn-primary rf-btn-xs mr-2">Save</button></div></div><div ng-if="AddDVCredentials" class="bb-1-s b-clr-3 my-10px"></div></form><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr"><ui-select class="mult-select" ng-model="SelectedSite.Site" tooltip-class="uibtooltipDenial" uib-tooltip="Select a Site" tooltip-placement="auto top" ng-change="InstSiteChanged(InstSelected.Site)"><ui-select-match placeholder="Select a Site" allow-clear="true">{{$select.selected.Site}}</ui-select-match><ui-select-choices repeat="list in AllSites | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr mob-pr-0"><ui-select class="mult-select" ng-model="SelectedViewer.ddlDicomViewer" tooltip-class="uibtooltipDenial" uib-tooltip="Select a Viewer" tooltip-placement="auto top" ng-required="true"><ui-select-match placeholder="Select a Viewer" allow-clear="true">{{$select.selected.Key}}</ui-select-match><ui-select-choices repeat="dicomviewer in InstDicomViewerList | propsFilter: {Key: $select.search}" position="down"><div ng-bind-html="dicomviewer.Key | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-6 pd-lr"><button type="submit" class="btn btn-primary rf-btn-xs mr-2" ng-click="GetAllDicomViewerCredentials()">Search</button> <button type="submit" class="btn btn-default rf-btn-xs" ng-click="ClearFilter()">Clear</button></div><div class="col-lg-6 col-md-3 col-sm-3 col-xs-6 pd-lr mob-pr-0"><div class="float-right"><button type="submit" class="btn btn-primary rf-btn-xs" ng-if="!AddDVCredentials" ng-click="AddDicomViewerCredentials()">Add</button></div><div class="clearfix"></div></div></div></div><div class="common-tbl tabnrow-height-2"><table><thead><tr><th class="w-25 text-left"><a href="#" ng-click="SortFilter(\'SITE\');" class="txt-clr-16">Site <span ng-show="OrderByField == \'SITE\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="OrderByField == \'SITE\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th class="w-25 text-left"><a href="#" ng-click="SortFilter(\'VIEWERNAME\');" class="txt-clr-16">Viewer Name <span ng-show="OrderByField == \'VIEWERNAME\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="OrderByField == \'VIEWERNAME\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th class="w-25 text-left"><a href="#" ng-click="SortFilter(\'USERNAME\');" class="txt-clr-16">Username <span ng-show="OrderByField == \'USERNAME\' && !ReverseSort" class="fa fa-caret-down"></span> <span ng-show="OrderByField == \'USERNAME\' && ReverseSort" class="fa fa-caret-up"></span></a></th><th class="w-15 text-left">Password</th><th class="w-5 text-right">Action</th></tr></thead><tbody ng-class="AddDVCredentials ? \'no-h-61vh\' : \'no-h-71vh\'"><tr ng-repeat="d in DicomViewerList track by $index"><td class="w-25 text-left">{{d.Site | UpperCase}}</td><td class="w-25">{{d.ViewerName}}</td><td class="w-25">{{d.UserName}}</td><td class="w-15"><input type="password" class="blk-input form-control my-4px" readonly="" ng-model="d.Password"></td><td class="w-5 p-0"><button ng-click="LoadData(d)" class="btn btn-default txt-clr-14 border-0 my-0 py-0"><span class="glyphicon glyphicon-pencil"></span></button></td></tr></tbody></table></div><div class="common-footer newfoot mob-footer"><div class="w-75 float-left pl-8px mob-w-100"><select id="ddlPageSize" class="sing-select form-control mt-10px float-left downArrow-ie w-auto" ng-model="PageSize" ng-change="pageSizeChanged();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" boundary-links="true" total-items="TotalRows" max-size="10" items-per-page="PageSize" ng-model="PageNo" ng-change="pageChanged()" class="pagination float-left" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul><div class="clearfix"></div></div><div class="w-25 float-left text-right d-table h-50px pr-8px txt-clr-1 mob-totalrecord-text"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ DicomViewerList.length }} of {{TotalRows}}</span> Total Records</h5></div><div class="clearfix"></div></div></div></div></div></div></div></div><div ng-show="isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div>');
$templateCache.put('app/theme/components/file-viewer/template/pdfviewer.html','<nav ng-class="getNavStyle(scroll)" class="py-10px px-5px"><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3"><button ng-click="goPrevious()" title="Previous" class="nxt-pre-pdfbtn"><i class="ion-chevron-left fs-13px"></i></button><input type="text" min="1" ng-model="pageNum" ng-change="gotoPage(pageNum)" class="w-25px h-28px mr-5px ml-5px text-center fs-13px border-0 fw-600 txt-clr-3"> <button ng-click="goNext()" title="Next" class="nxt-pre-pdfbtn"><i class="ion-chevron-right fs-13px"></i></button><input type="hidden" ng-value="pageCount" id="ngPdfPageCount"></div><div class="col-lg-3 col-md-3 col-sm-3 col-xs-3"><span class="fs-13px fw-600">Page</span> <input type="text" min="1" ng-model="pageNum" ng-change="gotoPage(pageNum)" class="w-25px h-28px mr-5px ml-5px text-center fs-13px border-0 fw-600 txt-clr-3"> <span class="fw-600">/ {{pageCount}}</span></div><div class="col-lg-5 col-md-5 col-sm-5 col-xs-5"><span class="fs-13px fw-600 mr-5px">Zoom</span> <button ng-click="zoomOut();" title="Zoom Out" class="zoom-in-outpdfbtn"><span class="">-</span></button> <button ng-click="fit()" id="btnfit" title="Reset" class="w-25 h-30px no-bg fs-13px b-1-s b-clr-7 mx-5px px-0"><span class="fw-600">Reset</span></button> <button ng-click="zoomIn()" title="Zoom In" class="zoom-in-outpdfbtn"><span>+</span></button> <button ng-click="rotate();fit();" title="Rotate" class="width-26-px height-26-px no-bg prev-btn txt-clr-1 border-0" style="display:none;"><i class="fa fa-rotate-right fs-18px"></i></button></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-right"><a ng-click="$ctrl.downloadFile()" title="Download - {{$ctrl.fileName}}" ng-show="!$ctrl.isLoading" class="btn btn-link cursor-pointer"><span class="glyphicon glyphicon-save"></span></a></div><div class="clearfix"></div></nav>{{loading}}');
$templateCache.put('app/theme/components/shift-schedule/add-edit-schedule-cmp/add-edit-schedule-cmp.html','<style>\r\n    [ng-cloak] { display: none !important; }\r\n\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-chevron-up,\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-chevron-down,\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-remove {\r\n        color: #05C1A4 !important;\r\n    }\r\n\r\n    .modal .modal-dialog .modal-body span.tultiptext {\r\n        font-family: \'Open Sans\';\r\n        font-weight: 600;\r\n    }\r\n\r\n    .addedit-selectmem .modal-body {\r\n        padding: 0;\r\n    }\r\n\r\n    .modal.fade.assign-schd-modal .modal-dialog {\r\n        width: 42%;\r\n        transform: translate(0, 0%) !important;\r\n    }\r\n\r\n    .modal.fade.assign-schd-modal #AvailableRadGridDiv,\r\n    .modal.fade.assign-schd-modal #SelectedRadGridDiv {\r\n        height: 400px;\r\n    }\r\n\r\n    #addEditScheduleProviderGrid.multiSelectGridDiv {\r\n        top: unset !important;\r\n    }\r\n\r\n    .rf-filter-ui .mult-select.viewby-shift-pro {\r\n        width: 82%;\r\n        margin-left: 5px;\r\n    }\r\n\r\n    .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        box-shadow: none !important;\r\n        border: 1px solid #424242 !important;\r\n    }\r\n\r\n    .assign-schd-modal .location-tags-input tags-input .tags {\r\n        border: 1px solid #9b9b9b !important;\r\n    }\r\n\r\n    .dicomview-sites .mlp-value-box {\r\n        background: rgba(19, 136, 117, 0.3) !important;\r\n    }\r\n\r\n    .viewby-collg {\r\n        width: 10.8% !important;\r\n    }\r\n\r\n    .dos-toggle {\r\n        flex: 1;\r\n        width: 100%;\r\n        height: 30px;\r\n        border: 1px solid #05c1a4;\r\n        border-radius: 4px;\r\n        display: flex !important;\r\n        align-items: center;\r\n        justify-content: center;\r\n        position: relative;\r\n        overflow: hidden;\r\n    }\r\n\r\n        .dos-toggle input[type="radio"] {\r\n            display: none;\r\n        }\r\n\r\n        .dos-toggle .left-toggle,\r\n        .dos-toggle .right-toggle {\r\n            width: 50%;\r\n            display: flex !important;\r\n            align-items: center;\r\n            justify-content: center;\r\n            cursor: pointer;\r\n            transition: background-color 0.3s, color 0.3s;\r\n            height: 100%;\r\n            font-weight: 500;\r\n        }\r\n\r\n        .dos-toggle .separator {\r\n            width: 1px;\r\n            height: 100%;\r\n            background-color: #05c1a4;\r\n            position: absolute;\r\n            left: 50%;\r\n            transform: translateX(-50%);\r\n        }\r\n\r\n        /* Default state */\r\n        .dos-toggle .left-toggle,\r\n        .dos-toggle .right-toggle {\r\n            background-color: #323232;\r\n            color: #05c1a4;\r\n        }\r\n\r\n        /* Left toggle selected */\r\n        .dos-toggle input[type="radio"]#toggle-left:checked + label.left-toggle {\r\n            background-color: #05c1a4;\r\n            color: #fdfdfd;\r\n        }\r\n\r\n        /* Right toggle selected */\r\n        .dos-toggle input[type="radio"]#toggle-right:checked + label.right-toggle {\r\n            background-color: #05c1a4;\r\n            color: #fdfdfd;\r\n        }\r\n    /*ui calender css start*/\r\n    .blk-calender .uib-datepicker-popup {\r\n        background: #1c1c1c !important;\r\n        box-shadow: 0 3px 7px #000 !important;\r\n        border-color: #323232 !important;\r\n        padding: 1px;\r\n    }\r\n\r\n        .blk-calender .uib-datepicker-popup li {\r\n            border-radius: 2px !important;\r\n            background: #323232 !important;\r\n            border-color: transparent !important;\r\n        }\r\n\r\n        .blk-calender .uib-datepicker-popup .btn-default {\r\n            background: #323232 !important;\r\n        }\r\n\r\n        .blk-calender .uib-datepicker-popup .btn-default {\r\n            border-color: transparent !important;\r\n        }\r\n\r\n    button.btn.btn-info:hover,\r\n    button.btn.btn-info:focus,\r\n    button.btn.btn-info.focus,\r\n    button.btn.btn-info:active,\r\n    button.btn.btn-info.active {\r\n        background-color: #05c1a4 !important;\r\n        border-radius: 4px !important;\r\n        border: 0 !important;\r\n    }\r\n\r\n    .text-info, .modal .modal-dialog .modal-body span.text-info {\r\n        color: #05c1a4 !important;\r\n    }\r\n\r\n    .btn-info.active .text-info, .modal .modal-dialog .modal-body .btn-info.active span.text-info {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .uib-daypicker .btn-primary:focus, .uib-daypicker .btn-default:focus {\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    tr.uib-weeks td, .uib-daypicker th {\r\n        color: #fff;\r\n        line-height: 24px;\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n    }\r\n\r\n        .uib-daypicker th .btn {\r\n            font-size: 12px !important;\r\n        }\r\n    /*ui calender css end*/\r\n    .multiselect-tooltip.tultip-bottom .tultiptext {\r\n        top: 100%;\r\n    }\r\n    .modal .modal-dialog .modal-body .multiselect-tooltip.tultip-bottom .tultiptext {\r\n        max-height: 320px;\r\n    }\r\n\r\n    /* \u2500\u2500 Schedule filter layout \u2500\u2500 */\r\n    .sched-filter-row {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        align-items: center;\r\n        gap: 6px;\r\n        padding: 8px 0 4px;\r\n    }\r\n    .sched-filter-item {\r\n        flex: 1 1 0;\r\n        min-width: 0;\r\n        max-width: 200px;\r\n        padding: 0 4px;\r\n        box-sizing: border-box;\r\n    }\r\n    .sched-filter-viewby {\r\n        flex: 0 0 auto;    /* fixed size \u2014 holds "View By:" + toggle */\r\n        min-width: 165px;\r\n        padding: 0 4px;\r\n    }\r\n    .sched-btn-group {\r\n        flex: 0 0 auto;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n        margin-left: auto;\r\n        padding: 0 4px;\r\n    }\r\n    @media only screen and (max-width: 1400px) {\r\n        .sched-btn-group {\r\n            flex: 1 1 100%;\r\n            margin-left: 0;\r\n            padding: 4px 4px 8px;\r\n        }\r\n    }\r\n\r\n    @media only screen and (min-width: 768px) and (max-width: 1200px) {\r\n        .rf-filter-ui .mult-select.viewby-shift-pro {\r\n            width: 66%;\r\n        }\r\n        .modal.fade.assign-schd-modal .modal-dialog {\r\n            width: 60%;\r\n        }\r\n        .modal .modal-dialog .modal-body .multiselect-tooltip.tultip-bottom .tultiptext {\r\n            max-height: 320px;\r\n            left: 53% !important;\r\n        }\r\n    }\r\n\r\n    .no-schedule-empty-state {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: calc(100vh - 160px);\r\n        gap: 14px;\r\n    }\r\n    .no-schedule-empty-state .no-schedule-icon {\r\n        font-size: 48px;\r\n        color: #555;\r\n    }\r\n    .no-schedule-empty-state .no-schedule-title {\r\n        font-size: 16px;\r\n        color: #ccc;\r\n        font-weight: 500;\r\n        letter-spacing: 0.4px;\r\n    }\r\n</style><div class="radf-header"><h2>Schedule</h2></div><div class="rf-filter-ui m-0 filterspace" ng-cloak=""><div class="sched-filter-row"><div class="sched-filter-viewby d-flex align-item-center"><label class="rf-label m-0 mr-10px" style="margin-top:3px !important; white-space:nowrap; font-size:11px;">View By:</label><div class="dos-toggle" style="min-width:100px;"><input type="radio" ng-model="DataObject.Filter.DisplayType" id="toggle-left" name="toggle" value="Provider" checked=""> <label for="toggle-left" class="left-toggle m-0" style="font-size:10px;">Provider</label> <input type="radio" ng-model="DataObject.Filter.DisplayType" id="toggle-right" name="toggle" value="Shift"> <label for="toggle-right" class="right-toggle m-0" style="font-size:10px;">Shift</label><div class="separator"></div></div></div><div class="sched-filter-item"><ui-select class="mult-select" ng-model="DataObject.Filter.SelectedTenant" ng-change="OnTenantChanged()"><ui-select-match placeholder="Select Tenant">{{$select.selected.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantList | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="sched-filter-item tultip-bottom multiselect-tooltip" ng-if="DataObject.UserRoles.includes(\'Scheduler\')"><multi-select master-data="DataObject.multiSelect.FilterScheduleProviders" list="DataObject.ProvidersList" ng-model="DataObject.multiSelect.FilterScheduleProviders.SelectedValue" on-change="DataObject.multiSelect.FilterScheduleProviders.onChange(selectedData)"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px" style="z-index:999;">{{DataObject.multiSelect.FilterScheduleProviders.SelectedValue.list.length>0?(DataObject.multiSelect.FilterScheduleProviders.tooltip):"Select Provider(s)"}}</span></div><div class="sched-filter-item tultip-bottom multiselect-tooltip"><multi-select master-data="DataObject.multiSelect.FilterByShifts" list="DataObject.ShiftConfigList" ng-model="DataObject.multiSelect.FilterByShifts.SelectedValue" on-change="DataObject.multiSelect.FilterByShifts.onChange(selectedData)" on-search="GetShiftConfigurationsMultiSelect(searchObj)" search-delay="500"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px" style="z-index:999;">{{DataObject.multiSelect.FilterByShifts.SelectedValue.list.length>0?(DataObject.multiSelect.FilterByShifts.tooltip):"Select Shift(s)"}}</span></div><div class="sched-filter-item tultip-bottom multiselect-tooltip"><multi-select master-data="DataObject.multiSelect.ShiftClassificationFilter" list="DataObject.ShiftClassificationList" ng-model="DataObject.multiSelect.ShiftClassificationFilter.SelectedValue" on-change="DataObject.multiSelect.ShiftClassificationFilter.onChange(selectedData)"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white tt-top" style="top:54px;">{{(DataObject.multiSelect.ShiftClassificationFilter.SelectedValue && DataObject.multiSelect.ShiftClassificationFilter.SelectedValue.list && DataObject.multiSelect.ShiftClassificationFilter.SelectedValue.list.length>0)?DataObject.multiSelect.ShiftClassificationFilter.tooltip:\'Select Classification\'}}</span></div><div class="sched-filter-item"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="Select Date Range" ng-model="DataObject.Filter.SelectedDate" options="DOSopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{DataObject.Filter.dateRangeTooltip}}" tooltip-placement="auto top"></div><div class="sched-btn-group"><button class="btn btn-primary rf-btn-xs" ng-click="GetShiftScheduleCalendar()">Search</button> <button class="btn btn-default rf-btn-xs" ng-click="Clear()">Clear</button> <button ng-click="Export()" class="btn btn-primary rf-btn-xs" ng-show="DataObject.UserRoles.includes(\'Admin\')" ng-disabled="isExporting" tooltip-class="uibtooltipDenial" uib-tooltip="Export" tooltip-placement="auto top"><i ng-class="isExporting ? \'fa fa-spinner fa-spin\' : \'fa fa-share-square-o fs-15px\'"></i></button> <button type="submit" class="btn btn-primary rf-btn-xs" ng-click="showUserScheduleModal()" ng-show="DataObject.UserRoles.includes(\'Scheduler\')">Assign Schedule</button></div></div></div><div style="padding:0 0px !important"><schedule-calendar ng-show="DataObject.ScheduleList && DataObject.ScheduleList.length > 0" selected-date="DataObject.Filter.SelectedDate" shift-config-list="DataObject.ShiftConfigList" shift-classification-list="DataObject.ShiftClassificationList" schedule-list="DataObject.ScheduleList" display-type="DataObject.Filter.DisplayType" selected-tenant="DataObject.Filter.SelectedTenant" get-shift-schedule-calendar="GetShiftScheduleCalendar()" ng-class="{\'set-addeditscdgrid-height\' : DataObject.multiSelect.FilterScheduleProviders.SelectedValue.list.length > 0 || DataObject.multiSelect.FilterByShifts.SelectedValue.list.length > 0|| DataObject.multiSelect.ShiftClassificationFilter.SelectedValue.list.length > 0}"></schedule-calendar><div class="no-schedule-empty-state" ng-show="DataObject.ScheduleList !== null && DataObject.ScheduleList.length === 0 && !DataObject.scheduleLoadError"><i class="glyphicon glyphicon-calendar no-schedule-icon"></i> <span class="no-schedule-title">No schedule available</span></div></div><div class="modal fade new-popup assign-schd-modal" id="AssignScheduleModal" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog comment-width assign-user-modal w-600px" role="document"><div class="modal-content"><div class="modal-header p-0-625-all border-0"><button type="button" class="close otln-0" aria-label="Close" data-dismiss="modal" ng-click="ClearAddEditScheduleData()">&times;</button><h4 class="modal-title">Assign Schedule</h4></div><div class="modal-body"><form name="frmSchedule" id="frmSchedule"><div class="width-inherit height-inherit"><div class="gc-content"><div class="row mb-10px"><div class="col-lg-12 col-md-12 col-sm-12"><div style="display:flex; align-items:center; gap:8px;"><span class="rf-label m-0" style="white-space:nowrap; flex-shrink:0;">Tenant:</span> <span style="font-weight:700; color:#05C1A4; font-size:13px; background:rgba(5,193,164,0.1); border:1px solid rgba(5,193,164,0.35); border-radius:4px; padding:3px 12px; letter-spacing:0.2px; white-space:nowrap;">{{DataObject.Filter.SelectedTenant.DisplayName}}</span></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 mb-10px"><label class="rf-label">Shift <span>*</span></label><ui-select class="mult-select" ng-model="DataObject.addEditSchedule.Shift" ng-required="true" ng-change="onShiftSelectionChanged()" required=""><ui-select-match placeholder="Select Shift" allow-clear="true">{{$select.selected.ShiftName}}</ui-select-match><ui-select-choices repeat="shift in DataObject.ShiftConfigList | filter:{ShiftName: $select.search}" position="down" refresh="GetShiftConfigurations($select.search)" refresh-delay="500"><div ng-bind-html="shift.ShiftName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-12 col-md-12 col-sm-12 mb-10px multiselect-tooltip tultip-bottom"><label class="rf-label">Select Providers <span>*</span></label><multi-select master-data="DataObject.multiSelect.addEditScheduleProviders" list="DataObject.ProvidersList" ng-model="DataObject.multiSelect.addEditScheduleProviders.SelectedValue" on-change="DataObject.multiSelect.addEditScheduleProviders.onChange(selectedData)" required=""></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px" style="z-index:999;">{{DataObject.multiSelect.addEditScheduleProviders.SelectedValue.list.length>0?(DataObject.multiSelect.addEditScheduleProviders.tooltip):"Select Provider(s)"}}</span></div><div class="col-lg-12 col-md-12 col-sm-12 mb-10px multiselect-tooltip tultip-bottom"><label class="rf-label">Shift Classification</label><ui-select class="mult-select" ng-model="DataObject.addEditSchedule.ShiftClassification"><ui-select-match placeholder="Select Shift Classification" allow-clear="true">{{$select.selected.ShiftClassificationName}}</ui-select-match><ui-select-choices repeat="classfication in DataObject.ShiftClassificationList | filter:{ShiftClassificationName: $select.search}" position="down"><div ng-bind-html="classfication.ShiftClassificationName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-12 col-md-12 col-sm-12 mb-10px"><label class="rf-label">Date <span>*</span></label><div class="input-group blk-calender mb-0"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="DataObject.addEditSchedule.selectedDate" is-open="DataObject.addEditSchedule.isSelectedDateOpen" readonly="" datepicker-options="DataObject.dateSearchOptions" ng-required="true" close-text="Close" placeholder="Select Date" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="DataObject.addEditSchedule.isSelectedDateOpen = true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-6"><label class="rf-label">From Time <span>*</span></label><div class="input-group mb-0 w-60"><uib-timepicker class="rf-timepick" id="FromTime" name="FromTime" ng-model="DataObject.addEditSchedule.StartTime" hour-step="1" minute-step="1" show-meridian="false" required=""></uib-timepicker></div></div><div class="col-lg-6 col-md-6 col-sm-6"><label class="rf-label">To Time <span>*</span></label><div class="input-group mb-0 w-60"><uib-timepicker class="rf-timepick" id="ToTime" name="ToTime" ng-model="DataObject.addEditSchedule.EndTime" hour-step="1" minute-step="1" show-meridian="false" required=""></uib-timepicker></div></div></div><div class="row mb-10px"><div class="col-lg-4 col-md-4 col-sm-4"><label class="rf-label">Shift Pay Amount <span>*</span></label> <input type="number" min="0" step="0.01" class="blk-input form-control" placeholder="Enter Shift Pay Amount" ng-model="DataObject.addEditSchedule.ShiftPayAmount" ng-required="true" required=""></div><div class="col-lg-4 col-md-4 col-sm-4"><label class="rf-label">Price per Excess wRVU</label> <input type="number" min="0" step="0.01" class="blk-input form-control" placeholder="Price per Excess wRVU" ng-model="DataObject.addEditSchedule.PricePerExcessRVU"></div><div class="col-lg-4 col-md-4 col-sm-4"><label class="rf-label">Minimum wRVU per hour</label> <input type="number" min="0" step="0.01" class="blk-input form-control" placeholder="Minimum wRVU per hour" ng-model="DataObject.addEditSchedule.MinimumWRVUPerHour"></div></div><div class="row py-10px"><div class="col-lg-12 d-flex justify-content-end"><button class="btn btn-default mr-5px" data-dismiss="modal" ng-click="ClearAddEditScheduleData()">Cancel</button> <button type="submit" class="btn btn-primary btn-sm fs-13px float-right" ng-click="AssignSchdeule()" ng-disabled="frmSchedule.$invalid ||(!DataObject.multiSelect.addEditScheduleProviders.SelectedValue || !DataObject.multiSelect.addEditScheduleProviders.SelectedValue.list || DataObject.multiSelect.addEditScheduleProviders.SelectedValue.list.length <= 0) || DataObject.addEditSchedule.isSaveBtnDisabled">Save</button><div class="clearfix"></div></div></div></div></div></form></div></div></div></div>');
$templateCache.put('app/theme/components/shift-schedule/schedule-calendar/schedule-calendar.html','<style>\r\n    #EventCalendar .ec-body::-webkit-scrollbar {\r\n        width: 12px;\r\n    }\r\n\r\n    #EventCalendar .ec-body::-webkit-scrollbar-track {\r\n        background: #2e2e2e; /* Dark track */\r\n    }\r\n\r\n    #EventCalendar .ec-body::-webkit-scrollbar-thumb {\r\n        background-color: #2e2e2e; /* Light gray thumb */\r\n        border-radius: 6px;\r\n        border: 2px solid #2e2e2e; /* Matches track */\r\n    }\r\n\r\n    .dicomview-sites {\r\n        margin-top: 3px;\r\n        margin-bottom: 1px;\r\n        max-height: 500px;\r\n        overflow-y: auto;\r\n        overflow-x: hidden;\r\n    }\r\n\r\n    .mlp-value-box {\r\n        width: 100%;\r\n        display: inline-block;\r\n        white-space: pre-line !important;\r\n        line-height: 14px;\r\n        margin: 0 0 4px;\r\n        letter-spacing: 0.4px;\r\n        /*background-color: #434343 !important;*/\r\n        padding-bottom: 4px !important;\r\n        padding: 10px 10px !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr {\r\n        width: 100%;\r\n    }\r\n\r\n    .set-addeditscdgrid-height .agrgid-schdcalndr {\r\n        width: 100%;\r\n    }\r\n\r\n    .sched-calendar-scroll-wrapper {\r\n        overflow-x: auto;\r\n        overflow-y: auto;\r\n        max-height: calc(100vh - 113px);\r\n    }\r\n\r\n    .set-addeditscdgrid-height .sched-calendar-scroll-wrapper {\r\n        max-height: calc(100vh - 141px);\r\n    }\r\n\r\n    @media only screen and (min-width: 768px) and (max-width: 1200px) {\r\n        .sched-calendar-scroll-wrapper {\r\n            max-height: calc(100vh - 150px);\r\n        }\r\n        .set-addeditscdgrid-height .sched-calendar-scroll-wrapper {\r\n            max-height: calc(100vh - 178px);\r\n        }\r\n    }\r\n\r\n    .sched-calendar-scroll-wrapper::-webkit-scrollbar {\r\n        height: 8px;\r\n    }\r\n\r\n    .sched-calendar-scroll-wrapper::-webkit-scrollbar-track {\r\n        background: #1c1c1c;\r\n    }\r\n\r\n    .sched-calendar-scroll-wrapper::-webkit-scrollbar-thumb {\r\n        background-color: #555;\r\n        border-radius: 4px;\r\n        border: 2px solid #1c1c1c;\r\n    }\r\n\r\n    .sched-calendar-scroll-wrapper::-webkit-scrollbar-thumb:hover {\r\n        background-color: #05c1a4;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-ltr .ag-body {\r\n        background: #2e2e2e !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-ltr .ag-cell {\r\n        background: #2e2e2e !important;\r\n        /*border-right: 1px solid #1f1f1f;*/\r\n        border-right: 1px solid #1c1c1c;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-row {\r\n        /*border-bottom-color: rgba(92, 92, 92, 0.5) !important;*/\r\n        border-bottom-color: #1c1c1c !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-header-cell {\r\n        border-right: 1px solid #424242;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-header-cell-label, .agrgid-schdcalndr .ag-header-group-cell-label {\r\n        color: #fff !important;\r\n        font-weight: 400 !important;\r\n        font-size: 14px !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr ag-cell-value, .agrgid-schdcalndr .ag-group-value {\r\n        line-height: 16px;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-header-cell:after, .agrgid-schdcalndr .ag-header-group-cell:after,\r\n    .ag-pinned-left-header::after {\r\n        /*background-color: rgb(5 193 164) !important;*/\r\n        background-color: none !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-header-row .ag-header-cell:last-child::after,\r\n    .agrgid-schdcalndr .ag-header-row .ag-header-group-cell:last-child:after {\r\n        background-color: transparent !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-cell-value {\r\n        line-height: 16px;\r\n        margin-top: 3px;\r\n        margin-bottom: 3px;\r\n        word-break: break-word;\r\n    }\r\n    /*.agrgid-schdcalndr .ag-row .ag-cell:first-child {\r\n        background: #242424 !important;\r\n    }*/\r\n    .agrgid-schdcalndr .ag-row .ag-cell {\r\n        background: #343434 !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-pinned-left-cols-container .ag-row-even .ag-cell {\r\n        background: #2e2e2e !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-pinned-left-cols-container .ag-row-odd .ag-cell {\r\n        background: #242424 !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-pinned-left-cols-container .ag-row .ag-cell {\r\n        border-right-color: #000 !important;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-pinned-left-header {\r\n        border-right: 0;\r\n        position: relative;\r\n    }\r\n    /*.agrgid-schdcalndr .ag-pinned-left-header::after {\r\n        content: \'\';\r\n        position: absolute;\r\n        top: 8px;\r\n        right: 0;\r\n        width: 1px;\r\n        height: 16px;\r\n        background: #05c1a4;\r\n    }*/\r\n    .ssch-datwrapper {\r\n        line-height: 23px;\r\n    }\r\n\r\n    .agrgid-schdcalndr .ag-overlay-no-rows-wrapper {\r\n        background: rgba(20, 20, 20, 0.65);\r\n        backdrop-filter: blur(4px);\r\n        -webkit-backdrop-filter: blur(4px);\r\n    }\r\n\r\n    .ag-status-bar {\r\n        display: none !important;\r\n    }\r\n\r\n    @media only screen and (min-width: 768px) and (max-width: 1200px) {\r\n        .mlp-value-box {\r\n            padding-bottom: 4px !important;\r\n        }\r\n    }\r\n</style><div><div class="sched-calendar-scroll-wrapper"><div id="ScheduleCalendarGrid" class="ag-theme-balham-dark w-100 agrgid-schdcalndr"></div></div></div><div class="modal fade new-popup" id="addEditScheduleCalendar" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog comment-width" role="document"><div class="modal-content"><div class="modal-header p-0-625-all border-0"><button type="button" class="close otln-0" aria-label="Close" data-dismiss="modal" ng-click="ClearAddEditScheduleData()">&times;</button><h4 class="modal-title">Edit Schedule</h4></div><div class="modal-body"><form name="frmShifts" id="frmShifts" novalidate="" ng-submit="$event.preventDefault()"><div class="width-inherit height-inherit"><div class="gc-content"><div class="row mb-10px" ng-if="DataObject.SelectedTenant"><div class="col-lg-12"><div style="display:flex; align-items:center; gap:8px;"><span class="rf-label m-0" style="white-space:nowrap; flex-shrink:0;">Tenant:</span> <span style="font-weight:700; color:#05C1A4; font-size:13px; background:rgba(5,193,164,0.1); border:1px solid rgba(5,193,164,0.35); border-radius:4px; padding:3px 12px; letter-spacing:0.2px; white-space:nowrap;">{{DataObject.SelectedTenant.DisplayName}}</span></div></div></div><div class="row"><div class="col-lg-12 mb-10px"><label class="rf-label">Shift Name <span class="txt-clr-6">*</span></label><ui-select class="mult-select" ng-model="DataObject.addEditSchedule.Shift" ng-required="true"><ui-select-match placeholder="Select Shift" allow-clear="true">{{$select.selected.ShiftName || $select.selected.shiftName || DataObject.addEditSchedule.ShiftNameFallback}}</ui-select-match><ui-select-choices repeat="shift in DataObject.ShiftConfigList | filter: $select.search" position="down"><div ng-bind-html="(shift.ShiftName || shift.shiftName) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-12 mb-10px"><label class="rf-label">Shift Classification</label><ui-select class="mult-select" ng-model="DataObject.addEditSchedule.ShiftClassification"><ui-select-match placeholder="Select Shift Classification" allow-clear="true">{{$select.selected.ShiftClassificationName || $select.selected.shiftClassificationName}}</ui-select-match><ui-select-choices repeat="classfication in DataObject.ShiftClassificationList | filter: $select.search" position="down"><div ng-bind-html="(classfication.ShiftClassificationName || classfication.shiftClassificationName) | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row mb-10px"><div class="col-lg-12"><label class="rf-label">Date <span>*</span></label><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="DataObject.addEditSchedule.StartDate" is-open="DataObject.addEditSchedule.isStartDateOpen" readonly="" datepicker-options="DataObject.dateSearchOptions" ng-required="true" close-text="Close" placeholder="Start Date" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="DataObject.addEditSchedule.isStartDateOpen = true;"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row mb-10px"><div class="col-lg-6 col-md-6 col-sm-6"><div class="col-lg-12" style="padding-left:0px;"><div class="col-lg-8 col-md-8 col-sm-8" style="padding-left:0px;"><label class="rf-label">Start Time <span>*</span></label><div class="input-group mb-0"><uib-timepicker class="rf-timepick" id="StartTime" name="StartTime" ng-model="DataObject.addEditSchedule.StartTime" show-meridian="false"></uib-timepicker></div></div></div></div><div class="col-lg-6 col-md-6 col-sm-6"><div class="col-lg-12" style="padding-left:0px;"><div class="col-lg-8 col-md-8 col-sm-8" style="padding-left:0px;"><label class="rf-label">End Time <span class="txt-clr-6">*</span></label><div class="input-group"><uib-timepicker class="rf-timepick" id="EndTime" name="EndTime" ng-model="DataObject.addEditSchedule.EndTime" show-meridian="false"></uib-timepicker></div></div></div></div></div><div class="row mb-10px"><div class="col-lg-4 col-md-4 col-sm-4"><label class="rf-label">Shift Pay Amount <span>*</span></label> <input type="number" min="0" step="0.01" class="blk-input form-control" placeholder="Enter Shift Pay Amount" ng-model="DataObject.addEditSchedule.ShiftPayAmount" ng-required="true" required=""></div><div class="col-lg-4 col-md-4 col-sm-4"><label class="rf-label">Price per Excess wRVU</label> <input type="number" min="0" step="0.01" class="blk-input form-control" placeholder="Price per Excess wRVU" ng-model="DataObject.addEditSchedule.PricePerExcessRVU"></div><div class="col-lg-4 col-md-4 col-sm-4"><label class="rf-label">Minimum wRVU per hour</label> <input type="number" min="0" step="0.01" class="blk-input form-control" placeholder="Minimum wRVU per hour" ng-model="DataObject.addEditSchedule.MinimumWRVUPerHour"></div></div><div class="row py-10px"><div class="col-lg-12 d-flex justify-content-end"><button class="btn btn-default mr-5px" data-dismiss="modal" ng-click="ClearAddEditScheduleData()">Cancel</button> <button type="button" style="margin-right:5px;" class="btn btn-primary btn-sm fs-13px" ng-disabled="frmShifts.$invalid" ng-click="SetShiftSchedule()">Save</button></div></div></div></div></form></div></div></div></div>');
$templateCache.put('app/theme/components/shift-schedule/schedule-setting-cmp/schedule-setting-cmp.html','<style>\r\n    .mr-15px {\r\n        margin-right: 15px;\r\n    }\r\n\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-chevron-up,\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-chevron-down,\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-remove {\r\n        color: #05C1A4 !important;\r\n    }\r\n\r\n    .shift-schedule-grid {\r\n        height: calc(100vh - 110px);\r\n    }\r\n\r\n    tr.uib-weeks td, .uib-daypicker th {\r\n        color: #fff;\r\n    }\r\n    /*ui calender css start*/\r\n    .blk-calender .uib-datepicker-popup {\r\n        background: #1c1c1c !important;\r\n        box-shadow: 0 3px 7px #000 !important;\r\n        border-color: #323232 !important;\r\n        padding: 1px;\r\n    }\r\n\r\n        .blk-calender .uib-datepicker-popup li {\r\n            border-radius: 2px !important;\r\n            background: #323232 !important;\r\n            border-color: transparent !important;\r\n        }\r\n\r\n        .blk-calender .uib-datepicker-popup .btn-default {\r\n            background: #323232 !important;\r\n        }\r\n\r\n        .blk-calender .uib-datepicker-popup .btn-default {\r\n            border-color: transparent !important;\r\n        }\r\n\r\n    button.btn.btn-info:hover,\r\n    button.btn.btn-info:focus,\r\n    button.btn.btn-info.focus,\r\n    button.btn.btn-info:active,\r\n    button.btn.btn-info.active {\r\n        background-color: #05c1a4 !important;\r\n        border-radius: 4px !important;\r\n        border: 0 !important;\r\n    }\r\n\r\n    .text-info, .modal .modal-dialog .modal-body span.text-info {\r\n        color: #05c1a4 !important;\r\n    }\r\n\r\n    .btn-info.active .text-info, .modal .modal-dialog .modal-body .btn-info.active span.text-info {\r\n        color: #fff !important;\r\n    }\r\n\r\n    .uib-daypicker .btn-primary:focus, .uib-daypicker .btn-default:focus {\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    tr.uib-weeks td, .uib-daypicker th {\r\n        color: #fff;\r\n        line-height: 24px;\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n    }\r\n\r\n        .uib-daypicker th .btn {\r\n            font-size: 12px !important;\r\n        }\r\n    /*ui calender css end*/\r\n</style><div class=""><div class=""><div class="radf-header"><h2>Schedule Setting</h2></div></div><div class="row rf-filter-ui m-0 pt-8px filterspace"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-4 pd-lr"><ui-select class="mult-select" ng-model="DataObject.Filter.SelectedTenant" ng-change="OnTenantChanged()"><ui-select-match placeholder="Select Tenant">{{$select.selected.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantList | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-4 pd-lr"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="Select Date Range" ng-model="DataObject.Filter.SelectedDate" options="DOSopts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial datefield-tt" uib-tooltip="{{DataObject.Filter.dateRangeTooltip}}" tooltip-placement="auto top"></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-4 pd-lr"><input type="text" name="note" class="blk-input form-control" placeholder="Search by Provider, Shift & Classification" ng-model="DataObject.Filter.SearchKey" maxlength="150"></div><div class="col-lg-1 col-md-2 col-sm-2 col-xs-4 pd-lr"><button type="submit" ng-click="Search()" class="btn btn-primary rf-btn-xs mr-4px">Filter</button> <button type="submit" ng-click="ClearFilter()" class="btn btn-default rf-btn-xs">Clear</button></div><div class="col-lg-1 col-md-2 col-sm-2 col-xs-4 pd-lr pull-right"><button type="submit" data-target="#ScheduleModal" data-toggle="modal" ng-click="addSchedule()" class="btn btn-primary rf-btn-xs pull-right">Add Schedule</button></div></div><div class=""><div id="ScheduleSettingGrid" class="ag-theme-balham-dark w-100 shift-schedule-grid"></div></div></div><div class="modal fade new-popup" id="ScheduleModal" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog comment-width" role="document"><div class="modal-content"><div class="modal-header p-0-625-all border-0"><button type="button" class="close otln-0" aria-label="Close" data-dismiss="modal" ng-click="ClearAddEditScheduleData()">&times;</button><h4 class="modal-title">{{DataObject.addEditSchedule.ShiftScheduleID?"Edit":"Add"}} Schedule</h4></div><div class="modal-body"><form name="frmShifts" id="frmShifts"><div class="width-inherit height-inherit"><div class="gc-content"><div class="row mb-10px"><div class="col-lg-12"><div style="display:flex; align-items:center; gap:8px;"><span class="rf-label m-0" style="white-space:nowrap; flex-shrink:0;">Tenant:</span> <span style="font-weight:700; color:#05C1A4; font-size:13px; background:rgba(5,193,164,0.1); border:1px solid rgba(5,193,164,0.35); border-radius:4px; padding:3px 12px; letter-spacing:0.2px; white-space:nowrap;">{{DataObject.Filter.SelectedTenant.DisplayName}}</span></div></div></div><div class="row mb-10px"><div class="col-lg-12"><label class="rf-label">Provider Name <span>*</span></label><ui-select class="mult-select" ng-model="DataObject.addEditSchedule.Provider" ng-required="true" required=""><ui-select-match placeholder="Select Provider" allow-clear="true">{{$select.selected.LastName}}, {{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="provider in DataObject.ProvidersList | filter: $select.search" position="down"><div ng-bind-html="provider.LastName + \', \' + provider.FirstName | highlight: $select.search"></div><small><span ng-if="provider.Email.length>0"><i class="fa fa-envelope"></i> {{provider.Email}}<br></span> <span ng-if="provider.PhoneNumber.length>0"><i class="fa fa-phone-square"></i> {{provider.PhoneNumber}}</span></small></ui-select-choices></ui-select></div></div><div class="row mb-10px"><div class="col-lg-12"><label class="rf-label">Shift Name <span class="txt-clr-6">*</span></label><ui-select class="mult-select" ng-model="DataObject.addEditSchedule.Shift" ng-change="onShiftSelectionChanged()" ng-required="true" required=""><ui-select-match placeholder="Select Shift" allow-clear="true">{{$select.selected.ShiftName || $select.selected.shiftName || DataObject.addEditSchedule.ShiftNameFallback}}</ui-select-match><ui-select-choices repeat="shift in DataObject.ShiftConfigList | filter: $select.search" position="down" refresh="GetShiftConfigurations($select.search)" refresh-delay="500"><div ng-bind-html="(shift.ShiftName || shift.shiftName) | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row mb-10px"><div class="col-lg-12"><label class="rf-label">Shift Classification</label><ui-select class="mult-select" ng-model="DataObject.addEditSchedule.ShiftClassification"><ui-select-match placeholder="Select Shift Classification" allow-clear="true">{{$select.selected.ShiftClassificationName || $select.selected.shiftClassificationName}}</ui-select-match><ui-select-choices repeat="classfication in DataObject.ShiftClassificationList | filter: $select.search" position="down"><div ng-bind-html="(classfication.ShiftClassificationName || classfication.shiftClassificationName) | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row mb-10px"><div class="col-lg-6 col-md-6 col-sm-6"><label class="rf-label">Start Date <span>*</span></label><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="DataObject.addEditSchedule.StartDate" is-open="DataObject.addEditSchedule.isStartDateOpen" readonly="" datepicker-options="DataObject.dateSearchOptions" ng-required="true" close-text="Close" placeholder="Start Date" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="DataObject.addEditSchedule.isStartDateOpen = true;"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-6 col-md-6 col-sm-6"><label class="rf-label">End Date <span>*</span></label><div><div class="input-group blk-calender"><input type="text" class="blk-input form-control" uib-datepicker-popup="MM/dd/yyyy" ng-model="DataObject.addEditSchedule.EndDate" is-open="DataObject.addEditSchedule.isEndDateOpen" readonly="" datepicker-options="DataObject.dateSearchOptions" ng-required="true" close-text="Close" placeholder="End Date" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="DataObject.addEditSchedule.isEndDateOpen = true;"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row mb-10px"><div class="col-lg-6 col-md-6 col-sm-6"><label class="rf-label">Start Time <span>*</span></label><div class="input-group mb-0 w-60"><uib-timepicker class="rf-timepick" id="StartTime" name="StartTime" ng-model="DataObject.addEditSchedule.StartTime" show-meridian="false" required=""></uib-timepicker></div></div><div class="col-lg-6 col-md-6 col-sm-6"><label class="rf-label">End Time <span class="txt-clr-6">*</span></label><div class="input-group w-60"><uib-timepicker class="rf-timepick" id="EndTime" name="EndTime" ng-model="DataObject.addEditSchedule.EndTime" show-meridian="false" required=""></uib-timepicker></div></div></div><div class="row mb-10px"><div class="col-lg-4 col-md-4 col-sm-4"><label class="rf-label">Shift Pay Amount <span>*</span></label> <input type="number" min="0" step="0.01" class="blk-input form-control" placeholder="Enter Shift Pay Amount" ng-model="DataObject.addEditSchedule.ShiftPayAmount" ng-required="true" required=""></div><div class="col-lg-4 col-md-4 col-sm-4"><label class="rf-label">Price per Excess wRVU</label> <input type="number" min="0" step="0.01" class="blk-input form-control" placeholder="Price per Excess wRVU" ng-model="DataObject.addEditSchedule.PricePerExcessRVU"></div><div class="col-lg-4 col-md-4 col-sm-4"><label class="rf-label">Minimum wRVU per hour</label> <input type="number" min="0" step="0.01" class="blk-input form-control" placeholder="Minimum wRVU per hour" ng-model="DataObject.addEditSchedule.MinimumWRVUPerHour"></div></div><div class="row py-10px"><div class="col-lg-12 d-flex justify-content-end"><button class="btn btn-default mr-5px" data-dismiss="modal" ng-click="ClearAddEditScheduleData()">Cancel</button> <button type="submit" style="margin-right:5px;" class="btn btn-primary btn-sm fs-13px" ng-disabled="frmShifts.$invalid || DataObject.addEditSchedule.isSaveBtnDisabled" ng-click="SetShiftSchedule()">Save</button></div></div></div></div></form></div></div></div></div>');
$templateCache.put('app/theme/components/shift-schedule/shift-classification-cmp/shift-classification-cmp.html','<style>\r\n    .mr-15px {\r\n        margin-right: 15px;\r\n    }\r\n    .aggrid-shoftclass {\r\n        height: calc(100vh - 110px)\r\n    }\r\n</style><div class=""><div class=""><div class="radf-header"><h2>Shift Classifications</h2></div></div><div class="row rf-filter-ui m-0 pt-8px filterspace"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-4 pd-lr"><ui-select class="mult-select" ng-model="DataObject.Filter.SelectedTenant" ng-change="OnTenantChanged()"><ui-select-match placeholder="Select Tenant">{{$select.selected.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantList | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-3 col-xs-4 pd-lr"><input type="text" name="note" class="blk-input form-control" placeholder="Search Shift Classification" ng-model="DataObject.SearchText" maxlength="150" ng-change="SearchClassification()"></div><div class="col-lg-8 col-md-7 col-sm-6 col-xs-4 pd-lr"><button type="submit" ng-click="addShiftClassification()" class="btn btn-primary rf-btn-xs pull-right">Add Shift Classification</button></div></div><div id="ShiftClassificationGrid" class="aggrid-shoftclass ag-theme-balham-dark w-100"></div></div><div class="modal fade new-popup" id="ShiftClassificationModal" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog comment-width" role="document"><div class="modal-content"><div class="modal-header p-0-625-all border-0"><button type="button" class="close otln-0" aria-label="Close" data-dismiss="modal" ng-click="clearAddClassificationData()">&times;</button><h4 class="modal-title">{{(DataObject.addEditClassification.ShiftClassificationID && DataObject.addEditClassification.ShiftClassificationID != \'-1\' )?"Edit" : "Add"}} Shift Classification</h4></div><div class="modal-body"><form name="frm" id="frm"><div class="width-inherit height-inherit"><div class="gc-content"><div class="row mb-10px"><div class="col-lg-12 col-md-12 col-sm-12"><div style="display:flex; align-items:center; gap:8px;"><span class="rf-label m-0" style="white-space:nowrap; flex-shrink:0;">Tenant:</span> <span style="font-weight:700; color:#05C1A4; font-size:13px; background:rgba(5,193,164,0.1); border:1px solid rgba(5,193,164,0.35); border-radius:4px; padding:3px 12px; letter-spacing:0.2px; white-space:nowrap;">{{DataObject.Filter.SelectedTenant.DisplayName}}</span></div></div></div><div class="row mb-10px"><div class="col-lg-12"><label class="rf-label">Name <span>*</span></label><div class="input-group w-100 mb-0"><input type="text" name="note" class="blk-input form-control" maxlength="150" ng-required="true" ng-model="DataObject.addEditClassification.ShiftClassificationName"></div></div></div><div class="row py-10px"><div class="col-lg-12 d-flex justify-content-end"><button class="btn btn-default mr-5px" data-dismiss="modal" ng-click="clearAddClassificationData()">Cancel</button> <button type="submit" style="margin-right:5px;" class="btn btn-primary btn-sm fs-13px" ng-disabled="frm.$invalid || DataObject.addEditClassification.isSaveBtnDisabled" ng-click="SaveShiftClassification()">Save</button></div></div></div></div></form></div></div></div></div>');
$templateCache.put('app/theme/components/shift-schedule/shift-configuration-cmp/shift-configuration-cmp.html','<style>\r\n    .mr-15px {\r\n        margin-right: 15px;\r\n    }\r\n\r\n    .modal-dialog.comment-width {\r\n        width: 36%;\r\n    }\r\n\r\n    .modal.fade .modal-dialog {\r\n        transform: translate(0, 1%) !important;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .rf-filter-ui .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        border-color: #424242 !important;\r\n    }\r\n\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-chevron-up,\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-chevron-down,\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-remove {\r\n        color: #05C1A4 !important;\r\n    }\r\n\r\n    .shift-congfig-grid {\r\n        height: calc(100vh - 110px);\r\n    }\r\n\r\n        .shift-congfig-grid.set-shiftconfiggrid-height {\r\n            height: calc(100vh - 136px);\r\n        }\r\n\r\n    .uiselect-days .ui-select-bootstrap > .ui-select-choices {\r\n        max-height: 150px;\r\n    }\r\n\r\n    input[type="color"] {\r\n        border: none;\r\n        background-color: transparent;\r\n        width: 38px;\r\n        height: 38px;\r\n        outline: none;\r\n    }\r\n\r\n    #color-picker::-webkit-color-swatch {\r\n        border-radius: 7px;\r\n    }\r\n\r\n    @media only screen and (min-width: 768px) and (max-width: 1200px) {\r\n        .modal.new-popup.addshift-conf .modal-dialog {\r\n            width: 64%;\r\n        }\r\n    }\r\n</style><div class=""><div class=""><div class="radf-header"><h2>Shift Configuration</h2></div></div><div class="row rf-filter-ui m-0 pt-8px filterspace"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-4 pd-lr"><ui-select class="mult-select" ng-model="DataObject.Filter.SelectedTenant" ng-change="OnTenantChanged()"><ui-select-match placeholder="Select Tenant">{{$select.selected.DisplayName}}</ui-select-match><ui-select-choices repeat="tenant in TenantList | filter: {DisplayName: $select.search} | orderBy:\'DisplayName\'" position="down"><div ng-bind-html="(tenant.DisplayName) | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-3 col-sm-5 col-xs-4 pd-lr"><input type="text" name="" class="blk-input form-control" placeholder="Shift Name" ng-model="DataObject.SearchShiftName"></div><div class="col-lg-1 col-md-2 col-sm-2 pd-lr"><button type="submit" class="btn btn-primary rf-btn-xs mr-4px" ng-click="SearchShiftConfig()">Filter</button> <button type="submit" class="btn btn-default rf-btn-xs mr-4px" ng-click="ClearSearch()">Clear</button></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-4 pd-lr pull-right"><button type="submit" data-target="#ShiftChangeModal" data-toggle="modal" ng-click="addShift()" class="btn btn-primary rf-btn-xs pull-right">Add Shift</button></div></div><div class=""><div id="SiteConfigGrid" class="ag-theme-balham-dark w-100 shift-congfig-grid" ng-class="{\'set-shiftconfiggrid-height\' : DataObject.multiSelectDropdown.ShiftClassificationFilter.SelectedValue.list.length > 0}"></div></div></div><div class="modal fade new-popup addshift-conf overflow-y-hide" id="ShiftChangeModal" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog comment-width" role="document"><div class="modal-content"><div class="modal-header p-0-625-all border-0"><button type="button" class="close otln-0" aria-label="Close" data-dismiss="modal" ng-click="clearAddEditShiftConfigData()">&times;</button><h4 class="modal-title">{{(DataObject.addEditShiftConfig.ShiftConfigID?"Edit":"Add")}} Shift</h4></div><div class="modal-body"><form name="frmShifts" id="frmShifts"><div class="width-inherit height-inherit"><div class="gc-content"><div class="row mb-10px"><div class="col-lg-12 col-md-12 col-sm-12"><div style="display:flex; align-items:center; gap:8px;"><span class="rf-label m-0" style="white-space:nowrap; flex-shrink:0;">Tenant:</span> <span style="font-weight:700; color:#05C1A4; font-size:13px; background:rgba(5,193,164,0.1); border:1px solid rgba(5,193,164,0.35); border-radius:4px; padding:3px 12px; letter-spacing:0.2px; white-space:nowrap;">{{DataObject.Filter.SelectedTenant.DisplayName}}</span></div></div></div><div class="row mb-10px"><div class="col-lg-10 col-sm-10"><label class="rf-label">Shift Name <span>*</span></label><div><div class="input-group w-100"><input type="text" name="note" class="blk-input form-control" ng-model="DataObject.addEditShiftConfig.ShiftName" maxlength="150" ng-required="true"></div></div></div><div class="col-lg-2 col-sm-2 pl-0"><label class="rf-label mb-0">Shift Color</label> <input type="color" id="color-picker" value="" ng-model="DataObject.addEditShiftConfig.ShiftColorCode"></div></div><div class="row mb-10px"><div class="col-lg-6 col-sm-6"><label class="rf-label">Start Time</label><div class="input-group w-60"><uib-timepicker class="rf-timepick" id="FromTime" name="FromTime" ng-model="DataObject.addEditShiftConfig.StartTime" show-meridian="false"></uib-timepicker></div></div><div class="col-lg-6 col-sm-6"><label class="rf-label">End Time</label><div class="input-group w-60"><uib-timepicker class="rf-timepick" id="ToTime" name="ToTime" ng-model="DataObject.addEditShiftConfig.EndTime" show-meridian="false"></uib-timepicker></div></div></div><div class="row mb-10px"><div class="col-lg-12" style="padding-left:0px;"><div class="col-lg-6 col-sm-6"><label class="rf-label">Low Anomaly</label> <span class="input-group"><input type="text" name="note" class="blk-input form-control" numbers-only="" ng-model="DataObject.addEditShiftConfig.LowAnomaly" maxlength="5"></span></div><div class="col-lg-6 col-sm-6"><label class="rf-label">High Anomaly</label> <span class="input-group"><input type="text" name="note" class="blk-input form-control" numbers-only="" ng-model="DataObject.addEditShiftConfig.HighAnomaly" maxlength="5"></span></div></div></div><div class="row py-10px"><div class="col-lg-12"><button type="submit" class="btn btn-primary float-right mr-5px btn-sm fs-13px" ng-disabled="DataObject.addEditShiftConfig.isSaveBtnDisabled || !DataObject.addEditShiftConfig.ShiftName" ng-click="SaveShiftConfigurations()">Save</button> <button class="btn btn-default btn-sm mr-5px float-right" data-dismiss="modal" ng-click="clearAddEditShiftConfigData()">Cancel</button></div></div></div></div></form></div></div></div></div>');
$templateCache.put('app/theme/components/shift-schedule/user-schedule-cmp/user-schedule-cmp.html','<style>\r\n    .rf-filter-ui .location-tags-input tags-input .tags {\r\n        background-color: #323232 !important;\r\n        border-color: #424242 !important;\r\n    }\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-chevron-up,\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-chevron-down,\r\n    .modal .modal-dialog .modal-body .rf-timepick a .glyphicon-remove {\r\n        color: #05C1A4 !important;\r\n    }\r\n    .location-tags-input tags-input .tags .input::placeholder {\r\n        color: #808080 !important;\r\n    }\r\n</style><div><div class="radf-header"><h2>Schedule</h2></div><div class="row rf-filter-ui m-0 pt-8px filterspace"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-4 pd-lr"><multi-select master-data="MultiSelectDropdown.ScheduleFilterPhysician" ng-model="" list="MasterRadiologistsFullSet" on-change="MultiSelectDropdown.ScheduleFilterPhysician.onChange(selectedData)" on-add-tag="onRadiologistFilterSelect()" on-remove-tag="onRadiologistFilterSelect()"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px wd-max-content max-w-180px d-none" tooltip-class="uibtooltipDenial" style="z-index: 999; top: 60px !important;" tooltip-placement="auto bottom">{{}}</span></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-4 pd-lr"><multi-select master-data="MultiSelectDropdown.ScheduleFilterShift" ng-model="" list="MasterRadiologistsFullSet" on-change="MultiSelectDropdown.ScheduleFilterShift.onChange(selectedData)" on-add-tag="onRadiologistFilterSelect()" on-remove-tag="onRadiologistFilterSelect()"></multi-select><span class="tultiptext text-preline max-h-500px overflow-auto text-left tt-white sl-hsw-180px wd-max-content max-w-180px d-none" tooltip-class="uibtooltipDenial" style="z-index: 999; top: 60px !important;" tooltip-placement="auto bottom">{{}}</span></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-4 pd-lr"><input date-range-picker="" class="blk-input form-control col-placeholder" type="text" placeholder="DOS" ng-model="DataObject.SelectedData.OrderDate" options="opts" autocomplete="off" readonly="" tooltip-class="uibtooltipDenial" uib-tooltip="{{DataObject.SelectedData.toolTipOrderDate}}" tooltip-placement="auto top" ng-mouseenter="resetDateRange()"></div><div class="col-lg-1 col-md-1 col-sm-2 col-xs-4 pd-lr"><button type="submit" class="btn btn-primary rf-btn-xs mr-4px" ng-click="appCtrl.search()">Filter</button> <button type="submit" class="btn btn-default rf-btn-xs" ng-click="appCtrl.reset()">Clear</button></div><div class="col-lg-1 col-md-1 col-sm-1 col-xs-4 pd-lr pull-right"><button type="submit" class="btn btn-primary rf-btn-xs pull-right" ng-click="showScheduleModal()">Add Schedule</button></div></div><div class=""><div><table class="table table-responsive" style="white-space:nowrap;" ng-if="appCtrl.ViewType == \'View by Physician\'"><thead><tr><th class="d-inline-block p-3px-all txt-clr-1 bg-clr-27 br-1-s b-clr-3 overflow-hide-all" style="width:200px; height:35px; padding-left:15px !important;" ng-if="appCtrl.DateList">Physician</th><th class="d-inline-block p-3px-all txt-clr-1 br-1-s b-clr-3 text-center fw-500 fs-13px overflow-hide-all" ng-repeat="dt in appCtrl.DateList track by $index" style="background-color:#182023; width:160px; height:35px; letter-spacing: 0.04rem; color:#ccc!important;">{{dt | amDateFormat:\'MMM DD\'}}</th></tr></thead><tbody class="scrollbar-macosx overflow-x-auto overflow-y-auto bg-clr-12 h-83vh pos-rel d-block" data-jquery-scrollbar="" style="padding:0 0 !important; max-width:1370px !important"><tr ng-repeat="data in appCtrl.QgendaData track by $index" class="{{data.StaffKey}} d-table"><td class="bg-clr-21 d-table-cell v-a-t" style="width:200px; min-height:35px; padding:0 !important;border-top: 0 !important; vertical-align:top !important"><div class="w-100"><div class="d-inline-block p-3px-all bg-clr-21 fs-14px txt-clr-3 fw-600 overflow-hide-all" style="width:200px; padding-left:15px !important; cursor:pointer;" ng-click="appCtrl.openUserChat(data.UserId, data.StaffKey)">{{data.DisplayName}}</div></div></td><td style="padding:0 !important; border-top: none !important;"><div class="w-100 d-table"><div ng-repeat="shiftList in data.QgendaShiftList track by $index" class="d-inline-block fs-13px txt-clr-3 fw-500 text-center overflow-hide-all v-a-t" style="width:160px;"><div ng-switch="" on="shiftList.StaffKey == appCtrl.currStaffKey"><div ng-switch-when="true"><div ng-repeat="shift in shiftList.PhysicianShiftsList track by $index" style="padding:3px; position:relative" class="text-truncate {{shift.ShiftId}}" ui-draggable="true" drag="shift" drag-channel="priests" drop-channel="priests" ui-on-drop="onDrop($event,$data,shift,$index)" drop-validate="dropValidateHandler($drop, $event, $data)" on-drop-success="dropSuccessHandler($event, $index, appCtrl.QgendaData)" ng-if="shift.IsSwapped">{{shift.ShiftName}} <i class="fa fa-exclamation-triangle" ng-if="shift.IsSwapped" style="color:red;"></i></div><div ng-repeat="shift in shiftList.PhysicianShiftsList track by $index" style="padding:3px; position:relative" class="text-truncate {{shift.ShiftId}}" ui-draggable="true" drag="shift" drag-channel="priests" drop-channel="priests" ui-on-drop="onDrop($event,$data,shift,$index)" drop-validate="dropValidateHandler($drop, $event, $data)" on-drop-success="dropSuccessHandler($event, $index, appCtrl.QgendaData)" context-menu="menuOptions" ng-if="!shift.IsSwapped && shift.IsDraggable">{{shift.ShiftName}}</div><div ng-repeat="shift in shiftList.PhysicianShiftsList track by $index" style="padding:3px; position:relative" class="text-truncate {{shift.ShiftId}}" ui-draggable="true" drag="shift" drag-channel="priests" drop-channel="priests" ui-on-drop="onDrop($event,$data,shift,$index)" drop-validate="dropValidateHandler($drop, $event, $data)" on-drop-success="dropSuccessHandler($event, $index, appCtrl.QgendaData)" ng-if="!shift.IsSwapped && !shift.IsDraggable">{{shift.ShiftName}}</div><div style="display:inline-block; width:150px;" ng-if="!shiftList.PhysicianShiftsList">-</div></div><div ng-switch-when="false"><div ng-repeat="shift in shiftList.PhysicianShiftsList track by $index" style="padding:3px; position:relative" drop-channel="priests" ui-on-drop="onDrop($event,$data,shift,$index)" drop-validate="dropValidateHandler($drop, $event, $data)" on-drop-success="dropSuccessHandler($event, $index, appCtrl.QgendaData)" class="text-truncate {{shift.ShiftId}}">{{shift.ShiftName}} <i class="fa fa-exclamation-triangle" ng-if="shift.IsSwapped" style="color:red;"></i></div><div style="display:inline-block; width:150px;" ng-if="!shiftList.PhysicianShiftsList">-</div></div></div></div><div class="clearfix"></div></div></td></tr></tbody><script type="text/javascript">\r\n                    $(document).ready(function () {\r\n                        $(\'tbody\').scroll(function (e) { //detect a scroll event on the tbody\r\n                            /*\r\n                            Setting the thead left value to the negative valule of tbody.scrollLeft will make it track the movement\r\n                            of the tbody element. Setting an elements left value to that of the tbody.scrollLeft left makes it maintain \t\t\tit\'s relative position at the left of the table.\r\n                            */\r\n                            $(\'thead\').css("left", -$("tbody").scrollLeft()); //fix the thead relative to the body scrolling\r\n                            $(\'thead th:nth-child(1)\').css("left", $("tbody").scrollLeft()); //fix the first cell of the header\r\n                            $(\'tbody td:nth-child(1)\').css("left", $("tbody").scrollLeft()); //fix the first column of tdbody\r\n                        });\r\n                    });\r\n                </script></table><table class="table table-responsive" style="white-space:nowrap;" ng-if="appCtrl.ViewType == \'View by Shift\'"><thead><tr><th class="d-inline-block p-3px-all txt-clr-1 bg-clr-27 br-1-s b-clr-3 overflow-hide-all" style="width:200px; height:35px; padding-left:15px !important;" ng-if="appCtrl.DateList">Shift</th><th class="d-inline-block p-3px-all txt-clr-1 br-1-s b-clr-3 text-center fw-500 fs-13px overflow-hide-all" ng-repeat="dt in appCtrl.DateList track by $index" style="background-color:#182023; width:160px; height:35px; letter-spacing: 0.04rem; color:#ccc!important;">{{dt | amDateFormat:\'MMM DD\'}}</th></tr></thead><tbody class="scrollbar-macosx overflow-x-auto overflow-y-auto bg-clr-12 h-83vh pos-rel d-block" data-jquery-scrollbar="" style="padding:0 0px !important; max-width:1370px !important"><tr ng-repeat="data in appCtrl.QgendaData track by $index" class="{{data.ShiftId}} d-table"><td class="bg-clr-21 d-table-cell v-a-t" style="width:200px; min-height:35px; padding:0 !important;border-top: 0 !important; vertical-align:top !important"><div class="w-100"><div class="d-inline-block p-3px-all bg-clr-21 fs-14px txt-clr-3 fw-600 overflow-hide-all" style="width:200px; padding-left:15px !important; cursor:pointer;">{{data.ShiftName}}</div></div></td><td style="padding:0 !important; border-top: none !important;"><div class="w-100 d-table"><div ng-repeat="shiftList in data.QgendaShiftList track by $index" class="d-inline-block fs-13px txt-clr-3 fw-500 text-center overflow-hide-all v-a-t" style="width:160px;"><div ng-switch="" on="shiftList.StaffKey == appCtrl.currStaffKey"><div ng-switch-when="true"><div ng-repeat="shift in shiftList.PhysicianList track by $index" class="{{shift.StaffKey}}" style="padding:3px;" ui-draggable="true" drag="shift" drag-channel="priests" drop-channel="priests" ui-on-drop="onDrop($event,$data,shift,$index)" drop-validate="dropValidateHandler($drop, $event, $data)" on-drop-success="dropSuccessHandler($event, $index, appCtrl.QgendaData)" ng-if="shift.IsSwapped"><span class="text-truncate" style="width: 140px; display: inline-block;">{{shift.DisplayName}}</span> <i class="fa fa-exclamation-triangle" ng-if="shift.IsSwapped" style="color:red;"></i></div><div ng-repeat="shift in shiftList.PhysicianList track by $index" class="{{shift.StaffKey}}" style="padding:3px;" ui-draggable="true" drag="shift" drag-channel="priests" drop-channel="priests" ui-on-drop="onDrop($event,$data,shift,$index)" drop-validate="dropValidateHandler($drop, $event, $data)" on-drop-success="dropSuccessHandler($event, $index, appCtrl.QgendaData)" context-menu="menuOptions" ng-if="!shift.IsSwapped && shift.IsDraggable"><span class="text-truncate" style="width: 140px; display: inline-block;">{{shift.DisplayName}}</span></div><div ng-repeat="shift in shiftList.PhysicianList track by $index" class="{{shift.StaffKey}}" style="padding:3px;" ui-draggable="true" drag="shift" drag-channel="priests" drop-channel="priests" ui-on-drop="onDrop($event,$data,shift,$index)" drop-validate="dropValidateHandler($drop, $event, $data)" on-drop-success="dropSuccessHandler($event, $index, appCtrl.QgendaData)" ng-if="!shift.IsSwapped && !shift.IsDraggable"><span class="text-truncate" style="width: 140px; display: inline-block;">{{shift.DisplayName}}</span></div><div style="display:inline-block; width:150px;" ng-if="!shiftList.PhysicianList">-</div></div><div ng-switch-when="false"><div ng-repeat="shift in shiftList.PhysicianList track by $index" class="{{shift.StaffKey}}" style="padding:3px;" drop-channel="priests" ui-on-drop="onDrop($event,$data,shift,$index)" drop-validate="dropValidateHandler($drop, $event, $data)" on-drop-success="dropSuccessHandler($event, $index, appCtrl.QgendaData)"><span class="text-truncate" style="width: 140px; display: inline-block;">{{shift.DisplayName}}</span> <i class="fa fa-exclamation-triangle" ng-if="shift.IsSwapped" style="color:red;"></i></div><div style="display:inline-block; width:150px;" ng-if="!shiftList.PhysicianList">-</div></div></div></div><div class="clearfix"></div></div></td></tr></tbody><script type="text/javascript">\r\n                    $(document).ready(function () {\r\n                        $(\'tbody\').scroll(function (e) { //detect a scroll event on the tbody\r\n                            /*\r\n                            Setting the thead left value to the negative valule of tbody.scrollLeft will make it track the movement\r\n                            of the tbody element. Setting an elements left value to that of the tbody.scrollLeft left makes it maintain \t\t\tit\'s relative position at the left of the table.\r\n                            */\r\n                            $(\'thead\').css("left", -$("tbody").scrollLeft()); //fix the thead relative to the body scrolling\r\n                            $(\'thead th:nth-child(1)\').css("left", $("tbody").scrollLeft()); //fix the first cell of the header\r\n                            $(\'tbody td:nth-child(1)\').css("left", $("tbody").scrollLeft()); //fix the first column of tdbody\r\n                        });\r\n                    });\r\n                </script></table></div></div><div class="modal fade new-popup" id="ScheduleModal" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog comment-width" role="document"><div class="modal-content"><div class="modal-header p-0-625-all border-0"><button type="button" class="close otln-0" aria-label="Close" data-dismiss="modal"><span aria-hidden="true" class="fw-400 fs-18px d-block">x</span></button><h4 class="modal-title">{{appCtrl.ScheduleId > 0 ? \'Edit Schedule\' : \'Add Schedule\'}}</h4></div><div class="modal-body"><form name="frmSchedule" id="frmSchedule"><div class="width-inherit height-inherit"><div class="gc-content"><div class="row mb-10px"><div class="col-lg-12"><label class="rf-label">Shift <span>*</span></label><ui-select class="mult-select" ng-model="appCtrl.ShiftId" tooltip-class="uibtooltipDenial" uib-tooltip="" tooltip-placement="auto top"><ui-select-match placeholder="" allow-clear="true">{{}}</ui-select-match><ui-select-choices repeat="" position="down" refresh="" refresh-delay="1500"><div ng-bind-html=""></div></ui-select-choices></ui-select></div></div><div class="row mb-10px"><div class="col-lg-6"><label class="rf-label">Date <span>*</span></label><div class="input-group blk-calender mb-0" tooltip-class="uibtooltipDenial" uib-tooltip="Date" tooltip-placement="auto top"><input type="text" name="DateFrom" placeholder="Date" class="blk-input form-control col-placeholder" style="opacity:1!important;" uib-datepicker-popup="MM/dd/yyyy" ng-model="ScheduleDate" readonly="" datepicker-options="DataObject.dateSearchOptions" is-open="DataObject.FromDateOpenFilter" ng-required="true" close-text="Close" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default h-30px" ng-click="appCtrl.showScheduleDateFlag = true"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="row"><div class="col-lg-3 col-md-3 col-sm-6"><label class="rf-label">From Time <span>*</span></label><div class="input-group"><uib-timepicker class="rf-timepick" id="ToTime" name="ToTime" ng-model="appCtrl.ScheduleStartTime" hour-step="hstep" minute-step="mstep" show-meridian="false"></uib-timepicker></div></div><div class="col-lg-3 col-md-3 col-sm-6"><label class="rf-label">To Time <span>*</span></label><div class="input-group"><uib-timepicker class="rf-timepick" id="FromTime" name="FromTime" ng-model="appCtrl.ScheduleEndTime" hour-step="hstep" minute-step="mstep" show-meridian="false"></uib-timepicker></div><span class="txt-clr-6" ng-show="appCtrl.ScheduleEndTime <= appCtrl.ScheduleStartTime">\'To Time\' must be greater than \'From Time\'.</span></div></div><div class="row py-10px"><div class="col-lg-12"><button type="submit" class="btn btn-primary btn-sm fs-13px float-right" ng-disabled="frmSchedule.$invalid" ng-click="appCtrl.addSchedule()">{{appCtrl.ScheduleId > 0 ? \'Edit Schedule\' : \'Add Schedule\'}}</button><div class="clearfix"></div></div></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/psorders/search/list/list.html','<style>\r\n    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {\r\n        /* IE9+ specific styles go here */\r\n        /*.disabled-grid {\r\n            display: block !important;\r\n            overflow-x: hidden !important;\r\n        }\r\n\r\n        .disabled-list-footer {\r\n            position: fixed !important;\r\n            bottom: 0 !important;\r\n            width: 100% !important;\r\n            padding-bottom: 5px;\r\n        }\r\n\r\n        .charges-list {\r\n            padding-bottom: 40px !important;\r\n            padding-top: 100px !important;\r\n        }\r\n\r\n        .mail-messages-control {\r\n            position: absolute;\r\n            width: 100%;\r\n            z-index: 1 !important;\r\n        }\r\n            */\r\n    }\r\n\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n</style><div style="height:0"></div><div id="divOrderList" class=""><div class="mail-messages-control side-message-navigation-item charges-list-header bg-clr-21"><form name="OrderListFilter"><div class="row charges-filter-bar mb-5px d-block"><div class="col-sm-2 col-md-2 mr-0"><ui-select class="flow-m-select" ng-model="SelectedList.Site" title="Select a Site" ng-change="SelectedSiteChanged(SelectedList.Site)"><ui-select-match placeholder="Select a Site" allow-clear="true">{{$select.selected.Site}}</ui-select-match><ui-select-choices repeat="list in SitesAndLocations | propsFilter: {Site: $select.search}" position="down"><div ng-bind-html="list.Site | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 mr-0"><ui-select class="flow-m-select" ng-model="SelectedList.Location" title="Choose a Location"><ui-select-match placeholder="Select a Location" allow-clear="true">{{$select.selected.Location}}</ui-select-match><ui-select-choices repeat="list in Locations | propsFilter: {Location: $select.search}" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 mr-0"><label class="rf-label"></label> <input type="text" class="form-control-n flow-input" ng-model="Accession" id="input01" placeholder="Accession"></div><div class="col-sm-2 col-md-2 mr-0"><input type="text" class="form-control-n flow-input w-c-100-35px float-left" uib-datepicker-popup="MM/dd/yyyy" ng-model="OrderDate" is-open="isOrderDateOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="OrderDate" placeholder="DOS(mm/dd/yyyy)"> <span class="float-left w-35px"><button type="button" class="btn btn-default h-30px py-1px px-10px" style="background-color:#fff;" ng-click="isOrderDateOpen = !isOrderDateOpen"><i class="glyphicon glyphicon-calendar" style="font-size:12px"></i></button></span><div class="clearfix"></div></div><div class="col-sm-2 col-md-2 mr-0"><input type="text" class="form-control-n flow-input" ng-model="ProviderPhysician" id="input01" placeholder="Ordering Physician"></div><div class="col-sm-2 col-md-2 mr-0"><span>Refresh in {{RefreshTimmer}} minutes.</span></div><div class="clearfix"></div></div><div class="row charges-filter-bar d-block"><div class="col-sm-2 col-md-2 mr-0"><input type="text" class="form-control-n flow-input" ng-model="PatientMRN" id="input02" placeholder="MRN"></div><div class="col-sm-2 col-md-2 mr-0"><input type="text" class="form-control-n flow-input" ng-model="PatientName" id="input01" placeholder="Name"></div><div class="col-sm-2 col-md-2 mr-0"><input type="text" class="form-control-n flow-input w-c-100-35px float-left" uib-datepicker-popup="MM/dd/yyyy" ng-model="DOB" is-open="isDOBOpen" datepicker-options="dateOptions" close-text="Close" alt-input-formats="altInputFormats" name="DOB" placeholder="DOB(mm/dd/yyyy)"> <span class="float-left w-35px"><button type="button" class="btn btn-default h-30px py-1px px-10px" style="background-color:#fff;" ng-click="isDOBOpen = !isDOBOpen"><i class="glyphicon glyphicon-calendar" style="font-size:12px"></i></button></span><div class="clearfix"></div></div><div class="col-sm-2 col-md-2 mr-0"><ui-select class="flow-m-select" ng-model="SelectedList.PatientClass" title="Select Type"><ui-select-match placeholder="Select Type" allow-clear="true">{{$select.selected.PatClass}}</ui-select-match><ui-select-choices repeat="list in PatientClass | propsFilter: {PatClass: $select.search}" position="down"><div ng-bind-html="list.PatClass | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-2 col-md-2 mr-0"><select id="ddlStatus" class="sing-select form-control w-100 downArrow-ie" ng-model="Status" ng-change=""><option value="C">Complete</option><option value="IP">Image Pending</option><option value="RP" selected="">Result Pending</option></select></div><div class="col-sm-2 col-md-2 mr-0"><button type="submit" ng-click="refresh()" class="btn cmn-btn btn-primary h-30px px-10px fs-13px">Filter</button> <button ng-click="clearFilter()" class="btn cmn-btn btn-primary h-30px px-10px fs-13px">Clear</button></div><div class="clearfix"></div></div></form></div><div class="messages charges-list h-76vh overflow-auto"><table class="patient-table"><thead><tr class="side-message-navigation-item little-human shineHover data-row patient-table"><th style="width:10%" align="left">Location</th><th style="display:none" align="left">Accession</th><th style="width:8%;" align="left">DOS</th><th style="display:none" align="left">MRN</th><th style="width:15%;" align="left">Name</th><th style="width:5%;" align="left">DOB</th><th style="width:5%;" align="left">Sex</th><th style="width:5%;" align="left">Type</th><th style="width:37%;" align="left">Procedure</th><th style="width:15%;" align="left">Ordering Physician</th></tr></thead><tbody class=""><tr class="side-message-navigation-item little-human shineHover data-row patient-table" ng-repeat="O in orderList track by $index" ng-hide="isLoading" ng-dblclick="OpenSingReport($index, orderList)" ng-click="setSelected(O.OrderID)" ng-style="{\'background-color\' : (O.OrderID === SelectedOrderID) ? \'#b7b7b7\' : \'\'}"><td style="width:10%" align="left" title="{{O.Location}}">{{O.Location}}</td><td style="display:none" align="left">{{O.Accession}}</td><td style="width:8%" align="left">{{O.OrderDate | date:\'MM/dd/yyyy HH:mm\'}}</td><td style="display:none" align="left">{{O.PatientMRN}}</td><td style="width:15%" align="left" title="{{O.PatientName}}">{{O.PatientName}}</td><td style="width:5%" align="left">{{O.PatientDOB | date:\'MM/dd/yyyy\'}}</td><td style="width:5%" align="left">{{O.PatientGender}}</td><td style="width:5%" align="left">{{O.PatientClass}}</td><td style="width:37%" align="left" title="{{O.ProcedureDesc}}">{{O.ProcedureDesc}}</td><td style="width:15%" align="left">{{O.ProviderPhysician}}</td></tr></tbody></table></div><div class="disabled-list-footer h-50px bg-clr-21"><div class="w-80 float-left pl-8px overflow-hidden"><select id="ddlPageSize" class="sing-select form-control mt-10px float-left downArrow-ie" style="width:auto;" ng-model="PageSize" ng-change="pageSizeChanged();"><option value="25" ng-selected="true">25</option><option value="50">50</option><option value="100">100</option><option value="200">200</option></select><ul uib-pagination="" boundary-links="true" total-items="TotalRows" max-size="10" items-per-page="PageSize" ng-model="PageNo" ng-change="pageChanged()" class="pagination-sm float-left" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></ul><div class="clearfix"></div></div><div class="w-20 float-left text-right d-table h-50px pr-8px overflow-hidden"><h5 class="f-f-quicksand d-table-cell v-a-m">Showing <span>{{ orderList.length }} of {{TotalRows}}</span> Total Records</h5></div><div class="clearfix"></div></div><div ng-show="isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="modal fade" id="ModalSingReport" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog" style="width:40%;"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">Sign Report</h4></div><div class="modal-body"><div class="row mb-10px"><div class="col-md-12 fs-14px">Site : {{SingReport.CurrentSite}}</div></div><div class="row mb-10px"><div class="col-md-4 fs-13px">MRN: {{SingReport.CurrentPatientMRN}}</div><div class="col-md-4">Patinet: {{SingReport.CurrentPatient}}</div><div class="col-md-4">Accession: {{SingReport.CurrentAccession}}</div></div><div class="row pt-10px"><div class="col-md-12"><button ng-click="SignAndPrevRec()" class="btn btn-primary btn-sm tultip-bottom" title="" ng-disabled="SingbtnDisabled"><i class="fa fa-chevron-left"></i> Previous <span class="tultiptext">{{SingReport.PrevToolTip}}</span></button> <button ng-click="SignAndNextRec()" class="btn btn-primary btn-sm tultip-bottom" title="" ng-disabled="SingbtnDisabled">Next <i class="fa fa-chevron-right"></i> <span class="tultiptext">{{SingReport.NextToolTip}}</span></button></div></div></div></div></div></div></div><div class="modal fade" id="ModalPSUser" role="dialog" data-keyboard="false" data-backdrop="static" style="overflow:hidden !important"><div class="modal-dialog" style="width:30%;"><div class="modal-content"><div class="new-popup"><div class="modal-header"><button type="button" class="close adjBtn-2" data-dismiss="modal">&times;</button><h4 class="modal-title">PowerScribe Login</h4></div><div class="modal-body" style="background:#006c9a !important; border-radius:0 !important"><div class="pScript m-0-auto pb-20px"><img src="assets/images/powerscribe360.png" class="mb-20px"><form name="PSUserform" id="PSUserform" ng-submit="InsertPSUsersBySIte(PSUserform.$valid)"><div class="w-30 float-left"><label class="rf-label">Location:</label></div><div class="w-70 float-left"><label class="fw-500 bg-clr-12 p-2px-all">{{SingReport.OrderList[SingReport.Index].Location}}</label></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Username:</label></div><div class="w-70 float-left"><input type="text" id="PSUserUsername" name="PSUserUsername" ng-model="PSUser.Username" ng-required="true" class="w-100 border-0 p-2px-all"></div><div class="clearfix h-10px"></div><div class="w-30 float-left"><label class="rf-label">Password:</label></div><div class="w-70 float-left"><input type="password" id="PSUserPassword" name="PSUserPassword" ng-model="PSUser.Password" ng-required="true" class="w-100 border-0 p-2px-all"></div><div class="clearfix h-15px"></div><div class="w-30 float-left">&nbsp;</div><div class="w-70 float-left"><button type="submit" class="btn btn-sm py-1px px-15px bor-rad-0 fw-600 bg-clr-12">Log On</button></div><div class="clearfix"></div></form></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/questionnaire/components/order-questionnaire-form/order-questionnaire-form.html','<div ng-if="$ctrl.questionnaireForms"><div ng-if="$ctrl.questionnaireForms.length"><uib-accordion class="rf-accordion" close-others="true"><div uib-accordion-group="" ng-repeat="formItem in $ctrl.questionnaireForms" is-open="formItem.isAccordionOpen"><uib-accordion-heading><div class="d-flex w-100 justify-content-between">{{formItem.name}} <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': formItem.isAccordionOpen, \'glyphicon-chevron-right\': !formItem.isAccordionOpen}"></i></div></uib-accordion-heading><div ng-if="formItem.isAccordionOpen"><div class="pt-10px"><questionnaire-form form-info="formItem" order-id="$ctrl.orderId"></questionnaire-form></div></div></div></uib-accordion></div><div class="alert alert-info" ng-if="!$ctrl.questionnaireForms.length">No form available</div></div>');
$templateCache.put('app/pages/questionnaire/components/questionnaire-form/questionnaire-form.html','<div ng-if="$ctrl.formCategories && $ctrl.formCategories.length"><form name="questionnaireForm" ng-submit="$ctrl.saveForm(questionnaireForm)" novalidate=""><div class="container-fluid quesnrform-wrapper overflow-x-hide overflow-y-auto"><div ng-repeat="category in $ctrl.formCategories"><fieldset><legend class="txt-clr-1 fs-14px" ng-if="category.name">{{category.name}}</legend><div ng-if="category.description" class="py-2">{{category.description}}</div><div class="row d-flex flex-wrap"><div class="mb-3" ng-repeat="question in category.questions" ng-class="question.controlOptions.wrapperCssClass"><div class="row"><div class="col-sm-12 col-md-12" ng-if="question.name"><label class="rf-label" for="{{question.controlOptions.name}}" ng-class="{\'brdrlabel\': question.name}">{{question.name}}</label></div><div ng-class="question.controlOptions.questionCssClass"><div ng-if="question.description" class="py-2">{{question.description}}</div><questionnaire-form-control question="question"></questionnaire-form-control></div><div ng-class="question.controlOptions.additionalQuestionCssClass"><label class="rf-label" for="{{question.additionalQuestion.name}}" ng-if="question.name || question.additionalQuestion.name" ng-class="{\'label-nocontent ng-hide\': !question.additionalQuestion.name}">{{question.additionalQuestion.name || \'&nbsp;\'}}</label><questionnaire-form-control question="question.additionalQuestion"></questionnaire-form-control></div></div><div class="txt-clr-5 fs-13px fw-600 col-md-12 pl-0" ng-show="(questionnaireForm.$submitted || questionnaireForm[question.controlOptions.name].$touched) && questionnaireForm[question.controlOptions.name].$error.required">{{question.controlOptions.requireMessage || question.name + \' is required.\'}}</div><div class="pl-2 row d-flex flex-wrap row-wrpr" ng-if="question.children && question.children.length"><div class="mb-3" ng-class="subQuestion.controlOptions.wrapperCssClass" ng-repeat="subQuestion in question.children"><div class="row"><div class="col-sm-12 col-md-12" ng-if="subQuestion.name"><label class="rf-label" for="{{subQuestion.name}}">{{subQuestion.name}}</label></div><div ng-class="subQuestion.controlOptions.questionCssClass"><div ng-if="subQuestion.description" class="py-2">{{subQuestion.description}}</div><questionnaire-form-control question="subQuestion"></questionnaire-form-control></div><div ng-class="subQuestion.controlOptions.additionalQuestionCssClass"><label class="rf-label" for="{{subQuestion.additionalQuestion.name}}" ng-if="subQuestion.additionalQuestion.name || subQuestion.name" ng-class="{\'ng-hide\': !subQuestion.additionalQuestion.name}">{{subQuestion.additionalQuestion.name || \'&nbsp;\'}}</label><questionnaire-form-control question="subQuestion.additionalQuestion"></questionnaire-form-control></div></div><div class="txt-clr-5 fs-12px" ng-show="(questionnaireForm.$submitted || questionnaireForm[subQuestion.controlOptions.name].$touched) && questionnaireForm[subQuestion.controlOptions.name].$error.required">{{subQuestion.controlOptions.requireMessage || subQuestion.name + \' is required.\'}}</div></div></div></div></div></fieldset></div></div><div class="d-flex justify-content-end px-20px py-10px" style="border-top: 1px solid #474747;"><button type="submit" class="btn btn-primary mb-0">Save</button></div></form></div>');
$templateCache.put('app/pages/settings/techform/techformdetails/techformdetails.html','<style>\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    .temp-horizontal {\r\n        height: calc(100vh - 60px);\r\n    }\r\n\r\n    .temp-vertical {\r\n        height: inherit;\r\n    }\r\n\r\n    .k-editable-area {\r\n        background-color: #2d2c2d !important;\r\n    }\r\n\r\n    #pop {\r\n        display: none;\r\n        position: absolute;\r\n        z-index: 99999;\r\n        padding: 10px;\r\n        background: #3AB9AE;\r\n        border: 1px solid #A2ADBC;\r\n        -moz-border-radius: 20px;\r\n        -webkit-border-radius: 20px;\r\n        margin: 0px;\r\n        -webkit-box-shadow: 0px 0px 5px 0px rgba(164, 164, 164, 1);\r\n        box-shadow: 0px 0px 5px 0px rgba(164, 164, 164, 1);\r\n    }\r\n\r\n   /* #divTechForm {\r\n        padding: 10px;\r\n        height: 88vh;\r\n        overflow: auto;\r\n    }*/\r\n\r\n    .defaultfontclass select {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 5px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n    .defaultfontclass input[type="text"] {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 5px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n    .defaultfontclass input[type="checkbox"] {       \r\n        margin-right: 5px;        \r\n    }\r\n    .defaultfontclass input[type="radio"] {\r\n        margin-right: 5px;\r\n    }\r\n    .defaultfontclass option{\r\n        color:#fff !important;\r\n    }\r\n    .defaultfontclass textarea {\r\n        box-sizing: border-box;\r\n        margin: 0 5px 0px 0;\r\n        font: inherit;\r\n        text-transform: none;\r\n        font-family: inherit;\r\n        height: 34px;\r\n        padding: 6px 12px;\r\n        font-size: 14px !important;\r\n        line-height: 1.42857143;\r\n        background-image: none;\r\n        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n        border: 1px solid #cbcbcb;\r\n        box-shadow: none;\r\n        background-color: #323232 !important;\r\n        border-radius: 4px !important;\r\n        border-color: #424242 !important;\r\n        color: #e4e4e4 !important;\r\n        padding-left: 8px;\r\n    }\r\n    label.defaultfontclass {\r\n        box-sizing: border-box;       \r\n        color: #fff !important;\r\n        font-weight: 600 !important;\r\n        margin-bottom: 5px;\r\n        font-size: 13px;\r\n        text-align: left;\r\n        display: inline-block !important;\r\n    }\r\n    .defaultfontclass td select {\r\n        vertical-align: inherit;\r\n    }\r\n    \r\n    .defaultfontclass tr td {\r\n        vertical-align: top;\r\n    }\r\n</style><div class="w-100 h-100 pos-rel row m-0" keyboard="keys"><div><div class="pos-rel"><div class="radf-header"><div class="text-left"><h2 class="">Tech Form</h2></div><div class="clearfix"></div></div><div class="clearfix"></div></div></div><iframe id="tempid" style="width:100%;height:500px;position:absolute;top:-1000px;"></iframe><div><div><div class="col-md-4 px-0"><form id="frmTemplate" name="frmTemplate" ng-submit="SetTechForm(frmTemplate.$valid)"><div class="row m-0"><div class="col-sm-6 pt-10px mob-px-0"><div class="control-fileupload"><label for="file"></label> <input class="cursor-pointer w-100 type-fileupload" type="file" id="fileInput" ng-model="inputfileModelDoc" name="fileInput" onchange="angular.element(this).scope().uploadFile(this)" ng-click="ResetFileInput()" accept=".html"></div><span class="fs-12px fw-600 text-left txt-clr-5 d-block py-5px">Only HTML files are allowed</span></div></div><div class="row mx-0 mt-0 mb-10px"><div class="col-sm-6 mb-8px mob-px-0"><div class="form-group mb-0"><label class="fw-500 txt-clr-1">Name <span class="required">*</span></label><div class=""><input type="text" class="form-control blk-input" id="inputName" name="inputName" ng-model="TechForm.TechFormName" autocomplete="off" required=""></div><div class="clearfix"></div></div></div><div class="col-sm-6 mb-8px mob-px-0"><div class="form-group mb-0"><label class="fw-500 txt-clr-1">Description <span class="required">*</span></label><div class=""><input type="text" class="form-control blk-input" id="inputMicro" name="inputMicro" ng-model="TechForm.Description" autocomplete="off" required=""></div><div class="clearfix"></div></div></div><div class="col-sm-6 mb-8px mob-px-0" ng-show="false"><div class="form-group mb-0"><label class="fw-500 txt-clr-1">Location</label><div class=""><ui-select id="Location" class="mult-select p-3px-all" on-select="onSelected()" on-remove="onSelected()" ng-model="TechForm._Locations" multiple="" close-on-select="false" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" ng-if="Locations.length>0"><ui-select-match placeholder="Select a Location" allow-clear="true" class="overflow-y-auto d-block" style="max-height:50px;">{{$item.Location}}</ui-select-match><ui-select-choices repeat="list in Locations | propsFilterStartWith: {Location: $select.search, Site: $select.search} | limitTo:50" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div><small ng-if="list.Site">Site: <span ng-bind-html="list.Site | highlight: $select.search"></span></small></ui-select-choices></ui-select></div><div class="clearfix"></div></div></div><div class="col-sm-12 mb-8px mob-px-0" ng-show="false"><div class="form-group mb-0"><label class="fw-500 txt-clr-1">Modality</label><div class=""><ui-select class="mult-select p-3px-all" ng-model="TechForm._Modalities" multiple="" close-on-select="false" title="" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false"><ui-select-match placeholder="Select Modalities" allow-clear="true" class="overflow-y-auto d-block" style="max-height:25px;">{{$item.Code}}</ui-select-match><ui-select-choices repeat="list in Modalities | propsFilter: {Code: $select.search}" position="down"><div ng-bind-html="list.Code | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="clearfix"></div></div></div><div class="col-sm-12 mb-8px mob-px-0"><div class="form-group mb-0"><label class="fw-500 txt-clr-1">Procedure</label><div class=""><ui-select id="Procedure" class="mult-select p-3px-all" on-select="onSelected()" on-remove="onSelected()" ng-model="TechForm._Procedures" multiple="" close-on-select="false" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" ng-if="Procedures.length>0"><ui-select-match placeholder="Select a Procedure" allow-clear="true" class="overflow-y-auto d-block" style="max-height:50px;">{{$item.CPT_Description}}</ui-select-match><ui-select-choices repeat="list in Procedures| propsFilterStartWith: {CPT_Code: $select.search, CPT_Description: $select.search} | limitTo:50" position="down"><div ng-bind-html="list.CPT | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="clearfix"></div></div></div><div class="col-sm-12 mb-8px" ng-show="false"><div class="form-group mb-0"><label class="fw-500 txt-clr-1">Reason</label><div class="clearfix"></div></div><div class="form-group row" ng-repeat="reason in TechForm.Reasons"><div class="col-sm-12 col-md-5 mb-10px"><select class="form-control blk-input" ng-model="reason.ReasonCondition"><option value="" selected="">Select</option><option value="Like \'%@@%\'">Contain</option><option value="NOT Like \'%@@%\'">Not Contain</option><option value="Like \'%@@\'">Start with</option><option value="Like \'@@%\'">Edit with</option></select></div><div class="col-sm-8 col-md-5"><input type="text" class="form-control blk-input" ng-model="reason.ReasonKeyword" autocomplete="off" ng-required="reason.ReasonCondition"></div><div class="col-sm-4 col-md-2 pl-0"><button type="button" class="btn btn-link btn-sm p-2" ng-click="TechForm.Reasons.splice($index + 1, 0, {});"><i class="fa fa-plus-circle fs-18px" aria-hidden="true"></i></button> <button type="button" class="btn btn-link btn-sm p-2" ng-disabled="TechForm.Reasons.length==1" ng-click="TechForm.Reasons.splice($index, 1);"><i class="fa fa-minus-circle fs-18px" aria-hidden="true"></i></button></div><div class="clearfix"></div></div></div><div class="col-sm-12 pt-10px mob-px-0"><div class="form-group mb-0"><div class="box-footer no-bg m-0 pr-0"><button type="button" class="btn btn-default" ng-click="Cancel();">Close</button> <button type="submit" class="btn btn-primary" ng-disabled="frmTemplate.$invalid">Save</button></div></div></div></div></form></div><div id="divTechForm" class="col-md-8 txt-clr-1 p-10px-all overflow-auto techformdetails-sec"></div></div></div><div ng-show="isLoading" class="spinner-overlay" style="z-index:999999;"><div class="spinner-overlay-body"></div><div class="single4"></div></div><div class="overflow-x-hide overflow-y-auto" kendo-window="winPickList" k-on-open="iswinPickListVisible = true" k-on-close="iswinPickListVisible = false;PickList_OnClose()" k-title="\'Pick List\'" k-visible="false" k-modal="true" k-width="800" k-height="600" k-animation="false" k-actions=\'["Maximize", "Close"]\'><div ng-if="iswinPickListVisible"><form id="frmPickList" name="frmPickList" ng-submit="SetPickList(frmPickList.$valid)"><div class="row m-0"><div class="col-sm-6 box-body pt-10px pb-20px pl-0"><div class="form-group mb-0"><label class="fw-600 txt-clr-1 col-sm-4 pl-0 pt-5px">Name <span class="required">*</span></label><div class="col-sm-8 pl-0"><input type="text" class="form-control blk-input" ng-model="Pick.Name" autocomplete="off" required=""></div><div class="clearfix"></div></div></div><div class="form-group mb-10px"><div class=""><table class="blk-table w-100 border-bottom-0 table-scroll"><thead><tr class="side-message-navigation-item little-human shineHover data-row"><th class="w-30 fw-600 text-center">Type</th><th class="w-30 fw-600 text-center">Name</th><th class="w-30 fw-600 text-center">Value</th><th class="w-10"></th></tr></thead><tbody class="overflow-auto border-bottom-0" style="max-height:400px;"><tr ng-repeat="l in Pick.List"><td class="w-30 text-center"><select class="sing-select form-control" ng-model="l.Type" required="" ng-change="l.Value=null"><option value="" selected="">Select</option><option value="Default Value">Default Value</option><option value="Template Field">Field</option><option value="Template">Template</option></select></td><td class="w-30 text-center"><input type="text" class="form-control blk-input" ng-model="l.Name" autocomplete="off" ng-required="l.Type"></td><td class="w-30 text-center"><input type="text" class="form-control blk-input" ng-model="l.Value" autocomplete="off" ng-required="l.Type" ng-if="l.Type==\'Default Value\'"><select class="sing-select form-control" ng-model="l.Value" ng-if="l.Type==\'Report Variable\'" ng-required="l.Type"><option ng-repeat="e in ReportVariable |orderBy:\'Key\'" value="{{e.Value}}" ng-hide="e.Key==\'Pick List\'">{{e.Key}}</option></select><select class="sing-select form-control" ng-model="l.Value" ng-if="l.Type==\'Template Field\'" ng-required="l.Type"><option ng-repeat="e in TemplateFields |orderBy:\'Macro\'" value="{{e.elementHtml}}">{{e.Macro}}</option></select><select class="sing-select form-control" ng-model="l.Value" ng-if="l.Type==\'Template\'" ng-required="l.Type"><option ng-repeat="e in Templates |orderBy:\'Macro\'" value="{{e.elementHtml}}">{{e.Macro}}</option></select></td><td class="w-10 text-center"><button type="button" class="btn btn-link btn-sm p-2" ng-click="Pick.List.splice($index + 1, 0, {});CalcSequence(Pick.List)"><i class="fa fa-plus-circle fs-18px" aria-hidden="true"></i></button> <button type="button" class="btn btn-link btn-sm p-2" ng-disabled="Pick.List.length==1" ng-click="Pick.List.splice($index, 1);CalcSequence(Pick.List)"><i class="fa fa-minus-circle fs-18px" aria-hidden="true"></i></button></td></tr></tbody></table></div></div><div class="col-sm-12 col-md-6 box-body mb-15px" ng-show="!Pick.Node"><div class="form-group mb-0"><div class="full-w"><label class="fw-600 txt-clr-1">&nbsp;</label></div><div class=""><div class="checkbox d-inline-block my-0 mx-10px"><label class="pr-0 fw-600 txt-clr-1 pt-8px"><input type="checkbox" ng-model="Pick.Template.IsActive"> Is Active</label></div><div class="checkbox d-inline-block my-0 mx-10px"><label class="pr-0 fw-600 txt-clr-1 pt-8px"><input type="checkbox" ng-model="Pick.Template.IsGlobal"> Is Global</label></div></div><div class="clearfix"></div></div></div><div class="col-sm-12 box-body mb-15px" ng-show="!Pick.Node"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Location</label><div class=""><ui-select id="Location" class="mult-select p-3px-all" on-select="onSelected()" on-remove="onSelected()" ng-model="Pick.Template._Locations" multiple="" close-on-select="false" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" ng-if="Locations.length>0"><ui-select-match placeholder="Select a Location" allow-clear="true" class="overflow-y-auto d-block" style="max-height:50px;">{{$item.Location}}</ui-select-match><ui-select-choices repeat="list in Locations | propsFilterStartWith: {Location: $select.search, Site: $select.search} | limitTo:50" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div><small ng-if="list.Site">Site: <span ng-bind-html="list.Site | highlight: $select.search"></span></small></ui-select-choices></ui-select></div><div class="clearfix"></div></div></div><div class="col-sm-12 box-body mb-15px" ng-show="!Pick.Node"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Modality</label><div class=""><ui-select class="mult-select p-3px-all" ng-model="Pick.Template._Modalities" multiple="" close-on-select="false" title="" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false"><ui-select-match placeholder="Select Modalities" allow-clear="true" class="overflow-y-auto d-block" style="max-height:25px;">{{$item.Code}}</ui-select-match><ui-select-choices repeat="list in Modalities | propsFilter: {Code: $select.search}" position="down"><div ng-bind-html="list.Code | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="clearfix"></div></div></div><div class="col-sm-12 box-body mb-15px" ng-show="!Pick.Node"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Procedure</label><div class=""><ui-select id="Procedure" class="mult-select p-3px-all" on-select="onSelected()" on-remove="onSelected()" ng-model="Pick.Template._Procedures" multiple="" close-on-select="false" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" ng-if="Procedures.length>0"><ui-select-match placeholder="Select a Procedure" allow-clear="true" class="overflow-y-auto d-block" style="max-height:50px;">{{$item.CPT_Description}}</ui-select-match><ui-select-choices repeat="list in Procedures| propsFilterStartWith: {CPT_Code: $select.search, CPT_Description: $select.search} | limitTo:50" position="down"><div ng-bind-html="list.CPT | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="clearfix"></div></div></div><div class="col-sm-12 box-body" ng-show="!Pick.Node" ng-if="false"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Reason</label><div class="clearfix"></div></div><div class="form-group row" ng-repeat="reason in Pick.Template.Reasons"><div class="col-sm-12 col-md-5 mb-10px"><select class="form-control blk-input" ng-model="reason.ReasonCondition"><option value="" selected="">Select</option><option value="Like \'%@@%\'">Contain</option><option value="NOT Like \'%@@%\'">Not Contain</option><option value="Like \'%@@\'">Start with</option><option value="Like \'@@%\'">Edit with</option></select></div><div class="col-sm-8 col-md-5"><input type="text" class="form-control blk-input" ng-model="reason.ReasonKeyword" autocomplete="off" ng-required="reason.ReasonCondition"></div><div class="col-sm-4 col-md-2 pl-0"><button type="button" class="btn btn-link btn-sm p-2" ng-click="Pick.Template.Reasons.splice($index + 1, 0, {});"><i class="fa fa-plus-circle fs-18px" aria-hidden="true"></i></button> <button type="button" class="btn btn-link btn-sm p-2" ng-disabled="Pick.Template.Reasons.length==1" ng-click="Pick.Template.Reasons.splice($index, 1);"><i class="fa fa-minus-circle fs-18px" aria-hidden="true"></i></button></div><div class="clearfix"></div></div></div></div><div><div class="box-body pt-10px px-15px"><div class="form-group mb-0"><div class="box-footer no-bg m-0 pr-0"><button type="submit" class="btn btn-primary mr-2" ng-disabled="frmPickList.$invalid">Save</button> <button type="button" class="btn btn-default" ng-click="winPickList.close()">Cancel</button></div></div></div></div></form></div></div><div class="overflow-x-hide overflow-y-auto" kendo-window="winEditTemplate" k-on-open="iswinEditTemplateVisible = true" k-on-close="iswinEditTemplateVisible = false" k-title="\'Template\'" k-visible="false" k-width="700" k-height="630" k-actions=\'["Minimize", "Maximize","Close"]\' k-animation="false"><div ng-if="iswinEditTemplateVisible"><form id="frmTemplate" name="frmTemplate" ng-submit="SetVRTemplate(frmTemplate.$valid)"><div class="row m-0 py-20px"><div class="col-sm-6 box-body mb-15px"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Name <span class="required">*</span></label><div class=""><input type="text" class="form-control blk-input" id="inputName" name="inputName" ng-model="_VRTemplate.TemplateName" autocomplete="off" required="" ng-blur="VRTemplate_OnBlur()"></div><div class="clearfix"></div></div></div><div class="col-sm-6 box-body mb-15px"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Macro <span class="required">*</span></label><div class=""><input type="text" class="form-control blk-input" id="inputMicro" name="inputMicro" ng-model="_VRTemplate.Macro" autocomplete="off" required=""></div><div class="clearfix"></div></div></div><div class="col-sm-12 col-md-6 box-body mb-15px"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Type</label><div class=""><select class="sing-select form-control" ng-model="_VRTemplate.Type" ng-change="Type_OnChange()"><option value="Template">Template</option><option value="Field">Field</option></select></div><div class="clearfix"></div></div></div><div class="col-sm-12 col-md-6 box-body mb-15px"><div class="form-group mb-0"><div class="full-w"><label class="fw-600 txt-clr-1">&nbsp;</label></div><div class=""><div class="checkbox d-inline-block my-0 mx-10px"><label class="pr-0 fw-600 txt-clr-1 pt-8px"><input type="checkbox" ng-model="_VRTemplate.IsActive"> Is Active</label></div><div class="checkbox d-inline-block my-0 mx-10px"><label class="pr-0 fw-600 txt-clr-1 pt-8px"><input type="checkbox" ng-model="_VRTemplate.IsGlobal"> Is Global</label></div></div><div class="clearfix"></div></div></div><div class="col-sm-12 box-body mb-15px" ng-show="_VRTemplate.Type==\'Template\' || _VRTemplate.Type==\'Field\'"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Location</label><div class=""><ui-select id="Location" class="mult-select p-3px-all" on-select="onSelected()" on-remove="onSelected()" ng-model="_VRTemplate._Locations" multiple="" close-on-select="false" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" ng-if="Locations.length>0"><ui-select-match placeholder="Select a Location" allow-clear="true" class="overflow-y-auto d-block" style="max-height:50px;">{{$item.Location}}</ui-select-match><ui-select-choices repeat="list in Locations | propsFilterStartWith: {Location: $select.search, Site: $select.search} | limitTo:50" position="down"><div ng-bind-html="list.Location | highlight: $select.search"></div><small ng-if="list.Site">Site: <span ng-bind-html="list.Site | highlight: $select.search"></span></small></ui-select-choices></ui-select></div><div class="clearfix"></div></div></div><div class="col-sm-12 box-body mb-15px" ng-show="_VRTemplate.Type==\'Template\' || _VRTemplate.Type==\'Field\'"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Modality</label><div class=""><ui-select class="mult-select p-3px-all" ng-model="_VRTemplate._Modalities" multiple="" close-on-select="false" title="" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false"><ui-select-match placeholder="Select Modalities" allow-clear="true" class="overflow-y-auto d-block" style="max-height:25px;">{{$item.Code}}</ui-select-match><ui-select-choices repeat="list in Modalities | propsFilter: {Code: $select.search}" position="down"><div ng-bind-html="list.Code | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="clearfix"></div></div></div><div class="col-sm-12 box-body mb-15px" ng-show="_VRTemplate.Type==\'Template\' || _VRTemplate.Type==\'Field\'"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Procedure</label><div class=""><ui-select id="Procedure" class="mult-select p-3px-all" on-select="onSelected()" on-remove="onSelected()" ng-model="_VRTemplate._Procedures" multiple="" close-on-select="false" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" ng-if="Procedures.length>0"><ui-select-match placeholder="Select a Procedure" allow-clear="true" class="overflow-y-auto d-block" style="max-height:50px;">{{$item.CPT_Description}}</ui-select-match><ui-select-choices repeat="list in Procedures| propsFilterStartWith: {CPT_Code: $select.search, CPT_Description: $select.search} | limitTo:50" position="down"><div ng-bind-html="list.CPT | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="clearfix"></div></div></div><div class="col-sm-12 box-body" ng-show="_VRTemplate.Type==\'Template\'"><div class="form-group mb-0"><label class="fw-600 txt-clr-1">Reason</label><div class="clearfix"></div></div><div class="form-group row" ng-repeat="reason in _VRTemplate.Reasons"><div class="col-sm-12 col-md-5 mb-10px"><select class="form-control blk-input" ng-model="reason.ReasonCondition"><option value="" selected="">Select</option><option value="Like \'%@@%\'">Contain</option><option value="NOT Like \'%@@%\'">Not Contain</option><option value="Like \'%@@\'">Start with</option><option value="Like \'@@%\'">Edit with</option></select></div><div class="col-sm-8 col-md-5"><input type="text" class="form-control blk-input" ng-model="reason.ReasonKeyword" autocomplete="off" ng-required="reason.ReasonCondition"></div><div class="col-sm-4 col-md-2 pl-0"><button type="button" class="btn btn-link btn-sm p-2" ng-click="_VRTemplate.Reasons.splice($index + 1, 0, {});"><i class="fa fa-plus-circle fs-18px" aria-hidden="true"></i></button> <button type="button" class="btn btn-link btn-sm p-2" ng-disabled="_VRTemplate.Reasons.length==1" ng-click="_VRTemplate.Reasons.splice($index, 1);"><i class="fa fa-minus-circle fs-18px" aria-hidden="true"></i></button></div><div class="clearfix"></div></div></div><div class="col-sm-12 box-body pt-10px"><div class="form-group mb-0"><div class="box-footer no-bg m-0 pr-0"><button type="button" class="btn btn-default" ng-click="winEditTemplate.close();">Close</button> <button type="submit" class="btn btn-primary mr-2" ng-disabled="frmTemplate.$invalid">Save And Close</button> <button type="button" class="btn btn-primary mr-2" ng-disabled="frmTemplate.$invalid" ng-click="SaveEditTemplate()">Save</button></div></div></div></div></form></div></div></div><style>\r\n    td.in-range {\r\n        background-color: #357ebd !important;\r\n        border-color: #3071a9 !important;\r\n        color: #fff;\r\n    }\r\n</style>');
$templateCache.put('app/pages/settings/techform/techformlist/techformlist.html','<style>\r\n    body {\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    /*.glyphicon-chevron-up,\r\n    .glyphicon-chevron-down,\r\n    .glyphicon-remove {\r\n        color: #767676;\r\n    }*/\r\n\r\n</style><div class="w-100 h-100 pos-rel row m-0"><div class="users-content-inner margin-0-625-all"><div class="users-content-inner-header pos-rel"><div class="radf-header"><div class="text-left"><h2 class="">Tech Form</h2></div><div class="clearfix"></div></div><div class="clearfix"></div></div><div class="pt-8px" id="collapseWorklist" role="tabpanel" aria-labelledby="heading_worklist"><form id="frmFilter" ng-submit="refresh(frmFilter.$valid)"><div class="row rf-filter-ui m-0 filterspace"><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr"><input type="text" class="blk-input form-control" ng-model="filter.TechFormName" placeholder="Name" tooltip-class="uibtooltipDenial" uib-tooltip="Name" tooltip-placement="auto top"></div><div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 pd-lr mob-pr-0"><ui-select id="Procedure" class="mult-select p-3px-all h-30px fs-12px" on-select="onSelected()" on-remove="onSelected()" ng-model="filter.Procedures" multiple="" close-on-select="false" uis-open-close="onOpenClose(isOpen,$select)" reset-search-input="false" tooltip-class="uibtooltipDenial" uib-tooltip="Select a Procedure" tooltip-placement="auto top"><ui-select-match placeholder="Select a Procedure" allow-clear="true" class="overflow-y-auto d-block" style="max-height:25px;">{{$item.CPT_Description}}</ui-select-match><ui-select-choices repeat="list in Procedures| propsFilterStartWith: {CPT_Code: $select.search, CPT_Description: $select.search}| limitTo:50" position="down"><div ng-bind-html="list.CPT | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 pd-lr"><button type="submit" class="btn btn-primary rf-btn-xs mr-4px">Filter</button> <button type="button" ng-click="clearFilterAndRefesh()" class="btn btn-default rf-btn-xs">Clear</button><div class="clearfix"></div></div></div></form></div><div class="kn-common-tbl single-row-filter dicom-content-inner-content bg-clr-27 worklist-client-container peer-reviewfooter"><kendo-grid options="VRTemplate_Options" id="VRTemplate_ListGrid" ng-if="VRTemplate_Options"></kendo-grid></div></div><div ng-show="isLoading" class="spinner-overlay"><div class="spinner-overlay-body"></div><div class="single4"></div></div></div><style>\r\n    td.in-range {\r\n        background-color: #357ebd !important;\r\n        border-color: #3071a9 !important;\r\n        color: #fff;\r\n    }\r\n</style>');
$templateCache.put('app/pages/questionnaire/components/shared/questionnaire-form-control/questionnaire-form-control.html','<div class="w-100" ng-switch="" on="($ctrl.question.controlType || \'\').toLowerCase()"><div class="w-100" ng-switch-when="textbox" ng-class="$ctrl.question.controlOptions.controlDescription ? \'d-flex gap-2\': \'\'"><input type="text" class="blk-input w-100 form-control" name="{{$ctrl.question.controlOptions.name}}" id="{{$ctrl.question.controlOptions.name}}" placeholder="{{$ctrl.question.controlOptions.placeholder}}" ng-required="$ctrl.question.controlOptions.required" ng-model="$ctrl.question.answer.answerValue"> <label class="rf-label ml-2 mt-2" ng-if="$ctrl.question.controlOptions.controlDescription" for="{{$ctrl.question.controlOptions.name}}">{{$ctrl.question.controlOptions.controlDescription}}</label></div><div class="w-100" ng-switch-when="textarea"><textarea class="txt-area h-60px w-100 py-6px px-12px" name="{{$ctrl.question.controlOptions.name}}" id="{{$ctrl.question.controlOptions.name}}" placeholder="{{$ctrl.question.controlOptions.placeholder}}" ng-required="$ctrl.question.controlOptions.required" ng-model="$ctrl.question.answer.answerValue"></textarea></div><div class="w-100" ng-switch-when="date"><div class="input-group blk-calender-inpop"><input type="text" class="blk-input form-control" name="{{$ctrl.question.controlOptions.name}}" id="{{$ctrl.question.controlOptions.name}}" placeholder="{{$ctrl.question.controlOptions.placeholder}}" ng-required="$ctrl.question.controlOptions.required" ng-model="$ctrl.question.answer.answerValue" uib-datepicker-popup="MM/dd/yyyy" is-open="$ctrl.isDatePickerOpen" datepicker-options="$ctrl.dateOptions" close-text="Close" alt-input-formats="altInputFormats" first-char-no-space=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ctrl.isDatePickerOpen = !$ctrl.isDatePickerOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="w-100 qsoption-yesno" ng-switch-when="yesno"><div class="form-controller d-flex gap-2 align-item-center"><label class="d-flex align-item-center gap-2 rtspace-radio" ng-repeat="item in $ctrl.question.answerOptions track by $index"><input class="cmn-checkbx-input m-0" type="radio" name="{{$ctrl.question.controlOptions.name}}" id="{{$ctrl.question.controlOptions.name}}-{{$index}}" ng-model="$ctrl.question.answer.answerValue" value="{{item.optionValue}}"> <span class="rf-label cmn-check-label">{{item.optionText}}</span></label></div></div><div class="w-100" ng-switch-when="listradio"><div class="form-controller d-flex flex-wrap align-item-center gap-4"><label class="d-flex align-item-center gap-2" ng-repeat="item in $ctrl.question.answerOptions track by $index"><input class="cmn-checkbx-input m-0" type="radio" name="{{$ctrl.question.controlOptions.name}}" id="{{$ctrl.question.controlOptions.name}}-{{$index}}" ng-model="$ctrl.question.answer.answerValue" value="{{item.optionValue}}"> <span class="rf-label cmn-check-label">{{item.optionText}}</span></label></div></div><div class="w-100" ng-switch-when="listcheckbox"><div class="form-controller d-flex flex-wrap align-item-center gap-4"><label class="d-flex align-item-center gap-2" ng-repeat="item in $ctrl.question.answerOptions track by $index"><input class="cmn-checkbx-input m-0" type="checkbox" name="{{$ctrl.question.controlOptions.name}}" id="{{$ctrl.question.controlOptions.name}}-{{$index}}" ng-model="item.isSelected" value="{{item.optionValue}}"> <span class="rf-label cmn-check-label">{{item.optionText}}</span></label></div></div><div class="w-100 d-flex align-item-center" ng-switch-when="checkbox"><input type="checkbox" ng-model="$ctrl.question.answer.answerValue" class="m-0 cmn-checkbx-input" name="{{$ctrl.question.controlOptions.name}}" id="{{$ctrl.question.controlOptions.name}}"> <label class="rf-label ml-2 mb-0" style="display: inline-block !important;" ng-if="$ctrl.question.controlOptions.controlDescription" for="{{$ctrl.question.controlOptions.name}}">{{$ctrl.question.controlOptions.controlDescription}}</label></div><div class="w-100" ng-switch-when="dropdown"><ui-select class="mult-select mob-closekeypad input-width" ng-required="$ctrl.question.controlOptions.required" name="{{$ctrl.question.controlOptions.name}}" id="{{$ctrl.question.controlOptions.name}}" ng-model="$ctrl.question.answer.answerValue"><ui-select-match placeholder="{{$ctrl.question.controlOptions.placeholder}}">{{$select.selected.optionText || ctrl.question.controlOptions.placeholder}}</ui-select-match><ui-select-choices repeat="item.optionValue as item in $ctrl.question.answerOptions | filter: $select.search"><div ng-bind-html="item.optionText | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="w-100" ng-switch-when="multiselect"><ui-select multiple="" class="mult-select mob-closekeypad input-width" ng-required="$ctrl.question.controlOptions.required" name="{{$ctrl.question.controlOptions.name}}" id="{{$ctrl.question.controlOptions.name}}" ng-model="$ctrl.question.answer.answerValue"><ui-select-match placeholder="{{$ctrl.question.controlOptions.placeholder}}">{{$select.selected.optionText}}</ui-select-match><ui-select-choices repeat="item.optionValue as item in $ctrl.question.answerOptions | filter: $select.search"><div ng-bind-html="item.optionText | highlight: $select.search"></div></ui-select-choices></ui-select></div></div>');}]);